
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d1f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d1f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 256, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194048) && ($dca0ddb82b882518$var$nextTransitionLane = 256);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_417) {
            var $dca0ddb82b882518$var$element$jscomp$inline_418 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_418.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = $dca0ddb82b882518$var$isSupported$jscomp$inline_417;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState$1 = null);
        $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$38);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, $dca0ddb82b882518$var$createEffectInstance(), create, createDeps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, createDeps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateEffect(create, createDeps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$41 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$41, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(init);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, init = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = init, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = init), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState = null;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects(wasDelayedCommit) {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects(wasDelayedCommit);
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$174, root$174 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1528 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1528 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1528++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1529 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1528], $dca0ddb82b882518$var$domEventName$jscomp$inline_1530 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1529.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1530, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $dca0ddb82b882518$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$244 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$244 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $dca0ddb82b882518$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$250)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane();
                            lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $acw62.version;
if ("19.1.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2257.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2257.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2257.inject($dca0ddb82b882518$var$internals$jscomp$inline_2256), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $72b03fdf46effee2$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.1.0";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("8sxY3", function(module, exports) {
"use strict";
var $628b497dee272d8a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $628b497dee272d8a$var$StyleToObject;

var $628b497dee272d8a$var$inline_style_parser_1 = $628b497dee272d8a$var$__importDefault((parcelRequire("dvUl4")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $628b497dee272d8a$var$StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    var declarations = (0, $628b497dee272d8a$var$inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === 'function';
    declarations.forEach(function(declaration) {
        if (declaration.type !== 'declaration') return;
        var property = declaration.property, value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("dvUl4", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $9d69df5777ad44b8$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $9d69df5777ad44b8$var$NEWLINE_REGEX = /\n/g;
var $9d69df5777ad44b8$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $9d69df5777ad44b8$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $9d69df5777ad44b8$var$COLON_REGEX = /^:\s*/;
var $9d69df5777ad44b8$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $9d69df5777ad44b8$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $9d69df5777ad44b8$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $9d69df5777ad44b8$var$NEWLINE = '\n';
var $9d69df5777ad44b8$var$FORWARD_SLASH = '/';
var $9d69df5777ad44b8$var$ASTERISK = '*';
var $9d69df5777ad44b8$var$EMPTY_STRING = '';
// types
var $9d69df5777ad44b8$var$TYPE_COMMENT = 'comment';
var $9d69df5777ad44b8$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($9d69df5777ad44b8$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($9d69df5777ad44b8$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($9d69df5777ad44b8$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(0) || $9d69df5777ad44b8$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($9d69df5777ad44b8$var$EMPTY_STRING != style.charAt(i) && ($9d69df5777ad44b8$var$ASTERISK != style.charAt(i) || $9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($9d69df5777ad44b8$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $9d69df5777ad44b8$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($9d69df5777ad44b8$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($9d69df5777ad44b8$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($9d69df5777ad44b8$var$VALUE_REGEX);
        var ret = pos({
            type: $9d69df5777ad44b8$var$TYPE_DECLARATION,
            property: $9d69df5777ad44b8$var$trim(prop[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)),
            value: val ? $9d69df5777ad44b8$var$trim(val[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)) : $9d69df5777ad44b8$var$EMPTY_STRING
        });
        // ;
        match($9d69df5777ad44b8$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $9d69df5777ad44b8$var$trim(str) {
    return str ? str.replace($9d69df5777ad44b8$var$TRIM_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING) : $9d69df5777ad44b8$var$EMPTY_STRING;
}

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


var $5538f90e64b9e455$exports = {};
$5538f90e64b9e455$exports = import.meta.resolve("a2DY4");



const $736b82c689bfc478$export$6c14678d11eea615 = {
    audio: {
        mandatory: {
            googEchoCancellation: 'false',
            googAutoGainControl: 'false',
            googNoiseSuppression: 'false',
            googHighpassFilter: 'false'
        },
        optional: []
    }
};
const $736b82c689bfc478$export$2bc698ffb4b0204b = 2048;
const $736b82c689bfc478$export$a77e5d8acb4fcf5d = [
    'C',
    'C#',
    'D',
    'D#',
    'E',
    'F',
    'F#',
    'G',
    'G#',
    'A',
    'A#',
    'B'
];


// Implements modified ACF2+ algorithm
// Source: https://github.com/cwilso/PitchDetect
const $bcbb27a1ba72a7ff$export$2d4983f05caf72e7 = (buf, sampleRate)=>{
    // Not enough signal check
    const RMS = Math.sqrt(buf.reduce((acc, el)=>acc + el ** 2, 0) / buf.length);
    if (RMS < 0.001) return NaN;
    const THRES = 0.2;
    let r1 = 0;
    let r2 = buf.length - 1;
    for(let i = 0; i < buf.length / 2; ++i)if (Math.abs(buf[i]) < THRES) {
        r1 = i;
        break;
    }
    for(let i = 1; i < buf.length / 2; ++i)if (Math.abs(buf[buf.length - i]) < THRES) {
        r2 = buf.length - i;
        break;
    }
    const buf2 = buf.slice(r1, r2);
    const c = new Array(buf2.length).fill(0);
    for(let i = 0; i < buf2.length; ++i)for(let j = 0; j < buf2.length - i; ++j)c[i] = c[i] + buf2[j] * buf2[j + i];
    let d = 0;
    for(; c[d] > c[d + 1]; ++d);
    let maxval = -1;
    let maxpos = -1;
    for(let i = d; i < buf2.length; ++i)if (c[i] > maxval) {
        maxval = c[i];
        maxpos = i;
    }
    let T0 = maxpos;
    let x1 = c[T0 - 1];
    let x2 = c[T0];
    let x3 = c[T0 + 1];
    let a = (x1 + x3 - 2 * x2) / 2;
    let b = (x3 - x1) / 2;
    return sampleRate / (a ? T0 - b / (2 * a) : T0);
};


// Information sources:
// https://pages.mtu.edu/~suits/NoteFreqCalcs.html
// https://www.translatorscafe.com/unit-converter/en-US/calculator/note-frequency/
// https://guitardialogues.wordpress.com/

const $83dd8c346eb71295$var$CONCERT_PITCH = 440 //frequency of a fixed note, which is used as a standard for tuning. It is usually a standard (also called concert) pitch of 440 Hz, which is called A440 or note A in the one-line (or fourth) octave (A4)
;
const $83dd8c346eb71295$var$MIDI = 69 // the MIDI note number of A4
;
const $83dd8c346eb71295$var$A = 2 ** (1 / 12 // the twelth root of 2 = the number which when multiplied by itself 12 times equals 2 = 1.059463094359...
);
const $83dd8c346eb71295$var$C0_PITCH = 16.35 // frequency of lowest note: C0
;
var $83dd8c346eb71295$export$2e2bcd8739ae039 = (frequency)=>{
    const N = Math.round(12 * Math.log2(frequency / $83dd8c346eb71295$var$CONCERT_PITCH)) // the number of half steps away from the fixed note you are. If you are at a higher note, n is positive. If you are on a lower note, n is negative.
    ;
    const Fn = $83dd8c346eb71295$var$CONCERT_PITCH * $83dd8c346eb71295$var$A ** N // the frequency of the note n half steps away of concert pitch
    ;
    const noteIndex = (N + $83dd8c346eb71295$var$MIDI) % 12 // index of note letter from NOTES array
    ;
    const octave = Math.floor(Math.log2(Fn / $83dd8c346eb71295$var$C0_PITCH));
    return {
        frequency: frequency,
        note: (0, $736b82c689bfc478$export$a77e5d8acb4fcf5d)[noteIndex],
        noteFrequency: Fn,
        deviation: frequency - Fn,
        octave: octave
    };
};


'use strict';
const $67d312986a59f741$export$6446a2431c728cb0 = async ()=>{
    let rafID;
    let audioContext;
    let analyser;
    let callbacks = [];
    const init = async ()=>{
        const stream = await navigator.mediaDevices.getUserMedia((0, $736b82c689bfc478$export$6c14678d11eea615));
        audioContext = new AudioContext();
        analyser = audioContext.createAnalyser();
        analyser.fftSize = (0, $736b82c689bfc478$export$2bc698ffb4b0204b);
        audioContext.createMediaStreamSource(stream).connect(analyser);
    };
    const update = ()=>{
        const buffer = new Float32Array((0, $736b82c689bfc478$export$2bc698ffb4b0204b));
        analyser.getFloatTimeDomainData(buffer);
        const frequency = (0, $bcbb27a1ba72a7ff$export$2d4983f05caf72e7)(buffer, audioContext.sampleRate);
        callbacks.forEach((fn)=>fn(frequency ? (0, $83dd8c346eb71295$export$2e2bcd8739ae039)(frequency) : {}));
        rafID = requestAnimationFrame(update);
    };
    await init();
    return {
        start: ()=>update(),
        stop: ()=>cancelAnimationFrame(rafID),
        subscribe: (fn)=>callbacks = [
                ...callbacks,
                fn
            ],
        unsubscribe: (fn)=>callbacks = callbacks.filter((el)=>el !== fn)
    };
};


var $bedc752fb75fe228$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    $bedc752fb75fe228$exports = factory();
})($bedc752fb75fe228$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ "./packages/@logrocket/console/src/index.js": /*!**************************************************!*\
  !*** ./packages/@logrocket/console/src/index.js ***!
  \**************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var _registerConsole = _interopRequireDefault(__webpack_require__(/*! ./registerConsole */ "./packages/@logrocket/console/src/registerConsole.js"));
                var _default = _registerConsole.default;
                exports["default"] = _default;
            /***/ },
            /***/ "./packages/@logrocket/console/src/registerConsole.js": /*!************************************************************!*\
  !*** ./packages/@logrocket/console/src/registerConsole.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerConsole;
                var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
                var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/enhanceFunc */ "./packages/@logrocket/utils/src/enhanceFunc.ts"));
                var _exceptions = __webpack_require__(/*! @logrocket/exceptions */ "./packages/@logrocket/exceptions/src/index.js");
                // eslint-disable-line no-restricted-imports
                function registerConsole(logger) {
                    var unsubFunctions = [];
                    var methods = [
                        'log',
                        'warn',
                        'info',
                        'error',
                        'debug'
                    ];
                    methods.forEach(function(method) {
                        unsubFunctions.push((0, _enhanceFunc.default)(console, method, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            logger.addEvent('lr.core.LogEvent', function() {
                                var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                var isEnabled = consoleOptions.isEnabled;
                                if ((0, _typeof2.default)(isEnabled) === 'object' && isEnabled[method] === false || isEnabled === false) return null;
                                if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
                                    // some customers have loggers that add the log level as the first arg
                                    if (!!args && args.length >= 2 && args[0] === 'ERROR') {
                                        var secondArg = '';
                                        try {
                                            secondArg = " ".concat(args[1]);
                                        } catch (_unused) {} // eslint-disable-line no-empty
                                        _exceptions.Capture.captureMessage(logger, "".concat(args[0]).concat(secondArg), args, {}, true);
                                    } else _exceptions.Capture.captureMessage(logger, args[0], args, {}, true);
                                }
                                return {
                                    logLevel: method.toUpperCase(),
                                    args: args
                                };
                            });
                        }));
                    });
                    return function() {
                        unsubFunctions.forEach(function(unsubFunction) {
                            return unsubFunction();
                        });
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/Capture.js": /*!*******************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/Capture.js ***!
  \*******************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.captureMessage = captureMessage;
                exports.captureException = captureException;
                var _scrubException = __webpack_require__(/*! @logrocket/utils/src/scrubException */ "./packages/@logrocket/utils/src/scrubException.ts");
                var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
                var _stackTraceFromError = _interopRequireDefault(__webpack_require__(/*! ./stackTraceFromError */ "./packages/@logrocket/exceptions/src/stackTraceFromError.js"));
                // eslint-disable-line no-restricted-imports
                // eslint-disable-line no-restricted-imports
                function captureMessage(logger, message, messageArgs) {
                    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                    var isConsole = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                    var data = {
                        exceptionType: isConsole ? 'CONSOLE' : 'MESSAGE',
                        message: message,
                        messageArgs: messageArgs,
                        browserHref: window.location ? window.location.href : ''
                    };
                    (0, _scrubException.scrubException)(data, options);
                    logger.addEvent('lr.core.Exception', function() {
                        return data;
                    });
                }
                function captureException(logger, exception) {
                    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                    var exceptionType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'WINDOW';
                    var trace = preppedTrace || _TraceKit.default.computeStackTrace(exception);
                    var data = {
                        exceptionType: exceptionType,
                        errorType: trace.name,
                        message: trace.message,
                        browserHref: window.location ? window.location.href : ''
                    };
                    (0, _scrubException.scrubException)(data, options);
                    var addEventOptions = {
                        _stackTrace: (0, _stackTraceFromError.default)(trace)
                    };
                    logger.addEvent('lr.core.Exception', function() {
                        return data;
                    }, addEventOptions);
                }
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/index.js": /*!*****************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/index.js ***!
  \*****************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                var _typeof = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                Object.defineProperty(exports, "registerExceptions", {
                    enumerable: true,
                    get: function get() {
                        return _registerExceptions.default;
                    }
                });
                exports.Capture = void 0;
                var _registerExceptions = _interopRequireDefault(__webpack_require__(/*! ./registerExceptions */ "./packages/@logrocket/exceptions/src/registerExceptions.js"));
                var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@logrocket/exceptions/src/Capture.js"));
                exports.Capture = Capture;
                function _getRequireWildcardCache(nodeInterop) {
                    if (typeof WeakMap !== "function") return null;
                    var cacheBabelInterop = new WeakMap();
                    var cacheNodeInterop = new WeakMap();
                    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
                        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
                    })(nodeInterop);
                }
                function _interopRequireWildcard(obj, nodeInterop) {
                    if (!nodeInterop && obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache(nodeInterop);
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/raven/raven.js": /*!***********************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/raven/raven.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
                var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
                var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
                /* eslint-disable */ /*
Some contents of this file were originaly from raven-js, BSD-2 Clause

Copyright (c) 2018 Sentry (https://sentry.io) and individual contributors.
All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
* Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ var objectPrototype = Object.prototype;
                function isUndefined(what) {
                    return what === void 0;
                }
                function isFunction(what) {
                    return typeof what === 'function';
                }
                function each(obj, callback) {
                    var i, j;
                    if (isUndefined(obj.length)) {
                        for(i in obj)if (hasKey(obj, i)) callback.call(null, i, obj[i]);
                    } else {
                        j = obj.length;
                        if (j) for(i = 0; i < j; i++)callback.call(null, i, obj[i]);
                    }
                }
                /**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */ function hasKey(object, key) {
                    return objectPrototype.hasOwnProperty.call(object, key);
                }
                /**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */ function fill(obj, name, replacement, track) {
                    var orig = obj[name];
                    obj[name] = replacement(orig);
                    if (track) track.push([
                        obj,
                        name,
                        orig
                    ]);
                }
                var _window = typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};
                var _document = _window.document;
                var Handler = /*#__PURE__*/ function() {
                    function Handler(_ref) {
                        var captureException = _ref.captureException;
                        (0, _classCallCheck2.default)(this, Handler);
                        this._errorHandler = this._errorHandler.bind(this);
                        this._ignoreOnError = 0;
                        this._wrappedBuiltIns = [];
                        this.captureException = captureException;
                        _TraceKit.default.report.subscribe(this._errorHandler);
                        this._instrumentTryCatch();
                    }
                    (0, _createClass2.default)(Handler, [
                        {
                            key: "uninstall",
                            value: function uninstall() {
                                _TraceKit.default.report.unsubscribe(this._errorHandler);
                                // restore any wrapped builtins
                                var builtin;
                                while(this._wrappedBuiltIns.length){
                                    builtin = this._wrappedBuiltIns.shift();
                                    var obj = builtin[0], name = builtin[1], orig = builtin[2];
                                    obj[name] = orig;
                                }
                            }
                        },
                        {
                            key: "_errorHandler",
                            value: function _errorHandler(report) {
                                if (!this._ignoreOnError) this.captureException(report);
                            }
                        },
                        {
                            key: "_ignoreNextOnError",
                            value: function _ignoreNextOnError() {
                                var _this = this;
                                this._ignoreOnError += 1;
                                setTimeout(function() {
                                    // onerror should trigger before setTimeout
                                    _this._ignoreOnError -= 1;
                                });
                            }
                        },
                        {
                            key: "context",
                            value: function context(options, func, args) {
                                if (isFunction(options)) {
                                    args = func || [];
                                    func = options;
                                    options = undefined;
                                }
                                return this.wrap(options, func).apply(this, args);
                            }
                        },
                        {
                            key: "wrap",
                            value: /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */ function wrap(options, func, _before) {
                                var self1 = this;
                                // 1 argument has been passed, and it's not a function
                                // so just return it
                                if (isUndefined(func) && !isFunction(options)) return options;
                                // options is optional
                                if (isFunction(options)) {
                                    func = options;
                                    options = undefined;
                                }
                                // At this point, we've passed along 2 arguments, and the second one
                                // is not a function either, so we'll just return the second argument.
                                if (!isFunction(func)) return func;
                                // We don't wanna wrap it twice!
                                try {
                                    if (func.__lr__) return func;
                                    // If this has already been wrapped in the past, return that
                                    if (func.__lr_wrapper__) return func.__lr_wrapper__;
                                    // If func is not extensible, return the function as-is to prevent TypeErrors
                                    // when trying to add new props & to assure immutable funcs aren't changed
                                    if (!Object.isExtensible(func)) return func;
                                } catch (e) {
                                    // Just accessing custom props in some Selenium environments
                                    // can cause a "Permission denied" exception (see lr-js#495).
                                    // Bail on wrapping and return the function as-is (defers to window.onerror).
                                    return func;
                                }
                                function wrapped() {
                                    var args = [], i = arguments.length, deep = !options || options && options.deep !== false;
                                    if (_before && isFunction(_before)) _before.apply(this, arguments);
                                    // Recursively wrap all of a function's arguments that are
                                    // functions themselves.
                                    while(i--)args[i] = deep ? self1.wrap(options, arguments[i]) : arguments[i];
                                    try {
                                        // Attempt to invoke user-land function. This is part of the LogRocket SDK.
                                        // If you're seeing this frame in a stack trace, it means that LogRocket caught
                                        // an unhandled error thrown by your application code, reported it, then bubbled
                                        // it up. This is expected behavior and is not a bug with LogRocket.
                                        return func.apply(this, args);
                                    } catch (e) {
                                        self1._ignoreNextOnError();
                                        self1.captureException(_TraceKit.default.computeStackTrace(e), options);
                                        throw e;
                                    }
                                }
                                // copy over properties of the old function
                                for(var property in func)if (hasKey(func, property)) wrapped[property] = func[property];
                                wrapped.prototype = func.prototype;
                                func.__lr_wrapper__ = wrapped;
                                // Signal that this function has been wrapped already
                                // for both debugging and to prevent it to being wrapped twice
                                wrapped.__lr__ = true;
                                wrapped.__inner__ = func;
                                return wrapped;
                            }
                        },
                        {
                            key: "_instrumentTryCatch",
                            value: /**
     * Install any queued plugins
     */ function _instrumentTryCatch() {
                                var self1 = this;
                                var wrappedBuiltIns = self1._wrappedBuiltIns;
                                function wrapTimeFn(orig) {
                                    return function(fn, t) {
                                        // preserve arity
                                        // Make a copy of the arguments to prevent deoptimization
                                        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                                        var args = new Array(arguments.length);
                                        for(var i = 0; i < args.length; ++i)args[i] = arguments[i];
                                        var originalCallback = args[0];
                                        if (isFunction(originalCallback)) args[0] = self1.wrap(originalCallback);
                                        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                                        // also supports only two arguments and doesn't care what this is, so we
                                        // can just call the original function directly.
                                        if (orig.apply) return orig.apply(this, args);
                                        else return orig(args[0], args[1]);
                                    };
                                }
                                function wrapEventTarget(global) {
                                    var proto = _window[global] && _window[global].prototype;
                                    if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
                                        fill(proto, 'addEventListener', function(orig) {
                                            return function(evtName, fn, capture, secure) {
                                                // preserve arity
                                                try {
                                                    if (fn && fn.handleEvent) fn.handleEvent = self1.wrap(fn.handleEvent);
                                                } catch (err) {
                                                // can sometimes get 'Permission denied to access property "handle Event'
                                                }
                                                // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                                                // so that we don't have more than one wrapper function
                                                var before;
                                                return orig.call(this, evtName, self1.wrap(fn, undefined, before), capture, secure);
                                            };
                                        }, wrappedBuiltIns);
                                        fill(proto, 'removeEventListener', function(orig) {
                                            return function(evt, fn, capture, secure) {
                                                /**
               * There are 3 scenararios to consider when removing an event listener
               *
               * 1. 'addEventListener' was called when the LR SDK was uninitialized.
               * In this case, the event handler has not been wrapped, so this behaves 
               * as a passthrough and just removes the original handler.
               *
               * 2. 'addEventListener' was called while the LR SDK was initialized, which means
               * our wrapped 'addEventListener' was called. In this case, the tracked event handler
               * is also wrapped, so we need to remove that wrapped version of the handler.
               *
               * 3. 'addEventListener' was called both before and after the LR SDK was initialized
               * for the same event handler. In this case, we have to remove both of them.
               * If we'd remove only the wrapped one, the initial handler would stick around forever.
               */ try {
                                                    var wrappedFn = fn === null || fn === void 0 ? void 0 : fn.__lr_wrapper__;
                                                    if (wrappedFn) orig.call(this, evt, wrappedFn, capture, secure);
                                                } catch (e) {
                                                // ignore, accessing __lr_wrapper__ will throw in some Selenium environments
                                                }
                                                return orig.call(this, evt, fn, capture, secure);
                                            };
                                        }, // undefined is provided here to skip tracking for uninstall.
                                        // Once our removeEventListener is installed, it can't be uninstalled.
                                        // We always need to support removing logrocket wrapped event handlers (event
                                        // handlers added when logrocket was installed) even after SDK shutdown.
                                        undefined);
                                    }
                                }
                                fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
                                fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
                                if (_window.requestAnimationFrame) fill(_window, 'requestAnimationFrame', function(orig) {
                                    return function(cb) {
                                        return orig(self1.wrap(cb));
                                    };
                                }, wrappedBuiltIns);
                                // event targets borrowed from bugsnag-js:
                                // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
                                var eventTargets = [
                                    'EventTarget',
                                    'Window',
                                    'Node',
                                    'ApplicationCache',
                                    'AudioTrackList',
                                    'ChannelMergerNode',
                                    'CryptoOperation',
                                    'EventSource',
                                    'FileReader',
                                    'HTMLUnknownElement',
                                    'IDBDatabase',
                                    'IDBRequest',
                                    'IDBTransaction',
                                    'KeyOperation',
                                    'MediaController',
                                    'MessagePort',
                                    'ModalWindow',
                                    'Notification',
                                    'SVGElementInstance',
                                    'Screen',
                                    'TextTrack',
                                    'TextTrackCue',
                                    'TextTrackList',
                                    'WebSocket',
                                    'WebSocketWorker',
                                    'Worker',
                                    'XMLHttpRequest',
                                    'XMLHttpRequestEventTarget',
                                    'XMLHttpRequestUpload'
                                ];
                                for(var i = 0; i < eventTargets.length; i++)wrapEventTarget(eventTargets[i]);
                                var $ = _window.jQuery || _window.$;
                                if ($ && $.fn && $.fn.ready) fill($.fn, 'ready', function(orig) {
                                    return function(fn) {
                                        return orig.call(this, self1.wrap(fn));
                                    };
                                }, wrappedBuiltIns);
                            }
                        }
                    ]);
                    return Handler;
                }();
                exports["default"] = Handler;
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/registerExceptions.js": /*!******************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/registerExceptions.js ***!
  \******************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                var _typeof = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerCore;
                var _raven = _interopRequireDefault(__webpack_require__(/*! ./raven/raven */ "./packages/@logrocket/exceptions/src/raven/raven.js"));
                var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@logrocket/exceptions/src/Capture.js"));
                function _getRequireWildcardCache(nodeInterop) {
                    if (typeof WeakMap !== "function") return null;
                    var cacheBabelInterop = new WeakMap();
                    var cacheNodeInterop = new WeakMap();
                    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
                        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
                    })(nodeInterop);
                }
                function _interopRequireWildcard(obj, nodeInterop) {
                    if (!nodeInterop && obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache(nodeInterop);
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function registerCore(logger) {
                    var raven = new _raven.default({
                        captureException: function captureException(errorReport) {
                            Capture.captureException(logger, null, null, errorReport);
                        }
                    });
                    var rejectionHandler = function rejectionHandler(evt) {
                        // http://2ality.com/2016/04/unhandled-rejections.html
                        if (evt.reason instanceof Error) Capture.captureException(logger, evt.reason, null, null, 'UNHANDLED_REJECTION');
                        else logger.addEvent('lr.core.Exception', function() {
                            return {
                                exceptionType: 'UNHANDLED_REJECTION',
                                message: evt.reason || 'Unhandled Promise rejection'
                            };
                        });
                    };
                    window.addEventListener('unhandledrejection', rejectionHandler);
                    return function() {
                        window.removeEventListener('unhandledrejection', rejectionHandler);
                        raven.uninstall();
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/stackTraceFromError.js": /*!*******************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/stackTraceFromError.js ***!
  \*******************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = stackTraceFromError;
                function stackTraceFromError(errorReport) {
                    function makeNotNull(val) {
                        return val === null ? undefined : val;
                    }
                    return errorReport.stack ? errorReport.stack.map(function(frame) {
                        return {
                            lineNumber: makeNotNull(frame.line),
                            columnNumber: makeNotNull(frame.column),
                            fileName: makeNotNull(frame.url),
                            functionName: makeNotNull(frame.func)
                        };
                    }) : undefined;
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/fetchIntercept.js": /*!***********************************************************!*\
  !*** ./packages/@logrocket/network/src/fetchIntercept.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js"));
                var _registerXHR = __webpack_require__(/*! ./registerXHR */ "./packages/@logrocket/network/src/registerXHR.js");
                var interceptors = [];
                function makeInterceptor(fetch, fetchId) {
                    var reversedInterceptors = interceptors.reduce(function(array, interceptor) {
                        return [
                            interceptor
                        ].concat(array);
                    }, []);
                    // if a browser supports fetch, it supports promise
                    // eslint-disable-next-line compat/compat
                    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                    var promise = Promise.resolve(args);
                    // Register request interceptors
                    reversedInterceptors.forEach(function(_ref) {
                        var request = _ref.request, requestError = _ref.requestError;
                        if (request || requestError) promise = promise.then(function(args) {
                            return request.apply(void 0, [
                                fetchId
                            ].concat((0, _toConsumableArray2.default)(args)));
                        }, function(args) {
                            return requestError.apply(void 0, [
                                fetchId
                            ].concat((0, _toConsumableArray2.default)(args)));
                        });
                    });
                    promise = promise.then(function(args) {
                        (0, _registerXHR.setActive)(false);
                        var res;
                        var err;
                        try {
                            res = fetch.apply(void 0, (0, _toConsumableArray2.default)(args));
                        } catch (_err) {
                            err = _err;
                        }
                        (0, _registerXHR.setActive)(true);
                        if (err) throw err;
                        return res;
                    });
                    reversedInterceptors.forEach(function(_ref2) {
                        var response = _ref2.response, responseError = _ref2.responseError;
                        if (response || responseError) promise = promise.then(function(res) {
                            return response(fetchId, res);
                        }, function(err) {
                            return responseError && responseError(fetchId, err);
                        });
                    });
                    return promise;
                }
                function attach(env) {
                    if (!env.fetch || !env.Promise) // Make sure fetch is available in the given environment. If it's not, then
                    // default to using XHR intercept.
                    return;
                    var isPolyfill = env.fetch.polyfill;
                    // eslint-disable-next-line no-param-reassign
                    env.fetch = function(fetch) {
                        var fetchId = 0;
                        return function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            return makeInterceptor.apply(void 0, [
                                fetch,
                                fetchId++
                            ].concat(args));
                        };
                    }(env.fetch);
                    // Forward the polyfill properly from fetch (set by github/whatwg-fetch).
                    if (isPolyfill) // eslint-disable-next-line no-param-reassign
                    env.fetch.polyfill = isPolyfill;
                }
                // TODO: React Native
                //   attach(global);
                var didAttach = false;
                var _default = {
                    register: function register(interceptor) {
                        if (!didAttach) {
                            didAttach = true;
                            attach(window);
                        }
                        interceptors.push(interceptor);
                        return function() {
                            var index = interceptors.indexOf(interceptor);
                            if (index >= 0) interceptors.splice(index, 1);
                        };
                    },
                    clear: function clear() {
                        interceptors = [];
                    }
                };
                exports["default"] = _default;
            /***/ },
            /***/ "./packages/@logrocket/network/src/index.js": /*!**************************************************!*\
  !*** ./packages/@logrocket/network/src/index.js ***!
  \**************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerNetwork;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
                var _registerFetch = _interopRequireDefault(__webpack_require__(/*! ./registerFetch */ "./packages/@logrocket/network/src/registerFetch.js"));
                var _registerIonic = __webpack_require__(/*! ./registerIonic */ "./packages/@logrocket/network/src/registerIonic.ts");
                var _registerNetworkInformation = _interopRequireDefault(__webpack_require__(/*! ./registerNetworkInformation */ "./packages/@logrocket/network/src/registerNetworkInformation.js"));
                var _registerXHR = _interopRequireDefault(__webpack_require__(/*! ./registerXHR */ "./packages/@logrocket/network/src/registerXHR.js"));
                var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            (0, _defineProperty2.default)(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                // eslint-disable-line no-restricted-imports
                function registerNetwork(logger) {
                    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        isReactNative: false,
                        isDisabled: false
                    };
                    if ((config === null || config === void 0 ? void 0 : config.isDisabled) === true) return function() {};
                    var isReactNative = config.isReactNative, shouldAugmentNPS = config.shouldAugmentNPS, shouldParseXHRBlob = config.shouldParseXHRBlob;
                    var ignoredNetwork = {};
                    // truncate if > 4MB in size
                    var truncate = function truncate(data) {
                        var limit = 4096000;
                        var str = data;
                        if ((0, _typeof2.default)(data) === 'object' && data != null) {
                            var proto = Object.getPrototypeOf(data);
                            if (proto === Object.prototype || proto === null) // plain object - jsonify for the size check
                            str = JSON.stringify(data);
                        }
                        if (str && str.length && str.length > limit && typeof str === 'string') {
                            var beginning = str.substring(0, 1000);
                            return "".concat(beginning, " ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference/network");
                        }
                        return data;
                    };
                    var addRequest = function addRequest(reqId, request) {
                        var method = request.method;
                        logger.addEvent('lr.network.RequestEvent', function() {
                            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, _ref$requestSanitizer = _ref.requestSanitizer, requestSanitizer = _ref$requestSanitizer === void 0 ? function(f) {
                                return f;
                            } : _ref$requestSanitizer;
                            if (!isEnabled) return null;
                            var sanitized = null;
                            try {
                                // only try catch user defined functions
                                sanitized = requestSanitizer(_objectSpread(_objectSpread({}, request), {}, {
                                    reqId: reqId
                                }));
                            } catch (err) {
                                console.error(err);
                            }
                            if (sanitized) {
                                var url = sanitized.url;
                                if (typeof document !== 'undefined' && typeof document.createElement === 'function') {
                                    // Writing and then reading from an a tag turns a relative
                                    // url into an absolute one.
                                    var a = document.createElement('a');
                                    a.href = sanitized.url;
                                    url = a.href;
                                }
                                return {
                                    reqId: reqId,
                                    // default
                                    url: url,
                                    // sanitized
                                    headers: (0, _mapValues.default)(sanitized.headers, function(headerValue) {
                                        // sanitized
                                        return "".concat(headerValue);
                                    }),
                                    body: truncate(sanitized.body),
                                    // sanitized
                                    method: method,
                                    // default
                                    referrer: sanitized.referrer || undefined,
                                    // sanitized
                                    mode: sanitized.mode || undefined,
                                    // sanitized
                                    credentials: sanitized.credentials || undefined // sanitized
                                };
                            }
                            ignoredNetwork[reqId] = true;
                            return null;
                        });
                    };
                    var addResponse = function addResponse(reqId, response) {
                        var method = response.method, status = response.status, responseType = response.responseType;
                        logger.addEvent('lr.network.ResponseEvent', function() {
                            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$isEnabled = _ref2.isEnabled, isEnabled = _ref2$isEnabled === void 0 ? true : _ref2$isEnabled, _ref2$responseSanitiz = _ref2.responseSanitizer, responseSanitizer = _ref2$responseSanitiz === void 0 ? function(f) {
                                return f;
                            } : _ref2$responseSanitiz;
                            if (!isEnabled) return null;
                            else if (ignoredNetwork[reqId]) {
                                delete ignoredNetwork[reqId];
                                return null;
                            }
                            var sanitized = null;
                            try {
                                // only try catch user defined functions
                                sanitized = responseSanitizer(_objectSpread(_objectSpread({}, response), {}, {
                                    reqId: reqId
                                }));
                            } catch (err) {
                                console.error(err);
                            // fall through to redacted log
                            }
                            if (sanitized) return {
                                reqId: reqId,
                                // default
                                responseType: responseType,
                                status: sanitized.status,
                                // sanitized
                                headers: (0, _mapValues.default)(sanitized.headers, function(headerValue) {
                                    // sanitized
                                    return "".concat(headerValue);
                                }),
                                body: truncate(sanitized.body),
                                // sanitized
                                method: method // default
                            };
                            return {
                                reqId: reqId,
                                // default
                                responseType: responseType,
                                status: status,
                                // default
                                headers: {},
                                // redacted
                                body: null,
                                // redacted
                                method: method // default
                            };
                        });
                    };
                    var isIgnored = function isIgnored(reqId) {
                        return logger.isDisabled || ignoredNetwork[reqId] === true;
                    };
                    var unsubFetch = (0, _registerFetch.default)({
                        addRequest: addRequest,
                        addResponse: addResponse,
                        isIgnored: isIgnored
                    });
                    var unsubXHR = (0, _registerXHR.default)({
                        addRequest: addRequest,
                        addResponse: addResponse,
                        isIgnored: isIgnored,
                        logger: logger,
                        shouldAugmentNPS: shouldAugmentNPS,
                        shouldParseXHRBlob: shouldParseXHRBlob
                    });
                    var unsubIonic = (0, _registerIonic.registerIonic)({
                        addRequest: addRequest,
                        addResponse: addResponse,
                        isIgnored: isIgnored
                    });
                    var unsubNetworkInformation = isReactNative ? function() {} : (0, _registerNetworkInformation.default)(logger);
                    return function() {
                        unsubNetworkInformation();
                        unsubFetch();
                        unsubXHR();
                        unsubIonic();
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/registerFetch.js": /*!**********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerFetch.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerFetch;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
                var _fetchIntercept = _interopRequireDefault(__webpack_require__(/*! ./fetchIntercept */ "./packages/@logrocket/network/src/fetchIntercept.js"));
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            (0, _defineProperty2.default)(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                function makeObjectFromHeaders(headers) {
                    // If using real fetch, we must stringify the Headers object.
                    if (headers == null || typeof headers.forEach !== 'function') return headers;
                    var result = {};
                    headers.forEach(function(value, key) {
                        if (result[key]) result[key] = "".concat(result[key], ",").concat(value);
                        else result[key] = "".concat(value);
                    });
                    return result;
                }
                // XHR specification is unclear of what types to allow in value so using toString method for now
                var stringifyHeaders = function stringifyHeaders(headers) {
                    return (0, _mapValues.default)(makeObjectFromHeaders(headers), function(value) {
                        return "".concat(value);
                    });
                };
                function pluckFetchFields() {
                    var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    return {
                        url: arg.url,
                        headers: stringifyHeaders(arg.headers),
                        method: arg.method && arg.method.toUpperCase(),
                        referrer: arg.referrer || undefined,
                        mode: arg.mode || undefined,
                        credentials: arg.credentials || undefined
                    };
                }
                function registerFetch(_ref) {
                    var addRequest = _ref.addRequest, addResponse = _ref.addResponse, isIgnored = _ref.isIgnored;
                    var LOGROCKET_FETCH_LABEL = 'fetch-';
                    var fetchMethodMap = {};
                    var unregister = _fetchIntercept.default.register({
                        request: function request(fetchId) {
                            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                            var p;
                            if (typeof Request !== 'undefined' && args[0] instanceof Request) {
                                var clonedText;
                                // Request.clone() and Request.text() may throw in Safari (e.g., when
                                // request body contains FormData)
                                try {
                                    clonedText = args[0].clone().text();
                                } catch (err) {
                                    // if a browser supports fetch, it supports promise
                                    // eslint-disable-next-line compat/compat
                                    clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
                                }
                                p = clonedText.then(function(body) {
                                    return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
                                        body: body
                                    });
                                }, function(err) {
                                    return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
                                        body: "LogRocket fetch error: ".concat(err.message)
                                    });
                                });
                            } else // if a browser supports fetch, it supports promise
                            // eslint-disable-next-line compat/compat
                            p = Promise.resolve(_objectSpread(_objectSpread({}, pluckFetchFields(args[1])), {}, {
                                url: "".concat(args[0]),
                                body: (args[1] || {}).body
                            }));
                            return p.then(function(req) {
                                fetchMethodMap[fetchId] = req.method;
                                addRequest("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), req);
                                return args;
                            });
                        },
                        requestError: function requestError(fetchId, error) {
                            // if a browser supports fetch, it supports promise
                            // eslint-disable-next-line compat/compat
                            return Promise.reject(error);
                        },
                        response: function response(fetchId, _response) {
                            var responseClone;
                            var responseTextPromise;
                            if (isIgnored("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId))) // Don't even try to read ignored requests
                            return _response;
                            // event-streams are meant to remain open and be consumed over time by the sender. Attempting to capture the body
                            // of these requests will cause us to "stall" here, and prevents the users of our SDK from using event-streams
                            // unless they have explicitly ignored the request.
                            if (_response.headers.get('content-type') === 'text/event-stream') // eslint-disable-next-line compat/compat
                            responseTextPromise = Promise.resolve('LogRocket skipped consuming an event-stream body.');
                            else {
                                try {
                                    // TODO: enhance function on original response and future clones for:
                                    // text(), json(), blob(), formdata(), arraybuffer()
                                    responseClone = _response.clone();
                                } catch (err) {
                                    // safari has a bug where cloning can fail
                                    var responseHash = {
                                        url: _response.url,
                                        responseType: _response.type.toUpperCase(),
                                        status: _response.status,
                                        headers: stringifyHeaders(_response.headers),
                                        body: "LogRocket fetch error: ".concat(err.message),
                                        method: fetchMethodMap[fetchId]
                                    };
                                    delete fetchMethodMap[fetchId];
                                    addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
                                    return _response;
                                }
                                try {
                                    if (window.TextDecoder && responseClone.body) {
                                        // use a reader to manually read the response body rather than calling response.text()
                                        // response.text() was timing out for some responses, in some cases because Apollo sends
                                        //   an abort signal or because the stream wasn't getting terminated cleanly
                                        // using a reader allows us to capture what we can from response bodies before the
                                        //   response receives an abort signal
                                        var reader = responseClone.body.getReader();
                                        // response bodies always decode with UTF-8
                                        // https://developer.mozilla.org/en-US/docs/Web/API/Response/text
                                        var utf8Decoder = new window.TextDecoder('utf-8');
                                        var bodyContents = '';
                                        responseTextPromise = reader.read().then(function readResponseBody(_ref2) {
                                            var done = _ref2.done, value = _ref2.value;
                                            if (done) return bodyContents;
                                            var chunk = value ? utf8Decoder.decode(value, {
                                                stream: true
                                            }) : '';
                                            bodyContents += chunk;
                                            return reader.read().then(readResponseBody);
                                        });
                                    } else // TextDecoder doesn't have support across all browsers that LR supports, so if there's
                                    //  no TextDecoder, fall back to the old approach
                                    responseTextPromise = responseClone.text();
                                } catch (error) {
                                    // eslint-disable-next-line compat/compat
                                    responseTextPromise = Promise.resolve("LogRocket error reading body: ".concat(error.message));
                                }
                            }
                            responseTextPromise.catch(function(error) {
                                // don't drop request & log to console when the request is aborted,
                                // as it may have already completed
                                // https://github.com/LogRocket/logrocket/issues/34
                                if (error.name === 'AbortError' && error instanceof DOMException) return;
                                return "LogRocket error reading body: ".concat(error.message);
                            }).then(function(data) {
                                var responseHash = {
                                    url: _response.url,
                                    responseType: _response.type.toUpperCase(),
                                    status: _response.status,
                                    headers: stringifyHeaders(_response.headers),
                                    body: data,
                                    method: fetchMethodMap[fetchId]
                                };
                                delete fetchMethodMap[fetchId];
                                addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
                            });
                            return _response;
                        },
                        responseError: function responseError(fetchId, error) {
                            var response = {
                                url: undefined,
                                status: 0,
                                headers: {},
                                body: "".concat(error)
                            };
                            addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), response);
                            // if a browser supports fetch, it supports promise
                            // eslint-disable-next-line compat/compat
                            return Promise.reject(error);
                        }
                    });
                    return unregister;
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/registerIonic.ts": /*!**********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerIonic.ts ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.mergeHeaders = mergeHeaders;
                exports.serializeQueryParams = serializeQueryParams;
                exports.appendQueryParamsString = appendQueryParamsString;
                exports.processData = processData;
                exports.registerIonic = registerIonic;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
                var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js"));
                var _protectFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/protectFunc */ "./packages/@logrocket/utils/src/protectFunc.js"));
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it.return != null) it.return();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            (0, _defineProperty2.default)(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                var VALID_HTTP_METHODS = new Set([
                    'get',
                    'put',
                    'post',
                    'patch',
                    'head',
                    'delete',
                    'options',
                    'upload',
                    'download'
                ]);
                var VALID_SERIALIZERS = new Set([
                    'urlencoded',
                    'json',
                    'utf8'
                ]);
                var UNSUPPORTED_SERIALIZERS = new Set([
                    'raw',
                    'multipart'
                ]);
                var LOGROCKET_IONIC_LABEL = 'ionic-';
                var UNSUPPORTED_PLATFORMS = new Set([
                    'desktop',
                    'mobileweb',
                    'pwa'
                ]);
                var FORM_DATA = new Set([
                    'FormData'
                ]);
                var EMPTY_SET = new Set();
                var STRING_SET = new Set([
                    'string'
                ]);
                var STRING_ARRAY_SET = new Set([
                    'string',
                    'array'
                ]);
                var ALLOWED_DATA_TYPES = {
                    utf8: STRING_SET,
                    urlencoded: new Set([
                        'object'
                    ]),
                    json: new Set([
                        'array',
                        'object'
                    ]),
                    raw: new Set([
                        'Uint8Array',
                        'ArrayBuffer'
                    ]),
                    default: EMPTY_SET
                };
                // Used in intercepting Ionic pugin requests found here https://www.npmjs.com/package/@ionic-native/http
                // based on https://github.com/silkimen/cordova-plugin-advanced-http/blob/master/www/public-interface.js
                function checkForValidStringValue(list, value, fieldName) {
                    if (typeof value !== 'string') throw new Error("".concat(fieldName, " must be one of: ").concat((0, _toConsumableArray2.default)(list).join(', ')));
                    // eslint-disable-next-line no-param-reassign
                    value = value.trim().toLowerCase();
                    if (!list.has(value)) throw new Error("".concat(fieldName, " must be one of: ").concat((0, _toConsumableArray2.default)(list).join(', ')));
                    return value;
                }
                function checkKeyValuePairObject(obj, allowedChildren, onInvalidValueMessage) {
                    if ((0, _typeof2.default)(obj) !== 'object') throw new Error(onInvalidValueMessage);
                    for(var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++){
                        var key = _Object$keys[_i];
                        if (!allowedChildren.has((0, _typeof2.default)(obj[key]))) throw new Error(onInvalidValueMessage);
                    }
                    return obj;
                }
                function getMatchingHostHeaders(url, ionicHttp) {
                    var _URL = new URL(url), host = _URL.host;
                    return ionicHttp.getHeaders(host) || null;
                }
                function mergeHeaders(defaultHeaders, headers) {
                    return _objectSpread(_objectSpread({}, defaultHeaders), headers);
                }
                function getMergedHeaders(url, requestHeaders, ionicHttp) {
                    // get global headers via public method
                    var globalHeaders = ionicHttp.getHeaders('*') || {};
                    var hostHeaders = getMatchingHostHeaders(url, ionicHttp) || {};
                    return mergeHeaders(mergeHeaders(globalHeaders, hostHeaders), requestHeaders);
                }
                function serializeValue(value, encode) {
                    if (encode) return encodeURIComponent(value);
                    else return value;
                }
                function serializeIdentifier(parentKey, key, encode) {
                    if (!parentKey.length) return encode ? encodeURIComponent(key) : key;
                    if (encode) return "".concat(encodeURIComponent(parentKey), "[").concat(encodeURIComponent(key), "]");
                    else return "".concat(parentKey, "[").concat(key, "]");
                }
                function serializeArray(parentKey, array, encode) {
                    var parts = [];
                    var _iterator = _createForOfIteratorHelper(array), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var e = _step.value;
                            if (Array.isArray(e)) {
                                parts.push(serializeArray("".concat(parentKey, "[]"), e, encode));
                                continue;
                            } else if ((0, _typeof2.default)(e) === 'object') {
                                /* This replicates what appears to be a bug in the Ionic code in order to capture everything identically
           parts.push(serializeObject(`${parentKey}[]${array[i]}`, encode));
           https://github.com/silkimen/cordova-plugin-advanced-http/blob/master/www/url-util.js#L73
        */ // eslint-disable-next-line @typescript-eslint/no-use-before-define
                                parts.push(serializeObject("".concat(parentKey, "[]").concat(e), encode, undefined));
                                continue;
                            }
                            parts.push("".concat(serializeIdentifier(parentKey, '', encode), "=").concat(serializeValue(e, encode)));
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    return parts.join('&');
                }
                function serializeObject(parentKey, object, encode) {
                    var parts = [];
                    for(var key in object){
                        if (!object.hasOwnProperty(key)) continue;
                        var identifier = parentKey.length ? "".concat(parentKey, "[").concat(key, "]") : key;
                        if (Array.isArray(object[key])) {
                            parts.push(serializeArray(identifier, object[key], encode));
                            continue;
                        } else if ((0, _typeof2.default)(object[key]) === 'object' && object[key] !== null) {
                            parts.push(serializeObject(identifier, object[key], encode));
                            continue;
                        }
                        parts.push("".concat(serializeIdentifier(parentKey, key, encode), "=").concat(serializeValue(object[key], encode)));
                    }
                    return parts.join('&');
                }
                function serializeQueryParams(params, encode) {
                    return serializeObject('', params, encode);
                }
                function appendQueryParamsString(url, params) {
                    if (!url.length || !params.length) return url;
                    var _URL2 = new URL(url), host = _URL2.host, pathname = _URL2.pathname, search = _URL2.search, hash = _URL2.hash, protocol = _URL2.protocol;
                    return "".concat(protocol, "//").concat(host).concat(pathname).concat(search.length ? "".concat(search, "&").concat(params) : "?".concat(params)).concat(hash);
                }
                function getAllowedDataTypes(dataSerializer) {
                    return ALLOWED_DATA_TYPES[dataSerializer] || ALLOWED_DATA_TYPES.default;
                }
                function getAllowedInstanceTypes(dataSerializer) {
                    return dataSerializer === 'multipart' ? FORM_DATA : EMPTY_SET;
                }
                function processData(data, dataSerializer) {
                    var currentDataType = (0, _typeof2.default)(data);
                    var allowedDataTypes = getAllowedDataTypes(dataSerializer);
                    var allowedInstanceTypes = getAllowedInstanceTypes(dataSerializer);
                    if (allowedInstanceTypes.size > 0) {
                        var isCorrectInstanceType = false;
                        allowedInstanceTypes.forEach(function(type) {
                            if (__webpack_require__.g[type] && data instanceof __webpack_require__.g[type]) isCorrectInstanceType = true;
                        });
                        if (!isCorrectInstanceType) throw new Error("INSTANCE_TYPE_MISMATCH_DATA ".concat((0, _toConsumableArray2.default)(allowedInstanceTypes).join(', ')));
                    }
                    if (allowedInstanceTypes.size === 0 && !allowedDataTypes.has(currentDataType)) throw new Error("TYPE_MISMATCH_DATA ".concat((0, _toConsumableArray2.default)(allowedDataTypes).join(', ')));
                    switch(dataSerializer){
                        case 'utf8':
                            // already a string
                            return data;
                        default:
                            // object of some sort (urlencoded or json)
                            return JSON.stringify(data, undefined, 2);
                    }
                }
                function handleMissingOptions(options, ionicHttp) {
                    // eslint-disable-next-line no-param-reassign
                    options = options || {};
                    var serializer;
                    var data = options.data;
                    try {
                        // need to check special case if data type is not handled by LR but otherwise valid
                        serializer = checkForValidStringValue(VALID_SERIALIZERS, options.serializer || ionicHttp.getDataSerializer(), 'serializer / data payload type');
                    } catch (_unused) {
                        // if this fails it's of entirely invalid type, let it fail
                        serializer = checkForValidStringValue(UNSUPPORTED_SERIALIZERS, options.serializer || ionicHttp.getDataSerializer(), 'serializer / data payload type');
                        // is of a valid but unsupported to LR type, set data to empty
                        data = {};
                    }
                    return {
                        data: data,
                        filePath: options.filePath,
                        followRedirect: options.followRedirect,
                        headers: checkKeyValuePairObject(options.headers || {}, STRING_SET, 'Invalid header type, must be string'),
                        method: checkForValidStringValue(VALID_HTTP_METHODS, options.method || VALID_HTTP_METHODS[0], 'method'),
                        name: options.name,
                        params: checkKeyValuePairObject(options.params || {}, STRING_ARRAY_SET, 'Invalid param, must be of type string or array'),
                        responseType: options.responseType,
                        serializer: serializer,
                        connectTimeout: options.connectTimeout,
                        readTimeout: options.readTimeout,
                        timeout: options.timeout
                    };
                }
                var ionicIdCounter = 0;
                function registerIonic(_ref) {
                    var _cordova, _cordova$plugin, _window$ionic;
                    var addRequest = _ref.addRequest, addResponse = _ref.addResponse, isIgnored = _ref.isIgnored;
                    var ionicHttp = (_cordova = window.cordova) === null || _cordova === void 0 ? void 0 : (_cordova$plugin = _cordova.plugin) === null || _cordova$plugin === void 0 ? void 0 : _cordova$plugin.http;
                    var ionicMap = {};
                    var unsubscribedFromIonic = false;
                    if (typeof ionicHttp === 'undefined') // Plugin does not exist! Empty uninstall hook.
                    return function() {};
                    var platforms = (_window$ionic = window.ionic) === null || _window$ionic === void 0 ? void 0 : _window$ionic.platforms;
                    if (typeof platforms !== 'undefined' && typeof platforms.some === 'function' && platforms.some(function(e) {
                        return UNSUPPORTED_PLATFORMS.has(e);
                    })) // We appear to be running in a web browser, do not hook and let XHR wrap instead.
                    return function() {};
                    var originalSendRequest = ionicHttp.sendRequest;
                    var handleResponse = (0, _protectFunc.default)(function(response, isSuccess, ionicReqId) {
                        if (!isIgnored("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId))) try {
                            var responseHash = {
                                url: response.url || '',
                                status: response.status < 600 && response.status >= 100 ? response.status : 0,
                                headers: response.headers || {},
                                body: isSuccess ? response.data : response.error,
                                method: ionicMap[ionicReqId].toUpperCase()
                            };
                            addResponse("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId), responseHash);
                        } catch (err) {
                            var _responseHash = {
                                url: response.url || '',
                                status: response.status < 600 && response.status >= 100 ? response.status : 0,
                                headers: response.headers || {},
                                body: "LogRocket fetch error: ".concat(err.message),
                                method: ionicMap[ionicReqId].toUpperCase()
                            };
                            addResponse("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId), _responseHash);
                        }
                         // Otherwise, don't even try to read ignored / unsubscribed requests
                    });
                    ionicHttp.sendRequest = function(url, options, success, failure) {
                        var currentId = ++ionicIdCounter;
                        var ourSuccessHandler = function ourSuccessHandler(response) {
                            if (!unsubscribedFromIonic) {
                                handleResponse(response, true, currentId);
                                delete ionicMap[currentId];
                            }
                            success(response);
                        };
                        var ourFailureHandler = function ourFailureHandler(response) {
                            if (!unsubscribedFromIonic) {
                                handleResponse(response, false, currentId);
                                delete ionicMap[currentId];
                            }
                            failure(response);
                        };
                        if (!unsubscribedFromIonic) try {
                            // will throw just like identical ionic code if input is invalid
                            var modifiedOptions = handleMissingOptions(options, ionicHttp);
                            var modifiedUrl = appendQueryParamsString(url, serializeObject('', modifiedOptions.params, true));
                            // need to minic behavior of Ionic API by adding global headers
                            var mergedHeaders = getMergedHeaders(url, modifiedOptions.headers, ionicHttp);
                            // ionic APIs default to get method
                            var method = modifiedOptions.method || 'get';
                            ionicMap[currentId] = method;
                            var requestHash = {
                                url: modifiedUrl,
                                method: method.toUpperCase(),
                                headers: mergedHeaders || {},
                                // only applicable on post, put or patch methods
                                body: processData(modifiedOptions.data || {}, modifiedOptions.serializer)
                            };
                            addRequest("".concat(LOGROCKET_IONIC_LABEL).concat(currentId), requestHash);
                        } catch (err) {
                            var _requestHash = {
                                url: url,
                                method: (options.method || 'get').toUpperCase(),
                                headers: {},
                                body: "LogRocket fetch error: ".concat(err.message)
                            };
                            addRequest("".concat(LOGROCKET_IONIC_LABEL).concat(currentId), _requestHash);
                        }
                        return originalSendRequest(url, options, ourSuccessHandler, ourFailureHandler);
                    };
                    return function() {
                        unsubscribedFromIonic = true;
                        ionicHttp.sendRequest = originalSendRequest;
                        ionicMap = {};
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/registerNetworkInformation.js": /*!***********************************************************************!*\
  !*** ./packages/@logrocket/network/src/registerNetworkInformation.js ***!
  \***********************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerNetworkInformation;
                var EFFECTIVE_TYPE_VALS = {
                    'slow-2g': 'SLOW2G',
                    '2g': 'TWOG',
                    '3g': 'THREEG',
                    '4g': 'FOURG'
                };
                function registerNetworkInformation(logger) {
                    var lastStatus = undefined;
                    function sendNetworkInformation() {
                        var newStatus = {
                            online: window.navigator.onLine,
                            effectiveType: 'UNKOWN'
                        };
                        if (!window.navigator.onLine) newStatus.effectiveType = 'NONE';
                        else if (window.navigator.connection && window.navigator.connection.effectiveType) newStatus.effectiveType = EFFECTIVE_TYPE_VALS[window.navigator.connection.effectiveType] || 'UNKNOWN';
                        if (lastStatus && newStatus.online === lastStatus.online && newStatus.effectiveType === lastStatus.effectiveType) return;
                        lastStatus = newStatus;
                        logger.addEvent('lr.network.NetworkStatusEvent', function() {
                            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;
                            if (!isEnabled) return null;
                            return newStatus;
                        });
                    }
                    setTimeout(sendNetworkInformation);
                    if (window.navigator.connection && typeof window.navigator.connection.addEventListener === 'function') window.navigator.connection.addEventListener('change', sendNetworkInformation);
                    window.addEventListener('online', sendNetworkInformation);
                    window.addEventListener('offline', sendNetworkInformation);
                    return function() {
                        window.removeEventListener('offline', sendNetworkInformation);
                        window.removeEventListener('online', sendNetworkInformation);
                        if (window.navigator.connection && typeof window.navigator.connection.removeEventListener === 'function') window.navigator.connection.removeEventListener('change', sendNetworkInformation);
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/registerXHR.js": /*!********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerXHR.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setActive = setActive;
                exports["default"] = registerXHR;
                var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.js"));
                var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/enhanceFunc */ "./packages/@logrocket/utils/src/enhanceFunc.ts"));
                var _startsWith = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/startsWith */ "./packages/@logrocket/utils/src/startsWith.js"));
                var _nps = __webpack_require__(/*! @logrocket/utils/src/constants/nps */ "./packages/@logrocket/utils/src/constants/nps.js");
                // eslint-disable-line no-restricted-imports
                // eslint-disable-line no-restricted-imports
                // eslint-disable-line no-restricted-imports
                var isActive = true;
                function setActive(shouldBeActive) {
                    isActive = shouldBeActive;
                }
                var currentXHRId = 0;
                function registerXHR(_ref) {
                    var addRequest = _ref.addRequest, addResponse = _ref.addResponse, isIgnored = _ref.isIgnored, logger = _ref.logger, _ref$shouldAugmentNPS = _ref.shouldAugmentNPS, shouldAugmentNPS = _ref$shouldAugmentNPS === void 0 ? true : _ref$shouldAugmentNPS, _ref$shouldParseXHRBl = _ref.shouldParseXHRBlob, shouldParseXHRBlob = _ref$shouldParseXHRBl === void 0 ? false : _ref$shouldParseXHRBl;
                    var _XHR = XMLHttpRequest;
                    var xhrMap = new WeakMap();
                    var unsubscribedFromXhr = false;
                    var LOGROCKET_XHR_LABEL = 'xhr-';
                    window._lrXMLHttpRequest = XMLHttpRequest;
                    // eslint-disable-next-line no-native-reassign
                    XMLHttpRequest = function XMLHttpRequest1(mozAnon, mozSystem) {
                        var xhrObject = new _XHR(mozAnon, mozSystem);
                        if (!isActive) return xhrObject;
                        xhrMap.set(xhrObject, {
                            xhrId: ++currentXHRId,
                            headers: {}
                        });
                        var openOriginal = xhrObject.open;
                        function openShim() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            try {
                                var url = args[1];
                                if (window.URL && typeof window.URL === 'function' && url.search(_nps.WOOTRIC_RESPONSES_REGEX) === 0) {
                                    var logrocketSessionURL = new window.URL(logger.recordingURL);
                                    logrocketSessionURL.searchParams.set('nps', 'wootric');
                                    var urlObj = new window.URL(url);
                                    var responseText = urlObj.searchParams.get('response[text]');
                                    var feedback = responseText ? "".concat(responseText, "\n\n") : '';
                                    urlObj.searchParams.set('response[text]', "".concat(feedback, "<").concat(logrocketSessionURL.href, "|View LogRocket session>"));
                                    args[1] = urlObj.href; // eslint-disable-line no-param-reassign
                                }
                            } catch (e) {}
                            return openOriginal.apply(this, args);
                        }
                        var sendOriginal = xhrObject.send;
                        function sendShim() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            try {
                                var currentXHR = xhrMap.get(xhrObject);
                                if (window.URL && typeof window.URL === 'function' && currentXHR && currentXHR.url && currentXHR.url.search(_nps.DELIGHTED_RESPONSES_REGEX) === 0 && args.length && args[0].indexOf(_nps.DELIGHTED_FEEDBACK_PREFIX) !== -1) {
                                    var recordingURL = new window.URL(logger.recordingURL);
                                    recordingURL.searchParams.set('nps', 'delighted');
                                    var logrocketSessionURL = encodeURIComponent(recordingURL.href);
                                    var data = args[0].split('&').map(function(dataString) {
                                        if ((0, _startsWith.default)(dataString, _nps.DELIGHTED_FEEDBACK_PREFIX)) {
                                            var isEmpty = dataString === _nps.DELIGHTED_FEEDBACK_PREFIX;
                                            return "".concat(dataString).concat(isEmpty ? '' : '\n\n', "<").concat(logrocketSessionURL, "|View LogRocket session>");
                                        }
                                        return dataString;
                                    }).join('&');
                                    args[0] = data; // eslint-disable-line no-param-reassign
                                }
                            } catch (e) {}
                            return sendOriginal.apply(this, args);
                        }
                        if (shouldAugmentNPS) {
                            xhrObject.open = openShim;
                            xhrObject.send = sendShim;
                        }
                        // ..., 'open', (method, url, async, username, password) => {
                        (0, _enhanceFunc.default)(xhrObject, 'open', function(method, url) {
                            if (unsubscribedFromXhr) return;
                            var currentXHR = xhrMap.get(xhrObject);
                            currentXHR.method = method;
                            currentXHR.url = url;
                        });
                        (0, _enhanceFunc.default)(xhrObject, 'send', function(data) {
                            if (unsubscribedFromXhr) return;
                            var currentXHR = xhrMap.get(xhrObject);
                            if (!currentXHR) return;
                            var request = {
                                url: currentXHR.url,
                                method: currentXHR.method && currentXHR.method.toUpperCase(),
                                headers: (0, _mapValues.default)(currentXHR.headers || {}, function(headerValues) {
                                    return headerValues.join(', ');
                                }),
                                body: data
                            };
                            addRequest("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), request);
                        });
                        (0, _enhanceFunc.default)(xhrObject, 'setRequestHeader', function(header, value) {
                            if (unsubscribedFromXhr) return;
                            var currentXHR = xhrMap.get(xhrObject);
                            if (!currentXHR) return;
                            currentXHR.headers = currentXHR.headers || {};
                            currentXHR.headers[header] = currentXHR.headers[header] || [];
                            currentXHR.headers[header].push(value);
                        });
                        var xhrListeners = {
                            readystatechange: function readystatechange() {
                                if (unsubscribedFromXhr) return;
                                if (xhrObject.readyState === 4) {
                                    var currentXHR = xhrMap.get(xhrObject);
                                    if (!currentXHR) return;
                                    // Do not read ignored requests at all.
                                    if (isIgnored("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId))) return;
                                    var headerString = xhrObject.getAllResponseHeaders() || '';
                                    var headers = headerString.split(/[\r\n]+/).reduce(function(previous, current) {
                                        var next = previous;
                                        var headerParts = current.split(': ');
                                        if (headerParts.length > 0) {
                                            var key = headerParts.shift(); // first index of the array
                                            var value = headerParts.join(': '); // rest of the array repaired
                                            if (previous[key]) next[key] += ", ".concat(value);
                                            else next[key] = value;
                                        }
                                        return next;
                                    }, {});
                                    var body;
                                    // IE 11 sometimes throws when trying to access large responses
                                    try {
                                        switch(xhrObject.responseType){
                                            case 'json':
                                                body = logger._shouldCloneResponse ? JSON.parse(JSON.stringify(xhrObject.response)) : xhrObject.response;
                                                break;
                                            case 'arraybuffer':
                                            case 'blob':
                                                body = xhrObject.response;
                                                break;
                                            case 'document':
                                                body = xhrObject.responseXML;
                                                break;
                                            case 'text':
                                            case '':
                                                body = xhrObject.responseText;
                                                break;
                                            default:
                                                body = '';
                                        }
                                    } catch (err) {
                                        body = 'LogRocket: Error accessing response.';
                                    }
                                    var response = {
                                        url: currentXHR.url,
                                        status: xhrObject.status,
                                        headers: headers,
                                        body: body,
                                        method: (currentXHR.method || '').toUpperCase()
                                    };
                                    if (shouldParseXHRBlob && response.body instanceof Blob) {
                                        var blobReader = new FileReader();
                                        blobReader.readAsText(response.body);
                                        blobReader.onload = function() {
                                            try {
                                                response.body = JSON.parse(blobReader.result);
                                            } catch (_unused) {} // eslint-disable-line no-empty
                                            addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
                                        };
                                    } else addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
                                }
                            }
                        };
                        Object.keys(xhrListeners).forEach(function(key) {
                            xhrObject.addEventListener(key, xhrListeners[key]);
                        });
                        return xhrObject;
                    };
                    // this allows "instanceof XMLHttpRequest" to work
                    XMLHttpRequest.prototype = _XHR.prototype;
                    // Persist the static variables.
                    [
                        'UNSENT',
                        'OPENED',
                        'HEADERS_RECEIVED',
                        'LOADING',
                        'DONE'
                    ].forEach(function(variable) {
                        XMLHttpRequest[variable] = _XHR[variable];
                    });
                    return function() {
                        unsubscribedFromXhr = true;
                        // eslint-disable-next-line no-native-reassign
                        XMLHttpRequest = _XHR;
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/now/src/index.js": /*!**********************************************!*\
  !*** ./packages/@logrocket/now/src/index.js ***!
  \**********************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                /* eslint-disable compat/compat */ var dateNow = Date.now.bind(Date);
                var loadTime = dateNow();
                var _default = typeof performance !== 'undefined' && performance.now ? performance.now.bind(performance) : function() {
                    return dateNow() - loadTime;
                };
                exports["default"] = _default;
            /***/ },
            /***/ "./packages/@logrocket/redux/src/createEnhancer.js": /*!*********************************************************!*\
  !*** ./packages/@logrocket/redux/src/createEnhancer.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = createEnhancer;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _now = _interopRequireDefault(__webpack_require__(/*! @logrocket/now */ "./packages/@logrocket/now/src/index.js"));
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            (0, _defineProperty2.default)(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                var storeIdCounter = 0;
                function createEnhancer(logger) {
                    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$stateSanitizer = _ref.stateSanitizer, stateSanitizer = _ref$stateSanitizer === void 0 ? function(f) {
                        return f;
                    } : _ref$stateSanitizer, _ref$actionSanitizer = _ref.actionSanitizer, actionSanitizer = _ref$actionSanitizer === void 0 ? function(f) {
                        return f;
                    } : _ref$actionSanitizer;
                    // an enhancer is a function that returns a Store
                    return function(createStore) {
                        return function(reducer, initialState, enhancer) {
                            var store = createStore(reducer, initialState, enhancer);
                            var originalDispatch = store.dispatch;
                            var storeId = storeIdCounter++;
                            logger.addEvent('lr.redux.InitialState', function() {
                                var sanitizedState;
                                try {
                                    // only try catch user defined functions
                                    sanitizedState = stateSanitizer(store.getState());
                                } catch (err) {
                                    console.error(err.toString());
                                }
                                return {
                                    state: sanitizedState,
                                    storeId: storeId
                                };
                            });
                            var dispatch = function dispatch(action) {
                                var start = (0, _now.default)();
                                var err;
                                var res;
                                try {
                                    res = originalDispatch(action);
                                } catch (_err) {
                                    err = _err;
                                } finally{
                                    var duration = (0, _now.default)() - start;
                                    logger.addEvent('lr.redux.ReduxAction', function() {
                                        var sanitizedState = null;
                                        var sanitizedAction = null;
                                        try {
                                            // only try catch user defined functions
                                            sanitizedState = stateSanitizer(store.getState());
                                            sanitizedAction = actionSanitizer(action);
                                        } catch (err) {
                                            console.error(err.toString());
                                        }
                                        if (sanitizedState && sanitizedAction) return {
                                            storeId: storeId,
                                            action: sanitizedAction,
                                            duration: duration,
                                            stateDelta: sanitizedState
                                        };
                                        return null;
                                    });
                                }
                                if (err) throw err;
                                return res;
                            };
                            return _objectSpread(_objectSpread({}, store), {}, {
                                dispatch: dispatch
                            });
                        };
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/redux/src/createMiddleware.js": /*!***********************************************************!*\
  !*** ./packages/@logrocket/redux/src/createMiddleware.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = createMiddleware;
                var _now = _interopRequireDefault(__webpack_require__(/*! @logrocket/now */ "./packages/@logrocket/now/src/index.js"));
                var storeIdCounter = 0;
                function createMiddleware(logger) {
                    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$stateSanitizer = _ref.stateSanitizer, stateSanitizer = _ref$stateSanitizer === void 0 ? function(f) {
                        return f;
                    } : _ref$stateSanitizer, _ref$actionSanitizer = _ref.actionSanitizer, actionSanitizer = _ref$actionSanitizer === void 0 ? function(f) {
                        return f;
                    } : _ref$actionSanitizer;
                    return function(store) {
                        var storeId = storeIdCounter++;
                        logger.addEvent('lr.redux.InitialState', function() {
                            var sanitizedState;
                            try {
                                // only try catch user defined functions
                                sanitizedState = stateSanitizer(store.getState());
                            } catch (err) {
                                console.error(err.toString());
                            }
                            return {
                                state: sanitizedState,
                                storeId: storeId
                            };
                        });
                        return function(next) {
                            return function(action) {
                                var start = (0, _now.default)();
                                var err;
                                var res;
                                try {
                                    res = next(action);
                                } catch (_err) {
                                    err = _err;
                                } finally{
                                    var duration = (0, _now.default)() - start;
                                    logger.addEvent('lr.redux.ReduxAction', function() {
                                        var sanitizedState = null;
                                        var sanitizedAction = null;
                                        try {
                                            // only try catch user defined functions
                                            sanitizedState = stateSanitizer(store.getState());
                                            sanitizedAction = actionSanitizer(action);
                                        } catch (err) {
                                            console.error(err.toString());
                                        }
                                        if (sanitizedState && sanitizedAction) return {
                                            storeId: storeId,
                                            action: sanitizedAction,
                                            duration: duration,
                                            stateDelta: sanitizedState
                                        };
                                        return null;
                                    });
                                }
                                if (err) throw err;
                                return res;
                            };
                        };
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/redux/src/index.js": /*!************************************************!*\
  !*** ./packages/@logrocket/redux/src/index.js ***!
  \************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                Object.defineProperty(exports, "createEnhancer", {
                    enumerable: true,
                    get: function get() {
                        return _createEnhancer.default;
                    }
                });
                Object.defineProperty(exports, "createMiddleware", {
                    enumerable: true,
                    get: function get() {
                        return _createMiddleware.default;
                    }
                });
                var _createEnhancer = _interopRequireDefault(__webpack_require__(/*! ./createEnhancer */ "./packages/@logrocket/redux/src/createEnhancer.js"));
                var _createMiddleware = _interopRequireDefault(__webpack_require__(/*! ./createMiddleware */ "./packages/@logrocket/redux/src/createMiddleware.js"));
            /***/ },
            /***/ "./packages/@logrocket/utils/src/TraceKit.js": /*!***************************************************!*\
  !*** ./packages/@logrocket/utils/src/TraceKit.js ***!
  \***************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /* eslint-disable */ /*
 TraceKit - Cross browser stack traces - github.com/occ/TraceKit

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var TraceKit = {
                    collectWindowErrors: true,
                    debug: false
                };
                // This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
                var _window = typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};
                // global reference to slice
                var _slice = [].slice;
                var UNKNOWN_FUNCTION = '?';
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
                var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
                function getLocationHref() {
                    if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';
                    return document.location.href;
                }
                /**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */ TraceKit.report = function reportModuleWrapper() {
                    var handlers = [], lastArgs = null, lastException = null, lastExceptionStack = null;
                    /**
   * Add a crash handler.
   * @param {Function} handler
   */ function subscribe(handler) {
                        installGlobalHandler();
                        handlers.push(handler);
                    }
                    /**
   * Remove a crash handler.
   * @param {Function} handler
   */ function unsubscribe(handler) {
                        for(var i = handlers.length - 1; i >= 0; --i)if (handlers[i] === handler) handlers.splice(i, 1);
                    }
                    /**
   * Remove all crash handlers.
   */ function unsubscribeAll() {
                        uninstallGlobalHandler();
                        handlers = [];
                    }
                    /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */ function notifyHandlers(stack, isWindowError) {
                        var exception = null;
                        if (isWindowError && !TraceKit.collectWindowErrors) return;
                        for(var i in handlers){
                            if (handlers.hasOwnProperty(i)) try {
                                handlers[i].apply(null, [
                                    stack
                                ].concat(_slice.call(arguments, 2)));
                            } catch (inner) {
                                exception = inner;
                            }
                        }
                        if (exception) throw exception;
                    }
                    var _oldOnerrorHandler, _onErrorHandlerInstalled;
                    /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} message Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */ function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
                        var stack = null;
                        if (lastExceptionStack) {
                            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
                            processLastException();
                        } else if (ex) {
                            // New chrome and blink send along a real error object
                            // Let's just report that like a normal error.
                            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
                            stack = TraceKit.computeStackTrace(ex);
                            notifyHandlers(stack, true);
                        } else {
                            var location1 = {
                                'url': url,
                                'line': lineNo,
                                'column': colNo
                            };
                            var name = undefined;
                            var msg = message; // must be new var or will modify original `arguments`
                            var groups;
                            if (({}).toString.call(message) === '[object String]') {
                                var groups = message.match(ERROR_TYPES_RE);
                                if (groups) {
                                    name = groups[1];
                                    msg = groups[2];
                                }
                            }
                            location1.func = UNKNOWN_FUNCTION;
                            stack = {
                                'name': name,
                                'message': msg,
                                'url': getLocationHref(),
                                'stack': [
                                    location1
                                ]
                            };
                            notifyHandlers(stack, true);
                        }
                        if (_oldOnerrorHandler) return _oldOnerrorHandler.apply(this, arguments);
                        return false;
                    }
                    function installGlobalHandler() {
                        if (_onErrorHandlerInstalled) return;
                        _oldOnerrorHandler = _window.onerror;
                        _window.onerror = traceKitWindowOnError;
                        _onErrorHandlerInstalled = true;
                    }
                    function uninstallGlobalHandler() {
                        if (!_onErrorHandlerInstalled) return;
                        _window.onerror = _oldOnerrorHandler;
                        _onErrorHandlerInstalled = false;
                        _oldOnerrorHandler = undefined;
                    }
                    function processLastException() {
                        var _lastExceptionStack = lastExceptionStack, _lastArgs = lastArgs;
                        lastArgs = null;
                        lastExceptionStack = null;
                        lastException = null;
                        notifyHandlers.apply(null, [
                            _lastExceptionStack,
                            false
                        ].concat(_lastArgs));
                    }
                    /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */ function report(ex, rethrow) {
                        var args = _slice.call(arguments, 1);
                        if (lastExceptionStack) {
                            if (lastException === ex) return; // already caught by an inner catch block, ignore
                            else processLastException();
                        }
                        var stack = TraceKit.computeStackTrace(ex);
                        lastExceptionStack = stack;
                        lastException = ex;
                        lastArgs = args;
                        // If the stack trace is incomplete, wait for 2 seconds for
                        // slow slow IE to see if onerror occurs or not before reporting
                        // this exception; otherwise, we will end up with an incomplete
                        // stack trace
                        setTimeout(function() {
                            if (lastException === ex) processLastException();
                        }, stack.incomplete ? 2000 : 0);
                        if (rethrow !== false) throw ex; // re-throw to propagate to the top level (and cause window.onerror)
                    }
                    report.subscribe = subscribe;
                    report.unsubscribe = unsubscribe;
                    report.uninstall = unsubscribeAll;
                    return report;
                }();
                /**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */ TraceKit.computeStackTrace = function computeStackTraceWrapper() {
                    /**
   * Escapes special characters, except for whitespace, in a string to be
   * used inside a regular expression as a string literal.
   * @param {string} text The string.
   * @return {string} The escaped string literal.
   */ function escapeRegExp(text) {
                        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
                    }
                    /**
   * Escapes special characters in a string to be used inside a regular
   * expression as a string literal. Also ensures that HTML entities will
   * be matched the same as their literal friends.
   * @param {string} body The string.
   * @return {string} The escaped string.
   */ function escapeCodeAsRegExpForMatchingInsideHTML(body) {
                        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
                    }
                    // Contents of Exception in various browsers.
                    //
                    // SAFARI:
                    // ex.message = Can't find variable: qq
                    // ex.line = 59
                    // ex.sourceId = 580238192
                    // ex.sourceURL = http://...
                    // ex.expressionBeginOffset = 96
                    // ex.expressionCaretOffset = 98
                    // ex.expressionEndOffset = 98
                    // ex.name = ReferenceError
                    //
                    // FIREFOX:
                    // ex.message = qq is not defined
                    // ex.fileName = http://...
                    // ex.lineNumber = 59
                    // ex.columnNumber = 69
                    // ex.stack = ...stack trace... (see the example below)
                    // ex.name = ReferenceError
                    //
                    // CHROME:
                    // ex.message = qq is not defined
                    // ex.name = ReferenceError
                    // ex.type = not_defined
                    // ex.arguments = ['aa']
                    // ex.stack = ...stack trace...
                    //
                    // INTERNET EXPLORER:
                    // ex.message = ...
                    // ex.name = ReferenceError
                    //
                    // OPERA:
                    // ex.message = ...message... (see the example below)
                    // ex.name = ReferenceError
                    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
                    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
                    /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */ function computeStackTraceFromStackProp(ex) {
                        if (typeof ex.stack === 'undefined' || !ex.stack) return;
                        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i, winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, lines = ex.stack.split('\n'), stack = [], parts, element, reference = /^(.*) is undefined$/.exec(ex.message);
                        for(var i = 0, j = lines.length; i < j; ++i){
                            if (parts = chrome.exec(lines[i])) {
                                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
                                element = {
                                    'url': !isNative ? parts[2] : null,
                                    'func': parts[1] || UNKNOWN_FUNCTION,
                                    'args': isNative ? [
                                        parts[2]
                                    ] : [],
                                    'line': parts[3] ? +parts[3] : null,
                                    'column': parts[4] ? +parts[4] : null
                                };
                            } else if (parts = winjs.exec(lines[i])) element = {
                                'url': parts[2],
                                'func': parts[1] || UNKNOWN_FUNCTION,
                                'args': [],
                                'line': +parts[3],
                                'column': parts[4] ? +parts[4] : null
                            };
                            else if (parts = gecko.exec(lines[i])) element = {
                                'url': parts[3],
                                'func': parts[1] || UNKNOWN_FUNCTION,
                                'args': parts[2] ? parts[2].split(',') : [],
                                'line': parts[4] ? +parts[4] : null,
                                'column': parts[5] ? +parts[5] : null
                            };
                            else continue;
                            if (!element.func && element.line) element.func = UNKNOWN_FUNCTION;
                            stack.push(element);
                        }
                        if (!stack.length) return null;
                        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') // FireFox uses this awesome columnNumber property for its top frame
                        // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                        // so adding 1
                        stack[0].column = ex.columnNumber + 1;
                        return {
                            'name': ex.name,
                            'message': ex.message,
                            'url': getLocationHref(),
                            'stack': stack
                        };
                    }
                    /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */ function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
                        var initial = {
                            'url': url,
                            'line': lineNo
                        };
                        if (initial.url && initial.line) {
                            stackInfo.incomplete = false;
                            if (!initial.func) initial.func = UNKNOWN_FUNCTION;
                            if (stackInfo.stack.length > 0) {
                                if (stackInfo.stack[0].url === initial.url) {
                                    if (stackInfo.stack[0].line === initial.line) return false; // already in stack trace
                                    else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                                        stackInfo.stack[0].line = initial.line;
                                        return false;
                                    }
                                }
                            }
                            stackInfo.stack.unshift(initial);
                            stackInfo.partial = true;
                            return true;
                        } else stackInfo.incomplete = true;
                        return false;
                    }
                    /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */ function computeStackTraceByWalkingCallerChain(ex, depth) {
                        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, stack = [], funcs = {}, recursion = false, parts, item, source;
                        for(var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller){
                            if (curr === computeStackTrace || curr === TraceKit.report) continue;
                            item = {
                                'url': null,
                                'func': UNKNOWN_FUNCTION,
                                'line': null,
                                'column': null
                            };
                            if (curr.name) item.func = curr.name;
                            else if (parts = functionName.exec(curr.toString())) item.func = parts[1];
                            if (typeof item.func === 'undefined') try {
                                item.func = parts.input.substring(0, parts.input.indexOf('{'));
                            } catch (e) {}
                            if (funcs['' + curr]) recursion = true;
                            else funcs['' + curr] = true;
                            stack.push(item);
                        }
                        if (depth) // console.log('depth is ' + depth);
                        // console.log('stack is ' + stack.length);
                        stack.splice(0, depth);
                        var result = {
                            'name': ex.name,
                            'message': ex.message,
                            'url': getLocationHref(),
                            'stack': stack
                        };
                        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
                        return result;
                    }
                    /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */ function computeStackTrace(ex, depth) {
                        var stack = null;
                        depth = depth == null ? 0 : +depth;
                        try {
                            stack = computeStackTraceFromStackProp(ex);
                            if (stack) return stack;
                        } catch (e) {
                            if (TraceKit.debug) throw e;
                        }
                        try {
                            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
                            if (stack) return stack;
                        } catch (e) {
                            if (TraceKit.debug) throw e;
                        }
                        return {
                            'name': ex.name,
                            'message': ex.message,
                            'url': getLocationHref()
                        };
                    }
                    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
                    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
                    return computeStackTrace;
                }();
                var _default = TraceKit;
                exports["default"] = _default;
            /***/ },
            /***/ "./packages/@logrocket/utils/src/constants/nps.js": /*!********************************************************!*\
  !*** ./packages/@logrocket/utils/src/constants/nps.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DELIGHTED_FEEDBACK_PREFIX = exports.DELIGHTED_RESPONSES_REGEX = exports.WOOTRIC_RESPONSES_REGEX = void 0;
                var WOOTRIC_RESPONSES_REGEX = /^https:\/\/production.wootric.com\/responses/;
                exports.WOOTRIC_RESPONSES_REGEX = WOOTRIC_RESPONSES_REGEX;
                var DELIGHTED_RESPONSES_REGEX = /^https:\/\/web.delighted.com\/e\/[a-zA-Z-]*\/c/;
                exports.DELIGHTED_RESPONSES_REGEX = DELIGHTED_RESPONSES_REGEX;
                var DELIGHTED_FEEDBACK_PREFIX = 'comment=';
                exports.DELIGHTED_FEEDBACK_PREFIX = DELIGHTED_FEEDBACK_PREFIX;
            /***/ },
            /***/ "./packages/@logrocket/utils/src/createUnsubListener.ts": /*!**************************************************************!*\
  !*** ./packages/@logrocket/utils/src/createUnsubListener.ts ***!
  \**************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createUnsubListener = createUnsubListener;
                exports.Handler = void 0;
                var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
                var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
                var Handler = /*#__PURE__*/ function() {
                    function Handler(value) {
                        (0, _classCallCheck2.default)(this, Handler);
                        this._value = void 0;
                        this._value = value;
                    }
                    (0, _createClass2.default)(Handler, [
                        {
                            key: "get",
                            value: function get() {
                                return this._value;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this._value = undefined;
                            }
                        }
                    ]);
                    return Handler;
                }();
                /*
 * This approach ensures the unsub function never keeps a reference to the event listener's target element.
 * This is not a concern in Chrome or Firefox, but Safari will hold the entire context of a function's parent function
 * in scope of that child function. This means that creating the unsub function inside 'addListener' could cause the
 * target element (the 'obj' argument) to be held in scope of the unsub function even though it is never referenced
 * in the unsub function itself. This would lead to a memory leak after the target element is removed from the DOM.
 *
 * This function is in a separate file to prevent the Terser minifier from inline-ing the function into 'addListener'.
 */ exports.Handler = Handler;
                function createUnsubListener(handler) {
                    return function() {
                        handler.clear();
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/enhanceFunc.ts": /*!******************************************************!*\
  !*** ./packages/@logrocket/utils/src/enhanceFunc.ts ***!
  \******************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = enhanceFunc;
                var _createUnsubListener = __webpack_require__(/*! ./createUnsubListener */ "./packages/@logrocket/utils/src/createUnsubListener.ts");
                var NO_OP_UNREGISTER = function NO_OP_UNREGISTER() {};
                function enhanceFunc(obj, method, handler) {
                    if (typeof obj[method] !== 'function') return NO_OP_UNREGISTER;
                    try {
                        // eslint-disable-next-line no-inner-declarations
                        var shim = function shim() {
                            var _h$get;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            var res = original.apply(this, args);
                            (_h$get = h.get()) === null || _h$get === void 0 || _h$get.apply(this, args);
                            return res;
                        }; // eslint-disable-next-line no-param-reassign
                        var original = obj[method];
                        var h = new _createUnsubListener.Handler(handler);
                        obj[method] = shim;
                        return function() {
                            // Disable our shim from running, and if the method hasn't been re-shimmed
                            // since our shim was applied, safely reset the method to its prior state
                            h.clear();
                            if (obj[method] === shim) // eslint-disable-next-line no-param-reassign
                            obj[method] = original;
                        };
                    } catch (_error) {
                        return NO_OP_UNREGISTER;
                    }
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/logError.js": /*!***************************************************!*\
  !*** ./packages/@logrocket/utils/src/logError.js ***!
  \***************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var canBind = typeof console !== 'undefined' && console.error && console.error.bind;
                var logError = canBind ? console.error.bind(console) : function() {};
                var _default = logError;
                exports["default"] = _default;
            /***/ },
            /***/ "./packages/@logrocket/utils/src/mapValues.js": /*!****************************************************!*\
  !*** ./packages/@logrocket/utils/src/mapValues.js ***!
  \****************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = mapValues;
                function mapValues(obj, f) {
                    if (obj == null) return {};
                    var res = {};
                    Object.keys(obj).forEach(function(key) {
                        res[key] = f(obj[key]);
                    });
                    return res;
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/protectFunc.js": /*!******************************************************!*\
  !*** ./packages/@logrocket/utils/src/protectFunc.js ***!
  \******************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = protectFunc;
                var _sendTelemetryData = _interopRequireDefault(__webpack_require__(/*! ./sendTelemetryData */ "./packages/@logrocket/utils/src/sendTelemetryData.js"));
                var _logError = _interopRequireDefault(__webpack_require__(/*! ./logError */ "./packages/@logrocket/utils/src/logError.js"));
                function protectFunc(f) {
                    var onFail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {};
                    return function() {
                        var result;
                        try {
                            result = f.apply(void 0, arguments);
                        } catch (err) {
                            if (typeof window !== 'undefined' && window._lrdebug) throw err;
                            var payload = onFail(err);
                            (0, _logError.default)('LogRocket', err);
                            (0, _sendTelemetryData.default)(err, payload);
                        }
                        return result;
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/scrubException.ts": /*!*********************************************************!*\
  !*** ./packages/@logrocket/utils/src/scrubException.ts ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.scrubException = scrubException;
                var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));
                function _createForOfIteratorHelper(o, allowArrayLike) {
                    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                    if (!it) {
                        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                            if (it) o = it;
                            var i = 0;
                            var F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    if (i >= o.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o[i++]
                                    };
                                },
                                e: function e(_e) {
                                    throw _e;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion = true, didErr = false, err;
                    return {
                        s: function s() {
                            it = it.call(o);
                        },
                        n: function n() {
                            var step = it.next();
                            normalCompletion = step.done;
                            return step;
                        },
                        e: function e(_e2) {
                            didErr = true;
                            err = _e2;
                        },
                        f: function f() {
                            try {
                                if (!normalCompletion && it.return != null) it.return();
                            } finally{
                                if (didErr) throw err;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function isScalar(value) {
                    return /boolean|number|string/.test((0, _typeof2.default)(value));
                }
                var optionalScalars = [
                    // Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
                    // and 'debug'. Defaults to 'error'.
                    'level',
                    'logger'
                ];
                var optionalMaps = [
                    'tags',
                    'extra'
                ];
                function scrubException(data, options) {
                    if (options) {
                        var _iterator = _createForOfIteratorHelper(optionalScalars), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var field = _step.value;
                                var value = options[field];
                                if (isScalar(value)) // eslint-disable-next-line no-param-reassign
                                data[field] = value.toString();
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        var _iterator2 = _createForOfIteratorHelper(optionalMaps), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var _field = _step2.value;
                                var dirty = options[_field] || {};
                                var scrubbed = {};
                                for(var _i = 0, _Object$keys = Object.keys(dirty); _i < _Object$keys.length; _i++){
                                    var key = _Object$keys[_i];
                                    var _value = dirty[key];
                                    if (isScalar(_value)) scrubbed[key.toString()] = _value.toString();
                                }
                                // eslint-disable-next-line no-param-reassign
                                data[_field] = scrubbed;
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                    }
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/sendTelemetryData.js": /*!************************************************************!*\
  !*** ./packages/@logrocket/utils/src/sendTelemetryData.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.sendTelemetry = sendTelemetry;
                exports["default"] = sendErrorTelemetry;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _logError = _interopRequireDefault(__webpack_require__(/*! ./logError */ "./packages/@logrocket/utils/src/logError.js"));
                var _TraceKit = _interopRequireDefault(__webpack_require__(/*! ./TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            (0, _defineProperty2.default)(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                // eslint-disable-next-line no-undef
                var SCRIPT_VERSION = "13dd130ab9a04ef867cdb9bbbdb0a16c225358f2";
                function _sendToSentry(data) {
                    var XHR = window._lrXMLHttpRequest || XMLHttpRequest;
                    try {
                        var _window, _window$__SDKCONFIG__;
                        var req = new XHR();
                        var message = data.message;
                        var url = 'https://e.logrocket.com/api/3/store/?sentry_version=7&sentry_client=http%2F3.8.0&sentry_key=b64162b4187a4c5caae8a68a7e291793';
                        req.open('POST', url);
                        req.send(JSON.stringify(_objectSpread({
                            message: message,
                            logger: 'javascript',
                            platform: 'javascript',
                            request: {
                                headers: {
                                    'User-Agent': typeof navigator !== 'undefined' && navigator.userAgent
                                },
                                url: typeof location !== 'undefined' && location.href
                            },
                            release: SCRIPT_VERSION,
                            environment: ((_window = window) === null || _window === void 0 ? void 0 : (_window$__SDKCONFIG__ = _window.__SDKCONFIG__) === null || _window$__SDKCONFIG__ === void 0 ? void 0 : _window$__SDKCONFIG__.scriptEnv) || 'prod'
                        }, data)));
                    } catch (err) {
                        (0, _logError.default)('Failed to send', err);
                    }
                }
                function sendTelemetry(message, more) {
                    if (typeof window !== 'undefined' && window._lrdebug) return void (0, _logError.default)(message);
                    if (more && more.extra && more.extra.appID && typeof more.extra.appID.indexOf === 'function' && more.extra.appID.indexOf('au2drp/') === 0 && Math.random() >= 0.25) return;
                    _sendToSentry(_objectSpread({
                        message: message
                    }, more));
                }
                function sendErrorTelemetry(err, payload) {
                    try {
                        var message = err.message;
                        var stringPayload;
                        try {
                            stringPayload = JSON.stringify(payload).slice(0, 1000);
                        } catch (err) {
                            try {
                                stringPayload = "Could not stringify payload: ".concat(Object.prototype.toString.call(payload));
                            } catch (err) {}
                        }
                        var stack;
                        try {
                            stack = _TraceKit.default.computeStackTrace(err).stack.map(function(frame) {
                                return {
                                    filename: frame.url,
                                    lineno: frame.line,
                                    colno: frame.column,
                                    function: frame.func || '?'
                                };
                            });
                        } catch (err) {
                        /* nada */ }
                        _sendToSentry({
                            message: message,
                            extra: {
                                stringPayload: stringPayload
                            },
                            exception: {
                                values: [
                                    {
                                        type: err.type,
                                        value: message,
                                        stacktrace: {
                                            frames: stack
                                        }
                                    }
                                ]
                            }
                        });
                    } catch (err) {
                        (0, _logError.default)('Failed to send', err);
                    }
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/startsWith.js": /*!*****************************************************!*\
  !*** ./packages/@logrocket/utils/src/startsWith.js ***!
  \*****************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = startsWith;
                function startsWith(value, search) {
                    var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    return value && search && value.substring(pos, pos + search.length) === search;
                }
            /***/ },
            /***/ "./packages/logrocket/src/LogRocket.js": /*!*********************************************!*\
  !*** ./packages/logrocket/src/LogRocket.js ***!
  \*********************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = exports.MAX_QUEUE_SIZE = void 0;
                var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));
                var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
                var _network = _interopRequireDefault(__webpack_require__(/*! @logrocket/network */ "./packages/@logrocket/network/src/index.js"));
                var _exceptions = __webpack_require__(/*! @logrocket/exceptions */ "./packages/@logrocket/exceptions/src/index.js");
                var _console = _interopRequireDefault(__webpack_require__(/*! @logrocket/console */ "./packages/@logrocket/console/src/index.js"));
                var _redux = __webpack_require__(/*! @logrocket/redux */ "./packages/@logrocket/redux/src/index.js");
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            (0, _defineProperty2.default)(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                var MAX_QUEUE_SIZE = 1000;
                exports.MAX_QUEUE_SIZE = MAX_QUEUE_SIZE;
                var considerIngestServerOption = function considerIngestServerOption() {
                    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, ingestServer = _ref.ingestServer, options = (0, _objectWithoutProperties2.default)(_ref, [
                        "ingestServer"
                    ]);
                    if (ingestServer) return _objectSpread({
                        serverURL: "".concat(ingestServer, "/i"),
                        statsURL: "".concat(ingestServer, "/s")
                    }, options);
                    return options;
                };
                var LogRocket = /*#__PURE__*/ function() {
                    function LogRocket() {
                        var _this = this;
                        (0, _classCallCheck2.default)(this, LogRocket);
                        this._buffer = [];
                        // TODO: tests for these exposed methods.
                        [
                            'log',
                            'info',
                            'warn',
                            'error',
                            'debug'
                        ].forEach(function(method) {
                            _this[method] = function() {
                                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                _this.addEvent('lr.core.LogEvent', function() {
                                    var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                    if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) _exceptions.Capture.captureMessage(_this, args[0], args, {}, true);
                                    return {
                                        logLevel: method.toUpperCase(),
                                        args: args
                                    };
                                }, {
                                    shouldCaptureStackTrace: true
                                });
                            };
                        });
                        this._isInitialized = false;
                        this._installed = [];
                        // expose a callback to get the session URL from the global context
                        window._lr_surl_cb = this.getSessionURL.bind(this);
                    }
                    (0, _createClass2.default)(LogRocket, [
                        {
                            key: "addEvent",
                            value: function addEvent(type, getMessage) {
                                var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                                var time = Date.now();
                                this._run(function(logger) {
                                    logger.addEvent(type, getMessage, _objectSpread(_objectSpread({}, opts), {}, {
                                        timeOverride: time
                                    }));
                                });
                            }
                        },
                        {
                            key: "onLogger",
                            value: function onLogger(logger) {
                                this._logger = logger;
                                while(this._buffer.length > 0){
                                    var f = this._buffer.shift();
                                    f(this._logger);
                                }
                            }
                        },
                        {
                            key: "_run",
                            value: function _run(f) {
                                if (this._isDisabled) return;
                                if (this._logger) f(this._logger);
                                else {
                                    if (this._buffer.length >= MAX_QUEUE_SIZE) {
                                        this._isDisabled = true;
                                        console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
                                        this.uninstall();
                                        return;
                                    }
                                    this._buffer.push(f.bind(this));
                                }
                            }
                        },
                        {
                            key: "init",
                            value: function init(appID) {
                                var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                                if (!this._isInitialized) {
                                    var _opts$network;
                                    var _opts$shouldAugmentNP = opts.shouldAugmentNPS, shouldAugmentNPS = _opts$shouldAugmentNP === void 0 ? true : _opts$shouldAugmentNP, _opts$shouldParseXHRB = opts.shouldParseXHRBlob, shouldParseXHRBlob = _opts$shouldParseXHRB === void 0 ? false : _opts$shouldParseXHRB, _opts$shouldDetectExc = opts.shouldDetectExceptions, shouldDetectExceptions = _opts$shouldDetectExc === void 0 ? true : _opts$shouldDetectExc;
                                    if (shouldDetectExceptions) this._installed.push((0, _exceptions.registerExceptions)(this));
                                    this._installed.push((0, _network.default)(this, {
                                        shouldAugmentNPS: !!shouldAugmentNPS,
                                        shouldParseXHRBlob: !!shouldParseXHRBlob,
                                        isDisabled: (opts === null || opts === void 0 ? void 0 : (_opts$network = opts.network) === null || _opts$network === void 0 ? void 0 : _opts$network.isEnabled) === false
                                    }));
                                    this._installed.push((0, _console.default)(this));
                                    this._isInitialized = true;
                                    this._run(function(logger) {
                                        logger.init(appID, considerIngestServerOption(opts));
                                    });
                                }
                            }
                        },
                        {
                            key: "start",
                            value: function start() {
                                this._run(function(logger) {
                                    logger.start();
                                });
                            }
                        },
                        {
                            key: "uninstall",
                            value: function uninstall() {
                                this._installed.forEach(function(f) {
                                    return f();
                                });
                                this._buffer = [];
                                this._run(function(logger) {
                                    logger.uninstall();
                                });
                            }
                        },
                        {
                            key: "identify",
                            value: function identify(id, opts) {
                                this._run(function(logger) {
                                    logger.identify(id, opts);
                                });
                            }
                        },
                        {
                            key: "startNewSession",
                            value: function startNewSession() {
                                this._run(function(logger) {
                                    logger.startNewSession();
                                });
                            }
                        },
                        {
                            key: "track",
                            value: function track(customEventName, eventProperties) {
                                this._run(function(logger) {
                                    logger.track(customEventName, eventProperties);
                                });
                            }
                        },
                        {
                            key: "getSessionURL",
                            value: function getSessionURL(cb) {
                                if (typeof cb !== 'function') throw new Error('LogRocket: must pass callback to getSessionURL()');
                                this._run(function(logger) {
                                    if (logger.getSessionURL) logger.getSessionURL(cb);
                                    else cb(logger.recordingURL);
                                });
                            }
                        },
                        {
                            key: "trackScrollEvent",
                            value: function trackScrollEvent(target) {
                                // Only reigster the event if the core logger is available,
                                //  otherwise we won't yet have captured the target element:
                                if (this._logger) this._logger.trackScrollEvent(target);
                            }
                        },
                        {
                            key: "getVersion",
                            value: function getVersion(cb) {
                                this._run(function(logger) {
                                    cb(logger.version);
                                });
                            }
                        },
                        {
                            key: "captureMessage",
                            value: function captureMessage(message) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                                _exceptions.Capture.captureMessage(this, message, [
                                    message
                                ], options);
                            }
                        },
                        {
                            key: "captureException",
                            value: function captureException(exception) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                                _exceptions.Capture.captureException(this, exception, options);
                            }
                        },
                        {
                            key: "version",
                            get: function get() {
                                return this._logger && this._logger.version;
                            }
                        },
                        {
                            key: "sessionURL",
                            get: function get() {
                                return this._logger && this._logger.recordingURL;
                            }
                        },
                        {
                            key: "recordingURL",
                            get: function get() {
                                return this._logger && this._logger.recordingURL;
                            }
                        },
                        {
                            key: "recordingID",
                            get: function get() {
                                return this._logger && this._logger.recordingID;
                            }
                        },
                        {
                            key: "threadID",
                            get: function get() {
                                return this._logger && this._logger.threadID;
                            }
                        },
                        {
                            key: "tabID",
                            get: function get() {
                                return this._logger && this._logger.tabID;
                            }
                        },
                        {
                            key: "reduxEnhancer",
                            value: function reduxEnhancer() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                return (0, _redux.createEnhancer)(this, options);
                            }
                        },
                        {
                            key: "reduxMiddleware",
                            value: function reduxMiddleware() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                return (0, _redux.createMiddleware)(this, options);
                            }
                        },
                        {
                            key: "isDisabled",
                            get: function get() {
                                return !!(this._isDisabled || this._logger && this._logger._isDisabled);
                            }
                        }
                    ]);
                    return LogRocket;
                }();
                exports["default"] = LogRocket;
            /***/ },
            /***/ "./packages/logrocket/src/makeLogRocket.js": /*!*************************************************!*\
  !*** ./packages/logrocket/src/makeLogRocket.js ***!
  \*************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = makeLogRocket;
                var _LogRocket = _interopRequireDefault(__webpack_require__(/*! ./LogRocket */ "./packages/logrocket/src/LogRocket.js"));
                var REACT_NATIVE_NOTICE = 'LogRocket on React Native requires the LogRocket React Native specific SDK. See setup guide here https://docs.logrocket.com/reference/react-native.';
                var makeNoopPolyfill = function makeNoopPolyfill() {
                    return {
                        init: function init() {},
                        uninstall: function uninstall() {},
                        log: function log() {},
                        info: function info() {},
                        warn: function warn() {},
                        error: function error() {},
                        debug: function debug() {},
                        addEvent: function addEvent() {},
                        identify: function identify() {},
                        start: function start() {},
                        get threadID () {
                            return null;
                        },
                        get recordingID () {
                            return null;
                        },
                        get recordingURL () {
                            return null;
                        },
                        reduxEnhancer: function reduxEnhancer() {
                            return function(store) {
                                return function() {
                                    return store.apply(void 0, arguments);
                                };
                            };
                        },
                        reduxMiddleware: function reduxMiddleware() {
                            return function() {
                                return function(next) {
                                    return function(action) {
                                        return next(action);
                                    };
                                };
                            };
                        },
                        track: function track() {},
                        getSessionURL: function getSessionURL() {},
                        getVersion: function getVersion() {},
                        startNewSession: function startNewSession() {},
                        onLogger: function onLogger() {},
                        setClock: function setClock() {},
                        captureMessage: function captureMessage() {},
                        captureException: function captureException() {}
                    };
                };
                function makeLogRocket() {
                    var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function() {};
                    var getNoopPolyfill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : makeNoopPolyfill;
                    var getInstance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {
                        return new _LogRocket.default();
                    };
                    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') throw new Error(REACT_NATIVE_NOTICE);
                    if (typeof window !== 'undefined') {
                        if (window._disableLogRocket) return getNoopPolyfill();
                        if (window.MutationObserver && window.WeakMap) {
                            // Save window globals that we rely on.
                            window._lrMutationObserver = window.MutationObserver;
                            var instance = getInstance();
                            getLogger(instance);
                            return instance;
                        }
                    }
                    return makeNoopPolyfill();
                }
            /***/ },
            /***/ "./packages/logrocket/src/setup.js": /*!*****************************************!*\
  !*** ./packages/logrocket/src/setup.js ***!
  \*****************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getDomainsAndEnv = getDomainsAndEnv;
                exports.setupBaseSDKCONFIG = setupBaseSDKCONFIG;
                exports["default"] = setup;
                var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
                var _makeLogRocket = _interopRequireDefault(__webpack_require__(/*! ./makeLogRocket */ "./packages/logrocket/src/makeLogRocket.js"));
                var CDN_SERVER_MAP = {
                    'cdn.logrocket.com': 'https://r.logrocket.io',
                    'cdn.logrocket.io': 'https://r.logrocket.io',
                    'cdn.lr-ingest.io': 'https://r.lr-ingest.io',
                    'cdn.lr-in.com': 'https://r.lr-in.com',
                    'cdn.lr-in-prod.com': 'https://r.lr-in-prod.com',
                    'cdn.lr-ingest.com': 'https://r.lr-ingest.com',
                    'cdn.ingest-lr.com': 'https://r.ingest-lr.com',
                    'cdn.lr-intake.com': 'https://r.lr-intake.com',
                    'cdn.intake-lr.com': 'https://r.intake-lr.com',
                    'cdn.logr-ingest.com': 'https://r.logr-ingest.com',
                    'cdn.lrkt-in.com': 'https://r.lrkt-in.com',
                    'cdn-staging.logrocket.io': 'https://staging-i.logrocket.io',
                    'cdn-staging.lr-ingest.io': 'https://staging-i.lr-ingest.io',
                    'cdn-staging.lr-in.com': 'https://staging-i.lr-in.com',
                    'cdn-staging.lr-in-prod.com': 'https://staging-i.lr-in-prod.com',
                    'cdn-staging.lr-ingest.com': 'https://staging-i.lr-ingest.com',
                    'cdn-staging.ingest-lr.com': 'https://staging-i.ingest-lr.com',
                    'cdn-staging.lr-intake.com': 'https://staging-i.lr-intake.com',
                    'cdn-staging.intake-lr.com': 'https://staging-i.intake-lr.com',
                    'cdn-staging.logr-ingest.com': 'https://staging-i.logr-ingest.com',
                    'cdn-staging.lrkt-in.com': 'https://staging-i.lrkt-in.com'
                };
                function envFromHostname(hostname) {
                    if (hostname.startsWith('cdn-staging')) return 'staging';
                    else if (hostname.startsWith('localhost')) return 'development';
                    else return 'prod';
                }
                function getDomainsAndEnv(sdkVersion) {
                    if (sdkVersion === 'script' || sdkVersion === 'shopify-pixel') {
                        // We cannot rely on the DEPLOY_ENV config for script tag usage: we deploy the script built for staging to prod to
                        // improve deployment times, so the DEPLOY_ENV is always 'staging' for script usage! Instead we default to 'prod'
                        // and inspect the script's URL to determine if the environment should instead be staging or development.
                        try {
                            // eslint-disable-next-line compat/compat
                            var scriptTag = document.currentScript;
                            var matches = scriptTag.src.match(/^(https?:\/\/([^\\]+))\/.+$/);
                            var scriptHostname = matches && matches[2];
                            if (scriptHostname && CDN_SERVER_MAP[scriptHostname]) return {
                                scriptEnv: envFromHostname(scriptHostname),
                                scriptOrigin: matches && matches[1],
                                scriptIngest: CDN_SERVER_MAP[scriptHostname]
                            };
                        } catch (_) {
                        /* no-op */ }
                        // If we cannot determine the env based on the script's URL we default to prod.
                        return {
                            scriptEnv: 'prod',
                            scriptOrigin: 'https://cdn.logrocket.io'
                        };
                    } else // NPM package
                    return {
                        scriptEnv: undefined,
                        scriptOrigin: 'https://cdn.lrkt-in.com',
                        scriptIngest: 'https://r.lrkt-in.com'
                    };
                }
                function setupBaseSDKCONFIG(ingestServer) {
                    if (typeof window.__SDKCONFIG__ === 'undefined') window.__SDKCONFIG__ = {};
                    window.__SDKCONFIG__.serverURL = "".concat(ingestServer, "/i");
                    window.__SDKCONFIG__.statsURL = "".concat(ingestServer, "/s");
                }
                function setup() {
                    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, enterpriseServer = _ref.enterpriseServer, _ref$sdkVersion = _ref.sdkVersion, sdkVersion = _ref$sdkVersion === void 0 ? "9.0.2" : _ref$sdkVersion, opts = (0, _objectWithoutProperties2.default)(_ref, [
                        "enterpriseServer",
                        "sdkVersion"
                    ]);
                    var _getDomainsAndEnv = getDomainsAndEnv(sdkVersion), scriptEnv = _getDomainsAndEnv.scriptEnv, scriptOrigin = _getDomainsAndEnv.scriptOrigin, scriptIngest = _getDomainsAndEnv.scriptIngest;
                    var sdkServer = opts.sdkServer || enterpriseServer;
                    var ingestServer = opts.ingestServer || enterpriseServer || scriptIngest;
                    var instance = (0, _makeLogRocket.default)(function() {
                        var script = document.createElement('script');
                        if (ingestServer) {
                            setupBaseSDKCONFIG(ingestServer);
                            window.__SDKCONFIG__.scriptEnv = scriptEnv;
                        }
                        if (sdkServer) script.src = "".concat(sdkServer, "/logger.min.js");
                        else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) script.src = window.__SDKCONFIG__.loggerURL;
                        else if (window._lrAsyncScript) script.src = window._lrAsyncScript;
                        else script.src = "".concat(scriptOrigin, "/logger-1.min.js");
                        script.async = true;
                        document.head.appendChild(script);
                        script.onload = function() {
                            // Brave browser: Advertises its user-agent as Chrome ##.##... then
                            // loads logger.min.js, but blocks the execution of the script
                            // causing _LRlogger to be undefined.  Let's make sure its there first.
                            if (typeof window._LRLogger === 'function') setTimeout(function() {
                                instance.onLogger(new window._LRLogger({
                                    sdkVersion: sdkVersion
                                }));
                            });
                            else {
                                console.warn('LogRocket: script execution has been blocked by a product or service.');
                                instance.uninstall();
                            }
                        };
                        script.onerror = function() {
                            console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
                            instance.uninstall();
                        };
                    });
                    return instance;
                }
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js": /*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/ /***/ function(module1) {
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                module1.exports = _arrayLikeToArray, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js": /*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
                function _arrayWithoutHoles(arr) {
                    if (Array.isArray(arr)) return arrayLikeToArray(arr);
                }
                module1.exports = _arrayWithoutHoles, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js": /*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/ /***/ function(module1) {
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                module1.exports = _classCallCheck, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/createClass.js": /*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                module1.exports = _createClass, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/defineProperty.js": /*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");
                function _defineProperty(obj, key, value) {
                    key = toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                module1.exports = _defineProperty, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js": /*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/interopRequireDefault.js ***!
  \**********************************************************************/ /***/ function(module1) {
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                module1.exports = _interopRequireDefault, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/iterableToArray.js": /*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
  \****************************************************************/ /***/ function(module1) {
                function _iterableToArray(iter) {
                    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
                }
                module1.exports = _iterableToArray, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js": /*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
  \******************************************************************/ /***/ function(module1) {
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                module1.exports = _nonIterableSpread, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js": /*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
  \************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var objectWithoutPropertiesLoose = __webpack_require__(/*! ./objectWithoutPropertiesLoose.js */ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");
                function _objectWithoutProperties(source, excluded) {
                    if (source == null) return {};
                    var target = objectWithoutPropertiesLoose(source, excluded);
                    var key, i;
                    if (Object.getOwnPropertySymbols) {
                        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                        for(i = 0; i < sourceSymbolKeys.length; i++){
                            key = sourceSymbolKeys[i];
                            if (excluded.indexOf(key) >= 0) continue;
                            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                            target[key] = source[key];
                        }
                    }
                    return target;
                }
                module1.exports = _objectWithoutProperties, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js": /*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
  \*****************************************************************************/ /***/ function(module1) {
                function _objectWithoutPropertiesLoose(source, excluded) {
                    if (source == null) return {};
                    var target = {};
                    var sourceKeys = Object.keys(source);
                    var key, i;
                    for(i = 0; i < sourceKeys.length; i++){
                        key = sourceKeys[i];
                        if (excluded.indexOf(key) >= 0) continue;
                        target[key] = source[key];
                    }
                    return target;
                }
                module1.exports = _objectWithoutPropertiesLoose, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/toConsumableArray.js": /*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
  \******************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arrayWithoutHoles = __webpack_require__(/*! ./arrayWithoutHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");
                var iterableToArray = __webpack_require__(/*! ./iterableToArray.js */ "./node_modules/@babel/runtime/helpers/iterableToArray.js");
                var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");
                var nonIterableSpread = __webpack_require__(/*! ./nonIterableSpread.js */ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");
                function _toConsumableArray(arr) {
                    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
                }
                module1.exports = _toConsumableArray, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/toPrimitive.js": /*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPrimitive.js ***!
  \************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                module1.exports = _toPrimitive, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/toPropertyKey.js": /*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPropertyKey.js ***!
  \**************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];
                var toPrimitive = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/@babel/runtime/helpers/toPrimitive.js");
                function _toPropertyKey(arg) {
                    var key = toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                module1.exports = _toPropertyKey, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/typeof.js": /*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/ /***/ function(module1) {
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return module1.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, module1.exports.__esModule = true, module1.exports["default"] = module1.exports, _typeof(obj);
                }
                module1.exports = _typeof, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js": /*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
                }
                module1.exports = _unsupportedIterableToArray, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/global */ /******/ !function() {
            /******/ __webpack_require__.g = function() {
                /******/ if (typeof globalThis === 'object') return globalThis;
                /******/ try {
                    /******/ return this || new Function('return this')();
                /******/ } catch (e) {
                    /******/ if (typeof window === 'object') return window;
                /******/ }
            /******/ }();
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be in strict mode.
        !function() {
            "use strict";
            var exports = __webpack_exports__;
            /*!**********************************************!*\
  !*** ./packages/logrocket/src/module-npm.js ***!
  \**********************************************/ var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports["default"] = void 0;
            var _setup = _interopRequireDefault(__webpack_require__(/*! ./setup */ "./packages/logrocket/src/setup.js"));
            var instance = (0, _setup.default)();
            var _default = instance;
            exports["default"] = _default;
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});


// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file

var $6ZWSX = parcelRequire("6ZWSX");
var $6fb9842575b03497$require$Buffer = $6ZWSX.Buffer;
var $6fb9842575b03497$var$win;
if (typeof window === 'undefined') {
    var $6fb9842575b03497$var$loc = {
        hostname: ''
    };
    $6fb9842575b03497$var$win = {
        crypto: {
            randomUUID: function() {
                throw Error('unsupported');
            }
        },
        navigator: {
            userAgent: '',
            onLine: true
        },
        document: {
            createElement: function() {
                return {};
            },
            location: $6fb9842575b03497$var$loc,
            referrer: ''
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $6fb9842575b03497$var$loc,
        addEventListener: function() {},
        removeEventListener: function() {}
    };
} else $6fb9842575b03497$var$win = window;
function $6fb9842575b03497$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6fb9842575b03497$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $6fb9842575b03497$var$_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $6fb9842575b03497$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $6fb9842575b03497$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $6fb9842575b03497$var$_construct(Parent, args, Class) {
    if ($6fb9842575b03497$var$_is_native_reflect_construct()) $6fb9842575b03497$var$_construct = Reflect.construct;
    else $6fb9842575b03497$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $6fb9842575b03497$var$_set_prototype_of(instance, Class.prototype);
        return instance;
    };
    return $6fb9842575b03497$var$_construct.apply(null, arguments);
}
function $6fb9842575b03497$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6fb9842575b03497$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $6fb9842575b03497$var$_defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function $6fb9842575b03497$var$_extends() {
    $6fb9842575b03497$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6fb9842575b03497$var$_extends.apply(this, arguments);
}
function $6fb9842575b03497$var$_get_prototype_of(o) {
    $6fb9842575b03497$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6fb9842575b03497$var$_get_prototype_of(o);
}
function $6fb9842575b03497$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6fb9842575b03497$var$_set_prototype_of(subClass, superClass);
}
function $6fb9842575b03497$var$_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}
function $6fb9842575b03497$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $6fb9842575b03497$var$_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6fb9842575b03497$var$_set_prototype_of(o, p) {
    $6fb9842575b03497$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6fb9842575b03497$var$_set_prototype_of(o, p);
}
function $6fb9842575b03497$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function $6fb9842575b03497$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6fb9842575b03497$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6fb9842575b03497$var$_array_like_to_array(o, minLen);
}
function $6fb9842575b03497$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $6fb9842575b03497$var$_wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !$6fb9842575b03497$var$_is_native_function(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $6fb9842575b03497$var$_construct(Class, arguments, $6fb9842575b03497$var$_get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $6fb9842575b03497$var$_set_prototype_of(Wrapper, Class);
    };
    return $6fb9842575b03497$var$_wrap_native_super(Class);
}
function $6fb9842575b03497$var$_is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($6fb9842575b03497$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6fb9842575b03497$var$_unsupported_iterable_to_array(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6fb9842575b03497$var$_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $6fb9842575b03497$var$_ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var $6fb9842575b03497$var$__defProp = Object.defineProperty;
var $6fb9842575b03497$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $6fb9842575b03497$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $6fb9842575b03497$var$__publicField = function(obj, key, value) {
    return $6fb9842575b03497$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $6fb9842575b03497$var$_a;
var $6fb9842575b03497$var$__defProp$1 = Object.defineProperty;
var $6fb9842575b03497$var$__defNormalProp$1 = function(obj, key, value) {
    return key in obj ? $6fb9842575b03497$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $6fb9842575b03497$var$__publicField$1 = function(obj, key, value) {
    return $6fb9842575b03497$var$__defNormalProp$1(obj, (typeof key === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $6fb9842575b03497$var$NodeType$3 = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($6fb9842575b03497$var$NodeType$3 || {});
var $6fb9842575b03497$var$testableAccessors$1 = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $6fb9842575b03497$var$testableMethods$1 = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $6fb9842575b03497$var$untaintedBasePrototype$1 = {};
var $6fb9842575b03497$var$isAngularZonePresent$1 = function() {
    return !!globalThis.Zone;
};
function $6fb9842575b03497$var$getUntaintedPrototype$1(key) {
    if ($6fb9842575b03497$var$untaintedBasePrototype$1[key]) return $6fb9842575b03497$var$untaintedBasePrototype$1[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $6fb9842575b03497$var$testableAccessors$1 ? $6fb9842575b03497$var$testableAccessors$1[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $6fb9842575b03497$var$testableMethods$1 ? $6fb9842575b03497$var$testableMethods$1[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$6fb9842575b03497$var$isAngularZonePresent$1()) {
        $6fb9842575b03497$var$untaintedBasePrototype$1[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $6fb9842575b03497$var$untaintedBasePrototype$1[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $6fb9842575b03497$var$untaintedAccessorCache$1 = {};
function $6fb9842575b03497$var$getUntaintedAccessor$1(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($6fb9842575b03497$var$untaintedAccessorCache$1[cacheKey]) return $6fb9842575b03497$var$untaintedAccessorCache$1[cacheKey].call(instance);
    var untaintedPrototype = $6fb9842575b03497$var$getUntaintedPrototype$1(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $6fb9842575b03497$var$untaintedAccessorCache$1[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $6fb9842575b03497$var$untaintedMethodCache$1 = {};
function $6fb9842575b03497$var$getUntaintedMethod$1(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($6fb9842575b03497$var$untaintedMethodCache$1[cacheKey]) return $6fb9842575b03497$var$untaintedMethodCache$1[cacheKey].bind(instance);
    var untaintedPrototype = $6fb9842575b03497$var$getUntaintedPrototype$1(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $6fb9842575b03497$var$untaintedMethodCache$1[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $6fb9842575b03497$var$childNodes$1(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Node", n2, "childNodes");
}
function $6fb9842575b03497$var$parentNode$1(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Node", n2, "parentNode");
}
function $6fb9842575b03497$var$parentElement$1(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Node", n2, "parentElement");
}
function $6fb9842575b03497$var$textContent$1(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Node", n2, "textContent");
}
function $6fb9842575b03497$var$contains$1(n2, other) {
    return $6fb9842575b03497$var$getUntaintedMethod$1("Node", n2, "contains")(other);
}
function $6fb9842575b03497$var$getRootNode$1(n2) {
    return $6fb9842575b03497$var$getUntaintedMethod$1("Node", n2, "getRootNode")();
}
function $6fb9842575b03497$var$host$1(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $6fb9842575b03497$var$getUntaintedAccessor$1("ShadowRoot", n2, "host");
}
function $6fb9842575b03497$var$styleSheets$1(n2) {
    return n2.styleSheets;
}
function $6fb9842575b03497$var$shadowRoot$1(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Element", n2, "shadowRoot");
}
function $6fb9842575b03497$var$querySelector$1(n2, selectors) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Element", n2, "querySelector")(selectors);
}
function $6fb9842575b03497$var$querySelectorAll$1(n2, selectors) {
    return $6fb9842575b03497$var$getUntaintedAccessor$1("Element", n2, "querySelectorAll")(selectors);
}
function $6fb9842575b03497$var$mutationObserverCtor$1() {
    return $6fb9842575b03497$var$getUntaintedPrototype$1("MutationObserver").constructor;
}
var $6fb9842575b03497$var$index$1 = {
    childNodes: $6fb9842575b03497$var$childNodes$1,
    parentNode: $6fb9842575b03497$var$parentNode$1,
    parentElement: $6fb9842575b03497$var$parentElement$1,
    textContent: $6fb9842575b03497$var$textContent$1,
    contains: $6fb9842575b03497$var$contains$1,
    getRootNode: $6fb9842575b03497$var$getRootNode$1,
    host: $6fb9842575b03497$var$host$1,
    styleSheets: $6fb9842575b03497$var$styleSheets$1,
    shadowRoot: $6fb9842575b03497$var$shadowRoot$1,
    querySelector: $6fb9842575b03497$var$querySelector$1,
    querySelectorAll: $6fb9842575b03497$var$querySelectorAll$1,
    mutationObserver: $6fb9842575b03497$var$mutationObserverCtor$1
};
function $6fb9842575b03497$var$isElement(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $6fb9842575b03497$var$isShadowRoot(n2) {
    var hostEl = // but only shadow roots have a `mode` property
    n2 && "host" in n2 && "mode" in n2 && $6fb9842575b03497$var$index$1.host(n2) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && $6fb9842575b03497$var$index$1.shadowRoot(hostEl) === n2);
}
function $6fb9842575b03497$var$isNativeShadowDom(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function $6fb9842575b03497$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $6fb9842575b03497$var$escapeImportStatement(rule2) {
    var cssText = rule2.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        "@import",
        "url(" + JSON.stringify(rule2.href) + ")"
    ];
    if (rule2.layerName === "") statement.push("layer");
    else if (rule2.layerName) statement.push("layer(" + rule2.layerName + ")");
    if (rule2.supportsText) statement.push("supports(" + rule2.supportsText + ")");
    if (rule2.media.length) statement.push(rule2.media.mediaText);
    return statement.join(" ") + ";";
}
function $6fb9842575b03497$var$stringifyStylesheet(s2) {
    try {
        var rules2 = s2.rules || s2.cssRules;
        if (!rules2) return null;
        var sheetHref = s2.href;
        if (!sheetHref && s2.ownerNode && s2.ownerNode.ownerDocument) sheetHref = s2.ownerNode.ownerDocument.location.href;
        var stringifiedRules = Array.from(rules2, function(rule2) {
            return $6fb9842575b03497$var$stringifyRule(rule2, sheetHref);
        }).join("");
        return $6fb9842575b03497$var$fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function $6fb9842575b03497$var$stringifyRule(rule2, sheetHref) {
    if ($6fb9842575b03497$var$isCSSImportRule(rule2)) {
        var importStringified;
        try {
            importStringified = $6fb9842575b03497$var$stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            $6fb9842575b03497$var$escapeImportStatement(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) return $6fb9842575b03497$var$absolutifyURLs(importStringified, rule2.styleSheet.href);
        return importStringified;
    } else {
        var ruleStringified = rule2.cssText;
        if ($6fb9842575b03497$var$isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) ruleStringified = $6fb9842575b03497$var$fixSafariColons(ruleStringified);
        if (sheetHref) return $6fb9842575b03497$var$absolutifyURLs(ruleStringified, sheetHref);
        return ruleStringified;
    }
}
function $6fb9842575b03497$var$fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $6fb9842575b03497$var$isCSSImportRule(rule2) {
    return "styleSheet" in rule2;
}
function $6fb9842575b03497$var$isCSSStyleRule(rule2) {
    return "selectorText" in rule2;
}
var $6fb9842575b03497$var$Mirror = /*#__PURE__*/ function() {
    function Mirror() {
        $6fb9842575b03497$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $6fb9842575b03497$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    var _proto = Mirror.prototype;
    _proto.getId = function getId(n2) {
        var _a2;
        if (!n2) return -1;
        var id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id != null ? id : -1;
    };
    _proto.getNode = function getNode(id) {
        return this.idNodeMap.get(id) || null;
    };
    _proto.getIds = function getIds() {
        return Array.from(this.idNodeMap.keys());
    };
    _proto.getMeta = function getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    };
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    _proto.removeNodeFromMap = function removeNodeFromMap(n2) {
        var _this = this;
        var id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach(function(childNode) {
            return _this.removeNodeFromMap(childNode);
        });
    };
    _proto.has = function has(id) {
        return this.idNodeMap.has(id);
    };
    _proto.hasNode = function hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    };
    _proto.add = function add(n2, meta) {
        var id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    };
    _proto.replace = function replace(id, n2) {
        var oldNode = this.getNode(id);
        if (oldNode) {
            var meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    };
    _proto.reset = function reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    };
    return Mirror;
}();
function $6fb9842575b03497$var$createMirror$2() {
    return new $6fb9842575b03497$var$Mirror();
}
function $6fb9842575b03497$var$maskInputValue(param) {
    var element = param.element, maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || "";
    var actualType = type && $6fb9842575b03497$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = "*".repeat(text.length);
    }
    return text;
}
function $6fb9842575b03497$var$toLowerCase(str) {
    return str.toLowerCase();
}
var $6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $6fb9842575b03497$var$is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext("2d");
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x2 = 0; x2 < canvas.width; x2 += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = $6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$6fb9842575b03497$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function $6fb9842575b03497$var$getInputType(element) {
    var type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $6fb9842575b03497$var$toLowerCase(type) : null;
}
function $6fb9842575b03497$var$extractFileExtension(path, baseURL) {
    var url;
    try {
        url = new URL(path, baseURL != null ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    var regex = /\.([0-9a-z]+)(?:$)/i;
    var match = url.pathname.match(regex);
    var _ref;
    return (_ref = match == null ? void 0 : match[1]) != null ? _ref : null;
}
function $6fb9842575b03497$var$extractOrigin(url) {
    var origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
var $6fb9842575b03497$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var $6fb9842575b03497$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var $6fb9842575b03497$var$URL_WWW_MATCH = /^www\..*/i;
var $6fb9842575b03497$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $6fb9842575b03497$var$absolutifyURLs(cssText, href) {
    return (cssText || "").replace($6fb9842575b03497$var$URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($6fb9842575b03497$var$URL_PROTOCOL_MATCH.test(filePath) || $6fb9842575b03497$var$URL_WWW_MATCH.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if ($6fb9842575b03497$var$DATA_URI.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if (filePath[0] === "/") return "url(" + maybeQuote + ($6fb9842575b03497$var$extractOrigin(href) + filePath) + maybeQuote + ")";
        var stack = href.split("/");
        var parts = filePath.split("/");
        stack.pop();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(parts), _step; !(_step = _iterator()).done;){
            var part = _step.value;
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return "url(" + maybeQuote + stack.join("/") + maybeQuote + ")";
    });
}
function $6fb9842575b03497$var$normalizeCssString(cssText) {
    return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
}
function $6fb9842575b03497$var$splitCssText(cssText, style) {
    var childNodes2 = Array.from(style.childNodes);
    var splits = [];
    if (childNodes2.length > 1 && cssText && typeof cssText === "string") {
        var cssTextNorm = $6fb9842575b03497$var$normalizeCssString(cssText);
        for(var i2 = 1; i2 < childNodes2.length; i2++)if (childNodes2[i2].textContent && typeof childNodes2[i2].textContent === "string") {
            var textContentNorm = $6fb9842575b03497$var$normalizeCssString(childNodes2[i2].textContent);
            for(var j = 3; j < textContentNorm.length; j++){
                var bit = textContentNorm.substring(0, j);
                if (cssTextNorm.split(bit).length === 2) {
                    var splitNorm = cssTextNorm.indexOf(bit);
                    for(var k = splitNorm; k < cssText.length; k++)if ($6fb9842575b03497$var$normalizeCssString(cssText.substring(0, k)).length === splitNorm) {
                        splits.push(cssText.substring(0, k));
                        cssText = cssText.substring(k);
                        break;
                    }
                    break;
                }
            }
        }
    }
    splits.push(cssText);
    return splits;
}
function $6fb9842575b03497$var$markCssSplits(cssText, style) {
    return $6fb9842575b03497$var$splitCssText(cssText, style).join("/* rr_split */");
}
var $6fb9842575b03497$var$_id = 1;
var $6fb9842575b03497$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
var $6fb9842575b03497$var$IGNORED_NODE = -2;
function $6fb9842575b03497$var$genId() {
    return $6fb9842575b03497$var$_id++;
}
function $6fb9842575b03497$var$getValidTagName$1(element) {
    if ($6fb9842575b03497$var$_instanceof(element, HTMLFormElement)) return "form";
    var processedTagName = $6fb9842575b03497$var$toLowerCase(element.tagName);
    if ($6fb9842575b03497$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
var $6fb9842575b03497$var$canvasService;
var $6fb9842575b03497$var$canvasCtx;
var $6fb9842575b03497$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var $6fb9842575b03497$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $6fb9842575b03497$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars2;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    var output = [];
    while(true){
        collectCharacters($6fb9842575b03497$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters($6fb9842575b03497$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $6fb9842575b03497$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = "";
            url = $6fb9842575b03497$var$absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
var $6fb9842575b03497$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $6fb9842575b03497$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $6fb9842575b03497$var$getHref(doc, attributeValue);
}
function $6fb9842575b03497$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $6fb9842575b03497$var$getHref(doc, customHref) {
    var a2 = $6fb9842575b03497$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $6fb9842575b03497$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $6fb9842575b03497$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $6fb9842575b03497$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $6fb9842575b03497$var$absolutifyURLs(value, $6fb9842575b03497$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $6fb9842575b03497$var$absoluteToDoc(doc, value);
    return value;
}
function $6fb9842575b03497$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $6fb9842575b03497$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $6fb9842575b03497$var$classMatchesRegex(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $6fb9842575b03497$var$classMatchesRegex($6fb9842575b03497$var$index$1.parentNode(node2), regex, checkAncestors);
    }
    for(var eIndex = node2.classList.length; eIndex--;){
        var className = node2.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $6fb9842575b03497$var$classMatchesRegex($6fb9842575b03497$var$index$1.parentNode(node2), regex, checkAncestors);
}
function $6fb9842575b03497$var$needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
    var el;
    if ($6fb9842575b03497$var$isElement(node2)) {
        el = node2;
        if (!$6fb9842575b03497$var$index$1.childNodes(el).length) return false;
    } else if ($6fb9842575b03497$var$index$1.parentElement(node2) === null) return false;
    else el = $6fb9842575b03497$var$index$1.parentElement(node2);
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest("." + maskTextClass)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($6fb9842575b03497$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e2) {}
    return false;
}
function $6fb9842575b03497$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        var timer = setTimeout(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", function() {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $6fb9842575b03497$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    var timer = setTimeout(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", function() {
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $6fb9842575b03497$var$serializeNode(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, needsMask = options.needsMask, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var rootId = $6fb9842575b03497$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $6fb9842575b03497$var$NodeType$3.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $6fb9842575b03497$var$NodeType$3.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType$3.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $6fb9842575b03497$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n2.TEXT_NODE:
            return $6fb9842575b03497$var$serializeTextNode(n2, {
                doc: doc,
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId,
                cssCaptured: cssCaptured
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType$3.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $6fb9842575b03497$var$NodeType$3.Comment,
                textContent: $6fb9842575b03497$var$index$1.textContent(n2) || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $6fb9842575b03497$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    var docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $6fb9842575b03497$var$serializeTextNode(n2, options) {
    var needsMask = options.needsMask, maskTextFn = options.maskTextFn, rootId = options.rootId, cssCaptured = options.cssCaptured;
    var parent = $6fb9842575b03497$var$index$1.parentNode(n2);
    var parentTagName = parent && parent.tagName;
    var textContent2 = "";
    var isStyle = parentTagName === "STYLE" ? true : void 0;
    var isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isScript) textContent2 = "SCRIPT_PLACEHOLDER";
    else if (!cssCaptured) {
        textContent2 = $6fb9842575b03497$var$index$1.textContent(n2);
        if (isStyle && textContent2) textContent2 = $6fb9842575b03497$var$absolutifyURLs(textContent2, $6fb9842575b03497$var$getHref(options.doc));
    }
    if (!isStyle && !isScript && textContent2 && needsMask) textContent2 = maskTextFn ? maskTextFn(textContent2, $6fb9842575b03497$var$index$1.parentElement(n2)) : textContent2.replace(/[\S]/g, "*");
    return {
        type: $6fb9842575b03497$var$NodeType$3.Text,
        textContent: textContent2 || "",
        rootId: rootId
    };
}
function $6fb9842575b03497$var$serializeElementNode(n2, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId;
    var needBlock = $6fb9842575b03497$var$_isBlockedElement(n2, blockClass, blockSelector);
    var tagName = $6fb9842575b03497$var$getValidTagName$1(n2);
    var attributes = {};
    var len = n2.attributes.length;
    for(var i2 = 0; i2 < len; i2++){
        var attr = n2.attributes[i2];
        if (!$6fb9842575b03497$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $6fb9842575b03497$var$transformAttribute(doc, tagName, $6fb9842575b03497$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === "link" && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s2) {
            return s2.href === n2.href;
        });
        var cssText = null;
        if (stylesheet) cssText = $6fb9842575b03497$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n2.sheet) {
        var cssText1 = $6fb9842575b03497$var$stringifyStylesheet(n2.sheet);
        if (cssText1) {
            if (n2.childNodes.length > 1) cssText1 = $6fb9842575b03497$var$markCssSplits(cssText1, n2);
            attributes._cssText = cssText1;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        var value = n2.value;
        var checked = n2.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) attributes.value = $6fb9842575b03497$var$maskInputValue({
            element: n2,
            type: $6fb9842575b03497$var$getInputType(n2),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "dialog" && n2.open) attributes.rr_open_mode = n2.matches("dialog:modal") ? "modal" : "non-modal";
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$6fb9842575b03497$var$is2DCanvasBlank(n2)) attributes.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            var canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$6fb9842575b03497$var$canvasService) {
            $6fb9842575b03497$var$canvasService = doc.createElement("canvas");
            $6fb9842575b03497$var$canvasCtx = $6fb9842575b03497$var$canvasService.getContext("2d");
        }
        var image = n2;
        var imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        var priorCrossOrigin = image.crossOrigin;
        var recordInlineImage = function() {
            image.removeEventListener("load", recordInlineImage);
            try {
                $6fb9842575b03497$var$canvasService.width = image.naturalWidth;
                $6fb9842575b03497$var$canvasService.height = image.naturalHeight;
                $6fb9842575b03497$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $6fb9842575b03497$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn("Cannot inline img src=" + imageSrc + "! Error: " + err);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        var mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n2.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n2.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n2.playbackRate;
        mediaAttributes.rr_mediaMuted = n2.muted;
        mediaAttributes.rr_mediaLoop = n2.loop;
        mediaAttributes.rr_mediaVolume = n2.volume;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        var _n2_getBoundingClientRect = n2.getBoundingClientRect(), width = _n2_getBoundingClientRect.width, height = _n2_getBoundingClientRect.height;
        attributes = {
            class: attributes.class,
            rr_width: "" + width + "px",
            rr_height: "" + height + "px"
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n2.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $6fb9842575b03497$var$NodeType$3.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $6fb9842575b03497$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $6fb9842575b03497$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $6fb9842575b03497$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $6fb9842575b03497$var$NodeType$3.Comment) return true;
    else if (sn.type === $6fb9842575b03497$var$NodeType$3.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $6fb9842575b03497$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "application-name" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "icon" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $6fb9842575b03497$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "robots" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "googlebot" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "author" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "generator" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "framework" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "publisher" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "progid" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $6fb9842575b03497$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "verification" || $6fb9842575b03497$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $6fb9842575b03497$var$serializeNodeWithId(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5e3 : _options_iframeLoadTimeout, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5e3 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var needsMask = options.needsMask;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    if (!needsMask) {
        var checkAncestors = needsMask === void 0;
        needsMask = $6fb9842575b03497$var$needMaskingText(n2, maskTextClass, maskTextSelector, checkAncestors);
    }
    var _serializedNode = $6fb9842575b03497$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        cssCaptured: cssCaptured
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    var id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($6fb9842575b03497$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $6fb9842575b03497$var$NodeType$3.Text && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $6fb9842575b03497$var$IGNORED_NODE;
    else id = $6fb9842575b03497$var$genId();
    var serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode);
    if (id === $6fb9842575b03497$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    var recordChild = !skipChild;
    if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        var shadowRootEl = $6fb9842575b03497$var$index$1.shadowRoot(n2);
        if (shadowRootEl && $6fb9842575b03497$var$isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $6fb9842575b03497$var$NodeType$3.Document || serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            cssCaptured: false
        };
        if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.attributes._cssText !== void 0 && typeof serializedNode.attributes._cssText === "string") bypassOptions.cssCaptured = true;
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(Array.from($6fb9842575b03497$var$index$1.childNodes(n2))), _step; !(_step = _iterator()).done;){
                var childN = _step.value;
                var serializedChildNode = $6fb9842575b03497$var$serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        }
        var shadowRootEl1 = null;
        if ($6fb9842575b03497$var$isElement(n2) && (shadowRootEl1 = $6fb9842575b03497$var$index$1.shadowRoot(n2))) for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(Array.from($6fb9842575b03497$var$index$1.childNodes(shadowRootEl1))), _step1; !(_step1 = _iterator1()).done;){
            var childN1 = _step1.value;
            var serializedChildNode1 = $6fb9842575b03497$var$serializeNodeWithId(childN1, bypassOptions);
            if (serializedChildNode1) {
                $6fb9842575b03497$var$isNativeShadowDom(shadowRootEl1) && (serializedChildNode1.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode1);
            }
        }
    }
    var parent = $6fb9842575b03497$var$index$1.parentNode(n2);
    if (parent && $6fb9842575b03497$var$isShadowRoot(parent) && $6fb9842575b03497$var$isNativeShadowDom(parent)) serializedNode.isShadow = true;
    if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.tagName === "iframe") $6fb9842575b03497$var$onceIframeLoaded(n2, function() {
        var iframeDoc = n2.contentDocument;
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = $6fb9842575b03497$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $6fb9842575b03497$var$NodeType$3.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $6fb9842575b03497$var$extractFileExtension(serializedNode.attributes.href) === "css")) $6fb9842575b03497$var$onceStylesheetLoaded(n2, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = $6fb9842575b03497$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $6fb9842575b03497$var$snapshot(n2, options) {
    var _ref = options || {}, tmp = _ref.mirror, mirror2 = tmp === void 0 ? new $6fb9842575b03497$var$Mirror() : tmp, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? "rr-block" : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? "rr-mask" : _ref_maskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $6fb9842575b03497$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $6fb9842575b03497$var$getDefaultExportFromCjs$1(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $6fb9842575b03497$var$getAugmentedNamespace$1(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($6fb9842575b03497$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $6fb9842575b03497$var$picocolors_browser$1 = {
    exports: {}
};
var $6fb9842575b03497$var$x$1 = String;
var $6fb9842575b03497$var$create$1 = function create$1() {
    return {
        isColorSupported: false,
        reset: $6fb9842575b03497$var$x$1,
        bold: $6fb9842575b03497$var$x$1,
        dim: $6fb9842575b03497$var$x$1,
        italic: $6fb9842575b03497$var$x$1,
        underline: $6fb9842575b03497$var$x$1,
        inverse: $6fb9842575b03497$var$x$1,
        hidden: $6fb9842575b03497$var$x$1,
        strikethrough: $6fb9842575b03497$var$x$1,
        black: $6fb9842575b03497$var$x$1,
        red: $6fb9842575b03497$var$x$1,
        green: $6fb9842575b03497$var$x$1,
        yellow: $6fb9842575b03497$var$x$1,
        blue: $6fb9842575b03497$var$x$1,
        magenta: $6fb9842575b03497$var$x$1,
        cyan: $6fb9842575b03497$var$x$1,
        white: $6fb9842575b03497$var$x$1,
        gray: $6fb9842575b03497$var$x$1,
        bgBlack: $6fb9842575b03497$var$x$1,
        bgRed: $6fb9842575b03497$var$x$1,
        bgGreen: $6fb9842575b03497$var$x$1,
        bgYellow: $6fb9842575b03497$var$x$1,
        bgBlue: $6fb9842575b03497$var$x$1,
        bgMagenta: $6fb9842575b03497$var$x$1,
        bgCyan: $6fb9842575b03497$var$x$1,
        bgWhite: $6fb9842575b03497$var$x$1
    };
};
$6fb9842575b03497$var$picocolors_browser$1.exports = $6fb9842575b03497$var$create$1();
$6fb9842575b03497$var$picocolors_browser$1.exports.createColors = $6fb9842575b03497$var$create$1;
var $6fb9842575b03497$var$picocolors_browserExports$1 = $6fb9842575b03497$var$picocolors_browser$1.exports;
var $6fb9842575b03497$var$__viteBrowserExternal$2 = {};
var $6fb9842575b03497$var$__viteBrowserExternal$1$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $6fb9842575b03497$var$__viteBrowserExternal$2
}, Symbol.toStringTag, {
    value: "Module"
}));
var $6fb9842575b03497$var$require$$2$1 = /* @__PURE__ */ $6fb9842575b03497$var$getAugmentedNamespace$1($6fb9842575b03497$var$__viteBrowserExternal$1$1);
var $6fb9842575b03497$var$pico$1 = $6fb9842575b03497$var$picocolors_browserExports$1;
var $6fb9842575b03497$var$terminalHighlight$1$1 = $6fb9842575b03497$var$require$$2$1;
var $6fb9842575b03497$var$CssSyntaxError$3$1 = /*#__PURE__*/ function(Error1) {
    $6fb9842575b03497$var$_inherits(CssSyntaxError, Error1);
    function CssSyntaxError(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError);
        return _this;
    }
    var _proto = CssSyntaxError.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $6fb9842575b03497$var$pico$1.isColorSupported;
        if ($6fb9842575b03497$var$terminalHighlight$1$1) {
            if (color) css = $6fb9842575b03497$var$terminalHighlight$1$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico$1_createColors = $6fb9842575b03497$var$pico$1.createColors(true), bold = _pico$1_createColors.bold, gray = _pico$1_createColors.gray, red = _pico$1_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError;
}($6fb9842575b03497$var$_wrap_native_super(Error));
var $6fb9842575b03497$var$cssSyntaxError$1 = $6fb9842575b03497$var$CssSyntaxError$3$1;
$6fb9842575b03497$var$CssSyntaxError$3$1.default = $6fb9842575b03497$var$CssSyntaxError$3$1;
var $6fb9842575b03497$var$symbols$1 = {};
$6fb9842575b03497$var$symbols$1.isClean = Symbol("isClean");
$6fb9842575b03497$var$symbols$1.my = Symbol("my");
var $6fb9842575b03497$var$DEFAULT_RAW$1 = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $6fb9842575b03497$var$capitalize$1(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $6fb9842575b03497$var$Stringifier$2$1 = /*#__PURE__*/ function() {
    function Stringifier(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $6fb9842575b03497$var$DEFAULT_RAW$1[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $6fb9842575b03497$var$capitalize$1(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $6fb9842575b03497$var$DEFAULT_RAW$1[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier;
}();
var $6fb9842575b03497$var$stringifier$1 = $6fb9842575b03497$var$Stringifier$2$1;
$6fb9842575b03497$var$Stringifier$2$1.default = $6fb9842575b03497$var$Stringifier$2$1;
var $6fb9842575b03497$var$Stringifier$1$1 = $6fb9842575b03497$var$stringifier$1;
function $6fb9842575b03497$var$stringify$4$1(node2, builder) {
    var str = new $6fb9842575b03497$var$Stringifier$1$1(builder);
    str.stringify(node2);
}
var $6fb9842575b03497$var$stringify_1$1 = $6fb9842575b03497$var$stringify$4$1;
$6fb9842575b03497$var$stringify$4$1.default = $6fb9842575b03497$var$stringify$4$1;
var $6fb9842575b03497$var$isClean$2$1 = $6fb9842575b03497$var$symbols$1.isClean, $6fb9842575b03497$var$my$2$1 = $6fb9842575b03497$var$symbols$1.my;
var $6fb9842575b03497$var$CssSyntaxError$2$1 = $6fb9842575b03497$var$cssSyntaxError$1;
var $6fb9842575b03497$var$Stringifier2$1 = $6fb9842575b03497$var$stringifier$1;
var $6fb9842575b03497$var$stringify$3$1 = $6fb9842575b03497$var$stringify_1$1;
function $6fb9842575b03497$var$cloneNode$1(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $6fb9842575b03497$var$cloneNode$1(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $6fb9842575b03497$var$cloneNode$1(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $6fb9842575b03497$var$Node$4$1 = /*#__PURE__*/ function() {
    function Node2(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$6fb9842575b03497$var$isClean$2$1] = false;
        this[$6fb9842575b03497$var$my$2$1] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node2.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $6fb9842575b03497$var$cloneNode$1(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $6fb9842575b03497$var$CssSyntaxError$2$1(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$6fb9842575b03497$var$isClean$2$1]) {
            this[$6fb9842575b03497$var$isClean$2$1] = false;
            var next = this;
            while(next = next.parent)next[$6fb9842575b03497$var$isClean$2$1] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $6fb9842575b03497$var$Stringifier2$1();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $6fb9842575b03497$var$stringify$3$1;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $6fb9842575b03497$var$_create_class(Node2, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node2;
}();
var $6fb9842575b03497$var$node$1 = $6fb9842575b03497$var$Node$4$1;
$6fb9842575b03497$var$Node$4$1.default = $6fb9842575b03497$var$Node$4$1;
var $6fb9842575b03497$var$Node$3$1 = $6fb9842575b03497$var$node$1;
var $6fb9842575b03497$var$Declaration$4$1 = /*#__PURE__*/ function(Node$3$1) {
    $6fb9842575b03497$var$_inherits(Declaration, Node$3$1);
    function Declaration(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $6fb9842575b03497$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3$1.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $6fb9842575b03497$var$_create_class(Declaration, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration;
}($6fb9842575b03497$var$Node$3$1);
var $6fb9842575b03497$var$declaration$1 = $6fb9842575b03497$var$Declaration$4$1;
$6fb9842575b03497$var$Declaration$4$1.default = $6fb9842575b03497$var$Declaration$4$1;
var $6fb9842575b03497$var$urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $6fb9842575b03497$var$nanoid$1$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $6fb9842575b03497$var$urlAlphabet$1[Math.random() * 64 | 0];
    return id;
};
var $6fb9842575b03497$var$nonSecure$1 = {
    nanoid: $6fb9842575b03497$var$nanoid$1$1
};
var $6fb9842575b03497$var$SourceMapConsumer$2$1 = $6fb9842575b03497$var$require$$2$1.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$2$1 = $6fb9842575b03497$var$require$$2$1.SourceMapGenerator;
var $6fb9842575b03497$var$existsSync$1 = $6fb9842575b03497$var$require$$2$1.existsSync, $6fb9842575b03497$var$readFileSync$1 = $6fb9842575b03497$var$require$$2$1.readFileSync;
var $6fb9842575b03497$var$dirname$1$1 = $6fb9842575b03497$var$require$$2$1.dirname, $6fb9842575b03497$var$join$1 = $6fb9842575b03497$var$require$$2$1.join;
function $6fb9842575b03497$var$fromBase64$1(str) {
    if ($6fb9842575b03497$require$Buffer) return $6fb9842575b03497$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $6fb9842575b03497$var$PreviousMap$2$1 = /*#__PURE__*/ function() {
    function PreviousMap(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $6fb9842575b03497$var$dirname$1$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $6fb9842575b03497$var$SourceMapConsumer$2$1(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $6fb9842575b03497$var$fromBase64$1(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $6fb9842575b03497$var$dirname$1$1(path);
        if ($6fb9842575b03497$var$existsSync$1(path)) {
            this.mapFile = path;
            return $6fb9842575b03497$var$readFileSync$1(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($6fb9842575b03497$var$_instanceof(prev, $6fb9842575b03497$var$SourceMapConsumer$2$1)) return $6fb9842575b03497$var$SourceMapGenerator$2$1.fromSourceMap(prev).toString();
            else if ($6fb9842575b03497$var$_instanceof(prev, $6fb9842575b03497$var$SourceMapGenerator$2$1)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $6fb9842575b03497$var$join$1($6fb9842575b03497$var$dirname$1$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap;
}();
var $6fb9842575b03497$var$previousMap$1 = $6fb9842575b03497$var$PreviousMap$2$1;
$6fb9842575b03497$var$PreviousMap$2$1.default = $6fb9842575b03497$var$PreviousMap$2$1;
var $6fb9842575b03497$var$SourceMapConsumer$1$1 = $6fb9842575b03497$var$require$$2$1.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$1$1 = $6fb9842575b03497$var$require$$2$1.SourceMapGenerator;
var $6fb9842575b03497$var$fileURLToPath$1 = $6fb9842575b03497$var$require$$2$1.fileURLToPath, $6fb9842575b03497$var$pathToFileURL$1$1 = $6fb9842575b03497$var$require$$2$1.pathToFileURL;
var $6fb9842575b03497$var$isAbsolute$1 = $6fb9842575b03497$var$require$$2$1.isAbsolute, $6fb9842575b03497$var$resolve$1$1 = $6fb9842575b03497$var$require$$2$1.resolve;
var $6fb9842575b03497$var$nanoid$2 = $6fb9842575b03497$var$nonSecure$1.nanoid;
var $6fb9842575b03497$var$terminalHighlight$2 = $6fb9842575b03497$var$require$$2$1;
var $6fb9842575b03497$var$CssSyntaxError$1$1 = $6fb9842575b03497$var$cssSyntaxError$1;
var $6fb9842575b03497$var$PreviousMap$1$1 = $6fb9842575b03497$var$previousMap$1;
var $6fb9842575b03497$var$fromOffsetCache$1 = Symbol("fromOffsetCache");
var $6fb9842575b03497$var$sourceMapAvailable$1$1 = Boolean($6fb9842575b03497$var$SourceMapConsumer$1$1 && $6fb9842575b03497$var$SourceMapGenerator$1$1);
var $6fb9842575b03497$var$pathAvailable$1$1 = Boolean($6fb9842575b03497$var$resolve$1$1 && $6fb9842575b03497$var$isAbsolute$1);
var $6fb9842575b03497$var$Input$4$1 = /*#__PURE__*/ function() {
    function Input(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$6fb9842575b03497$var$pathAvailable$1$1 || /^\w+:\/\//.test(opts.from) || $6fb9842575b03497$var$isAbsolute$1(opts.from)) this.file = opts.from;
            else this.file = $6fb9842575b03497$var$resolve$1$1(opts.from);
        }
        if ($6fb9842575b03497$var$pathAvailable$1$1 && $6fb9842575b03497$var$sourceMapAvailable$1$1) {
            var map = new $6fb9842575b03497$var$PreviousMap$1$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $6fb9842575b03497$var$nanoid$2(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $6fb9842575b03497$var$CssSyntaxError$1$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $6fb9842575b03497$var$CssSyntaxError$1$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($6fb9842575b03497$var$pathToFileURL$1$1) result2.input.url = $6fb9842575b03497$var$pathToFileURL$1$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$6fb9842575b03497$var$fromOffsetCache$1]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$6fb9842575b03497$var$fromOffsetCache$1] = lineToIndex;
        } else lineToIndex = this[$6fb9842575b03497$var$fromOffsetCache$1];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $6fb9842575b03497$var$resolve$1$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($6fb9842575b03497$var$isAbsolute$1(from.source)) fromUrl = $6fb9842575b03497$var$pathToFileURL$1$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $6fb9842575b03497$var$pathToFileURL$1$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($6fb9842575b03497$var$fileURLToPath$1) result2.file = $6fb9842575b03497$var$fileURLToPath$1(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $6fb9842575b03497$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $6fb9842575b03497$var$_create_class(Input, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input;
}();
var $6fb9842575b03497$var$input$1 = $6fb9842575b03497$var$Input$4$1;
$6fb9842575b03497$var$Input$4$1.default = $6fb9842575b03497$var$Input$4$1;
if ($6fb9842575b03497$var$terminalHighlight$2 && $6fb9842575b03497$var$terminalHighlight$2.registerInput) $6fb9842575b03497$var$terminalHighlight$2.registerInput($6fb9842575b03497$var$Input$4$1);
var $6fb9842575b03497$var$SourceMapConsumer$3 = $6fb9842575b03497$var$require$$2$1.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$3 = $6fb9842575b03497$var$require$$2$1.SourceMapGenerator;
var $6fb9842575b03497$var$dirname$2 = $6fb9842575b03497$var$require$$2$1.dirname, $6fb9842575b03497$var$relative$1 = $6fb9842575b03497$var$require$$2$1.relative, $6fb9842575b03497$var$resolve$2 = $6fb9842575b03497$var$require$$2$1.resolve, $6fb9842575b03497$var$sep$1 = $6fb9842575b03497$var$require$$2$1.sep;
var $6fb9842575b03497$var$pathToFileURL$2 = $6fb9842575b03497$var$require$$2$1.pathToFileURL;
var $6fb9842575b03497$var$Input$3$1 = $6fb9842575b03497$var$input$1;
var $6fb9842575b03497$var$sourceMapAvailable$2 = Boolean($6fb9842575b03497$var$SourceMapConsumer$3 && $6fb9842575b03497$var$SourceMapGenerator$3);
var $6fb9842575b03497$var$pathAvailable$2 = Boolean($6fb9842575b03497$var$dirname$2 && $6fb9842575b03497$var$resolve$2 && $6fb9842575b03497$var$relative$1 && $6fb9842575b03497$var$sep$1);
var $6fb9842575b03497$var$MapGenerator$2$1 = /*#__PURE__*/ function() {
    function MapGenerator(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $6fb9842575b03497$var$dirname$2(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $6fb9842575b03497$var$SourceMapConsumer$3(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($6fb9842575b03497$var$pathAvailable$2 && $6fb9842575b03497$var$sourceMapAvailable$2 && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $6fb9842575b03497$var$SourceMapGenerator$3.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $6fb9842575b03497$var$SourceMapGenerator$3({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $6fb9842575b03497$var$SourceMapGenerator$3({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $6fb9842575b03497$var$dirname$2(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $6fb9842575b03497$var$dirname$2($6fb9842575b03497$var$resolve$2(from, this.mapOpts.annotation));
        var path = $6fb9842575b03497$var$relative$1(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $6fb9842575b03497$var$Input$3$1(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($6fb9842575b03497$require$Buffer) return $6fb9842575b03497$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($6fb9842575b03497$var$pathToFileURL$2) {
            var fileURL = $6fb9842575b03497$var$pathToFileURL$2(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($6fb9842575b03497$var$sep$1 === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator;
}();
var $6fb9842575b03497$var$mapGenerator$1 = $6fb9842575b03497$var$MapGenerator$2$1;
var $6fb9842575b03497$var$Node$2$1 = $6fb9842575b03497$var$node$1;
var $6fb9842575b03497$var$Comment$4$1 = /*#__PURE__*/ function(Node$2$1) {
    $6fb9842575b03497$var$_inherits(Comment, Node$2$1);
    function Comment(defaults) {
        var _this;
        _this = Node$2$1.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment;
}($6fb9842575b03497$var$Node$2$1);
var $6fb9842575b03497$var$comment$1 = $6fb9842575b03497$var$Comment$4$1;
$6fb9842575b03497$var$Comment$4$1.default = $6fb9842575b03497$var$Comment$4$1;
var $6fb9842575b03497$var$isClean$1$1 = $6fb9842575b03497$var$symbols$1.isClean, $6fb9842575b03497$var$my$1$1 = $6fb9842575b03497$var$symbols$1.my;
var $6fb9842575b03497$var$Declaration$3$1 = $6fb9842575b03497$var$declaration$1;
var $6fb9842575b03497$var$Comment$3$1 = $6fb9842575b03497$var$comment$1;
var $6fb9842575b03497$var$Node$1$1 = $6fb9842575b03497$var$node$1;
var $6fb9842575b03497$var$parse$4$1, $6fb9842575b03497$var$Rule$4$1, $6fb9842575b03497$var$AtRule$4$1, $6fb9842575b03497$var$Root$6$1;
function $6fb9842575b03497$var$cleanSource$1(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $6fb9842575b03497$var$cleanSource$1(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $6fb9842575b03497$var$markDirtyUp$1(node2) {
    node2[$6fb9842575b03497$var$isClean$1$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $6fb9842575b03497$var$markDirtyUp$1(i2);
    }
}
var $6fb9842575b03497$var$Container$7$1 = /*#__PURE__*/ function(Node$1$1) {
    $6fb9842575b03497$var$_inherits(Container, Node$1$1);
    function Container() {
        return Node$1$1.apply(this, arguments) || this;
    }
    var _proto = Container.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $6fb9842575b03497$var$cleanSource$1($6fb9842575b03497$var$parse$4$1(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $6fb9842575b03497$var$Declaration$3$1(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $6fb9842575b03497$var$Rule$4$1(nodes)
        ];
        else if (nodes.name) nodes = [
            new $6fb9842575b03497$var$AtRule$4$1(nodes)
        ];
        else if (nodes.text) nodes = [
            new $6fb9842575b03497$var$Comment$3$1(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$6fb9842575b03497$var$my$1$1]) Container.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$6fb9842575b03497$var$isClean$1$1]) $6fb9842575b03497$var$markDirtyUp$1(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $6fb9842575b03497$var$_create_class(Container, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container;
}($6fb9842575b03497$var$Node$1$1);
$6fb9842575b03497$var$Container$7$1.registerParse = function(dependant) {
    $6fb9842575b03497$var$parse$4$1 = dependant;
};
$6fb9842575b03497$var$Container$7$1.registerRule = function(dependant) {
    $6fb9842575b03497$var$Rule$4$1 = dependant;
};
$6fb9842575b03497$var$Container$7$1.registerAtRule = function(dependant) {
    $6fb9842575b03497$var$AtRule$4$1 = dependant;
};
$6fb9842575b03497$var$Container$7$1.registerRoot = function(dependant) {
    $6fb9842575b03497$var$Root$6$1 = dependant;
};
var $6fb9842575b03497$var$container$1 = $6fb9842575b03497$var$Container$7$1;
$6fb9842575b03497$var$Container$7$1.default = $6fb9842575b03497$var$Container$7$1;
$6fb9842575b03497$var$Container$7$1.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $6fb9842575b03497$var$AtRule$4$1.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Rule$4$1.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Declaration$3$1.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Comment$3$1.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Root$6$1.prototype);
    node2[$6fb9842575b03497$var$my$1$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $6fb9842575b03497$var$Container$7$1.rebuild(child);
    });
};
var $6fb9842575b03497$var$Container$6$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$LazyResult$4$1, $6fb9842575b03497$var$Processor$3$1;
var $6fb9842575b03497$var$Document$3$1 = /*#__PURE__*/ function(Container$6$1) {
    $6fb9842575b03497$var$_inherits(Document2, Container$6$1);
    function Document2(defaults) {
        var _this;
        _this = Container$6$1.call(this, $6fb9842575b03497$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document2.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $6fb9842575b03497$var$LazyResult$4$1(new $6fb9842575b03497$var$Processor$3$1(), this, opts);
        return lazy.stringify();
    };
    return Document2;
}($6fb9842575b03497$var$Container$6$1);
$6fb9842575b03497$var$Document$3$1.registerLazyResult = function(dependant) {
    $6fb9842575b03497$var$LazyResult$4$1 = dependant;
};
$6fb9842575b03497$var$Document$3$1.registerProcessor = function(dependant) {
    $6fb9842575b03497$var$Processor$3$1 = dependant;
};
var $6fb9842575b03497$var$document$1$1 = $6fb9842575b03497$var$Document$3$1;
$6fb9842575b03497$var$Document$3$1.default = $6fb9842575b03497$var$Document$3$1;
var $6fb9842575b03497$var$printed$1 = {};
var $6fb9842575b03497$var$warnOnce$2$1 = function warnOnce(message) {
    if ($6fb9842575b03497$var$printed$1[message]) return;
    $6fb9842575b03497$var$printed$1[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $6fb9842575b03497$var$Warning$2$1 = /*#__PURE__*/ function() {
    function Warning(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning;
}();
var $6fb9842575b03497$var$warning$1 = $6fb9842575b03497$var$Warning$2$1;
$6fb9842575b03497$var$Warning$2$1.default = $6fb9842575b03497$var$Warning$2$1;
var $6fb9842575b03497$var$Warning$1$1 = $6fb9842575b03497$var$warning$1;
var $6fb9842575b03497$var$Result$3$1 = /*#__PURE__*/ function() {
    function Result(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $6fb9842575b03497$var$Warning$1$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $6fb9842575b03497$var$_create_class(Result, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result;
}();
var $6fb9842575b03497$var$result$1 = $6fb9842575b03497$var$Result$3$1;
$6fb9842575b03497$var$Result$3$1.default = $6fb9842575b03497$var$Result$3$1;
var $6fb9842575b03497$var$SINGLE_QUOTE$1 = "'".charCodeAt(0);
var $6fb9842575b03497$var$DOUBLE_QUOTE$1 = '"'.charCodeAt(0);
var $6fb9842575b03497$var$BACKSLASH$1 = "\\".charCodeAt(0);
var $6fb9842575b03497$var$SLASH$1 = "/".charCodeAt(0);
var $6fb9842575b03497$var$NEWLINE$1 = "\n".charCodeAt(0);
var $6fb9842575b03497$var$SPACE$1 = " ".charCodeAt(0);
var $6fb9842575b03497$var$FEED$1 = "\f".charCodeAt(0);
var $6fb9842575b03497$var$TAB$1 = "	".charCodeAt(0);
var $6fb9842575b03497$var$CR$1 = "\r".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_SQUARE$1 = "[".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_SQUARE$1 = "]".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_PARENTHESES$1 = "(".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_PARENTHESES$1 = ")".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_CURLY$1 = "{".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_CURLY$1 = "}".charCodeAt(0);
var $6fb9842575b03497$var$SEMICOLON$1 = ";".charCodeAt(0);
var $6fb9842575b03497$var$ASTERISK$1 = "*".charCodeAt(0);
var $6fb9842575b03497$var$COLON$1 = ":".charCodeAt(0);
var $6fb9842575b03497$var$AT$1 = "@".charCodeAt(0);
var $6fb9842575b03497$var$RE_AT_END$1 = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $6fb9842575b03497$var$RE_WORD_END$1 = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $6fb9842575b03497$var$RE_BAD_BRACKET$1 = /.[\r\n"'(/\\]/;
var $6fb9842575b03497$var$RE_HEX_ESCAPE$1 = /[\da-f]/i;
var $6fb9842575b03497$var$tokenize$1 = function tokenizer(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $6fb9842575b03497$var$NEWLINE$1:
            case $6fb9842575b03497$var$SPACE$1:
            case $6fb9842575b03497$var$TAB$1:
            case $6fb9842575b03497$var$CR$1:
            case $6fb9842575b03497$var$FEED$1:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $6fb9842575b03497$var$SPACE$1 || code === $6fb9842575b03497$var$NEWLINE$1 || code === $6fb9842575b03497$var$TAB$1 || code === $6fb9842575b03497$var$CR$1 || code === $6fb9842575b03497$var$FEED$1);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $6fb9842575b03497$var$OPEN_SQUARE$1:
            case $6fb9842575b03497$var$CLOSE_SQUARE$1:
            case $6fb9842575b03497$var$OPEN_CURLY$1:
            case $6fb9842575b03497$var$CLOSE_CURLY$1:
            case $6fb9842575b03497$var$COLON$1:
            case $6fb9842575b03497$var$SEMICOLON$1:
            case $6fb9842575b03497$var$CLOSE_PARENTHESES$1:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $6fb9842575b03497$var$OPEN_PARENTHESES$1:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $6fb9842575b03497$var$SINGLE_QUOTE$1 && n2 !== $6fb9842575b03497$var$DOUBLE_QUOTE$1 && n2 !== $6fb9842575b03497$var$SPACE$1 && n2 !== $6fb9842575b03497$var$NEWLINE$1 && n2 !== $6fb9842575b03497$var$TAB$1 && n2 !== $6fb9842575b03497$var$FEED$1 && n2 !== $6fb9842575b03497$var$CR$1) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $6fb9842575b03497$var$BACKSLASH$1){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $6fb9842575b03497$var$RE_BAD_BRACKET$1.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $6fb9842575b03497$var$SINGLE_QUOTE$1:
            case $6fb9842575b03497$var$DOUBLE_QUOTE$1:
                quote = code === $6fb9842575b03497$var$SINGLE_QUOTE$1 ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $6fb9842575b03497$var$BACKSLASH$1){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $6fb9842575b03497$var$AT$1:
                $6fb9842575b03497$var$RE_AT_END$1.lastIndex = pos + 1;
                $6fb9842575b03497$var$RE_AT_END$1.test(css);
                if ($6fb9842575b03497$var$RE_AT_END$1.lastIndex === 0) next = css.length - 1;
                else next = $6fb9842575b03497$var$RE_AT_END$1.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $6fb9842575b03497$var$BACKSLASH$1:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $6fb9842575b03497$var$BACKSLASH$1){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $6fb9842575b03497$var$SLASH$1 && code !== $6fb9842575b03497$var$SPACE$1 && code !== $6fb9842575b03497$var$NEWLINE$1 && code !== $6fb9842575b03497$var$TAB$1 && code !== $6fb9842575b03497$var$CR$1 && code !== $6fb9842575b03497$var$FEED$1) {
                    next += 1;
                    if ($6fb9842575b03497$var$RE_HEX_ESCAPE$1.test(css.charAt(next))) {
                        while($6fb9842575b03497$var$RE_HEX_ESCAPE$1.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $6fb9842575b03497$var$SPACE$1) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $6fb9842575b03497$var$SLASH$1 && css.charCodeAt(pos + 1) === $6fb9842575b03497$var$ASTERISK$1) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $6fb9842575b03497$var$RE_WORD_END$1.lastIndex = pos + 1;
                    $6fb9842575b03497$var$RE_WORD_END$1.test(css);
                    if ($6fb9842575b03497$var$RE_WORD_END$1.lastIndex === 0) next = css.length - 1;
                    else next = $6fb9842575b03497$var$RE_WORD_END$1.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $6fb9842575b03497$var$Container$5$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$AtRule$3$1 = /*#__PURE__*/ function(Container$5$1) {
    $6fb9842575b03497$var$_inherits(AtRule, Container$5$1);
    function AtRule(defaults) {
        var _this;
        _this = Container$5$1.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_append = Container$5$1.prototype.append).call.apply(_Container$5$1_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_prepend = Container$5$1.prototype.prepend).call.apply(_Container$5$1_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule;
}($6fb9842575b03497$var$Container$5$1);
var $6fb9842575b03497$var$atRule$1 = $6fb9842575b03497$var$AtRule$3$1;
$6fb9842575b03497$var$AtRule$3$1.default = $6fb9842575b03497$var$AtRule$3$1;
$6fb9842575b03497$var$Container$5$1.registerAtRule($6fb9842575b03497$var$AtRule$3$1);
var $6fb9842575b03497$var$Container$4$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$LazyResult$3$1, $6fb9842575b03497$var$Processor$2$1;
var $6fb9842575b03497$var$Root$5$1 = /*#__PURE__*/ function(Container$4$1) {
    $6fb9842575b03497$var$_inherits(Root, Container$4$1);
    function Root(defaults) {
        var _this;
        _this = Container$4$1.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4$1.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4$1.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $6fb9842575b03497$var$LazyResult$3$1(new $6fb9842575b03497$var$Processor$2$1(), this, opts);
        return lazy.stringify();
    };
    return Root;
}($6fb9842575b03497$var$Container$4$1);
$6fb9842575b03497$var$Root$5$1.registerLazyResult = function(dependant) {
    $6fb9842575b03497$var$LazyResult$3$1 = dependant;
};
$6fb9842575b03497$var$Root$5$1.registerProcessor = function(dependant) {
    $6fb9842575b03497$var$Processor$2$1 = dependant;
};
var $6fb9842575b03497$var$root$1 = $6fb9842575b03497$var$Root$5$1;
$6fb9842575b03497$var$Root$5$1.default = $6fb9842575b03497$var$Root$5$1;
$6fb9842575b03497$var$Container$4$1.registerRoot($6fb9842575b03497$var$Root$5$1);
var $6fb9842575b03497$var$list$2$1 = {
    comma: function comma(string) {
        return $6fb9842575b03497$var$list$2$1.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $6fb9842575b03497$var$list$2$1.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $6fb9842575b03497$var$list_1$1 = $6fb9842575b03497$var$list$2$1;
$6fb9842575b03497$var$list$2$1.default = $6fb9842575b03497$var$list$2$1;
var $6fb9842575b03497$var$Container$3$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$list$1$1 = $6fb9842575b03497$var$list_1$1;
var $6fb9842575b03497$var$Rule$3$1 = /*#__PURE__*/ function(Container$3$1) {
    $6fb9842575b03497$var$_inherits(Rule, Container$3$1);
    function Rule(defaults) {
        var _this;
        _this = Container$3$1.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $6fb9842575b03497$var$_create_class(Rule, [
        {
            key: "selectors",
            get: function get() {
                return $6fb9842575b03497$var$list$1$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule;
}($6fb9842575b03497$var$Container$3$1);
var $6fb9842575b03497$var$rule$1 = $6fb9842575b03497$var$Rule$3$1;
$6fb9842575b03497$var$Rule$3$1.default = $6fb9842575b03497$var$Rule$3$1;
$6fb9842575b03497$var$Container$3$1.registerRule($6fb9842575b03497$var$Rule$3$1);
var $6fb9842575b03497$var$Declaration$2$1 = $6fb9842575b03497$var$declaration$1;
var $6fb9842575b03497$var$tokenizer2$1 = $6fb9842575b03497$var$tokenize$1;
var $6fb9842575b03497$var$Comment$2$1 = $6fb9842575b03497$var$comment$1;
var $6fb9842575b03497$var$AtRule$2$1 = $6fb9842575b03497$var$atRule$1;
var $6fb9842575b03497$var$Root$4$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$Rule$2$1 = $6fb9842575b03497$var$rule$1;
var $6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR$1 = {
    empty: true,
    space: true
};
function $6fb9842575b03497$var$findLastWithPosition$1(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $6fb9842575b03497$var$Parser$1$1 = /*#__PURE__*/ function() {
    function Parser(input2) {
        this.input = input2;
        this.root = new $6fb9842575b03497$var$Root$4$1();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $6fb9842575b03497$var$AtRule$2$1();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $6fb9842575b03497$var$Comment$2$1();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $6fb9842575b03497$var$tokenizer2$1(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $6fb9842575b03497$var$Declaration$2$1();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $6fb9842575b03497$var$findLastWithPosition$1(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $6fb9842575b03497$var$Rule$2$1();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR$1[prev] && !$6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR$1[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $6fb9842575b03497$var$Rule$2$1();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser;
}();
var $6fb9842575b03497$var$parser$1 = $6fb9842575b03497$var$Parser$1$1;
var $6fb9842575b03497$var$Container$2$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$Parser2$1 = $6fb9842575b03497$var$parser$1;
var $6fb9842575b03497$var$Input$2$1 = $6fb9842575b03497$var$input$1;
function $6fb9842575b03497$var$parse$3$1(css, opts) {
    var input2 = new $6fb9842575b03497$var$Input$2$1(css, opts);
    var parser2 = new $6fb9842575b03497$var$Parser2$1(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $6fb9842575b03497$var$parse_1$1 = $6fb9842575b03497$var$parse$3$1;
$6fb9842575b03497$var$parse$3$1.default = $6fb9842575b03497$var$parse$3$1;
$6fb9842575b03497$var$Container$2$1.registerParse($6fb9842575b03497$var$parse$3$1);
var $6fb9842575b03497$var$isClean$3 = $6fb9842575b03497$var$symbols$1.isClean, $6fb9842575b03497$var$my$3 = $6fb9842575b03497$var$symbols$1.my;
var $6fb9842575b03497$var$MapGenerator$1$1 = $6fb9842575b03497$var$mapGenerator$1;
var $6fb9842575b03497$var$stringify$2$1 = $6fb9842575b03497$var$stringify_1$1;
var $6fb9842575b03497$var$Container$1$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$Document$2$1 = $6fb9842575b03497$var$document$1$1;
var $6fb9842575b03497$var$warnOnce$1$1 = $6fb9842575b03497$var$warnOnce$2$1;
var $6fb9842575b03497$var$Result$2$1 = $6fb9842575b03497$var$result$1;
var $6fb9842575b03497$var$parse$2$1 = $6fb9842575b03497$var$parse_1$1;
var $6fb9842575b03497$var$Root$3$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$TYPE_TO_CLASS_NAME$1 = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $6fb9842575b03497$var$PLUGIN_PROPS$1 = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $6fb9842575b03497$var$NOT_VISITORS$1 = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $6fb9842575b03497$var$CHILDREN$1 = 0;
function $6fb9842575b03497$var$isPromise$1(obj) {
    return (typeof obj === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $6fb9842575b03497$var$getEvents$1(node2) {
    var key = false;
    var type = $6fb9842575b03497$var$TYPE_TO_CLASS_NAME$1[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $6fb9842575b03497$var$CHILDREN$1,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $6fb9842575b03497$var$CHILDREN$1,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $6fb9842575b03497$var$toStack$1(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $6fb9842575b03497$var$CHILDREN$1,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $6fb9842575b03497$var$CHILDREN$1,
        "RootExit"
    ];
    else events = $6fb9842575b03497$var$getEvents$1(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $6fb9842575b03497$var$cleanMarks$1(node2) {
    node2[$6fb9842575b03497$var$isClean$3] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $6fb9842575b03497$var$cleanMarks$1(i2);
    });
    return node2;
}
var $6fb9842575b03497$var$postcss$2$1 = {};
var $6fb9842575b03497$var$LazyResult$2$1 = /*#__PURE__*/ function() {
    function LazyResult(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $6fb9842575b03497$var$cleanMarks$1(css);
        else if ($6fb9842575b03497$var$_instanceof(css, LazyResult) || $6fb9842575b03497$var$_instanceof(css, $6fb9842575b03497$var$Result$2$1)) {
            root2 = $6fb9842575b03497$var$cleanMarks$1(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $6fb9842575b03497$var$parse$2$1;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$6fb9842575b03497$var$my$3]) $6fb9842575b03497$var$Container$1$1.rebuild(root2);
        }
        this.result = new $6fb9842575b03497$var$Result$2$1(processor2, root2, opts);
        this.helpers = $6fb9842575b03497$var$_extends({}, $6fb9842575b03497$var$postcss$2$1, {
            postcss: $6fb9842575b03497$var$postcss$2$1,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $6fb9842575b03497$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$6fb9842575b03497$var$PLUGIN_PROPS$1[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$6fb9842575b03497$var$NOT_VISITORS$1[event]) {
                    if ($6fb9842575b03497$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $6fb9842575b03497$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$6fb9842575b03497$var$isPromise$1(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$6fb9842575b03497$var$isClean$3]) return [
                            3,
                            14
                        ];
                        root2[$6fb9842575b03497$var$isClean$3] = true;
                        stack = [
                            $6fb9842575b03497$var$toStack$1(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$6fb9842575b03497$var$isPromise$1(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $6fb9842575b03497$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($6fb9842575b03497$var$isPromise$1(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $6fb9842575b03497$var$stringify$2$1;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $6fb9842575b03497$var$MapGenerator$1$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($6fb9842575b03497$var$isPromise$1(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$6fb9842575b03497$var$isClean$3]){
                root2[$6fb9842575b03497$var$isClean$3] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($6fb9842575b03497$var$isPromise$1(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$6fb9842575b03497$var$isClean$3]) {
                    child[$6fb9842575b03497$var$isClean$3] = true;
                    stack.push($6fb9842575b03497$var$toStack$1(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $6fb9842575b03497$var$CHILDREN$1) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$6fb9842575b03497$var$isClean$3] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$6fb9842575b03497$var$isClean$3] = true;
        var events = $6fb9842575b03497$var$getEvents$1(node2);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $6fb9842575b03497$var$CHILDREN$1) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$6fb9842575b03497$var$isClean$3]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $6fb9842575b03497$var$_create_class(LazyResult, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult;
}();
$6fb9842575b03497$var$LazyResult$2$1.registerPostcss = function(dependant) {
    $6fb9842575b03497$var$postcss$2$1 = dependant;
};
var $6fb9842575b03497$var$lazyResult$1 = $6fb9842575b03497$var$LazyResult$2$1;
$6fb9842575b03497$var$LazyResult$2$1.default = $6fb9842575b03497$var$LazyResult$2$1;
$6fb9842575b03497$var$Root$3$1.registerLazyResult($6fb9842575b03497$var$LazyResult$2$1);
$6fb9842575b03497$var$Document$2$1.registerLazyResult($6fb9842575b03497$var$LazyResult$2$1);
var $6fb9842575b03497$var$MapGenerator2$1 = $6fb9842575b03497$var$mapGenerator$1;
var $6fb9842575b03497$var$stringify$1$1 = $6fb9842575b03497$var$stringify_1$1;
var $6fb9842575b03497$var$warnOnce2$1 = $6fb9842575b03497$var$warnOnce$2$1;
var $6fb9842575b03497$var$parse$1$1 = $6fb9842575b03497$var$parse_1$1;
var $6fb9842575b03497$var$Result$1$1 = $6fb9842575b03497$var$result$1;
var $6fb9842575b03497$var$NoWorkResult$1$1 = /*#__PURE__*/ function() {
    function NoWorkResult(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $6fb9842575b03497$var$stringify$1$1;
        this.result = new $6fb9842575b03497$var$Result$1$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $6fb9842575b03497$var$MapGenerator2$1(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $6fb9842575b03497$var$_create_class(NoWorkResult, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $6fb9842575b03497$var$parse$1$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult;
}();
var $6fb9842575b03497$var$noWorkResult$1 = $6fb9842575b03497$var$NoWorkResult$1$1;
$6fb9842575b03497$var$NoWorkResult$1$1.default = $6fb9842575b03497$var$NoWorkResult$1$1;
var $6fb9842575b03497$var$NoWorkResult2$1 = $6fb9842575b03497$var$noWorkResult$1;
var $6fb9842575b03497$var$LazyResult$1$1 = $6fb9842575b03497$var$lazyResult$1;
var $6fb9842575b03497$var$Document$1$1 = $6fb9842575b03497$var$document$1$1;
var $6fb9842575b03497$var$Root$2$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$Processor$1$1 = /*#__PURE__*/ function() {
    function Processor(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $6fb9842575b03497$var$NoWorkResult2$1(this, css, opts);
        else return new $6fb9842575b03497$var$LazyResult$1$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor;
}();
var $6fb9842575b03497$var$processor$1 = $6fb9842575b03497$var$Processor$1$1;
$6fb9842575b03497$var$Processor$1$1.default = $6fb9842575b03497$var$Processor$1$1;
$6fb9842575b03497$var$Root$2$1.registerProcessor($6fb9842575b03497$var$Processor$1$1);
$6fb9842575b03497$var$Document$1$1.registerProcessor($6fb9842575b03497$var$Processor$1$1);
var $6fb9842575b03497$var$Declaration$1$1 = $6fb9842575b03497$var$declaration$1;
var $6fb9842575b03497$var$PreviousMap2$1 = $6fb9842575b03497$var$previousMap$1;
var $6fb9842575b03497$var$Comment$1$1 = $6fb9842575b03497$var$comment$1;
var $6fb9842575b03497$var$AtRule$1$1 = $6fb9842575b03497$var$atRule$1;
var $6fb9842575b03497$var$Input$1$1 = $6fb9842575b03497$var$input$1;
var $6fb9842575b03497$var$Root$1$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$Rule$1$1 = $6fb9842575b03497$var$rule$1;
function $6fb9842575b03497$var$fromJSON$1$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $6fb9842575b03497$var$fromJSON$1$1(n2);
    });
    var ownInputs = json.inputs, defaults = $6fb9842575b03497$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $6fb9842575b03497$var$_extends({}, input2, {
                __proto__: $6fb9842575b03497$var$Input$1$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $6fb9842575b03497$var$_extends({}, inputHydrated.map, {
                __proto__: $6fb9842575b03497$var$PreviousMap2$1.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $6fb9842575b03497$var$fromJSON$1$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $6fb9842575b03497$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $6fb9842575b03497$var$Root$1$1(defaults);
    else if (defaults.type === "decl") return new $6fb9842575b03497$var$Declaration$1$1(defaults);
    else if (defaults.type === "rule") return new $6fb9842575b03497$var$Rule$1$1(defaults);
    else if (defaults.type === "comment") return new $6fb9842575b03497$var$Comment$1$1(defaults);
    else if (defaults.type === "atrule") return new $6fb9842575b03497$var$AtRule$1$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $6fb9842575b03497$var$fromJSON_1$1 = $6fb9842575b03497$var$fromJSON$1$1;
$6fb9842575b03497$var$fromJSON$1$1.default = $6fb9842575b03497$var$fromJSON$1$1;
var $6fb9842575b03497$var$CssSyntaxError2$1 = $6fb9842575b03497$var$cssSyntaxError$1;
var $6fb9842575b03497$var$Declaration2$1 = $6fb9842575b03497$var$declaration$1;
var $6fb9842575b03497$var$LazyResult2$1 = $6fb9842575b03497$var$lazyResult$1;
var $6fb9842575b03497$var$Container2$1 = $6fb9842575b03497$var$container$1;
var $6fb9842575b03497$var$Processor2$1 = $6fb9842575b03497$var$processor$1;
var $6fb9842575b03497$var$stringify$5 = $6fb9842575b03497$var$stringify_1$1;
var $6fb9842575b03497$var$fromJSON$2 = $6fb9842575b03497$var$fromJSON_1$1;
var $6fb9842575b03497$var$Document22 = $6fb9842575b03497$var$document$1$1;
var $6fb9842575b03497$var$Warning2$1 = $6fb9842575b03497$var$warning$1;
var $6fb9842575b03497$var$Comment2$1 = $6fb9842575b03497$var$comment$1;
var $6fb9842575b03497$var$AtRule2$1 = $6fb9842575b03497$var$atRule$1;
var $6fb9842575b03497$var$Result2$1 = $6fb9842575b03497$var$result$1;
var $6fb9842575b03497$var$Input2$1 = $6fb9842575b03497$var$input$1;
var $6fb9842575b03497$var$parse$5 = $6fb9842575b03497$var$parse_1$1;
var $6fb9842575b03497$var$list$3 = $6fb9842575b03497$var$list_1$1;
var $6fb9842575b03497$var$Rule2$1 = $6fb9842575b03497$var$rule$1;
var $6fb9842575b03497$var$Root2$1 = $6fb9842575b03497$var$root$1;
var $6fb9842575b03497$var$Node2$1 = $6fb9842575b03497$var$node$1;
function $6fb9842575b03497$var$postcss$3() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $6fb9842575b03497$var$Processor2$1(plugins);
}
$6fb9842575b03497$var$postcss$3.plugin = function plugin(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $6fb9842575b03497$var$Processor2$1().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $6fb9842575b03497$var$postcss$3([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$6fb9842575b03497$var$postcss$3.stringify = $6fb9842575b03497$var$stringify$5;
$6fb9842575b03497$var$postcss$3.parse = $6fb9842575b03497$var$parse$5;
$6fb9842575b03497$var$postcss$3.fromJSON = $6fb9842575b03497$var$fromJSON$2;
$6fb9842575b03497$var$postcss$3.list = $6fb9842575b03497$var$list$3;
$6fb9842575b03497$var$postcss$3.comment = function(defaults) {
    return new $6fb9842575b03497$var$Comment2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.atRule = function(defaults) {
    return new $6fb9842575b03497$var$AtRule2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.decl = function(defaults) {
    return new $6fb9842575b03497$var$Declaration2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.rule = function(defaults) {
    return new $6fb9842575b03497$var$Rule2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.root = function(defaults) {
    return new $6fb9842575b03497$var$Root2$1(defaults);
};
$6fb9842575b03497$var$postcss$3.document = function(defaults) {
    return new $6fb9842575b03497$var$Document22(defaults);
};
$6fb9842575b03497$var$postcss$3.CssSyntaxError = $6fb9842575b03497$var$CssSyntaxError2$1;
$6fb9842575b03497$var$postcss$3.Declaration = $6fb9842575b03497$var$Declaration2$1;
$6fb9842575b03497$var$postcss$3.Container = $6fb9842575b03497$var$Container2$1;
$6fb9842575b03497$var$postcss$3.Processor = $6fb9842575b03497$var$Processor2$1;
$6fb9842575b03497$var$postcss$3.Document = $6fb9842575b03497$var$Document22;
$6fb9842575b03497$var$postcss$3.Comment = $6fb9842575b03497$var$Comment2$1;
$6fb9842575b03497$var$postcss$3.Warning = $6fb9842575b03497$var$Warning2$1;
$6fb9842575b03497$var$postcss$3.AtRule = $6fb9842575b03497$var$AtRule2$1;
$6fb9842575b03497$var$postcss$3.Result = $6fb9842575b03497$var$Result2$1;
$6fb9842575b03497$var$postcss$3.Input = $6fb9842575b03497$var$Input2$1;
$6fb9842575b03497$var$postcss$3.Rule = $6fb9842575b03497$var$Rule2$1;
$6fb9842575b03497$var$postcss$3.Root = $6fb9842575b03497$var$Root2$1;
$6fb9842575b03497$var$postcss$3.Node = $6fb9842575b03497$var$Node2$1;
$6fb9842575b03497$var$LazyResult2$1.registerPostcss($6fb9842575b03497$var$postcss$3);
var $6fb9842575b03497$var$postcss_1$1 = $6fb9842575b03497$var$postcss$3;
$6fb9842575b03497$var$postcss$3.default = $6fb9842575b03497$var$postcss$3;
var $6fb9842575b03497$var$postcss$1$1 = /* @__PURE__ */ $6fb9842575b03497$var$getDefaultExportFromCjs$1($6fb9842575b03497$var$postcss_1$1);
$6fb9842575b03497$var$postcss$1$1.stringify;
$6fb9842575b03497$var$postcss$1$1.fromJSON;
$6fb9842575b03497$var$postcss$1$1.plugin;
$6fb9842575b03497$var$postcss$1$1.parse;
$6fb9842575b03497$var$postcss$1$1.list;
$6fb9842575b03497$var$postcss$1$1.document;
$6fb9842575b03497$var$postcss$1$1.comment;
$6fb9842575b03497$var$postcss$1$1.atRule;
$6fb9842575b03497$var$postcss$1$1.rule;
$6fb9842575b03497$var$postcss$1$1.decl;
$6fb9842575b03497$var$postcss$1$1.root;
$6fb9842575b03497$var$postcss$1$1.CssSyntaxError;
$6fb9842575b03497$var$postcss$1$1.Declaration;
$6fb9842575b03497$var$postcss$1$1.Container;
$6fb9842575b03497$var$postcss$1$1.Processor;
$6fb9842575b03497$var$postcss$1$1.Document;
$6fb9842575b03497$var$postcss$1$1.Comment;
$6fb9842575b03497$var$postcss$1$1.Warning;
$6fb9842575b03497$var$postcss$1$1.AtRule;
$6fb9842575b03497$var$postcss$1$1.Result;
$6fb9842575b03497$var$postcss$1$1.Input;
$6fb9842575b03497$var$postcss$1$1.Rule;
$6fb9842575b03497$var$postcss$1$1.Root;
$6fb9842575b03497$var$postcss$1$1.Node;
var $6fb9842575b03497$var$__defProp2 = Object.defineProperty;
var $6fb9842575b03497$var$__defNormalProp2 = function(obj, key, value) {
    return key in obj ? $6fb9842575b03497$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $6fb9842575b03497$var$__publicField2 = function(obj, key, value) {
    return $6fb9842575b03497$var$__defNormalProp2(obj, (typeof key === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
function $6fb9842575b03497$var$getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $6fb9842575b03497$var$getAugmentedNamespace(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($6fb9842575b03497$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $6fb9842575b03497$var$picocolors_browser = {
    exports: {}
};
var $6fb9842575b03497$var$x = String;
var $6fb9842575b03497$var$create = function create() {
    return {
        isColorSupported: false,
        reset: $6fb9842575b03497$var$x,
        bold: $6fb9842575b03497$var$x,
        dim: $6fb9842575b03497$var$x,
        italic: $6fb9842575b03497$var$x,
        underline: $6fb9842575b03497$var$x,
        inverse: $6fb9842575b03497$var$x,
        hidden: $6fb9842575b03497$var$x,
        strikethrough: $6fb9842575b03497$var$x,
        black: $6fb9842575b03497$var$x,
        red: $6fb9842575b03497$var$x,
        green: $6fb9842575b03497$var$x,
        yellow: $6fb9842575b03497$var$x,
        blue: $6fb9842575b03497$var$x,
        magenta: $6fb9842575b03497$var$x,
        cyan: $6fb9842575b03497$var$x,
        white: $6fb9842575b03497$var$x,
        gray: $6fb9842575b03497$var$x,
        bgBlack: $6fb9842575b03497$var$x,
        bgRed: $6fb9842575b03497$var$x,
        bgGreen: $6fb9842575b03497$var$x,
        bgYellow: $6fb9842575b03497$var$x,
        bgBlue: $6fb9842575b03497$var$x,
        bgMagenta: $6fb9842575b03497$var$x,
        bgCyan: $6fb9842575b03497$var$x,
        bgWhite: $6fb9842575b03497$var$x
    };
};
$6fb9842575b03497$var$picocolors_browser.exports = $6fb9842575b03497$var$create();
$6fb9842575b03497$var$picocolors_browser.exports.createColors = $6fb9842575b03497$var$create;
var $6fb9842575b03497$var$picocolors_browserExports = $6fb9842575b03497$var$picocolors_browser.exports;
var $6fb9842575b03497$var$__viteBrowserExternal = {};
var $6fb9842575b03497$var$__viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $6fb9842575b03497$var$__viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
var $6fb9842575b03497$var$require$$2 = /* @__PURE__ */ $6fb9842575b03497$var$getAugmentedNamespace($6fb9842575b03497$var$__viteBrowserExternal$1);
var $6fb9842575b03497$var$pico = $6fb9842575b03497$var$picocolors_browserExports;
var $6fb9842575b03497$var$terminalHighlight$1 = $6fb9842575b03497$var$require$$2;
var $6fb9842575b03497$var$CssSyntaxError$3 = /*#__PURE__*/ function(Error1) {
    $6fb9842575b03497$var$_inherits(CssSyntaxError2, Error1);
    function CssSyntaxError2(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError2);
        return _this;
    }
    var _proto = CssSyntaxError2.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $6fb9842575b03497$var$pico.isColorSupported;
        if ($6fb9842575b03497$var$terminalHighlight$1) {
            if (color) css = $6fb9842575b03497$var$terminalHighlight$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico_createColors = $6fb9842575b03497$var$pico.createColors(true), bold = _pico_createColors.bold, gray = _pico_createColors.gray, red = _pico_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError2;
}($6fb9842575b03497$var$_wrap_native_super(Error));
var $6fb9842575b03497$var$cssSyntaxError = $6fb9842575b03497$var$CssSyntaxError$3;
$6fb9842575b03497$var$CssSyntaxError$3.default = $6fb9842575b03497$var$CssSyntaxError$3;
var $6fb9842575b03497$var$symbols = {};
$6fb9842575b03497$var$symbols.isClean = Symbol("isClean");
$6fb9842575b03497$var$symbols.my = Symbol("my");
var $6fb9842575b03497$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $6fb9842575b03497$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $6fb9842575b03497$var$Stringifier$2 = /*#__PURE__*/ function() {
    function Stringifier2(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier2.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $6fb9842575b03497$var$DEFAULT_RAW[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $6fb9842575b03497$var$capitalize(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $6fb9842575b03497$var$DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier2;
}();
var $6fb9842575b03497$var$stringifier = $6fb9842575b03497$var$Stringifier$2;
$6fb9842575b03497$var$Stringifier$2.default = $6fb9842575b03497$var$Stringifier$2;
var $6fb9842575b03497$var$Stringifier$1 = $6fb9842575b03497$var$stringifier;
function $6fb9842575b03497$var$stringify$4(node2, builder) {
    var str = new $6fb9842575b03497$var$Stringifier$1(builder);
    str.stringify(node2);
}
var $6fb9842575b03497$var$stringify_1 = $6fb9842575b03497$var$stringify$4;
$6fb9842575b03497$var$stringify$4.default = $6fb9842575b03497$var$stringify$4;
var $6fb9842575b03497$var$isClean$2 = $6fb9842575b03497$var$symbols.isClean, $6fb9842575b03497$var$my$2 = $6fb9842575b03497$var$symbols.my;
var $6fb9842575b03497$var$CssSyntaxError$2 = $6fb9842575b03497$var$cssSyntaxError;
var $6fb9842575b03497$var$Stringifier22 = $6fb9842575b03497$var$stringifier;
var $6fb9842575b03497$var$stringify$3 = $6fb9842575b03497$var$stringify_1;
function $6fb9842575b03497$var$cloneNode(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $6fb9842575b03497$var$cloneNode(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $6fb9842575b03497$var$cloneNode(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $6fb9842575b03497$var$Node$4 = /*#__PURE__*/ function() {
    function Node3(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$6fb9842575b03497$var$isClean$2] = false;
        this[$6fb9842575b03497$var$my$2] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node3.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $6fb9842575b03497$var$cloneNode(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $6fb9842575b03497$var$CssSyntaxError$2(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$6fb9842575b03497$var$isClean$2]) {
            this[$6fb9842575b03497$var$isClean$2] = false;
            var next = this;
            while(next = next.parent)next[$6fb9842575b03497$var$isClean$2] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $6fb9842575b03497$var$Stringifier22();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $6fb9842575b03497$var$stringify$3;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $6fb9842575b03497$var$_create_class(Node3, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node3;
}();
var $6fb9842575b03497$var$node = $6fb9842575b03497$var$Node$4;
$6fb9842575b03497$var$Node$4.default = $6fb9842575b03497$var$Node$4;
var $6fb9842575b03497$var$Node$3 = $6fb9842575b03497$var$node;
var $6fb9842575b03497$var$Declaration$4 = /*#__PURE__*/ function(Node$3) {
    $6fb9842575b03497$var$_inherits(Declaration2, Node$3);
    function Declaration2(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $6fb9842575b03497$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $6fb9842575b03497$var$_create_class(Declaration2, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration2;
}($6fb9842575b03497$var$Node$3);
var $6fb9842575b03497$var$declaration = $6fb9842575b03497$var$Declaration$4;
$6fb9842575b03497$var$Declaration$4.default = $6fb9842575b03497$var$Declaration$4;
var $6fb9842575b03497$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $6fb9842575b03497$var$nanoid$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $6fb9842575b03497$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
var $6fb9842575b03497$var$nonSecure = {
    nanoid: $6fb9842575b03497$var$nanoid$1
};
var $6fb9842575b03497$var$SourceMapConsumer$2 = $6fb9842575b03497$var$require$$2.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$2 = $6fb9842575b03497$var$require$$2.SourceMapGenerator;
var $6fb9842575b03497$var$existsSync = $6fb9842575b03497$var$require$$2.existsSync, $6fb9842575b03497$var$readFileSync = $6fb9842575b03497$var$require$$2.readFileSync;
var $6fb9842575b03497$var$dirname$1 = $6fb9842575b03497$var$require$$2.dirname, $6fb9842575b03497$var$join = $6fb9842575b03497$var$require$$2.join;
function $6fb9842575b03497$var$fromBase64(str) {
    if ($6fb9842575b03497$require$Buffer) return $6fb9842575b03497$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $6fb9842575b03497$var$PreviousMap$2 = /*#__PURE__*/ function() {
    function PreviousMap2(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $6fb9842575b03497$var$dirname$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap2.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $6fb9842575b03497$var$SourceMapConsumer$2(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $6fb9842575b03497$var$fromBase64(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $6fb9842575b03497$var$dirname$1(path);
        if ($6fb9842575b03497$var$existsSync(path)) {
            this.mapFile = path;
            return $6fb9842575b03497$var$readFileSync(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($6fb9842575b03497$var$_instanceof(prev, $6fb9842575b03497$var$SourceMapConsumer$2)) return $6fb9842575b03497$var$SourceMapGenerator$2.fromSourceMap(prev).toString();
            else if ($6fb9842575b03497$var$_instanceof(prev, $6fb9842575b03497$var$SourceMapGenerator$2)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $6fb9842575b03497$var$join($6fb9842575b03497$var$dirname$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap2;
}();
var $6fb9842575b03497$var$previousMap = $6fb9842575b03497$var$PreviousMap$2;
$6fb9842575b03497$var$PreviousMap$2.default = $6fb9842575b03497$var$PreviousMap$2;
var $6fb9842575b03497$var$SourceMapConsumer$1 = $6fb9842575b03497$var$require$$2.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator$1 = $6fb9842575b03497$var$require$$2.SourceMapGenerator;
var $6fb9842575b03497$var$fileURLToPath = $6fb9842575b03497$var$require$$2.fileURLToPath, $6fb9842575b03497$var$pathToFileURL$1 = $6fb9842575b03497$var$require$$2.pathToFileURL;
var $6fb9842575b03497$var$isAbsolute = $6fb9842575b03497$var$require$$2.isAbsolute, $6fb9842575b03497$var$resolve$1 = $6fb9842575b03497$var$require$$2.resolve;
var $6fb9842575b03497$var$nanoid = $6fb9842575b03497$var$nonSecure.nanoid;
var $6fb9842575b03497$var$terminalHighlight = $6fb9842575b03497$var$require$$2;
var $6fb9842575b03497$var$CssSyntaxError$1 = $6fb9842575b03497$var$cssSyntaxError;
var $6fb9842575b03497$var$PreviousMap$1 = $6fb9842575b03497$var$previousMap;
var $6fb9842575b03497$var$fromOffsetCache = Symbol("fromOffsetCache");
var $6fb9842575b03497$var$sourceMapAvailable$1 = Boolean($6fb9842575b03497$var$SourceMapConsumer$1 && $6fb9842575b03497$var$SourceMapGenerator$1);
var $6fb9842575b03497$var$pathAvailable$1 = Boolean($6fb9842575b03497$var$resolve$1 && $6fb9842575b03497$var$isAbsolute);
var $6fb9842575b03497$var$Input$4 = /*#__PURE__*/ function() {
    function Input2(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$6fb9842575b03497$var$pathAvailable$1 || /^\w+:\/\//.test(opts.from) || $6fb9842575b03497$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $6fb9842575b03497$var$resolve$1(opts.from);
        }
        if ($6fb9842575b03497$var$pathAvailable$1 && $6fb9842575b03497$var$sourceMapAvailable$1) {
            var map = new $6fb9842575b03497$var$PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $6fb9842575b03497$var$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input2.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $6fb9842575b03497$var$CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $6fb9842575b03497$var$CssSyntaxError$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($6fb9842575b03497$var$pathToFileURL$1) result2.input.url = $6fb9842575b03497$var$pathToFileURL$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$6fb9842575b03497$var$fromOffsetCache]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$6fb9842575b03497$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$6fb9842575b03497$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $6fb9842575b03497$var$resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($6fb9842575b03497$var$isAbsolute(from.source)) fromUrl = $6fb9842575b03497$var$pathToFileURL$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $6fb9842575b03497$var$pathToFileURL$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($6fb9842575b03497$var$fileURLToPath) result2.file = $6fb9842575b03497$var$fileURLToPath(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $6fb9842575b03497$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $6fb9842575b03497$var$_create_class(Input2, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input2;
}();
var $6fb9842575b03497$var$input = $6fb9842575b03497$var$Input$4;
$6fb9842575b03497$var$Input$4.default = $6fb9842575b03497$var$Input$4;
if ($6fb9842575b03497$var$terminalHighlight && $6fb9842575b03497$var$terminalHighlight.registerInput) $6fb9842575b03497$var$terminalHighlight.registerInput($6fb9842575b03497$var$Input$4);
var $6fb9842575b03497$var$SourceMapConsumer = $6fb9842575b03497$var$require$$2.SourceMapConsumer, $6fb9842575b03497$var$SourceMapGenerator = $6fb9842575b03497$var$require$$2.SourceMapGenerator;
var $6fb9842575b03497$var$dirname = $6fb9842575b03497$var$require$$2.dirname, $6fb9842575b03497$var$relative = $6fb9842575b03497$var$require$$2.relative, $6fb9842575b03497$var$resolve$3 = $6fb9842575b03497$var$require$$2.resolve, $6fb9842575b03497$var$sep = $6fb9842575b03497$var$require$$2.sep;
var $6fb9842575b03497$var$pathToFileURL = $6fb9842575b03497$var$require$$2.pathToFileURL;
var $6fb9842575b03497$var$Input$3 = $6fb9842575b03497$var$input;
var $6fb9842575b03497$var$sourceMapAvailable = Boolean($6fb9842575b03497$var$SourceMapConsumer && $6fb9842575b03497$var$SourceMapGenerator);
var $6fb9842575b03497$var$pathAvailable = Boolean($6fb9842575b03497$var$dirname && $6fb9842575b03497$var$resolve$3 && $6fb9842575b03497$var$relative && $6fb9842575b03497$var$sep);
var $6fb9842575b03497$var$MapGenerator$2 = /*#__PURE__*/ function() {
    function MapGenerator2(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator2.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $6fb9842575b03497$var$dirname(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $6fb9842575b03497$var$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($6fb9842575b03497$var$pathAvailable && $6fb9842575b03497$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $6fb9842575b03497$var$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $6fb9842575b03497$var$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $6fb9842575b03497$var$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $6fb9842575b03497$var$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $6fb9842575b03497$var$dirname($6fb9842575b03497$var$resolve$3(from, this.mapOpts.annotation));
        var path = $6fb9842575b03497$var$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $6fb9842575b03497$var$Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($6fb9842575b03497$require$Buffer) return $6fb9842575b03497$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($6fb9842575b03497$var$pathToFileURL) {
            var fileURL = $6fb9842575b03497$var$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($6fb9842575b03497$var$sep === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator2;
}();
var $6fb9842575b03497$var$mapGenerator = $6fb9842575b03497$var$MapGenerator$2;
var $6fb9842575b03497$var$Node$2 = $6fb9842575b03497$var$node;
var $6fb9842575b03497$var$Comment$4 = /*#__PURE__*/ function(Node$2) {
    $6fb9842575b03497$var$_inherits(Comment2, Node$2);
    function Comment2(defaults) {
        var _this;
        _this = Node$2.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment2;
}($6fb9842575b03497$var$Node$2);
var $6fb9842575b03497$var$comment = $6fb9842575b03497$var$Comment$4;
$6fb9842575b03497$var$Comment$4.default = $6fb9842575b03497$var$Comment$4;
var $6fb9842575b03497$var$isClean$1 = $6fb9842575b03497$var$symbols.isClean, $6fb9842575b03497$var$my$1 = $6fb9842575b03497$var$symbols.my;
var $6fb9842575b03497$var$Declaration$3 = $6fb9842575b03497$var$declaration;
var $6fb9842575b03497$var$Comment$3 = $6fb9842575b03497$var$comment;
var $6fb9842575b03497$var$Node$1 = $6fb9842575b03497$var$node;
var $6fb9842575b03497$var$parse$4, $6fb9842575b03497$var$Rule$4, $6fb9842575b03497$var$AtRule$4, $6fb9842575b03497$var$Root$6;
function $6fb9842575b03497$var$cleanSource(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $6fb9842575b03497$var$cleanSource(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $6fb9842575b03497$var$markDirtyUp(node2) {
    node2[$6fb9842575b03497$var$isClean$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $6fb9842575b03497$var$markDirtyUp(i2);
    }
}
var $6fb9842575b03497$var$Container$7 = /*#__PURE__*/ function(Node$1) {
    $6fb9842575b03497$var$_inherits(Container2, Node$1);
    function Container2() {
        return Node$1.apply(this, arguments) || this;
    }
    var _proto = Container2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $6fb9842575b03497$var$cleanSource($6fb9842575b03497$var$parse$4(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $6fb9842575b03497$var$Declaration$3(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $6fb9842575b03497$var$Rule$4(nodes)
        ];
        else if (nodes.name) nodes = [
            new $6fb9842575b03497$var$AtRule$4(nodes)
        ];
        else if (nodes.text) nodes = [
            new $6fb9842575b03497$var$Comment$3(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$6fb9842575b03497$var$my$1]) Container2.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$6fb9842575b03497$var$isClean$1]) $6fb9842575b03497$var$markDirtyUp(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($6fb9842575b03497$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $6fb9842575b03497$var$_create_class(Container2, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container2;
}($6fb9842575b03497$var$Node$1);
$6fb9842575b03497$var$Container$7.registerParse = function(dependant) {
    $6fb9842575b03497$var$parse$4 = dependant;
};
$6fb9842575b03497$var$Container$7.registerRule = function(dependant) {
    $6fb9842575b03497$var$Rule$4 = dependant;
};
$6fb9842575b03497$var$Container$7.registerAtRule = function(dependant) {
    $6fb9842575b03497$var$AtRule$4 = dependant;
};
$6fb9842575b03497$var$Container$7.registerRoot = function(dependant) {
    $6fb9842575b03497$var$Root$6 = dependant;
};
var $6fb9842575b03497$var$container = $6fb9842575b03497$var$Container$7;
$6fb9842575b03497$var$Container$7.default = $6fb9842575b03497$var$Container$7;
$6fb9842575b03497$var$Container$7.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $6fb9842575b03497$var$AtRule$4.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Rule$4.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Declaration$3.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Comment$3.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $6fb9842575b03497$var$Root$6.prototype);
    node2[$6fb9842575b03497$var$my$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $6fb9842575b03497$var$Container$7.rebuild(child);
    });
};
var $6fb9842575b03497$var$Container$6 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$LazyResult$4, $6fb9842575b03497$var$Processor$3;
var $6fb9842575b03497$var$Document$3 = /*#__PURE__*/ function(Container$6) {
    $6fb9842575b03497$var$_inherits(Document23, Container$6);
    function Document23(defaults) {
        var _this;
        _this = Container$6.call(this, $6fb9842575b03497$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document23.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $6fb9842575b03497$var$LazyResult$4(new $6fb9842575b03497$var$Processor$3(), this, opts);
        return lazy.stringify();
    };
    return Document23;
}($6fb9842575b03497$var$Container$6);
$6fb9842575b03497$var$Document$3.registerLazyResult = function(dependant) {
    $6fb9842575b03497$var$LazyResult$4 = dependant;
};
$6fb9842575b03497$var$Document$3.registerProcessor = function(dependant) {
    $6fb9842575b03497$var$Processor$3 = dependant;
};
var $6fb9842575b03497$var$document$1$2 = $6fb9842575b03497$var$Document$3;
$6fb9842575b03497$var$Document$3.default = $6fb9842575b03497$var$Document$3;
var $6fb9842575b03497$var$printed = {};
var $6fb9842575b03497$var$warnOnce$2 = function warnOnce2(message) {
    if ($6fb9842575b03497$var$printed[message]) return;
    $6fb9842575b03497$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $6fb9842575b03497$var$Warning$2 = /*#__PURE__*/ function() {
    function Warning2(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning2.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning2;
}();
var $6fb9842575b03497$var$warning = $6fb9842575b03497$var$Warning$2;
$6fb9842575b03497$var$Warning$2.default = $6fb9842575b03497$var$Warning$2;
var $6fb9842575b03497$var$Warning$1 = $6fb9842575b03497$var$warning;
var $6fb9842575b03497$var$Result$3 = /*#__PURE__*/ function() {
    function Result2(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result2.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $6fb9842575b03497$var$Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $6fb9842575b03497$var$_create_class(Result2, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result2;
}();
var $6fb9842575b03497$var$result = $6fb9842575b03497$var$Result$3;
$6fb9842575b03497$var$Result$3.default = $6fb9842575b03497$var$Result$3;
var $6fb9842575b03497$var$SINGLE_QUOTE = "'".charCodeAt(0);
var $6fb9842575b03497$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
var $6fb9842575b03497$var$BACKSLASH = "\\".charCodeAt(0);
var $6fb9842575b03497$var$SLASH = "/".charCodeAt(0);
var $6fb9842575b03497$var$NEWLINE = "\n".charCodeAt(0);
var $6fb9842575b03497$var$SPACE = " ".charCodeAt(0);
var $6fb9842575b03497$var$FEED = "\f".charCodeAt(0);
var $6fb9842575b03497$var$TAB = "	".charCodeAt(0);
var $6fb9842575b03497$var$CR = "\r".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_SQUARE = "[".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_SQUARE = "]".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_PARENTHESES = "(".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
var $6fb9842575b03497$var$OPEN_CURLY = "{".charCodeAt(0);
var $6fb9842575b03497$var$CLOSE_CURLY = "}".charCodeAt(0);
var $6fb9842575b03497$var$SEMICOLON = ";".charCodeAt(0);
var $6fb9842575b03497$var$ASTERISK = "*".charCodeAt(0);
var $6fb9842575b03497$var$COLON = ":".charCodeAt(0);
var $6fb9842575b03497$var$AT = "@".charCodeAt(0);
var $6fb9842575b03497$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $6fb9842575b03497$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $6fb9842575b03497$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var $6fb9842575b03497$var$RE_HEX_ESCAPE = /[\da-f]/i;
var $6fb9842575b03497$var$tokenize = function tokenizer2(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $6fb9842575b03497$var$NEWLINE:
            case $6fb9842575b03497$var$SPACE:
            case $6fb9842575b03497$var$TAB:
            case $6fb9842575b03497$var$CR:
            case $6fb9842575b03497$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $6fb9842575b03497$var$SPACE || code === $6fb9842575b03497$var$NEWLINE || code === $6fb9842575b03497$var$TAB || code === $6fb9842575b03497$var$CR || code === $6fb9842575b03497$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $6fb9842575b03497$var$OPEN_SQUARE:
            case $6fb9842575b03497$var$CLOSE_SQUARE:
            case $6fb9842575b03497$var$OPEN_CURLY:
            case $6fb9842575b03497$var$CLOSE_CURLY:
            case $6fb9842575b03497$var$COLON:
            case $6fb9842575b03497$var$SEMICOLON:
            case $6fb9842575b03497$var$CLOSE_PARENTHESES:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $6fb9842575b03497$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $6fb9842575b03497$var$SINGLE_QUOTE && n2 !== $6fb9842575b03497$var$DOUBLE_QUOTE && n2 !== $6fb9842575b03497$var$SPACE && n2 !== $6fb9842575b03497$var$NEWLINE && n2 !== $6fb9842575b03497$var$TAB && n2 !== $6fb9842575b03497$var$FEED && n2 !== $6fb9842575b03497$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $6fb9842575b03497$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $6fb9842575b03497$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $6fb9842575b03497$var$SINGLE_QUOTE:
            case $6fb9842575b03497$var$DOUBLE_QUOTE:
                quote = code === $6fb9842575b03497$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $6fb9842575b03497$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $6fb9842575b03497$var$AT:
                $6fb9842575b03497$var$RE_AT_END.lastIndex = pos + 1;
                $6fb9842575b03497$var$RE_AT_END.test(css);
                if ($6fb9842575b03497$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $6fb9842575b03497$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $6fb9842575b03497$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $6fb9842575b03497$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $6fb9842575b03497$var$SLASH && code !== $6fb9842575b03497$var$SPACE && code !== $6fb9842575b03497$var$NEWLINE && code !== $6fb9842575b03497$var$TAB && code !== $6fb9842575b03497$var$CR && code !== $6fb9842575b03497$var$FEED) {
                    next += 1;
                    if ($6fb9842575b03497$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($6fb9842575b03497$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $6fb9842575b03497$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $6fb9842575b03497$var$SLASH && css.charCodeAt(pos + 1) === $6fb9842575b03497$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $6fb9842575b03497$var$RE_WORD_END.lastIndex = pos + 1;
                    $6fb9842575b03497$var$RE_WORD_END.test(css);
                    if ($6fb9842575b03497$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $6fb9842575b03497$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $6fb9842575b03497$var$Container$5 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$AtRule$3 = /*#__PURE__*/ function(Container$5) {
    $6fb9842575b03497$var$_inherits(AtRule2, Container$5);
    function AtRule2(defaults) {
        var _this;
        _this = Container$5.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_append = Container$5.prototype.append).call.apply(_Container$5_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_prepend = Container$5.prototype.prepend).call.apply(_Container$5_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule2;
}($6fb9842575b03497$var$Container$5);
var $6fb9842575b03497$var$atRule = $6fb9842575b03497$var$AtRule$3;
$6fb9842575b03497$var$AtRule$3.default = $6fb9842575b03497$var$AtRule$3;
$6fb9842575b03497$var$Container$5.registerAtRule($6fb9842575b03497$var$AtRule$3);
var $6fb9842575b03497$var$Container$4 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$LazyResult$3, $6fb9842575b03497$var$Processor$2;
var $6fb9842575b03497$var$Root$5 = /*#__PURE__*/ function(Container$4) {
    $6fb9842575b03497$var$_inherits(Root2, Container$4);
    function Root2(defaults) {
        var _this;
        _this = Container$4.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root2.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $6fb9842575b03497$var$LazyResult$3(new $6fb9842575b03497$var$Processor$2(), this, opts);
        return lazy.stringify();
    };
    return Root2;
}($6fb9842575b03497$var$Container$4);
$6fb9842575b03497$var$Root$5.registerLazyResult = function(dependant) {
    $6fb9842575b03497$var$LazyResult$3 = dependant;
};
$6fb9842575b03497$var$Root$5.registerProcessor = function(dependant) {
    $6fb9842575b03497$var$Processor$2 = dependant;
};
var $6fb9842575b03497$var$root = $6fb9842575b03497$var$Root$5;
$6fb9842575b03497$var$Root$5.default = $6fb9842575b03497$var$Root$5;
$6fb9842575b03497$var$Container$4.registerRoot($6fb9842575b03497$var$Root$5);
var $6fb9842575b03497$var$list$2 = {
    comma: function comma(string) {
        return $6fb9842575b03497$var$list$2.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $6fb9842575b03497$var$list$2.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $6fb9842575b03497$var$list_1 = $6fb9842575b03497$var$list$2;
$6fb9842575b03497$var$list$2.default = $6fb9842575b03497$var$list$2;
var $6fb9842575b03497$var$Container$3 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$list$1 = $6fb9842575b03497$var$list_1;
var $6fb9842575b03497$var$Rule$3 = /*#__PURE__*/ function(Container$3) {
    $6fb9842575b03497$var$_inherits(Rule2, Container$3);
    function Rule2(defaults) {
        var _this;
        _this = Container$3.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $6fb9842575b03497$var$_create_class(Rule2, [
        {
            key: "selectors",
            get: function get() {
                return $6fb9842575b03497$var$list$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule2;
}($6fb9842575b03497$var$Container$3);
var $6fb9842575b03497$var$rule = $6fb9842575b03497$var$Rule$3;
$6fb9842575b03497$var$Rule$3.default = $6fb9842575b03497$var$Rule$3;
$6fb9842575b03497$var$Container$3.registerRule($6fb9842575b03497$var$Rule$3);
var $6fb9842575b03497$var$Declaration$2 = $6fb9842575b03497$var$declaration;
var $6fb9842575b03497$var$tokenizer22 = $6fb9842575b03497$var$tokenize;
var $6fb9842575b03497$var$Comment$2 = $6fb9842575b03497$var$comment;
var $6fb9842575b03497$var$AtRule$2 = $6fb9842575b03497$var$atRule;
var $6fb9842575b03497$var$Root$4 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$Rule$2 = $6fb9842575b03497$var$rule;
var $6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $6fb9842575b03497$var$findLastWithPosition(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $6fb9842575b03497$var$Parser$1 = /*#__PURE__*/ function() {
    function Parser2(input2) {
        this.input = input2;
        this.root = new $6fb9842575b03497$var$Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser2.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $6fb9842575b03497$var$AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $6fb9842575b03497$var$Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $6fb9842575b03497$var$tokenizer22(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $6fb9842575b03497$var$Declaration$2();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $6fb9842575b03497$var$findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $6fb9842575b03497$var$Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR[prev] && !$6fb9842575b03497$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $6fb9842575b03497$var$Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser2;
}();
var $6fb9842575b03497$var$parser = $6fb9842575b03497$var$Parser$1;
var $6fb9842575b03497$var$Container$2 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$Parser22 = $6fb9842575b03497$var$parser;
var $6fb9842575b03497$var$Input$2 = $6fb9842575b03497$var$input;
function $6fb9842575b03497$var$parse$3(css, opts) {
    var input2 = new $6fb9842575b03497$var$Input$2(css, opts);
    var parser2 = new $6fb9842575b03497$var$Parser22(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $6fb9842575b03497$var$parse_1 = $6fb9842575b03497$var$parse$3;
$6fb9842575b03497$var$parse$3.default = $6fb9842575b03497$var$parse$3;
$6fb9842575b03497$var$Container$2.registerParse($6fb9842575b03497$var$parse$3);
var $6fb9842575b03497$var$isClean = $6fb9842575b03497$var$symbols.isClean, $6fb9842575b03497$var$my = $6fb9842575b03497$var$symbols.my;
var $6fb9842575b03497$var$MapGenerator$1 = $6fb9842575b03497$var$mapGenerator;
var $6fb9842575b03497$var$stringify$2 = $6fb9842575b03497$var$stringify_1;
var $6fb9842575b03497$var$Container$1 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$Document$2 = $6fb9842575b03497$var$document$1$2;
var $6fb9842575b03497$var$warnOnce$1 = $6fb9842575b03497$var$warnOnce$2;
var $6fb9842575b03497$var$Result$2 = $6fb9842575b03497$var$result;
var $6fb9842575b03497$var$parse$2 = $6fb9842575b03497$var$parse_1;
var $6fb9842575b03497$var$Root$3 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $6fb9842575b03497$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $6fb9842575b03497$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $6fb9842575b03497$var$CHILDREN = 0;
function $6fb9842575b03497$var$isPromise(obj) {
    return (typeof obj === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $6fb9842575b03497$var$getEvents(node2) {
    var key = false;
    var type = $6fb9842575b03497$var$TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $6fb9842575b03497$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $6fb9842575b03497$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $6fb9842575b03497$var$toStack(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $6fb9842575b03497$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $6fb9842575b03497$var$CHILDREN,
        "RootExit"
    ];
    else events = $6fb9842575b03497$var$getEvents(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $6fb9842575b03497$var$cleanMarks(node2) {
    node2[$6fb9842575b03497$var$isClean] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $6fb9842575b03497$var$cleanMarks(i2);
    });
    return node2;
}
var $6fb9842575b03497$var$postcss$2 = {};
var $6fb9842575b03497$var$LazyResult$2 = /*#__PURE__*/ function() {
    function LazyResult2(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $6fb9842575b03497$var$cleanMarks(css);
        else if ($6fb9842575b03497$var$_instanceof(css, LazyResult2) || $6fb9842575b03497$var$_instanceof(css, $6fb9842575b03497$var$Result$2)) {
            root2 = $6fb9842575b03497$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $6fb9842575b03497$var$parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$6fb9842575b03497$var$my]) $6fb9842575b03497$var$Container$1.rebuild(root2);
        }
        this.result = new $6fb9842575b03497$var$Result$2(processor2, root2, opts);
        this.helpers = $6fb9842575b03497$var$_extends({}, $6fb9842575b03497$var$postcss$2, {
            postcss: $6fb9842575b03497$var$postcss$2,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $6fb9842575b03497$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$6fb9842575b03497$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$6fb9842575b03497$var$NOT_VISITORS[event]) {
                    if ($6fb9842575b03497$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $6fb9842575b03497$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$6fb9842575b03497$var$isPromise(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$6fb9842575b03497$var$isClean]) return [
                            3,
                            14
                        ];
                        root2[$6fb9842575b03497$var$isClean] = true;
                        stack = [
                            $6fb9842575b03497$var$toStack(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$6fb9842575b03497$var$isPromise(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $6fb9842575b03497$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($6fb9842575b03497$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $6fb9842575b03497$var$stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $6fb9842575b03497$var$MapGenerator$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($6fb9842575b03497$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$6fb9842575b03497$var$isClean]){
                root2[$6fb9842575b03497$var$isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($6fb9842575b03497$var$isPromise(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$6fb9842575b03497$var$isClean]) {
                    child[$6fb9842575b03497$var$isClean] = true;
                    stack.push($6fb9842575b03497$var$toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $6fb9842575b03497$var$CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$6fb9842575b03497$var$isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$6fb9842575b03497$var$isClean] = true;
        var events = $6fb9842575b03497$var$getEvents(node2);
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $6fb9842575b03497$var$CHILDREN) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$6fb9842575b03497$var$isClean]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $6fb9842575b03497$var$_create_class(LazyResult2, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult2;
}();
$6fb9842575b03497$var$LazyResult$2.registerPostcss = function(dependant) {
    $6fb9842575b03497$var$postcss$2 = dependant;
};
var $6fb9842575b03497$var$lazyResult = $6fb9842575b03497$var$LazyResult$2;
$6fb9842575b03497$var$LazyResult$2.default = $6fb9842575b03497$var$LazyResult$2;
$6fb9842575b03497$var$Root$3.registerLazyResult($6fb9842575b03497$var$LazyResult$2);
$6fb9842575b03497$var$Document$2.registerLazyResult($6fb9842575b03497$var$LazyResult$2);
var $6fb9842575b03497$var$MapGenerator22 = $6fb9842575b03497$var$mapGenerator;
var $6fb9842575b03497$var$stringify$1 = $6fb9842575b03497$var$stringify_1;
var $6fb9842575b03497$var$warnOnce22 = $6fb9842575b03497$var$warnOnce$2;
var $6fb9842575b03497$var$parse$1 = $6fb9842575b03497$var$parse_1;
var $6fb9842575b03497$var$Result$1 = $6fb9842575b03497$var$result;
var $6fb9842575b03497$var$NoWorkResult$1 = /*#__PURE__*/ function() {
    function NoWorkResult2(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $6fb9842575b03497$var$stringify$1;
        this.result = new $6fb9842575b03497$var$Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $6fb9842575b03497$var$MapGenerator22(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $6fb9842575b03497$var$_create_class(NoWorkResult2, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $6fb9842575b03497$var$parse$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult2;
}();
var $6fb9842575b03497$var$noWorkResult = $6fb9842575b03497$var$NoWorkResult$1;
$6fb9842575b03497$var$NoWorkResult$1.default = $6fb9842575b03497$var$NoWorkResult$1;
var $6fb9842575b03497$var$NoWorkResult22 = $6fb9842575b03497$var$noWorkResult;
var $6fb9842575b03497$var$LazyResult$1 = $6fb9842575b03497$var$lazyResult;
var $6fb9842575b03497$var$Document$1 = $6fb9842575b03497$var$document$1$2;
var $6fb9842575b03497$var$Root$2 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$Processor$1 = /*#__PURE__*/ function() {
    function Processor2(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor2.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $6fb9842575b03497$var$NoWorkResult22(this, css, opts);
        else return new $6fb9842575b03497$var$LazyResult$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor2;
}();
var $6fb9842575b03497$var$processor = $6fb9842575b03497$var$Processor$1;
$6fb9842575b03497$var$Processor$1.default = $6fb9842575b03497$var$Processor$1;
$6fb9842575b03497$var$Root$2.registerProcessor($6fb9842575b03497$var$Processor$1);
$6fb9842575b03497$var$Document$1.registerProcessor($6fb9842575b03497$var$Processor$1);
var $6fb9842575b03497$var$Declaration$1 = $6fb9842575b03497$var$declaration;
var $6fb9842575b03497$var$PreviousMap22 = $6fb9842575b03497$var$previousMap;
var $6fb9842575b03497$var$Comment$1 = $6fb9842575b03497$var$comment;
var $6fb9842575b03497$var$AtRule$1 = $6fb9842575b03497$var$atRule;
var $6fb9842575b03497$var$Input$1 = $6fb9842575b03497$var$input;
var $6fb9842575b03497$var$Root$1 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$Rule$1 = $6fb9842575b03497$var$rule;
function $6fb9842575b03497$var$fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $6fb9842575b03497$var$fromJSON$1(n2);
    });
    var ownInputs = json.inputs, defaults = $6fb9842575b03497$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $6fb9842575b03497$var$_extends({}, input2, {
                __proto__: $6fb9842575b03497$var$Input$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $6fb9842575b03497$var$_extends({}, inputHydrated.map, {
                __proto__: $6fb9842575b03497$var$PreviousMap22.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $6fb9842575b03497$var$fromJSON$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $6fb9842575b03497$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $6fb9842575b03497$var$Root$1(defaults);
    else if (defaults.type === "decl") return new $6fb9842575b03497$var$Declaration$1(defaults);
    else if (defaults.type === "rule") return new $6fb9842575b03497$var$Rule$1(defaults);
    else if (defaults.type === "comment") return new $6fb9842575b03497$var$Comment$1(defaults);
    else if (defaults.type === "atrule") return new $6fb9842575b03497$var$AtRule$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $6fb9842575b03497$var$fromJSON_1 = $6fb9842575b03497$var$fromJSON$1;
$6fb9842575b03497$var$fromJSON$1.default = $6fb9842575b03497$var$fromJSON$1;
var $6fb9842575b03497$var$CssSyntaxError22 = $6fb9842575b03497$var$cssSyntaxError;
var $6fb9842575b03497$var$Declaration22 = $6fb9842575b03497$var$declaration;
var $6fb9842575b03497$var$LazyResult22 = $6fb9842575b03497$var$lazyResult;
var $6fb9842575b03497$var$Container22 = $6fb9842575b03497$var$container;
var $6fb9842575b03497$var$Processor22 = $6fb9842575b03497$var$processor;
var $6fb9842575b03497$var$stringify = $6fb9842575b03497$var$stringify_1;
var $6fb9842575b03497$var$fromJSON = $6fb9842575b03497$var$fromJSON_1;
var $6fb9842575b03497$var$Document222 = $6fb9842575b03497$var$document$1$2;
var $6fb9842575b03497$var$Warning22 = $6fb9842575b03497$var$warning;
var $6fb9842575b03497$var$Comment22 = $6fb9842575b03497$var$comment;
var $6fb9842575b03497$var$AtRule22 = $6fb9842575b03497$var$atRule;
var $6fb9842575b03497$var$Result22 = $6fb9842575b03497$var$result;
var $6fb9842575b03497$var$Input22 = $6fb9842575b03497$var$input;
var $6fb9842575b03497$var$parse = $6fb9842575b03497$var$parse_1;
var $6fb9842575b03497$var$list = $6fb9842575b03497$var$list_1;
var $6fb9842575b03497$var$Rule22 = $6fb9842575b03497$var$rule;
var $6fb9842575b03497$var$Root22 = $6fb9842575b03497$var$root;
var $6fb9842575b03497$var$Node22 = $6fb9842575b03497$var$node;
function $6fb9842575b03497$var$postcss() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $6fb9842575b03497$var$Processor22(plugins);
}
$6fb9842575b03497$var$postcss.plugin = function plugin2(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $6fb9842575b03497$var$Processor22().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $6fb9842575b03497$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$6fb9842575b03497$var$postcss.stringify = $6fb9842575b03497$var$stringify;
$6fb9842575b03497$var$postcss.parse = $6fb9842575b03497$var$parse;
$6fb9842575b03497$var$postcss.fromJSON = $6fb9842575b03497$var$fromJSON;
$6fb9842575b03497$var$postcss.list = $6fb9842575b03497$var$list;
$6fb9842575b03497$var$postcss.comment = function(defaults) {
    return new $6fb9842575b03497$var$Comment22(defaults);
};
$6fb9842575b03497$var$postcss.atRule = function(defaults) {
    return new $6fb9842575b03497$var$AtRule22(defaults);
};
$6fb9842575b03497$var$postcss.decl = function(defaults) {
    return new $6fb9842575b03497$var$Declaration22(defaults);
};
$6fb9842575b03497$var$postcss.rule = function(defaults) {
    return new $6fb9842575b03497$var$Rule22(defaults);
};
$6fb9842575b03497$var$postcss.root = function(defaults) {
    return new $6fb9842575b03497$var$Root22(defaults);
};
$6fb9842575b03497$var$postcss.document = function(defaults) {
    return new $6fb9842575b03497$var$Document222(defaults);
};
$6fb9842575b03497$var$postcss.CssSyntaxError = $6fb9842575b03497$var$CssSyntaxError22;
$6fb9842575b03497$var$postcss.Declaration = $6fb9842575b03497$var$Declaration22;
$6fb9842575b03497$var$postcss.Container = $6fb9842575b03497$var$Container22;
$6fb9842575b03497$var$postcss.Processor = $6fb9842575b03497$var$Processor22;
$6fb9842575b03497$var$postcss.Document = $6fb9842575b03497$var$Document222;
$6fb9842575b03497$var$postcss.Comment = $6fb9842575b03497$var$Comment22;
$6fb9842575b03497$var$postcss.Warning = $6fb9842575b03497$var$Warning22;
$6fb9842575b03497$var$postcss.AtRule = $6fb9842575b03497$var$AtRule22;
$6fb9842575b03497$var$postcss.Result = $6fb9842575b03497$var$Result22;
$6fb9842575b03497$var$postcss.Input = $6fb9842575b03497$var$Input22;
$6fb9842575b03497$var$postcss.Rule = $6fb9842575b03497$var$Rule22;
$6fb9842575b03497$var$postcss.Root = $6fb9842575b03497$var$Root22;
$6fb9842575b03497$var$postcss.Node = $6fb9842575b03497$var$Node22;
$6fb9842575b03497$var$LazyResult22.registerPostcss($6fb9842575b03497$var$postcss);
var $6fb9842575b03497$var$postcss_1 = $6fb9842575b03497$var$postcss;
$6fb9842575b03497$var$postcss.default = $6fb9842575b03497$var$postcss;
var $6fb9842575b03497$var$postcss$1 = /* @__PURE__ */ $6fb9842575b03497$var$getDefaultExportFromCjs($6fb9842575b03497$var$postcss_1);
$6fb9842575b03497$var$postcss$1.stringify;
$6fb9842575b03497$var$postcss$1.fromJSON;
$6fb9842575b03497$var$postcss$1.plugin;
$6fb9842575b03497$var$postcss$1.parse;
$6fb9842575b03497$var$postcss$1.list;
$6fb9842575b03497$var$postcss$1.document;
$6fb9842575b03497$var$postcss$1.comment;
$6fb9842575b03497$var$postcss$1.atRule;
$6fb9842575b03497$var$postcss$1.rule;
$6fb9842575b03497$var$postcss$1.decl;
$6fb9842575b03497$var$postcss$1.root;
$6fb9842575b03497$var$postcss$1.CssSyntaxError;
$6fb9842575b03497$var$postcss$1.Declaration;
$6fb9842575b03497$var$postcss$1.Container;
$6fb9842575b03497$var$postcss$1.Processor;
$6fb9842575b03497$var$postcss$1.Document;
$6fb9842575b03497$var$postcss$1.Comment;
$6fb9842575b03497$var$postcss$1.Warning;
$6fb9842575b03497$var$postcss$1.AtRule;
$6fb9842575b03497$var$postcss$1.Result;
$6fb9842575b03497$var$postcss$1.Input;
$6fb9842575b03497$var$postcss$1.Rule;
$6fb9842575b03497$var$postcss$1.Root;
$6fb9842575b03497$var$postcss$1.Node;
var $6fb9842575b03497$var$BaseRRNode = /*#__PURE__*/ function() {
    function BaseRRNode() {
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        $6fb9842575b03497$var$__publicField2(this, "parentElement", null);
        $6fb9842575b03497$var$__publicField2(this, "parentNode", null);
        $6fb9842575b03497$var$__publicField2(this, "ownerDocument");
        $6fb9842575b03497$var$__publicField2(this, "firstChild", null);
        $6fb9842575b03497$var$__publicField2(this, "lastChild", null);
        $6fb9842575b03497$var$__publicField2(this, "previousSibling", null);
        $6fb9842575b03497$var$__publicField2(this, "nextSibling", null);
        $6fb9842575b03497$var$__publicField2(this, "ELEMENT_NODE", 1);
        $6fb9842575b03497$var$__publicField2(this, "TEXT_NODE", 3);
        $6fb9842575b03497$var$__publicField2(this, "nodeType");
        $6fb9842575b03497$var$__publicField2(this, "nodeName");
        $6fb9842575b03497$var$__publicField2(this, "RRNodeType");
    }
    var _proto = BaseRRNode.prototype;
    _proto.contains = function contains(node2) {
        if (!$6fb9842575b03497$var$_instanceof(node2, BaseRRNode)) return false;
        else if (node2.ownerDocument !== this.ownerDocument) return false;
        else if (node2 === this) return true;
        while(node2.parentNode){
            if (node2.parentNode === this) return true;
            node2 = node2.parentNode;
        }
        return false;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.appendChild = function appendChild(_newChild) {
        throw new Error("RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.insertBefore = function insertBefore(_newChild, _refChild) {
        throw new Error("RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.removeChild = function removeChild(_node) {
        throw new Error("RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.");
    };
    _proto.toString = function toString() {
        return "RRNode";
    };
    $6fb9842575b03497$var$_create_class(BaseRRNode, [
        {
            key: "childNodes",
            get: function get() {
                var childNodes2 = [];
                var childIterator = this.firstChild;
                while(childIterator){
                    childNodes2.push(childIterator);
                    childIterator = childIterator.nextSibling;
                }
                return childNodes2;
            }
        }
    ]);
    return BaseRRNode;
}();
var $6fb9842575b03497$var$testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $6fb9842575b03497$var$testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $6fb9842575b03497$var$untaintedBasePrototype = {};
var $6fb9842575b03497$var$isAngularZonePresent = function() {
    return !!globalThis.Zone;
};
function $6fb9842575b03497$var$getUntaintedPrototype(key) {
    if ($6fb9842575b03497$var$untaintedBasePrototype[key]) return $6fb9842575b03497$var$untaintedBasePrototype[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $6fb9842575b03497$var$testableAccessors ? $6fb9842575b03497$var$testableAccessors[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $6fb9842575b03497$var$testableMethods ? $6fb9842575b03497$var$testableMethods[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$6fb9842575b03497$var$isAngularZonePresent()) {
        $6fb9842575b03497$var$untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $6fb9842575b03497$var$untaintedBasePrototype[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $6fb9842575b03497$var$untaintedAccessorCache = {};
function $6fb9842575b03497$var$getUntaintedAccessor(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($6fb9842575b03497$var$untaintedAccessorCache[cacheKey]) return $6fb9842575b03497$var$untaintedAccessorCache[cacheKey].call(instance);
    var untaintedPrototype = $6fb9842575b03497$var$getUntaintedPrototype(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $6fb9842575b03497$var$untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $6fb9842575b03497$var$untaintedMethodCache = {};
function $6fb9842575b03497$var$getUntaintedMethod(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($6fb9842575b03497$var$untaintedMethodCache[cacheKey]) return $6fb9842575b03497$var$untaintedMethodCache[cacheKey].bind(instance);
    var untaintedPrototype = $6fb9842575b03497$var$getUntaintedPrototype(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $6fb9842575b03497$var$untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $6fb9842575b03497$var$childNodes(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Node", n2, "childNodes");
}
function $6fb9842575b03497$var$parentNode(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Node", n2, "parentNode");
}
function $6fb9842575b03497$var$parentElement(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Node", n2, "parentElement");
}
function $6fb9842575b03497$var$textContent(n2) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Node", n2, "textContent");
}
function $6fb9842575b03497$var$contains(n2, other) {
    return $6fb9842575b03497$var$getUntaintedMethod("Node", n2, "contains")(other);
}
function $6fb9842575b03497$var$getRootNode(n2) {
    return $6fb9842575b03497$var$getUntaintedMethod("Node", n2, "getRootNode")();
}
function $6fb9842575b03497$var$host(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $6fb9842575b03497$var$getUntaintedAccessor("ShadowRoot", n2, "host");
}
function $6fb9842575b03497$var$styleSheets(n2) {
    return n2.styleSheets;
}
function $6fb9842575b03497$var$shadowRoot(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $6fb9842575b03497$var$getUntaintedAccessor("Element", n2, "shadowRoot");
}
function $6fb9842575b03497$var$querySelector(n2, selectors) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Element", n2, "querySelector")(selectors);
}
function $6fb9842575b03497$var$querySelectorAll(n2, selectors) {
    return $6fb9842575b03497$var$getUntaintedAccessor("Element", n2, "querySelectorAll")(selectors);
}
function $6fb9842575b03497$var$mutationObserverCtor() {
    return $6fb9842575b03497$var$getUntaintedPrototype("MutationObserver").constructor;
}
var $6fb9842575b03497$var$index = {
    childNodes: $6fb9842575b03497$var$childNodes,
    parentNode: $6fb9842575b03497$var$parentNode,
    parentElement: $6fb9842575b03497$var$parentElement,
    textContent: $6fb9842575b03497$var$textContent,
    contains: $6fb9842575b03497$var$contains,
    getRootNode: $6fb9842575b03497$var$getRootNode,
    host: $6fb9842575b03497$var$host,
    styleSheets: $6fb9842575b03497$var$styleSheets,
    shadowRoot: $6fb9842575b03497$var$shadowRoot,
    querySelector: $6fb9842575b03497$var$querySelector,
    querySelectorAll: $6fb9842575b03497$var$querySelectorAll,
    mutationObserver: $6fb9842575b03497$var$mutationObserverCtor
};
function $6fb9842575b03497$var$on(type, fn, target) {
    if (target === void 0) target = document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var $6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var $6fb9842575b03497$var$_mirror = {
    map: {},
    getId: function getId() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function getNode() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function removeNodeFromMap() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function has() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function reset() {
        console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $6fb9842575b03497$var$_mirror = new Proxy($6fb9842575b03497$var$_mirror, {
    get: function get(target, prop, receiver) {
        if (prop === "map") console.error($6fb9842575b03497$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $6fb9842575b03497$var$throttle(func, wait, options) {
    if (options === void 0) options = {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $6fb9842575b03497$var$hookSetter(target, key, d, isRevoked, win) {
    if (win === void 0) win = window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function set(value) {
            var _this = this;
            setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return $6fb9842575b03497$var$hookSetter(target, key, original || {}, true);
    };
}
function $6fb9842575b03497$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $6fb9842575b03497$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $6fb9842575b03497$var$nowTimestamp = function() {
    return /* @__PURE__ */ new Date().getTime();
};
function $6fb9842575b03497$var$getWindowScroll(win) {
    var _a2, _b, _c, _d;
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc.documentElement.scrollLeft || (doc == null ? void 0 : doc.body) && ((_a2 = $6fb9842575b03497$var$index.parentElement(doc.body)) == null ? void 0 : _a2.scrollLeft) || ((_b = doc == null ? void 0 : doc.body) == null ? void 0 : _b.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc == null ? void 0 : doc.documentElement.scrollTop) || (doc == null ? void 0 : doc.body) && ((_c = $6fb9842575b03497$var$index.parentElement(doc.body)) == null ? void 0 : _c.scrollTop) || ((_d = doc == null ? void 0 : doc.body) == null ? void 0 : _d.scrollTop) || 0
    };
}
function $6fb9842575b03497$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $6fb9842575b03497$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $6fb9842575b03497$var$closestElementOfNode(node2) {
    if (!node2) return null;
    var el = node2.nodeType === node2.ELEMENT_NODE ? node2 : $6fb9842575b03497$var$index.parentElement(node2);
    return el;
}
function $6fb9842575b03497$var$isBlocked(node2, blockClass, blockSelector, checkAncestors) {
    if (!node2) return false;
    var el = $6fb9842575b03497$var$closestElementOfNode(node2);
    if (!el) return false;
    try {
        if (typeof blockClass === "string") {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest("." + blockClass) !== null) return true;
        } else {
            if ($6fb9842575b03497$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e2) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $6fb9842575b03497$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $6fb9842575b03497$var$isIgnored(n2, mirror2, slimDOMOptions) {
    if (n2.tagName === "TITLE" && slimDOMOptions.headTitleMutations) return true;
    return mirror2.getId(n2) === $6fb9842575b03497$var$IGNORED_NODE;
}
function $6fb9842575b03497$var$isAncestorRemoved(target, mirror2) {
    if ($6fb9842575b03497$var$isShadowRoot(target)) return false;
    var id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    var parent = $6fb9842575b03497$var$index.parentNode(target);
    if (parent && parent.nodeType === target.DOCUMENT_NODE) return false;
    if (!parent) return true;
    return $6fb9842575b03497$var$isAncestorRemoved(parent, mirror2);
}
function $6fb9842575b03497$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $6fb9842575b03497$var$polyfill$1(win) {
    if (win === void 0) win = window;
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
}
function $6fb9842575b03497$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $6fb9842575b03497$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $6fb9842575b03497$var$hasShadowRoot(n2) {
    if (!n2) return false;
    if ($6fb9842575b03497$var$_instanceof(n2, $6fb9842575b03497$var$BaseRRNode) && "shadowRoot" in n2) return Boolean(n2.shadowRoot);
    return Boolean($6fb9842575b03497$var$index.shadowRoot(n2));
}
var $6fb9842575b03497$var$StyleSheetMirror = /*#__PURE__*/ function() {
    function StyleSheetMirror() {
        $6fb9842575b03497$var$__publicField(this, "id", 1);
        $6fb9842575b03497$var$__publicField(this, "styleIDMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "idStyleMap", /* @__PURE__ */ new Map());
    }
    var _proto = StyleSheetMirror.prototype;
    _proto.getId = function getId(stylesheet) {
        var _this_styleIDMap_get;
        return (_this_styleIDMap_get = this.styleIDMap.get(stylesheet)) != null ? _this_styleIDMap_get : -1;
    };
    _proto.has = function has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    };
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ _proto.add = function add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        var newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    };
    _proto.getStyle = function getStyle(id) {
        return this.idStyleMap.get(id) || null;
    };
    _proto.reset = function reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    };
    _proto.generateId = function generateId() {
        return this.id++;
    };
    return StyleSheetMirror;
}();
function $6fb9842575b03497$var$getShadowHost(n2) {
    var _a2;
    var shadowHost = null;
    if ("getRootNode" in n2 && ((_a2 = $6fb9842575b03497$var$index.getRootNode(n2)) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && $6fb9842575b03497$var$index.host($6fb9842575b03497$var$index.getRootNode(n2))) shadowHost = $6fb9842575b03497$var$index.host($6fb9842575b03497$var$index.getRootNode(n2));
    return shadowHost;
}
function $6fb9842575b03497$var$getRootShadowHost(n2) {
    var rootShadowHost = n2;
    var shadowHost;
    while(shadowHost = $6fb9842575b03497$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $6fb9842575b03497$var$shadowHostInDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    var shadowHost = $6fb9842575b03497$var$getRootShadowHost(n2);
    return $6fb9842575b03497$var$index.contains(doc, shadowHost);
}
function $6fb9842575b03497$var$inDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    return $6fb9842575b03497$var$index.contains(doc, n2) || $6fb9842575b03497$var$shadowHostInDom(n2);
}
var $6fb9842575b03497$var$EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}($6fb9842575b03497$var$EventType || {});
var $6fb9842575b03497$var$IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}($6fb9842575b03497$var$IncrementalSource || {});
var $6fb9842575b03497$var$MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}($6fb9842575b03497$var$MouseInteractions || {});
var $6fb9842575b03497$var$PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}($6fb9842575b03497$var$PointerTypes || {});
var $6fb9842575b03497$var$CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}($6fb9842575b03497$var$CanvasContext || {});
var $6fb9842575b03497$var$MediaInteractions = /* @__PURE__ */ function(MediaInteractions2) {
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
}($6fb9842575b03497$var$MediaInteractions || {});
var $6fb9842575b03497$var$NodeType = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($6fb9842575b03497$var$NodeType || {});
function $6fb9842575b03497$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
var $6fb9842575b03497$var$DoubleLinkedList = /*#__PURE__*/ function() {
    function DoubleLinkedList() {
        $6fb9842575b03497$var$__publicField(this, "length", 0);
        $6fb9842575b03497$var$__publicField(this, "head", null);
        $6fb9842575b03497$var$__publicField(this, "tail", null);
    }
    var _proto = DoubleLinkedList.prototype;
    _proto.get = function get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        var current = this.head;
        for(var index2 = 0; index2 < position; index2++)current = (current == null ? void 0 : current.next) || null;
        return current;
    };
    _proto.addNode = function addNode(n2) {
        var node2 = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node2;
        if (n2.previousSibling && $6fb9842575b03497$var$isNodeInLinkedList(n2.previousSibling)) {
            var current = n2.previousSibling.__ln.next;
            node2.next = current;
            node2.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node2;
            if (current) current.previous = node2;
        } else if (n2.nextSibling && $6fb9842575b03497$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            var current1 = n2.nextSibling.__ln.previous;
            node2.previous = current1;
            node2.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node2;
            if (current1) current1.next = node2;
        } else {
            if (this.head) this.head.previous = node2;
            node2.next = this.head;
            this.head = node2;
        }
        if (node2.next === null) this.tail = node2;
        this.length++;
    };
    _proto.removeNode = function removeNode(n2) {
        var current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    };
    return DoubleLinkedList;
}();
var $6fb9842575b03497$var$moveKey = function(id, parentId) {
    return id + "@" + parentId;
};
var $6fb9842575b03497$var$MutationBuffer = /*#__PURE__*/ function() {
    function MutationBuffer() {
        var _this = this;
        $6fb9842575b03497$var$__publicField(this, "frozen", false);
        $6fb9842575b03497$var$__publicField(this, "locked", false);
        $6fb9842575b03497$var$__publicField(this, "texts", []);
        $6fb9842575b03497$var$__publicField(this, "attributes", []);
        $6fb9842575b03497$var$__publicField(this, "attributeMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "removes", []);
        $6fb9842575b03497$var$__publicField(this, "mapRemoves", []);
        $6fb9842575b03497$var$__publicField(this, "movedMap", {});
        /**
     * the browser MutationObserver emits multiple mutations after
     * a delay for performance reasons, making tracing added nodes hard
     * in our `processMutations` callback function.
     * For example, if we append an element el_1 into body, and then append
     * another element el_2 into el_1, these two mutations may be passed to the
     * callback function together when the two operations were done.
     * Generally we need to trace child nodes of newly added nodes, but in this
     * case if we count el_2 as el_1's child node in the first mutation record,
     * then we will count el_2 again in the second mutation record which was
     * duplicated.
     * To avoid of duplicate counting added nodes, we use a Set to store
     * added nodes and its child nodes during iterate mutation records. Then
     * collect added nodes from the Set which have no duplicate copy. But
     * this also causes newly added nodes will not be serialized with id ASAP,
     * which means all the id related calculation should be lazy too.
     */ $6fb9842575b03497$var$__publicField(this, "addedSet", /* @__PURE__ */ new Set());
        $6fb9842575b03497$var$__publicField(this, "movedSet", /* @__PURE__ */ new Set());
        $6fb9842575b03497$var$__publicField(this, "droppedSet", /* @__PURE__ */ new Set());
        $6fb9842575b03497$var$__publicField(this, "removesSubTreeCache", /* @__PURE__ */ new Set());
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "blockClass");
        $6fb9842575b03497$var$__publicField(this, "blockSelector");
        $6fb9842575b03497$var$__publicField(this, "maskTextClass");
        $6fb9842575b03497$var$__publicField(this, "maskTextSelector");
        $6fb9842575b03497$var$__publicField(this, "inlineStylesheet");
        $6fb9842575b03497$var$__publicField(this, "maskInputOptions");
        $6fb9842575b03497$var$__publicField(this, "maskTextFn");
        $6fb9842575b03497$var$__publicField(this, "maskInputFn");
        $6fb9842575b03497$var$__publicField(this, "keepIframeSrcFn");
        $6fb9842575b03497$var$__publicField(this, "recordCanvas");
        $6fb9842575b03497$var$__publicField(this, "inlineImages");
        $6fb9842575b03497$var$__publicField(this, "slimDOMOptions");
        $6fb9842575b03497$var$__publicField(this, "dataURLOptions");
        $6fb9842575b03497$var$__publicField(this, "doc");
        $6fb9842575b03497$var$__publicField(this, "mirror");
        $6fb9842575b03497$var$__publicField(this, "iframeManager");
        $6fb9842575b03497$var$__publicField(this, "stylesheetManager");
        $6fb9842575b03497$var$__publicField(this, "shadowDomManager");
        $6fb9842575b03497$var$__publicField(this, "canvasManager");
        $6fb9842575b03497$var$__publicField(this, "processedNodeManager");
        $6fb9842575b03497$var$__publicField(this, "unattachedDoc");
        $6fb9842575b03497$var$__publicField(this, "processMutations", function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        });
        $6fb9842575b03497$var$__publicField(this, "emit", function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = /* @__PURE__ */ new Set();
            var addList = new $6fb9842575b03497$var$DoubleLinkedList();
            var getNextId = function(n2) {
                var ns = n2;
                var nextId = $6fb9842575b03497$var$IGNORED_NODE;
                while(nextId === $6fb9842575b03497$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n2) {
                var parent = $6fb9842575b03497$var$index.parentNode(n2);
                if (!parent || !$6fb9842575b03497$var$inDom(n2)) return;
                var cssCaptured = false;
                if (n2.nodeType === Node.TEXT_NODE) {
                    var parentTag = parent.tagName;
                    if (parentTag === "TEXTAREA") return;
                    else if (parentTag === "STYLE" && _this.addedSet.has(parent)) cssCaptured = true;
                }
                var parentId = $6fb9842575b03497$var$isShadowRoot(parent) ? _this.mirror.getId($6fb9842575b03497$var$getShadowHost(n2)) : _this.mirror.getId(parent);
                var nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                var sn = $6fb9842575b03497$var$serializeNodeWithId(n2, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskTextClass: _this.maskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if ($6fb9842575b03497$var$isSerializedIframe(currentN, _this.mirror)) _this.iframeManager.addIframe(currentN);
                        if ($6fb9842575b03497$var$isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if ($6fb9842575b03497$var$hasShadowRoot(n2)) _this.shadowDomManager.addShadowRoot($6fb9842575b03497$var$index.shadowRoot(n2), _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    cssCaptured: cssCaptured
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(_this.movedSet), _step; !(_step = _iterator()).done;){
                var n2 = _step.value;
                if ($6fb9842575b03497$var$isParentRemoved(_this.removesSubTreeCache, n2, _this.mirror) && !_this.movedSet.has($6fb9842575b03497$var$index.parentNode(n2))) continue;
                pushAdd(n2);
            }
            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(_this.addedSet), _step1; !(_step1 = _iterator1()).done;){
                var n21 = _step1.value;
                if (!$6fb9842575b03497$var$isAncestorInSet(_this.droppedSet, n21) && !$6fb9842575b03497$var$isParentRemoved(_this.removesSubTreeCache, n21, _this.mirror)) pushAdd(n21);
                else if ($6fb9842575b03497$var$isAncestorInSet(_this.movedSet, n21)) pushAdd(n21);
                else _this.droppedSet.add(n21);
            }
            var candidate = null;
            while(addList.length){
                var node2 = null;
                if (candidate) {
                    var parentId = _this.mirror.getId($6fb9842575b03497$var$index.parentNode(candidate.value));
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node2 = candidate;
                }
                if (!node2) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId($6fb9842575b03497$var$index.parentNode(_node.value));
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node2 = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                var parent = $6fb9842575b03497$var$index.parentNode(unhandledNode);
                                if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = $6fb9842575b03497$var$index.host(parent);
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node2 = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node2) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node2.previous;
                addList.removeNode(node2.value);
                pushAdd(node2.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    var n2 = text.node;
                    var parent = $6fb9842575b03497$var$index.parentNode(n2);
                    if (parent && parent.tagName === "TEXTAREA") _this.genTextAreaValueMutation(parent);
                    return {
                        id: _this.mirror.getId(n2),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === "string") {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = /* @__PURE__ */ new WeakMap();
            _this.removes = [];
            _this.addedSet = /* @__PURE__ */ new Set();
            _this.movedSet = /* @__PURE__ */ new Set();
            _this.droppedSet = /* @__PURE__ */ new Set();
            _this.removesSubTreeCache = /* @__PURE__ */ new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        });
        $6fb9842575b03497$var$__publicField(this, "genTextAreaValueMutation", function(textarea) {
            var item = _this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                _this.attributes.push(item);
                _this.attributeMap.set(textarea, item);
            }
            item.attributes.value = Array.from($6fb9842575b03497$var$index.childNodes(textarea), function(cn) {
                return $6fb9842575b03497$var$index.textContent(cn) || "";
            }).join("");
        });
        $6fb9842575b03497$var$__publicField(this, "processMutation", function(m) {
            if ($6fb9842575b03497$var$isIgnored(m.target, _this.mirror, _this.slimDOMOptions)) return;
            switch(m.type){
                case "characterData":
                    var value = $6fb9842575b03497$var$index.textContent(m.target);
                    if (!$6fb9842575b03497$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) && value !== m.oldValue) _this.texts.push({
                        value: $6fb9842575b03497$var$needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, true) && value ? _this.maskTextFn ? _this.maskTextFn(value, $6fb9842575b03497$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                        node: m.target
                    });
                    break;
                case "attributes":
                    var target = m.target;
                    var attributeName = m.attributeName;
                    var value1 = m.target.getAttribute(attributeName);
                    if (attributeName === "value") {
                        var type = $6fb9842575b03497$var$getInputType(target);
                        value1 = $6fb9842575b03497$var$maskInputValue({
                            element: target,
                            maskInputOptions: _this.maskInputOptions,
                            tagName: target.tagName,
                            type: type,
                            value: value1,
                            maskInputFn: _this.maskInputFn
                        });
                    }
                    if ($6fb9842575b03497$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || value1 === m.oldValue) return;
                    var item = _this.attributeMap.get(m.target);
                    if (target.tagName === "IFRAME" && attributeName === "src" && !_this.keepIframeSrcFn(value1)) {
                        if (!target.contentDocument) attributeName = "rr_src";
                        else return;
                    }
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                            styleDiff: {},
                            _unchangedStyles: {}
                        };
                        _this.attributes.push(item);
                        _this.attributeMap.set(m.target, item);
                    }
                    if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                    if (!$6fb9842575b03497$var$ignoreAttribute(target.tagName, attributeName)) {
                        item.attributes[attributeName] = $6fb9842575b03497$var$transformAttribute(_this.doc, $6fb9842575b03497$var$toLowerCase(target.tagName), $6fb9842575b03497$var$toLowerCase(attributeName), value1);
                        if (attributeName === "style") {
                            if (!_this.unattachedDoc) try {
                                _this.unattachedDoc = document.implementation.createHTMLDocument();
                            } catch (e2) {
                                _this.unattachedDoc = _this.doc;
                            }
                            var old = _this.unattachedDoc.createElement("span");
                            if (m.oldValue) old.setAttribute("style", m.oldValue);
                            for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(Array.from(target.style)), _step; !(_step = _iterator()).done;){
                                var pname = _step.value;
                                var newValue = target.style.getPropertyValue(pname);
                                var newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === "") item.styleDiff[pname] = newValue;
                                    else item.styleDiff[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                } else item._unchangedStyles[pname] = [
                                    newValue,
                                    newPriority
                                ];
                            }
                            for(var _iterator1 = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(Array.from(old.style)), _step1; !(_step1 = _iterator1()).done;){
                                var pname1 = _step1.value;
                                if (target.style.getPropertyValue(pname1) === "") item.styleDiff[pname1] = false;
                            }
                        } else if (attributeName === "open" && target.tagName === "DIALOG") {
                            if (target.matches("dialog:modal")) item.attributes["rr_open_mode"] = "modal";
                            else item.attributes["rr_open_mode"] = "non-modal";
                        }
                    }
                    break;
                case "childList":
                    if ($6fb9842575b03497$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, true)) return;
                    if (m.target.tagName === "TEXTAREA") {
                        _this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach(function(n2) {
                        return _this.genAdds(n2, m.target);
                    });
                    m.removedNodes.forEach(function(n2) {
                        var nodeId = _this.mirror.getId(n2);
                        var parentId = $6fb9842575b03497$var$isShadowRoot(m.target) ? _this.mirror.getId($6fb9842575b03497$var$index.host(m.target)) : _this.mirror.getId(m.target);
                        if ($6fb9842575b03497$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || $6fb9842575b03497$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions) || !$6fb9842575b03497$var$isSerialized(n2, _this.mirror)) return;
                        if (_this.addedSet.has(n2)) {
                            $6fb9842575b03497$var$deepDelete(_this.addedSet, n2);
                            _this.droppedSet.add(n2);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($6fb9842575b03497$var$isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n2) && _this.movedMap[$6fb9842575b03497$var$moveKey(nodeId, parentId)]) $6fb9842575b03497$var$deepDelete(_this.movedSet, n2);
                        else {
                            _this.removes.push({
                                parentId: parentId,
                                id: nodeId,
                                isShadow: $6fb9842575b03497$var$isShadowRoot(m.target) && $6fb9842575b03497$var$isNativeShadowDom(m.target) ? true : void 0
                            });
                            $6fb9842575b03497$var$processRemoves(n2, _this.removesSubTreeCache);
                        }
                        _this.mapRemoves.push(n2);
                    });
                    break;
            }
        });
        /**
     * Make sure you check if `n`'s parent is blocked before calling this function
     * */ $6fb9842575b03497$var$__publicField(this, "genAdds", function(n2, target) {
            if (_this.processedNodeManager.inOtherBuffer(n2, _this)) return;
            if (_this.addedSet.has(n2) || _this.movedSet.has(n2)) return;
            if (_this.mirror.hasNode(n2)) {
                if ($6fb9842575b03497$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions)) return;
                _this.movedSet.add(n2);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[$6fb9842575b03497$var$moveKey(_this.mirror.getId(n2), targetId)] = true;
            } else {
                _this.addedSet.add(n2);
                _this.droppedSet.delete(n2);
            }
            if (!$6fb9842575b03497$var$isBlocked(n2, _this.blockClass, _this.blockSelector, false)) {
                $6fb9842575b03497$var$index.childNodes(n2).forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if ($6fb9842575b03497$var$hasShadowRoot(n2)) $6fb9842575b03497$var$index.childNodes($6fb9842575b03497$var$index.shadowRoot(n2)).forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n2);
                });
            }
        });
    }
    var _proto = MutationBuffer.prototype;
    _proto.init = function init(options) {
        var _this = this;
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "maskTextClass",
            "maskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach(function(key) {
            _this[key] = options[key];
        });
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    };
    _proto.isFrozen = function isFrozen() {
        return this.frozen;
    };
    _proto.lock = function lock() {
        this.locked = true;
        this.canvasManager.lock();
    };
    _proto.unlock = function unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    };
    _proto.reset = function reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    };
    return MutationBuffer;
}();
function $6fb9842575b03497$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    $6fb9842575b03497$var$index.childNodes(n2).forEach(function(childN) {
        return $6fb9842575b03497$var$deepDelete(addsSet, childN);
    });
}
function $6fb9842575b03497$var$processRemoves(n2, cache) {
    var queue = [
        n2
    ];
    while(queue.length){
        var next = queue.pop();
        if (cache.has(next)) continue;
        cache.add(next);
        $6fb9842575b03497$var$index.childNodes(next).forEach(function(n22) {
            return queue.push(n22);
        });
    }
    return;
}
function $6fb9842575b03497$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.size === 0) return false;
    return $6fb9842575b03497$var$_isParentRemoved(removes, n2);
}
function $6fb9842575b03497$var$_isParentRemoved(removes, n2, _mirror2) {
    var node2 = $6fb9842575b03497$var$index.parentNode(n2);
    if (!node2) return false;
    return removes.has(node2);
}
function $6fb9842575b03497$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $6fb9842575b03497$var$_isAncestorInSet(set, n2);
}
function $6fb9842575b03497$var$_isAncestorInSet(set, n2) {
    var parent = $6fb9842575b03497$var$index.parentNode(n2);
    if (!parent) return false;
    if (set.has(parent)) return true;
    return $6fb9842575b03497$var$_isAncestorInSet(set, parent);
}
var $6fb9842575b03497$var$errorHandler;
function $6fb9842575b03497$var$registerErrorHandler(handler) {
    $6fb9842575b03497$var$errorHandler = handler;
}
function $6fb9842575b03497$var$unregisterErrorHandler() {
    $6fb9842575b03497$var$errorHandler = void 0;
}
var $6fb9842575b03497$var$callbackWrapper = function(cb) {
    if (!$6fb9842575b03497$var$errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
        try {
            return cb.apply(void 0, [].concat(rest));
        } catch (error) {
            if ($6fb9842575b03497$var$errorHandler && $6fb9842575b03497$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
var $6fb9842575b03497$var$mutationBuffers = [];
function $6fb9842575b03497$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e) {}
    return event && event.target;
}
function $6fb9842575b03497$var$initMutationObserver(options, rootEl) {
    var mutationBuffer = new $6fb9842575b03497$var$MutationBuffer();
    $6fb9842575b03497$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var observer = new ($6fb9842575b03497$var$mutationObserverCtor())($6fb9842575b03497$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $6fb9842575b03497$var$initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror2 = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = $6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function(evt) {
        var target = $6fb9842575b03497$var$getEventTarget(evt);
        var _ref = $6fb9842575b03497$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = $6fb9842575b03497$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $6fb9842575b03497$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && $6fb9842575b03497$var$_instanceof(evt, DragEvent) ? $6fb9842575b03497$var$IncrementalSource.Drag : $6fb9842575b03497$var$_instanceof(evt, MouseEvent) ? $6fb9842575b03497$var$IncrementalSource.MouseMove : $6fb9842575b03497$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        $6fb9842575b03497$var$on("mousemove", updatePosition, doc),
        $6fb9842575b03497$var$on("touchmove", updatePosition, doc),
        $6fb9842575b03497$var$on("drag", updatePosition, doc)
    ];
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = $6fb9842575b03497$var$getEventTarget(event);
            if ($6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $6fb9842575b03497$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $6fb9842575b03497$var$PointerTypes.Touch) {
                    if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $6fb9842575b03497$var$PointerTypes.Pen;
            } else if ($6fb9842575b03497$var$legacy_isTouchEvent(event)) pointerType = $6fb9842575b03497$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $6fb9842575b03497$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $6fb9842575b03497$var$PointerTypes.Mouse) pointerType = null;
            } else if ($6fb9842575b03497$var$MouseInteractions[eventKey] === $6fb9842575b03497$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e2 = $6fb9842575b03497$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            var id = mirror2.getId(target);
            var clientX = e2.clientX, clientY = e2.clientY;
            $6fb9842575b03497$var$callbackWrapper(mouseInteractionCb)($6fb9842575b03497$var$_extends({
                type: $6fb9842575b03497$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($6fb9842575b03497$var$MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = $6fb9842575b03497$var$toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch($6fb9842575b03497$var$MouseInteractions[eventKey]){
            case $6fb9842575b03497$var$MouseInteractions.MouseDown:
            case $6fb9842575b03497$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $6fb9842575b03497$var$MouseInteractions.TouchStart:
            case $6fb9842575b03497$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($6fb9842575b03497$var$on(eventName, handler, doc));
    });
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    var updatePosition = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function(evt) {
        var target = $6fb9842575b03497$var$getEventTarget(evt);
        if (!target || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
        var id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = $6fb9842575b03497$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $6fb9842575b03497$var$on("scroll", updatePosition, doc);
}
function $6fb9842575b03497$var$initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb;
    var win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function() {
        var height = $6fb9842575b03497$var$getWindowHeight();
        var width = $6fb9842575b03497$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $6fb9842575b03497$var$on("resize", updateDimension, win);
}
var $6fb9842575b03497$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
var $6fb9842575b03497$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $6fb9842575b03497$var$initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput;
    function eventHandler(event) {
        var target = $6fb9842575b03497$var$getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && target.tagName;
        if (target && tagName === "OPTION") target = $6fb9842575b03497$var$index.parentElement(target);
        if (!target || !tagName || $6fb9842575b03497$var$INPUT_TAGS.indexOf(tagName) < 0 || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        var text = target.value;
        var isChecked = false;
        var type = $6fb9842575b03497$var$getInputType(target) || "";
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $6fb9842575b03497$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function(el) {
            if (el !== target) {
                var text2 = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        var lastInputValue = $6fb9842575b03497$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $6fb9842575b03497$var$lastInputValueMap.set(target, v2);
            var id = mirror2.getId(target);
            $6fb9842575b03497$var$callbackWrapper(inputCb)($6fb9842575b03497$var$_extends({}, v2, {
                id: id
            }));
        }
    }
    var events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    var handlers = events.map(function(eventName) {
        return $6fb9842575b03497$var$on(eventName, $6fb9842575b03497$var$callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        var _handlers;
        (_handlers = handlers).push.apply(_handlers, [].concat(hookProperties.map(function(p) {
            return $6fb9842575b03497$var$hookSetter(p[0], p[1], {
                set: function set() {
                    $6fb9842575b03497$var$callbackWrapper(eventHandler)({
                        target: this,
                        isTrusted: false
                    });
                }
            }, false, currentWindow);
        })));
    }
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$getNestedCSSRulePositions(rule2) {
    var positions = [];
    function recurse(childRule, pos) {
        if ($6fb9842575b03497$var$hasNestedCSSRule("CSSGroupingRule") && $6fb9842575b03497$var$_instanceof(childRule.parentRule, CSSGroupingRule) || $6fb9842575b03497$var$hasNestedCSSRule("CSSMediaRule") && $6fb9842575b03497$var$_instanceof(childRule.parentRule, CSSMediaRule) || $6fb9842575b03497$var$hasNestedCSSRule("CSSSupportsRule") && $6fb9842575b03497$var$_instanceof(childRule.parentRule, CSSSupportsRule) || $6fb9842575b03497$var$hasNestedCSSRule("CSSConditionRule") && $6fb9842575b03497$var$_instanceof(childRule.parentRule, CSSConditionRule)) {
            var rules2 = Array.from(childRule.parentRule.cssRules);
            var index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        } else if (childRule.parentStyleSheet) {
            var rules21 = Array.from(childRule.parentStyleSheet.cssRules);
            var index21 = rules21.indexOf(childRule);
            pos.unshift(index21);
        }
        return pos;
    }
    return recurse(rule2, positions);
}
function $6fb9842575b03497$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $6fb9842575b03497$var$initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var rule2 = argumentsList[0], index2 = argumentsList[1];
            var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule2,
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.addRule = function(selector, styleBlock, index2) {
        if (index2 === void 0) index2 = this.cssRules.length;
        var rule2 = selector + " { " + styleBlock + " }";
        return win.CSSStyleSheet.prototype.insertRule.apply(this, [
            rule2,
            index2
        ]);
    };
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var index2 = argumentsList[0];
            var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.removeRule = function(index2) {
        return win.CSSStyleSheet.prototype.deleteRule.apply(this, [
            index2
        ]);
    };
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($6fb9842575b03497$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var typeKey = param[0], type = param[1];
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var rule2 = argumentsList[0], index2 = argumentsList[1];
                var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule2,
                            index: [].concat($6fb9842575b03497$var$getNestedCSSRulePositions(thisArg), [
                                index2 || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var index2 = argumentsList[0];
                var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [].concat($6fb9842575b03497$var$getNestedCSSRulePositions(thisArg), [
                                index2
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $6fb9842575b03497$var$callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var typeKey = param[0], type = param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $6fb9842575b03497$var$initAdoptedStyleSheetObserver(param, host2) {
    var mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var _a2, _b, _c;
    var hostId = null;
    if (host2.nodeName === "#document") hostId = mirror2.getId(host2);
    else hostId = mirror2.getId($6fb9842575b03497$var$index.host(host2));
    var patchTarget = host2.nodeName === "#document" ? (_a2 = host2.defaultView) == null ? void 0 : _a2.Document : (_c = (_b = host2.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.ShadowRoot;
    var originalPropertyDescriptor = (patchTarget == null ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget == null ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host2, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function get() {
            var _a3;
            return (_a3 = originalPropertyDescriptor.get) == null ? void 0 : _a3.call(this);
        },
        set: function set(sheets) {
            var _a3;
            var result2 = (_a3 = originalPropertyDescriptor.set) == null ? void 0 : _a3.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result2;
        }
    });
    return $6fb9842575b03497$var$callbackWrapper(function() {
        Object.defineProperty(host2, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $6fb9842575b03497$var$initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror2 = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0], value = argumentsList[1], priority = argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $6fb9842575b03497$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $6fb9842575b03497$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = $6fb9842575b03497$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $6fb9842575b03497$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $6fb9842575b03497$var$callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $6fb9842575b03497$var$initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, mirror2 = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = $6fb9842575b03497$var$callbackWrapper(function(type) {
        return $6fb9842575b03497$var$throttle($6fb9842575b03497$var$callbackWrapper(function(event) {
            var target = $6fb9842575b03497$var$getEventTarget(event);
            if (!target || $6fb9842575b03497$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate, loop = target.loop;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500);
    });
    var handlers = [
        $6fb9842575b03497$var$on("play", handler($6fb9842575b03497$var$MediaInteractions.Play), doc),
        $6fb9842575b03497$var$on("pause", handler($6fb9842575b03497$var$MediaInteractions.Pause), doc),
        $6fb9842575b03497$var$on("seeked", handler($6fb9842575b03497$var$MediaInteractions.Seeked), doc),
        $6fb9842575b03497$var$on("volumechange", handler($6fb9842575b03497$var$MediaInteractions.VolumeChange), doc),
        $6fb9842575b03497$var$on("ratechange", handler($6fb9842575b03497$var$MediaInteractions.RateChange), doc)
    ];
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = /* @__PURE__ */ new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = $6fb9842575b03497$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($6fb9842575b03497$var$callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $6fb9842575b03497$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$initSelectionObserver(param) {
    var doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = $6fb9842575b03497$var$callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && (selection == null ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i2 = 0; i2 < count; i2++){
            var range = selection.getRangeAt(i2);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = $6fb9842575b03497$var$isBlocked(startContainer, blockClass, blockSelector, true) || $6fb9842575b03497$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $6fb9842575b03497$var$on("selectionchange", updateSelection);
}
function $6fb9842575b03497$var$initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = $6fb9842575b03497$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {
                console.warn("Custom element callback failed for " + name);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $6fb9842575b03497$var$mergeHooks(o2, hooks) {
    var mutationCb = o2.mutationCb, mousemoveCb = o2.mousemoveCb, mouseInteractionCb = o2.mouseInteractionCb, scrollCb = o2.scrollCb, viewportResizeCb = o2.viewportResizeCb, inputCb = o2.inputCb, mediaInteractionCb = o2.mediaInteractionCb, styleSheetRuleCb = o2.styleSheetRuleCb, styleDeclarationCb = o2.styleDeclarationCb, canvasMutationCb = o2.canvasMutationCb, fontCb = o2.fontCb, selectionCb = o2.selectionCb, customElementCb = o2.customElementCb;
    o2.mutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mutation) {
            var _hooks;
            (_hooks = hooks).mutation.apply(_hooks, [].concat(p));
        }
        mutationCb.apply(void 0, [].concat(p));
    };
    o2.mousemoveCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mousemove) {
            var _hooks;
            (_hooks = hooks).mousemove.apply(_hooks, [].concat(p));
        }
        mousemoveCb.apply(void 0, [].concat(p));
    };
    o2.mouseInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mouseInteraction) {
            var _hooks;
            (_hooks = hooks).mouseInteraction.apply(_hooks, [].concat(p));
        }
        mouseInteractionCb.apply(void 0, [].concat(p));
    };
    o2.scrollCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.scroll) {
            var _hooks;
            (_hooks = hooks).scroll.apply(_hooks, [].concat(p));
        }
        scrollCb.apply(void 0, [].concat(p));
    };
    o2.viewportResizeCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.viewportResize) {
            var _hooks;
            (_hooks = hooks).viewportResize.apply(_hooks, [].concat(p));
        }
        viewportResizeCb.apply(void 0, [].concat(p));
    };
    o2.inputCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.input) {
            var _hooks;
            (_hooks = hooks).input.apply(_hooks, [].concat(p));
        }
        inputCb.apply(void 0, [].concat(p));
    };
    o2.mediaInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mediaInteaction) {
            var _hooks;
            (_hooks = hooks).mediaInteaction.apply(_hooks, [].concat(p));
        }
        mediaInteractionCb.apply(void 0, [].concat(p));
    };
    o2.styleSheetRuleCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleSheetRule) {
            var _hooks;
            (_hooks = hooks).styleSheetRule.apply(_hooks, [].concat(p));
        }
        styleSheetRuleCb.apply(void 0, [].concat(p));
    };
    o2.styleDeclarationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleDeclaration) {
            var _hooks;
            (_hooks = hooks).styleDeclaration.apply(_hooks, [].concat(p));
        }
        styleDeclarationCb.apply(void 0, [].concat(p));
    };
    o2.canvasMutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.canvasMutation) {
            var _hooks;
            (_hooks = hooks).canvasMutation.apply(_hooks, [].concat(p));
        }
        canvasMutationCb.apply(void 0, [].concat(p));
    };
    o2.fontCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.font) {
            var _hooks;
            (_hooks = hooks).font.apply(_hooks, [].concat(p));
        }
        fontCb.apply(void 0, [].concat(p));
    };
    o2.selectionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.selection) {
            var _hooks;
            (_hooks = hooks).selection.apply(_hooks, [].concat(p));
        }
        selectionCb.apply(void 0, [].concat(p));
    };
    o2.customElementCb = function() {
        for(var _len = arguments.length, c2 = new Array(_len), _key = 0; _key < _len; _key++)c2[_key] = arguments[_key];
        if (hooks.customElement) {
            var _hooks;
            (_hooks = hooks).customElement.apply(_hooks, [].concat(c2));
        }
        customElementCb.apply(void 0, [].concat(c2));
    };
}
function $6fb9842575b03497$var$initObservers(o2, hooks) {
    if (hooks === void 0) hooks = {};
    var currentWindow = o2.doc.defaultView;
    if (!currentWindow) return function() {};
    $6fb9842575b03497$var$mergeHooks(o2, hooks);
    var mutationObserver;
    if (o2.recordDOM) mutationObserver = $6fb9842575b03497$var$initMutationObserver(o2, o2.doc);
    var mousemoveHandler = $6fb9842575b03497$var$initMoveObserver(o2);
    var mouseInteractionHandler = $6fb9842575b03497$var$initMouseInteractionObserver(o2);
    var scrollHandler = $6fb9842575b03497$var$initScrollObserver(o2);
    var viewportResizeHandler = $6fb9842575b03497$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    var inputHandler = $6fb9842575b03497$var$initInputObserver(o2);
    var mediaInteractionHandler = $6fb9842575b03497$var$initMediaInteractionObserver(o2);
    var styleSheetObserver = function() {};
    var adoptedStyleSheetObserver = function() {};
    var styleDeclarationObserver = function() {};
    var fontObserver = function() {};
    if (o2.recordDOM) {
        styleSheetObserver = $6fb9842575b03497$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $6fb9842575b03497$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $6fb9842575b03497$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $6fb9842575b03497$var$initFontObserver(o2);
    }
    var selectionObserver = $6fb9842575b03497$var$initSelectionObserver(o2);
    var customElementObserver = $6fb9842575b03497$var$initCustomElementObserver(o2);
    var pluginHandlers = [];
    for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(o2.plugins), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        pluginHandlers.push(plugin3.observer(plugin3.callback, currentWindow, plugin3.options));
    }
    return $6fb9842575b03497$var$callbackWrapper(function() {
        $6fb9842575b03497$var$mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver == null || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function $6fb9842575b03497$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $6fb9842575b03497$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
var $6fb9842575b03497$var$CrossOriginIframeMirror = /*#__PURE__*/ function() {
    function CrossOriginIframeMirror(generateIdFn) {
        $6fb9842575b03497$var$__publicField(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap());
        this.generateIdFn = generateIdFn;
    }
    var _proto = CrossOriginIframeMirror.prototype;
    _proto.getId = function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        var id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    };
    _proto.getIds = function getIds(iframe, remoteId) {
        var _this = this;
        var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map(function(id) {
            return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
        });
    };
    _proto.getRemoteId = function getRemoteId(iframe, id, map) {
        var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        var remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    };
    _proto.getRemoteIds = function getRemoteIds(iframe, ids) {
        var _this = this;
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map(function(id) {
            return _this.getRemoteId(iframe, id, remoteIdToIdMap);
        });
    };
    _proto.reset = function reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    };
    _proto.getIdToRemoteIdMap = function getIdToRemoteIdMap(iframe) {
        var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    };
    _proto.getRemoteIdToIdMap = function getRemoteIdToIdMap(iframe) {
        var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    };
    return CrossOriginIframeMirror;
}();
var $6fb9842575b03497$var$IframeManager = /*#__PURE__*/ function() {
    function IframeManager(options) {
        $6fb9842575b03497$var$__publicField(this, "iframes", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "crossOriginIframeMirror", new $6fb9842575b03497$var$CrossOriginIframeMirror($6fb9842575b03497$var$genId));
        $6fb9842575b03497$var$__publicField(this, "crossOriginIframeStyleMirror");
        $6fb9842575b03497$var$__publicField(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "mirror");
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "wrappedEmit");
        $6fb9842575b03497$var$__publicField(this, "loadListener");
        $6fb9842575b03497$var$__publicField(this, "stylesheetManager");
        $6fb9842575b03497$var$__publicField(this, "recordCrossOriginIframes");
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $6fb9842575b03497$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    var _proto = IframeManager.prototype;
    _proto.addIframe = function addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    };
    _proto.addLoadListener = function addLoadListener(cb) {
        this.loadListener = cb;
    };
    _proto.attachIframe = function attachIframe(iframeEl, childSn) {
        var _a2, _b;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) (_a2 = iframeEl.contentWindow) == null || _a2.addEventListener("message", this.handleMessage.bind(this));
        (_b = this.loadListener) == null || _b.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    };
    _proto.handleMessage = function handleMessage(message) {
        var crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        var iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        var iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    };
    _proto.transformCrossOriginEvent = function transformCrossOriginEvent(iframeEl, e2) {
        var _this = this;
        var _a2;
        switch(e2.type){
            case $6fb9842575b03497$var$EventType.FullSnapshot:
                this.crossOriginIframeMirror.reset(iframeEl);
                this.crossOriginIframeStyleMirror.reset(iframeEl);
                this.replaceIdOnNode(e2.data.node, iframeEl);
                var rootId = e2.data.node.id;
                this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                this.patchRootIdOnNode(e2.data.node, rootId);
                return {
                    timestamp: e2.timestamp,
                    type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                    data: {
                        source: $6fb9842575b03497$var$IncrementalSource.Mutation,
                        adds: [
                            {
                                parentId: this.mirror.getId(iframeEl),
                                nextId: null,
                                node: e2.data.node
                            }
                        ],
                        removes: [],
                        texts: [],
                        attributes: [],
                        isAttachIframe: true
                    }
                };
            case $6fb9842575b03497$var$EventType.Meta:
            case $6fb9842575b03497$var$EventType.Load:
            case $6fb9842575b03497$var$EventType.DomContentLoaded:
                return false;
            case $6fb9842575b03497$var$EventType.Plugin:
                return e2;
            case $6fb9842575b03497$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $6fb9842575b03497$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $6fb9842575b03497$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            _this.replaceIdOnNode(n2.node, iframeEl);
                            var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && _this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.Drag:
                    case $6fb9842575b03497$var$IncrementalSource.TouchMove:
                    case $6fb9842575b03497$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach(function(p) {
                            _this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.ViewportResize:
                        return false;
                    case $6fb9842575b03497$var$IncrementalSource.MediaInteraction:
                    case $6fb9842575b03497$var$IncrementalSource.MouseInteraction:
                    case $6fb9842575b03497$var$IncrementalSource.Scroll:
                    case $6fb9842575b03497$var$IncrementalSource.CanvasMutation:
                    case $6fb9842575b03497$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.StyleSheetRule:
                    case $6fb9842575b03497$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.Font:
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach(function(range) {
                            _this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $6fb9842575b03497$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        (_a2 = e2.data.styles) == null || _a2.forEach(function(style) {
                            _this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    };
    _proto.replace = function replace(iframeMirror, obj, iframeEl, keys) {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(keys), _step; !(_step = _iterator()).done;){
            var key = _step.value;
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    };
    _proto.replaceIds = function replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    };
    _proto.replaceStyleIds = function replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    };
    _proto.replaceIdOnNode = function replaceIdOnNode(node2, iframeEl) {
        var _this = this;
        this.replaceIds(node2, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.replaceIdOnNode(child, iframeEl);
        });
    };
    _proto.patchRootIdOnNode = function patchRootIdOnNode(node2, rootId) {
        var _this = this;
        if (node2.type !== $6fb9842575b03497$var$NodeType.Document && !node2.rootId) node2.rootId = rootId;
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.patchRootIdOnNode(child, rootId);
        });
    };
    return IframeManager;
}();
var $6fb9842575b03497$var$ShadowDomManager = /*#__PURE__*/ function() {
    function ShadowDomManager(options) {
        $6fb9842575b03497$var$__publicField(this, "shadowDoms", /* @__PURE__ */ new WeakSet());
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "scrollCb");
        $6fb9842575b03497$var$__publicField(this, "bypassOptions");
        $6fb9842575b03497$var$__publicField(this, "mirror");
        $6fb9842575b03497$var$__publicField(this, "restoreHandlers", []);
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    var _proto = ShadowDomManager.prototype;
    _proto.init = function init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    };
    _proto.addShadowRoot = function addShadowRoot(shadowRoot2, doc) {
        var _this = this;
        if (!$6fb9842575b03497$var$isNativeShadowDom(shadowRoot2)) return;
        if (this.shadowDoms.has(shadowRoot2)) return;
        this.shadowDoms.add(shadowRoot2);
        var observer = $6fb9842575b03497$var$initMutationObserver($6fb9842575b03497$var$_extends({}, this.bypassOptions, {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot2);
        this.restoreHandlers.push(function() {
            return observer.disconnect();
        });
        this.restoreHandlers.push($6fb9842575b03497$var$initScrollObserver($6fb9842575b03497$var$_extends({}, this.bypassOptions, {
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot2,
            mirror: this.mirror
        })));
        setTimeout(function() {
            if (shadowRoot2.adoptedStyleSheets && shadowRoot2.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot2.adoptedStyleSheets, _this.mirror.getId($6fb9842575b03497$var$index.host(shadowRoot2)));
            _this.restoreHandlers.push($6fb9842575b03497$var$initAdoptedStyleSheetObserver({
                mirror: _this.mirror,
                stylesheetManager: _this.bypassOptions.stylesheetManager
            }, shadowRoot2));
        }, 0);
    };
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ _proto.observeAttachShadow = function observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    };
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ _proto.patchAttachShadow = function patchAttachShadow(element, doc) {
        var manager = this;
        this.restoreHandlers.push($6fb9842575b03497$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                var sRoot = original.call(this, option);
                var shadowRootEl = $6fb9842575b03497$var$index.shadowRoot(this);
                if (shadowRootEl && $6fb9842575b03497$var$inDom(this)) manager.addShadowRoot(shadowRootEl, doc);
                return sRoot;
            };
        }));
    };
    _proto.reset = function reset() {
        this.restoreHandlers.forEach(function(handler) {
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
    };
    return ShadowDomManager;
}();
var $6fb9842575b03497$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $6fb9842575b03497$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $6fb9842575b03497$var$i$1 = 0; $6fb9842575b03497$var$i$1 < $6fb9842575b03497$var$chars.length; $6fb9842575b03497$var$i$1++)$6fb9842575b03497$var$lookup[$6fb9842575b03497$var$chars.charCodeAt($6fb9842575b03497$var$i$1)] = $6fb9842575b03497$var$i$1;
var $6fb9842575b03497$var$encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $6fb9842575b03497$var$chars[bytes[i2] >> 2];
        base64 += $6fb9842575b03497$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $6fb9842575b03497$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $6fb9842575b03497$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $6fb9842575b03497$var$canvasVarMap = /* @__PURE__ */ new Map();
function $6fb9842575b03497$var$variableListFor$1(ctx, ctor) {
    var contextMap = $6fb9842575b03497$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $6fb9842575b03497$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var $6fb9842575b03497$var$saveWebGLVar = function(value, win, ctx) {
    if (!value || !($6fb9842575b03497$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value)) === "object")) return;
    var name = value.constructor.name;
    var list2 = $6fb9842575b03497$var$variableListFor$1(ctx, name);
    var index2 = list2.indexOf(value);
    if (index2 === -1) {
        index2 = list2.length;
        list2.push(value);
    }
    return index2;
};
function $6fb9842575b03497$var$serializeArg(value, win, ctx) {
    if ($6fb9842575b03497$var$_instanceof(value, Array)) return value.map(function(arg) {
        return $6fb9842575b03497$var$serializeArg(arg, win, ctx);
    });
    else if (value === null) return value;
    else if ($6fb9842575b03497$var$_instanceof(value, Float32Array) || $6fb9842575b03497$var$_instanceof(value, Float64Array) || $6fb9842575b03497$var$_instanceof(value, Int32Array) || $6fb9842575b03497$var$_instanceof(value, Uint32Array) || $6fb9842575b03497$var$_instanceof(value, Uint8Array) || $6fb9842575b03497$var$_instanceof(value, Uint16Array) || $6fb9842575b03497$var$_instanceof(value, Int16Array) || $6fb9842575b03497$var$_instanceof(value, Int8Array) || $6fb9842575b03497$var$_instanceof(value, Uint8ClampedArray)) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    $6fb9842575b03497$var$_instanceof(value, ArrayBuffer)) {
        var name1 = value.constructor.name;
        var base64 = $6fb9842575b03497$var$encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if ($6fb9842575b03497$var$_instanceof(value, DataView)) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                $6fb9842575b03497$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if ($6fb9842575b03497$var$_instanceof(value, HTMLImageElement)) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if ($6fb9842575b03497$var$_instanceof(value, HTMLCanvasElement)) {
        var name4 = "HTMLImageElement";
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if ($6fb9842575b03497$var$_instanceof(value, ImageData)) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                $6fb9842575b03497$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($6fb9842575b03497$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $6fb9842575b03497$var$_type_of(value)) === "object") {
        var name6 = value.constructor.name;
        var index2 = $6fb9842575b03497$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index2
        };
    }
    return value;
}
var $6fb9842575b03497$var$serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return $6fb9842575b03497$var$serializeArg(arg, win, ctx);
    });
};
var $6fb9842575b03497$var$isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === "function";
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return $6fb9842575b03497$var$_instanceof(value, win[name]);
    }));
};
function $6fb9842575b03497$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    var _loop = function() {
        var prop = _step.value;
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") return "continue";
            var restoreHandler = $6fb9842575b03497$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                return function() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    if (!$6fb9842575b03497$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(function() {
                        var recordArgs = $6fb9842575b03497$var$serializeArgs(args, win, _this);
                        cb(_this.canvas, {
                            type: $6fb9842575b03497$var$CanvasContext["2D"],
                            property: prop,
                            args: recordArgs
                        });
                    }, 0);
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $6fb9842575b03497$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: $6fb9842575b03497$var$CanvasContext["2D"],
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(props2D), _step; !(_step = _iterator()).done;)_loop();
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $6fb9842575b03497$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = $6fb9842575b03497$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (!$6fb9842575b03497$var$isBlocked(this, blockClass, blockSelector, true)) {
                    var ctxName = $6fb9842575b03497$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && $6fb9842575b03497$var$_type_of(args[0]) === "object") {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [].concat([
                    contextType
                ], args));
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $6fb9842575b03497$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, win) {
    var _loop = function() {
        var prop = _step.value;
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) return "continue";
        try {
            if (typeof prototype[prop] !== "function") return "continue";
            var restoreHandler = $6fb9842575b03497$var$patch(prototype, prop, function(original) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var result2 = original.apply(this, args);
                    $6fb9842575b03497$var$saveWebGLVar(result2, win, this);
                    if ("tagName" in this.canvas && !$6fb9842575b03497$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        var recordArgs = $6fb9842575b03497$var$serializeArgs(args, win, this);
                        var mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result2;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $6fb9842575b03497$var$hookSetter(prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(props), _step; !(_step = _iterator()).done;)_loop();
    return handlers;
}
function $6fb9842575b03497$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector) {
    var _handlers;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, [].concat($6fb9842575b03497$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $6fb9842575b03497$var$CanvasContext.WebGL, cb, blockClass, blockSelector, win)));
    if (typeof win.WebGL2RenderingContext !== "undefined") {
        var _handlers1;
        (_handlers1 = handlers).push.apply(_handlers1, [].concat($6fb9842575b03497$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $6fb9842575b03497$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, win)));
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var $6fb9842575b03497$var$encodedJs = "KGZ1bmN0aW9uKCkgewogICJ1c2Ugc3RyaWN0IjsKICB2YXIgY2hhcnMgPSAiQUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5ejAxMjM0NTY3ODkrLyI7CiAgdmFyIGxvb2t1cCA9IHR5cGVvZiBVaW50OEFycmF5ID09PSAidW5kZWZpbmVkIiA/IFtdIDogbmV3IFVpbnQ4QXJyYXkoMjU2KTsKICBmb3IgKHZhciBpID0gMDsgaSA8IGNoYXJzLmxlbmd0aDsgaSsrKSB7CiAgICBsb29rdXBbY2hhcnMuY2hhckNvZGVBdChpKV0gPSBpOwogIH0KICB2YXIgZW5jb2RlID0gZnVuY3Rpb24oYXJyYXlidWZmZXIpIHsKICAgIHZhciBieXRlcyA9IG5ldyBVaW50OEFycmF5KGFycmF5YnVmZmVyKSwgaTIsIGxlbiA9IGJ5dGVzLmxlbmd0aCwgYmFzZTY0ID0gIiI7CiAgICBmb3IgKGkyID0gMDsgaTIgPCBsZW47IGkyICs9IDMpIHsKICAgICAgYmFzZTY0ICs9IGNoYXJzW2J5dGVzW2kyXSA+PiAyXTsKICAgICAgYmFzZTY0ICs9IGNoYXJzWyhieXRlc1tpMl0gJiAzKSA8PCA0IHwgYnl0ZXNbaTIgKyAxXSA+PiA0XTsKICAgICAgYmFzZTY0ICs9IGNoYXJzWyhieXRlc1tpMiArIDFdICYgMTUpIDw8IDIgfCBieXRlc1tpMiArIDJdID4+IDZdOwogICAgICBiYXNlNjQgKz0gY2hhcnNbYnl0ZXNbaTIgKyAyXSAmIDYzXTsKICAgIH0KICAgIGlmIChsZW4gJSAzID09PSAyKSB7CiAgICAgIGJhc2U2NCA9IGJhc2U2NC5zdWJzdHJpbmcoMCwgYmFzZTY0Lmxlbmd0aCAtIDEpICsgIj0iOwogICAgfSBlbHNlIGlmIChsZW4gJSAzID09PSAxKSB7CiAgICAgIGJhc2U2NCA9IGJhc2U2NC5zdWJzdHJpbmcoMCwgYmFzZTY0Lmxlbmd0aCAtIDIpICsgIj09IjsKICAgIH0KICAgIHJldHVybiBiYXNlNjQ7CiAgfTsKICBjb25zdCBsYXN0QmxvYk1hcCA9IC8qIEBfX1BVUkVfXyAqLyBuZXcgTWFwKCk7CiAgY29uc3QgdHJhbnNwYXJlbnRCbG9iTWFwID0gLyogQF9fUFVSRV9fICovIG5ldyBNYXAoKTsKICBhc3luYyBmdW5jdGlvbiBnZXRUcmFuc3BhcmVudEJsb2JGb3Iod2lkdGgsIGhlaWdodCwgZGF0YVVSTE9wdGlvbnMpIHsKICAgIGNvbnN0IGlkID0gYCR7d2lkdGh9LSR7aGVpZ2h0fWA7CiAgICBpZiAoIk9mZnNjcmVlbkNhbnZhcyIgaW4gZ2xvYmFsVGhpcykgewogICAgICBpZiAodHJhbnNwYXJlbnRCbG9iTWFwLmhhcyhpZCkpIHJldHVybiB0cmFuc3BhcmVudEJsb2JNYXAuZ2V0KGlkKTsKICAgICAgY29uc3Qgb2Zmc2NyZWVuID0gbmV3IE9mZnNjcmVlbkNhbnZhcyh3aWR0aCwgaGVpZ2h0KTsKICAgICAgb2Zmc2NyZWVuLmdldENvbnRleHQoIjJkIik7CiAgICAgIGNvbnN0IGJsb2IgPSBhd2FpdCBvZmZzY3JlZW4uY29udmVydFRvQmxvYihkYXRhVVJMT3B0aW9ucyk7CiAgICAgIGNvbnN0IGFycmF5QnVmZmVyID0gYXdhaXQgYmxvYi5hcnJheUJ1ZmZlcigpOwogICAgICBjb25zdCBiYXNlNjQgPSBlbmNvZGUoYXJyYXlCdWZmZXIpOwogICAgICB0cmFuc3BhcmVudEJsb2JNYXAuc2V0KGlkLCBiYXNlNjQpOwogICAgICByZXR1cm4gYmFzZTY0OwogICAgfSBlbHNlIHsKICAgICAgcmV0dXJuICIiOwogICAgfQogIH0KICBjb25zdCB3b3JrZXIgPSBzZWxmOwogIHdvcmtlci5vbm1lc3NhZ2UgPSBhc3luYyBmdW5jdGlvbihlKSB7CiAgICBpZiAoIk9mZnNjcmVlbkNhbnZhcyIgaW4gZ2xvYmFsVGhpcykgewogICAgICBjb25zdCB7IGlkLCBiaXRtYXAsIHdpZHRoLCBoZWlnaHQsIGRhdGFVUkxPcHRpb25zIH0gPSBlLmRhdGE7CiAgICAgIGNvbnN0IHRyYW5zcGFyZW50QmFzZTY0ID0gZ2V0VHJhbnNwYXJlbnRCbG9iRm9yKAogICAgICAgIHdpZHRoLAogICAgICAgIGhlaWdodCwKICAgICAgICBkYXRhVVJMT3B0aW9ucwogICAgICApOwogICAgICBjb25zdCBvZmZzY3JlZW4gPSBuZXcgT2Zmc2NyZWVuQ2FudmFzKHdpZHRoLCBoZWlnaHQpOwogICAgICBjb25zdCBjdHggPSBvZmZzY3JlZW4uZ2V0Q29udGV4dCgiMmQiKTsKICAgICAgY3R4LmRyYXdJbWFnZShiaXRtYXAsIDAsIDApOwogICAgICBiaXRtYXAuY2xvc2UoKTsKICAgICAgY29uc3QgYmxvYiA9IGF3YWl0IG9mZnNjcmVlbi5jb252ZXJ0VG9CbG9iKGRhdGFVUkxPcHRpb25zKTsKICAgICAgY29uc3QgdHlwZSA9IGJsb2IudHlwZTsKICAgICAgY29uc3QgYXJyYXlCdWZmZXIgPSBhd2FpdCBibG9iLmFycmF5QnVmZmVyKCk7CiAgICAgIGNvbnN0IGJhc2U2NCA9IGVuY29kZShhcnJheUJ1ZmZlcik7CiAgICAgIGlmICghbGFzdEJsb2JNYXAuaGFzKGlkKSAmJiBhd2FpdCB0cmFuc3BhcmVudEJhc2U2NCA9PT0gYmFzZTY0KSB7CiAgICAgICAgbGFzdEJsb2JNYXAuc2V0KGlkLCBiYXNlNjQpOwogICAgICAgIHJldHVybiB3b3JrZXIucG9zdE1lc3NhZ2UoeyBpZCB9KTsKICAgICAgfQogICAgICBpZiAobGFzdEJsb2JNYXAuZ2V0KGlkKSA9PT0gYmFzZTY0KSByZXR1cm4gd29ya2VyLnBvc3RNZXNzYWdlKHsgaWQgfSk7CiAgICAgIHdvcmtlci5wb3N0TWVzc2FnZSh7CiAgICAgICAgaWQsCiAgICAgICAgdHlwZSwKICAgICAgICBiYXNlNjQsCiAgICAgICAgd2lkdGgsCiAgICAgICAgaGVpZ2h0CiAgICAgIH0pOwogICAgICBsYXN0QmxvYk1hcC5zZXQoaWQsIGJhc2U2NCk7CiAgICB9IGVsc2UgewogICAgICByZXR1cm4gd29ya2VyLnBvc3RNZXNzYWdlKHsgaWQ6IGUuZGF0YS5pZCB9KTsKICAgIH0KICB9Owp9KSgpOwovLyMgc291cmNlTWFwcGluZ1VSTD1pbWFnZS1iaXRtYXAtZGF0YS11cmwtd29ya2VyLUlKcEM3Z19iLmpzLm1hcAo=";
var $6fb9842575b03497$var$decodeBase64 = function(base64) {
    return Uint8Array.from(atob(base64), function(c2) {
        return c2.charCodeAt(0);
    });
};
var $6fb9842575b03497$var$blob = typeof window !== "undefined" && window.Blob && new Blob([
    $6fb9842575b03497$var$decodeBase64($6fb9842575b03497$var$encodedJs)
], {
    type: "text/javascript;charset=utf-8"
});
function $6fb9842575b03497$var$WorkerWrapper(options) {
    var objURL;
    try {
        objURL = $6fb9842575b03497$var$blob && (window.URL || window.webkitURL).createObjectURL($6fb9842575b03497$var$blob);
        if (!objURL) throw "";
        var worker = new Worker(objURL, {
            name: options == null ? void 0 : options.name
        });
        worker.addEventListener("error", function() {
            (window.URL || window.webkitURL).revokeObjectURL(objURL);
        });
        return worker;
    } catch (e2) {
        return new Worker("data:text/javascript;base64," + $6fb9842575b03497$var$encodedJs, {
            name: options == null ? void 0 : options.name
        });
    } finally{
        objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
    }
}
var $6fb9842575b03497$var$CanvasManager = /*#__PURE__*/ function() {
    function CanvasManager(options) {
        var _this = this;
        $6fb9842575b03497$var$__publicField(this, "pendingCanvasMutations", /* @__PURE__ */ new Map());
        $6fb9842575b03497$var$__publicField(this, "rafStamps", {
            latestId: 0,
            invokeId: null
        });
        $6fb9842575b03497$var$__publicField(this, "mirror");
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "resetObservers");
        $6fb9842575b03497$var$__publicField(this, "frozen", false);
        $6fb9842575b03497$var$__publicField(this, "locked", false);
        $6fb9842575b03497$var$__publicField(this, "processMutation", function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) _this.pendingCanvasMutations.set(target, []);
            _this.pendingCanvasMutations.get(target).push(mutation);
        });
        var _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? "all" : _options_sampling, win = options.win, blockClass = options.blockClass, blockSelector = options.blockSelector, recordCanvas = options.recordCanvas, dataURLOptions = options.dataURLOptions;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    var _proto = CanvasManager.prototype;
    _proto.reset = function reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
    };
    _proto.lock = function lock() {
        this.locked = true;
    };
    _proto.unlock = function unlock() {
        this.locked = false;
    };
    _proto.initCanvasFPSObserver = function initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        var _this = this;
        var canvasContextReset = $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
        var snapshotInProgressMap = /* @__PURE__ */ new Map();
        var worker = new $6fb9842575b03497$var$WorkerWrapper();
        worker.onmessage = function(e2) {
            var id = e2.data.id;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in e2.data)) return;
            var _e2_data = e2.data, base64 = _e2_data.base64, type = _e2_data.type, width = _e2_data.width, height = _e2_data.height;
            _this.mutationCb({
                id: id,
                type: $6fb9842575b03497$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        var timeBetweenSnapshots = 1e3 / fps;
        var lastSnapshotTime = 0;
        var rafId;
        var getCanvas = function() {
            var matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach(function(canvas) {
                if (!$6fb9842575b03497$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        var takeCanvasSnapshots = function(timestamp) {
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            var _this1 = _this;
            getCanvas().forEach(/*#__PURE__*/ $6fb9842575b03497$var$_async_to_generator(function(canvas) {
                var _a2, id, context, bitmap;
                return $6fb9842575b03497$var$_ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = _this1.mirror.getId(canvas);
                            if (snapshotInProgressMap.get(id)) return [
                                2
                            ];
                            if (canvas.width === 0 || canvas.height === 0) return [
                                2
                            ];
                            snapshotInProgressMap.set(id, true);
                            if ([
                                "webgl",
                                "webgl2"
                            ].includes(canvas.__context)) {
                                context = canvas.getContext(canvas.__context);
                                if (((_a2 = context == null ? void 0 : context.getContextAttributes()) == null ? void 0 : _a2.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                            }
                            return [
                                4,
                                createImageBitmap(canvas)
                            ];
                        case 1:
                            bitmap = _state.sent();
                            worker.postMessage({
                                id: id,
                                bitmap: bitmap,
                                width: canvas.width,
                                height: canvas.height,
                                dataURLOptions: options.dataURLOptions
                            }, [
                                bitmap
                            ]);
                            return [
                                2
                            ];
                    }
                });
            }));
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = function() {
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    };
    _proto.initCanvasMutationObserver = function initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        var canvasContextReset = $6fb9842575b03497$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
        var canvas2DReset = $6fb9842575b03497$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        var canvasWebGL1and2Reset = $6fb9842575b03497$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        this.resetObservers = function() {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    };
    _proto.startPendingCanvasMutationFlusher = function startPendingCanvasMutationFlusher() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.startRAFTimestamping = function startRAFTimestamping() {
        var _this = this;
        var setLatestRAFTimestamp = function(timestamp) {
            _this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    };
    _proto.flushPendingCanvasMutations = function flushPendingCanvasMutations() {
        var _this = this;
        this.pendingCanvasMutations.forEach(function(_values, canvas) {
            var id = _this.mirror.getId(canvas);
            _this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.flushPendingCanvasMutationFor = function flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        var valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        var values = valuesWithType.map(function(value) {
            value.type;
            var rest = $6fb9842575b03497$var$_object_without_properties_loose(value, [
                "type"
            ]);
            return rest;
        });
        var type = valuesWithType[0].type;
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    };
    return CanvasManager;
}();
var $6fb9842575b03497$var$StylesheetManager = /*#__PURE__*/ function() {
    function StylesheetManager(options) {
        $6fb9842575b03497$var$__publicField(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet());
        $6fb9842575b03497$var$__publicField(this, "mutationCb");
        $6fb9842575b03497$var$__publicField(this, "adoptedStyleSheetCb");
        $6fb9842575b03497$var$__publicField(this, "styleMirror", new $6fb9842575b03497$var$StyleSheetMirror());
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    var _proto = StylesheetManager.prototype;
    _proto.attachLinkElement = function attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    };
    _proto.trackLinkElement = function trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    };
    _proto.adoptStyleSheets = function adoptStyleSheets(sheets, hostId) {
        var _this, _loop = function() {
            var sheet = _step.value;
            var styleId = void 0;
            if (!_this.styleMirror.has(sheet)) {
                styleId = _this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, function(r2, index2) {
                        return {
                            rule: $6fb9842575b03497$var$stringifyRule(r2, sheet.href),
                            index: index2
                        };
                    })
                });
            } else styleId = _this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        };
        if (sheets.length === 0) return;
        var adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        var styles = [];
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(sheets), _step; !(_step = _iterator()).done;)_this = this, _loop();
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    };
    _proto.reset = function reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    };
    // TODO: take snapshot on stylesheet reload by applying event listener
    _proto.trackStylesheetInLinkElement = function trackStylesheetInLinkElement(_linkEl) {};
    return StylesheetManager;
}();
var $6fb9842575b03497$var$ProcessedNodeManager = /*#__PURE__*/ function() {
    function ProcessedNodeManager() {
        $6fb9842575b03497$var$__publicField(this, "nodeMap", /* @__PURE__ */ new WeakMap());
        $6fb9842575b03497$var$__publicField(this, "active", false);
    }
    var _proto = ProcessedNodeManager.prototype;
    _proto.inOtherBuffer = function inOtherBuffer(node2, thisBuffer) {
        var buffers = this.nodeMap.get(node2);
        return buffers && Array.from(buffers).some(function(buffer) {
            return buffer !== thisBuffer;
        });
    };
    _proto.add = function add(node2, buffer) {
        var _this = this;
        if (!this.active) {
            this.active = true;
            requestAnimationFrame(function() {
                _this.nodeMap = /* @__PURE__ */ new WeakMap();
                _this.active = false;
            });
        }
        this.nodeMap.set(node2, (this.nodeMap.get(node2) || /* @__PURE__ */ new Set()).add(buffer));
    };
    _proto.destroy = function destroy() {};
    return ProcessedNodeManager;
}();
var $6fb9842575b03497$var$wrappedEmit;
var $6fb9842575b03497$var$takeFullSnapshot$1;
var $6fb9842575b03497$var$canvasManager;
var $6fb9842575b03497$var$recording = false;
try {
    if (Array.from([
        1
    ], function(x2) {
        return x2 * 2;
    })[0] !== 2) {
        var $6fb9842575b03497$var$cleanFrame = document.createElement("iframe");
        document.body.appendChild($6fb9842575b03497$var$cleanFrame);
        Array.from = (($6fb9842575b03497$var$_a = $6fb9842575b03497$var$cleanFrame.contentWindow) == null ? void 0 : $6fb9842575b03497$var$_a.Array.from) || Array.from;
        document.body.removeChild($6fb9842575b03497$var$cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
var $6fb9842575b03497$var$mirror = $6fb9842575b03497$var$createMirror$2();
function $6fb9842575b03497$var$record(options) {
    if (options === void 0) options = {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? "rr-block" : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? "rr-ignore" : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? "rr-mask" : _options_maskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, hooks = options.hooks, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordDOM = options.recordDOM, recordDOM = _options_recordDOM === void 0 ? true : _options_recordDOM, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load" : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _options_ignoreCSSAttributes, errorHandler2 = options.errorHandler;
    $6fb9842575b03497$var$registerErrorHandler(errorHandler2);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return function() {};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $6fb9842575b03497$var$mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {
        password: true
    };
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all",
        headTitleMutations: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $6fb9842575b03497$var$polyfill$1();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e2) {
        for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
            var plugin3 = _step.value;
            if (plugin3.eventProcessor) e2 = plugin3.eventProcessor(e2);
        }
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $6fb9842575b03497$var$wrappedEmit = function(r2, isCheckout) {
        var _a2;
        var e2 = r2;
        e2.timestamp = $6fb9842575b03497$var$nowTimestamp();
        if (((_a2 = $6fb9842575b03497$var$mutationBuffers[0]) == null ? void 0 : _a2.isFrozen()) && e2.type !== $6fb9842575b03497$var$EventType.FullSnapshot && !(e2.type === $6fb9842575b03497$var$EventType.IncrementalSnapshot && e2.data.source === $6fb9842575b03497$var$IncrementalSource.Mutation)) $6fb9842575b03497$var$mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) emit == null || emit(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            var message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $6fb9842575b03497$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $6fb9842575b03497$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $6fb9842575b03497$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $6fb9842575b03497$var$takeFullSnapshot$1(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
            data: $6fb9842575b03497$var$_extends({
                source: $6fb9842575b03497$var$IncrementalSource.Mutation
            }, m)
        });
    };
    var wrappedScrollEmit = function(p) {
        return $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
            data: $6fb9842575b03497$var$_extends({
                source: $6fb9842575b03497$var$IncrementalSource.Scroll
            }, p)
        });
    };
    var wrappedCanvasMutationEmit = function(p) {
        return $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
            data: $6fb9842575b03497$var$_extends({
                source: $6fb9842575b03497$var$IncrementalSource.CanvasMutation
            }, p)
        });
    };
    var wrappedAdoptedStyleSheetEmit = function(a2) {
        return $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
            data: $6fb9842575b03497$var$_extends({
                source: $6fb9842575b03497$var$IncrementalSource.AdoptedStyleSheet
            }, a2)
        });
    };
    var stylesheetManager = new $6fb9842575b03497$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = new $6fb9842575b03497$var$IframeManager({
        mirror: $6fb9842575b03497$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $6fb9842575b03497$var$wrappedEmit
    });
    for(var _iterator = $6fb9842575b03497$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        if (plugin3.getMirror) plugin3.getMirror({
            nodeMirror: $6fb9842575b03497$var$mirror,
            crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
            crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
        });
    }
    var processedNodeManager = new $6fb9842575b03497$var$ProcessedNodeManager();
    $6fb9842575b03497$var$canvasManager = new $6fb9842575b03497$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $6fb9842575b03497$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    var shadowDomManager = new $6fb9842575b03497$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $6fb9842575b03497$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $6fb9842575b03497$var$mirror
    });
    $6fb9842575b03497$var$takeFullSnapshot$1 = function(isCheckout) {
        if (isCheckout === void 0) isCheckout = false;
        if (!recordDOM) return;
        $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $6fb9842575b03497$var$getWindowWidth(),
                height: $6fb9842575b03497$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $6fb9842575b03497$var$mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node2 = $6fb9842575b03497$var$snapshot(document, {
            mirror: $6fb9842575b03497$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n2) {
                if ($6fb9842575b03497$var$isSerializedIframe(n2, $6fb9842575b03497$var$mirror)) iframeManager.addIframe(n2);
                if ($6fb9842575b03497$var$isSerializedStylesheet(n2, $6fb9842575b03497$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($6fb9842575b03497$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot($6fb9842575b03497$var$index.shadowRoot(n2), document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node2) return console.warn("Failed to snapshot the document");
        $6fb9842575b03497$var$wrappedEmit({
            type: $6fb9842575b03497$var$EventType.FullSnapshot,
            data: {
                node: node2,
                initialOffset: $6fb9842575b03497$var$getWindowScroll(window)
            }
        }, isCheckout);
        $6fb9842575b03497$var$mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $6fb9842575b03497$var$mirror.getId(document));
    };
    try {
        var handlers = [];
        var observe = function(doc) {
            var _a2;
            return $6fb9842575b03497$var$callbackWrapper($6fb9842575b03497$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    });
                },
                mouseInteractionCb: function(d) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.MouseInteraction
                        }, d)
                    });
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.ViewportResize
                        }, d)
                    });
                },
                inputCb: function(v2) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.Input
                        }, v2)
                    });
                },
                mediaInteractionCb: function(p) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.MediaInteraction
                        }, p)
                    });
                },
                styleSheetRuleCb: function(r2) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.StyleSheetRule
                        }, r2)
                    });
                },
                styleDeclarationCb: function(r2) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.StyleDeclaration
                        }, r2)
                    });
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.Font
                        }, p)
                    });
                },
                selectionCb: function(p) {
                    $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: function(c2) {
                    $6fb9842575b03497$var$wrappedEmit({
                        type: $6fb9842575b03497$var$EventType.IncrementalSnapshot,
                        data: $6fb9842575b03497$var$_extends({
                            source: $6fb9842575b03497$var$IncrementalSource.CustomElement
                        }, c2)
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $6fb9842575b03497$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $6fb9842575b03497$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a2 = plugins == null ? void 0 : plugins.filter(function(p) {
                    return p.observer;
                })) == null ? void 0 : _a2.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return $6fb9842575b03497$var$wrappedEmit({
                                type: $6fb9842575b03497$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            });
                        }
                    };
                })) || []
            }, hooks);
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            $6fb9842575b03497$var$takeFullSnapshot$1();
            handlers.push(observe(document));
            $6fb9842575b03497$var$recording = true;
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($6fb9842575b03497$var$on("DOMContentLoaded", function() {
                $6fb9842575b03497$var$wrappedEmit({
                    type: $6fb9842575b03497$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($6fb9842575b03497$var$on("load", function() {
                $6fb9842575b03497$var$wrappedEmit({
                    type: $6fb9842575b03497$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return function() {
            handlers.forEach(function(h) {
                return h();
            });
            processedNodeManager.destroy();
            $6fb9842575b03497$var$recording = false;
            $6fb9842575b03497$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$6fb9842575b03497$var$record.addCustomEvent = function(tag, payload) {
    if (!$6fb9842575b03497$var$recording) throw new Error("please add custom event after start recording");
    $6fb9842575b03497$var$wrappedEmit({
        type: $6fb9842575b03497$var$EventType.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    });
};
$6fb9842575b03497$var$record.freezePage = function() {
    $6fb9842575b03497$var$mutationBuffers.forEach(function(buf) {
        return buf.freeze();
    });
};
$6fb9842575b03497$var$record.takeFullSnapshot = function(isCheckout) {
    if (!$6fb9842575b03497$var$recording) throw new Error("please take full snapshot after start recording");
    $6fb9842575b03497$var$takeFullSnapshot$1(isCheckout);
};
$6fb9842575b03497$var$record.mirror = $6fb9842575b03497$var$mirror;
var $6fb9842575b03497$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($6fb9842575b03497$var$n || ($6fb9842575b03497$var$n = {}));
$6fb9842575b03497$var$record.addCustomEvent;
$6fb9842575b03497$var$record.freezePage;
$6fb9842575b03497$var$record.takeFullSnapshot;
var $6fb9842575b03497$var$setImmediate = $6fb9842575b03497$var$win['setImmediate'];
var $6fb9842575b03497$var$builtInProp, $6fb9842575b03497$var$cycle, $6fb9842575b03497$var$schedulingQueue, $6fb9842575b03497$var$ToString = Object.prototype.toString, $6fb9842575b03497$var$timer = typeof $6fb9842575b03497$var$setImmediate !== 'undefined' ? function timer(fn) {
    return $6fb9842575b03497$var$setImmediate(fn);
} : setTimeout;
// dammit, IE8.
try {
    Object.defineProperty({}, 'x', {});
    $6fb9842575b03497$var$builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
            value: val,
            writable: true,
            configurable: config !== false
        });
    };
} catch (err) {
    $6fb9842575b03497$var$builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
    };
}
// Note: using a queue instead of array for efficiency
$6fb9842575b03497$var$schedulingQueue = function Queue() {
    var first, last, item;
    function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
    }
    return {
        add: function add(fn, self) {
            item = new Item(fn, self);
            if (last) last.next = item;
            else first = item;
            last = item;
            item = void 0;
        },
        drain: function drain() {
            var f = first;
            first = last = $6fb9842575b03497$var$cycle = void 0;
            while(f){
                f.fn.call(f.self);
                f = f.next;
            }
        }
    };
}();
function $6fb9842575b03497$var$schedule(fn, self) {
    $6fb9842575b03497$var$schedulingQueue.add(fn, self);
    if (!$6fb9842575b03497$var$cycle) $6fb9842575b03497$var$cycle = $6fb9842575b03497$var$timer($6fb9842575b03497$var$schedulingQueue.drain);
}
// promise duck typing
function $6fb9842575b03497$var$isThenable(o) {
    var _then, oType = typeof o;
    if (o !== null && (oType === 'object' || oType === 'function')) _then = o.then;
    return typeof _then === 'function' ? _then : false;
}
function $6fb9842575b03497$var$notify() {
    for(var i = 0; i < this.chain.length; i++)$6fb9842575b03497$var$notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    this.chain.length = 0;
}
// NOTE: This is a separate function to isolate
// the `try..catch` so that other code can be
// optimized better
function $6fb9842575b03497$var$notifyIsolated(self, cb, chain) {
    var ret, _then;
    try {
        if (cb === false) chain.reject(self.msg);
        else {
            if (cb === true) ret = self.msg;
            else ret = cb.call(void 0, self.msg);
            if (ret === chain.promise) chain.reject(TypeError('Promise-chain cycle'));
            else if (_then = $6fb9842575b03497$var$isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
            else chain.resolve(ret);
        }
    } catch (err) {
        chain.reject(err);
    }
}
function $6fb9842575b03497$var$resolve(msg) {
    var _then, self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    try {
        // eslint-disable-next-line no-cond-assign
        if (_then = $6fb9842575b03497$var$isThenable(msg)) $6fb9842575b03497$var$schedule(function() {
            var defWrapper = new $6fb9842575b03497$var$MakeDefWrapper(self);
            try {
                _then.call(msg, function $resolve$() {
                    $6fb9842575b03497$var$resolve.apply(defWrapper, arguments);
                }, function $reject$() {
                    $6fb9842575b03497$var$reject.apply(defWrapper, arguments);
                });
            } catch (err) {
                $6fb9842575b03497$var$reject.call(defWrapper, err);
            }
        });
        else {
            self.msg = msg;
            self.state = 1;
            if (self.chain.length > 0) $6fb9842575b03497$var$schedule($6fb9842575b03497$var$notify, self);
        }
    } catch (err) {
        $6fb9842575b03497$var$reject.call(new $6fb9842575b03497$var$MakeDefWrapper(self), err);
    }
}
function $6fb9842575b03497$var$reject(msg) {
    var self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    self.msg = msg;
    self.state = 2;
    if (self.chain.length > 0) $6fb9842575b03497$var$schedule($6fb9842575b03497$var$notify, self);
}
function $6fb9842575b03497$var$iteratePromises(Constructor, arr, resolver, rejecter) {
    for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
        }, rejecter);
    })(idx);
}
function $6fb9842575b03497$var$MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
}
function $6fb9842575b03497$var$MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
}
function $6fb9842575b03497$var$NpoPromise(executor) {
    if (typeof executor !== 'function') throw TypeError('Not a function');
    if (this['__NPO__'] !== 0) throw TypeError('Not a promise');
    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this['__NPO__'] = 1;
    var def = new $6fb9842575b03497$var$MakeDef(this);
    this['then'] = function then(success, failure) {
        var o = {
            success: typeof success === 'function' ? success : true,
            failure: typeof failure === 'function' ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
            if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
            o.resolve = resolve;
            o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) $6fb9842575b03497$var$schedule($6fb9842575b03497$var$notify, def);
        return o.promise;
    };
    this['catch'] = function $catch$(failure) {
        return this.then(void 0, failure);
    };
    try {
        executor.call(void 0, function publicResolve(msg) {
            $6fb9842575b03497$var$resolve.call(def, msg);
        }, function publicReject(msg) {
            $6fb9842575b03497$var$reject.call(def, msg);
        });
    } catch (err) {
        $6fb9842575b03497$var$reject.call(def, err);
    }
}
var $6fb9842575b03497$var$PromisePrototype = $6fb9842575b03497$var$builtInProp({}, 'constructor', $6fb9842575b03497$var$NpoPromise, /*configurable=*/ false);
// Note: Android 4 cannot use `Object.defineProperty(..)` here
$6fb9842575b03497$var$NpoPromise.prototype = $6fb9842575b03497$var$PromisePrototype;
// built-in "brand" to signal an "uninitialized" promise
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$PromisePrototype, '__NPO__', 0, /*configurable=*/ false);
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$NpoPromise, 'resolve', function Promise$resolve(msg) {
    var Constructor = this;
    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && typeof msg === 'object' && msg['__NPO__'] === 1) return msg;
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        resolve(msg);
    });
});
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$NpoPromise, 'reject', function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        reject(msg);
    });
});
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$NpoPromise, 'all', function Promise$all(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($6fb9842575b03497$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    if (arr.length === 0) return Constructor.resolve([]);
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        var len = arr.length, msgs = Array(len), count = 0;
        $6fb9842575b03497$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            msgs[idx] = msg;
            if (++count === len) resolve(msgs);
        }, reject);
    });
});
$6fb9842575b03497$var$builtInProp($6fb9842575b03497$var$NpoPromise, 'race', function Promise$race(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($6fb9842575b03497$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        $6fb9842575b03497$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            resolve(msg);
        }, reject);
    });
});
var $6fb9842575b03497$var$PromisePolyfill;
if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) $6fb9842575b03497$var$PromisePolyfill = Promise;
else $6fb9842575b03497$var$PromisePolyfill = $6fb9842575b03497$var$NpoPromise;
var $6fb9842575b03497$var$Config = {
    DEBUG: false,
    LIB_VERSION: '2.64.0'
};
/* eslint camelcase: "off", eqeqeq: "off" */ // Maximum allowed session recording length
var $6fb9842575b03497$var$MAX_RECORDING_MS = 86400000; // 24 hours
// Maximum allowed value for minimum session recording length
var $6fb9842575b03497$var$MAX_VALUE_FOR_MIN_RECORDING_MS = 8000; // 8 seconds
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $6fb9842575b03497$var$ArrayProto = Array.prototype, $6fb9842575b03497$var$FuncProto = Function.prototype, $6fb9842575b03497$var$ObjProto = Object.prototype, $6fb9842575b03497$var$slice = $6fb9842575b03497$var$ArrayProto.slice, $6fb9842575b03497$var$toString = $6fb9842575b03497$var$ObjProto.toString, $6fb9842575b03497$var$hasOwnProperty = $6fb9842575b03497$var$ObjProto.hasOwnProperty, $6fb9842575b03497$var$windowConsole = $6fb9842575b03497$var$win.console, $6fb9842575b03497$var$navigator = $6fb9842575b03497$var$win.navigator, $6fb9842575b03497$var$document$1 = $6fb9842575b03497$var$win.document, $6fb9842575b03497$var$windowOpera = $6fb9842575b03497$var$win.opera, $6fb9842575b03497$var$screen = $6fb9842575b03497$var$win.screen, $6fb9842575b03497$var$userAgent = $6fb9842575b03497$var$navigator.userAgent;
var $6fb9842575b03497$var$nativeBind = $6fb9842575b03497$var$FuncProto.bind, $6fb9842575b03497$var$nativeForEach = $6fb9842575b03497$var$ArrayProto.forEach, $6fb9842575b03497$var$nativeIndexOf = $6fb9842575b03497$var$ArrayProto.indexOf, $6fb9842575b03497$var$nativeMap = $6fb9842575b03497$var$ArrayProto.map, $6fb9842575b03497$var$nativeIsArray = Array.isArray, $6fb9842575b03497$var$breaker = {};
var $6fb9842575b03497$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
// Console override
var $6fb9842575b03497$var$console$1 = {
    /** @type {function(...*)} */ log: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) try {
            $6fb9842575b03497$var$windowConsole.log.apply($6fb9842575b03497$var$windowConsole, arguments);
        } catch (err) {
            $6fb9842575b03497$var$_.each(arguments, function(arg) {
                $6fb9842575b03497$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                'Mixpanel warning:'
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.warn.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($6fb9842575b03497$var$Config.DEBUG && !$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.error.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$windowConsole) && $6fb9842575b03497$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($6fb9842575b03497$var$_.toArray(arguments));
            try {
                $6fb9842575b03497$var$windowConsole.error.apply($6fb9842575b03497$var$windowConsole, args);
            } catch (err) {
                $6fb9842575b03497$var$_.each(args, function(arg) {
                    $6fb9842575b03497$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $6fb9842575b03497$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply($6fb9842575b03497$var$console$1, arguments);
    };
};
var $6fb9842575b03497$var$console_with_prefix = function(prefix) {
    return {
        log: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.log, prefix),
        error: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.error, prefix),
        critical: $6fb9842575b03497$var$log_func_with_prefix($6fb9842575b03497$var$console$1.critical, prefix)
    };
};
var $6fb9842575b03497$var$safewrap = function(f) {
    return function() {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            $6fb9842575b03497$var$console$1.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
            if ($6fb9842575b03497$var$Config.DEBUG) $6fb9842575b03497$var$console$1.critical(e);
        }
    };
};
var $6fb9842575b03497$var$safewrapClass = function(klass) {
    var proto = klass.prototype;
    for(var func in proto)if (typeof proto[func] === 'function') proto[func] = $6fb9842575b03497$var$safewrap(proto[func]);
};
// UNDERSCORE
// Embed part of the Underscore Library
$6fb9842575b03497$var$_.bind = function(func, context) {
    var args, bound;
    if ($6fb9842575b03497$var$nativeBind && func.bind === $6fb9842575b03497$var$nativeBind) return $6fb9842575b03497$var$nativeBind.apply(func, $6fb9842575b03497$var$slice.call(arguments, 1));
    if (!$6fb9842575b03497$var$_.isFunction(func)) throw new TypeError();
    args = $6fb9842575b03497$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($6fb9842575b03497$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($6fb9842575b03497$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $6fb9842575b03497$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($6fb9842575b03497$var$nativeForEach && obj.forEach === $6fb9842575b03497$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $6fb9842575b03497$var$breaker) return;
    }
    else {
        for(var key in obj)if ($6fb9842575b03497$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $6fb9842575b03497$var$breaker) return;
        }
    }
};
$6fb9842575b03497$var$_.extend = function(obj) {
    $6fb9842575b03497$var$_.each($6fb9842575b03497$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$6fb9842575b03497$var$_.isArray = $6fb9842575b03497$var$nativeIsArray || function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) === '[object Array]';
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$6fb9842575b03497$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$6fb9842575b03497$var$_.isArguments = function(obj) {
    return !!(obj && $6fb9842575b03497$var$hasOwnProperty.call(obj, 'callee'));
};
$6fb9842575b03497$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($6fb9842575b03497$var$_.isArray(iterable)) return $6fb9842575b03497$var$slice.call(iterable);
    if ($6fb9842575b03497$var$_.isArguments(iterable)) return $6fb9842575b03497$var$slice.call(iterable);
    return $6fb9842575b03497$var$_.values(iterable);
};
$6fb9842575b03497$var$_.map = function(arr, callback, context) {
    if ($6fb9842575b03497$var$nativeMap && arr.map === $6fb9842575b03497$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $6fb9842575b03497$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$6fb9842575b03497$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $6fb9842575b03497$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$6fb9842575b03497$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $6fb9842575b03497$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$6fb9842575b03497$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($6fb9842575b03497$var$nativeIndexOf && obj.indexOf === $6fb9842575b03497$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $6fb9842575b03497$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $6fb9842575b03497$var$breaker;
    });
    return found;
};
$6fb9842575b03497$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$6fb9842575b03497$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$6fb9842575b03497$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$6fb9842575b03497$var$_.isArray(obj);
};
$6fb9842575b03497$var$_.isEmptyObject = function(obj) {
    if ($6fb9842575b03497$var$_.isObject(obj)) {
        for(var key in obj){
            if ($6fb9842575b03497$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$6fb9842575b03497$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$6fb9842575b03497$var$_.isString = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == '[object String]';
};
$6fb9842575b03497$var$_.isDate = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == '[object Date]';
};
$6fb9842575b03497$var$_.isNumber = function(obj) {
    return $6fb9842575b03497$var$toString.call(obj) == '[object Number]';
};
$6fb9842575b03497$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$6fb9842575b03497$var$_.encodeDates = function(obj) {
    $6fb9842575b03497$var$_.each(obj, function(v, k) {
        if ($6fb9842575b03497$var$_.isDate(v)) obj[k] = $6fb9842575b03497$var$_.formatDate(v);
        else if ($6fb9842575b03497$var$_.isObject(v)) obj[k] = $6fb9842575b03497$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$6fb9842575b03497$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$6fb9842575b03497$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};
$6fb9842575b03497$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $6fb9842575b03497$var$_.each(p, function(v, k) {
        if ($6fb9842575b03497$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $6fb9842575b03497$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === 'string') ret = obj.slice(0, length);
    else if ($6fb9842575b03497$var$_.isArray(obj)) {
        ret = [];
        $6fb9842575b03497$var$_.each(obj, function(val) {
            ret.push($6fb9842575b03497$var$_.truncate(val, length));
        });
    } else if ($6fb9842575b03497$var$_.isObject(obj)) {
        ret = {};
        $6fb9842575b03497$var$_.each(obj, function(val, key) {
            ret[key] = $6fb9842575b03497$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$6fb9842575b03497$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' && typeof value.toJSON === 'function') value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case 'string':
                    return quote(value);
                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';
                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return 'null';
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($6fb9842575b03497$var$toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || 'null';
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($6fb9842575b03497$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $6fb9842575b03497$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        'b': '\b',
        'f': '\f',
        'n': '\n',
        'r': '\r',
        't': '\t'
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = '';
        if (ch === '-') {
            string = '-';
            next('-');
        }
        while(ch >= '0' && ch <= '9'){
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while(next() && ch >= '0' && ch <= '9')string += ch;
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while(ch >= '0' && ch <= '9'){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error('Bad number');
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = '', uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === '\\') {
                next();
                if (ch === 'u') {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === 'string') string += escapee[ch];
                else break;
            } else string += ch;
        }
        error('Bad string');
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= ' ')next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) error('Syntax error');
        return result;
    };
}();
$6fb9842575b03497$var$_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) return data;
    data = $6fb9842575b03497$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join('');
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};
$6fb9842575b03497$var$_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '', start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$6fb9842575b03497$var$_.UUID = function() {
    try {
        // use native Crypto API when available
        return $6fb9842575b03497$var$win['crypto']['randomUUID']();
    } catch (err) {
        // fall back to generating our own UUID
        // based on https://gist.github.com/scwood/3bff42cc005cc20ab7ec98f0d8e1d59d
        var uuid = new Array(36);
        for(var i = 0; i < 36; i++)uuid[i] = Math.floor(Math.random() * 16);
        uuid[14] = 4; // set bits 12-15 of time-high-and-version to 0100
        uuid[19] = uuid[19] &= -5; // set bit 6 of clock-seq-and-reserved to zero
        uuid[19] = uuid[19] |= 8; // set bit 7 of clock-seq-and-reserved to one
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        return $6fb9842575b03497$var$_.map(uuid, function(x) {
            return x.toString(16);
        }).join('');
    }
};
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $6fb9842575b03497$var$BLOCKED_UA_STRS = [
    'ahrefsbot',
    'ahrefssiteaudit',
    'amazonbot',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'chrome-lighthouse',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandex',
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
$6fb9842575b03497$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $6fb9842575b03497$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($6fb9842575b03497$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $6fb9842575b03497$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($6fb9842575b03497$var$_.isUndefined(arg_separator)) arg_separator = '&';
    $6fb9842575b03497$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$6fb9842575b03497$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/g, '\\[').replace(/[\]]/g, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)', regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) return '';
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $6fb9842575b03497$var$console$1.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$6fb9842575b03497$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = $6fb9842575b03497$var$document$1.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $6fb9842575b03497$var$_.JSONDecode($6fb9842575b03497$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $6fb9842575b03497$var$extract_domain($6fb9842575b03497$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        $6fb9842575b03497$var$document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $6fb9842575b03497$var$extract_domain($6fb9842575b03497$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        $6fb9842575b03497$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $6fb9842575b03497$var$_.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $6fb9842575b03497$var$_testStorageSupported = function(storage) {
    var supported = true;
    try {
        var key = '__mplss_' + $6fb9842575b03497$var$cheap_guid(8), val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    return supported;
};
var $6fb9842575b03497$var$_localStorageSupported = null;
var $6fb9842575b03497$var$localStorageSupported = function(storage, forceCheck) {
    if ($6fb9842575b03497$var$_localStorageSupported !== null && !forceCheck) return $6fb9842575b03497$var$_localStorageSupported;
    return $6fb9842575b03497$var$_localStorageSupported = $6fb9842575b03497$var$_testStorageSupported(storage || $6fb9842575b03497$var$win.localStorage);
};
var $6fb9842575b03497$var$_sessionStorageSupported = null;
var $6fb9842575b03497$var$sessionStorageSupported = function(storage, forceCheck) {
    if ($6fb9842575b03497$var$_sessionStorageSupported !== null && !forceCheck) return $6fb9842575b03497$var$_sessionStorageSupported;
    return $6fb9842575b03497$var$_sessionStorageSupported = $6fb9842575b03497$var$_testStorageSupported(storage || $6fb9842575b03497$var$win.sessionStorage);
};
function $6fb9842575b03497$var$_storageWrapper(storage, name, is_supported_fn) {
    var log_error = function(msg) {
        $6fb9842575b03497$var$console$1.error(name + ' error: ' + msg);
    };
    return {
        is_supported: function(forceCheck) {
            var supported = is_supported_fn(storage, forceCheck);
            if (!supported) $6fb9842575b03497$var$console$1.error(name + ' unsupported');
            return supported;
        },
        error: log_error,
        get: function(key) {
            try {
                return storage.getItem(key);
            } catch (err) {
                log_error(err);
            }
            return null;
        },
        parse: function(key) {
            try {
                return $6fb9842575b03497$var$_.JSONDecode(storage.getItem(key)) || {};
            } catch (err) {
            // noop
            }
            return null;
        },
        set: function(key, value) {
            try {
                storage.setItem(key, value);
            } catch (err) {
                log_error(err);
            }
        },
        remove: function(key) {
            try {
                storage.removeItem(key);
            } catch (err) {
                log_error(err);
            }
        }
    };
}
$6fb9842575b03497$var$_.localStorage = $6fb9842575b03497$var$_storageWrapper($6fb9842575b03497$var$win.localStorage, 'localStorage', $6fb9842575b03497$var$localStorageSupported);
$6fb9842575b03497$var$_.sessionStorage = $6fb9842575b03497$var$_storageWrapper($6fb9842575b03497$var$win.sessionStorage, 'sessionStorage', $6fb9842575b03497$var$sessionStorageSupported);
$6fb9842575b03497$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $6fb9842575b03497$var$console$1.error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent($6fb9842575b03497$var$win.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($6fb9842575b03497$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $6fb9842575b03497$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$6fb9842575b03497$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$6fb9842575b03497$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $6fb9842575b03497$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = $6fb9842575b03497$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = '*';
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $6fb9842575b03497$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($6fb9842575b03497$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = '*';
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case '=':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($6fb9842575b03497$var$_.isElement(query)) return [
            query
        ];
        else if ($6fb9842575b03497$var$_.isObject(query) && !$6fb9842575b03497$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $6fb9842575b03497$var$CAMPAIGN_KEYWORDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_source_platform',
    'utm_campaign_id',
    'utm_creative_format',
    'utm_marketing_tactic'
];
var $6fb9842575b03497$var$CLICK_IDS = [
    'dclid',
    'fbclid',
    'gclid',
    'ko_click_id',
    'li_fat_id',
    'msclkid',
    'sccid',
    'ttclid',
    'twclid',
    'wbraid'
];
$6fb9842575b03497$var$_.info = {
    campaignParams: function(default_value) {
        var kw = '', params = {};
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $6fb9842575b03497$var$_.getQueryParam($6fb9842575b03497$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = '', params = {};
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$CLICK_IDS, function(idkey) {
            id = $6fb9842575b03497$var$_.getQueryParam($6fb9842575b03497$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.info.campaignParams(), $6fb9842575b03497$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) return 'google';
        else if (referrer.search('https?://(.*)bing.com') === 0) return 'bing';
        else if (referrer.search('https?://(.*)yahoo.com') === 0) return 'yahoo';
        else if (referrer.search('https?://(.*)duckduckgo.com') === 0) return 'duckduckgo';
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $6fb9842575b03497$var$_.info.searchEngine(referrer), param = search != 'yahoo' ? 'q' : 'p', ret = {};
        if (search !== null) {
            ret['$search_engine'] = search;
            var keyword = $6fb9842575b03497$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret['mp_keyword'] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || $6fb9842575b03497$var$_.includes(user_agent, ' OPR/')) {
            if ($6fb9842575b03497$var$_.includes(user_agent, 'Mini')) return 'Opera Mini';
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'IEMobile') || $6fb9842575b03497$var$_.includes(user_agent, 'WPDesktop')) return 'Internet Explorer Mobile';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'SamsungBrowser/')) // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Edge') || $6fb9842575b03497$var$_.includes(user_agent, 'Edg/')) return 'Microsoft Edge';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'FBIOS')) return 'Facebook Mobile';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Chrome')) return 'Chrome';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'CriOS')) return 'Chrome iOS';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'UCWEB') || $6fb9842575b03497$var$_.includes(user_agent, 'UCBrowser')) return 'UC Browser';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'FxiOS')) return 'Firefox iOS';
        else if ($6fb9842575b03497$var$_.includes(vendor, 'Apple')) {
            if ($6fb9842575b03497$var$_.includes(user_agent, 'Mobile')) return 'Mobile Safari';
            return 'Safari';
        } else if ($6fb9842575b03497$var$_.includes(user_agent, 'Android')) return 'Android Mobile';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Konqueror')) return 'Konqueror';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Firefox')) return 'Firefox';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'MSIE') || $6fb9842575b03497$var$_.includes(user_agent, 'Trident/')) return 'Internet Explorer';
        else if ($6fb9842575b03497$var$_.includes(user_agent, 'Gecko')) return 'Mozilla';
        else return '';
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $6fb9842575b03497$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $6fb9842575b03497$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return 'Windows Phone';
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) return 'iOS';
        else if (/Android/.test(a)) return 'Android';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return 'BlackBerry';
        else if (/Mac/i.test(a)) return 'Mac OS X';
        else if (/Linux/.test(a)) return 'Linux';
        else if (/CrOS/.test(a)) return 'Chrome OS';
        else return '';
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return 'Windows Phone';
        else if (/iPad/.test(user_agent)) return 'iPad';
        else if (/iPod/.test(user_agent)) return 'iPod Touch';
        else if (/iPhone/.test(user_agent)) return 'iPhone';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (/Android/.test(user_agent)) return 'Android';
        else return '';
    },
    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) return split[2];
        return '';
    },
    currentUrl: function() {
        return $6fb9842575b03497$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== 'object') extra_props = {};
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.strip_empty_properties({
            '$os': $6fb9842575b03497$var$_.info.os(),
            '$browser': $6fb9842575b03497$var$_.info.browser($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera),
            '$referrer': $6fb9842575b03497$var$document$1.referrer,
            '$referring_domain': $6fb9842575b03497$var$_.info.referringDomain($6fb9842575b03497$var$document$1.referrer),
            '$device': $6fb9842575b03497$var$_.info.device($6fb9842575b03497$var$userAgent)
        }), {
            '$current_url': $6fb9842575b03497$var$_.info.currentUrl(),
            '$browser_version': $6fb9842575b03497$var$_.info.browserVersion($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera),
            '$screen_height': $6fb9842575b03497$var$screen.height,
            '$screen_width': $6fb9842575b03497$var$screen.width,
            'mp_lib': 'web',
            '$lib_version': $6fb9842575b03497$var$Config.LIB_VERSION,
            '$insert_id': $6fb9842575b03497$var$cheap_guid(),
            'time': $6fb9842575b03497$var$_.timestamp() / 1000 // epoch time in seconds
        }, $6fb9842575b03497$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.strip_empty_properties({
            '$os': $6fb9842575b03497$var$_.info.os(),
            '$browser': $6fb9842575b03497$var$_.info.browser($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera)
        }), {
            '$browser_version': $6fb9842575b03497$var$_.info.browserVersion($6fb9842575b03497$var$userAgent, $6fb9842575b03497$var$navigator.vendor, $6fb9842575b03497$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $6fb9842575b03497$var$_.strip_empty_properties({
            'current_page_title': $6fb9842575b03497$var$document$1.title,
            'current_domain': $6fb9842575b03497$var$win.location.hostname,
            'current_url_path': $6fb9842575b03497$var$win.location.pathname,
            'current_url_protocol': $6fb9842575b03497$var$win.location.protocol,
            'current_url_search': $6fb9842575b03497$var$win.location.search
        });
    }
};
/**
 * Returns a throttled function that will only run at most every `waitMs` and returns a promise that resolves with the next invocation.
 * Throttled calls will build up a batch of args and invoke the callback with all args since the last invocation.
 */ var $6fb9842575b03497$var$batchedThrottle = function(fn, waitMs) {
    var timeoutPromise = null;
    var throttledItems = [];
    return function(item) {
        var self = this;
        throttledItems.push(item);
        if (!timeoutPromise) timeoutPromise = new $6fb9842575b03497$var$PromisePolyfill(function(resolve) {
            setTimeout(function() {
                var returnValue = fn.apply(self, [
                    throttledItems
                ]);
                timeoutPromise = null;
                throttledItems = [];
                resolve(returnValue);
            }, waitMs);
        });
        return timeoutPromise;
    };
};
var $6fb9842575b03497$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $6fb9842575b03497$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $6fb9842575b03497$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $6fb9842575b03497$var$extract_domain = function(hostname) {
    var domain_regex = $6fb9842575b03497$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') domain_regex = $6fb9842575b03497$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};
/**
 * Check whether we have network connection. default to true for browsers that don't support navigator.onLine (IE)
 * @returns {boolean}
 */ var $6fb9842575b03497$var$isOnline = function() {
    var onLine = $6fb9842575b03497$var$win.navigator['onLine'];
    return $6fb9842575b03497$var$_.isUndefined(onLine) || onLine;
};
var $6fb9842575b03497$var$NOOP_FUNC = function() {};
var $6fb9842575b03497$var$JSONStringify = null, $6fb9842575b03497$var$JSONParse = null;
if (typeof JSON !== 'undefined') {
    $6fb9842575b03497$var$JSONStringify = JSON.stringify;
    $6fb9842575b03497$var$JSONParse = JSON.parse;
}
$6fb9842575b03497$var$JSONStringify = $6fb9842575b03497$var$JSONStringify || $6fb9842575b03497$var$_.JSONEncode;
$6fb9842575b03497$var$JSONParse = $6fb9842575b03497$var$JSONParse || $6fb9842575b03497$var$_.JSONDecode;
// UNMINIFIED EXPORTS (for closure compiler)
$6fb9842575b03497$var$_['info'] = $6fb9842575b03497$var$_.info;
$6fb9842575b03497$var$_['info']['browser'] = $6fb9842575b03497$var$_.info.browser;
$6fb9842575b03497$var$_['info']['browserVersion'] = $6fb9842575b03497$var$_.info.browserVersion;
$6fb9842575b03497$var$_['info']['device'] = $6fb9842575b03497$var$_.info.device;
$6fb9842575b03497$var$_['info']['properties'] = $6fb9842575b03497$var$_.info.properties;
$6fb9842575b03497$var$_['isBlockedUA'] = $6fb9842575b03497$var$_.isBlockedUA;
$6fb9842575b03497$var$_['isEmptyObject'] = $6fb9842575b03497$var$_.isEmptyObject;
$6fb9842575b03497$var$_['isObject'] = $6fb9842575b03497$var$_.isObject;
$6fb9842575b03497$var$_['JSONDecode'] = $6fb9842575b03497$var$_.JSONDecode;
$6fb9842575b03497$var$_['JSONEncode'] = $6fb9842575b03497$var$_.JSONEncode;
$6fb9842575b03497$var$_['toArray'] = $6fb9842575b03497$var$_.toArray;
$6fb9842575b03497$var$_['NPO'] = $6fb9842575b03497$var$NpoPromise;
var $6fb9842575b03497$var$MIXPANEL_DB_NAME = 'mixpanelBrowserDb';
var $6fb9842575b03497$var$RECORDING_EVENTS_STORE_NAME = 'mixpanelRecordingEvents';
var $6fb9842575b03497$var$RECORDING_REGISTRY_STORE_NAME = 'mixpanelRecordingRegistry';
// note: increment the version number when adding new object stores
var $6fb9842575b03497$var$DB_VERSION = 1;
var $6fb9842575b03497$var$OBJECT_STORES = [
    $6fb9842575b03497$var$RECORDING_EVENTS_STORE_NAME,
    $6fb9842575b03497$var$RECORDING_REGISTRY_STORE_NAME
];
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $6fb9842575b03497$var$IDBStorageWrapper = function(storeName) {
    /**
     * @type {Promise<IDBDatabase>|null}
     */ this.dbPromise = null;
    this.storeName = storeName;
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype._openDb = function() {
    return new $6fb9842575b03497$var$PromisePolyfill(function(resolve, reject) {
        var openRequest = $6fb9842575b03497$var$win.indexedDB.open($6fb9842575b03497$var$MIXPANEL_DB_NAME, $6fb9842575b03497$var$DB_VERSION);
        openRequest['onerror'] = function() {
            reject(openRequest.error);
        };
        openRequest['onsuccess'] = function() {
            resolve(openRequest.result);
        };
        openRequest['onupgradeneeded'] = function(ev) {
            var db = ev.target.result;
            $6fb9842575b03497$var$OBJECT_STORES.forEach(function(storeName) {
                db.createObjectStore(storeName);
            });
        };
    });
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.init = function() {
    if (!$6fb9842575b03497$var$win.indexedDB) return $6fb9842575b03497$var$PromisePolyfill.reject('indexedDB is not supported in this browser');
    if (!this.dbPromise) this.dbPromise = this._openDb();
    return this.dbPromise.then(function(dbOrError) {
        if (dbOrError instanceof $6fb9842575b03497$var$win['IDBDatabase']) return $6fb9842575b03497$var$PromisePolyfill.resolve();
        else return $6fb9842575b03497$var$PromisePolyfill.reject(dbOrError);
    });
};
/**
 * @param {IDBTransactionMode} mode
 * @param {function(IDBObjectStore): void} storeCb
 */ $6fb9842575b03497$var$IDBStorageWrapper.prototype.makeTransaction = function(mode, storeCb) {
    var storeName = this.storeName;
    var doTransaction = function(db) {
        return new $6fb9842575b03497$var$PromisePolyfill(function(resolve, reject) {
            var transaction = db.transaction(storeName, mode);
            transaction.oncomplete = function() {
                resolve(transaction);
            };
            transaction.onabort = transaction.onerror = function() {
                reject(transaction.error);
            };
            storeCb(transaction.objectStore(storeName));
        });
    };
    return this.dbPromise.then(doTransaction).catch((function(err) {
        if (err && err['name'] === 'InvalidStateError') {
            // try reopening the DB if the connection is closed
            this.dbPromise = this._openDb();
            return this.dbPromise.then(doTransaction);
        } else return $6fb9842575b03497$var$PromisePolyfill.reject(err);
    }).bind(this));
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.setItem = function(key, value) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.put(value, key);
    });
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.getItem = function(key) {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.get(key);
    }).then(function() {
        return req.result;
    });
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.removeItem = function(key) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.delete(key);
    });
};
$6fb9842575b03497$var$IDBStorageWrapper.prototype.getAll = function() {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.getAll();
    }).then(function() {
        return req.result;
    });
};
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $6fb9842575b03497$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$optIn(token, options) {
    $6fb9842575b03497$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $6fb9842575b03497$var$optOut(token, options) {
    $6fb9842575b03497$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $6fb9842575b03497$var$hasOptedIn(token, options) {
    return $6fb9842575b03497$var$_getStorageValue(token, options) === '1';
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $6fb9842575b03497$var$hasOptedOut(token, options) {
    if ($6fb9842575b03497$var$_hasDoNotTrackFlagOn(options)) {
        $6fb9842575b03497$var$console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $6fb9842575b03497$var$_getStorageValue(token, options) === '0';
    if (optedOut) $6fb9842575b03497$var$console$1.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelLib(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(method) {
    return $6fb9842575b03497$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$clearOptInOut(token, options) {
    options = options || {};
    $6fb9842575b03497$var$_getStorage(options).remove($6fb9842575b03497$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $6fb9842575b03497$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? $6fb9842575b03497$var$_.localStorage : $6fb9842575b03497$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $6fb9842575b03497$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $6fb9842575b03497$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $6fb9842575b03497$var$_getStorageValue(token, options) {
    return $6fb9842575b03497$var$_getStorage(options).get($6fb9842575b03497$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $6fb9842575b03497$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $6fb9842575b03497$var$win;
    var nav = win$1['navigator'] || {};
    var hasDntOn = false;
    $6fb9842575b03497$var$_.each([
        nav['doNotTrack'],
        nav['msDoNotTrack'],
        win$1['doNotTrack']
    ], function(dntValue) {
        if ($6fb9842575b03497$var$_.includes([
            true,
            1,
            '1',
            'yes'
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6fb9842575b03497$var$_optInOut(optValue, token, options) {
    if (!$6fb9842575b03497$var$_.isString(token) || !token.length) {
        $6fb9842575b03497$var$console$1.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }
    options = options || {};
    $6fb9842575b03497$var$_getStorage(options).set($6fb9842575b03497$var$_getStorageKey(token, options), optValue ? 1 : 0, $6fb9842575b03497$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || '$opt_in', options.trackProperties, {
        'send_immediately': true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6fb9842575b03497$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
            if (token) optedOut = $6fb9842575b03497$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $6fb9842575b03497$var$console$1.error('Unexpected error when checking tracking opt-out status: ' + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') callback(0);
        return;
    };
}
var $6fb9842575b03497$var$logger$6 = $6fb9842575b03497$var$console_with_prefix('lock');
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $6fb9842575b03497$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || $6fb9842575b03497$var$win.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
    // dependency-inject promise implementation for testing purposes
    this.promiseImpl = options.promiseImpl || $6fb9842575b03497$var$PromisePolyfill;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$6fb9842575b03497$var$SharedLock.prototype.withLock = function(lockedCB, pid) {
    var Promise1 = this.promiseImpl;
    return new Promise1($6fb9842575b03497$var$_.bind(function(resolve, reject) {
        var i = pid || new Date().getTime() + '|' + Math.random();
        var startTime = new Date().getTime();
        var key = this.storageKey;
        var pollIntervalMS = this.pollIntervalMS;
        var timeoutMS = this.timeoutMS;
        var storage = this.storage;
        var keyX = key + ':X';
        var keyY = key + ':Y';
        var keyZ = key + ':Z';
        var delay = function(cb) {
            if (new Date().getTime() - startTime > timeoutMS) {
                $6fb9842575b03497$var$logger$6.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
                storage.removeItem(keyZ);
                storage.removeItem(keyY);
                loop();
                return;
            }
            setTimeout(function() {
                try {
                    cb();
                } catch (err) {
                    reject(err);
                }
            }, pollIntervalMS * (Math.random() + 0.1));
        };
        var waitFor = function(predicate, cb) {
            if (predicate()) cb();
            else delay(function() {
                waitFor(predicate, cb);
            });
        };
        var getSetY = function() {
            var valY = storage.getItem(keyY);
            if (valY && valY !== i) return false;
            else {
                storage.setItem(keyY, i);
                if (storage.getItem(keyY) === i) return true;
                else {
                    if (!$6fb9842575b03497$var$localStorageSupported(storage, true)) reject(new Error('localStorage support dropped while acquiring lock'));
                    return false;
                }
            }
        };
        var loop = function() {
            storage.setItem(keyX, i);
            waitFor(getSetY, function() {
                if (storage.getItem(keyX) === i) {
                    criticalSection();
                    return;
                }
                delay(function() {
                    if (storage.getItem(keyY) !== i) {
                        loop();
                        return;
                    }
                    waitFor(function() {
                        return !storage.getItem(keyZ);
                    }, criticalSection);
                });
            });
        };
        var criticalSection = function() {
            storage.setItem(keyZ, '1');
            var removeLock = function() {
                storage.removeItem(keyZ);
                if (storage.getItem(keyY) === i) storage.removeItem(keyY);
                if (storage.getItem(keyX) === i) storage.removeItem(keyX);
            };
            lockedCB().then(function(ret) {
                removeLock();
                resolve(ret);
            }).catch(function(err) {
                removeLock();
                reject(err);
            });
        };
        try {
            if ($6fb9842575b03497$var$localStorageSupported(storage, true)) loop();
            else throw new Error('localStorage support check failed');
        } catch (err) {
            reject(err);
        }
    }, this));
};
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $6fb9842575b03497$var$LocalStorageWrapper = function(storageOverride) {
    this.storage = storageOverride || $6fb9842575b03497$var$win.localStorage;
};
$6fb9842575b03497$var$LocalStorageWrapper.prototype.init = function() {
    return $6fb9842575b03497$var$PromisePolyfill.resolve();
};
$6fb9842575b03497$var$LocalStorageWrapper.prototype.setItem = function(key, value) {
    return new $6fb9842575b03497$var$PromisePolyfill($6fb9842575b03497$var$_.bind(function(resolve, reject) {
        try {
            this.storage.setItem(key, $6fb9842575b03497$var$JSONStringify(value));
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
$6fb9842575b03497$var$LocalStorageWrapper.prototype.getItem = function(key) {
    return new $6fb9842575b03497$var$PromisePolyfill($6fb9842575b03497$var$_.bind(function(resolve, reject) {
        var item;
        try {
            item = $6fb9842575b03497$var$JSONParse(this.storage.getItem(key));
        } catch (e) {
            reject(e);
        }
        resolve(item);
    }, this));
};
$6fb9842575b03497$var$LocalStorageWrapper.prototype.removeItem = function(key) {
    return new $6fb9842575b03497$var$PromisePolyfill($6fb9842575b03497$var$_.bind(function(resolve, reject) {
        try {
            this.storage.removeItem(key);
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
var $6fb9842575b03497$var$logger$5 = $6fb9842575b03497$var$console_with_prefix('batch');
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $6fb9842575b03497$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.usePersistence = options.usePersistence;
    if (this.usePersistence) {
        this.queueStorage = options.queueStorage || new $6fb9842575b03497$var$LocalStorageWrapper();
        this.lock = new $6fb9842575b03497$var$SharedLock(storageKey, {
            storage: options.sharedLockStorage || $6fb9842575b03497$var$win.localStorage,
            timeoutMS: options.sharedLockTimeoutMS
        });
    }
    this.reportError = options.errorReporter || $6fb9842575b03497$var$_.bind($6fb9842575b03497$var$logger$5.error, $6fb9842575b03497$var$logger$5);
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
    this.initialized = false;
    if (options.enqueueThrottleMs) this.enqueuePersisted = $6fb9842575b03497$var$batchedThrottle($6fb9842575b03497$var$_.bind(this._enqueuePersisted, this), options.enqueueThrottleMs);
    else this.enqueuePersisted = $6fb9842575b03497$var$_.bind(function(queueEntry) {
        return this._enqueuePersisted([
            queueEntry
        ]);
    }, this);
};
$6fb9842575b03497$var$RequestQueue.prototype.ensureInit = function() {
    if (this.initialized) return $6fb9842575b03497$var$PromisePolyfill.resolve();
    return this.queueStorage.init().then($6fb9842575b03497$var$_.bind(function() {
        this.initialized = true;
    }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error initializing queue persistence. Disabling persistence', err);
        this.initialized = true;
        this.usePersistence = false;
    }, this));
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $6fb9842575b03497$var$RequestQueue.prototype.enqueue = function(item, flushInterval) {
    var queueEntry = {
        'id': $6fb9842575b03497$var$cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        return $6fb9842575b03497$var$PromisePolyfill.resolve(true);
    } else return this.enqueuePersisted(queueEntry);
};
$6fb9842575b03497$var$RequestQueue.prototype._enqueuePersisted = function(queueEntries) {
    var enqueueItem = $6fb9842575b03497$var$_.bind(function() {
        return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
            return this.saveToStorage(storedQueue.concat(queueEntries));
        }, this)).then($6fb9842575b03497$var$_.bind(function(succeeded) {
            // only add to in-memory queue when storage succeeds
            if (succeeded) this.memQueue = this.memQueue.concat(queueEntries);
            return succeeded;
        }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
            this.reportError('Error enqueueing items', err, queueEntries);
            return false;
        }, this));
    }, this);
    return this.lock.withLock(enqueueItem, this.pid).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $6fb9842575b03497$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) // don't need lock just to read events; localStorage is thread-safe
    // and the worst that could happen is a duplicate send of some
    // orphaned events, which will be deduplicated on the server side
    return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
        return this.readFromStorage();
    }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $6fb9842575b03497$var$_.each(batch, function(item) {
                idsInBatch[item['id']] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
        return batch;
    }, this));
    else return $6fb9842575b03497$var$PromisePolyfill.resolve(batch);
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $6fb9842575b03497$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $6fb9842575b03497$var$_.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $6fb9842575b03497$var$RequestQueue.prototype.removeItemsByID = function(ids) {
    var idSet = {}; // poor man's Set
    $6fb9842575b03497$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $6fb9842575b03497$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) return $6fb9842575b03497$var$PromisePolyfill.resolve(true);
    else {
        var removeFromStorage = $6fb9842575b03497$var$_.bind(function() {
            return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
                storedQueue = $6fb9842575b03497$var$filterOutIDsAndInvalid(storedQueue, idSet);
                return this.saveToStorage(storedQueue);
            }, this)).then($6fb9842575b03497$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
                // an extra check: did storage report success but somehow
                // the items are still there?
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) throw new Error('Item not removed from storage');
                }
                return true;
            }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
                this.reportError('Error removing items', err, ids);
                return false;
            }, this));
        }, this);
        return this.lock.withLock(removeFromStorage, this.pid).catch($6fb9842575b03497$var$_.bind(function(err) {
            this.reportError('Error acquiring storage lock', err);
            if (!$6fb9842575b03497$var$localStorageSupported(this.lock.storage, true)) // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            return removeFromStorage().then($6fb9842575b03497$var$_.bind(function(success) {
                if (!success) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                return this.queueStorage.removeItem(this.storageKey).then(function() {
                    return success;
                });
                return success;
            }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
                this.reportError('Error clearing queue', err);
                return false;
            }, this));
            else return false;
        }, this));
    }
};
// internal helper for RequestQueue.updatePayloads
var $6fb9842575b03497$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $6fb9842575b03497$var$_.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $6fb9842575b03497$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate) {
    this.memQueue = $6fb9842575b03497$var$updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) return $6fb9842575b03497$var$PromisePolyfill.resolve(true);
    else return this.lock.withLock($6fb9842575b03497$var$_.bind(function lockAcquired() {
        return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($6fb9842575b03497$var$_.bind(function(storedQueue) {
            storedQueue = $6fb9842575b03497$var$updatePayloads(storedQueue, itemsToUpdate);
            return this.saveToStorage(storedQueue);
        }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
            this.reportError('Error updating items', itemsToUpdate, err);
            return false;
        }, this));
    }, this), this.pid).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $6fb9842575b03497$var$RequestQueue.prototype.readFromStorage = function() {
    return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
        return this.queueStorage.getItem(this.storageKey);
    }, this)).then($6fb9842575b03497$var$_.bind(function(storageEntry) {
        if (storageEntry) {
            if (!$6fb9842575b03497$var$_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
        return storageEntry || [];
    }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error retrieving queue', err);
        return [];
    }, this));
};
/**
 * Serialize the given items array to localStorage.
 */ $6fb9842575b03497$var$RequestQueue.prototype.saveToStorage = function(queue) {
    return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
        return this.queueStorage.setItem(this.storageKey, queue);
    }, this)).then(function() {
        return true;
    }).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error saving queue', err);
        return false;
    }, this));
};
/**
 * Clear out queues (memory and localStorage).
 */ $6fb9842575b03497$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) return this.ensureInit().then($6fb9842575b03497$var$_.bind(function() {
        return this.queueStorage.removeItem(this.storageKey);
    }, this));
    else return $6fb9842575b03497$var$PromisePolyfill.resolve();
};
// maximum interval between request retries after exponential backoff
var $6fb9842575b03497$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $6fb9842575b03497$var$logger$4 = $6fb9842575b03497$var$console_with_prefix('batch');
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $6fb9842575b03497$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $6fb9842575b03497$var$RequestQueue(storageKey, {
        errorReporter: $6fb9842575b03497$var$_.bind(this.reportError, this),
        queueStorage: options.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        sharedLockTimeoutMS: options.sharedLockTimeoutMS,
        usePersistence: options.usePersistence,
        enqueueThrottleMs: options.enqueueThrottleMs
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
    this._flushPromise = null;
};
/**
 * Add one item to queue.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.enqueue = function(item) {
    return this.queue.enqueue(item, this.flushInterval);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    return this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $6fb9842575b03497$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.clear = function() {
    return this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($6fb9842575b03497$var$_.bind(function() {
        if (!this.stopped) this._flushPromise = this.flush();
    }, this), this.flushInterval);
};
/**
 * Send a request using the sendRequest callback, but promisified.
 * TODO: sendRequest should be promisified in the first place.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.sendRequestPromise = function(data, options) {
    return new $6fb9842575b03497$var$PromisePolyfill($6fb9842575b03497$var$_.bind(function(resolve) {
        this.sendRequest(data, options, resolve);
    }, this));
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $6fb9842575b03497$var$RequestBatcher.prototype.flush = function(options) {
    if (this.requestInProgress) {
        $6fb9842575b03497$var$logger$4.log('Flush: Request already in progress');
        return $6fb9842575b03497$var$PromisePolyfill.resolve();
    }
    this.requestInProgress = true;
    options = options || {};
    var timeoutMS = this.libConfig['batch_request_timeout_ms'];
    var startTime = new Date().getTime();
    var currentBatchSize = this.batchSize;
    return this.queue.fillBatch(currentBatchSize).then($6fb9842575b03497$var$_.bind(function(batch) {
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        $6fb9842575b03497$var$_.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) payload['properties'] = $6fb9842575b03497$var$_.extend({}, payload['properties'], {
                    'mp_sent_by_lib_version': $6fb9842575b03497$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError('[dupe] found item with no ID', {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.requestInProgress = false;
            this.resetFlush();
            return $6fb9842575b03497$var$PromisePolyfill.resolve(); // nothing to do
        }
        var removeItemsFromQueue = $6fb9842575b03497$var$_.bind(function() {
            return this.queue.removeItemsByID($6fb9842575b03497$var$_.map(batch, function(item) {
                return item['id'];
            })).then($6fb9842575b03497$var$_.bind(function(succeeded) {
                // client-side dedupe
                $6fb9842575b03497$var$_.each(batch, $6fb9842575b03497$var$_.bind(function(item) {
                    var itemId = item['id'];
                    if (itemId) {
                        this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                        this.itemIdsSentSuccessfully[itemId]++;
                        if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError('[dupe] item ID sent too many times', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                    } else this.reportError('[dupe] found item with no ID while removing', {
                        item: item
                    });
                }, this));
                if (succeeded) {
                    this.consecutiveRemovalFailures = 0;
                    if (this.flushOnlyOnInterval && !attemptSecondaryFlush) {
                        this.resetFlush(); // schedule next batch with a delay
                        return $6fb9842575b03497$var$PromisePolyfill.resolve();
                    } else return this.flush(); // handle next batch if the queue isn't empty
                } else {
                    if (++this.consecutiveRemovalFailures > 5) {
                        this.reportError('Too many queue failures; disabling batching system.');
                        this.stopAllBatching();
                    } else this.resetFlush();
                    return $6fb9842575b03497$var$PromisePolyfill.resolve();
                }
            }, this));
        }, this);
        var batchSendCallback = $6fb9842575b03497$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                if (options.unloading) // update persisted data to include hook transformations
                return this.queue.updatePayloads(transformedItems);
                else if ($6fb9842575b03497$var$_.isObject(res) && res.error === 'timeout' && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError('Network timeout; retrying');
                    return this.flush();
                } else if ($6fb9842575b03497$var$_.isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.httpStatusCode <= 0 && !$6fb9842575b03497$var$isOnline() || res.error === 'timeout')) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min($6fb9842575b03497$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                    return $6fb9842575b03497$var$PromisePolyfill.resolve();
                } else if ($6fb9842575b03497$var$_.isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                        return $6fb9842575b03497$var$PromisePolyfill.resolve();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        return removeItemsFromQueue();
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                return removeItemsFromQueue();
            } catch (err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = 'sendBeacon';
        $6fb9842575b03497$var$logger$4.log('MIXPANEL REQUEST:', dataForRequest);
        return this.sendRequestPromise(dataForRequest, requestOptions).then(batchSendCallback);
    }, this)).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }, this));
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $6fb9842575b03497$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $6fb9842575b03497$var$logger$4.error.apply($6fb9842575b03497$var$logger$4.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$logger$4.error(err);
    }
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 * @returns {boolean}
 */ var $6fb9842575b03497$var$isRecordingExpired = function(serializedRecording) {
    var now = Date.now();
    return !serializedRecording || now > serializedRecording['maxExpires'] || now > serializedRecording['idleExpires'];
};
var $6fb9842575b03497$var$RECORD_ENQUEUE_THROTTLE_MS = 250;
var $6fb9842575b03497$var$logger$3 = $6fb9842575b03497$var$console_with_prefix('recorder');
var $6fb9842575b03497$var$CompressionStream = $6fb9842575b03497$var$win['CompressionStream'];
var $6fb9842575b03497$var$RECORDER_BATCHER_LIB_CONFIG = {
    'batch_size': 1000,
    'batch_flush_interval_ms': 10000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true
};
var $6fb9842575b03497$var$ACTIVE_SOURCES = new Set([
    $6fb9842575b03497$var$IncrementalSource.MouseMove,
    $6fb9842575b03497$var$IncrementalSource.MouseInteraction,
    $6fb9842575b03497$var$IncrementalSource.Scroll,
    $6fb9842575b03497$var$IncrementalSource.ViewportResize,
    $6fb9842575b03497$var$IncrementalSource.Input,
    $6fb9842575b03497$var$IncrementalSource.TouchMove,
    $6fb9842575b03497$var$IncrementalSource.MediaInteraction,
    $6fb9842575b03497$var$IncrementalSource.Drag,
    $6fb9842575b03497$var$IncrementalSource.Selection
]);
function $6fb9842575b03497$var$isUserEvent(ev) {
    return ev.type === $6fb9842575b03497$var$EventType.IncrementalSnapshot && $6fb9842575b03497$var$ACTIVE_SOURCES.has(ev.data.source);
}
/**
 * @typedef {Object} SerializedRecording
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayId
 * @property {string} tabId
 * @property {string} replayStartUrl
 */ /**
 * @typedef {Object} SessionRecordingOptions
 * @property {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
 * @property {String} [options.replayId] - unique uuid for a single replay
 * @property {Function} [options.onIdleTimeout] - callback when a recording reaches idle timeout
 * @property {Function} [options.onMaxLengthReached] - callback when a recording reaches its maximum length
 * @property {Function} [options.rrwebRecord] - rrweb's `record` function
 * @property {Function} [options.onBatchSent] - callback when a batch of events is sent to the server
 * @property {Storage} [options.sharedLockStorage] - optional storage for shared lock, used for test dependency injection
 * optional properties for deserialization:
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayStartUrl
 */ /**
 * This class encapsulates a single session recording and its lifecycle.
 * @param {SessionRecordingOptions} options
 */ var $6fb9842575b03497$var$SessionRecording = function(options) {
    this._mixpanel = options.mixpanelInstance;
    this._onIdleTimeout = options.onIdleTimeout || $6fb9842575b03497$var$NOOP_FUNC;
    this._onMaxLengthReached = options.onMaxLengthReached || $6fb9842575b03497$var$NOOP_FUNC;
    this._onBatchSent = options.onBatchSent || $6fb9842575b03497$var$NOOP_FUNC;
    this._rrwebRecord = options.rrwebRecord || null;
    // internal rrweb stopRecording function
    this._stopRecording = null;
    this.replayId = options.replayId;
    this.batchStartUrl = options.batchStartUrl || null;
    this.replayStartUrl = options.replayStartUrl || null;
    this.idleExpires = options.idleExpires || null;
    this.maxExpires = options.maxExpires || null;
    this.replayStartTime = options.replayStartTime || null;
    this.seqNo = options.seqNo || 0;
    this.idleTimeoutId = null;
    this.maxTimeoutId = null;
    this.recordMaxMs = $6fb9842575b03497$var$MAX_RECORDING_MS;
    this.recordMinMs = 0;
    // disable persistence if localStorage is not supported
    // request-queue will automatically disable persistence if indexedDB fails to initialize
    var usePersistence = $6fb9842575b03497$var$localStorageSupported(options.sharedLockStorage, true);
    // each replay has its own batcher key to avoid conflicts between rrweb events of different recordings
    // this will be important when persistence is introduced
    this.batcherKey = '__mprec_' + this.getConfig('name') + '_' + this.getConfig('token') + '_' + this.replayId;
    this.queueStorage = new $6fb9842575b03497$var$IDBStorageWrapper($6fb9842575b03497$var$RECORDING_EVENTS_STORE_NAME);
    this.batcher = new $6fb9842575b03497$var$RequestBatcher(this.batcherKey, {
        errorReporter: this.reportError.bind(this),
        flushOnlyOnInterval: true,
        libConfig: $6fb9842575b03497$var$RECORDER_BATCHER_LIB_CONFIG,
        sendRequestFunc: this.flushEventsWithOptOut.bind(this),
        queueStorage: this.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        usePersistence: usePersistence,
        stopAllBatchingFunc: this.stopRecording.bind(this),
        // increased throttle and shared lock timeout because recording events are very high frequency.
        // this will minimize the amount of lock contention between enqueued events.
        // for session recordings there is a lock for each tab anyway, so there's no risk of deadlock between tabs.
        enqueueThrottleMs: $6fb9842575b03497$var$RECORD_ENQUEUE_THROTTLE_MS,
        sharedLockTimeoutMS: 10000
    });
};
$6fb9842575b03497$var$SessionRecording.prototype.unloadPersistedData = function() {
    this.batcher.stop();
    return this.batcher.flush().then((function() {
        return this.queueStorage.removeItem(this.batcherKey);
    }).bind(this));
};
$6fb9842575b03497$var$SessionRecording.prototype.getConfig = function(configVar) {
    return this._mixpanel.get_config(configVar);
};
// Alias for getConfig, used by the common addOptOutCheckMixpanelLib function which
// reaches into this class instance and expects the snake case version of the function.
// eslint-disable-next-line camelcase
$6fb9842575b03497$var$SessionRecording.prototype.get_config = function(configVar) {
    return this.getConfig(configVar);
};
$6fb9842575b03497$var$SessionRecording.prototype.startRecording = function(shouldStopBatcher) {
    if (this._rrwebRecord === null) {
        this.reportError('rrweb record function not provided. ');
        return;
    }
    if (this._stopRecording !== null) {
        $6fb9842575b03497$var$logger$3.log('Recording already in progress, skipping startRecording.');
        return;
    }
    this.recordMaxMs = this.getConfig('record_max_ms');
    if (this.recordMaxMs > $6fb9842575b03497$var$MAX_RECORDING_MS) {
        this.recordMaxMs = $6fb9842575b03497$var$MAX_RECORDING_MS;
        $6fb9842575b03497$var$logger$3.critical('record_max_ms cannot be greater than ' + $6fb9842575b03497$var$MAX_RECORDING_MS + 'ms. Capping value.');
    }
    if (!this.maxExpires) this.maxExpires = new Date().getTime() + this.recordMaxMs;
    this.recordMinMs = this.getConfig('record_min_ms');
    if (this.recordMinMs > $6fb9842575b03497$var$MAX_VALUE_FOR_MIN_RECORDING_MS) {
        this.recordMinMs = $6fb9842575b03497$var$MAX_VALUE_FOR_MIN_RECORDING_MS;
        $6fb9842575b03497$var$logger$3.critical('record_min_ms cannot be greater than ' + $6fb9842575b03497$var$MAX_VALUE_FOR_MIN_RECORDING_MS + 'ms. Capping value.');
    }
    if (!this.replayStartTime) {
        this.replayStartTime = new Date().getTime();
        this.batchStartUrl = $6fb9842575b03497$var$_.info.currentUrl();
        this.replayStartUrl = $6fb9842575b03497$var$_.info.currentUrl();
    }
    if (shouldStopBatcher || this.recordMinMs > 0) // the primary case for shouldStopBatcher is when we're starting recording after a reset
    // and don't want to send anything over the network until there's
    // actual user activity
    // this also applies if the minimum recording length has not been hit yet
    // so that we don't send data until we know the recording will be long enough
    this.batcher.stop();
    else this.batcher.start();
    var resetIdleTimeout = (function() {
        clearTimeout(this.idleTimeoutId);
        var idleTimeoutMs = this.getConfig('record_idle_timeout_ms');
        this.idleTimeoutId = setTimeout(this._onIdleTimeout, idleTimeoutMs);
        this.idleExpires = new Date().getTime() + idleTimeoutMs;
    }).bind(this);
    resetIdleTimeout();
    var blockSelector = this.getConfig('record_block_selector');
    if (blockSelector === '' || blockSelector === null) blockSelector = undefined;
    try {
        this._stopRecording = this._rrwebRecord({
            'emit': (function(ev) {
                if (this.idleExpires && this.idleExpires < ev.timestamp) {
                    this._onIdleTimeout();
                    return;
                }
                if ($6fb9842575b03497$var$isUserEvent(ev)) {
                    if (this.batcher.stopped && new Date().getTime() - this.replayStartTime >= this.recordMinMs) // start flushing again after user activity
                    this.batcher.start();
                    resetIdleTimeout();
                }
                // promise only used to await during tests
                this.__enqueuePromise = this.batcher.enqueue(ev);
            }).bind(this),
            'blockClass': this.getConfig('record_block_class'),
            'blockSelector': blockSelector,
            'collectFonts': this.getConfig('record_collect_fonts'),
            'dataURLOptions': {
                'type': 'image/webp',
                'quality': 0.6
            },
            'maskAllInputs': true,
            'maskTextClass': this.getConfig('record_mask_text_class'),
            'maskTextSelector': this.getConfig('record_mask_text_selector'),
            'recordCanvas': this.getConfig('record_canvas'),
            'sampling': {
                'canvas': 15
            }
        });
    } catch (err) {
        this.reportError('Unexpected error when starting rrweb recording.', err);
    }
    if (typeof this._stopRecording !== 'function') {
        this.reportError('rrweb failed to start, skipping this recording.');
        this._stopRecording = null;
        this.stopRecording(); // stop batcher looping and any timeouts
        return;
    }
    var maxTimeoutMs = this.maxExpires - new Date().getTime();
    this.maxTimeoutId = setTimeout(this._onMaxLengthReached.bind(this), maxTimeoutMs);
};
$6fb9842575b03497$var$SessionRecording.prototype.stopRecording = function(skipFlush) {
    if (!this.isRrwebStopped()) {
        try {
            this._stopRecording();
        } catch (err) {
            this.reportError('Error with rrweb stopRecording', err);
        }
        this._stopRecording = null;
    }
    var flushPromise;
    if (this.batcher.stopped) // never got user activity to flush after reset, so just clear the batcher
    flushPromise = this.batcher.clear();
    else if (!skipFlush) // flush any remaining events from running batcher
    flushPromise = this.batcher.flush();
    this.batcher.stop();
    clearTimeout(this.idleTimeoutId);
    clearTimeout(this.maxTimeoutId);
    return flushPromise;
};
$6fb9842575b03497$var$SessionRecording.prototype.isRrwebStopped = function() {
    return this._stopRecording === null;
};
/**
 * Flushes the current batch of events to the server, but passes an opt-out callback to make sure
 * we stop recording and dump any queued events if the user has opted out.
 */ $6fb9842575b03497$var$SessionRecording.prototype.flushEventsWithOptOut = function(data, options, cb) {
    var onOptOut = (function(code) {
        // addOptOutCheckMixpanelLib invokes this function with code=0 when the user has opted out
        if (code === 0) {
            this.stopRecording();
            cb({
                error: 'Tracking has been opted out, stopping recording.'
            });
        }
    }).bind(this);
    this._flushEvents(data, options, cb, onOptOut);
};
/**
 * @returns {SerializedRecording}
 */ $6fb9842575b03497$var$SessionRecording.prototype.serialize = function() {
    // don't break if mixpanel instance was destroyed at some point
    var tabId;
    try {
        tabId = this._mixpanel.get_tab_id();
    } catch (e) {
        this.reportError('Error getting tab ID for serialization ', e);
        tabId = null;
    }
    return {
        'replayId': this.replayId,
        'seqNo': this.seqNo,
        'replayStartTime': this.replayStartTime,
        'batchStartUrl': this.batchStartUrl,
        'replayStartUrl': this.replayStartUrl,
        'idleExpires': this.idleExpires,
        'maxExpires': this.maxExpires,
        'tabId': tabId
    };
};
/**
 * @static
 * @param {SerializedRecording} serializedRecording
 * @param {SessionRecordingOptions} options
 * @returns {SessionRecording}
 */ $6fb9842575b03497$var$SessionRecording.deserialize = function(serializedRecording, options) {
    var recording = new $6fb9842575b03497$var$SessionRecording($6fb9842575b03497$var$_.extend({}, options, {
        replayId: serializedRecording['replayId'],
        batchStartUrl: serializedRecording['batchStartUrl'],
        replayStartUrl: serializedRecording['replayStartUrl'],
        idleExpires: serializedRecording['idleExpires'],
        maxExpires: serializedRecording['maxExpires'],
        replayStartTime: serializedRecording['replayStartTime'],
        seqNo: serializedRecording['seqNo'],
        sharedLockStorage: options.sharedLockStorage
    }));
    return recording;
};
$6fb9842575b03497$var$SessionRecording.prototype._sendRequest = function(currentReplayId, reqParams, reqBody, callback) {
    var onSuccess = (function(response, responseBody) {
        // Update batch specific props only if the request was successful to guarantee ordering.
        // RequestBatcher will always flush the next batch after the previous one succeeds.
        // extra check to see if the replay ID has changed so that we don't increment the seqNo on the wrong replay
        if (response.status === 200 && this.replayId === currentReplayId) {
            this.seqNo++;
            this.batchStartUrl = $6fb9842575b03497$var$_.info.currentUrl();
        }
        this._onBatchSent();
        callback({
            status: 0,
            httpStatusCode: response.status,
            responseBody: responseBody,
            retryAfter: response.headers.get('Retry-After')
        });
    }).bind(this);
    $6fb9842575b03497$var$win['fetch'](this.getConfig('api_host') + '/' + this.getConfig('api_routes')['record'] + '?' + new URLSearchParams(reqParams), {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': reqBody
    }).then(function(response) {
        response.json().then(function(responseBody) {
            onSuccess(response, responseBody);
        }).catch(function(error) {
            callback({
                error: error
            });
        });
    }).catch(function(error) {
        callback({
            error: error,
            httpStatusCode: 0
        });
    });
};
$6fb9842575b03497$var$SessionRecording.prototype._flushEvents = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(data, options, callback) {
    var numEvents = data.length;
    if (numEvents > 0) {
        var replayId = this.replayId;
        // each rrweb event has a timestamp - leverage those to get time properties
        var batchStartTime = Infinity;
        var batchEndTime = -Infinity;
        var hasFullSnapshot = false;
        for(var i = 0; i < numEvents; i++){
            batchStartTime = Math.min(batchStartTime, data[i].timestamp);
            batchEndTime = Math.max(batchEndTime, data[i].timestamp);
            if (data[i].type === $6fb9842575b03497$var$EventType.FullSnapshot) hasFullSnapshot = true;
        }
        if (this.seqNo === 0) {
            if (!hasFullSnapshot) {
                callback({
                    error: 'First batch does not contain a full snapshot. Aborting recording.'
                });
                this.stopRecording(true);
                return;
            }
            this.replayStartTime = batchStartTime;
        } else if (!this.replayStartTime) {
            this.reportError('Replay start time not set but seqNo is not 0. Using current batch start time as a fallback.');
            this.replayStartTime = batchStartTime;
        }
        var replayLengthMs = batchEndTime - this.replayStartTime;
        var reqParams = {
            '$current_url': this.batchStartUrl,
            '$lib_version': $6fb9842575b03497$var$Config.LIB_VERSION,
            'batch_start_time': batchStartTime / 1000,
            'distinct_id': String(this._mixpanel.get_distinct_id()),
            'mp_lib': 'web',
            'replay_id': replayId,
            'replay_length_ms': replayLengthMs,
            'replay_start_time': this.replayStartTime / 1000,
            'replay_start_url': this.replayStartUrl,
            'seq': this.seqNo
        };
        var eventsJson = JSON.stringify(data);
        // send ID management props if they exist
        var deviceId = this._mixpanel.get_property('$device_id');
        if (deviceId) reqParams['$device_id'] = deviceId;
        var userId = this._mixpanel.get_property('$user_id');
        if (userId) reqParams['$user_id'] = userId;
        if ($6fb9842575b03497$var$CompressionStream) {
            var jsonStream = new Blob([
                eventsJson
            ], {
                type: 'application/json'
            }).stream();
            var gzipStream = jsonStream.pipeThrough(new $6fb9842575b03497$var$CompressionStream('gzip'));
            new Response(gzipStream).blob().then((function(compressedBlob) {
                reqParams['format'] = 'gzip';
                this._sendRequest(replayId, reqParams, compressedBlob, callback);
            }).bind(this));
        } else {
            reqParams['format'] = 'body';
            this._sendRequest(replayId, reqParams, eventsJson, callback);
        }
    }
});
$6fb9842575b03497$var$SessionRecording.prototype.reportError = function(msg, err) {
    $6fb9842575b03497$var$logger$3.error.apply($6fb9842575b03497$var$logger$3.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.getConfig('error_reporter')(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$logger$3.error(err);
    }
};
/**
 * Module for handling the storage and retrieval of recording metadata as well as any active recordings.
 * Makes sure that only one tab can be recording at a time.
 */ var $6fb9842575b03497$var$RecordingRegistry = function(options) {
    this.idb = new $6fb9842575b03497$var$IDBStorageWrapper($6fb9842575b03497$var$RECORDING_REGISTRY_STORE_NAME);
    this.errorReporter = options.errorReporter;
    this.mixpanelInstance = options.mixpanelInstance;
    this.sharedLockStorage = options.sharedLockStorage;
};
$6fb9842575b03497$var$RecordingRegistry.prototype.handleError = function(err) {
    this.errorReporter('IndexedDB error: ', err);
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 */ $6fb9842575b03497$var$RecordingRegistry.prototype.setActiveRecording = function(serializedRecording) {
    var tabId = serializedRecording['tabId'];
    if (!tabId) {
        console.warn('No tab ID is set, cannot persist recording metadata.');
        return $6fb9842575b03497$var$PromisePolyfill.resolve();
    }
    return this.idb.init().then((function() {
        return this.idb.setItem(tabId, serializedRecording);
    }).bind(this)).catch(this.handleError.bind(this));
};
/**
 * @returns {Promise<import('./session-recording').SerializedRecording>}
 */ $6fb9842575b03497$var$RecordingRegistry.prototype.getActiveRecording = function() {
    return this.idb.init().then((function() {
        return this.idb.getItem(this.mixpanelInstance.get_tab_id());
    }).bind(this)).then((function(serializedRecording) {
        return $6fb9842575b03497$var$isRecordingExpired(serializedRecording) ? null : serializedRecording;
    }).bind(this)).catch(this.handleError.bind(this));
};
$6fb9842575b03497$var$RecordingRegistry.prototype.clearActiveRecording = function() {
    // mark recording as expired instead of deleting it in case the page unloads mid-flush and doesn't make it to ingestion.
    // this will ensure the next pageload will flush the remaining events, but not try to continue the recording.
    return this.getActiveRecording().then((function(serializedRecording) {
        if (serializedRecording) {
            serializedRecording['maxExpires'] = 0;
            return this.setActiveRecording(serializedRecording);
        }
    }).bind(this)).catch(this.handleError.bind(this));
};
/**
 * Flush any inactive recordings from the registry to minimize data loss.
 * The main idea here is that we can flush remaining rrweb events on the next page load if a tab is closed mid-batch.
 */ $6fb9842575b03497$var$RecordingRegistry.prototype.flushInactiveRecordings = function() {
    return this.idb.init().then((function() {
        return this.idb.getAll();
    }).bind(this)).then((function(serializedRecordings) {
        // clean up any expired recordings from the registry, non-expired ones may be active in other tabs
        var unloadPromises = serializedRecordings.filter(function(serializedRecording) {
            return $6fb9842575b03497$var$isRecordingExpired(serializedRecording);
        }).map((function(serializedRecording) {
            var sessionRecording = $6fb9842575b03497$var$SessionRecording.deserialize(serializedRecording, {
                mixpanelInstance: this.mixpanelInstance,
                sharedLockStorage: this.sharedLockStorage
            });
            return sessionRecording.unloadPersistedData().then((function() {
                // expired recording was successfully flushed, we can clean it up from the registry
                return this.idb.removeItem(serializedRecording['tabId']);
            }).bind(this)).catch(this.handleError.bind(this));
        }).bind(this));
        return $6fb9842575b03497$var$PromisePolyfill.all(unloadPromises);
    }).bind(this)).catch(this.handleError.bind(this));
};
var $6fb9842575b03497$var$logger$2 = $6fb9842575b03497$var$console_with_prefix('recorder');
/**
 * Recorder API: bundles rrweb and and exposes methods to start and stop recordings.
 * @param {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
*/ var $6fb9842575b03497$var$MixpanelRecorder = function(mixpanelInstance, rrwebRecord, sharedLockStorage) {
    this.mixpanelInstance = mixpanelInstance;
    this.rrwebRecord = rrwebRecord || $6fb9842575b03497$var$record;
    this.sharedLockStorage = sharedLockStorage;
    /**
     * @member {import('./registry').RecordingRegistry}
     */ this.recordingRegistry = new $6fb9842575b03497$var$RecordingRegistry({
        mixpanelInstance: this.mixpanelInstance,
        errorReporter: $6fb9842575b03497$var$logger$2.error,
        sharedLockStorage: sharedLockStorage
    });
    this._flushInactivePromise = this.recordingRegistry.flushInactiveRecordings();
    this.activeRecording = null;
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.startRecording = function(options) {
    options = options || {};
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) {
        $6fb9842575b03497$var$logger$2.log('Recording already in progress, skipping startRecording.');
        return;
    }
    var onIdleTimeout = (function() {
        $6fb9842575b03497$var$logger$2.log('Idle timeout reached, restarting recording.');
        this.resetRecording();
    }).bind(this);
    var onMaxLengthReached = (function() {
        $6fb9842575b03497$var$logger$2.log('Max recording length reached, stopping recording.');
        this.resetRecording();
    }).bind(this);
    var onBatchSent = (function() {
        this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
        this['__flushPromise'] = this.activeRecording.batcher._flushPromise;
    }).bind(this);
    /**
     * @type {import('./session-recording').SessionRecordingOptions}
     */ var sessionRecordingOptions = {
        mixpanelInstance: this.mixpanelInstance,
        onBatchSent: onBatchSent,
        onIdleTimeout: onIdleTimeout,
        onMaxLengthReached: onMaxLengthReached,
        replayId: $6fb9842575b03497$var$_.UUID(),
        rrwebRecord: this.rrwebRecord,
        sharedLockStorage: this.sharedLockStorage
    };
    if (options.activeSerializedRecording) this.activeRecording = $6fb9842575b03497$var$SessionRecording.deserialize(options.activeSerializedRecording, sessionRecordingOptions);
    else this.activeRecording = new $6fb9842575b03497$var$SessionRecording(sessionRecordingOptions);
    this.activeRecording.startRecording(options.shouldStopBatcher);
    return this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.stopRecording = function() {
    var stopPromise = this._stopCurrentRecording(false);
    this.recordingRegistry.clearActiveRecording();
    this.activeRecording = null;
    return stopPromise;
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.pauseRecording = function() {
    return this._stopCurrentRecording(false);
};
$6fb9842575b03497$var$MixpanelRecorder.prototype._stopCurrentRecording = function(skipFlush) {
    if (this.activeRecording) return this.activeRecording.stopRecording(skipFlush);
    return $6fb9842575b03497$var$PromisePolyfill.resolve();
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.resumeRecording = function(startNewIfInactive) {
    if (this.activeRecording && this.activeRecording.isRrwebStopped()) {
        this.activeRecording.startRecording(false);
        return $6fb9842575b03497$var$PromisePolyfill.resolve(null);
    }
    return this.recordingRegistry.getActiveRecording().then((function(activeSerializedRecording) {
        if (activeSerializedRecording) return this.startRecording({
            activeSerializedRecording: activeSerializedRecording
        });
        else if (startNewIfInactive) return this.startRecording({
            shouldStopBatcher: false
        });
        else {
            $6fb9842575b03497$var$logger$2.log('No resumable recording found.');
            return null;
        }
    }).bind(this));
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.resetRecording = function() {
    this.stopRecording();
    this.startRecording({
        shouldStopBatcher: true
    });
};
$6fb9842575b03497$var$MixpanelRecorder.prototype.getActiveReplayId = function() {
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) return this.activeRecording.replayId;
    else return null;
};
// getter so that older mixpanel-core versions can still retrieve the replay ID
// when pulling the latest recorder bundle from the CDN
Object.defineProperty($6fb9842575b03497$var$MixpanelRecorder.prototype, 'replayId', {
    get: function() {
        return this.getActiveReplayId();
    }
});
$6fb9842575b03497$var$win['__mp_recorder'] = $6fb9842575b03497$var$MixpanelRecorder;
// stateless utils
// mostly from https://github.com/mixpanel/mixpanel-js/blob/989ada50f518edab47b9c4fd9535f9fbd5ec5fc0/src/autotrack-utils.js
var $6fb9842575b03497$var$EV_CHANGE = 'change';
var $6fb9842575b03497$var$EV_CLICK = 'click';
var $6fb9842575b03497$var$EV_HASHCHANGE = 'hashchange';
var $6fb9842575b03497$var$EV_MP_LOCATION_CHANGE = 'mp_locationchange';
var $6fb9842575b03497$var$EV_POPSTATE = 'popstate';
// TODO scrollend isn't available in Safari: document or polyfill?
var $6fb9842575b03497$var$EV_SCROLLEND = 'scrollend';
var $6fb9842575b03497$var$EV_SUBMIT = 'submit';
var $6fb9842575b03497$var$CLICK_EVENT_PROPS = [
    'clientX',
    'clientY',
    'offsetX',
    'offsetY',
    'pageX',
    'pageY',
    'screenX',
    'screenY',
    'x',
    'y'
];
var $6fb9842575b03497$var$OPT_IN_CLASSES = [
    'mp-include'
];
var $6fb9842575b03497$var$OPT_OUT_CLASSES = [
    'mp-no-track'
];
var $6fb9842575b03497$var$SENSITIVE_DATA_CLASSES = $6fb9842575b03497$var$OPT_OUT_CLASSES.concat([
    'mp-sensitive'
]);
var $6fb9842575b03497$var$TRACKED_ATTRS = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'href',
    'name',
    'role',
    'title',
    'type'
];
var $6fb9842575b03497$var$logger$1 = $6fb9842575b03497$var$console_with_prefix('autocapture');
function $6fb9842575b03497$var$getClasses(el) {
    var classes = {};
    var classList = $6fb9842575b03497$var$getClassName(el).split(' ');
    for(var i = 0; i < classList.length; i++){
        var cls = classList[i];
        if (cls) classes[cls] = true;
    }
    return classes;
}
/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */ function $6fb9842575b03497$var$getClassName(el) {
    switch(typeof el.className){
        case 'string':
            return el.className;
        case 'object':
            return el.className.baseVal || el.getAttribute('class') || '';
        default:
            return '';
    }
}
function $6fb9842575b03497$var$getPreviousElementSibling(el) {
    if (el.previousElementSibling) return el.previousElementSibling;
    else {
        do el = el.previousSibling;
        while (el && !$6fb9842575b03497$var$isElementNode(el));
        return el;
    }
}
function $6fb9842575b03497$var$getPropertiesFromElement(el, ev, blockAttrsSet, extraAttrs, allowElementCallback, allowSelectors) {
    var props = {
        '$classes': $6fb9842575b03497$var$getClassName(el).split(' '),
        '$tag_name': el.tagName.toLowerCase()
    };
    var elId = el.id;
    if (elId) props['$id'] = elId;
    if ($6fb9842575b03497$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors)) $6fb9842575b03497$var$_.each($6fb9842575b03497$var$TRACKED_ATTRS.concat(extraAttrs), function(attr) {
        if (el.hasAttribute(attr) && !blockAttrsSet[attr]) {
            var attrVal = el.getAttribute(attr);
            if ($6fb9842575b03497$var$shouldTrackValue(attrVal)) props['$attr-' + attr] = attrVal;
        }
    });
    var nthChild = 1;
    var nthOfType = 1;
    var currentElem = el;
    while(currentElem = $6fb9842575b03497$var$getPreviousElementSibling(currentElem)){
        nthChild++;
        if (currentElem.tagName === el.tagName) nthOfType++;
    }
    props['$nth_child'] = nthChild;
    props['$nth_of_type'] = nthOfType;
    return props;
}
function $6fb9842575b03497$var$getPropsForDOMEvent(ev, config) {
    var allowElementCallback = config.allowElementCallback;
    var allowSelectors = config.allowSelectors || [];
    var blockAttrs = config.blockAttrs || [];
    var blockElementCallback = config.blockElementCallback;
    var blockSelectors = config.blockSelectors || [];
    var captureTextContent = config.captureTextContent || false;
    var captureExtraAttrs = config.captureExtraAttrs || [];
    var capturedForHeatMap = config.capturedForHeatMap || false;
    // convert array to set every time, as the config may have changed
    var blockAttrsSet = {};
    $6fb9842575b03497$var$_.each(blockAttrs, function(attr) {
        blockAttrsSet[attr] = true;
    });
    var props = null;
    var target = typeof ev.target === 'undefined' ? ev.srcElement : ev.target;
    if ($6fb9842575b03497$var$isTextNode(target)) target = target.parentNode;
    if ($6fb9842575b03497$var$shouldTrackDomEvent(target, ev) && $6fb9842575b03497$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) && !$6fb9842575b03497$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) {
        var targetElementList = [
            target
        ];
        var curEl = target;
        while(curEl.parentNode && !$6fb9842575b03497$var$isTag(curEl, 'body')){
            targetElementList.push(curEl.parentNode);
            curEl = curEl.parentNode;
        }
        var elementsJson = [];
        var href, explicitNoTrack = false;
        $6fb9842575b03497$var$_.each(targetElementList, function(el) {
            var shouldTrackDetails = $6fb9842575b03497$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors);
            // if the element or a parent element is an anchor tag
            // include the href as a property
            if (!blockAttrsSet['href'] && el.tagName.toLowerCase() === 'a') {
                href = el.getAttribute('href');
                href = shouldTrackDetails && $6fb9842575b03497$var$shouldTrackValue(href) && href;
            }
            if ($6fb9842575b03497$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors)) explicitNoTrack = true;
            elementsJson.push($6fb9842575b03497$var$getPropertiesFromElement(el, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors));
        }, this);
        if (!explicitNoTrack) {
            var docElement = $6fb9842575b03497$var$document$1['documentElement'];
            props = {
                '$event_type': ev.type,
                '$host': $6fb9842575b03497$var$win.location.host,
                '$pathname': $6fb9842575b03497$var$win.location.pathname,
                '$elements': elementsJson,
                '$el_attr__href': href,
                '$viewportHeight': Math.max(docElement['clientHeight'], $6fb9842575b03497$var$win['innerHeight'] || 0),
                '$viewportWidth': Math.max(docElement['clientWidth'], $6fb9842575b03497$var$win['innerWidth'] || 0)
            };
            $6fb9842575b03497$var$_.each(captureExtraAttrs, function(attr) {
                if (!blockAttrsSet[attr] && target.hasAttribute(attr)) {
                    var attrVal = target.getAttribute(attr);
                    if ($6fb9842575b03497$var$shouldTrackValue(attrVal)) props['$el_attr__' + attr] = attrVal;
                }
            });
            if (captureTextContent) {
                elementText = $6fb9842575b03497$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (ev.type === $6fb9842575b03497$var$EV_CLICK) {
                $6fb9842575b03497$var$_.each($6fb9842575b03497$var$CLICK_EVENT_PROPS, function(prop) {
                    if (prop in ev) props['$' + prop] = ev[prop];
                });
                if (capturedForHeatMap) props['$captured_for_heatmap'] = true;
                target = $6fb9842575b03497$var$guessRealClickTarget(ev);
            }
            // prioritize text content from "real" click target if different from original target
            if (captureTextContent) {
                var elementText = $6fb9842575b03497$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (target) {
                // target may have been recalculated; check allowlists and blocklists again
                if (!$6fb9842575b03497$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) || $6fb9842575b03497$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) return null;
                var targetProps = $6fb9842575b03497$var$getPropertiesFromElement(target, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors);
                props['$target'] = targetProps;
                // pull up more props onto main event props
                props['$el_classes'] = targetProps['$classes'];
                $6fb9842575b03497$var$_.extend(props, $6fb9842575b03497$var$_.strip_empty_properties({
                    '$el_id': targetProps['$id'],
                    '$el_tag_name': targetProps['$tag_name']
                }));
            }
        }
    }
    return props;
}
/**
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {string} the element's direct text content
 */ function $6fb9842575b03497$var$getSafeText(el, ev, allowElementCallback, allowSelectors) {
    var elText = '';
    if ($6fb9842575b03497$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) && el.childNodes && el.childNodes.length) $6fb9842575b03497$var$_.each(el.childNodes, function(child) {
        if ($6fb9842575b03497$var$isTextNode(child) && child.textContent) elText += $6fb9842575b03497$var$_.trim(child.textContent)// scrub potentially sensitive values
        .split(/(\s+)/).filter($6fb9842575b03497$var$shouldTrackValue).join('')// normalize whitespace
        .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')// truncate
        .substring(0, 255);
    });
    return $6fb9842575b03497$var$_.trim(elText);
}
function $6fb9842575b03497$var$guessRealClickTarget(ev) {
    var target = ev.target;
    var composedPath = ev['composedPath']();
    for(var i = 0; i < composedPath.length; i++){
        var node = composedPath[i];
        if ($6fb9842575b03497$var$isTag(node, 'a') || $6fb9842575b03497$var$isTag(node, 'button') || $6fb9842575b03497$var$isTag(node, 'input') || $6fb9842575b03497$var$isTag(node, 'select') || node.getAttribute && node.getAttribute('role') === 'button') {
            target = node;
            break;
        }
        if (node === target) break;
    }
    return target;
}
function $6fb9842575b03497$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors) {
    if (allowElementCallback) try {
        if (!allowElementCallback(el, ev)) return false;
    } catch (err) {
        $6fb9842575b03497$var$logger$1.critical('Error while checking element in allowElementCallback', err);
        return false;
    }
    if (!allowSelectors.length) // no allowlist; all elements are fair game
    return true;
    for(var i = 0; i < allowSelectors.length; i++){
        var sel = allowSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            $6fb9842575b03497$var$logger$1.critical('Error while checking selector: ' + sel, err);
        }
    }
    return false;
}
function $6fb9842575b03497$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors) {
    var i;
    if (blockElementCallback) try {
        if (blockElementCallback(el, ev)) return true;
    } catch (err) {
        $6fb9842575b03497$var$logger$1.critical('Error while checking element in blockElementCallback', err);
        return true;
    }
    if (blockSelectors && blockSelectors.length) // programmatically prevent tracking of elements that match CSS selectors
    for(i = 0; i < blockSelectors.length; i++){
        var sel = blockSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            $6fb9842575b03497$var$logger$1.critical('Error while checking selector: ' + sel, err);
        }
    }
    // allow users to programmatically prevent tracking of elements by adding default classes such as 'mp-no-track'
    var classes = $6fb9842575b03497$var$getClasses(el);
    for(i = 0; i < $6fb9842575b03497$var$OPT_OUT_CLASSES.length; i++){
        if (classes[$6fb9842575b03497$var$OPT_OUT_CLASSES[i]]) return true;
    }
    return false;
}
/*
 * Check whether a DOM node has nodeType Node.ELEMENT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of the correct nodeType
 */ function $6fb9842575b03497$var$isElementNode(node) {
    return node && node.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}
/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */ function $6fb9842575b03497$var$isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}
/*
 * Check whether a DOM node is a TEXT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of type Node.TEXT_NODE
 */ function $6fb9842575b03497$var$isTextNode(node) {
    return node && node.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}
function $6fb9842575b03497$var$minDOMApisSupported() {
    try {
        var testEl = $6fb9842575b03497$var$document$1.createElement('div');
        return !!testEl['matches'];
    } catch (err) {
        return false;
    }
}
/*
 * Check whether a DOM event should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} ev - event to check
 * @returns {boolean} whether the event should be tracked
 */ function $6fb9842575b03497$var$shouldTrackDomEvent(el, ev) {
    if (!el || $6fb9842575b03497$var$isTag(el, 'html') || !$6fb9842575b03497$var$isElementNode(el)) return false;
    var tag = el.tagName.toLowerCase();
    switch(tag){
        case 'form':
            return ev.type === $6fb9842575b03497$var$EV_SUBMIT;
        case 'input':
            if ([
                'button',
                'submit'
            ].indexOf(el.getAttribute('type')) === -1) return ev.type === $6fb9842575b03497$var$EV_CHANGE;
            else return ev.type === $6fb9842575b03497$var$EV_CLICK;
        case 'select':
        case 'textarea':
            return ev.type === $6fb9842575b03497$var$EV_CHANGE;
        default:
            return ev.type === $6fb9842575b03497$var$EV_CLICK;
    }
}
/*
 * Check whether a DOM element should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {boolean} whether the element should be tracked
 */ function $6fb9842575b03497$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) {
    var i;
    if (!$6fb9842575b03497$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors)) return false;
    for(var curEl = el; curEl.parentNode && !$6fb9842575b03497$var$isTag(curEl, 'body'); curEl = curEl.parentNode){
        var classes = $6fb9842575b03497$var$getClasses(curEl);
        for(i = 0; i < $6fb9842575b03497$var$SENSITIVE_DATA_CLASSES.length; i++){
            if (classes[$6fb9842575b03497$var$SENSITIVE_DATA_CLASSES[i]]) return false;
        }
    }
    var elClasses = $6fb9842575b03497$var$getClasses(el);
    for(i = 0; i < $6fb9842575b03497$var$OPT_IN_CLASSES.length; i++){
        if (elClasses[$6fb9842575b03497$var$OPT_IN_CLASSES[i]]) return true;
    }
    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if ($6fb9842575b03497$var$isTag(el, 'input') || $6fb9842575b03497$var$isTag(el, 'select') || $6fb9842575b03497$var$isTag(el, 'textarea') || el.getAttribute('contenteditable') === 'true') return false;
    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') switch(type.toLowerCase()){
        case 'hidden':
            return false;
        case 'password':
            return false;
    }
    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    if (typeof name === 'string') {
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) return false;
    }
    return true;
}
/*
 * Check whether a string value should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */ function $6fb9842575b03497$var$shouldTrackValue(value) {
    if (value === null || $6fb9842575b03497$var$_.isUndefined(value)) return false;
    if (typeof value === 'string') {
        value = $6fb9842575b03497$var$_.trim(value);
        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[- ]/g, ''))) return false;
        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) return false;
    }
    return true;
}
var $6fb9842575b03497$var$AUTOCAPTURE_CONFIG_KEY = 'autocapture';
var $6fb9842575b03497$var$LEGACY_PAGEVIEW_CONFIG_KEY = 'track_pageview';
var $6fb9842575b03497$var$PAGEVIEW_OPTION_FULL_URL = 'full-url';
var $6fb9842575b03497$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING = 'url-with-path-and-query-string';
var $6fb9842575b03497$var$PAGEVIEW_OPTION_URL_WITH_PATH = 'url-with-path';
var $6fb9842575b03497$var$CONFIG_ALLOW_ELEMENT_CALLBACK = 'allow_element_callback';
var $6fb9842575b03497$var$CONFIG_ALLOW_SELECTORS = 'allow_selectors';
var $6fb9842575b03497$var$CONFIG_ALLOW_URL_REGEXES = 'allow_url_regexes';
var $6fb9842575b03497$var$CONFIG_BLOCK_ATTRS = 'block_attrs';
var $6fb9842575b03497$var$CONFIG_BLOCK_ELEMENT_CALLBACK = 'block_element_callback';
var $6fb9842575b03497$var$CONFIG_BLOCK_SELECTORS = 'block_selectors';
var $6fb9842575b03497$var$CONFIG_BLOCK_URL_REGEXES = 'block_url_regexes';
var $6fb9842575b03497$var$CONFIG_CAPTURE_EXTRA_ATTRS = 'capture_extra_attrs';
var $6fb9842575b03497$var$CONFIG_CAPTURE_TEXT_CONTENT = 'capture_text_content';
var $6fb9842575b03497$var$CONFIG_SCROLL_CAPTURE_ALL = 'scroll_capture_all';
var $6fb9842575b03497$var$CONFIG_SCROLL_CHECKPOINTS = 'scroll_depth_percent_checkpoints';
var $6fb9842575b03497$var$CONFIG_TRACK_CLICK = 'click';
var $6fb9842575b03497$var$CONFIG_TRACK_INPUT = 'input';
var $6fb9842575b03497$var$CONFIG_TRACK_PAGEVIEW = 'pageview';
var $6fb9842575b03497$var$CONFIG_TRACK_SCROLL = 'scroll';
var $6fb9842575b03497$var$CONFIG_TRACK_SUBMIT = 'submit';
var $6fb9842575b03497$var$CONFIG_DEFAULTS$1 = {};
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_ALLOW_SELECTORS] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_ALLOW_URL_REGEXES] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_BLOCK_ATTRS] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_BLOCK_ELEMENT_CALLBACK] = null;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_BLOCK_SELECTORS] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_BLOCK_URL_REGEXES] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_CAPTURE_EXTRA_ATTRS] = [];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_CAPTURE_TEXT_CONTENT] = false;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_SCROLL_CAPTURE_ALL] = false;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_SCROLL_CHECKPOINTS] = [
    25,
    50,
    75,
    100
];
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_CLICK] = true;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_INPUT] = true;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_PAGEVIEW] = $6fb9842575b03497$var$PAGEVIEW_OPTION_FULL_URL;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_SCROLL] = true;
$6fb9842575b03497$var$CONFIG_DEFAULTS$1[$6fb9842575b03497$var$CONFIG_TRACK_SUBMIT] = true;
var $6fb9842575b03497$var$DEFAULT_PROPS = {
    '$mp_autocapture': true
};
var $6fb9842575b03497$var$MP_EV_CLICK = '$mp_click';
var $6fb9842575b03497$var$MP_EV_INPUT = '$mp_input_change';
var $6fb9842575b03497$var$MP_EV_SCROLL = '$mp_scroll';
var $6fb9842575b03497$var$MP_EV_SUBMIT = '$mp_submit';
/**
 * Autocapture: manages automatic event tracking
 * @constructor
 */ var $6fb9842575b03497$var$Autocapture = function(mp) {
    this.mp = mp;
};
$6fb9842575b03497$var$Autocapture.prototype.init = function() {
    if (!$6fb9842575b03497$var$minDOMApisSupported()) {
        $6fb9842575b03497$var$logger$1.critical('Autocapture unavailable: missing required DOM APIs');
        return;
    }
    this.initPageviewTracking();
    this.initClickTracking();
    this.initInputTracking();
    this.initScrollTracking();
    this.initSubmitTracking();
};
$6fb9842575b03497$var$Autocapture.prototype.getFullConfig = function() {
    var autocaptureConfig = this.mp.get_config($6fb9842575b03497$var$AUTOCAPTURE_CONFIG_KEY);
    if (!autocaptureConfig) // Autocapture is completely off
    return {};
    else if ($6fb9842575b03497$var$_.isObject(autocaptureConfig)) return $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$CONFIG_DEFAULTS$1, autocaptureConfig);
    else // Autocapture config is non-object truthy value, return default
    return $6fb9842575b03497$var$CONFIG_DEFAULTS$1;
};
$6fb9842575b03497$var$Autocapture.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$6fb9842575b03497$var$Autocapture.prototype.currentUrlBlocked = function() {
    var i;
    var currentUrl = $6fb9842575b03497$var$_.info.currentUrl();
    var allowUrlRegexes = this.getConfig($6fb9842575b03497$var$CONFIG_ALLOW_URL_REGEXES) || [];
    if (allowUrlRegexes.length) {
        // we're using an allowlist, only track if current URL matches
        var allowed = false;
        for(i = 0; i < allowUrlRegexes.length; i++){
            var allowRegex = allowUrlRegexes[i];
            try {
                if (currentUrl.match(allowRegex)) {
                    allowed = true;
                    break;
                }
            } catch (err) {
                $6fb9842575b03497$var$logger$1.critical('Error while checking block URL regex: ' + allowRegex, err);
                return true;
            }
        }
        if (!allowed) // wasn't allowed by any regex
        return true;
    }
    var blockUrlRegexes = this.getConfig($6fb9842575b03497$var$CONFIG_BLOCK_URL_REGEXES) || [];
    if (!blockUrlRegexes || !blockUrlRegexes.length) return false;
    for(i = 0; i < blockUrlRegexes.length; i++)try {
        if (currentUrl.match(blockUrlRegexes[i])) return true;
    } catch (err) {
        $6fb9842575b03497$var$logger$1.critical('Error while checking block URL regex: ' + blockUrlRegexes[i], err);
        return true;
    }
    return false;
};
$6fb9842575b03497$var$Autocapture.prototype.pageviewTrackingConfig = function() {
    // supports both autocapture config and old track_pageview config
    if (this.mp.get_config($6fb9842575b03497$var$AUTOCAPTURE_CONFIG_KEY)) return this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_PAGEVIEW);
    else return this.mp.get_config($6fb9842575b03497$var$LEGACY_PAGEVIEW_CONFIG_KEY);
};
// helper for event handlers
$6fb9842575b03497$var$Autocapture.prototype.trackDomEvent = function(ev, mpEventName) {
    if (this.currentUrlBlocked()) return;
    var props = $6fb9842575b03497$var$getPropsForDOMEvent(ev, {
        allowElementCallback: this.getConfig($6fb9842575b03497$var$CONFIG_ALLOW_ELEMENT_CALLBACK),
        allowSelectors: this.getConfig($6fb9842575b03497$var$CONFIG_ALLOW_SELECTORS),
        blockAttrs: this.getConfig($6fb9842575b03497$var$CONFIG_BLOCK_ATTRS),
        blockElementCallback: this.getConfig($6fb9842575b03497$var$CONFIG_BLOCK_ELEMENT_CALLBACK),
        blockSelectors: this.getConfig($6fb9842575b03497$var$CONFIG_BLOCK_SELECTORS),
        captureExtraAttrs: this.getConfig($6fb9842575b03497$var$CONFIG_CAPTURE_EXTRA_ATTRS),
        captureTextContent: this.getConfig($6fb9842575b03497$var$CONFIG_CAPTURE_TEXT_CONTENT),
        capturedForHeatMap: mpEventName === $6fb9842575b03497$var$MP_EV_CLICK && !this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_CLICK) && this.mp.is_recording_heatmap_data()
    });
    if (props) {
        $6fb9842575b03497$var$_.extend(props, $6fb9842575b03497$var$DEFAULT_PROPS);
        this.mp.track(mpEventName, props);
    }
};
$6fb9842575b03497$var$Autocapture.prototype.initClickTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_CLICK, this.listenerClick);
    if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_CLICK) && !this.mp.get_config('record_heatmap_data')) return;
    $6fb9842575b03497$var$logger$1.log('Initializing click tracking');
    this.listenerClick = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_CLICK, (function(ev) {
        if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_CLICK) && !this.mp.is_recording_heatmap_data()) return;
        this.trackDomEvent(ev, $6fb9842575b03497$var$MP_EV_CLICK);
    }).bind(this));
};
$6fb9842575b03497$var$Autocapture.prototype.initInputTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_CHANGE, this.listenerChange);
    if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_INPUT)) return;
    $6fb9842575b03497$var$logger$1.log('Initializing input tracking');
    this.listenerChange = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_CHANGE, (function(ev) {
        if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_INPUT)) return;
        this.trackDomEvent(ev, $6fb9842575b03497$var$MP_EV_INPUT);
    }).bind(this));
};
$6fb9842575b03497$var$Autocapture.prototype.initPageviewTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_POPSTATE, this.listenerPopstate);
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_HASHCHANGE, this.listenerHashchange);
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE, this.listenerLocationchange);
    if (!this.pageviewTrackingConfig()) return;
    $6fb9842575b03497$var$logger$1.log('Initializing pageview tracking');
    var previousTrackedUrl = '';
    var tracked = false;
    if (!this.currentUrlBlocked()) tracked = this.mp.track_pageview($6fb9842575b03497$var$DEFAULT_PROPS);
    if (tracked) previousTrackedUrl = $6fb9842575b03497$var$_.info.currentUrl();
    this.listenerPopstate = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_POPSTATE, function() {
        $6fb9842575b03497$var$win.dispatchEvent(new Event($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE));
    });
    this.listenerHashchange = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_HASHCHANGE, function() {
        $6fb9842575b03497$var$win.dispatchEvent(new Event($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE));
    });
    var nativePushState = $6fb9842575b03497$var$win.history.pushState;
    if (typeof nativePushState === 'function') $6fb9842575b03497$var$win.history.pushState = function(state, unused, url) {
        nativePushState.call($6fb9842575b03497$var$win.history, state, unused, url);
        $6fb9842575b03497$var$win.dispatchEvent(new Event($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE));
    };
    var nativeReplaceState = $6fb9842575b03497$var$win.history.replaceState;
    if (typeof nativeReplaceState === 'function') $6fb9842575b03497$var$win.history.replaceState = function(state, unused, url) {
        nativeReplaceState.call($6fb9842575b03497$var$win.history, state, unused, url);
        $6fb9842575b03497$var$win.dispatchEvent(new Event($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE));
    };
    this.listenerLocationchange = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_MP_LOCATION_CHANGE, $6fb9842575b03497$var$safewrap((function() {
        if (this.currentUrlBlocked()) return;
        var currentUrl = $6fb9842575b03497$var$_.info.currentUrl();
        var shouldTrack = false;
        var didPathChange = currentUrl.split('#')[0].split('?')[0] !== previousTrackedUrl.split('#')[0].split('?')[0];
        var trackPageviewOption = this.pageviewTrackingConfig();
        if (trackPageviewOption === $6fb9842575b03497$var$PAGEVIEW_OPTION_FULL_URL) shouldTrack = currentUrl !== previousTrackedUrl;
        else if (trackPageviewOption === $6fb9842575b03497$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING) shouldTrack = currentUrl.split('#')[0] !== previousTrackedUrl.split('#')[0];
        else if (trackPageviewOption === $6fb9842575b03497$var$PAGEVIEW_OPTION_URL_WITH_PATH) shouldTrack = didPathChange;
        if (shouldTrack) {
            var tracked = this.mp.track_pageview($6fb9842575b03497$var$DEFAULT_PROPS);
            if (tracked) previousTrackedUrl = currentUrl;
            if (didPathChange) {
                this.lastScrollCheckpoint = 0;
                $6fb9842575b03497$var$logger$1.log('Path change: re-initializing scroll depth checkpoints');
            }
        }
    }).bind(this)));
};
$6fb9842575b03497$var$Autocapture.prototype.initScrollTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_SCROLLEND, this.listenerScroll);
    if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_SCROLL)) return;
    $6fb9842575b03497$var$logger$1.log('Initializing scroll tracking');
    this.lastScrollCheckpoint = 0;
    this.listenerScroll = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_SCROLLEND, $6fb9842575b03497$var$safewrap((function() {
        if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_SCROLL)) return;
        if (this.currentUrlBlocked()) return;
        var shouldTrack = this.getConfig($6fb9842575b03497$var$CONFIG_SCROLL_CAPTURE_ALL);
        var scrollCheckpoints = (this.getConfig($6fb9842575b03497$var$CONFIG_SCROLL_CHECKPOINTS) || []).slice().sort(function(a, b) {
            return a - b;
        });
        var scrollTop = $6fb9842575b03497$var$win.scrollY;
        var props = $6fb9842575b03497$var$_.extend({
            '$scroll_top': scrollTop
        }, $6fb9842575b03497$var$DEFAULT_PROPS);
        try {
            var scrollHeight = $6fb9842575b03497$var$document$1.body.scrollHeight;
            var scrollPercentage = Math.round(scrollTop / (scrollHeight - $6fb9842575b03497$var$win.innerHeight) * 100);
            props['$scroll_height'] = scrollHeight;
            props['$scroll_percentage'] = scrollPercentage;
            if (scrollPercentage > this.lastScrollCheckpoint) for(var i = 0; i < scrollCheckpoints.length; i++){
                var checkpoint = scrollCheckpoints[i];
                if (scrollPercentage >= checkpoint && this.lastScrollCheckpoint < checkpoint) {
                    props['$scroll_checkpoint'] = checkpoint;
                    this.lastScrollCheckpoint = checkpoint;
                    shouldTrack = true;
                }
            }
        } catch (err) {
            $6fb9842575b03497$var$logger$1.critical('Error while calculating scroll percentage', err);
        }
        if (shouldTrack) this.mp.track($6fb9842575b03497$var$MP_EV_SCROLL, props);
    }).bind(this)));
};
$6fb9842575b03497$var$Autocapture.prototype.initSubmitTracking = function() {
    $6fb9842575b03497$var$win.removeEventListener($6fb9842575b03497$var$EV_SUBMIT, this.listenerSubmit);
    if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_SUBMIT)) return;
    $6fb9842575b03497$var$logger$1.log('Initializing submit tracking');
    this.listenerSubmit = $6fb9842575b03497$var$win.addEventListener($6fb9842575b03497$var$EV_SUBMIT, (function(ev) {
        if (!this.getConfig($6fb9842575b03497$var$CONFIG_TRACK_SUBMIT)) return;
        this.trackDomEvent(ev, $6fb9842575b03497$var$MP_EV_SUBMIT);
    }).bind(this));
};
// TODO integrate error_reporter from mixpanel instance
$6fb9842575b03497$var$safewrapClass($6fb9842575b03497$var$Autocapture);
var $6fb9842575b03497$var$fetch = $6fb9842575b03497$var$win['fetch'];
var $6fb9842575b03497$var$logger = $6fb9842575b03497$var$console_with_prefix('flags');
var $6fb9842575b03497$var$FLAGS_CONFIG_KEY = 'flags';
var $6fb9842575b03497$var$CONFIG_CONTEXT = 'context';
var $6fb9842575b03497$var$CONFIG_DEFAULTS = {};
$6fb9842575b03497$var$CONFIG_DEFAULTS[$6fb9842575b03497$var$CONFIG_CONTEXT] = {};
/**
 * FeatureFlagManager: support for Mixpanel's feature flagging product
 * @constructor
 */ var $6fb9842575b03497$var$FeatureFlagManager = function(initOptions) {
    this.getMpConfig = initOptions.getConfigFunc;
    this.getDistinctId = initOptions.getDistinctIdFunc;
    this.track = initOptions.trackingFunc;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.init = function() {
    if (!$6fb9842575b03497$var$minApisSupported()) {
        $6fb9842575b03497$var$logger.critical('Feature Flags unavailable: missing minimum required APIs');
        return;
    }
    this.flags = null;
    this.fetchFlags();
    this.trackedFeatures = new Set();
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getFullConfig = function() {
    var ffConfig = this.getMpConfig($6fb9842575b03497$var$FLAGS_CONFIG_KEY);
    if (!ffConfig) // flags are completely off
    return {};
    else if ($6fb9842575b03497$var$_.isObject(ffConfig)) return $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$CONFIG_DEFAULTS, ffConfig);
    else // config is non-object truthy value, return default
    return $6fb9842575b03497$var$CONFIG_DEFAULTS;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.isEnabled = function() {
    return !!this.getMpConfig($6fb9842575b03497$var$FLAGS_CONFIG_KEY);
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.areFeaturesReady = function() {
    if (!this.isEnabled()) $6fb9842575b03497$var$logger.error('Feature Flags not enabled');
    return !!this.flags;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.fetchFlags = function() {
    if (!this.isEnabled()) return;
    var distinctId = this.getDistinctId();
    $6fb9842575b03497$var$logger.log('Fetching flags for distinct ID: ' + distinctId);
    var reqParams = {
        'context': $6fb9842575b03497$var$_.extend({
            'distinct_id': distinctId
        }, this.getConfig($6fb9842575b03497$var$CONFIG_CONTEXT))
    };
    this.fetchPromise = $6fb9842575b03497$var$win['fetch'](this.getMpConfig('api_host') + '/' + this.getMpConfig('api_routes')['flags'], {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getMpConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': JSON.stringify(reqParams)
    }).then((function(response) {
        return response.json().then((function(responseBody) {
            var responseFlags = responseBody['flags'];
            if (!responseFlags) throw new Error('No flags in API response');
            var flags = new Map();
            $6fb9842575b03497$var$_.each(responseFlags, function(data, key) {
                flags.set(key, {
                    'key': data['variant_key'],
                    'data': data['variant_value']
                });
            });
            this.flags = flags;
        }).bind(this)).catch(function(error) {
            $6fb9842575b03497$var$logger.error(error);
        });
    }).bind(this)).catch(function() {});
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getFeature = function(featureName, fallback) {
    if (!this.fetchPromise) return new Promise(function(resolve) {
        $6fb9842575b03497$var$logger.critical('Feature Flags not initialized');
        resolve(fallback);
    });
    return this.fetchPromise.then((function() {
        return this.getFeatureSync(featureName, fallback);
    }).bind(this)).catch(function(error) {
        $6fb9842575b03497$var$logger.error(error);
        return fallback;
    });
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getFeatureSync = function(featureName, fallback) {
    if (!this.areFeaturesReady()) {
        $6fb9842575b03497$var$logger.log('Flags not loaded yet');
        return fallback;
    }
    var feature = this.flags.get(featureName);
    if (!feature) {
        $6fb9842575b03497$var$logger.log('No flag found: "' + featureName + '"');
        return fallback;
    }
    this.trackFeatureCheck(featureName, feature);
    return feature;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getFeatureData = function(featureName, fallbackValue) {
    return this.getFeature(featureName, {
        'data': fallbackValue
    }).then(function(feature) {
        return feature['data'];
    }).catch(function(error) {
        $6fb9842575b03497$var$logger.error(error);
        return fallbackValue;
    });
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.getFeatureDataSync = function(featureName, fallbackValue) {
    return this.getFeatureSync(featureName, {
        'data': fallbackValue
    })['data'];
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.isFeatureEnabled = function(featureName, fallbackValue) {
    return this.getFeatureData(featureName).then((function() {
        return this.isFeatureEnabledSync(featureName, fallbackValue);
    }).bind(this)).catch(function(error) {
        $6fb9842575b03497$var$logger.error(error);
        return fallbackValue;
    });
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.isFeatureEnabledSync = function(featureName, fallbackValue) {
    fallbackValue = fallbackValue || false;
    var val = this.getFeatureDataSync(featureName, fallbackValue);
    if (val !== true && val !== false) {
        $6fb9842575b03497$var$logger.error('Feature flag "' + featureName + '" value: ' + val + ' is not a boolean; returning fallback value: ' + fallbackValue);
        val = fallbackValue;
    }
    return val;
};
$6fb9842575b03497$var$FeatureFlagManager.prototype.trackFeatureCheck = function(featureName, feature) {
    if (this.trackedFeatures.has(featureName)) return;
    this.trackedFeatures.add(featureName);
    this.track('$experiment_started', {
        'Experiment name': featureName,
        'Variant name': feature['key'],
        '$experiment_type': 'feature_flag'
    });
};
function $6fb9842575b03497$var$minApisSupported() {
    return !!$6fb9842575b03497$var$fetch && typeof Promise !== 'undefined' && typeof Map !== 'undefined' && typeof Set !== 'undefined';
}
$6fb9842575b03497$var$safewrapClass($6fb9842575b03497$var$FeatureFlagManager);
$6fb9842575b03497$var$FeatureFlagManager.prototype['are_features_ready'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.areFeaturesReady;
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_feature'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getFeature;
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_feature_data'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getFeatureData;
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_feature_data_sync'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getFeatureDataSync;
$6fb9842575b03497$var$FeatureFlagManager.prototype['get_feature_sync'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.getFeatureSync;
$6fb9842575b03497$var$FeatureFlagManager.prototype['is_feature_enabled'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.isFeatureEnabled;
$6fb9842575b03497$var$FeatureFlagManager.prototype['is_feature_enabled_sync'] = $6fb9842575b03497$var$FeatureFlagManager.prototype.isFeatureEnabledSync;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $6fb9842575b03497$var$DomTracker = function() {};
// interface
$6fb9842575b03497$var$DomTracker.prototype.create_properties = function() {};
$6fb9842575b03497$var$DomTracker.prototype.event_handler = function() {};
$6fb9842575b03497$var$DomTracker.prototype.after_track_handler = function() {};
$6fb9842575b03497$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $6fb9842575b03497$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $6fb9842575b03497$var$_.dom_query(query);
    if (elements.length === 0) {
        $6fb9842575b03497$var$console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }
    $6fb9842575b03497$var$_.each(elements, function(element) {
        $6fb9842575b03497$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $6fb9842575b03497$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$6fb9842575b03497$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === 'function') props = properties(element);
    else props = $6fb9842575b03497$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $6fb9842575b03497$var$LinkTracker = function() {
    this.override_event = 'click';
};
$6fb9842575b03497$var$_.inherit($6fb9842575b03497$var$LinkTracker, $6fb9842575b03497$var$DomTracker);
$6fb9842575b03497$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $6fb9842575b03497$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props['url'] = element.href;
    return props;
};
$6fb9842575b03497$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$6fb9842575b03497$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $6fb9842575b03497$var$FormTracker = function() {
    this.override_event = 'submit';
};
$6fb9842575b03497$var$_.inherit($6fb9842575b03497$var$FormTracker, $6fb9842575b03497$var$DomTracker);
$6fb9842575b03497$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$6fb9842575b03497$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
/* eslint camelcase: "off" */ /** @const */ var $6fb9842575b03497$var$SET_ACTION = '$set';
/** @const */ var $6fb9842575b03497$var$SET_ONCE_ACTION = '$set_once';
/** @const */ var $6fb9842575b03497$var$UNSET_ACTION = '$unset';
/** @const */ var $6fb9842575b03497$var$ADD_ACTION = '$add';
/** @const */ var $6fb9842575b03497$var$APPEND_ACTION = '$append';
/** @const */ var $6fb9842575b03497$var$UNION_ACTION = '$union';
/** @const */ var $6fb9842575b03497$var$REMOVE_ACTION = '$remove';
/** @const */ var $6fb9842575b03497$var$DELETE_ACTION = '$delete';
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $6fb9842575b03497$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($6fb9842575b03497$var$_.isObject(prop)) $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$6fb9842575b03497$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$6fb9842575b03497$var$_.isArray(prop)) prop = [
            prop
        ];
        $6fb9842575b03497$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$6fb9842575b03497$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($6fb9842575b03497$var$_.isObject(prop)) $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$6fb9842575b03497$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $6fb9842575b03497$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $6fb9842575b03497$var$_.isArray(values) ? values : [
            values
        ];
        data[$6fb9842575b03497$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$6fb9842575b03497$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($6fb9842575b03497$var$_.isObject(list_name)) $6fb9842575b03497$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$6fb9842575b03497$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$6fb9842575b03497$var$DELETE_ACTION] = '';
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelGroup = function() {};
$6fb9842575b03497$var$_.extend($6fb9842575b03497$var$MixpanelGroup.prototype, $6fb9842575b03497$var$apiActions);
$6fb9842575b03497$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.set = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.set_once = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.unset = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.union = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype['delete'] = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6fb9842575b03497$var$MixpanelGroup.prototype.remove = $6fb9842575b03497$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$6fb9842575b03497$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');
    var date_encoded_data = $6fb9842575b03497$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['groups'],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$6fb9842575b03497$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};
$6fb9842575b03497$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$6fb9842575b03497$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};
// MixpanelGroup Exports
$6fb9842575b03497$var$MixpanelGroup.prototype['remove'] = $6fb9842575b03497$var$MixpanelGroup.prototype.remove;
$6fb9842575b03497$var$MixpanelGroup.prototype['set'] = $6fb9842575b03497$var$MixpanelGroup.prototype.set;
$6fb9842575b03497$var$MixpanelGroup.prototype['set_once'] = $6fb9842575b03497$var$MixpanelGroup.prototype.set_once;
$6fb9842575b03497$var$MixpanelGroup.prototype['union'] = $6fb9842575b03497$var$MixpanelGroup.prototype.union;
$6fb9842575b03497$var$MixpanelGroup.prototype['unset'] = $6fb9842575b03497$var$MixpanelGroup.prototype.unset;
$6fb9842575b03497$var$MixpanelGroup.prototype['toString'] = $6fb9842575b03497$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelPeople = function() {};
$6fb9842575b03497$var$_.extend($6fb9842575b03497$var$MixpanelPeople.prototype, $6fb9842575b03497$var$apiActions);
$6fb9842575b03497$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.set = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) this._mixpanel['persistence'].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$6fb9842575b03497$var$SET_ACTION] = $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$_.info.people_properties(), data[$6fb9842575b03497$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.set_once = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($6fb9842575b03497$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.unset = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.increment = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($6fb9842575b03497$var$_.isObject(prop)) {
        $6fb9842575b03497$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $6fb9842575b03497$var$console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($6fb9842575b03497$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$6fb9842575b03497$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.append = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.remove = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.union = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($6fb9842575b03497$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelPeople.prototype.track_charge = $6fb9842575b03497$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$6fb9842575b03497$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $6fb9842575b03497$var$console$1.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }
    return this.append('$transactions', $6fb9842575b03497$var$_.extend({
        '$amount': amount
    }, properties), callback);
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $6fb9842575b03497$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $6fb9842575b03497$var$console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {
        '$delete': this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$6fb9842575b03497$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};
$6fb9842575b03497$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) data['$device_id'] = device_id;
    if (user_id) data['$user_id'] = user_id;
    if (had_persisted_distinct_id) data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    var date_encoded_data = $6fb9842575b03497$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$6fb9842575b03497$var$_.isUndefined(callback)) {
            if (this._get_config('verbose')) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $6fb9842575b03497$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['engage'],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$6fb9842575b03497$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($6fb9842575b03497$var$SET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$SET_ACTION, data);
    else if ($6fb9842575b03497$var$SET_ONCE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$SET_ONCE_ACTION, data);
    else if ($6fb9842575b03497$var$UNSET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$UNSET_ACTION, data);
    else if ($6fb9842575b03497$var$ADD_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$ADD_ACTION, data);
    else if ($6fb9842575b03497$var$APPEND_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$APPEND_ACTION, data);
    else if ($6fb9842575b03497$var$REMOVE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$REMOVE_ACTION, data);
    else if ($6fb9842575b03497$var$UNION_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$UNION_ACTION, data);
    else $6fb9842575b03497$var$console$1.error('Invalid call to _enqueue():', data);
};
$6fb9842575b03497$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $6fb9842575b03497$var$_.extend({}, this._mixpanel['persistence'].load_queue(action));
    var action_params = queued_data;
    if (!$6fb9842575b03497$var$_.isUndefined(queued_data) && $6fb9842575b03497$var$_.isObject(queued_data) && !$6fb9842575b03497$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        _this._mixpanel['persistence'].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            if (!$6fb9842575b03497$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$6fb9842575b03497$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($6fb9842575b03497$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($6fb9842575b03497$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($6fb9842575b03497$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $6fb9842575b03497$var$_.keys(queue);
    });
    this._flush_one_queue($6fb9842575b03497$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($6fb9842575b03497$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel['persistence'].load_queue($6fb9842575b03497$var$APPEND_ACTION);
    if (!$6fb9842575b03497$var$_.isUndefined($append_queue) && $6fb9842575b03497$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$APPEND_ACTION, $append_item);
            if (!$6fb9842575b03497$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel['persistence'].load_queue($6fb9842575b03497$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$6fb9842575b03497$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel['persistence'].load_queue($6fb9842575b03497$var$REMOVE_ACTION);
    if (!$6fb9842575b03497$var$_.isUndefined($remove_queue) && $6fb9842575b03497$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($6fb9842575b03497$var$REMOVE_ACTION, $remove_item);
            if (!$6fb9842575b03497$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel['persistence'].load_queue($6fb9842575b03497$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$6fb9842575b03497$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$6fb9842575b03497$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};
// MixpanelPeople Exports
$6fb9842575b03497$var$MixpanelPeople.prototype['set'] = $6fb9842575b03497$var$MixpanelPeople.prototype.set;
$6fb9842575b03497$var$MixpanelPeople.prototype['set_once'] = $6fb9842575b03497$var$MixpanelPeople.prototype.set_once;
$6fb9842575b03497$var$MixpanelPeople.prototype['unset'] = $6fb9842575b03497$var$MixpanelPeople.prototype.unset;
$6fb9842575b03497$var$MixpanelPeople.prototype['increment'] = $6fb9842575b03497$var$MixpanelPeople.prototype.increment;
$6fb9842575b03497$var$MixpanelPeople.prototype['append'] = $6fb9842575b03497$var$MixpanelPeople.prototype.append;
$6fb9842575b03497$var$MixpanelPeople.prototype['remove'] = $6fb9842575b03497$var$MixpanelPeople.prototype.remove;
$6fb9842575b03497$var$MixpanelPeople.prototype['union'] = $6fb9842575b03497$var$MixpanelPeople.prototype.union;
$6fb9842575b03497$var$MixpanelPeople.prototype['track_charge'] = $6fb9842575b03497$var$MixpanelPeople.prototype.track_charge;
$6fb9842575b03497$var$MixpanelPeople.prototype['clear_charges'] = $6fb9842575b03497$var$MixpanelPeople.prototype.clear_charges;
$6fb9842575b03497$var$MixpanelPeople.prototype['delete_user'] = $6fb9842575b03497$var$MixpanelPeople.prototype.delete_user;
$6fb9842575b03497$var$MixpanelPeople.prototype['toString'] = $6fb9842575b03497$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $6fb9842575b03497$var$SET_QUEUE_KEY = '__mps';
/** @const */ var $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */ var $6fb9842575b03497$var$UNSET_QUEUE_KEY = '__mpus';
/** @const */ var $6fb9842575b03497$var$ADD_QUEUE_KEY = '__mpa';
/** @const */ var $6fb9842575b03497$var$APPEND_QUEUE_KEY = '__mpap';
/** @const */ var $6fb9842575b03497$var$REMOVE_QUEUE_KEY = '__mpr';
/** @const */ var $6fb9842575b03497$var$UNION_QUEUE_KEY = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var $6fb9842575b03497$var$ALIAS_ID_KEY = '__alias';
/** @const */ var $6fb9842575b03497$var$EVENT_TIMERS_KEY = '__timers';
/** @const */ var $6fb9842575b03497$var$RESERVED_PROPERTIES = [
    $6fb9842575b03497$var$SET_QUEUE_KEY,
    $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY,
    $6fb9842575b03497$var$UNSET_QUEUE_KEY,
    $6fb9842575b03497$var$ADD_QUEUE_KEY,
    $6fb9842575b03497$var$APPEND_QUEUE_KEY,
    $6fb9842575b03497$var$REMOVE_QUEUE_KEY,
    $6fb9842575b03497$var$UNION_QUEUE_KEY,
    $6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY,
    $6fb9842575b03497$var$ALIAS_ID_KEY,
    $6fb9842575b03497$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;
    if (config['persistence_name']) this.name = 'mp_' + config['persistence_name'];
    else this.name = 'mp_' + config['token'] + '_mixpanel';
    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        $6fb9842575b03497$var$console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }
    if (storage_type === 'localStorage' && $6fb9842575b03497$var$_.localStorage.is_supported()) this.storage = $6fb9842575b03497$var$_.localStorage;
    else this.storage = $6fb9842575b03497$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $6fb9842575b03497$var$_.each(this['props'], function(v, k) {
        if (!$6fb9842575b03497$var$_.include($6fb9842575b03497$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this['props'] = $6fb9842575b03497$var$_.extend({}, entry);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === $6fb9842575b03497$var$_.localStorage) {
        old_cookie = $6fb9842575b03497$var$_.cookie.parse(this.name);
        $6fb9842575b03497$var$_.cookie.remove(this.name);
        $6fb9842575b03497$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === $6fb9842575b03497$var$_.cookie) {
        old_localstorage = $6fb9842575b03497$var$_.localStorage.parse(this.name);
        $6fb9842575b03497$var$_.localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $6fb9842575b03497$var$JSONStringify(this['props']), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this['props'][key];
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$6fb9842575b03497$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $6fb9842575b03497$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($6fb9842575b03497$var$_.isObject(props)) {
        if (typeof default_value === 'undefined') default_value = 'None';
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $6fb9842575b03497$var$_.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) this['props'][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $6fb9842575b03497$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($6fb9842575b03497$var$_.isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $6fb9842575b03497$var$_.extend(this['props'], props);
        this.save();
        return true;
    }
    return false;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($6fb9842575b03497$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': $6fb9842575b03497$var$_.info.referringDomain(referrer) || '$direct'
    }, '');
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $6fb9842575b03497$var$_.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($6fb9842575b03497$var$SET_ACTION), set_once_q = this._get_or_create_queue($6fb9842575b03497$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($6fb9842575b03497$var$UNSET_ACTION), add_q = this._get_or_create_queue($6fb9842575b03497$var$ADD_ACTION), union_q = this._get_or_create_queue($6fb9842575b03497$var$UNION_ACTION), remove_q = this._get_or_create_queue($6fb9842575b03497$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($6fb9842575b03497$var$APPEND_ACTION, []);
    if (q_key === $6fb9842575b03497$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $6fb9842575b03497$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($6fb9842575b03497$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($6fb9842575b03497$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$UNSET_QUEUE_KEY) $6fb9842575b03497$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $6fb9842575b03497$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $6fb9842575b03497$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $6fb9842575b03497$var$ADD_QUEUE_KEY) {
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$UNION_QUEUE_KEY) {
        $6fb9842575b03497$var$_.each(q_data, function(v, k) {
            if ($6fb9842575b03497$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // Prevent duplicate values
                $6fb9842575b03497$var$_.each(v, function(item) {
                    if (!$6fb9842575b03497$var$_.include(union_q[k], item)) union_q[k].push(item);
                });
            }
        });
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$APPEND_ACTION, q_data);
    } else if (q_key === $6fb9842575b03497$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($6fb9842575b03497$var$UNSET_ACTION, q_data);
    }
    $6fb9842575b03497$var$console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    $6fb9842575b03497$var$console$1.log(data);
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this['props'][this._get_queue_key(queue)];
    if (!$6fb9842575b03497$var$_.isUndefined(q)) $6fb9842575b03497$var$_.each(data, function(v, k) {
        if (queue === $6fb9842575b03497$var$APPEND_ACTION || queue === $6fb9842575b03497$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $6fb9842575b03497$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $6fb9842575b03497$var$SET_ACTION) return $6fb9842575b03497$var$SET_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$SET_ONCE_ACTION) return $6fb9842575b03497$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$UNSET_ACTION) return $6fb9842575b03497$var$UNSET_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$ADD_ACTION) return $6fb9842575b03497$var$ADD_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$APPEND_ACTION) return $6fb9842575b03497$var$APPEND_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$REMOVE_ACTION) return $6fb9842575b03497$var$REMOVE_QUEUE_KEY;
    else if (queue === $6fb9842575b03497$var$UNION_ACTION) return $6fb9842575b03497$var$UNION_QUEUE_KEY;
    else $6fb9842575b03497$var$console$1.error('Invalid queue:', queue);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $6fb9842575b03497$var$_.isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($6fb9842575b03497$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this['props'][$6fb9842575b03497$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$6fb9842575b03497$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($6fb9842575b03497$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$6fb9842575b03497$var$_.isUndefined(timestamp)) {
        delete this['props'][$6fb9842575b03497$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ /*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $6fb9842575b03497$var$init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var $6fb9842575b03497$var$load_extra_bundle = function(src, _onload) {
    throw new Error(src + ' not available in this build.');
};
var $6fb9842575b03497$var$mixpanel_master; // main mixpanel instance / object
var $6fb9842575b03497$var$INIT_MODULE = 0;
var $6fb9842575b03497$var$INIT_SNIPPET = 1;
var $6fb9842575b03497$var$IDENTITY_FUNC = function(x) {
    return x;
};
/** @const */ var $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64 = 'base64';
/** @const */ var $6fb9842575b03497$var$PAYLOAD_TYPE_JSON = 'json';
/** @const */ var $6fb9842575b03497$var$DEVICE_ID_PREFIX = '$device:';
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $6fb9842575b03497$var$USE_XHR = $6fb9842575b03497$var$win.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $6fb9842575b03497$var$ENQUEUE_REQUESTS = !$6fb9842575b03497$var$USE_XHR && $6fb9842575b03497$var$userAgent.indexOf('MSIE') === -1 && $6fb9842575b03497$var$userAgent.indexOf('Mozilla') === -1;
// save reference to navigator.sendBeacon so it can be minified
var $6fb9842575b03497$var$sendBeacon = null;
if ($6fb9842575b03497$var$navigator['sendBeacon']) $6fb9842575b03497$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $6fb9842575b03497$var$navigator['sendBeacon'].apply($6fb9842575b03497$var$navigator, arguments);
};
var $6fb9842575b03497$var$DEFAULT_API_ROUTES = {
    'track': 'track/',
    'engage': 'engage/',
    'groups': 'groups/',
    'record': 'record/',
    'flags': 'flags/'
};
/*
 * Module-level globals
 */ var $6fb9842575b03497$var$DEFAULT_CONFIG = {
    'api_host': 'https://api-js.mixpanel.com',
    'api_routes': $6fb9842575b03497$var$DEFAULT_API_ROUTES,
    'api_method': 'POST',
    'api_transport': 'XHR',
    'api_payload_format': $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64,
    'app_host': 'https://mixpanel.com',
    'autocapture': false,
    'cdn': 'https://cdn.mxpnl.com',
    'cross_site_cookie': false,
    'cross_subdomain_cookie': true,
    'error_reporter': $6fb9842575b03497$var$NOOP_FUNC,
    'flags': false,
    'persistence': 'cookie',
    'persistence_name': '',
    'cookie_domain': '',
    'cookie_name': '',
    'loaded': $6fb9842575b03497$var$NOOP_FUNC,
    'mp_loader': null,
    'track_marketing': true,
    'track_pageview': false,
    'skip_first_touch_marketing': false,
    'store_google': true,
    'stop_utm_persistence': false,
    'save_referrer': true,
    'test': false,
    'verbose': false,
    'img': false,
    'debug': false,
    'track_links_timeout': 300,
    'cookie_expiration': 365,
    'upgrade': false,
    'disable_persistence': false,
    'disable_cookie': false,
    'secure_cookie': false,
    'ip': true,
    'opt_out_tracking_by_default': false,
    'opt_out_persistence_by_default': false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix': null,
    'property_blacklist': [],
    'xhr_headers': {},
    'ignore_dnt': false,
    'batch_requests': true,
    'batch_size': 50,
    'batch_flush_interval_ms': 5000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true,
    'hooks': {},
    'record_block_class': new RegExp('^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$'),
    'record_block_selector': 'img, video',
    'record_canvas': false,
    'record_collect_fonts': false,
    'record_heatmap_data': false,
    'record_idle_timeout_ms': 1800000,
    'record_mask_text_class': new RegExp('^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$'),
    'record_mask_text_selector': '*',
    'record_max_ms': $6fb9842575b03497$var$MAX_RECORDING_MS,
    'record_min_ms': 0,
    'record_sessions_percent': 0,
    'recorder_src': 'https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js'
};
var $6fb9842575b03497$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $6fb9842575b03497$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $6fb9842575b03497$var$create_mplib = function(token, config, name) {
    var instance, target = name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME ? $6fb9842575b03497$var$mixpanel_master : $6fb9842575b03497$var$mixpanel_master[name];
    if (target && $6fb9842575b03497$var$init_type === $6fb9842575b03497$var$INIT_MODULE) instance = target;
    else {
        if (target && !$6fb9842575b03497$var$_.isArray(target)) {
            $6fb9842575b03497$var$console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new $6fb9842575b03497$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance['people'] = new $6fb9842575b03497$var$MixpanelPeople();
    instance['people']._init(instance);
    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $6fb9842575b03497$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $6fb9842575b03497$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance['people'].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $6fb9842575b03497$var$Config.DEBUG = $6fb9842575b03497$var$Config.DEBUG || instance.get_config('debug');
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$6fb9842575b03497$var$_.isUndefined(target) && $6fb9842575b03497$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $6fb9842575b03497$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($6fb9842575b03497$var$_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }
    var instance = $6fb9842575b03497$var$create_mplib(token, config, name);
    $6fb9842575b03497$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$6fb9842575b03497$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this['__loaded'] = true;
    this['config'] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || $6fb9842575b03497$var$DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) variable_features['api_payload_format'] = $6fb9842575b03497$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': (name === $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME ? name : $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));
    this['_jsc'] = $6fb9842575b03497$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!$6fb9842575b03497$var$_.localStorage.is_supported(true) || !$6fb9842575b03497$var$USE_XHR) {
            this._batch_requests = false;
            $6fb9842575b03497$var$console$1.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
            $6fb9842575b03497$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $6fb9842575b03497$var$console$1.log('Clearing batch queue ' + batcher_config.queue_key);
                $6fb9842575b03497$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($6fb9842575b03497$var$sendBeacon && $6fb9842575b03497$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $6fb9842575b03497$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $6fb9842575b03497$var$win.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) flush_on_unload();
                });
                $6fb9842575b03497$var$win.addEventListener('visibilitychange', function() {
                    if ($6fb9842575b03497$var$document$1['visibilityState'] === 'hidden') flush_on_unload();
                });
            }
        }
    }
    this['persistence'] = this['cookie'] = new $6fb9842575b03497$var$MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $6fb9842575b03497$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        'distinct_id': $6fb9842575b03497$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    this.flags = new $6fb9842575b03497$var$FeatureFlagManager({
        getConfigFunc: $6fb9842575b03497$var$_.bind(this.get_config, this),
        getDistinctIdFunc: $6fb9842575b03497$var$_.bind(this.get_distinct_id, this),
        trackingFunc: $6fb9842575b03497$var$_.bind(this.track, this)
    });
    this.flags.init();
    this['flags'] = this.flags;
    this.autocapture = new $6fb9842575b03497$var$Autocapture(this);
    this.autocapture.init();
    this._init_tab_id();
    this._check_and_start_session_recording();
};
/**
 * Assigns a unique UUID to this tab / window by leveraging sessionStorage.
 * This is primarily used for session recording, where data must be isolated to the current tab.
 */ $6fb9842575b03497$var$MixpanelLib.prototype._init_tab_id = function() {
    if ($6fb9842575b03497$var$_.sessionStorage.is_supported()) try {
        var key_suffix = this.get_config('name') + '_' + this.get_config('token');
        var tab_id_key = 'mp_tab_id_' + key_suffix;
        // A flag is used to determine if sessionStorage is copied over and we need to generate a new tab ID.
        // This enforces a unique ID in the cases like duplicated tab, window.open(...)
        var should_generate_new_tab_id_key = 'mp_gen_new_tab_id_' + key_suffix;
        if ($6fb9842575b03497$var$_.sessionStorage.get(should_generate_new_tab_id_key) || !$6fb9842575b03497$var$_.sessionStorage.get(tab_id_key)) $6fb9842575b03497$var$_.sessionStorage.set(tab_id_key, '$tab-' + $6fb9842575b03497$var$_.UUID());
        $6fb9842575b03497$var$_.sessionStorage.set(should_generate_new_tab_id_key, '1');
        this.tab_id = $6fb9842575b03497$var$_.sessionStorage.get(tab_id_key);
        // Remove the flag when the tab is unloaded to indicate the stored tab ID can be reused. This event is not reliable to detect all page unloads,
        // but reliable in cases where the user remains in the tab e.g. a refresh or href navigation.
        // If the flag is absent, this indicates to the next SDK instance that we can reuse the stored tab_id.
        $6fb9842575b03497$var$win.addEventListener('beforeunload', function() {
            $6fb9842575b03497$var$_.sessionStorage.remove(should_generate_new_tab_id_key);
        });
    } catch (err) {
        this.report_error('Error initializing tab id', err);
    }
    else this.report_error('Session storage is not supported, cannot keep track of unique tab ID.');
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_tab_id = function() {
    return this.tab_id || null;
};
$6fb9842575b03497$var$MixpanelLib.prototype._should_load_recorder = function() {
    var recording_registry_idb = new $6fb9842575b03497$var$IDBStorageWrapper($6fb9842575b03497$var$RECORDING_REGISTRY_STORE_NAME);
    var tab_id = this.get_tab_id();
    return recording_registry_idb.init().then(function() {
        return recording_registry_idb.getAll();
    }).then(function(recordings) {
        for(var i = 0; i < recordings.length; i++){
            // if there are expired recordings in the registry, we should load the recorder to flush them
            // if there's a recording for this tab id, we should load the recorder to continue the recording
            if ($6fb9842575b03497$var$isRecordingExpired(recordings[i]) || recordings[i]['tabId'] === tab_id) return true;
        }
        return false;
    }).catch($6fb9842575b03497$var$_.bind(function(err) {
        this.report_error('Error checking recording registry', err);
    }, this));
};
$6fb9842575b03497$var$MixpanelLib.prototype._check_and_start_session_recording = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(force_start) {
    if (!$6fb9842575b03497$var$win['MutationObserver']) {
        $6fb9842575b03497$var$console$1.critical('Browser does not support MutationObserver; skipping session recording');
        return;
    }
    var loadRecorder = $6fb9842575b03497$var$_.bind(function(startNewIfInactive) {
        var handleLoadedRecorder = $6fb9842575b03497$var$_.bind(function() {
            this._recorder = this._recorder || new $6fb9842575b03497$var$win['__mp_recorder'](this);
            this._recorder['resumeRecording'](startNewIfInactive);
        }, this);
        if ($6fb9842575b03497$var$_.isUndefined($6fb9842575b03497$var$win['__mp_recorder'])) $6fb9842575b03497$var$load_extra_bundle(this.get_config('recorder_src'), handleLoadedRecorder);
        else handleLoadedRecorder();
    }, this);
    /**
     * If the user is sampled or start_session_recording is called, we always load the recorder since it's guaranteed a recording should start.
     * Otherwise, if the recording registry has any records then it's likely there's a recording in progress or orphaned data that needs to be flushed.
     */ var is_sampled = this.get_config('record_sessions_percent') > 0 && Math.random() * 100 <= this.get_config('record_sessions_percent');
    if (force_start || is_sampled) loadRecorder(true);
    else this._should_load_recorder().then(function(shouldLoad) {
        if (shouldLoad) loadRecorder(false);
    });
});
$6fb9842575b03497$var$MixpanelLib.prototype.start_session_recording = function() {
    this._check_and_start_session_recording(true);
};
$6fb9842575b03497$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) this._recorder['stopRecording']();
};
$6fb9842575b03497$var$MixpanelLib.prototype.pause_session_recording = function() {
    if (this._recorder) this._recorder['pauseRecording']();
};
$6fb9842575b03497$var$MixpanelLib.prototype.resume_session_recording = function() {
    if (this._recorder) this._recorder['resumeRecording']();
};
$6fb9842575b03497$var$MixpanelLib.prototype.is_recording_heatmap_data = function() {
    return this._get_session_replay_id() && this.get_config('record_heatmap_data');
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    var replay_id = this._get_session_replay_id();
    if (replay_id) props['$mp_replay_id'] = replay_id;
    return props;
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_session_replay_url = function() {
    var replay_url = null;
    var replay_id = this._get_session_replay_id();
    if (replay_id) {
        var query_params = $6fb9842575b03497$var$_.HTTPBuildQuery({
            'replay_id': replay_id,
            'distinct_id': this.get_distinct_id(),
            'token': this.get_config('token')
        });
        replay_url = 'https://mixpanel.com/projects/replay-redirect?' + query_params;
    }
    return replay_url;
};
$6fb9842575b03497$var$MixpanelLib.prototype._get_session_replay_id = function() {
    var replay_id = null;
    if (this._recorder) replay_id = this._recorder['replayId'];
    return replay_id || null;
};
// "private" public method to reach into the recorder in test cases
$6fb9842575b03497$var$MixpanelLib.prototype.__get_recorder = function() {
    return this._recorder;
};
// Private methods
$6fb9842575b03497$var$MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
    this['people'].set_once(this['persistence'].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config('store_google') && this.get_config('stop_utm_persistence')) {
        var utm_params = $6fb9842575b03497$var$_.info.campaignParams(null);
        $6fb9842575b03497$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$6fb9842575b03497$var$MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword($6fb9842575b03497$var$document$1.referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config('store_google') && !this.get_config('stop_utm_persistence')) this.register($6fb9842575b03497$var$_.info.campaignParams());
    if (this.get_config('save_referrer')) this['persistence'].update_referrer_info($6fb9842575b03497$var$document$1.referrer);
};
$6fb9842575b03497$var$MixpanelLib.prototype._dom_loaded = function() {
    $6fb9842575b03497$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $6fb9842575b03497$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$6fb9842575b03497$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }
    if (!$6fb9842575b03497$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $6fb9842575b03497$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($6fb9842575b03497$var$_.isUndefined(callback)) return null;
    if ($6fb9842575b03497$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$6fb9842575b03497$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($6fb9842575b03497$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;
    if (!callback && ($6fb9842575b03497$var$_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = $6fb9842575b03497$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$6fb9842575b03497$var$USE_XHR) options.method = 'GET';
    var use_post = options.method === 'POST';
    var use_sendBeacon = $6fb9842575b03497$var$sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) verbose_mode = true;
    if (this.get_config('test')) data['test'] = 1;
    if (verbose_mode) data['verbose'] = 1;
    if (this.get_config('img')) data['img'] = 1;
    if (!$6fb9842575b03497$var$USE_XHR) {
        if (callback) data['callback'] = callback;
        else if (verbose_mode || this.get_config('test')) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
    }
    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }
    url += '?' + $6fb9842575b03497$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ('img' in data) {
        var img = $6fb9842575b03497$var$document$1.createElement('img');
        img.src = url;
        $6fb9842575b03497$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $6fb9842575b03497$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($6fb9842575b03497$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config('xhr_headers');
        if (use_post) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        $6fb9842575b03497$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== 'undefined') {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $6fb9842575b03497$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = 'timeout';
                    else error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req['responseHeaders'] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req['status'],
                                error: error,
                                retryAfter: response_headers['Retry-After']
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $6fb9842575b03497$var$document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $6fb9842575b03497$var$document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $6fb9842575b03497$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $6fb9842575b03497$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($6fb9842575b03497$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === 'function') item.call(this);
            else if ($6fb9842575b03497$var$_.isArray(item) && fn_name === 'alias') alias_calls.push(item);
            else if ($6fb9842575b03497$var$_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $6fb9842575b03497$var$_.each(calls, function(item) {
            if ($6fb9842575b03497$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $6fb9842575b03497$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$6fb9842575b03497$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$6fb9842575b03497$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = '__mpq_' + this.get_config('token');
    var api_routes = this.get_config('api_routes');
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: 'events',
            endpoint: '/' + api_routes['track'],
            queue_key: queue_prefix + '_ev'
        },
        people: {
            type: 'people',
            endpoint: '/' + api_routes['engage'],
            queue_key: queue_prefix + '_pp'
        },
        groups: {
            type: 'groups',
            endpoint: '/' + api_routes['groups'],
            queue_key: queue_prefix + '_gr'
        }
    };
    return this._batcher_configs;
};
$6fb9842575b03497$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $6fb9842575b03497$var$_.bind(function(attrs) {
            return new $6fb9842575b03497$var$RequestBatcher(attrs.queue_key, {
                libConfig: this['config'],
                errorReporter: this.get_config('error_reporter'),
                sendRequestFunc: $6fb9842575b03497$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config('api_host') + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $6fb9842575b03497$var$_.bind(function(item) {
                    return this._run_hook('before_send_' + attrs.type, item);
                }, this),
                stopAllBatchingFunc: $6fb9842575b03497$var$_.bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config('batch_autostart')) this.start_batch_senders();
};
$6fb9842575b03497$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$6fb9842575b03497$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $6fb9842575b03497$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $6fb9842575b03497$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === 'undefined') this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$6fb9842575b03497$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $6fb9842575b03497$var$JSONStringify(data);
    if (this.get_config('api_payload_format') === $6fb9842575b03497$var$PAYLOAD_TYPE_BASE64) encoded_data = $6fb9842575b03497$var$_.base64Encode(encoded_data);
    return {
        'data': encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$6fb9842575b03497$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $6fb9842575b03497$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $6fb9842575b03497$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $6fb9842575b03497$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        if (truncated_data) {
            $6fb9842575b03497$var$console$1.log('MIXPANEL REQUEST:');
            $6fb9842575b03497$var$console$1.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data).then(function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') callback = $6fb9842575b03497$var$NOOP_FUNC;
    if ($6fb9842575b03497$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $6fb9842575b03497$var$_.extend({}, properties);
    properties['token'] = this.get_config('token');
    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!$6fb9842575b03497$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config('track_marketing') ? $6fb9842575b03497$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$_.info.properties({
        'mp_loader': this.get_config('mp_loader')
    }), marketing_properties, this['persistence'].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config('property_blacklist');
    if ($6fb9842575b03497$var$_.isArray(property_blacklist)) $6fb9842575b03497$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/' + this.get_config('api_routes')['track'],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $6fb9842575b03497$var$MixpanelLib.prototype.set_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$6fb9842575b03497$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.add_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this['people'].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.remove_group = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this['people'].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_with_groups = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $6fb9842575b03497$var$_.extend({}, properties || {});
    $6fb9842575b03497$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$6fb9842575b03497$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};
$6fb9842575b03497$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $6fb9842575b03497$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_pageview = $6fb9842575b03497$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== 'object') properties = {};
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';
    var default_page_properties = $6fb9842575b03497$var$_.extend($6fb9842575b03497$var$_.info.mpPageViewProperties(), $6fb9842575b03497$var$_.info.campaignParams(), $6fb9842575b03497$var$_.info.clickParams());
    var event_properties = $6fb9842575b03497$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $6fb9842575b03497$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $6fb9842575b03497$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $6fb9842575b03497$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($6fb9842575b03497$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this['persistence'].set_event_timer(event_name, new Date().getTime());
};
var $6fb9842575b03497$var$REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $6fb9842575b03497$var$options_for_register = function(days_or_options) {
    var options;
    if ($6fb9842575b03497$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$6fb9842575b03497$var$_.isUndefined(days_or_options)) options = {
        'days': days_or_options
    };
    else options = {};
    return $6fb9842575b03497$var$_.extend({}, $6fb9842575b03497$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $6fb9842575b03497$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register(props, options['days']);
    else $6fb9842575b03497$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $6fb9842575b03497$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register_once(props, default_value, options['days']);
    else {
        if (typeof default_value === 'undefined') default_value = 'None';
        $6fb9842575b03497$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $6fb9842575b03497$var$options_for_register(options);
    if (options['persistent']) this['persistence'].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$6fb9842575b03497$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf($6fb9842575b03497$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({
            '$user_id': new_distinct_id
        });
    }
    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($6fb9842575b03497$var$ALIAS_ID_KEY)) {
        this.unregister($6fb9842575b03497$var$ALIAS_ID_KEY);
        this.register({
            'distinct_id': new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track('$identify', {
        'distinct_id': new_distinct_id,
        '$anon_distinct_id': previous_distinct_id
    }, {
        skip_hooks: true
    });
    // check feature flags again if distinct id has changed
    if (new_distinct_id !== previous_distinct_id) this.flags.fetchFlags();
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = $6fb9842575b03497$var$_.UUID();
    this.register_once({
        'distinct_id': $6fb9842575b03497$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($6fb9842575b03497$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }
    var _this = this;
    if ($6fb9842575b03497$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($6fb9842575b03497$var$ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $6fb9842575b03497$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $6fb9842575b03497$var$MixpanelLib.prototype.set_config = function(config) {
    if ($6fb9842575b03497$var$_.isObject(config)) {
        $6fb9842575b03497$var$_.extend(this['config'], config);
        var new_batch_size = config['batch_size'];
        if (new_batch_size) $6fb9842575b03497$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config('persistence_name')) this['config']['persistence_name'] = this['config']['cookie_name'];
        if (!this.get_config('disable_persistence')) this['config']['disable_persistence'] = this['config']['disable_cookie'];
        if (this['persistence']) this['persistence'].update_config(this['config']);
        $6fb9842575b03497$var$Config.DEBUG = $6fb9842575b03497$var$Config.DEBUG || this.get_config('debug');
        if (('autocapture' in config || 'record_heatmap_data' in config) && this.autocapture) this.autocapture.init();
    }
};
/**
 * returns the current config object for the library.
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $6fb9842575b03497$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || $6fb9842575b03497$var$IDENTITY_FUNC).apply(this, $6fb9842575b03497$var$slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $6fb9842575b03497$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence'].load_prop([
        property_name
    ]);
};
$6fb9842575b03497$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) name = $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME + '.' + name;
    return name;
};
$6fb9842575b03497$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $6fb9842575b03497$var$_.isBlockedUA($6fb9842575b03497$var$userAgent) || this._flags.disable_all_events || $6fb9842575b03497$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$6fb9842575b03497$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $6fb9842575b03497$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            'persistence_type': 'cookie'
        })) this.opt_in_tracking({
            'enable_persistence': false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            'persistence_type': 'cookie'
        })) this.opt_out_tracking({
            'clear_persistence': false
        });
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        'clear_persistence': true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config('opt_out_tracking_by_default') || $6fb9842575b03497$var$_.cookie.get('mp_optout'))) {
        $6fb9842575b03497$var$_.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $6fb9842575b03497$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) disabled = true;
    else if (options && options['enable_persistence']) disabled = false;
    else return;
    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) this['persistence'].set_disabled(disabled);
    if (disabled) {
        this.stop_batch_senders();
        this.stop_session_recording();
    } else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$6fb9842575b03497$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $6fb9842575b03497$var$_.extend({
        'track': $6fb9842575b03497$var$_.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$6fb9842575b03497$var$_.localStorage.is_supported()) options['persistence_type'] = 'cookie';
    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($6fb9842575b03497$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }
    this._gdpr_call_func($6fb9842575b03497$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($6fb9842575b03497$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($6fb9842575b03497$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6fb9842575b03497$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $6fb9842575b03497$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($6fb9842575b03497$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$6fb9842575b03497$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $6fb9842575b03497$var$console$1.error.apply($6fb9842575b03497$var$console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        $6fb9842575b03497$var$console$1.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$6fb9842575b03497$var$MixpanelLib.prototype['init'] = $6fb9842575b03497$var$MixpanelLib.prototype.init;
$6fb9842575b03497$var$MixpanelLib.prototype['reset'] = $6fb9842575b03497$var$MixpanelLib.prototype.reset;
$6fb9842575b03497$var$MixpanelLib.prototype['disable'] = $6fb9842575b03497$var$MixpanelLib.prototype.disable;
$6fb9842575b03497$var$MixpanelLib.prototype['time_event'] = $6fb9842575b03497$var$MixpanelLib.prototype.time_event;
$6fb9842575b03497$var$MixpanelLib.prototype['track'] = $6fb9842575b03497$var$MixpanelLib.prototype.track;
$6fb9842575b03497$var$MixpanelLib.prototype['track_links'] = $6fb9842575b03497$var$MixpanelLib.prototype.track_links;
$6fb9842575b03497$var$MixpanelLib.prototype['track_forms'] = $6fb9842575b03497$var$MixpanelLib.prototype.track_forms;
$6fb9842575b03497$var$MixpanelLib.prototype['track_pageview'] = $6fb9842575b03497$var$MixpanelLib.prototype.track_pageview;
$6fb9842575b03497$var$MixpanelLib.prototype['register'] = $6fb9842575b03497$var$MixpanelLib.prototype.register;
$6fb9842575b03497$var$MixpanelLib.prototype['register_once'] = $6fb9842575b03497$var$MixpanelLib.prototype.register_once;
$6fb9842575b03497$var$MixpanelLib.prototype['unregister'] = $6fb9842575b03497$var$MixpanelLib.prototype.unregister;
$6fb9842575b03497$var$MixpanelLib.prototype['identify'] = $6fb9842575b03497$var$MixpanelLib.prototype.identify;
$6fb9842575b03497$var$MixpanelLib.prototype['alias'] = $6fb9842575b03497$var$MixpanelLib.prototype.alias;
$6fb9842575b03497$var$MixpanelLib.prototype['name_tag'] = $6fb9842575b03497$var$MixpanelLib.prototype.name_tag;
$6fb9842575b03497$var$MixpanelLib.prototype['set_config'] = $6fb9842575b03497$var$MixpanelLib.prototype.set_config;
$6fb9842575b03497$var$MixpanelLib.prototype['get_config'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_config;
$6fb9842575b03497$var$MixpanelLib.prototype['get_property'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_property;
$6fb9842575b03497$var$MixpanelLib.prototype['get_distinct_id'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_distinct_id;
$6fb9842575b03497$var$MixpanelLib.prototype['toString'] = $6fb9842575b03497$var$MixpanelLib.prototype.toString;
$6fb9842575b03497$var$MixpanelLib.prototype['opt_out_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.opt_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['opt_in_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.opt_in_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['has_opted_out_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['has_opted_in_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.has_opted_in_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['clear_opt_in_out_tracking'] = $6fb9842575b03497$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$6fb9842575b03497$var$MixpanelLib.prototype['get_group'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_group;
$6fb9842575b03497$var$MixpanelLib.prototype['set_group'] = $6fb9842575b03497$var$MixpanelLib.prototype.set_group;
$6fb9842575b03497$var$MixpanelLib.prototype['add_group'] = $6fb9842575b03497$var$MixpanelLib.prototype.add_group;
$6fb9842575b03497$var$MixpanelLib.prototype['remove_group'] = $6fb9842575b03497$var$MixpanelLib.prototype.remove_group;
$6fb9842575b03497$var$MixpanelLib.prototype['track_with_groups'] = $6fb9842575b03497$var$MixpanelLib.prototype.track_with_groups;
$6fb9842575b03497$var$MixpanelLib.prototype['start_batch_senders'] = $6fb9842575b03497$var$MixpanelLib.prototype.start_batch_senders;
$6fb9842575b03497$var$MixpanelLib.prototype['stop_batch_senders'] = $6fb9842575b03497$var$MixpanelLib.prototype.stop_batch_senders;
$6fb9842575b03497$var$MixpanelLib.prototype['start_session_recording'] = $6fb9842575b03497$var$MixpanelLib.prototype.start_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype['stop_session_recording'] = $6fb9842575b03497$var$MixpanelLib.prototype.stop_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype['pause_session_recording'] = $6fb9842575b03497$var$MixpanelLib.prototype.pause_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype['resume_session_recording'] = $6fb9842575b03497$var$MixpanelLib.prototype.resume_session_recording;
$6fb9842575b03497$var$MixpanelLib.prototype['get_session_recording_properties'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_session_recording_properties;
$6fb9842575b03497$var$MixpanelLib.prototype['get_session_replay_url'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_session_replay_url;
$6fb9842575b03497$var$MixpanelLib.prototype['get_tab_id'] = $6fb9842575b03497$var$MixpanelLib.prototype.get_tab_id;
$6fb9842575b03497$var$MixpanelLib.prototype['DEFAULT_API_ROUTES'] = $6fb9842575b03497$var$DEFAULT_API_ROUTES;
// Exports intended only for testing
$6fb9842575b03497$var$MixpanelLib.prototype['__get_recorder'] = $6fb9842575b03497$var$MixpanelLib.prototype.__get_recorder;
// MixpanelPersistence Exports
$6fb9842575b03497$var$MixpanelPersistence.prototype['properties'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.properties;
$6fb9842575b03497$var$MixpanelPersistence.prototype['update_search_keyword'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.update_search_keyword;
$6fb9842575b03497$var$MixpanelPersistence.prototype['update_referrer_info'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.update_referrer_info;
$6fb9842575b03497$var$MixpanelPersistence.prototype['get_cross_subdomain'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.get_cross_subdomain;
$6fb9842575b03497$var$MixpanelPersistence.prototype['clear'] = $6fb9842575b03497$var$MixpanelPersistence.prototype.clear;
var $6fb9842575b03497$var$instances = {};
var $6fb9842575b03497$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $6fb9842575b03497$var$_.each($6fb9842575b03497$var$instances, function(instance, name) {
        if (name !== $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME) $6fb9842575b03497$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $6fb9842575b03497$var$mixpanel_master['_'] = $6fb9842575b03497$var$_;
};
var $6fb9842575b03497$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $6fb9842575b03497$var$mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$6fb9842575b03497$var$mixpanel_master[name]) {
                $6fb9842575b03497$var$mixpanel_master[name] = $6fb9842575b03497$var$instances[name] = $6fb9842575b03497$var$create_mplib(token, config, name);
                $6fb9842575b03497$var$mixpanel_master[name]._loaded();
            }
            return $6fb9842575b03497$var$mixpanel_master[name];
        } else {
            var instance = $6fb9842575b03497$var$mixpanel_master;
            if ($6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $6fb9842575b03497$var$create_mplib(token, config, $6fb9842575b03497$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $6fb9842575b03497$var$instances[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $6fb9842575b03497$var$mixpanel_master = instance;
            if ($6fb9842575b03497$var$init_type === $6fb9842575b03497$var$INIT_SNIPPET) $6fb9842575b03497$var$win[$6fb9842575b03497$var$PRIMARY_INSTANCE_NAME] = $6fb9842575b03497$var$mixpanel_master;
            $6fb9842575b03497$var$extend_mp();
        }
    };
};
var $6fb9842575b03497$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $6fb9842575b03497$var$DOM_LOADED = true;
        $6fb9842575b03497$var$ENQUEUE_REQUESTS = false;
        $6fb9842575b03497$var$_.each($6fb9842575b03497$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $6fb9842575b03497$var$document$1.documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($6fb9842575b03497$var$document$1.addEventListener) {
        if ($6fb9842575b03497$var$document$1.readyState === 'complete') // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $6fb9842575b03497$var$document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
    } else if ($6fb9842575b03497$var$document$1.attachEvent) {
        // IE
        $6fb9842575b03497$var$document$1.attachEvent('onreadystatechange', dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $6fb9842575b03497$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($6fb9842575b03497$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $6fb9842575b03497$var$_.register_event($6fb9842575b03497$var$win, 'load', dom_loaded_handler, true);
};
function $6fb9842575b03497$var$init_as_module(bundle_loader) {
    $6fb9842575b03497$var$load_extra_bundle = bundle_loader;
    $6fb9842575b03497$var$init_type = $6fb9842575b03497$var$INIT_MODULE;
    $6fb9842575b03497$var$mixpanel_master = new $6fb9842575b03497$var$MixpanelLib();
    $6fb9842575b03497$var$override_mp_init_func();
    $6fb9842575b03497$var$mixpanel_master['init']();
    $6fb9842575b03497$var$add_dom_loaded_handler();
    return $6fb9842575b03497$var$mixpanel_master;
}
// For loading separate bundles asynchronously via script tag
// so that we don't load them until they are needed at runtime.
// For builds that have everything in one bundle, no extra work.
function $6fb9842575b03497$var$loadNoop(_src, onload) {
    onload();
}
/* eslint camelcase: "off" */ var $6fb9842575b03497$export$2e2bcd8739ae039 = $6fb9842575b03497$var$init_as_module($6fb9842575b03497$var$loadNoop);



var $acw62 = parcelRequire("acw62");
/**
 * react-router v7.6.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $9fd38747d73cb940$exports = {};
"use strict";
Object.defineProperty($9fd38747d73cb940$exports, "__esModule", {
    value: true
});
$9fd38747d73cb940$exports.parse = $9fd38747d73cb940$var$parse;
$9fd38747d73cb940$exports.serialize = $9fd38747d73cb940$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $9fd38747d73cb940$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $9fd38747d73cb940$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $9fd38747d73cb940$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $9fd38747d73cb940$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $9fd38747d73cb940$var$__toString = Object.prototype.toString;
const $9fd38747d73cb940$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $9fd38747d73cb940$var$parse(str, options) {
    const obj = new $9fd38747d73cb940$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $9fd38747d73cb940$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $9fd38747d73cb940$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $9fd38747d73cb940$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $9fd38747d73cb940$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $9fd38747d73cb940$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $9fd38747d73cb940$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $9fd38747d73cb940$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $9fd38747d73cb940$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$9fd38747d73cb940$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$9fd38747d73cb940$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$9fd38747d73cb940$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$9fd38747d73cb940$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$9fd38747d73cb940$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $9fd38747d73cb940$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $9fd38747d73cb940$var$isDate(val) {
    return $9fd38747d73cb940$var$__toString.call(val) === "[object Date]";
}


var $e4a96bcce5e8f1ac$exports = {};
"use strict";
var $e4a96bcce5e8f1ac$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $e4a96bcce5e8f1ac$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $e4a96bcce5e8f1ac$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($e4a96bcce5e8f1ac$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $e4a96bcce5e8f1ac$var$parse(input, options) {
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).map(function(str) {
        return $e4a96bcce5e8f1ac$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $e4a96bcce5e8f1ac$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $e4a96bcce5e8f1ac$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$e4a96bcce5e8f1ac$exports = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parse = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parseString = $e4a96bcce5e8f1ac$var$parseString;
$e4a96bcce5e8f1ac$exports.splitCookiesString = $e4a96bcce5e8f1ac$var$splitCookiesString;


var $fbd80a69cf576f05$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-D4RADZKF.mjs"
});
var $fbd80a69cf576f05$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $fbd80a69cf576f05$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $fbd80a69cf576f05$var$__typeError("Cannot " + msg);
var $fbd80a69cf576f05$var$__privateGet = (obj, member, getter)=>($fbd80a69cf576f05$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $fbd80a69cf576f05$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $fbd80a69cf576f05$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $fbd80a69cf576f05$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($fbd80a69cf576f05$export$e19cd5f9376f8cee || {});
var $fbd80a69cf576f05$var$PopStateEventType = "popstate";
function $fbd80a69cf576f05$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $fbd80a69cf576f05$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $fbd80a69cf576f05$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $fbd80a69cf576f05$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $fbd80a69cf576f05$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $fbd80a69cf576f05$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $fbd80a69cf576f05$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $fbd80a69cf576f05$export$fe53371bee54353d(to);
    }
    return $fbd80a69cf576f05$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $fbd80a69cf576f05$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $fbd80a69cf576f05$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $fbd80a69cf576f05$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href2 = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href2 = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href2 + "#" + (typeof to === "string" ? to : $fbd80a69cf576f05$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $fbd80a69cf576f05$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $fbd80a69cf576f05$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $fbd80a69cf576f05$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $fbd80a69cf576f05$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $fbd80a69cf576f05$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $fbd80a69cf576f05$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $fbd80a69cf576f05$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $fbd80a69cf576f05$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $fbd80a69cf576f05$var$createKey()
    };
    return location;
}
function $fbd80a69cf576f05$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $fbd80a69cf576f05$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $fbd80a69cf576f05$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $fbd80a69cf576f05$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $fbd80a69cf576f05$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $fbd80a69cf576f05$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $fbd80a69cf576f05$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $fbd80a69cf576f05$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($fbd80a69cf576f05$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($fbd80a69cf576f05$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $fbd80a69cf576f05$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $fbd80a69cf576f05$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href2 = typeof to === "string" ? to : $fbd80a69cf576f05$export$fe53371bee54353d(to);
    href2 = href2.replace(/ $/, "%20");
    if (!isAbsolute && href2.startsWith("//")) href2 = base + href2;
    return new URL(href2, base);
}
// lib/router/utils.ts
function $fbd80a69cf576f05$export$f4fcb186418daff5(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $fbd80a69cf576f05$var$_map;
var $fbd80a69cf576f05$export$b754276817659c2d = class {
    constructor(init){
        $fbd80a69cf576f05$var$__privateAdd(this, $fbd80a69cf576f05$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    get(context) {
        if ($fbd80a69cf576f05$var$__privateGet(this, $fbd80a69cf576f05$var$_map).has(context)) return $fbd80a69cf576f05$var$__privateGet(this, $fbd80a69cf576f05$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    set(context, value) {
        $fbd80a69cf576f05$var$__privateGet(this, $fbd80a69cf576f05$var$_map).set(context, value);
    }
};
$fbd80a69cf576f05$var$_map = new WeakMap();
var $fbd80a69cf576f05$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $fbd80a69cf576f05$var$isUnsupportedLazyRouteObjectKey(key) {
    return $fbd80a69cf576f05$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $fbd80a69cf576f05$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "unstable_middleware",
    "children"
]);
function $fbd80a69cf576f05$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $fbd80a69cf576f05$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $fbd80a69cf576f05$var$isIndexRoute(route) {
    return route.index === true;
}
function $fbd80a69cf576f05$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $fbd80a69cf576f05$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $fbd80a69cf576f05$export$f5708dca728d7177(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($fbd80a69cf576f05$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $fbd80a69cf576f05$var$convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function $fbd80a69cf576f05$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $fbd80a69cf576f05$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $fbd80a69cf576f05$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $fbd80a69cf576f05$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $fbd80a69cf576f05$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $fbd80a69cf576f05$var$flattenRoutes(routes);
    $fbd80a69cf576f05$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $fbd80a69cf576f05$var$decodePath(pathname);
        matches = $fbd80a69cf576f05$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $fbd80a69cf576f05$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $fbd80a69cf576f05$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $fbd80a69cf576f05$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $fbd80a69cf576f05$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $fbd80a69cf576f05$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $fbd80a69cf576f05$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $fbd80a69cf576f05$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $fbd80a69cf576f05$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $fbd80a69cf576f05$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $fbd80a69cf576f05$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $fbd80a69cf576f05$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $fbd80a69cf576f05$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $fbd80a69cf576f05$var$paramRe = /^:[\w-]+$/;
var $fbd80a69cf576f05$var$dynamicSegmentValue = 3;
var $fbd80a69cf576f05$var$indexRouteValue = 2;
var $fbd80a69cf576f05$var$emptySegmentValue = 1;
var $fbd80a69cf576f05$var$staticSegmentValue = 10;
var $fbd80a69cf576f05$var$splatPenalty = -2;
var $fbd80a69cf576f05$var$isSplat = (s)=>s === "*";
function $fbd80a69cf576f05$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($fbd80a69cf576f05$var$isSplat)) initialScore += $fbd80a69cf576f05$var$splatPenalty;
    if (index) initialScore += $fbd80a69cf576f05$var$indexRouteValue;
    return segments.filter((s)=>!$fbd80a69cf576f05$var$isSplat(s)).reduce((score, segment)=>score + ($fbd80a69cf576f05$var$paramRe.test(segment) ? $fbd80a69cf576f05$var$dynamicSegmentValue : segment === "" ? $fbd80a69cf576f05$var$emptySegmentValue : $fbd80a69cf576f05$var$staticSegmentValue), initialScore);
}
function $fbd80a69cf576f05$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $fbd80a69cf576f05$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $fbd80a69cf576f05$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $fbd80a69cf576f05$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $fbd80a69cf576f05$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $fbd80a69cf576f05$var$normalizePathname($fbd80a69cf576f05$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $fbd80a69cf576f05$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $fbd80a69cf576f05$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $fbd80a69cf576f05$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $fbd80a69cf576f05$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify2(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $fbd80a69cf576f05$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $fbd80a69cf576f05$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $fbd80a69cf576f05$var$compilePath(path, caseSensitive = false, end = true) {
    $fbd80a69cf576f05$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $fbd80a69cf576f05$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $fbd80a69cf576f05$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $fbd80a69cf576f05$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $fbd80a69cf576f05$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $fbd80a69cf576f05$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $fbd80a69cf576f05$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $fbd80a69cf576f05$var$normalizeSearch(search),
        hash: $fbd80a69cf576f05$var$normalizeHash(hash)
    };
}
function $fbd80a69cf576f05$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $fbd80a69cf576f05$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $fbd80a69cf576f05$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $fbd80a69cf576f05$var$getResolveToMatches(matches) {
    let pathMatches = $fbd80a69cf576f05$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $fbd80a69cf576f05$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $fbd80a69cf576f05$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $fbd80a69cf576f05$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $fbd80a69cf576f05$var$getInvalidPathError("?", "pathname", "search", to));
        $fbd80a69cf576f05$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $fbd80a69cf576f05$var$getInvalidPathError("#", "pathname", "hash", to));
        $fbd80a69cf576f05$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $fbd80a69cf576f05$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $fbd80a69cf576f05$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $fbd80a69cf576f05$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $fbd80a69cf576f05$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $fbd80a69cf576f05$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $fbd80a69cf576f05$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $fbd80a69cf576f05$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $fbd80a69cf576f05$export$4051a07651545597(data2, init) {
    return new $fbd80a69cf576f05$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $fbd80a69cf576f05$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $fbd80a69cf576f05$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $fbd80a69cf576f05$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $fbd80a69cf576f05$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $fbd80a69cf576f05$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $fbd80a69cf576f05$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $fbd80a69cf576f05$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $fbd80a69cf576f05$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $fbd80a69cf576f05$var$validMutationMethods = new Set($fbd80a69cf576f05$var$validMutationMethodsArr);
var $fbd80a69cf576f05$var$validRequestMethodsArr = [
    "GET",
    ...$fbd80a69cf576f05$var$validMutationMethodsArr
];
var $fbd80a69cf576f05$var$validRequestMethods = new Set($fbd80a69cf576f05$var$validRequestMethodsArr);
var $fbd80a69cf576f05$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $fbd80a69cf576f05$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $fbd80a69cf576f05$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $fbd80a69cf576f05$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $fbd80a69cf576f05$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $fbd80a69cf576f05$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $fbd80a69cf576f05$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $fbd80a69cf576f05$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $fbd80a69cf576f05$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $fbd80a69cf576f05$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let mapRouteProperties2 = init.mapRouteProperties || $fbd80a69cf576f05$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $fbd80a69cf576f05$var$convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $fbd80a69cf576f05$var$defaultDataStrategyWithMiddleware;
    let future = {
        unstable_middleware: false,
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $fbd80a69cf576f05$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $fbd80a69cf576f05$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $fbd80a69cf576f05$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$fbd80a69cf576f05$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$fbd80a69cf576f05$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $fbd80a69cf576f05$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $fbd80a69cf576f05$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $fbd80a69cf576f05$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $fbd80a69cf576f05$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$fbd80a69cf576f05$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $fbd80a69cf576f05$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $fbd80a69cf576f05$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $fbd80a69cf576f05$export$386d57f03f0b2883));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $fbd80a69cf576f05$var$isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $fbd80a69cf576f05$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $fbd80a69cf576f05$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $fbd80a69cf576f05$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $fbd80a69cf576f05$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $fbd80a69cf576f05$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $fbd80a69cf576f05$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $fbd80a69cf576f05$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $fbd80a69cf576f05$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $fbd80a69cf576f05$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $fbd80a69cf576f05$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $fbd80a69cf576f05$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = new $fbd80a69cf576f05$export$b754276817659c2d(init.unstable_getContext ? await init.unstable_getContext() : void 0);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $fbd80a69cf576f05$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $fbd80a69cf576f05$var$isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($fbd80a69cf576f05$var$isErrorResult(result) && $fbd80a69cf576f05$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $fbd80a69cf576f05$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $fbd80a69cf576f05$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$fbd80a69cf576f05$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $fbd80a69cf576f05$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fbd80a69cf576f05$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $fbd80a69cf576f05$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $fbd80a69cf576f05$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($fbd80a69cf576f05$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $fbd80a69cf576f05$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($fbd80a69cf576f05$var$isErrorResult(result)) {
            let boundaryMatch = $fbd80a69cf576f05$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $fbd80a69cf576f05$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $fbd80a69cf576f05$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fbd80a69cf576f05$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $fbd80a69cf576f05$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $fbd80a69cf576f05$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$fbd80a69cf576f05$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $fbd80a69cf576f05$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $fbd80a69cf576f05$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $fbd80a69cf576f05$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$fbd80a69cf576f05$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $fbd80a69cf576f05$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href2, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $fbd80a69cf576f05$var$normalizeTo(state.location, state.matches, basename, href2, routeId, opts?.relative);
        let matches = $fbd80a69cf576f05$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $fbd80a69cf576f05$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $fbd80a69cf576f05$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $fbd80a69cf576f05$var$getTargetMatch(matches, path);
        let scopedContext = new $fbd80a69cf576f05$export$b754276817659c2d(init.unstable_getContext ? await init.unstable_getContext() : void 0);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $fbd80a69cf576f05$var$isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $fbd80a69cf576f05$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fbd80a69cf576f05$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fbd80a69cf576f05$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fbd80a69cf576f05$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $fbd80a69cf576f05$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($fbd80a69cf576f05$var$isRedirectResult(actionResult) || $fbd80a69cf576f05$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $fbd80a69cf576f05$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($fbd80a69cf576f05$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $fbd80a69cf576f05$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $fbd80a69cf576f05$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($fbd80a69cf576f05$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $fbd80a69cf576f05$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $fbd80a69cf576f05$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $fbd80a69cf576f05$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $fbd80a69cf576f05$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $fbd80a69cf576f05$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $fbd80a69cf576f05$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $fbd80a69cf576f05$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $fbd80a69cf576f05$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $fbd80a69cf576f05$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $fbd80a69cf576f05$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $fbd80a69cf576f05$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $fbd80a69cf576f05$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fbd80a69cf576f05$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fbd80a69cf576f05$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fbd80a69cf576f05$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $fbd80a69cf576f05$var$getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $fbd80a69cf576f05$var$getDoneFetcher(void 0));
            return;
        }
        if ($fbd80a69cf576f05$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $fbd80a69cf576f05$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($fbd80a69cf576f05$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $fbd80a69cf576f05$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $fbd80a69cf576f05$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $fbd80a69cf576f05$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $fbd80a69cf576f05$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = $fbd80a69cf576f05$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $fbd80a69cf576f05$var$stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $fbd80a69cf576f05$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($fbd80a69cf576f05$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $fbd80a69cf576f05$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $fbd80a69cf576f05$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $fbd80a69cf576f05$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($fbd80a69cf576f05$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $fbd80a69cf576f05$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $fbd80a69cf576f05$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $fbd80a69cf576f05$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $fbd80a69cf576f05$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $fbd80a69cf576f05$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $fbd80a69cf576f05$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $fbd80a69cf576f05$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $fbd80a69cf576f05$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $fbd80a69cf576f05$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $fbd80a69cf576f05$export$386d57f03f0b2883;
        $fbd80a69cf576f05$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $fbd80a69cf576f05$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $fbd80a69cf576f05$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $fbd80a69cf576f05$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $fbd80a69cf576f05$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$fbd80a69cf576f05$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $fbd80a69cf576f05$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $fbd80a69cf576f05$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $fbd80a69cf576f05$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $fbd80a69cf576f05$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $fbd80a69cf576f05$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $fbd80a69cf576f05$var$convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $fbd80a69cf576f05$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function $fbd80a69cf576f05$var$createStaticHandler(routes, opts) {
    $fbd80a69cf576f05$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $fbd80a69cf576f05$var$defaultMapRouteProperties;
    let dataRoutes = $fbd80a69cf576f05$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, unstable_respond: respond } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $fbd80a69cf576f05$var$createLocation("", $fbd80a69cf576f05$export$fe53371bee54353d(url), null, "default");
        let matches = $fbd80a69cf576f05$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $fbd80a69cf576f05$export$b754276817659c2d();
        if (!$fbd80a69cf576f05$var$isValidMethod(method) && method !== "HEAD") {
            let error = $fbd80a69cf576f05$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $fbd80a69cf576f05$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return respond ? respond(staticContext) : staticContext;
        } else if (!matches) {
            let error = $fbd80a69cf576f05$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $fbd80a69cf576f05$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return respond ? respond(staticContext) : staticContext;
        }
        if (respond && matches.some((m)=>m.route.unstable_middleware || typeof m.route.lazy === "object" && m.route.lazy.unstable_middleware)) {
            $fbd80a69cf576f05$export$f5708dca728d7177(requestContext instanceof $fbd80a69cf576f05$export$b754276817659c2d, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            try {
                await $fbd80a69cf576f05$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $fbd80a69cf576f05$var$runMiddlewarePipeline({
                    request: request,
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, true, async ()=>{
                    let result2 = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
                    if ($fbd80a69cf576f05$var$isResponse(result2)) return result2;
                    renderedStaticContext = {
                        location: location,
                        basename: basename,
                        ...result2
                    };
                    let res = await respond(renderedStaticContext);
                    return res;
                }, async (error, routeId)=>{
                    if ($fbd80a69cf576f05$var$isResponse(error)) return error;
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        return respond($fbd80a69cf576f05$var$getStaticContextFromError(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $fbd80a69cf576f05$var$findNearestBoundary(matches, routeId).route.id));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $fbd80a69cf576f05$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        return respond({
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $fbd80a69cf576f05$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        });
                    }
                });
                $fbd80a69cf576f05$export$f5708dca728d7177($fbd80a69cf576f05$var$isResponse(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($fbd80a69cf576f05$var$isResponse(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($fbd80a69cf576f05$var$isResponse(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, unstable_respond: respond } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $fbd80a69cf576f05$var$createLocation("", $fbd80a69cf576f05$export$fe53371bee54353d(url), null, "default");
        let matches = $fbd80a69cf576f05$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $fbd80a69cf576f05$export$b754276817659c2d();
        if (!$fbd80a69cf576f05$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $fbd80a69cf576f05$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $fbd80a69cf576f05$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $fbd80a69cf576f05$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $fbd80a69cf576f05$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $fbd80a69cf576f05$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (respond && matches.some((m)=>m.route.unstable_middleware || typeof m.route.lazy === "object" && m.route.lazy.unstable_middleware)) {
            $fbd80a69cf576f05$export$f5708dca728d7177(requestContext instanceof $fbd80a69cf576f05$export$b754276817659c2d, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            await $fbd80a69cf576f05$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $fbd80a69cf576f05$var$runMiddlewarePipeline({
                request: request,
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, true, async ()=>{
                let result2 = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                if ($fbd80a69cf576f05$var$isResponse(result2)) return respond(result2);
                let error2 = result2.errors ? Object.values(result2.errors)[0] : void 0;
                if (error2 !== void 0) throw error2;
                let value = result2.actionData ? Object.values(result2.actionData)[0] : Object.values(result2.loaderData)[0];
                return typeof value === "string" ? new Response(value) : Response.json(value);
            }, (error2)=>{
                if ($fbd80a69cf576f05$var$isResponse(error2)) return respond(error2);
                return new Response(String(error2), {
                    status: 500,
                    statusText: "Unexpected Server Error"
                });
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        if ($fbd80a69cf576f05$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $fbd80a69cf576f05$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($fbd80a69cf576f05$var$isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $fbd80a69cf576f05$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $fbd80a69cf576f05$var$isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($fbd80a69cf576f05$var$isDataStrategyResult(e) && $fbd80a69cf576f05$var$isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($fbd80a69cf576f05$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $fbd80a69cf576f05$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $fbd80a69cf576f05$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($fbd80a69cf576f05$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($fbd80a69cf576f05$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($fbd80a69cf576f05$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fbd80a69cf576f05$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $fbd80a69cf576f05$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($fbd80a69cf576f05$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fbd80a69cf576f05$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $fbd80a69cf576f05$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $fbd80a69cf576f05$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $fbd80a69cf576f05$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $fbd80a69cf576f05$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, false);
                return $fbd80a69cf576f05$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $fbd80a69cf576f05$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $fbd80a69cf576f05$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $fbd80a69cf576f05$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $fbd80a69cf576f05$var$callDataStrategyImpl(dataStrategy || $fbd80a69cf576f05$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($fbd80a69cf576f05$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $fbd80a69cf576f05$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($fbd80a69cf576f05$var$isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $fbd80a69cf576f05$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $fbd80a69cf576f05$var$getStaticContextFromError(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $fbd80a69cf576f05$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $fbd80a69cf576f05$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $fbd80a69cf576f05$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $fbd80a69cf576f05$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $fbd80a69cf576f05$var$resolveTo(to ? to : ".", $fbd80a69cf576f05$var$getResolveToMatches(contextualMatches), $fbd80a69cf576f05$var$stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $fbd80a69cf576f05$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $fbd80a69cf576f05$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $fbd80a69cf576f05$export$fe53371bee54353d(path);
}
function $fbd80a69cf576f05$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$fbd80a69cf576f05$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$fbd80a69cf576f05$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $fbd80a69cf576f05$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $fbd80a69cf576f05$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $fbd80a69cf576f05$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$fbd80a69cf576f05$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$fbd80a69cf576f05$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $fbd80a69cf576f05$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $fbd80a69cf576f05$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $fbd80a69cf576f05$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $fbd80a69cf576f05$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $fbd80a69cf576f05$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($fbd80a69cf576f05$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $fbd80a69cf576f05$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $fbd80a69cf576f05$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $fbd80a69cf576f05$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $fbd80a69cf576f05$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $fbd80a69cf576f05$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $fbd80a69cf576f05$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (route.loader == null) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $fbd80a69cf576f05$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($fbd80a69cf576f05$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $fbd80a69cf576f05$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $fbd80a69cf576f05$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $fbd80a69cf576f05$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $fbd80a69cf576f05$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = $fbd80a69cf576f05$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $fbd80a69cf576f05$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $fbd80a69cf576f05$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) {
            if (isRevalidationRequired) fetcherDsMatches = $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($fbd80a69cf576f05$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $fbd80a69cf576f05$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $fbd80a69cf576f05$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $fbd80a69cf576f05$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $fbd80a69cf576f05$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $fbd80a69cf576f05$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $fbd80a69cf576f05$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$fbd80a69cf576f05$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $fbd80a69cf576f05$var$convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $fbd80a69cf576f05$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$fbd80a69cf576f05$var$isSameRoute(aChild, bChild)));
}
var $fbd80a69cf576f05$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $fbd80a69cf576f05$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $fbd80a69cf576f05$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $fbd80a69cf576f05$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $fbd80a69cf576f05$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $fbd80a69cf576f05$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $fbd80a69cf576f05$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $fbd80a69cf576f05$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $fbd80a69cf576f05$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $fbd80a69cf576f05$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $fbd80a69cf576f05$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $fbd80a69cf576f05$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $fbd80a69cf576f05$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $fbd80a69cf576f05$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $fbd80a69cf576f05$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $fbd80a69cf576f05$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $fbd80a69cf576f05$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $fbd80a69cf576f05$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $fbd80a69cf576f05$var$isNonNullable(value) {
    return value !== void 0;
}
function $fbd80a69cf576f05$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.unstable_middleware) return void 0;
        return $fbd80a69cf576f05$var$loadLazyRouteProperty({
            key: "unstable_middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($fbd80a69cf576f05$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $fbd80a69cf576f05$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $fbd80a69cf576f05$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.unstable_middleware)) return $fbd80a69cf576f05$var$defaultDataStrategy(args);
    return $fbd80a69cf576f05$var$runMiddlewarePipeline(args, false, ()=>$fbd80a69cf576f05$var$defaultDataStrategy(args), (error, routeId)=>({
            [routeId]: {
                type: "error",
                result: error
            }
        }));
}
async function $fbd80a69cf576f05$var$runMiddlewarePipeline(args, propagateResult, handler, errorHandler) {
    let { matches: matches, request: request, params: params, context: context } = args;
    let middlewareState = {
        handlerResult: void 0
    };
    try {
        let tuples = matches.flatMap((m)=>m.route.unstable_middleware ? m.route.unstable_middleware.map((fn)=>[
                    m.route.id,
                    fn
                ]) : []);
        let result = await $fbd80a69cf576f05$var$callRouteMiddleware({
            request: request,
            params: params,
            context: context
        }, tuples, propagateResult, middlewareState, handler);
        return propagateResult ? result : middlewareState.handlerResult;
    } catch (e) {
        if (!middlewareState.middlewareError) throw e;
        let result = await errorHandler(middlewareState.middlewareError.error, middlewareState.middlewareError.routeId);
        if (propagateResult || !middlewareState.handlerResult) return result;
        return Object.assign(middlewareState.handlerResult, result);
    }
}
async function $fbd80a69cf576f05$var$callRouteMiddleware(args, middlewares, propagateResult, middlewareState, handler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) {
        if (request.signal.reason) throw request.signal.reason;
        throw new Error(`Request aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
    }
    let tuple = middlewares[idx];
    if (!tuple) {
        middlewareState.handlerResult = await handler();
        return middlewareState.handlerResult;
    }
    let [routeId, middleware] = tuple;
    let nextCalled = false;
    let nextResult = void 0;
    let next = async ()=>{
        if (nextCalled) throw new Error("You may only call `next()` once per middleware");
        nextCalled = true;
        let result = await $fbd80a69cf576f05$var$callRouteMiddleware(args, middlewares, propagateResult, middlewareState, handler, idx + 1);
        if (propagateResult) {
            nextResult = result;
            return nextResult;
        }
    };
    try {
        let result = await middleware({
            request: args.request,
            params: args.params,
            context: args.context
        }, next);
        if (nextCalled) {
            if (result === void 0) return nextResult;
            else return result;
        } else return next();
    } catch (error) {
        if (!middlewareState.middlewareError) middlewareState.middlewareError = {
            routeId: routeId,
            error: error
        };
        else if (middlewareState.middlewareError.error !== error) middlewareState.middlewareError = {
            routeId: routeId,
            error: error
        };
        throw error;
    }
}
function $fbd80a69cf576f05$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $fbd80a69cf576f05$var$loadLazyRouteProperty({
        key: "unstable_middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $fbd80a69cf576f05$var$loadLazyRoute(match.route, $fbd80a69cf576f05$var$isMutationMethod(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $fbd80a69cf576f05$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $fbd80a69cf576f05$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        unstable_shouldRevalidateArgs: unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $fbd80a69cf576f05$var$shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $fbd80a69cf576f05$var$shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            if (isUsingNewApi || shouldLoad || handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) return $fbd80a69cf576f05$var$callLoaderOrAction({
                request: request,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $fbd80a69cf576f05$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: $fbd80a69cf576f05$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $fbd80a69cf576f05$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $fbd80a69cf576f05$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let unstable_runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `unstable_runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $fbd80a69cf576f05$var$runMiddlewarePipeline(typedDataStrategyArgs, false, ()=>cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                unstable_runClientMiddleware: ()=>{
                    throw new Error("Cannot call `unstable_runClientMiddleware()` from within an `unstable_runClientMiddleware` handler");
                }
            }), (error, routeId)=>({
                [routeId]: {
                    type: "error",
                    result: error
                }
            }));
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        unstable_runClientMiddleware: unstable_runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $fbd80a69cf576f05$var$callLoaderOrAction({ request: request, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $fbd80a69cf576f05$var$isMutationMethod(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $fbd80a69cf576f05$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $fbd80a69cf576f05$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $fbd80a69cf576f05$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($fbd80a69cf576f05$var$isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $fbd80a69cf576f05$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($fbd80a69cf576f05$var$isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $fbd80a69cf576f05$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data),
                statusCode: $fbd80a69cf576f05$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $fbd80a69cf576f05$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($fbd80a69cf576f05$var$isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $fbd80a69cf576f05$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $fbd80a69cf576f05$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $fbd80a69cf576f05$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $fbd80a69cf576f05$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $fbd80a69cf576f05$var$stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $fbd80a69cf576f05$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($fbd80a69cf576f05$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $fbd80a69cf576f05$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $fbd80a69cf576f05$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $fbd80a69cf576f05$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $fbd80a69cf576f05$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $fbd80a69cf576f05$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $fbd80a69cf576f05$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $fbd80a69cf576f05$export$f5708dca728d7177(!$fbd80a69cf576f05$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($fbd80a69cf576f05$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $fbd80a69cf576f05$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $fbd80a69cf576f05$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $fbd80a69cf576f05$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $fbd80a69cf576f05$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $fbd80a69cf576f05$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $fbd80a69cf576f05$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($fbd80a69cf576f05$var$isErrorResult(result)) {
            let boundaryMatch = $fbd80a69cf576f05$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($fbd80a69cf576f05$var$isRedirectResult(result)) $fbd80a69cf576f05$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $fbd80a69cf576f05$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $fbd80a69cf576f05$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $fbd80a69cf576f05$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $fbd80a69cf576f05$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $fbd80a69cf576f05$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $fbd80a69cf576f05$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $fbd80a69cf576f05$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $fbd80a69cf576f05$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $fbd80a69cf576f05$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $fbd80a69cf576f05$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($fbd80a69cf576f05$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $fbd80a69cf576f05$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $fbd80a69cf576f05$export$8ccf933b0513f8d0(path) : path;
    return $fbd80a69cf576f05$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $fbd80a69cf576f05$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $fbd80a69cf576f05$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $fbd80a69cf576f05$var$isRedirectDataStrategyResult(result) {
    return $fbd80a69cf576f05$var$isResponse(result.result) && $fbd80a69cf576f05$var$redirectStatusCodes.has(result.result.status);
}
function $fbd80a69cf576f05$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $fbd80a69cf576f05$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $fbd80a69cf576f05$var$isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $fbd80a69cf576f05$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $fbd80a69cf576f05$var$isRedirectStatusCode(statusCode) {
    return $fbd80a69cf576f05$var$redirectStatusCodes.has(statusCode);
}
function $fbd80a69cf576f05$var$isRedirectResponse(result) {
    return $fbd80a69cf576f05$var$isResponse(result) && $fbd80a69cf576f05$var$isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function $fbd80a69cf576f05$var$isValidMethod(method) {
    return $fbd80a69cf576f05$var$validRequestMethods.has(method.toUpperCase());
}
function $fbd80a69cf576f05$var$isMutationMethod(method) {
    return $fbd80a69cf576f05$var$validMutationMethods.has(method.toUpperCase());
}
function $fbd80a69cf576f05$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $fbd80a69cf576f05$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $fbd80a69cf576f05$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $fbd80a69cf576f05$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $fbd80a69cf576f05$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $fbd80a69cf576f05$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $fbd80a69cf576f05$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $fbd80a69cf576f05$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $fbd80a69cf576f05$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $fbd80a69cf576f05$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $fbd80a69cf576f05$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $fbd80a69cf576f05$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($fbd80a69cf576f05$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $fbd80a69cf576f05$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($fbd80a69cf576f05$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $fbd80a69cf576f05$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $fbd80a69cf576f05$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $fbd80a69cf576f05$export$2eeee58951ff3c1c = $acw62.createContext(null);
$fbd80a69cf576f05$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $fbd80a69cf576f05$export$315e3ffb01f217 = $acw62.createContext(null);
$fbd80a69cf576f05$export$315e3ffb01f217.displayName = "DataRouterState";
var $fbd80a69cf576f05$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$fbd80a69cf576f05$export$3681f408decb40d1.displayName = "ViewTransition";
var $fbd80a69cf576f05$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$fbd80a69cf576f05$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $fbd80a69cf576f05$var$AwaitContext = $acw62.createContext(null);
$fbd80a69cf576f05$var$AwaitContext.displayName = "Await";
var $fbd80a69cf576f05$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$fbd80a69cf576f05$export$3044ab7fdabeaee6.displayName = "Navigation";
var $fbd80a69cf576f05$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$fbd80a69cf576f05$export$e6a44b110a0c44d3.displayName = "Location";
var $fbd80a69cf576f05$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$fbd80a69cf576f05$export$aac280ed165a4397.displayName = "Route";
var $fbd80a69cf576f05$var$RouteErrorContext = $acw62.createContext(null);
$fbd80a69cf576f05$var$RouteErrorContext.displayName = "RouteError";
var $fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS = true;
function $fbd80a69cf576f05$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $fbd80a69cf576f05$export$f5708dca728d7177($fbd80a69cf576f05$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $fbd80a69cf576f05$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $fbd80a69cf576f05$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $fbd80a69cf576f05$export$9c954a9d03d32f4a() {
    return $acw62.useContext($fbd80a69cf576f05$export$e6a44b110a0c44d3) != null;
}
function $fbd80a69cf576f05$export$45d76561a5302f2b() {
    $fbd80a69cf576f05$export$f5708dca728d7177($fbd80a69cf576f05$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($fbd80a69cf576f05$export$e6a44b110a0c44d3).location;
}
function $fbd80a69cf576f05$export$1b3f31771c5d07c() {
    return $acw62.useContext($fbd80a69cf576f05$export$e6a44b110a0c44d3).navigationType;
}
function $fbd80a69cf576f05$export$6c330e8992e8a295(pattern) {
    $fbd80a69cf576f05$export$f5708dca728d7177($fbd80a69cf576f05$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $fbd80a69cf576f05$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$fbd80a69cf576f05$export$81336c211d5ff295(pattern, $fbd80a69cf576f05$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $fbd80a69cf576f05$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $fbd80a69cf576f05$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $fbd80a69cf576f05$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    return isDataRoute ? $fbd80a69cf576f05$var$useNavigateStable() : $fbd80a69cf576f05$var$useNavigateUnstable();
}
function $fbd80a69cf576f05$var$useNavigateUnstable() {
    $fbd80a69cf576f05$export$f5708dca728d7177($fbd80a69cf576f05$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($fbd80a69cf576f05$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($fbd80a69cf576f05$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $fbd80a69cf576f05$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $fbd80a69cf576f05$var$warning(activeRef.current, $fbd80a69cf576f05$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $fbd80a69cf576f05$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $fbd80a69cf576f05$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $fbd80a69cf576f05$var$OutletContext = $acw62.createContext(null);
function $fbd80a69cf576f05$export$4138103a3ae699cc() {
    return $acw62.useContext($fbd80a69cf576f05$var$OutletContext);
}
function $fbd80a69cf576f05$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $fbd80a69cf576f05$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $fbd80a69cf576f05$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($fbd80a69cf576f05$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$fbd80a69cf576f05$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $fbd80a69cf576f05$export$5d3fca4a98652595(routes, locationArg) {
    return $fbd80a69cf576f05$var$useRoutesImpl(routes, locationArg);
}
function $fbd80a69cf576f05$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $fbd80a69cf576f05$export$f5708dca728d7177($fbd80a69cf576f05$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator, static: isStatic } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        $fbd80a69cf576f05$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $fbd80a69cf576f05$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $fbd80a69cf576f05$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : $fbd80a69cf576f05$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS) {
        $fbd80a69cf576f05$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $fbd80a69cf576f05$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $fbd80a69cf576f05$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $fbd80a69cf576f05$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $fbd80a69cf576f05$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $fbd80a69cf576f05$var$DefaultErrorComponent() {
    let error = $fbd80a69cf576f05$export$ed527bf60f6e05f2();
    let message = $fbd80a69cf576f05$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $fbd80a69cf576f05$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$DefaultErrorComponent, null);
var $fbd80a69cf576f05$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $fbd80a69cf576f05$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($fbd80a69cf576f05$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $fbd80a69cf576f05$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $fbd80a69cf576f05$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $fbd80a69cf576f05$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $fbd80a69cf576f05$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $fbd80a69cf576f05$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $fbd80a69cf576f05$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($fbd80a69cf576f05$export$2eeee58951ff3c1c);
    $fbd80a69cf576f05$export$f5708dca728d7177(ctx, $fbd80a69cf576f05$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $fbd80a69cf576f05$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($fbd80a69cf576f05$export$315e3ffb01f217);
    $fbd80a69cf576f05$export$f5708dca728d7177(state, $fbd80a69cf576f05$var$getDataRouterConsoleError(hookName));
    return state;
}
function $fbd80a69cf576f05$var$useRouteContext(hookName) {
    let route = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    $fbd80a69cf576f05$export$f5708dca728d7177(route, $fbd80a69cf576f05$var$getDataRouterConsoleError(hookName));
    return route;
}
function $fbd80a69cf576f05$var$useCurrentRouteId(hookName) {
    let route = $fbd80a69cf576f05$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $fbd80a69cf576f05$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $fbd80a69cf576f05$var$useRouteId() {
    return $fbd80a69cf576f05$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $fbd80a69cf576f05$export$d0fd4b7106de2769() {
    let state = $fbd80a69cf576f05$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $fbd80a69cf576f05$export$600dc272ed516c15() {
    let dataRouterContext = $fbd80a69cf576f05$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $fbd80a69cf576f05$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $fbd80a69cf576f05$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $fbd80a69cf576f05$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$fbd80a69cf576f05$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $fbd80a69cf576f05$export$1448a5050d252c4d() {
    let state = $fbd80a69cf576f05$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $fbd80a69cf576f05$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $fbd80a69cf576f05$export$fd5d37484eab868d(routeId) {
    let state = $fbd80a69cf576f05$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $fbd80a69cf576f05$export$fdc00f3f26066d5e() {
    let state = $fbd80a69cf576f05$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $fbd80a69cf576f05$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $fbd80a69cf576f05$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($fbd80a69cf576f05$var$RouteErrorContext);
    let state = $fbd80a69cf576f05$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $fbd80a69cf576f05$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $fbd80a69cf576f05$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($fbd80a69cf576f05$var$AwaitContext);
    return value?._data;
}
function $fbd80a69cf576f05$export$17f53340677d5831() {
    let value = $acw62.useContext($fbd80a69cf576f05$var$AwaitContext);
    return value?._error;
}
var $fbd80a69cf576f05$var$blockerId = 0;
function $fbd80a69cf576f05$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $fbd80a69cf576f05$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $fbd80a69cf576f05$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $fbd80a69cf576f05$var$stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $fbd80a69cf576f05$var$stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$fbd80a69cf576f05$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $fbd80a69cf576f05$export$386d57f03f0b2883;
}
function $fbd80a69cf576f05$var$useNavigateStable() {
    let { router: router } = $fbd80a69cf576f05$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $fbd80a69cf576f05$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $fbd80a69cf576f05$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $fbd80a69cf576f05$var$warning(activeRef.current, $fbd80a69cf576f05$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $fbd80a69cf576f05$var$alreadyWarned = {};
function $fbd80a69cf576f05$var$warningOnce(key, cond, message) {
    if (!cond && !$fbd80a69cf576f05$var$alreadyWarned[key]) {
        $fbd80a69cf576f05$var$alreadyWarned[key] = true;
        $fbd80a69cf576f05$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $fbd80a69cf576f05$var$alreadyWarned2 = {};
function $fbd80a69cf576f05$var$warnOnce(condition, message) {
    if (!condition && !$fbd80a69cf576f05$var$alreadyWarned2[message]) {
        $fbd80a69cf576f05$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function $fbd80a69cf576f05$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS) {
            if (route.element) $fbd80a69cf576f05$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS) {
            if (route.hydrateFallbackElement) $fbd80a69cf576f05$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS) {
            if (route.errorElement) $fbd80a69cf576f05$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $fbd80a69cf576f05$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $fbd80a69cf576f05$export$f30f7e456d254e83(routes, opts) {
    return $fbd80a69cf576f05$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $fbd80a69cf576f05$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $fbd80a69cf576f05$export$e2fd2c03906469db,
        mapRouteProperties: $fbd80a69cf576f05$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $fbd80a69cf576f05$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $fbd80a69cf576f05$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $fbd80a69cf576f05$var$warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $fbd80a69cf576f05$var$warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $acw62.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fbd80a69cf576f05$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $acw62.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $fbd80a69cf576f05$var$MemoizedDataRoutes = $acw62.memo($fbd80a69cf576f05$var$DataRoutes);
function $fbd80a69cf576f05$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $fbd80a69cf576f05$var$useRoutesImpl(routes, void 0, state, future);
}
function $fbd80a69cf576f05$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $fbd80a69cf576f05$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $fbd80a69cf576f05$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $fbd80a69cf576f05$export$f5708dca728d7177($fbd80a69cf576f05$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    $fbd80a69cf576f05$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let navigate = $fbd80a69cf576f05$export$9770f232ac06a008();
    let path = $fbd80a69cf576f05$var$resolveTo(to, $fbd80a69cf576f05$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $fbd80a69cf576f05$export$910ae8079b2c2852(props) {
    return $fbd80a69cf576f05$export$a3be3530d8e40d0b(props.context);
}
function $fbd80a69cf576f05$export$e7b0ac011bb776c6(_props) {
    $fbd80a69cf576f05$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $fbd80a69cf576f05$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false }) {
    $fbd80a69cf576f05$export$f5708dca728d7177(!$fbd80a69cf576f05$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $fbd80a69cf576f05$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $fbd80a69cf576f05$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $fbd80a69cf576f05$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $fbd80a69cf576f05$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $fbd80a69cf576f05$export$5d3fca4a98652595($fbd80a69cf576f05$export$16da398f5434bdec(children), location);
}
function $fbd80a69cf576f05$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$ResolveAwait, null, children));
}
var $fbd80a69cf576f05$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $fbd80a69cf576f05$var$ResolveAwait({ children: children }) {
    let data2 = $fbd80a69cf576f05$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $fbd80a69cf576f05$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $fbd80a69cf576f05$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $fbd80a69cf576f05$export$f5708dca728d7177(element.type === $fbd80a69cf576f05$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $fbd80a69cf576f05$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $fbd80a69cf576f05$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $fbd80a69cf576f05$export$9b5b6d122dea0c88 = $fbd80a69cf576f05$export$16da398f5434bdec;
function $fbd80a69cf576f05$export$daf73786167a7f72(matches) {
    return $fbd80a69cf576f05$var$_renderMatches(matches);
}
// lib/dom/dom.ts
var $fbd80a69cf576f05$var$defaultMethod = "get";
var $fbd80a69cf576f05$var$defaultEncType = "application/x-www-form-urlencoded";
function $fbd80a69cf576f05$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fbd80a69cf576f05$var$isButtonElement(object) {
    return $fbd80a69cf576f05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fbd80a69cf576f05$var$isFormElement(object) {
    return $fbd80a69cf576f05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fbd80a69cf576f05$var$isInputElement(object) {
    return $fbd80a69cf576f05$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fbd80a69cf576f05$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fbd80a69cf576f05$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fbd80a69cf576f05$var$isModifiedEvent(event);
}
function $fbd80a69cf576f05$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fbd80a69cf576f05$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $fbd80a69cf576f05$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $fbd80a69cf576f05$var$_formDataSupportsSubmitter = null;
function $fbd80a69cf576f05$var$isFormDataSubmitterSupported() {
    if ($fbd80a69cf576f05$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fbd80a69cf576f05$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fbd80a69cf576f05$var$_formDataSupportsSubmitter = true;
    }
    return $fbd80a69cf576f05$var$_formDataSupportsSubmitter;
}
var $fbd80a69cf576f05$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fbd80a69cf576f05$var$getFormEncType(encType) {
    if (encType != null && !$fbd80a69cf576f05$var$supportedFormEncTypes.has(encType)) {
        $fbd80a69cf576f05$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$fbd80a69cf576f05$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $fbd80a69cf576f05$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($fbd80a69cf576f05$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $fbd80a69cf576f05$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || $fbd80a69cf576f05$var$defaultMethod;
        encType = $fbd80a69cf576f05$var$getFormEncType(target.getAttribute("enctype")) || $fbd80a69cf576f05$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fbd80a69cf576f05$var$isButtonElement(target) || $fbd80a69cf576f05$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $fbd80a69cf576f05$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fbd80a69cf576f05$var$defaultMethod;
        encType = $fbd80a69cf576f05$var$getFormEncType(target.getAttribute("formenctype")) || $fbd80a69cf576f05$var$getFormEncType(form.getAttribute("enctype")) || $fbd80a69cf576f05$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$fbd80a69cf576f05$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fbd80a69cf576f05$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $fbd80a69cf576f05$var$defaultMethod;
        action = null;
        encType = $fbd80a69cf576f05$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function $fbd80a69cf576f05$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function $fbd80a69cf576f05$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $fbd80a69cf576f05$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $fbd80a69cf576f05$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href2)=>({
                    rel: "stylesheet",
                    href: href2
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $fbd80a69cf576f05$var$getModuleLinkHrefs(matches, manifest);
    return $fbd80a69cf576f05$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $fbd80a69cf576f05$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href2)=>({
            rel: "stylesheet",
            href: href2
        }));
}
async function $fbd80a69cf576f05$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $fbd80a69cf576f05$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($fbd80a69cf576f05$var$prefetchStyleLink));
}
async function $fbd80a69cf576f05$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$fbd80a69cf576f05$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$fbd80a69cf576f05$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$fbd80a69cf576f05$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($fbd80a69cf576f05$var$prefetchStyleLink));
}
async function $fbd80a69cf576f05$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $fbd80a69cf576f05$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $fbd80a69cf576f05$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $fbd80a69cf576f05$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $fbd80a69cf576f05$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $fbd80a69cf576f05$var$dedupeLinkDescriptors(links.flat(1).filter($fbd80a69cf576f05$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $fbd80a69cf576f05$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $fbd80a69cf576f05$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $fbd80a69cf576f05$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $fbd80a69cf576f05$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $fbd80a69cf576f05$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $fbd80a69cf576f05$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$fbd80a69cf576f05$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($fbd80a69cf576f05$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $fbd80a69cf576f05$var$_isPreloadSupported;
function $fbd80a69cf576f05$var$isPreloadSupported() {
    if ($fbd80a69cf576f05$var$_isPreloadSupported !== void 0) return $fbd80a69cf576f05$var$_isPreloadSupported;
    let el = document.createElement("link");
    $fbd80a69cf576f05$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $fbd80a69cf576f05$var$_isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var $fbd80a69cf576f05$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $fbd80a69cf576f05$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $fbd80a69cf576f05$var$escapeHtml(html) {
    return html.replace($fbd80a69cf576f05$var$ESCAPE_REGEX, (match)=>$fbd80a69cf576f05$var$ESCAPE_LOOKUP[match]);
}
function $fbd80a69cf576f05$var$createHtml(html) {
    return {
        __html: html
    };
}
// vendor/turbo-stream-v2/utils.ts
var $fbd80a69cf576f05$var$HOLE = -1;
var $fbd80a69cf576f05$var$NAN = -2;
var $fbd80a69cf576f05$var$NEGATIVE_INFINITY = -3;
var $fbd80a69cf576f05$var$NEGATIVE_ZERO = -4;
var $fbd80a69cf576f05$var$NULL = -5;
var $fbd80a69cf576f05$var$POSITIVE_INFINITY = -6;
var $fbd80a69cf576f05$var$UNDEFINED = -7;
var $fbd80a69cf576f05$var$TYPE_BIGINT = "B";
var $fbd80a69cf576f05$var$TYPE_DATE = "D";
var $fbd80a69cf576f05$var$TYPE_ERROR = "E";
var $fbd80a69cf576f05$var$TYPE_MAP = "M";
var $fbd80a69cf576f05$var$TYPE_NULL_OBJECT = "N";
var $fbd80a69cf576f05$var$TYPE_PROMISE = "P";
var $fbd80a69cf576f05$var$TYPE_REGEXP = "R";
var $fbd80a69cf576f05$var$TYPE_SET = "S";
var $fbd80a69cf576f05$var$TYPE_SYMBOL = "Y";
var $fbd80a69cf576f05$var$TYPE_URL = "U";
var $fbd80a69cf576f05$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $fbd80a69cf576f05$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $fbd80a69cf576f05$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $fbd80a69cf576f05$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $fbd80a69cf576f05$var$UNDEFINED;
    if (input === null) return $fbd80a69cf576f05$var$NULL;
    if (Number.isNaN(input)) return $fbd80a69cf576f05$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $fbd80a69cf576f05$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $fbd80a69cf576f05$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $fbd80a69cf576f05$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $fbd80a69cf576f05$var$stringify.call(this, input, index);
    return index;
}
function $fbd80a69cf576f05$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$fbd80a69cf576f05$var$flatten.call(this, k)}":${$fbd80a69cf576f05$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$fbd80a69cf576f05$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$fbd80a69cf576f05$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$fbd80a69cf576f05$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$fbd80a69cf576f05$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $fbd80a69cf576f05$var$flatten.call(this, input2[i]) : $fbd80a69cf576f05$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) str[index2] = `["${$fbd80a69cf576f05$var$TYPE_DATE}",${input2.getTime()}]`;
                        else if (input2 instanceof URL) str[index2] = `["${$fbd80a69cf576f05$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$fbd80a69cf576f05$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$fbd80a69cf576f05$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$fbd80a69cf576f05$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$fbd80a69cf576f05$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$fbd80a69cf576f05$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $fbd80a69cf576f05$var$flatten.call(this, k),
                                    $fbd80a69cf576f05$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$fbd80a69cf576f05$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$fbd80a69cf576f05$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$fbd80a69cf576f05$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$fbd80a69cf576f05$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($fbd80a69cf576f05$var$isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$fbd80a69cf576f05$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$fbd80a69cf576f05$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $fbd80a69cf576f05$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $fbd80a69cf576f05$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $fbd80a69cf576f05$var$objectProtoNames;
}
// vendor/turbo-stream-v2/unflatten.ts
var $fbd80a69cf576f05$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $fbd80a69cf576f05$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $fbd80a69cf576f05$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $fbd80a69cf576f05$var$hydrate.call(this, startIndex);
}
function $fbd80a69cf576f05$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $fbd80a69cf576f05$var$UNDEFINED:
                set(void 0);
                continue;
            case $fbd80a69cf576f05$var$NULL:
                set(null);
                continue;
            case $fbd80a69cf576f05$var$NAN:
                set(NaN);
                continue;
            case $fbd80a69cf576f05$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $fbd80a69cf576f05$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $fbd80a69cf576f05$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $fbd80a69cf576f05$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $fbd80a69cf576f05$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $fbd80a69cf576f05$var$globalObj && $fbd80a69cf576f05$var$globalObj[errorType] ? new $fbd80a69cf576f05$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $fbd80a69cf576f05$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $fbd80a69cf576f05$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $fbd80a69cf576f05$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $fbd80a69cf576f05$var$Deferred2();
    const reader = readable.pipeThrough($fbd80a69cf576f05$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $fbd80a69cf576f05$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $fbd80a69cf576f05$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $fbd80a69cf576f05$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $fbd80a69cf576f05$var$unflatten.call(this, line)
    };
}
async function $fbd80a69cf576f05$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $fbd80a69cf576f05$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $fbd80a69cf576f05$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $fbd80a69cf576f05$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $fbd80a69cf576f05$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $fbd80a69cf576f05$var$encode(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder2 = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $fbd80a69cf576f05$var$flatten.call(encoder2, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder2.stringified.join(",")}]
`));
                lastSentIndex = encoder2.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder2.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder2.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder2.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder2.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $fbd80a69cf576f05$var$flatten.call(encoder2, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$fbd80a69cf576f05$var$TYPE_PROMISE}${deferredId}:[["${$fbd80a69cf576f05$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder2.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$fbd80a69cf576f05$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder2.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$fbd80a69cf576f05$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder2.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $fbd80a69cf576f05$var$flatten.call(encoder2, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$fbd80a69cf576f05$var$TYPE_ERROR}${deferredId}:[["${$fbd80a69cf576f05$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder2.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$fbd80a69cf576f05$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder2.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$fbd80a69cf576f05$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder2.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder2.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder2.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder2.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $fbd80a69cf576f05$var$createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var $fbd80a69cf576f05$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $fbd80a69cf576f05$var$SingleFetchNoResultError = class extends Error {
};
var $fbd80a69cf576f05$var$SINGLE_FETCH_REDIRECT_STATUS = 202;
var $fbd80a69cf576f05$var$NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $fbd80a69cf576f05$var$StreamTransfer({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$fbd80a69cf576f05$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $fbd80a69cf576f05$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $fbd80a69cf576f05$var$getSingleFetchDataStrategyImpl(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $fbd80a69cf576f05$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $fbd80a69cf576f05$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.unstable_runClientMiddleware(dataStrategy);
}
function $fbd80a69cf576f05$var$getSingleFetchDataStrategyImpl(getRouter, getRouteInfo, fetchAndDecode, ssr, basename) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $fbd80a69cf576f05$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $fbd80a69cf576f05$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $fbd80a69cf576f05$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $fbd80a69cf576f05$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename);
    };
}
async function $fbd80a69cf576f05$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $fbd80a69cf576f05$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $fbd80a69cf576f05$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($fbd80a69cf576f05$var$isResponse(result.result) || $fbd80a69cf576f05$export$972111febbeef05b(result.result) || $fbd80a69cf576f05$var$isDataWithResponseInit(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $fbd80a69cf576f05$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $fbd80a69cf576f05$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $fbd80a69cf576f05$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $fbd80a69cf576f05$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$fbd80a69cf576f05$var$createDeferred2());
    let singleFetchDfd = $fbd80a69cf576f05$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $fbd80a69cf576f05$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $fbd80a69cf576f05$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $fbd80a69cf576f05$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $fbd80a69cf576f05$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $fbd80a69cf576f05$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $fbd80a69cf576f05$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $fbd80a69cf576f05$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $fbd80a69cf576f05$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $fbd80a69cf576f05$var$stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $fbd80a69cf576f05$var$singleFetchUrl(reqUrl, basename) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else if (basename && $fbd80a69cf576f05$var$stripBasename(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.data`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function $fbd80a69cf576f05$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $fbd80a69cf576f05$var$singleFetchUrl(request.url, basename);
    if (request.method === "GET") {
        url = $fbd80a69cf576f05$var$stripIndexParam(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $fbd80a69cf576f05$var$createRequestInit(request));
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $fbd80a69cf576f05$export$f2680fa305b734ca(404, "Not Found", true);
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $fbd80a69cf576f05$var$SINGLE_FETCH_REDIRECT_STATUS,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($fbd80a69cf576f05$var$NO_BODY_STATUS_CODES.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $fbd80a69cf576f05$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $fbd80a69cf576f05$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($fbd80a69cf576f05$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$fbd80a69cf576f05$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $fbd80a69cf576f05$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $fbd80a69cf576f05$export$4023ad4ecd4126a2(body, global2) {
    return $fbd80a69cf576f05$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $fbd80a69cf576f05$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$fbd80a69cf576f05$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $fbd80a69cf576f05$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $fbd80a69cf576f05$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $fbd80a69cf576f05$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $fbd80a69cf576f05$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $fbd80a69cf576f05$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $fbd80a69cf576f05$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($fbd80a69cf576f05$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $fbd80a69cf576f05$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $fbd80a69cf576f05$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$ff0bf87698939488, null) : null)));
}
function $fbd80a69cf576f05$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $fbd80a69cf576f05$var$ENABLE_DEV_WARNINGS ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $fbd80a69cf576f05$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $fbd80a69cf576f05$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $fbd80a69cf576f05$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $fbd80a69cf576f05$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$RemixRootDefaultErrorBoundary, {
            error: $fbd80a69cf576f05$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $fbd80a69cf576f05$var$createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $fbd80a69cf576f05$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $fbd80a69cf576f05$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$fbd80a69cf576f05$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $fbd80a69cf576f05$var$createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $fbd80a69cf576f05$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $fbd80a69cf576f05$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $fbd80a69cf576f05$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $fbd80a69cf576f05$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $fbd80a69cf576f05$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $fbd80a69cf576f05$var$noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $fbd80a69cf576f05$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $fbd80a69cf576f05$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $fbd80a69cf576f05$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $fbd80a69cf576f05$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $fbd80a69cf576f05$var$noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $fbd80a69cf576f05$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$fbd80a69cf576f05$var$getRouteComponents(route, routeModule, isSpaMode),
                unstable_middleware: routeModule.unstable_clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $fbd80a69cf576f05$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $fbd80a69cf576f05$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            async serverLoader () {
                                $fbd80a69cf576f05$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $fbd80a69cf576f05$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $fbd80a69cf576f05$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $fbd80a69cf576f05$var$noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        async serverAction () {
                            $fbd80a69cf576f05$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $fbd80a69cf576f05$var$noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $fbd80a69cf576f05$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $fbd80a69cf576f05$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $fbd80a69cf576f05$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $fbd80a69cf576f05$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $fbd80a69cf576f05$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                unstable_middleware: route.hasClientMiddleware ? async ()=>{
                    let { unstable_clientMiddleware: unstable_clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $fbd80a69cf576f05$var$invariant2(unstable_clientMiddleware, "No `unstable_clientMiddleware` export found");
                    return unstable_clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $fbd80a69cf576f05$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $fbd80a69cf576f05$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $fbd80a69cf576f05$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $fbd80a69cf576f05$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $fbd80a69cf576f05$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $fbd80a69cf576f05$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $fbd80a69cf576f05$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $fbd80a69cf576f05$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $fbd80a69cf576f05$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $fbd80a69cf576f05$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $fbd80a69cf576f05$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        unstable_clientMiddleware: routeModule.unstable_clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $fbd80a69cf576f05$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $fbd80a69cf576f05$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $fbd80a69cf576f05$var$nextPaths = /* @__PURE__ */ new Set();
var $fbd80a69cf576f05$var$discoveredPathsMaxSize = 1e3;
var $fbd80a69cf576f05$var$discoveredPaths = /* @__PURE__ */ new Set();
var $fbd80a69cf576f05$var$URL_LIMIT = 7680;
function $fbd80a69cf576f05$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $fbd80a69cf576f05$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $fbd80a69cf576f05$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $fbd80a69cf576f05$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$fbd80a69cf576f05$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($fbd80a69cf576f05$var$discoveredPaths.has(path)) return;
        await $fbd80a69cf576f05$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $fbd80a69cf576f05$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$fbd80a69cf576f05$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$fbd80a69cf576f05$var$discoveredPaths.has(pathname)) $fbd80a69cf576f05$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($fbd80a69cf576f05$var$nextPaths.keys()).filter((path)=>{
                if ($fbd80a69cf576f05$var$discoveredPaths.has(path)) {
                    $fbd80a69cf576f05$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $fbd80a69cf576f05$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $fbd80a69cf576f05$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $fbd80a69cf576f05$var$getManifestPath(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $fbd80a69cf576f05$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $fbd80a69cf576f05$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    let url = new URL($fbd80a69cf576f05$var$getManifestPath(manifestPath, basename), window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $fbd80a69cf576f05$var$URL_LIMIT) {
        $fbd80a69cf576f05$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            if (sessionStorage.getItem($fbd80a69cf576f05$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                console.error("Unable to discover routes due to manifest version mismatch.");
                return;
            }
            sessionStorage.setItem($fbd80a69cf576f05$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        sessionStorage.removeItem($fbd80a69cf576f05$var$MANIFEST_VERSION_STORAGE_KEY);
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$fbd80a69cf576f05$var$addToFifoQueue(p, $fbd80a69cf576f05$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $fbd80a69cf576f05$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $fbd80a69cf576f05$var$addToFifoQueue(path, queue) {
    if (queue.size >= $fbd80a69cf576f05$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $fbd80a69cf576f05$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $fbd80a69cf576f05$var$useDataRouterContext2() {
    let context = $acw62.useContext($fbd80a69cf576f05$export$2eeee58951ff3c1c);
    $fbd80a69cf576f05$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $fbd80a69cf576f05$var$useDataRouterStateContext() {
    let context = $acw62.useContext($fbd80a69cf576f05$export$315e3ffb01f217);
    $fbd80a69cf576f05$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $fbd80a69cf576f05$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$fbd80a69cf576f05$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $fbd80a69cf576f05$var$useFrameworkContext() {
    let context = $acw62.useContext($fbd80a69cf576f05$export$208d6a3bc3aa62bd);
    $fbd80a69cf576f05$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $fbd80a69cf576f05$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($fbd80a69cf576f05$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $fbd80a69cf576f05$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $fbd80a69cf576f05$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $fbd80a69cf576f05$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $fbd80a69cf576f05$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $fbd80a69cf576f05$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $fbd80a69cf576f05$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $fbd80a69cf576f05$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$fbd80a69cf576f05$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function $fbd80a69cf576f05$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $fbd80a69cf576f05$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $fbd80a69cf576f05$var$useDataRouterStateContext();
    let matches = $fbd80a69cf576f05$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$fbd80a69cf576f05$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "stylesheet",
        href: criticalCss.href
    }) : null, keyedLinks.map(({ key: key, link: link })=>$fbd80a69cf576f05$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $fbd80a69cf576f05$export$60dcec93e67386bd({ page: page, ...dataLinkProps }) {
    let { router: router } = $fbd80a69cf576f05$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$fbd80a69cf576f05$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...dataLinkProps
    });
}
function $fbd80a69cf576f05$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $fbd80a69cf576f05$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $fbd80a69cf576f05$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $fbd80a69cf576f05$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $fbd80a69cf576f05$var$useFrameworkContext();
    let { basename: basename } = $fbd80a69cf576f05$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $fbd80a69cf576f05$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$fbd80a69cf576f05$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$fbd80a69cf576f05$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $fbd80a69cf576f05$var$singleFetchUrl(page, basename);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$fbd80a69cf576f05$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $fbd80a69cf576f05$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href2)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href2,
            rel: "prefetch",
            as: "fetch",
            href: href2,
            ...linkProps
        })), moduleHrefs.map((href2)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href2,
            rel: "modulepreload",
            href: href2,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $fbd80a69cf576f05$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $fbd80a69cf576f05$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $fbd80a69cf576f05$var$useDataRouterStateContext();
    let location = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let _matches = $fbd80a69cf576f05$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$fbd80a69cf576f05$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $fbd80a69cf576f05$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $fbd80a69cf576f05$var$isHydrated = false;
function $fbd80a69cf576f05$export$ff0bf87698939488(props) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $fbd80a69cf576f05$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $fbd80a69cf576f05$var$useDataRouterContext2();
    let { matches: routerMatches } = $fbd80a69cf576f05$var$useDataRouterStateContext();
    let enableFogOfWar = $fbd80a69cf576f05$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $fbd80a69cf576f05$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $fbd80a69cf576f05$var$isHydrated = true;
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $fbd80a69cf576f05$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($fbd80a69cf576f05$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $fbd80a69cf576f05$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $fbd80a69cf576f05$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $fbd80a69cf576f05$var$isHydrated ? [] : $fbd80a69cf576f05$var$dedupe(manifest.entry.imports.concat($fbd80a69cf576f05$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    return $fbd80a69cf576f05$var$isHydrated ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $fbd80a69cf576f05$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $fbd80a69cf576f05$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var $fbd80a69cf576f05$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($fbd80a69cf576f05$var$isBrowser) window.__reactRouterVersion = "7.6.0";
} catch (e) {}
function $fbd80a69cf576f05$export$1f3f55432a00e06d(routes, opts) {
    return $fbd80a69cf576f05$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $fbd80a69cf576f05$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $fbd80a69cf576f05$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $fbd80a69cf576f05$export$9269a41d8c4635e,
        hydrationRouteProperties: $fbd80a69cf576f05$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $fbd80a69cf576f05$export$1ba7ed8a3a7b3765(routes, opts) {
    return $fbd80a69cf576f05$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $fbd80a69cf576f05$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $fbd80a69cf576f05$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $fbd80a69cf576f05$export$9269a41d8c4635e,
        hydrationRouteProperties: $fbd80a69cf576f05$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $fbd80a69cf576f05$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $fbd80a69cf576f05$var$deserializeErrors(state.errors)
    };
    return state;
}
function $fbd80a69cf576f05$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $fbd80a69cf576f05$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $fbd80a69cf576f05$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $fbd80a69cf576f05$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $fbd80a69cf576f05$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $fbd80a69cf576f05$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $fbd80a69cf576f05$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$fbd80a69cf576f05$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $fbd80a69cf576f05$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($fbd80a69cf576f05$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $fbd80a69cf576f05$var$stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $fbd80a69cf576f05$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href2 = $fbd80a69cf576f05$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $fbd80a69cf576f05$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $fbd80a69cf576f05$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href2,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $fbd80a69cf576f05$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$60dcec93e67386bd, {
        page: href2
    })) : link;
});
$fbd80a69cf576f05$export$a6c7ac8248d6e38a.displayName = "Link";
var $fbd80a69cf576f05$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $fbd80a69cf576f05$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($fbd80a69cf576f05$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fbd80a69cf576f05$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $fbd80a69cf576f05$var$stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$fbd80a69cf576f05$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $fbd80a69cf576f05$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $fbd80a69cf576f05$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $fbd80a69cf576f05$export$47c85c6e3a081d3();
    let formAction = $fbd80a69cf576f05$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$fbd80a69cf576f05$export$a7fed597f4b8afd8.displayName = "Form";
function $fbd80a69cf576f05$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($fbd80a69cf576f05$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let location = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let matches = $fbd80a69cf576f05$export$2378eb7f5ff86053();
    $fbd80a69cf576f05$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $fbd80a69cf576f05$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $fbd80a69cf576f05$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$fbd80a69cf576f05$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $fbd80a69cf576f05$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $fbd80a69cf576f05$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($fbd80a69cf576f05$export$2eeee58951ff3c1c);
    $fbd80a69cf576f05$export$f5708dca728d7177(ctx, $fbd80a69cf576f05$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $fbd80a69cf576f05$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($fbd80a69cf576f05$export$315e3ffb01f217);
    $fbd80a69cf576f05$export$f5708dca728d7177(state, $fbd80a69cf576f05$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $fbd80a69cf576f05$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $fbd80a69cf576f05$export$9770f232ac06a008();
    let location = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let path = $fbd80a69cf576f05$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($fbd80a69cf576f05$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $fbd80a69cf576f05$export$fe53371bee54353d(location) === $fbd80a69cf576f05$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $fbd80a69cf576f05$export$f1a78c17382fe22a(defaultInit) {
    $fbd80a69cf576f05$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($fbd80a69cf576f05$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fbd80a69cf576f05$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $fbd80a69cf576f05$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $fbd80a69cf576f05$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $fbd80a69cf576f05$var$fetcherId = 0;
var $fbd80a69cf576f05$var$getUniqueFetcherId = ()=>`__${String(++$fbd80a69cf576f05$var$fetcherId)}__`;
function $fbd80a69cf576f05$export$47c85c6e3a081d3() {
    let { router: router } = $fbd80a69cf576f05$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let currentRouteId = $fbd80a69cf576f05$var$useRouteId();
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $fbd80a69cf576f05$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $fbd80a69cf576f05$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $fbd80a69cf576f05$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    $fbd80a69cf576f05$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$fbd80a69cf576f05$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $fbd80a69cf576f05$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $fbd80a69cf576f05$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $fbd80a69cf576f05$export$fe53371bee54353d(path);
}
function $fbd80a69cf576f05$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $fbd80a69cf576f05$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $fbd80a69cf576f05$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($fbd80a69cf576f05$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($fbd80a69cf576f05$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $fbd80a69cf576f05$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $fbd80a69cf576f05$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $fbd80a69cf576f05$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href2, opts)=>{
        $fbd80a69cf576f05$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href2, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $fbd80a69cf576f05$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $fbd80a69cf576f05$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $fbd80a69cf576f05$export$fa996778a3a31087() {
    let state = $fbd80a69cf576f05$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $fbd80a69cf576f05$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fbd80a69cf576f05$var$savedScrollPositions = {};
function $fbd80a69cf576f05$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $fbd80a69cf576f05$var$stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $fbd80a69cf576f05$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $fbd80a69cf576f05$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $fbd80a69cf576f05$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($fbd80a69cf576f05$export$3044ab7fdabeaee6);
    let location = $fbd80a69cf576f05$export$45d76561a5302f2b();
    let matches = $fbd80a69cf576f05$export$2378eb7f5ff86053();
    let navigation = $fbd80a69cf576f05$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $fbd80a69cf576f05$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $fbd80a69cf576f05$var$getScrollRestorationKey(location, matches, basename, getKey);
            $fbd80a69cf576f05$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fbd80a69cf576f05$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fbd80a69cf576f05$var$savedScrollPositions));
        } catch (error) {
            $fbd80a69cf576f05$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $fbd80a69cf576f05$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fbd80a69cf576f05$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($fbd80a69cf576f05$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$fbd80a69cf576f05$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $fbd80a69cf576f05$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $fbd80a69cf576f05$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $fbd80a69cf576f05$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $fbd80a69cf576f05$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $fbd80a69cf576f05$export$e262bd1977bea848(to, opts = {}) {
    let vtContext = $acw62.useContext($fbd80a69cf576f05$export$3681f408decb40d1);
    $fbd80a69cf576f05$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $fbd80a69cf576f05$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $fbd80a69cf576f05$export$e75d2a2d1b3c245b(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $fbd80a69cf576f05$var$stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $fbd80a69cf576f05$var$stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $fbd80a69cf576f05$export$81336c211d5ff295(path.pathname, nextPath) != null || $fbd80a69cf576f05$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $fbd80a69cf576f05$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $fbd80a69cf576f05$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $fbd80a69cf576f05$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $fbd80a69cf576f05$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $fbd80a69cf576f05$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $fbd80a69cf576f05$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $fbd80a69cf576f05$var$serializeErrors(context.errors)
        };
        let json = $fbd80a69cf576f05$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $fbd80a69cf576f05$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $fbd80a69cf576f05$var$useRoutesImpl(routes, void 0, state, future);
}
function $fbd80a69cf576f05$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($fbd80a69cf576f05$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $fbd80a69cf576f05$var$getStatelessNavigator() {
    return {
        createHref: $fbd80a69cf576f05$var$createHref,
        encodeLocation: $fbd80a69cf576f05$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $fbd80a69cf576f05$export$3336b097a6fbc59a(routes, opts) {
    return $fbd80a69cf576f05$var$createStaticHandler(routes, {
        ...opts,
        mapRouteProperties: $fbd80a69cf576f05$export$9269a41d8c4635e
    });
}
function $fbd80a69cf576f05$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $fbd80a69cf576f05$var$convertRoutesToDataRoutes(routes, $fbd80a69cf576f05$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                unstable_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $fbd80a69cf576f05$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $fbd80a69cf576f05$var$createHref,
        encodeLocation: $fbd80a69cf576f05$var$encodeLocation,
        getFetcher () {
            return $fbd80a69cf576f05$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $fbd80a69cf576f05$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $fbd80a69cf576f05$var$createHref(to) {
    return typeof to === "string" ? to : $fbd80a69cf576f05$export$fe53371bee54353d(to);
}
function $fbd80a69cf576f05$var$encodeLocation(to) {
    let href2 = typeof to === "string" ? to : $fbd80a69cf576f05$export$fe53371bee54353d(to);
    href2 = href2.replace(/ $/, "%20");
    let encoded = $fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX3.test(href2) ? new URL(href2) : new URL(href2, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $fbd80a69cf576f05$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $fbd80a69cf576f05$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $fbd80a69cf576f05$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $fbd80a69cf576f05$var$htmlEscape(str) {
    return str.replace($fbd80a69cf576f05$var$ESCAPE_REGEX2, (match)=>$fbd80a69cf576f05$var$ESCAPE_LOOKUP2[match]);
}
function $fbd80a69cf576f05$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = $fbd80a69cf576f05$var$createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && $fbd80a69cf576f05$export$6ac68922d4e92125(routeId, route.clientLoader, manifestRoute.hasLoader, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = $fbd80a69cf576f05$export$3dd6171c30258b6f(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$208d6a3bc3aa62bd.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            routeDiscovery: context.routeDiscovery,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$32e57f52df4b6e34, {
        location: router.state.location
    }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$3d80f15952491985, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$var$StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $fbd80a69cf576f05$export$bea31554c7dfd2ad(routes, unstable_getContext) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $acw62.useRef();
        let remixContextRef = $acw62.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {
                    unstable_subResourceIntegrity: future?.unstable_subResourceIntegrity === true,
                    unstable_middleware: future?.unstable_middleware === true
                },
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false,
                routeDiscovery: {
                    mode: "lazy",
                    manifestPath: "/__manifest"
                }
            };
            let patched = $fbd80a69cf576f05$var$processRoutes(// @ts-expect-error `StubRouteObject` is stricter about `loader`/`action`
            // types compared to `AgnosticRouteObject`
            $fbd80a69cf576f05$var$convertRoutesToDataRoutes(routes, (r)=>r), remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = $fbd80a69cf576f05$export$f30f7e456d254e83(patched, {
                unstable_getContext: unstable_getContext,
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$208d6a3bc3aa62bd.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $acw62.createElement($fbd80a69cf576f05$export$323e4fc2fa4753fb, {
            router: routerRef.current
        }));
    };
}
function $fbd80a69cf576f05$var$withComponentProps(Component4) {
    return function Wrapped() {
        return $acw62.createElement(Component4, {
            params: $fbd80a69cf576f05$export$99eaa27ddbbb95ef(),
            loaderData: $fbd80a69cf576f05$export$1448a5050d252c4d(),
            actionData: $fbd80a69cf576f05$export$fdc00f3f26066d5e(),
            matches: $fbd80a69cf576f05$export$2378eb7f5ff86053()
        });
    };
}
function $fbd80a69cf576f05$var$withHydrateFallbackProps(HydrateFallback) {
    return function Wrapped() {
        const props = {
            params: $fbd80a69cf576f05$export$99eaa27ddbbb95ef(),
            loaderData: $fbd80a69cf576f05$export$1448a5050d252c4d(),
            actionData: $fbd80a69cf576f05$export$fdc00f3f26066d5e()
        };
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $fbd80a69cf576f05$var$withErrorBoundaryProps(ErrorBoundary) {
    return function Wrapped() {
        const props = {
            params: $fbd80a69cf576f05$export$99eaa27ddbbb95ef(),
            loaderData: $fbd80a69cf576f05$export$1448a5050d252c4d(),
            actionData: $fbd80a69cf576f05$export$fdc00f3f26066d5e(),
            error: $fbd80a69cf576f05$export$ed527bf60f6e05f2()
        };
        return $acw62.createElement(ErrorBoundary, props);
    };
}
function $fbd80a69cf576f05$var$processRoutes(routes, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component ? $fbd80a69cf576f05$var$withComponentProps(route.Component) : void 0,
            HydrateFallback: route.HydrateFallback ? $fbd80a69cf576f05$var$withHydrateFallbackProps(route.HydrateFallback) : void 0,
            ErrorBoundary: route.ErrorBoundary ? $fbd80a69cf576f05$var$withErrorBoundaryProps(route.ErrorBoundary) : void 0,
            action: route.action,
            loader: route.loader,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should be stubbing loader/action/middleware,
            // not trying to re-implement the full loader/clientLoader/SSR/hydration
            // flow. That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasClientMiddleware: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            clientMiddlewareModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: newRoute.Component || $fbd80a69cf576f05$export$910ae8079b2c2852,
            ErrorBoundary: newRoute.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $fbd80a69cf576f05$var$processRoutes(route.children, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $fbd80a69cf576f05$var$encoder = /* @__PURE__ */ new TextEncoder();
var $fbd80a69cf576f05$var$sign = async (value, secret)=>{
    let data2 = $fbd80a69cf576f05$var$encoder.encode(value);
    let key = await $fbd80a69cf576f05$var$createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $fbd80a69cf576f05$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $fbd80a69cf576f05$var$encoder.encode(value);
    let key = await $fbd80a69cf576f05$var$createKey2(secret, [
        "verify"
    ]);
    let signature = $fbd80a69cf576f05$var$byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var $fbd80a69cf576f05$var$createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", $fbd80a69cf576f05$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $fbd80a69cf576f05$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $fbd80a69cf576f05$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $fbd80a69cf576f05$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $9fd38747d73cb940$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $fbd80a69cf576f05$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $9fd38747d73cb940$exports.serialize)(name, value === "" ? "" : await $fbd80a69cf576f05$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $fbd80a69cf576f05$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $fbd80a69cf576f05$var$encodeCookieValue(value, secrets) {
    let encoded = $fbd80a69cf576f05$var$encodeData(value);
    if (secrets.length > 0) encoded = await $fbd80a69cf576f05$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $fbd80a69cf576f05$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $fbd80a69cf576f05$var$unsign(value, secret);
            if (unsignedValue !== false) return $fbd80a69cf576f05$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $fbd80a69cf576f05$var$decodeData(value);
}
function $fbd80a69cf576f05$var$encodeData(value) {
    return btoa($fbd80a69cf576f05$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $fbd80a69cf576f05$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($fbd80a69cf576f05$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $fbd80a69cf576f05$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $fbd80a69cf576f05$var$hex(code, 2);
            else result += "%u" + $fbd80a69cf576f05$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $fbd80a69cf576f05$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $fbd80a69cf576f05$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $fbd80a69cf576f05$var$warnOnceAboutExpiresCookie(name, expires) {
    $fbd80a69cf576f05$var$warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $fbd80a69cf576f05$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var $fbd80a69cf576f05$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($fbd80a69cf576f05$export$e7973f87fd96e4f2 || {});
function $fbd80a69cf576f05$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $fbd80a69cf576f05$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $fbd80a69cf576f05$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $fbd80a69cf576f05$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $fbd80a69cf576f05$var$serializeError(error, serverMode) {
    let sanitized = $fbd80a69cf576f05$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $fbd80a69cf576f05$var$serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($fbd80a69cf576f05$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $fbd80a69cf576f05$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $fbd80a69cf576f05$var$matchServerRoutes(routes, pathname, basename) {
    let matches = $fbd80a69cf576f05$export$2708184779ceb39d(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $fbd80a69cf576f05$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $fbd80a69cf576f05$var$stripRoutesParam($fbd80a69cf576f05$var$stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if ($fbd80a69cf576f05$var$isDataWithResponseInit(result) && result.init && result.init.status && $fbd80a69cf576f05$var$isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $fbd80a69cf576f05$var$stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $fbd80a69cf576f05$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $fbd80a69cf576f05$var$invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/dev.ts
var $fbd80a69cf576f05$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $fbd80a69cf576f05$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$fbd80a69cf576f05$var$globalDevServerHooksKey] = devServerHooks;
}
function $fbd80a69cf576f05$var$getDevServerHooks() {
    return globalThis[$fbd80a69cf576f05$var$globalDevServerHooksKey];
}
function $fbd80a69cf576f05$var$getBuildTimeHeader(request, headerName) {
    var e;
    return null;
}
// lib/server-runtime/routes.ts
function $fbd80a69cf576f05$var$groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $fbd80a69cf576f05$var$createRoutes(manifest, parentId = "", routesByParentId = $fbd80a69cf576f05$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $fbd80a69cf576f05$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $fbd80a69cf576f05$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $fbd80a69cf576f05$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            unstable_middleware: route.module.unstable_middleware,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                let preRenderedData = $fbd80a69cf576f05$var$getBuildTimeHeader(args.request, "X-React-Router-Prerender-Data");
                if (preRenderedData != null) {
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $fbd80a69cf576f05$var$invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await $fbd80a69cf576f05$export$4023ad4ecd4126a2(stream, $parcel$global);
                    let data2 = decoded.value;
                    if (data2 && $fbd80a69cf576f05$export$60644022b8b46aaa in data2) {
                        let result = data2[$fbd80a69cf576f05$export$60644022b8b46aaa];
                        let init = {
                            status: result.status
                        };
                        if (result.reload) throw $fbd80a69cf576f05$export$a6cd19cd1951a23c(result.redirect, init);
                        else if (result.replace) throw $fbd80a69cf576f05$export$77ad94ebf1c2b9ed(result.redirect, init);
                        else throw $fbd80a69cf576f05$export$89e12c5b50f7529d(result.redirect, init);
                    } else {
                        $fbd80a69cf576f05$var$invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                        let result = data2[route.id];
                        $fbd80a69cf576f05$var$invariant3("data" in result, "Unable to process prerendered data");
                        return result.data;
                    }
                }
                let val = await $fbd80a69cf576f05$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$fbd80a69cf576f05$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $fbd80a69cf576f05$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var $fbd80a69cf576f05$var$ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $fbd80a69cf576f05$var$ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function $fbd80a69cf576f05$var$escapeHtml2(html) {
    return html.replace($fbd80a69cf576f05$var$ESCAPE_REGEX3, (match)=>$fbd80a69cf576f05$var$ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function $fbd80a69cf576f05$var$createServerHandoffString(serverHandoff) {
    return $fbd80a69cf576f05$var$escapeHtml2(JSON.stringify(serverHandoff));
}
function $fbd80a69cf576f05$var$getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let route = build.routes[id];
        $fbd80a69cf576f05$var$invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $fbd80a69cf576f05$var$prependCookies(errorHeaders, headers2);
            $fbd80a69cf576f05$var$prependCookies(actionHeaders, headers2);
            $fbd80a69cf576f05$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) $fbd80a69cf576f05$var$prependCookies(errorHeaders, headers);
        $fbd80a69cf576f05$var$prependCookies(actionHeaders, headers);
        $fbd80a69cf576f05$var$prependCookies(loaderHeaders, headers);
        $fbd80a69cf576f05$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function $fbd80a69cf576f05$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $e4a96bcce5e8f1ac$exports.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $fbd80a69cf576f05$var$SERVER_NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    ...$fbd80a69cf576f05$var$NO_BODY_STATUS_CODES,
    304
]);
async function $fbd80a69cf576f05$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let respond2 = function(context) {
            let headers = $fbd80a69cf576f05$var$getDocumentHeaders(build, context);
            if ($fbd80a69cf576f05$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, {
                result: $fbd80a69cf576f05$var$getSingleFetchRedirect(context.statusCode, headers, build.basename),
                headers: headers,
                status: $fbd80a69cf576f05$var$SINGLE_FETCH_REDIRECT_STATUS
            });
            if (context.errors) {
                Object.values(context.errors).forEach((err)=>{
                    if (!$fbd80a69cf576f05$export$972111febbeef05b(err) || err.error) handleError(err);
                });
                context.errors = $fbd80a69cf576f05$var$sanitizeErrors(context.errors, serverMode);
            }
            let singleFetchResult;
            if (context.errors) singleFetchResult = {
                error: Object.values(context.errors)[0]
            };
            else singleFetchResult = {
                data: Object.values(context.actionData || {})[0]
            };
            return $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, {
                result: singleFetchResult,
                headers: headers,
                status: context.statusCode
            });
        };
        var respond = respond2;
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            skipRevalidation: true,
            unstable_respond: respond2
        });
        if (!$fbd80a69cf576f05$var$isResponse(result)) result = respond2(result);
        if ($fbd80a69cf576f05$var$isRedirectResponse(result)) return $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, {
            result: $fbd80a69cf576f05$var$getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: $fbd80a69cf576f05$var$SINGLE_FETCH_REDIRECT_STATUS
        });
        return result;
    } catch (error) {
        handleError(error);
        return $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        });
    }
}
async function $fbd80a69cf576f05$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let respond2 = function(context) {
            let headers = $fbd80a69cf576f05$var$getDocumentHeaders(build, context);
            if ($fbd80a69cf576f05$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, {
                result: {
                    [$fbd80a69cf576f05$export$60644022b8b46aaa]: $fbd80a69cf576f05$var$getSingleFetchRedirect(context.statusCode, headers, build.basename)
                },
                headers: headers,
                status: $fbd80a69cf576f05$var$SINGLE_FETCH_REDIRECT_STATUS
            });
            if (context.errors) {
                Object.values(context.errors).forEach((err)=>{
                    if (!$fbd80a69cf576f05$export$972111febbeef05b(err) || err.error) handleError(err);
                });
                context.errors = $fbd80a69cf576f05$var$sanitizeErrors(context.errors, serverMode);
            }
            let results = {};
            let loadedMatches = new Set(context.matches.filter((m)=>loadRouteIds ? loadRouteIds.has(m.route.id) : m.route.loader != null).map((m)=>m.route.id));
            if (context.errors) for (let [id, error] of Object.entries(context.errors))results[id] = {
                error: error
            };
            for (let [id, data2] of Object.entries(context.loaderData))if (!(id in results) && loadedMatches.has(id)) results[id] = {
                data: data2
            };
            return $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, {
                result: results,
                headers: headers,
                status: context.statusCode
            });
        };
        var respond = respond2;
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let routesParam = new URL(request.url).searchParams.get("_routes");
        let loadRouteIds = routesParam ? new Set(routesParam.split(",")) : null;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            filterMatchesToLoad: (m)=>!loadRouteIds || loadRouteIds.has(m.route.id),
            skipLoaderErrorBubbling: true,
            unstable_respond: respond2
        });
        if (!$fbd80a69cf576f05$var$isResponse(result)) result = respond2(result);
        if ($fbd80a69cf576f05$var$isRedirectResponse(result)) return $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                [$fbd80a69cf576f05$export$60644022b8b46aaa]: $fbd80a69cf576f05$var$getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: $fbd80a69cf576f05$var$SINGLE_FETCH_REDIRECT_STATUS
        });
        return result;
    } catch (error) {
        handleError(error);
        return $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                root: {
                    error: error
                }
            },
            headers: new Headers(),
            status: 500
        });
    }
}
function $fbd80a69cf576f05$var$generateSingleFetchResponse(request, build, serverMode, { result: result, headers: headers, status: status }) {
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if ($fbd80a69cf576f05$var$SERVER_NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status: status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response($fbd80a69cf576f05$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
function $fbd80a69cf576f05$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = $fbd80a69cf576f05$var$stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $fbd80a69cf576f05$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return $fbd80a69cf576f05$var$encode(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $fbd80a69cf576f05$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof $fbd80a69cf576f05$export$f2680fa305b734ca) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && $fbd80a69cf576f05$export$60644022b8b46aaa in value) return [
                    "SingleFetchRedirect",
                    value[$fbd80a69cf576f05$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $fbd80a69cf576f05$var$derive(build, mode) {
    let routes = $fbd80a69cf576f05$var$createRoutes(build.routes);
    let dataRoutes = $fbd80a69cf576f05$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $fbd80a69cf576f05$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = $fbd80a69cf576f05$var$createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        $fbd80a69cf576f05$export$972111febbeef05b(error) && error.error ? error.error : error);
    });
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var $fbd80a69cf576f05$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, initialContext) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $fbd80a69cf576f05$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = $fbd80a69cf576f05$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let params = {};
        let loadContext;
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $fbd80a69cf576f05$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        if (_build.future.unstable_middleware) {
            if (initialContext == null) loadContext = new $fbd80a69cf576f05$export$b754276817659c2d();
            else try {
                loadContext = new $fbd80a69cf576f05$export$b754276817659c2d(initialContext);
            } catch (e) {
                let error = new Error(`Unable to create initial \`unstable_RouterContextProvider\` instance. Please confirm you are returning an instance of \`Map<unstable_routerContext, unknown>\` from your \`getLoadContext\` function.

Error: ${e instanceof Error ? e.toString() : e}`);
                handleError(error);
                return $fbd80a69cf576f05$var$returnLastResortErrorResponse(error, serverMode);
            }
        } else loadContext = initialContext || {};
        let url = new URL(request.url);
        let normalizedBasename = _build.basename || "/";
        let normalizedPath = url.pathname;
        if ($fbd80a69cf576f05$var$stripBasename(normalizedPath, normalizedBasename) === "/_root.data") normalizedPath = normalizedBasename;
        else if (normalizedPath.endsWith(".data")) normalizedPath = normalizedPath.replace(/\.data$/, "");
        if ($fbd80a69cf576f05$var$stripBasename(normalizedPath, normalizedBasename) !== "/" && normalizedPath.endsWith("/")) normalizedPath = normalizedPath.slice(0, -1);
        let isSpaMode = $fbd80a69cf576f05$var$getBuildTimeHeader(request, "X-React-Router-SPA-Mode") === "yes";
        if (!_build.ssr) {
            if (_build.prerender.length === 0) isSpaMode = true;
            else if (!_build.prerender.includes(normalizedPath) && !_build.prerender.includes(normalizedPath + "/")) {
                if (url.pathname.endsWith(".data")) {
                    errorHandler(new $fbd80a69cf576f05$export$f2680fa305b734ca(404, "Not Found", `Refusing to SSR the path \`${normalizedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else isSpaMode = true;
            }
        }
        let manifestUrl = $fbd80a69cf576f05$var$getManifestPath(_build.routeDiscovery.manifestPath, normalizedBasename);
        if (url.pathname === manifestUrl) try {
            let res = await $fbd80a69cf576f05$var$handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $fbd80a69cf576f05$var$matchServerRoutes(routes, normalizedPath, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = normalizedPath;
            let singleFetchMatches = $fbd80a69cf576f05$var$matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await $fbd80a69cf576f05$var$handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ($fbd80a69cf576f05$var$isRedirectResponse(response)) {
                    let result = $fbd80a69cf576f05$var$getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [$fbd80a69cf576f05$export$60644022b8b46aaa]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response($fbd80a69cf576f05$var$encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: $fbd80a69cf576f05$var$SINGLE_FETCH_REDIRECT_STATUS,
                        headers: headers
                    });
                }
            }
        } else if (!isSpaMode && matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $fbd80a69cf576f05$var$handleResourceRequest(serverMode, _build, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let { pathname: pathname } = url;
            let criticalCss = void 0;
            if (_build.unstable_getCriticalCss) criticalCss = await _build.unstable_getCriticalCss({
                pathname: pathname
            });
            else if (mode === "development" /* Development */  && $fbd80a69cf576f05$var$getDevServerHooks()?.getCriticalCss) criticalCss = await $fbd80a69cf576f05$var$getDevServerHooks()?.getCriticalCss?.(pathname);
            response = await $fbd80a69cf576f05$var$handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function $fbd80a69cf576f05$var$handleManifestRequest(build, routes, url) {
    if (build.assets.version !== url.searchParams.get("version")) return new Response(null, {
        status: 204,
        headers: {
            "X-Remix-Reload-Document": "true"
        }
    });
    let patches = {};
    if (url.searchParams.has("p")) {
        let paths = /* @__PURE__ */ new Set();
        url.searchParams.getAll("p").forEach((path)=>{
            if (!path.startsWith("/")) path = `/${path}`;
            let segments = path.split("/").slice(1);
            segments.forEach((_, i)=>{
                let partialPath = segments.slice(0, i + 1).join("/");
                paths.add(`/${partialPath}`);
            });
        });
        for (let path of paths){
            let matches = $fbd80a69cf576f05$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $fbd80a69cf576f05$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let response = request.method !== "GET" ? await $fbd80a69cf576f05$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $fbd80a69cf576f05$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    return response;
}
async function $fbd80a69cf576f05$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss) {
    try {
        let response = await staticHandler.query(request, {
            requestContext: loadContext,
            unstable_respond: build.future.unstable_middleware ? (ctx)=>renderHtml(ctx, isSpaMode) : void 0
        });
        return $fbd80a69cf576f05$var$isResponse(response) ? response : renderHtml(response, isSpaMode);
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    async function renderHtml(context, isSpaMode2) {
        if ($fbd80a69cf576f05$var$isResponse(context)) return context;
        let headers = $fbd80a69cf576f05$var$getDocumentHeaders(build, context);
        if ($fbd80a69cf576f05$var$SERVER_NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$fbd80a69cf576f05$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $fbd80a69cf576f05$var$sanitizeErrors(context.errors, serverMode);
        }
        let state = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $fbd80a69cf576f05$var$serializeErrors2(context.errors, serverMode)
        };
        let baseServerHandoff = {
            basename: build.basename,
            future: build.future,
            routeDiscovery: build.routeDiscovery,
            ssr: build.ssr,
            isSpaMode: isSpaMode2
        };
        let entryContext = {
            manifest: build.assets,
            routeModules: $fbd80a69cf576f05$var$createEntryRouteModules(build.routes),
            staticHandlerContext: context,
            criticalCss: criticalCss,
            serverHandoffString: $fbd80a69cf576f05$var$createServerHandoffString({
                ...baseServerHandoff,
                criticalCss: criticalCss
            }),
            serverHandoffStream: $fbd80a69cf576f05$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {},
            future: build.future,
            ssr: build.ssr,
            routeDiscovery: build.routeDiscovery,
            isSpaMode: isSpaMode2,
            serializeError: (err)=>$fbd80a69cf576f05$var$serializeError(err, serverMode)
        };
        let handleDocumentRequestFunction = build.entry.module.default;
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error) {
            handleError(error);
            let errorForSecondRender = error;
            if ($fbd80a69cf576f05$var$isResponse(error)) try {
                let data2 = await $fbd80a69cf576f05$var$unwrapResponse(error);
                errorForSecondRender = new $fbd80a69cf576f05$export$f2680fa305b734ca(error.status, error.statusText, data2);
            } catch (e) {}
            context = $fbd80a69cf576f05$var$getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
            if (context.errors) context.errors = $fbd80a69cf576f05$var$sanitizeErrors(context.errors, serverMode);
            let state2 = {
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: $fbd80a69cf576f05$var$serializeErrors2(context.errors, serverMode)
            };
            entryContext = {
                ...entryContext,
                staticHandlerContext: context,
                serverHandoffString: $fbd80a69cf576f05$var$createServerHandoffString(baseServerHandoff),
                serverHandoffStream: $fbd80a69cf576f05$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                renderMeta: {}
            };
            try {
                return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
            } catch (error2) {
                handleError(error2);
                return $fbd80a69cf576f05$var$returnLastResortErrorResponse(error2, serverMode);
            }
        }
    }
}
async function $fbd80a69cf576f05$var$handleResourceRequest(serverMode, build, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext,
            unstable_respond: build.future.unstable_middleware ? (ctx)=>ctx : void 0
        });
        if ($fbd80a69cf576f05$var$isResponse(response)) return response;
        if (typeof response === "string") return new Response(response);
        return Response.json(response);
    } catch (error) {
        if ($fbd80a69cf576f05$var$isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if ($fbd80a69cf576f05$export$972111febbeef05b(error)) {
            if (error) handleError(error);
            return $fbd80a69cf576f05$var$errorResponseToJson(error, serverMode);
        }
        if (error instanceof Error && error.message === "Expected a response from queryRoute") {
            let newError = new Error("Expected a Response to be returned from resource route handler");
            handleError(newError);
            return $fbd80a69cf576f05$var$returnLastResortErrorResponse(newError, serverMode);
        }
        handleError(error);
        return $fbd80a69cf576f05$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $fbd80a69cf576f05$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($fbd80a69cf576f05$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function $fbd80a69cf576f05$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $fbd80a69cf576f05$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $fbd80a69cf576f05$var$flash(name) {
    return `__flash_${name}__`;
}
var $fbd80a69cf576f05$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($fbd80a69cf576f05$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $fbd80a69cf576f05$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($fbd80a69cf576f05$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $fbd80a69cf576f05$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $fbd80a69cf576f05$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $fbd80a69cf576f05$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $fbd80a69cf576f05$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $fbd80a69cf576f05$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $fbd80a69cf576f05$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $fbd80a69cf576f05$var$warnOnceAboutSigningSessionCookie(cookie) {
    $fbd80a69cf576f05$var$warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://reactrouter.com/explanation/sessions-and-cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $fbd80a69cf576f05$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $fbd80a69cf576f05$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $fbd80a69cf576f05$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $fbd80a69cf576f05$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $fbd80a69cf576f05$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $fbd80a69cf576f05$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $fbd80a69cf576f05$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function $fbd80a69cf576f05$export$8f51af5840e0602a(path, ...args) {
    let params = args[0];
    return path.split("/").map((segment)=>{
        const match = segment.match(/^:([\w-]+)(\?)?/);
        if (!match) return segment;
        const param = match[1];
        const value = params ? params[param] : void 0;
        const isRequired = match[2] === void 0;
        if (isRequired && value === void 0) throw Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value;
    }).filter((segment)=>segment !== void 0).join("/");
}
// lib/dom/ssr/errors.ts
function $fbd80a69cf576f05$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $fbd80a69cf576f05$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/dom/ssr/hydration.tsx
function $fbd80a69cf576f05$export$6fa8d910d97963ad(state, routes, getRouteInfo, location, basename, isSpaMode) {
    let hydrationData = {
        ...state,
        loaderData: {
            ...state.loaderData
        }
    };
    let initialMatches = $fbd80a69cf576f05$export$2708184779ceb39d(routes, location, basename);
    if (initialMatches) for (let match of initialMatches){
        let routeId = match.route.id;
        let routeInfo = getRouteInfo(routeId);
        if ($fbd80a69cf576f05$export$6ac68922d4e92125(routeId, routeInfo.clientLoader, routeInfo.hasLoader, isSpaMode) && (routeInfo.hasHydrateFallback || !routeInfo.hasLoader)) delete hydrationData.loaderData[routeId];
        else if (!routeInfo.hasLoader) hydrationData.loaderData[routeId] = null;
    }
    return hydrationData;
}





var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $186cacd6c17eb54c$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $186cacd6c17eb54c$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $acw62.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $acw62.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $acw62.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$186cacd6c17eb54c$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $186cacd6c17eb54c$var$g(r, f) : r,
            d ? $186cacd6c17eb54c$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $186cacd6c17eb54c$var$E(r), b());
    };
    return $186cacd6c17eb54c$var$X(s, !!t), $186cacd6c17eb54c$var$W(m), (0, $acw62.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $acw62.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $186cacd6c17eb54c$var$W(n) {
    (0, $acw62.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $186cacd6c17eb54c$var$X(n, t) {
    (0, $acw62.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $186cacd6c17eb54c$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$186cacd6c17eb54c$var$E(n.parentElement)
    ];
}
const $186cacd6c17eb54c$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $186cacd6c17eb54c$var$D = (n, t)=>$186cacd6c17eb54c$var$k.every((o)=>n[o] === t[o]);



var $acw62 = parcelRequire("acw62");
/* istanbul ignore next */ /** keep typescript happy */ var $8c321ba562d39156$var$noop = function() {};
function $8c321ba562d39156$export$2e2bcd8739ae039(callback, delay, immediate) {
    var savedCallback = (0, $acw62.useRef)($8c321ba562d39156$var$noop);
    // Remember the latest callback.
    (0, $acw62.useEffect)(function() {
        savedCallback.current = callback;
    });
    // Execute callback if immediate is set.
    (0, $acw62.useEffect)(function() {
        if (!immediate) return;
        if (delay === null || delay === false) return;
        savedCallback.current();
    }, [
        immediate
    ]);
    // Set up the interval.
    (0, $acw62.useEffect)(function() {
        if (delay === null || delay === false) return undefined;
        var tick = function() {
            return savedCallback.current();
        };
        var id = setInterval(tick, delay);
        return function() {
            return clearInterval(id);
        };
    }, [
        delay
    ]);
}



const $18044fa0a9c67a92$export$f4d796ac76f915d6 = {
    "benedictus es": {
        lines: [
            [
                "BLESS_ED art thou, O Lord /God of our /fa_thers;",
                "praised and ex_al_ted a_bove /all for /ev_er."
            ],
            [
                "Bless_ed art thou for the /name of thy /Ma_jes_ty;",
                "praised and ex_al_ted a_bove /all for /ev_er."
            ],
            [
                "Bless_ed art thou in the tem_ple /of thy /ho_li_ness;",
                "praised and ex_al_ted a_bove /all for /ev_er."
            ],
            [
                "Bless_ed art thou that be_hold_est the depths, and dwell_est be_/tween the /Che_ru_bim;",
                "praised and ex_al_ted a_bove /all for /ev_er."
            ],
            [
                "Bless_ed art thou on the glo_rious /throne of thy /king_dom;",
                "praised and ex_al_ted a_bove /all for /ev_er."
            ],
            [
                "Bless_ed art thou in the fir_ma_/ment of /heav_en;",
                "praised and ex_al_ted a_bove /all for /ev_er."
            ]
        ]
    },
    "pascha nostrum": {
        lines: [
            [
                "Christ our Pass_o_ver is sa_cri_ficed for /us;",
                "there_fore /let us /keep the /feast,"
            ],
            [
                "Not with old lea_ven, nei_ther with the lea_ven of /mal_ice and /wick_ed_ness,",
                "but with the un_leav_ened bread of sin_/ce_ri_/ty and /truth."
            ],
            [
                "Christ be_ing raised from the dead di_eth no /more;",
                "death hath no more do_/min_ion /o_ver him."
            ],
            [
                "For in that he died, he died un_to sin /once;",
                "but in that he liv_eth, he /liv_eth /un_to God."
            ],
            [
                "Like_wise re_ckon ye also your_selves to be dead in_deed un_to /sin,",
                "but a_live un_to God through Je_sus /Christ our Lord."
            ],
            [
                "Christ is ris_en from the /dead,",
                "and be_come the /first-_fruits of /them that /slept."
            ],
            [
                "For since by man came /death,",
                "by man came al_so the re_sur_/rec_tion /of the /dead."
            ],
            [
                "For as in A_dam all /die,",
                "e_ven so in Christ shall all be /made a_live."
            ]
        ]
    },
    venite: {
        lines: [
            [
                "O COME, let us /sing un_to /the /LORD;",
                "let us hear_ti_ly re_joice in the strength of /our sal_/va_tion."
            ],
            [
                "Let us come be_fore his pres_ence /with thanks_/giv_ing",
                "and show our_selves /glad in /him with /Psalms."
            ],
            [
                "For the /LORD is a /great /God",
                "and a great /King a_/bove /all gods."
            ],
            [
                "In his hand are all the /cor_ners of /the /earth",
                "and the strength of the hills /is his /al_so."
            ],
            [
                "The sea is /his, and /he /made it",
                "and his hands pre_/pared the /dry land."
            ],
            [
                "O come, let us /wor_ship and /fall /down",
                "and kneel be_fore the /Lord our /Ma_ker."
            ],
            [
                "For /he is the /LORD our /God",
                "and we are the peo_ple of his pas_ture, and the /sheep of his /hand."
            ],
            [
                "To_day if ye will hear his voice, /hard_en /not your /hearts",
                "as in the pro_vo_ca_tion, and as in the day of temp_ta_tion /in the /wil_der_ness;"
            ],
            [
                "When your /fa_thers /temp_ted me",
                "proved /me, and /saw my works."
            ],
            [
                "For_ty years long was I grieved with this gen_er_/a_tion, and /said,",
                "It is a peo_ple that do err in their heart, for they /have not /known my ways."
            ],
            [
                "Un_to whom I /sware in my /wrath",
                "that they should not en_ter /in_to /my /rest."
            ]
        ]
    },
    "te deum": {
        lines: [
            [
                "WE praise thee, O God we ack_now_ledge /thee to /be the /Lord.",
                "All the earth doth wor_ship thee the Fa_ther /e_ver_/last_ing."
            ],
            [
                "To thee all An_gels cry a_loud; the Hea_vens, and all the /Pow_ers /there_/in.",
                "To thee Che_ru_bim and Se_ra_phim con_/ti_nu_al_/ly do /cry,"
            ],
            [
                "Ho_ly, Ho_ly, Ho_ly Lord /God of /Sa_ba_oth;",
                "Heav_en and earth are full of the Ma_je_sty /of thy /glo_ry."
            ],
            [
                "The glo_ri_ous com_pa_ny of the A_/po_stles /praise thee.",
                "The good_ly fel_low_ship of the /Pro_phets /praise thee."
            ],
            [
                "The no_ble ar_my of /Mar_tyrs /praise thee.",
                "The ho_ly Church through_out all the world /doth ack_/now_ledge thee;"
            ],
            [
                "The Fa_ther of an in_fi_nite Ma_jes_ty; Thine hon_our_a_ble, /true and /on_ly /Son;",
                "Al_so the Ho_ly /Ghost, the /Com_for_ter."
            ],
            [
                "Thou art the King of /Glo_ry O /Christ.",
                "Thou art the e_ver_last_ing /Son of the /Fa_ther."
            ],
            [
                "When thou took_est up_on thee /to de_/li_ver /man",
                "thou didst hum_ble thy_self to be /born of a /Vir_gin."
            ],
            [
                "When thou hadst o_ver_come the /sharp_ness of /death",
                "thou didst o_pen the King_dom of Hea_ven to /all be_/lie_vers."
            ],
            [
                "Thou sitt_est at the /right hand of /God",
                "in the glo_ry /of the /Fa_ther."
            ],
            [
                "We be_lieve that thou shalt /come to /be our /Judge.",
                "We there_fore pray thee, help thy ser_vants whom thou hast re_deemed /with thy /prec_ious /blood."
            ],
            [
                "Make them to be /num_bered /with thy /Saints",
                "in glo_ry /ev_er_/last_ing."
            ],
            [
                "O Lord, save thy peo_ple and /bless thine /he_ri_tage.",
                "Gov_ern them and lift them /up for /e_ver."
            ],
            [
                "Day by day we /mag_ni_fy /thee;",
                "And we wor_ship thy Name e_ver /world with_/out end."
            ],
            [
                "Vouch_safe, O Lord, to keep us this /day with_/out /sin.",
                "O Lord, have mer_cy up_on us; have /mer_cy up_/on us."
            ],
            [
                "O Lord, let thy mer_cy be up_on us as our /trust is in /thee.",
                "O Lord, in thee have I trust_ed; let me ne_ver /be con_/found_ed."
            ]
        ]
    },
    benedictus: {
        lines: [
            [
                "BLESS_ED be the Lord /God of /Is_ra_el",
                "for he hath vi_si_ted and re_/deemed his /peo_ple;"
            ],
            [
                "And hath raised up a migh_ty sal_/va_tion /for us",
                "in the house of his /ser_vant /Da_vid;"
            ],
            [
                "As he spake by the mouth of his /ho_ly /Pro_phets",
                "which have been /since the /world be_/gan;"
            ],
            [
                "That we should be saved /from our /e_ne_mies",
                "and from the hand of /all that /hate us."
            ],
            [
                "To per_form the mer_cy prom_ised /to our /fore_fath_ers",
                "and to re_mem_ber his /ho_ly /co_ve_nant;"
            ],
            [
                "To per_form the oath which he sware to our /fore_fa_ther /A_bra_ham",
                "that /he would /give us;"
            ],
            [
                "That we be_ing de_liv_ered out of the /hand of our /e_ne_mies",
                "might /serve him with_/out fear;"
            ],
            [
                "In ho_li_ness and right_eous_/ness be_/fore him",
                "all the /days of our /life."
            ],
            [
                "And thou, child, shalt be called the /Pro_phet of the /High_est",
                "for thou shalt go be_fore the face of the Lord /to pre_/pare his /ways;"
            ],
            [
                "To give know_ledge of sal_va_tion /un_to his /peo_ple",
                "for the re_/miss_ion /of their /sins,"
            ],
            [
                "Through the ten_der /mer_cy of /our /God",
                "where_by the day-_spring from on high hath /vi_si_ted /us;"
            ],
            [
                "To give light to them that sit in dark_ness, and in the /sha_dow of /death",
                "and to guide our feet in_/to the /way of /peace."
            ]
        ]
    },
    magnificat: {
        lines: [
            [
                "MY soul doth /mag_ni_fy /the /Lord",
                "and my spi_rit hath re_joiced in /God my /Sav_iour."
            ],
            [
                "For he /hath re_/gar_ded",
                "the low_li_ness of /his hand_/maid_en."
            ],
            [
                "For be_/hold, from /hence_forth",
                "all ge_ne_ra_tions shall /call me /bless_ed."
            ],
            [
                "For he that is migh_ty hath /mag_ni_fied /me",
                "and /ho_ly /is his /Name."
            ],
            [
                "And his mer_cy is on /them that /fear him",
                "through_out all /ge_ne_/ra_tions."
            ],
            [
                "He hath showed /strength with his /arm",
                "he hath scatt_ered the proud in the i_ma_gi_/na_tion of /their hearts."
            ],
            [
                "He hath put down the /migh_ty /from their /seat",
                "and hath ex_al_ted the /hum_ble and /meek."
            ],
            [
                "He hath filled the /hun_gry with /good things",
                "and the rich he hath sent /emp_ty a_/way."
            ],
            [
                "He re_mem_ber_ing his mer_cy hath hol_pen his /ser_vant /Is_ra_el",
                "as he pro_mised to our fore_fa_thers, A_bra_ham and his /seed, for /e_ver."
            ]
        ]
    },
    "nunc dimittis": {
        lines: [
            [
                "LORD, now let_test thou thy /ser_vant de_/part in /peace",
                "ac_/cor_ding /to thy word."
            ],
            [
                "For mine eyes have seen /thy sal_/va_tion,",
                "Which thou hast pre_pared be_fore the /face of all /peo_ple;"
            ],
            [
                "To be a light to /ligh_ten the /Gen_tiles",
                "and to be the glo_ry of thy /peo_ple /Is_ra_el."
            ]
        ]
    },
    "quicunque vult": {
        lines: [
            [
                "Who_so_e_ver will be /saved",
                "be_fore all things it is ne_ces_sa_ry that he hold the /Cath_olic Faith."
            ],
            [
                "Which Faith ex_cept e_very one do keep whole and un_de_/filed",
                "with_out doubt he shall pe_rish e_ver_/last_ing_ly."
            ],
            [
                "And the Cath_olic Faith is /this:",
                "That we wor_ship one God in Tri_ni_ty, and Tri_ni_ty in /U_ni_ty;"
            ],
            [
                "Nei_ther con_found_ing the /Per_sons",
                "nor di_vi_ding the /Sub_stance."
            ],
            [
                "For there is one Per_son of the Fa_ther, a_no_ther of the /Son",
                "and a_no_ther of the /Ho_ly Ghost."
            ],
            [
                "But the God_head of the Fa_ther, of the Son, and of the Ho_ly Ghost, is all /one",
                "the Glo_ry e_qual, the Ma_je_sty co-_e_/ter_nal."
            ],
            [
                "Such as the Fa_ther is, such is the /Son",
                "and such is the /Ho_ly Ghost."
            ],
            [
                "The Fa_ther un_cre_ate, the Son un_cre_/ate",
                "and the Ho_ly Ghost /un_cre_ate."
            ],
            [
                "The Fa_ther in_com_pre_hen_si_ble, the Son in_com_pre_/hen_si_ble",
                "and the Ho_ly Ghost in_com_pre_/hen_si_ble."
            ],
            [
                "The Fa_ther e_ter_nal, the Son e_/ter_nal",
                "and the Ho_ly Ghost e_/ter_nal."
            ],
            [
                "And yet they are not three e_/ter_nals",
                "but one e_/ter_nal."
            ],
            [
                "As al_so there are not three in_com_pre_hen_si_bles, nor three un_cre_/a_ted",
                "but one un_cre_a_ted, and one in_com_pre_/hen_si_ble."
            ],
            [
                "So like_wise the Fa_ther is Al_migh_ty, the Son Al_/migh_ty",
                "and the Ho_ly Ghost Al_/migh_ty."
            ],
            [
                "And yet they are not three Al_/migh_ties",
                "but one Al_/migh_ty."
            ],
            [
                "So the Fa_ther is God, the Son is God, and the Ho_ly /Ghost is God.",
                "And yet they are not three Gods, but /one God."
            ],
            [
                "So like_wise the Fa_ther is Lord, the Son Lord, and the Ho_ly /Ghost Lord.",
                "And yet not three Lords, but /one Lord."
            ],
            [
                "For like as we are com_pelled by the Chris_tian /ve_ri_ty",
                "to ack_now_ledge e_very Per_son by him_self to be /God and Lord;"
            ],
            [
                "So are we for_bid_den by the Cath_olic Re_/li_gion",
                "to say there be three Gods, or /three Lords."
            ],
            [
                "The Fa_ther is made of /none",
                "neither cre_a_ted, nor be_/got_ten."
            ],
            [
                "The Son is of the Fa_ther a_/lone",
                "not made, nor cre_a_ted, but be_/got_ten."
            ],
            [
                "The Ho_ly Ghost is of the Fa_ther and of the /Son",
                "nei_ther made, nor cre_a_ted, nor be_got_ten, but pro_/ceed_ing."
            ],
            [
                "So there is one Fa_ther, not three Fa_thers; one Son, not /three Sons",
                "one Ho_ly Ghost, not three /Ho_ly Ghosts."
            ],
            [
                "And in this Tri_ni_ty none is a_fore, or af_ter o_ther; none is grea_ter, or less than a_/no_ther;",
                "But the whole three Per_sons are co-_e_ter_nal to_/ge_ther and co-_/e_qual."
            ],
            [
                "So that in all things, as is a_/fore_said",
                "the U_ni_ty in Tri_ni_ty, and the Tri_ni_ty in U_ni_ty is to be /wor_shipped."
            ],
            [
                "He there_fore that will be /saved",
                "must thus think of the /Tri_ni_ty."
            ],
            [
                "Fur_ther_more it is ne_ces_sa_ry to e_ver_last_ing sal_/va_tion",
                "that he al_so be_lieve right_ly the In_car_na_tion of our Lord /Je_sus Christ."
            ],
            [
                "For the right Faith is that we be_lieve and con_/fess",
                "that our Lord Je_sus Christ, the Son of God, is /God and Man;"
            ],
            [
                "God, of the Sub_stance of the Fa_ther, be_got_ten be_/fore the worlds",
                "and Man, of the Sub_stance of his Mo_ther, born /in the world;"
            ],
            [
                "Per_fect God, and Per_fect /Man",
                "of a rea_so_na_ble soul and hu_man flesh sub_/sist_ing;"
            ],
            [
                "E_qual to the Fa_ther, as touch_ing his /God_head",
                "and in_fe_ri_or to the Fa_ther, as touch_ing his /Man_hood."
            ],
            [
                "Who al_though he be God and /Man",
                "yet he is not two, but /one Christ;"
            ],
            [
                "One, not by con_ver_sion of the God_head in_to /flesh",
                "but by taking of the Man_hood /in_to God;"
            ],
            [
                "One al_to_ge_ther, not by con_fu_sion of /Sub_stance",
                "but by u_ni_ty of /Per_son."
            ],
            [
                "For as the rea_so_na_ble soul and flesh is /one man",
                "so God and Man is /one Christ."
            ],
            [
                "Who suf_fered for our sal_/va_tion",
                "de_scend_ed into hell, rose again the third day /from the dead."
            ],
            [
                "He a_scend_ed in_to hea_ven, he sit_teth on the right hand of the Fa_ther, God Al_/migh_ty:",
                "from whence he shall come to judge the /quick and the dead."
            ],
            [
                "At whose com_ing all men shall rise a_gain with their /bo_dies",
                "and shall give ac_count for their /own works."
            ],
            [
                "And they that have done good shall go into life e_ver_/last_ing",
                "and they that have done e_vil in_to e_ver_/last_ing fire."
            ],
            [
                "This is the Ca_tholic /Faith",
                "which ex_cept a man be_lieve faith_ful_ly, he can_/not be saved."
            ]
        ]
    }
};


const $7f98b4308afe4768$export$adc377d3f4f7a592 = [
    {
        id: "psalm1",
        lines: [
            [
                "BLESS_ED is the man that hath not walked in the coun_sel of the un_god_ly, nor stood in the /way of /sin_ners,",
                "and hath not sat in the /seat of the /scornf_ul."
            ],
            [
                "But his de_light is in the /law of the /LORD;",
                "and in his law will he ex_er_cise him_self /day and /night."
            ],
            [
                "And he shall be like a tree plan_ted /by the /wa_ter-_side,",
                "that will bring forth his /fruit in due /sea_son."
            ],
            [
                "His leaf al_so /shall not /wi_ther;",
                "and look, what_so_ev_er he do_eth, /it shall /pros_per."
            ],
            [
                "As for the un_god_ly, it /is not /so with /them;",
                "but they are like the chaff, which the wind scat_ter_eth a_way from the /face of the /earth."
            ],
            [
                "There_fore the un_god_ly shall not be a_ble to /stand in the /judg_ment,",
                "nei_ther the sin_ners in the con_gre_/ga_tion of the /right_eous."
            ],
            [
                "But the LORD know_eth the /way of the /right_eous;",
                "and the way of the un_/god_ly shall /per_ish."
            ]
        ]
    },
    {
        id: "psalm2",
        lines: [
            [
                "WHY do the heath_en so fu_ri_ous_ly /rage to_/ge_ther?",
                "and why do the peo_ple i_/ma_gine a /vain thing?"
            ],
            [
                "The kings of the earth stand up, and the rul_ers take /coun_sel to_/ge_ther",
                "a_gainst the LORD, and a_/gainst his A_/noin_ted:"
            ],
            [
                "Let us break their /bonds a_/sun_der,",
                "and cast a_/way their /cords from us."
            ],
            [
                "He that dwell_eth in hea_ven shall /laugh them to /scorn:",
                "the Lord shall have them /in de_/ri_sion."
            ],
            [
                "Then shall he speak un_to /them in his /wrath,",
                "and vex them in his /sore dis_/plea_sure:"
            ],
            [
                "Yet /have I /set my /King",
                "up_on my ho_ly /hill of /Si_on."
            ],
            [
                "I will re_/hearse the de_/cree;",
                "the LORD hath said un_to me, Thou art my Son, this day have /I be_/got_ten thee."
            ],
            [
                "De_sire of me, and I shall give thee the na_tions for /thine in_/he_ri_tance,",
                "and the ut_most parts of the earth for /thy pos_/sess_ion."
            ],
            [
                "Thou shalt bruise them with a /rod of /i_ron,",
                "and break them in pie_ces like a /pot_ter's /vess_el."
            ],
            [
                "Be wise now /there_fore, /O ye kings;",
                "be in_struct_ed, ye that are /judg_es /of the /earth."
            ],
            [
                "/Serve the /LORD in fear,",
                "and re_joice un_to /him with /rev_erence."
            ],
            [
                "Kiss the Son, lest he be an_gry, and so ye per_ish from the right way, if his wrath be kin_dled, yea /but a /lit_tle.",
                "Bless_ed are all they that /put their /trust in /him."
            ]
        ]
    },
    {
        id: "psalm3",
        lines: [
            [
                "LORD, how are they in_/creased that /trou_ble me!",
                "ma_ny are they that /rise a_/gainst me."
            ],
            [
                "Ma_ny one there be that /say of my /soul,",
                "There is no /help for him /in his /God."
            ],
            [
                "But thou, O LORD, art /my de_/fen_der;",
                "thou art my wor_ship, and the /lif_ter up of my /head."
            ],
            [
                "I did call up_on the /LORD with my /voice,",
                "and he heard me /out of his /ho_ly hill."
            ],
            [
                "I laid me down and /slept, and rose /up a_gain;",
                "for the /LORD sus_/tained me."
            ],
            [
                "I will not be a_fraid for ten thou_sands /of the /peo_ple,",
                "that have set them_selves a_/gainst me /round a_/bout."
            ],
            [
                "Up, LORD, and /help me, /O my /God,",
                "for thou smit_est all mine e_ne_mies up_on the cheek-_bone; thou hast bro_ken the teeth of /the un_/god_ly."
            ],
            [
                "Sal_va_tion be_long_eth /un_to the /LORD;",
                "and thy bless_ing is up_/on thy /peo_ple."
            ]
        ]
    },
    {
        id: "psalm4",
        lines: [
            [
                "HEAR me when I call, O /God of my /right_eous_ness:",
                "thou hast set me at li_ber_ty when I was in trou_ble; have mer_cy up_on me, and hear_ken /un_to /my /prayer."
            ],
            [
                "O ye sons of men, how long will ye blas_/pheme mine /ho_nour,",
                "and have such plea_sure in va_ni_ty, and seek /af_ter /false_hood?"
            ],
            [
                "Know this al_so, that the LORD hath cho_sen to him_self the /man that is /god_ly;",
                "when I call up_on the LORD /he will /hear me."
            ],
            [
                "Stand in /awe, and sin /not;",
                "comm_une with your own heart, and in your /cham_ber, /and be /still."
            ],
            [
                "Off_er the sac_ri_/fice of /right_eous_ness,",
                "and put your /trust in the /LORD."
            ],
            [
                "There be /ma_ny that /say,",
                "Who will /show us /an_y /good?"
            ],
            [
                "/LORD, lift thou /up",
                "the light of thy /coun_te_nance up_/on us."
            ],
            [
                "Thou hast put /glad_ness /in my /heart;",
                "yea, more than when their corn and /wine and /oil in_crease."
            ],
            [
                "I will lay me down in /peace, and /take my /rest;",
                "for it is thou, LORD, on_ly, that mak_est me /dwell in /safe_ty."
            ]
        ]
    },
    {
        id: "psalm5",
        lines: [
            [
                "/PON_DER my /words, O LORD,",
                "con_si_der my /me_di_/ta_tion."
            ],
            [
                "O hear_ken thou un_to the voice of my call_ing, my /King and my /God:",
                "for un_to /thee will I /make my /prayer."
            ],
            [
                "My voice shalt thou /hear be_/times, O LORD;",
                "ear_ly in the mor_ning will I di_rect my prayer un_to /thee, and will /look up."
            ],
            [
                "For thou art the God that hast no /plea_sure in /wick_ed_ness;",
                "nei_ther shall an_y /e_vil /dwell with thee."
            ],
            [
                "Such as be fool_ish shall not /stand in thy /sight;",
                "for thou hat_est all them that /work in_/i_qui_ty."
            ],
            [
                "Thou shalt des_troy /them that speak /lies:",
                "the LORD will ab_hor both the blood-_thirs_ty /and de_/ceit_ful /man."
            ],
            [
                "But as for me, in the mul_ti_tude of thy mer_cy I will come /in_to thine /house;",
                "and in thy fear will I wor_ship to_ward thy /ho_ly /tem_ple."
            ],
            [
                "Lead me, O LORD, in thy right_eous_ness, be_/cause of mine /e_ne_mies;",
                "make thy way /plain be_/fore my face."
            ],
            [
                "For there is no /faith_ful_ness /in their /mouth;",
                "their in_ward parts are /ve_ry /wick_ed_ness."
            ],
            [
                "Their throat is an /o_pen /se_pul_chre;",
                "they /flat_ter /with their /tongue."
            ],
            [
                "Des_troy thou them, O God; let them per_ish through their own i_/ma_gi_/na_tions;",
                "cast them out in the mul_ti_tude of their un_god_li_ness; for they have re_/belled a_/gainst thee."
            ],
            [
                "And let all them that put their /trust in /thee re_/joice:",
                "they shall ev_er be gi_ving of thanks, be_cause thou de_fend_est them; they that love thy Name shall be /joy_ful in /thee;"
            ],
            [
                "For thou, LORD, wilt give thy bless_ing /un_to the /right_eous,",
                "and with thy fa_vour_a_ble kind_ness wilt thou de_/fend him as /with a /shield."
            ]
        ]
    },
    {
        id: "psalm6",
        lines: [
            [
                "O LORD, re_buke me not in thine /in_dig_/na_tion,",
                "nei_ther chas_ten me in /thy dis_/plea_sure."
            ],
            [
                "Have mer_cy up_on me, O /LORD, for /I am /weak;",
                "O LORD, heal me, /for my /bones are /vexed."
            ],
            [
                "My soul /al_so is /sore /trou_bled:",
                "but, LORD, how /long wilt thou /pu_nish me?"
            ],
            [
                "Turn thee, O LORD, and de_/li_ver my /soul;",
                "O save me, /for thy /mer_cy's sake."
            ],
            [
                "For in death no man re_/mem_bereth thee;",
                "and who will give thee /thanks in the /pit?"
            ],
            [
                "I am wea_ry /of my /groan_ing;",
                "eve_ry night wash I my bed, and wa_ter my /couch with my /tears."
            ],
            [
                "My beau_ty is gone for /ve_ry /trou_ble,",
                "and worn a_way be_cause of /all mine /e_ne_mies."
            ],
            [
                "A_way from me, all ye that /work in_/i_qui_ty;",
                "for the LORD hath heard the /voice of my /weep_ing."
            ],
            [
                "The LORD hath /heard my pe_/ti_tion;",
                "the LORD /will re_/ceive my prayer."
            ],
            [
                "All mine e_ne_mies shall be con_/foun_ded, and /sore /vexed;",
                "they shall be turned back, and /put to shame /sud_den_ly."
            ]
        ]
    },
    {
        id: "psalm7",
        lines: [
            [
                "O LORD my God, in /thee have I /put my trust:",
                "save me from all them that per_se_cute me, /and de_/li_ver me;"
            ],
            [
                "Lest he de_vour my soul like a li_on, and /tear it in /pie_ces,",
                "/while there is /none to help."
            ],
            [
                "O LORD my God, if I have done /an_y such /thing;",
                "or if there be an_y /wick_ed_ness in /my /hands;"
            ],
            [
                "If I have re_war_ded e_vil un_to him that dealt /friend_ly with /me;",
                "yea, I have de_li_vered him that with_out an_y /cause is mine /e_ne_my;"
            ],
            [
                "Then let mine e_ne_my per_se_cute my /soul, and /take me;",
                "yea, let him tread my life down up_on the earth, and lay mine /ho_nour /in the /dust."
            ],
            [
                "Stand up, O LORD, in thy wrath, and lift up thy_self, be_cause of the in_dig_na_tion of /mine /e_ne_mies;",
                "a_rise up for me in the judg_ment that /thou hast com_/man_ded."
            ],
            [
                "And so shall the con_gre_ga_tion of the peo_ples /come a_/bout thee:",
                "for their sakes there_fore lift /up thy_/self a_gain."
            ],
            [
                "The LORD shall judge the peo_ples: give /sen_tence with /me, O LORD,",
                "ac_cor_ding to my right_eous_ness, and ac_cor_ding to the in_no_cen_cy /that is /in me."
            ],
            [
                "O let the wick_ed_ness of the un_god_ly /come to an /end;",
                "but /guide thou the /just."
            ],
            [
                "/For the /right_eous /God",
                "tri_eth the /ve_ry /hearts and reins."
            ],
            [
                "My help /com_eth of /God,",
                "who pre_ser_veth /them that are /true of heart."
            ],
            [
                "God is a right_eous Judge, /strong, and /pa_tient;",
                "and God is pro_/voked /eve_ry /day."
            ],
            [
                "If a man will not turn, he /will whet his /sword;",
                "he hath bent his bow, and /made it /rea_dy."
            ],
            [
                "He hath pre_pared for him the /inst_ru_ments of /death;",
                "he or_dain_eth his arr_ows a_gainst the /per_se_/cu_tors."
            ],
            [
                "Be_hold, the un_god_ly tra_vail_eth /with in_/i_qui_ty;",
                "he hath con_ceived mis_chief, and /brought forth /false_hood."
            ],
            [
                "He hath gra_ven and /digged up a /pit,",
                "and is fall_en him_self in_to the des_truc_tion that he /made for /oth_er."
            ],
            [
                "For his tra_vail shall come up_/on his /own head,",
                "and his wick_ed_ness shall /fall on his /own /pate."
            ],
            [
                "I will give thanks un_to the LORD, ac_cor_ding /to his /right_eous_ness;",
                "and I will praise the /Name of the /LORD Most High."
            ]
        ]
    },
    {
        id: "psalm8",
        lines: [
            [
                "O LORD our Go_ver_nor, how ex_cell_ent is thy /Name in /all the /world;",
                "thou that hast set thy glo_ry a_/bove the /hea_vens!"
            ],
            [
                "Out of the mouth of ve_ry babes and suck_lings hast thou or_dained strength, be_/cause of thine /e_ne_mies,",
                "that thou might_est still the e_ne_my and /the a_/ven_ger."
            ],
            [
                "When I con_si_der thy hea_vens, e_ven the /work of thy /fing_ers;",
                "the moon and the stars which /thou hast or_/dained;"
            ],
            [
                "What is man, that thou art /mind_ful of /him?",
                "and the son of man, that thou /vis_it_est /him?"
            ],
            [
                "Thou mad_est him low_er /than the /an_gels,",
                "to crown him with /glo_ry and /wor_ship."
            ],
            [
                "Thou mak_est him to have do_min_ion of the /works of thy /hands;",
                "and thou hast put all things in sub_jec_tion /un_der his /feet:"
            ],
            [
                "All /sheep and /ox_en;",
                "yea, and the /beasts of the /field;"
            ],
            [
                "The fowls of the air, and the /fish_es /of the /sea;",
                "and what_so_ev_er walk_eth through the /paths of the /seas."
            ],
            [
                "O /LORD our /Go_ver_nor,",
                "how ex_cell_ent is thy /Name in /all the /world!"
            ]
        ]
    },
    {
        id: "psalm9",
        lines: [
            [
                "I WILL give thanks un_to thee, O LORD, with /my whole /heart;",
                "I will speak of all /thy mar_/vell_ous /works."
            ],
            [
                "I will be /glad and re_/joice in thee;",
                "yea, my songs will I make of thy Name, O /thou Most /High_est."
            ],
            [
                "While mine e_ne_/mies are /driv_en back,",
                "they shall fall and per_ish /at thy /pres_ence."
            ],
            [
                "For thou hast main_tained my /right and my /cause;",
                "thou art set in the /throne that /judg_est right."
            ],
            [
                "Thou hast re_buked the heath_en, and des_troyed /the un_/god_ly;",
                "thou hast put out their name for /ev_er and /ev_er."
            ],
            [
                "O thou e_ne_my, thy des_truc_tions are come to a per_/pe_tu_al /end;",
                "e_ven as the ci_ties which thou hast des_troyed, whose me_mor_i_al is /per_ished with /them."
            ],
            [
                "But the LORD shall en_/dure for /ev_er;",
                "he hath al_so pre_pared his /seat for /judg_ment."
            ],
            [
                "For he shall judge the /world in /right_eous_ness,",
                "and mi_ni_ster true judg_ment /un_to the /peo_ple."
            ],
            [
                "The LORD al_so will be a de_fence /for the op_/pressed,",
                "e_ven a re_fuge in due /time of /trou_ble."
            ],
            [
                "And they that know thy Name will /put their /trust in thee;",
                "for thou, LORD, hast nev_er failed /them that /seek thee."
            ],
            [
                "O praise the LORD which /dwell_eth in /Si_on;",
                "show the peo_ple /of his /do_ings."
            ],
            [
                "For when he mak_eth in_qui_si_tion for blood, he re_/mem_ber_eth /them,",
                "and for_gett_eth not the com_plaint /of the /poor."
            ],
            [
                "Have mer_cy up_on me, O LORD; con_si_der the trou_ble which I suf_fer of /them that /hate me,",
                "thou that lift_est me up /from the /gates of /death;"
            ],
            [
                "That I may show all thy prais_es with_in the gates of the /daugh_ter of /Si_on:",
                "I will re_joice in /thy sal_/va_tion."
            ],
            [
                "The heath_en are sunk down in the /pit that they /made;",
                "in the same net which they hid pri_vi_ly is /their foot /tak_en."
            ],
            [
                "The LORD is known to /ex_e_cute /judg_ment;",
                "the un_god_ly is trapped in the /work of his /own hands."
            ],
            [
                "The wick_ed shall be /turned to des_/truc_tion,",
                "and all the peo_ple /that for_/get God."
            ],
            [
                "For the poor shall not al_way /be for_/got_ten;",
                "the pa_tient a_bi_ding of the meek shall not /per_ish for /ev_er."
            ],
            [
                "Up, LORD, and let not man /have the /up_per /hand;",
                "let the heath_en be /judged in thy /sight."
            ],
            [
                "Put /them in /fear, O /LORD,",
                "that the heath_en may know them_/selves to /be but /men."
            ]
        ]
    },
    {
        id: "psalm10",
        lines: [
            [
                "WHY stand_est thou /so far /off, O LORD,",
                "and hid_est thy face in the need_ful /time of /trou_ble?"
            ],
            [
                "The un_god_ly, for his own lust, doth /per_se_/cute the /poor:",
                "let them be tak_en in the craf_ty wi_li_ness that /they have i_/ma_gined."
            ],
            [
                "For the un_god_ly hath made boast of his /own heart's de_/sire,",
                "and speak_eth good of the co_ve_tous, whom the /LORD ab_/horr_eth."
            ],
            [
                "The un_god_ly is so proud, that he /ca_reth /not for God,",
                "nei_ther is /God in /all his thoughts."
            ],
            [
                "His ways are /al_way /grie_vous;",
                "thy judg_ments are far a_bove out of his sight, and there_fore de_fieth he /all his /e_ne_mies."
            ],
            [
                "For he hath said in his heart, Tush, I shall /nev_er be /cast /down,",
                "there shall no harm /hap_pen /un_to /me."
            ],
            [
                "His mouth is full of /cur_sing, de_/ceit, and /fraud;",
                "un_der his tongue is un_god_li_ness /and /va_ni_/ty."
            ],
            [
                "He sitt_eth lur_king in the thiev_ish /cor_ners /of the /streets,",
                "and pri_vi_ly in his lur_king dens doth he mur_der the in_no_cent; his eyes are /set a_/gainst the /poor."
            ],
            [
                "For he li_eth wait_ing se_cret_ly; e_ven as a li_on lurk_eth /he in his /den,",
                "that he may /ra_vish the /poor."
            ],
            [
                "He doth /ra_vish the /poor,",
                "when he gett_eth him /in_to his /net."
            ],
            [
                "He fall_eth down, and /humb_leth him_/self,",
                "that the con_gre_ga_tion of the poor may fall in_to the /hands of his /cap_tains."
            ],
            [
                "He hath said in his heart, Tush, God /hath for_/got_ten;",
                "he hid_eth a_way his face, and he will /nev_er /see it."
            ],
            [
                "A_rise, O LORD God, and /lift up thine /hand;",
                "for_get /not the poor."
            ],
            [
                "Where_fore should the /wick_ed blas_/pheme /God,",
                "while he doth say in his heart, Tush, thou God /car_est /not for it?"
            ],
            [
                "Sure_ly /thou hast /seen it;",
                "for thou be_hold_est un_god_li_ness and wrong, that thou may_est take the /mat_ter in_to /thy hand."
            ],
            [
                "The poor com_mitt_eth him_/self un_to /thee;",
                "for thou art the hel_per /of the /friend_less."
            ],
            [
                "Break thou the pow_er of the un_god_ly /and ma_/li_cious;",
                "search out his un_god_li_ness, un_/til thou /find /none."
            ],
            [
                "The LORD is King for /ev_er and /ev_er,",
                "and the heath_en are per_ished /out of the /land."
            ],
            [
                "LORD, thou hast heard the de_/sire of the /poor;",
                "thou pre_par_est their heart, and /thine ear /hear_ken_eth;"
            ],
            [
                "To help the fa_ther_less and poor /un_to their /right,",
                "that the man of the earth be no more ex_/al_ted a_/gainst them."
            ]
        ]
    },
    {
        id: "psalm11",
        lines: [
            [
                "IN the LORD /put I my /trust;",
                "how say ye then to my soul, that she should flee as a /bird /un_to the /hill?"
            ],
            [
                "For lo, the un_god_ly bend their bow, and make rea_dy their arr_ows with_/in the /qui_ver,",
                "that they may pri_vi_ly shoot at them /which are /true of heart."
            ],
            [
                "If the found_/a_tions /be des_/troyed,",
                "what /can the /right_eous do?"
            ],
            [
                "The LORD is in his /ho_ly /tem_ple;",
                "the LORD'S /seat is in /hea_ven."
            ],
            [
                "His eyes con_/si_der the /poor,",
                "and his eye_lids try the /child_ren of /men."
            ],
            [
                "The LORD app_/ro_veth the /right_eous:",
                "but the un_god_ly, and him that de_light_eth in wick_ed_ness, /doth his /soul ab_/hor."
            ],
            [
                "Up_on the un_god_ly he shall rain snares, fire and brim_stone, /storm and /tem_pest:",
                "this shall be their /por_tion to /drink."
            ],
            [
                "For the right_eous LORD /lov_eth /right_eous_ness;",
                "his coun_te_nance will be_hold the /thing that is /just."
            ]
        ]
    },
    {
        id: "psalm12",
        lines: [
            [
                "HELP me, LORD, for there is not one /god_ly man /left;",
                "for the faith_ful are min_ished from a_mong the /child_ren of /men."
            ],
            [
                "They talk of va_ni_ty eve_ry /one with his /neigh_bour;",
                "they do but flat_ter with their lips, and diss_em_ble /in their /dou_ble /heart."
            ],
            [
                "The LORD shall root out /all de_/ceit_ful /lips,",
                "and the tongue that /speak_eth /proud things;"
            ],
            [
                "Which have said, With our /tongue will /we pre_/vail;",
                "we are they that ought to speak; /who is lord /o_ver /us?"
            ],
            [
                "Now, for the com_fort_less trou_bles' /sake of the /nee_dy,",
                "and be_cause of the deep /sigh_ing of the /poor,"
            ],
            [
                "I will /up, saith the /LORD;",
                "and will help eve_ry one from him that swell_eth a_gainst him, and will /set him at /rest."
            ],
            [
                "The words of the /LORD are /pure words;",
                "e_ven as the sil_ver which from the earth is tried, and pu_ri_fied se_ven /times in the /fire."
            ],
            [
                "Thou shalt /keep them, O /LORD;",
                "thou shalt pre_serve them from this ge_ne_/ra_tion for /ev_er."
            ],
            [
                "The un_god_ly /walk on /eve_ry side:",
                "when they are ex_al_ted, the child_ren of men are /put to re_/buke."
            ]
        ]
    },
    {
        id: "psalm13",
        lines: [
            [
                "HOW long wilt thou for_get me, O /LORD; for /ev_er?",
                "how long wilt thou /hide thy /face from me?"
            ],
            [
                "How long shall I seek coun_sel in my soul, and be so /vexed in my /heart?",
                "how long shall mine e_ne_my /tri_umph /o_ver me?"
            ],
            [
                "Con_si_der, and /hear me, O /LORD my God;",
                "light_en mine eyes, that I /sleep /not in /death;"
            ],
            [
                "Lest mine e_ne_my say, I have pre_/vailed a_/gainst him:",
                "for if I be cast down, they that trou_ble me /will re_/joice at it."
            ],
            [
                "But my trust is /in thy /mer_cy,",
                "and my heart is joy_ful in /thy sal_/va_tion."
            ],
            [
                "I will sing of the LORD, be_cause he hath dealt so /lov_ing_ly /with me;",
                "yea, I will praise the Name of the /Lord Most /High_est."
            ]
        ]
    },
    {
        id: "psalm14",
        lines: [
            [
                "THE fool hath /said in his /heart,",
                "/There is /no God."
            ],
            [
                "They are cor_rupt, and be_come a_bom_in_a_ble /in their /do_ings;",
                "there is none that do_eth /good, no not /one."
            ],
            [
                "The LORD looked down from hea_ven up_on the /child_ren of /men,",
                "to see if there were an_y that would un_der_stand, and /seek af_ter /God."
            ],
            [
                "But they are all gone out of the way, they are al_to_ge_ther be_come a_/bom_in_a_/ble;",
                "there is none that do_eth /good, no not /one."
            ],
            [
                "Have they no know_ledge, that they are all such /wor_kers of /mis_chief,",
                "ea_ting up my peo_ple as it were bread, and call /not up_/on the LORD?"
            ],
            [
                "There were they brought in great fear, e_ven /where no /fear /was;",
                "for God is in the ge_ne_ra_tion /of the /right_eous."
            ],
            [
                "As for you, ye have made a mock at the /coun_sel /of the poor;",
                "be_cause he putt_eth his /trust in the /LORD."
            ],
            [
                "Who shall give sal_va_tion un_to Is_ra_el /out of /Si_on?",
                "When the LORD tur_neth the cap_ti_vi_ty of his peo_ple, then shall Ja_cob re_joice, and /Is_ra_el /shall be /glad."
            ]
        ]
    },
    {
        id: "psalm15",
        lines: [
            [
                "LORD, who shall dwell in thy /tab_er_/na_cle?",
                "or who shall rest up_/on thy /ho_ly /hill?"
            ],
            [
                "E_ven he that lead_eth an /un_corr_upt /life,",
                "and do_eth the thing which is right, and speak_eth the /truth /from his /heart."
            ],
            [
                "He that hath used no de_ceit in his tongue, nor done e_vil /to his /neigh_bour,",
                "and hath not /slan_dered his /neigh_bour."
            ],
            [
                "He that set_teth not by him_self, but is low_ly /in his /own eyes,",
                "and mak_eth much of /them that /fear the LORD."
            ],
            [
                "He that swear_eth un_to his neigh_bour, and dis_ap_/poin_teth him /not,",
                "though it were to /his own /hind_rance."
            ],
            [
                "He that hath not gi_ven his mo_ney up_/on /us_u_ry,",
                "nor tak_en re_ward a_/gainst the /in_no_cent."
            ],
            [
                "Who_so /do_eth these /things",
                "shall /nev_er fall."
            ]
        ]
    },
    {
        id: "psalm16",
        lines: [
            [
                "PRE_/SERVE me, O /God;",
                "for in /thee have I /put my trust."
            ],
            [
                "O my soul, thou hast said /un_to the /LORD,",
                "Thou art my God; I have no good /like /un_to /thee."
            ],
            [
                "All my de_light is up_on the /saints that are /in the /earth,",
                "and up_on such as ex_/cel in /vir_tue."
            ],
            [
                "But they that run /af_ter a_/no_ther god",
                "shall /have great /trou_ble."
            ],
            [
                "Their drink-_off_er_ings of blood will /I not /off_er,",
                "nei_ther make men_tion of their /names with_/in my /lips."
            ],
            [
                "The LORD him_self is the por_tion of mine in_he_ri_tance, /and of my /cup;",
                "/thou shalt main_/tain my /lot."
            ],
            [
                "The lot is fall_en un_to me /in a /fair /ground;",
                "yea, I have a /good_ly /he_ri_tage."
            ],
            [
                "I will thank the LORD for /gi_ving me /war_ning;",
                "my reins al_so chas_ten /me in the /night /sea_son."
            ],
            [
                "I have set the LORD /al_way be_/fore me;",
                "for he is on my right hand, /there_fore I /shall not /fall."
            ],
            [
                "Where_fore my heart is glad, and my /glo_ry re_/joic_eth:",
                "my flesh /al_so shall /rest in hope."
            ],
            [
                "For why? thou shalt not /leave my /soul in /hell;",
                "nei_ther shalt thou suf_fer thy Ho_ly One to /see cor_/rup_tion."
            ],
            [
                "Thou shalt show me the path of life: in thy pres_ence is the /ful_ness of /joy,",
                "and at thy right hand there is /plea_sure for /ev_er_/more."
            ]
        ]
    },
    {
        id: "psalm17",
        lines: [
            [
                "HEAR the right, O LORD, con_/si_der my /com_/plaint,",
                "and hear_ken un_to my prayer, that go_eth not /out of /feigned lips."
            ],
            [
                "Let my sen_tence come forth /from thy /pres_ence;",
                "and let thine eyes look up_on the /thing that is /e_qual."
            ],
            [
                "Thou hast proved and vis_it_ed mine heart in the night sea_son; thou hast tried me, and shalt find no /wick_ed_ness in /me;",
                "for I am utt_er_ly pur_posed that my /mouth shall /not off_/end."
            ],
            [
                "As /for the /works of /men,",
                "by the word of thy lips I have kept me from the ways of /the des_/troy_er."
            ],
            [
                "O hold thou up my /go_ings /in thy paths,",
                "that my /foot_steps /slip not."
            ],
            [
                "I have called up_on thee, O God, for /thou shalt /hear me:",
                "in_cline thine ear to me, and hear_ken /un_to my /words."
            ],
            [
                "Show thy mar_vell_ous lov_ing-_kind_ness, thou that art the Sav_iour of them which /put their /trust in /thee,",
                "from such as res_/ist thy right /hand."
            ],
            [
                "Keep me as the /ap_ple of an /eye;",
                "hide me un_der the /sha_dow of /thy /wings,"
            ],
            [
                "From the un_/god_ly, that /trou_ble me;",
                "mine e_ne_mies com_pass me round a_bout, to /take a_/way my /soul."
            ],
            [
                "They are in_closed /in their /own fat,",
                "and their mouth /speak_eth proud /things."
            ],
            [
                "They lie wait_ing in our /way on /eve_ry /side,",
                "watch_ing to cast us /down to the /ground;"
            ],
            [
                "Like as a li_on that is /gree_dy of /his prey,",
                "and as it were a li_on's whelp lur_king in /sec_ret /pla_ces."
            ],
            [
                "Up, LORD, dis_ap_/point him, and /cast him down;",
                "de_li_ver my soul from the un_god_ly, /by thine /own /sword;"
            ],
            [
                "Yea, by thy hand, O LORD; from the /men of the /e_vil world;",
                "which have their por_tion in this life, whose bell_ies thou fill_est /with thy hid /trea_sure."
            ],
            [
                "They have child_ren /at their de_/sire,",
                "and leave the rest of their /sub_stance /for their /babes."
            ],
            [
                "But as for me, I shall be_hold thy /pres_ence in /right_eous_ness;",
                "and when I a_wake up af_ter thy like_ness, I /shall be /sa_tis_fied."
            ]
        ]
    },
    {
        id: "psalm18",
        lines: [
            [
                "I WILL love /thee, O /LORD, my /strength.",
                "The LORD is my sto_ny /rock, and /my de_/fence;"
            ],
            [
                "My Sav_iour, my God, and my might, in /whom I will /trust;",
                "my buck_ler, the horn al_so of my sal_va_tion, /and my /re_fuge."
            ],
            [
                "I will call up_on the LORD, which is /wor_thy /to be /praised;",
                "so shall I be /safe from mine /e_ne_mies."
            ],
            [
                "The sor_rows of /death com_passed /me,",
                "and the o_ver_flow_ings of un_god_li_ness /made me a_/fraid."
            ],
            [
                "The pains of hell /came a_/bout me;",
                "the snares of death /o_ver_/took me."
            ],
            [
                "In my trou_ble I /called up_/on the /LORD,",
                "and com_plained /un_to my /God:"
            ],
            [
                "So he heard my voice out of his /ho_ly /tem_ple,",
                "and my com_plaint came be_fore him; it en_tered e_ven /in_to his /ears."
            ],
            [
                "The earth /trem_bled and /quaked,",
                "the ve_ry found_a_tions al_so of the hills shook, and were re_moved, be_/cause he /was /wroth."
            ],
            [
                "There went a smoke out /in his /pres_ence,",
                "and a con_su_ming fire out of his mouth, so that coals were /kin_dled at /it."
            ],
            [
                "He bowed the hea_vens /al_so, and /came /down,",
                "and it was dark /un_der his /feet."
            ],
            [
                "He rode up_on the /Che_ru_bim, /and did /fly;",
                "he came fly_ing up_on the /wings of the /wind."
            ],
            [
                "He made /dark_ness his /sec_ret /place,",
                "his pa_vil_ion round a_bout him with dark wa_ter, and thick /clouds to /co_ver him."
            ],
            [
                "At the bright_ness of his /pres_ence his /clouds re_/moved;",
                "/hail_stones and /coals of /fire."
            ],
            [
                "The LORD al_so thun_dered out of hea_ven, and the High_est /gave his /thun_der;",
                "/hail_stones and /coals of /fire."
            ],
            [
                "He sent out his /arr_ows, and /scat_tered /them;",
                "he cast forth light_nings, /and des_/troyed them."
            ],
            [
                "The springs of wa_ters were seen, and the found_a_tions of the round world /were dis_/co_vered,",
                "at thy chid_ing, O LORD, at the blast_ing of the breath of /thy dis_/plea_sure."
            ],
            [
                "He sent down from on /high to /fetch me,",
                "and took me out of /ma_ny /wa_ters."
            ],
            [
                "He de_li_vered me from my strong_est e_ne_my, and from /them which /hate me;",
                "for they were too /migh_ty for /me."
            ],
            [
                "They came up_on me in the /day of my /trou_ble;",
                "but the LORD was /my up_/hold_er."
            ],
            [
                "He brought me forth al_so in_to a /place of /li_ber_ty;",
                "he brought me forth, e_ven be_cause he had a /fa_vour /un_to /me."
            ],
            [
                "The LORD re_war_ded me af_ter my /right_eous /deal_ing,",
                "ac_cor_ding to the clean_ness of my hands did he /re_com_pense /me."
            ],
            [
                "Be_cause I have kept the /ways of the /LORD,",
                "and have not for_sa_ken my /God, as the /wick_ed doth."
            ],
            [
                "For I have an eye /un_to all his /laws,",
                "and will not cast out his com_/mand_ments from /me."
            ],
            [
                "I was al_so un_corr_/upt be_/fore him,",
                "and es_chewed /mine own /wick_ed_ness."
            ],
            [
                "There_fore the LORD re_war_ded me af_ter my /right_eous /deal_ing,",
                "and ac_cor_ding un_to the clean_ness of my hands /in his /eye_sight."
            ],
            [
                "With the ho_ly thou /shalt be /ho_ly,",
                "and with a per_fect man thou /shalt be /per_fect."
            ],
            [
                "With the /clean thou /shalt be /clean,",
                "and with the fro_ward thou /shalt be /fro_ward."
            ],
            [
                "For thou shalt save the peo_ple that are /in ad_/ver_si_ty,",
                "and shalt bring down the high /looks of the /proud."
            ],
            [
                "Thou al_so shalt /light my /can_dle;",
                "the LORD my God shall make my /dark_ness /to be /light."
            ],
            [
                "For in thee I shall dis_/com_fit an /host of /men,",
                "and with the help of my God I shall leap /o_ver the /wall."
            ],
            [
                "The way of God is an /un_de_/filed way:",
                "the word of the LORD al_so is tried in the fire; he is the de_fen_der of all them that /put their /trust in /him."
            ],
            [
                "For who is /God, but the /LORD?",
                "or who hath an_y /strength, ex_/cept our /God?"
            ],
            [
                "It is God that gird_eth /me with /strength of /war,",
                "and mak_eth /my way /per_fect."
            ],
            [
                "He mak_eth my /feet like /harts' feet,",
                "and set_teth /me up on /high."
            ],
            [
                "He /teach_eth mine /hands to /fight,",
                "and mine arms shall bend /e_ven a /bow of /steel."
            ],
            [
                "Thou hast gi_ven me the de_fence of /thy sal_/va_tion;",
                "thy right hand al_so shall hold me up, and thy lov_ing cor_/rec_tion shall /make me /great."
            ],
            [
                "Thou shalt make room en_ough un_der /me /for to /go,",
                "that my /foot_steps /shall not /slide."
            ],
            [
                "I will fol_low up_on mine e_ne_mies, and /o_ver_/take them;",
                "nei_ther will I turn a_gain till I /have des_/troyed them."
            ],
            [
                "I will smite them, that they shall not be /a_ble to /stand,",
                "but fall /un_der my /feet."
            ],
            [
                "Thou hast gir_ded me with strength /un_to the /bat_tle;",
                "thou shalt throw down mine /e_ne_mies /un_der me."
            ],
            [
                "Thou hast made mine e_ne_mies al_so to turn their /backs up_/on me,",
                "and I shall des_troy /them that /hate me."
            ],
            [
                "They shall cry, but there shall be /none to /help them;",
                "yea, e_ven un_to the LORD shall they cry, but he /shall not /hear them."
            ],
            [
                "I will beat them as small as the /dust be_/fore the /wind:",
                "I will cast them out as the /clay in the /streets."
            ],
            [
                "Thou shalt de_li_ver me from the striv_ings /of the /peo_ple,",
                "and thou shalt make me the head of the na_tions; a peo_ple whom I have not /known shall /serve me."
            ],
            [
                "As soon as they hear of me, they /shall o_/bey me;",
                "the stran_gers shall feign o_/be_di_ence /un_to me."
            ],
            [
                "The /stran_gers /shall /fail,",
                "and come trem_bling /out of their /strong_holds."
            ],
            [
                "The LORD liv_eth; and bless_ed /be my strong /hel_per,",
                "and praised be the God of /my sal_/va_tion;"
            ],
            [
                "E_ven the God that seeth that /I be a_/venged,",
                "and sub_du_eth the /peo_ple /un_to me."
            ],
            [
                "It is he that de_li_ver_eth me from my cru_el e_ne_mies, and set_teth me up a_bove /mine ad_/ver_sa_ries:",
                "thou shalt rid me /from the /wick_ed man."
            ],
            [
                "For this cause will I give thanks un_to thee, O LORD, a_/mong the /Gen_tiles,",
                "and sing prais_es /un_to thy /Name."
            ],
            [
                "Great pros_pe_ri_ty gi_veth he /un_to his /King,",
                "and show_eth lov_ing-_kind_ness un_to Da_vid his a_noin_ted, and un_to his /seed for /ev_er_more."
            ]
        ]
    },
    {
        id: "psalm19",
        lines: [
            [
                "THE hea_vens de_clare the /glo_ry of /God;",
                "and the fir_ma_ment /show_eth his /han_dy-_work."
            ],
            [
                "One day /tell_eth a_/no_ther;",
                "and one night cer_ti_/fi_eth a_/no_ther."
            ],
            [
                "There is nei_ther /speech nor /lang_uage;",
                "but their voi_ces are /heard a_/mong them."
            ],
            [
                "Their sound is gone out /in_to all /lands;",
                "and their words in_to the /ends of the /world."
            ],
            [
                "In them hath he set a tab_er_/na_cle /for the /sun;",
                "which com_eth forth as a bride_groom out of his cham_ber, and re_joic_eth as a /gi_ant to /run his /course."
            ],
            [
                "It go_eth forth from the ut_ter_most part of the hea_ven, and runn_eth a_bout un_to the /end of /it a_/gain;",
                "and there is noth_ing /hid from the /heat there_of."
            ],
            [
                "The law of the LORD is an un_de_filed law, con_/ver_ting the /soul;",
                "the tes_ti_mo_ny of the LORD is sure, and gi_veth wis_dom /un_to the /sim_ple."
            ],
            [
                "The stat_utes of the LORD are /right, and re_/joice the /heart;",
                "the com_mand_ment of the LORD is pure, and gi_veth /light un_/to the /eyes."
            ],
            [
                "The fear of the LORD is clean, and en_/dur_eth for /ev_er;",
                "the judg_ments of the LORD are true, and right_eous /al_to_/ge_ther."
            ],
            [
                "More to be de_sired are they than gold, /yea, than /much fine /gold;",
                "swee_ter al_so than hon_ey, /and the /hon_ey_comb."
            ],
            [
                "More_ov_er, by them /is thy /ser_vant /taught;",
                "and in keep_ing of them /there is /great re_ward."
            ],
            [
                "Who can tell how oft /he off_/end_eth?",
                "O cleanse thou me /from my /sec_ret /faults."
            ],
            [
                "Keep thy ser_vant al_so from pre_sump_tu_ous sins, lest they get the do_/min_ion /o_ver me;",
                "so shall I be un_de_filed, and in_no_cent /from the /great of_/fence."
            ],
            [
                "Let the words of my mouth, and the me_di_ta_tion of my heart, be al_way ac_/cep_ta_ble /in thy /sight,",
                "O LORD, my strength and /my re_/dee_mer."
            ]
        ]
    },
    {
        id: "psalm20",
        lines: [
            [
                "THE LORD hear thee in the /day of /trou_ble;",
                "the Name of the God of /Ja_cob de_/fend thee:"
            ],
            [
                "Send thee help from the /sanc_tu_/a_ry,",
                "and strength_en thee /out of /Si_on:"
            ],
            [
                "Re_mem_ber /all thy /of_fer_ings,",
                "and ac_cept /thy burnt-_/sac_ri_fice:"
            ],
            [
                "Grant /thee thy /heart's de_/sire,",
                "and ful_/fil all thy /mind."
            ],
            [
                "We will re_joice in thy sal_va_tion, and tri_umph in the /Name of the /Lord our God:",
                "the LORD per_form all /thy pe_/ti_tions."
            ],
            [
                "Now know I that the LORD help_eth his a_noin_ted, and will hear him from his /ho_ly /hea_ven,",
                "e_ven with the whole_some /strength of his /right hand."
            ],
            [
                "Some put their trust in cha_ri_ots, and /some in /hor_ses;",
                "but we will re_mem_ber the /Name of the /LORD our God."
            ],
            [
                "They are brought /down and /fall_en;",
                "but we are ri_sen /and stand /up_right."
            ],
            [
                "Save, LORD; and hear us, O /King of /hea_ven,",
                "when we /call up_/on thee."
            ]
        ]
    },
    {
        id: "psalm21",
        lines: [
            [
                "THE King shall re_joice in /thy strength, O /LORD;",
                "ex_ceed_ing glad shall he be of /thy sal_/va_tion."
            ],
            [
                "Thou hast gi_ven /him his /heart's de_/sire,",
                "and hast not de_nied him the re_/quest of his /lips."
            ],
            [
                "For thou shalt meet him with the /bless_ings of /good_ness,",
                "and shalt set a crown of pure /gold up_/on his head."
            ],
            [
                "He asked life of thee; and thou gav_est /him a /long life,",
                "e_ven for /ev_er and /ev_er."
            ],
            [
                "His ho_nour is great in /thy sal_/va_tion;",
                "glo_ry and great wor_ship shalt thou /lay up_/on him."
            ],
            [
                "For thou shalt give him ev_er_/last_ing fe_/li_ci_ty,",
                "and make him glad with the /joy of thy /coun_te_nance."
            ],
            [
                "And why? be_cause the King putt_eth his /trust in the /LORD;",
                "and in the mer_cy of the Most High_est he shall /not mis_/car_ry."
            ],
            [
                "All thine e_ne_mies /shall feel thine /hand;",
                "thy right hand shall find out /them that /hate thee."
            ],
            [
                "Thou shalt make them like a fie_ry ov_en in /time of thy /wrath:",
                "the LORD shall des_troy them in his dis_plea_sure, and the fire /shall con_/sume them."
            ],
            [
                "Their fruit shalt thou root /out of the /earth,",
                "and their seed from a_mong the /child_ren of /men."
            ],
            [
                "For they in_ten_ded /mis_chief a_/gainst thee,",
                "and i_ma_gined such a de_vice as they are not /a_ble /to per_/form."
            ],
            [
                "There_fore shalt thou /put /them to /flight,",
                "and the strings of thy bow shalt thou make rea_dy a_/gainst the /face of them."
            ],
            [
                "Be thou ex_al_ted, /LORD, in thine /own /strength;",
                "so will we sing, and /praise thy /pow_er."
            ]
        ]
    },
    {
        id: "psalm22",
        lines: [
            [
                "MY God, my God, look up_on me; why hast /thou for_/sa_ken me?",
                "and art so far from my health, and from the /words of /my com_/plaint?"
            ],
            [
                "O my God, I cry in the day-_time, /but thou /hear_est /not;",
                "and in the night sea_son /al_so I /take no /rest."
            ],
            [
                "And thou con_/ti_nu_est /ho_ly,",
                "O thou /Wor_ship of /Is_ra_el."
            ],
            [
                "Our /fa_thers /hoped in /thee;",
                "they trust_ed in thee, and thou /didst de_/li_ver them."
            ],
            [
                "They called up_on thee, /and were /hol_pen;",
                "they put their trust in thee, and were /not con_/foun_ded."
            ],
            [
                "But as for me, I am a /worm, and /no /man;",
                "a ve_ry scorn of men, and the out_cast /of the /peo_ple."
            ],
            [
                "All they that see me /laugh me to /scorn;",
                "they shoot out their lips, and /shake their /heads, say_ing,"
            ],
            [
                "He trust_ed in the LORD, that he /would de_/li_ver him;",
                "let him de_li_ver him, /if he will /have him."
            ],
            [
                "But thou art he that took me /out of my /mo_ther's /womb;",
                "thou wast my hope, when I hanged yet up_/on my /mo_ther's /breasts."
            ],
            [
                "I have been left un_to thee ev_er /since /I was /born;",
                "thou art my God e_ven /from my /mo_ther's /womb."
            ],
            [
                "O go not from me; for /trou_ble is /hard at /hand,",
                "and there is /none to /help me."
            ],
            [
                "Ma_ny ox_en are /come a_/bout me;",
                "fat bulls of Ba_shan close me /in on /eve_ry /side."
            ],
            [
                "They gape up_/on me /with their /mouths,",
                "as it were a ramp_ing and a /roar_ing /li_on."
            ],
            [
                "I am poured out like wa_ter, and all my /bones are /out of /joint;",
                "my heart al_so in the midst of my bo_dy is e_ven /like /mel_ting /wax."
            ],
            [
                "My strength is dried up like a pot_sherd, and my tongue /cleav_eth /to my /gums,",
                "and thou bring_est me /in_to the /dust of /death."
            ],
            [
                "For ma_ny dogs are /come a_/bout me,",
                "and the coun_cil of the wick_ed lay_eth /siege a_/gainst /me."
            ],
            [
                "They pierced my hands and my feet: I may /tell all my /bones:",
                "they stand star_ing and /look_ing up_/on me."
            ],
            [
                "They part my /gar_ments a_/mong them,",
                "and cast lots up_/on my /ves_ture."
            ],
            [
                "But be not thou far /from me, /O /LORD;",
                "thou art my suc_cour, haste /thee to /help me."
            ],
            [
                "De_li_ver my /soul from the /sword,",
                "my dar_ling from the /pow_er of /the /dog."
            ],
            [
                "Save me /from the /li_on's /mouth;",
                "thou hast heard me al_so from a_mong the /horns of the /u_ni_corns."
            ],
            [
                "I will de_clare thy Name /un_to my /breth_ren;",
                "in the midst of the con_gre_ga_tion /will I /praise /thee."
            ],
            [
                "O praise the LORD, /ye that /fear him:",
                "mag_ni_fy him, all ye of the seed of Ja_cob; and fear him, all ye /seed of /Is_ra_el."
            ],
            [
                "For he hath not desp_ised nor ab_horred the low es_/tate of the /poor;",
                "he hath not hid his face from him; but when he called un_to /him he /heard him."
            ],
            [
                "My praise is of thee in the great /con_gre_/ga_tion;",
                "my vows will I per_form in the sight of /them that /fear him."
            ],
            [
                "The poor shall eat, and be sa_tis_fied; they that seek af_ter the /LORD shall /praise him:",
                "your heart shall /live for /ev_er."
            ],
            [
                "All the ends of the world shall re_mem_ber them_selves, and be turned /un_to the /LORD;",
                "and all the kind_reds of the na_tions shall /wor_ship be_/fore him."
            ],
            [
                "For the /king_dom /is the /LORD'S,",
                "and he is the Go_ver_nor a_/mong the /na_tions."
            ],
            [
                "All such as be /fat up_/on /earth",
                "have /eat_en, and /wor_shipped."
            ],
            [
                "All they that go down in_to the dust shall /kneel be_/fore /him;",
                "and no man hath /quick_ened his /own /soul."
            ],
            [
                "My /seed shall /serve him:",
                "they shall be coun_ted un_to the Lord for a /ge_ne_/ra_tion."
            ],
            [
                "They shall come, and shall de_/clare his /right_eous_ness",
                "un_to a peo_ple that shall be born, /whom the /Lord hath /made."
            ]
        ]
    },
    {
        id: "psalm23",
        lines: [
            [
                "THE /LORD is my /shep_herd;",
                "there_fore /can I lack /noth_ing."
            ],
            [
                "He shall feed me /in a green /pas_ture,",
                "and lead me forth be_side the /wa_ters of /com_fort."
            ],
            [
                "He /shall con_/vert my /soul,",
                "and bring me forth in the paths of right_eous_ness /for his /Name's /sake."
            ],
            [
                "Yea, though I walk through the val_ley of the sha_dow of death, I will /fear no /e_vil;",
                "for thou art with me; thy rod and thy /staff /com_fort me."
            ],
            [
                "Thou shalt pre_pare a ta_ble be_fore me in the pres_ence of /them that /trou_ble me;",
                "thou hast a_noin_ted my head with oil, and my /cup /shall be /full."
            ],
            [
                "Sure_ly thy lov_ing-_kind_ness and mer_cy shall fol_low me all the /days /of my /life;",
                "and I will dwell in the house of the /LORD for /ev_er."
            ]
        ]
    },
    {
        id: "psalm24",
        lines: [
            [
                "THE earth is the LORD'S, and /all that /there_in /is;",
                "the com_pass of the world, and /they that /dwell there_/in."
            ],
            [
                "For he hath foun_ded /it up_/on the /seas,",
                "and stab_lished /it up_/on the /floods."
            ],
            [
                "Who shall asc_end in_to the /hill of the /LORD?",
                "or who shall rise up /in his /ho_ly /place?"
            ],
            [
                "E_ven he that hath clean hands, /and a /pure /heart;",
                "and that hath not lift up his mind un_to va_ni_ty, nor sworn to de_/ceive his /neigh_bour."
            ],
            [
                "He shall re_ceive the /bless_ing /from the /LORD,",
                "and right_eous_ness from the God of /his sal_/va_tion."
            ],
            [
                "This is the ge_ne_ra_tion of /them that /seek him;",
                "e_ven of them that seek thy face, O /God of /Ja_cob."
            ],
            [
                "Lift up your heads, O ye gates; and be ye lift up, ye /ev_er_/last_ing /doors;",
                "and the King of /glo_ry /shall come /in."
            ],
            [
                "Who is this /King of /glo_ry?",
                "It is the LORD strong and migh_ty, e_ven the LORD /migh_ty in /bat_tle."
            ],
            [
                "Lift up your heads, O ye gates; and be ye lift up, ye /ev_er_/last_ing /doors;",
                "and the King of /glo_ry /shall come /in."
            ],
            [
                "Who is this /King of /glo_ry?",
                "E_ven the LORD of hosts, he is the /King of /glo_ry."
            ]
        ]
    },
    {
        id: "psalm25",
        lines: [
            [
                "UN_TO thee, O LORD, will I lift up my soul; my God, I have /put my /trust in /thee:",
                "O let me not be con_foun_ded, nei_ther let mine e_ne_mies /tri_umph /o_ver /me."
            ],
            [
                "For all they that hope in thee /shall not /be a_/shamed;",
                "but such as trans_gress with_out a cause shall be /put to con_/fu_sion."
            ],
            [
                "/Show me thy /ways, O /LORD,",
                "and /teach me thy /paths."
            ],
            [
                "Lead me forth in thy /truth, and /learn me:",
                "for thou art the God of my sal_va_tion; in thee hath been my /hope all the /day /long."
            ],
            [
                "Call to re_mem_brance, O LORD, thy /ten_der /mer_cies,",
                "and thy lov_ing-_kind_ness_es, which have been /ev_er of /old."
            ],
            [
                "O re_mem_ber not the sins and off_/en_ces of my /youth;",
                "but ac_cor_ding to thy mer_cy think thou up_on me, O /LORD, for thy /good_ness."
            ],
            [
                "Gra_cious and /right_eous /is the /LORD;",
                "there_fore, will he teach /sin_ners /in the /way."
            ],
            [
                "Them that are meek shall he /guide in /judg_ment;",
                "and such as are gen_tle, /them shall he /learn his /way."
            ],
            [
                "All the paths of the LORD are /mer_cy and /truth,",
                "un_to such as keep his co_ve_nant and his /tes_ti_/mon_ies."
            ],
            [
                "For thy /Name's /sake, O /LORD,",
                "be mer_ci_ful un_to my sin; /for it is /great."
            ],
            [
                "What man is he that /fear_eth the /LORD?",
                "him shall he teach in the /way that /he shall /choose."
            ],
            [
                "His /soul shall /dwell at /ease,",
                "and his seed shall in_/he_rit the /land."
            ],
            [
                "The sec_ret of the LORD is a_mong /them that /fear him;",
                "and he will /show them his /co_ve_nant."
            ],
            [
                "Mine eyes are ev_er look_ing /un_to the /LORD;",
                "for he shall pluck my feet /out of the /net."
            ],
            [
                "Turn thee un_to me, and have /mer_cy up_/on me;",
                "for I am de_so_late, /and in /mi_se_ry."
            ],
            [
                "The sor_rows of my /heart are en_/larged:",
                "O bring thou me /out of my /trou_bles."
            ],
            [
                "Look up_on my ad_ver_si_ty /and /mi_se_ry,",
                "and for_/give me /all my /sin."
            ],
            [
                "Con_si_der mine e_ne_mies, how /ma_ny they /are;",
                "and they bear a ty_ran_nous /hate a_/gainst me."
            ],
            [
                "O keep my /soul, and de_/li_ver /me:",
                "let me not be con_foun_ded, for I have /put my /trust in /thee."
            ],
            [
                "Let per_fect_ness and right_eous deal_ing /wait up_/on me;",
                "for my /hope hath /been in /thee."
            ],
            [
                "De_li_ver /Is_ra_el, /O /God,",
                "out of /all his /trou_bles."
            ]
        ]
    },
    {
        id: "psalm26",
        lines: [
            [
                "BE thou my Judge, O LORD, for I have /walked /in_no_cent_ly:",
                "my trust hath been al_so in the LORD, there_fore /shall I /not /fall."
            ],
            [
                "Ex_am_ine me, O /LORD, and /prove me;",
                "try out my /reins /and my /heart."
            ],
            [
                "For thy lov_ing-_kind_ness is /ev_er be_/fore mine /eyes;",
                "and I will /walk in thy /truth."
            ],
            [
                "I have not /dwelt with /vain /per_sons;",
                "nei_ther will I have fel_low_ship with /the de_/ceit_ful."
            ],
            [
                "I have hat_ed the con_gre_ga_tion /of the /wick_ed;",
                "and will not sit a_mong /the un_/god_ly."
            ],
            [
                "I will wash my hands in /in_no_cen_/cy, O /LORD;",
                "and so will I /go to thine /al_tar;"
            ],
            [
                "That I may show the /voice of thanks_/giv_ing,",
                "and tell of /all thy /won_drous /works."
            ],
            [
                "LORD, I have loved the ha_bi_/ta_tion of /thy /house,",
                "and the place where thine /ho_nour /dwell_eth."
            ],
            [
                "O shut not up my soul /with the /sin_ners,",
                "nor my life /with the blood-_/thirs_ty;"
            ],
            [
                "In whose /hands is /wick_ed_ness,",
                "and their right /hand is /full of /gifts."
            ],
            [
                "But as for me, I will walk /in_no_cent_/ly:",
                "O de_li_ver me, and be /mer_ci_ful /un_to me."
            ],
            [
                "My /foot /stand_eth /right:",
                "I will praise the LORD in the /con_gre_/ga_tions."
            ]
        ]
    },
    {
        id: "psalm27",
        lines: [
            [
                "THE LORD is my light and my sal_va_tion; /whom then /shall I /fear?",
                "the LORD is the strength of my life; of whom then /shall I /be a_/fraid?"
            ],
            [
                "When the wick_ed, e_ven mine e_ne_mies and my foes, came up_on me to /eat up my /flesh,",
                "they /stum_bled and /fell."
            ],
            [
                "Though an host of men were laid a_gainst me, yet shall not my /heart be a_/fraid;",
                "and though there rose up war a_gainst me, yet will I /put my /trust in /him."
            ],
            [
                "One thing have I de_sired of the LORD, /which I /will re_/quire;",
                "e_ven that I may dwell in the house of the LORD all the days of my life, to be_hold the fair beau_ty of the LORD, and to /vis_it /his /tem_ple."
            ],
            [
                "For in the time of trou_ble he shall hide me in his /tab_er_/na_cle;",
                "yea, in the sec_ret place of his dwell_ing shall he hide me, and set me up up_/on a /rock of /stone."
            ],
            [
                "And now shall he /lift /up mine /head",
                "a_bove mine e_ne_mies /round a_/bout /me."
            ],
            [
                "There_fore will I off_er in his dwell_ing an ob_la_tion, /with great /glad_ness:",
                "I will sing and speak prais_es /un_/to the /LORD."
            ],
            [
                "Hear_ken un_to my voice, O LORD, when I /cry /un_to /thee;",
                "have mer_cy up_/on me, and /hear /me."
            ],
            [
                "My heart hath talked of thee, /Seek ye my /face:",
                "Thy /face, LORD, /will I /seek."
            ],
            [
                "O hide not /thou thy /face from /me,",
                "nor cast thy ser_vant a_way /in dis_/plea_sure."
            ],
            [
                "Thou hast /been my /suc_cour;",
                "leave me not, nei_ther for_sake me, O God of /my sal_/va_tion."
            ],
            [
                "When my fa_ther and my /mo_ther for_/sake me,",
                "the LORD /tak_eth me /up."
            ],
            [
                "/Teach me thy /way, O /LORD,",
                "and lead me in the right way, be_/cause of mine /e_ne_mies."
            ],
            [
                "De_li_ver me not o_ver in_to the will of mine /ad_ver_/sa_/ries:",
                "for there are false wit_ness_es ri_sen up a_gainst me, and /such /as speak /wrong."
            ],
            [
                "I should utt_er_/ly have /faint_ed,",
                "but that I be_lieve ve_ri_ly to see the good_ness of the LORD in the /land of the /li_ving."
            ],
            [
                "O tar_ry /thou the /LORD'S /lei_sure;",
                "be strong, and he shall com_fort thine heart; and put thou thy /trust in the /LORD."
            ]
        ]
    },
    {
        id: "psalm28",
        lines: [
            [
                "UN_TO thee will I /cry, O /LORD, my /strength:",
                "think no scorn of me; lest, if thou make as though thou hear_est not, I be_come like them that go down /in_/to the /pit."
            ],
            [
                "Hear the voice of my hum_ble pe_ti_tions, when I /cry /un_to /thee;",
                "when I hold up my hands to_wards the mer_cy_seat of thy /ho_ly /tem_ple."
            ],
            [
                "O pluck me not a_way, nei_ther des_troy me with the un_god_ly and /wick_ed /do_ers,",
                "which speak friend_ly to their neigh_bours, but i_ma_gine /mis_chief /in their /hearts."
            ],
            [
                "Re_ward them ac_/cor_ding /to their /deeds,",
                "and ac_cor_ding to the wick_ed_ness of their /own in_/ven_tions."
            ],
            [
                "Re_com_pense them af_ter the /work /of their /hands;",
                "pay them /that they /have des_/erved."
            ],
            [
                "For they re_gard not in their mind the works of the LORD, nor the op_er_/a_tion /of his /hands;",
                "there_fore shall he break them down, and /not /build them /up."
            ],
            [
                "Praised /be the /LORD;",
                "for he hath heard the voice of my /hum_ble pe_/ti_tions."
            ],
            [
                "The LORD is my strength, and my shield; my heart hath trust_ed in him, /and /I am /helped;",
                "there_fore my heart danc_eth for joy, and in my /song will I /praise /him."
            ],
            [
                "The /LORD is my /strength,",
                "and he is the whole_some de_fence of /his a_/noin_ted."
            ],
            [
                "O save thy peo_ple, and give thy bless_ing un_to /thine in_/he_ri_tance:",
                "feed them, and set them /up for /ev_er."
            ]
        ]
    },
    {
        id: "psalm29",
        lines: [
            [
                "A_SCRIBE un_to the LORD, /O ye /migh_ty,",
                "a_scribe un_to the LORD /wor_ship and /strength."
            ],
            [
                "A_scribe un_to the LORD the ho_nour due /un_to his /Name;",
                "wor_ship the LORD with /ho_ly /wor_ship."
            ],
            [
                "The voice of the LORD is up_/on the /wa_ters;",
                "it is the glo_rious God that /mak_eth the /thun_der."
            ],
            [
                "It is the LORD that rul_eth the sea; the voice of the LORD is migh_ty in /op_er_/a_tion;",
                "the voice of the LORD /is a /glo_rious /voice."
            ],
            [
                "The voice of the LORD /break_eth the /ce_dar-_trees;",
                "yea, the LORD break_eth the /ce_dars of /Le_ba_non."
            ],
            [
                "He mak_eth them al_so to /skip like a /calf;",
                "Le_ba_non al_so, and Sir_ion, /like a young /u_ni_corn."
            ],
            [
                "The voice of the LORD di_vi_deth the flames of fire; the voice of the LORD /shak_eth the /wil_der_ness;",
                "yea, the LORD shak_eth the wil_der_ness of /Ka_desh."
            ],
            [
                "The voice of the LORD mak_eth the hinds to bring forth young, and strip_peth /bare the /for_ests:",
                "in his tem_ple doth eve_ry thing /speak of his /ho_nour."
            ],
            [
                "The LORD sitt_eth a_/bove the /wa_ter-_flood,",
                "and the LORD re_main_eth a /King for /ev_er."
            ],
            [
                "The LORD shall give strength /un_to his /peo_ple;",
                "the LORD shall give his peo_ple the /bless_ing of /peace."
            ]
        ]
    },
    {
        id: "psalm30",
        lines: [
            [
                "I WILL mag_ni_fy thee, O LORD; for /thou hast /set me /up,",
                "and not made my foes to /tri_umph /o_ver me."
            ],
            [
                "O LORD my God, I /cried un_to /thee;",
                "and /thou hast /healed me."
            ],
            [
                "Thou, LORD, hast brought my /soul /out of /hell:",
                "thou hast kept my life, that I should not go down in_to /the pit."
            ],
            [
                "Sing prais_es un_to the LORD, /O ye /saints of his;",
                "and give thanks un_to him, for a re_mem_brance /of his /ho_li_ness."
            ],
            [
                "For his wrath en_dur_eth but the twink_ling of an eye, and in his /plea_sure is /life;",
                "hea_vi_ness may en_dure for a night, but joy com_eth /in the /mor_ning."
            ],
            [
                "And in my pros_pe_ri_ty I said, I shall /nev_er /be re_/moved:",
                "thou, LORD, of thy good_ness, hast /made my /hill so /strong."
            ],
            [
                "Thou didst /turn thy /face from me,",
                "and /I was /trou_bled."
            ],
            [
                "Then cried I /un_to /thee, O /LORD;",
                "and gat me to my /LORD right /humb_ly."
            ],
            [
                "What pro_fit /is there /in my /blood,",
                "when I go down /in_/to the /pit?"
            ],
            [
                "Shall the dust give /thanks un_to /thee?",
                "or /shall it de_/clare thy /truth?"
            ],
            [
                "Hear, O LORD, and have /mer_cy up_/on me;",
                "LORD, be /thou my /hel_per."
            ],
            [
                "Thou hast turned my /hea_vi_ness /in_to /joy;",
                "thou hast put off my sack_cloth, and gir_ded /me with /glad_ness:"
            ],
            [
                "There_fore shall eve_ry good man sing of thy /praise with_out /ceas_ing.",
                "O my God, I will give thanks un_to /thee for /ev_er."
            ]
        ]
    },
    {
        id: "psalm31",
        lines: [
            [
                "IN thee, O LORD, have I put my trust; let me nev_er be /put to con_/fu_sion;",
                "de_li_ver /me in thy /right_eous_ness."
            ],
            [
                "Bow /down thine /ear to me;",
                "make haste /to de_/li_ver me."
            ],
            [
                "And be thou my strong rock, and /house of de_/fence,",
                "that thou /may_est /save me."
            ],
            [
                "For thou art my strong /rock, and my /ca_stle:",
                "be thou al_so my guide, and lead me /for thy /Name's sake."
            ],
            [
                "Draw me out of the net that they have laid /pri_vi_ly for /me;",
                "for /thou art /my /strength."
            ],
            [
                "In_to thy hands I com_/mend my /spi_rit;",
                "for thou hast re_deemed me, O /LORD, thou /God of /truth."
            ],
            [
                "I have hat_ed them that hold of /ly_ing /va_ni_ties,",
                "and my trust hath /been in the /LORD."
            ],
            [
                "I will be glad and re_/joice in thy /mer_cy;",
                "for thou hast con_sid_ered my trou_ble, and hast known my /soul in ad_/ver_si_ties."
            ],
            [
                "Thou hast not shut me up in_to the /hand of the /e_ne_my;",
                "but hast set my /feet in a /large /room."
            ],
            [
                "Have mer_cy up_on me, O LORD, for /I am in /trou_ble,",
                "and mine eye is con_sumed for ve_ry hea_vi_ness; yea, my /soul and my /bo_dy."
            ],
            [
                "For my life is wax_en /old with /hea_vi_ness,",
                "and my /years with /mourn_ing."
            ],
            [
                "My strength fail_eth me, be_cause of /mine in_/i_qui_ty,",
                "and my bones /are con_/sumed."
            ],
            [
                "I be_came a rep_roach a_mong all mine e_ne_mies, but es_pe_cial_ly a_/mong my /neigh_bours;",
                "and they of mine ac_quain_tance were a_fraid of me; and they that did see me with_out, con_veyed /them_selves /from /me."
            ],
            [
                "I am clean for_got_ten as a /dead man /out of /mind;",
                "I am be_come like a /bro_ken /vess_el."
            ],
            [
                "For I have heard the blas_phe_my of the mul_ti_tude, and /fear is on /eve_ry /side;",
                "while they con_spire to_ge_ther a_gainst me, and take their coun_sel to /take a_/way my /life."
            ],
            [
                "But my hope hath /been in /thee, O LORD;",
                "I have said, /Thou art /my /God."
            ],
            [
                "My times are in thy hand; de_li_ver me from the /hand of mine /e_ne_mies,",
                "and from them that /per_se_cute /me."
            ],
            [
                "Show thy ser_vant the /light of thy /coun_te_nance,",
                "and save me /for thy /mer_cy's sake."
            ],
            [
                "Let me not be con_foun_ded, O LORD, for I have /called up_/on /thee;",
                "let the un_god_ly be put to con_fu_sion, and be put to /si_lence /in the /grave."
            ],
            [
                "Let the ly_ing lips be /put to /si_lence,",
                "which cruel_ly, dis_dain_ful_ly, and des_pite_ful_ly speak a_/gainst the /right_eous."
            ],
            [
                "O how plen_ti_ful is thy good_ness, which thou hast laid up for /them that /fear thee,",
                "and that thou hast pre_pared for them that put their trust in thee, e_ven be_/fore the /sons of /men!"
            ],
            [
                "Thou shalt hide them in the co_vert of thine own pres_ence from the /plot_tings of /men:",
                "thou shalt keep them se_cret_ly in thy tab_er_na_cle /from the /strife of /tongues."
            ],
            [
                "Thanks /be /to the /LORD;",
                "for he hath showed me mar_vell_ous great kind_ness /in a strong /ci_ty."
            ],
            [
                "But /in my /haste I /said,",
                "I am cast out of the /sight of /thine /eyes."
            ],
            [
                "Ne_ver_the_less, thou heard_est the /voice of /my /prayer,",
                "when I /cried /un_to /thee."
            ],
            [
                "O love the /LORD, all /ye his /saints;",
                "for the LORD pre_ser_veth them that are faith_ful, and plent_eous_ly re_/ward_eth the /proud do_er."
            ],
            [
                "Be strong, and he shall est_/ab_lish your /heart,",
                "all ye that put your /trust in the /LORD."
            ]
        ]
    },
    {
        id: "psalm32",
        lines: [
            [
                "BLESS_ED is he whose un_right_eous_ness /is for_/gi_ven,",
                "and whose /sin is /co_vered."
            ],
            [
                "Bless_ed is the man un_to whom the LORD im_/put_eth no /sin,",
                "and in whose spi_rit /there is no /guile."
            ],
            [
                "For /whilst I /held my /tongue,",
                "my bones con_sumed a_way through my /dai_ly com_/plain_ing."
            ],
            [
                "For thy hand was hea_vy up_/on me /day and /night,",
                "and my mois_ture was like the /drought in /sum_mer."
            ],
            [
                "I ack_now_ledged my /sin un_to /thee;",
                "and mine un_right_eous_ness /have I /not /hid."
            ],
            [
                "I said, I will con_fess my sins /un_to the /LORD;",
                "and so thou for_gav_est the /wick_ed_ness /of my /sin."
            ],
            [
                "For this shall eve_ry one that is god_ly make his prayer un_to thee, in a time when thou /may_est be /found;",
                "sure_ly the great wa_ter-_floods shall /not come /nigh him."
            ],
            [
                "Thou art a place to hide me in; thou shalt pre_/serve me from /trou_ble;",
                "thou shalt com_pass me a_bout with /songs of de_/liv_'rance."
            ],
            [
                "I will in_form thee, and teach thee in the way where_/in thou shalt /go;",
                "and I will /guide thee with /mine /eye."
            ],
            [
                "Be ye not like to horse and mule, which have no /un_der_/stan_ding;",
                "whose mouths must be held with bit and bri_dle, else they will /not o_/bey /thee."
            ],
            [
                "Great plagues re_main for the un_/god_ly;",
                "but who_so putt_eth his trust in the LORD, mer_cy em_brac_eth him /on /eve_ry /side."
            ],
            [
                "Be glad, O ye right_eous, and re_/joice in /the /LORD;",
                "and be joy_ful, all /ye that are /true of /heart."
            ]
        ]
    },
    {
        id: "psalm33",
        lines: [
            [
                "RE_JOICE in the LORD, /O ye /right_eous;",
                "for it be_com_eth well the /just to be /thank_ful."
            ],
            [
                "/Praise the /LORD with /harp;",
                "sing prais_es un_to him with the lute, and in_stru_/ment of /ten /strings."
            ],
            [
                "Sing un_to the /Lord a new /song;",
                "sing prais_es lus_ti_ly un_to him /with a good /cou_rage."
            ],
            [
                "For the /word of the /LORD is /true;",
                "and all his /works are /faith_ful."
            ],
            [
                "He lov_eth right_eous_ness and /judg_ment;",
                "the earth is full of the /good_ness /of the /LORD."
            ],
            [
                "By the word of the /LORD were the /hea_vens /made;",
                "and all the host of them by the /breath of /his /mouth."
            ],
            [
                "He ga_ther_eth the wa_ters of the sea to_ge_ther, as it /were up_/on an /heap;",
                "and lay_eth up the deep, as /in a /trea_sure-_/house."
            ],
            [
                "Let all the /earth fear the /LORD:",
                "stand in awe of him, all ye that /dwell in /the /world."
            ],
            [
                "For he /spake, and /it was /done;",
                "he com_man_ded, /and it /stood /fast."
            ],
            [
                "The LORD bring_eth the coun_sel of the /heath_en to /nought,",
                "and mak_eth the de_vices of the peo_ple to be of none eff_ect, and cast_eth out the /coun_sels of /prin_ces."
            ],
            [
                "The coun_sel of the LORD shall en_/dure for /ev_er,",
                "and the thoughts of his heart from ge_ne_ra_tion to /ge_ne_/ra_tion."
            ],
            [
                "Bless_ed are the peo_ple whose God is the /Lord JE_/HO_VAH;",
                "and bless_ed are the folk that he hath cho_sen to him, to be /his in_/he_ri_/tance."
            ],
            [
                "The LORD look_eth down from hea_ven, and be_hold_eth all the /child_ren of /men;",
                "from the ha_bi_ta_tion of his dwell_ing, he con_si_der_eth all them that /dwell on /the /earth."
            ],
            [
                "He fa_shion_eth /all the /hearts of /them,",
                "and un_der_/stand_eth /all their /works."
            ],
            [
                "There is no king that can be saved by the /mul_ti_tude /of an /host;",
                "nei_ther is an_y migh_ty man de_/li_vered by /much /strength."
            ],
            [
                "A horse is coun_ted but a vain /thing to /save a /man;",
                "nei_ther shall he de_li_ver an_y /man by his /great /strength."
            ],
            [
                "Be_hold, the eye of the LORD is up_on /them that /fear him,",
                "and up_on them that put their /trust in his /mer_cy;"
            ],
            [
                "To de_/li_ver their /soul from /death,",
                "and to feed them /in the /time of /dearth."
            ],
            [
                "Our soul hath pa_tient_ly /tar_ried for /the /LORD;",
                "for he is our /help and /our /shield."
            ],
            [
                "For our heart /shall re_/joice in /him;",
                "be_cause we have /hoped in his /ho_ly /Name."
            ],
            [
                "Let thy mer_ci_ful kind_ness, O /LORD, be up_/on us,",
                "like as we do /put our /trust in /thee."
            ]
        ]
    },
    {
        id: "psalm34",
        lines: [
            [
                "I WILL al_way give thanks /un_to the /LORD;",
                "his praise shall ev_er /be /in my /mouth."
            ],
            [
                "My soul shall make her /boast /in the /LORD;",
                "the hum_ble shall hear there_/of, /and be /glad."
            ],
            [
                "O /praise the /LORD with /me,",
                "and let us mag_ni_fy his /Name to_/ge_ther."
            ],
            [
                "I sought the LORD, /and he /heard me;",
                "yea, he de_li_vered me /out of /all my /fear."
            ],
            [
                "They had an eye un_to him, /and were /light_ened;",
                "and their /fa_ces were /not a_/shamed."
            ],
            [
                "Lo, the poor cri_eth, and the /LORD /hear_eth /him;",
                "yea, and sav_eth him out of /all his /trou_bles."
            ],
            [
                "The an_gel of the LORD tar_ri_eth round a_bout /them that /fear him,",
                "and de_/li_/ver_eth /them."
            ],
            [
                "O taste, and see, how /gra_cious the /LORD is:",
                "bless_ed is the man that /trust_eth in /him."
            ],
            [
                "O fear the LORD, /ye that /are his /saints;",
                "for they that /fear him lack /noth_ing."
            ],
            [
                "The li_ons do lack, and /suf_fer /hun_ger;",
                "but they who seek the LORD shall want no man_ner of /thing that is /good."
            ],
            [
                "Come, ye child_ren, and /hear_ken /un_to /me;",
                "I will teach you the /fear /of the /LORD."
            ],
            [
                "What man is he that /lust_eth to /live,",
                "and would /fain see /good /days?"
            ],
            [
                "Keep thy /tongue from /e_vil,",
                "and thy lips, /that they /speak no /guile."
            ],
            [
                "Es_chew /e_vil, and /do /good;",
                "seek /peace, and en_/sue it."
            ],
            [
                "The eyes of the LORD are /o_ver the /right_eous,",
                "and his ears are o_pen /un_to their /prayers."
            ],
            [
                "The coun_te_nance of the LORD is a_gainst /them that do /e_vil,",
                "to root out the re_mem_brance of them /from the /earth."
            ],
            [
                "The right_eous cry, and the /LORD /hear_eth /them,",
                "and de_li_ver_eth them out of /all their /trou_bles."
            ],
            [
                "The LORD is nigh un_to them that are /of a /con_trite /heart,",
                "and will save such as be of an /hum_ble /spi_rit."
            ],
            [
                "Great are the trou_bles /of the /right_eous;",
                "but the LORD de_li_ver_eth /him /out of /all."
            ],
            [
                "He /keep_eth /all his /bones,",
                "so that not one of /them is /bro_ken."
            ],
            [
                "But mis_for_tune shall /slay the un_/god_ly;",
                "and they that hate the right_eous /shall be /de_so_late."
            ],
            [
                "The LORD de_li_ver_eth the /souls of his /ser_vants;",
                "and all they that put their trust in him shall /not be /des_ti_tute."
            ]
        ]
    },
    {
        id: "psalm35",
        lines: [
            [
                "PLEAD thou my cause, O LORD, with /them that /strive with /me,",
                "and fight thou a_gainst them that /fight a_/gainst /me."
            ],
            [
                "Lay hand up_on the /shield and /buck_ler,",
                "and stand /up to /help me."
            ],
            [
                "Bring forth the spear, and stop the way a_gainst them /that pur_/sue /me:",
                "say un_to my soul, I am /thy sal_/va_tion."
            ],
            [
                "Let them be con_foun_ded, and put to shame, that seek /af_ter my /soul;",
                "let them be turned back, and brought to con_fu_sion, that i_ma_gine /mis_chief for /me."
            ],
            [
                "Let them be as the /dust be_/fore the /wind,",
                "and the an_gel of the LORD /scat_ter_ing /them."
            ],
            [
                "Let their way be /dark and /slip_pe_ry,",
                "and let the an_gel of the /LORD pur_/sue them."
            ],
            [
                "For they have pri_vi_ly laid their net to des_troy /me with_/out a /cause;",
                "yea, e_ven with_out a cause have they made a /pit for my /soul."
            ],
            [
                "Let a sud_den des_truc_tion come up_on him un_a_wares, and his net that he hath laid /pri_vi_ly /catch him_/self;",
                "that he may fall in_to his /own /mis_chief."
            ],
            [
                "And my soul shall be /joy_ful in the /LORD;",
                "it shall re_joice in /his sal_/va_tion."
            ],
            [
                "All my bones shall say, LORD, who is like un_to thee, who de_li_ver_est the poor from him that is /too strong for /him;",
                "yea, the poor, and him that is in mi_se_ry, from /him that /spoil_eth /him?"
            ],
            [
                "False /wit_ness_es /did rise /up:",
                "they laid to my charge things /that I /knew /not."
            ],
            [
                "They re_war_ded me /e_vil for /good,",
                "to the great dis_/com_fort of /my /soul."
            ],
            [
                "Ne_ver_the_less, when they were sick, I put on sack_cloth, and hum_bled my /soul with /fast_ing;",
                "and my prayer shall turn in_to /mine own /bo_som."
            ],
            [
                "I be_haved my_self as though it had been my /friend or my /bro_ther;",
                "I went hea_vi_ly, as one that mourn_eth /for his /mo_ther."
            ],
            [
                "But in mine ad_ver_si_ty they re_joiced, and ga_thered them_/selves to_/ge_ther;",
                "yea, the ve_ry ab_jects came to_ge_ther a_gainst me un_a_wares, ma_king mouths at /me, and /ceased /not."
            ],
            [
                "With the flat_ter_ers were /bu_sy /mock_ers,",
                "who gnashed up_/on me /with their /teeth."
            ],
            [
                "Lord, how long wilt thou /look up_/on /this?",
                "O de_li_ver my soul from the ca_la_mi_ties which they bring on me, and my dar_ling /from the /li_ons."
            ],
            [
                "So will I give thee thanks in the great /con_gre_/ga_tion;",
                "I will praise thee a_/mong much /peo_ple."
            ],
            [
                "O let not them that are mine e_ne_mies tri_umph o_ver /me un_/god_ly;",
                "nei_ther let them wink with their eyes, that /hate me with_/out a /cause."
            ],
            [
                "And why? their com_mun_ing /is not for /peace;",
                "but they i_ma_gine de_ceit_ful words a_gainst them that are /qui_et /in the /land."
            ],
            [
                "They gaped up_on me /with their /mouths, and /said,",
                "Fie on thee! fie on thee! we /saw it with /our /eyes."
            ],
            [
                "This /thou hast /seen, O /LORD;",
                "hold not thy tongue then; go not /far from /me, O /Lord."
            ],
            [
                "A_wake, and stand up to /judge my /quar_rel;",
                "a_venge thou my cause, my /God and /my /Lord."
            ],
            [
                "Judge me, O LORD my God, ac_cor_ding /to thy /right_eous_ness;",
                "and let them not /tri_umph /o_ver me."
            ],
            [
                "Let them not say in their hearts, There! there! /so would /we have /it;",
                "nei_ther let them say, We /have de_/voured him."
            ],
            [
                "Let them be put to con_fu_sion and shame to_ge_ther, that re_/joice at my /trou_ble;",
                "let them be clothed with re_buke and dis_hon_our, that boast them_/selves a_/gainst /me."
            ],
            [
                "Let them be glad and re_joice, that fa_vour my /right_eous /deal_ing;",
                "yea, let them say al_way, Bless_ed be the LORD, who hath plea_sure in the pros_pe_ri_ty /of his /ser_vant."
            ],
            [
                "And as for my tongue, it shall be talk_ing /of thy /right_eous_ness,",
                "and of thy praise, /all the /day /long."
            ]
        ]
    },
    {
        id: "psalm36",
        lines: [
            [
                "MY heart show_eth me the wick_ed_ness of /the un_/god_ly,",
                "that there is no fear of /God be_/fore his /eyes."
            ],
            [
                "For he flat_ter_eth him_self /in his /own sight,",
                "un_til his a_bom_in_a_ble /sin be /found /out."
            ],
            [
                "The words of his mouth are un_right_eous and /full of de_/ceit:",
                "he hath left off to be_have him_self wise_ly, /and to /do /good."
            ],
            [
                "He i_ma_gin_eth mis_chief up_on his bed, and hath set him_/self in no /good /way;",
                "nei_ther doth he ab_hor an_y thing /that is /e_vil."
            ],
            [
                "Thy mer_cy, O LORD, reach_eth un_/to the /hea_vens,",
                "and thy faith_ful_ness /un_to the /clouds."
            ],
            [
                "Thy right_eous_ness stand_eth /like the /strong /moun_tains:",
                "thy judg_ments are /like the /great /deep."
            ],
            [
                "Thou, LORD, shalt save both man and beast: how ex_cell_ent is thy /mer_cy, /O /God!",
                "and the child_ren of men shall put their trust un_der the /sha_dow of /thy /wings."
            ],
            [
                "They shall be sa_tis_fied with the /plen_teous_ness /of thy /house;",
                "and thou shalt give them drink of thy plea_sures, as /out of the /ri_ver."
            ],
            [
                "For with /thee is the /well of /life;",
                "and in thy light /shall /we see /light."
            ],
            [
                "O con_tin_ue forth thy lov_ing-_kind_ness un_to /them that /know thee,",
                "and thy right_eous_ness un_to /them that are /true of heart."
            ],
            [
                "O let not the foot of pride /come a_/gainst me;",
                "and let not the hand of the un_/god_ly /cast me /down."
            ],
            [
                "There are they fall_en, /all that work /wick_ed_ness;",
                "they are cast down, and shall not be /a_ble to /stand."
            ]
        ]
    },
    {
        id: "psalm37",
        lines: [
            [
                "FRET not thy_self be_cause of /the un_/god_ly;",
                "nei_ther be thou en_vi_ous a_gainst the /e_vil /do_ers."
            ],
            [
                "For they shall soon be cut /down like the /grass,",
                "and be with_ered /e_ven as the /green /herb."
            ],
            [
                "Put thou thy trust in the LORD, /and be /do_ing /good;",
                "dwell in the land, and ve_ri_ly /thou /shalt be /fed."
            ],
            [
                "De_/light thou in /the LORD,",
                "and he shall /give thee thy /heart's de_/sire."
            ],
            [
                "Com_mit thy way un_to the LORD, and /put thy /trust in /him,",
                "and he shall /bring it to /pass."
            ],
            [
                "He shall make thy right_eous_ness as /clear as the /light,",
                "and thy just deal_ing /as the /noon-_day."
            ],
            [
                "Hold thee still in the LORD, and a_bide pa_tient_ly up_/on him:",
                "but grieve not thy_self at him whose way doth pros_per, a_gainst the man that do_eth af_ter /e_vil /coun_sels."
            ],
            [
                "Leave off from wrath, and let /go dis_/plea_sure:",
                "fret not thy_self, else shalt thou be /moved to do /e_vil."
            ],
            [
                "Wick_ed do_ers /shall be /root_ed /out;",
                "and they that pa_tient_ly a_bide the LORD, those shall in_/he_rit the /land."
            ],
            [
                "Yet a lit_tle while, and the un_god_ly /shall be /clean /gone:",
                "thou shalt look af_ter his place, and /he shall /be a_/way."
            ],
            [
                "But the meek-_spi_ri_ted /shall pos_/sess the /earth,",
                "and shall be re_freshed in the /mul_ti_/tude of /peace."
            ],
            [
                "The un_god_ly seek_eth /coun_sel a_/gainst the /just,",
                "and gnash_eth up_/on him /with his /teeth."
            ],
            [
                "The Lord shall /laugh him to-_/scorn;",
                "for he hath seen that his /day is /com_ing."
            ],
            [
                "The un_god_ly have drawn out the sword, /and have /bent their /bow,",
                "to cast down the poor and nee_dy, and to slay such as be /up_right /in their /ways."
            ],
            [
                "Their sword shall go /through their /own /heart,",
                "and their bow /shall be /bro_ken."
            ],
            [
                "A small thing /that the /right_eous /hath,",
                "is bet_ter than great rich_es of /the un_/god_ly."
            ],
            [
                "For the arms of the un_god_ly /shall be /bro_ken,",
                "and the LORD up_/hold_eth the /right_eous."
            ],
            [
                "The LORD know_eth the /days of the /god_ly;",
                "and their in_he_ri_tance shall en_/dure for /ev_er."
            ],
            [
                "They shall not be con_foun_ded in the /pe_ri_lous /time;",
                "and in the days of dearth /they shall /have en_/ough."
            ],
            [
                "As for the un_god_ly, they shall per_ish, and the e_ne_mies of the LORD shall con_sume /as the /fat of /lambs:",
                "yea, e_ven as the smoke shall /they con_/sume a_/way."
            ],
            [
                "The un_god_ly bor_row_eth, and /pay_eth /not a_/gain;",
                "but the right_eous is mer_ci_/ful and /lib_eral."
            ],
            [
                "Such as are bless_ed of God, /shall pos_/sess the /land;",
                "and they that are curs_ed of him, /shall be /root_ed /out."
            ],
            [
                "The LORD or_der_eth a /good man's /go_ing,",
                "and mak_eth his way ac_/cep_ta_ble /to him_/self."
            ],
            [
                "Though he fall, he shall /not be /cast a_/way;",
                "for the LORD up_hold_eth /him /with his /hand."
            ],
            [
                "I have been /young, and /now am /old;",
                "and yet saw I nev_er the right_eous for_sa_ken, nor his seed /beg_ging their /bread."
            ],
            [
                "The right_eous is ev_er mer_ci_/ful, and /len_deth;",
                "and his /seed is /bless_ed."
            ],
            [
                "Flee from e_vil, and do the /thing that is /good;",
                "and /dwell for /ev_er_/more."
            ],
            [
                "For the LORD lov_eth the /thing /that is /right;",
                "he for_sak_eth not his that be god_ly, but they are pre_/served for /ev_er."
            ],
            [
                "The un_right_eous /shall be /pun_ished;",
                "as for the seed of the un_god_ly, /it shall be /root_ed /out."
            ],
            [
                "The right_eous shall in_/he_rit the /land,",
                "and dwell there_/in for /ev_er."
            ],
            [
                "The mouth of the right_eous is ex_er_cised in /wis_dom,",
                "and his tongue will be /talk_ing of /judg_ment."
            ],
            [
                "The law of his /God is /in his /heart,",
                "and his /go_ings /shall not /slide."
            ],
            [
                "The un_god_ly /watch_eth the /right_eous,",
                "and seek_eth oc_/ca_sion to /slay /him."
            ],
            [
                "The LORD will not /leave him /in his /hand,",
                "nor con_/demn him when /he is /judged."
            ],
            [
                "Hope thou in the LORD, and keep his way, and he shall pro_mote thee, that /thou shalt pos_/sess the /land:",
                "when the un_god_ly shall per_ish, /thou shalt /see it."
            ],
            [
                "I my_self have seen the un_/god_ly in /great /power,",
                "and flour_ish_ing /like a green /bay-_tree."
            ],
            [
                "I went by, and /lo, he was /gone:",
                "I sought him, but his place could /no_where be /found."
            ],
            [
                "Keep in_no_cen_cy, and take heed un_to the /thing that is /right;",
                "for that shall bring a man /peace /at the /last."
            ],
            [
                "As for the trans_gres_sors, they shall /per_ish to_/ge_ther;",
                "and the end of the un_god_ly is, they shall be root_ed /out /at the /last."
            ],
            [
                "But the sal_va_tion of the right_eous /com_eth /of the /LORD;",
                "who is al_so their strength in the /time of /trou_ble."
            ],
            [
                "And the LORD shall stand /by them, and /save them:",
                "he shall de_li_ver them from the un_god_ly, and shall save them, be_cause they /put their /trust in /him."
            ]
        ]
    },
    {
        id: "psalm38",
        lines: [
            [
                "PUT me not to re_buke, O LORD, /in thine /an_ger;",
                "nei_ther chas_ten me in thy /hea_vy dis_/plea_sure:"
            ],
            [
                "For thine /arr_ows stick /fast in me,",
                "and thy hand /press_eth /me /sore."
            ],
            [
                "There is no health in my flesh, be_cause of /thy dis_/plea_sure;",
                "nei_ther is there an_y rest in my bones, by /rea_son of /my /sin."
            ],
            [
                "For my wick_ed_ness_es are gone /o_ver my /head,",
                "and are like a sore bur_den, too hea_vy /for /me to /bear."
            ],
            [
                "My wounds /stink, and /are cor_/rupt,",
                "/through my /fool_ish_ness."
            ],
            [
                "I am brought in_to so great /trou_ble and /mi_se_ry,",
                "that I go mourn_ing /all the /day /long."
            ],
            [
                "For my loins are /filled with a /sore dis_/ease,",
                "and there is no whole part /in my /bo_dy."
            ],
            [
                "I am fee_ble /and sore /smit_ten;",
                "I have roar_ed for the ve_ry dis_qui_et_ness of /my /heart."
            ],
            [
                "Lord, thou know_est /all my de_/sire;",
                "and my groan_ing /is not /hid from /thee."
            ],
            [
                "My heart pan_teth, my /strength hath /failed me,",
                "and the light of mine /eyes is /gone from me."
            ],
            [
                "My lov_ers and my neigh_bours did stand look_ing up_/on my /trou_ble,",
                "and my kins_men /stood af_/ar /off."
            ],
            [
                "They al_so that sought af_ter my /life laid /snares for me;",
                "and they that went a_bout to do me e_vil talked of wick_ed_ness, and i_ma_gined de_ceit /all the /day long."
            ],
            [
                "As for me, I was like a /deaf man, and /heard not;",
                "and as one that is dumb, who doth not /o_pen /his mouth."
            ],
            [
                "I be_came e_ven as a /man that /hear_eth not,",
                "and in whose /mouth are no /re_proofs."
            ],
            [
                "For in thee, O LORD, /have I /put my /trust;",
                "thou shalt an_swer for /me, O /Lord my /God."
            ],
            [
                "I have re_quired that they, e_ven mine e_ne_mies, should not /tri_umph /o_ver me;",
                "for when my foot slipt, they re_joiced /great_ly a_/gainst me."
            ],
            [
                "And I tru_ly am /set in the /plague,",
                "and my hea_vi_ness is /ev_er in /my /sight."
            ],
            [
                "For I will con_/fess my /wick_ed_ness,",
                "and be /sor_ry for /my /sin."
            ],
            [
                "But mine e_ne_mies /live, and are /migh_ty;",
                "and they that hate me wrong_ful_ly are /ma_ny in /num_ber."
            ],
            [
                "They al_so that re_ward e_vil for /good are a_/gainst me;",
                "be_cause I fol_low the /thing that /good is."
            ],
            [
                "For_sake me /not, O /LORD my /God;",
                "be /not thou /far from me."
            ]
        ]
    },
    {
        id: "psalm39",
        lines: [
            [
                "I SAID, I will take /heed to my /ways,",
                "that I off_end /not in my /tongue"
            ],
            [
                "I will keep my mouth as it /were with a /bri_dle,",
                "while the un_/god_ly is /in my /sight."
            ],
            [
                "I held my /tongue, and spake /noth_ing:",
                "I kept si_lence, yea, e_ven from good words; but it was /pain and /grief to /me."
            ],
            [
                "My heart was hot with_in me: and while I was thus mus_ing the fire /kin_dled,",
                "and at the last I /spake with /my /tongue:"
            ],
            [
                "LORD, let me know mine end, and the /num_ber /of my /days;",
                "that I may be cer_ti_fied how /long I /have to /live."
            ],
            [
                "Be_hold, thou hast made my days as it were a span long, and mine age is e_ven as noth_ing /in res_/pect of /thee;",
                "and ve_ri_ly eve_ry man li_ving is al_to_/ge_ther /va_ni_ty."
            ],
            [
                "For man walk_eth in a vain sha_dow, and dis_qui_et_eth /him_self in /vain;",
                "he heap_eth up rich_es, and can_not tell /who shall /gath_er /them."
            ],
            [
                "And now, Lord, /what is my /hope?",
                "tru_ly my hope is /e_ven /in /thee."
            ],
            [
                "De_li_ver me from /all mine of_/fen_ces;",
                "and make me not a re_buke /un_to the /fool_ish."
            ],
            [
                "I be_came dumb, and /o_pened not /my /mouth;",
                "for /it was thy /do_ing."
            ],
            [
                "Take thy /plague a_/way from me:",
                "I am e_ven con_sumed by the /means of thy /hea_vy /hand."
            ],
            [
                "When thou with re_bukes dost chas_ten man for sin, thou mak_est his beau_ty to con_sume a_way, like as it were a moth /frett_ing a /gar_ment:",
                "eve_ry man there_fore /is but /va_ni_ty."
            ],
            [
                "Hear my prayer, O LORD, and with thine ears con_/si_der my /call_ing;",
                "hold not thy /peace at my /tears;"
            ],
            [
                "For I am a stran_ger with /thee, and a /so_jour_ner,",
                "as /all my /fa_thers /were."
            ],
            [
                "O spare me a lit_tle, that I may re_/co_ver my /strength,",
                "be_fore I go /hence, and be /no more /seen."
            ]
        ]
    },
    {
        id: "psalm40",
        lines: [
            [
                "I WAIT_ED /pa_tient_ly /for the /LORD,",
                "and he in_clined un_to me, and /heard my /call_ing."
            ],
            [
                "He brought me al_so out of the hor_ri_ble pit, /out of the /mire and /clay,",
                "and set my feet up_on the rock, and /or_dered my /go_ings."
            ],
            [
                "And he hath put a new /song /in my /mouth,",
                "e_ven a thanks_giv_ing /un_to /our /God."
            ],
            [
                "Ma_ny shall /see it, and /fear,",
                "and shall put their /trust /in the /LORD."
            ],
            [
                "Bless_ed is the man that hath set his /hope in the /LORD,",
                "and turned not un_to the proud, and to such as /go a_/bout with /lies."
            ],
            [
                "O LORD my God, great are the won_drous works which thou hast done, like as be al_so thy thoughts, which /are to /us-_ward;",
                "and yet there is no man that or_der_eth /them /un_to /thee."
            ],
            [
                "If I should de_clare them, /and /speak of /them,",
                "they should be more than I am /a_ble /to ex_/press."
            ],
            [
                "Sac_ri_fice and off_er_ing /thou /would_est /not,",
                "but mine ears /hast thou /o_pened."
            ],
            [
                "Burnt-_off_er_ing and sac_ri_fice for sin /hast thou /not re_/quired:",
                "/then said I, /Lo, I /come;"
            ],
            [
                "In the vol_ume of the book it is writ_ten of me, that I should ful_/fil thy will, /O my /God:",
                "I am con_tent to do it; yea, thy /law is with_/in my /heart."
            ],
            [
                "I have de_clared thy right_eous_ness in the great /con_gre_/ga_tion:",
                "lo, I will not re_frain my lips, O LORD, and /that thou /know_est."
            ],
            [
                "I have not hid thy right_eous_ness with_/in my /heart;",
                "my talk hath been of thy truth, and of /thy sal_/va_tion."
            ],
            [
                "I have not kept back thy lov_ing /mer_cy and /truth",
                "from the great /con_gre_/ga_tion."
            ],
            [
                "With_draw not thou thy mer_cy /from /me, O /LORD;",
                "let thy lov_ing-_kind_ness and thy truth al_/way pre_/serve me."
            ],
            [
                "For in_nu_me_ra_ble trou_bles are come a_bout me; my sins have tak_en such hold up_on me, that I am not /a_ble to /look /up;",
                "yea, they are more in num_ber than the hairs of my head, and my /heart hath /failed me."
            ],
            [
                "O LORD, let it be thy plea_sure /to de_/li_ver /me;",
                "make haste, O /LORD, to /help /me."
            ],
            [
                "Let them be a_shamed, and con_foun_ded to_ge_ther, that seek af_ter my /soul to des_/troy it;",
                "let them be driv_en back_ward, and put to re_buke, that /wish me /e_vil."
            ],
            [
                "Let them be de_so_late, and re_/war_ded /with /shame,",
                "that say un_to me, Fie up_on thee! /fie up_/on /thee!"
            ],
            [
                "Let all those that seek thee, be /joy_ful and /glad in thee;",
                "and let such as love thy sal_va_tion, say al_way, The /LORD be /praised."
            ],
            [
                "As for me, I am /poor and /nee_dy;",
                "but the Lord /ca_reth /for /me."
            ],
            [
                "Thou art my hel_per /and re_/dee_mer;",
                "make no long /tar_ry_ing, /O my /God."
            ]
        ]
    },
    {
        id: "psalm41",
        lines: [
            [
                "BLESS_ED is he that con_si_der_eth the /poor and /nee_dy;",
                "the LORD shall de_li_ver him in the /time of /trou_ble."
            ],
            [
                "The LORD pre_serve him, and keep him a_live, that he may be /blessed up_/on /earth;",
                "and de_li_ver not thou him in_to the /will of his /e_ne_mies."
            ],
            [
                "The LORD com_fort him when he li_eth /sick up_/on his /bed;",
                "make thou all his bed /in his /sick_ness."
            ],
            [
                "I said, LORD, be /mer_ci_ful /un_to me;",
                "heal my soul, for I have /sinned a_/gainst /thee."
            ],
            [
                "Mine e_ne_mies speak /e_vil of /me,",
                "When shall he die, /and his name /per_ish?"
            ],
            [
                "And if he come to see me, he /speak_eth /va_ni_ty,",
                "and his heart con_ceiv_eth false_hood with_in him_self; and when he com_eth /forth, he /tell_eth it."
            ],
            [
                "All mine e_ne_mies whis_per to_/ge_ther a_/gainst /me;",
                "e_ven a_gainst me do they i_/ma_gine this /e_vil."
            ],
            [
                "An e_vil dis_ease, say they, cleav_eth /fast un_to /him;",
                "and now that he li_eth, he shall /rise up /no /more."
            ],
            [
                "Yea, e_ven mine own fa_mi_li_ar /friend whom I /trust_ed,",
                "who did al_so eat of my bread, hath /laid great /wait for /me."
            ],
            [
                "But be thou mer_ci_ful /un_to /me, O /LORD;",
                "raise thou me up a_gain, and I /shall re_/ward /them."
            ],
            [
                "By this I know thou /fa_vour_est /me,",
                "that mine e_ne_my doth not /tri_umph a_/gainst me."
            ],
            [
                "And in my in_no_cen_cy /thou up_/hold_est me,",
                "and shalt set me be_fore thy /face for /ev_er."
            ],
            [
                "Bless_ed be the LORD /God of /Is_ra_el,",
                "world /with_out /end. A_/men."
            ]
        ]
    },
    {
        id: "psalm42",
        lines: [
            [
                "LIKE as the hart de_/sir_eth the /wa_ter-_brooks,",
                "so long_eth my soul /af_ter /thee, O /God."
            ],
            [
                "My soul is a_thirst for God, yea, e_/ven for the /li_ving /God:",
                "when shall I come to ap_pear be_fore the /pres_ence of /God?"
            ],
            [
                "My tears have /been my meat /day and /night,",
                "while they dai_ly say un_to me, /Where is /now thy /God?"
            ],
            [
                "Now when I think there_up_on, I pour out my /heart by my_/self;",
                "for I went with the mul_ti_tude, and brought them forth /in_to the /house of /God;"
            ],
            [
                "In the voice of /praise and thanks_/giv_ing,",
                "a_mong /such as keep /ho_ly-_/day."
            ],
            [
                "Why art thou so full of /hea_vi_ness, O my /soul?",
                "and why art thou so dis_qui_et_ed with_/in me?"
            ],
            [
                "O /put thy /trust in /God;",
                "for I will yet thank him, which is the help of my /coun_te_nance, /and my /God."
            ],
            [
                "My soul is /vexed with_/in me;",
                "there_fore will I re_mem_ber thee from the land of Jor_dan, from Her_mon /and the /lit_tle /hill."
            ],
            [
                "One deep call_eth a_no_ther, be_cause of the /noise of thy /wa_ter-_floods;",
                "all thy waves and /storms are gone /o_ver /me."
            ],
            [
                "The LORD will grant his lov_ing-_/kind_ness in the /day_time;",
                "and in the night sea_son will I sing of him, and make my prayer un_to the /God of my /life."
            ],
            [
                "I will say un_to the God of my strength, Why hast /thou for_/got_ten me?",
                "why go I thus hea_vi_ly, while the e_ne_my op_/press_eth /me?"
            ],
            [
                "My bones are smit_ten a_sun_der /as with a /sword,",
                "while mine e_ne_mies that trou_ble me /cast me /in the /teeth;"
            ],
            [
                "Name_ly, while they say /dai_ly /un_to /me,",
                "/Where is /now thy /God?"
            ],
            [
                "Why art thou so /vexed, /O my /soul?",
                "and why art thou so dis_qui_et_ed with_/in me?"
            ],
            [
                "O /put thy /trust in /God;",
                "for I will yet thank him, which is the help of my /coun_te_nance, /and my /God."
            ]
        ]
    },
    {
        id: "psalm43",
        lines: [
            [
                "GIVE sen_tence with me, O God, and de_fend my cause a_gainst the un_/god_ly /peo_ple;",
                "O de_li_ver me from the de_/ceit_ful and /wick_ed /man."
            ],
            [
                "For thou art the God of my strength; why hast thou /put me /from thee?",
                "and why go I so hea_vi_ly, while the e_ne_my op_/press_eth /me?"
            ],
            [
                "O send out thy light and thy truth, that /they may /lead me,",
                "and bring me un_to thy ho_ly hill, and /to thy /dwell_ing;"
            ],
            [
                "And that I may go un_to the al_tar of God, e_ven un_to the God of my /joy and /glad_ness;",
                "and up_on the harp will I give thanks un_to /thee, O /God, my /God."
            ],
            [
                "Why art thou so /hea_vy, O my /soul?",
                "and why art thou so dis_qui_et_ed with_/in me?"
            ],
            [
                "O /put thy /trust in /God;",
                "for I will yet give him thanks, which is the help of my /coun_te_nance, /and my /God."
            ]
        ]
    },
    {
        id: "psalm44",
        lines: [
            [
                "WE have heard with our ears, O God, our /fa_thers have /told us",
                "what thou hast /done in their /time of /old:"
            ],
            [
                "How thou hast driv_en out the heath_en with thy hand, and /plan_ted our /fa_thers in;",
                "how thou hast des_troyed the na_tions, and made thy /peo_ple to /flou_rish."
            ],
            [
                "For they gat not the land in pos_sess_ion /through their /own sword,",
                "nei_ther was it their own /arm that /helped them;"
            ],
            [
                "But thy right hand, and thine arm, and the /light of thy /coun_te_nance;",
                "be_cause thou hadst a /fa_vour un_/to /them."
            ],
            [
                "Thou /art my /King, O God;",
                "send /help un_to /Ja_cob."
            ],
            [
                "Through thee will we o_ver_/throw our /e_ne_mies,",
                "and in thy Name will we tread them un_der that rise /up a_/gainst us."
            ],
            [
                "For I will not /trust in my /bow,",
                "it is not my /sword that shall /help me;"
            ],
            [
                "But it is thou that sav_est us /from our /e_ne_mies,",
                "and putt_est them to con_/fu_sion that /hate us."
            ],
            [
                "We make our boast of /God all day /long,",
                "and will praise thy /Name for /ev_er."
            ],
            [
                "But now thou art far off, and putt_est /us to con_/fu_sion,",
                "and go_est not /forth with our /arm_ies."
            ],
            [
                "Thou mak_est us to turn our backs up_/on our /e_ne_mies,",
                "so that they which /hate us /spoil our /goods."
            ],
            [
                "Thou lett_est us be /eat_en /up like sheep,",
                "and hast scat_tered us a_/mong the /heath_en."
            ],
            [
                "Thou sell_est thy /peo_ple for /nought,",
                "and tak_est no /mo_ney for /them."
            ],
            [
                "Thou mak_est us to be re_/buked of our /neigh_bours,",
                "to be laughed to scorn, and had in de_ri_sion of them that are /round a_/bout us."
            ],
            [
                "Thou mak_est us to be a by-_word a_/mong the /na_tions,",
                "and that the peo_ples /shake their /heads at us."
            ],
            [
                "My con_fu_sion is /dai_ly be_/fore me,",
                "and the shame of my /face hath /co_vered me;"
            ],
            [
                "For the voice of the slan_der_er /and blas_/phe_mer,",
                "for the e_ne_my /and a_/ven_ger."
            ],
            [
                "And though all this be come up_on us, yet do we /not for_/get thee,",
                "nor be_have our_selves fro_ward_ly /in thy /co_ve_nant."
            ],
            [
                "Our /heart is /not turned /back,",
                "nei_ther our steps gone /out of thy /way;"
            ],
            [
                "No, not when thou hast smit_ten us in_to the /place of /dra_gons,",
                "and co_vered us with the /sha_dow of /death."
            ],
            [
                "If we have for_got_ten the Name of our God, and hold_en up our hands to /an_y /strange god,",
                "shall not God search it out? for he know_eth the ve_ry /sec_rets /of the /heart."
            ],
            [
                "For thy sake al_so are we /killed all the /day long,",
                "and are coun_ted as sheep ap_/poin_ted to /be /slain."
            ],
            [
                "/Up, Lord, why /sleep_est thou?",
                "a_wake, and be not ab_sent from /us for /ev_er."
            ],
            [
                "Where_fore /hid_est /thou thy /face,",
                "and for_gett_est our mi_se_ry and /trou_ble?"
            ],
            [
                "For our soul is brought low, e_ven /un_to the /dust;",
                "our bel_ly cleav_eth /un_to the /ground."
            ],
            [
                "A_/rise, and /help us,",
                "and de_li_ver us, /for thy /mer_cy's /sake."
            ]
        ]
    },
    {
        id: "psalm45",
        lines: [
            [
                "MY heart ov_er_flow_eth with a good mat_ter; I speak the things which I have made con_/cer_ning the /King.",
                "My tongue is the pen of a /rea_dy /wri_ter."
            ],
            [
                "Thou art fair_er than the /child_ren of /men;",
                "full of grace are thy lips, be_cause God hath blessed /thee for /ev_er."
            ],
            [
                "Gird thee with thy sword up_on thy thigh, O /thou Most /Migh_ty,",
                "ac_cor_ding to thy /wor_ship /and re_/nown."
            ],
            [
                "Good luck have thou /with thine /ho_nour:",
                "ride on, be_cause of the word of truth, of meek_ness, and right_eous_ness; and thy right hand shall teach thee /ter_ri_ble /things."
            ],
            [
                "Thy arr_ows are ve_ry sharp in the heart of the /King's /e_ne_mies,",
                "and the peo_ple shall /be sub_dued /un_to /thee."
            ],
            [
                "Thy seat, O God, en_/dur_eth for /ev_er;",
                "the scep_tre of thy king_dom /is a right /scep_tre."
            ],
            [
                "Thou hast loved right_eous_ness, and /hat_ed in_/i_qui_ty;",
                "where_fore God, e_ven thy God, hath a_noin_ted thee with the oil of glad_ness a_/bove thy /fel_lows."
            ],
            [
                "All thy gar_ments smell of myrrh, /al_oes, and /cas_si_a;",
                "out of the i_vo_ry pa_la_ces, where_by /they have /made thee /glad."
            ],
            [
                "Kings' daugh_ters are a_mong thy /ho_nou_ra_ble /wo_men;",
                "up_on thy right hand doth stand the queen in a ves_ture of gold, wrought a_bout /with di_vers /col_ours."
            ],
            [
                "Hear_ken, O daugh_ter, and con_si_der; /in_/cline thine /ear;",
                "for_get al_so thine own peo_ple, /and thy /fa_ther's /house."
            ],
            [
                "So shall the King have plea_sure /in thy /beau_ty;",
                "for he is thy Lord, and /wor_ship /thou /him."
            ],
            [
                "And the daugh_ter of Tyre shall /be there /with a /gift;",
                "like as the rich al_so a_mong the peo_ple shall make their supp_li_/ca_tion be_/fore /thee."
            ],
            [
                "The King's daugh_ter is all /glo_rious with_/in;",
                "her clo_thing /is of /wrought gold."
            ],
            [
                "She shall be brought un_to the King in /rai_ment of /nee_dle_work:",
                "the vir_gins that be her fel_lows shall bear her com_pa_ny, and shall be /brought /un_to /thee."
            ],
            [
                "With joy and glad_ness /shall they be /brought,",
                "and shall en_ter in_/to the King's /pa_lace."
            ],
            [
                "In_stead of thy fa_thers, thou /shalt have /child_ren,",
                "whom thou may_est make /prin_ces in /all /lands."
            ],
            [
                "I will make thy Name to be re_mem_bered from one ge_ne_ra_tion /to a_/no_ther;",
                "there_fore shall the peo_ple give thanks un_to thee, /world with_/out end."
            ]
        ]
    },
    {
        id: "psalm46",
        lines: [
            [
                "GOD is our /hope and /strength,",
                "a ve_ry pre_sent /help in /trou_ble."
            ],
            [
                "There_fore will we not fear, /though the /earth be /moved,",
                "and though the hills be car_ried in_to the /midst of the /sea;"
            ],
            [
                "Though the wa_ters there_/of /rage and /swell,",
                "and though the moun_tains shake at the /tem_pest /of the /same."
            ],
            [
                "There is a ri_ver, the streams where_of make glad the /ci_ty of /God;",
                "the ho_ly place of the tab_er_na_cle /of the Most /High_est."
            ],
            [
                "God is in the midst of her, there_fore shall she /not be re_/moved;",
                "God shall help her, and /that right /ear_ly."
            ],
            [
                "The na_tions make much ado, and the /king_doms are /moved;",
                "but God hath showed his voice, and the /earth shall /melt a_way."
            ],
            [
                "The LORD of /hosts is /with us;",
                "the God of Ja_cob /is our /re_fuge."
            ],
            [
                "O come hi_ther, and be_hold the /works of the /LORD,",
                "what des_truc_tion he hath /brought up_/on the /earth."
            ],
            [
                "He mak_eth wars to /cease in /all the /world;",
                "he break_eth the bow, and knapp_eth the spear in sun_der, and burn_eth the /cha_ri_ots /in the /fire."
            ],
            [
                "Be still then, and /know that /I am /God:",
                "I will be ex_al_ted a_mong the na_tions, and I will be ex_/al_ted /in the /earth."
            ],
            [
                "The LORD of /hosts is /with us;",
                "the God of Ja_cob /is our /re_fuge."
            ]
        ]
    },
    {
        id: "psalm47",
        lines: [
            [
                "CLAP your hands to_ge_ther, /all ye /peo_ples:",
                "O sing un_to God with the /voice of /me_lo_dy."
            ],
            [
                "For the LORD is /high, and /to be /feared;",
                "he is the great /King up_on /all the /earth."
            ],
            [
                "He shall sub_due the /peo_ples /un_der /us,",
                "and the na_tions /un_der our /feet."
            ],
            [
                "He shall choose out an /he_ri_tage /for /us,",
                "e_ven the ex_cell_en_cy of /Ja_cob, /whom he /loved."
            ],
            [
                "God is gone up /with a /mer_ry /noise,",
                "and the LORD with the /sound /of the /trump."
            ],
            [
                "O sing prais_es, sing prais_es /un_to /our /God;",
                "O sing prais_es, sing prais_es /un_to /our /King."
            ],
            [
                "For God is the /King of /all the /earth:",
                "sing ye prais_es with /un_der_/stan_ding."
            ],
            [
                "God reign_eth /o_ver the /na_tions;",
                "God sitt_eth up_/on his /ho_ly /seat."
            ],
            [
                "The prin_ces of the peo_ples are joined un_to the peo_ple of the /God of /Ab_ra_ham;",
                "for God, which is ve_ry high ex_al_ted, doth de_fend the earth, as it /were /with a /shield."
            ]
        ]
    },
    {
        id: "psalm48",
        lines: [
            [
                "GREAT is the LORD, and /high_ly to be /praised",
                "in the ci_ty of our God, e_ven up_/on his /ho_ly /hill."
            ],
            [
                "The hill of Si_on is a fair place, and the /joy of the /whole /earth;",
                "up_on the north side li_eth the ci_ty of the great King: God is well known in her pa_la_ces /as a sure /re_fuge."
            ],
            [
                "For lo, the /kings of the /earth",
                "were ga_thered, and gone /by to_/ge_ther."
            ],
            [
                "They /mar_velled to /see such /things;",
                "they were as_ton_ished, and /sud_den_ly /cast /down."
            ],
            [
                "Fear came there up_/on them; and /sor_row,",
                "as up_on a wo_man /in /her tra_/vail."
            ],
            [
                "Thou dost break the /ships of the /sea",
                "/through the /east-_wind."
            ],
            [
                "Like as we have heard, so have we seen in the ci_ty of the LORD of hosts, in the /ci_ty of /our /God;",
                "God up_hold_eth the /same for /ev_er."
            ],
            [
                "We wait for thy lov_ing-_/kind_ness, O /God,",
                "in the midst /of thy /tem_ple."
            ],
            [
                "O God, ac_cor_ding to thy Name, so is thy praise /un_to the /world's end;",
                "thy right hand is /full of /right_eous_ness."
            ],
            [
                "Let the mount Si_on re_joice, and the daugh_ters of /Ju_dah be /glad,",
                "be_/cause of thy /judg_ments."
            ],
            [
                "Walk a_bout Si_on, and go /round a_/bout her;",
                "and /tell the /tow'rs there_/of."
            ],
            [
                "Mark well her bul_warks, con_/si_der her /pa_la_ces,",
                "that ye may tell /them that come /af_ter."
            ],
            [
                "For this God is our God for /ev_er and /ev_er:",
                "he shall /be our guide /un_to /death."
            ]
        ]
    },
    {
        id: "psalm49",
        lines: [
            [
                "O HEAR ye this, /all ye /peo_ple;",
                "pon_der it with your ears, all ye that /dwell in /the /world;"
            ],
            [
                "High and /low, rich and /poor,",
                "one /with a_/no_ther."
            ],
            [
                "My mouth shall /speak of /wis_dom,",
                "and my heart shall muse of /un_der_/stan_ding."
            ],
            [
                "I will in_cline mine /ear to the /pa_ra_ble,",
                "and show my dark /speech up_/on the /harp."
            ],
            [
                "Where_fore should I fear in the /days of /e_vil,",
                "when wick_ed_ness at my heels com_pass_eth /me round a_/bout?"
            ],
            [
                "There be some that put their /trust in their /goods,",
                "and boast them_selves in the mul_ti_tude /of their /rich_es."
            ],
            [
                "But no man may de_/li_ver his /bro_ther,",
                "nor give a ran_som /un_to /God for him,"
            ],
            [
                "For it cost /more to re_/deem their /souls,",
                "so that he must let that a_/lone for /ev_er;"
            ],
            [
                "That he /shall live /al_way,",
                "and /not see the /grave."
            ],
            [
                "For he seeth that wise men al_so die and /per_ish to_/ge_ther,",
                "as well as the ig_no_rant and fool_ish, and leave their /rich_es for /oth_er."
            ],
            [
                "And yet they think that their hou_ses shall con_tin_ue for ev_er, and that their dwell_ing-_pla_ces shall en_dure from one ge_ne_ra_tion /to a_/no_ther;",
                "and call the lands /af_ter their /own /names."
            ],
            [
                "Ne_ver_the_less, man be_ing in ho_nour a_/bi_deth /not,",
                "see_ing he may be comp_ared un_to the /beasts that /per_ish;"
            ],
            [
                "This their way is /ve_ry /fool_ish_ness;",
                "yet their pos_te_ri_ty /praise their /say_ing."
            ],
            [
                "They lie in the grave like sheep; death is their shep_herd; and the right_eous shall have do_min_ion o_ver them /in the /mor_ning:",
                "their beau_ty shall con_sume in the se_pul_chre, and have /no a_/bi_ding."
            ],
            [
                "But God hath de_li_vered my soul from the /pow_er of /the /grave;",
                "for he /shall re_/ceive me."
            ],
            [
                "Be not thou a_fraid, though /one be made /rich,",
                "or if the glo_ry of his /house be in_/creased;"
            ],
            [
                "For he shall car_ry noth_ing a_way with him /when he /di_eth,",
                "nei_ther shall his /pomp fol_low /him."
            ],
            [
                "For while he lived, he coun_ted him_/self an /hap_py /man;",
                "and so long as thou do_est well un_to thy_self, men will /speak /good of /thee."
            ],
            [
                "He shall fol_low the ge_ne_ra_tion /of his /fa_thers,",
                "and shall /nev_er see /light."
            ],
            [
                "Man that is in ho_nour but hath no /un_der_/stan_ding",
                "is comp_ared un_to the /beasts that /per_ish."
            ]
        ]
    },
    {
        id: "psalm50",
        lines: [
            [
                "THE LORD, e_ven the Most Migh_ty /God, hath /spo_ken,",
                "and called the world, from the ris_ing up of the sun un_to the /go_ing /down there_/of."
            ],
            [
                "Out of /Si_on hath /God ap_/peared",
                "in /per_fect /beau_ty."
            ],
            [
                "Our God shall come, and shall /not keep /si_lence;",
                "there shall go be_fore him a con_su_ming fire, and a migh_ty tem_pest shall be stirred up /round a_/bout him."
            ],
            [
                "He shall call the /hea_ven /from a_/bove,",
                "and the earth, that he may /judge his /peo_ple."
            ],
            [
                "Gath_er my saints to_/ge_ther /un_to /me;",
                "those that have made a co_ve_nant with /me with /sac_ri_fice."
            ],
            [
                "And the hea_vens shall de_/clare his /right_eous_ness;",
                "for /God is /Judge him_/self."
            ],
            [
                "Hear, O my /peo_ple, and /I will /speak;",
                "I my_self will tes_ti_fy a_gainst thee, O Is_ra_el; for I am God, /e_ven /thy /God."
            ],
            [
                "I will not re_prove thee be_cause of thy /sac_ri_/fi_ces;",
                "as for thy burnt-_off_er_ings, they are /al_way be_/fore /me."
            ],
            [
                "I will take no bull_ock /out of thine /house,",
                "nor he-_goats /out of thy /folds."
            ],
            [
                "For all the beasts of the /for_est are /mine,",
                "and so are the cat_tle up_/on a /thou_sand /hills."
            ],
            [
                "I know all the fowls up_/on the /moun_tains,",
                "and the wild beasts of the /field are /in my /sight."
            ],
            [
                "If I be hun_gry, I /will not /tell thee;",
                "for the whole world is mine, and /all that /is there_/in."
            ],
            [
                "Think_est thou that /I will eat /bulls' /flesh,",
                "and /drink the /blood of /goats?"
            ],
            [
                "Off_er un_to /God thanks_/giv_ing,",
                "and pay thy vows /un_to the Most /High_est."
            ],
            [
                "And call up_on me in the /time of /trou_ble;",
                "so will I hear thee, and /thou shalt /praise me."
            ],
            [
                "But un_to the un_/god_ly saith /God,",
                "Why dost thou preach my laws, and tak_est my co_ve_nant in /thy /mouth;"
            ],
            [
                "Where_as thou /hat_est to /be re_/formed,",
                "and hast cast my /words be_/hind thee?"
            ],
            [
                "When thou saw_est a thief, thou con_/sent_edst /un_to /him;",
                "and hast been par_tak_er /with the ad_/ult_er_ers."
            ],
            [
                "Thou hast let thy /mouth speak /wick_ed_ness,",
                "and with thy tongue thou hast /set /forth de_/ceit."
            ],
            [
                "Thou satt_est and spak_est a_/gainst thy /bro_ther;",
                "yea, and hast slan_dered thine /own /mo_ther's /son."
            ],
            [
                "These things hast thou done, and I held my tongue, and thou thought_est wick_ed_ly, that I am e_ven such a /one as thy_/self;",
                "but I will re_prove thee, and set be_fore thee the /things that /thou hast /done."
            ],
            [
                "O con_si_der this, /ye that for_/get /God,",
                "lest I pluck you a_way, and there be /none to de_/li_ver you."
            ],
            [
                "Who_so off_er_eth me thanks and praise, he /hon_our_eth /me;",
                "and to him that or_der_eth his way a_right, will I show the sal_/va_tion of /God."
            ]
        ]
    },
    {
        id: "psalm51",
        lines: [
            [
                "HAVE mer_cy up_on me, O God, /af_ter /thy great /good_ness;",
                "ac_cor_ding to the mul_ti_tude of thy mer_cies do a_way /mine off_/en_ces."
            ],
            [
                "Wash me through_ly /from my /wick_ed_ness,",
                "and /cleanse me /from my /sin."
            ],
            [
                "For I ack_/now_ledge my /faults,",
                "and my sin is /ev_er be_/fore me."
            ],
            [
                "A_gainst thee on_ly have I sinned, and done this /e_vil /in thy /sight;",
                "that thou might_est be jus_ti_fied in thy say_ing, and /clear when /thou shalt /judge."
            ],
            [
                "Be_hold, I was /sha_pen in /wick_ed_ness,",
                "and in sin hath my /mo_ther con_/ceived me."
            ],
            [
                "But lo, thou re_quir_est /truth in the /in_ward parts,",
                "and shalt make me to un_der_stand /wis_dom /se_cret_ly."
            ],
            [
                "Thou shalt purge me with hys_sop, /and I /shall be /clean;",
                "thou shalt wash me, and I shall be /whi_ter than /snow."
            ],
            [
                "Thou shalt make me hear of /joy and /glad_ness,",
                "that the bones which thou hast /bro_ken /may re_/joice."
            ],
            [
                "Turn thy /face from my /sins,",
                "and put /out all /my mis_deeds."
            ],
            [
                "Make /me a clean /heart, O /God,",
                "and re_new a right /spi_rit with_/in me."
            ],
            [
                "Cast me not a_way /from thy /pres_ence,",
                "and take not thy ho_ly /Spi_rit /from me."
            ],
            [
                "O give me the com_fort /of thy /help a_gain,",
                "and stab_lish me /with thy /free /Spi_rit."
            ],
            [
                "Then shall I teach thy ways /un_to the /wick_ed,",
                "and sin_ners shall be con_/ver_ted /un_to /thee."
            ],
            [
                "De_li_ver me from blood-_guil_ti_ness, O God, thou that art the /God of my /health;",
                "and my tongue shall /sing of thy /right_eous_ness."
            ],
            [
                "Thou shalt /o_pen my /lips, O Lord,",
                "and my /mouth shall /show thy /praise."
            ],
            [
                "For thou de_sir_est no sac_ri_fice, else /would I /give it thee;",
                "but thou de_light_est /not in burnt-_/off_er_ings."
            ],
            [
                "The sac_ri_fice of God is a /trou_bled /spi_rit:",
                "a bro_ken and con_trite heart, O God, /shalt thou /not des_/pise."
            ],
            [
                "O be fa_vour_a_ble and gra_cious /un_to /Si_on;",
                "build thou the /walls of Je_/ru_sa_/lem."
            ],
            [
                "Then shalt thou be pleased with the sac_ri_fice of right_eous_ness, with the burnt-_off_er_ings /and ob_/la_tions;",
                "then shall they off_er young bull_ocks up_/on thine /al_tar."
            ]
        ]
    },
    {
        id: "psalm52",
        lines: [
            [
                "WHY boast_est thou thy_/self, thou /ty_rant,",
                "that thou /canst do /mis_chief;"
            ],
            [
                "Where_as the /good_ness of /God",
                "en_/dur_eth yet /dai_ly?"
            ],
            [
                "Thy tongue i_/ma_gin_eth /wick_ed_ness,",
                "and with lies thou cutt_est /like a sharp /ra_zor."
            ],
            [
                "Thou hast loved un_right_eous_ness /more than /good_ness,",
                "and false_hood /more than /right_eous_ness."
            ],
            [
                "Thou hast loved to speak all /words that /may do /hurt,",
                "/O thou /false /tongue."
            ],
            [
                "There_fore shall God des_/troy thee for /ev_er;",
                "he shall take thee, and pluck thee out of thy dwell_ing, and root thee out of the /land of the /li_ving."
            ],
            [
                "The right_eous al_so shall /see this, and /fear,",
                "and shall /laugh him to /scorn:"
            ],
            [
                "Lo, this is the man that took not /God for his /strength;",
                "but trust_ed un_to the mul_ti_tude of his rich_es, and strength_en_ed him_self /in his /wick_ed_ness."
            ],
            [
                "As for me, I am like a green ol_ive-_tree /in the /house of /God;",
                "my trust is in the ten_der mer_cy of God for /ev_er and /ev_er."
            ],
            [
                "I will al_way give thanks un_to thee for /that /thou hast /done;",
                "and I will hope in thy Name, for thy /saints like it /well."
            ]
        ]
    },
    {
        id: "psalm53",
        lines: [
            [
                "THE fool_ish bo_dy hath /said in his /heart,",
                "/There is /no God."
            ],
            [
                "Cor_rupt are they, and be_come a_bom_in_a_ble /in their /wick_ed_ness;",
                "there is /none that /do_eth /good."
            ],
            [
                "God looked down from hea_ven up_on the /child_ren of /men,",
                "to see if there were an_y that would un_der_stand, and seek /af_ter /God."
            ],
            [
                "But they are all gone out of the way, they are al_to_ge_ther be_come a_/bom_in_a_/ble;",
                "there is al_so none that do_eth /good, no not /one."
            ],
            [
                "Are not they with_out un_der_stan_ding that /work /wick_ed_ness,",
                "ea_ting up my peo_ple as if they would eat bread? they have not /called up_/on God."
            ],
            [
                "They were a_fraid /where no /fear /was;",
                "for God hath bro_ken the bones of him that be_sieged thee; thou hast put them to con_fu_sion, be_cause God /hath desp_/ised them."
            ],
            [
                "O that the sal_va_tion were gi_ven un_to Is_ra_el /out of /Si_on!",
                "O that the Lord would de_li_ver his peo_ple /out of cap_/ti_vi_ty!"
            ],
            [
                "Then should /Ja_cob re_/joice,",
                "and Is_ra_el /should /be right /glad."
            ]
        ]
    },
    {
        id: "psalm54",
        lines: [
            [
                "SAVE me, O God, /for thy /Name's sake,",
                "and a_venge me in thy /strength."
            ],
            [
                "/Hear my /prayer, O /God,",
                "and hear_ken un_to the /words of my /mouth."
            ],
            [
                "For stran_gers are ri_sen /up a_/gainst me;",
                "and ty_rants, which have not God be_fore their eyes, seek /af_ter my /soul."
            ],
            [
                "Be_hold, /God is my /hel_per;",
                "the Lord is with them that up_hold my /soul."
            ],
            [
                "He shall re_ward e_vil /un_to mine /e_ne_mies:",
                "des_troy thou /them in thy /truth."
            ],
            [
                "An off_er_ing of a free heart will I give thee, and /praise thy /Name, O LORD;",
                "be_cause it is so /com_/for_ta_ble."
            ],
            [
                "For he hath de_li_vered me out of /all my /trou_ble;",
                "and mine eye hath seen his de_sire up_/on mine /e_ne_mies."
            ]
        ]
    },
    {
        id: "psalm55",
        lines: [
            [
                "/HEAR my /prayer, O /God,",
                "and hide not thy_self from /my pe_/ti_tion."
            ],
            [
                "Take heed un_to /me, and /hear me,",
                "how I mourn in my /prayer, and /am /vexed;"
            ],
            [
                "The e_ne_my cri_eth so, and the un_god_ly /com_eth on /so /fast;",
                "for they are min_ded to do me some mis_chief, so ma_li_cious_ly are they /set a_/gainst me."
            ],
            [
                "My heart is dis_qui_et_ed with_/in me,",
                "and the fear of death is /fall_en up_/on me."
            ],
            [
                "Fear_ful_ness and trem_bling are /come up_/on me,",
                "and an hor_ri_ble dread hath /ov_er_/whelmed /me."
            ],
            [
                "And I said, O that I had /wings like a /dove!",
                "for then would I flee a_/way, and /be at /rest."
            ],
            [
                "Lo, then would I /get me a_/way far /off,",
                "and re_main /in the /wil_der_ness."
            ],
            [
                "I would make /haste to es_/cape,",
                "be_cause of the stor_my /wind and /tem_pest."
            ],
            [
                "Des_troy their tongues, O /Lord, and di_/vide them;",
                "for I have spied un_right_eous_ness and /strife in the /ci_ty."
            ],
            [
                "Day and night they go a_bout with_/in the /walls there_/of:",
                "mis_chief al_so and sor_row are /in the /midst of it."
            ],
            [
                "/Wick_ed_ness /is there_/in;",
                "de_ceit and guile go not /out of /her /streets."
            ],
            [
                "For it is not an o_pen e_ne_my that hath done me /this dis_/hon_our;",
                "for then I /could have /borne it;"
            ],
            [
                "Nei_ther was it mine ad_ver_sa_ry that did mag_ni_fy him_/self a_/gainst /me;",
                "for then per_ad_ven_ture I would have /hid my_self /from /him;"
            ],
            [
                "But it was e_ven /thou, my com_/pan_ion,",
                "my guide, and mine /own fam_/il_iar /friend."
            ],
            [
                "We took sweet /coun_sel to_/ge_ther,",
                "and walked in the /house of /God as /friends."
            ],
            [
                "Let death come has_ti_ly up_on them, and let them go down a_live /in_to the /pit;",
                "for wick_ed_ness is in their dwell_ings, /and a_/mong them."
            ],
            [
                "As for me, I will /call up_/on /God,",
                "and the /LORD shall /save me."
            ],
            [
                "In the eve_ning, and mor_ning, and at noon-_day will I pray, /and that /in_stant_ly;",
                "and /he shall /hear my /voice."
            ],
            [
                "It is he that hath de_li_vered my soul in peace from the bat_tle that /was a_/gainst me;",
                "for there were /ma_ny that /strove with me."
            ],
            [
                "Yea, e_ven God, that en_dur_eth for ev_er, shall /hear me, and /bring them /down;",
                "for they will not /turn, nor /fear /God."
            ],
            [
                "He laid his hands up_on such as /be at /peace with /him,",
                "and he /brake his /co_ve_nant."
            ],
            [
                "The words of his mouth were sof_ter than but_ter, hav_ing /war in his /heart;",
                "his words were smooth_er than oil, and /yet be they /ve_ry /swords."
            ],
            [
                "O cast thy bur_den up_on the LORD, and /he shall /nour_ish thee,",
                "and shall not suf_fer the right_eous to /fall for /ev_er."
            ],
            [
                "/And /as for /them,",
                "thou, O God, shalt bring them in_to the /pit of des_/truc_tion."
            ],
            [
                "The blood-_thirs_ty and de_ceit_ful men shall not /live out /half their /days:",
                "ne_ver_the_less, my trust shall /be in /thee, O /Lord."
            ]
        ]
    },
    {
        id: "psalm56",
        lines: [
            [
                "BE mer_ci_ful un_to me, O God, for man go_eth a_/bout to de_/vour me;",
                "he is dai_ly /fight_ing, and /troubl_ing /me."
            ],
            [
                "Mine e_ne_mies are dai_ly at hand to /swal_low me /up;",
                "for they be ma_ny that fight a_gainst me, O /thou Most /High_est."
            ],
            [
                "Ne_ver_the_less, though I am /some_time a_/fraid,",
                "yet /put I my /trust in /thee."
            ],
            [
                "I will praise God, be_/cause of his /word:",
                "I have put my trust in God, and will not fear what /flesh can do /un_to /me."
            ],
            [
                "They /dai_ly mis_/take my /words;",
                "all that they i_ma_gine is to /do me /e_vil."
            ],
            [
                "They hold all to_ge_ther, and /keep them_/selves /close,",
                "and mark my steps, when they lay /wait for /my /soul."
            ],
            [
                "Shall they es_/cape for their /wick_ed_ness?",
                "thou, O God, in thy dis_/plea_sure shalt /cast them /down."
            ],
            [
                "Thou tell_est my wan_der_ings; put my tears /in_to thy /bot_tle:",
                "are not these things /not_ed /in thy /book?"
            ],
            [
                "When_so_ev_er I call up_on thee, then shall mine e_ne_mies /be /put to /flight:",
                "this I know; for /God is /on my /side."
            ],
            [
                "In God's /word will I re_/joice;",
                "in the LORD'S word /will I /com_fort me."
            ],
            [
                "Yea, in /God have I /put my /trust;",
                "I will not be a_fraid what man can /do /un_to /me."
            ],
            [
                "Un_to thee, O /God, will I /pay my /vows;",
                "un_to thee /will I /give /thanks."
            ],
            [
                "For thou hast de_li_vered my soul from death, and my /feet from /fall_ing,",
                "that I may walk be_fore God in the /light of the /li_ving."
            ]
        ]
    },
    {
        id: "psalm57",
        lines: [
            [
                "BE mer_ci_ful un_to me, O God, be mer_ci_ful un_to me; for my soul /trust_eth in /thee;",
                "and un_der the sha_dow of thy wings shall be my re_fuge, un_til this ty_ran_ny /be /ov_er_/past."
            ],
            [
                "I will call /un_to the /Most High /God,",
                "e_ven un_to the God that shall per_form the cause /which I /have in /hand."
            ],
            [
                "He shall /send from /hea_ven,",
                "and save me from the re_proof of /him that would /eat me /up."
            ],
            [
                "God shall send forth his /mer_cy and /truth:",
                "my soul /is a_mong /li_ons;"
            ],
            [
                "And I lie e_ven a_mong the child_ren of /men, that are /set on /fire,",
                "whose teeth are spears and arr_ows, and their /tongue a /sharp /sword."
            ],
            [
                "Set up thy_self, O God, a_/bove the /hea_vens;",
                "and thy glo_ry a_/bove /all the /earth."
            ],
            [
                "They have laid a net for my feet, and /pressed /down my /soul;",
                "they have digged a pit be_fore me, and are fall_en in_to the /midst of /it them_/selves."
            ],
            [
                "My heart is fixed, O God, /my /heart is /fixed;",
                "I will /sing and /give /praise."
            ],
            [
                "A_wake up, my glo_ry; a_/wake, /lute and /harp:",
                "I my_self will a_/wake right /ear_ly."
            ],
            [
                "I will give thanks un_to thee, O Lord, a_/mong the /peo_ples;",
                "and I will sing un_to thee a_/mong the /na_tions."
            ],
            [
                "For the great_ness of thy mer_cy reach_eth un_/to the /hea_vens,",
                "and thy truth /un_to the /clouds."
            ],
            [
                "Set up thy_self, O God, a_/bove the /hea_vens;",
                "and thy glo_ry a_/bove /all the /earth."
            ]
        ]
    },
    {
        id: "psalm58",
        lines: [
            [
                "ARE your minds set up_on right_eous_ness, O ye /con_gre_/ga_tion?",
                "and do ye judge the thing that is right, /O ye /sons of /men?"
            ],
            [
                "Yea, ye i_ma_gine mis_chief in your /heart up_/on the /earth,",
                "and your hands /deal with /wick_ed_ness."
            ],
            [
                "The un_god_ly are fro_ward, e_ven /from their /mo_ther's /womb;",
                "as soon as they are born, they go as_/tray, and /speak /lies."
            ],
            [
                "They are as ve_no_mous as the poi_son /of a /ser_pent,",
                "e_ven like the deaf add_er, that /stopp_eth her /ears;"
            ],
            [
                "Which re_fus_eth to hear the /voice of the /char_mer,",
                "charm he /nev_er so /wise_ly."
            ],
            [
                "Break their teeth, O /God, in their /mouths;",
                "smite the jaw-_bones of the /li_ons, O /LORD."
            ],
            [
                "Let them fall a_way like wa_ter that /runn_eth a_/pace;",
                "when they shoot their arr_ows, /let them be /root_ed /out."
            ],
            [
                "Let them con_sume a_way like a snail, and be like the un_time_ly /fruit of a /wo_man;",
                "and let them /not /see the /sun."
            ],
            [
                "Or ev_er your /pots be made /hot with /thorns,",
                "he shall take them a_way with a whirl_wind, the green and the /burn_ing a_/like."
            ],
            [
                "The right_eous shall re_joice when he /seeth the /ven_geance;",
                "he shall wash his foot_steps in the blood of /the un_/god_ly."
            ],
            [
                "So that a man shall say, Ve_ri_ly there is a re_/ward for the /right_eous;",
                "doubt_less there is a God that /judg_eth the /earth."
            ]
        ]
    },
    {
        id: "psalm59",
        lines: [
            [
                "DE_LI_VER me from mine /e_ne_mies, O /God;",
                "de_fend me from them that rise /up a_/gainst me."
            ],
            [
                "O de_li_ver me from the /wick_ed /do_ers,",
                "and save me from the /blood-_thirs_ty /men."
            ],
            [
                "For lo, they lie /wait_ing /for my /soul;",
                "the migh_ty men are ga_thered a_gainst me, with_out an_y of_fence or /fault of /me, O /LORD."
            ],
            [
                "They run and pre_pare them_/selves with_/out my /fault;",
                "a_rise thou there_fore to /help me, /and be_/hold."
            ],
            [
                "Stand up, O LORD God of hosts, thou God of Is_ra_el, to vis_it /all the /heath_en,",
                "and be not mer_ci_ful un_to them that off_end of ma_/li_cious /wick_ed_ness."
            ],
            [
                "They go to and /fro in the /eve_ning,",
                "they grin like a dog, and run a_/bout through the /ci_ty."
            ],
            [
                "Be_hold, they speak with their mouth, and /swords are /in their /lips;",
                "for /who doth /hear?"
            ],
            [
                "But thou, O LORD, shalt have them /in de_/ri_sion,",
                "and thou shalt laugh all the /heath_en to /scorn."
            ],
            [
                "My strength will I a_/scribe un_to /thee;",
                "for thou art the /God of my /re_fuge."
            ],
            [
                "God show_eth me his /good_ness /plent_eous_ly;",
                "and God shall let me see my de_sire up_/on mine /e_ne_mies."
            ],
            [
                "Slay them not, lest my /peo_ple for_/get it;",
                "but scat_ter them a_broad a_mong the peo_ple, and put them down, O /Lord our de_/fence."
            ],
            [
                "For the sin of their mouth, and for the words of their lips, they shall be /tak_en /in their /pride:",
                "and why? their talk is of /cur_sing and /lies."
            ],
            [
                "Con_sume them in thy wrath, con_sume them, that /they may /per_ish;",
                "and know that it is God that rul_eth in Ja_cob, and un_to the /ends of the /world."
            ],
            [
                "And in the /eve_ning they /will re_/turn,",
                "grin like a dog, and will go a_/bout the /ci_ty."
            ],
            [
                "They will run /here and /there for /meat,",
                "and grudge if they /be not /sa_tis_fied."
            ],
            [
                "As for me, I will sing of thy pow_er, and will praise thy mer_cy be_/times in the /mor_ning;",
                "for thou hast been my de_fence and re_fuge in the /day of my /trou_ble."
            ],
            [
                "Un_to thee, O my /strength, will I /sing;",
                "for thou, O God, art my re_fuge, and my /mer_ci_ful /God."
            ]
        ]
    },
    {
        id: "psalm60",
        lines: [
            [
                "O GOD, thou hast cast us out, and /scat_tered /us a_/broad;",
                "thou hast al_so been dis_pleased: O turn thee /un_to /us a_/gain."
            ],
            [
                "Thou hast moved the /land, and di_/vi_ded /it:",
                "heal the sores there_of, /for it /shak_eth."
            ],
            [
                "Thou hast showed thy /peo_ple /hea_vy /things;",
                "thou hast gi_ven us a /drink of /dead_ly /wine."
            ],
            [
                "Thou hast gi_ven a to_ken for /such as /fear /thee,",
                "that they may tri_umph be_/cause of /the /truth."
            ],
            [
                "There_fore were thy be_/lov_ed de_/li_vered;",
                "help me with thy right /hand, and /hear me."
            ],
            [
                "God hath spo_ken in his ho_li_ness, I will re_joice, and di_/vide /She_chem,",
                "and mete out the /val_ley of /Succ_oth."
            ],
            [
                "Gi_le_ad is mine, and Ma_/na_sseh /is /mine;",
                "Eph_ra_im al_so is the strength of my head; Ju_dah /is my /law-_gi_ver;"
            ],
            [
                "Mo_ab is my wash-_pot; o_ver E_dom will I /cast /out my /shoe;",
                "Phil_is_ti_a, /be thou /glad of /me."
            ],
            [
                "Who will lead me in_to /the strong /ci_ty?",
                "who will bring me /in_to /E_dom?"
            ],
            [
                "Hast not thou /cast us /out, O /God?",
                "wilt not thou, O God, go /out /with our /hosts?"
            ],
            [
                "O be thou our /help in /trou_ble;",
                "for /vain is the /help of /man."
            ],
            [
                "Through /God will we /do great /acts;",
                "for it is he that shall tread /down our /e_ne_mies."
            ]
        ]
    },
    {
        id: "psalm61",
        lines: [
            [
                "HEAR my /cry_ing, O /God,",
                "give /ear un_to /my /prayer."
            ],
            [
                "From the ends of the earth will I /call up_/on thee,",
                "when my /heart is in /hea_vi_ness."
            ],
            [
                "O set me up up_on the rock that is /high_er /than /I;",
                "for thou hast been my hope, and a strong tow_er for me a_/gainst the /e_ne_my."
            ],
            [
                "I will dwell in thy tab_er_/na_cle for /ev_er,",
                "and my trust shall be un_der the /co_ver_ing /of thy /wings."
            ],
            [
                "For thou, O Lord, hast /heard my de_/sires,",
                "and hast gi_ven an he_ri_tage un_to /those that /fear thy /Name."
            ],
            [
                "Thou shalt grant the /King a /long life,",
                "that his years may en_dure through_out all /gen_er_/a_tions."
            ],
            [
                "He shall dwell be_fore /God for /ev_er:",
                "O pre_pare thy lov_ing mer_cy and faith_ful_ness, that they /may pre_/serve /him."
            ],
            [
                "So will I al_way sing praise /un_to thy /Name,",
                "that I may /dai_ly per_/form my /vows."
            ]
        ]
    },
    {
        id: "psalm62",
        lines: [
            [
                "MY soul tru_ly wait_eth /still up_on /God;",
                "for of him com_eth /my sal_/va_tion."
            ],
            [
                "He ve_ri_ly is my strength and /my sal_/va_tion;",
                "he is my de_fence, so that I /shall not /great_ly /fall."
            ],
            [
                "How long will ye i_ma_gine mis_chief a_/gainst eve_ry /man?",
                "Ye shall be slain all the sort of you; yea, as a tot_ter_ing wall shall ye be, and /like a /bro_ken /hedge."
            ],
            [
                "Their de_vice is on_ly how to put him out whom /God will ex_/alt;",
                "their de_light is in lies; they give good words with their mouth, but /curse with /their /heart."
            ],
            [
                "Ne_ver_the_less, my soul, wait thou /still up_/on /God;",
                "for my /hope is /in /him."
            ],
            [
                "He tru_ly is my strength and /my sal_/va_tion;",
                "he is my de_fence, /so that I /shall not /fall."
            ],
            [
                "In God is my /health and my /glo_ry;",
                "the rock of my might; and in /God is /my /trust."
            ],
            [
                "O put your trust in him al_/way, ye /peo_ple;",
                "pour out your hearts be_fore him, for /God is our /hope."
            ],
            [
                "As for the child_ren of men, they are but va_ni_ty; the child_ren of /men are de_/ceit_ful;",
                "up_on the weights they are al_to_ge_ther light_er than /va_ni_ty /it_/self."
            ],
            [
                "O trust not in wrong and robb_e_ry; give not your_selves /un_to /va_ni_ty:",
                "if rich_es in_crease, set not your /heart up_/on them."
            ],
            [
                "God spake once, and twice I have /al_so /heard the /same,",
                "that pow_er be_/long_eth /un_to /God;"
            ],
            [
                "And that thou, /Lord, art /mer_ci_ful;",
                "for thou re_ward_est eve_ry man ac_/cor_ding /to his /work."
            ]
        ]
    },
    {
        id: "psalm63",
        lines: [
            [
                "O GOD, /thou art my /God;",
                "ear_ly /will I /seek thee."
            ],
            [
                "My soul thirst_eth for thee, my flesh al_so /long_eth /af_ter /thee,",
                "in a bar_ren and dry /land where no /wa_ter /is."
            ],
            [
                "Thus have I looked for thee in the /sanc_tu_/a_ry,",
                "that I might be_hold thy pow'r and /glo_ry."
            ],
            [
                "For thy lov_ing-_kind_ness is bet_ter /than the /life it_/self:",
                "my /lips shall /praise thee."
            ],
            [
                "As long as I live will I mag_ni_fy thee /in this /man_ner,",
                "and lift up my /hands in /thy /Name."
            ],
            [
                "My soul shall be sa_tis_fied, e_ven as it were with /mar_row and /fat_ness,",
                "when my mouth prais_eth /thee with /joy_ful /lips."
            ],
            [
                "Have I not re_/mem_bered thee /in my /bed,",
                "and thought up_on thee /when I /was /wak_ing?"
            ],
            [
                "Be_cause thou hast /been my /hel_per;",
                "there_fore un_der the sha_dow of thy /wings will /I re_/joice."
            ],
            [
                "My soul /hang_eth up_/on /thee;",
                "thy right /hand hath up_/hold_en me."
            ],
            [
                "These al_so that seek the /hurt of /my /soul,",
                "they shall go /un_der the /earth."
            ],
            [
                "Let them fall up_on the /edge /of the /sword,",
                "that they may be a /por_tion for /fox_es."
            ],
            [
                "But the King shall re_joice in God; all they al_so that swear by him shall /be com_/men_ded;",
                "for the mouth of them that speak /lies /shall be /stopped."
            ]
        ]
    },
    {
        id: "psalm64",
        lines: [
            [
                "HEAR my voice, O /God, in my /prayer;",
                "pre_serve my life from /fear of the /e_ne_my."
            ],
            [
                "Hide me from the gath_er_ing to_ge_ther /of the /fro_ward,",
                "and from the in_sur_rec_tion of /wick_ed /do_ers;"
            ],
            [
                "Who have whet their /tongue /like a /sword,",
                "and shoot out their arr_ows, /e_ven /bit_ter /words;"
            ],
            [
                "That they may pri_vi_ly shoot at him /that is /per_fect:",
                "sud_den_ly do they /hit him, and /fear not."
            ],
            [
                "They en_cour_age them_/selves in /mis_chief,",
                "and comm_une a_mong them_selves, how they may lay snares; and say, that no /man shall /see them."
            ],
            [
                "They i_ma_gine wick_ed_ness, and /prac_tise it;",
                "that they keep sec_ret a_mong them_selves, eve_ry man in the /deep of his /heart."
            ],
            [
                "But God shall sud_den_ly shoot at them with a /swift /ar_row,",
                "that they /shall be /woun_ded."
            ],
            [
                "Yea, their own /tongues shall /make them /fall;",
                "in_so_much that who_so seeth them shall /laugh them to /scorn."
            ],
            [
                "And all men that see it shall say, /This hath /God done;",
                "for they shall per_ceive that it is /his work."
            ],
            [
                "The right_eous shall re_joice in the LORD, and /put his /trust in him;",
                "and all they that are true of /heart shall be /glad."
            ]
        ]
    },
    {
        id: "psalm65",
        lines: [
            [
                "THOU, O God, art /praised in /Si_on;",
                "and un_to thee shall the vow be per_/formed in Je_/ru_sa_lem."
            ],
            [
                "Thou that /hear_est the /prayer,",
                "un_to /thee shall all /flesh come."
            ],
            [
                "My mis_deeds pre_/vail a_/gainst /me:",
                "O be thou mer_ci_ful /un_to our /sins."
            ],
            [
                "Bless_ed is the man whom thou choos_est, and re_/ceiv_est /un_to /thee:",
                "he shall dwell in thy court, and shall be sa_tis_fied with the plea_sures of thy house, e_ven of thy /ho_ly /tem_ple."
            ],
            [
                "Thou shalt show us won_der_ful things in thy right_eous_ness, O God of /our sal_/va_tion;",
                "thou that art the hope of all the ends of the earth, and of them that re_/main in the /broad /sea."
            ],
            [
                "Who in his strength set_teth /fast the /moun_tains,",
                "and is gir_ded a_/bout with /pow_er."
            ],
            [
                "Who still_eth the /rag_ing /of the /sea,",
                "and the noise of his waves, and the mad_ness /of the /peo_ples."
            ],
            [
                "They al_so that dwell in the ut_ter_most parts of the earth shall be a_/fraid at thy /tok_ens,",
                "thou that mak_est the out-_go_ings of the mor_ning and /eve_ning to /praise thee."
            ],
            [
                "Thou vis_it_est the /earth, and /bless_est it;",
                "thou mak_est it /ve_ry /plen_te_ous."
            ],
            [
                "The ri_ver of God is /full of /wa_ter:",
                "thou pre_par_est their corn, for so thou pro_/vi_dest /for the /earth."
            ],
            [
                "Thou wa_ter_est her furr_ows; thou send_est rain in_to the lit_tle /vall_eys there_/of;",
                "thou mak_est it soft with the drops of rain, and bless_est the /in_crease of /it."
            ],
            [
                "Thou crown_est the year /with thy /good_ness;",
                "and thy /clouds drop /fat_ness."
            ],
            [
                "They shall drop up_on the dwell_ings /of the /wil_der_ness;",
                "and the lit_tle hills shall re_/joice on /eve_ry /side."
            ],
            [
                "The folds /shall be /full of /sheep;",
                "the vall_eys al_so shall stand so thick with corn, that /they shall /laugh and /sing."
            ]
        ]
    },
    {
        id: "psalm66",
        lines: [
            [
                "O BE joy_ful in /God, all ye /lands;",
                "sing prais_es un_to the ho_nour of his Name; make his /praise to be /glo_ri_ous."
            ],
            [
                "Say un_to God, O how won_der_ful art /thou in /thy /works!",
                "through the great_ness of thy pow_er shall thine e_ne_mies bow /down /un_to /thee."
            ],
            [
                "For all the /world shall /wor_ship thee,",
                "sing of /thee, and /praise thy /Name."
            ],
            [
                "O come hi_ther, and be_/hold the /works of /God;",
                "how won_der_ful he is in his do_ing to_ward the /child_ren /of /men."
            ],
            [
                "He turned the sea /in_to /dry /land,",
                "so that they went through the wa_ter on foot; there did /we re_/joice there_/of."
            ],
            [
                "He rul_eth with his pow_er for ev_er; his eyes be_/hold the /na_tions:",
                "and such as will not be_lieve shall not be a_ble /to ex_/alt them_/selves."
            ],
            [
                "O praise our /God, ye /peo_ples,",
                "and make the voice of his /praise to be /heard;"
            ],
            [
                "Who /hold_eth our /soul in /life;",
                "and suff_er_eth /not our /feet to /slip."
            ],
            [
                "For thou, O /God, hast /proved us;",
                "thou al_so hast tried us, like as /sil_ver is /tried."
            ],
            [
                "Thou brought_est us /in_to the /snare;",
                "and laid_est /trou_ble up_/on our /loins."
            ],
            [
                "Thou suffer_edst men to ride /o_ver our /heads;",
                "we went through fire and wa_ter, and thou brought_est us out /in_to a /weal_thy /place."
            ],
            [
                "I will go in_to thine house with burnt-_off_er_ings, and will /pay thee my /vows,",
                "which I prom_ised with my lips, and spake with my mouth, when /I was in /trou_ble."
            ],
            [
                "I will off_er un_to thee fat burnt-_sac_ri_fi_ces, with the /in_cense of /rams;",
                "I will off_er /bull_ocks and /goats."
            ],
            [
                "O come hi_ther, and hear_ken, all /ye that /fear /God;",
                "and I will tell you what he hath /done for /my /soul."
            ],
            [
                "I called un_to /him with my /mouth,",
                "and gave him /prais_es /with my /tongue."
            ],
            [
                "If I in_cline un_to /wick_ed_ness /with mine /heart,",
                "the Lord /will not /hear me."
            ],
            [
                "But /God hath /heard me;",
                "and con_sid_ered the /voice of my /prayer."
            ],
            [
                "Praised be God, who hath not /cast out my /prayer,",
                "nor turned his /mer_cy /from /me."
            ]
        ]
    },
    {
        id: "psalm67",
        lines: [
            [
                "GOD be mer_ci_ful un_to /us, and /bless us,",
                "and show us the light of his coun_te_nance, and be /mer_ci_ful /un_to /us;"
            ],
            [
                "That thy way may be /known up_/on /earth,",
                "thy sav_ing health a_/mong all /na_tions."
            ],
            [
                "Let the peo_ples /praise thee, O /God;",
                "yea, let all the /peo_ples /praise thee."
            ],
            [
                "O let the na_tions re_/joice and be /glad;",
                "for thou shalt judge the folk right_eous_ly, and gov_ern the /na_tions up_on /earth."
            ],
            [
                "Let the peo_ples /praise thee, O /God;",
                "yea, let all the /peo_ples /praise thee."
            ],
            [
                "Then shall the earth bring /forth her /in_crease;",
                "and God, e_ven our own God, shall /give us his /bless_ing."
            ],
            [
                "/God shall /bless us;",
                "and all the ends of the /world shall /fear him."
            ]
        ]
    },
    {
        id: "psalm68",
        lines: [
            [
                "LET God a_rise, and let his /e_ne_mies be /scat_tered;",
                "let them al_so that hate him /flee be_/fore him."
            ],
            [
                "Like as the smoke van_ish_eth, so shalt thou /drive them a_/way;",
                "and like as wax melt_eth at the fire, so let the un_god_ly per_ish at the /pres_ence /of /God."
            ],
            [
                "But let the right_eous be glad, and re_/joice be_/fore /God;",
                "let them al_so be /mer_ry and /joy_ful."
            ],
            [
                "O sing un_to God, and sing prais_es un_to his Name; mag_ni_fy him that rid_eth up_/on the /hea_vens;",
                "praise him in his Name JAH, and re_/joice be_/fore him."
            ],
            [
                "He is a Fa_ther of the fa_ther_less, and de_fend_eth the /cause of the /wid_ows;",
                "e_ven God in his ho_ly /ha_bi_/ta_tion."
            ],
            [
                "He is the God that mak_eth men to be of one mind in an house, and bring_eth the pris_on_ers /out of cap_/ti_vi_ty;",
                "but let_teth the run_a_gates con_/tin_ue in /scarce_ness."
            ],
            [
                "O God, when thou went_est forth be_/fore the /peo_ple;",
                "when thou went_est /through the /wil_der_ness,"
            ],
            [
                "The earth shook, and the hea_vens dropped at the /pres_ence /of /God;",
                "e_ven as Si_nai al_so was moved at the pres_ence of God, who is the /God of /Is_ra_el."
            ],
            [
                "Thou, O God, sent_est a gra_cious rain up_on /thine in_/he_ri_tance,",
                "and ref_resh_edst it /when it was /wea_ry."
            ],
            [
                "Thy con_gre_/ga_tion shall /dwell there_in;",
                "for thou, O God, hast of thy good_ness pre_/pared /for the /poor."
            ],
            [
                "The /Lord gave the /word;",
                "great was the com_pa_ny of wo_men that /bare the /tid_ings."
            ],
            [
                "Kings with their arm_ies did flee, and /were dis_/com_fit_ed,",
                "and they of the house_hold di_/vi_ded /the /spoil."
            ],
            [
                "Though ye have lain a_mong the sheep-_folds, yet shall ye be as the /wings of a /dove",
                "that is co_vered with sil_ver wings, and her /feath_ers /like /gold."
            ],
            [
                "When the Al_migh_ty scat_tered /kings for their /sake,",
                "then were they as white as /snow in /Sal_mon."
            ],
            [
                "As the hill of Ba_shan, /so is /God's hill;",
                "e_ven an high hill, as the /hill of /Ba_shan."
            ],
            [
                "Why mock ye so, ye high hills? this is God's hill, in the which it /pleas_eth /him to /dwell;",
                "yea, the LORD will a_bide in /it for /ev_er."
            ],
            [
                "The cha_ri_ots of God are twen_ty thou_sand, e_ven /thou_sands of /an_gels;",
                "and the Lord is a_mong them as in the ho_ly /place of /Si_nai."
            ],
            [
                "Thou art gone up on high, thou hast led cap_ti_vi_ty cap_tive, and re_/ceived /gifts from /men;",
                "yea, e_ven from thine e_ne_mies, that the LORD God might /dwell a_/mong them."
            ],
            [
                "Praised /be the Lord /dai_ly,",
                "e_ven the God who help_eth us, and pour_eth his be_ne_/fits up_/on us."
            ],
            [
                "He is our God, e_ven the God of whom /com_eth sal_/va_tion:",
                "GOD is the Lord, by /whom we es_/cape /death."
            ],
            [
                "God shall wound the /head of his /e_ne_mies,",
                "and the hai_ry scalp of such a one as go_eth on /still in his /wick_ed_ness."
            ],
            [
                "The Lord hath said, I will bring my peo_ple a_gain, as I /did from /Ba_shan;",
                "mine own will I bring a_gain, as I did some_time from the /deep of the /sea."
            ],
            [
                "That thy foot may be dipped in the /blood of thine /e_ne_mies,",
                "and that the tongue of thy dogs may be /red through the /same."
            ],
            [
                "It is well seen, O God, /how thou /go_est;",
                "how thou, my God and King, go_est in the /sanc_tu_/a_ry."
            ],
            [
                "The sing_ers go be_fore, the min_strels /fol_low /af_ter,",
                "in the midst of the dam_sels play_ing /with the /tim_brels."
            ],
            [
                "Give thanks un_to God the Lord in the /con_gre_/ga_tion,",
                "ye that are of the /foun_tain of /Is_ra_el."
            ],
            [
                "There is lit_tle Ben_ja_min their ru_ler, and the prin_ces of /Ju_dah their /coun_cil;",
                "the prin_ces of Ze_bu_lon, and the prin_ces /of Naph_/tha_li."
            ],
            [
                "Thy God hath /sent forth /strength for /thee;",
                "stab_lish the thing, O God, that /thou hast /wrought in /us,"
            ],
            [
                "For thy temp_le's /sake at Je_/ru_sa_lem;",
                "so shall kings bring /pres_ents /un_to /thee."
            ],
            [
                "Re_buke thou the dra_gon and the bull, with the lead_ers of the heath_en, so that they humb_ly bring /pie_ces of /sil_ver;",
                "scat_ter thou the peo_ples /that de_/light in /war;"
            ],
            [
                "Then shall the prin_ces come /out of /E_gypt;",
                "the Mo_ri_ans' land shall soon stretch out her /hands un_to /God."
            ],
            [
                "Sing un_to God, O ye /king_doms /of the /earth;",
                "O sing prais_es /un_/to the /Lord;"
            ],
            [
                "Who sitt_eth in the hea_vens o_ver all, /from the be_/ginn_ing:",
                "lo, he doth send out his voice; yea, and /that a /migh_ty /voice."
            ],
            [
                "A_scribe ye the pow_er to God /o_ver /Is_ra_el;",
                "his wor_ship and /strength is /in the /clouds."
            ],
            [
                "O God, won_der_ful art thou in thy /ho_ly /pla_ces:",
                "e_ven the God of Is_ra_el, he will give strength and pow_er un_to his peo_ple. /Bless_ed be /God."
            ]
        ]
    },
    {
        id: "psalm69",
        lines: [
            [
                "SAVE me, O /God;",
                "for the wa_ters are come in, e_ven /un_to my /soul."
            ],
            [
                "I stick fast in the deep mire, /where no /ground is;",
                "I am come in_to deep wa_ters, so that the /floods run /o_ver me."
            ],
            [
                "I am wea_ry of cry_ing; /my /throat is /dry;",
                "my sight fail_eth me for wait_ing so /long up_/on my /God."
            ],
            [
                "They that hate me with_out a cause are more than the /hairs of my /head;",
                "they that are mine e_ne_mies, and would des_troy me /guilt_less, are /migh_ty."
            ],
            [
                "I paid them the /things that I /nev_er /took:",
                "God, thou know_est my sim_ple_ness, and my /faults are not /hid from thee."
            ],
            [
                "Let not them that trust in thee, O Lord GOD of hosts, be a_/shamed for my /cause;",
                "let not those that seek thee be con_foun_ded through me, O Lord /God of /Is_ra_el."
            ],
            [
                "And why? for thy sake have I /suff_ered re_/proof;",
                "shame hath /co_vered my /face."
            ],
            [
                "I am be_come a stran_ger /un_to my /breth_ren,",
                "e_ven an a_li_en un_to my /mo_ther's /child_ren."
            ],
            [
                "For the zeal of thine house hath /e_ven /eat_en me;",
                "and the re_bukes of them that re_buked thee are /fall_en up_/on me."
            ],
            [
                "I wept, and chast_ened my_/self with /fast_ing,",
                "and that was /turned to my /re_/proof."
            ],
            [
                "I put on /sack_cloth /al_so,",
                "and they /jes_ted up_/on me."
            ],
            [
                "They that sit in the /gate speak a_/gainst me,",
                "and the drunk_ards make /songs up_/on me."
            ],
            [
                "But, LORD, I make my /prayer un_to /thee",
                "in an ac_/cep_ta_ble /time."
            ],
            [
                "Hear me, O God, in the mul_ti_tude /of thy /mer_cy,",
                "e_ven in the truth of /thy sal_/va_tion."
            ],
            [
                "Take me out of the /mire, that I /sink not;",
                "O let me be de_li_vered from them that hate me, and out of the deep /wa_ters."
            ],
            [
                "Let not the wa_ter-_flood drown me, nei_ther let the deep /swal_low me /up;",
                "and let not the pit shut her /mouth up_/on me."
            ],
            [
                "Hear me, O LORD, for thy lov_ing-_kind_ness is /com_fort_able;",
                "turn thee un_to me ac_cor_ding to the mul_ti_tude /of thy /mer_cies."
            ],
            [
                "And hide not thy face from thy ser_vant; for /I am in /trou_ble:",
                "O /haste thee, and /hear me."
            ],
            [
                "Draw nigh un_to my /soul, and /save it;",
                "O de_li_ver me, be_/cause of mine /e_ne_mies."
            ],
            [
                "Thou hast known my rep_roach, my shame, and /my dis_/hon_our:",
                "mine ad_ver_sa_ries are /all /in thy /sight."
            ],
            [
                "Rep_roach hath bro_ken my heart; I am /full of /hea_vi_ness:",
                "I looked for some to have pi_ty on me, but there was no man, nei_ther found I /an_y to /com_fort me."
            ],
            [
                "They /gave me /gall to /eat;",
                "and when I was thirs_ty they gave me /vi_ne_gar to /drink."
            ],
            [
                "Let their ta_ble be made a snare to /take them_/selves with_/al;",
                "and let the things that should have been for their wealth be un_to them an oc_/ca_sion of /fall_ing."
            ],
            [
                "Let their eyes be blin_ded, /that they /see not;",
                "and ev_er /bow thou /down their /backs."
            ],
            [
                "Pour out thine in_dig_/na_tion up_/on them,",
                "and let thy wrath_ful dis_/plea_sure take /hold of them."
            ],
            [
                "Let their ha_bi_/ta_tion be /void,",
                "and no man to /dwell in their /tents."
            ],
            [
                "For they per_se_cute him whom /thou hast /smit_ten;",
                "and they talk how they may vex them whom /thou hast /woun_ded."
            ],
            [
                "Let them fall from one wick_ed_ness /to a_/no_ther,",
                "and not come /in_to thy /right_eous_ness."
            ],
            [
                "Let them be wiped out of the /book of the /li_ving,",
                "and not be writ_ten a_/mong the /right_eous."
            ],
            [
                "As for me, when I am /poor and in /hea_vi_ness,",
                "thy help, O /God, shall /lift me /up."
            ],
            [
                "I will praise the Name of /God with a /song,",
                "and mag_ni_fy it /with thanks_/giv_ing."
            ],
            [
                "This al_so /shall please the /LORD",
                "bet_ter than a bull_ock /that hath /horns and /hoofs."
            ],
            [
                "The hum_ble shall con_si_der /this, and be /glad:",
                "seek ye af_ter God, /and your /soul shall /live."
            ],
            [
                "For the LORD /hear_eth the /poor,",
                "and des_pis_eth /not his /pris_on_ers."
            ],
            [
                "Let hea_ven /and earth /praise him:",
                "the sea, and all that /mov_eth there_/in."
            ],
            [
                "For God will save Si_on, and build the /ci_ties of /Ju_dah,",
                "that men may dwell there, and have it /in pos_/sess_ion."
            ],
            [
                "The pos_te_ri_ty al_so of his ser_vants /shall in_/he_rit it;",
                "and they that love his /Name shall /dwell there_/in."
            ]
        ]
    },
    {
        id: "psalm70",
        lines: [
            [
                "HASTE thee, O /God, to de_/li_ver me;",
                "make haste to /help me, /O /LORD."
            ],
            [
                "Let them be a_shamed and con_foun_ded that seek /af_ter my /soul;",
                "let them be turned back_ward and put to con_fu_sion that /wish me /e_vil."
            ],
            [
                "Let them for their re_ward be /soon /brought to /shame,",
                "that cry /o_ver me, /There! there!"
            ],
            [
                "But let all those that seek thee be /joy_ful and /glad in thee:",
                "and let all such as de_light in thy sal_va_tion say al_way, /The /Lord be /praised."
            ],
            [
                "As for me, I am /poor and in /mi_se_ry:",
                "haste thee /un_to me, /O God."
            ],
            [
                "Thou art my hel_per, and /my re_/dee_mer:",
                "O LORD, make /no long /tar_ry_ing."
            ]
        ]
    },
    {
        id: "psalm71",
        lines: [
            [
                "IN thee, O LORD, have I put my trust; let me nev_er be /put to con_/fu_sion,",
                "but rid me and de_li_ver me in thy right_eous_ness; in_cline thine ear un_to /me, and /save me."
            ],
            [
                "Be thou my strong_hold, where_un_to I may /al_way res_/ort:",
                "thou hast prom_ised to help me, for thou art my house of de_/fence, and my /ca_stle."
            ],
            [
                "De_li_ver me, O my God, out of the hand of /the un_/god_ly,",
                "out of the hand of the un_/right_eous and /cru_el /man."
            ],
            [
                "For thou, O Lord GOD, art the /thing that I /long for:",
                "thou art my hope, /e_ven /from my /youth."
            ],
            [
                "Through thee have I been hold_en up ev_er /since /I was /born:",
                "thou art he that took me out of my mo_ther's womb: my praise shall be /al_way of /thee."
            ],
            [
                "I am be_come as it were a mon_ster /un_to /ma_ny,",
                "but my sure /trust is in /thee."
            ],
            [
                "O let my mouth be /filled with /thy /praise,",
                "that I may sing of thy glo_ry and ho_nour /all the /day /long."
            ],
            [
                "Cast me not a_/way in the /time of /age;",
                "for_sake me not when /my strength /fail_eth me."
            ],
            [
                "For mine e_ne_mies /speak a_/gainst me;",
                "and they that lay wait for my soul take their coun_sel to_/ge_ther, /say_ing,"
            ],
            [
                "God /hath for_/sa_ken him;",
                "per_se_cute him, and take him, for there is /none to de_/li_ver /him."
            ],
            [
                "Go not /far from /me, O /God;",
                "my God, /haste thee to /help me."
            ],
            [
                "Let them be con_foun_ded and per_ish /that are a_/gainst my /soul;",
                "let them be co_vered with shame and dis_hon_our that seek to /do me /e_vil."
            ],
            [
                "As for me, I will pa_tient_/ly a_bide /al_way,",
                "and will /praise thee /more and /more."
            ],
            [
                "My mouth shall dai_ly speak of thy right_eous_ness /and sal_/va_tion;",
                "for I /know no /end there_/of."
            ],
            [
                "I will go forth in the /strength of the /Lord GOD,",
                "and will make men_tion of thy /right_eous_ness /on_ly."
            ],
            [
                "Thou, O God, hast taught me from my youth /up un_/til /now;",
                "there_fore will I /tell of thy /won_drous /works."
            ],
            [
                "For_sake me not, O God, in mine old age, when /I am /gray-_/head_ed,",
                "un_til I have showed thy strength un_to this ge_ne_ra_tion, and thy pow_er to all them that are /yet for to /come."
            ],
            [
                "Thy right_eous_ness, O /God, is /ve_ry /high,",
                "and great things are they that thou hast done: O God, who is /like /un_to /thee!"
            ],
            [
                "O what great trou_bles and ad_ver_si_ties hast thou showed me! and yet didst thou /turn and ref_/resh me;",
                "yea, and brought_est me from the /deep of the /earth a_/gain."
            ],
            [
                "Thou hast brought me /to great /ho_nour,",
                "and com_for_ted /me on /eve_ry /side:"
            ],
            [
                "There_fore will I praise thee, and thy faith_ful_ness, O God, play_ing up_on an in_stru_/ment of /mu_sic:",
                "un_to thee will I sing up_on the harp, O thou Ho_ly /One of /Is_ra_el."
            ],
            [
                "My lips will be glad when I /sing un_to /thee;",
                "and so will my soul whom thou /hast de_/li_vered."
            ],
            [
                "My tongue al_so shall talk of thy right_eous_ness /all the day /long;",
                "for they are con_foun_ded and brought un_to shame that seek to /do me /e_vil."
            ]
        ]
    },
    {
        id: "psalm72",
        lines: [
            [
                "GIVE the King thy /judg_ments, O /God,",
                "and thy right_eous_ness /un_to the /King's son."
            ],
            [
                "Then shall he judge thy peo_ple ac_/cor_ding /un_to /right,",
                "/and de_/fend the poor."
            ],
            [
                "The moun_tains /al_so /shall bring /peace,",
                "and the lit_tle hills right_eous_ness /un_to the /peo_ple."
            ],
            [
                "He shall keep the sim_ple /folk /by their /right,",
                "de_fend the child_ren of the poor, and pu_nish /the wrong /do_er."
            ],
            [
                "They shall fear thee, as long as the sun and /moon en_/dur_eth,",
                "from one ge_ne_ra_tion /to a_/no_ther."
            ],
            [
                "He shall come down like the rain up_/on the /mown grass,",
                "e_ven as the drops that /wa_ter the /earth."
            ],
            [
                "In his time shall the /right_eous /flou_rish;",
                "yea, and ab_un_dance of peace, so long as the /moon en_/dur_eth."
            ],
            [
                "His do_min_ion shall be al_so from the one /sea to the /oth_er,",
                "and from the Ri_ver /un_to the /world's end."
            ],
            [
                "They that dwell in the wil_der_ness shall /kneel be_/fore him;",
                "his e_ne_mies /shall /lick the /dust."
            ],
            [
                "The kings of Tar_shish and of the /isles shall give /pres_ents;",
                "the kings of A_ra_bi_a and /Sa_ba shall /bring /gifts."
            ],
            [
                "All kings shall fall /down be_/fore him;",
                "all na_tions shall /do him /ser_vice."
            ],
            [
                "For he shall de_li_ver the /poor when he /cri_eth;",
                "the nee_dy al_so, and him that /hath no /hel_per."
            ],
            [
                "He shall be fa_vour_a_ble to the /sim_ple and /nee_dy,",
                "and shall pre_serve the /souls /of the /poor."
            ],
            [
                "He shall de_li_ver their souls from /false_hood and /wrong;",
                "and dear shall their /blood be /in his /sight."
            ],
            [
                "He shall live, and un_to him shall be gi_ven of the /gold of A_/ra_bi_a;",
                "prayer shall be made ev_er un_to him, and dai_ly /shall /he be /praised."
            ],
            [
                "There shall be an heap of corn in the earth, high up_on the hills; the fruit there_of shall /shake like /Le_ba_non:",
                "and they of the ci_ty shall flou_rish like /grass up_/on the /earth."
            ],
            [
                "His Name shall en_dure for ev_er; his Name shall re_main un_der the sun a_mong the pos_te_ri_ties, which /shall be /blessed in /him;",
                "and all the /na_tions shall /praise him."
            ],
            [
                "Bless_ed be the LORD God, e_ven the /God of /Is_ra_el,",
                "which on_ly /do_eth /won_drous /things;"
            ],
            [
                "And bless_ed be the Name of his ma_jes_ty for /ev_er:",
                "and all the earth shall be filled with his ma_jes_ty. /A_men, /A_men."
            ]
        ]
    },
    {
        id: "psalm73",
        lines: [
            [
                "TRU_LY God is lov_ing /un_to /Is_ra_el:",
                "e_ven un_to such as are /of a /clean /heart."
            ],
            [
                "Ne_ver_the_less, my /feet were /al_most /gone,",
                "my /tread_ings had /well-_nigh /slipt."
            ],
            [
                "And why? I was /grieved at the /wick_ed:",
                "I do al_so see the un_god_ly in /such pros_/pe_ri_ty."
            ],
            [
                "For they are in no /pe_ril of /death;",
                "but are /lus_ty and /strong."
            ],
            [
                "They come in no mis_/for_tune like /oth_er /folk;",
                "nei_ther are they /plagued like /oth_er /men."
            ],
            [
                "And this is the cause that they are so /hold_en with /pride,",
                "and cruel_ty co_ver_eth them /as a /gar_ment."
            ],
            [
                "Their eyes /swell with /fat_ness,",
                "and they do /e_ven /what they /lust."
            ],
            [
                "They cor_rupt oth_er, and speak of /wick_ed /blas_phe_my;",
                "their talk_ing is a_/gainst the /Most /High."
            ],
            [
                "For they stretch forth their mouth /un_to the /hea_ven,",
                "and their tongue /go_eth /through the /world."
            ],
            [
                "There_fore fall the /peo_ple /un_to /them,",
                "and there_out suck they no /small ad_/van_tage."
            ],
            [
                "Tush, say they, how should /God per_/ceive it?",
                "is there know_ledge /in the /Most /High?"
            ],
            [
                "Lo, these are /the un_/god_ly,",
                "these pros_per in the world, and these have rich_es /in pos_/sess_ion:"
            ],
            [
                "And I said, Then have I /cleansed my /heart in /vain,",
                "and washed my hands in /in_no_/cen_cy."
            ],
            [
                "All the day long have /I been /pun_ished,",
                "and chast_ened /eve_ry /mor_ning."
            ],
            [
                "Yea, and I had al_most said /e_ven as /they;",
                "but lo, then I should have con_demned the ge_ne_ra_tion /of thy /child_ren."
            ],
            [
                "Then thought I to /un_der_/stand this;",
                "but it /was too /hard for /me,"
            ],
            [
                "Un_til I went in_to the sanc_tu_/a_ry of /God:",
                "then un_der_stood I the /end of /these /men;"
            ],
            [
                "Name_ly, how thou dost set them in /slip_pe_ry /pla_ces,",
                "and cast_est them down, /and des_/troy_est /them."
            ],
            [
                "O how sud_den_ly /do they con_/sume,",
                "per_ish, and /come to a /fear_ful /end!"
            ],
            [
                "Yea, e_ven like as a dream when /one a_/wak_eth;",
                "so shalt thou make their im_age to van_ish /out of the /ci_ty."
            ],
            [
                "Thus /my /heart was /grieved,",
                "and it went /e_ven /through my /reins."
            ],
            [
                "So fool_ish was /I, and /ig_no_rant,",
                "e_ven as it were a /beast be_/fore thee."
            ],
            [
                "Ne_ver_the_less, I am /al_way by /thee;",
                "for thou hast hold_en me /by my /right hand."
            ],
            [
                "Thou shalt guide me /with thy /coun_sel,",
                "and af_ter that re_/ceive me with /glo_ry."
            ],
            [
                "Whom have I in /hea_ven but /thee?",
                "and there is none up_on earth that I de_sire in com_/pa_ri_son /of /thee."
            ],
            [
                "My flesh /and my heart /fail_eth;",
                "but God is the strength of my heart, and my /por_tion for /ev_er."
            ],
            [
                "For lo, they that for_/sake thee shall /per_ish;",
                "thou hast des_troyed all them that are un_/faith_ful /un_to /thee."
            ],
            [
                "But it is good for me to hold me fast by God, to put my /trust in the /Lord GOD,",
                "and to speak of all thy works in the gates of the /daugh_ter of /Si_on."
            ]
        ]
    },
    {
        id: "psalm74",
        lines: [
            [
                "O GOD, where_fore art thou ab_sent /from us /so /long?",
                "why is thy wrath so hot a_gainst the /sheep of thy /pas_ture?"
            ],
            [
                "O think up_on thy /con_gre_/ga_tion,",
                "whom thou hast purch_ased, /and re_/deemed of /old."
            ],
            [
                "Think up_on the tribe of /thine in_/he_ri_tance,",
                "and Mount Si_on, /where_in thou /hast /dwelt."
            ],
            [
                "Lift up thy feet, that thou may_est utt_er_ly des_troy /eve_ry /e_ne_my,",
                "which hath done e_vil in thy /sanc_tu_/a_ry."
            ],
            [
                "Thine ad_ver_sa_ries roar in the midst of thy /con_gre_/ga_tions,",
                "and set up their /ban_ners for /tok_ens."
            ],
            [
                "He that hewed tim_ber a_fore /out of the /thick /trees,",
                "was known to bring it to an /ex_cell_ent /work."
            ],
            [
                "But now they break down all the /carved /work there_/of",
                "with /ax_es and /ham_mers."
            ],
            [
                "They have set fire up_on thy /ho_ly /pla_ces,",
                "and have de_filed the dwell_ing-_place of thy Name, e_ven /un_to the /ground."
            ],
            [
                "Yea, they said in their hearts, Let us make hav_oc of them /al_to_/ge_ther:",
                "thus have they burnt up all the hou_ses of /God in the /land."
            ],
            [
                "We see not our tok_ens; there is not /one /pro_phet /more;",
                "no, not one is there a_mong us, that un_der_/stand_eth /an_y /more."
            ],
            [
                "O God, how long shall the ad_ver_sa_ry /do this dis_/hon_our?",
                "shall the e_ne_my blas_pheme thy /Name for /ev_er?"
            ],
            [
                "Why with_/draw_est /thou thy /hand?",
                "why pluck_est thou not thy right hand out of thy bo_som to con_/sume the /e_ne_my?"
            ],
            [
                "For /God is my /King of /old;",
                "the help that is done up_on earth, he /do_eth /it him_/self."
            ],
            [
                "Thou didst di_vide the sea /through thy /pow_er;",
                "thou brak_est the heads of the dra_gons /in the /wa_ters."
            ],
            [
                "Thou smot_est the heads of le_/vi_a_than in /pie_ces,",
                "and gav_est him to be meat for the peo_ple /of the /wil_der_ness."
            ],
            [
                "Thou brought_est out foun_tains and wa_ters /out of the /hard /rocks;",
                "thou driedst up /migh_ty /wa_ters."
            ],
            [
                "The day is /thine, and the /night is thine;",
                "thou hast pre_pared the /light and the /sun."
            ],
            [
                "Thou hast set all the /bor_ders /of the /earth;",
                "thou hast made /sum_mer and /win_ter."
            ],
            [
                "Re_mem_ber this, O LORD, how the /e_ne_my /hath re_/buked;",
                "and how the fool_ish peo_ple /hath blas_/phemed thy /Name."
            ],
            [
                "O de_li_ver not the soul of thy tur_tle-_dove un_to the mul_ti_tude /of the /e_ne_mies;",
                "and for_get not the con_gre_ga_tion of the /poor for /ev_er."
            ],
            [
                "Look up_/on the /co_ve_nant;",
                "for all the earth is full of dark_ness and cru_el /ha_bi_/ta_tions."
            ],
            [
                "O let not the sim_ple /go a_/way a_/shamed;",
                "but let the poor and nee_dy give praise /un_to /thy /Name."
            ],
            [
                "A_rise, O God, main_/tain thine /own /cause;",
                "re_mem_ber how the fool_ish man blas_/phem_eth thee /dai_ly."
            ],
            [
                "For_get not the /voice of thine /e_ne_mies:",
                "the pre_sump_tion of them that hate thee in_creas_eth /ev_er /more and /more."
            ]
        ]
    },
    {
        id: "psalm75",
        lines: [
            [
                "UN_TO thee, O God, /do we /give thanks;",
                "yea, un_to /thee do /we give /thanks."
            ],
            [
                "Thy Name /al_so /is so /nigh;",
                "and that do thy /won_drous /works de_/clare."
            ],
            [
                "In the ap_/poin_ted /time, saith /God,",
                "I shall judge ac_/cor_ding /un_to /right."
            ],
            [
                "The earth is weak, and all the in_/hab_it_ers /there_of:",
                "I bear up the /pill_ars of /it."
            ],
            [
                "I said un_to the fools, /Deal not so /mad_ly;",
                "and to the un_god_ly, /Set not /up your /horn."
            ],
            [
                "Set not /up your /horn on /high,",
                "and speak /not with a /stiff /neck."
            ],
            [
                "For pro_mo_tion com_eth nei_ther from the east, /nor /from the /west,",
                "nor /yet from the /south."
            ],
            [
                "And why? /God is the /Judge;",
                "he putt_eth down one, and set_teth /up a_/no_ther."
            ],
            [
                "For in the hand of the LORD there is a /cup, and the /wine is /red;",
                "it is full mixt, and he pour_eth /out of the /same."
            ],
            [
                "/As for the /dregs there_/of,",
                "all the un_god_ly of the earth shall /drink them, and /suck them /out."
            ],
            [
                "But I will talk of the /God of /Ja_cob,",
                "and /praise him for /ev_er."
            ],
            [
                "All the horns of the un_god_ly /al_so /will I /break,",
                "and the horns of the right_eous shall /be ex_/al_ted."
            ]
        ]
    },
    {
        id: "psalm76",
        lines: [
            [
                "IN /Ju_dah is /God /known;",
                "his Name is /great in /Is_ra_el."
            ],
            [
                "At Sa_lem is his /tab_er_/na_cle,",
                "and his /dwell_ing in /Si_on."
            ],
            [
                "There brake he the /arr_ows /of the /bow,",
                "the shield, the /sword, and the /bat_tle."
            ],
            [
                "Thou art /glo_rious in /might,",
                "when thou com_est from the /hills of the /rob_bers."
            ],
            [
                "The proud are robbed, /they have /slept their sleep;",
                "and all the men whose hands were migh_ty /have found /noth_ing."
            ],
            [
                "At thy re_buke, O /God of /Ja_cob,",
                "both the cha_ri_ot and /horse are /fall_en."
            ],
            [
                "Thou, e_ven thou /art to be /feared;",
                "and who may stand in thy sight when /thou art /an_gry?"
            ],
            [
                "Thou didst cause thy judg_ment to be /heard from /hea_ven;",
                "the earth /trem_bled, /and was /still,"
            ],
            [
                "When God ar_/ose to /judg_ment,",
                "and to help all the /meek up_/on earth."
            ],
            [
                "The fierce_ness of man shall /turn to thy /praise;",
                "and the fierce_ness of them /shalt /thou re_/frain."
            ],
            [
                "Prom_ise un_to the LORD your God, and keep it, all ye that are /round a_/bout him;",
                "bring pres_ents un_to him that /ought /to be /feared."
            ],
            [
                "He shall re_frain the /spi_rit of /prin_ces,",
                "and is won_der_ful a_mong the /kings of the /earth."
            ]
        ]
    },
    {
        id: "psalm77",
        lines: [
            [
                "I WILL cry un_to /God with my /voice;",
                "e_ven un_to God will I cry with my voice, and he shall /hear_ken /un_to /me."
            ],
            [
                "In the time of my /trou_ble I /sought the /Lord:",
                "I stretched forth my hands un_to him, and ceased not in the night sea_son; my /soul re_fused /com_fort."
            ],
            [
                "When I am in hea_vi_ness, I will /think up_/on /God;",
                "when my heart is vexed, /I will com_/plain."
            ],
            [
                "Thou /hold_est mine /eyes /wak_ing:",
                "I am so fee_ble /that I /can_not /speak."
            ],
            [
                "I have con_/sid_ered the /days of /old,",
                "and the /years that are /past."
            ],
            [
                "I call to re_/mem_brance my /song,",
                "and in the night I comm_une with mine own heart, and search /out my /spi_rit."
            ],
            [
                "Will the Lord ab_sent him_/self for /ev_er?",
                "and will he be no /more in_/treat_ed?"
            ],
            [
                "Is his mer_cy clean /gone for /ev_er?",
                "and is his prom_ise come utt_er_ly to an /end for /ev_er_more?"
            ],
            [
                "Hath God for_got_ten /to be /gra_cious?",
                "and will he shut up his lov_ing-_kind_ness /in dis_/plea_sure?"
            ],
            [
                "And I said, It is mine /own in_/fir_mi_ty;",
                "but I will re_mem_ber the years of the right /hand of the /Most /High_est."
            ],
            [
                "I will re_mem_ber the /works of the /LORD,",
                "and call to mind thy /won_ders of /old time."
            ],
            [
                "I will think /al_so of /all thy /works,",
                "and my talk_ing shall be /of thy /do_ings."
            ],
            [
                "Thy way, O /God, is /ho_ly:",
                "who is so great a /God as our /God?"
            ],
            [
                "Thou art the God that /do_est /won_ders,",
                "and hast de_clared thy pow_er a_/mong the /peo_ples."
            ],
            [
                "Thou hast migh_ti_ly de_/li_vered thy /peo_ple,",
                "e_ven the sons of /Ja_cob and /Jo_seph."
            ],
            [
                "The wa_ters saw thee, O God, the wa_ters /saw thee, and /were a_/fraid;",
                "the depths /al_so were /trou_bled."
            ],
            [
                "The clouds poured out wa_ter, /the air /thun_dered,",
                "and thine /arr_ows /went a_/broad."
            ],
            [
                "The voice of thy thun_der was /heard round a_/bout:",
                "the light_nings shone up_on the ground; the earth was /moved, and /shook with_/al."
            ],
            [
                "Thy way is in the sea, and thy paths /in the great /wa_ters,",
                "and thy /foot_steps are /not /known."
            ],
            [
                "Thou ledd_est thy /peo_ple like /sheep,",
                "by the hand of /Mo_ses and /Aa_ron."
            ]
        ]
    },
    {
        id: "psalm78",
        lines: [
            [
                "HEAR my law, /O my /peo_ple;",
                "in_cline your ears un_to the /words of my /mouth."
            ],
            [
                "I will o_pen my mouth /in a /pa_ra_ble;",
                "I will de_clare hard /sen_ten_ces /of old;"
            ],
            [
                "Which /we have /heard and /known,",
                "and such as our /fa_thers have /told us;"
            ],
            [
                "That we should not hide them from the child_ren of the gen_er_/a_tions to /come;",
                "but to show the ho_nour of the LORD, his migh_ty and won_der_ful /works that /he hath /done."
            ],
            [
                "He made a co_ve_nant with Ja_cob, and gave /Is_ra_el a /law,",
                "which he com_man_ded our fore_fa_thers to /teach their /child_ren;"
            ],
            [
                "That their pos_te_ri_/ty might /know it,",
                "and the child_ren /which were /yet un_/born;"
            ],
            [
                "To the in_tent that /when they /came /up,",
                "they might show their /child_ren the /same;"
            ],
            [
                "That they might /put their /trust in /God;",
                "and not to for_get the works of God, but to /keep his com_/mand_ments;"
            ],
            [
                "And not to be as their fore_fa_thers, a faith_less and stub_born /ge_ne_/ra_tion;",
                "a ge_ne_ra_tion that set not their heart a_right, and whose spi_rit clave not /sted_fast_ly /un_to God;"
            ],
            [
                "Like as the /child_ren of /Eph_ra_im;",
                "who be_ing harn_essed, and car_ry_ing bows, turned them_selves back in the /day of /bat_tle."
            ],
            [
                "They kept not the /co_ve_nant of /God,",
                "and would not /walk in his /law;"
            ],
            [
                "But for_/gat what /he had /done,",
                "and the won_der_ful works that /he had /showed for /them."
            ],
            [
                "Mar_vell_ous things did he in the sight of our fore_fa_thers, in the /land of /E_gypt,",
                "e_ven in the /field of /Zo_an."
            ],
            [
                "He di_vi_ded the sea, and /let them go /through;",
                "he made the wa_ters to /stand on /an /heap."
            ],
            [
                "In the day-_time al_so he /led them /with a /cloud,",
                "and all the night /through with a /light of /fire."
            ],
            [
                "He clave the hard /rocks in the /wil_der_ness,",
                "and gave them drink there_of, as it had been /out of the /great /depth."
            ],
            [
                "He brought wa_ters /out of the /sto_ny /rock,",
                "so that it gushed /out like the /ri_vers."
            ],
            [
                "Yet for all this they sinned /more a_/gainst him,",
                "and pro_voked the Most High_est /in the /wil_der_ness."
            ],
            [
                "They tempt_ed /God /in their /hearts,",
                "and re_quired /meat for their /lust."
            ],
            [
                "They spake a_gainst God /al_so, /say_ing,",
                "Shall God pre_pare a ta_ble /in the /wil_der_ness?"
            ],
            [
                "He smote the sto_ny rock in_deed, that the wa_ter gushed out, and the /streams /flowed with_al;",
                "but can he give bread al_so, or pro_vide /flesh for his /peo_ple?"
            ],
            [
                "When the LORD /heard this, /he was /wroth;",
                "so the fire was kin_dled in Ja_cob, and there came up hea_vy dis_plea_sure a_/gainst /Is_ra_el;"
            ],
            [
                "Be_cause they /be_lieved /not in God,",
                "and put not their /trust in his /help."
            ],
            [
                "So he com_/man_ded the /clouds a_/bove,",
                "and o_pened the /doors of /hea_ven."
            ],
            [
                "He rained down man_na al_so up_/on them /for to /eat,",
                "and gave them /food from /hea_ven."
            ],
            [
                "So /man did eat /an_gels' food;",
                "for he /sent them /meat en_ough."
            ],
            [
                "He caused the east-_wind to blow /un_der /hea_ven;",
                "and through his pow_er he brought /in the /south_west-_wind."
            ],
            [
                "He rained flesh up_/on them as /thick as /dust,",
                "and feath_ered fowls like as the /sand of the /sea."
            ],
            [
                "He let it /fall a_/mong their /tents,",
                "e_ven round a_bout their /ha_bi_/ta_tion."
            ],
            [
                "So they did eat, and were well filled; for he /gave them their /own de_/sire:",
                "they were not dis_ap_/point_ed /of their /lust."
            ],
            [
                "But while the meat was yet in their mouths, the hea_vy wrath of God came up_on them, and slew the /wealth_i_est of /them;",
                "yea, and smote down the cho_sen men that /were in /Is_ra_el."
            ],
            [
                "But for all /this they /sinned yet /more,",
                "and be_lieved /not his /won_drous /works."
            ],
            [
                "There_fore their days did he con_/sume in /va_ni_ty,",
                "and their /years in /trou_ble."
            ],
            [
                "When he /slew them, they /sought him,",
                "and turned them ear_ly, and in_/quired /af_ter /God."
            ],
            [
                "And they re_mem_bered that /God was their /strength,",
                "and that the High God was /their re_/dee_mer."
            ],
            [
                "Ne_ver_the_less, they did but /flat_ter him /with their /mouth,",
                "and dis_sem_bled with /him /in their /tongue."
            ],
            [
                "For their heart /was not /whole with him,",
                "nei_ther con_tin_ued they sted_fast /in his /co_ve_nant."
            ],
            [
                "But he was so mer_ci_ful, that he for_/gave their /mis_deeds,",
                "and des_troyed /them not."
            ],
            [
                "Yea, ma_ny a time turned /he his /wrath a_way,",
                "and would not suf_fer his whole dis_/plea_sure /to a_/rise."
            ],
            [
                "For he con_sid_ered that /they /were but /flesh,",
                "and that they were e_ven a wind that pass_eth a_way, and /com_eth /not a_/gain."
            ],
            [
                "Ma_ny a time did they pro_voke him /in the /wil_der_ness,",
                "and grieved him /in the /des_ert."
            ],
            [
                "They turned /back, and /tempt_ed /God,",
                "and pro_voked the Ho_ly /One in /Is_ra_el."
            ],
            [
                "They thought /not of /his /hand,",
                "and of the day when he de_li_vered them from the /hand of the /e_ne_my;"
            ],
            [
                "How he had wrought his mi_ra_/cles in /E_gypt,",
                "and his won_ders in the /field of /Zo_an."
            ],
            [
                "He turned their /wa_ters /in_to /blood,",
                "so that they might not /drink of the /ri_vers."
            ],
            [
                "He sent flies a_mong them, /and de_/voured them /up;",
                "and /frogs to des_/troy them."
            ],
            [
                "He gave their fruit un_to the /ca_ter_/pil_lar,",
                "and their la_bour /un_to the /grass_hop_per."
            ],
            [
                "He des_troyed their /vines with /hail_stones,",
                "and their mul_ber_ry_/-trees /with the /frost."
            ],
            [
                "He smote their cat_tle /al_so with /hail_stones,",
                "and their flocks with /hot /thun_der_bolts."
            ],
            [
                "He cast up_on them the fu_ri_ous_ness of his wrath, an_ger, dis_/plea_sure, and /trou_ble:",
                "and sent e_vil /an_gels a_/mong them."
            ],
            [
                "He made a way to his in_dig_na_tion, and spared /not their /soul from /death;",
                "but gave their life o_ver /to the /pes_til_ence;"
            ],
            [
                "And smote all the /first_born in /E_gypt,",
                "the most prin_ci_pal and migh_ti_est in the /dwell_ings /of /Ham."
            ],
            [
                "But as for his own peo_ple, he /led them /forth like /sheep,",
                "and car_ried them in the /wil_der_ness /like a /flock."
            ],
            [
                "He brought them out safe_ly, /that they /should not /fear,",
                "and ov_er_whelmed their /e_ne_mies /with the /sea."
            ],
            [
                "And brought them with_in the bor_ders of his /sanc_tu_/a_ry,",
                "e_ven to this moun_tain, which he purch_ased /with his /right hand."
            ],
            [
                "He cast out the heath_en /al_so be_/fore them,",
                "caused their land to be di_vi_ded a_mong them for an he_ri_tage, and made the tribes of Is_ra_el to /dwell in their /tents."
            ],
            [
                "Yet they tempt_ed and dis_/pleased the /Most High /God,",
                "and kept not his /tes_ti_/mon_ies."
            ],
            [
                "They turned their backs, and fell a_way like their /fore_fa_thers;",
                "start_ing as_ide /like a /bro_ken /bow."
            ],
            [
                "For they grieved him /with their /hill-_alt_ars,",
                "and pro_voked him to dis_plea_sure /with their /im_a_ges."
            ],
            [
                "When God /heard this, /he was /wroth,",
                "and took sore dis_/plea_sure at /Is_ra_el;"
            ],
            [
                "So that he for_sook the tab_er_/na_cle in /Shi_loh,",
                "e_ven the tent that he had /pitched a_/mong men."
            ],
            [
                "He de_li_vered their pow_er /in_to cap_/ti_vi_ty,",
                "and their beau_ty in_to the /e_/ne_my's /hand"
            ],
            [
                "He gave his peo_ple o_ver al_so /un_to the /sword,",
                "and was wroth with /his in_/he_ri_tance."
            ],
            [
                "The fire con_/sumed their young /men,",
                "and their maid_ens were not /gi_ven in /mar_riage."
            ],
            [
                "Their priests were /slain with the /sword,",
                "and there were no wid_ows to make /la_men_/ta_tion."
            ],
            [
                "So the Lord a_waked as /one out of /sleep,",
                "and like a /gi_ant re_/freshed with /wine."
            ],
            [
                "He drave his /e_ne_mies /back_ward,",
                "and put them to a per_/pe_/tu_al /shame."
            ],
            [
                "He re_fused the tab_er_/na_cle of /Jo_seph,",
                "and chose not the /tribe of /Eph_ra_im;"
            ],
            [
                "But chose the /tribe of /Ju_dah,",
                "e_ven the hill of /Si_on /which he /loved."
            ],
            [
                "And there he built his /tem_ple on /high,",
                "and laid the foun_da_tion of it like the ground which he hath made con_/ti_nu_/al_ly."
            ],
            [
                "He chose Da_vid /al_so his /ser_vant,",
                "and took him a_/way from the /sheep-_folds:"
            ],
            [
                "As he was fol_low_ing the ewes with their /young he /took him,",
                "that he might feed Ja_cob his peo_ple, and Is_ra_el /his in_/he_ri_tance."
            ],
            [
                "So he fed them with a /faith_ful and /true /heart,",
                "and ruled them pru_dent_ly with /all his /pow_er."
            ]
        ]
    },
    {
        id: "psalm79",
        lines: [
            [
                "O GOD, the heath_en are come in_to /thine in_/he_ri_tance;",
                "thy ho_ly tem_ple have they de_filed, and made Je_ru_sa_/lem an /heap of /stones."
            ],
            [
                "The dead bod_ies of thy ser_vants have they gi_ven to be meat un_to the /fowls of the /air,",
                "and the flesh of thy saints un_to the /beasts of the /land."
            ],
            [
                "Their blood have they shed like wa_ter on eve_ry /side of Je_/ru_sa_/lem,",
                "and there was no /man to /bu_ry them."
            ],
            [
                "We are be_come an o_pen /shame to our /e_ne_mies,",
                "a ve_ry scorn and de_ri_sion un_to them that are /round a_/bout us."
            ],
            [
                "LORD, how long wilt /thou be /an_gry?",
                "shall thy jea_lou_sy burn like /fire for /ev_er?"
            ],
            [
                "Pour out thine in_dig_na_tion up_on the heath_en that /have not /known thee;",
                "and up_on the king_doms that have not /called up_/on thy /Name."
            ],
            [
                "For they /have de_voured /Ja_cob,",
                "and laid /waste his /dwell_ing-_place."
            ],
            [
                "O re_mem_ber not our old sins, but have mer_cy up_/on us, and /that /soon;",
                "for we are /come to great /mi_se_ry."
            ],
            [
                "Help us, O God of our sal_va_tion, for the /glo_ry /of thy /Name:",
                "O de_li_ver us, and be mer_ci_ful un_to our sins, /for thy /Name's sake."
            ],
            [
                "Where_fore /do the /heath_en /say,",
                "/Where is /now their /God?"
            ],
            [
                "O let the ven_geance of thy ser_vants' /blood that is /shed,",
                "be o_pen_ly showed up_on the /heath_en, /in our /sight."
            ],
            [
                "O let the sor_row_ful sigh_ing of the pris_on_ers /come be_/fore thee;",
                "ac_cor_ding to the great_ness of thy pow_er, pre_serve thou those that are ap_/poin_ted to /die."
            ],
            [
                "And for the blas_phe_my where_with our neigh_bours /have blas_/phemed thee,",
                "re_ward thou them, O Lord, sev_en_fold /in_to their /bo_som."
            ],
            [
                "So we, that are thy peo_ple, and sheep of thy pas_ture, shall give thee /thanks for /ev_er,",
                "and will al_way be show_ing forth thy praise from ge_ne_ra_tion to /ge_ne_/ra_tion."
            ]
        ]
    },
    {
        id: "psalm80",
        lines: [
            [
                "HEAR, O thou Shep_herd of Is_ra_el, thou that lead_est /Jo_seph /like a /flock;",
                "show thy_self al_so, thou that sitt_est up_/on the /Che_ru_bim."
            ],
            [
                "Be_fore Eph_ra_im, Ben_ja_min, /and Ma_/na_sseh,",
                "stir up thy strength, and /come and /help us."
            ],
            [
                "/Turn us a_/gain, O God;",
                "show the light of thy coun_te_nance, and /we /shall be /whole."
            ],
            [
                "O /LORD /God of /hosts,",
                "how long wilt thou be an_gry with thy /peo_ple that /pray_eth?"
            ],
            [
                "Thou feed_est them /with the /bread of /tears,",
                "and giv_est them plen_teous_ness of /tears to /drink."
            ],
            [
                "Thou hast made us a ve_ry strife /un_to our /neigh_bours,",
                "and our e_ne_mies /laugh /us to /scorn."
            ],
            [
                "Turn us a_/gain, thou /God of /hosts;",
                "show the light of thy coun_te_nance, and /we /shall be /whole."
            ],
            [
                "Thou hast brought a vine /out of /E_gypt;",
                "thou hast cast out the /heath_en, and /plan_ted it."
            ],
            [
                "Thou /mad_est /room for it;",
                "and when it had tak_en /root, it /filled the /land."
            ],
            [
                "The hills were co_vered with the /sha_dow of /it,",
                "and the boughs there_of were like the /good_ly /ce_dar-_trees."
            ],
            [
                "She stretched out her branch_es /un_to the /sea,",
                "and her boughs /un_to the /Ri_ver."
            ],
            [
                "Why hast thou then /bro_ken /down her hedge,",
                "that all they that go by /pluck /off her /grapes?"
            ],
            [
                "The wild boar out of the /wood doth /root it up,",
                "and the wild beasts of the /field de_/vour it."
            ],
            [
                "Turn thee a_gain, thou God of hosts, look /down from /hea_ven,",
                "be_hold, and /vis_it /this /vine;"
            ],
            [
                "And the place of the vine_yard that thy right /hand hath /plan_ted,",
                "and the branch that thou mad_est so /strong for /thy_/self."
            ],
            [
                "It is burnt with /fire, and cut /down;",
                "and they shall per_ish at the re_/buke of thy /coun_te_nance."
            ],
            [
                "Let thy hand be up_on the /man of /thy right /hand,",
                "and up_on the son of man, whom thou mad_est so /strong for thine /own /self."
            ],
            [
                "And so will not /we go /back from thee:",
                "O let us live, and we shall /call up_/on thy /Name."
            ],
            [
                "Turn us a_gain, O /LORD /God of /hosts;",
                "show the light of thy coun_te_nance, and /we /shall be /whole."
            ]
        ]
    },
    {
        id: "psalm81",
        lines: [
            [
                "SING we mer_ri_ly /un_to /God our /strength;",
                "make a cheer_ful noise un_to the /God of /Ja_cob."
            ],
            [
                "Take the psalm, bring /hi_ther the /tab_ret,",
                "the mer_ry /harp with the /lute."
            ],
            [
                "Blow up the trum_pet /in the /new /moon,",
                "e_ven in the time ap_poin_ted, and up_on our /sol_emn /feast-_day."
            ],
            [
                "For this was made a /stat_ute for /Is_ra_el,",
                "and a law of the /God of /Ja_cob."
            ],
            [
                "This he or_dained in Jo_seph for a /tes_ti_/mo_ny,",
                "when he came out of the land of E_gypt, and had /heard a strange /lang_uage."
            ],
            [
                "I eased his shoul_der /from the /bur_den,",
                "and his hands were de_li_vered from /ma_king the /pots."
            ],
            [
                "Thou call_edst up_on me in trou_bles, and /I de_/li_vered thee;",
                "and heard thee what time as the storm /fell up_/on thee."
            ],
            [
                "I /proved thee /al_so",
                "at the /wa_ters of /strife."
            ],
            [
                "Hear, O my peo_ple; and I will ass_ure /thee, O /Is_ra_el,",
                "if thou wilt /hear_ken /un_to /me,"
            ],
            [
                "There shall no strange /god be /in thee,",
                "nei_ther shalt thou wor_ship /an_y /oth_er /god."
            ],
            [
                "I am the LORD thy God, who brought thee out of the /land of /E_gypt:",
                "o_pen thy mouth wide, and /I shall /fill it."
            ],
            [
                "But my peo_ple /would not /hear my /voice;",
                "and Is_ra_el would /not o_/bey me;"
            ],
            [
                "So I gave them up /un_to their /own hearts' /lusts,",
                "and let them fol_low their own i_/ma_gi_/na_tions."
            ],
            [
                "O that my peo_ple would have /heark_ened /un_to me!",
                "for if Is_ra_el had /walked in my /ways,"
            ],
            [
                "I should soon have put /down their /e_ne_mies,",
                "and turned my hand a_gainst their /ad_ver_/sa_ries."
            ],
            [
                "The hat_ers of the LORD should have sub_mit_ted them_/selves un_to /him;",
                "but their time should have en_/dured for /ev_er."
            ],
            [
                "I would have fed them al_so with the /fin_est /wheat_flour;",
                "and with hon_ey out of the sto_ny rock would I have /sa_tis_/fied thee."
            ]
        ]
    },
    {
        id: "psalm82",
        lines: [
            [
                "GOD stand_eth in the con_gre_/ga_tion of /prin_ces;",
                "he is a /Judge a_/mong gods."
            ],
            [
                "How long will ye /give wrong /judg_ment,",
                "and ac_cept the per_sons of /the un_/god_ly?"
            ],
            [
                "De_fend the /poor and /fa_ther_less;",
                "see that such as are in need and ne_/ces_si_ty /have right."
            ],
            [
                "De_li_ver the /out_cast and /poor;",
                "save them from the hand of /the un_/god_ly."
            ],
            [
                "They know not, nei_ther do they un_der_stand, but walk on /still in /dark_ness:",
                "all the found_a_tions of the /earth are /out of /course."
            ],
            [
                "I have /said, /Ye are /gods,",
                "and ye are all the child_ren of /the Most /High_est."
            ],
            [
                "But /ye shall /die like /men,",
                "and fall like /one of the /prin_ces."
            ],
            [
                "A_rise, O God, and /judge /thou the /earth;",
                "for thou shalt take all na_tions to /thine in_/he_ri_tance."
            ]
        ]
    },
    {
        id: "psalm83",
        lines: [
            [
                "HOLD not thy tongue, O God, keep /not still /si_lence:",
                "re_frain /not thy_/self, O /God."
            ],
            [
                "For lo, thine e_ne_mies /make a /mur_mur_ing;",
                "and they that hate thee have /lift up their /head."
            ],
            [
                "They have i_ma_gined craf_ti_ly a_/gainst thy /peo_ple,",
                "and tak_en coun_sel a_/gainst thy /sec_ret /ones."
            ],
            [
                "They have said, Come, and let us root them out, that they be no /more a /peo_ple,",
                "and that the name of Is_ra_el may be no /more in re_/mem_brance."
            ],
            [
                "For they have cast their heads to_/ge_ther with /one con_/sent,",
                "and are con_fed_er_/ate a_/gainst thee:"
            ],
            [
                "The ta_ber_na_cles of the E_dom_ites, and the /Ish_ma_/el_ites;",
                "the Mo_a_/bites, and /Ha_ga_renes;"
            ],
            [
                "Ge_bal, and /Am_mon, and /A_ma_lek;",
                "the Phi_li_stines, with /them that /dwell at /Tyre."
            ],
            [
                "As_sy_ria /al_so is /joined with /them;",
                "they have hol_pen the /child_ren of /Lot."
            ],
            [
                "But do thou to them as un_to the /Mi_di_/an_ites;",
                "un_to Si_se_ra, and un_to Ja_bin at the /brook of /Ki_shon;"
            ],
            [
                "Who /per_ished at /En_dor,",
                "and be_came as the /dung of the /earth."
            ],
            [
                "Make them and their prin_ces like /Or_eb and /Ze_eb;",
                "yea, make all their prin_ces like as Ze_bah /and Zal_/mun_na;"
            ],
            [
                "Who say, Let us /take to our_/selves",
                "the hou_ses of God /in pos_/sess_ion."
            ],
            [
                "O my God, make them like /un_to the /whirl_ing /dust,",
                "and as the /stub_ble be_/fore the /wind;"
            ],
            [
                "Like as the fire that burn_eth /up the /for_est,",
                "and as the flame that con_/sum_eth the /moun_tains;"
            ],
            [
                "Pur_sue them e_ven so /with thy /tem_pest,",
                "and make them a_/fraid with thy /storm."
            ],
            [
                "Make their /fa_ces a_/shamed, O /LORD,",
                "that /they may /seek thy /Name."
            ],
            [
                "Let them be con_foun_ded and vexed /ev_er /more and /more;",
                "let them be put to /shame, and /per_ish."
            ],
            [
                "And they shall know that thou, whose /Name is JE_/HO_VAH,",
                "art on_ly the Most High_est /o_ver /all the /earth."
            ]
        ]
    },
    {
        id: "psalm84",
        lines: [
            [
                "O HOW a_mi_able /are thy /dwell_ings,",
                "thou LORD of /hosts!"
            ],
            [
                "My soul hath a de_sire and long_ing to en_ter in_to the /courts of the /LORD;",
                "my heart and my flesh re_/joice in the /li_ving /God."
            ],
            [
                "Yea, the spar_row hath found her an house, and the swal_low a nest, /where she may /lay her /young;",
                "e_ven thy alt_ars, O LORD of hosts, my /King and my /God."
            ],
            [
                "Bless_ed are they that /dwell in thy /house;",
                "they will be /al_way /prais_ing /thee."
            ],
            [
                "Bless_ed is the man whose /strength is /in /thee;",
                "in whose /heart are thy /ways."
            ],
            [
                "Who go_ing through the vale of mi_se_ry /use it /for a /well;",
                "and the pools are /filled with /wa_ter."
            ],
            [
                "They will /go from /strength to /strength,",
                "and un_to the God of gods ap_pear_eth eve_ry one of /them in /Si_on."
            ],
            [
                "O LORD God of /hosts, /hear my /prayer;",
                "hear_ken, O /God of /Ja_cob."
            ],
            [
                "Be_hold, O God /our de_/fen_der,",
                "and look up_on the face of /thine a_/noin_ted."
            ],
            [
                "For one /day /in thy /courts",
                "is bet_ter /than a /thou_sand."
            ],
            [
                "I had ra_ther be a door-_kee_per in the /house of my /God,",
                "than to dwell in the /tents of un_/god_li_ness."
            ],
            [
                "For the LORD God is a /light and de_/fence;",
                "the LORD will give grace and wor_ship; and no good thing shall he with_hold from them that /live a /god_ly life."
            ],
            [
                "O /LORD /God of /hosts,",
                "bless_ed is the man that /putt_eth his /trust in /thee."
            ]
        ]
    },
    {
        id: "psalm85",
        lines: [
            [
                "LORD, thou art be_come gra_cious /un_to thy /land;",
                "thou hast turned a_way the cap_/ti_vi_ty of /Ja_cob."
            ],
            [
                "Thou hast for_gi_ven the of_/fence of thy /peo_ple,",
                "and /co_vered /all their /sins."
            ],
            [
                "Thou hast tak_en a_way all /thy dis_/plea_sure,",
                "and turned thy_self from thy wrath_ful /in_dig_/na_tion."
            ],
            [
                "Turn us then, O /God our /Sav_iour,",
                "and let thine /an_ger /cease from us."
            ],
            [
                "Wilt thou be dis_pleased at /us for /ev_er?",
                "and wilt thou stretch out thy wrath from one ge_ne_ra_tion /to a_/no_ther?"
            ],
            [
                "Wilt thou not turn a_/gain, and /quick_en us,",
                "that thy peo_ple /may re_/joice in /thee?"
            ],
            [
                "Show us thy /mer_cy, O /LORD,",
                "and grant us /thy sal_/va_tion."
            ],
            [
                "I will hear_ken what the /LORD /God will /say;",
                "for he shall speak peace un_to his peo_ple, and to his saints, that they turn not a_gain /un_to /fool_ish_ness."
            ],
            [
                "For his sal_va_tion is nigh /them that /fear him;",
                "that glo_ry may /dwell /in our /land."
            ],
            [
                "Mer_cy and truth are /met to_/ge_ther:",
                "right_eous_ness and peace have /kissed each /oth_er."
            ],
            [
                "Truth shall flou_rish /out of the /earth,",
                "and right_eous_ness hath looked /down from /hea_ven."
            ],
            [
                "Yea, the LORD shall show /lov_ing-_/kind_ness;",
                "and our land shall /give her /in_crease."
            ],
            [
                "Right_eous_ness shall /go be_/fore him,",
                "and shall di_rect his /go_ing /in the /way."
            ]
        ]
    },
    {
        id: "psalm86",
        lines: [
            [
                "BOW down thine ear, O /LORD, and /hear me;",
                "for I am /poor, and in /mi_se_ry."
            ],
            [
                "Pre_serve thou my soul, for /I am /ho_ly:",
                "my God, save thy ser_vant that /putt_eth his /trust in /thee."
            ],
            [
                "Be mer_ci_ful /un_to /me, O /Lord;",
                "for I will call /dai_ly up_/on thee."
            ],
            [
                "Com_fort the /soul of thy /ser_vant;",
                "for un_to thee, O Lord, do I /lift /up my /soul."
            ],
            [
                "For thou, Lord, art /good and /gra_cious,",
                "and of great mer_cy un_to all them that /call up_/on thee."
            ],
            [
                "Give ear, LORD, /un_to my /prayer,",
                "and pon_der the voice of my /hum_ble de_/sires."
            ],
            [
                "In the time of my trou_ble I will /call up_/on thee;",
                "/for thou /hear_est /me."
            ],
            [
                "A_mong the gods there is none like /un_to /thee, O /Lord;",
                "there is not one that can /do as /thou do_est."
            ],
            [
                "All na_tions whom thou hast made shall come and /wor_ship /thee, O /Lord;",
                "and shall /glo_ri_/fy thy Name."
            ],
            [
                "For thou art great, and /do_est /won_drous /things:",
                "/thou art /God a_/lone."
            ],
            [
                "Teach me thy way, O LORD, and I will /walk in thy /truth:",
                "O knit my heart un_to thee, that /I may /fear thy /Name."
            ],
            [
                "I will thank thee, O Lord my /God, with /all my /heart;",
                "and will praise thy /Name for /ev_er_/more."
            ],
            [
                "For great is thy /mer_cy to_/ward me;",
                "and thou hast de_li_vered my soul from the /neth_er_/most hell."
            ],
            [
                "O God, the proud are /ri_sen a_/gainst me;",
                "and the con_gre_ga_tions of vio_lent men have sought af_ter my soul, and have not set /thee be_/fore their /eyes."
            ],
            [
                "But thou, O Lord God, art full of com_/pass_ion and /mer_cy,",
                "long-_suf_fer_ing, plen_te_ous in /good_ness and /truth."
            ],
            [
                "O turn thee then un_to me, and have /mer_cy up_/on me;",
                "give thy strength un_to thy ser_vant, and help the /son of thine /hand_maid."
            ],
            [
                "Show some to_ken up_on me for good; that they who hate me may see /it, and /be a_/shamed,",
                "be_cause thou, LORD, hast hol_pen me, and /com_for_ted /me."
            ]
        ]
    },
    {
        id: "psalm87",
        lines: [
            [
                "HER found_a_tions are up_/on the /ho_ly /hills:",
                "the LORD lov_eth the gates of Si_on more than all the /dwell_ings of /Ja_cob."
            ],
            [
                "Ve_ry ex_cell_ent things are /spo_ken of /thee,",
                "thou /ci_ty of /God."
            ],
            [
                "I will make men_tion of /E_gypt and /Ba_by_lon,",
                "a_mong /them that /know me."
            ],
            [
                "Be_hold, Phil_is_ti_a al_so; and Tyre, with /E_thi_/o_pi_a;",
                "lo, in /Si_on /were they /born."
            ],
            [
                "Yea, of Si_on it shall be re_por_ted, this one and /that one were /born in /her;",
                "and the Most /High shall /stab_lish her."
            ],
            [
                "The LORD shall re_cord it, when he writ_eth /up the /peo_ples;",
                "lo, in /Si_on /were they /born."
            ],
            [
                "The sing_ers al_so and trump_et_ers /shall make /an_swer:",
                "All my fresh /springs are /in thee."
            ]
        ]
    },
    {
        id: "psalm88",
        lines: [
            [
                "O LORD God of my sal_va_tion, I have cried day and /night be_/fore thee:",
                "O let my prayer en_ter in_to thy pres_ence, in_cline thine ear /un_to my /call_ing;"
            ],
            [
                "For my soul is /full of /trou_ble,",
                "and my life draw_eth nigh /un_to the /grave."
            ],
            [
                "I am coun_ted as one of them that go down /in_/to the /pit,",
                "and I am e_ven as a /man that /hath no /strength;"
            ],
            [
                "Cast off a_mong the dead, like un_to them that are slain, and /lie in the /grave,",
                "who are out of re_mem_brance, and are cut a_/way from thy /hand."
            ],
            [
                "Thou hast laid me /in the /low_est pit,",
                "in a place of /dark_ness, and /in the /deep."
            ],
            [
                "Thine in_dig_na_tion li_eth /hard up_/on me,",
                "and thou hast /vexed me with /all thy /storms."
            ],
            [
                "Thou hast put a_way mine ac_/quain_tance /far from me,",
                "and made me to /be ab_/horred of /them."
            ],
            [
                "I am so /fast in /pri_son",
                "/that I can_/not get /forth."
            ],
            [
                "My sight fail_eth for /ve_ry /trou_ble;",
                "LORD, I have called dai_ly up_on thee, I have stretched forth my /hands /un_to /thee."
            ],
            [
                "Dost thou show /won_ders a_/mong the /dead?",
                "or shall the dead rise up a_/gain, and /praise thee?"
            ],
            [
                "Shall thy lov_ing-_kind_ness be /showed in the /grave?",
                "or thy faith_ful_ness /in des_/truc_tion?"
            ],
            [
                "Shall thy won_drous works be /known in the /dark?",
                "and thy right_eous_ness in the land where all /things are for_/got_ten?"
            ],
            [
                "Un_to /thee have I /cried, O /LORD;",
                "and ear_ly shall my /prayer come be_/fore thee."
            ],
            [
                "LORD, why ab_/horr_est /thou my /soul,",
                "and hid_est /thou thy /face from me?"
            ],
            [
                "I am in mi_se_ry, and like un_to him that is /at the /point to /die;",
                "e_ven from my youth up, thy terr_ors have I suff_ered with a /trou_bled /mind."
            ],
            [
                "Thy wrath_ful dis_plea_sure /go_eth /o_ver me,",
                "and the fear of /thee hath un_/done me."
            ],
            [
                "They came round a_bout me /dai_ly like /wa_ter,",
                "and com_passed me to_/ge_ther on /eve_ry /side."
            ],
            [
                "My lov_ers and friends hast thou /put a_/way from me,",
                "and hid mine ac_quain_tance /out of my /sight."
            ]
        ]
    },
    {
        id: "psalm89",
        lines: [
            [
                "MY song shall be al_way of the lov_ing-_/kind_ness /of the /LORD;",
                "with my mouth will I ev_er be show_ing thy truth from one ge_ne_ra_tion /to a_/no_ther."
            ],
            [
                "For I have said, Mer_cy shall be set /up for /ev_er;",
                "thy truth shalt thou stab_lish /in the /hea_vens."
            ],
            [
                "I have made a co_ve_nant /with my /cho_sen;",
                "I have sworn un_to /Da_vid my /ser_vant:"
            ],
            [
                "Thy seed will I /stab_lish for /ev_er,",
                "and set up thy throne from one ge_ne_ra_tion /to a_/no_ther."
            ],
            [
                "O LORD, the ve_ry hea_vens shall /praise thy /won_drous /works;",
                "and thy truth in the con_gre_/ga_tion /of the /saints."
            ],
            [
                "For who is /he a_/mong the /clouds,",
                "that shall be comp_ared /un_to the /LORD?"
            ],
            [
                "And what is /he a_/mong the /gods,",
                "that shall be like /un_to the /LORD?"
            ],
            [
                "God is ve_ry great_ly to be feared in the /coun_cil /of the /saints,",
                "and to be had in rev_erence of all them that are /round a_/bout him."
            ],
            [
                "O Lord God of hosts, who is /like /un_to /thee?",
                "thy truth, most migh_ty /LORD, is on /eve_ry /side."
            ],
            [
                "Thou rul_est the /rag_ing /of the /sea;",
                "thou still_est the waves there_/of when /they a_/rise."
            ],
            [
                "Thou hast sub_dued E_gypt, /and des_/troyed it;",
                "thou hast scat_tered thine e_ne_mies a_broad /with thy /migh_ty /arm."
            ],
            [
                "The hea_vens are thine, the earth /al_so is /thine;",
                "thou hast laid the foun_da_tion of the round world, and /all that /there_in /is."
            ],
            [
                "Thou hast made the /north and the /south;",
                "Ta_bor and Her_mon shall re_/joice in /thy /Name."
            ],
            [
                "Thou /hast a /migh_ty /arm;",
                "strong is thy hand, and /high is thy /right hand."
            ],
            [
                "Right_eous_ness and eq_ui_ty are the ha_bi_/ta_tion /of thy /seat;",
                "mer_cy and truth shall /go be_/fore thy /face."
            ],
            [
                "Bless_ed is the peo_ple, O LORD, that /can re_/joice in /thee;",
                "they shall walk in the /light of thy /coun_te_nance."
            ],
            [
                "Their de_light shall be /dai_ly /in thy /Name;",
                "and in thy right_eous_ness /shall they /make their /boast."
            ],
            [
                "For thou art the /glo_ry /of their /strength,",
                "and in thy lov_ing-_kind_ness thou shalt /lift /up our /horns."
            ],
            [
                "For the /LORD is /our de_/fence;",
                "the Ho_ly One of /Is_ra_el /is our /King."
            ],
            [
                "Thou spak_est some_time in vis_ions /un_to thy /saints, and /saidst,",
                "I have laid help up_on one that is migh_ty, I have ex_al_ted one cho_sen /out of the /peo_ple."
            ],
            [
                "I have found /Da_vid my /ser_vant;",
                "with my ho_ly oil have /I a_/noin_ted /him."
            ],
            [
                "My /hand shall /hold him /fast,",
                "and my /arm shall /strength_en him."
            ],
            [
                "The e_ne_my shall not be a_ble to /do him /vio_lence;",
                "the son of wick_ed_ness /shall not /hurt him."
            ],
            [
                "I will smite down his /foes be_/fore his /face,",
                "and plague /them that /hate him."
            ],
            [
                "My truth al_so and my mer_cy /shall be /with him;",
                "and in my Name shall his horn /be ex_/al_ted."
            ],
            [
                "I will set his do_min_ion /al_so /in the /sea,",
                "and his right /hand /in the /floods."
            ],
            [
                "He shall call me, /Thou art my /Fa_ther,",
                "my God, and my /strong sal_/va_tion."
            ],
            [
                "And I will /make him my /first_born,",
                "high_er than the /kings of the /earth."
            ],
            [
                "My mer_cy will I keep for /him for /ev_er_/more,",
                "and my co_ve_nant /shall stand /fast with him."
            ],
            [
                "His seed al_so will I make to en_/dure for /ev_er,",
                "and his throne as the /days of /hea_ven."
            ],
            [
                "But if his /child_ren for_/sake my /law,",
                "and walk /not in my /judg_ments;"
            ],
            [
                "If they break my stat_utes, and keep /not my com_/mand_ments;",
                "I will vis_it their off_en_ces with the rod, and their /sin with /scour_ges."
            ],
            [
                "Ne_ver_the_less, my lov_ing-_kind_ness will I not /utt_er_ly /take from him,",
                "nor suf_fer my /truth to /fail."
            ],
            [
                "My co_ve_nant will I not break, nor al_ter the thing that is gone /out of my /lips:",
                "I have sworn once by my ho_li_ness, that I /will not fail /Da_vid."
            ],
            [
                "His seed shall en_/dure for /ev_er,",
                "and his throne is like as the /sun be_/fore me."
            ],
            [
                "He shall stand fast for ev_er_/more as the /moon,",
                "and as the faith_ful /wit_ness in /hea_ven."
            ],
            [
                "But thou hast ab_horred and for_sa_ken /thine a_/noin_ted,",
                "and /art dis_/pleased at /him."
            ],
            [
                "Thou hast bro_ken the co_ve_nant /of thy /ser_vant,",
                "and cast his /crown to the /ground."
            ],
            [
                "Thou hast ov_er_thrown /all his /hed_ges,",
                "and bro_ken /down his /strong_holds."
            ],
            [
                "All they that /go by /spoil him,",
                "and he is be_come a rep_/roach to his /neigh_bours."
            ],
            [
                "Thou hast set up the right /hand of his /e_ne_mies,",
                "and made all his ad_ver_/sa_ries /to re_/joice."
            ],
            [
                "Thou hast tak_en a_way the /edge of his /sword,",
                "and giv_est him not vic_to_ry /in the /bat_tle."
            ],
            [
                "Thou hast put /out his /glo_ry,",
                "and cast his throne /down to the /ground."
            ],
            [
                "The days of his youth /hast thou /short_ened,",
                "and co_vered him /with dis_/hon_our."
            ],
            [
                "LORD, how long wilt thou hide thy_/self? for /ev_er?",
                "and shall thy /wrath /burn like /fire?"
            ],
            [
                "O re_mem_ber how /short my /time is;",
                "where_fore hast thou /made all /men for /nought?"
            ],
            [
                "What man is he that liv_eth, and /shall /not see /death?",
                "and shall he de_li_ver his soul from the /pow_er of /the /grave?"
            ],
            [
                "Lord, where are thy old /lov_ing-_/kind_ness_es,",
                "which thou swar_est un_to /Da_vid /in thy /truth?"
            ],
            [
                "Re_mem_ber, Lord, the re_/buke that thy /ser_vants have,",
                "and how I do bear in my bo_som the re_bukes of /ma_ny /peo_ple;"
            ],
            [
                "Where_with thine e_ne_mies /have blas_/phemed thee,",
                "and slan_dered the foot_steps of /thine a_/noin_ted."
            ],
            [
                "Praised be the /LORD for /ev_er_more.",
                "A_men, and /A_men."
            ]
        ]
    },
    {
        id: "psalm90",
        lines: [
            [
                "LORD, thou hast /been our /re_fuge,",
                "from one ge_ne_ra_tion /to a_/no_ther."
            ],
            [
                "Be_fore the moun_tains were brought forth, or ev_er the earth /and the /world were made,",
                "thou art God from ev_er_last_ing, and /world with_/out /end."
            ],
            [
                "Thou turn_est /man to des_/truc_tion;",
                "a_gain thou say_est, Come a_gain, ye /child_ren of /men."
            ],
            [
                "For a thou_sand years in thy sight are but as yes_ter_day /when /it is /past,",
                "and as a /watch in the /night."
            ],
            [
                "As soon as thou scat_ter_est them they are /e_ven /as a sleep;",
                "and fade a_way /sud_den_ly /like the /grass."
            ],
            [
                "In the mor_ning it is /green, and /grow_eth /up;",
                "but in the eve_ning it is cut down, dried /up, and /with_ered."
            ],
            [
                "For we con_sume a_way in /thy dis_/plea_sure,",
                "and are a_fraid at thy wrath_ful /in_dig_/na_tion."
            ],
            [
                "Thou hast set our mis_/deeds be_/fore thee;",
                "and our sec_ret sins in the /light of thy /coun_te_nance."
            ],
            [
                "For when thou art an_gry /all our /days are /gone:",
                "we bring our years to an end, as it were a /tale that is /told."
            ],
            [
                "The days of our age are three_score years and ten; and though men be so strong that they /come to /four_score /years,",
                "yet is their strength then but la_bour and sor_row; so soon pass_eth it a_/way, and /we are /gone."
            ],
            [
                "But who re_gard_eth the /pow_er /of thy /wrath?",
                "or fear_eth a_right thy /in_dig_/na_tion?"
            ],
            [
                "So teach us to /num_ber our /days,",
                "that we may ap_ply our hearts /un_to /wis_dom."
            ],
            [
                "Turn thee a_gain, O /LORD, /at the /last,",
                "and be gra_cious /un_to thy /ser_vants."
            ],
            [
                "O sat_is_fy us with thy /mer_cy, /and that /soon:",
                "so shall we re_joice and be glad all the /days of our /life."
            ],
            [
                "Com_fort us a_gain now af_ter the time that /thou hast /plagued us;",
                "and for the years where_in we have /suff_ered ad_/ver_si_ty."
            ],
            [
                "Show thy /ser_vants /thy work,",
                "and their /child_ren thy /glo_ry."
            ],
            [
                "And the glo_rious ma_jes_ty of the LORD our /God be up_/on us:",
                "pros_per thou the work of our hands up_on us; O pros_per /thou our /han_dy-_work."
            ]
        ]
    },
    {
        id: "psalm91",
        lines: [
            [
                "WHO_SO dwell_eth un_der the de_/fence of the Most /High,",
                "shall a_bide un_der the sha_dow /of the Al_/migh_ty."
            ],
            [
                "I will say un_to the LORD, Thou art my /hope, and my /strong_hold;",
                "my God, in /him will /I trust."
            ],
            [
                "For he shall de_li_ver thee from the /snare of the /hun_ter,",
                "and from the /noi_some /pes_til_ence."
            ],
            [
                "He shall de_fend thee un_der his wings, and thou shalt be safe /un_der his /feath_ers;",
                "his faith_ful_ness and truth shall be thy /shield and /buck_ler."
            ],
            [
                "Thou shalt not be a_fraid for an_y /terr_or by /night,",
                "nor for the ar_row that /fli_eth /by /day;"
            ],
            [
                "For the pes_til_ence that /walk_eth in /dark_ness,",
                "nor for the sick_ness that des_troy_eth /in the /noon-_day."
            ],
            [
                "A thou_sand shall fall be_side thee, and ten thou_sand /at thy right /hand;",
                "but it shall /not come /nigh thee."
            ],
            [
                "Yea, with thine /eyes shalt /thou be_/hold,",
                "and see the re_ward of /the un_/god_ly."
            ],
            [
                "For /thou, LORD, /art my /hope;",
                "thou hast set thine house of de_/fence /ve_ry /high."
            ],
            [
                "There shall no e_vil /hap_pen /un_to /thee,",
                "nei_ther shall an_y plague come /nigh thy /dwell_ing."
            ],
            [
                "For he shall give his an_gels /charge /o_ver thee,",
                "to /keep thee in /all thy /ways."
            ],
            [
                "They shall /bear thee /in their /hands,",
                "that thou hurt not thy /foot a_/gainst a /stone."
            ],
            [
                "Thou shalt go up_on the /li_on and /add_er:",
                "the young li_on and the dra_gon shalt thou tread /un_der /thy /feet."
            ],
            [
                "Be_cause he hath set his love up_on me, there_fore will /I de_/li_ver him;",
                "I will set him up, be_/cause he hath /known my /Name."
            ],
            [
                "He shall call up_on me, and /I will /hear him;",
                "yea, I am with him in trou_ble; I will de_li_ver him, and /bring him to /ho_nour."
            ],
            [
                "With long life will I /sat_is_fy /him,",
                "and show him /my sal_/va_tion."
            ]
        ]
    },
    {
        id: "psalm92",
        lines: [
            [
                "IT is a good thing to give thanks /un_to the /LORD,",
                "and to sing prais_es un_to thy Name, /O Most /High_est;"
            ],
            [
                "To tell of thy lov_ing-_kind_ness ear_ly /in the /mor_ning,",
                "and of thy /truth in the /night /sea_son;"
            ],
            [
                "Up_on an in_stru_ment of ten /strings, and up_/on the /lute;",
                "up_on a loud in_stru_ment, /and up_/on the /harp."
            ],
            [
                "For thou, LORD, hast made me /glad through thy /works;",
                "and I will re_joice in gi_ving praise for the op_er_/a_tions of /thy /hands."
            ],
            [
                "O LORD, how /glo_rious /are thy /works!",
                "thy /thoughts are /ve_ry /deep."
            ],
            [
                "An un_wise man doth not /well con_/si_der this,",
                "and a fool doth not /un_der_/stand it."
            ],
            [
                "When the un_god_ly are green as the grass, and when all the wor_kers of /wick_ed_ness do /flou_rish,",
                "then shall they be des_troyed for ev_er; but thou, LORD, art the Most /High_est for /ev_er_/more."
            ],
            [
                "For lo, thine e_ne_mies, O LORD, lo, thine /e_ne_mies shall /per_ish;",
                "and all the wor_kers of wick_ed_ness /shall /be des_/troyed."
            ],
            [
                "But my horn shall be ex_al_ted like the /horn of an /u_ni_corn;",
                "for I am a_/noin_ted with /fresh oil."
            ],
            [
                "Mine eye al_so shall see his /lust of mine /e_ne_mies,",
                "and mine ear shall hear his de_sire of the wick_ed that a_rise /up a_/gainst me."
            ],
            [
                "The right_eous shall flou_rish /like a /palm-_tree,",
                "and shall spread a_broad like a /ce_dar in /Le_ba_non."
            ],
            [
                "Such as are plan_ted in the /house of the /LORD,",
                "shall flou_rish in the courts of the /house of our /God."
            ],
            [
                "They al_so shall bring forth more /fruit in their /age,",
                "and shall be /fat and well-_/li_king;"
            ],
            [
                "That they may show how true the /LORD my /strength is,",
                "and that there is no un_/right_eous_ness /in him."
            ]
        ]
    },
    {
        id: "psalm93",
        lines: [
            [
                "THE LORD is King, and hath put on /glo_rious ap_/pa_rel;",
                "the LORD hath put on his ap_pa_rel, and /gir_ded him_/self with /strength."
            ],
            [
                "He hath /made the round /world so /sure,",
                "that it /can_/not be /moved."
            ],
            [
                "Ev_er since the world be_gan, hath thy /seat /been pre_/pared:",
                "thou art from /ev_er_/last_ing."
            ],
            [
                "The floods are ri_sen, O LORD, the floods have /lift /up their /voice;",
                "the floods /lift /up their /waves."
            ],
            [
                "The waves of the sea are migh_ty, and rage /hor_ri_bly;",
                "but yet the LORD, who dwell_eth on /high, is /migh_ti_er."
            ],
            [
                "Thy tes_ti_mon_ies, O /LORD, are /ve_ry /sure:",
                "ho_li_ness be_com_eth thine /house for /ev_er."
            ]
        ]
    },
    {
        id: "psalm94",
        lines: [
            [
                "O LORD God, to whom /ven_geance be_/long_eth,",
                "thou God, to whom ven_geance be_/long_eth, /show thy_self."
            ],
            [
                "A_rise, thou /Judge of the /world,",
                "and re_ward the proud af_ter /their de_/serv_ing."
            ],
            [
                "LORD, how long /shall the un_/god_ly,",
                "how long shall the un_/god_ly /tri_umph?"
            ],
            [
                "How long shall all wick_ed do_ers /speak so dis_/dain_ful_ly,",
                "and /make such proud /boast_ing?"
            ],
            [
                "They smite down thy /peo_ple, O /LORD,",
                "and /trou_ble thine /he_ri_tage."
            ],
            [
                "They mur_der the wid_ow /and the /stran_ger,",
                "and put the /fa_ther_/less to /death."
            ],
            [
                "And yet they say, Tush, the /LORD /shall not see,",
                "nei_ther shall the God of /Ja_cob re_/gard it."
            ],
            [
                "Take heed, ye un_wise a_/mong the /peo_ple:",
                "O ye fools, when /will ye /un_der_/stand?"
            ],
            [
                "He that plan_ted the ear, /shall /he not /hear?",
                "or he that made the eye, /shall /he not /see?"
            ],
            [
                "Or he that in_/struct_eth the /heath_en,",
                "it is he that teach_eth man know_ledge; shall /not he /pu_nish?"
            ],
            [
                "The LORD /know_eth the /thoughts of man,",
                "that /they are /but vain."
            ],
            [
                "Bless_ed is the man whom thou /chast_en_/est, O /LORD,",
                "and /teach_est him /in thy law;"
            ],
            [
                "That thou may_est give him pa_tience in /time of ad_/ver_si_ty,",
                "un_til the pit be digged up for /the un_/god_ly."
            ],
            [
                "For the LORD will not /fail his /peo_ple;",
                "nei_ther will he for_/sake his in_/he_ri_tance;"
            ],
            [
                "Un_til right_eous_ness turn a_gain /un_to /judg_ment:",
                "all such as are true in /heart shall /fol_low it."
            ],
            [
                "Who will rise up with me a_/gainst the /wick_ed?",
                "or who will take my part a_gainst the /e_vil /do_ers?"
            ],
            [
                "If the LORD /had not /helped me,",
                "it had not failed, but my soul had been /put to /si_lence."
            ],
            [
                "But when I /said, My /foot hath /slipt;",
                "thy mer_cy, O /LORD, /held me /up."
            ],
            [
                "In the mul_ti_tude of the sor_rows that I /had in my /heart,",
                "thy com_forts /have re_/freshed my /soul."
            ],
            [
                "Wilt thou have an_y thing to do with the /throne of /wick_ed_ness,",
                "which i_ma_gin_eth /mis_chief /as a law?"
            ],
            [
                "They gath_er them to_ge_ther a_gainst the /soul of the /right_eous,",
                "and con_demn the /in_no_/cent /blood."
            ],
            [
                "But the /LORD is my /re_fuge,",
                "and my God is the /strength of my /con_fi_dence."
            ],
            [
                "He shall re_com_pense them their wick_ed_ness, and des_troy them in /their own /ma_lice;",
                "yea, the LORD our God /shall des_/troy them."
            ]
        ]
    },
    {
        id: "psalm95",
        lines: [
            [
                "O COME, let us sing /un_to the /LORD;",
                "let us hear_ti_ly re_joice in the strength of /our sal_/va_tion."
            ],
            [
                "Let us come be_fore his pres_ence /with thanks_/giv_ing;",
                "and show our_selves /glad in /him with /Psalms."
            ],
            [
                "For the /LORD is a /great God;",
                "and a great /King a_/bove all /gods."
            ],
            [
                "In his hand are all the /cor_ners /of the /earth;",
                "and the strength of the /hills is his /al_so."
            ],
            [
                "The sea is /his, and he /made it;",
                "and his hands pre_/pared the /dry land."
            ],
            [
                "O come, let us /wor_ship and /fall /down,",
                "and kneel be_fore the /LORD our /Ma_ker."
            ],
            [
                "For he /is the /Lord our /God;",
                "and we are the peo_ple of his pas_ture, and the /sheep of his /hand."
            ],
            [
                "To-_day if ye will hear his voice, /har_den /not your /hearts",
                "as in the pro_vo_ca_tion, and as in the day of temp_ta_tion /in the /wil_der_ness;"
            ],
            [
                "When your /fa_thers /tempt_ed me,",
                "/proved me, and /saw my /works."
            ],
            [
                "For_ty years long was I grieved with this ge_ne_/ra_tion, and /said,",
                "It is a peo_ple that do err in their hearts, for they /have not /known my /ways:"
            ],
            [
                "Un_to whom I /sware in my /wrath,",
                "that they should not en_ter /in_to my /rest."
            ]
        ]
    },
    {
        id: "psalm96",
        lines: [
            [
                "O SING un_to the /LORD a new /song;",
                "sing un_to the LORD, /all the /whole /earth."
            ],
            [
                "Sing un_to the /LORD, and /praise his /Name;",
                "be tell_ing of his sal_va_tion /from /day to /day."
            ],
            [
                "De_clare his ho_nour un_/to the /heath_en,",
                "and his won_ders un_/to all /peo_ples."
            ],
            [
                "For the LORD is great, and can_not /wor_thi_ly be /praised;",
                "he is more to be /feared than all /gods."
            ],
            [
                "As for all the gods of the heath_en, /they are but /i_dols;",
                "but it is the LORD that /made the /hea_vens."
            ],
            [
                "Glo_ry and wor_ship /are be_/fore him;",
                "pow_er and ho_nour are in his /sanc_tu_/a_ry."
            ],
            [
                "A_scribe un_to the LORD, O ye kind_reds /of the /peo_ples,",
                "a_scribe un_to the LORD /wor_ship and /pow_er."
            ],
            [
                "A_scribe un_to the LORD the ho_nour due /un_to his /Name;",
                "bring pres_ents, and come /in_to his /courts."
            ],
            [
                "O wor_ship the LORD in the /beau_ty of /ho_li_ness;",
                "let the whole earth /stand in /awe of him."
            ],
            [
                "Tell it out a_mong the heath_en, that the LORD is King, and that it is he who hath made the round world so fast that it /can_/not be /moved;",
                "and how that he shall judge the /peo_ples /right_eous_ly."
            ],
            [
                "Let the hea_vens re_joice, and /let the /earth be /glad;",
                "let the sea make a noise, and /all that /there_in /is."
            ],
            [
                "Let the field be joy_ful, and /all that is /in it;",
                "then shall all the trees of the wood re_/joice be_/fore the /LORD."
            ],
            [
                "For he com_eth, for he /com_eth to /judge the earth;",
                "and with right_eous_ness to judge the world, and the /peo_ples /with his /truth."
            ]
        ]
    },
    {
        id: "psalm97",
        lines: [
            [
                "THE LORD is King, the earth /may be /glad there_of;",
                "yea, the mul_ti_tude of the /isles may be /glad there_of."
            ],
            [
                "Clouds and dark_ness are /round a_/bout him:",
                "right_eous_ness and judg_ment are the ha_bi_/ta_tion /of his seat."
            ],
            [
                "There shall go a /fire be_/fore him,",
                "and burn up his e_ne_/mies on /eve_ry /side."
            ],
            [
                "His light_nings gave shine /un_to the /world:",
                "the earth /saw it, and /was a_/fraid."
            ],
            [
                "The hills mel_ted like wax at the /pres_ence /of the /LORD;",
                "at the pres_ence of the /Lord of the /whole earth."
            ],
            [
                "The hea_vens have de_/clared his /right_eous_ness,",
                "and all the peo_ples have /seen his /glo_ry."
            ],
            [
                "Con_foun_ded be all they that wor_ship carved im_a_ges, and that de_/light in /vain /gods:",
                "/wor_ship him, /all ye gods."
            ],
            [
                "Si_on heard of it, and re_joiced; and the daugh_ters of /Ju_dah were /glad,",
                "be_cause of thy /judg_ments, O /LORD."
            ],
            [
                "For thou, LORD, art high_er than all /that are /in the /earth:",
                "thou art ex_al_ted /far a_/bove all /gods."
            ],
            [
                "O ye that love the LORD, see that ye hate the /thing which is /e_vil:",
                "the Lord pre_ser_veth the souls of his saints; he shall de_li_ver them from the hand of /the un_/god_ly."
            ],
            [
                "There is sprung up a /light for the /right_eous,",
                "and joy_ful glad_ness for such as /are true-_/heart_ed."
            ],
            [
                "Re_joice in the /LORD, ye /right_eous;",
                "and give thanks for a re_mem_brance /of his /ho_li_ness."
            ]
        ]
    },
    {
        id: "psalm98",
        lines: [
            [
                "O SING un_to the /LORD a new /song;",
                "for he hath done /mar_vell_ous /things."
            ],
            [
                "With his own right hand, and /with his /ho_ly /arm,",
                "hath he got_ten him_/self the /vic_to_ry."
            ],
            [
                "The LORD de_/clared his sal_/va_tion;",
                "his right_eous_ness hath he o_pen_ly showed in the /sight of the /heath_en."
            ],
            [
                "He hath re_mem_bered his mer_cy and truth to_ward the /house of Is_ra_el;",
                "and all the ends of the world have seen the sal_/va_tion /of our /God."
            ],
            [
                "Show your_selves joy_ful un_to the /LORD, all ye /lands;",
                "sing, re_/joice, /and give /thanks."
            ],
            [
                "Praise the /LORD up_/on the /harp;",
                "sing to the harp with a /psalm of thanks_/giv_ing."
            ],
            [
                "With trum_pets /al_so and /shawms,",
                "O show your_selves joy_ful be_/fore the /LORD, the /King."
            ],
            [
                "Let the sea make a noise, and /all that /there_in /is;",
                "the round world, and /they that /dwell there_/in."
            ],
            [
                "Let the floods clap their hands, and let the hills be joy_ful to_/ge_ther be_/fore the /LORD;",
                "for he is /come to /judge the earth."
            ],
            [
                "With right_eous_ness /shall he /judge the /world,",
                "and the /peo_ples with /eq_ui_ty."
            ]
        ]
    },
    {
        id: "psalm99",
        lines: [
            [
                "THE LORD is King, be the peo_ple nev_er /so im_/pa_tient;",
                "he sitt_eth bet_ween the Che_ru_bim, be the earth nev_er /so un_/qui_et."
            ],
            [
                "The LORD is /great in /Si_on,",
                "and high a_/bove all /peo_ple."
            ],
            [
                "They shall give /thanks un_to thy /Name,",
                "which is great, won_der_/ful, and /ho_ly."
            ],
            [
                "The King's pow_er lov_eth judg_ment; thou hast pre_/pared /eq_ui_ty,",
                "thou hast ex_e_cut_ed judg_ment and right_eous_/ness in /Ja_cob."
            ],
            [
                "O mag_ni_fy the LORD our God, and fall down be_/fore his /foot_stool;",
                "for /he is /ho_ly."
            ],
            [
                "Mo_ses and Aa_ron a_mong his priests, and Sam_u_el a_mong such as /call up_/on his Name:",
                "these called up_on the /LORD, and he /heard them."
            ],
            [
                "He spake un_to them out of the /clou_dy /pil_lar;",
                "for they kept his tes_ti_mon_ies, and the /law that he /gave them."
            ],
            [
                "Thou heard_est /them, O /LORD our God;",
                "thou for_gav_est them, O God, though thou didst pu_nish their /wick_ed /do_ings."
            ],
            [
                "O mag_ni_fy the LORD our God, and wor_ship him up_/on his /ho_ly /hill;",
                "for the LORD our /God is /ho_ly."
            ]
        ]
    },
    {
        id: "psalm100",
        lines: [
            [
                "O BE joy_ful in the /LORD, all ye /lands:",
                "serve the LORD with glad_ness, and come be_fore his /pres_ence /with a song."
            ],
            [
                "Be ye sure that the LORD he is God; it is he that hath made us, /and not /we our_/selves;",
                "we are his peo_ple, and the /sheep of his /pas_ture."
            ],
            [
                "O go your way in_to his gates with thanks_giv_ing, and /in_to his /courts with /praise;",
                "be thank_ful un_to him, and speak /good of his /Name."
            ],
            [
                "For the LORD is gra_cious, his mer_cy is /ev_er_/last_ing;",
                "and his truth en_dur_eth from ge_ne_ra_tion to /ge_ne_/ra_tion."
            ]
        ]
    },
    {
        id: "psalm101",
        lines: [
            [
                "MY song shall be of /mer_cy and /judg_ment;",
                "un_to thee, O /LORD, will I /sing."
            ],
            [
                "O let me have /un_der_/stan_ding",
                "in the /way of /god_li_ness!"
            ],
            [
                "When wilt thou /come un_to /me?",
                "I will walk in my house /with a /per_fect /heart."
            ],
            [
                "I will take no wick_ed thing in hand; I hate the /sins of un_/faith_ful_ness;",
                "there shall no such /cleave un_to /me."
            ],
            [
                "A fro_ward heart /shall de_/part from me;",
                "I will not know a /wick_ed /per_son."
            ],
            [
                "Who_so pri_vi_ly slan_der_/eth his /neigh_bour,",
                "/him will /I des_/troy."
            ],
            [
                "Who_so hath al_so a haugh_ty look /and a /proud heart,",
                "I /will not /suf_fer him."
            ],
            [
                "Mine eyes look up_on such as are /faith_ful /in the /land,",
                "that /they may /dwell with me."
            ],
            [
                "Who_so /lead_eth a /god_ly life,",
                "he shall /be my /ser_vant."
            ],
            [
                "There shall no de_ceit_ful per_son /dwell in my /house;",
                "he that tell_eth lies shall not /tar_ry in /my /sight."
            ],
            [
                "I shall soon des_troy all the un_god_ly /that are /in the land;",
                "that I may root out all wick_ed do_ers from the /ci_ty /of the /LORD."
            ]
        ]
    },
    {
        id: "psalm102",
        lines: [
            [
                "HEAR my /prayer, O /LORD,",
                "and let my cry_ing come /un_to /thee."
            ],
            [
                "Hide not thy face from me in the /time of my /trou_ble;",
                "in_cline thine ear un_to me when I call; O /hear me, and /that right soon."
            ],
            [
                "For my days are con_/sumed a_/way like /smoke,",
                "and my bones are burnt up as it /were a /fire_brand."
            ],
            [
                "My heart is smit_ten down, and /with_ered like /grass;",
                "so that I for_/get to /eat my /bread."
            ],
            [
                "For the /voice of my /groan_ing,",
                "my bones will scarce /cleave to my /flesh."
            ],
            [
                "I am be_come like a pel_i_can /in the /wil_der_ness,",
                "and like an owl that is /in the /des_ert."
            ],
            [
                "I have watched, and am e_ven as it /were a /spar_row,",
                "that sitt_eth a_lone up_/on the /house_top."
            ],
            [
                "Mine e_ne_mies re_vile me /all the day /long;",
                "and they that are mad up_on me are sworn to_/ge_ther a_/gainst /me."
            ],
            [
                "For I have eat_en ash_es /as it /were bread,",
                "and ming_led my /drink with /weep_ing;"
            ],
            [
                "And that, be_cause of thine in_dig_/na_tion and /wrath;",
                "for thou hast tak_en me /up, and /cast me /down."
            ],
            [
                "My days are /gone like a /sha_dow,",
                "and I am /with_ered /like grass."
            ],
            [
                "But thou, O LORD, shalt en_/dure for /ev_er,",
                "and thy re_mem_brance through_out all /gen_er_/a_tions."
            ],
            [
                "Thou shalt a_rise, and have mer_cy /up_on /Si_on;",
                "for it is time that thou have mer_cy up_on her, /yea, the /time is /come."
            ],
            [
                "And why? thy ser_vants /think up_/on her /stones,",
                "and it pi_ti_eth them to /see her /in the /dust."
            ],
            [
                "The na_tions shall /fear thy /Name, O LORD;",
                "and all the kings of the /earth thy /ma_jes_ty;"
            ],
            [
                "When the LORD shall /build up /Si_on,",
                "and when his /glo_ry /shall ap_/pear;"
            ],
            [
                "When he tur_neth him un_to the prayer of the /poor des_ti_tute,",
                "and des_pis_eth /not /their de_/sire."
            ],
            [
                "This shall be writ_ten for /those that come /af_ter,",
                "and the peo_ple which shall be /born shall /praise the /LORD."
            ],
            [
                "For he hath looked down from his /sanc_tu_/a_ry;",
                "out of the hea_ven did the /LORD be_/hold the earth;"
            ],
            [
                "That he might hear the mourn_ings of such as are /in cap_/ti_vi_ty,",
                "and de_li_ver them that are ap_/poin_ted /un_to /death;"
            ],
            [
                "That they may de_clare the Name of the /LORD in /Si_on,",
                "and his wor_ship /at Je_/ru_sa_lem;"
            ],
            [
                "When the peo_ples are /ga_thered to_/ge_ther,",
                "and the king_doms /al_so, to /serve the LORD."
            ],
            [
                "He brought down my /strength in my /journ_ey,",
                "and /short_ened my /days."
            ],
            [
                "But I said, O my God, take me not a_way in the /midst of mine /age;",
                "as for thy years, they en_dure through_out all /gen_er_/a_tions."
            ],
            [
                "Thou, Lord, in the be_ginn_ing hast laid the foun_/da_tion /of the earth,",
                "and the hea_vens are the /work of thy /hands."
            ],
            [
                "They shall per_ish, but /thou shalt en_/dure:",
                "they all shall wax old as /doth a /gar_ment;"
            ],
            [
                "And as a ves_ture shalt thou change them, and /they shall /be changed;",
                "but thou art the same, and thy /years shall /not fail."
            ],
            [
                "The child_ren of thy ser_vants /shall con_/tin_ue,",
                "and their seed shall stand /fast in thy /sight."
            ]
        ]
    },
    {
        id: "psalm103",
        lines: [
            [
                "PRAISE the /LORD, O my /soul;",
                "and all that is with_in me, /praise his /ho_ly Name."
            ],
            [
                "Praise the /LORD, O my /soul,",
                "and for_get not /all his /be_ne_fits:"
            ],
            [
                "Who for_/giv_eth /all thy /sin,",
                "and heal_eth all /thine in_/fir_mi_ties;"
            ],
            [
                "Who sav_eth thy /life from des_/truc_tion,",
                "and crown_eth thee with mer_cy and /lov_ing-_/kind_ness;"
            ],
            [
                "Who sa_tis_fi_eth thy /mouth with good /things,",
                "ma_king thee young and lus_ty /as an /ea_gle."
            ],
            [
                "The LORD ex_e_cut_eth right_eous_ness and /judg_ment",
                "for all them that /are op_/pressed with /wrong."
            ],
            [
                "He showed his /ways un_to /Mo_ses,",
                "his works un_to the /child_ren of /Is_ra_el."
            ],
            [
                "The LORD is full of com_/pass_ion and /mer_cy,",
                "long_suff_er_ing, /and of great /good_ness."
            ],
            [
                "He will not /al_way be /chid_ing;",
                "nei_ther keep_eth he his /an_ger for /ev_er."
            ],
            [
                "He hath not dealt with us /af_ter our /sins;",
                "nor re_war_ded us ac_cor_ding to our /wick_ed_/ness_es."
            ],
            [
                "For look how high the hea_ven is in com_/pa_ri_son /of the /earth;",
                "so great is his mer_cy al_so to_ward /them that /fear him."
            ],
            [
                "Look how wide al_so the /east is /from the /west;",
                "so far hath he /set our /sins from us."
            ],
            [
                "Yea, like as a fa_ther pi_ti_eth /his own /child_ren;",
                "e_ven so is the LORD mer_ci_ful un_to /them that /fear him."
            ],
            [
                "For he know_eth where_/of we are /made;",
                "he re_mem_ber_eth that /we are /but /dust."
            ],
            [
                "The days of /man are /but as /grass;",
                "for he flour_ish_eth as a /flow_er /of the /field."
            ],
            [
                "For as soon as the wind go_eth /o_ver it, /it is /gone;",
                "and the place there_of shall /know it no /more."
            ],
            [
                "But the mer_ci_ful good_ness of the LORD en_dur_eth for ev_er and ev_er up_on /them that /fear him;",
                "and his right_eous_ness up_on /child_ren's /child_ren;"
            ],
            [
                "E_ven up_on such as /keep his /co_ve_nant,",
                "and think up_on his com_/mand_ments to /do them."
            ],
            [
                "The LORD hath pre_pared his /seat in /hea_ven,",
                "and his king_dom /rul_eth /o_ver all."
            ],
            [
                "O praise the LORD, ye an_gels of his, ye that /ex_cel in /strength;",
                "ye that ful_fil his com_mand_ment, and hear_ken un_to the /voice of his /word."
            ],
            [
                "O praise the /LORD, all /ye his /hosts;",
                "ye ser_vants of his that /do his /plea_sure."
            ],
            [
                "O speak good of the LORD, all ye works of his, in all pla_ces of /his do_/min_ion:",
                "praise thou the LORD, /O my soul."
            ]
        ]
    },
    {
        id: "psalm104",
        lines: [
            [
                "PRAISE the /LORD, O my /soul:",
                "O LORD my God, thou art be_come ex_ceed_ing glo_rious; thou art clothed with ma_jes_/ty and /ho_nour."
            ],
            [
                "Thou deck_est thy_self with light as it /were with a /gar_ment,",
                "and spread_est out the hea_vens /like a /cur_tain."
            ],
            [
                "Who lay_eth the beams of his cham_bers /in the /wa_ters,",
                "and mak_eth the clouds his cha_ri_ot, and walk_eth up_on the /wings of the /wind."
            ],
            [
                "He /mak_eth his /an_gels /winds,",
                "and his mi_ni_/sters a /flam_ing /fire."
            ],
            [
                "He laid the found_/a_tions /of the earth,",
                "that it nev_er should /move at /an_y time."
            ],
            [
                "Thou cov_eredst it with the deep like as /with a /gar_ment;",
                "the wa_ters /stand a_/bove the hills."
            ],
            [
                "At /thy re_/buke they /flee;",
                "at the voice of thy /thun_der they /haste a_/way."
            ],
            [
                "They go up as high as the hills, and down to the /vall_eys be_/neath;",
                "e_ven un_to the place which thou hast ap_/poin_ted for /them."
            ],
            [
                "Thou hast set them their bounds, /which they /shall not /pass,",
                "nei_ther turn a_gain to /co_ver the /earth."
            ],
            [
                "He send_eth the springs /in_to the /ri_vers,",
                "which /run a_/mong the /hills."
            ],
            [
                "All beasts of the /field drink there_/of,",
                "and the wild /ass_es /quench their /thirst."
            ],
            [
                "Be_side them shall the fowls of the air have their /ha_bi_/ta_tion,",
                "and sing a_/mong the /branch_es."
            ],
            [
                "He wa_ter_eth the /hills from a_/bove;",
                "the earth is filled with the /fruit of thy /works."
            ],
            [
                "He bring_eth forth /grass for the /cat_tle,",
                "and green herb for the /ser_vice of /men;"
            ],
            [
                "That he may bring food out of the earth, and wine that mak_eth /glad the /heart of man;",
                "and oil to make him a cheer_ful coun_te_nance, and bread to /strength_en /man's heart."
            ],
            [
                "The trees of the LORD /al_so are /full of /sap;",
                "e_ven the ce_dars of Le_ba_non which /he hath /plan_ted;"
            ],
            [
                "Where_in the /birds /make their /nests;",
                "and the fir_trees are a /dwell_ing /for the stork."
            ],
            [
                "The high hills are a re_fuge /for the /wild /goats;",
                "and so are the sto_ny /rocks for the /con_ies."
            ],
            [
                "He ap_poin_ted the moon for /cer_tain /sea_sons,",
                "and the sun /know_eth his /go_ing /down."
            ],
            [
                "Thou mak_est dark_ness /that it /may be /night;",
                "where_in all the beasts of the /for_est do /move."
            ],
            [
                "The li_ons, roar_ing /af_ter their /prey,",
                "do /seek their /meat from /God."
            ],
            [
                "The sun a_ris_eth, and they get them a_/way to_/ge_ther,",
                "and lay them /down in their /dens."
            ],
            [
                "Man go_eth forth to his work, and /to his /la_bour,",
                "un_/til the /eve_ning."
            ],
            [
                "O LORD, how /ma_ni_fold /are thy /works!",
                "in wis_dom hast thou made them all; the earth is /full of thy /rich_es."
            ],
            [
                "So is the great and /wide sea /al_so;",
                "where_in are things creep_ing in_nu_me_ra_ble, both /small and /great beasts."
            ],
            [
                "There go the ships, and there is /that le_/vi_a_than,",
                "whom thou hast made to take his /pas_time there_/in."
            ],
            [
                "These /wait all up_/on thee,",
                "that thou may_est give them /meat in due /sea_son."
            ],
            [
                "When thou giv_est it /them, they /gath_er it;",
                "and when thou o_pen_est thy hand, /they are /filled with good."
            ],
            [
                "When thou hid_est thy face, /they are /trou_bled:",
                "when thou tak_est a_way their breath, they die, and are turned a_/gain to their /dust."
            ],
            [
                "When thou lett_est thy breath go /forth, they /shall be /made;",
                "and thou shalt re_new the /face of the /earth."
            ],
            [
                "The glo_rious ma_jes_ty of the LORD shall en_/dure for /ev_er;",
                "the LORD shall re_/joice in his /works."
            ],
            [
                "The earth shall trem_ble /at the /look of him;",
                "if he do but touch the /hills, they shall /smoke."
            ],
            [
                "I will sing un_to the LORD as /long as /I /live;",
                "I will praise my God while I /have my /be_ing."
            ],
            [
                "And so /shall my words /please him:",
                "my joy /shall be /in the /LORD."
            ],
            [
                "As for sin_ners, they shall be con_sumed /out /of the /earth,",
                "and the un_god_ly shall /come to an /end."
            ],
            [
                "Praise thou the /LORD, O my /soul.",
                "/Praise the /LORD."
            ]
        ]
    },
    {
        id: "psalm105",
        lines: [
            [
                "GIVE thanks un_to the LORD, and /call up_/on his /Name;",
                "tell the peo_ple what /things /he hath /done."
            ],
            [
                "O let your songs be of /him, and /praise him;",
                "and let your talk_ing be of /all his /won_drous /works."
            ],
            [
                "Re_/joice in his /ho_ly Name;",
                "let the heart of them re_/joice that /seek the /LORD."
            ],
            [
                "Seek the /LORD and his /strength;",
                "/seek his face /ev_er_more."
            ],
            [
                "Re_mem_ber the mar_vell_ous /works that /he hath /done;",
                "his won_ders, and the /judg_ments /of his /mouth;"
            ],
            [
                "O ye seed of Ab_ra_/ham his /ser_vant,",
                "ye child_ren of /Ja_cob his /cho_sen."
            ],
            [
                "He /is the /LORD our /God;",
                "his judg_ments /are in /all the world."
            ],
            [
                "He hath been al_way mind_ful of his co_ve_/nant and /prom_ise,",
                "that he made to a thou_sand /gen_er_/a_tions;"
            ],
            [
                "E_ven the co_ve_nant that he /made with /Ab_ra_ham;",
                "and the oath that he sware /un_to /I_saac;"
            ],
            [
                "And ap_poin_ted the same un_to /Ja_cob /for a law,",
                "and to Is_ra_el for an ev_er_/last_ing /tes_ta_ment;"
            ],
            [
                "Say_ing, Un_to thee will I give the /land of /Ca_naan,",
                "the lot of /your in_/he_ri_tance:"
            ],
            [
                "When there were /yet but a /few of them,",
                "and they /stran_gers /in the land;"
            ],
            [
                "What time as they went from one na_tion /to a_/no_ther,",
                "from one king_dom to a_/no_ther /peo_ple;"
            ],
            [
                "He suff_ered no /man to /do them wrong,",
                "but re_proved e_ven /kings for their /sakes;"
            ],
            [
                "Touch /not mine a_/noin_ted,",
                "and do my /pro_phets /no harm."
            ],
            [
                "More_ov_er, he called for a /dearth up_/on the land,",
                "and des_troyed all the pro_/vis_/ion of /bread."
            ],
            [
                "But he had sent a /man be_/fore them,",
                "e_ven Jo_seph, who was sold to /be a bond-_/ser_vant;"
            ],
            [
                "Whose feet they /hurt in the /stocks;",
                "the i_ron en_tered /in_/to his /soul;"
            ],
            [
                "Un_til the time came /that his /cause was /known:",
                "the word of the LORD /tried /him."
            ],
            [
                "The king /sent, and de_/li_vered him;",
                "the prince of the peo_ple /let him go /free."
            ],
            [
                "He made him lord /al_so /of his /house,",
                "and ru_ler of /all his /sub_stance;"
            ],
            [
                "That he might in_form his prin_ces /af_ter /his /will,",
                "and teach his /se_na_tors /wis_dom."
            ],
            [
                "Is_ra_el al_so came /in_to /E_gypt,",
                "and Ja_cob was a stran_ger /in the /land of /Ham."
            ],
            [
                "And he in_creased his /peo_ple ex_/ceed_ing_ly,",
                "and made them stron_ger /than their /e_ne_mies;"
            ],
            [
                "Whose heart turned so, that they /hat_ed his /peo_ple,",
                "and dealt un_tru_ly /with his /ser_vants."
            ],
            [
                "Then sent he /Mo_ses /his ser_vant,",
                "and Aa_ron whom /he had /cho_sen."
            ],
            [
                "And these showed his /tok_ens a_/mong them,",
                "and won_ders /in the /land of /Ham."
            ],
            [
                "He sent /dark_ness, and /it was /dark;",
                "and they were not o_be_di_ent /un_to his /word."
            ],
            [
                "He turned their /wa_ters /in_to /blood,",
                "and slew their /fish."
            ],
            [
                "Their /land /brought forth /frogs;",
                "yea, e_ven /in their /kings' cham_bers."
            ],
            [
                "He spake the word, and there came all /man_ner of /flies,",
                "and lice in /all their /quar_ters."
            ],
            [
                "He gave them /hail_stones for /rain;",
                "and flames of /fire in their /land."
            ],
            [
                "He smote their vines /al_so and /fig-_trees;",
                "and des_troyed the trees /that were /in their /coasts."
            ],
            [
                "He spake the word, and the grass_hop_pers came, and ca_ter_pil_lars in_/nu_me_/ra_ble,",
                "and did eat up all the grass in their land, and de_voured the /fruit of their /ground."
            ],
            [
                "He smote all the /first_born /in their /land;",
                "e_ven the /chief of /all their /strength."
            ],
            [
                "He brought them forth al_so with /sil_ver and /gold;",
                "there was not one fee_ble /per_son a_/mong their tribes."
            ],
            [
                "E_gypt was glad at /their de_/part_ing;",
                "for they /were a_/fraid of them."
            ],
            [
                "He spread out a cloud to /be a /co_ver_ing,",
                "and fire to give light in the night /sea_son."
            ],
            [
                "At their de_/sire he brought /quails;",
                "and he filled them with the /bread of /hea_ven."
            ],
            [
                "He o_pened the rock of stone, and the /wa_ters flowed /out,",
                "so that ri_vers ran /in the /dry pla_ces."
            ],
            [
                "For why? he re_mem_bered his /ho_ly /prom_ise;",
                "and Ab_ra_/ham his /ser_vant."
            ],
            [
                "And he brought forth his /peo_ple with /joy,",
                "and his /cho_sen with /glad_ness;"
            ],
            [
                "And gave them the /lands of the /heath_en;",
                "and they took the la_bours of the peo_ple /in pos_/sess_ion;"
            ],
            [
                "That they might /keep his /stat_utes,",
                "and ob_/serve his /laws."
            ]
        ]
    },
    {
        id: "psalm106",
        lines: [
            [
                "O GIVE thanks un_to the LORD; for /he is /gra_cious,",
                "and his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who can ex_press the no_ble /acts of the /LORD,",
                "or show /forth /all his /praise?"
            ],
            [
                "Bless_ed are they that /al_way keep /judg_ment,",
                "and do /right_eous_ness."
            ],
            [
                "Re_mem_ber me, O LORD, ac_cor_ding to the fa_vour that thou bear_est /un_to thy /peo_ple;",
                "O vis_it me with /thy sal_/va_tion;"
            ],
            [
                "That I may see the fe_li_ci_ty /of thy /cho_sen,",
                "and re_joice in the glad_ness of thy peo_ple, and give thanks with /thine in_/he_ri_tance."
            ],
            [
                "We have /sinned with our /fa_thers;",
                "we have done a_/miss, and dealt /wick_ed_ly."
            ],
            [
                "Our fa_thers re_gar_ded not thy won_ders in E_gypt, nei_ther kept they thy great good_ness /in re_/mem_brance;",
                "but were dis_o_be_di_ent at the sea, e_ven /at the Red /Sea."
            ],
            [
                "Ne_ver_the_less, he helped them /for his /Name's sake,",
                "that he might make his /pow_er /to be /known."
            ],
            [
                "He re_buked the Red Sea al_so, and /it was /dried up;",
                "so he led them through the deep, as /through a /wil_der_ness."
            ],
            [
                "And he saved them from the ad_/ver_sa_ry's /hand,",
                "and de_li_vered them from the /hand of the /e_ne_my."
            ],
            [
                "As for those that trou_bled them, the wa_ters /ov_er_/whelmed them;",
                "there was not /one /of them /left."
            ],
            [
                "Then be_/lieved they his /words,",
                "and sang /praise /un_to /him."
            ],
            [
                "But with_in a /while they for_/gat his /works,",
                "and would not a_/bide his /coun_sel."
            ],
            [
                "But lust came up_on them /in the /wil_der_ness,",
                "and they tempt_ed /God in the /des_ert."
            ],
            [
                "And he /gave them /their de_/sire,",
                "and sent lean_ness with_al /in_to /their /soul."
            ],
            [
                "They an_gered Mo_ses /al_so /in the /tents,",
                "and Aa_ron the /saint of /the /LORD."
            ],
            [
                "So the earth o_pened, and /swal_lowed up /Da_than,",
                "and co_vered the con_gre_/ga_tion of A_/bi_ram."
            ],
            [
                "And the fire was kin_dled /in their /com_pa_ny;",
                "the flame burnt /up the un_/god_ly."
            ],
            [
                "They made a /calf in /Ho_reb,",
                "and wor_shipped the /mol_ten /im_age."
            ],
            [
                "Thus they /turned their /glo_ry",
                "in_to the si_mi_li_tude of a /calf that /eat_eth /hay."
            ],
            [
                "And they for_gat /God their /Sav_iour,",
                "who had done so great /things in /E_gypt;"
            ],
            [
                "Won_drous /works in the /land of /Ham;",
                "and fear_ful /things by the /Red Sea."
            ],
            [
                "So he said he would have des_troyed them, had not Mo_ses his cho_sen stood be_/fore him /in the /gap,",
                "to turn a_way his wrath_ful in_dig_na_tion, lest he /should des_/troy them."
            ],
            [
                "Yea, they thought /scorn of that /plea_sant /land,",
                "and gave no cre_dence /un_to /his /word;"
            ],
            [
                "But /mur_mured /in their /tents,",
                "and heark_ened not un_to the /voice /of the /LORD."
            ],
            [
                "Then lift he up his /hand a_/gainst them,",
                "to o_ver_throw them /in the /wil_der_ness;"
            ],
            [
                "To cast out their seed a_/mong the /na_tions,",
                "and to /scat_ter them /in the /lands."
            ],
            [
                "They joined them_selves /un_to /Baal-_pe_or,",
                "and ate the /of_fer_ings /of the /dead."
            ],
            [
                "Thus they pro_voked him to an_ger with their /own in_/ven_tions;",
                "and the plague was /great a_/mong them."
            ],
            [
                "Then stood up Phi_ne_has, and /in_ter_/posed;",
                "and /so the /plague ceased."
            ],
            [
                "And that was coun_ted un_to /him for /right_eous_ness,",
                "a_mong all pos_te_ri_/ties for /ev_er_more."
            ],
            [
                "They an_gered him al_so at the /wa_ters of /strife,",
                "so that he pun_ished /Mo_ses /for their /sakes;"
            ],
            [
                "Be_cause they pro_/voked his /spi_rit,",
                "so that he spake un_ad_/vi_sed_ly /with his /lips."
            ],
            [
                "Nei_ther des_troyed /they the /heath_en,",
                "as the /LORD com_/man_ded them;"
            ],
            [
                "But were ming_led a_/mong the /heath_en,",
                "and learned their /works."
            ],
            [
                "In_so_much that they wor_shipped their i_dols, which be_came a /snare un_to /them;",
                "yea, they off_ered their sons and their daugh_ters /un_to /dev_ils;"
            ],
            [
                "And shed in_no_cent blood, e_ven the blood of their sons and /of their /daugh_ters,",
                "whom they off_ered un_to the i_dols of Ca_naan; and the /land was de_/filed with /blood."
            ],
            [
                "Thus were they /stained with their /own works,",
                "and went a whor_ing with their /own in_/ven_tions."
            ],
            [
                "There_fore was the wrath of the LORD kin_dled a_/gainst his /peo_ple,",
                "in_so_much that he ab_horred his /own in_/he_ri_tance."
            ],
            [
                "And he gave them o_ver in_to the /hand of the /heath_en;",
                "and they that hat_ed them were /lords /o_ver /them."
            ],
            [
                "Their e_ne_mies op_/pressed them,",
                "and had them /in sub_/jec_tion."
            ],
            [
                "Ma_ny a time /did he de_/li_ver them;",
                "but they re_belled a_gainst him with their own in_ven_tions, and were brought /down in their /wick_ed_ness."
            ],
            [
                "Ne_ver_the_less, when he /saw their ad_/ver_si_ty,",
                "he /heard their com_/plaint."
            ],
            [
                "He thought up_on his co_ve_nant, and pit_ied them, ac_cor_ding un_to the mul_ti_tude /of his /mer_cies;",
                "yea, he made all those that led them a_way /cap_tive to /pi_ty them."
            ],
            [
                "De_li_ver us, O LORD our God, and gath_er us from a_/mong the /heath_en;",
                "that we may give thanks un_to thy ho_ly Name, and make our /boast of thy /praise."
            ],
            [
                "Bless_ed be the LORD God of Is_ra_el, from ev_er_last_ing, and /world with_/out /end;",
                "And let all the /peo_ple /say, A_/men."
            ]
        ]
    },
    {
        id: "psalm107",
        lines: [
            [
                "O GIVE thanks un_to the LORD, for /he is /gra_cious,",
                "and his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Let them give thanks whom the /LORD hath re_/deemed,",
                "and de_li_vered from the /hand of the /e_ne_my;"
            ],
            [
                "And ga_thered them out of the lands, from the /east, and /from the /west;",
                "from the /north, and /from the south."
            ],
            [
                "They went as_tray in the wil_der_ness /out of the /way,",
                "and found no /ci_ty to /dwell in."
            ],
            [
                "Hun_gry and /thirs_ty,",
                "their soul /faint_ed /in them."
            ],
            [
                "So they cried un_to the LORD /in their /trou_ble,",
                "and he de_li_vered /them from /their dist_ress."
            ],
            [
                "He led them forth /by the right /way,",
                "that they might go to the /ci_ty /where they /dwelt."
            ],
            [
                "O that men would there_fore praise the LORD /for his /good_ness;",
                "and de_clare the won_ders that he do_eth for the /child_ren of /men!"
            ],
            [
                "For he sa_tis_/fi_eth the /emp_ty soul,",
                "and fil_leth the hun_gry /soul with /good_ness."
            ],
            [
                "Such as sit in dark_ness, and in the /sha_dow of /death,",
                "be_ing fast bound in mi_se_/ry and /i_ron;"
            ],
            [
                "Be_cause they re_belled a_gainst the /words of the /Lord,",
                "and light_ly re_gar_ded the coun_sel /of the Most /High_est;"
            ],
            [
                "He al_so brought down their /heart through /hea_vi_ness:",
                "they fell down, and there was /none to /help them."
            ],
            [
                "So when they cried un_to the LORD /in their /trou_ble,",
                "he de_li_vered them /out of /their dist_/ress."
            ],
            [
                "For he brought them out of dark_ness, and out of the /sha_dow of /death,",
                "and brake their /bonds in /sun_der."
            ],
            [
                "O that men would there_fore praise the LORD /for his /good_ness;",
                "and de_clare the won_ders that he do_eth for the /child_ren of /men!"
            ],
            [
                "For he hath /bro_ken the /gates of /brass,",
                "and smit_ten the bars of /i_ron in /sun_der."
            ],
            [
                "Fool_ish men are /plagued for /their of_/fence,",
                "and be_/cause of their /wick_ed_ness."
            ],
            [
                "Their soul ab_horred all /man_ner of /meat,",
                "and they were e_ven /hard at /death's door."
            ],
            [
                "So when they cried un_to the LORD /in their /trou_ble,",
                "he de_li_vered them /out of /their dist_/ress."
            ],
            [
                "He sent his /word, and /healed them;",
                "and they were saved from /their des_/truc_tion."
            ],
            [
                "O that men would there_fore praise the LORD /for his /good_ness;",
                "and de_clare the won_ders that he do_eth for the /child_ren of /men!"
            ],
            [
                "That they would off_er un_to him the sac_ri_fice /of thanks_/giv_ing,",
                "and tell out his /works with /glad_ness!"
            ],
            [
                "THEY that go /down to the /sea in /ships,",
                "and oc_cu_py their busi_ness /in great /wa_ters;"
            ],
            [
                "These men see the /works of the /LORD,",
                "and his /won_ders /in the /deep."
            ],
            [
                "For at his word the stor_my /wind a_/ris_eth,",
                "which lift_eth /up the /waves there_/of."
            ],
            [
                "They are car_ried up to the hea_ven, and down a_/gain to the /deep;",
                "their soul melt_eth a_way be_/cause of the /trou_ble."
            ],
            [
                "They reel to and fro, and stag_ger /like a /drunk_en /man,",
                "and are /at their /wit's end."
            ],
            [
                "So when they cry un_to the LORD /in their /trou_ble,",
                "he de_li_ver_eth them /out of /their dist_/ress."
            ],
            [
                "For he /mak_eth the /storm to /cease,",
                "so that the /waves there_/of are /still."
            ],
            [
                "Then are they glad, be_/cause they /are at /rest;",
                "and so he bring_eth them un_to the ha_ven /where they /would be."
            ],
            [
                "O that men would there_fore praise the LORD /for his /good_ness;",
                "and de_clare the won_ders that he do_eth for the /child_ren of /men!"
            ],
            [
                "That they would ex_alt him al_so in the con_gre_ga_tion /of the /peo_ple,",
                "and praise him in the /seat of the /eld_ers!"
            ],
            [
                "He tur_neth the floods /in_to a /wil_der_ness,",
                "and dri_eth up the /wa_ter-_springs."
            ],
            [
                "A fruit_ful land /mak_eth he /bar_ren,",
                "for the wick_ed_ness of /them that /dwell there_/in."
            ],
            [
                "A_gain, he mak_eth the wil_der_ness a /stand_ing /wa_ter,",
                "and wa_ter-_springs /of a /dry ground."
            ],
            [
                "And there he /set_teth the /hun_gry,",
                "that they may build them a /ci_ty to /dwell in;"
            ],
            [
                "That they may sow their /land, and plant /vine_yards,",
                "to yield them /fruits of /in_crease."
            ],
            [
                "He bles_seth them, so that they mul_ti_/ply ex_/ceed_ing_ly;",
                "and suff_er_eth not their /cat_tle /to de_/crease."
            ],
            [
                "And a_gain, when they are /min_ished /and brought /low",
                "through opp_ress_ion, through an_y /plague or /trou_ble;"
            ],
            [
                "Though he suf_fer them to be e_vil en_/treat_ed through /ty_rants,",
                "and let them wan_der out of the /way in the /wil_der_ness;"
            ],
            [
                "Yet help_eth he the poor /out of /mi_se_ry,",
                "and mak_eth him house_holds /like a /flock of /sheep."
            ],
            [
                "The right_eous will con_si_der /this, and re_/joice;",
                "and the mouth of all /wick_ed_ness /shall be /stopped."
            ],
            [
                "Who_so is wise, will /pon_der /these /things;",
                "and they shall un_der_stand the lov_ing-_/kind_ness /of the /LORD."
            ]
        ]
    },
    {
        id: "psalm108",
        lines: [
            [
                "O GOD, my heart is rea_dy, my /heart is /rea_dy;",
                "I will sing, and give praise with the best /mem_ber /that I have."
            ],
            [
                "A_/wake, thou /lute and /harp;",
                "I my_self will a_/wake right /ear_ly."
            ],
            [
                "I will give thanks un_to thee, O LORD, a_/mong the /peo_ples;",
                "I will sing prais_es un_to thee a_/mong the /na_tions."
            ],
            [
                "For thy mer_cy is great_er /than the /hea_vens,",
                "and thy truth reach_eth /un_/to the /clouds."
            ],
            [
                "Set up thy_self, O God, a_/bove the /hea_vens,",
                "and thy glo_ry a_/bove /all the /earth;"
            ],
            [
                "That thy be_lov_ed may /be de_/li_vered:",
                "let thy right hand /save them, and /hear thou me."
            ],
            [
                "God hath spo_ken /in his /ho_li_ness;",
                "I will re_joice there_fore, and di_vide She_chem, and mete out the /val_ley of /Succ_oth."
            ],
            [
                "Gi_le_ad is mine, and Ma_/na_sseh /is /mine;",
                "Eph_ra_im al_so is the strength of my head; Ju_dah /is my /law_giv_er;"
            ],
            [
                "Mo_ab is my wash-_pot; o_ver E_dom will I /cast /out my /shoe;",
                "up_on Phil_is_ti_a /will I /tri_umph."
            ],
            [
                "Who will lead me in_to /the strong /ci_ty?",
                "and who will bring me /in_to /E_dom?"
            ],
            [
                "Hast not thou for_/sa_ken /us, O /God?",
                "and wilt not thou, O God, go /forth with our /hosts?"
            ],
            [
                "O help us a_/gainst the /e_ne_my:",
                "for /vain is the /help of /man."
            ],
            [
                "Through God /we shall do /great acts;",
                "and it is he that shall tread /down our /e_ne_mies."
            ]
        ]
    },
    {
        id: "psalm109",
        lines: [
            [
                "Hold not thy tongue, O /God of my /praise;",
                "for the mouth of the un_god_ly, yea, the mouth of the de_ceit_ful is /o_pened up_/on me."
            ],
            [
                "And they have spo_ken a_/gainst me with /false tongues;",
                "they com_passed me a_bout al_so with words of hat_red, and fought a_/gainst me with_/out a cause."
            ],
            [
                "For the love that I had un_to them, lo, they take now my /con_tra_ry /part;",
                "but I give my_/self /un_to /prayer."
            ],
            [
                "Thus have they re_war_ded me /e_vil for /good,",
                "and hat_red /for my /good will."
            ],
            [
                "Set thou an un_god_ly man to be /ru_ler /o_ver him,",
                "and let an ad_ver_sa_ry /stand at his /right /hand."
            ],
            [
                "When sen_tence is gi_ven up_on him, let him /be con_/demned;",
                "and let his prayer be /turned /in_to /sin."
            ],
            [
                "/Let his /days be /few;",
                "and let a_no_ther /take his /off_ice."
            ],
            [
                "Let his /child_ren be /fa_ther_less,",
                "and his /wife a /wid_ow."
            ],
            [
                "Let his child_ren be va_ga_/bonds, and /beg their /bread;",
                "let them seek it al_so out of /de_so_late /pla_ces."
            ],
            [
                "Let the ex_tor_tion_er con_sume /all that he /hath;",
                "and let the stran_ger /spoil his /la_bour."
            ],
            [
                "Let there be no /man to /pi_ty him,",
                "nor to have com_pass_ion up_on his /fa_ther_less /child_ren."
            ],
            [
                "Let his pos_/te_ri_ty /be des_/troyed;",
                "and in the next ge_ne_ra_tion let his /name be /clean put out."
            ],
            [
                "Let the wick_ed_ness of his fa_thers be had in re_mem_brance in the /sight of the /LORD;",
                "and let not the sin of his /mo_ther be /done a_/way."
            ],
            [
                "Let them /al_way be be_/fore the LORD,",
                "that he may root out the me_mor_i_al of /them from /off the earth;"
            ],
            [
                "And that, be_cause his mind was /not to do /good;",
                "but per_se_cu_ted the poor help_less man, that he might slay him that was /vexed /at the /heart."
            ],
            [
                "His de_light was in cur_sing, and it shall /hap_pen /un_to /him;",
                "he loved not bless_ing, there_fore /shall it be /far from /him."
            ],
            [
                "He clothed him_self with cur_sing like as /with a /rai_ment,",
                "and it shall come in_to his bow_els like wa_ter, and like oil /in_to /his /bones."
            ],
            [
                "Let it be un_to him as the cloak that he /hath up_/on him,",
                "and as the gir_dle that he is al_way /gir_ded with_/al."
            ],
            [
                "Let it thus hap_pen from the LORD /un_to mine /e_ne_mies,",
                "and to those that speak /e_vil a_/gainst my /soul."
            ],
            [
                "But deal thou with me, O LORD God, ac_cor_ding /un_to thy /Name;",
                "for /sweet is thy /mer_cy."
            ],
            [
                "O de_li_ver me, for I am /help_less and /poor,",
                "and my heart is /woun_ded with_/in me."
            ],
            [
                "I go hence like the sha_dow /that de_/par_teth,",
                "and am driv_en a_way /as the /grass_hop_per."
            ],
            [
                "My knees are /weak through /fast_ing;",
                "my flesh is dried up for /want of /fat_ness."
            ],
            [
                "I am be_come al_so a rep_roach /un_to /them:",
                "they that look up_/on me /shake their heads."
            ],
            [
                "/Help me, O /LORD my /God;",
                "O save me ac_cor_ding /to thy /mer_cy;"
            ],
            [
                "And they shall know how that /this is thy /hand,",
                "and that /thou, LORD, hast /done it."
            ],
            [
                "Though they /curse, yet /bless thou;",
                "and let them be con_foun_ded that rise up a_gainst me; but let thy /ser_vant re_/joice."
            ],
            [
                "Let mine ad_ver_sa_ries be /clothed with /shame;",
                "and let them co_ver them_selves with their own con_fu_sion, /as /with a /cloak."
            ],
            [
                "As for me, I will give great thanks un_to the /LORD with my /mouth,",
                "and praise him a_/mong the /mul_ti_tude;"
            ],
            [
                "For he shall stand at the /right hand /of the /poor,",
                "to save his soul from un_/right_eous /judg_es."
            ]
        ]
    },
    {
        id: "psalm110",
        lines: [
            [
                "THE LORD said /un_to my /Lord,",
                "Sit thou on my right hand, un_til I make thine e_ne_mies thy /foot_stool."
            ],
            [
                "The LORD shall send the rod of thy pow_er /out of /Si_on:",
                "be thou ru_ler, e_ven in the midst a_/mong thine /e_ne_mies."
            ],
            [
                "In the day of thy pow_er shall thy peo_ple off_er them_selves will_ing_ly with an /ho_ly /wor_ship:",
                "thy young men come to thee as dew from the /womb of the /mor_ning."
            ],
            [
                "The LORD /sware, and will /not re_/pent,",
                "Thou art a Priest for ev_er af_ter the or_der /of Mel_/chi_ze_dek."
            ],
            [
                "The Lord up_/on thy /right hand",
                "shall wound e_ven kings in the /day of /his /wrath."
            ],
            [
                "He shall judge a_/mong the /heath_en;",
                "he shall fill the pla_ces with the dead bod_ies, and smite in sun_der the heads o_ver /di_vers /coun_tries."
            ],
            [
                "He shall drink of the /brook in the /way;",
                "there_fore /shall he lift /up his /head."
            ]
        ]
    },
    {
        id: "psalm111",
        lines: [
            [
                "I WILL give thanks un_to the LORD /with my /whole heart,",
                "se_cret_ly a_mong the faith_ful, and in the /con_gre_/ga_tion."
            ],
            [
                "The works of the /LORD are /great,",
                "sought out of all them that have /plea_sure there_/in."
            ],
            [
                "His work is wor_thy to be praised and /had in /ho_nour,",
                "and his right_eous_ness en_/dur_eth for /ev_er."
            ],
            [
                "The mer_ci_ful and gra_cious LORD hath so done his /mar_vell_ous /works,",
                "that they ought to be /had in re_/mem_brance."
            ],
            [
                "He hath gi_ven meat un_to /them that /fear him;",
                "he shall ev_er be mind_ful /of his /co_ve_nant."
            ],
            [
                "He hath showed his peo_ple the /pow_er /of his /works,",
                "that he may give them the he_ri_tage /of the /heath_en."
            ],
            [
                "The works of his hands are /ve_ri_ty and /judg_ment;",
                "all his com_/mand_ments are /true."
            ],
            [
                "They stand fast for /ev_er and /ev_er,",
                "and are done in /truth and /eq_ui_ty."
            ],
            [
                "He sent re_demp_tion /un_to his /peo_ple;",
                "he hath com_man_ded his co_ve_nant for ev_er; ho_ly and /re_ver_end /is his /Name."
            ],
            [
                "The fear of the LORD is the be_/ginn_ing of /wis_dom;",
                "a good un_der_stan_ding have all they that do there_af_ter; his praise en_/dur_eth for /ev_er."
            ]
        ]
    },
    {
        id: "psalm112",
        lines: [
            [
                "BLESS_ED is the man that /fear_eth the /LORD;",
                "he hath great de_light in /his com_/mand_ments."
            ],
            [
                "His seed shall be /migh_ty up_/on earth;",
                "the ge_ne_ra_tion of the /faith_ful /shall be /blessed."
            ],
            [
                "Rich_es and plen_teous_ness shall /be in his /house;",
                "and his right_eous_ness en_/dur_eth for /ev_er."
            ],
            [
                "Un_to the god_ly there a_ris_eth up /light in the /dark_ness;",
                "he is mer_ci_ful, /lov_ing, and /right_eous."
            ],
            [
                "A good man is mer_ci_/ful, and /len_deth;",
                "and will guide his /words with dis_/cre_tion."
            ],
            [
                "For he shall /nev_er be /moved:",
                "and the right_eous shall be had in ev_er_/last_ing re_/mem_brance."
            ],
            [
                "He will not be a_fraid of an_y /e_vil /tid_ings;",
                "for his heart stand_eth fast, and be_/liev_eth /in the /LORD."
            ],
            [
                "His heart is /stab_lished, and /will not /shrink,",
                "un_til he see his de_sire up_/on his /e_ne_mies."
            ],
            [
                "He hath dis_persed a_broad, and /gi_ven /to the /poor.",
                "and his right_eous_ness re_main_eth for ev_er; his horn shall be ex_/al_ted with /ho_nour."
            ],
            [
                "The un_god_ly shall see it, and /it shall /grieve him;",
                "he shall gnash with his teeth, and con_sume a_way; the de_sire of the un_/god_ly shall /per_ish."
            ]
        ]
    },
    {
        id: "psalm113",
        lines: [
            [
                "PRAISE the /LORD, ye /ser_vants;",
                "O praise the /Name /of the /LORD."
            ],
            [
                "Bless_ed be the /Name of the /LORD",
                "from this time /forth for /ev_er_more."
            ],
            [
                "The LORD'S /Name is /praised",
                "from the ris_ing up of the sun un_to the go_ing /down of the /same."
            ],
            [
                "The LORD is high a_/bove all /na_tions,",
                "and his glo_ry a_/bove the /hea_vens."
            ],
            [
                "Who is like un_to the LORD our God, that hath his /dwell_ing so /high,",
                "and yet humb_leth him_self to be_hold the things that are in /hea_ven and /earth!"
            ],
            [
                "He tak_eth up the sim_ple /out of the /dust,",
                "and lift_eth the poor /out of /the /mire;"
            ],
            [
                "That he may set him /with the /prin_ces,",
                "e_ven with the prin_ces /of his /peo_ple."
            ],
            [
                "He mak_eth the bar_ren /wo_man /to keep /house,",
                "and to be a joy_ful /mo_ther of /child_ren."
            ]
        ]
    },
    {
        id: "psalm114",
        lines: [
            [
                "WHEN Is_ra_el came /out of /E_gypt,",
                "and the house of Ja_cob from a_/mong the strange /peo_ple,"
            ],
            [
                "Ju_dah was his /sanc_tu_/a_ry,",
                "and Is_ra_el /his do_/min_ion."
            ],
            [
                "The /sea saw /that, and fled;",
                "/Jor_dan was /driv_en back."
            ],
            [
                "The /moun_tains /skipped like /rams,",
                "and the lit_tle /hills like /young sheep."
            ],
            [
                "What ail_eth thee, O thou /sea, that thou /fled_dest?",
                "and thou Jor_dan, that /thou wast /driv_en /back?"
            ],
            [
                "Ye moun_tains, /that ye /skipped like /rams?",
                "and ye lit_tle /hills, like /young sheep?"
            ],
            [
                "Trem_ble, thou earth, at the /pres_ence /of the /Lord:",
                "at the pres_ence of the /God of /Ja_cob;"
            ],
            [
                "Who turned the hard rock in_to a /stand_ing /wa_ter,",
                "and the flint-_stone /in_to a /spring_ing /well."
            ]
        ]
    },
    {
        id: "psalm115",
        lines: [
            [
                "NOT un_to us, O LORD, not un_to us, but un_to /thy Name /give the /praise;",
                "for thy lov_ing mer_cy, and /for thy /truth's sake."
            ],
            [
                "Where_fore /shall the /heath_en say,",
                "/Where is /now their /God?"
            ],
            [
                "As for our God, he /is in /hea_ven:",
                "he hath done what_so_/ev_er /pleased him."
            ],
            [
                "Their i_dols are /sil_ver /and /gold,",
                "e_ven the /work of men's /hands."
            ],
            [
                "They have /mouths, and /speak not;",
                "eyes have /they, and /see not."
            ],
            [
                "They have /ears, and /hear not;",
                "no_ses have /they, and /smell not."
            ],
            [
                "They have hands, and han_dle not; feet have /they, and /walk not;",
                "nei_ther /speak they /through their throat."
            ],
            [
                "They that make them /are like /un_to /them;",
                "and so are all such as /put their /trust in them."
            ],
            [
                "But thou, house of Is_ra_el, /trust thou /in the LORD;",
                "he is their hel_per /and de_fen_der."
            ],
            [
                "Ye house of Aa_ron, put your /trust in the /LORD;",
                "he is their hel_per /and de_fen_der."
            ],
            [
                "Ye that fear the LORD, put your /trust in the /LORD;",
                "he is their hel_per /and de_fen_der."
            ],
            [
                "The LORD hath been mind_ful of us, and /he shall /bless us;",
                "e_ven he shall bless the house of Is_ra_el, he shall bless the /house of /Aa_ron."
            ],
            [
                "He shall /bless them that /fear the /LORD,",
                "both /small and great."
            ],
            [
                "The LORD shall in_/crease you /more and more,",
                "you /and your /child_ren."
            ],
            [
                "Ye are the /bless_ed /of the /LORD,",
                "who made /hea_ven and /earth."
            ],
            [
                "All the whole /hea_vens /are the LORD'S;",
                "the earth hath he gi_ven to the /child_ren of /men."
            ],
            [
                "The dead /praise not /thee, O LORD,",
                "nei_ther all they that go /down in_to /si_lence."
            ],
            [
                "But /we will /praise the LORD,",
                "from this time forth for ev_er_more. /Praise the LORD."
            ]
        ]
    },
    {
        id: "psalm116",
        lines: [
            [
                "MY de_/light is /in the /LORD;",
                "be_cause he hath heard the /voice of my /prayer;"
            ],
            [
                "Be_cause he hath in_/clined his ear /un_to /me;",
                "there_fore will I call up_on him as /long as I /live."
            ],
            [
                "The snares of death /com_passed me /round a_/bout,",
                "and the pains of hell gat /hold up_/on me."
            ],
            [
                "I found trou_ble and hea_vi_ness; then called I up_on the /Name of the /LORD;",
                "O LORD, I be_seech thee, de_/li_ver my /soul."
            ],
            [
                "Gra_cious is the /LORD, and /right_eous;",
                "yea, our /God is /mer_ci_ful."
            ],
            [
                "The LORD pre_/ser_veth the /sim_ple:",
                "I was in mi_se_ry, /and he /helped me."
            ],
            [
                "Turn a_gain then un_to thy /rest, O my /soul;",
                "for the LORD /hath re_/war_ded /thee."
            ],
            [
                "And why? thou hast de_/li_vered my /soul from /death,",
                "mine eyes from tears, and my /feet from /fall_ing."
            ],
            [
                "I will /walk be_/fore the /LORD",
                "in the /land of the /li_ving."
            ],
            [
                "I be_lieved, and there_fore will I speak; but I /was sore /trou_bled:",
                "I said in my haste, All /men are /li_ars."
            ],
            [
                "What re_ward shall I give /un_to the /LORD",
                "for all the be_ne_fits that he hath /done un_to /me?"
            ],
            [
                "I will re_ceive the /cup of sal_/va_tion,",
                "and call up_on the /Name of the /LORD."
            ],
            [
                "I will pay my vows now in the pres_ence of /all his /peo_ple:",
                "right dear in the sight of the LORD is the /death of his /saints."
            ],
            [
                "Be_hold, O LORD, how that /I am thy /ser_vant;",
                "I am thy ser_vant, and the son of thine hand_maid; thou hast bro_ken my /bonds in /sun_der."
            ],
            [
                "I will off_er to thee the sac_ri_fice /of thanks_/giv_ing,",
                "and will call up_on the /Name of the /LORD."
            ],
            [
                "I will pay my vows un_to the LORD, in the sight of /all his /peo_ple,",
                "in the courts of the LORD'S house; e_ven in the midst of thee, O Je_/ru_sa_lem. /Praise the /LORD."
            ]
        ]
    },
    {
        id: "psalm117",
        lines: [
            [
                "O PRAISE the LORD, /all ye /na_tions;",
                "praise him, /all ye /peo_ples."
            ],
            [
                "For his mer_ci_ful kind_ness is ev_er more and /more to_/ward us;",
                "and the truth of the LORD en_dur_eth for /ev_er. /Praise the LORD."
            ]
        ]
    },
    {
        id: "psalm118",
        lines: [
            [
                "O GIVE thanks un_to the LORD, for /he is /gra_cious;",
                "be_cause his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Let Is_ra_el now con_fess that /he is /gra_cious,",
                "and that his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Let the house of /Aa_ron /now con_/fess,",
                "that his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Yea, let them now that /fear the /LORD con_/fess,",
                "that his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "I called up_on the /LORD in /trou_ble;",
                "and the LORD /heard me /at /large."
            ],
            [
                "The /LORD is /on my side;",
                "I will not fear what man /do_eth /un_to /me."
            ],
            [
                "The LORD tak_eth my part with /them that /help me;",
                "there_fore shall I see my de_sire up_/on mine /e_ne_mies."
            ],
            [
                "It is bet_ter to /trust in the /LORD,",
                "than to put an_y /con_fi_/dence in /man."
            ],
            [
                "It is bet_ter to /trust in the /LORD,",
                "than to put an_y con_fi_/dence in /prin_ces."
            ],
            [
                "All na_tions /com_passed me /round a_/bout;",
                "but in the Name of the LORD will /I des_/troy them."
            ],
            [
                "They kept me in on eve_ry side, they kept me in, I /say, on /eve_ry side;",
                "but in the Name of the LORD will /I des_/troy them."
            ],
            [
                "They came a_bout me like bees, and are ex_tinct e_ven as the /fire a_/mong the /thorns;",
                "for in the Name of the LORD I /will des_/troy them."
            ],
            [
                "Thou hast thrust sore at me, /that I might /fall;",
                "but the /LORD was my /help."
            ],
            [
                "The LORD is my /strength, and my /song;",
                "and is be_/come my sal_/va_tion."
            ],
            [
                "The voice of joy and health is in the dwell_ings /of the /right_eous;",
                "the right hand of the LORD bring_eth /migh_ty /things to /pass."
            ],
            [
                "The right hand of the LORD /hath the pre-_/em_in_ence;",
                "the right hand of the LORD bring_eth /migh_ty /things to /pass."
            ],
            [
                "I /shall not /die, but /live,",
                "and de_clare the /works of the /LORD."
            ],
            [
                "The LORD hath chast_ened /and cor_/rec_ted me;",
                "but he hath not gi_ven me /o_ver /un_to /death."
            ],
            [
                "O_pen me the /gates of /right_eous_ness,",
                "that I may go in_to them, and give thanks /un_to the /LORD."
            ],
            [
                "This is the /gate of the /LORD,",
                "the right_eous shall /en_ter /in_to it."
            ],
            [
                "I will thank thee; for /thou hast /heard me,",
                "and art be_/come my sal_/va_tion."
            ],
            [
                "The same stone which the /build_ers re_/fused,",
                "is be_come the head-_stone /in the /corn_er."
            ],
            [
                "This /is the /LORD'S do_ing,",
                "and it is /mar_vell_ous /in our /eyes."
            ],
            [
                "This is the /day which the /LORD hath /made;",
                "we will re_/joice and be /glad in it."
            ],
            [
                "Help me /now, O LORD:",
                "O LORD, send us /now pros_/pe_ri_ty."
            ],
            [
                "Bless_ed be he that com_eth in the /Name of the /LORD:",
                "we have wished you good luck, we that are of the /house of the /LORD."
            ],
            [
                "God is the /LORD, who hath /showed us /light:",
                "bind the sac_ri_fice with cords, yea, e_ven un_to the /horns of the /al_tar."
            ],
            [
                "Thou art my God, and /I will /thank thee;",
                "thou art my God, and /I will /praise thee."
            ],
            [
                "O give thanks un_to the LORD; for /he is /gra_cious,",
                "and his mer_cy en_/dur_eth for /ev_er."
            ]
        ]
    },
    {
        id: "psalm119",
        lines: [
            [
                "BLESS_ED are those that are un_de_/filed in the /way,",
                "and walk in the /law of the /LORD."
            ],
            [
                "Bless_ed are they that keep his /tes_ti_/mon_ies,",
                "and seek him /with their /whole heart;"
            ],
            [
                "E_ven they who /do no /wick_ed_ness,",
                "and /walk in his /ways."
            ],
            [
                "/Thou hast /charg-_ed",
                "that we shall di_li_gent_ly keep /thy com_/mand_ments."
            ],
            [
                "O that my ways were /made so /di_rect,",
                "that I might /keep thy /stat_utes!"
            ],
            [
                "So shall I not /be con_/foun_ded,",
                "while I have res_pect un_to all /thy com_/mand_ments."
            ],
            [
                "I will thank thee /with an /un_feigned heart,",
                "when I shall have learned the judg_ments /of thy /right_eous_ness."
            ],
            [
                "I will /keep thy /stat_utes;",
                "O for_/sake me not /utt_er_ly."
            ],
            [
                "WHERE_WITH_AL shall a young /man /cleanse his /way?",
                "e_ven by rul_ing him_self /af_ter /thy word."
            ],
            [
                "With my whole /heart have I /sought thee;",
                "O let me not go wrong out of /thy com_/mand_ments."
            ],
            [
                "Thy word have I /hid with_/in my heart,",
                "that I should not /sin a_/gainst thee."
            ],
            [
                "Bless_ed /art thou, O /LORD;",
                "O /teach me thy /stat_utes."
            ],
            [
                "With my lips have /I been /tell_ing",
                "of all the /judg_ments /of thy mouth."
            ],
            [
                "I have had as great de_light in the way of thy /tes_ti_/mon_ies,",
                "as in all /man_ner of /rich_es."
            ],
            [
                "I will talk of /thy com_/mand_ments,",
                "and have res_/pect un_to /thy /ways."
            ],
            [
                "My de_light shall /be in thy /stat_utes,",
                "and I will /not for_/get thy word."
            ],
            [
                "O DO well /un_to thy /ser_vant;",
                "that I may /live, and /keep thy word."
            ],
            [
                "/O_pen /thou mine /eyes;",
                "that I may see the won_drous /things of thy /law."
            ],
            [
                "I am a /stran_ger up_/on earth;",
                "O hide not thy com_/mand_ments from /me."
            ],
            [
                "My soul break_eth out for the ve_ry /fer_vent /de_sire",
                "that it hath al_way /un_to thy /judg_ments."
            ],
            [
                "Thou /hast re_/buked the proud;",
                "and cursed are they that do err from /thy com_/mand_ments."
            ],
            [
                "O turn from me /shame and re_/buke;",
                "for I have kept thy /tes_ti_/mon_ies."
            ],
            [
                "Prin_ces al_so did sit and /speak a_/gainst me;",
                "but thy ser_vant is oc_cu_pied /in thy /stat_utes."
            ],
            [
                "For thy tes_ti_mon_ies /are /my de_/light,",
                "/and my /coun_sel_lors."
            ],
            [
                "MY soul /cleav_eth /to the dust;",
                "O quick_en thou me, ac_/cor_ding /to thy /word."
            ],
            [
                "I have ack_now_ledged my ways, /and thou /heard_est me:",
                "O /teach me thy /stat_utes."
            ],
            [
                "Make me to un_der_stand the way of /thy com_/mand_ments;",
                "and so shall I /talk of thy /won_drous /works."
            ],
            [
                "My soul melt_eth a_way for /ve_ry /hea_vi_ness;",
                "com_fort thou me ac_cor_ding /un_to /thy /word."
            ],
            [
                "Take from me the /way of /ly_ing,",
                "and cause thou me to make /much of thy /law."
            ],
            [
                "I have /cho_sen the /way of /truth,",
                "and thy judg_ments have I /laid be_/fore me."
            ],
            [
                "I have stuck un_to thy /tes_ti_/mon_ies;",
                "O /LORD, con_/found me /not."
            ],
            [
                "I will run the way of /thy com_/mand_ments,",
                "when thou hast set my /heart at /li_ber_ty."
            ],
            [
                "TEACH me, O LORD, the /way of thy /stat_utes,",
                "and I shall keep it /un_to the /end."
            ],
            [
                "Give me un_der_stan_ding, and /I shall /keep thy /law;",
                "yea, I shall keep it /with my /whole heart."
            ],
            [
                "Make me to go in the path of /thy com_/mand_ments;",
                "for there_/in is /my de_/sire."
            ],
            [
                "In_cline my heart un_to thy /tes_ti_/mon_ies,",
                "and not to /co_ve_tous_/ness."
            ],
            [
                "O turn a_way mine eyes, lest they /be_hold /va_ni_ty;",
                "and quick_en thou /me /in thy /way."
            ],
            [
                "O stab_lish thy /word in thy /ser_vant,",
                "that /I may /fear thee."
            ],
            [
                "Take a_way the re_buke that I /am a_/fraid of;",
                "for thy /judg_ments are good."
            ],
            [
                "Be_hold, my de_light is in /thy com_/mand_ments;",
                "O quick_en /me in thy /right_eous_ness."
            ],
            [
                "LET thy lov_ing mer_cy come al_so /un_to /me, O /LORD,",
                "e_ven thy sal_va_tion, ac_cor_ding /un_to /thy /word."
            ],
            [
                "So shall I make an_swer un_to /my blas_/phem_ers;",
                "for my /trust is /in thy /word."
            ],
            [
                "O take not the word of thy truth utt_er_ly /out of my /mouth;",
                "for my hope is /in thy /judg_ments."
            ],
            [
                "So shall I /al_way /keep thy /law;",
                "yea, for /ev_er and /ev_er."
            ],
            [
                "And I will /walk at /li_ber_ty;",
                "for I /seek thy com_/mand_ments."
            ],
            [
                "I will speak of thy tes_ti_mon_ies al_so, /e_ven be_/fore kings,",
                "and will /not /be a_/shamed."
            ],
            [
                "And my de_light shall be in /thy com_/mand_ments,",
                "/which I /have loved."
            ],
            [
                "My hands al_so will I lift up un_to thy com_mand_ments, /which I /have loved;",
                "and my stu_dy shall /be in thy /stat_utes."
            ],
            [
                "O THINK up_on thy ser_vant, as con_/cer_ning thy /word,",
                "where_in thou hast /caused me to /put my /trust."
            ],
            [
                "The same is my com_fort /in my /trou_ble;",
                "for thy /word hath /quick_ened me."
            ],
            [
                "The proud have had me ex_ceed_ing_ly /in de_/ri_sion;",
                "yet have I not /shrinked from thy /law."
            ],
            [
                "For I re_mem_bered thine ev_er_last_ing /judg_ments, O /LORD,",
                "/and re_ceived /com_fort."
            ],
            [
                "I am /hor_ri_/bly a_/fraid,",
                "for the un_god_ly /that for_/sake thy /law."
            ],
            [
                "Thy stat_utes have /been my /songs,",
                "in the /house of my /pil_grim_age."
            ],
            [
                "I have thought up_on thy Name, O /LORD, in the night /sea_son,",
                "and /have kept thy /law."
            ],
            [
                "This I had, be_cause I /kept thy com_/mand_ments.",
                "Thou art my por_tion, O LORD; I have /prom_ised to /keep thy /law."
            ],
            [
                "I made my hum_ble pe_ti_tion /in thy /pres_ence",
                "with my /whole heart;"
            ],
            [
                "O be /mer_ci_ful /un_to me,",
                "ac_/cor_ding /to thy /word."
            ],
            [
                "I called mine own /ways to re_/mem_brance,",
                "and turned my feet un_to thy /tes_ti_/mon_ies."
            ],
            [
                "I made haste, and pro_/longed /not the /time,",
                "to /keep thy com_/mand_ments."
            ],
            [
                "The snares of the un_god_ly have /com_passed /me a_/bout;",
                "but I have not for_/got_ten thy /law."
            ],
            [
                "At mid_night I will rise to give /thanks un_to /thee,",
                "be_cause of thy /right_eous /judg_ments."
            ],
            [
                "I am a com_pan_ion of all /them that /fear thee,",
                "and /keep thy com_/mand_ments."
            ],
            [
                "The earth, O LORD, is /full of thy /mer_cy:",
                "O /teach me thy /stat_utes."
            ],
            [
                "O LORD, thou hast dealt gra_cious_ly /with thy /ser_vant,",
                "ac_cor_ding /un_to /thy /word."
            ],
            [
                "O teach me true un_der_/stan_ding and /know_ledge;",
                "for I have be_/lieved thy com_/mand_ments."
            ],
            [
                "Be_fore I was /trou_bled, /I went /wrong;",
                "but /now have I /kept thy /word."
            ],
            [
                "Thou art /good and /gra_cious;",
                "O /teach me thy /stat_utes."
            ],
            [
                "The proud have i_ma_gined a /lie a_/gainst me;",
                "but I will keep thy com_mand_ments /with my /whole /heart."
            ],
            [
                "Their /heart is as /fat as /brawn;",
                "but my de_light hath /been in thy /law."
            ],
            [
                "It is good for me that I have /been in /trou_ble;",
                "that I may /learn thy /stat_utes."
            ],
            [
                "The law of thy mouth is /dea_rer /un_to /me",
                "than thou_sands of /gold and /sil_ver."
            ],
            [
                "THY hands have /made me and /fash_ioned me:",
                "O give me un_der_stan_ding, that I may /learn thy com_/mand_ments."
            ],
            [
                "They that fear thee will be /glad when they /see me;",
                "be_cause I have put my /trust in thy /word."
            ],
            [
                "I know, O LORD, that thy /judg_ments are /right,",
                "and that thou of ve_ry faith_ful_ness hast caused /me to be /trou_bled."
            ],
            [
                "O let thy mer_ci_ful kind_ness /be my /com_fort,",
                "ac_cor_ding to thy word /un_to thy /ser_vant."
            ],
            [
                "O let thy lov_ing mer_cies come un_to /me, that /I may /live;",
                "for thy /law is /my de_/light."
            ],
            [
                "Let the proud be con_foun_ded, for they go wick_ed_ly a_/bout to des_/troy me;",
                "but I will be oc_cu_pied in /thy com_/mand_ments."
            ],
            [
                "Let such as fear thee, and have known thy /tes_ti_/mon_ies,",
                "be turned /un_to me."
            ],
            [
                "O let my heart be /sound in thy /stat_utes,",
                "that I /be /not a_/shamed."
            ],
            [
                "MY soul hath longed for /thy sal_/va_tion,",
                "and I have a good hope be_/cause of /thy /word."
            ],
            [
                "Mine eyes-_long /sore for thy /word;",
                "say_ing, O when /wilt thou /com_fort me?"
            ],
            [
                "For I am be_come like a /bot_tle /in the /smoke;",
                "yet do I not for_/get thy /stat_utes."
            ],
            [
                "How ma_ny are the /days of thy /ser_vant?",
                "when wilt thou be a_venged of them that /per_se_cute /me?"
            ],
            [
                "The /proud have digged /pits for me,",
                "which are not /af_ter /thy /law."
            ],
            [
                "All thy com_/mand_ments are /true:",
                "they per_se_cute me false_ly; O be /thou my help."
            ],
            [
                "They had al_most made an end of /me up_/on earth;",
                "but I for_sook /not thy com_/mand_ments."
            ],
            [
                "O quick_en me af_ter thy /lov_ing-_/kind_ness;",
                "and so shall I keep the tes_ti_mon_ies /of thy mouth."
            ],
            [
                "O LORD, thy /word",
                "en_dur_eth for /ev_er in /hea_ven."
            ],
            [
                "Thy truth al_so re_main_eth from one ge_ne_ra_tion /to a_/no_ther;",
                "thou hast laid the foun_da_tion of the earth, and /it a_/bi_deth."
            ],
            [
                "They con_tin_ue this day ac_cor_ding /to thine /ord_in_ance;",
                "for /all things /serve /thee."
            ],
            [
                "If my de_light had not /been in thy /law,",
                "I should have per_ished /in my /trou_ble."
            ],
            [
                "I will nev_er for_/get thy com_/mand_ments;",
                "for with them /thou hast /quick_ened me."
            ],
            [
                "I am /thine: O /save me,",
                "for I have /sought thy com_/mand_ments."
            ],
            [
                "The un_god_ly laid wait for /me, to des_/troy me;",
                "but I will con_si_der thy /tes_ti_/mon_ies."
            ],
            [
                "I see that all things /come to an /end;",
                "but thy com_mand_ment /is ex_/ceed_ing broad."
            ],
            [
                "LORD, what love have I /un_to thy /law!",
                "all the day long is my /stu_dy /in it."
            ],
            [
                "Thou, through thy com_mand_ments, hast made me wis_er /than mine /e_ne_mies;",
                "for they are /ev_er /with me."
            ],
            [
                "I have more un_der_stan_ding /than my /teach_ers;",
                "for thy tes_ti_mon_ies /are my /stu_dy."
            ],
            [
                "I am wis_er /than the /ag-_ed;",
                "be_cause I /keep thy com_/mand_ments."
            ],
            [
                "I have ref_rained my feet from /eve_ry /e_vil /way,",
                "that /I may /keep thy /word."
            ],
            [
                "I have not /shrunk from thy /judg_ments;",
                "/for thou /teach_est me."
            ],
            [
                "O how sweet are thy words /un_to my /throat;",
                "yea, swee_ter than hon_ey /un_to my /mouth!"
            ],
            [
                "Through thy com_mand_ments I get /un_der_/stan_ding:",
                "there_fore I /hate all /e_vil /ways."
            ],
            [
                "THY word is a lant_ern /un_to my /feet,",
                "and a light /un_to my /paths."
            ],
            [
                "I have sworn, and am /sted_fast_ly /pur_posed,",
                "to keep thy /right_eous /judg_ments."
            ],
            [
                "I am trou_bled /a_bove /meas_ure:",
                "quick_en me, O LORD, ac_/cor_ding /to thy /word."
            ],
            [
                "Let the free-_will of_fer_ings of my mouth /please thee, O /LORD;",
                "and /teach me thy /judg_ments."
            ],
            [
                "My soul is /al_way /in my hand;",
                "yet do I /not for_/get thy law."
            ],
            [
                "The un_god_ly have /laid a /snare for me;",
                "but yet I swerved not from /thy com_/mand_ments."
            ],
            [
                "Thy tes_ti_mon_ies have I claimed as mine he_ri_/tage for /ev_er;",
                "and why? they are the ve_ry /joy of my /heart."
            ],
            [
                "I have app_lied my heart to ful_fil thy /stat_utes /al_way,",
                "e_ven /un_to the /end."
            ],
            [
                "I HATE them that i_/ma_gine /e_vil things;",
                "but thy /law do I /love."
            ],
            [
                "Thou /art my de_/fence and shield;",
                "and my /trust is /in thy /word."
            ],
            [
                "A_way from /me, ye /wick_ed;",
                "I will keep the com_/mand_ments /of my God."
            ],
            [
                "O stab_lish me ac_cor_ding to thy /word, that /I may live;",
                "and let me not be dis_ap_/point_ed /of my hope."
            ],
            [
                "Hold thou me up, and /I shall /be safe;",
                "yea, my de_light shall be ev_er /in thy /stat_utes."
            ],
            [
                "Thou hast trod_den down all them that de_/part from thy /stat_utes;",
                "for they i_/ma_gine /but de_/ceit."
            ],
            [
                "Thou putt_est a_way all the un_god_ly /of the /earth like dross;",
                "there_fore I love thy /tes_ti_/mon_ies."
            ],
            [
                "My flesh /tremb_leth for /fear of /thee;",
                "and I am a_/fraid of thy /judg_ments."
            ],
            [
                "I DEAL with the thing that is /law_ful and /right;",
                "O give me not o_ver un_to /mine op_/press_ors."
            ],
            [
                "Make thou thy ser_vant to de_light in /that which is /good,",
                "that the proud /do me /no wrong."
            ],
            [
                "Mine eyes are wast_ed a_way with /look_ing /for thy health,",
                "and for the /word of thy /right_eous_ness."
            ],
            [
                "O deal with thy ser_vant ac_cor_ding un_to thy /lov_ing /mer_cy,",
                "and /teach me thy /stat_utes."
            ],
            [
                "I am thy ser_vant; O grant me /un_der_/stan_ding,",
                "that I may know thy /tes_ti_/mon_ies."
            ],
            [
                "It is time for thee, LORD, to /lay to /thine hand;",
                "for they /have des_/troyed thy /law."
            ],
            [
                "For I /love thy com_/mand_ments",
                "a_bove /gold and /prec_ious stones."
            ],
            [
                "There_fore hold I straight /all thy com_/mand_ments;",
                "and all false ways I /utt_er_/ly ab_/hor."
            ],
            [
                "THY tes_ti_mon_ies /are /won_der_ful;",
                "there_fore /doth my soul /keep them."
            ],
            [
                "When thy /word go_eth /forth,",
                "it gi_veth light and un_der_stan_ding /un_to the /sim_ple."
            ],
            [
                "I o_pened my mouth, and /drew in my /breath;",
                "for my de_light was in /thy com_/mand_ments."
            ],
            [
                "O look thou up_on me, and be /mer_ci_ful /un_to me,",
                "as thou us_est to do un_to /those that /love thy Name."
            ],
            [
                "Or_der my /steps in thy /word;",
                "and so shall no wick_ed_ness have do_/min_ion /o_ver me."
            ],
            [
                "O de_li_ver me from the wrong_ful /deal_ings of /men;",
                "and so shall I /keep thy com_/mand_ments."
            ],
            [
                "Show the light of thy coun_te_nance up_/on thy /ser_vant,",
                "and /teach me thy /stat_utes."
            ],
            [
                "Mine eyes gush /out with /wa_ter,",
                "be_cause /men keep /not thy law."
            ],
            [
                "/RIGHT_EOUS art /thou, O /LORD;",
                "and /true are thy /judg_ments."
            ],
            [
                "The tes_ti_mon_ies that /thou hast com_/man_ded",
                "are ex_ceed_ing /right_eous and /true."
            ],
            [
                "My zeal hath /e_ven con_/sumed me;",
                "be_cause mine e_ne_mies have for_/got_ten /thy /words."
            ],
            [
                "Thy word is /tried to the /ut_ter_most,",
                "and thy /ser_vant /lov_eth it."
            ],
            [
                "I am small and of no /re_pu_/ta_tion;",
                "yet do I not for_/get thy com_/mand_ments."
            ],
            [
                "Thy right_eous_ness is an ev_er_/last_ing /right_eous_ness,",
                "and thy /law is the /truth."
            ],
            [
                "Trou_ble and hea_vi_ness have tak_en /hold up_/on me;",
                "yet is my de_light in /thy com_/mand_ments."
            ],
            [
                "The right_eous_ness of thy tes_ti_mon_ies is /ev_er_/last_ing:",
                "O grant me un_der_/stan_ding, and /I shall live."
            ],
            [
                "I /CALL with my /whole /heart;",
                "hear me, O LORD; I will /keep thy /stat_utes."
            ],
            [
                "Yea, e_ven un_to /thee do I /call;",
                "help me, and I shall keep thy /tes_ti_/mon_ies."
            ],
            [
                "Ear_ly in the mor_ning do I /cry un_to /thee;",
                "for in thy /word is my /trust."
            ],
            [
                "Mine eyes pre_/vent the night /watch_es;",
                "that I might be /oc_cu_pied /in thy word."
            ],
            [
                "Hear my voice, O LORD, ac_cor_ding un_to thy /lov_ing_/kind_ness;",
                "quick_en me, ac_cor_ding /to thy /judg_ments."
            ],
            [
                "They draw nigh that of ma_lice /per_se_/cute /me,",
                "and are /far from thy /law."
            ],
            [
                "Be thou /nigh at /hand, O /LORD;",
                "for all thy com_/mand_ments are /true."
            ],
            [
                "As con_cer_ning thy tes_ti_mon_ies, /I have /known /long since,",
                "that thou hast groun_ded /them for /ev_er."
            ],
            [
                "O CON_SI_DER mine ad_ver_si_ty, /and de_/li_ver me,",
                "for I do /not for_/get thy law."
            ],
            [
                "A_venge thou my cause, /and de_/li_ver me;",
                "quick_en me ac_/cor_ding /to thy /word."
            ],
            [
                "Health is far from /the un_/god_ly;",
                "for they re_gard /not thy /stat_utes."
            ],
            [
                "Great is thy /mer_cy, O /LORD;",
                "quick_en /me, as /thou art wont."
            ],
            [
                "Ma_ny there are that trou_ble me, and /per_se_/cute me;",
                "yet do I not swerve from thy /tes_ti_/mon_ies."
            ],
            [
                "It griev_eth me when I /see the trans_/gres_sors;",
                "be_cause they /keep not /thy law."
            ],
            [
                "Con_si_der, O LORD, how I /love thy com_/mand_ments;",
                "O quick_en me, ac_cor_ding to thy /lov_ing-_/kind_ness."
            ],
            [
                "Thy word is true from /ev_er_/last_ing;",
                "all the judg_ments of thy right_eous_ness en_/dure for /ev_er_more."
            ],
            [
                "PRIN_CES have per_se_cu_ted /me with_/out a cause;",
                "but my heart stand_eth in /awe of thy /word."
            ],
            [
                "I am as /glad of thy /word,",
                "as one that /find_eth /great spoils."
            ],
            [
                "As for lies, I /hate and ab_/hor them;",
                "but thy /law do I /love."
            ],
            [
                "Se_ven times a /day do I /praise thee;",
                "be_cause of thy /right_eous /judg_ments."
            ],
            [
                "Great is the peace that they /have who /love thy law;",
                "and they have none oc_/ca_sion of /stum_bling."
            ],
            [
                "LORD, I have /looked for thy /sav_ing health,",
                "and done af_ter /thy com_/mand_ments."
            ],
            [
                "My soul hath kept thy /tes_ti_/mon_ies,",
                "and /loved them ex_/ceed_ing_ly."
            ],
            [
                "I have kept thy com_mand_ments and /tes_ti_/mon_ies;",
                "for all my /ways are be_/fore thee."
            ],
            [
                "LET my com_plaint come be_/fore thee, O /LORD;",
                "give me un_der_stan_ding ac_/cor_ding /to thy /word."
            ],
            [
                "Let my supp_li_ca_tion /come be_/fore thee;",
                "de_li_ver me ac_/cor_ding /to thy /word."
            ],
            [
                "My lips shall /speak of thy /praise,",
                "when thou hast /taught me thy /stat_utes."
            ],
            [
                "Yea, my tongue shall /sing of thy /word;",
                "for all thy com_/mand_ments are /right_eous."
            ],
            [
                "Let /thine hand /help me;",
                "for I have cho_sen /thy com_/mand_ments."
            ],
            [
                "I have longed for thy /sav_ing /health, O /LORD;",
                "and in thy /law is /my de_/light."
            ],
            [
                "O let my soul live, and /it shall /praise thee;",
                "and thy /judg_ments shall /help me."
            ],
            [
                "I have gone as_tray like a /sheep that is /lost;",
                "O seek thy ser_vant, for I do not for_/get thy com_/mand_ments."
            ]
        ]
    },
    {
        id: "psalm120",
        lines: [
            [
                "WHEN I was in trou_ble, I /called up_/on the /LORD,",
                "and he /heard me."
            ],
            [
                "De_li_ver my soul, O /LORD, from /ly_ing /lips,",
                "and /from a de_/ceit_ful /tongue."
            ],
            [
                "What re_ward shall be gi_ven or done un_to /thee, thou /false /tongue?",
                "e_ven migh_ty and sharp arr_ows, with /hot /burn_ing /coals."
            ],
            [
                "Woe is me, that I am con_strained to /dwell with /Mesh_ech,",
                "and to have my ha_bi_ta_tion a_mong the /tents of /Ke_dar!"
            ],
            [
                "My soul hath long /dwelt a_/mong them",
                "that are /e_ne_mies /un_to /peace."
            ],
            [
                "I la_bour for peace; but when I /speak un_to /them there_/of,",
                "they make them /rea_dy to /bat_tle."
            ]
        ]
    },
    {
        id: "psalm121",
        lines: [
            [
                "I WILL lift up mine /eyes un_to the /hills;",
                "from /whence com_eth /my /help?"
            ],
            [
                "My help com_eth /e_ven /from the /LORD,",
                "who hath made /hea_ven /and /earth."
            ],
            [
                "He will not suf_fer thy /foot /to be /moved;",
                "and he that /keep_eth thee /will not /sleep."
            ],
            [
                "Be_hold, he that /keep_eth /Is_ra_el",
                "shall nei_ther /slum_ber /nor /sleep."
            ],
            [
                "The LORD him_/self is thy /keep_er;",
                "the LORD is thy de_fence up_/on thy /right hand;"
            ],
            [
                "So that the sun shall not /burn thee by /day,",
                "/nei_ther the /moon by /night."
            ],
            [
                "The LORD shall pre_serve thee /from all /e_vil;",
                "yea, it is e_ven /he that shall /keep thy /soul."
            ],
            [
                "The LORD shall pre_serve thy go_ing /out, and thy /com_ing in,",
                "from this time /forth for /ev_er_more."
            ]
        ]
    },
    {
        id: "psalm122",
        lines: [
            [
                "I WAS glad when they /said un_to /me,",
                "We will go in_to the /house of the /LORD."
            ],
            [
                "Our feet shall /stand in thy /gates,",
                "O Je_/ru_sa_lem."
            ],
            [
                "Je_ru_sa_lem is /built as a /ci_ty",
                "that is at u_ni_ty /in it_/self."
            ],
            [
                "For thi_ther the tribes go up, e_ven the /tribes of the /LORD,",
                "to tes_ti_fy un_to Is_ra_el, to give thanks un_to the /Name of the /LORD."
            ],
            [
                "For there is the /seat of /judg_ment,",
                "e_ven the seat of the /house of /Da_vid."
            ],
            [
                "O pray for the peace of Je_/ru_sa_lem;",
                "they shall /pros_per that /love thee."
            ],
            [
                "Peace be with_/in thy /walls,",
                "and plen_teous_ness with_/in thy /pa_la_ces."
            ],
            [
                "For my breth_ren /and com_/pan_ions' sakes,",
                "I will /wish thee pros_/pe_ri_ty."
            ],
            [
                "Yea, be_cause of the house of the /LORD our God,",
                "I will /seek to /do thee /good."
            ]
        ]
    },
    {
        id: "psalm123",
        lines: [
            [
                "UN_TO /thee lift I /up mine /eyes,",
                "O thou that dwell_est /in the /hea_vens."
            ],
            [
                "Be_hold, e_ven as the eyes of ser_vants look un_to the hand of their mas_ters, and as the eyes of a mai_den un_to the /hand of her /mis_tress,",
                "e_ven so our eyes wait up_on the LORD our God, un_til he have /mer_cy up_/on us."
            ],
            [
                "Have mer_cy up_on us, O LORD, have /mer_cy up_/on us;",
                "for we are /utt_er_ly /des_pised."
            ],
            [
                "Our soul is filled with the scornf_ul re_/proof of the /weal_thy,",
                "and with the des_/pite_ful_ness /of the /proud."
            ]
        ]
    },
    {
        id: "psalm124",
        lines: [
            [
                "IF the LORD him_self had not been on our side, now may /Is_ra_el /say;",
                "if the LORD him_self had not been on our side, when men rose /up a_/gainst us;"
            ],
            [
                "They had /swal_lowed us /up a_/live;",
                "when they were so wrath_ful_/ly dis_/pleased at us."
            ],
            [
                "Yea, the /wa_ters had /drowned us,",
                "and the stream had gone /o_ver our /soul."
            ],
            [
                "The deep /wa_ters /of the /proud",
                "had gone e_ven /o_ver our /soul."
            ],
            [
                "But /praised be the /LORD,",
                "who hath not gi_ven us o_ver for a /prey un_to /their /teeth."
            ],
            [
                "Our soul is es_caped e_ven as a bird out of the /snare of the /fow_ler;",
                "the snare is bro_ken, and /we are de_/li_vered."
            ],
            [
                "Our help stand_eth in the /Name of the /LORD,",
                "who hath made /hea_ven /and /earth."
            ]
        ]
    },
    {
        id: "psalm125",
        lines: [
            [
                "THEY that put their trust in the LORD shall be e_ven /as the mount /Si_on,",
                "which may not be re_moved, but stand_eth /fast for /ev_er."
            ],
            [
                "The hills stand a_/bout Je_/ru_sa_lem;",
                "e_ven so stand_eth the LORD round a_bout his peo_ple, from this time /forth for /ev_er_more."
            ],
            [
                "For the scep_tre of the un_god_ly shall not a_bide up_on the /lot of the /right_eous;",
                "lest the right_eous put their hand /un_to /wick_ed_ness."
            ],
            [
                "Do well, O /LORD,",
                "un_to those that are /good and /true of heart."
            ],
            [
                "As for such as turn back un_to their own /wick_ed_ness,",
                "the LORD shall lead them forth with the e_vil do_ers; but peace shall /be up_on /Is_ra_el."
            ]
        ]
    },
    {
        id: "psalm126",
        lines: [
            [
                "WHEN the LORD turned a_gain the cap_ti_vi_/ty of /Si_on,",
                "then were we like /un_to /them that dream."
            ],
            [
                "Then was our mouth /filled with /laugh_ter,",
                "/and our /tongue with /joy."
            ],
            [
                "Then said they a_/mong the /heath_en,",
                "The LORD hath /done great /things for them."
            ],
            [
                "Yea, the LORD hath done great things for /us al_/rea_dy;",
                "where_of /we re_joice."
            ],
            [
                "Turn our cap_ti_vi_ty, O LORD, as the /ri_vers /in the /south.",
                "They that sow in /tears shall /reap in joy."
            ],
            [
                "He that now go_eth on his way weep_ing, and /bear_eth /forth good /seed,",
                "shall doubt_less come a_gain with joy, and /bring his /sheaves with him."
            ]
        ]
    },
    {
        id: "psalm127",
        lines: [
            [
                "EX_CEPT the /LORD build the /house,",
                "their la_bour is but /lost that /build it."
            ],
            [
                "Ex_cept the LORD /keep the /ci_ty,",
                "the watch_man /wak_eth /but in /vain."
            ],
            [
                "It is but lost la_bour that ye haste to rise up ear_ly, and so late take rest, and eat the /bread of /care_ful_ness;",
                "for so he gi_veth /his be_/lov_ed /sleep."
            ],
            [
                "Lo, child_ren, and the /fruit of the /womb,",
                "are an he_ri_tage and gift that /com_eth /of the /LORD."
            ],
            [
                "Like as the arr_ows in the /hand of the /gi_ant,",
                "e_ven so /are the young /child_ren."
            ],
            [
                "Hap_py is the man that hath his /qui_ver /full of them;",
                "they shall not be a_shamed when they speak with their /e_ne_mies /in the /gate."
            ]
        ]
    },
    {
        id: "psalm128",
        lines: [
            [
                "BLESS_ED are all /they that /fear the /LORD,",
                "and /walk in his /ways."
            ],
            [
                "For thou shalt eat the /la_bours /of thine hands:",
                "O well is thee, and /hap_py /shalt thou be."
            ],
            [
                "Thy wife shall be /as the /fruit_ful /vine",
                "up_on the /walls of thine /house;"
            ],
            [
                "Thy child_ren like the /ol_ive-_/branch_es",
                "round a_/bout thy /ta_ble."
            ],
            [
                "Lo, thus /shall the /man be /blessed",
                "that /fear_eth the /LORD."
            ],
            [
                "The LORD from out of Si_on /shall so /bless thee,",
                "that thou shalt see Je_ru_sa_lem in pros_pe_ri_ty /all thy /life long;"
            ],
            [
                "Yea, that thou shalt see thy /child_ren's /child_ren,",
                "and /peace up_on /Is_ra_el."
            ]
        ]
    },
    {
        id: "psalm129",
        lines: [
            [
                "MA_NY a time have they fought a_gainst me /from my /youth up,",
                "may /Is_ra_el /now say;"
            ],
            [
                "Yea, ma_ny a time have they vexed me /from my /youth up;",
                "but they have not pre_/vailed a_/gainst me."
            ],
            [
                "The plo_wers /plowed up_/on my back,",
                "and /made long /furr_ows."
            ],
            [
                "/But the /right_eous /LORD",
                "hath hewn the snares of the un_/god_ly in /pie_ces."
            ],
            [
                "Let them be con_foun_ded /and turned /back_ward,",
                "as ma_ny as have e_vil /will at /Si_on."
            ],
            [
                "Let them be e_ven as the grass up_/on the /house_tops,",
                "which with_er_eth a_/fore it be /grown up;"
            ],
            [
                "Where_of the mo_wer /fil_leth /not his hand,",
                "nei_ther he that bind_eth up the /sheaves his /bo_som."
            ],
            [
                "So that they who go by say not so much /as, The LORD /pros_per you;",
                "we wish you good luck in the /Name of the /LORD."
            ]
        ]
    },
    {
        id: "psalm130",
        lines: [
            [
                "OUT of the deep have I called /un_to /thee, O LORD;",
                "Lord, /hear my /voice."
            ],
            [
                "O let thine /ears con_/si_der /well",
                "the /voice of /my com_/plaint."
            ],
            [
                "If thou, LORD, wilt be ext_reme to mark /what is /done a_/miss,",
                "O Lord, /who may a_/bide it?"
            ],
            [
                "For there is /mer_cy /with /thee;",
                "there_fore /shalt thou be /feared."
            ],
            [
                "I look for the LORD; my /soul doth /wait for him;",
                "in his /word is my /trust."
            ],
            [
                "My soul fleeth un_to the Lord be_/fore the /mor_ning watch;",
                "I say, be_/fore the /mor_ning watch."
            ],
            [
                "O Is_ra_el, trust in the LORD; for with the /LORD there is /mer_cy,",
                "and with him is /plen_te_ous re_/demp_tion."
            ],
            [
                "And he /shall re_deem /Is_ra_el",
                "/from /all his /sins."
            ]
        ]
    },
    {
        id: "psalm131",
        lines: [
            [
                "LORD, I am /not high-_/min_ded;",
                "I /have no /proud looks."
            ],
            [
                "I do not ex_er_cise my_self /in great /mat_ters",
                "which /are too /high for me."
            ],
            [
                "But I re_frain my soul, and keep it low, like as a child that is /weaned from his /mo_ther:",
                "yea, my soul is e_ven /as a /weaned /child."
            ],
            [
                "O Is_ra_el, /trust in the /LORD",
                "from this time /forth for /ev_er_more."
            ]
        ]
    },
    {
        id: "psalm132",
        lines: [
            [
                "LORD, re_/mem_ber /Da_vid,",
                "and /all his /trou_ble:"
            ],
            [
                "How he sware /un_to the /LORD,",
                "and vowed a vow un_to the Al_/migh_ty /God of /Ja_cob:"
            ],
            [
                "I will not come with_in the tab_er_/na_cle /of mine /house,",
                "nor climb up /in_to /my /bed;"
            ],
            [
                "I will not suf_fer mine eyes to sleep, nor mine /eye_lids to /slum_ber;",
                "nei_ther the temp_les of my /head to take /an_y rest;"
            ],
            [
                "Un_til I find out a place for the /tem_ple /of the /LORD;",
                "an ha_bi_ta_tion for the Migh_ty /God of /Ja_cob."
            ],
            [
                "Lo, we heard of the /same at /Eph_ra_tah,",
                "and /found it /in the /wood."
            ],
            [
                "We will go in_to his /tab_er_/na_cle,",
                "and fall low on our knees be_/fore his /foot_stool."
            ],
            [
                "A_rise, O LORD, /in_to thy /res_ting-_place;",
                "thou, and the /ark /of thy /strength."
            ],
            [
                "Let thy priests be /clothed with /right_eous_ness;",
                "and let thy saints /sing with /joy_ful_ness."
            ],
            [
                "For thy /ser_vant /Da_vid's /sake,",
                "turn not a_way the face of /thine a_/noin_ted."
            ],
            [
                "The LORD hath made a faith_ful /oath un_to /Da_vid,",
                "and he /shall not /shrink from it:"
            ],
            [
                "Of the /fruit of thy /bo_dy",
                "shall I /set up_/on thy /throne."
            ],
            [
                "If thy child_ren will keep my co_ve_nant, and my tes_ti_mon_ies that /I shall /teach them;",
                "their child_ren al_so shall sit up_on thy /throne for /ev_er_more."
            ],
            [
                "For the LORD hath cho_sen Si_on to be an ha_bi_/ta_tion /for him_self;",
                "/he hath /longed for /her."
            ],
            [
                "This shall be my /rest for /ev_er:",
                "here will I dwell, for I /have a de_/light there_/in."
            ],
            [
                "I will bless her /vic_tu_als with /in_crease,",
                "and will sat_is_fy her /poor with /bread."
            ],
            [
                "I will /deck her /priests with /health,",
                "and her saints /shall re_/joice and /sing."
            ],
            [
                "There shall I make the horn of /Da_vid to /flou_rish:",
                "I have or_dained a lant_ern for /mine a_/noin_ted."
            ],
            [
                "As for his e_ne_mies, I shall /clothe them with /shame;",
                "but up_on him_self /shall his crown /flou_rish."
            ]
        ]
    },
    {
        id: "psalm133",
        lines: [
            [
                "BE_HOLD, how good and /joy_ful a /thing it /is,",
                "for breth_ren to dwell to_/ge_ther in /u_ni_ty!"
            ],
            [
                "It is like the prec_ious oil up_on the head, that ran down /un_to the /beard,",
                "e_ven un_to Aa_ron's beard, and went down to the /skirts of his /clo_thing."
            ],
            [
                "Like as the /dew of /Her_mon,",
                "which fell up_on the /hill of /Si_on."
            ],
            [
                "For there the LORD /prom_ised his /bless_ing,",
                "and /life for /ev_er_/more."
            ]
        ]
    },
    {
        id: "psalm134",
        lines: [
            [
                "BE_/HOLD now, /praise the /LORD,",
                "all ye /ser_vants /of the /LORD;"
            ],
            [
                "Ye that by night stand in the /house of the /LORD,",
                "e_ven in the courts of the /house of our /God."
            ],
            [
                "Lift up your hands in the sanc_tu_a_ry, and /praise the /LORD.",
                "The LORD that made hea_ven and earth give thee bless_ing /out of /Si_on."
            ]
        ]
    },
    {
        id: "psalm135",
        lines: [
            [
                "O PRAISE the LORD, laud ye the /Name of the /LORD;",
                "praise it, O ye /ser_vants /of the /LORD;"
            ],
            [
                "Ye that stand in the /house of the /LORD,",
                "in the courts of the /house of our /God."
            ],
            [
                "O praise the LORD, for the /LORD is /gra_cious;",
                "O sing prais_es un_to his Name, for /it is /love_ly."
            ],
            [
                "For why? the LORD hath cho_sen Ja_cob /un_to /him_self,",
                "and Is_ra_el for his /own pos_/sess_ion."
            ],
            [
                "For I /know that the /LORD is /great,",
                "and that our Lord /is a_/bove all /gods."
            ],
            [
                "What_so_ev_er the LORD pleased, that did he in /hea_ven, /and in /earth;",
                "and in the sea, and in /all deep /pla_ces."
            ],
            [
                "He bring_eth forth the clouds from the /ends of the /world,",
                "and send_eth forth light_nings with the rain, bring_ing the winds /out of his /treas_ur_ies."
            ],
            [
                "He smote the /first_born of /E_gypt,",
                "/both of /man and /beast."
            ],
            [
                "He hath sent tok_ens and won_ders in_to the midst of thee, O thou /land of /E_gypt;",
                "up_on Pha_raoh, and /all his /ser_vants."
            ],
            [
                "He smote /di_vers /na_tions,",
                "and slew /migh_ty /kings:"
            ],
            [
                "Si_hon, king of the Am_or_ites; and Og, the /king of /Ba_shan;",
                "and all the /king_doms of /Ca_naan;"
            ],
            [
                "And gave their land to /be an /he_ri_tage,",
                "e_ven an he_ri_tage un_to Is_ra_/el his /peo_ple."
            ],
            [
                "Thy Name, O LORD, en_/dur_eth for /ev_er;",
                "so doth thy me_mor_i_al, O LORD, from one ge_ne_ra_tion /to a_/no_ther."
            ],
            [
                "For the LORD will a_/venge his /peo_ple,",
                "and be gra_cious /un_to his /ser_vants."
            ],
            [
                "As for the im_a_ges of the heath_en, they are but /sil_ver and /gold;",
                "the /work of /men's /hands."
            ],
            [
                "They have /mouths, and /speak not;",
                "eyes have they, /but they /see not."
            ],
            [
                "They have ears, and /yet they /hear not;",
                "nei_ther is there an_y /breath in their /mouths."
            ],
            [
                "They that make them are /like un_to /them;",
                "and so are all they that /put their /trust in /them."
            ],
            [
                "Praise the LORD, ye /house of /Is_ra_el;",
                "praise the LORD, ye /house of /Aa_ron."
            ],
            [
                "Praise the LORD, ye /house of /Le_vi;",
                "ye that /fear the LORD, /praise the /LORD."
            ],
            [
                "Praised be the LORD /out of /Si_on,",
                "who dwell_eth /at Je_/ru_sa_lem."
            ]
        ]
    },
    {
        id: "psalm136",
        lines: [
            [
                "O GIVE thanks un_to the LORD, for /he is /gra_cious:",
                "and his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "O give thanks un_to the /God of /all gods:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "O thank the /Lord of all /lords:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who on_ly /do_eth great /won_ders:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who by his ex_cell_ent wis_dom /made the /hea_vens:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who laid out the earth a_/bove the /wa_ters:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who /hath made great /lights:",
                "for his mer_cy en_/dur_eth for /ev_er:"
            ],
            [
                "The /sun to /rule the /day:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "The moon and the stars to /gov_ern the /night:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who smote E_gypt, /with their /first_born:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "And brought out Is_ra_el /from a_/mong them:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "With a migh_ty /hand and /stretched-_out /arm:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who di_vi_ded the Red /Sea in /two /parts:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "And made Is_ra_el to go /through the /midst of /it:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "But as for Pha_raoh and his host, he o_ver_threw them /in the /Red Sea:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who led his peo_ple /through the /wil_der_ness:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who /smote great /kings:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "Yea, and /slew /migh_ty /kings:",
                "for his mer_cy en_/dur_eth for /ev_er:"
            ],
            [
                "Si_hon, /king of the /Am_or_ites:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "And Og, the /king of /Ba_shan:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "And gave a_way their /land for an /he_ri_tage:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "E_ven for an he_ri_tage un_to Is_ra_/el his /ser_vant:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who re_mem_bered us when we /were in /trou_ble:",
                "for his mer_cy en_/dur_eth for /ev_er;"
            ],
            [
                "And hath de_li_vered us /from our /e_ne_mies:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "Who gi_veth /food to /all /flesh:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "O give thanks un_to the /God of /hea_ven:",
                "for his mer_cy en_/dur_eth for /ev_er."
            ],
            [
                "O give thanks /un_to the /Lord of /lords:",
                "for his mer_cy en_/dur_eth for /ev_er"
            ]
        ]
    },
    {
        id: "psalm137",
        lines: [
            [
                "BY the wa_ters of Ba_by_lon we /sat down /and /wept,",
                "when we re_mem_bered /thee, O /Si_on."
            ],
            [
                "As for our /harps, we /hanged them /up",
                "up_on the /trees that /are there_/in."
            ],
            [
                "For they that led us a_way cap_tive, re_quired of us then a song, and me_lo_dy /in our /hea_vi_ness:",
                "Sing us one of the /songs of /Si_on."
            ],
            [
                "How shall we /sing the /LORD'S /song",
                "in a /strange land?"
            ],
            [
                "If I for_get thee, /O Je_/ru_sa_lem,",
                "let my right hand for_/get her /cunn_ing."
            ],
            [
                "If I do not re_mem_ber thee, let my tongue cleave to the /roof of my /mouth;",
                "yea, if I pre_fer not Je_ru_sa_lem a_/bove my /chief joy."
            ],
            [
                "Re_mem_ber the child_ren of E_dom, O LORD, in the /day of Je_/ru_sa_lem;",
                "how they said, Down with it, down with it, /e_ven /to the /ground."
            ],
            [
                "O daugh_ter of Ba_by_lon, /wast_ed with /mi_se_ry;",
                "yea, hap_py shall he be that re_ward_eth thee as /thou hast /served us."
            ],
            [
                "Bless_ed shall he be that /tak_eth thy /child_ren,",
                "and throw_eth /them a_/gainst the /stones."
            ]
        ]
    },
    {
        id: "psalm138",
        lines: [
            [
                "I will give thanks un_to thee, O Lord, with /my whole /heart;",
                "e_ven be_fore the gods will I sing /praise un_/to /thee."
            ],
            [
                "I will wor_ship to_ward thy ho_ly tem_ple, and praise thy Name, be_cause of thy lov_ing-_/kind_ness and /truth;",
                "for thou hast mag_ni_fied thy Name, and thy /word, a_/bove all /things."
            ],
            [
                "When I called up_/on thee, thou /heard_est me;",
                "and en_duedst my /soul /with much /strength."
            ],
            [
                "All the kings of the earth shall /praise /thee, O /LORD;",
                "for they have heard the /words of thy /mouth."
            ],
            [
                "Yea, they shall sing of the /ways of the /LORD,",
                "that great is the /glo_ry /of the /LORD."
            ],
            [
                "For though the LORD be high, yet hath he res_pect /un_to the /low_ly;",
                "as for the proud, he be_hold_eth /them af_/ar off."
            ],
            [
                "Though I walk in the midst of trou_ble, yet shalt /thou ref_/resh me;",
                "thou shalt stretch forth thy hand up_on the fu_ri_ous_ness of mine e_ne_mies, and thy right /hand shall /save me."
            ],
            [
                "The LORD shall make good his lov_ing-_/kind_ness to_/ward me;",
                "yea, thy mer_cy, O LORD, en_dur_eth for ev_er; des_pise not then the /works of /thine own /hands."
            ]
        ]
    },
    {
        id: "psalm139",
        lines: [
            [
                "O LORD, thou hast searched me /out, and /known me.",
                "Thou know_est my down-_sitt_ing, and mine up_ris_ing; thou un_der_stand_est my /thoughts /long be_/fore."
            ],
            [
                "Thou art a_bout my /path, and a_/bout my /bed;",
                "and art ac_/quain_ted with /all my /ways."
            ],
            [
                "For lo, there is not a /word in my /tongue,",
                "but thou, O LORD, know_est it /al_to_/ge_ther."
            ],
            [
                "Thou hast be_set me be_/hind and be_/fore,",
                "and laid thine /hand up_/on me."
            ],
            [
                "Such know_ledge is too won_der_ful and /ex_cell_ent /for /me;",
                "I can_/not at_tain /un_to it."
            ],
            [
                "Whi_ther shall I go then /from thy /Spi_rit?",
                "or whi_ther shall I go then /from thy /pres_ence?"
            ],
            [
                "If I climb up in_to /hea_ven, /thou art /there;",
                "if I go down to hell, /thou art there /al_so."
            ],
            [
                "If I take the /wings of the /mor_ning,",
                "and re_main in the ut_ter_most /parts of /the /sea;"
            ],
            [
                "E_ven there al_so /shall thy hand /lead me,",
                "and thy right /hand shall /hold me."
            ],
            [
                "If I say, Per_ad_ven_ture the /dark_ness shall /co_ver me;",
                "then shall my /night be /turned to /day."
            ],
            [
                "Yea, the dark_ness is no dark_ness with thee, but the night is as /clear as the /day;",
                "the dark_ness and light to /thee are /both a_/like."
            ],
            [
                "For /my /reins are /thine;",
                "thou hast co_vered me /in my /mo_ther's /womb."
            ],
            [
                "I will give thanks un_to thee, for I am fear_ful_ly and /won_der_/fully made:",
                "mar_vell_ous are thy works, and that my soul /know_eth /right well."
            ],
            [
                "My /bones are not /hid from thee,",
                "though I be made se_cret_ly, and fash_ioned be_/neath in the /earth."
            ],
            [
                "Thine eyes did see my sub_stance, yet /be_ing im_/per_fect;",
                "and in thy book were all my /mem_bers /writ_ten;"
            ],
            [
                "Which day by /day were /fash_ioned,",
                "when as yet /there was /none of /them."
            ],
            [
                "How dear are thy coun_sels /un_to /me, O God;",
                "O how great /is the /sum of /them!"
            ],
            [
                "If I tell them, they are more in /num_ber /than the /sand:",
                "when I wake up, I am /pre_sent /with thee."
            ],
            [
                "Wilt thou not slay the /wick_ed, O /God?",
                "De_part from me, ye /blood-_/thirs_ty /men."
            ],
            [
                "For they speak un_right_eous_/ly a_/gainst thee;",
                "and thine e_ne_mies /take thy /Name in /vain."
            ],
            [
                "Do not I hate them, O /LORD, that /hate thee?",
                "and am not I grieved with those that rise /up a_/gainst thee?"
            ],
            [
                "Yea, I /hate them /right sore;",
                "e_ven as though they /were mine /e_ne_mies."
            ],
            [
                "Try me, O God, and seek the /ground of my /heart;",
                "prove me, and ex_/am_ine /my /thoughts."
            ],
            [
                "Look well if there be an_y way of /wick_ed_ness in /me;",
                "and lead me in the way /ev_er_/last_ing."
            ]
        ]
    },
    {
        id: "psalm140",
        lines: [
            [
                "DE_LI_VER me, O LORD, /from the /e_vil /man;",
                "and pre_serve me /from the /wick_ed man;"
            ],
            [
                "Who i_ma_gine /mis_chief /in their /hearts,",
                "and stir up strife /all the /day /long."
            ],
            [
                "They have sharp_ened their /tongues like a /ser_pent;",
                "ad_der's poi_son is /un_der their /lips."
            ],
            [
                "Keep me, O LORD, from the hands of /the un_/god_ly;",
                "pre_serve me from the wick_ed men, who are pur_posed to o_ver_/throw my /go_ings."
            ],
            [
                "The proud have laid a snare for me, and spread a /net a_/broad with /cords;",
                "yea, and set /traps in my /way."
            ],
            [
                "I said un_to the LORD, /Thou art my /God,",
                "hear the /voice of my /prayers, O /LORD."
            ],
            [
                "O LORD God, thou /strength of my /health;",
                "thou hast co_vered my head in the /day of /bat_tle."
            ],
            [
                "Let not the un_god_ly /have his de_/sire, O /LORD;",
                "let not his mis_chie_vous i_ma_gi_na_tion pros_per, /lest they /be too /proud."
            ],
            [
                "Let the mis_chief of their own lips fall up_/on the /head of them",
                "that /com_pass /me a_/bout."
            ],
            [
                "Let hot burn_ing coals /fall up_/on them;",
                "let them be cast in_to the fire, and in_to the pit, that they nev_er /rise /up a_/gain."
            ],
            [
                "A man full of words shall not /pros_per up_/on the /earth:",
                "e_vil shall hunt the wick_ed per_son to /o_ver_/throw him."
            ],
            [
                "Sure I am that the LORD /will a_/venge the /poor,",
                "and main_tain the /cause of the /help_less."
            ],
            [
                "The right_eous al_so shall give /thanks un_to thy /Name;",
                "and the just shall con_/tin_ue /in thy /sight."
            ]
        ]
    },
    {
        id: "psalm141",
        lines: [
            [
                "LORD, I call up_on thee; /haste thee /un_to /me,",
                "and con_si_der my voice, when I /cry /un_to /thee."
            ],
            [
                "Let my prayer be set forth in thy /sight as the /in_cense;",
                "and let the lift_ing up of my hands be an /eve_ning /sac_ri_fice."
            ],
            [
                "Set a watch, O /LORD, be_/fore my /mouth,",
                "and keep the /door of my /lips."
            ],
            [
                "O let not mine heart be in_clined to an_y /e_vil thing;",
                "let me not be oc_cu_pied in un_god_ly works with the men that work wick_ed_ness, nei_ther let me eat of such /things as /please them."
            ],
            [
                "Let the right_eous ra_ther smite me friend_ly, /and re_/prove me;",
                "yea, let not my head re_/fuse their /prec_ious /balms."
            ],
            [
                "As /for the un_/god_ly,",
                "I will pray yet a_/gainst their /wick_ed_ness."
            ],
            [
                "Let their judg_es be ov_er_thrown in /sto_ny /pla_ces,",
                "that they may hear my /words; for /they are /sweet."
            ],
            [
                "Our bones lie /scat_tered be_/fore the /pit,",
                "like as when one break_eth and hew_eth /wood up_/on the earth."
            ],
            [
                "But mine eyes look un_to /thee, O /LORD /God;",
                "in thee is my trust; O /cast not /out my /soul."
            ],
            [
                "Keep me from the snare that /they have /laid for me,",
                "and from the traps of the /wick_ed /do_ers."
            ],
            [
                "Let the un_god_ly fall in_to their own /nets to_/ge_ther,",
                "and let me /ev_er es_/cape them."
            ]
        ]
    },
    {
        id: "psalm142",
        lines: [
            [
                "I CRIED un_to the /LORD with my /voice;",
                "yea, e_ven un_to the LORD did I make my /supp_li_/ca_tion."
            ],
            [
                "I poured out my comp_/laints be_/fore him,",
                "and showed /him of my /trou_ble."
            ],
            [
                "When my spi_rit was in hea_vi_ness, thou /knew_est my /path;",
                "in the way where_in I walked, have they pri_vi_ly /laid a /snare for me."
            ],
            [
                "I looked al_so up_/on my /right hand,",
                "and saw there was no /man that would /know me."
            ],
            [
                "I had no /place to /flee un_to,",
                "and no man /cared /for my /soul."
            ],
            [
                "I cried un_to /thee, O /LORD, and /said,",
                "Thou art my hope, and my por_tion in the /land of the /li_ving."
            ],
            [
                "Con_/si_der my /com_/plaint;",
                "for I am /brought /ve_ry /low."
            ],
            [
                "O de_li_ver me from my /per_se_/cu_tors;",
                "for they /are too /strong for me."
            ],
            [
                "Bring my soul out of pri_son, that I may give /thanks un_to thy /Name;",
                "which thing if thou wilt grant me, then shall the right_eous res_ort /un_to my /com_pa_ny."
            ]
        ]
    },
    {
        id: "psalm143",
        lines: [
            [
                "HEAR my prayer, O LORD, and con_/si_der /my de_/sire;",
                "hear_ken un_to me for thy truth and /right_eous_ness' /sake."
            ],
            [
                "And en_ter not in_to judg_ment /with thy /ser_vant;",
                "for in thy sight shall no man /li_ving be /jus_ti_fied."
            ],
            [
                "For the e_ne_my hath per_se_cu_ted my soul; he hath smit_ten my life /down to the /ground;",
                "he hath laid me in the dark_ness, as the /men that have /been long /dead."
            ],
            [
                "There_fore is my spi_rit /vexed with_/in me,",
                "and my heart with_/in me is /de_so_late."
            ],
            [
                "Yet do I re_mem_ber the time past; I muse up_/on all thy /works;",
                "yea, I ex_er_cise my_self in the /works of thy /hands."
            ],
            [
                "I stretch forth my /hands /un_to /thee;",
                "my soul gasp_eth un_to /thee as a /thirs_ty /land."
            ],
            [
                "Hear me, O LORD, and that soon; for my /spi_rit /wax_eth /faint:",
                "hide not thy face from me, lest I be like un_to them that go down /in_/to the /pit."
            ],
            [
                "O let me hear thy lov_ing-_kind_ness be_times in the mor_ning; for in /thee is my /trust:",
                "show thou me the way that I should walk in; for I lift up my /soul /un_to /thee."
            ],
            [
                "De_li_ver me, O /LORD, from mine /e_ne_mies;",
                "for I flee un_to /thee to /hide me."
            ],
            [
                "Teach me to do the thing that pleas_eth thee; for /thou art my /God:",
                "let thy lov_ing Spi_rit lead me forth in_to the /land of /right_eous_ness."
            ],
            [
                "Quick_en me, O /LORD, for thy /Name's /sake;",
                "and for thy right_eous_ness' sake bring my /soul out of /trou_ble."
            ],
            [
                "And of thy good_ness /slay mine /e_ne_mies,",
                "and des_troy all them that vex my soul; for /I am thy /ser_vant."
            ]
        ]
    },
    {
        id: "psalm144",
        lines: [
            [
                "BLESS_ED /be the /LORD my /strength,",
                "who teach_eth my hands to war, and my /fing_ers to /fight:"
            ],
            [
                "My hope and my fort_ress, my ca_stle and de_li_ver_er, my de_/fen_der in /whom I /trust;",
                "who sub_du_eth my peo_ple /that is /un_der me."
            ],
            [
                "LORD, what is man, that thou hast such res_/pect un_to /him?",
                "or the son of man, that thou /so re_/gard_est /him?"
            ],
            [
                "Man is /like a /thing of /nought;",
                "his time pass_eth a_way /like a /sha_dow."
            ],
            [
                "Bow thy hea_vens, O /LORD, and /come /down;",
                "touch the /moun_tains, and /they shall /smoke."
            ],
            [
                "Cast forth thy /light_ning, and /tear them;",
                "shoot out thine arr_ows, /and con_/sume them."
            ],
            [
                "Send down thine /hand from a_/bove;",
                "de_li_ver me, and take me out of the great wa_ters, from the /hand of /stran_gers;"
            ],
            [
                "Whose mouth /talk_eth of /va_ni_ty,",
                "and their right hand is a right /hand of /wick_ed_ness."
            ],
            [
                "I will sing a new song /un_to /thee, O /God;",
                "and sing prais_es un_to thee up_/on a /ten-_stringed /lute."
            ],
            [
                "Thou hast gi_ven /vic_to_ry /un_to /kings,",
                "and hast de_li_vered Da_vid thy ser_vant from the /pe_ril /of the /sword."
            ],
            [
                "Save me, and de_li_ver me from the /hand of /stran_gers,",
                "whose mouth talk_eth of va_ni_ty, and their right hand is a right /hand of in_/i_qui_ty:"
            ],
            [
                "That our sons may grow /up as the /young /plants,",
                "and that our daugh_ters may be as the pol_ished cor_ners /of the /tem_ple;"
            ],
            [
                "That our gar_ners may be full and plen_te_ous with all /man_ner of /store;",
                "that our sheep may bring forth thou_sands, and ten /thou_sands /in our /fields;"
            ],
            [
                "That our ox_en may be strong to la_bour; that there /be no de_/cay,",
                "no lead_ing in_to cap_ti_vi_ty, and no com_/plain_ing /in our /streets."
            ],
            [
                "Hap_py are the peo_ple that are /in /such a /case;",
                "yea, bless_ed are the peo_ple who have the /LORD for their /God."
            ]
        ]
    },
    {
        id: "psalm145",
        lines: [
            [
                "I WILL mag_ni_fy /thee, O /God, my /King;",
                "and I will praise thy Name for /ev_er and /ev_er."
            ],
            [
                "Eve_ry day will I give /thanks /un_to /thee;",
                "and praise thy Name for /ev_er and /ev_er."
            ],
            [
                "Great is the LORD, and mar_vell_ous /wor_thy /to be /praised;",
                "there is no /end of his /great_ness."
            ],
            [
                "One ge_ne_ra_tion shall praise thy works /un_to a_/no_ther,",
                "and de_/clare thy /pow_er."
            ],
            [
                "As for me, I will be talk_ing /of thy /wor_ship,",
                "thy glo_ry, thy /praise, and /won_drous /works;"
            ],
            [
                "So that men shall speak of the might of thy /mar_vell_ous /acts;",
                "and I will al_so /tell of thy /great_ness."
            ],
            [
                "The me_mor_i_al of thine ab_un_dant /kind_ness /shall be /showed;",
                "and men shall /sing of thy /right_eous_ness."
            ],
            [
                "The LORD is /gra_cious and /mer_ci_ful;",
                "long-_suf_fer_ing, /and of great /good_ness."
            ],
            [
                "The LORD is lov_ing /un_to /eve_ry man;",
                "and his mer_cy is /o_ver /all his /works."
            ],
            [
                "All thy works /praise thee, O /LORD;",
                "and thy saints give /thanks un_to /thee."
            ],
            [
                "They show the glo_ry /of thy /king_dom,",
                "and /talk of thy /pow_er;"
            ],
            [
                "That thy pow_er, thy glo_ry, and migh_ti_ness /of thy /king_dom,",
                "might be /known /un_to /men."
            ],
            [
                "Thy king_dom is an ev_er_/last_ing /king_dom,",
                "and thy do_min_ion en_dur_eth through_/out all /a_ges."
            ],
            [
                "The LORD up_hold_eth /all such as /fall,",
                "and lift_eth up all /those that /are /down."
            ],
            [
                "The eyes of all wait up_/on thee, O /Lord;",
                "and thou giv_est them their /meat in due /sea_son."
            ],
            [
                "Thou /o_pen_est /thine /hand,",
                "and fill_est all things /li_ving with /plen_teous_ness."
            ],
            [
                "The LORD is /right_eous in /all his /ways,",
                "and /ho_ly in /all his /works."
            ],
            [
                "The LORD is nigh un_to all them that /call up_/on him;",
                "yea, all such as call up_/on him /faith_ful_ly."
            ],
            [
                "He will ful_fil the de_sire of /them that /fear him;",
                "he al_so will hear their /cry, and will /help them."
            ],
            [
                "The LORD pre_ser_veth all /them that /love him;",
                "but scat_ter_eth a_broad /all the un_/god_ly."
            ],
            [
                "My mouth shall speak the /praise of the /LORD;",
                "and let all flesh give thanks un_to his ho_ly Name for /ev_er and /ev_er."
            ]
        ]
    },
    {
        id: "psalm146",
        lines: [
            [
                "PRAISE the LORD, O my soul: while I live, /will I /praise the /LORD;",
                "yea, as long as I have an_y be_ing, I will sing prais_es /un_to my /God."
            ],
            [
                "O put not your trust in prin_ces, nor in /an_y /child of /man;",
                "for there is no /help in them."
            ],
            [
                "For when the breath of man go_eth forth, he shall turn a_/gain to his /earth,",
                "and then /all his thoughts /per_ish."
            ],
            [
                "Bless_ed is he that hath the God of /Ja_cob /for his /help,",
                "and whose hope is /in the /LORD his /God:"
            ],
            [
                "Who made hea_ven and earth, the sea, and /all that /there_in is;",
                "who keep_eth his /prom_ise for /ev_er;"
            ],
            [
                "Who help_eth them to /right that /suf_fer /wrong;",
                "who /feed_eth the /hun_gry."
            ],
            [
                "The LORD loos_eth /men out of /pri_son;",
                "the LORD gi_veth /sight to the /blind."
            ],
            [
                "The LORD help_eth /them that are /fall_en;",
                "the LORD ca_reth for the /right_eous."
            ],
            [
                "The LORD ca_reth for the stran_gers; he de_fend_eth the /fa_ther_less and /wid_ow:",
                "as for the way of the un_god_ly, he /tur_neth it /up_side /down."
            ],
            [
                "The LORD thy God, O Si_on, shall be /King for /ev_er_/more,",
                "and through_out all /gen_er_/a_tions."
            ]
        ]
    },
    {
        id: "psalm147",
        lines: [
            [
                "PRAISE the LORD, for it is a good thing to sing prais_es /un_to /our /God;",
                "yea, a joy_ful and plea_sant thing it /is to be /thank_ful."
            ],
            [
                "The LORD doth build /up Je_/ru_sa_lem,",
                "and gath_er to_ge_ther the /out_casts of /Is_ra_el."
            ],
            [
                "He heal_eth those that are /bro_ken in /heart,",
                "and gi_veth me_di_cine to /heal their /sick_ness."
            ],
            [
                "He tell_eth the /num_ber /of the /stars,",
                "and call_eth them /all by their /names."
            ],
            [
                "Great is our Lord, and /great is his /pow_er;",
                "yea, and his /wis_dom is /in_fin_ite."
            ],
            [
                "The LORD /set_teth /up the /meek,",
                "and bring_eth the un_god_ly /down to the /ground."
            ],
            [
                "O sing un_to the /LORD with thanks_/giv_ing;",
                "sing prais_es up_on the harp /un_to our /God:"
            ],
            [
                "Who co_ver_eth the hea_ven with clouds, and pre_par_eth /rain for the /earth;",
                "and mak_eth the grass to grow up_on the moun_tains, and /herb for the /use of /men;"
            ],
            [
                "Who gi_veth fod_der /un_to the /cat_tle,",
                "and feed_eth the young ra_vens that /call up_/on /him."
            ],
            [
                "He hath no plea_sure in the /strength of an /horse;",
                "nei_ther de_light_eth he in /an_y /man's legs."
            ],
            [
                "But the LORD'S de_light is in /them that /fear him,",
                "and put their /trust in his /mer_cy."
            ],
            [
                "Praise the LORD, /O Je_/ru_sa_lem;",
                "praise thy /God, O /Si_on."
            ],
            [
                "For he hath made fast the /bars of thy /gates,",
                "and hath bless_ed thy /child_ren with_/in thee."
            ],
            [
                "He mak_eth /peace in thy /bor_ders,",
                "and fil_leth /thee with the /flour of /wheat."
            ],
            [
                "He send_eth forth his com_/mand_ment up_/on /earth,",
                "and his word runn_eth /ve_ry /swift_ly."
            ],
            [
                "He /gi_veth /snow like /wool,",
                "and scat_ter_eth the /hoar_frost like /ash_es."
            ],
            [
                "He cast_eth forth his /ice like /mor_sels:",
                "who is a_ble /to a_/bide his /frost?"
            ],
            [
                "He send_eth out his /word, and /melt_eth them:",
                "he blow_eth with his /wind, and the /wa_ters flow."
            ],
            [
                "He show_eth his /word un_to /Ja_cob,",
                "his stat_utes and or_di_nan_ces /un_to /Is_ra_el."
            ],
            [
                "He hath not dealt so with /an_y /na_tion;",
                "nei_ther have the heath_en /know_ledge /of his /laws."
            ]
        ]
    },
    {
        id: "psalm148",
        lines: [
            [
                "O PRAISE the /LORD from the /hea_vens:",
                "/praise him /in the /heights."
            ],
            [
                "Praise him, all ye /an_gels of /his:",
                "/praise him, /all his /host."
            ],
            [
                "/Praise him, /sun and /moon:",
                "praise him, /all ye /stars and /light."
            ],
            [
                "Praise him, /all ye /hea_vens,",
                "and ye wa_ters that are a_/bove the /hea_vens."
            ],
            [
                "Let them praise the /Name /of the /LORD:",
                "for he spake the word, and they were made; he com_man_ded, and /they were cre_/at_ed."
            ],
            [
                "He hath made them fast for /ev_er and /ev_er:",
                "he hath gi_ven them a law which shall /not be /bro_ken."
            ],
            [
                "Praise the /LORD from the /earth,",
                "ye /dra_gons and /all /deeps;"
            ],
            [
                "Fire and hail, /snow and /va_pours,",
                "wind and storm, ful_/fil_ling his /word;"
            ],
            [
                "/Moun_tains /and all /hills;",
                "fruit_ful /trees and /all /ce_dars;"
            ],
            [
                "/Beasts and all /cat_tle;",
                "creep_ing /things and /fly_ing /fowls;"
            ],
            [
                "Kings of the /earth, and all /peo_ples;",
                "prin_ces, and all /judg_es /of the /world;"
            ],
            [
                "Young men and maid_ens, old men and child_ren, praise the /Name /of the /LORD:",
                "for his Name on_ly is ex_cell_ent, and his praise a_bove /hea_ven and /earth."
            ],
            [
                "He shall ex_alt the horn of his peo_ple: all his /saints shall /praise him;",
                "e_ven the child_ren of Is_ra_el, e_ven the /peo_ple that /serv_eth /him."
            ]
        ]
    },
    {
        id: "psalm149",
        lines: [
            [
                "O SING un_to the /LORD a new /song;",
                "let the con_gre_ga_tion /of saints /praise /him."
            ],
            [
                "Let Is_ra_el re_joice in /him that /made him,",
                "and let the child_ren of Si_on be /joy_ful /in their /King."
            ],
            [
                "Let them praise his /Name in the /dance:",
                "let them sing prais_es un_to him with /tab_/ret and /harp."
            ],
            [
                "For the LORD hath plea_sure /in his /peo_ple,",
                "and /help_eth the /meek-_/heart_ed."
            ],
            [
                "Let the saints be /joy_ful with /glo_ry;",
                "let them re_/joice /in their /beds."
            ],
            [
                "Let the prais_es of God /be in their /mouth;",
                "and a two-_edged /sword /in their /hands;"
            ],
            [
                "To be a_/venged of the /na_tions,",
                "and to re_/buke the /peo_ples;"
            ],
            [
                "To /bind their /kings in /chains,",
                "and their no_bles with /links of /i_ron;"
            ],
            [
                "To ex_e_cute judg_ment up_on them; as /it is /writ_ten,",
                "Such ho_nour /have /all his /saints."
            ]
        ]
    },
    {
        id: "psalm150",
        lines: [
            [
                "O PRAISE God in his /sanc_tu_/a_ry:",
                "praise him in the fir_ma_ment /of his /pow_er."
            ],
            [
                "Praise him /in his /no_ble /acts:",
                "praise him ac_cor_ding to his /ex_cell_ent /great_ness."
            ],
            [
                "Praise him in the sound /of the /trum_pet:",
                "praise him up_/on the /lute and /harp."
            ],
            [
                "Praise him in the /tim_brels and /dan_ces:",
                "praise him up_/on the /strings and /pipe."
            ],
            [
                "Praise him up_on the /well-_tuned /cym_bals:",
                "praise him up_/on the loud /cym_bals."
            ],
            [
                "Let eve_ry /thing that /hath breath",
                "/praise the /LORD."
            ]
        ]
    }
];


const $a6cfd8f7f51b9dd9$export$a35df4ef14d66b3 = [
    [
        "Glo_ry be to the /Fa_ther, and /to the /Son",
        "and /to the /Ho_ly Ghost."
    ],
    [
        "As it was in the be_ginn_ing, is now, and /e_ver /shall be,",
        "/world with_out /end. A_men."
    ]
];


const $b5ba7a3b4030cdca$export$ba83f0dc94d99a1d = [
    [
        "blessed",
        "bless-ed"
    ],
    [
        "is",
        "is"
    ],
    [
        "the",
        "the"
    ],
    [
        "man",
        "man"
    ],
    [
        "that",
        "that"
    ],
    [
        "hath",
        "hath"
    ],
    [
        "not",
        "not"
    ],
    [
        "walked",
        "walk-ed"
    ],
    [
        "in",
        "in"
    ],
    [
        "counsel",
        "coun-sel"
    ],
    [
        "of",
        "of"
    ],
    [
        "ungodly",
        "un-god-ly"
    ],
    [
        "nor",
        "nor"
    ],
    [
        "stood",
        "stood"
    ],
    [
        "way",
        "way"
    ],
    [
        "sinners",
        "sin-ners"
    ],
    [
        "and",
        "and"
    ],
    [
        "sat",
        "sat"
    ],
    [
        "seat",
        "seat"
    ],
    [
        "scornful",
        "scornf-ul"
    ],
    [
        "but",
        "but"
    ],
    [
        "his",
        "his"
    ],
    [
        "delight",
        "de-light"
    ],
    [
        "law",
        "law"
    ],
    [
        "lord",
        "lord"
    ],
    [
        "will",
        "will"
    ],
    [
        "he",
        "he"
    ],
    [
        "exercise",
        "ex-er-cise"
    ],
    [
        "himself",
        "him-self"
    ],
    [
        "day",
        "day"
    ],
    [
        "night",
        "night"
    ],
    [
        "shall",
        "shall"
    ],
    [
        "be",
        "be"
    ],
    [
        "like",
        "like"
    ],
    [
        "a",
        "a"
    ],
    [
        "tree",
        "tree"
    ],
    [
        "planted",
        "plan-ted"
    ],
    [
        "by",
        "by"
    ],
    [
        "water-side",
        "wa-ter_side"
    ],
    [
        "bring",
        "bring"
    ],
    [
        "forth",
        "forth"
    ],
    [
        "fruit",
        "fruit"
    ],
    [
        "due",
        "due"
    ],
    [
        "season",
        "sea-son"
    ],
    [
        "leaf",
        "leaf"
    ],
    [
        "also",
        "al-so"
    ],
    [
        "wither",
        "wi-ther"
    ],
    [
        "look",
        "look"
    ],
    [
        "whatsoever",
        "what-so-ev-er"
    ],
    [
        "doeth",
        "do-eth"
    ],
    [
        "it",
        "it"
    ],
    [
        "prosper",
        "pros-per"
    ],
    [
        "as",
        "as"
    ],
    [
        "for",
        "for"
    ],
    [
        "so",
        "so"
    ],
    [
        "with",
        "with"
    ],
    [
        "them",
        "them"
    ],
    [
        "they",
        "they"
    ],
    [
        "are",
        "are"
    ],
    [
        "chaff",
        "chaff"
    ],
    [
        "which",
        "which"
    ],
    [
        "wind",
        "wind"
    ],
    [
        "scattereth",
        "scat-ter-eth"
    ],
    [
        "away",
        "a-way"
    ],
    [
        "from",
        "from"
    ],
    [
        "face",
        "face"
    ],
    [
        "earth",
        "earth"
    ],
    [
        "therefore",
        "there-fore"
    ],
    [
        "able",
        "able"
    ],
    [
        "to",
        "to"
    ],
    [
        "stand",
        "stand"
    ],
    [
        "judgment",
        "judg-ment"
    ],
    [
        "neither",
        "nei-ther"
    ],
    [
        "congregation",
        "con-gre-ga-tion"
    ],
    [
        "righteous",
        "right-eous"
    ],
    [
        "knoweth",
        "know-eth"
    ],
    [
        "perish",
        "per-ish"
    ],
    [
        "why",
        "why"
    ],
    [
        "do",
        "do"
    ],
    [
        "heathen",
        "heath-en"
    ],
    [
        "furiously",
        "fu-ri-ous-ly"
    ],
    [
        "rage",
        "rage"
    ],
    [
        "together",
        "to-ge-ther"
    ],
    [
        "people",
        "peo-ple"
    ],
    [
        "imagine",
        "im-a-gine"
    ],
    [
        "vain",
        "vain"
    ],
    [
        "thing",
        "thing"
    ],
    [
        "kings",
        "kings"
    ],
    [
        "up",
        "up"
    ],
    [
        "rulers",
        "rul-ers"
    ],
    [
        "take",
        "take"
    ],
    [
        "against",
        "a-gainst"
    ],
    [
        "anointed",
        "a-noin-ted"
    ],
    [
        "let",
        "let"
    ],
    [
        "us",
        "us"
    ],
    [
        "break",
        "break"
    ],
    [
        "their",
        "their"
    ],
    [
        "bonds",
        "bonds"
    ],
    [
        "asunder",
        "a-sun-der"
    ],
    [
        "cast",
        "cast"
    ],
    [
        "cords",
        "cords"
    ],
    [
        "dwelleth",
        "dwell-eth"
    ],
    [
        "heaven",
        "hea-ven"
    ],
    [
        "laugh",
        "laugh"
    ],
    [
        "scorn",
        "scorn"
    ],
    [
        "have",
        "have"
    ],
    [
        "derision",
        "de-ri-sion"
    ],
    [
        "then",
        "then"
    ],
    [
        "speak",
        "speak"
    ],
    [
        "unto",
        "un-to"
    ],
    [
        "wrath",
        "wrath"
    ],
    [
        "vex",
        "vex"
    ],
    [
        "sore",
        "sore"
    ],
    [
        "displeasure",
        "dis-plea-sure"
    ],
    [
        "yet",
        "yet"
    ],
    [
        "i",
        "i"
    ],
    [
        "set",
        "set"
    ],
    [
        "my",
        "my"
    ],
    [
        "king",
        "king"
    ],
    [
        "upon",
        "up-on"
    ],
    [
        "holy",
        "ho-ly"
    ],
    [
        "hill",
        "hill"
    ],
    [
        "sion",
        "si-on"
    ],
    [
        "rehearse",
        "re-hearse"
    ],
    [
        "decree",
        "de-cree"
    ],
    [
        "said",
        "said"
    ],
    [
        "me",
        "me"
    ],
    [
        "thou",
        "thou"
    ],
    [
        "art",
        "art"
    ],
    [
        "son",
        "son"
    ],
    [
        "this",
        "this"
    ],
    [
        "begotten",
        "be-got-ten"
    ],
    [
        "thee",
        "thee"
    ],
    [
        "desire",
        "de-sire"
    ],
    [
        "give",
        "give"
    ],
    [
        "nations",
        "na-tions"
    ],
    [
        "thine",
        "thine"
    ],
    [
        "inheritance",
        "in-he-ri-tance"
    ],
    [
        "utmost",
        "ut-most"
    ],
    [
        "parts",
        "parts"
    ],
    [
        "thy",
        "thy"
    ],
    [
        "possession",
        "poss-ess-ion"
    ],
    [
        "shalt",
        "shalt"
    ],
    [
        "bruise",
        "bruise"
    ],
    [
        "rod",
        "rod"
    ],
    [
        "iron",
        "i-ron"
    ],
    [
        "pieces",
        "pie-ces"
    ],
    [
        "potters",
        "pot-ters"
    ],
    [
        "vessel",
        "vess-el"
    ],
    [
        "wise",
        "wise"
    ],
    [
        "now",
        "now"
    ],
    [
        "o",
        "o"
    ],
    [
        "ye",
        "ye"
    ],
    [
        "instructed",
        "in-struct-ed"
    ],
    [
        "judges",
        "judg-es"
    ],
    [
        "serve",
        "serve"
    ],
    [
        "fear",
        "fear"
    ],
    [
        "rejoice",
        "re-joice"
    ],
    [
        "him",
        "him"
    ],
    [
        "reverence",
        "re-ver-ence"
    ],
    [
        "kiss",
        "kiss"
    ],
    [
        "lest",
        "lest"
    ],
    [
        "angry",
        "angry"
    ],
    [
        "right",
        "right"
    ],
    [
        "if",
        "if"
    ],
    [
        "kindled",
        "kin-dled"
    ],
    [
        "yea",
        "yea"
    ],
    [
        "little",
        "lit-tle"
    ],
    [
        "all",
        "all"
    ],
    [
        "put",
        "put"
    ],
    [
        "trust",
        "trust"
    ],
    [
        "how",
        "how"
    ],
    [
        "increased",
        "in-creased"
    ],
    [
        "trouble",
        "trou-ble"
    ],
    [
        "many",
        "ma-ny"
    ],
    [
        "rise",
        "rise"
    ],
    [
        "one",
        "one"
    ],
    [
        "there",
        "there"
    ],
    [
        "say",
        "say"
    ],
    [
        "soul",
        "soul"
    ],
    [
        "no",
        "no"
    ],
    [
        "help",
        "help"
    ],
    [
        "god",
        "god"
    ],
    [
        "defender",
        "de-fen-der"
    ],
    [
        "worship",
        "wor-ship"
    ],
    [
        "lifter",
        "lif-ter"
    ],
    [
        "head",
        "head"
    ],
    [
        "did",
        "did"
    ],
    [
        "call",
        "call"
    ],
    [
        "voice",
        "voice"
    ],
    [
        "heard",
        "heard"
    ],
    [
        "out",
        "out"
    ],
    [
        "laid",
        "laid"
    ],
    [
        "down",
        "down"
    ],
    [
        "slept",
        "slept"
    ],
    [
        "rose",
        "rose"
    ],
    [
        "again",
        "a-gain"
    ],
    [
        "sustained",
        "sus-tained"
    ],
    [
        "afraid",
        "a-fraid"
    ],
    [
        "ten",
        "ten"
    ],
    [
        "thousands",
        "thou-sands"
    ],
    [
        "themselves",
        "them-selves"
    ],
    [
        "round",
        "round"
    ],
    [
        "about",
        "a-bout"
    ],
    [
        "smitest",
        "smit-est"
    ],
    [
        "mine",
        "mine"
    ],
    [
        "enemies",
        "e-ne-mies"
    ],
    [
        "cheek-bone",
        "cheek-bone"
    ],
    [
        "hast",
        "hast"
    ],
    [
        "broken",
        "bro-ken"
    ],
    [
        "teeth",
        "teeth"
    ],
    [
        "salvation",
        "sal-va-tion"
    ],
    [
        "belongeth",
        "be-long-eth"
    ],
    [
        "blessing",
        "bless-ing"
    ],
    [
        "hear",
        "hear"
    ],
    [
        "when",
        "when"
    ],
    [
        "righteousness",
        "right-eous-ness"
    ],
    [
        "at",
        "at"
    ],
    [
        "liberty",
        "li-ber-ty"
    ],
    [
        "was",
        "was"
    ],
    [
        "mercy",
        "mer-cy"
    ],
    [
        "hearken",
        "hear-ken"
    ],
    [
        "prayer",
        "prayer"
    ],
    [
        "sons",
        "sons"
    ],
    [
        "men",
        "men"
    ],
    [
        "long",
        "long"
    ],
    [
        "blaspheme",
        "blas-pheme"
    ],
    [
        "honour",
        "ho-nour"
    ],
    [
        "such",
        "such"
    ],
    [
        "pleasure",
        "plea-sure"
    ],
    [
        "vanity",
        "va-ni-ty"
    ],
    [
        "seek",
        "seek"
    ],
    [
        "after",
        "af-ter"
    ],
    [
        "falsehood",
        "false-hood"
    ],
    [
        "know",
        "know"
    ],
    [
        "chosen",
        "cho-sen"
    ],
    [
        "godly",
        "god-ly"
    ],
    [
        "awe",
        "awe"
    ],
    [
        "sin",
        "sin"
    ],
    [
        "commune",
        "comm-une"
    ],
    [
        "your",
        "your"
    ],
    [
        "own",
        "own"
    ],
    [
        "heart",
        "heart"
    ],
    [
        "chamber",
        "cham-ber"
    ],
    [
        "still",
        "still"
    ],
    [
        "offer",
        "off-er"
    ],
    [
        "sacrifice",
        "sac-ri-fice"
    ],
    [
        "who",
        "who"
    ],
    [
        "show",
        "show"
    ],
    [
        "any",
        "any"
    ],
    [
        "good",
        "good"
    ],
    [
        "lift",
        "lift"
    ],
    [
        "up",
        "up"
    ],
    [
        "light",
        "light"
    ],
    [
        "countenance",
        "coun-te-nance"
    ],
    [
        "gladness",
        "glad-ness"
    ],
    [
        "more",
        "more"
    ],
    [
        "than",
        "than"
    ],
    [
        "corn",
        "corn"
    ],
    [
        "wine",
        "wine"
    ],
    [
        "oil",
        "oil"
    ],
    [
        "increase",
        "in-crease"
    ],
    [
        "lay",
        "lay"
    ],
    [
        "peace",
        "peace"
    ],
    [
        "rest",
        "rest"
    ],
    [
        "only",
        "only"
    ],
    [
        "makest",
        "mak-est"
    ],
    [
        "dwell",
        "dwell"
    ],
    [
        "safety",
        "safe-ty"
    ],
    [
        "ponder",
        "pon-der"
    ],
    [
        "words",
        "words"
    ],
    [
        "consider",
        "con-si-der"
    ],
    [
        "meditation",
        "me-di-ta-tion"
    ],
    [
        "calling",
        "call-ing"
    ],
    [
        "make",
        "make"
    ],
    [
        "betimes",
        "be-times"
    ],
    [
        "early",
        "ear-ly"
    ],
    [
        "morning",
        "mor-ning"
    ],
    [
        "direct",
        "di-rect"
    ],
    [
        "wickedness",
        "wick-ed-ness"
    ],
    [
        "evil",
        "e-vil"
    ],
    [
        "foolish",
        "fool-ish"
    ],
    [
        "sight",
        "sight"
    ],
    [
        "hatest",
        "hat-est"
    ],
    [
        "work",
        "work"
    ],
    [
        "iniquity",
        "in-i-qui-ty"
    ],
    [
        "destroy",
        "des-troy"
    ],
    [
        "lies",
        "lies"
    ],
    [
        "abhor",
        "ab-hor"
    ],
    [
        "both",
        "both"
    ],
    [
        "blood-thirsty",
        "blood_thirs-ty"
    ],
    [
        "deceitful",
        "de-ceit-ful"
    ],
    [
        "multitude",
        "mul-ti-tude"
    ],
    [
        "come",
        "come"
    ],
    [
        "into",
        "in-to"
    ],
    [
        "house",
        "house"
    ],
    [
        "toward",
        "to-ward"
    ],
    [
        "temple",
        "tem-ple"
    ],
    [
        "lead",
        "lead"
    ],
    [
        "because",
        "be-cause"
    ],
    [
        "plain",
        "plain"
    ],
    [
        "before",
        "be-fore"
    ],
    [
        "faithfulness",
        "faith-ful-ness"
    ],
    [
        "mouth",
        "mouth"
    ],
    [
        "inward",
        "in-ward"
    ],
    [
        "very",
        "ve-ry"
    ],
    [
        "throat",
        "throat"
    ],
    [
        "an",
        "an"
    ],
    [
        "open",
        "open"
    ],
    [
        "sepulchre",
        "se-pul-chre"
    ],
    [
        "flatter",
        "flat-ter"
    ],
    [
        "tongue",
        "tongue"
    ],
    [
        "through",
        "through"
    ],
    [
        "imaginations",
        "i-ma-gi-na-tions"
    ],
    [
        "ungodliness",
        "un-god-li-ness"
    ],
    [
        "rebelled",
        "re-belled"
    ],
    [
        "ever",
        "ev-er"
    ],
    [
        "giving",
        "gi-ving"
    ],
    [
        "thanks",
        "thanks"
    ],
    [
        "defendest",
        "de-fend-est"
    ],
    [
        "love",
        "love"
    ],
    [
        "name",
        "name"
    ],
    [
        "joyful",
        "joy-ful"
    ],
    [
        "wilt",
        "wilt"
    ],
    [
        "favourable",
        "fa-vour-a-ble"
    ],
    [
        "kindness",
        "kind-ness"
    ],
    [
        "defend",
        "de-fend"
    ],
    [
        "shield",
        "shield"
    ],
    [
        "rebuke",
        "re-buke"
    ],
    [
        "indignation",
        "in-dig-na-tion"
    ],
    [
        "chasten",
        "chas-ten"
    ],
    [
        "am",
        "am"
    ],
    [
        "weak",
        "weak"
    ],
    [
        "heal",
        "heal"
    ],
    [
        "bones",
        "bones"
    ],
    [
        "vexed",
        "vexed"
    ],
    [
        "troubled",
        "trou-bled"
    ],
    [
        "punish",
        "pu-nish"
    ],
    [
        "turn",
        "turn"
    ],
    [
        "deliver",
        "de-li-ver"
    ],
    [
        "save",
        "save"
    ],
    [
        "mercys",
        "mer-cys"
    ],
    [
        "sake",
        "sake"
    ],
    [
        "death",
        "death"
    ],
    [
        "remembereth",
        "re-mem-ber-eth"
    ],
    [
        "pit",
        "pit"
    ],
    [
        "weary",
        "wea-ry"
    ],
    [
        "groaning",
        "groan-ing"
    ],
    [
        "every",
        "eve-ry"
    ],
    [
        "wash",
        "wash"
    ],
    [
        "bed",
        "bed"
    ],
    [
        "water",
        "water"
    ],
    [
        "couch",
        "couch"
    ],
    [
        "tears",
        "tears"
    ],
    [
        "beauty",
        "beau-ty"
    ],
    [
        "gone",
        "gone"
    ],
    [
        "worn",
        "worn"
    ],
    [
        "weeping",
        "weep-ing"
    ],
    [
        "petition",
        "pe-ti-tion"
    ],
    [
        "receive",
        "re-ceive"
    ],
    [
        "confounded",
        "con-foun-ded"
    ],
    [
        "turned",
        "turned"
    ],
    [
        "back",
        "back"
    ],
    [
        "shame",
        "shame"
    ],
    [
        "suddenly",
        "sud-den-ly"
    ],
    [
        "persecute",
        "per-se-cute"
    ],
    [
        "devour",
        "de-vour"
    ],
    [
        "lion",
        "li-on"
    ],
    [
        "tear",
        "tear"
    ],
    [
        "while",
        "while"
    ],
    [
        "none",
        "none"
    ],
    [
        "done",
        "done"
    ],
    [
        "or",
        "or"
    ],
    [
        "hands",
        "hands"
    ],
    [
        "rewarded",
        "re-war-ded"
    ],
    [
        "dealt",
        "dealt"
    ],
    [
        "friendly",
        "friend-ly"
    ],
    [
        "yea",
        "yea"
    ],
    [
        "delivered",
        "de-li-vered"
    ],
    [
        "without",
        "with-out"
    ],
    [
        "cause",
        "cause"
    ],
    [
        "enemy",
        "e-ne-my"
    ],
    [
        "tread",
        "tread"
    ],
    [
        "life",
        "life"
    ],
    [
        "dust",
        "dust"
    ],
    [
        "thyself",
        "thy-self"
    ],
    [
        "arise",
        "a-rise"
    ],
    [
        "commanded",
        "com-man-ded"
    ],
    [
        "peoples",
        "peo-ples"
    ],
    [
        "sakes",
        "sakes"
    ],
    [
        "judge",
        "judge"
    ],
    [
        "sentence",
        "sen-tence"
    ],
    [
        "according",
        "ac-cor-ding"
    ],
    [
        "innocency",
        "in-no-cen-cy"
    ],
    [
        "end",
        "end"
    ],
    [
        "guide",
        "guide"
    ],
    [
        "just",
        "just"
    ],
    [
        "trieth",
        "tri-eth"
    ],
    [
        "hearts",
        "hearts"
    ],
    [
        "reins",
        "reins"
    ],
    [
        "cometh",
        "com-eth"
    ],
    [
        "preserveth",
        "pre-ser-veth"
    ],
    [
        "true",
        "true"
    ],
    [
        "strong",
        "strong"
    ],
    [
        "patient",
        "pa-tient"
    ],
    [
        "provoked",
        "pro-voked"
    ],
    [
        "whet",
        "whet"
    ],
    [
        "sword",
        "sword"
    ],
    [
        "bent",
        "bent"
    ],
    [
        "bow",
        "bow"
    ],
    [
        "made",
        "made"
    ],
    [
        "ready",
        "rea-dy"
    ],
    [
        "prepared",
        "pre-pared"
    ],
    [
        "instruments",
        "inst-ru-ments"
    ],
    [
        "ordaineth",
        "or-dain-eth"
    ],
    [
        "arrows",
        "arr-ows"
    ],
    [
        "persecutors",
        "per-se-cu-tors"
    ],
    [
        "behold",
        "be-hold"
    ],
    [
        "travaileth",
        "tra-vail-eth"
    ],
    [
        "conceived",
        "con-ceived"
    ],
    [
        "mischief",
        "mis-chief"
    ],
    [
        "brought",
        "brought"
    ],
    [
        "graven",
        "gra-ven"
    ],
    [
        "digged",
        "digged"
    ],
    [
        "fallen",
        "fall-en"
    ],
    [
        "destruction",
        "des-truc-tion"
    ],
    [
        "other",
        "oth-er"
    ],
    [
        "travail",
        "tra-vail"
    ],
    [
        "fall",
        "fall"
    ],
    [
        "on",
        "on"
    ],
    [
        "pate",
        "pate"
    ],
    [
        "praise",
        "praise"
    ],
    [
        "most",
        "most"
    ],
    [
        "high",
        "high"
    ],
    [
        "our",
        "our"
    ],
    [
        "governor",
        "go-ver-nor"
    ],
    [
        "excellent",
        "ex-cell-ent"
    ],
    [
        "world",
        "world"
    ],
    [
        "glory",
        "glo-ry"
    ],
    [
        "above",
        "a-bove"
    ],
    [
        "heavens",
        "hea-vens"
    ],
    [
        "babes",
        "babes"
    ],
    [
        "sucklings",
        "suck-lings"
    ],
    [
        "ordained",
        "or-dained"
    ],
    [
        "strength",
        "strength"
    ],
    [
        "mightest",
        "might-est"
    ],
    [
        "avenger",
        "a-ven-ger"
    ],
    [
        "even",
        "e-ven"
    ],
    [
        "fingers",
        "fing-ers"
    ],
    [
        "moon",
        "moon"
    ],
    [
        "stars",
        "stars"
    ],
    [
        "what",
        "what"
    ],
    [
        "mindful",
        "mind-ful"
    ],
    [
        "visitest",
        "vis-it-est"
    ],
    [
        "madest",
        "mad-est"
    ],
    [
        "lower",
        "low-er"
    ],
    [
        "angels",
        "an-gels"
    ],
    [
        "crown",
        "crown"
    ],
    [
        "dominion",
        "do-min-ion"
    ],
    [
        "works",
        "works"
    ],
    [
        "things",
        "things"
    ],
    [
        "subjection",
        "sub-jec-tion"
    ],
    [
        "under",
        "un-der"
    ],
    [
        "feet",
        "feet"
    ],
    [
        "sheep",
        "sheep"
    ],
    [
        "oxen",
        "oxen"
    ],
    [
        "beasts",
        "beasts"
    ],
    [
        "field",
        "field"
    ],
    [
        "fowls",
        "fowls"
    ],
    [
        "air",
        "air"
    ],
    [
        "fishes",
        "fish-es"
    ],
    [
        "sea",
        "sea"
    ],
    [
        "walketh",
        "walk-eth"
    ],
    [
        "paths",
        "paths"
    ],
    [
        "seas",
        "seas"
    ],
    [
        "whole",
        "whole"
    ],
    [
        "marvellous",
        "mar-vell-ous"
    ],
    [
        "glad",
        "glad"
    ],
    [
        "songs",
        "songs"
    ],
    [
        "highest",
        "high-est"
    ],
    [
        "driven",
        "driv-en"
    ],
    [
        "presence",
        "pres-ence"
    ],
    [
        "maintained",
        "main-tained"
    ],
    [
        "throne",
        "throne"
    ],
    [
        "judgest",
        "judg-est"
    ],
    [
        "rebuked",
        "re-buked"
    ],
    [
        "destroyed",
        "des-troy-ed"
    ],
    [
        "destructions",
        "des-truc-tions"
    ],
    [
        "perpetual",
        "per-pe-tu-al"
    ],
    [
        "cities",
        "ci-ties"
    ],
    [
        "whose",
        "whose"
    ],
    [
        "memorial",
        "me-mor-i-al"
    ],
    [
        "perished",
        "per-ished"
    ],
    [
        "endure",
        "en-dure"
    ],
    [
        "minister",
        "mi-ni-ster"
    ],
    [
        "defence",
        "de-fence"
    ],
    [
        "oppressed",
        "op-pressed"
    ],
    [
        "refuge",
        "re-fuge"
    ],
    [
        "time",
        "time"
    ],
    [
        "never",
        "nev-er"
    ],
    [
        "failed",
        "failed"
    ],
    [
        "doings",
        "do-ings"
    ],
    [
        "maketh",
        "mak-eth"
    ],
    [
        "inquisition",
        "in-qui-si-tion"
    ],
    [
        "blood",
        "blood"
    ],
    [
        "forgetteth",
        "for-gett-eth"
    ],
    [
        "complaint",
        "com-plaint"
    ],
    [
        "poor",
        "poor"
    ],
    [
        "suffer",
        "suf-fer"
    ],
    [
        "hate",
        "hate"
    ],
    [
        "liftest",
        "lift-est"
    ],
    [
        "gates",
        "gates"
    ],
    [
        "may",
        "may"
    ],
    [
        "praises",
        "prais-es"
    ],
    [
        "within",
        "with-in"
    ],
    [
        "daughter",
        "daugh-ter"
    ],
    [
        "sunk",
        "sunk"
    ],
    [
        "same",
        "same"
    ],
    [
        "net",
        "net"
    ],
    [
        "hid",
        "hid"
    ],
    [
        "privily",
        "pri-vi-ly"
    ],
    [
        "foot",
        "foot"
    ],
    [
        "taken",
        "tak-en"
    ],
    [
        "known",
        "known"
    ],
    [
        "execute",
        "ex-e-cute"
    ],
    [
        "trapped",
        "trapped"
    ],
    [
        "wicked",
        "wick-ed"
    ],
    [
        "forget",
        "for-get"
    ],
    [
        "alway",
        "al-way"
    ],
    [
        "forgotten",
        "for-got-ten"
    ],
    [
        "abiding",
        "a-bi-ding"
    ],
    [
        "meek",
        "meek"
    ],
    [
        "upper",
        "up-per"
    ],
    [
        "hand",
        "hand"
    ],
    [
        "judged",
        "judged"
    ],
    [
        "standest",
        "stand-est"
    ],
    [
        "far",
        "far"
    ],
    [
        "off",
        "off"
    ],
    [
        "hidest",
        "hid-est"
    ],
    [
        "needful",
        "need-ful"
    ],
    [
        "lust",
        "lust"
    ],
    [
        "doth",
        "doth"
    ],
    [
        "crafty",
        "craf-ty"
    ],
    [
        "wiliness",
        "wi-li-ness"
    ],
    [
        "imagined",
        "im-a-gined"
    ],
    [
        "boast",
        "boast"
    ],
    [
        "hearts",
        "hearts"
    ],
    [
        "speaketh",
        "speak-eth"
    ],
    [
        "covetous",
        "co-ve-tous"
    ],
    [
        "whom",
        "whom"
    ],
    [
        "abhorreth",
        "ab-horr-eth"
    ],
    [
        "proud",
        "proud"
    ],
    [
        "careth",
        "ca-reth"
    ],
    [
        "thoughts",
        "thoughts"
    ],
    [
        "ways",
        "ways"
    ],
    [
        "grievous",
        "grie-vous"
    ],
    [
        "judgments",
        "judg-ments"
    ],
    [
        "defieth",
        "de-fieth"
    ],
    [
        "tush",
        "tush"
    ],
    [
        "harm",
        "harm"
    ],
    [
        "happen",
        "hap-pen"
    ],
    [
        "full",
        "full"
    ],
    [
        "cursing",
        "cur-sing"
    ],
    [
        "deceit",
        "de-ceit"
    ],
    [
        "fraud",
        "fraud"
    ],
    [
        "sitteth",
        "sitt-eth"
    ],
    [
        "lurking",
        "lur-king"
    ],
    [
        "thievish",
        "thiev-ish"
    ],
    [
        "corners",
        "cor-ners"
    ],
    [
        "streets",
        "streets"
    ],
    [
        "dens",
        "dens"
    ],
    [
        "murder",
        "mur-der"
    ],
    [
        "innocent",
        "in-no-cent"
    ],
    [
        "eyes",
        "eyes"
    ],
    [
        "lieth",
        "li-eth"
    ],
    [
        "waiting",
        "wait-ing"
    ],
    [
        "secretly",
        "se-cret-ly"
    ],
    ////////
    [
        "lurketh",
        "lurk-eth"
    ],
    [
        "den",
        "den"
    ],
    [
        "ravish",
        "ra-vish"
    ],
    [
        "getteth",
        "gett-eth"
    ],
    [
        "falleth",
        "fall-eth"
    ],
    [
        "humbleth",
        "humb-leth"
    ],
    [
        "captains",
        "cap-tains"
    ],
    [
        "hideth",
        "hid-eth"
    ],
    [
        "see",
        "see"
    ],
    [
        "wherefore",
        "where-fore"
    ],
    [
        "should",
        "should"
    ],
    [
        "carest",
        "car-est"
    ],
    [
        "surely",
        "sure-ly"
    ],
    [
        "seen",
        "seen"
    ],
    [
        "beholdest",
        "be-hold-est"
    ],
    [
        "wrong",
        "wrong"
    ],
    [
        "mayest",
        "may-est"
    ],
    [
        "matter",
        "mat-ter"
    ],
    [
        "committeth",
        "com-mitt-eth"
    ],
    [
        "helper",
        "hel-per"
    ],
    [
        "friendless",
        "friend-less"
    ],
    [
        "power",
        "power"
    ],
    [
        "malicious",
        "ma-li-cious"
    ],
    [
        "search",
        "search"
    ],
    [
        "until",
        "un-til"
    ],
    [
        "find",
        "find"
    ],
    [
        "land",
        "land"
    ],
    [
        "preparest",
        "pre-par-est"
    ],
    [
        "ear",
        "ear"
    ],
    [
        "hearkeneth",
        "hear-ken-eth"
    ],
    [
        "fatherless",
        "fa-ther-less"
    ],
    [
        "exalted",
        "ex-al-ted"
    ],
    [
        "she",
        "she"
    ],
    [
        "flee",
        "flee"
    ],
    [
        "bird",
        "bird"
    ],
    [
        "lo",
        "lo"
    ],
    [
        "bend",
        "bend"
    ],
    [
        "quiver",
        "qui-ver"
    ],
    [
        "shoot",
        "shoot"
    ],
    [
        "foundations",
        "found-a-tions"
    ],
    [
        "can",
        "can"
    ],
    [
        "lords",
        "lords"
    ],
    [
        "eyelids",
        "eye-lids"
    ],
    [
        "try",
        "try"
    ],
    [
        "children",
        "child-ren"
    ],
    [
        "approveth",
        "app-ro-veth"
    ],
    [
        "delighteth",
        "de-light-eth"
    ],
    [
        "rain",
        "rain"
    ],
    [
        "snares",
        "snares"
    ],
    [
        "fire",
        "fire"
    ],
    [
        "brimstone",
        "brim-stone"
    ],
    [
        "storm",
        "storm"
    ],
    [
        "tempest",
        "tem-pest"
    ],
    [
        "portion",
        "por-tion"
    ],
    [
        "drink",
        "drink"
    ],
    [
        "loveth",
        "lov-eth"
    ],
    [
        "left",
        "left"
    ],
    [
        "faithful",
        "faith-ful"
    ],
    [
        "minished",
        "min-ished"
    ],
    [
        "among",
        "a-mong"
    ],
    [
        "talk",
        "talk"
    ],
    [
        "neighbour",
        "neigh-bour"
    ],
    [
        "lips",
        "lips"
    ],
    [
        "dissemble",
        "diss-em-ble"
    ],
    [
        "double",
        "double"
    ],
    [
        "root",
        "root"
    ],
    [
        "we",
        "we"
    ],
    [
        "prevail",
        "pre-vail"
    ],
    [
        "ought",
        "ought"
    ],
    [
        "over",
        "o-ver"
    ],
    [
        "comfortless",
        "com-fort-less"
    ],
    [
        "troubles",
        "trou-bles"
    ],
    [
        "needy",
        "nee-dy"
    ],
    [
        "deep",
        "deep"
    ],
    [
        "sighing",
        "sigh-ing"
    ],
    [
        "saith",
        "saith"
    ],
    [
        "swelleth",
        "swell-eth"
    ],
    [
        "pure",
        "pure"
    ],
    [
        "silver",
        "sil-ver"
    ],
    [
        "tried",
        "tried"
    ],
    [
        "purified",
        "pu-ri-fied"
    ],
    [
        "seven",
        "se-ven"
    ],
    [
        "times",
        "times"
    ],
    [
        "keep",
        "keep"
    ],
    [
        "preserve",
        "pre-serve"
    ],
    [
        "generation",
        "ge-ne-ra-tion"
    ],
    [
        "walk",
        "walk"
    ],
    [
        "side",
        "side"
    ],
    [
        "hide",
        "hide"
    ],
    [
        "triumph",
        "tri-umph"
    ],
    [
        "lighten",
        "light-en"
    ],
    [
        "sleep",
        "sleep"
    ],
    [
        "prevailed",
        "pre-vailed"
    ],
    [
        "sing",
        "sing"
    ],
    [
        "lovingly",
        "lov-ing-ly"
    ],
    [
        "fool",
        "fool"
    ],
    [
        "corrupt",
        "cor-rupt"
    ],
    [
        "become",
        "be-come"
    ],
    [
        "abominable",
        "a-bom-in-a-ble"
    ],
    [
        "looked",
        "looked"
    ],
    [
        "were",
        "were"
    ],
    [
        "would",
        "would"
    ],
    [
        "understand",
        "un-der-stand"
    ],
    [
        "altogether",
        "al-to-ge-ther"
    ],
    [
        "knowledge",
        "know-ledge"
    ],
    [
        "workers",
        "wor-kers"
    ],
    [
        "eating",
        "ea-ting"
    ],
    [
        "bread",
        "bread"
    ],
    [
        "great",
        "great"
    ],
    [
        "where",
        "where"
    ],
    [
        "you",
        "you"
    ],
    [
        "mock",
        "mock"
    ],
    [
        "putteth",
        "putt-eth"
    ],
    [
        "israel",
        "is-r-ael"
    ],
    [
        "turneth",
        "tur-neth"
    ],
    [
        "captivity",
        "cap-ti-vi-ty"
    ],
    [
        "jacob",
        "ja-cob"
    ],
    [
        "psalm",
        "psalm"
    ],
    ////////
    [
        "tabernacle",
        "tab-er-na-cle"
    ],
    [
        "leadeth",
        "lead-eth"
    ],
    [
        "uncorrupt",
        "un-corr-upt"
    ],
    [
        "truth",
        "truth"
    ],
    [
        "used",
        "used"
    ],
    [
        "slandered",
        "slan-dered"
    ],
    [
        "setteth",
        "set-teth"
    ],
    [
        "lowly",
        "low-ly"
    ],
    [
        "much",
        "much"
    ],
    [
        "sweareth",
        "swear-eth"
    ],
    [
        "disappointeth",
        "dis-app-oin-teth"
    ],
    [
        "though",
        "though"
    ],
    [
        "hindrance",
        "hind-rance"
    ],
    [
        "given",
        "gi-ven"
    ],
    [
        "money",
        "mo-ney"
    ],
    [
        "usury",
        "us-u-ry"
    ],
    [
        "reward",
        "re-ward"
    ],
    [
        "whoso",
        "who-so"
    ],
    [
        "these",
        "these"
    ],
    [
        "saints",
        "saints"
    ],
    [
        "excel",
        "ex-cel"
    ],
    [
        "virtue",
        "vir-tue"
    ],
    [
        "run",
        "run"
    ],
    [
        "another",
        "a-no-ther"
    ],
    [
        "drink-offerings",
        "drink_off-er-ings"
    ],
    [
        "mention",
        "men-tion"
    ],
    [
        "names",
        "names"
    ],
    [
        "cup",
        "cup"
    ],
    [
        "maintain",
        "main-tain"
    ],
    [
        "lot",
        "lot"
    ],
    [
        "fair",
        "fair"
    ],
    [
        "ground",
        "ground"
    ],
    [
        "goodly",
        "good-ly"
    ],
    [
        "heritage",
        "he-ri-tage"
    ],
    [
        "thank",
        "thank"
    ],
    [
        "warning",
        "war-ning"
    ],
    [
        "rejoiceth",
        "re-joic-eth"
    ],
    [
        "flesh",
        "flesh"
    ],
    [
        "hope",
        "hope"
    ],
    [
        "leave",
        "leave"
    ],
    [
        "hell",
        "hell"
    ],
    [
        "corruption",
        "cor-rup-tion"
    ],
    [
        "path",
        "path"
    ],
    [
        "fulness",
        "ful-ness"
    ],
    [
        "joy",
        "joy"
    ],
    [
        "evermore",
        "ev-er-more"
    ],
    [
        "goeth",
        "go-eth"
    ],
    ///////
    [
        "feigned",
        "feigned"
    ],
    [
        "equal",
        "e-qual"
    ],
    [
        "proved",
        "proved"
    ],
    [
        "visited",
        "vis-it-ed"
    ],
    [
        "utterly",
        "utt-er-ly"
    ],
    [
        "purposed",
        "pur-posed"
    ],
    [
        "offend",
        "off-end"
    ],
    [
        "word",
        "word"
    ],
    [
        "kept",
        "kept"
    ],
    [
        "destroyer",
        "des-troy-er"
    ],
    [
        "hold",
        "hold"
    ],
    [
        "goings",
        "go-ings"
    ],
    [
        "footsteps",
        "foot-steps"
    ],
    [
        "slip",
        "slip"
    ],
    [
        "called",
        "called"
    ],
    [
        "incline",
        "in-cline"
    ],
    [
        "loving-kindness",
        "lov-ing_kind-ness"
    ],
    [
        "saviour",
        "sav-iour"
    ],
    [
        "resist",
        "res-ist"
    ],
    [
        "apple",
        "ap-ple"
    ],
    [
        "eye",
        "eye"
    ],
    [
        "shadow",
        "sha-dow"
    ],
    [
        "wings",
        "wings"
    ],
    [
        "compass",
        "com-pass"
    ],
    [
        "inclosed",
        "in-closed"
    ],
    [
        "fat",
        "fat"
    ],
    [
        "lie",
        "lie"
    ],
    [
        "watching",
        "watch-ing"
    ],
    [
        "greedy",
        "gree-dy"
    ],
    [
        "prey",
        "prey"
    ],
    [
        "lions",
        "li-ons"
    ],
    [
        "whelp",
        "whelp"
    ],
    [
        "secret",
        "sec-ret"
    ],
    [
        "places",
        "pla-ces"
    ],
    [
        "disappoint",
        "dis-ap-point"
    ],
    [
        "bellies",
        "bell-ies"
    ],
    [
        "fillest",
        "fill-est"
    ],
    [
        "treasure",
        "trea-sure"
    ],
    [
        "substance",
        "sub-stance"
    ],
    [
        "awake",
        "a-wake"
    ],
    [
        "likeness",
        "like-ness"
    ],
    [
        "satisfied",
        "sa-tis-fied"
    ],
    [
        "stony",
        "stony"
    ],
    [
        "rock",
        "rock"
    ],
    [
        "might",
        "might"
    ],
    [
        "buckler",
        "buck-ler"
    ],
    [
        "horn",
        "horn"
    ],
    [
        "worthy",
        "wor-thy"
    ],
    [
        "praised",
        "praised"
    ],
    [
        "safe",
        "safe"
    ],
    [
        "sorrows",
        "sor-rows"
    ],
    [
        "compassed",
        "com-passed"
    ],
    [
        "overflowings",
        "o-ver-flow-ings"
    ],
    [
        "pains",
        "pains"
    ],
    [
        "came",
        "came"
    ],
    [
        "overtook",
        "o-ver-took"
    ],
    [
        "complained",
        "com-plained"
    ],
    [
        "entered",
        "en-tered"
    ],
    [
        "ears",
        "ears"
    ],
    [
        "trembled",
        "trem-bled"
    ],
    [
        "quaked",
        "quaked"
    ],
    [
        "hills",
        "hills"
    ],
    [
        "shook",
        "shook"
    ],
    [
        "removed",
        "re-moved"
    ],
    [
        "wroth",
        "wroth"
    ],
    [
        "went",
        "went"
    ],
    [
        "smoke",
        "smoke"
    ],
    [
        "consuming",
        "con-su-ming"
    ],
    [
        "coals",
        "coals"
    ],
    [
        "bowed",
        "bowed"
    ],
    [
        "dark",
        "dark"
    ],
    [
        "rode",
        "rode"
    ],
    [
        "cherubim",
        "che-ru-bim"
    ],
    [
        "fly",
        "fly"
    ],
    [
        "flying",
        "fly-ing"
    ],
    [
        "darkness",
        "dark-ness"
    ],
    [
        "place",
        "place"
    ],
    [
        "pavilion",
        "pa-vil-ion"
    ],
    [
        "thick",
        "thick"
    ],
    [
        "clouds",
        "clouds"
    ],
    [
        "cover",
        "cover"
    ],
    [
        "brightness",
        "bright-ness"
    ],
    [
        "hailstones",
        "hail-stones"
    ],
    [
        "thundered",
        "thun-dered"
    ],
    [
        "gave",
        "gave"
    ],
    [
        "thunder",
        "thun-der"
    ],
    [
        "sent",
        "sent"
    ],
    [
        "scattered",
        "scat-tered"
    ],
    [
        "lightnings",
        "light-nings"
    ],
    [
        "springs",
        "springs"
    ],
    [
        "waters",
        "wa-ters"
    ],
    [
        "discovered",
        "dis-co-vered"
    ],
    [
        "chiding",
        "chid-ing"
    ],
    [
        "blasting",
        "blast-ing"
    ],
    [
        "breath",
        "breath"
    ],
    [
        "fetch",
        "fetch"
    ],
    [
        "took",
        "took"
    ],
    [
        "strongest",
        "strong-est"
    ],
    [
        "too",
        "too"
    ],
    [
        "mighty",
        "migh-ty"
    ],
    [
        "upholder",
        "up-hold-er"
    ],
    [
        "had",
        "had"
    ],
    [
        "favour",
        "favour"
    ],
    [
        "dealing",
        "deal-ing"
    ],
    [
        "cleanness",
        "clean-ness"
    ],
    [
        "recompense",
        "re-com-pense"
    ],
    [
        "forsaken",
        "for-saken"
    ],
    [
        "laws",
        "laws"
    ],
    [
        "commandments",
        "com-mand-ments"
    ],
    [
        "eschewed",
        "es-chewed"
    ],
    [
        "eyesight",
        "eye-sight"
    ],
    [
        "perfect",
        "per-fect"
    ],
    [
        "clean",
        "clean"
    ],
    [
        "froward",
        "fro-ward"
    ],
    [
        "adversity",
        "ad-ver-si-ty"
    ],
    [
        "looks",
        "looks"
    ],
    [
        "candle",
        "can-dle"
    ],
    [
        "discomfit",
        "dis-com-fit"
    ],
    [
        "host",
        "host"
    ],
    [
        "leap",
        "leap"
    ],
    [
        "wall",
        "wall"
    ],
    [
        "undefiled",
        "un-de-filed"
    ],
    [
        "except",
        "ex-cept"
    ],
    [
        "girdeth",
        "gird-eth"
    ],
    [
        "war",
        "war"
    ],
    [
        "harts",
        "harts"
    ],
    [
        "teacheth",
        "teach-eth"
    ],
    [
        "fight",
        "fight"
    ],
    [
        "arms",
        "arms"
    ],
    [
        "steel",
        "steel"
    ],
    [
        "loving",
        "lov-ing"
    ],
    [
        "correction",
        "cor-rec-tion"
    ],
    [
        "room",
        "room"
    ],
    [
        "enough",
        "en-ough"
    ],
    [
        "go",
        "go"
    ],
    [
        "slide",
        "slide"
    ],
    [
        "follow",
        "fol-low"
    ],
    [
        "overtake",
        "o-ver-take"
    ],
    [
        "till",
        "till"
    ],
    [
        "smite",
        "smite"
    ],
    [
        "girded",
        "gir-ded"
    ],
    [
        "battle",
        "bat-tle"
    ],
    [
        "throw",
        "throw"
    ],
    [
        "backs",
        "backs"
    ],
    [
        "cry",
        "cry"
    ],
    [
        "beat",
        "beat"
    ],
    [
        "small",
        "small"
    ],
    [
        "clay",
        "clay"
    ],
    [
        "strivings",
        "striv-ings"
    ],
    [
        "soon",
        "soon"
    ],
    [
        "obey",
        "o-bey"
    ],
    [
        "strangers",
        "stran-gers"
    ],
    [
        "feign",
        "feign"
    ],
    [
        "obedience",
        "o-be-di-ence"
    ],
    [
        "fail",
        "fail"
    ],
    [
        "trembling",
        "trem-bling"
    ],
    [
        "strongholds",
        "strong-holds"
    ],
    [
        "liveth",
        "liv-eth"
    ],
    [
        "seeth",
        "seeth"
    ],
    [
        "avenged",
        "av-enged"
    ],
    [
        "subdueth",
        "sub-du-eth"
    ],
    [
        "delivereth",
        "de-li-ver-eth"
    ],
    [
        "cruel",
        "cru-el"
    ],
    [
        "adversaries",
        "ad-ver-sa-ries"
    ],
    [
        "rid",
        "rid"
    ],
    [
        "gentiles",
        "gen-tiles"
    ],
    [
        "prosperity",
        "pros-pe-ri-ty"
    ],
    [
        "giveth",
        "gi-veth"
    ],
    [
        "showeth",
        "show-eth"
    ],
    [
        "david",
        "da-vid"
    ],
    [
        "seed",
        "seed"
    ],
    [
        "declare",
        "de-clare"
    ],
    [
        "firmament",
        "fir-ma-ment"
    ],
    [
        "handy-work",
        "han-dy_work"
    ],
    [
        "telleth",
        "tell-eth"
    ],
    [
        "certifieth",
        "cer-ti-fi-eth"
    ],
    ////////////////
    [
        "speech",
        "speech"
    ],
    [
        "language",
        "lang-uage"
    ],
    [
        "voices",
        "voi-ces"
    ],
    [
        "sound",
        "sound"
    ],
    [
        "lands",
        "lands"
    ],
    [
        "ends",
        "ends"
    ],
    [
        "sun",
        "sun"
    ],
    [
        "bridegroom",
        "bride-groom"
    ],
    [
        "giant",
        "gi-ant"
    ],
    [
        "course",
        "course"
    ],
    [
        "uttermost",
        "ut-ter-most"
    ],
    [
        "part",
        "part"
    ],
    [
        "runneth",
        "runn-eth"
    ],
    [
        "nothing",
        "noth-ing"
    ],
    [
        "heat",
        "heat"
    ],
    [
        "thereof",
        "there-of"
    ],
    [
        "converting",
        "con-ver-ting"
    ],
    [
        "testimony",
        "tes-ti-mo-ny"
    ],
    [
        "sure",
        "sure"
    ],
    [
        "wisdom",
        "wis-dom"
    ],
    [
        "simple",
        "sim-ple"
    ],
    [
        "statutes",
        "stat-utes"
    ],
    [
        "commandment",
        "com-mand-ment"
    ],
    [
        "endureth",
        "en-dur-eth"
    ],
    [
        "desired",
        "de-sired"
    ],
    [
        "gold",
        "gold"
    ],
    [
        "fine",
        "fine"
    ],
    [
        "sweeter",
        "swee-ter"
    ],
    [
        "honey",
        "hon-ey"
    ],
    [
        "honeycomb",
        "hon-ey-comb"
    ],
    [
        "moreover",
        "more-ov-er"
    ],
    [
        "servant",
        "ser-vant"
    ],
    [
        "taught",
        "taught"
    ],
    [
        "keeping",
        "keep-ing"
    ],
    [
        "tell",
        "tell"
    ],
    [
        "oft",
        "oft"
    ],
    [
        "offendeth",
        "off-end-eth"
    ],
    [
        "cleanse",
        "cleanse"
    ],
    [
        "faults",
        "faults"
    ],
    [
        "presumptuous",
        "pre-sump-tu-ous"
    ],
    [
        "sins",
        "sins"
    ],
    [
        "get",
        "get"
    ],
    [
        "offence",
        "off-ence"
    ],
    [
        "acceptable",
        "ac-cep-ta-ble"
    ],
    [
        "redeemer",
        "re-dee-mer"
    ],
    [
        "send",
        "send"
    ],
    [
        "sanctuary",
        "sanc-tu-a-ry"
    ],
    [
        "strengthen",
        "strength-en"
    ],
    [
        "remember",
        "re-mem-ber"
    ],
    [
        "offerings",
        "of-fer-ings"
    ],
    [
        "accept",
        "ac-cept"
    ],
    [
        "burnt-sacrifice",
        "burnt_sac-ri-fice"
    ],
    [
        "grant",
        "grant"
    ],
    [
        "fulfil",
        "ful-fil"
    ],
    [
        "mind",
        "mind"
    ],
    [
        "perform",
        "per-form"
    ],
    [
        "petitions",
        "pe-ti-tions"
    ],
    [
        "helpeth",
        "help-eth"
    ],
    [
        "wholesome",
        "whole-some"
    ],
    [
        "some",
        "some"
    ],
    [
        "chariots",
        "cha-ri-ots"
    ],
    [
        "horses",
        "hor-ses"
    ],
    [
        "risen",
        "ri-sen"
    ],
    [
        "upright",
        "up-right"
    ],
    [
        "exceeding",
        "ex-ceed-ing"
    ],
    [
        "denied",
        "de-nied"
    ],
    [
        "request",
        "re-quest"
    ],
    [
        "meet",
        "meet"
    ],
    [
        "blessings",
        "bless-ings"
    ],
    [
        "goodness",
        "good-ness"
    ],
    [
        "asked",
        "asked"
    ],
    [
        "gavest",
        "gav-est"
    ],
    [
        "everlasting",
        "ev-er-last-ing"
    ],
    [
        "felicity",
        "fe-li-ci-ty"
    ],
    [
        "miscarry",
        "mis-car-ry"
    ],
    [
        "feel",
        "feel"
    ],
    [
        "fiery",
        "fie-ry"
    ],
    [
        "oven",
        "ov-en"
    ],
    [
        "consume",
        "con-sume"
    ],
    [
        "intended",
        "in-ten-ded"
    ],
    [
        "device",
        "de-vice"
    ],
    [
        "flight",
        "flight"
    ],
    [
        "strings",
        "strings"
    ],
    [
        "health",
        "health"
    ],
    [
        "day-time",
        "day_time"
    ],
    [
        "hearest",
        "hear-est"
    ],
    [
        "continuest",
        "con-ti-nu-est"
    ],
    [
        "fathers",
        "fathers"
    ],
    [
        "hoped",
        "hoped"
    ],
    [
        "trusted",
        "trust-ed"
    ],
    [
        "didst",
        "didst"
    ],
    [
        "holpen",
        "hol-pen"
    ],
    [
        "worm",
        "worm"
    ],
    [
        "outcast",
        "out-cast"
    ],
    [
        "shake",
        "shake"
    ],
    [
        "heads",
        "heads"
    ],
    [
        "saying",
        "say-ing"
    ],
    [
        "mothers",
        "mo-thers"
    ],
    [
        "womb",
        "womb"
    ],
    [
        "wast",
        "wast"
    ],
    [
        "hanged",
        "hanged"
    ],
    [
        "breasts",
        "breasts"
    ],
    [
        "been",
        "been"
    ],
    [
        "since",
        "since"
    ],
    [
        "born",
        "born"
    ],
    [
        "hard",
        "hard"
    ],
    [
        "bulls",
        "bulls"
    ],
    [
        "bashan",
        "ba-shan"
    ],
    [
        "close",
        "close"
    ],
    [
        "gape",
        "gape"
    ],
    [
        "mouths",
        "mouths"
    ],
    [
        "ramping",
        "ramp-ing"
    ],
    [
        "roaring",
        "roar-ing"
    ],
    [
        "poured",
        "poured"
    ],
    [
        "joint",
        "joint"
    ],
    [
        "midst",
        "midst"
    ],
    [
        "body",
        "bo-dy"
    ],
    [
        "melting",
        "mel-ting"
    ],
    [
        "wax",
        "wax"
    ],
    [
        "dried",
        "dried"
    ],
    [
        "potsherd",
        "pot-sherd"
    ],
    [
        "cleaveth",
        "cleav-eth"
    ],
    [
        "gums",
        "gums"
    ],
    [
        "bringest",
        "bring-est"
    ],
    [
        "dogs",
        "dogs"
    ],
    [
        "council",
        "coun-cil"
    ],
    [
        "layeth",
        "lay-eth"
    ],
    [
        "siege",
        "siege"
    ],
    [
        "pierced",
        "pierced"
    ],
    [
        "staring",
        "star-ing"
    ],
    [
        "looking",
        "look-ing"
    ],
    [
        "garments",
        "gar-ments"
    ],
    [
        "lots",
        "lots"
    ],
    [
        "vesture",
        "ves-ture"
    ],
    [
        "succour",
        "suc-cour"
    ],
    [
        "haste",
        "haste"
    ],
    [
        "darling",
        "dar-ling"
    ],
    [
        "dog",
        "dog"
    ],
    [
        "horns",
        "horns"
    ],
    [
        "unicorns",
        "u-ni-corns"
    ],
    [
        "brethren",
        "breth-ren"
    ],
    [
        "magnify",
        "mag-ni-fy"
    ],
    [
        "despised",
        "desp-ised"
    ],
    [
        "abhorred",
        "ab-horred"
    ],
    [
        "low",
        "low"
    ],
    [
        "estate",
        "es-tate"
    ],
    [
        "great-congregation",
        "great_con-gre-ga-tion"
    ],
    [
        "vows",
        "vows"
    ],
    [
        "eat",
        "eat"
    ],
    [
        "live",
        "live"
    ],
    [
        "kindreds",
        "kind-reds"
    ],
    [
        "kingdom",
        "king-dom"
    ],
    [
        "eaten",
        "eat-en"
    ],
    [
        "worshipped",
        "wor-shipped"
    ],
    [
        "kneel",
        "kneel"
    ],
    [
        "quickened",
        "quick-ened"
    ],
    [
        "counted",
        "coun-ted"
    ],
    [
        "shepherd",
        "shep-herd"
    ],
    [
        "lack",
        "lack"
    ],
    [
        "feed",
        "feed"
    ],
    [
        "green",
        "green"
    ],
    [
        "pasture",
        "pas-ture"
    ],
    [
        "beside",
        "be-side"
    ],
    [
        "comfort",
        "com-fort"
    ],
    [
        "convert",
        "con-vert"
    ],
    [
        "names",
        "names"
    ],
    [
        "valley",
        "val-ley"
    ],
    [
        "staff",
        "staff"
    ],
    [
        "prepare",
        "pre-pare"
    ],
    [
        "table",
        "ta-ble"
    ],
    [
        "days",
        "days"
    ],
    [
        "therein",
        "there-in"
    ],
    [
        "founded",
        "foun-ded"
    ],
    [
        "stablished",
        "stab-lished"
    ],
    [
        "floods",
        "floods"
    ],
    [
        "ascend",
        "asc-end"
    ],
    [
        "sworn",
        "sworn"
    ],
    [
        "deceive",
        "de-ceive"
    ],
    [
        "doors",
        "doors"
    ],
    [
        "hosts",
        "hosts"
    ],
    [
        "ashamed",
        "a-shamed"
    ],
    [
        "transgress",
        "trans-gress"
    ],
    [
        "confusion",
        "con-fu-sion"
    ],
    [
        "teach",
        "teach"
    ],
    [
        "learn",
        "learn"
    ],
    [
        "remembrance",
        "re-mem-brance"
    ],
    [
        "tender",
        "ten-der"
    ],
    [
        "mercies",
        "mer-cies"
    ],
    [
        "loving-kindnesses",
        "lov-ing_kind-ness-es"
    ],
    [
        "old",
        "old"
    ],
    [
        "offences",
        "off-en-ces"
    ],
    [
        "youth",
        "youth"
    ],
    [
        "think",
        "think"
    ],
    [
        "gracious",
        "gra-cious"
    ],
    [
        "gentle",
        "gen-tle"
    ],
    [
        "covenant",
        "co-ve-nant"
    ],
    [
        "testimonies",
        "tes-ti-mon-ies"
    ],
    [
        "merciful",
        "mer-ci-ful"
    ],
    [
        "feareth",
        "fear-eth"
    ],
    [
        "choose",
        "choose"
    ],
    [
        "ease",
        "ease"
    ],
    [
        "inherit",
        "in-he-rit"
    ],
    [
        "pluck",
        "pluck"
    ],
    [
        "desolate",
        "de-so-late"
    ],
    [
        "misery",
        "mi-se-ry"
    ],
    [
        "enlarged",
        "en-larged"
    ],
    [
        "troubles",
        "trou-bles"
    ],
    [
        "forgive",
        "for-give"
    ],
    [
        "bear",
        "bear"
    ],
    [
        "tyrannous",
        "ty-ran-nous"
    ],
    [
        "perfectness",
        "per-fect-ness"
    ],
    [
        "wait",
        "wait"
    ],
    [
        "innocently",
        "in-no-cent-ly"
    ],
    [
        "examine",
        "ex-am-ine"
    ],
    [
        "prove",
        "prove"
    ],
    [
        "dwelt",
        "dwelt"
    ],
    [
        "persons",
        "per-sons"
    ],
    [
        "fellowship",
        "fel-low-ship"
    ],
    [
        "hated",
        "hat-ed"
    ],
    [
        "sit",
        "sit"
    ],
    [
        "altar",
        "al-tar"
    ],
    [
        "thanksgiving",
        "thanks-giv-ing"
    ],
    [
        "wondrous",
        "won-drous"
    ],
    [
        "loved",
        "loved"
    ],
    [
        "habitation",
        "ha-bi-ta-tion"
    ],
    [
        "shut",
        "shut"
    ],
    [
        "gifts",
        "gifts"
    ],
    [
        "standeth",
        "stand-eth"
    ],
    [
        "congregations",
        "con-gre-ga-tions"
    ],
    [
        "foes",
        "foes"
    ],
    [
        "stumbled",
        "stum-bled"
    ],
    [
        "fell",
        "fell"
    ],
    [
        "require",
        "re-quire"
    ],
    [
        "visit",
        "vis-it"
    ],
    [
        "dwelling",
        "dwell-ing"
    ],
    [
        "stone",
        "stone"
    ],
    [
        "oblation",
        "ob-la-tion"
    ],
    [
        "talked",
        "talked"
    ],
    [
        "forsake",
        "for-sake"
    ],
    [
        "father",
        "fa-ther"
    ],
    [
        "mother",
        "mo-ther"
    ],
    [
        "taketh",
        "tak-eth"
    ],
    [
        "false",
        "false"
    ],
    [
        "witnesses",
        "wit-ness-es"
    ],
    [
        "fainted",
        "faint-ed"
    ],
    [
        "believe",
        "be-lieve"
    ],
    [
        "verily",
        "ve-ri-ly"
    ],
    [
        "living",
        "li-ving"
    ],
    [
        "tarry",
        "tar-ry"
    ],
    [
        "leisure",
        "lei-sure"
    ],
    [
        "humble",
        "hum-ble"
    ],
    [
        "towards",
        "to-wards"
    ],
    [
        "mercyseat",
        "mer-cy-seat"
    ],
    [
        "doers",
        "do-ers"
    ],
    [
        "neighbours",
        "neigh-bours"
    ],
    [
        "deeds",
        "deeds"
    ],
    [
        "inventions",
        "in-ven-tions"
    ],
    [
        "pay",
        "pay"
    ],
    [
        "deserved",
        "des-erved"
    ],
    [
        "regard",
        "re-gard"
    ],
    [
        "operation",
        "op-er-a-tion"
    ],
    [
        "build",
        "build"
    ],
    [
        "helped",
        "helped"
    ],
    [
        "danceth",
        "danc-eth"
    ],
    [
        "song",
        "song"
    ],
    [
        "ascribe",
        "a-scribe"
    ],
    [
        "glorious",
        "glo-rious"
    ],
    [
        "ruleth",
        "rul-eth"
    ],
    [
        "breaketh",
        "break-eth"
    ],
    [
        "cedar-trees",
        "ce-dar_trees"
    ],
    [
        "cedars",
        "cedars"
    ],
    [
        "lebanon",
        "le-ba-non"
    ],
    [
        "skip",
        "skip"
    ],
    [
        "calf",
        "calf"
    ],
    [
        "sirion",
        "sir-ion"
    ],
    [
        "young",
        "young"
    ],
    [
        "unicorn",
        "u-ni-corn"
    ],
    [
        "divideth",
        "di-vi-deth"
    ],
    [
        "flames",
        "flames"
    ],
    [
        "shaketh",
        "shak-eth"
    ],
    [
        "wilderness",
        "wil-der-ness"
    ],
    [
        "kadesh",
        "ka-desh"
    ],
    [
        "hinds",
        "hinds"
    ],
    [
        "strippeth",
        "strip-peth"
    ],
    [
        "bare",
        "bare"
    ],
    [
        "forests",
        "for-ests"
    ],
    [
        "water-flood",
        "wa-ter_flood"
    ],
    [
        "remaineth",
        "re-main-eth"
    ],
    [
        "cried",
        "cried"
    ],
    [
        "healed",
        "healed"
    ],
    [
        "holiness",
        "ho-li-ness"
    ],
    [
        "twinkling",
        "twink-ling"
    ],
    [
        "heaviness",
        "hea-vi-ness"
    ],
    [
        "gat",
        "gat"
    ],
    [
        "humbly",
        "humb-ly"
    ],
    [
        "profit",
        "pro-fit"
    ],
    [
        "sackcloth",
        "sack-cloth"
    ],
    [
        "ceasing",
        "ceas-ing"
    ],
    [
        "castle",
        "cas-tle"
    ],
    [
        "draw",
        "draw"
    ],
    [
        "commend",
        "com-mend"
    ],
    [
        "spirit",
        "spi-rit"
    ],
    [
        "redeemed",
        "re-deemed"
    ],
    [
        "lying",
        "ly-ing"
    ],
    [
        "vanities",
        "va-ni-ties"
    ],
    [
        "considered",
        "con-sid-ered"
    ],
    [
        "adversities",
        "ad-ver-si-ties"
    ],
    [
        "large",
        "large"
    ],
    [
        "consumed",
        "con-sumed"
    ],
    [
        "waxen",
        "wax-en"
    ],
    [
        "years",
        "years"
    ],
    [
        "mourning",
        "mourn-ing"
    ],
    [
        "faileth",
        "fail-eth"
    ],
    [
        "became",
        "be-came"
    ],
    [
        "reproach",
        "rep-roach"
    ],
    [
        "especially",
        "es-pe-cial-ly"
    ],
    [
        "acquaintance",
        "ac-quain-tance"
    ],
    [
        "conveyed",
        "con-veyed"
    ],
    [
        "dead",
        "dead"
    ],
    [
        "blasphemy",
        "blas-phe-my"
    ],
    [
        "conspire",
        "con-spire"
    ],
    [
        "silence",
        "si-lence"
    ],
    [
        "grave",
        "grave"
    ],
    [
        "cruelly",
        "cruel-ly"
    ],
    [
        "disdainfully",
        "dis-dain-ful-ly"
    ],
    [
        "despitefully",
        "des-pite-ful-ly"
    ],
    [
        "plentiful",
        "plen-ti-ful"
    ],
    [
        "covert",
        "co-vert"
    ],
    [
        "plottings",
        "plot-tings"
    ],
    [
        "strife",
        "strife"
    ],
    [
        "tongues",
        "tongues"
    ],
    [
        "showed",
        "showed"
    ],
    [
        "city",
        "ci-ty"
    ],
    [
        "nevertheless",
        "ne-ver-the-less"
    ],
    [
        "heardest",
        "heard-est"
    ],
    [
        "plenteously",
        "plent-eous-ly"
    ],
    [
        "rewardeth",
        "re-ward-eth"
    ],
    [
        "doer",
        "do-er"
    ],
    [
        "establish",
        "est-ab-lish"
    ],
    [
        "unrighteousness",
        "un-right-eous-ness"
    ],
    [
        "forgiven",
        "for-gi-ven"
    ],
    [
        "covered",
        "co-vered"
    ],
    [
        "imputeth",
        "im-put-eth"
    ],
    [
        "guile",
        "guile"
    ],
    [
        "whilst",
        "whilst"
    ],
    [
        "held",
        "held"
    ],
    [
        "daily",
        "dai-ly"
    ],
    [
        "complaining",
        "com-plain-ing"
    ],
    [
        "heavy",
        "hea-vy"
    ],
    [
        "moisture",
        "mois-ture"
    ],
    [
        "drought",
        "drought"
    ],
    [
        "summer",
        "sum-mer"
    ],
    [
        "acknowledged",
        "ack-now-ledged"
    ],
    [
        "confess",
        "con-fess"
    ],
    [
        "forgavest",
        "for-gav-est"
    ],
    [
        "found",
        "found"
    ],
    [
        "water-floods",
        "wa-ter_floods"
    ],
    [
        "nigh",
        "nigh"
    ],
    [
        "deliverance",
        "de-li-ver-ance"
    ],
    [
        "inform",
        "in-form"
    ],
    [
        "wherein",
        "where-in"
    ],
    [
        "horse",
        "horse"
    ],
    [
        "mule",
        "mule"
    ],
    [
        "understanding",
        "un-der-stan-ding"
    ],
    [
        "must",
        "must"
    ],
    [
        "bit",
        "bit"
    ],
    [
        "bridle",
        "bri-dle"
    ],
    [
        "else",
        "else"
    ],
    [
        "plagues",
        "plagues"
    ],
    [
        "remain",
        "re-main"
    ],
    [
        "embraceth",
        "em-brac-eth"
    ],
    [
        "becometh",
        "be-com-eth"
    ],
    [
        "well",
        "well"
    ],
    [
        "thankful",
        "thank-ful"
    ],
    [
        "harp",
        "harp"
    ],
    [
        "lute",
        "lute"
    ],
    [
        "instrument",
        "in-stru-ment"
    ],
    [
        "new",
        "new"
    ],
    [
        "lustily",
        "lus-ti-ly"
    ],
    [
        "courage",
        "cou-rage"
    ],
    [
        "gathereth",
        "ga-ther-eth"
    ],
    [
        "heap",
        "heap"
    ],
    [
        "treasure-house",
        "trea-sure_house"
    ],
    [
        "spake",
        "spake"
    ],
    [
        "fast",
        "fast"
    ],
    [
        "bringeth",
        "bring-eth"
    ],
    [
        "nought",
        "nought"
    ],
    [
        "devices",
        "de-vices"
    ],
    [
        "effect",
        "eff-ect"
    ],
    [
        "casteth",
        "cast-eth"
    ],
    [
        "counsels",
        "coun-sels"
    ],
    [
        "princes",
        "prin-ces"
    ],
    [
        "jehovah",
        "je-ho-vah"
    ],
    [
        "folk",
        "folk"
    ],
    [
        "looketh",
        "look-eth"
    ],
    [
        "beholdeth",
        "be-hold-eth"
    ],
    [
        "considereth",
        "con-si-der-eth"
    ],
    [
        "fashioneth",
        "fa-shion-eth"
    ],
    [
        "understandeth",
        "un-der-stand-eth"
    ],
    [
        "saved",
        "saved"
    ],
    [
        "dearth",
        "dearth"
    ],
    [
        "patiently",
        "pa-tient-ly"
    ],
    [
        "tarried",
        "tar-ried"
    ],
    [
        "her",
        "her"
    ],
    [
        "sought",
        "sought"
    ],
    [
        "lightened",
        "light-ened"
    ],
    [
        "faces",
        "fa-ces"
    ],
    [
        "crieth",
        "cri-eth"
    ],
    [
        "heareth",
        "hear-eth"
    ],
    [
        "saveth",
        "sav-eth"
    ],
    [
        "angel",
        "an-gel"
    ],
    [
        "tarrieth",
        "tar-ri-eth"
    ],
    [
        "taste",
        "taste"
    ],
    [
        "trusteth",
        "trust-eth"
    ],
    [
        "lions",
        "li-ons"
    ],
    [
        "hunger",
        "hun-ger"
    ],
    [
        "want",
        "want"
    ],
    [
        "manner",
        "man-ner"
    ],
    [
        "lusteth",
        "lust-eth"
    ],
    [
        "fain",
        "fain"
    ],
    [
        "eschew",
        "es-chew"
    ],
    [
        "ensue",
        "en-sue"
    ],
    [
        "prayers",
        "prayers"
    ],
    [
        "contrite",
        "con-trite"
    ],
    [
        "keepeth",
        "keep-eth"
    ],
    [
        "misfortune",
        "mis-for-tune"
    ],
    [
        "slay",
        "slay"
    ],
    [
        "souls",
        "souls"
    ],
    [
        "servants",
        "ser-vants"
    ],
    [
        "destitute",
        "des-ti-tute"
    ],
    [
        "plead",
        "plead"
    ],
    [
        "strive",
        "strive"
    ],
    [
        "spear",
        "spear"
    ],
    [
        "stop",
        "stop"
    ],
    [
        "pursue",
        "pur-sue"
    ],
    [
        "scattering",
        "scat-ter-ing"
    ],
    [
        "slippery",
        "slip-pe-ry"
    ],
    [
        "sudden",
        "sud-den"
    ],
    [
        "unawares",
        "un-a-wares"
    ],
    [
        "catch",
        "catch"
    ],
    [
        "deliverest",
        "de-li-ver-est"
    ],
    [
        "spoileth",
        "spoil-eth"
    ],
    [
        "charge",
        "charge"
    ],
    [
        "knew",
        "knew"
    ],
    [
        "discomfort",
        "dis-com-fort"
    ],
    [
        "sick",
        "sick"
    ],
    [
        "humbled",
        "hum-bled"
    ],
    [
        "fasting",
        "fast-ing"
    ],
    [
        "bosom",
        "bo-som"
    ],
    [
        "behaved",
        "be-haved"
    ],
    [
        "myself",
        "my-self"
    ],
    [
        "friend",
        "friend"
    ],
    [
        "brother",
        "bro-ther"
    ],
    [
        "heavily",
        "hea-vi-ly"
    ],
    [
        "mourneth",
        "mourn-eth"
    ],
    [
        "rejoiced",
        "re-joiced"
    ],
    [
        "gathered",
        "ga-thered"
    ],
    [
        "abjects",
        "ab-jects"
    ],
    [
        "making",
        "ma-king"
    ],
    [
        "ceased",
        "ceased"
    ],
    [
        "flatterers",
        "flat-ter-ers"
    ],
    [
        "busy",
        "bu-sy"
    ],
    [
        "mockers",
        "mock-ers"
    ],
    [
        "gnashed",
        "gnashed"
    ],
    [
        "calamities",
        "ca-la-mi-ties"
    ],
    [
        "wink",
        "wink"
    ],
    [
        "communing",
        "com-mun-ing"
    ],
    [
        "quiet",
        "qui-et"
    ],
    [
        "gaped",
        "gaped"
    ],
    [
        "fie",
        "fie"
    ],
    [
        "saw",
        "saw"
    ],
    [
        "quarrel",
        "quar-rel"
    ],
    [
        "avenge",
        "a-venge"
    ],
    [
        "devoured",
        "de-voured"
    ],
    [
        "clothed",
        "clothed"
    ],
    [
        "dishonour",
        "dis-hon-our"
    ],
    [
        "talking",
        "talk-ing"
    ],
    [
        "flattereth",
        "flat-ter-eth"
    ],
    [
        "unrighteous",
        "un-right-eous"
    ],
    [
        "behave",
        "be-have"
    ],
    [
        "wisely",
        "wise-ly"
    ],
    [
        "imagineth",
        "i-ma-gin-eth"
    ],
    [
        "reacheth",
        "reach-eth"
    ],
    [
        "mountains",
        "moun-tains"
    ],
    [
        "beast",
        "beast"
    ],
    [
        "plenteousness",
        "plen-teous-ness"
    ],
    [
        "pleasures",
        "plea-sures"
    ],
    [
        "river",
        "ri-ver"
    ],
    [
        "continue",
        "con-tin-ue"
    ],
    [
        "pride",
        "pride"
    ],
    [
        "fret",
        "fret"
    ],
    [
        "envious",
        "en-vi-ous"
    ],
    [
        "cut",
        "cut"
    ],
    [
        "grass",
        "grass"
    ],
    [
        "withered",
        "with-ered"
    ],
    [
        "herb",
        "herb"
    ],
    [
        "doing",
        "do-ing"
    ],
    [
        "fed",
        "fed"
    ],
    [
        "commit",
        "com-mit"
    ],
    [
        "pass",
        "pass"
    ],
    [
        "clear",
        "clear"
    ],
    [
        "noon-day",
        "noon_day"
    ],
    [
        "abide",
        "ab-ide"
    ],
    [
        "grieve",
        "grieve"
    ],
    [
        "moved",
        "moved"
    ],
    [
        "rooted",
        "root-ed"
    ],
    [
        "those",
        "those"
    ],
    [
        "meek-spirited",
        "meek_spi-ri-ted"
    ],
    [
        "possess",
        "pos-sess"
    ],
    [
        "refreshed",
        "re-freshed"
    ],
    [
        "seeketh",
        "seek-eth"
    ],
    [
        "gnasheth",
        "gnash-eth"
    ],
    [
        "to-scorn",
        "to_scorn"
    ],
    [
        "coming",
        "com-ing"
    ],
    [
        "drawn",
        "drawn"
    ],
    [
        "better",
        "bet-ter"
    ],
    [
        "riches",
        "rich-es"
    ],
    [
        "upholdeth",
        "up-hold-eth"
    ],
    [
        "perilous",
        "pe-ri-lous"
    ],
    [
        "lambs",
        "lambs"
    ],
    [
        "borroweth",
        "bor-row-eth"
    ],
    [
        "payeth",
        "pay-eth"
    ],
    [
        "liberal",
        "lib-er-al"
    ],
    [
        "cursed",
        "cursed"
    ],
    [
        "ordereth",
        "or-der-eth"
    ],
    [
        "mans",
        "mans"
    ],
    [
        "going",
        "go-ing"
    ],
    [
        "begging",
        "beg-ging"
    ],
    [
        "lendeth",
        "len-deth"
    ],
    [
        "forsaketh",
        "for-sak-eth"
    ],
    [
        "preserved",
        "pre-ser-ved"
    ],
    [
        "punished",
        "pun-ished"
    ],
    [
        "exercised",
        "ex-er-cised"
    ],
    [
        "watcheth",
        "watch-eth"
    ],
    [
        "occasion",
        "oc-ca-sion"
    ],
    [
        "condemn",
        "con-demn"
    ],
    [
        "promote",
        "pro-mote"
    ],
    [
        "flourishing",
        "flour-ish-ing"
    ],
    [
        "bay-tree",
        "bay_tree"
    ],
    [
        "could",
        "could"
    ],
    [
        "heed",
        "heed"
    ],
    [
        "last",
        "last"
    ],
    [
        "transgressors",
        "trans-gres-sors"
    ],
    [
        "anger",
        "an-ger"
    ],
    [
        "stick",
        "stick"
    ],
    [
        "presseth",
        "press-eth"
    ],
    [
        "reason",
        "rea-son"
    ],
    [
        "wickednesses",
        "wick-ed-ness-es"
    ],
    [
        "burden",
        "bur-den"
    ],
    [
        "wounds",
        "wounds"
    ],
    [
        "stink",
        "stink"
    ],
    [
        "foolishness",
        "fool-ish-ness"
    ],
    [
        "loins",
        "loins"
    ],
    [
        "filled",
        "filled"
    ],
    [
        "disease",
        "dis-ease"
    ],
    [
        "feeble",
        "fee-ble"
    ],
    [
        "smitten",
        "smit-ten"
    ],
    [
        "roared",
        "roar-ed"
    ],
    [
        "disquietness",
        "dis-qui-et-ness"
    ],
    [
        "knowest",
        "know-est"
    ],
    [
        "panteth",
        "pan-teth"
    ],
    [
        "lovers",
        "lov-ers"
    ],
    [
        "kinsmen",
        "kins-men"
    ],
    [
        "afar",
        "af-ar"
    ],
    [
        "deaf",
        "deaf"
    ],
    [
        "dumb",
        "dumb"
    ],
    [
        "reproofs",
        "re-proofs"
    ],
    [
        "answer",
        "an-swer"
    ],
    [
        "required",
        "re-quired"
    ],
    [
        "slipt",
        "slipt"
    ],
    [
        "greatly",
        "great-ly"
    ],
    [
        "truly",
        "tru-ly"
    ],
    [
        "plague",
        "plague"
    ],
    [
        "sorry",
        "sor-ry"
    ],
    [
        "wrongfully",
        "wrong-ful-ly"
    ],
    [
        "number",
        "num-ber"
    ],
    [
        "pain",
        "pain"
    ],
    [
        "grief",
        "grief"
    ],
    [
        "hot",
        "hot"
    ],
    [
        "thus",
        "thus"
    ],
    [
        "musing",
        "mus-ing"
    ],
    [
        "certified",
        "cer-ti-fied"
    ],
    [
        "span",
        "span"
    ],
    [
        "age",
        "age"
    ],
    [
        "respect",
        "res-pect"
    ],
    [
        "disquieteth",
        "dis-qui-et-eth"
    ],
    [
        "heapeth",
        "heap-eth"
    ],
    [
        "cannot",
        "can-not"
    ],
    [
        "gather",
        "gath-er"
    ],
    [
        "opened",
        "o-pened"
    ],
    [
        "means",
        "means"
    ],
    [
        "rebukes",
        "re-bukes"
    ],
    [
        "dost",
        "dost"
    ],
    [
        "moth",
        "moth"
    ],
    [
        "fretting",
        "frett-ing"
    ],
    [
        "garment",
        "gar-ment"
    ],
    [
        "stranger",
        "stran-ger"
    ],
    [
        "sojourner",
        "so-jour-ner"
    ],
    [
        "spare",
        "spare"
    ],
    [
        "recover",
        "re-co-ver"
    ],
    [
        "hence",
        "hence"
    ],
    [
        "waited",
        "wait-ed"
    ],
    [
        "inclined",
        "in-clined"
    ],
    [
        "horrible",
        "hor-ri-ble"
    ],
    [
        "mire",
        "mire"
    ],
    [
        "ordered",
        "or-dered"
    ],
    [
        "us-ward",
        "us_ward"
    ],
    [
        "express",
        "ex-press"
    ],
    [
        "offering",
        "off-er-ing"
    ],
    [
        "wouldest",
        "would-est"
    ],
    [
        "burnt-offering",
        "burnt_off-er-ing"
    ],
    [
        "volume",
        "vol-ume"
    ],
    [
        "book",
        "book"
    ],
    [
        "written",
        "writ-ten"
    ],
    [
        "content",
        "con-tent"
    ],
    [
        "declared",
        "de-clared"
    ],
    [
        "refrain",
        "re-frain"
    ],
    [
        "withdraw",
        "with-draw"
    ],
    [
        "innumerable",
        "in-nu-me-ra-ble"
    ],
    [
        "hairs",
        "hairs"
    ],
    [
        "backward",
        "back-ward"
    ],
    [
        "wish",
        "wish"
    ],
    [
        "tarrying",
        "tar-ry-ing"
    ],
    [
        "alive",
        "a-live"
    ],
    [
        "sickness",
        "sick-ness"
    ],
    [
        "sinned",
        "sinned"
    ],
    [
        "die",
        "die"
    ],
    [
        "conceiveth",
        "con-ceiv-eth"
    ],
    [
        "whisper",
        "whis-per"
    ],
    [
        "familiar",
        "fa-mi-li-ar"
    ],
    [
        "raise",
        "raise"
    ],
    [
        "favourest",
        "fa-vour-est"
    ],
    [
        "upholdest",
        "up-hold-est"
    ],
    [
        "amen",
        "a-men"
    ],
    [
        "hart",
        "hart"
    ],
    [
        "desireth",
        "de-sir-eth"
    ],
    [
        "water-brooks",
        "wa-ter_brooks"
    ],
    [
        "longeth",
        "long-eth"
    ],
    [
        "athirst",
        "a-thirst"
    ],
    [
        "appear",
        "ap-pear"
    ],
    [
        "meat",
        "meat"
    ],
    [
        "thereupon",
        "there-up-on"
    ],
    [
        "pour",
        "pour"
    ],
    [
        "holy-day",
        "ho-ly_day"
    ],
    [
        "disquieted",
        "dis-qui-et-ed"
    ],
    [
        "jordan",
        "jor-dan"
    ],
    [
        "hermon",
        "her-mon"
    ],
    [
        "calleth",
        "call-eth"
    ],
    [
        "noise",
        "noise"
    ],
    [
        "waves",
        "waves"
    ],
    [
        "storms",
        "storms"
    ],
    [
        "daytime",
        "day-time"
    ],
    [
        "oppresseth",
        "op-press-eth"
    ],
    [
        "namely",
        "name-ly"
    ],
    [
        "told",
        "told"
    ],
    [
        "flourish",
        "flou-rish"
    ],
    [
        "arm",
        "arm"
    ],
    [
        "hadst",
        "hadst"
    ],
    [
        "overthrow",
        "o-ver-throw"
    ],
    [
        "savest",
        "sav-est"
    ],
    [
        "puttest",
        "putt-est"
    ],
    [
        "goest",
        "goest"
    ],
    [
        "armies",
        "arm-ies"
    ],
    [
        "spoil",
        "spoil"
    ],
    [
        "goods",
        "goods"
    ],
    [
        "lettest",
        "lett-est"
    ],
    [
        "sellest",
        "sell-est"
    ],
    [
        "takest",
        "tak-est"
    ],
    [
        "laughed",
        "laughed"
    ],
    [
        "by-word",
        "by_word"
    ],
    [
        "slanderer",
        "slan-der-er"
    ],
    [
        "blasphemer",
        "blas-phe-mer"
    ],
    [
        "ourselves",
        "our-selves"
    ],
    [
        "frowardly",
        "fro-ward-ly"
    ],
    [
        "steps",
        "steps"
    ],
    [
        "dragons",
        "dra-gons"
    ],
    [
        "holden",
        "hold-en"
    ],
    [
        "strange",
        "strange"
    ],
    [
        "secrets",
        "sec-rets"
    ],
    [
        "killed",
        "killed"
    ],
    [
        "appointed",
        "ap-poin-ted"
    ],
    [
        "slain",
        "slain"
    ],
    [
        "sleepest",
        "sleep-est"
    ],
    [
        "absent",
        "ab-sent"
    ],
    [
        "forgettest",
        "for-gett-est"
    ],
    [
        "belly",
        "bel-ly"
    ],
    [
        "overfloweth",
        "ov-er-flow-eth"
    ],
    [
        "concerning",
        "con-cer-ning"
    ],
    [
        "pen",
        "pen"
    ],
    [
        "writer",
        "wri-ter"
    ],
    [
        "fairer",
        "fair-er"
    ],
    [
        "grace",
        "grace"
    ],
    [
        "gird",
        "gird"
    ],
    [
        "thigh",
        "thigh"
    ],
    [
        "renown",
        "re-nown"
    ],
    [
        "luck",
        "luck"
    ],
    [
        "ride",
        "ride"
    ],
    [
        "meekness",
        "meek-ness"
    ],
    [
        "terrible",
        "ter-ri-ble"
    ],
    [
        "sharp",
        "sharp"
    ],
    [
        "kings",
        "kings"
    ],
    [
        "subdued",
        "sub-dued"
    ],
    [
        "sceptre",
        "scep-tre"
    ],
    [
        "fellows",
        "fel-lows"
    ],
    [
        "smell",
        "smell"
    ],
    [
        "myrrh",
        "myrrh"
    ],
    [
        "aloes",
        "al-oes"
    ],
    [
        "cassia",
        "cas-si-a"
    ],
    [
        "ivory",
        "i-vo-ry"
    ],
    [
        "palaces",
        "pa-la-ces"
    ],
    [
        "whereby",
        "where-by"
    ],
    [
        "kings",
        "kings"
    ],
    [
        "daughters",
        "daugh-ters"
    ],
    [
        "honourable",
        "ho-nou-ra-ble"
    ],
    [
        "women",
        "wo-men"
    ],
    [
        "queen",
        "queen"
    ],
    [
        "wrought",
        "wrought"
    ],
    [
        "divers",
        "di-vers"
    ],
    [
        "colours",
        "col-ours"
    ],
    [
        "fathers",
        "fa-thers"
    ],
    [
        "tyre",
        "tyre"
    ],
    [
        "gift",
        "gift"
    ],
    [
        "rich",
        "rich"
    ],
    [
        "supplication",
        "supp-li-ca-tion"
    ],
    [
        "clothing",
        "clo-thing"
    ],
    [
        "raiment",
        "rai-ment"
    ],
    [
        "needlework",
        "nee-dle-work"
    ],
    [
        "virgins",
        "vir-gins"
    ],
    [
        "company",
        "com-pa-ny"
    ],
    [
        "enter",
        "en-ter"
    ],
    [
        "palace",
        "pa-lace"
    ],
    [
        "instead",
        "in-stead"
    ],
    [
        "remembered",
        "re-mem-bered"
    ],
    [
        "present",
        "pre-sent"
    ],
    [
        "carried",
        "car-ried"
    ],
    [
        "swell",
        "swell"
    ],
    [
        "streams",
        "streams"
    ],
    [
        "whereof",
        "where-of"
    ],
    [
        "ado",
        "ado"
    ],
    [
        "kingdoms",
        "king-doms"
    ],
    [
        "melt",
        "melt"
    ],
    [
        "hither",
        "hi-ther"
    ],
    [
        "wars",
        "wars"
    ],
    [
        "cease",
        "cease"
    ],
    [
        "knappeth",
        "knapp-eth"
    ],
    [
        "sunder",
        "sun-der"
    ],
    [
        "burneth",
        "burn-eth"
    ],
    [
        "clap",
        "clap"
    ],
    [
        "melody",
        "me-lo-dy"
    ],
    /////////
    [
        "feared",
        "feared"
    ],
    [
        "subdue",
        "sub-due"
    ],
    [
        "excellency",
        "ex-cell-en-cy"
    ],
    [
        "merry",
        "mer-ry"
    ],
    [
        "trump",
        "trump"
    ],
    [
        "reigneth",
        "reign-eth"
    ],
    [
        "joined",
        "joined"
    ],
    [
        "abraham",
        "ab-ra-ham"
    ],
    [
        "highly",
        "high-ly"
    ],
    [
        "north",
        "north"
    ],
    [
        "marvelled",
        "mar-velled"
    ],
    [
        "astonished",
        "as-ton-ished"
    ],
    [
        "sorrow",
        "sor-row"
    ],
    [
        "woman",
        "wo-man"
    ],
    [
        "ships",
        "ships"
    ],
    [
        "east-wind",
        "east_wind"
    ],
    [
        "worlds",
        "worlds"
    ],
    [
        "mount",
        "mount"
    ],
    [
        "judah",
        "ju-dah"
    ],
    [
        "towers",
        "tow-ers"
    ],
    [
        "mark",
        "mark"
    ],
    [
        "bulwarks",
        "bul-warks"
    ],
    [
        "muse",
        "muse"
    ],
    [
        "parable",
        "pa-ra-ble"
    ],
    [
        "heels",
        "heels"
    ],
    [
        "compasseth",
        "com-pass-eth"
    ],
    [
        "ransom",
        "ran-som"
    ],
    [
        "for",
        "for"
    ],
    ////////
    [
        "cost",
        "cost"
    ],
    [
        "redeem",
        "re-deem"
    ],
    [
        "alone",
        "a-lone"
    ],
    [
        "ever",
        "ev-er"
    ],
    [
        "ignorant",
        "ig-no-rant"
    ],
    [
        "houses",
        "hou-ses"
    ],
    [
        "dwelling-places",
        "dwell-ing_pla-ces"
    ],
    [
        "being",
        "be-ing"
    ],
    [
        "abideth",
        "ab-id-eth"
    ],
    [
        "seeing",
        "see-ing"
    ],
    [
        "compared",
        "comp-ared"
    ],
    [
        "posterity",
        "pos-te-ri-ty"
    ],
    [
        "carry",
        "car-ry"
    ],
    [
        "dieth",
        "di-eth"
    ],
    [
        "pomp",
        "pomp"
    ],
    [
        "lived",
        "lived"
    ],
    [
        "happy",
        "hap-py"
    ],
    [
        "doest",
        "do-est"
    ],
    [
        "spoken",
        "spo-ken"
    ],
    [
        "rising",
        "ris-ing"
    ],
    [
        "appeared",
        "ap-peared"
    ],
    [
        "stirred",
        "stirred"
    ],
    [
        "testify",
        "tes-ti-fy"
    ],
    [
        "reprove",
        "re-prove"
    ],
    [
        "sacrifices",
        "sac-ri-fi-ces"
    ],
    [
        "burnt-offerings",
        "burnt_off-er-ings"
    ],
    [
        "bullock",
        "bull-ock"
    ],
    [
        "he-goats",
        "he_goats"
    ],
    [
        "folds",
        "folds"
    ],
    [
        "forest",
        "for-est"
    ],
    [
        "cattle",
        "cat-tle"
    ],
    [
        "thousand",
        "thou-sand"
    ],
    [
        "wild",
        "wild"
    ],
    [
        "hungry",
        "hun-gry"
    ],
    [
        "thinkest",
        "think-est"
    ],
    [
        "bulls",
        "bulls"
    ],
    [
        "goats",
        "goats"
    ],
    [
        "preach",
        "preach"
    ],
    [
        "whereas",
        "where-as"
    ],
    [
        "reformed",
        "re-formed"
    ],
    [
        "behind",
        "be-hind"
    ],
    [
        "sawest",
        "saw-est"
    ],
    [
        "thief",
        "thief"
    ],
    [
        "consentedst",
        "con-sent-edst"
    ],
    [
        "partaker",
        "par-tak-er"
    ],
    [
        "adulterers",
        "ad-ult-er-ers"
    ],
    [
        "sattest",
        "satt-est"
    ],
    [
        "spakest",
        "spak-est"
    ],
    [
        "thoughtest",
        "thought-est"
    ],
    [
        "wickedly",
        "wick-ed-ly"
    ],
    [
        "offereth",
        "off-er-eth"
    ],
    [
        "honoureth",
        "hon-our-eth"
    ],
    [
        "aright",
        "a-right"
    ],
    [
        "throughly",
        "through-ly"
    ],
    [
        "acknowledge",
        "ack-now-ledge"
    ],
    [
        "justified",
        "jus-ti-fied"
    ],
    [
        "shapen",
        "sha-pen"
    ],
    [
        "requirest",
        "re-quir-est"
    ],
    [
        "purge",
        "purge"
    ],
    [
        "hyssop",
        "hys-sop"
    ],
    [
        "whiter",
        "whi-ter"
    ],
    [
        "snow",
        "snow"
    ],
    [
        "misdeeds",
        "mis-deeds"
    ],
    [
        "renew",
        "re-new"
    ],
    [
        "stablish",
        "stab-lish"
    ],
    [
        "free",
        "free"
    ],
    [
        "converted",
        "con-ver-ted"
    ],
    [
        "blood-guiltiness",
        "blood_guil-ti-ness"
    ],
    [
        "desirest",
        "de-sir-est"
    ],
    [
        "delightest",
        "de-light-est"
    ],
    [
        "despise",
        "des-pise"
    ],
    [
        "walls",
        "walls"
    ],
    [
        "jerusalem",
        "je-ru-sa-lem"
    ],
    [
        "pleased",
        "pleased"
    ],
    [
        "oblations",
        "ob-la-tions"
    ],
    [
        "bullocks",
        "bull-ocks"
    ],
    [
        "boastest",
        "boast-est"
    ],
    [
        "tyrant",
        "ty-rant"
    ],
    [
        "canst",
        "canst"
    ],
    [
        "cuttest",
        "cutt-est"
    ],
    [
        "razor",
        "ra-zor"
    ],
    [
        "hurt",
        "hurt"
    ],
    [
        "strengthened",
        "strength-en-ed"
    ],
    [
        "olive-tree",
        "ol-ive_tree"
    ],
    [
        "besieged",
        "be-sieged"
    ],
    [
        "tyrants",
        "ty-rants"
    ],
    [
        "uphold",
        "up-hold"
    ],
    [
        "comfortable",
        "com-for-ta-ble"
    ],
    [
        "mourn",
        "mourn"
    ],
    [
        "minded",
        "min-ded"
    ],
    [
        "maliciously",
        "ma-li-cious-ly"
    ],
    [
        "fearfulness",
        "fear-ful-ness"
    ],
    [
        "dread",
        "dread"
    ],
    [
        "overwhelmed",
        "ov-er-whelmed"
    ],
    [
        "dove",
        "dove"
    ],
    [
        "escape",
        "es-cape"
    ],
    [
        "stormy",
        "stor-my"
    ],
    [
        "divide",
        "di-vide"
    ],
    [
        "spied",
        "spied"
    ],
    [
        "borne",
        "borne"
    ],
    [
        "adversary",
        "ad-ver-sa-ry"
    ],
    [
        "peradventure",
        "per-ad-ven-ture"
    ],
    [
        "companion",
        "com-pan-ion"
    ],
    [
        "sweet",
        "sweet"
    ],
    [
        "friends",
        "friends"
    ],
    [
        "hastily",
        "has-ti-ly"
    ],
    [
        "dwellings",
        "dwell-ings"
    ],
    [
        "evening",
        "eve-ning"
    ],
    [
        "pray",
        "pray"
    ],
    [
        "instantly",
        "in-stant-ly"
    ],
    [
        "strove",
        "strove"
    ],
    [
        "brake",
        "brake"
    ],
    [
        "softer",
        "sof-ter"
    ],
    [
        "butter",
        "but-ter"
    ],
    [
        "having",
        "hav-ing"
    ],
    [
        "smoother",
        "smooth-er"
    ],
    [
        "swords",
        "swords"
    ],
    [
        "nourish",
        "nour-ish"
    ],
    [
        "half",
        "half"
    ],
    [
        "fighting",
        "fight-ing"
    ],
    [
        "troubling",
        "troubl-ing"
    ],
    [
        "swallow",
        "swal-low"
    ],
    /////////
    [
        "sometime",
        "some-time"
    ],
    [
        "mistake",
        "mis-take"
    ],
    [
        "tellest",
        "tell-est"
    ],
    [
        "wanderings",
        "wan-der-ings"
    ],
    [
        "bottle",
        "bot-tle"
    ],
    [
        "noted",
        "not-ed"
    ],
    [
        "whensoever",
        "when-so-ev-er"
    ],
    [
        "gods",
        "gods"
    ],
    [
        "falling",
        "fall-ing"
    ],
    [
        "tyranny",
        "ty-ran-ny"
    ],
    [
        "overpast",
        "ov-er-past"
    ],
    [
        "reproof",
        "re-proof"
    ],
    [
        "spears",
        "spears"
    ],
    [
        "pressed",
        "pressed"
    ],
    [
        "fixed",
        "fixed"
    ],
    [
        "greatness",
        "great-ness"
    ],
    [
        "minds",
        "minds"
    ],
    [
        "deal",
        "deal"
    ],
    [
        "astray",
        "as-tray"
    ],
    [
        "venomous",
        "ve-no-mous"
    ],
    [
        "poison",
        "poi-son"
    ],
    [
        "serpent",
        "ser-pent"
    ],
    [
        "adder",
        "add-er"
    ],
    [
        "stoppeth",
        "stopp-eth"
    ],
    [
        "refuseth",
        "re-fus-eth"
    ],
    [
        "charmer",
        "char-mer"
    ],
    [
        "charm",
        "charm"
    ],
    [
        "jaw-bones",
        "jaw_bones"
    ],
    [
        "apace",
        "ap-ace"
    ],
    [
        "snail",
        "snail"
    ],
    [
        "untimely",
        "un-time-ly"
    ],
    [
        "pots",
        "pots"
    ],
    [
        "thorns",
        "thorns"
    ],
    [
        "whirlwind",
        "whirl-wind"
    ],
    [
        "burning",
        "burn-ing"
    ],
    [
        "alike",
        "a-like"
    ],
    [
        "vengeance",
        "ven-geance"
    ],
    [
        "doubtless",
        "doubt-less"
    ],
    [
        "judgeth",
        "judg-eth"
    ],
    [
        "fault",
        "fault"
    ],
    [
        "fro",
        "fro"
    ],
    [
        "grin",
        "grin"
    ],
    [
        "scatter",
        "scat-ter"
    ],
    [
        "abroad",
        "a-broad"
    ],
    [
        "return",
        "re-turn"
    ],
    [
        "here",
        "here"
    ],
    [
        "grudge",
        "grudge"
    ],
    [
        "displeased",
        "dis-pleased"
    ],
    [
        "divided",
        "di-vi-ded"
    ],
    [
        "sores",
        "sores"
    ],
    [
        "deadly",
        "dead-ly"
    ],
    [
        "token",
        "to-ken"
    ],
    [
        "beloved",
        "be-lov-ed"
    ],
    [
        "shechem",
        "she-chem"
    ],
    [
        "mete",
        "mete"
    ],
    [
        "succoth",
        "succ-oth"
    ],
    [
        "gilead",
        "gi-le-ad"
    ],
    [
        "manasseh",
        "ma-na-sseh"
    ],
    [
        "ephraim",
        "eph-ra-im"
    ],
    [
        "law-giver",
        "law_gi-ver"
    ],
    [
        "moab",
        "mo-ab"
    ],
    [
        "wash-pot",
        "wash_pot"
    ],
    [
        "edom",
        "e-dom"
    ],
    [
        "shoe",
        "shoe"
    ],
    [
        "philistia",
        "phil-is-ti-a"
    ],
    [
        "acts",
        "acts"
    ],
    [
        "crying",
        "cry-ing"
    ],
    [
        "higher",
        "high-er"
    ],
    [
        "tower",
        "tow-er"
    ],
    [
        "covering",
        "co-ver-ing"
    ],
    [
        "desires",
        "de-sires"
    ],
    [
        "throughout",
        "through-out"
    ],
    [
        "generations",
        "gen-er-a-tions"
    ],
    [
        "waiteth",
        "wait-eth"
    ],
    [
        "sort",
        "sort"
    ],
    [
        "tottering",
        "tot-ter-ing"
    ],
    [
        "hedge",
        "hedge"
    ],
    [
        "exalt",
        "ex-alt"
    ],
    [
        "curse",
        "curse"
    ],
    [
        "weights",
        "weights"
    ],
    [
        "lighter",
        "light-er"
    ],
    [
        "itself",
        "it-self"
    ],
    [
        "robbery",
        "robb-e-ry"
    ],
    [
        "yourselves",
        "your-selves"
    ],
    [
        "once",
        "once"
    ],
    [
        "twice",
        "twice"
    ],
    [
        "rewardest",
        "re-ward-est"
    ],
    [
        "thirsteth",
        "thirst-eth"
    ],
    [
        "barren",
        "bar-ren"
    ],
    [
        "dry",
        "dry"
    ],
    [
        "marrow",
        "mar-row"
    ],
    [
        "fatness",
        "fat-ness"
    ],
    [
        "praiseth",
        "prais-eth"
    ],
    [
        "thought",
        "thought"
    ],
    [
        "waking",
        "wak-ing"
    ],
    [
        "hangeth",
        "hang-eth"
    ],
    [
        "upholden",
        "up-hold-en"
    ],
    [
        "edge",
        "edge"
    ],
    [
        "foxes",
        "fox-es"
    ],
    [
        "swear",
        "swear"
    ],
    [
        "commended",
        "com-men-ded"
    ],
    [
        "stopped",
        "stopped"
    ],
    [
        "gathering",
        "gath-er-ing"
    ],
    [
        "insurrection",
        "in-sur-rec-tion"
    ],
    [
        "bitter",
        "bit-ter"
    ],
    [
        "hit",
        "hit"
    ],
    [
        "encourage",
        "en-cour-age"
    ],
    [
        "practise",
        "prac-tise"
    ],
    [
        "swift",
        "swift"
    ],
    [
        "arrow",
        "ar-row"
    ],
    [
        "wounded",
        "woun-ded"
    ],
    [
        "insomuch",
        "in-so-much"
    ],
    [
        "perceive",
        "per-ceive"
    ],
    [
        "vow",
        "vow"
    ],
    [
        "performed",
        "per-formed"
    ],
    [
        "choosest",
        "choos-est"
    ],
    [
        "receivest",
        "re-ceiv-est"
    ],
    [
        "court",
        "court"
    ],
    [
        "wonderful",
        "won-der-ful"
    ],
    [
        "broad",
        "broad"
    ],
    [
        "stilleth",
        "still-eth"
    ],
    [
        "raging",
        "rag-ing"
    ],
    [
        "madness",
        "mad-ness"
    ],
    [
        "tokens",
        "tok-ens"
    ],
    [
        "out-goings",
        "out_go-ings"
    ],
    [
        "blessest",
        "bless-est"
    ],
    [
        "plenteous",
        "plen-te-ous"
    ],
    [
        "providest",
        "pro-vi-dest"
    ],
    [
        "waterest",
        "wa-ter-est"
    ],
    [
        "furrows",
        "furr-ows"
    ],
    [
        "sendest",
        "send-est"
    ],
    [
        "valleys",
        "vall-eys"
    ],
    [
        "soft",
        "soft"
    ],
    [
        "drops",
        "drops"
    ],
    [
        "crownest",
        "crown-est"
    ],
    [
        "year",
        "year"
    ],
    [
        "drop",
        "drop"
    ],
    [
        "holdeth",
        "hold-eth"
    ],
    [
        "suffereth",
        "suff-er-eth"
    ],
    [
        "broughtest",
        "brought-est"
    ],
    [
        "snare",
        "snare"
    ],
    [
        "laidest",
        "laid-est"
    ],
    [
        "sufferedst",
        "suffer-edst"
    ],
    [
        "wealthy",
        "weal-thy"
    ],
    [
        "promised",
        "prom-ised"
    ],
    [
        "burnt-sacrifices",
        "burnt_sac-ri-fi-ces"
    ],
    [
        "incense",
        "in-cense"
    ],
    [
        "rams",
        "rams"
    ],
    [
        "bless",
        "bless"
    ],
    [
        "saving",
        "sav-ing"
    ],
    [
        "righteously",
        "right-eous-ly"
    ],
    [
        "govern",
        "gov-ern"
    ],
    [
        "vanisheth",
        "van-ish-eth"
    ],
    [
        "drive",
        "drive"
    ],
    [
        "melteth",
        "melt-eth"
    ],
    [
        "rideth",
        "rid-eth"
    ],
    [
        "jah",
        "jah"
    ],
    [
        "defendeth",
        "de-fend-eth"
    ],
    [
        "widows",
        "wid-ows"
    ],
    [
        "prisoners",
        "pris-on-ers"
    ],
    [
        "letteth",
        "let-teth"
    ],
    [
        "runagates",
        "run-a-gates"
    ],
    [
        "scarceness",
        "scarce-ness"
    ],
    [
        "wentest",
        "went-est"
    ],
    [
        "dropped",
        "dropped"
    ],
    [
        "sinai",
        "si-nai"
    ],
    [
        "sentest",
        "sent-est"
    ],
    [
        "refreshedst",
        "ref-resh-edst"
    ],
    [
        "tidings",
        "tid-ings"
    ],
    //////
    [
        "discomfited",
        "dis-com-fit-ed"
    ],
    [
        "household",
        "house-hold"
    ],
    [
        "lain",
        "lain"
    ],
    [
        "sheep-folds",
        "sheep_folds"
    ],
    [
        "feathers",
        "feath-ers"
    ],
    [
        "almighty",
        "al-migh-ty"
    ],
    [
        "white",
        "white"
    ],
    [
        "salmon",
        "sal-mon"
    ],
    [
        "pleaseth",
        "pleas-eth"
    ],
    [
        "twenty",
        "twen-ty"
    ],
    [
        "led",
        "led"
    ],
    [
        "captive",
        "cap-tive"
    ],
    [
        "received",
        "re-ceived"
    ],
    [
        "poureth",
        "pour-eth"
    ],
    [
        "benefits",
        "be-ne-fits"
    ],
    [
        "wound",
        "wound"
    ],
    [
        "hairy",
        "hai-ry"
    ],
    [
        "scalp",
        "scalp"
    ],
    [
        "dipped",
        "dipped"
    ],
    [
        "red",
        "red"
    ],
    [
        "singers",
        "sing-ers"
    ],
    [
        "minstrels",
        "min-strels"
    ],
    [
        "damsels",
        "dam-sels"
    ],
    [
        "playing",
        "play-ing"
    ],
    [
        "timbrels",
        "tim-brels"
    ],
    [
        "fountain",
        "foun-tain"
    ],
    [
        "benjamin",
        "ben-ja-min"
    ],
    [
        "ruler",
        "ru-ler"
    ],
    [
        "zebulon",
        "ze-bu-lon"
    ],
    [
        "naphthali",
        "naph-tha-li"
    ],
    [
        "temples",
        "temples"
    ],
    [
        "presents",
        "pres-ents"
    ],
    [
        "dragon",
        "dra-gon"
    ],
    [
        "bull",
        "bull"
    ],
    [
        "leaders",
        "lead-ers"
    ],
    [
        "egypt",
        "egypt"
    ],
    [
        "morians",
        "mo-ri-ans"
    ],
    [
        "stretch",
        "stretch"
    ],
    [
        "beginning",
        "be-ginn-ing"
    ],
    [
        "guiltless",
        "guilt-less"
    ],
    [
        "paid",
        "paid"
    ],
    [
        "simpleness",
        "sim-ple-ness"
    ],
    [
        "suffered",
        "suff-ered"
    ],
    [
        "alien",
        "a-li-en"
    ],
    [
        "zeal",
        "zeal"
    ],
    [
        "wept",
        "wept"
    ],
    [
        "chastened",
        "chast-ened"
    ],
    [
        "jested",
        "jes-ted"
    ],
    [
        "gate",
        "gate"
    ],
    [
        "drunkards",
        "drunk-ards"
    ],
    [
        "sink",
        "sink"
    ],
    [
        "drown",
        "drown"
    ],
    [
        "pity",
        "pi-ty"
    ],
    [
        "gall",
        "gall"
    ],
    [
        "thirsty",
        "thirs-ty"
    ],
    [
        "vinegar",
        "vi-ne-gar"
    ],
    [
        "withal",
        "with-al"
    ],
    [
        "wealth",
        "wealth"
    ],
    [
        "blinded",
        "blin-ded"
    ],
    [
        "wrathful",
        "wrath-ful"
    ],
    [
        "void",
        "void"
    ],
    [
        "tents",
        "tents"
    ],
    [
        "wiped",
        "wiped"
    ],
    [
        "please",
        "please"
    ],
    [
        "hoofs",
        "hoofs"
    ],
    [
        "despiseth",
        "des-pis-eth"
    ],
    [
        "moveth",
        "mov-eth"
    ],
    [
        "stronghold",
        "strong-hold"
    ],
    [
        "whereunto",
        "where-un-to"
    ],
    [
        "resort",
        "res-ort"
    ],
    [
        "monster",
        "mon-ster"
    ],
    [
        "gray-headed",
        "gray_head-ed"
    ],
    [
        "refresh",
        "ref-resh"
    ],
    [
        "comforted",
        "com-for-ted"
    ],
    [
        "music",
        "mu-sic"
    ],
    [
        "mown",
        "mown"
    ],
    [
        "abundance",
        "ab-un-dance"
    ],
    [
        "lick",
        "lick"
    ],
    [
        "tarshish",
        "tar-shish"
    ],
    [
        "isles",
        "isles"
    ],
    [
        "arabia",
        "a-ra-bi-a"
    ],
    [
        "saba",
        "sa-ba"
    ],
    [
        "service",
        "ser-vice"
    ],
    [
        "dear",
        "dear"
    ],
    [
        "posterities",
        "pos-te-ri-ties"
    ],
    [
        "majesty",
        "ma-jes-ty"
    ],
    [
        "almost",
        "al-most"
    ],
    [
        "treadings",
        "tread-ings"
    ],
    [
        "well-nigh",
        "well_nigh"
    ],
    [
        "grieved",
        "grieved"
    ],
    [
        "peril",
        "pe-ril"
    ],
    [
        "lusty",
        "lus-ty"
    ],
    [
        "plagued",
        "plagued"
    ],
    [
        "cruelty",
        "cruel-ty"
    ],
    [
        "covereth",
        "co-ver-eth"
    ],
    [
        "thereout",
        "there-out"
    ],
    [
        "suck",
        "suck"
    ],
    [
        "advantage",
        "ad-van-tage"
    ],
    [
        "cleansed",
        "cleansed"
    ],
    [
        "washed",
        "washed"
    ],
    [
        "condemned",
        "con-demned"
    ],
    [
        "understood",
        "un-der-stood"
    ],
    [
        "castest",
        "cast-est"
    ],
    [
        "destroyest",
        "des-troy-est"
    ],
    [
        "fearful",
        "fear-ful"
    ],
    [
        "dream",
        "dream"
    ],
    [
        "awaketh",
        "a-wak-eth"
    ],
    [
        "image",
        "im-age"
    ],
    [
        "vanish",
        "van-ish"
    ],
    [
        "comparison",
        "com-pa-ri-son"
    ],
    [
        "unfaithful",
        "un-faith-ful"
    ],
    [
        "purchased",
        "purch-ased"
    ],
    [
        "tribe",
        "tribe"
    ],
    [
        "roar",
        "roar"
    ],
    [
        "banners",
        "ban-ners"
    ],
    [
        "hewed",
        "hewed"
    ],
    [
        "timber",
        "tim-ber"
    ],
    [
        "afore",
        "a-fore"
    ],
    [
        "trees",
        "trees"
    ],
    [
        "carved",
        "carved"
    ],
    [
        "axes",
        "axes"
    ],
    [
        "hammers",
        "ham-mers"
    ],
    [
        "defiled",
        "de-filed"
    ],
    [
        "dwelling-place",
        "dwell-ing_place"
    ],
    [
        "havoc",
        "hav-oc"
    ],
    [
        "burnt",
        "burnt"
    ],
    [
        "prophet",
        "pro-phet"
    ],
    [
        "withdrawest",
        "with-draw-est"
    ],
    [
        "pluckest",
        "pluck-est"
    ],
    [
        "brakest",
        "brak-est"
    ],
    [
        "smotest",
        "smot-est"
    ],
    [
        "leviathan",
        "le-vi-a-than"
    ],
    [
        "fountains",
        "foun-tains"
    ],
    [
        "rocks",
        "rocks"
    ],
    [
        "driedst",
        "driedst"
    ],
    [
        "borders",
        "bor-ders"
    ],
    [
        "winter",
        "win-ter"
    ],
    [
        "blasphemed",
        "blas-phemed"
    ],
    [
        "turtle-dove",
        "tur-tle_dove"
    ],
    [
        "habitations",
        "ha-bi-ta-tions"
    ],
    [
        "blasphemeth",
        "blas-phem-eth"
    ],
    [
        "presumption",
        "pre-sump-tion"
    ],
    [
        "increaseth",
        "in-creas-eth"
    ],
    [
        "inhabiters",
        "in-hab-it-ers"
    ],
    [
        "pillars",
        "pill-ars"
    ],
    [
        "fools",
        "fools"
    ],
    [
        "madly",
        "mad-ly"
    ],
    [
        "stiff",
        "stiff"
    ],
    [
        "neck",
        "neck"
    ],
    [
        "promotion",
        "pro-mo-tion"
    ],
    [
        "east",
        "east"
    ],
    [
        "west",
        "west"
    ],
    [
        "south",
        "south"
    ],
    [
        "mixt",
        "mixt"
    ],
    [
        "dregs",
        "dregs"
    ],
    [
        "salem",
        "sa-lem"
    ],
    [
        "comest",
        "com-est"
    ],
    [
        "robbers",
        "rob-bers"
    ],
    [
        "robbed",
        "robbed"
    ],
    [
        "chariot",
        "cha-ri-ot"
    ],
    [
        "arose",
        "ar-ose"
    ],
    [
        "fierceness",
        "fierce-ness"
    ],
    [
        "promise",
        "prom-ise"
    ],
    [
        "stretched",
        "stretched"
    ],
    [
        "refused",
        "re-fused"
    ],
    [
        "complain",
        "com-plain"
    ],
    [
        "holdest",
        "hold-est"
    ],
    [
        "past",
        "past"
    ],
    [
        "intreated",
        "in-treat-ed"
    ],
    [
        "infirmity",
        "in-fir-mi-ty"
    ],
    [
        "wonders",
        "won-ders"
    ],
    [
        "mightily",
        "migh-ti-ly"
    ],
    [
        "joseph",
        "jo-seph"
    ],
    [
        "depths",
        "depths"
    ],
    [
        "shone",
        "shone"
    ],
    [
        "leddest",
        "ledd-est"
    ],
    [
        "moses",
        "mo-ses"
    ],
    [
        "aaron",
        "aa-ron"
    ],
    [
        "sentences",
        "sen-ten-ces"
    ],
    [
        "forefathers",
        "fore-fathers"
    ],
    [
        "unborn",
        "un-born"
    ],
    [
        "intent",
        "in-tent"
    ],
    [
        "faithless",
        "faith-less"
    ],
    [
        "stubborn",
        "stub-born"
    ],
    [
        "clave",
        "clave"
    ],
    [
        "stedfastly",
        "sted-fast-ly"
    ],
    [
        "harnessed",
        "harn-essed"
    ],
    [
        "carrying",
        "car-ry-ing"
    ],
    [
        "bows",
        "bows"
    ],
    [
        "forgat",
        "for-gat"
    ],
    [
        "zoan",
        "zo-an"
    ],
    [
        "cloud",
        "cloud"
    ],
    [
        "depth",
        "depth"
    ],
    [
        "gushed",
        "gushed"
    ],
    [
        "rivers",
        "ri-vers"
    ],
    [
        "tempted",
        "tempt-ed"
    ],
    [
        "smote",
        "smote"
    ],
    [
        "indeed",
        "in-deed"
    ],
    [
        "flowed",
        "flowed"
    ],
    [
        "provide",
        "pro-vide"
    ],
    [
        "believed",
        "be-lieved"
    ],
    [
        "rained",
        "rained"
    ],
    [
        "manna",
        "man-na"
    ],
    [
        "food",
        "food"
    ],
    [
        "angels",
        "an-gels"
    ],
    [
        "caused",
        "caused"
    ],
    [
        "blow",
        "blow"
    ],
    [
        "southwest-wind",
        "south-west_wind"
    ],
    [
        "feathered",
        "feath-ered"
    ],
    [
        "sand",
        "sand"
    ],
    [
        "disappointed",
        "dis-ap-point-ed"
    ],
    [
        "slew",
        "slew"
    ],
    [
        "wealthiest",
        "wealth-i-est"
    ],
    [
        "inquired",
        "in-quired"
    ],
    [
        "dissembled",
        "dis-sem-bled"
    ],
    [
        "continued",
        "con-tin-ued"
    ],
    [
        "stedfast",
        "sted-fast"
    ],
    [
        "forgave",
        "for-gave"
    ],
    [
        "passeth",
        "pass-eth"
    ],
    [
        "provoke",
        "pro-voke"
    ],
    [
        "desert",
        "des-ert"
    ],
    [
        "miracles",
        "mi-ra-cles"
    ],
    [
        "flies",
        "flies"
    ],
    [
        "frogs",
        "frogs"
    ],
    [
        "caterpillar",
        "ca-ter-pil-lar"
    ],
    [
        "labour",
        "la-bour"
    ],
    [
        "grasshopper",
        "grass-hop-per"
    ],
    [
        "vines",
        "vines"
    ],
    [
        "mulberry-trees",
        "mul-ber-ry-trees"
    ],
    [
        "frost",
        "frost"
    ],
    [
        "flocks",
        "flocks"
    ],
    [
        "thunderbolts",
        "thun-der-bolts"
    ],
    [
        "furiousness",
        "fu-ri-ous-ness"
    ],
    [
        "spared",
        "spared"
    ],
    [
        "pestilence",
        "pes-til-ence"
    ],
    [
        "firstborn",
        "first-born"
    ],
    [
        "principal",
        "prin-ci-pal"
    ],
    [
        "mightiest",
        "migh-ti-est"
    ],
    [
        "ham",
        "ham"
    ],
    [
        "flock",
        "flock"
    ],
    [
        "safely",
        "safe-ly"
    ],
    [
        "mountain",
        "moun-tain"
    ],
    [
        "tribes",
        "tribes"
    ],
    [
        "starting",
        "start-ing"
    ],
    [
        "aside",
        "as-ide"
    ],
    [
        "hill-altars",
        "hill_alt-ars"
    ],
    [
        "images",
        "im-a-ges"
    ],
    [
        "forsook",
        "for-sook"
    ],
    [
        "shiloh",
        "shi-loh"
    ],
    [
        "tent",
        "tent"
    ],
    [
        "pitched",
        "pitched"
    ],
    [
        "enemys",
        "e-ne-mys"
    ],
    [
        "maidens",
        "maid-ens"
    ],
    [
        "marriage",
        "mar-riage"
    ],
    [
        "priests",
        "priests"
    ],
    [
        "lamentation",
        "lam-en-ta-tion"
    ],
    [
        "awaked",
        "a-waked"
    ],
    [
        "drave",
        "drave"
    ],
    [
        "chose",
        "chose"
    ],
    [
        "built",
        "built"
    ],
    [
        "foundation",
        "foun-da-tion"
    ],
    [
        "continually",
        "con-ti-nu-al-ly"
    ],
    [
        "following",
        "fol-low-ing"
    ],
    [
        "ewes",
        "ewes"
    ],
    [
        "ruled",
        "ruled"
    ],
    [
        "prudently",
        "pru-dent-ly"
    ],
    [
        "stones",
        "stones"
    ],
    [
        "bodies",
        "bod-ies"
    ],
    [
        "shed",
        "shed"
    ],
    [
        "bury",
        "bu-ry"
    ],
    [
        "jealousy",
        "jea-lou-sy"
    ],
    [
        "burn",
        "burn"
    ],
    [
        "waste",
        "waste"
    ],
    [
        "servants",
        "ser-vants"
    ],
    [
        "openly",
        "o-pen-ly"
    ],
    [
        "sorrowful",
        "sor-row-ful"
    ],
    [
        "wherewith",
        "where-with"
    ],
    [
        "sevenfold",
        "sev-en-fold"
    ],
    [
        "showing",
        "show-ing"
    ],
    [
        "leadest",
        "lead-est"
    ],
    [
        "sittest",
        "sitt-est"
    ],
    [
        "stir",
        "stir"
    ],
    [
        "prayeth",
        "pray-eth"
    ],
    [
        "feedest",
        "feed-est"
    ],
    [
        "givest",
        "giv-est"
    ],
    [
        "vine",
        "vine"
    ],
    [
        "boughs",
        "boughs"
    ],
    [
        "branches",
        "branch-es"
    ],
    [
        "grapes",
        "grapes"
    ],
    [
        "boar",
        "boar"
    ],
    [
        "wood",
        "wood"
    ],
    [
        "vineyard",
        "vine-yard"
    ],
    [
        "branch",
        "branch"
    ],
    [
        "self",
        "self"
    ],
    [
        "merrily",
        "mer-ri-ly"
    ],
    [
        "cheerful",
        "cheer-ful"
    ],
    [
        "tabret",
        "tab-ret"
    ],
    [
        "trumpet",
        "trum-pet"
    ],
    [
        "solemn",
        "sol-emn"
    ],
    [
        "feast-day",
        "feast_day"
    ],
    [
        "statute",
        "stat-ute"
    ],
    [
        "eased",
        "eased"
    ],
    [
        "shoulder",
        "shoul-der"
    ],
    [
        "calledst",
        "call-edst"
    ],
    [
        "assure",
        "ass-ure"
    ],
    [
        "wide",
        "wide"
    ],
    [
        "fill",
        "fill"
    ],
    [
        "hearts",
        "hearts"
    ],
    [
        "lusts",
        "lusts"
    ],
    [
        "hearkened",
        "heark-en-ed"
    ],
    [
        "haters",
        "hat-ers"
    ],
    [
        "submitted",
        "sub-mit-ted"
    ],
    [
        "endured",
        "en-dured"
    ],
    [
        "finest",
        "fin-est"
    ],
    [
        "wheatflour",
        "wheat-flour"
    ],
    [
        "gods",
        "gods"
    ],
    [
        "need",
        "need"
    ],
    [
        "necessity",
        "ne-ces-si-ty"
    ],
    [
        "murmuring",
        "mur-mur-ing"
    ],
    [
        "craftily",
        "craf-ti-ly"
    ],
    [
        "ones",
        "ones"
    ],
    [
        "consent",
        "con-sent"
    ],
    [
        "confederate",
        "con-fed-er-ate"
    ],
    [
        "tabernacles",
        "ta-ber-na-cles"
    ],
    [
        "edomites",
        "e-dom-ites"
    ],
    [
        "ishmaelites",
        "ish-mael-ites"
    ],
    [
        "moabites",
        "mo-a-bites"
    ],
    [
        "hagarenes",
        "ha-ga-renes"
    ],
    [
        "gebal",
        "ge-bal"
    ],
    [
        "ammon",
        "am-mon"
    ],
    [
        "amalek",
        "a-ma-lek"
    ],
    [
        "philistines",
        "phi-li-stines"
    ],
    [
        "assyria",
        "as-sy-ria"
    ],
    [
        "midianites",
        "mi-di-an-ites"
    ],
    [
        "sisera",
        "si-se-ra"
    ],
    [
        "jabin",
        "ja-bin"
    ],
    [
        "brook",
        "brook"
    ],
    [
        "kishon",
        "ki-shon"
    ],
    [
        "endor",
        "en-dor"
    ],
    [
        "dung",
        "dung"
    ],
    [
        "oreb",
        "or-eb"
    ],
    [
        "zeeb",
        "ze-eb"
    ],
    [
        "zebah",
        "ze-bah"
    ],
    [
        "zalmunna",
        "zal-mun-na"
    ],
    [
        "whirling",
        "whirl-ing"
    ],
    [
        "stubble",
        "stub-ble"
    ],
    [
        "flame",
        "flame"
    ],
    [
        "consumeth",
        "con-sum-eth"
    ],
    [
        "amiable",
        "a-mi-able"
    ],
    [
        "longing",
        "long-ing"
    ],
    [
        "courts",
        "courts"
    ],
    [
        "sparrow",
        "spar-row"
    ],
    [
        "nest",
        "nest"
    ],
    [
        "altars",
        "alt-ars"
    ],
    [
        "praising",
        "prais-ing"
    ],
    [
        "vale",
        "vale"
    ],
    [
        "use",
        "use"
    ],
    [
        "pools",
        "pools"
    ],
    [
        "appeareth",
        "ap-pear-eth"
    ],
    [
        "rather",
        "ra-ther"
    ],
    [
        "door-keeper",
        "door_kee-per"
    ],
    [
        "withhold",
        "with-hold"
    ],
    [
        "quicken",
        "quick-en"
    ],
    [
        "met",
        "met"
    ],
    [
        "kissed",
        "kissed"
    ],
    [
        "each",
        "each"
    ],
    [
        "glorify",
        "glo-ri-fy"
    ],
    [
        "knit",
        "knit"
    ],
    [
        "nethermost",
        "neth-er-most"
    ],
    [
        "violent",
        "vio-lent"
    ],
    [
        "compassion",
        "com-pass-ion"
    ],
    [
        "long-suffering",
        "long_suf-fer-ing"
    ],
    [
        "handmaid",
        "hand-maid"
    ],
    [
        "babylon",
        "ba-by-lon"
    ],
    [
        "ethiopia",
        "eth-i-op-ia"
    ],
    [
        "reported",
        "re-por-ted"
    ],
    [
        "record",
        "re-cord"
    ],
    [
        "writeth",
        "writ-eth"
    ],
    [
        "trumpeters",
        "trump-et-ers"
    ],
    [
        "fresh",
        "fresh"
    ],
    [
        "draweth",
        "draw-eth"
    ],
    [
        "lowest",
        "low-est"
    ],
    [
        "prison",
        "pri-son"
    ],
    [
        "abhorrest",
        "ab-horr-est"
    ],
    [
        "point",
        "point"
    ],
    [
        "terrors",
        "terr-ors"
    ],
    [
        "undone",
        "un-done"
    ],
    [
        "rulest",
        "rul-est"
    ],
    [
        "stillest",
        "still-est"
    ],
    [
        "tabor",
        "ta-bor"
    ],
    [
        "equity",
        "eq-ui-ty"
    ],
    [
        "visions",
        "vis-ions"
    ],
    [
        "saidst",
        "saidst"
    ],
    [
        "violence",
        "vio-lence"
    ],
    [
        "scourges",
        "scour-ges"
    ],
    [
        "alter",
        "al-ter"
    ],
    [
        "witness",
        "wit-ness"
    ],
    [
        "overthrown",
        "ov-er-thrown"
    ],
    [
        "hedges",
        "hed-ges"
    ],
    [
        "victory",
        "vic-to-ry"
    ],
    [
        "shortened",
        "short-ened"
    ],
    [
        "short",
        "short"
    ],
    [
        "swarest",
        "swar-est"
    ],
    [
        "turnest",
        "turn-est"
    ],
    [
        "sayest",
        "say-est"
    ],
    [
        "yesterday",
        "yes-ter-day"
    ],
    [
        "watch",
        "watch"
    ],
    [
        "scatterest",
        "scat-ter-est"
    ],
    [
        "fade",
        "fade"
    ],
    [
        "groweth",
        "grow-eth"
    ],
    [
        "tale",
        "tale"
    ],
    [
        "threescore",
        "three-score"
    ],
    [
        "fourscore",
        "four-score"
    ],
    [
        "regardeth",
        "re-gard-eth"
    ],
    [
        "apply",
        "ap-ply"
    ],
    [
        "satisfy",
        "sat-is-fy"
    ],
    [
        "hunter",
        "hun-ter"
    ],
    [
        "noisome",
        "noi-some"
    ],
    [
        "terror",
        "terr-or"
    ],
    [
        "flieth",
        "fli-eth"
    ],
    [
        "destroyeth",
        "des-troy-eth"
    ],
    [
        "loud",
        "loud"
    ],
    [
        "operations",
        "op-er-a-tions"
    ],
    [
        "unwise",
        "un-wise"
    ],
    [
        "palm-tree",
        "palm_tree"
    ],
    [
        "spread",
        "spread"
    ],
    [
        "cedar",
        "ce-dar"
    ],
    [
        "well-liking",
        "well_li-king"
    ],
    [
        "apparel",
        "ap-pa-rel"
    ],
    [
        "began",
        "be-gan"
    ],
    [
        "horribly",
        "hor-ri-bly"
    ],
    [
        "mightier",
        "migh-ti-er"
    ],
    [
        "deserving",
        "des-erv-ing"
    ],
    [
        "boasting",
        "boast-ing"
    ],
    [
        "widow",
        "wid-ow"
    ],
    [
        "instructeth",
        "in-struct-eth"
    ],
    [
        "chastenest",
        "chast-en-est"
    ],
    [
        "teachest",
        "teach-est"
    ],
    [
        "patience",
        "pa-tience"
    ],
    [
        "comforts",
        "com-forts"
    ],
    [
        "confidence",
        "con-fi-dence"
    ],
    [
        "malice",
        "ma-lice"
    ],
    [
        "heartily",
        "hear-ti-ly"
    ],
    [
        "maker",
        "ma-ker"
    ],
    [
        "to-day",
        "to_day"
    ],
    [
        "harden",
        "har-den"
    ],
    [
        "provocation",
        "pro-vo-ca-tion"
    ],
    [
        "temptation",
        "temp-ta-tion"
    ],
    [
        "forty",
        "for-ty"
    ],
    [
        "err",
        "err"
    ],
    [
        "sware",
        "sware"
    ],
    [
        "telling",
        "tell-ing"
    ],
    [
        "worthily",
        "wor-thi-ly"
    ],
    [
        "praised",
        "praised"
    ],
    [
        "idols",
        "i-dols"
    ],
    [
        "shine",
        "shine"
    ],
    [
        "melted",
        "mel-ted"
    ],
    [
        "sprung",
        "sprung"
    ],
    [
        "true-hearted",
        "true_heart-ed"
    ],
    [
        "gotten",
        "got-ten"
    ],
    [
        "trumpets",
        "trum-pets"
    ],
    [
        "shawms",
        "shawms"
    ],
    [
        "impatient",
        "im-pa-tient"
    ],
    [
        "between",
        "bet-ween"
    ],
    [
        "unquiet",
        "un-qui-et"
    ],
    [
        "executed",
        "ex-e-cut-ed"
    ],
    [
        "footstool",
        "foot-stool"
    ],
    [
        "samuel",
        "sam-u-el"
    ],
    [
        "cloudy",
        "clou-dy"
    ],
    [
        "pillar",
        "pil-lar"
    ],
    [
        "godliness",
        "god-li-ness"
    ],
    [
        "unfaithfulness",
        "un-faith-ful-ness"
    ],
    [
        "cleave",
        "cleave"
    ],
    [
        "depart",
        "de-part"
    ],
    [
        "person",
        "per-son"
    ],
    [
        "slandereth",
        "slan-der-eth"
    ],
    [
        "haughty",
        "haugh-ty"
    ],
    [
        "firebrand",
        "fireb-rand"
    ],
    [
        "scarce",
        "scarce"
    ],
    [
        "pelican",
        "pel-i-can"
    ],
    [
        "owl",
        "owl"
    ],
    [
        "watched",
        "watched"
    ],
    [
        "housetop",
        "house-top"
    ],
    [
        "revile",
        "re-vile"
    ],
    [
        "mad",
        "mad"
    ],
    [
        "ashes",
        "ash-es"
    ],
    [
        "mingled",
        "ming-led"
    ],
    [
        "pitieth",
        "pi-ti-eth"
    ],
    [
        "mournings",
        "mourn-ings"
    ],
    [
        "journey",
        "journ-ey"
    ],
    [
        "change",
        "change"
    ],
    [
        "changed",
        "changed"
    ],
    [
        "forgiveth",
        "for-giv-eth"
    ],
    [
        "healeth",
        "heal-eth"
    ],
    [
        "infirmities",
        "in-fir-mi-ties"
    ],
    [
        "crowneth",
        "crown-eth"
    ],
    [
        "satisfieth",
        "sa-tis-fi-eth"
    ],
    [
        "eagle",
        "eagle"
    ],
    [
        "executeth",
        "ex-e-cut-eth"
    ],
    [
        "longsuffering",
        "long-suff-er-ing"
    ],
    [
        "flourisheth",
        "flour-ish-eth"
    ],
    [
        "flower",
        "flow-er"
    ],
    [
        "childrens",
        "child-rens"
    ],
    [
        "deckest",
        "deck-est"
    ],
    [
        "spreadest",
        "spread-est"
    ],
    [
        "curtain",
        "cur-tain"
    ],
    [
        "beams",
        "beams"
    ],
    [
        "chambers",
        "cham-bers"
    ],
    [
        "winds",
        "winds"
    ],
    [
        "ministers",
        "mi-ni-sters"
    ],
    [
        "flaming",
        "flam-ing"
    ],
    [
        "move",
        "move"
    ],
    [
        "coveredst",
        "cov-eredst"
    ],
    [
        "beneath",
        "be-neath"
    ],
    [
        "bounds",
        "bounds"
    ],
    [
        "sendeth",
        "send-eth"
    ],
    [
        "asses",
        "ass-es"
    ],
    [
        "quench",
        "quench"
    ],
    [
        "thirst",
        "thirst"
    ],
    [
        "watereth",
        "wa-ter-eth"
    ],
    [
        "sap",
        "sap"
    ],
    [
        "birds",
        "birds"
    ],
    [
        "nests",
        "nests"
    ],
    [
        "firtrees",
        "fir-trees"
    ],
    [
        "stork",
        "stork"
    ],
    [
        "conies",
        "con-ies"
    ],
    [
        "certain",
        "cer-tain"
    ],
    [
        "seasons",
        "sea-sons"
    ],
    [
        "ariseth",
        "a-ris-eth"
    ],
    [
        "manifold",
        "ma-ni-fold"
    ],
    [
        "creeping",
        "creep-ing"
    ],
    [
        "pastime",
        "pas-time"
    ],
    [
        "openest",
        "o-pen-est"
    ],
    /////
    [
        "tremble",
        "trem-ble"
    ],
    [
        "touch",
        "touch"
    ],
    [
        "oath",
        "oath"
    ],
    [
        "isaac",
        "i-saac"
    ],
    [
        "testament",
        "tes-ta-ment"
    ],
    [
        "canaan",
        "ca-naan"
    ],
    [
        "few",
        "few"
    ],
    [
        "nation",
        "na-tion"
    ],
    [
        "reproved",
        "re-proved"
    ],
    [
        "prophets",
        "pro-phets"
    ],
    [
        "provision",
        "pro-vis-ion"
    ],
    [
        "sold",
        "sold"
    ],
    [
        "bond-servant",
        "bond_ser-vant"
    ],
    [
        "stocks",
        "stocks"
    ],
    [
        "prince",
        "prince"
    ],
    [
        "senators",
        "se-na-tors"
    ],
    [
        "exceedingly",
        "ex-ceed-ing-ly"
    ],
    [
        "stronger",
        "stron-ger"
    ],
    [
        "untruly",
        "un-tru-ly"
    ],
    [
        "obedient",
        "o-be-di-ent"
    ],
    [
        "fish",
        "fish"
    ],
    [
        "lice",
        "lice"
    ],
    [
        "quarters",
        "quar-ters"
    ],
    [
        "fig-trees",
        "fig_trees"
    ],
    [
        "coasts",
        "coasts"
    ],
    [
        "grasshoppers",
        "grass-hop-pers"
    ],
    [
        "caterpillars",
        "ca-ter-pil-lars"
    ],
    [
        "chief",
        "chief"
    ],
    [
        "departing",
        "de-part-ing"
    ],
    [
        "quails",
        "quails"
    ],
    [
        "ran",
        "ran"
    ],
    [
        "labours",
        "la-bours"
    ],
    [
        "observe",
        "ob-serve"
    ],
    [
        "noble",
        "no-ble"
    ],
    [
        "bearest",
        "bear-est"
    ],
    [
        "amiss",
        "a-miss"
    ],
    [
        "regarded",
        "re-gar-ded"
    ],
    [
        "disobedient",
        "dis-o-be-di-ent"
    ],
    [
        "adversarys",
        "ad-ver-sa-rys"
    ],
    [
        "sang",
        "sang"
    ],
    [
        "leanness",
        "lean-ness"
    ],
    [
        "angered",
        "an-gered"
    ],
    [
        "saint",
        "saint"
    ],
    [
        "swallowed",
        "swal-lowed"
    ],
    [
        "dathan",
        "da-than"
    ],
    [
        "abiram",
        "ab-i-ram"
    ],
    [
        "horeb",
        "ho-reb"
    ],
    [
        "molten",
        "mol-ten"
    ],
    [
        "similitude",
        "si-mi-li-tude"
    ],
    [
        "eateth",
        "eat-eth"
    ],
    [
        "hay",
        "hay"
    ],
    [
        "gap",
        "gap"
    ],
    [
        "pleasant",
        "plea-sant"
    ],
    [
        "credence",
        "cred-ence"
    ],
    [
        "murmured",
        "mur-mured"
    ],
    [
        "baal-peor",
        "baal_pe-or"
    ],
    [
        "ate",
        "ate"
    ],
    [
        "phinehas",
        "phi-ne-has"
    ],
    [
        "interposed",
        "in-ter-posed"
    ],
    [
        "unadvisedly",
        "un-ad-vi-sed-ly"
    ],
    [
        "learned",
        "learned"
    ],
    [
        "offered",
        "off-ered"
    ],
    [
        "devils",
        "dev-ils"
    ],
    [
        "stained",
        "stained"
    ],
    [
        "whoring",
        "whor-ing"
    ],
    [
        "lords",
        "lords"
    ],
    [
        "pitied",
        "pit-ied"
    ],
    [
        "distress",
        "dist-ress"
    ],
    [
        "empty",
        "emp-ty"
    ],
    [
        "filleth",
        "fil-leth"
    ],
    [
        "bound",
        "bound"
    ],
    [
        "lightly",
        "light-ly"
    ],
    [
        "brass",
        "brass"
    ],
    [
        "bars",
        "bars"
    ],
    [
        "deaths",
        "deaths"
    ],
    [
        "door",
        "door"
    ],
    [
        "occupy",
        "oc-cu-py"
    ],
    [
        "business",
        "busi-ness"
    ],
    [
        "lifteth",
        "lift-eth"
    ],
    [
        "reel",
        "reel"
    ],
    [
        "stagger",
        "stag-ger"
    ],
    [
        "drunken",
        "drunk-en"
    ],
    [
        "wits",
        "wits"
    ],
    [
        "haven",
        "ha-ven"
    ],
    [
        "elders",
        "eld-ers"
    ],
    [
        "drieth",
        "dri-eth"
    ],
    [
        "water-springs",
        "wa-ter_springs"
    ],
    [
        "fruitful",
        "fruit-ful"
    ],
    [
        "standing",
        "stand-ing"
    ],
    [
        "sow",
        "sow"
    ],
    [
        "plant",
        "plant"
    ],
    [
        "vineyards",
        "vine-yards"
    ],
    [
        "yield",
        "yield"
    ],
    [
        "fruits",
        "fruits"
    ],
    [
        "blesseth",
        "bles-seth"
    ],
    [
        "multiply",
        "mul-ti-ply"
    ],
    [
        "decrease",
        "de-crease"
    ],
    [
        "oppression",
        "opp-ress-ion"
    ],
    [
        "entreated",
        "en-treat-ed"
    ],
    [
        "wander",
        "wan-der"
    ],
    [
        "households",
        "house-holds"
    ],
    [
        "best",
        "best"
    ],
    [
        "member",
        "mem-ber"
    ],
    [
        "greater",
        "great-er"
    ],
    [
        "lawgiver",
        "law-giv-er"
    ],
    [
        "hatred",
        "hat-red"
    ],
    [
        "fought",
        "fought"
    ],
    [
        "contrary",
        "con-tra-ry"
    ],
    [
        "office",
        "off-ice"
    ],
    [
        "wife",
        "wife"
    ],
    [
        "vagabonds",
        "va-ga-bonds"
    ],
    [
        "beg",
        "beg"
    ],
    [
        "extortioner",
        "ex-tor-tion-er"
    ],
    [
        "next",
        "next"
    ],
    [
        "persecuted",
        "per-se-cu-ted"
    ],
    [
        "helpless",
        "help-less"
    ],
    [
        "bowels",
        "bow-els"
    ],
    [
        "cloak",
        "cloak"
    ],
    [
        "girdle",
        "gir-dle"
    ],
    [
        "departeth",
        "de-par-teth"
    ],
    [
        "knees",
        "knees"
    ],
    [
        "willingly",
        "will-ing-ly"
    ],
    [
        "dew",
        "dew"
    ],
    [
        "repent",
        "re-pent"
    ],
    [
        "priest",
        "priest"
    ],
    [
        "order",
        "or-der"
    ],
    [
        "melchizedek",
        "mel-chi-ze-dek"
    ],
    [
        "countries",
        "coun-tries"
    ],
    [
        "verity",
        "ve-ri-ty"
    ],
    [
        "redemption",
        "re-demp-tion"
    ],
    [
        "reverend",
        "re-ver-end"
    ],
    [
        "thereafter",
        "there-af-ter"
    ],
    [
        "discretion",
        "dis-cre-tion"
    ],
    [
        "believeth",
        "be-liev-eth"
    ],
    [
        "shrink",
        "shrink"
    ],
    [
        "dispersed",
        "dis-persed"
    ],
    [
        "gnash",
        "gnash"
    ],
    [
        "fled",
        "fled"
    ],
    [
        "skipped",
        "skipped"
    ],
    [
        "aileth",
        "ail-eth"
    ],
    [
        "fleddest",
        "fled-dest"
    ],
    [
        "water",
        "wa-ter"
    ],
    [
        "flint-stone",
        "flint_stone"
    ],
    [
        "springing",
        "spring-ing"
    ],
    [
        "truths",
        "truths"
    ],
    [
        "mens",
        "mens"
    ],
    [
        "noses",
        "no-ses"
    ],
    [
        "handle",
        "han-dle"
    ],
    [
        "beseech",
        "be-seech"
    ],
    [
        "liars",
        "li-ars"
    ],
    [
        "bees",
        "bees"
    ],
    [
        "extinct",
        "ex-tinct"
    ],
    [
        "thrust",
        "thrust"
    ],
    [
        "pre-eminence",
        "pre_em-in-ence"
    ],
    [
        "corrected",
        "cor-rec-ted"
    ],
    [
        "builders",
        "build-ers"
    ],
    [
        "head-stone",
        "head_stone"
    ],
    [
        "comer",
        "com-er"
    ],
    [
        "wished",
        "wished"
    ],
    [
        "bind",
        "bind"
    ],
    [
        "charged",
        "charged"
    ],
    [
        "diligently",
        "di-li-gent-ly"
    ],
    [
        "unfeigned",
        "un-feigned"
    ],
    [
        "wherewithal",
        "where-with-al"
    ],
    [
        "ruling",
        "rul-ing"
    ],
    [
        "fervent",
        "fer-vent"
    ],
    [
        "occupied",
        "oc-cu-pied"
    ],
    [
        "counsellors",
        "coun-sel-lors"
    ],
    [
        "stuck",
        "stuck"
    ],
    [
        "confound",
        "con-found"
    ],
    [
        "covetousness",
        "co-ve-tous-ness"
    ],
    [
        "blasphemers",
        "blas-phem-ers"
    ],
    [
        "study",
        "stu-dy"
    ],
    [
        "shrinked",
        "shrinked"
    ],
    [
        "pilgrimage",
        "pil-grim-age"
    ],
    [
        "prolonged",
        "pro-longed"
    ],
    [
        "midnight",
        "mid-night"
    ],
    [
        "graciously",
        "gra-cious-ly"
    ],
    [
        "brawn",
        "brawn"
    ],
    [
        "dearer",
        "dea-rer"
    ],
    [
        "fashioned",
        "fash-ioned"
    ],
    [
        "longed",
        "longed"
    ],
    [
        "eyes-long",
        "eyes_long"
    ],
    [
        "pits",
        "pits"
    ],
    [
        "falsely",
        "false-ly"
    ],
    [
        "ordinance",
        "ord-in-ance"
    ],
    [
        "wiser",
        "wis-er"
    ],
    [
        "teachers",
        "teach-ers"
    ],
    [
        "aged",
        "aged"
    ],
    [
        "refrained",
        "ref-rained"
    ],
    [
        "shrunk",
        "shrunk"
    ],
    [
        "lantern",
        "lant-ern"
    ],
    [
        "measure",
        "meas-ure"
    ],
    [
        "free-will",
        "free_will"
    ],
    [
        "swerved",
        "swerved"
    ],
    [
        "claimed",
        "claimed"
    ],
    [
        "applied",
        "app-lied"
    ],
    [
        "trodden",
        "trod-den"
    ],
    [
        "dross",
        "dross"
    ],
    [
        "trembleth",
        "tremb-leth"
    ],
    [
        "lawful",
        "law-ful"
    ],
    [
        "oppressors",
        "opp-ress-ors"
    ],
    [
        "wasted",
        "wast-ed"
    ],
    [
        "precious",
        "prec-ious"
    ],
    [
        "straight",
        "straight"
    ],
    [
        "drew",
        "drew"
    ],
    [
        "usest",
        "us-est"
    ],
    [
        "wrongful",
        "wrong-ful"
    ],
    [
        "dealings",
        "deal-ings"
    ],
    [
        "gush",
        "gush"
    ],
    [
        "reputation",
        "re-pu-ta-tion"
    ],
    [
        "prevent",
        "pre-vent"
    ],
    [
        "watches",
        "watch-es"
    ],
    [
        "lovingkindness",
        "lov-ing-kind-ness"
    ],
    [
        "grounded",
        "groun-ded"
    ],
    [
        "wont",
        "wont"
    ],
    [
        "swerve",
        "swerve"
    ],
    [
        "grieveth",
        "griev-eth"
    ],
    [
        "findeth",
        "find-eth"
    ],
    [
        "spoils",
        "spoils"
    ],
    [
        "stumbling",
        "stum-bling"
    ],
    [
        "lost",
        "lost"
    ],
    [
        "woe",
        "woe"
    ],
    [
        "constrained",
        "con-strained"
    ],
    [
        "meshech",
        "mesh-ech"
    ],
    [
        "kedar",
        "ke-dar"
    ],
    [
        "whence",
        "whence"
    ],
    [
        "slumber",
        "slum-ber"
    ],
    [
        "keeper",
        "keep-er"
    ],
    [
        "unity",
        "u-ni-ty"
    ],
    [
        "thither",
        "thi-ther"
    ],
    [
        "companions",
        "com-pan-ions"
    ],
    [
        "dwellest",
        "dwell-est"
    ],
    [
        "masters",
        "mas-ters"
    ],
    [
        "maiden",
        "mai-den"
    ],
    [
        "mistress",
        "mis-tress"
    ],
    [
        "despitefulness",
        "des-pite-ful-ness"
    ],
    [
        "wrathfully",
        "wrath-ful-ly"
    ],
    [
        "drowned",
        "drowned"
    ],
    [
        "stream",
        "stream"
    ],
    [
        "escaped",
        "es-caped"
    ],
    [
        "fowler",
        "fow-ler"
    ],
    [
        "laughter",
        "laugh-ter"
    ],
    [
        "already",
        "al-ready"
    ],
    [
        "reap",
        "reap"
    ],
    [
        "beareth",
        "bear-eth"
    ],
    [
        "sheaves",
        "sheaves"
    ],
    [
        "watchman",
        "watch-man"
    ],
    [
        "waketh",
        "wak-eth"
    ],
    [
        "late",
        "late"
    ],
    [
        "carefulness",
        "care-ful-ness"
    ],
    [
        "olive-branches",
        "ol-ive_branches"
    ],
    [
        "plowers",
        "plo-wers"
    ],
    [
        "plowed",
        "plowed"
    ],
    [
        "hewn",
        "hewn"
    ],
    [
        "housetops",
        "house-tops"
    ],
    [
        "withereth",
        "with-er-eth"
    ],
    [
        "grown",
        "grown"
    ],
    [
        "mower",
        "mo-wer"
    ],
    [
        "bindeth",
        "bind-eth"
    ],
    [
        "extreme",
        "ext-reme"
    ],
    [
        "fleeth",
        "fleeth"
    ],
    [
        "high-minded",
        "high_min-ded"
    ],
    [
        "matters",
        "mat-ters"
    ],
    [
        "child",
        "child"
    ],
    [
        "weaned",
        "weaned"
    ],
    [
        "vowed",
        "vowed"
    ],
    [
        "climb",
        "climb"
    ],
    [
        "temples",
        "temp-les"
    ],
    [
        "ephratah",
        "eph-ra-tah"
    ],
    [
        "resting-place",
        "res-ting_place"
    ],
    [
        "ark",
        "ark"
    ],
    [
        "joyfulness",
        "joy-ful-ness"
    ],
    [
        "davids",
        "da-vids"
    ],
    [
        "victuals",
        "vic-tu-als"
    ],
    [
        "deck",
        "deck"
    ],
    [
        "clothe",
        "clothe"
    ],
    [
        "beard",
        "beard"
    ],
    [
        "aarons",
        "aa-rons"
    ],
    [
        "skirts",
        "skirts"
    ],
    [
        "laud",
        "laud"
    ],
    [
        "lovely",
        "love-ly"
    ],
    [
        "bringing",
        "bring-ing"
    ],
    [
        "treasuries",
        "treas-ur-ies"
    ],
    [
        "pharaoh",
        "pha-raoh"
    ],
    [
        "sihon",
        "si-hon"
    ],
    [
        "amorites",
        "am-or-ites"
    ],
    [
        "og",
        "og"
    ],
    [
        "levi",
        "levi"
    ],
    [
        "lights",
        "lights"
    ],
    [
        "rule",
        "rule"
    ],
    [
        "stretched-out",
        "stret-ched_out"
    ],
    [
        "two",
        "two"
    ],
    [
        "overthrew",
        "o-ver-threw"
    ],
    [
        "harps",
        "harps"
    ],
    [
        "cunning",
        "cunn-ing"
    ],
    [
        "roof",
        "roof"
    ],
    [
        "prefer",
        "pre-fer"
    ],
    [
        "served",
        "served"
    ],
    [
        "throweth",
        "throw-eth"
    ],
    [
        "magnified",
        "mag-ni-fied"
    ],
    [
        "enduedst",
        "en-duedst"
    ],
    [
        "searched",
        "searched"
    ],
    [
        "down-sitting",
        "down_sitt-ing"
    ],
    [
        "uprising",
        "up-ris-ing"
    ],
    [
        "understandest",
        "un-der-stand-est"
    ],
    [
        "acquainted",
        "ac-quain-ted"
    ],
    [
        "beset",
        "be-set"
    ],
    [
        "attain",
        "at-tain"
    ],
    [
        "whither",
        "whi-ther"
    ],
    [
        "fearfully",
        "fear-ful-ly"
    ],
    [
        "wonderfully",
        "won-der-ful-ly"
    ],
    [
        "imperfect",
        "im-per-fect"
    ],
    [
        "members",
        "mem-bers"
    ],
    [
        "sum",
        "sum"
    ],
    [
        "wake",
        "wake"
    ],
    [
        "unrighteously",
        "un-right-eous-ly"
    ],
    [
        "sharpened",
        "sharp-ened"
    ],
    [
        "adders",
        "ad-ders"
    ],
    [
        "traps",
        "traps"
    ],
    [
        "mischievous",
        "mis-chie-vous"
    ],
    [
        "imagination",
        "i-ma-gi-na-tion"
    ],
    [
        "hunt",
        "hunt"
    ],
    [
        "lifting",
        "lift-ing"
    ],
    [
        "refuse",
        "re-fuse"
    ],
    [
        "balms",
        "balms"
    ],
    [
        "heweth",
        "hew-eth"
    ],
    [
        "nets",
        "nets"
    ],
    [
        "complaints",
        "comp-laints"
    ],
    [
        "knewest",
        "knew-est"
    ],
    [
        "cared",
        "cared"
    ],
    [
        "righteousness",
        "right-eous-ness"
    ],
    [
        "gaspeth",
        "gasp-eth"
    ],
    [
        "waxeth",
        "wax-eth"
    ],
    [
        "faint",
        "faint"
    ],
    [
        "fortress",
        "fort-ress"
    ],
    [
        "deliverer",
        "de-li-ver-er"
    ],
    [
        "regardest",
        "re-gard-est"
    ],
    [
        "lightning",
        "light-ning"
    ],
    [
        "talketh",
        "talk-eth"
    ],
    [
        "ten-stringed",
        "ten_stringed"
    ],
    [
        "grow",
        "grow"
    ],
    [
        "plants",
        "plants"
    ],
    [
        "polished",
        "pol-ished"
    ],
    [
        "garners",
        "gar-ners"
    ],
    [
        "store",
        "store"
    ],
    [
        "fields",
        "fields"
    ],
    [
        "decay",
        "de-cay"
    ],
    [
        "leading",
        "lead-ing"
    ],
    [
        "case",
        "case"
    ],
    [
        "abundant",
        "ab-un-dant"
    ],
    [
        "mightiness",
        "migh-ti-ness"
    ],
    [
        "ages",
        "a-ges"
    ],
    [
        "faithfully",
        "faith-ful-ly"
    ],
    [
        "feedeth",
        "feed-eth"
    ],
    [
        "looseth",
        "loos-eth"
    ],
    [
        "blind",
        "blind"
    ],
    [
        "upside",
        "up-side"
    ],
    [
        "outcasts",
        "out-casts"
    ],
    [
        "medicine",
        "me-di-cine"
    ],
    [
        "infinite",
        "in-fin-ite"
    ],
    [
        "prepareth",
        "pre-par-eth"
    ],
    [
        "fodder",
        "fod-der"
    ],
    [
        "ravens",
        "ra-vens"
    ],
    [
        "legs",
        "legs"
    ],
    [
        "flour",
        "flour"
    ],
    [
        "wheat",
        "wheat"
    ],
    [
        "swiftly",
        "swift-ly"
    ],
    [
        "wool",
        "wool"
    ],
    [
        "hoarfrost",
        "hoar-frost"
    ],
    [
        "ice",
        "ice"
    ],
    [
        "morsels",
        "mor-sels"
    ],
    [
        "bloweth",
        "blow-eth"
    ],
    [
        "flow",
        "flow"
    ],
    [
        "ordinances",
        "or-di-nan-ces"
    ],
    [
        "heights",
        "heights"
    ],
    [
        "created",
        "cre-at-ed"
    ],
    [
        "deeps",
        "deeps"
    ],
    [
        "hail",
        "hail"
    ],
    [
        "vapours",
        "va-pours"
    ],
    [
        "fulfilling",
        "ful-fil-ling"
    ],
    [
        "serveth",
        "serv-eth"
    ],
    [
        "dance",
        "dance"
    ],
    [
        "meek-hearted",
        "meek_heart-ed"
    ],
    [
        "beds",
        "beds"
    ],
    [
        "two-edged",
        "two_edged"
    ],
    [
        "chains",
        "chains"
    ],
    [
        "nobles",
        "no-bles"
    ],
    [
        "links",
        "links"
    ],
    [
        "dances",
        "dan-ces"
    ],
    [
        "pipe",
        "pipe"
    ],
    [
        "well-tuned",
        "well_tuned"
    ],
    [
        "cymbals",
        "cym-bals"
    ]
];


const $c07cc9090462c085$export$af3a35665fe7186d = (toneId)=>{
    const isOrdinariatePage = window.location.href.includes("/se/");
    return (isOrdinariatePage ? $c07cc9090462c085$export$df12744c9c7cdebd : $c07cc9090462c085$var$TONES)[toneId];
};
const $c07cc9090462c085$var$TONES = {
    "1a.1": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "4."
        ]
    },
    "1a.2": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "43."
        ]
    },
    "1a.3": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "454."
        ]
    },
    "1a.4": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4.",
            "4?",
            "5."
        ]
    },
    "1a.5": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "4321."
        ]
    },
    "1a.7": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/43",
            "4?",
            "45."
        ]
    },
    "1a.8": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/43",
            "1?",
            "1."
        ]
    },
    "1a.9": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "45."
        ]
    },
    "1a.10": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/5",
            "4?",
            "4."
        ]
    },
    "1a.11": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "35."
        ]
    },
    "1a.12": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "45."
        ]
    },
    "1b.1": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "4."
        ]
    },
    "1b.2": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "43."
        ]
    },
    "1b.3": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "454."
        ]
    },
    "1b.4": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4.",
            "4?",
            "5."
        ]
    },
    "1b.5": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "4321."
        ]
    },
    "1b.7": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/43",
            "4?",
            "45."
        ]
    },
    "1b.8": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/43",
            "1?",
            "1."
        ]
    },
    "1b.9": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "45."
        ]
    },
    "1b.10": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/5",
            "4?",
            "4."
        ]
    },
    "1b.11": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "35."
        ]
    },
    "1b.12": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "45."
        ]
    },
    "1s.1": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "4."
        ]
    },
    "1s.2": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "43."
        ]
    },
    "1s.3": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "454."
        ]
    },
    "1s.4": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/4.",
            "4?",
            "5."
        ]
    },
    "1s.5": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "4321."
        ]
    },
    "1s.7": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/43",
            "4?",
            "45."
        ]
    },
    "1s.8": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/43",
            "1?",
            "1."
        ]
    },
    "1s.9": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "45."
        ]
    },
    "1s.10": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/5",
            "4?",
            "4."
        ]
    },
    "1s.11": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "35."
        ]
    },
    "1s.12": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "45."
        ]
    },
    "1ant": {
        clef: "c7",
        intonation: [
            "15",
            "56b",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "43",
            "45."
        ],
        secondRecitingNote: 4,
        ending: [
            "23",
            "21."
        ]
    },
    "2.1": {
        clef: "f5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "/2.",
            "2?",
            "3."
        ]
    },
    "2.2": {
        clef: "f5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "43",
            "54",
            "/2.",
            "2?",
            "3."
        ]
    },
    "2s.1": {
        clef: "f5",
        intonation: [
            "2",
            "32",
            "25"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "56",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "/2.",
            "2?",
            "3."
        ]
    },
    "2s.2": {
        clef: "f5",
        intonation: [
            "2",
            "32",
            "25"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "56",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "43",
            "54",
            "/2.",
            "2?",
            "3."
        ]
    },
    "2ant": {
        clef: "f5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "43",
            "45."
        ],
        secondRecitingNote: 4,
        ending: [
            "54",
            "3."
        ]
    },
    "3a.1": {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7",
            "7?",
            "6.",
            "7."
        ],
        ending: [
            "76",
            "56",
            "/5",
            "4?",
            "45."
        ]
    },
    "3a.2": {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7",
            "7?",
            "6.",
            "7."
        ],
        ending: [
            "76",
            "56",
            "/5.",
            "4?",
            "4."
        ]
    },
    "3a.4": {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7",
            "7?",
            "6.",
            "7."
        ],
        ending: [
            "5",
            "/7.",
            "6?",
            "6."
        ]
    },
    "3a.5": {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7",
            "7?",
            "6.",
            "7."
        ],
        ending: [
            "5",
            "/7",
            "7?",
            "65."
        ]
    },
    "3a.6": {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7",
            "7?",
            "6.",
            "7."
        ],
        ending: [
            "5",
            "7",
            "6",
            "/5.",
            "4?",
            "4."
        ]
    },
    "3s.1": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/78",
            "7?",
            "7",
            "/7?",
            "/65",
            "7."
        ],
        ending: [
            "76",
            "56",
            "/5",
            "4?",
            "45."
        ]
    },
    "3s.2": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7",
            "7?",
            "6.",
            "7."
        ],
        ending: [
            "76",
            "56",
            "/5",
            "4?",
            "4."
        ]
    },
    "3s.4": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/78",
            "7?",
            "7",
            "/7?",
            "/65",
            "7."
        ],
        ending: [
            "5",
            "/7.",
            "6?",
            "6."
        ]
    },
    "3s.5": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/78",
            "7?",
            "7",
            "/7?",
            "/65",
            "7."
        ],
        ending: [
            "5",
            "/7",
            "7?",
            "65."
        ]
    },
    "3s.6": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/78",
            "7?",
            "7",
            "/7?",
            "/65",
            "7."
        ],
        ending: [
            "5",
            "7",
            "6",
            "/5",
            "4?",
            "4."
        ]
    },
    "3ant": {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "56",
            "54."
        ],
        secondRecitingNote: 5,
        ending: [
            "43",
            "2."
        ]
    },
    "4.1": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "65",
            "/432",
            "2?",
            "2."
        ]
    },
    "4.2": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "65",
            "/432",
            "2?",
            "32."
        ]
    },
    "4.3": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "65",
            "/43",
            "2?",
            "2."
        ]
    },
    "4.4": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "2?",
            "2."
        ]
    },
    "4.5": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4",
            "4?",
            "24."
        ]
    },
    "4.6": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "/5",
            "/4?",
            "/4."
        ]
    },
    "4.7": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5."
        ]
    },
    "4.8": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "/46",
            "5?",
            "5."
        ]
    },
    "4.9": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "454."
        ]
    },
    "4.10": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "4?",
            "5."
        ]
    },
    "4.11": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "6",
            "/45",
            "4?",
            "5."
        ]
    },
    "4.12": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "4?",
            "45."
        ]
    },
    "4.13": {
        clef: "c7",
        intonation: [
            "5",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "4?",
            "454."
        ]
    },
    "4s.1": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "65",
            "/432",
            "2?",
            "2."
        ]
    },
    "4s.2": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "65",
            "/432",
            "2?",
            "32."
        ]
    },
    "4s.3": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "76",
            "/54",
            "2?",
            "2."
        ]
    },
    "4s.4": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "2?",
            "2."
        ]
    },
    "4s.5": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4",
            "4?",
            "24."
        ]
    },
    "4s.6": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "/5.",
            "4?",
            "4."
        ]
    },
    "4s.7": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5."
        ]
    },
    "4s.8": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "/46",
            "5?",
            "5."
        ]
    },
    "4s.9": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "454."
        ]
    },
    "4s.10": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "4?",
            "5."
        ]
    },
    "4s.11": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "6",
            "/45",
            "4?",
            "5."
        ]
    },
    "4s.12": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "4?",
            "45."
        ]
    },
    "4s.13": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "4?",
            "454."
        ]
    },
    "4ant": {
        clef: "c7",
        intonation: [
            "2",
            "3",
            "4"
        ],
        recitingNote: 4,
        mediant: [
            "32",
            "21."
        ],
        secondRecitingNote: 5,
        ending: [
            "43",
            "2."
        ]
    },
    "5.1": {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "/6",
            "5?",
            "4",
            "/5.",
            "3?",
            "3."
        ]
    },
    "5.2": {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "/6",
            "5?",
            "4",
            "/5",
            "5?",
            "35."
        ]
    },
    "5.3": {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "3",
            "4b",
            "/2.",
            "1?",
            "1."
        ]
    },
    "5s.1": {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "6",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "/6",
            "5?",
            "4",
            "/5.",
            "3?",
            "3."
        ]
    },
    "5s.2": {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "6",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "/6",
            "5?",
            "4",
            "/5",
            "5?",
            "35."
        ]
    },
    "5s.3": {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "6",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "3",
            "4b",
            "/2.",
            "1?",
            "1."
        ]
    },
    "5ant": {
        clef: "c5",
        intonation: [
            "3",
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "56",
            "65."
        ],
        secondRecitingNote: 3,
        ending: [
            "23",
            "21."
        ]
    },
    "6a": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4.",
            "5."
        ],
        ending: [
            "3",
            "45",
            "/4.",
            "3?",
            "3."
        ]
    },
    "6b": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5?",
            "5",
            "/4.",
            "4?",
            "5."
        ],
        ending: [
            "3",
            "45",
            "/4.",
            "3?",
            "3."
        ]
    },
    "6c": {
        clef: "c7",
        intonation: [
            "3",
            "4",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "/5.",
            "3?",
            "3.~"
        ],
        ending: [
            "3",
            "45",
            "/4.",
            "3?",
            "3."
        ]
    },
    "6s": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46b",
            "5",
            "/5?",
            "/54",
            "45."
        ],
        ending: [
            "3",
            "45",
            "/4.",
            "3?",
            "3."
        ]
    },
    "6ant": {
        clef: "c7",
        intonation: [
            "3",
            "1",
            "3"
        ],
        recitingNote: 3,
        mediant: [
            "34",
            "43."
        ],
        secondRecitingNote: 4,
        ending: [
            "45",
            "43."
        ]
    },
    "6ood": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "/3",
            "3?"
        ],
        ending: [
            "3",
            "/4",
            "4?"
        ]
    },
    "7.1": {
        clef: "c5",
        intonation: [
            "4",
            "5",
            "6"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7?",
            "7",
            "/6.",
            "6?",
            "7."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5",
            "5?",
            "43."
        ]
    },
    "7.2": {
        clef: "c5",
        intonation: [
            "4",
            "5",
            "6"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7?",
            "7",
            "/6.",
            "6?",
            "7."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5",
            "5?",
            "45."
        ]
    },
    "7.3": {
        clef: "c5",
        intonation: [
            "4",
            "5",
            "6"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7?",
            "7",
            "/6.",
            "6?",
            "7."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5.",
            "5?",
            "4."
        ]
    },
    "7.4": {
        clef: "c5",
        intonation: [
            "4",
            "5",
            "6"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7?",
            "7",
            "/6.",
            "6?",
            "7."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5",
            "5?",
            "46."
        ]
    },
    "7.5": {
        clef: "c5",
        intonation: [
            "4",
            "5",
            "6"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7?",
            "7",
            "/6.",
            "6?",
            "7."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/56",
            "5?",
            "5."
        ]
    },
    "7.6": {
        clef: "c5",
        intonation: [
            "4",
            "5",
            "6"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7?",
            "7",
            "/6.",
            "6?",
            "7."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5",
            "5?",
            "65."
        ]
    },
    "7.7": {
        clef: "c5",
        intonation: [
            "4",
            "5",
            "6"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7?",
            "7",
            "/6.",
            "6?",
            "7."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5.",
            "5?",
            "6."
        ]
    },
    "7s.1": {
        clef: "c5",
        intonation: [
            "25",
            "4",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "68",
            "7?",
            "7",
            "/7?",
            "76",
            "67."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5",
            "5?",
            "43."
        ]
    },
    "7s.2": {
        clef: "c5",
        intonation: [
            "25",
            "4",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "68",
            "7?",
            "7",
            "/7?",
            "76",
            "67."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5",
            "5?",
            "45."
        ]
    },
    "7s.3": {
        clef: "c5",
        intonation: [
            "25",
            "4",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "68",
            "7?",
            "7",
            "/7?",
            "76",
            "67."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5.",
            "5?",
            "4."
        ]
    },
    "7s.4": {
        clef: "c5",
        intonation: [
            "25",
            "4",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "68",
            "7?",
            "7",
            "/7?",
            "76",
            "67."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5",
            "5?",
            "46."
        ]
    },
    "7s.5": {
        clef: "c5",
        intonation: [
            "25",
            "4",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "68",
            "7?",
            "7",
            "/7?",
            "76",
            "67."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/56",
            "5?",
            "5."
        ]
    },
    "7s.6": {
        clef: "c5",
        intonation: [
            "25",
            "4",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "68",
            "7?",
            "7",
            "/7?",
            "76",
            "67."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5",
            "5?",
            "65."
        ]
    },
    "7s.7": {
        clef: "c5",
        intonation: [
            "25",
            "4",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "68",
            "7?",
            "7",
            "/7?",
            "76",
            "67."
        ],
        ending: [
            "/7",
            "6?",
            "6",
            "/5.",
            "5?",
            "6."
        ]
    },
    "7ant": {
        clef: "c5",
        intonation: [
            "2",
            "4",
            "5",
            "6"
        ],
        recitingNote: 6,
        mediant: [
            "54",
            "46."
        ],
        secondRecitingNote: 5,
        ending: [
            "42",
            "32."
        ]
    },
    "8.1": {
        clef: "c5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "/3.",
            "2?",
            "2."
        ]
    },
    "8.2": {
        clef: "c5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "3",
            "5",
            "/6.",
            "5?",
            "5."
        ]
    },
    "8.3": {
        clef: "c5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "3",
            "/5.",
            "5?",
            "5."
        ]
    },
    "8.5": {
        clef: "c5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "/3",
            "2?",
            "23."
        ]
    },
    "8.6": {
        clef: "c5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "/3",
            "2?",
            "232."
        ]
    },
    "8s.1": {
        clef: "c5",
        intonation: [
            "2",
            "32",
            "25"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "56",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "/3.",
            "2?",
            "2."
        ]
    },
    "8s.2": {
        clef: "c5",
        intonation: [
            "2",
            "32",
            "25"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "56",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "3",
            "5",
            "/6.",
            "5?",
            "5."
        ]
    },
    "8s.3": {
        clef: "c5",
        intonation: [
            "2",
            "32",
            "25"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "56",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "3",
            "/5.",
            "5?",
            "5."
        ]
    },
    "8s.5": {
        clef: "c5",
        intonation: [
            "2",
            "32",
            "25"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "56",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "/3",
            "2?",
            "23."
        ]
    },
    "8s.6": {
        clef: "c5",
        intonation: [
            "2",
            "32",
            "25"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "56",
            "6",
            "/56",
            "5?",
            "5."
        ],
        ending: [
            "4",
            "5",
            "/3",
            "2?",
            "232."
        ]
    },
    "8ant": {
        clef: "c5",
        intonation: [
            "1",
            "2",
            "3"
        ],
        recitingNote: 3,
        mediant: [
            "53",
            "32."
        ],
        secondRecitingNote: 5,
        ending: [
            "34",
            "32."
        ]
    },
    "Tonus Peregrinus A": {
        clef: "c7",
        intonation: [
            "56b",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "/4.",
            "3?",
            "3."
        ],
        secondRecitingNote: 4,
        ending: [
            "1",
            "/3",
            "3?",
            "21."
        ]
    },
    "Tonus Peregrinus B": {
        clef: "c7",
        intonation: [
            "56b",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "/6b",
            "5",
            "4.",
            "3?",
            "3."
        ],
        secondRecitingNote: 4,
        ending: [
            "1",
            "/3",
            "3?",
            "21."
        ]
    }
};
const $c07cc9090462c085$export$df12744c9c7cdebd = {
    tid: {
        clef: "f5",
        intonation: [
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "3",
            "/5",
            "5?",
            "5?"
        ],
        ending: [
            "/5",
            "3?",
            "3"
        ],
        liber: ""
    },
    "1b.1": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "4"
        ],
        liber: "I g"
    },
    "1b.2": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "43"
        ],
        liber: "I f"
    },
    "1b.3": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "454"
        ],
        liber: "I g\xb2"
    },
    "1b.4": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/4",
            "5?",
            "5"
        ],
        liber: "I a"
    },
    "1b.5": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "4321"
        ],
        liber: "I D"
    },
    "1b.6": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "4321"
        ],
        liber: "I D'"
    },
    "1b.7": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "45"
        ],
        liber: "I a\xb3"
    },
    "1b.8": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/4?",
            "\\43",
            "1"
        ],
        endingOptions: [
            [
                "4",
                "3",
                "/43",
                "1"
            ],
            [
                "4",
                "3",
                "/4?",
                "\\43",
                "1"
            ]
        ],
        liber: "I D\xb2"
    },
    "1b.9": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "45"
        ],
        liber: "I a\xb3"
    },
    "1b.10": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/45",
            "4?",
            "4"
        ],
        liber: "I g"
    },
    "1b.12": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "3",
            "/4",
            "4?",
            "45"
        ],
        liber: "I a\xb2"
    },
    "1n": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/57",
            "5",
            "5?",
            "5?",
            "54",
            "45"
        ],
        secondIntonation: [
            "43",
            "45"
        ],
        ending: [
            "575",
            "4",
            "3",
            "333",
            "1"
        ],
        liber: "I"
    },
    2.1: {
        clef: "f5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6",
            "5?",
            "5~"
        ],
        ending: [
            "4",
            "/2",
            "3?",
            "3"
        ],
        liber: "II"
    },
    2.2: {
        clef: "f5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6",
            "5?",
            "5~"
        ],
        ending: [
            "4",
            "/2",
            "3?",
            "3"
        ],
        liber: "II"
    },
    "2n": {
        clef: "f5",
        intonation: [
            "2",
            "32",
            "25"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "56",
            "6",
            "/56",
            "5?",
            "5"
        ],
        secondIntonation: [
            "53",
            "35"
        ],
        ending: [
            "6",
            "53",
            "5",
            "42",
            "343"
        ],
        liber: "II"
    },
    "3a.1": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7",
            "7?",
            "7?",
            "/65",
            "7"
        ],
        ending: [
            "76",
            "56",
            "/5",
            "4?",
            "45"
        ],
        liber: "III a\xb2"
    },
    "3a.2": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7",
            "7?",
            "7?",
            "/65",
            "7"
        ],
        ending: [
            "76",
            "56",
            "/5",
            "4?",
            "4"
        ],
        liber: "III g"
    },
    "3a.4": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7",
            "7?",
            "7?",
            "/65",
            "7"
        ],
        ending: [
            "5",
            "/7",
            "7?",
            "6"
        ],
        liber: "III b"
    },
    "3a.5": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7",
            "7?",
            "7?",
            "/65",
            "7"
        ],
        ending: [
            "5",
            "/7",
            "7?",
            "65"
        ],
        liber: "III a"
    },
    "3a.6": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7",
            "7?",
            "7?",
            "/65",
            "7"
        ],
        ending: [
            "5",
            "7",
            "6",
            "/5",
            "4?",
            "4"
        ],
        liber: "III g\xb2"
    },
    "3n": {
        clef: "c7",
        intonation: [
            "4",
            "57"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7",
            "7?",
            "7?",
            "65",
            "777"
        ],
        secondIntonation: [
            "64",
            "57"
        ],
        ending: [
            "776",
            "54",
            "5",
            "6",
            "45"
        ],
        liber: "III"
    },
    4.1: {
        clef: "c7",
        intonation: [
            "5",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6",
            "5?",
            "5~"
        ],
        ending: [
            "4",
            "5",
            "65",
            "/4?",
            "\\43",
            "2"
        ],
        endingOptions: [
            [
                "4",
                "5",
                "65",
                "/43",
                "2"
            ],
            [
                "4",
                "5",
                "65",
                "/4?",
                "\\43",
                "2"
            ]
        ],
        liber: "IV E"
    },
    4.3: {
        clef: "c7",
        intonation: [
            "5",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6",
            "5?",
            "5~"
        ],
        ending: [
            "4",
            "5",
            "65",
            "/4?",
            "\\43",
            "2"
        ],
        endingOptions: [
            [
                "4",
                "5",
                "65",
                "/43",
                "2"
            ],
            [
                "4",
                "5",
                "65",
                "/4?",
                "\\43",
                "2"
            ]
        ],
        liber: "IV E"
    },
    4.4: {
        clef: "c5",
        intonation: [
            "6",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "5",
            "6",
            "/7",
            "6?",
            "6~"
        ],
        ending: [
            "5",
            "6",
            "7",
            "/5",
            "3?",
            "3"
        ],
        liber: "IV A"
    },
    "4.4trans": {
        clef: "c7",
        intonation: [
            "5",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "5",
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4.",
            "2?",
            "2."
        ],
        liber: "IV A"
    },
    4.5: {
        clef: "c5",
        intonation: [
            "6",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "5",
            "6",
            "/7",
            "6?",
            "6~"
        ],
        ending: [
            "5",
            "6",
            "7",
            "/5",
            "3?",
            "34"
        ],
        liber: "IV A*"
    },
    4.7: {
        clef: "c5",
        intonation: [
            "6",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "5",
            "6",
            "/7",
            "6?",
            "6~"
        ],
        ending: [
            "/6",
            "5?",
            "5"
        ],
        liber: "IV c"
    },
    4.8: {
        clef: "c5",
        intonation: [
            "6",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "5",
            "6",
            "/7",
            "6?",
            "6~"
        ],
        ending: [
            "5",
            "6",
            "7",
            "/5",
            "3?",
            "3"
        ],
        liber: "IV A"
    },
    4.9: {
        clef: "c5",
        intonation: [
            "6",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "5",
            "6",
            "/7",
            "6?",
            "6~"
        ],
        ending: [
            "/6",
            "5?",
            "5"
        ],
        liber: "IV c"
    },
    "4.10": {
        clef: "c5",
        intonation: [
            "6",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "5",
            "6",
            "/7",
            "6?",
            "6~"
        ],
        ending: [
            "5",
            "6",
            "7",
            "/5",
            "3?",
            "3"
        ],
        liber: "IV A"
    },
    4.12: {
        clef: "c5",
        intonation: [
            "6",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "5",
            "6",
            "/7",
            "6?",
            "6~"
        ],
        ending: [
            "4",
            "5",
            "6",
            "/4",
            "4?",
            "45"
        ],
        liber: ""
    },
    "4s": {
        /// TODO
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5"
        ],
        ending: [
            "4",
            "5",
            "65",
            "/432",
            "2?",
            "2"
        ],
        liber: "TODO"
    },
    "4n": {
        clef: "c7",
        intonation: [
            "54",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "54",
            "46",
            "6",
            "/56",
            "5?",
            "5"
        ],
        secondIntonation: [
            "54",
            "45"
        ],
        ending: [
            "43",
            "45",
            "4",
            "2"
        ],
        liber: "IV"
    },
    5.1: {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6",
            "5?",
            "5~"
        ],
        ending: [
            "/6",
            "4?",
            "4",
            "/5",
            "3?",
            "3"
        ],
        liber: "V"
    },
    5.2: {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6",
            "5?",
            "5~"
        ],
        ending: [
            "/6",
            "4?",
            "4",
            "/5",
            "3?",
            "3"
        ],
        liber: "V"
    },
    5.3: {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6",
            "5?",
            "5~"
        ],
        ending: [
            "/6",
            "4?",
            "4",
            "/5",
            "3?",
            "3"
        ],
        liber: "V"
    },
    "5n": {
        clef: "c5",
        intonation: [
            "1",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "6",
            "/6",
            "5?",
            "5~"
        ],
        secondIntonation: [
            "3",
            "5"
        ],
        ending: [
            "/6",
            "4?",
            "4",
            "/5",
            "3?",
            "3"
        ],
        liber: "V"
    },
    "6a": {
        // for canticles
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "/5",
            "3?",
            "3~"
        ],
        ending: [
            "3",
            "45",
            "/4",
            "3?",
            "3"
        ],
        liber: "VI"
    },
    "6ac2": {
        clef: "c5",
        intonation: [
            "5",
            "67"
        ],
        recitingNote: 7,
        mediant: [
            "6",
            "/7",
            "5?",
            "5~"
        ],
        ending: [
            "5",
            "67",
            "/6",
            "5?",
            "5"
        ],
        liber: "VI"
    },
    "6b": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "3",
            "45",
            "/4",
            "3?",
            "3"
        ],
        liber: "VI"
    },
    "6c": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "5?",
            "/4",
            "5?",
            "5"
        ],
        ending: [
            "3",
            "45",
            "/4",
            "3?",
            "3"
        ],
        liber: "VI"
    },
    "6n": {
        clef: "c7",
        intonation: [
            "34",
            "43",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "/6b",
            "5?",
            "5",
            "/4",
            "3?",
            "3."
        ],
        secondIntonation: [
            "3",
            "45"
        ],
        //secondMediant: ["/57", "4", "3?"],
        //secondRecitingNote: 3,
        ending: [
            "/57",
            "4",
            "3?",
            "3?",
            "3?",
            "3",
            "4",
            "31",
            "3",
            "/4",
            "3?",
            "3."
        ]
    },
    "6ood": {
        clef: "c7",
        intonation: [
            "3",
            "45"
        ],
        recitingNote: 5,
        mediant: [
            "4",
            "/3",
            "3?"
        ],
        ending: [
            "3",
            "/4",
            "4?"
        ],
        liber: "VI"
    },
    7.1: {
        clef: "c5",
        intonation: [
            "54",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7",
            "7?",
            "/6",
            "7?",
            "7"
        ],
        ending: [
            "/7",
            "6",
            "6?",
            "/5",
            "5?",
            "43"
        ],
        liber: "VII a"
    },
    7.2: {
        clef: "c5",
        intonation: [
            "54",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7",
            "7?",
            "/6",
            "7?",
            "7"
        ],
        ending: [
            "/7",
            "6",
            "6?",
            "/5",
            "5?",
            "45"
        ],
        liber: "VII c"
    },
    7.3: {
        clef: "c5",
        intonation: [
            "54",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7",
            "7?",
            "/6",
            "7?",
            "7"
        ],
        ending: [
            "/7",
            "6",
            "6?",
            "/5",
            "5?",
            "4"
        ],
        liber: "VII b"
    },
    7.4: {
        clef: "c5",
        intonation: [
            "54",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7",
            "7?",
            "/6",
            "7?",
            "7"
        ],
        ending: [
            "/7",
            "6",
            "6?",
            "/5",
            "5?",
            "46"
        ],
        liber: "VII d"
    },
    7.5: {
        clef: "c5",
        intonation: [
            "54",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7",
            "7?",
            "/6",
            "7?",
            "7"
        ],
        ending: [
            "/7",
            "6",
            "6?",
            "/5",
            "5?",
            "65"
        ],
        liber: "VII c\xb2"
    },
    7.6: {
        clef: "c5",
        intonation: [
            "54",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7",
            "7?",
            "/6",
            "7?",
            "7"
        ],
        ending: [
            "/7",
            "6",
            "6?",
            "/5",
            "5?",
            "65"
        ],
        liber: "VII c\xb2"
    },
    7.7: {
        clef: "c5",
        intonation: [
            "54",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "/8",
            "7",
            "7?",
            "/6",
            "7?",
            "7"
        ],
        ending: [
            "/7",
            "6",
            "6?",
            "/5",
            "5?",
            "4"
        ],
        liber: "VII b"
    },
    "7n": {
        clef: "c5",
        intonation: [
            "254",
            "56"
        ],
        recitingNote: 6,
        mediant: [
            "/68",
            "7",
            "7?",
            "7?",
            "76",
            "67"
        ],
        secondIntonation: [
            "64",
            "56"
        ],
        ending: [
            "678w",
            "6",
            "5",
            "555",
            "32"
        ]
    },
    8.1: {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7~"
        ],
        ending: [
            "6",
            "7",
            "/5",
            "4?",
            "4"
        ],
        liber: "VIII G"
    },
    "8.1trans": {
        clef: "c5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "/3.",
            "2?",
            "2."
        ],
        liber: "VIII G"
    },
    8.2: {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7~"
        ],
        ending: [
            "5",
            "7",
            "/8",
            "7?",
            "7"
        ],
        liber: "VIII c"
    },
    8.3: {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7~"
        ],
        ending: [
            "5",
            "7",
            "/8",
            "7?",
            "7"
        ],
        liber: "VIII c"
    },
    8.5: {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7~"
        ],
        ending: [
            "6",
            "7",
            "/5",
            "4?",
            "45"
        ],
        liber: "VIII G*"
    },
    8.6: {
        clef: "c7",
        intonation: [
            "4",
            "5",
            "7"
        ],
        recitingNote: 7,
        mediant: [
            "/8",
            "7?",
            "7~"
        ],
        ending: [
            "6",
            "7",
            "/5",
            "4?",
            "45"
        ],
        liber: "VIII G*"
    },
    "8.6trans": {
        clef: "c5",
        intonation: [
            "2",
            "3",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6.",
            "5?",
            "5.~"
        ],
        ending: [
            "4",
            "5",
            "/3.",
            "2?",
            "23."
        ],
        liber: "VIII G"
    },
    "8n": {
        clef: "c7",
        intonation: [
            "4",
            "54",
            "47"
        ],
        recitingNote: 7,
        mediant: [
            "76",
            "78",
            "8",
            "/78",
            "7?",
            "7"
        ],
        secondIntonation: [
            "75",
            "57"
        ],
        ending: [
            "776",
            "45",
            "76",
            "/5",
            "5?",
            "4"
        ]
    },
    "Tonus Peregrinus A": {
        clef: "c7",
        intonation: [
            "56b",
            "5"
        ],
        recitingNote: 5,
        mediant: [
            "/6b",
            "5",
            "/4",
            "3?",
            "3"
        ],
        secondRecitingNote: 4,
        ending: [
            "1",
            "/3",
            "3?",
            "21"
        ],
        liber: "T.P."
    }
};


const $8da148c2c45b952c$export$f846b1f6e107a70c = (refText)=>{
    if (refText.includes(":")) {
        const parts = refText.split(/[:-]/g).map((part)=>parseInt(part));
        return {
            type: "section",
            number: parts[0],
            firstVerse: parts[1],
            lastVerse: parts[2]
        };
    } else return {
        type: "full",
        number: parseInt(refText)
    };
};
const $8da148c2c45b952c$export$db824001adbaa732 = (psalmRef)=>{
    if (psalmRef.type === "full") return `Psalm ${psalmRef.number}`;
    else return `Psalm ${psalmRef.number}:${psalmRef.firstVerse}-${psalmRef.lastVerse}`;
};
const $8da148c2c45b952c$var$normalizeText = (text)=>{
    return text.replace(" * ", " ").replace(/\./g, "").replace(/:/g, "").replace(/,/g, "").replace(/;/g, "").replace(/\!/g, "").replace(/\?/g, "").replace(/\~/g, "").replace(/\'/g, "").replace(/\(/g, "").replace(/\)/g, "").toLocaleLowerCase();
};
const $8da148c2c45b952c$export$6701fca49c714eb = (rawPsalms)=>{
    const words = new Set([]);
    rawPsalms.forEach((psalm)=>{
        psalm.lines.forEach((line)=>{
            $8da148c2c45b952c$var$normalizeText(line).split(" ").forEach((word)=>{
                words.add(word);
            });
        });
    });
    const result = [];
    words.forEach((word)=>{
        result.push([
            word,
            word
        ]);
    });
    return result;
};
const $8da148c2c45b952c$var$getHyphenDictionary = ()=>{
    const result = {};
    (0, $b5ba7a3b4030cdca$export$ba83f0dc94d99a1d).forEach(([word, hyphenation])=>{
        result[word] = hyphenation;
    });
    return result;
};
const $8da148c2c45b952c$var$getSyllables = (dictionary, word)=>{
    const pattern = dictionary[$8da148c2c45b952c$var$normalizeText(word)];
    let patternPointer = 0;
    let wordPointer = 0;
    const result = [];
    let curr = "";
    while(wordPointer < word.length){
        if (pattern[patternPointer] === "-") {
            result.push(curr);
            curr = "";
            patternPointer++;
        } else if (pattern[patternPointer] === "_") {
            curr += "-";
            result.push(curr);
            curr = "";
            patternPointer++;
            wordPointer++;
        } else if (pattern[patternPointer] === word[wordPointer].toLocaleLowerCase()) {
            curr += word[wordPointer];
            patternPointer++;
            wordPointer++;
        } else {
            curr += word[wordPointer];
            wordPointer++;
        }
    }
    return result.concat([
        curr
    ]);
};
const $8da148c2c45b952c$export$e439a9577e5b17df = (rawPsalms)=>{
    const hyphenDictionary = $8da148c2c45b952c$var$getHyphenDictionary();
    const result = [];
    rawPsalms.forEach((psalm)=>{
        const lines = psalm.lines.map((line)=>{
            const halves = line.split("*");
            return halves.map((half)=>{
                const words = half.trim().split(" ");
                return words.map((word)=>$8da148c2c45b952c$var$getSyllables(hyphenDictionary, word).join("_")).join(" ");
            });
        });
        result.push({
            id: `psalm${psalm.psalm}`,
            lines: lines
        });
    });
    return result;
};
const $8da148c2c45b952c$export$71a6da0b33b4c032 = (rawPsalms)=>{
    const hyphenDictionary = $8da148c2c45b952c$var$getHyphenDictionary();
    return rawPsalms.map((psalm)=>{
        return psalm.lines.map((line)=>{
            const halves = line.split("*");
            return halves.map((half)=>{
                const words = half.trim().split(" ");
                return words.map((word)=>$8da148c2c45b952c$var$getSyllables(hyphenDictionary, word));
            });
        });
    });
};
const $8da148c2c45b952c$export$40045568ea82b4e3 = (rawHalf)=>{
    const half = rawHalf.split(" ").map((word)=>word.split("_"));
    let pointer = half.length;
    let syllables = 0;
    while(syllables < 6 && pointer > 0){
        pointer--;
        syllables += half[pointer].length;
    }
    const ending = half.slice(pointer).map((syllables)=>syllables.join("_")).join(" ");
    return $8da148c2c45b952c$var$normalizeText(ending);
};
const $8da148c2c45b952c$export$cb4de6427ee7ed64 = ()=>{
    const endings = {};
    (0, $7f98b4308afe4768$export$adc377d3f4f7a592).forEach((text)=>{
        text.lines.forEach((line)=>{
            line.forEach((rawHalf)=>{
                const ending = $8da148c2c45b952c$export$40045568ea82b4e3(rawHalf);
                if (!endings[ending]) endings[ending] = {
                    tagged: ending,
                    examples: [
                        rawHalf
                    ]
                };
                else endings[ending].examples.push(rawHalf);
            });
        });
    });
    return endings;
};
const $8da148c2c45b952c$export$59b14e03afbf9ee8 = (half, emphasisDb)=>{
    if (half.includes("/")) {
        // Already has stress marks
        const emphasisPoints = [];
        half.replace(/_/g, " ").split(" ").reverse().forEach((syllable, syllableIndex)=>{
            if (syllable[0] === "/") emphasisPoints.push(syllableIndex + 1);
        });
        return emphasisPoints;
    } else {
        // Needs stress marks based on the ending
        const ending = $8da148c2c45b952c$export$40045568ea82b4e3(half);
        const emphasisPoints = [];
        const finalEmphasisDatabase = emphasisDb ?? {};
        try {
            finalEmphasisDatabase[ending].tagged.replace(/_/g, " ").split(" ").reverse().forEach((syllable, syllableIndex)=>{
                if (syllable[0] === "/") emphasisPoints.push(syllableIndex + 1);
            });
        } catch  {
            throw new Error(`ENDING BROKEN FOR [${ending}]`);
        }
        if (!finalEmphasisDatabase[ending].tagged.includes("/")) throw new Error(`No emphasis points included for [${ending}]`);
        return emphasisPoints;
    }
};
const $8da148c2c45b952c$export$15512d11fbbb20af = (noteString)=>{
    const notes = [];
    Array.from(noteString.replace(".", "").replace("/", "")).forEach((char)=>{
        if (char === "b") notes[notes.length - 1] += "b";
        else notes.push(char);
    });
    return notes;
};
const $8da148c2c45b952c$export$8201ef773ec0d6c0 = (half, recitingNote, ending, intonation, emphasisDb)=>{
    // Compute all the possible tone endings (at most 4)
    let toneEndings = [
        []
    ];
    ending.forEach((syllable)=>{
        if (syllable[syllable.length - 1] === "?") toneEndings = toneEndings.concat(toneEndings.map((ending)=>ending.concat([
                syllable
            ])));
        else if (syllable[syllable.length - 1] === "~") toneEndings = toneEndings.filter((toneEnding)=>toneEnding.length === toneEndings[0].length).concat(toneEndings.map((ending)=>ending.concat([
                syllable
            ]))).concat(toneEndings.filter((toneEnding)=>toneEnding.length > toneEndings[0].length));
        else toneEndings.forEach((ending)=>ending.push(syllable));
    });
    // Work out which ending matches the half best
    const halfEmphasisPoints = $8da148c2c45b952c$export$59b14e03afbf9ee8(half, emphasisDb);
    let bestEnding = [];
    let bestEndingScore = -1;
    toneEndings.forEach((toneEnding)=>{
        const endingEmphasisPoints = toneEnding.slice().reverse().map((syllable, syllableIndex)=>syllable[0] === "/" ? syllableIndex + 1 : 0).filter((point)=>point > 0);
        const score = endingEmphasisPoints.filter((point)=>halfEmphasisPoints.includes(point)).length;
        if (score > bestEndingScore) {
            bestEnding = toneEnding;
            bestEndingScore = score;
        }
    });
    bestEnding = bestEnding.map((note)=>note.replace("/", "").replace("?", "").replace("~", ""));
    // Don't use the intonation if there aren't enough syllables
    if (intonation.length + bestEnding.length > half.replace(/ /g, "_").split("_").length) intonation = [];
    // Generate the pointed words
    const totalSyllables = half.replace(/_/g, " ").split(" ").length;
    let syllableIndex = 0;
    let dotUsed = false;
    return half.replace(/\//g, "").split(" ").map((word)=>{
        const pointedWord = {
            syllables: []
        };
        word.split("_").forEach((syllable)=>{
            let noteString = `${syllableIndex < intonation.length ? intonation[syllableIndex] : recitingNote}`;
            let dotBefore = false;
            if (syllableIndex >= totalSyllables - bestEnding.length) {
                if (!dotUsed) {
                    dotBefore = true;
                    dotUsed = true;
                }
                noteString = bestEnding[syllableIndex - (totalSyllables - bestEnding.length)];
            }
            pointedWord.syllables.push({
                text: syllable,
                notes: $8da148c2c45b952c$export$15512d11fbbb20af(noteString),
                long: noteString.includes("."),
                dotBefore: dotBefore
            });
            syllableIndex++;
        });
        return pointedWord;
    });
};
const $8da148c2c45b952c$export$67c5240321e9091f = (refString, emphasisDb)=>{
    const psalmRef = $8da148c2c45b952c$export$f846b1f6e107a70c(refString);
    const id = `psalm${psalmRef.number}`;
    const textData = (0, $7f98b4308afe4768$export$adc377d3f4f7a592).find((td)=>td.id === id);
    if (!textData) throw new Error(`Could not find the text for ${id}`);
    const lines = psalmRef.type === "full" ? textData.lines : textData.lines.slice(psalmRef.firstVerse - 1, psalmRef.lastVerse);
    const endings = [];
    lines.forEach((line)=>{
        try {
            $8da148c2c45b952c$export$8201ef773ec0d6c0(line[0], 5, [], [], emphasisDb);
        } catch (error) {
            endings.push({
                ending: $8da148c2c45b952c$export$40045568ea82b4e3(line[0]),
                verse: line
            });
        }
        try {
            $8da148c2c45b952c$export$8201ef773ec0d6c0(line[1], 5, [], [], emphasisDb);
        } catch  {
            endings.push({
                ending: $8da148c2c45b952c$export$40045568ea82b4e3(line[1]),
                verse: line
            });
        }
    });
    return endings;
};
const $8da148c2c45b952c$export$30094a79c9c7227e = (lines, toneId, gloriaPatri, intoneEveryVerse, emphasisDb)=>{
    const tone = (0, $c07cc9090462c085$export$af3a35665fe7186d)(toneId);
    if (gloriaPatri) lines = lines.concat((0, $a6cfd8f7f51b9dd9$export$a35df4ef14d66b3));
    return {
        clef: tone.clef,
        verses: lines.map((line, lineIndex)=>{
            return {
                firstHalf: $8da148c2c45b952c$export$8201ef773ec0d6c0(line[0], tone.recitingNote, tone.mediant, lineIndex === 0 || intoneEveryVerse ? tone.intonation : [], emphasisDb),
                secondHalf: $8da148c2c45b952c$export$8201ef773ec0d6c0(line[1], tone.secondRecitingNote ?? tone.recitingNote, tone.ending, [], emphasisDb)
            };
        })
    };
};
const $8da148c2c45b952c$var$getPointedAntiphonPart = (text, intonation, recitingNote, ending, firstCap, startWithQBar)=>{
    const words = text.split(" ");
    let totalSyllables = 0;
    words.forEach((word)=>{
        totalSyllables += word.split("_").length;
    });
    const pointedWords = [];
    let syllableIndex = 0;
    words.forEach((word, wordIndex)=>{
        const syllables = [];
        (firstCap && (wordIndex === 0 || wordIndex === 1 && words[0].length === 1) ? word.toLocaleUpperCase() : word).split("_").forEach((syllable)=>{
            if (syllableIndex < intonation.length && totalSyllables >= intonation.length + ending.length) {
                // Use intonation for note
                syllables.push({
                    text: syllable,
                    notes: $8da148c2c45b952c$export$15512d11fbbb20af(intonation[syllableIndex]),
                    long: false,
                    dotBefore: false
                });
                syllableIndex++;
            } else {
                const endingIndex = syllableIndex - (totalSyllables - ending.length);
                if (endingIndex >= 0) {
                    // Use ending for note
                    syllables.push({
                        text: syllable,
                        notes: $8da148c2c45b952c$export$15512d11fbbb20af(ending[endingIndex]),
                        long: ending[endingIndex][ending[endingIndex].length - 1] === ".",
                        dotBefore: endingIndex === 0,
                        qBarBefore: syllableIndex === 0 && startWithQBar
                    });
                    syllableIndex++;
                } else {
                    // Use reciting note
                    syllables.push({
                        text: syllable,
                        notes: [
                            `${recitingNote}`
                        ],
                        long: false,
                        dotBefore: false,
                        qBarBefore: syllableIndex === 0 && startWithQBar
                    });
                    syllableIndex++;
                }
            }
        });
        pointedWords.push({
            syllables: syllables
        });
    });
    return pointedWords;
};
const $8da148c2c45b952c$export$3f976a3262e985fa = (text, toneId)=>{
    const parts = text.replace(/-/g, "_").replace(/ \* /g, " ").replace(/~/g, "-").split("|");
    const initParts = parts.slice(0, parts.length - 1);
    const finalPart = parts[parts.length - 1];
    const tone = (0, $c07cc9090462c085$export$af3a35665fe7186d)(toneId);
    const firstHalf = [];
    initParts.forEach((part, index)=>{
        const pointedWords = $8da148c2c45b952c$var$getPointedAntiphonPart(part, index === 0 ? tone.intonation : [], tone.recitingNote, tone.mediant, index === 0, index !== 0);
        firstHalf.push(...pointedWords);
    });
    return {
        clef: tone.clef,
        verses: [
            {
                firstHalf: firstHalf,
                secondHalf: $8da148c2c45b952c$var$getPointedAntiphonPart(finalPart, [], tone.secondRecitingNote ?? tone.recitingNote, tone.ending, false, false)
            }
        ]
    };
};
const $8da148c2c45b952c$export$b4b9f8f66b7dc49d = (psalmRef, toneId, gloriaPatri)=>{
    const id = `psalm${psalmRef.number}`;
    const textData = (0, $7f98b4308afe4768$export$adc377d3f4f7a592).find((td)=>td.id === id);
    if (!textData) throw new Error(`Could not find the text for ${id}`);
    const lines = psalmRef.type === "full" ? textData.lines : textData.lines.slice(psalmRef.firstVerse - 1, psalmRef.lastVerse);
    return $8da148c2c45b952c$export$30094a79c9c7227e(lines, toneId, gloriaPatri, false);
};
const $8da148c2c45b952c$export$aff03f17ba557a93 = (id, toneId)=>{
    return $8da148c2c45b952c$export$30094a79c9c7227e((0, $18044fa0a9c67a92$export$f4d796ac76f915d6)[id].lines, toneId, id !== "te deum", id !== "venite" && id !== "te deum" && id !== "benedictus es" && id !== "quicunque vult");
};
const $8da148c2c45b952c$export$956628726129226c = (toneId)=>{
    switch(toneId[0]){
        case "1":
            return "1a.1";
        case "2":
            return "2.1";
        case "3":
            return "3a.4";
        case "4":
            return "4.7";
        case "5":
            return "5.1";
        case "6":
            return "6a";
        case "7":
            return "7.5";
        case "8":
            return "8.1";
        case "T":
            return "Tonus Peregrinus A";
    }
    throw new Error("Invalid tone");
};


const $4fae7b70f2712114$export$47fe3383e0215c92 = (omitFirst)=>{
    const result = [];
    if (!omitFirst) {
        result.push({
            type: "chant",
            boldMode: "none",
            tone: "5.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "1"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "o",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "pen",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thou",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "lips.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        });
        result.push({
            type: "chant",
            boldMode: "all",
            tone: "5.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "1"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "mouth",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "shall",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "show",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "forth",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "praise.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        });
    }
    result.push({
        type: "chant",
        boldMode: "none",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "O",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "God,",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "make",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "speed",
                                    notes: [
                                        "8"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "save",
                                    notes: [
                                        "6"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: [
                                        "7"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    result.push({
        type: "chant",
        boldMode: "all",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "O",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Lord,",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "make",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "haste",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "help",
                                    notes: [
                                        "6"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: [
                                        "7"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    result.push({
        type: "chant",
        boldMode: "none",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Glo",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "ry",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "be",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Fa",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "ther,",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "and",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Son,",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "and",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Ho",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "ly",
                                    notes: [
                                        "6"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Ghost.",
                                    notes: [
                                        "7"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    result.push({
        type: "chant",
        boldMode: "all",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "As",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "it",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "was",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "in",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "be",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "ginn",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "ing,",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "is",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "now,",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "and",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "e",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "ver",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "shall",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "be,",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "world",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "with",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "out",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "end.",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "A",
                                    notes: [
                                        "6"
                                    ],
                                    long: true,
                                    dotBefore: false
                                },
                                {
                                    text: "men.",
                                    notes: [
                                        "7"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    result.push({
        type: "chant",
        boldMode: "none",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Praise",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "ye",
                                    notes: [
                                        "7",
                                        "8"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Lord.",
                                    notes: [
                                        "7",
                                        "6"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    result.push({
        type: "chant",
        boldMode: "all",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "The",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Lord's",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Name",
                                    notes: [
                                        "7",
                                        "8"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "be",
                                    notes: [
                                        "7"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "prais-",
                                    notes: [
                                        "7",
                                        "6"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "ed.",
                                    notes: [
                                        "6"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    return result;
};


const $8572c14473ccb858$export$d75431e321b6a7a8 = {
    "1662": [
        {
            text: "When the wicked man turneth away from his wickedness that he hath committed, and doeth that which is lawful and right, he shall save his soul alive.",
            ref: "Ezekiel 18:27"
        },
        {
            text: "I acknowledge my transgressions, and my sin is ever before me.",
            ref: "Psalm 51:3"
        },
        {
            text: "Hide thy face from my sins, and blot out all mine iniquities.",
            ref: "Psalm 51:9"
        },
        {
            text: "The sacrifices of God are a broken spirit: a broken and a contrite heart, O God, thou wilt not despise.",
            ref: "Psalm 51:17"
        },
        {
            text: "Rend your heart, and not your garments, and turn unto the Lord your God: for he is gracious and merciful, slow to anger, and of great kindness, and repenteth him of the evil.",
            ref: "Joel 2:13"
        },
        {
            text: "To the Lord our God belong mercies and forgivenesses, though we have rebelled against him: neither have we obeyed the voice of the Lord our God, to walk in his laws which he set before us.",
            ref: "Daniel 9:9"
        },
        {
            text: "O Lord, correct me, but with judgement; not in thine anger, lest thou bring me to nothing.",
            ref: "Jeremiah 10:24"
        },
        {
            text: "Repent ye; for the Kingdom of heaven is at hand.",
            ref: "St. Matthew 3:2"
        },
        {
            text: "I will arise and go to my father, and will say unto him, Father, I have sinned against heaven, and before thee, and am no more worthy to be called thy son.",
            ref: "St. Luke 15:18-19"
        },
        {
            text: "Enter not into judgement with thy servant, O Lord; for in thy sight shall no man living be justified.",
            ref: "Psalm 143:2"
        },
        {
            text: "If we say that we have no sin, we deceive ourselves, and the truth is not in us: but if we confess our sins, he is faithful and just to forgive us our sins, and to cleanse us from all unrighteousness.",
            ref: "1 St. John 1:8-9"
        }
    ],
    advent: [
        {
            text: "I shall see him, but not now. I shall behold him, but not now. There shall come a Star out of Jacob, and a Scepter shall rise out of Israel.",
            ref: "Numbers 24:17"
        },
        {
            text: "The Lord shall judge the ends of the earth, and he shall give strength unto his king, and exalt the horn of his Anointed.",
            ref: "1 Samuel 2:10"
        },
        {
            text: "Prepare ye the way of the Lord; make straight in the desert a highway for our God.",
            ref: "Isaiah 40:3"
        },
        {
            text: "And the glory of the Lord shall be revealed, and all flesh shall see it together.",
            ref: "Isaiah 40:5"
        },
        {
            text: "Behold, the days come, saith the Lord, that I will raise unto David a righteous Branch, and a King shall reign and prosper, and shall execute judgment and justice in the earth.",
            ref: "Jeremiah 23:5"
        },
        {
            text: "Repent ye, for the kingdom of heaven is at hand.",
            ref: "Matthew 3:2"
        },
        {
            text: "The time is fulfilled, and the kingdom of heaven is at hand. Repent ye, and believe the Gospel.",
            ref: "Mark 1:15"
        },
        {
            text: "Jesus said, The powers that are in Heaven shall be shaken. And then shall they see the Son of man coming in the clouds, with great power and glory.",
            ref: "Mark 13:25"
        },
        {
            text: "Watch ye, for ye know not when the master of the house cometh \u2014 at even, or at midnight, or at the cock crowing, or in the morning \u2014 lest coming suddenly, he find you asleep.",
            ref: "Mark 13:35"
        },
        {
            text: "The night is far spent, the day is at hand: let us therefore cast off the works of darkness, and let us put on the armour of light.",
            ref: "Romans 13:12"
        },
        {
            text: "If they escaped not who refused him that spake on earth, much more shall we not escape if we turn away from him that speaketh from Heaven.",
            ref: "Hebrews 12:25"
        },
        {
            text: "If thou shalt not watch, I will come on thee as a thief, and thou shalt not know at what hour I will come upon thee.",
            ref: "Revelation 3:3"
        },
        {
            text: "Behold, I come quickly, hold that fast which thou hast, that no man take thy crown.",
            ref: "Revelation 3:11"
        },
        {
            text: "Behold, I come quickly, and my reward is with me, to give every man according as his work shall be.",
            ref: "Revelation 22:12"
        }
    ],
    christmas: [
        {
            text: "Mary shall bring forth a son, and thou shalt call his name Jesus, for he shall save his people from their sins.",
            ref: "Matthew 1:21"
        },
        {
            text: "Mary brought forth her first-born Son, and wrapped him in swaddling clothes, and laid him in a manger, because there was no room for them in the inn.",
            ref: "Luke 2:7"
        },
        {
            text: "Behold, I bring you good tidings of great joy, which shall be to all people. For unto you is born this day in the city of David a Saviour, which is Christ the Lord.",
            ref: "Luke 2:10"
        },
        {
            text: "Behold, the tabernacle of God is with men, and he will dwell with them, and they shall be his people, and God himself shall be with them, and be their God.",
            ref: "Revelation 21:3"
        },
        {
            text: "The Word was made flesh, and dwelt among us, and we beheld his glory, the glory as of the only-begotten of the Father, full of grace and truth.",
            ref: "John 1:14"
        }
    ],
    epiphany: [
        {
            text: "Arise, shine; for thy light has come, and the glory of the Lord is risen upon thee.",
            ref: "Isaiah 51:1"
        },
        {
            text: "All they from Sheba shall come; they shall bring gold and incense; and they shall show forth the praises of the Lord.",
            ref: "Isaiah 60:6"
        },
        {
            text: "Awake, awake, put on thy strength O Sion, put on thy beautiful garments, O Jerusalem the holy city.",
            ref: "Isaiah 52:1"
        },
        {
            text: "I will give thee for a light to the Gentiles, that thou mayest be my salvation, unto the end of the earth.",
            ref: "Isaiah 49:6"
        },
        {
            text: "The Gentiles shall come to thy light, and kings to the brightness of thy rising.",
            ref: "Isaiah 63:3"
        },
        {
            text: "From the rising of the sun even unto the going down of the same my Name shall be great among the Gentiles; and in every place incense shall be offered unto my Name, and a pure offering: for my Name shall be great among the heathen, saith the LORD of hosts.",
            ref: "Malachi 1:11"
        },
        {
            text: "Lo, the star which the wise men saw in the East went before them, till it came and stood over where the young Child was.",
            ref: "Matthew 2:9"
        },
        {
            text: "When the wise men saw the star, they rejoiced with exceeding great joy. And when they were coming into the house, they saw the young Child with Mary his Mother, and fell down, and worshipped him.",
            ref: "Matthew 2:10"
        },
        {
            text: "John the Baptist said, I have need to be baptised of thee, and comest thou to me? And Jesus answering said unto him, Suffer it to be so now: for thus it becometh us to fulfill all righteousness.",
            ref: "Matthew 3:14-15"
        },
        {
            text: "Jesus came from Nazareth of Galilee, and was baptised of John in the Jordan. And there came a voice from Heaven saying, Thou art my beloved Son, in whom I am well pleased.",
            ref: "Mark 1:9-11"
        },
        {
            text: "John the Baptist said, He that sent me to baptise with water, the same said unto me, Upon whom thou shalt see the Spirit descending, and remaining on him, the same is he which baptiseth with the Holy Ghost. And I saw, and bare record, that this is the Son of God.",
            ref: "John 1:33,34"
        }
    ],
    lent: [
        {
            text: "Moses said, fear not: for God is come to prove you, and that his fear may be before your faces, that ye sin not.",
            ref: "Exodus 20:20"
        },
        {
            text: "I acknowledge my transgressions, and my sin is ever before me.",
            ref: "Psalm 51:3"
        },
        {
            text: "The sacrifice of God is a troubled spirit; a broken and contrite heart, O God, shalt thou not despise.",
            ref: "Psalm 51:7"
        },
        {
            text: "Let the wicked forsake his way, and the unrighteous man his thoughts, and let him return unto the Lord, and he will have mercy upon him; and to our God, for he will abundantly pardon.",
            ref: "Isaiah 55:7"
        },
        {
            text: "Cry aloud, spare not, lift up thy voice like a trumpet, and show my people their transgression, and the house of Jacob their sin.",
            ref: "Isaiah 58:1"
        },
        {
            text: "To the Lord our God belong mercies and forgivenesses, though we have rebelled against him; neither have we obeyed the voice of the LORD our God, to walk in his laws which he set before us.",
            ref: "Daniel 9:9-10"
        },
        {
            text: "Rend your heart, and not your garments, and turn unto the LORD your God: for he is gracious and merciful, slow to anger, and of great kindness.",
            ref: "Joel 2:13"
        },
        {
            text: "Let the priests, the ministers of the Lord, weep between the porch and the altar, and let them say, Spare thy people, O Lord, and give not thine heritage to reproach, that the heathen should rule over them.",
            ref: "Joel 2:17"
        },
        {
            text: "Why do the disiples of John, and of the Pharisees fast, but thy disciples fast not? And Jesus said, The days will come, when the Bridegroom shall be taken away from them, and then shall they fast in those days.",
            ref: "Mark 2:18-20"
        },
        {
            text: "Jesus said, Whosoever will come after me, let him deny himself, and take up his cross, and follow me.",
            ref: "Mark 8:34"
        },
        {
            text: "I will arise and go to my Father, and will say unto him, Father, I have sinned against heaven, and before thee, and am no more worthy to be called thy son.",
            ref: "Luke 15:18-19"
        },
        {
            text: "We ourselves also were sometimes foolish, disobedient, deceived, serving diverse lusts and pleasures, living in malice and envy, hateful, and hating one another. But after the kindness and love of God our Saviour toward man appeared, he saved us.",
            ref: "Titus 3:3-5"
        },
        {
            text: "Let us lay aside every weight, and the sin which doth so easily beset us, and let us run with patience unto the race that is set before us. Looking unto Jesus, the Author and Finisher of our faith.",
            ref: "Hebrews 12:1-2"
        },
        {
            text: "Pure religion and undefiled before God the Father is this, To visit the fatherless and widows in their affliction, and to keep himself unspotted from the world.",
            ref: "James 1:27"
        },
        {
            text: "Dearly beloved: I beseech you as strangers and pilgrims, abstain from fleshly lusts, which war against the soul.",
            ref: "1 Peter 2:11"
        },
        {
            text: "If we say we have no sin, we deceive ourselves, and the truth is not in us; but if we confess our sins, God is faithful and just to forgive us our sins, and to cleanse us from all unrighteousness.",
            ref: "1 John 1:8-9"
        },
        {
            text: "Jesus said, Be watchful, and strengthen the things which remain, that are ready to die: for I have not found thy works perfect before God.",
            ref: "Revelation 3:2"
        },
        {
            text: "Jesus said, Remember how thou hast received and heard, and hold fast, and repent.",
            ref: "Revelation 3:3"
        },
        {
            text: "The dragon was wroth with the woman, and went to make war with the remnant of her seed, which keep the commandments of God, and have the testimony of Jesus Christ.",
            ref: "Revelation 12:17"
        },
        {
            text: "Babylon the great is fallen, is fallen. Come out of her, my people, that ye be not partakers of her sins, and that ye receive not of her plagues: for her sins have reached unto Heaven, and God hath remembered her iniquities.",
            ref: "Revelation 18:2,4-5"
        },
        {
            text: "Jesus said, The fearful, and unbelieving, and the abominable, and murderers, and whoremongers, and sorcerers, and idolators, and all liars, shall have their part in the lake which burneth with fire and brimstone.",
            ref: "Revelation 21:8"
        }
    ],
    passiontide: [
        {
            text: "I gave my back to the smiters, and my cheeks to them that plucked off the hair: I hid not my face from shame and spitting.",
            ref: "Isaiah 50:6"
        },
        {
            text: "He is despised and rejected of men; a Man of sorrows, and acquainted with grief. Surely he hath borne our griefs, and carried our sorrows.",
            ref: "Isaiah 53:3-4"
        },
        {
            text: "He was wounded for our transgressions, he was bruised for our iniquities: the chastisement of our peace was upon him, and with his stripes we are healed.",
            ref: "Isaiah 53:5"
        },
        {
            text: "All we like sheep have gone astray; we have turned every one to his own way; and the Lord hath laid on him the iniquity of us all.",
            ref: "Isaiah 53:6"
        },
        {
            text: "He hath poured out his soul unto death: and he was numbered with the transgressors, and he bare the sins of many, and made intercession for the transgressors.",
            ref: "Isaiah 53:12"
        },
        {
            text: "O Lord, the hope of Israel, all that forsake thee shall be ashamed, and they that depart from thee shall be written in the earth, because they have forsaken the Lord, the Fountain of living waters.",
            ref: "Jeremiah 17:13"
        },
        {
            text: "Is it nothing to you, all ye that pass by? Behold, and see if there be any sorrow like unto my sorrow which is done unto me, wherewith the Lord hath afflicted me.",
            ref: "Lamentations 1:12"
        },
        {
            text: "In Christ we have redemption though his blood, the forgiveness of sins, according to the riches of his grace.",
            ref: "Ephesians 1:7"
        },
        {
            text: "He humbled himself, and became obedient unto death, even the death of the Cross. Wherefore God hath highly exalted him, and given him a Name which is above every name.",
            ref: "Philippians 2:8"
        },
        {
            text: "Let us run with patience unto the race that is set before us. Looking unto Jesus, the Author and Finisher of our faith, who for the joy that was set before him, endured the Cross, despising the shame.",
            ref: "Hebrews 12:1-2"
        },
        {
            text: "Worthy is the Lamb who was slain, to receive power, and riches, and wisdom, and strength, and honor, and glory, and blessing.",
            ref: "Revelation 5:12"
        }
    ],
    easter: [
        {
            text: "This is the day that the LORD hath made; we will rejoice and be glad in it.",
            ref: "Psalm 118:24"
        },
        {
            text: "The LORD of hosts will swallow up death in victory, and the Lord God will wipe away tears from off all faces.",
            ref: "Isaiah 25:8"
        },
        {
            text: "Ye seek Jesus of Nazareth, which was crucified: he is risen, he is not here: behold the place where they laid him.",
            ref: "Mark 16:6"
        },
        {
            text: "He is risen. The Lord is risen indeed.",
            ref: "Luke 24:34"
        },
        {
            text: "Jesus said unto Martha, I am the Resurrection, and the Life: he that believeth in me, though he were dead, yet shall he live. And whosoever liveth and believeth in me, shall never die.",
            ref: "John 11:24"
        },
        {
            text: "Jesus said unto Thomas, Reach hither thy finger, and behold my hands, and reach hither thy hand, and thrust it into my side, and be not faithless, but believing. And Thomas answered, and said unto him, My Lord, and my God.",
            ref: "John 20:27-28"
        },
        {
            text: "Jesus of Nazareth they slew and hanged on a tree. Him God raised up the third day, and showed him openly.",
            ref: "Acts 10:39-40"
        },
        {
            text: "Christ being raised from the dead dieth no more; death hath no dominion over him. For in that he died, he died unto sin once; but in that he liveth, he liveth unto God.",
            ref: "Romans 6:9"
        },
        {
            text: "If in this life only we have hope in Christ, we are of all men most miserable. But now is Christ risen from the dead, and become the first fruits of them that slept.",
            ref: "1 Corinthians 15:19-20"
        },
        {
            text: "For since by man came death, by man came also the resurrection of the dead. For as in Adam all die, even so in Christ shall all be made alive.",
            ref: "1 Corinthians 15:21-22"
        },
        {
            text: "The trumpet shall sound, and the dead shall be raised incorruptible, and we shall be changed.",
            ref: "1 Corinthians 15:52"
        },
        {
            text: "Whatsoever is born of God overcometh the world: and this is the victory that overcometh the world, even our Faith.",
            ref: "1 John 5:4"
        },
        {
            text: "Jesus said, Fear not, I am the first and the last. I am he that liveth, and was dead: and behold, I am alive for evermore.",
            ref: "Revelation 1:17"
        },
        {
            text: "Give thanks unto the LORD, call upon his Name, make known his deeds among the people. Let the heavens be glad, and let the earth rejoice: and let men say among the nations, The LORD reigneth.",
            ref: "1 Chronicles 16:8,31"
        },
        {
            text: "The day is thine, O LORD, and the night is thine; thou hast prepared the light and the sun. Thou hast set all the borders of the earth; thou hast made summer and winter.",
            ref: "Psalm 74:17-18"
        },
        {
            text: "O worship the LORD in the beauty of holiness; let the whole earth stand in awe of him.",
            ref: "Psalm 96:9"
        },
        {
            text: "I was glad when they said unto me, We will go into the house of the LORD.",
            ref: "Psalm 122:1"
        },
        {
            text: "Jesus said, I am the light of the world: he that followeth me, shall not walk in darkness, but shall have the light of life.",
            ref: "John 8:12"
        },
        {
            text: "O the depth of the riches both of the wisdom and knowledge of God! How unsearchable are his judgments, and his ways are past finding out.",
            ref: "Romans 11:33"
        }
    ],
    ascension: [
        {
            text: "Ye men of Galilee, why stand ye gazing up into heaven? This same Jesus, which is taken up from you into heaven, shall so come in like manner as ye have seen him go into heaven.",
            ref: "Acts 1:11"
        },
        {
            text: "If ye then be risen with Christ, seek those things which are above, where Christ sitteth on the right hand of God.",
            ref: "Colossians 3:1"
        },
        {
            text: "Seeing that we have a great High Priest, that is passed into the heavens, Jesus the Son of God, let us come boldly unto the thone of grace, that we may obtain mercy, and find grace to help in time of need.",
            ref: "Hebrews 4:14"
        },
        {
            text: "Christ is not entered into the holy places made with hands, which are the figures of the true, but into Heaven itself, now to appear in the presence of God for us.",
            ref: "Hebrews 9:24"
        },
        {
            text: "Jesus Christ is gone into Heaven, and is on the right hand of God; Angels, and authorities, and powers being made subject unto him.",
            ref: "1 Peter 3:22"
        },
        {
            text: "Behold, a throne was set in Heaven, and one sat on the throne. And he that sat was to look upon like a jasper, and a sardine stone: and there was a rainbow round about the throne, in sight like unto an emerald.",
            ref: "Revelation 4:2"
        },
        {
            text: "Jesus said, To him that overcometh, will I grant to sit with me in my throne, even as I also overcame, and am set down with my Father in his throne.",
            ref: "Revelation 3:21"
        },
        {
            text: "The four and twenty elders fall down before him that sat on the throne, and worship him that liveth for ever and ever, and cast their crowns before the throne.",
            ref: "Revelation 4:10"
        }
    ],
    whitsun: [
        {
            text: "There is a river, the streams whereof make glad the city of God; the holy place of the tabernacle of the Most Highest.",
            ref: "Psalm 46:4"
        },
        {
            text: "Jesus said, If ye love me, keep my commandments. And I will pray the Father, and he shall give you another Comforter, that he may abide with you for ever, even the Spirit of truth.",
            ref: "John 14:15"
        },
        {
            text: "Jesus said, I tell you the truth: it is expedient for you that I go away: for if I go not away, the Comforter will not come unto you: but if I depart, I will send him unto you.",
            ref: "John 16:7"
        },
        {
            text: "Jesus said, When the Spirit of truth is come, he will guide you into all truth. For he shall not speak of himself: but whatsoever he shall hear, that shall he speak, and he will show you things to come. He shall glorify me.",
            ref: "John 16:13"
        },
        {
            text: "When the day of Pentecost was fully come, they were all with one accord in one place: and suddenly there came a sound from heaven as of a rushing and mighty wind, and it filled all the house where they were sitting.",
            ref: "Acts 2:1"
        },
        {
            text: "Ye shall receive power, after that the Holy Ghost is come upon you: and ye shall be witnesses unto me both in Jerusalem, and in all Judea, and in Samaria, and unto the uttermost part of the earth.",
            ref: "Acts 1:8"
        },
        {
            text: "Because ye are sons, God hath sent forth the Spirit of his Son into your hearts, crying, Abba, Father.",
            ref: "Galatians 4:6"
        },
        {
            text: "The Spirit and the Bride say, Come. And let him that is athirst, come. And whosoever will, let him take the water of life freely.",
            ref: "Revelation 22:17"
        }
    ],
    trinity: [],
    annunciation: [
        {
            text: "Strength and honour are her clothing. She openeth her mouth with wisdom; and in her tongue is the law of kindness.",
            ref: "Proverbs 31:25-26"
        },
        {
            text: "The Angel Gabriel came unto Mary, and said, Hail thou that art highly favoured, the Lord is with thee. Blessed art thou among women.",
            ref: "Luke 1:28"
        },
        {
            text: "Mary said, My soul doth magnify the Lord, and my spirit hath rejoiced in God my Saviour. For he hath regarded the lowliness of his handmaiden. For behold, from henceforth all generations shall call me blessed.",
            ref: "Luke 1:46-48"
        },
        {
            text: "When Jesus saw his Mother, and the disiple standing by, whom he loved, he saith unto his Mother, Woman, behold thy son.",
            ref: "John 19:26"
        },
        {
            text: "When the fulness of time was come, God sent forth his Son made of a Woman, made under the Law, to redeem them that were under the Law, that we might receive the adoption of Sons.",
            ref: "Galations 4:4"
        },
        {
            text: "There appeared a great wonder in Heaven, a woman clothed with the sun, and the moon under her feet, and upon her head a crown of twelve stars.",
            ref: "Revelation 12:2"
        }
    ],
    saints: [
        {
            text: "The marriage of the Lamb is come, and his wife hath made herself ready. And to her was granted, that she should be arrayed in fine linen, clean and white: for the fine linen is the righteousness of the Saints.",
            ref: "Revelation 19:7-8"
        },
        {
            text: "He is Lord of lords, and King of kings, and they that are with him, are called, and chosen, and faithful.",
            ref: "Revelation 17:14"
        },
        {
            text: "The Lamb, which is in the midst of the throne, shall feed them, and shall lead them unto living fountains of waters: and God shall wipe away all tears from their eyes.",
            ref: "Revelation 6:17"
        },
        {
            text: "They shall hunger no more, neither thirst any more, neither shall the sun light on them, nor any heat.",
            ref: "Revelation 7:16"
        },
        {
            text: "They are before the throne of God, and serve him day and night in his temple: and he that sitteth on the throne shall dwell among them.",
            ref: "Revelation 7:15"
        },
        {
            text: "Behold, the Lord cometh with ten thousands of his Saints, to execute judgment upon all, and to convince all that are ungodly among them of all their ungodly deeds which they have committed.",
            ref: "Jude:14,15"
        },
        {
            text: "For our citizenship is in heaven; from whence also we look for the Saviour, the Lord Jesus Christ.",
            ref: "Philippians 3:20"
        },
        {
            text: "Give thanks to the Father, which hath made us meet to be partakers of the inheritance of the Saints in light.",
            ref: "Colossians 1:12"
        }
    ],
    ordinary: [
        {
            text: "Give thanks unto the LORD, call upon his Name, make known his deeds among the people. Let the heavens be glad, and let the earth rejoice: and let men say among the nations, The LORD reigneth.",
            ref: "1 Chronicles 16:8,31"
        },
        {
            text: "Ezra said, Thou, even thou art LORD alone, thou hast made Heaven, the Heaven of heavens, with all their host, the earth, and all things that are therein, the seas, and all that is therein, and thou preservest them all, and the host of Heaven worshippeth thee.",
            ref: "Nehemiah 9:6"
        },
        {
            text: "Let the words of my mouth, and the meditation of my heart, be alway acceptable in thy sight, O LORD, my strength and my redeemer.",
            ref: "Psalm 19:14"
        },
        {
            text: "LORD, I have loved the habitation of thy house, and the place where thine honour dwelleth.",
            ref: "Psalm 24:8"
        },
        {
            text: "O send out thy light and thy truth, that they may lead me, and bring me unto thy holy hill, and to thy dwelling.",
            ref: "Psalm 43:3"
        },
        {
            text: "The day is thine, O LORD, and the night is thine; thou hast prepared the light and the sun. Thou hast set all the borders of the earth; thou hast made summer and winter.",
            ref: "Psalm 74:17-18"
        },
        {
            text: "Lord, I have called daily upon thee; I have stretched forth my hands unto thee.",
            ref: "Psalm 88:9"
        },
        {
            text: "O worship the LORD in the beauty of holiness; let the whole earth stand in awe of him.",
            ref: "Psalm 96:9"
        },
        {
            text: "O magnify the LORD our God, and worship him upon his holy hill; for the LORD our God is holy.",
            ref: "Psalm 99:9"
        },
        {
            text: "I was glad when they said unto me, We will go into the house of the LORD.",
            ref: "Psalm 122:1"
        },
        {
            text: "Thus saith the high and lofty One that inhabiteth eternity, whose Name is Holy: I dwell in the high and holy place, with him also that is of a contrite and humble spirit, to revive the spirit of the humble, and to revive the heart of the contrite ones.",
            ref: "Isaiah 57:15"
        },
        {
            text: "Seek him that maketh the seven stars and Orion, and turneth the shadow of the earth in the morning, and maketh the day dark with night: that calleth for the waters of the sea, and poureth them out upon the face of the earth: the LORD is his Name.",
            ref: "Amos 5:8"
        },
        {
            text: "The LORD is in his holy temple: let all the earth keep silence before him.",
            ref: "Habakkuk 2:20"
        },
        {
            text: "Jesus said, All things are delivered to me of my Father: and no man knoweth who the Son is, but the Father: and who the Father is, but the Son, and he to whom the Son will reveal him.",
            ref: "Luke 10:22"
        },
        {
            text: "Jesus said, The hour cometh, and now is, when the true worshippers shall worship the Father in spirit and in truth: for the Father seeketh such to worship him.",
            ref: "John 4:23"
        },
        {
            text: "Jesus said, I am the light of the world: he that followeth me, shall not walk in darkness, but shall have the light of life.",
            ref: "John 8:12"
        },
        {
            text: "We know that all things work together for good, to them that love God, to them that are called according to his purpose.",
            ref: "Romans 8:28"
        },
        {
            text: "O the depth of the riches both of the wisdom and knowledge of God! How unsearchable are his judgments, and his ways are past finding out.",
            ref: "Romans 11:33"
        },
        {
            text: "I beseech you brethren, by the mercies of God, that ye present your bodies a living sacrifice, holy, acceptable unto God, which is your reasonable service.",
            ref: "Romans 12:1"
        },
        {
            text: "For ye are bought with a price; therefore glorify God in your body, and in your spirit, which are God's.",
            ref: "1 Corinthians 6:20"
        },
        {
            text: "The fruit of the Spirit is love, joy, peace, longsuffering, gentleness, goodness, faith, meekness, temperance: against such there is no law.",
            ref: "Galatians 5:22-23"
        },
        {
            text: "As the body without the spirit is dead, so faith without works is dead.",
            ref: "James 2:26"
        },
        {
            text: "Giving all diligence, add to your faith, virtue: and to virtue, knowledge; and to knowledge, temperance; and to temperance, patience; and to patience, godliness; and to godliness, brotherly kindness; and to brotherly kindness, charity.",
            ref: "2 Peter 1:5-7"
        },
        {
            text: "But ye beloved, building up your selves on your most holy faith, praying in the Holy Ghost, keep your selves in the love of God, looking for the mercy of our Lord Jesus Christ unto eternal life.",
            ref: "Jude:20-21"
        }
    ],
    morning: [],
    evening: []
};


function $a1ab1a80faebded9$var$findHCF(x, y) {
    while(Math.max(x, y) % Math.min(x, y) != 0)if (x > y) x %= y;
    else y %= x;
    return Math.min(x, y);
}
const $a1ab1a80faebded9$export$3e516573607ab6c4 = (day, hour)=>{
    /*const id =
        day.eveOf && hour === "evensong"
            ? day.eveOf.sentenceId
            : day.sentenceId;*/ const id = "1662";
    const sentences = (0, $8572c14473ccb858$export$d75431e321b6a7a8)[id];
    if (id === "ordinary") {
        if (hour === "mattins") sentences.push(...(0, $8572c14473ccb858$export$d75431e321b6a7a8)["morning"]);
        else sentences.push(...(0, $8572c14473ccb858$export$d75431e321b6a7a8)["evening"]);
    }
    if (sentences.length === 0) return [];
    else {
        const possibleCycles = [];
        for(let i = 2; i < sentences.length; i++)if ($a1ab1a80faebded9$var$findHCF(i, sentences.length) === 1) possibleCycles.push(i);
        const target = 0.66 * sentences.length;
        let bestCycle = -1000;
        possibleCycles.forEach((possibleCycle)=>{
            if (Math.abs(target - possibleCycle) < Math.abs(target - bestCycle)) bestCycle = possibleCycle;
        });
        const sentence = sentences[(day.dayOfTheYear * 2 + (hour === "evensong" ? 1 : 0)) * bestCycle % sentences.length];
        return [
            {
                type: "rubric",
                content: `Before the Office, the Officiant shall read one or more sentences of Scripture.`
            },
            {
                type: "text",
                content: sentence.text
            },
            {
                type: "spacer"
            }
        ];
    }
};


const $e5d4e422eab295c9$export$640f02cc93cb7a75 = (settings)=>{
    const result = [];
    if (settings.salutation === "o lord hear our prayer") result.push({
        type: "chant",
        boldMode: "alternate",
        tone: "2.1",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "O",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Lord",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "hear",
                                    notes: [
                                        "4",
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "our",
                                    notes: [
                                        "5",
                                        "4"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "prayer.",
                                    notes: [
                                        "4"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                },
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "And",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "let",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "our",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "cry",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "come",
                                    notes: [
                                        "4",
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "un",
                                    notes: [
                                        "5",
                                        "4"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "to",
                                    notes: [
                                        "4"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "thee.",
                                    notes: [
                                        "4"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    else result.push({
        type: "chant",
        boldMode: "alternate",
        tone: "2.1",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "The",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "Lord",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "be",
                                    notes: [
                                        "4",
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "with",
                                    notes: [
                                        "5",
                                        "4"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "you.",
                                    notes: [
                                        "4"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                },
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "And",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "with",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "thy",
                                    notes: [
                                        "4",
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "spi",
                                    notes: [
                                        "5",
                                        "4"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "rit.",
                                    notes: [
                                        "4"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    result.push({
        type: "chant",
        boldMode: "none",
        tone: "2.1",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Let",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "us",
                                    notes: [
                                        "4",
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "pray.",
                                    notes: [
                                        "5"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    return result;
};


const $59182a366e3671e1$export$128941c64a6df66a = (settings)=>{
    return [
        {
            type: "chant",
            boldMode: "alternate",
            tone: "2.1",
            pointedText: {
                clef: "f5",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "show",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "mer",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "cy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "up",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "on",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "grant",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "sal",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "va",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    },
                                    {
                                        text: "tion.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "save",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: settings.monarch === "yes" ? "King." : "State.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "mer",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ci",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ful",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ly",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hear",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "when",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "we",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "call",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "up",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "on",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thee.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "En",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "due",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Mi",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ni",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "sters",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "with",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "right",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "eous",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ness.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "make",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "cho",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "sen",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "peo",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ple",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "joy",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ful.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "save",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "peo",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ple.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "bless",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thine",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "he",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "rit",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ance.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Give",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "peace",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "time,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Be",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "cause",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "there",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "is",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "none",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "oth",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "er",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "that",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "fight",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "eth",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "for",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "but",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "on",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ly",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thou,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "God.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "God,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "make",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "clean",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hearts",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "with",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "in",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "take",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "not",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Ho",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ly",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Spi",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "rit",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "from",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];
};


const $fd3990ac94a480d5$var$rawText = `Now(h) on(h) the(h) first(h) day(h) of(h) the(h) week(%) Ma(h)ry(h) Mag(h)da(h)lene(h) came(h) to(h) the(h) tomb(h) ear(h)ly,(h) while(h) it(h) was(h) still(h) dark,(1;) and(h) saw(h) that(h) the(h) stone(h) had(h) been(h) ta(h)ken(h) a(h)way(h) from(h) the(h) tomb.(h) (:)

So(h) she(h) ran,(h) and(h) went(h) to(h) Si(h)mon(h) Pe(h)ter(h) and(h) the(h) o(h)ther(h) di(h)sci(h)ple,(%) the(h) one(h) whom(h) Je(h)sus(h) loved,(1;) and(h) said(h) to(h) them,(h) \u{201C}They(h) have(h) ta(h)ken(h) the(h) Lord(h) out(h) of(h) the(h) tomb,(1;) and(h) we(h) do(h) not(h) know(h) where(h) they(h) have(h) laid(h) him.\u{201D}(h) (:)

Pe(h)ter(h) then(h) came(h) out(h) with(h) the(h) o(h)ther(h) di(h)sci(h)ple,(%) and(h) they(h) went(h) to(h)ward(h) the(h) tomb.(h) (:)

They(h) both(h) ran,(h) but(h) the(h) o(h)ther(h) di(h)sci(h)ple(h) out(h)ran(h) Pe(h)ter(h) and(h) reached(h) the(h) tomb(h) first;(%) and(h) stoop(h)ing(h) to(h) look(h) in,(1;) he(h) saw(h) the(h) li(h)nen(h) cloths(h) ly(h)ing(h) there,(h) but(h) he(h) did(h) not(h) go(h) in. (:)

Then(h) Si(h)mon(h) Pe(h)ter(h) came,(h) fol(h)low(h)ing(h) him,(%) and(h) went(h) in(h)to(h) the(h) tomb;(h) (:)

he(h) saw(h) the(h) li(h)nen(h) cloths(h) ly(h)ing,(%) and(h) the(h) nap(h)kin,(h) which(h) had(h) been(h) on(h) his(h) head,(1;) not(h) ly(h)ing(h) with(h) the(h) li(h)nen(h) cloths(h) but(h) rolled(h) up(h) in(h) a(h) place(h) by(h) it(h)self.(h) (:)

Then(h) the(h) o(h)ther(h) di(h)sci(h)ple,(h) who(h) reached(h) the(h) tomb(h) first,(%) al(h)so(h) went(h) in,(h) and(h) he(h) saw(h) and(h) be(h)lieved;(1;) for(h) as(h) yet(h) they(h) did(h) not(h) know(h) the(h) scrip(h)ture,(2;) that(h) he(h) must(h) rise(h) from(h) the(h) dead.(h) (:)

Then(h) the(h) di(h)sci(h)ples(%) went(h) back(h) to(h) their(h) homes.(h) (:)

But(h) Ma(h)ry(h) stood(h) weep(h)ing(h) out(h)side(h) the(h) tomb,(%) and(h) as(h) she(h) wept(h) she(h) stooped(h) to(h) look(h) in(h)to(h) the(h) tomb;(1;) and(h) she(h) saw(h) two(h) an(h)gels(h) in(h) white,(h) sit(h)ting(h) where(h) the(h) bo(h)dy(h) of(h) Je(h)sus(h) had(h) lain,(1;) one(h) at(h) the(h) head(h) and(h) one(h) at(h) the(h) feet.(h) (:)

They(h) said(h) to(h) her,(%) \u{201C}Wo(h)man,(h) why(h) are(h) you(h) weep(h)ing?\u{201D}(h) (:)

She(h) said(h) to(h) them,(%) \u{201C}Be(h)cause(h) they(h) have(h) ta(h)ken(h) a(h)way(h) my(h) Lord,(1;) and(h) I(h) do(h) not(h) know(h) where(h) they(h) have(h) laid(h) him.\u{201D}(h) (:)

Say(h)ing(h) this,(h) she(h) turned(h) round(h) and(h) saw(h) Je(h)sus(h) stand(h)ing,(%) but(h) she(h) did(h) not(h) know(h) that(h) it(h) was(h) Je(h)sus.(h) (:)

Je(h)sus(h) said(h) to(h) her,(%) \u{201C}Wo(h)man,(h) why(h) are(h) you(h) weep(h)ing?(h) Whom(h) do(h) you(h) seek?\u{201D}(h) (:)

Sup(h)pos(h)ing(h) him(h) to(h) be(h) the(h) gard'(h)ner,(%) she(h) said(h) to(h) him,(h) \u{201C}Sir,(h) if(h) you(h) have(h) car(h)ried(h) him(h) a(h)way,(1;) tell(h) me(h) where(h) you(h) have(h) laid(h) him,(h) and(h) I(h) will(h) take(h) him(h) a(h)way.\u{201D}(h) (:)

Je(h)sus(h) said(h) to(h) her,(h) \u{201C}Ma(h)ry.\u{201D}(%) She(h) turned(h) and(h) said(h) to(h) him(h) in(h) He(h)brew,(2;) \u{201C}Rab(h)bo(h)ni!\u{201D}(h) which(h) means(h) Tea(h)cher.(h) (:)

Je(h)sus(h) said(h) to(h) her,(%) \u{201C}Do(h) not(h) hold(h) me,(h) for(h) I(h) have(h) not(h) yet(h) a(h)scen(h)ded(h) to(h) the(h) Fa(h)ther;(2;) but(h) go(h) to(h) my(h) breth(h)ren(h) and(h) say(h) to(h) them,(1;) I(h) am(h) a(h)scend(h)ing(h) to(h) my(h) Fa(h)ther(h) and(h) your(h) Fa(h)ther,(h) to(h) my(h) God(h) and(h) your(h) God.\u{201D}(h) (:)

Ma(h)ry(h) Mag(h)da(h)lene(h) went(h) and(h) said(h) to(h) the(h) di(h)sci(h)ples,(%) \u{201C}I(h) have(h) seen(h) the(h) Lord\u{201D};(1;) and(h) she(h) told(h) them(h) that(h) he(h) had(h) said(h) these(h) things(h) to(h) her.(h) (:)

On(h) the(h) eve(h)ning(h) of(h) that(h) day,(%) the(h) first(h) day(h) of(h) the(h) week,(1;) the(h) doors(h) be(h)ing(h) shut(h) where(h) the(h) di(h)sci(h)ples(h) were,(h) for(h) fear(h) of(h) the(h) Jews,(1;) Je(h)sus(h) came(h) and(h) stood(h) a(h)mong(h) them(h) and(h) said(h) to(h) them,(h) \u{201C}Peace(h) be(h) with(h) you.\u{201D}(h) (:)

When(h) he(h) had(h) said(h) this,(%) he(h) showed(h) them(h) his(h) hands(h) and(h) his(h) side.(h) (:)

Then(h) the(h) di(h)sci(h)ples(%) were(h) glad(h) when(h) they(h) saw(h) the(h) Lord.(h) (:)

Je(h)sus(h) said(h) to(h) them(h) a(h)gain,(h) \u{201C}Peace(h) be(h) with(h) you.(%) As(h) the(h) Father(h) has(h) sent(h) me,(h) e(h)ven(h) so(h) I(h) send(h) you.\u{201D}(h) (:)

And(h) when(h) he(h) had(h) said(h) this,(%) he(h) breathed(h) on(h) them,(h) and(h) said(h) to(h) them,(1;) \u{201C}Re(h)ceive(h) the(h) Ho(h)ly(h) Spi(h)rit.(h) (:)

If(h) you(h) for(h)give(h) the(h) sins(h) of(h) a(h)ny,(h) they(h) are(h) for(h)gi(h)ven;(%) if(h) you(h) re(h)tain(h) the(h) sins(h) of(h) a(h)ny,(h) they(h) are(h) re(h)tained.\u{201D}(h)`;
const $fd3990ac94a480d5$var$lines = $fd3990ac94a480d5$var$rawText.replace(/\n/g, "").split(" (:)").map((l)=>l.trim());
const $fd3990ac94a480d5$var$gabcPhrases = $fd3990ac94a480d5$var$lines.map((line, lineIndex)=>{
    const isLastLine = lineIndex === $fd3990ac94a480d5$var$lines.length - 1;
    const firstSplitParts = line.split("(%)");
    const firstPartWords = firstSplitParts[0].split("(h)");
    const omitFirstBreathMark = firstPartWords.length === 3 || firstPartWords[firstPartWords.length - 1] === "sci" || firstPartWords[firstPartWords.length - 1] === "ples";
    const firstPartGabc = firstPartWords.map((word, wordIndex)=>{
        if (wordIndex === 0) return `${word}(jijIHGF)`;
        else if (wordIndex === 1 && firstPartWords.length === 3) return `${word}(fe)`;
        else if (wordIndex === 2 && firstPartWords.length === 3) return `${word}(fgh)`;
        else if (wordIndex === firstPartWords.length - 3) return `${word}(e)`;
        else if (wordIndex === firstPartWords.length - 2) return `${word}(fg)`;
        else if (wordIndex === firstPartWords.length - 1) return `${word}(h)`;
        else return `${word}(f)`;
    }).join("");
    const secondSplitParts = firstSplitParts[1].split(";)");
    const secondPartGabc = secondSplitParts.map((part)=>{
        if (part[part.length - 1] === "1") {
            const secondPartWords = part.replace("(1", "").split("(h)").filter((w)=>w.length > 0);
            return secondPartWords.map((word, wordIndex)=>{
                if (wordIndex === 0) return `${word}(f)`;
                else if (wordIndex === secondPartWords.length - 3) return `${word}(g)`;
                else if (wordIndex === secondPartWords.length - 2) return `${word}(f)`;
                else if (wordIndex === secondPartWords.length - 1) return `${word}(h)`;
                else return `${word}(h)`;
            }).join("");
        } else if (part[part.length - 1] === "2") {
            const secondPartWords = part.replace("(2", "").split("(h)").filter((w)=>w.length > 0);
            return secondPartWords.map((word, wordIndex)=>{
                if (wordIndex === 0) return `${word}(f)`;
                else if (wordIndex === secondPartWords.length - 4) return `${word}(g)`;
                else if (wordIndex === secondPartWords.length - 3) return `${word}(f)`;
                else if (wordIndex === secondPartWords.length - 2) return `${word}(h)`;
                else if (wordIndex === secondPartWords.length - 1) return `${word}(h)`;
                else return `${word}(h)`;
            }).join("");
        } else {
            const secondPartWords = part.split("(h)").filter((w)=>w.length > 0);
            return secondPartWords.map((word, wordIndex)=>{
                if (wordIndex === secondPartWords.length - 5) return `${word}(hij)`;
                else if (wordIndex === secondPartWords.length - 4) return `${word}(i)`;
                else if (wordIndex === secondPartWords.length - 3) return `${word}(hvGFg)`;
                else if (wordIndex === secondPartWords.length - 2) return isLastLine ? `${word}(ef)` : `${word}(e)`;
                else if (wordIndex === secondPartWords.length - 1) return isLastLine ? `${word}(gf)` : `${word}(f)`;
                else if (wordIndex === 0) {
                    if (omitFirstBreathMark) return `${word}(h)`;
                    else return `${word}(f)`;
                } else return `${word}(h)`;
            }).join("");
        }
    }).join(" (,) ");
    return firstPartGabc + (omitFirstBreathMark ? "" : " (,) ") + secondPartGabc + (isLastLine ? " (::)" : " (:) ");
});
console.log("GOSPEL", $fd3990ac94a480d5$var$gabcPhrases);
const $fd3990ac94a480d5$export$220433390345da8d = "(c3) " + $fd3990ac94a480d5$var$gabcPhrases.join("");


const $f946c5f928169e9d$export$4e75a5f268c5373c = (gabc)=>{
    let isInsideNeume = false;
    let charsSoFar = 0;
    let wordsSoFar = 0;
    let result = "";
    for(let charIndex = 0; charIndex < gabc.length; charIndex++){
        const char = gabc[charIndex];
        if (char === ")") isInsideNeume = false;
        if (isInsideNeume) result += char;
        else {
            if (char === " " && charsSoFar > 1) wordsSoFar++;
            if ("abcdefghijklmnopqrstuvwxyz".includes(char.toLocaleLowerCase()) && wordsSoFar < 1) {
                charsSoFar++;
                result += char.toLocaleUpperCase();
            } else result += char;
        }
        if (char === "(") isInsideNeume = true;
    }
    return result;
};
const $f946c5f928169e9d$export$73f5c5f9b6ebb3d8 = (line)=>{
    if (line.split(" ")[0].length === 1) return line.split(" ")[0].toLocaleUpperCase() + " " + line.split(" ")[1].toLocaleUpperCase() + " " + line.split(" ").slice(2).join(" ");
    else return line.split(" ")[0].toLocaleUpperCase() + " " + line.split(" ").slice(1).join(" ");
};
const $f946c5f928169e9d$var$getVAndRGabc = (vAndR, isEastertide, isSolemnity)=>{
    return (isSolemnity ? "(c3) " : "(c4) ") + vAndR.map((v, vi)=>{
        if (isEastertide) {
            if (v[v.length - 1] === ".") v = v.slice(0, v.length - 1) + ", al_le_lu_ia.";
            else v += " Al_le_lu_ia.";
        }
        let capitalized = v;
        if (vi === 0) capitalized = $f946c5f928169e9d$export$73f5c5f9b6ebb3d8(v);
        const syllables = capitalized.replace(/ /g, "_ ").split("_");
        if (isSolemnity) {
            const firstPart = [];
            const secondPart = [];
            let isSecondPart = syllables.find((s)=>s.trim() === "'") === undefined;
            for (let s of syllables){
                if (s.trim() === "'") isSecondPart = true;
                else if (isSecondPart) secondPart.push(s);
                else firstPart.push(s);
            }
            const result = [];
            firstPart.forEach((s)=>{
                if (s.trim()[0] === "/") result.push(`${s.replace("/", "")}(hi)`);
                else result.push(`${s}(h)`);
            });
            if (firstPart.length > 0) result.push(" (,) ");
            let secondPartNotes = [
                "h",
                "f",
                "e",
                "fh",
                "hiHGhih./ghGFE/fg/gf."
            ];
            if (secondPart.length === 4) secondPartNotes = [
                "h",
                "fe",
                "fh",
                "hiHGhih./ghGFE/fg/gf."
            ];
            for(let i = 0; i < secondPart.length; i++){
                const fromEnd = secondPart.length - i;
                const noteIndex = Math.max(0, secondPartNotes.length - fromEnd);
                result.push(`${secondPart[i]}(${secondPartNotes[noteIndex]})`);
            }
            return result.map((syllable)=>{
                if (vi === 1) {
                    if (syllable[0] === " ") return ` *${syllable.slice(1).replace("(", "*(")}`;
                    else return `*${syllable.replace("(", "*(")}`;
                } else return syllable;
            }).join("") + " (::)";
        }
        return syllables.map((s)=>{
            return s.replace("/", "");
        }).filter((s)=>s.trim() !== "'").map((syllable)=>{
            if (vi === 1) {
                if (syllable[0] === " ") return ` *${syllable.slice(1)}*`;
                else return `*${syllable}*`;
            } else return syllable;
        }).map((syllable, syllableIndex)=>{
            if (syllableIndex === syllables.length - 1) return `${syllable}(i/jvIHGhih)`;
            else return `${syllable}(j)`;
        }).join("") + " (::)";
    }).join("");
};
const $f946c5f928169e9d$export$5c8b9199836a83b3 = (day, hour, celebration, settings, loadableLessons, selectedOtCanticle, onSelectOtCanticle, officiantType, onSelectOfficiantType, antiphonOption, onSelectAntiphonOption, selectedCommon, onSelectCommon, selectedPsalms, onSelectPsalms, isAdvent, isChristmasOctave, isLent, isEastertide, simplifiedHaecDies, onSelectSimplifiedHaecDies, includeIntroduction, onSelectIncludeIntroduction, properVenite, onSelectProperVenite, isBeforeEaster, marianAntiphonLanguage, onSelectMarianAntiphonLanguage, resurrectionChant, onSelectResurrectionChant)=>{
    console.log("celebration", celebration);
    console.log(loadableLessons);
    const isTriduum = celebration.label === "maundy-thursday" || celebration.label === "good-friday" || celebration.label === "holy-saturday";
    const psalms = loadableLessons.state === "loaded" ? hour === "mattins" ? loadableLessons.value.psalms.find((p)=>p.title === selectedPsalms || selectedPsalms === "")?.psalms.morning : loadableLessons.value.psalms.find((p)=>p.title === selectedPsalms || selectedPsalms === "")?.psalms.evening : undefined;
    const firstLesson = loadableLessons.state === "loaded" ? hour === "mattins" ? loadableLessons.value.lessons.morningFirstLesson : loadableLessons.value.lessons.eveningFirstLesson : undefined;
    const secondLesson = loadableLessons.state === "loaded" ? hour === "mattins" ? loadableLessons.value.lessons.morningSecondLesson : loadableLessons.value.lessons.eveningSecondLesson : undefined;
    const items = [];
    if (celebration.specialManner) {
        items.push({
            type: "rubric",
            content: "On ferias with rank 9 in the table of liturgical days, optional memorials may still be celebrated, but only the Collect of the memorial is used, while the rest of the propers are taken from the feria."
        });
        items.push({
            type: "spacer"
        });
    } else if (celebration.commons) {
        items.push({
            type: "rubric",
            content: "Supplementary material is taken from the Commons:"
        });
        items.push({
            type: "picker",
            options: celebration.commons,
            selectedOption: selectedCommon,
            onChange: onSelectCommon
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "picker",
        options: [
            "Include Introduction",
            "Omit"
        ],
        selectedOption: includeIntroduction,
        onChange: onSelectIncludeIntroduction
    });
    if (includeIntroduction === "Include Introduction") {
        items.push({
            type: "spacer"
        });
        items.push(...(0, $a1ab1a80faebded9$export$3e516573607ab6c4)(day, "mattins"));
        items.push({
            type: "rubric",
            content: "Then the Officiant shall say the following **Exhortation.**"
        });
        items.push({
            type: "text",
            content: `Dearly beloved brethren, the Scripture moveth us, in sundry
            places, to acknowledge and confess our manifold sins and
            wickedness; and that we should not dissemble nor cloak them
            before the face of Almighty God our heavenly Father; but confess
            them with an humble, lowly, penitent, and obedient heart; to the
            end that we may obtain forgiveness of the same, by his infinite
            goodness and mercy. And although we ought, at all times, humbly
            to acknowledge our sins before God; yet ought we most chiefly so
            to do, when we assemble and meet together to render thanks for
            the great benefits that we have received at his hands, to set
            forth his most worthy praise, to hear his most holy Word, and to
            ask those things which are requisite and necessary, as well for
            the body as the soul. Wherefore I pray and beseech you, as many
            as are here present, to accompany me with a pure heart, and
            humble voice, unto the throne of the heavenly grace, saying after me:`,
            dropCap: true
        });
        items.push({
            type: "rubric",
            content: "All then, kneeling, say:"
        });
        items.push({
            type: "text",
            content: `A**lmighty and most merciful Father; We have erred, and strayed
            from thy ways like lost sheep. We have followed too much the
            devices and desires of our own hearts. We have offended against
            thy holy laws. We have left undone those things which we ought
            to have done; And we have done those things which we ought not
            to have done; And there is no health in us. But thou, O Lord,
            have mercy upon us, miserable offenders. Spare thou them, O God,
            which confess their faults. Restore thou them that are penitent;
            According to thy promises declared unto mankind in Christ Jesu
            our Lord. And grant, O most merciful Father, for his sake; That
            we may hereafter live a godly, righteous, and sober life, To the
            glory of thy holy Name. Amen.**`,
            dropCap: true
        });
        items.push({
            type: "picker",
            options: [
                "Lay officiant",
                "Priest officiant"
            ],
            selectedOption: officiantType,
            onChange: onSelectOfficiantType
        });
        if (officiantType === "Priest officiant") {
            items.push({
                type: "rubric",
                content: "The Officiant, if he is a Priest, stands and reads the following prayer:"
            });
            items.push({
                type: "text",
                content: `Almighty God, the Father of our Lord Jesus Christ, who
                    desireth not the death of a sinner, but rather that he
                    may turn from his wickedness, and live; and hath given
                    power, and commandment, to his Ministers, to declare and
                    pronounce to his people, being penitent, the Absolution
                    and Remission of their sins: He pardoneth and absolveth
                    all them that truly repent, and unfeignedly believe his
                    holy Gospel. Wherefore let us beseech him to grant us
                    true repentance, and his Holy Spirit, that those things
                    may please him, which we do at this present; and that
                    the rest of our life hereafter may be pure, and holy; so
                    that at the last we may come to his eternal joy; through
                    Jesus Christ our Lord. **Amen.**`,
                dropCap: true
            });
        } else {
            items.push({
                type: "rubric",
                content: "If the Officiant is not a Priest, the Collect for the Twenty-First Sunday after Trinity is said, all kneeling."
            });
            items.push({
                type: "text",
                content: `Grant, we beseech thee, merciful Lord, to thy faithful
                    people pardon and peace, that they may be cleansed from
                    all their sins, and serve thee with a quiet mind;
                    through Jesus Christ thy Son our Lord, who liveth and
                    reigneth with thee, in the unity of the Holy Ghost, ever
                    one God, world without end. **Amen.**`,
                dropCap: true
            });
        }
        items.push({
            type: "rubric",
            content: "Then, all kneeling, say:"
        });
        items.push({
            type: "text",
            content: "O**UR Father, who art in heaven, hallowed be thy Name, thy kingdom come, thy will be done, on earth as it is in heaven. Give us this day our daily bread. And forgive us our trespasses, as we forgive those who trespass against us. And lead us not into temptation, but deliver us from evil. Amen.**",
            dropCap: true
        });
    }
    items.push({
        type: "spacer"
    });
    if (!isTriduum) {
        items.push({
            type: "rubric",
            content: "The Officiant shall say:"
        });
        if (celebration.type === "solemnity") items.push({
            type: "gabc chant",
            gabc: "(c4) O(f) Lord,(gh) (,) o(ixg!hwi)pen(h) thou(h) our(hg) lips.(gh..) (::) *And*(f) *our*(gh) *mouth*(h) (,) *shall*(h) *show*(ixg!hwi) *forth*(h) *thy*(hg) *praise.*(gh..) (::) O(f) God,(gh) (,) make(h) speed(ixg!hwi) to(h) save(hg) us.(gh..) (::) *O*(f) *Lord,*(gh) (,) *make*(h) *haste*(ixg!hwi) *to*(h) *help*(hg) *us.*(gh..) (::) Glo(f)ry(gh) be(h) to(h) the(h) Fa(h)ther,(h) and(h) to(h) the(h) Son,(h) (,) and(h) to(ixg!hwi) the(h) Ho(h)ly(hg) Ghost.(gh..) (::) *As*(f) *it*(gh) *was*(h) *in*(h) *the*(h) *be*(h)*gin*(h)*ning,*(h) (,) *is*(h) *now,*(h) *and*(h) *e*(ixg!hwi)*ver*(h) *shall*(hg) *be,*(gh..) (;) *world*(h) *with*(h)*out*(h) *end.*(ixi) *A*(h)*men.*(g.) (::) Praise(h) ye(ixi) the(h) Lord.(hg..) (::) *The*(h) *Lord's*(h) *Name*(ixi) *be*(h) *prais*(hg)*ed.*(g.) (::)",
            title: "Domine, labia mea",
            dropCap: false,
            tone: "1",
            playButtons: [
                {
                    gabc: "(c4) O(f) Lord,(gh) (h) (h) (h) (h) (::)",
                    title: "Intone",
                    intoneOnly: true
                },
                {
                    gabc: "(c4) O(f) Lord,(gh) (,) o(ixg!hwi)pen(h) thou(h) our(hg) lips.(gh..) (::)",
                    title: "Full",
                    intoneOnly: false
                }
            ]
        });
        else items.push(...(0, $4fae7b70f2712114$export$47fe3383e0215c92)(false));
        items.push({
            type: "spacer"
        });
        if (hour === "mattins") {
            // Mattins so add the venite or pascha nostrum
            if (celebration.title === "Easter Day" || celebration.title.includes("Octave of Easter")) {
                items.push({
                    type: "rubric",
                    content: "Instead of the Venite the following **Anthems** are said at Morning Prayer of Easter Day and through the Octave:"
                });
                items.push({
                    type: "tone chant",
                    pointedText: (0, $8da148c2c45b952c$export$aff03f17ba557a93)("pascha nostrum", "2.1"),
                    boldMode: "alternate",
                    tone: "2.1",
                    title: "Pascha Nostrum"
                });
                items.push({
                    type: "spacer"
                });
            } else {
                items.push({
                    type: "rubric",
                    content: `The **${day.date === 19 ? "Jubliate Deo" : "Venite"}** is recited, and may be accompanied by the appointed Antiphon.`
                });
                if (loadableLessons.state === "loaded") {
                    const invAnt = loadableLessons.value.invAnts[celebration.invId ?? ""];
                    let properAnt = loadableLessons.value.invAnts[(celebration.invId ?? "") + " proper"];
                    properAnt = undefined;
                    const properVeniteText = loadableLessons.value.properVenites[(celebration.invId ?? "") + " proper"];
                    if (properAnt && properVeniteText) items.push({
                        type: "picker",
                        options: [
                            "Proper chant",
                            "Mode VI"
                        ],
                        selectedOption: properVenite,
                        onChange: onSelectProperVenite
                    });
                    if (loadableLessons.value.venite && invAnt) {
                        if (properAnt && properVeniteText && properVenite === "Proper chant") {
                            items.push({
                                type: "gabc chant",
                                title: "Antiphon",
                                gabc: properAnt.gabc,
                                tone: properAnt.tone[1],
                                dropCap: true,
                                playButtons: [
                                    {
                                        gabc: properAnt.gabc,
                                        title: "Intone",
                                        intoneOnly: true
                                    },
                                    {
                                        gabc: properAnt.gabc,
                                        title: "Play full",
                                        intoneOnly: false
                                    }
                                ]
                            });
                            items.push({
                                type: "gabc chant",
                                title: day.date === 19 ? "Jubliate Deo" : "Venite",
                                gabc: properVeniteText,
                                tone: properAnt.tone[1],
                                dropCap: true,
                                playButtons: [
                                    {
                                        gabc: properVeniteText,
                                        title: "Intone",
                                        intoneOnly: true
                                    },
                                    {
                                        gabc: properVeniteText.split("(::)")[0],
                                        title: "Play line",
                                        intoneOnly: false
                                    }
                                ]
                            });
                            items.push({
                                type: "gabc chant",
                                title: "Antiphon",
                                gabc: properAnt.gabc,
                                tone: properAnt.tone[1],
                                dropCap: true,
                                playButtons: [
                                    {
                                        gabc: properAnt.gabc,
                                        title: "Intone",
                                        intoneOnly: true
                                    },
                                    {
                                        gabc: properAnt.gabc,
                                        title: "Play full",
                                        intoneOnly: false
                                    }
                                ]
                            });
                        } else {
                            items.push({
                                type: "gabc chant",
                                title: "Antiphon",
                                gabc: invAnt.gabc,
                                tone: invAnt.tone,
                                dropCap: true,
                                playButtons: [
                                    {
                                        gabc: invAnt.gabc,
                                        title: "Intone",
                                        intoneOnly: true
                                    },
                                    {
                                        gabc: invAnt.gabc,
                                        title: "Play full",
                                        intoneOnly: false
                                    }
                                ]
                            });
                            items.push({
                                type: "gabc chant",
                                title: day.date === 19 ? "Jubliate Deo" : "Venite",
                                gabc: loadableLessons.value.venite,
                                tone: "VI",
                                dropCap: true,
                                playButtons: [
                                    {
                                        gabc: loadableLessons.value.venite,
                                        title: "Intone",
                                        intoneOnly: true
                                    },
                                    {
                                        gabc: loadableLessons.value.venite.split("(::)")[0] + "(::)",
                                        title: "Play line",
                                        intoneOnly: false
                                    }
                                ]
                            });
                            items.push({
                                type: "gabc chant",
                                title: "Antiphon",
                                gabc: invAnt.gabc,
                                tone: invAnt.tone,
                                dropCap: true,
                                playButtons: []
                            });
                        }
                        items.push({
                            type: "spacer"
                        });
                    }
                } else items.push({
                    type: "loading"
                });
            }
        }
    } else {
        if (day.date === 19 && hour === "mattins" && celebration.title !== "Good Friday") items.push({
            type: "rubric",
            content: `The **Venite** is not sung during the days of the Sacred Paschal Triduum (except as Psalm 95 in the regular course of the Psalms), and the Gloria Patri is omitted throughout the office.`
        });
        else if (hour === "mattins") items.push({
            type: "rubric",
            content: `The **Venite** is not sung during the days of the Sacred Paschal Triduum, and the Gloria Patri is omitted throughout the office.`
        });
        else items.push({
            type: "rubric",
            content: `During the days of the Sacred Paschal Triduum, the Gloria Patri is omitted throughout the office.`
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: `The **Appointed_Psalms** are sung.`
    });
    if (loadableLessons.state === "loaded") items.push({
        type: "picker",
        options: loadableLessons.value.psalms.map((p)=>p.title),
        selectedOption: selectedPsalms.length === 0 ? loadableLessons.value.psalms[0].title : selectedPsalms,
        onChange: onSelectPsalms
    });
    if (psalms !== undefined) psalms.forEach((psalm)=>{
        items.push({
            type: "ord psalm",
            title: `Psalm ${psalm.ref}`,
            psalmNumber: parseInt(psalm.ref.split(":")[0]),
            sections: psalm.sections
        });
    });
    else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "The **First_Lesson** is_read."
    });
    if (firstLesson !== undefined && Array.isArray(firstLesson)) {
        firstLesson.forEach((lessonPart, index)=>{
            items.push({
                type: "scripture",
                title: lessonPart.title,
                content: lessonPart.content,
                hasBeginneth: index === 0
            });
        });
        items.push({
            type: "text",
            content: "Here endeth the first lesson."
        });
    } else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    if (hour === "mattins") {
        // Mattins so add the te deum
        items.push({
            type: "rubric",
            content: `The **First Canticle** is recited.`
        });
        if (loadableLessons.state === "loaded") {
            const selectedTitle = selectedOtCanticle === "" ? loadableLessons.value.otCanticleOptions[0].title : selectedOtCanticle;
            if (loadableLessons.value.otCanticleOptions) {
                items.push({
                    type: "picker",
                    options: loadableLessons.value.otCanticleOptions.map((opt)=>opt.title),
                    selectedOption: selectedTitle,
                    onChange: onSelectOtCanticle
                });
                const selectedCanticle = loadableLessons.value.otCanticleOptions.find((c)=>c.title === selectedTitle);
                if (selectedCanticle) {
                    if (selectedCanticle.gabc) items.push({
                        type: "gabc chant",
                        title: selectedCanticle.title,
                        tone: selectedCanticle.tone,
                        gabc: selectedCanticle.gabc,
                        dropCap: true,
                        playButtons: [
                            {
                                gabc: selectedCanticle.gabc,
                                title: "Intone",
                                intoneOnly: true
                            }
                        ]
                    });
                    else if (selectedCanticle.pointedText) items.push({
                        type: "tone chant",
                        title: selectedCanticle.title,
                        pointedText: selectedCanticle.pointedText,
                        tone: selectedCanticle.tone,
                        boldMode: "alternate"
                    });
                }
                items.push({
                    type: "spacer"
                });
            }
        } else items.push({
            type: "loading"
        });
    }
    const haecDies = simplifiedHaecDies === "Simplified" ? "(c3) This(d) is(f) the(h) day(h) which(h) \xa3the(i) Lord(i) hath(h) made:(h) (:) we(f) will(h) re(h)\xa3joice(i) and(g) be(g) glad(h) in(f) it.(fe/fvEDe.) (::)" : "(c3) <sc>This</sc>(gxfe/gvFE) is(fd) the(fh) day(hhhvFE/fef) *(;) which(e) the(f) Lord(hh/ijhhvFEf.) (,) hath(hfh) made:(hf!gwh!iv./hi/jhh/iih) (:) we(f) will(h) re(h)joice(hg/hi!jvHG/hhg) (,) (ih/ivHF/fhFE/fhhf!hhvGF/heed) (:) and(d/ef~) be(fef) glad(hf) in(hi) it.(iv.hi!jvIH) (,) (jh!jki/hhvFE/f!gwh!iv./hjijHGF!hhf) (::)";
    if (hour !== "mattins") {
        // Evensong so add the hymn and magnificat
        if (isTriduum) {
            items.push({
                type: "rubric",
                content: `No **Office Hymn** is sung during the days of the Sacred Paschal Triduum.`
            });
            items.push({
                type: "spacer"
            });
        } else if (celebration.title === "Easter Day" || celebration.title.includes("Octave of Easter")) {
            items.push({
                type: "rubric",
                content: "Throughout the Octave of Easter, the Hymn and V&R are replaced by the **H\xe6c Dies**."
            });
            items.push({
                type: "picker",
                options: [
                    "Full",
                    "Simplified"
                ],
                onChange: onSelectSimplifiedHaecDies,
                selectedOption: simplifiedHaecDies
            });
            items.push({
                type: "gabc chant",
                gabc: haecDies,
                title: "H\xe6c Dies",
                dropCap: true,
                tone: "5",
                playButtons: [
                    {
                        gabc: haecDies,
                        title: "Intone",
                        intoneOnly: true
                    },
                    {
                        gabc: haecDies,
                        title: "Play full",
                        intoneOnly: false
                    }
                ]
            });
            items.push({
                type: "spacer"
            });
        } else {
            items.push({
                type: "rubric",
                content: "The **Office_Hymn,** together with its Versicle and Response, may be sung."
            });
            if (loadableLessons.state === "loaded") {
                if (hour === "first-evensong" && celebration.ep1HymnId && loadableLessons.value.hymns[celebration.ep1HymnId]) {
                    if (loadableLessons.value.hymns[celebration.ep1HymnId].ep1Note) items.push({
                        type: "rubric",
                        content: loadableLessons.value.hymns[celebration.ep1HymnId].ep1Note ?? ""
                    });
                    items.push({
                        type: "new hymn",
                        hymn: loadableLessons.value.hymns[celebration.ep1HymnId]
                    });
                }
                if (hour === "second-evensong" && celebration.ep2HymnId && loadableLessons.value.hymns[celebration.ep2HymnId]) {
                    if (loadableLessons.value.hymns[celebration.ep2HymnId].ep2Note) items.push({
                        type: "rubric",
                        content: loadableLessons.value.hymns[celebration.ep2HymnId].ep2Note ?? ""
                    });
                    items.push({
                        type: "new hymn",
                        hymn: loadableLessons.value.hymns[celebration.ep2HymnId]
                    });
                }
            } else items.push({
                type: "loading"
            });
            if (hour === "first-evensong" && celebration.ep1VandR) items.push({
                type: "gabc chant",
                title: "Versicle & Response",
                gabc: $f946c5f928169e9d$var$getVAndRGabc(celebration.ep1VandR, isEastertide, celebration.type === "solemnity"),
                dropCap: true,
                tone: "",
                playButtons: [
                    {
                        gabc: celebration.type === "solemnity" ? "(c3) x(h) x(hi) x(h) x(fe) x(fh) x(hiHGhih./ghGFE/fg/gf.)" : "(c4) x(ji/jvIHGhih) (:)",
                        title: "Play",
                        intoneOnly: false
                    }
                ]
            });
            if (hour === "second-evensong" && celebration.ep2VandR) items.push({
                type: "gabc chant",
                title: "Versicle & Response",
                gabc: $f946c5f928169e9d$var$getVAndRGabc(celebration.ep2VandR, isEastertide, celebration.type === "solemnity"),
                dropCap: true,
                tone: "",
                playButtons: [
                    {
                        gabc: celebration.type === "solemnity" ? "(c3) x(h) x(hi) x(h) x(fe) x(fh) x(hiHGhih./ghGFE/fg/gf.)" : "(c4) x(ji/jvIHGhih) (:)",
                        title: "Play",
                        intoneOnly: false
                    }
                ]
            });
            items.push({
                type: "spacer"
            });
        }
        items.push({
            type: "rubric",
            content: "The **Magnificat** is recited, and may be accompanied by the appointed Antiphon."
        });
        if (loadableLessons.state === "loaded") {
            const mag = loadableLessons.value.mags[(hour === "first-evensong" ? celebration.ep1MagId : celebration.ep2MagId) ?? ""];
            if (mag) {
                if (mag.onlySimplified) items.push({
                    type: "rubric",
                    content: "No full setting of this Antiphon_is_available."
                });
                else items.push({
                    type: "picker",
                    options: [
                        "Full",
                        "Simplified"
                    ],
                    onChange: onSelectAntiphonOption,
                    selectedOption: antiphonOption
                });
                const magAnt = antiphonOption === "Full" && !mag.onlySimplified ? mag.ant : mag.simplifiedAnt;
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: magAnt.gabc,
                    tone: magAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: magAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: magAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "tone chant",
                    pointedText: (antiphonOption === "Simplified" || mag.onlySimplified) && mag.simplifiedMag ? mag.simplifiedMag : mag.mag,
                    tone: antiphonOption === "Full" ? mag.ant.tone : mag.ant.tone.replace("trans", ""),
                    boldMode: "alternate",
                    title: "Magnificat"
                });
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: magAnt.gabc,
                    tone: magAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: magAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: magAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "spacer"
                });
            }
        } else items.push({
            type: "loading"
        });
    }
    items.push({
        type: "rubric",
        content: "The **Second_Lesson** is_read."
    });
    if (celebration.label === "easter-day" && hour === "second-evensong") {
        items.push({
            type: "rubric",
            content: "While normatively the lessons are read, on Easter Day the Second Lesson could be sung to the very solemn tone of the Resurrection Gospel."
        });
        items.push({
            type: "picker",
            options: [
                "Text",
                "Very solemn tone"
            ],
            onChange: onSelectResurrectionChant,
            selectedOption: resurrectionChant
        });
    }
    if (secondLesson !== undefined && Array.isArray(secondLesson)) {
        if (resurrectionChant === "Very solemn tone") items.push({
            type: "gabc chant",
            title: "John 20:1-23",
            gabc: (0, $fd3990ac94a480d5$export$220433390345da8d),
            tone: "",
            dropCap: true,
            playButtons: [
                {
                    gabc: "(c3) a(jijIHGF) b(f) c(e) d(fg) e(h) (,) f(f) g(h) h(hij) i(i) j(hvGFg) k(e) l(f) (:)",
                    title: "Play",
                    intoneOnly: false
                }
            ]
        });
        else secondLesson.forEach((lessonPart, index)=>{
            items.push({
                type: "scripture",
                title: lessonPart.title,
                content: lessonPart.content,
                hasBeginneth: index === 0
            });
        });
        items.push({
            type: "text",
            content: "Here endeth the second lesson."
        });
    } else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    if (hour === "mattins") {
        // Mattins so add the hymn and benedictus
        if (isTriduum) {
            items.push({
                type: "rubric",
                content: `No **Office Hymn** is sung during the days of the Sacred Paschal Triduum.`
            });
            items.push({
                type: "spacer"
            });
        } else if (celebration.title === "Easter Day" || celebration.title.includes("Octave of Easter")) {
            items.push({
                type: "rubric",
                content: "Throughout the Octave of Easter, the Hymn and V&R are replaced by the **H\xe6c Dies**."
            });
            items.push({
                type: "picker",
                options: [
                    "Full",
                    "Simplified"
                ],
                onChange: onSelectSimplifiedHaecDies,
                selectedOption: simplifiedHaecDies
            });
            items.push({
                type: "gabc chant",
                gabc: haecDies,
                title: "H\xe6c Dies",
                dropCap: true,
                tone: "5",
                playButtons: [
                    {
                        gabc: haecDies,
                        title: "Intone",
                        intoneOnly: true
                    },
                    {
                        gabc: haecDies,
                        title: "Play full",
                        intoneOnly: false
                    }
                ]
            });
            items.push({
                type: "spacer"
            });
        } else {
            items.push({
                type: "rubric",
                content: "The **Office_Hymn,** together with its Versicle and Response, may be sung."
            });
            if (loadableLessons.state === "loaded") {
                if (celebration.mpHymnId && loadableLessons.value.hymns[celebration.mpHymnId]) {
                    if (loadableLessons.value.hymns[celebration.mpHymnId].mpNote) items.push({
                        type: "rubric",
                        content: loadableLessons.value.hymns[celebration.mpHymnId].mpNote ?? ""
                    });
                    items.push({
                        type: "new hymn",
                        hymn: loadableLessons.value.hymns[celebration.mpHymnId]
                    });
                }
            } else items.push({
                type: "loading"
            });
            if (celebration.mpVandR) items.push({
                type: "gabc chant",
                title: "Versicle & Response",
                gabc: $f946c5f928169e9d$var$getVAndRGabc(celebration.mpVandR, isEastertide, celebration.type === "solemnity"),
                dropCap: true,
                tone: "",
                playButtons: [
                    {
                        gabc: celebration.type === "solemnity" ? "(c3) x(h) x(hi) x(h) x(fe) x(fh) x(hiHGhih./ghGFE/fg/gf.)" : "(c4) x(ji/jvIHGhih) (:)",
                        title: "Play",
                        intoneOnly: false
                    }
                ]
            });
            items.push({
                type: "spacer"
            });
        }
        items.push({
            type: "rubric",
            content: "The **Benedictus** is recited, and may be accompanied by the appointed Antiphon."
        });
        if (loadableLessons.state === "loaded") {
            const ben = loadableLessons.value.bens[celebration.mpBenId ?? ""];
            if (ben) {
                if (ben.onlySimplified) items.push({
                    type: "rubric",
                    content: "No full setting of this Antiphon_is_available."
                });
                else items.push({
                    type: "picker",
                    options: [
                        "Full",
                        "Simplified"
                    ],
                    onChange: onSelectAntiphonOption,
                    selectedOption: antiphonOption
                });
                const benAnt = antiphonOption === "Full" && !ben.onlySimplified ? ben.ant : ben.simplifiedAnt;
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: benAnt.gabc,
                    tone: benAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: benAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: benAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "tone chant",
                    pointedText: (antiphonOption === "Simplified" || ben.onlySimplified) && ben.simplifiedBen ? ben.simplifiedBen : ben.ben,
                    tone: antiphonOption === "Full" ? ben.ant.tone : ben.ant.tone.replace("trans", ""),
                    boldMode: "alternate",
                    title: "Benedictus"
                });
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: benAnt.gabc,
                    tone: benAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: benAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: benAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "spacer"
                });
            }
        } else items.push({
            type: "loading"
        });
    }
    if (hour !== "mattins") {
        // Evensong so add the nunc
        items.push({
            type: "rubric",
            content: "The **Nunc Dimittis** is recited."
        });
        if (loadableLessons.state === "loaded") {
            if (loadableLessons.value.nunc) {
                items.push({
                    type: "tone chant",
                    pointedText: loadableLessons.value.nunc,
                    tone: "3a.2",
                    boldMode: "alternate",
                    title: "Nunc Dimittis"
                });
                items.push({
                    type: "spacer"
                });
            }
        } else items.push({
            type: "loading"
        });
    }
    if (celebration.athanasianCreed && hour === "mattins") {
        items.push({
            type: "rubric",
            content: "On this day, the **Athanasian Creed** is said."
        });
        items.push({
            type: "tone chant",
            pointedText: (0, $8da148c2c45b952c$export$aff03f17ba557a93)("quicunque vult", "4.4"),
            boldMode: "alternate",
            tone: "4.4",
            title: "Quicunque Vult"
        });
    } else {
        items.push({
            type: "rubric",
            content: "The **Apostle's Creed** shall be said by the Officiant and People standing."
        });
        items.push({
            type: "text",
            content: `I **BELIEVE in God the Father Almighty, Maker of heaven and
                earth; and in Jesus Christ, his only Son our Lord; Who was
                conceived by the Holy Ghost; Born of the Virgin Mary; Suffered
                under Pontius Pilate; Was crucified, dead, and buried; He
                descended into hell; The third day he rose again from the dead;
                He ascended into heaven, And sitteth on the right hand of God
                the Father Almighty; From thence he shall come to judge the
                quick and the dead. I believe in the Holy Ghost; The holy
                Catholic Church; The Communion of Saints; The Forgiveness of
                sins; The Resurrection of the body; And the life everlasting.
                Amen.**`,
            dropCap: true
        });
    }
    items.push({
        type: "rubric",
        content: "And afterward these Prayers are said, all devoutly kneeling."
    });
    items.push({
        type: "picker",
        options: [
            "Lay officiant",
            "Priest officiant"
        ],
        selectedOption: officiantType,
        onChange: onSelectOfficiantType
    });
    items.push(...(0, $e5d4e422eab295c9$export$640f02cc93cb7a75)(settings));
    items.push({
        type: "minimal gabc chant",
        gabc: "(f3) Lord(h) have(h) mer(h)cy(h) up(h)on(hg) us.(h) (::) *Christ*(h) *have*(h) *mer*(h)*cy*(h) *up*(h)*on*(hg) *us.*(h) (::) Lord(f) have(f) mer(f)cy(f) up(f)on(fe) us.(f) (::)",
        tone: "",
        dropCap: false
    });
    items.push({
        type: "rubric",
        content: "Then the Officiant and People shall say the **Lord's Prayer.**"
    });
    items.push({
        type: "text",
        content: "O**UR Father, who art in heaven, hallowed be thy Name, thy kingdom come, thy will be done, on earth as it is in heaven. Give us this day our daily bread. And forgive us our trespasses, as we forgive those who trespass against us. And lead us not into temptation, but deliver us from evil. Amen.**",
        dropCap: true
    });
    items.push({
        type: "rubric",
        content: "Then shall follow these **Versicles_and_Responses.**"
    });
    items.push(...(0, $59182a366e3671e1$export$128941c64a6df66a)(settings));
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `The **Collect of the Day** is_said.`
    });
    (celebration.collect ?? "").split("//").forEach((collect, ci)=>{
        if (ci > 0) items.push({
            type: "rubric",
            content: `This Collect is also said.`
        });
        items.push({
            type: "text",
            content: (collect.length > 0 ? collect : undefined)?.replace(". Amen.", ". **Amen.**") ?? "Not found",
            dropCap: true
        });
    });
    if (isLent && celebration.title !== "Ash Wednesday") {
        items.push({
            type: "rubric",
            content: `Throughout Lent, the **Collect for Ash Wednesday** is_said.`
        });
        items.push({
            type: "text",
            content: "Almighty and everlasting God, who hatest nothing that thou hast made and dost forgive the sins of all those who are penitent: create and make in us new and contrite hearts, that we, worthily lamenting our sins and acknowledging our wretchedness, may obtain of thee, the God of all mercy, perfect remission and forgiveness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. **Amen.**",
            dropCap: true
        });
    }
    if (isAdvent && celebration.collect !== "Almighty God, give us grace that we may cast away the works of darkness, and put upon us the armour of light, now in the time of this mortal life, in which thy Son Jesus Christ came to visit us in great humility; that in the last day, when he shall come again in his glorious majesty, to judge both the quick and the dead; we may rise to the life immortal; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." && celebration.label !== "christmas-day") {
        items.push({
            type: "rubric",
            content: `Throughout Advent, the **Collect for Advent_I** is_said.`
        });
        items.push({
            type: "text",
            content: "Almighty God, give us grace that we may cast away the works of darkness, and put upon us the armour of light, now in the time of this mortal life, in which thy Son Jesus Christ came to visit us in great humility; that in the last day, when he shall come again in his glorious majesty, to judge both the quick and the dead; we may rise to the life immortal; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. **Amen.**",
            dropCap: true
        });
    }
    if (isChristmasOctave && celebration.collect !== "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.") {
        items.push({
            type: "rubric",
            content: `During the Octave of Christmas, the **Collect for Christmas_Day** is_said daily.`
        });
        items.push({
            type: "text",
            content: "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. **Amen.**",
            dropCap: true
        });
    }
    if (hour === "mattins") {
        items.push({
            type: "rubric",
            content: "The **Collect_for_Peace** is said."
        });
        items.push({
            type: "text",
            content: `O GOD, who art the author of peace and lover of concord, in knowledge of whom standeth our eternal life, whose service is perfect freedom: defend us thy humble servants in all assaults of our enemies; that we, surely trusting in thy defence, may not fear the power of any adversaries; through the might of Jesus Christ our Lord. **Amen.**`,
            dropCap: true
        });
        items.push({
            type: "rubric",
            content: "The **Collect_for_Grace** is said."
        });
        items.push({
            type: "text",
            content: `O LORD, our heavenly Father, Almighty and everlasting God, who
                hast safely brought us to the beginning of this day; Defend us
                in the same with thy mighty power; and grant that this day we
                fall into no sin, neither run into any kind of danger; but that
                all our doings may be ordered by thy governance, to do always
                that is righteous in thy sight; through Jesus Christ our
                Lord. **Amen.**`,
            dropCap: true
        });
    } else {
        items.push({
            type: "rubric",
            content: "The **Collect_for_Peace** is said."
        });
        items.push({
            type: "text",
            content: `O GOD, from whom all holy desires, all good counsels, and all
                just works do proceed; Give unto thy servants that peace which
                the world cannot give; that both our hearts may be set to obey
                thy commandments, and also that by thee, we, being defended from the
                fear of our enemies, may pass our time in rest and quietness;
                through the merits of Jesus Christ our Saviour. **Amen.**`,
            dropCap: true
        });
        items.push({
            type: "rubric",
            content: "The **Collect_for_Aid_Against_all_Perils** is said."
        });
        items.push({
            type: "text",
            content: `LIGHTEN our darkness, we beseech thee, O Lord; and by thy great
                mercy defend us from all perils and dangers of this night; for
                the love of thy only Son, our Saviour, Jesus Christ. **Amen.**`,
            dropCap: true
        });
    }
    items.push({
        type: "rubric",
        content: "In quires and places where they sing, an Anthem may follow. Then these five prayers may be read, or at least the Prayer of Saint Chrysostom and the Grace."
    });
    const cfeThursday = "(c4) Christ(f/fgf) $(,) be(f)came(fg) for(f) us(ghF'ED.g_e/fgf.) (;) o(f)be(hf/gh!jj/kjk)di(jij)ent(h_g) (,) e(h!jjh)ven(f.) un(ixfiH'Gh)to(f) death.(ff_g_f_) (::)";
    const cfeFriday = "(c4) Christ(f/fgf) $(,) be(f)came(fg) for(f) us(ghF'ED.g_e/fgf.) (;) o(f)be(hf/gh!jj/kjk)di(jij)ent(h_g) (,) e(h!jjh)ven(f.) un(ixfiH'Gh)to(f) death,(ff_g_f_) (:) death(ixf!hhig) on(ixgjj.h!iw!jvIG'hw!ivHG) a(f) cross.(fv.fff_c) (,) (fg!hvGF.e!g'h//fhg/hggf.) (::)";
    const pqed = "(c3) Where(d)fore(d) God(fe) hath(eh) high(h)ly(h) ex(h)al(hihhe./h_i_h_/ihhe.,hi!kv//lvKI'jvHF.,h_g/ijh'___ jvIH)ted(jvIH) him,(hvGF.) (:) and(f) gi(f!h'i)ven(i) him(ih/jkihhf.) (,) a(hf) name(hhhh.f!gwh!iv.hi/jhh/iih.) (;) which(d) is(d) a(d)bove(dfE'D/ef) ev(fhG'F)ery(hhh) name.(hhf.) (,) (gxg_fgvED.fgED.fehv.hhhff//dfe/feed.) (::)";
    if (isTriduum) {
        items.push({
            type: "rubric",
            content: "This Anthem is suggested."
        });
        if (celebration.label === "maundy-thursday") items.push({
            type: "gabc chant",
            gabc: cfeThursday,
            title: "Chritus factus est",
            dropCap: true,
            tone: "5",
            playButtons: [
                {
                    gabc: cfeThursday,
                    title: "Intone",
                    intoneOnly: true
                },
                {
                    gabc: cfeThursday,
                    title: "Play full",
                    intoneOnly: false
                }
            ]
        });
        if (celebration.label === "good-friday") items.push({
            type: "gabc chant",
            gabc: cfeFriday,
            title: "Chritus factus est",
            dropCap: true,
            tone: "5",
            playButtons: [
                {
                    gabc: cfeFriday,
                    title: "Intone",
                    intoneOnly: true
                },
                {
                    gabc: cfeFriday,
                    title: "Play full",
                    intoneOnly: false
                }
            ]
        });
        if (celebration.label === "holy-saturday") {
            items.push({
                type: "gabc chant",
                gabc: cfeFriday,
                title: "Chritus factus est",
                dropCap: true,
                tone: "5",
                playButtons: [
                    {
                        gabc: cfeFriday,
                        title: "Intone",
                        intoneOnly: true
                    },
                    {
                        gabc: cfeFriday,
                        title: "Play full",
                        intoneOnly: false
                    }
                ]
            });
            items.push({
                type: "gabc chant",
                gabc: pqed,
                title: "Propter quad et Deus",
                dropCap: true,
                tone: "5",
                playButtons: [
                    {
                        gabc: pqed,
                        title: "Intone",
                        intoneOnly: true
                    },
                    {
                        gabc: pqed,
                        title: "Play full",
                        intoneOnly: false
                    }
                ]
            });
        }
    }
    items.push({
        type: "rubric",
        content: "A Prayer for the King's Majesty"
    });
    items.push({
        type: "text",
        content: "O LORD, our heavenly Father, high and mighty, King of kings, Lord of lords, the only Ruler of princes, who dost from thy throne behold all the dwellers upon earth: Most heartily we beseech thee with thy favour to behold our most gracious Sovereign Lord, King Charles; and so replenish him with the grace of thy Holy Spirit, that he may alway incline to thy will, and walk in thy way. Endue him plenteously with heavenly gifts; grant him in health and wealth long to live; strengthen him that he may vanquish and overcome all his enemies; and finally after this life he may attain everlasting joy and felicity; through Jesus Christ our Lord. **Amen.**",
        dropCap: true
    });
    items.push({
        type: "rubric",
        content: "A Prayer for the Royal Family"
    });
    items.push({
        type: "text",
        content: "ALMIGHTY God, the fountain of all goodness, we humbly beseech thee to bless Queen Camilla, William Prince of Wales, the Princess of Wales, and all the Royal Family: Endue them with thy Holy Spirit; enrich them with thy heavenly grace; prosper them with all happiness; and bring them to thine everlasting kingdom; through Jesus Christ our Lord. **Amen.**",
        dropCap: true
    });
    items.push({
        type: "rubric",
        content: "Or in the Commonwealth:"
    });
    items.push({
        type: "text",
        content: "ALMIGHTY God, the fountain of all goodness, we humbly beseech thee to bless our Sovereign Lord, King Charles, the Parliaments of the Commonwealth, and all who are set in authority under him; that they may order all things in wisdom, righteousness, and peace, to the honour of thy holy Name, and the good of thy Church and people; through Jesus Christ our Lord. **Amen.**",
        dropCap: true
    });
    items.push({
        type: "rubric",
        content: "A Prayer for the Clergy and People"
    });
    items.push({
        type: "text",
        content: "ALMIGHTY and everlasting God, who alone workest great marvels: Send down upon our Bishops, and Curates, and all Congregations committed to their charge, the healthful Spirit of thy grace; and that they may truly please thee, pour upon them the continual dew of thy blessing. Grant this, O Lord, for the honour of our Advocate and Mediator, Jesus Christ. **Amen.**",
        dropCap: true
    });
    // if (settings.oneDayAheadPsalter === "true") {
    //     items.push({
    //         type: "rubric",
    //         content: "A Prayer for the Sick",
    //     });
    //     items.push({
    //         type: "text",
    //         content:
    //             "O FATHER of all mercies and God of all comfort, our only help in time of need: We humbly beseech thee to behold, visit, and relieve thy sick servant N., for whom our prayers are desired. Look upon her with the eyes of thy mercy, comfort her with a sense of thy goodness, preserve her from the temptations of the enemy, and give her patience under her affliction. In thy good time, restore her to health, and enable her to lead the rest of her life in thy fear and to thy glory, and grant that finally she may dwell with thee in life everlasting, through Jesus Christ our Lord. **Amen.**",
    //         dropCap: true,
    //     });
    // }
    items.push({
        type: "rubric",
        content: "A Prayer of Saint Chrysostom"
    });
    items.push({
        type: "text",
        content: "ALMIGHTY God, who hast given us grace at this time with one accord to make our common supplications unto thee; and dost promise that when two or three are gathered together in thy Name thou wilt grant their requests: Fulfil now, O Lord, the desires and petitions of thy servants, as may be most expedient for them; granting us in this world knowledge of thy truth, and in the world to come life everlasting. **Amen.**",
        dropCap: true
    });
    items.push({
        type: "rubric",
        content: "The Grace"
    });
    items.push({
        type: "text",
        content: "THE grace of our Lord Jesus Christ, and the love of God, and the fellowship of the Holy Ghost, be with us all evermore. **Amen.**",
        dropCap: true
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `Here ends the Order of ${hour === "mattins" ? "Morning" : "Evening"} Prayer.`
    });
    items.push({
        type: "spacer"
    });
    const aveReginaCaelorumLatin = "(c4) A(f)ve(e') Re(d)g\xed(c')na(d) c\xe6(f')l\xf3(g)rum,(f.) $(;) A(h')ve(j) D\xf3(ixi')mi(g)na(h') An(g)ge(f')l\xf3(h)rum:(g.) (;) Sal(f)ve(e') ra(d)dix,(c') sal(d)ve(f') por(g)ta,(f'_) (;) Ex(h) qua(g') mun(ixi)do(h') lux(g) est(d') or(g)ta:(f.) (:) Gau(f)de(g') Vir(h)go(h') glo(g)ri(h')\xf3(ixi)sa,(h'_) (;) Su(j)per(ixi') o(h)mnes(g') spe(f)ci(d')\xf3(g)sa:(f.) (:) Va(ixi)le,(h') o(g) val(ixi)de(h') de(g)c\xf3(f!gwh)ra,(h.) (;) Et(j) pro(ixi) no(ixijk)bis(h'_) Chri(h)stum(g') ex(f)\xf3(gg)ra.(f.) (::)";
    const aveReginaCaelorumEnglish = "(c4) Queen(f) of(e') the(d) hea(c')vens(d) we(f') hail(g) thee:(f.) (;) Hail(h') thee(j) La(ixi')dy(g) of(h') all(g) the(f') An(h)gels:(g.) (;) Thou(f) the(e') dawn,(d) the(c') door(d) of(f') morn(g)ing,(f'_) (;) whence(h) the(g') world's(ixi) true(h') light(g) is(d') ri(g)sen:(f.) (:) Joy(f) to(g') thee(h) O(h') Vir(g)gin(h') glo(ixi)rious,(h'_) (;) Beau(j)ti(ixi')ful(h) bey(g')ond(f) all(d') o(g)ther:(f.) (:) Hail(ixi) and(h') fare(g)well(ixi) O(h') most(g) gra(f!gwh)cious,(h.) (;) In(j)ter(ixi)cede(ixij) for(k) us(hh) al(h)way(g') to(f) Je(gg)sus.(f.) (::)";
    const reginaCaeliLatin = "(c4) RE(f)gi(g)na(f') c\xe6(g)li(h.) $(,) l\xe6(ixi)t\xe1(h)re,(g'_) al(ixi)le(h')l\xfa(g)ia:(f.) (;) Qui(f)a(j'_) quem(j) me(k')ru(j)\xed(ixi')sti(h) por(f')t\xe1(g)re,(h'_) al(ixi)le(h')l\xfa(g)ia:(f.) (:) Re(j)sur(j')r\xe9(k)xit,(j'_) sic(j)ut(f') di(g)xit,(f'_) al(g)le(h')l\xfa(ixi)ia:(j.) (;) O(j)ra(f) pro(g') no(ixi)bis(h') De(g)um,(f.) al(e)le(g)l\xfa(gg)ia.(f.) (::)";
    const reginaCaeliEnglish = "(c4) O(f) Queen(g) of(f') hea(g)ven(h.) *(,) be(ixi) joy(h)ful,(g) al(ixi)le(h')lu(g)ia:(f.) (;) Be(f)cause(j'_) he(j) whom(k') so(j) meet(ixi')ly(h) thou(f') bear(g)est,(h'_) al(ixi)le(h')lu(g)ia:(f.) (:) Hath(j) a(j')ri(k)sen(j'_) as(j) he(f') pro(g)mis'd,(f'_) al(g)le(h')lu(ixi)ia:(j.) (;) Pray(j) for(f) us(g') to(ixi) the(h') Fa(g)ther,(f.) al(e)le(g)lu(gg)ia.(f.) (::)";
    if (!isTriduum) {
        items.push({
            type: "rubric",
            content: "The Marian Anthem appointed for the season may be recited."
        });
        items.push({
            type: "picker",
            options: [
                "Latin",
                "English"
            ],
            selectedOption: marianAntiphonLanguage,
            onChange: onSelectMarianAntiphonLanguage
        });
        if (marianAntiphonLanguage === "English") {
            if (isAdvent || day.month === 1 || day.month === 2 && day.date <= 2) {
                items.push({
                    type: "rubric",
                    content: "Alma redeptoris"
                });
                if (isAdvent) items.push({
                    type: "rubric",
                    content: "First V and R"
                });
                else items.push({
                    type: "rubric",
                    content: "Second V and R"
                });
            } else if (isBeforeEaster) {
                items.push({
                    type: "gabc chant",
                    gabc: aveReginaCaelorumEnglish,
                    title: "Ave Regina c\xe6lorum",
                    dropCap: true,
                    tone: "6",
                    playButtons: [
                        {
                            gabc: aveReginaCaelorumEnglish,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: aveReginaCaelorumEnglish,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "minimal gabc chant",
                    gabc: "(c3) Grant(h) that(h) I(h) may(h) praise(h) thee,(h) sa(h)cred(h) Vir(h)gin.(f) (::) *Give*(h) *me*(h) *strength*(h) *a*(h)*gainst*(h) *thine*(h) *e*(h)*ne*(f)*mies.*(f) (::) Let(h) us(f) pray.(g) (:) Grant(h) us(h) pro(h)tec(h)tion(h) in(h) our(h) weak(h)ness,(h) O(h) mer(h)ci(h)ful(h) God,(f) (;) that(h) we(h) who(h) com(h)me(h)mo(h)rate(h) the(h) ho(h)ly(h) Mo(h)ther(g) of(f) God(h) (;) may(h) tri(h)umph(h) o(h)ver(h) our(h) i(h)ni(h)qui(h)ties(h) with(h) the(h) help(h) of(h) her(h) in(h)ter(h)ces(h)sion;(d) (:) through(h) Christ(h) our(f) Lord.(g) (::) *A*(g)*men.*(h) (::)",
                    dropCap: false,
                    tone: "1"
                });
            } else if (isEastertide) {
                items.push({
                    type: "gabc chant",
                    gabc: reginaCaeliEnglish,
                    title: "Regina c\xe6li",
                    dropCap: true,
                    tone: "6",
                    playButtons: [
                        {
                            gabc: reginaCaeliEnglish,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: reginaCaeliEnglish,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "minimal gabc chant",
                    gabc: "(c3) Re(h)joice(h) and(h) be(h) glad,(h) O(h) Vir(h)gin(h) Ma(h)ry,(h) al(h)le(h)lu(h)ia.(f) (::) *For*(h) *the*(h) *Lord*(h) *is*(h) *ri*(h)*sen*(h) *in*(h)*deed,*(h) *al*(h)*le*(h)*lu*(h)*ia.*(f) (::) Let(h) us(f) pray.(g) (:) O(h) God,(h) who,(h) by(h) the(h) Re(h)sur(h)rec(h)tion(h) of(h) thy(h) Son,(h) our(h) Lord(h) Je(h)sus(h) Christ,(h) hast(h) brought(h) joy(h) to(h) the(h) world:(f) (;) grant(h) we(h) be(h)seech(h) thee,(h) that,(h) through(h) his(h) Mo(h)ther(h) the(h) Vir(g)gin(f) Ma(h)ry,(h) (;) we(h) may(h) ob(h)tain(h) the(h) joys(h) of(h) e(h)ver(h)last(h)ing(h) life;(d) (:) through(h) the(h) same(h) Christ(h) our(f) Lord.(g) (::) *A*(g)*men.*(h) (::)",
                    dropCap: false,
                    tone: "1"
                });
            } else items.push({
                type: "rubric",
                content: "Salve regina"
            });
        } else {
            if (isAdvent || day.month === 1 || day.month === 2 && day.date <= 2) {
                items.push({
                    type: "rubric",
                    content: "Alma redeptoris"
                });
                if (isAdvent) items.push({
                    type: "rubric",
                    content: "First V and R"
                });
                else items.push({
                    type: "rubric",
                    content: "Second V and R"
                });
            } else if (isBeforeEaster) {
                items.push({
                    type: "gabc chant",
                    gabc: aveReginaCaelorumLatin,
                    title: "Ave Regina c\xe6lorum",
                    dropCap: true,
                    tone: "6",
                    playButtons: [
                        {
                            gabc: aveReginaCaelorumLatin,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: aveReginaCaelorumLatin,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "minimal gabc chant",
                    gabc: "(c3) Dig(h)na(h)re(h) me(h) lau(h)da(h)re te,(h) Vir(h)go(h) sa(h)cra(h)ta.(f) (::) *Da*(h) *mi*(h)*hi*(h) *vir*(h)*tu*(h)*tem*(h) *con*(h)*tra*(h) *hos*(h)*tes*(h) *tu*(h)*os.*(f) (::) O(h)re(h)mus.(f) (:) Con(h)ce(h)de,(h) mi(h)se(h)ri(h)cors(h) De(h)us,(h) fra(h)gi(h)li(h)ta(h)ti(h) nos(h)trae(h) prae(h)si(h)di(f)um:(f) (;) ut,(h) qui(h) sanc(h)tae(h) De(h)i(h) Ge(h)ne(h)tri(h)cis(h) me(h)mo(h)ri(g)am(f) a(h)gi(h)mus;(h) (;) in(h)ter(h)ces(h)si(h)o(h)nis(h) ei(h)us(h) aux(h)i(h)li(h)o,(h) a(h) nos(h)tris(h) i(h)ni(h)qui(h)ta(h)ti(h)bus(h) re(h)sur(h)ga(h)mus.(d) (:) Per(h) Chris(h)tum(h) Do(h)mi(h)num(h) nos(h)trum.(f) (::) *A*(g)*men.*(h) (::)",
                    dropCap: false,
                    tone: "1"
                });
            } else if (isEastertide) {
                items.push({
                    type: "gabc chant",
                    gabc: reginaCaeliLatin,
                    title: "Regina c\xe6li",
                    dropCap: true,
                    tone: "6",
                    playButtons: [
                        {
                            gabc: reginaCaeliLatin,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: reginaCaeliLatin,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "minimal gabc chant",
                    gabc: "(c3) Gau(h)de(h) et(h) l\xe6(h)ta(h)re,(h) Vir(h)go(h) Ma(h)ri(h)a,(h) al(h)le(h)lu(h)ia.(f) (::) *Qui*(h)*a*(h) *sur*(h)*rex*(h)*it*(h) *Do*(h)*mi*(h)*nus*(h) *ve*(h)*re,*(h) *al*(h)*le*(h)*lu*(h)*ia.*(f) (::) O(h)re(h)mus.(f) (:) De(h)us,(h) qui(h) per(h) re(h)sur(h)rec(h)ti(h)o(h)nem(h) Fi(h)li(h)i(h) tu(h)i(h) Do(h)mi(h)ni(h) nos(h)tri(h) Ie(h)su(h) Chris(h)ti,(h) mun(h)dum(h) l\xe6(h)ti(h)fi(h)ca(h)re(h) dig(h)na(h)tus(f) es:(f) (;) pr\xe6(h)sta,(h) qu\xe6(h)su(h)mus,(h) ut,(h) per(h) ei(h)us(h) Ge(h)ne(h)tri(h)cem(h) Vir(h)gi(h)nem(g) Ma(f)ri(h)am,(h) (;) per(h)pe(h)tu(h)\xe6(h) ca(h)pi(h)a(h)mus(h) gau(h)di(h)a(h) vi(h)t\xe6.(d) (:) Per(h) Chris(h)tum(h) Do(h)mi(h)num(h) nos(h)trum.(f) (::) *A*(g)*men.*(h) (::)",
                    dropCap: false,
                    tone: "1"
                });
            } else items.push({
                type: "rubric",
                content: "Salve regina"
            });
        }
    } else items.push({
        type: "rubric",
        content: "No Marian Anthem is sung during the days of the Sacred Paschal Triduum."
    });
    items.push({
        type: "spacer",
        big: true
    });
    return items;
};


const $b5d1360628cd70a0$export$9369a7166d10a081 = "#db281b";
const $b5d1360628cd70a0$export$278aa54ed3f4968d = "#222110";
const $b5d1360628cd70a0$export$ac989c726cc30b36 = "#222110";
const $b5d1360628cd70a0$export$516f68680b50dca1 = "#222110";
const $b5d1360628cd70a0$export$5f6c0430e306396e = "#222110";
const $b5d1360628cd70a0$export$48ee2f34eb455667 = "#db281b";
const $b5d1360628cd70a0$export$f20e1008093b38b9 = "#db281b";
const $b5d1360628cd70a0$export$1af8700c980da4bf = "#00c3e8";
const $b5d1360628cd70a0$export$f50ba89cb1eaa85d = "#007f96";
const $b5d1360628cd70a0$var$isWindows = navigator.platform.indexOf("Win") > -1;
const $b5d1360628cd70a0$export$1ac009f0e037ca3c = "19px EB Garamond";
const $b5d1360628cd70a0$export$ce9a3fcbbe56f52e = "17px EB Garamond";
const $b5d1360628cd70a0$export$a281c13bc07e2812 = "84px Goudy Initialen";
const $b5d1360628cd70a0$export$f688c137b5ee517a = "#e8e8e8";
const $b5d1360628cd70a0$export$1a6c4fc8d15a2dc7 = "#fafafa";
const $b5d1360628cd70a0$export$ee522376d3ee75f2 = "#f8f8f8";
const $b5d1360628cd70a0$export$2a756fe1d703ec38 = "#f4f4f4";
const $b5d1360628cd70a0$export$6a1034a6524f1861 = "#d0d0d0";
const $b5d1360628cd70a0$export$cabad38efc6f637d = "#dcdcdc";
const $b5d1360628cd70a0$export$95deb96ddfd043a9 = $b5d1360628cd70a0$var$isWindows ? "EB Garamond" : "EB Garamond";
const $b5d1360628cd70a0$export$edb31f1ce7b7be57 = 19;
const $b5d1360628cd70a0$export$84c40e91fbd203e0 = 48;
const $b5d1360628cd70a0$export$397f5285b920487e = 680;
const $b5d1360628cd70a0$export$beeaca86d94e0278 = "se";



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $fc466355347b8480$export$86e2cef2561044ac(key, initialValue) {
    // Get from local storage then
    // parse stored json or return initialValue
    const readValue = ()=>{
        // Prevent build error "window is undefined" but keep keep working
        if (typeof window === "undefined") return initialValue;
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.warn(`Error reading localStorage key \u{201C}${key}\u{201D}:`, error);
            return initialValue;
        }
    };
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = (0, $acw62.useState)(readValue);
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value)=>{
        // Prevent build error "window is undefined" but keep keep working
        if (typeof window == "undefined") console.warn(`Tried setting localStorage key \u{201C}${key}\u{201D} even though environment is not a client`);
        try {
            // Allow value to be a function so we have the same API as useState
            const newValue = value instanceof Function ? value(storedValue) : value;
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(newValue));
            // Save state
            setStoredValue(newValue);
            // We dispatch a custom event so every useLocalStorage hook are notified
            window.dispatchEvent(new Event("local-storage"));
        } catch (error) {
            console.warn(`Error setting localStorage key \u{201C}${key}\u{201D}:`, error);
        }
    };
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    (0, $acw62.useEffect)(()=>{
        const handleStorageChange = ()=>{
            setStoredValue(readValue());
        };
        // this only works for other documents, not the current one
        window.addEventListener("storage", handleStorageChange);
        // this is a custom event, triggered in writeValueToLocalStorage
        window.addEventListener("local-storage", handleStorageChange);
        return ()=>{
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("local-storage", handleStorageChange);
        };
    }, []);
    return [
        storedValue,
        setValue
    ];
}


const $e5274831a769feea$export$45057e54bc6685bf = (morningReadings)=>{
    const result = morningReadings.replace("morning", "evening");
    return result;
};
const $e5274831a769feea$export$de29564508b632b2 = {
    bibleTranslation: "ESV",
    psalmsBold: "none",
    invitatoryAntiphons: "always",
    antiphonTones: "solemn",
    psalmCycle: "bcp",
    teDeum: "always",
    mattinsReadings: "1961-morning",
    monarch: "yes",
    salutation: "the lord be with you",
    psalmsAtCompline: "compline-short",
    secondReadingToCompline: "no",
    letUsBlessMattinsAndEvensong: "after collects",
    transpositions: {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        T: 0
    },
    hymnPosition: "before canticle",
    gospelCanticleTones: "standard",
    absolution: "pardon and peace collect",
    lordsPrayerAfterConfession: "omit",
    lordsPrayer: "standard",
    adventAndLentCollects: "repeat",
    paschaNostrum: "octave",
    canticleAntiphonsExperimental: "none",
    canticleTonesExperimental: "simplified",
    tuning: "disabled",
    experimentalChantRendering: "off",
    transferEpiphany: "no",
    transferAscension: "no",
    transferCorpusChristi: "no",
    oneDayAheadPsalter: "false",
    marianAntiphonLanguage: "Latin"
};
const $e5274831a769feea$export$9115b42802a3e44f = ()=>{
    const [settings, setSettings] = (0, $fc466355347b8480$export$86e2cef2561044ac)("app-settings", $e5274831a769feea$export$de29564508b632b2);
    return (0, $acw62.useMemo)(()=>{
        return {
            settings: {
                ...$e5274831a769feea$export$de29564508b632b2,
                ...settings
            },
            setSetting: (key, value)=>{
                setSettings({
                    ...settings,
                    [key]: value
                });
            }
        };
    }, [
        settings,
        setSettings
    ]);
};




var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");

const $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49 = (props)=>{
    const { onlySides: onlySides, children: children } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    const padding = isSmallScreen ? 8 : 48;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: onlySides ? {
            paddingLeft: padding,
            paddingRight: padding
        } : {
            padding: padding
        },
        children: children
    });
};






var $acw62 = parcelRequire("acw62");
const $ec0044bd603cd929$export$6d26a49742b7cf57 = (props)=>{
    const { imageData: imageData, width: width, height: height } = props;
    const canvasRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!canvasRef.current) return;
        const context = canvasRef.current.getContext("2d");
        if (!context) return;
        context.putImageData(imageData, 0, 0);
    }, [
        imageData
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("canvas", {
        ref: canvasRef,
        width: width,
        height: height,
        id: "canvas"
    });
};




const $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa = (context, xPos, yPos, width, tuningNote)=>{
    context.strokeStyle = (0, $b5d1360628cd70a0$export$9369a7166d10a081);
    [
        1,
        2,
        3,
        4
    ].forEach((offset)=>{
        context.beginPath();
        context.moveTo(xPos, yPos + offset * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64));
        context.lineTo(xPos + width + 0.5, yPos + offset * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64));
        context.stroke();
    });
    if (tuningNote && tuningNote >= -0.5) {
        const tuningY = yPos + (9 - tuningNote) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
        context.strokeStyle = "rgba(0, 214, 255, 0.5)";
        context.lineWidth = 3;
        context.beginPath();
        context.moveTo(xPos, tuningY);
        context.lineTo(xPos + width + 0.5, tuningY);
        context.stroke();
        context.lineWidth = 1;
    }
};
const $c25e5e6c4ba9c9f6$export$285dd097f3c00610 = (context, noteX, yPos, note, tuningNote)=>{
    const noteValue = (0, $49d4b9cf3f617ce8$export$6bd450e554c25d4b)(note);
    const isTuningNote = tuningNote === noteValue - 0.5;
    const x = noteX - (0, $49d4b9cf3f617ce8$export$dcfc08b7a30da462) - 3;
    const y = yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
    const HORIZONTAL_STROKE = 2;
    context.beginPath();
    context.moveTo(x - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), y + 0.7 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38)); // Bottom left
    context.lineTo(x + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), y + 1.4 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38)); // Bottom right
    context.lineTo(x + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), y - 0.7 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38)); // Top right
    context.lineTo(x - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), y - 1.4 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38)); // Top left
    context.lineTo(x - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), y - 1.4 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + HORIZONTAL_STROKE); // Inner top left
    context.lineTo(x + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) - 1, y - 0.7 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + HORIZONTAL_STROKE); // Inner top right
    context.lineTo(x + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) - 1, y + 1.4 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) - HORIZONTAL_STROKE); // Inner bottom right
    context.lineTo(x - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), y + 0.7 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) - HORIZONTAL_STROKE); // Inner bottom left
    context.closePath();
    context.fillStyle = isTuningNote ? (0, $b5d1360628cd70a0$export$f50ba89cb1eaa85d) : (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
    context.fill();
    context.beginPath();
    context.moveTo(x - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), y + 0.7 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) - 0.5);
    context.lineTo(x - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), y + 0.7 * (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) - (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) * 1.5);
    context.strokeStyle = isTuningNote ? (0, $b5d1360628cd70a0$export$f50ba89cb1eaa85d) : (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
    context.stroke();
};
const $c25e5e6c4ba9c9f6$export$26951c054d3de335 = (context, noteX, yPos, note, specialYOffset, specialCurveOffset, highlighted, options, tuningNote)=>{
    const noteValue = (0, $49d4b9cf3f617ce8$export$6bd450e554c25d4b)(note);
    // correct blurriness on non-retina
    noteX += 0.5;
    specialYOffset += 0.5;
    const isFlat = note[note.length - 1] === "b";
    if (isFlat) $c25e5e6c4ba9c9f6$export$285dd097f3c00610(context, noteX + (options.shiftFlat ?? 0), yPos, note, tuningNote);
    const isTuningNote = isFlat ? tuningNote === noteValue - 0.5 : tuningNote === noteValue;
    context.beginPath();
    context.moveTo(noteX - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + specialYOffset);
    context.quadraticCurveTo(noteX, yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) - (specialCurveOffset ?? (0, $49d4b9cf3f617ce8$export$2f425c82cb309503)) + specialYOffset, noteX + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 1, yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + specialYOffset);
    context.lineTo(noteX + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 1, yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 1 + specialYOffset);
    context.quadraticCurveTo(noteX + 1, yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 1 - (specialCurveOffset ?? (0, $49d4b9cf3f617ce8$export$2f425c82cb309503)) + specialYOffset, noteX - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38), yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 1 + specialYOffset);
    context.closePath();
    context.fillStyle = highlighted ? "white" : isTuningNote ? (0, $b5d1360628cd70a0$export$1af8700c980da4bf) : (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
    context.fill();
    if (highlighted) {
        context.strokeStyle = "black";
        context.stroke();
    }
    if (isTuningNote) {
        context.strokeStyle = (0, $b5d1360628cd70a0$export$f50ba89cb1eaa85d);
        context.stroke();
    }
};
const $c25e5e6c4ba9c9f6$export$57ec12daf141ce6 = (context, noteX, yPos, note, highlighted, tuningNote)=>{
    const noteValue = (0, $49d4b9cf3f617ce8$export$6bd450e554c25d4b)(note);
    const isTuningNote = tuningNote === noteValue;
    context.fillStyle = highlighted ? "white" : isTuningNote ? (0, $b5d1360628cd70a0$export$1af8700c980da4bf) : (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
    context.beginPath();
    context.moveTo(noteX + 2, yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) - 1);
    context.lineTo(noteX + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 2, yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64));
    context.lineTo(noteX + 2, yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 1);
    context.lineTo(noteX - (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 2, yPos + (9 - noteValue) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64));
    context.closePath();
    context.fill();
    if (highlighted) {
        context.strokeStyle = "black";
        context.stroke();
    }
    if (isTuningNote) {
        context.strokeStyle = (0, $b5d1360628cd70a0$export$f50ba89cb1eaa85d);
        context.stroke();
    }
};
const $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2 = (context, noteX, yPos, note)=>{
    const longX = noteX + (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 5;
    const longY = yPos + (9 - (0, $49d4b9cf3f617ce8$export$6bd450e554c25d4b)(note)) / 2 * (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - ((0, $49d4b9cf3f617ce8$export$6bd450e554c25d4b)(note) % 2 === 0 ? 1 : (0, $49d4b9cf3f617ce8$export$6ee4576e82bf6b38) + 1);
    context.beginPath();
    context.arc(longX, longY, 1.5, 0, 2 * Math.PI, false);
    context.fillStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
    context.fill();
};



const $02b52bdf6f82c33e$export$17267529e6476353 = (mode)=>{
    const lookup = {
        "1": 0,
        "2": 4,
        "3": -3,
        "4": window.location.href.includes("/se/") ? -5 : 0,
        "5": -3,
        "6": 0,
        "7": -5,
        "8": -3,
        T: 1
    };
    return lookup[mode] ?? 0;
};
const $02b52bdf6f82c33e$export$c6bb8e99f71a0bee = (tone)=>{
    if (!tone) return $02b52bdf6f82c33e$export$17267529e6476353("1");
    const clefOffset = parseInt(tone.clef.slice(1));
    const offset = tone.clef.slice(0, 1) === "c" ? 9 - clefOffset : 5 - clefOffset;
    const recitingNote = $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d[tone.recitingNote + offset];
    let transposedBy = -10;
    while($02b52bdf6f82c33e$export$94966884eea635c4(recitingNote, transposedBy) !== "A3")transposedBy++;
    return transposedBy;
};
const $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d = [
    "A2",
    "B2",
    "C3",
    "D3",
    "E3",
    "F3",
    "G3",
    "A3",
    "B3",
    "C4",
    "D4",
    "E4",
    "F4",
    "G4"
];
const $02b52bdf6f82c33e$export$4ae37d1471dcafc7 = {
    C: "C",
    "C#": "Db",
    D: "D",
    "D#": "Eb",
    E: "E",
    F: "F",
    "F#": "Gb",
    G: "G",
    "G#": "Ab",
    A: "A",
    "A#": "Bb",
    B: "B"
};
const $02b52bdf6f82c33e$var$TRANSPOSITION_TABLE = [
    "C",
    "Db",
    "D",
    "Eb",
    "E",
    "F",
    "Gb",
    "G",
    "Ab",
    "A",
    "Bb",
    "B"
];
const $02b52bdf6f82c33e$export$94966884eea635c4 = (noteString, amount)=>{
    const octave = parseInt(noteString[noteString.length - 1]);
    const note = noteString.slice(0, noteString.length - 1);
    const index = $02b52bdf6f82c33e$var$TRANSPOSITION_TABLE.indexOf(note);
    const transposedNote = $02b52bdf6f82c33e$var$TRANSPOSITION_TABLE[($02b52bdf6f82c33e$var$TRANSPOSITION_TABLE.length * 2 + index + amount) % $02b52bdf6f82c33e$var$TRANSPOSITION_TABLE.length];
    const transposedOctave = octave + Math.floor((index + amount) / $02b52bdf6f82c33e$var$TRANSPOSITION_TABLE.length);
    return `${transposedNote}${transposedOctave}`;
};


const $49d4b9cf3f617ce8$export$42510bee89f29ff9 = 76;
const $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 = 11;
const $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 = 2.5;
const $49d4b9cf3f617ce8$export$dcfc08b7a30da462 = $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 * 2 + 1;
const $49d4b9cf3f617ce8$export$2f425c82cb309503 = 2;
const $49d4b9cf3f617ce8$export$e944699278f9a54b = $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.5;
const $49d4b9cf3f617ce8$export$6bd450e554c25d4b = (note)=>{
    return parseInt(note.replace("b", ""));
};
const $49d4b9cf3f617ce8$var$WINDOW = window;
const $49d4b9cf3f617ce8$export$90dad5714e071580 = (props)=>{
    const { pointedText: pointedText, boldMode: boldMode, dropCap: dropCap, highlightCount: highlightCount, rubric: rubric, yExtraOffset: yExtraOffset, exportLines: exportLines, tone: tone } = props;
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    (0, $acw62.useEffect)(()=>{
        if (settings.tuning === "enabled") $49d4b9cf3f617ce8$var$WINDOW.startTuning();
    }, [
        settings.tuning
    ]);
    const [tuningNote, setTuningNote] = (0, $acw62.useState)(undefined);
    const getTuningNote = (0, $acw62.useCallback)(()=>{
        if (settings.tuning === "enabled" && tone) {
            const transposeByKey = tone[0];
            const tuningEvent = $49d4b9cf3f617ce8$var$WINDOW.tuningEvent;
            if (tuningEvent && tuningEvent.note) {
                const transposeBy = settings.transpositions["1"] + (0, $02b52bdf6f82c33e$export$17267529e6476353)(transposeByKey);
                const clefOffset = pointedText.clef === "c7" ? 7 : 5;
                const offset = pointedText.clef === "c5" || pointedText.clef === "c7" ? 9 - clefOffset : 5 - clefOffset;
                const detectedNote = (0, $02b52bdf6f82c33e$export$4ae37d1471dcafc7)[tuningEvent.note];
                const transposedNote = (0, $02b52bdf6f82c33e$export$94966884eea635c4)(`${detectedNote}${tuningEvent.octave}`, -transposeBy);
                const isFlat = transposedNote[1] === "b";
                const transposedNoteWithoutFlat = transposedNote.replace("b", "");
                const noteValue = (0, $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d).findIndex((n)=>n === transposedNoteWithoutFlat) - offset - (isFlat ? 0.5 : 0);
                if (noteValue && noteValue > -0.5) setTuningNote(noteValue);
            }
        }
    }, [
        settings
    ]);
    (0, $8c321ba562d39156$export$2e2bcd8739ae039)(getTuningNote, 25);
    const noPadding = exportLines || props.noPadding;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    const CANVAS_FONT = exportLines ? "18px Palatino" : isSmallScreen ? (0, $b5d1360628cd70a0$export$ce9a3fcbbe56f52e) : (0, $b5d1360628cd70a0$export$1ac009f0e037ca3c);
    const CANVAS_SMALL_CAP_FONT = exportLines ? "14px Palatino" : isSmallScreen ? `12px ${0, $b5d1360628cd70a0$export$95deb96ddfd043a9}` : `14px ${0, $b5d1360628cd70a0$export$95deb96ddfd043a9}`;
    const SPACE_WIDTH = isSmallScreen ? 5 : 7;
    const SPACES_PER_MID = isSmallScreen ? 3 : 3;
    const SPACES_PER_END = isSmallScreen ? 5 : 5;
    const TEXT_BREATHING_ROOM = isSmallScreen ? 35 : 50;
    const containerRef = (0, $acw62.useRef)(null);
    const canvasRef = (0, $acw62.useRef)(null);
    const [height, setHeight] = (0, $acw62.useState)(0);
    const canvas = canvasRef.current;
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (canvas) {
                canvas.height = 0;
                canvas.width = 0;
            }
        };
    }, [
        canvas
    ]);
    const [forceRenderCount, setForceRenderCount] = (0, $acw62.useState)(0);
    (0, $8c321ba562d39156$export$2e2bcd8739ae039)((0, $acw62.useCallback)(()=>{
        if (forceRenderCount < 10) setForceRenderCount((rc)=>rc + 1);
    }, [
        forceRenderCount
    ]), 2500);
    const [exportData, setExportData] = (0, $acw62.useState)({
        width: 0,
        height: 0,
        lines: []
    });
    (0, $acw62.useEffect)(()=>{
        if (!canvasRef.current) return;
        const context = canvasRef.current.getContext("2d");
        if (!context) return;
        const canvasWidth = canvasRef.current.getBoundingClientRect().width;
        // Scale correctly
        const ctx = context;
        const dpr = exportLines ? 3 : window.devicePixelRatio || 1;
        const bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
        let pixelRatio = dpr / bsr;
        let pixelWidth = canvasWidth * pixelRatio;
        let pixelHeight = height * pixelRatio;
        //while (pixelWidth * pixelHeight > 16777216 && pixelRatio >= 2) {
        while(pixelHeight * pixelWidth > 8388608 && pixelRatio >= 2){
            // Don't exceed maximum size in safari
            pixelRatio -= 0.5;
            pixelWidth = canvasWidth * pixelRatio;
            pixelHeight = height * pixelRatio;
        }
        while(navigator.userAgent.indexOf("Firefox") > 0 && pixelHeight > 32767){
            // Don't exceed maximum size in firefox
            pixelRatio--;
            pixelWidth = canvasWidth * pixelRatio;
            pixelHeight = height * pixelRatio;
        }
        canvasRef.current.width = pixelWidth;
        canvasRef.current.height = pixelHeight;
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        context.font = CANVAS_FONT;
        context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        // Compute the line layout
        const renderLines = [
            {
                elements: [],
                rawWidth: 0,
                textWidth: 0,
                spaceCount: 0
            }
        ];
        const addHyphen = ()=>{
            context.font = CANVAS_FONT;
            renderLines[renderLines.length - 1].elements.push({
                type: "hyphen"
            });
            renderLines[renderLines.length - 1].textWidth += context.measureText("-").width;
            renderLines[renderLines.length - 1].rawWidth += context.measureText("-").width;
        };
        const addDot = (long)=>{
            context.font = CANVAS_FONT;
            renderLines[renderLines.length - 1].elements.push({
                type: "dot",
                long: long
            });
            renderLines[renderLines.length - 1].textWidth += context.measureText("-").width;
            renderLines[renderLines.length - 1].rawWidth += context.measureText("-").width;
        };
        const addClef = ()=>{
            renderLines[renderLines.length - 1].elements.push({
                type: "clef",
                variant: pointedText.clef
            });
            renderLines[renderLines.length - 1].textWidth += $49d4b9cf3f617ce8$export$e944699278f9a54b;
            renderLines[renderLines.length - 1].rawWidth += $49d4b9cf3f617ce8$export$e944699278f9a54b;
        };
        let isFirstSyllable = true;
        let verseIsBold = boldMode === "all";
        let highlightedSoFar = 0;
        const processSyllable = (syllable, verseIndex, half)=>{
            if (isFirstSyllable) {
                if (dropCap) {
                    // Add drop cap at the very beginning
                    renderLines[renderLines.length - 1].elements.push({
                        type: "drop cap",
                        text: syllable.text[0]
                    });
                    context.font = (0, $b5d1360628cd70a0$export$a281c13bc07e2812);
                    const dropCapWidth = context.measureText(syllable.text[0]).width;
                    renderLines[renderLines.length - 1].textWidth += dropCapWidth;
                    renderLines[renderLines.length - 1].rawWidth += dropCapWidth;
                    syllable = {
                        ...syllable,
                        text: syllable.text.substr(1)
                    };
                }
                isFirstSyllable = false;
                // Add the first clef
                addClef();
            }
            if (syllable.qBarBefore) {
                renderLines[renderLines.length - 1].elements.push({
                    type: "qbar"
                });
                renderLines[renderLines.length - 1].rawWidth += 20;
            }
            context.font = (verseIsBold ? "700 " : "500 ") + CANVAS_FONT;
            let syllableWidth = Math.max(context.measureText(syllable.text).width, $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * syllable.notes.length * 0.75);
            if (syllable.text.slice(0, 4) === "LORD") syllableWidth *= 0.9;
            const highlightedNoteCount = Math.min((highlightCount ?? 0) - highlightedSoFar, syllable.notes.length);
            highlightedSoFar += highlightedNoteCount;
            const syllableElement = {
                type: "syllable",
                text: syllable.text,
                notes: syllable.notes,
                long: syllable.long,
                width: syllableWidth,
                reciting: !!syllable.reciting,
                highlightedNoteCount: highlightedNoteCount
            };
            const prevElement = renderLines[renderLines.length - 1]?.elements[renderLines[renderLines.length - 1]?.elements.length - 1] ?? undefined;
            if (renderLines[renderLines.length - 1].rawWidth + syllableWidth < canvasWidth - TEXT_BREATHING_ROOM) {
                if (prevElement && prevElement.type === "syllable" && (prevElement.notes[prevElement.notes.length - 1] !== syllable.notes[0] || syllable.notes.length > 1)) {
                    if (syllable.dotBefore) addDot(false);
                    else if (prevElement.text[prevElement.text.length - 1] !== "-") addHyphen();
                }
                renderLines[renderLines.length - 1].elements.push(syllableElement);
                renderLines[renderLines.length - 1].textWidth += syllableWidth;
                renderLines[renderLines.length - 1].rawWidth += syllableWidth;
            } else {
                if (prevElement.type === "syllable") {
                    if (syllable.dotBefore) addDot(false);
                    else if (prevElement.text[prevElement.text.length - 1] !== "-") addHyphen();
                }
                renderLines[renderLines.length - 1].elements.push({
                    type: "line feed",
                    noteValue: $49d4b9cf3f617ce8$export$6bd450e554c25d4b(syllable.notes[0])
                });
                renderLines.push({
                    elements: [],
                    rawWidth: 0,
                    textWidth: 0,
                    spaceCount: 0
                });
                addClef();
                renderLines[renderLines.length - 1].elements.push(syllableElement);
                renderLines[renderLines.length - 1].textWidth += syllableWidth;
                renderLines[renderLines.length - 1].rawWidth += syllableWidth;
            }
        };
        const addSpace = ()=>{
            if (renderLines[renderLines.length - 1].rawWidth + SPACE_WIDTH < canvasWidth) {
                renderLines[renderLines.length - 1].elements.push({
                    type: "space"
                });
                renderLines[renderLines.length - 1].rawWidth += SPACE_WIDTH;
                renderLines[renderLines.length - 1].spaceCount += 1;
            }
        };
        pointedText.verses.forEach((verse, verseIndex)=>{
            if (verse.firstHalf) {
                verse.firstHalf.forEach((word, wordIndex)=>{
                    word.syllables.forEach((syllable)=>processSyllable(syllable, verseIndex, "first"));
                    if (!verse.firstHalf) return; // won't happen, just making TS happy
                    if (wordIndex < verse.firstHalf.length - 1) {
                        if (verse.firstHalf[wordIndex + 1].syllables[0].dotBefore) addDot(true);
                        else addSpace();
                    }
                });
                renderLines[renderLines.length - 1].elements.push({
                    type: "mid"
                });
                renderLines[renderLines.length - 1].rawWidth += SPACE_WIDTH * SPACES_PER_MID;
                renderLines[renderLines.length - 1].spaceCount += SPACES_PER_MID;
            }
            verse.secondHalf.forEach((word, wordIndex)=>{
                word.syllables.forEach((syllable)=>processSyllable(syllable, verseIndex, "second"));
                if (wordIndex < verse.secondHalf.length - 1) {
                    if (verse.secondHalf[wordIndex + 1].syllables[0].dotBefore) addDot(true);
                    else addSpace();
                }
            });
            renderLines[renderLines.length - 1].elements.push({
                type: "end"
            });
            renderLines[renderLines.length - 1].rawWidth += SPACE_WIDTH * SPACES_PER_END;
            renderLines[renderLines.length - 1].spaceCount += SPACES_PER_END;
            if (boldMode === "alternate") verseIsBold = !verseIsBold;
        });
        let bold = boldMode === "all";
        // ==== RENDER THE CONTENT ====
        renderLines.forEach((renderLine, lineIndex)=>{
            const spaceWidth = 0.2 * (canvasWidth - renderLine.textWidth) / renderLine.spaceCount + 0.8 * SPACE_WIDTH;
            let xPos = 0;
            renderLine.elements.forEach((element, elementIndex)=>{
                const yPos = lineIndex * $49d4b9cf3f617ce8$export$42510bee89f29ff9 + 0.5 + (yExtraOffset ?? 0);
                switch(element.type){
                    case "drop cap":
                        context.font = (0, $b5d1360628cd70a0$export$a281c13bc07e2812);
                        context.fillStyle = (0, $b5d1360628cd70a0$export$9369a7166d10a081);
                        context.fillText(element.text, xPos + 4, yPos + $49d4b9cf3f617ce8$export$42510bee89f29ff9 * 0.92);
                        xPos += context.measureText(element.text).width + 4;
                        context.lineWidth = 1;
                        break;
                    case "clef":
                        const clefWidth = element.variant === "f5" ? $49d4b9cf3f617ce8$export$e944699278f9a54b * 1.5 : $49d4b9cf3f617ce8$export$e944699278f9a54b;
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, clefWidth, tuningNote);
                        let clefX = xPos;
                        const clefY = yPos + (9 - (element.variant === "c7" ? 7 : 5)) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64;
                        context.fillStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                        if (element.variant === "f5") {
                            context.beginPath();
                            context.moveTo(clefX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462, clefY + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1);
                            context.quadraticCurveTo(clefX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 0.5, clefY + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1 - $49d4b9cf3f617ce8$export$2f425c82cb309503, clefX, clefY + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1);
                            context.lineTo(clefX, clefY - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38);
                            context.quadraticCurveTo(clefX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 0.5, clefY - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 - $49d4b9cf3f617ce8$export$2f425c82cb309503, clefX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462, clefY - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38);
                            context.closePath();
                            context.fill();
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(clefX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 0.5, clefY);
                            context.lineTo(clefX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 0.5, clefY + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.4);
                            context.closePath();
                            context.stroke();
                            clefX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 + 1;
                        }
                        context.beginPath();
                        context.moveTo(clefX, clefY);
                        context.lineTo(clefX, clefY - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.5);
                        context.bezierCurveTo(clefX, clefY - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.8, clefX + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.3, clefY - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.0, clefX + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.6, clefY - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.75);
                        context.lineTo(clefX + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.6, clefY - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.25);
                        context.bezierCurveTo(clefX + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.25, clefY - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.25, clefX + 1, clefY - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.25, clefX + 1, clefY);
                        context.bezierCurveTo(clefX + 1, clefY + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.25, clefX + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.25, clefY + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.25, clefX + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.6, clefY + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.25);
                        context.lineTo(clefX + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.6, clefY + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.75);
                        context.bezierCurveTo(clefX + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.3, clefY + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.0, clefX, clefY + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.8, clefX, clefY + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 0.5);
                        context.closePath();
                        context.fill();
                        xPos += clefWidth;
                        break;
                    case "syllable":
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, element.width, tuningNote);
                        let remainingHighlightedNotes = element.highlightedNoteCount;
                        context.fillStyle = (0, $b5d1360628cd70a0$export$516f68680b50dca1);
                        context.font = (bold ? "700 " : "500 ") + CANVAS_FONT;
                        if (element.text.includes("LORD")) {
                            context.font = (bold ? "700 " : "500 ") + CANVAS_FONT;
                            const lWidth = context.measureText("L").width;
                            context.font = (bold ? "700 " : "500 ") + CANVAS_SMALL_CAP_FONT;
                            const remWidth = context.measureText(element.text.slice(1)).width;
                            context.font = (bold ? "700 " : "500 ") + CANVAS_FONT;
                            context.fillText("L", xPos + (element.width - lWidth - remWidth) / 2, yPos + 6 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 2);
                            context.font = (bold ? "700 " : "500 ") + CANVAS_SMALL_CAP_FONT;
                            context.fillText(element.text.slice(1), xPos + (element.width - lWidth - remWidth) / 2 + lWidth, yPos + 6 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 2);
                        } else context.fillText(element.text, xPos + (element.width - context.measureText(element.text).width) / 2, yPos + 6 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 2);
                        const centerX = Math.round(xPos + element.width / 2);
                        if (element.reciting) {
                            const w = 24;
                            context.beginPath();
                            context.rect(centerX - w / 2, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2, w, $49d4b9cf3f617ce8$export$dcfc08b7a30da462);
                            if (element.highlightedNoteCount > 0) {
                                context.fillStyle = (0, $b5d1360628cd70a0$export$1a6c4fc8d15a2dc7);
                                context.fill();
                                context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                                context.stroke();
                            } else {
                                context.fillStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                                context.fill();
                            }
                        } else if (element.notes.length === 2 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) < $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) {
                            // Two-note ascending
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, centerX, yPos, element.notes[0], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, centerX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(centerX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(centerX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            if (element.long) {
                                (0, $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2)(context, centerX, yPos, element.notes[0]);
                                (0, $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2)(context, centerX, yPos, element.notes[1]);
                            }
                        } else if (element.notes.length === 2 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) {
                            // Two note consecutive descending
                            let noteX = Math.round(centerX - (element.notes.length - 1) * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462, yPos, element.notes[1], 0, undefined, remainingHighlightedNotes-- > 0, {
                                shiftFlat: 2 - $49d4b9cf3f617ce8$export$dcfc08b7a30da462
                            }, tuningNote);
                            context.beginPath();
                            context.moveTo(noteX - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.3);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.stroke();
                            if (element.long) {
                                (0, $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2)(context, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462, yPos, element.notes[0]);
                                (0, $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2)(context, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462, yPos, `${$49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) % 2}`);
                            }
                        } else if (element.notes.length === 2 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 2 >= $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) {
                            // Two note descending by >=2
                            let noteX = Math.round(centerX - (element.notes.length - 1) * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1, yPos, element.notes[1], 0, undefined, remainingHighlightedNotes-- > 0, {
                                shiftFlat: 2 - $49d4b9cf3f617ce8$export$dcfc08b7a30da462
                            }, tuningNote);
                            context.beginPath();
                            context.moveTo(noteX - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.stroke();
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.stroke();
                        // TODO: implement long dots
                        } else if (element.notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) || element.notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) {
                            // 3 or 4 note descending
                            // Two note consecutive descending
                            let noteX = centerX - (element.notes.length - 1) * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.3);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.stroke();
                            element.notes.slice(1).forEach((note)=>{
                                noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                                (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, note, remainingHighlightedNotes-- > 0, tuningNote);
                            });
                            if (element.long) (0, $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2)(context, noteX + 1, yPos, element.notes[element.notes.length - 1]);
                        } else if (element.notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) {
                            // 3 note descender as in the compline resonsory
                            const noteX = centerX - 3 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            context.beginPath();
                            context.moveTo(noteX - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.3);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.stroke();
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462, yPos, element.notes[1], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 2 + 1, yPos, element.notes[2], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            if (element.long) (0, $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2)(context, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 2 + 1, yPos, element.notes[2]);
                        } else if (element.notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 4 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 4 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 5 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) {
                            // 1556 as in Saints day hymn
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, centerX - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 - 1, yPos, element.notes[0], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, centerX - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 - 1, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(centerX, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(centerX, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, centerX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos, element.notes[2], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, centerX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos, element.notes[3], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(centerX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(centerX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                        } else if (element.notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) {
                            // 5765 as in Saints day hymn
                            let noteX = centerX - 3 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2 + 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[2], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 1, yPos, element.notes[3], remainingHighlightedNotes-- > 0, tuningNote);
                        } else if (element.notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) {
                            // 4323 as in annunciation hymn
                            let noteX = centerX - 3 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2 + 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.3);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[1], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 2;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[2], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 + 1;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[3], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                        } else if (element.notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) {
                            // 4543 as in annunciation hymn
                            let noteX = centerX - 3 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[2], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 2;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[3], remainingHighlightedNotes-- > 0, tuningNote);
                        } else if (element.notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) {
                            // 132 as in Sunday evening OT hymn
                            let noteX = centerX - 3 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[2], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                        } else if (element.notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) {
                            // 345 as in passiontide evening hymn
                            let noteX = centerX - 3 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0.5, 0, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -0.5, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[2], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                        } else if (element.notes.length === 6 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[4]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[5])) {
                            // 431234 as in passiontide evening hymn
                            let noteX = centerX - 5 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[1], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 2;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[2], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 + 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[3], 0.5, 0, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[4], -0.5, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[4])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[5], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[5])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                        } else if (element.notes.length === 5 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[4])) {
                            // 35654 as in passiontide evening hymn
                            let noteX = centerX - 4 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[2], 0, undefined, remainingHighlightedNotes-- > 0, {
                                shiftFlat: -4
                            }, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[4])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[3], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 2;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[4], remainingHighlightedNotes-- > 0, tuningNote);
                        } else if (element.notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) {
                            // 121 as in Office Hymn "Amen"
                            let noteX = centerX - 3 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            context.beginPath();
                            context.moveTo(noteX + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 * 1.3);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.stroke();
                            context.beginPath();
                            context.moveTo(noteX, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38);
                            context.quadraticCurveTo(noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 2 + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 3 + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 3 + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1);
                            context.quadraticCurveTo(noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 2 + 0.5, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, noteX, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38);
                            const highlighted = (remainingHighlightedNotes -= 2) > 0;
                            context.fillStyle = highlighted ? "white" : (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.fill();
                            if (highlighted) {
                                context.strokeStyle = "black";
                                context.stroke();
                            }
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 3, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 3, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.stroke();
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX + $49d4b9cf3f617ce8$export$dcfc08b7a30da462 * 2 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38, yPos, element.notes[2], -1, 1, remainingHighlightedNotes-- > 0, {}, tuningNote);
                        } else if (element.notes.length === 5 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[4])) {
                            // 25432 as in Let us bless the Lord Alleluia Alleluia
                            let noteX = centerX - 4 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2 + 2;
                            // First ascender
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            // First diamond streak
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[2], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 1, yPos, element.notes[3], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 2, yPos, element.notes[4], remainingHighlightedNotes-- > 0, tuningNote);
                        } else if (element.notes.length === 5 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[4])) {
                            // 45675 as in Ascension hymn
                            let noteX = centerX - 4 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2 + 2;
                            // First ascender
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[2], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[3], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[4])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[4], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                        } else if (element.notes.length === 6 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[4]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[5])) {
                            // 567654 as in Ascension hymn
                            let noteX = centerX - 4 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2 + 2;
                            // First ascender
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            // First diamond streak
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[2], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 1, yPos, element.notes[3], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 2, yPos, element.notes[4], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 3, yPos, element.notes[5], remainingHighlightedNotes-- > 0, tuningNote);
                        } else if (element.notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) {
                            // 476 as in Ascension hymn
                            let noteX = centerX - 3 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2 + 2;
                            // First ascender
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], -0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 - 1;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[2], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                        } else if (element.notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 4 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0]) + 5 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[2])) {
                            // 378 as in Whitsun PM hymn
                            let noteX = centerX - 2 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2 + 2;
                            // First ascender
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], -0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[2], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                        } else if (element.notes.length === 9) {
                            // HACKY SPECIAL CASE FOR "...APPLE OF THINE EYE" - 9 NOTES LONG
                            let noteX = centerX - 7 * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            // First ascender
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[0], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[1], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[0])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[1])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            // First diamond streak
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[2], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 1, yPos, element.notes[3], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 2, yPos, element.notes[4], remainingHighlightedNotes-- > 0, tuningNote);
                            // Second ascender
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462 + 2;
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[5], 0.5, 0.5, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, element.notes[6], -1, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                            context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                            context.beginPath();
                            context.moveTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[5])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.lineTo(noteX + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + 1, yPos + (9 - $49d4b9cf3f617ce8$export$6bd450e554c25d4b(element.notes[6])) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64);
                            context.stroke();
                            // Second diamond streak
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX, yPos, element.notes[7], remainingHighlightedNotes-- > 0, tuningNote);
                            noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            (0, $c25e5e6c4ba9c9f6$export$57ec12daf141ce6)(context, noteX - 1, yPos, element.notes[8], remainingHighlightedNotes-- > 0, tuningNote);
                            (0, $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2)(context, noteX - 1, yPos, element.notes[8]);
                        } else {
                            // Any other note(s)
                            let noteX = centerX - (element.notes.length - 1) * $49d4b9cf3f617ce8$export$dcfc08b7a30da462 / 2;
                            element.notes.forEach((note)=>{
                                (0, $c25e5e6c4ba9c9f6$export$26951c054d3de335)(context, noteX, yPos, note, 0, undefined, remainingHighlightedNotes-- > 0, {}, tuningNote);
                                noteX += $49d4b9cf3f617ce8$export$dcfc08b7a30da462;
                            });
                            if (element.long) (0, $c25e5e6c4ba9c9f6$export$d63f636b4e063ae2)(context, noteX - $49d4b9cf3f617ce8$export$dcfc08b7a30da462, yPos, element.notes[element.notes.length - 1]);
                        }
                        xPos += element.width;
                        break;
                    case "space":
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, spaceWidth, tuningNote);
                        xPos += spaceWidth;
                        break;
                    case "qbar":
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, spaceWidth * SPACES_PER_MID * 0.5, tuningNote);
                        context.strokeStyle = (0, $b5d1360628cd70a0$export$278aa54ed3f4968d);
                        context.beginPath();
                        context.moveTo(Math.round(xPos + spaceWidth * SPACES_PER_MID * 0.5 / 2) + 0.5, yPos + 1.5 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 0.5);
                        context.lineTo(Math.round(xPos + spaceWidth * SPACES_PER_MID * 0.5 / 2) + 0.5, yPos + 3.5 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + 0.5);
                        context.stroke();
                        xPos += spaceWidth * SPACES_PER_MID * 0.5;
                        break;
                    case "mid":
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, spaceWidth * SPACES_PER_MID, tuningNote);
                        context.strokeStyle = (0, $b5d1360628cd70a0$export$278aa54ed3f4968d);
                        context.beginPath();
                        context.moveTo(Math.round(xPos + spaceWidth * SPACES_PER_MID / 2) + 0.5, yPos + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 0.5);
                        context.lineTo(Math.round(xPos + spaceWidth * SPACES_PER_MID / 2) + 0.5, yPos + 4 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + 0.5);
                        context.stroke();
                        xPos += spaceWidth * SPACES_PER_MID;
                        if (boldMode === "alternate halves") bold = !bold;
                        break;
                    case "end":
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, elementIndex === renderLine.elements.length - 1 ? spaceWidth * SPACES_PER_END / 2 + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 / 4 : spaceWidth * SPACES_PER_END, tuningNote);
                        context.strokeStyle = (0, $b5d1360628cd70a0$export$278aa54ed3f4968d);
                        context.beginPath();
                        context.moveTo(Math.round(xPos + spaceWidth * SPACES_PER_END / 2 - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 / 4) + 0.5, yPos + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 0.5);
                        context.lineTo(Math.round(xPos + spaceWidth * SPACES_PER_END / 2 - $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 / 4) + 0.5, yPos + 4 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + 0.5);
                        context.stroke();
                        context.beginPath();
                        context.moveTo(Math.round(xPos + spaceWidth * SPACES_PER_END / 2 + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 / 4) + 0.5, yPos + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 0.5);
                        context.lineTo(Math.round(xPos + spaceWidth * SPACES_PER_END / 2 + $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 / 4) + 0.5, yPos + 4 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + 0.5);
                        context.stroke();
                        xPos += spaceWidth * SPACES_PER_END;
                        if (boldMode === "alternate" || boldMode === "alternate halves") bold = !bold;
                        break;
                    case "hyphen":
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, context.measureText("-").width, tuningNote);
                        context.fillStyle = (0, $b5d1360628cd70a0$export$5f6c0430e306396e);
                        context.fillText("-", xPos, yPos + 6 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 2);
                        xPos += context.measureText("-").width;
                        break;
                    case "dot":
                        const dotWidth = element.long ? context.measureText(" \u2022 ").width : context.measureText("\u2022").width;
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, dotWidth, tuningNote);
                        context.fillStyle = (0, $b5d1360628cd70a0$export$48ee2f34eb455667);
                        context.font = CANVAS_FONT;
                        context.fillText("\u2022", xPos + dotWidth / 2 - context.measureText("\u2022").width / 2, yPos + 6 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - 0.5);
                        xPos += dotWidth;
                        break;
                    case "line feed":
                        (0, $c25e5e6c4ba9c9f6$export$fb62f8e239018dfa)(context, xPos, yPos, canvasWidth - xPos, tuningNote);
                        context.fillStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                        context.beginPath();
                        context.moveTo(canvasWidth - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 - 0.5, yPos + (9 - element.noteValue) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 - 1);
                        context.quadraticCurveTo(canvasWidth - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 / 2, yPos + (9 - element.noteValue) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 - 1 + $49d4b9cf3f617ce8$export$2f425c82cb309503 / 2, canvasWidth, yPos + (9 - element.noteValue) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 - 1 + $49d4b9cf3f617ce8$export$2f425c82cb309503 / 2);
                        context.lineTo(canvasWidth, yPos + (9 - element.noteValue) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + $49d4b9cf3f617ce8$export$2f425c82cb309503 / 2);
                        context.quadraticCurveTo(canvasWidth - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 / 2, yPos + (9 - element.noteValue) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + $49d4b9cf3f617ce8$export$2f425c82cb309503 / 2, canvasWidth - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 - 0.5, yPos + (9 - element.noteValue) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38);
                        context.closePath();
                        context.fill();
                        context.beginPath();
                        context.strokeStyle = (0, $b5d1360628cd70a0$export$ac989c726cc30b36);
                        context.moveTo(canvasWidth - 0.5, yPos + (9 - element.noteValue) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 + $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 + $49d4b9cf3f617ce8$export$2f425c82cb309503 / 2 - 2);
                        context.lineTo(canvasWidth - 0.5, yPos + (9 - element.noteValue) / 2 * $49d4b9cf3f617ce8$export$31dc21c2b5f77f64 - $49d4b9cf3f617ce8$export$6ee4576e82bf6b38 * 5 + $49d4b9cf3f617ce8$export$2f425c82cb309503 / 2);
                        context.stroke();
                        break;
                }
            });
        });
        if (exportLines && canvasWidth > 0) {
            const lineImageData = [];
            let exportY = yExtraOffset ?? 0;
            renderLines.forEach(()=>{
                lineImageData.push(context.getImageData(0, exportY, canvasWidth * pixelRatio, $49d4b9cf3f617ce8$export$42510bee89f29ff9 * pixelRatio));
                exportY += $49d4b9cf3f617ce8$export$42510bee89f29ff9 * pixelRatio;
            });
            console.log("lines", {
                lines: lineImageData,
                width: canvasWidth * pixelRatio,
                height: $49d4b9cf3f617ce8$export$42510bee89f29ff9 * pixelRatio
            });
            setExportData({
                lines: lineImageData,
                width: canvasWidth * pixelRatio,
                height: $49d4b9cf3f617ce8$export$42510bee89f29ff9 * pixelRatio
            });
        }
        setHeight(renderLines.length * $49d4b9cf3f617ce8$export$42510bee89f29ff9);
    }, [
        pointedText,
        height,
        boldMode,
        forceRenderCount,
        tuningNote
    ]);
    const isOrdinariatePage = window.location.href.includes("/se/");
    const chant = settings.experimentalChantRendering === "on" || isOrdinariatePage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04cfb5a990424bdb$export$a512b99ae1e55604), {
        gabc: $49d4b9cf3f617ce8$export$6893db788aa80426(pointedText, boldMode),
        dropCap: dropCap,
        tone: tone,
        onReportMistake: props.onReportMistake
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: containerRef,
                style: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("canvas", {
                    ref: canvasRef,
                    style: {
                        width: "100%",
                        height: height
                    }
                })
            }),
            exportData.width > 0 ? exportData.lines.map((imageData)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: "export-item",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec0044bd603cd929$export$6d26a49742b7cf57), {
                        imageData: imageData,
                        width: imageData.width,
                        height: imageData.height
                    })
                });
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
    const content = rubric ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "flex-start",
                flexDirection: isSmallScreen ? "column" : "row"
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: isSmallScreen ? {
                        color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                        fontSize: "90%"
                    } : {
                        color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                        paddingRight: 16,
                        paddingTop: 16,
                        width: 64,
                        flexShrink: 0,
                        textAlign: "right",
                        fontSize: "90%"
                    },
                    children: rubric
                }),
                chant
            ]
        })
    }) : chant;
    const paddedContent = noPadding ? content : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        onlySides: true,
        children: content
    });
    return paddedContent;
};
const $49d4b9cf3f617ce8$var$lookup = "cdefghijk";
const $49d4b9cf3f617ce8$var$getGabcNotesForSyllable = (notes, long)=>{
    let result = "";
    const drawNote = (note, long)=>{
        if (note[note.length - 1] === "b") result = $49d4b9cf3f617ce8$var$lookup[$49d4b9cf3f617ce8$export$6bd450e554c25d4b(note)] + "x" + result;
        result += $49d4b9cf3f617ce8$var$lookup[$49d4b9cf3f617ce8$export$6bd450e554c25d4b(note)];
        if (long) result += ".";
    };
    const drawDiamond = (note, long)=>{
        result += $49d4b9cf3f617ce8$var$lookup[$49d4b9cf3f617ce8$export$6bd450e554c25d4b(note)].toLocaleUpperCase();
        if (long) result += ".";
    };
    if (notes.length === 2 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) < $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1])) {
        // Two-note ascending
        drawNote(notes[0], long);
        drawNote(notes[1], long);
    } else if (notes.length === 2 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1])) {
        // Two note consecutive descending
        drawNote(notes[0], long);
        drawNote(notes[1], long);
    } else if (notes.length === 2 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 2 >= $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1])) {
        // Two note descending by >=2
        drawNote(notes[0], long);
        drawNote(notes[1], long);
    } else if (notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) || notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3])) {
        // 3 or 4 note descending
        // Two note consecutive descending
        drawNote(notes[0], false);
        notes.slice(1).forEach((note, noteIndex)=>{
            drawDiamond(note, noteIndex === notes.length - 2);
        });
    } else if (notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2])) {
        // 3 note descender as in the compline resonsory
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], long);
    } else if (notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 4 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 4 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 5 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3])) {
        // 1556 as in Saints day hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
        drawNote(notes[3], false);
    } else if (notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3])) {
        // 5765 as in Saints day hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawDiamond(notes[2], false);
        drawDiamond(notes[3], false);
    } else if (notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3])) {
        // 4323 as in annunciation hymn
        drawNote(notes[0], false);
        drawDiamond(notes[1], false);
        drawDiamond(notes[2], false);
        drawNote(notes[3], false);
    } else if (notes.length === 4 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3])) {
        // 4543 as in annunciation hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawDiamond(notes[2], false);
        drawDiamond(notes[3], false);
    } else if (notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2])) {
        // 132 as in Sunday evening OT hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
    } else if (notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2])) {
        // 345 as in passiontide evening hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
    } else if (notes.length === 6 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[4]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[5])) {
        // 431234 as in passiontide evening hymn
        drawNote(notes[0], false);
        drawDiamond(notes[1], false);
        drawDiamond(notes[2], false);
        drawNote(notes[3], false);
        drawNote(notes[4], false);
        drawNote(notes[5], false);
    } else if (notes.length === 5 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[4])) {
        // 35654 as in passiontide evening hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
        drawDiamond(notes[3], false);
        drawDiamond(notes[4], false);
    } else if (notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2])) {
        // 121 as in Office Hymn "Amen"
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
    } else if (notes.length === 5 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[4])) {
        // 25432 as in Let us bless the Lord Alleluia Alleluia
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawDiamond(notes[2], false);
        drawDiamond(notes[3], false);
        drawDiamond(notes[4], false);
    } else if (notes.length === 5 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[4])) {
        // 45675 as in Ascension hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
        drawNote(notes[3], false);
        drawNote(notes[4], false);
    } else if (notes.length === 6 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[3]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[4]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) - 1 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[5])) {
        // 567654 as in Ascension hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
        drawDiamond(notes[3], false);
        drawDiamond(notes[4], false);
        drawDiamond(notes[5], false);
    } else if (notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 3 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 2 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2])) {
        // 476 as in Ascension hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
    } else if (notes.length === 3 && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 4 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[1]) && $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[0]) + 5 === $49d4b9cf3f617ce8$export$6bd450e554c25d4b(notes[2])) {
        // 378 as in Whitsun PM hymn
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawNote(notes[2], false);
    } else if (notes.length === 9) {
        // HACKY SPECIAL CASE FOR "...APPLE OF THINE EYE" - 9 NOTES LONG
        drawNote(notes[0], false);
        drawNote(notes[1], false);
        drawDiamond(notes[2], false);
        drawDiamond(notes[3], false);
        drawDiamond(notes[4], false);
        drawNote(notes[5], false);
        drawNote(notes[6], false);
        drawDiamond(notes[7], false);
        drawDiamond(notes[8], true);
    } else // Any other note(s)
    notes.forEach((note, noteIndex)=>{
        drawNote(note, long && noteIndex === notes.length - 1);
    });
    if (result.includes("undefined")) console.log(result, notes);
    return result;
};
const $49d4b9cf3f617ce8$export$6893db788aa80426 = (pointedText, boldMode)=>{
    let gabc = "";
    if (pointedText.clef === "c5") gabc += "(c3)";
    if (pointedText.clef === "c7") gabc += "(c4)";
    if (pointedText.clef === "f5") gabc += "(f3)";
    let verseIsBold = boldMode === "all";
    pointedText.verses.forEach((verse)=>{
        verse.firstHalf?.forEach((word)=>{
            gabc += " ";
            word.syllables.forEach((syllable)=>{
                const notes = $49d4b9cf3f617ce8$var$getGabcNotesForSyllable(syllable.notes, syllable.long);
                if (syllable.dotBefore) gabc += "\xa3";
                if (syllable.pauseBefore) gabc += "\u2020(,) ";
                const text = verseIsBold ? `*${syllable.text}*` : syllable.text;
                gabc += text + "(" + notes + ")";
            });
        });
        if (verse.firstHalf) gabc += " $(:)";
        verse.secondHalf?.forEach((word)=>{
            gabc += " ";
            word.syllables.forEach((syllable)=>{
                const notes = $49d4b9cf3f617ce8$var$getGabcNotesForSyllable(syllable.notes, syllable.long);
                if (syllable.dotBefore) gabc += "\xa3";
                const text = verseIsBold ? `*${syllable.text}*` : syllable.text;
                gabc += text + "(" + notes + ")";
            });
        });
        gabc += " (::)";
        if (boldMode === "alternate") verseIsBold = !verseIsBold;
    });
    return gabc;
};






const $462dc9aff22a0c60$var$maybeHighlightNote = (neumeIndex, neumeNoteIndex, pitch, highlightedPitch, highlightedNote, id)=>{
    if (highlightedNote && neumeIndex === highlightedNote[0] && neumeNoteIndex === highlightedNote[1]) return `${id}-white`;
    else return id;
};
const $462dc9aff22a0c60$export$cac4fba5c7f7e881 = (neumes, isSmallScreen, measureText, highlightedNote)=>{
    const highlightedPitch = undefined;
    const layoutNeumesWithoutText = neumes.map((neume, neumeIndex)=>{
        let neumeExtensionLeft = 0;
        const svgNeume = [];
        let leftOffset = 0;
        const addMora = (pitch, leftOffset)=>{
            svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                xlinkHref: "#mora",
                x: leftOffset + 2,
                y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(pitch) - 5 - (pitch % 2 - 1) * 1
            }));
        };
        const addNote = (note, incrementLeft, renderMora, neumeNoteIndex)=>{
            if (note.isInclinatum) {
                svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                    xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex, note.pitch, highlightedPitch, highlightedNote, "#punctum-inclinatum"),
                    x: leftOffset,
                    y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note.pitch) - 4
                }));
                if (incrementLeft) leftOffset += 4;
            } else if (note.isQuilisma) {
                svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                    xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex, note.pitch, highlightedPitch, highlightedNote, "#quilisma"),
                    x: leftOffset,
                    y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note.pitch) - 4
                }));
                if (incrementLeft) leftOffset += 6;
            } else {
                svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                    xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex, note.pitch, highlightedPitch, highlightedNote, "#punctum-quadratum"),
                    x: leftOffset,
                    y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note.pitch) - 3.5
                }));
                if (incrementLeft) leftOffset += 6;
            }
            if (note.hasMora && renderMora) {
                addMora(note.pitch, leftOffset);
                leftOffset += 4;
            }
        };
        const addVerticalLine = (startPitch, endPitch, extraDescent, offset)=>{
            svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: leftOffset + offset + 0.5,
                x2: leftOffset + offset + 0.5,
                y1: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(startPitch),
                y2: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(endPitch) + extraDescent,
                stroke: "black",
                strokeWidth: 1
            }));
        };
        const addPodatus = (note1, note2, neumeNoteIndex)=>{
            if (note2.isLiquescent) {
                svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                    xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex, note1.pitch, highlightedPitch, highlightedNote, "#beginning-ascending-liquescent"),
                    x: leftOffset,
                    y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note1.pitch) - 4.5
                }));
                leftOffset += 3;
                svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                    xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex + 1, note2.pitch, highlightedPitch, highlightedNote, "#terminating-ascending-liquescent"),
                    x: leftOffset,
                    y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note2.pitch) - 2.5
                }));
                leftOffset += 3;
                addVerticalLine(note1.pitch, note2.pitch, 0, -1);
            } else {
                if (note1.isQuilisma) svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                    xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex, note1.pitch, highlightedPitch, highlightedNote, "#quilisma"),
                    x: leftOffset,
                    y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note1.pitch) - 4
                }));
                else svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                    xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex, note1.pitch, highlightedPitch, highlightedNote, "#podatus-lower"),
                    x: leftOffset,
                    y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note1.pitch) - 2.5
                }));
                svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                    xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex + 1, note2.pitch, highlightedPitch, highlightedNote, "#podatus-upper"),
                    x: leftOffset + 0.5,
                    y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note2.pitch) - 3.5
                }));
                leftOffset += 6;
                addVerticalLine(note1.pitch, note2.pitch, 0, -1);
            }
            if (note1.hasMora) addMora(note1.pitch, leftOffset);
            if (note2.hasMora) addMora(note2.pitch, leftOffset);
        };
        const addPorrectus = (note1, note2, note3, neumeNoteIndex)=>{
            const size = note1.pitch - note2.pitch;
            const leftWhite = highlightedNote && neumeIndex === highlightedNote[0] && neumeNoteIndex === highlightedNote[1];
            const rightWhite = highlightedNote && neumeIndex === highlightedNote[0] && neumeNoteIndex + 1 === highlightedNote[1];
            if (size === 1) svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                xlinkHref: leftWhite ? "#porrectus-1-left-white" : rightWhite ? "#porrectus-1-right-white" : "#porrectus-1",
                x: leftOffset,
                y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note1.pitch) - 3.5
            }));
            if (size === 2) svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                xlinkHref: leftWhite ? "#porrectus-2-left-white" : rightWhite ? "#porrectus-2-right-white" : "#porrectus-2",
                x: leftOffset,
                y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note1.pitch) - 3.5
            }));
            if (size === 3) svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                xlinkHref: leftWhite ? "#porrectus-3-left-white" : rightWhite ? "#porrectus-3-right-white" : "#porrectus-3",
                x: leftOffset,
                y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note1.pitch) - 3.5
            }));
            leftOffset += 13;
            svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex + 2, note3.pitch, highlightedPitch, highlightedNote, "#podatus-upper"),
                x: leftOffset + 0.5,
                y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(note3.pitch) - 3.5
            }));
            leftOffset += 6;
            addVerticalLine(note2.pitch, note3.pitch, 0, -1);
        };
        if (neume.showFlat && neume.flatPitch) {
            svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                xlinkHref: "#flat",
                x: -10,
                y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(neume.flatPitch) - 11
            }));
            neumeExtensionLeft += 10;
        }
        let neumeNoteIndex = 0;
        let minNote = 0;
        let maxNote = 0;
        neume.elements.forEach((element)=>{
            minNote = Math.min(minNote, ...element.notes.map((n)=>n.pitch));
            maxNote = Math.max(maxNote, ...element.notes.map((n)=>n.pitch));
            switch(element.type){
                case "punctum":
                    addNote(element.notes[0], true, true, neumeNoteIndex);
                    break;
                case "podatus":
                    addPodatus(element.notes[0], element.notes[1], neumeNoteIndex);
                    break;
                case "clivis":
                    if (element.notes[1].isLiquescent) {
                        addVerticalLine(element.notes[0].pitch, element.notes[1].pitch, element.notes[0].pitch - element.notes[1].pitch === 1 ? 3.5 + ((0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - 1) * (1 - element.notes[1].pitch % 2) / 2 : 3.5, 0);
                        addNote(element.notes[0], false, false, neumeNoteIndex);
                        leftOffset += 3;
                        svgNeume.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                            xlinkHref: $462dc9aff22a0c60$var$maybeHighlightNote(neumeIndex, neumeNoteIndex + 1, element.notes[1].pitch, highlightedPitch, highlightedNote, "#terminating-descending-liquescent"),
                            x: leftOffset,
                            y: (0, $04cfb5a990424bdb$export$97879dd1a1210ded)(element.notes[1].pitch) - 4.5
                        }));
                        leftOffset += 3;
                        addVerticalLine(element.notes[0].pitch, element.notes[1].pitch, 0, -1);
                    } else {
                        addVerticalLine(element.notes[0].pitch, element.notes[1].pitch, element.notes[0].pitch - element.notes[1].pitch === 1 ? 3.5 + ((0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - 1) * (1 - element.notes[1].pitch % 2) / 2 : 3.5, 0);
                        addNote(element.notes[0], true, false, neumeNoteIndex);
                        leftOffset -= 1;
                        addVerticalLine(element.notes[0].pitch, element.notes[1].pitch, 0, 0);
                        addNote(element.notes[1], true, false, neumeNoteIndex + 1);
                    }
                    if (element.notes[0].hasMora) addMora(element.notes[0].pitch, leftOffset - 4);
                    if (element.notes[1].hasMora) addMora(element.notes[1].pitch, leftOffset);
                    break;
                case "scandicus":
                    addNote(element.notes[0], true, true, neumeNoteIndex);
                    addPodatus(element.notes[1], element.notes[2], neumeNoteIndex + 1);
                    if (element.notes[1].hasMora) addMora(element.notes[0].pitch, leftOffset);
                    if (element.notes[2].hasMora) addMora(element.notes[1].pitch, leftOffset);
                    break;
                case "torculus":
                    addNote(element.notes[0], true, false, neumeNoteIndex);
                    leftOffset -= 1;
                    addVerticalLine(element.notes[0].pitch, element.notes[1].pitch, 0, 0);
                    addNote(element.notes[1], true, false, neumeNoteIndex + 1);
                    leftOffset -= 1;
                    addVerticalLine(element.notes[1].pitch, element.notes[2].pitch, 0, 0);
                    addNote(element.notes[2], true, true, neumeNoteIndex + 2);
                    break;
                case "porrectus":
                    addVerticalLine(element.notes[0].pitch, element.notes[1].pitch, element.notes[0].pitch - element.notes[1].pitch === 1 ? 3.5 + ((0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - 1) * (1 - element.notes[1].pitch % 2) / 2 : 3.5, 0);
                    addPorrectus(element.notes[0], element.notes[1], element.notes[2], neumeNoteIndex);
                    break;
                case "pes subpunctis":
                    addPodatus(element.notes[0], element.notes[1], neumeNoteIndex);
                    leftOffset += 1;
                    element.notes.slice(2).forEach((note, noteIndex)=>{
                        addNote(note, true, true, neumeNoteIndex + 2 + noteIndex);
                    });
                    leftOffset += 2;
                    break;
                case "climacus":
                    addNote(element.notes[0], true, true, neumeNoteIndex);
                    addVerticalLine(element.notes[0].pitch, element.notes[1].pitch, element.notes[0].pitch - element.notes[1].pitch === 1 ? 3.5 + ((0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) - 1) * (1 - element.notes[1].pitch % 2) / 2 : 3.5, -1);
                    element.notes.slice(1).forEach((note, noteIndex)=>{
                        addNote(note, true, true, neumeNoteIndex + 1 + noteIndex);
                    });
                    leftOffset += 2;
                    break;
                case "quarter bar":
                    leftOffset += 2;
                    addVerticalLine(6, 8, 0, 0);
                    leftOffset += 2;
                    break;
                case "half bar":
                    leftOffset += 2;
                    addVerticalLine(2, 6, 0, 0);
                    leftOffset += 2;
                    break;
                case "full bar":
                    leftOffset += 2;
                    addVerticalLine(1, 7, 0, 0);
                    leftOffset += 2;
                    break;
            }
            if (!element.suppressSpace) leftOffset += 2;
            neumeNoteIndex += element.notes.length;
        });
        leftOffset += isSmallScreen ? 4 : 8;
        return {
            neume: neume,
            svgNeume: svgNeume,
            neumeExtensionLeft: neumeExtensionLeft,
            neumeExtensionRight: leftOffset,
            maxNote: maxNote,
            minNote: minNote
        };
    });
    const extensions = layoutNeumesWithoutText.map((layoutNeume)=>{
        const fvi = Array.from(layoutNeume.neume.text).findIndex((char, charIndex)=>{
            if (charIndex !== 0 && (char === "y" || char === "Y")) return true;
            if (charIndex > 0 && char === "u" && Array.from(layoutNeume.neume.text)[charIndex - 1] === "q") return false;
            return "aeiouAEIOU\xe1\xe9\xed\xf3\xfa\xc1\xc9\xcd\xd3\xda\xe6".includes(char);
        });
        const firstVowelIndex = fvi === -1 ? 0 : fvi;
        const textBeforeNeume = layoutNeume.neume.text.slice(0, firstVowelIndex);
        const textAfterNeume = layoutNeume.neume.text.slice(firstVowelIndex);
        const textExtensionLeft = measureText(textBeforeNeume, layoutNeume.neume.isBold ? "normal bold" : "normal");
        const textExtensionRight = measureText(textAfterNeume, layoutNeume.neume.isBold ? "normal bold" : "normal");
        return {
            textExtensionLeft: textExtensionLeft,
            textExtensionRight: textExtensionRight,
            isEmpty: layoutNeume.neume.text.trim().length === 0
        };
    });
    const bulletWidth = measureText("\u2022", "normal");
    const layoutNeumes = layoutNeumesWithoutText.map((layoutNeume, layoutNeumeIndex)=>{
        let text = layoutNeume.neume.text;
        let textExtensionRight = extensions[layoutNeumeIndex].textExtensionRight;
        let neumeExtensionRight = layoutNeume.neumeExtensionRight;
        let redDotOffset = undefined;
        const endsWithSpace = layoutNeume.neume.text[layoutNeume.neume.text.length - 1] === " ";
        const endsWithHyphen = layoutNeume.neume.text[layoutNeume.neume.text.length - 1] === "-";
        if (layoutNeumeIndex < layoutNeumesWithoutText.length - 1) {
            const redDotFollows = layoutNeumesWithoutText[layoutNeumeIndex + 1].neume.hasRedDotBefore;
            if (redDotFollows) {
                redDotOffset = textExtensionRight;
                textExtensionRight += bulletWidth;
            }
            const spaceAvailableForNeume = extensions[layoutNeumeIndex].textExtensionRight + extensions[layoutNeumeIndex + 1].textExtensionLeft;
            const needsHyphen = layoutNeume.neumeExtensionRight > spaceAvailableForNeume && layoutNeume.neume.text.trim().length > 0 && !extensions[layoutNeumeIndex + 1].isEmpty && !endsWithSpace && !endsWithHyphen;
            if (needsHyphen && !redDotFollows) {
                text += "-";
                textExtensionRight += measureText("-", layoutNeume.neume.isBold ? "normal bold" : "normal");
            }
        }
        if (endsWithSpace) textExtensionRight += 4;
        return {
            ...layoutNeume,
            neume: {
                ...layoutNeume.neume,
                text: text
            },
            neumeExtensionRight: neumeExtensionRight,
            textExtensionLeft: extensions[layoutNeumeIndex].textExtensionLeft,
            textExtensionRight: textExtensionRight,
            redDotOffset: redDotOffset
        };
    });
    return layoutNeumes;
};


const $70c95f146be4c1d3$var$isInclinatum = (char)=>{
    return "ABCDEFGHIJKLM".indexOf(char) !== -1;
};
const $70c95f146be4c1d3$var$getPitchFromChar = (char)=>{
    return "abcdefghijklm".indexOf(char.toLowerCase()) - 2;
};
const $70c95f146be4c1d3$export$57f278225405371b = (gabc, dropCap)=>{
    const rawChantElements = [
        {
            text: "",
            chant: ""
        }
    ];
    gabc = gabc.replaceAll("<sc>", "").replaceAll("</sc>", "");
    let dropCapText = "";
    let mode = "before chant";
    let hasRedDotBefore = false;
    for(let i = 4; i < gabc.length; i++){
        const char = gabc[i];
        const lastElement = rawChantElements[rawChantElements.length - 1];
        if (mode === "before chant") {
            if (char === "(") mode = "in chant";
            else if (char === " ") rawChantElements.push({
                text: "",
                chant: ""
            });
            else if (dropCap && dropCapText.length === 0) dropCapText = char;
            else lastElement.text += char;
        } else if (mode === "in chant") {
            if (char === ")") mode = "after chant";
            else if (char === "o" || char === "@") ;
            else lastElement.chant += char;
        } else if (mode === "after chant") {
            if (char === "(") mode = "in chant";
            else if (char === " ") {
                lastElement.text += " ";
                rawChantElements.push({
                    text: "",
                    chant: ""
                });
            } else if (char === "\xa3") hasRedDotBefore = true;
            else {
                rawChantElements.push({
                    text: char,
                    chant: "",
                    hasRedDotBefore: hasRedDotBefore
                });
                hasRedDotBefore = false;
                mode = "before chant";
            }
        }
    }
    const nonEmptyRawChantElements = rawChantElements.filter((element)=>element.text.length > 0 || element.chant.length > 0);
    const neumes = [];
    let flatPitch = undefined;
    let showFlat = false;
    nonEmptyRawChantElements.forEach((rawElement)=>{
        let neumeElements = [];
        let requirePunctum = true;
        for(let i = 0; i < rawElement.chant.length; i++){
            const chantChar = rawElement.chant[i];
            if (chantChar === "/") {
                requirePunctum = true;
                continue;
            }
            if (chantChar === "!") {
                requirePunctum = true;
                const lastElement = neumeElements[neumeElements.length - 1];
                lastElement.suppressSpace = true;
                continue;
            }
            if (chantChar === ".") continue; // Turned off
            if (chantChar === "'") {
                const lastElement = neumeElements[neumeElements.length - 1];
                if (lastElement) {
                    const lastNote = lastElement.notes[lastElement.notes.length - 1];
                    if (lastNote) lastNote.hasVerticalEpisemaBelow = true;
                }
                continue;
            }
            if (chantChar === "w") {
                const lastElement = neumeElements[neumeElements.length - 1];
                if (lastElement) {
                    const lastNote = lastElement.notes[lastElement.notes.length - 1];
                    if (lastNote) lastNote.isQuilisma = true;
                }
                continue;
            }
            if (chantChar === "v") {
                const lastElement = neumeElements[neumeElements.length - 1];
                if (lastElement) {
                    const lastNote = lastElement.notes[lastElement.notes.length - 1];
                    if (lastNote) lastNote.isVirga = true;
                }
                continue;
            }
            if (chantChar === "~") {
                const lastElement = neumeElements[neumeElements.length - 1];
                if (lastElement) {
                    const lastNote = lastElement.notes[lastElement.notes.length - 1];
                    if (lastNote) lastNote.isLiquescent = true;
                }
                continue;
            }
            if (chantChar === " ") {
                const lastElement = neumeElements[neumeElements.length - 1];
                if (lastElement) {
                    const lastNote = lastElement.notes[lastElement.notes.length - 1];
                    if (lastNote) lastNote.addSpace = true;
                }
                continue;
            }
            if (chantChar === "_") continue; // Turned off
            if (chantChar === ",") {
                neumeElements.push({
                    type: "quarter bar",
                    notes: []
                });
                continue;
            }
            if (chantChar === ";") {
                neumeElements.push({
                    type: "half bar",
                    notes: []
                });
                continue;
            }
            if (chantChar === ":") {
                neumeElements.push({
                    type: "full bar",
                    notes: []
                });
                continue;
            }
            const pitch = $70c95f146be4c1d3$var$getPitchFromChar(chantChar);
            if (rawElement.chant[i + 1] === "x") {
                i += 1;
                flatPitch = pitch;
                showFlat = true;
                continue;
            }
            if (rawElement.chant[i + 1] === "y") {
                i += 1;
                flatPitch = undefined;
                continue;
            }
            if ($70c95f146be4c1d3$var$isInclinatum(chantChar)) {
                const lastElement = neumeElements[neumeElements.length - 1];
                if (lastElement) {
                    if (lastElement.type === "podatus") {
                        lastElement.type = "pes subpunctis";
                        lastElement.notes.push({
                            pitch: pitch,
                            isInclinatum: true
                        });
                    } else if (lastElement.type === "pes subpunctis" && pitch < lastElement.notes[lastElement.notes.length - 1].pitch) lastElement.notes.push({
                        pitch: pitch,
                        isInclinatum: true
                    });
                    else if (lastElement.type === "punctum" && pitch < lastElement.notes[lastElement.notes.length - 1].pitch) {
                        lastElement.type = "climacus";
                        lastElement.notes.push({
                            pitch: pitch,
                            isInclinatum: true
                        });
                    } else if (lastElement.type === "climacus" && pitch < lastElement.notes[lastElement.notes.length - 1].pitch) lastElement.notes.push({
                        pitch: pitch,
                        isInclinatum: true
                    });
                    else neumeElements.push({
                        type: "punctum",
                        notes: [
                            {
                                pitch: pitch,
                                isInclinatum: true
                            }
                        ]
                    });
                }
                requirePunctum = true;
            } else if (requirePunctum) {
                neumeElements.push({
                    type: "punctum",
                    notes: [
                        {
                            pitch: pitch
                        }
                    ]
                });
                requirePunctum = false;
            } else {
                const lastElement = neumeElements[neumeElements.length - 1];
                if (lastElement.type === "punctum" && pitch > lastElement.notes[0].pitch) {
                    lastElement.type = "podatus";
                    lastElement.notes.push({
                        pitch: pitch
                    });
                } else if (lastElement.type === "punctum" && pitch < lastElement.notes[0].pitch && !lastElement.notes[0].isVirga) {
                    lastElement.type = "clivis";
                    lastElement.notes.push({
                        pitch: pitch
                    });
                } else if (lastElement.type === "podatus" && pitch > lastElement.notes[1].pitch) {
                    lastElement.type = "scandicus";
                    lastElement.notes.push({
                        pitch: pitch
                    });
                } else if (lastElement.type === "podatus" && pitch < lastElement.notes[1].pitch) {
                    lastElement.type = "torculus";
                    lastElement.notes.push({
                        pitch: pitch
                    });
                } else if (lastElement.type === "clivis" && pitch > lastElement.notes[1].pitch && !lastElement.notes[0].hasHorizontalEpisema && !lastElement.notes[1].hasHorizontalEpisema) {
                    lastElement.type = "porrectus";
                    lastElement.notes.push({
                        pitch: pitch
                    });
                } else {
                    neumeElements.push({
                        type: "punctum",
                        notes: [
                            {
                                pitch: pitch
                            }
                        ]
                    });
                    requirePunctum = false;
                }
            }
            if (pitch === flatPitch) {
                const lastElement = neumeElements[neumeElements.length - 1];
                if (lastElement) {
                    const lastNote = lastElement.notes[lastElement.notes.length - 1];
                    lastNote.isNoteFlat = true;
                }
            }
        }
        let trailingSpaces = "";
        while(rawElement.text[rawElement.text.length - trailingSpaces.length - 1] === " ")trailingSpaces += " ";
        const isBold = rawElement.text[0] === "*" && rawElement.text[rawElement.text.length - trailingSpaces.length - 1] === "*";
        let text = rawElement.text;
        const textToRender = isBold ? text.slice(1, rawElement.text.length - trailingSpaces.length - 1) + trailingSpaces : text;
        neumes.push({
            elements: neumeElements.map((el)=>{
                return {
                    ...el,
                    q: el.notes.map((n)=>n.pitch).join(" ")
                };
            }),
            text: textToRender,
            isBold: isBold,
            flatPitch: flatPitch,
            showFlat: showFlat,
            hasRedDotBefore: rawElement.hasRedDotBefore
        });
        showFlat = false;
        if (trailingSpaces.length > 0) flatPitch = undefined;
    });
    return {
        neumes: neumes,
        dropCapText: dropCapText
    };
};



const $04cfb5a990424bdb$var$WINDOW = window;
if (!$04cfb5a990424bdb$var$WINDOW.measureCanvas) $04cfb5a990424bdb$var$WINDOW.measureCanvas = document.createElement("canvas");
const $04cfb5a990424bdb$var$canvasContext = $04cfb5a990424bdb$var$WINDOW.measureCanvas.getContext("2d");
const $04cfb5a990424bdb$var$DROP_CAP_FONT_SIZE = 64;
const $04cfb5a990424bdb$var$BODY_FONT = "EB Garamond";
const $04cfb5a990424bdb$var$STAVE_LINE_SPACING = 11;
const $04cfb5a990424bdb$var$TEXT_OFFSET = 55;
const $04cfb5a990424bdb$var$DROP_CAP_OFFSET = 55;
const $04cfb5a990424bdb$var$DOCUMENT = document;
const $04cfb5a990424bdb$export$97879dd1a1210ded = (pitch)=>{
    return (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64) * 3.5 - $04cfb5a990424bdb$var$STAVE_LINE_SPACING / 2 * pitch;
};
const $04cfb5a990424bdb$export$a512b99ae1e55604 = (props)=>{
    const { gabc: unfilteredGabc, dropCap: dropCap, tone: tone, onClickNeume: onClickNeume, highlightedNote: highlightedNote } = props;
    const [mistakeNeume, setMistakeNeume] = (0, $acw62.useState)(-1);
    const [mistakeClicks, setMistakeClicks] = (0, $acw62.useState)(0);
    const filteredGabc = unfilteredGabc.replace(/\<sc\>/g, "").replace(/\<\/sc\>/g, "").replace(/%/g, "");
    const gabc = dropCap ? (0, $f946c5f928169e9d$export$4e75a5f268c5373c)(filteredGabc) : filteredGabc;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    const bodyFontSize = isSmallScreen ? (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57) * 0.9 : (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57);
    const measureText = (0, $acw62.useCallback)((text, style)=>{
        if (style === "normal") $04cfb5a990424bdb$var$canvasContext.font = `${bodyFontSize}px ${$04cfb5a990424bdb$var$BODY_FONT}`;
        else if (style === "drop cap") $04cfb5a990424bdb$var$canvasContext.font = `700 ${$04cfb5a990424bdb$var$DROP_CAP_FONT_SIZE}px ${$04cfb5a990424bdb$var$BODY_FONT}`;
        else if (style === "normal bold") $04cfb5a990424bdb$var$canvasContext.font = `700 ${bodyFontSize}px ${$04cfb5a990424bdb$var$BODY_FONT}`;
        let measurements = $04cfb5a990424bdb$var$canvasContext.measureText(text.replace(/-/g, "n"));
        return measurements.width;
    }, []);
    const toneLabel = (0, $c07cc9090462c085$export$df12744c9c7cdebd)[tone ?? ""]?.liber ?? (tone ?? "")?.replace("1", "I").replace("2", "II").replace("3", "III").replace("4", "IV").replace("5", "V").replace("6", "VI").replace("7", "VII").replace("8", "VIII").replace("n", "");
    // const gabc = "(c4) CHris(ffg)tus(f.) *(,) fac(fg)tus(f) est(f') pro(f) no(ghF'ED.g_e/fg)bis(f.) (;) o(f)bé(hf/gh!jj/kjk)di(jij)ens(h_g) (,) us(h!jjh)que(f.) ad(ixfiH'Gh) mor(fgf___)tem,(f.) (:) mor(ixf!hhi)tem(g) au(ixgjj//)tem(j.h!iw!jvIG'hw!ivHG) cru(fv.ff)cis.(f_c) (,) (fg!hvGF.e!g'h//fhg/hgg.f.) V/.(::)  Prop(d)ter(d) quod(d) et(fe~) De(eh)us(h.) (,) e(h)xal(h)tá(h)vit(h) il(h)lum,(ihhe.//hih___/ihhe.) (,) (hi!kv//lvKI'jvHF.) (,) (h_g/ijh'___ jvIH'jvIH'//hvGF.) (:) et(f) de(f!h'i)dit(i) il(i)li(ih/jki/hhf.) (,) no(hf/hhh)men,(h.f!gwh!iv.hi/jhh/iih.) (;) quod(d) est(d) su(d)per(d) o(dfE'D)mne(ef) *() no(fhG'Fhhh)men.(hhf.) (,) (gxg_fgvED.fgED.fe/hv.hhhff//dfe/feed.) (::) X(gh~/hg~/dh~/hd~) Y(ghgi) Z(hghf) A(ghi) B(hgj) C(igh) D(jgh)";
    const clef = gabc.slice(1, 3);
    const containerRef = (0, $acw62.useRef)(null);
    const [measureRef, measure] = (0, $186cacd6c17eb54c$export$2e2bcd8739ae039)();
    const { neumes: neumes, dropCapText: dropCapText } = (0, $acw62.useMemo)(()=>{
        return (0, $70c95f146be4c1d3$export$57f278225405371b)(gabc, dropCap);
    }, [
        gabc,
        dropCap
    ]);
    const { settings: settings } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const [tuningPitch, setTuningPitch] = (0, $acw62.useState)(undefined);
    const isOnScreen = $04cfb5a990424bdb$var$useOnScreen(containerRef);
    const [hasEverBeenOnScreen, setHasEverBeenOnScreen] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (isOnScreen && !hasEverBeenOnScreen) setHasEverBeenOnScreen(true);
    }, [
        isOnScreen,
        hasEverBeenOnScreen
    ]);
    const getTuningNote = (0, $acw62.useCallback)(()=>{
        if (settings.tuning === "enabled" && tone && isOnScreen) {
            const transposeByKey = tone[0];
            const clef = gabc.slice(1, 3);
            const tuningEvent = $04cfb5a990424bdb$var$WINDOW.tuningEvent;
            if (tuningEvent && tuningEvent.note) {
                const transposeBy = settings.transpositions["1"] + (0, $02b52bdf6f82c33e$export$c6bb8e99f71a0bee)((0, $c07cc9090462c085$export$df12744c9c7cdebd)[tone ?? ""]);
                const clefOffset = clef === "c2" ? 3 : clef === "c4" ? 7 : 5;
                const offset = clef === "c3" || clef === "c4" || clef === "c2" ? 9 - clefOffset : 5 - clefOffset;
                const detectedNote = (0, $02b52bdf6f82c33e$export$4ae37d1471dcafc7)[tuningEvent.note];
                const transposedNote = (0, $02b52bdf6f82c33e$export$94966884eea635c4)(`${detectedNote}${tuningEvent.octave}`, -transposeBy);
                const isFlat = transposedNote[1] === "b";
                const transposedNoteWithoutFlat = transposedNote.replace("b", "");
                const noteValue = (0, $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d).findIndex((n)=>n === transposedNoteWithoutFlat) - offset - (isFlat ? 0.5 : 0);
                setTuningPitch(noteValue);
            }
        } else setTuningPitch(undefined);
    }, [
        settings
    ]);
    (0, $8c321ba562d39156$export$2e2bcd8739ae039)(getTuningNote, 25);
    const layoutNeumes = (0, $462dc9aff22a0c60$export$cac4fba5c7f7e881)(neumes, isSmallScreen, measureText, highlightedNote);
    const svgRows = [];
    let currentSvgRow = [];
    const pushRow = ()=>{
        const isDropCapRow = dropCap && svgRows.length === 0;
        const staveLineStart = isDropCapRow ? dropCapWidth + 4 : 0;
        svgRows.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            width: measure.width,
            height: dropCapText === "Q" && svgRows.length === 0 ? 90 : dropCapText === "J" && svgRows.length === 0 ? 84 : 78,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                transform: "translate(0, 16)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "punctum-quadratum",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M3 1C3.98202 1 4.6106 1.1275 4.985 1.3615C5.30525 1.56165 5.5 1.87871 5.5 2.5V6.54149C4.87081 6.22134 4.03265 6.00001 3 6.00001C1.96735 6.00001 1.12919 6.22134 0.5 6.54149V2.5C0.5 1.87871 0.694752 1.56165 1.015 1.3615C1.3894 1.1275 2.01798 1 3 1Z",
                                    fill: "black",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "podatus-upper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M2.5 0.5C3.48202 0.5 4.1106 0.627497 4.485 0.861499C4.80525 1.06165 5 1.37871 5 2V6.5H4.99151C4.98747 6.42532 4.9815 6.35214 4.9727 6.28173C4.94402 6.05226 4.87997 5.79829 4.7125 5.575C4.3662 5.11327 3.75425 5 3 5C1.96735 5 1.12919 5.22133 0.5 5.54148V2C0.5 1.27668 0.627668 0.981964 0.820092 0.821611C1.04519 0.634033 1.50249 0.5 2.5 0.5Z",
                                    fill: "black",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "podatus-lower",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M5.38032 0.5H5.50025V0.640625L5.50025 2.125L5.50025 5C5.50025 5.2368 5.49964 5.38557 5.49081 5.49056C5.38582 5.49939 5.23705 5.5 5.00025 5.5H4.99437H4.98848H4.98256H4.97663H4.97066H4.96468H4.95867H4.95265H4.94659H4.94052H4.93443H4.92831H4.92217H4.91601H4.90983H4.90363H4.8974H4.89116H4.88489H4.8786H4.87229H4.86596H4.85961H4.85323H4.84684H4.84043H4.83399H4.82754H4.82106H4.81457H4.80805H4.80151H4.79496H4.78838H4.78179H4.77517H4.76854H4.76188H4.75521H4.74851H4.7418H4.73507H4.72832H4.72155H4.71476H4.70795H4.70112H4.69428H4.68741H4.68053H4.67363H4.66671H4.65977H4.65281H4.64584H4.63885H4.63184H4.62481H4.61777H4.6107H4.60362H4.59652H4.58941H4.58228H4.57513H4.56796H4.56078H4.55358H4.54636H4.53912H4.53187H4.52461H4.51732H4.51002H4.50271H4.49537H4.48802H4.48066H4.47328H4.46588H4.45847H4.45104H4.4436H4.43614H4.42867H4.42118H4.41367H4.40615H4.39862H4.39107H4.3835H4.37592H4.36833H4.36072H4.3531H4.34546H4.33781H4.33014H4.32246H4.31477H4.30706H4.29934H4.2916H4.28385H4.27609H4.26831H4.26052H4.25272H4.2449H4.23707H4.22923H4.22138H4.21351H4.20563H4.19773H4.18982H4.18191H4.17397H4.16603H4.15807H4.15011H4.14213H4.13413H4.12613H4.11811H4.11009H4.10205H4.09399H4.08593H4.07786H4.06977H4.06168H4.05357H4.04545H4.03732H4.02918H4.02103H4.01287H4.0047H3.99652H3.98832H3.98012H3.97191H3.96368H3.95545H3.94721H3.93896H3.93069H3.92242H3.91414H3.90585H3.89755H3.88924H3.88092H3.87259H3.86425H3.8559H3.84755H3.83918H3.83081H3.82243H3.81404H3.80564H3.79724H3.78882H3.7804H3.77197H3.76353H3.75508H3.74663H3.73816H3.72969H3.72122H3.71273H3.70424H3.69574H3.68723H3.67872H3.6702H3.66167H3.65314H3.6446H3.63605H3.6275H3.61893H3.61037H3.60179H3.59322H3.58463H3.57604H3.56744H3.55884H3.55023H3.54162H3.533H3.52437H3.51574H3.5071H3.49846H3.48982H3.48116H3.47251H3.46385H3.45518H3.44651H3.43784H3.42916H3.42047H3.41178H3.40309H3.39439H3.38569H3.37699H3.36828H3.35957H3.35085H3.34213H3.33341H3.32469H3.31596H3.30722H3.29849H3.28975H3.28101H3.27226H3.26351H3.25476H3.24601H3.23726H3.2285H3.21974H3.21098H3.20221H3.19345H3.18468H3.17591H3.16713H3.15836H3.14959H3.14081H3.13203H3.12325H3.11447H3.10569H3.0969H3.08812H3.07934H3.07055H3.06176H3.05298H3.04419H3.0354H3.02661H3.01782H3.00903H3.00024H2.99146H2.98267H2.97388H2.96509H2.9563H2.94751H2.93873H2.92994H2.92115H2.91237H2.90358H2.8948H2.88602H2.87724H2.86846H2.85968H2.8509H2.84213H2.83335H2.82458H2.81581H2.80704H2.79828H2.78951H2.78075H2.77199H2.76323H2.75448H2.74573H2.73698H2.72823H2.71948H2.71074H2.702H2.69327H2.68453H2.6758H2.66708H2.65836H2.64964H2.64092H2.63221H2.6235H2.6148H2.60609H2.5974H2.58871H2.58002H2.57133H2.56265H2.55398H2.54531H2.53664H2.52798H2.51933H2.51067H2.50203H2.49339H2.48475H2.47612H2.46749H2.45887H2.45026H2.44165H2.43305H2.42445H2.41586H2.40727H2.39869H2.39012H2.38155H2.37299H2.36444H2.35589H2.34735H2.33882H2.33029H2.32177H2.31326H2.30475H2.29625H2.28776H2.27927H2.2708H2.26233H2.25386H2.24541H2.23696H2.22852H2.22009H2.21167H2.20325H2.19485H2.18645H2.17806H2.16968H2.16131H2.15294H2.14459H2.13624H2.1279H2.11957H2.11125H2.10294H2.09464H2.08635H2.07807H2.0698H2.06153H2.05328H2.04504H2.0368H2.02858H2.02037H2.01217H2.00397H1.99579H1.98762H1.97946H1.97131H1.96317H1.95504H1.94692H1.93881H1.93072H1.92263H1.91456H1.90649H1.89844H1.8904H1.88238H1.87436H1.86636H1.85836H1.85038H1.84242H1.83446H1.82652H1.81858H1.81066H1.80276H1.79486H1.78698H1.77911H1.77126H1.76342H1.75559H1.74777H1.73997H1.73218H1.7244H1.71664H1.70889H1.70115H1.69343H1.68572H1.67803H1.67035H1.66268H1.65503H1.64739H1.63977H1.63216H1.62457H1.61699H1.60942H1.60187H1.59434H1.58682H1.57931H1.57182H1.56435H1.55689H1.54945H1.54202H1.53461H1.52721H1.51983H1.51247H1.50512H1.49778H1.49047H1.48317H1.47588H1.46862H1.46137H1.45413H1.44691H1.43971H1.43253H1.42536H1.41821H1.41108H1.40397H1.39687H1.38979H1.38272H1.37568H1.36865H1.36164H1.35465H1.34768H1.34072H1.33378H1.32686H1.31996H1.31308H1.30621H1.29937H1.29254H1.28573H1.27894H1.27217H1.26542H1.25869H1.25198H1.24528H1.23861H1.23195H1.22532H1.2187H1.21211H1.20553H1.19898H1.19244H1.18592H1.17943H1.17295H1.1665H1.16006H1.15365H1.14726H1.14088H1.13453H1.1282H1.12189H1.1156H1.10933H1.10309H1.09686H1.09066H1.08448H1.07832H1.07218H1.06606H1.05997H1.0539H1.04784H1.04182H1.03581H1.02983H1.02386H1.01793H1.01201H1.00612H1.00024C0.763439 5.5 0.614674 5.49939 0.509678 5.49057C0.500851 5.38557 0.500244 5.2368 0.500244 5V4.99413V4.98823V4.98232V4.97638V4.97042V4.96443V4.95843V4.9524V4.94635V4.94028V4.93419V4.92807V4.92193V4.91578V4.9096V4.9034V4.89717V4.89093V4.88467V4.87838V4.87208V4.86575V4.85941V4.85304V4.84665V4.84025V4.83382V4.82737V4.82091V4.81442V4.80791V4.80139V4.79485V4.78828V4.7817V4.7751V4.76848V4.76184V4.75518V4.7485V4.74181V4.7351V4.72837V4.72162V4.71485V4.70806V4.70126V4.69444V4.6876V4.68075V4.67387V4.66699V4.66008V4.65315V4.64621V4.63926V4.63228V4.62529V4.61828V4.61126V4.60422V4.59717V4.59009V4.58301V4.5759V4.56878V4.56165V4.5545V4.54734V4.54015V4.53296V4.52575V4.51852V4.51128V4.50403V4.49676V4.48948V4.48218V4.47487V4.46754V4.4602V4.45285V4.44548V4.4381V4.43071V4.4233V4.41588V4.40844V4.401V4.39354V4.38606V4.37858V4.37108V4.36357V4.35604V4.34851V4.34096V4.3334V4.32583V4.31825V4.31065V4.30304V4.29543V4.2878V4.28016V4.2725V4.26484V4.25717V4.24948V4.24179V4.23408V4.22636V4.21864V4.2109V4.20315V4.19539V4.18763V4.17985V4.17206V4.16426V4.15646V4.14864V4.14082V4.13299V4.12514V4.11729V4.10943V4.10156V4.09368V4.0858V4.0779V4.07V4.06209V4.05417V4.04624V4.03831V4.03036V4.02241V4.01446V4.00649V3.99852V3.99054V3.98255V3.97456V3.96656V3.95856V3.95054V3.94252V3.9345V3.92646V3.91843V3.91038V3.90233V3.89428V3.88621V3.87815V3.87007V3.862V3.85391V3.84582V3.83773V3.82963V3.82153V3.81342V3.80531V3.79719V3.78907V3.78095V3.77282V3.76468V3.75654V3.7484V3.74026V3.73211V3.72396V3.7158V3.70764V3.69948V3.69132V3.68315V3.67498V3.66681V3.65863V3.65046V3.64228V3.63409V3.62591V3.61772V3.60953V3.60134V3.59315V3.58496V3.57676V3.56857V3.56037V3.55217V3.54397V3.53577V3.52757V3.51937V3.51117V3.50297V3.49476V3.48656V3.47836V3.47015V3.46195V3.45375V3.44555V3.43734V3.42914V3.42094V3.41274V3.40454V3.39635V3.38815V3.37995V3.37176V3.36357V3.35538V3.34719V3.339V3.33081V3.32263V3.31445V3.30627V3.29809V3.28992V3.28175V3.27358V3.26541V3.25725V3.24909V3.24093V3.23278V3.22463V3.21648V3.20834V3.2002V3.19206V3.18393V3.1758V3.16768V3.15956V3.15144V3.14333V3.13523V3.12713V3.11903V3.11094V3.10285V3.09477V3.08669V3.07862V3.07056V3.0625V3.05445V3.0464V3.03836V3.03032V3.02229V3.01427V3.00625V2.99824V2.99023V2.98224V2.97425V2.96626V2.95829V2.95032V2.94236V2.9344V2.92645V2.91851V2.91058V2.90266V2.89474V2.88684V2.87894V2.87104V2.86316V2.85529V2.84742V2.83957V2.83172V2.82388V2.81605V2.80823V2.80041V2.79261V2.78482V2.77704V2.76926V2.7615V2.75375V2.746V2.73827V2.73055V2.72283V2.71513V2.70744V2.69976V2.69209V2.68443V2.67678V2.66915V2.66152V2.65391V2.64631V2.63872V2.63114V2.62357V2.61602V2.60847V2.60094V2.59342V2.58592V2.57842V2.57094V2.56348V2.55602V2.54858V2.54115V2.53373V2.52633V2.51894V2.51157V2.5042V2.49686V2.48952V2.4822V2.4749V2.4676V2.46033V2.45306V2.44582V2.43858V2.43136V2.42416V2.41697V2.40979V2.40264V2.39549V2.38836V2.38125V2.37415V2.36707V2.36001V2.35296V2.34593V2.33891V2.33191V2.32492V2.31796V2.31101V2.30407V2.29715V2.29025V2.28337V2.27651V2.26966V2.26283V2.25601V2.24922V2.24244V2.23568V2.22894V2.22221V2.21551V2.20882V2.20215V2.1955V2.18887V2.18226V2.17566V2.16909V2.16253V2.156V2.14948V2.14298V2.1365V2.13004V2.12361V2.11719V2.11079V2.10441V2.09805V2.09171V2.0854V2.0791V2.07282V2.06657V2.06033V2.05412V2.04793V2.04176V2.03561V2.02948V2.02337V2.01729V2.01122V2.00518V1.99916V1.99317V1.98719V1.98124V1.97531V1.9694V1.96352V1.95766V1.95182V1.946V1.94021V1.93444V1.9287V1.92297V1.91727V1.9116V1.90595V1.90032V1.89472V1.88914V1.88358V1.87805V1.87255V1.86707V1.86161V1.85618V1.85077V1.84539V1.84003V1.8347V1.8294V1.82412V1.81886V1.81363V1.80843V1.80325V1.7981V1.79297V1.78788V1.7828V1.77776V1.77274V1.76775V1.76278V1.75784V1.75293V1.74805V1.74319V1.73836V1.73356V1.72878V1.72403V1.71932V1.71462V1.70996V1.70533V1.70072V1.69614V1.69159V1.68707V1.68258V1.67812V1.67368V1.66928V1.6649V1.66055V1.65624V1.65195V1.64769V1.64346V1.63926V1.63509V1.63096V1.62685V1.62277V1.61872V1.6147V1.61072V1.60676V1.60284V1.59894V1.59508V1.59125V1.58745V1.58368V1.57994V1.57624V1.57256V1.56892V1.56531V1.56173V1.55819V1.55467V1.55119V1.54774V1.54433V1.54095V1.5376V1.53428V1.53099V1.52774V1.52453V1.52134V1.51819V1.51508V1.51199V1.50894V1.50593V1.50295V1.5C0.500244 1.35551 0.542504 1.29595 0.559582 1.27714C0.579937 1.25473 0.599893 1.25004 0.609294 1.24973C0.768646 1.24453 1.03718 1.24546 1.52935 1.24715C1.88695 1.24838 2.36262 1.25001 3.00025 1.25C3.7581 1.24998 4.34097 1.18969 4.74845 1.02669C4.96082 0.941734 5.1572 0.816705 5.29867 0.628096C5.32992 0.586436 5.35702 0.543635 5.38032 0.5Z",
                                    fill: "black",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "porrectus-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M18 12.5C14.3216 12.5 10.3436 11.2814 8 10.5C4.61444 9.36039 2.40875 8.11637 0 6V0C1.79037 1.75817 3.83325 2.81862 8 5C9.92044 6.00946 13.44 7 16.5 7C17.8346 7 18.6744 6.23725 19 5V11.5C19 11.9557 18.7812 12.5 18 12.5Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "porrectus-2",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M18 17.5C14.3216 17.5 10 15 8 13.5C5.33333 11.5 2 8.5 0 6V0C2 2.5 5 5.5 8 8C9.66672 9.38893 14 12 16.5 12C17.8346 12 18.6744 11.2373 19 10V16.5C19 16.9557 18.7812 17.5 18 17.5Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "porrectus-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M18 23.5C14.3216 23.5 10 19.5 7 16C4.8307 13.4691 2 9.5 0 6V0C2 3.5 5.5 8.5 9 12.5C11.1082 14.9094 14 18 16.5 18C17.8346 18 18.6744 17.2373 19 16V22.5C19 22.9557 18.7812 23.5 18 23.5Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "punctum-inclinatum",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M3 7.0566L1.08962 4.00001L3 0.943399L4.91038 4.00001L3 7.0566Z",
                                    fill: "black",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "custos",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M2.5 0.006505C2.85812 -0.0259952 3.00001 0.00647604 3.00001 1.50647V18.5063C2.00001 18.5063 2.5 18.5062 2 18.5063C0 18.5065 0 16.5065 0 14.5065V11.5063C0.358124 11.8318 0.741699 12.5063 1.5 12.5063C2 12.5063 1.54438 12.5063 2.00001 12.5063L2 2.50626C2.00001 1.50648 2 0.506504 2.5 0.006505Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "beginning-ascending-liquescent",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M0 6V1.00002C0.260437 1.45577 0.972895 2.00011 3 2.00011C5.5 2.00011 6 0.000108242 6 0.000108242V6C6 7 4.97656 7.20713 4 7.5C3.65964 7.60208 2 7.66667 1.5 7.5C0.666107 7.22204 0 6.84644 0 6Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "terminating-ascending-liquescent",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M2.5 5C2.5 4.25125 2.1185 4 1.5 4C0.8165 4 0.390625 4.04425 0 4.5V1.80656C0 1.38344 0.16275 1.00906 0.488312 0.683563C0.813812 0.357938 1.15562 0.146437 1.51369 0.0487499C1.67637 0.0162499 1.83912 0 2.00181 0C2.22975 0 2.44131 0.0487499 2.63663 0.146437C2.96225 0.309187 3 0.641875 3 1V7H2.539L2.5 5Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "terminating-descending-liquescent",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M2.5 2C2.5 2.74875 2.1185 3 1.5 3C0.8165 3 0.390625 2.95575 3.93402e-07 2.5L1.57935e-07 5.19344C1.20944e-07 5.61656 0.16275 5.99094 0.488313 6.31644C0.813813 6.64206 1.15563 6.85356 1.51369 6.95125C1.67638 6.98375 1.83913 7 2.00181 7C2.22975 7 2.44131 6.95125 2.63663 6.85356C2.96225 6.69081 3 6.35813 3 6L3 2.62268e-07L2.539 2.21966e-07L2.5 2Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "mora",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: "1.5",
                                    cy: "1.5",
                                    r: "1.5",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "quilisma",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M0 6.62507V2.04171C0.3438 3.1528 0.7812 3.70837 1.3125 3.70837C1.78128 3.70837 2.0625 2.87504 2.15628 1.20837C2.37498 1.87504 2.57028 2.34032 2.74218 2.60421C2.91408 2.86811 3.15618 3.00005 3.46878 3.00005C3.78126 3.00005 4.03122 2.23611 4.21878 0.70832C4.56258 1.93056 4.8594 2.54165 5.10936 2.54165C5.45316 2.54165 5.74998 1.69445 6 0V5.33333C6 6.27771 5.8125 6.74987 5.4375 6.74987C5.15622 6.74987 4.8906 6.43051 4.6407 5.79157C4.5156 6.95824 4.15626 7.5416 3.5625 7.5416C3.09372 7.5416 2.59374 7.15269 2.0625 6.37493C1.78122 7.45824 1.42188 8 0.9843 8C0.67188 8 0.42966 7.86107 0.25782 7.58325C0.0859201 7.3056 0 6.98613 0 6.62507Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "c-clef",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M0 15.1014V3.85379C0 2.68873 0.3594 1.75522 1.0782 1.0531C1.79688 0.351033 2.73438 0 3.89064 0C4.54686 0 5.06244 0.179303 5.43744 0.537792C5.81244 0.896281 6 1.37425 6 1.97175V8.15572L5.625 7.84197C5.37498 7.6329 5.00778 7.41637 4.5234 7.19227C4.03908 6.96818 3.51564 6.85615 2.9532 6.85615C2.2656 6.85615 1.66404 7.11008 1.1484 7.61799C0.63282 8.12584 0.375 8.7382 0.375 9.45517C0.375 10.1722 0.63282 10.7921 1.1484 11.3149C1.66404 11.8377 2.2656 12.0991 2.9532 12.0991C3.51564 12.0991 4.03908 11.9946 4.5234 11.7855C5.00778 11.5763 5.37498 11.3672 5.625 11.1581L6 10.7996V17.0283C6 17.5959 5.8125 18.0665 5.4375 18.4399C5.0625 18.8133 4.54686 19 3.8907 19C2.73438 19 1.79688 18.6415 1.07814 17.9245C0.3594 17.2076 0 16.2666 0 15.1014V15.1014Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "f-clef",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M5.32231 8.40046V18.9063C5.32231 19.4683 5.19531 19.9688 5 20C4.90225 20 4.78525 19.6406 4.78525 19.3711C4.78525 19.1914 4.78513 18.9623 4.78525 18.8374V13.6931C4.26431 13.1936 3.54819 12.9437 2.63675 12.9437C1.52988 12.9437 0.651125 13.1779 0 13.6463V8.40046C0 7.30752 0.887062 6.7611 2.66112 6.7611C4.43519 6.7611 5.32231 7.30758 5.32231 8.40046ZM6.15244 15.8946V4.79393C6.15244 3.63864 6.51056 2.70181 7.22662 1.98363C7.94275 1.2654 8.88675 0.906281 10.0587 0.906281C10.7423 0.906281 11.2549 1.07805 11.5968 1.42152C11.9385 1.76505 12.1094 2.2334 12.1094 2.82663V9.00934L11.7676 8.72834C11.5398 8.50969 11.1817 8.2911 10.6934 8.07246C10.2051 7.85393 9.70056 7.74469 9.17969 7.74463C8.43106 7.74463 7.80444 7.99446 7.29987 8.49404C6.79531 8.99369 6.543 9.59478 6.543 10.2974C6.543 10.9999 6.79531 11.6166 7.29987 12.1475C7.80444 12.6783 8.43113 12.9436 9.17975 12.9436C9.70056 12.9436 10.2051 12.8344 10.6935 12.6158C11.1816 12.3973 11.5398 12.1943 11.7676 12.0069L12.1095 11.6791V17.8616C12.1095 18.4549 11.9304 18.9312 11.5724 19.2903C11.2143 19.6493 10.7098 19.8289 10.0586 19.8289C8.88675 19.8289 7.94281 19.462 7.22675 18.7281C6.5105 17.9943 6.15244 17.0499 6.15244 15.8946Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "flat",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M0.506063 0C0.76305 0 0.891604 0.272091 0.891604 0.816326L0.795188 10.1224C2.11245 11.3741 3.36549 11.9999 4.55425 11.9999C5.1325 11.9999 5.42169 11.7551 5.42169 11.2653C5.42169 10.9388 5.35741 10.653 5.22892 10.4082C5.10042 10.1632 4.79526 9.89794 4.31324 9.61222C3.83147 9.32644 3.51008 9.14285 3.34945 9.06119L1.71087 8.28582V6.4489C2.77107 6.4489 3.75103 6.70072 4.6506 7.20404C5.55018 7.70747 6 8.20401 6 8.69386C6 12.2313 5.98396 13.9999 5.95188 14C3.5743 14 1.66269 13.3605 0.216876 12.0816C0.024105 7.94561 -0.0401725 4.20414 0.024105 0.857129C0.024105 0.285727 0.184737 0 0.506063 0Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "punctum-quadratum-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M3 1C3.98202 1 4.6106 1.1275 4.985 1.3615C5.30525 1.56165 5.5 1.87871 5.5 2.5V6.54149C4.87081 6.22134 4.03265 6.00001 3 6.00001C1.96735 6.00001 1.12919 6.22134 0.5 6.54149V2.5C0.5 1.87871 0.694752 1.56165 1.015 1.3615C1.3894 1.1275 2.01798 1 3 1Z",
                                    fill: "white",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "podatus-upper-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M2.5 0.5C3.48202 0.5 4.1106 0.627497 4.485 0.861499C4.80525 1.06165 5 1.37871 5 2V6.5H4.99151C4.98747 6.42532 4.9815 6.35214 4.9727 6.28173C4.94402 6.05226 4.87997 5.79829 4.7125 5.575C4.3662 5.11327 3.75425 5 3 5C1.96735 5 1.12919 5.22133 0.5 5.54148V2C0.5 1.27668 0.627668 0.981964 0.820092 0.821611C1.04519 0.634033 1.50249 0.5 2.5 0.5Z",
                                    fill: "white",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "podatus-lower-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M5.38032 0.5H5.50025V0.640625L5.50025 2.125L5.50025 5C5.50025 5.2368 5.49964 5.38557 5.49081 5.49056C5.38582 5.49939 5.23705 5.5 5.00025 5.5H4.99437H4.98848H4.98256H4.97663H4.97066H4.96468H4.95867H4.95265H4.94659H4.94052H4.93443H4.92831H4.92217H4.91601H4.90983H4.90363H4.8974H4.89116H4.88489H4.8786H4.87229H4.86596H4.85961H4.85323H4.84684H4.84043H4.83399H4.82754H4.82106H4.81457H4.80805H4.80151H4.79496H4.78838H4.78179H4.77517H4.76854H4.76188H4.75521H4.74851H4.7418H4.73507H4.72832H4.72155H4.71476H4.70795H4.70112H4.69428H4.68741H4.68053H4.67363H4.66671H4.65977H4.65281H4.64584H4.63885H4.63184H4.62481H4.61777H4.6107H4.60362H4.59652H4.58941H4.58228H4.57513H4.56796H4.56078H4.55358H4.54636H4.53912H4.53187H4.52461H4.51732H4.51002H4.50271H4.49537H4.48802H4.48066H4.47328H4.46588H4.45847H4.45104H4.4436H4.43614H4.42867H4.42118H4.41367H4.40615H4.39862H4.39107H4.3835H4.37592H4.36833H4.36072H4.3531H4.34546H4.33781H4.33014H4.32246H4.31477H4.30706H4.29934H4.2916H4.28385H4.27609H4.26831H4.26052H4.25272H4.2449H4.23707H4.22923H4.22138H4.21351H4.20563H4.19773H4.18982H4.18191H4.17397H4.16603H4.15807H4.15011H4.14213H4.13413H4.12613H4.11811H4.11009H4.10205H4.09399H4.08593H4.07786H4.06977H4.06168H4.05357H4.04545H4.03732H4.02918H4.02103H4.01287H4.0047H3.99652H3.98832H3.98012H3.97191H3.96368H3.95545H3.94721H3.93896H3.93069H3.92242H3.91414H3.90585H3.89755H3.88924H3.88092H3.87259H3.86425H3.8559H3.84755H3.83918H3.83081H3.82243H3.81404H3.80564H3.79724H3.78882H3.7804H3.77197H3.76353H3.75508H3.74663H3.73816H3.72969H3.72122H3.71273H3.70424H3.69574H3.68723H3.67872H3.6702H3.66167H3.65314H3.6446H3.63605H3.6275H3.61893H3.61037H3.60179H3.59322H3.58463H3.57604H3.56744H3.55884H3.55023H3.54162H3.533H3.52437H3.51574H3.5071H3.49846H3.48982H3.48116H3.47251H3.46385H3.45518H3.44651H3.43784H3.42916H3.42047H3.41178H3.40309H3.39439H3.38569H3.37699H3.36828H3.35957H3.35085H3.34213H3.33341H3.32469H3.31596H3.30722H3.29849H3.28975H3.28101H3.27226H3.26351H3.25476H3.24601H3.23726H3.2285H3.21974H3.21098H3.20221H3.19345H3.18468H3.17591H3.16713H3.15836H3.14959H3.14081H3.13203H3.12325H3.11447H3.10569H3.0969H3.08812H3.07934H3.07055H3.06176H3.05298H3.04419H3.0354H3.02661H3.01782H3.00903H3.00024H2.99146H2.98267H2.97388H2.96509H2.9563H2.94751H2.93873H2.92994H2.92115H2.91237H2.90358H2.8948H2.88602H2.87724H2.86846H2.85968H2.8509H2.84213H2.83335H2.82458H2.81581H2.80704H2.79828H2.78951H2.78075H2.77199H2.76323H2.75448H2.74573H2.73698H2.72823H2.71948H2.71074H2.702H2.69327H2.68453H2.6758H2.66708H2.65836H2.64964H2.64092H2.63221H2.6235H2.6148H2.60609H2.5974H2.58871H2.58002H2.57133H2.56265H2.55398H2.54531H2.53664H2.52798H2.51933H2.51067H2.50203H2.49339H2.48475H2.47612H2.46749H2.45887H2.45026H2.44165H2.43305H2.42445H2.41586H2.40727H2.39869H2.39012H2.38155H2.37299H2.36444H2.35589H2.34735H2.33882H2.33029H2.32177H2.31326H2.30475H2.29625H2.28776H2.27927H2.2708H2.26233H2.25386H2.24541H2.23696H2.22852H2.22009H2.21167H2.20325H2.19485H2.18645H2.17806H2.16968H2.16131H2.15294H2.14459H2.13624H2.1279H2.11957H2.11125H2.10294H2.09464H2.08635H2.07807H2.0698H2.06153H2.05328H2.04504H2.0368H2.02858H2.02037H2.01217H2.00397H1.99579H1.98762H1.97946H1.97131H1.96317H1.95504H1.94692H1.93881H1.93072H1.92263H1.91456H1.90649H1.89844H1.8904H1.88238H1.87436H1.86636H1.85836H1.85038H1.84242H1.83446H1.82652H1.81858H1.81066H1.80276H1.79486H1.78698H1.77911H1.77126H1.76342H1.75559H1.74777H1.73997H1.73218H1.7244H1.71664H1.70889H1.70115H1.69343H1.68572H1.67803H1.67035H1.66268H1.65503H1.64739H1.63977H1.63216H1.62457H1.61699H1.60942H1.60187H1.59434H1.58682H1.57931H1.57182H1.56435H1.55689H1.54945H1.54202H1.53461H1.52721H1.51983H1.51247H1.50512H1.49778H1.49047H1.48317H1.47588H1.46862H1.46137H1.45413H1.44691H1.43971H1.43253H1.42536H1.41821H1.41108H1.40397H1.39687H1.38979H1.38272H1.37568H1.36865H1.36164H1.35465H1.34768H1.34072H1.33378H1.32686H1.31996H1.31308H1.30621H1.29937H1.29254H1.28573H1.27894H1.27217H1.26542H1.25869H1.25198H1.24528H1.23861H1.23195H1.22532H1.2187H1.21211H1.20553H1.19898H1.19244H1.18592H1.17943H1.17295H1.1665H1.16006H1.15365H1.14726H1.14088H1.13453H1.1282H1.12189H1.1156H1.10933H1.10309H1.09686H1.09066H1.08448H1.07832H1.07218H1.06606H1.05997H1.0539H1.04784H1.04182H1.03581H1.02983H1.02386H1.01793H1.01201H1.00612H1.00024C0.763439 5.5 0.614674 5.49939 0.509678 5.49057C0.500851 5.38557 0.500244 5.2368 0.500244 5V4.99413V4.98823V4.98232V4.97638V4.97042V4.96443V4.95843V4.9524V4.94635V4.94028V4.93419V4.92807V4.92193V4.91578V4.9096V4.9034V4.89717V4.89093V4.88467V4.87838V4.87208V4.86575V4.85941V4.85304V4.84665V4.84025V4.83382V4.82737V4.82091V4.81442V4.80791V4.80139V4.79485V4.78828V4.7817V4.7751V4.76848V4.76184V4.75518V4.7485V4.74181V4.7351V4.72837V4.72162V4.71485V4.70806V4.70126V4.69444V4.6876V4.68075V4.67387V4.66699V4.66008V4.65315V4.64621V4.63926V4.63228V4.62529V4.61828V4.61126V4.60422V4.59717V4.59009V4.58301V4.5759V4.56878V4.56165V4.5545V4.54734V4.54015V4.53296V4.52575V4.51852V4.51128V4.50403V4.49676V4.48948V4.48218V4.47487V4.46754V4.4602V4.45285V4.44548V4.4381V4.43071V4.4233V4.41588V4.40844V4.401V4.39354V4.38606V4.37858V4.37108V4.36357V4.35604V4.34851V4.34096V4.3334V4.32583V4.31825V4.31065V4.30304V4.29543V4.2878V4.28016V4.2725V4.26484V4.25717V4.24948V4.24179V4.23408V4.22636V4.21864V4.2109V4.20315V4.19539V4.18763V4.17985V4.17206V4.16426V4.15646V4.14864V4.14082V4.13299V4.12514V4.11729V4.10943V4.10156V4.09368V4.0858V4.0779V4.07V4.06209V4.05417V4.04624V4.03831V4.03036V4.02241V4.01446V4.00649V3.99852V3.99054V3.98255V3.97456V3.96656V3.95856V3.95054V3.94252V3.9345V3.92646V3.91843V3.91038V3.90233V3.89428V3.88621V3.87815V3.87007V3.862V3.85391V3.84582V3.83773V3.82963V3.82153V3.81342V3.80531V3.79719V3.78907V3.78095V3.77282V3.76468V3.75654V3.7484V3.74026V3.73211V3.72396V3.7158V3.70764V3.69948V3.69132V3.68315V3.67498V3.66681V3.65863V3.65046V3.64228V3.63409V3.62591V3.61772V3.60953V3.60134V3.59315V3.58496V3.57676V3.56857V3.56037V3.55217V3.54397V3.53577V3.52757V3.51937V3.51117V3.50297V3.49476V3.48656V3.47836V3.47015V3.46195V3.45375V3.44555V3.43734V3.42914V3.42094V3.41274V3.40454V3.39635V3.38815V3.37995V3.37176V3.36357V3.35538V3.34719V3.339V3.33081V3.32263V3.31445V3.30627V3.29809V3.28992V3.28175V3.27358V3.26541V3.25725V3.24909V3.24093V3.23278V3.22463V3.21648V3.20834V3.2002V3.19206V3.18393V3.1758V3.16768V3.15956V3.15144V3.14333V3.13523V3.12713V3.11903V3.11094V3.10285V3.09477V3.08669V3.07862V3.07056V3.0625V3.05445V3.0464V3.03836V3.03032V3.02229V3.01427V3.00625V2.99824V2.99023V2.98224V2.97425V2.96626V2.95829V2.95032V2.94236V2.9344V2.92645V2.91851V2.91058V2.90266V2.89474V2.88684V2.87894V2.87104V2.86316V2.85529V2.84742V2.83957V2.83172V2.82388V2.81605V2.80823V2.80041V2.79261V2.78482V2.77704V2.76926V2.7615V2.75375V2.746V2.73827V2.73055V2.72283V2.71513V2.70744V2.69976V2.69209V2.68443V2.67678V2.66915V2.66152V2.65391V2.64631V2.63872V2.63114V2.62357V2.61602V2.60847V2.60094V2.59342V2.58592V2.57842V2.57094V2.56348V2.55602V2.54858V2.54115V2.53373V2.52633V2.51894V2.51157V2.5042V2.49686V2.48952V2.4822V2.4749V2.4676V2.46033V2.45306V2.44582V2.43858V2.43136V2.42416V2.41697V2.40979V2.40264V2.39549V2.38836V2.38125V2.37415V2.36707V2.36001V2.35296V2.34593V2.33891V2.33191V2.32492V2.31796V2.31101V2.30407V2.29715V2.29025V2.28337V2.27651V2.26966V2.26283V2.25601V2.24922V2.24244V2.23568V2.22894V2.22221V2.21551V2.20882V2.20215V2.1955V2.18887V2.18226V2.17566V2.16909V2.16253V2.156V2.14948V2.14298V2.1365V2.13004V2.12361V2.11719V2.11079V2.10441V2.09805V2.09171V2.0854V2.0791V2.07282V2.06657V2.06033V2.05412V2.04793V2.04176V2.03561V2.02948V2.02337V2.01729V2.01122V2.00518V1.99916V1.99317V1.98719V1.98124V1.97531V1.9694V1.96352V1.95766V1.95182V1.946V1.94021V1.93444V1.9287V1.92297V1.91727V1.9116V1.90595V1.90032V1.89472V1.88914V1.88358V1.87805V1.87255V1.86707V1.86161V1.85618V1.85077V1.84539V1.84003V1.8347V1.8294V1.82412V1.81886V1.81363V1.80843V1.80325V1.7981V1.79297V1.78788V1.7828V1.77776V1.77274V1.76775V1.76278V1.75784V1.75293V1.74805V1.74319V1.73836V1.73356V1.72878V1.72403V1.71932V1.71462V1.70996V1.70533V1.70072V1.69614V1.69159V1.68707V1.68258V1.67812V1.67368V1.66928V1.6649V1.66055V1.65624V1.65195V1.64769V1.64346V1.63926V1.63509V1.63096V1.62685V1.62277V1.61872V1.6147V1.61072V1.60676V1.60284V1.59894V1.59508V1.59125V1.58745V1.58368V1.57994V1.57624V1.57256V1.56892V1.56531V1.56173V1.55819V1.55467V1.55119V1.54774V1.54433V1.54095V1.5376V1.53428V1.53099V1.52774V1.52453V1.52134V1.51819V1.51508V1.51199V1.50894V1.50593V1.50295V1.5C0.500244 1.35551 0.542504 1.29595 0.559582 1.27714C0.579937 1.25473 0.599893 1.25004 0.609294 1.24973C0.768646 1.24453 1.03718 1.24546 1.52935 1.24715C1.88695 1.24838 2.36262 1.25001 3.00025 1.25C3.7581 1.24998 4.34097 1.18969 4.74845 1.02669C4.96082 0.941734 5.1572 0.816705 5.29867 0.628096C5.32992 0.586436 5.35702 0.543635 5.38032 0.5Z",
                                    fill: "white",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                id: "porrectus-1-left-white",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M18 12.5C14.3216 12.5 10.3436 11.2814 8 10.5C4.61444 9.36039 2.40875 8.11637 0 6V0C1.79037 1.75817 3.83325 2.81862 8 5C9.92044 6.00946 13.44 7 16.5 7C17.8346 7 18.6744 6.23725 19 5V11.5C19 11.9557 18.7812 12.5 18 12.5Z",
                                        fill: "black"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        "fill-rule": "evenodd",
                                        "clip-rule": "evenodd",
                                        d: "M8.3177 9.55181C10.6601 10.3328 14.5003 11.5 18 11.5V7.7044C17.5455 7.90223 17.0399 8 16.5 8C13.2757 8 9.59731 6.96911 7.53553 5.88559C7.44677 5.83912 7.3589 5.79313 7.27191 5.7476C4.44358 4.2672 2.54142 3.27158 1 2.14893V5.54262C3.16827 7.38531 5.20704 8.50461 8.3177 9.55181ZM8 10.5C4.61444 9.36039 2.40875 8.11637 0 6V0C0.321573 0.315789 0.651292 0.609069 1 0.890378C2.5717 2.15829 4.52916 3.18302 7.86525 4.92946L8 5C9.92044 6.00946 13.44 7 16.5 7C17.1009 7 17.6015 6.84538 18 6.56245C18.4866 6.21698 18.821 5.6802 19 5V11.5C19 11.9557 18.7812 12.5 18 12.5C14.3216 12.5 10.3436 11.2814 8 10.5Z",
                                        fill: "black"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        "fill-rule": "evenodd",
                                        "clip-rule": "evenodd",
                                        d: "M8.3177 9.55181C10.6601 10.3328 14.5003 11.5 18 11.5V7.7044C17.5455 7.90223 17.0399 8 16.5 8C13.2757 8 9.59731 6.96911 7.53553 5.88559C7.44677 5.83912 7.3589 5.79313 7.27191 5.7476C4.44358 4.2672 2.54142 3.27158 1 2.14893V5.54262C3.16827 7.38531 5.20704 8.50461 8.3177 9.55181ZM8 10.5C4.61444 9.36039 2.40875 8.11637 0 6V0C0.321573 0.315789 0.651292 0.609069 1 0.890378C2.5717 2.15829 4.52916 3.18302 7.86525 4.92946L8 5C9.92044 6.00946 13.44 7 16.5 7C17.1009 7 17.6015 6.84538 18 6.56245C18.4866 6.21698 18.821 5.6802 19 5V11.5C19 11.9557 18.7812 12.5 18 12.5C14.3216 12.5 10.3436 11.2814 8 10.5Z",
                                        fill: "black"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                        id: "mask0_0_1",
                                        style: {
                                            maskType: "alpha"
                                        },
                                        maskUnits: "userSpaceOnUse",
                                        x: "0",
                                        y: "0",
                                        width: "6",
                                        height: "14",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            width: "6",
                                            height: "14",
                                            fill: "#D9D9D9"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                        mask: "url(#mask0_0_1)",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M18 12C14.411 12 10.502 10.8071 8.15895 10.0259C4.91009 8.93229 2.78803 7.75093 0.5 5.77255V1.12666C2.14683 2.50043 4.1607 3.55462 7.5652 5.33676C7.63218 5.37182 7.69969 5.40716 7.76776 5.44279C9.75887 6.48928 13.3579 7.5 16.5 7.5C17.2671 7.5 17.928 7.27866 18.4471 6.84924C18.4649 6.83447 18.4826 6.8195 18.5 6.80433V11.5C18.5 11.6591 18.4603 11.7854 18.4005 11.8611C18.3571 11.9161 18.2619 12 18 12Z",
                                                fill: "white",
                                                stroke: "black"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M18.5 6.94147L17.8005 7.24595C17.7448 7.27018 17.688 7.29272 17.6302 7.31355C17.8672 7.2281 18.0875 7.1135 18.2895 6.97015C18.3628 6.91809 18.433 6.86277 18.5 6.80438V6.94147ZM0.5 1.16621V1.12688C0.561476 1.17818 0.623478 1.22905 0.686061 1.27953C0.849664 1.41152 1.01725 1.54088 1.18978 1.66859L0.5 1.16621ZM7.50378 5.30461C5.33702 4.17049 3.73825 3.33287 2.4337 2.51275C3.75019 3.33961 5.3745 4.18994 7.57984 5.34441L7.63335 5.37243L7.50378 5.30461Z",
                                                fill: "white",
                                                stroke: "black"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                id: "porrectus-1-right-white",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M18 12C14.411 12 10.502 10.8071 8.15895 10.0259C4.91009 8.93229 2.78803 7.75093 0.5 5.77255V1.12666C2.14683 2.50043 4.1607 3.55462 7.5652 5.33676C7.63218 5.37182 7.69969 5.40716 7.76776 5.44279C9.75887 6.48928 13.3579 7.5 16.5 7.5C17.2671 7.5 17.928 7.27866 18.4471 6.84924C18.4649 6.83447 18.4826 6.8195 18.5 6.80433V11.5C18.5 11.6591 18.4603 11.7854 18.4005 11.8611C18.3571 11.9161 18.2619 12 18 12Z",
                                        fill: "black",
                                        stroke: "black"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                        id: "mask0_0_2",
                                        style: {
                                            maskType: "alpha"
                                        },
                                        maskUnits: "userSpaceOnUse",
                                        x: "13",
                                        y: "4",
                                        width: "6",
                                        height: "13",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            x: "13",
                                            y: "4",
                                            width: "6",
                                            height: "13",
                                            fill: "#D9D9D9"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        mask: "url(#mask0_0_2)",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18 12C14.411 12 10.502 10.8071 8.15895 10.0259C4.91009 8.93229 2.78803 7.75093 0.5 5.77255V1.12666C2.14683 2.50043 4.1607 3.55462 7.5652 5.33676C7.63218 5.37182 7.69969 5.40716 7.76776 5.44279C9.75887 6.48928 13.3579 7.5 16.5 7.5C17.2671 7.5 17.928 7.27866 18.4471 6.84924C18.4649 6.83447 18.4826 6.8195 18.5 6.80433V11.5C18.5 11.6591 18.4603 11.7854 18.4005 11.8611C18.3571 11.9161 18.2619 12 18 12Z",
                                            fill: "white",
                                            stroke: "black"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                id: "porrectus-2-left-white",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M18 17C16.2627 17 14.3379 16.4063 12.5772 15.6072C10.8228 14.811 9.27352 13.8301 8.3 13.1C5.70245 11.1518 2.47638 8.25274 0.5 5.82345V1.38299C2.46722 3.66634 5.07527 6.21358 7.67991 8.38411C8.54654 9.1063 10.0785 10.1256 11.7085 10.9653C13.3186 11.7948 15.1202 12.5 16.5 12.5C17.2671 12.5 17.928 12.2787 18.4471 11.8492C18.4649 11.8345 18.4826 11.8195 18.5 11.8043V16.5C18.5 16.6591 18.4603 16.7854 18.4005 16.8611C18.3571 16.9161 18.2619 17 18 17Z",
                                        fill: "black",
                                        stroke: "black"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                        id: "mask0_0_3",
                                        style: {
                                            maskType: "alpha"
                                        },
                                        maskUnits: "userSpaceOnUse",
                                        x: "0",
                                        y: "0",
                                        width: "6",
                                        height: "13",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            width: "6",
                                            height: "13",
                                            fill: "#D9D9D9"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        mask: "url(#mask0_0_3)",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18 17C16.2627 17 14.3379 16.4063 12.5772 15.6072C10.8228 14.811 9.27352 13.8301 8.3 13.1C5.70245 11.1518 2.47638 8.25274 0.5 5.82345V1.38299C2.46722 3.66634 5.07527 6.21358 7.67991 8.38411C8.54654 9.1063 10.0785 10.1256 11.7085 10.9653C13.3186 11.7948 15.1202 12.5 16.5 12.5C17.2671 12.5 17.928 12.2787 18.4471 11.8492C18.4649 11.8345 18.4826 11.8195 18.5 11.8043V16.5C18.5 16.6591 18.4603 16.7854 18.4005 16.8611C18.3571 16.9161 18.2619 17 18 17Z",
                                            fill: "white",
                                            stroke: "black"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                id: "porrectus-2-right-white",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M18 17C16.2627 17 14.3379 16.4063 12.5772 15.6072C10.8228 14.811 9.27352 13.8301 8.3 13.1C5.70245 11.1518 2.47638 8.25274 0.5 5.82345V1.38299C2.46722 3.66634 5.07527 6.21358 7.67991 8.38411C8.54654 9.1063 10.0785 10.1256 11.7085 10.9653C13.3186 11.7948 15.1202 12.5 16.5 12.5C17.2671 12.5 17.928 12.2787 18.4471 11.8492C18.4649 11.8345 18.4826 11.8195 18.5 11.8043V16.5C18.5 16.6591 18.4603 16.7854 18.4005 16.8611C18.3571 16.9161 18.2619 17 18 17Z",
                                        fill: "black",
                                        stroke: "black"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                        id: "mask0_0_4",
                                        style: {
                                            maskType: "alpha"
                                        },
                                        maskUnits: "userSpaceOnUse",
                                        x: "13",
                                        y: "7",
                                        width: "6",
                                        height: "17",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            x: "13",
                                            y: "7",
                                            width: "6",
                                            height: "17",
                                            fill: "#D9D9D9"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        mask: "url(#mask0_0_4)",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18 17C16.2627 17 14.3379 16.4063 12.5772 15.6072C10.8228 14.811 9.27352 13.8301 8.3 13.1C5.70245 11.1518 2.47638 8.25274 0.5 5.82345V1.38299C2.46722 3.66634 5.07527 6.21358 7.67991 8.38411C8.54654 9.1063 10.0785 10.1256 11.7085 10.9653C13.3186 11.7948 15.1202 12.5 16.5 12.5C17.2671 12.5 17.928 12.2787 18.4471 11.8492C18.4649 11.8345 18.4826 11.8195 18.5 11.8043V16.5C18.5 16.6591 18.4603 16.7854 18.4005 16.8611C18.3571 16.9161 18.2619 17 18 17Z",
                                            fill: "white",
                                            stroke: "black"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                id: "porrectus-3-left-white",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M18 23C16.3264 23 14.4355 22.081 12.5457 20.6626C10.6705 19.2551 8.86675 17.4096 7.37963 15.6746C5.25484 13.1957 2.48054 9.31157 0.5 5.86686V1.8162C2.57102 5.1694 5.59668 9.36979 8.62371 12.8293C9.67879 14.0351 10.9517 15.4371 12.2845 16.5389C13.5985 17.6251 15.0641 18.5 16.5 18.5C17.2671 18.5 17.928 18.2787 18.4471 17.8492C18.4649 17.8345 18.4826 17.8195 18.5 17.8043V22.5C18.5 22.6591 18.4603 22.7854 18.4005 22.8611C18.3571 22.9161 18.2619 23 18 23Z",
                                        fill: "black",
                                        stroke: "black"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                        id: "mask0_0_5",
                                        style: {
                                            maskType: "alpha"
                                        },
                                        maskUnits: "userSpaceOnUse",
                                        x: "0",
                                        y: "0",
                                        width: "6",
                                        height: "15",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            width: "6",
                                            height: "15",
                                            fill: "#D9D9D9"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        mask: "url(#mask0_0_5)",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18 23C16.3264 23 14.4355 22.081 12.5457 20.6626C10.6705 19.2551 8.86675 17.4096 7.37963 15.6746C5.25484 13.1957 2.48054 9.31157 0.5 5.86686V1.8162C2.57102 5.1694 5.59668 9.36979 8.62371 12.8293C9.67879 14.0351 10.9517 15.4371 12.2845 16.5389C13.5985 17.6251 15.0641 18.5 16.5 18.5C17.2671 18.5 17.928 18.2787 18.4471 17.8492C18.4649 17.8345 18.4826 17.8195 18.5 17.8043V22.5C18.5 22.6591 18.4603 22.7854 18.4005 22.8611C18.3571 22.9161 18.2619 23 18 23Z",
                                            fill: "white",
                                            stroke: "black"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                id: "porrectus-3-right-white",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M18 23C16.3264 23 14.4355 22.081 12.5457 20.6626C10.6705 19.2551 8.86675 17.4096 7.37963 15.6746C5.25484 13.1957 2.48054 9.31157 0.5 5.86686V1.8162C2.57102 5.1694 5.59668 9.36979 8.62371 12.8293C9.67879 14.0351 10.9517 15.4371 12.2845 16.5389C13.5985 17.6251 15.0641 18.5 16.5 18.5C17.2671 18.5 17.928 18.2787 18.4471 17.8492C18.4649 17.8345 18.4826 17.8195 18.5 17.8043V22.5C18.5 22.6591 18.4603 22.7854 18.4005 22.8611C18.3571 22.9161 18.2619 23 18 23Z",
                                        fill: "black",
                                        stroke: "black"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                        id: "mask0_0_6",
                                        style: {
                                            maskType: "alpha"
                                        },
                                        maskUnits: "userSpaceOnUse",
                                        x: "13",
                                        y: "10",
                                        width: "6",
                                        height: "17",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                            x: "13",
                                            y: "10",
                                            width: "6",
                                            height: "17",
                                            fill: "#D9D9D9"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        mask: "url(#mask0_0_6)",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18 23C16.3264 23 14.4355 22.081 12.5457 20.6626C10.6705 19.2551 8.86675 17.4096 7.37963 15.6746C5.25484 13.1957 2.48054 9.31157 0.5 5.86686V1.8162C2.57102 5.1694 5.59668 9.36979 8.62371 12.8293C9.67879 14.0351 10.9517 15.4371 12.2845 16.5389C13.5985 17.6251 15.0641 18.5 16.5 18.5C17.2671 18.5 17.928 18.2787 18.4471 17.8492C18.4649 17.8345 18.4826 17.8195 18.5 17.8043V22.5C18.5 22.6591 18.4603 22.7854 18.4005 22.8611C18.3571 22.9161 18.2619 23 18 23Z",
                                            fill: "white",
                                            stroke: "black"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "punctum-inclinatum-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M3 7.0566L1.08962 4.00001L3 0.943399L4.91038 4.00001L3 7.0566Z",
                                    fill: "white",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "beginning-ascending-liquescent-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M0 6V1.00002C0.260437 1.45577 0.972895 2.00011 3 2.00011C5.5 2.00011 6 0.000108242 6 0.000108242V6C6 7 4.97656 7.20713 4 7.5C3.65964 7.60208 2 7.66667 1.5 7.5C0.666107 7.22204 0 6.84644 0 6Z",
                                    fill: "white",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "terminating-ascending-liquescent-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M2.5 5C2.5 4.25125 2.1185 4 1.5 4C0.8165 4 0.390625 4.04425 0 4.5V1.80656C0 1.38344 0.16275 1.00906 0.488312 0.683563C0.813812 0.357938 1.15562 0.146437 1.51369 0.0487499C1.67637 0.0162499 1.83912 0 2.00181 0C2.22975 0 2.44131 0.0487499 2.63663 0.146437C2.96225 0.309187 3 0.641875 3 1V7H2.539L2.5 5Z",
                                    fill: "white",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "terminating-descending-liquescent-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M2.5 2C2.5 2.74875 2.1185 3 1.5 3C0.8165 3 0.390625 2.95575 3.93402e-07 2.5L1.57935e-07 5.19344C1.20944e-07 5.61656 0.16275 5.99094 0.488313 6.31644C0.813813 6.64206 1.15563 6.85356 1.51369 6.95125C1.67638 6.98375 1.83913 7 2.00181 7C2.22975 7 2.44131 6.95125 2.63663 6.85356C2.96225 6.69081 3 6.35813 3 6L3 2.62268e-07L2.539 2.21966e-07L2.5 2Z",
                                    fill: "white",
                                    stroke: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                id: "quilisma-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M0.5 6.62507V3.91319C0.728921 4.09502 0.999827 4.20837 1.3125 4.20837C1.59911 4.20837 1.83223 4.07364 2.00056 3.88661C2.15839 3.71125 2.26771 3.48341 2.34876 3.24326C2.37363 3.16957 2.39696 3.09127 2.41879 3.00845C2.67886 3.32847 3.04075 3.50005 3.46878 3.50005C3.77518 3.50005 3.98003 3.30813 4.09406 3.15326C4.21032 2.99536 4.29659 2.79418 4.36583 2.58261C4.37034 2.56881 4.37483 2.55482 4.3793 2.54064C4.42882 2.62097 4.48229 2.69544 4.54049 2.76048C4.64485 2.87712 4.83542 3.04165 5.10936 3.04165C5.2635 3.04165 5.39334 2.99414 5.5 2.92666V5.33333C5.5 5.75923 5.4585 6.02984 5.40527 6.18269C5.32283 6.08069 5.21974 5.89936 5.10635 5.60945L4.14355 5.73826C4.08405 6.29315 3.97375 6.64363 3.85165 6.84183C3.74643 7.01261 3.65646 7.0416 3.5625 7.0416C3.47269 7.0416 3.33574 7.00524 3.1429 6.85525C2.94855 6.70409 2.72455 6.45773 2.47538 6.09292L1.85498 5.18463L1.57855 6.24928C1.4433 6.77016 1.30004 7.11429 1.16537 7.31729C1.0996 7.41642 1.04751 7.46399 1.01673 7.48492C1.00234 7.49469 0.993697 7.49795 0.990615 7.49895C0.987928 7.49982 0.986446 7.5 0.9843 7.5C0.854447 7.5 0.768791 7.45885 0.683048 7.32023L0.682939 7.32006C0.565096 7.12971 0.5 6.90335 0.5 6.62507ZM5.48238 6.2585C5.48238 6.2586 5.48126 6.25813 5.47904 6.25674C5.48127 6.25769 5.48239 6.25839 5.48238 6.2585Z",
                                    fill: "white",
                                    stroke: "black"
                                })
                            })
                        ]
                    }),
                    isDropCapRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                x: dropCapWidth / 2 + (dropCapText === "J" ? 4 : 0),
                                y: 4,
                                textAnchor: "middle",
                                fontSize: 14,
                                fontWeight: 600,
                                children: toneLabel
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                x: dropCapWidth / 2 + (dropCapText === "J" ? 4 : 0),
                                y: $04cfb5a990424bdb$var$DROP_CAP_OFFSET,
                                textAnchor: "middle",
                                style: {
                                    fontSize: `${$04cfb5a990424bdb$var$DROP_CAP_FONT_SIZE}px`,
                                    fontFamily: $04cfb5a990424bdb$var$BODY_FONT,
                                    fill: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                                },
                                children: dropCapText
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    [
                        0,
                        1,
                        2,
                        3
                    ].map((staveLine)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                            x1: staveLineStart,
                            y1: staveLine * $04cfb5a990424bdb$var$STAVE_LINE_SPACING,
                            x2: measure.width,
                            y2: staveLine * $04cfb5a990424bdb$var$STAVE_LINE_SPACING,
                            stroke: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                            strokeWidth: 1
                        });
                    }),
                    tuningPitch && isOnScreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                        x1: staveLineStart,
                        x2: measure.width,
                        y1: $04cfb5a990424bdb$export$97879dd1a1210ded(tuningPitch),
                        y2: $04cfb5a990424bdb$export$97879dd1a1210ded(tuningPitch),
                        strokeWidth: 2,
                        stroke: "rgba(0, 214, 255, 0.5)"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    clef === "c4" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                        xlinkHref: "#c-clef",
                        x: isDropCapRow ? dropCapWidth + 4 : 0,
                        y: -9.5
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    clef === "c3" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                        xlinkHref: "#c-clef",
                        x: isDropCapRow ? dropCapWidth + 4 : 0,
                        y: 1.5
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    clef === "c2" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                        xlinkHref: "#c-clef",
                        x: isDropCapRow ? dropCapWidth + 4 : 0,
                        y: 12.5
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    clef === "f3" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                        xlinkHref: "#f-clef",
                        x: isDropCapRow ? dropCapWidth + 4 : 0,
                        y: 0.5
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    currentSvgRow
                ]
            })
        }));
        currentSvgRow = [];
    };
    const dropCapWidth = Math.max(measureText(toneLabel, "normal"), measureText(dropCapText, "drop cap"));
    if (hasEverBeenOnScreen) {
        let left = undefined;
        layoutNeumes.forEach((layoutNeume, layoutNeumeIndex)=>{
            if (left === undefined) {
                left = clef === "f3" ? 20 : 12;
                left += Math.max(8 - layoutNeume.textExtensionLeft, 0);
                if (dropCap && svgRows.length === 0) left += dropCapWidth;
                left += Math.max(layoutNeume.neumeExtensionLeft, layoutNeume.textExtensionLeft);
            }
            const nextLayoutNeume = layoutNeumes[layoutNeumeIndex + 1];
            const nextButOneLayoutNeume = layoutNeumes[layoutNeumeIndex + 2];
            let nextLayoutNeumeWithANote = undefined;
            for(let nlnwan = layoutNeumeIndex + 1; nlnwan < layoutNeumes.length; nlnwan++)if (layoutNeumes[nlnwan].neume.elements[0]?.notes.length > 0) {
                nextLayoutNeumeWithANote = layoutNeumes[nlnwan];
                break;
            }
            let nextLeft = nextLayoutNeume ? left + Math.max(layoutNeume.neumeExtensionRight + nextLayoutNeume.neumeExtensionLeft, layoutNeume.textExtensionRight + nextLayoutNeume.textExtensionLeft) : 0;
            let nextNeumeNeedsNewLine = false;
            if (nextLayoutNeume) {
                let bufferSize = 4;
                if (nextLeft + Math.max(nextLayoutNeume.neumeExtensionRight, nextLayoutNeume.textExtensionRight) + bufferSize > measure.width) // Next neume crosses threshold
                nextNeumeNeedsNewLine = true;
                else // Even if this neume does not cross the threshold, maybe the next one is a bar and does
                if (nextButOneLayoutNeume && nextButOneLayoutNeume.neume.elements[0] && nextButOneLayoutNeume.neume.elements[0].type.includes("bar") && nextLeft + Math.max(nextLayoutNeume.neumeExtensionRight, nextLayoutNeume.textExtensionRight) + nextButOneLayoutNeume.neumeExtensionRight + bufferSize > measure.width) nextNeumeNeedsNewLine = true;
            }
            let text = layoutNeume.neume.text.replace("[", "(").replace("]", ")").replace("$", "*");
            if (nextLayoutNeume && layoutNeume.textExtensionRight + nextLayoutNeume.textExtensionLeft >= layoutNeume.neumeExtensionRight + nextLayoutNeume.neumeExtensionLeft && !nextNeumeNeedsNewLine && text.slice(text.length - 1) !== " " && layoutNeume.redDotOffset === undefined) {
                // Accumulate text that touches and show it on the last neume
                let kernAdjustment = measureText(text, "normal") + measureText(nextLayoutNeume.neume.text, "normal") - measureText(text + nextLayoutNeume.neume.text, "normal");
                // console.log("combining", text + nextLayoutNeume.neume.text, {
                //     addAfterMeasure:
                //         measureText(text, "normal") +
                //         measureText(nextLayoutNeume.neume.text, "normal"),
                //     addBeforemeasure: measureText(
                //         text + nextLayoutNeume.neume.text,
                //         "normal"
                //     ),
                //     kernAdjustment,
                // });
                nextLayoutNeume.textExtensionLeft += layoutNeume.textExtensionRight + layoutNeume.textExtensionLeft - kernAdjustment;
                nextLayoutNeume.neume.text = text + nextLayoutNeume.neume.text;
                nextLeft -= kernAdjustment;
                text = "";
            }
            const totalExtensionLeft = Math.max(layoutNeume.neumeExtensionLeft, layoutNeume.textExtensionLeft);
            const totalExtensionRight = Math.max(layoutNeume.neumeExtensionRight, layoutNeume.textExtensionRight);
            let currentSvgItem = [];
            if (layoutNeume.maxNote >= 9) currentSvgItem.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: -layoutNeume.neumeExtensionLeft - 4,
                y1: -1 * $04cfb5a990424bdb$var$STAVE_LINE_SPACING,
                x2: layoutNeume.neumeExtensionRight - 6,
                y2: -1 * $04cfb5a990424bdb$var$STAVE_LINE_SPACING,
                stroke: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                strokeWidth: 1
            }));
            if (layoutNeume.minNote <= -1) currentSvgItem.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: -layoutNeume.neumeExtensionLeft - 4,
                y1: 4 * $04cfb5a990424bdb$var$STAVE_LINE_SPACING,
                x2: layoutNeume.neumeExtensionRight - 6,
                y2: 4 * $04cfb5a990424bdb$var$STAVE_LINE_SPACING,
                stroke: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                strokeWidth: 1
            }));
            currentSvgItem.push(...layoutNeume.svgNeume);
            currentSvgItem.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                x: -layoutNeume.textExtensionLeft + (text === "* " ? -1 : 0),
                y: $04cfb5a990424bdb$var$TEXT_OFFSET,
                style: {
                    fontSize: bodyFontSize,
                    fontFamily: $04cfb5a990424bdb$var$BODY_FONT,
                    fontWeight: layoutNeume.neume.isBold || text === "* " ? 700 : undefined,
                    fill: text === "* " ? (0, $b5d1360628cd70a0$export$f20e1008093b38b9) : undefined
                },
                "data-width": measureText(layoutNeume.neume.text, layoutNeume.neume.isBold ? "normal bold" : "normal"),
                "data-tl": layoutNeume.textExtensionLeft,
                "data-tr": layoutNeume.textExtensionRight,
                "data-nl": layoutNeume.neumeExtensionLeft,
                "data-nr": layoutNeume.neumeExtensionRight,
                "data-nnl": nextLayoutNeume?.neumeExtensionLeft,
                "data-ntl": nextLayoutNeume?.textExtensionLeft,
                "data-text-space": layoutNeume.textExtensionRight + nextLayoutNeume?.textExtensionLeft,
                "data-neume-space": layoutNeume.neumeExtensionRight + nextLayoutNeume?.neumeExtensionLeft,
                "data-concat": nextLayoutNeume && layoutNeume.textExtensionRight + nextLayoutNeume.textExtensionLeft >= layoutNeume.neumeExtensionRight + nextLayoutNeume.neumeExtensionLeft && !nextNeumeNeedsNewLine,
                children: [
                    text,
                    nextNeumeNeedsNewLine && layoutNeume.neume.text.length > 0 && "abcdefghijklmnopqrstuvwxyz".includes(layoutNeume.neume.text[layoutNeume.neume.text.length - 1].toLocaleLowerCase()) ? "-" : ""
                ]
            }));
            currentSvgItem.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: totalExtensionLeft + totalExtensionRight,
                height: 100,
                x: -totalExtensionLeft,
                y: -20,
                fill: "transparent"
            }));
            if (layoutNeume.redDotOffset !== undefined) currentSvgItem.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: layoutNeume.redDotOffset + 1,
                y: $04cfb5a990424bdb$var$TEXT_OFFSET + 0.5,
                style: {
                    fontSize: bodyFontSize * 0.8,
                    fontFamily: $04cfb5a990424bdb$var$BODY_FONT,
                    fill: (0, $b5d1360628cd70a0$export$48ee2f34eb455667)
                },
                children: "\u2022"
            }));
            currentSvgRow.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                transform: `translate(${left}, 0)`,
                onClick: ()=>{
                    if (mistakeNeume === -1 || mistakeNeume === layoutNeumeIndex) {
                        if (mistakeClicks === 2) {
                            let verseIndex = 0;
                            for(let i = 0; i < layoutNeumeIndex; i++){
                                const ln = layoutNeumes[i];
                                if (ln.neume.text.trim().length === 0 && i !== 0) verseIndex++;
                            }
                            console.log("found mistake in verse", verseIndex);
                            if (props.onReportMistake) props.onReportMistake(verseIndex);
                        }
                        setMistakeClicks((p)=>p + 1);
                        setTimeout(()=>{
                            setMistakeClicks((p)=>p > 0 ? p - 1 : 0);
                        }, 1000);
                    } else {
                        setMistakeNeume(-1);
                        setMistakeClicks(0);
                    }
                    if (onClickNeume) onClickNeume(layoutNeumeIndex);
                },
                children: currentSvgItem
            }));
            if (nextLayoutNeume) {
                if (nextNeumeNeedsNewLine) {
                    left = undefined;
                    if (nextLayoutNeumeWithANote) currentSvgRow.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                        xlinkHref: "#custos",
                        x: measure.width - 3,
                        y: $04cfb5a990424bdb$export$97879dd1a1210ded(nextLayoutNeumeWithANote.neume.elements[0]?.notes[0]?.pitch ?? 0) - 4 - (0, $49d4b9cf3f617ce8$export$31dc21c2b5f77f64)
                    }));
                    pushRow();
                } else left = nextLeft;
            }
        });
        pushRow();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: measureRef,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: containerRef,
            className: "svg-chant",
            children: svgRows
        })
    });
};
const $04cfb5a990424bdb$var$useOnScreen = (ref)=>{
    // State and setter for storing whether element is visible
    const [isIntersecting, setIntersecting] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            // Update our state when observer callback fires
            setIntersecting(entry.isIntersecting);
        }, {
            rootMargin: "0px"
        });
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (ref.current) observer.unobserve(ref.current);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return isIntersecting;
};


const $800a243c436a5a55$export$822ec9e4f0223433 = (tune, text)=>{
    try {
        const tuneLines = tune.split("\n").map((tl)=>tl.trim());
        const verses = text.split("\n\n");
        return `(${tuneLines[0]}) ` + verses.map((v)=>{
            const lines = v.split("\n").map((vl)=>vl.trim());
            return lines.map((l, lineIndex)=>{
                const tuneSyllables = tuneLines[lineIndex + 1]?.split(" ") ?? [];
                return l.replace(/ /g, "_ ").split("_").map((syllable, syllableIndex)=>{
                    return `${syllable}(${tuneSyllables[syllableIndex] ?? ","})`;
                }).join("") + ` (${tuneSyllables[tuneSyllables.length - 1]})`;
            }).join(" ");
        }).join(" ");
    } catch  {
        return "";
    }
};
const $800a243c436a5a55$export$11a6a3eba8387011 = (tune)=>{
    let totalNoteValue = 0;
    let noteCount = 0;
    let minNote = 99;
    let maxNote = 0;
    for(let i = 1; i < tune.length; i++){
        // skip c4 etc
        const char = tune.charAt(i);
        const alpha = "abcdefghijklmn";
        if (alpha.includes(char)) {
            const noteValue = alpha.indexOf(char);
            totalNoteValue += noteValue;
            noteCount++;
            minNote = Math.min(minNote, noteValue);
            maxNote = Math.max(maxNote, noteValue);
        }
    }
    const avgNote = Math.round(totalNoteValue / noteCount);
    const range = maxNote - minNote;
    let tweak = 4 - avgNote;
    const initialTweak = tweak;
    const topLimit = 12;
    const bottomLimit = 4;
    const rangeLimit = topLimit - bottomLimit;
    const rangeError = Math.max(range - rangeLimit, 0);
    const topError = Math.max(maxNote + tweak - topLimit, 0);
    const bottomError = Math.max(bottomLimit + tweak - minNote, 0);
    const allowedError = Math.round(rangeError / 2);
    if (topError > allowedError) tweak -= topError - allowedError;
    if (bottomError > allowedError) tweak += bottomError - allowedError;
    console.log("auto tweak", {
        avgNote: avgNote,
        minNote: minNote,
        maxNote: maxNote,
        range: range,
        effectiveAvg: avgNote + tweak,
        effectiveMin: minNote + tweak,
        effectiveMax: maxNote + tweak,
        topError: topError,
        bottomError: bottomError,
        rangeError: rangeError,
        initialTweak: initialTweak,
        tweak: tweak,
        allowedError: allowedError
    });
    return tweak;
};
const $800a243c436a5a55$export$f3e61a719d75a165 = (props)=>{
    const { hymn: hymn } = props;
    const verses = hymn.text.split("\n\n");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: verses.map((verse, verseIndex)=>{
            const gabc = $800a243c436a5a55$export$822ec9e4f0223433(hymn.tune, verse);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04cfb5a990424bdb$export$a512b99ae1e55604), {
                gabc: gabc,
                dropCap: verseIndex === 0,
                tone: hymn.mode + ""
            });
        })
    });
};


const $4d61651d1fc64a9b$export$1063804fe6672506 = {
    "to-thee-before-the-close-of-day": {
        // compline
        title: "Te lucis ante terminum",
        text: [
            [
                [
                    "TO"
                ],
                [
                    "thee"
                ],
                [
                    "be",
                    "fore"
                ],
                [
                    "the"
                ],
                [
                    "close"
                ],
                [
                    "of"
                ],
                [
                    "day,"
                ]
            ],
            [
                [
                    "Cre",
                    "a",
                    "tor"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "world,"
                ],
                [
                    "we"
                ],
                [
                    "pray,"
                ]
            ],
            [
                [
                    "that"
                ],
                [
                    "with"
                ],
                [
                    "thy"
                ],
                [
                    "won",
                    "ted"
                ],
                [
                    "fa",
                    "vour"
                ],
                [
                    "thou"
                ]
            ],
            [
                [
                    "wouldst"
                ],
                [
                    "be"
                ],
                [
                    "our"
                ],
                [
                    "guard"
                ],
                [
                    "and"
                ],
                [
                    "kee",
                    "per"
                ],
                [
                    "now."
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "all"
                ],
                [
                    "ill"
                ],
                [
                    "dreams"
                ],
                [
                    "de",
                    "fend"
                ],
                [
                    "our"
                ],
                [
                    "eyes,"
                ]
            ],
            [
                [
                    "from"
                ],
                [
                    "night",
                    "ly"
                ],
                [
                    "fears"
                ],
                [
                    "and"
                ],
                [
                    "fan",
                    "ta",
                    "sies"
                ]
            ],
            [
                [
                    "tread"
                ],
                [
                    "un",
                    "der"
                ],
                [
                    "foot"
                ],
                [
                    "our"
                ],
                [
                    "ghost",
                    "ly"
                ],
                [
                    "foe,"
                ]
            ],
            [
                [
                    "that"
                ],
                [
                    "no"
                ],
                [
                    "pol",
                    "lu",
                    "tion"
                ],
                [
                    "we"
                ],
                [
                    "may"
                ],
                [
                    "know."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "ask"
                ],
                [
                    "be"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "through"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "Christ,"
                ],
                [
                    "thine"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son;"
                ]
            ],
            [
                [
                    "who,"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "and"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "doth"
                ],
                [
                    "live"
                ],
                [
                    "and"
                ],
                [
                    "reign"
                ],
                [
                    "e",
                    "ter",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "5",
                "7",
                "7",
                "7",
                "7",
                "8",
                "7",
                "6"
            ],
            [
                "5",
                "5",
                "5",
                "5",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "6",
                "5",
                "4",
                "2",
                "4",
                "5",
                "5"
            ],
            [
                "7",
                "7",
                "7",
                "7",
                "5",
                "6",
                "5",
                "4"
            ]
        ],
        amen: [
            "45",
            "434"
        ],
        clef: "c7",
        tone: "8"
    },
    "this-day-the-first-of-days-was-made": {
        // sunday
        title: "Primo dierum omnium",
        text: [
            [
                [
                    "THIS"
                ],
                [
                    "day"
                ],
                [
                    "the"
                ],
                [
                    "first"
                ],
                [
                    "of"
                ],
                [
                    "days"
                ],
                [
                    "was"
                ],
                [
                    "made,"
                ]
            ],
            [
                [
                    "When"
                ],
                [
                    "God"
                ],
                [
                    "in"
                ],
                [
                    "light"
                ],
                [
                    "the"
                ],
                [
                    "world"
                ],
                [
                    "ar",
                    "rayed;"
                ]
            ],
            [
                [
                    "Or"
                ],
                [
                    "when"
                ],
                [
                    "his"
                ],
                [
                    "Word"
                ],
                [
                    "a",
                    "rose"
                ],
                [
                    "a",
                    "gain,"
                ]
            ],
            [
                [
                    "And,"
                ],
                [
                    "con",
                    "q'ring"
                ],
                [
                    "death,"
                ],
                [
                    "gave"
                ],
                [
                    "life"
                ],
                [
                    "to"
                ],
                [
                    "men."
                ]
            ],
            [
                [
                    "Slum",
                    "ber"
                ],
                [
                    "and"
                ],
                [
                    "sloth"
                ],
                [
                    "drive"
                ],
                [
                    "far"
                ],
                [
                    "a",
                    "way;"
                ]
            ],
            [
                [
                    "Ear",
                    "lier"
                ],
                [
                    "a",
                    "rise"
                ],
                [
                    "to"
                ],
                [
                    "greet"
                ],
                [
                    "the"
                ],
                [
                    "day;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "ere"
                ],
                [
                    "its"
                ],
                [
                    "dawn"
                ],
                [
                    "in"
                ],
                [
                    "heav'n"
                ],
                [
                    "un",
                    "fold"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "heart's"
                ],
                [
                    "de",
                    "sire"
                ],
                [
                    "to"
                ],
                [
                    "God"
                ],
                [
                    "be"
                ],
                [
                    "told."
                ]
            ],
            [
                [
                    "Un",
                    "to"
                ],
                [
                    "our"
                ],
                [
                    "prayer"
                ],
                [
                    "that"
                ],
                [
                    "he"
                ],
                [
                    "at",
                    "tend,"
                ]
            ],
            [
                [
                    "His"
                ],
                [
                    "all-",
                    "cre",
                    "a",
                    "ting"
                ],
                [
                    "pow'r"
                ],
                [
                    "ex",
                    "tend,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "still"
                ],
                [
                    "re",
                    "new"
                ],
                [
                    "us,"
                ],
                [
                    "lest"
                ],
                [
                    "we"
                ],
                [
                    "miss,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "earth",
                    "ly"
                ],
                [
                    "stain"
                ],
                [
                    "our"
                ],
                [
                    "heav'n",
                    "ly"
                ],
                [
                    "bliss."
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "us,"
                ],
                [
                    "who"
                ],
                [
                    "here"
                ],
                [
                    "this"
                ],
                [
                    "day"
                ],
                [
                    "re",
                    "pair"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "keep"
                ],
                [
                    "the-",
                    "Apos",
                    "tles'"
                ],
                [
                    "time"
                ],
                [
                    "of"
                ],
                [
                    "pray'r,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "hymn"
                ],
                [
                    "the"
                ],
                [
                    "qui",
                    "et"
                ],
                [
                    "hours"
                ],
                [
                    "of"
                ],
                [
                    "morn,"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "bless-",
                    "ed"
                ],
                [
                    "gifts"
                ],
                [
                    "he"
                ],
                [
                    "may"
                ],
                [
                    "a",
                    "dorn."
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "this,"
                ],
                [
                    "Re",
                    "dee",
                    "mer,"
                ],
                [
                    "thee"
                ],
                [
                    "we"
                ],
                [
                    "pray,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "thou"
                ],
                [
                    "wilt"
                ],
                [
                    "wash"
                ],
                [
                    "our"
                ],
                [
                    "sins"
                ],
                [
                    "a",
                    "way,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "of"
                ],
                [
                    "thy"
                ],
                [
                    "lo",
                    "ving-",
                    "kind",
                    "ness"
                ],
                [
                    "grant"
                ]
            ],
            [
                [
                    "What",
                    "e'er"
                ],
                [
                    "of"
                ],
                [
                    "good"
                ],
                [
                    "our"
                ],
                [
                    "spi",
                    "rits"
                ],
                [
                    "want."
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "ex",
                    "iles"
                ],
                [
                    "here"
                ],
                [
                    "a",
                    "while"
                ],
                [
                    "in"
                ],
                [
                    "flesh"
                ]
            ],
            [
                [
                    "Some"
                ],
                [
                    "ear",
                    "nest"
                ],
                [
                    "may"
                ],
                [
                    "our"
                ],
                [
                    "souls"
                ],
                [
                    "re",
                    "fresh"
                ]
            ],
            [
                [
                    "Of"
                ],
                [
                    "that"
                ],
                [
                    "pure"
                ],
                [
                    "life"
                ],
                [
                    "for"
                ],
                [
                    "which"
                ],
                [
                    "we"
                ],
                [
                    "long,"
                ]
            ],
            [
                [
                    "Some"
                ],
                [
                    "fore",
                    "taste"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "heav'n",
                    "ly"
                ],
                [
                    "song."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "ask"
                ],
                [
                    "be"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "Christ,"
                ],
                [
                    "thine"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son;"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "and"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "Doth"
                ],
                [
                    "live"
                ],
                [
                    "and"
                ],
                [
                    "reign"
                ],
                [
                    "e",
                    "ter",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "1",
                "2",
                "3",
                "4",
                "24",
                "3",
                "2",
                "3"
            ],
            [
                "1",
                "2",
                "3",
                "4",
                "24",
                "3",
                "2",
                "121"
            ],
            [
                "2",
                "0",
                "2",
                "45",
                "56",
                "5",
                "4",
                "5"
            ],
            [
                "5",
                "5",
                "5",
                "4",
                "3",
                "4",
                "3",
                "2"
            ]
        ],
        amen: [
            "23",
            "212"
        ],
        clef: "c7",
        tone: "4"
    },
    "o-splendour-of-gods-glory-bright": {
        // monday
        title: "Splendor paternae gloriae",
        text: [
            [
                [
                    "O"
                ],
                [
                    "SPLEN",
                    "DOUR"
                ],
                [
                    "of"
                ],
                [
                    "God's"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "bright,"
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "thou"
                ],
                [
                    "that"
                ],
                [
                    "bring",
                    "est"
                ],
                [
                    "light"
                ],
                [
                    "from"
                ],
                [
                    "light,"
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Light"
                ],
                [
                    "of"
                ],
                [
                    "light,"
                ],
                [
                    "light's"
                ],
                [
                    "liv",
                    "ing"
                ],
                [
                    "spring,"
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Day,"
                ],
                [
                    "all"
                ],
                [
                    "days"
                ],
                [
                    "il",
                    "lu",
                    "min",
                    "ing."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "thou"
                ],
                [
                    "true"
                ],
                [
                    "Sun,"
                ],
                [
                    "on"
                ],
                [
                    "us"
                ],
                [
                    "thy"
                ],
                [
                    "glance"
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "fall"
                ],
                [
                    "in"
                ],
                [
                    "roy",
                    "al"
                ],
                [
                    "ra",
                    "di",
                    "ance,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Spi",
                    "rit's"
                ],
                [
                    "sanc",
                    "ti",
                    "fy",
                    "ing"
                ],
                [
                    "beam,"
                ]
            ],
            [
                [
                    "Up",
                    "on"
                ],
                [
                    "our"
                ],
                [
                    "earth",
                    "ly"
                ],
                [
                    "sen",
                    "ses"
                ],
                [
                    "stream."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "too,"
                ],
                [
                    "our"
                ],
                [
                    "pray'rs"
                ],
                [
                    "im",
                    "plore,"
                ]
            ],
            [
                [
                    "Fa",
                    "ther"
                ],
                [
                    "of"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "e",
                    "ver",
                    "more;"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "of"
                ],
                [
                    "all"
                ],
                [
                    "grace"
                ],
                [
                    "and"
                ],
                [
                    "might,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "ban",
                    "ish"
                ],
                [
                    "sin"
                ],
                [
                    "from"
                ],
                [
                    "our"
                ],
                [
                    "de",
                    "light:"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "guide"
                ],
                [
                    "what",
                    "e'er"
                ],
                [
                    "we"
                ],
                [
                    "no",
                    "bly"
                ],
                [
                    "do,"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "love"
                ],
                [
                    "all"
                ],
                [
                    "en",
                    "vy"
                ],
                [
                    "to"
                ],
                [
                    "sub",
                    "due,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "make"
                ],
                [
                    "ill-",
                    "for",
                    "tune"
                ],
                [
                    "turn"
                ],
                [
                    "to"
                ],
                [
                    "fair,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "give"
                ],
                [
                    "us"
                ],
                [
                    "grace"
                ],
                [
                    "our"
                ],
                [
                    "wrongs"
                ],
                [
                    "to"
                ],
                [
                    "bear."
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "mind"
                ],
                [
                    "be"
                ],
                [
                    "in"
                ],
                [
                    "his"
                ],
                [
                    "kee",
                    "ping"
                ],
                [
                    "placed,"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "bo",
                    "dy"
                ],
                [
                    "true"
                ],
                [
                    "to"
                ],
                [
                    "him"
                ],
                [
                    "and"
                ],
                [
                    "chaste,"
                ]
            ],
            [
                [
                    "Where"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "faith"
                ],
                [
                    "here"
                ],
                [
                    "fire"
                ],
                [
                    "shall"
                ],
                [
                    "feed,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "burn"
                ],
                [
                    "the"
                ],
                [
                    "tares"
                ],
                [
                    "of"
                ],
                [
                    "Sa",
                    "tan's"
                ],
                [
                    "seed."
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "Christ"
                ],
                [
                    "to"
                ],
                [
                    "us"
                ],
                [
                    "for"
                ],
                [
                    "food"
                ],
                [
                    "shall"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "him"
                ],
                [
                    "our"
                ],
                [
                    "drink"
                ],
                [
                    "that"
                ],
                [
                    "well",
                    "eth"
                ],
                [
                    "free,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Spi",
                    "rit's"
                ],
                [
                    "wine,"
                ],
                [
                    "that"
                ],
                [
                    "mak",
                    "eth"
                ],
                [
                    "whole,"
                ]
            ],
            [
                [
                    "And,"
                ],
                [
                    "mock",
                    "ing"
                ],
                [
                    "not,"
                ],
                [
                    "ex",
                    "alts"
                ],
                [
                    "the"
                ],
                [
                    "soul."
                ]
            ],
            [
                [
                    "Re",
                    "joic",
                    "ing"
                ],
                [
                    "may"
                ],
                [
                    "this"
                ],
                [
                    "day"
                ],
                [
                    "go"
                ],
                [
                    "hence."
                ]
            ],
            [
                [
                    "Like"
                ],
                [
                    "vir",
                    "gin"
                ],
                [
                    "dawn"
                ],
                [
                    "our"
                ],
                [
                    "in",
                    "no",
                    "cence,"
                ]
            ],
            [
                [
                    "Like"
                ],
                [
                    "fie",
                    "ry"
                ],
                [
                    "noon"
                ],
                [
                    "our"
                ],
                [
                    "faith"
                ],
                [
                    "ap",
                    "pear,"
                ]
            ],
            [
                [
                    "Nor"
                ],
                [
                    "know"
                ],
                [
                    "the"
                ],
                [
                    "gloom"
                ],
                [
                    "of"
                ],
                [
                    "twi",
                    "light"
                ],
                [
                    "drear."
                ]
            ],
            [
                [
                    "Morn"
                ],
                [
                    "in"
                ],
                [
                    "her"
                ],
                [
                    "ro",
                    "sy"
                ],
                [
                    "car"
                ],
                [
                    "is"
                ],
                [
                    "borne;"
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "him"
                ],
                [
                    "come"
                ],
                [
                    "forth"
                ],
                [
                    "our"
                ],
                [
                    "per",
                    "fect"
                ],
                [
                    "morn,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Word"
                ],
                [
                    "in"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "one,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "per",
                    "fect"
                ],
                [
                    "in"
                ],
                [
                    "the"
                ],
                [
                    "Son."
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "laud"
                ],
                [
                    "to"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "praise,"
                ],
                [
                    "e",
                    "ter",
                    "nal"
                ],
                [
                    "Son,"
                ],
                [
                    "to"
                ],
                [
                    "thee;"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry,"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "e",
                    "ver"
                ],
                [
                    "meet,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Pa",
                    "ra",
                    "clete."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "3",
                "4",
                "5",
                "6b",
                "5",
                "4",
                "5"
            ],
            [
                "5",
                "4",
                "7",
                "7",
                "4",
                "5",
                "6b",
                "54"
            ],
            [
                "5",
                "5",
                "4",
                "5",
                "4",
                "3",
                "2",
                "3"
            ],
            [
                "4",
                "5",
                "4",
                "3",
                "2",
                "34",
                "2",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "the-wing-ed-herald-of-the-day": {
        // tuesday
        title: "Ales diei nuntius",
        text: [
            [
                [
                    "THE"
                ],
                [
                    "wing-",
                    "ed"
                ],
                [
                    "he",
                    "rald"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "day"
                ]
            ],
            [
                [
                    "Pro",
                    "claims"
                ],
                [
                    "the"
                ],
                [
                    "morn's"
                ],
                [
                    "ap",
                    "proach",
                    "ing"
                ],
                [
                    "ray:"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "Christ"
                ],
                [
                    "the"
                ],
                [
                    "Lord"
                ],
                [
                    "our"
                ],
                [
                    "soul"
                ],
                [
                    "ex",
                    "cites,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "so"
                ],
                [
                    "to"
                ],
                [
                    "end",
                    "less"
                ],
                [
                    "life"
                ],
                [
                    "in",
                    "vites."
                ]
            ],
            [
                [
                    "Take"
                ],
                [
                    "up"
                ],
                [
                    "thy"
                ],
                [
                    "bed,"
                ],
                [
                    "to"
                ],
                [
                    "each"
                ],
                [
                    "he"
                ],
                [
                    "cries,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "sick"
                ],
                [
                    "or"
                ],
                [
                    "wrapt"
                ],
                [
                    "in"
                ],
                [
                    "slum",
                    "ber"
                ],
                [
                    "lies;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "chaste"
                ],
                [
                    "and"
                ],
                [
                    "just"
                ],
                [
                    "and"
                ],
                [
                    "so",
                    "ber"
                ],
                [
                    "stand,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "watch:"
                ],
                [
                    "my"
                ],
                [
                    "com",
                    "ing"
                ],
                [
                    "is"
                ],
                [
                    "at"
                ],
                [
                    "hand."
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "ear",
                    "nest"
                ],
                [
                    "cry,"
                ],
                [
                    "with"
                ],
                [
                    "tear",
                    "ful"
                ],
                [
                    "care,"
                ]
            ],
            [
                [
                    "Call"
                ],
                [
                    "we"
                ],
                [
                    "the"
                ],
                [
                    "Lord"
                ],
                [
                    "to"
                ],
                [
                    "hear"
                ],
                [
                    "our"
                ],
                [
                    "pray'r;"
                ]
            ],
            [
                [
                    "While"
                ],
                [
                    "supp",
                    "li",
                    "ca",
                    "tion,"
                ],
                [
                    "pure"
                ],
                [
                    "and"
                ],
                [
                    "deep,"
                ]
            ],
            [
                [
                    "For",
                    "bids"
                ],
                [
                    "each"
                ],
                [
                    "chast",
                    "en'd"
                ],
                [
                    "heart"
                ],
                [
                    "to"
                ],
                [
                    "sleep."
                ]
            ],
            [
                [
                    "Do"
                ],
                [
                    "thou,"
                ],
                [
                    "O"
                ],
                [
                    "Christ,"
                ],
                [
                    "our"
                ],
                [
                    "slum",
                    "bers"
                ],
                [
                    "wake;"
                ]
            ],
            [
                [
                    "Do"
                ],
                [
                    "thou"
                ],
                [
                    "the"
                ],
                [
                    "chains"
                ],
                [
                    "of"
                ],
                [
                    "dark",
                    "ness"
                ],
                [
                    "break;"
                ]
            ],
            [
                [
                    "Purge"
                ],
                [
                    "thou"
                ],
                [
                    "our"
                ],
                [
                    "for",
                    "mer"
                ],
                [
                    "sins"
                ],
                [
                    "a",
                    "way,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "in"
                ],
                [
                    "our"
                ],
                [
                    "souls"
                ],
                [
                    "new"
                ],
                [
                    "light"
                ],
                [
                    "dis",
                    "play."
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "laud"
                ],
                [
                    "to"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "praise,"
                ],
                [
                    "e",
                    "ter",
                    "nal"
                ],
                [
                    "Son,"
                ],
                [
                    "to"
                ],
                [
                    "thee;"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry,"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "e",
                    "ver"
                ],
                [
                    "meet,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Pa",
                    "ra",
                    "clete."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "3",
                "4",
                "5",
                "6b",
                "5",
                "4",
                "5"
            ],
            [
                "5",
                "4",
                "7",
                "7",
                "4",
                "5",
                "6b",
                "54"
            ],
            [
                "5",
                "5",
                "4",
                "5",
                "4",
                "3",
                "2",
                "3"
            ],
            [
                "4",
                "5",
                "4",
                "3",
                "2",
                "34",
                "2",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "ye-clouds-and-darkness-hosts-of-night": {
        // wednesday
        title: "Nox et tenebrae et nubila",
        text: [
            [
                [
                    "YE"
                ],
                [
                    "clouds"
                ],
                [
                    "and"
                ],
                [
                    "dark",
                    "ness,"
                ],
                [
                    "hosts"
                ],
                [
                    "of"
                ],
                [
                    "night,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "breed"
                ],
                [
                    "con",
                    "fu",
                    "sion"
                ],
                [
                    "and"
                ],
                [
                    "af",
                    "fright,"
                ]
            ],
            [
                [
                    "Be",
                    "gone!"
                ],
                [
                    "O'er",
                    "head"
                ],
                [
                    "the"
                ],
                [
                    "dawn"
                ],
                [
                    "shines"
                ],
                [
                    "clear,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "light"
                ],
                [
                    "breaks"
                ],
                [
                    "in"
                ],
                [
                    "and"
                ],
                [
                    "Christ"
                ],
                [
                    "is"
                ],
                [
                    "here."
                ]
            ],
            [
                [
                    "Earth's"
                ],
                [
                    "gloom"
                ],
                [
                    "flees"
                ],
                [
                    "bro",
                    "ken"
                ],
                [
                    "and"
                ],
                [
                    "dis",
                    "persed,"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "the"
                ],
                [
                    "sun's"
                ],
                [
                    "pier",
                    "cing"
                ],
                [
                    "shafts"
                ],
                [
                    "co",
                    "erced:"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "day-",
                    "star's"
                ],
                [
                    "eyes"
                ],
                [
                    "rain"
                ],
                [
                    "in",
                    "fluence"
                ],
                [
                    "bright,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "co",
                    "lours"
                ],
                [
                    "glim",
                    "mer"
                ],
                [
                    "back"
                ],
                [
                    "to"
                ],
                [
                    "sight."
                ]
            ],
            [
                [
                    "Thee,"
                ],
                [
                    "Christ,"
                ],
                [
                    "a",
                    "lone"
                ],
                [
                    "we"
                ],
                [
                    "know;"
                ],
                [
                    "to"
                ],
                [
                    "thee"
                ]
            ],
            [
                [
                    "We"
                ],
                [
                    "bend"
                ],
                [
                    "in"
                ],
                [
                    "pure"
                ],
                [
                    "sim",
                    "pli",
                    "ci",
                    "ty;"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "songs"
                ],
                [
                    "with"
                ],
                [
                    "tears"
                ],
                [
                    "to"
                ],
                [
                    "thee"
                ],
                [
                    "a",
                    "rise;"
                ]
            ],
            [
                [
                    "Prove"
                ],
                [
                    "thou"
                ],
                [
                    "our"
                ],
                [
                    "hearts"
                ],
                [
                    "with"
                ],
                [
                    "thy"
                ],
                [
                    "clear"
                ],
                [
                    "eyes."
                ]
            ],
            [
                [
                    "Though"
                ],
                [
                    "we"
                ],
                [
                    "be"
                ],
                [
                    "stained"
                ],
                [
                    "with"
                ],
                [
                    "blots"
                ],
                [
                    "with",
                    "in,"
                ]
            ],
            [
                [
                    "Thy"
                ],
                [
                    "quick'",
                    "ning"
                ],
                [
                    "rays"
                ],
                [
                    "shall"
                ],
                [
                    "purge"
                ],
                [
                    "our"
                ],
                [
                    "sin;"
                ]
            ],
            [
                [
                    "Light"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "Morn",
                    "ing"
                ],
                [
                    "Star,"
                ],
                [
                    "thy"
                ],
                [
                    "grace,"
                ]
            ],
            [
                [
                    "Shed"
                ],
                [
                    "on"
                ],
                [
                    "us"
                ],
                [
                    "from"
                ],
                [
                    "thy"
                ],
                [
                    "cloud",
                    "less"
                ],
                [
                    "face."
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "laud"
                ],
                [
                    "to"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "praise,"
                ],
                [
                    "e",
                    "ter",
                    "nal"
                ],
                [
                    "Son,"
                ],
                [
                    "to"
                ],
                [
                    "thee;"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry,"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "e",
                    "ver"
                ],
                [
                    "meet,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Pa",
                    "ra",
                    "clete."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "3",
                "4",
                "5",
                "6b",
                "5",
                "4",
                "5"
            ],
            [
                "5",
                "4",
                "7",
                "7",
                "4",
                "5",
                "6b",
                "54"
            ],
            [
                "5",
                "5",
                "4",
                "5",
                "4",
                "3",
                "2",
                "3"
            ],
            [
                "4",
                "5",
                "4",
                "3",
                "2",
                "34",
                "2",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "lo-golden-light-rekindles-day": {
        // thursday
        title: "Lux ecce surgit aurea",
        text: [
            [
                [
                    "LO!"
                ],
                [
                    "Gold",
                    "en"
                ],
                [
                    "light"
                ],
                [
                    "re",
                    "kin",
                    "dles"
                ],
                [
                    "day:"
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "pal",
                    "ing"
                ],
                [
                    "dark",
                    "ness"
                ],
                [
                    "steal"
                ],
                [
                    "a",
                    "way,"
                ]
            ],
            [
                [
                    "Which"
                ],
                [
                    "all"
                ],
                [
                    "too"
                ],
                [
                    "long"
                ],
                [
                    "o'er",
                    "whelm'd"
                ],
                [
                    "our"
                ],
                [
                    "gaze,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "led"
                ],
                [
                    "our"
                ],
                [
                    "steps"
                ],
                [
                    "by"
                ],
                [
                    "wind",
                    "ing"
                ],
                [
                    "ways."
                ]
            ],
            [
                [
                    "We"
                ],
                [
                    "pray"
                ],
                [
                    "thee,"
                ],
                [
                    "ris",
                    "ing"
                ],
                [
                    "Light"
                ],
                [
                    "se",
                    "rene,"
                ]
            ],
            [
                [
                    "Ev'n"
                ],
                [
                    "as"
                ],
                [
                    "thy",
                    "self"
                ],
                [
                    "our"
                ],
                [
                    "hearts"
                ],
                [
                    "make"
                ],
                [
                    "clean;"
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "no"
                ],
                [
                    "de",
                    "ceit"
                ],
                [
                    "our"
                ],
                [
                    "lips"
                ],
                [
                    "de",
                    "file,"
                ]
            ],
            [
                [
                    "Nor"
                ],
                [
                    "let"
                ],
                [
                    "our"
                ],
                [
                    "souls"
                ],
                [
                    "be"
                ],
                [
                    "vex'd"
                ],
                [
                    "by"
                ],
                [
                    "guile."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "keep"
                ],
                [
                    "us,"
                ],
                [
                    "as"
                ],
                [
                    "the"
                ],
                [
                    "hours"
                ],
                [
                    "pro",
                    "ceed,"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "ly",
                    "ing"
                ],
                [
                    "word"
                ],
                [
                    "and"
                ],
                [
                    "e",
                    "vil"
                ],
                [
                    "deed;"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "rov",
                    "ing"
                ],
                [
                    "eyes"
                ],
                [
                    "from"
                ],
                [
                    "sin"
                ],
                [
                    "set"
                ],
                [
                    "free,"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "bo",
                    "dy"
                ],
                [
                    "from"
                ],
                [
                    "im",
                    "pu",
                    "ri",
                    "ty."
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "thou"
                ],
                [
                    "dost"
                ],
                [
                    "from"
                ],
                [
                    "a",
                    "bove"
                ],
                [
                    "sur",
                    "vey"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "con",
                    "verse"
                ],
                [
                    "of"
                ],
                [
                    "each"
                ],
                [
                    "fleet",
                    "ing"
                ],
                [
                    "day;"
                ]
            ],
            [
                [
                    "Thou"
                ],
                [
                    "dost"
                ],
                [
                    "fore",
                    "see"
                ],
                [
                    "from"
                ],
                [
                    "morn",
                    "ing"
                ],
                [
                    "light"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "ev'",
                    "ry"
                ],
                [
                    "deed,"
                ],
                [
                    "un",
                    "til"
                ],
                [
                    "the"
                ],
                [
                    "night."
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "laud"
                ],
                [
                    "to"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "praise,"
                ],
                [
                    "e",
                    "ter",
                    "nal"
                ],
                [
                    "Son,"
                ],
                [
                    "to"
                ],
                [
                    "thee;"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry,"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "e",
                    "ver"
                ],
                [
                    "meet,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Pa",
                    "ra",
                    "clete."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "3",
                "4",
                "5",
                "6b",
                "5",
                "4",
                "5"
            ],
            [
                "5",
                "4",
                "7",
                "7",
                "4",
                "5",
                "6b",
                "54"
            ],
            [
                "5",
                "5",
                "4",
                "5",
                "4",
                "3",
                "2",
                "3"
            ],
            [
                "4",
                "5",
                "4",
                "3",
                "2",
                "34",
                "2",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "eternal-glory-of-the-sky": {
        // friday
        title: "Aeterna coeli gloria",
        text: [
            [
                [
                    "E",
                    "TER",
                    "NAL"
                ],
                [
                    "Glo",
                    "ry"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "sky,"
                ]
            ],
            [
                [
                    "Blest"
                ],
                [
                    "hope"
                ],
                [
                    "of"
                ],
                [
                    "frail"
                ],
                [
                    "hu",
                    "ma",
                    "ni",
                    "ty,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Fa",
                    "ther's"
                ],
                [
                    "sole-",
                    "be",
                    "got",
                    "ten"
                ],
                [
                    "One,"
                ]
            ],
            [
                [
                    "Yet"
                ],
                [
                    "born"
                ],
                [
                    "a"
                ],
                [
                    "spot",
                    "less"
                ],
                [
                    "Vir",
                    "gin's"
                ],
                [
                    "Son!"
                ]
            ],
            [
                [
                    "Up",
                    "lift"
                ],
                [
                    "us"
                ],
                [
                    "with"
                ],
                [
                    "thine"
                ],
                [
                    "arm"
                ],
                [
                    "of"
                ],
                [
                    "might,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "let"
                ],
                [
                    "our"
                ],
                [
                    "hearts"
                ],
                [
                    "rise"
                ],
                [
                    "pure"
                ],
                [
                    "and"
                ],
                [
                    "bright,"
                ]
            ],
            [
                [
                    "And,"
                ],
                [
                    "ar",
                    "dent"
                ],
                [
                    "in"
                ],
                [
                    "God's"
                ],
                [
                    "prais",
                    "es"
                ],
                [
                    "pay"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "thanks"
                ],
                [
                    "we"
                ],
                [
                    "owe"
                ],
                [
                    "him"
                ],
                [
                    "ev'",
                    "ry"
                ],
                [
                    "day."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "day-",
                    "star's"
                ],
                [
                    "rays"
                ],
                [
                    "are"
                ],
                [
                    "glitt",
                    "'ring"
                ],
                [
                    "clear,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "tell"
                ],
                [
                    "that"
                ],
                [
                    "day"
                ],
                [
                    "it",
                    "self"
                ],
                [
                    "is"
                ],
                [
                    "near:"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "sha",
                    "dows"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "night"
                ],
                [
                    "de",
                    "part;"
                ]
            ],
            [
                [
                    "Thou,"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Light,"
                ],
                [
                    "il",
                    "lume"
                ],
                [
                    "the"
                ],
                [
                    "heart!"
                ]
            ],
            [
                [
                    "With",
                    "in"
                ],
                [
                    "our"
                ],
                [
                    "sen",
                    "ses"
                ],
                [
                    "e",
                    "ver"
                ],
                [
                    "dwell,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "world",
                    "ly"
                ],
                [
                    "dark",
                    "ness"
                ],
                [
                    "thence"
                ],
                [
                    "ex",
                    "pel;"
                ]
            ],
            [
                [
                    "Long"
                ],
                [
                    "as"
                ],
                [
                    "the"
                ],
                [
                    "days"
                ],
                [
                    "of"
                ],
                [
                    "life"
                ],
                [
                    "en",
                    "dure,"
                ]
            ],
            [
                [
                    "Pre",
                    "serve"
                ],
                [
                    "our"
                ],
                [
                    "souls"
                ],
                [
                    "de",
                    "vout"
                ],
                [
                    "and"
                ],
                [
                    "pure."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "faith"
                ],
                [
                    "that"
                ],
                [
                    "first"
                ],
                [
                    "must"
                ],
                [
                    "be"
                ],
                [
                    "pos",
                    "sest,"
                ]
            ],
            [
                [
                    "Root"
                ],
                [
                    "deep"
                ],
                [
                    "with",
                    "in"
                ],
                [
                    "our"
                ],
                [
                    "in",
                    "most"
                ],
                [
                    "breast;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "joy",
                    "ous"
                ],
                [
                    "hope"
                ],
                [
                    "in"
                ],
                [
                    "se",
                    "cond"
                ],
                [
                    "place,"
                ]
            ],
            [
                [
                    "Then"
                ],
                [
                    "cha",
                    "ri",
                    "ty,"
                ],
                [
                    "thy"
                ],
                [
                    "great",
                    "est"
                ],
                [
                    "grace."
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "laud"
                ],
                [
                    "to"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "praise,"
                ],
                [
                    "e",
                    "ter",
                    "nal"
                ],
                [
                    "Son,"
                ],
                [
                    "to"
                ],
                [
                    "thee;"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry,"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "e",
                    "ver"
                ],
                [
                    "meet,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Pa",
                    "ra",
                    "clete."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "3",
                "4",
                "5",
                "6b",
                "5",
                "4",
                "5"
            ],
            [
                "5",
                "4",
                "7",
                "7",
                "4",
                "5",
                "6b",
                "54"
            ],
            [
                "5",
                "5",
                "4",
                "5",
                "4",
                "3",
                "2",
                "3"
            ],
            [
                "4",
                "5",
                "4",
                "3",
                "2",
                "34",
                "2",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "the-dawn-is-sprinkling-in-the-east": {
        // saturday
        title: "Aurora jam spargit polum",
        text: [
            [
                [
                    "DAWN"
                ],
                [
                    "sprin",
                    "kles"
                ],
                [
                    "all"
                ],
                [
                    "the"
                ],
                [
                    "East"
                ],
                [
                    "with"
                ],
                [
                    "light:"
                ]
            ],
            [
                [
                    "Day"
                ],
                [
                    "o\u2019er"
                ],
                [
                    "the"
                ],
                [
                    "earth"
                ],
                [
                    "is"
                ],
                [
                    "gli",
                    "ding"
                ],
                [
                    "bright:"
                ]
            ],
            [
                [
                    "Morn\u2019s"
                ],
                [
                    "glitt\u2019",
                    "ring"
                ],
                [
                    "rays"
                ],
                [
                    "their"
                ],
                [
                    "course"
                ],
                [
                    "be",
                    "gin;"
                ]
            ],
            [
                [
                    "Fare",
                    "well"
                ],
                [
                    "to"
                ],
                [
                    "dark",
                    "ness"
                ],
                [
                    "and"
                ],
                [
                    "to"
                ],
                [
                    "sin."
                ]
            ],
            [
                [
                    "Each"
                ],
                [
                    "phan",
                    "tom"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "night"
                ],
                [
                    "de",
                    "part,"
                ]
            ],
            [
                [
                    "Each"
                ],
                [
                    "thought"
                ],
                [
                    "of"
                ],
                [
                    "guilt"
                ],
                [
                    "for",
                    "sake"
                ],
                [
                    "the"
                ],
                [
                    "heart:"
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "ev\u2019",
                    "ry"
                ],
                [
                    "ill"
                ],
                [
                    "that"
                ],
                [
                    "dark",
                    "ness"
                ],
                [
                    "brought"
                ]
            ],
            [
                [
                    "Be",
                    "neath"
                ],
                [
                    "its"
                ],
                [
                    "shade,"
                ],
                [
                    "now"
                ],
                [
                    "come"
                ],
                [
                    "to"
                ],
                [
                    "nought."
                ]
            ],
            [
                [
                    "So"
                ],
                [
                    "that"
                ],
                [
                    "last"
                ],
                [
                    "morn",
                    "ing,"
                ],
                [
                    "dread"
                ],
                [
                    "and"
                ],
                [
                    "great,"
                ]
            ],
            [
                [
                    "Which"
                ],
                [
                    "we"
                ],
                [
                    "with"
                ],
                [
                    "tremb",
                    "ling"
                ],
                [
                    "hope"
                ],
                [
                    "a",
                    "wait,"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "bless",
                    "ed"
                ],
                [
                    "light"
                ],
                [
                    "for"
                ],
                [
                    "us"
                ],
                [
                    "shall"
                ],
                [
                    "glow,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "chant"
                ],
                [
                    "the"
                ],
                [
                    "song"
                ],
                [
                    "we"
                ],
                [
                    "sang"
                ],
                [
                    "be",
                    "low,\u2014"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "laud"
                ],
                [
                    "to"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "praise,"
                ],
                [
                    "e",
                    "ter",
                    "nal"
                ],
                [
                    "Son,"
                ],
                [
                    "to"
                ],
                [
                    "thee;"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry,"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "e",
                    "ver"
                ],
                [
                    "meet,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Pa",
                    "ra",
                    "clete."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "3",
                "4",
                "5",
                "6b",
                "5",
                "4",
                "5"
            ],
            [
                "5",
                "4",
                "7",
                "7",
                "4",
                "5",
                "6b",
                "54"
            ],
            [
                "5",
                "5",
                "4",
                "5",
                "4",
                "3",
                "2",
                "3"
            ],
            [
                "4",
                "5",
                "4",
                "3",
                "2",
                "34",
                "2",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "the-fast-as-taught-by-holy-lore": {
        // lent, evening until lent 3
        title: "Ex more docti mystico",
        text: [
            [
                [
                    "THE"
                ],
                [
                    "fast"
                ],
                [
                    "as"
                ],
                [
                    "taught"
                ],
                [
                    "by"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "lore,"
                ]
            ],
            [
                [
                    "We"
                ],
                [
                    "keep"
                ],
                [
                    "in"
                ],
                [
                    "so",
                    "lemn"
                ],
                [
                    "course"
                ],
                [
                    "once"
                ],
                [
                    "more:"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "fast"
                ],
                [
                    "to"
                ],
                [
                    "all"
                ],
                [
                    "men"
                ],
                [
                    "known,"
                ],
                [
                    "and"
                ],
                [
                    "bound"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "for",
                    "ty"
                ],
                [
                    "days"
                ],
                [
                    "of"
                ],
                [
                    "year",
                    "ly"
                ],
                [
                    "round."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "law"
                ],
                [
                    "and"
                ],
                [
                    "seers"
                ],
                [
                    "that"
                ],
                [
                    "were"
                ],
                [
                    "of"
                ],
                [
                    "old"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "di",
                    "verse"
                ],
                [
                    "ways"
                ],
                [
                    "this"
                ],
                [
                    "Lent"
                ],
                [
                    "fore",
                    "told,"
                ]
            ],
            [
                [
                    "Which"
                ],
                [
                    "Christ,"
                ],
                [
                    "all"
                ],
                [
                    "sea",
                    "sons'"
                ],
                [
                    "King"
                ],
                [
                    "and"
                ],
                [
                    "guide,"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "af",
                    "ter"
                ],
                [
                    "a",
                    "ges"
                ],
                [
                    "sanc",
                    "ti",
                    "fied."
                ]
            ],
            [
                [
                    "More"
                ],
                [
                    "spar",
                    "ing"
                ],
                [
                    "there",
                    "fore"
                ],
                [
                    "let"
                ],
                [
                    "us"
                ],
                [
                    "make"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "words"
                ],
                [
                    "we"
                ],
                [
                    "speak,"
                ],
                [
                    "the"
                ],
                [
                    "food"
                ],
                [
                    "we"
                ],
                [
                    "take,"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "sleep"
                ],
                [
                    "and"
                ],
                [
                    "mirth;"
                ],
                [
                    "and"
                ],
                [
                    "clo",
                    "ser"
                ],
                [
                    "barred"
                ]
            ],
            [
                [
                    "Be"
                ],
                [
                    "ev",
                    "ery"
                ],
                [
                    "sense"
                ],
                [
                    "in"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "guard."
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "prayer"
                ],
                [
                    "to",
                    "ge",
                    "ther"
                ],
                [
                    "let"
                ],
                [
                    "us"
                ],
                [
                    "fall,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "cry"
                ],
                [
                    "for"
                ],
                [
                    "mer",
                    "cy,"
                ],
                [
                    "one"
                ],
                [
                    "and"
                ],
                [
                    "all,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "weep"
                ],
                [
                    "be",
                    "fore"
                ],
                [
                    "the"
                ],
                [
                    "Judg",
                    "e's"
                ],
                [
                    "feet,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "his"
                ],
                [
                    "a",
                    "veng",
                    "ing"
                ],
                [
                    "wrath"
                ],
                [
                    "en",
                    "treat."
                ]
            ],
            [
                [
                    "Thy"
                ],
                [
                    "grace"
                ],
                [
                    "have"
                ],
                [
                    "we"
                ],
                [
                    "of",
                    "fen",
                    "ded"
                ],
                [
                    "sore,"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "sins,"
                ],
                [
                    "O"
                ],
                [
                    "God,"
                ],
                [
                    "which"
                ],
                [
                    "we"
                ],
                [
                    "de",
                    "plore;"
                ]
            ],
            [
                [
                    "But"
                ],
                [
                    "pour"
                ],
                [
                    "up",
                    "on"
                ],
                [
                    "us"
                ],
                [
                    "from"
                ],
                [
                    "on"
                ],
                [
                    "high,"
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "pard",
                    "'ning"
                ],
                [
                    "One,"
                ],
                [
                    "thy"
                ],
                [
                    "clem",
                    "en",
                    "cy."
                ]
            ],
            [
                [
                    "Re",
                    "mem",
                    "ber"
                ],
                [
                    "thou,"
                ],
                [
                    "though"
                ],
                [
                    "frail"
                ],
                [
                    "we"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "yet"
                ],
                [
                    "thine"
                ],
                [
                    "han",
                    "di",
                    "work"
                ],
                [
                    "are"
                ],
                [
                    "we;"
                ]
            ],
            [
                [
                    "Nor"
                ],
                [
                    "let"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "nour"
                ],
                [
                    "of"
                ],
                [
                    "thy"
                ],
                [
                    "name"
                ]
            ],
            [
                [
                    "Be"
                ],
                [
                    "by"
                ],
                [
                    "a",
                    "no",
                    "ther"
                ],
                [
                    "put"
                ],
                [
                    "to"
                ],
                [
                    "shame."
                ]
            ],
            [
                [
                    "For",
                    "give"
                ],
                [
                    "the"
                ],
                [
                    "sin"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "have"
                ],
                [
                    "wrought;"
                ]
            ],
            [
                [
                    "In",
                    "crease"
                ],
                [
                    "the"
                ],
                [
                    "good"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "have"
                ],
                [
                    "sought;"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "we"
                ],
                [
                    "at"
                ],
                [
                    "length,"
                ],
                [
                    "our"
                ],
                [
                    "wan",
                    "d'rings"
                ],
                [
                    "o'er,"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "please"
                ],
                [
                    "thee"
                ],
                [
                    "here"
                ],
                [
                    "and"
                ],
                [
                    "e",
                    "ver",
                    "more."
                ]
            ],
            [
                [
                    "We"
                ],
                [
                    "pray"
                ],
                [
                    "thee,"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Tri",
                    "ni",
                    "ty,"
                ]
            ],
            [
                [
                    "One"
                ],
                [
                    "God,"
                ],
                [
                    "un",
                    "chang",
                    "ing"
                ],
                [
                    "U",
                    "ni",
                    "ty,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "we"
                ],
                [
                    "from"
                ],
                [
                    "this"
                ],
                [
                    "our"
                ],
                [
                    "ab",
                    "sti",
                    "nence"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "reap"
                ],
                [
                    "the"
                ],
                [
                    "fruits"
                ],
                [
                    "of"
                ],
                [
                    "pe",
                    "ni",
                    "tence."
                ]
            ]
        ],
        tune: [
            [
                "4",
                "6",
                "67",
                "7",
                "65",
                "6",
                "6",
                "7"
            ],
            [
                "6",
                "4",
                "5",
                "6",
                "54",
                "3",
                "24",
                "4"
            ],
            [
                "4",
                "6",
                "67",
                "76",
                "43",
                "5",
                "43",
                "34"
            ],
            [
                "2",
                "54",
                "56",
                "54",
                "2",
                "45",
                "3",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "2"
    },
    "o-kind-creator-bow-thine-ear": {
        // lent, morning until lent 3
        title: "Audi, benigne Conditor",
        text: [
            [
                [
                    "O"
                ],
                [
                    "KIND"
                ],
                [
                    "Cre",
                    "a",
                    "tor,"
                ],
                [
                    "bow"
                ],
                [
                    "thine"
                ],
                [
                    "ear"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "mark"
                ],
                [
                    "the"
                ],
                [
                    "cry,"
                ],
                [
                    "to"
                ],
                [
                    "know"
                ],
                [
                    "the"
                ],
                [
                    "tear"
                ]
            ],
            [
                [
                    "Be",
                    "fore"
                ],
                [
                    "thy"
                ],
                [
                    "throne"
                ],
                [
                    "of"
                ],
                [
                    "mer",
                    "cy"
                ],
                [
                    "spent"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "this"
                ],
                [
                    "thy"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "fast"
                ],
                [
                    "of"
                ],
                [
                    "Lent."
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "hearts"
                ],
                [
                    "are"
                ],
                [
                    "op",
                    "en,"
                ],
                [
                    "Lord,"
                ],
                [
                    "to"
                ],
                [
                    "thee:"
                ]
            ],
            [
                [
                    "Thou"
                ],
                [
                    "know",
                    "est"
                ],
                [
                    "our"
                ],
                [
                    "in",
                    "fir",
                    "mi",
                    "ty;"
                ]
            ],
            [
                [
                    "Pour"
                ],
                [
                    "out"
                ],
                [
                    "on"
                ],
                [
                    "all"
                ],
                [
                    "who"
                ],
                [
                    "seek"
                ],
                [
                    "thy"
                ],
                [
                    "face"
                ]
            ],
            [
                [
                    "A",
                    "bun",
                    "dance"
                ],
                [
                    "of"
                ],
                [
                    "thy"
                ],
                [
                    "pard",
                    "'ning"
                ],
                [
                    "grace."
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "sins"
                ],
                [
                    "are"
                ],
                [
                    "ma",
                    "ny,"
                ],
                [
                    "this"
                ],
                [
                    "we"
                ],
                [
                    "know;"
                ]
            ],
            [
                [
                    "Spare"
                ],
                [
                    "us,"
                ],
                [
                    "good"
                ],
                [
                    "Lord,"
                ],
                [
                    "thy"
                ],
                [
                    "mer",
                    "cy"
                ],
                [
                    "show;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "for"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "nour"
                ],
                [
                    "of"
                ],
                [
                    "thy"
                ],
                [
                    "name"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "faint",
                    "ing"
                ],
                [
                    "souls"
                ],
                [
                    "to"
                ],
                [
                    "life"
                ],
                [
                    "re",
                    "claim."
                ]
            ],
            [
                [
                    "Give"
                ],
                [
                    "us"
                ],
                [
                    "the"
                ],
                [
                    "self-",
                    "con",
                    "trol"
                ],
                [
                    "that"
                ],
                [
                    "springs"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "di",
                    "sci",
                    "pline"
                ],
                [
                    "of"
                ],
                [
                    "out",
                    "ward"
                ],
                [
                    "things,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "fast",
                    "ing"
                ],
                [
                    "in",
                    "ward"
                ],
                [
                    "se",
                    "cret",
                    "ly"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "soul"
                ],
                [
                    "may"
                ],
                [
                    "pure",
                    "ly"
                ],
                [
                    "dwell"
                ],
                [
                    "with"
                ],
                [
                    "thee."
                ]
            ],
            [
                [
                    "We"
                ],
                [
                    "pray"
                ],
                [
                    "thee,"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Tri",
                    "ni",
                    "ty,"
                ]
            ],
            [
                [
                    "One"
                ],
                [
                    "God,"
                ],
                [
                    "un",
                    "chang",
                    "ing"
                ],
                [
                    "U",
                    "ni",
                    "ty,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "we"
                ],
                [
                    "from"
                ],
                [
                    "this"
                ],
                [
                    "our"
                ],
                [
                    "ab",
                    "sti",
                    "nence"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "reap"
                ],
                [
                    "the"
                ],
                [
                    "fruits"
                ],
                [
                    "of"
                ],
                [
                    "pe",
                    "ni",
                    "tence."
                ]
            ]
        ],
        tune: [
            [
                "32",
                "3",
                "54",
                "5",
                "34",
                "43",
                "23",
                "3"
            ],
            [
                "54",
                "56",
                "654",
                "3",
                "54",
                "34",
                "32",
                "2"
            ],
            [
                "2",
                "3",
                "4",
                "54",
                "3",
                "54",
                "56",
                "6"
            ],
            [
                "23",
                "56",
                "4",
                "54",
                "3",
                "43",
                "23",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "2"
    },
    "now-is-the-healing-time-decreed": {
        // lent, evening, lent 3 until passion sunday
        title: "Ecce tempus idoneum",
        text: [
            [
                [
                    "NOW"
                ],
                [
                    "is"
                ],
                [
                    "the"
                ],
                [
                    "heal",
                    "ing"
                ],
                [
                    "time"
                ],
                [
                    "de",
                    "creed"
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "sins"
                ],
                [
                    "of"
                ],
                [
                    "heart,"
                ],
                [
                    "of"
                ],
                [
                    "word"
                ],
                [
                    "or"
                ],
                [
                    "deed,"
                ]
            ],
            [
                [
                    "when"
                ],
                [
                    "we"
                ],
                [
                    "in"
                ],
                [
                    "hum",
                    "ble"
                ],
                [
                    "fear"
                ],
                [
                    "re",
                    "cord"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "wrong"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "have"
                ],
                [
                    "done"
                ],
                [
                    "the"
                ],
                [
                    "Lord;"
                ]
            ],
            [
                [
                    "Who,"
                ],
                [
                    "al",
                    "way"
                ],
                [
                    "mer",
                    "ci",
                    "ful"
                ],
                [
                    "and"
                ],
                [
                    "good,"
                ]
            ],
            [
                [
                    "Has"
                ],
                [
                    "borne"
                ],
                [
                    "so"
                ],
                [
                    "long"
                ],
                [
                    "our"
                ],
                [
                    "way",
                    "ward"
                ],
                [
                    "mood,"
                ]
            ],
            [
                [
                    "Nor"
                ],
                [
                    "cut"
                ],
                [
                    "us"
                ],
                [
                    "off"
                ],
                [
                    "un",
                    "spar",
                    "ing",
                    "ly"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "our"
                ],
                [
                    "so"
                ],
                [
                    "great"
                ],
                [
                    "i",
                    "ni",
                    "qui",
                    "ty."
                ]
            ],
            [
                [
                    "There",
                    "fore"
                ],
                [
                    "with"
                ],
                [
                    "fast",
                    "ing"
                ],
                [
                    "and"
                ],
                [
                    "with"
                ],
                [
                    "prayer,"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "sec",
                    "ret"
                ],
                [
                    "sor",
                    "row"
                ],
                [
                    "we"
                ],
                [
                    "de",
                    "clare;"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "all"
                ],
                [
                    "good"
                ],
                [
                    "striv",
                    "ing"
                ],
                [
                    "seek"
                ],
                [
                    "his"
                ],
                [
                    "face,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "low",
                    "ly"
                ],
                [
                    "hear",
                    "ted"
                ],
                [
                    "plead"
                ],
                [
                    "for"
                ],
                [
                    "grace."
                ]
            ],
            [
                [
                    "Cleanse"
                ],
                [
                    "us,"
                ],
                [
                    "O"
                ],
                [
                    "Lord,"
                ],
                [
                    "from"
                ],
                [
                    "ev",
                    "'ry"
                ],
                [
                    "stain,"
                ]
            ],
            [
                [
                    "Help"
                ],
                [
                    "us"
                ],
                [
                    "the"
                ],
                [
                    "meed"
                ],
                [
                    "of"
                ],
                [
                    "praise"
                ],
                [
                    "to"
                ],
                [
                    "gain,"
                ]
            ],
            [
                [
                    "Till"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "An",
                    "gels"
                ],
                [
                    "linked"
                ],
                [
                    "in"
                ],
                [
                    "love"
                ]
            ],
            [
                [
                    "Joy",
                    "ful"
                ],
                [
                    "we"
                ],
                [
                    "tread"
                ],
                [
                    "thy"
                ],
                [
                    "courts"
                ],
                [
                    "a",
                    "bove."
                ]
            ],
            [
                [
                    "Fa",
                    "ther"
                ],
                [
                    "and"
                ],
                [
                    "Son"
                ],
                [
                    "and"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "blest,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "thee"
                ],
                [
                    "be"
                ],
                [
                    "ev",
                    "'ry"
                ],
                [
                    "prayer"
                ],
                [
                    "ad",
                    "drest,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "art"
                ],
                [
                    "in"
                ],
                [
                    "three",
                    "fold"
                ],
                [
                    "Name"
                ],
                [
                    "a",
                    "dored,"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "age"
                ],
                [
                    "to"
                ],
                [
                    "age,"
                ],
                [
                    "the"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Lord."
                ]
            ]
        ],
        tune: [
            [
                "4",
                "56",
                "65",
                "7",
                "65",
                "4",
                "5",
                "6"
            ],
            [
                "4",
                "6",
                "4",
                "5",
                "2",
                "3",
                "2",
                "1"
            ],
            [
                "4",
                "6",
                "5",
                "7",
                "8",
                "7",
                "65",
                "4"
            ],
            [
                "57",
                "4",
                "5",
                "3",
                "45",
                "4",
                "32",
                "2"
            ]
        ],
        amen: [
            "23",
            "212"
        ],
        clef: "c7",
        tone: "3"
    },
    "the-glory-of-these-forty-days": {
        // lent, morning, lent 3 until lent 5
        title: "Clarum decus jejunii",
        text: [
            [
                [
                    "THE"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "of"
                ],
                [
                    "these"
                ],
                [
                    "for",
                    "ty"
                ],
                [
                    "days"
                ]
            ],
            [
                [
                    "We"
                ],
                [
                    "ce",
                    "le",
                    "brate"
                ],
                [
                    "with"
                ],
                [
                    "songs"
                ],
                [
                    "of"
                ],
                [
                    "praise;"
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "Christ,"
                ],
                [
                    "by"
                ],
                [
                    "whom"
                ],
                [
                    "all"
                ],
                [
                    "things"
                ],
                [
                    "were"
                ],
                [
                    "made,"
                ]
            ],
            [
                [
                    "Him",
                    "self"
                ],
                [
                    "has"
                ],
                [
                    "fast",
                    "ed"
                ],
                [
                    "and"
                ],
                [
                    "has"
                ],
                [
                    "prayed."
                ]
            ],
            [
                [
                    "A",
                    "lone"
                ],
                [
                    "and"
                ],
                [
                    "fast",
                    "ing"
                ],
                [
                    "Mo",
                    "ses"
                ],
                [
                    "saw"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "lov",
                    "ing"
                ],
                [
                    "God"
                ],
                [
                    "who"
                ],
                [
                    "gave"
                ],
                [
                    "the"
                ],
                [
                    "Law;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "to"
                ],
                [
                    "E",
                    "li",
                    "jah,"
                ],
                [
                    "fast",
                    "ing,"
                ],
                [
                    "came"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "steeds"
                ],
                [
                    "and"
                ],
                [
                    "cha",
                    "ri",
                    "ots"
                ],
                [
                    "of"
                ],
                [
                    "flame."
                ]
            ],
            [
                [
                    "So"
                ],
                [
                    "Dan",
                    "iel"
                ],
                [
                    "trained"
                ],
                [
                    "his"
                ],
                [
                    "mys",
                    "tic"
                ],
                [
                    "sight,"
                ]
            ],
            [
                [
                    "De",
                    "li",
                    "vered"
                ],
                [
                    "from"
                ],
                [
                    "the"
                ],
                [
                    "li",
                    "ons"
                ],
                [
                    "might;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "John,"
                ],
                [
                    "the"
                ],
                [
                    "bride",
                    "groom's"
                ],
                [
                    "friend,"
                ],
                [
                    "be",
                    "came"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "he",
                    "rald"
                ],
                [
                    "of"
                ],
                [
                    "Mes",
                    "si",
                    "ah's"
                ],
                [
                    "name."
                ]
            ],
            [
                [
                    "Then"
                ],
                [
                    "grant"
                ],
                [
                    "us,"
                ],
                [
                    "Lord,"
                ],
                [
                    "like"
                ],
                [
                    "them"
                ],
                [
                    "to"
                ],
                [
                    "be"
                ]
            ],
            [
                [
                    "Full"
                ],
                [
                    "oft"
                ],
                [
                    "in"
                ],
                [
                    "fast"
                ],
                [
                    "and"
                ],
                [
                    "prayer"
                ],
                [
                    "with"
                ],
                [
                    "thee;"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "spi",
                    "rits"
                ],
                [
                    "strength",
                    "ened"
                ],
                [
                    "with"
                ],
                [
                    "thy"
                ],
                [
                    "grace,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "give"
                ],
                [
                    "us"
                ],
                [
                    "joy"
                ],
                [
                    "to"
                ],
                [
                    "see"
                ],
                [
                    "thy"
                ],
                [
                    "face."
                ]
            ],
            [
                [
                    "Fa",
                    "ther"
                ],
                [
                    "and"
                ],
                [
                    "Son"
                ],
                [
                    "and"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "blest,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "thee"
                ],
                [
                    "be"
                ],
                [
                    "ev",
                    "'ry"
                ],
                [
                    "prayer"
                ],
                [
                    "ad",
                    "drest,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "art"
                ],
                [
                    "in"
                ],
                [
                    "three",
                    "fold"
                ],
                [
                    "Name"
                ],
                [
                    "a",
                    "dored,"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "age"
                ],
                [
                    "to"
                ],
                [
                    "age,"
                ],
                [
                    "the"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Lord."
                ]
            ]
        ],
        tune: [
            [
                "23",
                "3",
                "35",
                "2",
                "35",
                "54",
                "34",
                "4"
            ],
            [
                "6",
                "54",
                "3",
                "4",
                "54",
                "3",
                "23",
                "3"
            ],
            [
                "36",
                "3",
                "36",
                "5",
                "54",
                "34",
                "32",
                "2"
            ],
            [
                "2",
                "3",
                "4",
                "54",
                "3",
                "43",
                "23",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "2"
    },
    "o-jesus-christ-from-thee-began": {
        // lent, morning, from lent 3 to lent 5
        title: "Jesu quadragenariae",
        text: [
            [
                [
                    "O"
                ],
                [
                    "JE",
                    "SUS"
                ],
                [
                    "Christ,"
                ],
                [
                    "from"
                ],
                [
                    "thee"
                ],
                [
                    "be",
                    "gan"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "heal",
                    "ing"
                ],
                [
                    "for"
                ],
                [
                    "the"
                ],
                [
                    "soul"
                ],
                [
                    "of"
                ],
                [
                    "man"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "fast",
                    "ing"
                ],
                [
                    "sought,"
                ],
                [
                    "by"
                ],
                [
                    "fast",
                    "ing"
                ],
                [
                    "found,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "for",
                    "ty"
                ],
                [
                    "days"
                ],
                [
                    "of"
                ],
                [
                    "year",
                    "ly"
                ],
                [
                    "round;"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "he"
                ],
                [
                    "who"
                ],
                [
                    "fell"
                ],
                [
                    "from"
                ],
                [
                    "high"
                ],
                [
                    "delight,"
                ]
            ],
            [
                [
                    "Borne"
                ],
                [
                    "down"
                ],
                [
                    "to"
                ],
                [
                    "sen",
                    "sual"
                ],
                [
                    "ap",
                    "pe",
                    "tite,"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "dint"
                ],
                [
                    "of"
                ],
                [
                    "stern"
                ],
                [
                    "con",
                    "trol"
                ],
                [
                    "may"
                ],
                [
                    "rise"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "climb"
                ],
                [
                    "the"
                ],
                [
                    "hills"
                ],
                [
                    "of"
                ],
                [
                    "Pa",
                    "ra",
                    "dise."
                ]
            ],
            [
                [
                    "There",
                    "fore"
                ],
                [
                    "be",
                    "hold"
                ],
                [
                    "thy"
                ],
                [
                    "Church,"
                ],
                [
                    "O"
                ],
                [
                    "Lord,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "grace"
                ],
                [
                    "of"
                ],
                [
                    "pe",
                    "ni",
                    "tence"
                ],
                [
                    "ac",
                    "cord"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "all"
                ],
                [
                    "who"
                ],
                [
                    "seek"
                ],
                [
                    "with"
                ],
                [
                    "gen",
                    "'rous"
                ],
                [
                    "tears"
                ]
            ],
            [
                [
                    "Re",
                    "ne",
                    "wal"
                ],
                [
                    "of"
                ],
                [
                    "their"
                ],
                [
                    "was",
                    "ted"
                ],
                [
                    "years."
                ]
            ],
            [
                [
                    "For",
                    "give"
                ],
                [
                    "the"
                ],
                [
                    "sin"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "have"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "For",
                    "give"
                ],
                [
                    "the"
                ],
                [
                    "course"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "have"
                ],
                [
                    "run,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "show"
                ],
                [
                    "hence",
                    "forth"
                ],
                [
                    "in"
                ],
                [
                    "e",
                    "vil"
                ],
                [
                    "day"
                ]
            ],
            [
                [
                    "Thy",
                    "self"
                ],
                [
                    "our"
                ],
                [
                    "suc",
                    "cour"
                ],
                [
                    "and"
                ],
                [
                    "our"
                ],
                [
                    "stay."
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "now"
                ],
                [
                    "let"
                ],
                [
                    "ev",
                    "'ry"
                ],
                [
                    "heart"
                ],
                [
                    "pre",
                    "pare,"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "sac",
                    "ri",
                    "fice"
                ],
                [
                    "of"
                ],
                [
                    "fast"
                ],
                [
                    "and"
                ],
                [
                    "prayer,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "keep"
                ],
                [
                    "with"
                ],
                [
                    "joy"
                ],
                [
                    "mag",
                    "ni",
                    "fi",
                    "cal"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "so",
                    "lemn"
                ],
                [
                    "Eas",
                    "ter"
                ],
                [
                    "fes",
                    "ti",
                    "val."
                ]
            ],
            [
                [
                    "Fa",
                    "ther"
                ],
                [
                    "and"
                ],
                [
                    "Son"
                ],
                [
                    "and"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "blest,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "thee"
                ],
                [
                    "be"
                ],
                [
                    "ev",
                    "'ry"
                ],
                [
                    "prayer"
                ],
                [
                    "ad",
                    "drest,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "art"
                ],
                [
                    "in"
                ],
                [
                    "three",
                    "fold"
                ],
                [
                    "Name"
                ],
                [
                    "a",
                    "dored,"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "age"
                ],
                [
                    "to"
                ],
                [
                    "age,"
                ],
                [
                    "the"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Lord."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "2345",
                "4",
                "31",
                "3",
                "23",
                "2",
                "2"
            ],
            [
                "4",
                "56",
                "5",
                "43",
                "4",
                "43",
                "2",
                "21"
            ],
            [
                "01",
                "1",
                "10",
                "1",
                "3",
                "12",
                "2",
                "2"
            ],
            [
                "4",
                "45",
                "4",
                "31",
                "3",
                "23",
                "2",
                "2"
            ]
        ],
        amen: [
            "23",
            "212"
        ],
        clef: "c7",
        tone: "4"
    },
    "the-royal-banners-forward-go": {
        // passiontide, evening
        title: "Vexilla Regis prodeunt",
        text: [
            [
                [
                    "THE"
                ],
                [
                    "roy",
                    "al"
                ],
                [
                    "ban",
                    "ners"
                ],
                [
                    "for",
                    "ward"
                ],
                [
                    "go;"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Cross"
                ],
                [
                    "shines"
                ],
                [
                    "forth"
                ],
                [
                    "in"
                ],
                [
                    "my",
                    "stic"
                ],
                [
                    "glow;"
                ]
            ],
            [
                [
                    "Where"
                ],
                [
                    "he"
                ],
                [
                    "in"
                ],
                [
                    "flesh,"
                ],
                [
                    "our"
                ],
                [
                    "flesh"
                ],
                [
                    "who"
                ],
                [
                    "made,"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "sen",
                    "tence"
                ],
                [
                    "bore,"
                ],
                [
                    "our"
                ],
                [
                    "ran",
                    "som"
                ],
                [
                    "paid:"
                ]
            ],
            [
                [
                    "Where"
                ],
                [
                    "deep"
                ],
                [
                    "for"
                ],
                [
                    "us"
                ],
                [
                    "the"
                ],
                [
                    "spear"
                ],
                [
                    "was"
                ],
                [
                    "dyed,"
                ]
            ],
            [
                [
                    "Life's"
                ],
                [
                    "tor",
                    "rent"
                ],
                [
                    "rush",
                    "ing"
                ],
                [
                    "from"
                ],
                [
                    "his"
                ],
                [
                    "side,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "wash"
                ],
                [
                    "us"
                ],
                [
                    "in"
                ],
                [
                    "that"
                ],
                [
                    "pre",
                    "cious"
                ],
                [
                    "flood,"
                ]
            ],
            [
                [
                    "Where"
                ],
                [
                    "ming",
                    "led"
                ],
                [
                    "Wa",
                    "ter"
                ],
                [
                    "flowed,"
                ],
                [
                    "and"
                ],
                [
                    "Blood."
                ]
            ],
            [
                [
                    "Ful",
                    "filled"
                ],
                [
                    "is"
                ],
                [
                    "all"
                ],
                [
                    "that"
                ],
                [
                    "Da",
                    "vid"
                ],
                [
                    "told"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "true"
                ],
                [
                    "pro",
                    "phe",
                    "tic"
                ],
                [
                    "song"
                ],
                [
                    "of"
                ],
                [
                    "old;"
                ]
            ],
            [
                [
                    "A",
                    "midst"
                ],
                [
                    "the"
                ],
                [
                    "na",
                    "tions,"
                ],
                [
                    "God,"
                ],
                [
                    "saith"
                ],
                [
                    "he,"
                ]
            ],
            [
                [
                    "Hath"
                ],
                [
                    "reigned"
                ],
                [
                    "and"
                ],
                [
                    "tri",
                    "umphed"
                ],
                [
                    "from"
                ],
                [
                    "the"
                ],
                [
                    "tree."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Tree"
                ],
                [
                    "of"
                ],
                [
                    "beau",
                    "ty,"
                ],
                [
                    "Tree"
                ],
                [
                    "of"
                ],
                [
                    "light!"
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Tree"
                ],
                [
                    "with"
                ],
                [
                    "roy",
                    "al"
                ],
                [
                    "pur",
                    "ple"
                ],
                [
                    "dight!"
                ]
            ],
            [
                [
                    "E",
                    "lect"
                ],
                [
                    "on"
                ],
                [
                    "whose"
                ],
                [
                    "tri",
                    "umph",
                    "al"
                ],
                [
                    "breast"
                ]
            ],
            [
                [
                    "Those"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "limbs"
                ],
                [
                    "should"
                ],
                [
                    "find"
                ],
                [
                    "their"
                ],
                [
                    "rest:"
                ]
            ],
            [
                [
                    "On"
                ],
                [
                    "whose"
                ],
                [
                    "dear"
                ],
                [
                    "arms,"
                ],
                [
                    "so"
                ],
                [
                    "wide",
                    "ly"
                ],
                [
                    "flung,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "weight"
                ],
                [
                    "of"
                ],
                [
                    "this"
                ],
                [
                    "world's"
                ],
                [
                    "ran",
                    "som"
                ],
                [
                    "hung;"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "price"
                ],
                [
                    "of"
                ],
                [
                    "hu",
                    "man",
                    "kind"
                ],
                [
                    "to"
                ],
                [
                    "pay,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "spoil"
                ],
                [
                    "the"
                ],
                [
                    "spoil",
                    "er"
                ],
                [
                    "of"
                ],
                [
                    "his"
                ],
                [
                    "prey."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Cross,"
                ],
                [
                    "our"
                ],
                [
                    "one"
                ],
                [
                    "re",
                    "li",
                    "ance"
                ],
                [
                    "hail!"
                ]
            ],
            [
                [
                    "So"
                ],
                [
                    "may"
                ],
                [
                    "thy"
                ],
                [
                    "pow'r"
                ],
                [
                    "with"
                ],
                [
                    "us"
                ],
                [
                    "av",
                    "ail"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "give"
                ],
                [
                    "new"
                ],
                [
                    "vir",
                    "tue"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "saint,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "par",
                    "don"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "pe",
                    "ni",
                    "tent."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "thee,"
                ],
                [
                    "e",
                    "ter",
                    "al"
                ],
                [
                    "Three"
                ],
                [
                    "in"
                ],
                [
                    "One,"
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "ho",
                    "mage"
                ],
                [
                    "meet"
                ],
                [
                    "by"
                ],
                [
                    "all"
                ],
                [
                    "be"
                ],
                [
                    "done:"
                ]
            ],
            [
                [
                    "Whom"
                ],
                [
                    "by"
                ],
                [
                    "the"
                ],
                [
                    "Cross"
                ],
                [
                    "thou"
                ],
                [
                    "dost"
                ],
                [
                    "re",
                    "store,"
                ]
            ],
            [
                [
                    "Pre",
                    "serve"
                ],
                [
                    "and"
                ],
                [
                    "gov",
                    "ern"
                ],
                [
                    "ev",
                    "er",
                    "more."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "46b",
                "6b",
                "543",
                "4",
                "454",
                "3",
                "21"
            ],
            [
                "4",
                "4",
                "5",
                "321",
                "3",
                "23",
                "10",
                "01"
            ],
            [
                "1",
                "1",
                "3",
                "10",
                "3",
                "345",
                "4",
                "43"
            ],
            [
                "3",
                "356b54",
                "5",
                "321",
                "3",
                "23",
                "10",
                "01"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "sing-my-tongue-the-glorious-battle": {
        // passiontide, morning
        title: "Pange lingua gloriosi lauream certaminus",
        text: [
            [
                [
                    "SING,"
                ],
                [
                    "my"
                ],
                [
                    "tongue,"
                ],
                [
                    "the"
                ],
                [
                    "glor",
                    "ious"
                ],
                [
                    "bat",
                    "tle,"
                ]
            ],
            [
                [
                    "Sing"
                ],
                [
                    "the"
                ],
                [
                    "end",
                    "ing"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "fray;"
                ]
            ],
            [
                [
                    "Now"
                ],
                [
                    "a",
                    "bove"
                ],
                [
                    "the"
                ],
                [
                    "Cross,"
                ],
                [
                    "the"
                ],
                [
                    "tro",
                    "phy,"
                ]
            ],
            [
                [
                    "Sound"
                ],
                [
                    "the"
                ],
                [
                    "loud"
                ],
                [
                    "tri",
                    "umph",
                    "ant"
                ],
                [
                    "lay:"
                ]
            ],
            [
                [
                    "Tell"
                ],
                [
                    "how"
                ],
                [
                    "Christ,"
                ],
                [
                    "the"
                ],
                [
                    "world's"
                ],
                [
                    "Re",
                    "dee",
                    "mer,"
                ]
            ],
            [
                [
                    "As"
                ],
                [
                    "a"
                ],
                [
                    "Vic",
                    "tim"
                ],
                [
                    "won"
                ],
                [
                    "the"
                ],
                [
                    "day."
                ]
            ],
            [
                [
                    "God"
                ],
                [
                    "in"
                ],
                [
                    "pi",
                    "ty"
                ],
                [
                    "saw"
                ],
                [
                    "man"
                ],
                [
                    "fall",
                    "en,"
                ]
            ],
            [
                [
                    "Shamed"
                ],
                [
                    "and"
                ],
                [
                    "sunk"
                ],
                [
                    "in"
                ],
                [
                    "mi",
                    "se",
                    "ry,"
                ]
            ],
            [
                [
                    "When"
                ],
                [
                    "he"
                ],
                [
                    "fell"
                ],
                [
                    "on"
                ],
                [
                    "death"
                ],
                [
                    "by"
                ],
                [
                    "tast",
                    "ing"
                ]
            ],
            [
                [
                    "Fruit"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "for",
                    "bid",
                    "den"
                ],
                [
                    "tree;"
                ]
            ],
            [
                [
                    "Then"
                ],
                [
                    "a",
                    "no",
                    "ther"
                ],
                [
                    "tree"
                ],
                [
                    "was"
                ],
                [
                    "cho",
                    "sen"
                ]
            ],
            [
                [
                    "Which"
                ],
                [
                    "the"
                ],
                [
                    "world"
                ],
                [
                    "from"
                ],
                [
                    "death"
                ],
                [
                    "should"
                ],
                [
                    "free."
                ]
            ],
            [
                [
                    "Thus"
                ],
                [
                    "the"
                ],
                [
                    "scheme"
                ],
                [
                    "of"
                ],
                [
                    "our"
                ],
                [
                    "sal",
                    "va",
                    "tion"
                ]
            ],
            [
                [
                    "Was"
                ],
                [
                    "of"
                ],
                [
                    "old"
                ],
                [
                    "in"
                ],
                [
                    "or",
                    "der"
                ],
                [
                    "laid,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "the"
                ],
                [
                    "ma",
                    "ni",
                    "fold"
                ],
                [
                    "de",
                    "cei",
                    "ver's"
                ]
            ],
            [
                [
                    "Art"
                ],
                [
                    "by"
                ],
                [
                    "art"
                ],
                [
                    "might"
                ],
                [
                    "be"
                ],
                [
                    "out",
                    "weighed,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "the"
                ],
                [
                    "lure"
                ],
                [
                    "the"
                ],
                [
                    "foe"
                ],
                [
                    "put"
                ],
                [
                    "for",
                    "ward"
                ]
            ],
            [
                [
                    "In",
                    "to"
                ],
                [
                    "means"
                ],
                [
                    "of"
                ],
                [
                    "heal",
                    "ing"
                ],
                [
                    "made."
                ]
            ],
            [
                [
                    "There",
                    "fore"
                ],
                [
                    "when"
                ],
                [
                    "the-",
                    "appoint",
                    "ed"
                ],
                [
                    "full",
                    "ness"
                ]
            ],
            [
                [
                    "Of"
                ],
                [
                    "the"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "time"
                ],
                [
                    "was"
                ],
                [
                    "come,"
                ]
            ],
            [
                [
                    "He"
                ],
                [
                    "was"
                ],
                [
                    "sent"
                ],
                [
                    "who"
                ],
                [
                    "mak",
                    "eth"
                ],
                [
                    "all"
                ],
                [
                    "things"
                ]
            ],
            [
                [
                    "Forth"
                ],
                [
                    "from"
                ],
                [
                    "God's"
                ],
                [
                    "et",
                    "er",
                    "nal"
                ],
                [
                    "home;"
                ]
            ],
            [
                [
                    "Thus"
                ],
                [
                    "he"
                ],
                [
                    "came"
                ],
                [
                    "to"
                ],
                [
                    "earth"
                ],
                [
                    "in",
                    "car",
                    "nate,"
                ]
            ],
            [
                [
                    "Off",
                    "spring"
                ],
                [
                    "of"
                ],
                [
                    "a"
                ],
                [
                    "maid",
                    "en's"
                ],
                [
                    "womb."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "the"
                ],
                [
                    "Tri",
                    "ni",
                    "ty"
                ],
                [
                    "be"
                ],
                [
                    "glo",
                    "ry"
                ]
            ],
            [
                [
                    "Ev",
                    "er",
                    "last",
                    "ing"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "meet;"
                ]
            ],
            [
                [
                    "E",
                    "qual"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "e",
                    "qual"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "the"
                ],
                [
                    "Son"
                ],
                [
                    "and"
                ],
                [
                    "Pa",
                    "ra",
                    "clete:"
                ]
            ],
            [
                [
                    "Tri",
                    "nal"
                ],
                [
                    "U",
                    "ni",
                    "ty,"
                ],
                [
                    "whose"
                ],
                [
                    "prai",
                    "ses"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "cre",
                    "a",
                    "ted"
                ],
                [
                    "things"
                ],
                [
                    "re",
                    "peat."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "3",
                "3",
                "2",
                "5",
                "5",
                "68",
                "8"
            ],
            [
                "89",
                "8",
                "8",
                "8",
                "6",
                "8",
                "765"
            ],
            [
                "5",
                "6",
                "8",
                "7",
                "6",
                "5",
                "6",
                "6"
            ],
            [
                "6",
                "7",
                "5",
                "4",
                "3",
                "6",
                "62"
            ],
            [
                "5",
                "5",
                "5",
                "3",
                "5",
                "6",
                "6",
                "5"
            ],
            [
                "6",
                "7",
                "5",
                "65",
                "4b",
                "2",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "c5",
        tone: "3"
    },
    "thirty-years-among-us-dwelling": {
        // passiontide, morning
        title: "Lustra sex qui jam peracts",
        text: [
            [
                [
                    "THIR",
                    "TY"
                ],
                [
                    "years"
                ],
                [
                    "a",
                    "mong"
                ],
                [
                    "us"
                ],
                [
                    "dwell",
                    "ing,"
                ]
            ],
            [
                [
                    "His"
                ],
                [
                    "ap",
                    "poin",
                    "ted"
                ],
                [
                    "time"
                ],
                [
                    "ful",
                    "filled,"
                ]
            ],
            [
                [
                    "Born"
                ],
                [
                    "for"
                ],
                [
                    "this,"
                ],
                [
                    "he"
                ],
                [
                    "meets"
                ],
                [
                    "his"
                ],
                [
                    "Pass",
                    "ion,"
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "that"
                ],
                [
                    "this"
                ],
                [
                    "he"
                ],
                [
                    "free",
                    "ly"
                ],
                [
                    "willed,"
                ]
            ],
            [
                [
                    "On"
                ],
                [
                    "the"
                ],
                [
                    "Cross"
                ],
                [
                    "the"
                ],
                [
                    "Lamb"
                ],
                [
                    "is"
                ],
                [
                    "lift",
                    "ed"
                ]
            ],
            [
                [
                    "Where"
                ],
                [
                    "his"
                ],
                [
                    "life-",
                    "blood"
                ],
                [
                    "shall"
                ],
                [
                    "be"
                ],
                [
                    "spilled."
                ]
            ],
            [
                [
                    "He"
                ],
                [
                    "en",
                    "dured"
                ],
                [
                    "the"
                ],
                [
                    "nails,"
                ],
                [
                    "the"
                ],
                [
                    "spit",
                    "ting,"
                ]
            ],
            [
                [
                    "Vi",
                    "ne",
                    "gar,"
                ],
                [
                    "and"
                ],
                [
                    "spear,"
                ],
                [
                    "and"
                ],
                [
                    "reed;"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "that"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Bo",
                    "dy"
                ],
                [
                    "bro",
                    "ken"
                ]
            ],
            [
                [
                    "Blood"
                ],
                [
                    "and"
                ],
                [
                    "wa",
                    "ter"
                ],
                [
                    "forth"
                ],
                [
                    "pro",
                    "ceed;"
                ]
            ],
            [
                [
                    "Earth,"
                ],
                [
                    "and"
                ],
                [
                    "stars,"
                ],
                [
                    "and"
                ],
                [
                    "sky,"
                ],
                [
                    "and"
                ],
                [
                    "o",
                    "cean"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "that"
                ],
                [
                    "flood"
                ],
                [
                    "from"
                ],
                [
                    "stain"
                ],
                [
                    "are"
                ],
                [
                    "freed."
                ]
            ],
            [
                [
                    "Faith",
                    "ful"
                ],
                [
                    "Cross!"
                ],
                [
                    "A",
                    "bove"
                ],
                [
                    "all"
                ],
                [
                    "o",
                    "ther,"
                ]
            ],
            [
                [
                    "One"
                ],
                [
                    "and"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "no",
                    "ble"
                ],
                [
                    "tree!"
                ]
            ],
            [
                [
                    "None"
                ],
                [
                    "in"
                ],
                [
                    "fol",
                    "iage,"
                ],
                [
                    "none"
                ],
                [
                    "in"
                ],
                [
                    "bloss",
                    "om,"
                ]
            ],
            [
                [
                    "None"
                ],
                [
                    "in"
                ],
                [
                    "fruit"
                ],
                [
                    "thy"
                ],
                [
                    "peer"
                ],
                [
                    "may"
                ],
                [
                    "be;"
                ]
            ],
            [
                [
                    "Sweet",
                    "est"
                ],
                [
                    "wood"
                ],
                [
                    "and"
                ],
                [
                    "sweet",
                    "est"
                ],
                [
                    "i",
                    "ron!"
                ]
            ],
            [
                [
                    "Sweet",
                    "est"
                ],
                [
                    "weight"
                ],
                [
                    "is"
                ],
                [
                    "hung"
                ],
                [
                    "on"
                ],
                [
                    "thee."
                ]
            ],
            [
                [
                    "Bend"
                ],
                [
                    "thy"
                ],
                [
                    "boughs,"
                ],
                [
                    "O"
                ],
                [
                    "Tree"
                ],
                [
                    "of"
                ],
                [
                    "Glo",
                    "ry!"
                ]
            ],
            [
                [
                    "Thy"
                ],
                [
                    "re",
                    "lax",
                    "ing"
                ],
                [
                    "sin",
                    "ews"
                ],
                [
                    "bend;"
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "a",
                    "wile"
                ],
                [
                    "the"
                ],
                [
                    "an",
                    "cient"
                ],
                [
                    "rig",
                    "our"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "thy"
                ],
                [
                    "birth"
                ],
                [
                    "be",
                    "stowed,"
                ],
                [
                    "sus",
                    "pend;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "the"
                ],
                [
                    "King"
                ],
                [
                    "of"
                ],
                [
                    "heav'n",
                    "ly"
                ],
                [
                    "beau",
                    "ty"
                ]
            ],
            [
                [
                    "On"
                ],
                [
                    "thy"
                ],
                [
                    "bo",
                    "som"
                ],
                [
                    "gent",
                    "ly"
                ],
                [
                    "tend!"
                ]
            ],
            [
                [
                    "Thou"
                ],
                [
                    "a",
                    "lone"
                ],
                [
                    "wast"
                ],
                [
                    "count",
                    "ed"
                ],
                [
                    "wor",
                    "thy"
                ]
            ],
            [
                [
                    "This"
                ],
                [
                    "world's"
                ],
                [
                    "ran",
                    "som"
                ],
                [
                    "to"
                ],
                [
                    "up",
                    "hold;"
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "a"
                ],
                [
                    "ship",
                    "wreck'd"
                ],
                [
                    "race"
                ],
                [
                    "pre",
                    "par",
                    "ing"
                ]
            ],
            [
                [
                    "Har",
                    "bour,"
                ],
                [
                    "like"
                ],
                [
                    "the"
                ],
                [
                    "Ark"
                ],
                [
                    "of"
                ],
                [
                    "old;"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "the"
                ],
                [
                    "sa",
                    "cred"
                ],
                [
                    "Blood"
                ],
                [
                    "a",
                    "noin",
                    "ted"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "the"
                ],
                [
                    "smit",
                    "ten"
                ],
                [
                    "Lamb"
                ],
                [
                    "that"
                ],
                [
                    "rolled."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "the"
                ],
                [
                    "Tri",
                    "ni",
                    "ty"
                ],
                [
                    "be"
                ],
                [
                    "glo",
                    "ry"
                ]
            ],
            [
                [
                    "Ev",
                    "er",
                    "last",
                    "ing"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "meet;"
                ]
            ],
            [
                [
                    "E",
                    "qual"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "e",
                    "qual"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "the"
                ],
                [
                    "Son"
                ],
                [
                    "and"
                ],
                [
                    "Pa",
                    "ra",
                    "clete:"
                ]
            ],
            [
                [
                    "Tri",
                    "nal"
                ],
                [
                    "U",
                    "ni",
                    "ty,"
                ],
                [
                    "whose"
                ],
                [
                    "prai",
                    "ses"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "cre",
                    "a",
                    "ted"
                ],
                [
                    "things"
                ],
                [
                    "re",
                    "peat."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "3",
                "3",
                "2",
                "5",
                "5",
                "68",
                "8"
            ],
            [
                "89",
                "8",
                "8",
                "8",
                "6",
                "8",
                "765"
            ],
            [
                "5",
                "6",
                "8",
                "7",
                "6",
                "5",
                "6",
                "6"
            ],
            [
                "6",
                "7",
                "5",
                "4",
                "3",
                "6",
                "62"
            ],
            [
                "5",
                "5",
                "5",
                "3",
                "5",
                "6",
                "6",
                "5"
            ],
            [
                "6",
                "7",
                "5",
                "65",
                "4b",
                "2",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "c5",
        tone: "3"
    },
    "lord-of-creation-bow-thine-ear": {
        title: "Annue Christe",
        text: [
            [
                [
                    "LORD"
                ],
                [
                    "of"
                ],
                [
                    "cre",
                    "a",
                    "tion,"
                ],
                [
                    "bow"
                ],
                [
                    "Thine"
                ],
                [
                    "ear,"
                ],
                [
                    "O"
                ],
                [
                    "Christ,"
                ],
                [
                    "to"
                ],
                [
                    "hear"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "in",
                    "ter",
                    "cess",
                    "ion"
                ],
                [
                    "of"
                ],
                [
                    "Thy"
                ],
                [
                    "ser",
                    "vant"
                ],
                [
                    "true"
                ],
                [
                    "and"
                ],
                [
                    "dear,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "we"
                ],
                [
                    "un",
                    "wor",
                    "thy,"
                ],
                [
                    "who"
                ],
                [
                    "have"
                ],
                [
                    "tres",
                    "passed"
                ],
                [
                    "in"
                ],
                [
                    "Thy"
                ],
                [
                    "sight,"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "live"
                ],
                [
                    "be",
                    "fore"
                ],
                [
                    "Thee"
                ],
                [
                    "where"
                ],
                [
                    "he"
                ],
                [
                    "dwells"
                ],
                [
                    "in"
                ],
                [
                    "glo",
                    "rious"
                ],
                [
                    "light."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "God"
                ],
                [
                    "our"
                ],
                [
                    "Sav",
                    "ior,"
                ],
                [
                    "look"
                ],
                [
                    "on"
                ],
                [
                    "Thine"
                ],
                [
                    "in",
                    "he",
                    "ri",
                    "tance,"
                ]
            ],
            [
                [
                    "Sealed"
                ],
                [
                    "by"
                ],
                [
                    "the"
                ],
                [
                    "fa",
                    "vor"
                ],
                [
                    "shin",
                    "ing"
                ],
                [
                    "from"
                ],
                [
                    "Thy"
                ],
                [
                    "coun",
                    "te",
                    "nance;"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "no"
                ],
                [
                    "false"
                ],
                [
                    "spi",
                    "rit"
                ],
                [
                    "bring"
                ],
                [
                    "to"
                ],
                [
                    "naught"
                ],
                [
                    "the"
                ],
                [
                    "souls"
                ],
                [
                    "of"
                ],
                [
                    "price"
                ]
            ],
            [
                [
                    "Bought"
                ],
                [
                    "by"
                ],
                [
                    "the"
                ],
                [
                    "me",
                    "rit"
                ],
                [
                    "of"
                ],
                [
                    "Thy"
                ],
                [
                    "per",
                    "fect"
                ],
                [
                    "sac",
                    "ri",
                    "fice."
                ]
            ],
            [
                [
                    "We"
                ],
                [
                    "bear"
                ],
                [
                    "the"
                ],
                [
                    "bur",
                    "den"
                ],
                [
                    "of"
                ],
                [
                    "our"
                ],
                [
                    "guilt"
                ],
                [
                    "and"
                ],
                [
                    "en",
                    "mi",
                    "ty,"
                ]
            ],
            [
                [
                    "Un",
                    "til"
                ],
                [
                    "Thy"
                ],
                [
                    "par",
                    "don"
                ],
                [
                    "lift"
                ],
                [
                    "the"
                ],
                [
                    "heart"
                ],
                [
                    "from"
                ],
                [
                    "sla",
                    "ve",
                    "ry;"
                ]
            ],
            [
                [
                    "Then"
                ],
                [
                    "through"
                ],
                [
                    "the"
                ],
                [
                    "spend",
                    "ing"
                ],
                [
                    "of"
                ],
                [
                    "Thy"
                ],
                [
                    "life"
                ],
                [
                    "blood,"
                ],
                [
                    "King"
                ],
                [
                    "of"
                ],
                [
                    "grace,"
                ]
            ],
            [
                [
                    "Grant"
                ],
                [
                    "us"
                ],
                [
                    "un",
                    "end",
                    "ing"
                ],
                [
                    "tri",
                    "umph"
                ],
                [
                    "in"
                ],
                [
                    "Thy"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "place."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "Thee"
                ],
                [
                    "the"
                ],
                [
                    "glor",
                    "ious"
                ],
                [
                    "Christ,"
                ],
                [
                    "our"
                ],
                [
                    "Sav",
                    "ior"
                ],
                [
                    "ma",
                    "ni",
                    "fest,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "wreaths"
                ],
                [
                    "vic",
                    "to",
                    "rious,"
                ],
                [
                    "praise"
                ],
                [
                    "and"
                ],
                [
                    "wor",
                    "ship"
                ],
                [
                    "be"
                ],
                [
                    "ad",
                    "drest,"
                ]
            ],
            [
                [
                    "Whom"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "li",
                    "ving"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "humb",
                    "ly"
                ],
                [
                    "we"
                ],
                [
                    "a",
                    "dore,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "the"
                ],
                [
                    "life"
                ],
                [
                    "giv",
                    "ing"
                ],
                [
                    "Spi",
                    "rit,"
                ],
                [
                    "God"
                ],
                [
                    "for",
                    "ev",
                    "er",
                    "more."
                ]
            ]
        ],
        tune: [
            [
                "1556",
                "4",
                "56",
                "7",
                "65",
                "8",
                "7",
                "65",
                "4",
                "7",
                "654",
                "5"
            ],
            [
                "5",
                "5765",
                "4",
                "343",
                "21",
                "4",
                "56",
                "7",
                "65",
                "4",
                "5",
                "5"
            ],
            [
                "8",
                "76",
                "78",
                "76",
                "5",
                "6",
                "7",
                "5",
                "6",
                "4",
                "5",
                "5"
            ],
            [
                "5",
                "5765",
                "4",
                "343",
                "21",
                "2",
                "3",
                "1",
                "2",
                "0",
                "1",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "the-god-whom-earth-and-sea-and-sky": {
        title: "Quem terra, pontus, aethera",
        text: [
            [
                [
                    "THE"
                ],
                [
                    "God"
                ],
                [
                    "whom"
                ],
                [
                    "earth"
                ],
                [
                    "and"
                ],
                [
                    "sea"
                ],
                [
                    "and"
                ],
                [
                    "sky"
                ]
            ],
            [
                [
                    "A",
                    "dore"
                ],
                [
                    "and"
                ],
                [
                    "laud"
                ],
                [
                    "and"
                ],
                [
                    "mag",
                    "ni",
                    "fy,"
                ]
            ],
            [
                [
                    "Whose"
                ],
                [
                    "might"
                ],
                [
                    "they"
                ],
                [
                    "own,"
                ],
                [
                    "whose"
                ],
                [
                    "praise"
                ],
                [
                    "they"
                ],
                [
                    "swell,"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "Ma",
                    "ry's"
                ],
                [
                    "womb"
                ],
                [
                    "vouch",
                    "safed"
                ],
                [
                    "to"
                ],
                [
                    "dwell."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Lord"
                ],
                [
                    "whom"
                ],
                [
                    "sun"
                ],
                [
                    "and"
                ],
                [
                    "moon"
                ],
                [
                    "o",
                    "bey,"
                ]
            ],
            [
                [
                    "Whom"
                ],
                [
                    "all"
                ],
                [
                    "things"
                ],
                [
                    "serve"
                ],
                [
                    "from"
                ],
                [
                    "day"
                ],
                [
                    "to"
                ],
                [
                    "day,"
                ]
            ],
            [
                [
                    "Was"
                ],
                [
                    "by"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "con",
                    "ceived"
                ]
            ],
            [
                [
                    "Of"
                ],
                [
                    "her"
                ],
                [
                    "who"
                ],
                [
                    "through"
                ],
                [
                    "his"
                ],
                [
                    "grace"
                ],
                [
                    "be",
                    "lieved."
                ]
            ],
            [
                [
                    "How"
                ],
                [
                    "blest"
                ],
                [
                    "that"
                ],
                [
                    "Mo",
                    "ther,"
                ],
                [
                    "in"
                ],
                [
                    "whose"
                ],
                [
                    "shrine"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "world's"
                ],
                [
                    "Cre",
                    "a",
                    "tor,"
                ],
                [
                    "Lord"
                ],
                [
                    "di",
                    "vine,"
                ]
            ],
            [
                [
                    "Whose"
                ],
                [
                    "hand"
                ],
                [
                    "con",
                    "tains"
                ],
                [
                    "the"
                ],
                [
                    "earth"
                ],
                [
                    "and"
                ],
                [
                    "sky,"
                ]
            ],
            [
                [
                    "Once"
                ],
                [
                    "deigned,"
                ],
                [
                    "as"
                ],
                [
                    "in"
                ],
                [
                    "his"
                ],
                [
                    "ark,"
                ],
                [
                    "to"
                ],
                [
                    "lie."
                ]
            ],
            [
                [
                    "Blest"
                ],
                [
                    "in"
                ],
                [
                    "the"
                ],
                [
                    "mess",
                    "age"
                ],
                [
                    "Ga",
                    "briel"
                ],
                [
                    "brought,"
                ]
            ],
            [
                [
                    "Blest"
                ],
                [
                    "by"
                ],
                [
                    "the"
                ],
                [
                    "work"
                ],
                [
                    "the"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "wrought;"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "whom"
                ],
                [
                    "the"
                ],
                [
                    "great"
                ],
                [
                    "De",
                    "sire"
                ],
                [
                    "of"
                ],
                [
                    "earth"
                ]
            ],
            [
                [
                    "Took"
                ],
                [
                    "hu",
                    "man"
                ],
                [
                    "flesh"
                ],
                [
                    "and"
                ],
                [
                    "hu",
                    "man"
                ],
                [
                    "birth."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Lord,"
                ],
                [
                    "the"
                ],
                [
                    "Vir",
                    "gin-",
                    "born,"
                ],
                [
                    "to"
                ],
                [
                    "thee"
                ]
            ],
            [
                [
                    "E",
                    "ter",
                    "nal"
                ],
                [
                    "praise"
                ],
                [
                    "and"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "Whom"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "we"
                ],
                [
                    "a",
                    "dore"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "for"
                ],
                [
                    "ev",
                    "er",
                    "more."
                ]
            ]
        ],
        tune: [
            [
                "4",
                "4323",
                "10",
                "4",
                "46b",
                "6b5",
                "4",
                "5"
            ],
            [
                "7",
                "76b",
                "5",
                "6b5",
                "4",
                "54",
                "34",
                "4"
            ],
            [
                "47",
                "7",
                "76b",
                "7",
                "787",
                "6b5",
                "43",
                "4543"
            ],
            [
                "6b5",
                "6b7",
                "5",
                "6b5",
                "4",
                "54",
                "34",
                "4"
            ]
        ],
        amen: [
            "45",
            "434"
        ],
        clef: "c7",
        tone: "1"
    },
    "all-prophets-hail-thee": {
        title: "Quod chorus vatum",
        text: [
            [
                [
                    "ALL"
                ],
                [
                    "pro",
                    "phets"
                ],
                [
                    "hail"
                ],
                [
                    "thee,"
                ],
                [
                    "from"
                ],
                [
                    "of"
                ],
                [
                    "old"
                ],
                [
                    "an",
                    "noun",
                    "cing,"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "the"
                ],
                [
                    "in",
                    "breath",
                    "ed"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther,"
                ]
            ],
            [
                [
                    "God's"
                ],
                [
                    "Mo",
                    "ther,"
                ],
                [
                    "bring",
                    "ing"
                ],
                [
                    "pro",
                    "phe",
                    "cies"
                ],
                [
                    "to"
                ],
                [
                    "full",
                    "ness"
                ]
            ],
            [
                [
                    "Ma",
                    "ry"
                ],
                [
                    "the"
                ],
                [
                    "mai",
                    "den."
                ]
            ],
            [
                [
                    "Thou"
                ],
                [
                    "the"
                ],
                [
                    "true"
                ],
                [
                    "Vir",
                    "gin"
                ],
                [
                    "Mo",
                    "ther"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "High",
                    "est,"
                ]
            ],
            [
                [
                    "Bear",
                    "ing"
                ],
                [
                    "in",
                    "car",
                    "nate"
                ],
                [
                    "God"
                ],
                [
                    "in"
                ],
                [
                    "awed"
                ],
                [
                    "o",
                    "be",
                    "dience,"
                ]
            ],
            [
                [
                    "Meek",
                    "ly"
                ],
                [
                    "ac",
                    "cept",
                    "est"
                ],
                [
                    "for"
                ],
                [
                    "a"
                ],
                [
                    "sin",
                    "less"
                ],
                [
                    "off",
                    "spring"
                ]
            ],
            [
                [
                    "Pu",
                    "ri",
                    "fi",
                    "ca",
                    "tion."
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "the"
                ],
                [
                    "high"
                ],
                [
                    "tem",
                    "ple"
                ],
                [
                    "Si",
                    "me",
                    "on"
                ],
                [
                    "re",
                    "ceives"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "Takes"
                ],
                [
                    "to"
                ],
                [
                    "his"
                ],
                [
                    "bent"
                ],
                [
                    "arms"
                ],
                [
                    "with"
                ],
                [
                    "a"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "rap",
                    "ture"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "pro",
                    "mised"
                ],
                [
                    "Sav",
                    "ior,"
                ],
                [
                    "vis",
                    "ion"
                ],
                [
                    "of"
                ],
                [
                    "re",
                    "demp",
                    "tion,"
                ]
            ],
            [
                [
                    "Christ"
                ],
                [
                    "long"
                ],
                [
                    "a",
                    "wait",
                    "ed."
                ]
            ],
            [
                [
                    "Now"
                ],
                [
                    "the"
                ],
                [
                    "fair"
                ],
                [
                    "realm"
                ],
                [
                    "of"
                ],
                [
                    "pa",
                    "ra",
                    "dise"
                ],
                [
                    "at",
                    "tain",
                    "ing,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "to"
                ],
                [
                    "thy"
                ],
                [
                    "Son's"
                ],
                [
                    "throne,"
                ],
                [
                    "Mo",
                    "ther"
                ],
                [
                    "of"
                ],
                [
                    "the-",
                    "Eter",
                    "nal,"
                ]
            ],
            [
                [
                    "Rais",
                    "ed"
                ],
                [
                    "all"
                ],
                [
                    "glor",
                    "ious,"
                ],
                [
                    "yet"
                ],
                [
                    "in"
                ],
                [
                    "earth's"
                ],
                [
                    "de",
                    "vo",
                    "tion"
                ]
            ],
            [
                [
                    "Join"
                ],
                [
                    "with"
                ],
                [
                    "us"
                ],
                [
                    "al",
                    "ways."
                ]
            ],
            [
                [
                    "Glo",
                    "ry"
                ],
                [
                    "and"
                ],
                [
                    "wor",
                    "ship"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "Lord"
                ],
                [
                    "of"
                ],
                [
                    "all"
                ],
                [
                    "things"
                ]
            ],
            [
                [
                    "Pay"
                ],
                [
                    "we"
                ],
                [
                    "un",
                    "rest",
                    "ing,"
                ],
                [
                    "who"
                ],
                [
                    "a",
                    "lone"
                ],
                [
                    "a",
                    "dor",
                    "ed,"
                ]
            ],
            [
                [
                    "Fa",
                    "ther"
                ],
                [
                    "and"
                ],
                [
                    "Son"
                ],
                [
                    "and"
                ],
                [
                    "Spi",
                    "rit,"
                ],
                [
                    "in"
                ],
                [
                    "the"
                ],
                [
                    "high",
                    "est"
                ]
            ],
            [
                [
                    "Reign",
                    "eth"
                ],
                [
                    "e",
                    "ter",
                    "nal."
                ]
            ]
        ],
        tune: [
            [
                "13",
                "1",
                "1",
                "0",
                "1",
                "3",
                "3",
                "1",
                "2",
                "2",
                "1"
            ],
            [
                "156b",
                "5",
                "5",
                "54",
                "45",
                "3",
                "45",
                "4",
                "34",
                "432",
                "1"
            ],
            [
                "14",
                "32",
                "10",
                "1",
                "0",
                "32",
                "34",
                "32",
                "10",
                "12",
                "2"
            ],
            [
                "13",
                "1",
                "1",
                "0",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "o-boundless-wisdom-god-most-high": {
        // Monday evening, ordinary time
        title: "Immense caeli Conditor",
        text: [
            [
                [
                    "O"
                ],
                [
                    "BOUND",
                    "LESS"
                ],
                [
                    "Wis",
                    "dom,"
                ],
                [
                    "God"
                ],
                [
                    "most"
                ],
                [
                    "high,"
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Ma",
                    "ker"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "earth"
                ],
                [
                    "and"
                ],
                [
                    "sky,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "bid\u2019st"
                ],
                [
                    "the"
                ],
                [
                    "par",
                    "ted"
                ],
                [
                    "wa",
                    "ters"
                ],
                [
                    "flow"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "heav'n"
                ],
                [
                    "a",
                    "bove,"
                ],
                [
                    "on"
                ],
                [
                    "earth"
                ],
                [
                    "be",
                    "low."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "streams"
                ],
                [
                    "on"
                ],
                [
                    "earth,"
                ],
                [
                    "the"
                ],
                [
                    "clouds"
                ],
                [
                    "in"
                ],
                [
                    "heav'n,"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "Thee"
                ],
                [
                    "their"
                ],
                [
                    "ord",
                    "er'd"
                ],
                [
                    "bounds"
                ],
                [
                    "were"
                ],
                [
                    "giv'n,"
                ]
            ],
            [
                [
                    "Lest"
                ],
                [
                    "\u2019neath"
                ],
                [
                    "the-un",
                    "temp",
                    "er'd"
                ],
                [
                    "fires"
                ],
                [
                    "of"
                ],
                [
                    "day"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "parch-",
                    "ed"
                ],
                [
                    "soil"
                ],
                [
                    "should"
                ],
                [
                    "waste"
                ],
                [
                    "a",
                    "way."
                ]
            ],
            [
                [
                    "E\u2019en"
                ],
                [
                    "so"
                ],
                [
                    "on"
                ],
                [
                    "us"
                ],
                [
                    "who"
                ],
                [
                    "seek"
                ],
                [
                    "Thy"
                ],
                [
                    "face"
                ]
            ],
            [
                [
                    "Pour"
                ],
                [
                    "forth"
                ],
                [
                    "the"
                ],
                [
                    "wa",
                    "ters"
                ],
                [
                    "of"
                ],
                [
                    "Thy"
                ],
                [
                    "grace;"
                ]
            ],
            [
                [
                    "Re",
                    "new"
                ],
                [
                    "the"
                ],
                [
                    "fount"
                ],
                [
                    "of"
                ],
                [
                    "life"
                ],
                [
                    "with",
                    "in,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "quench"
                ],
                [
                    "the"
                ],
                [
                    "wast",
                    "ing"
                ],
                [
                    "fires"
                ],
                [
                    "of"
                ],
                [
                    "sin."
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "faith"
                ],
                [
                    "di",
                    "scern"
                ],
                [
                    "the-e",
                    "ter",
                    "nal"
                ],
                [
                    "Light"
                ]
            ],
            [
                [
                    "Be",
                    "yond"
                ],
                [
                    "the"
                ],
                [
                    "dark",
                    "ness"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "night,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "through"
                ],
                [
                    "the"
                ],
                [
                    "mists"
                ],
                [
                    "of"
                ],
                [
                    "false",
                    "hood"
                ],
                [
                    "see"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "path"
                ],
                [
                    "of"
                ],
                [
                    "truth"
                ],
                [
                    "re",
                    "vealed"
                ],
                [
                    "by"
                ],
                [
                    "Thee."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "ask"
                ],
                [
                    "be"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "Christ,"
                ],
                [
                    "thine"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son;"
                ]
            ],
            [
                [
                    "Who,"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "and"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "Doth"
                ],
                [
                    "live"
                ],
                [
                    "and"
                ],
                [
                    "reign"
                ],
                [
                    "et",
                    "er",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "5",
                "5"
            ],
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "3",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "2"
    },
    "earths-mighty-maker-whose-command": {
        // Tuesday evening, ordinary time
        title: "Telluris ingens Conditor",
        text: [
            [
                [
                    "EARTH'S"
                ],
                [
                    "migh",
                    "ty"
                ],
                [
                    "Ma",
                    "ker,"
                ],
                [
                    "whose"
                ],
                [
                    "com",
                    "mand"
                ]
            ],
            [
                [
                    "Raised"
                ],
                [
                    "from"
                ],
                [
                    "the"
                ],
                [
                    "sea"
                ],
                [
                    "the"
                ],
                [
                    "so",
                    "lid"
                ],
                [
                    "land,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "drove"
                ],
                [
                    "each"
                ],
                [
                    "bill",
                    "owy"
                ],
                [
                    "heap"
                ],
                [
                    "a",
                    "way,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "bade"
                ],
                [
                    "the"
                ],
                [
                    "earth"
                ],
                [
                    "stand"
                ],
                [
                    "firm"
                ],
                [
                    "for"
                ],
                [
                    "aye:"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "so,"
                ],
                [
                    "with"
                ],
                [
                    "flowers"
                ],
                [
                    "of"
                ],
                [
                    "gold",
                    "en"
                ],
                [
                    "hue,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "seeds"
                ],
                [
                    "of"
                ],
                [
                    "each"
                ],
                [
                    "it"
                ],
                [
                    "might"
                ],
                [
                    "re",
                    "new;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "fruit"
                ],
                [
                    "trees"
                ],
                [
                    "bear",
                    "ing"
                ],
                [
                    "fruit"
                ],
                [
                    "might"
                ],
                [
                    "yield-"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "plea",
                    "sant"
                ],
                [
                    "pas",
                    "ture"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "field;"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "spi",
                    "rit\u2019s"
                ],
                [
                    "rank",
                    "ling"
                ],
                [
                    "wounds"
                ],
                [
                    "ef",
                    "face"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "dew",
                    "y"
                ],
                [
                    "fresh",
                    "ness"
                ],
                [
                    "of"
                ],
                [
                    "Thy"
                ],
                [
                    "grace:"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "grief"
                ],
                [
                    "may"
                ],
                [
                    "cleanse"
                ],
                [
                    "each"
                ],
                [
                    "deed"
                ],
                [
                    "of"
                ],
                [
                    "ill,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "o\u2019er"
                ],
                [
                    "each"
                ],
                [
                    "lust"
                ],
                [
                    "may"
                ],
                [
                    "tri",
                    "umph"
                ],
                [
                    "still."
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "ev",
                    "ery"
                ],
                [
                    "soul"
                ],
                [
                    "thy"
                ],
                [
                    "law"
                ],
                [
                    "o",
                    "bey,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "keep"
                ],
                [
                    "from"
                ],
                [
                    "ev",
                    "ery"
                ],
                [
                    "e",
                    "vil"
                ],
                [
                    "way;"
                ]
            ],
            [
                [
                    "Re",
                    "joice"
                ],
                [
                    "each"
                ],
                [
                    "pro",
                    "mised"
                ],
                [
                    "good"
                ],
                [
                    "to"
                ],
                [
                    "win"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "flee"
                ],
                [
                    "from"
                ],
                [
                    "ev",
                    "ery"
                ],
                [
                    "mor",
                    "tal"
                ],
                [
                    "sin."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "ask"
                ],
                [
                    "be"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "Christ,"
                ],
                [
                    "thine"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son;"
                ]
            ],
            [
                [
                    "Who,"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "and"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "Doth"
                ],
                [
                    "live"
                ],
                [
                    "and"
                ],
                [
                    "reign"
                ],
                [
                    "et",
                    "er",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "5",
                "5"
            ],
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "3",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "2"
    },
    "most-holy-lord-and-god-of-heaven": {
        // Wednesday evening, ordinary time
        title: "Coeli Deus sanctissime",
        text: [
            [
                [
                    "MOST"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "Lord"
                ],
                [
                    "and"
                ],
                [
                    "God"
                ],
                [
                    "of"
                ],
                [
                    "Heav'n,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "glow",
                    "ing"
                ],
                [
                    "sky"
                ],
                [
                    "hast"
                ],
                [
                    "giv'n"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "fires"
                ],
                [
                    "that"
                ],
                [
                    "in"
                ],
                [
                    "the"
                ],
                [
                    "east"
                ],
                [
                    "are"
                ],
                [
                    "born"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "grad",
                    "ual"
                ],
                [
                    "splen",
                    "dors"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "morn;"
                ]
            ],
            [
                [
                    "Who,"
                ],
                [
                    "on"
                ],
                [
                    "the"
                ],
                [
                    "fourth"
                ],
                [
                    "day,"
                ],
                [
                    "didst"
                ],
                [
                    "re",
                    "veal"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "sun\u2019s"
                ],
                [
                    "en",
                    "kin",
                    "dled"
                ],
                [
                    "flam",
                    "ing"
                ],
                [
                    "wheel,"
                ]
            ],
            [
                [
                    "Didst"
                ],
                [
                    "set"
                ],
                [
                    "the"
                ],
                [
                    "moon"
                ],
                [
                    "her"
                ],
                [
                    "ord",
                    "er'd"
                ],
                [
                    "ways,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "stars"
                ],
                [
                    "their"
                ],
                [
                    "ev",
                    "er"
                ],
                [
                    "wind",
                    "ing"
                ],
                [
                    "maze;"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "each"
                ],
                [
                    "in"
                ],
                [
                    "its"
                ],
                [
                    "ap",
                    "poin",
                    "ted"
                ],
                [
                    "way"
                ]
            ],
            [
                [
                    "Might"
                ],
                [
                    "se",
                    "pa",
                    "rate"
                ],
                [
                    "the"
                ],
                [
                    "night"
                ],
                [
                    "from"
                ],
                [
                    "day,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "sea",
                    "sons"
                ],
                [
                    "through"
                ],
                [
                    "the"
                ],
                [
                    "year"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "well"
                ],
                [
                    "re",
                    "mem",
                    "bered"
                ],
                [
                    "signs"
                ],
                [
                    "de",
                    "clare;"
                ]
            ],
            [
                [
                    "Il",
                    "lu",
                    "min",
                    "ate"
                ],
                [
                    "our"
                ],
                [
                    "hearts"
                ],
                [
                    "with",
                    "in,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "cleanse"
                ],
                [
                    "our"
                ],
                [
                    "minds"
                ],
                [
                    "from"
                ],
                [
                    "stain"
                ],
                [
                    "of"
                ],
                [
                    "sin;"
                ]
            ],
            [
                [
                    "Un",
                    "bur",
                    "dened"
                ],
                [
                    "of"
                ],
                [
                    "our"
                ],
                [
                    "guil",
                    "ty"
                ],
                [
                    "load"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "we"
                ],
                [
                    "un",
                    "fet",
                    "tered"
                ],
                [
                    "serve"
                ],
                [
                    "our"
                ],
                [
                    "God."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "ask"
                ],
                [
                    "be"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "Christ,"
                ],
                [
                    "thine"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son;"
                ]
            ],
            [
                [
                    "Who,"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "and"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "Doth"
                ],
                [
                    "live"
                ],
                [
                    "and"
                ],
                [
                    "reign"
                ],
                [
                    "et",
                    "er",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "5",
                "5"
            ],
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "3",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "2"
    },
    "almighty-god-who-from-the-flood": {
        // Thursday evening, ordinary time
        title: "Magnae Deus potentiae",
        text: [
            [
                [
                    "AL",
                    "MIGH",
                    "TY"
                ],
                [
                    "God,"
                ],
                [
                    "who"
                ],
                [
                    "from"
                ],
                [
                    "the"
                ],
                [
                    "flood"
                ]
            ],
            [
                [
                    "Didst"
                ],
                [
                    "bring"
                ],
                [
                    "to"
                ],
                [
                    "light"
                ],
                [
                    "a"
                ],
                [
                    "two",
                    "fold"
                ],
                [
                    "brood;"
                ]
            ],
            [
                [
                    "Part"
                ],
                [
                    "in"
                ],
                [
                    "the"
                ],
                [
                    "fir",
                    "ma",
                    "ment"
                ],
                [
                    "to"
                ],
                [
                    "fly,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "part"
                ],
                [
                    "in"
                ],
                [
                    "o",
                    "cean\u2019s"
                ],
                [
                    "depths"
                ],
                [
                    "to"
                ],
                [
                    "lie;"
                ]
            ],
            [
                [
                    "Ap",
                    "point",
                    "ing"
                ],
                [
                    "fish",
                    "es"
                ],
                [
                    "in"
                ],
                [
                    "the"
                ],
                [
                    "sea,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "fowls"
                ],
                [
                    "in"
                ],
                [
                    "o",
                    "pen"
                ],
                [
                    "air"
                ],
                [
                    "to"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "each,"
                ],
                [
                    "by"
                ],
                [
                    "o",
                    "ri",
                    "gin"
                ],
                [
                    "the"
                ],
                [
                    "same,"
                ]
            ],
            [
                [
                    "Its"
                ],
                [
                    "sep",
                    "arate"
                ],
                [
                    "dwell",
                    "ing"
                ],
                [
                    "place"
                ],
                [
                    "might"
                ],
                [
                    "claim:"
                ]
            ],
            [
                [
                    "Grant"
                ],
                [
                    "that"
                ],
                [
                    "Thy"
                ],
                [
                    "ser",
                    "vants,"
                ],
                [
                    "by"
                ],
                [
                    "the"
                ],
                [
                    "tide"
                ]
            ],
            [
                [
                    "Of"
                ],
                [
                    "blood"
                ],
                [
                    "and"
                ],
                [
                    "wa",
                    "ter"
                ],
                [
                    "pu",
                    "ri",
                    "fied,"
                ]
            ],
            [
                [
                    "No"
                ],
                [
                    "guil",
                    "ty"
                ],
                [
                    "fall"
                ],
                [
                    "from"
                ],
                [
                    "Thee"
                ],
                [
                    "may"
                ],
                [
                    "know,"
                ]
            ],
            [
                [
                    "Nor"
                ],
                [
                    "death"
                ],
                [
                    "e",
                    "ter",
                    "nal"
                ],
                [
                    "un",
                    "der",
                    "go."
                ]
            ],
            [
                [
                    "Be"
                ],
                [
                    "none"
                ],
                [
                    "sub",
                    "merged"
                ],
                [
                    "in"
                ],
                [
                    "sin\u2019s"
                ],
                [
                    "dis",
                    "tress,"
                ]
            ],
            [
                [
                    "None"
                ],
                [
                    "lift",
                    "ed"
                ],
                [
                    "up"
                ],
                [
                    "in"
                ],
                [
                    "boast",
                    "ful",
                    "ness;"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "con",
                    "trite"
                ],
                [
                    "hearts"
                ],
                [
                    "be"
                ],
                [
                    "not"
                ],
                [
                    "dis",
                    "mayed,"
                ]
            ],
            [
                [
                    "Nor"
                ],
                [
                    "naugh",
                    "ty"
                ],
                [
                    "souls"
                ],
                [
                    "in"
                ],
                [
                    "ru",
                    "in"
                ],
                [
                    "laid."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "ask"
                ],
                [
                    "be"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "Christ,"
                ],
                [
                    "thine"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son;"
                ]
            ],
            [
                [
                    "Who,"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "and"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "Doth"
                ],
                [
                    "live"
                ],
                [
                    "and"
                ],
                [
                    "reign"
                ],
                [
                    "et",
                    "er",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "5",
                "5"
            ],
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "3",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "2"
    },
    "maker-of-man-who-from-thy-throne": {
        // Friday evening, ordinary time
        title: "Plasmator hominis, Deus",
        text: [
            [
                [
                    "MA",
                    "KER"
                ],
                [
                    "of"
                ],
                [
                    "man,"
                ],
                [
                    "who"
                ],
                [
                    "from"
                ],
                [
                    "Thy"
                ],
                [
                    "throne"
                ]
            ],
            [
                [
                    "Dost"
                ],
                [
                    "or",
                    "der"
                ],
                [
                    "all"
                ],
                [
                    "things,"
                ],
                [
                    "God"
                ],
                [
                    "a",
                    "lone;"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "whose"
                ],
                [
                    "de",
                    "cree"
                ],
                [
                    "the"
                ],
                [
                    "teem",
                    "ing"
                ],
                [
                    "earth"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "rep",
                    "tile"
                ],
                [
                    "and"
                ],
                [
                    "to"
                ],
                [
                    "beast"
                ],
                [
                    "gave"
                ],
                [
                    "birth:"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "migh",
                    "ty"
                ],
                [
                    "forms"
                ],
                [
                    "that"
                ],
                [
                    "fill"
                ],
                [
                    "the"
                ],
                [
                    "land,"
                ]
            ],
            [
                [
                    "In",
                    "stinct"
                ],
                [
                    "with"
                ],
                [
                    "life"
                ],
                [
                    "at"
                ],
                [
                    "Thy"
                ],
                [
                    "com",
                    "mand,"
                ]
            ],
            [
                [
                    "Are"
                ],
                [
                    "giv\u2019n"
                ],
                [
                    "sub",
                    "dued"
                ],
                [
                    "to"
                ],
                [
                    "hu",
                    "man",
                    "kind"
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "ser",
                    "vice"
                ],
                [
                    "in"
                ],
                [
                    "their"
                ],
                [
                    "rank"
                ],
                [
                    "a",
                    "ssigned."
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "all"
                ],
                [
                    "Thy"
                ],
                [
                    "ser",
                    "vants"
                ],
                [
                    "drive"
                ],
                [
                    "a",
                    "way"
                ]
            ],
            [
                [
                    "What",
                    "e\u2019er"
                ],
                [
                    "of"
                ],
                [
                    "thought"
                ],
                [
                    "im",
                    "pure"
                ],
                [
                    "to",
                    "day"
                ]
            ],
            [
                [
                    "Hath"
                ],
                [
                    "been"
                ],
                [
                    "with"
                ],
                [
                    "o",
                    "pen"
                ],
                [
                    "ac",
                    "tion"
                ],
                [
                    "blent"
                ]
            ],
            [
                [
                    "Or"
                ],
                [
                    "min",
                    "gled"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "heart\u2019s"
                ],
                [
                    "in",
                    "tent."
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "Heav\u2019n"
                ],
                [
                    "Thine"
                ],
                [
                    "end",
                    "less"
                ],
                [
                    "joys"
                ],
                [
                    "be",
                    "stow,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "grant"
                ],
                [
                    "Thy"
                ],
                [
                    "gifts"
                ],
                [
                    "of"
                ],
                [
                    "grace"
                ],
                [
                    "be",
                    "low;"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "chains"
                ],
                [
                    "of"
                ],
                [
                    "strife"
                ],
                [
                    "our"
                ],
                [
                    "souls"
                ],
                [
                    "re",
                    "lease,"
                ]
            ],
            [
                [
                    "Bind"
                ],
                [
                    "fast"
                ],
                [
                    "the"
                ],
                [
                    "gen",
                    "tle"
                ],
                [
                    "hands"
                ],
                [
                    "of"
                ],
                [
                    "peace."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "ask"
                ],
                [
                    "be"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "Christ,"
                ],
                [
                    "thine"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son;"
                ]
            ],
            [
                [
                    "Who,"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "and"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "Doth"
                ],
                [
                    "live"
                ],
                [
                    "and"
                ],
                [
                    "reign"
                ],
                [
                    "et",
                    "er",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "5",
                "5"
            ],
            [
                "5",
                "5",
                "6",
                "7",
                "6",
                "6",
                "5",
                "4"
            ],
            [
                "6",
                "4",
                "5",
                "3",
                "2",
                "5",
                "3",
                "3"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "2"
    },
    "creator-of-the-earth-and-sky": {
        // Saturday evening, ordinary time
        title: "Deus Creator omnium",
        text: [
            [
                [
                    "CRE",
                    "A",
                    "TOR"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "earth"
                ],
                [
                    "and"
                ],
                [
                    "sky,"
                ]
            ],
            [
                [
                    "Rul",
                    "ing"
                ],
                [
                    "the"
                ],
                [
                    "fir",
                    "ma",
                    "ment"
                ],
                [
                    "on"
                ],
                [
                    "high,"
                ]
            ],
            [
                [
                    "Cloth",
                    "ing"
                ],
                [
                    "the"
                ],
                [
                    "day"
                ],
                [
                    "with"
                ],
                [
                    "robes"
                ],
                [
                    "of"
                ],
                [
                    "light,"
                ]
            ],
            [
                [
                    "Bless",
                    "ing"
                ],
                [
                    "with"
                ],
                [
                    "gra",
                    "cious"
                ],
                [
                    "sleep"
                ],
                [
                    "the"
                ],
                [
                    "night,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "rest"
                ],
                [
                    "may"
                ],
                [
                    "com",
                    "fort"
                ],
                [
                    "wea",
                    "ry"
                ],
                [
                    "men,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "brace"
                ],
                [
                    "to"
                ],
                [
                    "use",
                    "ful"
                ],
                [
                    "toil"
                ],
                [
                    "a",
                    "gain,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "soothe"
                ],
                [
                    "a",
                    "while"
                ],
                [
                    "the"
                ],
                [
                    "ha",
                    "rassed"
                ],
                [
                    "mind,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "sor",
                    "row\u2019s"
                ],
                [
                    "hea",
                    "vy"
                ],
                [
                    "load"
                ],
                [
                    "un",
                    "bind:"
                ]
            ],
            [
                [
                    "Day"
                ],
                [
                    "sinks;"
                ],
                [
                    "we"
                ],
                [
                    "thank"
                ],
                [
                    "thee"
                ],
                [
                    "for"
                ],
                [
                    "thy"
                ],
                [
                    "gift;"
                ]
            ],
            [
                [
                    "Night"
                ],
                [
                    "comes;"
                ],
                [
                    "and"
                ],
                [
                    "once"
                ],
                [
                    "a",
                    "gain"
                ],
                [
                    "we"
                ],
                [
                    "lift"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "prayer"
                ],
                [
                    "and"
                ],
                [
                    "vows"
                ],
                [
                    "and"
                ],
                [
                    "hymns"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ]
            ],
            [
                [
                    "A",
                    "gainst"
                ],
                [
                    "all"
                ],
                [
                    "ills"
                ],
                [
                    "may"
                ],
                [
                    "shield",
                    "ed"
                ],
                [
                    "be."
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "when"
                ],
                [
                    "black"
                ],
                [
                    "dark",
                    "ness"
                ],
                [
                    "clo",
                    "ses"
                ],
                [
                    "day,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "shad",
                    "ows"
                ],
                [
                    "thick",
                    "en"
                ],
                [
                    "round"
                ],
                [
                    "our"
                ],
                [
                    "way,"
                ]
            ],
            [
                [
                    "Faith"
                ],
                [
                    "may"
                ],
                [
                    "no"
                ],
                [
                    "dark",
                    "ness"
                ],
                [
                    "know,"
                ],
                [
                    "and"
                ],
                [
                    "night"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "faith\u2019s"
                ],
                [
                    "clear"
                ],
                [
                    "beam"
                ],
                [
                    "may"
                ],
                [
                    "bor",
                    "row"
                ],
                [
                    "light."
                ]
            ],
            [
                [
                    "Pray"
                ],
                [
                    "we"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "and"
                ],
                [
                    "the"
                ],
                [
                    "Son,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Spi",
                    "rit,"
                ],
                [
                    "Three"
                ],
                [
                    "in"
                ],
                [
                    "One;"
                ]
            ],
            [
                [
                    "Blest"
                ],
                [
                    "Tri",
                    "ni",
                    "ty,"
                ],
                [
                    "whom"
                ],
                [
                    "all"
                ],
                [
                    "o",
                    "bey,"
                ]
            ],
            [
                [
                    "Guard"
                ],
                [
                    "thou"
                ],
                [
                    "thy"
                ],
                [
                    "sheep"
                ],
                [
                    "by"
                ],
                [
                    "night"
                ],
                [
                    "and"
                ],
                [
                    "day."
                ]
            ]
        ],
        tune: [
            [
                "3",
                "2",
                "4",
                "54",
                "3",
                "45",
                "432",
                "2"
            ],
            [
                "1",
                "15",
                "5",
                "5",
                "54",
                "57",
                "54",
                "45"
            ],
            [
                "5",
                "5",
                "4",
                "54",
                "3",
                "4",
                "32",
                "1"
            ],
            [
                "3",
                "2",
                "4",
                "54",
                "3",
                "45",
                "432",
                "2"
            ]
        ],
        amen: [
            "23",
            "212"
        ],
        clef: "c7",
        tone: "4"
    },
    "o-blest-creator-of-the-light": {
        // Sunday evening, ordinary time
        title: "Lucis Creator optime",
        text: [
            [
                [
                    "O"
                ],
                [
                    "BLEST"
                ],
                [
                    "Cre",
                    "a",
                    "tor"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "light,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "mak\u2019st"
                ],
                [
                    "the"
                ],
                [
                    "day"
                ],
                [
                    "with"
                ],
                [
                    "ra",
                    "diance"
                ],
                [
                    "bright,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "o\u2019er"
                ],
                [
                    "the"
                ],
                [
                    "form",
                    "ing"
                ],
                [
                    "world"
                ],
                [
                    "didst"
                ],
                [
                    "call"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "light"
                ],
                [
                    "from"
                ],
                [
                    "cha",
                    "os"
                ],
                [
                    "first"
                ],
                [
                    "of"
                ],
                [
                    "all."
                ]
            ],
            [
                [
                    "Whose"
                ],
                [
                    "wis",
                    "dom"
                ],
                [
                    "joined"
                ],
                [
                    "in"
                ],
                [
                    "meet"
                ],
                [
                    "arr",
                    "ay"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "morn"
                ],
                [
                    "and"
                ],
                [
                    "eve,"
                ],
                [
                    "and"
                ],
                [
                    "named"
                ],
                [
                    "them"
                ],
                [
                    "day:"
                ]
            ],
            [
                [
                    "Night"
                ],
                [
                    "comes"
                ],
                [
                    "with"
                ],
                [
                    "all"
                ],
                [
                    "its"
                ],
                [
                    "dark",
                    "ling"
                ],
                [
                    "fears;"
                ]
            ],
            [
                [
                    "Re",
                    "gard"
                ],
                [
                    "Thy"
                ],
                [
                    "peo",
                    "ple\u2019s"
                ],
                [
                    "prayers"
                ],
                [
                    "and"
                ],
                [
                    "tears."
                ]
            ],
            [
                [
                    "Lest,"
                ],
                [
                    "sunk"
                ],
                [
                    "in"
                ],
                [
                    "sin,"
                ],
                [
                    "and"
                ],
                [
                    "whelmed"
                ],
                [
                    "with"
                ],
                [
                    "strife,"
                ]
            ],
            [
                [
                    "They"
                ],
                [
                    "lose"
                ],
                [
                    "the"
                ],
                [
                    "gift"
                ],
                [
                    "of"
                ],
                [
                    "end",
                    "less"
                ],
                [
                    "life;"
                ]
            ],
            [
                [
                    "While"
                ],
                [
                    "think",
                    "ing"
                ],
                [
                    "but"
                ],
                [
                    "the"
                ],
                [
                    "thoughts"
                ],
                [
                    "of"
                ],
                [
                    "time,"
                ]
            ],
            [
                [
                    "They"
                ],
                [
                    "weave"
                ],
                [
                    "new"
                ],
                [
                    "chains"
                ],
                [
                    "of"
                ],
                [
                    "woe"
                ],
                [
                    "and"
                ],
                [
                    "crime."
                ]
            ],
            [
                [
                    "But"
                ],
                [
                    "grant"
                ],
                [
                    "them"
                ],
                [
                    "grace"
                ],
                [
                    "that"
                ],
                [
                    "they"
                ],
                [
                    "may"
                ],
                [
                    "strain"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "heav'n",
                    "ly"
                ],
                [
                    "gate"
                ],
                [
                    "and"
                ],
                [
                    "prize"
                ],
                [
                    "to"
                ],
                [
                    "gain:"
                ]
            ],
            [
                [
                    "Each"
                ],
                [
                    "harm",
                    "ful"
                ],
                [
                    "lure"
                ],
                [
                    "a",
                    "side"
                ],
                [
                    "to"
                ],
                [
                    "cast,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "purge"
                ],
                [
                    "a",
                    "way"
                ],
                [
                    "each"
                ],
                [
                    "err",
                    "or"
                ],
                [
                    "past."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ],
                [
                    "ask"
                ],
                [
                    "be"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "Christ,"
                ],
                [
                    "thine"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son;"
                ]
            ],
            [
                [
                    "Who,"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "and"
                ],
                [
                    "thee,"
                ]
            ],
            [
                [
                    "Doth"
                ],
                [
                    "live"
                ],
                [
                    "and"
                ],
                [
                    "reign"
                ],
                [
                    "et",
                    "er",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "454",
                "3",
                "57",
                "7",
                "4",
                "54",
                "34",
                "4"
            ],
            [
                "48",
                "898",
                "7",
                "76",
                "5",
                "76",
                "54",
                "454"
            ],
            [
                "1",
                "132",
                "34",
                "45",
                "43",
                "4",
                "45",
                "5"
            ],
            [
                "7",
                "787",
                "5",
                "65",
                "4",
                "54",
                "34",
                "4"
            ]
        ],
        amen: [
            "45",
            "434"
        ],
        clef: "c7",
        tone: "8"
    },
    "ye-choirs-of-new-jerusalem": {
        title: "Chorus novae Jerusalem",
        text: [
            [
                [
                    "Ye"
                ],
                [
                    "Choirs"
                ],
                [
                    "of"
                ],
                [
                    "New"
                ],
                [
                    "Je",
                    "ru",
                    "sa",
                    "lem!"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "sweet"
                ],
                [
                    "new"
                ],
                [
                    "strains"
                ],
                [
                    "at",
                    "tune"
                ],
                [
                    "your"
                ],
                [
                    "theme;"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "while"
                ],
                [
                    "we"
                ],
                [
                    "keep,"
                ],
                [
                    "from"
                ],
                [
                    "care"
                ],
                [
                    "re",
                    "leas'd,"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "so",
                    "ber"
                ],
                [
                    "joy"
                ],
                [
                    "our"
                ],
                [
                    "Pas",
                    "chal"
                ],
                [
                    "Feast:"
                ]
            ],
            [
                [
                    "When"
                ],
                [
                    "Christ,"
                ],
                [
                    "Who"
                ],
                [
                    "spake"
                ],
                [
                    "the"
                ],
                [
                    "Dra",
                    "gon's"
                ],
                [
                    "doom,"
                ]
            ],
            [
                [
                    "Rose,"
                ],
                [
                    "Vic",
                    "tor-",
                    "Li",
                    "on,"
                ],
                [
                    "from"
                ],
                [
                    "the"
                ],
                [
                    "Tomb:"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "while"
                ],
                [
                    "with"
                ],
                [
                    "liv",
                    "ing"
                ],
                [
                    "voice"
                ],
                [
                    "He"
                ],
                [
                    "cries,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "dead"
                ],
                [
                    "of"
                ],
                [
                    "o",
                    "ther"
                ],
                [
                    "years"
                ],
                [
                    "might"
                ],
                [
                    "rise."
                ]
            ],
            [
                [
                    "En",
                    "gorg'd"
                ],
                [
                    "in"
                ],
                [
                    "for",
                    "mer"
                ],
                [
                    "years,"
                ],
                [
                    "their"
                ],
                [
                    "prey"
                ]
            ],
            [
                [
                    "Must"
                ],
                [
                    "Death"
                ],
                [
                    "and"
                ],
                [
                    "Hell"
                ],
                [
                    "re",
                    "store"
                ],
                [
                    "to",
                    "day:"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "ma",
                    "ny-a"
                ],
                [
                    "cap",
                    "tive"
                ],
                [
                    "soul,"
                ],
                [
                    "set"
                ],
                [
                    "free,"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "Je",
                    "sus"
                ],
                [
                    "leaves"
                ],
                [
                    "cap",
                    "ti",
                    "vi",
                    "ty."
                ]
            ],
            [
                [
                    "Right"
                ],
                [
                    "glo",
                    "rious",
                    "ly"
                ],
                [
                    "He"
                ],
                [
                    "tri",
                    "umphs"
                ],
                [
                    "now,"
                ]
            ],
            [
                [
                    "Wor",
                    "thy"
                ],
                [
                    "to"
                ],
                [
                    "Whom"
                ],
                [
                    "should"
                ],
                [
                    "all"
                ],
                [
                    "things"
                ],
                [
                    "bow;"
                ]
            ],
            [
                [
                    "And,"
                ],
                [
                    "join",
                    "ing"
                ],
                [
                    "heav'n"
                ],
                [
                    "and"
                ],
                [
                    "earth"
                ],
                [
                    "a",
                    "gain,"
                ]
            ],
            [
                [
                    "Links"
                ],
                [
                    "in"
                ],
                [
                    "one"
                ],
                [
                    "com",
                    "mon",
                    "weal"
                ],
                [
                    "the"
                ],
                [
                    "twain."
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "we,"
                ],
                [
                    "as"
                ],
                [
                    "these"
                ],
                [
                    "His"
                ],
                [
                    "deeds"
                ],
                [
                    "we"
                ],
                [
                    "sing,"
                ]
            ],
            [
                [
                    "His"
                ],
                [
                    "sup",
                    "pliant"
                ],
                [
                    "sol",
                    "diers,"
                ],
                [
                    "pray"
                ],
                [
                    "our"
                ],
                [
                    "King,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "in"
                ],
                [
                    "His"
                ],
                [
                    "Pa",
                    "lace,"
                ],
                [
                    "bright"
                ],
                [
                    "and"
                ],
                [
                    "vast,"
                ]
            ],
            [
                [
                    "We"
                ],
                [
                    "may"
                ],
                [
                    "keep"
                ],
                [
                    "watch"
                ],
                [
                    "and"
                ],
                [
                    "ward"
                ],
                [
                    "at"
                ],
                [
                    "last."
                ]
            ],
            [
                [
                    "Long"
                ],
                [
                    "as"
                ],
                [
                    "un",
                    "end",
                    "ing"
                ],
                [
                    "a",
                    "ges"
                ],
                [
                    "run,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "laud"
                ],
                [
                    "be"
                ],
                [
                    "done;"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Son"
                ],
                [
                    "our"
                ],
                [
                    "e",
                    "qual"
                ],
                [
                    "praise,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost,"
                ],
                [
                    "we"
                ],
                [
                    "raise."
                ]
            ]
        ],
        tune: [
            [
                "234",
                "32",
                "12",
                "2",
                "10",
                "1",
                "31",
                "232"
            ],
            [
                "210",
                "4",
                "5",
                "6",
                "7",
                "654",
                "7",
                "654"
            ],
            [
                "65",
                "4",
                "54",
                "321",
                "234",
                "3",
                "2",
                "1"
            ],
            [
                "5",
                "4",
                "5",
                "654",
                "5",
                "431234",
                "32",
                "2"
            ]
        ],
        amen: [
            "23",
            "212"
        ],
        clef: "c7",
        tone: "3"
    },
    "the-day-draws-on-ferias": {
        title: "Aurora lucis rutilat",
        text: [
            [
                [
                    "THE"
                ],
                [
                    "day"
                ],
                [
                    "draws"
                ],
                [
                    "on"
                ],
                [
                    "with"
                ],
                [
                    "gol",
                    "den"
                ],
                [
                    "light,"
                ]
            ],
            [
                [
                    "Glad"
                ],
                [
                    "songs"
                ],
                [
                    "go"
                ],
                [
                    "ech",
                    "oing"
                ],
                [
                    "through"
                ],
                [
                    "the"
                ],
                [
                    "height,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "broad"
                ],
                [
                    "earth"
                ],
                [
                    "lifts"
                ],
                [
                    "an"
                ],
                [
                    "ans",
                    "wering"
                ],
                [
                    "cheer,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "hell"
                ],
                [
                    "makes"
                ],
                [
                    "moan"
                ],
                [
                    "with"
                ],
                [
                    "wail",
                    "ing"
                ],
                [
                    "fear."
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "lo,"
                ],
                [
                    "he"
                ],
                [
                    "comes,"
                ],
                [
                    "the"
                ],
                [
                    "migh",
                    "ty"
                ],
                [
                    "King,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "take"
                ],
                [
                    "from"
                ],
                [
                    "death"
                ],
                [
                    "his"
                ],
                [
                    "power"
                ],
                [
                    "and"
                ],
                [
                    "sting,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "tram",
                    "ple"
                ],
                [
                    "down"
                ],
                [
                    "his"
                ],
                [
                    "gloo",
                    "my"
                ],
                [
                    "reign,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "break"
                ],
                [
                    "the"
                ],
                [
                    "wea",
                    "ry"
                ],
                [
                    "pris",
                    "'ner\u2019s"
                ],
                [
                    "chain."
                ]
            ],
            [
                [
                    "En",
                    "closed"
                ],
                [
                    "he"
                ],
                [
                    "lay"
                ],
                [
                    "in"
                ],
                [
                    "roc",
                    "ky"
                ],
                [
                    "cell,"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "guard"
                ],
                [
                    "of"
                ],
                [
                    "arm",
                    "\xe8d"
                ],
                [
                    "sen",
                    "ti",
                    "nel;"
                ]
            ],
            [
                [
                    "But"
                ],
                [
                    "thence"
                ],
                [
                    "re",
                    "turn",
                    "ing,"
                ],
                [
                    "strong"
                ],
                [
                    "and"
                ],
                [
                    "free,"
                ]
            ],
            [
                [
                    "He"
                ],
                [
                    "comes"
                ],
                [
                    "in"
                ],
                [
                    "might"
                ],
                [
                    "of"
                ],
                [
                    "vic",
                    "to",
                    "ry."
                ]
            ],
            [
                [
                    "Ma",
                    "ker"
                ],
                [
                    "of"
                ],
                [
                    "all,"
                ],
                [
                    "to"
                ],
                [
                    "thee"
                ],
                [
                    "we"
                ],
                [
                    "pray,"
                ]
            ],
            [
                [
                    "Ful",
                    "fil"
                ],
                [
                    "in"
                ],
                [
                    "us"
                ],
                [
                    "thy"
                ],
                [
                    "joy"
                ],
                [
                    "to",
                    "day;"
                ]
            ],
            [
                [
                    "When"
                ],
                [
                    "death"
                ],
                [
                    "ass",
                    "ails,"
                ],
                [
                    "grant,"
                ],
                [
                    "Lord,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "share"
                ],
                [
                    "thy"
                ],
                [
                    "Pas",
                    "chal"
                ],
                [
                    "vic",
                    "to",
                    "ry."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "thee"
                ],
                [
                    "who,"
                ],
                [
                    "dead,"
                ],
                [
                    "a",
                    "gain"
                ],
                [
                    "dost"
                ],
                [
                    "live,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry,"
                ],
                [
                    "Lord,"
                ],
                [
                    "thy"
                ],
                [
                    "peo",
                    "ple"
                ],
                [
                    "give,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "be"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "blest,"
                ],
                [
                    "e",
                    "ter",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "4",
                "4",
                "5",
                "6",
                "7",
                "6",
                "5",
                "4"
            ],
            [
                "7",
                "7",
                "7",
                "6",
                "4",
                "5",
                "7",
                "7876"
            ],
            [
                "5",
                "6",
                "7",
                "8",
                "6",
                "7",
                "6",
                "5"
            ],
            [
                "5",
                "6",
                "7",
                "6",
                "5",
                "6",
                "5",
                "4"
            ]
        ],
        amen: [
            "45",
            "434"
        ],
        clef: "c7",
        tone: "8"
    },
    "the-day-draws-on-apostles": {
        title: "Aurora lucis rutilat (Apostles)",
        text: [
            [
                [
                    "THE"
                ],
                [
                    "day"
                ],
                [
                    "draws"
                ],
                [
                    "on"
                ],
                [
                    "with"
                ],
                [
                    "gol",
                    "den"
                ],
                [
                    "light,"
                ]
            ],
            [
                [
                    "Glad"
                ],
                [
                    "songs"
                ],
                [
                    "go"
                ],
                [
                    "ech",
                    "oing"
                ],
                [
                    "through"
                ],
                [
                    "the"
                ],
                [
                    "height,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "broad"
                ],
                [
                    "earth"
                ],
                [
                    "lifts"
                ],
                [
                    "an"
                ],
                [
                    "ans",
                    "wering"
                ],
                [
                    "cheer,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "hell"
                ],
                [
                    "makes"
                ],
                [
                    "moan"
                ],
                [
                    "with"
                ],
                [
                    "wail",
                    "ing"
                ],
                [
                    "fear."
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "lo,"
                ],
                [
                    "he"
                ],
                [
                    "comes,"
                ],
                [
                    "the"
                ],
                [
                    "migh",
                    "ty"
                ],
                [
                    "King,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "take"
                ],
                [
                    "from"
                ],
                [
                    "death"
                ],
                [
                    "his"
                ],
                [
                    "power"
                ],
                [
                    "and"
                ],
                [
                    "sting,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "tram",
                    "ple"
                ],
                [
                    "down"
                ],
                [
                    "his"
                ],
                [
                    "gloo",
                    "my"
                ],
                [
                    "reign,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "break"
                ],
                [
                    "the"
                ],
                [
                    "wea",
                    "ry"
                ],
                [
                    "pris",
                    "'ner\u2019s"
                ],
                [
                    "chain."
                ]
            ],
            [
                [
                    "En",
                    "closed"
                ],
                [
                    "he"
                ],
                [
                    "lay"
                ],
                [
                    "in"
                ],
                [
                    "roc",
                    "ky"
                ],
                [
                    "cell,"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "guard"
                ],
                [
                    "of"
                ],
                [
                    "arm",
                    "\xe8d"
                ],
                [
                    "sen",
                    "ti",
                    "nel;"
                ]
            ],
            [
                [
                    "But"
                ],
                [
                    "thence"
                ],
                [
                    "re",
                    "turn",
                    "ing,"
                ],
                [
                    "strong"
                ],
                [
                    "and"
                ],
                [
                    "free,"
                ]
            ],
            [
                [
                    "He"
                ],
                [
                    "comes"
                ],
                [
                    "in"
                ],
                [
                    "might"
                ],
                [
                    "of"
                ],
                [
                    "vic",
                    "to",
                    "ry."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "sad"
                ],
                [
                    "A",
                    "po",
                    "stles"
                ],
                [
                    "mourn"
                ],
                [
                    "him"
                ],
                [
                    "slain,"
                ]
            ],
            [
                [
                    "Nor"
                ],
                [
                    "hope"
                ],
                [
                    "to"
                ],
                [
                    "see"
                ],
                [
                    "their"
                ],
                [
                    "Lord"
                ],
                [
                    "a",
                    "gain,"
                ]
            ],
            [
                [
                    "When,"
                ],
                [
                    "to"
                ],
                [
                    "their"
                ],
                [
                    "ve",
                    "ry"
                ],
                [
                    "eyes"
                ],
                [
                    "re",
                    "stored,"
                ]
            ],
            [
                [
                    "They"
                ],
                [
                    "look"
                ],
                [
                    "up",
                    "on"
                ],
                [
                    "the"
                ],
                [
                    "ri",
                    "sen"
                ],
                [
                    "Lord."
                ]
            ],
            [
                [
                    "But"
                ],
                [
                    "now"
                ],
                [
                    "they"
                ],
                [
                    "put"
                ],
                [
                    "their"
                ],
                [
                    "grief"
                ],
                [
                    "a",
                    "way,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "pains"
                ],
                [
                    "of"
                ],
                [
                    "hell"
                ],
                [
                    "are"
                ],
                [
                    "loosed"
                ],
                [
                    "to",
                    "day;"
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "by"
                ],
                [
                    "the"
                ],
                [
                    "grave,"
                ],
                [
                    "with"
                ],
                [
                    "flash",
                    "ing"
                ],
                [
                    "eyes,"
                ]
            ],
            [
                [
                    '"Your'
                ],
                [
                    "Lord"
                ],
                [
                    "is"
                ],
                [
                    "ris'n\""
                ],
                [
                    "the"
                ],
                [
                    "An",
                    "gel"
                ],
                [
                    "cries."
                ]
            ],
            [
                [
                    "Ma",
                    "ker"
                ],
                [
                    "of"
                ],
                [
                    "all,"
                ],
                [
                    "to"
                ],
                [
                    "thee"
                ],
                [
                    "we"
                ],
                [
                    "pray,"
                ]
            ],
            [
                [
                    "Ful",
                    "fil"
                ],
                [
                    "in"
                ],
                [
                    "us"
                ],
                [
                    "thy"
                ],
                [
                    "joy"
                ],
                [
                    "to",
                    "day;"
                ]
            ],
            [
                [
                    "When"
                ],
                [
                    "death"
                ],
                [
                    "ass",
                    "ails,"
                ],
                [
                    "grant,"
                ],
                [
                    "Lord,"
                ],
                [
                    "that"
                ],
                [
                    "we"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "share"
                ],
                [
                    "thy"
                ],
                [
                    "Pas",
                    "chal"
                ],
                [
                    "vic",
                    "to",
                    "ry."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "thee"
                ],
                [
                    "who,"
                ],
                [
                    "dead,"
                ],
                [
                    "a",
                    "gain"
                ],
                [
                    "dost"
                ],
                [
                    "live,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry,"
                ],
                [
                    "Lord,"
                ],
                [
                    "thy"
                ],
                [
                    "peo",
                    "ple"
                ],
                [
                    "give,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "be"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "blest,"
                ],
                [
                    "e",
                    "ter",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "4",
                "4",
                "5",
                "6",
                "7",
                "6",
                "5",
                "4"
            ],
            [
                "7",
                "7",
                "7",
                "6",
                "4",
                "5",
                "7",
                "7876"
            ],
            [
                "5",
                "6",
                "7",
                "8",
                "6",
                "7",
                "6",
                "5"
            ],
            [
                "5",
                "6",
                "7",
                "6",
                "5",
                "6",
                "5",
                "4"
            ]
        ],
        amen: [
            "45",
            "434"
        ],
        clef: "c7",
        tone: "8"
    },
    "eternal-monarch-king-most-high": {
        title: "Aeterne Rex altissime",
        text: [
            [
                [
                    "E",
                    "ter",
                    "nal"
                ],
                [
                    "Mon",
                    "arch,"
                ],
                [
                    "King"
                ],
                [
                    "most"
                ],
                [
                    "high,"
                ]
            ],
            [
                [
                    "Whose"
                ],
                [
                    "blood"
                ],
                [
                    "hath"
                ],
                [
                    "brought"
                ],
                [
                    "re",
                    "demp",
                    "tion"
                ],
                [
                    "nigh,"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "whom"
                ],
                [
                    "the"
                ],
                [
                    "death"
                ],
                [
                    "of"
                ],
                [
                    "Death"
                ],
                [
                    "was"
                ],
                [
                    "wrought"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "con",
                    "quering"
                ],
                [
                    "gra",
                    "ce\u2019s"
                ],
                [
                    "bat",
                    "tle"
                ],
                [
                    "fought:"
                ]
            ],
            [
                [
                    "A",
                    "scend",
                    "ing"
                ],
                [
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "throne"
                ],
                [
                    "of"
                ],
                [
                    "might,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "seat",
                    "ed"
                ],
                [
                    "at"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther\u2019s"
                ],
                [
                    "right,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "power"
                ],
                [
                    "in"
                ],
                [
                    "heaven"
                ],
                [
                    "is"
                ],
                [
                    "Jes",
                    "u\u2019s"
                ],
                [
                    "own,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "here"
                ],
                [
                    "his"
                ],
                [
                    "man",
                    "hood"
                ],
                [
                    "had"
                ],
                [
                    "not"
                ],
                [
                    "known."
                ]
            ],
            [
                [
                    "Yea,"
                ],
                [
                    "an",
                    "gels"
                ],
                [
                    "trem",
                    "ble"
                ],
                [
                    "when"
                ],
                [
                    "they"
                ],
                [
                    "see"
                ]
            ],
            [
                [
                    "How"
                ],
                [
                    "changed"
                ],
                [
                    "is"
                ],
                [
                    "our"
                ],
                [
                    "hu",
                    "ma",
                    "ni",
                    "ty;"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "flesh"
                ],
                [
                    "hath"
                ],
                [
                    "purged"
                ],
                [
                    "what"
                ],
                [
                    "flesh"
                ],
                [
                    "had"
                ],
                [
                    "stained,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "God,"
                ],
                [
                    "the"
                ],
                [
                    "flesh"
                ],
                [
                    "of"
                ],
                [
                    "God,"
                ],
                [
                    "hath"
                ],
                [
                    "reigned."
                ]
            ],
            [
                [
                    "Be"
                ],
                [
                    "thou"
                ],
                [
                    "our"
                ],
                [
                    "joy"
                ],
                [
                    "and"
                ],
                [
                    "strong"
                ],
                [
                    "de",
                    "fence,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "art"
                ],
                [
                    "our"
                ],
                [
                    "fu",
                    "ture"
                ],
                [
                    "re",
                    "com",
                    "pense:"
                ]
            ],
            [
                [
                    "So"
                ],
                [
                    "shall"
                ],
                [
                    "the"
                ],
                [
                    "light"
                ],
                [
                    "that"
                ],
                [
                    "springs"
                ],
                [
                    "from"
                ],
                [
                    "thee"
                ]
            ],
            [
                [
                    "Be"
                ],
                [
                    "ours"
                ],
                [
                    "through"
                ],
                [
                    "all"
                ],
                [
                    "e",
                    "ter",
                    "ni",
                    "ty."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "ris",
                    "en"
                ],
                [
                    "Christ,"
                ],
                [
                    "a",
                    "scen",
                    "ded"
                ],
                [
                    "Lord,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "praise"
                ],
                [
                    "to"
                ],
                [
                    "thee"
                ],
                [
                    "let"
                ],
                [
                    "earth"
                ],
                [
                    "ac",
                    "cord,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "art,"
                ],
                [
                    "while"
                ],
                [
                    "end",
                    "less"
                ],
                [
                    "ag",
                    "es"
                ],
                [
                    "run,"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "and"
                ],
                [
                    "with"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "One."
                ]
            ]
        ],
        tune: [
            [
                "4",
                "45675",
                "43",
                "54",
                "567654",
                "54",
                "34",
                "4"
            ],
            [
                "4",
                "476",
                "78",
                "8",
                "76",
                "54",
                "57",
                "7"
            ],
            [
                "7",
                "5",
                "7",
                "4",
                "45",
                "54",
                "34",
                "4"
            ],
            [
                "3",
                "54",
                "57",
                "76",
                "54",
                "54",
                "34",
                "4"
            ]
        ],
        amen: [
            "45",
            "434"
        ],
        clef: "c7",
        tone: "8"
    },
    "when-christ-our-lord-had-passed-once-more": {
        title: "Jam Christus astra ascenderat",
        text: [
            [
                [
                    "When"
                ],
                [
                    "Christ"
                ],
                [
                    "our"
                ],
                [
                    "Lord"
                ],
                [
                    "had"
                ],
                [
                    "passed"
                ],
                [
                    "once"
                ],
                [
                    "more"
                ]
            ],
            [
                [
                    "In",
                    "to"
                ],
                [
                    "the"
                ],
                [
                    "heaven"
                ],
                [
                    "He"
                ],
                [
                    "left"
                ],
                [
                    "be",
                    "fore,"
                ]
            ],
            [
                [
                    "He"
                ],
                [
                    "sent"
                ],
                [
                    "a"
                ],
                [
                    "Com",
                    "for",
                    "ter"
                ],
                [
                    "below"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Fa",
                    "ther\u2019s"
                ],
                [
                    "pro",
                    "mise"
                ],
                [
                    "to"
                ],
                [
                    "be",
                    "stow."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "so",
                    "lemn"
                ],
                [
                    "time"
                ],
                [
                    "was"
                ],
                [
                    "soon"
                ],
                [
                    "to"
                ],
                [
                    "fall"
                ]
            ],
            [
                [
                    "Which"
                ],
                [
                    "told"
                ],
                [
                    "the"
                ],
                [
                    "num",
                    "ber"
                ],
                [
                    "my",
                    "sti",
                    "cal"
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "since"
                ],
                [
                    "the"
                ],
                [
                    "re",
                    "sur",
                    "rec",
                    "tion"
                ],
                [
                    "day"
                ]
            ],
            [
                [
                    "A"
                ],
                [
                    "week"
                ],
                [
                    "of"
                ],
                [
                    "weeks"
                ],
                [
                    "had"
                ],
                [
                    "passed"
                ],
                [
                    "a",
                    "way."
                ]
            ],
            [
                [
                    "At"
                ],
                [
                    "the"
                ],
                [
                    "third"
                ],
                [
                    "hour"
                ],
                [
                    "a"
                ],
                [
                    "rush",
                    "ing"
                ],
                [
                    "noise"
                ]
            ],
            [
                [
                    "Came"
                ],
                [
                    "like"
                ],
                [
                    "the"
                ],
                [
                    "tem",
                    "pest\u2019s"
                ],
                [
                    "sud",
                    "den"
                ],
                [
                    "voice,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "min",
                    "gled"
                ],
                [
                    "with"
                ],
                [
                    "the-a",
                    "pos",
                    "tles\u2019"
                ],
                [
                    "prayer,"
                ]
            ],
            [
                [
                    "Pro",
                    "claim",
                    "ing"
                ],
                [
                    "loud"
                ],
                [
                    "that"
                ],
                [
                    "God"
                ],
                [
                    "was"
                ],
                [
                    "there."
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "out"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther\u2019s"
                ],
                [
                    "light"
                ],
                [
                    "it"
                ],
                [
                    "came,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "beau",
                    "ti",
                    "ful"
                ],
                [
                    "and"
                ],
                [
                    "kind",
                    "ly"
                ],
                [
                    "flame,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "kin",
                    "dle"
                ],
                [
                    "eve",
                    "ry"
                ],
                [
                    "Christ",
                    "ian"
                ],
                [
                    "heart,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "fer",
                    "vor"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "Word"
                ],
                [
                    "im",
                    "part."
                ]
            ],
            [
                [
                    "As"
                ],
                [
                    "then,"
                ],
                [
                    "O"
                ],
                [
                    "Lord,"
                ],
                [
                    "Thou"
                ],
                [
                    "didst"
                ],
                [
                    "ful",
                    "fill,"
                ]
            ],
            [
                [
                    "Each"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "heart"
                ],
                [
                    "to"
                ],
                [
                    "do"
                ],
                [
                    "Thy"
                ],
                [
                    "will,"
                ]
            ],
            [
                [
                    "So"
                ],
                [
                    "now"
                ],
                [
                    "do"
                ],
                [
                    "Thou"
                ],
                [
                    "our"
                ],
                [
                    "sins"
                ],
                [
                    "for",
                    "give"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "make"
                ],
                [
                    "the"
                ],
                [
                    "world"
                ],
                [
                    "in"
                ],
                [
                    "peace"
                ],
                [
                    "to"
                ],
                [
                    "live."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Son,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Spi",
                    "rit,"
                ],
                [
                    "praise"
                ],
                [
                    "be"
                ],
                [
                    "done;"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "Christ"
                ],
                [
                    "the"
                ],
                [
                    "Lord"
                ],
                [
                    "up",
                    "on"
                ],
                [
                    "us"
                ],
                [
                    "pour"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Spi",
                    "rit\u2019s"
                ],
                [
                    "gift"
                ],
                [
                    "for",
                    "ev",
                    "er",
                    "more."
                ]
            ]
        ],
        tune: [
            [
                "1",
                "1",
                "3",
                "1",
                "10",
                "3",
                "4",
                "5"
            ],
            [
                "54",
                "7",
                "78",
                "7",
                "76",
                "5",
                "4",
                "5"
            ],
            [
                "5",
                "5",
                "5765",
                "43",
                "21",
                "3",
                "21",
                "12"
            ],
            [
                "0",
                "21",
                "4",
                "454",
                "32",
                "1",
                "0",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "rejoice-the-year-upon-its-way": {
        title: "Beata nobis gaudia",
        text: [
            [
                [
                    "Re",
                    "joice!"
                ],
                [
                    "the"
                ],
                [
                    "year"
                ],
                [
                    "up",
                    "on"
                ],
                [
                    "its"
                ],
                [
                    "way"
                ]
            ],
            [
                [
                    "Has"
                ],
                [
                    "brought"
                ],
                [
                    "a",
                    "gain"
                ],
                [
                    "that"
                ],
                [
                    "bless",
                    "\xe8d"
                ],
                [
                    "day,"
                ]
            ],
            [
                [
                    "When"
                ],
                [
                    "on"
                ],
                [
                    "the"
                ],
                [
                    "cho",
                    "sen"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "Lord"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Spi",
                    "rit"
                ],
                [
                    "was"
                ],
                [
                    "out",
                    "poured."
                ]
            ],
            [
                [
                    "On"
                ],
                [
                    "each"
                ],
                [
                    "the"
                ],
                [
                    "fire,"
                ],
                [
                    "de",
                    "scend",
                    "ing,"
                ],
                [
                    "stood"
                ]
            ],
            [
                [
                    "In"
                ],
                [
                    "qui",
                    "v'ring"
                ],
                [
                    "tongues\u2019"
                ],
                [
                    "si",
                    "mi",
                    "li",
                    "tude,"
                ]
            ],
            [
                [
                    "Tongues,"
                ],
                [
                    "that"
                ],
                [
                    "their"
                ],
                [
                    "words"
                ],
                [
                    "might"
                ],
                [
                    "rea",
                    "dy"
                ],
                [
                    "prove,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "fire,"
                ],
                [
                    "to"
                ],
                [
                    "make"
                ],
                [
                    "them"
                ],
                [
                    "flame"
                ],
                [
                    "with"
                ],
                [
                    "love."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "all"
                ],
                [
                    "in"
                ],
                [
                    "eve",
                    "ry"
                ],
                [
                    "tongue"
                ],
                [
                    "they"
                ],
                [
                    "spoke;"
                ]
            ],
            [
                [
                    "A",
                    "maze",
                    "ment"
                ],
                [
                    "in"
                ],
                [
                    "the"
                ],
                [
                    "crowd"
                ],
                [
                    "a",
                    "woke,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "mocked,"
                ],
                [
                    "as"
                ],
                [
                    "o",
                    "ver",
                    "come"
                ],
                [
                    "with"
                ],
                [
                    "wine,"
                ]
            ],
            [
                [
                    "Those"
                ],
                [
                    "who"
                ],
                [
                    "were"
                ],
                [
                    "filled"
                ],
                [
                    "with"
                ],
                [
                    "power"
                ],
                [
                    "di",
                    "vine."
                ]
            ],
            [
                [
                    "These"
                ],
                [
                    "things"
                ],
                [
                    "were"
                ],
                [
                    "done"
                ],
                [
                    "in"
                ],
                [
                    "type"
                ],
                [
                    "that"
                ],
                [
                    "day,"
                ]
            ],
            [
                [
                    "When"
                ],
                [
                    "Eas",
                    "ter",
                    "tide"
                ],
                [
                    "had"
                ],
                [
                    "passed"
                ],
                [
                    "a",
                    "way,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "num",
                    "ber"
                ],
                [
                    "told"
                ],
                [
                    "which"
                ],
                [
                    "once"
                ],
                [
                    "set"
                ],
                [
                    "free"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "cap",
                    "tive"
                ],
                [
                    "at"
                ],
                [
                    "the"
                ],
                [
                    "ju",
                    "bi",
                    "lee."
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "now,"
                ],
                [
                    "O"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "God,"
                ],
                [
                    "this"
                ],
                [
                    "day"
                ]
            ],
            [
                [
                    "Re",
                    "gard"
                ],
                [
                    "us"
                ],
                [
                    "as"
                ],
                [
                    "we"
                ],
                [
                    "humb",
                    "ly"
                ],
                [
                    "pray,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "send"
                ],
                [
                    "us,"
                ],
                [
                    "from"
                ],
                [
                    "Thy"
                ],
                [
                    "heav'n",
                    "ly"
                ],
                [
                    "seat,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "bless",
                    "ings"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "Pa",
                    "ra",
                    "clete."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Son,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Spi",
                    "rit,"
                ],
                [
                    "praise"
                ],
                [
                    "be"
                ],
                [
                    "done;"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "Christ"
                ],
                [
                    "the"
                ],
                [
                    "Lord"
                ],
                [
                    "up",
                    "on"
                ],
                [
                    "us"
                ],
                [
                    "pour"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Spi",
                    "rit\u2019s"
                ],
                [
                    "gift"
                ],
                [
                    "for",
                    "ev",
                    "er",
                    "more."
                ]
            ]
        ],
        tune: [
            [
                "23",
                "378b",
                "7",
                "7",
                "76",
                "67",
                "6",
                "65"
            ],
            [
                "7",
                "7",
                "6",
                "54",
                "3",
                "45",
                "32",
                "23"
            ],
            [
                "0",
                "23",
                "3",
                "35",
                "53",
                "4",
                "3",
                "2"
            ],
            [
                "6",
                "6",
                "5",
                "676",
                "43",
                "45",
                "32",
                "23"
            ]
        ],
        amen: [
            "34",
            "323"
        ],
        clef: "f5",
        tone: "8"
    },
    "creator-of-the-stars-of-night": {
        title: "Conditor alme siderum",
        text: [
            [
                [
                    "Cre",
                    "a",
                    "tor"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "stars"
                ],
                [
                    "of"
                ],
                [
                    "night,"
                ]
            ],
            [
                [
                    "Thy"
                ],
                [
                    "peo",
                    "ple\u2019s"
                ],
                [
                    "ev",
                    "er",
                    "last",
                    "ing"
                ],
                [
                    "light,"
                ]
            ],
            [
                [
                    "Je",
                    "su,"
                ],
                [
                    "Re",
                    "dee",
                    "mer,"
                ],
                [
                    "save"
                ],
                [
                    "us"
                ],
                [
                    "all,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "hear"
                ],
                [
                    "thy"
                ],
                [
                    "ser",
                    "vants"
                ],
                [
                    "when"
                ],
                [
                    "they"
                ],
                [
                    "call."
                ]
            ],
            [
                [
                    "Thou,"
                ],
                [
                    "griev",
                    "ing"
                ],
                [
                    "that"
                ],
                [
                    "the"
                ],
                [
                    "an",
                    "cient"
                ],
                [
                    "curse"
                ]
            ],
            [
                [
                    "Should"
                ],
                [
                    "doom"
                ],
                [
                    "to"
                ],
                [
                    "death"
                ],
                [
                    "a"
                ],
                [
                    "u",
                    "ni",
                    "verse,"
                ]
            ],
            [
                [
                    "Hast"
                ],
                [
                    "found"
                ],
                [
                    "the"
                ],
                [
                    "med'",
                    "cine,"
                ],
                [
                    "full"
                ],
                [
                    "of"
                ],
                [
                    "grace,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "save"
                ],
                [
                    "and"
                ],
                [
                    "heal"
                ],
                [
                    "a"
                ],
                [
                    "ru",
                    "ined"
                ],
                [
                    "race."
                ]
            ],
            [
                [
                    "Thou"
                ],
                [
                    "cam\u2019st,"
                ],
                [
                    "the"
                ],
                [
                    "Bride",
                    "groom"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "bride,"
                ]
            ],
            [
                [
                    "As"
                ],
                [
                    "drew"
                ],
                [
                    "the"
                ],
                [
                    "world"
                ],
                [
                    "to"
                ],
                [
                    "eve",
                    "ning-",
                    "tide;"
                ]
            ],
            [
                [
                    "Pro",
                    "ceed",
                    "ing"
                ],
                [
                    "from"
                ],
                [
                    "a"
                ],
                [
                    "vir",
                    "gin"
                ],
                [
                    "shrine,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "spot",
                    "less"
                ],
                [
                    "vic",
                    "tim"
                ],
                [
                    "all"
                ],
                [
                    "di",
                    "vine."
                ]
            ],
            [
                [
                    "At"
                ],
                [
                    "whose"
                ],
                [
                    "dread"
                ],
                [
                    "name,"
                ],
                [
                    "ma",
                    "jes",
                    "tic"
                ],
                [
                    "now,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "knees"
                ],
                [
                    "must"
                ],
                [
                    "bend,"
                ],
                [
                    "all"
                ],
                [
                    "hearts"
                ],
                [
                    "must"
                ],
                [
                    "bow;"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "things"
                ],
                [
                    "ce",
                    "les",
                    "tial"
                ],
                [
                    "Thee"
                ],
                [
                    "shall"
                ],
                [
                    "own,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "things"
                ],
                [
                    "ter",
                    "res",
                    "trial,"
                ],
                [
                    "Lord"
                ],
                [
                    "a",
                    "lone."
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Thou"
                ],
                [
                    "whose"
                ],
                [
                    "com",
                    "ing"
                ],
                [
                    "is"
                ],
                [
                    "with"
                ],
                [
                    "dread"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "judge"
                ],
                [
                    "and"
                ],
                [
                    "doom"
                ],
                [
                    "the"
                ],
                [
                    "quick"
                ],
                [
                    "and"
                ],
                [
                    "dead,"
                ]
            ],
            [
                [
                    "Pre",
                    "serve"
                ],
                [
                    "us,"
                ],
                [
                    "while"
                ],
                [
                    "we"
                ],
                [
                    "dwell"
                ],
                [
                    "be",
                    "low,"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "ev",
                    "'ry"
                ],
                [
                    "in",
                    "sult"
                ],
                [
                    "of"
                ],
                [
                    "the"
                ],
                [
                    "foe."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Son,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Spi",
                    "rit,"
                ],
                [
                    "Three"
                ],
                [
                    "in"
                ],
                [
                    "One,"
                ]
            ],
            [
                [
                    "Laud,"
                ],
                [
                    "ho",
                    "nor,"
                ],
                [
                    "might,"
                ],
                [
                    "and"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "be"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "age"
                ],
                [
                    "to"
                ],
                [
                    "age"
                ],
                [
                    "e",
                    "ter",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "4",
                "2",
                "4",
                "6",
                "7",
                "7",
                "5",
                "6"
            ],
            [
                "6",
                "7",
                "5",
                "6",
                "5",
                "4",
                "3",
                "4"
            ],
            [
                "6",
                "5",
                "3",
                "4",
                "5",
                "4",
                "3",
                "2"
            ],
            [
                "2",
                "4",
                "5",
                "6",
                "5",
                "4",
                "3",
                "4"
            ]
        ],
        amen: [
            "45",
            "434"
        ],
        clef: "f5",
        tone: "4"
    },
    "to-earth-descending-word-sublime": {
        title: "Verbum supernum prodiens",
        text: [
            [
                [
                    "To"
                ],
                [
                    "earth"
                ],
                [
                    "de",
                    "scend",
                    "ing,"
                ],
                [
                    "Word"
                ],
                [
                    "sub",
                    "lime,"
                ]
            ],
            [
                [
                    "Be",
                    "got",
                    "ten"
                ],
                [
                    "ere"
                ],
                [
                    "the"
                ],
                [
                    "days"
                ],
                [
                    "of"
                ],
                [
                    "time,"
                ]
            ],
            [
                [
                    "Who"
                ],
                [
                    "cam\u2019st"
                ],
                [
                    "a"
                ],
                [
                    "Child,"
                ],
                [
                    "the"
                ],
                [
                    "world"
                ],
                [
                    "to"
                ],
                [
                    "aid,"
                ]
            ],
            [
                [
                    "As"
                ],
                [
                    "years"
                ],
                [
                    "their"
                ],
                [
                    "down",
                    "ward"
                ],
                [
                    "course"
                ],
                [
                    "dis",
                    "play\u2019d:"
                ]
            ],
            [
                [
                    "Each"
                ],
                [
                    "breast"
                ],
                [
                    "be"
                ],
                [
                    "light",
                    "en\u2019d"
                ],
                [
                    "from"
                ],
                [
                    "a",
                    "bove,"
                ]
            ],
            [
                [
                    "Each"
                ],
                [
                    "heart"
                ],
                [
                    "be"
                ],
                [
                    "kin",
                    "dled"
                ],
                [
                    "with"
                ],
                [
                    "Thy"
                ],
                [
                    "love;"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "we,"
                ],
                [
                    "who"
                ],
                [
                    "hear"
                ],
                [
                    "Thy"
                ],
                [
                    "call"
                ],
                [
                    "to-",
                    "day,"
                ]
            ],
            [
                [
                    "At"
                ],
                [
                    "length"
                ],
                [
                    "may"
                ],
                [
                    "cast"
                ],
                [
                    "earth\u2019s"
                ],
                [
                    "joys"
                ],
                [
                    "a",
                    "way."
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "so,"
                ],
                [
                    "when"
                ],
                [
                    "Thou,"
                ],
                [
                    "our"
                ],
                [
                    "Judge,"
                ],
                [
                    "art"
                ],
                [
                    "nigh,"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "sec",
                    "ret"
                ],
                [
                    "deeds"
                ],
                [
                    "of"
                ],
                [
                    "men"
                ],
                [
                    "to"
                ],
                [
                    "try,"
                ]
            ],
            [
                [
                    "Shalt"
                ],
                [
                    "mete"
                ],
                [
                    "to"
                ],
                [
                    "sin"
                ],
                [
                    "pangs"
                ],
                [
                    "right",
                    "ly"
                ],
                [
                    "won,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "just"
                ],
                [
                    "men"
                ],
                [
                    "joy"
                ],
                [
                    "for"
                ],
                [
                    "deeds"
                ],
                [
                    "well"
                ],
                [
                    "done,"
                ]
            ],
            [
                [
                    "Thy"
                ],
                [
                    "ser",
                    "vants"
                ],
                [
                    "may"
                ],
                [
                    "not"
                ],
                [
                    "be"
                ],
                [
                    "en",
                    "chain\u2019d"
                ]
            ],
            [
                [
                    "By"
                ],
                [
                    "pu",
                    "nish",
                    "ment"
                ],
                [
                    "their"
                ],
                [
                    "guilt"
                ],
                [
                    "has"
                ],
                [
                    "gain\u2019d:"
                ]
            ],
            [
                [
                    "But"
                ],
                [
                    "with"
                ],
                [
                    "the"
                ],
                [
                    "bless",
                    "ed"
                ],
                [
                    "e",
                    "ver",
                    "more"
                ]
            ],
            [
                [
                    "May"
                ],
                [
                    "serve"
                ],
                [
                    "and"
                ],
                [
                    "love"
                ],
                [
                    "Thee,"
                ],
                [
                    "and"
                ],
                [
                    "a",
                    "dore."
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "Him"
                ],
                [
                    "Who"
                ],
                [
                    "comes"
                ],
                [
                    "the"
                ],
                [
                    "world"
                ],
                [
                    "to"
                ],
                [
                    "free,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Son,"
                ],
                [
                    "all"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "be:"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "as"
                ],
                [
                    "is"
                ],
                [
                    "meet,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Bless",
                    "ed"
                ],
                [
                    "Pa",
                    "ra",
                    "clete."
                ]
            ]
        ],
        tune: [
            [
                "2",
                "0",
                "2",
                "4",
                "5",
                "6",
                "5",
                "5"
            ],
            [
                "4",
                "5",
                "7",
                "7",
                "64",
                "5",
                "6",
                "5"
            ],
            [
                "5",
                "5",
                "6",
                "4",
                "24",
                "3",
                "2",
                "1"
            ],
            [
                "2",
                "0",
                "2",
                "4",
                "5",
                "6",
                "5",
                "5"
            ]
        ],
        amen: [
            "56",
            "545"
        ],
        clef: "c7",
        tone: "2"
    },
    "jesu-the-fathers-only-son": {
        title: "Christe Redemptor omnium",
        text: [
            [
                [
                    "Je",
                    "su,"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther\u2019s"
                ],
                [
                    "on",
                    "ly"
                ],
                [
                    "Son,"
                ]
            ],
            [
                [
                    "Whose"
                ],
                [
                    "death"
                ],
                [
                    "for"
                ],
                [
                    "all"
                ],
                [
                    "re",
                    "demp",
                    "tion"
                ],
                [
                    "won;"
                ]
            ],
            [
                [
                    "Be",
                    "fore"
                ],
                [
                    "the"
                ],
                [
                    "worlds"
                ],
                [
                    "of"
                ],
                [
                    "God"
                ],
                [
                    "most"
                ],
                [
                    "high"
                ]
            ],
            [
                [
                    "Be",
                    "got",
                    "ten"
                ],
                [
                    "all"
                ],
                [
                    "in",
                    "eff",
                    "ab",
                    "ly."
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Fa",
                    "ther\u2019s"
                ],
                [
                    "light"
                ],
                [
                    "and"
                ],
                [
                    "splen",
                    "dor"
                ],
                [
                    "Thou,"
                ]
            ],
            [
                [
                    "Their"
                ],
                [
                    "end",
                    "less"
                ],
                [
                    "hope"
                ],
                [
                    "to"
                ],
                [
                    "Thee"
                ],
                [
                    "that"
                ],
                [
                    "bow;"
                ]
            ],
            [
                [
                    "Ac",
                    "cept"
                ],
                [
                    "the"
                ],
                [
                    "pray'rs"
                ],
                [
                    "and"
                ],
                [
                    "praise"
                ],
                [
                    "to",
                    "day"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "through"
                ],
                [
                    "the"
                ],
                [
                    "world"
                ],
                [
                    "Thy"
                ],
                [
                    "ser",
                    "vants"
                ],
                [
                    "pray."
                ]
            ],
            [
                [
                    "Sal",
                    "va",
                    "tion\u2019s"
                ],
                [
                    "au",
                    "thor,"
                ],
                [
                    "call"
                ],
                [
                    "to"
                ],
                [
                    "mind"
                ]
            ],
            [
                [
                    "How,"
                ],
                [
                    "tak",
                    "ing"
                ],
                [
                    "form"
                ],
                [
                    "of"
                ],
                [
                    "hu",
                    "man",
                    "kind,"
                ]
            ],
            [
                [
                    "Born"
                ],
                [
                    "of"
                ],
                [
                    "a"
                ],
                [
                    "vir",
                    "gin"
                ],
                [
                    "un",
                    "de",
                    "filed,"
                ]
            ],
            [
                [
                    "Thou"
                ],
                [
                    "in"
                ],
                [
                    "man\u2019s"
                ],
                [
                    "flesh"
                ],
                [
                    "be",
                    "cam\u2019st"
                ],
                [
                    "a"
                ],
                [
                    "child."
                ]
            ],
            [
                [
                    "Thus"
                ],
                [
                    "tes",
                    "ti",
                    "fies"
                ],
                [
                    "the"
                ],
                [
                    "pre",
                    "sent"
                ],
                [
                    "day,"
                ]
            ],
            [
                [
                    "Through"
                ],
                [
                    "ev'",
                    "ry"
                ],
                [
                    "year"
                ],
                [
                    "in"
                ],
                [
                    "long"
                ],
                [
                    "arr",
                    "ay,"
                ]
            ],
            [
                [
                    "That"
                ],
                [
                    "Thou,"
                ],
                [
                    "sal",
                    "va",
                    "tion\u2019s"
                ],
                [
                    "source"
                ],
                [
                    "a",
                    "lone,"
                ]
            ],
            [
                [
                    "Pro",
                    "ceed",
                    "est"
                ],
                [
                    "from"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther\u2019s"
                ],
                [
                    "throne."
                ]
            ],
            [
                [
                    "Whence"
                ],
                [
                    "sky,"
                ],
                [
                    "and"
                ],
                [
                    "stars,"
                ],
                [
                    "and"
                ],
                [
                    "sea\u2019s"
                ],
                [
                    "a",
                    "byss,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "earth,"
                ],
                [
                    "and"
                ],
                [
                    "all"
                ],
                [
                    "that"
                ],
                [
                    "there",
                    "in"
                ],
                [
                    "is,"
                ]
            ],
            [
                [
                    "Shall"
                ],
                [
                    "still,"
                ],
                [
                    "with"
                ],
                [
                    "laud"
                ],
                [
                    "and"
                ],
                [
                    "ca",
                    "rol"
                ],
                [
                    "meet,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Au",
                    "thor"
                ],
                [
                    "of"
                ],
                [
                    "Thine"
                ],
                [
                    "ad",
                    "vent"
                ],
                [
                    "greet."
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "we"
                ],
                [
                    "who,"
                ],
                [
                    "by"
                ],
                [
                    "Thy"
                ],
                [
                    "pre",
                    "cious"
                ],
                [
                    "blood"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "sin"
                ],
                [
                    "re",
                    "deemed,"
                ],
                [
                    "are"
                ],
                [
                    "marked"
                ],
                [
                    "for"
                ],
                [
                    "God,"
                ]
            ],
            [
                [
                    "On"
                ],
                [
                    "this"
                ],
                [
                    "the"
                ],
                [
                    "day"
                ],
                [
                    "that"
                ],
                [
                    "saw"
                ],
                [
                    "Thy"
                ],
                [
                    "birth,"
                ]
            ],
            [
                [
                    "Sing"
                ],
                [
                    "the"
                ],
                [
                    "new"
                ],
                [
                    "song"
                ],
                [
                    "of"
                ],
                [
                    "ran",
                    "somed"
                ],
                [
                    "earth."
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "that"
                ],
                [
                    "Thine"
                ],
                [
                    "ad",
                    "vent"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "be,"
                ]
            ],
            [
                [
                    "O"
                ],
                [
                    "Je",
                    "su,"
                ],
                [
                    "vir",
                    "gin"
                ],
                [
                    "born,"
                ],
                [
                    "to"
                ],
                [
                    "Thee;"
                ]
            ],
            [
                [
                    "With"
                ],
                [
                    "Fa",
                    "ther,"
                ],
                [
                    "and"
                ],
                [
                    "with"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost,"
                ]
            ],
            [
                [
                    "From"
                ],
                [
                    "men"
                ],
                [
                    "and"
                ],
                [
                    "from"
                ],
                [
                    "the"
                ],
                [
                    "heav'n",
                    "ly"
                ],
                [
                    "host."
                ]
            ]
        ],
        tune: [
            [
                "0",
                "1",
                "24",
                "43",
                "21",
                "3",
                "210",
                "1"
            ],
            [
                "02",
                "4",
                "45",
                "5",
                "54",
                "47",
                "654",
                "5"
            ],
            [
                "57",
                "4",
                "43",
                "2",
                "10",
                "1",
                "12",
                "2"
            ],
            [
                "0",
                "1",
                "24",
                "43",
                "21",
                "3",
                "210",
                "1"
            ]
        ],
        amen: [
            "12",
            "101"
        ],
        clef: "c7",
        tone: "1"
    },
    "from-east-to-west-from-shore-to-shore": {
        title: "A solis ortus cardine",
        text: [
            [
                [
                    "From"
                ],
                [
                    "east"
                ],
                [
                    "to"
                ],
                [
                    "west,"
                ],
                [
                    "from"
                ],
                [
                    "shore"
                ],
                [
                    "to"
                ],
                [
                    "shore"
                ]
            ],
            [
                [
                    "Let"
                ],
                [
                    "ev'",
                    "ry"
                ],
                [
                    "heart"
                ],
                [
                    "a",
                    "wake"
                ],
                [
                    "and"
                ],
                [
                    "sing"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "ho",
                    "ly"
                ],
                [
                    "child"
                ],
                [
                    "whom"
                ],
                [
                    "Ma",
                    "ry"
                ],
                [
                    "bore,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "Christ,"
                ],
                [
                    "the"
                ],
                [
                    "ev",
                    "er",
                    "last",
                    "ing"
                ],
                [
                    "king."
                ]
            ],
            [
                [
                    "Be",
                    "hold,"
                ],
                [
                    "the"
                ],
                [
                    "world's"
                ],
                [
                    "cre",
                    "a",
                    "tor"
                ],
                [
                    "wears"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "form"
                ],
                [
                    "and"
                ],
                [
                    "fa",
                    "shion"
                ],
                [
                    "of"
                ],
                [
                    "a"
                ],
                [
                    "slave;"
                ]
            ],
            [
                [
                    "Our"
                ],
                [
                    "ve",
                    "ry"
                ],
                [
                    "flesh"
                ],
                [
                    "our"
                ],
                [
                    "ma",
                    "ker"
                ],
                [
                    "shares,"
                ]
            ],
            [
                [
                    "His"
                ],
                [
                    "fall",
                    "en"
                ],
                [
                    "crea",
                    "tures"
                ],
                [
                    "all"
                ],
                [
                    "to"
                ],
                [
                    "save."
                ]
            ],
            [
                [
                    "For"
                ],
                [
                    "this"
                ],
                [
                    "how"
                ],
                [
                    "won",
                    "drous",
                    "ly"
                ],
                [
                    "He"
                ],
                [
                    "wrought!"
                ]
            ],
            [
                [
                    "A"
                ],
                [
                    "mai",
                    "den,"
                ],
                [
                    "in"
                ],
                [
                    "her"
                ],
                [
                    "low",
                    "ly"
                ],
                [
                    "place,"
                ]
            ],
            [
                [
                    "Be",
                    "came,"
                ],
                [
                    "in"
                ],
                [
                    "ways"
                ],
                [
                    "bey",
                    "ond"
                ],
                [
                    "all"
                ],
                [
                    "thought,"
                ]
            ],
            [
                [
                    "The"
                ],
                [
                    "cho",
                    "sen"
                ],
                [
                    "ves",
                    "sel"
                ],
                [
                    "of"
                ],
                [
                    "His"
                ],
                [
                    "grace."
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "while"
                ],
                [
                    "the"
                ],
                [
                    "an",
                    "gels"
                ],
                [
                    "in"
                ],
                [
                    "the"
                ],
                [
                    "sky"
                ]
            ],
            [
                [
                    "Sang"
                ],
                [
                    "praise"
                ],
                [
                    "a",
                    "bove"
                ],
                [
                    "the"
                ],
                [
                    "si",
                    "lent"
                ],
                [
                    "field,"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "shep",
                    "herds"
                ],
                [
                    "poor"
                ],
                [
                    "the"
                ],
                [
                    "Lord"
                ],
                [
                    "Most"
                ],
                [
                    "High,"
                ]
            ],
            [
                [
                    "the"
                ],
                [
                    "one"
                ],
                [
                    "great"
                ],
                [
                    "Shep",
                    "herd,"
                ],
                [
                    "was"
                ],
                [
                    "re",
                    "vealed."
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "glo",
                    "ry"
                ],
                [
                    "for"
                ],
                [
                    "this"
                ],
                [
                    "bless",
                    "ed"
                ],
                [
                    "morn"
                ]
            ],
            [
                [
                    "To"
                ],
                [
                    "God"
                ],
                [
                    "the"
                ],
                [
                    "Fa",
                    "ther"
                ],
                [
                    "ev",
                    "er"
                ],
                [
                    "be;"
                ]
            ],
            [
                [
                    "All"
                ],
                [
                    "praise"
                ],
                [
                    "to"
                ],
                [
                    "You,"
                ],
                [
                    "O"
                ],
                [
                    "Vir",
                    "gin",
                    "born,"
                ]
            ],
            [
                [
                    "And"
                ],
                [
                    "Ho",
                    "ly"
                ],
                [
                    "Ghost"
                ],
                [
                    "e",
                    "ter",
                    "nal",
                    "ly."
                ]
            ]
        ],
        tune: [
            [
                "1",
                "2",
                "3",
                "45",
                "1",
                "234",
                "32",
                "2"
            ],
            [
                "4",
                "57",
                "7",
                "76",
                "54",
                "56",
                "6",
                "6"
            ],
            [
                "5",
                "578",
                "7",
                "76",
                "54",
                "5765",
                "43",
                "2345"
            ],
            [
                "1",
                "2",
                "3",
                "5",
                "5765",
                "4234",
                "32",
                "2"
            ]
        ],
        amen: [
            "23",
            "212"
        ],
        clef: "c7",
        tone: "3"
    }
};


const $425bbd180391c0d9$export$63738645d6c02a26 = ()=>{
    const [hymnText, setHymnText] = (0, $acw62.useState)("");
    const [tune, setTune] = (0, $acw62.useState)("");
    console.log(">>", (0, $4d61651d1fc64a9b$export$1063804fe6672506)["thirty-years-among-us-dwelling"].text.map((line)=>{
        return line.map((word)=>{
            return word.join("_");
        }).join(" ");
    }).join("\n"));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: "100%",
            overflow: "auto"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: async ()=>{
                        const blobText = await navigator.clipboard.readText();
                        setTune(blobText.replace(/\).*?\(/g, " ").replace(/^\(/g, "").replace(/\)$/g, "").replace(/'/g, "").replace(/ /, "\n").replace(/: /g, ":\n").replace(/; /g, ";\n").replace(/, /g, ",\n"));
                    },
                    children: "Paste tune"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                onChange: (event)=>{
                    setTune(event.currentTarget.value);
                },
                style: {
                    height: 200,
                    width: 534
                },
                value: tune
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            paddingTop: 1,
                            paddingRight: 4
                        },
                        children: hymnText.split("\n").map((line)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    height: 20,
                                    width: 30,
                                    textAlign: "right",
                                    fontWeight: "bold"
                                },
                                children: line.length === 0 ? "" : line.replace(/ /g, "_").split("_").length
                            });
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                        onChange: (event)=>{
                            setHymnText(event.currentTarget.value);
                        },
                        style: {
                            height: 5000,
                            width: 500,
                            lineHeight: "20px"
                        },
                        children: hymnText
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            width: 500
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800a243c436a5a55$export$f3e61a719d75a165), {
                            hymn: {
                                text: hymnText,
                                tune: tune,
                                mode: 1,
                                title: ""
                            }
                        })
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");

var $c6d47dac24204f66$exports = {};
$c6d47dac24204f66$exports = import.meta.resolve("o2qHY");


const $d0e7871cd1858330$export$9c9ee2e156b54bfb = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
        href: "/",
        style: {
            color: (0, $b5d1360628cd70a0$export$1a6c4fc8d15a2dc7),
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            fontWeight: "bold"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: "flex",
                    paddingRight: 8
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: new URL($c6d47dac24204f66$exports).href,
                    style: {
                        width: 30,
                        height: 30,
                        borderRadius: 4
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    color: (0, $b5d1360628cd70a0$export$516f68680b50dca1)
                },
                children: "Sing"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                },
                children: "The"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    color: (0, $b5d1360628cd70a0$export$516f68680b50dca1)
                },
                children: "Office"
            })
        ]
    });
};



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");
const $982dab2795189e62$export$45a8b3c92b66d3be = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `sticky-container-${props.id}`,
        children: props.children
    });
};





var $acw62 = parcelRequire("acw62");
const $b0ef04497ab55347$var$NULL = null;
const $b0ef04497ab55347$var$TweakContext = /*#__PURE__*/ (0, $acw62.createContext)($b0ef04497ab55347$var$NULL);
const $b0ef04497ab55347$export$9d593b1761d4031 = ()=>{
    return (0, $acw62.useContext)($b0ef04497ab55347$var$TweakContext);
};
const $b0ef04497ab55347$export$875ca48977813ee8 = (props)=>{
    const { initialState: initialState } = props;
    const [tweaks, setTweaks] = (0, $acw62.useState)(initialState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0ef04497ab55347$var$TweakContext.Provider, {
        value: {
            tweaks: tweaks,
            setTweak: (id, value)=>{
                setTweaks((prev)=>{
                    return {
                        ...prev,
                        [id]: value
                    };
                });
            }
        },
        children: props.children
    });
};



parcelRequire("acw62");


parcelRequire("acw62");
const $ca62a1dbd14c6d35$export$6ccfe534fa2728ed = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: props.children
    });
/*
    return (
        <Sticky
            scrollElement=".app-scroll-area"
            boundaryElement={`.sticky-container-${props.id}`}
        >
            {props.children}
        </Sticky>
    );
    */ };



const $e2d213bd4c46a128$export$1246c4e68efb74f5 = (props)=>{
    const { id: id, title: title, player: player } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca62a1dbd14c6d35$export$6ccfe534fa2728ed), {
        id: id,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                backgroundColor: (0, $b5d1360628cd70a0$export$1a6c4fc8d15a2dc7),
                transition: "all 0.1s"
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                onlySides: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontWeight: "bold",
                                paddingBottom: 12,
                                paddingTop: 12,
                                flexGrow: 1,
                                fontSize: (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57),
                                width: 0,
                                textOverflow: "ellipsis",
                                overflow: "hidden"
                            },
                            className: "title",
                            "data-content": title,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                flexShrink: 0
                            },
                            children: player
                        })
                    ]
                })
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
var $0d19688bebdb26f8$var$__defProp = Object.defineProperty;
var $0d19688bebdb26f8$var$__defProps = Object.defineProperties;
var $0d19688bebdb26f8$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0d19688bebdb26f8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0d19688bebdb26f8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0d19688bebdb26f8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0d19688bebdb26f8$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $0d19688bebdb26f8$var$__defNormalProp = (obj, key, value)=>key in obj ? $0d19688bebdb26f8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0d19688bebdb26f8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0d19688bebdb26f8$var$__hasOwnProp.call(b, prop)) $0d19688bebdb26f8$var$__defNormalProp(a, prop, b[prop]);
    if ($0d19688bebdb26f8$var$__getOwnPropSymbols) {
        for (var prop of $0d19688bebdb26f8$var$__getOwnPropSymbols(b))if ($0d19688bebdb26f8$var$__propIsEnum.call(b, prop)) $0d19688bebdb26f8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0d19688bebdb26f8$var$__spreadProps = (a, b)=>$0d19688bebdb26f8$var$__defProps(a, $0d19688bebdb26f8$var$__getOwnPropDescs(b));
var $0d19688bebdb26f8$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $0d19688bebdb26f8$var$__typeError("Cannot " + msg);
var $0d19688bebdb26f8$var$__privateGet = (obj, member, getter)=>($0d19688bebdb26f8$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $0d19688bebdb26f8$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $0d19688bebdb26f8$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $0d19688bebdb26f8$var$__privateSet = (obj, member, value, setter)=>($0d19688bebdb26f8$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $0d19688bebdb26f8$var$__privateMethod = (obj, member, method)=>($0d19688bebdb26f8$var$__accessCheck(obj, member, "access private method"), method);
var $0d19688bebdb26f8$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/player/connect.ts
function $0d19688bebdb26f8$var$connectSerial(nodes) {
    const _nodes = nodes.filter((x)=>!!x);
    _nodes.reduce((a, b)=>{
        const left = "output" in a ? a.output : a;
        const right = "input" in b ? b.input : b;
        left.connect(right);
        return b;
    });
    return ()=>{
        _nodes.reduce((a, b)=>{
            const left = "output" in a ? a.output : a;
            const right = "input" in b ? b.input : b;
            left.disconnect(right);
            return b;
        });
    };
}
// src/player/signals.ts
function $0d19688bebdb26f8$var$createControl(initialValue) {
    let current = initialValue;
    const listeners = /* @__PURE__ */ new Set();
    function subscribe(listener) {
        listeners.add(listener);
        listener(current);
        return ()=>{
            listeners.delete(listener);
        };
    }
    function set(value) {
        current = value;
        listeners.forEach((listener)=>listener(current));
    }
    function get() {
        return current;
    }
    return {
        subscribe: subscribe,
        set: set,
        get: get
    };
}
function $0d19688bebdb26f8$var$createTrigger() {
    const listeners = /* @__PURE__ */ new Set();
    function subscribe(listener) {
        listeners.add(listener);
        return ()=>{
            listeners.delete(listener);
        };
    }
    function trigger(value) {
        listeners.forEach((listener)=>listener(value));
    }
    return {
        subscribe: subscribe,
        trigger: trigger
    };
}
function $0d19688bebdb26f8$var$unsubscribeAll(unsubscribe) {
    let done = false;
    return ()=>{
        if (done) return;
        done = true;
        unsubscribe.forEach((cb)=>cb == null ? void 0 : cb());
    };
}
// src/player/volume.ts
function $0d19688bebdb26f8$var$midiVelToGain(vel) {
    return vel * vel / 16129;
}
function $0d19688bebdb26f8$var$dbToGain(decibels) {
    return Math.pow(10, decibels / 20);
}
// src/player/channel.ts
var $0d19688bebdb26f8$var$_volume, $0d19688bebdb26f8$var$_sends, $0d19688bebdb26f8$var$_inserts, $0d19688bebdb26f8$var$_disconnect, $0d19688bebdb26f8$var$_unsubscribe, $0d19688bebdb26f8$var$_config, $0d19688bebdb26f8$var$_disconnected;
var $0d19688bebdb26f8$var$Channel = class {
    constructor(context, options){
        this.context = context;
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_volume);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_sends);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_inserts);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_disconnect);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_unsubscribe);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_config);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_disconnected, false);
        var _a, _b, _c;
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_config, {
            destination: (_a = options == null ? void 0 : options.destination) != null ? _a : context.destination,
            volume: (_b = options == null ? void 0 : options.volume) != null ? _b : 100,
            volumeToGain: (_c = options == null ? void 0 : options.volumeToGain) != null ? _c : $0d19688bebdb26f8$var$midiVelToGain
        });
        this.input = context.createGain();
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_volume, context.createGain());
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_disconnect, $0d19688bebdb26f8$var$connectSerial([
            this.input,
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_volume),
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config).destination
        ]));
        const volume = $0d19688bebdb26f8$var$createControl($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config).volume);
        this.setVolume = volume.set;
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_unsubscribe, volume.subscribe((volume2)=>{
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_volume).gain.value = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config).volumeToGain(volume2);
        }));
    }
    addInsert(effect) {
        var _a;
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnected)) throw Error("Can't add insert to disconnected channel");
        (_a = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_inserts)) != null ? _a : $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_inserts, []);
        $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_inserts).push(effect);
        $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnect).call(this);
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_disconnect, $0d19688bebdb26f8$var$connectSerial([
            this.input,
            ...$0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_inserts),
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_volume),
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config).destination
        ]));
    }
    addEffect(name, effect, mixValue) {
        var _a;
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnected)) throw Error("Can't add effect to disconnected channel");
        const mix = this.context.createGain();
        mix.gain.value = mixValue;
        const input = "input" in effect ? effect.input : effect;
        const disconnect = $0d19688bebdb26f8$var$connectSerial([
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_volume),
            mix,
            input
        ]);
        (_a = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_sends)) != null ? _a : $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_sends, []);
        $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_sends).push({
            name: name,
            mix: mix,
            disconnect: disconnect
        });
    }
    sendEffect(name, mix) {
        var _a;
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnected)) throw Error("Can't send effect to disconnected channel");
        const send = (_a = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_sends)) == null ? void 0 : _a.find((send2)=>send2.name === name);
        if (send) send.mix.gain.value = mix;
        else console.warn("Send bus not found: " + name);
    }
    disconnect() {
        var _a;
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnected)) return;
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_disconnected, true);
        $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnect).call(this);
        $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_unsubscribe).call(this);
        (_a = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_sends)) == null || _a.forEach((send)=>send.disconnect());
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_sends, void 0);
    }
};
$0d19688bebdb26f8$var$_volume = new WeakMap();
$0d19688bebdb26f8$var$_sends = new WeakMap();
$0d19688bebdb26f8$var$_inserts = new WeakMap();
$0d19688bebdb26f8$var$_disconnect = new WeakMap();
$0d19688bebdb26f8$var$_unsubscribe = new WeakMap();
$0d19688bebdb26f8$var$_config = new WeakMap();
$0d19688bebdb26f8$var$_disconnected = new WeakMap();
// src/player/sorted-queue.ts
var $0d19688bebdb26f8$var$_items;
var $0d19688bebdb26f8$var$SortedQueue = class {
    constructor(compare){
        this.compare = compare;
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_items, []);
    }
    push(item) {
        const len = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items).length;
        let left = 0;
        let right = len - 1;
        let index = len;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (this.compare(item, $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items)[mid]) < 0) {
                index = mid;
                right = mid - 1;
            } else left = mid + 1;
        }
        $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items).splice(index, 0, item);
    }
    pop() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items).shift();
    }
    peek() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items)[0];
    }
    removeAll(predicate) {
        const len = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items).length;
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_items, $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items).filter((item)=>!predicate(item)));
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items).length !== len;
    }
    clear() {
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_items, []);
    }
    size() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_items).length;
    }
};
$0d19688bebdb26f8$var$_items = new WeakMap();
// src/player/queued-player.ts
function $0d19688bebdb26f8$var$compose(a, b) {
    return a && b ? (x)=>{
        a(x);
        b(x);
    } : a != null ? a : b;
}
function $0d19688bebdb26f8$var$getConfig(options) {
    var _a, _b, _c;
    const config = {
        disableScheduler: (_a = options.disableScheduler) != null ? _a : false,
        scheduleLookaheadMs: (_b = options.scheduleLookaheadMs) != null ? _b : 200,
        scheduleIntervalMs: (_c = options.scheduleIntervalMs) != null ? _c : 50,
        onStart: options.onStart,
        onEnded: options.onEnded
    };
    if (config.scheduleLookaheadMs < 1) throw Error("scheduleLookaheadMs must be greater than 0");
    if (config.scheduleIntervalMs < 1) throw Error("scheduleIntervalMs must be greater than 0");
    if (config.scheduleLookaheadMs < config.scheduleIntervalMs) throw Error("scheduleLookaheadMs must be greater than scheduleIntervalMs");
    return config;
}
var $0d19688bebdb26f8$var$_config2, $0d19688bebdb26f8$var$_queue, $0d19688bebdb26f8$var$_intervalId;
var $0d19688bebdb26f8$var$QueuedPlayer = class {
    constructor(player, options = {}){
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_config2);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_queue);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_intervalId);
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_config2, $0d19688bebdb26f8$var$getConfig(options));
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_queue, new $0d19688bebdb26f8$var$SortedQueue((a, b)=>a.time - b.time));
        this.player = player;
    }
    get context() {
        return this.player.context;
    }
    get buffers() {
        return this.player.buffers;
    }
    get isRunning() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_intervalId) !== void 0;
    }
    start(sample) {
        var _a;
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config2).disableScheduler) return this.player.start(sample);
        const context = this.player.context;
        const now = context.currentTime;
        const startAt = (_a = sample.time) != null ? _a : now;
        const lookAhead = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config2).scheduleLookaheadMs / 1e3;
        sample.onStart = $0d19688bebdb26f8$var$compose(sample.onStart, $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config2).onStart);
        sample.onEnded = $0d19688bebdb26f8$var$compose(sample.onEnded, $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config2).onEnded);
        if (startAt < now + lookAhead) return this.player.start(sample);
        $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).push($0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, sample), {
            time: startAt
        }));
        if (!$0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_intervalId)) $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_intervalId, setInterval(()=>{
            const nextTick = context.currentTime + lookAhead;
            while($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).size() && $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).peek().time <= nextTick){
                const sample2 = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).pop();
                if (sample2) this.player.start(sample2);
            }
            if (!$0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).size()) {
                clearInterval($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_intervalId));
                $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_intervalId, void 0);
            }
        }, $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config2).scheduleIntervalMs));
        return (time)=>{
            if (!time || time < startAt) {
                if (!$0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).removeAll((item)=>item === sample)) this.player.stop($0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, sample), {
                    time: time
                }));
            } else this.player.stop($0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, sample), {
                time: time
            }));
        };
    }
    stop(sample) {
        var _a;
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config2).disableScheduler) return this.player.stop(sample);
        this.player.stop(sample);
        if (!sample) {
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).clear();
            return;
        }
        const time = (_a = sample == null ? void 0 : sample.time) != null ? _a : 0;
        const stopId = sample == null ? void 0 : sample.stopId;
        if (stopId) $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).removeAll((item)=>item.time >= time && item.stopId ? item.stopId === stopId : item.note === stopId);
        else $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_queue).removeAll((item)=>item.time >= time);
    }
    disconnect() {
        this.player.disconnect();
    }
};
$0d19688bebdb26f8$var$_config2 = new WeakMap();
$0d19688bebdb26f8$var$_queue = new WeakMap();
$0d19688bebdb26f8$var$_intervalId = new WeakMap();
// src/player/sample-player.ts
var $0d19688bebdb26f8$var$_config3, $0d19688bebdb26f8$var$_disconnected2, $0d19688bebdb26f8$var$_stop;
var $0d19688bebdb26f8$var$SamplePlayer = class {
    constructor(context, options){
        this.context = context;
        this.options = options;
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_config3);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_disconnected2, false);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_stop);
        var _a, _b;
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_config3, {
            velocityToGain: (_a = options.velocityToGain) != null ? _a : $0d19688bebdb26f8$var$midiVelToGain,
            destination: (_b = options.destination) != null ? _b : context.destination
        });
        this.buffers = {};
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_stop, $0d19688bebdb26f8$var$createTrigger());
    }
    start(sample) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnected2)) throw new Error("Can't start a sample on disconnected player");
        const context = this.context;
        const buffer = sample.name && this.buffers[sample.name] || this.buffers[sample.note];
        if (!buffer) {
            console.warn(`Sample not found: '${sample.note}'`);
            return ()=>void 0;
        }
        const source = context.createBufferSource();
        source.buffer = buffer;
        const cents = (_b = (_a = sample.detune) != null ? _a : this.options.detune) != null ? _b : 0;
        if (source.detune) source.detune.value = cents;
        else if (source.playbackRate) source.playbackRate.value = Math.pow(2, cents / 1200);
        const lpfCutoffHz = (_c = sample.lpfCutoffHz) != null ? _c : this.options.lpfCutoffHz;
        const lpf = lpfCutoffHz ? context.createBiquadFilter() : void 0;
        if (lpfCutoffHz && lpf) {
            lpf.type = "lowpass";
            lpf.frequency.value = lpfCutoffHz;
        }
        const volume = context.createGain();
        const velocity = (_e = (_d = sample.velocity) != null ? _d : this.options.velocity) != null ? _e : 100;
        volume.gain.value = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config3).velocityToGain(velocity);
        const loop = (_f = sample.loop) != null ? _f : this.options.loop;
        if (loop) {
            source.loop = true;
            source.loopStart = (_g = sample.loopStart) != null ? _g : 0;
            source.loopEnd = (_h = sample.loopEnd) != null ? _h : buffer.duration;
        }
        const decayTime = (_i = sample.decayTime) != null ? _i : this.options.decayTime;
        const [decay, startDecay] = $0d19688bebdb26f8$var$createDecayEnvelope(context, decayTime);
        function stop(time) {
            time != null ? time : time = context.currentTime;
            if (time <= startAt) source.stop(time);
            else {
                const stopAt = startDecay(time);
                source.stop(stopAt);
            }
        }
        const gainCompensation = sample.gainOffset ? context.createGain() : void 0;
        if (gainCompensation && sample.gainOffset) gainCompensation.gain.value = sample.gainOffset;
        const stopId = (_j = sample.stopId) != null ? _j : sample.note;
        const cleanup = $0d19688bebdb26f8$var$unsubscribeAll([
            $0d19688bebdb26f8$var$connectSerial([
                source,
                lpf,
                volume,
                decay,
                gainCompensation,
                $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_config3).destination
            ]),
            (_k = sample.stop) == null ? void 0 : _k.call(sample, stop),
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_stop).subscribe((event)=>{
                if (!event || event.stopId === void 0 || event.stopId === stopId) stop(event == null ? void 0 : event.time);
            })
        ]);
        source.onended = ()=>{
            var _a2;
            cleanup();
            (_a2 = sample.onEnded) == null || _a2.call(sample, sample);
        };
        (_l = sample.onStart) == null || _l.call(sample, sample);
        const startAt = Math.max((_m = sample.time) != null ? _m : 0, context.currentTime);
        source.start(sample.time);
        let duration = (_n = sample.duration) != null ? _n : buffer.duration;
        if (typeof sample.duration == "number") stop(startAt + duration);
        return stop;
    }
    stop(sample) {
        $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_stop).trigger(sample);
    }
    disconnect() {
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnected2)) return;
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_disconnected2, true);
        this.stop();
        Object.keys(this.buffers).forEach((key)=>{
            delete this.buffers[key];
        });
    }
    get connected() {
        return !$0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_disconnected2);
    }
};
$0d19688bebdb26f8$var$_config3 = new WeakMap();
$0d19688bebdb26f8$var$_disconnected2 = new WeakMap();
$0d19688bebdb26f8$var$_stop = new WeakMap();
function $0d19688bebdb26f8$var$createDecayEnvelope(context, envelopeTime = 0.2) {
    let stopAt = 0;
    const envelope = context.createGain();
    envelope.gain.value = 1;
    function start(time) {
        if (stopAt) return stopAt;
        envelope.gain.cancelScheduledValues(time);
        const envelopeAt = time || context.currentTime;
        stopAt = envelopeAt + envelopeTime;
        envelope.gain.setValueAtTime(1, envelopeAt);
        envelope.gain.linearRampToValueAtTime(0, stopAt);
        return stopAt;
    }
    return [
        envelope,
        start
    ];
}
// src/player/default-player.ts
var $0d19688bebdb26f8$var$DefaultPlayer = class {
    constructor(context, options){
        this.context = context;
        const channel = new $0d19688bebdb26f8$var$Channel(context, options);
        this.player = new $0d19688bebdb26f8$var$QueuedPlayer(new $0d19688bebdb26f8$var$SamplePlayer(context, $0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, options), {
            destination: channel.input
        })), options);
        this.output = channel;
    }
    get buffers() {
        return this.player.buffers;
    }
    start(sample) {
        return this.player.start(sample);
    }
    stop(sample) {
        this.player.stop(typeof sample === "object" ? sample : sample !== void 0 ? {
            stopId: sample
        } : void 0);
    }
    disconnect() {
        this.output.disconnect();
        this.player.disconnect();
    }
};
// src/player/load-audio.ts
function $0d19688bebdb26f8$var$loadAudioBuffer(context, url, storage) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        url = url.replace(/#/g, "%23").replace(/([^:]\/)\/+/g, "$1");
        const response = yield storage.fetch(url);
        if (response.status !== 200) {
            console.warn("Error loading buffer. Invalid status: ", response.status, url);
            return;
        }
        try {
            const audioData = yield response.arrayBuffer();
            const buffer = yield context.decodeAudioData(audioData);
            return buffer;
        } catch (error) {
            console.warn("Error loading buffer", error, url);
        }
    });
}
function $0d19688bebdb26f8$var$findFirstSupportedFormat(formats) {
    if (typeof document === "undefined") return null;
    const audio = document.createElement("audio");
    for(let i = 0; i < formats.length; i++){
        const format = formats[i];
        const canPlay = audio.canPlayType(`audio/${format}`);
        if (canPlay === "probably" || canPlay === "maybe") return format;
        if (format === "m4a") {
            const canPlay2 = audio.canPlayType(`audio/aac`);
            if (canPlay2 === "probably" || canPlay2 === "maybe") return format;
        }
    }
    return null;
}
function $0d19688bebdb26f8$var$getPreferredAudioExtension() {
    var _a;
    const format = (_a = $0d19688bebdb26f8$var$findFirstSupportedFormat([
        "ogg",
        "m4a"
    ])) != null ? _a : "ogg";
    return "." + format;
}
// src/storage.ts
var $0d19688bebdb26f8$export$7fd566d5ad2998a9 = {
    fetch (url) {
        return fetch(url);
    }
};
var $0d19688bebdb26f8$var$_cache, $0d19688bebdb26f8$var$_CacheStorage_instances, $0d19688bebdb26f8$var$tryFromCache_fn, $0d19688bebdb26f8$var$saveResponse_fn;
var $0d19688bebdb26f8$export$2b715f8922748263 = class {
    constructor(name = "smplr"){
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_CacheStorage_instances);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_cache);
        if (typeof window === "undefined" || !("caches" in window)) $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_cache, Promise.reject("CacheStorage not supported"));
        else $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_cache, caches.open(name));
    }
    fetch(url) {
        return $0d19688bebdb26f8$var$__async(this, null, function*() {
            const request = new Request(url);
            try {
                return yield $0d19688bebdb26f8$var$__privateMethod(this, $0d19688bebdb26f8$var$_CacheStorage_instances, $0d19688bebdb26f8$var$tryFromCache_fn).call(this, request);
            } catch (err) {
                const response = yield fetch(request);
                yield $0d19688bebdb26f8$var$__privateMethod(this, $0d19688bebdb26f8$var$_CacheStorage_instances, $0d19688bebdb26f8$var$saveResponse_fn).call(this, request, response);
                return response;
            }
        });
    }
};
$0d19688bebdb26f8$var$_cache = new WeakMap();
$0d19688bebdb26f8$var$_CacheStorage_instances = new WeakSet();
$0d19688bebdb26f8$var$tryFromCache_fn = function(request) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        const cache = yield $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_cache);
        const response = yield cache.match(request);
        if (response) return response;
        else throw Error("Not found");
    });
};
$0d19688bebdb26f8$var$saveResponse_fn = function(request, response) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        try {
            const cache = yield $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_cache);
            yield cache.put(request, response.clone());
        } catch (err) {}
    });
};
// src/drum-machine/dm-instrument.ts
function $0d19688bebdb26f8$var$isDrumMachineInstrument(instrument) {
    return typeof instrument === "object" && typeof instrument.baseUrl === "string" && typeof instrument.name === "string" && Array.isArray(instrument.samples) && Array.isArray(instrument.groupNames) && typeof instrument.nameToSampleName === "object" && typeof instrument.sampleGroupVariations === "object";
}
var $0d19688bebdb26f8$var$EMPTY_INSTRUMENT = {
    baseUrl: "",
    name: "",
    samples: [],
    groupNames: [],
    nameToSampleName: {},
    sampleGroupVariations: {}
};
function $0d19688bebdb26f8$var$fetchDrumMachineInstrument(url, storage) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        var _a, _b, _c, _d;
        const res = yield storage.fetch(url);
        const json = yield res.json();
        json.baseUrl = url.replace("/dm.json", "");
        json.groupNames = [];
        json.nameToSampleName = {};
        json.sampleGroupVariations = {};
        for (const sample of json.samples){
            json.nameToSampleName[sample] = sample;
            const separator = sample.indexOf("/") !== -1 ? "/" : "-";
            const [base, variation] = sample.split(separator);
            if (!json.groupNames.includes(base)) json.groupNames.push(base);
            (_b = (_a = json.nameToSampleName)[base]) != null ? _b : _a[base] = sample;
            (_d = (_c = json.sampleGroupVariations)[base]) != null ? _d : _c[base] = [];
            if (variation) json.sampleGroupVariations[base].push(`${base}${separator}${variation}`);
        }
        return json;
    });
}
// src/drum-machine/drum-machine.ts
function $0d19688bebdb26f8$export$8b94bfd7008e8f41() {
    return Object.keys($0d19688bebdb26f8$var$INSTRUMENTS);
}
var $0d19688bebdb26f8$var$INSTRUMENTS = {
    "TR-808": "https://smpldsnds.github.io/drum-machines/TR-808/dm.json",
    "Casio-RZ1": "https://smpldsnds.github.io/drum-machines/Casio-RZ1/dm.json",
    "LM-2": "https://smpldsnds.github.io/drum-machines/LM-2/dm.json",
    "MFB-512": "https://smpldsnds.github.io/drum-machines/MFB-512/dm.json",
    "Roland CR-8000": "https://smpldsnds.github.io/drum-machines/Roland-CR-8000/dm.json"
};
function $0d19688bebdb26f8$var$getConfig2(options) {
    var _a, _b, _c;
    const config = {
        instrument: (_a = options == null ? void 0 : options.instrument) != null ? _a : "TR-808",
        storage: (_b = options == null ? void 0 : options.storage) != null ? _b : $0d19688bebdb26f8$export$7fd566d5ad2998a9,
        url: (_c = options == null ? void 0 : options.url) != null ? _c : ""
    };
    if (typeof config.instrument === "string") {
        config.url || (config.url = $0d19688bebdb26f8$var$INSTRUMENTS[config.instrument]);
        if (!config.url) throw new Error("Invalid instrument: " + config.instrument);
    } else if (!$0d19688bebdb26f8$var$isDrumMachineInstrument(config.instrument)) throw new Error("Invalid instrument: " + config.instrument);
    return config;
}
var $0d19688bebdb26f8$var$_instrument;
var $0d19688bebdb26f8$export$8ceded137695f5d5 = class {
    constructor(context, options){
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_instrument, $0d19688bebdb26f8$var$EMPTY_INSTRUMENT);
        const config = $0d19688bebdb26f8$var$getConfig2(options);
        const instrument = $0d19688bebdb26f8$var$isDrumMachineInstrument(config.instrument) ? Promise.resolve(config.instrument) : $0d19688bebdb26f8$var$fetchDrumMachineInstrument(config.url, config.storage);
        this.player = new $0d19688bebdb26f8$var$DefaultPlayer(context, options);
        this.output = this.player.output;
        this.load = $0d19688bebdb26f8$var$drumMachineLoader(context, this.player.buffers, instrument, config.storage).then(()=>this);
        instrument.then((instrument2)=>{
            $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_instrument, instrument2);
        });
    }
    getSampleNames() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_instrument).samples.slice();
    }
    getGroupNames() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_instrument).groupNames.slice();
    }
    getSampleNamesForGroup(groupName) {
        var _a;
        return (_a = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_instrument).sampleGroupVariations[groupName]) != null ? _a : [];
    }
    start(sample) {
        var _a;
        const sampleName = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_instrument).nameToSampleName[sample.note];
        return this.player.start($0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, sample), {
            note: sampleName ? sampleName : sample.note,
            stopId: (_a = sample.stopId) != null ? _a : sample.note
        }));
    }
    stop(sample) {
        return this.player.stop(sample);
    }
    /** @deprecated */ loaded() {
        return $0d19688bebdb26f8$var$__async(this, null, function*() {
            console.warn("deprecated: use load instead");
            return this.load;
        });
    }
    /** @deprecated */ get sampleNames() {
        console.log("deprecated: Use getGroupNames instead");
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_instrument).groupNames.slice();
    }
    /** @deprecated */ getVariations(groupName) {
        var _a;
        console.warn("deprecated: use getSampleNamesForGroup");
        return (_a = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_instrument).sampleGroupVariations[groupName]) != null ? _a : [];
    }
};
$0d19688bebdb26f8$var$_instrument = new WeakMap();
function $0d19688bebdb26f8$var$drumMachineLoader(context, buffers, instrument, storage) {
    var _a;
    const format = (_a = $0d19688bebdb26f8$var$findFirstSupportedFormat([
        "ogg",
        "m4a"
    ])) != null ? _a : "ogg";
    return instrument.then((data)=>Promise.all(data.samples.map((sampleName)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
                const url = `${data.baseUrl}/${sampleName}.${format}`;
                const buffer = yield $0d19688bebdb26f8$var$loadAudioBuffer(context, url, storage);
                if (buffer) buffers[sampleName] = buffer;
            }))));
}
// src/player/midi.ts
function $0d19688bebdb26f8$var$noteNameToMidi(note) {
    const REGEX = /^([a-gA-G]?)(#{1,}|b{1,}|)(-?\d+)$/;
    const m = REGEX.exec(note);
    if (!m) return;
    const letter = m[1].toUpperCase();
    if (!letter) return;
    const acc = m[2];
    const alt = acc[0] === "b" ? -acc.length : acc.length;
    const oct = m[3] ? +m[3] : 4;
    const step = (letter.charCodeAt(0) + 3) % 7;
    return [
        0,
        2,
        4,
        5,
        7,
        9,
        11
    ][step] + alt + 12 * (oct + 1);
}
function $0d19688bebdb26f8$var$toMidi(note) {
    return note === void 0 ? void 0 : typeof note === "number" ? note : $0d19688bebdb26f8$var$noteNameToMidi(note);
}
// src/sfz/sfz-load.ts
function $0d19688bebdb26f8$var$loadSfzBuffers(context, buffers, websfz, storage) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        websfz.groups.forEach((group)=>{
            const urls = $0d19688bebdb26f8$var$getWebsfzGroupUrls(websfz, group);
            return $0d19688bebdb26f8$var$loadAudioBuffers(context, buffers, urls, storage);
        });
    });
}
function $0d19688bebdb26f8$var$SfzInstrumentLoader(instrument, storage) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        var _a;
        const isWebsfz = (inst)=>"global" in inst;
        const isSfzInstrument = (inst)=>"websfzUrl" in inst;
        if (typeof instrument === "string") return $0d19688bebdb26f8$var$fetchWebSfz(instrument, storage);
        else if (isWebsfz(instrument)) return instrument;
        else if (isSfzInstrument(instrument)) {
            const websfz = yield $0d19688bebdb26f8$var$fetchWebSfz(instrument.websfzUrl, storage);
            (_a = websfz.meta) != null ? _a : websfz.meta = {};
            if (instrument.name) websfz.meta.name = instrument.name;
            if (instrument.baseUrl) websfz.meta.baseUrl = instrument.baseUrl;
            if (instrument.formats) websfz.meta.formats = instrument.formats;
            return websfz;
        } else throw new Error("Invalid instrument: " + JSON.stringify(instrument));
    });
}
function $0d19688bebdb26f8$var$loadAudioBuffers(context, buffers, urls, storage) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        yield Promise.all(Object.keys(urls).map((sampleId)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
                if (buffers[sampleId]) return;
                const buffer = yield $0d19688bebdb26f8$var$loadAudioBuffer(context, urls[sampleId], storage);
                if (buffer) buffers[sampleId] = buffer;
                return buffers;
            })));
    });
}
function $0d19688bebdb26f8$var$fetchWebSfz(url, storage) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        try {
            const response = yield fetch(url);
            const json = yield response.json();
            return json;
        } catch (error) {
            console.warn(`Can't load SFZ file ${url}`, error);
            throw new Error(`Can't load SFZ file ${url}`);
        }
    });
}
function $0d19688bebdb26f8$var$getWebsfzGroupUrls(websfz, group) {
    var _a, _b, _c, _d;
    const urls = {};
    const baseUrl = (_a = websfz.meta.baseUrl) != null ? _a : "";
    const format = (_c = $0d19688bebdb26f8$var$findFirstSupportedFormat((_b = websfz.meta.formats) != null ? _b : [])) != null ? _c : "ogg";
    const prefix = (_d = websfz.global["default_path"]) != null ? _d : "";
    if (!group) return urls;
    return group.regions.reduce((urls2, region)=>{
        if (region.sample) urls2[region.sample] = `${baseUrl}/${prefix}${region.sample}.${format}`;
        return urls2;
    }, urls);
}
// src/sfz/sfz-regions.ts
function $0d19688bebdb26f8$var$checkRange(value, low, hi) {
    const isAboveLow = low === void 0 || value !== void 0 && value >= low;
    const isBelowHi = hi === void 0 || value !== void 0 && value <= hi;
    return isAboveLow && isBelowHi;
}
function $0d19688bebdb26f8$var$findRegions(websfz, note) {
    const regions = [];
    for (const group of websfz.groups)if ($0d19688bebdb26f8$var$checkRange(note.midi, group.lokey, group.hikey) && $0d19688bebdb26f8$var$checkRange(note.velocity, group.lovel, group.hivel) && $0d19688bebdb26f8$var$checkRange(note.cc64, group.locc64, group.hicc64)) {
        for (const region of group.regions)if ($0d19688bebdb26f8$var$checkRange(note.midi, region.lokey, region.hikey) && $0d19688bebdb26f8$var$checkRange(note.velocity, region.lovel, region.hivel) && $0d19688bebdb26f8$var$checkRange(note.cc64, group.locc64, group.hicc64)) regions.push([
            group,
            region
        ]);
    }
    return regions;
}
// src/sfz/sfz-sampler.ts
var $0d19688bebdb26f8$var$EMPTY_WEBSFZ = Object.freeze({
    meta: {},
    global: {},
    groups: []
});
var $0d19688bebdb26f8$var$_websfz, $0d19688bebdb26f8$var$_SfzSampler_instances, $0d19688bebdb26f8$var$startLayers_fn;
var $0d19688bebdb26f8$var$SfzSampler = class {
    constructor(context, options){
        this.context = context;
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_SfzSampler_instances);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_websfz);
        this.options = Object.freeze(Object.assign({
            volume: 100,
            velocity: 100,
            storage: $0d19688bebdb26f8$export$7fd566d5ad2998a9,
            detune: 0,
            destination: context.destination
        }, options));
        this.player = new $0d19688bebdb26f8$var$DefaultPlayer(context, options);
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_websfz, $0d19688bebdb26f8$var$EMPTY_WEBSFZ);
        this.load = $0d19688bebdb26f8$var$SfzInstrumentLoader(options.instrument, this.options.storage).then((result)=>{
            $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_websfz, Object.freeze(result));
            return $0d19688bebdb26f8$var$loadSfzBuffers(context, this.player.buffers, $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_websfz), this.options.storage);
        }).then(()=>this);
    }
    get output() {
        return this.player.output;
    }
    loaded() {
        return $0d19688bebdb26f8$var$__async(this, null, function*() {
            console.warn("deprecated: use load instead");
            return this.load;
        });
    }
    start(sample) {
        $0d19688bebdb26f8$var$__privateMethod(this, $0d19688bebdb26f8$var$_SfzSampler_instances, $0d19688bebdb26f8$var$startLayers_fn).call(this, typeof sample === "object" ? sample : {
            note: sample
        });
    }
    stop(sample) {
        this.player.stop(sample);
    }
    disconnect() {
        this.player.disconnect();
    }
};
$0d19688bebdb26f8$var$_websfz = new WeakMap();
$0d19688bebdb26f8$var$_SfzSampler_instances = new WeakSet();
$0d19688bebdb26f8$var$startLayers_fn = function(sample) {
    var _a;
    const midi = $0d19688bebdb26f8$var$toMidi(sample.note);
    if (midi === void 0) return ()=>void 0;
    const velocity = (_a = sample.velocity) != null ? _a : this.options.velocity;
    const regions = $0d19688bebdb26f8$var$findRegions($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_websfz), {
        midi: midi,
        velocity: velocity
    });
    const onEnded = ()=>{
        var _a2;
        (_a2 = sample.onEnded) == null || _a2.call(sample, sample);
    };
    const stopAll = regions.map(([group, region])=>{
        var _a2, _b, _c;
        let target = (_b = (_a2 = region.pitch_keycenter) != null ? _a2 : region.key) != null ? _b : midi;
        const detune = (midi - target) * 100;
        return this.player.start($0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, sample), {
            note: region.sample,
            decayTime: sample.decayTime,
            detune: detune + ((_c = sample.detune) != null ? _c : this.options.detune),
            onEnded: onEnded,
            stopId: midi
        }));
    });
    switch(stopAll.length){
        case 0:
            return ()=>void 0;
        case 1:
            return stopAll[0];
        default:
            return (time)=>stopAll.forEach((stop)=>stop(time));
    }
};
// src/tremolo.ts
function $0d19688bebdb26f8$var$createTremolo(context, depth) {
    const input = context.createGain();
    const output = context.createGain();
    input.channelCount = 2;
    input.channelCountMode = "explicit";
    const splitter = context.createChannelSplitter(2);
    const ampL = context.createGain();
    const ampR = context.createGain();
    const merger = context.createChannelMerger(2);
    const lfoL = context.createOscillator();
    lfoL.type = "sine";
    lfoL.frequency.value = 1;
    lfoL.start();
    const lfoLAmp = context.createGain();
    const lfoR = context.createOscillator();
    lfoR.type = "sine";
    lfoR.frequency.value = 1.1;
    lfoR.start();
    const lfoRAmp = context.createGain();
    input.connect(splitter);
    splitter.connect(ampL, 0);
    splitter.connect(ampR, 1);
    ampL.connect(merger, 0, 0);
    ampR.connect(merger, 0, 1);
    lfoL.connect(lfoLAmp);
    lfoLAmp.connect(ampL.gain);
    lfoR.connect(lfoRAmp);
    lfoRAmp.connect(ampR.gain);
    merger.connect(output);
    const unsubscribe = depth((depth2)=>{
        lfoLAmp.gain.value = depth2;
        lfoRAmp.gain.value = depth2;
    });
    input.disconnect = ()=>{
        unsubscribe();
        lfoL.stop();
        lfoR.stop();
        input.disconnect(splitter);
        splitter.disconnect(ampL, 0);
        splitter.disconnect(ampR, 1);
        ampL.disconnect(merger, 0, 0);
        ampR.disconnect(merger, 0, 1);
        lfoL.disconnect(ampL);
        lfoR.disconnect(ampR);
        merger.disconnect(output);
    };
    return {
        input: input,
        output: output
    };
}
// src/electric-piano.ts
function $0d19688bebdb26f8$export$aba2f28f2a021086() {
    return Object.keys($0d19688bebdb26f8$var$INSTRUMENTS2);
}
var $0d19688bebdb26f8$var$INSTRUMENTS2 = {
    CP80: "https://danigb.github.io/samples/gs-e-pianos/CP80/cp80.websfz.json",
    PianetT: "https://danigb.github.io/samples/gs-e-pianos/Pianet T/pianet-t.websfz.json",
    WurlitzerEP200: "https://danigb.github.io/samples/gs-e-pianos/Wurlitzer EP200/wurlitzer-ep200.websfz.json",
    TX81Z: "https://danigb.github.io/samples/vcsl/TX81Z/tx81z-fm-piano.websfz.json"
};
var $0d19688bebdb26f8$export$858a9ef83d65172b = class extends $0d19688bebdb26f8$var$SfzSampler {
    constructor(context, options){
        var _a;
        super(context, $0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, options), {
            instrument: (_a = $0d19688bebdb26f8$var$INSTRUMENTS2[options.instrument]) != null ? _a : options.instrument
        }));
        const depth = $0d19688bebdb26f8$var$createControl(0);
        this.tremolo = {
            level: (level)=>depth.set($0d19688bebdb26f8$var$midiVelToGain(level))
        };
        const tremolo = $0d19688bebdb26f8$var$createTremolo(context, depth.subscribe);
        this.output.addInsert(tremolo);
    }
};
// src/player/layers.ts
function $0d19688bebdb26f8$var$createEmptySamplerInstrument(options = {}) {
    return {
        groups: [],
        options: options
    };
}
function $0d19688bebdb26f8$var$createEmptyRegionGroup() {
    return {
        regions: []
    };
}
function $0d19688bebdb26f8$var$findSamplesInRegions(group, sample, seqNumber, options) {
    const results = [];
    const midi = $0d19688bebdb26f8$var$toMidi(sample.note);
    if (midi === void 0) return results;
    for (const region of group.regions){
        const found = $0d19688bebdb26f8$var$findSampleInRegion(midi, seqNumber != null ? seqNumber : 0, sample, region, options);
        if (found) results.push(found);
    }
    return results;
}
function $0d19688bebdb26f8$var$findFirstSampleInRegions(group, sample, seqNumber, options) {
    const midi = $0d19688bebdb26f8$var$toMidi(sample.note);
    if (midi === void 0) return void 0;
    for (const region of group.regions){
        const found = $0d19688bebdb26f8$var$findSampleInRegion(midi, seqNumber != null ? seqNumber : 0, sample, region, options);
        if (found) return found;
    }
    return void 0;
}
function $0d19688bebdb26f8$var$findSampleInRegion(midi, seqNum, sample, region, defaults) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B;
    const matchMidi = midi >= ((_a = region.midiLow) != null ? _a : 0) && midi < ((_b = region.midiHigh) != null ? _b : 127) + 1;
    if (!matchMidi) return void 0;
    const matchVelocity = sample.velocity === void 0 || sample.velocity >= ((_c = region.velLow) != null ? _c : 0) && sample.velocity <= ((_d = region.velHigh) != null ? _d : 127);
    if (!matchVelocity) return void 0;
    if (region.seqLength) {
        const currentSeq = seqNum % region.seqLength;
        const regionIndex = ((_e = region.seqPosition) != null ? _e : 1) - 1;
        if (currentSeq !== regionIndex) return void 0;
    }
    const semitones = midi - region.midiPitch;
    const velocity = (_f = sample.velocity) != null ? _f : defaults == null ? void 0 : defaults.velocity;
    const regionGainOffset = region.volume ? $0d19688bebdb26f8$var$dbToGain(region.volume) : 0;
    const sampleGainOffset = (_h = (_g = sample.gainOffset) != null ? _g : defaults == null ? void 0 : defaults.gainOffset) != null ? _h : 0;
    const sampleDetune = (_i = sample.detune) != null ? _i : 0;
    return {
        decayTime: (_l = (_k = sample == null ? void 0 : sample.decayTime) != null ? _k : (_j = region.sample) == null ? void 0 : _j.decayTime) != null ? _l : defaults == null ? void 0 : defaults.decayTime,
        detune: 100 * (semitones + ((_m = region.tune) != null ? _m : 0)) + sampleDetune,
        duration: (_p = (_o = sample == null ? void 0 : sample.duration) != null ? _o : (_n = region.sample) == null ? void 0 : _n.duration) != null ? _p : defaults == null ? void 0 : defaults.duration,
        gainOffset: sampleGainOffset + regionGainOffset || void 0,
        loop: (_s = (_r = sample == null ? void 0 : sample.loop) != null ? _r : (_q = region.sample) == null ? void 0 : _q.loop) != null ? _s : defaults == null ? void 0 : defaults.loop,
        loopEnd: (_v = (_u = sample == null ? void 0 : sample.loopEnd) != null ? _u : (_t = region.sample) == null ? void 0 : _t.loopEnd) != null ? _v : defaults == null ? void 0 : defaults.loopEnd,
        loopStart: (_y = (_x = sample == null ? void 0 : sample.loopStart) != null ? _x : (_w = region.sample) == null ? void 0 : _w.loopStart) != null ? _y : defaults == null ? void 0 : defaults.loopStart,
        lpfCutoffHz: (_B = (_A = sample == null ? void 0 : sample.lpfCutoffHz) != null ? _A : (_z = region.sample) == null ? void 0 : _z.lpfCutoffHz) != null ? _B : defaults == null ? void 0 : defaults.lpfCutoffHz,
        name: region.sampleName,
        note: midi,
        onEnded: sample.onEnded,
        onStart: sample.onStart,
        stopId: sample.name,
        time: sample.time,
        velocity: velocity == void 0 ? void 0 : velocity
    };
}
function $0d19688bebdb26f8$var$spreadRegions(regions) {
    if (regions.length === 0) return [];
    regions.sort((a, b)=>a.midiPitch - b.midiPitch);
    regions[0].midiLow = 0;
    regions[0].midiHigh = 127;
    if (regions.length === 1) return regions;
    for(let i = 1; i < regions.length; i++){
        const prev = regions[i - 1];
        const curr = regions[i];
        const mid = Math.floor((prev.midiPitch + curr.midiPitch) / 2);
        prev.midiHigh = mid;
        curr.midiLow = mid + 1;
    }
    regions[regions.length - 1].midiHigh = 127;
    return regions;
}
// src/player/region-player.ts
var $0d19688bebdb26f8$var$RegionPlayer = class {
    constructor(context, options){
        this.context = context;
        this.seqNum = 0;
        const channel = new $0d19688bebdb26f8$var$Channel(context, options);
        this.instrument = $0d19688bebdb26f8$var$createEmptySamplerInstrument(options);
        this.player = new $0d19688bebdb26f8$var$QueuedPlayer(new $0d19688bebdb26f8$var$SamplePlayer(context, $0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, options), {
            destination: channel.input
        })), options);
        this.output = channel;
    }
    get buffers() {
        return this.player.buffers;
    }
    start(sample) {
        const stopAll = [];
        const sampleStart = typeof sample === "object" ? sample : {
            note: sample
        };
        for (const group of this.instrument.groups){
            const found = $0d19688bebdb26f8$var$findSamplesInRegions(group, sampleStart, this.seqNum);
            this.seqNum++;
            for (const sample2 of found){
                let stop = this.player.start(sample2);
                stopAll.push(stop);
            }
        }
        return (time)=>stopAll.forEach((stop)=>stop(time));
    }
    stop(sample) {
        if (sample == void 0) {
            this.player.stop();
            return;
        }
        const toStop = typeof sample === "object" ? sample : {
            stopId: sample
        };
        const midi = $0d19688bebdb26f8$var$toMidi(toStop.stopId);
        if (!midi) return;
        toStop.stopId = midi;
        this.player.stop(toStop);
    }
    disconnect() {
        this.output.disconnect();
        this.player.disconnect();
    }
};
// src/sfz2.ts
function $0d19688bebdb26f8$var$SfzInstrumentLoader2(url, config) {
    const audioExt = $0d19688bebdb26f8$var$getPreferredAudioExtension();
    return (context, storage)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
            const sfz = yield fetch(url).then((res)=>res.text());
            const errors = $0d19688bebdb26f8$var$sfzToLayer(sfz, config.group);
            if (errors.length) console.warn("Problems converting sfz", errors);
            const sampleNames = /* @__PURE__ */ new Set();
            config.group.regions.forEach((r)=>sampleNames.add(r.sampleName));
            return Promise.all(Array.from(sampleNames).map((sampleName)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
                    const sampleUrl = config.urlFromSampleName(sampleName, audioExt);
                    const buffer = yield $0d19688bebdb26f8$var$loadAudioBuffer(context, sampleUrl, storage);
                    config.buffers[sampleName] = buffer;
                }))).then(()=>config.group);
        });
}
function $0d19688bebdb26f8$var$sfzToLayer(sfz, group) {
    let mode = "global";
    const tokens = sfz.split("\n").map($0d19688bebdb26f8$var$parseToken).filter((x)=>!!x);
    const scope = new $0d19688bebdb26f8$var$Scope();
    let errors = [];
    for (const token of tokens)switch(token.type){
        case "mode":
            errors.push(scope.closeScope(mode, group));
            mode = token.value;
            break;
        case "prop:num":
        case "prop:str":
        case "prop:num_arr":
            scope.push(token.key, token.value);
            break;
        case "unknown":
            console.warn("Unknown SFZ token", token.value);
            break;
    }
    closeScope(mode, scope, group);
    return errors.filter((x)=>!!x);
    function closeScope(mode2, scope2, group2) {}
}
var $0d19688bebdb26f8$var$MODE_REGEX = /^<([^>]+)>$/;
var $0d19688bebdb26f8$var$PROP_NUM_REGEX = /^([^=]+)=([-\.\d]+)$/;
var $0d19688bebdb26f8$var$PROP_STR_REGEX = /^([^=]+)=(.+)$/;
var $0d19688bebdb26f8$var$PROP_NUM_ARR_REGEX = /^([^=]+)_(\d+)=(\d+)$/;
function $0d19688bebdb26f8$var$parseToken(line) {
    line = line.trim();
    if (line === "") return void 0;
    if (line.startsWith("//")) return void 0;
    const modeMatch = line.match($0d19688bebdb26f8$var$MODE_REGEX);
    if (modeMatch) return {
        type: "mode",
        value: modeMatch[1]
    };
    const propNumArrMatch = line.match($0d19688bebdb26f8$var$PROP_NUM_ARR_REGEX);
    if (propNumArrMatch) return {
        type: "prop:num_arr",
        key: propNumArrMatch[1],
        value: [
            Number(propNumArrMatch[2]),
            Number(propNumArrMatch[3])
        ]
    };
    const propNumMatch = line.match($0d19688bebdb26f8$var$PROP_NUM_REGEX);
    if (propNumMatch) return {
        type: "prop:num",
        key: propNumMatch[1],
        value: Number(propNumMatch[2])
    };
    const propStrMatch = line.match($0d19688bebdb26f8$var$PROP_STR_REGEX);
    if (propStrMatch) return {
        type: "prop:str",
        key: propStrMatch[1],
        value: propStrMatch[2]
    };
    return {
        type: "unknown",
        value: line
    };
}
var $0d19688bebdb26f8$var$_Scope_instances, $0d19688bebdb26f8$var$closeRegion_fn;
var $0d19688bebdb26f8$var$Scope = class {
    constructor(){
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_Scope_instances);
        this.values = {};
        this.global = {};
        this.group = {};
    }
    closeScope(mode, group) {
        if (mode === "global") $0d19688bebdb26f8$var$__privateMethod(this, $0d19688bebdb26f8$var$_Scope_instances, $0d19688bebdb26f8$var$closeRegion_fn).call(this, this.global);
        else if (mode === "group") this.group = $0d19688bebdb26f8$var$__privateMethod(this, $0d19688bebdb26f8$var$_Scope_instances, $0d19688bebdb26f8$var$closeRegion_fn).call(this, {});
        else if (mode === "region") {
            const region = $0d19688bebdb26f8$var$__privateMethod(this, $0d19688bebdb26f8$var$_Scope_instances, $0d19688bebdb26f8$var$closeRegion_fn).call(this, $0d19688bebdb26f8$var$__spreadValues($0d19688bebdb26f8$var$__spreadValues({
                sampleName: "",
                midiPitch: -1
            }, this.global), this.group));
            if (region.sampleName === "") return "Missing sample name";
            if (region.midiPitch === -1) {
                if (region.midiLow !== void 0) region.midiPitch = region.midiLow;
                else return "Missing pitch_keycenter";
            }
            if (region.seqLength && region.seqPosition === void 0) region.seqPosition = 1;
            if (region.ampRelease) {
                region.sample = {
                    decayTime: region.ampRelease
                };
                delete region.ampRelease;
            }
            group.regions.push(region);
        }
    }
    get empty() {
        return Object.keys(this.values).length === 0;
    }
    get keys() {
        return Object.keys(this.values);
    }
    push(key, value) {
        this.values[key] = value;
    }
    popNum(key, dest, destKey) {
        if (typeof this.values[key] !== "number") return false;
        dest[destKey] = this.values[key];
        delete this.values[key];
        return true;
    }
    popStr(key, dest, destKey) {
        if (typeof this.values[key] !== "string") return false;
        dest[destKey] = this.values[key];
        delete this.values[key];
        return true;
    }
    popNumArr(key, dest, destKey) {
        if (!Array.isArray(this.values[key])) return false;
        dest[destKey] = this.values[key];
        delete this.values[key];
        return true;
    }
};
$0d19688bebdb26f8$var$_Scope_instances = new WeakSet();
$0d19688bebdb26f8$var$closeRegion_fn = function(region) {
    this.popStr("sample", region, "sampleName");
    this.popNum("pitch_keycenter", region, "midiPitch");
    this.popNum("ampeg_attack", region, "ampAttack");
    this.popNum("ampeg_release", region, "ampRelease");
    this.popNum("bend_down", region, "bendDown");
    this.popNum("bend_up", region, "bendUp");
    this.popNum("group", region, "group");
    this.popNum("hikey", region, "midiHigh");
    this.popNum("hivel", region, "velHigh");
    this.popNum("lokey", region, "midiLow");
    this.popNum("offset", region, "offset");
    this.popNum("lovel", region, "velLow");
    this.popNum("off_by", region, "groupOffBy");
    this.popNum("pitch_keytrack", region, "ignore");
    this.popNum("seq_length", region, "seqLength");
    this.popNum("seq_position", region, "seqPosition");
    this.popNum("tune", region, "tune");
    this.popNum("volume", region, "volume");
    this.popNumArr("amp_velcurve", region, "ampVelCurve");
    this.values = {};
    return region;
};
// src/versilian.ts
var $0d19688bebdb26f8$var$instruments = [];
var $0d19688bebdb26f8$var$BASE_URL = "https://smpldsnds.github.io/sgossner-vcsl/";
function $0d19688bebdb26f8$export$a66a4b902406fe5d() {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        if ($0d19688bebdb26f8$var$instruments.length) return $0d19688bebdb26f8$var$instruments;
        $0d19688bebdb26f8$var$instruments = yield fetch($0d19688bebdb26f8$var$BASE_URL + "sfz_files.json").then((res)=>res.json());
        return $0d19688bebdb26f8$var$instruments;
    });
}
function $0d19688bebdb26f8$var$getVcslInstrumentSfzUrl(instrument) {
    return $0d19688bebdb26f8$var$BASE_URL + instrument + ".sfz";
}
function $0d19688bebdb26f8$export$5448e79a3a331366(instrument, buffers) {
    const url = $0d19688bebdb26f8$var$getVcslInstrumentSfzUrl(instrument);
    const base = instrument.slice(0, instrument.lastIndexOf("/") + 1);
    const sampleBase = `https://smpldsnds.github.io/sgossner-vcsl/${base}`;
    const group = $0d19688bebdb26f8$var$createEmptyRegionGroup();
    return $0d19688bebdb26f8$var$SfzInstrumentLoader2(url, {
        buffers: buffers,
        group: group,
        urlFromSampleName: (sampleName, audioExt)=>{
            return sampleBase + "/" + sampleName.replace(".wav", audioExt);
        }
    });
}
var $0d19688bebdb26f8$export$8cc6d0fd3afaa0c8 = class {
    constructor(context, options = {}){
        var _a, _b;
        this.config = {
            instrument: (_a = options.instrument) != null ? _a : "Arco",
            storage: (_b = options.storage) != null ? _b : $0d19688bebdb26f8$export$7fd566d5ad2998a9
        };
        this.player = new $0d19688bebdb26f8$var$RegionPlayer(context, options);
        const loader = $0d19688bebdb26f8$export$5448e79a3a331366(this.config.instrument, this.player.buffers);
        this.load = loader(context, this.config.storage).then((group)=>{
            this.player.instrument.groups.push(group);
            return this;
        });
    }
    get output() {
        return this.player.output;
    }
    get buffers() {
        return this.player.buffers;
    }
    get context() {
        return this.player.context;
    }
    start(sample) {
        return this.player.start(sample);
    }
    stop(sample) {
        return this.player.stop(sample);
    }
    disconnect() {
        this.player.disconnect();
    }
};
// src/mallet.ts
function $0d19688bebdb26f8$export$53af967af8457099() {
    return Object.keys($0d19688bebdb26f8$export$d256c5979b498699);
}
var $0d19688bebdb26f8$export$7003e69389dc401 = class extends $0d19688bebdb26f8$export$8cc6d0fd3afaa0c8 {
    constructor(context, options){
        var _a;
        super(context, $0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, options), {
            instrument: $0d19688bebdb26f8$export$d256c5979b498699[(_a = options.instrument) != null ? _a : ""]
        }));
    }
};
var $0d19688bebdb26f8$export$d256c5979b498699 = {
    "Balafon - Hard Mallet": "Idiophones/Struck Idiophones/Balafon - Hard Mallet",
    "Balafon - Keyswitch": "Idiophones/Struck Idiophones/Balafon - Keyswitch",
    "Balafon - Soft Mallet": "Idiophones/Struck Idiophones/Balafon - Soft Mallet",
    "Balafon - Traditional Mallet": "Idiophones/Struck Idiophones/Balafon - Traditional Mallet",
    "Tubular Bells 1": "Idiophones/Struck Idiophones/Tubular Bells 1",
    "Tubular Bells 2": "Idiophones/Struck Idiophones/Tubular Bells 2",
    "Vibraphone - Bowed": "Idiophones/Struck Idiophones/Vibraphone - Bowed",
    "Vibraphone - Hard Mallets": "Idiophones/Struck Idiophones/Vibraphone - Hard Mallets",
    "Vibraphone - Keyswitch": "Idiophones/Struck Idiophones/Vibraphone - Keyswitch",
    "Vibraphone - Soft Mallets": "Idiophones/Struck Idiophones/Vibraphone - Soft Mallets",
    "Xylophone - Hard Mallets": "Idiophones/Struck Idiophones/Xylophone - Hard Mallets",
    "Xylophone - Keyswitch": "Idiophones/Struck Idiophones/Xylophone - Keyswitch",
    "Xylophone - Medium Mallets": "Idiophones/Struck Idiophones/Xylophone - Medium Mallets",
    "Xylophone - Soft Mallets": "Idiophones/Struck Idiophones/Xylophone - Soft Mallets"
};
// src/mellotron.ts
var $0d19688bebdb26f8$var$INSTRUMENT_VARIATIONS = {
    "300 STRINGS CELLO": [
        "300 STRINGS",
        "CELL"
    ],
    "300 STRINGS VIOLA": [
        "300 STRINGS",
        "VIOL"
    ]
};
function $0d19688bebdb26f8$export$91f876c54fbf91d6() {
    return [
        "300 STRINGS CELLO",
        "300 STRINGS VIOLA",
        "8VOICE CHOIR",
        "BASSA+STRNGS",
        "BOYS CHOIR",
        "CHA CHA FLT",
        "CHM CLARINET",
        "CHMB 3 VLNS",
        "CHMB ALTOSAX",
        "CHMB FEMALE",
        "CHMB MALE VC",
        "CHMB TNR SAX",
        "CHMB TRMBONE",
        "CHMB TRUMPET",
        "CHMBLN CELLO",
        "CHMBLN FLUTE",
        "CHMBLN OBOE",
        "DIXIE+TRMBN",
        "FOXTROT+SAX",
        "HALFSP.BRASS",
        "MIXED STRGS",
        "MKII BRASS",
        "MKII GUITAR",
        "MKII ORGAN",
        "MKII SAX",
        "MKII VIBES",
        "MKII VIOLINS",
        "MOVE BS+STGS",
        "STRGS+BRASS",
        "TROMB+TRMPT",
        "TRON 16VLNS",
        "TRON CELLO",
        "TRON FLUTE",
        "TRON VIOLA"
    ];
}
var $0d19688bebdb26f8$export$32e02f95080c701e = class {
    constructor(context, options){
        this.context = context;
        this.options = options;
        this.config = $0d19688bebdb26f8$var$getMellotronConfig(options);
        this.player = new $0d19688bebdb26f8$var$DefaultPlayer(context, options);
        this.group = $0d19688bebdb26f8$var$createEmptyRegionGroup();
        const loader = $0d19688bebdb26f8$var$loadMellotronInstrument(this.config.instrument, this.player.buffers, this.group);
        this.load = loader(context, this.config.storage).then(()=>this);
    }
    get buffers() {
        return this.player.buffers;
    }
    get output() {
        return this.player.output;
    }
    start(sample) {
        const found = $0d19688bebdb26f8$var$findFirstSampleInRegions(this.group, typeof sample === "object" ? sample : {
            note: sample
        }, void 0, this.options);
        if (!found) return ()=>void 0;
        return this.player.start(found);
    }
    stop(sample) {
        this.player.stop(sample);
    }
    disconnect() {
        this.player.disconnect();
    }
};
function $0d19688bebdb26f8$var$getMellotronConfig(options) {
    var _a, _b;
    return {
        instrument: (_a = options.instrument) != null ? _a : "MKII VIOLINS",
        storage: (_b = options.storage) != null ? _b : $0d19688bebdb26f8$export$7fd566d5ad2998a9
    };
}
function $0d19688bebdb26f8$var$loadMellotronInstrument(instrument, buffers, group) {
    let variation = $0d19688bebdb26f8$var$INSTRUMENT_VARIATIONS[instrument];
    if (variation) instrument = variation[0];
    return (context, storage)=>{
        const baseUrl = `https://smpldsnds.github.io/archiveorg-mellotron/${instrument}/`;
        const audioExt = $0d19688bebdb26f8$var$getPreferredAudioExtension();
        return fetch(baseUrl + "files.json").then((res)=>res.json()).then((sampleNames)=>Promise.all(sampleNames.map((sampleName)=>{
                var _a;
                if (variation && !sampleName.includes(variation[1])) return;
                const midi = $0d19688bebdb26f8$var$toMidi((_a = sampleName.split(" ")[0]) != null ? _a : "");
                if (!midi) return;
                const sampleUrl = baseUrl + sampleName + audioExt;
                $0d19688bebdb26f8$var$loadAudioBuffer(context, sampleUrl, storage).then((audioBuffer)=>{
                    var _a2;
                    buffers[sampleName] = audioBuffer;
                    const duration = (_a2 = audioBuffer == null ? void 0 : audioBuffer.duration) != null ? _a2 : 0;
                    group.regions.push({
                        sampleName: sampleName,
                        midiPitch: midi,
                        sample: {
                            loop: true,
                            loopStart: duration / 10,
                            loopEnd: duration - duration / 10
                        }
                    });
                });
            }))).then(()=>{
            $0d19688bebdb26f8$var$spreadRegions(group.regions);
        });
    };
}
// src/reverb/processor.min.ts
var $0d19688bebdb26f8$var$PROCESSOR = `"use strict";(()=>{var f=class extends AudioWorkletProcessor{_pDLength;_preDelay;_pDWrite;_lp1;_lp2;_lp3;_excPhase;_taps;_Delays;sampleRate;static get parameterDescriptors(){return[["preDelay",0,0,sampleRate-1,"k-rate"],["bandwidth",.9999,0,1,"k-rate"],["inputDiffusion1",.75,0,1,"k-rate"],["inputDiffusion2",.625,0,1,"k-rate"],["decay",.5,0,1,"k-rate"],["decayDiffusion1",.7,0,.999999,"k-rate"],["decayDiffusion2",.5,0,.999999,"k-rate"],["damping",.005,0,1,"k-rate"],["excursionRate",.5,0,2,"k-rate"],["excursionDepth",.7,0,2,"k-rate"],["wet",1,0,1,"k-rate"],["dry",0,0,1,"k-rate"]].map(e=>new Object({name:e[0],defaultValue:e[1],minValue:e[2],maxValue:e[3],automationRate:e[4]}))}constructor(e){super(),this.sampleRate=sampleRate,this._Delays=[],this._pDLength=sampleRate+(128-sampleRate%128),this._preDelay=new Float32Array(this._pDLength),this._pDWrite=0,this._lp1=0,this._lp2=0,this._lp3=0,this._excPhase=0,[.004771345,.003595309,.012734787,.009307483,.022579886,.149625349,.060481839,.1249958,.030509727,.141695508,.089244313,.106280031].forEach(a=>this.makeDelay(a,sampleRate)),this._taps=Int16Array.from([.008937872,.099929438,.064278754,.067067639,.066866033,.006283391,.035818689,.011861161,.121870905,.041262054,.08981553,.070931756,.011256342,.004065724],a=>Math.round(a*sampleRate))}makeDelay(e,a){let t=Math.round(e*a),s=2**Math.ceil(Math.log2(t));this._Delays.push([new Float32Array(s),t-1,0,s-1])}writeDelay(e,a){return this._Delays[e][0][this._Delays[e][1]]=a}readDelay(e){return this._Delays[e][0][this._Delays[e][2]]}readDelayAt(e,a){let t=this._Delays[e];return t[0][t[2]+a&t[3]]}readDelayCAt(e,a){let t=this._Delays[e],s=a-~~a,d=~~a+t[2]-1,r=t[3],D=t[0][d++&r],l=t[0][d++&r],h=t[0][d++&r],y=t[0][d&r],u=(3*(l-h)-D+y)/2,m=2*h+D-(5*l+y)/2,c=(h-D)/2;return((u*s+m)*s+c)*s+l}process(e,a,t){let s=~~t.preDelay[0],d=t.bandwidth[0],r=t.inputDiffusion1[0],D=t.inputDiffusion2[0],l=t.decay[0],h=t.decayDiffusion1[0],y=t.decayDiffusion2[0],u=1-t.damping[0],m=t.excursionRate[0]/sampleRate,c=t.excursionDepth[0]*sampleRate/1e3,w=t.wet[0]*.6,A=t.dry[0];if(e[0].length==2)for(let i=127;i>=0;i--)this._preDelay[this._pDWrite+i]=(e[0][0][i]+e[0][1][i])*.5,a[0][0][i]=e[0][0][i]*A,a[0][1][i]=e[0][1][i]*A;else if(e[0].length>0){this._preDelay.set(e[0][0],this._pDWrite);for(let i=127;i>=0;i--)a[0][0][i]=a[0][1][i]=e[0][0][i]*A}else this._preDelay.set(new Float32Array(128),this._pDWrite);let o=0;for(;o<128;){let i=0,b=0;this._lp1+=d*(this._preDelay[(this._pDLength+this._pDWrite-s+o)%this._pDLength]-this._lp1);let p=this.writeDelay(0,this._lp1-r*this.readDelay(0));p=this.writeDelay(1,r*(p-this.readDelay(1))+this.readDelay(0)),p=this.writeDelay(2,r*p+this.readDelay(1)-D*this.readDelay(2)),p=this.writeDelay(3,D*(p-this.readDelay(3))+this.readDelay(2));let k=D*p+this.readDelay(3),g=c*(1+Math.cos(this._excPhase*6.28)),x=c*(1+Math.sin(this._excPhase*6.2847)),_=this.writeDelay(4,k+l*this.readDelay(11)+h*this.readDelayCAt(4,g));this.writeDelay(5,this.readDelayCAt(4,g)-h*_),this._lp2+=u*(this.readDelay(5)-this._lp2),_=this.writeDelay(6,l*this._lp2-y*this.readDelay(6)),this.writeDelay(7,this.readDelay(6)+y*_),_=this.writeDelay(8,k+l*this.readDelay(7)+h*this.readDelayCAt(8,x)),this.writeDelay(9,this.readDelayCAt(8,x)-h*_),this._lp3+=u*(this.readDelay(9)-this._lp3),_=this.writeDelay(10,l*this._lp3-y*this.readDelay(10)),this.writeDelay(11,this.readDelay(10)+y*_),i=this.readDelayAt(9,this._taps[0])+this.readDelayAt(9,this._taps[1])-this.readDelayAt(10,this._taps[2])+this.readDelayAt(11,this._taps[3])-this.readDelayAt(5,this._taps[4])-this.readDelayAt(6,this._taps[5])-this.readDelayAt(7,this._taps[6]),b=this.readDelayAt(5,this._taps[7])+this.readDelayAt(5,this._taps[8])-this.readDelayAt(6,this._taps[9])+this.readDelayAt(7,this._taps[10])-this.readDelayAt(9,this._taps[11])-this.readDelayAt(10,this._taps[12])-this.readDelayAt(11,this._taps[13]),a[0][0][o]+=i*w,a[0][1][o]+=b*w,this._excPhase+=m,o++;for(let R=0,n=this._Delays[0];R<this._Delays.length;n=this._Delays[++R])n[1]=n[1]+1&n[3],n[2]=n[2]+1&n[3]}return this._pDWrite=(this._pDWrite+128)%this._pDLength,!0}};registerProcessor("DattorroReverb",f);})();`;
// src/reverb/reverb.ts
var $0d19688bebdb26f8$var$PARAMS = [
    "preDelay",
    "bandwidth",
    "inputDiffusion1",
    "inputDiffusion2",
    "decay",
    "decayDiffusion1",
    "decayDiffusion2",
    "damping",
    "excursionRate",
    "excursionDepth",
    "wet",
    "dry"
];
var $0d19688bebdb26f8$var$init = /* @__PURE__ */ new WeakMap();
function $0d19688bebdb26f8$var$createDattorroReverbEffect(context) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        let ready = $0d19688bebdb26f8$var$init.get(context);
        if (!ready) {
            const blob = new Blob([
                $0d19688bebdb26f8$var$PROCESSOR
            ], {
                type: "application/javascript"
            });
            const url = URL.createObjectURL(blob);
            ready = context.audioWorklet.addModule(url);
            $0d19688bebdb26f8$var$init.set(context, ready);
        }
        yield ready;
        const reverb = new AudioWorkletNode(context, "DattorroReverb", {
            outputChannelCount: [
                2
            ]
        });
        return reverb;
    });
}
var $0d19688bebdb26f8$var$_effect, $0d19688bebdb26f8$var$_ready, $0d19688bebdb26f8$var$_output;
var $0d19688bebdb26f8$export$6fb1520d4329a18d = class {
    constructor(context){
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_effect);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_ready);
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_output);
        this.input = context.createGain();
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_output, context.destination);
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_ready, $0d19688bebdb26f8$var$createDattorroReverbEffect(context).then((reverb)=>{
            this.input.connect(reverb);
            reverb.connect($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_output));
            $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_effect, reverb);
            return this;
        }));
    }
    get paramNames() {
        return $0d19688bebdb26f8$var$PARAMS;
    }
    getParam(name) {
        var _a;
        return (_a = $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_effect)) == null ? void 0 : _a.parameters.get("preDelay");
    }
    get isReady() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_effect) !== void 0;
    }
    ready() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_ready);
    }
    connect(output) {
        if ($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_effect)) {
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_effect).disconnect($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_output));
            $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_effect).connect(output);
        }
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_output, output);
    }
};
$0d19688bebdb26f8$var$_effect = new WeakMap();
$0d19688bebdb26f8$var$_ready = new WeakMap();
$0d19688bebdb26f8$var$_output = new WeakMap();
// src/sampler.ts
var $0d19688bebdb26f8$var$_options;
var $0d19688bebdb26f8$export$322f102bec719b22 = class {
    constructor(context, options = {}){
        this.context = context;
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_options);
        var _a, _b, _c, _d, _e, _f;
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_options, {
            destination: (_a = options.destination) != null ? _a : context.destination,
            detune: 0,
            volume: (_b = options.volume) != null ? _b : 100,
            velocity: (_c = options.velocity) != null ? _c : 100,
            buffers: (_d = options.buffers) != null ? _d : {},
            volumeToGain: (_e = options.volumeToGain) != null ? _e : $0d19688bebdb26f8$var$midiVelToGain
        });
        this.player = new $0d19688bebdb26f8$var$DefaultPlayer(context, $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_options));
        const storage = (_f = options.storage) != null ? _f : $0d19688bebdb26f8$export$7fd566d5ad2998a9;
        const loader = typeof $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_options).buffers === "function" ? $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_options).buffers : $0d19688bebdb26f8$var$createAudioBuffersLoader($0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_options).buffers, storage);
        this.load = loader(context, this.player.buffers).then(()=>this);
    }
    loaded() {
        return $0d19688bebdb26f8$var$__async(this, null, function*() {
            console.warn("deprecated: use load instead");
            return this.load;
        });
    }
    get output() {
        return this.player.output;
    }
    start(sample) {
        return this.player.start(typeof sample === "object" ? sample : {
            note: sample
        });
    }
    stop(sample) {
        return this.player.stop(typeof sample === "object" ? sample : sample === void 0 ? void 0 : {
            stopId: sample
        });
    }
    disconnect() {
        return this.player.disconnect();
    }
};
$0d19688bebdb26f8$var$_options = new WeakMap();
function $0d19688bebdb26f8$var$createAudioBuffersLoader(source, storage) {
    return (context, buffers)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
            yield Promise.all([
                Object.keys(source).map((key)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
                        const value = source[key];
                        if (value instanceof AudioBuffer) buffers[key] = value;
                        else if (typeof value === "string") {
                            const buffer = yield $0d19688bebdb26f8$var$loadAudioBuffer(context, value, storage);
                            if (buffer) buffers[key] = buffer;
                        }
                    }))
            ]);
        });
}
// src/smolken.ts
function $0d19688bebdb26f8$export$bb024515dad59be8() {
    return [
        "Pizzicato",
        "Arco",
        "Switched"
    ];
}
function $0d19688bebdb26f8$var$getSmolkenUrl(instrument) {
    const FILES = {
        Arco: "arco",
        Pizzicato: "pizz",
        Switched: "switched"
    };
    return `https://smpldsnds.github.io/sfzinstruments-dsmolken-double-bass/d_smolken_rubner_bass_${FILES[instrument]}.sfz`;
}
var $0d19688bebdb26f8$export$548691975240e36a = class {
    constructor(context, options = {}){
        this.seqNum = 0;
        var _a, _b;
        this.config = {
            instrument: (_a = options.instrument) != null ? _a : "Arco",
            storage: (_b = options.storage) != null ? _b : $0d19688bebdb26f8$export$7fd566d5ad2998a9
        };
        this.player = new $0d19688bebdb26f8$var$DefaultPlayer(context, options);
        this.group = $0d19688bebdb26f8$var$createEmptyRegionGroup();
        const url = $0d19688bebdb26f8$var$getSmolkenUrl(this.config.instrument);
        const loader = $0d19688bebdb26f8$var$SfzInstrumentLoader2(url, {
            buffers: this.player.buffers,
            group: this.group,
            urlFromSampleName: (sampleName, audioExt)=>{
                const samplePath = sampleName.replace("\\", "/").replace(".wav", audioExt);
                return `https://smpldsnds.github.io/sfzinstruments-dsmolken-double-bass/${samplePath}`;
            }
        });
        this.load = loader(context, this.config.storage).then(()=>this);
    }
    get output() {
        return this.player.output;
    }
    get buffers() {
        return this.player.buffers;
    }
    get context() {
        return this.player.context;
    }
    start(sample) {
        const found = $0d19688bebdb26f8$var$findSamplesInRegions(this.group, typeof sample === "object" ? sample : {
            note: sample
        }, this.seqNum);
        this.seqNum++;
        const stopAll = found.map((sample2)=>this.player.start(sample2));
        return (time)=>stopAll.forEach((stop)=>stop(time));
    }
    stop(sample) {
        if (sample == void 0) {
            this.player.stop();
            return;
        }
        const toStop = typeof sample === "object" ? sample : {
            stopId: sample
        };
        const midi = $0d19688bebdb26f8$var$toMidi(toStop.stopId);
        if (!midi) return;
        toStop.stopId = midi;
        this.player.stop(toStop);
    }
    disconnect() {
        this.player.disconnect();
    }
};
// src/soundfont/soundfont-instrument.ts
function $0d19688bebdb26f8$var$gleitzKitUrl(name, kit) {
    var _a;
    const format = (_a = $0d19688bebdb26f8$var$findFirstSupportedFormat([
        "ogg",
        "mp3"
    ])) != null ? _a : "mp3";
    return `https://gleitz.github.io/midi-js-soundfonts/${kit}/${name}-${format}.js`;
}
function $0d19688bebdb26f8$var$soundfontInstrumentLoader(url, buffers, group) {
    return (context, storage)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
            const sourceFile = yield (yield storage.fetch(url)).text();
            const json = $0d19688bebdb26f8$var$midiJsToJson(sourceFile);
            const noteNames = Object.keys(json);
            yield Promise.all(noteNames.map((noteName)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
                    const midi = $0d19688bebdb26f8$var$toMidi(noteName);
                    if (!midi) return;
                    const audioData = $0d19688bebdb26f8$var$base64ToArrayBuffer($0d19688bebdb26f8$var$removeBase64Prefix(json[noteName]));
                    const buffer = yield context.decodeAudioData(audioData);
                    buffers[noteName] = buffer;
                    group.regions.push({
                        sampleName: noteName,
                        midiPitch: midi
                    });
                })));
            $0d19688bebdb26f8$var$spreadRegions(group.regions);
        });
}
function $0d19688bebdb26f8$var$midiJsToJson(source) {
    const header = source.indexOf("MIDI.Soundfont.");
    if (header < 0) throw Error("Invalid MIDI.js Soundfont format");
    const start = source.indexOf("=", header) + 2;
    const end = source.lastIndexOf(",");
    return JSON.parse(source.slice(start, end) + "}");
}
function $0d19688bebdb26f8$var$removeBase64Prefix(audioBase64) {
    return audioBase64.slice(audioBase64.indexOf(",") + 1);
}
function $0d19688bebdb26f8$var$base64ToArrayBuffer(base64) {
    const decoded = window.atob(base64);
    const len = decoded.length;
    const bytes = new Uint8Array(len);
    for(let i = 0; i < len; i++)bytes[i] = decoded.charCodeAt(i);
    return bytes.buffer;
}
var $0d19688bebdb26f8$var$SOUNDFONT_KITS = [
    "MusyngKite",
    "FluidR3_GM"
];
var $0d19688bebdb26f8$var$SOUNDFONT_INSTRUMENTS = [
    "accordion",
    "acoustic_bass",
    "acoustic_grand_piano",
    "acoustic_guitar_nylon",
    "acoustic_guitar_steel",
    "agogo",
    "alto_sax",
    "applause",
    "bagpipe",
    "banjo",
    "baritone_sax",
    "bassoon",
    "bird_tweet",
    "blown_bottle",
    "brass_section",
    "breath_noise",
    "bright_acoustic_piano",
    "celesta",
    "cello",
    "choir_aahs",
    "church_organ",
    "clarinet",
    "clavinet",
    "contrabass",
    "distortion_guitar",
    "drawbar_organ",
    "dulcimer",
    "electric_bass_finger",
    "electric_bass_pick",
    "electric_grand_piano",
    "electric_guitar_clean",
    "electric_guitar_jazz",
    "electric_guitar_muted",
    "electric_piano_1",
    "electric_piano_2",
    "english_horn",
    "fiddle",
    "flute",
    "french_horn",
    "fretless_bass",
    "fx_1_rain",
    "fx_2_soundtrack",
    "fx_3_crystal",
    "fx_4_atmosphere",
    "fx_5_brightness",
    "fx_6_goblins",
    "fx_7_echoes",
    "fx_8_scifi",
    "glockenspiel",
    "guitar_fret_noise",
    "guitar_harmonics",
    "gunshot",
    "harmonica",
    "harpsichord",
    "helicopter",
    "honkytonk_piano",
    "kalimba",
    "koto",
    "lead_1_square",
    "lead_2_sawtooth",
    "lead_3_calliope",
    "lead_4_chiff",
    "lead_5_charang",
    "lead_6_voice",
    "lead_7_fifths",
    "lead_8_bass__lead",
    "marimba",
    "melodic_tom",
    "music_box",
    "muted_trumpet",
    "oboe",
    "ocarina",
    "orchestra_hit",
    "orchestral_harp",
    "overdriven_guitar",
    "pad_1_new_age",
    "pad_2_warm",
    "pad_3_polysynth",
    "pad_4_choir",
    "pad_5_bowed",
    "pad_6_metallic",
    "pad_7_halo",
    "pad_8_sweep",
    "pan_flute",
    "percussive_organ",
    "piccolo",
    "pizzicato_strings",
    "recorder",
    "reed_organ",
    "reverse_cymbal",
    "rock_organ",
    "seashore",
    "shakuhachi",
    "shamisen",
    "shanai",
    "sitar",
    "slap_bass_1",
    "slap_bass_2",
    "soprano_sax",
    "steel_drums",
    "string_ensemble_1",
    "string_ensemble_2",
    "synth_bass_1",
    "synth_bass_2",
    "synth_brass_1",
    "synth_brass_2",
    "synth_choir",
    "synth_drum",
    "synth_strings_1",
    "synth_strings_2",
    "taiko_drum",
    "tango_accordion",
    "telephone_ring",
    "tenor_sax",
    "timpani",
    "tinkle_bell",
    "tremolo_strings",
    "trombone",
    "trumpet",
    "tuba",
    "tubular_bells",
    "vibraphone",
    "viola",
    "violin",
    "voice_oohs",
    "whistle",
    "woodblock",
    "xylophone"
];
// src/soundfont/soundfont-loops.ts
function $0d19688bebdb26f8$var$getGoldstSoundfontLoopsUrl(instrument, kit) {
    if (instrument.startsWith("http")) return void 0;
    return `https://goldst.dev/midi-js-soundfonts/${kit}/${instrument}-loop.json`;
}
function $0d19688bebdb26f8$var$fetchSoundfontLoopData(url, sampleRate = 44100) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        if (!url) return void 0;
        try {
            const req = yield fetch(url);
            if (req.status !== 200) return;
            const raw = yield req.json();
            const loopData = {};
            Object.keys(raw).forEach((key)=>{
                const midi = $0d19688bebdb26f8$var$toMidi(key);
                if (midi) {
                    const offsets = raw[key];
                    loopData[midi] = [
                        offsets[0] / sampleRate,
                        offsets[1] / sampleRate
                    ];
                }
            });
            return loopData;
        } catch (err) {
            return void 0;
        }
    });
}
// src/soundfont/soundfont.ts
function $0d19688bebdb26f8$export$76130f4c04b30de6() {
    return $0d19688bebdb26f8$var$SOUNDFONT_KITS;
}
function $0d19688bebdb26f8$export$e8e6d6b2de61876d() {
    return $0d19688bebdb26f8$var$SOUNDFONT_INSTRUMENTS;
}
var $0d19688bebdb26f8$var$_hasLoops;
var $0d19688bebdb26f8$export$508265175ec7f40e = class {
    constructor(context, options){
        this.context = context;
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_hasLoops);
        this.config = $0d19688bebdb26f8$var$getSoundfontConfig(options);
        this.player = new $0d19688bebdb26f8$var$DefaultPlayer(context, options);
        this.group = $0d19688bebdb26f8$var$createEmptyRegionGroup();
        $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_hasLoops, false);
        const loader = $0d19688bebdb26f8$var$soundfontLoader(this.config.instrumentUrl, this.config.loopDataUrl, this.player.buffers, this.group);
        this.load = loader(context, this.config.storage).then((hasLoops)=>{
            $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_hasLoops, hasLoops);
            return this;
        });
        const gain = context.createGain();
        gain.gain.value = this.config.extraGain;
        this.player.output.addInsert(gain);
    }
    get output() {
        return this.player.output;
    }
    get hasLoops() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_hasLoops);
    }
    loaded() {
        return $0d19688bebdb26f8$var$__async(this, null, function*() {
            console.warn("deprecated: use load instead");
            return this.load;
        });
    }
    disconnect() {
        this.player.disconnect();
    }
    start(sample) {
        const found = $0d19688bebdb26f8$var$findFirstSampleInRegions(this.group, typeof sample === "object" ? sample : {
            note: sample
        });
        if (!found) return ()=>void 0;
        return this.player.start(found);
    }
    stop(sample) {
        return this.player.stop(sample);
    }
};
$0d19688bebdb26f8$var$_hasLoops = new WeakMap();
function $0d19688bebdb26f8$var$soundfontLoader(url, loopsUrl, buffers, group) {
    const loadInstrument = $0d19688bebdb26f8$var$soundfontInstrumentLoader(url, buffers, group);
    return (context, storage)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
            const [_, loops] = yield Promise.all([
                loadInstrument(context, storage),
                $0d19688bebdb26f8$var$fetchSoundfontLoopData(loopsUrl)
            ]);
            if (loops) group.regions.forEach((region)=>{
                var _a;
                const loop = loops[region.midiPitch];
                if (loop) {
                    (_a = region.sample) != null ? _a : region.sample = {};
                    region.sample.loop = true;
                    region.sample.loopStart = loop[0];
                    region.sample.loopEnd = loop[1];
                }
            });
            return !!loops;
        });
}
function $0d19688bebdb26f8$var$getSoundfontConfig(options) {
    var _a, _b, _c, _d;
    if (!options.instrument && !options.instrumentUrl) throw Error("Soundfont: instrument or instrumentUrl is required");
    const config = {
        kit: "MusyngKite",
        instrument: options.instrument,
        storage: (_a = options.storage) != null ? _a : $0d19688bebdb26f8$export$7fd566d5ad2998a9,
        // This is to compensate the low volume of the original samples
        extraGain: (_b = options.extraGain) != null ? _b : 5,
        loadLoopData: (_c = options.loadLoopData) != null ? _c : false,
        loopDataUrl: options.loopDataUrl,
        instrumentUrl: (_d = options.instrumentUrl) != null ? _d : ""
    };
    if (config.instrument && config.instrument.startsWith("http")) {
        console.warn("Use 'instrumentUrl' instead of 'instrument' to load from a URL");
        config.instrumentUrl = config.instrument;
        config.instrument = void 0;
    }
    if (!config.instrumentUrl) {
        if (config.instrument) config.instrumentUrl = $0d19688bebdb26f8$var$gleitzKitUrl(config.instrument, config.kit);
        else throw Error("Soundfont: 'instrument' or 'instrumentUrl' configuration parameter is required");
    } else if (config.kit || config.instrument) console.warn("Soundfont: 'kit' and 'instrument' config parameters are ignored because 'instrumentUrl' is explicitly set.");
    if (config.loadLoopData && config.instrument && !config.loopDataUrl) config.loopDataUrl = $0d19688bebdb26f8$var$getGoldstSoundfontLoopsUrl(config.instrument, config.kit);
    return config;
}
// src/soundfont2.ts
var $0d19688bebdb26f8$var$_instrumentNames;
var $0d19688bebdb26f8$export$f6af7c1c387361fb = class {
    constructor(context, options){
        this.context = context;
        this.options = options;
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_instrumentNames, []);
        this.player = new $0d19688bebdb26f8$var$RegionPlayer(context, options);
        this.load = $0d19688bebdb26f8$var$loadSoundfont(options).then((soundfont)=>{
            this.soundfont = soundfont;
            $0d19688bebdb26f8$var$__privateSet(this, $0d19688bebdb26f8$var$_instrumentNames, soundfont.instruments.map((instrument)=>instrument.header.name));
        }).then(()=>this);
    }
    get instrumentNames() {
        return $0d19688bebdb26f8$var$__privateGet(this, $0d19688bebdb26f8$var$_instrumentNames);
    }
    loadInstrument(instrumentName) {
        var _a, _b, _c;
        const sf2instrument = (_a = this.soundfont) == null ? void 0 : _a.instruments.find((inst)=>inst.header.name === instrumentName);
        if (!sf2instrument) return;
        const buffers = this.player.buffers;
        const group = {
            regions: []
        };
        for (const zone of sf2instrument.zones){
            const sample = zone.sample;
            const header = sample.header;
            const buffer = $0d19688bebdb26f8$var$getAudioBufferFromSample(this.context, sample);
            let region = {
                sampleName: sample.header.name,
                midiPitch: sample.header.originalPitch,
                midiLow: (_b = zone.keyRange) == null ? void 0 : _b.lo,
                midiHigh: (_c = zone.keyRange) == null ? void 0 : _c.hi,
                sample: {
                    loop: header.startLoop >= 0 && header.endLoop > header.startLoop,
                    loopStart: header.startLoop / header.sampleRate,
                    loopEnd: header.endLoop / header.sampleRate
                }
            };
            group.regions.push(region);
            buffers[region.sampleName] = buffer;
        }
        const instrument = {
            groups: [
                group
            ],
            options: this.options
        };
        this.player.instrument = instrument;
        return [
            instrument,
            buffers
        ];
    }
    get output() {
        return this.player.output;
    }
    start(sample) {
        return this.player.start(sample);
    }
    stop(sample) {
        return this.player.stop(sample);
    }
    disconnect() {
        this.player.disconnect();
    }
};
$0d19688bebdb26f8$var$_instrumentNames = new WeakMap();
function $0d19688bebdb26f8$var$getAudioBufferFromSample(context, sample) {
    const { header: header, data: int16 } = sample;
    const float32 = new Float32Array(int16.length);
    for(let i = 0; i < int16.length; i++)float32[i] = int16[i] / 32768;
    const audioBuffer = context.createBuffer(1, float32.length, header.sampleRate);
    const channelData = audioBuffer.getChannelData(0);
    channelData.set(float32);
    return audioBuffer;
}
function $0d19688bebdb26f8$var$loadSoundfont(options) {
    return $0d19688bebdb26f8$var$__async(this, null, function*() {
        const buffer = yield fetch(options.url).then((res)=>res.arrayBuffer());
        const data = new Uint8Array(buffer);
        return options.createSoundfont(data);
    });
}
// src/splendid-grand-piano.ts
var $0d19688bebdb26f8$var$BASE_URL2 = "https://danigb.github.io/samples/splendid-grand-piano";
var $0d19688bebdb26f8$var$_SplendidGrandPiano_instances, $0d19688bebdb26f8$var$sampleToMidi_fn;
var $0d19688bebdb26f8$export$589c152416f2342b = class {
    constructor(context, options){
        this.context = context;
        $0d19688bebdb26f8$var$__privateAdd(this, $0d19688bebdb26f8$var$_SplendidGrandPiano_instances);
        this.options = Object.assign({
            baseUrl: $0d19688bebdb26f8$var$BASE_URL2,
            storage: $0d19688bebdb26f8$export$7fd566d5ad2998a9,
            detune: 0,
            volume: 100,
            velocity: 100,
            decayTime: 0.5
        }, options);
        this.player = new $0d19688bebdb26f8$var$DefaultPlayer(context, this.options);
        const loader = $0d19688bebdb26f8$var$splendidGrandPianoLoader(this.options.baseUrl, this.options.storage, this.options.notesToLoad);
        this.load = loader(context, this.player.buffers).then(()=>this);
    }
    get output() {
        return this.player.output;
    }
    get buffers() {
        return this.player.buffers;
    }
    loaded() {
        return $0d19688bebdb26f8$var$__async(this, null, function*() {
            console.warn("deprecated: use load instead");
            return this.load;
        });
    }
    start(sampleOrNote) {
        var _a, _b;
        const sample = typeof sampleOrNote === "object" ? $0d19688bebdb26f8$var$__spreadValues({}, sampleOrNote) : {
            note: sampleOrNote
        };
        const found = $0d19688bebdb26f8$var$__privateMethod(this, $0d19688bebdb26f8$var$_SplendidGrandPiano_instances, $0d19688bebdb26f8$var$sampleToMidi_fn).call(this, sample);
        if (!found) return ()=>void 0;
        sample.note = found[0];
        sample.stopId = (_a = sample.stopId) != null ? _a : found[1];
        sample.detune = found[2] + ((_b = sample.detune) != null ? _b : this.options.detune);
        return this.player.start(sample);
    }
    stop(sample) {
        var _a;
        if (typeof sample === "string") return this.player.stop((_a = $0d19688bebdb26f8$var$toMidi(sample)) != null ? _a : sample);
        else if (typeof sample === "object") {
            const midi = $0d19688bebdb26f8$var$toMidi(sample.stopId);
            return this.player.stop(midi !== void 0 ? $0d19688bebdb26f8$var$__spreadProps($0d19688bebdb26f8$var$__spreadValues({}, sample), {
                stopId: midi
            }) : sample);
        } else return this.player.stop(sample);
    }
};
$0d19688bebdb26f8$var$_SplendidGrandPiano_instances = new WeakSet();
$0d19688bebdb26f8$var$sampleToMidi_fn = function(sample) {
    var _a;
    const midi = $0d19688bebdb26f8$var$toMidi(sample.note);
    if (!midi) return;
    const vel = (_a = sample.velocity) != null ? _a : this.options.velocity;
    const layerIdx = $0d19688bebdb26f8$export$fdca3ba65b5cceec.findIndex((layer2)=>vel >= layer2.vel_range[0] && vel <= layer2.vel_range[1]);
    const layer = $0d19688bebdb26f8$export$fdca3ba65b5cceec[layerIdx];
    if (!layer) return;
    return $0d19688bebdb26f8$var$findNearestMidiInLayer(layer.name, midi, this.player.buffers);
};
function $0d19688bebdb26f8$var$findNearestMidiInLayer(prefix, midi, buffers) {
    let i = 0;
    while(buffers[prefix + (midi + i)] === void 0 && i < 128)if (i > 0) i = -i;
    else i = -i + 1;
    return i === 127 ? [
        prefix + midi,
        midi,
        0
    ] : [
        prefix + (midi + i),
        midi,
        -i * 100
    ];
}
function $0d19688bebdb26f8$var$splendidGrandPianoLoader(baseUrl, storage, notesToLoad) {
    var _a;
    const format = (_a = $0d19688bebdb26f8$var$findFirstSupportedFormat([
        "ogg",
        "m4a"
    ])) != null ? _a : "ogg";
    let layers = notesToLoad ? $0d19688bebdb26f8$export$fdca3ba65b5cceec.filter((layer)=>layer.vel_range[0] <= notesToLoad.velocityRange[1] && layer.vel_range[1] >= notesToLoad.velocityRange[0]) : $0d19688bebdb26f8$export$fdca3ba65b5cceec;
    return (context, buffers)=>$0d19688bebdb26f8$var$__async(this, null, function*() {
            for (const layer of layers){
                const samples = notesToLoad ? layer.samples.filter((sample)=>notesToLoad.notes.includes(sample[0])) : layer.samples;
                yield Promise.all(samples.map((_0)=>$0d19688bebdb26f8$var$__async(this, [
                        _0
                    ], function*([midi, name]) {
                        const url = `${baseUrl}/${name}.${format}`;
                        const buffer = yield $0d19688bebdb26f8$var$loadAudioBuffer(context, url, storage);
                        if (buffer) buffers[layer.name + midi] = buffer;
                    })));
            }
        });
}
var $0d19688bebdb26f8$export$fdca3ba65b5cceec = [
    {
        name: "PPP",
        vel_range: [
            1,
            40
        ],
        cutoff: 1e3,
        samples: [
            [
                23,
                "PP-B-1"
            ],
            [
                27,
                "PP-D#0"
            ],
            [
                29,
                "PP-F0"
            ],
            [
                31,
                "PP-G0"
            ],
            [
                33,
                "PP-A0"
            ],
            [
                35,
                "PP-B0"
            ],
            [
                37,
                "PP-C#1"
            ],
            [
                38,
                "PP-D1"
            ],
            [
                40,
                "PP-E1"
            ],
            [
                41,
                "PP-F1"
            ],
            [
                43,
                "PP-G1"
            ],
            [
                45,
                "PP-A1"
            ],
            [
                47,
                "PP-B1"
            ],
            [
                48,
                "PP-C2"
            ],
            [
                50,
                "PP-D2"
            ],
            [
                52,
                "PP-E2"
            ],
            [
                53,
                "PP-F2"
            ],
            [
                55,
                "PP-G2"
            ],
            [
                56,
                "PP-G#2"
            ],
            [
                57,
                "PP-A2"
            ],
            [
                58,
                "PP-A#2"
            ],
            [
                59,
                "PP-B2"
            ],
            [
                60,
                "PP-C3"
            ],
            [
                62,
                "PP-D3"
            ],
            [
                64,
                "PP-E3"
            ],
            [
                65,
                "PP-F3"
            ],
            [
                67,
                "PP-G3"
            ],
            [
                69,
                "PP-A3"
            ],
            [
                71,
                "PP-B3"
            ],
            [
                72,
                "PP-C4"
            ],
            [
                74,
                "PP-D4"
            ],
            [
                76,
                "PP-E4"
            ],
            [
                77,
                "PP-F4"
            ],
            [
                79,
                "PP-G4"
            ],
            [
                80,
                "PP-G#4"
            ],
            [
                81,
                "PP-A4"
            ],
            [
                82,
                "PP-A#4"
            ],
            [
                83,
                "PP-B4"
            ],
            [
                85,
                "PP-C#5"
            ],
            [
                86,
                "PP-D5"
            ],
            [
                87,
                "PP-D#5"
            ],
            [
                89,
                "PP-F5"
            ],
            [
                90,
                "PP-F#5"
            ],
            [
                91,
                "PP-G5"
            ],
            [
                92,
                "PP-G#5"
            ],
            [
                93,
                "PP-A5"
            ],
            [
                94,
                "PP-A#5"
            ],
            [
                95,
                "PP-B5"
            ],
            [
                96,
                "PP-C6"
            ],
            [
                97,
                "PP-C#6"
            ],
            [
                98,
                "PP-D6"
            ],
            [
                99,
                "PP-D#6"
            ],
            [
                100,
                "PP-E6"
            ],
            [
                101,
                "PP-F6"
            ],
            [
                102,
                "PP-F#6"
            ],
            [
                103,
                "PP-G6"
            ],
            [
                104,
                "PP-G#6"
            ],
            [
                105,
                "PP-A6"
            ],
            [
                106,
                "PP-A#6"
            ],
            [
                107,
                "PP-B6"
            ],
            [
                108,
                "PP-C7"
            ]
        ]
    },
    {
        name: "PP",
        vel_range: [
            41,
            67
        ],
        samples: [
            [
                23,
                "PP-B-1"
            ],
            [
                27,
                "PP-D#0"
            ],
            [
                29,
                "PP-F0"
            ],
            [
                31,
                "PP-G0"
            ],
            [
                33,
                "PP-A0"
            ],
            [
                35,
                "PP-B0"
            ],
            [
                37,
                "PP-C#1"
            ],
            [
                38,
                "PP-D1"
            ],
            [
                40,
                "PP-E1"
            ],
            [
                41,
                "PP-F1"
            ],
            [
                43,
                "PP-G1"
            ],
            [
                45,
                "PP-A1"
            ],
            [
                47,
                "PP-B1"
            ],
            [
                48,
                "PP-C2"
            ],
            [
                50,
                "PP-D2"
            ],
            [
                52,
                "PP-E2"
            ],
            [
                53,
                "PP-F2"
            ],
            [
                55,
                "PP-G2"
            ],
            [
                56,
                "PP-G#2"
            ],
            [
                57,
                "PP-A2"
            ],
            [
                58,
                "PP-A#2"
            ],
            [
                59,
                "PP-B2"
            ],
            [
                60,
                "PP-C3"
            ],
            [
                62,
                "PP-D3"
            ],
            [
                64,
                "PP-E3"
            ],
            [
                65,
                "PP-F3"
            ],
            [
                67,
                "PP-G3"
            ],
            [
                69,
                "PP-A3"
            ],
            [
                71,
                "PP-B3"
            ],
            [
                72,
                "PP-C4"
            ],
            [
                74,
                "PP-D4"
            ],
            [
                76,
                "PP-E4"
            ],
            [
                77,
                "PP-F4"
            ],
            [
                79,
                "PP-G4"
            ],
            [
                80,
                "PP-G#4"
            ],
            [
                81,
                "PP-A4"
            ],
            [
                82,
                "PP-A#4"
            ],
            [
                83,
                "PP-B4"
            ],
            [
                85,
                "PP-C#5"
            ],
            [
                86,
                "PP-D5"
            ],
            [
                87,
                "PP-D#5"
            ],
            [
                89,
                "PP-F5"
            ],
            [
                90,
                "PP-F#5"
            ],
            [
                91,
                "PP-G5"
            ],
            [
                92,
                "PP-G#5"
            ],
            [
                93,
                "PP-A5"
            ],
            [
                94,
                "PP-A#5"
            ],
            [
                95,
                "PP-B5"
            ],
            [
                96,
                "PP-C6"
            ],
            [
                97,
                "PP-C#6"
            ],
            [
                98,
                "PP-D6"
            ],
            [
                99,
                "PP-D#6"
            ],
            [
                100,
                "PP-E6"
            ],
            [
                101,
                "PP-F6"
            ],
            [
                102,
                "PP-F#6"
            ],
            [
                103,
                "PP-G6"
            ],
            [
                104,
                "PP-G#6"
            ],
            [
                105,
                "PP-A6"
            ],
            [
                106,
                "PP-A#6"
            ],
            [
                107,
                "PP-B6"
            ],
            [
                108,
                "PP-C7"
            ]
        ]
    },
    {
        name: "MP",
        vel_range: [
            68,
            84
        ],
        samples: [
            [
                23,
                "Mp-B-1"
            ],
            [
                27,
                "Mp-D#0"
            ],
            [
                29,
                "Mp-F0"
            ],
            [
                31,
                "Mp-G0"
            ],
            [
                33,
                "Mp-A0"
            ],
            [
                35,
                "Mp-B0"
            ],
            [
                37,
                "Mp-C#1"
            ],
            [
                38,
                "Mp-D1"
            ],
            [
                40,
                "Mp-E1"
            ],
            [
                41,
                "Mp-F1"
            ],
            [
                43,
                "Mp-G1"
            ],
            [
                45,
                "Mp-A1"
            ],
            [
                47,
                "Mp-B1"
            ],
            [
                48,
                "Mp-C2"
            ],
            [
                50,
                "Mp-D2"
            ],
            [
                52,
                "Mp-E2"
            ],
            [
                53,
                "Mp-F2"
            ],
            [
                55,
                "Mp-G2"
            ],
            [
                56,
                "Mp-G#2"
            ],
            [
                57,
                "Mp-A2"
            ],
            [
                58,
                "Mp-A#2"
            ],
            [
                59,
                "Mp-B2"
            ],
            [
                60,
                "Mp-C3"
            ],
            [
                62,
                "Mp-D3"
            ],
            [
                64,
                "Mp-E3"
            ],
            [
                65,
                "Mp-F3"
            ],
            [
                67,
                "Mp-G3"
            ],
            [
                69,
                "Mp-A3"
            ],
            [
                71,
                "Mp-B3"
            ],
            [
                72,
                "Mp-C4"
            ],
            [
                74,
                "Mp-D4"
            ],
            [
                76,
                "Mp-E4"
            ],
            [
                77,
                "Mp-F4"
            ],
            [
                79,
                "Mp-G4"
            ],
            [
                80,
                "Mp-G#4"
            ],
            [
                81,
                "Mp-A4"
            ],
            [
                82,
                "Mp-A#4"
            ],
            [
                83,
                "Mp-B4"
            ],
            [
                85,
                "Mp-C#5"
            ],
            [
                86,
                "Mp-D5"
            ],
            [
                87,
                "Mp-D#5"
            ],
            [
                88,
                "Mp-E5"
            ],
            [
                89,
                "Mp-F5"
            ],
            [
                90,
                "Mp-F#5"
            ],
            [
                91,
                "Mp-G5"
            ],
            [
                92,
                "Mp-G#5"
            ],
            [
                93,
                "Mp-A5"
            ],
            [
                94,
                "Mp-A#5"
            ],
            [
                95,
                "Mp-B5"
            ],
            [
                96,
                "Mp-C6"
            ],
            [
                97,
                "Mp-C#6"
            ],
            [
                98,
                "Mp-D6"
            ],
            [
                99,
                "Mp-D#6"
            ],
            [
                100,
                "PP-E6"
            ],
            [
                101,
                "Mp-F6"
            ],
            [
                102,
                "Mp-F#6"
            ],
            [
                103,
                "Mp-G6"
            ],
            [
                104,
                "Mp-G#6"
            ],
            [
                105,
                "Mp-A6"
            ],
            [
                106,
                "Mp-A#6"
            ],
            [
                107,
                "PP-B6"
            ],
            [
                108,
                "PP-C7"
            ]
        ]
    },
    {
        name: "MF",
        vel_range: [
            85,
            100
        ],
        samples: [
            [
                23,
                "Mf-B-1"
            ],
            [
                27,
                "Mf-D#0"
            ],
            [
                29,
                "Mf-F0"
            ],
            [
                31,
                "Mf-G0"
            ],
            [
                33,
                "Mf-A0"
            ],
            [
                35,
                "Mf-B0"
            ],
            [
                37,
                "Mf-C#1"
            ],
            [
                38,
                "Mf-D1"
            ],
            [
                40,
                "Mf-E1"
            ],
            [
                41,
                "Mf-F1"
            ],
            [
                43,
                "Mf-G1"
            ],
            [
                45,
                "Mf-A1"
            ],
            [
                47,
                "Mf-B1"
            ],
            [
                48,
                "Mf-C2"
            ],
            [
                50,
                "Mf-D2"
            ],
            [
                52,
                "Mf-E2"
            ],
            [
                53,
                "Mf-F2"
            ],
            [
                55,
                "Mf-G2"
            ],
            [
                56,
                "Mf-G#2"
            ],
            [
                57,
                "Mf-A2"
            ],
            [
                58,
                "Mf-A#2"
            ],
            [
                59,
                "Mf-B2"
            ],
            [
                60,
                "Mf-C3"
            ],
            [
                62,
                "Mf-D3"
            ],
            [
                64,
                "Mf-E3"
            ],
            [
                65,
                "Mf-F3"
            ],
            [
                67,
                "Mf-G3"
            ],
            [
                69,
                "Mf-A3"
            ],
            [
                71,
                "Mf-B3"
            ],
            [
                72,
                "Mf-C4"
            ],
            [
                74,
                "Mf-D4"
            ],
            [
                76,
                "Mf-E4"
            ],
            [
                77,
                "Mf-F4"
            ],
            [
                79,
                "Mf-G4"
            ],
            [
                80,
                "Mf-G#4"
            ],
            [
                81,
                "Mf-A4"
            ],
            [
                82,
                "Mf-A#4"
            ],
            [
                83,
                "Mf-B4"
            ],
            [
                85,
                "Mf-C#5"
            ],
            [
                86,
                "Mf-D5"
            ],
            [
                87,
                "Mf-D#5"
            ],
            [
                88,
                "Mf-E5"
            ],
            [
                89,
                "Mf-F5"
            ],
            [
                90,
                "Mf-F#5"
            ],
            [
                91,
                "Mf-G5"
            ],
            [
                92,
                "Mf-G#5"
            ],
            [
                93,
                "Mf-A5"
            ],
            [
                94,
                "Mf-A#5"
            ],
            [
                95,
                "Mf-B5"
            ],
            [
                96,
                "Mf-C6"
            ],
            [
                97,
                "Mf-C#6"
            ],
            [
                98,
                "Mf-D6"
            ],
            [
                99,
                "Mf-D#6"
            ],
            [
                100,
                "Mf-E6"
            ],
            [
                101,
                "Mf-F6"
            ],
            [
                102,
                "Mf-F#6"
            ],
            [
                103,
                "Mf-G6"
            ],
            [
                104,
                "Mf-G#6"
            ],
            [
                105,
                "Mf-A6"
            ],
            [
                106,
                "Mf-A#6"
            ],
            [
                107,
                "Mf-B6"
            ],
            [
                108,
                "PP-C7"
            ]
        ]
    },
    {
        name: "FF",
        vel_range: [
            101,
            127
        ],
        samples: [
            [
                23,
                "FF-B-1"
            ],
            [
                27,
                "FF-D#0"
            ],
            [
                29,
                "FF-F0"
            ],
            [
                31,
                "FF-G0"
            ],
            [
                33,
                "FF-A0"
            ],
            [
                35,
                "FF-B0"
            ],
            [
                37,
                "FF-C#1"
            ],
            [
                38,
                "FF-D1"
            ],
            [
                40,
                "FF-E1"
            ],
            [
                41,
                "FF-F1"
            ],
            [
                43,
                "FF-G1"
            ],
            [
                45,
                "FF-A1"
            ],
            [
                47,
                "FF-B1"
            ],
            [
                48,
                "FF-C2"
            ],
            [
                50,
                "FF-D2"
            ],
            [
                52,
                "FF-E2"
            ],
            [
                53,
                "FF-F2"
            ],
            [
                55,
                "FF-G2"
            ],
            [
                56,
                "FF-G#2"
            ],
            [
                57,
                "FF-A2"
            ],
            [
                58,
                "FF-A#2"
            ],
            [
                59,
                "FF-B2"
            ],
            [
                60,
                "FF-C3"
            ],
            [
                62,
                "FF-D3"
            ],
            [
                64,
                "FF-E3"
            ],
            [
                65,
                "FF-F3"
            ],
            [
                67,
                "FF-G3"
            ],
            [
                69,
                "FF-A3"
            ],
            [
                71,
                "FF-B3"
            ],
            [
                72,
                "FF-C4"
            ],
            [
                74,
                "FF-D4"
            ],
            [
                76,
                "FF-E4"
            ],
            [
                77,
                "FF-F4"
            ],
            [
                79,
                "FF-G4"
            ],
            [
                80,
                "FF-G#4"
            ],
            [
                81,
                "FF-A4"
            ],
            [
                82,
                "FF-A#4"
            ],
            [
                83,
                "FF-B4"
            ],
            [
                85,
                "FF-C#5"
            ],
            [
                86,
                "FF-D5"
            ],
            [
                88,
                "FF-E5"
            ],
            [
                89,
                "FF-F5"
            ],
            [
                91,
                "FF-G5"
            ],
            [
                93,
                "FF-A5"
            ],
            [
                95,
                "Mf-B5"
            ],
            [
                96,
                "Mf-C6"
            ],
            [
                97,
                "Mf-C#6"
            ],
            [
                98,
                "Mf-D6"
            ],
            [
                99,
                "Mf-D#6"
            ],
            [
                100,
                "Mf-E6"
            ],
            [
                102,
                "Mf-F#6"
            ],
            [
                103,
                "Mf-G6"
            ],
            [
                104,
                "Mf-G#6"
            ],
            [
                105,
                "Mf-A6"
            ],
            [
                106,
                "Mf-A#6"
            ],
            [
                107,
                "Mf-B6"
            ],
            [
                108,
                "Mf-C7"
            ]
        ]
    }
];




const $99492fb2897c9321$var$w = window;
var $99492fb2897c9321$var$AudioContext = $99492fb2897c9321$var$w.AudioContext || // Default
$99492fb2897c9321$var$w.webkitAudioContext; // Safari and old versions of Chrome
const $99492fb2897c9321$var$NOTE_LENGTH = 0.5;
let $99492fb2897c9321$var$playingId = 0;
const $99492fb2897c9321$var$playTone = (ac, clef, clefOffset, score, onFinished, onSetHighlightCount, transposedBy, playingIdRef)=>{
    const offset = clef === "c" ? 9 - clefOffset : 5 - clefOffset;
    $99492fb2897c9321$var$playingId++;
    const thisPlayingId = $99492fb2897c9321$var$playingId;
    let t = 0.5;
    const flute = new (0, $0d19688bebdb26f8$export$508265175ec7f40e)(new $99492fb2897c9321$var$AudioContext(), {
        instrument: "flute"
    });
    let highlightCount = 0;
    const addHighlight = (noteIndex)=>{
        setTimeout(()=>{
            if ((playingIdRef.current ?? 9999) <= thisPlayingId) {
                highlightCount++;
                onSetHighlightCount(highlightCount);
            } else onSetHighlightCount(0);
        }, t * 1000);
    };
    const scheduleNote = (note, scheduleTime, long)=>{
        setTimeout(()=>{
            if ((playingIdRef.current ?? 9999) <= thisPlayingId) {
                console.log((0, $02b52bdf6f82c33e$export$94966884eea635c4)(note, transposedBy), ac.currentTime, {
                    duration: long ? $99492fb2897c9321$var$NOTE_LENGTH * 2.1 : $99492fb2897c9321$var$NOTE_LENGTH * 1.1
                });
                flute.start({
                    note: (0, $02b52bdf6f82c33e$export$94966884eea635c4)(note, transposedBy),
                    duration: long ? $99492fb2897c9321$var$NOTE_LENGTH * 2.1 : $99492fb2897c9321$var$NOTE_LENGTH * 1.1
                });
            } else onFinished();
        }, scheduleTime * 1000);
    };
    score.forEach((note, noteIndex)=>{
        if (note === "6b" || note === "4b") {
            scheduleNote("Bb3", t, false);
            addHighlight(noteIndex);
            t += $99492fb2897c9321$var$NOTE_LENGTH;
        } else if (note === ",") t += $99492fb2897c9321$var$NOTE_LENGTH;
        else if (note.length === 2 && note.charAt(1) === ".") {
            const noteOffset = parseInt(note.charAt(0));
            scheduleNote((0, $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d)[offset + noteOffset], t, true);
            addHighlight(noteIndex);
            t += $99492fb2897c9321$var$NOTE_LENGTH * 2;
        } else {
            const noteOffset = parseInt(note);
            scheduleNote((0, $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d)[offset + noteOffset], t, false);
            addHighlight(noteIndex);
            t += $99492fb2897c9321$var$NOTE_LENGTH;
        }
    });
    setTimeout(()=>{
        if ((playingIdRef.current ?? 9999) <= thisPlayingId) {
            onFinished();
            onSetHighlightCount(0);
        }
    }, t * 1000);
    return $99492fb2897c9321$var$playingId;
};
const $99492fb2897c9321$export$fbed5f62d839a0cd = (props)=>{
    const { clef: clef, score: score, title: title, transposeBy: transposeBy, onSetHighlightCount: onSetHighlightCount } = props;
    const [playing, setPlaying] = (0, $acw62.useState)(false);
    const playingIdRef = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{}, []);
    const play = (0, $acw62.useCallback)(()=>{
        setPlaying(true);
        const ac = new $99492fb2897c9321$var$AudioContext();
        // create empty buffer
        var buffer = ac.createBuffer(1, 1, 22050);
        var source = ac.createBufferSource();
        source.buffer = buffer;
        // connect to output (your speakers)
        source.connect(ac.destination);
        // play the file
        source.start(0);
        playingIdRef.current = $99492fb2897c9321$var$playTone(ac, clef === "f5" ? "f" : "c", clef === "c7" ? 7 : 5, score, ()=>{
            setPlaying(false);
        }, onSetHighlightCount ?? ((count)=>undefined), transposeBy, playingIdRef);
    }, [
        clef,
        score,
        transposeBy,
        onSetHighlightCount
    ]);
    const stop = (0, $acw62.useCallback)(()=>{
        playingIdRef.current++;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingLeft: 4
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: playing ? "new-button-playing" : "new-button",
            onClick: playing ? stop : play,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "play-icon",
                    children: "\u25BA"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: title
                })
            ]
        })
    });
};




parcelRequire("acw62");



const $8094b590f6f28f06$export$f68cd553b87bbab1 = (props)=>{
    const { toneId: toneId, highlightCount: highlightCount } = props;
    const tone = (0, $c07cc9090462c085$export$af3a35665fe7186d)(toneId);
    if (!tone) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    const processNotes = (notes)=>{
        return notes.filter((noteString)=>!noteString.includes("?")).map((noteString)=>{
            return {
                syllables: [
                    {
                        text: "    ",
                        notes: (0, $8da148c2c45b952c$export$15512d11fbbb20af)(noteString.replace("~", "")),
                        long: noteString.replace(/[\?\~]/, "").includes("."),
                        dotBefore: false
                    }
                ]
            };
        });
    };
    const secondReciting = [
        {
            syllables: [
                {
                    text: "        ",
                    notes: [
                        `${tone.secondRecitingNote ?? tone.recitingNote}`
                    ],
                    long: false,
                    dotBefore: false,
                    reciting: true
                }
            ]
        }
    ];
    let secondHalf = secondReciting;
    secondReciting.push(...processNotes(tone.endingOptions?.[0] ?? tone.ending));
    const pointedText = {
        clef: tone.clef,
        verses: [
            {
                firstHalf: processNotes(tone.intonation).concat([
                    {
                        syllables: [
                            {
                                text: "        ",
                                notes: [
                                    `${tone.recitingNote}`
                                ],
                                long: false,
                                dotBefore: false,
                                reciting: true
                            }
                        ]
                    }
                ]).concat(processNotes(tone.mediant)),
                secondHalf: secondHalf
            }
        ]
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tone-diagram",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
            pointedText: pointedText,
            boldMode: "all",
            dropCap: false,
            highlightCount: highlightCount,
            noPadding: true,
            tone: toneId
        })
    });
};


const $d785bb9b161f2130$var$getScoreFromTone = (tone, intonationType, mediantType, endType)=>{
    const score = [];
    let offset = 0;
    const processSyllable = (syllable, include)=>{
        let notesInSyllable = 0;
        Array.from(syllable).forEach((char)=>{
            if (char === "/" || char === "~") ;
            else if (char === "?") {
                if (include) score.pop();
                else offset -= 1;
            } else if (char === ".") {
                if (include) {
                    if (notesInSyllable === 2) {
                        score[score.length - 1] += ".";
                        score[score.length - 2] += ".";
                    } else score[score.length - 1] += ".";
                }
            } else if (char === "b") {
                if (include) score[score.length - 1] += "b";
            } else {
                notesInSyllable++;
                if (include) score.push(char);
                else offset++;
            }
        });
    };
    if (intonationType !== "skip") tone.intonation.forEach((syllable)=>{
        processSyllable(syllable, intonationType === "include");
    });
    if (mediantType !== "skip") {
        if (mediantType === "include") score.push(`${tone.recitingNote}.`);
        tone.mediant.forEach((syllable)=>{
            processSyllable(syllable, mediantType === "include");
        });
    }
    if (mediantType === "include" && endType === "include") score.push(",");
    else if (mediantType === "offset" && endType === "include") offset++;
    if (endType !== "skip") {
        if (endType === "include") score.push(`${tone.secondRecitingNote ?? tone.recitingNote}.`);
        tone.ending.forEach((syllable)=>{
            processSyllable(syllable, endType === "include");
        });
    }
    return {
        score: score,
        offset: offset
    };
};
const $d785bb9b161f2130$var$getStartFromTone = (tone)=>{
    const score = [];
    const processSyllable = (syllable)=>{
        let notesInSyllable = 0;
        Array.from(syllable).forEach((char)=>{
            if (char === "/" || char === "~") ;
            else if (char === "?") score.pop();
            else if (char === ".") {
                if (notesInSyllable === 2) {
                    score[score.length - 1] += ".";
                    score[score.length - 2] += ".";
                } else score[score.length - 1] += ".";
            } else if (char === "b") score[score.length - 1] += "b";
            else {
                notesInSyllable++;
                score.push(char);
            }
        });
    };
    tone.intonation.forEach((syllable)=>{
        processSyllable(syllable);
    });
    score[score.length - 1] += ".";
    if (score[0] !== score[score.length - 1]) score.push(score[0] + ".");
    return score;
};
const $d785bb9b161f2130$export$1bd89bc972623ab2 = (tone, isSmallScreen)=>{
    if (isSmallScreen) return tone.includes("Tonus") ? tone.replace("Tonus Peregrinus", "T.P.") : `Tone ${tone}`;
    else return tone.includes("Tonus") ? tone : `Tone ${tone}`;
};
const $d785bb9b161f2130$export$397fd5de0a6e6acd = (props)=>{
    const { tones: tones, selectedTone: selectedTone, id: id, onSetModal: onSetModal, onSetSelectedTone: onSetSelectedTone } = props;
    const isOrdinariatePage = window.location.href.includes("/se/");
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    const title = isOrdinariatePage ? `Tone ${(0, $c07cc9090462c085$export$df12744c9c7cdebd)[selectedTone].liber}` : $d785bb9b161f2130$export$1bd89bc972623ab2(selectedTone, isSmallScreen);
    const fullTone = (0, $c07cc9090462c085$export$af3a35665fe7186d)(selectedTone);
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const transposeByKey = "1";
    const transposeBy = settings.transpositions["1"] + (0, $02b52bdf6f82c33e$export$17267529e6476353)("1");
    const increaseTransposeBy = (0, $acw62.useCallback)(()=>{
        setSetting("transpositions", {
            ...settings.transpositions,
            ["1"]: transposeBy + 1
        });
    }, [
        settings,
        transposeBy
    ]);
    const decreaseTransposeBy = (0, $acw62.useCallback)(()=>{
        setSetting("transpositions", {
            ...settings.transpositions,
            ["1"]: transposeBy - 1
        });
    }, [
        settings,
        transposeBy
    ]);
    const [highlightCount, setHighlightCount] = (0, $acw62.useState)(0);
    const { popoverId: popoverId, setPopoverId: setPopoverId } = (0, $cd93687958c8007e$export$542a6fd13ac93354)();
    (0, $acw62.useEffect)(()=>{
        const medScore = $d785bb9b161f2130$var$getScoreFromTone(fullTone, "offset", "include", "skip");
        const endScore = $d785bb9b161f2130$var$getScoreFromTone(fullTone, "offset", "offset", "include");
        const fullScore = $d785bb9b161f2130$var$getScoreFromTone(fullTone, "include", "include", "include");
        const modal = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                zIndex: 100000
            },
            className: "modal",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flexGrow: 1,
                    maxWidth: (0, $b5d1360628cd70a0$export$397f5285b920487e),
                    boxSizing: "border-box",
                    display: popoverId === `tone-${id}` ? "block" : "none",
                    padding: isSmallScreen ? 4 : 16,
                    paddingBottom: isSmallScreen ? 0 : 16
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        backgroundColor: "white",
                        border: `1px solid ${(0, $b5d1360628cd70a0$export$516f68680b50dca1)}`,
                        borderRadius: 8,
                        borderBottomLeftRadius: isSmallScreen ? 0 : 8,
                        borderBottomRightRadius: isSmallScreen ? 0 : 8,
                        borderBottom: isSmallScreen ? "none" : `1px solid ${0, $b5d1360628cd70a0$export$516f68680b50dca1}`,
                        boxShadow: `0 0 12px rgba(0, 0, 0, 0.4)`,
                        flexGrow: 1,
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                padding: 4,
                                paddingLeft: 12,
                                paddingRight: 4,
                                borderBottom: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`,
                                backgroundColor: (0, $b5d1360628cd70a0$export$ee522376d3ee75f2)
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        flexGrow: 1
                                    }
                                }),
                                tones.length > 1 ? tones.filter((tone)=>tone !== selectedTone).map((tone)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {},
                                        children: [
                                            "Alternatively:",
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                style: {
                                                    fontWeight: "bold",
                                                    cursor: "pointer",
                                                    textDecoration: "underline"
                                                },
                                                onClick: ()=>{
                                                    if (onSetSelectedTone) onSetSelectedTone(tone);
                                                },
                                                children: $d785bb9b161f2130$export$1bd89bc972623ab2(tone, isSmallScreen)
                                            })
                                        ]
                                    });
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        flexGrow: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "checkbox",
                                            id: "show-pitch",
                                            name: "show-pitch",
                                            checked: settings.tuning === "enabled",
                                            style: {
                                                paddingTop: 2
                                            },
                                            onChange: ()=>{
                                                console.log("hi");
                                                if (settings.tuning === "enabled") setSetting("tuning", "disabled");
                                                else setSetting("tuning", "enabled");
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "show-pitch",
                                            style: {
                                                paddingLeft: 4
                                            },
                                            children: "Show pitch"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        flexGrow: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "new-button",
                                    onClick: ()=>setPopoverId(undefined),
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                paddingTop: 24,
                                paddingLeft: isSmallScreen ? 8 : 24
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8094b590f6f28f06$export$f68cd553b87bbab1), {
                                toneId: selectedTone,
                                highlightCount: highlightCount
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: isSmallScreen ? {
                                borderTop: `1px solid ${0, $b5d1360628cd70a0$export$6a1034a6524f1861}`,
                                display: "flex",
                                flexDirection: "column-reverse",
                                alignItems: "center",
                                backgroundColor: (0, $b5d1360628cd70a0$export$ee522376d3ee75f2)
                            } : {
                                borderTop: `1px solid ${0, $b5d1360628cd70a0$export$6a1034a6524f1861}`,
                                display: "flex",
                                flexDirection: "row",
                                backgroundColor: (0, $b5d1360628cd70a0$export$ee522376d3ee75f2)
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        padding: 8,
                                        paddingBottom: 4,
                                        flexGrow: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                width: 80
                                            },
                                            children: [
                                                "Pitch:",
                                                " ",
                                                transposeBy >= 0 ? `+${transposeBy}` : `${transposeBy}`
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "new-button",
                                            onClick: decreaseTransposeBy,
                                            children: "\u2193 Lower"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                paddingLeft: 4
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "new-button",
                                                onClick: increaseTransposeBy,
                                                children: "\u2191 Higher"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: 4,
                                        paddingLeft: 12,
                                        paddingRight: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99492fb2897c9321$export$fbed5f62d839a0cd), {
                                            clef: fullTone.clef,
                                            score: medScore.score,
                                            title: "Play Med",
                                            transposeBy: transposeBy + (0, $02b52bdf6f82c33e$export$c6bb8e99f71a0bee)((0, $c07cc9090462c085$export$df12744c9c7cdebd)[selectedTone]),
                                            onSetHighlightCount: (count)=>setHighlightCount(count === 0 ? 0 : medScore.offset + count)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99492fb2897c9321$export$fbed5f62d839a0cd), {
                                            clef: fullTone.clef,
                                            score: endScore.score,
                                            title: "Play End",
                                            transposeBy: transposeBy + (0, $02b52bdf6f82c33e$export$c6bb8e99f71a0bee)((0, $c07cc9090462c085$export$df12744c9c7cdebd)[selectedTone]),
                                            onSetHighlightCount: (count)=>setHighlightCount(count === 0 ? 0 : endScore.offset + count)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99492fb2897c9321$export$fbed5f62d839a0cd), {
                                            clef: fullTone.clef,
                                            score: fullScore.score,
                                            title: "Play Full",
                                            transposeBy: transposeBy + (0, $02b52bdf6f82c33e$export$c6bb8e99f71a0bee)((0, $c07cc9090462c085$export$df12744c9c7cdebd)[selectedTone]),
                                            onSetHighlightCount: setHighlightCount
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: 8,
                                paddingBottom: 20,
                                backgroundColor: (0, $b5d1360628cd70a0$export$ee522376d3ee75f2)
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontStyle: "italic"
                                },
                                children: "Don't forget to turn your sound on!"
                            })
                        })
                    ]
                })
            })
        });
        onSetModal(`tone-${id}`, modal);
    }, [
        popoverId,
        highlightCount,
        transposeBy,
        selectedTone,
        settings.tuning
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99492fb2897c9321$export$fbed5f62d839a0cd), {
                    clef: fullTone.clef,
                    score: $d785bb9b161f2130$var$getStartFromTone(fullTone),
                    title: "Intone",
                    transposeBy: transposeBy + (0, $02b52bdf6f82c33e$export$c6bb8e99f71a0bee)((0, $c07cc9090462c085$export$df12744c9c7cdebd)[selectedTone])
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        paddingLeft: 4
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "new-button",
                        onClick: ()=>setPopoverId(`tone-${id}`),
                        style: {
                            opacity: popoverId === `tone-${id}` ? 0.5 : 1
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: "More..."
                        })
                    })
                })
            ]
        })
    });
};



const $6aa1945ec54bb8d7$export$6772ff6b75684fb1 = {
    advent: [
        "Our King and /Sav_iour /draw_eth /nigh;",
        "O come, let /us a_/dore him"
    ],
    christmas: [
        "Al_le_lu_ia. Un_to /us a /child is /born;",
        "O come, let /us a_/dore him. /Al_le_/lu_ia."
    ],
    epiphany: [
        "The Lord hath ma_ni_fes_ted /forth his /glo_ry;",
        "O come, let /us a_/dore him."
    ],
    lent: [
        "The Lord is full of com_/pass_ion and /mer_cy;",
        "O come, let /us a_/dore him."
    ],
    easter: [
        "Al_le_lu_ia. The Lord is /ri_sen in_/deed;",
        "O come let us a_dore him. /Al_le_/lu_ia."
    ],
    ascension: [
        "Al_le_lu_ia. Christ the Lord a_scen_ded /in_to /heav_en;",
        "O come, let /us a_/dore him. /Al_le_/lu_ia."
    ],
    whitsun: [
        "Al_le_lu_ia. The Spi_rit of the Lord /fill_eth the /world;",
        "O come, let /us a_/dore him. /Al_le_/lu_ia."
    ],
    trinity: [
        "Fa_ther, Son, and /Ho_ly Ghost, /One God;",
        "O come, let /us a_/dore him."
    ],
    annunciation: [
        "The Word was made flesh and /dwelt a_/mong us;",
        "O come, let /us a_/dore him."
    ],
    saints: [
        "The Lord is /glo_ri_ous /in his saints;",
        "O come, let /us a_/dore him."
    ],
    "ordinary-0": [
        "The earth is the /Lord\u2019s for he /made it;",
        "O come, let /us a_/dore him."
    ],
    "ordinary-1": [
        "Wor_ship the Lord in the /beau_ty of /ho_li_ness;",
        "O come, let /us a_/dore him."
    ],
    "ordinary-2": [
        "The mer_cy of the Lord is /e_ver_/last_ing;",
        "O come, let /us a_/dore him."
    ]
};



const $2de76dc2a5b96b1f$export$8bd16c3f92413ace = (id)=>{
    return id === "venite" ? "Venite" : id === "te deum" ? "Te Deum" : id === "benedictus" ? "Benedictus" : id === "magnificat" ? "Magnificat" : id === "nunc dimittis" ? "Nunc Dimittis" : id === "pascha nostrum" ? "Pascha Nostrum" : id === "benedictus es" ? "Benedictus es, Domine" : "";
};
const $2de76dc2a5b96b1f$export$dc5d6ec6455be932 = {
    venite: [
        "1a.1",
        "2.1",
        "8.5",
        "6b"
    ],
    "pascha nostrum": [
        "Tonus Peregrinus A",
        "Tonus Peregrinus A",
        "Tonus Peregrinus A",
        "Tonus Peregrinus A"
    ],
    "te deum": [
        "3a.6",
        "Tonus Peregrinus A",
        "7.5",
        "8.1"
    ],
    "benedictus es": [
        "3a.6",
        "Tonus Peregrinus A",
        "7.5",
        "8.1"
    ],
    benedictus: [
        "6a",
        "3a.1",
        "4.4",
        "2.1"
    ],
    magnificat: [
        "2.1",
        "6b",
        "7.5",
        "1a.1"
    ],
    "nunc dimittis": [
        "3a.4",
        "1a.2",
        "4.8",
        "6a"
    ],
    "quicunque vult": [
        "4.4",
        "4.4",
        "4.4",
        "4.4"
    ]
};
const $2de76dc2a5b96b1f$export$4d2dd46eb8f9c829 = (props)=>{
    const { id: id, day: day, tone: toneOverride, exportLines: exportLines } = props;
    const { settings: settings } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const defaultTone = toneOverride ?? $2de76dc2a5b96b1f$export$dc5d6ec6455be932[id][day.weekOfTheYear % 4];
    const { tweaks: tweaks, setTweak: setTweak } = (0, $b0ef04497ab55347$export$9d593b1761d4031)();
    let tone = tweaks[id] ?? defaultTone;
    const [antiphonModal, setAntiphonModal] = (0, $acw62.useState)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}));
    const [canticleModal, setCanticleModal] = (0, $acw62.useState)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}));
    const antiphon = (()=>{
        if (id === "venite" && (settings.invitatoryAntiphons === "always" || settings.invitatoryAntiphons === "seasons" && !day.antiphonId.includes("ordinary"))) {
            const antiphonTone = settings.antiphonTones === "solemn" ? tone.includes("Tonus") ? tone : tone[0] + "s" + tone.replace(/[ab]/, "").slice(1) : tone;
            //const antiphonTone = tone.slice(0, 1) + "ant";
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $982dab2795189e62$export$45a8b3c92b66d3be), {
                id: `${id}-ant`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2d213bd4c46a128$export$1246c4e68efb74f5), {
                        id: `${id}-ant`,
                        title: "Antiphon",
                        player: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d785bb9b161f2130$export$397fd5de0a6e6acd), {
                            tones: [
                                antiphonTone
                            ],
                            selectedTone: antiphonTone,
                            id: "antiphon",
                            onSetModal: (id, element)=>setAntiphonModal(element)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                        pointedText: (0, $8da148c2c45b952c$export$30094a79c9c7227e)([
                            (0, $6aa1945ec54bb8d7$export$6772ff6b75684fb1)[day.antiphonId]
                        ], antiphonTone, false, true),
                        boldMode: "none",
                        dropCap: false,
                        exportLines: exportLines,
                        tone: antiphonTone
                    })
                ]
            });
        }
    })();
    const content = (0, $acw62.useMemo)(()=>{
        const pointedPsalm = (0, $8da148c2c45b952c$export$aff03f17ba557a93)(id, tone);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
            pointedText: pointedPsalm,
            boldMode: settings.psalmsBold,
            dropCap: true,
            exportLines: exportLines,
            tone: tone
        });
    }, [
        id,
        tone,
        settings.psalmsBold
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {},
        children: [
            antiphon,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $982dab2795189e62$export$45a8b3c92b66d3be), {
                id: id,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2d213bd4c46a128$export$1246c4e68efb74f5), {
                        id: id,
                        title: $2de76dc2a5b96b1f$export$8bd16c3f92413ace(id),
                        player: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d785bb9b161f2130$export$397fd5de0a6e6acd), {
                            tones: [
                                tone,
                                (0, $8da148c2c45b952c$export$956628726129226c)(tone)
                            ],
                            selectedTone: tone,
                            id: id,
                            onSetModal: (id, element)=>setAntiphonModal(element),
                            onSetSelectedTone: (tone)=>{
                                setTweak(id, tone);
                            }
                        })
                    }),
                    content
                ]
            }),
            antiphon,
            antiphonModal,
            canticleModal
        ]
    });
};



parcelRequire("acw62");
const $ef18d012be6266df$export$a8a3e93435678ff9 = (props)=>{
    const { text: text, rightItem: rightItem } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            paddingTop: 32,
            fontSize: "115%",
            fontWeight: "bold",
            letterSpacing: 0.15,
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flexGrow: 1
                },
                children: text
            }),
            rightItem
        ]
    });
};



parcelRequire("acw62");


const $8aa619cb9c0e374f$export$72490c06b5868661 = (props)=>{
    const { link: link, title: title, subtitle: subtitle } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            padding: 16,
            paddingBottom: 16,
            width: 200,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: "110%",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    letterSpacing: 1
                },
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    paddingBottom: 10,
                    fontWeight: "bold",
                    color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                },
                children: subtitle
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                to: link,
                style: {
                    textDecoration: "none",
                    border: `1px solid ${(0, $b5d1360628cd70a0$export$f20e1008093b38b9)}`,
                    color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                    paddingTop: 8,
                    paddingRight: 16,
                    paddingBottom: 10,
                    paddingLeft: 16,
                    borderRadius: 4,
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    textTransform: "uppercase",
                    fontSize: "90%",
                    fontWeight: "bold",
                    letterSpacing: 0.1
                },
                children: [
                    "Pray ",
                    title
                ]
            })
        ]
    });
};




const $d572d9bbc08f1eb4$var$getFeriaTitle = (month, date)=>{
    if (month === 12) {
        if (date === 17) return "O Sapientia";
        if (date === 18) return "O Adonai";
        if (date === 19) return "O Radix Jesse";
        if (date === 20) return "O Clavis David";
        if (date === 21) return "O Oriens";
        if (date === 22) return "O Rex Gentium";
        if (date === 23) return "O Emmanuel";
    }
    return "Feria";
};
const $d572d9bbc08f1eb4$export$ae5419e1b4c8d902 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingTop: (0, $cd93687958c8007e$export$bc451faac18251e7)() ? 8 : 48,
            paddingBottom: 48
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
            onlySides: true,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        paddingTop: 24,
                        fontWeight: "bold",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        fontSize: "140%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: "Sing"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                            },
                            children: "The"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: "Office"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                        textAlign: "center",
                        fontWeight: "bold"
                    },
                    children: "First Edition"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef18d012be6266df$export$a8a3e93435678ff9), {
                    text: "Pray Now",
                    rightItem: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                        style: {
                            textDecoration: "underline",
                            fontSize: 16,
                            paddingRight: 4
                        },
                        to: "/settings",
                        children: "Settings"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: (0, $cd93687958c8007e$export$bc451faac18251e7)() ? "column" : "row",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8aa619cb9c0e374f$export$72490c06b5868661), {
                            link: "/pray/today/mattins",
                            title: "Mattins",
                            subtitle: "Morning Prayer"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8aa619cb9c0e374f$export$72490c06b5868661), {
                            link: "/pray/today/evensong",
                            title: "Evensong",
                            subtitle: "Evening Prayer"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8aa619cb9c0e374f$export$72490c06b5868661), {
                            link: "/pray/today/compline",
                            title: "Compline",
                            subtitle: "Night Prayer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef18d012be6266df$export$a8a3e93435678ff9), {
                    text: "Psalms by Number"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center"
                    },
                    children: (()=>{
                        const allPsalms = [];
                        for(let i = 1; i <= 150; i++)allPsalms.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                    style: {
                                        padding: 4,
                                        width: 24,
                                        fontWeight: "bold",
                                        textAlign: "center"
                                    },
                                    to: `/psalm/${i}`,
                                    children: i
                                }),
                                " "
                            ]
                        }));
                        return allPsalms;
                    })()
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef18d012be6266df$export$a8a3e93435678ff9), {
                    text: "Canticles"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center"
                    },
                    children: Object.entries((0, $2de76dc2a5b96b1f$export$dc5d6ec6455be932)).map(([canticleId, tones])=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                width: 240,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                paddingTop: 16
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: (0, $2de76dc2a5b96b1f$export$8bd16c3f92413ace)(canticleId)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                paddingLeft: 6,
                                                paddingRight: 6
                                            },
                                            children: "Tone"
                                        }),
                                        tones.map((tone, toneIndex)=>{
                                            if (canticleId === "pascha nostrum" && toneIndex > 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                                style: {
                                                    paddingLeft: 6,
                                                    paddingRight: 6,
                                                    fontWeight: "bold",
                                                    textAlign: "center"
                                                },
                                                to: `/canticle/${canticleId.replace(/ /g, "-")}/${tone === "Tonus Peregrinus A" ? "tpa" : tone}`,
                                                children: tone === "Tonus Peregrinus A" ? "T.P. A" : tone
                                            });
                                        })
                                    ]
                                })
                            ]
                        });
                    })
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");



const $9269fe14be50e41e$export$3457cdbe4eabc5a0 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: props.primary ? "new-button-primary" : "new-button",
        onClick: props.onClick,
        children: props.children
    });
};




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



const $43ca0afba8341f20$var$getFeriaTitle = (month, date)=>{
    if (month === 12) {
        if (date === 17) return "O Sapientia";
        if (date === 18) return "O Adonai";
        if (date === 19) return "O Radix Jesse";
        if (date === 20) return "O Clavis David";
        if (date === 21) return "O Oriens";
        if (date === 22) return "O Rex Gentium";
        if (date === 23) return "O Emmanuel";
    }
    return "Feria";
};
const $43ca0afba8341f20$export$d3b856a81b700900 = (props)=>{
    const { year: year, month: month, date: date, options: options, outranked: outranked, firstEvensongList: firstEvensongList, isEvening: isEvening, isToday: isToday, compact: compact } = props;
    const [showOther, setShowOther] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            lineHeight: compact ? 1.2 : undefined
        },
        children: [
            options.filter((celebration)=>!celebration.label.includes("votive-")).sort((a, b)=>{
                if (a.optional) return 1;
                if (b.optional) return -1;
                return a.rank - b.rank;
            }).map((celebration, celebrationIndex)=>{
                let liturgicalColor = "#4d9c2c"; // green
                if (celebration.title.includes("Advent") || celebration.title.includes("Lent") || celebration.title.includes("Palm Sunday") || celebration.title.includes("gesima") || celebration.title.includes("Passion") || celebration.title === "Holy Saturday" || celebration.title === "Maundy Thursday" || celebration.title.includes("Ash Wednesday") || celebration.title === "ANZAC Day" || celebration.title.includes("Ember") || celebration.title.includes("December")) liturgicalColor = "#6f3eb0"; // purple
                if (celebration.type === "memorial" || celebration.title.includes("Easter") || celebration.title.includes("Christmas") || celebration.title === "Rogation Monday" || celebration.title === "Rogation Tuesday" || celebration.title === "Rogation Wednesday" || celebration.title === "Rogation Thursday" || celebration.title === "Rogation Friday" || celebration.title === "Rogation Saturday" || celebration.title.includes("Ascension")) liturgicalColor = "#ffffff"; // white
                if (celebration.type === "feast" || celebration.type === "solemnity") liturgicalColor = "#fdde6c"; // gold
                if (celebration.subtitle?.toLocaleLowerCase().includes("martyr") || celebration.title.toLocaleLowerCase().includes("martyr") || celebration.subtitle?.includes("Apostle") || celebration.subtitle?.includes("Evangelist") || celebration.title.includes("Whit") || celebration.title.includes("Pentecost") || celebration.title.includes("Holy Cross")) liturgicalColor = "#c23b1d"; // red
                if (celebration.title.includes("Holy Week")) liturgicalColor = "#6f3eb0"; // purple
                if (celebration.title === "All Souls" || celebration.title === "Office of the Dead") liturgicalColor = "#000000"; // black
                if (celebration.title.includes("before Advent")) liturgicalColor = "#4d9c2c"; // green
                if (celebration.shortTitle === "Advent III" || celebration.shortTitle === "Lent IV") liturgicalColor = "#ff91b0"; // rose
                if (celebration.title === "Saint John") liturgicalColor = "#ffffff"; // white
                if (celebration.title === "Palm Sunday") liturgicalColor = "#c23b1d"; // red
                if (celebration.collect === "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.") liturgicalColor = "#ffffff"; // white
                if (celebration.title.includes("Good Friday")) liturgicalColor = "#000000"; // black
                if (celebration.title === "Holy Saturday") liturgicalColor = "#6f3eb0"; // purple
                let isFirstEvensong = false;
                if (isEvening) {
                    if (celebration.type === "sunday" || celebration.type === "solemnity" || celebration.type === "feast") {
                        if (firstEvensongList.find((ife)=>ife === celebration.label)) isFirstEvensong = true;
                    }
                }
                const isHighlighted = celebrationIndex === 0 && isToday && !compact;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center"
                    },
                    children: [
                        celebrationIndex > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                paddingLeft: 6,
                                paddingRight: 2,
                                paddingBottom: 2,
                                width: 26,
                                boxSizing: "border-box"
                            },
                            children: "or:"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                backgroundColor: isHighlighted ? "#f7f0cb" : undefined,
                                boxShadow: isHighlighted ? "inset 0 0 0 1px rgba(0,0,0,0.05)" : undefined,
                                paddingLeft: 6,
                                paddingRight: 6,
                                paddingTop: compact ? 2 : 6,
                                paddingBottom: compact ? 2 : 6,
                                borderRadius: 4,
                                flexGrow: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        alignSelf: "stretch",
                                        width: 8,
                                        minWidth: 8,
                                        backgroundColor: liturgicalColor,
                                        borderRadius: 2,
                                        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.2)"
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        paddingLeft: 6,
                                        paddingRight: 6,
                                        flexGrow: 1
                                    },
                                    children: [
                                        isFirstEvensong ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: "90%",
                                                lineHeight: 1.4
                                            },
                                            children: "First Evensong of"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                lineHeight: 1.35
                                            },
                                            children: [
                                                celebration.title,
                                                celebration.subtitle ? `, ${celebration.subtitle}` : "",
                                                celebration.type === "feast" ? " (Feast)" : "",
                                                celebration.type === "solemnity" ? " (Solemnity)" : ""
                                            ]
                                        })
                                    ]
                                }),
                                compact ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                    to: `se/${year}/${month}/${date}/${celebration.label}/${isFirstEvensong ? "first-evensong" : isEvening ? "evensong" : "mattins"}`,
                                    style: {
                                        color: isHighlighted ? "white" : "black"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9269fe14be50e41e$export$3457cdbe4eabc5a0), {
                                        onClick: ()=>{},
                                        primary: isHighlighted,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "Pray",
                                                " ",
                                                isEvening ? "Evensong" : "Mattins"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                });
            }),
            compact ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : showOther ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    [
                        {
                            title: "Office of the Dead",
                            label: "office-of-the-dead",
                            urlOverride: "/se/office-of-the-dead",
                            liturgicalColor: "#000000"
                        }
                    ].concat(props.votivesNotAllowedReason ? [] : [
                        {
                            title: "Votive Office of Saint Peter and Saint Paul",
                            label: "votive-of-saints-peter-and-paul",
                            urlOverride: null,
                            liturgicalColor: "#c23b1d"
                        },
                        {
                            title: "Votive Office of Our Lord Jesus Christ, Supreme and Eternal High Priest",
                            label: "votive-of-oljc-high-priest",
                            urlOverride: null,
                            liturgicalColor: "#FFFFFF"
                        }
                    ]).map((otherRow)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        paddingLeft: 6,
                                        paddingRight: 2,
                                        paddingBottom: 2,
                                        width: 26,
                                        boxSizing: "border-box"
                                    },
                                    children: "or:"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        paddingLeft: 6,
                                        paddingRight: 6,
                                        paddingTop: compact ? 2 : 6,
                                        paddingBottom: compact ? 2 : 6,
                                        borderRadius: 4,
                                        flexGrow: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                alignSelf: "stretch",
                                                width: 8,
                                                minWidth: 8,
                                                backgroundColor: otherRow.liturgicalColor,
                                                borderRadius: 2,
                                                boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.2)"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                paddingLeft: 6,
                                                paddingRight: 6,
                                                flexGrow: 1
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    lineHeight: 1.35
                                                },
                                                children: otherRow.title
                                            })
                                        }),
                                        compact ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                            to: otherRow.urlOverride ? `${otherRow.urlOverride}/${isEvening ? "evensong" : "mattins"}` : `${0, $b5d1360628cd70a0$export$beeaca86d94e0278}/${year}/${month}/${date}/${otherRow.label}/${isEvening ? "evensong" : "mattins"}`,
                                            style: {
                                                color: "black"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9269fe14be50e41e$export$3457cdbe4eabc5a0), {
                                                onClick: ()=>{},
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        "Pray",
                                                        " ",
                                                        isEvening ? "Evensong" : "Mattins"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        });
                    }),
                    props.votivesNotAllowedReason ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                            paddingLeft: 32
                        },
                        children: [
                            "Votive Offices are not said",
                            " ",
                            props.votivesNotAllowedReason,
                            "."
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    height: 40
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            paddingLeft: 6,
                            paddingRight: 8,
                            paddingBottom: 4
                        },
                        children: "or:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9269fe14be50e41e$export$3457cdbe4eabc5a0), {
                        onClick: ()=>{
                            setShowOther(true);
                        },
                        children: "Other..."
                    })
                ]
            }),
            !compact && outranked.filter((c)=>!c.label.includes("votive-")).length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    paddingTop: 16,
                    lineHeight: 1.4,
                    fontSize: "90%"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {},
                        children: "Outranked:"
                    }),
                    outranked.filter((c)=>!c.label.includes("votive-")).map((celebration)=>{
                        let isFirstEvensong = false;
                        if (isEvening) {
                            if (celebration.type === "sunday" || celebration.type === "solemnity" || celebration.type === "feast") {
                                if (firstEvensongList.find((ife)=>ife === celebration.label)) isFirstEvensong = true;
                            }
                        }
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                to: `se/${year}/${month}/${date}/${celebration.label}/${isFirstEvensong ? "first-evensong" : isEvening ? "evensong" : "mattins"}`,
                                style: {
                                    color: "#777",
                                    textDecoration: "underline"
                                },
                                children: [
                                    isFirstEvensong ? "First Evensong of " : "",
                                    celebration.title,
                                    celebration.subtitle ? `, ${celebration.subtitle}` : "",
                                    celebration.type === "feast" ? " (Feast)" : "",
                                    celebration.type === "solemnity" ? " (Solemnity)" : ""
                                ]
                            })
                        });
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
};


const $759a82e2daa88b64$var$getOAntiphonTitle = (month, date)=>{
    if (month === 12) {
        if (date === 17) return "(O Sapientia)";
        if (date === 18) return "(O Adonai)";
        if (date === 19) return "(O Radix Jesse)";
        if (date === 20) return "(O Clavis David)";
        if (date === 21) return "(O Oriens)";
        if (date === 22) return "(O Rex Gentium)";
        if (date === 23) return "(O Emmanuel)";
    }
    return "";
};
const $759a82e2daa88b64$export$d0d43328e21205da = (props)=>{
    const isToday = props.date === new Date().getDate() && props.month === new Date().getMonth() + 1 && props.year === new Date().getFullYear();
    const [hour, setHour] = (0, $acw62.useState)(isToday ? new Date().getHours() > 12 ? "evening" : "morning" : "mattins");
    const votivesNotAllowedReason = [
        {
            label: "on Solemnities",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.type === "solemnity")
        },
        {
            label: "on Sundays of Advent",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.title.includes("Sunday of Advent"))
        },
        {
            label: "on Sundays in Lent",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.title.includes("Sunday in Lent"))
        },
        {
            label: "on Sundays of Easter",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.title.includes("Sunday of Easter"))
        },
        {
            label: "on Ash Wednesday",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.title.includes("Ash Wednesday"))
        },
        {
            label: "in Holy Week",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.title.includes("Holy Week") || celebration.title.includes("Maundy Thursday") || celebration.title.includes("Good Friday") || celebration.title.includes("Holy Saturday"))
        },
        {
            label: "in the Octave of Easter",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.title.includes("Octave of Easter"))
        },
        {
            label: "in the Octave of Pentecost",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.title.includes("in Whitsun Week"))
        },
        {
            label: "on 2 November",
            check: (celebrationList)=>celebrationList.find((celebration)=>celebration.title.includes("All Souls"))
        }
    ].find((reason)=>reason.check(props.morningOptions))?.label;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: props.isSelected ? undefined : "calendar-day-selectable",
        style: {
            ...props.isSelected ? (0, $cd93687958c8007e$export$bc451faac18251e7)() ? {
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 16,
                paddingBottom: 8
            } : {
                paddingLeft: 16,
                paddingRight: 16,
                paddingTop: 16,
                paddingBottom: 16
            } : (0, $cd93687958c8007e$export$bc451faac18251e7)() ? {
                paddingLeft: 2,
                paddingRight: 2,
                paddingTop: 4,
                paddingBottom: 6
            } : {
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        onClick: ()=>{
            if (!props.isSelected) {
                if (isToday) setHour(new Date().getHours() > 12 ? "evening" : "morning");
                else setHour("morning");
                props.setDate(new Date(props.year, props.month - 1, props.date));
            }
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                pointerEvents: !props.isSelected ? "none" : undefined
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: props.isSelected ? {
                        fontWeight: "bold",
                        fontSize: "130%",
                        paddingLeft: 6,
                        paddingRight: 6,
                        lineHeight: 0.8
                    } : {
                        fontWeight: "bold",
                        paddingLeft: 6,
                        paddingRight: 6
                    },
                    children: [
                        {
                            mon: "Monday",
                            tues: "Tuesday",
                            wed: "Wednesday",
                            thur: "Thursday",
                            fri: "Friday",
                            sat: "Saturday",
                            sun: "Sunday"
                        }[props.day],
                        " ",
                        props.date,
                        " ",
                        [
                            "",
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ][props.month],
                        " ",
                        $759a82e2daa88b64$var$getOAntiphonTitle(props.month, props.date)
                    ]
                }),
                props.isSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-end",
                        paddingLeft: 6,
                        paddingRight: 6,
                        paddingBottom: isToday ? 16 : 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: "130%",
                                flexGrow: 1,
                                lineHeight: 1
                            },
                            children: hour === "morning" ? "Mattins" : "Evensong"
                        }),
                        hour === "morning" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9269fe14be50e41e$export$3457cdbe4eabc5a0), {
                            onClick: ()=>{
                                setHour("evening");
                            },
                            children: "Switch to Evensong"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9269fe14be50e41e$export$3457cdbe4eabc5a0), {
                            onClick: ()=>{
                                setHour("morning");
                            },
                            children: "Switch to Mattins"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                props.isSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: hour === "morning" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43ca0afba8341f20$export$d3b856a81b700900), {
                                year: props.year,
                                month: props.month,
                                date: props.date,
                                options: props.morningOptions,
                                outranked: props.morningOutranked,
                                firstEvensongList: [],
                                isEvening: false,
                                isToday: isToday,
                                compact: false,
                                votivesNotAllowedReason: votivesNotAllowedReason
                            }),
                            props.isFirstEvensong.length > 0 && hour === "morning" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    paddingTop: 16
                                },
                                children: [
                                    isToday ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontWeight: "bold",
                                            paddingLeft: 6
                                        },
                                        children: "This evening:"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontWeight: "bold",
                                            paddingLeft: 6
                                        },
                                        children: "In the evening:"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43ca0afba8341f20$export$d3b856a81b700900), {
                                        year: props.year,
                                        month: props.month,
                                        date: props.date,
                                        options: props.eveningOptions,
                                        outranked: [],
                                        firstEvensongList: props.isFirstEvensong,
                                        isEvening: true,
                                        isToday: false,
                                        compact: true,
                                        votivesNotAllowedReason: votivesNotAllowedReason
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43ca0afba8341f20$export$d3b856a81b700900), {
                            year: props.year,
                            month: props.month,
                            date: props.date,
                            options: props.eveningOptions,
                            outranked: props.eveningOutranked,
                            firstEvensongList: props.isFirstEvensong,
                            isEvening: true,
                            isToday: isToday,
                            compact: false,
                            votivesNotAllowedReason: votivesNotAllowedReason
                        })
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43ca0afba8341f20$export$d3b856a81b700900), {
                            year: props.year,
                            month: props.month,
                            date: props.date,
                            options: props.morningOptions,
                            outranked: props.morningOutranked,
                            firstEvensongList: [],
                            isEvening: false,
                            isToday: isToday,
                            compact: true,
                            votivesNotAllowedReason: votivesNotAllowedReason
                        }),
                        props.isFirstEvensong.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                paddingTop: 8
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43ca0afba8341f20$export$d3b856a81b700900), {
                                year: props.year,
                                month: props.month,
                                date: props.date,
                                options: props.eveningOptions,
                                outranked: [],
                                firstEvensongList: props.isFirstEvensong,
                                isEvening: true,
                                isToday: false,
                                compact: true,
                                votivesNotAllowedReason: votivesNotAllowedReason
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                    ]
                })
            ]
        })
    });
};


const $e4d81acce6b1f0d2$var$oneMartyr = {
    ep1HymnId: "martyr of god whose strength was steeled",
    invId: "martyr inv",
    mpHymnId: "martyr of god whose strength was steeled",
    mpVandR: [
        "The righ_teous shall flou_rish like a palm tree.",
        "And shall spread a_broad like a ce_dar in Li_ba_nus."
    ],
    mpBenId: "martyr ben",
    ep2HymnId: "o god thy soldiers crown and guard",
    ep2VandR: [
        "The righ_teous shall flou_rish like a palm tree.",
        "And shall spread a_broad like a ce_dar in Li_ba_nus."
    ],
    ep2MagId: "martyr ep2 mag",
    easterOverrides: {
        mpVandR: [
            "Right dear in the sight of the Lord.",
            "Is the death of his Saints."
        ],
        ep2VandR: [
            "Right dear in the sight of the Lord.",
            "Is the death of his Saints."
        ]
    }
};
const $e4d81acce6b1f0d2$var$confessorBishop = {
    ep1HymnId: "he whose confession god of old accepted",
    ep1MagId: "bishop o high priest",
    ep1VandR: [
        "The Lord loved him and a_dorned him.",
        "He clothed him with a robe of glo_ry."
    ],
    invId: "religious the lord the king",
    mpHymnId: "he whose confession god of old accepted",
    mpVandR: [
        "The Lord gui_ded the righ_teous in right paths.",
        "And showed him the king_dom of God."
    ],
    mpBenId: "bishops well done good and faithful",
    ep2HymnId: "o thou whose all redeeming might",
    ep2VandR: [
        "The Lord gui_ded the righ_teous in right paths.",
        "And showed him the king_dom of God."
    ],
    ep2MagId: "bishops the lord loved him"
};
const $e4d81acce6b1f0d2$var$virgin = {
    ep1HymnId: "son of a virgin maker of thy mother",
    ep1VandR: [
        "In thy grace and in the beau_ty go forth.",
        "Ride pro_spe_rous_ly and reign."
    ],
    ep1MagId: "virgins come thou bride",
    invId: "virgins the lord the king",
    mpHymnId: "jesu the virgins crown do thou",
    mpVandR: [
        "Full of grace are thy lips.",
        "Be_cause God hath blessed thee for e_ver."
    ],
    mpBenId: "virgins the kingdom of",
    ep2HymnId: "son of a virgin maker of thy mother",
    ep2VandR: [
        "In thy grace and in thy beau_ty go forth.",
        "Ride pro_spe_rous_ly and reign."
    ],
    ep2MagId: "virgins come thou bride"
};
const $e4d81acce6b1f0d2$var$confessor = {
    ep1HymnId: "he whose confession god of old accepted",
    ep1VandR: [
        "The Lord loved him and a_dorned him.",
        "He clothed him with a robe of glo_ry."
    ],
    ep1MagId: "religious i will liken him",
    invId: "religious the lord the king",
    mpHymnId: "he whose confession god of old accepted",
    mpVandR: [
        "The Lord gui_ded the righ_teous in right paths.",
        "And showed him the king_dom of God."
    ],
    mpBenId: "religious well done good and faithful",
    ep2HymnId: "o thou whose all redeeming might",
    ep2VandR: [
        "The Lord gui_ded the righ_teous in right paths.",
        "And showed him the king_dom of God."
    ],
    ep2MagId: "religious this man the world"
};
const $e4d81acce6b1f0d2$export$68aaa04082781e33 = {
    "Abbot or Abbess": {
        ...$e4d81acce6b1f0d2$var$confessor,
        ep1HymnId: "sing we of those who in the forest wild",
        mpHymnId: "why fledst thou from all folk apart",
        ep2HymnId: "sing we of those who in the forest wild"
    },
    Religious: {
        ...$e4d81acce6b1f0d2$var$confessor,
        ep1HymnId: "sing we of those who in the forest wild",
        mpHymnId: "why fledst thou from all folk apart",
        ep2HymnId: "sing we of those who in the forest wild"
    },
    "Confessor: Bishop": $e4d81acce6b1f0d2$var$confessorBishop,
    "Confessor: Holy Pope": $e4d81acce6b1f0d2$var$confessorBishop,
    "Blessed Virgin Mary": {
        ep1HymnId: "hail o star that pointest",
        ep1VandR: [
            "Vouch_safe to re_ceive my /prai_ses, ' O hal_lowed Vir_gin.",
            "Streng_then /me to re_sist ' all thine e_ne_mies."
        ],
        ep1MagId: "bvm o holy mary [check for pointing]",
        invId: "bvm inv",
        mpHymnId: "the god whom earth and sea and sky",
        mpVandR: [
            "Full of grace are thy lips.",
            "Be_cause God hath blessed thee for e_ver."
        ],
        mpBenId: "bvm blessed art thou",
        ep2HymnId: "hail o star that pointest",
        ep2VandR: [
            "Vouch_safe to re_ceive my /prai_ses, ' O hal_lowed Vir_gin.",
            "Streng_then /me to re_sist ' all thine e_ne_mies."
        ],
        ep2MagId: "bvm all generations"
    },
    Apostles: {
        ep1HymnId: "lord of creation bow thine ear o christ to hear",
        ep1VandR: [
            "For their sound is gone out in_to all lands.",
            "And their words in_to the ends of the world."
        ],
        ep1MagId: "apostles for they shall",
        invId: "apostles inv",
        mpHymnId: "let the round world with songs rejoice",
        mpVandR: [
            "They de_clared the work of God.",
            "And wise_ly con_si_dered of his do_ings."
        ],
        mpBenId: "apostles ye which have",
        ep2HymnId: "let the round world with songs rejoice",
        ep2VandR: [
            "They de_clared the work of God.",
            "And wise_ly con_si_dered of his do_ings."
        ],
        ep2MagId: "apostles be ye valiant",
        easterOverrides: {
            ep1HymnId: "the sad apostles mourn him slain",
            ep1VandR: [
                "O ye saints and righ_teous, re_joice in the Lord.",
                "God hath cho_sen you for his own in_he_ri_tance."
            ],
            ep1MagId: "apostles light perpetual",
            mpHymnId: "on that fair day of paschal joy",
            mpVandR: [
                "Right dear in the sight of the Lord.",
                "Is the death of his Saints."
            ],
            mpBenId: "apostles daughters of jerusalem",
            ep2HymnId: "on that fair day of paschal joy",
            ep2VandR: [
                "Right dear in the sight of the Lord.",
                "Is the death of his Saints."
            ],
            ep2MagId: "apostles o ye holy"
        }
    },
    "Doctor of the Church": $e4d81acce6b1f0d2$var$confessor,
    "Confessor: Priest": $e4d81acce6b1f0d2$var$confessor,
    "Confessor: Missionary": $e4d81acce6b1f0d2$var$confessor,
    "Martyr: Bishop": $e4d81acce6b1f0d2$var$oneMartyr,
    "Martyr: Pope or Bishop": $e4d81acce6b1f0d2$var$oneMartyr,
    "One Martyr": $e4d81acce6b1f0d2$var$oneMartyr,
    "Virgin Martyr": {
        ...$e4d81acce6b1f0d2$var$virgin
    },
    "Many Virgin Martyrs": {
        ...$e4d81acce6b1f0d2$var$virgin,
        ep1VandR: [
            "The Vir_gins shall be brought un_to the King.",
            "Her fel_lows shall be brought un_to thee."
        ],
        mpVandR: [
            "The Vir_gins shall be brought un_to the King.",
            "Her fel_lows shall be brought un_to thee."
        ],
        ep2VandR: [
            "The Vir_gins shall be brought un_to the King.",
            "Her fel_lows shall be brought un_to thee."
        ]
    },
    Virgin: {
        ...$e4d81acce6b1f0d2$var$virgin
    },
    Educator: {
        ...$e4d81acce6b1f0d2$var$confessor
    },
    "Several Martyrs": {
        ep1HymnId: "the merits of the saints",
        ep1VandR: [
            "Be glad O ye right_eous, and re_joice in the Lord.",
            "And be joy_ful, all ye that are true of heart."
        ],
        ep1MagId: "many martyrs for theirs is the kingdom",
        invId: "martyr inv",
        mpHymnId: "the merits of the saints",
        mpVandR: [
            "Let the Saints be joy_ful in glo_ry.",
            "Let them re_joice in their beds."
        ],
        mpBenId: "many martyrs the very hairs",
        ep2HymnId: "o glorious king of martyr hosts",
        ep2VandR: [
            "Let the Saints be joy_ful in glo_ry.",
            "Let them re_joice in their beds."
        ],
        ep2MagId: "many martyrs in the heavenly",
        easterOverrides: {
            ep1HymnId: "o glorious king of martyr hosts",
            ep1VandR: [
                "O ye saints and righ_teous, re_joice in the Lord.",
                "God hath cho_sen you for his own in_he_ri_tance."
            ],
            ep1MagId: "apostles light perpetual",
            mpHymnId: "o glorious king of martyr hosts",
            mpVandR: [
                "Right dear in the sight of the Lord.",
                "Is the death of his Saints."
            ],
            mpBenId: "apostles daughters of jerusalem",
            ep2HymnId: "o glorious king of martyr hosts",
            ep2VandR: [
                "Right dear in the sight of the Lord.",
                "Is the death of his Saints."
            ],
            ep2MagId: "apostles o ye holy"
        }
    },
    "Any Holy Man": {
        ep1HymnId: "o thou whose all redeeming might",
        ep1VandR: [
            "The Lord loved him and a_dorned him.",
            "He clothed him with a robe of glo_ry."
        ],
        ep1MagId: "religious i will liken him",
        invId: "inv any holy man",
        mpHymnId: "jesu eternal truth sublime",
        mpVandR: [
            "The Lord gui_ded the righ_teous in right paths.",
            "And showed him the king_dom of God."
        ],
        mpBenId: "religious well done good and faithful",
        ep2HymnId: "o thou whose all redeeming might",
        ep2VandR: [
            "The Lord loved him and a_dorned him.",
            "He clothed him with a robe of glo_ry."
        ],
        ep2MagId: "religious this man the world"
    },
    "Any Matron or Holy Woman": {
        ep1HymnId: "the praises of that saint we sing",
        ep1VandR: [
            "In thy grace and in thy beau_ty go forth.",
            "Ride pros_pe_rous_ly and reign."
        ],
        ep1MagId: "virgins the kingdom of",
        // INV IS PER SAINT
        mpHymnId: "the praises of that saint we sing",
        mpVandR: [
            "Full of grace are thy lips.",
            "Be_cause God hath blessed thee for e_ver."
        ],
        mpBenId: "holy woman give her",
        ep2HymnId: "the praises of that saint we sing",
        ep2VandR: [
            "In thy grace and in thy beau_ty go forth.",
            "Ride pros_pe_rous_ly and reign."
        ],
        ep2MagId: "matron she stretcheth"
    },
    "Dedication of a Church": {
        ep1HymnId: "blessed city heavenly salem",
        ep1VandR: [
            "This is the house of the Lord, most firm_ly build_ed.",
            "It is well found_ed u_pon a strong rock."
        ],
        ep1MagId: "dedication the lord hath",
        invId: "dedication inv",
        mpHymnId: "christ is made the sure foundation",
        mpVandR: [
            "This is the house of the Lord, most firm_ly build_ed.",
            "It is well found_ed u_pon a strong rock."
        ],
        mpBenId: "dedication zacchaeus",
        ep2HymnId: "christ is made the sure foundation",
        ep2VandR: [
            "Ho_li_ness be_com_eth thine house, O Lord.",
            "For e_ver and e_ver."
        ],
        ep2MagId: "dedication o how"
    }
};


const $f413104e060180de$export$6ba6f5acbe0c0a65 = [
    {
        day: 2,
        month: 1,
        title: "Saints Basil the Great and Gregory Nazianzen",
        subtitle: "Bishops and Doctors of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty God, whose servants Basil and Gregory proclaimed the mystery of thy Word made flesh, that thy Church might be built up in wisdom and strength: grant that we, through their prayers, and rejoicing in the Lord's presence among us, may with them be brought to know the power of thine unending love; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 3,
        month: 1,
        title: "The Most Holy Name of Jesus",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, who by thy blessed Apostle hast taught us that there is none other name given among men whereby we must be saved, but only the Name of our Lord Jesus Christ: grant, we beseech thee; that we may ever glory in this Name, and strive to make thy salvation known unto all mankind; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            invId: "hnj inv",
            mpHymnId: "jesu the very thought is sweet",
            mpVandR: [
                "Our help stan_deth in the Name of the Lord.",
                "Who hath made hea_ven and earth."
            ],
            mpBenId: "hnj he gave himself",
            ep2HymnId: "o let the heart beat high with bliss",
            ep2VandR: [
                "Bless_ed be the Name of the Lord.",
                "From this time forth for e_ver_more, al_le_lu_ia."
            ],
            ep2MagId: "hnj thou shalt call"
        }
    },
    {
        day: 7,
        month: 1,
        title: "Saint Raymond of Penyafort",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst appoint blessed Raymond excellently to minister the Sacrament of Penance, and didst wondrously make for him a passage upon the waves of the sea: grant, we pray thee; that, at his intercession, we may bring forth fruits worthy of repentance, and be found meet to attain to the harbour of everlasting salvation; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 12,
        month: 1,
        title: "Saint Benedict Biscop",
        subtitle: "Abbot",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, by whose gift the blessed Abbot Benedict left all things that he might be made perfect: grant unto all those who have entered upon the path of evangelical perfection; that they may neither look back nor linger, in the way; but hastening to thee without stumbling, may lay hold on life eternal; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 12,
        month: 1,
        title: "Saint \xc6lred of Rievaulx",
        subtitle: "Abbot",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, who didst endow the blessed Abbot \xc6lred with the gift of Christian friendship and the wisdom to lead others into the way of holiness: grant to thy people that same spirit of mutual affection; that in loving one another we may know the love of Christ and rejoice in the eternal possession of thine unsurpassable goodness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 13,
        month: 1,
        title: "Saint Hilary",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty, everlasting God, whose servant Hilary steadfastly confessed thy Son our Saviour Jesus Christ to be very God and very Man: grant that we may hold to this faith, and evermore magnify his holy Name; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor francis de sales"
        }
    },
    {
        day: 13,
        month: 1,
        title: "Saint Kentigern (Mungo)",
        subtitle: "Bishop",
        regionNote: "Australia, Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who through thy Bishop Saint Kentigern made the light of the true faith to shine forth in splendour: grant, we pray; that by faithfully following the teaching of him whose feast we now celebrate, we may obtain the glory of eternal light; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 17,
        month: 1,
        title: "Saint Anthony",
        subtitle: "Abbot",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Most gracious God, who didst call thy servant Anthony, to sell all that he had and to serve thee in the solitude of the desert: grant that we, through his intercession and following his example, may learn to deny ourselves and to love thee before all things; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 19,
        month: 1,
        title: "Saint Wulfstan",
        subtitle: "Bishop",
        regionNote: "Australia, Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, the light of the faithful and shepherd of souls, who didst call thy Bishop Wulfstan to feed thy sheep by his word, and guide them by his example: grant us, we pray thee, by his intercession, to keep the faith he taught, and to follow in his footsteps; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 20,
        month: 1,
        title: "Saint Fabian",
        subtitle: "Pope and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who dost support and defend us with the glorious witness and prayers of thy blessed Martyr Pope Fabian: grant us so to go forward in his footsteps, and ever to rejoice in fellowship with him; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Pope or Bishop",
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 20,
        month: 1,
        title: "Saint Sebastian",
        subtitle: "Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant unto us, we pray thee, O Lord, a spirit of fortitude: so that, taught by the glorious example of the Martyr Saint Sebastian, we may learn to obey thee rather than men; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 21,
        month: 1,
        title: "Saint Agnes",
        subtitle: "Virgin and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty, everlasting God, who dost choose the weak things of the world to confound those things that are strong: mercifully grant that we, who keep the festival of blessed Agnes thy Martyr, may perceive within ourselves the effect of her prayers; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 22,
        month: 1,
        title: "Saint Vincent",
        subtitle: "Deacon and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, by whose grace and power thy holy Deacon and Martyr Vincent triumphed over suffering and despised death: grant, we beseech thee, by his intercession; that enduring hardness, and waxing valiant in fight, we may with the noble army of Martyrs receive the crown of everlasting life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 24,
        month: 1,
        title: "Saint Francis de Sales",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "God of all holiness, who didst call thy Bishop Francis de Sales to bring many to Christ through his devout life, and to renew thy Church with patience and understanding: grant that through his intercession, we may, by word and example, reflect thy gentleness and love to all those whom we meet; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor francis de sales"
        }
    },
    {
        day: 25,
        month: 1,
        title: "The Conversion of Saint Paul the Apostle",
        subtitle: "",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "O God, who, through the preaching of the blessed Apostle Paul, hast caused the light of the Gospel to shine throughout the world: grant, we beseech thee; that we, having his wonderful conversion in remembrance, may show forth our thankfulness unto thee for the same, by following the holy doctrine which he taught; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear st paul",
            ep1VandR: [
                "Thou art a cho_sen ves_sel, ho_ly A_po_stle Paul.",
                "A prea_cher of the truth through_out the world."
            ],
            ep1MagId: "saint paul go forth",
            invId: "saint paul inv",
            mpHymnId: "let the round world with songs rejoice",
            mpVandR: [
                "Thou art a cho_sen ves_sel, ho_ly A_po_stle Paul.",
                "A prea_cher of the truth through_out the world."
            ],
            mpBenId: "saint paul ye which have",
            ep2HymnId: "let the round world with songs rejoice",
            ep2VandR: [
                "Thou art a cho_sen ves_sel, ho_ly A_po_stle Paul.",
                "A prea_cher of the truth through_out the world."
            ],
            ep2MagId: "saint paul o holy apostle"
        }
    },
    {
        day: 26,
        month: 1,
        title: "Saints Timothy and Titus",
        subtitle: "Bishops",
        regionNote: "Britain",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Heavenly Father, who didst send thine Apostle Paul to preach the Gospel, and gavest him Timothy and Titus to be his companions in the Faith: grant that, through their prayers, our fellowship in the Holy Spirit may bear witness to the Name of Jesus; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        regionNote: "OLSC",
        day: 26,
        month: 1,
        title: "Australia Day",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we pray, O Lord our God: that as the Cross shines in our southern skies; so may Christ bring light to our nation, and to its peoples old and new, and by saving grace transform our lives; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        propersOfTheFeria: true
    },
    {
        day: 27,
        month: 1,
        title: "Saint Angela Merici",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who through thy blessed Saint Angela didst cause a new household of Virgins consecrated to thy service to be established in thy Church: grant us, we pray thee, by her intercession, so to live after the manner of the holy Angels; that, putting aside all things earthly, we may be found worthy, to rejoice in everlasting felicity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, world without end. Amen.",
        commons: [
            "Virgin",
            "Educator"
        ]
    },
    {
        regionNote: "OLSC",
        day: 27,
        month: 1,
        title: "Saints Timothy and Titus",
        subtitle: "Bishops",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Heavenly Father, who didst send thine Apostle Paul to preach the Gospel, and gavest him Timothy and Titus to be his companions in the Faith: grant that, through their prayers, our fellowship in the Holy Spirit may bear witness to the Name of Jesus; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 28,
        month: 1,
        title: "Saint Thomas Aquinas",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Everlasting God, who didst enrich thy Church with the learning and holiness of thy servant Saint Thomas Aquinas: grant to all who seek thee a humble mind and a pure heart; that they may know thy Son Jesus Christ to be the way, the truth and the life; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Priest"
        ],
        supplements: {
            ep2MagId: "doctor thomas aquinas"
        }
    },
    {
        day: 31,
        month: 1,
        title: "Saint John Bosco",
        subtitle: "Priest",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst raise up Saint John Bosco thy Confessor to be a father and teacher of the young, and through him, with the aid of the Virgin Mary, didst will that new families should flourish in thy Church: grant, we beseech thee, that being kindled by the same fire of charity, we may have the strength to seek for souls, and to serve thee alone; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Educator"
        ]
    },
    {
        day: 1,
        month: 2,
        title: "Saint Brigid of Kildare",
        subtitle: "Abbess",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Grant, we beseech thee, O Lord, that the prayers of thy holy Abbess, blessed Brigid, may commend us unto thee: that we, who have no power of ourselves to help ourselves, may by her advocacy find favour in thy sight; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "O God, who to the blessed Abbess Brigid gavest grace to imitate Christ in his poverty, and with humble heart to follow him to the end: grant that all who enter the path of Gospel perfection may neither look back nor go astray from the way; but hastening to thee without stumbling, may attain the crown of eternal life whereunto thou dost call them; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 3,
        month: 2,
        title: "Saint Blaise",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who makest us glad with the yearly festival of blessed Blaise, thy Martyr and Bishop: mercifully grant that, as we now observe his heavenly birthday; so we may likewise rejoice in his protection; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Pope or Bishop"
        ]
    },
    {
        day: 3,
        month: 2,
        title: "Saint Ansgar",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty and gracious God, who didst send thy servant Ansgar to spread the Gospel among the Nordic peoples: through his intercession, we beseech thee to raise up, in this our generation, messengers of thy good tidings and heralds of thy kingdom; that the world may come to know the immeasurable riches of our Saviour Jesus Christ; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop",
            "Confessor: Missionary"
        ]
    },
    {
        day: 4,
        month: 2,
        title: "Saint Gilbert of Sempringham",
        subtitle: "Religious",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, our heavenly Father: we remember before thee all thy servants who have served thee faithfully in their generation, and have entered into rest, especially Gilbert of Sempringham, beseeching thee to give us grace so to follow in their steps; that with them we may be partakers of thy heavenly kingdom; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 5,
        month: 2,
        title: "Saint Agatha",
        subtitle: "Virgin and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who among the manifold works of thine almighty power hast bestowed even upon the gentleness of women strength to win the victory of martyrdom: grant, we beseech thee; that we, who on this day recall the heavenly birth of Saint Agatha, thy Virgin and Martyr, may so follow in her footsteps, that we may likewise attain unto thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 6,
        month: 2,
        title: "Saint Paul Miki and Companions",
        subtitle: "Martyrs",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, the strength of all the Saints, who through the Cross wast pleased to call the Martyrs Saint Paul Miki and Companions to everlasting life: grant, we pray; that by their intercession we may hold with courage to the faith that we profess, even unto death; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 8,
        month: 2,
        title: "Saint Jerome Emiliani",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, the Father of mercies, who didst raise up Saint Jerome Emiliani to be a defender and father of the fatherless: vouchsafe, through his merits and intercession; that we may faithfully guard thy spirit of adoption, whereby we are called and are indeed thy children; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Educator"
        ]
    },
    {
        day: 8,
        month: 2,
        title: "Saint Josephine Bakhita",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst lead Saint Josephine Bakhita from abject slavery to the dignity of being thy daughter and a bride of Christ: grant, we pray; that by her example we may show constant love for the Lord Jesus crucified, remaining steadfast in charity and prompt to show compassion; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin"
        ]
    },
    {
        day: 9,
        month: 2,
        title: "Saint Teilo",
        subtitle: "Bishop",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, by whose grace the Bishop Saint Teilo taught thy Church with simplicity and sustained her in adversity by his prayers: grant her, we pray thee, in our own day, through his intercession and example, guidance and consolation; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 10,
        month: 2,
        title: "Saint Scholastica",
        subtitle: "Virgin",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who for a testimony to the path of innocency didst cause the soul of blessed Scholastica, thy Virgin, to enter heaven in the appearance of a dove: grant unto us; that by her merits and intercession, we may walk in such innocency of life; that we may be worthy to attain to everlasting felicity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin",
            "Abbot or Abbess"
        ]
    },
    {
        day: 11,
        month: 2,
        title: "Our Lady of Lourdes",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who by the Immaculate Conception of the Blessed Virgin Mary didst consecrate a dwelling-place meet for thy Son: we humbly pray thee; that we, celebrating the apparition of the same Blessed Virgin, may obtain thy healing, both in body and soul; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 14,
        month: 2,
        title: "Saints Cyril, Monk, and Methodius, Bishop",
        shortTitle: "Saints Cyril and Methodius",
        patronNote: "Patrons of Europe",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty and everlasting God, we thank thee for thy servants Cyril and Methodius, whom thou didst call to preach the Gospel to the Slavic peoples: raise up, we pray thee, in this and every land, heralds and evangelists of thy kingdom; that thy Church may make known the unsearchable riches of Christ, and may increase with the increase of God; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary"
        ]
    },
    {
        day: 14,
        month: 2,
        title: "Saints Cyril, Monk, and Methodius, Bishop",
        shortTitle: "Saints Cyril and Methodius",
        patronNote: "Patrons of Europe",
        type: "feast",
        regionNote: "Britain",
        rank: 7,
        optional: false,
        collect: "Almighty and everlasting God, we thank thee for thy servants Cyril and Methodius, whom thou didst call to preach the Gospel to the Slavic peoples: raise up, we pray thee, in this and every land, heralds and evangelists of thy kingdom; that thy Church may make known the unsearchable riches of Christ, and may increase with the increase of God; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary"
        ]
    },
    {
        day: 17,
        month: 2,
        title: "The Seven Holy Founders of the Servite Order",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Lord Jesus Christ, who for the remembrance of the sorrows of thy most holy Mother didst by the seven blessed Fathers enrich thy Church with a new household of her servants: mercifully grant that we may in such wise be joined to them in their sorrowing; that we may be made worthy to be partakers of their gladness; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 21,
        month: 2,
        title: "Saint Peter Damian",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, Almighty God: that we may so follow the teaching and examples of thy blessed Confessor Saint Peter Damian; that learning of him to despise all things earthly, we may attain in the end to everlasting felicity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor peter damian"
        }
    },
    {
        day: 23,
        month: 2,
        title: "Saint Polycarp",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Fulfil, O Lord, the petitions of thy servants who on this day devoutly reverence the passion of blessed Polycarp, thy Martyr and Bishop: and accept us, together with him, as a whole burnt-offering dedicated unto thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop"
        ]
    },
    {
        day: 27,
        month: 2,
        title: "Saint Gregory of Narek",
        subtitle: "Abbot and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, O Lord, that the prayers of thy holy Abbot, blessed Gregory of Narek, may commend us unto thee: that we, who have no power of ourselves to help ourselves, may by his advocacy find favour in thy sight; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "O God, who to the blessed Abbot Gregory of Narek gavest grace to imitate Christ in his poverty, and with humble heart to follow him to the end: grant that all who enter the path of Gospel perfection may neither look back nor go astray from the way; but hastening to thee without stumbling, may attain the crown of eternal life where unto thou dost call them; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "O God, by whose providence blessed Gregory of Narek was sent to guide thy people in the way of everlasting salvation: grant, we beseech thee; as we on earth have learned of him the doctrine of life, so we may be found worthy to have him for our advocate in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "Doctor of the Church",
            "Abbot or Abbess"
        ],
        supplements: {
            ep2MagId: "doctor gregory"
        }
    },
    {
        day: 1,
        month: 3,
        title: "Saint David",
        subtitle: "Bishop",
        patronNote: "Patron of Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Almighty God, who in thy providence didst choose thy servant David to be an apostle to the people of Wales, to bring those who were wandering in darkness and error to the true light and knowledge of thee: grant us, by his intercession, so to walk in that light; that we may come at last to the light of everlasting life through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 1,
        month: 3,
        title: "Saint David",
        subtitle: "Bishop",
        patronNote: "Patron of Wales",
        regionNote: "Britain",
        type: "feast",
        feastHasFirstEvensong: false,
        rank: 7,
        optional: false,
        collect: "O Almighty God, who in thy providence didst choose thy servant David to be an apostle to the people of Wales, to bring those who were wandering in darkness and error to the true light and knowledge of thee: grant us, by his intercession, so to walk in that light; that we may come at last to the light of everlasting life through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 1,
        month: 3,
        title: "Saint David",
        subtitle: "Bishop",
        patronNote: "Patron of Wales",
        regionNote: "Wales",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "O Almighty God, who in thy providence didst choose thy servant David to be an apostle to the people of Wales, to bring those who were wandering in darkness and error to the true light and knowledge of thee: grant us, by his intercession, so to walk in that light; that we may come at last to the light of everlasting life through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ],
        supplements: {
            ep1ProperPsalms: [
                "110",
                "112",
                "113",
                "132"
            ],
            mpProperPsalms: [
                "1",
                "2",
                "8"
            ],
            ep2ProperPsalms: [
                "110",
                "112",
                "113",
                "132"
            ],
            properPsalmsOptional: true
        }
    },
    {
        day: 4,
        month: 3,
        title: "Saint Casimir",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who, amidst the pleasures of a temporal kingdom, didst endue thy blessed Saint Casimir with constancy to resist all temptations: grant, we beseech thee; that by his intercession; thy faithful people may learn to despise all things earthly, and to seek earnestly after all things heavenly; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Holy Man"
        ]
    },
    {
        day: 5,
        month: 3,
        title: "Saint Piran",
        subtitle: "Abbot",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, O Lord, that the prayers of thy holy Abbot, blessed Piran, may commend us unto thee: that we, who have no power of ourselves to help ourselves, may by his by his advocacy find favour in thy Son our Lord, who liveth and reigneth with thee, in the u ever of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "O God, who to the blessed Abbot Piran gavest grace to imitate Christ in his poverty, and with humble heart to follow him to the end: grant that all who enter the path of Gospel perfection may neither look back nor go astray from the way; but hastening to thee without stumbling, may attain the crown of eternal life whereunto thou dost call them; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 7,
        month: 3,
        title: "Saints Perpetua and Felicitas",
        subtitle: "Martyrs",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O holy God, who gavest great courage to Saints Perpetua, Felicitas and their Companions: grant that, through their prayers, we may be worthy to climb the ladder of sacrifice, and be received into the garden of peace; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 8,
        month: 3,
        title: "Saint John of God",
        subtitle: "Religious",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst cause blessed John, by the fire of thy love, to pass unhurt amid the flames, and through him didst enrich thy Church with a new offspring: grant, by the pleading of his merits; that our vices be may healed by the fire of thy charity, and that we may obtain thine eternal healing; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one. God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 9,
        month: 3,
        title: "Saint Frances of Rome",
        subtitle: "Religious",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who amongst other gifts of thy grace, didst honour blessed Frances, thy handmaid, with the familiar converse of an Angel: grant, we beseech thee; that by the help of her intercession, we may be worthy to attain unto the fellowship of the Angels in thy heavenly kingdom; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Matron or Holy Woman",
            "Abbot or Abbess"
        ],
        supplements: {
            invId: "frances of rome inv"
        }
    },
    {
        day: 17,
        month: 3,
        title: "Saint Patrick",
        subtitle: "Bishop",
        patronNote: "Patron of Ireland",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Almighty God, who in thy providence didst choose thy servant Patrick k to be an be an apostle to the people of Ireland, to bring those who were wandering in darkness and error to the true light and knowledge of thee: grant us, by his intercession, so to walk in that light; that we may come at last to the light of everlasting life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 17,
        month: 3,
        title: "Saint Patrick",
        subtitle: "Bishop",
        patronNote: "Patron of Ireland",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O Almighty God, who in thy providence didst choose thy servant Patrick k to be an be an apostle to the people of Ireland, to bring those who were wandering in darkness and error to the true light and knowledge of thee: grant us, by his intercession, so to walk in that light; that we may come at last to the light of everlasting life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 17,
        month: 3,
        title: "Saint Patrick",
        subtitle: "Bishop",
        patronNote: "Patron of Ireland",
        regionNote: "Australia",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "O Almighty God, who in thy providence didst choose thy servant Patrick k to be an be an apostle to the people of Ireland, to bring those who were wandering in darkness and error to the true light and knowledge of thee: grant us, by his intercession, so to walk in that light; that we may come at last to the light of everlasting life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ],
        supplements: {
            ep1ProperPsalms: [
                "110",
                "112",
                "113",
                "132"
            ],
            mpProperPsalms: [
                "1",
                "2",
                "8"
            ],
            ep2ProperPsalms: [
                "110",
                "112",
                "113",
                "132"
            ],
            properPsalmsOptional: true
        }
    },
    {
        day: 18,
        month: 3,
        title: "Saint Cyril of Jerusalem",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, Almighty God: that at the intercession of thy blessed Bishop Saint Cyril, we may learn to know thee, the only true God, and Jesus Christ, whom thou hast sent; that we may be found worthy to be numbered for ever among the sheep that hear his voice; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor cyril"
        }
    },
    {
        day: 19,
        month: 3,
        title: "Saint Joseph",
        subtitle: "Spouse of the Blessed Virgin Mary",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "O God, who from the house of thy servant David didst raise up Saint Joseph to be the guardian of thine incarnate Son, and spouse of his Virgin Mother: give us grace to imitate his uprightness of life and his obedience to thy commands; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "let angels chant thy praise",
            ep1VandR: [
                "He made him lord al_so of his house.",
                "And ru_ler of all his sub_stance."
            ],
            ep1MagId: "joseph then joseph being raised",
            invId: "joseph inv",
            mpHymnId: "joseph thou splendour",
            mpVandR: [
                "The mouth of the right_eous is ex_er_cised in wis_dom.",
                "And his tongue will be talk_ing of judge_ment."
            ],
            mpBenId: "joseph jesus himself",
            ep2HymnId: "let angels chant thy praise",
            ep2VandR: [
                "Rich_es and plen_teous_ness shall be in his house.",
                "And his righ_teous_ness re_main_eth for e_ver."
            ],
            ep2MagId: "joseph behold a faithful"
        }
    },
    {
        day: 23,
        month: 3,
        title: "Saint Turibius de Mogrovejo",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who gavest increase to thy Church through the apostolic labours and zeal for truth of the Bishop Saint Turibius: grant that the people consecrated to thee may always receive new growth in faith and holiness; through Jesus Christ thy Son our Lord, who liveth and reigneth thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 25,
        month: 3,
        title: "The Annunciation of the Lord",
        subtitle: "",
        type: "solemnity",
        rank: 3,
        optional: false,
        commonlyCalled: "Lady Day",
        collect: "We beseech thee, O Lord, pour thy grace into our hearts: that, as we have known the Incarnation of thy Son Jesus Christ by the message of an Angel; so by his Cross and Passion we may be brought unto the glory of his Resurrection; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ],
        supplements: {
            ep1VandR: [
                "Hail, Ma_ry, full of grace.",
                "Be it un_to me ac_cord_ing to thy word."
            ],
            ep1MagId: "annunciation the holy ghost",
            invId: "annunciation inv",
            mpVandR: [
                "Hail, Ma_ry, full of grace.",
                "Be it un_to me ac_cord_ing to thy word."
            ],
            mpBenId: "annunciation how shall this be",
            ep2VandR: [
                "Hail, Ma_ry, full of grace.",
                "Be it un_to me ac_cord_ing to thy word."
            ],
            ep2MagId: "annunciation the angel gabriel"
        }
    },
    {
        day: 2,
        month: 4,
        title: "Saint Francis of Paola",
        subtitle: "Hermit",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who, by exalting the humble, didst raise the blessed Confessor Francis to the glory of thy Saints: grant, we beseech thee; that, through his merits and example, we may attain with gladness unto the rewards promised to them that are lowly of heart; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 4,
        month: 4,
        title: "Saint Isidore",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, by whose providence blessed Isidore was sent to guide thy people in the way of everlasting salvation: grant, we beseech thee; that as we have learned of him the doctrine of life on earth, so we may be found worthy to have him for our advocate in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor isidore"
        }
    },
    {
        day: 5,
        month: 4,
        title: "Saint Vincent Ferrer",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst vouchsafe to illumine thy Church by the merits and preaching of blessed Vincent thy Confessor: grant to us thy servants; that we may both be instructed by his example, and by his advocacy be delivered from all adversities; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary"
        ]
    },
    {
        day: 7,
        month: 4,
        title: "Saint John Baptist de la Salle",
        subtitle: "Priest",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who for the Christian education of the poor, and for the confirmation of the young in the way of truth, didst raise up the holy Confessor John Baptist de la Salle, and through him didst gather a new family in the Church: graciously grant that by his intercession and example we, being kindled with zeal for thy glory in the salvation of souls, may be enabled to be made partakers of his crown in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Educator"
        ]
    },
    {
        day: 11,
        month: 4,
        title: "Saint Stanislaus",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, for whose honour the glorious Bishop Stanislaus was slain by the swords of wicked men: grant, we beseech thee; that all who call upon him for succour, may obtain the saving effect of their petition; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Pope or Bishop"
        ]
    },
    {
        day: 13,
        month: 4,
        title: "Saint Martin I",
        subtitle: "Pope and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Everlasting Shepherd, favourably look upon thy flock: and keep it with perpetual protection through the prayers of blessed Martin, thy Martyr and Supreme Pontiff, whom thou didst appoint to be shepherd of the whole Church; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Pope or Bishop",
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 16,
        month: 4,
        title: "Saint Magnus of Orkney",
        subtitle: "Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Protect us, O Lord, by the glorious merits of Saint Magnus thy Martyr: and may we, proclaiming the works of thy majesty therein, likewise obtain thy succour both in this world, and in that which is to come; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 19,
        month: 4,
        title: "Saint Alphege",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst adorn blessed Alphege, most devout Confessor of thy Name, with the dignity of the priesthood and the palm of martyrdom: mercifully grant that we may so be aided by his intercession before thee; that we that we may be enabled to rejoice with him in eternal felicity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Pope or Bishop"
        ]
    },
    {
        day: 20,
        month: 4,
        title: "Saint Beuno",
        subtitle: "Abbot",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, O Lord, we pray thee: that by the intercession of Saint Beuno, thy Church may increase both in wisdom and fidelity to thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 21,
        month: 4,
        title: "Saint Anselm of Canterbury",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O everlasting God, who gavest to thy Bishop Anselm singular gifts as a pastor and teacher: grant that we, like him, may desire thee with our whole heart; and, so desiring, may seek thee and, seeking, may find thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ]
    },
    {
        day: 21,
        month: 4,
        title: "Saint Anselm of Canterbury",
        subtitle: "Bishop and Doctor of the Church",
        regionNote: "Australia",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O everlasting God, who gavest to thy Bishop Anselm singular gifts as a pastor and teacher: grant that we, like him, may desire thee with our whole heart; and, so desiring, may seek thee and, seeking, may find thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ]
    },
    {
        day: 23,
        month: 4,
        title: "Saint George",
        subtitle: "Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God of hosts, who didst so kindle the flame of love in the heart of thy servant George that he bore witness to the risen Lord by his life and by his death: grant us the same power of faith and love; that we, who rejoice in his triumphs, may come to share with him the fulness of the Resurrection; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ],
        supplements: {
            ep1VandR: [
                "With thy lo_ving kind_ness.",
                "Thou hast de_fen_ded him as with a shield."
            ],
            ep1MagId: "st george the saints through faith",
            mpVandR: [
                "With thy lo_ving kind_ness.",
                "Thou hast de_fen_ded him as with a shield."
            ],
            mpBenId: "st george the saints through faith",
            ep2VandR: [
                "With thy lo_ving kind_ness.",
                "Thou hast de_fen_ded him as with a shield."
            ],
            ep2MagId: "st george the saints through faith"
        }
    },
    {
        day: 23,
        month: 4,
        title: "Saint George",
        subtitle: "Martyr",
        patronNote: "Patron of England",
        regionNote: "England",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "O God of hosts, who didst so kindle the flame of love in the heart of thy servant George that he bore witness to the risen Lord by his life and by his death: grant us the same power of faith and love; that we, who rejoice in his triumphs, may come to share with him the fulness of the Resurrection; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ],
        supplements: {
            ep1VandR: [
                "With thy lo_ving kind_ness.",
                "Thou hast de_fen_ded him as with a shield."
            ],
            ep1MagId: "st george the saints through faith",
            mpVandR: [
                "With thy lo_ving kind_ness.",
                "Thou hast de_fen_ded him as with a shield."
            ],
            mpBenId: "st george the saints through faith",
            ep2VandR: [
                "With thy lo_ving kind_ness.",
                "Thou hast de_fen_ded him as with a shield."
            ],
            ep2MagId: "st george the saints through faith"
        },
        properPsalmsOptional: true
    },
    {
        day: 24,
        month: 4,
        title: "Saint Fidelis of Sigmaringen",
        subtitle: "Priest and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst enkindle blessed Fidelis with seraphic ardour of spirit in the propagation of the true Faith, and didst vouchsafe to adorn him with the palm of martyrdom, and with glorious miracles: we beseech thee; that, by his merits and intercession, thou wouldest so confirm us through thy grace in faith and charity; that in thy service we may be worthy to be found faithful, even unto death; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr",
            "Confessor: Priest"
        ]
    },
    {
        day: 24,
        month: 4,
        title: "Saint Adalbert",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst bestow the crown of martyrdom on the Bishop Saint Adalbert, as he burned with zeal for souls: grant, we pray, by his prayers; that the obedience of the flock may never fail the shepherds, nor the care of the shepherds be ever lacking to the flock; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 24,
        month: 4,
        title: "Saint Mellitus",
        subtitle: "Bishop",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "We beseech thee, O Lord, graciously hear the prayers we offer unto thee on the festival of blessed Mellitus, thy Confessor and Bishop: that, as he was found worthy to do thee fitting service; so by his interceding merits we may be absolved from all our sins; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 25,
        month: 4,
        title: "Saint Mark",
        subtitle: "Evangelist",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "O Almighty God, who hast instructed thy holy Church with the heavenly doctrine of thy Evangelist Saint Mark: give us grace; that, being not like children carried away with every blast of vain doctrine, we may be established in the truth of thy holy Gospel; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Apostles"
        ]
    },
    {
        day: 25,
        month: 4,
        title: "ANZAC Day",
        regionNote: "Australia",
        type: "misc",
        rank: 7,
        optional: false,
        collect: "O Lord our God, whose Name only is excellent and thy praise above heaven and earth: we thank thee for all those who counted not their lives dear unto themselves but laid them down for their friends; grant us, we beseech thee, that having them always in remembrance we may imitate their faithfulness and sacrifice; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        propersOfTheFeria: true
    },
    {
        day: 26,
        month: 4,
        title: "Saint Mark",
        subtitle: "Evangelist",
        regionNote: "Australia",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "O Almighty God, who hast instructed thy holy Church with the heavenly doctrine of thy Evangelist Saint Mark: give us grace; that, being not like children carried away with every blast of vain doctrine, we may be established in the truth of thy holy Gospel; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Apostles"
        ]
    },
    {
        day: 27,
        month: 4,
        title: "Saint Louis Grignion de Montfort",
        regionNote: "Australia",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst will to direct the steps of thy Priest Saint Louis de Montfort along the way of salvation and of the love of Christ, in the company of the Blessed Virgin: grant us, by his example; that, meditating on the mysteries of thy love, we may strive tirelessly for the building up of thy Church; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 28,
        month: 4,
        title: "Saint Peter Chanel",
        subtitle: "Priest and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who for the spreading of thy Church didst crown Saint Peter Chanel with martyrdom: grant that, in these day days of Paschal joy, we may so celebrate the mysteries of Christ's Death and Resurrection as to bear worthy witness to newness of life; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr",
            "Confessor: Missionary"
        ]
    },
    {
        day: 28,
        month: 4,
        title: "Saint Peter Chanel",
        subtitle: "Priest and Martyr",
        regionNote: "Australia",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who for the spreading of thy Church didst crown Saint Peter Chanel with martyrdom: grant that, in these day days of Paschal joy, we may so celebrate the mysteries of Christ's Death and Resurrection as to bear worthy witness to newness of life; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr",
            "Confessor: Missionary"
        ]
    },
    {
        day: 28,
        month: 4,
        title: "Saint Louis Grignion de Montfort",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst will to direct the steps of thy Priest Saint Louis de Montfort along the way of salvation and of the love of Christ, in the company of the Blessed Virgin: grant us, by his example; that, meditating on the mysteries of thy love, we may strive tirelessly for the building up of thy Church; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 29,
        month: 4,
        title: "Saint Catherine of Siena",
        subtitle: "Virgin and Doctor of the Church",
        patronNote: "Patron of Europe",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who gavest to thy servant Saint Catherine of Siena a wondrous love of the Passion of Christ: grant that, through her prayers; we thy people may be united to him in his majesty and rejoice for ever in the revelation of his glory; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Virgin"
        ],
        supplements: {
            ep2MagId: "doctor catherine"
        }
    },
    {
        day: 29,
        month: 4,
        title: "Saint Catherine of Siena",
        subtitle: "Virgin and Doctor of the Church",
        patronNote: "Patron of Europe",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O God, who gavest to thy servant Saint Catherine of Siena a wondrous love of the Passion of Christ: grant that, through her prayers; we thy people may be united to him in his majesty and rejoice for ever in the revelation of his glory; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Virgin"
        ],
        supplements: {
            ep2MagId: "doctor catherine"
        }
    },
    {
        day: 30,
        month: 4,
        title: "Saint Pius V",
        subtitle: "Pope",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who, for the overthrow of the enemies of thy Church and for the restoring of divine worship, wast pleased to choose blessed Pius to be Supreme Pontiff: grant that we may be defended by his protection, and so cleave to thy service; that overcoming the devices of all our enemies, we may rejoice in perpetual peace; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 1,
        month: 5,
        title: "Saint Joseph the Worker",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, the Creator of all things, who hast appointed for mankind the law of labour: graciously grant that through the example and patronage of Saint Joseph we may accomplish the work that thou hast commanded, and attain unto the rewards that thou dost promise; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            // No EP1 when this is a memorial
            ep1HymnId: "let angels chant thy praise",
            ep1VandR: [
                "He made him lord al_so of his house.",
                "And ru_ler of all his sub_stance."
            ],
            ep1MagId: "joseph then joseph being raised",
            invId: "joseph inv",
            mpHymnId: "joseph thou splendour",
            mpVandR: [
                "The mouth of the right_eous is ex_er_cised in wis_dom.",
                "And his tongue will be talk_ing of judge_ment."
            ],
            mpBenId: "joseph jesus himself",
            ep2HymnId: "let angels chant thy praise",
            ep2VandR: [
                "Rich_es and plen_teous_ness shall be in his house.",
                "And his righ_teous_ness re_main_eth for e_ver."
            ],
            ep2MagId: "joseph behold a faithful"
        }
    },
    {
        day: 2,
        month: 5,
        title: "Saint Athanasius",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Everliving God, whose servant Saint Athanasius bore witness to the mystery of the Word made flesh for our salvation: give us grace, with thy Saints, to contend for the truth and to grow into the likeness of thy Son Jesus Christ our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor athanasius"
        }
    },
    {
        day: 3,
        month: 5,
        title: "Saints Philip and James",
        subtitle: "Apostles",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "O Almighty God, whom truly to know is everlasting life: grant us perfectly to know thy Son Jesus Christ to be the way, the truth and the life; that, following the steps of thy holy Apostles Saint Philip and Saint James, we may steadfastly walk in the way that leadeth to eternal life; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Apostles"
        ],
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear sts philip and james"
        }
    },
    {
        day: 4,
        month: 5,
        title: "The English Martyrs",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O merciful God, who, when thy Church on earth was torn apart by the ravages of sin, didst raise up men and women in England who witnessed to their faith with courage and constancy: give unto thy Church that peace which is thy will, and grant that those who have been divided on earth may be reconciled in heaven and be partakers together in the vision of thy glory; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 4,
        month: 5,
        title: "The English Martyrs",
        subtitle: "",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O merciful God, who, when thy Church on earth was torn apart by the ravages of sin, didst raise up men and women in England who witnessed to their faith with courage and constancy: give unto thy Church that peace which is thy will, and grant that those who have been divided on earth may be reconciled in heaven and be partakers together in the vision of thy glory; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 5,
        month: 5,
        title: "Saint Asaph",
        subtitle: "Bishop",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, O Lord, we pray thee: that, as Saint Asaph made an offering of perpetual praise in thy Church; so through his intercession thou mayest sustain us in devoted service of thy Name; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 6,
        month: 5,
        title: "Saint John the Apostle in Eastertide",
        subtitle: "",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who with the oil of gladness didst anoint blessed John a companions in the tribulation and patience of the Lord Jesus: grant us likewise so to rejoice in the fellowship of Christ's sufferings; that when his glory shall be revealed, we may be glad with exceeding joy; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Apostles"
        ],
        supplements: {
            mpHymnId: "beloved disciple of thy lord",
            ep2MagId: "jaiet john the"
        }
    },
    {
        day: 10,
        month: 5,
        title: "Saint John of Avila",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who willest to be glorified in thy Saints, and didst raise up thy servant John of Avila to shine as a light in the world: shine, we pray thee, in our hearts; that aided by his prayers we also in our generation may show forth thy praises, who hast called us out of darkness into thy marvellous light; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "O God, who makest us glad with the yearly feast of blessed John of Avila, thy Priest and Confessor: mercifully grant that, as we now observe his heavenly birthday; so we may follow him in all virtuous and godly living; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "O God, by whose providence blessed John of Avila was sent to guide thy people in the way of everlasting salvation: grant, we beseech thee; as we on earth have learned of him the doctrine of life, so we may be found worthy to have him for our advocate in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "Doctor of the Church",
            "Confessor: Priest"
        ],
        supplements: {
            ep2MagId: "doctor john"
        }
    },
    {
        day: 12,
        month: 5,
        title: "Saints Nereus and Achilleus",
        subtitle: "Martyrs",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, O Lord, that this holy festival of thy blessed Martyrs Nereus and Achilleus, may ever assist us in thy service: and that we may thereby be rendered worthy to walk after thy commandments; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 12,
        month: 5,
        title: "Saint Pancras",
        subtitle: "Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "May thy Church rejoice, O God, confident in the intercession of the Martyr Saint Pancras and by his glorious prayers may she persevere in devotion to thee and stand ever firm; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 13,
        month: 5,
        title: "Our Lady of Fatima",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst choose the Mother of thy Son to be our Mother also: grant us that, persevering in penance and prayer for the salvation of the world, we may further more effectively each day the reign of Christ; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 14,
        month: 5,
        title: "Saint Matthias",
        subtitle: "Apostle",
        type: "feast",
        rank: 7,
        optional: false,
        feastHasFirstEvensong: true,
        collect: "O Almighty God, who into the place of the traitor Judas didst choose thy faithful servant Matthias to be of the number of the twelve Apostles: grant that thy Church, being always preserved from false Apostles, may be ordered and guided by faithful and true pastors; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        athanasianCreed: true,
        commons: [
            "Apostles"
        ],
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear st matthias"
        }
    },
    {
        day: 18,
        month: 5,
        title: "Saint John I",
        subtitle: "Pope and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O everlasting Shepherd, mercifully look upon thy flock: and through blessed John, thy Martyr and Supreme Pontiff, whom thou didst appoint to be shepherd of the whole Church, keep her with thy perpetual protection; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Pope or Bishop",
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 19,
        month: 5,
        title: "Saint Dunstan",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who dost ever hallow and protect thy Church: raise up therein through Spirit good and faithful stewards of the mysteries of Christ, as thou didst in thy Bishop Dunstan; that by their ministry and example, thy people may abide in thy favour and walk in the way of truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 20,
        month: 5,
        title: "Saint Bernardine of Siena",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Lord Jesus Christ, who didst endue blessed Bernardine, thy Confessor, with pre-eminent love of thy most holy Name: we beseech thee; that, by the virtue of his merits and intercession, thou wouldest graciously pour into our hearts the spirit of love who livest and reignest with the Father in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary",
            "Religious"
        ]
    },
    {
        day: 21,
        month: 5,
        title: "Saint Christopher Magallanes, Priest, and Companions, Martyrs",
        shortTitle: "Saint Christopher Magallanes and Companions",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty and eternal God, who madest Saint Christopher Magallanes and his Companions faithful to Christ the King even unto martyrdom: grant us, through their intercession; that, persevering in confession of the true faith, we may always hold fast to the commandments of thy love; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 21,
        month: 5,
        title: "Saint Godric of Finchale",
        subtitle: "Religious",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, our heavenly Father: we remember before thee all thy servants who have served thee faithfully in their generation, and have entered into rest, especially Godric of Finchale, beseeching thee to give us grace so to follow in their steps; that with them we may be partakers of thy heavenly kingdom; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 21,
        month: 5,
        title: "Saint Helena",
        subtitle: "",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Lord Jesus Christ, who didst reveal to blessed Helena the place where thy Cross lay hid, that through her, thou mightest enrich thy Church with this precious treasure: grant unto us at her intercession; that by the ransom of the life-giving Tree we may attain unto the rewards of eternal life; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Matron or Holy Woman"
        ],
        supplements: {
            invId: "helena inv"
        }
    },
    {
        day: 22,
        month: 5,
        title: "Saint Rita of Cascia",
        subtitle: "Religious",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Bestow upon us, we pray, O Lord, the wisdom and strength of the Cross, with which thou wert pleased to endow Saint Rita: so that, suffering in every tribulation with Christ, we may participate ever more deeply in his Paschal Mystery; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 23,
        month: 5,
        title: "Saint Petroc",
        subtitle: "Abbot",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, O Lord that the prayers of thy holy Abbot, blessed Petroc, may commend us unto thee: that we, who have no power of ourselves to help ourselves, may by his advocacy find favour in thy sight; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "O God, who to the blessed Abbot Petroc gavest grace to imitate Christ in his poverty, and with humble heart to follow him to the end: grant that all who enter the path of Gospel perfection may neither look back nor go astray from the way; but hastening to thee without stumbling, may attain the crown of eternal life whereunto thou dost call them; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 24,
        month: 5,
        title: "Our Lady, Help of Christians",
        regionNote: "Australia",
        patronNote: "Patron of Australia",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "Almighty and merciful God, who for the defence of the Christian people didst in the most Blessed Virgin Mary wondrously establish a perpetual help: graciously grant that we, being strengthened by her sure protection, as we strive in life, may in death have strength to win the victory over the malicious enemy; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "oft times when hemmed around by hostile arms",
            ep1VandR: [
                "Grant that I may praise thee, Ho_ly Vir_gin.",
                "Give me strength a_gainst thy e_ne_mies."
            ],
            ep1MagId: "olhoc behold mary",
            invId: "bvm inv",
            mpHymnId: "mother of our lord and saviour",
            mpVandR: [
                "Grace is poured out u_pon thy lips.",
                "There_fore God hath blessed thee for_e_ver."
            ],
            mpBenId: "olhoc to thee we cried",
            ep2HymnId: "oft times when hemmed around by hostile arms",
            ep2VandR: [
                "Grant that I may praise thee, Ho_ly Vir_gin.",
                "Give me strength a_gainst thy e_ne_mies."
            ],
            ep2MagId: "olhoc holy mary help"
        }
    },
    {
        day: 24,
        month: 5,
        title: "Saint Aldhelm",
        subtitle: "Bishop",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who as on this day didst exalt thy blessed Bishop Saint Aldhelm to everlasting felicity: we pray thee; that by his merits and intercession, thy mercy may bring us unto that place whither he is gone before; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 25,
        month: 5,
        title: "Saint Bede the Venerable",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who hast caused thy Church to shine with the learning of blessed Bede, thy Confessor and Doctor: mercifully grant that we thy servants may ever be enlightened by his wisdom, and holpen for his merits' sake; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Religious"
        ],
        supplements: {
            ep2MagId: "doctor bede"
        }
    },
    {
        day: 25,
        month: 5,
        title: "Saint Bede the Venerable",
        subtitle: "Priest and Doctor of the Church",
        regionNote: "Britain",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who hast caused thy Church to shine with the learning of blessed Bede, thy Confessor and Doctor: mercifully grant that we thy servants may ever be enlightened by his wisdom, and holpen for his merits' sake; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Religious"
        ],
        supplements: {
            ep2MagId: "doctor bede"
        }
    },
    {
        day: 25,
        month: 5,
        title: "Saint Gregory VII",
        subtitle: "Pope",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, the strength of them that put their trust in thee, who didst stablish thy blessed Confessor and Pope Gregory the Seventh with the strength of constancy to defend the freedom of thy Church: grant, we pray thee; that by his prayers and good example, we may valiantly conquer all things contrary to our salvation; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 25,
        month: 5,
        title: "Saint Mary Magdalene de' Pazzi",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, lover of virginity, who didst adorn with heavenly gifts the Virgin Saint Mary Magdalene de' Pazzi, setting her on fire with thy love: grant, we pray; that we, who honour her today, may imitate her example of purity and love; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin",
            "Religious"
        ]
    },
    {
        day: 26,
        month: 5,
        title: "Saint Philip Neri",
        subtitle: "Priest",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst exalt thy blessed Confessor Philip to the glory of thy Saints: mercifully grant that we, who rejoice in his festival, may learn to follow example of his virtues; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 27,
        month: 5,
        title: "Saint Augustine of Canterbury",
        subtitle: "Bishop",
        patronNote: "Patron of the Ordinariate of Our Lady of the Southern Cross",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who by the preaching and miracles of blessed Augustine, thy Confessor and Bishop, had enlightened the English people with the light of the true faith: mercifully grant that by his intercession the hearts of them that have gone astray may return to the unity of thy truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 27,
        month: 5,
        title: "Saint Augustine of Canterbury",
        subtitle: "Bishop",
        patronNote: "Patron of the Ordinariate of Our Lady of the Southern Cross",
        type: "feast",
        rank: 7,
        optional: false,
        regionNote: "Australia, Britain",
        collect: "O God, who by the preaching and miracles of blessed Augustine, thy Confessor and Bishop, had enlightened the English people with the light of the true faith: mercifully grant that by his intercession the hearts of them that have gone astray may return to the unity of thy truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 28,
        month: 5,
        title: "Saint Gregory VII",
        subtitle: "Pope",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, the strength of them that put their trust in thee, who didst stablish thy blessed Confessor and Pope Gregory the Seventh with the strength of constancy to defend the freedom of thy Church: grant, we pray thee; that by his prayers and good example, we may valiantly conquer all things contrary to our salvation; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ],
        regionNote: "Britain"
    },
    {
        day: 28,
        month: 5,
        title: "Saint Mary Magdalene de' Pazzi",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, lover of virginity, who didst adorn with heavenly gifts the Virgin Saint Mary Magdalene de' Pazzi, setting her on fire with thy love: grant, we pray; that we, who honour her today, may imitate her example of purity and love; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin",
            "Religious"
        ],
        regionNote: "Britain"
    },
    {
        day: 29,
        month: 5,
        title: "Saint Paul VI",
        subtitle: "Pope",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O everlasting Shepherd, mercifully look upon thy flock: and through the intercession of blessed Paul the Sixth thy Supreme Pontiff, whom thou didst appoint to be shepherd of the whole Church, keep her with thy perpetual protection; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 31,
        month: 5,
        title: "The Visitation of the Blessed Virgin Mary",
        subtitle: "",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "O God, who didst lead the Blessed Virgin Mary to visit Elizabeth, to their exceeding joy and comfort: grant unto thy people; that as Mary did rejoice to be called the Mother of the Lord, so we may ever rejoice to believe the Incarnation of thine Only Begotten Son; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "now in holy celebration",
            ep1VandR: [
                "Bless_ed art thou a_mong wo_men.",
                "And bless_ed is the fruit of thy womb."
            ],
            ep1MagId: "visit blessed art thou",
            invId: "visit inv",
            mpHymnId: "portal of the worlds salvation",
            mpVandR: [
                "Bless_ed art thou a_mong wo_men.",
                "And bless_ed is the fruit of thy womb."
            ],
            mpBenId: "visit when elizabeth",
            ep2HymnId: "now in holy celebration",
            ep2VandR: [
                "Bless_ed art thou a_mong wo_men.",
                "And bless_ed is the fruit of thy womb."
            ],
            ep2MagId: "visit all generations"
        }
    },
    {
        day: 1,
        month: 6,
        title: "Saint Justin",
        subtitle: "Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who through the foolishness of the Cross didst wondrously teach blessed Justin Martyr the excellent knowledge of Jesus Christ: grant to us by his intercession; that, driving away the errors that beset us, we may attain unto steadfastness of faith; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 2,
        month: 6,
        title: "Saints Marcellinus and Peter",
        subtitle: "Martyrs",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who makest us glad with the yearly festival of thy Martyrs Marcellinus and Peter: grant, we beseech thee; that as we do rejoice in their merits, so we may be enkindled to follow them in all virtuous and godly living; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 3,
        month: 6,
        title: "Saint Charles Lwanga and Companions",
        subtitle: "Martyrs",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who hast made the blood of Martyrs to be the seed of Christians: mercifully grant that the field which is thy Church, watered with the blood shed by Saints Charles Lwanga and his Companions, may be fertile and always yield thee an abundant harvest; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 5,
        month: 6,
        title: "Saint Boniface",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who raised up the holy Bishop and Martyr Saint Boniface from the English nation enlighten many peoples with the Gospel of Christ: grant, we pray; that we may hold fast in our hearts that faith which he taught with his lips and sealed with his blood; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 6,
        month: 6,
        title: "Saint Norbert",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: 'O God, who didst make blessed Norbert, thy Confessor and Bishop, an illustrious preacher of thy Word, and through him didst render thy Church fruitful with a new offspring: grant, we beseech thee; that by his intercession and merits, we may be enabled by thy help to practise what he taught, both in word and deed; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God," without end. Amen.',
        commons: [
            "Confessor: Bishop",
            "Religious"
        ]
    },
    {
        day: 9,
        month: 6,
        title: "Saint Ephrem",
        subtitle: "Deacon and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst will to illumine thy Church with the wondrous learning and splendid merits of blessed Ephrem, thy Confessor and Doctor: we humbly beseech thee, at his intercession; that thou wouldest ever defend her by thy continual power against the snares of error and wickedness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church"
        ],
        supplements: {
            ep2MagId: "doctor ephrem"
        }
    },
    {
        day: 9,
        month: 6,
        title: "Saint Columba",
        subtitle: "Abbot",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "We pray thee, O Lord, inspire our hearts with the desire of heavenly glory: and grant that we, bringing our sheaves with us, may hither attain where the holy Abbot Columba shineth like a star before thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 11,
        month: 6,
        title: "Saint Barnabas",
        subtitle: "Apostle",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O Lord God Almighty, who didst endue thy holy Apostle Barnabas with singular gifts of the Holy Spirit: leave us not, we beseech thee, destitute of thy manifold gifts, nor yet of grace to use them always to thy honour and glory; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Apostles"
        ]
    },
    {
        day: 13,
        month: 6,
        title: "Saint Anthony of Padua",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Grant, O Lord, that the solemn festival of thy holy Confessor Saint Anthony may bring gladness to thy Church: that being defended by thy succour in all things spiritual, we may be found worthy to attain to everlasting felicity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Priest"
        ],
        supplements: {
            ep2MagId: "doctor anthony"
        }
    },
    {
        day: 16,
        month: 6,
        title: "Saint Richard of Chichester",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Most merciful Redeemer, who gavest to thy Bishop Richard a love of learning, a zeal for souls, and a devotion to the poor: grant that, encouraged by his example, and aided by his prayers, we may know thee more clearly, love thee more dearly, and follow thee more nearly, day by day; who livest and reignest with the Father in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 19,
        month: 6,
        title: "Saint Romuald",
        subtitle: "Abbot",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who through Saint Romuald didst renew the manner of life of hermits in thy Church: grant, we beseech thee; that, denying ourselves and following Christ, we may merit to reach the heavenly realms on high; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 20,
        month: 6,
        title: "Saint Alban",
        subtitle: "Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Eternal Father, who, when the Gospel of Christ first came to England, didst gloriously confirm the faith of Alban by making him the first to win the martyr's crown: grant that, assisted by his prayers and following his example in the fellowship of the Saints, we may worship thee, the living God, and faithfully witness to Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 20,
        month: 6,
        title: "Saints Alban, Julius and Aaron",
        subtitle: "Protomartyrs of Britain",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, by whose grace Saints Alban, Julius, and Aaron received the martyr's crown, as the first in this land to shed their blood for Christ: grant, we pray thee; that, following their example and supported by their prayers, we may worship thee, the living God, and give true witness to Christ our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 21,
        month: 6,
        title: "Saint Aloysius Gonzaga",
        subtitle: "Religious",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, the giver of all spiritual gifts, who in the angelic youth of thy blessed Saint Aloysius didst unite a wondrous penitence to a wondrous innocence of life: grant, by his merits and intercession; that although we have not followed the pattern of his innocence, yet we may imitate the example of his penitence; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious"
        ]
    },
    {
        day: 22,
        month: 6,
        title: "Saints John Fisher, Bishop, and Thomas More",
        subtitle: "Martyrs",
        shortTitle: "Saints John Fisher and Thomas More",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst raise up amongst the English people thy blessed Martyrs John and Thomas to be defenders of the faith and to witness to the primacy of the Roman Church: grant by their merits and prayers; that in the profession of one faith we may all be made one in Christ, and in him continue to be at one with one another; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 22,
        month: 6,
        title: "Saints John Fisher, Bishop, and Thomas More",
        subtitle: "Martyrs",
        shortTitle: "Saints John Fisher and Thomas More",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O God, who didst raise up amongst the English people thy blessed Martyrs John and Thomas to be defenders of the faith and to witness to the primacy of the Roman Church: grant by their merits and prayers; that in the profession of one faith we may all be made one in Christ, and in him continue to be at one with one another; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 23,
        month: 6,
        title: "Saint Paulinus of Nola",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who to them that forsake all things in this world for thee, hast promised a hundredfold in the world to come: graciously grant that, following in the footsteps of thy holy Bishop Paulinus, we e may be enabled to despise earthly things and to seek only things heavenly; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 23,
        month: 6,
        title: "Saint Etheldreda (Audrey)",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who art the Spouse of virgin souls, the refreshment of the pure in heart, and the salvation of all who love thee: mercifully grant that we, who reverently celebrate the feast of thy blessed virgin Etheldreda, may through her prayers obtain mercy of thy divine majesty; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity Holy Spirit, ever one God, world of the without end. Amen.",
        commons: [
            "Virgin"
        ]
    },
    {
        day: 24,
        month: 6,
        title: "The Nativity of Saint John the Baptist",
        subtitle: "",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "Almighty God, by whose providence thy servant Saint John the Baptist was wonderfully born, and sent to prepare the way of thy Son our Saviour, by preaching of repentance: make us so to follow his doctrine and holy life, that we may truly repent according to his preaching; and after his example constantly speak the truth, boldly rebuke vice, and patiently suffer for the truth's sake; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        athanasianCreed: true,
        supplements: {
            ep1HymnId: "let thine example holy john remind us",
            ep1VandR: [
                "There was a man sent from God.",
                "Whose name was John."
            ],
            ep1MagId: "njb when zacharias",
            invId: "njb inv",
            mpHymnId: "een in thy childhood mid the desert places",
            mpVandR: [
                "This Child shall be great in the sight of the Lord.",
                "For the hand of the Lord is with him."
            ],
            mpBenId: "njb the mouth",
            ep2HymnId: "let thine example holy john remind us",
            ep2VandR: [
                "This Child shall be great in the sight of the Lord.",
                "For the hand of the Lord is with him."
            ],
            ep2MagId: "njb the child"
        }
    },
    {
        day: 27,
        month: 6,
        title: "Saint Cyril of Alexandria",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst strengthen thy blessed Confessor and Bishop Saint Cyril, invincibly to maintain the divine motherhood of the Blessed Virgin Mary: vouchsafe that at his intercession we, believing her to be indeed the Mother of God, may as her children rejoice in her protection; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor cyril"
        }
    },
    {
        day: 28,
        month: 6,
        title: "Saint Irenaeus",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst bestow upon blessed Irenaeus, thy Martyr and Bishop, grace to overcome false doctrine by the teaching of the truth, and to establish thy Church in peace and prosperity: we beseech thee; that thou wouldest give thy people constancy in thy true religion; and grant us thy peace all the days of our life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop",
            "Confessor: Bishop"
        ]
    },
    {
        day: 29,
        month: 6,
        title: "Saints Peter and Paul",
        subtitle: "Apostles",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "O God, who hast hallowed this day by the martyrdom of thine Apostles Peter and Paul: grant unto thy Church, in all things, to follow the precepts of those through whom she received the beginning of religion; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "this holy feast through all the quarters of the world",
            ep1VandR: [
                "Their sound is gone out in_to all lands.",
                "And their words in_to the ends of the world."
            ],
            ep1MagId: "chair of st peter thou art",
            invId: "apostles inv",
            mpHymnId: "with golden splendour and with roseate hues of morn",
            mpVandR: [
                "They de_clared the work of God.",
                "And wise_ly con_si_dered his do_ings."
            ],
            mpBenId: "chair of st peter whatsoever",
            ep2HymnId: "this holy feast through all the quarters of the world",
            ep2VandR: [
                "They de_clared the work of God.",
                "And wise_ly con_si_dered his do_ings."
            ],
            ep2MagId: "peter and paul today"
        }
    },
    {
        day: 30,
        month: 6,
        title: "The First Martyrs of the Holy Roman Church",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst consecrate the abundant first fruits of the Roman Church by the blood of the Martyrs: grant, we beseech thee; that with firm courage we may together draw strength from so great a struggle and ever rejoice at the triumph of faithful love; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 1,
        month: 7,
        title: "Saint Oliver Plunkett",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who for the defence of the Catholic faith didst vouchsafe to endue blessed Oliver, thy Martyr and Bishop, with wondrous strengths of spirit: grant unto us by his intercession and example; that we may imitate his constancy in faith, and in danger perceive his advocacy; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop",
            "Confessor: Bishop"
        ]
    },
    {
        day: 3,
        month: 7,
        title: "Saint Thomas",
        subtitle: "Apostle",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "Almighty and everliving God, who for the greater confirmation of the faith didst suffer thy holy Apostle Thomas to be doubtful in thy Son's Resurrection: grant us so perfectly, and without all doubt, to believe in thy Son Jesus Christ; that our faith in thy sight may never be reproved; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Apostles"
        ],
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear st thomas"
        }
    },
    {
        day: 4,
        month: 7,
        title: "Saint Elizabeth of Portugal",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, the author of peace and lover of charity, who didst adorn Saint Elizabeth of Portugal with a marvellous grace for reconciling those in conflict: grant, through her intercession; that we may become peacemakers, and so be called children of God; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Matron or Holy Woman"
        ],
        supplements: {
            invId: "elizabeth inv"
        }
    },
    {
        day: 5,
        month: 7,
        title: "Saint Anthony Zaccaria",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant us, O Lord God Almighty: that we, being filled with the spirit of thy blessed Apostle Paul, may learns that pre-eminent knowledge of Christ Jesus, whereby thou didst wondrously teach blessed Anthony Mary to establish in thy Church new households of priests and virgins; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious",
            "Educator"
        ]
    },
    {
        day: 6,
        month: 7,
        title: "Saint Maria Goretti",
        subtitle: "Virgin and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, the author of innocence and lover of chastity, who didst bestow the grace of martyrdom on thy handmaid, the Virgin Saint Maria Goretti, in her youth: grant, we pray, through her intercession; that, as thou gavest her a crown for her steadfastness, so we too may be firm in obeying thy commandments; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 7,
        month: 7,
        title: "Blessed Peter To Rot",
        subtitle: "Martyr",
        regionNote: "Australia",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty and everliving God, who dost adorn the Church with the witness of Martyrs: grant us, we beseech thee; that through the intercession of Blessed Peter To Rot, we may be strengthened in faith and constancy, and, like him, be made steadfast in all trials; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr",
            "Educator"
        ]
    },
    {
        day: 9,
        month: 7,
        title: "Saint Augustine Zhao Rong, Priest, and Companions, Martyrs",
        type: "memorial",
        shortTitle: "Saint Augustine Zhao Rong and Companions",
        rank: 12,
        optional: true,
        collect: "O God, who in thy wonderful providence hast strengthened thy Church through the confession of the Martyrs Saint Augustine Zhao and Companions: grant that thy people, faithful to the mission entrusted to them, may enjoy ever greater freedom, and witness to the truth before the world; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 11,
        month: 7,
        title: "Saint Benedict",
        subtitle: "Abbot",
        patronNote: "Patron of Europe",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O eternal God, who didst make thine Abbot Saint Benedict a wise master in the school of thy service, and a guide for many called into the common life to follow the rule of Christ: grant that we may put thy love above all things, and seek with joy the way of thy commandments; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 11,
        month: 7,
        title: "Saint Benedict",
        subtitle: "Abbot",
        patronNote: "Patron of Europe",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O eternal God, who didst make thine Abbot Saint Benedict a wise master in the school of thy service, and a guide for many called into the common life to follow the rule of Christ: grant that we may put thy love above all things, and seek with joy the way of thy commandments; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 12,
        month: 7,
        title: "Saint John Jones",
        subtitle: "Priest and Martyr",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, by whose grace Saint John Jones combined a love of the Cross with a zeal for souls, and gave his life for his priestly fidelity: grant us, we beseech thee, through his intercession, constant fervour; and bring us to a share in his reward; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 13,
        month: 7,
        title: "Saint Henry",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, whose abundant grace prepared Saint Henry to be raised by thee in a wonderful way from the cares of earthly rule to heavenly realms: grant, we pray, through his intercession; that amid the uncertainties of this world, we may hasten towards thee in perfect purity of heart; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Holy Man"
        ]
    },
    {
        day: 15,
        month: 7,
        title: "Saint Bonaventure",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, by whose providence blessed Bonaventure was sent to guide thy people in the way of everlasting salvation: grant, we beseech thee; that as we have learned of him the doctrine of life on earth, so we may be found worthy to have him for our advocate in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor bonaventure"
        }
    },
    {
        day: 15,
        month: 7,
        title: "Saint Swithun",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, by whose grace we celebrate again the festival of thy servant Swithun: grant that, as he governed with gentleness the people committed to his care; so we, rejoicing in our inheritance in Christ, may ever seek to build up thy Church in unity and love; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 16,
        month: 7,
        title: "Our Lady of Mount Carmel",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "May the venerable intercession of the glorious Virgin Mary come to our aid, we pray thee, O Lord: so that, fortified by her protection, we may reach the mountain which is Christ; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 16,
        month: 7,
        title: "Saint Osmund",
        subtitle: "Bishop",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, whose miracles of old we perceive to shine forth even in our time to the glory and praise of thy Name, and to the honour of thy holy Confessor and Bishop Saint Osmund: mercifully grant that we who keep his festival may by his prayers both glorify thee in this present time, and be deemed worthy to enjoy thee in the world to come; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 20,
        month: 7,
        title: "Saint Apollinaris",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who dost reward the souls of the faithful and who hast hallowed, this day by thy martyrdom of blessed Apollinaris, thy Bishop: grant unto us, thy servants; that we who keep his festival, may by his prayers obtain the pardon of thy mercy; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop"
        ]
    },
    {
        day: 20,
        month: 7,
        title: "Saint Margaret of Antioch",
        subtitle: "Martyr",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, O Lord, that, like as blessed Margaret, thy Virgin and Martyr, by the merits of her chastity and the godliness of her conduct, did ever walk acceptably in thy sight: so she may at all times effectually intercede for our forgiveness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 21,
        month: 7,
        title: "Saint Lawrence of Brindisi",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst bestow on blessed Lawrence of Brindisi, thy Confessor and Doctor, the spirit of wisdom and fortitude to endure every labour for the glory of thy Name and the salvation of souls: grant us, in the same spirit, both to perceive what we ought to do, and by his intercession to perform the same; through Jesus Christ thy Son our Lord, who liveth, and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Priest",
            "Religious"
        ],
        supplements: {
            ep2MagId: "doctor lawrence"
        }
    },
    {
        day: 22,
        month: 7,
        title: "Saint Mary Magdalene",
        subtitle: "",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "Almighty God, whose blessed Son did call and sanctify Mary Magdalene to be a witness to his Resurrection: mercifully grant that by thy grace, and assisted by her prayers, we may be healed of all our infirmities, and always serve thee in the power of his endless life; who, liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "sing we now the joys and sorrows",
            ep1VandR: [
                "Full of grace are thy lips.",
                "Be_cause God hath blessed thee for_e_ver."
            ],
            ep1MagId: "mary mag a woman",
            invId: "mary mag inv",
            mpHymnId: "as the gardener him addressing",
            mpVandR: [
                "God hath cho_sen and fore_cho_sen her.",
                "He hath made her to dwell in his ta_ber_na_cle."
            ],
            mpBenId: "mary mag mary anointed",
            ep2HymnId: "mary weep not weep no longer",
            ep2VandR: [
                "God hath cho_sen and fore_cho_sen her.",
                "He hath made her to dwell in his ta_ber_na_cle."
            ],
            ep2MagId: "mary mag a woman in the city"
        }
    },
    {
        day: 23,
        month: 7,
        title: "Saint Bridget of Sweden",
        subtitle: "Religious",
        patronNote: "Patron of Europe",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God Most High, the Creator of all mankind: we bless thy holy Name for the virtue and grace which thou hast given unto holy women in all ages, especially Saint Bridget; and we pray that her intercession and the example of her faith and purity may inspire many souls in this generation to look unto thee, and to follow thy blessed Son Jesus Christ our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 23,
        month: 7,
        title: "Saint Bridget of Sweden",
        subtitle: "Religious",
        patronNote: "Patron of Europe",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O God Most High, the Creator of all mankind: we bless thy holy Name for the virtue and grace which thou hast given unto holy women in all ages, especially Saint Bridget; and we pray that her intercession and the example of her faith and purity may inspire many souls in this generation to look unto thee, and to follow thy blessed Son Jesus Christ our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 24,
        month: 7,
        title: "Saint Sharbel Makhluf",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst call the Priest Saint Sharbel Makhluf to the solitary combat of the desert and imbued him with all manner of devotion: grant us, we pray thee; that, being made imitators of the Lord's Passion, we may merit to be coheirs of his kingdom; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious"
        ]
    },
    {
        day: 25,
        month: 7,
        title: "Saint James",
        subtitle: "Apostle",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "Grant, O merciful God, that as thine holy Apostle Saint James, leaving his father and all that he had, without delay was obedient unto the calling of thy Son Jesus Christ, and followed him: so we, forsaking all worldly and carnal affections, may be evermore ready to follow thy holy commandments; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        athanasianCreed: true,
        commons: [
            "Apostles"
        ],
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear st james"
        }
    },
    {
        day: 26,
        month: 7,
        title: "Saints Joachim and Anne",
        subtitle: "Parents of the Blessed Virgin Mary",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst choose blessed Joachim and holy Anne that of  them might be born the Mother of thine Only Begotten Son: grant unto us, at their intercession, a place in the fellowship of thine elect, wherein for ever to praise thee for thy loving-kindness; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            invId: "joachim and anne inv",
            mpHymnId: "the morning star succeeds to night",
            mpVandR: [
                "The just ex_ult in their glo_ry.",
                "They shout for joy on their beds."
            ],
            mpBenId: "joachim and anne i am",
            ep2HymnId: "let all the saints in concert sing",
            ep2VandR: [
                "The just ex_ult in their glo_ry.",
                "They shout for joy on their beds."
            ],
            ep2MagId: "joachim and anne the glorious"
        }
    },
    {
        day: 29,
        month: 7,
        title: "Saints Martha, Mary and Lazarus",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O Almighty God, who willest to be glorified in thy Saints, and didst raise up thy servants Martha, Mary and Lazarus to shine as lights in the world: shine, we pray thee, in our hearts; that aided by their prayers we also in our generation may show forth thy praises, who hast called us out of darkness into thy marvellous light; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            invId: "martha inv",
            mpHymnId: "christs noble servants we would sing your greatness",
            mpVandR: [
                "The se_cret of the Lord is a_mong them that fear him, and he will show them his co_ve_nant.",
                "Yea, gra_cious and righ_teous is the Lord."
            ],
            mpBenId: "martha watch and pray",
            ep2HymnId: "lo christ hath gone to bethany",
            ep2VandR: [
                "The righ_teous shall give thanks un_to thy Name.",
                "And the just shall con_tin_ue in thy sight."
            ],
            ep2MagId: "martha since the"
        }
    },
    {
        day: 30,
        month: 7,
        title: "Saint Peter Chrysologus",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who madest the Bishop Saint Peter Chrysologus an illustrious preacher of thy incarnate Word: grant, through his intercession; that we may constantly ponder in our hearts the mysteries of thy salvation and faithfully manifest them in our lives; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor peter"
        }
    },
    {
        day: 31,
        month: 7,
        title: "Saint Ignatius of Loyola",
        subtitle: "Priest",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who for the greater glory of thy Name, didst endue thy Church militant with an increase of strength through the life and labours of blessed Ignatius: grant us, by his help and example, so to wage our earthly warfare; that with him we may be found worthy of a heavenly crown; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious",
            "Confessor: Priest"
        ]
    },
    {
        day: 1,
        month: 8,
        title: "Saint Alphonsus Liguori",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst inflame blessed Alphonsus, thy Confessor and Bishop, with zeal for souls, and didst through him enrich thy Church with a new offspring: we beseech thee; that being taught by his wholesome precepts and strengthened by his example, we may be enabled to attain in gladness unto thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor alphonsus"
        }
    },
    {
        day: 2,
        month: 8,
        title: "Saint Eusebius of Vercelli",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Lead us, O Lord God, to imitate the constancy of Saint Eusebius in affirming the divinity of thy Son: that, by preserving the faith he taught as thy Bishop, we may merit a share in the very life of the same Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 2,
        month: 8,
        title: "Saint Peter Julian Eymard",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst adorn Saint Peter Julian Eymards with a wonderful love for the sacred mysteries of the Body and Blood of thy Son: graciously grant that we, too, may be worthy to receive the delights he drew from this divine banquet; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious",
            "Confessor: Priest"
        ]
    },
    {
        day: 3,
        month: 8,
        title: "Saint Germanus of Auxerre",
        subtitle: "Bishop",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Lord, who didst call Saint Germanus to Wales to confirm the faith and strengthen monastic life: grant that, through his intercession and example, we may attain a share in the glory of Christ; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 4,
        month: 8,
        title: "Saint John Mary Vianney",
        subtitle: "Priest",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty and merciful God, who didst wonderfully endue Saint John Vianney with pastoral zeal and a continual desire for prayer and penance: grant, we beseech thee; that by his example and intercession, we may win the souls of our brethren for Christ, and with them attain glory everlasting; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 5,
        month: 8,
        title: "The Dedication of the Basilica of Saint Mary Major",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, who by the obedience of Mary didst repair the sin of Eve: grant that we who venerate the glorious and ever-Virgin Mother, may imitate her purity, rejoice in her succour, and share her triumph; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 5,
        month: 8,
        title: "Saint Oswald",
        subtitle: "Martyr",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty everlasting God, who by the martyrdom of blessed King Oswald hast hallowed this day with holy joy and gladness: grant unto our hearts the increase of thy charity; that we, who honour his glorious battle for the faith, may imitate his constancy even unto death; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 6,
        month: 8,
        title: "The Transfiguration of the Lord",
        subtitle: "",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 5,
        optional: false,
        collect: "O God, who on the holy mount didst reveal to chosen witnesses thine Only Begotten Son wonderfully transfigured, in raiment white and glistening: mercifully grant that we, being delivered from the disquietude of this world, may be permitted to behold the King in his beauty; who with thee, O Father, and thee, O Holy Spirit, liveth and reigneth, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "an image of that heavenly light",
            ep1VandR: [
                "Glo_rious didst thou ap_pear in the sight of the Lord.",
                "Be_cause the Lord hath clothed thee with ma_je_sty."
            ],
            ep1MagId: "transfiguration christ jesus",
            invId: "transfiguration inv",
            mpHymnId: "author of all things christ the worlds redeemer",
            mpVandR: [
                "A crown of gold is set u_pon his head.",
                "Where_in is en_graved ho_li_ness, glo_ry, and ho_nour."
            ],
            mpBenId: "transfiguration and behold",
            ep2HymnId: "o light of light by love inclined",
            ep2VandR: [
                "Glo_rious didst thou ap_pear in the sight of the Lord.",
                "Be_cause the Lord hath clothed thee with ma_je_sty."
            ],
            ep2MagId: "transfiguration and when"
        }
    },
    {
        day: 7,
        month: 8,
        title: "Saint Sixtus II, Pope, and Companions",
        subtitle: "Martyrs",
        shortTitle: "Saint Sixtus II and Companions",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who dost vouchsafe unto us to celebrate the heavenly birthday of thy holy Martyrs blessed Pope Sixtus and his Companions: grant us to rejoice in the perpetual felicity of their fellowship in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 7,
        month: 8,
        title: "Saint Cajetan",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst give to thy blessed Confessor Cajetan to live after the likeness of thine Apostles: grant to us also, by his intercession and example, to put our trust in thee, and to seek after heavenly things alone; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious"
        ]
    },
    {
        day: 7,
        month: 8,
        title: "Saint Dominic",
        subtitle: "Priest",
        regionNote: "Australia",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, whose Priest Dominic grew in the knowledge of thy truth, and formed an order of preachers to proclaim the faith of Christ: by thy grace, grant to all thy people a love for thy word and a longing to share the Gospel; that the whole world may be filled with the knowledge of thee and of thy Son Jesus Christ our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious"
        ]
    },
    {
        day: 8,
        month: 8,
        title: "Saint Dominic",
        subtitle: "Priest",
        regionNote: "Britain",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty God, whose Priest Dominic grew in the knowledge of thy truth, and formed an order of preachers to proclaim the faith of Christ: by thy grace, grant to all thy people a love for thy word and a longing to share the Gospel; that the whole world may be filled with the knowledge of thee and of thy Son Jesus Christ our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious"
        ]
    },
    {
        day: 8,
        month: 8,
        title: "Saint Mary of the Cross",
        subtitle: "Virgin",
        regionNote: "Australia",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "O God, the source of all goodness, who hast shown us in Saint Mary a woman of faith living by the power of the Cross: teach us, we pray thee, by her example to live by the Gospel in changing times; and to respect and defend the human dignity of all in our land; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin",
            "Religious",
            "Educator"
        ],
        supplements: {
            ep1MagId: "smotc let us",
            mpBenId: "smotc forsaking",
            ep2MagId: "smotc inspired"
        }
    },
    {
        day: 9,
        month: 8,
        title: "Saint Teresa Benedicta of the Cross",
        subtitle: "Virgin and Martyr",
        patronNote: "Patron of Europe",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God of our fathers, who didst lead the blessed Martyr Saint Teresa Benedicta of the Cross to know thy crucified Son and imitate him even unto death: mercifully grant that, by her intercession, all men may know Christ as Saviour, and through him come to thine eternal vision; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 9,
        month: 8,
        title: "Saint Teresa Benedicta of the Cross",
        subtitle: "Virgin and Martyr",
        patronNote: "Patron of Europe",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O God of our fathers, who didst lead the blessed Martyr Saint Teresa Benedicta of the Cross to know thy crucified Son and imitate him even unto death: mercifully grant that, by her intercession, all men may know Christ as Saviour, and through him come to thine eternal vision; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 10,
        month: 8,
        title: "Saint Lawrence",
        subtitle: "Deacon and Martyr",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "Almighty God, who didst endue blessed Lawrence with power to overcome the fires of his torments: give us grace, we beseech thee, to quench the flames of our sins; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 11,
        month: 8,
        title: "Saint Clare",
        subtitle: "Virgin",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Graciously hear us, O God of our salvation: of that we who rejoice in the festival of blessed Clare, thy Virgin, may grow in the knowledge and love of true devotion; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin",
            "Religious"
        ]
    },
    {
        day: 12,
        month: 8,
        title: "Saint Jane Frances de Chantal",
        subtitle: "Religious",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who madest Saint Jane Frances de Chantal radiant with outstanding merits in divers paths of life in the way of perfection: grant us, through her intercession; that, walking faithfully in our vocation, we may ever be examples of thy shining light; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 13,
        month: 8,
        title: "Saints Pontian, Pope, and Hippolytus, Priest",
        subtitle: "Martyrs",
        shortTitle: "Saints Pontian and Hippolytus",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, Almighty God: that we, who on this day devoutly observe the festival of thy holy Martyrs blessed Pontian and Hippolytus, may thereby increase in godliness to the attainment of everlasting salvation; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 14,
        month: 8,
        title: "Saint Maximillian Mary Kolbe",
        subtitle: "Priest and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Most gracious God, who didst fill thy Priest and Martyr Maximilian Kolbe with zeal for thine house and love of his neighbour: vouchsafe that, holpen by the prayers of this devoted servant of the immaculate Mother of God; we too may strive to serve others for thy glory, and become like unto thy dear Son, who loved his own even unto the end; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 15,
        month: 8,
        title: "The Assumption of the Blessed Virgin Mary",
        subtitle: "",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "Almighty and everlasting God, who didst assume the Immaculate Virgin Mary, Mother of thy Son, body and soul to the glory of heaven: grant us, we beseech thee; that being ever intent on things above, we may be worthy to be partakers of her glory hereafter; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "blest maid to highest dignity",
            ep1VandR: [
                "Thou art ex_al_ted, O ho_ly Mo_ther of God.",
                "A_bove the choir of An_gels, un_to the hea_ven_ly king_dom."
            ],
            ep1MagId: "assump o virgin",
            invId: "assump inv",
            mpHymnId: "virgin most holy robed in golden sunlight",
            mpVandR: [
                "Thou art ex_al_ted, O ho_ly Mo_ther of God.",
                "A_bove the choir of An_gels, un_to the hea_ven_ly king_dom."
            ],
            mpBenId: "assump who is she",
            ep2HymnId: "candlemas sequence",
            ep2VandR: [
                "Thou art ex_al_ted, O ho_ly Mo_ther of God.",
                "A_bove the choir of An_gels, un_to the hea_ven_ly king_dom."
            ],
            ep2MagId: "assump today"
        }
    },
    {
        day: 16,
        month: 8,
        title: "Saint Stephen of Hungary",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant thy Church, we pray, Almighty God: that she may have Saint Stephen of Hungary, who fostered her growth while a king on earth, as her glorious defender in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Holy Man"
        ]
    },
    {
        day: 19,
        month: 8,
        title: "Saint John Eudes",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst wonderfully choose thy Priest Saint John Eudes to proclaim the unfathomable riches of Christ: grant us, by his example and teachings; that, growing in knowledge of thee, we may live faithfully by the light of the Gospel; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious"
        ]
    },
    {
        day: 20,
        month: 8,
        title: "Saint Bernard",
        subtitle: "Abbot and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, by whose grace the blessed Abbot Bernard, kindled with the fire of thy love, became a burning and a shining light in thy Church: grant, his intercession; that we may be inflamed with the same spirit of love, and ever walk before thee as children of light; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Abbot or Abbess"
        ],
        supplements: {
            ep2MagId: "doctor bernard"
        }
    },
    {
        day: 21,
        month: 8,
        title: "Saint Pius X",
        subtitle: "Pope",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who for the defence of the Catholic faith, and the restoring of all things in Christ, didst fill thy Supreme Pontiff Saint Pius the Tenth, with heavenly wisdom and apostolic fortitude: graciously grant that, following his teaching and example, we may attain unto eternal rewards; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 22,
        month: 8,
        title: "The Queenship of the Blessed Virgin Mary",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Grant to us, we beseech thee, O Lord: that we, who celebrate the festival of the Blessed Virgin Mary our Queen, being defended by her succour, may obtain peace in this world, and glory in that which is to come; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 23,
        month: 8,
        title: "Saint Rose of Lima",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, the giver of all good gifts, who didst will that Saint Rose, bedewed with heavenly graces, should blossom forth among the peoples of the Americas as a flower of virginity and suffering: grant to us thy servants, so to run after her in the fragrance of her sweetness; that we may be found worthy to be made a sweet savour unto Christ our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin"
        ]
    },
    {
        day: 24,
        month: 8,
        title: "Saint Bartholomew",
        subtitle: "Apostle",
        feastHasFirstEvensong: true,
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O Almighty and everlasting God, who didst give to thine Apostle Bartholomew grace truly to believe and to preach thy Word: grant, we beseech thee, unto thy Church; to love that Word which he believed, and both to preach and to receive the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        athanasianCreed: true,
        commons: [
            "Apostles"
        ],
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear st bartholomew"
        }
    },
    {
        day: 25,
        month: 8,
        title: "Saint Louis",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst exalt blessed Louis from the cares of earthly rule to the glory of thy heavenly kingdom: grant, we pray thee, through his intercession; that, by fulfilling our duties on earth, we may be made heirs of the King of kings, even Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Holy Man"
        ]
    },
    {
        day: 25,
        month: 8,
        title: "Saint Joseph Calasanz",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst adorn the Priest Saint Joseph Calasanz with such charity and patience that he la laboured tirelessly to educate children and endow them with every virtue: grant, we pray; that we, who venerate him as a teacher of wisdom, may constantly imitate his work for thy truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Educator",
            "Confessor: Priest"
        ]
    },
    {
        day: 26,
        month: 8,
        title: "Blessed Dominic of the Mother of God",
        subtitle: "Priest",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst choose thy Priest Blessed Dominic Barberi to be a minister of thy salvation, so that his teaching and example might help many to find peace and reconciliation in thy Church: mercifully guide our steps, we humbly pray, along that same way of love and truth, until by thy grace we gain its eternal reward; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious"
        ]
    },
    {
        day: 26,
        month: 8,
        title: "Saint David Lewis",
        subtitle: "Martyr",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who through the precious Blood of thy only Son hast redeemed mankind: grant that, as we rejoice that thy Martyr r Saint David Lewis was united to the sacrifice of thy Son; thy saving work may be accomplished in us, and we may become worthy to gather its fruit; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr",
            "Confessor: Priest"
        ]
    },
    {
        day: 27,
        month: 8,
        title: "Saint Monica",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who art the Comforter of them that mourn, and the Salvation of them that hope in thee, who didst graciously regard the tearful pleading of blessed Monica for the conversion of her son Augustine: grant, we beseech thee, at their united intercession; that we may truly lament our sins and be made worthy to obtain thy gracious pardon; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Matron or Holy Woman"
        ],
        supplements: {
            invId: "monica inv"
        }
    },
    {
        day: 28,
        month: 8,
        title: "Saint Augustine of Hippo",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: false,
        collect: "O merciful Lord, who didst turn Saint Augustine from his sins to be a faithful Bishop and teacher: grant that we may follow him in penitence and godly discipline; till our restless hearts find their rest in thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor augustine"
        }
    },
    {
        day: 29,
        month: 8,
        title: "The Passion of Saint John the Baptist",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst send thy messenger, Saint John the Baptist, to be the forerunner of the Lord, and to glorify thee by his death: grant that we, who have received the truth of thy most holy Gospel, may bear our witness thereunto; and after his example and aided by his prayers, constantly speak the truth, boldly rebuke vice, and patiently suffer for the truth's sake; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ],
        supplements: {
            mpBenId: "bsjb herod sent",
            ep2MagId: "bsjb the unbelieving king"
        }
    },
    {
        day: 30,
        month: 8,
        title: "Saints Margaret Clitherow, Anne Line, and Margaret Ward",
        subtitle: "Martyrs",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Steadfast God, as we honour the fidelity in life and constancy in death of thy holy Martyrs Margaret Clitherow, Anne Line, and Margaret Ward: we pray thee to raise up in our day women of courage and resource to care for thy household the Church; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 31,
        month: 8,
        title: "Saint Aidan, Bishop, and the Saints of Lindisfarne",
        subtitle: "",
        shortTitle: "Saint Aidan and the Saints of Lindisfarne",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Everlasting God, who didst send thy gentle Bishop Aidan to proclaim the Gospel in Britain: grant that, aided by his prayers, we may live after his teaching in simplicity, humility, and love for the poor; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 1,
        month: 9,
        title: "Our Lady of the Southern Cross",
        subtitle: "",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "Almighty and everlasting God, who stooped to raise fallen humanity through the child-bearing of Blessed Mary: grant that we, who have seen thy glory revealed in our human nature and thy love made perfect in our weakness, may daily be renewed in thine image and, through her constant intercession, conformed to the pattern of thy Son Jesus Christ our Lord; liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ],
        supplements: {
            ep1MagId: "olsc the blessed",
            mpBenId: "olsc our lady",
            ep2MagId: "olsc we turn"
        },
        regionNote: "Australia"
    },
    {
        day: 3,
        month: 9,
        title: "Saint Gregory the Great",
        subtitle: "Pope and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty and merciful God, who didst raise up thy servant Pope Gregory to be the servant of the servants of God, and didst inspire him to send missionaries to preach the Gospel to the English people: preserve in thy Church the Catholic and Apostolic Faith they taught; that thy people, being fruitful in every good work, may receive t the crown of glory that fadeth not away; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Holy Pope"
        ],
        supplements: {
            mpHymnId: "of angles once apostle thou",
            ep2HymnId: "of angles once apostle thou",
            ep2MagId: "doctor gregory"
        }
    },
    {
        day: 3,
        month: 9,
        title: "Saint Gregory the Great",
        subtitle: "Pope and Doctor of the Church",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "Almighty and merciful God, who didst raise up thy servant Pope Gregory to be the servant of the servants of God, and didst inspire him to send missionaries to preach the Gospel to the English people: preserve in thy Church the Catholic and Apostolic Faith they taught; that thy people, being fruitful in every good work, may receive the crown of glory that fadeth not away; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Holy Pope"
        ],
        supplements: {
            mpHymnId: "of angles once apostle thou",
            ep2HymnId: "of angles once apostle thou",
            ep2MagId: "doctor gregory"
        }
    },
    {
        day: 4,
        month: 9,
        title: "Saint Cuthbert",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, who didst call thy servant Cuthbert from tending sheep to follow thy Son and to be a shepherd of thy people: in thy mercy, grant that we may so follow his example; that we may bring those who are lost home to thy fold; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 8,
        month: 9,
        title: "The Nativity of the Blessed Virgin Mary",
        subtitle: "",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "O Lord, we beseech thee, bestow on thy servants the gift of heavenly grace: that as our redemption began to dawn in the child-bearing of the Blessed Virgin Mary; so this festival of her Nativity may yield us an increase of peace; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "hail o star that pointest",
            ep1VandR: [
                "To_day is the Na_ti_vi_ty of the ho_ly Vir_gin Ma_ry.",
                "Whose glo_rious life il_lu_mi_neth all the chur_ches."
            ],
            ep1MagId: "nativity bvm let us celebrate",
            invId: "nativity bvm inv",
            mpHymnId: "the god whom earth and sea and sky",
            mpVandR: [
                "To_day is the Na_ti_vi_ty of the ho_ly Vir_gin Ma_ry.",
                "Whose glo_rious life il_lu_mi_neth all the chur_ches."
            ],
            mpBenId: "nativity bvm today let us",
            ep2HymnId: "candlemas sequence",
            ep2VandR: [
                "To_day is the Na_ti_vi_ty of the ho_ly Vir_gin Ma_ry.",
                "Whose glo_rious life il_lu_mi_neth all the chur_ches."
            ],
            ep2MagId: "nativity bvm thy nativity"
        }
    },
    {
        day: 9,
        month: 9,
        title: "Saint Peter Claver",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who madest Saint Peter Claver a slave of slaves, and strengthened him with wonderful charity an and patience as he came to their help: grant, through his intercession; that, seeking the things of Christ, we may love our neighbour in deeds and in truth; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 12,
        month: 9,
        title: "The Most Holy Name of Mary",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, Almighty God: that thy faithful people who rejoice in the name and protections of the most holy Virgin Mary, may by her loving intercession, be delivered from all evils on earth and be found worthy to come to everlasting joys in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 13,
        month: 9,
        title: "Saint John Chrysostom",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God of truth and love, who gavest to thy Bishop John Chrysostom eloquence to declare thy righteousness in the great congregation, and courage to bear reproach for the honour of thy Name: mercifully grant to the ministers of thy Word such excellence in preaching; that all people may share with them in the glory that shall be revealed; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor john"
        }
    },
    {
        day: 14,
        month: 9,
        title: "The Exaltation of the Holy Cross",
        subtitle: "",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 5,
        optional: false,
        collect: "Almighty God, whose Son our Saviour Jesus Christ was lifted high upon the Cross that he might draw the whole world unto himself: mercifully grant that we, who glory in the mystery of our redemption, may have grace to take up our cross and follow him; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "fulfilled is all that david told",
            ep1VandR: [
                "This sign of the Cross shall be in hea_ven.",
                "When the Lord shall come to judge_ment."
            ],
            ep1MagId: "holy cross o cross",
            invId: "holy cross inv",
            mpHymnId: "sing my tongue the glorious battle",
            mpVandR: [
                "We a_dore thee, O Christ, and we bless thee.",
                "Be_cause by thy Cross thou hast re_deemed the world."
            ],
            mpBenId: "holy cross above all",
            ep2HymnId: "faithful cross above all other",
            ep2VandR: [
                "This sign of the Cross shall be in hea_ven.",
                "When the Lord shall come to judge_ment."
            ],
            ep2MagId: "holy cross he the holy"
        }
    },
    {
        day: 15,
        month: 9,
        title: "Our Lady of Sorrows",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O Lord, in whose Passion, according to the word of Simeon, the sword of sorrow didst pierce the most sweet soul of the glorious Virgin and Mother Mary: graciously grant that we, who devoutly call to mind her sorrows, may obtain the blessed effects of thy Passion; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            invId: "sorrows inv",
            mpHymnId: "o god the merciful and true",
            mpVandR: [
                "O Vir_gin Ma_ry, by the vir_tue of so ma_ny sor_rows.",
                "Make us to re_joice in the hea_ven_ly king_dom."
            ],
            mpBenId: "sorrows come ye",
            ep2HymnId: "what a sea of tears and sorrow",
            ep2VandR: [
                "Pray for us, O Queen of Mar_tyrs.",
                "Who didst stand by the Cross of Je_sus."
            ],
            ep2MagId: "sorrows sorrow hath weighed"
        }
    },
    {
        day: 16,
        month: 9,
        title: "Saints Cornelius, Pope, and Cyprian, Bishop",
        subtitle: "Martyrs",
        shortTitle: "Saints Cornelius and Cyprian",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst give Saints Cornelius and Cyprian to thy people as diligent shepherds and valiant Martyrs: grant that,  through their intercession, we may be strengthened in faith and constancy and spend ourselves without reserve for the unity of the Church; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 17,
        month: 9,
        title: "Saint Robert Bellarmine",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst adorn blessed Robert Bellarmine, thy Bishop and Doctor, with wondrous learning and virtue, to banish the wiles of error and contend for the rights of the Apostolic See: grant by his merits and intercession; that we may grow in the love of truth, and that the hearts of those that err may return to the unity of thy Church; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor robert"
        }
    },
    {
        day: 17,
        month: 9,
        title: "Saint Hildegard of Bingen",
        subtitle: "Virgin and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, O Lord, that the prayers of thy holy Abbess, blessed Hildegard of Bingen, may commend us unto thee: that we, who have no power of ourselves to help ourselves, may by her advocacy find favour in thy sight; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "O God, who to the blessed Abbess Hildegard of Bingen gavest grace to imitate Christ in his poverty, and with humble heart to follow him to the end: grant that all who enter the path of Gospel perfection may neither look back nor go astray from the way; but hastening to thee without stumbling, may attain the crown of eternal life whereunto thou dost call them; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "O God, by whose providence blessed Hildegard of Bingen was sent to guide thy people in the way of everlasting salvation: grant, we beseech thee; as we on earth have learned of her the doctrine of life, so we may be found worthy to have her for our advocate in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "Doctor of the Church",
            "Abbot or Abbess"
        ],
        supplements: {
            ep2MagId: "doctor hildegard"
        }
    },
    {
        day: 17,
        month: 9,
        title: "Saint Ninian",
        subtitle: "Bishop",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who hast made this day to be observed in honour of blessed Ninian, thy Confessor and Bishop: mercifully grant that as through his teaching the light of truth hath been shed forth in our hearts, so through his intercession we may attain to the joys of life everlasting; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 17,
        month: 9,
        title: "Saint Edith of Wilton",
        subtitle: "Religious",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst will that thy Son our Lord should be born of a Virgin, and didst thereby give unto thy faithful a pattern of chastity: grant to us, through the prayers of Saint Edith thy Virgin, that purity of mind and body, whereby we may obtain the felicity promised to us by thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin",
            "Religious"
        ]
    },
    {
        day: 19,
        month: 9,
        title: "Saint Januarius",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who dost grant us to venerate the memory of the Martyr Saint Januarius: give us, we pray, the joy of his company in blessed happiness for all eternity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop"
        ]
    },
    {
        day: 19,
        month: 9,
        title: "Saint Theodore of Canterbury",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, whose Bishop Theodore was called to England (to this land), to set the Church on a firm foundation: by his prayers, build us always anew on the rock that is Christ; and keep thy household faithful to the call we have received; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever ne God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 20,
        month: 9,
        title: "Saint Andrew Kim Tae-gon, Priest, Paul Chong Ha-sang and Companions",
        subtitle: "Martyrs",
        shortTitle: "Saint Andrew Kim Tae-gon and Companions",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who wast pleased to increase thy adopted children in all the world, and who made the blood of thy Martyrs Saint Andrew Kim Tae-gon and his Companions a most fruitful seed of Christians: grant that we may be defended by their help and profit always from their example; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 21,
        month: 9,
        title: "Saint Matthew",
        subtitle: "Apostle and Evangelist",
        type: "feast",
        rank: 7,
        optional: false,
        feastHasFirstEvensong: true,
        collect: "O Almighty God, who by thy blessed Son didst call Saint Matthew from the receipt of custom to be an Apostle and Evangelist: grant us grace to forsake all covetous desires and inordinate love of riches; and to follow the same thy Son Jesus Christ; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        athanasianCreed: true,
        commons: [
            "Apostles"
        ],
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear st matthew"
        }
    },
    {
        day: 23,
        month: 9,
        title: "Saint Pius of Pietrelcina",
        subtitle: "Priest",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty everliving God, who, by a singular grace, didst give the Priest Saint Pius a share in the Cross of thy Son and, by means of his ministry, renewed the wonders of thy mercy: grant that, through his intercession, we may be united constantly to the sufferings of Christ, and so brought happily to the glory of the Resurrection; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest",
            "Religious"
        ]
    },
    {
        day: 24,
        month: 9,
        title: "Our Lady of Walsingham",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "O God, who, through the mystery of the Word made flesh, didst in thy mercy sanctify the house of the Blessed Virgin Mary: do thou grant that we may keep aloof from the tabernacle of sinners, and become worthy indwellers of thy house; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "Grant, we pray thee, O Lord God, that as in the mystery of the Incarnation the blessed and ever-Virgin Mary conceived thy Son in her heart before she conceived him in her womb: so we, thy pilgrim people, rejoicing in her patronage, may welcome him into our hearts; and, like her, be made a holy house fit for his eternal dwelling; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        supplements: {
            ep1HymnId: "hail o star that pointest",
            ep1VandR: [
                "And the Word was made flesh.",
                "And dwelt a_mong us."
            ],
            ep1MagId: "dedication the lord hath",
            invId: "walsingham inv",
            mpHymnId: "the god whom earth and sea and sky",
            mpVandR: [
                "We will go /in_to ' his ta_ber_na_cle.",
                "And fall low on our /knees ' be_fore his foot_stool."
            ],
            mpBenId: "walsingham behold the tabernacle",
            ep2HymnId: "hail o star that pointest",
            ep2VandR: [
                "And the Word was made flesh.",
                "And dwelt a_mong us."
            ],
            ep2MagId: "dedication o how"
        }
    },
    {
        day: 24,
        month: 9,
        title: "Our Lady of Walsingham",
        type: "solemnity",
        regionNote: "Ordinariate of OLW",
        rank: 3,
        optional: false,
        collect: "O God, who, through the mystery of the Word made flesh, didst in thy mercy sanctify the house of the Blessed Virgin Mary: do thou grant that we may keep aloof from the tabernacle of sinners, and become worthy indwellers of thy house; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "Grant, we pray thee, O Lord God, that as in the mystery of the Incarnation the blessed and ever-Virgin Mary conceived thy Son in her heart before she conceived him in her womb: so we, thy pilgrim people, rejoicing in her patronage, may welcome him into our hearts; and, like her, be made a holy house fit for his eternal dwelling; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        supplements: {
            ep1HymnId: "hail o star that pointest",
            ep1VandR: [
                "And the Word was made flesh.",
                "And dwelt a_mong us."
            ],
            ep1MagId: "dedication the lord hath",
            invId: "walsingham inv",
            mpHymnId: "the god whom earth and sea and sky",
            mpVandR: [
                "We will go /in_to ' his ta_ber_na_cle.",
                "And fall low on our /knees ' be_fore his foot_stool."
            ],
            mpBenId: "walsingham behold the tabernacle",
            ep2HymnId: "hail o star that pointest",
            ep2VandR: [
                "And the Word was made flesh.",
                "And dwelt a_mong us."
            ],
            ep2MagId: "dedication o how"
        }
    },
    {
        day: 26,
        month: 9,
        title: "Saints Cosmas and Damian",
        subtitle: "Martyrs",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, Almighty God: that we who celebrate the heavenly birthday of Saints Cosmas and Damian, thy Martyrs, may by their intercession be delivered from all evils that beset us; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 27,
        month: 9,
        title: "Saint Vincent de Paul",
        subtitle: "Priest",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst strengthen blessed Vincent de Paul with apostolic power for preaching the Gospel to the poor, and for promoting worthiness in the clergy: grant, we beseech thee; that we who reverence his pious deeds may also be taught by the example of his virtues; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 28,
        month: 9,
        title: "Saint Wenceslaus",
        subtitle: "Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who by the victory of martyrdom didst exalt blessed Wenceslaus f from an earthly realm to the g glory of thy heavenly kingdom: grant, we pray thee; that by his merits and intercession, we may be made heirs of the King of kings, even Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 28,
        month: 9,
        title: "Saint Lawrence Ruiz and Companions",
        subtitle: "Martyrs",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant us, we pray, Lord God, the same perseverance shown by thy Martyrs Saint Lawrence Ruiz and his Companions in serving thee and their neighbour: even as those persecuted for the sake of righteousness are blessed in thy kingdom; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 29,
        month: 9,
        title: "Saints Michael, Gabriel, and Raphael",
        subtitle: "Archangels",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O everlasting God, who hast ordained and constituted the services of Angels and men in a wonderful order: mercifully grant that as thy holy Angels always do thee service in heaven; so by thy appointment they may succour and defend us on earth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            invId: "archangels inv"
        }
    },
    {
        day: 30,
        month: 9,
        title: "Saint Jerome",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who hast given us the holy Scriptures for a light to shine upon our path: grant us, after the example of thy servant Saint Jerome and assisted by his prayers, so to learn of thee according to thy holy Word; that we may find in it the light that shineth more and more unto the perfect day; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Priest"
        ],
        supplements: {
            ep2MagId: "doctor jerome"
        }
    },
    {
        day: 1,
        month: 10,
        title: "Saint Th\xe9r\xe8se of the Child Jesus",
        subtitle: "Virgin and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O Lord Jesus Christ, who hast said except ye become as little children ye shall not enter into the kingdom of heaven: grant us, we beseech thee, in meekness and lowliness of heart to follow the footsteps of blessed Th\xe9r\xe8se thy Virgin; and so at last to come unto thine everlasting kingdom; who livest and reignest with the Father in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin",
            "Doctor of the Church"
        ],
        supplements: {
            ep2MagId: "doctor therese"
        }
    },
    {
        day: 2,
        month: 10,
        title: "Holy Guardian Angels",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who in thine ineffable providence dost vouchsafe to send thy holy Angels to guard us: grant, of thy bountiful goodness; that we thy humble servants may continue in safety under their protection, and hereafter rejoice in their abiding fellowship; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            invId: "angels inv",
            mpHymnId: "eternal ruler of the sky",
            mpVandR: [
                "E_ven be_fore the An_gels will I sing praise un_to thee, O my God.",
                "I will wor_ship to_ward thy ho_ly tem_ple, and praise thy Name."
            ],
            mpBenId: "hga the angel",
            ep2HymnId: "angelic guardians blest",
            ep2VandR: [
                "E_ven be_fore the An_gels will I sing praise un_to thee, O my God.",
                "I will wor_ship to_ward thy ho_ly tem_ple, and praise thy Name."
            ],
            ep2MagId: "hga holy angels"
        }
    },
    {
        day: 3,
        month: 10,
        title: "Saint Thomas of Hereford",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst adorn thy Church with the angelic purity and glorious virtues of the blessed Bishop Thomas of Hereford: grant unto us thy servants; that, by the pleading of his merits, we may with him be worthy to be joined unto the company of Angels; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 4,
        month: 10,
        title: "Saint Francis of Assisi",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who dost ever delight to reveal thyself to the childlike and lowly of heart: grant that, following the example of blessed Francis, and aided by his prayers; we may count the wisdom of this world as foolishness and know only Jesus Christ and him crucified; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 5,
        month: 10,
        title: "Saint Faustina Kowalska",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Graciously hear us, O God of our salvation: that, like as we do rejoice in the festival of blessed Faustina, thy holy Virgin, so we may learn to follow her in all godly and devout affections; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, without end. Amen.",
        alternativeCollects: [
            "O God who didst endue thy holy Virgin Faustina, with grace to witness a holy life: grant that we, after her example and aided by her prayers, may be found ready when the Bridegroom cometh, and enter with him to the marriage feast; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "Virgin",
            "Religious"
        ]
    },
    {
        day: 6,
        month: 10,
        title: "Saint Bruno",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty and everlasting God, who dost prepare mansions in heaven for them that forsake the world: we humbly entreat thy boundless mercy; that at the intercession of blessed Bruno, thy Confessor, we may faithful to vows that we have made, and may obtain, to our eternal salvation, the rewards which thou hast promised to them that persevere unto the end; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious",
            "Confessor: Priest"
        ]
    },
    {
        day: 7,
        month: 10,
        title: "Our Lady of the Rosary",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, whose Only Begotten Son by his life, death, and Resurrection, hath purchased for us the rewards of eternal salvation: grant, we beseech thee; that meditating upon the mysteries of the Rosary, our devotion may bud forth as the rose in honour of the Blessed Virgin Mary; and that we may so follow the pattern of their teaching, that we may finally be made partakers of thy heavenly promises; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 8,
        month: 10,
        title: "Saint Denis, Bishop and Companions",
        subtitle: "Martyrs",
        shortTitle: "Saint Denis and Companions",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst strengthen blessed Denis, thy Martyr and Bishop, with the virtue constancy in his suffering, and didst vouchsafe to join unto him Rusticus and Eleutherius, for the preaching of thy glory to the heathen: grant us, we beseech thee, by their example, to despise the prosperity of this world, and to fear none of its adversities; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 8,
        month: 10,
        title: "Saint John Leonardi",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst wondrously vouchsafe to raise up blessed John Leonardi, thy Confessor, to spread abroad the faith among the nations, and through him didst gather a new family in thy Church for the instructing of the faithful: grant unto us thy servants, so to profit by his teaching; that we may attain unto eternal rewards; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary"
        ]
    },
    {
        day: 9,
        month: 10,
        title: "Saint John Henry Newman",
        subtitle: "Priest",
        patronNote: "Patron of the Ordinariate of Our Lady of Walsingham",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O God, who didst bestow upon thy Priest Saint John Henry Newman, the grace to follow thy kindly light and find peace in thy Church: graciously grant that, through his intercession and example, we may be led out of shadows and images into the fulness of thy truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ],
        supplements: {
            mpHymnId: "hail dearest patron well beloved master",
            mpBenId: "jhn this man",
            ep2HymnId: "hail dearest patron well beloved master",
            ep2MagId: "jhn every scribe"
        }
    },
    {
        day: 9,
        month: 10,
        title: "Saint John Henry Newman",
        subtitle: "Priest",
        patronNote: "Patron of the Ordinariate of Our Lady of Walsingham",
        regionNote: "Ordinariates of CSP and OLSC",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst bestow upon thy Priest Saint John Henry Newman, the grace to follow thy kindly light and find peace in thy Church: graciously grant that, through his intercession and example, we may be led out of shadows and images into the fulness of thy truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ],
        supplements: {
            mpHymnId: "hail dearest patron well beloved master",
            mpBenId: "jhn this man",
            ep2HymnId: "hail dearest patron well beloved master",
            ep2MagId: "jhn every scribe"
        }
    },
    {
        day: 10,
        month: 10,
        title: "Saint Paulinus of York",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, our Saviour, who didst send thy servant Paulinus to preach and to baptise, and so to build up thy Church: grant that, being inspired by his example, we may proclaim to the whole world thy truth; that with him we may receive the reward thou hast prepared for all thy faithful servants; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 11,
        month: 10,
        title: "Saint John XXIII",
        subtitle: "Pope",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty and eternal God, who in Pope Saint John the Twenty-third didst give to the whole world the shining example of a good shepherd: grant, we beseech thee; that, through his intercession, we may with joy spread abroad the fulness of Christian charity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 11,
        month: 10,
        title: "Saint Ethelburga",
        subtitle: "Abbess",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, O Lord, that the prayers of thy holy Abbess, blessed Ethelburga, may commend us unto thee: that we, who have no power of ourselves to help ourselves, may by her advocacy find favour in thy sight; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "O God, who to the blessed Abbess Ethelhurga gavest grace to imitate Christ in his poverty, and with humble heart to follow him to the end: grant that all who enter the path of Gospel perfection may neither look back nor go astray from the way; but hastening to thee without stumbling, may attain the crown of eternal life whereunto thou dost call them; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 12,
        month: 10,
        title: "Saint Wilfrid",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, who didst call our forebears to the light of by the preaching of thy servant Wilfrid: grant us, who keep his life and labour in remembrance, to glorify thy Name by following the example of his zeal and perseverance; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 13,
        month: 10,
        title: "Saint Edward the Confessor",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who hast crowned thy blessed Confessor King Edward with eternal glory: grant that we who venerate him on earth, may be found worthy to reign with him in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Holy Man"
        ]
    },
    {
        day: 14,
        month: 10,
        title: "Saint Callistus I",
        subtitle: "Pope and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst raise up Pope Saint Callistus to serve the Church and attend devoutly to Christ's faithful departed: strengthen us, we pray, by his witness to the faith; so that, rescued from the slavery of corruption, we may merit an incorruptible inheritance; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Pope or Bishop",
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 15,
        month: 10,
        title: "Saint Teresa of Jesus",
        subtitle: "Virgin and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Merciful God, who by thy Spirit didst raise up thy servant Saint Teresa of Jesus to reveal to thy Church the way of perfection: grant that her teaching may awaken in us a longing for holiness until, assisted by her intercession, we attain to the perfect union of love in Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Virgin"
        ],
        supplements: {
            ep2MagId: "doctor teresa"
        }
    },
    {
        day: 16,
        month: 10,
        title: "Saint Hedwig",
        subtitle: "Religious",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst tech blessed Hedwig to forsake the pomps and vanities of this life, for the humble following of the Cross: mercifully grant that, by her merits and example, we may learn to trample underfoot the transitory pleasures of this world, and cleaving steadfastly to the Cross of Christ to overcome all things contrary to our salvation; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 16,
        month: 10,
        title: "Saint Margaret Mary Alacoque",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Lord Jesus Christ, who unto thy holy Virgin Margaret Mary Alacoque didst reveal the unsearchable riches of thy Sacred Heart: grant us, by her merits and example, to love thee in all things and above all things, and so find in thy loving Heart an everlasting habitation; who livest and reignest with the Father in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin"
        ]
    },
    {
        day: 16,
        month: 10,
        title: "Saint Richard Gwyn",
        subtitle: "Martyr",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty God, by whose grace and power thy Martyr Richard was enabled to witness to the truth and to be faithful unto death: grant that we who now remember him before thee, may likewise so bear witness unto thee in this world; that we may receive with him the crown of glory that fadeth not away; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "Grant, we beseech thee, Almighty God: that we, who this day keep the heavenly birthday of blessed Richard thy holy Martyr, may by his prayers be stablished in the love of thy holy Name; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 17,
        month: 10,
        title: "Saint Ignatius of Antioch",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Feed us, O Lord, with the living Bread and make us drink deep of the cup of salvation: that, following the teaching of thy Bishop Ignatius, and rejoicing in the faith with which he embraced the death of a Martyr, we may be nourished for that eternal life which he ever desired; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop",
            "Confessor: Bishop"
        ]
    },
    {
        day: 18,
        month: 10,
        title: "Saint Luke",
        subtitle: "Evangelist",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "Almighty God, who didst call Saint Luke, whose praise is in the Gospel, to be an Evangelist and physician of the soul: may it please thee; that, by the wholesome medicines of the doctrine delivered by him, all the diseases of our souls may be healed; through the merits of Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Apostles"
        ]
    },
    {
        day: 19,
        month: 10,
        title: "Saints Jean de Br\xe9beuf and Isaac Jogues, Priests, and Companions, Martyrs",
        subtitle: "",
        shortTitle: "Saints Jean de Br\xe9beuf, Isaac Jogues and Companions",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who amongst the peoples of North America didst hallow the first fruits of the Faith both in the preaching and in the blood of many holy Martyrs: graciously grant by the intercession of Saints Jean de Br\xe9beuf, Isaac Jogues and Companions; that everywhere from day to day the harvest of souls may abound to the increase of thy faithful people; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 19,
        month: 10,
        title: "Saint Paul of the Cross",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "May the Priest Saint Paul, whose only love was the Cross, obtain for us thy grace, O Lord: so that, urged on more strongly by his example, we may each embrace our own cross with courage; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 19,
        month: 10,
        title: "Saint Frideswide",
        subtitle: "Abbess",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty everlasting God, the author of virtue and lover of virginity: grant us, we beseech thee; that as Saint Frideswide, thy Virgin and Abbess, was pleasing unto thee by the merit of her chastity, so by her prayers we may find favour with thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 22,
        month: 10,
        title: "Saint John Paul II",
        subtitle: "Pope",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who art rich in mercy and who didst will that Saint John Paul the Second should preside as Pope over thy universal Church: grant, we pray; that instructed by his teaching, we may open our hearts to the saving grace of Christ, the sole Redeemer of mankind; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 23,
        month: 10,
        title: "Saint John of Capistrano",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst raise up Saint John of Capistrano to comfort thy faithful people in tribulation: place us, we pray, under thy safe protection, and keep thy Church in everlasting peace; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary",
            "Religious"
        ]
    },
    {
        day: 24,
        month: 10,
        title: "Saint Anthony Mary Claret",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who for the evangelisation of peoples didst strengthen the Bishop Saint Anthony Mary Claret with admirable charity and long-suffering: grant, through his intercession; that, seeking the things that are thine, we may earnestly devote ourselves to winning our brethren for Christ; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary",
            "Confessor: Bishop"
        ]
    },
    {
        day: 25,
        month: 10,
        title: "Six Welsh Martyrs and their Companions",
        subtitle: "",
        regionNote: "Wales",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "Almighty God, who in our country raised up Martyrs from every walk of life to vindicate the authority of thy Church in teaching and worship: grant at their intercession, we pray thee; that all our people may be gathered once again to celebrate the same Sacraments under the one Shepherd, Jesus Christ thy Son; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 26,
        month: 10,
        title: "Saints Chad and Cedd",
        subtitle: "Bishops",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty and everlasting God, who didst enkindle the flame of thy love in the hearts of thy Bishops Chad and Cedd: grant to us, thy humble servants, the same faith and power of love; that, as we rejoice in their triumph, we may profit by their example and prayers; through Jesus Christ thy Son our Lord, Lord, who live liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 28,
        month: 10,
        title: "Saints Simon and Jude",
        subtitle: "Apostles",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "O Almighty God, who hast built thy Church upon the foundation of the Apostles and Prophets, Jesus Christ himself being the head corner-stone: grant us so to be joined together in unity of spirit by their doctrine; that we may be made an holy temple acceptable unto thee; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        athanasianCreed: true,
        commons: [
            "Apostles"
        ],
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear sts simon and jude"
        }
    },
    {
        day: 1,
        month: 11,
        title: "All Saints",
        subtitle: "",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "Almighty God, who hast knit together thine elect in one communion and fellowship, in the mystical body of thy Son Christ our Lord: grant us grace so to follow thy blessed Saints in all virtuous and godly living; that through their intercession we may come to those unspeakable joys, which thou hast prepared for them that unfeignedly love thee; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "o saviour jesu not alone",
            ep1VandR: [
                "Be glad, O ye /right_eous ' and re_joice in the Lord.",
                "And be /joy_ful ' all ye that are true of heart."
            ],
            ep1MagId: "as angels archangels",
            invId: "as inv",
            mpHymnId: "the fathers pardon from above",
            mpVandR: [
                "Let the Saints be joy_ful in glo_ry.",
                "Let them re_joice in their beds."
            ],
            mpBenId: "as the glorious",
            ep2HymnId: "the fathers pardon from above",
            ep2VandR: [
                "Let the Saints be joy_ful in glo_ry.",
                "Let them re_joice in their beds."
            ],
            ep2MagId: "as o how glorious"
        }
    },
    {
        day: 2,
        month: 11,
        title: "All Souls",
        type: "misc",
        rank: 3,
        optional: false,
        collect: "O God, the Creator and Redeemer of all them that believe: grant unto the souls of thy servants and handmaids the remission of all their sins; that as they have ever desired thy merciful pardon, so by the supplications of their brethren they may receive the same; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "O God, whose nature and property is ever to have mercy and to forgive: have compassion on the souls of thy servants and handmaids, and grant unto them, the remission of all their sins; that, being delivered from the bonds of this our mortal nature, they may be found worthy to pass into everlasting life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ]
    },
    {
        day: 3,
        month: 11,
        title: "Saint Martin de Porres",
        subtitle: "Religious",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst lead Saint Martin de Porres by the way of humility to heavenly glory: grant that we may so follow the example of his holiness; that we may be worthy to be exalted with him to heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Religious"
        ]
    },
    {
        day: 3,
        month: 11,
        title: "Saint Winefride",
        subtitle: "Virgin",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty everlasting God, who didst bestow on blessed Winefride the rewards of virginity: make us, we beseech thee, by her intercession, to lay aside the enticements of this world, and with her to win a throne of everlasting glory; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin"
        ]
    },
    {
        day: 4,
        month: 11,
        title: "Saint Charles Borromeo",
        subtitle: "Bishop",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Keep, O Lord, thy Church by the continual protection of Saint Charles Borromeo: that as his zeal for thy flock did render him glorious; so his intercession may ever make us fervent in thy love; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 6,
        month: 11,
        title: "Saint Illtud",
        subtitle: "Abbot",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Through to the example and intercession of Saint Illtud, O Lord: grant us the grace to seek thee in wisdom, and bring us to find thee in prayer; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 7,
        month: 11,
        title: "Saint Willibrord",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst vouchsafe to send thy blessed Saint Willibrord to preach thy glory to the nations: we humbly pray thee; that by his merits and intercession we may both see and know the things which we ought to do, and by thy mercy be enabled to perform the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 8,
        month: 11,
        title: "All Saints of England",
        subtitle: "",
        regionNote: "England",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "Grant, we beseech thee, Almighty God: that we may in all things be comforted by the intercession of holy Mary, Mother of God, of all the holy Apostles, Martyrs, Confessors and Virgins, and all the Saints of England (Wales): and that like as we do call to mind their godliness of life; so we may be effectually defended by their help; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            ep1HymnId: "o saviour jesu not alone",
            ep1VandR: [
                "Be glad, O ye right_eous and re_joice in the Lord.",
                "And be joy_ful all ye that are true of heart."
            ],
            ep1MagId: "as angels archangels",
            invId: "as inv",
            mpHymnId: "the fathers pardon from above",
            mpVandR: [
                "Let the Saints be joy_ful in glo_ry.",
                "Let them re_joice in their beds."
            ],
            mpBenId: "as the glorious",
            ep2HymnId: "the fathers pardon from above",
            ep2VandR: [
                "Let the Saints be joy_ful in glo_ry.",
                "Let them re_joice in their beds."
            ],
            ep2MagId: "as o how glorious"
        }
    },
    {
        day: 9,
        month: 11,
        title: "The Dedication of the Lateran Basilica",
        subtitle: "",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 5,
        optional: false,
        collect: "O most blessed Saviour, who didst vouchsafe thy gracious presence at the Feast of Dedication: be present with us at this time by thy Holy Spirit, and so possess our souls by thy grace; that we may be living temples, holy and acceptable unto thee; who livest and reignest with the Father, in the unity of the same Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Dedication of a Church"
        ]
    },
    {
        day: 10,
        month: 11,
        title: "Saint Leo the Great",
        subtitle: "Pope and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O Lord Jesus Christ, who didst strengthen thy holy Bishop and Doctor Pope Leo to maintain both by word and deed the verity of thy sacred Humanity: grant, we beseech thee; that guided by the light of his doctrine, we may earnestly defend the faith of thy holy Incarnation; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Holy Pope"
        ],
        supplements: {
            ep2MagId: "doctor leo"
        }
    },
    {
        day: 11,
        month: 11,
        title: "Saint Martin of Tours",
        subtitle: "Bishop",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who seest that we are not able to stand in our own strength: mercifully grant that, through the prayers of blessed Martin, thy Confessor and Bishop, we may be defended from all adversities; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 12,
        month: 11,
        title: "Saint Josaphat",
        subtitle: "Bishop and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Stir up in thy Church, we pray, O Lord, the Spirit that filled Saint Josaphat: that, as he laid down his life for the sheep; so through his intercession we, too, may be strengthened by the same Spirit and not fear to lay down our life for our brethren; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop",
            "Confessor: Bishop"
        ]
    },
    {
        day: 15,
        month: 11,
        title: "Saint Albert the Great",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who gavest grace unto blessed Albert, thy Bishop and Doctor, to become truly great in the subjection of human wisdom to divine faith: grant us, we beseech thee, so to follow in the footsteps of his teaching; that we may enjoy the perfect light in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor albert"
        }
    },
    {
        day: 16,
        month: 11,
        title: "Saint Margaret of Scotland",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst call thy servant Margaret to an earthly throne that she might advance thy heavenly kingdom, and didst endue her with zeal for thy Church and charity towards thy people: mercifully grant that we who ask her prayers and commemorate her example may be fruitful in good works, and attain to the glorious fellowship of thy Saints; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Matron or Holy Woman"
        ],
        supplements: {
            invId: "margaret of scotland inv"
        }
    },
    {
        day: 16,
        month: 11,
        title: "Saint Gertrude",
        subtitle: "Virgin",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst prepare a delightful dwelling for thyself in the heart of the Virgin Saint Gertrude: graciously bring light, through her intercession, to the darkness of our hearts; that we may joyfully experience thee present and at work within us; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin",
            "Religious"
        ]
    },
    {
        day: 16,
        month: 11,
        title: "Saint Edmund of Abingdon",
        subtitle: "Bishop",
        regionNote: "Britain",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God who, by the providence of thine abundant bounty, didst adorn thy Church with the merits of the wondrous life of blessed Edmund, thy Confessor and Bishop, and gladdened her with his glorious miracles: mercifully grant to us thy servants; that by his example we may learn to amend our lives, and by his intercession be defended against all adversities; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 17,
        month: 11,
        title: "Saint Elizabeth of Hungary",
        subtitle: "Religious",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O Lord God, who didst teach Saint Elizabeth of Hungary to recognize and to reverence Christ in the poor of this world: grant that we, being strengthened by her example and assisted by her prayers, may so love and serve the afflicted and those in need that we may honour thy Son, the servant King; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Matron or Holy Woman"
        ],
        supplements: {
            invId: "elizabeth of hungary inv"
        }
    },
    {
        day: 17,
        month: 11,
        title: "Saint Hilda",
        subtitle: "Abbess",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty and everlasting God, who didst endow thy Abbess Hilda with purity and strength: grant by her intercession; we may subdue our souls and bodies to thy most holy will; through Jesus Christ thy S thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Abbot or Abbess"
        ]
    },
    {
        day: 17,
        month: 11,
        title: "Saint Hugh of Lincoln",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst endow thy servant Saint Hugh of Lincoln with a wise and cheerful boldness and didst teach him to commend to earthly rulers the discipline of a holy life: by his intercession, give us grace like him to be bold in the service of the Gospel, putting our confidence in Christ alone; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 18,
        month: 11,
        title: "Dedication of the Basilicas of Saints Peter and Paul",
        subtitle: "Apostles",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Defend thy Church, O Lord, by the protection of the holy Apostles: that, as she received from them the beginnings of her knowledge of things divine; so through them she may receive, even to the end of the world, an increase in heavenly grace; through Jesus Christ thy Son our Lord, who liveth a and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Dedication of a Church"
        ]
    },
    {
        day: 20,
        month: 11,
        title: "Saint Edmund",
        subtitle: "Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, of unspeakable, mercy, who didst give thy blessed Saint Edmund grace to overcome the enemy by dying for thy Name: mercifully grant to us thy servants; that by intercession we may be found worthy to conquer and subdue the temptations of our ancient adversary; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr"
        ]
    },
    {
        day: 21,
        month: 11,
        title: "The Presentation of the Blessed Virgin Mary",
        subtitle: "",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty and everlasting God, who by the overshadowing of the Holy Spirit didst prepare the body and soul of the glorious Virgin Mother Mary to be a dwelling-place for thy Son: grant that we who rejoice in her Presentation may at her tender intercession be kept unspotted, and made a pure temple for his dwelling; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 22,
        month: 11,
        title: "Saint Cecilia",
        subtitle: "Virgin and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who makest us glad with the yearly festival of blessed Cecilia, thy Virgin and Martyr: grant that we who venerate her in our service, may also follow the example of her godly life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 23,
        month: 11,
        title: "Saint Clement I",
        subtitle: "Pope and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O everlasting Shepherd, favourably look upon thy flock: and keep it with perpetual protection, through the intercession of blessed Clement, thy Pope and Martyr, whom thou didst appoint to be shepherd of the whole Church; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Pope or Bishop",
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 23,
        month: 11,
        title: "Saint Columban",
        subtitle: "Abbot",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who in Saint Columban wonderfully didst join the work of evangelisation to zeal for the monastic life: grant, we pray, that through his intercession and example, we may strive to seek thee above all things, and to bring increase to thy faithful people; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary",
            "Abbot or Abbess"
        ]
    },
    {
        day: 24,
        month: 11,
        title: "Saint Andrew Dung-Lac, Priest, and Companions, Martyrs",
        subtitle: "",
        shortTitle: "Saint Andrew Dung-Lac and Companions",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, source and origin of all fatherhood, who kept the Martyrs Saint Andrew Dung-L\u0227c and his Companions faithful to the Cross of thy Son, even to the shedding of their blood: grant, through their intercession; that, spreading thy love among our brethren, we may be thy children both in name and in truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Several Martyrs"
        ]
    },
    {
        day: 25,
        month: 11,
        title: "Saint Catherine of Alexandria",
        subtitle: "Virgin and Martyr",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, whose dwelling-place is in the pure of heart: grant we beseech thee; that we who venerate the memory of the Martyr Catherine, thy faithful bride, may have grace to follow the example of her holiness and courage; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 30,
        month: 11,
        title: "Saint Andrew",
        subtitle: "Apostle",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 7,
        optional: false,
        collect: "Almighty God, who didst give such grace unto thy holy Apostle Saint Andrew, that he readily obeyed the calling of thy Son Jesus Christ, and followed him without delay: grant unto us all; that we, being called by thy holy Word, may forthwith give up ourselves obediently to fulfil thy holy commandments; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        athanasianCreed: true,
        commons: [
            "Apostles"
        ],
        supplements: {
            ep1HymnId: "lord of creation bow thine ear o christ to hear st andrew",
            ep1MagId: "andrew one of the two",
            ep2MagId: "andrew one of the two"
        }
    },
    {
        day: 1,
        month: 12,
        title: "Saint Edmund Campion",
        subtitle: "Priest and Martyr",
        type: "memorial",
        rank: 10,
        optional: true,
        collect: "Almighty and everliving God, who gavest thy Martyr Edmund Campion courage to witness to the Gospel of Christ, even unto the giving of his life: grant that, by his prayers; we may endure all suffering for love of thee, and may seek thee with all our hearts, for thou alone art the source of life; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr",
            "Confessor: Priest"
        ]
    },
    {
        day: 1,
        month: 12,
        title: "Saint Edmund Campion",
        subtitle: "Priest and Martyr",
        regionNote: "Britain",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "Almighty and everliving God, who gavest thy Martyr Edmund Campion courage to witness to the Gospel of Christ, even unto the giving of his life: grant that, by his prayers; we may endure all suffering for love of thee, and may seek thee with all our hearts, for thou alone art the source of life; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr",
            "Confessor: Priest"
        ]
    },
    {
        day: 3,
        month: 12,
        title: "Saint Francis Xavier",
        subtitle: "Priest",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who by the preaching and wondrous works of Saint Francis Xavier didst unite unto thy Church the peoples of India: mercifully grant that we who venerate his glorious merits, may likewise follow him in all virtuous and godly living; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Missionary",
            "Confessor: Priest"
        ]
    },
    {
        day: 4,
        month: 12,
        title: "Saint John Damascene",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Almighty everlasting God, who, for the defence of the veneration of sacred images, didst endue blessed John Damascene with heavenly doctrine and wondrous strength of spirit: grant unto us, by his intercession and example; that we may imitate the virtues and perceive the advocacy of those whose images we honour; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 6,
        month: 12,
        title: "Saint Nicholas",
        subtitle: "Bishop",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst adorn thy blessed Bishop Saint Nicholas with power to work many and great miracles: grant, we beseech thee; that by his prayers and merits, we may be delivered from the fires of everlasting torment; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Bishop"
        ]
    },
    {
        day: 7,
        month: 12,
        title: "Saint Ambrose",
        subtitle: "Bishop and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst set thy blessed Bishop Saint Ambrose in thy Church as a Doctor and defender of the Catholic faith and an example of apostolic fortitude: grant, we beseech thee; that aided by his intercession, we may escape the dangers of error, and never be ashamed to confess thy truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Bishop"
        ],
        supplements: {
            ep2MagId: "doctor ambrose"
        }
    },
    {
        day: 8,
        month: 12,
        title: "The Immaculate Conception of the Blessed Virgin Mary",
        subtitle: "",
        shortTitle: "The Immaculate Conception",
        type: "solemnity",
        rank: 3,
        optional: false,
        collect: "O God, who in the foreknowledge of thy Son's most precious death didst consecrate for him a dwelling-place by the Immaculate Conception of the Blessed Virgin Mary: mercifully grant that she who was preserved from all defilement, may evermore pray for us, until we attain unto thee in purity of heart; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ],
        supplements: {
            ep1MagId: "icbvm all generations",
            invId: "icbvm inv",
            mpBenId: "icbvm today let us",
            ep2MagId: "icbvm let us celebrate"
        }
    },
    {
        day: 9,
        month: 12,
        title: "Saint Juan Diego Cuauhtlatoatzin",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who by means of Saint Juan Diego didst show the love of the most holy Virgin Mary for thy people: grant, through his intercession; that, by following the counsels our Mother gave at Guadalupe, we may be ever constant in fulfilling thy will; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Any Holy Man"
        ]
    },
    {
        day: 10,
        month: 12,
        title: "Our Lady of Loreto",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, O Lord God, that we thy servants may enjoy y perpetual health of mind and body: and, at the glorious intercession the blessed and ever-Virgin Mary, may be delivered from present sadness, and may rejoice in continual gladness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 10,
        month: 12,
        title: "Saint John Roberts",
        subtitle: "Priest and Martyr",
        regionNote: "Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Preserve among thy people, O Lord, we pray, that faith which was handed down from thine Apostles, assured by the authority of the Holy See, and professed by the blood of Saint John Roberts, thy holy Martyr; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "One Martyr",
            "Confessor: Priest"
        ]
    },
    {
        day: 11,
        month: 12,
        title: "Saint Damasus I",
        subtitle: "Pope",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we pray thee, O Lord: that we may constantly exalt the merits of thy Martyrs, whom Pope Saint Damasus so venerated and loved; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ]
    },
    {
        day: 12,
        month: 12,
        title: "Our Lady of Guadalupe",
        subtitle: "",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who hast willed that under the special patronage of the most Blessed Virgin Mary of Guadalupe, we should receive an abundant measure of unceasing favours: grant us, thy suppliant people; that as we rejoice to honour her upon earth, so we may enjoy the vision of her in heaven; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Blessed Virgin Mary"
        ]
    },
    {
        day: 13,
        month: 12,
        title: "Saint Lucy",
        subtitle: "Virgin and Martyr",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O Lord our Saviour, who art the true Light that lighteneth every man: graciously hear us; that like as we do rejoice in the festival of blessed Lucy, thy Virgin and Martyr, so we may learn to follow her in all godly and devout affections; who liveth and reigneth with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Virgin Martyr"
        ]
    },
    {
        day: 14,
        month: 12,
        title: "Saint John of the Cross",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 10,
        optional: false,
        collect: "O God, who didst inspire thy holy Confessor Saint John with an ardent love of self-denial and of the Cross: grant that by constantly following his example, we may attain to everlasting glory; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Priest"
        ],
        supplements: {
            ep2MagId: "doctor john"
        }
    },
    {
        day: 21,
        month: 12,
        title: "Saint Peter Canisius",
        subtitle: "Priest and Doctor of the Church",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, who didst strengthen Saint Peter Canisius, thy Confessor, for the defence of the Catholic faith: mercifully grant that by his example and teaching, the erring may be made wise unto salvation, and the faithful may stand fast in the confession of truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Doctor of the Church",
            "Confessor: Priest"
        ],
        supplements: {
            ep2MagId: "doctor peter"
        }
    },
    {
        day: 23,
        month: 12,
        title: "Saint John of Kanty",
        subtitle: "Priest",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Grant, we beseech thee, Almighty God: that after the example of blessed John of Kanty, thy Confessor, we may so advance in the knowledge of the Saints, and likewise so learn to show mercy to all men; that by his merits we may be counted worthy to attain thy pardon; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Priest"
        ]
    },
    {
        day: 26,
        month: 12,
        title: "Saint Stephen",
        subtitle: "The First Martyr",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "Grant, O Lord, that in all our sufferings here upon earth, for the testimony of thy truth, we may steadfastly look up to heaven, and by faith behold the glory that shall be revealed: and, being filled with the Holy Spirit, may learn to love and bless our persecutors, by the example of thy first Martyr Saint Stephen; who prayed for his murderers to thee, O blessed Jesus, who standest at the right hand of God to succour all those that suffer for thee, our Mediator and Advocate; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            invId: "stephen inv",
            mpHymnId: "saint of god elect and precious",
            mpVandR: [
                "De_vout men car_ried Ste_phen to his bu_ri_al.",
                "And made great la_men_ta_tion o_ver him."
            ],
            mpBenId: "stephen but stephen",
            ep2HymnId: "saint of god elect and precious",
            ep2VandR: [
                "Ste_phen saw the hea_vens o_pened.",
                "He saw and en_tered: how bless_ed is the man un_to whom hea_ven stood o_pen."
            ],
            ep2MagId: "stephen devout men"
        }
    },
    {
        day: 27,
        month: 12,
        title: "Saint John",
        subtitle: "Apostle and Evangelist",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "Merciful Lord, we beseech thee to cast thy bright beams of light upon thy Church: that she being enlightened by the doctrine of thy blessed Apostle and Evangelist Saint John, may so walk in the light of thy truth, that she may at length attain to the light of everlasting life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Apostles"
        ],
        supplements: {
            mpVandR: [
                "This is the di_sci_ple which tes_ti_fi_eth of these things.",
                "And we know that his tes_ti_mo_ny is true."
            ],
            mpBenId: "john this is that john",
            ep2VandR: [
                "Right wor_thy of ho_nour is bless_ed John the A_po_stle.",
                "Who leaned on the Lord's bo_som at sup_per."
            ],
            ep2MagId: "john this saying"
        }
    },
    {
        day: 28,
        month: 12,
        title: "The Holy Innocents",
        subtitle: "Martyrs",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O Almighty God, who out of the mouths of babes and nurslings hast ordained strength, and madest infants to glorify thee by their deaths: mortify and kill all vices in us; and so strengthen us by thy grace, that by the innocency of our lives, and constancy of our faith, even unto death, we may glorify thy holy Name; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        supplements: {
            invId: "martyr inv",
            mpHymnId: "all hail ye little martyr flowers",
            mpVandR: [
                "He_rod was ex_ceed_ing wroth, and slew many chil_dren.",
                "In Beth_le_hem of Ju_daea, the ci_ty of Da_vid."
            ],
            mpBenId: "hi these are they",
            ep2HymnId: "all hail ye little martyr flowers",
            ep2VandR: [
                "Un_der the throne of God all the Saints cry out.",
                "A_venge our blood, O Lord our God."
            ],
            ep2MagId: "hi many innocent"
        }
    },
    {
        day: 29,
        month: 12,
        title: "Saint Thomas Becket",
        subtitle: "Bishop and Martyr",
        patronNote: "Patron of Pastoral Clergy in England and Wales",
        regionNote: "Britain",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O God, for whose Church the glorious Bishop Thomas Becket fell by the swords of wicked men: grant, we beseech thee; that all who call upon him for succour may be profited by the obtaining of all that they desire; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop",
            "Confessor: Bishop"
        ]
    },
    {
        day: 29,
        month: 12,
        title: "Saint Thomas Becket",
        subtitle: "Bishop and Martyr",
        patronNote: "Patron of Pastoral Clergy in England and Wales",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "O God, for whose Church the glorious Bishop Thomas Becket fell by the swords of wicked men: grant, we beseech thee; that all who call upon him for succour may be profited by the obtaining of all that they desire; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Martyr: Bishop",
            "Confessor: Bishop"
        ]
    },
    {
        day: 31,
        month: 12,
        title: "Saint Sylvester I",
        subtitle: "Pope",
        type: "memorial",
        rank: 12,
        optional: true,
        collect: "Be merciful to the people of thy flock, O Lord, eternal Shepherd of our souls: and keep us in thy continual protection at the intercession of Saint Sylvester, whom thou didst raise up to be shepherd of the whole Church; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        commons: [
            "Confessor: Holy Pope"
        ]
    }
];


const $2d95fb1756754bc6$var$DAYS_OF_THE_WEEK = [
    "sun",
    "mon",
    "tues",
    "wed",
    "thur",
    "fri",
    "sat"
];
const $2d95fb1756754bc6$var$getEaster = function Easter(Y) {
    var C = Math.floor(Y / 100);
    var N = Y - 19 * Math.floor(Y / 19);
    var K = Math.floor((C - 17) / 25);
    var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor(I / 30);
    I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
    var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    var L = I - J;
    var M = 3 + Math.floor((L + 40) / 44);
    var D = L + 28 - 31 * Math.floor(M / 4);
    return {
        date: D,
        month: M
    };
};
const $2d95fb1756754bc6$var$createCalendar = (year)=>{
    let day = new Date(`January 1, ${year}`);
    const calendar = {
        year: year,
        days: []
    };
    let weekOfTheYear = 0;
    let dayOfTheYear = 0;
    while(day.getFullYear() === year){
        if ($2d95fb1756754bc6$var$DAYS_OF_THE_WEEK[day.getDay()] === "sun") weekOfTheYear++;
        calendar.days.push({
            year: year,
            date: day.getDate(),
            dayOfTheWeek: $2d95fb1756754bc6$var$DAYS_OF_THE_WEEK[day.getDay()],
            month: day.getMonth() + 1,
            weekOfTheYear: weekOfTheYear,
            dayOfTheYear: dayOfTheYear,
            celebrations: [],
            transferNotes: []
        });
        // Increment the day
        day = new Date(day);
        day.setDate(day.getDate() + 1);
        dayOfTheYear++;
    }
    return calendar;
};
const $2d95fb1756754bc6$var$getDateMethods = (calendar, date, month, skip)=>{
    return {
        placeCelebration: (c)=>{
            const day = calendar.days.find((day)=>day.date === date && day.month === month);
            if (day !== undefined) {
                let celebration;
                if (typeof c === "function") celebration = c(day);
                else celebration = c;
                if (celebration.sundayAfterEpiphany) celebration = {
                    ep1HymnId: "creator of the earth and sky",
                    ep1VandR: [
                        "Let our eve_ning prayer come up be_fore thee, O Lord.",
                        "And let thy mer_cy come down up_on us."
                    ],
                    invId: "inv sun ep",
                    mpHymnId: "this day the first of days was made",
                    mpVandR: [
                        "The Lord is King, and hath put on glo_rious ap_pa_rel.",
                        "The Lord hath put on his ap_pa_rel, and gir_ded him_self with strength."
                    ],
                    ep2HymnId: "o blest creator of the light",
                    ep2VandR: [
                        "Let our eve_ning prayer come up be_fore thee, O Lord.",
                        "And let thy mer_cy come down up_on us."
                    ],
                    weekdays: celebration.weekdays ?? [
                        {},
                        {},
                        {},
                        {},
                        {},
                        {}
                    ],
                    ...celebration
                };
                if (celebration.sundayAfterTrinity) celebration = {
                    ...celebration,
                    ep1HymnId: "o trinity of blessed light",
                    ep1VandR: [
                        "Let our eve_ning prayer come up be_fore thee, O Lord.",
                        "And let thy mer_cy come down up_on us."
                    ],
                    invId: "inv sun trin",
                    mpHymnId: "father we praise thee now the night is over",
                    mpVandR: [
                        "The Lord is King, and hath put on glo_rious ap_pa_rel.",
                        "The Lord hath put on his ap_pa_rel, and gir_ded him_self with strength."
                    ],
                    ep2HymnId: "o blest creator of the light",
                    ep2VandR: [
                        "Let our eve_ning prayer come up be_fore thee, O Lord.",
                        "And let thy mer_cy come down up_on us."
                    ],
                    weekdays: celebration.weekdays ?? [
                        {},
                        {},
                        {},
                        {},
                        {},
                        {}
                    ]
                };
                if (celebration.sundayInLent) celebration = {
                    ...celebration,
                    weekdays: (celebration.weekdays ?? [
                        {},
                        {},
                        {},
                        {},
                        {},
                        {}
                    ]).map((weekday)=>{
                        return {
                            invId: celebration.invId,
                            mpHymnId: celebration.mpHymnId,
                            mpVandR: celebration.mpVandR,
                            ep2HymnId: celebration.ep2HymnId,
                            ep2VandR: celebration.ep2VandR,
                            rank: 9,
                            ...weekday
                        };
                    })
                };
                if (celebration.sundayInAdvent) celebration = {
                    ...celebration,
                    weekdays: (celebration.weekdays ?? [
                        {},
                        {},
                        {},
                        {},
                        {},
                        {}
                    ]).map((weekday)=>{
                        return {
                            invId: "ad1 the lord the king ferias",
                            mpHymnId: "high word of god who once didst come",
                            mpVandR: [
                                "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                                "Make straight the paths of our God."
                            ],
                            ep2HymnId: "creator of the stars of night",
                            ep2VandR: [
                                "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
                                "Let the earth o_pen, and let it bring forth sal_va_tion."
                            ],
                            rank: weekday.rank ?? weekday.title?.includes("December") ? 9 : 13,
                            ...weekday
                        };
                    })
                };
                if (celebration.sundayAfterEaster) celebration = {
                    ...celebration,
                    weekdays: (celebration.weekdays ?? [
                        {},
                        {},
                        {},
                        {},
                        {},
                        {}
                    ]).map((weekday)=>{
                        return {
                            invId: celebration.invId,
                            mpHymnId: celebration.mpHymnId,
                            mpVandR: celebration.mpVandR,
                            ep2HymnId: celebration.ep2HymnId,
                            ep2VandR: celebration.ep2VandR,
                            mpBenId: weekday.benId ?? celebration.mpBenId,
                            ep2MagId: weekday.magId ?? celebration.ep2MagId,
                            ...weekday
                        };
                    })
                };
                if (celebration.label === "lent-5" || celebration.label === "palm-sunday") celebration = {
                    ...celebration,
                    weekdays: celebration.weekdays?.map((weekday, index)=>{
                        return {
                            invId: celebration.invId,
                            mpHymnId: index % 2 === (celebration.label === "lent-5" ? 1 : 0) ? "sing my tongue the glorious battle" : "thirty years among us dwelling",
                            mpVandR: celebration.mpVandR,
                            ep2HymnId: "the royal banners forward go",
                            ep2VandR: celebration.ep2VandR,
                            ...weekday
                        };
                    })
                };
                day.celebrations.push(celebration);
                const dayIndex = calendar.days.findIndex((day)=>day.date === date && day.month === month);
                const weekdayNames = [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ];
                const weekdayRank = celebration.title.includes("Advent") ? 13 : celebration.title.includes("Lent") || celebration.title.includes("Palm Sunday") || celebration.title.includes("Holy Week") ? 13 : 13.1;
                celebration.weekdays?.forEach((weekday, weekdayIndex)=>{
                    calendar.days[dayIndex + weekdayIndex + 1]?.celebrations.push({
                        type: weekday.title === "Ash Wednesday" ? "misc" : "feria",
                        deletesFeria: weekday.title === "Ash Wednesday",
                        title: weekday.title ?? `${weekdayNames[weekdayIndex]} following ${celebration.shortTitle ?? celebration.title}`,
                        rank: weekday.rank ?? (weekday.emberDay ? 10 : weekdayRank),
                        label: `${celebration.label}-${weekdayNames[weekdayIndex].toLocaleLowerCase()}`,
                        collect: weekday.collect ?? celebration.collect,
                        alternativeCollects: weekday.alternativeCollects ?? celebration.alternativeCollects,
                        invId: weekday.invId ?? [
                            "inv mon",
                            "inv tues",
                            "inv wed",
                            "inv thur",
                            "inv fri",
                            "inv sat"
                        ][weekdayIndex],
                        mpBenId: weekday.benId ?? celebration.mpBenId,
                        ep2MagId: weekday.magId ?? celebration.ep2MagId,
                        mpHymnId: weekday.mpHymnId ?? [
                            "o splendour of gods glory bright",
                            "the winged herald of the day",
                            "ye clouds and darkness hosts of night",
                            "lo golden light rekindles day",
                            "eternal glory of the sky",
                            "the dawn is sprinkling in the east"
                        ][weekdayIndex],
                        mpVandR: weekday.mpVandR ?? [
                            "O sa_tis_fy us with thy mer_cy.",
                            "That we may re_joice and be glad."
                        ],
                        ep2HymnId: weekday.ep2HymnId ?? [
                            "o boundless wisdom god most high",
                            "earths mighty maker whose command",
                            "most holy lord and god of heaven",
                            "almighty god who from the flood",
                            "maker of man who from thy throne",
                            celebration.label.includes("trinity") ? "o trinity of blessed light" : "creator of the earth and sky"
                        ][weekdayIndex],
                        ep2VandR: weekday.ep2VandR ?? [
                            "Let our eve_ning prayer come up be_fore thee, O Lord.",
                            "And let thy mer_cy come down up_on us."
                        ],
                        mpProperPsalms: weekday.mpProperPsalms,
                        ep2ProperPsalms: weekday.epProperPsalms
                    });
                });
            // if (
            //     celebration.type === "sunday" ||
            //     celebration.operatesAsSunday
            // ) {
            //     const dayIndex = calendar.days.findIndex(
            //         (day) => day.date === date && day.month === month
            //     );
            //     const weekdayRank = celebration.title.includes("Advent")
            //         ? 13
            //         : celebration.title.includes("Lent")
            //         ? 13
            //         : 13.1;
            //     const monday = calendar.days[dayIndex + 1];
            //     monday?.celebrations.push({
            //         type: "feria",
            //         title: `Monday following ${
            //             celebration.shortTitle ?? celebration.title
            //         }`,
            //         rank: weekdayRank,
            //         label: `${celebration.label}-monday`,
            //     });
            //     const tuesday = calendar.days[dayIndex + 2];
            //     tuesday?.celebrations.push({
            //         type: "feria",
            //         title: `Tuesday following ${
            //             celebration.shortTitle ?? celebration.title
            //         }`,
            //         rank: weekdayRank,
            //         label: `${celebration.label}-tuesday`,
            //     });
            //     const wednesday = calendar.days[dayIndex + 3];
            //     wednesday?.celebrations.push({
            //         type: "feria",
            //         title: `Wednesday following ${
            //             celebration.shortTitle ?? celebration.title
            //         }`,
            //         rank: weekdayRank,
            //         label: `${celebration.label}-wednesday`,
            //     });
            //     const thursday = calendar.days[dayIndex + 4];
            //     thursday?.celebrations.push({
            //         type: "feria",
            //         title: `Thursday following ${
            //             celebration.shortTitle ?? celebration.title
            //         }`,
            //         rank: weekdayRank,
            //         label: `${celebration.label}-thursday`,
            //     });
            //     const friday = calendar.days[dayIndex + 5];
            //     friday?.celebrations.push({
            //         type: "feria",
            //         title: `Friday following ${
            //             celebration.shortTitle ?? celebration.title
            //         }`,
            //         rank: weekdayRank,
            //         label: `${celebration.label}-friday`,
            //     });
            //     const saturday = calendar.days[dayIndex + 6];
            //     saturday?.celebrations.push({
            //         type: "feria",
            //         title: `Saturday following ${
            //             celebration.shortTitle ?? celebration.title
            //         }`,
            //         rank: weekdayRank,
            //         label: `${celebration.label}-saturday`,
            //     });
            //     saturday?.celebrations.push({
            //         type: "memorial",
            //         title: `Saint Mary on Saturday`,
            //         rank: weekdayRank - 1,
            //         optional: true,
            //         label: `saint-mary-on-saturday`,
            //     });
            // }
            }
            if (day) return $2d95fb1756754bc6$var$getDateMethods(calendar, day.date, day.month, skip);
            else return $2d95fb1756754bc6$var$getDateMethods(calendar, 0, 0, true);
        },
        plus: (amount, unit)=>{
            const startIndex = calendar.days.findIndex((day)=>day.date === date && day.month === month);
            const endIndex = startIndex + amount * (unit === "weeks" ? 7 : 1);
            const day = calendar.days[endIndex];
            if (day) return $2d95fb1756754bc6$var$getDateMethods(calendar, day.date, day.month, skip);
            else return $2d95fb1756754bc6$var$getDateMethods(calendar, 0, 0, true);
        },
        minus: (amount, unit)=>{
            return $2d95fb1756754bc6$var$getDateMethods(calendar, date, month, skip).plus(-amount, unit);
        },
        getNthAfter: (amount, dayOfTheWeek)=>{
            let index = calendar.days.findIndex((day)=>day.date === date && day.month === month);
            while(amount !== 0){
                index++;
                if (!calendar.days[index]) return $2d95fb1756754bc6$var$getDateMethods(calendar, 0, 0, true);
                if (calendar.days[index].dayOfTheWeek === dayOfTheWeek) amount--;
            }
            const day = calendar.days[index];
            return $2d95fb1756754bc6$var$getDateMethods(calendar, day.date, day.month, skip);
        },
        getNthBefore: (amount, dayOfTheWeek)=>{
            let index = calendar.days.findIndex((day)=>day.date === date && day.month === month);
            while(amount !== 0){
                index--;
                if (!calendar.days[index]) return $2d95fb1756754bc6$var$getDateMethods(calendar, 0, 0, true);
                if (calendar.days[index].dayOfTheWeek === dayOfTheWeek) amount--;
            }
            const day = calendar.days[index];
            return $2d95fb1756754bc6$var$getDateMethods(calendar, day.date, day.month, skip);
        }
    };
};
const $2d95fb1756754bc6$var$modify = (calendar)=>{
    return {
        cal: $2d95fb1756754bc6$var$modify,
        onDate: (date, month)=>{
            return $2d95fb1756754bc6$var$getDateMethods(calendar, date, month, false);
        },
        onCelebration: (label)=>{
            const day = calendar.days.find((day)=>day.celebrations.find((celebration)=>celebration.label === label) !== undefined);
            if (day) return $2d95fb1756754bc6$var$getDateMethods(calendar, day.date, day.month, false);
            else return $2d95fb1756754bc6$var$getDateMethods(calendar, 0, 0, true);
        }
    };
};
const $2d95fb1756754bc6$var$getOptionsAndOutranked = (celebrations, regionLabelsAllowed)=>{
    const regionLabels = new Set(celebrations.filter((c)=>c.regionNote).flatMap((c)=>c.regionNote.split(", ")));
    const finalCelebrations = celebrations.filter((celebration)=>regionLabelsAllowed.includes("*") || !celebration.regionNote || celebration.regionNote.split(", ").filter((regionNote)=>regionLabelsAllowed.includes(regionNote)).length > 0);
    const basicFeria = finalCelebrations.find((celebration)=>celebration.type === "feria" && !celebration.deletesFeria);
    const highestRankIs9 = finalCelebrations.find((celebration)=>celebration.rank === 9) !== undefined && finalCelebrations.find((celebration)=>celebration.rank < 9 && !celebration.regionNote) === undefined;
    const sortedCelebrations = finalCelebrations.map((celebration)=>{
        if (celebration.type === "memorial" && highestRankIs9) return {
            ...celebration,
            optional: true,
            specialManner: true
        };
        else return celebration;
    }).map((celebration)=>{
        if (basicFeria && celebration.deletesFeria) return {
            ...basicFeria,
            ...celebration
        };
        else return celebration;
    }).filter((celebration, celebrationIndex)=>{
        if (finalCelebrations.slice(0, celebrationIndex).find((c)=>c.label === celebration.label)) return false;
        else return true;
    }).sort((a, b)=>a.rank - b.rank) ?? [];
    const outrankedCelebrations = {};
    const deletedCelebrations = {};
    sortedCelebrations.forEach((celebration)=>{
        sortedCelebrations.forEach((otherCelebration)=>{
            if (otherCelebration.rank < celebration.rank && !otherCelebration.optional && !highestRankIs9) outrankedCelebrations[celebration.label] = true;
            if (otherCelebration.type === "sunday" && celebration.type === "feria") deletedCelebrations[celebration.label] = true;
            if (otherCelebration.type === "sunday" && celebration.type === "sunday" && otherCelebration.rank < celebration.rank) deletedCelebrations[celebration.label] = true;
            if (otherCelebration.type === "feria" && celebration.type === "feria" && otherCelebration.rank < celebration.rank) deletedCelebrations[celebration.label] = true;
            if (otherCelebration.deletesFeria && celebration.type === "feria") deletedCelebrations[celebration.label] = true;
        });
    });
    const sortedOutrankedCelebrations = sortedCelebrations.filter((celebration)=>!deletedCelebrations[celebration.label] && outrankedCelebrations[celebration.label]);
    return {
        options: sortedCelebrations.filter((celebration)=>!deletedCelebrations[celebration.label] && !outrankedCelebrations[celebration.label]),
        outranked: sortedOutrankedCelebrations,
        regionLabels: regionLabels
    };
};
const $2d95fb1756754bc6$export$f64a227ad5260d8c = (year, epiphanyTransferred, ascensionTransferred, corpusChristiTransferred, regionLabelsAllowed)=>{
    const days = $2d95fb1756754bc6$export$1c780ae2703443e0(year - 1, epiphanyTransferred, ascensionTransferred, corpusChristiTransferred).days.concat($2d95fb1756754bc6$export$1c780ae2703443e0(year, epiphanyTransferred, ascensionTransferred, corpusChristiTransferred).days).concat($2d95fb1756754bc6$export$1c780ae2703443e0(year + 1, epiphanyTransferred, ascensionTransferred, corpusChristiTransferred).days);
    return days.slice(0, days.length - 1).map((day, dayIndex)=>{
        const tomorrow = days[dayIndex + 1];
        const optionsToday = $2d95fb1756754bc6$var$getOptionsAndOutranked(day.celebrations, regionLabelsAllowed);
        const optionsTomorrow = $2d95fb1756754bc6$var$getOptionsAndOutranked(tomorrow.celebrations, regionLabelsAllowed);
        const feastsAndSolemnitiesOptionsTomorrow = optionsTomorrow.options.filter((op)=>op.type === "feast" && op.feastHasFirstEvensong || op.type === "solemnity" || op.type === "sunday").filter((op)=>!op.doesntHaveFirstEvensong).map((op)=>{
            return {
                ...op,
                rank: op.rank + 0.05
            };
        });
        const feastsAndSolemnitiesOutrankedTomorrow = optionsTomorrow.outranked.filter((op)=>op.type === "feast" && op.feastHasFirstEvensong || op.type === "solemnity" || op.type === "sunday").filter((op)=>!op.doesntHaveFirstEvensong);
        const morningOptions = optionsToday.options;
        const morningOutranked = optionsToday.outranked;
        // BEGIN HACKS FOR PARTICLAR DAYS
        const extraEveningCelebrations = [];
        if (day.month === 4 && day.date === 24) {
            const feria = day.celebrations.find((c)=>c.type === "feria");
            if (feria) extraEveningCelebrations.push({
                ...feria,
                label: `${feria.label}-australia`,
                regionNote: "Australia",
                rank: 7
            });
        }
        if (day.month === 4 && day.date === 25) {
            const ep1StMark = feastsAndSolemnitiesOptionsTomorrow.find((c)=>c.label === "saint-mark-australia");
            if (ep1StMark) ep1StMark.rank -= 0.1;
        }
        // END HACKS FOR PARTICULAR DAYS
        const eveningOptionsAndOutranked = $2d95fb1756754bc6$var$getOptionsAndOutranked(optionsToday.options.concat(feastsAndSolemnitiesOptionsTomorrow).concat(extraEveningCelebrations), regionLabelsAllowed);
        const eveningOptions = eveningOptionsAndOutranked.options.filter((c)=>c.label !== "saint-mary-on-saturday" && c.label !== "anzac-day-australia" && c.label !== "saturday-after-whitsun").filter((c)=>!c.doesntHaveSeconeEvensong);
        const eveningOutranked = eveningOptions.find((option)=>option.deletesEve) !== undefined ? [] : eveningOptionsAndOutranked.outranked.concat(morningOutranked).concat(feastsAndSolemnitiesOutrankedTomorrow).filter((c)=>c.label !== "saint-mary-on-saturday" && c.label !== "anzac-day-australia" && c.label !== "saturday-after-whitsun");
        return {
            year: day.year,
            day: day.dayOfTheWeek,
            date: day.date,
            month: day.month,
            morningOptions: morningOptions,
            morningOutranked: morningOutranked,
            eveningOptions: eveningOptions,
            eveningOutranked: eveningOutranked,
            isFirstEvensong: feastsAndSolemnitiesOptionsTomorrow.map((c)=>c.label),
            transferNotes: day.transferNotes,
            regionLabels: optionsToday.regionLabels
        };
    });
};
const $2d95fb1756754bc6$export$1c780ae2703443e0 = (year, epiphanyTransferred, ascensionTransferred, corpusChristiTransferred)=>{
    const calendar = $2d95fb1756754bc6$var$createCalendar(year);
    // The end of Christmas until Ephipany Day
    $2d95fb1756754bc6$var$modify(calendar).onDate(1, 1).placeCelebration({
        label: "mary-mother-of-god",
        type: "solemnity",
        rank: 3,
        title: "Mary, the Holy Mother of God",
        collect: "O God, who by the fruitful virginity of Blessed Mary hast bestowed upon mankind the reward of eternal salvation: grant, we beseech thee, that we may know the help of her intercession, through whom we have been accounted worthy to receive the Author of our life, Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        ep1HymnId: "from east to west from shore to shore",
        ep1VandR: [
            "The Word was made flesh, al_le_lu_ia.",
            "And dwelt a_mong us, al_le_lu_ia."
        ],
        ep1MagId: "mmg for his great love",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Word was made flesh, al_le_lu_ia.",
            "And dwelt a_mong us, al_le_lu_ia."
        ],
        mpBenId: "mmg a great and wondrous",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "mmg heirs are we"
    });
    const showEpiphanySwitch = calendar.days.find((d)=>d.date === 6 && d.month === 1)?.dayOfTheWeek !== "sun";
    const isEpiphanyTransferred = showEpiphanySwitch && epiphanyTransferred;
    const baptismCelebration = {
        label: "baptism-of-the-lord",
        type: "feast",
        rank: 5,
        title: "The Baptism of the Lord",
        feastHasFirstEvensong: true,
        collect: "Heavenly Father, whose blessed Son Jesus Christ did take our nature upon him, and was baptised for our sakes in the river Jordan: mercifully grant that we, being regenerate and made thy children by adoption and grace, may also be partakers of thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        ep1HymnId: "why impious herod shouldst thou fear",
        ep1VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep1MagId: "botl the soldier",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "botl john the",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "botl the springs",
        sundayAfterEpiphany: true
    };
    if (isEpiphanyTransferred) {
        const relevantSunday = calendar.days.find((d)=>d.month === 1 && d.date > 1 && d.date <= 8 && d.dayOfTheWeek === "sun");
        $2d95fb1756754bc6$var$modify(calendar).onDate(1, 1).getNthAfter(1, "sun").placeCelebration({
            label: "epiphany",
            type: "solemnity",
            rank: 3,
            title: "The Epiphany of the Lord",
            ep1HymnId: "why impious herod shouldst thou fear",
            ep1VandR: [
                "The kings of Thar_sis and of the isles shall give pre_sents.",
                "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
            ],
            ep1MagId: "ep the sages beholding",
            invId: "the christ hath been",
            mpHymnId: "send down by god to this worlds frame",
            mpVandR: [
                "O wor_ship the Lord, al_le_lu_ia.",
                "All ye an_gels of his, al_le_lu_ia."
            ],
            mpBenId: "ep today to her heavenly",
            ep2HymnId: "why impious herod shouldst thou fear",
            ep2VandR: [
                "The kings of Thar_sis and of the isles shall give pre_sents.",
                "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
            ],
            ep2MagId: "ep we celebrate a holy day",
            collect: "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            athanasianCreed: true
        });
        if (relevantSunday?.date === 7 || relevantSunday?.date === 8) $2d95fb1756754bc6$var$modify(calendar).onDate(1, 1).getNthAfter(1, "sun").getNthAfter(1, "mon").placeCelebration(baptismCelebration);
        else $2d95fb1756754bc6$var$modify(calendar).onDate(6, 1).getNthAfter(1, "sun").placeCelebration(baptismCelebration);
    } else {
        $2d95fb1756754bc6$var$modify(calendar).onDate(6, 1).placeCelebration({
            label: "epiphany",
            type: "solemnity",
            rank: 3,
            title: "The Epiphany of the Lord",
            ep1HymnId: "why impious herod shouldst thou fear",
            ep1VandR: [
                "The kings of Thar_sis and of the isles shall give pre_sents.",
                "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
            ],
            ep1MagId: "ep the sages beholding",
            invId: "the christ hath been",
            mpHymnId: "send down by god to this worlds frame",
            mpVandR: [
                "O wor_ship the Lord, al_le_lu_ia.",
                "All ye an_gels of his, al_le_lu_ia."
            ],
            mpBenId: "ep today to her heavenly",
            ep2HymnId: "why impious herod shouldst thou fear",
            ep2VandR: [
                "The kings of Thar_sis and of the isles shall give pre_sents.",
                "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
            ],
            ep2MagId: "ep we celebrate a holy day",
            collect: "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            athanasianCreed: true
        });
        $2d95fb1756754bc6$var$modify(calendar).onDate(6, 1).getNthAfter(1, "sun").placeCelebration(baptismCelebration);
    }
    const epiphanyDate = calendar.days.findIndex((d)=>d.celebrations.find((c)=>c.label === "epiphany") !== undefined) + 1;
    const baptismDate = calendar.days.findIndex((d)=>d.celebrations.find((c)=>c.label === "baptism-of-the-lord") !== undefined) + 1;
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("epiphany").getNthBefore(1, "sun").placeCelebration({
        label: "christmas-2",
        type: "sunday",
        rank: 6,
        title: "The Second Sunday of Christmas",
        shortTitle: "Christmas II",
        ep1HymnId: "come thou redeemer of the earth",
        ep1VandR: [
            "Tom_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
            "And the Sa_viour of the world shall reign o_ver us."
        ],
        ep1MagId: "nl2 as many as",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        mpBenId: "nl2 and we beheld",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "nl2 thine almighty word",
        collect: "Almighty God, who didst wonderfully create man in thine own image, and didst yet more wonderfully restore him: grant, we beseech thee, that as thy Son our Lord Jesus Christ was made in the likeness of men, so we may be made partakers of the divine nature; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (!isEpiphanyTransferred || epiphanyDate > 2) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(1, "days").placeCelebration({
        type: "feria",
        title: `The Ninth Day of Christmas`,
        rank: 13,
        label: "day-of-christmas-9",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        mpBenId: "nl2 and we beheld",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "nl2 thine almighty word",
        collect: "Almighty God, who didst wonderfully create man in thine own image, and didst yet more wonderfully restore him: grant, we beseech thee, that as thy Son our Lord Jesus Christ was made in the likeness of men, so we may be made partakers of the divine nature; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (!isEpiphanyTransferred || epiphanyDate > 3) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(2, "days").placeCelebration({
        type: "feria",
        title: `The Tenth Day of Christmas`,
        rank: 13,
        label: "day-of-christmas-10",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        mpBenId: "nl2 and we beheld",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "nl2 thine almighty word",
        collect: "Almighty God, who didst wonderfully create man in thine own image, and didst yet more wonderfully restore him: grant, we beseech thee, that as thy Son our Lord Jesus Christ was made in the likeness of men, so we may be made partakers of the divine nature; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (epiphanyDate < 3) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(2, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "transferred-epiphany-1",
        title: "Additional day after the Epiphany",
        ep1HymnId: "why impious herod shouldst thou fear",
        ep1VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep1MagId: "ep the sages beholding",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "ep today to her heavenly",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "ep we celebrate a holy day",
        collect: "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (!isEpiphanyTransferred || epiphanyDate > 4) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(3, "days").placeCelebration({
        type: "feria",
        title: `The Eleventh Day of Christmas`,
        rank: 13,
        label: "day-of-christmas-11",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        mpBenId: "nl2 and we beheld",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "nl2 thine almighty word",
        collect: "Almighty God, who didst wonderfully create man in thine own image, and didst yet more wonderfully restore him: grant, we beseech thee, that as thy Son our Lord Jesus Christ was made in the likeness of men, so we may be made partakers of the divine nature; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (epiphanyDate < 4) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(3, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "transferred-epiphany-1",
        title: "Additional day after the Epiphany",
        ep1HymnId: "why impious herod shouldst thou fear",
        ep1VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep1MagId: "ep the sages beholding",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "ep today to her heavenly",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "ep we celebrate a holy day",
        collect: "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (!isEpiphanyTransferred || epiphanyDate > 5) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(4, "days").placeCelebration({
        type: "feria",
        title: `The Twelfth Day of Christmas`,
        rank: 13,
        label: "day-of-christmas-12",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        mpBenId: "nl2 and we beheld",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "nl2 thine almighty word",
        collect: "Almighty God, who didst wonderfully create man in thine own image, and didst yet more wonderfully restore him: grant, we beseech thee, that as thy Son our Lord Jesus Christ was made in the likeness of men, so we may be made partakers of the divine nature; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (epiphanyDate < 5) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(4, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "transferred-epiphany-1",
        title: "Additional day after the Epiphany",
        ep1HymnId: "why impious herod shouldst thou fear",
        ep1VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep1MagId: "ep the sages beholding",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "ep today to her heavenly",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "ep we celebrate a holy day",
        collect: "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (epiphanyDate < 6 && isEpiphanyTransferred) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(5, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "transferred-epiphany-1",
        title: "Additional day after the Epiphany",
        ep1HymnId: "why impious herod shouldst thou fear",
        ep1VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep1MagId: "ep the sages beholding",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "ep today to her heavenly",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "ep we celebrate a holy day",
        collect: "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (epiphanyDate >= 7) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(5, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "extra-jan-6",
        title: "The Thirteenth Day of Christmastide",
        ep1HymnId: "come thou redeemer of the earth",
        ep1VandR: [
            "Tom_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
            "And the Sa_viour of the world shall reign o_ver us."
        ],
        ep1MagId: "nl2 as many as",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        mpBenId: "nl2 and we beheld",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "nl2 thine almighty word",
        collect: "Almighty God, who didst wonderfully create man in thine own image, and didst yet more wonderfully restore him: grant, we beseech thee, that as thy Son our Lord Jesus Christ was made in the likeness of men, so we may be made partakers of the divine nature; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        doesntHaveSeconeEvensong: epiphanyDate === 7
    });
    if (epiphanyDate >= 8) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(6, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "extra-jan-7",
        title: "The Fourteenth Day of Christmastide",
        ep1HymnId: "come thou redeemer of the earth",
        ep1VandR: [
            "Tom_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
            "And the Sa_viour of the world shall reign o_ver us."
        ],
        ep1MagId: "nl2 as many as",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        mpBenId: "nl2 and we beheld",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "nl2 thine almighty word",
        collect: "Almighty God, who didst wonderfully create man in thine own image, and didst yet more wonderfully restore him: grant, we beseech thee, that as thy Son our Lord Jesus Christ was made in the likeness of men, so we may be made partakers of the divine nature; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        doesntHaveSeconeEvensong: epiphanyDate === 8
    });
    if (epiphanyDate < 7) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(6, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "jan-7",
        title: "7 January",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "j7 from the east",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "j7 seeing the star",
        collect: baptismDate <= 7 ? "Heavenly Father, whose blessed Son Jesus Christ did take our nature upon him, and was baptised for our sakes in the river Jordan: mercifully grant that we, being regenerate and made thy children by adoption and grace, may also be partakers of thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." : "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    if (epiphanyDate < 8) $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(7, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "jan-8",
        title: "8 January",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "j8 there are the",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "j8 light of light",
        collect: baptismDate <= 8 ? "Heavenly Father, whose blessed Son Jesus Christ did take our nature upon him, and was baptised for our sakes in the river Jordan: mercifully grant that we, being regenerate and made thy children by adoption and grace, may also be partakers of thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." : "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(8, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "jan-9",
        title: "9 January",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "j9 we have seen",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "j9 herod inquired",
        collect: baptismDate <= 9 ? "Heavenly Father, whose blessed Son Jesus Christ did take our nature upon him, and was baptised for our sakes in the river Jordan: mercifully grant that we, being regenerate and made thy children by adoption and grace, may also be partakers of thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." : "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(9, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "jan-10",
        title: "10 January",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "j10 many nations",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "j10 all they from",
        collect: baptismDate <= 10 ? "Heavenly Father, whose blessed Son Jesus Christ did take our nature upon him, and was baptised for our sakes in the river Jordan: mercifully grant that we, being regenerate and made thy children by adoption and grace, may also be partakers of thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." : "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(10, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "jan-11",
        title: "11 January",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "j11 they that",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "j11 the sages",
        collect: baptismDate <= 11 ? "Heavenly Father, whose blessed Son Jesus Christ did take our nature upon him, and was baptised for our sakes in the river Jordan: mercifully grant that we, being regenerate and made thy children by adoption and grace, may also be partakers of thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." : "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("mary-mother-of-god").plus(11, "days").placeCelebration({
        type: "feria",
        rank: 13,
        label: "jan-12",
        title: "12 January",
        invId: "the christ hath been",
        mpHymnId: "send down by god to this worlds frame",
        mpVandR: [
            "O wor_ship the Lord, al_le_lu_ia.",
            "All ye an_gels of his, al_le_lu_ia."
        ],
        mpBenId: "j12 great is",
        ep2HymnId: "why impious herod shouldst thou fear",
        ep2VandR: [
            "The kings of Thar_sis and of the isles shall give pre_sents.",
            "The kings of A_ra_bi_a and Sa_ba shall bring gifts."
        ],
        ep2MagId: "j12 the sages",
        collect: baptismDate <= 12 ? "Heavenly Father, whose blessed Son Jesus Christ did take our nature upon him, and was baptised for our sakes in the river Jordan: mercifully grant that we, being regenerate and made thy children by adoption and grace, may also be partakers of thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." : "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    // Easter and related feasts
    const easter = $2d95fb1756754bc6$var$getEaster(year);
    $2d95fb1756754bc6$var$modify(calendar).onDate(easter.date, easter.month).placeCelebration({
        label: "easter-day",
        type: "solemnity",
        rank: 1,
        title: "Easter Day",
        deletesEve: true,
        athanasianCreed: true,
        mpBenId: "e1 and very early",
        ep2MagId: "e1 and when they looked",
        collect: "Almighty God, who through thine Only Begotten Son Jesus Christ hast overcome death, and opened unto us the gate of everlasting life: we humbly beseech thee; that as by thy special grace thou dost put into our minds good desires, so by thy continual help we may bring the same to good effect; through the same Jesus Christ thy Son, our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(1, "sat").placeCelebration({
        label: "holy-saturday",
        type: "misc",
        rank: 1,
        title: "Holy Saturday",
        invId: "passiontide inv",
        mpHymnId: "thirty years among us dwelling",
        mpVandR: [
            "De_li_ver me from mine e_ne_mies, O God.",
            "De_fend me from them that rise up a_gainst me."
        ],
        mpBenId: "hw the women also sitting",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep2MagId: "hw the chief priests",
        collect: "Grant, O Lord, that as we are baptised into the death of thy blessed Son our Saviour Jesus Christ: so by continually mortifying our corrupt affections we may be buried with him; and that, through the grave, and gate of death, we may pass to our joyful resurrection; for his merits, who died, and was buried, and rose again for us, thy Son Jesus Christ our Lord. Amen.",
        deletesFeria: true,
        deletesEve: true
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(1, "fri").placeCelebration({
        label: "good-friday",
        type: "misc",
        rank: 1,
        title: "Good Friday",
        invId: "passiontide inv",
        mpHymnId: "sing my tongue the glorious battle",
        mpVandR: [
            "De_li_ver me from mine e_ne_mies, O God.",
            "De_fend me from them that rise up a_gainst me."
        ],
        mpBenId: "hw they set up",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep2MagId: "hw when he had received",
        collect: "Almighty God: we beseech thee graciously to behold this thy family, for which our Lord Jesus Christ was contented to be betrayed, and given up into the hands of wicked men, and to suffer death upon the Cross; who now liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        deletesFeria: true
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(1, "thur").placeCelebration({
        label: "maundy-thursday",
        rank: 2,
        type: "feast",
        title: "Thursday in Holy Week",
        commonlyCalled: "Maundy Thursday",
        invId: "passiontide inv",
        ep1HymnId: "the royal banners forward go",
        mpHymnId: "thirty years among us dwelling",
        mpVandR: [
            "De_li_ver me from mine e_ne_mies, O God.",
            "De_fend me from them that rise up a_gainst me."
        ],
        mpBenId: "hw now he that betrayed",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep2MagId: "hw and as they were eating",
        collect: "Almighty God: we beseech thee graciously to behold this thy family, for which our Lord Jesus Christ was contented to be betrayed, and given up into the hands of wicked men, and to suffer death upon the Cross; who now liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        deletesFeria: true,
        deletesEve: true
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(1, "wed").placeCelebration({
        label: "wed-before-easter",
        rank: 2,
        type: "misc",
        title: "Wednesday in Holy Week",
        invId: "passiontide inv",
        mpHymnId: "sing my tongue the glorious battle",
        mpVandR: [
            "De_li_ver me from mine e_ne_mies, O God.",
            "De_fend me from them that rise up a_gainst me."
        ],
        mpBenId: "hw simon sleepest thou",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep2MagId: "hw a maid said",
        collect: "O God, who didst will that thy Son should suffer death upon the Cross that thou mightest deliver us from the snares of the enemy: grant that by the merits of his Passion and Death we may know the power of his Resurrection; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        deletesFeria: true,
        deletesEve: true
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(1, "tues").placeCelebration({
        label: "tues-before-easter",
        rank: 2,
        type: "misc",
        title: "Tuesday in Holy Week",
        invId: "passiontide inv",
        mpHymnId: "thirty years among us dwelling",
        mpVandR: [
            "De_li_ver me from mine e_ne_mies, O God.",
            "De_fend me from them that rise up a_gainst me."
        ],
        mpBenId: "hw before the day",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep2MagId: "hw i have power",
        collect: "O Lord God, whose blessed Son, our Saviour, gave his back to the smiters and hid not his face from shame: grant us grace to take joyfully the suffering of the present time, in full assurance of the glory that shall be revealed; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        deletesFeria: true
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(1, "mon").placeCelebration({
        label: "mon-before-easter",
        rank: 2,
        type: "misc",
        title: "Monday in Holy Week",
        invId: "passiontide inv",
        mpHymnId: "sing my tongue the glorious battle",
        mpVandR: [
            "De_li_ver me from mine e_ne_mies, O God.",
            "De_fend me from them that rise up a_gainst me."
        ],
        mpBenId: "hw o father glorify",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep2MagId: "hw thou couldest have",
        collect: "Almighty God, whose most dear Son went not up to joy but first he suffered pain, and entered not into glory before he was crucified: mercifully grant that we, walking in the way of the Cross, may find it none other than the way of life and peace; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        deletesFeria: true
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(1, "mon").placeCelebration({
        label: "easter-monday",
        rank: 2,
        type: "misc",
        title: "Monday in the Octave of Easter",
        deletesFeria: true,
        mpBenId: "e1 jesus joined himself",
        ep2MagId: "e1 what manner",
        collect: "O God, whose blessed Son did manifest himself to his disciples in the breaking of bread: open, we pray thee, the eyes of our faith; that we may behold thee in all thy works; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(1, "tues").placeCelebration({
        label: "easter-tuesday",
        rank: 2,
        type: "misc",
        title: "Tuesday in the Octave of Easter",
        deletesFeria: true,
        mpBenId: "e1 jesus stood in",
        ep2MagId: "e1 behold my hands",
        collect: "O God, who by the glorious Resurrection of thy Son Jesus Christ destroyed death and brought life and immortality to light: grant that we, who have been raised with him, may abide in his presence and rejoice in the hope of eternal glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(1, "wed").placeCelebration({
        label: "easter-wednesday",
        rank: 2,
        type: "misc",
        title: "Wednesday in the Octave of Easter",
        deletesFeria: true,
        mpBenId: "e1 cast the net",
        ep2MagId: "e1 jesus said to",
        collect: "O God, who dost gladden us with the yearly solemnity of the Resurrection of thy Son Jesus Christ our Lord: mercifully grant that we may so observe this temporal feast; that we may be found worthy to attain to everlasting felicity; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(1, "thur").placeCelebration({
        label: "easter-thursday",
        rank: 2,
        type: "misc",
        title: "Thursday in the Octave of Easter",
        deletesFeria: true,
        mpBenId: "e1 many stood",
        ep2MagId: "e1 they have taken",
        collect: "Almighty and everlasting God, who in the Paschal Mystery hast established the new covenant of reconciliation: grant that all who have been reborn into the fellowship of Christ's Body may show forth in their lives what they profess by their faith; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(1, "fri").placeCelebration({
        label: "easter-friday",
        rank: 2,
        type: "misc",
        title: "Friday in the Octave of Easter",
        deletesFeria: true,
        mpBenId: "e1 the eleven",
        ep2MagId: "e1 all power",
        collect: "O God, who hast united the diversity of nations in the confession of thy of thy Name: grant that they who are born again in the font of Baptism, may be of one mind in faith and in godliness of life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(1, "sat").placeCelebration({
        label: "easter-saturday",
        rank: 2,
        type: "misc",
        title: "Saturday in the Octave of Easter",
        deletesFeria: true,
        mpBenId: "e1 they ran both",
        collect: "We thank thee, heavenly Father, for that thou hast delivered us from the dominion of sin and death and hast brought us unto the kingdom of thy Son: and we pray thee that, as by his death he hath recalled us to life, so by his love he may raise us to joys eternal; who liveth and reigneth with thee in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(7, "sun").placeCelebration({
        label: "whitsun",
        rank: 2,
        type: "sunday",
        title: "Pentecost",
        commonlyCalled: "Whitsunday",
        athanasianCreed: true,
        ep1HymnId: "when christ our lord had passed once more",
        ep1VandR: [
            "They were all filled with the Ho_ly Ghost.",
            "And be_gan to speak."
        ],
        ep1MagId: "pen i will not",
        invId: "pen inv",
        mpHymnId: "when christ our lord had passed once more",
        mpVandR: [
            "They were all filled with the Ho_ly Ghost.",
            "And be_gan to speak."
        ],
        mpBenId: "pen receive ye",
        ep2HymnId: "rejoice the year upon its way",
        ep2VandR: [
            "The A_po_stles did speak with o_ther tongues.",
            "The won_der_ful works of God."
        ],
        ep2MagId: "pen today are fulfilled",
        collect: "O God, who as at this time didst teach the hearts of thy faithful people, by sending to them the light of thy Holy Spirit: grant us by the same Spirit to have a right judgement in all things, and evermore to rejoice in his holy comfort; through the merits of Christ Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("whitsun").getNthAfter(1, "mon").placeCelebration({
        label: "monday-after-whitsun",
        rank: 9,
        type: "misc",
        title: "Monday in Whitsun Week",
        deletesFeria: true,
        invId: "pen inv",
        mpHymnId: "when christ our lord had passed once more",
        mpVandR: [
            "They were all filled with the Ho_ly Ghost.",
            "And be_gan to speak."
        ],
        mpBenId: "pen god so loved",
        ep2HymnId: "rejoice the year upon its way",
        ep2VandR: [
            "The A_po_stles did speak with o_ther tongues.",
            "The won_der_ful works of God."
        ],
        ep2MagId: "pen if a man love",
        collect: "Send, we beseech thee, Almighty God, thy Holy Spirit into our hearts: that he may direct and rule us according to thy will, comfort us in our afflictions, defend us from all error, and lead us into all truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("whitsun").getNthAfter(1, "tues").placeCelebration({
        label: "tuesday-after-whitsun",
        rank: 9,
        type: "misc",
        title: "Tuesday in Whitsun Week",
        deletesFeria: true,
        invId: "pen inv",
        mpHymnId: "when christ our lord had passed once more",
        mpVandR: [
            "They were all filled with the Ho_ly Ghost.",
            "And be_gan to speak."
        ],
        mpBenId: "pen i am the door",
        ep2HymnId: "rejoice the year upon its way",
        ep2VandR: [
            "The A_po_stles did speak with o_ther tongues.",
            "The won_der_ful works of God."
        ],
        ep2MagId: "pen peace i leave",
        collect: "Grant, we beseech thee, merciful God: that thy Church, being gathered together in unity by thy Holy Spirit, may manifest thy power among all peoples to the glory of thy Name; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("whitsun").getNthAfter(1, "wed").placeCelebration({
        label: "wednesday-after-whitsun",
        rank: 9,
        type: "misc",
        title: "Ember Wednesday in Whitsun Week",
        deletesFeria: true,
        invId: "pen inv",
        mpHymnId: "when christ our lord had passed once more",
        mpVandR: [
            "They were all filled with the Ho_ly Ghost.",
            "And be_gan to speak."
        ],
        mpBenId: "pen i am the living",
        ep2HymnId: "rejoice the year upon its way",
        ep2VandR: [
            "The A_po_stles did speak with o_ther tongues.",
            "The won_der_ful works of God."
        ],
        ep2MagId: "pen i am the living which came",
        collect: "We beseech thee, O Lord, that the Comforter who proceedeth from thee may enlighten our minds: and lead us, as thy Son hath promised, into all truth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("whitsun").getNthAfter(1, "thur").placeCelebration({
        label: "thursday-after-whitsun",
        rank: 9,
        type: "misc",
        title: "Thursday in Whitsun Week",
        deletesFeria: true,
        invId: "pen inv",
        mpHymnId: "when christ our lord had passed once more",
        mpVandR: [
            "They were all filled with the Ho_ly Ghost.",
            "And be_gan to speak."
        ],
        mpBenId: "pen jesus called unto",
        ep2HymnId: "rejoice the year upon its way",
        ep2VandR: [
            "The A_po_stles did speak with o_ther tongues.",
            "The won_der_ful works of God."
        ],
        ep2MagId: "pen the spirit which",
        collect: "Almighty God, who as at this time didst open the way of eternal life to every race and nation by the promised gift of thy Holy Spirit: shed abroad this gift throughout the world by the preaching of the Gospel, that it may reach to the ends of the earth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("whitsun").getNthAfter(1, "thur").placeCelebration({
        label: "oljc-eternal-high-priest",
        rank: 8,
        type: "feast",
        title: "Our Lord Jesus Christ, Eternal High Priest",
        regionNote: "England, Wales",
        collect: "O God, who, for the glory of thy majesty and the salvation of mankind, didst appoint thine Only Begotten Son supreme and eternal Priest: vouchsafe that they, whom he hath chosen to be the ministers and stewards of his mysteries, may be found faithful in fulfilling the ministry they have received; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.//Almighty God, who as at this time didst open the way of eternal life to every race and nation by the promised gift of thy Holy Spirit: shed abroad this gift throughout the world by the preaching of the Gospel, that it may reach to the ends of the earth; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen.",
        doesntHaveFirstEvensong: true,
        invId: "oljchp inv",
        mpHymnId: "when the patriarch was returning",
        mpVandR: [
            "I will re_ceive the cup of sal_va_tion.",
            "And call u_pon the Name of the Lord."
        ],
        mpBenId: "oljchp this is my body",
        ep2HymnId: "sing o earth for thy redemption",
        ep2VandR: [
            "Thou hast a_noin_ted my head with oil.",
            "And my cup shall be full."
        ],
        ep2MagId: "oljchp behold i will send"
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("whitsun").getNthAfter(1, "fri").placeCelebration({
        label: "friday-after-whitsun",
        rank: 9,
        type: "misc",
        title: "Ember Friday in Whitsun Week",
        deletesFeria: true,
        invId: "pen inv",
        mpHymnId: "when christ our lord had passed once more",
        mpVandR: [
            "They were all filled with the Ho_ly Ghost.",
            "And be_gan to speak."
        ],
        mpBenId: "pen jesus said",
        ep2HymnId: "rejoice the year upon its way",
        ep2VandR: [
            "The A_po_stles did speak with o_ther tongues.",
            "The won_der_ful works of God."
        ],
        ep2MagId: "pen but the comforter",
        collect: "Most merciful God, we beseech thee: that thy Church, being gathered together in the Holy Spirit, may nevermore be disquieted by the assaults of her enemies; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("whitsun").getNthAfter(1, "sat").placeCelebration({
        label: "saturday-after-whitsun",
        rank: 9,
        type: "misc",
        title: "Ember Saturday in Whitsun Week",
        deletesFeria: true,
        invId: "pen inv",
        mpHymnId: "when christ our lord had passed once more",
        mpVandR: [
            "They were all filled with the Ho_ly Ghost.",
            "And be_gan to speak."
        ],
        mpBenId: "pen the love of god",
        collect: "We beseech thee, O Lord, graciously pour the Holy Spirit into our hearts: by whose wisdom we were created, and by whose providence we are governed; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(8, "sun").placeCelebration({
        label: "trinity-sunday",
        rank: 3,
        type: "solemnity",
        title: "Trinity Sunday",
        operatesAsSunday: true,
        athanasianCreed: true,
        ep1HymnId: "be present holy trinity",
        ep1VandR: [
            "Let us bless the Fa_ther and the Son with the Ho_ly Ghost.",
            "Let us praise him and mag_ni_fy him for e_ver."
        ],
        ep1MagId: "trin thanks o god",
        collect: "Almighty and everlasting God, who hast given unto us thy servants grace, by the confession of a true faith, to acknowledge the glory of the eternal Trinity, and in the power of the divine majesty to worship the Unity: we beseech thee; that this holy faith may evermore be our defence against all adversities; who livest and reignest, ever one God, world without end. Amen.",
        invId: "trin inv",
        mpHymnId: "father most holy merciful and tender",
        mpVandR: [
            "Let us bless the Fa_ther and the Son with the Ho_ly Ghost.",
            "Let us praise him and mag_ni_fy him for e_ver."
        ],
        mpBenId: "trin blessed be",
        ep2HymnId: "be present holy trinity",
        ep2VandR: [
            "Bless_ed art thou, O Lord, in the fir_ma_ment of hea_ven.",
            "A_bove all to be praised and glo_ri_fied for e_ver."
        ],
        ep2MagId: "trin thee o god",
        sundayAfterEpiphany: true
    });
    const corpusChristi = {
        label: "corpus-christi",
        rank: 3,
        type: "solemnity",
        title: "The Most Holy Body and Blood of Christ",
        commonlyCalled: "Corpus Christi",
        ep1HymnId: "at this our solemn feast",
        ep1VandR: [
            "Thou ga_vest them bread from hea_ven, al_le_lu_ia.",
            "Con_tain_ing in it_self all sweet_ness, al_le_lu_ia."
        ],
        invId: "corpus inv",
        mpHymnId: "of the glorious body telling",
        mpVandR: [
            "He ma_keth peace in thy bor_ders, al_le_lu_ia.",
            "And fill_eth thee with the flour of wheat, al_le_lu_ia."
        ],
        mpBenId: "corpus i am",
        ep1MagId: "corpus o how sweet",
        ep2HymnId: "at this our solemn feast",
        ep2VandR: [
            "Thou ga_vest them bread from hea_ven, al_le_lu_ia.",
            "Con_tain_ing in it_self all sweet_ness, al_le_lu_ia."
        ],
        ep2MagId: "corpus o sacred",
        collect: "O God, who in a wonderful Sacrament hast left unto us a memorial of thy Passion: grant us, we beseech thee, so to venerate the sacred mysteries of thy Body and Blood; that we may ever know within ourselves the fruit of thy redemption; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    };
    if (corpusChristiTransferred) $2d95fb1756754bc6$var$modify(calendar).onCelebration("trinity-sunday").getNthAfter(1, "sun").placeCelebration(corpusChristi);
    else $2d95fb1756754bc6$var$modify(calendar).onCelebration("trinity-sunday").getNthAfter(1, "thur").placeCelebration(corpusChristi);
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("trinity-sunday").getNthAfter(2, "fri").placeCelebration({
        label: "sacred-heart-of-jesus",
        rank: 3,
        type: "solemnity",
        title: "The Most Sacred Heart of Jesus",
        ep1MagId: "sh i am come",
        ep1HymnId: "jesu creator of the world",
        ep1VandR: [
            "Take my yoke u_pon you, and learn of me.",
            "For I am meek and low_ly of heart."
        ],
        invId: "sh inv",
        mpHymnId: "what proud attack our sins have launched",
        mpVandR: [
            "With joy shall ye draw wa_ter.",
            "From the wells of sal_va_tion."
        ],
        mpBenId: "sh now these things",
        ep2HymnId: "jesu creator of the world",
        ep2VandR: [
            "With joy shall ye draw wa_ter.",
            "From the wells of sal_va_tion."
        ],
        ep2MagId: "sh but when they",
        collect: "O God, who hast suffered the Heart of thy Son to be wounded by our sins, and in that very Heart hast bestowed on us the abundant riches of thy love: grant, we beseech thee; that the devout homage of our hearts which we render unto him, may of thy mercy be deemed a recompense acceptable in thy sight; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("trinity-sunday").getNthAfter(2, "sat").placeCelebration({
        label: "immacuate-heart-of-mary",
        rank: 10,
        type: "memorial",
        title: "The Immaculate Heart of the Blessed Virgin Mary",
        commons: [
            "Blessed Virgin Mary"
        ],
        collect: "Almighty and everlasting God, who in the heart of the Blessed Virgin Mary didst prepare an habitation meet for the Holy Spirit: mercifully grant that we, celebrating with devout mind the festival of the same Immaculate Heart, may be enabled to live after thine own Heart; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
    });
    const dateOfSeptuagesima = calendar.days.findIndex((d)=>d.year === year && d.celebrations.find((c)=>c.label === "septuagesima") !== undefined);
    const dateOfCandlemas = calendar.days.findIndex((d)=>d.year === year && d.celebrations.find((c)=>c.label === "the-presentation-of-the-lord") !== undefined);
    const candlemasIsAfterSeptuagesima = dateOfCandlemas > dateOfSeptuagesima;
    $2d95fb1756754bc6$var$modify(calendar).onDate(2, 2).placeCelebration({
        label: "the-presentation-of-the-lord",
        title: "The Presentation of the Lord",
        commonlyCalled: "Candlemas",
        type: "feast",
        feastHasFirstEvensong: true,
        rank: 5,
        optional: false,
        collect: "Almighty and everliving God, we humbly beseech thy majesty: that, as thine Only Begotten Son was this day presented in the temple in substance of our flesh; so we may be presented unto thee with pure and clean hearts, by the same thy Son Jesus Christ our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        ep1HymnId: "all prophets hail thee",
        ep1VandR: [
            "It was re_vealed un_to Si_me_on by the Ho_ly Ghost.",
            "That he should not see death be_fore he had seen the Lord's Christ."
        ],
        ep1MagId: "presentation the ancient",
        invId: "presentation behold the lord",
        mpHymnId: "the god whom earth and sea and sky",
        mpVandR: [
            "Full of grace are thy lips.",
            "Be_cause God hath blessed thee for_e_ver."
        ],
        mpBenId: "presentation and when the parents",
        ep2HymnId: candlemasIsAfterSeptuagesima ? "all prophets hail thee" : "candlemas sequence",
        ep2VandR: [
            "It was re_vealed un_to Si_me_on by the Ho_ly Ghost.",
            "That he should not see death be_fore he had seen the Lord's Christ."
        ],
        ep2MagId: "presentation today the blessed"
    });
    (0, $f413104e060180de$export$6ba6f5acbe0c0a65).forEach((ordSaint)=>{
        const type = ordSaint.type;
        const celebration = {
            label: (ordSaint.title.replace("\xc6", "ae") + " " + (ordSaint.regionNote ?? "")?.replaceAll("(", "").replaceAll(")", "").replaceAll(":", "").replaceAll(",", "")).trim().replaceAll(",", "").replaceAll(" ", "-").toLocaleLowerCase(),
            rank: ordSaint.rank,
            type: type,
            title: ordSaint.title,
            subtitle: ordSaint.subtitle,
            shortTitle: ordSaint.shortTitle,
            optional: ordSaint.optional,
            regionNote: ordSaint.regionNote,
            collect: ordSaint.collect,
            alternativeCollects: ordSaint.alternativeCollects,
            commonlyCalled: ordSaint.commonlyCalled,
            commons: ordSaint.commons,
            properPsalmsOptional: ordSaint.properPsalmsOptional,
            propersOfTheFeria: ordSaint.propersOfTheFeria,
            feastHasFirstEvensong: ordSaint.feastHasFirstEvensong,
            athanasianCreed: ordSaint.athanasianCreed,
            ...ordSaint.supplements
        };
        $2d95fb1756754bc6$var$modify(calendar).onDate(ordSaint.day, ordSaint.month).placeCelebration(celebration);
    });
    // Sundays in Lent
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(1, "sun").placeCelebration({
        label: "palm-sunday",
        rank: 2,
        type: "sunday",
        title: "Palm Sunday",
        invId: "passiontide inv",
        ep1HymnId: "the royal banners forward go",
        ep1VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep1MagId: "hw righteous father",
        mpHymnId: "thirty years among us dwelling",
        mpVandR: [
            "De_li_ver me from mine e_ne_mies, O God.",
            "De_fend me from them that rise up a_gainst me."
        ],
        mpBenId: "hw much people",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep2MagId: "hw for it is written",
        collect: "ALMIGHTY and everlasting God, who, of thy of tender love towards mankind, hast sent thy Son our Saviour Jesus Christ, to take upon him our flesh, and to suffer death upon the Cross, that all mankind should follow the example of his great humility: mercifully grant that we may follow the example of his patience, and so be made partakers of his Resurrection; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(2, "sun").placeCelebration({
        label: "lent-5",
        rank: 2,
        type: "sunday",
        title: "The Fifth Sunday in Lent",
        commonlyCalled: "Passion Sunday",
        shortTitle: "Passion Sunday",
        ep1HymnId: "the royal banners forward go",
        ep1VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep1MagId: "l5 i am one",
        invId: "passiontide inv",
        mpHymnId: "sing my tongue the glorious battle",
        mpVandR: [
            "De_li_ver me from mine e_ne_mies, O God.",
            "De_fend me from them that rise up a_gainst me."
        ],
        mpBenId: "l5 jesus said unto the",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "De_li_ver me, O Lord, from the e_vil man.",
            "And pre_serve me from the wi_cked man."
        ],
        ep2MagId: "l5 your father abraham",
        collect: "We beseech thee, Almighty God, mercifully to look upon thy people: that by thy great goodness they may be governed and preserved evermore, both in body and soul; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayInLent: true,
        weekdays: [
            {
                benId: "l5 in the last day of the feast",
                magId: "l5 if any man thirst",
                collect: "Let thy bountiful goodness, O Lord, we beseech thee, sanctify this our fasting: and effectually bestow upon us the remission of all our sins; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l5 my time is not yet come",
                magId: "l5 go ye up",
                collect: "Grant, O Lord, we pray thee, that this our fasting may be acceptable in thy sight: that we, being cleansed from our sins, and made worthy of thy grace, may be made whole unto everlasting life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l5 my sheep hear",
                magId: "l5 many good works",
                collect: "O merciful God, we beseech thee to sanctify this our fasting to the enlightenment of the hearts of thy faithful people: that we, to whom thou hast given an hearty desire to pray, may obtain of thy loving-kindness the fulfilment of all our petitions; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l5 the master saith",
                magId: "l5 with desire have i",
                collect: "Grant, we beseech thee, Almighty God: that we, who by our self-indulgence have corrupted the worthiness of man's condition, may by devout abstinence heal and restore the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l5 now the feast day",
                magId: "l5 the chief priests",
                collect: "We beseech thee, O Lord, mercifully to pour thy grace into our hearts: that we, who by willing chastisement restrain our sins, may rather mortify ourselves in this life, than be condemned to eternal punishment; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l5 o father glorify",
                collect: "Grant, O Lord, that thy people who are consecrated to thy service may continually increase in all godly affections: that they, being duly instructed in all holy learning, may both be made the more acceptable unto thy divine majesty, and prospered more abundantly in the gifts of thy bounty; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            }
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(2, "sun").getNthAfter(1, "fri").placeCelebration({
        label: "st-mary-in-passiontide",
        rank: 12,
        type: "memorial",
        optional: true,
        title: "Saint Mary in Passiontide",
        invId: "passiontide inv",
        mpHymnId: "sing my tongue the glorious battle",
        mpVandR: [
            "O Vir_gin Ma_ry, by the vir_tue of so ma_ny sor_rows.",
            "Make us to re_joice in the hea_ven_ly king_dom."
        ],
        mpBenId: "sorrows come ye",
        ep2HymnId: "the royal banners forward go",
        ep2VandR: [
            "Pray for us, O Queen of Mar_tyrs.",
            "Who didst stand by the Cross of Je_sus."
        ],
        ep2MagId: "sorrows sorrow hath weighed",
        collect: "O Lord, in whose Passion, according to the prophecy of Simeon, the sword of sorrow did pierce the most loving soul of thy glorious Virgin Mother Mary: mercifully grant that we, who devoutly call to mind the suffering whereby she was pierced, may, by the glorious merits and prayers of all the Saints who have stood beneath the Cross, obtain with gladness the benefits of thy Passion; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(3, "sun").placeCelebration({
        label: "lent-4",
        rank: 2,
        type: "sunday",
        title: "The Fourth Sunday in Lent",
        shortTitle: "Lent IV",
        ep1HymnId: "now is the healing time decreed",
        ep1VandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        ep1MagId: "l4 woman hath no",
        invId: "l1 inv",
        mpHymnId: "the glory of these forty days",
        mpVandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        mpBenId: "l4 when jesus lift up",
        ep2HymnId: "now is the healing time decreed",
        ep2VandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        ep2MagId: "l4 jesus went up",
        collect: "GRANT, we beseech thee, Almighty God: that we, who for our evil deeds do worthily deserve to be punished, by the comfort of thy grace, may mercifully be relieved; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayInLent: true,
        weekdays: [
            {
                benId: "l4 take these things hence",
                magId: "l4 destroy this temple",
                collect: "Grant, we beseech thee, Almighty God: that we who year by year devoutly keep this holy ordinance of fasting, may serve thee acceptably both in body and soul; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l4 wherefore do ye seek",
                magId: "l4 no man laid hands",
                collect: "We beseech thee, O Lord: that we may in such wise observe this solemn ordinance of fasting; that by reason of the same we may increase in all godliness of life, and effectually obtain the continual succour of thy mercy; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l4 master wherein hath",
                magId: "l4 a man that is called",
                collect: "O God, who dost grant unto the righteous the reward of their godliness, and unto sinners that turn unto thee with fasting the pardon of their offences: have compassion, we pray thee, upon us thy humble servants; that we, confessing the sins which we have committed, may obtain of thee the remission of all our iniquities; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l4 jesus went into",
                magId: "l4 a great prophet",
                collect: "Grant, we beseech thee, Almighty God: that we, duly mortifying the flesh by this abstinence, may inwardly rejoice in holiness of spirit; that being delivered from all earthly and carnal affections, we may speedily obtain thy heavenly promises; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l4 our friend lazarus",
                magId: "l4 lord if thou hadst",
                collect: "O God, who hast ordained thine ineffable Sacraments for the regeneration of all men: we humbly beseech thee; that thy Church, being profited by the same to her advancement in all things spiritual, may likewise fail not of thy succour in all things temporal; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l4 he that followeth me",
                collect: "O God, forasmuch as our fast is unprofitable unto us unless it be acceptable unto thy loving-kindness: grant, we beseech thee; that the devout affection of our hearts may by thy grace be rendered abundant in the fruit of all good works; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            }
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(4, "sun").placeCelebration({
        label: "lent-3",
        rank: 2,
        type: "sunday",
        title: "The Third Sunday in Lent",
        shortTitle: "Lent III",
        ep1HymnId: "now is the healing time decreed",
        ep1VandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        ep1MagId: "l3 but the father",
        invId: "l1 inv",
        mpHymnId: "the glory of these forty days",
        mpVandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        mpBenId: "l3 when a strong man",
        ep2HymnId: "now is the healing time decreed",
        ep2VandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        ep2MagId: "l3 a certain woman",
        collect: "We beseech thee, Almighty God: look upon the hearty desires of thy humble servants, and stretch forth the right hand of thy majesty, to be our defence against all our enemies; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayInLent: true,
        weekdays: [
            {
                benId: "l3 verily i say unto you",
                magId: "l3 but jesus",
                collect: "We beseech thee, O Lord, mercifully to pour thy grace into our hearts: that like as we do refrain our bodies from carnal feastings, so we may be inwardly delivered from all wantonness that may hurt the soul; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l3 if two of you",
                magId: "l3 where two or three",
                collect: "Almighty and most merciful God: we beseech thee graciously to hearken unto our prayers; that we may obtain of thy great goodness the gift of continence unto our salvation; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l3 hearken",
                magId: "l3 to eat with",
                collect: "Grant, we beseech thee, O Lord: that we, being taught by abstinence in the way of salvation, may in such wise learn to refrain ourselves from all vices that may hurt the soul; that we may readily obtain the pardon of thy loving-kindness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l3 and devils also",
                magId: "l3 whosoever had any",
                collect: "Grant, we beseech thee, Almighty God: that the holy devotion of this fast may both increase our purity, and render us acceptable to thy majesty; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l3 whosoever drinketh",
                magId: "l3 sir i perceive",
                collect: "Assist, O Lord, we pray thee, this our fasting with thy most gracious favour: that like as we do refrain from food in our outward bodies, so we may fast from sin in our inward souls; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l3 and jesus stooped down",
                collect: "Grant, we beseech thee, Almighty God: that like as we thy family do abstain from food to the mortifying of the flesh; so we may likewise fast from sin to the following after righteousness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            }
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(5, "sun").placeCelebration({
        label: "lent-2",
        rank: 2,
        type: "sunday",
        title: "The Second Sunday in Lent",
        shortTitle: "Lent II",
        ep1HymnId: "the fast as taught by holy lore",
        ep1VandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        ep1MagId: "l2 tell the vision",
        invId: "l1 inv",
        mpHymnId: "o kind creator bow thine ear",
        mpVandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        mpBenId: "l2 and jesus went thence",
        ep2HymnId: "the fast as taught by holy lore",
        ep2VandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        ep2MagId: "l2 o woman great is",
        collect: "Almighty God, who seest that we have no power of ourselves to help ourselves: keep us both outwardly in our bodies, and inwardly in our souls; that we may be defended from all adversities which may happen to the body, and from all evil thoughts which may assault and hurt the soul; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayInLent: true,
        weekdays: [
            {
                benId: "l2 i am the beginning",
                magId: "l2 he that sent me",
                collect: "Grant, we beseech thee, Almighty God: that, like as we thy family do abstain from food to the mortifying of the flesh; so we may likewise fast from sin to the following after righteousness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l2 one is your master",
                magId: "l2 all ye are brethren",
                collect: "O most merciful God, we beseech thee so to perfect in us the work of this holy observance: that we, who by thine inspiration know those things that we ought to do, may likewise by thee be enabled to perform the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l2 behold we go up",
                magId: "l2 he shall be delivered",
                collect: "We beseech thee, O Lord, graciously to hear the prayers of thy people: that we, who by thine ordinance abstain from carnal food, may likewise be delivered from all sins that hurt the soul; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l2 son remember",
                magId: "l2 the same rich man",
                collect: "Grant to us, Lord, we beseech thee, the help of thy grace: that we, being devoutly given to abstinence and prayer, may be preserved both in body and soul from all the assaults of our enemies; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l2 he will miserably",
                magId: "l2 when they sought to lay",
                collect: "Almighty God: we humbly beseech thee, that we may in such wise be cleansed by this holy time of fasting; that we may keep the coming feast in all sincerity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l2 i will go unto my father",
                collect: "Grant, we beseech thee, O Lord, that this our abstinence may so work in us to good effect: that we, who now submit ourselves to the mortifying of the flesh, may be profited thereby to the quickening of our souls; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            }
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(6, "sun").placeCelebration({
        label: "lent-1",
        rank: 2,
        type: "sunday",
        title: "The First Sunday in Lent",
        shortTitle: "Lent I",
        ep1HymnId: "the fast as taught by holy lore",
        ep1VandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        ep1MagId: "l1 then thou shalt",
        invId: "l1 inv",
        mpHymnId: "o kind creator bow thine ear",
        mpVandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        mpBenId: "l1 then was jesus led",
        ep2HymnId: "the fast as taught by holy lore",
        ep2VandR: [
            "God shall give his An_gels charge o_ver thee.",
            "To keep thee in all thy ways."
        ],
        ep2MagId: "l1 behold now is",
        sundayInLent: true,
        collect: "O Lord, who for our sake didst fast forty days and forty nights: give us grace to use such abstinence, that, our flesh being subdued to the Spirit, we may ever obey thy godly motions in righteousness and true holiness, to thy honour and glory; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        weekdays: [
            {
                benId: "l1 come ye blessed",
                magId: "l1 inasmuch",
                collect: "Turn thou us, O God our Saviour: and that this our Lenten fast may be profitable unto us, vouchsafe, we pray thee, to instruct our minds in all heavenly learning; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l1 and jesus went into",
                magId: "l1 truly it is written",
                collect: "We beseech thee, O Lord, graciously to behold this thy family: that, whereas we now do chasten our bodies by the mortifying of the flesh, our souls may shine in thy sight with longing after thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                rank: 10,
                title: "Ember Wednesday in Lent",
                benId: "l1 this crooked and perverse",
                magId: "l1 for as jonah",
                collect: "We beseech thee, O Lord, that thou wouldest graciously hear our prayers: and stretch forth the right hand of thy majesty to be our defence against all adversities; through Jesus Christ our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                benId: "l1 and jesus went thence",
                magId: "l1 o woman great is your faith",
                collect: "We beseech thee, O Lord, graciously to regard the devout prayers of thy people: that they, who by abstinence do mortify the deeds of the flesh, may by the fruit of good be renewed in the spirit of their minds; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                rank: 10,
                title: "Ember Friday in Lent",
                benId: "l1 an angel of the lord",
                magId: "l1 he that made me",
                collect: "We beseech thee, O Lord, mercifully to have compassion on thy people: that they, who by thee are enabled to serve thee in all godliness, may ever be comforted by thy gracious and ready help; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                rank: 10,
                title: "Ember Saturday in Lent",
                benId: "l1 and jesus taketh",
                collect: "We beseech thee, O Lord, graciously to hear the prayers of thy people, and of thy great goodness turn aside from them the scourges of thine anger; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            }
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(7, "sun").placeCelebration({
        label: "quinquagesima",
        rank: 6,
        type: "sunday",
        title: "The Sunday Next Before Lent",
        commonlyCalled: "Quinquagesima",
        shortTitle: "Quinquagesima",
        sundayAfterEpiphany: true,
        ep1MagId: "quinquagesima mighty abraham",
        invId: "gesima let us come",
        mpBenId: "quinquagesima behold we go up",
        ep2MagId: "quinquagesima and jesus standing",
        collect: "O Lord, who hast taught us that all our doings without charity are nothing worth: send thy Holy Spirit, and pour into our hearts that most excellent gift of charity, the very bond of peace and of all virtues, without which whosoever liveth is counted dead before thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        weekdays: [
            {
                invId: "gesima let us come",
                magId: "quinquagesima and they which"
            },
            {
                invId: "gesima let us come",
                magId: "quinquagesima have mercy"
            },
            {
                invId: "gesima let us come",
                title: "Ash Wednesday",
                rank: 2,
                benId: "ash weds when ye fast",
                magId: "ash weds lay up",
                mpProperPsalms: [
                    "6",
                    "32",
                    "38"
                ],
                epProperPsalms: [
                    "102",
                    "130",
                    "143"
                ],
                collect: "Almighty and everlasting God, who hatest nothing that thou hast made and dost forgive the sins of all those who are penitent: create and make in us new and contrite hearts, that we, worthily lamenting our sins and acknowledging our wretchedness, may obtain of thee, the God of all mercy, perfect remission and forgiveness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            },
            {
                invId: "gesima let us come",
                title: "Thursday following Ash Wednesday",
                benId: "ash weds lord my servant",
                magId: "ash weds lord i am not worthy",
                collect: "O God who art wroth with them that sin against thee, and sparest them that are penitent: we beseech thee to hear the prayers of thy people that call upon thee; that we, who have most justly deserved the scourges of thine anger, may by thy great mercy be delivered from the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            },
            {
                invId: "gesima let us come",
                title: "Friday following Ash Wednesday",
                benId: "ash weds when thou doest thine alms",
                magId: "ash weds but thou when",
                collect: "We beseech thee, O Lord, to further with thy gracious favour the fast which we have here begun: that we, who with our bodies therein do thee outward worship, may inwardly perform the same in singleness of heart; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            },
            {
                invId: "gesima let us come",
                title: "Saturday following Ash Wednesday",
                benId: "ash weds yet they seek",
                collect: "Assist us mercifully, O Lord, in these our supplications: and grant that, like as this fast hath been ordained for the healing of our bodies and our souls, so we may in all godliness and lowliness observe the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            }
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(8, "sun").placeCelebration({
        label: "sexagesima",
        rank: 6,
        type: "sunday",
        title: "The Second Sunday Before Lent",
        commonlyCalled: "Sexagesima",
        shortTitle: "Sexagesima",
        sundayAfterEpiphany: true,
        ep1MagId: "sexagesima the lord spake unto noah",
        invId: "gesima let us come",
        mpBenId: "sexagesima when much people",
        ep2MagId: "sexagesima unto you it is given",
        collect: "O Lord God, who seest that we put not our trust in anything that we do: mercifully grant that by thy power, we may be defended against all adversity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        weekdays: [
            {
                invId: "gesima let us come",
                magId: "sexagesima if ye seek"
            },
            {
                invId: "gesima let us come",
                magId: "sexagesima the seed"
            },
            {
                invId: "gesima let us come",
                magId: "sexagesima but that"
            },
            {
                invId: "gesima let us come",
                magId: "sexagesima if then brethren"
            },
            {
                invId: "gesima let us come",
                magId: "sexagesima they which keep"
            },
            {
                invId: "gesima let us come"
            }
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthBefore(9, "sun").placeCelebration({
        label: "septuagesima",
        rank: 6,
        type: "sunday",
        title: "The Third Sunday Before Lent",
        commonlyCalled: "Septuagesima",
        shortTitle: "Septuagesima",
        sundayAfterEpiphany: true,
        ep1MagId: "septuagesima the lord said",
        invId: "gesima let us come",
        mpVandR: [
            "O Lord, thou hast been our re_fuge.",
            "From one ge_ne_ra_tion to a_no_ther."
        ],
        mpBenId: "septuagesima the kingdom of",
        ep2MagId: "septuagesima the householder said",
        weekdays: [
            {
                invId: "gesima let us come",
                magId: "septuagesima these last"
            },
            {
                invId: "gesima let us come",
                magId: "septuagesima but the householder"
            },
            {
                invId: "gesima let us come",
                magId: "septuagesima take that"
            },
            {
                invId: "gesima let us come",
                magId: "septuagesima is it not"
            },
            {
                invId: "gesima let us come",
                magId: "septuagesima so the last"
            },
            {
                invId: "gesima let us come"
            }
        ],
        collect: "O Lord, we beseech thee favourably to hear the prayers of thy people: that we, who are justly punished for our offences, may be mercifully delivered by thy goodness, for the glory of thy Name; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onDate(22, 2).placeCelebration({
        label: "the-chair-of-saint-peter",
        title: "The Chair of Saint Peter",
        subtitle: "",
        type: "feast",
        rank: 7,
        optional: false,
        collect: "O Almighty God, who by thy Son Jesus Christ didst give to thy Apostle Saint Peter many excellent gifts, and commandedst him earnestly to feed thy flock: make, we beseech thee, all Bishops and Pastors diligently to preach thy holy Word, and the people obediently to follow the same; that they may receive the crown of everlasting glory; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        ep1HymnId: "lord of creation bow thine ear o christ to hear chair of st peter",
        ep1VandR: [
            "Thou art Pe_ter.",
            "And u_pon this rock I will build my Church."
        ],
        ep1MagId: "chair of st peter thou art",
        invId: "chair of st peter inv",
        mpHymnId: "lord of creation bow thine ear o christ to hear chair of st peter",
        mpVandR: [
            "Let them ex_alt him in the con_gre_ga_tion of the peo_ple.",
            "And praise him in the seat of the el_ders."
        ],
        mpBenId: "chair of st peter whatsoever",
        ep2HymnId: "whatever on earth below thy word o peter chained",
        ep2VandR: [
            "The Lord chose him for a Priest un_to him_self.",
            "To of_fer unto him the sa_cri_fice of praise."
        ],
        ep2MagId: "chair of st peter being a high priest",
        feastHasFirstEvensong: true
    });
    // Sundays in Epiphany (lower precedence than sundays in Lent)
    $2d95fb1756754bc6$var$modify(calendar).onDate(6, 1).getNthAfter(2, "sun").placeCelebration({
        label: "epiphany-2",
        rank: 6.1,
        type: "sunday",
        title: "The Second Sunday after the Epiphany",
        shortTitle: "Epiphany II",
        sundayAfterEpiphany: true,
        collect: "Almighty and everlasting God, who dost govern all things in heaven and earth: mercifully hear the supplications of thy people; and grant us thy peace all the days of our life; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        ep1MagId: "ep sat ep1 god hath holpen",
        mpBenId: "ep2 there was a marriage",
        ep2MagId: "ep2 and when they"
    });
    $2d95fb1756754bc6$var$modify(calendar).onDate(6, 1).getNthAfter(3, "sun").placeCelebration({
        label: "epiphany-3",
        rank: 6.1,
        type: "sunday",
        title: "The Third Sunday after the Epiphany",
        shortTitle: "Epiphany III",
        sundayAfterEpiphany: true,
        collect: "Almighty and everlasting God: mercifully look upon our infirmities; and in all our dangers and necessities, stretch forth thy right hand to help and defend us; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        mpBenId: "ep3 and when jesus",
        ep1MagId: "ep sat ep1 god hath holpen",
        ep2MagId: "ep3 lord if thou wilt"
    });
    $2d95fb1756754bc6$var$modify(calendar).onDate(6, 1).getNthAfter(4, "sun").placeCelebration({
        label: "epiphany-4",
        rank: 6.1,
        type: "sunday",
        title: "The Fourth Sunday after the Epiphany",
        shortTitle: "Epiphany IV",
        sundayAfterEpiphany: true,
        ep1MagId: "ep sat ep1 god hath holpen",
        mpBenId: "ep4 when jesus",
        ep2MagId: "ep4 master save",
        collect: "O God, who knowest us to be set in the midst of so many and great dangers, that by reason of the frailty of our nature we cannot always stand upright: grant to us such strength and protection, as may support us in all dangers, and carry us through all temptations; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onDate(6, 1).getNthAfter(5, "sun").placeCelebration({
        label: "epiphany-5",
        rank: 6.1,
        type: "sunday",
        title: "The Fifth Sunday after the Epiphany",
        shortTitle: "Epiphany V",
        sundayAfterEpiphany: true,
        ep1MagId: "ep sat ep1 god hath holpen",
        mpBenId: "ep5 master sowedst",
        ep2MagId: "ep5 gather ye",
        collect: "O Lord, we beseech thee to keep thy Church and household continually in thy true religion: that they who do lean only upon the hope of thy heavenly grace, may evermore be defended by thy mighty power; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onDate(6, 1).getNthAfter(6, "sun").placeCelebration({
        label: "epiphany-6",
        rank: 6.1,
        type: "sunday",
        title: "The Sixth Sunday after the Epiphany",
        shortTitle: "Epiphany VI",
        sundayAfterEpiphany: true,
        ep1MagId: "ep sat ep1 god hath holpen",
        mpBenId: "ep6 as the lightning",
        ep2MagId: "ep6 wheresoever",
        collect: "O God, whose blessed Son was manifested that he might destroy the works of the devil, and make us the sons of God, and heirs of eternal life: grant us, we beseech thee, that, having this hope, we may purify ourselves, even as he is pure; that, when he shall appear again with power and great glory, we may be made like unto him in his eternal and glorious kingdom; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    // Sundays in Easter
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(1, "sun").placeCelebration({
        label: "easter-2",
        type: "sunday",
        rank: 1,
        title: "The Second Sunday of Easter",
        shortTitle: "Easter II",
        ep1HymnId: "ye choirs of new jerusalem",
        ep1VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep1MagId: "e2 that same evening",
        invId: "easter inv",
        mpHymnId: "the day draws on with golden light",
        mpVandR: [
            "In thy re_sur_rec_tion, O Christ.",
            "Let hea_ven and earth re_joice."
        ],
        mpBenId: "e2 that same evening",
        ep2HymnId: "the lambs high banquet we await",
        ep2VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep2MagId: "e2 after eight days",
        collect: "Almighty Father, who hast given thine only Son to die for our sins, and to rise again for our justification: grant us so to put away the leaven of malice and wickedness; that we may always serve thee in pureness of living and truth; through the merits of the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayAfterEaster: true,
        weekdays: [
            {
                benId: "e2 when jesus was risen",
                magId: "e2 peace be unto you"
            },
            {
                benId: "e2 i go before you",
                magId: "e2 reach hither"
            },
            {
                benId: "e2 i am the true vine",
                magId: "e2 because thou hast"
            },
            {
                benId: "e2 my heart burns",
                magId: "e2 i did put"
            },
            {
                benId: "e2 there came unto the tomb",
                magId: "e2 after ... when the doors"
            },
            {}
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(2, "sun").placeCelebration({
        label: "easter-3",
        type: "sunday",
        rank: 2,
        title: "The Third Sunday of Easter",
        shortTitle: "Easter III",
        ep1HymnId: "ye choirs of new jerusalem",
        ep1VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep1MagId: "e3 i am the shepherd",
        invId: "easter inv",
        mpHymnId: "the day draws on with golden light",
        mpVandR: [
            "In thy re_sur_rec_tion, O Christ.",
            "Let hea_ven and earth re_joice."
        ],
        mpBenId: "e3 i am the shepherd",
        ep2HymnId: "the lambs high banquet we await",
        ep2VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep2MagId: "e3 i am the good shepherd",
        collect: "Almighty God, who hast given thine only Son to be unto us both a sacrifice for sin, and also an example of godly life: give us grace that we may always most thankfully receive his inestimable benefit; and also daily endeavour ourselves to follow the blessed steps of his most holy life; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayAfterEaster: true,
        weekdays: [
            {
                benId: "e3 go ye into all",
                magId: "e3 the good shepherd lays"
            },
            {
                benId: "e3 go ye into the world",
                magId: "e3 he that is an hireling"
            },
            {
                benId: "e3 go unto my",
                magId: "e3 as the father knows"
            },
            {
                benId: "e3 art thou only",
                magId: "e3 other sheep i have"
            },
            {
                benId: "e3 ought not christ",
                magId: "e3 i am the good shepherd"
            },
            {}
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(3, "sun").placeCelebration({
        label: "easter-4",
        type: "sunday",
        rank: 2,
        title: "The Fourth Sunday of Easter",
        commonlyCalled: "Good Shepherd Sunday",
        shortTitle: "Easter IV",
        ep1HymnId: "ye choirs of new jerusalem",
        ep1VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep1MagId: "e4 a little while",
        invId: "easter inv",
        mpHymnId: "the day draws on with golden light",
        mpVandR: [
            "In thy re_sur_rec_tion, O Christ.",
            "Let hea_ven and earth re_joice."
        ],
        mpBenId: "e4 a little while",
        ep2HymnId: "the lambs high banquet we await",
        ep2VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep2MagId: "e4 verily i say",
        collect: "Almighty God, who showest to them that be in error the light of thy truth, to the intent that they may return into the way of righteousness: grant unto all them that are admitted into the fellowship of Christ's religion; that they may forsake those things that are contrary to their profession, and follow all such things as are agreeable to the same; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayAfterEaster: true,
        weekdays: [
            {
                benId: "e4 and beginning",
                magId: "e4 your sorrow shall be"
            },
            {
                benId: "e4 and they constrained",
                magId: "e4 sorrow hath filled"
            },
            {
                benId: "e4 abide with us for",
                magId: "e4 your sorrow will be turned"
            },
            {
                benId: "e4 and he went in",
                magId: "e4 verily verily i say"
            },
            {
                benId: "e4 they knew the lord",
                magId: "e4 verily i say"
            },
            {}
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(4, "sun").placeCelebration({
        label: "easter-5",
        type: "sunday",
        rank: 2,
        title: "The Fifth Sunday of Easter",
        shortTitle: "Easter V",
        ep1HymnId: "ye choirs of new jerusalem",
        ep1VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep1MagId: "e5 i go my way",
        invId: "easter inv",
        mpHymnId: "the day draws on with golden light",
        mpVandR: [
            "In thy re_sur_rec_tion, O Christ.",
            "Let hea_ven and earth re_joice."
        ],
        mpBenId: "e5 i go my way",
        ep2HymnId: "the lambs high banquet we await",
        ep2VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep2MagId: "e5 i go my way",
        collect: "Almighty God, who alone makest the minds of the faithful to be of one will: grant unto thy people, that they may love the thing which thou commandest, and desire that which thou dost promise; that so, among sundry and manifold changes of the world, our hearts may surely there be fixed, where true joys are to be found; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayAfterEaster: true,
        weekdays: [
            {
                benId: "e5 did not our heart",
                magId: "e5 i tell you the truth"
            },
            {
                benId: "e5 peace but unto you it is",
                magId: "e5 when the comforter"
            },
            {
                benId: "e5 a spirit hath not",
                magId: "e5 i have yet many"
            },
            {
                benId: "e5 the disciples offered",
                magId: "e5 for he shall not"
            },
            {
                benId: "e5 these are the words",
                magId: "e5 now i go my way"
            },
            {}
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(5, "sun").placeCelebration({
        label: "easter-6",
        type: "sunday",
        rank: 2,
        title: "The Sixth Sunday of Easter",
        commonlyCalled: "Rogation Sunday",
        shortTitle: "Easter VI",
        ep1HymnId: "ye choirs of new jerusalem",
        ep1VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep1MagId: "e6 hitherto have ye",
        invId: "easter inv",
        mpHymnId: "the day draws on with golden light",
        mpVandR: [
            "In thy re_sur_rec_tion, O Christ.",
            "Let hea_ven and earth re_joice."
        ],
        mpBenId: "e6 hitherto have ye",
        ep2HymnId: "the lambs high banquet we await",
        ep2VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep2MagId: "e6 ask ye",
        collect: "O Lord, from whom all good things do come: grant to us thy humble servants; that by thy holy inspiration we may think those things that be good, and by thy merciful guiding may perform the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    // Ascension week can have a transfer
    if (ascensionTransferred) $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(5, "sun").getNthAfter(1, "mon").placeCelebration({
        label: "easter-6-monday",
        type: "feria",
        rank: 12,
        title: "Monday following Easter VI",
        shortTitle: "Easter VI",
        invId: "easter inv",
        mpHymnId: "the day draws on with golden light",
        mpVandR: [
            "In thy re_sur_rec_tion, O Christ.",
            "Let hea_ven and earth re_joice."
        ],
        mpBenId: "e6 hitherto have ye",
        ep2HymnId: "the lambs high banquet we await",
        ep2VandR: [
            "A_bide with us, O Lord.",
            "For it is to_ward eve_ning."
        ],
        ep2MagId: "e6 ask ye",
        collect: "O Lord, from whom all good things do come: grant to us thy humble servants; that by thy holy inspiration we may think those things that be good, and by thy merciful guiding may perform the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    else {
        $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(5, "sun").getNthAfter(1, "mon").placeCelebration({
            label: "rogation-monday",
            type: "feria",
            rank: 10.1,
            title: "Rogation Monday",
            invId: "easter inv",
            mpHymnId: "the day draws on with golden light",
            mpVandR: [
                "In thy re_sur_rec_tion, O Christ.",
                "Let hea_ven and earth re_joice."
            ],
            mpBenId: "e6 ask and it shall",
            ep2HymnId: "the lambs high banquet we await",
            ep2VandR: [
                "A_bide with us, O Lord.",
                "For it is to_ward eve_ning."
            ],
            ep2MagId: "e6 for the father",
            collect: "Assist us mercifully, O Lord, in these our supplications and prayers: and dispose the way of thy servants towards the attainment of everlasting salvation; that, among all the changes and chances of this mortal life, they may ever be defended by thy most gracious and ready help; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        });
        $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(5, "sun").getNthAfter(1, "tues").placeCelebration({
            label: "rogation-tuesday",
            type: "feria",
            rank: 10.1,
            title: "Rogation Tuesday",
            invId: "easter inv",
            mpHymnId: "the day draws on with golden light",
            mpVandR: [
                "In thy re_sur_rec_tion, O Christ.",
                "Let hea_ven and earth re_joice."
            ],
            mpBenId: "e6 it behoved christ",
            ep2HymnId: "the lambs high banquet we await",
            ep2VandR: [
                "A_bide with us, O Lord.",
                "For it is to_ward eve_ning."
            ],
            ep2MagId: "e6 i came forth",
            collect: "Assist us mercifully, O Lord, in these our supplications and prayers: and dispose the way of thy servants towards the attainment of everlasting salvation; that, among all the changes and chances of this mortal life, they may ever be defended by thy most gracious and ready help; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        });
        $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(5, "sun").getNthAfter(1, "wed").placeCelebration({
            label: "rogation-wednesday",
            type: "feria",
            rank: 10.1,
            title: "Rogation Wednesday",
            invId: "easter inv",
            mpHymnId: "the day draws on with golden light",
            mpVandR: [
                "In thy re_sur_rec_tion, O Christ.",
                "Let hea_ven and earth re_joice."
            ],
            mpBenId: "e6 father the hour",
            collect: "Assist us mercifully, O Lord, in these our supplications and prayers: and dispose the way of thy servants towards the attainment of everlasting salvation; that, among all the changes and chances of this mortal life, they may ever be defended by thy most gracious and ready help; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        });
        $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(6, "thur").placeCelebration({
            label: "ascension",
            rank: 3,
            type: "solemnity",
            title: "The Ascension of the Lord",
            athanasianCreed: true,
            ep1HymnId: "eternal monarch king most high",
            ep1VandR: [
                "God is gone up with a merry noise.",
                "And the Lord with the sound of the trump."
            ],
            ep1MagId: "ascension father i have",
            invId: "ascension inv",
            mpHymnId: "o christ our joy to whom is given",
            mpVandR: [
                "The Lord hath pre_pared.",
                "His throne in hea_ven."
            ],
            mpBenId: "ascension i ascend",
            ep2HymnId: "eternal monarch king most high",
            ep2VandR: [
                "God is gone up with a merry noise.",
                "And the Lord with the sound of the trump."
            ],
            ep2MagId: "ascension o king of",
            collect: "Grant, we beseech thee, Almighty God: that like as we do believe thy Only Begotten Son our Lord Jesus Christ to have ascended into the heavens; so we may also in heart and mind thither ascend, and with him continually dwell; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        });
        $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(6, "fri").placeCelebration({
            label: "ascension-friday",
            rank: 13,
            type: "feria",
            title: "Friday following the Ascension",
            invId: "ascension inv",
            mpHymnId: "o christ our joy to whom is given",
            mpVandR: [
                "The Lord hath pre_pared.",
                "His throne in hea_ven."
            ],
            mpBenId: "ascension i ascend",
            ep2HymnId: "eternal monarch king most high",
            ep2VandR: [
                "God is gone up with a merry noise.",
                "And the Lord with the sound of the trump."
            ],
            ep2MagId: "ascension o king of",
            collect: "Grant, we beseech thee, Almighty God: that like as we do believe thy Only Begotten Son our Lord Jesus Christ to have ascended into the heavens; so we may also in heart and mind thither ascend, and with him continually dwell; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        });
        $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(6, "sat").placeCelebration({
            label: "ascension-saturday",
            rank: 13,
            type: "feria",
            title: "Saturday following the Ascension",
            invId: "ascension inv",
            mpHymnId: "o christ our joy to whom is given",
            mpVandR: [
                "The Lord hath pre_pared.",
                "His throne in hea_ven."
            ],
            mpBenId: "ascension i ascend",
            ep2HymnId: "eternal monarch king most high",
            ep2VandR: [
                "God is gone up with a merry noise.",
                "And the Lord with the sound of the trump."
            ],
            ep2MagId: "ascension o king of",
            collect: "Grant, we beseech thee, Almighty God: that like as we do believe thy Only Begotten Son our Lord Jesus Christ to have ascended into the heavens; so we may also in heart and mind thither ascend, and with him continually dwell; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        });
    }
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("easter-day").getNthAfter(6, "sun").placeCelebration({
        label: "easter-7",
        type: "sunday",
        rank: 2,
        title: "The Seventh Sunday of Easter",
        shortTitle: "Easter VII",
        ep1HymnId: "eternal monarch king most high",
        mpVandR: [
            "God is gone up with a merry noise.",
            "And the Lord with the sound of the trump."
        ],
        mpHymnId: "o christ our joy to whom is given",
        ep1VandR: [
            "The Lord hath pre_pared.",
            "His throne in hea_ven."
        ],
        ep2VandR: [
            "The Lord hath pre_pared.",
            "His throne in hea_ven."
        ],
        ep2HymnId: "eternal monarch king most high",
        ep1MagId: "e7 when the",
        invId: "ascension inv",
        mpBenId: "e7 when the",
        ep2MagId: "e7 these things",
        collect: "O God, the King of glory, who hast exalted thine only Son Jesus Christ with great triumph unto thy kingdom in heaven: we beseech thee, leave us not comfortless; but send to us thy Holy Spirit to comfort us, and exalt us unto the same place whither our Saviour Christ is gone before; who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen.",
        sundayAfterEaster: true,
        weekdays: [
            {
                mpHymnId: "o christ our joy to whom is given",
                mpVandR: [
                    "The Lord hath pre_pared.",
                    "His throne in hea_ven."
                ],
                benId: "ascension i ascend",
                ep2HymnId: "eternal monarch king most high",
                ep2VandR: [
                    "God is gone up with a merry noise.",
                    "And the Lord with the sound of the trump."
                ],
                magId: "ascension o king of"
            },
            {
                mpHymnId: "o christ our joy to whom is given",
                mpVandR: [
                    "The Lord hath pre_pared.",
                    "His throne in hea_ven."
                ],
                benId: "ascension i ascend",
                ep2HymnId: "eternal monarch king most high",
                ep2VandR: [
                    "God is gone up with a merry noise.",
                    "And the Lord with the sound of the trump."
                ],
                magId: "ascension o king of"
            },
            {
                mpHymnId: "o christ our joy to whom is given",
                mpVandR: [
                    "The Lord hath pre_pared.",
                    "His throne in hea_ven."
                ],
                benId: "ascension i ascend",
                ep2HymnId: "eternal monarch king most high",
                ep2VandR: [
                    "God is gone up with a merry noise.",
                    "And the Lord with the sound of the trump."
                ],
                magId: "ascension o king of"
            },
            {
                mpHymnId: "o christ our joy to whom is given",
                mpVandR: [
                    "The Lord hath pre_pared.",
                    "His throne in hea_ven."
                ],
                benId: "ascension i ascend",
                ep2HymnId: "eternal monarch king most high",
                ep2VandR: [
                    "God is gone up with a merry noise.",
                    "And the Lord with the sound of the trump."
                ],
                magId: "ascension o king of"
            },
            {
                mpHymnId: "o christ our joy to whom is given",
                mpVandR: [
                    "The Lord hath pre_pared.",
                    "His throne in hea_ven."
                ],
                benId: "ascension i ascend",
                ep2HymnId: "eternal monarch king most high",
                ep2VandR: [
                    "God is gone up with a merry noise.",
                    "And the Lord with the sound of the trump."
                ],
                magId: "ascension o king of"
            },
            {
                mpHymnId: "o christ our joy to whom is given",
                mpVandR: [
                    "The Lord hath pre_pared.",
                    "His throne in hea_ven."
                ],
                benId: "ascension i ascend",
                ep2HymnId: "eternal monarch king most high",
                ep2VandR: [
                    "God is gone up with a merry noise.",
                    "And the Lord with the sound of the trump."
                ],
                magId: "ascension o king of"
            }
        ]
    });
    // Christmas Day, and the Season of Advent
    $2d95fb1756754bc6$var$modify(calendar).onDate(25, 12).placeCelebration({
        label: "christmas-day",
        rank: 1.9,
        type: "solemnity",
        title: "The Nativity of the Lord",
        commonlyCalled: "Christmas",
        athanasianCreed: true,
        collect: "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        mpProperPsalms: [
            "19",
            "45",
            "85"
        ],
        ep2ProperPsalms: [
            "89",
            "110",
            "132"
        ],
        ep1HymnId: "come thou redeemer of the earth",
        ep1VandR: [
            "Tom_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
            "And the Sa_viour of the world shall reign o_ver us."
        ],
        ep1MagId: "nl or ever the sun",
        invId: "nl unto us the christ is born",
        mpHymnId: "jesu the fathers only son",
        mpVandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        mpBenId: "nl glory to god",
        ep2HymnId: "from east to west from shore to shore",
        ep2VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep2MagId: "nl today the christ is born",
        weekdays: [
            {
                title: "The Second Day in the Octave of Christmas",
                invId: "nl unto us the christ is born",
                mpHymnId: "jesu the fathers only son",
                mpVandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                benId: "nl glory to god",
                ep2HymnId: "from east to west from shore to shore",
                ep2VandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                magId: "nl today the christ is born",
                collect: "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            },
            {
                title: "The Third Day in the Octave of Christmas",
                benId: "nl glory to god",
                magId: "nl today the christ is born",
                collect: "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            },
            {
                title: "The Fourth Day in the Octave of Christmas",
                invId: "nl unto us the christ is born",
                mpHymnId: "jesu the fathers only son",
                mpVandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                benId: "nl glory to god",
                ep2HymnId: "from east to west from shore to shore",
                ep2VandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                magId: "nl today the christ is born",
                collect: "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            },
            {
                title: "The Fifth Day in the Octave of Christmas",
                invId: "nl unto us the christ is born",
                mpHymnId: "jesu the fathers only son",
                mpVandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                benId: "nl glory to god",
                ep2HymnId: "from east to west from shore to shore",
                ep2VandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                magId: "nl today the christ is born",
                collect: "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            },
            {
                title: "The Sixth Day in the Octave of Christmas",
                invId: "nl unto us the christ is born",
                mpHymnId: "jesu the fathers only son",
                mpVandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                benId: "nl glory to god",
                ep2HymnId: "from east to west from shore to shore",
                ep2VandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                magId: "nl today the christ is born",
                collect: "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            },
            {
                title: "The Seventh Day in the Octave of Christmas",
                invId: "nl unto us the christ is born",
                mpHymnId: "jesu the fathers only son",
                mpVandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                benId: "nl glory to god",
                ep2HymnId: "from east to west from shore to shore",
                ep2VandR: [
                    "The Lord hath made known, al_le_lu_ia.",
                    "His sal_va_tion, al_le_lu_ia."
                ],
                magId: "nl today the christ is born",
                collect: "Almighty God, who hast given us thy Only Begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 9
            }
        ]
    });
    const christmasIsOnASunday = calendar.days.find((d)=>d.month === 12 && d.date === 25 && d.dayOfTheWeek === "sun") !== undefined;
    (christmasIsOnASunday ? $2d95fb1756754bc6$var$modify(calendar).onDate(30, 12) : $2d95fb1756754bc6$var$modify(calendar).onDate(25, 12).getNthAfter(1, "sun")).placeCelebration({
        label: "holy-family",
        rank: 5,
        type: "feast",
        title: "The Holy Family of Jesus, Mary and Joseph",
        shortTitle: "The Holy Family",
        collect: "O Lord Jesus Christ, who by thy wondrous holiness didst adorn a human home, and by thy subjection to Mary and Joseph didst consecrate the order of earthly families: grant that we, being enlightened by the example of their life with thee in thy Holy Family, and assisted by their prayers, may at last be joined with them in thine eternal fellowship; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        invId: "hf christ the son of god",
        ep1HymnId: "from east to west from shore to shore",
        ep1VandR: [
            "The Lord hath made known, al_le_lu_ia.",
            "His sal_va_tion, al_le_lu_ia."
        ],
        ep1MagId: "nl today the christ is born",
        mpHymnId: "now are the churches all with lights agleaming",
        mpVandR: [
            "All thy child_ren shall be taught of the Lord.",
            "And great shall be the peace of thy child_ren."
        ],
        mpBenId: "hf enlighten us",
        ep2HymnId: "o jesu light of hosts above",
        ep2VandR: [
            "All thy child_ren shall be taught of the Lord.",
            "And great shall be the peace of thy child_ren."
        ],
        ep2MagId: "hf but mary kept",
        feastHasFirstEvensong: true
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("christmas-day").getNthBefore(4, "sun").placeCelebration({
        label: "advent-1",
        rank: 2,
        type: "sunday",
        title: "The First Sunday of Advent",
        shortTitle: "Advent I",
        ep1HymnId: "creator of the stars of night",
        ep1VandR: [
            "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
            "Let the earth o_pen, and let it bring forth sal_va_tion."
        ],
        ep1MagId: "ad1 behold the name",
        invId: "ad1 the lord the king",
        mpHymnId: "high word of god who once didst come",
        mpVandR: [
            "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
            "Make straight the paths of our God."
        ],
        mpBenId: "ad1 the holy ghost",
        ep2HymnId: "creator of the stars of night",
        ep2VandR: [
            "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
            "Let the earth o_pen, and let it bring forth sal_va_tion."
        ],
        ep2MagId: "ad1 fear not mary",
        collect: "Almighty God, give us grace that we may cast away the works of darkness, and put upon us the armour of light, now in the time of this mortal life, in which thy Son Jesus Christ came to visit us in great humility; that in the last day, when he shall come again in his glorious majesty, to judge both the quick and the dead; we may rise to the life immortal; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        sundayInAdvent: true,
        weekdays: [
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad1 the angel",
                magId: "ad1 lift up"
            },
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad1 before they",
                magId: "ad1 see ye"
            },
            {
                title: "Ember Wednesday in Advent",
                emberDay: true,
                invId: "ad1 the lord the king ferias",
                benId: "ad1 out of sion",
                magId: "ad1 there shall",
                collect: "Grant, we beseech thee, Almighty God: that the coming festival of our redemption may obtain for us the comfort of thy succour in this life, and in the life to come the reward of eternal felicity; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 10.1
            },
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad1 blessed art",
                magId: "ad1 i will"
            },
            {
                title: "Ember Friday in Advent",
                emberDay: true,
                invId: "ad1 the lord the king ferias",
                benId: "ad1 lo there",
                magId: "ad1 out of egypt",
                collect: "Stir up, we beseech thee, O Lord, thy power, and come among us: that we, who put our trust and confidence in thy mercy, may speedily may be delivered from all our adversities; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
                rank: 10.1
            },
            {
                title: "Ember Saturday in Advent",
                emberDay: true,
                invId: "ad1 the lord the king ferias",
                benId: "ad1 sion be not",
                collect: "O God, who seest us to be sore afflicted by reason of the frailty of our mortal nature: grant, we beseech thee, that we may be relieved by thy gracious visitation; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end Amen.",
                rank: 10.1
            }
        ]
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("christmas-day").getNthBefore(3, "sun").placeCelebration({
        label: "advent-2",
        rank: 2,
        type: "sunday",
        title: "The Second Sunday of Advent",
        shortTitle: "Advent II",
        ep1HymnId: "creator of the stars of night",
        ep1VandR: [
            "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
            "Let the earth o_pen, and let it bring forth sal_va_tion."
        ],
        ep1MagId: "ad2 come o lord",
        invId: "ad1 the lord the king",
        mpHymnId: "high word of god who once didst come",
        mpVandR: [
            "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
            "Make straight the paths of our God."
        ],
        mpBenId: "ad2 now when john",
        ep2HymnId: "creator of the stars of night",
        ep2VandR: [
            "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
            "Let the earth o_pen, and let it bring forth sal_va_tion."
        ],
        ep2MagId: "ad2 art thou he",
        collect: "Stir up our hearts, O Lord, to prepare the ways of thine Only Begotten Son: that through his advent we may be worthy to serve thee with purified minds; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        alternativeCollects: [
            "Blessed Lord, who hast caused all holy Scriptures to be written for our learning: grant that we may in such wise hear them, read, mark, learn, and inwardly digest them, that by patience and comfort of thy holy Word, we may embrace and ever hold fast the blessed hope of everlasting life, which thou hast given us in our Saviour Jesus Christ; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        ],
        sundayInAdvent: true,
        weekdays: [
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad2 from heaven there",
                magId: "ad2 behold the king"
            },
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad2 the lord shall",
                magId: "ad2 the voice of"
            },
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad2 behold i send",
                magId: "ad2 sion thou shalt"
            },
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad2 thou o lord",
                magId: "ad2 he that cometh"
            },
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad2 say to them",
                magId: "ad2 o sing unto"
            },
            {
                invId: "ad1 the lord the king ferias",
                benId: "ad2 the lord shall"
            }
        ]
    });
    const getAdventMag = (date)=>{
        const lookup = {
            "17": "ad o wisdom",
            "18": "ad o adonai",
            "19": "ad o root of jesse",
            "20": "ad o key of david",
            "21": "ad o dayspring",
            "22": "ad o king of the nations",
            "23": "ad o emmanuel"
        };
        return lookup[date + ""];
    };
    const getAdventBen = (date)=>{
        const lookup = {
            "21": "ad be not afraid",
            "23": "ad behold all things",
            "24": "ad the saviour of the world"
        };
        return lookup[date + ""];
    };
    const getAdventCollect = (date)=>{
        const lookup = {
            "17": "O God, the Creator and Redeemer of all mankind, who didst will that thy Word should take flesh in an ever-virgin womb: mercifully hear our prayers; that thine Only Begotten Son, who hath taken unto himself our humanity, may graciously grant us a share in his divinity; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "18": "Grant, we beseech thee, Almighty God: that we, who through our ancient bondage are held beneath the yoke of sin, may by the new birth of thine Only Begotten Son in the flesh obtain deliverance; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "19": "O God, who through the child-bearing of the holy Virgin hast graciously revealed the brightness of thy glory unto all the world: grant, we beseech thee; that we may worship with purity of faith the mystery of so wondrous an Incarnation, and always celebrate it with due reverence; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "20": "O God, eternal majesty, whose ineffable Word the immaculate Virgin received by the message of an Angel, and so became the dwelling-place of divinity filled with the light of the Holy Spirit: grant, we beseech thee; that by her example we may in humility hold fast to thy will; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "21": "We beseech thee, O Lord, to hear the prayers of thy people: that those who rejoice at the advent of thine Only Begotten Son in our flesh, may, when at last he cometh in glory, obtain the reward of eternal life; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "22": "O God, who seeing man sunk in death didst will to redeem him by the advent of thine Only Begotten Son: grant, we beseech thee; that those who confess with humble devotion his Incarnation may also merit participation in him as their Redeemer; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "23": "Almighty and everlasting God, as the Nativity of thy Son according to the flesh draweth nigh: we beseech thee, that to us thine unworthy servants thy Word may grant mercy; for he Vouchsafed to be made flesh of the Virgin Mary and dwell among us, even Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            "24": "Raise up, we beseech thee, O Lord, thy power, and come among us, and with great might succour us: that whereas, through our sins and wickedness, we are sorely hindered in running the race that is set before us, thy bountiful grace and mercy may speedily help and deliver us; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        };
        return lookup[date + ""];
    };
    const getSapientiatideTitle = (date)=>{
        const lookup = {
            "17": "17th December",
            "18": "18th December",
            "19": "19th December",
            "20": "20th December",
            "21": "21st December",
            "22": "22nd December",
            "23": "23rd December",
            "24": "24th December"
        };
        return lookup[date + ""];
    };
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("christmas-day").getNthBefore(2, "sun").placeCelebration((day)=>{
        return {
            label: "advent-3",
            rank: 2,
            type: "sunday",
            title: "The Third Sunday of Advent",
            shortTitle: "Advent III",
            ep1HymnId: "creator of the stars of night",
            ep1VandR: [
                "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
                "Let the earth o_pen, and let it bring forth sal_va_tion."
            ],
            ep1MagId: getAdventMag(day.date - 1) ?? "ad3 before me",
            invId: "ad3 the lord is now nigh",
            mpHymnId: "high word of god who once didst come",
            mpVandR: [
                "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                "Make straight the paths of our God."
            ],
            mpBenId: "ad3 on the throne",
            ep2HymnId: "creator of the stars of night",
            ep2VandR: [
                "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
                "Let the earth o_pen, and let it bring forth sal_va_tion."
            ],
            ep2MagId: getAdventMag(day.date) ?? "ad3 blessed art thou",
            collect: "O Lord Jesus Christ, who at thy first coming didst send thy messenger to prepare thy way before thee: grant that the ministers and stewards of thy mysteries may likewise so prepare and make ready thy way, by turning the hearts of the disobedient to the wisdom of the just; that at thy second coming to judge the world we may be found an acceptable people in thy sight; who livest and reignest with the Father in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            sundayInAdvent: true,
            weekdays: [
                {
                    invId: "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 1) ?? "ad3 there shall come",
                    magId: getAdventMag(day.date + 1) ?? "ad3 all generations",
                    collect: getAdventCollect(day.date + 1),
                    rank: getAdventCollect(day.date + 1) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 1)
                },
                {
                    invId: "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 2) ?? "ad3 thou bethlehem",
                    magId: getAdventMag(day.date + 2) ?? "ad3 awake awake arise CHECK",
                    collect: getAdventCollect(day.date + 2),
                    rank: getAdventCollect(day.date + 2) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 2)
                },
                {
                    invId: "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 3) ?? "ad3 the angel gabriel",
                    magId: getAdventMag(day.date + 3) ?? "ad3 behold the handmaid CHECK",
                    collect: getAdventCollect(day.date + 3),
                    rank: getAdventCollect(day.date + 3) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 3)
                },
                {
                    invId: "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 4) ?? "ad3 watch therefore",
                    magId: getAdventMag(day.date + 4) ?? "ad3 rejoice ye with CHECK",
                    collect: getAdventCollect(day.date + 4),
                    rank: getAdventCollect(day.date + 4) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 4)
                },
                {
                    invId: "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 5) ?? "ad3 as soon as",
                    magId: getAdventMag(day.date + 5),
                    collect: getAdventCollect(day.date + 5),
                    rank: getAdventCollect(day.date + 5) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 5)
                },
                {
                    invId: "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 6) ?? "ad3 how shall this be CHECK",
                    magId: getAdventMag(day.date + 6),
                    collect: getAdventCollect(day.date + 6),
                    rank: getAdventCollect(day.date + 6) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 6)
                }
            ]
        };
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("christmas-day").getNthBefore(1, "sun").placeCelebration((day)=>{
        return {
            label: "advent-4",
            rank: 2,
            type: "sunday",
            title: "The Fourth Sunday of Advent",
            shortTitle: "Advent IV",
            ep1HymnId: "creator of the stars of night",
            ep1VandR: [
                "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
                "Let the earth o_pen, and let it bring forth sal_va_tion."
            ],
            ep1MagId: getAdventMag(day.date - 1),
            invId: day.date === 24 ? "christmas eve inv" : "ad3 the lord is now nigh",
            mpHymnId: "high word of god who once didst come",
            mpVandR: day.date === 24 ? [
                "To_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
                "And the Sa_viour of the world shall reign o_ver us."
            ] : [
                "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                "Make straight the paths of our God."
            ],
            mpBenId: day.date === 21 || day.date === 23 ? getAdventBen(day.date) : "ad4 hail mary full",
            ep2HymnId: "creator of the stars of night",
            ep2VandR: [
                "Drop down, ye hea_vens, from a_bove, and let the skies pour down right_eous_ness.",
                "Let the earth o_pen, and let it bring forth sal_va_tion."
            ],
            ep2MagId: getAdventMag(day.date),
            collect: "Raise up, we beseech thee, O Lord, thy power, and come among us, and with great might succour us: that whereas, through our sins and wickedness, we are sorely hindered in running the race that is set before us, thy bountiful grace and mercy may speedily help and deliver us; who livest and reignest with the Father, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
            sundayInAdvent: true,
            weekdays: [
                {
                    invId: day.date + 1 === 24 ? "christmas eve inv" : "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 1) ?? "ad4 thus says CHECK",
                    magId: getAdventMag(day.date + 1),
                    collect: getAdventCollect(day.date + 1),
                    alternativeCollects: day.date + 1 === 24 ? [
                        "O God, who makest us glad with the yearly remembrance of the birth of thy only Son Jesus Christ: grant that as we joyfully as our Redeemer, we may with sure confidence behold him when he shall come again to be our Judge; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
                    ] : undefined,
                    rank: getAdventCollect(day.date + 1) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 1),
                    mpVandR: day.date === 25 ? [
                        "To_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
                        "And the Sa_viour of the world shall reign o_ver us."
                    ] : [
                        "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                        "Make straight the paths of our God."
                    ]
                },
                {
                    invId: day.date + 2 === 24 ? "christmas eve inv" : "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 2) ?? "ad4 awake awake",
                    magId: getAdventMag(day.date + 2),
                    collect: getAdventCollect(day.date + 2),
                    alternativeCollects: day.date + 2 === 24 ? [
                        "O God, who makest us glad with the yearly remembrance of the birth of thy only Son Jesus Christ: grant that as we joyfully as our Redeemer, we may with sure confidence behold him when he shall come again to be our Judge; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
                    ] : undefined,
                    rank: getAdventCollect(day.date + 2) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 2),
                    mpVandR: day.date + 2 === 24 ? [
                        "To_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
                        "And the Sa_viour of the world shall reign o_ver us."
                    ] : [
                        "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                        "Make straight the paths of our God."
                    ]
                },
                {
                    invId: day.date + 3 === 24 ? "christmas eve inv" : "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 3) ?? "ad4 i will place",
                    magId: getAdventMag(day.date + 3),
                    collect: getAdventCollect(day.date + 3),
                    alternativeCollects: day.date + 3 === 24 ? [
                        "O God, who makest us glad with the yearly remembrance of the birth of thy only Son Jesus Christ: grant that as we joyfully as our Redeemer, we may with sure confidence behold him when he shall come again to be our Judge; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
                    ] : undefined,
                    rank: getAdventCollect(day.date + 3) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 3),
                    mpVandR: day.date + 3 === 24 ? [
                        "To_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
                        "And the Sa_viour of the world shall reign o_ver us."
                    ] : [
                        "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                        "Make straight the paths of our God."
                    ]
                },
                {
                    invId: day.date + 4 === 24 ? "christmas eve inv" : "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 4) ?? "ad4 comfort ye",
                    magId: getAdventMag(day.date + 4),
                    collect: getAdventCollect(day.date + 4),
                    alternativeCollects: day.date + 4 === 24 ? [
                        "O God, who makest us glad with the yearly remembrance of the birth of thy only Son Jesus Christ: grant that as we joyfully as our Redeemer, we may with sure confidence behold him when he shall come again to be our Judge; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
                    ] : undefined,
                    rank: getAdventCollect(day.date + 4) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 4),
                    mpVandR: day.date + 4 === 24 ? [
                        "To_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
                        "And the Sa_viour of the world shall reign o_ver us."
                    ] : [
                        "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                        "Make straight the paths of our God."
                    ]
                },
                {
                    invId: day.date + 5 === 24 ? "christmas eve inv" : "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 5),
                    magId: getAdventMag(day.date + 5),
                    collect: getAdventCollect(day.date + 5),
                    alternativeCollects: day.date + 5 === 24 ? [
                        "O God, who makest us glad with the yearly remembrance of the birth of thy only Son Jesus Christ: grant that as we joyfully as our Redeemer, we may with sure confidence behold him when he shall come again to be our Judge; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
                    ] : undefined,
                    rank: getAdventCollect(day.date + 5) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 5),
                    mpVandR: day.date + 5 === 24 ? [
                        "To_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
                        "And the Sa_viour of the world shall reign o_ver us."
                    ] : [
                        "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                        "Make straight the paths of our God."
                    ]
                },
                {
                    invId: day.date + 6 === 24 ? "christmas eve inv" : "ad3 the lord is now nigh ferias",
                    benId: getAdventBen(day.date + 6),
                    magId: getAdventMag(day.date + 6),
                    collect: getAdventCollect(day.date + 6),
                    alternativeCollects: day.date + 6 === 24 ? [
                        "O God, who makest us glad with the yearly remembrance of the birth of thy only Son Jesus Christ: grant that as we joyfully as our Redeemer, we may with sure confidence behold him when he shall come again to be our Judge; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
                    ] : undefined,
                    rank: getAdventCollect(day.date + 6) ? 9 : undefined,
                    title: getSapientiatideTitle(day.date + 6),
                    mpVandR: day.date + 6 === 24 ? [
                        "To_mor_row the i_ni_qui_ty of the earth shall be done a_way.",
                        "And the Sa_viour of the world shall reign o_ver us."
                    ] : [
                        "The voice of one cry_ing in the wil_der_ness: Pre_pare ye the way of the Lord.",
                        "Make straight the paths of our God."
                    ]
                }
            ].slice(0, 24 - day.date)
        };
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("advent-1").getNthBefore(1, "sun").placeCelebration({
        label: "christ-the-king",
        rank: 3,
        type: "solemnity",
        title: "Our Lord Jesus Christ, King of the Universe",
        shortTitle: "Christ the King",
        operatesAsSunday: true,
        ep1HymnId: "o christ to endless ages lord",
        ep1VandR: [
            "All po_wer is gi_ven to me.",
            "In hea_ven and in earth."
        ],
        ep1MagId: "ctk the lord god",
        invId: "ctk inv",
        mpHymnId: "unfurled the glorious banners fly",
        mpVandR: [
            "Of the in_crease of his go_vern_ment.",
            "And of his peace there shall be no end."
        ],
        mpBenId: "ctk unto god",
        ep2HymnId: "o christ to endless ages lord",
        ep2VandR: [
            "Of the in_crease of his go_vern_ment.",
            "And of his peace there shall be no end."
        ],
        ep2MagId: "ctk he hath",
        collect: "Almighty and everlasting God, whose will it is to restore all things in thy well-beloved Son, the King of kings and Lord of lords: mercifully grant that the peoples of the earth, divided and enslaved by sin, may be freed and brought together under his most gracious rule; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("advent-1").getNthBefore(1, "mon").placeCelebration({
        label: "monday-before-advent",
        rank: 13,
        type: "feria",
        title: "Monday before Advent",
        collect: "Stir up, we beseech thee, O Lord, the wills of thy faithful people: that they, plenteously bringing forth the fruit of good works, may of thee be plenteously rewarded; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        invId: "inv mon",
        mpHymnId: "o splendour of gods glory bright",
        mpVandR: [
            "O sa_tis_fy us with thy mer_cy.",
            "That we may re_joice and be glad."
        ],
        mpBenId: "sba when jesus",
        ep2HymnId: "o boundless wisdom god most high",
        ep2VandR: [
            "Let our eve_ning prayer come up be_fore thee, O Lord.",
            "And let thy mer_cy come down up_on us."
        ],
        ep2MagId: "sba then those"
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("advent-1").getNthBefore(1, "tues").placeCelebration({
        label: "tuesday-before-advent",
        rank: 13,
        type: "feria",
        title: "Tuesday before Advent",
        collect: "Stir up, we beseech thee, O Lord, the wills of thy faithful people: that they, plenteously bringing forth the fruit of good works, may of thee be plenteously rewarded; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        invId: "inv tues",
        mpHymnId: "the winged herald of the day",
        mpVandR: [
            "O sa_tis_fy us with thy mer_cy.",
            "That we may re_joice and be glad."
        ],
        mpBenId: "sba when jesus",
        ep2HymnId: "earths mighty maker whose command",
        ep2VandR: [
            "Let our eve_ning prayer come up be_fore thee, O Lord.",
            "And let thy mer_cy come down up_on us."
        ],
        ep2MagId: "sba then those"
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("advent-1").getNthBefore(1, "wed").placeCelebration({
        label: "wednesday-before-advent",
        rank: 13,
        type: "feria",
        title: "Wednesday before Advent",
        collect: "Stir up, we beseech thee, O Lord, the wills of thy faithful people: that they, plenteously bringing forth the fruit of good works, may of thee be plenteously rewarded; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        invId: "inv wed",
        mpHymnId: "ye clouds and darkness hosts of night",
        mpVandR: [
            "O sa_tis_fy us with thy mer_cy.",
            "That we may re_joice and be glad."
        ],
        mpBenId: "sba when jesus",
        ep2HymnId: "most holy lord and god of heaven",
        ep2VandR: [
            "Let our eve_ning prayer come up be_fore thee, O Lord.",
            "And let thy mer_cy come down up_on us."
        ],
        ep2MagId: "sba then those"
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("advent-1").getNthBefore(1, "thur").placeCelebration({
        label: "thursday-before-advent",
        rank: 13,
        type: "feria",
        title: "Thursday before Advent",
        collect: "Stir up, we beseech thee, O Lord, the wills of thy faithful people: that they, plenteously bringing forth the fruit of good works, may of thee be plenteously rewarded; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        invId: "inv thur",
        mpHymnId: "lo golden light rekindles day",
        mpVandR: [
            "O sa_tis_fy us with thy mer_cy.",
            "That we may re_joice and be glad."
        ],
        mpBenId: "sba when jesus",
        ep2HymnId: "almighty god who from the flood",
        ep2VandR: [
            "Let our eve_ning prayer come up be_fore thee, O Lord.",
            "And let thy mer_cy come down up_on us."
        ],
        ep2MagId: "sba then those"
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("advent-1").getNthBefore(1, "fri").placeCelebration({
        label: "friday-before-advent",
        rank: 13,
        type: "feria",
        title: "Friday before Advent",
        collect: "Stir up, we beseech thee, O Lord, the wills of thy faithful people: that they, plenteously bringing forth the fruit of good works, may of thee be plenteously rewarded; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        invId: "inv fri",
        mpHymnId: "eternal glory of the sky",
        mpVandR: [
            "O sa_tis_fy us with thy mer_cy.",
            "That we may re_joice and be glad."
        ],
        mpBenId: "sba when jesus",
        ep2HymnId: "maker of man who from thy throne",
        ep2VandR: [
            "Let our eve_ning prayer come up be_fore thee, O Lord.",
            "And let thy mer_cy come down up_on us."
        ],
        ep2MagId: "sba then those"
    });
    $2d95fb1756754bc6$var$modify(calendar).onCelebration("advent-1").getNthBefore(1, "sat").placeCelebration({
        label: "saturday-before-advent",
        rank: 13,
        type: "feria",
        title: "Saturday before Advent",
        collect: "Stir up, we beseech thee, O Lord, the wills of thy faithful people: that they, plenteously bringing forth the fruit of good works, may of thee be plenteously rewarded; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen.",
        invId: "inv sat",
        mpHymnId: "the dawn is sprinkling in the east",
        mpVandR: [
            "O sa_tis_fy us with thy mer_cy.",
            "That we may re_joice and be glad."
        ],
        mpBenId: "sba when jesus",
        ep2HymnId: "o trinity of blessed light",
        ep2VandR: [
            "Let our eve_ning prayer come up be_fore thee, O Lord.",
            "And let thy mer_cy come down up_on us."
        ],
        ep2MagId: "sba then those"
    });
    $2d95fb1756754bc6$var$modify(calendar).onDate(14, 9).getNthAfter(1, "wed").placeCelebration({
        label: "ember-wednesday-in-september",
        rank: 9,
        type: "misc",
        deletesFeria: true,
        title: "Ember Wednesday in September",
        mpBenId: "ember sept this kind",
        collect: "Grant, we beseech thee, O Lord, to us thy humble servants: that we, who do refrain ourselves from carnal feastings, may likewise fast from sin within our souls; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onDate(14, 9).getNthAfter(1, "fri").placeCelebration({
        label: "ember-friday-in-september",
        rank: 9,
        type: "misc",
        deletesFeria: true,
        title: "Ember Friday in September",
        mpBenId: "ember sept a woman",
        collect: "Grant, we beseech thee, Almighty God: that we, who year by year devotedly keep this holy ordinance of abstinence, may serve thee acceptably both in body and soul; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    $2d95fb1756754bc6$var$modify(calendar).onDate(14, 9).getNthAfter(1, "sat").placeCelebration({
        label: "ember-saturday-in-september",
        rank: 9,
        type: "misc",
        deletesFeria: true,
        title: "Ember Saturday in September",
        mpBenId: "ember sept give light",
        collect: "Almighty and everlasting God, who through godly continency bestowest healing both of body and soul: we humbly beseech thy majesty graciously to look upon the devout prayers and abstinence of thy people, granting us in this world the succour of thy grace, and in the world to come life everlasting; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
    });
    // Sundays after Trinity (lower precedence than Sundays in Advent)
    const trinitytidePropers = {
        "trinity-1": {
            ep1MagId: "t1 the child samuel",
            mpBenId: "t1 father abraham",
            ep2MagId: "t1 son remember",
            collect: "O God, the strength of all them that put their trust in thee: mercifully accept our prayers; and because through the weakness of our mortal nature we can do no good thing without thee, grant us the help of thy grace, that in keeping thy commandments we may please thee both in will and deed; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-2": {
            ep1MagId: "t2 and all israel",
            mpBenId: "t2 a certain man",
            ep2MagId: "t2 go out quickly",
            collect: "O Lord, who never failest to help and govern them whom thou dost bring up in thy steadfast fear and love: keep us, we beseech thee, under the protection of thy good providence; and make us to have a perpetual fear and love of thy holy Name; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-3": {
            ep1MagId: "t3 ye mountains",
            mpBenId: "t3 what man",
            ep2MagId: "t3 what woman",
            collect: "O Lord, we beseech thee mercifully to hear us: and grant that we, to whom thou hast given an hearty desire to pray, may, by thy mighty aid, be defended and comforted in all dangers and adversities; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-4": {
            ep1MagId: "t4 and david said",
            mpBenId: "t4 be ye therefore",
            ep2MagId: "t4 judge not",
            collect: "O God, the protector of all that trust in thee, without whom nothing is strong, nothing is holy: increase and multiply upon us thy mercy; that, thou being our ruler and guide, we may so pass through things temporal, that we finally lose not the things eternal; grant this, O heavenly Father, for the sake of Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-5": {
            ep1MagId: "t5 so david",
            mpBenId: "t5 and jesus",
            ep2MagId: "t5 master we have toiled",
            collect: "Grant, O Lord, we beseech thee: that the course of this world may be so peaceably ordered by thy governance; that thy Church may joyfully serve thee in all godly quietness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-6": {
            ep1MagId: "t6 i am distressed",
            mpBenId: "t6 ye have heard",
            ep2MagId: "t6 if thou bring",
            collect: "O God, who hast prepared for them that love thee such good things as pass man's understanding: pour into our hearts such love toward thee; that we, loving thee in all things and above all things, may obtain thy promises, which exceed all that we can desire; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-7": {
            ep1MagId: "t7 but king david",
            mpBenId: "t7 when a great",
            ep2MagId: "t7 i have compassion",
            collect: "Lord of all power and might, who art the author and giver of all good things: graft in our hearts the love of thy Name; increase in us true religion, nourish us with all goodness, and of thy great mercy keep us in the same; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-8": {
            ep1MagId: "t8 wisdom crieth",
            mpBenId: "t8 beware ye",
            ep2MagId: "t8 a good tree",
            collect: "O God, whose never-failing providence ordereth all things both in heaven and earth: we humbly beseech thee to put away from us all hurtful things, and to give us those things which be profitable for us; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-9": {
            ep1MagId: "t9 i beseech",
            mpBenId: "t9 the lord said",
            ep2MagId: "t9 what shall i do",
            collect: "Grant to us, Lord, we beseech thee, the spirit to think and do always such things as be rightful: that we, who cannot do any thing that is good without thee, may by thee be enabled to live according to thy will; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-10": {
            ep1MagId: "t10 go not",
            mpBenId: "t10 when jesus",
            ep2MagId: "t10 it is written",
            collect: "Let thy merciful ears, O Lord, be open to the prayers of thy humble servants: and that they may obtain their petitions, make them to ask such things as shall please thee; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-11": {
            ep1MagId: "t11 son of man",
            mpBenId: "t11 standing afar",
            ep2MagId: "t11 this man",
            collect: "O God, who declarest thy almighty power most chiefly in showing mercy and pity; mercifully grant unto us such a measure of thy grace; that we, running the way of thy commandments, may obtain thy gracious promises, and be made partakers of thy heavenly treasure; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-12": {
            ep1MagId: "t12 i will shake",
            mpBenId: "t12 when the lord",
            ep2MagId: "t12 he hath done",
            collect: "Almighty and everlasting God, who art always more ready to hear than we to pray, and art wont to give more than either we desire or deserve: pour down upon us the abundance of thy mercy; forgiving us those things whereof our conscience is afraid, and giving us those good things which we are not worthy to ask, but through the merits and mediation of Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-13": {
            ep1MagId: "t13 i will stand",
            mpBenId: "t13 master what shall",
            ep2MagId: "t13 a certain man",
            collect: "Almighty and merciful God, of whose only gift it cometh that thy faithful people do unto thee true and laudable service: grant, we beseech thee; that we may so faithfully serve thee in this life, that we fail not finally to attain thy heavenly promises; through the merits of Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-14": {
            ep1MagId: "t14 blessed be",
            mpBenId: "t14 as jesus",
            ep2MagId: "t14 but one",
            collect: "Almighty and everlasting God: give unto us the increase of faith, hope, and charity; and, that we may obtain that which thou dost promise, make us to love that which thou dost command; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-15": {
            ep1MagId: "t15 blessed be",
            mpBenId: "t15 take no",
            ep2MagId: "t15 but seek ye",
            collect: "Keep, we beseech thee, O Lord, thy Church with thy perpetual mercy: and, because the frailty of man without thee cannot but fall; keep us ever by thy help from all things hurtful, and lead us to all things profitable to our salvation; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-16": {
            ep1MagId: "t16 the sun shone",
            mpBenId: "t16 jesus entered",
            ep2MagId: "t16 a great prophet",
            collect: "O Lord, we beseech thee, let thy continual pity cleanse and defend thy Church: and, because she cannot continue in safety without thy succour; preserve her evermore by thy help and goodness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-17": {
            ep1MagId: "t17 now job",
            mpBenId: "t17 as jesus",
            ep2MagId: "t17 when thou",
            collect: "Lord, we pray thee that thy grace may always precede and follow us: and make us continually to be given to all good works; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-18": {
            ep1MagId: "t18 dominion and fear",
            mpBenId: "t18 master which",
            ep2MagId: "t18 what think ye",
            collect: "Lord, we beseech thee, grant thy people grace to withstand the temptations of the world, the flesh, and the devil: and with pure hearts and minds to follow thee the only God; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-19": {
            ep1MagId: "t19 where shall",
            mpBenId: "t19 jesus said",
            ep2MagId: "t19 the sick",
            collect: "O God, forasmuch as without thee we are not able to please thee: mercifully grant that thy Holy Spirit may in all things direct and rule our hearts; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the same Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-20": {
            ep1MagId: "t20 wisdom hath",
            mpBenId: "t20 tell them",
            ep2MagId: "t20 but when",
            collect: "O Almighty and most merciful God: of thy bountiful goodness keep us, we beseech thee, from all things that may hurt us; that we, being ready both in body and soul, may cheerfully accomplish those things which thou commandest; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-21": {
            ep1MagId: "t21 in the way",
            mpBenId: "t21 there was",
            ep2MagId: "t21 so the father",
            collect: "Grant, we beseech thee, merciful Lord, to thy faithful people pardon and peace: that they may be cleansed from all their sins, and serve thee with a quiet mind; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-22": {
            ep1MagId: "t22 all wisdom",
            mpBenId: "t22 the lord said",
            ep2MagId: "t22 thou wicked",
            collect: "Lord, we beseech thee to keep thy household the Church in continual godliness: that through thy protection she may be free from all adversities, and devoutly given to serve thee in good works, to the glory of thy Name; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-23": {
            ep1MagId: "t23 arm yourselves",
            mpBenId: "t23 master we know",
            ep2MagId: "t23 render therefore",
            collect: "O God, our refuge and strength, who art the author of all godliness: be ready, we beseech thee, to hear the devout prayers of thy Church; and grant that those things which we ask faithfully we may obtain effectually; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-24": {
            ep1MagId: "t24 i dwell",
            mpBenId: "t24 for she said",
            ep2MagId: "t24 but jesus",
            collect: "O Lord, we beseech thee, absolve thy people from their offences: that through thy bountiful goodness we may all be delivered from the bonds of those sins, which by our frailty we have committed; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        },
        "trinity-25": {
            ep1MagId: "ep sat ep1 god hath holpen",
            mpBenId: "ep6 as the lightning",
            ep2MagId: "t25 give peace",
            collect: "O God, whose blessed Son was manifested that he might destroy the works of the devil, and make us the sons of God, and heirs of eternal life: grant us, we beseech thee; that, having this hope, we may purify ourselves, even as he is pure; that, when he shall appear again with power and great glory, we may be made like unto him in his eternal glorious kingdom; where with thee, O Father, and thee, O Holy Spirit, he liveth and reigneth, ever one God, world without end. Amen."
        },
        "trinity-26": {
            ep1MagId: "ep sat ep1 god hath holpen",
            mpBenId: "ep6 as the lightning",
            ep2MagId: "t26 let your song",
            collect: "O God, whose blessed Son was manifested that he might destroy the works of the devil, and make us the sons of God, and heirs of eternal life: grant us, we beseech thee; that, having this hope, we may purify ourselves, even as he is pure; that, when he shall appear again with power and great glory, we may be made like unto him in his eternal glorious kingdom; where with thee, O Father, and thee, O Holy Spirit, he liveth and reigneth, ever one God, world without end. Amen."
        }
    };
    for(let i = 1; i <= 27; i++)$2d95fb1756754bc6$var$modify(calendar).onCelebration("trinity-sunday").getNthAfter(i, "sun").placeCelebration({
        label: `trinity-${i}`,
        rank: 6,
        type: "sunday",
        title: "The " + [
            "First",
            "Second",
            "Third",
            "Fourth",
            "Fifth",
            "Sixth",
            "Seventh",
            "Eighth",
            "Ninth",
            "Tenth",
            "Eleventh",
            "Twelfth",
            "Thirteenth",
            "Fourteenth",
            "Fifteenth",
            "Sixteenth",
            "Seventeenth",
            "Eighteenth",
            "Nineteenth",
            "Twentieth",
            "Twenty-first",
            "Twenty-second",
            "Twenty-third",
            "Twenty-fourth",
            "Twenty-fifth",
            "Twenty-sixth",
            "Twenty-seventh"
        ][i - 1] + " Sunday after Trinity",
        shortTitle: "Trinity " + [
            "I",
            "II",
            "III",
            "IV",
            "V",
            "VI",
            "VII",
            "VIII",
            "IX",
            "X",
            "XI",
            "XII",
            "XIII",
            "XIV",
            "XV",
            "XVI",
            "XVII",
            "XVIII",
            "XIX",
            "XX",
            "XXI",
            "XXII",
            "XXIII",
            "XXIV",
            "XXV",
            "XXVI",
            "XXVII"
        ][i - 1],
        sundayAfterTrinity: true,
        ...trinitytidePropers[`trinity-${i}`] ?? {}
    });
    const trinity25Index = calendar.days.findIndex((day)=>day.celebrations.find((c)=>c.label === "trinity-25") !== undefined && day.year === year);
    const advent1Index = calendar.days.findIndex((day)=>day.celebrations.find((c)=>c.label === "advent-1") !== undefined && day.year === year);
    if (advent1Index - trinity25Index > 7) {
        const t25 = calendar.days[trinity25Index].celebrations.find((c)=>c.label === "trinity-25");
        if (t25) {
            t25.mpBenId = "ep5 master sowedst";
            for(let i = 1; i <= 6; i++){
                const feria = calendar.days[trinity25Index + i].celebrations.find((c)=>c.type === "feria");
                if (feria) feria.mpBenId = "ep5 master sowedst";
            }
        }
    }
    const grabbedSolemnities = [];
    // Transfer outranked solemnities
    calendar.days.forEach((day, dayIndex)=>{
        const { outranked: outranked } = $2d95fb1756754bc6$var$getOptionsAndOutranked(day.celebrations, [
            "*"
        ]);
        outranked.forEach((outrankedCelebration)=>{
            if (outrankedCelebration.type === "solemnity") {
                const alreadyGrabbed = grabbedSolemnities.includes(outrankedCelebration.label);
                if (alreadyGrabbed) day.celebrations = day.celebrations.filter((celebration)=>celebration.label !== outrankedCelebration.label);
                else {
                    day.transferNotes.push(`The Solemnity of ${outrankedCelebration.shortTitle ?? outrankedCelebration.title}${outrankedCelebration.regionNote ? ` (${outrankedCelebration.regionNote})` : ""}, which would usually fall on this day, is outranked this year, and has been transferred to the next available day.`);
                    grabbedSolemnities.push(outrankedCelebration.label);
                }
                calendar.days[dayIndex + 1].celebrations.push(outrankedCelebration);
            }
        });
    });
    calendar.days.forEach((day)=>{
        if (day.dayOfTheWeek === "sat") {
            // Add Office of St Mary on Saturday
            const celebration = {
                invId: "annunciation inv",
                label: "saint-mary-on-saturday",
                rank: 12,
                type: "memorial",
                optional: true,
                title: "Saint Mary on Saturday",
                mpHymnId: "o glorious maid exalted far",
                mpVandR: [
                    "Bless_ed art thou a_mong wo_men.",
                    "And bless_ed is the fruit of thy womb."
                ],
                mpBenId: day.month === 1 && day.date >= 14 || day.month === 2 && day.date === 1 ? "bvm a great and wondrous" : day.celebrations.find((c)=>c.title.includes("Easter") || c.title.includes("Ascension") || c.title.includes("Whitsun")) ? "bvm joy to thee" : "bvm o blessed mother",
                collect: day.celebrations.find((c)=>c.title.includes("Advent")) ? "O God, who didst will that thy Word should take flesh in the womb of the Blessed Virgin Mary, at the message of an Angel: grant that we thy suppliants, who believe her to be in very deed the Mother of God, may be aided by her intercession with thee; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." : day.celebrations.find((c)=>c.title.includes("Christmas")) ? "O God, who through the fruitful virginity of Blessed Mary hast bestowed upon mankind the rewards of eternal salvation: grant, we beseech thee; that we may continually perceive the benefit of her intercession, since through her we have been counted worthy to receive the Author of life, Jesus Christ thy Son our Lord; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen." : "Grant, we beseech thee, O Lord God, that we thy servants may enjoy perpetual health of mind and body: and, at the glorious intercession of the blessed and ever-Virgin Mary, may be delivered from present sadness, and may rejoice in continual gladness; through Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
            };
            day.celebrations.push(celebration);
        }
    });
    // Change how memorials outranked by ferias of rank 9 are populated
    calendar.days.forEach((day, dayIndex)=>{
        const outrankingFeria = day.celebrations.find((c)=>c.rank === 9);
        calendar.days[dayIndex].celebrations = calendar.days[dayIndex].celebrations.map((celebration)=>{
            if (celebration.rank > 9 && outrankingFeria) return {
                ...celebration,
                invId: outrankingFeria.invId,
                mpHymnId: outrankingFeria.mpHymnId,
                mpVandR: outrankingFeria.mpVandR,
                mpBenId: outrankingFeria.mpBenId,
                ep2HymnId: outrankingFeria.ep2HymnId,
                ep2VandR: outrankingFeria.ep2VandR,
                ep2MagId: outrankingFeria.ep2MagId
            };
            else return celebration;
        });
    });
    // Add votive offices every day
    calendar.days.forEach((day, dayIndex)=>{
        day.celebrations.push({
            ...(0, $e4d81acce6b1f0d2$export$68aaa04082781e33)["Apostles"],
            ...day.celebrations.find((celebration)=>celebration.title.includes("Easter")) !== undefined ? (0, $e4d81acce6b1f0d2$export$68aaa04082781e33)["Apostles"].easterOverrides : {},
            type: "misc",
            rank: 20,
            title: "Votive Office of Saint Peter and Saint Paul",
            label: "votive-of-saints-peter-and-paul",
            mpVandR: [
                "Their sound is gone out in_to all lands.",
                "And their words to the ends of the world."
            ],
            mpBenId: "votive peter and paul these glorious",
            ep2VandR: [
                "Thou shalt make them prin_ces in all lands.",
                "They shall re_mem_ber thy Name, O Lord, from one ge_ne_ration to a_no_ther."
            ],
            ep2MagId: "votive peter and paul peter the",
            collect: "O God, who didst give such grace unto thy holy Apostles Saint Peter and Saint Paul, that they were enabled to bear witness to the truth by their death: grant unto thy Church that, as in the beginning she was enlightened by their teaching, so by their intercession she may continue in the same unto the coming of our Lord Jesus Christ; who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        });
        day.celebrations.push({
            label: "votive-of-oljc-high-priest",
            title: "Votive Office of Our Lord Jesus Christ, Supreme and Eternal High Priest",
            type: "misc",
            rank: 20,
            invId: "oljchp inv",
            mpHymnId: "when the patriarch was returning",
            mpVandR: [
                "I will re_ceive the cup of sal_va_tion.",
                "And call u_pon the Name of the Lord."
            ],
            mpBenId: "oljchp this is my body",
            ep2HymnId: "sing o earth for thy redemption",
            ep2VandR: [
                "Thou hast a_noin_ted my head with oil.",
                "And my cup shall be full."
            ],
            ep2MagId: "oljchp behold i will send",
            collect: "O God, who, for the glory of thy majesty and the salvation of mankind, didst appoint thine Only Begotten Son supreme and eternal Priest: vouchsafe that they, whom he hath chosen to be the ministers and stewards of his mysteries, may be found faithful in fulfilling the ministry they have received; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
        });
    });
    return calendar;
};
const $2d95fb1756754bc6$export$881078e20baaf0cf = (year, month, date, epiphanyTransferred, ascensionTransferred, corupsChristiTransferred)=>{
    const y = parseInt(`${year}`);
    const m = parseInt(`${month}`);
    const d = parseInt(`${date}`);
    const day = $2d95fb1756754bc6$export$1c780ae2703443e0(y, epiphanyTransferred, ascensionTransferred, corupsChristiTransferred).days.find((day)=>day.month === m && day.date === d);
    if (day) return day;
    else throw new Error("Could not find that day");
};
const $2d95fb1756754bc6$export$e7af3ee2c84591cc = (month)=>{
    return [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ][month - 1];
};




const $9afeba4689e197d7$export$def13b44aba10201 = ()=>{
    const mailRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (mailRef.current) mailRef.current.href = "mailto:" + [
            "contact",
            "singtheoffice.com"
        ].join("@");
    }, []);
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const [date, setDate] = (0, $acw62.useState)(new Date());
    const isEpiphanyTransferred = settings.transferEpiphany === "yes";
    const isAscensionTransferred = settings.transferAscension === "yes";
    const isCorpusChristiTransferred = settings.transferCorpusChristi === "yes";
    const [regionsSwitchedOn, setRegionsSwitchedOn] = (0, $acw62.useState)(new Set(localStorage.getItem("region-switches")?.split(";;;")));
    const regionLabelsAllowed = [];
    regionsSwitchedOn.forEach((r)=>regionLabelsAllowed.push(r));
    const year = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(date.getFullYear(), isEpiphanyTransferred, isAscensionTransferred, isCorpusChristiTransferred, regionLabelsAllowed);
    const todayIndex = year.findIndex((day)=>day.date === new Date().getDate() && day.month === new Date().getMonth() + 1 && day.year === new Date().getFullYear());
    const [hour, setHour] = (0, $acw62.useState)(new Date().getHours() > 12 ? "evening" : "morning");
    const partOfYearToShow = year.slice(todayIndex, todayIndex + 9);
    const regionLabelsToShow = new Set();
    partOfYearToShow.forEach((day)=>{
        day.regionLabels.forEach((regionLabel)=>{
            regionLabelsToShow.add(regionLabel);
        });
    });
    const sortedRegionLabels = [];
    regionLabelsToShow.forEach((regionLabel)=>{
        sortedRegionLabels.push(regionLabel);
    });
    sortedRegionLabels.sort();
    console.log(regionsSwitchedOn);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    paddingTop: 32,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontSize: "200%",
                            fontWeight: "bold",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            height: 44
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "Sing"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                                },
                                children: "The"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "Office"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                            textAlign: "center",
                            fontWeight: "bold"
                        },
                        children: "Second Edition"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            textAlign: "center",
                            fontSize: "120%",
                            padding: 24,
                            paddingBottom: 32,
                            maxWidth: 350
                        },
                        children: "Daily Offices from the English Prayerbook tradition, pointed\xa0for\xa0chant."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: (0, $cd93687958c8007e$export$bc451faac18251e7)() ? 0 : 8
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $759a82e2daa88b64$export$d0d43328e21205da), {
                    ...partOfYearToShow[0],
                    isSelected: true,
                    setDate: setDate
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: (0, $cd93687958c8007e$export$bc451faac18251e7)() ? 8 : 16
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        border: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`,
                        borderRadius: 4,
                        overflow: "hidden",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                backgroundColor: "#f4f4f4",
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                columnGap: 12,
                                rowGap: 0,
                                justifyContent: "center",
                                padding: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        width: "100%",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        fontSize: "110%"
                                    },
                                    children: "Calendar"
                                }),
                                sortedRegionLabels.map((regionLabel)=>{
                                    const isOn = regionsSwitchedOn.has(regionLabel);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                id: regionLabel,
                                                checked: isOn,
                                                onClick: ()=>{
                                                    if (isOn) regionsSwitchedOn.delete(regionLabel);
                                                    else regionsSwitchedOn.add(regionLabel);
                                                    setRegionsSwitchedOn(new Set(regionsSwitchedOn));
                                                    const lsItems = [];
                                                    regionsSwitchedOn.forEach((r)=>lsItems.push(r));
                                                    localStorage.setItem(`region-switches`, lsItems.join(";;;"));
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: regionLabel,
                                                style: {
                                                    paddingLeft: 4
                                                },
                                                children: regionLabel
                                            })
                                        ]
                                    });
                                })
                            ]
                        }),
                        partOfYearToShow.slice(1).map((day)=>{
                            const isSelected = day.date === date.getDate() && day.month === date.getMonth() + 1 && day.year === date.getFullYear();
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    borderTop: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $759a82e2daa88b64$export$d0d43328e21205da), {
                                    ...day,
                                    setDate: setDate,
                                    isSelected: isSelected
                                })
                            });
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: (0, $cd93687958c8007e$export$bc451faac18251e7)() ? 8 : 16,
                    paddingTop: 0,
                    paddingBottom: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        textAlign: "left",
                        padding: 24,
                        border: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`,
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                        borderRadius: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "stretch",
                        gap: 12
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                                fontSize: "110%"
                            },
                            children: "About"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: "SingTheOffice provides Daily Offices from the English Prayerbook tradition, fully pointed for Gregorian Chant, and as of the Second Edition, compliant with the rubrics of Divine Worship: Daily Office (Commonwealth Edition)."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: "The first edition of SingTheOffice, with the 1662 Calendar, Sarum tones, and other features as released in 2021 is still available below."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "If you have feedback or suggestions, please",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    type: "mailto",
                                    ref: mailRef,
                                    children: "get in touch."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                            children: [
                                "If you would like to receive extremely rare email updates,",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://singtheoffice.substack.com/subscribe",
                                    children: "sign up for our newsletter."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: 24,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                    to: "/first-edition",
                    style: {
                        color: "black"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9269fe14be50e41e$export$3457cdbe4eabc5a0), {
                        onClick: ()=>{},
                        children: "Go to First Edition"
                    })
                })
            })
        ]
    });
};



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




const $ec987eae7646dfa6$export$581092beba250b02 = (props)=>{
    const { title: title, toneId: toneId, pointedText: pointedText, psalmNumber: psalmNumber, firstVerse: firstVerse } = props;
    const [modal, setModal] = (0, $acw62.useState)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}));
    const id = title + toneId;
    const { settings: settings } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {},
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2d213bd4c46a128$export$1246c4e68efb74f5), {
                id: id,
                title: title,
                player: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d785bb9b161f2130$export$397fd5de0a6e6acd), {
                    tones: [
                        toneId
                    ],
                    id: title + toneId,
                    onSetModal: (id, element)=>setModal(element),
                    selectedTone: toneId,
                    onSetSelectedTone: (tone)=>{}
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                pointedText: pointedText,
                boldMode: "alternate",
                dropCap: true,
                exportLines: false,
                tone: toneId,
                onReportMistake: async (verseIndex)=>{}
            }),
            modal
        ]
    });
};


const $77125283e747f314$export$bebb639124f81280 = (props)=>{
    const { title: title, psalmNumber: psalmNumber, sections: sections } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: sections.map((section, i)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec987eae7646dfa6$export$581092beba250b02), {
                title: i == 0 ? title.replace("-100", "-end") : `${title} cont'd`,
                pointedText: section.pointedText,
                toneId: section.toneId,
                psalmNumber: psalmNumber,
                firstVerse: section.verseNumber
            }, `${title}-${section.toneId}`);
        })
    });
};




var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");
/**
 * @import {Element, Nodes, Parents, Root} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {ComponentType, JSX, ReactElement, ReactNode} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList, Processor} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in keyof JSX.IntrinsicElements]?: ComponentType<JSX.IntrinsicElements[Key] & ExtraProps> | keyof JSX.IntrinsicElements
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @typedef HooksOptionsOnly
 *   Configuration specifically for {@linkcode MarkdownHooks}.
 * @property {ReactNode | null | undefined} [fallback]
 *   Content to render while the processor processing the markdown (optional).
 */ /**
 * @typedef {Options & HooksOptionsOnly} HooksOptions
 *   Configuration for {@linkcode MarkdownHooks};
 *   extends the regular {@linkcode Options} with a `fallback` prop.
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ function $b33bccef26feab59$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $b33bccef26feab59$export$411ce8e5a71e3069() {}
function $b33bccef26feab59$export$dcb8b3f0e2de7e49() {}
function $b33bccef26feab59$export$565e9d9bd6b6e0d4() {}


/**
 * @import {Identifier, Literal, MemberExpression} from 'estree'
 * @import {Jsx, JsxDev, Options, Props} from 'hast-util-to-jsx-runtime'
 * @import {Element, Nodes, Parents, Root, Text} from 'hast'
 * @import {MdxFlowExpressionHast, MdxTextExpressionHast} from 'mdast-util-mdx-expression'
 * @import {MdxJsxFlowElementHast, MdxJsxTextElementHast} from 'mdast-util-mdx-jsx'
 * @import {MdxjsEsmHast} from 'mdast-util-mdxjs-esm'
 * @import {Position} from 'unist'
 * @import {Child, Create, Field, JsxElement, State, Style} from './types.js'
 */ /**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $79f9d1c25aee8303$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $79f9d1c25aee8303$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $71dccab0424c1a9b$var$startRe = /[$_\p{ID_Start}]/u;
const $71dccab0424c1a9b$var$contRe = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $71dccab0424c1a9b$var$contReJsx = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $71dccab0424c1a9b$var$nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const $71dccab0424c1a9b$var$nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
/** @type {Options} */ const $71dccab0424c1a9b$var$emptyOptions = {};
function $71dccab0424c1a9b$export$b3571188c770cc5a(code) {
    return code ? $71dccab0424c1a9b$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $71dccab0424c1a9b$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $71dccab0424c1a9b$var$emptyOptions;
    const re = settings.jsx ? $71dccab0424c1a9b$var$contReJsx : $71dccab0424c1a9b$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $71dccab0424c1a9b$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $71dccab0424c1a9b$var$emptyOptions;
    const re = settings.jsx ? $71dccab0424c1a9b$var$nameReJsx : $71dccab0424c1a9b$var$nameRe;
    return re.test(name);
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $1c96ecd7b01e42d9$var$re = /[ \t\n\f\r]/g;
function $1c96ecd7b01e42d9$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $1c96ecd7b01e42d9$var$empty(thing.value) : false : $1c96ecd7b01e42d9$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $1c96ecd7b01e42d9$var$empty(value) {
    return value.replace($1c96ecd7b01e42d9$var$re, '') === '';
}


/**
 * @import {Schema} from 'property-information'
 */ /**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $5570beed4f72c7cb$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.attribute = '';
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.booleanish = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.boolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.defined = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.number = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.property = '';
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.space = undefined;


var $7bb28a628b951544$exports = {};

$parcel$export($7bb28a628b951544$exports, "boolean", () => $7bb28a628b951544$export$4a21f16c33752377);
$parcel$export($7bb28a628b951544$exports, "booleanish", () => $7bb28a628b951544$export$55e9e1fbc638dc8f);
$parcel$export($7bb28a628b951544$exports, "overloadedBoolean", () => $7bb28a628b951544$export$242ac3d3042558aa);
$parcel$export($7bb28a628b951544$exports, "number", () => $7bb28a628b951544$export$98e628dec113755e);
$parcel$export($7bb28a628b951544$exports, "spaceSeparated", () => $7bb28a628b951544$export$ab8645c862eb5a3e);
$parcel$export($7bb28a628b951544$exports, "commaSeparated", () => $7bb28a628b951544$export$9c8d678629b3d3);
$parcel$export($7bb28a628b951544$exports, "commaOrSpaceSeparated", () => $7bb28a628b951544$export$2ad25cfebf36cacd);
let $7bb28a628b951544$var$powers = 0;
const $7bb28a628b951544$export$4a21f16c33752377 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$55e9e1fbc638dc8f = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$242ac3d3042558aa = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$98e628dec113755e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$ab8645c862eb5a3e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$9c8d678629b3d3 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$2ad25cfebf36cacd = $7bb28a628b951544$var$increment();
function $7bb28a628b951544$var$increment() {
    return 2 ** ++$7bb28a628b951544$var$powers;
}


const $de3826e2cce515f8$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($7bb28a628b951544$exports);
class $de3826e2cce515f8$export$ea6b9f0064e88c9b extends (0, $5570beed4f72c7cb$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $de3826e2cce515f8$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $de3826e2cce515f8$var$checks.length){
            const check = $de3826e2cce515f8$var$checks[index];
            $de3826e2cce515f8$var$mark(this, $de3826e2cce515f8$var$checks[index], (mask & $7bb28a628b951544$exports[check]) === $7bb28a628b951544$exports[check]);
        }
    }
}
$de3826e2cce515f8$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $de3826e2cce515f8$var$mark(values, key, value) {
    if (value) values[key] = value;
}



/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $e8e4f4c42f412e49$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


const $a05ae03077f3d80b$var$cap = /[A-Z]/g;
const $a05ae03077f3d80b$var$dash = /-[a-z]/g;
const $a05ae03077f3d80b$var$valid = /^data[-\w.:]+$/i;
function $a05ae03077f3d80b$export$71aa6c912b956294(schema, value) {
    const normal = (0, $e8e4f4c42f412e49$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $5570beed4f72c7cb$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $a05ae03077f3d80b$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($a05ae03077f3d80b$var$dash, $a05ae03077f3d80b$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$a05ae03077f3d80b$var$dash.test(rest)) {
                let dashes = rest.replace($a05ae03077f3d80b$var$cap, $a05ae03077f3d80b$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $de3826e2cce515f8$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $a05ae03077f3d80b$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $a05ae03077f3d80b$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * Special cases for React (`Record<string, string>`).
 *
 * `hast` is close to `React` but differs in a couple of cases.
 * To get a React property from a hast property,
 * check if it is in `hastToReact`.
 * If it is, use the corresponding value;
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $d2bfbc2ede41b173$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};

// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $ebcb43fb277eac89$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$ebcb43fb277eac89$export$19342e026b58ebb7.prototype.normal = {};
$ebcb43fb277eac89$export$19342e026b58ebb7.prototype.property = {};
$ebcb43fb277eac89$export$19342e026b58ebb7.prototype.space = undefined;


function $9557e96728c042cf$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $ebcb43fb277eac89$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ 


function $9ab7a0f2f5273cb1$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $de3826e2cce515f8$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $e8e4f4c42f412e49$export$a3295358bff77e)(property)] = property;
        normals[(0, $e8e4f4c42f412e49$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $ebcb43fb277eac89$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $90343b68c9a7ed34$export$4d2d26490572750a = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaColIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaColSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaControls: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaLevel: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaPressed: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaRowIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaRowSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaSelected: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueMin: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueNow: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $fa5ee16f731231fb$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $f2ac7ad36db76cd1$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $fa5ee16f731231fb$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $71d94da779c1399e$export$c0bb0b647f701bb5 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        acceptCharset: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        accessKey: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $7bb28a628b951544$export$4a21f16c33752377),
        allowPaymentRequest: (0, $7bb28a628b951544$export$4a21f16c33752377),
        allowUserMedia: (0, $7bb28a628b951544$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $7bb28a628b951544$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        autoFocus: (0, $7bb28a628b951544$export$4a21f16c33752377),
        autoPlay: (0, $7bb28a628b951544$export$4a21f16c33752377),
        blocking: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $7bb28a628b951544$export$4a21f16c33752377),
        cite: null,
        className: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        cols: (0, $7bb28a628b951544$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        controls: (0, $7bb28a628b951544$export$4a21f16c33752377),
        controlsList: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        coords: (0, $7bb28a628b951544$export$98e628dec113755e) | (0, $7bb28a628b951544$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $7bb28a628b951544$export$4a21f16c33752377),
        defer: (0, $7bb28a628b951544$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $7bb28a628b951544$export$4a21f16c33752377),
        download: (0, $7bb28a628b951544$export$242ac3d3042558aa),
        draggable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $7bb28a628b951544$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        height: (0, $7bb28a628b951544$export$98e628dec113755e),
        hidden: (0, $7bb28a628b951544$export$242ac3d3042558aa),
        high: (0, $7bb28a628b951544$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        httpEquiv: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $7bb28a628b951544$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $7bb28a628b951544$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        itemRef: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        itemScope: (0, $7bb28a628b951544$export$4a21f16c33752377),
        itemType: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $7bb28a628b951544$export$4a21f16c33752377),
        low: (0, $7bb28a628b951544$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        multiple: (0, $7bb28a628b951544$export$4a21f16c33752377),
        muted: (0, $7bb28a628b951544$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noValidate: (0, $7bb28a628b951544$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $7bb28a628b951544$export$4a21f16c33752377),
        optimum: (0, $7bb28a628b951544$export$98e628dec113755e),
        pattern: null,
        ping: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $7bb28a628b951544$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $7bb28a628b951544$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        required: (0, $7bb28a628b951544$export$4a21f16c33752377),
        reversed: (0, $7bb28a628b951544$export$4a21f16c33752377),
        rows: (0, $7bb28a628b951544$export$98e628dec113755e),
        rowSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        sandbox: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $7bb28a628b951544$export$4a21f16c33752377),
        seamless: (0, $7bb28a628b951544$export$4a21f16c33752377),
        selected: (0, $7bb28a628b951544$export$4a21f16c33752377),
        shadowRootClonable: (0, $7bb28a628b951544$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $7bb28a628b951544$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $7bb28a628b951544$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $7bb28a628b951544$export$98e628dec113755e),
        spellCheck: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $7bb28a628b951544$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $7bb28a628b951544$export$4a21f16c33752377),
        useMap: null,
        value: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        width: (0, $7bb28a628b951544$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $7bb28a628b951544$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $7bb28a628b951544$export$4a21f16c33752377),
        declare: (0, $7bb28a628b951544$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $7bb28a628b951544$export$98e628dec113755e),
        leftMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        marginWidth: (0, $7bb28a628b951544$export$98e628dec113755e),
        noResize: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noHref: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noShade: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noWrap: (0, $7bb28a628b951544$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $7bb28a628b951544$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $7bb28a628b951544$export$4a21f16c33752377),
        disableRemotePlayback: (0, $7bb28a628b951544$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $7bb28a628b951544$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $f2ac7ad36db76cd1$export$32b9e4cec9c208e1)
});





const $81184b40caf3b243$export$7ed1367e7fa1ad68 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        accentHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $7bb28a628b951544$export$98e628dec113755e),
        amplitude: (0, $7bb28a628b951544$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $7bb28a628b951544$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $7bb28a628b951544$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $7bb28a628b951544$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        className: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $7bb28a628b951544$export$98e628dec113755e),
        diffuseConstant: (0, $7bb28a628b951544$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $7bb28a628b951544$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $7bb28a628b951544$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $7bb28a628b951544$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $7bb28a628b951544$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $7bb28a628b951544$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        g2: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        glyphName: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $7bb28a628b951544$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $7bb28a628b951544$export$98e628dec113755e),
        horizOriginX: (0, $7bb28a628b951544$export$98e628dec113755e),
        horizOriginY: (0, $7bb28a628b951544$export$98e628dec113755e),
        id: null,
        ideographic: (0, $7bb28a628b951544$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $7bb28a628b951544$export$98e628dec113755e),
        k: (0, $7bb28a628b951544$export$98e628dec113755e),
        k1: (0, $7bb28a628b951544$export$98e628dec113755e),
        k2: (0, $7bb28a628b951544$export$98e628dec113755e),
        k3: (0, $7bb28a628b951544$export$98e628dec113755e),
        k4: (0, $7bb28a628b951544$export$98e628dec113755e),
        kernelMatrix: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $7bb28a628b951544$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $7bb28a628b951544$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        overlineThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $7bb28a628b951544$export$98e628dec113755e),
        pointsAtY: (0, $7bb28a628b951544$export$98e628dec113755e),
        pointsAtZ: (0, $7bb28a628b951544$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        rev: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFonts: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFormats: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $7bb28a628b951544$export$98e628dec113755e),
        specularExponent: (0, $7bb28a628b951544$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        strikethroughThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $7bb28a628b951544$export$98e628dec113755e),
        strokeOpacity: (0, $7bb28a628b951544$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $7bb28a628b951544$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        tabIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $7bb28a628b951544$export$98e628dec113755e),
        targetY: (0, $7bb28a628b951544$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        underlineThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $7bb28a628b951544$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $7bb28a628b951544$export$98e628dec113755e),
        vMathematical: (0, $7bb28a628b951544$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $7bb28a628b951544$export$98e628dec113755e),
        vIdeographic: (0, $7bb28a628b951544$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $7bb28a628b951544$export$98e628dec113755e),
        vertOriginX: (0, $7bb28a628b951544$export$98e628dec113755e),
        vertOriginY: (0, $7bb28a628b951544$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $fa5ee16f731231fb$export$5b10b3bc32d7efbc)
});



const $54e6fef78f3cbe14$export$2bd1230ec7600845 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $6b2d9925b04ededa$export$e20c24a128671213 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $f2ac7ad36db76cd1$export$32b9e4cec9c208e1)
});



const $9c2001df32d7e0eb$export$f2913fe8983302e = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});





const $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5 = (0, $9557e96728c042cf$export$4950aa0f605343fb)([
    (0, $90343b68c9a7ed34$export$4d2d26490572750a),
    (0, $71d94da779c1399e$export$c0bb0b647f701bb5),
    (0, $54e6fef78f3cbe14$export$2bd1230ec7600845),
    (0, $6b2d9925b04ededa$export$e20c24a128671213),
    (0, $9c2001df32d7e0eb$export$f2913fe8983302e)
], 'html');
const $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68 = (0, $9557e96728c042cf$export$4950aa0f605343fb)([
    (0, $90343b68c9a7ed34$export$4d2d26490572750a),
    (0, $81184b40caf3b243$export$7ed1367e7fa1ad68),
    (0, $54e6fef78f3cbe14$export$2bd1230ec7600845),
    (0, $6b2d9925b04ededa$export$e20c24a128671213),
    (0, $9c2001df32d7e0eb$export$f2913fe8983302e)
], 'svg');


/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $38edd4def83e695e$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $38edd4def83e695e$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


var $71148f37a304a9c5$exports = {};
"use strict";
var $71148f37a304a9c5$var$__importDefault = $71148f37a304a9c5$exports && $71148f37a304a9c5$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $71148f37a304a9c5$var$style_to_object_1 = $71148f37a304a9c5$var$__importDefault((parcelRequire("8sxY3")));
var $f5184b1855e76cde$exports = {};
"use strict";
Object.defineProperty($f5184b1855e76cde$exports, "__esModule", {
    value: true
});
$f5184b1855e76cde$exports.camelCase = void 0;
var $f5184b1855e76cde$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $f5184b1855e76cde$var$HYPHEN_REGEX = /-([a-z])/g;
var $f5184b1855e76cde$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $f5184b1855e76cde$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $f5184b1855e76cde$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $f5184b1855e76cde$var$skipCamelCase = function(property) {
    return !property || $f5184b1855e76cde$var$NO_HYPHEN_REGEX.test(property) || $f5184b1855e76cde$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $f5184b1855e76cde$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $f5184b1855e76cde$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $f5184b1855e76cde$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($f5184b1855e76cde$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($f5184b1855e76cde$var$MS_VENDOR_PREFIX_REGEX, $f5184b1855e76cde$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($f5184b1855e76cde$var$VENDOR_PREFIX_REGEX, $f5184b1855e76cde$var$trimHyphen);
    return property.replace($f5184b1855e76cde$var$HYPHEN_REGEX, $f5184b1855e76cde$var$capitalize);
};
$f5184b1855e76cde$exports.camelCase = $f5184b1855e76cde$var$camelCase;


/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $71148f37a304a9c5$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $71148f37a304a9c5$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $f5184b1855e76cde$exports.camelCase)(property, options)] = value;
    });
    return output;
}
$71148f37a304a9c5$var$StyleToJS.default = $71148f37a304a9c5$var$StyleToJS;
$71148f37a304a9c5$exports = $71148f37a304a9c5$var$StyleToJS;


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $bbca31c5046a61f5$export$da309cdce9dc2a25 = $bbca31c5046a61f5$var$point('end');
const $bbca31c5046a61f5$export$771bf3e4949bfbee = $bbca31c5046a61f5$var$point('start');
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $bbca31c5046a61f5$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === 'number' && point.line > 0 && typeof point.column === 'number' && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === 'number' && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $bbca31c5046a61f5$export$5880b8b5730aff45(node) {
    const start = $bbca31c5046a61f5$export$771bf3e4949bfbee(node);
    const end = $bbca31c5046a61f5$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $b094d2c4d032c594$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $b094d2c4d032c594$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $b094d2c4d032c594$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $b094d2c4d032c594$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $b094d2c4d032c594$var$point(point) {
    return $b094d2c4d032c594$var$index(point && point.line) + ':' + $b094d2c4d032c594$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $b094d2c4d032c594$var$position(pos) {
    return $b094d2c4d032c594$var$point(pos && pos.start) + '-' + $b094d2c4d032c594$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $b094d2c4d032c594$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $84ecfcc79391545c$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = '';
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = {
                ...optionsOrParentOrPlace
            };
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && 'start' in options.place ? options.place.start : options.place;
        /* eslint-disable no-unused-expressions */ /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file;
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $b094d2c4d032c594$export$c304dd45fe166145)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url;
    /* eslint-enable no-unused-expressions */ }
}
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.file = '';
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.name = '';
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.reason = '';
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.message = '';
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.stack = '';
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.column = undefined;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.line = undefined;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.ancestors = undefined;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.cause = undefined;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.fatal = undefined;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.place = undefined;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.ruleId = undefined;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.source = undefined;


// To do: next major: `Object.hasOwn`.
const $d43ea869f7285ee3$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $d43ea869f7285ee3$var$emptyMap = new Map();
const $d43ea869f7285ee3$var$cap = /[A-Z]/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $d43ea869f7285ee3$var$tableElements = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
const $d43ea869f7285ee3$var$tableCellElement = new Set([
    'td',
    'th'
]);
const $d43ea869f7285ee3$var$docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';
function $d43ea869f7285ee3$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError('Expected `Fragment` in options');
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== 'function') throw new TypeError('Expected `jsxDEV` in options when `development: true`');
        create = $d43ea869f7285ee3$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== 'function') throw new TypeError('Expected `jsx` in production options');
        if (typeof options.jsxs !== 'function') throw new TypeError('Expected `jsxs` in production options');
        create = $d43ea869f7285ee3$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || 'react',
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === 'svg' ? (0, $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68) : (0, $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $d43ea869f7285ee3$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== 'string') return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $d43ea869f7285ee3$var$one(state, node, key) {
    if (node.type === 'element') return $d43ea869f7285ee3$var$element(state, node, key);
    if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') return $d43ea869f7285ee3$var$mdxExpression(state, node);
    if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') return $d43ea869f7285ee3$var$mdxJsxElement(state, node, key);
    if (node.type === 'mdxjsEsm') return $d43ea869f7285ee3$var$mdxEsm(state, node);
    if (node.type === 'root') return $d43ea869f7285ee3$var$root(state, node, key);
    if (node.type === 'text') return $d43ea869f7285ee3$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $d43ea869f7285ee3$var$element(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
        schema = (0, $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = $d43ea869f7285ee3$var$findComponentFromName(state, node.tagName, false);
    const props = $d43ea869f7285ee3$var$createElementProps(state, node);
    let children = $d43ea869f7285ee3$var$createChildren(state, node);
    if ($d43ea869f7285ee3$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === 'string' ? !(0, $1c96ecd7b01e42d9$export$7af1228ff777d175)(child) : true;
    });
    $d43ea869f7285ee3$var$addNode(state, props, type, node);
    $d43ea869f7285ee3$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpressionHast | MdxTextExpressionHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $d43ea869f7285ee3$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        const program = node.data.estree;
        const expression = program.body[0];
        (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $d43ea869f7285ee3$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsmHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $d43ea869f7285ee3$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $d43ea869f7285ee3$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $d43ea869f7285ee3$var$mdxJsxElement(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.name === 'svg' && parentSchema.space === 'html') {
        schema = (0, $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = node.name === null ? state.Fragment : $d43ea869f7285ee3$var$findComponentFromName(state, node.name, true);
    const props = $d43ea869f7285ee3$var$createJsxElementProps(state, node);
    const children = $d43ea869f7285ee3$var$createChildren(state, node);
    $d43ea869f7285ee3$var$addNode(state, props, type, node);
    $d43ea869f7285ee3$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $d43ea869f7285ee3$var$root(state, node, key) {
    /** @type {Props} */ const props = {};
    $d43ea869f7285ee3$var$addChildren(props, $d43ea869f7285ee3$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $d43ea869f7285ee3$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $d43ea869f7285ee3$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== 'string' && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $d43ea869f7285ee3$var$addChildren(props, children) {
    if (children.length > 0) {
        const value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $d43ea869f7285ee3$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $d43ea869f7285ee3$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $bbca31c5046a61f5$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $d43ea869f7285ee3$var$createElementProps(state, node) {
    /** @type {Props} */ const props = {};
    /** @type {string | undefined} */ let alignValue;
    /** @type {string} */ let prop;
    for(prop in node.properties)if (prop !== 'children' && $d43ea869f7285ee3$var$own.call(node.properties, prop)) {
        const result = $d43ea869f7285ee3$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            const [key, value] = result;
            if (state.tableCellAlignToStyle && key === 'align' && typeof value === 'string' && $d43ea869f7285ee3$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        const style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $d43ea869f7285ee3$var$createJsxElementProps(state, node) {
    /** @type {Props} */ const props = {};
    for (const attribute of node.attributes)if (attribute.type === 'mdxJsxExpressionAttribute') {
        if (attribute.data && attribute.data.estree && state.evaluater) {
            const program = attribute.data.estree;
            const expression = program.body[0];
            (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
            const objectExpression = expression.expression;
            (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(objectExpression.type === 'ObjectExpression');
            const property = objectExpression.properties[0];
            (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(property.type === 'SpreadElement');
            Object.assign(props, state.evaluater.evaluateExpression(property.argument));
        } else $d43ea869f7285ee3$var$crashEstree(state, node.position);
    } else {
        // For JSX, the author is responsible of passing in the correct values.
        const name = attribute.name;
        /** @type {unknown} */ let value;
        if (attribute.value && typeof attribute.value === 'object') {
            if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                const program = attribute.value.data.estree;
                const expression = program.body[0];
                (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
                value = state.evaluater.evaluateExpression(expression.expression);
            } else $d43ea869f7285ee3$var$crashEstree(state, node.position);
        } else value = attribute.value === null ? true : attribute.value;
        // Assume a prop.
        props[name] = /** @type {Props[keyof Props]} */ value;
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $d43ea869f7285ee3$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByName = state.passKeys ? new Map() : $d43ea869f7285ee3$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys) {
            const name = child.type === 'element' ? child.tagName : child.type === 'mdxJsxFlowElement' || child.type === 'mdxJsxTextElement' ? child.name : undefined;
            if (name) {
                const count = countsByName.get(name) || 0;
                key = name + '-' + count;
                countsByName.set(name, count + 1);
            }
        }
        const result = $d43ea869f7285ee3$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $d43ea869f7285ee3$var$createProperty(state, prop, value) {
    const info = (0, $a05ae03077f3d80b$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === 'number' && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $79f9d1c25aee8303$export$fac44ee5b035f737)(value) : (0, $38edd4def83e695e$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === 'style') {
        let styleObject = typeof value === 'object' ? value : $d43ea869f7285ee3$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === 'css') styleObject = $d43ea869f7285ee3$var$transformStylesToCssCasing(styleObject);
        return [
            'style',
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === 'react' && info.space ? (0, $d2bfbc2ede41b173$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $d43ea869f7285ee3$var$parseStyle(state, value) {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($71148f37a304a9c5$exports)))(value, {
            reactCompat: true
        });
    } catch (error) {
        if (state.ignoreInvalidStyle) return {};
        const cause = /** @type {Error} */ error;
        const message = new (0, $84ecfcc79391545c$export$752e5c445fe834ef)('Cannot parse `style` attribute', {
            ancestors: state.ancestors,
            cause: cause,
            ruleId: 'style',
            source: 'hast-util-to-jsx-runtime'
        });
        message.file = state.filePath || undefined;
        message.url = $d43ea869f7285ee3$var$docs + '#cannot-parse-style-attribute';
        throw message;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $d43ea869f7285ee3$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ let result;
    if (!allowExpression) result = {
        type: 'Literal',
        value: name
    };
    else if (name.includes('.')) {
        const identifiers = name.split('.');
        let index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ let node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ const prop = (0, $71dccab0424c1a9b$export$a8ff84c12d48cfa6)(identifiers[index]) ? {
                type: 'Identifier',
                name: identifiers[index]
            } : {
                type: 'Literal',
                value: identifiers[index]
            };
            node = node ? {
                type: 'MemberExpression',
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === 'Literal'),
                optional: false
            } : prop;
        }
        (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(node, 'always a result');
        result = node;
    } else result = (0, $71dccab0424c1a9b$export$a8ff84c12d48cfa6)(name) && !/^[a-z]/.test(name) ? {
        type: 'Identifier',
        name: name
    } : {
        type: 'Literal',
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === 'Literal') {
        const name = /** @type {string | number} */ result.value;
        return $d43ea869f7285ee3$var$own.call(state.components, name) ? state.components[name] : name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $d43ea869f7285ee3$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $d43ea869f7285ee3$var$crashEstree(state, place) {
    const message = new (0, $84ecfcc79391545c$export$752e5c445fe834ef)('Cannot handle MDX estrees without `createEvaluater`', {
        ancestors: state.ancestors,
        place: place,
        ruleId: 'mdx-estree',
        source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = $d43ea869f7285ee3$var$docs + '#cannot-handle-mdx-estrees-without-createevaluater';
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $d43ea869f7285ee3$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($d43ea869f7285ee3$var$own.call(domCasing, from)) cssCasing[$d43ea869f7285ee3$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $d43ea869f7285ee3$var$transformStyleToCssCasing(from) {
    let to = from.replace($d43ea869f7285ee3$var$cap, $d43ea869f7285ee3$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === 'ms-') to = '-' + to;
    return to;
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $d43ea869f7285ee3$var$toDash($0) {
    return '-' + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $4819636f8d2ef87b$export$de3e062aedff083a = {
    action: [
        'form'
    ],
    cite: [
        'blockquote',
        'del',
        'ins',
        'q'
    ],
    data: [
        'object'
    ],
    formAction: [
        'button',
        'input'
    ],
    href: [
        'a',
        'area',
        'base',
        'link'
    ],
    icon: [
        'menuitem'
    ],
    itemId: null,
    manifest: [
        'html'
    ],
    ping: [
        'a',
        'area'
    ],
    poster: [
        'video'
    ],
    src: [
        'audio',
        'embed',
        'iframe',
        'img',
        'input',
        'script',
        'source',
        'track',
        'video'
    ]
};




var $acw62 = parcelRequire("acw62");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ /**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $79369f5237095e86$var$emptyOptions = {};
function $79369f5237095e86$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $79369f5237095e86$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $79369f5237095e86$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $79369f5237095e86$var$one(value, includeImageAlt, includeHtml) {
    if ($79369f5237095e86$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $79369f5237095e86$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $79369f5237095e86$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $79369f5237095e86$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $79369f5237095e86$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $79369f5237095e86$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* eslint-env browser */ const $3d93ada39b1c4dd6$var$element = document.createElement('i');
function $3d93ada39b1c4dd6$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $3d93ada39b1c4dd6$var$element.innerHTML = characterReference;
    const character = $3d93ada39b1c4dd6$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (// @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return character === characterReference ? false : character;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $0a9edb7ff3ef159f$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $0a9edb7ff3ef159f$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $0a9edb7ff3ef159f$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $12b512a5203a7cce$var$hasOwnProperty = {}.hasOwnProperty;
function $12b512a5203a7cce$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$12b512a5203a7cce$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $12b512a5203a7cce$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $12b512a5203a7cce$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$12b512a5203a7cce$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $12b512a5203a7cce$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $12b512a5203a7cce$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $0a9edb7ff3ef159f$export$869882364835d202)(existing, 0, 0, before);
}
function $12b512a5203a7cce$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$12b512a5203a7cce$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $12b512a5203a7cce$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $12b512a5203a7cce$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $23c7742930bb7617$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $66b350feb28b9f84$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $66b350feb28b9f84$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $66b350feb28b9f84$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $710781c0cdec9f6d$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $432513c48b12fdfc$export$d65d6b62c24d5436 = $432513c48b12fdfc$var$regexCheck(/[A-Za-z]/);
const $432513c48b12fdfc$export$75c76db11865a9f4 = $432513c48b12fdfc$var$regexCheck(/[\dA-Za-z]/);
const $432513c48b12fdfc$export$4397998b34fe597d = $432513c48b12fdfc$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $432513c48b12fdfc$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $432513c48b12fdfc$export$ca8b5b1a6c320e6e = $432513c48b12fdfc$var$regexCheck(/\d/);
const $432513c48b12fdfc$export$eca2752363989806 = $432513c48b12fdfc$var$regexCheck(/[\dA-Fa-f]/);
const $432513c48b12fdfc$export$35794a7d1db99380 = $432513c48b12fdfc$var$regexCheck(/[!-/:-@[-`{-~]/);
function $432513c48b12fdfc$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $432513c48b12fdfc$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $432513c48b12fdfc$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $432513c48b12fdfc$export$aa04114dd888a7a0 = $432513c48b12fdfc$var$regexCheck(/\p{P}|\p{S}/u);
const $432513c48b12fdfc$export$a0ff789c034ffdf4 = $432513c48b12fdfc$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $432513c48b12fdfc$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $628da7f4dfdef27c$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $66b350feb28b9f84$export$c564cdbbe6da493)($628da7f4dfdef27c$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $628da7f4dfdef27c$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $432513c48b12fdfc$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $432513c48b12fdfc$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $30565e716fad33a9$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $30565e716fad33a9$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $30565e716fad33a9$var$protocolSource = /^https?$/i;
function $30565e716fad33a9$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $12b512a5203a7cce$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(head, body);
        head = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($30565e716fad33a9$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $66b350feb28b9f84$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $710781c0cdec9f6d$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $628da7f4dfdef27c$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $30565e716fad33a9$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $628da7f4dfdef27c$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $30565e716fad33a9$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$30565e716fad33a9$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $23c7742930bb7617$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $3d93ada39b1c4dd6$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $628da7f4dfdef27c$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $30565e716fad33a9$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $628da7f4dfdef27c$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $653f8b80711d97d0$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $171a79fbb1402b9a$export$a7db06668cad9adb = {
    tokenize: $171a79fbb1402b9a$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $171a79fbb1402b9a$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 


const $348cdb85d1aeadd1$export$5a7bfc01df82fcd1 = {
    tokenize: $348cdb85d1aeadd1$var$initializeDocument
};
/** @type {Construct} */ const $348cdb85d1aeadd1$var$containerConstruct = {
    tokenize: $348cdb85d1aeadd1$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $348cdb85d1aeadd1$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $0a9edb7ff3ef159f$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($348cdb85d1aeadd1$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($348cdb85d1aeadd1$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $0a9edb7ff3ef159f$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $348cdb85d1aeadd1$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $ad11d598ddddec2e$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $ad11d598ddddec2e$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ad11d598ddddec2e$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $db6aead07b23826f$export$bd596157370df26e {
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $db6aead07b23826f$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $db6aead07b23826f$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $db6aead07b23826f$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $db6aead07b23826f$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $db6aead07b23826f$var$chunkedPush(this.left, removed.reverse());
        }
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $db6aead07b23826f$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $dae5d3de466990fa$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $db6aead07b23826f$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $dae5d3de466990fa$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $0a9edb7ff3ef159f$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $dae5d3de466990fa$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $deaf16079a1807fb$export$a7db06668cad9adb = {
    resolve: $deaf16079a1807fb$var$resolveContent,
    tokenize: $deaf16079a1807fb$var$tokenizeContent
};
/** @type {Construct} */ const $deaf16079a1807fb$var$continuationConstruct = {
    partial: true,
    tokenize: $deaf16079a1807fb$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $deaf16079a1807fb$var$resolveContent(events) {
    (0, $dae5d3de466990fa$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $deaf16079a1807fb$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return effects.check($deaf16079a1807fb$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $deaf16079a1807fb$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $e2fdd11cbe455c51$export$ccc7b0636abaffc3 = {
    tokenize: $e2fdd11cbe455c51$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $e2fdd11cbe455c51$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $ad11d598ddddec2e$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $deaf16079a1807fb$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ const $1fdcbfee479a4092$export$50397835cbfdbc24 = {
    resolveAll: $1fdcbfee479a4092$var$createResolver()
};
const $1fdcbfee479a4092$export$22b082955e083ec3 = $1fdcbfee479a4092$var$initializeFactory('string');
const $1fdcbfee479a4092$export$6f093cfa640b7166 = $1fdcbfee479a4092$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $1fdcbfee479a4092$var$initializeFactory(field) {
    return {
        resolveAll: $1fdcbfee479a4092$var$createResolver(field === 'text' ? $1fdcbfee479a4092$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $1fdcbfee479a4092$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $1fdcbfee479a4092$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $62cac499df3c25a0$exports = {};

$parcel$export($62cac499df3c25a0$exports, "document", () => $62cac499df3c25a0$export$5a7bfc01df82fcd1);
$parcel$export($62cac499df3c25a0$exports, "contentInitial", () => $62cac499df3c25a0$export$5a2181fb44b58173);
$parcel$export($62cac499df3c25a0$exports, "flowInitial", () => $62cac499df3c25a0$export$cf8bead395eff824);
$parcel$export($62cac499df3c25a0$exports, "flow", () => $62cac499df3c25a0$export$ccc7b0636abaffc3);
$parcel$export($62cac499df3c25a0$exports, "string", () => $62cac499df3c25a0$export$22b082955e083ec3);
$parcel$export($62cac499df3c25a0$exports, "text", () => $62cac499df3c25a0$export$6f093cfa640b7166);
$parcel$export($62cac499df3c25a0$exports, "insideSpan", () => $62cac499df3c25a0$export$d44f260a3f9b69f5);
$parcel$export($62cac499df3c25a0$exports, "attentionMarkers", () => $62cac499df3c25a0$export$b9c0b60d74426aea);
$parcel$export($62cac499df3c25a0$exports, "disable", () => $62cac499df3c25a0$export$e20fbacbb41798b);
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $d2c40a75b3c1060a$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) || (0, $432513c48b12fdfc$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $432513c48b12fdfc$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $5fffc2d235733349$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


const $ab77d7b684ccca7a$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $ab77d7b684ccca7a$var$resolveAllAttention,
    tokenize: $ab77d7b684ccca7a$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $ab77d7b684ccca7a$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $ab77d7b684ccca7a$var$movePoint(start, -use);
            $ab77d7b684ccca7a$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, (0, $5fffc2d235733349$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ab77d7b684ccca7a$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $d2c40a75b3c1060a$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $d2c40a75b3c1060a$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $ab77d7b684ccca7a$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $5d33fad6991aa1ad$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $5d33fad6991aa1ad$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5d33fad6991aa1ad$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $432513c48b12fdfc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $432513c48b12fdfc$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $76cd53d8c5b717c4$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $76cd53d8c5b717c4$var$tokenizeBlockQuoteContinuation
    },
    exit: $76cd53d8c5b717c4$var$exit,
    name: 'blockQuote',
    tokenize: $76cd53d8c5b717c4$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $76cd53d8c5b717c4$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $76cd53d8c5b717c4$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($76cd53d8c5b717c4$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $76cd53d8c5b717c4$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $59f80dfce403f5de$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $59f80dfce403f5de$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $59f80dfce403f5de$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $432513c48b12fdfc$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $ce662a9402db28e3$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $ce662a9402db28e3$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ce662a9402db28e3$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $432513c48b12fdfc$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $432513c48b12fdfc$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $432513c48b12fdfc$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $432513c48b12fdfc$export$75c76db11865a9f4) && !(0, $3d93ada39b1c4dd6$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ const $1c411422dc205d23$var$nonLazyContinuation = {
    partial: true,
    tokenize: $1c411422dc205d23$var$tokenizeNonLazyContinuation
};
const $1c411422dc205d23$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $1c411422dc205d23$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1c411422dc205d23$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($1c411422dc205d23$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return effects.check($1c411422dc205d23$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1c411422dc205d23$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $ab4d46130bbbc8bd$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $ab4d46130bbbc8bd$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $ab4d46130bbbc8bd$var$furtherStart = {
    partial: true,
    tokenize: $ab4d46130bbbc8bd$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ab4d46130bbbc8bd$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return effects.attempt($ab4d46130bbbc8bd$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ab4d46130bbbc8bd$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $16c806108f267846$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $16c806108f267846$var$previous,
    resolve: $16c806108f267846$var$resolveCodeText,
    tokenize: $16c806108f267846$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $16c806108f267846$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $16c806108f267846$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $16c806108f267846$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $b2c7e8deac525d60$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $432513c48b12fdfc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $432513c48b12fdfc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $d33e937ae1ea4ed4$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $f42304cc65ff93d0$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $42ba7c725dbf102d$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $d7e2fdfd86ff4dd4$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $d7e2fdfd86ff4dd4$var$tokenizeDefinition
};
/** @type {Construct} */ const $d7e2fdfd86ff4dd4$var$titleBefore = {
    partial: true,
    tokenize: $d7e2fdfd86ff4dd4$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d7e2fdfd86ff4dd4$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $d33e937ae1ea4ed4$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) ? (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $b2c7e8deac525d60$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($d7e2fdfd86ff4dd4$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d7e2fdfd86ff4dd4$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) ? (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $f42304cc65ff93d0$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $0e19123aa1bdeff9$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $0e19123aa1bdeff9$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0e19123aa1bdeff9$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $a46ae5f97ae33c5d$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $a46ae5f97ae33c5d$var$resolveHeadingAtx,
    tokenize: $a46ae5f97ae33c5d$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $a46ae5f97ae33c5d$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $a46ae5f97ae33c5d$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $71c3e0f388301604$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $71c3e0f388301604$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $7d9d35fac2b6ebcc$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $7d9d35fac2b6ebcc$var$resolveToHtmlFlow,
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $7d9d35fac2b6ebcc$var$blankLineBefore = {
    partial: true,
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeBlankLineBefore
};
const $7d9d35fac2b6ebcc$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $7d9d35fac2b6ebcc$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $71c3e0f388301604$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $71c3e0f388301604$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($7d9d35fac2b6ebcc$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($7d9d35fac2b6ebcc$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $71c3e0f388301604$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7d9d35fac2b6ebcc$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $ad11d598ddddec2e$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $b5a186cf1fccfac7$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $b5a186cf1fccfac7$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b5a186cf1fccfac7$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 







const $1dc73455d0df3be9$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $1dc73455d0df3be9$var$resolveAllLabelEnd,
    resolveTo: $1dc73455d0df3be9$var$resolveToLabelEnd,
    tokenize: $1dc73455d0df3be9$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$resourceConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeResource
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$referenceFullConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$referenceCollapsedConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $1dc73455d0df3be9$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $1dc73455d0df3be9$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, (0, $5fffc2d235733349$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $710781c0cdec9f6d$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($1dc73455d0df3be9$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($1dc73455d0df3be9$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($1dc73455d0df3be9$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) ? (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $b2c7e8deac525d60$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) ? (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $f42304cc65ff93d0$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) ? (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $d33e937ae1ea4ed4$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $710781c0cdec9f6d$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1dc73455d0df3be9$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $f5591a0a77ea393a$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $1dc73455d0df3be9$export$470a5dafbbf62654).resolveAll,
    tokenize: $f5591a0a77ea393a$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $f5591a0a77ea393a$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $d496929de41504d8$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $1dc73455d0df3be9$export$470a5dafbbf62654).resolveAll,
    tokenize: $d496929de41504d8$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d496929de41504d8$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $6e24888a23d546e6$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $6e24888a23d546e6$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6e24888a23d546e6$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $aa27701f1509407c$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $aa27701f1509407c$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $aa27701f1509407c$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $57144dde063f82cb$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $57144dde063f82cb$var$tokenizeListContinuation
    },
    exit: $57144dde063f82cb$var$tokenizeListEnd,
    name: 'list',
    tokenize: $57144dde063f82cb$var$tokenizeListStart
};
/** @type {Construct} */ const $57144dde063f82cb$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $57144dde063f82cb$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $57144dde063f82cb$var$indentConstruct = {
    partial: true,
    tokenize: $57144dde063f82cb$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $57144dde063f82cb$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $432513c48b12fdfc$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $aa27701f1509407c$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $432513c48b12fdfc$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $ad11d598ddddec2e$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($57144dde063f82cb$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $57144dde063f82cb$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $ad11d598ddddec2e$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($57144dde063f82cb$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, effects.attempt($57144dde063f82cb$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $57144dde063f82cb$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $57144dde063f82cb$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $57144dde063f82cb$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $8eba9e38644cd781$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $8eba9e38644cd781$var$resolveToSetextUnderline,
    tokenize: $8eba9e38644cd781$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $8eba9e38644cd781$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[content][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $8eba9e38644cd781$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $62cac499df3c25a0$export$5a7bfc01df82fcd1 = {
    [42]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [43]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [45]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [48]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [49]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [50]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [51]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [52]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [53]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [54]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [55]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [56]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [57]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [62]: (0, $76cd53d8c5b717c4$export$200dcd0a5903c968)
};
const $62cac499df3c25a0$export$5a2181fb44b58173 = {
    [91]: (0, $d7e2fdfd86ff4dd4$export$69f215ed977cdb73)
};
const $62cac499df3c25a0$export$cf8bead395eff824 = {
    [-2]: (0, $ab4d46130bbbc8bd$export$47910b7ab28d1853),
    [-1]: (0, $ab4d46130bbbc8bd$export$47910b7ab28d1853),
    [32]: (0, $ab4d46130bbbc8bd$export$47910b7ab28d1853)
};
const $62cac499df3c25a0$export$ccc7b0636abaffc3 = {
    [35]: (0, $a46ae5f97ae33c5d$export$3871e9deb360695c),
    [42]: (0, $aa27701f1509407c$export$ba7b13e047416c03),
    [45]: [
        (0, $8eba9e38644cd781$export$e104e2de391dfde9),
        (0, $aa27701f1509407c$export$ba7b13e047416c03)
    ],
    [60]: (0, $7d9d35fac2b6ebcc$export$476ac411cb7d0d8f),
    [61]: (0, $8eba9e38644cd781$export$e104e2de391dfde9),
    [95]: (0, $aa27701f1509407c$export$ba7b13e047416c03),
    [96]: (0, $1c411422dc205d23$export$c23e4921f8d87e7c),
    [126]: (0, $1c411422dc205d23$export$c23e4921f8d87e7c)
};
const $62cac499df3c25a0$export$22b082955e083ec3 = {
    [38]: (0, $ce662a9402db28e3$export$e31905600aaf3d8e),
    [92]: (0, $59f80dfce403f5de$export$2005478564e78d96)
};
const $62cac499df3c25a0$export$6f093cfa640b7166 = {
    [-5]: (0, $6e24888a23d546e6$export$8e62e0ad51c97b2),
    [-4]: (0, $6e24888a23d546e6$export$8e62e0ad51c97b2),
    [-3]: (0, $6e24888a23d546e6$export$8e62e0ad51c97b2),
    [33]: (0, $f5591a0a77ea393a$export$3d754936e25aa5f5),
    [38]: (0, $ce662a9402db28e3$export$e31905600aaf3d8e),
    [42]: (0, $ab77d7b684ccca7a$export$45b92471da762af7),
    [60]: [
        (0, $5d33fad6991aa1ad$export$17ddf85e4c916ad6),
        (0, $b5a186cf1fccfac7$export$398af27f284914fe)
    ],
    [91]: (0, $d496929de41504d8$export$5c0cee0701a3b584),
    [92]: [
        (0, $0e19123aa1bdeff9$export$86c573ab9e06f418),
        (0, $59f80dfce403f5de$export$2005478564e78d96)
    ],
    [93]: (0, $1dc73455d0df3be9$export$470a5dafbbf62654),
    [95]: (0, $ab77d7b684ccca7a$export$45b92471da762af7),
    [96]: (0, $16c806108f267846$export$d24f93e715f9df88)
};
const $62cac499df3c25a0$export$d44f260a3f9b69f5 = {
    null: [
        (0, $ab77d7b684ccca7a$export$45b92471da762af7),
        (0, $1fdcbfee479a4092$export$50397835cbfdbc24)
    ]
};
const $62cac499df3c25a0$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $62cac499df3c25a0$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $4a83eb91ec5d6b95$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $5fffc2d235733349$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $4a83eb91ec5d6b95$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $4a83eb91ec5d6b95$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $0a9edb7ff3ef159f$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $4a83eb91ec5d6b95$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $4a83eb91ec5d6b95$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $1fc819ea965a3f81$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $12b512a5203a7cce$export$86a865d89ef3c690)([
        $62cac499df3c25a0$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $171a79fbb1402b9a$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $348cdb85d1aeadd1$export$5a7bfc01df82fcd1)),
        flow: create((0, $e2fdd11cbe455c51$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $1fdcbfee479a4092$export$22b082955e083ec3)),
        text: create((0, $1fdcbfee479a4092$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $4a83eb91ec5d6b95$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $4e6fd59d488c6494$export$bd0e6e1378a871d7(events) {
    while(!(0, $dae5d3de466990fa$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $cdd1ff6afd8515e5$var$search = /[\0\t\n\r]/g;
function $cdd1ff6afd8515e5$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $cdd1ff6afd8515e5$var$search.lastIndex = startPosition;
            match = $cdd1ff6afd8515e5$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $620bfb330ac6be0d$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $30565e716fad33a9$export$ef7acd7185315e22)(options)((0, $4e6fd59d488c6494$export$bd0e6e1378a871d7)((0, $1fc819ea965a3f81$export$98e6a39c04603d36)(options).document().write((0, $cdd1ff6afd8515e5$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $0fb53ec7385928f9$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $0fb53ec7385928f9$export$a0fb664af7d0cc44(value) {
    return value.replace($0fb53ec7385928f9$var$characterEscapeOrReference, $0fb53ec7385928f9$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $0fb53ec7385928f9$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $23c7742930bb7617$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $3d93ada39b1c4dd6$export$289b6a6320f709b4)($2) || $0;
}





const $236f1a66ed1dd212$var$own = {}.hasOwnProperty;
function $236f1a66ed1dd212$export$d744d789c09bfde6(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $236f1a66ed1dd212$var$compiler(options)((0, $4e6fd59d488c6494$export$bd0e6e1378a871d7)((0, $1fc819ea965a3f81$export$98e6a39c04603d36)(options).document().write((0, $cdd1ff6afd8515e5$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $236f1a66ed1dd212$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $236f1a66ed1dd212$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($236f1a66ed1dd212$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $236f1a66ed1dd212$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $236f1a66ed1dd212$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $236f1a66ed1dd212$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $236f1a66ed1dd212$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $b094d2c4d032c594$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $236f1a66ed1dd212$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $79369f5237095e86$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $236f1a66ed1dd212$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $236f1a66ed1dd212$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $0fb53ec7385928f9$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $23c7742930bb7617$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $3d93ada39b1c4dd6$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $236f1a66ed1dd212$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $236f1a66ed1dd212$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $236f1a66ed1dd212$var$configure(combined, value);
        else $236f1a66ed1dd212$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $236f1a66ed1dd212$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($236f1a66ed1dd212$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $236f1a66ed1dd212$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $b094d2c4d032c594$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $b094d2c4d032c594$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $b094d2c4d032c594$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $2aab0d1dd6b1383c$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $236f1a66ed1dd212$export$d744d789c09bfde6)(doc, {
            ...self.data('settings'),
            ...options,
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        });
    }
}


/**
 * @import {Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {Options as ToHastOptions} from 'mdast-util-to-hast'
 * @import {Processor} from 'unified'
 * @import {VFile} from 'vfile'
 */ /**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ /**
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('./state.js').Options} Options
 */ 
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ const $45ef8f746872a9d4$export$1cd1943b3a73bbe8 = -1;
const $45ef8f746872a9d4$export$a44b4f3d5b73db95 = 0;
const $45ef8f746872a9d4$export$b119f07080a207ba = 1;
const $45ef8f746872a9d4$export$8b8a958a7f6f130c = 2;
const $45ef8f746872a9d4$export$501a7fac1df67a49 = 3;
const $45ef8f746872a9d4$export$cd2b220b1ea851b2 = 4;
const $45ef8f746872a9d4$export$ce970371e0e850bc = 5;
const $45ef8f746872a9d4$export$5e8f180ef0142226 = 6;
const $45ef8f746872a9d4$export$103bedf43ba882db = 7;
const $45ef8f746872a9d4$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $fd10feb1f7983dd3$var$env = typeof self === 'object' ? self : globalThis;
const $fd10feb1f7983dd3$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $45ef8f746872a9d4$export$a44b4f3d5b73db95:
            case 0, $45ef8f746872a9d4$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $45ef8f746872a9d4$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $45ef8f746872a9d4$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $45ef8f746872a9d4$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $45ef8f746872a9d4$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $45ef8f746872a9d4$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $45ef8f746872a9d4$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $45ef8f746872a9d4$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(new $fd10feb1f7983dd3$var$env[name](message), index);
                }
            case 0, $45ef8f746872a9d4$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
            case 'ArrayBuffer':
                return as(new Uint8Array(value).buffer, value);
            case 'DataView':
                {
                    const { buffer: buffer } = new Uint8Array(value);
                    return as(new DataView(buffer), value);
                }
        }
        return as(new $fd10feb1f7983dd3$var$env[type](value), index);
    };
    return unpair;
};
const $fd10feb1f7983dd3$export$efcd34ab6248d3cd = (serialized)=>$fd10feb1f7983dd3$var$deserializer(new Map, serialized)(0);



const $5cfeb93cc24b886f$var$EMPTY = '';
const { toString: $5cfeb93cc24b886f$var$toString } = {};
const { keys: $5cfeb93cc24b886f$var$keys } = Object;
const $5cfeb93cc24b886f$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== 'object' || !value) return [
        (0, $45ef8f746872a9d4$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $5cfeb93cc24b886f$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $45ef8f746872a9d4$export$b119f07080a207ba),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $45ef8f746872a9d4$export$8b8a958a7f6f130c),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $45ef8f746872a9d4$export$501a7fac1df67a49),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $45ef8f746872a9d4$export$cd2b220b1ea851b2),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $45ef8f746872a9d4$export$ce970371e0e850bc),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $45ef8f746872a9d4$export$5e8f180ef0142226),
                $5cfeb93cc24b886f$var$EMPTY
            ];
        case 'DataView':
            return [
                (0, $45ef8f746872a9d4$export$b119f07080a207ba),
                asString
            ];
    }
    if (asString.includes('Array')) return [
        (0, $45ef8f746872a9d4$export$b119f07080a207ba),
        asString
    ];
    if (asString.includes('Error')) return [
        (0, $45ef8f746872a9d4$export$103bedf43ba882db),
        asString
    ];
    return [
        (0, $45ef8f746872a9d4$export$8b8a958a7f6f130c),
        asString
    ];
};
const $5cfeb93cc24b886f$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $45ef8f746872a9d4$export$a44b4f3d5b73db95) && (type === 'function' || type === 'symbol');
const $5cfeb93cc24b886f$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $5cfeb93cc24b886f$var$typeOf(value);
        switch(TYPE){
            case 0, $45ef8f746872a9d4$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $45ef8f746872a9d4$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $45ef8f746872a9d4$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $45ef8f746872a9d4$export$b119f07080a207ba:
                {
                    if (type) {
                        let spread = value;
                        if (type === 'DataView') spread = new Uint8Array(value.buffer);
                        else if (type === 'ArrayBuffer') spread = new Uint8Array(value);
                        return as([
                            type,
                            [
                                ...spread
                            ]
                        ], value);
                    }
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $45ef8f746872a9d4$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $5cfeb93cc24b886f$var$keys(value))if (strict || !$5cfeb93cc24b886f$var$shouldSkip($5cfeb93cc24b886f$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $45ef8f746872a9d4$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $45ef8f746872a9d4$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $45ef8f746872a9d4$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($5cfeb93cc24b886f$var$shouldSkip($5cfeb93cc24b886f$var$typeOf(key)) || $5cfeb93cc24b886f$var$shouldSkip($5cfeb93cc24b886f$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $45ef8f746872a9d4$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$5cfeb93cc24b886f$var$shouldSkip($5cfeb93cc24b886f$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $5cfeb93cc24b886f$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $5cfeb93cc24b886f$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $ffa319e7789dae9d$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ('json' in options || 'lossy' in options) ? (0, $fd10feb1f7983dd3$export$efcd34ab6248d3cd)((0, $5cfeb93cc24b886f$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $fd10feb1f7983dd3$export$efcd34ab6248d3cd)((0, $5cfeb93cc24b886f$export$dfdc1655ccc5b9cb)(any, options));



function $43b288b5d784432f$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: 'text',
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            {
                type: 'text',
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $43b288b5d784432f$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $43b288b5d784432f$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const footnoteBackContent = state.options.footnoteBackContent || $43b288b5d784432f$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $43b288b5d784432f$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
    const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const definition = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!definition) continue;
        const content = state.all(definition);
        const id = String(definition.identifier).toUpperCase();
        const safeId = (0, $628da7f4dfdef27c$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            let children = typeof footnoteBackContent === 'string' ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === 'string') children = {
                type: 'text',
                value: children
            };
            backReferences.push({
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + clobberPrefix + 'fnref-' + safeId + (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
                    dataFootnoteBackref: '',
                    ariaLabel: typeof footnoteBackLabel === 'string' ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        'data-footnote-backref'
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(definition, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: footnoteLabelTagName,
                properties: {
                    ...(0, $ffa319e7789dae9d$export$2e2bcd8739ae039)(footnoteLabelProperties),
                    id: 'footnote-label'
                },
                children: [
                    {
                        type: 'text',
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').RootContent} HastRootContent
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('mdast').Parents} MdastParents
 *
 * @typedef {import('vfile').VFile} VFile
 *
 * @typedef {import('./footer.js').FootnoteBackContentTemplate} FootnoteBackContentTemplate
 * @typedef {import('./footer.js').FootnoteBackLabelTemplate} FootnoteBackLabelTemplate
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $96c8174c61624bc3$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $96c8174c61624bc3$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$96c8174c61624bc3$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $96c8174c61624bc3$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $96c8174c61624bc3$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $96c8174c61624bc3$var$ok;
    if (typeof test === 'function') return $96c8174c61624bc3$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $96c8174c61624bc3$var$anyFactory(test) : $96c8174c61624bc3$var$propsFactory(test);
    if (typeof test === 'string') return $96c8174c61624bc3$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $96c8174c61624bc3$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $96c8174c61624bc3$export$9c68d69a4c5bbcf9(tests[index]);
    return $96c8174c61624bc3$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $96c8174c61624bc3$var$propsFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $96c8174c61624bc3$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $96c8174c61624bc3$var$typeFactory(check) {
    return $96c8174c61624bc3$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $96c8174c61624bc3$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($96c8174c61624bc3$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $96c8174c61624bc3$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $96c8174c61624bc3$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $f79aea1cccf1d8e6$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $d5f8100665f1cd06$var$empty = [];
const $d5f8100665f1cd06$export$f4d8133c446fe484 = true;
const $d5f8100665f1cd06$export$7f100f842f565dc9 = false;
const $d5f8100665f1cd06$export$8773f85c2fb2c116 = 'skip';
function $d5f8100665f1cd06$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $96c8174c61624bc3$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $f79aea1cccf1d8e6$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $d5f8100665f1cd06$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $d5f8100665f1cd06$var$toResult(visitor(node, parents));
                if (result[0] === $d5f8100665f1cd06$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $d5f8100665f1cd06$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $d5f8100665f1cd06$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $d5f8100665f1cd06$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $d5f8100665f1cd06$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $d5f8100665f1cd06$var$empty : [
        value
    ];
}


function $4ad53e9051b55a53$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $d5f8100665f1cd06$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $0d7bf6069cd4a99d$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $5f854cb469f7f6cd$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $9f7a2a9a3e8cdc0a$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    /** @type {Properties} */ const properties = {};
    if (node.lang) properties.className = [
        'language-' + node.lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $4f75ba80b35d3487$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $71ae8bf40e51fddd$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../state.js').State} State
 */ 
function $d059032a2037e72d$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $628da7f4dfdef27c$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + clobberPrefix + 'fn-' + safeId,
            id: clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $80a0025fee2734a4$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Html} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ // Make VS Code show references to the above types.
'';
function $a544d24f31a6d015$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Reference} Reference
 *
 * @typedef {import('./state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $457fc7453091eab4$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return [
        {
            type: 'text',
            value: '![' + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $34e938c73615b97e$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $457fc7453091eab4$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $628da7f4dfdef27c$export$e42a3e39590d28b5)(definition.url || ''),
        alt: node.alt
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $fa267d4e016e1a94$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $628da7f4dfdef27c$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $a18e1d7c380780d4$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $5ffda1b647f76013$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $457fc7453091eab4$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $628da7f4dfdef27c$export$e42a3e39590d28b5)(definition.url || '')
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $97ae763275816d1f$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $628da7f4dfdef27c$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $0bf735405dac3389$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $0bf735405dac3389$var$listLoose(parent) : $0bf735405dac3389$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $0bf735405dac3389$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $0bf735405dac3389$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $0bf735405dac3389$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $6d52c8b65c22a0f3$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $3d9c5fb20df8334b$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Parents} HastParents
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $921589a7f49d4b71$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $76efd80b61faffa2$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $be7da570dd44e9e6$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $bbca31c5046a61f5$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $bbca31c5046a61f5$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $df756fa740e8d832$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    // To do: option to use `style`?
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $b5328549adeefd62$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $a20c9b53bbfad667$var$tab = 9 /* `\t` */ ;
const $a20c9b53bbfad667$var$space = 32 /* ` ` */ ;
function $a20c9b53bbfad667$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($a20c9b53bbfad667$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($a20c9b53bbfad667$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $a20c9b53bbfad667$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $a20c9b53bbfad667$var$tab || code === $a20c9b53bbfad667$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $a20c9b53bbfad667$var$tab || code === $a20c9b53bbfad667$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $c898c12a1a7a9791$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $a20c9b53bbfad667$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $02537fefb8a9d631$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $22ba932f8fab6e62$export$455ce229eb3d2472 = {
    blockquote: $0d7bf6069cd4a99d$export$67dc04e652a298ca,
    break: (0, $5f854cb469f7f6cd$export$371da9dd35aba193),
    code: $9f7a2a9a3e8cdc0a$export$6565f9f03506010b,
    delete: (0, $4f75ba80b35d3487$export$19426ff118fe8be),
    emphasis: $71ae8bf40e51fddd$export$bef81ba411953b51,
    footnoteReference: $d059032a2037e72d$export$7f87ee744075c1ba,
    heading: $80a0025fee2734a4$export$46e4a324ac90507f,
    html: $a544d24f31a6d015$export$c0bb0b647f701bb5,
    imageReference: $34e938c73615b97e$export$f281796f6bc3b8db,
    image: $fa267d4e016e1a94$export$5c452ff88e35e47d,
    inlineCode: $a18e1d7c380780d4$export$91b9bee19a0d8569,
    linkReference: $5ffda1b647f76013$export$e6c469b1b7b2bc6a,
    link: $97ae763275816d1f$export$9c30223ca0a664fb,
    listItem: $0bf735405dac3389$export$76c7e83ecc9cdf05,
    list: $6d52c8b65c22a0f3$export$8837f4fc672e936d,
    paragraph: $3d9c5fb20df8334b$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $921589a7f49d4b71$export$e8e78c978b129247,
    strong: $76efd80b61faffa2$export$59ae2c325a998f89,
    table: $be7da570dd44e9e6$export$9852986a3ec5f6a0,
    tableCell: $b5328549adeefd62$export$e1e720e5f4603e6a,
    tableRow: $df756fa740e8d832$export$ce666bf02318c957,
    text: $c898c12a1a7a9791$export$6f093cfa640b7166,
    thematicBreak: $02537fefb8a9d631$export$ba7b13e047416c03,
    toml: $22ba932f8fab6e62$var$ignore,
    yaml: $22ba932f8fab6e62$var$ignore,
    definition: $22ba932f8fab6e62$var$ignore,
    footnoteDefinition: $22ba932f8fab6e62$var$ignore
};
// Return nothing for nodes that are ignored.
function $22ba932f8fab6e62$var$ignore() {
    return undefined;
}


const $0d64a4b488f7bd12$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $0d64a4b488f7bd12$var$emptyOptions = {};
function $0d64a4b488f7bd12$export$e6a0daad8304de(tree, options) {
    const settings = options || $0d64a4b488f7bd12$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = {
        ...(0, $22ba932f8fab6e62$export$455ce229eb3d2472),
        ...settings.handlers
    };
    /** @type {State} */ const state = {
        all: all,
        applyData: $0d64a4b488f7bd12$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $0d64a4b488f7bd12$var$patch,
        wrap: $0d64a4b488f7bd12$export$4997ffc0176396a6
    };
    (0, $4ad53e9051b55a53$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === 'definition' || node.type === 'footnoteDefinition') {
            const map = node.type === 'definition' ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($0d64a4b488f7bd12$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ('children' in node) {
                const { children: children, ...shallow } = node;
                const result = (0, $ffa319e7789dae9d$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $ffa319e7789dae9d$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $0d64a4b488f7bd12$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ('children' in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === 'break') {
                        if (!Array.isArray(result) && result.type === 'text') result.value = $0d64a4b488f7bd12$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === 'element') {
                            const head = result.children[0];
                            if (head && head.type === 'text') head.value = $0d64a4b488f7bd12$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $0d64a4b488f7bd12$var$patch(from, to) {
    if (from.position) to.position = (0, $bbca31c5046a61f5$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $0d64a4b488f7bd12$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = 'children' in result ? result.children : [
                    result
                ];
                result = {
                    type: 'element',
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === 'element' && hProperties) Object.assign(result.properties, (0, $ffa319e7789dae9d$export$2e2bcd8739ae039)(hProperties));
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $0d64a4b488f7bd12$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = 'value' in node && !($0d64a4b488f7bd12$var$own.call(data, 'hProperties') || $0d64a4b488f7bd12$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $0d64a4b488f7bd12$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $0d64a4b488f7bd12$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $e651c33bf4085f1d$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $0d64a4b488f7bd12$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $43b288b5d784432f$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node || {
        type: 'root',
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)('children' in result);
        result.children.push({
            type: 'text',
            value: '\n'
        }, foot);
    }
    return result;
}


function $f21eb379270d044c$export$2e2bcd8739ae039(destination, options) {
    if (destination && 'run' in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $e651c33bf4085f1d$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...options
        });
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree, file) {
        // Cast because root in -> root out.
        // To do: in the future, disallow ` || options` fallback.
        // With `unified-engine`, `destination` can be `undefined` but
        // `options` will be the file set.
        // We should not pass that as `options`.
        return /** @type {HastRoot} */ (0, $e651c33bf4085f1d$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...destination || options
        });
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@linkcode CompileResultMap}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@linkcode Node}
 *   and {@linkcode VFile} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@linkcode CompileResultMap}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@linkcode VFile} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@linkcode Node}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@linkcode VFile} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@linkcode VFile}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $ed6a7f7e034afcf2$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $16d474a0815e976d$exports = {};
'use strict';
var $16d474a0815e976d$var$hasOwn = Object.prototype.hasOwnProperty;
var $16d474a0815e976d$var$toStr = Object.prototype.toString;
var $16d474a0815e976d$var$defineProperty = Object.defineProperty;
var $16d474a0815e976d$var$gOPD = Object.getOwnPropertyDescriptor;
var $16d474a0815e976d$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $16d474a0815e976d$var$toStr.call(arr) === '[object Array]';
};
var $16d474a0815e976d$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $16d474a0815e976d$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $16d474a0815e976d$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $16d474a0815e976d$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $16d474a0815e976d$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $16d474a0815e976d$var$setProperty = function setProperty(target, options) {
    if ($16d474a0815e976d$var$defineProperty && options.name === '__proto__') $16d474a0815e976d$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $16d474a0815e976d$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$16d474a0815e976d$var$hasOwn.call(obj, name)) return void 0;
        else if ($16d474a0815e976d$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $16d474a0815e976d$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$16d474a0815e976d$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $16d474a0815e976d$var$getProperty(target, name);
            copy = $16d474a0815e976d$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($16d474a0815e976d$var$isPlainObject(copy) || (copyIsArray = $16d474a0815e976d$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $16d474a0815e976d$var$isArray(src) ? src : [];
                    } else clone = src && $16d474a0815e976d$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $16d474a0815e976d$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $16d474a0815e976d$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $fd11a02fceb57d58$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $c333b7763c7c24e2$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $c333b7763c7c24e2$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $c333b7763c7c24e2$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $6c0e34cf2f183349$export$500c965389abde9c = {
    basename: $6c0e34cf2f183349$var$basename,
    dirname: $6c0e34cf2f183349$var$dirname,
    extname: $6c0e34cf2f183349$var$extname,
    join: $6c0e34cf2f183349$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $6c0e34cf2f183349$var$basename(path, extname) {
    if (extname !== undefined && typeof extname !== 'string') throw new TypeError('"ext" argument must be a string');
    $6c0e34cf2f183349$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (extname === undefined || extname.length === 0 || extname.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (extname === path) return '';
    let firstNonSlashEnd = -1;
    let extnameIndex = extname.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extnameIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
                    if (extnameIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extnameIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$dirname(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $6c0e34cf2f183349$var$extname(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $6c0e34cf2f183349$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $6c0e34cf2f183349$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $6c0e34cf2f183349$var$normalize(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $6c0e34cf2f183349$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $6c0e34cf2f183349$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $329b4cd6854e87dd$export$77f0ef6e088922ec = {
    cwd: $329b4cd6854e87dd$var$cwd
};
function $329b4cd6854e87dd$var$cwd() {
    return '/';
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $ea6379392cbaeecd$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && 'href' in fileUrlOrPath && fileUrlOrPath.href && 'protocol' in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $028cf007d1b71fb0$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $ea6379392cbaeecd$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $028cf007d1b71fb0$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $028cf007d1b71fb0$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $ebdb906eb43ac433$var$order = /** @type {const} */ [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $ebdb906eb43ac433$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $ea6379392cbaeecd$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === 'string' || $ebdb906eb43ac433$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ // Prevent calling `cwd` (which could be expensive) if it’s not needed;
        // the empty string will be overridden in the next block.
        this.cwd = 'cwd' in options ? '' : (0, $329b4cd6854e87dd$export$77f0ef6e088922ec).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $ebdb906eb43ac433$var$order.length){
            const field = $ebdb906eb43ac433$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (field in options && options[field] !== undefined && options[field] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[field] = field === 'history' ? [
                ...options[field]
            ] : options[field];
        }
        /** @type {string} */ let field;
        // Set non-path related properties.
        for(field in options)// @ts-expect-error: fine to set other things.
        if (!$ebdb906eb43ac433$var$order.includes(field)) // @ts-expect-error: fine to set other things.
        this[field] = options[field];
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === 'string' ? (0, $6c0e34cf2f183349$export$500c965389abde9c).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $ebdb906eb43ac433$var$assertNonEmpty(basename, 'basename');
        $ebdb906eb43ac433$var$assertPart(basename, 'basename');
        this.path = (0, $6c0e34cf2f183349$export$500c965389abde9c).join(this.dirname || '', basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $6c0e34cf2f183349$export$500c965389abde9c).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $ebdb906eb43ac433$var$assertPath(this.basename, 'dirname');
        this.path = (0, $6c0e34cf2f183349$export$500c965389abde9c).join(dirname || '', this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === 'string' ? (0, $6c0e34cf2f183349$export$500c965389abde9c).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $ebdb906eb43ac433$var$assertPart(extname, 'extname');
        $ebdb906eb43ac433$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $6c0e34cf2f183349$export$500c965389abde9c).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $ea6379392cbaeecd$export$8304a22d431f958)(path)) path = (0, $028cf007d1b71fb0$export$9b2b676c902de799)(path);
        $ebdb906eb43ac433$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === 'string' ? (0, $6c0e34cf2f183349$export$500c965389abde9c).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $ebdb906eb43ac433$var$assertNonEmpty(stem, 'stem');
        $ebdb906eb43ac433$var$assertPart(stem, 'stem');
        this.path = (0, $6c0e34cf2f183349$export$500c965389abde9c).join(this.dirname || '', stem + (this.extname || ''));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $84ecfcc79391545c$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return '';
        if (typeof this.value === 'string') return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertPart(part, name) {
    if (part && part.includes((0, $6c0e34cf2f183349$export$500c965389abde9c).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $6c0e34cf2f183349$export$500c965389abde9c).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $ebdb906eb43ac433$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}


const $de08c1c35a47a6e1$export$b7de1db558410812 = /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const value = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    // Not needed for us in `unified`: we only call this on the `copy`
    // function,
    // and we don't need to add its fields (`length`, `name`)
    // over.
    // See also: GH-246.
    // const names = Object.getOwnPropertyNames(value)
    //
    // for (const p of names) {
    //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
    //   if (descriptor) Object.defineProperty(apply, p, descriptor)
    // }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $cd17945441716b11$var$own = {}.hasOwnProperty;
class $cd17945441716b11$export$c30cd198d731db19 extends (0, $de08c1c35a47a6e1$export$b7de1db558410812) {
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super('copy');
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $c333b7763c7c24e2$export$91b56f5ca106aa43)();
    }
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $cd17945441716b11$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $cd17945441716b11$var$assertUnfrozen('data', this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $cd17945441716b11$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $cd17945441716b11$var$assertUnfrozen('data', this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === 'function') this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $cd17945441716b11$var$vfile(file);
        const parser = this.parser || this.Parser;
        $cd17945441716b11$var$assertParser('parse', parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $cd17945441716b11$var$assertParser('process', this.parser || this.Parser);
        $cd17945441716b11$var$assertCompiler('process', this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $cd17945441716b11$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($cd17945441716b11$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $cd17945441716b11$var$assertParser('processSync', this.parser || this.Parser);
        $cd17945441716b11$var$assertCompiler('processSync', this.compiler || this.Compiler);
        this.process(file, realDone);
        $cd17945441716b11$var$assertDone('processSync', 'process', complete);
        (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $ed6a7f7e034afcf2$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $cd17945441716b11$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === 'function') {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(typeof file !== 'function', "`file` can\u2019t be a `done` anymore, we checked");
            const realFile = $cd17945441716b11$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $cd17945441716b11$var$assertDone('runSync', 'run', complete);
        (0, $b33bccef26feab59$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $ed6a7f7e034afcf2$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $cd17945441716b11$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $cd17945441716b11$var$assertCompiler('stringify', compiler);
        $cd17945441716b11$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $cd17945441716b11$var$assertUnfrozen('use', this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, parameters);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value, []);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!('plugins' in result) && !('settings' in result)) throw new Error('Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither');
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $fd11a02fceb57d58$export$2e2bcd8739ae039)(currentPrimary) && (0, $fd11a02fceb57d58$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
}
const $cd17945441716b11$export$7cc1b2fe10c52bb = new $cd17945441716b11$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $cd17945441716b11$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $cd17945441716b11$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $cd17945441716b11$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $cd17945441716b11$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $fd11a02fceb57d58$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $cd17945441716b11$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $cd17945441716b11$var$vfile(value) {
    return $cd17945441716b11$var$looksLikeAVFile(value) ? value : new (0, $ebdb906eb43ac433$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $cd17945441716b11$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $cd17945441716b11$var$looksLikeAValue(value) {
    return typeof value === 'string' || $cd17945441716b11$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $cd17945441716b11$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}




const $ead699faf34263db$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $ead699faf34263db$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $ead699faf34263db$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $ead699faf34263db$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $ead699faf34263db$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'className',
        id: 'remove-classname'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $ead699faf34263db$export$7460c8b7e4ce9582(options) {
    const processor = $ead699faf34263db$var$createProcessor(options);
    const file = $ead699faf34263db$var$createFile(options);
    return $ead699faf34263db$var$post(processor.runSync(processor.parse(file), file), options);
}
async function $ead699faf34263db$export$445edbd7f2c65a8c(options) {
    const processor = $ead699faf34263db$var$createProcessor(options);
    const file = $ead699faf34263db$var$createFile(options);
    const tree = await processor.run(processor.parse(file), file);
    return $ead699faf34263db$var$post(tree, options);
}
function $ead699faf34263db$export$915021c692d253a2(options) {
    const processor = $ead699faf34263db$var$createProcessor(options);
    const [error, setError] = (0, $acw62.useState)(/** @type {Error | undefined} */ undefined);
    const [tree, setTree] = (0, $acw62.useState)(/** @type {Root | undefined} */ undefined);
    (0, $acw62.useEffect)(function() {
        let cancelled = false;
        const file = $ead699faf34263db$var$createFile(options);
        processor.run(processor.parse(file), file, function(error, tree) {
            if (!cancelled) {
                setError(error);
                setTree(tree);
            }
        });
        /**
       * @returns {undefined}
       *   Nothing.
       */ return function() {
            cancelled = true;
        };
    }, [
        options.children,
        options.rehypePlugins,
        options.remarkPlugins,
        options.remarkRehypeOptions
    ]);
    if (error) throw error;
    return tree ? $ead699faf34263db$var$post(tree, options) : options.fallback;
}
/**
 * Set up the `unified` processor.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {Processor<MdastRoot, MdastRoot, Root, undefined, undefined>}
 *   Result.
 */ function $ead699faf34263db$var$createProcessor(options) {
    const rehypePlugins = options.rehypePlugins || $ead699faf34263db$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $ead699faf34263db$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$ead699faf34263db$var$emptyRemarkRehypeOptions
    } : $ead699faf34263db$var$emptyRemarkRehypeOptions;
    const processor = (0, $cd17945441716b11$export$7cc1b2fe10c52bb)().use((0, $2aab0d1dd6b1383c$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $f21eb379270d044c$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    return processor;
}
/**
 * Set up the virtual file.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {VFile}
 *   Result.
 */ function $ead699faf34263db$var$createFile(options) {
    const children = options.children || '';
    const file = new (0, $ebdb906eb43ac433$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $b33bccef26feab59$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    return file;
}
/**
 * Process the result from unified some more.
 *
 * @param {Nodes} tree
 *   Tree.
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {ReactElement}
 *   React element.
 */ function $ead699faf34263db$var$post(tree, options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $ead699faf34263db$export$ca5e94754123e2f3;
    for (const deprecation of $ead699faf34263db$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $b33bccef26feab59$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $ead699faf34263db$var$changelog + '#' + deprecation.id + '> for more info)');
    if (allowedElements && disallowedElements) (0, $b33bccef26feab59$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    (0, $4ad53e9051b55a53$export$bf638b60ea8b89b7)(tree, transform);
    return (0, $d43ea869f7285ee3$export$59c10052b2dee561)(tree, {
        Fragment: $7b02d682eb115277$exports.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $7b02d682eb115277$exports.jsx,
        jsxs: $7b02d682eb115277$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $4819636f8d2ef87b$export$de3e062aedff083a)if (Object.hasOwn((0, $4819636f8d2ef87b$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $4819636f8d2ef87b$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $ead699faf34263db$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $ead699faf34263db$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}







var $acw62 = parcelRequire("acw62");



const $d2de9233531d2f09$export$ac4e8b8ca2b79f39 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "enable-background": "new 0 0 24 24",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        style: {
            width: 20,
            height: 20,
            fill: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M0,0h24v24H0V0z",
                    fill: "none"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
                })
            ]
        })
    });
};



parcelRequire("acw62");

parcelRequire("acw62");
const $e6b11845b52b2e17$export$5404b1d39162d870 = (props)=>{
    const { text: text } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingTop: 8,
            paddingBottom: 4,
            fontWeight: "bold"
        },
        children: text
    });
};




var $acw62 = parcelRequire("acw62");


const $0f79d22936bfac5d$export$88e71b651fee3a0 = (props)=>{
    const { settingId: settingId, options: options } = props;
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const selectedId = settings[settingId];
    const [hoveredId, setHoveredId] = (0, $acw62.useState)(undefined);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingBottom: 4,
            borderBottom: `0.5px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`
        },
        children: options.map(({ id: id, name: name })=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    borderRadius: 4,
                    padding: 4,
                    paddingLeft: 12,
                    paddingRight: 12,
                    cursor: "pointer",
                    backgroundColor: selectedId === id ? "#e0e0e0" : hoveredId === id ? "#f0f0f0" : "transparent"
                },
                onClick: ()=>{
                    setSetting(settingId, id);
                },
                onMouseEnter: ()=>setHoveredId(id),
                onMouseLeave: ()=>setHoveredId(undefined),
                children: name
            });
        })
    });
};


const $ab540e91b6a0c911$export$805dc0bee9369f09 = (props)=>{
    const { setting: setting } = props;
    switch(setting){
        case "psalmCycle":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Psalm cycle"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "psalmCycle",
                        options: [
                            {
                                id: "bcp",
                                name: "1662 BCP 30-day cycle"
                            },
                            {
                                id: "cw",
                                name: "Common Worship cycle"
                            },
                            {
                                id: "acna",
                                name: "2019 BCP 60-day cycle"
                            }
                        ]
                    })
                ]
            });
        case "lectionary":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Lectionary"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "mattinsReadings",
                        options: [
                            {
                                id: "1961-morning",
                                name: "1961 English Lectionary"
                            },
                            {
                                id: "1922-morning",
                                name: "1922 English Lectionary"
                            },
                            {
                                id: "1871-morning",
                                name: "1871 English Lectionary"
                            },
                            {
                                id: "1662-morning",
                                name: "1662 English Lectionary"
                            },
                            {
                                id: "cw-morning",
                                name: "Common Worship Daily Prayer Lectionary"
                            },
                            {
                                id: "acna-morning-long",
                                name: "2019 ACNA Lectionary"
                            },
                            {
                                id: "acna-morning-short",
                                name: "2019 ACNA Lectionary (Short Readings)"
                            }
                        ]
                    })
                ]
            });
        case "secondReadingToCompline":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Lesson at Compline"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "secondReadingToCompline",
                        options: [
                            {
                                id: "no",
                                name: "Jeremiah 14:9"
                            },
                            {
                                id: "yes",
                                name: "Transfer the Second Lesson appointed at Evensong"
                            }
                        ]
                    })
                ]
            });
        case "psalmsAtCompline":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Psalms at Compline"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "psalmsAtCompline",
                        options: [
                            {
                                id: "compline-short",
                                name: "Cycle through the Psalms of Compline every three days: 4 & 134; 31a; 91"
                            },
                            {
                                id: "compline",
                                name: "All the Psalms of Compline: 4, 31a, 91, 134"
                            },
                            {
                                id: "same as evensong",
                                name: "The same as appointed at Evensong"
                            }
                        ]
                    })
                ]
            });
        case "bibleTranslation":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Bible translation for Lessons"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "bibleTranslation",
                        options: [
                            {
                                id: "ESV",
                                name: "ESV - English Standard Version"
                            },
                            {
                                id: "NRSV",
                                name: "NRSV - New Revised Standard Version"
                            },
                            {
                                id: "KJV",
                                name: "KJV - King James Version"
                            },
                            {
                                id: "RSV",
                                name: "RSV - Revised Standard Version"
                            },
                            {
                                id: "NASB",
                                name: "NASB - New American Standard Bible"
                            }
                        ]
                    })
                ]
            });
        case "psalmsBold":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Bold type in Psalms and Canticles"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "psalmsBold",
                        options: [
                            {
                                id: "all",
                                name: "Every verse"
                            },
                            {
                                id: "alternate",
                                name: "Alternate verses"
                            },
                            {
                                id: "none",
                                name: "None"
                            }
                        ]
                    })
                ]
            });
        case "invitatoryAntiphons":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Antiphons for the Invitatory Psalm"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "invitatoryAntiphons",
                        options: [
                            {
                                id: "always",
                                name: "Always"
                            },
                            {
                                id: "seasons",
                                name: "Except in Ordinary Time"
                            },
                            {
                                id: "never",
                                name: "Never"
                            }
                        ]
                    })
                ]
            });
        case "antiphonTones":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Tone for Antiphons"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "antiphonTones",
                        options: [
                            {
                                id: "solemn",
                                name: "Solemn tone"
                            },
                            {
                                id: "standard",
                                name: "Same tone as Psalm"
                            }
                        ]
                    })
                ]
            });
        case "teDeum":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Te Deum at Mattins"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "teDeum",
                        options: [
                            {
                                id: "always",
                                name: "Every day"
                            },
                            {
                                id: "feasts",
                                name: "Only on Feast Days"
                            },
                            {
                                id: "never",
                                name: "Never"
                            }
                        ]
                    })
                ]
            });
        case "salutation":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "The Salutation"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "salutation",
                        options: [
                            {
                                id: "o lord hear our prayer",
                                name: 'For a lay Officiant: "O Lord hear our prayer. / And let our cry come unto thee."'
                            },
                            {
                                id: "the lord be with you",
                                name: 'For a Priest or Deacon: "The Lord be with you. / And with thy spirit."'
                            }
                        ]
                    })
                ]
            });
        case "monarch":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Monarchy?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "monarch",
                        options: [
                            {
                                id: "yes",
                                name: '"O Lord save the King."'
                            },
                            {
                                id: "no",
                                name: '"O Lord save the State."'
                            }
                        ]
                    })
                ]
            });
        case "letUsBlessMattinsAndEvensong":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: '"Let us bless the Lord..." at Mattins and Evensong'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "letUsBlessMattinsAndEvensong",
                        options: [
                            {
                                id: "after collects",
                                name: "Immediately after the Collects"
                            },
                            {
                                id: "before grace",
                                name: "Immediately before the Grace"
                            },
                            {
                                id: "omit",
                                name: "Omit"
                            }
                        ]
                    })
                ]
            });
        case "hymnPosition":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Position of the Office Hymn"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "hymnPosition",
                        options: [
                            {
                                id: "anthem",
                                name: "Before the Grace (1662 BCP Anthem position)"
                            },
                            {
                                id: "before psalms",
                                name: "Before the Psalms"
                            },
                            {
                                id: "before canticle",
                                name: "Before the Gospel Canticle"
                            },
                            {
                                id: "omit",
                                name: "Omit the Office Hymn"
                            }
                        ]
                    })
                ]
            });
        case "absolution":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Absolution at Mattins and Evensong"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "absolution",
                        options: [
                            {
                                id: "pardon and peace collect",
                                name: "Collect for Trinity 21"
                            },
                            {
                                id: "bcp absolution",
                                name: "1662 Absolution by a priest"
                            },
                            {
                                id: "omit",
                                name: "Omit"
                            }
                        ]
                    })
                ]
            });
        case "lordsPrayerAfterConfession":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Lord's Prayer after the Confession"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "lordsPrayerAfterConfession",
                        options: [
                            {
                                id: "omit",
                                name: "Omit"
                            },
                            {
                                id: "said",
                                name: "Said"
                            },
                            {
                                id: "sung",
                                name: "Sung"
                            }
                        ]
                    })
                ]
            });
        case "lordsPrayer":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Text of the Lord's Prayer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "lordsPrayer",
                        options: [
                            {
                                id: "standard",
                                name: "Standard (Our Father who art...)"
                            },
                            {
                                id: "bcp",
                                name: "1662 text (Our Father which art...)"
                            }
                        ]
                    })
                ]
            });
        case "adventAndLentCollects":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Advent 1 and Ash Wednesday Collects throughout the season"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "adventAndLentCollects",
                        options: [
                            {
                                id: "repeat",
                                name: "Repeat every day after the Collect of the Day"
                            },
                            {
                                id: "dont repeat",
                                name: "Don't repeat"
                            }
                        ]
                    })
                ]
            });
        case "paschaNostrum":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Pascha Nostrum at Easter"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "paschaNostrum",
                        options: [
                            {
                                id: "octave",
                                name: "Pascha Nostrum replaces Venite throughout the octave of Easter"
                            },
                            {
                                id: "day",
                                name: "Pascha Nostrum replaces Venite on Easter Sunday only"
                            },
                            {
                                id: "no",
                                name: "Keep Venite throughout"
                            }
                        ]
                    })
                ]
            });
        case "canticleAntiphonsExperimental":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Debug"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "canticleAntiphonsExperimental",
                        options: [
                            {
                                id: "none",
                                name: "Off"
                            },
                            {
                                id: "sarum",
                                name: "On"
                            }
                        ]
                    })
                ]
            });
        case "canticleTonesExperimental":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Debug 2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "canticleTonesExperimental",
                        options: [
                            {
                                id: "simplified",
                                name: "Off"
                            },
                            {
                                id: "sarum",
                                name: "On"
                            }
                        ]
                    })
                ]
            });
        case "experimentalChantRendering":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6b11845b52b2e17$export$5404b1d39162d870), {
                        text: "Debug 3"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f79d22936bfac5d$export$88e71b651fee3a0), {
                        settingId: "experimentalChantRendering",
                        options: [
                            {
                                id: "off",
                                name: "Off"
                            },
                            {
                                id: "on",
                                name: "On"
                            }
                        ]
                    })
                ]
            });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
};




var $acw62 = parcelRequire("acw62");


const $bcf20e28db4a76dc$export$2b77a92f1a5ad772 = (props)=>{
    const { id: id, title: title, titleBarContent: titleBarContent, onSetModal: onSetModal, children: children } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    const { popoverId: popoverId, setPopoverId: setPopoverId } = (0, $cd93687958c8007e$export$542a6fd13ac93354)();
    (0, $acw62.useEffect)(()=>{
        const modal = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                zIndex: 100000
            },
            className: "modal",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flexGrow: 1,
                    maxWidth: (0, $b5d1360628cd70a0$export$397f5285b920487e),
                    boxSizing: "border-box",
                    display: popoverId === id ? "block" : "none",
                    padding: isSmallScreen ? 4 : 16,
                    paddingBottom: isSmallScreen ? 0 : 16
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        backgroundColor: "white",
                        border: `1px solid ${(0, $b5d1360628cd70a0$export$516f68680b50dca1)}`,
                        borderRadius: 8,
                        borderBottomLeftRadius: isSmallScreen ? 0 : 8,
                        borderBottomRightRadius: isSmallScreen ? 0 : 8,
                        borderBottom: isSmallScreen ? "none" : `1px solid ${0, $b5d1360628cd70a0$export$516f68680b50dca1}`,
                        boxShadow: `0 0 12px rgba(0, 0, 0, 0.4)`,
                        flexGrow: 1,
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                padding: 4,
                                paddingLeft: 12,
                                paddingRight: 4,
                                borderBottom: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`,
                                backgroundColor: (0, $b5d1360628cd70a0$export$ee522376d3ee75f2)
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        flexGrow: 1
                                    }
                                }),
                                titleBarContent,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        flexGrow: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "new-button",
                                    onClick: ()=>setPopoverId(undefined),
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                maxHeight: 415,
                                overflowY: "auto",
                                pointerEvents: "all"
                            },
                            children: children
                        })
                    ]
                })
            })
        });
        onSetModal(modal);
    }, [
        popoverId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
};


const $3ffe339e0803830b$export$e2457e1974c298c3 = (props)=>{
    const { settingsPanelId: settingsPanelId } = props;
    const [modalContent, setModalContent] = (0, $acw62.useState)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}));
    const { popoverId: popoverId, setPopoverId: setPopoverId } = (0, $cd93687958c8007e$export$542a6fd13ac93354)();
    const isOpen = popoverId === settingsPanelId;
    const [isHovered, setIsHovered] = (0, $acw62.useState)(false);
    const settingsContents = (()=>{
        switch(settingsPanelId){
            case "psalms":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "psalmCycle"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "psalmsBold"
                        })
                    ]
                });
            case "morning lessons":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "lectionary"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "bibleTranslation"
                        })
                    ]
                });
            case "evening lessons":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "lectionary"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "secondReadingToCompline"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "bibleTranslation"
                        })
                    ]
                });
            case "compline lesson":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                        setting: "secondReadingToCompline"
                    })
                });
            case "compline psalms":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "psalmsAtCompline"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "psalmsBold"
                        })
                    ]
                });
            case "invitatory":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "invitatoryAntiphons"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "antiphonTones"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "paschaNostrum"
                        })
                    ]
                });
            case "te deum":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "teDeum"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "psalmsBold"
                        })
                    ]
                });
            case "gospel canticles":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                        setting: "psalmsBold"
                    })
                });
            case "salutation":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                        setting: "salutation"
                    })
                });
            case "suffrages":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                        setting: "monarch"
                    })
                });
            case "let us bless":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                        setting: "letUsBlessMattinsAndEvensong"
                    })
                });
            case "office hymn":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                        setting: "hymnPosition"
                    })
                });
            case "confession":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "absolution"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                            setting: "lordsPrayerAfterConfession"
                        })
                    ]
                });
            case "lords prayer":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                        setting: "lordsPrayer"
                    })
                });
            case "collect":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                        setting: "adventAndLentCollects"
                    })
                });
        }
    })();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: 24,
                    height: 24,
                    pointerEvents: isOpen ? "none" : "all",
                    opacity: isOpen ? 0.5 : 1,
                    cursor: "pointer",
                    borderRadius: 4,
                    backgroundColor: isHovered ? "#e9e9e9" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                onClick: ()=>{
                    setPopoverId(settingsPanelId);
                },
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2de9233531d2f09$export$ac4e8b8ca2b79f39), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcf20e28db4a76dc$export$2b77a92f1a5ad772), {
                id: settingsPanelId,
                title: "Settings",
                onSetModal: setModalContent,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        paddingLeft: 8,
                        paddingRight: 8,
                        paddingBottom: 24
                    },
                    children: settingsContents
                })
            }),
            modalContent
        ]
    });
};


const $18d48c4e99474336$export$c95cd4f09a6c19a2 = (props)=>{
    const { content: content, settingsPanelId: settingsPanelId } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        onlySides: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            },
            className: "rubric",
            "data-content": content,
            children: [
                settingsPanelId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        width: 24,
                        height: 24
                    }
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        paddingLeft: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                        paddingRight: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                        color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                        fontSize: isSmallScreen ? (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57) * 0.9 : (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57),
                        textAlign: "center",
                        flexGrow: 1,
                        paddingTop: 8,
                        paddingBottom: 8
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ead699faf34263db$export$7460c8b7e4ce9582), {
                        children: ("\u2761__" + content).replace(/\\n/g, "  \n").replace(/_/g, "\u00a0")
                    })
                }),
                settingsPanelId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ffe339e0803830b$export$e2457e1974c298c3), {
                    settingsPanelId: settingsPanelId
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
            ]
        })
    });
};



parcelRequire("acw62");
const $0d7fa6b19148d6ce$export$d7a54cba636a8cd6 = (props)=>{
    const { big: big } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            height: big ? 64 : 32,
            display: "flex",
            alignItems: "center"
        },
        className: big ? "big-spacer" : "spacer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                flexGrow: 1
            }
        })
    });
};




const $6610792c2b4ce802$export$28c156c102c4a912 = {
    "1": [
        {
            fromVerse: 1,
            tone: "1a.1"
        }
    ],
    "2": [
        {
            fromVerse: 1,
            tone: "3a.4"
        }
    ],
    "3": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "4": [
        {
            fromVerse: 1,
            tone: "8.1"
        }
    ],
    "5": [
        {
            fromVerse: 1,
            tone: "1a.4"
        }
    ],
    "6": [
        {
            fromVerse: 1,
            tone: "8.5"
        }
    ],
    "7": [
        {
            fromVerse: 1,
            tone: "1a.1"
        }
    ],
    "8": [
        {
            fromVerse: 1,
            tone: "5.2"
        }
    ],
    "9": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "10": [
        {
            fromVerse: 1,
            tone: "8.2"
        }
    ],
    "11": [
        {
            fromVerse: 1,
            tone: "5.2"
        }
    ],
    "12": [
        {
            fromVerse: 1,
            tone: "4.9"
        }
    ],
    "13": [
        {
            fromVerse: 1,
            tone: "3a.4"
        }
    ],
    "14": [
        {
            fromVerse: 1,
            tone: "7.4"
        }
    ],
    "15": [
        {
            fromVerse: 1,
            tone: "3a.5"
        }
    ],
    "16": [
        {
            fromVerse: 1,
            tone: "8.5"
        }
    ],
    "17": [
        {
            fromVerse: 1,
            tone: "7.6"
        }
    ],
    "18": [
        {
            fromVerse: 1,
            tone: "1b.2"
        },
        {
            fromVerse: 21,
            tone: "2.1"
        },
        {
            fromVerse: 36,
            tone: "8.6"
        }
    ],
    "19": [
        {
            fromVerse: 1,
            tone: "4.5"
        }
    ],
    "20": [
        {
            fromVerse: 1,
            tone: "3a.1"
        }
    ],
    "21": [
        {
            fromVerse: 1,
            tone: "8.2"
        }
    ],
    "22": [
        {
            fromVerse: 1,
            tone: "2.1"
        },
        {
            fromVerse: 20,
            tone: "Tonus Peregrinus A"
        }
    ],
    "23": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "24": [
        {
            fromVerse: 1,
            tone: "7.5"
        }
    ],
    "25": [
        {
            fromVerse: 1,
            tone: "1a.9"
        }
    ],
    "26": [
        {
            fromVerse: 1,
            tone: "6b"
        }
    ],
    "27": [
        {
            fromVerse: 1,
            tone: "7.3"
        }
    ],
    "28": [
        {
            fromVerse: 1,
            tone: "4.10"
        }
    ],
    "29": [
        {
            fromVerse: 1,
            tone: "5.3"
        }
    ],
    "30": [
        {
            fromVerse: 1,
            tone: "1b.10"
        }
    ],
    "31": [
        {
            fromVerse: 1,
            tone: "8.1"
        },
        {
            fromVerse: 17,
            tone: "7.6"
        }
    ],
    "32": [
        {
            fromVerse: 1,
            tone: "1a.8"
        }
    ],
    "33": [
        {
            fromVerse: 1,
            tone: "3a.5"
        }
    ],
    "34": [
        {
            fromVerse: 1,
            tone: "7.2"
        }
    ],
    "35": [
        {
            fromVerse: 1,
            tone: "1a.1"
        },
        {
            fromVerse: 15,
            tone: "3a.6"
        }
    ],
    "36": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "37": [
        {
            fromVerse: 1,
            tone: "1b.4"
        },
        {
            fromVerse: 12,
            tone: "1a.5"
        },
        {
            fromVerse: 25,
            tone: "7.5"
        }
    ],
    "38": [
        {
            fromVerse: 1,
            tone: "4.8"
        }
    ],
    "39": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "40": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "41": [
        {
            fromVerse: 1,
            tone: "3a.2"
        }
    ],
    "42": [
        {
            fromVerse: 1,
            tone: "5.1"
        }
    ],
    "43": [
        {
            fromVerse: 1,
            tone: "5.1"
        }
    ],
    "44": [
        {
            fromVerse: 1,
            tone: "4.7"
        }
    ],
    "45": [
        {
            fromVerse: 1,
            tone: "8.1"
        }
    ],
    "46": [
        {
            fromVerse: 1,
            tone: "5.3"
        }
    ],
    "47": [
        {
            fromVerse: 1,
            tone: "7.6"
        }
    ],
    "48": [
        {
            fromVerse: 1,
            tone: "1a.10"
        }
    ],
    "49": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "50": [
        {
            fromVerse: 1,
            tone: "3a.2"
        }
    ],
    "51": [
        {
            fromVerse: 1,
            tone: "4.4"
        }
    ],
    "52": [
        {
            fromVerse: 1,
            tone: "7.7"
        }
    ],
    "53": [
        {
            fromVerse: 1,
            tone: "3a.5"
        }
    ],
    "54": [
        {
            fromVerse: 1,
            tone: "4.7"
        }
    ],
    "55": [
        {
            fromVerse: 1,
            tone: "1a.8"
        }
    ],
    "56": [
        {
            fromVerse: 1,
            tone: "1b.9"
        }
    ],
    "57": [
        {
            fromVerse: 1,
            tone: "8.6"
        }
    ],
    "58": [
        {
            fromVerse: 1,
            tone: "7.4"
        }
    ],
    "59": [
        {
            fromVerse: 1,
            tone: "4.7"
        }
    ],
    "60": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "61": [
        {
            fromVerse: 1,
            tone: "8.1"
        }
    ],
    "62": [
        {
            fromVerse: 1,
            tone: "4.10"
        }
    ],
    "63": [
        {
            fromVerse: 1,
            tone: "1a.10"
        }
    ],
    "64": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "65": [
        {
            fromVerse: 1,
            tone: "7.5"
        }
    ],
    "66": [
        {
            fromVerse: 1,
            tone: "1b.3"
        }
    ],
    "67": [
        {
            fromVerse: 1,
            tone: "8.3"
        }
    ],
    "68": [
        {
            fromVerse: 1,
            tone: "8.1"
        },
        {
            fromVerse: 19,
            tone: "7.4"
        }
    ],
    "69": [
        {
            fromVerse: 1,
            tone: "2.1"
        },
        {
            fromVerse: 19,
            tone: "1a.5"
        }
    ],
    "70": [
        {
            fromVerse: 1,
            tone: "4.8"
        }
    ],
    "71": [
        {
            fromVerse: 1,
            tone: "4.9"
        }
    ],
    "72": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "73": [
        {
            fromVerse: 1,
            tone: "7.5"
        },
        {
            fromVerse: 14,
            tone: "1b.8"
        }
    ],
    "74": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "75": [
        {
            fromVerse: 1,
            tone: "1a.3"
        }
    ],
    "76": [
        {
            fromVerse: 1,
            tone: "8.2"
        }
    ],
    "77": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "78": [
        {
            fromVerse: 1,
            tone: "1b.4"
        },
        {
            fromVerse: 19,
            tone: "4.3"
        },
        {
            fromVerse: 41,
            tone: "2.2"
        },
        {
            fromVerse: 57,
            tone: "Tonus Peregrinus A"
        }
    ],
    "79": [
        {
            fromVerse: 1,
            tone: "7.1"
        }
    ],
    "80": [
        {
            fromVerse: 1,
            tone: "4.4"
        }
    ],
    "81": [
        {
            fromVerse: 1,
            tone: "3a.6"
        }
    ],
    "82": [
        {
            fromVerse: 1,
            tone: "8.2"
        }
    ],
    "83": [
        {
            fromVerse: 1,
            tone: "7.1"
        }
    ],
    "84": [
        {
            fromVerse: 1,
            tone: "3a.1"
        }
    ],
    "85": [
        {
            fromVerse: 1,
            tone: "4.5"
        }
    ],
    "86": [
        {
            fromVerse: 1,
            tone: "1b.4"
        }
    ],
    "87": [
        {
            fromVerse: 1,
            tone: "7.2"
        }
    ],
    "88": [
        {
            fromVerse: 1,
            tone: "4.7"
        }
    ],
    "89": [
        {
            fromVerse: 1,
            tone: "1b.1"
        },
        {
            fromVerse: 19,
            tone: "5.3"
        },
        {
            fromVerse: 31,
            tone: "4.12"
        }
    ],
    "90": [
        {
            fromVerse: 1,
            tone: "1a.2"
        }
    ],
    "91": [
        {
            fromVerse: 1,
            tone: "8.1"
        }
    ],
    "92": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "93": [
        {
            fromVerse: 1,
            tone: "5.3"
        }
    ],
    "94": [
        {
            fromVerse: 1,
            tone: "4.4"
        }
    ],
    "95": [
        {
            fromVerse: 1,
            tone: "3a.1"
        }
    ],
    "96": [
        {
            fromVerse: 1,
            tone: "8.1"
        }
    ],
    "97": [
        {
            fromVerse: 1,
            tone: "5.2"
        }
    ],
    "98": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "99": [
        {
            fromVerse: 1,
            tone: "4.4"
        }
    ],
    "100": [
        {
            fromVerse: 1,
            tone: "8.1"
        }
    ],
    "101": [
        {
            fromVerse: 1,
            tone: "7.5"
        }
    ],
    "102": [
        {
            fromVerse: 1,
            tone: "1a.3"
        },
        {
            fromVerse: 15,
            tone: "7.1"
        }
    ],
    "103": [
        {
            fromVerse: 1,
            tone: "5.3"
        }
    ],
    "104": [
        {
            fromVerse: 1,
            tone: "3a.1"
        },
        {
            fromVerse: 24,
            tone: "4.7"
        }
    ],
    "105": [
        {
            fromVerse: 1,
            tone: "6b"
        },
        {
            fromVerse: 23,
            tone: "1a.7"
        }
    ],
    "106": [
        {
            fromVerse: 1,
            tone: "6a"
        },
        {
            fromVerse: 12,
            tone: "1a.8"
        }
    ],
    "107": [
        {
            fromVerse: 1,
            tone: "8.1"
        },
        {
            fromVerse: 23,
            tone: "1a.5"
        }
    ],
    "108": [
        {
            fromVerse: 1,
            tone: "8.2"
        }
    ],
    "109": [
        {
            fromVerse: 1,
            tone: "4.5"
        },
        {
            fromVerse: 12,
            tone: "4.7"
        }
    ],
    "110": [
        {
            fromVerse: 1,
            tone: "3a.2"
        }
    ],
    "111": [
        {
            fromVerse: 1,
            tone: "4.7"
        }
    ],
    "112": [
        {
            fromVerse: 1,
            tone: "7.5"
        }
    ],
    "113": [
        {
            fromVerse: 1,
            tone: "5.2"
        }
    ],
    "114": [
        {
            fromVerse: 1,
            tone: "Tonus Peregrinus A"
        }
    ],
    "115": [
        {
            fromVerse: 1,
            tone: "Tonus Peregrinus A"
        }
    ],
    "116": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "117": [
        {
            fromVerse: 1,
            tone: "Tonus Peregrinus A"
        }
    ],
    "118": [
        {
            fromVerse: 1,
            tone: "1a.1"
        },
        {
            fromVerse: 15,
            tone: "Tonus Peregrinus A"
        }
    ],
    "119": [
        {
            fromVerse: 1,
            tone: "3a.4"
        },
        {
            fromVerse: 25,
            tone: "1a.12"
        },
        {
            fromVerse: 49,
            tone: "4.7"
        },
        {
            fromVerse: 73,
            tone: "1b.10"
        },
        {
            fromVerse: 89,
            tone: "2.1"
        },
        {
            fromVerse: 105,
            tone: "7.3"
        },
        {
            fromVerse: 129,
            tone: "5.1"
        },
        {
            fromVerse: 153,
            tone: "3a.4"
        }
    ],
    "120": [
        {
            fromVerse: 1,
            tone: "1a.8"
        }
    ],
    "121": [
        {
            fromVerse: 1,
            tone: "1b.4"
        }
    ],
    "122": [
        {
            fromVerse: 1,
            tone: "4.7"
        }
    ],
    "123": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "124": [
        {
            fromVerse: 1,
            tone: "7.7"
        }
    ],
    "125": [
        {
            fromVerse: 1,
            tone: "8.2"
        }
    ],
    "126": [
        {
            fromVerse: 1,
            tone: "1a.2"
        }
    ],
    "127": [
        {
            fromVerse: 1,
            tone: "2.1"
        }
    ],
    "128": [
        {
            fromVerse: 1,
            tone: "3a.5"
        }
    ],
    "129": [
        {
            fromVerse: 1,
            tone: "4.4"
        }
    ],
    "130": [
        {
            fromVerse: 1,
            tone: "4.7"
        }
    ],
    "131": [
        {
            fromVerse: 1,
            tone: "8.2"
        }
    ],
    "132": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "133": [
        {
            fromVerse: 1,
            tone: "8.3"
        }
    ],
    "134": [
        {
            fromVerse: 1,
            tone: "8.1"
        }
    ],
    "135": [
        {
            fromVerse: 1,
            tone: "7.2"
        }
    ],
    "136": [
        {
            fromVerse: 1,
            tone: "3a.6"
        },
        {
            fromVerse: 15,
            tone: "1a.8"
        }
    ],
    "137": [
        {
            fromVerse: 1,
            tone: "1a.9"
        }
    ],
    "138": [
        {
            fromVerse: 1,
            tone: "5.2"
        }
    ],
    "139": [
        {
            fromVerse: 1,
            tone: "1b.5"
        }
    ],
    "140": [
        {
            fromVerse: 1,
            tone: "3a.5"
        }
    ],
    "141": [
        {
            fromVerse: 1,
            tone: "8.6"
        }
    ],
    "142": [
        {
            fromVerse: 1,
            tone: "6b"
        }
    ],
    "143": [
        {
            fromVerse: 1,
            tone: "7.1"
        }
    ],
    "144": [
        {
            fromVerse: 1,
            tone: "1b.2"
        }
    ],
    "145": [
        {
            fromVerse: 1,
            tone: "5.1"
        }
    ],
    "146": [
        {
            fromVerse: 1,
            tone: "4.7"
        }
    ],
    "147": [
        {
            fromVerse: 1,
            tone: "8.1"
        }
    ],
    "148": [
        {
            fromVerse: 1,
            tone: "7.2"
        }
    ],
    "149": [
        {
            fromVerse: 1,
            tone: "6a"
        }
    ],
    "150": [
        {
            fromVerse: 1,
            tone: "Tonus Peregrinus A"
        }
    ]
};




var $acw62 = parcelRequire("acw62");







const $a6ebc2b5175d02b7$export$b552e0270138ce1d = (props)=>{
    const { sectionRef: sectionRef, pointedPsalmSection: pointedPsalmSection, title: title, tones: tones, exportLines: exportLines } = props;
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const [modal, setModal] = (0, $acw62.useState)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}));
    const { tweaks: tweaks, setTweak: setTweak } = (0, $b0ef04497ab55347$export$9d593b1761d4031)();
    const selectedTone = tweaks[(0, $8da148c2c45b952c$export$db824001adbaa732)(sectionRef)] ?? tones[0];
    const id = sectionRef.number + (sectionRef.type === "section" ? `-${sectionRef.firstVerse}-${sectionRef.lastVerse}` : "");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {},
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $982dab2795189e62$export$45a8b3c92b66d3be), {
                id: id,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2d213bd4c46a128$export$1246c4e68efb74f5), {
                        id: id,
                        title: title,
                        player: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d785bb9b161f2130$export$397fd5de0a6e6acd), {
                            tones: tones,
                            id: sectionRef.type === "full" ? `${sectionRef.number}` : `${sectionRef.number}:${sectionRef.firstVerse}-${sectionRef.lastVerse}`,
                            onSetModal: (id, element)=>setModal(element),
                            selectedTone: selectedTone,
                            onSetSelectedTone: (tone)=>{
                                setTweak((0, $8da148c2c45b952c$export$db824001adbaa732)(sectionRef), tone);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                        pointedText: pointedPsalmSection,
                        boldMode: settings.psalmsBold,
                        dropCap: true,
                        exportLines: exportLines,
                        tone: selectedTone
                    })
                ]
            }),
            modal
        ]
    });
};



const $8f9a5c5a44aa3093$export$b4e679dc0df20af5 = (props)=>{
    const { psalmRef: psalmRef, excludeGloriaPatri: excludeGloriaPatri, exportLines: exportLines } = props;
    const toneRanges = (0, $6610792c2b4ce802$export$28c156c102c4a912)[psalmRef.number];
    const { tweaks: tweaks } = (0, $b0ef04497ab55347$export$9d593b1761d4031)();
    const sections = (0, $acw62.useMemo)(()=>{
        const psalmLength = (0, $7f98b4308afe4768$export$adc377d3f4f7a592).find((datum)=>datum.id === `psalm${psalmRef.number}`)?.lines.length ?? 1000;
        const sectionRefs = toneRanges.length === 1 ? [
            psalmRef
        ] : toneRanges.map((toneRange, toneRangeIndex)=>{
            return {
                type: "section",
                number: psalmRef.number,
                firstVerse: psalmRef.type === "section" ? Math.max(psalmRef.firstVerse, toneRange.fromVerse) : toneRange.fromVerse,
                lastVerse: psalmRef.type === "section" ? Math.min(psalmRef.lastVerse, (toneRanges[toneRangeIndex + 1]?.fromVerse ?? psalmRef.lastVerse + 1) - 1) : (toneRanges[toneRangeIndex + 1]?.fromVerse ?? psalmLength + 1) - 1
            };
        });
        let visibleParts = 0;
        const sectionVisibility = sectionRefs.map((sectionRef)=>{
            return !(sectionRef.type === "section" && sectionRef.lastVerse - sectionRef.firstVerse <= 0);
        });
        return sectionRefs.map((sectionRef, sectionIndex)=>{
            if (sectionRef.type === "section" && sectionRef.lastVerse - sectionRef.firstVerse <= 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
            visibleParts++;
            try {
                const pointedPsalmSection = (0, $8da148c2c45b952c$export$b4b9f8f66b7dc49d)(sectionRef, tweaks[(0, $8da148c2c45b952c$export$db824001adbaa732)(sectionRef)] ?? toneRanges[sectionIndex].tone, !(sectionVisibility.slice(sectionIndex + 1).indexOf(true) >= 0) && !excludeGloriaPatri);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6ebc2b5175d02b7$export$b552e0270138ce1d), {
                    sectionRef: sectionRef,
                    pointedPsalmSection: pointedPsalmSection,
                    title: visibleParts > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Ps",
                            " ",
                            psalmRef.type === "full" ? `${psalmRef.number}` : `${psalmRef.number}:${psalmRef.firstVerse}-${psalmRef.lastVerse}`,
                            " ",
                            "cont'd"
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Psalm",
                            " ",
                            psalmRef.type === "full" ? `${psalmRef.number}` : `${psalmRef.number}:${psalmRef.firstVerse}-${psalmRef.lastVerse}`
                        ]
                    }),
                    tones: [
                        toneRanges[sectionIndex].tone,
                        (0, $8da148c2c45b952c$export$956628726129226c)(toneRanges[sectionIndex].tone)
                    ],
                    exportLines: exportLines
                });
            } catch (error) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        background: "#db281b",
                        color: "white",
                        padding: 16
                    },
                    children: error.message
                });
            }
        });
    }, [
        tweaks
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            psalmRef.number === 95 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "It may be appropriate to omit Psalm 95 here as it is used as the Invitatory Psalm at Mattins."
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            sections,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {})
        ]
    });
};




var $acw62 = parcelRequire("acw62");





const $074faffa041224b7$var$w = window;
var $074faffa041224b7$var$AudioContext = $074faffa041224b7$var$w.AudioContext || // Default
$074faffa041224b7$var$w.webkitAudioContext; // Safari and old versions of Chrome
const $074faffa041224b7$var$NOTE_LENGTH = 0.5;
let $074faffa041224b7$var$playingId = 0;
const $074faffa041224b7$var$playTone = (ac, clef, clefOffset, score, onFinished, onSetHighlightCount, transposedBy, playingIdRef)=>{
    const offset = clef === "c" ? 9 - clefOffset : 5 - clefOffset;
    $074faffa041224b7$var$playingId++;
    const thisPlayingId = $074faffa041224b7$var$playingId;
    let t = 0.5;
    const flute = new (0, $0d19688bebdb26f8$export$508265175ec7f40e)(new $074faffa041224b7$var$AudioContext(), {
        instrument: "flute"
    });
    let highlightCount = 0;
    const addHighlight = (noteIndex)=>{
        setTimeout(()=>{
            if ((playingIdRef.current ?? 9999) <= thisPlayingId) {
                highlightCount++;
                onSetHighlightCount(highlightCount);
            } else onSetHighlightCount(0);
        }, t * 1000);
    };
    const scheduleNote = (note, scheduleTime, long)=>{
        setTimeout(()=>{
            if ((playingIdRef.current ?? 9999) <= thisPlayingId) try {
                flute.start({
                    note: (0, $02b52bdf6f82c33e$export$94966884eea635c4)(note, transposedBy),
                    duration: long ? $074faffa041224b7$var$NOTE_LENGTH * 2.1 : $074faffa041224b7$var$NOTE_LENGTH * 1.1
                });
            } catch  {
                console.log("Couldn't play", note);
            }
            else onFinished();
        }, scheduleTime * 1000);
    };
    score.forEach((note, noteIndex)=>{
        if (note === "6b" || note === "4b" || note === "8b") {
            scheduleNote("Bb3", t, false);
            addHighlight(noteIndex);
            t += $074faffa041224b7$var$NOTE_LENGTH;
        } else if (note === "6b." || note === "4b.") {
            scheduleNote("Bb3", t, true);
            addHighlight(noteIndex);
            t += $074faffa041224b7$var$NOTE_LENGTH * 2;
        } else if (note === ",") t += $074faffa041224b7$var$NOTE_LENGTH;
        else if (note.length === 2 && note.charAt(1) === ".") {
            const noteOffset = parseInt(note.charAt(0));
            scheduleNote((0, $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d)[offset + noteOffset], t, true);
            addHighlight(noteIndex);
            t += $074faffa041224b7$var$NOTE_LENGTH * 2;
        } else {
            const noteOffset = parseInt(note);
            scheduleNote((0, $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d)[offset + noteOffset], t, false);
            addHighlight(noteIndex);
            t += $074faffa041224b7$var$NOTE_LENGTH;
        }
    });
    setTimeout(()=>{
        if ((playingIdRef.current ?? 9999) <= thisPlayingId) {
            onFinished();
            onSetHighlightCount(0);
        }
    }, t * 1000);
    return $074faffa041224b7$var$playingId;
};
const $074faffa041224b7$var$getNotesFromGabc = (gabc, onlyIntone)=>{
    let isInsideNeume = false;
    let clefLetter = "";
    let clefOffset = -1;
    const hasStar = gabc.indexOf("*") !== -1;
    const score = [];
    let foundStar = false;
    const flattened = new Set([]);
    const pushNote = (num)=>{
        if (flattened.has(num)) score.push(`${num}b`);
        else score.push(num);
    };
    for(let charIndex = 0; charIndex < gabc.length; charIndex++){
        if (onlyIntone && (hasStar && foundStar || score.length >= 5 && !isInsideNeume)) {
            const finalNote = score.pop()?.replace(".", "");
            while(score[score.length - 1] === finalNote)score.pop();
            score.push(`${finalNote}.`);
            score.push(`${score[0]}.`);
            break;
        }
        const char = gabc[charIndex];
        if (char === ")") isInsideNeume = false;
        const lcChar = char.toLocaleLowerCase();
        if (isInsideNeume) {
            if (clefLetter === "") {
                clefLetter = lcChar;
                continue;
            }
            if (clefOffset === -1) clefOffset = parseInt(lcChar) * 2 - 1;
            if (lcChar === "x") {
                flattened.add(score[score.length - 1]);
                score.pop();
            }
            if ("abcdefghijkl".includes(lcChar)) pushNote([
                //"-3",
                "-2",
                "-1",
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9"
            ]["abcdefghijkl".indexOf(lcChar)]);
            if (";:".includes(lcChar)) {
                score.push(`${score.pop()?.replace(".", "")}.`);
                flattened.clear();
                pushNote(",");
            }
        } else if (char === "*") foundStar = true;
        if (char === "(") isInsideNeume = true;
    }
    return {
        score: score,
        clefLetter: clefLetter,
        clefOffset: clefOffset
    };
};
const $074faffa041224b7$export$7b9f512f3db4233b = (props)=>{
    const { gabc: gabc, title: title, onlyIntone: onlyIntone, tone: tone, tweak: tweak } = props;
    const { settings: settings } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const transposeBy = tweak + settings.transpositions["1"] + ((0, $c07cc9090462c085$export$df12744c9c7cdebd)[tone] ? (0, $02b52bdf6f82c33e$export$c6bb8e99f71a0bee)((0, $c07cc9090462c085$export$df12744c9c7cdebd)[tone]) : (0, $02b52bdf6f82c33e$export$17267529e6476353)(tone.slice(0, 1)));
    const [playing, setPlaying] = (0, $acw62.useState)(false);
    const playingIdRef = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{}, []);
    const { score: score, clefLetter: clefLetter, clefOffset: clefOffset } = (0, $acw62.useMemo)(()=>{
        return $074faffa041224b7$var$getNotesFromGabc(gabc, onlyIntone ?? false);
    }, [
        gabc,
        onlyIntone
    ]);
    const play = (0, $acw62.useCallback)(()=>{
        console.log(gabc, score);
        setPlaying(true);
        const ac = new $074faffa041224b7$var$AudioContext();
        // create empty buffer
        var buffer = ac.createBuffer(1, 1, 22050);
        var source = ac.createBufferSource();
        source.buffer = buffer;
        // connect to output (your speakers)
        source.connect(ac.destination);
        // play the file
        source.start(0);
        playingIdRef.current = $074faffa041224b7$var$playTone(ac, clefLetter, clefOffset, score, ()=>{
            setPlaying(false);
        }, (count)=>undefined, transposeBy, playingIdRef);
    }, [
        clefLetter,
        clefOffset,
        score,
        transposeBy
    ]);
    const stop = (0, $acw62.useCallback)(()=>{
        playingIdRef.current++;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingLeft: 4
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: playing ? "new-button-playing" : "new-button",
            onClick: playing ? stop : play,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "play-icon",
                    children: "\u25BA"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: title
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");



const $82bb01a09dc6158e$export$b74815b6cb0f6d09 = (props)=>{
    const { children: children } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        onlySides: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                paddingBottom: 8,
                paddingTop: 8,
                paddingLeft: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                paddingRight: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                fontSize: isSmallScreen ? (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57) * 0.9 : (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57),
                textAlign: "justify",
                color: (0, $b5d1360628cd70a0$export$516f68680b50dca1)
            },
            className: "legacy-text-block",
            children: children
        })
    });
};


const $130eca1cdc8dd34c$export$a06f1c675e846f6f = (props)=>{
    const { day: day, hour: hour } = props;
    const mailRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (mailRef.current) mailRef.current.href = "mailto:" + [
            "contact",
            "singtheoffice.com"
        ].join("@");
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingBottom: 32
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    borderTop: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`,
                    paddingTop: 32,
                    paddingBottom: 32,
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            paddingBottom: 16,
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0e7871cd1858330$export$9c9ee2e156b54bfb), {})
                    }),
                    "If you found any errors, or have any comments or suggestions, help us out by",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        style: {
                            textDecoration: "underline"
                        },
                        type: "mailto",
                        ref: mailRef,
                        children: "contacting\xa0us."
                    })
                ]
            })
        })
    });
};



parcelRequire("acw62");

const $fa95bc0dec5925fc$export$42a339231f97c2b2 = {
    "advent-1": "Almighty God, give us grace that we may cast away the works of darkness, and put upon us the armour of light, now in the time of this mortal life in which thy Son Jesus Christ came to visit us in great humility; that in the last day, when he shall come again in his glorious majesty to judge both the quick and the dead, we may rise to the life immortal; through him who liveth and reigneth with thee and the Holy Ghost, one God, now and for ever.",
    "advent-2": "Blessed Lord, who hast caused all holy Scriptures to be written for our learning; Grant that we may in such wise hear them, read, mark, learn, and inwardly digest them, that by patience and  comfort of thy holy Word, we may embrace, and ever hold fast, the blessed hope of everlasting life, which thou hast given us in our Saviour Jesus Christ.",
    "advent-3": "O Lord Jesus Christ, who at thy first coming didst send thy messenger to prepare thy way before thee; Grant that the ministers and stewards of thy mysteries may likewise so prepare and make ready thy way, by turning the hearts of the disobedient to the wisdom of the just, that at thy second coming to judge the world we may be found an acceptable people in thy sight, who livest and reignest with the Father and the Holy Spirit ever, one God, world without end.",
    "advent-4": "O Lord, raise up, we pray thee, thy power, and come among us, and with great might succour us; that whereas, through our sins and wickedness, we are sore let and hindered in running the race that is set before us, thy bountiful grace and mercy may speedily help and deliver us; through the satisfaction of thy Son our Lord, to whom with thee and the Holy Ghost be honour and glory, world without end.",
    "christmas-day": "Almighty God, who hast given us thy only-begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin: Grant that we, being regenerate and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same our Lord Jesus Christ, who liveth and reigneth with thee and the same Spirit ever, one God, world without end. Amen.",
    "christmas-1": "Almighty God, who hast given us thy only-begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin; Grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same our Lord Jesus Christ, who liveth and reigneth with thee and the same Spirit, one God, world without end.",
    "christmas-2": "Almighty God, who hast given us thy only-begotten Son to take our nature upon him, and as at this time to be born of a pure Virgin; Grant that we being regenerate, and made thy children by adoption and grace, may daily be renewed by thy Holy Spirit; through the same our Lord Jesus Christ, who liveth and reigneth with thee and the same Spirit, one God, world without end.",
    epiphany: "O God, who by the leading of a star didst manifest thy only-begotten Son to the Gentiles: Mercifully grant, that we, which know thee now by faith, may after this life have the fruition of thy glorious Godhead; through Jesus Christ our Lord.",
    "epiphany-1": "O Lord, we beseech thee mercifully to receive the prayers of thy people which call upon thee; and grant that they may both perceive and know what things they ought to do, and also may have grace and power faithfully to fulfil the same; through Jesus Christ our Lord.",
    "epiphany-2": "Almighty and everlasting God, who dost govern all things in heaven and earth; Mercifully hear the supplications of thy people, and grant us thy peace all the days of our life; through Jesus Christ our Lord.",
    "epiphany-3": "Almighty and everlasting God, mercifully look upon our infirmities, and in all our dangers and necessities stretch forth thy right hand to help and defend us; through Jesus Christ our Lord.",
    "epiphany-4": "O God, who knowest us to be set in the midst of so many and great dangers, that by reason of the frailty of our nature we cannot always stand upright; Grant to us such strength and protection, as may support us in all dangers, and carry us through all temptations; through Jesus Christ our Lord.",
    "epiphany-5": "O Lord, we beseech thee to keep thy Church and household continually in thy true religion; that they who do lean only upon the hope of thy heavenly grace may evermore be defended by thy mighty power; through Jesus Christ our Lord.",
    "epiphany-6": "O God, whose blessed Son was manifested that he might destroy the works of the devil, and make us the sons of God, and heirs of eternal life; Grant us, we beseech thee, that, having this hope, we may purify ourselves, even as he is pure; that, when he shall appear again with power and great glory, we may be made like unto him in his eternal and glorious kingdom; where with thee, O Father, and thee, O Holy Ghost, he liveth and reigneth, ever one God, world without end.",
    septuagesima: "O Lord, we beseech thee favourably to hear the prayers of thy people; that we, who are justly punished for our offences, may be mercifully delivered by thy goodness, for the glory of thy Name; through Jesus Christ our Saviour, who liveth and reigneth with thee and the Holy Ghost, ever one God, world without end.",
    sexagesima: "O Lord God, who seest that we put not our trust in any thing that we do; Mercifully grant that by thy power we may be defended against all adversity; through Jesus Christ our Lord.",
    quinquagesima: "O Lord, who hast taught us that all our doings without charity are nothing worth; Send thy Holy Ghost and pour into our hearts that most excellent gift of charity, the very bond of peace and of all virtues, without which whosoever liveth is counted dead before thee. Grant this for thine only Son Jesus Christ's sake.",
    "ash-wednesday": "Almighty and everlasting God, who hatest nothing that thou hast made and dost forgive the sins of all them that are penitent: Create and make in us new and contrite hearts, that we, worthily lamenting our sins, and acknowledging our wretchedness, may obtain of thee, the God of all mercy, perfect remission and forgiveness; through Jesus Christ our Lord.",
    "lent-1": "O Lord, who for our sake didst fast forty days and forty nights; Give us grace to use such abstinence, that, our flesh being subdued to the Spirit, we may ever obey thy godly motions in righteousness, and true holiness, to thy honour and glory, who livest and reignest with the Father and the Holy Ghost, one God, world without end.",
    "lent-2": "Almighty God, who seest that we have no power of ourselves to help ourselves; Keep us both outwardly in our bodies and inwardly in our souls; that we may be defended from all adversities which may happen to the body and from all evil thoughts which may assault and hurt the soul; through Jesus Christ our Lord.",
    "lent-3": "We beseech thee, Almighty God, look upon the hearty desires of thy humble servants, and stretch forth the right hand of thy Majesty, to be our defence against all our enemies; through Jesus Christ our Lord.",
    "lent-4": "Grant, we beseech thee, Almighty God, that we, who for our evil deeds do worthily deserve to be punished, by the comfort of thy grace may mercifully be relieved; through our Lord and Saviour Jesus Christ.",
    "lent-5": "We beseech thee, Almighty God, mercifully to look upon thy people; that by thy great goodness they may be governed and preserved evermore, both in body and soul; through Jesus Christ our Lord.",
    "lent-6": "Almighty and everlasting God, who, of thy tender love towards mankind, hast sent thy Son, our Savior Jesus Christ, to take upon him our flesh, and to suffer death upon the cross, that all mankind should follow the example of his great humility; Mercifully grant, that we may both follow the example of his patience, and also be made partakers of his resurrection; through the same Jesus Christ our Lord.",
    "good-friday": "Almighty God, we beseech thee graciously to behold this thy family, for whom our Lord Jesus Christ was contented to be betrayed, and given up into the hands of wicked men, and to suffer death upon the cross, who now liveth and reigneth with thee and the Holy Ghost, ever one God, world without end.",
    "easter-eve": "Grant, O Lord, that as we are baptized into the death of thy blessed Son our Saviour Jesus Christ, so by continual mortifying our corrupt affections we may be buried with him : and that through the grave, and gate of death, we may pass to our joyful resurrection ; for his merits, who died, and was buried, and rose again for us, thy Son Jesus Christ our Lord.",
    "easter-day": "Almighty God, who through thine only-begotten Son Jesus Christ hast overcome death and opened unto us the gate of everlasting life; We humbly beseech thee, that as by thy special grace preventing us thou dost put into our minds good desires, so by thy continual help we may bring the same to good effect; through Jesus Christ our Lord, who liveth and reigneth with thee and the Holy Ghost, ever one God, world without end.",
    "easter-monday": "Almighty God, who through thy only-begotten Son Jesus Christ hast overcome death, and opened unto us the gate of everlasting life; We humbly beseech thee, that, as by thy special grace preventing us thou dost put into our minds good desires, so by thy continual help we may bring the same to good effect; through Jesus Christ our Lord, who liveth and reigneth with thee and the Holy Ghost, ever one God, world without end.",
    "easter-tuesday": "Almighty God, who through thine only-begotten Son Jesus Christ hast overcome death and opened unto us the gate of everlasting life; We humbly beseech thee, that as by thy special grace preventing us thou dost put into our minds good desires, so by thy continual help we may bring the same to good effect; through Jesus Christ our Lord, who liveth and reigneth with thee and the Holy Ghost, ever one God, world without end.",
    "easter-1": "Almighty Father, who has given thine only Son to die for our sins, and to rise again for our justification; Grant us so to put away the leaven of malice and wickedness, that we may alway serve thee in pureness of living and truth; through the merits of the same thy Son Jesus Christ our Lord.",
    "easter-2": "Almighty God, who has given thine only Son to be unto us both a sacrifice for sin, and also an ensample of godly life; Give us grace that we may always most thankfully receive that his inestimable benefit, and also daily endeavour ourselves to follow the blessed steps of his most holy life; through the same Jesus Christ our Lord.",
    "easter-3": "Almighty God, who shewest to them that be in error the light of thy truth, to the intent that they may return into the way of righteousness; Grant unto all them that are admitted into the fellowship of Christ's Religion, that they may eschew those things that are contrary to their profession, and follow all such things as are agreeable to the same; through our Lord Jesus Christ.",
    "easter-4": "O Almighty God, who alone canst order the unruly wills and affections of sinful men; Grant unto thy people, that they may love the thing which thou commandest, and desire that which thou dost promise; that so, among the sundry and manifold changes of the world, our hearts may surely there be fixed, where true joys are to be found; through Jesus Christ our Lord.",
    "easter-5": "O Lord, from whom all good things do come; Grant to us thy humble servants, that by thy holy inspiration we may think those things that be good, and by thy merciful guiding may perform the same; through our Lord Jesus Christ.",
    ascension: "Grant, we beseech thee, Almighty God, that like as we do believe thy only-begotten Son our Lord Jesus Christ to have ascended into the heavens; so we may also in heart and mind thither ascend, and with him continually dwell, who liveth and reigneth with thee and the Holy Ghost, one God, world without end.",
    "easter-6": "O God the King of glory, who hast exalted thine only Son Jesus Christ with great triumph unto thy kingdom in heaven; We beseech thee, leave us not comfortless; but send to us thine Holy Ghost to comfort us, and exalt us unto the same place whither our Saviour Christ is gone before, who liveth and reigneth with thee and the Holy Ghost, one God, world without end.",
    whitsun: "God, who as at this time didst teach the hearts of thy faithful people, by the sending to them the light of thy Holy Spirit; Grant us by the same Spirit to have a right judgment in all things, and evermore to rejoice in his holy comfort; through the merits of Christ Jesus our Saviour, who liveth and reigneth with thee, in the unity of the same Spirit, one God, world without end.",
    "monday-after-whitsun": "O God, who as at this time didst teach the hearts of thy faithful people by sending to them the light of thy Holy Spirit: Grant us by the same Spirit to have a right judgment in all things, and evermore to rejoice in his holy comfort; through the merits of Christ Jesus our Savior, who liveth and reigneth with thee, in the unity of the same Spirit, one God, world without end.",
    "tuesday-after-whitsun": "O God, who as at this time didst teach the hearts of thy faithful people by sending to them the light of thy Holy Spirit: Grant us by the same Spirit to have a right judgment in all things, and evermore to rejoice in his holy comfort; through the merits of Christ Jesus our Savior, who liveth and reigneth with thee, in the unity of the same Spirit, one God, world without end.",
    "trinity-sunday": "Almighty and everlasting God, who hast given unto us thy servants grace, by the confession of a true faith to acknowledge the glory of the eternal Trinity, and in the power of thy Divine Majesty to worship the Unity; We beseech thee, that thou wouldst keep us steadfast in this faith, and evermore defend us from all adversities, who livest and reignest, one God, world without end.",
    "trinity-1": "O God, the strength of all them that put their trust in thee, mercifully accept our prayers; and because through the weakness of our mortal nature we can do no good thing without thee, grant us the help of thy grace, that in keeping of thy commandments we may please thee, both in will and deed; through Jesus Christ our Lord.",
    "trinity-2": "O Lord, who never failest to help and govern them who thou dost bring up in thy stedfast fear and love; Keep us, we beseech thee, under the protection of thy good providence, and make us to have a perpetual fear and love of thy holy Name; through Jesus Christ our Lord.",
    "trinity-3": "O Lord, we beseech thee mercifully to hear us; and grant that we, to whom thou hast given an hearty desire to pray, may be comforted in all dangers and adversities; through Jesus Christ our Lord.",
    "trinity-4": "O God, the protector of all that trust in thee, without whom nothing is strong, nothing is holy; Increase and multiply upon us thy mercy; that, thou being our ruler and guide, we may so pass through things temporal, that we finally lose not the things eternal: Grant this, O heavenly Father, for Jesus Christ's sake our Lord.",
    "trinity-5": "Grant, O Lord, we beseech thee, that the course of this world may be so peaceably ordered by thy governance, that thy Church may joyfully serve thee in all godly quietness; through Jesus Christ our Lord.",
    "trinity-6": "O God, who hast prepared for them that love thee such good things as pass man's understanding; Pour into our hearts such love toward thee, that we, loving thee above all things, may obtain thy promises, which exceed all that we can desire; through Jesus Christ our Lord.",
    "trinity-7": "Lord of all power and might, who art the author and giver of all good things; Graft in our hearts the love of thy Name, increase in us true religion, nourish us with all goodness, and of thy great mercy keep us in the same; through Jesus Christ our Lord.",
    "trinity-8": "O God, whose never-failing providence ordereth all things both in heaven and earth; We humbly beseech thee to put away from us all hurtful things, and to give us those things which be profitable for us; through Jesus Christ our Lord.",
    "trinity-9": "Grant to us, Lord, we beseech thee, the spirit to think and do always such things as be rightful; that we, who cannot do any thing that is good without thee, may by thee be enabled to live according to thy will; through Jesus Christ our Lord.",
    "trinity-10": "Let thy merciful ears, O Lord, be open to the prayers of thy humble servants; and that they may obtain their petitions make them to ask such things as shall please thee; through Jesus Christ our Lord.",
    "trinity-11": "O God, who declarest thy almighty power most chiefly in shewing mercy and pity; Mercifully grant unto us such a measure of thy grace, that we, running the way of thy commandments, may obtain thy gracious promises, and be made partakers of thy heavenly treasure; through Jesus Christ our Lord.",
    "trinity-12": "Almighty and everlasting God, who art always more ready to hear than we are to pray, and art wont to give more than either we desire, or deserve; Pour down upon us the abundance of thy mercy; forgiving us those things whereof our conscience is afraid, and giving us those good things which we are not worthy to ask, but through the merits and mediation of Jesus Christ, thy Son, our Lord.",
    "trinity-13": "Almighty and merciful God, of whose only gift it cometh that thy faithful people do unto thee true and laudable service ; Grant, we beseech thee, that we may so faithfully serve thee in this life, that we fail not finally to attain thy heavenly promises; through the merits of Jesus Christ our Lord.",
    "trinity-14": "Almighty and everlasting God, give unto us the increase of faith, hope, and charity; and, that we may obtain that which thou dost promise, make us to love that which thou dost command; through Jesus Christ our Lord.",
    "trinity-15": "Keep, we beseech thee, O Lord, thy Church with thy perpetual mercy: and, because the frailty of man without thee cannot but fall, keep us ever by thy help from all things hurtful, and lead us to all things profitable to our salvation; through Jesus Christ our Lord.",
    "trinity-16": "O Lord, we beseech thee, let thy continual pity cleanse and defend thy Church; and, because it cannot continue in safety without thy succour, preserve it evermore by thy help and goodness; through Jesus Christ our Lord.",
    "trinity-17": "Lord, we pray thee that thy grace may always prevent and follow us, and make us continually to be given to all good works; through Jesus Christ our Lord.",
    "trinity-18": "Lord, we beseech thee, grant thy people grace to withstand the temptations of the world, the flesh, and the devil, and with pure hearts and minds to follow thee the only God; through Jesus Christ our Lord.",
    "trinity-19": "O God, forasmuch as without thee we are not able to please thee; Mercifully grant, that thy Holy Spirit may in all things direct and rule our hearts; through Jesus Christ our Lord.",
    "trinity-20": "O Almighty and most merciful God, of thy bountiful goodness keep us, we beseech thee, from all things that may hurt us; that we, being ready both in body and soul, may cheerfully accomplish those things that thou wouldest have done; through Jesus Christ our Lord.",
    "trinity-21": "Grant, we beseech thee, merciful Lord, to thy faithful people pardon and peace, that they may be cleansed from all their sins, and serve thee with a quiet mind; through Jesus Christ our Lord.",
    "trinity-22": "Lord, we beseech thee to keep thy household the Church in continual godliness; that through thy protection it may be free from all adversities, and devoutly given to serve thee in good works, to the glory of thy Name; through Jesus Christ our Lord.",
    "trinity-23": "O God, our refuge and strength, who art the author of all godliness; Be ready, we beseech thee, to hear the devout prayers of thy Church; and grant that those things which we ask faithfully we may obtain effectually; through Jesus Christ our Lord.",
    "trinity-24": "O Lord, we beseech thee, absolve thy people from their offences; that through thy bountiful goodness we may all be delivered from the bands of those sins, which by our frailty we have  committed: Grant this, O heavenly Father, for Jesus Christ's sake, our blessed Lord and Saviour.",
    "trinity-25": "O Lord, we beseech thee, absolve thy people from their offences; that through thy bountiful goodness we may all be delivered from the bands of those sins, which by our frailty we have  committed: Grant this, O heavenly Father, for Jesus Christ's sake, our blessed Lord and Saviour.",
    "trinity-26": "O Lord, we beseech thee, absolve thy people from their offences; that through thy bountiful goodness we may all be delivered from the bands of those sins, which by our frailty we have  committed: Grant this, O heavenly Father, for Jesus Christ's sake, our blessed Lord and Saviour.",
    "trinity-27": "O Lord, we beseech thee, absolve thy people from their offences; that through thy bountiful goodness we may all be delivered from the bands of those sins, which by our frailty we have  committed: Grant this, O heavenly Father, for Jesus Christ's sake, our blessed Lord and Saviour.",
    "sunday-before-advent": "Stir up, we beseech thee, O Lord, the wills of thy faithful people; that they, plenteously bringing forth the fruit of good works, may of thee be plenteously rewarded; through Jesus Christ our Lord."
};
const $fa95bc0dec5925fc$export$286f1125f679f180 = {
    "all-saints": "O ALMIGHTY God, who hast knit together thine elect in one communion and fellowship, in the mystical body of thy Son Christ our Lord: Grant us grace so to follow thy blessed Saints in all virtuous and godly living, that we may come to those unspeakable joys, which thou hast prepared for them that unfeignedly love thee; through Jesus Christ our Lord.",
    "st-stephen": "Grant, O Lord, that in all our sufferings here upon earth for the testimony of thy truth, we may stedfastly look up to heaven, and by faith behold the glory that shall be revealed; and, being filled with the Holy Ghost, may learn to love and bless our persecutors by the example of thy first Martyr Saint Stephen, who prayed for his murderers to thee, O blessed Jesus, who standest at the right hand of God to succour all those that suffer for thee, our only Mediator and Advocate.",
    "st-john": "Merciful Lord, we beseech thee to cast thy bright beams of light upon thy Church, that it being enlightened by the doctrine of thy blessed Apostle and Evangelist Saint John may so walk in the light of thy truth, that it may at length attain to the light of everlasting life; through Jesus Christ our Lord.",
    "holy-innocents": "O Almighty God, who out of the mouths of babes and sucklings hast ordained strength, and madest infants to glorify thee by their deaths; Mortify and kill all vices in us, and so strengthen us by thy grace, that by the innocency of our lives, and constancy of our faith even unto death, we may glorify thy holy Name; through Jesus Christ our Lord.",
    circumcision: "Almighty God, who madest thy blessed Son to be circumcised, and obedient to the law for man; Grant us the true Circumcision of the Spirit; that, our hearts, and all our members, being mortified from all worldly and carnal lusts, we may in all things obey thy blessed will; through the same thy Son Jesus Christ our Lord.",
    "st-andrew": "Almighty God, who didst give such grace unto thy holy Apostle Saint Andrew, that he readily obeyed the calling of thy Son Jesus Christ, and followed him without delay: Grant unto us all, that we, being called by thy holy word, may forthwith give up ourselves obediently to fulfil thy holy commandments; through the same Jesus Christ our Lord.",
    "st-thomas": "Almighty and everliving God, who for the more confirmation of the faith didst suffer thy holy Apostle Thomas to be doubtful in thy Son's resurrection: Grant us so perfectly, and without all doubt, to believe in thy Son Jesus Christ, that our faith in thy sight may never be reproved. Hear us, O Lord, through the same Jesus Christ, to whom, with thee and the Holy Ghost, be all honour and glory, now and for evermore.",
    "conversion-of-st-paul": "O God, who, through the preaching of the blessed Apostle Saint Paul, hast caused the light of the Gospel to shine throughout the world: Grant, we beseech thee, that we, having his wonderful conversion in remembrance, may shew forth our thankfulness unto thee for the same, by following the holy doctrine which he taught; through Jesus Christ our Lord.",
    presentation: "Almighty and everliving God, we humbly beseech thy Majesty, that, as thy only-begotten Son was this day presented in the temple in substance of our flesh, so we may be presented unto thee with pure and clean hearts, by the same thy Son Jesus Christ our Lord.",
    "st-matthias": "O Almighty God, who into the place of the traitor Judas didst choose thy faithful servant Matthias to be of the number of the twelve Apostles: Grant that thy Church, being alway preserved from false Apostles, may be ordered and guided by faithful and true pastors; through Jesus Christ our Lord.",
    annunciation: "We beseech thee, O Lord, pour thy grace into our hearts; that, as we have known the incarnation of thy Son Jesus Christ by the message of an angel, so by his cross and passion we may be brought unto the glory of his resurrection; through the same Jesus Christ our Lord.",
    "st-mark": "O Almighty God, who hast instructed thy holy Church with the heavenly doctrine of thy Evangelist Saint Mark: Give us grace, that, being not like children carried away with every blast of vain doctrine, we may be established in the truth of thy holy Gospel; through Jesus Christ our Lord.",
    "st-philip-and-st-james": "O Almighty God, whom truly to know is everlasting life: Grant us perfectly to know thy Son Jesus Christ to be the way, the truth, and the life; that, following the steps of thy holy Apostles, Saint Philip and Saint James, we may stedfastly walk in the way that leadeth to eternal life; through the same thy Son Jesus Christ our Lord.",
    "st-barnabas": "O Lord God Almighty, who didst endue thy holy Apostle Barnabas with singular gifts of the Holy Ghost: Leave us not, we beseech thee, destitute of thy manifold gifts, nor yet of grace to use them alway to thy honour and glory; through Jesus Christ our Lord.",
    "st-john-baptist": "Almighty God, by whose providence thy servant John Baptist was wonderfully born, and sent to prepare the way of thy Son our Saviour, by preaching of repentance: Make us so to follow his doctrine and holy life, that we may truly repent according to his preaching; and after his example constantly speak the truth, boldly rebuke vice, and patiently suffer for the truth's sake; through Jesus Christ our Lord.",
    "st-peter": "O Almighty God, who by thy Son Jesus Christ didst give to thy Apostle Saint Peter many excellent gifts, and commandedst him earnestly to feed thy flock: Make, we beseech thee, all Bishops and Pastors diligently to preach thy holy Word, and the people obediently to follow the same, that they may receive the crown of everlasting glory; through Jesus Christ our Lord.",
    "st-james": "Grant, O merciful God, that as thine holy Apostle Saint James, leaving his father and all that he had, without delay was obedient unto the calling of thy Son Jesus Christ, and followed him; so we, forsaking all worldly and carnal affections, may be evermore ready to follow thy holy commandments; through Jesus Christ our Lord.",
    "st-bartholomew": "O Almighty and everlasting God, who didst give to thine Apostle Bartholomew grace truly to believe and to preach thy Word: Grant, we beseech thee, unto thy Church, to love that Word which he believed, and both to preach and receive the same; through Jesus Christ our Lord.",
    "st-matthew": "O Almighty God, who by thy blessed Son didst call Matthew from the receipt of custom to be an Apostle and Evangelist: Grant us grace to forsake all covetous desires and inordinate love of riches, and to follow the same thy Son Jesus Christ, who liveth and reigneth with thee and the Holy Ghost, one God, world without end.",
    "st-michael-and-all-angels": "O Everlasting God, who hast ordained and constituted the services of Angels and men in a wonderful order: Mercifully grant that, as thy holy Angels alway do thee service in heaven, so by thy appointment they may succour and defend us on earth; through Jesus Christ our Lord.",
    "st-luke": "Almighty God, who calledst Luke the Physician, whose praise is in the Gospel, to be an Evangelist, and Physician of the soul: May it please thee that, by the wholesome medicines of the doctrine delivered by him, all the diseases of our souls may be healed; through the merits of thy Son Jesus Christ our Lord.",
    "st-simon-and-st-jude": "O Almighty God, who hast built thy Church upon the foundation of the Apostles and Prophets, Jesus Christ himself being the head corner-stone: Grant us so to be joined together in unity of spirit by their doctrine, that we may be made an holy temple acceptable unto thee; through Jesus Christ our Lord."
};


const $063afc2d5fcbb72a$var$DAYS_OF_THE_WEEK = [
    "sun",
    "mon",
    "tues",
    "wed",
    "thur",
    "fri",
    "sat"
];
const $063afc2d5fcbb72a$var$getEaster = function Easter(Y) {
    var C = Math.floor(Y / 100);
    var N = Y - 19 * Math.floor(Y / 19);
    var K = Math.floor((C - 17) / 25);
    var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor(I / 30);
    I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
    var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    var L = I - J;
    var M = 3 + Math.floor((L + 40) / 44);
    var D = L + 28 - 31 * Math.floor(M / 4);
    return {
        date: D,
        month: M
    };
};
const $063afc2d5fcbb72a$var$createCalendar = (year)=>{
    let day = new Date(`January 1, ${year}`);
    const calendar = {
        year: year,
        days: []
    };
    let weekOfTheYear = 0;
    let dayOfTheYear = 0;
    while(day.getFullYear() === year){
        if ($063afc2d5fcbb72a$var$DAYS_OF_THE_WEEK[day.getDay()] === "sun") weekOfTheYear++;
        calendar.days.push({
            year: year,
            date: day.getDate(),
            dayOfTheWeek: $063afc2d5fcbb72a$var$DAYS_OF_THE_WEEK[day.getDay()],
            month: day.getMonth() + 1,
            label: undefined,
            otherLabels: [],
            collectId: "",
            collect: "",
            weekOfTheYear: weekOfTheYear,
            antiphonId: "",
            dayOfTheYear: dayOfTheYear,
            sentenceId: "",
            hymnId: "",
            easterOctave: false,
            weekBeforeChristTheKing: false
        });
        // Increment the day
        day = new Date(day);
        day.setDate(day.getDate() + 1);
        dayOfTheYear++;
    }
    return calendar;
};
const $063afc2d5fcbb72a$var$getDateMethods = (calendar, date, month, skip)=>{
    return {
        maybePlaceLabel: (label)=>{
            const day = calendar.days.find((day)=>day.date === date && day.month === month);
            const valid = day !== undefined && day.label === undefined && !skip;
            if (day !== undefined) {
                if (valid) day.label = label;
            }
            return {
                else: ()=>{
                    $063afc2d5fcbb72a$var$getDateMethods(calendar, date, month, valid || skip);
                }
            };
        },
        placeLabel: (label)=>{
            const day = calendar.days.find((day)=>day.date === date && day.month === month);
            const valid = day !== undefined && day.label === undefined && !skip;
            if (day !== undefined) {
                if (valid) day.label = label;
                else day.otherLabels.push(label);
            }
        },
        plus: (amount, unit)=>{
            const startIndex = calendar.days.findIndex((day)=>day.date === date && day.month === month);
            const endIndex = startIndex + amount * (unit === "weeks" ? 7 : 1);
            const day = calendar.days[endIndex];
            if (day) return $063afc2d5fcbb72a$var$getDateMethods(calendar, day.date, day.month, skip);
            else return $063afc2d5fcbb72a$var$getDateMethods(calendar, 0, 0, true);
        },
        minus: (amount, unit)=>{
            return $063afc2d5fcbb72a$var$getDateMethods(calendar, date, month, skip).plus(-amount, unit);
        },
        getNthAfter: (amount, dayOfTheWeek)=>{
            let index = calendar.days.findIndex((day)=>day.date === date && day.month === month);
            while(amount !== 0){
                index++;
                if (!calendar.days[index]) return $063afc2d5fcbb72a$var$getDateMethods(calendar, 0, 0, true);
                if (calendar.days[index].dayOfTheWeek === dayOfTheWeek) amount--;
            }
            const day = calendar.days[index];
            return $063afc2d5fcbb72a$var$getDateMethods(calendar, day.date, day.month, skip);
        },
        getNthBefore: (amount, dayOfTheWeek)=>{
            let index = calendar.days.findIndex((day)=>day.date === date && day.month === month);
            while(amount !== 0){
                index--;
                if (!calendar.days[index]) return $063afc2d5fcbb72a$var$getDateMethods(calendar, 0, 0, true);
                if (calendar.days[index].dayOfTheWeek === dayOfTheWeek) amount--;
            }
            const day = calendar.days[index];
            return $063afc2d5fcbb72a$var$getDateMethods(calendar, day.date, day.month, skip);
        },
        placeBlackLetterDay: (blackLetterDay)=>{
            const day = calendar.days.find((day)=>day.date === date && day.month === month);
            if (day !== undefined) day.blackLetterDay = blackLetterDay;
        }
    };
};
const $063afc2d5fcbb72a$var$modify = (calendar)=>{
    return {
        cal: $063afc2d5fcbb72a$var$modify,
        onDate: (date, month)=>{
            return $063afc2d5fcbb72a$var$getDateMethods(calendar, date, month, false);
        },
        onLabel: (label)=>{
            const day = calendar.days.find((day)=>day.label === label || day.otherLabels.includes(label));
            if (day) return $063afc2d5fcbb72a$var$getDateMethods(calendar, day.date, day.month, false);
            else return $063afc2d5fcbb72a$var$getDateMethods(calendar, 0, 0, true);
        }
    };
};
const $063afc2d5fcbb72a$export$6d7724e5c284a396 = (year, dateFeasts)=>{
    const calendar = $063afc2d5fcbb72a$var$createCalendar(year);
    // The end of Christmas until Ephipany Day
    $063afc2d5fcbb72a$var$modify(calendar).onDate(1, 1).placeLabel("circumcision");
    $063afc2d5fcbb72a$var$modify(calendar).onDate(6, 1).placeLabel("epiphany");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("epiphany").getNthBefore(1, "sun").placeLabel("christmas-2");
    // Easter and related feasts
    const easter = $063afc2d5fcbb72a$var$getEaster(year);
    $063afc2d5fcbb72a$var$modify(calendar).onDate(easter.date, easter.month).placeLabel("easter-day");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(1, "sat").placeLabel("holy-saturday");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(1, "fri").placeLabel("good-friday");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(1, "thur").placeLabel("maundy-thursday");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(1, "wed").placeLabel("wed-before-easter");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(1, "tues").placeLabel("tues-before-easter");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(1, "mon").placeLabel("mon-before-easter");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(1, "mon").placeLabel("easter-monday");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(1, "tues").placeLabel("easter-tuesday");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(6, "sun").getNthBefore(1, "wed").placeLabel("ash-wednesday");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(6, "thur").placeLabel("ascension");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(7, "sun").placeLabel("whitsun");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("whitsun").getNthAfter(1, "mon").placeLabel("monday-after-whitsun");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("whitsun").getNthAfter(1, "tues").placeLabel("tuesday-after-whitsun");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(8, "sun").placeLabel("trinity-sunday");
    if (dateFeasts) {
        // Minor feasts until advent
        $063afc2d5fcbb72a$var$modify(calendar).onDate(25, 1).placeLabel("conversion-of-st-paul");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(2, 2).placeLabel("presentation");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(24, 2).placeLabel("st-matthias");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(25, 3).placeLabel("annunciation");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(25, 4).placeLabel("st-mark");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(1, 5).placeLabel("st-philip-and-st-james");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(11, 6).placeLabel("st-barnabas");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(24, 6).placeLabel("st-john-baptist");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(29, 6).placeLabel("st-peter");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(22, 7).placeLabel("st-mary-magdalene");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(25, 7).placeLabel("st-james");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(6, 8).placeLabel("transfiguration");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(24, 8).placeLabel("st-bartholomew");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(14, 9).placeLabel("holy-cross");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(21, 9).placeLabel("st-matthew");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(29, 9).placeLabel("st-michael-and-all-angels");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(18, 10).placeLabel("st-luke");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(28, 10).placeLabel("st-simon-and-st-jude");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(1, 11).placeLabel("all-saints");
    }
    // Sundays in Lent
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(1, "sun").placeLabel("lent-6");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(2, "sun").placeLabel("lent-5");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(3, "sun").placeLabel("lent-4");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(4, "sun").placeLabel("lent-3");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(5, "sun").placeLabel("lent-2");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(6, "sun").placeLabel("lent-1");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(7, "sun").placeLabel("quinquagesima");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(8, "sun").placeLabel("sexagesima");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthBefore(9, "sun").placeLabel("septuagesima");
    // Sundays in Epiphany (lower precedence than sundays in Lent)
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("epiphany").getNthAfter(1, "sun").maybePlaceLabel("epiphany-1");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("epiphany").getNthAfter(2, "sun").maybePlaceLabel("epiphany-2");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("epiphany").getNthAfter(3, "sun").maybePlaceLabel("epiphany-3");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("epiphany").getNthAfter(4, "sun").maybePlaceLabel("epiphany-4");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("epiphany").getNthAfter(5, "sun").maybePlaceLabel("epiphany-5");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("epiphany").getNthAfter(6, "sun").maybePlaceLabel("epiphany-6");
    // Sundays in Easter
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(1, "sun").placeLabel("easter-1");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(2, "sun").placeLabel("easter-2");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(3, "sun").placeLabel("easter-3");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(4, "sun").placeLabel("easter-4");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(5, "sun").placeLabel("easter-5");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("easter-day").getNthAfter(6, "sun").placeLabel("easter-6");
    // Christmas Day, and the Season of Advent
    $063afc2d5fcbb72a$var$modify(calendar).onDate(25, 12).placeLabel("christmas-day");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("christmas-day").getNthBefore(4, "sun").placeLabel("advent-1");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("christmas-day").getNthBefore(3, "sun").placeLabel("advent-2");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("christmas-day").getNthBefore(2, "sun").placeLabel("advent-3");
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("christmas-day").getNthBefore(1, "sun").placeLabel("advent-4");
    if (dateFeasts) {
        $063afc2d5fcbb72a$var$modify(calendar).onDate(30, 11).placeLabel("st-andrew");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(21, 12).placeLabel("st-thomas");
    }
    // The Season of Christmas up to the end of the year
    if (dateFeasts) {
        $063afc2d5fcbb72a$var$modify(calendar).onDate(26, 12).placeLabel("st-stephen");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(27, 12).placeLabel("st-john");
        $063afc2d5fcbb72a$var$modify(calendar).onDate(28, 12).placeLabel("holy-innocents");
    }
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("christmas-day").getNthAfter(1, "sun").placeLabel("christmas-1");
    // Sunday before advent
    $063afc2d5fcbb72a$var$modify(calendar).onLabel("advent-1").getNthBefore(1, "sun").placeLabel("sunday-before-advent");
    // Sundays in Trinity (lower precedence than Sundays in Advent)
    for(let i = 1; i <= 27; i++)$063afc2d5fcbb72a$var$modify(calendar).onLabel("trinity-sunday").getNthAfter(i, "sun").placeLabel(`trinity-${i}`);
    // Assign the collects
    let collectId = "christmas-1";
    let collect = (0, $fa95bc0dec5925fc$export$42a339231f97c2b2)["christmas-1"];
    calendar.days.forEach((day)=>{
        if (day.label && (0, $fa95bc0dec5925fc$export$286f1125f679f180)[day.label]) {
            day.collectId = day.label;
            day.collect = (0, $fa95bc0dec5925fc$export$286f1125f679f180)[day.label];
            // START HACK
            // Turned this back on for Easter 3 / St Mark 2021
            const weekCollectLabelIndex = day.otherLabels.findIndex((otherLabel)=>(0, $fa95bc0dec5925fc$export$42a339231f97c2b2)[otherLabel] !== undefined);
            if (weekCollectLabelIndex > -1) {
                collectId = day.otherLabels[weekCollectLabelIndex];
                collect = (0, $fa95bc0dec5925fc$export$42a339231f97c2b2)[day.otherLabels[weekCollectLabelIndex]];
            }
        // END HACK
        } else if (day.label && (0, $fa95bc0dec5925fc$export$42a339231f97c2b2)[day.label]) {
            day.collectId = day.label;
            day.collect = (0, $fa95bc0dec5925fc$export$42a339231f97c2b2)[day.label];
            collectId = day.collectId;
            collect = (0, $fa95bc0dec5925fc$export$42a339231f97c2b2)[day.label];
        } else {
            day.collectId = collectId;
            day.collect = collect;
        }
    });
    // Assign the old style invitatory antiphons
    let antiphonId = "christmas";
    let ordinaryCycle = 0;
    let easterOctave = false;
    calendar.days.forEach((day)=>{
        if (day.label === "epiphany") {
            antiphonId = "epiphany";
            day.antiphonId = "epiphany";
        } else if (day.label === "epiphany-1") {
            antiphonId = "ordinary";
            day.antiphonId = "epiphany";
            ordinaryCycle = 0;
        } else if (day.label === "transfiguration") day.antiphonId = "epiphany";
        else if (day.label === "ash-wednesday") {
            antiphonId = "lent";
            day.antiphonId = "lent";
        } else if (day.label === "easter-day") {
            antiphonId = "easter";
            day.antiphonId = "easter";
            easterOctave = true;
            day.easterOctave = true;
        } else if (day.label === "easter-1") {
            day.antiphonId = "easter";
            easterOctave = false;
            day.easterOctave = true;
        } else if (day.label === "ascension") {
            antiphonId = "ascension";
            day.antiphonId = "ascension";
        } else if (day.label === "whitsun") {
            antiphonId = "whitsun";
            day.antiphonId = "whitsun";
        } else if (day.label === "trinity-sunday") {
            antiphonId = "ordinary";
            day.antiphonId = "trinity";
        } else if (day.label === "presentation" || day.label === "annunciation") day.antiphonId = "annunciation";
        else if (day.label === "all-saints" || day.label && day.label.includes("st-")) day.antiphonId = "saints";
        else if (day.label === "advent-1") {
            antiphonId = "advent";
            day.antiphonId = "advent";
        } else if (day.label === "christmas-day") {
            antiphonId = "christmas";
            day.antiphonId = "christmas";
        } else {
            if (antiphonId === "ordinary") {
                day.antiphonId = `ordinary-${ordinaryCycle}`;
                ordinaryCycle = (ordinaryCycle + 1) % 3;
            } else day.antiphonId = antiphonId;
            day.easterOctave = easterOctave;
        }
    });
    const adventSundayIndex = calendar.days.findIndex((day)=>day.label === "advent-1");
    for(let offset = -13; offset <= -8; offset++)calendar.days[adventSundayIndex + offset].weekBeforeChristTheKing = true;
    // Assign the sentences
    let sentenceId = "christmas";
    calendar.days.forEach((day)=>{
        if (day.label === "epiphany") {
            sentenceId = "epiphany";
            day.sentenceId = "epiphany";
        } else if (day.label === "epiphany-1") {
            sentenceId = "ordinary";
            day.sentenceId = "epiphany";
        } else if (day.label === "transfiguration") day.sentenceId = "epiphany";
        else if (day.label === "ash-wednesday") {
            sentenceId = "lent";
            day.sentenceId = "lent";
        } else if (day.label === "lent-5") {
            sentenceId = "passiontide";
            day.sentenceId = "passiontide";
        } else if (day.label === "easter-day") {
            sentenceId = "easter";
            day.sentenceId = "easter";
        } else if (day.label === "ascension") {
            sentenceId = "ascension";
            day.sentenceId = "ascension";
        } else if (day.label === "whitsun") {
            sentenceId = "whitsun";
            day.sentenceId = "whitsun";
        } else if (day.label === "trinity-sunday") {
            sentenceId = "ordinary";
            day.sentenceId = "trinity";
        } else if (day.label === "presentation" || day.label === "annunciation") day.sentenceId = "annunciation";
        else if (day.label === "all-saints" || day.label && day.label.includes("st-")) day.sentenceId = "saints";
        else if (day.label === "advent-1") {
            sentenceId = "advent";
            day.sentenceId = "advent";
        } else if (day.label === "christmas-day") {
            sentenceId = "christmas";
            day.sentenceId = "christmas";
        } else day.sentenceId = sentenceId;
    });
    // Assign the hymns
    let hymnId = "christmas";
    let passionTideIndex = 1;
    calendar.days.forEach((day)=>{
        if (day.label === "epiphany") {
            hymnId = "epiphany";
            day.hymnId = "epiphany";
        } else if (day.label === "epiphany-1") {
            hymnId = "ordinary";
            day.hymnId = "epiphany";
        } else if (day.label === "transfiguration") day.hymnId = "epiphany";
        else if (day.label === "ash-wednesday") {
            hymnId = "lent-1";
            day.hymnId = "lent-1";
        } else if (day.label === "lent-2") {
            hymnId = "lent-2";
            day.hymnId = "lent-2";
        } else if (day.label === "lent-3") {
            hymnId = "lent-3";
            day.hymnId = "lent-3";
        } else if (day.label === "lent-4") {
            hymnId = "lent-4";
            day.hymnId = "lent-4";
        } else if (day.label === "lent-5") {
            hymnId = "passiontide";
            day.hymnId = "passiontide-0";
        } else if (day.label === "easter-day") {
            hymnId = "easter";
            day.hymnId = "easter";
        } else if (day.label === "ascension") {
            hymnId = "ascension";
            day.hymnId = "ascension";
        } else if (day.label === "whitsun") {
            hymnId = "whitsun";
            day.hymnId = "whitsun";
        } else if (day.label === "trinity-sunday") {
            hymnId = "ordinary";
            day.hymnId = "trinity";
        } else if (day.label === "presentation") day.hymnId = "presentation";
        else if (day.label === "annunciation") day.hymnId = "annunciation";
        else if (day.label === "all-saints" || day.label && day.label.includes("st-")) {
            if (hymnId === "easter") day.hymnId = "apostle-or-evangelist-easter";
            else day.hymnId = "apostle-or-evangelist";
        } else if (day.label === "advent-1") {
            hymnId = "advent";
            day.hymnId = "advent";
        } else if (day.label === "christmas-day") {
            hymnId = "christmas";
            day.hymnId = "christmas";
        } else if (hymnId === "passiontide") day.hymnId = `passiontide-${passionTideIndex++ % 2}`;
        else day.hymnId = hymnId;
    });
    // Assign the black letter days
    $063afc2d5fcbb72a$var$modify(calendar).onDate(8, 1).placeBlackLetterDay({
        id: "st-lucian",
        title: "Saint Lucian, Priest and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(13, 1).placeBlackLetterDay({
        id: "st-hilary",
        title: "Saint Hilary, Bishop and Confessor"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(18, 1).placeBlackLetterDay({
        id: "st-prisca",
        title: "Saint Prisca, Virgin Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(20, 1).placeBlackLetterDay({
        id: "st-fabian",
        title: "Saint Fabian, Bishop of Rome and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(21, 1).placeBlackLetterDay({
        id: "st-agnes",
        title: "Saint Agnes, Virgin Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(22, 1).placeBlackLetterDay({
        id: "st-vincent",
        title: "Saint Vincent, Deacon and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(3, 2).placeBlackLetterDay({
        id: "st-blasius",
        title: "Saint Blasius, Bishop and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(5, 2).placeBlackLetterDay({
        id: "st-agatha",
        title: "Saint Agatha, Virgin Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(14, 2).placeBlackLetterDay({
        id: "st-blasius",
        title: "Saint Valentine, Bishop and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(1, 3).placeBlackLetterDay({
        id: "st-david-of-menevia",
        title: "Saint David, Archbishop of Menevia"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(2, 3).placeBlackLetterDay({
        id: "st-chad",
        title: "Saint Chad, Bishop of Lichfield"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(7, 3).placeBlackLetterDay({
        id: "st-perpetua",
        title: "Saint Perpetua, Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(12, 3).placeBlackLetterDay({
        id: "st-gregory-magnus",
        title: "Saint Gregory Magnus, Bishop and Confessor"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(18, 3).placeBlackLetterDay({
        id: "st-edward",
        title: "Saint Edward, King and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(21, 3).placeBlackLetterDay({
        id: "st-benedict",
        title: "Saint Benedict, Abbot"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(3, 4).placeBlackLetterDay({
        id: "st-richard",
        title: "Saint Richard, Bishop of Chichester"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(4, 4).placeBlackLetterDay({
        id: "st-ambrose",
        title: "Saint Ambrose, Bishop of Milan"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(19, 4).placeBlackLetterDay({
        id: "st-alphege",
        title: "Saint Alphege, Archbishop of Canterbury"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(23, 4).placeBlackLetterDay({
        id: "st-george",
        title: "Saint George, Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(3, 5).placeBlackLetterDay({
        id: "invention-of-the-cross",
        title: "Invention of the Cross"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(6, 5).placeBlackLetterDay({
        id: "st-john-ante-portnam",
        title: "Saint John the Evangelist ante Portnam Latinam"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(19, 5).placeBlackLetterDay({
        id: "st-dunstan",
        title: "Saint Dunstan, Archbishop of Canterbury"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(26, 5).placeBlackLetterDay({
        id: "st-augustine-canterbury",
        title: "Saint Augustine, Archbishop of Canterbury"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(27, 5).placeBlackLetterDay({
        id: "venerable-bede",
        title: "Venerable Bede, Priest"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(1, 6).placeBlackLetterDay({
        id: "st-nicomede",
        title: "Saint Nicomede, Priest and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(5, 6).placeBlackLetterDay({
        id: "st-boniface",
        title: "Saint Boniface, Bishop of Mainz and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(17, 6).placeBlackLetterDay({
        id: "st-alban",
        title: "Saint Alban, Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(20, 6).placeBlackLetterDay({
        id: "tr-of-edward",
        title: "Translation of Edward, King of the West Saxons"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(2, 7).placeBlackLetterDay({
        id: "visitation",
        title: "Visitation of the Blessed Virgin Mary"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(4, 7).placeBlackLetterDay({
        id: "tr-of-st-martin",
        title: "Translation of Saint Martin, Bishop and Confessor"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(15, 7).placeBlackLetterDay({
        id: "st-swithun",
        title: "Saint Swithun, Bishop of Winchester"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(20, 7).placeBlackLetterDay({
        id: "st-margaret",
        title: "Saint Margaret, Virgin Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(26, 7).placeBlackLetterDay({
        id: "st-anne",
        title: "St Anne, Mother of the Blessed Virgin Mary"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(1, 8).placeBlackLetterDay({
        id: "lammas",
        title: "Lammas Day"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(7, 8).placeBlackLetterDay({
        id: "holy-name-of-jesus",
        title: "Holy Name of Jesus"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(10, 8).placeBlackLetterDay({
        id: "st-laurence",
        title: "Saint Laurence, Archdeacon of Rome and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(28, 8).placeBlackLetterDay({
        id: "st-augustine-hippo",
        title: "Saint Augustine, Bishop, Confessor, and Doctor of the Church"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(28, 8).placeBlackLetterDay({
        id: "st-augustine-hippo",
        title: "Saint Augustine, Bishop, Confessor, and Doctor of the Church"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(29, 8).placeBlackLetterDay({
        id: "beheading-of-st-john",
        title: "The Beheading of St John the Baptist"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(1, 9).placeBlackLetterDay({
        id: "st-giles",
        title: "Saint Giles, Abbot and Confessor"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(7, 9).placeBlackLetterDay({
        id: "st-evurtius",
        title: "Saint Evurtius, Bishop of Orleans"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(8, 9).placeBlackLetterDay({
        id: "nativity-of-bvm",
        title: "Nativity of the Blessed Virgin Mary"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(17, 9).placeBlackLetterDay({
        id: "st-lambert",
        title: "Saint Lambert, Bishop and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(26, 9).placeBlackLetterDay({
        id: "st-cyprian",
        title: "Saint Cyprian, Archbishop of Carthage and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(30, 9).placeBlackLetterDay({
        id: "st-jerome",
        title: "Saint Jerome, Priest, Confessor, and Doctor of the Church"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(1, 10).placeBlackLetterDay({
        id: "st-remigius",
        title: "Saint Remigius, Bishop of Rheims"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(6, 10).placeBlackLetterDay({
        id: "st-faith",
        title: "Saint Faith, Virgin Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(9, 10).placeBlackLetterDay({
        id: "st-denys",
        title: "Saint Denys the Areopagite, Bishop and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(13, 10).placeBlackLetterDay({
        id: "tr-of-king-edward-confessor",
        title: "Translation of King Edward the Confessor"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(17, 10).placeBlackLetterDay({
        id: "st-etheldreda",
        title: "Saint Etheldreda, Virgin"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(25, 10).placeBlackLetterDay({
        id: "st-crispin",
        title: "Saint Crispin, Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(2, 11).placeBlackLetterDay({
        id: "all-souls",
        title: "All Souls",
        optional: true
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(6, 11).placeBlackLetterDay({
        id: "st-leonard",
        title: "Saint Leonard, Confessor"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(11, 11).placeBlackLetterDay({
        id: "st-martin",
        title: "Saint Martin, Bishop and Confessor"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(13, 11).placeBlackLetterDay({
        id: "st-britius",
        title: "Saint Britius, Bishop"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(15, 11).placeBlackLetterDay({
        id: "st-machutus",
        title: "Saint Machutus, Bishop"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(17, 11).placeBlackLetterDay({
        id: "st-hugh",
        title: "Saint Hugh, Bishop of Lincoln"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(20, 11).placeBlackLetterDay({
        id: "st-edmund",
        title: "Saint Edmund, King and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(22, 11).placeBlackLetterDay({
        id: "st-ceclia",
        title: "Saint Cecilia, Virgin Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(23, 11).placeBlackLetterDay({
        id: "st-clement",
        title: "Saint Clement I, Bishop of Rome and Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(25, 11).placeBlackLetterDay({
        id: "st-catherine",
        title: "Saint Catherine, Virgin Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(6, 12).placeBlackLetterDay({
        id: "st-nicholas",
        title: "Saint Nicholas, Bishop of Myra"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(6, 12).placeBlackLetterDay({
        id: "st-nicholas",
        title: "Saint Nicholas, Bishop of Myra"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(8, 12).placeBlackLetterDay({
        id: "conception-of-the-bvm",
        title: "Conception of the Blessed Virgin Mary"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(13, 12).placeBlackLetterDay({
        id: "st-lucy",
        title: "Saint Lucy, Virgin Martyr"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(16, 12).placeBlackLetterDay({
        id: "o-sapientia",
        title: "O Sapientia"
    });
    $063afc2d5fcbb72a$var$modify(calendar).onDate(31, 12).placeBlackLetterDay({
        id: "st-silvester",
        title: "Saint Silvester, Bishop of Rome"
    });
    // Set all the eves
    calendar.days.forEach((day, dayIndex)=>{
        const nextDay = calendar.days[(dayIndex + 1) % calendar.days.length];
        if ((!day.label || day.label === "holy-saturday") && nextDay.label) day.eveOf = nextDay;
    });
    console.log("CALENDAR", calendar);
    return calendar;
};
const $063afc2d5fcbb72a$export$229d3f939f129064 = (year, month, date, dateFeasts)=>{
    const y = parseInt(`${year}`);
    const m = parseInt(`${month}`);
    const d = parseInt(`${date}`);
    const day = $063afc2d5fcbb72a$export$6d7724e5c284a396(y, dateFeasts).days.find((day)=>day.month === m && day.date === d);
    if (day) return day;
    else throw new Error("Could not find that day");
};
const $063afc2d5fcbb72a$export$e7af3ee2c84591cc = (month)=>{
    return [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ][month - 1];
};
const $063afc2d5fcbb72a$export$fd51ed252694f070 = (label)=>{
    switch(label){
        case "advent-1":
            return "The First Sunday in Advent";
        case "advent-2":
            return "The Second Sunday in Advent";
        case "advent-3":
            return "The Third Sunday in Advent";
        case "advent-4":
            return "The Fourth Sunday in Advent";
        case "christmas-day":
            return "Christmas Day";
        case "st-stephen":
            return "Saint Stephen the Martyr";
        case "st-john":
            return "Saint John the Evangelist";
        case "holy-innocents":
            return "The Holy Innocents";
        case "christmas-1":
            return "The Sunday after Christmas";
        case "christmas-2":
            return "The Second Sunday after Christmas";
        case "circumcision":
            return "The Circumcision of Christ";
        case "epiphany":
            return "The Epiphany";
        case "epiphany-1":
            return "The First Sunday after the Epiphany";
        case "epiphany-2":
            return "The Second Sunday after the Epiphany";
        case "epiphany-3":
            return "The Third Sunday after the Epiphany";
        case "epiphany-4":
            return "The Fourth Sunday after the Epiphany";
        case "epiphany-5":
            return "The Fifth Sunday after the Epiphany";
        case "epiphany-6":
            return "The Sixth Sunday after the Epiphany";
        case "septuagesima":
            return "Septuagesima Sunday";
        case "sexagesima":
            return "Sexagesima Sunday";
        case "quinquagesima":
            return "Quinquagesima Sunday";
        case "ash-wednesday":
            return "Ash Wednesday";
        case "lent-1":
            return "The First Sunday in Lent";
        case "lent-2":
            return "The Second Sunday in Lent";
        case "lent-3":
            return "The Third Sunday in Lent";
        case "lent-4":
            return "The Fourth Sunday in Lent";
        case "lent-5":
            return "The Fifth Sunday in Lent";
        case "lent-6":
            return "Palm Sunday";
        case "mon-before-easter":
            return "The Monday before Easter";
        case "tues-before-easter":
            return "The Tuesday before Easter";
        case "wed-before-easter":
            return "The Wednesday before Easter";
        case "maundy-thursday":
            return "Maundy Thursday";
        case "good-friday":
            return "Good Friday";
        case "holy-saturday":
            return "Holy Saturday";
        case "easter-day":
            return "Easter Day";
        case "easter-monday":
            return "Monday in Easter Week";
        case "easter-tuesday":
            return "Tuesday in Easter Week";
        case "easter-1":
            return "The First Sunday after Easter";
        case "easter-2":
            return "The Second Sunday after Easter";
        case "easter-3":
            return "The Third Sunday after Easter";
        case "easter-4":
            return "The Fourth Sunday after Easter";
        case "easter-5":
            return "The Fifth Sunday after Easter";
        case "ascension":
            return "The Ascension";
        case "easter-6":
            return "The Sunday after the Ascension";
        case "whitsun":
            return "Whitsunday";
        case "monday-after-whitsun":
            return "Monday in Whitsun Week";
        case "tuesday-after-whitsun":
            return "Tuesday in Whitsun Week";
        case "trinity-sunday":
            return "Trinity Sunday";
        case "sunday-before-advent":
            return "The Sunday next before Advent";
        case "st-andrew":
            return "Saint Andrew the Apostle";
        case "st-thomas":
            return "Saint Thomas the Apostle";
        case "conversion-of-st-paul":
            return "The Conversion of Saint Paul";
        case "presentation":
            return "The Presentation of Christ in the Temple";
        case "st-matthias":
            return "Saint Matthias the Apostle";
        case "annunciation":
            return "The Annunciation of the Blessed Virgin Mary";
        case "st-mark":
            return "Saint Mark the Evangelist";
        case "st-philip-and-st-james":
            return "Saint Philip and Saint James, Apostles";
        case "st-barnabas":
            return "Saint Barnabas the Apostle";
        case "st-john-baptist":
            return "Saint John the Baptist";
        case "st-peter":
            return "Saint Peter the Apostle";
        case "st-mary-magdalene":
            return "Saint Mary Magdalene";
        case "st-james":
            return "Saint James the Apostle";
        case "transfiguration":
            return "The Transfiguration";
        case "holy-cross":
            return "Holy Cross Day";
        case "st-bartholomew":
            return "Saint Bartholomew the Apostle";
        case "st-matthew":
            return "Saint Matthew the Apostle";
        case "st-michael-and-all-angels":
            return "Saint Michael and All Angels";
        case "st-luke":
            return "Saint Luke the Evangelist";
        case "st-simon-and-st-jude":
            return "Saint Simon and Saint Jude, Apostles";
        case "all-saints":
            return "All Saints";
    }
    if (label.includes("trinity")) return "The " + [
        "First",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seventh",
        "Eighth",
        "Ninth",
        "Tenth",
        "Eleventh",
        "Twelfth",
        "Thirteenth",
        "Fourteenth",
        "Fifteenth",
        "Sixteenth",
        "Seventeenth",
        "Eighteenth",
        "Nineteenth",
        "Twentieth",
        "Twenty-first",
        "Twenty-second",
        "Twenty-third",
        "Twenty-fourth",
        "Twenty-fifth",
        "Twenty-sixth",
        "Twenty-seventh"
    ][parseInt(label.split("-")[1]) - 1] + " Sunday after Trinity";
    return label;
};




parcelRequire("acw62");




const $56b95cfdb7e54a07$export$35e63fe56e1d2b2a = (props)=>{
    const { children: children, settingsPanelId: settingsPanelId } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        onlySides: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            },
            children: [
                settingsPanelId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        width: 24,
                        height: 24
                    }
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        paddingTop: 8,
                        paddingBottom: 8,
                        paddingLeft: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                        paddingRight: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                        color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                        fontSize: isSmallScreen ? (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57) * 0.9 : (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57),
                        textAlign: "center",
                        flexGrow: 1
                    },
                    children: [
                        "\u2761\xa0\xa0",
                        children
                    ]
                }),
                settingsPanelId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ffe339e0803830b$export$e2457e1974c298c3), {
                    settingsPanelId: settingsPanelId
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
            ]
        })
    });
};



const $55a5c2e1bacb63c1$export$a8a3e93435678ff9 = (props)=>{
    const { day: day, hour: hour } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontWeight: "bold",
                        letterSpacing: 2,
                        textTransform: "uppercase",
                        fontSize: "140%",
                        paddingBottom: 4,
                        paddingTop: 32
                    },
                    children: hour.toLocaleUpperCase()
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        fontWeight: "bold",
                        fontSize: "90%",
                        paddingBottom: 32
                    },
                    children: [
                        {
                            mon: "Monday",
                            tues: "Tuesday",
                            wed: "Wednesday",
                            thur: "Thursday",
                            fri: "Friday",
                            sat: "Saturday",
                            sun: "Sunday"
                        }[day.dayOfTheWeek],
                        " ",
                        day.date,
                        " ",
                        (0, $063afc2d5fcbb72a$export$e7af3ee2c84591cc)(day.month),
                        " ",
                        day.year
                    ]
                }),
                day.eveOf && hour !== "mattins" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontWeight: "bold",
                                letterSpacing: 0.3,
                                fontSize: "90%",
                                textTransform: "uppercase"
                            },
                            children: "The eve of"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontWeight: "bold",
                                letterSpacing: 0.3,
                                fontSize: "125%",
                                paddingBottom: 32
                            },
                            children: (0, $063afc2d5fcbb72a$export$fd51ed252694f070)(day.eveOf.label ?? "")
                        })
                    ]
                }) : day.label ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontWeight: "bold",
                        letterSpacing: 0.3,
                        fontSize: "150%",
                        paddingBottom: 32,
                        paddingLeft: 16,
                        paddingRight: 16
                    },
                    children: (0, $063afc2d5fcbb72a$export$fd51ed252694f070)(day.label)
                }) : day.blackLetterDay ? day.blackLetterDay.optional ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        paddingBottom: 32,
                        paddingLeft: 16,
                        paddingRight: 16,
                        fontSize: 18
                    },
                    children: [
                        "Commonly celebrated as:",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        (0, $063afc2d5fcbb72a$export$fd51ed252694f070)(day.blackLetterDay.title)
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        paddingBottom: 32,
                        paddingLeft: 16,
                        paddingRight: 16,
                        fontSize: 18
                    },
                    children: (0, $063afc2d5fcbb72a$export$fd51ed252694f070)(day.blackLetterDay.title)
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                day.label === "ash-wednesday" && hour === "mattins" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $56b95cfdb7e54a07$export$35e63fe56e1d2b2a), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "NOTE ON ASH WEDNESDAY"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "It is appropriate on Ash Wednesday to conclude Mattins with",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    style: {
                                        textDecoration: "underline"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                        to: "/pray/litany",
                                        children: "The\xa0Litany"
                                    })
                                }),
                                " ",
                                "and",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    style: {
                                        textDecoration: "underline"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                        to: "/pray/commination",
                                        children: "The\xa0Commination"
                                    })
                                }),
                                ". Links for doing so will be found at the appropriate points in Mattins and the Litany."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {
                            big: true
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $4e6ae22ad468d2c6$export$e2b0760399e6dece = ()=>{
    const [t, setT] = (0, $acw62.useState)(0);
    (0, $8c321ba562d39156$export$2e2bcd8739ae039)(()=>{
        setT((t)=>t + 0.1);
    }, 100);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 16
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    border: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`,
                    height: 12,
                    width: 100,
                    transition: "all 0.1s"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        height: "100%",
                        width: `${100 - 100 * (1 / (t / 5 + 1))}%`,
                        backgroundColor: (0, $b5d1360628cd70a0$export$cabad38efc6f637d)
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    paddingTop: 8
                },
                children: "Loading..."
            })
        ]
    });
};




parcelRequire("acw62");

parcelRequire("acw62");




const $a5b3a389defd8cf9$export$b6ed1485637740ed = (props)=>{
    const { hymn: hymn } = props;
    const verseCount = hymn.text.length / hymn.tune.length;
    const score = [
        (0, $8da148c2c45b952c$export$15512d11fbbb20af)(hymn.tune[0][0])[0] + ".",
        ",",
        ","
    ];
    for(let v = 0; v < verseCount; v++){
        hymn.tune.forEach((line, lineIndex)=>{
            line.forEach((syllable, syllableIndex)=>{
                (0, $8da148c2c45b952c$export$15512d11fbbb20af)(syllable).forEach((note, noteIndex)=>{
                    if (syllableIndex === line.length - 1 && (noteIndex === syllable.length - 1 || syllable.length === 2)) score.push(note + ".");
                    else score.push(note);
                });
            });
            if (lineIndex % 2 === 1) score.push(",", ",");
            else score.push(",");
        });
        if (v < verseCount - 1) score.push(",", ",");
    }
    (0, $8da148c2c45b952c$export$15512d11fbbb20af)(hymn.amen[0]).map((note, noteIndex)=>noteIndex === hymn.amen[0].length - 1 ? `${note}.` : note).forEach((note)=>score.push(note));
    (0, $8da148c2c45b952c$export$15512d11fbbb20af)(hymn.amen[1]).map((note, noteIndex)=>noteIndex === hymn.amen[1].length - 1 ? `${note}.` : note).forEach((note)=>score.push(note));
    const { settings: settings } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const transposeBy = settings.transpositions[hymn.tone];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99492fb2897c9321$export$fbed5f62d839a0cd), {
            clef: hymn.clef,
            score: score,
            title: "Play full hymn",
            transposeBy: (transposeBy ?? 0) + (0, $02b52bdf6f82c33e$export$17267529e6476353)(hymn.tone)
        })
    });
};








const $427fec415011985b$export$389138f633999d3 = (props)=>{
    const { day: day, hour: hour, verseLimit: verseLimit, exportLines: exportLines } = props;
    let mattinsId = "";
    let evensongId = "";
    let complineId = "to-thee-before-the-close-of-day";
    const hymnId = day.hymnId;
    if (hymnId === "apostle-or-evangelist") {
        mattinsId = "lord-of-creation-bow-thine-ear";
        evensongId = "lord-of-creation-bow-thine-ear";
    } else if (hymnId === "apostle-or-evangelist-easter") {
        mattinsId = "the-day-draws-on-apostles";
        evensongId = "lord-of-creation-bow-thine-ear";
    } else if (hymnId === "presentation") {
        mattinsId = "all-prophets-hail-thee";
        evensongId = "all-prophets-hail-thee";
    } else if (hymnId === "annunciation") {
        mattinsId = "the-god-whom-earth-and-sea-and-sky";
        evensongId = "the-god-whom-earth-and-sea-and-sky";
    } else if (hymnId === "lent-1") {
        mattinsId = "o-kind-creator-bow-thine-ear";
        evensongId = "the-fast-as-taught-by-holy-lore";
    } else if (hymnId === "lent-2") {
        mattinsId = "o-kind-creator-bow-thine-ear";
        evensongId = "the-fast-as-taught-by-holy-lore";
    } else if (hymnId === "lent-3") {
        mattinsId = "the-glory-of-these-forty-days";
        evensongId = "now-is-the-healing-time-decreed";
    } else if (hymnId === "lent-4") {
        mattinsId = "the-glory-of-these-forty-days";
        evensongId = "now-is-the-healing-time-decreed";
    } else if (hymnId === "passiontide-0") {
        mattinsId = "sing-my-tongue-the-glorious-battle";
        evensongId = "the-royal-banners-forward-go";
    } else if (hymnId === "passiontide-1") {
        mattinsId = "thirty-years-among-us-dwelling";
        evensongId = "the-royal-banners-forward-go";
    } else if (hymnId === "easter") {
        mattinsId = "the-day-draws-on-ferias";
        evensongId = "ye-choirs-of-new-jerusalem";
    } else if (hymnId === "ascension") {
        mattinsId = "eternal-monarch-king-most-high";
        evensongId = "eternal-monarch-king-most-high";
    } else if (hymnId === "whitsun") {
        mattinsId = "when-christ-our-lord-had-passed-once-more";
        evensongId = "rejoice-the-year-upon-its-way";
    } else if (hymnId === "advent") {
        mattinsId = "to-earth-descending-word-sublime";
        evensongId = "creator-of-the-stars-of-night";
    } else if (hymnId === "christmas") {
        mattinsId = "jesu-the-fathers-only-son";
        evensongId = "from-east-to-west-from-shore-to-shore";
    } else {
        mattinsId = day.dayOfTheWeek === "sun" ? "this-day-the-first-of-days-was-made" : day.dayOfTheWeek === "mon" ? "o-splendour-of-gods-glory-bright" : day.dayOfTheWeek === "tues" ? "the-wing-ed-herald-of-the-day" : day.dayOfTheWeek === "wed" ? "ye-clouds-and-darkness-hosts-of-night" : day.dayOfTheWeek === "thur" ? "lo-golden-light-rekindles-day" : day.dayOfTheWeek === "fri" ? "eternal-glory-of-the-sky" : day.dayOfTheWeek === "sat" ? "the-dawn-is-sprinkling-in-the-east" : "";
        evensongId = day.dayOfTheWeek === "sun" ? "o-blest-creator-of-the-light" : day.dayOfTheWeek === "mon" ? "o-boundless-wisdom-god-most-high" : day.dayOfTheWeek === "tues" ? "earths-mighty-maker-whose-command" : day.dayOfTheWeek === "wed" ? "most-holy-lord-and-god-of-heaven" : day.dayOfTheWeek === "thur" ? "almighty-god-who-from-the-flood" : day.dayOfTheWeek === "fri" ? "maker-of-man-who-from-thy-throne" : day.dayOfTheWeek === "sat" ? "creator-of-the-earth-and-sky" : "";
    }
    const id = hour === "mattins" ? mattinsId : hour === "evensong" ? evensongId : complineId;
    if (id === "") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
        content: "(This Office Hymn is coming soon!)"
    });
    const hymn = (0, $4d61651d1fc64a9b$export$1063804fe6672506)[id];
    let tuneLine = 0;
    const halves = hymn.text.slice(0, (verseLimit ?? hymn.text.length / hymn.tune.length) * hymn.tune.length).map((line)=>{
        let tuneIndex = 0;
        const half = [];
        line.forEach((word)=>{
            half.push({
                syllables: word.map((syllable)=>{
                    const result = {
                        text: syllable,
                        notes: (0, $8da148c2c45b952c$export$15512d11fbbb20af)(hymn.tune[tuneLine][tuneIndex]),
                        long: tuneIndex === hymn.tune[tuneLine].length - 1,
                        dotBefore: false
                    };
                    tuneIndex++;
                    return result;
                })
            });
        });
        tuneLine = (tuneLine + 1) % hymn.tune.length;
        return half;
    });
    const chants = [];
    for(let i = 0; i < halves.length; i += hymn.tune.length){
        chants.push([]);
        for(let j = 0; j < hymn.tune.length; j += 2)chants[chants.length - 1].push({
            firstHalf: halves[i + j],
            secondHalf: halves[i + j + 1]
        });
    }
    chants[chants.length - 1].push({
        secondHalf: [
            {
                syllables: [
                    {
                        text: "A",
                        notes: (0, $8da148c2c45b952c$export$15512d11fbbb20af)(hymn.amen[0]),
                        long: false,
                        dotBefore: false
                    },
                    {
                        text: "men.",
                        notes: (0, $8da148c2c45b952c$export$15512d11fbbb20af)(hymn.amen[1]),
                        long: true,
                        dotBefore: false
                    }
                ]
            }
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $982dab2795189e62$export$45a8b3c92b66d3be), {
        id: "hymn",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2d213bd4c46a128$export$1246c4e68efb74f5), {
                id: hymn.title.replace(/ /g, "-"),
                title: hymn.title,
                player: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5b3a389defd8cf9$export$b6ed1485637740ed), {
                    hymn: hymn
                })
            }),
            chants.map((chant, chantIndex)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                    pointedText: {
                        verses: chant,
                        clef: hymn.clef
                    },
                    dropCap: chantIndex === 0,
                    boldMode: "none",
                    yExtraOffset: id === "sing-my-tongue-the-glorious-battle" || id === "thirty-years-among-us-dwelling" || id === "o-blest-creator-of-the-light" ? 4 : 0,
                    exportLines: exportLines,
                    tone: hymn.tone
                });
            })
        ]
    });
};




parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




const $df21f7e96797500c$var$NULL = null;
function $df21f7e96797500c$var$replaceCaretsWithAsteriskSpan(element) {
    // Create a TreeWalker to visit all text nodes
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
    // Array to store nodes that need replacement
    // (We can't modify the DOM while walking the tree)
    const nodesToProcess = [];
    // Collect all text nodes containing "^^^"
    let currentNode;
    while(currentNode = walker.nextNode())if (currentNode.nodeValue.includes("^^^")) nodesToProcess.push(currentNode);
    // Process each node that needs replacement
    nodesToProcess.forEach((textNode)=>{
        const parent = textNode.parentNode;
        const text = textNode.nodeValue;
        // Split the text by "^^^"
        const parts = text.split("^^^");
        // If there's only one part, then "^^^" wasn't found (shouldn't happen due to our check above)
        if (parts.length === 1) return;
        console.log(parts);
        // Create a document fragment to hold the new nodes
        const fragment = document.createDocumentFragment();
        // Add each part with an asterisk span in between
        for(let i = 0; i < parts.length; i++){
            // Add the text part
            if (parts[i]) fragment.appendChild(document.createTextNode(parts[i]));
            // Add the asterisk span after all but the last part
            if (i < parts.length - 1) {
                const span = document.createElement("span");
                span.style.color = (0, $b5d1360628cd70a0$export$f20e1008093b38b9);
                span.textContent = "*";
                fragment.appendChild(span);
            }
        }
        // Replace the original text node with our fragment
        parent.replaceChild(fragment, textNode);
    });
}
const $df21f7e96797500c$export$f1b51ca5b8e2fcc6 = (props)=>{
    const { content: content, indent: indent, dropCap: dropCap } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    let initialLength = dropCap ? 1 : 0;
    while(!"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".includes(content[initialLength - 1]) && dropCap)initialLength++;
    const capitalized = dropCap ? (0, $f946c5f928169e9d$export$73f5c5f9b6ebb3d8)(content) : content;
    const initial = capitalized.slice(0, initialLength);
    const main = capitalized.slice(initialLength);
    const containerRef = (0, $acw62.useRef)($df21f7e96797500c$var$NULL);
    (0, $acw62.useLayoutEffect)(()=>{
        const el = containerRef.current.querySelector("p");
        const existingInitialSmall = containerRef.current.querySelector("p span.initial-small");
        const existingInitialLarge = containerRef.current.querySelector("p span.initial");
        const existingInitial = existingInitialSmall || existingInitialLarge;
        const initialEl = document.createElement("span");
        initialEl.className = isSmallScreen ? "initial-small" : "initial";
        initialEl.appendChild(document.createTextNode(initial));
        if (el && !existingInitial && dropCap) el.insertBefore(initialEl, el.childNodes[0] || null);
        $df21f7e96797500c$var$replaceCaretsWithAsteriskSpan(containerRef.current);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingLeft: indent === 10 ? 0 : (indent ?? 0) * (isSmallScreen ? 16 : 24),
            paddingTop: (indent ?? 0) === 0 ? 6 : 0,
            paddingBottom: (indent ?? 0) === 0 ? 6 : 0,
            textAlign: indent === 10 ? "right" : (indent ?? 0) === 0 ? "justify" : "left"
        },
        ref: containerRef,
        className: "markdown-text-line",
        "data-content": content,
        "data-indent": indent,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ead699faf34263db$export$7460c8b7e4ce9582), {
            children: main.replace(/\\n/g, "  \n")
        })
    });
};




var $acw62 = parcelRequire("acw62");




const $4c45cd8ea291c1ba$export$2db84c782bfb16e2 = (props)=>{
    const { content: content, dropCap: dropCap } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    const containerRef = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        onlySides: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                paddingLeft: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                paddingRight: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                fontSize: isSmallScreen ? (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57) * 0.9 : (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57),
                textAlign: "justify",
                color: (0, $b5d1360628cd70a0$export$516f68680b50dca1),
                paddingTop: 6,
                paddingBottom: 6
            },
            className: "text-block",
            "data-content": content,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df21f7e96797500c$export$f1b51ca5b8e2fcc6), {
                content: content,
                dropCap: dropCap
            })
        })
    });
};


const $2fb31402637fa4d9$var$getBookName = (title)=>{
    const names = {
        Genesis: "the Book of Genesis",
        Exodus: "the Book of Exodus",
        Leviticus: "the Book of Leviticus",
        Numbers: "the Book of Numbers",
        Deuteronomy: "the Book of Deuteronomy",
        Joshua: "the Book of Joshua",
        Judges: "the Book of Judges",
        Ruth: "the Book of Ruth",
        "1 Samuel": "the First Book of Samuel",
        "2 Samuel": "the Second Book of Samuel",
        "1 Kings": "the First Book of Kings",
        "2 Kings": "the Second Book of Kings",
        "1 Chronicles": "the First Book of Chronicles",
        "2 Chronicles": "the Second Book of Chronicles",
        Ezra: "the Book of Ezra",
        Nehemiah: "the Book of Nehemiah",
        Tobit: "the Book of Tobit",
        Judith: "the Book of Judith",
        Esther: "the Book of Esther",
        "1 Maccabees": "the First Book of Maccabees",
        "2 Maccabees": "the Second Book of Maccabees",
        Job: "the Book of Job",
        Proverbs: "the Book of Proverbs",
        Ecclesiastes: "the Book of Ecclesiastes",
        "Song of Songs": "the Song of Songs",
        "Song of Solomon": "the Song of Songs",
        Wisdom: "the Book of Wisdom",
        Sirach: "the Wisdom of Sirach",
        Isaiah: "the Book of the Prophet Isaiah",
        Jeremiah: "the Book of the Prophet Jeremiah",
        Lamentations: "the Book of Lamentations",
        Baruch: "the Book of the Prophet Baruch",
        Ezekiel: "the Book of the Prophet Ezekiel",
        Daniel: "the Book of the Prophet Daniel",
        Hosea: "the Book of the Prophet Hosea",
        Joel: "the Book of the Prophet Joel",
        Amos: "the Book of the Prophet Amos",
        Obadiah: "the Book of the Prophet Obadiah",
        Jonah: "the Book of the Prophet Jonah",
        Micah: "the Book of the Prophet Micah",
        Nahum: "the Book of the Prophet Nahum",
        Habakkuk: "the Book of the Prophet Habakkuk",
        Zephaniah: "the Book of the Prophet Zephaniah",
        Haggai: "the Book of the Prophet Haggai",
        Zechariah: "the Book of the Prophet Zechariah",
        Malachi: "the Book of the Prophet Malachi",
        Matthew: "the Gospel according to Saint Matthew",
        Mark: "the Gospel according to Saint Mark",
        Luke: "the Gospel according to Saint Luke",
        John: "the Gospel according to Saint John",
        Acts: "the Acts of the Apostles",
        Romans: "the Letter of Saint Paul to the Romans",
        "1 Corinthians": "the First Letter of Saint Paul to the Corinthians",
        "2 Corinthians": "the Second Letter of Saint Paul to the Corinthians",
        Galatians: "the Letter of Saint Paul to the Galatians",
        Ephesians: "the Letter of Saint Paul to the Ephesians",
        Philippians: "the Letter of Saint Paul to the Philippians",
        Colossians: "the Letter of Saint Paul to the Colossians",
        "1 Thessalonians": "the First Letter of Saint Paul to the Thessalonians",
        "2 Thessalonians": "the Second Letter of Saint Paul to the Thessalonians",
        "1 Timothy": "the First Letter of Saint Paul to Timothy",
        "2 Timothy": "the Second Letter of Saint Paul to Timothy",
        Titus: "the Letter of Saint Paul to Titus",
        Philemon: "the Letter of Saint Paul to Philemon",
        Hebrews: "the Letter to the Hebrews",
        James: "the Letter of Saint James",
        "1 Peter": "the First Letter of Saint Peter",
        "2 Peter": "the Second Letter of Saint Peter",
        "1 John": "the First Letter of Saint John",
        "2 John": "the Second Letter of Saint John",
        "3 John": "the Third Letter of Saint John",
        Jude: "the Letter of Saint Jude",
        Revelation: "the Book of Revelation"
    };
    const longName = Object.entries(names).find(([n, _])=>{
        return title.slice(0, n.length) === n;
    })?.[1];
    return longName ?? "the reading";
};
const $2fb31402637fa4d9$var$getOrdinalNumber = (n)=>{
    const base = [
        "zeroth",
        "first",
        "second",
        "third",
        "fourth",
        "fifth",
        "sixth",
        "seventh",
        "eighth",
        "ninth",
        "tenth",
        "eleventh",
        "twelfth",
        "thirteenth",
        "fourteenth",
        "fifteenth",
        "sixteenth",
        "seventeenth",
        "eighteenth",
        "nineteenth"
    ];
    const tens = [
        "twentieth",
        "thirtieth",
        "fortieth",
        "fiftieth",
        "sixtieth",
        "seventieth",
        "eightieth",
        "ninetieth"
    ];
    const tenPlus = [
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety"
    ];
    if (n < 20) return base[n];
    if (n % 10 === 0) return tens[n / 10 - 2];
    return tenPlus[Math.floor(n / 10) - 2] + "-" + base[n % 10];
};
const $2fb31402637fa4d9$export$aaa271f2756a673f = (props)=>{
    const { title: title, content: content, hasBeginneth: hasBeginneth } = props;
    const id = title.replace(/[^A-Za-z]/g, "-");
    const bookName = $2fb31402637fa4d9$var$getBookName(title);
    const chapterRef = parseInt(/ (\d+)/.exec(title)?.[1] ?? "0");
    const verseRef = parseInt(/:(\d+)/.exec(title)?.[1] ?? "1");
    let beginneth = `Here beginneth ${bookName}.`;
    if (verseRef && verseRef > 1 && chapterRef) beginneth = `Here beginneth the ${$2fb31402637fa4d9$var$getOrdinalNumber(verseRef)} verse of the ${$2fb31402637fa4d9$var$getOrdinalNumber(chapterRef)} chapter of ${bookName}.`;
    else if (chapterRef) beginneth = `Here beginneth the ${$2fb31402637fa4d9$var$getOrdinalNumber(chapterRef)} chapter of ${bookName}.`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $982dab2795189e62$export$45a8b3c92b66d3be), {
        id: id,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca62a1dbd14c6d35$export$6ccfe534fa2728ed), {
                id: id,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            backgroundColor: (0, $b5d1360628cd70a0$export$1a6c4fc8d15a2dc7),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                            onlySides: true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontWeight: "bold",
                                    paddingBottom: 12,
                                    paddingTop: 12,
                                    fontSize: (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57)
                                },
                                className: "title",
                                "data-content": title,
                                children: title
                            })
                        })
                    })
                })
            }),
            hasBeginneth ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: beginneth
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: content.map((line, lineIndex)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df21f7e96797500c$export$f1b51ca5b8e2fcc6), {
                        content: line.text,
                        indent: line.indent,
                        dropCap: lineIndex === 0
                    });
                })
            })
        ]
    });
};




parcelRequire("acw62");




const $8cc292920dd8fd1f$export$5404b1d39162d870 = (props)=>{
    const { content: content } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        onlySides: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            },
            className: "rubric",
            "data-content": content,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    paddingLeft: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                    paddingRight: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                    color: (0, $b5d1360628cd70a0$export$516f68680b50dca1),
                    fontWeight: "bold",
                    fontSize: isSmallScreen ? (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57) * 0.9 : (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57),
                    textAlign: "center",
                    flexGrow: 1,
                    paddingTop: 8,
                    paddingBottom: 8
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ead699faf34263db$export$7460c8b7e4ce9582), {
                    children: content.replace(/\\n/g, "  \n").replace(/_/g, "\u00a0")
                })
            })
        })
    });
};






var $6ZWSX = parcelRequire("6ZWSX");

var $be59461d4a783f7b$var$Buffer = (parcelRequire("6ZWSX")).Buffer;
var $be59461d4a783f7b$var$__defProp = Object.defineProperty;
var $be59461d4a783f7b$var$__defProps = Object.defineProperties;
var $be59461d4a783f7b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $be59461d4a783f7b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $be59461d4a783f7b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $be59461d4a783f7b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $be59461d4a783f7b$var$__defNormalProp = (obj, key, value)=>key in obj ? $be59461d4a783f7b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $be59461d4a783f7b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($be59461d4a783f7b$var$__hasOwnProp.call(b, prop)) $be59461d4a783f7b$var$__defNormalProp(a, prop, b[prop]);
    if ($be59461d4a783f7b$var$__getOwnPropSymbols) {
        for (var prop of $be59461d4a783f7b$var$__getOwnPropSymbols(b))if ($be59461d4a783f7b$var$__propIsEnum.call(b, prop)) $be59461d4a783f7b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $be59461d4a783f7b$var$__spreadProps = (a, b)=>$be59461d4a783f7b$var$__defProps(a, $be59461d4a783f7b$var$__getOwnPropDescs(b));
var $be59461d4a783f7b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($be59461d4a783f7b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $be59461d4a783f7b$var$__getOwnPropSymbols) {
        for (var prop of $be59461d4a783f7b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $be59461d4a783f7b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $be59461d4a783f7b$var$__publicField = (obj, key, value)=>$be59461d4a783f7b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $be59461d4a783f7b$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
class $be59461d4a783f7b$export$f1963fc784a1cb56 {
    constructor(rootKey){
        $be59461d4a783f7b$var$__publicField(this, "rootKey");
        this.rootKey = rootKey;
    }
}
const $be59461d4a783f7b$export$253fab909bb52269 = Object.seal({});
class $be59461d4a783f7b$export$19f99b70db82ec96 extends $be59461d4a783f7b$export$f1963fc784a1cb56 {
    constructor(rootKey){
        super(rootKey);
        // eslint-disable-next-line functional/prefer-readonly-type, @typescript-eslint/no-explicit-any
        $be59461d4a783f7b$var$__publicField(this, "root");
        this.root = new Array();
    }
    // This method is called by the formatter to get the XML representation of this component.
    // It is called recursively for all child components.
    // It is a serializer to be used in the xml library.
    // https://www.npmjs.com/package/xml
    // Child components can override this method to customize the XML representation, or execute side effects.
    prepForXml(context) {
        var _a;
        context.stack.push(this);
        const children = this.root.map((comp)=>{
            if (comp instanceof $be59461d4a783f7b$export$f1963fc784a1cb56) return comp.prepForXml(context);
            return comp;
        }).filter((comp)=>comp !== void 0);
        context.stack.pop();
        return {
            [this.rootKey]: children.length ? children.length === 1 && ((_a = children[0]) == null ? void 0 : _a._attr) ? children[0] : children : $be59461d4a783f7b$export$253fab909bb52269
        };
    }
    /**
   * @deprecated Do not use this method. It is only used internally by the library. It will be removed in a future version.
   */ addChildElement(child) {
        this.root.push(child);
        return this;
    }
}
class $be59461d4a783f7b$export$951524d865ce655a extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    prepForXml(context) {
        const result = super.prepForXml(context);
        if (result && (typeof result[this.rootKey] !== "object" || Object.keys(result[this.rootKey]).length)) return result;
        return void 0;
    }
}
class $be59461d4a783f7b$export$d14a6833c537c2d extends $be59461d4a783f7b$export$f1963fc784a1cb56 {
    constructor(root){
        super("_attr");
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys");
        this.root = root;
    }
    prepForXml(_) {
        const attrs = {};
        Object.entries(this.root).forEach(([key, value])=>{
            if (value !== void 0) {
                const newKey = this.xmlKeys && this.xmlKeys[key] || key;
                attrs[newKey] = value;
            }
        });
        return {
            _attr: attrs
        };
    }
}
class $be59461d4a783f7b$export$b95d92bd70e2302a extends $be59461d4a783f7b$export$f1963fc784a1cb56 {
    constructor(root){
        super("_attr");
        this.root = root;
    }
    prepForXml(_) {
        const attrs = Object.values(this.root).filter(({ value: value })=>value !== void 0).reduce((acc, { key: key, value: value })=>$be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, acc), {
                [key]: value
            }), {});
        return {
            _attr: attrs
        };
    }
}
class $be59461d4a783f7b$export$21991851b0bb231f extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val",
            color: "w:color",
            fill: "w:fill",
            space: "w:space",
            sz: "w:sz",
            type: "w:type",
            rsidR: "w:rsidR",
            rsidRPr: "w:rsidRPr",
            rsidSect: "w:rsidSect",
            w: "w:w",
            h: "w:h",
            top: "w:top",
            right: "w:right",
            bottom: "w:bottom",
            left: "w:left",
            header: "w:header",
            footer: "w:footer",
            gutter: "w:gutter",
            linePitch: "w:linePitch",
            pos: "w:pos"
        });
    }
}
var $be59461d4a783f7b$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $be59461d4a783f7b$var$getDefaultExportFromCjs$1(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $be59461d4a783f7b$var$sax = {};
var $be59461d4a783f7b$var$events = {
    exports: {}
};
var $be59461d4a783f7b$var$hasRequiredEvents;
function $be59461d4a783f7b$var$requireEvents() {
    if ($be59461d4a783f7b$var$hasRequiredEvents) return $be59461d4a783f7b$var$events.exports;
    $be59461d4a783f7b$var$hasRequiredEvents = 1;
    var R = typeof Reflect === "object" ? Reflect : null;
    var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
    else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target);
    };
    function ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
        return value !== value;
    };
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    $be59461d4a783f7b$var$events.exports = EventEmitter;
    $be59461d4a783f7b$var$events.exports.once = once;
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.prototype._events = void 0;
    EventEmitter.prototype._eventsCount = 0;
    EventEmitter.prototype._maxListeners = void 0;
    var defaultMaxListeners = 10;
    function checkListener(listener) {
        if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty(EventEmitter, "defaultMaxListeners", {
        enumerable: true,
        get: function() {
            return defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
            defaultMaxListeners = arg;
        }
    });
    EventEmitter.init = function() {
        if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
            this._events = /* @__PURE__ */ Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || void 0;
    };
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
        this._maxListeners = n;
        return this;
    };
    function _getMaxListeners(that) {
        if (that._maxListeners === void 0) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
    };
    EventEmitter.prototype.emit = function emit(type2) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type2 === "error";
        var events2 = this._events;
        if (events2 !== void 0) doError = doError && events2.error === void 0;
        else if (!doError) return false;
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) throw er;
            var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
            err.context = er;
            throw err;
        }
        var handler = events2[type2];
        if (handler === void 0) return false;
        if (typeof handler === "function") ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function _addListener(target, type2, listener, prepend) {
        var m;
        var events2;
        var existing;
        checkListener(listener);
        events2 = target._events;
        if (events2 === void 0) {
            events2 = target._events = /* @__PURE__ */ Object.create(null);
            target._eventsCount = 0;
        } else {
            if (events2.newListener !== void 0) {
                target.emit("newListener", type2, listener.listener ? listener.listener : listener);
                events2 = target._events;
            }
            existing = events2[type2];
        }
        if (existing === void 0) {
            existing = events2[type2] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === "function") existing = events2[type2] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            m = _getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type2) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                w.name = "MaxListenersExceededWarning";
                w.emitter = target;
                w.type = type2;
                w.count = existing.length;
                ProcessEmitWarning(w);
            }
        }
        return target;
    }
    EventEmitter.prototype.addListener = function addListener(type2, listener) {
        return _addListener(this, type2, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type2, listener) {
        return _addListener(this, type2, listener, true);
    };
    function onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function _onceWrap(target, type2, listener) {
        var state2 = {
            fired: false,
            wrapFn: void 0,
            target: target,
            type: type2,
            listener: listener
        };
        var wrapped = onceWrapper.bind(state2);
        wrapped.listener = listener;
        state2.wrapFn = wrapped;
        return wrapped;
    }
    EventEmitter.prototype.once = function once2(type2, listener) {
        checkListener(listener);
        this.on(type2, _onceWrap(this, type2, listener));
        return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type2, listener) {
        checkListener(listener);
        this.prependListener(type2, _onceWrap(this, type2, listener));
        return this;
    };
    EventEmitter.prototype.removeListener = function removeListener(type2, listener) {
        var list, events2, position, i, originalListener;
        checkListener(listener);
        events2 = this._events;
        if (events2 === void 0) return this;
        list = events2[type2];
        if (list === void 0) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = /* @__PURE__ */ Object.create(null);
            else {
                delete events2[type2];
                if (events2.removeListener) this.emit("removeListener", type2, list.listener || listener);
            }
        } else if (typeof list !== "function") {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else spliceOne(list, position);
            if (list.length === 1) events2[type2] = list[0];
            if (events2.removeListener !== void 0) this.emit("removeListener", type2, originalListener || listener);
        }
        return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type2) {
        var listeners, events2, i;
        events2 = this._events;
        if (events2 === void 0) return this;
        if (events2.removeListener === void 0) {
            if (arguments.length === 0) {
                this._events = /* @__PURE__ */ Object.create(null);
                this._eventsCount = 0;
            } else if (events2[type2] !== void 0) {
                if (--this._eventsCount === 0) this._events = /* @__PURE__ */ Object.create(null);
                else delete events2[type2];
            }
            return this;
        }
        if (arguments.length === 0) {
            var keys = Object.keys(events2);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === "removeListener") continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners("removeListener");
            this._events = /* @__PURE__ */ Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events2[type2];
        if (typeof listeners === "function") this.removeListener(type2, listeners);
        else if (listeners !== void 0) for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type2, listeners[i]);
        return this;
    };
    function _listeners(target, type2, unwrap) {
        var events2 = target._events;
        if (events2 === void 0) return [];
        var evlistener = events2[type2];
        if (evlistener === void 0) return [];
        if (typeof evlistener === "function") return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter.prototype.listeners = function listeners(type2) {
        return _listeners(this, type2, true);
    };
    EventEmitter.prototype.rawListeners = function rawListeners(type2) {
        return _listeners(this, type2, false);
    };
    EventEmitter.listenerCount = function(emitter, type2) {
        if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type2);
        else return listenerCount.call(emitter, type2);
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type2) {
        var events2 = this._events;
        if (events2 !== void 0) {
            var evlistener = events2[type2];
            if (typeof evlistener === "function") return 1;
            else if (evlistener !== void 0) return evlistener.length;
        }
        return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
                resolve([].slice.call(arguments));
            }
            eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
    }
    function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === "function") {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === "function") emitter.addEventListener(name, function wrapListener(arg) {
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
    return $be59461d4a783f7b$var$events.exports;
}
var $be59461d4a783f7b$var$inherits_browser = {
    exports: {}
};
var $be59461d4a783f7b$var$hasRequiredInherits_browser;
function $be59461d4a783f7b$var$requireInherits_browser() {
    if ($be59461d4a783f7b$var$hasRequiredInherits_browser) return $be59461d4a783f7b$var$inherits_browser.exports;
    $be59461d4a783f7b$var$hasRequiredInherits_browser = 1;
    if (typeof Object.create === "function") $be59461d4a783f7b$var$inherits_browser.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else $be59461d4a783f7b$var$inherits_browser.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
    return $be59461d4a783f7b$var$inherits_browser.exports;
}
function $be59461d4a783f7b$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $be59461d4a783f7b$var$browser$1 = {
    exports: {}
};
var $be59461d4a783f7b$var$process = $be59461d4a783f7b$var$browser$1.exports = {};
var $be59461d4a783f7b$var$cachedSetTimeout;
var $be59461d4a783f7b$var$cachedClearTimeout;
function $be59461d4a783f7b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $be59461d4a783f7b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $be59461d4a783f7b$var$cachedSetTimeout = setTimeout;
        else $be59461d4a783f7b$var$cachedSetTimeout = $be59461d4a783f7b$var$defaultSetTimout;
    } catch (e) {
        $be59461d4a783f7b$var$cachedSetTimeout = $be59461d4a783f7b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $be59461d4a783f7b$var$cachedClearTimeout = clearTimeout;
        else $be59461d4a783f7b$var$cachedClearTimeout = $be59461d4a783f7b$var$defaultClearTimeout;
    } catch (e) {
        $be59461d4a783f7b$var$cachedClearTimeout = $be59461d4a783f7b$var$defaultClearTimeout;
    }
})();
function $be59461d4a783f7b$var$runTimeout(fun) {
    if ($be59461d4a783f7b$var$cachedSetTimeout === setTimeout) return setTimeout(fun, 0);
    if (($be59461d4a783f7b$var$cachedSetTimeout === $be59461d4a783f7b$var$defaultSetTimout || !$be59461d4a783f7b$var$cachedSetTimeout) && setTimeout) {
        $be59461d4a783f7b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        return $be59461d4a783f7b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            return $be59461d4a783f7b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e2) {
            return $be59461d4a783f7b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $be59461d4a783f7b$var$runClearTimeout(marker) {
    if ($be59461d4a783f7b$var$cachedClearTimeout === clearTimeout) return clearTimeout(marker);
    if (($be59461d4a783f7b$var$cachedClearTimeout === $be59461d4a783f7b$var$defaultClearTimeout || !$be59461d4a783f7b$var$cachedClearTimeout) && clearTimeout) {
        $be59461d4a783f7b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        return $be59461d4a783f7b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            return $be59461d4a783f7b$var$cachedClearTimeout.call(null, marker);
        } catch (e2) {
            return $be59461d4a783f7b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $be59461d4a783f7b$var$queue = [];
var $be59461d4a783f7b$var$draining = false;
var $be59461d4a783f7b$var$currentQueue;
var $be59461d4a783f7b$var$queueIndex = -1;
function $be59461d4a783f7b$var$cleanUpNextTick() {
    if (!$be59461d4a783f7b$var$draining || !$be59461d4a783f7b$var$currentQueue) return;
    $be59461d4a783f7b$var$draining = false;
    if ($be59461d4a783f7b$var$currentQueue.length) $be59461d4a783f7b$var$queue = $be59461d4a783f7b$var$currentQueue.concat($be59461d4a783f7b$var$queue);
    else $be59461d4a783f7b$var$queueIndex = -1;
    if ($be59461d4a783f7b$var$queue.length) $be59461d4a783f7b$var$drainQueue();
}
function $be59461d4a783f7b$var$drainQueue() {
    if ($be59461d4a783f7b$var$draining) return;
    var timeout = $be59461d4a783f7b$var$runTimeout($be59461d4a783f7b$var$cleanUpNextTick);
    $be59461d4a783f7b$var$draining = true;
    var len = $be59461d4a783f7b$var$queue.length;
    while(len){
        $be59461d4a783f7b$var$currentQueue = $be59461d4a783f7b$var$queue;
        $be59461d4a783f7b$var$queue = [];
        while(++$be59461d4a783f7b$var$queueIndex < len)if ($be59461d4a783f7b$var$currentQueue) $be59461d4a783f7b$var$currentQueue[$be59461d4a783f7b$var$queueIndex].run();
        $be59461d4a783f7b$var$queueIndex = -1;
        len = $be59461d4a783f7b$var$queue.length;
    }
    $be59461d4a783f7b$var$currentQueue = null;
    $be59461d4a783f7b$var$draining = false;
    $be59461d4a783f7b$var$runClearTimeout(timeout);
}
$be59461d4a783f7b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $be59461d4a783f7b$var$queue.push(new $be59461d4a783f7b$var$Item(fun, args));
    if ($be59461d4a783f7b$var$queue.length === 1 && !$be59461d4a783f7b$var$draining) $be59461d4a783f7b$var$runTimeout($be59461d4a783f7b$var$drainQueue);
};
function $be59461d4a783f7b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$be59461d4a783f7b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$be59461d4a783f7b$var$process.title = "browser";
$be59461d4a783f7b$var$process.browser = true;
$be59461d4a783f7b$var$process.env = {};
$be59461d4a783f7b$var$process.argv = [];
$be59461d4a783f7b$var$process.version = "";
$be59461d4a783f7b$var$process.versions = {};
function $be59461d4a783f7b$var$noop() {}
$be59461d4a783f7b$var$process.on = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.addListener = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.once = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.off = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.removeListener = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.removeAllListeners = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.emit = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.prependListener = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.prependOnceListener = $be59461d4a783f7b$var$noop;
$be59461d4a783f7b$var$process.listeners = function(name) {
    return [];
};
$be59461d4a783f7b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$be59461d4a783f7b$var$process.cwd = function() {
    return "/";
};
$be59461d4a783f7b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$be59461d4a783f7b$var$process.umask = function() {
    return 0;
};
var $be59461d4a783f7b$var$browserExports = $be59461d4a783f7b$var$browser$1.exports;
const $be59461d4a783f7b$var$process$1 = /* @__PURE__ */ $be59461d4a783f7b$var$getDefaultExportFromCjs($be59461d4a783f7b$var$browserExports);
var $be59461d4a783f7b$var$streamBrowser;
var $be59461d4a783f7b$var$hasRequiredStreamBrowser;
function $be59461d4a783f7b$var$requireStreamBrowser() {
    if ($be59461d4a783f7b$var$hasRequiredStreamBrowser) return $be59461d4a783f7b$var$streamBrowser;
    $be59461d4a783f7b$var$hasRequiredStreamBrowser = 1;
    $be59461d4a783f7b$var$streamBrowser = $be59461d4a783f7b$var$requireEvents().EventEmitter;
    return $be59461d4a783f7b$var$streamBrowser;
}
var $be59461d4a783f7b$var$buffer = {};
var $be59461d4a783f7b$var$base64Js = {};
var $be59461d4a783f7b$var$hasRequiredBase64Js;
function $be59461d4a783f7b$var$requireBase64Js() {
    if ($be59461d4a783f7b$var$hasRequiredBase64Js) return $be59461d4a783f7b$var$base64Js;
    $be59461d4a783f7b$var$hasRequiredBase64Js = 1;
    $be59461d4a783f7b$var$base64Js.byteLength = byteLength;
    $be59461d4a783f7b$var$base64Js.toByteArray = toByteArray;
    $be59461d4a783f7b$var$base64Js.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    }
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
        var len2 = b64.length;
        if (len2 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var validLen = b64.indexOf("=");
        if (validLen === -1) validLen = len2;
        var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
        return [
            validLen,
            placeHoldersLen
        ];
    }
    function byteLength(b64) {
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
        var tmp;
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
        var curByte = 0;
        var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
        var i2;
        for(i2 = 0; i2 < len2; i2 += 4){
            tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
            arr[curByte++] = tmp >> 16 & 255;
            arr[curByte++] = tmp >> 8 & 255;
            arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 2) {
            tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
            arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 1) {
            tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
            arr[curByte++] = tmp >> 8 & 255;
            arr[curByte++] = tmp & 255;
        }
        return arr;
    }
    function tripletToBase64(num) {
        return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start, end) {
        var tmp;
        var output = [];
        for(var i2 = start; i2 < end; i2 += 3){
            tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
            output.push(tripletToBase64(tmp));
        }
        return output.join("");
    }
    function fromByteArray(uint8) {
        var tmp;
        var len2 = uint8.length;
        var extraBytes = len2 % 3;
        var parts = [];
        var maxChunkLength = 16383;
        for(var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength)parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
        if (extraBytes === 1) {
            tmp = uint8[len2 - 1];
            parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
        } else if (extraBytes === 2) {
            tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
            parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
        }
        return parts.join("");
    }
    return $be59461d4a783f7b$var$base64Js;
}
var $be59461d4a783f7b$var$ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $be59461d4a783f7b$var$hasRequiredIeee754;
function $be59461d4a783f7b$var$requireIeee754() {
    if ($be59461d4a783f7b$var$hasRequiredIeee754) return $be59461d4a783f7b$var$ieee754;
    $be59461d4a783f7b$var$hasRequiredIeee754 = 1;
    $be59461d4a783f7b$var$ieee754.read = function(buffer2, offset, isLE, mLen, nBytes) {
        var e, m;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = -7;
        var i = isLE ? nBytes - 1 : 0;
        var d = isLE ? -1 : 1;
        var s = buffer2[offset + i];
        i += d;
        e = s & (1 << -nBits) - 1;
        s >>= -nBits;
        nBits += eLen;
        for(; nBits > 0; e = e * 256 + buffer2[offset + i], i += d, nBits -= 8);
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for(; nBits > 0; m = m * 256 + buffer2[offset + i], i += d, nBits -= 8);
        if (e === 0) e = 1 - eBias;
        else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
        else {
            m = m + Math.pow(2, mLen);
            e = e - eBias;
        }
        return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    $be59461d4a783f7b$var$ieee754.write = function(buffer2, value, offset, isLE, mLen, nBytes) {
        var e, m, c;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
        var i = isLE ? 0 : nBytes - 1;
        var d = isLE ? 1 : -1;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        value = Math.abs(value);
        if (isNaN(value) || value === Infinity) {
            m = isNaN(value) ? 1 : 0;
            e = eMax;
        } else {
            e = Math.floor(Math.log(value) / Math.LN2);
            if (value * (c = Math.pow(2, -e)) < 1) {
                e--;
                c *= 2;
            }
            if (e + eBias >= 1) value += rt / c;
            else value += rt * Math.pow(2, 1 - eBias);
            if (value * c >= 2) {
                e++;
                c /= 2;
            }
            if (e + eBias >= eMax) {
                m = 0;
                e = eMax;
            } else if (e + eBias >= 1) {
                m = (value * c - 1) * Math.pow(2, mLen);
                e = e + eBias;
            } else {
                m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                e = 0;
            }
        }
        for(; mLen >= 8; buffer2[offset + i] = m & 255, i += d, m /= 256, mLen -= 8);
        e = e << mLen | m;
        eLen += mLen;
        for(; eLen > 0; buffer2[offset + i] = e & 255, i += d, e /= 256, eLen -= 8);
        buffer2[offset + i - d] |= s * 128;
    };
    return $be59461d4a783f7b$var$ieee754;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ var $be59461d4a783f7b$var$hasRequiredBuffer;
function $be59461d4a783f7b$var$requireBuffer() {
    if ($be59461d4a783f7b$var$hasRequiredBuffer) return $be59461d4a783f7b$var$buffer;
    $be59461d4a783f7b$var$hasRequiredBuffer = 1;
    (function(exports) {
        var base64 = $be59461d4a783f7b$var$requireBase64Js();
        var ieee7542 = $be59461d4a783f7b$var$requireIeee754();
        var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
        exports.Buffer = Buffer2;
        exports.SlowBuffer = SlowBuffer;
        exports.INSPECT_MAX_BYTES = 50;
        var K_MAX_LENGTH = 2147483647;
        exports.kMaxLength = K_MAX_LENGTH;
        Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
        if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
        function typedArraySupport() {
            try {
                var arr = new Uint8Array(1);
                var proto = {
                    foo: function() {
                        return 42;
                    }
                };
                Object.setPrototypeOf(proto, Uint8Array.prototype);
                Object.setPrototypeOf(arr, proto);
                return arr.foo() === 42;
            } catch (e) {
                return false;
            }
        }
        Object.defineProperty(Buffer2.prototype, "parent", {
            enumerable: true,
            get: function() {
                if (!Buffer2.isBuffer(this)) return void 0;
                return this.buffer;
            }
        });
        Object.defineProperty(Buffer2.prototype, "offset", {
            enumerable: true,
            get: function() {
                if (!Buffer2.isBuffer(this)) return void 0;
                return this.byteOffset;
            }
        });
        function createBuffer(length) {
            if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
            var buf = new Uint8Array(length);
            Object.setPrototypeOf(buf, Buffer2.prototype);
            return buf;
        }
        function Buffer2(arg, encodingOrOffset, length) {
            if (typeof arg === "number") {
                if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                return allocUnsafe(arg);
            }
            return from(arg, encodingOrOffset, length);
        }
        Buffer2.poolSize = 8192;
        function from(value, encodingOrOffset, length) {
            if (typeof value === "string") return fromString(value, encodingOrOffset);
            if (ArrayBuffer.isView(value)) return fromArrayView(value);
            if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
            if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
            if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
            if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
            var valueOf = value.valueOf && value.valueOf();
            if (valueOf != null && valueOf !== value) return Buffer2.from(valueOf, encodingOrOffset, length);
            var b = fromObject(value);
            if (b) return b;
            if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        }
        Buffer2.from = function(value, encodingOrOffset, length) {
            return from(value, encodingOrOffset, length);
        };
        Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
        Object.setPrototypeOf(Buffer2, Uint8Array);
        function assertSize(size) {
            if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
            else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
        }
        function alloc(size, fill, encoding) {
            assertSize(size);
            if (size <= 0) return createBuffer(size);
            if (fill !== void 0) return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
            return createBuffer(size);
        }
        Buffer2.alloc = function(size, fill, encoding) {
            return alloc(size, fill, encoding);
        };
        function allocUnsafe(size) {
            assertSize(size);
            return createBuffer(size < 0 ? 0 : checked(size) | 0);
        }
        Buffer2.allocUnsafe = function(size) {
            return allocUnsafe(size);
        };
        Buffer2.allocUnsafeSlow = function(size) {
            return allocUnsafe(size);
        };
        function fromString(string, encoding) {
            if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
            if (!Buffer2.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
            var length = byteLength(string, encoding) | 0;
            var buf = createBuffer(length);
            var actual = buf.write(string, encoding);
            if (actual !== length) buf = buf.slice(0, actual);
            return buf;
        }
        function fromArrayLike(array) {
            var length = array.length < 0 ? 0 : checked(array.length) | 0;
            var buf = createBuffer(length);
            for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
            return buf;
        }
        function fromArrayView(arrayView) {
            if (isInstance(arrayView, Uint8Array)) {
                var copy = new Uint8Array(arrayView);
                return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
            }
            return fromArrayLike(arrayView);
        }
        function fromArrayBuffer(array, byteOffset, length) {
            if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
            if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var buf;
            if (byteOffset === void 0 && length === void 0) buf = new Uint8Array(array);
            else if (length === void 0) buf = new Uint8Array(array, byteOffset);
            else buf = new Uint8Array(array, byteOffset, length);
            Object.setPrototypeOf(buf, Buffer2.prototype);
            return buf;
        }
        function fromObject(obj) {
            if (Buffer2.isBuffer(obj)) {
                var len = checked(obj.length) | 0;
                var buf = createBuffer(len);
                if (buf.length === 0) return buf;
                obj.copy(buf, 0, 0, len);
                return buf;
            }
            if (obj.length !== void 0) {
                if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
                return fromArrayLike(obj);
            }
            if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
        }
        function checked(length) {
            if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
            return length | 0;
        }
        function SlowBuffer(length) {
            if (+length != length) length = 0;
            return Buffer2.alloc(+length);
        }
        Buffer2.isBuffer = function isBuffer(b) {
            return b != null && b._isBuffer === true && b !== Buffer2.prototype;
        };
        Buffer2.compare = function compare(a, b) {
            if (isInstance(a, Uint8Array)) a = Buffer2.from(a, a.offset, a.byteLength);
            if (isInstance(b, Uint8Array)) b = Buffer2.from(b, b.offset, b.byteLength);
            if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (a === b) return 0;
            var x = a.length;
            var y = b.length;
            for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                x = a[i];
                y = b[i];
                break;
            }
            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
        };
        Buffer2.isEncoding = function isEncoding(encoding) {
            switch(String(encoding).toLowerCase()){
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return true;
                default:
                    return false;
            }
        };
        Buffer2.concat = function concat(list, length) {
            if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (list.length === 0) return Buffer2.alloc(0);
            var i;
            if (length === void 0) {
                length = 0;
                for(i = 0; i < list.length; ++i)length += list[i].length;
            }
            var buffer2 = Buffer2.allocUnsafe(length);
            var pos = 0;
            for(i = 0; i < list.length; ++i){
                var buf = list[i];
                if (isInstance(buf, Uint8Array)) {
                    if (pos + buf.length > buffer2.length) Buffer2.from(buf).copy(buffer2, pos);
                    else Uint8Array.prototype.set.call(buffer2, buf, pos);
                } else if (!Buffer2.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                else buf.copy(buffer2, pos);
                pos += buf.length;
            }
            return buffer2;
        };
        function byteLength(string, encoding) {
            if (Buffer2.isBuffer(string)) return string.length;
            if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
            if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
            var len = string.length;
            var mustMatch = arguments.length > 2 && arguments[2] === true;
            if (!mustMatch && len === 0) return 0;
            var loweredCase = false;
            for(;;)switch(encoding){
                case "ascii":
                case "latin1":
                case "binary":
                    return len;
                case "utf8":
                case "utf-8":
                    return utf8ToBytes(string).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return len * 2;
                case "hex":
                    return len >>> 1;
                case "base64":
                    return base64ToBytes(string).length;
                default:
                    if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length;
                    encoding = ("" + encoding).toLowerCase();
                    loweredCase = true;
            }
        }
        Buffer2.byteLength = byteLength;
        function slowToString(encoding, start, end) {
            var loweredCase = false;
            if (start === void 0 || start < 0) start = 0;
            if (start > this.length) return "";
            if (end === void 0 || end > this.length) end = this.length;
            if (end <= 0) return "";
            end >>>= 0;
            start >>>= 0;
            if (end <= start) return "";
            if (!encoding) encoding = "utf8";
            while(true)switch(encoding){
                case "hex":
                    return hexSlice(this, start, end);
                case "utf8":
                case "utf-8":
                    return utf8Slice(this, start, end);
                case "ascii":
                    return asciiSlice(this, start, end);
                case "latin1":
                case "binary":
                    return latin1Slice(this, start, end);
                case "base64":
                    return base64Slice(this, start, end);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return utf16leSlice(this, start, end);
                default:
                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                    encoding = (encoding + "").toLowerCase();
                    loweredCase = true;
            }
        }
        Buffer2.prototype._isBuffer = true;
        function swap(b, n, m) {
            var i = b[n];
            b[n] = b[m];
            b[m] = i;
        }
        Buffer2.prototype.swap16 = function swap16() {
            var len = this.length;
            if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
            return this;
        };
        Buffer2.prototype.swap32 = function swap32() {
            var len = this.length;
            if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for(var i = 0; i < len; i += 4){
                swap(this, i, i + 3);
                swap(this, i + 1, i + 2);
            }
            return this;
        };
        Buffer2.prototype.swap64 = function swap64() {
            var len = this.length;
            if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for(var i = 0; i < len; i += 8){
                swap(this, i, i + 7);
                swap(this, i + 1, i + 6);
                swap(this, i + 2, i + 5);
                swap(this, i + 3, i + 4);
            }
            return this;
        };
        Buffer2.prototype.toString = function toString() {
            var length = this.length;
            if (length === 0) return "";
            if (arguments.length === 0) return utf8Slice(this, 0, length);
            return slowToString.apply(this, arguments);
        };
        Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
        Buffer2.prototype.equals = function equals(b) {
            if (!Buffer2.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
            if (this === b) return true;
            return Buffer2.compare(this, b) === 0;
        };
        Buffer2.prototype.inspect = function inspect() {
            var str = "";
            var max2 = exports.INSPECT_MAX_BYTES;
            str = this.toString("hex", 0, max2).replace(/(.{2})/g, "$1 ").trim();
            if (this.length > max2) str += " ... ";
            return "<Buffer " + str + ">";
        };
        if (customInspectSymbol) Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
        Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
            if (isInstance(target, Uint8Array)) target = Buffer2.from(target, target.offset, target.byteLength);
            if (!Buffer2.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
            if (start === void 0) start = 0;
            if (end === void 0) end = target ? target.length : 0;
            if (thisStart === void 0) thisStart = 0;
            if (thisEnd === void 0) thisEnd = this.length;
            if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
            if (thisStart >= thisEnd && start >= end) return 0;
            if (thisStart >= thisEnd) return -1;
            if (start >= end) return 1;
            start >>>= 0;
            end >>>= 0;
            thisStart >>>= 0;
            thisEnd >>>= 0;
            if (this === target) return 0;
            var x = thisEnd - thisStart;
            var y = end - start;
            var len = Math.min(x, y);
            var thisCopy = this.slice(thisStart, thisEnd);
            var targetCopy = target.slice(start, end);
            for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                x = thisCopy[i];
                y = targetCopy[i];
                break;
            }
            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
        };
        function bidirectionalIndexOf(buffer2, val, byteOffset, encoding, dir) {
            if (buffer2.length === 0) return -1;
            if (typeof byteOffset === "string") {
                encoding = byteOffset;
                byteOffset = 0;
            } else if (byteOffset > 2147483647) byteOffset = 2147483647;
            else if (byteOffset < -2147483648) byteOffset = -2147483648;
            byteOffset = +byteOffset;
            if (numberIsNaN(byteOffset)) byteOffset = dir ? 0 : buffer2.length - 1;
            if (byteOffset < 0) byteOffset = buffer2.length + byteOffset;
            if (byteOffset >= buffer2.length) {
                if (dir) return -1;
                else byteOffset = buffer2.length - 1;
            } else if (byteOffset < 0) {
                if (dir) byteOffset = 0;
                else return -1;
            }
            if (typeof val === "string") val = Buffer2.from(val, encoding);
            if (Buffer2.isBuffer(val)) {
                if (val.length === 0) return -1;
                return arrayIndexOf(buffer2, val, byteOffset, encoding, dir);
            } else if (typeof val === "number") {
                val = val & 255;
                if (typeof Uint8Array.prototype.indexOf === "function") {
                    if (dir) return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
                    else return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
                }
                return arrayIndexOf(buffer2, [
                    val
                ], byteOffset, encoding, dir);
            }
            throw new TypeError("val must be string, number or Buffer");
        }
        function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
            var indexSize = 1;
            var arrLength = arr.length;
            var valLength = val.length;
            if (encoding !== void 0) {
                encoding = String(encoding).toLowerCase();
                if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                    if (arr.length < 2 || val.length < 2) return -1;
                    indexSize = 2;
                    arrLength /= 2;
                    valLength /= 2;
                    byteOffset /= 2;
                }
            }
            function read(buf, i2) {
                if (indexSize === 1) return buf[i2];
                else return buf.readUInt16BE(i2 * indexSize);
            }
            var i;
            if (dir) {
                var foundIndex = -1;
                for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                    if (foundIndex === -1) foundIndex = i;
                    if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                } else {
                    if (foundIndex !== -1) i -= i - foundIndex;
                    foundIndex = -1;
                }
            } else {
                if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                for(i = byteOffset; i >= 0; i--){
                    var found = true;
                    for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                        found = false;
                        break;
                    }
                    if (found) return i;
                }
            }
            return -1;
        }
        Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
            return this.indexOf(val, byteOffset, encoding) !== -1;
        };
        Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
        };
        Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
        };
        function hexWrite(buf, string, offset, length) {
            offset = Number(offset) || 0;
            var remaining = buf.length - offset;
            if (!length) length = remaining;
            else {
                length = Number(length);
                if (length > remaining) length = remaining;
            }
            var strLen = string.length;
            if (length > strLen / 2) length = strLen / 2;
            for(var i = 0; i < length; ++i){
                var parsed = parseInt(string.substr(i * 2, 2), 16);
                if (numberIsNaN(parsed)) return i;
                buf[offset + i] = parsed;
            }
            return i;
        }
        function utf8Write(buf, string, offset, length) {
            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
        }
        function asciiWrite(buf, string, offset, length) {
            return blitBuffer(asciiToBytes(string), buf, offset, length);
        }
        function base64Write(buf, string, offset, length) {
            return blitBuffer(base64ToBytes(string), buf, offset, length);
        }
        function ucs2Write(buf, string, offset, length) {
            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
        }
        Buffer2.prototype.write = function write(string, offset, length, encoding) {
            if (offset === void 0) {
                encoding = "utf8";
                length = this.length;
                offset = 0;
            } else if (length === void 0 && typeof offset === "string") {
                encoding = offset;
                length = this.length;
                offset = 0;
            } else if (isFinite(offset)) {
                offset = offset >>> 0;
                if (isFinite(length)) {
                    length = length >>> 0;
                    if (encoding === void 0) encoding = "utf8";
                } else {
                    encoding = length;
                    length = void 0;
                }
            } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            var remaining = this.length - offset;
            if (length === void 0 || length > remaining) length = remaining;
            if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            if (!encoding) encoding = "utf8";
            var loweredCase = false;
            for(;;)switch(encoding){
                case "hex":
                    return hexWrite(this, string, offset, length);
                case "utf8":
                case "utf-8":
                    return utf8Write(this, string, offset, length);
                case "ascii":
                case "latin1":
                case "binary":
                    return asciiWrite(this, string, offset, length);
                case "base64":
                    return base64Write(this, string, offset, length);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return ucs2Write(this, string, offset, length);
                default:
                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                    encoding = ("" + encoding).toLowerCase();
                    loweredCase = true;
            }
        };
        Buffer2.prototype.toJSON = function toJSON() {
            return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
            };
        };
        function base64Slice(buf, start, end) {
            if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
            else return base64.fromByteArray(buf.slice(start, end));
        }
        function utf8Slice(buf, start, end) {
            end = Math.min(buf.length, end);
            var res = [];
            var i = start;
            while(i < end){
                var firstByte = buf[i];
                var codePoint = null;
                var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
                if (i + bytesPerSequence <= end) {
                    var secondByte, thirdByte, fourthByte, tempCodePoint;
                    switch(bytesPerSequence){
                        case 1:
                            if (firstByte < 128) codePoint = firstByte;
                            break;
                        case 2:
                            secondByte = buf[i + 1];
                            if ((secondByte & 192) === 128) {
                                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                                if (tempCodePoint > 127) codePoint = tempCodePoint;
                            }
                            break;
                        case 3:
                            secondByte = buf[i + 1];
                            thirdByte = buf[i + 2];
                            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) codePoint = tempCodePoint;
                            }
                            break;
                        case 4:
                            secondByte = buf[i + 1];
                            thirdByte = buf[i + 2];
                            fourthByte = buf[i + 3];
                            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                                if (tempCodePoint > 65535 && tempCodePoint < 1114112) codePoint = tempCodePoint;
                            }
                    }
                }
                if (codePoint === null) {
                    codePoint = 65533;
                    bytesPerSequence = 1;
                } else if (codePoint > 65535) {
                    codePoint -= 65536;
                    res.push(codePoint >>> 10 & 1023 | 55296);
                    codePoint = 56320 | codePoint & 1023;
                }
                res.push(codePoint);
                i += bytesPerSequence;
            }
            return decodeCodePointsArray(res);
        }
        var MAX_ARGUMENTS_LENGTH = 4096;
        function decodeCodePointsArray(codePoints) {
            var len = codePoints.length;
            if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints);
            var res = "";
            var i = 0;
            while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
            return res;
        }
        function asciiSlice(buf, start, end) {
            var ret = "";
            end = Math.min(buf.length, end);
            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 127);
            return ret;
        }
        function latin1Slice(buf, start, end) {
            var ret = "";
            end = Math.min(buf.length, end);
            for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
            return ret;
        }
        function hexSlice(buf, start, end) {
            var len = buf.length;
            if (!start || start < 0) start = 0;
            if (!end || end < 0 || end > len) end = len;
            var out = "";
            for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
            return out;
        }
        function utf16leSlice(buf, start, end) {
            var bytes = buf.slice(start, end);
            var res = "";
            for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
            return res;
        }
        Buffer2.prototype.slice = function slice(start, end) {
            var len = this.length;
            start = ~~start;
            end = end === void 0 ? len : ~~end;
            if (start < 0) {
                start += len;
                if (start < 0) start = 0;
            } else if (start > len) start = len;
            if (end < 0) {
                end += len;
                if (end < 0) end = 0;
            } else if (end > len) end = len;
            if (end < start) end = start;
            var newBuf = this.subarray(start, end);
            Object.setPrototypeOf(newBuf, Buffer2.prototype);
            return newBuf;
        };
        function checkOffset(offset, ext, length) {
            if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
            if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
        }
        Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) checkOffset(offset, byteLength2, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;
            while(++i < byteLength2 && (mul *= 256))val += this[offset + i] * mul;
            return val;
        };
        Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) checkOffset(offset, byteLength2, this.length);
            var val = this[offset + --byteLength2];
            var mul = 1;
            while(byteLength2 > 0 && (mul *= 256))val += this[offset + --byteLength2] * mul;
            return val;
        };
        Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 1, this.length);
            return this[offset];
        };
        Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] | this[offset + 1] << 8;
        };
        Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] << 8 | this[offset + 1];
        };
        Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
        };
        Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
        };
        Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) checkOffset(offset, byteLength2, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;
            while(++i < byteLength2 && (mul *= 256))val += this[offset + i] * mul;
            mul *= 128;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
            return val;
        };
        Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) checkOffset(offset, byteLength2, this.length);
            var i = byteLength2;
            var mul = 1;
            var val = this[offset + --i];
            while(i > 0 && (mul *= 256))val += this[offset + --i] * mul;
            mul *= 128;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
            return val;
        };
        Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 1, this.length);
            if (!(this[offset] & 128)) return this[offset];
            return (255 - this[offset] + 1) * -1;
        };
        Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset] | this[offset + 1] << 8;
            return val & 32768 ? val | 4294901760 : val;
        };
        Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset + 1] | this[offset] << 8;
            return val & 32768 ? val | 4294901760 : val;
        };
        Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
        };
        Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
        };
        Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee7542.read(this, offset, true, 23, 4);
        };
        Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee7542.read(this, offset, false, 23, 4);
        };
        Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee7542.read(this, offset, true, 52, 8);
        };
        Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee7542.read(this, offset, false, 52, 8);
        };
        function checkInt(buf, value, offset, ext, max2, min2) {
            if (!Buffer2.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (value > max2 || value < min2) throw new RangeError('"value" argument is out of bounds');
            if (offset + ext > buf.length) throw new RangeError("Index out of range");
        }
        Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
            value = +value;
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) {
                var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
                checkInt(this, value, offset, byteLength2, maxBytes, 0);
            }
            var mul = 1;
            var i = 0;
            this[offset] = value & 255;
            while(++i < byteLength2 && (mul *= 256))this[offset + i] = value / mul & 255;
            return offset + byteLength2;
        };
        Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
            value = +value;
            offset = offset >>> 0;
            byteLength2 = byteLength2 >>> 0;
            if (!noAssert) {
                var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
                checkInt(this, value, offset, byteLength2, maxBytes, 0);
            }
            var i = byteLength2 - 1;
            var mul = 1;
            this[offset + i] = value & 255;
            while(--i >= 0 && (mul *= 256))this[offset + i] = value / mul & 255;
            return offset + byteLength2;
        };
        Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
            this[offset] = value & 255;
            return offset + 1;
        };
        Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
            this[offset] = value & 255;
            this[offset + 1] = value >>> 8;
            return offset + 2;
        };
        Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
            this[offset] = value >>> 8;
            this[offset + 1] = value & 255;
            return offset + 2;
        };
        Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
            this[offset + 3] = value >>> 24;
            this[offset + 2] = value >>> 16;
            this[offset + 1] = value >>> 8;
            this[offset] = value & 255;
            return offset + 4;
        };
        Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 255;
            return offset + 4;
        };
        Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
                var limit = Math.pow(2, 8 * byteLength2 - 1);
                checkInt(this, value, offset, byteLength2, limit - 1, -limit);
            }
            var i = 0;
            var mul = 1;
            var sub = 0;
            this[offset] = value & 255;
            while(++i < byteLength2 && (mul *= 256)){
                if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                this[offset + i] = (value / mul >> 0) - sub & 255;
            }
            return offset + byteLength2;
        };
        Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
                var limit = Math.pow(2, 8 * byteLength2 - 1);
                checkInt(this, value, offset, byteLength2, limit - 1, -limit);
            }
            var i = byteLength2 - 1;
            var mul = 1;
            var sub = 0;
            this[offset + i] = value & 255;
            while(--i >= 0 && (mul *= 256)){
                if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                this[offset + i] = (value / mul >> 0) - sub & 255;
            }
            return offset + byteLength2;
        };
        Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
            if (value < 0) value = 255 + value + 1;
            this[offset] = value & 255;
            return offset + 1;
        };
        Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
            this[offset] = value & 255;
            this[offset + 1] = value >>> 8;
            return offset + 2;
        };
        Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
            this[offset] = value >>> 8;
            this[offset + 1] = value & 255;
            return offset + 2;
        };
        Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
            this[offset] = value & 255;
            this[offset + 1] = value >>> 8;
            this[offset + 2] = value >>> 16;
            this[offset + 3] = value >>> 24;
            return offset + 4;
        };
        Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
            if (value < 0) value = 4294967295 + value + 1;
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 255;
            return offset + 4;
        };
        function checkIEEE754(buf, value, offset, ext, max2, min2) {
            if (offset + ext > buf.length) throw new RangeError("Index out of range");
            if (offset < 0) throw new RangeError("Index out of range");
        }
        function writeFloat(buf, value, offset, littleEndian, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkIEEE754(buf, value, offset, 4);
            ieee7542.write(buf, value, offset, littleEndian, 23, 4);
            return offset + 4;
        }
        Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
            return writeFloat(this, value, offset, true, noAssert);
        };
        Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
            return writeFloat(this, value, offset, false, noAssert);
        };
        function writeDouble(buf, value, offset, littleEndian, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkIEEE754(buf, value, offset, 8);
            ieee7542.write(buf, value, offset, littleEndian, 52, 8);
            return offset + 8;
        }
        Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
            return writeDouble(this, value, offset, true, noAssert);
        };
        Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
            return writeDouble(this, value, offset, false, noAssert);
        };
        Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
            if (!Buffer2.isBuffer(target)) throw new TypeError("argument should be a Buffer");
            if (!start) start = 0;
            if (!end && end !== 0) end = this.length;
            if (targetStart >= target.length) targetStart = target.length;
            if (!targetStart) targetStart = 0;
            if (end > 0 && end < start) end = start;
            if (end === start) return 0;
            if (target.length === 0 || this.length === 0) return 0;
            if (targetStart < 0) throw new RangeError("targetStart out of bounds");
            if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
            if (end < 0) throw new RangeError("sourceEnd out of bounds");
            if (end > this.length) end = this.length;
            if (target.length - targetStart < end - start) end = target.length - targetStart + start;
            var len = end - start;
            if (this === target && typeof Uint8Array.prototype.copyWithin === "function") this.copyWithin(targetStart, start, end);
            else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
            return len;
        };
        Buffer2.prototype.fill = function fill(val, start, end, encoding) {
            if (typeof val === "string") {
                if (typeof start === "string") {
                    encoding = start;
                    start = 0;
                    end = this.length;
                } else if (typeof end === "string") {
                    encoding = end;
                    end = this.length;
                }
                if (encoding !== void 0 && typeof encoding !== "string") throw new TypeError("encoding must be a string");
                if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                if (val.length === 1) {
                    var code = val.charCodeAt(0);
                    if (encoding === "utf8" && code < 128 || encoding === "latin1") val = code;
                }
            } else if (typeof val === "number") val = val & 255;
            else if (typeof val === "boolean") val = Number(val);
            if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
            if (end <= start) return this;
            start = start >>> 0;
            end = end === void 0 ? this.length : end >>> 0;
            if (!val) val = 0;
            var i;
            if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
            else {
                var bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
                var len = bytes.length;
                if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
            }
            return this;
        };
        var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
        function base64clean(str) {
            str = str.split("=")[0];
            str = str.trim().replace(INVALID_BASE64_RE, "");
            if (str.length < 2) return "";
            while(str.length % 4 !== 0)str = str + "=";
            return str;
        }
        function utf8ToBytes(string, units) {
            units = units || Infinity;
            var codePoint;
            var length = string.length;
            var leadSurrogate = null;
            var bytes = [];
            for(var i = 0; i < length; ++i){
                codePoint = string.charCodeAt(i);
                if (codePoint > 55295 && codePoint < 57344) {
                    if (!leadSurrogate) {
                        if (codePoint > 56319) {
                            if ((units -= 3) > -1) bytes.push(239, 191, 189);
                            continue;
                        } else if (i + 1 === length) {
                            if ((units -= 3) > -1) bytes.push(239, 191, 189);
                            continue;
                        }
                        leadSurrogate = codePoint;
                        continue;
                    }
                    if (codePoint < 56320) {
                        if ((units -= 3) > -1) bytes.push(239, 191, 189);
                        leadSurrogate = codePoint;
                        continue;
                    }
                    codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
                } else if (leadSurrogate) {
                    if ((units -= 3) > -1) bytes.push(239, 191, 189);
                }
                leadSurrogate = null;
                if (codePoint < 128) {
                    if ((units -= 1) < 0) break;
                    bytes.push(codePoint);
                } else if (codePoint < 2048) {
                    if ((units -= 2) < 0) break;
                    bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
                } else if (codePoint < 65536) {
                    if ((units -= 3) < 0) break;
                    bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
                } else if (codePoint < 1114112) {
                    if ((units -= 4) < 0) break;
                    bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
                } else throw new Error("Invalid code point");
            }
            return bytes;
        }
        function asciiToBytes(str) {
            var byteArray = [];
            for(var i = 0; i < str.length; ++i)byteArray.push(str.charCodeAt(i) & 255);
            return byteArray;
        }
        function utf16leToBytes(str, units) {
            var c, hi, lo;
            var byteArray = [];
            for(var i = 0; i < str.length; ++i){
                if ((units -= 2) < 0) break;
                c = str.charCodeAt(i);
                hi = c >> 8;
                lo = c % 256;
                byteArray.push(lo);
                byteArray.push(hi);
            }
            return byteArray;
        }
        function base64ToBytes(str) {
            return base64.toByteArray(base64clean(str));
        }
        function blitBuffer(src, dst, offset, length) {
            for(var i = 0; i < length; ++i){
                if (i + offset >= dst.length || i >= src.length) break;
                dst[i + offset] = src[i];
            }
            return i;
        }
        function isInstance(obj, type2) {
            return obj instanceof type2 || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type2.name;
        }
        function numberIsNaN(obj) {
            return obj !== obj;
        }
        var hexSliceLookupTable = function() {
            var alphabet = "0123456789abcdef";
            var table = new Array(256);
            for(var i = 0; i < 16; ++i){
                var i16 = i * 16;
                for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
            }
            return table;
        }();
    })($be59461d4a783f7b$var$buffer);
    return $be59461d4a783f7b$var$buffer;
}
var $be59461d4a783f7b$var$util = {};
var $be59461d4a783f7b$var$types = {};
var $be59461d4a783f7b$var$shams$1;
var $be59461d4a783f7b$var$hasRequiredShams$1;
function $be59461d4a783f7b$var$requireShams$1() {
    if ($be59461d4a783f7b$var$hasRequiredShams$1) return $be59461d4a783f7b$var$shams$1;
    $be59461d4a783f7b$var$hasRequiredShams$1 = 1;
    $be59461d4a783f7b$var$shams$1 = function hasSymbols2() {
        if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
        if (typeof Symbol.iterator === "symbol") return true;
        var obj = {};
        var sym = Symbol("test");
        var symObj = Object(sym);
        if (typeof sym === "string") return false;
        if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
        if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
        var symVal = 42;
        obj[sym] = symVal;
        for(var _ in obj)return false;
        if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
        if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
        var syms = Object.getOwnPropertySymbols(obj);
        if (syms.length !== 1 || syms[0] !== sym) return false;
        if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
        if (typeof Object.getOwnPropertyDescriptor === "function") {
            var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
            if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
        }
        return true;
    };
    return $be59461d4a783f7b$var$shams$1;
}
var $be59461d4a783f7b$var$shams;
var $be59461d4a783f7b$var$hasRequiredShams;
function $be59461d4a783f7b$var$requireShams() {
    if ($be59461d4a783f7b$var$hasRequiredShams) return $be59461d4a783f7b$var$shams;
    $be59461d4a783f7b$var$hasRequiredShams = 1;
    var hasSymbols2 = $be59461d4a783f7b$var$requireShams$1();
    $be59461d4a783f7b$var$shams = function hasToStringTagShams() {
        return hasSymbols2() && !!Symbol.toStringTag;
    };
    return $be59461d4a783f7b$var$shams;
}
var $be59461d4a783f7b$var$esObjectAtoms;
var $be59461d4a783f7b$var$hasRequiredEsObjectAtoms;
function $be59461d4a783f7b$var$requireEsObjectAtoms() {
    if ($be59461d4a783f7b$var$hasRequiredEsObjectAtoms) return $be59461d4a783f7b$var$esObjectAtoms;
    $be59461d4a783f7b$var$hasRequiredEsObjectAtoms = 1;
    $be59461d4a783f7b$var$esObjectAtoms = Object;
    return $be59461d4a783f7b$var$esObjectAtoms;
}
var $be59461d4a783f7b$var$esErrors;
var $be59461d4a783f7b$var$hasRequiredEsErrors;
function $be59461d4a783f7b$var$requireEsErrors() {
    if ($be59461d4a783f7b$var$hasRequiredEsErrors) return $be59461d4a783f7b$var$esErrors;
    $be59461d4a783f7b$var$hasRequiredEsErrors = 1;
    $be59461d4a783f7b$var$esErrors = Error;
    return $be59461d4a783f7b$var$esErrors;
}
var $be59461d4a783f7b$var$_eval;
var $be59461d4a783f7b$var$hasRequired_eval;
function $be59461d4a783f7b$var$require_eval() {
    if ($be59461d4a783f7b$var$hasRequired_eval) return $be59461d4a783f7b$var$_eval;
    $be59461d4a783f7b$var$hasRequired_eval = 1;
    $be59461d4a783f7b$var$_eval = EvalError;
    return $be59461d4a783f7b$var$_eval;
}
var $be59461d4a783f7b$var$range;
var $be59461d4a783f7b$var$hasRequiredRange;
function $be59461d4a783f7b$var$requireRange() {
    if ($be59461d4a783f7b$var$hasRequiredRange) return $be59461d4a783f7b$var$range;
    $be59461d4a783f7b$var$hasRequiredRange = 1;
    $be59461d4a783f7b$var$range = RangeError;
    return $be59461d4a783f7b$var$range;
}
var $be59461d4a783f7b$var$ref;
var $be59461d4a783f7b$var$hasRequiredRef;
function $be59461d4a783f7b$var$requireRef() {
    if ($be59461d4a783f7b$var$hasRequiredRef) return $be59461d4a783f7b$var$ref;
    $be59461d4a783f7b$var$hasRequiredRef = 1;
    $be59461d4a783f7b$var$ref = ReferenceError;
    return $be59461d4a783f7b$var$ref;
}
var $be59461d4a783f7b$var$syntax;
var $be59461d4a783f7b$var$hasRequiredSyntax;
function $be59461d4a783f7b$var$requireSyntax() {
    if ($be59461d4a783f7b$var$hasRequiredSyntax) return $be59461d4a783f7b$var$syntax;
    $be59461d4a783f7b$var$hasRequiredSyntax = 1;
    $be59461d4a783f7b$var$syntax = SyntaxError;
    return $be59461d4a783f7b$var$syntax;
}
var $be59461d4a783f7b$var$type;
var $be59461d4a783f7b$var$hasRequiredType;
function $be59461d4a783f7b$var$requireType() {
    if ($be59461d4a783f7b$var$hasRequiredType) return $be59461d4a783f7b$var$type;
    $be59461d4a783f7b$var$hasRequiredType = 1;
    $be59461d4a783f7b$var$type = TypeError;
    return $be59461d4a783f7b$var$type;
}
var $be59461d4a783f7b$var$uri;
var $be59461d4a783f7b$var$hasRequiredUri;
function $be59461d4a783f7b$var$requireUri() {
    if ($be59461d4a783f7b$var$hasRequiredUri) return $be59461d4a783f7b$var$uri;
    $be59461d4a783f7b$var$hasRequiredUri = 1;
    $be59461d4a783f7b$var$uri = URIError;
    return $be59461d4a783f7b$var$uri;
}
var $be59461d4a783f7b$var$abs;
var $be59461d4a783f7b$var$hasRequiredAbs;
function $be59461d4a783f7b$var$requireAbs() {
    if ($be59461d4a783f7b$var$hasRequiredAbs) return $be59461d4a783f7b$var$abs;
    $be59461d4a783f7b$var$hasRequiredAbs = 1;
    $be59461d4a783f7b$var$abs = Math.abs;
    return $be59461d4a783f7b$var$abs;
}
var $be59461d4a783f7b$var$floor;
var $be59461d4a783f7b$var$hasRequiredFloor;
function $be59461d4a783f7b$var$requireFloor() {
    if ($be59461d4a783f7b$var$hasRequiredFloor) return $be59461d4a783f7b$var$floor;
    $be59461d4a783f7b$var$hasRequiredFloor = 1;
    $be59461d4a783f7b$var$floor = Math.floor;
    return $be59461d4a783f7b$var$floor;
}
var $be59461d4a783f7b$var$max;
var $be59461d4a783f7b$var$hasRequiredMax;
function $be59461d4a783f7b$var$requireMax() {
    if ($be59461d4a783f7b$var$hasRequiredMax) return $be59461d4a783f7b$var$max;
    $be59461d4a783f7b$var$hasRequiredMax = 1;
    $be59461d4a783f7b$var$max = Math.max;
    return $be59461d4a783f7b$var$max;
}
var $be59461d4a783f7b$var$min;
var $be59461d4a783f7b$var$hasRequiredMin;
function $be59461d4a783f7b$var$requireMin() {
    if ($be59461d4a783f7b$var$hasRequiredMin) return $be59461d4a783f7b$var$min;
    $be59461d4a783f7b$var$hasRequiredMin = 1;
    $be59461d4a783f7b$var$min = Math.min;
    return $be59461d4a783f7b$var$min;
}
var $be59461d4a783f7b$var$pow;
var $be59461d4a783f7b$var$hasRequiredPow;
function $be59461d4a783f7b$var$requirePow() {
    if ($be59461d4a783f7b$var$hasRequiredPow) return $be59461d4a783f7b$var$pow;
    $be59461d4a783f7b$var$hasRequiredPow = 1;
    $be59461d4a783f7b$var$pow = Math.pow;
    return $be59461d4a783f7b$var$pow;
}
var $be59461d4a783f7b$var$round;
var $be59461d4a783f7b$var$hasRequiredRound;
function $be59461d4a783f7b$var$requireRound() {
    if ($be59461d4a783f7b$var$hasRequiredRound) return $be59461d4a783f7b$var$round;
    $be59461d4a783f7b$var$hasRequiredRound = 1;
    $be59461d4a783f7b$var$round = Math.round;
    return $be59461d4a783f7b$var$round;
}
var $be59461d4a783f7b$var$_isNaN;
var $be59461d4a783f7b$var$hasRequired_isNaN;
function $be59461d4a783f7b$var$require_isNaN() {
    if ($be59461d4a783f7b$var$hasRequired_isNaN) return $be59461d4a783f7b$var$_isNaN;
    $be59461d4a783f7b$var$hasRequired_isNaN = 1;
    $be59461d4a783f7b$var$_isNaN = Number.isNaN || function isNaN2(a) {
        return a !== a;
    };
    return $be59461d4a783f7b$var$_isNaN;
}
var $be59461d4a783f7b$var$sign;
var $be59461d4a783f7b$var$hasRequiredSign;
function $be59461d4a783f7b$var$requireSign() {
    if ($be59461d4a783f7b$var$hasRequiredSign) return $be59461d4a783f7b$var$sign;
    $be59461d4a783f7b$var$hasRequiredSign = 1;
    var $isNaN = /* @__PURE__ */ $be59461d4a783f7b$var$require_isNaN();
    $be59461d4a783f7b$var$sign = function sign2(number) {
        if ($isNaN(number) || number === 0) return number;
        return number < 0 ? -1 : 1;
    };
    return $be59461d4a783f7b$var$sign;
}
var $be59461d4a783f7b$var$gOPD;
var $be59461d4a783f7b$var$hasRequiredGOPD;
function $be59461d4a783f7b$var$requireGOPD() {
    if ($be59461d4a783f7b$var$hasRequiredGOPD) return $be59461d4a783f7b$var$gOPD;
    $be59461d4a783f7b$var$hasRequiredGOPD = 1;
    $be59461d4a783f7b$var$gOPD = Object.getOwnPropertyDescriptor;
    return $be59461d4a783f7b$var$gOPD;
}
var $be59461d4a783f7b$var$gopd;
var $be59461d4a783f7b$var$hasRequiredGopd;
function $be59461d4a783f7b$var$requireGopd() {
    if ($be59461d4a783f7b$var$hasRequiredGopd) return $be59461d4a783f7b$var$gopd;
    $be59461d4a783f7b$var$hasRequiredGopd = 1;
    var $gOPD = /* @__PURE__ */ $be59461d4a783f7b$var$requireGOPD();
    if ($gOPD) try {
        $gOPD([], "length");
    } catch (e) {
        $gOPD = null;
    }
    $be59461d4a783f7b$var$gopd = $gOPD;
    return $be59461d4a783f7b$var$gopd;
}
var $be59461d4a783f7b$var$esDefineProperty;
var $be59461d4a783f7b$var$hasRequiredEsDefineProperty;
function $be59461d4a783f7b$var$requireEsDefineProperty() {
    if ($be59461d4a783f7b$var$hasRequiredEsDefineProperty) return $be59461d4a783f7b$var$esDefineProperty;
    $be59461d4a783f7b$var$hasRequiredEsDefineProperty = 1;
    var $defineProperty = Object.defineProperty || false;
    if ($defineProperty) try {
        $defineProperty({}, "a", {
            value: 1
        });
    } catch (e) {
        $defineProperty = false;
    }
    $be59461d4a783f7b$var$esDefineProperty = $defineProperty;
    return $be59461d4a783f7b$var$esDefineProperty;
}
var $be59461d4a783f7b$var$hasSymbols;
var $be59461d4a783f7b$var$hasRequiredHasSymbols;
function $be59461d4a783f7b$var$requireHasSymbols() {
    if ($be59461d4a783f7b$var$hasRequiredHasSymbols) return $be59461d4a783f7b$var$hasSymbols;
    $be59461d4a783f7b$var$hasRequiredHasSymbols = 1;
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = $be59461d4a783f7b$var$requireShams$1();
    $be59461d4a783f7b$var$hasSymbols = function hasNativeSymbols() {
        if (typeof origSymbol !== "function") return false;
        if (typeof Symbol !== "function") return false;
        if (typeof origSymbol("foo") !== "symbol") return false;
        if (typeof Symbol("bar") !== "symbol") return false;
        return hasSymbolSham();
    };
    return $be59461d4a783f7b$var$hasSymbols;
}
var $be59461d4a783f7b$var$Reflect_getPrototypeOf;
var $be59461d4a783f7b$var$hasRequiredReflect_getPrototypeOf;
function $be59461d4a783f7b$var$requireReflect_getPrototypeOf() {
    if ($be59461d4a783f7b$var$hasRequiredReflect_getPrototypeOf) return $be59461d4a783f7b$var$Reflect_getPrototypeOf;
    $be59461d4a783f7b$var$hasRequiredReflect_getPrototypeOf = 1;
    $be59461d4a783f7b$var$Reflect_getPrototypeOf = typeof Reflect !== "undefined" && Reflect.getPrototypeOf || null;
    return $be59461d4a783f7b$var$Reflect_getPrototypeOf;
}
var $be59461d4a783f7b$var$Object_getPrototypeOf;
var $be59461d4a783f7b$var$hasRequiredObject_getPrototypeOf;
function $be59461d4a783f7b$var$requireObject_getPrototypeOf() {
    if ($be59461d4a783f7b$var$hasRequiredObject_getPrototypeOf) return $be59461d4a783f7b$var$Object_getPrototypeOf;
    $be59461d4a783f7b$var$hasRequiredObject_getPrototypeOf = 1;
    var $Object = /* @__PURE__ */ $be59461d4a783f7b$var$requireEsObjectAtoms();
    $be59461d4a783f7b$var$Object_getPrototypeOf = $Object.getPrototypeOf || null;
    return $be59461d4a783f7b$var$Object_getPrototypeOf;
}
var $be59461d4a783f7b$var$implementation;
var $be59461d4a783f7b$var$hasRequiredImplementation;
function $be59461d4a783f7b$var$requireImplementation() {
    if ($be59461d4a783f7b$var$hasRequiredImplementation) return $be59461d4a783f7b$var$implementation;
    $be59461d4a783f7b$var$hasRequiredImplementation = 1;
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var toStr = Object.prototype.toString;
    var max2 = Math.max;
    var funcType = "[object Function]";
    var concatty = function concatty2(a, b) {
        var arr = [];
        for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
        for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
        return arr;
    };
    var slicy = function slicy2(arrLike, offset) {
        var arr = [];
        for(var i = offset, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
        return arr;
    };
    var joiny = function(arr, joiner) {
        var str = "";
        for(var i = 0; i < arr.length; i += 1){
            str += arr[i];
            if (i + 1 < arr.length) str += joiner;
        }
        return str;
    };
    $be59461d4a783f7b$var$implementation = function bind(that) {
        var target = this;
        if (typeof target !== "function" || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
        var args = slicy(arguments, 1);
        var bound;
        var binder = function() {
            if (this instanceof bound) {
                var result = target.apply(this, concatty(args, arguments));
                if (Object(result) === result) return result;
                return this;
            }
            return target.apply(that, concatty(args, arguments));
        };
        var boundLength = max2(0, target.length - args.length);
        var boundArgs = [];
        for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
        bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
        if (target.prototype) {
            var Empty = function Empty2() {};
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            Empty.prototype = null;
        }
        return bound;
    };
    return $be59461d4a783f7b$var$implementation;
}
var $be59461d4a783f7b$var$functionBind;
var $be59461d4a783f7b$var$hasRequiredFunctionBind;
function $be59461d4a783f7b$var$requireFunctionBind() {
    if ($be59461d4a783f7b$var$hasRequiredFunctionBind) return $be59461d4a783f7b$var$functionBind;
    $be59461d4a783f7b$var$hasRequiredFunctionBind = 1;
    var implementation2 = $be59461d4a783f7b$var$requireImplementation();
    $be59461d4a783f7b$var$functionBind = Function.prototype.bind || implementation2;
    return $be59461d4a783f7b$var$functionBind;
}
var $be59461d4a783f7b$var$functionCall;
var $be59461d4a783f7b$var$hasRequiredFunctionCall;
function $be59461d4a783f7b$var$requireFunctionCall() {
    if ($be59461d4a783f7b$var$hasRequiredFunctionCall) return $be59461d4a783f7b$var$functionCall;
    $be59461d4a783f7b$var$hasRequiredFunctionCall = 1;
    $be59461d4a783f7b$var$functionCall = Function.prototype.call;
    return $be59461d4a783f7b$var$functionCall;
}
var $be59461d4a783f7b$var$functionApply;
var $be59461d4a783f7b$var$hasRequiredFunctionApply;
function $be59461d4a783f7b$var$requireFunctionApply() {
    if ($be59461d4a783f7b$var$hasRequiredFunctionApply) return $be59461d4a783f7b$var$functionApply;
    $be59461d4a783f7b$var$hasRequiredFunctionApply = 1;
    $be59461d4a783f7b$var$functionApply = Function.prototype.apply;
    return $be59461d4a783f7b$var$functionApply;
}
var $be59461d4a783f7b$var$reflectApply;
var $be59461d4a783f7b$var$hasRequiredReflectApply;
function $be59461d4a783f7b$var$requireReflectApply() {
    if ($be59461d4a783f7b$var$hasRequiredReflectApply) return $be59461d4a783f7b$var$reflectApply;
    $be59461d4a783f7b$var$hasRequiredReflectApply = 1;
    $be59461d4a783f7b$var$reflectApply = typeof Reflect !== "undefined" && Reflect && Reflect.apply;
    return $be59461d4a783f7b$var$reflectApply;
}
var $be59461d4a783f7b$var$actualApply;
var $be59461d4a783f7b$var$hasRequiredActualApply;
function $be59461d4a783f7b$var$requireActualApply() {
    if ($be59461d4a783f7b$var$hasRequiredActualApply) return $be59461d4a783f7b$var$actualApply;
    $be59461d4a783f7b$var$hasRequiredActualApply = 1;
    var bind = $be59461d4a783f7b$var$requireFunctionBind();
    var $apply = $be59461d4a783f7b$var$requireFunctionApply();
    var $call = $be59461d4a783f7b$var$requireFunctionCall();
    var $reflectApply = $be59461d4a783f7b$var$requireReflectApply();
    $be59461d4a783f7b$var$actualApply = $reflectApply || bind.call($call, $apply);
    return $be59461d4a783f7b$var$actualApply;
}
var $be59461d4a783f7b$var$callBindApplyHelpers;
var $be59461d4a783f7b$var$hasRequiredCallBindApplyHelpers;
function $be59461d4a783f7b$var$requireCallBindApplyHelpers() {
    if ($be59461d4a783f7b$var$hasRequiredCallBindApplyHelpers) return $be59461d4a783f7b$var$callBindApplyHelpers;
    $be59461d4a783f7b$var$hasRequiredCallBindApplyHelpers = 1;
    var bind = $be59461d4a783f7b$var$requireFunctionBind();
    var $TypeError = /* @__PURE__ */ $be59461d4a783f7b$var$requireType();
    var $call = $be59461d4a783f7b$var$requireFunctionCall();
    var $actualApply = $be59461d4a783f7b$var$requireActualApply();
    $be59461d4a783f7b$var$callBindApplyHelpers = function callBindBasic(args) {
        if (args.length < 1 || typeof args[0] !== "function") throw new $TypeError("a function is required");
        return $actualApply(bind, $call, args);
    };
    return $be59461d4a783f7b$var$callBindApplyHelpers;
}
var $be59461d4a783f7b$var$get;
var $be59461d4a783f7b$var$hasRequiredGet;
function $be59461d4a783f7b$var$requireGet() {
    if ($be59461d4a783f7b$var$hasRequiredGet) return $be59461d4a783f7b$var$get;
    $be59461d4a783f7b$var$hasRequiredGet = 1;
    var callBind2 = $be59461d4a783f7b$var$requireCallBindApplyHelpers();
    var gOPD2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireGopd();
    var hasProtoAccessor;
    try {
        hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
    } catch (e) {
        if (!e || typeof e !== "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS") throw e;
    }
    var desc = !!hasProtoAccessor && gOPD2 && gOPD2(Object.prototype, /** @type {keyof typeof Object.prototype} */ "__proto__");
    var $Object = Object;
    var $getPrototypeOf = $Object.getPrototypeOf;
    $be59461d4a783f7b$var$get = desc && typeof desc.get === "function" ? callBind2([
        desc.get
    ]) : typeof $getPrototypeOf === "function" ? /** @type {import('./get')} */ function getDunder(value) {
        return $getPrototypeOf(value == null ? value : $Object(value));
    } : false;
    return $be59461d4a783f7b$var$get;
}
var $be59461d4a783f7b$var$getProto;
var $be59461d4a783f7b$var$hasRequiredGetProto;
function $be59461d4a783f7b$var$requireGetProto() {
    if ($be59461d4a783f7b$var$hasRequiredGetProto) return $be59461d4a783f7b$var$getProto;
    $be59461d4a783f7b$var$hasRequiredGetProto = 1;
    var reflectGetProto = $be59461d4a783f7b$var$requireReflect_getPrototypeOf();
    var originalGetProto = $be59461d4a783f7b$var$requireObject_getPrototypeOf();
    var getDunderProto = /* @__PURE__ */ $be59461d4a783f7b$var$requireGet();
    $be59461d4a783f7b$var$getProto = reflectGetProto ? function getProto2(O) {
        return reflectGetProto(O);
    } : originalGetProto ? function getProto2(O) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new TypeError("getProto: not an object");
        return originalGetProto(O);
    } : getDunderProto ? function getProto2(O) {
        return getDunderProto(O);
    } : null;
    return $be59461d4a783f7b$var$getProto;
}
var $be59461d4a783f7b$var$hasown;
var $be59461d4a783f7b$var$hasRequiredHasown;
function $be59461d4a783f7b$var$requireHasown() {
    if ($be59461d4a783f7b$var$hasRequiredHasown) return $be59461d4a783f7b$var$hasown;
    $be59461d4a783f7b$var$hasRequiredHasown = 1;
    var call = Function.prototype.call;
    var $hasOwn = Object.prototype.hasOwnProperty;
    var bind = $be59461d4a783f7b$var$requireFunctionBind();
    $be59461d4a783f7b$var$hasown = bind.call(call, $hasOwn);
    return $be59461d4a783f7b$var$hasown;
}
var $be59461d4a783f7b$var$getIntrinsic;
var $be59461d4a783f7b$var$hasRequiredGetIntrinsic;
function $be59461d4a783f7b$var$requireGetIntrinsic() {
    if ($be59461d4a783f7b$var$hasRequiredGetIntrinsic) return $be59461d4a783f7b$var$getIntrinsic;
    $be59461d4a783f7b$var$hasRequiredGetIntrinsic = 1;
    var undefined$1;
    var $Object = /* @__PURE__ */ $be59461d4a783f7b$var$requireEsObjectAtoms();
    var $Error = /* @__PURE__ */ $be59461d4a783f7b$var$requireEsErrors();
    var $EvalError = /* @__PURE__ */ $be59461d4a783f7b$var$require_eval();
    var $RangeError = /* @__PURE__ */ $be59461d4a783f7b$var$requireRange();
    var $ReferenceError = /* @__PURE__ */ $be59461d4a783f7b$var$requireRef();
    var $SyntaxError = /* @__PURE__ */ $be59461d4a783f7b$var$requireSyntax();
    var $TypeError = /* @__PURE__ */ $be59461d4a783f7b$var$requireType();
    var $URIError = /* @__PURE__ */ $be59461d4a783f7b$var$requireUri();
    var abs2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireAbs();
    var floor2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireFloor();
    var max2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireMax();
    var min2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireMin();
    var pow2 = /* @__PURE__ */ $be59461d4a783f7b$var$requirePow();
    var round2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireRound();
    var sign2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireSign();
    var $Function = Function;
    var getEvalledConstructor = function(expressionSyntax) {
        try {
            return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
        } catch (e) {}
    };
    var $gOPD = /* @__PURE__ */ $be59461d4a783f7b$var$requireGopd();
    var $defineProperty = /* @__PURE__ */ $be59461d4a783f7b$var$requireEsDefineProperty();
    var throwTypeError = function() {
        throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
        try {
            arguments.callee;
            return throwTypeError;
        } catch (calleeThrows) {
            try {
                return $gOPD(arguments, "callee").get;
            } catch (gOPDthrows) {
                return throwTypeError;
            }
        }
    }() : throwTypeError;
    var hasSymbols2 = $be59461d4a783f7b$var$requireHasSymbols()();
    var getProto2 = $be59461d4a783f7b$var$requireGetProto();
    var $ObjectGPO = $be59461d4a783f7b$var$requireObject_getPrototypeOf();
    var $ReflectGPO = $be59461d4a783f7b$var$requireReflect_getPrototypeOf();
    var $apply = $be59461d4a783f7b$var$requireFunctionApply();
    var $call = $be59461d4a783f7b$var$requireFunctionCall();
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" || !getProto2 ? undefined$1 : getProto2(Uint8Array);
    var INTRINSICS = {
        __proto__: null,
        "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
        "%Array%": Array,
        "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
        "%ArrayIteratorPrototype%": hasSymbols2 && getProto2 ? getProto2([][Symbol.iterator]()) : undefined$1,
        "%AsyncFromSyncIteratorPrototype%": undefined$1,
        "%AsyncFunction%": needsEval,
        "%AsyncGenerator%": needsEval,
        "%AsyncGeneratorFunction%": needsEval,
        "%AsyncIteratorPrototype%": needsEval,
        "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
        "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
        "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
        "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
        "%Boolean%": Boolean,
        "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
        "%Date%": Date,
        "%decodeURI%": decodeURI,
        "%decodeURIComponent%": decodeURIComponent,
        "%encodeURI%": encodeURI,
        "%encodeURIComponent%": encodeURIComponent,
        "%Error%": $Error,
        "%eval%": eval,
        // eslint-disable-line no-eval
        "%EvalError%": $EvalError,
        "%Float16Array%": typeof Float16Array === "undefined" ? undefined$1 : Float16Array,
        "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
        "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
        "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
        "%Function%": $Function,
        "%GeneratorFunction%": needsEval,
        "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
        "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
        "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
        "%isFinite%": isFinite,
        "%isNaN%": isNaN,
        "%IteratorPrototype%": hasSymbols2 && getProto2 ? getProto2(getProto2([][Symbol.iterator]())) : undefined$1,
        "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
        "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
        "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 || !getProto2 ? undefined$1 : getProto2(/* @__PURE__ */ new Map()[Symbol.iterator]()),
        "%Math%": Math,
        "%Number%": Number,
        "%Object%": $Object,
        "%Object.getOwnPropertyDescriptor%": $gOPD,
        "%parseFloat%": parseFloat,
        "%parseInt%": parseInt,
        "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
        "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
        "%RangeError%": $RangeError,
        "%ReferenceError%": $ReferenceError,
        "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
        "%RegExp%": RegExp,
        "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
        "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 || !getProto2 ? undefined$1 : getProto2(/* @__PURE__ */ new Set()[Symbol.iterator]()),
        "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
        "%String%": String,
        "%StringIteratorPrototype%": hasSymbols2 && getProto2 ? getProto2(""[Symbol.iterator]()) : undefined$1,
        "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
        "%SyntaxError%": $SyntaxError,
        "%ThrowTypeError%": ThrowTypeError,
        "%TypedArray%": TypedArray,
        "%TypeError%": $TypeError,
        "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
        "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
        "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
        "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
        "%URIError%": $URIError,
        "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
        "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
        "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet,
        "%Function.prototype.call%": $call,
        "%Function.prototype.apply%": $apply,
        "%Object.defineProperty%": $defineProperty,
        "%Object.getPrototypeOf%": $ObjectGPO,
        "%Math.abs%": abs2,
        "%Math.floor%": floor2,
        "%Math.max%": max2,
        "%Math.min%": min2,
        "%Math.pow%": pow2,
        "%Math.round%": round2,
        "%Math.sign%": sign2,
        "%Reflect.getPrototypeOf%": $ReflectGPO
    };
    if (getProto2) try {
        null.error;
    } catch (e) {
        var errorProto = getProto2(getProto2(e));
        INTRINSICS["%Error.prototype%"] = errorProto;
    }
    var doEval = function doEval2(name) {
        var value;
        if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
        else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
        else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
        else if (name === "%AsyncGenerator%") {
            var fn = doEval2("%AsyncGeneratorFunction%");
            if (fn) value = fn.prototype;
        } else if (name === "%AsyncIteratorPrototype%") {
            var gen = doEval2("%AsyncGenerator%");
            if (gen && getProto2) value = getProto2(gen.prototype);
        }
        INTRINSICS[name] = value;
        return value;
    };
    var LEGACY_ALIASES = {
        __proto__: null,
        "%ArrayBufferPrototype%": [
            "ArrayBuffer",
            "prototype"
        ],
        "%ArrayPrototype%": [
            "Array",
            "prototype"
        ],
        "%ArrayProto_entries%": [
            "Array",
            "prototype",
            "entries"
        ],
        "%ArrayProto_forEach%": [
            "Array",
            "prototype",
            "forEach"
        ],
        "%ArrayProto_keys%": [
            "Array",
            "prototype",
            "keys"
        ],
        "%ArrayProto_values%": [
            "Array",
            "prototype",
            "values"
        ],
        "%AsyncFunctionPrototype%": [
            "AsyncFunction",
            "prototype"
        ],
        "%AsyncGenerator%": [
            "AsyncGeneratorFunction",
            "prototype"
        ],
        "%AsyncGeneratorPrototype%": [
            "AsyncGeneratorFunction",
            "prototype",
            "prototype"
        ],
        "%BooleanPrototype%": [
            "Boolean",
            "prototype"
        ],
        "%DataViewPrototype%": [
            "DataView",
            "prototype"
        ],
        "%DatePrototype%": [
            "Date",
            "prototype"
        ],
        "%ErrorPrototype%": [
            "Error",
            "prototype"
        ],
        "%EvalErrorPrototype%": [
            "EvalError",
            "prototype"
        ],
        "%Float32ArrayPrototype%": [
            "Float32Array",
            "prototype"
        ],
        "%Float64ArrayPrototype%": [
            "Float64Array",
            "prototype"
        ],
        "%FunctionPrototype%": [
            "Function",
            "prototype"
        ],
        "%Generator%": [
            "GeneratorFunction",
            "prototype"
        ],
        "%GeneratorPrototype%": [
            "GeneratorFunction",
            "prototype",
            "prototype"
        ],
        "%Int8ArrayPrototype%": [
            "Int8Array",
            "prototype"
        ],
        "%Int16ArrayPrototype%": [
            "Int16Array",
            "prototype"
        ],
        "%Int32ArrayPrototype%": [
            "Int32Array",
            "prototype"
        ],
        "%JSONParse%": [
            "JSON",
            "parse"
        ],
        "%JSONStringify%": [
            "JSON",
            "stringify"
        ],
        "%MapPrototype%": [
            "Map",
            "prototype"
        ],
        "%NumberPrototype%": [
            "Number",
            "prototype"
        ],
        "%ObjectPrototype%": [
            "Object",
            "prototype"
        ],
        "%ObjProto_toString%": [
            "Object",
            "prototype",
            "toString"
        ],
        "%ObjProto_valueOf%": [
            "Object",
            "prototype",
            "valueOf"
        ],
        "%PromisePrototype%": [
            "Promise",
            "prototype"
        ],
        "%PromiseProto_then%": [
            "Promise",
            "prototype",
            "then"
        ],
        "%Promise_all%": [
            "Promise",
            "all"
        ],
        "%Promise_reject%": [
            "Promise",
            "reject"
        ],
        "%Promise_resolve%": [
            "Promise",
            "resolve"
        ],
        "%RangeErrorPrototype%": [
            "RangeError",
            "prototype"
        ],
        "%ReferenceErrorPrototype%": [
            "ReferenceError",
            "prototype"
        ],
        "%RegExpPrototype%": [
            "RegExp",
            "prototype"
        ],
        "%SetPrototype%": [
            "Set",
            "prototype"
        ],
        "%SharedArrayBufferPrototype%": [
            "SharedArrayBuffer",
            "prototype"
        ],
        "%StringPrototype%": [
            "String",
            "prototype"
        ],
        "%SymbolPrototype%": [
            "Symbol",
            "prototype"
        ],
        "%SyntaxErrorPrototype%": [
            "SyntaxError",
            "prototype"
        ],
        "%TypedArrayPrototype%": [
            "TypedArray",
            "prototype"
        ],
        "%TypeErrorPrototype%": [
            "TypeError",
            "prototype"
        ],
        "%Uint8ArrayPrototype%": [
            "Uint8Array",
            "prototype"
        ],
        "%Uint8ClampedArrayPrototype%": [
            "Uint8ClampedArray",
            "prototype"
        ],
        "%Uint16ArrayPrototype%": [
            "Uint16Array",
            "prototype"
        ],
        "%Uint32ArrayPrototype%": [
            "Uint32Array",
            "prototype"
        ],
        "%URIErrorPrototype%": [
            "URIError",
            "prototype"
        ],
        "%WeakMapPrototype%": [
            "WeakMap",
            "prototype"
        ],
        "%WeakSetPrototype%": [
            "WeakSet",
            "prototype"
        ]
    };
    var bind = $be59461d4a783f7b$var$requireFunctionBind();
    var hasOwn = /* @__PURE__ */ $be59461d4a783f7b$var$requireHasown();
    var $concat = bind.call($call, Array.prototype.concat);
    var $spliceApply = bind.call($apply, Array.prototype.splice);
    var $replace = bind.call($call, String.prototype.replace);
    var $strSlice = bind.call($call, String.prototype.slice);
    var $exec = bind.call($call, RegExp.prototype.exec);
    var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = function stringToPath2(string) {
        var first = $strSlice(string, 0, 1);
        var last = $strSlice(string, -1);
        if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
        else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
        var result = [];
        $replace(string, rePropName, function(match, number, quote, subString) {
            result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
        });
        return result;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
        var intrinsicName = name;
        var alias;
        if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
            alias = LEGACY_ALIASES[intrinsicName];
            intrinsicName = "%" + alias[0] + "%";
        }
        if (hasOwn(INTRINSICS, intrinsicName)) {
            var value = INTRINSICS[intrinsicName];
            if (value === needsEval) value = doEval(intrinsicName);
            if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
            return {
                alias: alias,
                name: intrinsicName,
                value: value
            };
        }
        throw new $SyntaxError("intrinsic " + name + " does not exist!");
    };
    $be59461d4a783f7b$var$getIntrinsic = function GetIntrinsic(name, allowMissing) {
        if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
        if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
        if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
        var parts = stringToPath(name);
        var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
        var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
        var intrinsicRealName = intrinsic.name;
        var value = intrinsic.value;
        var skipFurtherCaching = false;
        var alias = intrinsic.alias;
        if (alias) {
            intrinsicBaseName = alias[0];
            $spliceApply(parts, $concat([
                0,
                1
            ], alias));
        }
        for(var i = 1, isOwn = true; i < parts.length; i += 1){
            var part = parts[i];
            var first = $strSlice(part, 0, 1);
            var last = $strSlice(part, -1);
            if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
            if (part === "constructor" || !isOwn) skipFurtherCaching = true;
            intrinsicBaseName += "." + part;
            intrinsicRealName = "%" + intrinsicBaseName + "%";
            if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
            else if (value != null) {
                if (!(part in value)) {
                    if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                    return void 0;
                }
                if ($gOPD && i + 1 >= parts.length) {
                    var desc = $gOPD(value, part);
                    isOwn = !!desc;
                    if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                    else value = value[part];
                } else {
                    isOwn = hasOwn(value, part);
                    value = value[part];
                }
                if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
            }
        }
        return value;
    };
    return $be59461d4a783f7b$var$getIntrinsic;
}
var $be59461d4a783f7b$var$callBind = {
    exports: {}
};
var $be59461d4a783f7b$var$defineDataProperty;
var $be59461d4a783f7b$var$hasRequiredDefineDataProperty;
function $be59461d4a783f7b$var$requireDefineDataProperty() {
    if ($be59461d4a783f7b$var$hasRequiredDefineDataProperty) return $be59461d4a783f7b$var$defineDataProperty;
    $be59461d4a783f7b$var$hasRequiredDefineDataProperty = 1;
    var $defineProperty = /* @__PURE__ */ $be59461d4a783f7b$var$requireEsDefineProperty();
    var $SyntaxError = /* @__PURE__ */ $be59461d4a783f7b$var$requireSyntax();
    var $TypeError = /* @__PURE__ */ $be59461d4a783f7b$var$requireType();
    var gopd2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireGopd();
    $be59461d4a783f7b$var$defineDataProperty = function defineDataProperty2(obj, property, value) {
        if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $TypeError("`obj` must be an object or a function`");
        if (typeof property !== "string" && typeof property !== "symbol") throw new $TypeError("`property` must be a string or a symbol`");
        if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
        if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
        if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
        if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $TypeError("`loose`, if provided, must be a boolean");
        var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
        var nonWritable = arguments.length > 4 ? arguments[4] : null;
        var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
        var loose = arguments.length > 6 ? arguments[6] : false;
        var desc = !!gopd2 && gopd2(obj, property);
        if ($defineProperty) $defineProperty(obj, property, {
            configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
            enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
            value: value,
            writable: nonWritable === null && desc ? desc.writable : !nonWritable
        });
        else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) obj[property] = value;
        else throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
    };
    return $be59461d4a783f7b$var$defineDataProperty;
}
var $be59461d4a783f7b$var$hasPropertyDescriptors_1;
var $be59461d4a783f7b$var$hasRequiredHasPropertyDescriptors;
function $be59461d4a783f7b$var$requireHasPropertyDescriptors() {
    if ($be59461d4a783f7b$var$hasRequiredHasPropertyDescriptors) return $be59461d4a783f7b$var$hasPropertyDescriptors_1;
    $be59461d4a783f7b$var$hasRequiredHasPropertyDescriptors = 1;
    var $defineProperty = /* @__PURE__ */ $be59461d4a783f7b$var$requireEsDefineProperty();
    var hasPropertyDescriptors = function hasPropertyDescriptors2() {
        return !!$defineProperty;
    };
    hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
        if (!$defineProperty) return null;
        try {
            return $defineProperty([], "length", {
                value: 1
            }).length !== 1;
        } catch (e) {
            return true;
        }
    };
    $be59461d4a783f7b$var$hasPropertyDescriptors_1 = hasPropertyDescriptors;
    return $be59461d4a783f7b$var$hasPropertyDescriptors_1;
}
var $be59461d4a783f7b$var$setFunctionLength;
var $be59461d4a783f7b$var$hasRequiredSetFunctionLength;
function $be59461d4a783f7b$var$requireSetFunctionLength() {
    if ($be59461d4a783f7b$var$hasRequiredSetFunctionLength) return $be59461d4a783f7b$var$setFunctionLength;
    $be59461d4a783f7b$var$hasRequiredSetFunctionLength = 1;
    var GetIntrinsic = /* @__PURE__ */ $be59461d4a783f7b$var$requireGetIntrinsic();
    var define = /* @__PURE__ */ $be59461d4a783f7b$var$requireDefineDataProperty();
    var hasDescriptors = /* @__PURE__ */ $be59461d4a783f7b$var$requireHasPropertyDescriptors()();
    var gOPD2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireGopd();
    var $TypeError = /* @__PURE__ */ $be59461d4a783f7b$var$requireType();
    var $floor = GetIntrinsic("%Math.floor%");
    $be59461d4a783f7b$var$setFunctionLength = function setFunctionLength2(fn, length) {
        if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
        if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor(length) !== length) throw new $TypeError("`length` must be a positive 32-bit integer");
        var loose = arguments.length > 2 && !!arguments[2];
        var functionLengthIsConfigurable = true;
        var functionLengthIsWritable = true;
        if ("length" in fn && gOPD2) {
            var desc = gOPD2(fn, "length");
            if (desc && !desc.configurable) functionLengthIsConfigurable = false;
            if (desc && !desc.writable) functionLengthIsWritable = false;
        }
        if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
            if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
            else define(/** @type {Parameters<define>[0]} */ fn, "length", length);
        }
        return fn;
    };
    return $be59461d4a783f7b$var$setFunctionLength;
}
var $be59461d4a783f7b$var$hasRequiredCallBind;
function $be59461d4a783f7b$var$requireCallBind() {
    if ($be59461d4a783f7b$var$hasRequiredCallBind) return $be59461d4a783f7b$var$callBind.exports;
    $be59461d4a783f7b$var$hasRequiredCallBind = 1;
    (function(module) {
        var bind = $be59461d4a783f7b$var$requireFunctionBind();
        var GetIntrinsic = /* @__PURE__ */ $be59461d4a783f7b$var$requireGetIntrinsic();
        var setFunctionLength2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireSetFunctionLength();
        var $TypeError = /* @__PURE__ */ $be59461d4a783f7b$var$requireType();
        var $apply = GetIntrinsic("%Function.prototype.apply%");
        var $call = GetIntrinsic("%Function.prototype.call%");
        var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
        var $defineProperty = /* @__PURE__ */ $be59461d4a783f7b$var$requireEsDefineProperty();
        var $max = GetIntrinsic("%Math.max%");
        module.exports = function callBind2(originalFunction) {
            if (typeof originalFunction !== "function") throw new $TypeError("a function is required");
            var func = $reflectApply(bind, $call, arguments);
            return setFunctionLength2(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
        };
        var applyBind = function applyBind2() {
            return $reflectApply(bind, $apply, arguments);
        };
        if ($defineProperty) $defineProperty(module.exports, "apply", {
            value: applyBind
        });
        else module.exports.apply = applyBind;
    })($be59461d4a783f7b$var$callBind);
    return $be59461d4a783f7b$var$callBind.exports;
}
var $be59461d4a783f7b$var$callBound;
var $be59461d4a783f7b$var$hasRequiredCallBound;
function $be59461d4a783f7b$var$requireCallBound() {
    if ($be59461d4a783f7b$var$hasRequiredCallBound) return $be59461d4a783f7b$var$callBound;
    $be59461d4a783f7b$var$hasRequiredCallBound = 1;
    var GetIntrinsic = /* @__PURE__ */ $be59461d4a783f7b$var$requireGetIntrinsic();
    var callBind2 = $be59461d4a783f7b$var$requireCallBind();
    var $indexOf = callBind2(GetIntrinsic("String.prototype.indexOf"));
    $be59461d4a783f7b$var$callBound = function callBoundIntrinsic(name, allowMissing) {
        var intrinsic = GetIntrinsic(name, !!allowMissing);
        if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind2(intrinsic);
        return intrinsic;
    };
    return $be59461d4a783f7b$var$callBound;
}
var $be59461d4a783f7b$var$isArguments;
var $be59461d4a783f7b$var$hasRequiredIsArguments;
function $be59461d4a783f7b$var$requireIsArguments() {
    if ($be59461d4a783f7b$var$hasRequiredIsArguments) return $be59461d4a783f7b$var$isArguments;
    $be59461d4a783f7b$var$hasRequiredIsArguments = 1;
    var hasToStringTag = $be59461d4a783f7b$var$requireShams()();
    var callBound2 = $be59461d4a783f7b$var$requireCallBound();
    var $toString = callBound2("Object.prototype.toString");
    var isStandardArguments = function isArguments2(value) {
        if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
        return $toString(value) === "[object Arguments]";
    };
    var isLegacyArguments = function isArguments2(value) {
        if (isStandardArguments(value)) return true;
        return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
    };
    var supportsStandardArguments = function() {
        return isStandardArguments(arguments);
    }();
    isStandardArguments.isLegacyArguments = isLegacyArguments;
    $be59461d4a783f7b$var$isArguments = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
    return $be59461d4a783f7b$var$isArguments;
}
var $be59461d4a783f7b$var$isGeneratorFunction;
var $be59461d4a783f7b$var$hasRequiredIsGeneratorFunction;
function $be59461d4a783f7b$var$requireIsGeneratorFunction() {
    if ($be59461d4a783f7b$var$hasRequiredIsGeneratorFunction) return $be59461d4a783f7b$var$isGeneratorFunction;
    $be59461d4a783f7b$var$hasRequiredIsGeneratorFunction = 1;
    var toStr = Object.prototype.toString;
    var fnToStr = Function.prototype.toString;
    var isFnRegex = /^\s*(?:function)?\*/;
    var hasToStringTag = $be59461d4a783f7b$var$requireShams()();
    var getProto2 = Object.getPrototypeOf;
    var getGeneratorFunc = function() {
        if (!hasToStringTag) return false;
        try {
            return Function("return function*() {}")();
        } catch (e) {}
    };
    var GeneratorFunction;
    $be59461d4a783f7b$var$isGeneratorFunction = function isGeneratorFunction2(fn) {
        if (typeof fn !== "function") return false;
        if (isFnRegex.test(fnToStr.call(fn))) return true;
        if (!hasToStringTag) {
            var str = toStr.call(fn);
            return str === "[object GeneratorFunction]";
        }
        if (!getProto2) return false;
        if (typeof GeneratorFunction === "undefined") {
            var generatorFunc = getGeneratorFunc();
            GeneratorFunction = generatorFunc ? getProto2(generatorFunc) : false;
        }
        return getProto2(fn) === GeneratorFunction;
    };
    return $be59461d4a783f7b$var$isGeneratorFunction;
}
var $be59461d4a783f7b$var$isCallable;
var $be59461d4a783f7b$var$hasRequiredIsCallable;
function $be59461d4a783f7b$var$requireIsCallable() {
    if ($be59461d4a783f7b$var$hasRequiredIsCallable) return $be59461d4a783f7b$var$isCallable;
    $be59461d4a783f7b$var$hasRequiredIsCallable = 1;
    var fnToStr = Function.prototype.toString;
    var reflectApply2 = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
    var badArrayLike;
    var isCallableMarker;
    if (typeof reflectApply2 === "function" && typeof Object.defineProperty === "function") try {
        badArrayLike = Object.defineProperty({}, "length", {
            get: function() {
                throw isCallableMarker;
            }
        });
        isCallableMarker = {};
        reflectApply2(function() {
            throw 42;
        }, null, badArrayLike);
    } catch (_) {
        if (_ !== isCallableMarker) reflectApply2 = null;
    }
    else reflectApply2 = null;
    var constructorRegex = /^\s*class\b/;
    var isES6ClassFn = function isES6ClassFunction(value) {
        try {
            var fnStr = fnToStr.call(value);
            return constructorRegex.test(fnStr);
        } catch (e) {
            return false;
        }
    };
    var tryFunctionObject = function tryFunctionToStr(value) {
        try {
            if (isES6ClassFn(value)) return false;
            fnToStr.call(value);
            return true;
        } catch (e) {
            return false;
        }
    };
    var toStr = Object.prototype.toString;
    var objectClass = "[object Object]";
    var fnClass = "[object Function]";
    var genClass = "[object GeneratorFunction]";
    var ddaClass = "[object HTMLAllCollection]";
    var ddaClass2 = "[object HTML document.all class]";
    var ddaClass3 = "[object HTMLCollection]";
    var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
    var isIE68 = !(0 in [
        , 
    ]);
    var isDDA = function isDocumentDotAll() {
        return false;
    };
    if (typeof document === "object") {
        var all = document.all;
        if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
            if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
                var str = toStr.call(value);
                return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value("") == null;
            } catch (e) {}
            return false;
        };
    }
    $be59461d4a783f7b$var$isCallable = reflectApply2 ? function isCallable2(value) {
        if (isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== "function" && typeof value !== "object") return false;
        try {
            reflectApply2(value, null, badArrayLike);
        } catch (e) {
            if (e !== isCallableMarker) return false;
        }
        return !isES6ClassFn(value) && tryFunctionObject(value);
    } : function isCallable2(value) {
        if (isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== "function" && typeof value !== "object") return false;
        if (hasToStringTag) return tryFunctionObject(value);
        if (isES6ClassFn(value)) return false;
        var strClass = toStr.call(value);
        if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
        return tryFunctionObject(value);
    };
    return $be59461d4a783f7b$var$isCallable;
}
var $be59461d4a783f7b$var$forEach_1;
var $be59461d4a783f7b$var$hasRequiredForEach;
function $be59461d4a783f7b$var$requireForEach() {
    if ($be59461d4a783f7b$var$hasRequiredForEach) return $be59461d4a783f7b$var$forEach_1;
    $be59461d4a783f7b$var$hasRequiredForEach = 1;
    var isCallable2 = $be59461d4a783f7b$var$requireIsCallable();
    var toStr = Object.prototype.toString;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var forEachArray = function forEachArray2(array, iterator, receiver) {
        for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
            if (receiver == null) iterator(array[i], i, array);
            else iterator.call(receiver, array[i], i, array);
        }
    };
    var forEachString = function forEachString2(string, iterator, receiver) {
        for(var i = 0, len = string.length; i < len; i++)if (receiver == null) iterator(string.charAt(i), i, string);
        else iterator.call(receiver, string.charAt(i), i, string);
    };
    var forEachObject = function forEachObject2(object, iterator, receiver) {
        for(var k in object)if (hasOwnProperty.call(object, k)) {
            if (receiver == null) iterator(object[k], k, object);
            else iterator.call(receiver, object[k], k, object);
        }
    };
    var forEach = function forEach2(list, iterator, thisArg) {
        if (!isCallable2(iterator)) throw new TypeError("iterator must be a function");
        var receiver;
        if (arguments.length >= 3) receiver = thisArg;
        if (toStr.call(list) === "[object Array]") forEachArray(list, iterator, receiver);
        else if (typeof list === "string") forEachString(list, iterator, receiver);
        else forEachObject(list, iterator, receiver);
    };
    $be59461d4a783f7b$var$forEach_1 = forEach;
    return $be59461d4a783f7b$var$forEach_1;
}
var $be59461d4a783f7b$var$possibleTypedArrayNames;
var $be59461d4a783f7b$var$hasRequiredPossibleTypedArrayNames;
function $be59461d4a783f7b$var$requirePossibleTypedArrayNames() {
    if ($be59461d4a783f7b$var$hasRequiredPossibleTypedArrayNames) return $be59461d4a783f7b$var$possibleTypedArrayNames;
    $be59461d4a783f7b$var$hasRequiredPossibleTypedArrayNames = 1;
    $be59461d4a783f7b$var$possibleTypedArrayNames = [
        "Float32Array",
        "Float64Array",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "BigInt64Array",
        "BigUint64Array"
    ];
    return $be59461d4a783f7b$var$possibleTypedArrayNames;
}
var $be59461d4a783f7b$var$availableTypedArrays;
var $be59461d4a783f7b$var$hasRequiredAvailableTypedArrays;
function $be59461d4a783f7b$var$requireAvailableTypedArrays() {
    if ($be59461d4a783f7b$var$hasRequiredAvailableTypedArrays) return $be59461d4a783f7b$var$availableTypedArrays;
    $be59461d4a783f7b$var$hasRequiredAvailableTypedArrays = 1;
    var possibleNames = /* @__PURE__ */ $be59461d4a783f7b$var$requirePossibleTypedArrayNames();
    var g = typeof globalThis === "undefined" ? $be59461d4a783f7b$var$commonjsGlobal : globalThis;
    $be59461d4a783f7b$var$availableTypedArrays = function availableTypedArrays2() {
        var out = [];
        for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === "function") out[out.length] = possibleNames[i];
        return out;
    };
    return $be59461d4a783f7b$var$availableTypedArrays;
}
var $be59461d4a783f7b$var$whichTypedArray;
var $be59461d4a783f7b$var$hasRequiredWhichTypedArray;
function $be59461d4a783f7b$var$requireWhichTypedArray() {
    if ($be59461d4a783f7b$var$hasRequiredWhichTypedArray) return $be59461d4a783f7b$var$whichTypedArray;
    $be59461d4a783f7b$var$hasRequiredWhichTypedArray = 1;
    var forEach = $be59461d4a783f7b$var$requireForEach();
    var availableTypedArrays2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireAvailableTypedArrays();
    var callBind2 = $be59461d4a783f7b$var$requireCallBind();
    var callBound2 = $be59461d4a783f7b$var$requireCallBound();
    var gOPD2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireGopd();
    var $toString = callBound2("Object.prototype.toString");
    var hasToStringTag = $be59461d4a783f7b$var$requireShams()();
    var g = typeof globalThis === "undefined" ? $be59461d4a783f7b$var$commonjsGlobal : globalThis;
    var typedArrays = availableTypedArrays2();
    var $slice = callBound2("String.prototype.slice");
    var getPrototypeOf = Object.getPrototypeOf;
    var $indexOf = callBound2("Array.prototype.indexOf", true) || function indexOf(array, value) {
        for(var i = 0; i < array.length; i += 1){
            if (array[i] === value) return i;
        }
        return -1;
    };
    var cache = {
        __proto__: null
    };
    if (hasToStringTag && gOPD2 && getPrototypeOf) forEach(typedArrays, function(typedArray) {
        var arr = new g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = getPrototypeOf(arr);
            var descriptor = gOPD2(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = getPrototypeOf(proto);
                descriptor = gOPD2(superProto, Symbol.toStringTag);
            }
            cache["$" + typedArray] = callBind2(descriptor.get);
        }
    });
    else forEach(typedArrays, function(typedArray) {
        var arr = new g[typedArray]();
        var fn = arr.slice || arr.set;
        if (fn) cache["$" + typedArray] = callBind2(fn);
    });
    var tryTypedArrays = function tryAllTypedArrays(value) {
        var found = false;
        forEach(// eslint-disable-next-line no-extra-parens
        /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
            if (!found) try {
                if ("$" + getter(value) === typedArray) found = $slice(typedArray, 1);
            } catch (e) {}
        });
        return found;
    };
    var trySlices = function tryAllSlices(value) {
        var found = false;
        forEach(// eslint-disable-next-line no-extra-parens
        /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
            if (!found) try {
                getter(value);
                found = $slice(name, 1);
            } catch (e) {}
        });
        return found;
    };
    $be59461d4a783f7b$var$whichTypedArray = function whichTypedArray2(value) {
        if (!value || typeof value !== "object") return false;
        if (!hasToStringTag) {
            var tag = $slice($toString(value), 8, -1);
            if ($indexOf(typedArrays, tag) > -1) return tag;
            if (tag !== "Object") return false;
            return trySlices(value);
        }
        if (!gOPD2) return null;
        return tryTypedArrays(value);
    };
    return $be59461d4a783f7b$var$whichTypedArray;
}
var $be59461d4a783f7b$var$isTypedArray;
var $be59461d4a783f7b$var$hasRequiredIsTypedArray;
function $be59461d4a783f7b$var$requireIsTypedArray() {
    if ($be59461d4a783f7b$var$hasRequiredIsTypedArray) return $be59461d4a783f7b$var$isTypedArray;
    $be59461d4a783f7b$var$hasRequiredIsTypedArray = 1;
    var whichTypedArray2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireWhichTypedArray();
    $be59461d4a783f7b$var$isTypedArray = function isTypedArray2(value) {
        return !!whichTypedArray2(value);
    };
    return $be59461d4a783f7b$var$isTypedArray;
}
var $be59461d4a783f7b$var$hasRequiredTypes;
function $be59461d4a783f7b$var$requireTypes() {
    if ($be59461d4a783f7b$var$hasRequiredTypes) return $be59461d4a783f7b$var$types;
    $be59461d4a783f7b$var$hasRequiredTypes = 1;
    (function(exports) {
        var isArgumentsObject = $be59461d4a783f7b$var$requireIsArguments();
        var isGeneratorFunction2 = $be59461d4a783f7b$var$requireIsGeneratorFunction();
        var whichTypedArray2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireWhichTypedArray();
        var isTypedArray2 = /* @__PURE__ */ $be59461d4a783f7b$var$requireIsTypedArray();
        function uncurryThis(f) {
            return f.call.bind(f);
        }
        var BigIntSupported = typeof BigInt !== "undefined";
        var SymbolSupported = typeof Symbol !== "undefined";
        var ObjectToString = uncurryThis(Object.prototype.toString);
        var numberValue = uncurryThis(Number.prototype.valueOf);
        var stringValue = uncurryThis(String.prototype.valueOf);
        var booleanValue = uncurryThis(Boolean.prototype.valueOf);
        if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
        if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
        function checkBoxedPrimitive(value, prototypeValueOf) {
            if (typeof value !== "object") return false;
            try {
                prototypeValueOf(value);
                return true;
            } catch (e) {
                return false;
            }
        }
        exports.isArgumentsObject = isArgumentsObject;
        exports.isGeneratorFunction = isGeneratorFunction2;
        exports.isTypedArray = isTypedArray2;
        function isPromise(input) {
            return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
        }
        exports.isPromise = isPromise;
        function isArrayBufferView(value) {
            if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
            return isTypedArray2(value) || isDataView(value);
        }
        exports.isArrayBufferView = isArrayBufferView;
        function isUint8Array(value) {
            return whichTypedArray2(value) === "Uint8Array";
        }
        exports.isUint8Array = isUint8Array;
        function isUint8ClampedArray(value) {
            return whichTypedArray2(value) === "Uint8ClampedArray";
        }
        exports.isUint8ClampedArray = isUint8ClampedArray;
        function isUint16Array(value) {
            return whichTypedArray2(value) === "Uint16Array";
        }
        exports.isUint16Array = isUint16Array;
        function isUint32Array(value) {
            return whichTypedArray2(value) === "Uint32Array";
        }
        exports.isUint32Array = isUint32Array;
        function isInt8Array(value) {
            return whichTypedArray2(value) === "Int8Array";
        }
        exports.isInt8Array = isInt8Array;
        function isInt16Array(value) {
            return whichTypedArray2(value) === "Int16Array";
        }
        exports.isInt16Array = isInt16Array;
        function isInt32Array(value) {
            return whichTypedArray2(value) === "Int32Array";
        }
        exports.isInt32Array = isInt32Array;
        function isFloat32Array(value) {
            return whichTypedArray2(value) === "Float32Array";
        }
        exports.isFloat32Array = isFloat32Array;
        function isFloat64Array(value) {
            return whichTypedArray2(value) === "Float64Array";
        }
        exports.isFloat64Array = isFloat64Array;
        function isBigInt64Array(value) {
            return whichTypedArray2(value) === "BigInt64Array";
        }
        exports.isBigInt64Array = isBigInt64Array;
        function isBigUint64Array(value) {
            return whichTypedArray2(value) === "BigUint64Array";
        }
        exports.isBigUint64Array = isBigUint64Array;
        function isMapToString(value) {
            return ObjectToString(value) === "[object Map]";
        }
        isMapToString.working = typeof Map !== "undefined" && isMapToString(/* @__PURE__ */ new Map());
        function isMap(value) {
            if (typeof Map === "undefined") return false;
            return isMapToString.working ? isMapToString(value) : value instanceof Map;
        }
        exports.isMap = isMap;
        function isSetToString(value) {
            return ObjectToString(value) === "[object Set]";
        }
        isSetToString.working = typeof Set !== "undefined" && isSetToString(/* @__PURE__ */ new Set());
        function isSet(value) {
            if (typeof Set === "undefined") return false;
            return isSetToString.working ? isSetToString(value) : value instanceof Set;
        }
        exports.isSet = isSet;
        function isWeakMapToString(value) {
            return ObjectToString(value) === "[object WeakMap]";
        }
        isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(/* @__PURE__ */ new WeakMap());
        function isWeakMap(value) {
            if (typeof WeakMap === "undefined") return false;
            return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
        }
        exports.isWeakMap = isWeakMap;
        function isWeakSetToString(value) {
            return ObjectToString(value) === "[object WeakSet]";
        }
        isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(/* @__PURE__ */ new WeakSet());
        function isWeakSet(value) {
            return isWeakSetToString(value);
        }
        exports.isWeakSet = isWeakSet;
        function isArrayBufferToString(value) {
            return ObjectToString(value) === "[object ArrayBuffer]";
        }
        isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
        function isArrayBuffer(value) {
            if (typeof ArrayBuffer === "undefined") return false;
            return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
        }
        exports.isArrayBuffer = isArrayBuffer;
        function isDataViewToString(value) {
            return ObjectToString(value) === "[object DataView]";
        }
        isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
        function isDataView(value) {
            if (typeof DataView === "undefined") return false;
            return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
        }
        exports.isDataView = isDataView;
        var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : void 0;
        function isSharedArrayBufferToString(value) {
            return ObjectToString(value) === "[object SharedArrayBuffer]";
        }
        function isSharedArrayBuffer(value) {
            if (typeof SharedArrayBufferCopy === "undefined") return false;
            if (typeof isSharedArrayBufferToString.working === "undefined") isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
            return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
        }
        exports.isSharedArrayBuffer = isSharedArrayBuffer;
        function isAsyncFunction(value) {
            return ObjectToString(value) === "[object AsyncFunction]";
        }
        exports.isAsyncFunction = isAsyncFunction;
        function isMapIterator(value) {
            return ObjectToString(value) === "[object Map Iterator]";
        }
        exports.isMapIterator = isMapIterator;
        function isSetIterator(value) {
            return ObjectToString(value) === "[object Set Iterator]";
        }
        exports.isSetIterator = isSetIterator;
        function isGeneratorObject(value) {
            return ObjectToString(value) === "[object Generator]";
        }
        exports.isGeneratorObject = isGeneratorObject;
        function isWebAssemblyCompiledModule(value) {
            return ObjectToString(value) === "[object WebAssembly.Module]";
        }
        exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
        function isNumberObject(value) {
            return checkBoxedPrimitive(value, numberValue);
        }
        exports.isNumberObject = isNumberObject;
        function isStringObject(value) {
            return checkBoxedPrimitive(value, stringValue);
        }
        exports.isStringObject = isStringObject;
        function isBooleanObject(value) {
            return checkBoxedPrimitive(value, booleanValue);
        }
        exports.isBooleanObject = isBooleanObject;
        function isBigIntObject(value) {
            return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
        }
        exports.isBigIntObject = isBigIntObject;
        function isSymbolObject(value) {
            return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
        }
        exports.isSymbolObject = isSymbolObject;
        function isBoxedPrimitive(value) {
            return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
        }
        exports.isBoxedPrimitive = isBoxedPrimitive;
        function isAnyArrayBuffer(value) {
            return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
        }
        exports.isAnyArrayBuffer = isAnyArrayBuffer;
        [
            "isProxy",
            "isExternal",
            "isModuleNamespaceObject"
        ].forEach(function(method) {
            Object.defineProperty(exports, method, {
                enumerable: false,
                value: function() {
                    throw new Error(method + " is not supported in userland");
                }
            });
        });
    })($be59461d4a783f7b$var$types);
    return $be59461d4a783f7b$var$types;
}
var $be59461d4a783f7b$var$isBufferBrowser;
var $be59461d4a783f7b$var$hasRequiredIsBufferBrowser;
function $be59461d4a783f7b$var$requireIsBufferBrowser() {
    if ($be59461d4a783f7b$var$hasRequiredIsBufferBrowser) return $be59461d4a783f7b$var$isBufferBrowser;
    $be59461d4a783f7b$var$hasRequiredIsBufferBrowser = 1;
    $be59461d4a783f7b$var$isBufferBrowser = function isBuffer(arg) {
        return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
    };
    return $be59461d4a783f7b$var$isBufferBrowser;
}
var $be59461d4a783f7b$var$hasRequiredUtil;
function $be59461d4a783f7b$var$requireUtil() {
    if ($be59461d4a783f7b$var$hasRequiredUtil) return $be59461d4a783f7b$var$util;
    $be59461d4a783f7b$var$hasRequiredUtil = 1;
    (function(exports) {
        var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors2(obj) {
            var keys = Object.keys(obj);
            var descriptors = {};
            for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
            return descriptors;
        };
        var formatRegExp = /%[sdj%]/g;
        exports.format = function(f) {
            if (!isString(f)) {
                var objects = [];
                for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
                return objects.join(" ");
            }
            var i = 1;
            var args = arguments;
            var len = args.length;
            var str = String(f).replace(formatRegExp, function(x2) {
                if (x2 === "%%") return "%";
                if (i >= len) return x2;
                switch(x2){
                    case "%s":
                        return String(args[i++]);
                    case "%d":
                        return Number(args[i++]);
                    case "%j":
                        try {
                            return JSON.stringify(args[i++]);
                        } catch (_) {
                            return "[Circular]";
                        }
                    default:
                        return x2;
                }
            });
            for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
            else str += " " + inspect(x);
            return str;
        };
        exports.deprecate = function(fn, msg) {
            if (typeof $be59461d4a783f7b$var$process$1 !== "undefined" && $be59461d4a783f7b$var$process$1.noDeprecation === true) return fn;
            if (typeof $be59461d4a783f7b$var$process$1 === "undefined") return function() {
                return exports.deprecate(fn, msg).apply(this, arguments);
            };
            var warned = false;
            function deprecated() {
                if (!warned) {
                    if ($be59461d4a783f7b$var$process$1.throwDeprecation) throw new Error(msg);
                    else if ($be59461d4a783f7b$var$process$1.traceDeprecation) console.trace(msg);
                    else console.error(msg);
                    warned = true;
                }
                return fn.apply(this, arguments);
            }
            return deprecated;
        };
        var debugs = {};
        var debugEnvRegex = /^$/;
        if ($be59461d4a783f7b$var$process$1.env.NODE_DEBUG) {
            var debugEnv = $be59461d4a783f7b$var$process$1.env.NODE_DEBUG;
            debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
            debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
        }
        exports.debuglog = function(set) {
            set = set.toUpperCase();
            if (!debugs[set]) {
                if (debugEnvRegex.test(set)) {
                    var pid = $be59461d4a783f7b$var$process$1.pid;
                    debugs[set] = function() {
                        var msg = exports.format.apply(exports, arguments);
                        console.error("%s %d: %s", set, pid, msg);
                    };
                } else debugs[set] = function() {};
            }
            return debugs[set];
        };
        function inspect(obj, opts) {
            var ctx = {
                seen: [],
                stylize: stylizeNoColor
            };
            if (arguments.length >= 3) ctx.depth = arguments[2];
            if (arguments.length >= 4) ctx.colors = arguments[3];
            if (isBoolean(opts)) ctx.showHidden = opts;
            else if (opts) exports._extend(ctx, opts);
            if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
            if (isUndefined(ctx.depth)) ctx.depth = 2;
            if (isUndefined(ctx.colors)) ctx.colors = false;
            if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
            if (ctx.colors) ctx.stylize = stylizeWithColor;
            return formatValue(ctx, obj, ctx.depth);
        }
        exports.inspect = inspect;
        inspect.colors = {
            "bold": [
                1,
                22
            ],
            "italic": [
                3,
                23
            ],
            "underline": [
                4,
                24
            ],
            "inverse": [
                7,
                27
            ],
            "white": [
                37,
                39
            ],
            "grey": [
                90,
                39
            ],
            "black": [
                30,
                39
            ],
            "blue": [
                34,
                39
            ],
            "cyan": [
                36,
                39
            ],
            "green": [
                32,
                39
            ],
            "magenta": [
                35,
                39
            ],
            "red": [
                31,
                39
            ],
            "yellow": [
                33,
                39
            ]
        };
        inspect.styles = {
            "special": "cyan",
            "number": "yellow",
            "boolean": "yellow",
            "undefined": "grey",
            "null": "bold",
            "string": "green",
            "date": "magenta",
            // "name": intentionally not styling
            "regexp": "red"
        };
        function stylizeWithColor(str, styleType) {
            var style = inspect.styles[styleType];
            if (style) return "\x1B[" + inspect.colors[style][0] + "m" + str + "\x1B[" + inspect.colors[style][1] + "m";
            else return str;
        }
        function stylizeNoColor(str, styleType) {
            return str;
        }
        function arrayToHash(array) {
            var hash2 = {};
            array.forEach(function(val, idx) {
                hash2[val] = true;
            });
            return hash2;
        }
        function formatValue(ctx, value, recurseTimes) {
            if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
            value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
            !(value.constructor && value.constructor.prototype === value)) {
                var ret = value.inspect(recurseTimes, ctx);
                if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
                return ret;
            }
            var primitive = formatPrimitive(ctx, value);
            if (primitive) return primitive;
            var keys = Object.keys(value);
            var visibleKeys = arrayToHash(keys);
            if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
            if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
            if (keys.length === 0) {
                if (isFunction(value)) {
                    var name = value.name ? ": " + value.name : "";
                    return ctx.stylize("[Function" + name + "]", "special");
                }
                if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
                if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
                if (isError(value)) return formatError(value);
            }
            var base = "", array = false, braces = [
                "{",
                "}"
            ];
            if (isArray(value)) {
                array = true;
                braces = [
                    "[",
                    "]"
                ];
            }
            if (isFunction(value)) {
                var n = value.name ? ": " + value.name : "";
                base = " [Function" + n + "]";
            }
            if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
            if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
            if (isError(value)) base = " " + formatError(value);
            if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
            if (recurseTimes < 0) {
                if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
                else return ctx.stylize("[Object]", "special");
            }
            ctx.seen.push(value);
            var output;
            if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
            else output = keys.map(function(key) {
                return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
            });
            ctx.seen.pop();
            return reduceToSingleString(output, base, braces);
        }
        function formatPrimitive(ctx, value) {
            if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
            if (isString(value)) {
                var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return ctx.stylize(simple, "string");
            }
            if (isNumber(value)) return ctx.stylize("" + value, "number");
            if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
            if (isNull(value)) return ctx.stylize("null", "null");
        }
        function formatError(value) {
            return "[" + Error.prototype.toString.call(value) + "]";
        }
        function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
            var output = [];
            for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
            else output.push("");
            keys.forEach(function(key) {
                if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
            });
            return output;
        }
        function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
            var name, str, desc;
            desc = Object.getOwnPropertyDescriptor(value, key) || {
                value: value[key]
            };
            if (desc.get) {
                if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
                else str = ctx.stylize("[Getter]", "special");
            } else if (desc.set) str = ctx.stylize("[Setter]", "special");
            if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
            if (!str) {
                if (ctx.seen.indexOf(desc.value) < 0) {
                    if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                    else str = formatValue(ctx, desc.value, recurseTimes - 1);
                    if (str.indexOf("\n") > -1) {
                        if (array) str = str.split("\n").map(function(line) {
                            return "  " + line;
                        }).join("\n").slice(2);
                        else str = "\n" + str.split("\n").map(function(line) {
                            return "   " + line;
                        }).join("\n");
                    }
                } else str = ctx.stylize("[Circular]", "special");
            }
            if (isUndefined(name)) {
                if (array && key.match(/^\d+$/)) return str;
                name = JSON.stringify("" + key);
                if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                    name = name.slice(1, -1);
                    name = ctx.stylize(name, "name");
                } else {
                    name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                    name = ctx.stylize(name, "string");
                }
            }
            return name + ": " + str;
        }
        function reduceToSingleString(output, base, braces) {
            var length = output.reduce(function(prev, cur) {
                cur.indexOf("\n");
                return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
            return braces[0] + base + " " + output.join(", ") + " " + braces[1];
        }
        exports.types = $be59461d4a783f7b$var$requireTypes();
        function isArray(ar) {
            return Array.isArray(ar);
        }
        exports.isArray = isArray;
        function isBoolean(arg) {
            return typeof arg === "boolean";
        }
        exports.isBoolean = isBoolean;
        function isNull(arg) {
            return arg === null;
        }
        exports.isNull = isNull;
        function isNullOrUndefined(arg) {
            return arg == null;
        }
        exports.isNullOrUndefined = isNullOrUndefined;
        function isNumber(arg) {
            return typeof arg === "number";
        }
        exports.isNumber = isNumber;
        function isString(arg) {
            return typeof arg === "string";
        }
        exports.isString = isString;
        function isSymbol(arg) {
            return typeof arg === "symbol";
        }
        exports.isSymbol = isSymbol;
        function isUndefined(arg) {
            return arg === void 0;
        }
        exports.isUndefined = isUndefined;
        function isRegExp(re) {
            return isObject(re) && objectToString(re) === "[object RegExp]";
        }
        exports.isRegExp = isRegExp;
        exports.types.isRegExp = isRegExp;
        function isObject(arg) {
            return typeof arg === "object" && arg !== null;
        }
        exports.isObject = isObject;
        function isDate(d) {
            return isObject(d) && objectToString(d) === "[object Date]";
        }
        exports.isDate = isDate;
        exports.types.isDate = isDate;
        function isError(e) {
            return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
        }
        exports.isError = isError;
        exports.types.isNativeError = isError;
        function isFunction(arg) {
            return typeof arg === "function";
        }
        exports.isFunction = isFunction;
        function isPrimitive(arg) {
            return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
            typeof arg === "undefined";
        }
        exports.isPrimitive = isPrimitive;
        exports.isBuffer = $be59461d4a783f7b$var$requireIsBufferBrowser();
        function objectToString(o) {
            return Object.prototype.toString.call(o);
        }
        function pad(n) {
            return n < 10 ? "0" + n.toString(10) : n.toString(10);
        }
        var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        function timestamp() {
            var d = /* @__PURE__ */ new Date();
            var time = [
                pad(d.getHours()),
                pad(d.getMinutes()),
                pad(d.getSeconds())
            ].join(":");
            return [
                d.getDate(),
                months[d.getMonth()],
                time
            ].join(" ");
        }
        exports.log = function() {
            console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
        };
        exports.inherits = $be59461d4a783f7b$var$requireInherits_browser();
        exports._extend = function(origin, add) {
            if (!add || !isObject(add)) return origin;
            var keys = Object.keys(add);
            var i = keys.length;
            while(i--)origin[keys[i]] = add[keys[i]];
            return origin;
        };
        function hasOwnProperty(obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
        }
        var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : void 0;
        exports.promisify = function promisify(original) {
            if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
            if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
                var fn = original[kCustomPromisifiedSymbol];
                if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                    value: fn,
                    enumerable: false,
                    writable: false,
                    configurable: true
                });
                return fn;
            }
            function fn() {
                var promiseResolve, promiseReject;
                var promise = new Promise(function(resolve, reject) {
                    promiseResolve = resolve;
                    promiseReject = reject;
                });
                var args = [];
                for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                args.push(function(err, value) {
                    if (err) promiseReject(err);
                    else promiseResolve(value);
                });
                try {
                    original.apply(this, args);
                } catch (err) {
                    promiseReject(err);
                }
                return promise;
            }
            Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
            if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
            });
            return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
        };
        exports.promisify.custom = kCustomPromisifiedSymbol;
        function callbackifyOnRejected(reason, cb) {
            if (!reason) {
                var newReason = new Error("Promise was rejected with a falsy value");
                newReason.reason = reason;
                reason = newReason;
            }
            return cb(reason);
        }
        function callbackify(original) {
            if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
            function callbackified() {
                var args = [];
                for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                var maybeCb = args.pop();
                if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
                var self2 = this;
                var cb = function() {
                    return maybeCb.apply(self2, arguments);
                };
                original.apply(this, args).then(function(ret) {
                    $be59461d4a783f7b$var$process$1.nextTick(cb.bind(null, null, ret));
                }, function(rej) {
                    $be59461d4a783f7b$var$process$1.nextTick(callbackifyOnRejected.bind(null, rej, cb));
                });
            }
            Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
            Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
            return callbackified;
        }
        exports.callbackify = callbackify;
    })($be59461d4a783f7b$var$util);
    return $be59461d4a783f7b$var$util;
}
var $be59461d4a783f7b$var$buffer_list;
var $be59461d4a783f7b$var$hasRequiredBuffer_list;
function $be59461d4a783f7b$var$requireBuffer_list() {
    if ($be59461d4a783f7b$var$hasRequiredBuffer_list) return $be59461d4a783f7b$var$buffer_list;
    $be59461d4a783f7b$var$hasRequiredBuffer_list = 1;
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        return Constructor;
    }
    var _require = $be59461d4a783f7b$var$requireBuffer(), Buffer2 = _require.Buffer;
    var _require2 = $be59461d4a783f7b$var$requireUtil(), inspect = _require2.inspect;
    var custom = inspect && inspect.custom || "inspect";
    function copyBuffer(src, target, offset) {
        Buffer2.prototype.copy.call(src, target, offset);
    }
    $be59461d4a783f7b$var$buffer_list = /* @__PURE__ */ function() {
        function BufferList() {
            _classCallCheck(this, BufferList);
            this.head = null;
            this.tail = null;
            this.length = 0;
        }
        _createClass(BufferList, [
            {
                key: "push",
                value: function push(v) {
                    var entry = {
                        data: v,
                        next: null
                    };
                    if (this.length > 0) this.tail.next = entry;
                    else this.head = entry;
                    this.tail = entry;
                    ++this.length;
                }
            },
            {
                key: "unshift",
                value: function unshift(v) {
                    var entry = {
                        data: v,
                        next: this.head
                    };
                    if (this.length === 0) this.tail = entry;
                    this.head = entry;
                    ++this.length;
                }
            },
            {
                key: "shift",
                value: function shift() {
                    if (this.length === 0) return;
                    var ret = this.head.data;
                    if (this.length === 1) this.head = this.tail = null;
                    else this.head = this.head.next;
                    --this.length;
                    return ret;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
            },
            {
                key: "join",
                value: function join(s) {
                    if (this.length === 0) return "";
                    var p = this.head;
                    var ret = "" + p.data;
                    while(p = p.next)ret += s + p.data;
                    return ret;
                }
            },
            {
                key: "concat",
                value: function concat(n) {
                    if (this.length === 0) return Buffer2.alloc(0);
                    var ret = Buffer2.allocUnsafe(n >>> 0);
                    var p = this.head;
                    var i = 0;
                    while(p){
                        copyBuffer(p.data, ret, i);
                        i += p.data.length;
                        p = p.next;
                    }
                    return ret;
                }
            },
            {
                key: "consume",
                value: function consume(n, hasStrings) {
                    var ret;
                    if (n < this.head.data.length) {
                        ret = this.head.data.slice(0, n);
                        this.head.data = this.head.data.slice(n);
                    } else if (n === this.head.data.length) ret = this.shift();
                    else ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                    return ret;
                }
            },
            {
                key: "first",
                value: function first() {
                    return this.head.data;
                }
            },
            {
                key: "_getString",
                value: function _getString(n) {
                    var p = this.head;
                    var c = 1;
                    var ret = p.data;
                    n -= ret.length;
                    while(p = p.next){
                        var str = p.data;
                        var nb = n > str.length ? str.length : n;
                        if (nb === str.length) ret += str;
                        else ret += str.slice(0, n);
                        n -= nb;
                        if (n === 0) {
                            if (nb === str.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = str.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                }
            },
            {
                key: "_getBuffer",
                value: function _getBuffer(n) {
                    var ret = Buffer2.allocUnsafe(n);
                    var p = this.head;
                    var c = 1;
                    p.data.copy(ret);
                    n -= p.data.length;
                    while(p = p.next){
                        var buf = p.data;
                        var nb = n > buf.length ? buf.length : n;
                        buf.copy(ret, ret.length - n, 0, nb);
                        n -= nb;
                        if (n === 0) {
                            if (nb === buf.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = buf.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                }
            },
            {
                key: custom,
                value: function value(_, options) {
                    return inspect(this, _objectSpread({}, options, {
                        // Only inspect one level.
                        depth: 0,
                        // It should not recurse.
                        customInspect: false
                    }));
                }
            }
        ]);
        return BufferList;
    }();
    return $be59461d4a783f7b$var$buffer_list;
}
var $be59461d4a783f7b$var$destroy_1;
var $be59461d4a783f7b$var$hasRequiredDestroy;
function $be59461d4a783f7b$var$requireDestroy() {
    if ($be59461d4a783f7b$var$hasRequiredDestroy) return $be59461d4a783f7b$var$destroy_1;
    $be59461d4a783f7b$var$hasRequiredDestroy = 1;
    function destroy(err, cb) {
        var _this = this;
        var readableDestroyed = this._readableState && this._readableState.destroyed;
        var writableDestroyed = this._writableState && this._writableState.destroyed;
        if (readableDestroyed || writableDestroyed) {
            if (cb) cb(err);
            else if (err) {
                if (!this._writableState) $be59461d4a783f7b$var$process$1.nextTick(emitErrorNT, this, err);
                else if (!this._writableState.errorEmitted) {
                    this._writableState.errorEmitted = true;
                    $be59461d4a783f7b$var$process$1.nextTick(emitErrorNT, this, err);
                }
            }
            return this;
        }
        if (this._readableState) this._readableState.destroyed = true;
        if (this._writableState) this._writableState.destroyed = true;
        this._destroy(err || null, function(err2) {
            if (!cb && err2) {
                if (!_this._writableState) $be59461d4a783f7b$var$process$1.nextTick(emitErrorAndCloseNT, _this, err2);
                else if (!_this._writableState.errorEmitted) {
                    _this._writableState.errorEmitted = true;
                    $be59461d4a783f7b$var$process$1.nextTick(emitErrorAndCloseNT, _this, err2);
                } else $be59461d4a783f7b$var$process$1.nextTick(emitCloseNT, _this);
            } else if (cb) {
                $be59461d4a783f7b$var$process$1.nextTick(emitCloseNT, _this);
                cb(err2);
            } else $be59461d4a783f7b$var$process$1.nextTick(emitCloseNT, _this);
        });
        return this;
    }
    function emitErrorAndCloseNT(self2, err) {
        emitErrorNT(self2, err);
        emitCloseNT(self2);
    }
    function emitCloseNT(self2) {
        if (self2._writableState && !self2._writableState.emitClose) return;
        if (self2._readableState && !self2._readableState.emitClose) return;
        self2.emit("close");
    }
    function undestroy() {
        if (this._readableState) {
            this._readableState.destroyed = false;
            this._readableState.reading = false;
            this._readableState.ended = false;
            this._readableState.endEmitted = false;
        }
        if (this._writableState) {
            this._writableState.destroyed = false;
            this._writableState.ended = false;
            this._writableState.ending = false;
            this._writableState.finalCalled = false;
            this._writableState.prefinished = false;
            this._writableState.finished = false;
            this._writableState.errorEmitted = false;
        }
    }
    function emitErrorNT(self2, err) {
        self2.emit("error", err);
    }
    function errorOrDestroy(stream, err) {
        var rState = stream._readableState;
        var wState = stream._writableState;
        if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
        else stream.emit("error", err);
    }
    $be59461d4a783f7b$var$destroy_1 = {
        destroy: destroy,
        undestroy: undestroy,
        errorOrDestroy: errorOrDestroy
    };
    return $be59461d4a783f7b$var$destroy_1;
}
var $be59461d4a783f7b$var$errorsBrowser = {};
var $be59461d4a783f7b$var$hasRequiredErrorsBrowser;
function $be59461d4a783f7b$var$requireErrorsBrowser() {
    if ($be59461d4a783f7b$var$hasRequiredErrorsBrowser) return $be59461d4a783f7b$var$errorsBrowser;
    $be59461d4a783f7b$var$hasRequiredErrorsBrowser = 1;
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var codes = {};
    function createErrorType(code, message, Base) {
        if (!Base) Base = Error;
        function getMessage(arg1, arg2, arg3) {
            if (typeof message === "string") return message;
            else return message(arg1, arg2, arg3);
        }
        var NodeError = /* @__PURE__ */ function(_Base) {
            _inheritsLoose(NodeError2, _Base);
            function NodeError2(arg1, arg2, arg3) {
                return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
            }
            return NodeError2;
        }(Base);
        NodeError.prototype.name = Base.name;
        NodeError.prototype.code = code;
        codes[code] = NodeError;
    }
    function oneOf(expected, thing) {
        if (Array.isArray(expected)) {
            var len = expected.length;
            expected = expected.map(function(i) {
                return String(i);
            });
            if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
            else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
            else return "of ".concat(thing, " ").concat(expected[0]);
        } else return "of ".concat(thing, " ").concat(String(expected));
    }
    function startsWith(str, search, pos) {
        return str.substr(0, search.length) === search;
    }
    function endsWith(str, search, this_len) {
        if (this_len === void 0 || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function includes(str, search, start) {
        if (typeof start !== "number") start = 0;
        if (start + search.length > str.length) return false;
        else return str.indexOf(search, start) !== -1;
    }
    createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
        return 'The value "' + value + '" is invalid for option "' + name + '"';
    }, TypeError);
    createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
        var determiner;
        if (typeof expected === "string" && startsWith(expected, "not ")) {
            determiner = "must not be";
            expected = expected.replace(/^not /, "");
        } else determiner = "must be";
        var msg;
        if (endsWith(name, " argument")) msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
        else {
            var type2 = includes(name, ".") ? "property" : "argument";
            msg = 'The "'.concat(name, '" ').concat(type2, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
        }
        msg += ". Received type ".concat(typeof actual);
        return msg;
    }, TypeError);
    createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
    createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
        return "The " + name + " method is not implemented";
    });
    createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
    createErrorType("ERR_STREAM_DESTROYED", function(name) {
        return "Cannot call " + name + " after a stream was destroyed";
    });
    createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
    createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
    createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
    createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
    createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
        return "Unknown encoding: " + arg;
    }, TypeError);
    createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
    $be59461d4a783f7b$var$errorsBrowser.codes = codes;
    return $be59461d4a783f7b$var$errorsBrowser;
}
var $be59461d4a783f7b$var$state;
var $be59461d4a783f7b$var$hasRequiredState;
function $be59461d4a783f7b$var$requireState() {
    if ($be59461d4a783f7b$var$hasRequiredState) return $be59461d4a783f7b$var$state;
    $be59461d4a783f7b$var$hasRequiredState = 1;
    var ERR_INVALID_OPT_VALUE = $be59461d4a783f7b$var$requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
    function highWaterMarkFrom(options, isDuplex, duplexKey) {
        return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
    }
    function getHighWaterMark(state2, options, duplexKey, isDuplex) {
        var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
        if (hwm != null) {
            if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                var name = isDuplex ? duplexKey : "highWaterMark";
                throw new ERR_INVALID_OPT_VALUE(name, hwm);
            }
            return Math.floor(hwm);
        }
        return state2.objectMode ? 16 : 16384;
    }
    $be59461d4a783f7b$var$state = {
        getHighWaterMark: getHighWaterMark
    };
    return $be59461d4a783f7b$var$state;
}
var $be59461d4a783f7b$var$browser;
var $be59461d4a783f7b$var$hasRequiredBrowser;
function $be59461d4a783f7b$var$requireBrowser() {
    if ($be59461d4a783f7b$var$hasRequiredBrowser) return $be59461d4a783f7b$var$browser;
    $be59461d4a783f7b$var$hasRequiredBrowser = 1;
    $be59461d4a783f7b$var$browser = deprecate;
    function deprecate(fn, msg) {
        if (config("noDeprecation")) return fn;
        var warned = false;
        function deprecated() {
            if (!warned) {
                if (config("throwDeprecation")) throw new Error(msg);
                else if (config("traceDeprecation")) console.trace(msg);
                else console.warn(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    }
    function config(name) {
        try {
            if (!$be59461d4a783f7b$var$commonjsGlobal.localStorage) return false;
        } catch (_) {
            return false;
        }
        var val = $be59461d4a783f7b$var$commonjsGlobal.localStorage[name];
        if (null == val) return false;
        return String(val).toLowerCase() === "true";
    }
    return $be59461d4a783f7b$var$browser;
}
var $be59461d4a783f7b$var$_stream_writable;
var $be59461d4a783f7b$var$hasRequired_stream_writable;
function $be59461d4a783f7b$var$require_stream_writable() {
    if ($be59461d4a783f7b$var$hasRequired_stream_writable) return $be59461d4a783f7b$var$_stream_writable;
    $be59461d4a783f7b$var$hasRequired_stream_writable = 1;
    $be59461d4a783f7b$var$_stream_writable = Writable;
    function CorkedRequest(state2) {
        var _this = this;
        this.next = null;
        this.entry = null;
        this.finish = function() {
            onCorkedFinish(_this, state2);
        };
    }
    var Duplex;
    Writable.WritableState = WritableState;
    var internalUtil = {
        deprecate: $be59461d4a783f7b$var$requireBrowser()
    };
    var Stream = $be59461d4a783f7b$var$requireStreamBrowser();
    var Buffer2 = $be59461d4a783f7b$var$requireBuffer().Buffer;
    var OurUint8Array = $be59461d4a783f7b$var$commonjsGlobal.Uint8Array || function() {};
    function _uint8ArrayToBuffer(chunk) {
        return Buffer2.from(chunk);
    }
    function _isUint8Array(obj) {
        return Buffer2.isBuffer(obj) || obj instanceof OurUint8Array;
    }
    var destroyImpl = $be59461d4a783f7b$var$requireDestroy();
    var _require = $be59461d4a783f7b$var$requireState(), getHighWaterMark = _require.getHighWaterMark;
    var _require$codes = $be59461d4a783f7b$var$requireErrorsBrowser().codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
    var errorOrDestroy = destroyImpl.errorOrDestroy;
    $be59461d4a783f7b$var$requireInherits_browser()(Writable, Stream);
    function nop() {}
    function WritableState(options, stream, isDuplex) {
        Duplex = Duplex || $be59461d4a783f7b$var$require_stream_duplex();
        options = options || {};
        if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
        this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
        this.finalCalled = false;
        this.needDrain = false;
        this.ending = false;
        this.ended = false;
        this.finished = false;
        this.destroyed = false;
        var noDecode = options.decodeStrings === false;
        this.decodeStrings = !noDecode;
        this.defaultEncoding = options.defaultEncoding || "utf8";
        this.length = 0;
        this.writing = false;
        this.corked = 0;
        this.sync = true;
        this.bufferProcessing = false;
        this.onwrite = function(er) {
            onwrite(stream, er);
        };
        this.writecb = null;
        this.writelen = 0;
        this.bufferedRequest = null;
        this.lastBufferedRequest = null;
        this.pendingcb = 0;
        this.prefinished = false;
        this.errorEmitted = false;
        this.emitClose = options.emitClose !== false;
        this.autoDestroy = !!options.autoDestroy;
        this.bufferedRequestCount = 0;
        this.corkedRequestsFree = new CorkedRequest(this);
    }
    WritableState.prototype.getBuffer = function getBuffer() {
        var current = this.bufferedRequest;
        var out = [];
        while(current){
            out.push(current);
            current = current.next;
        }
        return out;
    };
    (function() {
        try {
            Object.defineProperty(WritableState.prototype, "buffer", {
                get: internalUtil.deprecate(function writableStateBufferGetter() {
                    return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
        } catch (_) {}
    })();
    var realHasInstance;
    if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
        realHasInstance = Function.prototype[Symbol.hasInstance];
        Object.defineProperty(Writable, Symbol.hasInstance, {
            value: function value(object) {
                if (realHasInstance.call(this, object)) return true;
                if (this !== Writable) return false;
                return object && object._writableState instanceof WritableState;
            }
        });
    } else realHasInstance = function realHasInstance2(object) {
        return object instanceof this;
    };
    function Writable(options) {
        Duplex = Duplex || $be59461d4a783f7b$var$require_stream_duplex();
        var isDuplex = this instanceof Duplex;
        if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
        this._writableState = new WritableState(options, this, isDuplex);
        this.writable = true;
        if (options) {
            if (typeof options.write === "function") this._write = options.write;
            if (typeof options.writev === "function") this._writev = options.writev;
            if (typeof options.destroy === "function") this._destroy = options.destroy;
            if (typeof options.final === "function") this._final = options.final;
        }
        Stream.call(this);
    }
    Writable.prototype.pipe = function() {
        errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
    };
    function writeAfterEnd(stream, cb) {
        var er = new ERR_STREAM_WRITE_AFTER_END();
        errorOrDestroy(stream, er);
        $be59461d4a783f7b$var$process$1.nextTick(cb, er);
    }
    function validChunk(stream, state2, chunk, cb) {
        var er;
        if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
        else if (typeof chunk !== "string" && !state2.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer"
        ], chunk);
        if (er) {
            errorOrDestroy(stream, er);
            $be59461d4a783f7b$var$process$1.nextTick(cb, er);
            return false;
        }
        return true;
    }
    Writable.prototype.write = function(chunk, encoding, cb) {
        var state2 = this._writableState;
        var ret = false;
        var isBuf = !state2.objectMode && _isUint8Array(chunk);
        if (isBuf && !Buffer2.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
        if (typeof encoding === "function") {
            cb = encoding;
            encoding = null;
        }
        if (isBuf) encoding = "buffer";
        else if (!encoding) encoding = state2.defaultEncoding;
        if (typeof cb !== "function") cb = nop;
        if (state2.ending) writeAfterEnd(this, cb);
        else if (isBuf || validChunk(this, state2, chunk, cb)) {
            state2.pendingcb++;
            ret = writeOrBuffer(this, state2, isBuf, chunk, encoding, cb);
        }
        return ret;
    };
    Writable.prototype.cork = function() {
        this._writableState.corked++;
    };
    Writable.prototype.uncork = function() {
        var state2 = this._writableState;
        if (state2.corked) {
            state2.corked--;
            if (!state2.writing && !state2.corked && !state2.bufferProcessing && state2.bufferedRequest) clearBuffer(this, state2);
        }
    };
    Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
        if (typeof encoding === "string") encoding = encoding.toLowerCase();
        if (!([
            "hex",
            "utf8",
            "utf-8",
            "ascii",
            "binary",
            "base64",
            "ucs2",
            "ucs-2",
            "utf16le",
            "utf-16le",
            "raw"
        ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
        this._writableState.defaultEncoding = encoding;
        return this;
    };
    Object.defineProperty(Writable.prototype, "writableBuffer", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._writableState && this._writableState.getBuffer();
        }
    });
    function decodeChunk(state2, chunk, encoding) {
        if (!state2.objectMode && state2.decodeStrings !== false && typeof chunk === "string") chunk = Buffer2.from(chunk, encoding);
        return chunk;
    }
    Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._writableState.highWaterMark;
        }
    });
    function writeOrBuffer(stream, state2, isBuf, chunk, encoding, cb) {
        if (!isBuf) {
            var newChunk = decodeChunk(state2, chunk, encoding);
            if (chunk !== newChunk) {
                isBuf = true;
                encoding = "buffer";
                chunk = newChunk;
            }
        }
        var len = state2.objectMode ? 1 : chunk.length;
        state2.length += len;
        var ret = state2.length < state2.highWaterMark;
        if (!ret) state2.needDrain = true;
        if (state2.writing || state2.corked) {
            var last = state2.lastBufferedRequest;
            state2.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
            };
            if (last) last.next = state2.lastBufferedRequest;
            else state2.bufferedRequest = state2.lastBufferedRequest;
            state2.bufferedRequestCount += 1;
        } else doWrite(stream, state2, false, len, chunk, encoding, cb);
        return ret;
    }
    function doWrite(stream, state2, writev, len, chunk, encoding, cb) {
        state2.writelen = len;
        state2.writecb = cb;
        state2.writing = true;
        state2.sync = true;
        if (state2.destroyed) state2.onwrite(new ERR_STREAM_DESTROYED("write"));
        else if (writev) stream._writev(chunk, state2.onwrite);
        else stream._write(chunk, encoding, state2.onwrite);
        state2.sync = false;
    }
    function onwriteError(stream, state2, sync, er, cb) {
        --state2.pendingcb;
        if (sync) {
            $be59461d4a783f7b$var$process$1.nextTick(cb, er);
            $be59461d4a783f7b$var$process$1.nextTick(finishMaybe, stream, state2);
            stream._writableState.errorEmitted = true;
            errorOrDestroy(stream, er);
        } else {
            cb(er);
            stream._writableState.errorEmitted = true;
            errorOrDestroy(stream, er);
            finishMaybe(stream, state2);
        }
    }
    function onwriteStateUpdate(state2) {
        state2.writing = false;
        state2.writecb = null;
        state2.length -= state2.writelen;
        state2.writelen = 0;
    }
    function onwrite(stream, er) {
        var state2 = stream._writableState;
        var sync = state2.sync;
        var cb = state2.writecb;
        if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
        onwriteStateUpdate(state2);
        if (er) onwriteError(stream, state2, sync, er, cb);
        else {
            var finished = needFinish(state2) || stream.destroyed;
            if (!finished && !state2.corked && !state2.bufferProcessing && state2.bufferedRequest) clearBuffer(stream, state2);
            if (sync) $be59461d4a783f7b$var$process$1.nextTick(afterWrite, stream, state2, finished, cb);
            else afterWrite(stream, state2, finished, cb);
        }
    }
    function afterWrite(stream, state2, finished, cb) {
        if (!finished) onwriteDrain(stream, state2);
        state2.pendingcb--;
        cb();
        finishMaybe(stream, state2);
    }
    function onwriteDrain(stream, state2) {
        if (state2.length === 0 && state2.needDrain) {
            state2.needDrain = false;
            stream.emit("drain");
        }
    }
    function clearBuffer(stream, state2) {
        state2.bufferProcessing = true;
        var entry = state2.bufferedRequest;
        if (stream._writev && entry && entry.next) {
            var l = state2.bufferedRequestCount;
            var buffer2 = new Array(l);
            var holder = state2.corkedRequestsFree;
            holder.entry = entry;
            var count = 0;
            var allBuffers = true;
            while(entry){
                buffer2[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
            }
            buffer2.allBuffers = allBuffers;
            doWrite(stream, state2, true, state2.length, buffer2, "", holder.finish);
            state2.pendingcb++;
            state2.lastBufferedRequest = null;
            if (holder.next) {
                state2.corkedRequestsFree = holder.next;
                holder.next = null;
            } else state2.corkedRequestsFree = new CorkedRequest(state2);
            state2.bufferedRequestCount = 0;
        } else {
            while(entry){
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state2.objectMode ? 1 : chunk.length;
                doWrite(stream, state2, false, len, chunk, encoding, cb);
                entry = entry.next;
                state2.bufferedRequestCount--;
                if (state2.writing) break;
            }
            if (entry === null) state2.lastBufferedRequest = null;
        }
        state2.bufferedRequest = entry;
        state2.bufferProcessing = false;
    }
    Writable.prototype._write = function(chunk, encoding, cb) {
        cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
    };
    Writable.prototype._writev = null;
    Writable.prototype.end = function(chunk, encoding, cb) {
        var state2 = this._writableState;
        if (typeof chunk === "function") {
            cb = chunk;
            chunk = null;
            encoding = null;
        } else if (typeof encoding === "function") {
            cb = encoding;
            encoding = null;
        }
        if (chunk !== null && chunk !== void 0) this.write(chunk, encoding);
        if (state2.corked) {
            state2.corked = 1;
            this.uncork();
        }
        if (!state2.ending) endWritable(this, state2, cb);
        return this;
    };
    Object.defineProperty(Writable.prototype, "writableLength", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._writableState.length;
        }
    });
    function needFinish(state2) {
        return state2.ending && state2.length === 0 && state2.bufferedRequest === null && !state2.finished && !state2.writing;
    }
    function callFinal(stream, state2) {
        stream._final(function(err) {
            state2.pendingcb--;
            if (err) errorOrDestroy(stream, err);
            state2.prefinished = true;
            stream.emit("prefinish");
            finishMaybe(stream, state2);
        });
    }
    function prefinish(stream, state2) {
        if (!state2.prefinished && !state2.finalCalled) {
            if (typeof stream._final === "function" && !state2.destroyed) {
                state2.pendingcb++;
                state2.finalCalled = true;
                $be59461d4a783f7b$var$process$1.nextTick(callFinal, stream, state2);
            } else {
                state2.prefinished = true;
                stream.emit("prefinish");
            }
        }
    }
    function finishMaybe(stream, state2) {
        var need = needFinish(state2);
        if (need) {
            prefinish(stream, state2);
            if (state2.pendingcb === 0) {
                state2.finished = true;
                stream.emit("finish");
                if (state2.autoDestroy) {
                    var rState = stream._readableState;
                    if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                }
            }
        }
        return need;
    }
    function endWritable(stream, state2, cb) {
        state2.ending = true;
        finishMaybe(stream, state2);
        if (cb) {
            if (state2.finished) $be59461d4a783f7b$var$process$1.nextTick(cb);
            else stream.once("finish", cb);
        }
        state2.ended = true;
        stream.writable = false;
    }
    function onCorkedFinish(corkReq, state2, err) {
        var entry = corkReq.entry;
        corkReq.entry = null;
        while(entry){
            var cb = entry.callback;
            state2.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        state2.corkedRequestsFree.next = corkReq;
    }
    Object.defineProperty(Writable.prototype, "destroyed", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            if (this._writableState === void 0) return false;
            return this._writableState.destroyed;
        },
        set: function set(value) {
            if (!this._writableState) return;
            this._writableState.destroyed = value;
        }
    });
    Writable.prototype.destroy = destroyImpl.destroy;
    Writable.prototype._undestroy = destroyImpl.undestroy;
    Writable.prototype._destroy = function(err, cb) {
        cb(err);
    };
    return $be59461d4a783f7b$var$_stream_writable;
}
var $be59461d4a783f7b$var$_stream_duplex;
var $be59461d4a783f7b$var$hasRequired_stream_duplex;
function $be59461d4a783f7b$var$require_stream_duplex() {
    if ($be59461d4a783f7b$var$hasRequired_stream_duplex) return $be59461d4a783f7b$var$_stream_duplex;
    $be59461d4a783f7b$var$hasRequired_stream_duplex = 1;
    var objectKeys = Object.keys || function(obj) {
        var keys2 = [];
        for(var key in obj)keys2.push(key);
        return keys2;
    };
    $be59461d4a783f7b$var$_stream_duplex = Duplex;
    var Readable = $be59461d4a783f7b$var$require_stream_readable();
    var Writable = $be59461d4a783f7b$var$require_stream_writable();
    $be59461d4a783f7b$var$requireInherits_browser()(Duplex, Readable);
    var keys = objectKeys(Writable.prototype);
    for(var v = 0; v < keys.length; v++){
        var method = keys[v];
        if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
    }
    function Duplex(options) {
        if (!(this instanceof Duplex)) return new Duplex(options);
        Readable.call(this, options);
        Writable.call(this, options);
        this.allowHalfOpen = true;
        if (options) {
            if (options.readable === false) this.readable = false;
            if (options.writable === false) this.writable = false;
            if (options.allowHalfOpen === false) {
                this.allowHalfOpen = false;
                this.once("end", onend);
            }
        }
    }
    Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._writableState.highWaterMark;
        }
    });
    Object.defineProperty(Duplex.prototype, "writableBuffer", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._writableState && this._writableState.getBuffer();
        }
    });
    Object.defineProperty(Duplex.prototype, "writableLength", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._writableState.length;
        }
    });
    function onend() {
        if (this._writableState.ended) return;
        $be59461d4a783f7b$var$process$1.nextTick(onEndNT, this);
    }
    function onEndNT(self2) {
        self2.end();
    }
    Object.defineProperty(Duplex.prototype, "destroyed", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            if (this._readableState === void 0 || this._writableState === void 0) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(value) {
            if (this._readableState === void 0 || this._writableState === void 0) return;
            this._readableState.destroyed = value;
            this._writableState.destroyed = value;
        }
    });
    return $be59461d4a783f7b$var$_stream_duplex;
}
var $be59461d4a783f7b$var$string_decoder = {};
var $be59461d4a783f7b$var$safeBuffer = {
    exports: {}
};
var $be59461d4a783f7b$var$hasRequiredSafeBuffer;
function $be59461d4a783f7b$var$requireSafeBuffer() {
    if ($be59461d4a783f7b$var$hasRequiredSafeBuffer) return $be59461d4a783f7b$var$safeBuffer.exports;
    $be59461d4a783f7b$var$hasRequiredSafeBuffer = 1;
    (function(module, exports) {
        var buffer2 = $be59461d4a783f7b$var$requireBuffer();
        var Buffer2 = buffer2.Buffer;
        function copyProps(src, dst) {
            for(var key in src)dst[key] = src[key];
        }
        if (Buffer2.from && Buffer2.alloc && Buffer2.allocUnsafe && Buffer2.allocUnsafeSlow) module.exports = buffer2;
        else {
            copyProps(buffer2, exports);
            exports.Buffer = SafeBuffer;
        }
        function SafeBuffer(arg, encodingOrOffset, length) {
            return Buffer2(arg, encodingOrOffset, length);
        }
        copyProps(Buffer2, SafeBuffer);
        SafeBuffer.from = function(arg, encodingOrOffset, length) {
            if (typeof arg === "number") throw new TypeError("Argument must not be a number");
            return Buffer2(arg, encodingOrOffset, length);
        };
        SafeBuffer.alloc = function(size, fill, encoding) {
            if (typeof size !== "number") throw new TypeError("Argument must be a number");
            var buf = Buffer2(size);
            if (fill !== void 0) {
                if (typeof encoding === "string") buf.fill(fill, encoding);
                else buf.fill(fill);
            } else buf.fill(0);
            return buf;
        };
        SafeBuffer.allocUnsafe = function(size) {
            if (typeof size !== "number") throw new TypeError("Argument must be a number");
            return Buffer2(size);
        };
        SafeBuffer.allocUnsafeSlow = function(size) {
            if (typeof size !== "number") throw new TypeError("Argument must be a number");
            return buffer2.SlowBuffer(size);
        };
    })($be59461d4a783f7b$var$safeBuffer, $be59461d4a783f7b$var$safeBuffer.exports);
    return $be59461d4a783f7b$var$safeBuffer.exports;
}
var $be59461d4a783f7b$var$hasRequiredString_decoder;
function $be59461d4a783f7b$var$requireString_decoder() {
    if ($be59461d4a783f7b$var$hasRequiredString_decoder) return $be59461d4a783f7b$var$string_decoder;
    $be59461d4a783f7b$var$hasRequiredString_decoder = 1;
    var Buffer2 = $be59461d4a783f7b$var$requireSafeBuffer().Buffer;
    var isEncoding = Buffer2.isEncoding || function(encoding) {
        encoding = "" + encoding;
        switch(encoding && encoding.toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
                return true;
            default:
                return false;
        }
    };
    function _normalizeEncoding(enc) {
        if (!enc) return "utf8";
        var retried;
        while(true)switch(enc){
            case "utf8":
            case "utf-8":
                return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return "utf16le";
            case "latin1":
            case "binary":
                return "latin1";
            case "base64":
            case "ascii":
            case "hex":
                return enc;
            default:
                if (retried) return;
                enc = ("" + enc).toLowerCase();
                retried = true;
        }
    }
    function normalizeEncoding(enc) {
        var nenc = _normalizeEncoding(enc);
        if (typeof nenc !== "string" && (Buffer2.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
        return nenc || enc;
    }
    $be59461d4a783f7b$var$string_decoder.StringDecoder = StringDecoder;
    function StringDecoder(encoding) {
        this.encoding = normalizeEncoding(encoding);
        var nb;
        switch(this.encoding){
            case "utf16le":
                this.text = utf16Text;
                this.end = utf16End;
                nb = 4;
                break;
            case "utf8":
                this.fillLast = utf8FillLast;
                nb = 4;
                break;
            case "base64":
                this.text = base64Text;
                this.end = base64End;
                nb = 3;
                break;
            default:
                this.write = simpleWrite;
                this.end = simpleEnd;
                return;
        }
        this.lastNeed = 0;
        this.lastTotal = 0;
        this.lastChar = Buffer2.allocUnsafe(nb);
    }
    StringDecoder.prototype.write = function(buf) {
        if (buf.length === 0) return "";
        var r;
        var i;
        if (this.lastNeed) {
            r = this.fillLast(buf);
            if (r === void 0) return "";
            i = this.lastNeed;
            this.lastNeed = 0;
        } else i = 0;
        if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
        return r || "";
    };
    StringDecoder.prototype.end = utf8End;
    StringDecoder.prototype.text = utf8Text;
    StringDecoder.prototype.fillLast = function(buf) {
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
        this.lastNeed -= buf.length;
    };
    function utf8CheckByte(byte) {
        if (byte <= 127) return 0;
        else if (byte >> 5 === 6) return 2;
        else if (byte >> 4 === 14) return 3;
        else if (byte >> 3 === 30) return 4;
        return byte >> 6 === 2 ? -1 : -2;
    }
    function utf8CheckIncomplete(self2, buf, i) {
        var j = buf.length - 1;
        if (j < i) return 0;
        var nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self2.lastNeed = nb - 1;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self2.lastNeed = nb - 2;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) {
                if (nb === 2) nb = 0;
                else self2.lastNeed = nb - 3;
            }
            return nb;
        }
        return 0;
    }
    function utf8CheckExtraBytes(self2, buf, p) {
        if ((buf[0] & 192) !== 128) {
            self2.lastNeed = 0;
            return "\uFFFD";
        }
        if (self2.lastNeed > 1 && buf.length > 1) {
            if ((buf[1] & 192) !== 128) {
                self2.lastNeed = 1;
                return "\uFFFD";
            }
            if (self2.lastNeed > 2 && buf.length > 2) {
                if ((buf[2] & 192) !== 128) {
                    self2.lastNeed = 2;
                    return "\uFFFD";
                }
            }
        }
    }
    function utf8FillLast(buf) {
        var p = this.lastTotal - this.lastNeed;
        var r = utf8CheckExtraBytes(this, buf);
        if (r !== void 0) return r;
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, p, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, p, 0, buf.length);
        this.lastNeed -= buf.length;
    }
    function utf8Text(buf, i) {
        var total = utf8CheckIncomplete(this, buf, i);
        if (!this.lastNeed) return buf.toString("utf8", i);
        this.lastTotal = total;
        var end = buf.length - (total - this.lastNeed);
        buf.copy(this.lastChar, 0, end);
        return buf.toString("utf8", i, end);
    }
    function utf8End(buf) {
        var r = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) return r + "\uFFFD";
        return r;
    }
    function utf16Text(buf, i) {
        if ((buf.length - i) % 2 === 0) {
            var r = buf.toString("utf16le", i);
            if (r) {
                var c = r.charCodeAt(r.length - 1);
                if (c >= 55296 && c <= 56319) {
                    this.lastNeed = 2;
                    this.lastTotal = 4;
                    this.lastChar[0] = buf[buf.length - 2];
                    this.lastChar[1] = buf[buf.length - 1];
                    return r.slice(0, -1);
                }
            }
            return r;
        }
        this.lastNeed = 1;
        this.lastTotal = 2;
        this.lastChar[0] = buf[buf.length - 1];
        return buf.toString("utf16le", i, buf.length - 1);
    }
    function utf16End(buf) {
        var r = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) {
            var end = this.lastTotal - this.lastNeed;
            return r + this.lastChar.toString("utf16le", 0, end);
        }
        return r;
    }
    function base64Text(buf, i) {
        var n = (buf.length - i) % 3;
        if (n === 0) return buf.toString("base64", i);
        this.lastNeed = 3 - n;
        this.lastTotal = 3;
        if (n === 1) this.lastChar[0] = buf[buf.length - 1];
        else {
            this.lastChar[0] = buf[buf.length - 2];
            this.lastChar[1] = buf[buf.length - 1];
        }
        return buf.toString("base64", i, buf.length - n);
    }
    function base64End(buf) {
        var r = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
        return r;
    }
    function simpleWrite(buf) {
        return buf.toString(this.encoding);
    }
    function simpleEnd(buf) {
        return buf && buf.length ? this.write(buf) : "";
    }
    return $be59461d4a783f7b$var$string_decoder;
}
var $be59461d4a783f7b$var$endOfStream;
var $be59461d4a783f7b$var$hasRequiredEndOfStream;
function $be59461d4a783f7b$var$requireEndOfStream() {
    if ($be59461d4a783f7b$var$hasRequiredEndOfStream) return $be59461d4a783f7b$var$endOfStream;
    $be59461d4a783f7b$var$hasRequiredEndOfStream = 1;
    var ERR_STREAM_PREMATURE_CLOSE = $be59461d4a783f7b$var$requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
    function once(callback) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            callback.apply(this, args);
        };
    }
    function noop2() {}
    function isRequest(stream) {
        return stream.setHeader && typeof stream.abort === "function";
    }
    function eos(stream, opts, callback) {
        if (typeof opts === "function") return eos(stream, null, opts);
        if (!opts) opts = {};
        callback = once(callback || noop2);
        var readable = opts.readable || opts.readable !== false && stream.readable;
        var writable = opts.writable || opts.writable !== false && stream.writable;
        var onlegacyfinish = function onlegacyfinish2() {
            if (!stream.writable) onfinish();
        };
        var writableEnded = stream._writableState && stream._writableState.finished;
        var onfinish = function onfinish2() {
            writable = false;
            writableEnded = true;
            if (!readable) callback.call(stream);
        };
        var readableEnded = stream._readableState && stream._readableState.endEmitted;
        var onend = function onend2() {
            readable = false;
            readableEnded = true;
            if (!writable) callback.call(stream);
        };
        var onerror = function onerror2(err) {
            callback.call(stream, err);
        };
        var onclose = function onclose2() {
            var err;
            if (readable && !readableEnded) {
                if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
            }
            if (writable && !writableEnded) {
                if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
            }
        };
        var onrequest = function onrequest2() {
            stream.req.on("finish", onfinish);
        };
        if (isRequest(stream)) {
            stream.on("complete", onfinish);
            stream.on("abort", onclose);
            if (stream.req) onrequest();
            else stream.on("request", onrequest);
        } else if (writable && !stream._writableState) {
            stream.on("end", onlegacyfinish);
            stream.on("close", onlegacyfinish);
        }
        stream.on("end", onend);
        stream.on("finish", onfinish);
        if (opts.error !== false) stream.on("error", onerror);
        stream.on("close", onclose);
        return function() {
            stream.removeListener("complete", onfinish);
            stream.removeListener("abort", onclose);
            stream.removeListener("request", onrequest);
            if (stream.req) stream.req.removeListener("finish", onfinish);
            stream.removeListener("end", onlegacyfinish);
            stream.removeListener("close", onlegacyfinish);
            stream.removeListener("finish", onfinish);
            stream.removeListener("end", onend);
            stream.removeListener("error", onerror);
            stream.removeListener("close", onclose);
        };
    }
    $be59461d4a783f7b$var$endOfStream = eos;
    return $be59461d4a783f7b$var$endOfStream;
}
var $be59461d4a783f7b$var$async_iterator;
var $be59461d4a783f7b$var$hasRequiredAsync_iterator;
function $be59461d4a783f7b$var$requireAsync_iterator() {
    if ($be59461d4a783f7b$var$hasRequiredAsync_iterator) return $be59461d4a783f7b$var$async_iterator;
    $be59461d4a783f7b$var$hasRequiredAsync_iterator = 1;
    var _Object$setPrototypeO;
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var finished = $be59461d4a783f7b$var$requireEndOfStream();
    var kLastResolve = Symbol("lastResolve");
    var kLastReject = Symbol("lastReject");
    var kError = Symbol("error");
    var kEnded = Symbol("ended");
    var kLastPromise = Symbol("lastPromise");
    var kHandlePromise = Symbol("handlePromise");
    var kStream = Symbol("stream");
    function createIterResult(value, done) {
        return {
            value: value,
            done: done
        };
    }
    function readAndResolve(iter) {
        var resolve = iter[kLastResolve];
        if (resolve !== null) {
            var data = iter[kStream].read();
            if (data !== null) {
                iter[kLastPromise] = null;
                iter[kLastResolve] = null;
                iter[kLastReject] = null;
                resolve(createIterResult(data, false));
            }
        }
    }
    function onReadable(iter) {
        $be59461d4a783f7b$var$process$1.nextTick(readAndResolve, iter);
    }
    function wrapForNext(lastPromise, iter) {
        return function(resolve, reject) {
            lastPromise.then(function() {
                if (iter[kEnded]) {
                    resolve(createIterResult(void 0, true));
                    return;
                }
                iter[kHandlePromise](resolve, reject);
            }, reject);
        };
    }
    var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
    var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
        get stream () {
            return this[kStream];
        },
        next: function next() {
            var _this = this;
            var error = this[kError];
            if (error !== null) return Promise.reject(error);
            if (this[kEnded]) return Promise.resolve(createIterResult(void 0, true));
            if (this[kStream].destroyed) return new Promise(function(resolve, reject) {
                $be59461d4a783f7b$var$process$1.nextTick(function() {
                    if (_this[kError]) reject(_this[kError]);
                    else resolve(createIterResult(void 0, true));
                });
            });
            var lastPromise = this[kLastPromise];
            var promise;
            if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
            else {
                var data = this[kStream].read();
                if (data !== null) return Promise.resolve(createIterResult(data, false));
                promise = new Promise(this[kHandlePromise]);
            }
            this[kLastPromise] = promise;
            return promise;
        }
    }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
        return this;
    }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2[kStream].destroy(null, function(err) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(createIterResult(void 0, true));
            });
        });
    }), _Object$setPrototypeO), AsyncIteratorPrototype);
    var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator2(stream) {
        var _Object$create;
        var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
            value: stream,
            writable: true
        }), _defineProperty(_Object$create, kLastResolve, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kLastReject, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kError, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kEnded, {
            value: stream._readableState.endEmitted,
            writable: true
        }), _defineProperty(_Object$create, kHandlePromise, {
            value: function value(resolve, reject) {
                var data = iterator[kStream].read();
                if (data) {
                    iterator[kLastPromise] = null;
                    iterator[kLastResolve] = null;
                    iterator[kLastReject] = null;
                    resolve(createIterResult(data, false));
                } else {
                    iterator[kLastResolve] = resolve;
                    iterator[kLastReject] = reject;
                }
            },
            writable: true
        }), _Object$create));
        iterator[kLastPromise] = null;
        finished(stream, function(err) {
            if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var reject = iterator[kLastReject];
                if (reject !== null) {
                    iterator[kLastPromise] = null;
                    iterator[kLastResolve] = null;
                    iterator[kLastReject] = null;
                    reject(err);
                }
                iterator[kError] = err;
                return;
            }
            var resolve = iterator[kLastResolve];
            if (resolve !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(void 0, true));
            }
            iterator[kEnded] = true;
        });
        stream.on("readable", onReadable.bind(null, iterator));
        return iterator;
    };
    $be59461d4a783f7b$var$async_iterator = createReadableStreamAsyncIterator;
    return $be59461d4a783f7b$var$async_iterator;
}
var $be59461d4a783f7b$var$fromBrowser;
var $be59461d4a783f7b$var$hasRequiredFromBrowser;
function $be59461d4a783f7b$var$requireFromBrowser() {
    if ($be59461d4a783f7b$var$hasRequiredFromBrowser) return $be59461d4a783f7b$var$fromBrowser;
    $be59461d4a783f7b$var$hasRequiredFromBrowser = 1;
    $be59461d4a783f7b$var$fromBrowser = function() {
        throw new Error("Readable.from is not available in the browser");
    };
    return $be59461d4a783f7b$var$fromBrowser;
}
var $be59461d4a783f7b$var$_stream_readable;
var $be59461d4a783f7b$var$hasRequired_stream_readable;
function $be59461d4a783f7b$var$require_stream_readable() {
    if ($be59461d4a783f7b$var$hasRequired_stream_readable) return $be59461d4a783f7b$var$_stream_readable;
    $be59461d4a783f7b$var$hasRequired_stream_readable = 1;
    $be59461d4a783f7b$var$_stream_readable = Readable;
    var Duplex;
    Readable.ReadableState = ReadableState;
    $be59461d4a783f7b$var$requireEvents().EventEmitter;
    var EElistenerCount = function EElistenerCount2(emitter, type2) {
        return emitter.listeners(type2).length;
    };
    var Stream = $be59461d4a783f7b$var$requireStreamBrowser();
    var Buffer2 = $be59461d4a783f7b$var$requireBuffer().Buffer;
    var OurUint8Array = $be59461d4a783f7b$var$commonjsGlobal.Uint8Array || function() {};
    function _uint8ArrayToBuffer(chunk) {
        return Buffer2.from(chunk);
    }
    function _isUint8Array(obj) {
        return Buffer2.isBuffer(obj) || obj instanceof OurUint8Array;
    }
    var debugUtil = $be59461d4a783f7b$var$requireUtil();
    var debug;
    if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
    else debug = function debug2() {};
    var BufferList = $be59461d4a783f7b$var$requireBuffer_list();
    var destroyImpl = $be59461d4a783f7b$var$requireDestroy();
    var _require = $be59461d4a783f7b$var$requireState(), getHighWaterMark = _require.getHighWaterMark;
    var _require$codes = $be59461d4a783f7b$var$requireErrorsBrowser().codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
    var StringDecoder;
    var createReadableStreamAsyncIterator;
    var from;
    $be59461d4a783f7b$var$requireInherits_browser()(Readable, Stream);
    var errorOrDestroy = destroyImpl.errorOrDestroy;
    var kProxyEvents = [
        "error",
        "close",
        "destroy",
        "pause",
        "resume"
    ];
    function prependListener(emitter, event, fn) {
        if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
    function ReadableState(options, stream, isDuplex) {
        Duplex = Duplex || $be59461d4a783f7b$var$require_stream_duplex();
        options = options || {};
        if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
        this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
        this.buffer = new BufferList();
        this.length = 0;
        this.pipes = null;
        this.pipesCount = 0;
        this.flowing = null;
        this.ended = false;
        this.endEmitted = false;
        this.reading = false;
        this.sync = true;
        this.needReadable = false;
        this.emittedReadable = false;
        this.readableListening = false;
        this.resumeScheduled = false;
        this.paused = true;
        this.emitClose = options.emitClose !== false;
        this.autoDestroy = !!options.autoDestroy;
        this.destroyed = false;
        this.defaultEncoding = options.defaultEncoding || "utf8";
        this.awaitDrain = 0;
        this.readingMore = false;
        this.decoder = null;
        this.encoding = null;
        if (options.encoding) {
            if (!StringDecoder) StringDecoder = $be59461d4a783f7b$var$requireString_decoder().StringDecoder;
            this.decoder = new StringDecoder(options.encoding);
            this.encoding = options.encoding;
        }
    }
    function Readable(options) {
        Duplex = Duplex || $be59461d4a783f7b$var$require_stream_duplex();
        if (!(this instanceof Readable)) return new Readable(options);
        var isDuplex = this instanceof Duplex;
        this._readableState = new ReadableState(options, this, isDuplex);
        this.readable = true;
        if (options) {
            if (typeof options.read === "function") this._read = options.read;
            if (typeof options.destroy === "function") this._destroy = options.destroy;
        }
        Stream.call(this);
    }
    Object.defineProperty(Readable.prototype, "destroyed", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            if (this._readableState === void 0) return false;
            return this._readableState.destroyed;
        },
        set: function set(value) {
            if (!this._readableState) return;
            this._readableState.destroyed = value;
        }
    });
    Readable.prototype.destroy = destroyImpl.destroy;
    Readable.prototype._undestroy = destroyImpl.undestroy;
    Readable.prototype._destroy = function(err, cb) {
        cb(err);
    };
    Readable.prototype.push = function(chunk, encoding) {
        var state2 = this._readableState;
        var skipChunkCheck;
        if (!state2.objectMode) {
            if (typeof chunk === "string") {
                encoding = encoding || state2.defaultEncoding;
                if (encoding !== state2.encoding) {
                    chunk = Buffer2.from(chunk, encoding);
                    encoding = "";
                }
                skipChunkCheck = true;
            }
        } else skipChunkCheck = true;
        return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    };
    Readable.prototype.unshift = function(chunk) {
        return readableAddChunk(this, chunk, null, true, false);
    };
    function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
        debug("readableAddChunk", chunk);
        var state2 = stream._readableState;
        if (chunk === null) {
            state2.reading = false;
            onEofChunk(stream, state2);
        } else {
            var er;
            if (!skipChunkCheck) er = chunkInvalid(state2, chunk);
            if (er) errorOrDestroy(stream, er);
            else if (state2.objectMode || chunk && chunk.length > 0) {
                if (typeof chunk !== "string" && !state2.objectMode && Object.getPrototypeOf(chunk) !== Buffer2.prototype) chunk = _uint8ArrayToBuffer(chunk);
                if (addToFront) {
                    if (state2.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                    else addChunk(stream, state2, chunk, true);
                } else if (state2.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                else if (state2.destroyed) return false;
                else {
                    state2.reading = false;
                    if (state2.decoder && !encoding) {
                        chunk = state2.decoder.write(chunk);
                        if (state2.objectMode || chunk.length !== 0) addChunk(stream, state2, chunk, false);
                        else maybeReadMore(stream, state2);
                    } else addChunk(stream, state2, chunk, false);
                }
            } else if (!addToFront) {
                state2.reading = false;
                maybeReadMore(stream, state2);
            }
        }
        return !state2.ended && (state2.length < state2.highWaterMark || state2.length === 0);
    }
    function addChunk(stream, state2, chunk, addToFront) {
        if (state2.flowing && state2.length === 0 && !state2.sync) {
            state2.awaitDrain = 0;
            stream.emit("data", chunk);
        } else {
            state2.length += state2.objectMode ? 1 : chunk.length;
            if (addToFront) state2.buffer.unshift(chunk);
            else state2.buffer.push(chunk);
            if (state2.needReadable) emitReadable(stream);
        }
        maybeReadMore(stream, state2);
    }
    function chunkInvalid(state2, chunk) {
        var er;
        if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== void 0 && !state2.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], chunk);
        return er;
    }
    Readable.prototype.isPaused = function() {
        return this._readableState.flowing === false;
    };
    Readable.prototype.setEncoding = function(enc) {
        if (!StringDecoder) StringDecoder = $be59461d4a783f7b$var$requireString_decoder().StringDecoder;
        var decoder = new StringDecoder(enc);
        this._readableState.decoder = decoder;
        this._readableState.encoding = this._readableState.decoder.encoding;
        var p = this._readableState.buffer.head;
        var content = "";
        while(p !== null){
            content += decoder.write(p.data);
            p = p.next;
        }
        this._readableState.buffer.clear();
        if (content !== "") this._readableState.buffer.push(content);
        this._readableState.length = content.length;
        return this;
    };
    var MAX_HWM = 1073741824;
    function computeNewHighWaterMark(n) {
        if (n >= MAX_HWM) n = MAX_HWM;
        else {
            n--;
            n |= n >>> 1;
            n |= n >>> 2;
            n |= n >>> 4;
            n |= n >>> 8;
            n |= n >>> 16;
            n++;
        }
        return n;
    }
    function howMuchToRead(n, state2) {
        if (n <= 0 || state2.length === 0 && state2.ended) return 0;
        if (state2.objectMode) return 1;
        if (n !== n) {
            if (state2.flowing && state2.length) return state2.buffer.head.data.length;
            else return state2.length;
        }
        if (n > state2.highWaterMark) state2.highWaterMark = computeNewHighWaterMark(n);
        if (n <= state2.length) return n;
        if (!state2.ended) {
            state2.needReadable = true;
            return 0;
        }
        return state2.length;
    }
    Readable.prototype.read = function(n) {
        debug("read", n);
        n = parseInt(n, 10);
        var state2 = this._readableState;
        var nOrig = n;
        if (n !== 0) state2.emittedReadable = false;
        if (n === 0 && state2.needReadable && ((state2.highWaterMark !== 0 ? state2.length >= state2.highWaterMark : state2.length > 0) || state2.ended)) {
            debug("read: emitReadable", state2.length, state2.ended);
            if (state2.length === 0 && state2.ended) endReadable(this);
            else emitReadable(this);
            return null;
        }
        n = howMuchToRead(n, state2);
        if (n === 0 && state2.ended) {
            if (state2.length === 0) endReadable(this);
            return null;
        }
        var doRead = state2.needReadable;
        debug("need readable", doRead);
        if (state2.length === 0 || state2.length - n < state2.highWaterMark) {
            doRead = true;
            debug("length less than watermark", doRead);
        }
        if (state2.ended || state2.reading) {
            doRead = false;
            debug("reading or ended", doRead);
        } else if (doRead) {
            debug("do read");
            state2.reading = true;
            state2.sync = true;
            if (state2.length === 0) state2.needReadable = true;
            this._read(state2.highWaterMark);
            state2.sync = false;
            if (!state2.reading) n = howMuchToRead(nOrig, state2);
        }
        var ret;
        if (n > 0) ret = fromList(n, state2);
        else ret = null;
        if (ret === null) {
            state2.needReadable = state2.length <= state2.highWaterMark;
            n = 0;
        } else {
            state2.length -= n;
            state2.awaitDrain = 0;
        }
        if (state2.length === 0) {
            if (!state2.ended) state2.needReadable = true;
            if (nOrig !== n && state2.ended) endReadable(this);
        }
        if (ret !== null) this.emit("data", ret);
        return ret;
    };
    function onEofChunk(stream, state2) {
        debug("onEofChunk");
        if (state2.ended) return;
        if (state2.decoder) {
            var chunk = state2.decoder.end();
            if (chunk && chunk.length) {
                state2.buffer.push(chunk);
                state2.length += state2.objectMode ? 1 : chunk.length;
            }
        }
        state2.ended = true;
        if (state2.sync) emitReadable(stream);
        else {
            state2.needReadable = false;
            if (!state2.emittedReadable) {
                state2.emittedReadable = true;
                emitReadable_(stream);
            }
        }
    }
    function emitReadable(stream) {
        var state2 = stream._readableState;
        debug("emitReadable", state2.needReadable, state2.emittedReadable);
        state2.needReadable = false;
        if (!state2.emittedReadable) {
            debug("emitReadable", state2.flowing);
            state2.emittedReadable = true;
            $be59461d4a783f7b$var$process$1.nextTick(emitReadable_, stream);
        }
    }
    function emitReadable_(stream) {
        var state2 = stream._readableState;
        debug("emitReadable_", state2.destroyed, state2.length, state2.ended);
        if (!state2.destroyed && (state2.length || state2.ended)) {
            stream.emit("readable");
            state2.emittedReadable = false;
        }
        state2.needReadable = !state2.flowing && !state2.ended && state2.length <= state2.highWaterMark;
        flow(stream);
    }
    function maybeReadMore(stream, state2) {
        if (!state2.readingMore) {
            state2.readingMore = true;
            $be59461d4a783f7b$var$process$1.nextTick(maybeReadMore_, stream, state2);
        }
    }
    function maybeReadMore_(stream, state2) {
        while(!state2.reading && !state2.ended && (state2.length < state2.highWaterMark || state2.flowing && state2.length === 0)){
            var len = state2.length;
            debug("maybeReadMore read 0");
            stream.read(0);
            if (len === state2.length) break;
        }
        state2.readingMore = false;
    }
    Readable.prototype._read = function(n) {
        errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
    };
    Readable.prototype.pipe = function(dest, pipeOpts) {
        var src = this;
        var state2 = this._readableState;
        switch(state2.pipesCount){
            case 0:
                state2.pipes = dest;
                break;
            case 1:
                state2.pipes = [
                    state2.pipes,
                    dest
                ];
                break;
            default:
                state2.pipes.push(dest);
                break;
        }
        state2.pipesCount += 1;
        debug("pipe count=%d opts=%j", state2.pipesCount, pipeOpts);
        var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $be59461d4a783f7b$var$process$1.stdout && dest !== $be59461d4a783f7b$var$process$1.stderr;
        var endFn = doEnd ? onend : unpipe;
        if (state2.endEmitted) $be59461d4a783f7b$var$process$1.nextTick(endFn);
        else src.once("end", endFn);
        dest.on("unpipe", onunpipe);
        function onunpipe(readable, unpipeInfo) {
            debug("onunpipe");
            if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                    unpipeInfo.hasUnpiped = true;
                    cleanup();
                }
            }
        }
        function onend() {
            debug("onend");
            dest.end();
        }
        var ondrain = pipeOnDrain(src);
        dest.on("drain", ondrain);
        var cleanedUp = false;
        function cleanup() {
            debug("cleanup");
            dest.removeListener("close", onclose);
            dest.removeListener("finish", onfinish);
            dest.removeListener("drain", ondrain);
            dest.removeListener("error", onerror);
            dest.removeListener("unpipe", onunpipe);
            src.removeListener("end", onend);
            src.removeListener("end", unpipe);
            src.removeListener("data", ondata);
            cleanedUp = true;
            if (state2.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
        }
        src.on("data", ondata);
        function ondata(chunk) {
            debug("ondata");
            var ret = dest.write(chunk);
            debug("dest.write", ret);
            if (ret === false) {
                if ((state2.pipesCount === 1 && state2.pipes === dest || state2.pipesCount > 1 && indexOf(state2.pipes, dest) !== -1) && !cleanedUp) {
                    debug("false write response, pause", state2.awaitDrain);
                    state2.awaitDrain++;
                }
                src.pause();
            }
        }
        function onerror(er) {
            debug("onerror", er);
            unpipe();
            dest.removeListener("error", onerror);
            if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
        }
        prependListener(dest, "error", onerror);
        function onclose() {
            dest.removeListener("finish", onfinish);
            unpipe();
        }
        dest.once("close", onclose);
        function onfinish() {
            debug("onfinish");
            dest.removeListener("close", onclose);
            unpipe();
        }
        dest.once("finish", onfinish);
        function unpipe() {
            debug("unpipe");
            src.unpipe(dest);
        }
        dest.emit("pipe", src);
        if (!state2.flowing) {
            debug("pipe resume");
            src.resume();
        }
        return dest;
    };
    function pipeOnDrain(src) {
        return function pipeOnDrainFunctionResult() {
            var state2 = src._readableState;
            debug("pipeOnDrain", state2.awaitDrain);
            if (state2.awaitDrain) state2.awaitDrain--;
            if (state2.awaitDrain === 0 && EElistenerCount(src, "data")) {
                state2.flowing = true;
                flow(src);
            }
        };
    }
    Readable.prototype.unpipe = function(dest) {
        var state2 = this._readableState;
        var unpipeInfo = {
            hasUnpiped: false
        };
        if (state2.pipesCount === 0) return this;
        if (state2.pipesCount === 1) {
            if (dest && dest !== state2.pipes) return this;
            if (!dest) dest = state2.pipes;
            state2.pipes = null;
            state2.pipesCount = 0;
            state2.flowing = false;
            if (dest) dest.emit("unpipe", this, unpipeInfo);
            return this;
        }
        if (!dest) {
            var dests = state2.pipes;
            var len = state2.pipesCount;
            state2.pipes = null;
            state2.pipesCount = 0;
            state2.flowing = false;
            for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
                hasUnpiped: false
            });
            return this;
        }
        var index = indexOf(state2.pipes, dest);
        if (index === -1) return this;
        state2.pipes.splice(index, 1);
        state2.pipesCount -= 1;
        if (state2.pipesCount === 1) state2.pipes = state2.pipes[0];
        dest.emit("unpipe", this, unpipeInfo);
        return this;
    };
    Readable.prototype.on = function(ev, fn) {
        var res = Stream.prototype.on.call(this, ev, fn);
        var state2 = this._readableState;
        if (ev === "data") {
            state2.readableListening = this.listenerCount("readable") > 0;
            if (state2.flowing !== false) this.resume();
        } else if (ev === "readable") {
            if (!state2.endEmitted && !state2.readableListening) {
                state2.readableListening = state2.needReadable = true;
                state2.flowing = false;
                state2.emittedReadable = false;
                debug("on readable", state2.length, state2.reading);
                if (state2.length) emitReadable(this);
                else if (!state2.reading) $be59461d4a783f7b$var$process$1.nextTick(nReadingNextTick, this);
            }
        }
        return res;
    };
    Readable.prototype.addListener = Readable.prototype.on;
    Readable.prototype.removeListener = function(ev, fn) {
        var res = Stream.prototype.removeListener.call(this, ev, fn);
        if (ev === "readable") $be59461d4a783f7b$var$process$1.nextTick(updateReadableListening, this);
        return res;
    };
    Readable.prototype.removeAllListeners = function(ev) {
        var res = Stream.prototype.removeAllListeners.apply(this, arguments);
        if (ev === "readable" || ev === void 0) $be59461d4a783f7b$var$process$1.nextTick(updateReadableListening, this);
        return res;
    };
    function updateReadableListening(self2) {
        var state2 = self2._readableState;
        state2.readableListening = self2.listenerCount("readable") > 0;
        if (state2.resumeScheduled && !state2.paused) state2.flowing = true;
        else if (self2.listenerCount("data") > 0) self2.resume();
    }
    function nReadingNextTick(self2) {
        debug("readable nexttick read 0");
        self2.read(0);
    }
    Readable.prototype.resume = function() {
        var state2 = this._readableState;
        if (!state2.flowing) {
            debug("resume");
            state2.flowing = !state2.readableListening;
            resume(this, state2);
        }
        state2.paused = false;
        return this;
    };
    function resume(stream, state2) {
        if (!state2.resumeScheduled) {
            state2.resumeScheduled = true;
            $be59461d4a783f7b$var$process$1.nextTick(resume_, stream, state2);
        }
    }
    function resume_(stream, state2) {
        debug("resume", state2.reading);
        if (!state2.reading) stream.read(0);
        state2.resumeScheduled = false;
        stream.emit("resume");
        flow(stream);
        if (state2.flowing && !state2.reading) stream.read(0);
    }
    Readable.prototype.pause = function() {
        debug("call pause flowing=%j", this._readableState.flowing);
        if (this._readableState.flowing !== false) {
            debug("pause");
            this._readableState.flowing = false;
            this.emit("pause");
        }
        this._readableState.paused = true;
        return this;
    };
    function flow(stream) {
        var state2 = stream._readableState;
        debug("flow", state2.flowing);
        while(state2.flowing && stream.read() !== null);
    }
    Readable.prototype.wrap = function(stream) {
        var _this = this;
        var state2 = this._readableState;
        var paused = false;
        stream.on("end", function() {
            debug("wrapped end");
            if (state2.decoder && !state2.ended) {
                var chunk = state2.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
            }
            _this.push(null);
        });
        stream.on("data", function(chunk) {
            debug("wrapped data");
            if (state2.decoder) chunk = state2.decoder.write(chunk);
            if (state2.objectMode && (chunk === null || chunk === void 0)) return;
            else if (!state2.objectMode && (!chunk || !chunk.length)) return;
            var ret = _this.push(chunk);
            if (!ret) {
                paused = true;
                stream.pause();
            }
        });
        for(var i in stream)if (this[i] === void 0 && typeof stream[i] === "function") this[i] = /* @__PURE__ */ function methodWrap(method) {
            return function methodWrapReturnFunction() {
                return stream[method].apply(stream, arguments);
            };
        }(i);
        for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
        this._read = function(n2) {
            debug("wrapped _read", n2);
            if (paused) {
                paused = false;
                stream.resume();
            }
        };
        return this;
    };
    if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
        if (createReadableStreamAsyncIterator === void 0) createReadableStreamAsyncIterator = $be59461d4a783f7b$var$requireAsync_iterator();
        return createReadableStreamAsyncIterator(this);
    };
    Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._readableState.highWaterMark;
        }
    });
    Object.defineProperty(Readable.prototype, "readableBuffer", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._readableState && this._readableState.buffer;
        }
    });
    Object.defineProperty(Readable.prototype, "readableFlowing", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._readableState.flowing;
        },
        set: function set(state2) {
            if (this._readableState) this._readableState.flowing = state2;
        }
    });
    Readable._fromList = fromList;
    Object.defineProperty(Readable.prototype, "readableLength", {
        // making it explicit this property is not enumerable
        // because otherwise some prototype manipulation in
        // userland will fail
        enumerable: false,
        get: function get2() {
            return this._readableState.length;
        }
    });
    function fromList(n, state2) {
        if (state2.length === 0) return null;
        var ret;
        if (state2.objectMode) ret = state2.buffer.shift();
        else if (!n || n >= state2.length) {
            if (state2.decoder) ret = state2.buffer.join("");
            else if (state2.buffer.length === 1) ret = state2.buffer.first();
            else ret = state2.buffer.concat(state2.length);
            state2.buffer.clear();
        } else ret = state2.buffer.consume(n, state2.decoder);
        return ret;
    }
    function endReadable(stream) {
        var state2 = stream._readableState;
        debug("endReadable", state2.endEmitted);
        if (!state2.endEmitted) {
            state2.ended = true;
            $be59461d4a783f7b$var$process$1.nextTick(endReadableNT, state2, stream);
        }
    }
    function endReadableNT(state2, stream) {
        debug("endReadableNT", state2.endEmitted, state2.length);
        if (!state2.endEmitted && state2.length === 0) {
            state2.endEmitted = true;
            stream.readable = false;
            stream.emit("end");
            if (state2.autoDestroy) {
                var wState = stream._writableState;
                if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
            }
        }
    }
    if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
        if (from === void 0) from = $be59461d4a783f7b$var$requireFromBrowser();
        return from(Readable, iterable, opts);
    };
    function indexOf(xs, x) {
        for(var i = 0, l = xs.length; i < l; i++){
            if (xs[i] === x) return i;
        }
        return -1;
    }
    return $be59461d4a783f7b$var$_stream_readable;
}
var $be59461d4a783f7b$var$_stream_transform;
var $be59461d4a783f7b$var$hasRequired_stream_transform;
function $be59461d4a783f7b$var$require_stream_transform() {
    if ($be59461d4a783f7b$var$hasRequired_stream_transform) return $be59461d4a783f7b$var$_stream_transform;
    $be59461d4a783f7b$var$hasRequired_stream_transform = 1;
    $be59461d4a783f7b$var$_stream_transform = Transform;
    var _require$codes = $be59461d4a783f7b$var$requireErrorsBrowser().codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
    var Duplex = $be59461d4a783f7b$var$require_stream_duplex();
    $be59461d4a783f7b$var$requireInherits_browser()(Transform, Duplex);
    function afterTransform(er, data) {
        var ts = this._transformState;
        ts.transforming = false;
        var cb = ts.writecb;
        if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
        ts.writechunk = null;
        ts.writecb = null;
        if (data != null) this.push(data);
        cb(er);
        var rs = this._readableState;
        rs.reading = false;
        if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
    function Transform(options) {
        if (!(this instanceof Transform)) return new Transform(options);
        Duplex.call(this, options);
        this._transformState = {
            afterTransform: afterTransform.bind(this),
            needTransform: false,
            transforming: false,
            writecb: null,
            writechunk: null,
            writeencoding: null
        };
        this._readableState.needReadable = true;
        this._readableState.sync = false;
        if (options) {
            if (typeof options.transform === "function") this._transform = options.transform;
            if (typeof options.flush === "function") this._flush = options.flush;
        }
        this.on("prefinish", prefinish);
    }
    function prefinish() {
        var _this = this;
        if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
            done(_this, er, data);
        });
        else done(this, null, null);
    }
    Transform.prototype.push = function(chunk, encoding) {
        this._transformState.needTransform = false;
        return Duplex.prototype.push.call(this, chunk, encoding);
    };
    Transform.prototype._transform = function(chunk, encoding, cb) {
        cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
    };
    Transform.prototype._write = function(chunk, encoding, cb) {
        var ts = this._transformState;
        ts.writecb = cb;
        ts.writechunk = chunk;
        ts.writeencoding = encoding;
        if (!ts.transforming) {
            var rs = this._readableState;
            if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
        }
    };
    Transform.prototype._read = function(n) {
        var ts = this._transformState;
        if (ts.writechunk !== null && !ts.transforming) {
            ts.transforming = true;
            this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
        } else ts.needTransform = true;
    };
    Transform.prototype._destroy = function(err, cb) {
        Duplex.prototype._destroy.call(this, err, function(err2) {
            cb(err2);
        });
    };
    function done(stream, er, data) {
        if (er) return stream.emit("error", er);
        if (data != null) stream.push(data);
        if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
        if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
        return stream.push(null);
    }
    return $be59461d4a783f7b$var$_stream_transform;
}
var $be59461d4a783f7b$var$_stream_passthrough;
var $be59461d4a783f7b$var$hasRequired_stream_passthrough;
function $be59461d4a783f7b$var$require_stream_passthrough() {
    if ($be59461d4a783f7b$var$hasRequired_stream_passthrough) return $be59461d4a783f7b$var$_stream_passthrough;
    $be59461d4a783f7b$var$hasRequired_stream_passthrough = 1;
    $be59461d4a783f7b$var$_stream_passthrough = PassThrough;
    var Transform = $be59461d4a783f7b$var$require_stream_transform();
    $be59461d4a783f7b$var$requireInherits_browser()(PassThrough, Transform);
    function PassThrough(options) {
        if (!(this instanceof PassThrough)) return new PassThrough(options);
        Transform.call(this, options);
    }
    PassThrough.prototype._transform = function(chunk, encoding, cb) {
        cb(null, chunk);
    };
    return $be59461d4a783f7b$var$_stream_passthrough;
}
var $be59461d4a783f7b$var$pipeline_1;
var $be59461d4a783f7b$var$hasRequiredPipeline;
function $be59461d4a783f7b$var$requirePipeline() {
    if ($be59461d4a783f7b$var$hasRequiredPipeline) return $be59461d4a783f7b$var$pipeline_1;
    $be59461d4a783f7b$var$hasRequiredPipeline = 1;
    var eos;
    function once(callback) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            callback.apply(void 0, arguments);
        };
    }
    var _require$codes = $be59461d4a783f7b$var$requireErrorsBrowser().codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
    function noop2(err) {
        if (err) throw err;
    }
    function isRequest(stream) {
        return stream.setHeader && typeof stream.abort === "function";
    }
    function destroyer(stream, reading, writing, callback) {
        callback = once(callback);
        var closed = false;
        stream.on("close", function() {
            closed = true;
        });
        if (eos === void 0) eos = $be59461d4a783f7b$var$requireEndOfStream();
        eos(stream, {
            readable: reading,
            writable: writing
        }, function(err) {
            if (err) return callback(err);
            closed = true;
            callback();
        });
        var destroyed = false;
        return function(err) {
            if (closed) return;
            if (destroyed) return;
            destroyed = true;
            if (isRequest(stream)) return stream.abort();
            if (typeof stream.destroy === "function") return stream.destroy();
            callback(err || new ERR_STREAM_DESTROYED("pipe"));
        };
    }
    function call(fn) {
        fn();
    }
    function pipe(from, to) {
        return from.pipe(to);
    }
    function popCallback(streams) {
        if (!streams.length) return noop2;
        if (typeof streams[streams.length - 1] !== "function") return noop2;
        return streams.pop();
    }
    function pipeline() {
        for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
        var callback = popCallback(streams);
        if (Array.isArray(streams[0])) streams = streams[0];
        if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
        var error;
        var destroys = streams.map(function(stream, i) {
            var reading = i < streams.length - 1;
            var writing = i > 0;
            return destroyer(stream, reading, writing, function(err) {
                if (!error) error = err;
                if (err) destroys.forEach(call);
                if (reading) return;
                destroys.forEach(call);
                callback(error);
            });
        });
        return streams.reduce(pipe);
    }
    $be59461d4a783f7b$var$pipeline_1 = pipeline;
    return $be59461d4a783f7b$var$pipeline_1;
}
var $be59461d4a783f7b$var$streamBrowserify;
var $be59461d4a783f7b$var$hasRequiredStreamBrowserify;
function $be59461d4a783f7b$var$requireStreamBrowserify() {
    if ($be59461d4a783f7b$var$hasRequiredStreamBrowserify) return $be59461d4a783f7b$var$streamBrowserify;
    $be59461d4a783f7b$var$hasRequiredStreamBrowserify = 1;
    $be59461d4a783f7b$var$streamBrowserify = Stream;
    var EE = $be59461d4a783f7b$var$requireEvents().EventEmitter;
    var inherits = $be59461d4a783f7b$var$requireInherits_browser();
    inherits(Stream, EE);
    Stream.Readable = $be59461d4a783f7b$var$require_stream_readable();
    Stream.Writable = $be59461d4a783f7b$var$require_stream_writable();
    Stream.Duplex = $be59461d4a783f7b$var$require_stream_duplex();
    Stream.Transform = $be59461d4a783f7b$var$require_stream_transform();
    Stream.PassThrough = $be59461d4a783f7b$var$require_stream_passthrough();
    Stream.finished = $be59461d4a783f7b$var$requireEndOfStream();
    Stream.pipeline = $be59461d4a783f7b$var$requirePipeline();
    Stream.Stream = Stream;
    function Stream() {
        EE.call(this);
    }
    Stream.prototype.pipe = function(dest, options) {
        var source = this;
        function ondata(chunk) {
            if (dest.writable) {
                if (false === dest.write(chunk) && source.pause) source.pause();
            }
        }
        source.on("data", ondata);
        function ondrain() {
            if (source.readable && source.resume) source.resume();
        }
        dest.on("drain", ondrain);
        if (!dest._isStdio && (!options || options.end !== false)) {
            source.on("end", onend);
            source.on("close", onclose);
        }
        var didOnEnd = false;
        function onend() {
            if (didOnEnd) return;
            didOnEnd = true;
            dest.end();
        }
        function onclose() {
            if (didOnEnd) return;
            didOnEnd = true;
            if (typeof dest.destroy === "function") dest.destroy();
        }
        function onerror(er) {
            cleanup();
            if (EE.listenerCount(this, "error") === 0) throw er;
        }
        source.on("error", onerror);
        dest.on("error", onerror);
        function cleanup() {
            source.removeListener("data", ondata);
            dest.removeListener("drain", ondrain);
            source.removeListener("end", onend);
            source.removeListener("close", onclose);
            source.removeListener("error", onerror);
            dest.removeListener("error", onerror);
            source.removeListener("end", cleanup);
            source.removeListener("close", cleanup);
            dest.removeListener("close", cleanup);
        }
        source.on("end", cleanup);
        source.on("close", cleanup);
        dest.on("close", cleanup);
        dest.emit("pipe", source);
        return dest;
    };
    return $be59461d4a783f7b$var$streamBrowserify;
}
var $be59461d4a783f7b$var$hasRequiredSax;
function $be59461d4a783f7b$var$requireSax() {
    if ($be59461d4a783f7b$var$hasRequiredSax) return $be59461d4a783f7b$var$sax;
    $be59461d4a783f7b$var$hasRequiredSax = 1;
    (function(exports) {
        (function(sax2) {
            sax2.parser = function(strict, opt) {
                return new SAXParser(strict, opt);
            };
            sax2.SAXParser = SAXParser;
            sax2.SAXStream = SAXStream;
            sax2.createStream = createStream;
            sax2.MAX_BUFFER_LENGTH = 65536;
            var buffers = [
                "comment",
                "sgmlDecl",
                "textNode",
                "tagName",
                "doctype",
                "procInstName",
                "procInstBody",
                "entity",
                "attribName",
                "attribValue",
                "cdata",
                "script"
            ];
            sax2.EVENTS = [
                "text",
                "processinginstruction",
                "sgmldeclaration",
                "doctype",
                "comment",
                "opentagstart",
                "attribute",
                "opentag",
                "closetag",
                "opencdata",
                "cdata",
                "closecdata",
                "error",
                "end",
                "ready",
                "script",
                "opennamespace",
                "closenamespace"
            ];
            function SAXParser(strict, opt) {
                if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
                var parser = this;
                clearBuffers(parser);
                parser.q = parser.c = "";
                parser.bufferCheckPosition = sax2.MAX_BUFFER_LENGTH;
                parser.opt = opt || {};
                parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
                parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase";
                parser.tags = [];
                parser.closed = parser.closedRoot = parser.sawRoot = false;
                parser.tag = parser.error = null;
                parser.strict = !!strict;
                parser.noscript = !!(strict || parser.opt.noscript);
                parser.state = S.BEGIN;
                parser.strictEntities = parser.opt.strictEntities;
                parser.ENTITIES = parser.strictEntities ? Object.create(sax2.XML_ENTITIES) : Object.create(sax2.ENTITIES);
                parser.attribList = [];
                if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
                parser.trackPosition = parser.opt.position !== false;
                if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
                emit(parser, "onready");
            }
            if (!Object.create) Object.create = function(o) {
                function F() {}
                F.prototype = o;
                var newf = new F();
                return newf;
            };
            if (!Object.keys) Object.keys = function(o) {
                var a = [];
                for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
                return a;
            };
            function checkBufferLength(parser) {
                var maxAllowed = Math.max(sax2.MAX_BUFFER_LENGTH, 10);
                var maxActual = 0;
                for(var i = 0, l = buffers.length; i < l; i++){
                    var len = parser[buffers[i]].length;
                    if (len > maxAllowed) switch(buffers[i]){
                        case "textNode":
                            closeText(parser);
                            break;
                        case "cdata":
                            emitNode(parser, "oncdata", parser.cdata);
                            parser.cdata = "";
                            break;
                        case "script":
                            emitNode(parser, "onscript", parser.script);
                            parser.script = "";
                            break;
                        default:
                            error(parser, "Max buffer length exceeded: " + buffers[i]);
                    }
                    maxActual = Math.max(maxActual, len);
                }
                var m = sax2.MAX_BUFFER_LENGTH - maxActual;
                parser.bufferCheckPosition = m + parser.position;
            }
            function clearBuffers(parser) {
                for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = "";
            }
            function flushBuffers(parser) {
                closeText(parser);
                if (parser.cdata !== "") {
                    emitNode(parser, "oncdata", parser.cdata);
                    parser.cdata = "";
                }
                if (parser.script !== "") {
                    emitNode(parser, "onscript", parser.script);
                    parser.script = "";
                }
            }
            SAXParser.prototype = {
                end: function() {
                    end(this);
                },
                write: write,
                resume: function() {
                    this.error = null;
                    return this;
                },
                close: function() {
                    return this.write(null);
                },
                flush: function() {
                    flushBuffers(this);
                }
            };
            var Stream;
            try {
                Stream = $be59461d4a783f7b$var$requireStreamBrowserify().Stream;
            } catch (ex) {
                Stream = function() {};
            }
            var streamWraps = sax2.EVENTS.filter(function(ev) {
                return ev !== "error" && ev !== "end";
            });
            function createStream(strict, opt) {
                return new SAXStream(strict, opt);
            }
            function SAXStream(strict, opt) {
                if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
                Stream.apply(this);
                this._parser = new SAXParser(strict, opt);
                this.writable = true;
                this.readable = true;
                var me = this;
                this._parser.onend = function() {
                    me.emit("end");
                };
                this._parser.onerror = function(er) {
                    me.emit("error", er);
                    me._parser.error = null;
                };
                this._decoder = null;
                streamWraps.forEach(function(ev) {
                    Object.defineProperty(me, "on" + ev, {
                        get: function() {
                            return me._parser["on" + ev];
                        },
                        set: function(h) {
                            if (!h) {
                                me.removeAllListeners(ev);
                                me._parser["on" + ev] = h;
                                return h;
                            }
                            me.on(ev, h);
                        },
                        enumerable: true,
                        configurable: false
                    });
                });
            }
            SAXStream.prototype = Object.create(Stream.prototype, {
                constructor: {
                    value: SAXStream
                }
            });
            SAXStream.prototype.write = function(data) {
                if (typeof $be59461d4a783f7b$var$Buffer === "function" && typeof $be59461d4a783f7b$var$Buffer.isBuffer === "function" && $be59461d4a783f7b$var$Buffer.isBuffer(data)) {
                    if (!this._decoder) {
                        var SD = $be59461d4a783f7b$var$requireString_decoder().StringDecoder;
                        this._decoder = new SD("utf8");
                    }
                    data = this._decoder.write(data);
                }
                this._parser.write(data.toString());
                this.emit("data", data);
                return true;
            };
            SAXStream.prototype.end = function(chunk) {
                if (chunk && chunk.length) this.write(chunk);
                this._parser.end();
                return true;
            };
            SAXStream.prototype.on = function(ev, handler) {
                var me = this;
                if (!me._parser["on" + ev] && streamWraps.indexOf(ev) !== -1) me._parser["on" + ev] = function() {
                    var args = arguments.length === 1 ? [
                        arguments[0]
                    ] : Array.apply(null, arguments);
                    args.splice(0, 0, ev);
                    me.emit.apply(me, args);
                };
                return Stream.prototype.on.call(me, ev, handler);
            };
            var CDATA = "[CDATA[";
            var DOCTYPE = "DOCTYPE";
            var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
            var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
            var rootNS = {
                xml: XML_NAMESPACE,
                xmlns: XMLNS_NAMESPACE
            };
            var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
            var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
            var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
            var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
            function isWhitespace(c) {
                return c === " " || c === "\n" || c === "\r" || c === "	";
            }
            function isQuote(c) {
                return c === '"' || c === "'";
            }
            function isAttribEnd(c) {
                return c === ">" || isWhitespace(c);
            }
            function isMatch(regex, c) {
                return regex.test(c);
            }
            function notMatch(regex, c) {
                return !isMatch(regex, c);
            }
            var S = 0;
            sax2.STATE = {
                BEGIN: S++,
                // leading byte order mark or whitespace
                BEGIN_WHITESPACE: S++,
                // leading whitespace
                TEXT: S++,
                // general stuff
                TEXT_ENTITY: S++,
                // &amp and such.
                OPEN_WAKA: S++,
                // <
                SGML_DECL: S++,
                // <!BLARG
                SGML_DECL_QUOTED: S++,
                // <!BLARG foo "bar
                DOCTYPE: S++,
                // <!DOCTYPE
                DOCTYPE_QUOTED: S++,
                // <!DOCTYPE "//blah
                DOCTYPE_DTD: S++,
                // <!DOCTYPE "//blah" [ ...
                DOCTYPE_DTD_QUOTED: S++,
                // <!DOCTYPE "//blah" [ "foo
                COMMENT_STARTING: S++,
                // <!-
                COMMENT: S++,
                // <!--
                COMMENT_ENDING: S++,
                // <!-- blah -
                COMMENT_ENDED: S++,
                // <!-- blah --
                CDATA: S++,
                // <![CDATA[ something
                CDATA_ENDING: S++,
                // ]
                CDATA_ENDING_2: S++,
                // ]]
                PROC_INST: S++,
                // <?hi
                PROC_INST_BODY: S++,
                // <?hi there
                PROC_INST_ENDING: S++,
                // <?hi "there" ?
                OPEN_TAG: S++,
                // <strong
                OPEN_TAG_SLASH: S++,
                // <strong /
                ATTRIB: S++,
                // <a
                ATTRIB_NAME: S++,
                // <a foo
                ATTRIB_NAME_SAW_WHITE: S++,
                // <a foo _
                ATTRIB_VALUE: S++,
                // <a foo=
                ATTRIB_VALUE_QUOTED: S++,
                // <a foo="bar
                ATTRIB_VALUE_CLOSED: S++,
                // <a foo="bar"
                ATTRIB_VALUE_UNQUOTED: S++,
                // <a foo=bar
                ATTRIB_VALUE_ENTITY_Q: S++,
                // <foo bar="&quot;"
                ATTRIB_VALUE_ENTITY_U: S++,
                // <foo bar=&quot
                CLOSE_TAG: S++,
                // </a
                CLOSE_TAG_SAW_WHITE: S++,
                // </a   >
                SCRIPT: S++,
                // <script> ...
                SCRIPT_ENDING: S++
            };
            sax2.XML_ENTITIES = {
                "amp": "&",
                "gt": ">",
                "lt": "<",
                "quot": '"',
                "apos": "'"
            };
            sax2.ENTITIES = {
                "amp": "&",
                "gt": ">",
                "lt": "<",
                "quot": '"',
                "apos": "'",
                "AElig": 198,
                "Aacute": 193,
                "Acirc": 194,
                "Agrave": 192,
                "Aring": 197,
                "Atilde": 195,
                "Auml": 196,
                "Ccedil": 199,
                "ETH": 208,
                "Eacute": 201,
                "Ecirc": 202,
                "Egrave": 200,
                "Euml": 203,
                "Iacute": 205,
                "Icirc": 206,
                "Igrave": 204,
                "Iuml": 207,
                "Ntilde": 209,
                "Oacute": 211,
                "Ocirc": 212,
                "Ograve": 210,
                "Oslash": 216,
                "Otilde": 213,
                "Ouml": 214,
                "THORN": 222,
                "Uacute": 218,
                "Ucirc": 219,
                "Ugrave": 217,
                "Uuml": 220,
                "Yacute": 221,
                "aacute": 225,
                "acirc": 226,
                "aelig": 230,
                "agrave": 224,
                "aring": 229,
                "atilde": 227,
                "auml": 228,
                "ccedil": 231,
                "eacute": 233,
                "ecirc": 234,
                "egrave": 232,
                "eth": 240,
                "euml": 235,
                "iacute": 237,
                "icirc": 238,
                "igrave": 236,
                "iuml": 239,
                "ntilde": 241,
                "oacute": 243,
                "ocirc": 244,
                "ograve": 242,
                "oslash": 248,
                "otilde": 245,
                "ouml": 246,
                "szlig": 223,
                "thorn": 254,
                "uacute": 250,
                "ucirc": 251,
                "ugrave": 249,
                "uuml": 252,
                "yacute": 253,
                "yuml": 255,
                "copy": 169,
                "reg": 174,
                "nbsp": 160,
                "iexcl": 161,
                "cent": 162,
                "pound": 163,
                "curren": 164,
                "yen": 165,
                "brvbar": 166,
                "sect": 167,
                "uml": 168,
                "ordf": 170,
                "laquo": 171,
                "not": 172,
                "shy": 173,
                "macr": 175,
                "deg": 176,
                "plusmn": 177,
                "sup1": 185,
                "sup2": 178,
                "sup3": 179,
                "acute": 180,
                "micro": 181,
                "para": 182,
                "middot": 183,
                "cedil": 184,
                "ordm": 186,
                "raquo": 187,
                "frac14": 188,
                "frac12": 189,
                "frac34": 190,
                "iquest": 191,
                "times": 215,
                "divide": 247,
                "OElig": 338,
                "oelig": 339,
                "Scaron": 352,
                "scaron": 353,
                "Yuml": 376,
                "fnof": 402,
                "circ": 710,
                "tilde": 732,
                "Alpha": 913,
                "Beta": 914,
                "Gamma": 915,
                "Delta": 916,
                "Epsilon": 917,
                "Zeta": 918,
                "Eta": 919,
                "Theta": 920,
                "Iota": 921,
                "Kappa": 922,
                "Lambda": 923,
                "Mu": 924,
                "Nu": 925,
                "Xi": 926,
                "Omicron": 927,
                "Pi": 928,
                "Rho": 929,
                "Sigma": 931,
                "Tau": 932,
                "Upsilon": 933,
                "Phi": 934,
                "Chi": 935,
                "Psi": 936,
                "Omega": 937,
                "alpha": 945,
                "beta": 946,
                "gamma": 947,
                "delta": 948,
                "epsilon": 949,
                "zeta": 950,
                "eta": 951,
                "theta": 952,
                "iota": 953,
                "kappa": 954,
                "lambda": 955,
                "mu": 956,
                "nu": 957,
                "xi": 958,
                "omicron": 959,
                "pi": 960,
                "rho": 961,
                "sigmaf": 962,
                "sigma": 963,
                "tau": 964,
                "upsilon": 965,
                "phi": 966,
                "chi": 967,
                "psi": 968,
                "omega": 969,
                "thetasym": 977,
                "upsih": 978,
                "piv": 982,
                "ensp": 8194,
                "emsp": 8195,
                "thinsp": 8201,
                "zwnj": 8204,
                "zwj": 8205,
                "lrm": 8206,
                "rlm": 8207,
                "ndash": 8211,
                "mdash": 8212,
                "lsquo": 8216,
                "rsquo": 8217,
                "sbquo": 8218,
                "ldquo": 8220,
                "rdquo": 8221,
                "bdquo": 8222,
                "dagger": 8224,
                "Dagger": 8225,
                "bull": 8226,
                "hellip": 8230,
                "permil": 8240,
                "prime": 8242,
                "Prime": 8243,
                "lsaquo": 8249,
                "rsaquo": 8250,
                "oline": 8254,
                "frasl": 8260,
                "euro": 8364,
                "image": 8465,
                "weierp": 8472,
                "real": 8476,
                "trade": 8482,
                "alefsym": 8501,
                "larr": 8592,
                "uarr": 8593,
                "rarr": 8594,
                "darr": 8595,
                "harr": 8596,
                "crarr": 8629,
                "lArr": 8656,
                "uArr": 8657,
                "rArr": 8658,
                "dArr": 8659,
                "hArr": 8660,
                "forall": 8704,
                "part": 8706,
                "exist": 8707,
                "empty": 8709,
                "nabla": 8711,
                "isin": 8712,
                "notin": 8713,
                "ni": 8715,
                "prod": 8719,
                "sum": 8721,
                "minus": 8722,
                "lowast": 8727,
                "radic": 8730,
                "prop": 8733,
                "infin": 8734,
                "ang": 8736,
                "and": 8743,
                "or": 8744,
                "cap": 8745,
                "cup": 8746,
                "int": 8747,
                "there4": 8756,
                "sim": 8764,
                "cong": 8773,
                "asymp": 8776,
                "ne": 8800,
                "equiv": 8801,
                "le": 8804,
                "ge": 8805,
                "sub": 8834,
                "sup": 8835,
                "nsub": 8836,
                "sube": 8838,
                "supe": 8839,
                "oplus": 8853,
                "otimes": 8855,
                "perp": 8869,
                "sdot": 8901,
                "lceil": 8968,
                "rceil": 8969,
                "lfloor": 8970,
                "rfloor": 8971,
                "lang": 9001,
                "rang": 9002,
                "loz": 9674,
                "spades": 9824,
                "clubs": 9827,
                "hearts": 9829,
                "diams": 9830
            };
            Object.keys(sax2.ENTITIES).forEach(function(key) {
                var e = sax2.ENTITIES[key];
                var s2 = typeof e === "number" ? String.fromCharCode(e) : e;
                sax2.ENTITIES[key] = s2;
            });
            for(var s in sax2.STATE)sax2.STATE[sax2.STATE[s]] = s;
            S = sax2.STATE;
            function emit(parser, event, data) {
                parser[event] && parser[event](data);
            }
            function emitNode(parser, nodeType, data) {
                if (parser.textNode) closeText(parser);
                emit(parser, nodeType, data);
            }
            function closeText(parser) {
                parser.textNode = textopts(parser.opt, parser.textNode);
                if (parser.textNode) emit(parser, "ontext", parser.textNode);
                parser.textNode = "";
            }
            function textopts(opt, text) {
                if (opt.trim) text = text.trim();
                if (opt.normalize) text = text.replace(/\s+/g, " ");
                return text;
            }
            function error(parser, er) {
                closeText(parser);
                if (parser.trackPosition) er += "\nLine: " + parser.line + "\nColumn: " + parser.column + "\nChar: " + parser.c;
                er = new Error(er);
                parser.error = er;
                emit(parser, "onerror", er);
                return parser;
            }
            function end(parser) {
                if (parser.sawRoot && !parser.closedRoot) strictFail(parser, "Unclosed root tag");
                if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, "Unexpected end");
                closeText(parser);
                parser.c = "";
                parser.closed = true;
                emit(parser, "onend");
                SAXParser.call(parser, parser.strict, parser.opt);
                return parser;
            }
            function strictFail(parser, message) {
                if (typeof parser !== "object" || !(parser instanceof SAXParser)) throw new Error("bad call to strictFail");
                if (parser.strict) error(parser, message);
            }
            function newTag(parser) {
                if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
                var parent = parser.tags[parser.tags.length - 1] || parser;
                var tag = parser.tag = {
                    name: parser.tagName,
                    attributes: {}
                };
                if (parser.opt.xmlns) tag.ns = parent.ns;
                parser.attribList.length = 0;
                emitNode(parser, "onopentagstart", tag);
            }
            function qname(name, attribute) {
                var i = name.indexOf(":");
                var qualName = i < 0 ? [
                    "",
                    name
                ] : name.split(":");
                var prefix = qualName[0];
                var local = qualName[1];
                if (attribute && name === "xmlns") {
                    prefix = "xmlns";
                    local = "";
                }
                return {
                    prefix: prefix,
                    local: local
                };
            }
            function attrib(parser) {
                if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
                if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
                    parser.attribName = parser.attribValue = "";
                    return;
                }
                if (parser.opt.xmlns) {
                    var qn = qname(parser.attribName, true);
                    var prefix = qn.prefix;
                    var local = qn.local;
                    if (prefix === "xmlns") {
                        if (local === "xml" && parser.attribValue !== XML_NAMESPACE) strictFail(parser, "xml: prefix must be bound to " + XML_NAMESPACE + "\nActual: " + parser.attribValue);
                        else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\nActual: " + parser.attribValue);
                        else {
                            var tag = parser.tag;
                            var parent = parser.tags[parser.tags.length - 1] || parser;
                            if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                            tag.ns[local] = parser.attribValue;
                        }
                    }
                    parser.attribList.push([
                        parser.attribName,
                        parser.attribValue
                    ]);
                } else {
                    parser.tag.attributes[parser.attribName] = parser.attribValue;
                    emitNode(parser, "onattribute", {
                        name: parser.attribName,
                        value: parser.attribValue
                    });
                }
                parser.attribName = parser.attribValue = "";
            }
            function openTag(parser, selfClosing) {
                if (parser.opt.xmlns) {
                    var tag = parser.tag;
                    var qn = qname(parser.tagName);
                    tag.prefix = qn.prefix;
                    tag.local = qn.local;
                    tag.uri = tag.ns[qn.prefix] || "";
                    if (tag.prefix && !tag.uri) {
                        strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(parser.tagName));
                        tag.uri = qn.prefix;
                    }
                    var parent = parser.tags[parser.tags.length - 1] || parser;
                    if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                        emitNode(parser, "onopennamespace", {
                            prefix: p,
                            uri: tag.ns[p]
                        });
                    });
                    for(var i = 0, l = parser.attribList.length; i < l; i++){
                        var nv = parser.attribList[i];
                        var name = nv[0];
                        var value = nv[1];
                        var qualName = qname(name, true);
                        var prefix = qualName.prefix;
                        var local = qualName.local;
                        var uri2 = prefix === "" ? "" : tag.ns[prefix] || "";
                        var a = {
                            name: name,
                            value: value,
                            prefix: prefix,
                            local: local,
                            uri: uri2
                        };
                        if (prefix && prefix !== "xmlns" && !uri2) {
                            strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(prefix));
                            a.uri = prefix;
                        }
                        parser.tag.attributes[name] = a;
                        emitNode(parser, "onattribute", a);
                    }
                    parser.attribList.length = 0;
                }
                parser.tag.isSelfClosing = !!selfClosing;
                parser.sawRoot = true;
                parser.tags.push(parser.tag);
                emitNode(parser, "onopentag", parser.tag);
                if (!selfClosing) {
                    if (!parser.noscript && parser.tagName.toLowerCase() === "script") parser.state = S.SCRIPT;
                    else parser.state = S.TEXT;
                    parser.tag = null;
                    parser.tagName = "";
                }
                parser.attribName = parser.attribValue = "";
                parser.attribList.length = 0;
            }
            function closeTag(parser) {
                if (!parser.tagName) {
                    strictFail(parser, "Weird empty close tag.");
                    parser.textNode += "</>";
                    parser.state = S.TEXT;
                    return;
                }
                if (parser.script) {
                    if (parser.tagName !== "script") {
                        parser.script += "</" + parser.tagName + ">";
                        parser.tagName = "";
                        parser.state = S.SCRIPT;
                        return;
                    }
                    emitNode(parser, "onscript", parser.script);
                    parser.script = "";
                }
                var t = parser.tags.length;
                var tagName = parser.tagName;
                if (!parser.strict) tagName = tagName[parser.looseCase]();
                var closeTo = tagName;
                while(t--){
                    var close = parser.tags[t];
                    if (close.name !== closeTo) strictFail(parser, "Unexpected close tag");
                    else break;
                }
                if (t < 0) {
                    strictFail(parser, "Unmatched closing tag: " + parser.tagName);
                    parser.textNode += "</" + parser.tagName + ">";
                    parser.state = S.TEXT;
                    return;
                }
                parser.tagName = tagName;
                var s2 = parser.tags.length;
                while(s2-- > t){
                    var tag = parser.tag = parser.tags.pop();
                    parser.tagName = parser.tag.name;
                    emitNode(parser, "onclosetag", parser.tagName);
                    var x = {};
                    for(var i in tag.ns)x[i] = tag.ns[i];
                    var parent = parser.tags[parser.tags.length - 1] || parser;
                    if (parser.opt.xmlns && tag.ns !== parent.ns) Object.keys(tag.ns).forEach(function(p) {
                        var n = tag.ns[p];
                        emitNode(parser, "onclosenamespace", {
                            prefix: p,
                            uri: n
                        });
                    });
                }
                if (t === 0) parser.closedRoot = true;
                parser.tagName = parser.attribValue = parser.attribName = "";
                parser.attribList.length = 0;
                parser.state = S.TEXT;
            }
            function parseEntity(parser) {
                var entity = parser.entity;
                var entityLC = entity.toLowerCase();
                var num;
                var numStr = "";
                if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
                if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
                entity = entityLC;
                if (entity.charAt(0) === "#") {
                    if (entity.charAt(1) === "x") {
                        entity = entity.slice(2);
                        num = parseInt(entity, 16);
                        numStr = num.toString(16);
                    } else {
                        entity = entity.slice(1);
                        num = parseInt(entity, 10);
                        numStr = num.toString(10);
                    }
                }
                entity = entity.replace(/^0+/, "");
                if (isNaN(num) || numStr.toLowerCase() !== entity) {
                    strictFail(parser, "Invalid character entity");
                    return "&" + parser.entity + ";";
                }
                return String.fromCodePoint(num);
            }
            function beginWhiteSpace(parser, c) {
                if (c === "<") {
                    parser.state = S.OPEN_WAKA;
                    parser.startTagPosition = parser.position;
                } else if (!isWhitespace(c)) {
                    strictFail(parser, "Non-whitespace before first tag.");
                    parser.textNode = c;
                    parser.state = S.TEXT;
                }
            }
            function charAt(chunk, i) {
                var result = "";
                if (i < chunk.length) result = chunk.charAt(i);
                return result;
            }
            function write(chunk) {
                var parser = this;
                if (this.error) throw this.error;
                if (parser.closed) return error(parser, "Cannot write after close. Assign an onready handler.");
                if (chunk === null) return end(parser);
                if (typeof chunk === "object") chunk = chunk.toString();
                var i = 0;
                var c = "";
                while(true){
                    c = charAt(chunk, i++);
                    parser.c = c;
                    if (!c) break;
                    if (parser.trackPosition) {
                        parser.position++;
                        if (c === "\n") {
                            parser.line++;
                            parser.column = 0;
                        } else parser.column++;
                    }
                    switch(parser.state){
                        case S.BEGIN:
                            parser.state = S.BEGIN_WHITESPACE;
                            if (c === "\uFEFF") continue;
                            beginWhiteSpace(parser, c);
                            continue;
                        case S.BEGIN_WHITESPACE:
                            beginWhiteSpace(parser, c);
                            continue;
                        case S.TEXT:
                            if (parser.sawRoot && !parser.closedRoot) {
                                var starti = i - 1;
                                while(c && c !== "<" && c !== "&"){
                                    c = charAt(chunk, i++);
                                    if (c && parser.trackPosition) {
                                        parser.position++;
                                        if (c === "\n") {
                                            parser.line++;
                                            parser.column = 0;
                                        } else parser.column++;
                                    }
                                }
                                parser.textNode += chunk.substring(starti, i - 1);
                            }
                            if (c === "<" && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                                parser.state = S.OPEN_WAKA;
                                parser.startTagPosition = parser.position;
                            } else {
                                if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, "Text data outside of root node.");
                                if (c === "&") parser.state = S.TEXT_ENTITY;
                                else parser.textNode += c;
                            }
                            continue;
                        case S.SCRIPT:
                            if (c === "<") parser.state = S.SCRIPT_ENDING;
                            else parser.script += c;
                            continue;
                        case S.SCRIPT_ENDING:
                            if (c === "/") parser.state = S.CLOSE_TAG;
                            else {
                                parser.script += "<" + c;
                                parser.state = S.SCRIPT;
                            }
                            continue;
                        case S.OPEN_WAKA:
                            if (c === "!") {
                                parser.state = S.SGML_DECL;
                                parser.sgmlDecl = "";
                            } else if (isWhitespace(c)) ;
                            else if (isMatch(nameStart, c)) {
                                parser.state = S.OPEN_TAG;
                                parser.tagName = c;
                            } else if (c === "/") {
                                parser.state = S.CLOSE_TAG;
                                parser.tagName = "";
                            } else if (c === "?") {
                                parser.state = S.PROC_INST;
                                parser.procInstName = parser.procInstBody = "";
                            } else {
                                strictFail(parser, "Unencoded <");
                                if (parser.startTagPosition + 1 < parser.position) {
                                    var pad = parser.position - parser.startTagPosition;
                                    c = new Array(pad).join(" ") + c;
                                }
                                parser.textNode += "<" + c;
                                parser.state = S.TEXT;
                            }
                            continue;
                        case S.SGML_DECL:
                            if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                                emitNode(parser, "onopencdata");
                                parser.state = S.CDATA;
                                parser.sgmlDecl = "";
                                parser.cdata = "";
                            } else if (parser.sgmlDecl + c === "--") {
                                parser.state = S.COMMENT;
                                parser.comment = "";
                                parser.sgmlDecl = "";
                            } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                                parser.state = S.DOCTYPE;
                                if (parser.doctype || parser.sawRoot) strictFail(parser, "Inappropriately located doctype declaration");
                                parser.doctype = "";
                                parser.sgmlDecl = "";
                            } else if (c === ">") {
                                emitNode(parser, "onsgmldeclaration", parser.sgmlDecl);
                                parser.sgmlDecl = "";
                                parser.state = S.TEXT;
                            } else if (isQuote(c)) {
                                parser.state = S.SGML_DECL_QUOTED;
                                parser.sgmlDecl += c;
                            } else parser.sgmlDecl += c;
                            continue;
                        case S.SGML_DECL_QUOTED:
                            if (c === parser.q) {
                                parser.state = S.SGML_DECL;
                                parser.q = "";
                            }
                            parser.sgmlDecl += c;
                            continue;
                        case S.DOCTYPE:
                            if (c === ">") {
                                parser.state = S.TEXT;
                                emitNode(parser, "ondoctype", parser.doctype);
                                parser.doctype = true;
                            } else {
                                parser.doctype += c;
                                if (c === "[") parser.state = S.DOCTYPE_DTD;
                                else if (isQuote(c)) {
                                    parser.state = S.DOCTYPE_QUOTED;
                                    parser.q = c;
                                }
                            }
                            continue;
                        case S.DOCTYPE_QUOTED:
                            parser.doctype += c;
                            if (c === parser.q) {
                                parser.q = "";
                                parser.state = S.DOCTYPE;
                            }
                            continue;
                        case S.DOCTYPE_DTD:
                            parser.doctype += c;
                            if (c === "]") parser.state = S.DOCTYPE;
                            else if (isQuote(c)) {
                                parser.state = S.DOCTYPE_DTD_QUOTED;
                                parser.q = c;
                            }
                            continue;
                        case S.DOCTYPE_DTD_QUOTED:
                            parser.doctype += c;
                            if (c === parser.q) {
                                parser.state = S.DOCTYPE_DTD;
                                parser.q = "";
                            }
                            continue;
                        case S.COMMENT:
                            if (c === "-") parser.state = S.COMMENT_ENDING;
                            else parser.comment += c;
                            continue;
                        case S.COMMENT_ENDING:
                            if (c === "-") {
                                parser.state = S.COMMENT_ENDED;
                                parser.comment = textopts(parser.opt, parser.comment);
                                if (parser.comment) emitNode(parser, "oncomment", parser.comment);
                                parser.comment = "";
                            } else {
                                parser.comment += "-" + c;
                                parser.state = S.COMMENT;
                            }
                            continue;
                        case S.COMMENT_ENDED:
                            if (c !== ">") {
                                strictFail(parser, "Malformed comment");
                                parser.comment += "--" + c;
                                parser.state = S.COMMENT;
                            } else parser.state = S.TEXT;
                            continue;
                        case S.CDATA:
                            if (c === "]") parser.state = S.CDATA_ENDING;
                            else parser.cdata += c;
                            continue;
                        case S.CDATA_ENDING:
                            if (c === "]") parser.state = S.CDATA_ENDING_2;
                            else {
                                parser.cdata += "]" + c;
                                parser.state = S.CDATA;
                            }
                            continue;
                        case S.CDATA_ENDING_2:
                            if (c === ">") {
                                if (parser.cdata) emitNode(parser, "oncdata", parser.cdata);
                                emitNode(parser, "onclosecdata");
                                parser.cdata = "";
                                parser.state = S.TEXT;
                            } else if (c === "]") parser.cdata += "]";
                            else {
                                parser.cdata += "]]" + c;
                                parser.state = S.CDATA;
                            }
                            continue;
                        case S.PROC_INST:
                            if (c === "?") parser.state = S.PROC_INST_ENDING;
                            else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                            else parser.procInstName += c;
                            continue;
                        case S.PROC_INST_BODY:
                            if (!parser.procInstBody && isWhitespace(c)) continue;
                            else if (c === "?") parser.state = S.PROC_INST_ENDING;
                            else parser.procInstBody += c;
                            continue;
                        case S.PROC_INST_ENDING:
                            if (c === ">") {
                                emitNode(parser, "onprocessinginstruction", {
                                    name: parser.procInstName,
                                    body: parser.procInstBody
                                });
                                parser.procInstName = parser.procInstBody = "";
                                parser.state = S.TEXT;
                            } else {
                                parser.procInstBody += "?" + c;
                                parser.state = S.PROC_INST_BODY;
                            }
                            continue;
                        case S.OPEN_TAG:
                            if (isMatch(nameBody, c)) parser.tagName += c;
                            else {
                                newTag(parser);
                                if (c === ">") openTag(parser);
                                else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                                else {
                                    if (!isWhitespace(c)) strictFail(parser, "Invalid character in tag name");
                                    parser.state = S.ATTRIB;
                                }
                            }
                            continue;
                        case S.OPEN_TAG_SLASH:
                            if (c === ">") {
                                openTag(parser, true);
                                closeTag(parser);
                            } else {
                                strictFail(parser, "Forward-slash in opening tag not followed by >");
                                parser.state = S.ATTRIB;
                            }
                            continue;
                        case S.ATTRIB:
                            if (isWhitespace(c)) continue;
                            else if (c === ">") openTag(parser);
                            else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                            else if (isMatch(nameStart, c)) {
                                parser.attribName = c;
                                parser.attribValue = "";
                                parser.state = S.ATTRIB_NAME;
                            } else strictFail(parser, "Invalid attribute name");
                            continue;
                        case S.ATTRIB_NAME:
                            if (c === "=") parser.state = S.ATTRIB_VALUE;
                            else if (c === ">") {
                                strictFail(parser, "Attribute without value");
                                parser.attribValue = parser.attribName;
                                attrib(parser);
                                openTag(parser);
                            } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                            else if (isMatch(nameBody, c)) parser.attribName += c;
                            else strictFail(parser, "Invalid attribute name");
                            continue;
                        case S.ATTRIB_NAME_SAW_WHITE:
                            if (c === "=") parser.state = S.ATTRIB_VALUE;
                            else if (isWhitespace(c)) continue;
                            else {
                                strictFail(parser, "Attribute without value");
                                parser.tag.attributes[parser.attribName] = "";
                                parser.attribValue = "";
                                emitNode(parser, "onattribute", {
                                    name: parser.attribName,
                                    value: ""
                                });
                                parser.attribName = "";
                                if (c === ">") openTag(parser);
                                else if (isMatch(nameStart, c)) {
                                    parser.attribName = c;
                                    parser.state = S.ATTRIB_NAME;
                                } else {
                                    strictFail(parser, "Invalid attribute name");
                                    parser.state = S.ATTRIB;
                                }
                            }
                            continue;
                        case S.ATTRIB_VALUE:
                            if (isWhitespace(c)) continue;
                            else if (isQuote(c)) {
                                parser.q = c;
                                parser.state = S.ATTRIB_VALUE_QUOTED;
                            } else {
                                strictFail(parser, "Unquoted attribute value");
                                parser.state = S.ATTRIB_VALUE_UNQUOTED;
                                parser.attribValue = c;
                            }
                            continue;
                        case S.ATTRIB_VALUE_QUOTED:
                            if (c !== parser.q) {
                                if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                                else parser.attribValue += c;
                                continue;
                            }
                            attrib(parser);
                            parser.q = "";
                            parser.state = S.ATTRIB_VALUE_CLOSED;
                            continue;
                        case S.ATTRIB_VALUE_CLOSED:
                            if (isWhitespace(c)) parser.state = S.ATTRIB;
                            else if (c === ">") openTag(parser);
                            else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                            else if (isMatch(nameStart, c)) {
                                strictFail(parser, "No whitespace between attributes");
                                parser.attribName = c;
                                parser.attribValue = "";
                                parser.state = S.ATTRIB_NAME;
                            } else strictFail(parser, "Invalid attribute name");
                            continue;
                        case S.ATTRIB_VALUE_UNQUOTED:
                            if (!isAttribEnd(c)) {
                                if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U;
                                else parser.attribValue += c;
                                continue;
                            }
                            attrib(parser);
                            if (c === ">") openTag(parser);
                            else parser.state = S.ATTRIB;
                            continue;
                        case S.CLOSE_TAG:
                            if (!parser.tagName) {
                                if (isWhitespace(c)) continue;
                                else if (notMatch(nameStart, c)) {
                                    if (parser.script) {
                                        parser.script += "</" + c;
                                        parser.state = S.SCRIPT;
                                    } else strictFail(parser, "Invalid tagname in closing tag.");
                                } else parser.tagName = c;
                            } else if (c === ">") closeTag(parser);
                            else if (isMatch(nameBody, c)) parser.tagName += c;
                            else if (parser.script) {
                                parser.script += "</" + parser.tagName;
                                parser.tagName = "";
                                parser.state = S.SCRIPT;
                            } else {
                                if (!isWhitespace(c)) strictFail(parser, "Invalid tagname in closing tag");
                                parser.state = S.CLOSE_TAG_SAW_WHITE;
                            }
                            continue;
                        case S.CLOSE_TAG_SAW_WHITE:
                            if (isWhitespace(c)) continue;
                            if (c === ">") closeTag(parser);
                            else strictFail(parser, "Invalid characters in closing tag");
                            continue;
                        case S.TEXT_ENTITY:
                        case S.ATTRIB_VALUE_ENTITY_Q:
                        case S.ATTRIB_VALUE_ENTITY_U:
                            var returnState;
                            var buffer2;
                            switch(parser.state){
                                case S.TEXT_ENTITY:
                                    returnState = S.TEXT;
                                    buffer2 = "textNode";
                                    break;
                                case S.ATTRIB_VALUE_ENTITY_Q:
                                    returnState = S.ATTRIB_VALUE_QUOTED;
                                    buffer2 = "attribValue";
                                    break;
                                case S.ATTRIB_VALUE_ENTITY_U:
                                    returnState = S.ATTRIB_VALUE_UNQUOTED;
                                    buffer2 = "attribValue";
                                    break;
                            }
                            if (c === ";") {
                                parser[buffer2] += parseEntity(parser);
                                parser.entity = "";
                                parser.state = returnState;
                            } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                            else {
                                strictFail(parser, "Invalid character in entity name");
                                parser[buffer2] += "&" + parser.entity + c;
                                parser.entity = "";
                                parser.state = returnState;
                            }
                            continue;
                        default:
                            throw new Error(parser, "Unknown state: " + parser.state);
                    }
                }
                if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
                return parser;
            }
            /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ if (!String.fromCodePoint) (function() {
                var stringFromCharCode = String.fromCharCode;
                var floor2 = Math.floor;
                var fromCodePoint = function() {
                    var MAX_SIZE = 16384;
                    var codeUnits = [];
                    var highSurrogate;
                    var lowSurrogate;
                    var index = -1;
                    var length = arguments.length;
                    if (!length) return "";
                    var result = "";
                    while(++index < length){
                        var codePoint = Number(arguments[index]);
                        if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                        codePoint < 0 || // not a valid Unicode code point
                        codePoint > 1114111 || // not a valid Unicode code point
                        floor2(codePoint) !== codePoint) throw RangeError("Invalid code point: " + codePoint);
                        if (codePoint <= 65535) codeUnits.push(codePoint);
                        else {
                            codePoint -= 65536;
                            highSurrogate = (codePoint >> 10) + 55296;
                            lowSurrogate = codePoint % 1024 + 56320;
                            codeUnits.push(highSurrogate, lowSurrogate);
                        }
                        if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                            result += stringFromCharCode.apply(null, codeUnits);
                            codeUnits.length = 0;
                        }
                    }
                    return result;
                };
                if (Object.defineProperty) Object.defineProperty(String, "fromCodePoint", {
                    value: fromCodePoint,
                    configurable: true,
                    writable: true
                });
                else String.fromCodePoint = fromCodePoint;
            })();
        })(exports);
    })($be59461d4a783f7b$var$sax);
    return $be59461d4a783f7b$var$sax;
}
var $be59461d4a783f7b$var$arrayHelper;
var $be59461d4a783f7b$var$hasRequiredArrayHelper;
function $be59461d4a783f7b$var$requireArrayHelper() {
    if ($be59461d4a783f7b$var$hasRequiredArrayHelper) return $be59461d4a783f7b$var$arrayHelper;
    $be59461d4a783f7b$var$hasRequiredArrayHelper = 1;
    $be59461d4a783f7b$var$arrayHelper = {
        isArray: function(value) {
            if (Array.isArray) return Array.isArray(value);
            return Object.prototype.toString.call(value) === "[object Array]";
        }
    };
    return $be59461d4a783f7b$var$arrayHelper;
}
var $be59461d4a783f7b$var$optionsHelper;
var $be59461d4a783f7b$var$hasRequiredOptionsHelper;
function $be59461d4a783f7b$var$requireOptionsHelper() {
    if ($be59461d4a783f7b$var$hasRequiredOptionsHelper) return $be59461d4a783f7b$var$optionsHelper;
    $be59461d4a783f7b$var$hasRequiredOptionsHelper = 1;
    var isArray = $be59461d4a783f7b$var$requireArrayHelper().isArray;
    $be59461d4a783f7b$var$optionsHelper = {
        copyOptions: function(options) {
            var key, copy = {};
            for(key in options)if (options.hasOwnProperty(key)) copy[key] = options[key];
            return copy;
        },
        ensureFlagExists: function(item, options) {
            if (!(item in options) || typeof options[item] !== "boolean") options[item] = false;
        },
        ensureSpacesExists: function(options) {
            if (!("spaces" in options) || typeof options.spaces !== "number" && typeof options.spaces !== "string") options.spaces = 0;
        },
        ensureAlwaysArrayExists: function(options) {
            if (!("alwaysArray" in options) || typeof options.alwaysArray !== "boolean" && !isArray(options.alwaysArray)) options.alwaysArray = false;
        },
        ensureKeyExists: function(key, options) {
            if (!(key + "Key" in options) || typeof options[key + "Key"] !== "string") options[key + "Key"] = options.compact ? "_" + key : key;
        },
        checkFnExists: function(key, options) {
            return key + "Fn" in options;
        }
    };
    return $be59461d4a783f7b$var$optionsHelper;
}
var $be59461d4a783f7b$var$xml2js;
var $be59461d4a783f7b$var$hasRequiredXml2js;
function $be59461d4a783f7b$var$requireXml2js() {
    if ($be59461d4a783f7b$var$hasRequiredXml2js) return $be59461d4a783f7b$var$xml2js;
    $be59461d4a783f7b$var$hasRequiredXml2js = 1;
    var sax2 = $be59461d4a783f7b$var$requireSax();
    var helper = $be59461d4a783f7b$var$requireOptionsHelper();
    var isArray = $be59461d4a783f7b$var$requireArrayHelper().isArray;
    var options;
    var currentElement;
    function validateOptions(userOptions) {
        options = helper.copyOptions(userOptions);
        helper.ensureFlagExists("ignoreDeclaration", options);
        helper.ensureFlagExists("ignoreInstruction", options);
        helper.ensureFlagExists("ignoreAttributes", options);
        helper.ensureFlagExists("ignoreText", options);
        helper.ensureFlagExists("ignoreComment", options);
        helper.ensureFlagExists("ignoreCdata", options);
        helper.ensureFlagExists("ignoreDoctype", options);
        helper.ensureFlagExists("compact", options);
        helper.ensureFlagExists("alwaysChildren", options);
        helper.ensureFlagExists("addParent", options);
        helper.ensureFlagExists("trim", options);
        helper.ensureFlagExists("nativeType", options);
        helper.ensureFlagExists("nativeTypeAttributes", options);
        helper.ensureFlagExists("sanitize", options);
        helper.ensureFlagExists("instructionHasAttributes", options);
        helper.ensureFlagExists("captureSpacesBetweenElements", options);
        helper.ensureAlwaysArrayExists(options);
        helper.ensureKeyExists("declaration", options);
        helper.ensureKeyExists("instruction", options);
        helper.ensureKeyExists("attributes", options);
        helper.ensureKeyExists("text", options);
        helper.ensureKeyExists("comment", options);
        helper.ensureKeyExists("cdata", options);
        helper.ensureKeyExists("doctype", options);
        helper.ensureKeyExists("type", options);
        helper.ensureKeyExists("name", options);
        helper.ensureKeyExists("elements", options);
        helper.ensureKeyExists("parent", options);
        helper.checkFnExists("doctype", options);
        helper.checkFnExists("instruction", options);
        helper.checkFnExists("cdata", options);
        helper.checkFnExists("comment", options);
        helper.checkFnExists("text", options);
        helper.checkFnExists("instructionName", options);
        helper.checkFnExists("elementName", options);
        helper.checkFnExists("attributeName", options);
        helper.checkFnExists("attributeValue", options);
        helper.checkFnExists("attributes", options);
        return options;
    }
    function nativeType(value) {
        var nValue = Number(value);
        if (!isNaN(nValue)) return nValue;
        var bValue = value.toLowerCase();
        if (bValue === "true") return true;
        else if (bValue === "false") return false;
        return value;
    }
    function addField(type2, value) {
        var key;
        if (options.compact) {
            if (!currentElement[options[type2 + "Key"]] && (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(options[type2 + "Key"]) !== -1 : options.alwaysArray)) currentElement[options[type2 + "Key"]] = [];
            if (currentElement[options[type2 + "Key"]] && !isArray(currentElement[options[type2 + "Key"]])) currentElement[options[type2 + "Key"]] = [
                currentElement[options[type2 + "Key"]]
            ];
            if (type2 + "Fn" in options && typeof value === "string") value = options[type2 + "Fn"](value, currentElement);
            if (type2 === "instruction" && ("instructionFn" in options || "instructionNameFn" in options)) {
                for(key in value)if (value.hasOwnProperty(key)) {
                    if ("instructionFn" in options) value[key] = options.instructionFn(value[key], key, currentElement);
                    else {
                        var temp = value[key];
                        delete value[key];
                        value[options.instructionNameFn(key, temp, currentElement)] = temp;
                    }
                }
            }
            if (isArray(currentElement[options[type2 + "Key"]])) currentElement[options[type2 + "Key"]].push(value);
            else currentElement[options[type2 + "Key"]] = value;
        } else {
            if (!currentElement[options.elementsKey]) currentElement[options.elementsKey] = [];
            var element = {};
            element[options.typeKey] = type2;
            if (type2 === "instruction") {
                for(key in value){
                    if (value.hasOwnProperty(key)) break;
                }
                element[options.nameKey] = "instructionNameFn" in options ? options.instructionNameFn(key, value, currentElement) : key;
                if (options.instructionHasAttributes) {
                    element[options.attributesKey] = value[key][options.attributesKey];
                    if ("instructionFn" in options) element[options.attributesKey] = options.instructionFn(element[options.attributesKey], key, currentElement);
                } else {
                    if ("instructionFn" in options) value[key] = options.instructionFn(value[key], key, currentElement);
                    element[options.instructionKey] = value[key];
                }
            } else {
                if (type2 + "Fn" in options) value = options[type2 + "Fn"](value, currentElement);
                element[options[type2 + "Key"]] = value;
            }
            if (options.addParent) element[options.parentKey] = currentElement;
            currentElement[options.elementsKey].push(element);
        }
    }
    function manipulateAttributes(attributes) {
        if ("attributesFn" in options && attributes) attributes = options.attributesFn(attributes, currentElement);
        if ((options.trim || "attributeValueFn" in options || "attributeNameFn" in options || options.nativeTypeAttributes) && attributes) {
            var key;
            for(key in attributes)if (attributes.hasOwnProperty(key)) {
                if (options.trim) attributes[key] = attributes[key].trim();
                if (options.nativeTypeAttributes) attributes[key] = nativeType(attributes[key]);
                if ("attributeValueFn" in options) attributes[key] = options.attributeValueFn(attributes[key], key, currentElement);
                if ("attributeNameFn" in options) {
                    var temp = attributes[key];
                    delete attributes[key];
                    attributes[options.attributeNameFn(key, attributes[key], currentElement)] = temp;
                }
            }
        }
        return attributes;
    }
    function onInstruction(instruction) {
        var attributes = {};
        if (instruction.body && (instruction.name.toLowerCase() === "xml" || options.instructionHasAttributes)) {
            var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
            var match;
            while((match = attrsRegExp.exec(instruction.body)) !== null)attributes[match[1]] = match[2] || match[3] || match[4];
            attributes = manipulateAttributes(attributes);
        }
        if (instruction.name.toLowerCase() === "xml") {
            if (options.ignoreDeclaration) return;
            currentElement[options.declarationKey] = {};
            if (Object.keys(attributes).length) currentElement[options.declarationKey][options.attributesKey] = attributes;
            if (options.addParent) currentElement[options.declarationKey][options.parentKey] = currentElement;
        } else {
            if (options.ignoreInstruction) return;
            if (options.trim) instruction.body = instruction.body.trim();
            var value = {};
            if (options.instructionHasAttributes && Object.keys(attributes).length) {
                value[instruction.name] = {};
                value[instruction.name][options.attributesKey] = attributes;
            } else value[instruction.name] = instruction.body;
            addField("instruction", value);
        }
    }
    function onStartElement(name, attributes) {
        var element;
        if (typeof name === "object") {
            attributes = name.attributes;
            name = name.name;
        }
        attributes = manipulateAttributes(attributes);
        if ("elementNameFn" in options) name = options.elementNameFn(name, currentElement);
        if (options.compact) {
            element = {};
            if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
                element[options.attributesKey] = {};
                var key;
                for(key in attributes)if (attributes.hasOwnProperty(key)) element[options.attributesKey][key] = attributes[key];
            }
            if (!(name in currentElement) && (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(name) !== -1 : options.alwaysArray)) currentElement[name] = [];
            if (currentElement[name] && !isArray(currentElement[name])) currentElement[name] = [
                currentElement[name]
            ];
            if (isArray(currentElement[name])) currentElement[name].push(element);
            else currentElement[name] = element;
        } else {
            if (!currentElement[options.elementsKey]) currentElement[options.elementsKey] = [];
            element = {};
            element[options.typeKey] = "element";
            element[options.nameKey] = name;
            if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) element[options.attributesKey] = attributes;
            if (options.alwaysChildren) element[options.elementsKey] = [];
            currentElement[options.elementsKey].push(element);
        }
        element[options.parentKey] = currentElement;
        currentElement = element;
    }
    function onText(text) {
        if (options.ignoreText) return;
        if (!text.trim() && !options.captureSpacesBetweenElements) return;
        if (options.trim) text = text.trim();
        if (options.nativeType) text = nativeType(text);
        if (options.sanitize) text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        addField("text", text);
    }
    function onComment(comment) {
        if (options.ignoreComment) return;
        if (options.trim) comment = comment.trim();
        addField("comment", comment);
    }
    function onEndElement(name) {
        var parentElement = currentElement[options.parentKey];
        if (!options.addParent) delete currentElement[options.parentKey];
        currentElement = parentElement;
    }
    function onCdata(cdata) {
        if (options.ignoreCdata) return;
        if (options.trim) cdata = cdata.trim();
        addField("cdata", cdata);
    }
    function onDoctype(doctype) {
        if (options.ignoreDoctype) return;
        doctype = doctype.replace(/^ /, "");
        if (options.trim) doctype = doctype.trim();
        addField("doctype", doctype);
    }
    function onError(error) {
        error.note = error;
    }
    $be59461d4a783f7b$var$xml2js = function(xml2, userOptions) {
        var parser = sax2.parser(true, {});
        var result = {};
        currentElement = result;
        options = validateOptions(userOptions);
        parser.opt = {
            strictEntities: true
        };
        parser.onopentag = onStartElement;
        parser.ontext = onText;
        parser.oncomment = onComment;
        parser.onclosetag = onEndElement;
        parser.onerror = onError;
        parser.oncdata = onCdata;
        parser.ondoctype = onDoctype;
        parser.onprocessinginstruction = onInstruction;
        parser.write(xml2).close();
        if (result[options.elementsKey]) {
            var temp = result[options.elementsKey];
            delete result[options.elementsKey];
            result[options.elementsKey] = temp;
            delete result.text;
        }
        return result;
    };
    return $be59461d4a783f7b$var$xml2js;
}
var $be59461d4a783f7b$var$xml2json;
var $be59461d4a783f7b$var$hasRequiredXml2json;
function $be59461d4a783f7b$var$requireXml2json() {
    if ($be59461d4a783f7b$var$hasRequiredXml2json) return $be59461d4a783f7b$var$xml2json;
    $be59461d4a783f7b$var$hasRequiredXml2json = 1;
    var helper = $be59461d4a783f7b$var$requireOptionsHelper();
    var xml2js2 = $be59461d4a783f7b$var$requireXml2js();
    function validateOptions(userOptions) {
        var options = helper.copyOptions(userOptions);
        helper.ensureSpacesExists(options);
        return options;
    }
    $be59461d4a783f7b$var$xml2json = function(xml2, userOptions) {
        var options, js, json, parentKey;
        options = validateOptions(userOptions);
        js = xml2js2(xml2, options);
        parentKey = "compact" in options && options.compact ? "_parent" : "parent";
        if ("addParent" in options && options.addParent) json = JSON.stringify(js, function(k, v) {
            return k === parentKey ? "_" : v;
        }, options.spaces);
        else json = JSON.stringify(js, null, options.spaces);
        return json.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
    };
    return $be59461d4a783f7b$var$xml2json;
}
var $be59461d4a783f7b$var$js2xml;
var $be59461d4a783f7b$var$hasRequiredJs2xml;
function $be59461d4a783f7b$var$requireJs2xml() {
    if ($be59461d4a783f7b$var$hasRequiredJs2xml) return $be59461d4a783f7b$var$js2xml;
    $be59461d4a783f7b$var$hasRequiredJs2xml = 1;
    var helper = $be59461d4a783f7b$var$requireOptionsHelper();
    var isArray = $be59461d4a783f7b$var$requireArrayHelper().isArray;
    var currentElement, currentElementName;
    function validateOptions(userOptions) {
        var options = helper.copyOptions(userOptions);
        helper.ensureFlagExists("ignoreDeclaration", options);
        helper.ensureFlagExists("ignoreInstruction", options);
        helper.ensureFlagExists("ignoreAttributes", options);
        helper.ensureFlagExists("ignoreText", options);
        helper.ensureFlagExists("ignoreComment", options);
        helper.ensureFlagExists("ignoreCdata", options);
        helper.ensureFlagExists("ignoreDoctype", options);
        helper.ensureFlagExists("compact", options);
        helper.ensureFlagExists("indentText", options);
        helper.ensureFlagExists("indentCdata", options);
        helper.ensureFlagExists("indentAttributes", options);
        helper.ensureFlagExists("indentInstruction", options);
        helper.ensureFlagExists("fullTagEmptyElement", options);
        helper.ensureFlagExists("noQuotesForNativeAttributes", options);
        helper.ensureSpacesExists(options);
        if (typeof options.spaces === "number") options.spaces = Array(options.spaces + 1).join(" ");
        helper.ensureKeyExists("declaration", options);
        helper.ensureKeyExists("instruction", options);
        helper.ensureKeyExists("attributes", options);
        helper.ensureKeyExists("text", options);
        helper.ensureKeyExists("comment", options);
        helper.ensureKeyExists("cdata", options);
        helper.ensureKeyExists("doctype", options);
        helper.ensureKeyExists("type", options);
        helper.ensureKeyExists("name", options);
        helper.ensureKeyExists("elements", options);
        helper.checkFnExists("doctype", options);
        helper.checkFnExists("instruction", options);
        helper.checkFnExists("cdata", options);
        helper.checkFnExists("comment", options);
        helper.checkFnExists("text", options);
        helper.checkFnExists("instructionName", options);
        helper.checkFnExists("elementName", options);
        helper.checkFnExists("attributeName", options);
        helper.checkFnExists("attributeValue", options);
        helper.checkFnExists("attributes", options);
        helper.checkFnExists("fullTagEmptyElement", options);
        return options;
    }
    function writeIndentation(options, depth, firstLine) {
        return (!firstLine && options.spaces ? "\n" : "") + Array(depth + 1).join(options.spaces);
    }
    function writeAttributes(attributes, options, depth) {
        if (options.ignoreAttributes) return "";
        if ("attributesFn" in options) attributes = options.attributesFn(attributes, currentElementName, currentElement);
        var key, attr, attrName, quote, result = [];
        for(key in attributes)if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== void 0) {
            quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== "string" ? "" : '"';
            attr = "" + attributes[key];
            attr = attr.replace(/"/g, "&quot;");
            attrName = "attributeNameFn" in options ? options.attributeNameFn(key, attr, currentElementName, currentElement) : key;
            result.push(options.spaces && options.indentAttributes ? writeIndentation(options, depth + 1, false) : " ");
            result.push(attrName + "=" + quote + ("attributeValueFn" in options ? options.attributeValueFn(attr, key, currentElementName, currentElement) : attr) + quote);
        }
        if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) result.push(writeIndentation(options, depth, false));
        return result.join("");
    }
    function writeDeclaration(declaration, options, depth) {
        currentElement = declaration;
        currentElementName = "xml";
        return options.ignoreDeclaration ? "" : "<?xml" + writeAttributes(declaration[options.attributesKey], options, depth) + "?>";
    }
    function writeInstruction(instruction, options, depth) {
        if (options.ignoreInstruction) return "";
        var key;
        for(key in instruction){
            if (instruction.hasOwnProperty(key)) break;
        }
        var instructionName = "instructionNameFn" in options ? options.instructionNameFn(key, instruction[key], currentElementName, currentElement) : key;
        if (typeof instruction[key] === "object") {
            currentElement = instruction;
            currentElementName = instructionName;
            return "<?" + instructionName + writeAttributes(instruction[key][options.attributesKey], options, depth) + "?>";
        } else {
            var instructionValue = instruction[key] ? instruction[key] : "";
            if ("instructionFn" in options) instructionValue = options.instructionFn(instructionValue, key, currentElementName, currentElement);
            return "<?" + instructionName + (instructionValue ? " " + instructionValue : "") + "?>";
        }
    }
    function writeComment(comment, options) {
        return options.ignoreComment ? "" : "<!--" + ("commentFn" in options ? options.commentFn(comment, currentElementName, currentElement) : comment) + "-->";
    }
    function writeCdata(cdata, options) {
        return options.ignoreCdata ? "" : "<![CDATA[" + ("cdataFn" in options ? options.cdataFn(cdata, currentElementName, currentElement) : cdata.replace("]]>", "]]]]><![CDATA[>")) + "]]>";
    }
    function writeDoctype(doctype, options) {
        return options.ignoreDoctype ? "" : "<!DOCTYPE " + ("doctypeFn" in options ? options.doctypeFn(doctype, currentElementName, currentElement) : doctype) + ">";
    }
    function writeText(text, options) {
        if (options.ignoreText) return "";
        text = "" + text;
        text = text.replace(/&amp;/g, "&");
        text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        return "textFn" in options ? options.textFn(text, currentElementName, currentElement) : text;
    }
    function hasContent(element, options) {
        var i;
        if (element.elements && element.elements.length) for(i = 0; i < element.elements.length; ++i)switch(element.elements[i][options.typeKey]){
            case "text":
                if (options.indentText) return true;
                break;
            // skip to next key
            case "cdata":
                if (options.indentCdata) return true;
                break;
            // skip to next key
            case "instruction":
                if (options.indentInstruction) return true;
                break;
            // skip to next key
            case "doctype":
            case "comment":
            case "element":
                return true;
            default:
                return true;
        }
        return false;
    }
    function writeElement(element, options, depth) {
        currentElement = element;
        currentElementName = element.name;
        var xml2 = [], elementName = "elementNameFn" in options ? options.elementNameFn(element.name, element) : element.name;
        xml2.push("<" + elementName);
        if (element[options.attributesKey]) xml2.push(writeAttributes(element[options.attributesKey], options, depth));
        var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]["xml:space"] === "preserve";
        if (!withClosingTag) {
            if ("fullTagEmptyElementFn" in options) withClosingTag = options.fullTagEmptyElementFn(element.name, element);
            else withClosingTag = options.fullTagEmptyElement;
        }
        if (withClosingTag) {
            xml2.push(">");
            if (element[options.elementsKey] && element[options.elementsKey].length) {
                xml2.push(writeElements(element[options.elementsKey], options, depth + 1));
                currentElement = element;
                currentElementName = element.name;
            }
            xml2.push(options.spaces && hasContent(element, options) ? "\n" + Array(depth + 1).join(options.spaces) : "");
            xml2.push("</" + elementName + ">");
        } else xml2.push("/>");
        return xml2.join("");
    }
    function writeElements(elements, options, depth, firstLine) {
        return elements.reduce(function(xml2, element) {
            var indent = writeIndentation(options, depth, firstLine && !xml2);
            switch(element.type){
                case "element":
                    return xml2 + indent + writeElement(element, options, depth);
                case "comment":
                    return xml2 + indent + writeComment(element[options.commentKey], options);
                case "doctype":
                    return xml2 + indent + writeDoctype(element[options.doctypeKey], options);
                case "cdata":
                    return xml2 + (options.indentCdata ? indent : "") + writeCdata(element[options.cdataKey], options);
                case "text":
                    return xml2 + (options.indentText ? indent : "") + writeText(element[options.textKey], options);
                case "instruction":
                    var instruction = {};
                    instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
                    return xml2 + (options.indentInstruction ? indent : "") + writeInstruction(instruction, options, depth);
            }
        }, "");
    }
    function hasContentCompact(element, options, anyContent) {
        var key;
        for(key in element)if (element.hasOwnProperty(key)) switch(key){
            case options.parentKey:
            case options.attributesKey:
                break;
            // skip to next key
            case options.textKey:
                if (options.indentText || anyContent) return true;
                break;
            // skip to next key
            case options.cdataKey:
                if (options.indentCdata || anyContent) return true;
                break;
            // skip to next key
            case options.instructionKey:
                if (options.indentInstruction || anyContent) return true;
                break;
            // skip to next key
            case options.doctypeKey:
            case options.commentKey:
                return true;
            default:
                return true;
        }
        return false;
    }
    function writeElementCompact(element, name, options, depth, indent) {
        currentElement = element;
        currentElementName = name;
        var elementName = "elementNameFn" in options ? options.elementNameFn(name, element) : name;
        if (typeof element === "undefined" || element === null || element === "") return "fullTagEmptyElementFn" in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? "<" + elementName + "></" + elementName + ">" : "<" + elementName + "/>";
        var xml2 = [];
        if (name) {
            xml2.push("<" + elementName);
            if (typeof element !== "object") {
                xml2.push(">" + writeText(element, options) + "</" + elementName + ">");
                return xml2.join("");
            }
            if (element[options.attributesKey]) xml2.push(writeAttributes(element[options.attributesKey], options, depth));
            var withClosingTag = hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]["xml:space"] === "preserve";
            if (!withClosingTag) {
                if ("fullTagEmptyElementFn" in options) withClosingTag = options.fullTagEmptyElementFn(name, element);
                else withClosingTag = options.fullTagEmptyElement;
            }
            if (withClosingTag) xml2.push(">");
            else {
                xml2.push("/>");
                return xml2.join("");
            }
        }
        xml2.push(writeElementsCompact(element, options, depth + 1, false));
        currentElement = element;
        currentElementName = name;
        if (name) xml2.push((indent ? writeIndentation(options, depth, false) : "") + "</" + elementName + ">");
        return xml2.join("");
    }
    function writeElementsCompact(element, options, depth, firstLine) {
        var i, key, nodes, xml2 = [];
        for(key in element)if (element.hasOwnProperty(key)) {
            nodes = isArray(element[key]) ? element[key] : [
                element[key]
            ];
            for(i = 0; i < nodes.length; ++i){
                switch(key){
                    case options.declarationKey:
                        xml2.push(writeDeclaration(nodes[i], options, depth));
                        break;
                    case options.instructionKey:
                        xml2.push((options.indentInstruction ? writeIndentation(options, depth, firstLine) : "") + writeInstruction(nodes[i], options, depth));
                        break;
                    case options.attributesKey:
                    case options.parentKey:
                        break;
                    // skip
                    case options.textKey:
                        xml2.push((options.indentText ? writeIndentation(options, depth, firstLine) : "") + writeText(nodes[i], options));
                        break;
                    case options.cdataKey:
                        xml2.push((options.indentCdata ? writeIndentation(options, depth, firstLine) : "") + writeCdata(nodes[i], options));
                        break;
                    case options.doctypeKey:
                        xml2.push(writeIndentation(options, depth, firstLine) + writeDoctype(nodes[i], options));
                        break;
                    case options.commentKey:
                        xml2.push(writeIndentation(options, depth, firstLine) + writeComment(nodes[i], options));
                        break;
                    default:
                        xml2.push(writeIndentation(options, depth, firstLine) + writeElementCompact(nodes[i], key, options, depth, hasContentCompact(nodes[i], options)));
                }
                firstLine = firstLine && !xml2.length;
            }
        }
        return xml2.join("");
    }
    $be59461d4a783f7b$var$js2xml = function(js, options) {
        options = validateOptions(options);
        var xml2 = [];
        currentElement = js;
        currentElementName = "_root_";
        if (options.compact) xml2.push(writeElementsCompact(js, options, 0, true));
        else {
            if (js[options.declarationKey]) xml2.push(writeDeclaration(js[options.declarationKey], options, 0));
            if (js[options.elementsKey] && js[options.elementsKey].length) xml2.push(writeElements(js[options.elementsKey], options, 0, !xml2.length));
        }
        return xml2.join("");
    };
    return $be59461d4a783f7b$var$js2xml;
}
var $be59461d4a783f7b$var$json2xml;
var $be59461d4a783f7b$var$hasRequiredJson2xml;
function $be59461d4a783f7b$var$requireJson2xml() {
    if ($be59461d4a783f7b$var$hasRequiredJson2xml) return $be59461d4a783f7b$var$json2xml;
    $be59461d4a783f7b$var$hasRequiredJson2xml = 1;
    var js2xml2 = $be59461d4a783f7b$var$requireJs2xml();
    $be59461d4a783f7b$var$json2xml = function(json, options) {
        if (json instanceof $be59461d4a783f7b$var$Buffer) json = json.toString();
        var js = null;
        if (typeof json === "string") try {
            js = JSON.parse(json);
        } catch (e) {
            throw new Error("The JSON structure is invalid");
        }
        else js = json;
        return js2xml2(js, options);
    };
    return $be59461d4a783f7b$var$json2xml;
}
var $be59461d4a783f7b$var$lib;
var $be59461d4a783f7b$var$hasRequiredLib;
function $be59461d4a783f7b$var$requireLib() {
    if ($be59461d4a783f7b$var$hasRequiredLib) return $be59461d4a783f7b$var$lib;
    $be59461d4a783f7b$var$hasRequiredLib = 1;
    var xml2js2 = $be59461d4a783f7b$var$requireXml2js();
    var xml2json2 = $be59461d4a783f7b$var$requireXml2json();
    var js2xml2 = $be59461d4a783f7b$var$requireJs2xml();
    var json2xml2 = $be59461d4a783f7b$var$requireJson2xml();
    $be59461d4a783f7b$var$lib = {
        xml2js: xml2js2,
        xml2json: xml2json2,
        js2xml: js2xml2,
        json2xml: json2xml2
    };
    return $be59461d4a783f7b$var$lib;
}
var $be59461d4a783f7b$var$libExports = $be59461d4a783f7b$var$requireLib();
const $be59461d4a783f7b$export$cd3b8f5143756514 = (element)=>{
    switch(element.type){
        case void 0:
        case "element":
            const xmlComponent = new $be59461d4a783f7b$export$77c93fcadb03b2c4(element.name, element.attributes);
            const childElements = element.elements || [];
            for (const childElm of childElements){
                const child = $be59461d4a783f7b$export$cd3b8f5143756514(childElm);
                if (child !== void 0) xmlComponent.push(child);
            }
            return xmlComponent;
        case "text":
            return element.text;
        default:
            return void 0;
    }
};
class $be59461d4a783f7b$var$ImportedXmlComponentAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
}
class $be59461d4a783f7b$export$77c93fcadb03b2c4 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    /**
   * Converts the xml string to a XmlComponent tree.
   *
   * @param importedContent xml content of the imported component
   */ static fromXmlString(importedContent) {
        const xmlObj = $be59461d4a783f7b$var$libExports.xml2js(importedContent, {
            compact: false
        });
        return $be59461d4a783f7b$export$cd3b8f5143756514(xmlObj);
    }
    /**
   * Converts the xml string to a XmlComponent tree.
   *
   * @param importedContent xml content of the imported component
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rootKey, _attr){
        super(rootKey);
        if (_attr) this.root.push(new $be59461d4a783f7b$var$ImportedXmlComponentAttributes(_attr));
    }
    push(xmlComponent) {
        this.root.push(xmlComponent);
    }
}
class $be59461d4a783f7b$export$f3691753fff0e91f extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(_attr){
        super("");
        this._attr = _attr;
    }
    prepForXml(_) {
        return {
            _attr: this._attr
        };
    }
}
const $be59461d4a783f7b$export$c4bbce4cc16b0237 = "";
class $be59461d4a783f7b$export$646396cb36770d6c extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(rootKey, initComponent){
        super(rootKey);
        if (initComponent) this.root = initComponent.root;
    }
}
const $be59461d4a783f7b$export$3965b376946dc953 = (val)=>{
    if (isNaN(val)) throw new Error(`Invalid value '${val}' specified. Must be an integer.`);
    return Math.floor(val);
};
const $be59461d4a783f7b$export$58d953e127c6884e = (val)=>{
    const value = $be59461d4a783f7b$export$3965b376946dc953(val);
    if (value < 0) throw new Error(`Invalid value '${val}' specified. Must be a positive integer.`);
    return value;
};
const $be59461d4a783f7b$var$hexBinary = (val, length)=>{
    const expectedLength = length * 2;
    if (val.length !== expectedLength || isNaN(Number(`0x${val}`))) throw new Error(`Invalid hex value '${val}'. Expected ${expectedLength} digit hex value`);
    return val;
};
const $be59461d4a783f7b$export$a5c0e816bf39352b = (val)=>$be59461d4a783f7b$var$hexBinary(val, 4);
const $be59461d4a783f7b$export$545c905536cb1e26 = (val)=>$be59461d4a783f7b$var$hexBinary(val, 2);
const $be59461d4a783f7b$export$2a22699fe7518b3d = (val)=>$be59461d4a783f7b$var$hexBinary(val, 1);
const $be59461d4a783f7b$export$931bfbdf25b9a036 = (val)=>{
    const unit = val.slice(-2);
    const amount = val.substring(0, val.length - 2);
    return `${Number(amount)}${unit}`;
};
const $be59461d4a783f7b$export$f6298d17c608c740 = (val)=>{
    const value = $be59461d4a783f7b$export$931bfbdf25b9a036(val);
    if (parseFloat(value) < 0) throw new Error(`Invalid value '${value}' specified. Expected a positive number.`);
    return value;
};
const $be59461d4a783f7b$export$39c9e6e42c794b97 = (val)=>{
    if (val === "auto") return val;
    const color = val.charAt(0) === "#" ? val.substring(1) : val;
    return $be59461d4a783f7b$var$hexBinary(color, 3);
};
const $be59461d4a783f7b$export$866cabb7ed3455e9 = (val)=>typeof val === "string" ? $be59461d4a783f7b$export$931bfbdf25b9a036(val) : $be59461d4a783f7b$export$3965b376946dc953(val);
const $be59461d4a783f7b$export$3813118357b6f66a = (val)=>typeof val === "string" ? $be59461d4a783f7b$export$f6298d17c608c740(val) : $be59461d4a783f7b$export$58d953e127c6884e(val);
const $be59461d4a783f7b$export$100aeae069b884f4 = (val)=>typeof val === "string" ? $be59461d4a783f7b$export$931bfbdf25b9a036(val) : $be59461d4a783f7b$export$3965b376946dc953(val);
const $be59461d4a783f7b$export$ffe63bc01ceacb3d = (val)=>typeof val === "string" ? $be59461d4a783f7b$export$f6298d17c608c740(val) : $be59461d4a783f7b$export$58d953e127c6884e(val);
const $be59461d4a783f7b$export$ac4c0555c0ebcb52 = (val)=>{
    const percent = val.substring(0, val.length - 1);
    return `${Number(percent)}%`;
};
const $be59461d4a783f7b$export$cb4dd365b0fd654b = (val)=>{
    if (typeof val === "number") return $be59461d4a783f7b$export$3965b376946dc953(val);
    if (val.slice(-1) === "%") return $be59461d4a783f7b$export$ac4c0555c0ebcb52(val);
    return $be59461d4a783f7b$export$931bfbdf25b9a036(val);
};
const $be59461d4a783f7b$export$1363940119b3ec20 = $be59461d4a783f7b$export$58d953e127c6884e;
const $be59461d4a783f7b$export$1a8952df865d374b = $be59461d4a783f7b$export$58d953e127c6884e;
const $be59461d4a783f7b$export$89d9edd4d0429282 = (val)=>val.toISOString();
class $be59461d4a783f7b$export$9ea807bff926c949 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name, val = true){
        super(name);
        if (val !== true) this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: val
        }));
    }
}
class $be59461d4a783f7b$export$47eaf94bc2b4abbf extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name, val){
        super(name);
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: $be59461d4a783f7b$export$3813118357b6f66a(val)
        }));
    }
}
class $be59461d4a783f7b$export$96977b263db98d55 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
}
class $be59461d4a783f7b$export$eacbde36aa74068 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name, val){
        super(name);
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: val
        }));
    }
}
const $be59461d4a783f7b$export$e9d3b59c3f434130 = (name, value)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: name,
        attributes: {
            value: {
                key: "w:val",
                value: value
            }
        }
    });
class $be59461d4a783f7b$export$7c6d6f8dacf13e40 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name, val){
        super(name);
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: val
        }));
    }
}
class $be59461d4a783f7b$export$5616f64bff69d2 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name, val){
        super(name);
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: val
        }));
    }
}
class $be59461d4a783f7b$export$5ef82a33e5d8976f extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name, val){
        super(name);
        this.root.push(val);
    }
}
class $be59461d4a783f7b$export$da493cbe1334accc extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ name: name, attributes: attributes, children: children }){
        super(name);
        if (attributes) this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a(attributes));
        if (children) this.root.push(...children);
    }
}
const $be59461d4a783f7b$export$97e681628fc5cdf4 = {
    /** Align Start */ START: "start",
    /** Align Center */ CENTER: "center",
    /** End */ END: "end",
    /** Justified */ BOTH: "both",
    /** Medium Kashida Length */ MEDIUM_KASHIDA: "mediumKashida",
    /** Distribute All Characters Equally */ DISTRIBUTE: "distribute",
    /** Align to List Tab */ NUM_TAB: "numTab",
    /** Widest Kashida Length */ HIGH_KASHIDA: "highKashida",
    /** Low Kashida Length */ LOW_KASHIDA: "lowKashida",
    /** Thai Language Justification */ THAI_DISTRIBUTE: "thaiDistribute",
    /** Align Left */ LEFT: "left",
    /** Align Right */ RIGHT: "right",
    /** Justified */ JUSTIFIED: "both"
};
class $be59461d4a783f7b$export$1f0c0d50b8c8ca7c extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$export$9d7927214ed7d2cf extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(type2){
        super("w:jc");
        this.root.push(new $be59461d4a783f7b$export$1f0c0d50b8c8ca7c({
            val: type2
        }));
    }
}
class $be59461d4a783f7b$export$a6733098a4eb57cf extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(elementName, { color: color, size: size, space: space, style: style }){
        super(elementName);
        this.root.push(new $be59461d4a783f7b$var$BordersAttributes({
            style: style,
            color: color === void 0 ? void 0 : $be59461d4a783f7b$export$39c9e6e42c794b97(color),
            size: size === void 0 ? void 0 : $be59461d4a783f7b$export$1363940119b3ec20(size),
            space: space === void 0 ? void 0 : $be59461d4a783f7b$export$1a8952df865d374b(space)
        }));
    }
}
class $be59461d4a783f7b$var$BordersAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            style: "w:val",
            color: "w:color",
            size: "w:sz",
            space: "w:space"
        });
    }
}
const $be59461d4a783f7b$export$5f9c7f3ab6d185b = {
    /** a single line */ SINGLE: "single",
    /** a line with a series of alternating thin and thick strokes */ DASH_DOT_STROKED: "dashDotStroked",
    /** a dashed line */ DASHED: "dashed",
    /** a dashed line with small gaps */ DASH_SMALL_GAP: "dashSmallGap",
    /** a line with alternating dots and dashes */ DOT_DASH: "dotDash",
    /** a line with a repeating dot - dot - dash sequence */ DOT_DOT_DASH: "dotDotDash",
    /** a dotted line */ DOTTED: "dotted",
    /** a double line */ DOUBLE: "double",
    /** a double wavy line */ DOUBLE_WAVE: "doubleWave",
    /** an inset set of lines */ INSET: "inset",
    /** no border */ NIL: "nil",
    /** no border */ NONE: "none",
    /** an outset set of lines */ OUTSET: "outset",
    /** a single line */ THICK: "thick",
    /** a thick line contained within a thin line with a large-sized intermediate gap */ THICK_THIN_LARGE_GAP: "thickThinLargeGap",
    /** a thick line contained within a thin line with a medium-sized intermediate gap */ THICK_THIN_MEDIUM_GAP: "thickThinMediumGap",
    /** a thick line contained within a thin line with a small intermediate gap */ THICK_THIN_SMALL_GAP: "thickThinSmallGap",
    /** a thin line contained within a thick line with a large-sized intermediate gap */ THIN_THICK_LARGE_GAP: "thinThickLargeGap",
    /** a thick line contained within a thin line with a medium-sized intermediate gap */ THIN_THICK_MEDIUM_GAP: "thinThickMediumGap",
    /** a thick line contained within a thin line with a small intermediate gap */ THIN_THICK_SMALL_GAP: "thinThickSmallGap",
    /** a thin-thick-thin line with a large gap */ THIN_THICK_THIN_LARGE_GAP: "thinThickThinLargeGap",
    /** a thin-thick-thin line with a medium gap */ THIN_THICK_THIN_MEDIUM_GAP: "thinThickThinMediumGap",
    /** a thin-thick-thin line with a small gap */ THIN_THICK_THIN_SMALL_GAP: "thinThickThinSmallGap",
    /** a three-staged gradient line, getting darker towards the paragraph */ THREE_D_EMBOSS: "threeDEmboss",
    /** a three-staged gradient like, getting darker away from the paragraph */ THREE_D_ENGRAVE: "threeDEngrave",
    /** a triple line */ TRIPLE: "triple",
    /** a wavy line */ WAVE: "wave"
};
class $be59461d4a783f7b$export$d8e9c9d63e86d41e extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(options){
        super("w:pBdr");
        if (options.top) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:top", options.top));
        if (options.bottom) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:bottom", options.bottom));
        if (options.left) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:left", options.left));
        if (options.right) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:right", options.right));
    }
}
class $be59461d4a783f7b$export$ae968d136aefa6fc extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:pBdr");
        const bottom = new $be59461d4a783f7b$export$a6733098a4eb57cf("w:bottom", {
            color: "auto",
            space: 1,
            style: $be59461d4a783f7b$export$5f9c7f3ab6d185b.SINGLE,
            size: 6
        });
        this.root.push(bottom);
    }
}
class $be59461d4a783f7b$export$e883eb7bc5d8ee6 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ start: start, end: end, left: left, right: right, hanging: hanging, firstLine: firstLine }){
        super("w:ind");
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            start: {
                key: "w:start",
                value: start === void 0 ? void 0 : $be59461d4a783f7b$export$866cabb7ed3455e9(start)
            },
            end: {
                key: "w:end",
                value: end === void 0 ? void 0 : $be59461d4a783f7b$export$866cabb7ed3455e9(end)
            },
            left: {
                key: "w:left",
                value: left === void 0 ? void 0 : $be59461d4a783f7b$export$866cabb7ed3455e9(left)
            },
            right: {
                key: "w:right",
                value: right === void 0 ? void 0 : $be59461d4a783f7b$export$866cabb7ed3455e9(right)
            },
            hanging: {
                key: "w:hanging",
                value: hanging === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(hanging)
            },
            firstLine: {
                key: "w:firstLine",
                value: firstLine === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(firstLine)
            }
        }));
    }
}
let $be59461d4a783f7b$var$Break$1 = class Break extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:br");
    }
};
const $be59461d4a783f7b$var$FieldCharacterType = {
    BEGIN: "begin",
    END: "end",
    SEPARATE: "separate"
};
class $be59461d4a783f7b$var$FidCharAttrs extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            type: "w:fldCharType",
            dirty: "w:dirty"
        });
    }
}
class $be59461d4a783f7b$var$Begin extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(dirty){
        super("w:fldChar");
        this.root.push(new $be59461d4a783f7b$var$FidCharAttrs({
            type: $be59461d4a783f7b$var$FieldCharacterType.BEGIN,
            dirty: dirty
        }));
    }
}
class $be59461d4a783f7b$var$Separate extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(dirty){
        super("w:fldChar");
        this.root.push(new $be59461d4a783f7b$var$FidCharAttrs({
            type: $be59461d4a783f7b$var$FieldCharacterType.SEPARATE,
            dirty: dirty
        }));
    }
}
class $be59461d4a783f7b$var$End extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(dirty){
        super("w:fldChar");
        this.root.push(new $be59461d4a783f7b$var$FidCharAttrs({
            type: $be59461d4a783f7b$var$FieldCharacterType.END,
            dirty: dirty
        }));
    }
}
const $be59461d4a783f7b$export$ac6f53b7b1ca6d = {
    CENTER: "center",
    INSIDE: "inside",
    LEFT: "left",
    OUTSIDE: "outside",
    RIGHT: "right"
};
const $be59461d4a783f7b$export$9da8b3349e2dd4ea = {
    BOTTOM: "bottom",
    CENTER: "center",
    INSIDE: "inside",
    OUTSIDE: "outside",
    TOP: "top"
};
const $be59461d4a783f7b$export$27bce688931fdfcc = {
    DECIMAL: "decimal",
    UPPER_ROMAN: "upperRoman",
    LOWER_ROMAN: "lowerRoman",
    UPPER_LETTER: "upperLetter",
    LOWER_LETTER: "lowerLetter",
    ORDINAL: "ordinal",
    CARDINAL_TEXT: "cardinalText",
    ORDINAL_TEXT: "ordinalText",
    HEX: "hex",
    CHICAGO: "chicago",
    IDEOGRAPH_DIGITAL: "ideographDigital",
    JAPANESE_COUNTING: "japaneseCounting",
    AIUEO: "aiueo",
    IROHA: "iroha",
    DECIMAL_FULL_WIDTH: "decimalFullWidth",
    DECIMAL_HALF_WIDTH: "decimalHalfWidth",
    JAPANESE_LEGAL: "japaneseLegal",
    JAPANESE_DIGITAL_TEN_THOUSAND: "japaneseDigitalTenThousand",
    DECIMAL_ENCLOSED_CIRCLE: "decimalEnclosedCircle",
    DECIMAL_FULL_WIDTH_2: "decimalFullWidth2",
    AIUEO_FULL_WIDTH: "aiueoFullWidth",
    IROHA_FULL_WIDTH: "irohaFullWidth",
    DECIMAL_ZERO: "decimalZero",
    BULLET: "bullet",
    GANADA: "ganada",
    CHOSUNG: "chosung",
    DECIMAL_ENCLOSED_FULL_STOP: "decimalEnclosedFullstop",
    DECIMAL_ENCLOSED_PAREN: "decimalEnclosedParen",
    DECIMAL_ENCLOSED_CIRCLE_CHINESE: "decimalEnclosedCircleChinese",
    IDEOGRAPH_ENCLOSED_CIRCLE: "ideographEnclosedCircle",
    IDEOGRAPH_TRADITIONAL: "ideographTraditional",
    IDEOGRAPH_ZODIAC: "ideographZodiac",
    IDEOGRAPH_ZODIAC_TRADITIONAL: "ideographZodiacTraditional",
    TAIWANESE_COUNTING: "taiwaneseCounting",
    IDEOGRAPH_LEGAL_TRADITIONAL: "ideographLegalTraditional",
    TAIWANESE_COUNTING_THOUSAND: "taiwaneseCountingThousand",
    TAIWANESE_DIGITAL: "taiwaneseDigital",
    CHINESE_COUNTING: "chineseCounting",
    CHINESE_LEGAL_SIMPLIFIED: "chineseLegalSimplified",
    CHINESE_COUNTING_TEN_THOUSAND: "chineseCountingThousand",
    KOREAN_DIGITAL: "koreanDigital",
    KOREAN_COUNTING: "koreanCounting",
    KOREAN_LEGAL: "koreanLegal",
    KOREAN_DIGITAL_2: "koreanDigital2",
    VIETNAMESE_COUNTING: "vietnameseCounting",
    RUSSIAN_LOWER: "russianLower",
    RUSSIAN_UPPER: "russianUpper",
    NONE: "none",
    NUMBER_IN_DASH: "numberInDash",
    HEBREW_1: "hebrew1",
    HEBREW_2: "hebrew2",
    ARABIC_ALPHA: "arabicAlpha",
    ARABIC_ABJAD: "arabicAbjad",
    HINDI_VOWELS: "hindiVowels",
    HINDI_CONSONANTS: "hindiConsonants",
    HINDI_NUMBERS: "hindiNumbers",
    HINDI_COUNTING: "hindiCounting",
    THAI_LETTERS: "thaiLetters",
    THAI_NUMBERS: "thaiNumbers",
    THAI_COUNTING: "thaiCounting",
    BAHT_TEXT: "bahtText",
    DOLLAR_TEXT: "dollarText"
};
const $be59461d4a783f7b$export$bb538ef550ced38 = {
    DEFAULT: "default",
    PRESERVE: "preserve"
};
class $be59461d4a783f7b$var$TextAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            space: "xml:space"
        });
    }
}
class $be59461d4a783f7b$var$Page extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:instrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push("PAGE");
    }
}
class $be59461d4a783f7b$var$NumberOfPages extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:instrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push("NUMPAGES");
    }
}
class $be59461d4a783f7b$var$NumberOfPagesSection extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:instrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push("SECTIONPAGES");
    }
}
class $be59461d4a783f7b$var$CurrentSection extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:instrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push("SECTION");
    }
}
class $be59461d4a783f7b$var$ShadingAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            fill: "w:fill",
            color: "w:color",
            type: "w:val"
        });
    }
}
class $be59461d4a783f7b$export$21ac63597b3ebf8e extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ fill: fill, color: color, type: type2 }){
        super("w:shd");
        this.root.push(new $be59461d4a783f7b$var$ShadingAttributes({
            fill: fill === void 0 ? void 0 : $be59461d4a783f7b$export$39c9e6e42c794b97(fill),
            color: color === void 0 ? void 0 : $be59461d4a783f7b$export$39c9e6e42c794b97(color),
            type: type2
        }));
    }
}
const $be59461d4a783f7b$export$44d637c1ab7244fb = {
    CLEAR: "clear",
    DIAGONAL_CROSS: "diagCross",
    DIAGONAL_STRIPE: "diagStripe",
    HORIZONTAL_CROSS: "horzCross",
    HORIZONTAL_STRIPE: "horzStripe",
    NIL: "nil",
    PERCENT_5: "pct5",
    PERCENT_10: "pct10",
    PERCENT_12: "pct12",
    PERCENT_15: "pct15",
    PERCENT_20: "pct20",
    PERCENT_25: "pct25",
    PERCENT_30: "pct30",
    PERCENT_35: "pct35",
    PERCENT_37: "pct37",
    PERCENT_40: "pct40",
    PERCENT_45: "pct45",
    PERCENT_50: "pct50",
    PERCENT_55: "pct55",
    PERCENT_60: "pct60",
    PERCENT_62: "pct62",
    PERCENT_65: "pct65",
    PERCENT_70: "pct70",
    PERCENT_75: "pct75",
    PERCENT_80: "pct80",
    PERCENT_85: "pct85",
    PERCENT_87: "pct87",
    PERCENT_90: "pct90",
    PERCENT_95: "pct95",
    REVERSE_DIAGONAL_STRIPE: "reverseDiagStripe",
    SOLID: "solid",
    THIN_DIAGONAL_CROSS: "thinDiagCross",
    THIN_DIAGONAL_STRIPE: "thinDiagStripe",
    THIN_HORIZONTAL_CROSS: "thinHorzCross",
    THIN_REVERSE_DIAGONAL_STRIPE: "thinReverseDiagStripe",
    THIN_VERTICAL_STRIPE: "thinVertStripe",
    VERTICAL_STRIPE: "vertStripe"
};
class $be59461d4a783f7b$var$ChangeAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "w:id",
            author: "w:author",
            date: "w:date"
        });
    }
}
const $be59461d4a783f7b$export$bd85bf7ed3568df8 = {
    DOT: "dot"
};
class $be59461d4a783f7b$export$4346136c589de1a1 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(emphasisMarkType){
        super("w:em");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: emphasisMarkType
        }));
    }
}
class $be59461d4a783f7b$export$19e3176976994b01 extends $be59461d4a783f7b$export$4346136c589de1a1 {
    constructor(emphasisMarkType = $be59461d4a783f7b$export$bd85bf7ed3568df8.DOT){
        super(emphasisMarkType);
    }
}
class $be59461d4a783f7b$export$1a4a9e0df1cf2f7d extends $be59461d4a783f7b$export$4346136c589de1a1 {
    constructor(){
        super($be59461d4a783f7b$export$bd85bf7ed3568df8.DOT);
    }
}
class $be59461d4a783f7b$var$CharacterSpacing extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:spacing");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: $be59461d4a783f7b$export$866cabb7ed3455e9(value)
        }));
    }
}
class $be59461d4a783f7b$var$Color extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(color){
        super("w:color");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: $be59461d4a783f7b$export$39c9e6e42c794b97(color)
        }));
    }
}
class $be59461d4a783f7b$var$Highlight extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(color){
        super("w:highlight");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: color
        }));
    }
}
class $be59461d4a783f7b$var$HighlightComplexScript extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(color){
        super("w:highlightCs");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: color
        }));
    }
}
const $be59461d4a783f7b$var$createLanguageComponent = (options)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:lang",
        attributes: {
            value: {
                key: "w:val",
                value: options.value
            },
            eastAsia: {
                key: "w:eastAsia",
                value: options.eastAsia
            },
            bidirectional: {
                key: "w:bidi",
                value: options.bidirectional
            }
        }
    });
class $be59461d4a783f7b$var$RunFontAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            ascii: "w:ascii",
            cs: "w:cs",
            eastAsia: "w:eastAsia",
            hAnsi: "w:hAnsi",
            hint: "w:hint"
        });
    }
}
class $be59461d4a783f7b$export$b2daa015e8fb0d8d extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(nameOrAttrs, hint){
        super("w:rFonts");
        if (typeof nameOrAttrs === "string") {
            const name = nameOrAttrs;
            this.root.push(new $be59461d4a783f7b$var$RunFontAttributes({
                ascii: name,
                cs: name,
                eastAsia: name,
                hAnsi: name,
                hint: hint
            }));
        } else {
            const attrs = nameOrAttrs;
            this.root.push(new $be59461d4a783f7b$var$RunFontAttributes(attrs));
        }
    }
}
let $be59461d4a783f7b$var$VerticalAlign$1 = class VerticalAlign extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(type2){
        super("w:vertAlign");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: type2
        }));
    }
};
class $be59461d4a783f7b$var$SuperScript extends $be59461d4a783f7b$var$VerticalAlign$1 {
    constructor(){
        super("superscript");
    }
}
class $be59461d4a783f7b$var$SubScript extends $be59461d4a783f7b$var$VerticalAlign$1 {
    constructor(){
        super("subscript");
    }
}
const $be59461d4a783f7b$export$7d5cc92343d18d1b = {
    SINGLE: "single",
    WORDS: "words",
    DOUBLE: "double",
    THICK: "thick",
    DOTTED: "dotted",
    DOTTEDHEAVY: "dottedHeavy",
    DASH: "dash",
    DASHEDHEAVY: "dashedHeavy",
    DASHLONG: "dashLong",
    DASHLONGHEAVY: "dashLongHeavy",
    DOTDASH: "dotDash",
    DASHDOTHEAVY: "dashDotHeavy",
    DOTDOTDASH: "dotDotDash",
    DASHDOTDOTHEAVY: "dashDotDotHeavy",
    WAVE: "wave",
    WAVYHEAVY: "wavyHeavy",
    WAVYDOUBLE: "wavyDouble",
    NONE: "none"
};
class $be59461d4a783f7b$export$741ee5bff4f2bc22 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(underlineType = $be59461d4a783f7b$export$7d5cc92343d18d1b.SINGLE, color){
        super("w:u");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: underlineType,
            color: color === void 0 ? void 0 : $be59461d4a783f7b$export$39c9e6e42c794b97(color)
        }));
    }
}
const $be59461d4a783f7b$export$f71093cf721ae205 = {
    BLINK_BACKGROUND: "blinkBackground",
    LIGHTS: "lights",
    ANTS_BLACK: "antsBlack",
    ANTS_RED: "antsRed",
    SHIMMER: "shimmer",
    SPARKLE: "sparkle",
    NONE: "none"
};
const $be59461d4a783f7b$export$5a04965c26302ef6 = {
    BLACK: "black",
    BLUE: "blue",
    CYAN: "cyan",
    DARK_BLUE: "darkBlue",
    DARK_CYAN: "darkCyan",
    DARK_GRAY: "darkGray",
    DARK_GREEN: "darkGreen",
    DARK_MAGENTA: "darkMagenta",
    DARK_RED: "darkRed",
    DARK_YELLOW: "darkYellow",
    GREEN: "green",
    LIGHT_GRAY: "lightGray",
    MAGENTA: "magenta",
    NONE: "none",
    RED: "red",
    WHITE: "white",
    YELLOW: "yellow"
};
class $be59461d4a783f7b$export$5ae5540473946c91 extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(options){
        var _a, _b;
        super("w:rPr");
        if (!options) return;
        if (options.noProof !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:noProof", options.noProof));
        if (options.bold !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:b", options.bold));
        if (options.boldComplexScript === void 0 && options.bold !== void 0 || options.boldComplexScript) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:bCs", (_a = options.boldComplexScript) != null ? _a : options.bold));
        if (options.italics !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:i", options.italics));
        if (options.italicsComplexScript === void 0 && options.italics !== void 0 || options.italicsComplexScript) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:iCs", (_b = options.italicsComplexScript) != null ? _b : options.italics));
        if (options.underline) this.push(new $be59461d4a783f7b$export$741ee5bff4f2bc22(options.underline.type, options.underline.color));
        if (options.effect) this.push(new $be59461d4a783f7b$export$eacbde36aa74068("w:effect", options.effect));
        if (options.emphasisMark) this.push(new $be59461d4a783f7b$export$19e3176976994b01(options.emphasisMark.type));
        if (options.color) this.push(new $be59461d4a783f7b$var$Color(options.color));
        if (options.kern) this.push(new $be59461d4a783f7b$export$47eaf94bc2b4abbf("w:kern", options.kern));
        if (options.position) this.push(new $be59461d4a783f7b$export$eacbde36aa74068("w:position", options.position));
        if (options.size !== void 0) this.push(new $be59461d4a783f7b$export$47eaf94bc2b4abbf("w:sz", options.size));
        const szCs = options.sizeComplexScript === void 0 || options.sizeComplexScript === true ? options.size : options.sizeComplexScript;
        if (szCs) this.push(new $be59461d4a783f7b$export$47eaf94bc2b4abbf("w:szCs", szCs));
        if (options.rightToLeft !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:rtl", options.rightToLeft));
        if (options.smallCaps !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:smallCaps", options.smallCaps));
        else if (options.allCaps !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:caps", options.allCaps));
        if (options.strike !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:strike", options.strike));
        if (options.doubleStrike !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:dstrike", options.doubleStrike));
        if (options.subScript) this.push(new $be59461d4a783f7b$var$SubScript());
        if (options.superScript) this.push(new $be59461d4a783f7b$var$SuperScript());
        if (options.style) this.push(new $be59461d4a783f7b$export$eacbde36aa74068("w:rStyle", options.style));
        if (options.font) {
            if (typeof options.font === "string") this.push(new $be59461d4a783f7b$export$b2daa015e8fb0d8d(options.font));
            else if ("name" in options.font) this.push(new $be59461d4a783f7b$export$b2daa015e8fb0d8d(options.font.name, options.font.hint));
            else this.push(new $be59461d4a783f7b$export$b2daa015e8fb0d8d(options.font));
        }
        if (options.highlight) this.push(new $be59461d4a783f7b$var$Highlight(options.highlight));
        const highlightCs = options.highlightComplexScript === void 0 || options.highlightComplexScript === true ? options.highlight : options.highlightComplexScript;
        if (highlightCs) this.push(new $be59461d4a783f7b$var$HighlightComplexScript(highlightCs));
        if (options.characterSpacing) this.push(new $be59461d4a783f7b$var$CharacterSpacing(options.characterSpacing));
        if (options.emboss !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:emboss", options.emboss));
        if (options.imprint !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:imprint", options.imprint));
        if (options.shading) this.push(new $be59461d4a783f7b$export$21ac63597b3ebf8e(options.shading));
        if (options.revision) this.push(new $be59461d4a783f7b$export$d0aecc325b7ec545(options.revision));
        if (options.border) this.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:bdr", options.border));
        if (options.snapToGrid !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:snapToGrid", options.snapToGrid));
        if (options.vanish) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:vanish", options.vanish));
        if (options.specVanish) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:specVanish", options.vanish));
        if (options.scale !== void 0) this.push(new $be59461d4a783f7b$export$7c6d6f8dacf13e40("w:w", options.scale));
        if (options.language) this.push($be59461d4a783f7b$var$createLanguageComponent(options.language));
        if (options.math) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:oMath", options.math));
    }
    push(item) {
        this.root.push(item);
    }
}
class $be59461d4a783f7b$export$d0aecc325b7ec545 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:rPrChange");
        this.root.push(new $be59461d4a783f7b$var$ChangeAttributes({
            id: options.id,
            author: options.author,
            date: options.date
        }));
        this.addChildElement(new $be59461d4a783f7b$export$5ae5540473946c91(options));
    }
}
class $be59461d4a783f7b$var$Text extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        var _a;
        super("w:t");
        if (typeof options === "string") {
            this.root.push(new $be59461d4a783f7b$var$TextAttributes({
                space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
            }));
            this.root.push(options);
        } else {
            this.root.push(new $be59461d4a783f7b$var$TextAttributes({
                space: (_a = options.space) != null ? _a : $be59461d4a783f7b$export$bb538ef550ced38.DEFAULT
            }));
            this.root.push(options.text);
        }
    }
}
const $be59461d4a783f7b$export$9d30b4f7b635f195 = {
    CURRENT: "CURRENT",
    TOTAL_PAGES: "TOTAL_PAGES",
    TOTAL_PAGES_IN_SECTION: "TOTAL_PAGES_IN_SECTION",
    CURRENT_SECTION: "SECTION"
};
class $be59461d4a783f7b$export$ddae37e51c7979e2 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:r");
        $be59461d4a783f7b$var$__publicField(this, "properties");
        this.properties = new $be59461d4a783f7b$export$5ae5540473946c91(options);
        this.root.push(this.properties);
        if (options.break) for(let i = 0; i < options.break; i++)this.root.push(new $be59461d4a783f7b$var$Break$1());
        if (options.children) for (const child of options.children){
            if (typeof child === "string") {
                switch(child){
                    case $be59461d4a783f7b$export$9d30b4f7b635f195.CURRENT:
                        this.root.push(new $be59461d4a783f7b$var$Begin());
                        this.root.push(new $be59461d4a783f7b$var$Page());
                        this.root.push(new $be59461d4a783f7b$var$Separate());
                        this.root.push(new $be59461d4a783f7b$var$End());
                        break;
                    case $be59461d4a783f7b$export$9d30b4f7b635f195.TOTAL_PAGES:
                        this.root.push(new $be59461d4a783f7b$var$Begin());
                        this.root.push(new $be59461d4a783f7b$var$NumberOfPages());
                        this.root.push(new $be59461d4a783f7b$var$Separate());
                        this.root.push(new $be59461d4a783f7b$var$End());
                        break;
                    case $be59461d4a783f7b$export$9d30b4f7b635f195.TOTAL_PAGES_IN_SECTION:
                        this.root.push(new $be59461d4a783f7b$var$Begin());
                        this.root.push(new $be59461d4a783f7b$var$NumberOfPagesSection());
                        this.root.push(new $be59461d4a783f7b$var$Separate());
                        this.root.push(new $be59461d4a783f7b$var$End());
                        break;
                    case $be59461d4a783f7b$export$9d30b4f7b635f195.CURRENT_SECTION:
                        this.root.push(new $be59461d4a783f7b$var$Begin());
                        this.root.push(new $be59461d4a783f7b$var$CurrentSection());
                        this.root.push(new $be59461d4a783f7b$var$Separate());
                        this.root.push(new $be59461d4a783f7b$var$End());
                        break;
                    default:
                        this.root.push(new $be59461d4a783f7b$var$Text(child));
                        break;
                }
                continue;
            }
            this.root.push(child);
        }
        else if (options.text !== void 0) this.root.push(new $be59461d4a783f7b$var$Text(options.text));
    }
}
class $be59461d4a783f7b$export$84d920a4f7ee9ae2 extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(options){
        super(typeof options === "string" ? {
            text: options
        } : options);
    }
}
class $be59461d4a783f7b$var$SymbolAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            char: "w:char",
            symbolfont: "w:font"
        });
    }
}
let $be59461d4a783f7b$var$Symbol$1 = class Symbol2 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(char = "", symbolfont = "Wingdings"){
        super("w:sym");
        this.root.push(new $be59461d4a783f7b$var$SymbolAttributes({
            char: char,
            symbolfont: symbolfont
        }));
    }
};
class $be59461d4a783f7b$export$2d254945a19d4f19 extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(options){
        if (typeof options === "string") {
            super({});
            this.root.push(new $be59461d4a783f7b$var$Symbol$1(options));
            return this;
        }
        super(options);
        this.root.push(new $be59461d4a783f7b$var$Symbol$1(options.char, options.symbolfont));
    }
}
var $be59461d4a783f7b$var$hash$1 = {};
var $be59461d4a783f7b$var$utils = {};
var $be59461d4a783f7b$var$minimalisticAssert;
var $be59461d4a783f7b$var$hasRequiredMinimalisticAssert;
function $be59461d4a783f7b$var$requireMinimalisticAssert() {
    if ($be59461d4a783f7b$var$hasRequiredMinimalisticAssert) return $be59461d4a783f7b$var$minimalisticAssert;
    $be59461d4a783f7b$var$hasRequiredMinimalisticAssert = 1;
    $be59461d4a783f7b$var$minimalisticAssert = assert;
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    assert.equal = function assertEqual(l, r, msg) {
        if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
    };
    return $be59461d4a783f7b$var$minimalisticAssert;
}
var $be59461d4a783f7b$var$hasRequiredUtils;
function $be59461d4a783f7b$var$requireUtils() {
    if ($be59461d4a783f7b$var$hasRequiredUtils) return $be59461d4a783f7b$var$utils;
    $be59461d4a783f7b$var$hasRequiredUtils = 1;
    var assert = $be59461d4a783f7b$var$requireMinimalisticAssert();
    var inherits = $be59461d4a783f7b$var$requireInherits_browser();
    $be59461d4a783f7b$var$utils.inherits = inherits;
    function isSurrogatePair(msg, i) {
        if ((msg.charCodeAt(i) & 64512) !== 55296) return false;
        if (i < 0 || i + 1 >= msg.length) return false;
        return (msg.charCodeAt(i + 1) & 64512) === 56320;
    }
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg === "string") {
            if (!enc) {
                var p = 0;
                for(var i = 0; i < msg.length; i++){
                    var c = msg.charCodeAt(i);
                    if (c < 128) res[p++] = c;
                    else if (c < 2048) {
                        res[p++] = c >> 6 | 192;
                        res[p++] = c & 63 | 128;
                    } else if (isSurrogatePair(msg, i)) {
                        c = 65536 + ((c & 1023) << 10) + (msg.charCodeAt(++i) & 1023);
                        res[p++] = c >> 18 | 240;
                        res[p++] = c >> 12 & 63 | 128;
                        res[p++] = c >> 6 & 63 | 128;
                        res[p++] = c & 63 | 128;
                    } else {
                        res[p++] = c >> 12 | 224;
                        res[p++] = c >> 6 & 63 | 128;
                        res[p++] = c & 63 | 128;
                    }
                }
            } else if (enc === "hex") {
                msg = msg.replace(/[^a-z0-9]+/ig, "");
                if (msg.length % 2 !== 0) msg = "0" + msg;
                for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
            }
        } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    $be59461d4a783f7b$var$utils.toArray = toArray;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    $be59461d4a783f7b$var$utils.toHex = toHex;
    function htonl(w) {
        var res = w >>> 24 | w >>> 8 & 65280 | w << 8 & 16711680 | (w & 255) << 24;
        return res >>> 0;
    }
    $be59461d4a783f7b$var$utils.htonl = htonl;
    function toHex32(msg, endian) {
        var res = "";
        for(var i = 0; i < msg.length; i++){
            var w = msg[i];
            if (endian === "little") w = htonl(w);
            res += zero8(w.toString(16));
        }
        return res;
    }
    $be59461d4a783f7b$var$utils.toHex32 = toHex32;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    $be59461d4a783f7b$var$utils.zero2 = zero2;
    function zero8(word) {
        if (word.length === 7) return "0" + word;
        else if (word.length === 6) return "00" + word;
        else if (word.length === 5) return "000" + word;
        else if (word.length === 4) return "0000" + word;
        else if (word.length === 3) return "00000" + word;
        else if (word.length === 2) return "000000" + word;
        else if (word.length === 1) return "0000000" + word;
        else return word;
    }
    $be59461d4a783f7b$var$utils.zero8 = zero8;
    function join32(msg, start, end, endian) {
        var len = end - start;
        assert(len % 4 === 0);
        var res = new Array(len / 4);
        for(var i = 0, k = start; i < res.length; i++, k += 4){
            var w;
            if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
            else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
            res[i] = w >>> 0;
        }
        return res;
    }
    $be59461d4a783f7b$var$utils.join32 = join32;
    function split32(msg, endian) {
        var res = new Array(msg.length * 4);
        for(var i = 0, k = 0; i < msg.length; i++, k += 4){
            var m = msg[i];
            if (endian === "big") {
                res[k] = m >>> 24;
                res[k + 1] = m >>> 16 & 255;
                res[k + 2] = m >>> 8 & 255;
                res[k + 3] = m & 255;
            } else {
                res[k + 3] = m >>> 24;
                res[k + 2] = m >>> 16 & 255;
                res[k + 1] = m >>> 8 & 255;
                res[k] = m & 255;
            }
        }
        return res;
    }
    $be59461d4a783f7b$var$utils.split32 = split32;
    function rotr32(w, b) {
        return w >>> b | w << 32 - b;
    }
    $be59461d4a783f7b$var$utils.rotr32 = rotr32;
    function rotl32(w, b) {
        return w << b | w >>> 32 - b;
    }
    $be59461d4a783f7b$var$utils.rotl32 = rotl32;
    function sum32(a, b) {
        return a + b >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum32 = sum32;
    function sum32_3(a, b, c) {
        return a + b + c >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum32_3 = sum32_3;
    function sum32_4(a, b, c, d) {
        return a + b + c + d >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum32_4 = sum32_4;
    function sum32_5(a, b, c, d, e) {
        return a + b + c + d + e >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum32_5 = sum32_5;
    function sum64(buf, pos, ah, al) {
        var bh = buf[pos];
        var bl = buf[pos + 1];
        var lo = al + bl >>> 0;
        var hi = (lo < al ? 1 : 0) + ah + bh;
        buf[pos] = hi >>> 0;
        buf[pos + 1] = lo;
    }
    $be59461d4a783f7b$var$utils.sum64 = sum64;
    function sum64_hi(ah, al, bh, bl) {
        var lo = al + bl >>> 0;
        var hi = (lo < al ? 1 : 0) + ah + bh;
        return hi >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum64_hi = sum64_hi;
    function sum64_lo(ah, al, bh, bl) {
        var lo = al + bl;
        return lo >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum64_lo = sum64_lo;
    function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
        var carry = 0;
        var lo = al;
        lo = lo + bl >>> 0;
        carry += lo < al ? 1 : 0;
        lo = lo + cl >>> 0;
        carry += lo < cl ? 1 : 0;
        lo = lo + dl >>> 0;
        carry += lo < dl ? 1 : 0;
        var hi = ah + bh + ch + dh + carry;
        return hi >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum64_4_hi = sum64_4_hi;
    function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
        var lo = al + bl + cl + dl;
        return lo >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum64_4_lo = sum64_4_lo;
    function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
        var carry = 0;
        var lo = al;
        lo = lo + bl >>> 0;
        carry += lo < al ? 1 : 0;
        lo = lo + cl >>> 0;
        carry += lo < cl ? 1 : 0;
        lo = lo + dl >>> 0;
        carry += lo < dl ? 1 : 0;
        lo = lo + el >>> 0;
        carry += lo < el ? 1 : 0;
        var hi = ah + bh + ch + dh + eh + carry;
        return hi >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum64_5_hi = sum64_5_hi;
    function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
        var lo = al + bl + cl + dl + el;
        return lo >>> 0;
    }
    $be59461d4a783f7b$var$utils.sum64_5_lo = sum64_5_lo;
    function rotr64_hi(ah, al, num) {
        var r = al << 32 - num | ah >>> num;
        return r >>> 0;
    }
    $be59461d4a783f7b$var$utils.rotr64_hi = rotr64_hi;
    function rotr64_lo(ah, al, num) {
        var r = ah << 32 - num | al >>> num;
        return r >>> 0;
    }
    $be59461d4a783f7b$var$utils.rotr64_lo = rotr64_lo;
    function shr64_hi(ah, al, num) {
        return ah >>> num;
    }
    $be59461d4a783f7b$var$utils.shr64_hi = shr64_hi;
    function shr64_lo(ah, al, num) {
        var r = ah << 32 - num | al >>> num;
        return r >>> 0;
    }
    $be59461d4a783f7b$var$utils.shr64_lo = shr64_lo;
    return $be59461d4a783f7b$var$utils;
}
var $be59461d4a783f7b$var$common$1 = {};
var $be59461d4a783f7b$var$hasRequiredCommon$1;
function $be59461d4a783f7b$var$requireCommon$1() {
    if ($be59461d4a783f7b$var$hasRequiredCommon$1) return $be59461d4a783f7b$var$common$1;
    $be59461d4a783f7b$var$hasRequiredCommon$1 = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var assert = $be59461d4a783f7b$var$requireMinimalisticAssert();
    function BlockHash() {
        this.pending = null;
        this.pendingTotal = 0;
        this.blockSize = this.constructor.blockSize;
        this.outSize = this.constructor.outSize;
        this.hmacStrength = this.constructor.hmacStrength;
        this.padLength = this.constructor.padLength / 8;
        this.endian = "big";
        this._delta8 = this.blockSize / 8;
        this._delta32 = this.blockSize / 32;
    }
    $be59461d4a783f7b$var$common$1.BlockHash = BlockHash;
    BlockHash.prototype.update = function update(msg, enc) {
        msg = utils2.toArray(msg, enc);
        if (!this.pending) this.pending = msg;
        else this.pending = this.pending.concat(msg);
        this.pendingTotal += msg.length;
        if (this.pending.length >= this._delta8) {
            msg = this.pending;
            var r = msg.length % this._delta8;
            this.pending = msg.slice(msg.length - r, msg.length);
            if (this.pending.length === 0) this.pending = null;
            msg = utils2.join32(msg, 0, msg.length - r, this.endian);
            for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
        }
        return this;
    };
    BlockHash.prototype.digest = function digest(enc) {
        this.update(this._pad());
        assert(this.pending === null);
        return this._digest(enc);
    };
    BlockHash.prototype._pad = function pad() {
        var len = this.pendingTotal;
        var bytes = this._delta8;
        var k = bytes - (len + this.padLength) % bytes;
        var res = new Array(k + this.padLength);
        res[0] = 128;
        for(var i = 1; i < k; i++)res[i] = 0;
        len <<= 3;
        if (this.endian === "big") {
            for(var t = 8; t < this.padLength; t++)res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = len >>> 24 & 255;
            res[i++] = len >>> 16 & 255;
            res[i++] = len >>> 8 & 255;
            res[i++] = len & 255;
        } else {
            res[i++] = len & 255;
            res[i++] = len >>> 8 & 255;
            res[i++] = len >>> 16 & 255;
            res[i++] = len >>> 24 & 255;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            for(t = 8; t < this.padLength; t++)res[i++] = 0;
        }
        return res;
    };
    return $be59461d4a783f7b$var$common$1;
}
var $be59461d4a783f7b$var$sha = {};
var $be59461d4a783f7b$var$common = {};
var $be59461d4a783f7b$var$hasRequiredCommon;
function $be59461d4a783f7b$var$requireCommon() {
    if ($be59461d4a783f7b$var$hasRequiredCommon) return $be59461d4a783f7b$var$common;
    $be59461d4a783f7b$var$hasRequiredCommon = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var rotr32 = utils2.rotr32;
    function ft_1(s, x, y, z) {
        if (s === 0) return ch32(x, y, z);
        if (s === 1 || s === 3) return p32(x, y, z);
        if (s === 2) return maj32(x, y, z);
    }
    $be59461d4a783f7b$var$common.ft_1 = ft_1;
    function ch32(x, y, z) {
        return x & y ^ ~x & z;
    }
    $be59461d4a783f7b$var$common.ch32 = ch32;
    function maj32(x, y, z) {
        return x & y ^ x & z ^ y & z;
    }
    $be59461d4a783f7b$var$common.maj32 = maj32;
    function p32(x, y, z) {
        return x ^ y ^ z;
    }
    $be59461d4a783f7b$var$common.p32 = p32;
    function s0_256(x) {
        return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
    }
    $be59461d4a783f7b$var$common.s0_256 = s0_256;
    function s1_256(x) {
        return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
    }
    $be59461d4a783f7b$var$common.s1_256 = s1_256;
    function g0_256(x) {
        return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
    }
    $be59461d4a783f7b$var$common.g0_256 = g0_256;
    function g1_256(x) {
        return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
    }
    $be59461d4a783f7b$var$common.g1_256 = g1_256;
    return $be59461d4a783f7b$var$common;
}
var $be59461d4a783f7b$var$_1;
var $be59461d4a783f7b$var$hasRequired_1;
function $be59461d4a783f7b$var$require_1() {
    if ($be59461d4a783f7b$var$hasRequired_1) return $be59461d4a783f7b$var$_1;
    $be59461d4a783f7b$var$hasRequired_1 = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var common2 = $be59461d4a783f7b$var$requireCommon$1();
    var shaCommon = $be59461d4a783f7b$var$requireCommon();
    var rotl32 = utils2.rotl32;
    var sum32 = utils2.sum32;
    var sum32_5 = utils2.sum32_5;
    var ft_1 = shaCommon.ft_1;
    var BlockHash = common2.BlockHash;
    var sha1_K = [
        1518500249,
        1859775393,
        2400959708,
        3395469782
    ];
    function SHA1() {
        if (!(this instanceof SHA1)) return new SHA1();
        BlockHash.call(this);
        this.h = [
            1732584193,
            4023233417,
            2562383102,
            271733878,
            3285377520
        ];
        this.W = new Array(80);
    }
    utils2.inherits(SHA1, BlockHash);
    $be59461d4a783f7b$var$_1 = SHA1;
    SHA1.blockSize = 512;
    SHA1.outSize = 160;
    SHA1.hmacStrength = 80;
    SHA1.padLength = 64;
    SHA1.prototype._update = function _update(msg, start) {
        var W = this.W;
        for(var i = 0; i < 16; i++)W[i] = msg[start + i];
        for(; i < W.length; i++)W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        var a = this.h[0];
        var b = this.h[1];
        var c = this.h[2];
        var d = this.h[3];
        var e = this.h[4];
        for(i = 0; i < W.length; i++){
            var s = ~~(i / 20);
            var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
            e = d;
            d = c;
            c = rotl32(b, 30);
            b = a;
            a = t;
        }
        this.h[0] = sum32(this.h[0], a);
        this.h[1] = sum32(this.h[1], b);
        this.h[2] = sum32(this.h[2], c);
        this.h[3] = sum32(this.h[3], d);
        this.h[4] = sum32(this.h[4], e);
    };
    SHA1.prototype._digest = function digest(enc) {
        if (enc === "hex") return utils2.toHex32(this.h, "big");
        else return utils2.split32(this.h, "big");
    };
    return $be59461d4a783f7b$var$_1;
}
var $be59461d4a783f7b$var$_256;
var $be59461d4a783f7b$var$hasRequired_256;
function $be59461d4a783f7b$var$require_256() {
    if ($be59461d4a783f7b$var$hasRequired_256) return $be59461d4a783f7b$var$_256;
    $be59461d4a783f7b$var$hasRequired_256 = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var common2 = $be59461d4a783f7b$var$requireCommon$1();
    var shaCommon = $be59461d4a783f7b$var$requireCommon();
    var assert = $be59461d4a783f7b$var$requireMinimalisticAssert();
    var sum32 = utils2.sum32;
    var sum32_4 = utils2.sum32_4;
    var sum32_5 = utils2.sum32_5;
    var ch32 = shaCommon.ch32;
    var maj32 = shaCommon.maj32;
    var s0_256 = shaCommon.s0_256;
    var s1_256 = shaCommon.s1_256;
    var g0_256 = shaCommon.g0_256;
    var g1_256 = shaCommon.g1_256;
    var BlockHash = common2.BlockHash;
    var sha256_K = [
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
    ];
    function SHA256() {
        if (!(this instanceof SHA256)) return new SHA256();
        BlockHash.call(this);
        this.h = [
            1779033703,
            3144134277,
            1013904242,
            2773480762,
            1359893119,
            2600822924,
            528734635,
            1541459225
        ];
        this.k = sha256_K;
        this.W = new Array(64);
    }
    utils2.inherits(SHA256, BlockHash);
    $be59461d4a783f7b$var$_256 = SHA256;
    SHA256.blockSize = 512;
    SHA256.outSize = 256;
    SHA256.hmacStrength = 192;
    SHA256.padLength = 64;
    SHA256.prototype._update = function _update(msg, start) {
        var W = this.W;
        for(var i = 0; i < 16; i++)W[i] = msg[start + i];
        for(; i < W.length; i++)W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
        var a = this.h[0];
        var b = this.h[1];
        var c = this.h[2];
        var d = this.h[3];
        var e = this.h[4];
        var f = this.h[5];
        var g = this.h[6];
        var h = this.h[7];
        assert(this.k.length === W.length);
        for(i = 0; i < W.length; i++){
            var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
            var T2 = sum32(s0_256(a), maj32(a, b, c));
            h = g;
            g = f;
            f = e;
            e = sum32(d, T1);
            d = c;
            c = b;
            b = a;
            a = sum32(T1, T2);
        }
        this.h[0] = sum32(this.h[0], a);
        this.h[1] = sum32(this.h[1], b);
        this.h[2] = sum32(this.h[2], c);
        this.h[3] = sum32(this.h[3], d);
        this.h[4] = sum32(this.h[4], e);
        this.h[5] = sum32(this.h[5], f);
        this.h[6] = sum32(this.h[6], g);
        this.h[7] = sum32(this.h[7], h);
    };
    SHA256.prototype._digest = function digest(enc) {
        if (enc === "hex") return utils2.toHex32(this.h, "big");
        else return utils2.split32(this.h, "big");
    };
    return $be59461d4a783f7b$var$_256;
}
var $be59461d4a783f7b$var$_224;
var $be59461d4a783f7b$var$hasRequired_224;
function $be59461d4a783f7b$var$require_224() {
    if ($be59461d4a783f7b$var$hasRequired_224) return $be59461d4a783f7b$var$_224;
    $be59461d4a783f7b$var$hasRequired_224 = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var SHA256 = $be59461d4a783f7b$var$require_256();
    function SHA224() {
        if (!(this instanceof SHA224)) return new SHA224();
        SHA256.call(this);
        this.h = [
            3238371032,
            914150663,
            812702999,
            4144912697,
            4290775857,
            1750603025,
            1694076839,
            3204075428
        ];
    }
    utils2.inherits(SHA224, SHA256);
    $be59461d4a783f7b$var$_224 = SHA224;
    SHA224.blockSize = 512;
    SHA224.outSize = 224;
    SHA224.hmacStrength = 192;
    SHA224.padLength = 64;
    SHA224.prototype._digest = function digest(enc) {
        if (enc === "hex") return utils2.toHex32(this.h.slice(0, 7), "big");
        else return utils2.split32(this.h.slice(0, 7), "big");
    };
    return $be59461d4a783f7b$var$_224;
}
var $be59461d4a783f7b$var$_512;
var $be59461d4a783f7b$var$hasRequired_512;
function $be59461d4a783f7b$var$require_512() {
    if ($be59461d4a783f7b$var$hasRequired_512) return $be59461d4a783f7b$var$_512;
    $be59461d4a783f7b$var$hasRequired_512 = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var common2 = $be59461d4a783f7b$var$requireCommon$1();
    var assert = $be59461d4a783f7b$var$requireMinimalisticAssert();
    var rotr64_hi = utils2.rotr64_hi;
    var rotr64_lo = utils2.rotr64_lo;
    var shr64_hi = utils2.shr64_hi;
    var shr64_lo = utils2.shr64_lo;
    var sum64 = utils2.sum64;
    var sum64_hi = utils2.sum64_hi;
    var sum64_lo = utils2.sum64_lo;
    var sum64_4_hi = utils2.sum64_4_hi;
    var sum64_4_lo = utils2.sum64_4_lo;
    var sum64_5_hi = utils2.sum64_5_hi;
    var sum64_5_lo = utils2.sum64_5_lo;
    var BlockHash = common2.BlockHash;
    var sha512_K = [
        1116352408,
        3609767458,
        1899447441,
        602891725,
        3049323471,
        3964484399,
        3921009573,
        2173295548,
        961987163,
        4081628472,
        1508970993,
        3053834265,
        2453635748,
        2937671579,
        2870763221,
        3664609560,
        3624381080,
        2734883394,
        310598401,
        1164996542,
        607225278,
        1323610764,
        1426881987,
        3590304994,
        1925078388,
        4068182383,
        2162078206,
        991336113,
        2614888103,
        633803317,
        3248222580,
        3479774868,
        3835390401,
        2666613458,
        4022224774,
        944711139,
        264347078,
        2341262773,
        604807628,
        2007800933,
        770255983,
        1495990901,
        1249150122,
        1856431235,
        1555081692,
        3175218132,
        1996064986,
        2198950837,
        2554220882,
        3999719339,
        2821834349,
        766784016,
        2952996808,
        2566594879,
        3210313671,
        3203337956,
        3336571891,
        1034457026,
        3584528711,
        2466948901,
        113926993,
        3758326383,
        338241895,
        168717936,
        666307205,
        1188179964,
        773529912,
        1546045734,
        1294757372,
        1522805485,
        1396182291,
        2643833823,
        1695183700,
        2343527390,
        1986661051,
        1014477480,
        2177026350,
        1206759142,
        2456956037,
        344077627,
        2730485921,
        1290863460,
        2820302411,
        3158454273,
        3259730800,
        3505952657,
        3345764771,
        106217008,
        3516065817,
        3606008344,
        3600352804,
        1432725776,
        4094571909,
        1467031594,
        275423344,
        851169720,
        430227734,
        3100823752,
        506948616,
        1363258195,
        659060556,
        3750685593,
        883997877,
        3785050280,
        958139571,
        3318307427,
        1322822218,
        3812723403,
        1537002063,
        2003034995,
        1747873779,
        3602036899,
        1955562222,
        1575990012,
        2024104815,
        1125592928,
        2227730452,
        2716904306,
        2361852424,
        442776044,
        2428436474,
        593698344,
        2756734187,
        3733110249,
        3204031479,
        2999351573,
        3329325298,
        3815920427,
        3391569614,
        3928383900,
        3515267271,
        566280711,
        3940187606,
        3454069534,
        4118630271,
        4000239992,
        116418474,
        1914138554,
        174292421,
        2731055270,
        289380356,
        3203993006,
        460393269,
        320620315,
        685471733,
        587496836,
        852142971,
        1086792851,
        1017036298,
        365543100,
        1126000580,
        2618297676,
        1288033470,
        3409855158,
        1501505948,
        4234509866,
        1607167915,
        987167468,
        1816402316,
        1246189591
    ];
    function SHA512() {
        if (!(this instanceof SHA512)) return new SHA512();
        BlockHash.call(this);
        this.h = [
            1779033703,
            4089235720,
            3144134277,
            2227873595,
            1013904242,
            4271175723,
            2773480762,
            1595750129,
            1359893119,
            2917565137,
            2600822924,
            725511199,
            528734635,
            4215389547,
            1541459225,
            327033209
        ];
        this.k = sha512_K;
        this.W = new Array(160);
    }
    utils2.inherits(SHA512, BlockHash);
    $be59461d4a783f7b$var$_512 = SHA512;
    SHA512.blockSize = 1024;
    SHA512.outSize = 512;
    SHA512.hmacStrength = 192;
    SHA512.padLength = 128;
    SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
        var W = this.W;
        for(var i = 0; i < 32; i++)W[i] = msg[start + i];
        for(; i < W.length; i += 2){
            var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);
            var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
            var c1_hi = W[i - 14];
            var c1_lo = W[i - 13];
            var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);
            var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
            var c3_hi = W[i - 32];
            var c3_lo = W[i - 31];
            W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
            W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        }
    };
    SHA512.prototype._update = function _update(msg, start) {
        this._prepareBlock(msg, start);
        var W = this.W;
        var ah = this.h[0];
        var al = this.h[1];
        var bh = this.h[2];
        var bl = this.h[3];
        var ch = this.h[4];
        var cl = this.h[5];
        var dh = this.h[6];
        var dl = this.h[7];
        var eh = this.h[8];
        var el = this.h[9];
        var fh = this.h[10];
        var fl = this.h[11];
        var gh = this.h[12];
        var gl = this.h[13];
        var hh = this.h[14];
        var hl = this.h[15];
        assert(this.k.length === W.length);
        for(var i = 0; i < W.length; i += 2){
            var c0_hi = hh;
            var c0_lo = hl;
            var c1_hi = s1_512_hi(eh, el);
            var c1_lo = s1_512_lo(eh, el);
            var c2_hi = ch64_hi(eh, el, fh, fl, gh);
            var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
            var c3_hi = this.k[i];
            var c3_lo = this.k[i + 1];
            var c4_hi = W[i];
            var c4_lo = W[i + 1];
            var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
            var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
            c0_hi = s0_512_hi(ah, al);
            c0_lo = s0_512_lo(ah, al);
            c1_hi = maj64_hi(ah, al, bh, bl, ch);
            c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
            var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
            var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
            hh = gh;
            hl = gl;
            gh = fh;
            gl = fl;
            fh = eh;
            fl = el;
            eh = sum64_hi(dh, dl, T1_hi, T1_lo);
            el = sum64_lo(dl, dl, T1_hi, T1_lo);
            dh = ch;
            dl = cl;
            ch = bh;
            cl = bl;
            bh = ah;
            bl = al;
            ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
            al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
        }
        sum64(this.h, 0, ah, al);
        sum64(this.h, 2, bh, bl);
        sum64(this.h, 4, ch, cl);
        sum64(this.h, 6, dh, dl);
        sum64(this.h, 8, eh, el);
        sum64(this.h, 10, fh, fl);
        sum64(this.h, 12, gh, gl);
        sum64(this.h, 14, hh, hl);
    };
    SHA512.prototype._digest = function digest(enc) {
        if (enc === "hex") return utils2.toHex32(this.h, "big");
        else return utils2.split32(this.h, "big");
    };
    function ch64_hi(xh, xl, yh, yl, zh) {
        var r = xh & yh ^ ~xh & zh;
        if (r < 0) r += 4294967296;
        return r;
    }
    function ch64_lo(xh, xl, yh, yl, zh, zl) {
        var r = xl & yl ^ ~xl & zl;
        if (r < 0) r += 4294967296;
        return r;
    }
    function maj64_hi(xh, xl, yh, yl, zh) {
        var r = xh & yh ^ xh & zh ^ yh & zh;
        if (r < 0) r += 4294967296;
        return r;
    }
    function maj64_lo(xh, xl, yh, yl, zh, zl) {
        var r = xl & yl ^ xl & zl ^ yl & zl;
        if (r < 0) r += 4294967296;
        return r;
    }
    function s0_512_hi(xh, xl) {
        var c0_hi = rotr64_hi(xh, xl, 28);
        var c1_hi = rotr64_hi(xl, xh, 2);
        var c2_hi = rotr64_hi(xl, xh, 7);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 4294967296;
        return r;
    }
    function s0_512_lo(xh, xl) {
        var c0_lo = rotr64_lo(xh, xl, 28);
        var c1_lo = rotr64_lo(xl, xh, 2);
        var c2_lo = rotr64_lo(xl, xh, 7);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 4294967296;
        return r;
    }
    function s1_512_hi(xh, xl) {
        var c0_hi = rotr64_hi(xh, xl, 14);
        var c1_hi = rotr64_hi(xh, xl, 18);
        var c2_hi = rotr64_hi(xl, xh, 9);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 4294967296;
        return r;
    }
    function s1_512_lo(xh, xl) {
        var c0_lo = rotr64_lo(xh, xl, 14);
        var c1_lo = rotr64_lo(xh, xl, 18);
        var c2_lo = rotr64_lo(xl, xh, 9);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 4294967296;
        return r;
    }
    function g0_512_hi(xh, xl) {
        var c0_hi = rotr64_hi(xh, xl, 1);
        var c1_hi = rotr64_hi(xh, xl, 8);
        var c2_hi = shr64_hi(xh, xl, 7);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 4294967296;
        return r;
    }
    function g0_512_lo(xh, xl) {
        var c0_lo = rotr64_lo(xh, xl, 1);
        var c1_lo = rotr64_lo(xh, xl, 8);
        var c2_lo = shr64_lo(xh, xl, 7);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 4294967296;
        return r;
    }
    function g1_512_hi(xh, xl) {
        var c0_hi = rotr64_hi(xh, xl, 19);
        var c1_hi = rotr64_hi(xl, xh, 29);
        var c2_hi = shr64_hi(xh, xl, 6);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 4294967296;
        return r;
    }
    function g1_512_lo(xh, xl) {
        var c0_lo = rotr64_lo(xh, xl, 19);
        var c1_lo = rotr64_lo(xl, xh, 29);
        var c2_lo = shr64_lo(xh, xl, 6);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 4294967296;
        return r;
    }
    return $be59461d4a783f7b$var$_512;
}
var $be59461d4a783f7b$var$_384;
var $be59461d4a783f7b$var$hasRequired_384;
function $be59461d4a783f7b$var$require_384() {
    if ($be59461d4a783f7b$var$hasRequired_384) return $be59461d4a783f7b$var$_384;
    $be59461d4a783f7b$var$hasRequired_384 = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var SHA512 = $be59461d4a783f7b$var$require_512();
    function SHA384() {
        if (!(this instanceof SHA384)) return new SHA384();
        SHA512.call(this);
        this.h = [
            3418070365,
            3238371032,
            1654270250,
            914150663,
            2438529370,
            812702999,
            355462360,
            4144912697,
            1731405415,
            4290775857,
            2394180231,
            1750603025,
            3675008525,
            1694076839,
            1203062813,
            3204075428
        ];
    }
    utils2.inherits(SHA384, SHA512);
    $be59461d4a783f7b$var$_384 = SHA384;
    SHA384.blockSize = 1024;
    SHA384.outSize = 384;
    SHA384.hmacStrength = 192;
    SHA384.padLength = 128;
    SHA384.prototype._digest = function digest(enc) {
        if (enc === "hex") return utils2.toHex32(this.h.slice(0, 12), "big");
        else return utils2.split32(this.h.slice(0, 12), "big");
    };
    return $be59461d4a783f7b$var$_384;
}
var $be59461d4a783f7b$var$hasRequiredSha;
function $be59461d4a783f7b$var$requireSha() {
    if ($be59461d4a783f7b$var$hasRequiredSha) return $be59461d4a783f7b$var$sha;
    $be59461d4a783f7b$var$hasRequiredSha = 1;
    $be59461d4a783f7b$var$sha.sha1 = $be59461d4a783f7b$var$require_1();
    $be59461d4a783f7b$var$sha.sha224 = $be59461d4a783f7b$var$require_224();
    $be59461d4a783f7b$var$sha.sha256 = $be59461d4a783f7b$var$require_256();
    $be59461d4a783f7b$var$sha.sha384 = $be59461d4a783f7b$var$require_384();
    $be59461d4a783f7b$var$sha.sha512 = $be59461d4a783f7b$var$require_512();
    return $be59461d4a783f7b$var$sha;
}
var $be59461d4a783f7b$var$ripemd = {};
var $be59461d4a783f7b$var$hasRequiredRipemd;
function $be59461d4a783f7b$var$requireRipemd() {
    if ($be59461d4a783f7b$var$hasRequiredRipemd) return $be59461d4a783f7b$var$ripemd;
    $be59461d4a783f7b$var$hasRequiredRipemd = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var common2 = $be59461d4a783f7b$var$requireCommon$1();
    var rotl32 = utils2.rotl32;
    var sum32 = utils2.sum32;
    var sum32_3 = utils2.sum32_3;
    var sum32_4 = utils2.sum32_4;
    var BlockHash = common2.BlockHash;
    function RIPEMD160() {
        if (!(this instanceof RIPEMD160)) return new RIPEMD160();
        BlockHash.call(this);
        this.h = [
            1732584193,
            4023233417,
            2562383102,
            271733878,
            3285377520
        ];
        this.endian = "little";
    }
    utils2.inherits(RIPEMD160, BlockHash);
    $be59461d4a783f7b$var$ripemd.ripemd160 = RIPEMD160;
    RIPEMD160.blockSize = 512;
    RIPEMD160.outSize = 160;
    RIPEMD160.hmacStrength = 192;
    RIPEMD160.padLength = 64;
    RIPEMD160.prototype._update = function update(msg, start) {
        var A = this.h[0];
        var B = this.h[1];
        var C = this.h[2];
        var D = this.h[3];
        var E = this.h[4];
        var Ah = A;
        var Bh = B;
        var Ch = C;
        var Dh = D;
        var Eh = E;
        for(var j = 0; j < 80; j++){
            var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
            A = E;
            E = D;
            D = rotl32(C, 10);
            C = B;
            B = T;
            T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
            Ah = Eh;
            Eh = Dh;
            Dh = rotl32(Ch, 10);
            Ch = Bh;
            Bh = T;
        }
        T = sum32_3(this.h[1], C, Dh);
        this.h[1] = sum32_3(this.h[2], D, Eh);
        this.h[2] = sum32_3(this.h[3], E, Ah);
        this.h[3] = sum32_3(this.h[4], A, Bh);
        this.h[4] = sum32_3(this.h[0], B, Ch);
        this.h[0] = T;
    };
    RIPEMD160.prototype._digest = function digest(enc) {
        if (enc === "hex") return utils2.toHex32(this.h, "little");
        else return utils2.split32(this.h, "little");
    };
    function f(j, x, y, z) {
        if (j <= 15) return x ^ y ^ z;
        else if (j <= 31) return x & y | ~x & z;
        else if (j <= 47) return (x | ~y) ^ z;
        else if (j <= 63) return x & z | y & ~z;
        else return x ^ (y | ~z);
    }
    function K(j) {
        if (j <= 15) return 0;
        else if (j <= 31) return 1518500249;
        else if (j <= 47) return 1859775393;
        else if (j <= 63) return 2400959708;
        else return 2840853838;
    }
    function Kh(j) {
        if (j <= 15) return 1352829926;
        else if (j <= 31) return 1548603684;
        else if (j <= 47) return 1836072691;
        else if (j <= 63) return 2053994217;
        else return 0;
    }
    var r = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        7,
        4,
        13,
        1,
        10,
        6,
        15,
        3,
        12,
        0,
        9,
        5,
        2,
        14,
        11,
        8,
        3,
        10,
        14,
        4,
        9,
        15,
        8,
        1,
        2,
        7,
        0,
        6,
        13,
        11,
        5,
        12,
        1,
        9,
        11,
        10,
        0,
        8,
        12,
        4,
        13,
        3,
        7,
        15,
        14,
        5,
        6,
        2,
        4,
        0,
        5,
        9,
        7,
        12,
        2,
        10,
        14,
        1,
        3,
        8,
        11,
        6,
        15,
        13
    ];
    var rh = [
        5,
        14,
        7,
        0,
        9,
        2,
        11,
        4,
        13,
        6,
        15,
        8,
        1,
        10,
        3,
        12,
        6,
        11,
        3,
        7,
        0,
        13,
        5,
        10,
        14,
        15,
        8,
        12,
        4,
        9,
        1,
        2,
        15,
        5,
        1,
        3,
        7,
        14,
        6,
        9,
        11,
        8,
        12,
        2,
        10,
        0,
        4,
        13,
        8,
        6,
        4,
        1,
        3,
        11,
        15,
        0,
        5,
        12,
        2,
        13,
        9,
        7,
        10,
        14,
        12,
        15,
        10,
        4,
        1,
        5,
        8,
        7,
        6,
        2,
        13,
        14,
        0,
        3,
        9,
        11
    ];
    var s = [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8,
        7,
        6,
        8,
        13,
        11,
        9,
        7,
        15,
        7,
        12,
        15,
        9,
        11,
        7,
        13,
        12,
        11,
        13,
        6,
        7,
        14,
        9,
        13,
        15,
        14,
        8,
        13,
        6,
        5,
        12,
        7,
        5,
        11,
        12,
        14,
        15,
        14,
        15,
        9,
        8,
        9,
        14,
        5,
        6,
        8,
        6,
        5,
        12,
        9,
        15,
        5,
        11,
        6,
        8,
        13,
        12,
        5,
        12,
        13,
        14,
        11,
        8,
        5,
        6
    ];
    var sh = [
        8,
        9,
        9,
        11,
        13,
        15,
        15,
        5,
        7,
        7,
        8,
        11,
        14,
        14,
        12,
        6,
        9,
        13,
        15,
        7,
        12,
        8,
        9,
        11,
        7,
        7,
        12,
        7,
        6,
        15,
        13,
        11,
        9,
        7,
        15,
        11,
        8,
        6,
        6,
        14,
        12,
        13,
        5,
        14,
        13,
        13,
        7,
        5,
        15,
        5,
        8,
        11,
        14,
        14,
        6,
        14,
        6,
        9,
        12,
        9,
        12,
        5,
        15,
        8,
        8,
        5,
        12,
        9,
        12,
        5,
        14,
        6,
        8,
        13,
        6,
        5,
        15,
        13,
        11,
        11
    ];
    return $be59461d4a783f7b$var$ripemd;
}
var $be59461d4a783f7b$var$hmac;
var $be59461d4a783f7b$var$hasRequiredHmac;
function $be59461d4a783f7b$var$requireHmac() {
    if ($be59461d4a783f7b$var$hasRequiredHmac) return $be59461d4a783f7b$var$hmac;
    $be59461d4a783f7b$var$hasRequiredHmac = 1;
    var utils2 = $be59461d4a783f7b$var$requireUtils();
    var assert = $be59461d4a783f7b$var$requireMinimalisticAssert();
    function Hmac(hash2, key, enc) {
        if (!(this instanceof Hmac)) return new Hmac(hash2, key, enc);
        this.Hash = hash2;
        this.blockSize = hash2.blockSize / 8;
        this.outSize = hash2.outSize / 8;
        this.inner = null;
        this.outer = null;
        this._init(utils2.toArray(key, enc));
    }
    $be59461d4a783f7b$var$hmac = Hmac;
    Hmac.prototype._init = function init(key) {
        if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
        assert(key.length <= this.blockSize);
        for(var i = key.length; i < this.blockSize; i++)key.push(0);
        for(i = 0; i < key.length; i++)key[i] ^= 54;
        this.inner = new this.Hash().update(key);
        for(i = 0; i < key.length; i++)key[i] ^= 106;
        this.outer = new this.Hash().update(key);
    };
    Hmac.prototype.update = function update(msg, enc) {
        this.inner.update(msg, enc);
        return this;
    };
    Hmac.prototype.digest = function digest(enc) {
        this.outer.update(this.inner.digest());
        return this.outer.digest(enc);
    };
    return $be59461d4a783f7b$var$hmac;
}
var $be59461d4a783f7b$var$hasRequiredHash;
function $be59461d4a783f7b$var$requireHash() {
    if ($be59461d4a783f7b$var$hasRequiredHash) return $be59461d4a783f7b$var$hash$1;
    $be59461d4a783f7b$var$hasRequiredHash = 1;
    (function(exports) {
        var hash2 = exports;
        hash2.utils = $be59461d4a783f7b$var$requireUtils();
        hash2.common = $be59461d4a783f7b$var$requireCommon$1();
        hash2.sha = $be59461d4a783f7b$var$requireSha();
        hash2.ripemd = $be59461d4a783f7b$var$requireRipemd();
        hash2.hmac = $be59461d4a783f7b$var$requireHmac();
        hash2.sha1 = hash2.sha.sha1;
        hash2.sha256 = hash2.sha.sha256;
        hash2.sha224 = hash2.sha.sha224;
        hash2.sha384 = hash2.sha.sha384;
        hash2.sha512 = hash2.sha.sha512;
        hash2.ripemd160 = hash2.ripemd.ripemd160;
    })($be59461d4a783f7b$var$hash$1);
    return $be59461d4a783f7b$var$hash$1;
}
var $be59461d4a783f7b$var$hashExports = $be59461d4a783f7b$var$requireHash();
const $be59461d4a783f7b$var$hash = /* @__PURE__ */ $be59461d4a783f7b$var$getDefaultExportFromCjs$1($be59461d4a783f7b$var$hashExports);
let $be59461d4a783f7b$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $be59461d4a783f7b$var$customAlphabet = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $be59461d4a783f7b$var$nanoid = (size = 21)=>{
    let id = "";
    let i = size | 0;
    while(i--)id += $be59461d4a783f7b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
const $be59461d4a783f7b$export$9c2bb9525a3b6907 = (millimeters)=>Math.floor(millimeters / 25.4 * 1440);
const $be59461d4a783f7b$export$4db9ad0f69d17611 = (inches)=>Math.floor(inches * 1440);
const $be59461d4a783f7b$export$cad86b9e31290e6a = (initial = 0)=>{
    let currentCount = initial;
    return ()=>++currentCount;
};
const $be59461d4a783f7b$export$704353bc8da186a0 = ()=>$be59461d4a783f7b$export$cad86b9e31290e6a();
const $be59461d4a783f7b$export$efd792105b1568d0 = ()=>$be59461d4a783f7b$export$cad86b9e31290e6a(1);
const $be59461d4a783f7b$export$63865147ffc7f253 = ()=>$be59461d4a783f7b$export$cad86b9e31290e6a();
const $be59461d4a783f7b$export$3be069097e26ba4c = ()=>$be59461d4a783f7b$export$cad86b9e31290e6a();
const $be59461d4a783f7b$export$8b15d37bc3f197d4 = ()=>$be59461d4a783f7b$var$nanoid().toLowerCase();
const $be59461d4a783f7b$export$e96b930cac5ed9fe = (data)=>$be59461d4a783f7b$var$hash.sha1().update(data instanceof ArrayBuffer ? new Uint8Array(data) : data).digest("hex");
const $be59461d4a783f7b$var$generateUuidPart = (count)=>$be59461d4a783f7b$var$customAlphabet("1234567890abcdef", count)();
const $be59461d4a783f7b$export$a261054604391cc = ()=>`${$be59461d4a783f7b$var$generateUuidPart(8)}-${$be59461d4a783f7b$var$generateUuidPart(4)}-${$be59461d4a783f7b$var$generateUuidPart(4)}-${$be59461d4a783f7b$var$generateUuidPart(4)}-${$be59461d4a783f7b$var$generateUuidPart(12)}`;
const $be59461d4a783f7b$export$10c561c819151cc = {
    /**
   * ## Character
   *
   * Specifies that the horizontal positioning shall be relative to the position of the anchor within its run content.
   */ CHARACTER: "character",
    /**
   * ## Column
   *
   * Specifies that the horizontal positioning shall be relative to the extents of the column which contains its anchor.
   */ COLUMN: "column",
    /**
   * ## Inside Margin
   *
   * Specifies that the horizontal positioning shall be relative to the inside margin of the current page (the left margin on odd pages, right on even pages).
   */ INSIDE_MARGIN: "insideMargin",
    /**
   * ## Left Margin
   *
   * Specifies that the horizontal positioning shall be relative to the left margin of the page.
   */ LEFT_MARGIN: "leftMargin",
    /**
   * ## Page Margin
   *
   * Specifies that the horizontal positioning shall be relative to the page margins.
   */ MARGIN: "margin",
    /**
   * ## Outside Margin
   *
   * Specifies that the horizontal positioning shall be relative to the outside margin of the current page (the right margin on odd pages, left on even pages).
   */ OUTSIDE_MARGIN: "outsideMargin",
    /**
   * ## Page Edge
   *
   * Specifies that the horizontal positioning shall be relative to the edge of the page.
   */ PAGE: "page",
    /**
   * ## Right Margin
   *
   * Specifies that the horizontal positioning shall be relative to the right margin of the page.
   */ RIGHT_MARGIN: "rightMargin"
};
const $be59461d4a783f7b$export$f98d20a05a7811b3 = {
    /**
   * ## Bottom Margin
   *
   * Specifies that the vertical positioning shall be relative to the bottom margin of the current page.
   */ BOTTOM_MARGIN: "bottomMargin",
    /**
   * ## Inside Margin
   *
   * Specifies that the vertical positioning shall be relative to the inside margin of the current page.
   */ INSIDE_MARGIN: "insideMargin",
    /**
   * ## Line
   *
   * Specifies that the vertical positioning shall be relative to the line containing the anchor character.
   */ LINE: "line",
    /**
   * ## Page Margin
   *
   * Specifies that the vertical positioning shall be relative to the page margins.
   */ MARGIN: "margin",
    /**
   * ## Outside Margin
   *
   * Specifies that the vertical positioning shall be relative to the outside margin of the current page.
   */ OUTSIDE_MARGIN: "outsideMargin",
    /**
   * ## Page Edge
   *
   * Specifies that the vertical positioning shall be relative to the edge of the page.
   */ PAGE: "page",
    /**
   * ## Paragraph
   *
   * Specifies that the vertical positioning shall be relative to the paragraph which contains the drawing anchor.
   */ PARAGRAPH: "paragraph",
    /**
   * ## Top Margin
   *
   * Specifies that the vertical positioning shall be relative to the top margin of the current page.
   */ TOP_MARGIN: "topMargin"
};
const $be59461d4a783f7b$export$f82b3ebaa79117d5 = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:simplePos",
        // NOTE: It's not fully supported in Microsoft Word, but this element is needed anyway
        attributes: {
            x: {
                key: "x",
                value: 0
            },
            y: {
                key: "y",
                value: 0
            }
        }
    });
const $be59461d4a783f7b$var$createAlign = (value)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:align",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        children: [
            value
        ]
    });
const $be59461d4a783f7b$var$createPositionOffset = (offsetValue)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:posOffset",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        children: [
            offsetValue.toString()
        ]
    });
const $be59461d4a783f7b$export$64ff7a198e0d7f3d = ({ relative: relative, align: align, offset: offset })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:positionH",
        attributes: {
            relativeFrom: {
                key: "relativeFrom",
                value: relative != null ? relative : $be59461d4a783f7b$export$10c561c819151cc.PAGE
            }
        },
        children: [
            (()=>{
                if (align) return $be59461d4a783f7b$var$createAlign(align);
                else if (offset !== void 0) return $be59461d4a783f7b$var$createPositionOffset(offset);
                else throw new Error("There is no configuration provided for floating position (Align or offset)");
            })()
        ]
    });
const $be59461d4a783f7b$export$ab8b855f16331446 = ({ relative: relative, align: align, offset: offset })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:positionV",
        attributes: {
            relativeFrom: {
                key: "relativeFrom",
                value: relative != null ? relative : $be59461d4a783f7b$export$f98d20a05a7811b3.PAGE
            }
        },
        children: [
            (()=>{
                if (align) return $be59461d4a783f7b$var$createAlign(align);
                else if (offset !== void 0) return $be59461d4a783f7b$var$createPositionOffset(offset);
                else throw new Error("There is no configuration provided for floating position (Align or offset)");
            })()
        ]
    });
class $be59461d4a783f7b$var$GraphicDataAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            uri: "uri"
        });
    }
}
const $be59461d4a783f7b$var$createSvgBlip = (mediaData)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "asvg:svgBlip",
        attributes: {
            asvg: {
                key: "xmlns:asvg",
                value: "http://schemas.microsoft.com/office/drawing/2016/SVG/main"
            },
            embed: {
                key: "r:embed",
                value: `rId{${mediaData.fileName}}`
            }
        }
    });
const $be59461d4a783f7b$var$createExtention = (mediaData)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:ext",
        attributes: {
            uri: {
                key: "uri",
                value: "{96DAC541-7B7A-43D3-8B79-37D633B846F1}"
            }
        },
        children: [
            $be59461d4a783f7b$var$createSvgBlip(mediaData)
        ]
    });
const $be59461d4a783f7b$var$createExtentionList = (mediaData)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:extLst",
        children: [
            $be59461d4a783f7b$var$createExtention(mediaData)
        ]
    });
const $be59461d4a783f7b$var$createBlip = (mediaData)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:blip",
        attributes: {
            embed: {
                key: "r:embed",
                value: `rId{${mediaData.type === "svg" ? mediaData.fallback.fileName : mediaData.fileName}}`
            },
            cstate: {
                key: "cstate",
                value: "none"
            }
        },
        children: mediaData.type === "svg" ? [
            $be59461d4a783f7b$var$createExtentionList(mediaData)
        ] : []
    });
class $be59461d4a783f7b$var$SourceRectangle extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("a:srcRect");
    }
}
class $be59461d4a783f7b$var$FillRectangle extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("a:fillRect");
    }
}
class $be59461d4a783f7b$var$Stretch extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("a:stretch");
        this.root.push(new $be59461d4a783f7b$var$FillRectangle());
    }
}
class $be59461d4a783f7b$var$BlipFill extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(mediaData){
        super("pic:blipFill");
        this.root.push($be59461d4a783f7b$var$createBlip(mediaData));
        this.root.push(new $be59461d4a783f7b$var$SourceRectangle());
        this.root.push(new $be59461d4a783f7b$var$Stretch());
    }
}
class $be59461d4a783f7b$var$PicLocksAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            noChangeAspect: "noChangeAspect",
            noChangeArrowheads: "noChangeArrowheads"
        });
    }
}
class $be59461d4a783f7b$var$PicLocks extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("a:picLocks");
        this.root.push(new $be59461d4a783f7b$var$PicLocksAttributes({
            noChangeAspect: 1,
            noChangeArrowheads: 1
        }));
    }
}
class $be59461d4a783f7b$var$ChildNonVisualProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("pic:cNvPicPr");
        this.root.push(new $be59461d4a783f7b$var$PicLocks());
    }
}
const $be59461d4a783f7b$var$createHyperlinkClick = (linkId, hasXmlNs)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:hlinkClick",
        attributes: $be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, hasXmlNs ? {
            xmlns: {
                key: "xmlns:a",
                value: "http://schemas.openxmlformats.org/drawingml/2006/main"
            }
        } : {}), {
            id: {
                key: "r:id",
                value: `rId${linkId}`
            }
        })
    });
class $be59461d4a783f7b$var$NonVisualPropertiesAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "id",
            name: "name",
            descr: "descr"
        });
    }
}
class $be59461d4a783f7b$var$NonVisualProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("pic:cNvPr");
        this.root.push(new $be59461d4a783f7b$var$NonVisualPropertiesAttributes({
            id: 0,
            name: "",
            descr: ""
        }));
    }
    prepForXml(context) {
        for(let i = context.stack.length - 1; i >= 0; i--){
            const element = context.stack[i];
            if (!(element instanceof $be59461d4a783f7b$export$6beda279b4a51476)) continue;
            this.root.push($be59461d4a783f7b$var$createHyperlinkClick(element.linkId, false));
            break;
        }
        return super.prepForXml(context);
    }
}
class $be59461d4a783f7b$var$NonVisualPicProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("pic:nvPicPr");
        this.root.push(new $be59461d4a783f7b$var$NonVisualProperties());
        this.root.push(new $be59461d4a783f7b$var$ChildNonVisualProperties());
    }
}
class $be59461d4a783f7b$var$PicAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            xmlns: "xmlns:pic"
        });
    }
}
class $be59461d4a783f7b$var$ExtentsAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            cx: "cx",
            cy: "cy"
        });
    }
}
class $be59461d4a783f7b$var$Extents extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(x, y){
        super("a:ext");
        $be59461d4a783f7b$var$__publicField(this, "attributes");
        this.attributes = new $be59461d4a783f7b$var$ExtentsAttributes({
            cx: x,
            cy: y
        });
        this.root.push(this.attributes);
    }
}
class $be59461d4a783f7b$var$OffsetAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            x: "x",
            y: "y"
        });
    }
}
class $be59461d4a783f7b$var$Offset extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("a:off");
        this.root.push(new $be59461d4a783f7b$var$OffsetAttributes({
            x: 0,
            y: 0
        }));
    }
}
class $be59461d4a783f7b$var$FormAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            flipVertical: "flipV",
            flipHorizontal: "flipH",
            rotation: "rot"
        });
    }
}
class $be59461d4a783f7b$var$Form extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        var _a, _b;
        super("a:xfrm");
        $be59461d4a783f7b$var$__publicField(this, "extents");
        this.root.push(new $be59461d4a783f7b$var$FormAttributes({
            flipVertical: (_a = options.flip) == null ? void 0 : _a.vertical,
            flipHorizontal: (_b = options.flip) == null ? void 0 : _b.horizontal,
            rotation: options.rotation
        }));
        this.extents = new $be59461d4a783f7b$var$Extents(options.emus.x, options.emus.y);
        this.root.push(new $be59461d4a783f7b$var$Offset());
        this.root.push(this.extents);
    }
}
const $be59461d4a783f7b$var$createNoFill = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:noFill"
    });
const $be59461d4a783f7b$var$createSolidRgbColor = (options)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:srgbClr",
        attributes: {
            value: {
                key: "val",
                value: options.value
            }
        }
    });
const $be59461d4a783f7b$var$createSchemeColor = (options)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:schemeClr",
        attributes: {
            value: {
                key: "val",
                value: options.value
            }
        }
    });
const $be59461d4a783f7b$var$createSolidFill = (options)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:solidFill",
        children: [
            options.type === "rgb" ? $be59461d4a783f7b$var$createSolidRgbColor(options) : $be59461d4a783f7b$var$createSchemeColor(options)
        ]
    });
const $be59461d4a783f7b$var$createOutline = (options)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "a:ln",
        attributes: {
            width: {
                key: "w",
                value: options.width
            },
            cap: {
                key: "cap",
                value: options.cap
            },
            compoundLine: {
                key: "cmpd",
                value: options.compoundLine
            },
            align: {
                key: "algn",
                value: options.align
            }
        },
        children: [
            options.type === "noFill" ? $be59461d4a783f7b$var$createNoFill() : options.solidFillType === "rgb" ? $be59461d4a783f7b$var$createSolidFill({
                type: "rgb",
                value: options.value
            }) : $be59461d4a783f7b$var$createSolidFill({
                type: "scheme",
                value: options.value
            })
        ]
    });
class $be59461d4a783f7b$var$AdjustmentValues extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("a:avLst");
    }
}
class $be59461d4a783f7b$var$PresetGeometryAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            prst: "prst"
        });
    }
}
class $be59461d4a783f7b$var$PresetGeometry extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("a:prstGeom");
        this.root.push(new $be59461d4a783f7b$var$PresetGeometryAttributes({
            prst: "rect"
        }));
        this.root.push(new $be59461d4a783f7b$var$AdjustmentValues());
    }
}
class $be59461d4a783f7b$var$ShapePropertiesAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            bwMode: "bwMode"
        });
    }
}
class $be59461d4a783f7b$var$ShapeProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ outline: outline, transform: transform }){
        super("pic:spPr");
        $be59461d4a783f7b$var$__publicField(this, "form");
        this.root.push(new $be59461d4a783f7b$var$ShapePropertiesAttributes({
            bwMode: "auto"
        }));
        this.form = new $be59461d4a783f7b$var$Form(transform);
        this.root.push(this.form);
        this.root.push(new $be59461d4a783f7b$var$PresetGeometry());
        if (outline) {
            this.root.push($be59461d4a783f7b$var$createNoFill());
            this.root.push($be59461d4a783f7b$var$createOutline(outline));
        }
    }
}
class $be59461d4a783f7b$var$Pic extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ mediaData: mediaData, transform: transform, outline: outline }){
        super("pic:pic");
        this.root.push(new $be59461d4a783f7b$var$PicAttributes({
            xmlns: "http://schemas.openxmlformats.org/drawingml/2006/picture"
        }));
        this.root.push(new $be59461d4a783f7b$var$NonVisualPicProperties());
        this.root.push(new $be59461d4a783f7b$var$BlipFill(mediaData));
        this.root.push(new $be59461d4a783f7b$var$ShapeProperties({
            transform: transform,
            outline: outline
        }));
    }
}
class $be59461d4a783f7b$var$GraphicData extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ mediaData: mediaData, transform: transform, outline: outline }){
        super("a:graphicData");
        $be59461d4a783f7b$var$__publicField(this, "pic");
        this.root.push(new $be59461d4a783f7b$var$GraphicDataAttributes({
            uri: "http://schemas.openxmlformats.org/drawingml/2006/picture"
        }));
        this.pic = new $be59461d4a783f7b$var$Pic({
            mediaData: mediaData,
            transform: transform,
            outline: outline
        });
        this.root.push(this.pic);
    }
}
class $be59461d4a783f7b$var$GraphicAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            a: "xmlns:a"
        });
    }
}
class $be59461d4a783f7b$var$Graphic extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ mediaData: mediaData, transform: transform, outline: outline }){
        super("a:graphic");
        $be59461d4a783f7b$var$__publicField(this, "data");
        this.root.push(new $be59461d4a783f7b$var$GraphicAttributes({
            a: "http://schemas.openxmlformats.org/drawingml/2006/main"
        }));
        this.data = new $be59461d4a783f7b$var$GraphicData({
            mediaData: mediaData,
            transform: transform,
            outline: outline
        });
        this.root.push(this.data);
    }
}
const $be59461d4a783f7b$export$6a3bca3ba43863ad = {
    NONE: 0,
    SQUARE: 1,
    TIGHT: 2,
    TOP_AND_BOTTOM: 3
};
const $be59461d4a783f7b$export$18bd536dc9d39d85 = {
    BOTH_SIDES: "bothSides",
    LEFT: "left",
    RIGHT: "right",
    LARGEST: "largest"
};
class $be59461d4a783f7b$export$55989adc605dc8b3 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("wp:wrapNone");
    }
}
class $be59461d4a783f7b$var$WrapSquareAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            distT: "distT",
            distB: "distB",
            distL: "distL",
            distR: "distR",
            wrapText: "wrapText"
        });
    }
}
class $be59461d4a783f7b$export$cb58bbb894326836 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(textWrapping, margins = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    }){
        super("wp:wrapSquare");
        this.root.push(new $be59461d4a783f7b$var$WrapSquareAttributes({
            wrapText: textWrapping.side || $be59461d4a783f7b$export$18bd536dc9d39d85.BOTH_SIDES,
            distT: margins.top,
            distB: margins.bottom,
            distL: margins.left,
            distR: margins.right
        }));
    }
}
class $be59461d4a783f7b$var$WrapTightAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            distT: "distT",
            distB: "distB"
        });
    }
}
class $be59461d4a783f7b$export$cdf188ce20f1ead1 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(margins = {
        top: 0,
        bottom: 0
    }){
        super("wp:wrapTight");
        this.root.push(new $be59461d4a783f7b$var$WrapTightAttributes({
            distT: margins.top,
            distB: margins.bottom
        }));
    }
}
class $be59461d4a783f7b$var$WrapTopAndBottomAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            distT: "distT",
            distB: "distB"
        });
    }
}
class $be59461d4a783f7b$export$b8b93fdb253c534d extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(margins = {
        top: 0,
        bottom: 0
    }){
        super("wp:wrapTopAndBottom");
        this.root.push(new $be59461d4a783f7b$var$WrapTopAndBottomAttributes({
            distT: margins.top,
            distB: margins.bottom
        }));
    }
}
class $be59461d4a783f7b$var$DocProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ name: name, description: description, title: title } = {
        name: "",
        description: "",
        title: ""
    }){
        super("wp:docPr");
        $be59461d4a783f7b$var$__publicField(this, "docPropertiesUniqueNumericId", $be59461d4a783f7b$export$63865147ffc7f253());
        const attributes = {
            id: {
                key: "id",
                value: this.docPropertiesUniqueNumericId()
            },
            name: {
                key: "name",
                value: name
            }
        };
        if (description !== null && description !== void 0) attributes.description = {
            key: "descr",
            value: description
        };
        if (title !== null && title !== void 0) attributes.title = {
            key: "title",
            value: title
        };
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a(attributes));
    }
    prepForXml(context) {
        for(let i = context.stack.length - 1; i >= 0; i--){
            const element = context.stack[i];
            if (!(element instanceof $be59461d4a783f7b$export$6beda279b4a51476)) continue;
            this.root.push($be59461d4a783f7b$var$createHyperlinkClick(element.linkId, true));
            break;
        }
        return super.prepForXml(context);
    }
}
const $be59461d4a783f7b$var$createEffectExtent = ({ top: top, right: right, bottom: bottom, left: left })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:effectExtent",
        attributes: {
            top: {
                key: "t",
                value: top
            },
            right: {
                key: "r",
                value: right
            },
            bottom: {
                key: "b",
                value: bottom
            },
            left: {
                key: "l",
                value: left
            }
        }
    });
const $be59461d4a783f7b$var$createExtent = ({ x: x, y: y })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:extent",
        attributes: {
            x: {
                key: "cx",
                value: x
            },
            y: {
                key: "cy",
                value: y
            }
        }
    });
class $be59461d4a783f7b$var$GraphicFrameLockAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            xmlns: "xmlns:a",
            noChangeAspect: "noChangeAspect"
        });
    }
}
class $be59461d4a783f7b$var$GraphicFrameLocks extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("a:graphicFrameLocks");
        this.root.push(new $be59461d4a783f7b$var$GraphicFrameLockAttributes({
            xmlns: "http://schemas.openxmlformats.org/drawingml/2006/main",
            noChangeAspect: 1
        }));
    }
}
const $be59461d4a783f7b$var$createGraphicFrameProperties = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:cNvGraphicFramePr",
        children: [
            new $be59461d4a783f7b$var$GraphicFrameLocks()
        ]
    });
class $be59461d4a783f7b$var$AnchorAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            distT: "distT",
            distB: "distB",
            distL: "distL",
            distR: "distR",
            allowOverlap: "allowOverlap",
            behindDoc: "behindDoc",
            layoutInCell: "layoutInCell",
            locked: "locked",
            relativeHeight: "relativeHeight",
            simplePos: "simplePos"
        });
    }
}
class $be59461d4a783f7b$var$Anchor extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ mediaData: mediaData, transform: transform, drawingOptions: drawingOptions }){
        super("wp:anchor");
        const floating = $be59461d4a783f7b$var$__spreadValues({
            allowOverlap: true,
            behindDocument: false,
            lockAnchor: false,
            layoutInCell: true,
            verticalPosition: {},
            horizontalPosition: {}
        }, drawingOptions.floating);
        this.root.push(new $be59461d4a783f7b$var$AnchorAttributes({
            distT: floating.margins ? floating.margins.top || 0 : 0,
            distB: floating.margins ? floating.margins.bottom || 0 : 0,
            distL: floating.margins ? floating.margins.left || 0 : 0,
            distR: floating.margins ? floating.margins.right || 0 : 0,
            simplePos: "0",
            // note: word doesn't fully support - so we use 0
            allowOverlap: floating.allowOverlap === true ? "1" : "0",
            behindDoc: floating.behindDocument === true ? "1" : "0",
            locked: floating.lockAnchor === true ? "1" : "0",
            layoutInCell: floating.layoutInCell === true ? "1" : "0",
            relativeHeight: floating.zIndex ? floating.zIndex : transform.emus.y
        }));
        this.root.push($be59461d4a783f7b$export$f82b3ebaa79117d5());
        this.root.push($be59461d4a783f7b$export$64ff7a198e0d7f3d(floating.horizontalPosition));
        this.root.push($be59461d4a783f7b$export$ab8b855f16331446(floating.verticalPosition));
        this.root.push($be59461d4a783f7b$var$createExtent({
            x: transform.emus.x,
            y: transform.emus.y
        }));
        this.root.push($be59461d4a783f7b$var$createEffectExtent({
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }));
        if (drawingOptions.floating !== void 0 && drawingOptions.floating.wrap !== void 0) switch(drawingOptions.floating.wrap.type){
            case $be59461d4a783f7b$export$6a3bca3ba43863ad.SQUARE:
                this.root.push(new $be59461d4a783f7b$export$cb58bbb894326836(drawingOptions.floating.wrap, drawingOptions.floating.margins));
                break;
            case $be59461d4a783f7b$export$6a3bca3ba43863ad.TIGHT:
                this.root.push(new $be59461d4a783f7b$export$cdf188ce20f1ead1(drawingOptions.floating.margins));
                break;
            case $be59461d4a783f7b$export$6a3bca3ba43863ad.TOP_AND_BOTTOM:
                this.root.push(new $be59461d4a783f7b$export$b8b93fdb253c534d(drawingOptions.floating.margins));
                break;
            case $be59461d4a783f7b$export$6a3bca3ba43863ad.NONE:
            default:
                this.root.push(new $be59461d4a783f7b$export$55989adc605dc8b3());
        }
        else this.root.push(new $be59461d4a783f7b$export$55989adc605dc8b3());
        this.root.push(new $be59461d4a783f7b$var$DocProperties(drawingOptions.docProperties));
        this.root.push($be59461d4a783f7b$var$createGraphicFrameProperties());
        this.root.push(new $be59461d4a783f7b$var$Graphic({
            mediaData: mediaData,
            transform: transform,
            outline: drawingOptions.outline
        }));
    }
}
const $be59461d4a783f7b$var$createInline = ({ mediaData: mediaData, transform: transform, docProperties: docProperties, outline: outline })=>{
    var _a, _b, _c, _d;
    return new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "wp:inline",
        attributes: {
            distanceTop: {
                key: "distT",
                value: 0
            },
            distanceBottom: {
                key: "distB",
                value: 0
            },
            distanceLeft: {
                key: "distL",
                value: 0
            },
            distanceRight: {
                key: "distR",
                value: 0
            }
        },
        children: [
            $be59461d4a783f7b$var$createExtent({
                x: transform.emus.x,
                y: transform.emus.y
            }),
            $be59461d4a783f7b$var$createEffectExtent(outline ? {
                top: ((_a = outline.width) != null ? _a : 9525) * 2,
                right: ((_b = outline.width) != null ? _b : 9525) * 2,
                bottom: ((_c = outline.width) != null ? _c : 9525) * 2,
                left: ((_d = outline.width) != null ? _d : 9525) * 2
            } : {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }),
            new $be59461d4a783f7b$var$DocProperties(docProperties),
            $be59461d4a783f7b$var$createGraphicFrameProperties(),
            new $be59461d4a783f7b$var$Graphic({
                mediaData: mediaData,
                transform: transform,
                outline: outline
            })
        ]
    });
};
class $be59461d4a783f7b$export$6c98c30b3a286440 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(imageData, drawingOptions = {}){
        super("w:drawing");
        if (!drawingOptions.floating) this.root.push($be59461d4a783f7b$var$createInline({
            mediaData: imageData,
            transform: imageData.transformation,
            docProperties: drawingOptions.docProperties,
            outline: drawingOptions.outline
        }));
        else this.root.push(new $be59461d4a783f7b$var$Anchor({
            mediaData: imageData,
            transform: imageData.transformation,
            drawingOptions: drawingOptions
        }));
    }
}

const $be59461d4a783f7b$var$convertDataURIToBinary = (dataURI)=>{
    if (typeof atob === "function") {
        const BASE64_MARKER = ";base64,";
        const base64Index = dataURI.indexOf(BASE64_MARKER);
        const base64IndexWithOffset = base64Index === -1 ? 0 : base64Index + BASE64_MARKER.length;
        return new Uint8Array(atob(dataURI.substring(base64IndexWithOffset)).split("").map((c)=>c.charCodeAt(0)));
    } else {
        const b = (parcelRequire("6ZWSX"));
        return new b.Buffer(dataURI, "base64");
    }
};
const $be59461d4a783f7b$var$standardizeData = (data)=>typeof data === "string" ? $be59461d4a783f7b$var$convertDataURIToBinary(data) : data;
const $be59461d4a783f7b$var$createImageData = (options, key)=>({
        data: $be59461d4a783f7b$var$standardizeData(options.data),
        fileName: key,
        transformation: {
            pixels: {
                x: Math.round(options.transformation.width),
                y: Math.round(options.transformation.height)
            },
            emus: {
                x: Math.round(options.transformation.width * 9525),
                y: Math.round(options.transformation.height * 9525)
            },
            flip: options.transformation.flip,
            rotation: options.transformation.rotation ? options.transformation.rotation * 6e4 : void 0
        }
    });
class $be59461d4a783f7b$export$748e1095269a17e0 extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(options){
        super({});
        $be59461d4a783f7b$var$__publicField(this, "imageData");
        const hash2 = $be59461d4a783f7b$export$e96b930cac5ed9fe(options.data);
        const key = `${hash2}.${options.type}`;
        this.imageData = options.type === "svg" ? $be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({
            type: options.type
        }, $be59461d4a783f7b$var$createImageData(options, key)), {
            fallback: $be59461d4a783f7b$var$__spreadValues({
                type: options.fallback.type
            }, $be59461d4a783f7b$var$createImageData($be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, options.fallback), {
                transformation: options.transformation
            }), `${$be59461d4a783f7b$export$e96b930cac5ed9fe(options.fallback.data)}.${options.fallback.type}`))
        }) : $be59461d4a783f7b$var$__spreadValues({
            type: options.type
        }, $be59461d4a783f7b$var$createImageData(options, key));
        const drawing = new $be59461d4a783f7b$export$6c98c30b3a286440(this.imageData, {
            floating: options.floating,
            docProperties: options.altText,
            outline: options.outline
        });
        this.root.push(drawing);
    }
    prepForXml(context) {
        context.file.Media.addImage(this.imageData.fileName, this.imageData);
        if (this.imageData.type === "svg") context.file.Media.addImage(this.imageData.fallback.fileName, this.imageData.fallback);
        return super.prepForXml(context);
    }
}
class $be59461d4a783f7b$var$SequentialIdentifierInstruction extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(identifier){
        super("w:instrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push(`SEQ ${identifier}`);
    }
}
class $be59461d4a783f7b$export$c6c7e7a175869529 extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(identifier){
        super({});
        this.root.push(new $be59461d4a783f7b$var$Begin(true));
        this.root.push(new $be59461d4a783f7b$var$SequentialIdentifierInstruction(identifier));
        this.root.push(new $be59461d4a783f7b$var$Separate());
        this.root.push(new $be59461d4a783f7b$var$End());
    }
}
class $be59461d4a783f7b$var$FldSimpleAttrs extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            instr: "w:instr"
        });
    }
}
class $be59461d4a783f7b$export$68548adcc40655f2 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(instruction, cachedValue){
        super("w:fldSimple");
        this.root.push(new $be59461d4a783f7b$var$FldSimpleAttrs({
            instr: instruction
        }));
        if (cachedValue !== void 0) this.root.push(new $be59461d4a783f7b$export$84d920a4f7ee9ae2(cachedValue));
    }
}
class $be59461d4a783f7b$export$398abb3a757cc8e0 extends $be59461d4a783f7b$export$68548adcc40655f2 {
    constructor(fieldName){
        super(` MERGEFIELD ${fieldName} `, `\xab${fieldName}\xbb`);
    }
}
class $be59461d4a783f7b$var$RelationshipsAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            xmlns: "xmlns"
        });
    }
}
class $be59461d4a783f7b$var$RelationshipAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "Id",
            type: "Type",
            target: "Target",
            targetMode: "TargetMode"
        });
    }
}
const $be59461d4a783f7b$var$TargetModeType = {
    EXTERNAL: "External"
};
class $be59461d4a783f7b$var$Relationship extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id, type2, target, targetMode){
        super("Relationship");
        this.root.push(new $be59461d4a783f7b$var$RelationshipAttributes({
            id: id,
            type: type2,
            target: target,
            targetMode: targetMode
        }));
    }
}
class $be59461d4a783f7b$var$Relationships extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("Relationships");
        this.root.push(new $be59461d4a783f7b$var$RelationshipsAttributes({
            xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
        }));
    }
    createRelationship(id, type2, target, targetMode) {
        const relationship = new $be59461d4a783f7b$var$Relationship(`rId${id}`, type2, target, targetMode);
        this.root.push(relationship);
        return relationship;
    }
    get RelationshipCount() {
        return this.root.length - 1;
    }
}
class $be59461d4a783f7b$var$CommentAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "w:id",
            initials: "w:initials",
            author: "w:author",
            date: "w:date"
        });
    }
}
class $be59461d4a783f7b$var$CommentRangeAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "w:id"
        });
    }
}
class $be59461d4a783f7b$var$RootCommentsAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            "xmlns:cx": "xmlns:cx",
            "xmlns:cx1": "xmlns:cx1",
            "xmlns:cx2": "xmlns:cx2",
            "xmlns:cx3": "xmlns:cx3",
            "xmlns:cx4": "xmlns:cx4",
            "xmlns:cx5": "xmlns:cx5",
            "xmlns:cx6": "xmlns:cx6",
            "xmlns:cx7": "xmlns:cx7",
            "xmlns:cx8": "xmlns:cx8",
            "xmlns:mc": "xmlns:mc",
            "xmlns:aink": "xmlns:aink",
            "xmlns:am3d": "xmlns:am3d",
            "xmlns:o": "xmlns:o",
            "xmlns:r": "xmlns:r",
            "xmlns:m": "xmlns:m",
            "xmlns:v": "xmlns:v",
            "xmlns:wp14": "xmlns:wp14",
            "xmlns:wp": "xmlns:wp",
            "xmlns:w10": "xmlns:w10",
            "xmlns:w": "xmlns:w",
            "xmlns:w14": "xmlns:w14",
            "xmlns:w15": "xmlns:w15",
            "xmlns:w16cex": "xmlns:w16cex",
            "xmlns:w16cid": "xmlns:w16cid",
            "xmlns:w16": "xmlns:w16",
            "xmlns:w16sdtdh": "xmlns:w16sdtdh",
            "xmlns:w16se": "xmlns:w16se",
            "xmlns:wpg": "xmlns:wpg",
            "xmlns:wpi": "xmlns:wpi",
            "xmlns:wne": "xmlns:wne",
            "xmlns:wps": "xmlns:wps"
        });
    }
}
class $be59461d4a783f7b$export$7fae596544522c24 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id){
        super("w:commentRangeStart");
        this.root.push(new $be59461d4a783f7b$var$CommentRangeAttributes({
            id: id
        }));
    }
}
class $be59461d4a783f7b$export$1c909ece16de52c8 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id){
        super("w:commentRangeEnd");
        this.root.push(new $be59461d4a783f7b$var$CommentRangeAttributes({
            id: id
        }));
    }
}
class $be59461d4a783f7b$export$4b42d1c3b05fc701 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id){
        super("w:commentReference");
        this.root.push(new $be59461d4a783f7b$var$CommentRangeAttributes({
            id: id
        }));
    }
}
class $be59461d4a783f7b$export$4d299b491347818a extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ id: id, initials: initials, author: author, date: date = /* @__PURE__ */ new Date(), children: children }){
        super("w:comment");
        this.root.push(new $be59461d4a783f7b$var$CommentAttributes({
            id: id,
            initials: initials,
            author: author,
            date: date.toISOString()
        }));
        for (const child of children)this.root.push(child);
    }
}
class $be59461d4a783f7b$export$434c217d363ea16 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ children: children }){
        super("w:comments");
        $be59461d4a783f7b$var$__publicField(this, "relationships");
        this.root.push(new $be59461d4a783f7b$var$RootCommentsAttributes({
            "xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
            "xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
            "xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
            "xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
            "xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
            "xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
            "xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
            "xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
            "xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
            "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
            "xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
            "xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
            "xmlns:o": "urn:schemas-microsoft-com:office:office",
            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            "xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
            "xmlns:v": "urn:schemas-microsoft-com:vml",
            "xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            "xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            "xmlns:w10": "urn:schemas-microsoft-com:office:word",
            "xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            "xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
            "xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
            "xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
            "xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
            "xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
            "xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
            "xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
            "xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            "xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            "xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
            "xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
        }));
        for (const child of children)this.root.push(new $be59461d4a783f7b$export$4d299b491347818a(child));
        this.relationships = new $be59461d4a783f7b$var$Relationships();
    }
    get Relationships() {
        return this.relationships;
    }
}
class $be59461d4a783f7b$export$89cf22b7cd4e5412 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:noBreakHyphen");
    }
}
class $be59461d4a783f7b$export$4fc66ded9fea0dc2 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:softHyphen");
    }
}
class $be59461d4a783f7b$export$7aa9b47ca2ad3435 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:dayShort");
    }
}
class $be59461d4a783f7b$export$cb13e7e828d466b4 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:monthShort");
    }
}
class $be59461d4a783f7b$export$b22abff4e0bb2227 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:yearShort");
    }
}
class $be59461d4a783f7b$export$7f11aa0bd1185b81 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:dayLong");
    }
}
class $be59461d4a783f7b$export$fb4c8c9ac11bc45a extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:monthLong");
    }
}
class $be59461d4a783f7b$export$45f274d2a51212fa extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:yearLong");
    }
}
class $be59461d4a783f7b$export$f2387e03417b0225 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:annotationRef");
    }
}
class $be59461d4a783f7b$export$c55c754dfdb27980 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:footnoteRef");
    }
}
class $be59461d4a783f7b$export$6ab9196e64545ac3 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:endnoteRef");
    }
}
class $be59461d4a783f7b$export$1ff3c3f08ae963c0 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:separator");
    }
}
class $be59461d4a783f7b$export$16dff850c66f7024 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:continuationSeparator");
    }
}
class $be59461d4a783f7b$export$b31d4e59306b6dff extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:pgNum");
    }
}
class $be59461d4a783f7b$export$f30b2ad466b6f52c extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:cr");
    }
}
class $be59461d4a783f7b$export$3e41faf802a29e71 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:tab");
    }
}
class $be59461d4a783f7b$export$381f05e113561c91 extends $be59461d4a783f7b$export$96977b263db98d55 {
    constructor(){
        super("w:lastRenderedPageBreak");
    }
}
const $be59461d4a783f7b$export$142f52a4680b9e5d = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
};
const $be59461d4a783f7b$export$f2247382176912fd = {
    MARGIN: "margin",
    INDENT: "indent"
};
const $be59461d4a783f7b$export$9c74d220d8b0cb92 = {
    NONE: "none",
    DOT: "dot",
    HYPHEN: "hyphen",
    UNDERSCORE: "underscore",
    MIDDLE_DOT: "middleDot"
};
class $be59461d4a783f7b$export$9e7f52ab4ae6a08b extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:ptab");
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            alignment: {
                key: "w:alignment",
                value: options.alignment
            },
            relativeTo: {
                key: "w:relativeTo",
                value: options.relativeTo
            },
            leader: {
                key: "w:leader",
                value: options.leader
            }
        }));
    }
}
const $be59461d4a783f7b$var$BreakType = {
    COLUMN: "column",
    PAGE: "page"
};
class $be59461d4a783f7b$var$Break2 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(type2){
        super("w:br");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            type: type2
        }));
    }
}
class $be59461d4a783f7b$export$9423c247516c9fc8 extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(){
        super({});
        this.root.push(new $be59461d4a783f7b$var$Break2($be59461d4a783f7b$var$BreakType.PAGE));
    }
}
class $be59461d4a783f7b$export$40b3a3732603d761 extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(){
        super({});
        this.root.push(new $be59461d4a783f7b$var$Break2($be59461d4a783f7b$var$BreakType.COLUMN));
    }
}
class $be59461d4a783f7b$export$f4d23c02e5ffac1a extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:pageBreakBefore");
    }
}
const $be59461d4a783f7b$export$595a14bf61dfe45b = {
    AT_LEAST: "atLeast",
    EXACTLY: "exactly",
    EXACT: "exact",
    AUTO: "auto"
};
class $be59461d4a783f7b$var$SpacingAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            after: "w:after",
            before: "w:before",
            line: "w:line",
            lineRule: "w:lineRule",
            beforeAutoSpacing: "w:beforeAutospacing",
            afterAutoSpacing: "w:afterAutospacing"
        });
    }
}
class $be59461d4a783f7b$export$a39947a896defee6 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:spacing");
        this.root.push(new $be59461d4a783f7b$var$SpacingAttributes(options));
    }
}
const $be59461d4a783f7b$export$148b6b80f73d2a18 = {
    HEADING_1: "Heading1",
    HEADING_2: "Heading2",
    HEADING_3: "Heading3",
    HEADING_4: "Heading4",
    HEADING_5: "Heading5",
    HEADING_6: "Heading6",
    TITLE: "Title"
};
let $be59461d4a783f7b$export$d9e45bc13d335801 = class Style extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(styleId){
        super("w:pStyle");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: styleId
        }));
    }
};
class $be59461d4a783f7b$export$639143e2dbee2d0 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(tabDefinitions){
        super("w:tabs");
        for (const tabDefinition of tabDefinitions)this.root.push(new $be59461d4a783f7b$export$f9728ec8c3f86596(tabDefinition));
    }
}
const $be59461d4a783f7b$export$2effbc422db8f8ed = {
    LEFT: "left",
    RIGHT: "right",
    CENTER: "center",
    BAR: "bar",
    CLEAR: "clear",
    DECIMAL: "decimal",
    END: "end",
    NUM: "num",
    START: "start"
};
const $be59461d4a783f7b$export$aa498464def7b45a = {
    DOT: "dot",
    HYPHEN: "hyphen",
    MIDDLE_DOT: "middleDot",
    NONE: "none",
    UNDERSCORE: "underscore"
};
const $be59461d4a783f7b$export$d53250c7bcc57c01 = {
    MAX: 9026
};
class $be59461d4a783f7b$export$fbf624c7a128869a extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val",
            pos: "w:pos",
            leader: "w:leader"
        });
    }
}
class $be59461d4a783f7b$export$f9728ec8c3f86596 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ type: type2, position: position, leader: leader }){
        super("w:tab");
        this.root.push(new $be59461d4a783f7b$export$fbf624c7a128869a({
            val: type2,
            pos: position,
            leader: leader
        }));
    }
}
class $be59461d4a783f7b$export$b5d3f7ce2f820092 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(numberId, indentLevel){
        super("w:numPr");
        this.root.push(new $be59461d4a783f7b$var$IndentLevel(indentLevel));
        this.root.push(new $be59461d4a783f7b$var$NumberId(numberId));
    }
}
class $be59461d4a783f7b$var$IndentLevel extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(level){
        super("w:ilvl");
        if (level > 9) throw new Error("Level cannot be greater than 9. Read more here: https://answers.microsoft.com/en-us/msoffice/forum/all/does-word-support-more-than-9-list-levels/d130fdcd-1781-446d-8c84-c6c79124e4d7");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: level
        }));
    }
}
class $be59461d4a783f7b$var$NumberId extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id){
        super("w:numId");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: typeof id === "string" ? `{${id}}` : id
        }));
    }
}
class $be59461d4a783f7b$export$5b43359c04ff37a0 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "fileChild", Symbol());
    }
}
class $be59461d4a783f7b$var$HyperlinkAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "r:id",
            history: "w:history",
            anchor: "w:anchor"
        });
    }
}
const $be59461d4a783f7b$export$3d0da6f803a431e6 = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL"
};
class $be59461d4a783f7b$export$6beda279b4a51476 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(children, relationshipId, anchor){
        super("w:hyperlink");
        $be59461d4a783f7b$var$__publicField(this, "linkId");
        this.linkId = relationshipId;
        const props = {
            history: 1,
            anchor: anchor ? anchor : void 0,
            id: !anchor ? `rId${this.linkId}` : void 0
        };
        const attributes = new $be59461d4a783f7b$var$HyperlinkAttributes(props);
        this.root.push(attributes);
        children.forEach((child)=>{
            this.root.push(child);
        });
    }
}
class $be59461d4a783f7b$export$d6a545b6cd90455e extends $be59461d4a783f7b$export$6beda279b4a51476 {
    constructor(options){
        super(options.children, $be59461d4a783f7b$export$8b15d37bc3f197d4(), options.anchor);
    }
}
class $be59461d4a783f7b$export$6ea6a3f0b2b263f3 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:externalHyperlink");
        this.options = options;
    }
}
class $be59461d4a783f7b$var$BookmarkStartAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "w:id",
            name: "w:name"
        });
    }
}
class $be59461d4a783f7b$var$BookmarkEndAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "w:id"
        });
    }
}
class $be59461d4a783f7b$export$301ef70c5c7bdf65 {
    constructor(options){
        $be59461d4a783f7b$var$__publicField(this, "bookmarkUniqueNumericId", $be59461d4a783f7b$export$3be069097e26ba4c());
        $be59461d4a783f7b$var$__publicField(this, "start");
        $be59461d4a783f7b$var$__publicField(this, "children");
        $be59461d4a783f7b$var$__publicField(this, "end");
        const linkId = this.bookmarkUniqueNumericId();
        this.start = new $be59461d4a783f7b$export$ad0c5cb04e0f1440(options.id, linkId);
        this.children = options.children;
        this.end = new $be59461d4a783f7b$export$9b661a8aff2b962a(linkId);
    }
}
class $be59461d4a783f7b$export$ad0c5cb04e0f1440 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id, linkId){
        super("w:bookmarkStart");
        const attributes = new $be59461d4a783f7b$var$BookmarkStartAttributes({
            name: id,
            id: linkId
        });
        this.root.push(attributes);
    }
}
class $be59461d4a783f7b$export$9b661a8aff2b962a extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(linkId){
        super("w:bookmarkEnd");
        const attributes = new $be59461d4a783f7b$var$BookmarkEndAttributes({
            id: linkId
        });
        this.root.push(attributes);
    }
}
class $be59461d4a783f7b$export$2d9dc1cf136663b0 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(level){
        super("w:outlineLvl");
        this.level = level;
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: level
        }));
    }
}
class $be59461d4a783f7b$var$PageReferenceFieldInstruction extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(bookmarkId, options = {}){
        super("w:instrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        let instruction = `PAGEREF ${bookmarkId}`;
        if (options.hyperlink) instruction = `${instruction} \\h`;
        if (options.useRelativePosition) instruction = `${instruction} \\p`;
        this.root.push(instruction);
    }
}
class $be59461d4a783f7b$export$d235dfd3d86270a3 extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(bookmarkId, options = {}){
        super({
            children: [
                new $be59461d4a783f7b$var$Begin(true),
                new $be59461d4a783f7b$var$PageReferenceFieldInstruction(bookmarkId, options),
                new $be59461d4a783f7b$var$End()
            ]
        });
    }
}
const $be59461d4a783f7b$export$9a180d3da31cc07f = {
    TOP: "top",
    CENTER: "center",
    BOTTOM: "bottom"
};
const $be59461d4a783f7b$export$35346e57eb27294f = $be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, $be59461d4a783f7b$export$9a180d3da31cc07f), {
    BOTH: "both"
});
const $be59461d4a783f7b$export$cbd1a71eaec89d7d = $be59461d4a783f7b$export$35346e57eb27294f;
class $be59461d4a783f7b$export$f53f51ea6e65c652 extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            verticalAlign: "w:val"
        });
    }
}
class $be59461d4a783f7b$export$a6efa4726c94649f extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:vAlign");
        this.root.push(new $be59461d4a783f7b$export$f53f51ea6e65c652({
            verticalAlign: value
        }));
    }
}
class $be59461d4a783f7b$export$f02cc02ad0e0bba3 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ space: space, count: count, separate: separate, equalWidth: equalWidth, children: children }){
        super("w:cols");
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            space: {
                key: "w:space",
                value: space === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(space)
            },
            count: {
                key: "w:num",
                value: count === void 0 ? void 0 : $be59461d4a783f7b$export$3965b376946dc953(count)
            },
            separate: {
                key: "w:sep",
                value: separate
            },
            equalWidth: {
                key: "w:equalWidth",
                value: equalWidth
            }
        }));
        if (!equalWidth && children) children.forEach((column)=>this.addChildElement(column));
    }
}
const $be59461d4a783f7b$export$4ad510af33d57e8f = {
    /**
   * Specifies that no document grid shall be applied to the contents of the current section in the document.
   */ DEFAULT: "default",
    /**
   * Specifies that the parent section shall have additional line pitch added to each line within it (as specified on the <docGrid> element (§2.6.5)) in order to maintain the specified number of lines per page.
   */ LINES: "lines",
    /**
   * Specifies that the parent section shall have both the additional line pitch and character pitch added to each line and character within it (as specified on the <docGrid> element (§2.6.5)) in order to maintain a specific number of lines per page and characters per line.
   *
   * When this value is set, the input specified via the user interface may be allowed in exact number of line/character pitch units. */ LINES_AND_CHARS: "linesAndChars",
    /**
   * Specifies that the parent section shall have both the additional line pitch and character pitch added to each line and character within it (as specified on the <docGrid> element (§2.6.5)) in order to maintain a specific number of lines per page and characters per line.
   *
   * When this value is set, the input specified via the user interface may be restricted to the number of lines per page and characters per line, with the consumer or producer translating this information based on the current font data to get the resulting line and character pitch values
   */ SNAP_TO_CHARS: "snapToChars"
};
const $be59461d4a783f7b$export$a9632d15c615e0bf = ({ type: type2, linePitch: linePitch, charSpace: charSpace })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:docGrid",
        attributes: {
            type: {
                key: "w:type",
                value: type2
            },
            linePitch: {
                key: "w:linePitch",
                value: $be59461d4a783f7b$export$3965b376946dc953(linePitch)
            },
            charSpace: {
                key: "w:charSpace",
                value: charSpace ? $be59461d4a783f7b$export$3965b376946dc953(charSpace) : void 0
            }
        }
    });
const $be59461d4a783f7b$export$df165515f58460ef = {
    /** Specifies that this header or footer shall appear on every page in this section which is not overridden with a specific `even` or `first` page header/footer. In a section with all three types specified, this type shall be used on all odd numbered pages (counting from the `first` page in the section, not the section numbering). */ DEFAULT: "default",
    /** Specifies that this header or footer shall appear on the first page in this section. The appearance of this header or footer is contingent on the setting of the `titlePg` element (§2.10.6). */ FIRST: "first",
    /** Specifies that this header or footer shall appear on all even numbered pages in this section (counting from the first page in the section, not the section numbering). The appearance of this header or footer is contingent on the setting of the `evenAndOddHeaders` element (§2.10.1). */ EVEN: "even"
};
class $be59461d4a783f7b$var$FooterReferenceAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            type: "w:type",
            id: "r:id"
        });
    }
}
const $be59461d4a783f7b$export$a43a9c8e52ad1cf8 = {
    HEADER: "w:headerReference",
    FOOTER: "w:footerReference"
};
class $be59461d4a783f7b$export$5e9115ca7d433920 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(type2, options){
        super(type2);
        this.root.push(new $be59461d4a783f7b$var$FooterReferenceAttributes({
            type: options.type || $be59461d4a783f7b$export$df165515f58460ef.DEFAULT,
            id: `rId${options.id}`
        }));
    }
}
const $be59461d4a783f7b$export$40c8287995802d41 = {
    /**
   * ## Restart Line Numbering on Each Page
   *
   * Specifies that line numbering for the parent section shall restart to the starting value whenever a new page is displayed.
   */ NEW_PAGE: "newPage",
    /**
   * ## Restart Line Numbering for Each Section
   *
   * Specifies that line numbering for the parent section shall restart to the starting value whenever the parent begins.
   */ NEW_SECTION: "newSection",
    /**
   * ## Continue Line Numbering From Previous Section
   *
   * Specifies that line numbering for the parent section shall continue from the line numbering from the end of the previous section, if any.
   */ CONTINUOUS: "continuous"
};
const $be59461d4a783f7b$export$3484f2bb52b39a49 = ({ countBy: countBy, start: start, restart: restart, distance: distance })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:lnNumType",
        attributes: {
            countBy: {
                key: "w:countBy",
                value: countBy === void 0 ? void 0 : $be59461d4a783f7b$export$3965b376946dc953(countBy)
            },
            start: {
                key: "w:start",
                value: start === void 0 ? void 0 : $be59461d4a783f7b$export$3965b376946dc953(start)
            },
            restart: {
                key: "w:restart",
                value: restart
            },
            distance: {
                key: "w:distance",
                value: distance === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(distance)
            }
        }
    });
const $be59461d4a783f7b$export$8bb308995b75dd36 = {
    ALL_PAGES: "allPages",
    FIRST_PAGE: "firstPage",
    NOT_FIRST_PAGE: "notFirstPage"
};
const $be59461d4a783f7b$export$c9d82c5cfac1c6f = {
    PAGE: "page",
    TEXT: "text"
};
const $be59461d4a783f7b$export$1f518d53a9e51fd8 = {
    BACK: "back",
    FRONT: "front"
};
class $be59461d4a783f7b$var$PageBordersAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            display: "w:display",
            offsetFrom: "w:offsetFrom",
            zOrder: "w:zOrder"
        });
    }
}
class $be59461d4a783f7b$export$de9d08c3f4557a89 extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(options){
        super("w:pgBorders");
        if (!options) return this;
        if (options.pageBorders) this.root.push(new $be59461d4a783f7b$var$PageBordersAttributes({
            display: options.pageBorders.display,
            offsetFrom: options.pageBorders.offsetFrom,
            zOrder: options.pageBorders.zOrder
        }));
        else this.root.push(new $be59461d4a783f7b$var$PageBordersAttributes({}));
        if (options.pageBorderTop) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:top", options.pageBorderTop));
        if (options.pageBorderLeft) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:left", options.pageBorderLeft));
        if (options.pageBorderBottom) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:bottom", options.pageBorderBottom));
        if (options.pageBorderRight) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:right", options.pageBorderRight));
    }
}
class $be59461d4a783f7b$export$c4c7c131dba7ddb8 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(top, right, bottom, left, header, footer, gutter){
        super("w:pgMar");
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            top: {
                key: "w:top",
                value: $be59461d4a783f7b$export$866cabb7ed3455e9(top)
            },
            right: {
                key: "w:right",
                value: $be59461d4a783f7b$export$ffe63bc01ceacb3d(right)
            },
            bottom: {
                key: "w:bottom",
                value: $be59461d4a783f7b$export$866cabb7ed3455e9(bottom)
            },
            left: {
                key: "w:left",
                value: $be59461d4a783f7b$export$ffe63bc01ceacb3d(left)
            },
            header: {
                key: "w:header",
                value: $be59461d4a783f7b$export$ffe63bc01ceacb3d(header)
            },
            footer: {
                key: "w:footer",
                value: $be59461d4a783f7b$export$ffe63bc01ceacb3d(footer)
            },
            gutter: {
                key: "w:gutter",
                value: $be59461d4a783f7b$export$ffe63bc01ceacb3d(gutter)
            }
        }));
    }
}
const $be59461d4a783f7b$export$48aa6fc1cd40b49e = {
    HYPHEN: "hyphen",
    PERIOD: "period",
    COLON: "colon",
    EM_DASH: "emDash",
    EN_DASH: "endash"
};
class $be59461d4a783f7b$export$e3b964361512152d extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            start: "w:start",
            formatType: "w:fmt",
            separator: "w:chapSep"
        });
    }
}
class $be59461d4a783f7b$export$fa056ea14efefec7 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ start: start, formatType: formatType, separator: separator }){
        super("w:pgNumType");
        this.root.push(new $be59461d4a783f7b$export$e3b964361512152d({
            start: start === void 0 ? void 0 : $be59461d4a783f7b$export$3965b376946dc953(start),
            formatType: formatType,
            separator: separator
        }));
    }
}
const $be59461d4a783f7b$export$67acfc4ca0bb516e = {
    /**
   * ## Portrait Mode
   *
   * Specifies that pages in this section shall be printed in portrait mode.
   */ PORTRAIT: "portrait",
    /**
   * ## Landscape Mode
   *
   * Specifies that pages in this section shall be printed in landscape mode, which prints the page contents with a 90 degree rotation with respect to the normal page orientation.
   */ LANDSCAPE: "landscape"
};
const $be59461d4a783f7b$export$ff3bd051879e24ec = ({ width: width, height: height, orientation: orientation, code: code })=>{
    const widthTwips = $be59461d4a783f7b$export$ffe63bc01ceacb3d(width);
    const heightTwips = $be59461d4a783f7b$export$ffe63bc01ceacb3d(height);
    return new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:pgSz",
        attributes: {
            width: {
                key: "w:w",
                value: orientation === $be59461d4a783f7b$export$67acfc4ca0bb516e.LANDSCAPE ? heightTwips : widthTwips
            },
            height: {
                key: "w:h",
                value: orientation === $be59461d4a783f7b$export$67acfc4ca0bb516e.LANDSCAPE ? widthTwips : heightTwips
            },
            orientation: {
                key: "w:orient",
                value: orientation
            },
            code: {
                key: "w:code",
                value: code
            }
        }
    });
};
const $be59461d4a783f7b$export$853e5073bac6becf = {
    LEFT_TO_RIGHT_TOP_TO_BOTTOM: "lrTb",
    TOP_TO_BOTTOM_RIGHT_TO_LEFT: "tbRl"
};
class $be59461d4a783f7b$var$PageTextDirectionAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$export$e7b14932bf37ca00 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:textDirection");
        this.root.push(new $be59461d4a783f7b$var$PageTextDirectionAttributes({
            val: value
        }));
    }
}
const $be59461d4a783f7b$export$baf8ba8b113e8dcf = {
    NEXT_PAGE: "nextPage",
    NEXT_COLUMN: "nextColumn",
    CONTINUOUS: "continuous",
    EVEN_PAGE: "evenPage",
    ODD_PAGE: "oddPage"
};
class $be59461d4a783f7b$export$f0431657ae3c761f extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$export$92738401e1603719 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:type");
        this.root.push(new $be59461d4a783f7b$export$f0431657ae3c761f({
            val: value
        }));
    }
}
const $be59461d4a783f7b$export$e0587973aabf6efb = {
    TOP: 1440,
    RIGHT: 1440,
    BOTTOM: 1440,
    LEFT: 1440,
    HEADER: 708,
    FOOTER: 708,
    GUTTER: 0
};
const $be59461d4a783f7b$export$9cd1a883da4c58e9 = {
    WIDTH: 11906,
    HEIGHT: 16838,
    ORIENTATION: $be59461d4a783f7b$export$67acfc4ca0bb516e.PORTRAIT
};
class $be59461d4a783f7b$export$785f0f5de588d020 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ page: { size: { width: width = $be59461d4a783f7b$export$9cd1a883da4c58e9.WIDTH, height: height = $be59461d4a783f7b$export$9cd1a883da4c58e9.HEIGHT, orientation: orientation = $be59461d4a783f7b$export$9cd1a883da4c58e9.ORIENTATION } = {}, margin: { top: top = $be59461d4a783f7b$export$e0587973aabf6efb.TOP, right: right = $be59461d4a783f7b$export$e0587973aabf6efb.RIGHT, bottom: bottom = $be59461d4a783f7b$export$e0587973aabf6efb.BOTTOM, left: left = $be59461d4a783f7b$export$e0587973aabf6efb.LEFT, header: header = $be59461d4a783f7b$export$e0587973aabf6efb.HEADER, footer: footer = $be59461d4a783f7b$export$e0587973aabf6efb.FOOTER, gutter: gutter = $be59461d4a783f7b$export$e0587973aabf6efb.GUTTER } = {}, pageNumbers: pageNumbers = {}, borders: borders, textDirection: textDirection } = {}, grid: { linePitch: linePitch = 360, charSpace: charSpace, type: gridType } = {}, headerWrapperGroup: headerWrapperGroup = {}, footerWrapperGroup: footerWrapperGroup = {}, lineNumbers: lineNumbers, titlePage: titlePage, verticalAlign: verticalAlign, column: column, type: type2 } = {}){
        super("w:sectPr");
        this.addHeaderFooterGroup($be59461d4a783f7b$export$a43a9c8e52ad1cf8.HEADER, headerWrapperGroup);
        this.addHeaderFooterGroup($be59461d4a783f7b$export$a43a9c8e52ad1cf8.FOOTER, footerWrapperGroup);
        if (type2) this.root.push(new $be59461d4a783f7b$export$92738401e1603719(type2));
        this.root.push($be59461d4a783f7b$export$ff3bd051879e24ec({
            width: width,
            height: height,
            orientation: orientation
        }));
        this.root.push(new $be59461d4a783f7b$export$c4c7c131dba7ddb8(top, right, bottom, left, header, footer, gutter));
        if (borders) this.root.push(new $be59461d4a783f7b$export$de9d08c3f4557a89(borders));
        if (lineNumbers) this.root.push($be59461d4a783f7b$export$3484f2bb52b39a49(lineNumbers));
        this.root.push(new $be59461d4a783f7b$export$fa056ea14efefec7(pageNumbers));
        if (column) this.root.push(new $be59461d4a783f7b$export$f02cc02ad0e0bba3(column));
        if (verticalAlign) this.root.push(new $be59461d4a783f7b$export$a6efa4726c94649f(verticalAlign));
        if (titlePage !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:titlePg", titlePage));
        if (textDirection) this.root.push(new $be59461d4a783f7b$export$e7b14932bf37ca00(textDirection));
        this.root.push($be59461d4a783f7b$export$a9632d15c615e0bf({
            linePitch: linePitch,
            charSpace: charSpace,
            type: gridType
        }));
    }
    addHeaderFooterGroup(type2, group) {
        if (group.default) this.root.push(new $be59461d4a783f7b$export$5e9115ca7d433920(type2, {
            type: $be59461d4a783f7b$export$df165515f58460ef.DEFAULT,
            id: group.default.View.ReferenceId
        }));
        if (group.first) this.root.push(new $be59461d4a783f7b$export$5e9115ca7d433920(type2, {
            type: $be59461d4a783f7b$export$df165515f58460ef.FIRST,
            id: group.first.View.ReferenceId
        }));
        if (group.even) this.root.push(new $be59461d4a783f7b$export$5e9115ca7d433920(type2, {
            type: $be59461d4a783f7b$export$df165515f58460ef.EVEN,
            id: group.even.View.ReferenceId
        }));
    }
}
class $be59461d4a783f7b$export$4b2c32e08f77ff18 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:body");
        // eslint-disable-next-line functional/prefer-readonly-type
        $be59461d4a783f7b$var$__publicField(this, "sections", []);
    }
    /**
   * Adds new section properties.
   * Note: Previous section is created in paragraph after the current element, and then new section will be added.
   * The spec says:
   *  - section element should be in the last paragraph of the section
   *  - last section should be direct child of body
   *
   * @param options new section options
   */ addSection(options) {
        const currentSection = this.sections.pop();
        this.root.push(this.createSectionParagraph(currentSection));
        this.sections.push(new $be59461d4a783f7b$export$785f0f5de588d020(options));
    }
    prepForXml(context) {
        if (this.sections.length === 1) {
            this.root.splice(0, 1);
            this.root.push(this.sections.pop());
        }
        return super.prepForXml(context);
    }
    push(component) {
        this.root.push(component);
    }
    createSectionParagraph(section) {
        const paragraph = new $be59461d4a783f7b$export$358a232cca1ab2ac({});
        const properties = new $be59461d4a783f7b$export$2580ab652a992a27({});
        properties.push(section);
        paragraph.addChildElement(properties);
        return paragraph;
    }
}
class $be59461d4a783f7b$export$816b5d811295e6bc extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ width: width, space: space }){
        super("w:col");
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            width: {
                key: "w:w",
                value: $be59461d4a783f7b$export$ffe63bc01ceacb3d(width)
            },
            space: {
                key: "w:space",
                value: space === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(space)
            }
        }));
    }
}
const $be59461d4a783f7b$export$7379524039920247 = {
    wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
    mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
    o: "urn:schemas-microsoft-com:office:office",
    r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
    v: "urn:schemas-microsoft-com:vml",
    wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
    wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
    w10: "urn:schemas-microsoft-com:office:word",
    w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
    w14: "http://schemas.microsoft.com/office/word/2010/wordml",
    w15: "http://schemas.microsoft.com/office/word/2012/wordml",
    wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
    wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
    wne: "http://schemas.microsoft.com/office/word/2006/wordml",
    wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
    cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
    dc: "http://purl.org/dc/elements/1.1/",
    dcterms: "http://purl.org/dc/terms/",
    dcmitype: "http://purl.org/dc/dcmitype/",
    xsi: "http://www.w3.org/2001/XMLSchema-instance",
    cx: "http://schemas.microsoft.com/office/drawing/2014/chartex",
    cx1: "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
    cx2: "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
    cx3: "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
    cx4: "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
    cx5: "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
    cx6: "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
    cx7: "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
    cx8: "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
    aink: "http://schemas.microsoft.com/office/drawing/2016/ink",
    am3d: "http://schemas.microsoft.com/office/drawing/2017/model3d",
    w16cex: "http://schemas.microsoft.com/office/word/2018/wordml/cex",
    w16cid: "http://schemas.microsoft.com/office/word/2016/wordml/cid",
    w16: "http://schemas.microsoft.com/office/word/2018/wordml",
    w16sdtdh: "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
    w16se: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
};
class $be59461d4a783f7b$export$e2bedb2588efb3f4 extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(ns, Ignorable){
        super($be59461d4a783f7b$var$__spreadValues({
            Ignorable: Ignorable
        }, Object.fromEntries(ns.map((n)=>[
                n,
                $be59461d4a783f7b$export$7379524039920247[n]
            ]))));
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", $be59461d4a783f7b$var$__spreadValues({
            Ignorable: "mc:Ignorable"
        }, Object.fromEntries(Object.keys($be59461d4a783f7b$export$7379524039920247).map((key)=>[
                key,
                `xmlns:${key}`
            ]))));
    }
}
class $be59461d4a783f7b$export$12711c2c2d60b4b5 extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            color: "w:color",
            themeColor: "w:themeColor",
            themeShade: "w:themeShade",
            themeTint: "w:themeTint"
        });
    }
}
class $be59461d4a783f7b$export$a4418effc9bcba0b extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:background");
        this.root.push(new $be59461d4a783f7b$export$12711c2c2d60b4b5({
            color: options.color === void 0 ? void 0 : $be59461d4a783f7b$export$39c9e6e42c794b97(options.color),
            themeColor: options.themeColor,
            themeShade: options.themeShade === void 0 ? void 0 : $be59461d4a783f7b$export$2a22699fe7518b3d(options.themeShade),
            themeTint: options.themeTint === void 0 ? void 0 : $be59461d4a783f7b$export$2a22699fe7518b3d(options.themeTint)
        }));
    }
}
class $be59461d4a783f7b$var$Document extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:document");
        $be59461d4a783f7b$var$__publicField(this, "body");
        this.root.push(new $be59461d4a783f7b$export$e2bedb2588efb3f4([
            "wpc",
            "mc",
            "o",
            "r",
            "m",
            "v",
            "wp14",
            "wp",
            "w10",
            "w",
            "w14",
            "w15",
            "wpg",
            "wpi",
            "wne",
            "wps",
            "cx",
            "cx1",
            "cx2",
            "cx3",
            "cx4",
            "cx5",
            "cx6",
            "cx7",
            "cx8",
            "aink",
            "am3d",
            "w16cex",
            "w16cid",
            "w16",
            "w16sdtdh",
            "w16se"
        ], "w14 w15 wp14"));
        this.body = new $be59461d4a783f7b$export$4b2c32e08f77ff18();
        if (options.background) this.root.push(new $be59461d4a783f7b$export$a4418effc9bcba0b(options.background));
        this.root.push(this.body);
    }
    add(item) {
        this.body.push(item);
        return this;
    }
    get Body() {
        return this.body;
    }
}
class $be59461d4a783f7b$var$DocumentWrapper {
    constructor(options){
        $be59461d4a783f7b$var$__publicField(this, "document");
        $be59461d4a783f7b$var$__publicField(this, "relationships");
        this.document = new $be59461d4a783f7b$var$Document(options);
        this.relationships = new $be59461d4a783f7b$var$Relationships();
    }
    get View() {
        return this.document;
    }
    get Relationships() {
        return this.relationships;
    }
}
class $be59461d4a783f7b$var$WordWrapAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$var$WordWrap extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:wordWrap");
        this.root.push(new $be59461d4a783f7b$var$WordWrapAttributes({
            val: 0
        }));
    }
}
const $be59461d4a783f7b$export$6f1995c5dbac7f91 = {
    NONE: "none",
    DROP: "drop",
    MARGIN: "margin"
};
const $be59461d4a783f7b$export$ba211c2bc275e09c = {
    MARGIN: "margin",
    PAGE: "page",
    TEXT: "text"
};
const $be59461d4a783f7b$export$2d429d33139c34f9 = {
    AROUND: "around",
    AUTO: "auto",
    NONE: "none",
    NOT_BESIDE: "notBeside",
    THROUGH: "through",
    TIGHT: "tight"
};
const $be59461d4a783f7b$export$e1cc76173cf5faa2 = (options)=>{
    var _a, _b;
    return new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:framePr",
        attributes: {
            anchorLock: {
                key: "w:anchorLock",
                value: options.anchorLock
            },
            dropCap: {
                key: "w:dropCap",
                value: options.dropCap
            },
            width: {
                key: "w:w",
                value: options.width
            },
            height: {
                key: "w:h",
                value: options.height
            },
            x: {
                key: "w:x",
                value: options.position ? options.position.x : void 0
            },
            y: {
                key: "w:y",
                value: options.position ? options.position.y : void 0
            },
            anchorHorizontal: {
                key: "w:hAnchor",
                value: options.anchor.horizontal
            },
            anchorVertical: {
                key: "w:vAnchor",
                value: options.anchor.vertical
            },
            spaceHorizontal: {
                key: "w:hSpace",
                value: (_a = options.space) == null ? void 0 : _a.horizontal
            },
            spaceVertical: {
                key: "w:vSpace",
                value: (_b = options.space) == null ? void 0 : _b.vertical
            },
            rule: {
                key: "w:hRule",
                value: options.rule
            },
            alignmentX: {
                key: "w:xAlign",
                value: options.alignment ? options.alignment.x : void 0
            },
            alignmentY: {
                key: "w:yAlign",
                value: options.alignment ? options.alignment.y : void 0
            },
            lines: {
                key: "w:lines",
                value: options.lines
            },
            wrap: {
                key: "w:wrap",
                value: options.wrap
            }
        }
    });
};
class $be59461d4a783f7b$export$2580ab652a992a27 extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(options){
        var _a, _b;
        super("w:pPr");
        // eslint-disable-next-line functional/prefer-readonly-type
        $be59461d4a783f7b$var$__publicField(this, "numberingReferences", []);
        if (!options) return this;
        if (options.heading) this.push(new $be59461d4a783f7b$export$d9e45bc13d335801(options.heading));
        if (options.bullet) this.push(new $be59461d4a783f7b$export$d9e45bc13d335801("ListParagraph"));
        if (options.numbering) {
            if (!options.style && !options.heading) {
                if (!options.numbering.custom) this.push(new $be59461d4a783f7b$export$d9e45bc13d335801("ListParagraph"));
            }
        }
        if (options.style) this.push(new $be59461d4a783f7b$export$d9e45bc13d335801(options.style));
        if (options.keepNext !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:keepNext", options.keepNext));
        if (options.keepLines !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:keepLines", options.keepLines));
        if (options.pageBreakBefore) this.push(new $be59461d4a783f7b$export$f4d23c02e5ffac1a());
        if (options.frame) this.push($be59461d4a783f7b$export$e1cc76173cf5faa2(options.frame));
        if (options.widowControl !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:widowControl", options.widowControl));
        if (options.bullet) this.push(new $be59461d4a783f7b$export$b5d3f7ce2f820092(1, options.bullet.level));
        if (options.numbering) {
            this.numberingReferences.push({
                reference: options.numbering.reference,
                instance: (_a = options.numbering.instance) != null ? _a : 0
            });
            this.push(new $be59461d4a783f7b$export$b5d3f7ce2f820092(`${options.numbering.reference}-${(_b = options.numbering.instance) != null ? _b : 0}`, options.numbering.level));
        } else if (options.numbering === false) this.push(new $be59461d4a783f7b$export$b5d3f7ce2f820092(0, 0));
        if (options.border) this.push(new $be59461d4a783f7b$export$d8e9c9d63e86d41e(options.border));
        if (options.thematicBreak) this.push(new $be59461d4a783f7b$export$ae968d136aefa6fc());
        if (options.shading) this.push(new $be59461d4a783f7b$export$21ac63597b3ebf8e(options.shading));
        if (options.wordWrap) this.push(new $be59461d4a783f7b$var$WordWrap());
        if (options.overflowPunctuation) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:overflowPunct", options.overflowPunctuation));
        const tabDefinitions = [
            ...options.rightTabStop !== void 0 ? [
                {
                    type: $be59461d4a783f7b$export$2effbc422db8f8ed.RIGHT,
                    position: options.rightTabStop
                }
            ] : [],
            ...options.tabStops ? options.tabStops : [],
            ...options.leftTabStop !== void 0 ? [
                {
                    type: $be59461d4a783f7b$export$2effbc422db8f8ed.LEFT,
                    position: options.leftTabStop
                }
            ] : []
        ];
        if (tabDefinitions.length > 0) this.push(new $be59461d4a783f7b$export$639143e2dbee2d0(tabDefinitions));
        if (options.bidirectional !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:bidi", options.bidirectional));
        if (options.spacing) this.push(new $be59461d4a783f7b$export$a39947a896defee6(options.spacing));
        if (options.indent) this.push(new $be59461d4a783f7b$export$e883eb7bc5d8ee6(options.indent));
        if (options.contextualSpacing !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:contextualSpacing", options.contextualSpacing));
        if (options.alignment) this.push(new $be59461d4a783f7b$export$9d7927214ed7d2cf(options.alignment));
        if (options.outlineLevel !== void 0) this.push(new $be59461d4a783f7b$export$2d9dc1cf136663b0(options.outlineLevel));
        if (options.suppressLineNumbers !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:suppressLineNumbers", options.suppressLineNumbers));
        if (options.autoSpaceEastAsianText !== void 0) this.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:autoSpaceDN", options.autoSpaceEastAsianText));
        if (options.run) this.push(new $be59461d4a783f7b$export$5ae5540473946c91(options.run));
    }
    push(item) {
        this.root.push(item);
    }
    prepForXml(context) {
        if (context.viewWrapper instanceof $be59461d4a783f7b$var$DocumentWrapper) for (const reference of this.numberingReferences)context.file.Numbering.createConcreteNumberingInstance(reference.reference, reference.instance);
        return super.prepForXml(context);
    }
}
class $be59461d4a783f7b$export$358a232cca1ab2ac extends $be59461d4a783f7b$export$5b43359c04ff37a0 {
    constructor(options){
        super("w:p");
        $be59461d4a783f7b$var$__publicField(this, "properties");
        if (typeof options === "string") {
            this.properties = new $be59461d4a783f7b$export$2580ab652a992a27({});
            this.root.push(this.properties);
            this.root.push(new $be59461d4a783f7b$export$84d920a4f7ee9ae2(options));
            return this;
        }
        this.properties = new $be59461d4a783f7b$export$2580ab652a992a27(options);
        this.root.push(this.properties);
        if (options.text) this.root.push(new $be59461d4a783f7b$export$84d920a4f7ee9ae2(options.text));
        if (options.children) for (const child of options.children){
            if (child instanceof $be59461d4a783f7b$export$301ef70c5c7bdf65) {
                this.root.push(child.start);
                for (const textRun of child.children)this.root.push(textRun);
                this.root.push(child.end);
                continue;
            }
            this.root.push(child);
        }
    }
    prepForXml(context) {
        for (const element of this.root)if (element instanceof $be59461d4a783f7b$export$6ea6a3f0b2b263f3) {
            const index = this.root.indexOf(element);
            const concreteHyperlink = new $be59461d4a783f7b$export$6beda279b4a51476(element.options.children, $be59461d4a783f7b$export$8b15d37bc3f197d4());
            context.viewWrapper.Relationships.createRelationship(concreteHyperlink.linkId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", element.options.link, $be59461d4a783f7b$var$TargetModeType.EXTERNAL);
            this.root[index] = concreteHyperlink;
        }
        return super.prepForXml(context);
    }
    addRunToFront(run) {
        this.root.splice(1, 0, run);
        return this;
    }
}
let $be59461d4a783f7b$export$380958644dbbc22b = class Math2 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:oMath");
        for (const child of options.children)this.root.push(child);
    }
};
class $be59461d4a783f7b$var$MathText extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(text){
        super("m:t");
        this.root.push(text);
    }
}
class $be59461d4a783f7b$export$90dfc67d0f4dd34b extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(text){
        super("m:r");
        this.root.push(new $be59461d4a783f7b$var$MathText(text));
    }
}
class $be59461d4a783f7b$export$ff6b7d5a5a81866e extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(children){
        super("m:den");
        for (const child of children)this.root.push(child);
    }
}
class $be59461d4a783f7b$export$99cac471ef125c11 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(children){
        super("m:num");
        for (const child of children)this.root.push(child);
    }
}
class $be59461d4a783f7b$export$4733894f11785949 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:f");
        this.root.push(new $be59461d4a783f7b$export$99cac471ef125c11(options.numerator));
        this.root.push(new $be59461d4a783f7b$export$ff6b7d5a5a81866e(options.denominator));
    }
}
const $be59461d4a783f7b$export$d0daf58c4817cb7f = ({ accent: accent })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:chr",
        attributes: {
            accent: {
                key: "m:val",
                value: accent
            }
        }
    });
const $be59461d4a783f7b$export$7896e74cf40943d3 = ({ children: children })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:e",
        children: children
    });
const $be59461d4a783f7b$export$cbf667cdc8eb5775 = ({ value: value })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:limLoc",
        attributes: {
            value: {
                key: "m:val",
                value: value || "undOvr"
            }
        }
    });
const $be59461d4a783f7b$var$createMathSubScriptHide = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:subHide",
        attributes: {
            hide: {
                key: "m:val",
                value: 1
            }
        }
    });
const $be59461d4a783f7b$var$createMathSuperScriptHide = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:supHide",
        attributes: {
            hide: {
                key: "m:val",
                value: 1
            }
        }
    });
const $be59461d4a783f7b$export$6f13c1099e0feacf = ({ accent: accent, hasSuperScript: hasSuperScript, hasSubScript: hasSubScript, limitLocationVal: limitLocationVal })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:naryPr",
        children: [
            ...!!accent ? [
                $be59461d4a783f7b$export$d0daf58c4817cb7f({
                    accent: accent
                })
            ] : [],
            $be59461d4a783f7b$export$cbf667cdc8eb5775({
                value: limitLocationVal
            }),
            ...!hasSuperScript ? [
                $be59461d4a783f7b$var$createMathSuperScriptHide()
            ] : [],
            ...!hasSubScript ? [
                $be59461d4a783f7b$var$createMathSubScriptHide()
            ] : []
        ]
    });
const $be59461d4a783f7b$export$c6f9aff0d7d6e6ff = ({ children: children })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:sub",
        children: children
    });
const $be59461d4a783f7b$export$76baebf9a2f6b172 = ({ children: children })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:sup",
        children: children
    });
class $be59461d4a783f7b$export$fdc132f2f50726bf extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:nary");
        this.root.push($be59461d4a783f7b$export$6f13c1099e0feacf({
            accent: "\u2211",
            hasSuperScript: !!options.superScript,
            hasSubScript: !!options.subScript
        }));
        if (!!options.subScript) this.root.push($be59461d4a783f7b$export$c6f9aff0d7d6e6ff({
            children: options.subScript
        }));
        if (!!options.superScript) this.root.push($be59461d4a783f7b$export$76baebf9a2f6b172({
            children: options.superScript
        }));
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
    }
}
class $be59461d4a783f7b$export$284571621872e60b extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:nary");
        this.root.push($be59461d4a783f7b$export$6f13c1099e0feacf({
            accent: "",
            hasSuperScript: !!options.superScript,
            hasSubScript: !!options.subScript,
            limitLocationVal: "subSup"
        }));
        if (!!options.subScript) this.root.push($be59461d4a783f7b$export$c6f9aff0d7d6e6ff({
            children: options.subScript
        }));
        if (!!options.superScript) this.root.push($be59461d4a783f7b$export$76baebf9a2f6b172({
            children: options.superScript
        }));
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
    }
}
class $be59461d4a783f7b$export$11dfa8b406d6277 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(children){
        super("m:lim");
        for (const child of children)this.root.push(child);
    }
}
class $be59461d4a783f7b$export$509e21df53f9ba2d extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:limUpp");
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
        this.root.push(new $be59461d4a783f7b$export$11dfa8b406d6277(options.limit));
    }
}
class $be59461d4a783f7b$export$9bf2e5be4e9c5811 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:limLow");
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
        this.root.push(new $be59461d4a783f7b$export$11dfa8b406d6277(options.limit));
    }
}
const $be59461d4a783f7b$export$f14ce960f89e1420 = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:sSupPr"
    });
class $be59461d4a783f7b$export$4841c07b5c4540ae extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:sSup");
        this.root.push($be59461d4a783f7b$export$f14ce960f89e1420());
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
        this.root.push($be59461d4a783f7b$export$76baebf9a2f6b172({
            children: options.superScript
        }));
    }
}
const $be59461d4a783f7b$export$c94f5ccbb71fbaa = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:sSubPr"
    });
class $be59461d4a783f7b$export$6c9d9f8e0a9a0050 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:sSub");
        this.root.push($be59461d4a783f7b$export$c94f5ccbb71fbaa());
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
        this.root.push($be59461d4a783f7b$export$c6f9aff0d7d6e6ff({
            children: options.subScript
        }));
    }
}
const $be59461d4a783f7b$export$3d2a42d693dccc5a = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:sSubSupPr"
    });
class $be59461d4a783f7b$export$b65c9d7e29726d90 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:sSubSup");
        this.root.push($be59461d4a783f7b$export$3d2a42d693dccc5a());
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
        this.root.push($be59461d4a783f7b$export$c6f9aff0d7d6e6ff({
            children: options.subScript
        }));
        this.root.push($be59461d4a783f7b$export$76baebf9a2f6b172({
            children: options.superScript
        }));
    }
}
const $be59461d4a783f7b$export$e5caf28a75a3b58 = ()=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:sPrePr"
    });
class $be59461d4a783f7b$export$6a6b66354165e5d9 extends $be59461d4a783f7b$export$da493cbe1334accc {
    constructor({ children: children, subScript: subScript, superScript: superScript }){
        super({
            name: "m:sPre",
            children: [
                $be59461d4a783f7b$export$e5caf28a75a3b58(),
                $be59461d4a783f7b$export$7896e74cf40943d3({
                    children: children
                }),
                $be59461d4a783f7b$export$c6f9aff0d7d6e6ff({
                    children: subScript
                }),
                $be59461d4a783f7b$export$76baebf9a2f6b172({
                    children: superScript
                })
            ]
        });
    }
}
const $be59461d4a783f7b$export$188277a33510f07b = "";
class $be59461d4a783f7b$export$40049e2a10faefc0 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(children){
        super("m:deg");
        if (!!children) for (const child of children)this.root.push(child);
    }
}
class $be59461d4a783f7b$var$MathDegreeHideAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            hide: "m:val"
        });
    }
}
class $be59461d4a783f7b$var$MathDegreeHide extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("m:degHide");
        this.root.push(new $be59461d4a783f7b$var$MathDegreeHideAttributes({
            hide: 1
        }));
    }
}
class $be59461d4a783f7b$export$428abb7ebef50ed3 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(hasDegree){
        super("m:radPr");
        if (!hasDegree) this.root.push(new $be59461d4a783f7b$var$MathDegreeHide());
    }
}
class $be59461d4a783f7b$export$26950747f72b19b4 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:rad");
        this.root.push(new $be59461d4a783f7b$export$428abb7ebef50ed3(!!options.degree));
        this.root.push(new $be59461d4a783f7b$export$40049e2a10faefc0(options.degree));
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
    }
}
class $be59461d4a783f7b$export$9d22093c8a5af07c extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(children){
        super("m:fName");
        for (const child of children)this.root.push(child);
    }
}
class $be59461d4a783f7b$export$2639caa68c82d30c extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("m:funcPr");
    }
}
class $be59461d4a783f7b$export$f46dd3ee437ba7d2 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:func");
        this.root.push(new $be59461d4a783f7b$export$2639caa68c82d30c());
        this.root.push(new $be59461d4a783f7b$export$9d22093c8a5af07c(options.name));
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
    }
}
const $be59461d4a783f7b$var$createMathBeginningCharacter = ({ character: character })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:begChr",
        attributes: {
            character: {
                key: "m:val",
                value: character
            }
        }
    });
const $be59461d4a783f7b$var$createMathEndingCharacter = ({ character: character })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:endChr",
        attributes: {
            character: {
                key: "m:val",
                value: character
            }
        }
    });
const $be59461d4a783f7b$var$createMathBracketProperties = ({ characters: characters })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "m:dPr",
        children: !!characters ? [
            $be59461d4a783f7b$var$createMathBeginningCharacter({
                character: characters.beginningCharacter
            }),
            $be59461d4a783f7b$var$createMathEndingCharacter({
                character: characters.endingCharacter
            })
        ] : []
    });
class $be59461d4a783f7b$export$8f0bc5351033327c extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:d");
        this.root.push($be59461d4a783f7b$var$createMathBracketProperties({}));
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
    }
}
class $be59461d4a783f7b$export$368e49b3c2c4bceb extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:d");
        this.root.push($be59461d4a783f7b$var$createMathBracketProperties({
            characters: {
                beginningCharacter: "[",
                endingCharacter: "]"
            }
        }));
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
    }
}
class $be59461d4a783f7b$export$c7412ca3c2c2fc72 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:d");
        this.root.push($be59461d4a783f7b$var$createMathBracketProperties({
            characters: {
                beginningCharacter: "{",
                endingCharacter: "}"
            }
        }));
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
    }
}
class $be59461d4a783f7b$export$7bc6cec92819f63a extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("m:d");
        this.root.push($be59461d4a783f7b$var$createMathBracketProperties({
            characters: {
                beginningCharacter: "\u2329",
                endingCharacter: "\u232A"
            }
        }));
        this.root.push($be59461d4a783f7b$export$7896e74cf40943d3({
            children: options.children
        }));
    }
}
class $be59461d4a783f7b$var$TableGrid extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(widths){
        super("w:tblGrid");
        for (const width of widths)this.root.push(new $be59461d4a783f7b$var$GridCol(width));
    }
}
class $be59461d4a783f7b$var$GridCol extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(width){
        super("w:gridCol");
        if (width !== void 0) this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            width: {
                key: "w:w",
                value: $be59461d4a783f7b$export$ffe63bc01ceacb3d(width)
            }
        }));
    }
}
const $be59461d4a783f7b$var$TableCellMarginElementType = {
    TABLE: "w:tblCellMar",
    TABLE_CELL: "w:tcMar"
};
class $be59461d4a783f7b$var$TableCellMargin extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(type2, { marginUnitType: marginUnitType = $be59461d4a783f7b$export$4d41558722ac7eed.DXA, top: top, left: left, bottom: bottom, right: right }){
        super(type2);
        if (top !== void 0) this.root.push(new $be59461d4a783f7b$export$691ad35ca26919d6("w:top", {
            type: marginUnitType,
            size: top
        }));
        if (left !== void 0) this.root.push(new $be59461d4a783f7b$export$691ad35ca26919d6("w:left", {
            type: marginUnitType,
            size: left
        }));
        if (bottom !== void 0) this.root.push(new $be59461d4a783f7b$export$691ad35ca26919d6("w:bottom", {
            type: marginUnitType,
            size: bottom
        }));
        if (right !== void 0) this.root.push(new $be59461d4a783f7b$export$691ad35ca26919d6("w:right", {
            type: marginUnitType,
            size: right
        }));
    }
}
const $be59461d4a783f7b$export$4d41558722ac7eed = {
    /** Auto. */ AUTO: "auto",
    /** Value is in twentieths of a point */ DXA: "dxa",
    /** No (empty) value. */ NIL: "nil",
    /** Value is in percentage. */ PERCENTAGE: "pct"
};
class $be59461d4a783f7b$export$691ad35ca26919d6 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name, { type: type2 = $be59461d4a783f7b$export$4d41558722ac7eed.AUTO, size: size }){
        super(name);
        let tableWidthValue = size;
        if (type2 === $be59461d4a783f7b$export$4d41558722ac7eed.PERCENTAGE && typeof size === "number") tableWidthValue = `${size}%`;
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            type: {
                key: "w:type",
                value: type2
            },
            size: {
                key: "w:w",
                value: $be59461d4a783f7b$export$cb4dd365b0fd654b(tableWidthValue)
            }
        }));
    }
}
class $be59461d4a783f7b$export$a3702afe8c903878 extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(options){
        super("w:tcBorders");
        if (options.top) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:top", options.top));
        if (options.start) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:start", options.start));
        if (options.left) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:left", options.left));
        if (options.bottom) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:bottom", options.bottom));
        if (options.end) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:end", options.end));
        if (options.right) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:right", options.right));
    }
}
class $be59461d4a783f7b$var$GridSpanAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$export$6cde27bc1b78afe7 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:gridSpan");
        this.root.push(new $be59461d4a783f7b$var$GridSpanAttributes({
            val: $be59461d4a783f7b$export$3965b376946dc953(value)
        }));
    }
}
const $be59461d4a783f7b$export$ba6d52537e3f9b56 = {
    /**
   * Cell that is merged with upper one.
   */ CONTINUE: "continue",
    /**
   * Cell that is starting the vertical merge.
   */ RESTART: "restart"
};
class $be59461d4a783f7b$var$VerticalMergeAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$export$ef0dbc2e8af92c85 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:vMerge");
        this.root.push(new $be59461d4a783f7b$var$VerticalMergeAttributes({
            val: value
        }));
    }
}
const $be59461d4a783f7b$export$63e1cbbb2c6e2c2 = {
    BOTTOM_TO_TOP_LEFT_TO_RIGHT: "btLr",
    LEFT_TO_RIGHT_TOP_TO_BOTTOM: "lrTb",
    TOP_TO_BOTTOM_RIGHT_TO_LEFT: "tbRl"
};
class $be59461d4a783f7b$var$TDirectionAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$export$ced1d73164c0b0e5 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:textDirection");
        this.root.push(new $be59461d4a783f7b$var$TDirectionAttributes({
            val: value
        }));
    }
}
class $be59461d4a783f7b$var$TableCellProperties extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(options){
        super("w:tcPr");
        if (options.width) this.root.push(new $be59461d4a783f7b$export$691ad35ca26919d6("w:tcW", options.width));
        if (options.columnSpan) this.root.push(new $be59461d4a783f7b$export$6cde27bc1b78afe7(options.columnSpan));
        if (options.verticalMerge) this.root.push(new $be59461d4a783f7b$export$ef0dbc2e8af92c85(options.verticalMerge));
        else if (options.rowSpan && options.rowSpan > 1) this.root.push(new $be59461d4a783f7b$export$ef0dbc2e8af92c85($be59461d4a783f7b$export$ba6d52537e3f9b56.RESTART));
        if (options.borders) this.root.push(new $be59461d4a783f7b$export$a3702afe8c903878(options.borders));
        if (options.shading) this.root.push(new $be59461d4a783f7b$export$21ac63597b3ebf8e(options.shading));
        if (options.margins) this.root.push(new $be59461d4a783f7b$var$TableCellMargin($be59461d4a783f7b$var$TableCellMarginElementType.TABLE_CELL, options.margins));
        if (options.textDirection) this.root.push(new $be59461d4a783f7b$export$ced1d73164c0b0e5(options.textDirection));
        if (options.verticalAlign) this.root.push(new $be59461d4a783f7b$export$a6efa4726c94649f(options.verticalAlign));
    }
}
class $be59461d4a783f7b$export$1e4baea7053fc0e3 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:tc");
        this.options = options;
        this.root.push(new $be59461d4a783f7b$var$TableCellProperties(options));
        for (const child of options.children)this.root.push(child);
    }
    prepForXml(context) {
        if (!(this.root[this.root.length - 1] instanceof $be59461d4a783f7b$export$358a232cca1ab2ac)) this.root.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({}));
        return super.prepForXml(context);
    }
}
const $be59461d4a783f7b$var$NONE_BORDER = {
    style: $be59461d4a783f7b$export$5f9c7f3ab6d185b.NONE,
    size: 0,
    color: "auto"
};
const $be59461d4a783f7b$var$DEFAULT_BORDER = {
    style: $be59461d4a783f7b$export$5f9c7f3ab6d185b.SINGLE,
    size: 4,
    color: "auto"
};
class $be59461d4a783f7b$export$5433bd36edb7bb1 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:tblBorders");
        if (options.top) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:top", options.top));
        else this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:top", $be59461d4a783f7b$var$DEFAULT_BORDER));
        if (options.left) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:left", options.left));
        else this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:left", $be59461d4a783f7b$var$DEFAULT_BORDER));
        if (options.bottom) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:bottom", options.bottom));
        else this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:bottom", $be59461d4a783f7b$var$DEFAULT_BORDER));
        if (options.right) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:right", options.right));
        else this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:right", $be59461d4a783f7b$var$DEFAULT_BORDER));
        if (options.insideHorizontal) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:insideH", options.insideHorizontal));
        else this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:insideH", $be59461d4a783f7b$var$DEFAULT_BORDER));
        if (options.insideVertical) this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:insideV", options.insideVertical));
        else this.root.push(new $be59461d4a783f7b$export$a6733098a4eb57cf("w:insideV", $be59461d4a783f7b$var$DEFAULT_BORDER));
    }
}
$be59461d4a783f7b$var$__publicField($be59461d4a783f7b$export$5433bd36edb7bb1, "NONE", {
    top: $be59461d4a783f7b$var$NONE_BORDER,
    bottom: $be59461d4a783f7b$var$NONE_BORDER,
    left: $be59461d4a783f7b$var$NONE_BORDER,
    right: $be59461d4a783f7b$var$NONE_BORDER,
    insideHorizontal: $be59461d4a783f7b$var$NONE_BORDER,
    insideVertical: $be59461d4a783f7b$var$NONE_BORDER
});
const $be59461d4a783f7b$export$f92b8391c5df40cb = {
    MARGIN: "margin",
    PAGE: "page",
    TEXT: "text"
};
const $be59461d4a783f7b$export$c25e228331ab29ba = {
    CENTER: "center",
    INSIDE: "inside",
    LEFT: "left",
    OUTSIDE: "outside",
    RIGHT: "right"
};
const $be59461d4a783f7b$export$6c91432b7690e7dd = {
    CENTER: "center",
    INSIDE: "inside",
    BOTTOM: "bottom",
    OUTSIDE: "outside",
    INLINE: "inline",
    TOP: "top"
};
const $be59461d4a783f7b$export$ae9f0393a3d86f0c = {
    NEVER: "never",
    OVERLAP: "overlap"
};
class $be59461d4a783f7b$export$c7f5805bc6840420 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ horizontalAnchor: horizontalAnchor, verticalAnchor: verticalAnchor, absoluteHorizontalPosition: absoluteHorizontalPosition, relativeHorizontalPosition: relativeHorizontalPosition, absoluteVerticalPosition: absoluteVerticalPosition, relativeVerticalPosition: relativeVerticalPosition, bottomFromText: bottomFromText, topFromText: topFromText, leftFromText: leftFromText, rightFromText: rightFromText, overlap: overlap }){
        super("w:tblpPr");
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            leftFromText: {
                key: "w:leftFromText",
                value: leftFromText === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(leftFromText)
            },
            rightFromText: {
                key: "w:rightFromText",
                value: rightFromText === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(rightFromText)
            },
            topFromText: {
                key: "w:topFromText",
                value: topFromText === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(topFromText)
            },
            bottomFromText: {
                key: "w:bottomFromText",
                value: bottomFromText === void 0 ? void 0 : $be59461d4a783f7b$export$ffe63bc01ceacb3d(bottomFromText)
            },
            absoluteHorizontalPosition: {
                key: "w:tblpX",
                value: absoluteHorizontalPosition === void 0 ? void 0 : $be59461d4a783f7b$export$866cabb7ed3455e9(absoluteHorizontalPosition)
            },
            absoluteVerticalPosition: {
                key: "w:tblpY",
                value: absoluteVerticalPosition === void 0 ? void 0 : $be59461d4a783f7b$export$866cabb7ed3455e9(absoluteVerticalPosition)
            },
            horizontalAnchor: {
                key: "w:horzAnchor",
                value: horizontalAnchor === void 0 ? void 0 : horizontalAnchor
            },
            relativeHorizontalPosition: {
                key: "w:tblpXSpec",
                value: relativeHorizontalPosition
            },
            relativeVerticalPosition: {
                key: "w:tblpYSpec",
                value: relativeVerticalPosition
            },
            verticalAnchor: {
                key: "w:vertAnchor",
                value: verticalAnchor
            }
        }));
        if (overlap) this.root.push(new $be59461d4a783f7b$export$5616f64bff69d2("w:tblOverlap", overlap));
    }
}
const $be59461d4a783f7b$export$b86104a70e212fe1 = {
    AUTOFIT: "autofit",
    FIXED: "fixed"
};
class $be59461d4a783f7b$var$TableLayoutAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            type: "w:type"
        });
    }
}
class $be59461d4a783f7b$export$62444c3c724b1b20 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(type2){
        super("w:tblLayout");
        this.root.push(new $be59461d4a783f7b$var$TableLayoutAttributes({
            type: type2
        }));
    }
}
const $be59461d4a783f7b$var$CellSpacingType = {
    /** Value is in twentieths of a point */ DXA: "dxa"
};
class $be59461d4a783f7b$var$TableCellSpacingElement extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ type: type2 = $be59461d4a783f7b$var$CellSpacingType.DXA, value: value }){
        super("w:tblCellSpacing");
        this.root.push(new $be59461d4a783f7b$export$b95d92bd70e2302a({
            type: {
                key: "w:type",
                value: type2
            },
            value: {
                key: "w:w",
                value: $be59461d4a783f7b$export$cb4dd365b0fd654b(value)
            }
        }));
    }
}
class $be59461d4a783f7b$export$6dad081acd6c9224 extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(options){
        super("w:tblPr");
        if (options.style) this.root.push(new $be59461d4a783f7b$export$eacbde36aa74068("w:tblStyle", options.style));
        if (options.float) this.root.push(new $be59461d4a783f7b$export$c7f5805bc6840420(options.float));
        if (options.visuallyRightToLeft !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:bidiVisual", options.visuallyRightToLeft));
        if (options.width) this.root.push(new $be59461d4a783f7b$export$691ad35ca26919d6("w:tblW", options.width));
        if (options.alignment) this.root.push(new $be59461d4a783f7b$export$9d7927214ed7d2cf(options.alignment));
        if (options.indent) this.root.push(new $be59461d4a783f7b$export$691ad35ca26919d6("w:tblInd", options.indent));
        if (options.borders) this.root.push(new $be59461d4a783f7b$export$5433bd36edb7bb1(options.borders));
        if (options.shading) this.root.push(new $be59461d4a783f7b$export$21ac63597b3ebf8e(options.shading));
        if (options.layout) this.root.push(new $be59461d4a783f7b$export$62444c3c724b1b20(options.layout));
        if (options.cellMargin) this.root.push(new $be59461d4a783f7b$var$TableCellMargin($be59461d4a783f7b$var$TableCellMarginElementType.TABLE, options.cellMargin));
        if (options.cellSpacing) this.root.push(new $be59461d4a783f7b$var$TableCellSpacingElement(options.cellSpacing));
    }
}
class $be59461d4a783f7b$export$54ec01a60f47d33d extends $be59461d4a783f7b$export$5b43359c04ff37a0 {
    constructor({ rows: rows, width: width, columnWidths: // eslint-disable-next-line functional/immutable-data
    columnWidths = Array(Math.max(...rows.map((row)=>row.CellCount))).fill(100), margins: margins, indent: indent, float: float, layout: layout, style: style, borders: borders, alignment: alignment, visuallyRightToLeft: visuallyRightToLeft, cellSpacing: cellSpacing }){
        super("w:tbl");
        this.root.push(new $be59461d4a783f7b$export$6dad081acd6c9224({
            borders: borders != null ? borders : {},
            width: width != null ? width : {
                size: 100
            },
            indent: indent,
            float: float,
            layout: layout,
            style: style,
            alignment: alignment,
            cellMargin: margins,
            visuallyRightToLeft: visuallyRightToLeft,
            cellSpacing: cellSpacing
        }));
        this.root.push(new $be59461d4a783f7b$var$TableGrid(columnWidths));
        for (const row of rows)this.root.push(row);
        rows.forEach((row, rowIndex)=>{
            if (rowIndex === rows.length - 1) return;
            let columnIndex = 0;
            row.cells.forEach((cell)=>{
                if (cell.options.rowSpan && cell.options.rowSpan > 1) {
                    const continueCell = new $be59461d4a783f7b$export$1e4baea7053fc0e3({
                        // the inserted CONTINUE cell has rowSpan, and will be handled when process the next row
                        rowSpan: cell.options.rowSpan - 1,
                        columnSpan: cell.options.columnSpan,
                        borders: cell.options.borders,
                        children: [],
                        verticalMerge: $be59461d4a783f7b$export$ba6d52537e3f9b56.CONTINUE
                    });
                    rows[rowIndex + 1].addCellToColumnIndex(continueCell, columnIndex);
                }
                columnIndex += cell.options.columnSpan || 1;
            });
        });
    }
}
const $be59461d4a783f7b$export$f6b000a26dc0329c = {
    /** Height is determined based on the content, so value is ignored. */ AUTO: "auto",
    /** At least the value specified */ ATLEAST: "atLeast",
    /** Exactly the value specified */ EXACT: "exact"
};
class $be59461d4a783f7b$export$891ad127202c0bd2 extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            value: "w:val",
            rule: "w:hRule"
        });
    }
}
class $be59461d4a783f7b$export$5ebfe399c7544ece extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value, rule){
        super("w:trHeight");
        this.root.push(new $be59461d4a783f7b$export$891ad127202c0bd2({
            value: $be59461d4a783f7b$export$ffe63bc01ceacb3d(value),
            rule: rule
        }));
    }
}
class $be59461d4a783f7b$export$bc525f85d0e260b3 extends $be59461d4a783f7b$export$951524d865ce655a {
    constructor(options){
        super("w:trPr");
        if (options.cantSplit !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:cantSplit", options.cantSplit));
        if (options.tableHeader !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:tblHeader", options.tableHeader));
        if (options.height) this.root.push(new $be59461d4a783f7b$export$5ebfe399c7544ece(options.height.value, options.height.rule));
        if (options.cellSpacing) this.root.push(new $be59461d4a783f7b$var$TableCellSpacingElement(options.cellSpacing));
    }
}
class $be59461d4a783f7b$export$b05581f4e764e162 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:tr");
        this.options = options;
        this.root.push(new $be59461d4a783f7b$export$bc525f85d0e260b3(options));
        for (const child of options.children)this.root.push(child);
    }
    get CellCount() {
        return this.options.children.length;
    }
    get cells() {
        return this.root.filter((xmlComponent)=>xmlComponent instanceof $be59461d4a783f7b$export$1e4baea7053fc0e3);
    }
    addCellToIndex(cell, index) {
        this.root.splice(index + 1, 0, cell);
    }
    addCellToColumnIndex(cell, columnIndex) {
        const rootIndex = this.columnIndexToRootIndex(columnIndex, true);
        this.addCellToIndex(cell, rootIndex - 1);
    }
    rootIndexToColumnIndex(rootIndex) {
        if (rootIndex < 1 || rootIndex >= this.root.length) throw new Error(`cell 'rootIndex' should between 1 to ${this.root.length - 1}`);
        let colIdx = 0;
        for(let rootIdx = 1; rootIdx < rootIndex; rootIdx++){
            const cell = this.root[rootIdx];
            colIdx += cell.options.columnSpan || 1;
        }
        return colIdx;
    }
    columnIndexToRootIndex(columnIndex, allowEndNewCell = false) {
        if (columnIndex < 0) throw new Error(`cell 'columnIndex' should not less than zero`);
        let colIdx = 0;
        let rootIdx = 1;
        while(colIdx <= columnIndex){
            if (rootIdx >= this.root.length) {
                if (allowEndNewCell) return this.root.length;
                else throw new Error(`cell 'columnIndex' should not great than ${colIdx - 1}`);
            }
            const cell = this.root[rootIdx];
            rootIdx += 1;
            colIdx += cell && cell.options.columnSpan || 1;
        }
        return rootIdx - 1;
    }
}
class $be59461d4a783f7b$var$AppPropertiesAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            xmlns: "xmlns",
            vt: "xmlns:vt"
        });
    }
}
class $be59461d4a783f7b$var$AppProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("Properties");
        this.root.push(new $be59461d4a783f7b$var$AppPropertiesAttributes({
            xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
            vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
        }));
    }
}
class $be59461d4a783f7b$var$ContentTypeAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            xmlns: "xmlns"
        });
    }
}
class $be59461d4a783f7b$var$DefaultAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            contentType: "ContentType",
            extension: "Extension"
        });
    }
}
class $be59461d4a783f7b$var$Default extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(contentType, extension){
        super("Default");
        this.root.push(new $be59461d4a783f7b$var$DefaultAttributes({
            contentType: contentType,
            extension: extension
        }));
    }
}
class $be59461d4a783f7b$var$OverrideAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            contentType: "ContentType",
            partName: "PartName"
        });
    }
}
class $be59461d4a783f7b$var$Override extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(contentType, partName){
        super("Override");
        this.root.push(new $be59461d4a783f7b$var$OverrideAttributes({
            contentType: contentType,
            partName: partName
        }));
    }
}
class $be59461d4a783f7b$var$ContentTypes extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("Types");
        this.root.push(new $be59461d4a783f7b$var$ContentTypeAttributes({
            xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
        }));
        this.root.push(new $be59461d4a783f7b$var$Default("image/png", "png"));
        this.root.push(new $be59461d4a783f7b$var$Default("image/jpeg", "jpeg"));
        this.root.push(new $be59461d4a783f7b$var$Default("image/jpeg", "jpg"));
        this.root.push(new $be59461d4a783f7b$var$Default("image/bmp", "bmp"));
        this.root.push(new $be59461d4a783f7b$var$Default("image/gif", "gif"));
        this.root.push(new $be59461d4a783f7b$var$Default("image/svg+xml", "svg"));
        this.root.push(new $be59461d4a783f7b$var$Default("application/vnd.openxmlformats-package.relationships+xml", "rels"));
        this.root.push(new $be59461d4a783f7b$var$Default("application/xml", "xml"));
        this.root.push(new $be59461d4a783f7b$var$Default("application/vnd.openxmlformats-officedocument.obfuscatedFont", "odttf"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml", "/word/document.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml", "/word/styles.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-package.core-properties+xml", "/docProps/core.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.custom-properties+xml", "/docProps/custom.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.extended-properties+xml", "/docProps/app.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml", "/word/numbering.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml", "/word/footnotes.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml", "/word/settings.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml", "/word/comments.xml"));
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.fontTable+xml", "/word/fontTable.xml"));
    }
    addFooter(index) {
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml", `/word/footer${index}.xml`));
    }
    addHeader(index) {
        this.root.push(new $be59461d4a783f7b$var$Override("application/vnd.openxmlformats-officedocument.wordprocessingml.header+xml", `/word/header${index}.xml`));
    }
}
class $be59461d4a783f7b$var$CoreProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("cp:coreProperties");
        this.root.push(new $be59461d4a783f7b$export$e2bedb2588efb3f4([
            "cp",
            "dc",
            "dcterms",
            "dcmitype",
            "xsi"
        ]));
        if (options.title) this.root.push(new $be59461d4a783f7b$export$5ef82a33e5d8976f("dc:title", options.title));
        if (options.subject) this.root.push(new $be59461d4a783f7b$export$5ef82a33e5d8976f("dc:subject", options.subject));
        if (options.creator) this.root.push(new $be59461d4a783f7b$export$5ef82a33e5d8976f("dc:creator", options.creator));
        if (options.keywords) this.root.push(new $be59461d4a783f7b$export$5ef82a33e5d8976f("cp:keywords", options.keywords));
        if (options.description) this.root.push(new $be59461d4a783f7b$export$5ef82a33e5d8976f("dc:description", options.description));
        if (options.lastModifiedBy) this.root.push(new $be59461d4a783f7b$export$5ef82a33e5d8976f("cp:lastModifiedBy", options.lastModifiedBy));
        if (options.revision) this.root.push(new $be59461d4a783f7b$export$5ef82a33e5d8976f("cp:revision", String(options.revision)));
        this.root.push(new $be59461d4a783f7b$var$TimestampElement("dcterms:created"));
        this.root.push(new $be59461d4a783f7b$var$TimestampElement("dcterms:modified"));
    }
}
class $be59461d4a783f7b$var$TimestampElementProperties extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            type: "xsi:type"
        });
    }
}
class $be59461d4a783f7b$var$TimestampElement extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name){
        super(name);
        this.root.push(new $be59461d4a783f7b$var$TimestampElementProperties({
            type: "dcterms:W3CDTF"
        }));
        this.root.push($be59461d4a783f7b$export$89d9edd4d0429282(/* @__PURE__ */ new Date()));
    }
}
class $be59461d4a783f7b$var$CustomPropertiesAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            xmlns: "xmlns",
            vt: "xmlns:vt"
        });
    }
}
class $be59461d4a783f7b$var$CustomPropertyAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            fmtid: "fmtid",
            pid: "pid",
            name: "name"
        });
    }
}
class $be59461d4a783f7b$var$CustomProperty extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id, properties){
        super("property");
        this.root.push(new $be59461d4a783f7b$var$CustomPropertyAttributes({
            fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
            pid: id.toString(),
            name: properties.name
        }));
        this.root.push(new $be59461d4a783f7b$var$CustomPropertyValue(properties.value));
    }
}
class $be59461d4a783f7b$var$CustomPropertyValue extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("vt:lpwstr");
        this.root.push(value);
    }
}
class $be59461d4a783f7b$var$CustomProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(properties){
        super("Properties");
        // eslint-disable-next-line functional/prefer-readonly-type
        $be59461d4a783f7b$var$__publicField(this, "nextId");
        // eslint-disable-next-line functional/prefer-readonly-type
        $be59461d4a783f7b$var$__publicField(this, "properties", []);
        this.root.push(new $be59461d4a783f7b$var$CustomPropertiesAttributes({
            xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
            vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
        }));
        this.nextId = 2;
        for (const property of properties)this.addCustomProperty(property);
    }
    prepForXml(context) {
        this.properties.forEach((x)=>this.root.push(x));
        return super.prepForXml(context);
    }
    addCustomProperty(property) {
        this.properties.push(new $be59461d4a783f7b$var$CustomProperty(this.nextId++, property));
    }
}
const $be59461d4a783f7b$export$fba22c9d3f66adb = {
    ANSI: "00",
    DEFAULT: "01",
    SYMBOL: "02",
    MAC: "4D",
    JIS: "80",
    HANGUL: "81",
    JOHAB: "82",
    GB_2312: "86",
    CHINESEBIG5: "88",
    GREEK: "A1",
    TURKISH: "A2",
    VIETNAMESE: "A3",
    HEBREW: "B1",
    ARABIC: "B2",
    BALTIC: "BA",
    RUSSIAN: "CC",
    THAI: "DE",
    EASTEUROPE: "EE",
    OEM: "FF"
};
const $be59461d4a783f7b$var$createFontRelationship = ({ id: id, fontKey: fontKey, subsetted: subsetted }, name)=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: name,
        attributes: $be59461d4a783f7b$var$__spreadValues({
            id: {
                key: "r:id",
                value: id
            }
        }, fontKey ? {
            fontKey: {
                key: "w:fontKey",
                value: `{${fontKey}}`
            }
        } : {}),
        children: [
            ...subsetted ? [
                new $be59461d4a783f7b$export$9ea807bff926c949("w:subsetted", subsetted)
            ] : []
        ]
    });
const $be59461d4a783f7b$var$createFont = ({ name: name, altName: altName, panose1: panose1, charset: charset, family: family, notTrueType: notTrueType, pitch: pitch, sig: sig, embedRegular: embedRegular, embedBold: embedBold, embedItalic: embedItalic, embedBoldItalic: embedBoldItalic })=>// http://www.datypic.com/sc/ooxml/e-w_font-1.html
    new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:font",
        attributes: {
            name: {
                key: "w:name",
                value: name
            }
        },
        children: [
            // http://www.datypic.com/sc/ooxml/e-w_altName-1.html
            ...altName ? [
                $be59461d4a783f7b$export$e9d3b59c3f434130("w:altName", altName)
            ] : [],
            // http://www.datypic.com/sc/ooxml/e-w_panose1-1.html
            ...panose1 ? [
                $be59461d4a783f7b$export$e9d3b59c3f434130("w:panose1", panose1)
            ] : [],
            // http://www.datypic.com/sc/ooxml/e-w_charset-1.html
            ...charset ? [
                $be59461d4a783f7b$export$e9d3b59c3f434130("w:charset", charset)
            ] : [],
            $be59461d4a783f7b$export$e9d3b59c3f434130("w:family", family),
            // http://www.datypic.com/sc/ooxml/e-w_notTrueType-1.html
            ...notTrueType ? [
                new $be59461d4a783f7b$export$9ea807bff926c949("w:notTrueType", notTrueType)
            ] : [],
            $be59461d4a783f7b$export$e9d3b59c3f434130("w:pitch", pitch),
            // http://www.datypic.com/sc/ooxml/e-w_sig-1.html
            ...sig ? [
                new $be59461d4a783f7b$export$da493cbe1334accc({
                    name: "w:sig",
                    attributes: {
                        usb0: {
                            key: "w:usb0",
                            value: sig.usb0
                        },
                        usb1: {
                            key: "w:usb1",
                            value: sig.usb1
                        },
                        usb2: {
                            key: "w:usb2",
                            value: sig.usb2
                        },
                        usb3: {
                            key: "w:usb3",
                            value: sig.usb3
                        },
                        csb0: {
                            key: "w:csb0",
                            value: sig.csb0
                        },
                        csb1: {
                            key: "w:csb1",
                            value: sig.csb1
                        }
                    }
                })
            ] : [],
            // http://www.datypic.com/sc/ooxml/e-w_embedRegular-1.html
            ...embedRegular ? [
                $be59461d4a783f7b$var$createFontRelationship(embedRegular, "w:embedRegular")
            ] : [],
            // http://www.datypic.com/sc/ooxml/e-w_embedBold-1.html
            ...embedBold ? [
                $be59461d4a783f7b$var$createFontRelationship(embedBold, "w:embedBold")
            ] : [],
            // http://www.datypic.com/sc/ooxml/e-w_embedItalic-1.html
            ...embedItalic ? [
                $be59461d4a783f7b$var$createFontRelationship(embedItalic, "w:embedItalic")
            ] : [],
            // http://www.datypic.com/sc/ooxml/e-w_embedBoldItalic-1.html
            ...embedBoldItalic ? [
                $be59461d4a783f7b$var$createFontRelationship(embedBoldItalic, "w:embedBoldItalic")
            ] : []
        ]
    });
const $be59461d4a783f7b$var$createRegularFont = ({ name: name, index: index, fontKey: fontKey, characterSet: characterSet })=>$be59461d4a783f7b$var$createFont({
        name: name,
        sig: {
            usb0: "E0002AFF",
            usb1: "C000247B",
            usb2: "00000009",
            usb3: "00000000",
            csb0: "000001FF",
            csb1: "00000000"
        },
        charset: characterSet,
        family: "auto",
        pitch: "variable",
        embedRegular: {
            fontKey: fontKey,
            id: `rId${index}`
        }
    });
const $be59461d4a783f7b$var$createFontTable = (fonts)=>// https://c-rex.net/projects/samples/ooxml/e1/Part4/OOXML_P4_DOCX_Font_topic_ID0ERNCU.html
    // http://www.datypic.com/sc/ooxml/e-w_fonts.html
    new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:fonts",
        attributes: {
            mc: {
                key: "xmlns:mc",
                value: "http://schemas.openxmlformats.org/markup-compatibility/2006"
            },
            r: {
                key: "xmlns:r",
                value: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
            },
            w: {
                key: "xmlns:w",
                value: "http://schemas.openxmlformats.org/wordprocessingml/2006/main"
            },
            w14: {
                key: "xmlns:w14",
                value: "http://schemas.microsoft.com/office/word/2010/wordml"
            },
            w15: {
                key: "xmlns:w15",
                value: "http://schemas.microsoft.com/office/word/2012/wordml"
            },
            w16cex: {
                key: "xmlns:w16cex",
                value: "http://schemas.microsoft.com/office/word/2018/wordml/cex"
            },
            w16cid: {
                key: "xmlns:w16cid",
                value: "http://schemas.microsoft.com/office/word/2016/wordml/cid"
            },
            w16: {
                key: "xmlns:w16",
                value: "http://schemas.microsoft.com/office/word/2018/wordml"
            },
            w16sdtdh: {
                key: "xmlns:w16sdtdh",
                value: "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash"
            },
            w16se: {
                key: "xmlns:w16se",
                value: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
            },
            Ignorable: {
                key: "mc:Ignorable",
                value: "w14 w15 w16se w16cid w16 w16cex w16sdtdh"
            }
        },
        children: fonts.map((font, i)=>$be59461d4a783f7b$var$createRegularFont({
                name: font.name,
                index: i + 1,
                fontKey: font.fontKey
            }))
    });
class $be59461d4a783f7b$var$FontWrapper {
    constructor(options){
        $be59461d4a783f7b$var$__publicField(this, "fontTable");
        $be59461d4a783f7b$var$__publicField(this, "relationships");
        $be59461d4a783f7b$var$__publicField(this, "fontOptionsWithKey", []);
        this.options = options;
        this.fontOptionsWithKey = options.map((o)=>$be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, o), {
                fontKey: $be59461d4a783f7b$export$a261054604391cc()
            }));
        this.fontTable = $be59461d4a783f7b$var$createFontTable(this.fontOptionsWithKey);
        this.relationships = new $be59461d4a783f7b$var$Relationships();
        for(let i = 0; i < options.length; i++)this.relationships.createRelationship(i + 1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/font", `fonts/${options[i].name}.odttf`);
    }
    get View() {
        return this.fontTable;
    }
    get Relationships() {
        return this.relationships;
    }
}
class $be59461d4a783f7b$var$FooterAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            cp: "xmlns:cp",
            dc: "xmlns:dc",
            dcterms: "xmlns:dcterms",
            dcmitype: "xmlns:dcmitype",
            xsi: "xmlns:xsi",
            type: "xsi:type"
        });
    }
}
let $be59461d4a783f7b$var$Footer$1 = class Footer extends $be59461d4a783f7b$export$646396cb36770d6c {
    constructor(referenceNumber, initContent){
        super("w:ftr", initContent);
        $be59461d4a783f7b$var$__publicField(this, "refId");
        this.refId = referenceNumber;
        if (!initContent) this.root.push(new $be59461d4a783f7b$var$FooterAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
        }));
    }
    get ReferenceId() {
        return this.refId;
    }
    add(item) {
        this.root.push(item);
    }
};
class $be59461d4a783f7b$export$fd9000017733fabf {
    constructor(media, referenceId, initContent){
        $be59461d4a783f7b$var$__publicField(this, "footer");
        $be59461d4a783f7b$var$__publicField(this, "relationships");
        this.media = media;
        this.footer = new $be59461d4a783f7b$var$Footer$1(referenceId, initContent);
        this.relationships = new $be59461d4a783f7b$var$Relationships();
    }
    add(item) {
        this.footer.add(item);
    }
    addChildElement(childElement) {
        this.footer.addChildElement(childElement);
    }
    get View() {
        return this.footer;
    }
    get Relationships() {
        return this.relationships;
    }
    get Media() {
        return this.media;
    }
}
class $be59461d4a783f7b$var$FootnoteAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            type: "w:type",
            id: "w:id"
        });
    }
}
class $be59461d4a783f7b$var$FootnoteRef extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:footnoteRef");
    }
}
class $be59461d4a783f7b$var$FootnoteRefRun extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(){
        super({
            style: "FootnoteReference"
        });
        this.root.push(new $be59461d4a783f7b$var$FootnoteRef());
    }
}
const $be59461d4a783f7b$var$FootnoteType = {
    SEPERATOR: "separator",
    CONTINUATION_SEPERATOR: "continuationSeparator"
};
class $be59461d4a783f7b$var$Footnote extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:footnote");
        this.root.push(new $be59461d4a783f7b$var$FootnoteAttributes({
            type: options.type,
            id: options.id
        }));
        for(let i = 0; i < options.children.length; i++){
            const child = options.children[i];
            if (i === 0) child.addRunToFront(new $be59461d4a783f7b$var$FootnoteRefRun());
            this.root.push(child);
        }
    }
}
class $be59461d4a783f7b$var$ContinuationSeperator extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:continuationSeparator");
    }
}
class $be59461d4a783f7b$var$ContinuationSeperatorRun extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(){
        super({});
        this.root.push(new $be59461d4a783f7b$var$ContinuationSeperator());
    }
}
class $be59461d4a783f7b$var$Seperator extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:separator");
    }
}
class $be59461d4a783f7b$var$SeperatorRun extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(){
        super({});
        this.root.push(new $be59461d4a783f7b$var$Seperator());
    }
}
class $be59461d4a783f7b$var$FootnotesAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            Ignorable: "mc:Ignorable"
        });
    }
}
class $be59461d4a783f7b$export$4f472d314600dfca extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:footnotes");
        this.root.push(new $be59461d4a783f7b$var$FootnotesAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
        }));
        const begin = new $be59461d4a783f7b$var$Footnote({
            id: -1,
            type: $be59461d4a783f7b$var$FootnoteType.SEPERATOR,
            children: [
                new $be59461d4a783f7b$export$358a232cca1ab2ac({
                    spacing: {
                        after: 0,
                        line: 240,
                        lineRule: $be59461d4a783f7b$export$595a14bf61dfe45b.AUTO
                    },
                    children: [
                        new $be59461d4a783f7b$var$SeperatorRun()
                    ]
                })
            ]
        });
        this.root.push(begin);
        const spacing = new $be59461d4a783f7b$var$Footnote({
            id: 0,
            type: $be59461d4a783f7b$var$FootnoteType.CONTINUATION_SEPERATOR,
            children: [
                new $be59461d4a783f7b$export$358a232cca1ab2ac({
                    spacing: {
                        after: 0,
                        line: 240,
                        lineRule: $be59461d4a783f7b$export$595a14bf61dfe45b.AUTO
                    },
                    children: [
                        new $be59461d4a783f7b$var$ContinuationSeperatorRun()
                    ]
                })
            ]
        });
        this.root.push(spacing);
    }
    createFootNote(id, paragraph) {
        const footnote = new $be59461d4a783f7b$var$Footnote({
            id: id,
            children: paragraph
        });
        this.root.push(footnote);
    }
}
class $be59461d4a783f7b$var$FootnotesWrapper {
    constructor(){
        $be59461d4a783f7b$var$__publicField(this, "footnotess");
        $be59461d4a783f7b$var$__publicField(this, "relationships");
        this.footnotess = new $be59461d4a783f7b$export$4f472d314600dfca();
        this.relationships = new $be59461d4a783f7b$var$Relationships();
    }
    get View() {
        return this.footnotess;
    }
    get Relationships() {
        return this.relationships;
    }
}
class $be59461d4a783f7b$var$HeaderAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            cp: "xmlns:cp",
            dc: "xmlns:dc",
            dcterms: "xmlns:dcterms",
            dcmitype: "xmlns:dcmitype",
            xsi: "xmlns:xsi",
            type: "xsi:type",
            cx: "xmlns:cx",
            cx1: "xmlns:cx1",
            cx2: "xmlns:cx2",
            cx3: "xmlns:cx3",
            cx4: "xmlns:cx4",
            cx5: "xmlns:cx5",
            cx6: "xmlns:cx6",
            cx7: "xmlns:cx7",
            cx8: "xmlns:cx8",
            w16cid: "xmlns:w16cid",
            w16se: "xmlns:w16se"
        });
    }
}
let $be59461d4a783f7b$var$Header$1 = class Header extends $be59461d4a783f7b$export$646396cb36770d6c {
    constructor(referenceNumber, initContent){
        super("w:hdr", initContent);
        $be59461d4a783f7b$var$__publicField(this, "refId");
        this.refId = referenceNumber;
        if (!initContent) this.root.push(new $be59461d4a783f7b$var$HeaderAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            cx: "http://schemas.microsoft.com/office/drawing/2014/chartex",
            cx1: "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
            cx2: "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
            cx3: "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
            cx4: "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
            cx5: "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
            cx6: "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
            cx7: "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
            cx8: "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
            w16cid: "http://schemas.microsoft.com/office/word/2016/wordml/cid",
            w16se: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
        }));
    }
    get ReferenceId() {
        return this.refId;
    }
    add(item) {
        this.root.push(item);
    }
};
class $be59461d4a783f7b$export$960a49cc3d27a090 {
    constructor(media, referenceId, initContent){
        $be59461d4a783f7b$var$__publicField(this, "header");
        $be59461d4a783f7b$var$__publicField(this, "relationships");
        this.media = media;
        this.header = new $be59461d4a783f7b$var$Header$1(referenceId, initContent);
        this.relationships = new $be59461d4a783f7b$var$Relationships();
    }
    add(item) {
        this.header.add(item);
        return this;
    }
    addChildElement(childElement) {
        this.header.addChildElement(childElement);
    }
    get View() {
        return this.header;
    }
    get Relationships() {
        return this.relationships;
    }
    get Media() {
        return this.media;
    }
}
class $be59461d4a783f7b$export$7fc53215244aec38 {
    constructor(){
        // eslint-disable-next-line functional/prefer-readonly-type
        $be59461d4a783f7b$var$__publicField(this, "map");
        this.map = /* @__PURE__ */ new Map();
    }
    addImage(key, mediaData) {
        this.map.set(key, mediaData);
    }
    get Array() {
        return Array.from(this.map.values());
    }
}
const $be59461d4a783f7b$export$acf3e21fbd48faf6 = "";
const $be59461d4a783f7b$export$c17662f376a36ef9 = {
    DECIMAL: "decimal",
    UPPER_ROMAN: "upperRoman",
    LOWER_ROMAN: "lowerRoman",
    UPPER_LETTER: "upperLetter",
    LOWER_LETTER: "lowerLetter",
    ORDINAL: "ordinal",
    CARDINAL_TEXT: "cardinalText",
    ORDINAL_TEXT: "ordinalText",
    HEX: "hex",
    CHICAGO: "chicago",
    IDEOGRAPH__DIGITAL: "ideographDigital",
    JAPANESE_COUNTING: "japaneseCounting",
    AIUEO: "aiueo",
    IROHA: "iroha",
    DECIMAL_FULL_WIDTH: "decimalFullWidth",
    DECIMAL_HALF_WIDTH: "decimalHalfWidth",
    JAPANESE_LEGAL: "japaneseLegal",
    JAPANESE_DIGITAL_TEN_THOUSAND: "japaneseDigitalTenThousand",
    DECIMAL_ENCLOSED_CIRCLE: "decimalEnclosedCircle",
    DECIMAL_FULL_WIDTH2: "decimalFullWidth2",
    AIUEO_FULL_WIDTH: "aiueoFullWidth",
    IROHA_FULL_WIDTH: "irohaFullWidth",
    DECIMAL_ZERO: "decimalZero",
    BULLET: "bullet",
    GANADA: "ganada",
    CHOSUNG: "chosung",
    DECIMAL_ENCLOSED_FULLSTOP: "decimalEnclosedFullstop",
    DECIMAL_ENCLOSED_PARENTHESES: "decimalEnclosedParen",
    DECIMAL_ENCLOSED_CIRCLE_CHINESE: "decimalEnclosedCircleChinese",
    IDEOGRAPH_ENCLOSED_CIRCLE: "ideographEnclosedCircle",
    IDEOGRAPH_TRADITIONAL: "ideographTraditional",
    IDEOGRAPH_ZODIAC: "ideographZodiac",
    IDEOGRAPH_ZODIAC_TRADITIONAL: "ideographZodiacTraditional",
    TAIWANESE_COUNTING: "taiwaneseCounting",
    IDEOGRAPH_LEGAL_TRADITIONAL: "ideographLegalTraditional",
    TAIWANESE_COUNTING_THOUSAND: "taiwaneseCountingThousand",
    TAIWANESE_DIGITAL: "taiwaneseDigital",
    CHINESE_COUNTING: "chineseCounting",
    CHINESE_LEGAL_SIMPLIFIED: "chineseLegalSimplified",
    CHINESE_COUNTING_THOUSAND: "chineseCountingThousand",
    KOREAN_DIGITAL: "koreanDigital",
    KOREAN_COUNTING: "koreanCounting",
    KOREAN_LEGAL: "koreanLegal",
    KOREAN_DIGITAL2: "koreanDigital2",
    VIETNAMESE_COUNTING: "vietnameseCounting",
    RUSSIAN_LOWER: "russianLower",
    RUSSIAN_UPPER: "russianUpper",
    NONE: "none",
    NUMBER_IN_DASH: "numberInDash",
    HEBREW1: "hebrew1",
    HEBREW2: "hebrew2",
    ARABIC_ALPHA: "arabicAlpha",
    ARABIC_ABJAD: "arabicAbjad",
    HINDI_VOWELS: "hindiVowels",
    HINDI_CONSONANTS: "hindiConsonants",
    HINDI_NUMBERS: "hindiNumbers",
    HINDI_COUNTING: "hindiCounting",
    THAI_LETTERS: "thaiLetters",
    THAI_NUMBERS: "thaiNumbers",
    THAI_COUNTING: "thaiCounting",
    BAHT_TEXT: "bahtText",
    DOLLAR_TEXT: "dollarText",
    CUSTOM: "custom"
};
class $be59461d4a783f7b$var$LevelAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            ilvl: "w:ilvl",
            tentative: "w15:tentative"
        });
    }
}
class $be59461d4a783f7b$var$NumberFormat extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:numFmt");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: value
        }));
    }
}
class $be59461d4a783f7b$var$LevelText extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:lvlText");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: value
        }));
    }
}
class $be59461d4a783f7b$var$LevelJc extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:lvlJc");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: value
        }));
    }
}
const $be59461d4a783f7b$export$47604b1a4ce5619b = {
    NOTHING: "nothing",
    SPACE: "space",
    TAB: "tab"
};
class $be59461d4a783f7b$var$Suffix extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:suff");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: value
        }));
    }
}
class $be59461d4a783f7b$var$IsLegalNumberingStyle extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:isLgl");
    }
}
class $be59461d4a783f7b$export$91f8da61a0e8158c extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor({ level: level, format: format, text: text, alignment: alignment = $be59461d4a783f7b$export$97e681628fc5cdf4.START, start: start = 1, style: style, suffix: suffix, isLegalNumberingStyle: isLegalNumberingStyle }){
        super("w:lvl");
        $be59461d4a783f7b$var$__publicField(this, "paragraphProperties");
        $be59461d4a783f7b$var$__publicField(this, "runProperties");
        this.root.push(new $be59461d4a783f7b$export$7c6d6f8dacf13e40("w:start", $be59461d4a783f7b$export$3965b376946dc953(start)));
        if (format) this.root.push(new $be59461d4a783f7b$var$NumberFormat(format));
        if (suffix) this.root.push(new $be59461d4a783f7b$var$Suffix(suffix));
        if (isLegalNumberingStyle) this.root.push(new $be59461d4a783f7b$var$IsLegalNumberingStyle());
        if (text) this.root.push(new $be59461d4a783f7b$var$LevelText(text));
        this.root.push(new $be59461d4a783f7b$var$LevelJc(alignment));
        this.paragraphProperties = new $be59461d4a783f7b$export$2580ab652a992a27(style && style.paragraph);
        this.runProperties = new $be59461d4a783f7b$export$5ae5540473946c91(style && style.run);
        this.root.push(this.paragraphProperties);
        this.root.push(this.runProperties);
        if (level > 9) throw new Error("Level cannot be greater than 9. Read more here: https://answers.microsoft.com/en-us/msoffice/forum/all/does-word-support-more-than-9-list-levels/d130fdcd-1781-446d-8c84-c6c79124e4d7");
        this.root.push(new $be59461d4a783f7b$var$LevelAttributes({
            ilvl: $be59461d4a783f7b$export$3965b376946dc953(level),
            tentative: 1
        }));
    }
}
class $be59461d4a783f7b$export$ca664994d1d54bff extends $be59461d4a783f7b$export$91f8da61a0e8158c {
}
class $be59461d4a783f7b$export$797f82c452e3a5b7 extends $be59461d4a783f7b$export$91f8da61a0e8158c {
}
class $be59461d4a783f7b$var$MultiLevelType extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:multiLevelType");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: value
        }));
    }
}
class $be59461d4a783f7b$var$AbstractNumberingAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            abstractNumId: "w:abstractNumId",
            restartNumberingAfterBreak: "w15:restartNumberingAfterBreak"
        });
    }
}
class $be59461d4a783f7b$export$266bd704d5aa6083 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id, levelOptions){
        super("w:abstractNum");
        $be59461d4a783f7b$var$__publicField(this, "id");
        this.root.push(new $be59461d4a783f7b$var$AbstractNumberingAttributes({
            abstractNumId: $be59461d4a783f7b$export$3965b376946dc953(id),
            restartNumberingAfterBreak: 0
        }));
        this.root.push(new $be59461d4a783f7b$var$MultiLevelType("hybridMultilevel"));
        this.id = id;
        for (const option of levelOptions)this.root.push(new $be59461d4a783f7b$export$ca664994d1d54bff(option));
    }
}
class $be59461d4a783f7b$var$AbstractNumId extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:abstractNumId");
        this.root.push(new $be59461d4a783f7b$export$21991851b0bb231f({
            val: value
        }));
    }
}
class $be59461d4a783f7b$var$NumAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            numId: "w:numId"
        });
    }
}
class $be59461d4a783f7b$export$706d61b850a8b75b extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:num");
        $be59461d4a783f7b$var$__publicField(this, "numId");
        $be59461d4a783f7b$var$__publicField(this, "reference");
        $be59461d4a783f7b$var$__publicField(this, "instance");
        this.numId = options.numId;
        this.reference = options.reference;
        this.instance = options.instance;
        this.root.push(new $be59461d4a783f7b$var$NumAttributes({
            numId: $be59461d4a783f7b$export$3965b376946dc953(options.numId)
        }));
        this.root.push(new $be59461d4a783f7b$var$AbstractNumId($be59461d4a783f7b$export$3965b376946dc953(options.abstractNumId)));
        if (options.overrideLevels && options.overrideLevels.length) for (const level of options.overrideLevels)this.root.push(new $be59461d4a783f7b$export$55dcfb0831b1f416(level.num, level.start));
    }
}
class $be59461d4a783f7b$var$LevelOverrideAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            ilvl: "w:ilvl"
        });
    }
}
class $be59461d4a783f7b$export$55dcfb0831b1f416 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(levelNum, start){
        super("w:lvlOverride");
        this.root.push(new $be59461d4a783f7b$var$LevelOverrideAttributes({
            ilvl: levelNum
        }));
        if (start !== void 0) this.root.push(new $be59461d4a783f7b$var$StartOverride(start));
    }
}
class $be59461d4a783f7b$var$StartOverrideAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$var$StartOverride extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(start){
        super("w:startOverride");
        this.root.push(new $be59461d4a783f7b$var$StartOverrideAttributes({
            val: start
        }));
    }
}
class $be59461d4a783f7b$export$521a466b2293b1d9 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:numbering");
        $be59461d4a783f7b$var$__publicField(this, "abstractNumberingMap", /* @__PURE__ */ new Map());
        $be59461d4a783f7b$var$__publicField(this, "concreteNumberingMap", /* @__PURE__ */ new Map());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $be59461d4a783f7b$var$__publicField(this, "referenceConfigMap", /* @__PURE__ */ new Map());
        $be59461d4a783f7b$var$__publicField(this, "abstractNumUniqueNumericId", $be59461d4a783f7b$export$704353bc8da186a0());
        $be59461d4a783f7b$var$__publicField(this, "concreteNumUniqueNumericId", $be59461d4a783f7b$export$efd792105b1568d0());
        this.root.push(new $be59461d4a783f7b$export$e2bedb2588efb3f4([
            "wpc",
            "mc",
            "o",
            "r",
            "m",
            "v",
            "wp14",
            "wp",
            "w10",
            "w",
            "w14",
            "w15",
            "wpg",
            "wpi",
            "wne",
            "wps"
        ], "w14 w15 wp14"));
        const abstractNumbering = new $be59461d4a783f7b$export$266bd704d5aa6083(this.abstractNumUniqueNumericId(), [
            {
                level: 0,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: $be59461d4a783f7b$export$4db9ad0f69d17611(0.5),
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 1,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25CB",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: $be59461d4a783f7b$export$4db9ad0f69d17611(1),
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 2,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25A0",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 2160,
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 3,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 2880,
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 4,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25CB",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 3600,
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 5,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25A0",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 4320,
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 6,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 5040,
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 7,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 5760,
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            },
            {
                level: 8,
                format: $be59461d4a783f7b$export$c17662f376a36ef9.BULLET,
                text: "\u25CF",
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.LEFT,
                style: {
                    paragraph: {
                        indent: {
                            left: 6480,
                            hanging: $be59461d4a783f7b$export$4db9ad0f69d17611(0.25)
                        }
                    }
                }
            }
        ]);
        this.concreteNumberingMap.set("default-bullet-numbering", new $be59461d4a783f7b$export$706d61b850a8b75b({
            numId: 1,
            abstractNumId: abstractNumbering.id,
            reference: "default-bullet-numbering",
            instance: 0,
            overrideLevels: [
                {
                    num: 0,
                    start: 1
                }
            ]
        }));
        this.abstractNumberingMap.set("default-bullet-numbering", abstractNumbering);
        for (const con of options.config){
            this.abstractNumberingMap.set(con.reference, new $be59461d4a783f7b$export$266bd704d5aa6083(this.abstractNumUniqueNumericId(), con.levels));
            this.referenceConfigMap.set(con.reference, con.levels);
        }
    }
    prepForXml(context) {
        for (const numbering of this.abstractNumberingMap.values())this.root.push(numbering);
        for (const numbering of this.concreteNumberingMap.values())this.root.push(numbering);
        return super.prepForXml(context);
    }
    createConcreteNumberingInstance(reference, instance) {
        const abstractNumbering = this.abstractNumberingMap.get(reference);
        if (!abstractNumbering) return;
        const fullReference = `${reference}-${instance}`;
        if (this.concreteNumberingMap.has(fullReference)) return;
        const referenceConfigLevels = this.referenceConfigMap.get(reference);
        const firstLevelStartNumber = referenceConfigLevels && referenceConfigLevels[0].start;
        const concreteNumberingSettings = {
            numId: this.concreteNumUniqueNumericId(),
            abstractNumId: abstractNumbering.id,
            reference: reference,
            instance: instance,
            overrideLevels: [
                firstLevelStartNumber && Number.isInteger(firstLevelStartNumber) ? {
                    num: 0,
                    start: firstLevelStartNumber
                } : {
                    num: 0,
                    start: 1
                }
            ]
        };
        this.concreteNumberingMap.set(fullReference, new $be59461d4a783f7b$export$706d61b850a8b75b(concreteNumberingSettings));
    }
    get ConcreteNumbering() {
        return Array.from(this.concreteNumberingMap.values());
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get ReferenceConfig() {
        return Array.from(this.referenceConfigMap.values());
    }
}
class $be59461d4a783f7b$var$CompatibilitySettingAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            version: "w:val",
            name: "w:name",
            uri: "w:uri"
        });
    }
}
class $be59461d4a783f7b$var$CompatibilitySetting extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(version){
        super("w:compatSetting");
        this.root.push(new $be59461d4a783f7b$var$CompatibilitySettingAttributes({
            version: version,
            uri: "http://schemas.microsoft.com/office/word",
            name: "compatibilityMode"
        }));
    }
}
class $be59461d4a783f7b$var$Compatibility extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:compat");
        if (options.version) this.root.push(new $be59461d4a783f7b$var$CompatibilitySetting(options.version));
        if (options.useSingleBorderforContiguousCells) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:useSingleBorderforContiguousCells", options.useSingleBorderforContiguousCells));
        if (options.wordPerfectJustification) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:wpJustification", options.wordPerfectJustification));
        if (options.noTabStopForHangingIndent) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:noTabHangInd", options.noTabStopForHangingIndent));
        if (options.noLeading) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:noLeading", options.noLeading));
        if (options.spaceForUnderline) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:spaceForUL", options.spaceForUnderline));
        if (options.noColumnBalance) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:noColumnBalance", options.noColumnBalance));
        if (options.balanceSingleByteDoubleByteWidth) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:balanceSingleByteDoubleByteWidth", options.balanceSingleByteDoubleByteWidth));
        if (options.noExtraLineSpacing) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:noExtraLineSpacing", options.noExtraLineSpacing));
        if (options.doNotLeaveBackslashAlone) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotLeaveBackslashAlone", options.doNotLeaveBackslashAlone));
        if (options.underlineTrailingSpaces) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:ulTrailSpace", options.underlineTrailingSpaces));
        if (options.doNotExpandShiftReturn) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotExpandShiftReturn", options.doNotExpandShiftReturn));
        if (options.spacingInWholePoints) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:spacingInWholePoints", options.spacingInWholePoints));
        if (options.lineWrapLikeWord6) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:lineWrapLikeWord6", options.lineWrapLikeWord6));
        if (options.printBodyTextBeforeHeader) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:printBodyTextBeforeHeader", options.printBodyTextBeforeHeader));
        if (options.printColorsBlack) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:printColBlack", options.printColorsBlack));
        if (options.spaceWidth) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:wpSpaceWidth", options.spaceWidth));
        if (options.showBreaksInFrames) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:showBreaksInFrames", options.showBreaksInFrames));
        if (options.subFontBySize) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:subFontBySize", options.subFontBySize));
        if (options.suppressBottomSpacing) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:suppressBottomSpacing", options.suppressBottomSpacing));
        if (options.suppressTopSpacing) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:suppressTopSpacing", options.suppressTopSpacing));
        if (options.suppressSpacingAtTopOfPage) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:suppressSpacingAtTopOfPage", options.suppressSpacingAtTopOfPage));
        if (options.suppressTopSpacingWP) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:suppressTopSpacingWP", options.suppressTopSpacingWP));
        if (options.suppressSpBfAfterPgBrk) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:suppressSpBfAfterPgBrk", options.suppressSpBfAfterPgBrk));
        if (options.swapBordersFacingPages) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:swapBordersFacingPages", options.swapBordersFacingPages));
        if (options.convertMailMergeEsc) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:convMailMergeEsc", options.convertMailMergeEsc));
        if (options.truncateFontHeightsLikeWP6) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:truncateFontHeightsLikeWP6", options.truncateFontHeightsLikeWP6));
        if (options.macWordSmallCaps) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:mwSmallCaps", options.macWordSmallCaps));
        if (options.usePrinterMetrics) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:usePrinterMetrics", options.usePrinterMetrics));
        if (options.doNotSuppressParagraphBorders) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotSuppressParagraphBorders", options.doNotSuppressParagraphBorders));
        if (options.wrapTrailSpaces) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:wrapTrailSpaces", options.wrapTrailSpaces));
        if (options.footnoteLayoutLikeWW8) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:footnoteLayoutLikeWW8", options.footnoteLayoutLikeWW8));
        if (options.shapeLayoutLikeWW8) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:shapeLayoutLikeWW8", options.shapeLayoutLikeWW8));
        if (options.alignTablesRowByRow) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:alignTablesRowByRow", options.alignTablesRowByRow));
        if (options.forgetLastTabAlignment) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:forgetLastTabAlignment", options.forgetLastTabAlignment));
        if (options.adjustLineHeightInTable) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:adjustLineHeightInTable", options.adjustLineHeightInTable));
        if (options.autoSpaceLikeWord95) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:autoSpaceLikeWord95", options.autoSpaceLikeWord95));
        if (options.noSpaceRaiseLower) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:noSpaceRaiseLower", options.noSpaceRaiseLower));
        if (options.doNotUseHTMLParagraphAutoSpacing) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotUseHTMLParagraphAutoSpacing", options.doNotUseHTMLParagraphAutoSpacing));
        if (options.layoutRawTableWidth) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:layoutRawTableWidth", options.layoutRawTableWidth));
        if (options.layoutTableRowsApart) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:layoutTableRowsApart", options.layoutTableRowsApart));
        if (options.useWord97LineBreakRules) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:useWord97LineBreakRules", options.useWord97LineBreakRules));
        if (options.doNotBreakWrappedTables) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotBreakWrappedTables", options.doNotBreakWrappedTables));
        if (options.doNotSnapToGridInCell) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotSnapToGridInCell", options.doNotSnapToGridInCell));
        if (options.selectFieldWithFirstOrLastCharacter) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:selectFldWithFirstOrLastChar", options.selectFieldWithFirstOrLastCharacter));
        if (options.applyBreakingRules) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:applyBreakingRules", options.applyBreakingRules));
        if (options.doNotWrapTextWithPunctuation) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotWrapTextWithPunct", options.doNotWrapTextWithPunctuation));
        if (options.doNotUseEastAsianBreakRules) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotUseEastAsianBreakRules", options.doNotUseEastAsianBreakRules));
        if (options.useWord2002TableStyleRules) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:useWord2002TableStyleRules", options.useWord2002TableStyleRules));
        if (options.growAutofit) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:growAutofit", options.growAutofit));
        if (options.useFELayout) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:useFELayout", options.useFELayout));
        if (options.useNormalStyleForList) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:useNormalStyleForList", options.useNormalStyleForList));
        if (options.doNotUseIndentAsNumberingTabStop) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotUseIndentAsNumberingTabStop", options.doNotUseIndentAsNumberingTabStop));
        if (options.useAlternateEastAsianLineBreakRules) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:useAltKinsokuLineBreakRules", options.useAlternateEastAsianLineBreakRules));
        if (options.allowSpaceOfSameStyleInTable) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:allowSpaceOfSameStyleInTable", options.allowSpaceOfSameStyleInTable));
        if (options.doNotSuppressIndentation) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotSuppressIndentation", options.doNotSuppressIndentation));
        if (options.doNotAutofitConstrainedTables) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotAutofitConstrainedTables", options.doNotAutofitConstrainedTables));
        if (options.autofitToFirstFixedWidthCell) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:autofitToFirstFixedWidthCell", options.autofitToFirstFixedWidthCell));
        if (options.underlineTabInNumberingList) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:underlineTabInNumList", options.underlineTabInNumberingList));
        if (options.displayHangulFixedWidth) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:displayHangulFixedWidth", options.displayHangulFixedWidth));
        if (options.splitPgBreakAndParaMark) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:splitPgBreakAndParaMark", options.splitPgBreakAndParaMark));
        if (options.doNotVerticallyAlignCellWithSp) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotVertAlignCellWithSp", options.doNotVerticallyAlignCellWithSp));
        if (options.doNotBreakConstrainedForcedTable) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotBreakConstrainedForcedTable", options.doNotBreakConstrainedForcedTable));
        if (options.ignoreVerticalAlignmentInTextboxes) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotVertAlignInTxbx", options.ignoreVerticalAlignmentInTextboxes));
        if (options.useAnsiKerningPairs) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:useAnsiKerningPairs", options.useAnsiKerningPairs));
        if (options.cachedColumnBalance) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:cachedColBalance", options.cachedColumnBalance));
    }
}
class $be59461d4a783f7b$var$SettingsAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            wpc: "xmlns:wpc",
            mc: "xmlns:mc",
            o: "xmlns:o",
            r: "xmlns:r",
            m: "xmlns:m",
            v: "xmlns:v",
            wp14: "xmlns:wp14",
            wp: "xmlns:wp",
            w10: "xmlns:w10",
            w: "xmlns:w",
            w14: "xmlns:w14",
            w15: "xmlns:w15",
            wpg: "xmlns:wpg",
            wpi: "xmlns:wpi",
            wne: "xmlns:wne",
            wps: "xmlns:wps",
            Ignorable: "mc:Ignorable"
        });
    }
}
class $be59461d4a783f7b$var$Settings extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super("w:settings");
        this.root.push(new $be59461d4a783f7b$var$SettingsAttributes({
            wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
            mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
            o: "urn:schemas-microsoft-com:office:office",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
            v: "urn:schemas-microsoft-com:vml",
            wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
            wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
            w10: "urn:schemas-microsoft-com:office:word",
            w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
            w14: "http://schemas.microsoft.com/office/word/2010/wordml",
            w15: "http://schemas.microsoft.com/office/word/2012/wordml",
            wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
            wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
            wne: "http://schemas.microsoft.com/office/word/2006/wordml",
            wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
            Ignorable: "w14 w15 wp14"
        }));
        this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:displayBackgroundShape", true));
        if (options.trackRevisions !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:trackRevisions", options.trackRevisions));
        if (options.evenAndOddHeaders !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:evenAndOddHeaders", options.evenAndOddHeaders));
        if (options.updateFields !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:updateFields", options.updateFields));
        if (options.defaultTabStop !== void 0) this.root.push(new $be59461d4a783f7b$export$7c6d6f8dacf13e40("w:defaultTabStop", options.defaultTabStop));
        if (((_a = options.hyphenation) == null ? void 0 : _a.autoHyphenation) !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:autoHyphenation", options.hyphenation.autoHyphenation));
        if (((_b = options.hyphenation) == null ? void 0 : _b.hyphenationZone) !== void 0) this.root.push(new $be59461d4a783f7b$export$7c6d6f8dacf13e40("w:hyphenationZone", options.hyphenation.hyphenationZone));
        if (((_c = options.hyphenation) == null ? void 0 : _c.consecutiveHyphenLimit) !== void 0) this.root.push(new $be59461d4a783f7b$export$7c6d6f8dacf13e40("w:consecutiveHyphenLimit", options.hyphenation.consecutiveHyphenLimit));
        if (((_d = options.hyphenation) == null ? void 0 : _d.doNotHyphenateCaps) !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:doNotHyphenateCaps", options.hyphenation.doNotHyphenateCaps));
        this.root.push(new $be59461d4a783f7b$var$Compatibility($be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, (_e = options.compatibility) != null ? _e : {}), {
            version: (_h = (_g = (_f = options.compatibility) == null ? void 0 : _f.version) != null ? _g : options.compatibilityModeVersion) != null ? _h : 15
        })));
    }
}
class $be59461d4a783f7b$var$ComponentAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w:val"
        });
    }
}
class $be59461d4a783f7b$var$Name extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:name");
        this.root.push(new $be59461d4a783f7b$var$ComponentAttributes({
            val: value
        }));
    }
}
class $be59461d4a783f7b$var$UiPriority extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(value){
        super("w:uiPriority");
        this.root.push(new $be59461d4a783f7b$var$ComponentAttributes({
            val: $be59461d4a783f7b$export$3965b376946dc953(value)
        }));
    }
}
class $be59461d4a783f7b$var$StyleAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            type: "w:type",
            styleId: "w:styleId",
            default: "w:default",
            customStyle: "w:customStyle"
        });
    }
}
class $be59461d4a783f7b$var$Style2 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(attributes, options){
        super("w:style");
        this.root.push(new $be59461d4a783f7b$var$StyleAttributes(attributes));
        if (options.name) this.root.push(new $be59461d4a783f7b$var$Name(options.name));
        if (options.basedOn) this.root.push(new $be59461d4a783f7b$export$eacbde36aa74068("w:basedOn", options.basedOn));
        if (options.next) this.root.push(new $be59461d4a783f7b$export$eacbde36aa74068("w:next", options.next));
        if (options.link) this.root.push(new $be59461d4a783f7b$export$eacbde36aa74068("w:link", options.link));
        if (options.uiPriority !== void 0) this.root.push(new $be59461d4a783f7b$var$UiPriority(options.uiPriority));
        if (options.semiHidden !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:semiHidden", options.semiHidden));
        if (options.unhideWhenUsed !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:unhideWhenUsed", options.unhideWhenUsed));
        if (options.quickFormat !== void 0) this.root.push(new $be59461d4a783f7b$export$9ea807bff926c949("w:qFormat", options.quickFormat));
    }
}
class $be59461d4a783f7b$export$6adfeaa1778d50f4 extends $be59461d4a783f7b$var$Style2 {
    constructor(options){
        super({
            type: "paragraph",
            styleId: options.id
        }, options);
        $be59461d4a783f7b$var$__publicField(this, "paragraphProperties");
        $be59461d4a783f7b$var$__publicField(this, "runProperties");
        this.paragraphProperties = new $be59461d4a783f7b$export$2580ab652a992a27(options.paragraph);
        this.runProperties = new $be59461d4a783f7b$export$5ae5540473946c91(options.run);
        this.root.push(this.paragraphProperties);
        this.root.push(this.runProperties);
    }
}
class $be59461d4a783f7b$export$b30019f2711c7199 extends $be59461d4a783f7b$var$Style2 {
    constructor(options){
        super({
            type: "character",
            styleId: options.id
        }, $be59461d4a783f7b$var$__spreadValues({
            uiPriority: 99,
            unhideWhenUsed: true
        }, options));
        $be59461d4a783f7b$var$__publicField(this, "runProperties");
        this.runProperties = new $be59461d4a783f7b$export$5ae5540473946c91(options.run);
        this.root.push(this.runProperties);
    }
}
class $be59461d4a783f7b$var$HeadingStyle extends $be59461d4a783f7b$export$6adfeaa1778d50f4 {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true
        }, options));
    }
}
class $be59461d4a783f7b$var$TitleStyle extends $be59461d4a783f7b$var$HeadingStyle {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Title",
            name: "Title"
        }, options));
    }
}
class $be59461d4a783f7b$var$Heading1Style extends $be59461d4a783f7b$var$HeadingStyle {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Heading1",
            name: "Heading 1"
        }, options));
    }
}
class $be59461d4a783f7b$var$Heading2Style extends $be59461d4a783f7b$var$HeadingStyle {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Heading2",
            name: "Heading 2"
        }, options));
    }
}
class $be59461d4a783f7b$var$Heading3Style extends $be59461d4a783f7b$var$HeadingStyle {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Heading3",
            name: "Heading 3"
        }, options));
    }
}
class $be59461d4a783f7b$var$Heading4Style extends $be59461d4a783f7b$var$HeadingStyle {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Heading4",
            name: "Heading 4"
        }, options));
    }
}
class $be59461d4a783f7b$var$Heading5Style extends $be59461d4a783f7b$var$HeadingStyle {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Heading5",
            name: "Heading 5"
        }, options));
    }
}
class $be59461d4a783f7b$var$Heading6Style extends $be59461d4a783f7b$var$HeadingStyle {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Heading6",
            name: "Heading 6"
        }, options));
    }
}
class $be59461d4a783f7b$var$StrongStyle extends $be59461d4a783f7b$var$HeadingStyle {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Strong",
            name: "Strong"
        }, options));
    }
}
class $be59461d4a783f7b$var$ListParagraph extends $be59461d4a783f7b$export$6adfeaa1778d50f4 {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "ListParagraph",
            name: "List Paragraph",
            basedOn: "Normal",
            quickFormat: true
        }, options));
    }
}
class $be59461d4a783f7b$var$FootnoteText extends $be59461d4a783f7b$export$6adfeaa1778d50f4 {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "FootnoteText",
            name: "footnote text",
            link: "FootnoteTextChar",
            basedOn: "Normal",
            uiPriority: 99,
            semiHidden: true,
            unhideWhenUsed: true,
            paragraph: {
                spacing: {
                    after: 0,
                    line: 240,
                    lineRule: $be59461d4a783f7b$export$595a14bf61dfe45b.AUTO
                }
            },
            run: {
                size: 20
            }
        }, options));
    }
}
class $be59461d4a783f7b$var$FootnoteReferenceStyle extends $be59461d4a783f7b$export$b30019f2711c7199 {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "FootnoteReference",
            name: "footnote reference",
            basedOn: "DefaultParagraphFont",
            semiHidden: true,
            run: {
                superScript: true
            }
        }, options));
    }
}
class $be59461d4a783f7b$var$FootnoteTextChar extends $be59461d4a783f7b$export$b30019f2711c7199 {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "FootnoteTextChar",
            name: "Footnote Text Char",
            basedOn: "DefaultParagraphFont",
            link: "FootnoteText",
            semiHidden: true,
            run: {
                size: 20
            }
        }, options));
    }
}
class $be59461d4a783f7b$var$HyperlinkStyle extends $be59461d4a783f7b$export$b30019f2711c7199 {
    constructor(options){
        super($be59461d4a783f7b$var$__spreadValues({
            id: "Hyperlink",
            name: "Hyperlink",
            basedOn: "DefaultParagraphFont",
            run: {
                color: "0563C1",
                underline: {
                    type: $be59461d4a783f7b$export$7d5cc92343d18d1b.SINGLE
                }
            }
        }, options));
    }
}
class $be59461d4a783f7b$export$e155666bf54a9f18 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:styles");
        if (options.initialStyles) this.root.push(options.initialStyles);
        if (options.importedStyles) for (const style of options.importedStyles)this.root.push(style);
        if (options.paragraphStyles) for (const style of options.paragraphStyles)this.root.push(new $be59461d4a783f7b$export$6adfeaa1778d50f4(style));
        if (options.characterStyles) for (const style of options.characterStyles)this.root.push(new $be59461d4a783f7b$export$b30019f2711c7199(style));
    }
}
class $be59461d4a783f7b$export$1c732adbaa41477e extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:pPrDefault");
        this.root.push(new $be59461d4a783f7b$export$2580ab652a992a27(options));
    }
}
class $be59461d4a783f7b$export$8bbc5109c297588f extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:rPrDefault");
        this.root.push(new $be59461d4a783f7b$export$5ae5540473946c91(options));
    }
}
class $be59461d4a783f7b$export$61bda0fab7780ed1 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:docDefaults");
        $be59461d4a783f7b$var$__publicField(this, "runPropertiesDefaults");
        $be59461d4a783f7b$var$__publicField(this, "paragraphPropertiesDefaults");
        this.runPropertiesDefaults = new $be59461d4a783f7b$export$8bbc5109c297588f(options.run);
        this.paragraphPropertiesDefaults = new $be59461d4a783f7b$export$1c732adbaa41477e(options.paragraph);
        this.root.push(this.runPropertiesDefaults);
        this.root.push(this.paragraphPropertiesDefaults);
    }
}
class $be59461d4a783f7b$var$ExternalStylesFactory {
    /**
   * Creates new Style based on the given styles.
   * Parses the styles and convert them to XmlComponent.
   * Example content from styles.xml:
   * <?xml version="1.0">
   * <w:styles xmlns:mc="some schema" ...>
   *
   *   <w:style w:type="paragraph" w:styleId="Heading1">
   *           <w:name w:val="heading 1"/>
   *           .....
   *   </w:style>
   *
   *   <w:style w:type="paragraph" w:styleId="Heading2">
   *           <w:name w:val="heading 2"/>
   *           .....
   *   </w:style>
   *
   *   <w:docDefaults>Or any other element will be parsed to</w:docDefaults>
   *
   * </w:styles>
   *
   * @param externalStyles context from styles.xml
   */ newInstance(xmlData) {
        const xmlObj = $be59461d4a783f7b$var$libExports.xml2js(xmlData, {
            compact: false
        });
        let stylesXmlElement;
        for (const xmlElm of xmlObj.elements || [])if (xmlElm.name === "w:styles") stylesXmlElement = xmlElm;
        if (stylesXmlElement === void 0) throw new Error("can not find styles element");
        const stylesElements = stylesXmlElement.elements || [];
        const importedStyle = new $be59461d4a783f7b$export$e155666bf54a9f18({
            initialStyles: new $be59461d4a783f7b$export$f3691753fff0e91f(stylesXmlElement.attributes),
            importedStyles: stylesElements.map((childElm)=>$be59461d4a783f7b$export$cd3b8f5143756514(childElm))
        });
        return importedStyle;
    }
}
class $be59461d4a783f7b$var$DefaultStylesFactory {
    newInstance(options = {}) {
        var _a;
        const documentAttributes = new $be59461d4a783f7b$export$e2bedb2588efb3f4([
            "mc",
            "r",
            "w",
            "w14",
            "w15"
        ], "w14 w15");
        return {
            initialStyles: documentAttributes,
            importedStyles: [
                new $be59461d4a783f7b$export$61bda0fab7780ed1((_a = options.document) != null ? _a : {}),
                new $be59461d4a783f7b$var$TitleStyle($be59461d4a783f7b$var$__spreadValues({
                    run: {
                        size: 56
                    }
                }, options.title)),
                new $be59461d4a783f7b$var$Heading1Style($be59461d4a783f7b$var$__spreadValues({
                    run: {
                        color: "2E74B5",
                        size: 32
                    }
                }, options.heading1)),
                new $be59461d4a783f7b$var$Heading2Style($be59461d4a783f7b$var$__spreadValues({
                    run: {
                        color: "2E74B5",
                        size: 26
                    }
                }, options.heading2)),
                new $be59461d4a783f7b$var$Heading3Style($be59461d4a783f7b$var$__spreadValues({
                    run: {
                        color: "1F4D78",
                        size: 24
                    }
                }, options.heading3)),
                new $be59461d4a783f7b$var$Heading4Style($be59461d4a783f7b$var$__spreadValues({
                    run: {
                        color: "2E74B5",
                        italics: true
                    }
                }, options.heading4)),
                new $be59461d4a783f7b$var$Heading5Style($be59461d4a783f7b$var$__spreadValues({
                    run: {
                        color: "2E74B5"
                    }
                }, options.heading5)),
                new $be59461d4a783f7b$var$Heading6Style($be59461d4a783f7b$var$__spreadValues({
                    run: {
                        color: "1F4D78"
                    }
                }, options.heading6)),
                new $be59461d4a783f7b$var$StrongStyle($be59461d4a783f7b$var$__spreadValues({
                    run: {
                        bold: true
                    }
                }, options.strong)),
                new $be59461d4a783f7b$var$ListParagraph(options.listParagraph || {}),
                new $be59461d4a783f7b$var$HyperlinkStyle(options.hyperlink || {}),
                new $be59461d4a783f7b$var$FootnoteReferenceStyle(options.footnoteReference || {}),
                new $be59461d4a783f7b$var$FootnoteText(options.footnoteText || {}),
                new $be59461d4a783f7b$var$FootnoteTextChar(options.footnoteTextChar || {})
            ]
        };
    }
}
class $be59461d4a783f7b$export$b34a105447964f9f {
    constructor(options){
        // eslint-disable-next-line functional/prefer-readonly-type
        $be59461d4a783f7b$var$__publicField(this, "currentRelationshipId", 1);
        $be59461d4a783f7b$var$__publicField(this, "documentWrapper");
        // eslint-disable-next-line functional/prefer-readonly-type
        $be59461d4a783f7b$var$__publicField(this, "headers", []);
        // eslint-disable-next-line functional/prefer-readonly-type
        $be59461d4a783f7b$var$__publicField(this, "footers", []);
        $be59461d4a783f7b$var$__publicField(this, "coreProperties");
        $be59461d4a783f7b$var$__publicField(this, "numbering");
        $be59461d4a783f7b$var$__publicField(this, "media");
        $be59461d4a783f7b$var$__publicField(this, "fileRelationships");
        $be59461d4a783f7b$var$__publicField(this, "footnotesWrapper");
        $be59461d4a783f7b$var$__publicField(this, "settings");
        $be59461d4a783f7b$var$__publicField(this, "contentTypes");
        $be59461d4a783f7b$var$__publicField(this, "customProperties");
        $be59461d4a783f7b$var$__publicField(this, "appProperties");
        $be59461d4a783f7b$var$__publicField(this, "styles");
        $be59461d4a783f7b$var$__publicField(this, "comments");
        $be59461d4a783f7b$var$__publicField(this, "fontWrapper");
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        this.coreProperties = new $be59461d4a783f7b$var$CoreProperties($be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, options), {
            creator: (_a = options.creator) != null ? _a : "Un-named",
            revision: (_b = options.revision) != null ? _b : 1,
            lastModifiedBy: (_c = options.lastModifiedBy) != null ? _c : "Un-named"
        }));
        this.numbering = new $be59461d4a783f7b$export$521a466b2293b1d9(options.numbering ? options.numbering : {
            config: []
        });
        this.comments = new $be59461d4a783f7b$export$434c217d363ea16((_d = options.comments) != null ? _d : {
            children: []
        });
        this.fileRelationships = new $be59461d4a783f7b$var$Relationships();
        this.customProperties = new $be59461d4a783f7b$var$CustomProperties((_e = options.customProperties) != null ? _e : []);
        this.appProperties = new $be59461d4a783f7b$var$AppProperties();
        this.footnotesWrapper = new $be59461d4a783f7b$var$FootnotesWrapper();
        this.contentTypes = new $be59461d4a783f7b$var$ContentTypes();
        this.documentWrapper = new $be59461d4a783f7b$var$DocumentWrapper({
            background: options.background
        });
        this.settings = new $be59461d4a783f7b$var$Settings({
            compatibilityModeVersion: options.compatabilityModeVersion,
            compatibility: options.compatibility,
            evenAndOddHeaders: options.evenAndOddHeaderAndFooters ? true : false,
            trackRevisions: (_f = options.features) == null ? void 0 : _f.trackRevisions,
            updateFields: (_g = options.features) == null ? void 0 : _g.updateFields,
            defaultTabStop: options.defaultTabStop,
            hyphenation: {
                autoHyphenation: (_h = options.hyphenation) == null ? void 0 : _h.autoHyphenation,
                hyphenationZone: (_i = options.hyphenation) == null ? void 0 : _i.hyphenationZone,
                consecutiveHyphenLimit: (_j = options.hyphenation) == null ? void 0 : _j.consecutiveHyphenLimit,
                doNotHyphenateCaps: (_k = options.hyphenation) == null ? void 0 : _k.doNotHyphenateCaps
            }
        });
        this.media = new $be59461d4a783f7b$export$7fc53215244aec38();
        if (options.externalStyles !== void 0) {
            const stylesFactory = new $be59461d4a783f7b$var$ExternalStylesFactory();
            this.styles = stylesFactory.newInstance(options.externalStyles);
        } else if (options.styles) {
            const stylesFactory = new $be59461d4a783f7b$var$DefaultStylesFactory();
            const defaultStyles = stylesFactory.newInstance(options.styles.default);
            this.styles = new $be59461d4a783f7b$export$e155666bf54a9f18($be59461d4a783f7b$var$__spreadValues($be59461d4a783f7b$var$__spreadValues({}, defaultStyles), options.styles));
        } else {
            const stylesFactory = new $be59461d4a783f7b$var$DefaultStylesFactory();
            this.styles = new $be59461d4a783f7b$export$e155666bf54a9f18(stylesFactory.newInstance());
        }
        this.addDefaultRelationships();
        for (const section of options.sections)this.addSection(section);
        if (options.footnotes) for(const key in options.footnotes)this.footnotesWrapper.View.createFootNote(parseFloat(key), options.footnotes[key].children);
        this.fontWrapper = new $be59461d4a783f7b$var$FontWrapper((_l = options.fonts) != null ? _l : []);
    }
    addSection({ headers: headers = {}, footers: footers = {}, children: children, properties: properties }) {
        this.documentWrapper.View.Body.addSection($be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, properties), {
            headerWrapperGroup: {
                default: headers.default ? this.createHeader(headers.default) : void 0,
                first: headers.first ? this.createHeader(headers.first) : void 0,
                even: headers.even ? this.createHeader(headers.even) : void 0
            },
            footerWrapperGroup: {
                default: footers.default ? this.createFooter(footers.default) : void 0,
                first: footers.first ? this.createFooter(footers.first) : void 0,
                even: footers.even ? this.createFooter(footers.even) : void 0
            }
        }));
        for (const child of children)this.documentWrapper.View.add(child);
    }
    createHeader(header) {
        const wrapper = new $be59461d4a783f7b$export$960a49cc3d27a090(this.media, this.currentRelationshipId++);
        for (const child of header.options.children)wrapper.add(child);
        this.addHeaderToDocument(wrapper);
        return wrapper;
    }
    createFooter(footer) {
        const wrapper = new $be59461d4a783f7b$export$fd9000017733fabf(this.media, this.currentRelationshipId++);
        for (const child of footer.options.children)wrapper.add(child);
        this.addFooterToDocument(wrapper);
        return wrapper;
    }
    addHeaderToDocument(header, type2 = $be59461d4a783f7b$export$df165515f58460ef.DEFAULT) {
        this.headers.push({
            header: header,
            type: type2
        });
        this.documentWrapper.Relationships.createRelationship(header.View.ReferenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header", `header${this.headers.length}.xml`);
        this.contentTypes.addHeader(this.headers.length);
    }
    addFooterToDocument(footer, type2 = $be59461d4a783f7b$export$df165515f58460ef.DEFAULT) {
        this.footers.push({
            footer: footer,
            type: type2
        });
        this.documentWrapper.Relationships.createRelationship(footer.View.ReferenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer", `footer${this.footers.length}.xml`);
        this.contentTypes.addFooter(this.footers.length);
    }
    addDefaultRelationships() {
        this.fileRelationships.createRelationship(1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument", "word/document.xml");
        this.fileRelationships.createRelationship(2, "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties", "docProps/core.xml");
        this.fileRelationships.createRelationship(3, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties", "docProps/app.xml");
        this.fileRelationships.createRelationship(4, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties", "docProps/custom.xml");
        this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
        this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles", "styles.xml");
        this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
        this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering", "numbering.xml");
        this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
        this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes", "footnotes.xml");
        this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
        this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings", "settings.xml");
        this.documentWrapper.Relationships.createRelationship(// eslint-disable-next-line functional/immutable-data
        this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments", "comments.xml");
    }
    get Document() {
        return this.documentWrapper;
    }
    get Styles() {
        return this.styles;
    }
    get CoreProperties() {
        return this.coreProperties;
    }
    get Numbering() {
        return this.numbering;
    }
    get Media() {
        return this.media;
    }
    get FileRelationships() {
        return this.fileRelationships;
    }
    get Headers() {
        return this.headers.map((item)=>item.header);
    }
    get Footers() {
        return this.footers.map((item)=>item.footer);
    }
    get ContentTypes() {
        return this.contentTypes;
    }
    get CustomProperties() {
        return this.customProperties;
    }
    get AppProperties() {
        return this.appProperties;
    }
    get FootNotes() {
        return this.footnotesWrapper;
    }
    get Settings() {
        return this.settings;
    }
    get Comments() {
        return this.comments;
    }
    get FontTable() {
        return this.fontWrapper;
    }
}
class $be59461d4a783f7b$var$FieldInstruction extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(properties = {}){
        super("w:instrText");
        $be59461d4a783f7b$var$__publicField(this, "properties");
        this.properties = properties;
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        let instruction = "TOC";
        if (this.properties.captionLabel) instruction = `${instruction} \\a "${this.properties.captionLabel}"`;
        if (this.properties.entriesFromBookmark) instruction = `${instruction} \\b "${this.properties.entriesFromBookmark}"`;
        if (this.properties.captionLabelIncludingNumbers) instruction = `${instruction} \\c "${this.properties.captionLabelIncludingNumbers}"`;
        if (this.properties.sequenceAndPageNumbersSeparator) instruction = `${instruction} \\d "${this.properties.sequenceAndPageNumbersSeparator}"`;
        if (this.properties.tcFieldIdentifier) instruction = `${instruction} \\f "${this.properties.tcFieldIdentifier}"`;
        if (this.properties.hyperlink) instruction = `${instruction} \\h`;
        if (this.properties.tcFieldLevelRange) instruction = `${instruction} \\l "${this.properties.tcFieldLevelRange}"`;
        if (this.properties.pageNumbersEntryLevelsRange) instruction = `${instruction} \\n "${this.properties.pageNumbersEntryLevelsRange}"`;
        if (this.properties.headingStyleRange) instruction = `${instruction} \\o "${this.properties.headingStyleRange}"`;
        if (this.properties.entryAndPageNumberSeparator) instruction = `${instruction} \\p "${this.properties.entryAndPageNumberSeparator}"`;
        if (this.properties.seqFieldIdentifierForPrefix) instruction = `${instruction} \\s "${this.properties.seqFieldIdentifierForPrefix}"`;
        if (this.properties.stylesWithLevels && this.properties.stylesWithLevels.length) {
            const styles = this.properties.stylesWithLevels.map((sl)=>`${sl.styleName},${sl.level}`).join(",");
            instruction = `${instruction} \\t "${styles}"`;
        }
        if (this.properties.useAppliedParagraphOutlineLevel) instruction = `${instruction} \\u`;
        if (this.properties.preserveTabInEntries) instruction = `${instruction} \\w`;
        if (this.properties.preserveNewLineInEntries) instruction = `${instruction} \\x`;
        if (this.properties.hideTabAndPageNumbersInWebView) instruction = `${instruction} \\z`;
        this.root.push(instruction);
    }
}
class $be59461d4a783f7b$var$StructuredDocumentTagContent extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:sdtContent");
    }
}
class $be59461d4a783f7b$var$StructuredDocumentTagProperties extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(alias){
        super("w:sdtPr");
        if (alias) this.root.push(new $be59461d4a783f7b$export$eacbde36aa74068("w:alias", alias));
    }
}
class $be59461d4a783f7b$export$65a20d5539dff777 extends $be59461d4a783f7b$export$5b43359c04ff37a0 {
    constructor(alias = "Table of Contents", properties){
        super("w:sdt");
        this.root.push(new $be59461d4a783f7b$var$StructuredDocumentTagProperties(alias));
        const content = new $be59461d4a783f7b$var$StructuredDocumentTagContent();
        const beginParagraph = new $be59461d4a783f7b$export$358a232cca1ab2ac({
            children: [
                new $be59461d4a783f7b$export$ddae37e51c7979e2({
                    children: [
                        new $be59461d4a783f7b$var$Begin(true),
                        new $be59461d4a783f7b$var$FieldInstruction(properties),
                        new $be59461d4a783f7b$var$Separate()
                    ]
                })
            ]
        });
        content.addChildElement(beginParagraph);
        const endParagraph = new $be59461d4a783f7b$export$358a232cca1ab2ac({
            children: [
                new $be59461d4a783f7b$export$ddae37e51c7979e2({
                    children: [
                        new $be59461d4a783f7b$var$End()
                    ]
                })
            ]
        });
        content.addChildElement(endParagraph);
        this.root.push(content);
    }
}
class $be59461d4a783f7b$export$8620d935ae9e70d8 {
    constructor(styleName, level){
        $be59461d4a783f7b$var$__publicField(this, "styleName");
        $be59461d4a783f7b$var$__publicField(this, "level");
        this.styleName = styleName;
        this.level = level;
    }
}
class $be59461d4a783f7b$export$8b251419efc915eb {
    constructor(options = {
        children: []
    }){
        $be59461d4a783f7b$var$__publicField(this, "options");
        this.options = options;
    }
}
class $be59461d4a783f7b$export$a06f1c675e846f6f {
    constructor(options = {
        children: []
    }){
        $be59461d4a783f7b$var$__publicField(this, "options");
        this.options = options;
    }
}
class $be59461d4a783f7b$export$acfee73582d2a289 extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            id: "w:id"
        });
    }
}
class $be59461d4a783f7b$export$ccd8225ec2fb34fe extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(id){
        super("w:footnoteReference");
        this.root.push(new $be59461d4a783f7b$export$acfee73582d2a289({
            id: id
        }));
    }
}
class $be59461d4a783f7b$export$c1993b92b39f032e extends $be59461d4a783f7b$export$ddae37e51c7979e2 {
    constructor(id){
        super({
            style: "FootnoteReference"
        });
        this.root.push(new $be59461d4a783f7b$export$ccd8225ec2fb34fe(id));
    }
}
class $be59461d4a783f7b$export$be933bc21596e47 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:ins");
        this.root.push(new $be59461d4a783f7b$var$ChangeAttributes({
            id: options.id,
            author: options.author,
            date: options.date
        }));
        this.addChildElement(new $be59461d4a783f7b$export$84d920a4f7ee9ae2(options));
    }
}
class $be59461d4a783f7b$var$DeletedPage extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:delInstrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push("PAGE");
    }
}
class $be59461d4a783f7b$var$DeletedNumberOfPages extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:delInstrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push("NUMPAGES");
    }
}
class $be59461d4a783f7b$var$DeletedNumberOfPagesSection extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(){
        super("w:delInstrText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push("SECTIONPAGES");
    }
}
class $be59461d4a783f7b$var$DeletedText extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(text){
        super("w:delText");
        this.root.push(new $be59461d4a783f7b$var$TextAttributes({
            space: $be59461d4a783f7b$export$bb538ef550ced38.PRESERVE
        }));
        this.root.push(text);
    }
}
class $be59461d4a783f7b$export$fbc7a99f5255f638 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:del");
        $be59461d4a783f7b$var$__publicField(this, "deletedTextRunWrapper");
        this.root.push(new $be59461d4a783f7b$var$ChangeAttributes({
            id: options.id,
            author: options.author,
            date: options.date
        }));
        this.deletedTextRunWrapper = new $be59461d4a783f7b$var$DeletedTextRunWrapper(options);
        this.addChildElement(this.deletedTextRunWrapper);
    }
}
class $be59461d4a783f7b$var$DeletedTextRunWrapper extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        super("w:r");
        this.root.push(new $be59461d4a783f7b$export$5ae5540473946c91(options));
        if (options.children) for (const child of options.children){
            if (typeof child === "string") {
                switch(child){
                    case $be59461d4a783f7b$export$9d30b4f7b635f195.CURRENT:
                        this.root.push(new $be59461d4a783f7b$var$Begin());
                        this.root.push(new $be59461d4a783f7b$var$DeletedPage());
                        this.root.push(new $be59461d4a783f7b$var$Separate());
                        this.root.push(new $be59461d4a783f7b$var$End());
                        break;
                    case $be59461d4a783f7b$export$9d30b4f7b635f195.TOTAL_PAGES:
                        this.root.push(new $be59461d4a783f7b$var$Begin());
                        this.root.push(new $be59461d4a783f7b$var$DeletedNumberOfPages());
                        this.root.push(new $be59461d4a783f7b$var$Separate());
                        this.root.push(new $be59461d4a783f7b$var$End());
                        break;
                    case $be59461d4a783f7b$export$9d30b4f7b635f195.TOTAL_PAGES_IN_SECTION:
                        this.root.push(new $be59461d4a783f7b$var$Begin());
                        this.root.push(new $be59461d4a783f7b$var$DeletedNumberOfPagesSection());
                        this.root.push(new $be59461d4a783f7b$var$Separate());
                        this.root.push(new $be59461d4a783f7b$var$End());
                        break;
                    default:
                        this.root.push(new $be59461d4a783f7b$var$DeletedText(child));
                        break;
                }
                continue;
            }
            this.root.push(child);
        }
        else if (options.text) this.root.push(new $be59461d4a783f7b$var$DeletedText(options.text));
        if (options.break) for(let i = 0; i < options.break; i++)this.root.splice(1, 0, new $be59461d4a783f7b$var$Break$1());
    }
}
class $be59461d4a783f7b$var$CheckboxSymbolAttributes extends $be59461d4a783f7b$export$d14a6833c537c2d {
    constructor(){
        super(...arguments);
        $be59461d4a783f7b$var$__publicField(this, "xmlKeys", {
            val: "w14:val",
            symbolfont: "w14:font"
        });
    }
}
class $be59461d4a783f7b$export$466d83ed591e9874 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(name, val, font){
        super(name);
        if (font) this.root.push(new $be59461d4a783f7b$var$CheckboxSymbolAttributes({
            val: $be59461d4a783f7b$export$545c905536cb1e26(val),
            symbolfont: font
        }));
        else this.root.push(new $be59461d4a783f7b$var$CheckboxSymbolAttributes({
            val: val
        }));
    }
}
class $be59461d4a783f7b$export$9499831ee554ccd8 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super("w14:checkbox");
        $be59461d4a783f7b$var$__publicField(this, "DEFAULT_UNCHECKED_SYMBOL", "2610");
        $be59461d4a783f7b$var$__publicField(this, "DEFAULT_CHECKED_SYMBOL", "2612");
        $be59461d4a783f7b$var$__publicField(this, "DEFAULT_FONT", "MS Gothic");
        const value = (options == null ? void 0 : options.checked) ? "1" : "0";
        let symbol;
        let font;
        this.root.push(new $be59461d4a783f7b$export$466d83ed591e9874("w14:checked", value));
        symbol = ((_a = options == null ? void 0 : options.checkedState) == null ? void 0 : _a.value) ? (_b = options == null ? void 0 : options.checkedState) == null ? void 0 : _b.value : this.DEFAULT_CHECKED_SYMBOL;
        font = ((_c = options == null ? void 0 : options.checkedState) == null ? void 0 : _c.font) ? (_d = options == null ? void 0 : options.checkedState) == null ? void 0 : _d.font : this.DEFAULT_FONT;
        this.root.push(new $be59461d4a783f7b$export$466d83ed591e9874("w14:checkedState", symbol, font));
        symbol = ((_e = options == null ? void 0 : options.uncheckedState) == null ? void 0 : _e.value) ? (_f = options == null ? void 0 : options.uncheckedState) == null ? void 0 : _f.value : this.DEFAULT_UNCHECKED_SYMBOL;
        font = ((_g = options == null ? void 0 : options.uncheckedState) == null ? void 0 : _g.font) ? (_h = options == null ? void 0 : options.uncheckedState) == null ? void 0 : _h.font : this.DEFAULT_FONT;
        this.root.push(new $be59461d4a783f7b$export$466d83ed591e9874("w14:uncheckedState", symbol, font));
    }
}
class $be59461d4a783f7b$export$ea5f704b89d806f6 extends $be59461d4a783f7b$export$19f99b70db82ec96 {
    constructor(options){
        var _a, _b, _c, _d;
        super("w:sdt");
        // default values per Microsoft
        $be59461d4a783f7b$var$__publicField(this, "DEFAULT_UNCHECKED_SYMBOL", "2610");
        $be59461d4a783f7b$var$__publicField(this, "DEFAULT_CHECKED_SYMBOL", "2612");
        $be59461d4a783f7b$var$__publicField(this, "DEFAULT_FONT", "MS Gothic");
        const properties = new $be59461d4a783f7b$var$StructuredDocumentTagProperties(options == null ? void 0 : options.alias);
        properties.addChildElement(new $be59461d4a783f7b$export$9499831ee554ccd8(options));
        this.root.push(properties);
        const content = new $be59461d4a783f7b$var$StructuredDocumentTagContent();
        const checkedFont = (_a = options == null ? void 0 : options.checkedState) == null ? void 0 : _a.font;
        const checkedText = (_b = options == null ? void 0 : options.checkedState) == null ? void 0 : _b.value;
        const uncheckedFont = (_c = options == null ? void 0 : options.uncheckedState) == null ? void 0 : _c.font;
        const uncheckedText = (_d = options == null ? void 0 : options.uncheckedState) == null ? void 0 : _d.value;
        let symbolFont;
        let char;
        if (options == null ? void 0 : options.checked) {
            symbolFont = checkedFont ? checkedFont : this.DEFAULT_FONT;
            char = checkedText ? checkedText : this.DEFAULT_CHECKED_SYMBOL;
        } else {
            symbolFont = uncheckedFont ? uncheckedFont : this.DEFAULT_FONT;
            char = uncheckedText ? uncheckedText : this.DEFAULT_UNCHECKED_SYMBOL;
        }
        const initialRenderedChar = new $be59461d4a783f7b$export$2d254945a19d4f19({
            char: char,
            symbolfont: symbolFont
        });
        content.addChildElement(initialRenderedChar);
        this.root.push(content);
    }
}
const $be59461d4a783f7b$var$createPictElement = ({ shape: shape })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:pict",
        children: [
            shape
        ]
    });
const $be59461d4a783f7b$var$createTextboxContent = ({ children: children = [] })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "w:txbxContent",
        children: children
    });
const $be59461d4a783f7b$var$createVmlTextbox = ({ style: style, children: children, inset: inset })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "v:textbox",
        attributes: {
            style: {
                key: "style",
                value: style
            },
            insetMode: {
                key: "insetmode",
                value: inset ? "custom" : "auto"
            },
            inset: {
                key: "inset",
                value: inset ? `${inset.left}, ${inset.top}, ${inset.right}, ${inset.bottom}` : void 0
            }
        },
        children: [
            $be59461d4a783f7b$var$createTextboxContent({
                children: children
            })
        ]
    });
const $be59461d4a783f7b$var$SHAPE_TYPE = "#_x0000_t202";
const $be59461d4a783f7b$var$styleToKeyMap = {
    flip: "flip",
    height: "height",
    left: "left",
    marginBottom: "margin-bottom",
    marginLeft: "margin-left",
    marginRight: "margin-right",
    marginTop: "margin-top",
    positionHorizontal: "mso-position-horizontal",
    positionHorizontalRelative: "mso-position-horizontal-relative",
    positionVertical: "mso-position-vertical",
    positionVerticalRelative: "mso-position-vertical-relative",
    wrapDistanceBottom: "mso-wrap-distance-bottom",
    wrapDistanceLeft: "mso-wrap-distance-left",
    wrapDistanceRight: "mso-wrap-distance-right",
    wrapDistanceTop: "mso-wrap-distance-top",
    wrapEdited: "mso-wrap-edited",
    wrapStyle: "mso-wrap-style",
    position: "position",
    rotation: "rotation",
    top: "top",
    visibility: "visibility",
    width: "width",
    zIndex: "z-index"
};
const $be59461d4a783f7b$var$formatShapeStyle = (style)=>style ? Object.entries(style).map(([key, value])=>`${$be59461d4a783f7b$var$styleToKeyMap[key]}:${value}`).join(";") : void 0;
const $be59461d4a783f7b$var$createShape = ({ id: id, children: children, type: type2 = $be59461d4a783f7b$var$SHAPE_TYPE, style: style })=>new $be59461d4a783f7b$export$da493cbe1334accc({
        name: "v:shape",
        attributes: {
            id: {
                key: "id",
                value: id
            },
            type: {
                key: "type",
                value: type2
            },
            style: {
                key: "style",
                value: $be59461d4a783f7b$var$formatShapeStyle(style)
            }
        },
        children: [
            $be59461d4a783f7b$var$createVmlTextbox({
                style: "mso-fit-shape-to-text:t;",
                children: children
            })
        ]
    });
class $be59461d4a783f7b$export$8e3dca5fa4d5f04b extends $be59461d4a783f7b$export$5b43359c04ff37a0 {
    constructor(_a){
        var _b = _a, { style: style, children: children } = _b, rest = $be59461d4a783f7b$var$__objRest(_b, [
            "style",
            "children"
        ]);
        super("w:p");
        this.root.push(new $be59461d4a783f7b$export$2580ab652a992a27(rest));
        this.root.push($be59461d4a783f7b$var$createPictElement({
            shape: $be59461d4a783f7b$var$createShape({
                children: children,
                id: $be59461d4a783f7b$export$8b15d37bc3f197d4(),
                style: style
            })
        }));
    }
}
var $be59461d4a783f7b$var$streamBrowserifyExports = $be59461d4a783f7b$var$requireStreamBrowserify();
function $be59461d4a783f7b$var$commonjsRequire(path) {
    throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $be59461d4a783f7b$var$jszip_min = {
    exports: {}
};
var $be59461d4a783f7b$var$hasRequiredJszip_min;
function $be59461d4a783f7b$var$requireJszip_min() {
    if ($be59461d4a783f7b$var$hasRequiredJszip_min) return $be59461d4a783f7b$var$jszip_min.exports;
    $be59461d4a783f7b$var$hasRequiredJszip_min = 1;
    (function(module, exports) {
        !function(e) {
            module.exports = e();
        }(function() {
            return (function s(a, o, h) {
                function u(r, e2) {
                    if (!o[r]) {
                        if (!a[r]) {
                            var t = "function" == typeof $be59461d4a783f7b$var$commonjsRequire && $be59461d4a783f7b$var$commonjsRequire;
                            if (!e2 && t) return t(r, true);
                            if (l) return l(r, true);
                            var n = new Error("Cannot find module '" + r + "'");
                            throw n.code = "MODULE_NOT_FOUND", n;
                        }
                        var i = o[r] = {
                            exports: {}
                        };
                        a[r][0].call(i.exports, function(e3) {
                            var t2 = a[r][1][e3];
                            return u(t2 || e3);
                        }, i, i.exports, s, a, o, h);
                    }
                    return o[r].exports;
                }
                for(var l = "function" == typeof $be59461d4a783f7b$var$commonjsRequire && $be59461d4a783f7b$var$commonjsRequire, e = 0; e < h.length; e++)u(h[e]);
                return u;
            })({
                1: [
                    function(e, t, r) {
                        var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                        r.encode = function(e2) {
                            for(var t2, r2, n, i, s, a, o, h = [], u = 0, l = e2.length, f = l, c2 = "string" !== d.getTypeOf(e2); u < e2.length;)f = l - u, n = c2 ? (t2 = e2[u++], r2 = u < l ? e2[u++] : 0, u < l ? e2[u++] : 0) : (t2 = e2.charCodeAt(u++), r2 = u < l ? e2.charCodeAt(u++) : 0, u < l ? e2.charCodeAt(u++) : 0), i = t2 >> 2, s = (3 & t2) << 4 | r2 >> 4, a = 1 < f ? (15 & r2) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                            return h.join("");
                        }, r.decode = function(e2) {
                            var t2, r2, n, i, s, a, o = 0, h = 0, u = "data:";
                            if (e2.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                            var l, f = 3 * (e2 = e2.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                            if (e2.charAt(e2.length - 1) === p.charAt(64) && f--, e2.charAt(e2.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                            for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e2.length;)t2 = p.indexOf(e2.charAt(o++)) << 2 | (i = p.indexOf(e2.charAt(o++))) >> 4, r2 = (15 & i) << 4 | (s = p.indexOf(e2.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e2.charAt(o++))), l[h++] = t2, 64 !== s && (l[h++] = r2), 64 !== a && (l[h++] = n);
                            return l;
                        };
                    },
                    {
                        "./support": 30,
                        "./utils": 32
                    }
                ],
                2: [
                    function(e, t, r) {
                        var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                        function o(e2, t2, r2, n2, i2) {
                            this.compressedSize = e2, this.uncompressedSize = t2, this.crc32 = r2, this.compression = n2, this.compressedContent = i2;
                        }
                        o.prototype = {
                            getContentWorker: function() {
                                var e2 = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t2 = this;
                                return e2.on("end", function() {
                                    if (this.streamInfo.data_length !== t2.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                }), e2;
                            },
                            getCompressedWorker: function() {
                                return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                            }
                        }, o.createWorkerFrom = function(e2, t2, r2) {
                            return e2.pipe(new s()).pipe(new a("uncompressedSize")).pipe(t2.compressWorker(r2)).pipe(new a("compressedSize")).withStreamInfo("compression", t2);
                        }, t.exports = o;
                    },
                    {
                        "./external": 6,
                        "./stream/Crc32Probe": 25,
                        "./stream/DataLengthProbe": 26,
                        "./stream/DataWorker": 27
                    }
                ],
                3: [
                    function(e, t, r) {
                        var n = e("./stream/GenericWorker");
                        r.STORE = {
                            magic: "\0\0",
                            compressWorker: function() {
                                return new n("STORE compression");
                            },
                            uncompressWorker: function() {
                                return new n("STORE decompression");
                            }
                        }, r.DEFLATE = e("./flate");
                    },
                    {
                        "./flate": 7,
                        "./stream/GenericWorker": 28
                    }
                ],
                4: [
                    function(e, t, r) {
                        var n = e("./utils");
                        var o = function() {
                            for(var e2, t2 = [], r2 = 0; r2 < 256; r2++){
                                e2 = r2;
                                for(var n2 = 0; n2 < 8; n2++)e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
                                t2[r2] = e2;
                            }
                            return t2;
                        }();
                        t.exports = function(e2, t2) {
                            return void 0 !== e2 && e2.length ? "string" !== n.getTypeOf(e2) ? function(e3, t3, r2, n2) {
                                var i = o, s = n2 + r2;
                                e3 ^= -1;
                                for(var a = n2; a < s; a++)e3 = e3 >>> 8 ^ i[255 & (e3 ^ t3[a])];
                                return -1 ^ e3;
                            }(0 | t2, e2, e2.length, 0) : function(e3, t3, r2, n2) {
                                var i = o, s = n2 + r2;
                                e3 ^= -1;
                                for(var a = n2; a < s; a++)e3 = e3 >>> 8 ^ i[255 & (e3 ^ t3.charCodeAt(a))];
                                return -1 ^ e3;
                            }(0 | t2, e2, e2.length, 0) : 0;
                        };
                    },
                    {
                        "./utils": 32
                    }
                ],
                5: [
                    function(e, t, r) {
                        r.base64 = false, r.binary = false, r.dir = false, r.createFolders = true, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
                    },
                    {}
                ],
                6: [
                    function(e, t, r) {
                        var n = null;
                        n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                            Promise: n
                        };
                    },
                    {
                        lie: 37
                    }
                ],
                7: [
                    function(e, t, r) {
                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                        function h(e2, t2) {
                            a.call(this, "FlateWorker/" + e2), this._pako = null, this._pakoAction = e2, this._pakoOptions = t2, this.meta = {};
                        }
                        r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e2) {
                            this.meta = e2.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e2.data), false);
                        }, h.prototype.flush = function() {
                            a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], true);
                        }, h.prototype.cleanUp = function() {
                            a.prototype.cleanUp.call(this), this._pako = null;
                        }, h.prototype._createPako = function() {
                            this._pako = new i[this._pakoAction]({
                                raw: true,
                                level: this._pakoOptions.level || -1
                            });
                            var t2 = this;
                            this._pako.onData = function(e2) {
                                t2.push({
                                    data: e2,
                                    meta: t2.meta
                                });
                            };
                        }, r.compressWorker = function(e2) {
                            return new h("Deflate", e2);
                        }, r.uncompressWorker = function() {
                            return new h("Inflate", {});
                        };
                    },
                    {
                        "./stream/GenericWorker": 28,
                        "./utils": 32,
                        pako: 38
                    }
                ],
                8: [
                    function(e, t, r) {
                        function A(e2, t2) {
                            var r2, n2 = "";
                            for(r2 = 0; r2 < t2; r2++)n2 += String.fromCharCode(255 & e2), e2 >>>= 8;
                            return n2;
                        }
                        function n(e2, t2, r2, n2, i2, s2) {
                            var a, o, h = e2.file, u = e2.compression, l = s2 !== O.utf8encode, f = I.transformTo("string", s2(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s2(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                                crc32: 0,
                                compressedSize: 0,
                                uncompressedSize: 0
                            };
                            t2 && !r2 || (x.crc32 = e2.crc32, x.compressedSize = e2.compressedSize, x.uncompressedSize = e2.uncompressedSize);
                            var S = 0;
                            t2 && (S |= 8), l || !_ && !g || (S |= 2048);
                            var z = 0, C = 0;
                            w && (z |= 16), "UNIX" === i2 ? (C = 798, z |= function(e3, t3) {
                                var r3 = e3;
                                return e3 || (r3 = t3 ? 16893 : 33204), (65535 & r3) << 16;
                            }(h.unixPermissions, w)) : (C = 20, z |= function(e3) {
                                return 63 & (e3 || 0);
                            }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                            var E = "";
                            return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                                fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                                dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n2, 4) + f + b + p
                            };
                        }
                        var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                        function s(e2, t2, r2, n2) {
                            i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t2, this.zipPlatform = r2, this.encodeFileName = n2, this.streamFiles = e2, this.accumulate = false, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                        }
                        I.inherits(s, i), s.prototype.push = function(e2) {
                            var t2 = e2.meta.percent || 0, r2 = this.entriesCount, n2 = this._sources.length;
                            this.accumulate ? this.contentBuffer.push(e2) : (this.bytesWritten += e2.data.length, i.prototype.push.call(this, {
                                data: e2.data,
                                meta: {
                                    currentFile: this.currentFile,
                                    percent: r2 ? (t2 + 100 * (r2 - n2 - 1)) / r2 : 100
                                }
                            }));
                        }, s.prototype.openedSource = function(e2) {
                            this.currentSourceOffset = this.bytesWritten, this.currentFile = e2.file.name;
                            var t2 = this.streamFiles && !e2.file.dir;
                            if (t2) {
                                var r2 = n(e2, t2, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                this.push({
                                    data: r2.fileRecord,
                                    meta: {
                                        percent: 0
                                    }
                                });
                            } else this.accumulate = true;
                        }, s.prototype.closedSource = function(e2) {
                            this.accumulate = false;
                            var t2 = this.streamFiles && !e2.file.dir, r2 = n(e2, t2, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                            if (this.dirRecords.push(r2.dirRecord), t2) this.push({
                                data: function(e3) {
                                    return R.DATA_DESCRIPTOR + A(e3.crc32, 4) + A(e3.compressedSize, 4) + A(e3.uncompressedSize, 4);
                                }(e2),
                                meta: {
                                    percent: 100
                                }
                            });
                            else for(this.push({
                                data: r2.fileRecord,
                                meta: {
                                    percent: 0
                                }
                            }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                            this.currentFile = null;
                        }, s.prototype.flush = function() {
                            for(var e2 = this.bytesWritten, t2 = 0; t2 < this.dirRecords.length; t2++)this.push({
                                data: this.dirRecords[t2],
                                meta: {
                                    percent: 100
                                }
                            });
                            var r2 = this.bytesWritten - e2, n2 = function(e3, t3, r3, n3, i2) {
                                var s2 = I.transformTo("string", i2(n3));
                                return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e3, 2) + A(e3, 2) + A(t3, 4) + A(r3, 4) + A(s2.length, 2) + s2;
                            }(this.dirRecords.length, r2, e2, this.zipComment, this.encodeFileName);
                            this.push({
                                data: n2,
                                meta: {
                                    percent: 100
                                }
                            });
                        }, s.prototype.prepareNextSource = function() {
                            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                        }, s.prototype.registerPrevious = function(e2) {
                            this._sources.push(e2);
                            var t2 = this;
                            return e2.on("data", function(e3) {
                                t2.processChunk(e3);
                            }), e2.on("end", function() {
                                t2.closedSource(t2.previous.streamInfo), t2._sources.length ? t2.prepareNextSource() : t2.end();
                            }), e2.on("error", function(e3) {
                                t2.error(e3);
                            }), this;
                        }, s.prototype.resume = function() {
                            return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), true) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), true));
                        }, s.prototype.error = function(e2) {
                            var t2 = this._sources;
                            if (!i.prototype.error.call(this, e2)) return false;
                            for(var r2 = 0; r2 < t2.length; r2++)try {
                                t2[r2].error(e2);
                            } catch (e3) {}
                            return true;
                        }, s.prototype.lock = function() {
                            i.prototype.lock.call(this);
                            for(var e2 = this._sources, t2 = 0; t2 < e2.length; t2++)e2[t2].lock();
                        }, t.exports = s;
                    },
                    {
                        "../crc32": 4,
                        "../signature": 23,
                        "../stream/GenericWorker": 28,
                        "../utf8": 31,
                        "../utils": 32
                    }
                ],
                9: [
                    function(e, t, r) {
                        var u = e("../compressions"), n = e("./ZipFileWorker");
                        r.generateWorker = function(e2, a, t2) {
                            var o = new n(a.streamFiles, t2, a.platform, a.encodeFileName), h = 0;
                            try {
                                e2.forEach(function(e3, t3) {
                                    h++;
                                    var r2 = function(e4, t4) {
                                        var r3 = e4 || t4, n3 = u[r3];
                                        if (!n3) throw new Error(r3 + " is not a valid compression method !");
                                        return n3;
                                    }(t3.options.compression, a.compression), n2 = t3.options.compressionOptions || a.compressionOptions || {}, i = t3.dir, s = t3.date;
                                    t3._compressWorker(r2, n2).withStreamInfo("file", {
                                        name: e3,
                                        dir: i,
                                        date: s,
                                        comment: t3.comment || "",
                                        unixPermissions: t3.unixPermissions,
                                        dosPermissions: t3.dosPermissions
                                    }).pipe(o);
                                }), o.entriesCount = h;
                            } catch (e3) {
                                o.error(e3);
                            }
                            return o;
                        };
                    },
                    {
                        "../compressions": 3,
                        "./ZipFileWorker": 8
                    }
                ],
                10: [
                    function(e, t, r) {
                        function n() {
                            if (!(this instanceof n)) return new n();
                            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                            this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                                var e2 = new n();
                                for(var t2 in this)"function" != typeof this[t2] && (e2[t2] = this[t2]);
                                return e2;
                            };
                        }
                        (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e2, t2) {
                            return new n().loadAsync(e2, t2);
                        }, n.external = e("./external"), t.exports = n;
                    },
                    {
                        "./defaults": 5,
                        "./external": 6,
                        "./load": 11,
                        "./object": 15,
                        "./support": 30
                    }
                ],
                11: [
                    function(e, t, r) {
                        var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                        function f(n2) {
                            return new i.Promise(function(e2, t2) {
                                var r2 = n2.decompressed.getContentWorker().pipe(new a());
                                r2.on("error", function(e3) {
                                    t2(e3);
                                }).on("end", function() {
                                    r2.streamInfo.crc32 !== n2.decompressed.crc32 ? t2(new Error("Corrupted zip : CRC32 mismatch")) : e2();
                                }).resume();
                            });
                        }
                        t.exports = function(e2, o) {
                            var h = this;
                            return o = u.extend(o || {}, {
                                base64: false,
                                checkCRC32: false,
                                optimizedBinaryString: false,
                                createFolders: false,
                                decodeFileName: n.utf8decode
                            }), l.isNode && l.isStream(e2) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e2, true, o.optimizedBinaryString, o.base64).then(function(e3) {
                                var t2 = new s(o);
                                return t2.load(e3), t2;
                            }).then(function(e3) {
                                var t2 = [
                                    i.Promise.resolve(e3)
                                ], r2 = e3.files;
                                if (o.checkCRC32) for(var n2 = 0; n2 < r2.length; n2++)t2.push(f(r2[n2]));
                                return i.Promise.all(t2);
                            }).then(function(e3) {
                                for(var t2 = e3.shift(), r2 = t2.files, n2 = 0; n2 < r2.length; n2++){
                                    var i2 = r2[n2], s2 = i2.fileNameStr, a2 = u.resolve(i2.fileNameStr);
                                    h.file(a2, i2.decompressed, {
                                        binary: true,
                                        optimizedBinaryString: true,
                                        date: i2.date,
                                        dir: i2.dir,
                                        comment: i2.fileCommentStr.length ? i2.fileCommentStr : null,
                                        unixPermissions: i2.unixPermissions,
                                        dosPermissions: i2.dosPermissions,
                                        createFolders: o.createFolders
                                    }), i2.dir || (h.file(a2).unsafeOriginalName = s2);
                                }
                                return t2.zipComment.length && (h.comment = t2.zipComment), h;
                            });
                        };
                    },
                    {
                        "./external": 6,
                        "./nodejsUtils": 14,
                        "./stream/Crc32Probe": 25,
                        "./utf8": 31,
                        "./utils": 32,
                        "./zipEntries": 33
                    }
                ],
                12: [
                    function(e, t, r) {
                        var n = e("../utils"), i = e("../stream/GenericWorker");
                        function s(e2, t2) {
                            i.call(this, "Nodejs stream input adapter for " + e2), this._upstreamEnded = false, this._bindStream(t2);
                        }
                        n.inherits(s, i), s.prototype._bindStream = function(e2) {
                            var t2 = this;
                            (this._stream = e2).pause(), e2.on("data", function(e3) {
                                t2.push({
                                    data: e3,
                                    meta: {
                                        percent: 0
                                    }
                                });
                            }).on("error", function(e3) {
                                t2.isPaused ? this.generatedError = e3 : t2.error(e3);
                            }).on("end", function() {
                                t2.isPaused ? t2._upstreamEnded = true : t2.end();
                            });
                        }, s.prototype.pause = function() {
                            return !!i.prototype.pause.call(this) && (this._stream.pause(), true);
                        }, s.prototype.resume = function() {
                            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), true);
                        }, t.exports = s;
                    },
                    {
                        "../stream/GenericWorker": 28,
                        "../utils": 32
                    }
                ],
                13: [
                    function(e, t, r) {
                        var i = e("readable-stream").Readable;
                        function n(e2, t2, r2) {
                            i.call(this, t2), this._helper = e2;
                            var n2 = this;
                            e2.on("data", function(e3, t3) {
                                n2.push(e3) || n2._helper.pause(), r2 && r2(t3);
                            }).on("error", function(e3) {
                                n2.emit("error", e3);
                            }).on("end", function() {
                                n2.push(null);
                            });
                        }
                        e("../utils").inherits(n, i), n.prototype._read = function() {
                            this._helper.resume();
                        }, t.exports = n;
                    },
                    {
                        "../utils": 32,
                        "readable-stream": 16
                    }
                ],
                14: [
                    function(e, t, r) {
                        t.exports = {
                            isNode: "undefined" != typeof $be59461d4a783f7b$var$Buffer,
                            newBufferFrom: function(e2, t2) {
                                if ($be59461d4a783f7b$var$Buffer.from && $be59461d4a783f7b$var$Buffer.from !== Uint8Array.from) return $be59461d4a783f7b$var$Buffer.from(e2, t2);
                                if ("number" == typeof e2) throw new Error('The "data" argument must not be a number');
                                return new $be59461d4a783f7b$var$Buffer(e2, t2);
                            },
                            allocBuffer: function(e2) {
                                if ($be59461d4a783f7b$var$Buffer.alloc) return $be59461d4a783f7b$var$Buffer.alloc(e2);
                                var t2 = new $be59461d4a783f7b$var$Buffer(e2);
                                return t2.fill(0), t2;
                            },
                            isBuffer: function(e2) {
                                return $be59461d4a783f7b$var$Buffer.isBuffer(e2);
                            },
                            isStream: function(e2) {
                                return e2 && "function" == typeof e2.on && "function" == typeof e2.pause && "function" == typeof e2.resume;
                            }
                        };
                    },
                    {}
                ],
                15: [
                    function(e, t, r) {
                        function s(e2, t2, r2) {
                            var n2, i2 = u.getTypeOf(t2), s2 = u.extend(r2 || {}, f);
                            s2.date = s2.date || /* @__PURE__ */ new Date(), null !== s2.compression && (s2.compression = s2.compression.toUpperCase()), "string" == typeof s2.unixPermissions && (s2.unixPermissions = parseInt(s2.unixPermissions, 8)), s2.unixPermissions && 16384 & s2.unixPermissions && (s2.dir = true), s2.dosPermissions && 16 & s2.dosPermissions && (s2.dir = true), s2.dir && (e2 = g(e2)), s2.createFolders && (n2 = _(e2)) && b.call(this, n2, true);
                            var a2 = "string" === i2 && false === s2.binary && false === s2.base64;
                            r2 && void 0 !== r2.binary || (s2.binary = !a2), (t2 instanceof c && 0 === t2.uncompressedSize || s2.dir || !t2 || 0 === t2.length) && (s2.base64 = false, s2.binary = true, t2 = "", s2.compression = "STORE", i2 = "string");
                            var o2 = null;
                            o2 = t2 instanceof c || t2 instanceof l ? t2 : p.isNode && p.isStream(t2) ? new m(e2, t2) : u.prepareContent(e2, t2, s2.binary, s2.optimizedBinaryString, s2.base64);
                            var h2 = new d(e2, o2, s2);
                            this.files[e2] = h2;
                        }
                        var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e2) {
                            "/" === e2.slice(-1) && (e2 = e2.substring(0, e2.length - 1));
                            var t2 = e2.lastIndexOf("/");
                            return 0 < t2 ? e2.substring(0, t2) : "";
                        }, g = function(e2) {
                            return "/" !== e2.slice(-1) && (e2 += "/"), e2;
                        }, b = function(e2, t2) {
                            return t2 = void 0 !== t2 ? t2 : f.createFolders, e2 = g(e2), this.files[e2] || s.call(this, e2, null, {
                                dir: true,
                                createFolders: t2
                            }), this.files[e2];
                        };
                        function h(e2) {
                            return "[object RegExp]" === Object.prototype.toString.call(e2);
                        }
                        var n = {
                            load: function() {
                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                            },
                            forEach: function(e2) {
                                var t2, r2, n2;
                                for(t2 in this.files)n2 = this.files[t2], (r2 = t2.slice(this.root.length, t2.length)) && t2.slice(0, this.root.length) === this.root && e2(r2, n2);
                            },
                            filter: function(r2) {
                                var n2 = [];
                                return this.forEach(function(e2, t2) {
                                    r2(e2, t2) && n2.push(t2);
                                }), n2;
                            },
                            file: function(e2, t2, r2) {
                                if (1 !== arguments.length) return e2 = this.root + e2, s.call(this, e2, t2, r2), this;
                                if (h(e2)) {
                                    var n2 = e2;
                                    return this.filter(function(e3, t3) {
                                        return !t3.dir && n2.test(e3);
                                    });
                                }
                                var i2 = this.files[this.root + e2];
                                return i2 && !i2.dir ? i2 : null;
                            },
                            folder: function(r2) {
                                if (!r2) return this;
                                if (h(r2)) return this.filter(function(e3, t3) {
                                    return t3.dir && r2.test(e3);
                                });
                                var e2 = this.root + r2, t2 = b.call(this, e2), n2 = this.clone();
                                return n2.root = t2.name, n2;
                            },
                            remove: function(r2) {
                                r2 = this.root + r2;
                                var e2 = this.files[r2];
                                if (e2 || ("/" !== r2.slice(-1) && (r2 += "/"), e2 = this.files[r2]), e2 && !e2.dir) delete this.files[r2];
                                else for(var t2 = this.filter(function(e3, t3) {
                                    return t3.name.slice(0, r2.length) === r2;
                                }), n2 = 0; n2 < t2.length; n2++)delete this.files[t2[n2].name];
                                return this;
                            },
                            generate: function() {
                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                            },
                            generateInternalStream: function(e2) {
                                var t2, r2 = {};
                                try {
                                    if ((r2 = u.extend(e2 || {}, {
                                        streamFiles: false,
                                        compression: "STORE",
                                        compressionOptions: null,
                                        type: "",
                                        platform: "DOS",
                                        comment: null,
                                        mimeType: "application/zip",
                                        encodeFileName: i.utf8encode
                                    })).type = r2.type.toLowerCase(), r2.compression = r2.compression.toUpperCase(), "binarystring" === r2.type && (r2.type = "string"), !r2.type) throw new Error("No output type specified.");
                                    u.checkSupport(r2.type), "darwin" !== r2.platform && "freebsd" !== r2.platform && "linux" !== r2.platform && "sunos" !== r2.platform || (r2.platform = "UNIX"), "win32" === r2.platform && (r2.platform = "DOS");
                                    var n2 = r2.comment || this.comment || "";
                                    t2 = o.generateWorker(this, r2, n2);
                                } catch (e3) {
                                    (t2 = new l("error")).error(e3);
                                }
                                return new a(t2, r2.type || "string", r2.mimeType);
                            },
                            generateAsync: function(e2, t2) {
                                return this.generateInternalStream(e2).accumulate(t2);
                            },
                            generateNodeStream: function(e2, t2) {
                                return (e2 = e2 || {}).type || (e2.type = "nodebuffer"), this.generateInternalStream(e2).toNodejsStream(t2);
                            }
                        };
                        t.exports = n;
                    },
                    {
                        "./compressedObject": 2,
                        "./defaults": 5,
                        "./generate": 9,
                        "./nodejs/NodejsStreamInputAdapter": 12,
                        "./nodejsUtils": 14,
                        "./stream/GenericWorker": 28,
                        "./stream/StreamHelper": 29,
                        "./utf8": 31,
                        "./utils": 32,
                        "./zipObject": 35
                    }
                ],
                16: [
                    function(e, t, r) {
                        t.exports = e("stream");
                    },
                    {
                        stream: void 0
                    }
                ],
                17: [
                    function(e, t, r) {
                        var n = e("./DataReader");
                        function i(e2) {
                            n.call(this, e2);
                            for(var t2 = 0; t2 < this.data.length; t2++)e2[t2] = 255 & e2[t2];
                        }
                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
                            return this.data[this.zero + e2];
                        }, i.prototype.lastIndexOfSignature = function(e2) {
                            for(var t2 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t2 && this.data[s + 1] === r2 && this.data[s + 2] === n2 && this.data[s + 3] === i2) return s - this.zero;
                            return -1;
                        }, i.prototype.readAndCheckSignature = function(e2) {
                            var t2 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.readData(4);
                            return t2 === s[0] && r2 === s[1] && n2 === s[2] && i2 === s[3];
                        }, i.prototype.readData = function(e2) {
                            if (this.checkOffset(e2), 0 === e2) return [];
                            var t2 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
                            return this.index += e2, t2;
                        }, t.exports = i;
                    },
                    {
                        "../utils": 32,
                        "./DataReader": 18
                    }
                ],
                18: [
                    function(e, t, r) {
                        var n = e("../utils");
                        function i(e2) {
                            this.data = e2, this.length = e2.length, this.index = 0, this.zero = 0;
                        }
                        i.prototype = {
                            checkOffset: function(e2) {
                                this.checkIndex(this.index + e2);
                            },
                            checkIndex: function(e2) {
                                if (this.length < this.zero + e2 || e2 < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e2 + "). Corrupted zip ?");
                            },
                            setIndex: function(e2) {
                                this.checkIndex(e2), this.index = e2;
                            },
                            skip: function(e2) {
                                this.setIndex(this.index + e2);
                            },
                            byteAt: function() {},
                            readInt: function(e2) {
                                var t2, r2 = 0;
                                for(this.checkOffset(e2), t2 = this.index + e2 - 1; t2 >= this.index; t2--)r2 = (r2 << 8) + this.byteAt(t2);
                                return this.index += e2, r2;
                            },
                            readString: function(e2) {
                                return n.transformTo("string", this.readData(e2));
                            },
                            readData: function() {},
                            lastIndexOfSignature: function() {},
                            readAndCheckSignature: function() {},
                            readDate: function() {
                                var e2 = this.readInt(4);
                                return new Date(Date.UTC(1980 + (e2 >> 25 & 127), (e2 >> 21 & 15) - 1, e2 >> 16 & 31, e2 >> 11 & 31, e2 >> 5 & 63, (31 & e2) << 1));
                            }
                        }, t.exports = i;
                    },
                    {
                        "../utils": 32
                    }
                ],
                19: [
                    function(e, t, r) {
                        var n = e("./Uint8ArrayReader");
                        function i(e2) {
                            n.call(this, e2);
                        }
                        e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
                            this.checkOffset(e2);
                            var t2 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
                            return this.index += e2, t2;
                        }, t.exports = i;
                    },
                    {
                        "../utils": 32,
                        "./Uint8ArrayReader": 21
                    }
                ],
                20: [
                    function(e, t, r) {
                        var n = e("./DataReader");
                        function i(e2) {
                            n.call(this, e2);
                        }
                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
                            return this.data.charCodeAt(this.zero + e2);
                        }, i.prototype.lastIndexOfSignature = function(e2) {
                            return this.data.lastIndexOf(e2) - this.zero;
                        }, i.prototype.readAndCheckSignature = function(e2) {
                            return e2 === this.readData(4);
                        }, i.prototype.readData = function(e2) {
                            this.checkOffset(e2);
                            var t2 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
                            return this.index += e2, t2;
                        }, t.exports = i;
                    },
                    {
                        "../utils": 32,
                        "./DataReader": 18
                    }
                ],
                21: [
                    function(e, t, r) {
                        var n = e("./ArrayReader");
                        function i(e2) {
                            n.call(this, e2);
                        }
                        e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
                            if (this.checkOffset(e2), 0 === e2) return new Uint8Array(0);
                            var t2 = this.data.subarray(this.zero + this.index, this.zero + this.index + e2);
                            return this.index += e2, t2;
                        }, t.exports = i;
                    },
                    {
                        "../utils": 32,
                        "./ArrayReader": 17
                    }
                ],
                22: [
                    function(e, t, r) {
                        var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                        t.exports = function(e2) {
                            var t2 = n.getTypeOf(e2);
                            return n.checkSupport(t2), "string" !== t2 || i.uint8array ? "nodebuffer" === t2 ? new o(e2) : i.uint8array ? new h(n.transformTo("uint8array", e2)) : new s(n.transformTo("array", e2)) : new a(e2);
                        };
                    },
                    {
                        "../support": 30,
                        "../utils": 32,
                        "./ArrayReader": 17,
                        "./NodeBufferReader": 19,
                        "./StringReader": 20,
                        "./Uint8ArrayReader": 21
                    }
                ],
                23: [
                    function(e, t, r) {
                        r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\x07\b";
                    },
                    {}
                ],
                24: [
                    function(e, t, r) {
                        var n = e("./GenericWorker"), i = e("../utils");
                        function s(e2) {
                            n.call(this, "ConvertWorker to " + e2), this.destType = e2;
                        }
                        i.inherits(s, n), s.prototype.processChunk = function(e2) {
                            this.push({
                                data: i.transformTo(this.destType, e2.data),
                                meta: e2.meta
                            });
                        }, t.exports = s;
                    },
                    {
                        "../utils": 32,
                        "./GenericWorker": 28
                    }
                ],
                25: [
                    function(e, t, r) {
                        var n = e("./GenericWorker"), i = e("../crc32");
                        function s() {
                            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                        }
                        e("../utils").inherits(s, n), s.prototype.processChunk = function(e2) {
                            this.streamInfo.crc32 = i(e2.data, this.streamInfo.crc32 || 0), this.push(e2);
                        }, t.exports = s;
                    },
                    {
                        "../crc32": 4,
                        "../utils": 32,
                        "./GenericWorker": 28
                    }
                ],
                26: [
                    function(e, t, r) {
                        var n = e("../utils"), i = e("./GenericWorker");
                        function s(e2) {
                            i.call(this, "DataLengthProbe for " + e2), this.propName = e2, this.withStreamInfo(e2, 0);
                        }
                        n.inherits(s, i), s.prototype.processChunk = function(e2) {
                            if (e2) {
                                var t2 = this.streamInfo[this.propName] || 0;
                                this.streamInfo[this.propName] = t2 + e2.data.length;
                            }
                            i.prototype.processChunk.call(this, e2);
                        }, t.exports = s;
                    },
                    {
                        "../utils": 32,
                        "./GenericWorker": 28
                    }
                ],
                27: [
                    function(e, t, r) {
                        var n = e("../utils"), i = e("./GenericWorker");
                        function s(e2) {
                            i.call(this, "DataWorker");
                            var t2 = this;
                            this.dataIsReady = false, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = false, e2.then(function(e3) {
                                t2.dataIsReady = true, t2.data = e3, t2.max = e3 && e3.length || 0, t2.type = n.getTypeOf(e3), t2.isPaused || t2._tickAndRepeat();
                            }, function(e3) {
                                t2.error(e3);
                            });
                        }
                        n.inherits(s, i), s.prototype.cleanUp = function() {
                            i.prototype.cleanUp.call(this), this.data = null;
                        }, s.prototype.resume = function() {
                            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = true, n.delay(this._tickAndRepeat, [], this)), true);
                        }, s.prototype._tickAndRepeat = function() {
                            this._tickScheduled = false, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = true));
                        }, s.prototype._tick = function() {
                            if (this.isPaused || this.isFinished) return false;
                            var e2 = null, t2 = Math.min(this.max, this.index + 16384);
                            if (this.index >= this.max) return this.end();
                            switch(this.type){
                                case "string":
                                    e2 = this.data.substring(this.index, t2);
                                    break;
                                case "uint8array":
                                    e2 = this.data.subarray(this.index, t2);
                                    break;
                                case "array":
                                case "nodebuffer":
                                    e2 = this.data.slice(this.index, t2);
                            }
                            return this.index = t2, this.push({
                                data: e2,
                                meta: {
                                    percent: this.max ? this.index / this.max * 100 : 0
                                }
                            });
                        }, t.exports = s;
                    },
                    {
                        "../utils": 32,
                        "./GenericWorker": 28
                    }
                ],
                28: [
                    function(e, t, r) {
                        function n(e2) {
                            this.name = e2 || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = true, this.isFinished = false, this.isLocked = false, this._listeners = {
                                data: [],
                                end: [],
                                error: []
                            }, this.previous = null;
                        }
                        n.prototype = {
                            push: function(e2) {
                                this.emit("data", e2);
                            },
                            end: function() {
                                if (this.isFinished) return false;
                                this.flush();
                                try {
                                    this.emit("end"), this.cleanUp(), this.isFinished = true;
                                } catch (e2) {
                                    this.emit("error", e2);
                                }
                                return true;
                            },
                            error: function(e2) {
                                return !this.isFinished && (this.isPaused ? this.generatedError = e2 : (this.isFinished = true, this.emit("error", e2), this.previous && this.previous.error(e2), this.cleanUp()), true);
                            },
                            on: function(e2, t2) {
                                return this._listeners[e2].push(t2), this;
                            },
                            cleanUp: function() {
                                this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                            },
                            emit: function(e2, t2) {
                                if (this._listeners[e2]) for(var r2 = 0; r2 < this._listeners[e2].length; r2++)this._listeners[e2][r2].call(this, t2);
                            },
                            pipe: function(e2) {
                                return e2.registerPrevious(this);
                            },
                            registerPrevious: function(e2) {
                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                this.streamInfo = e2.streamInfo, this.mergeStreamInfo(), this.previous = e2;
                                var t2 = this;
                                return e2.on("data", function(e3) {
                                    t2.processChunk(e3);
                                }), e2.on("end", function() {
                                    t2.end();
                                }), e2.on("error", function(e3) {
                                    t2.error(e3);
                                }), this;
                            },
                            pause: function() {
                                return !this.isPaused && !this.isFinished && (this.isPaused = true, this.previous && this.previous.pause(), true);
                            },
                            resume: function() {
                                if (!this.isPaused || this.isFinished) return false;
                                var e2 = this.isPaused = false;
                                return this.generatedError && (this.error(this.generatedError), e2 = true), this.previous && this.previous.resume(), !e2;
                            },
                            flush: function() {},
                            processChunk: function(e2) {
                                this.push(e2);
                            },
                            withStreamInfo: function(e2, t2) {
                                return this.extraStreamInfo[e2] = t2, this.mergeStreamInfo(), this;
                            },
                            mergeStreamInfo: function() {
                                for(var e2 in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e2) && (this.streamInfo[e2] = this.extraStreamInfo[e2]);
                            },
                            lock: function() {
                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                this.isLocked = true, this.previous && this.previous.lock();
                            },
                            toString: function() {
                                var e2 = "Worker " + this.name;
                                return this.previous ? this.previous + " -> " + e2 : e2;
                            }
                        }, t.exports = n;
                    },
                    {}
                ],
                29: [
                    function(e, t, r) {
                        var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                        if (n.nodestream) try {
                            o = e("../nodejs/NodejsStreamOutputAdapter");
                        } catch (e2) {}
                        function l(e2, o2) {
                            return new a.Promise(function(t2, r2) {
                                var n2 = [], i2 = e2._internalType, s2 = e2._outputType, a2 = e2._mimeType;
                                e2.on("data", function(e3, t3) {
                                    n2.push(e3), o2 && o2(t3);
                                }).on("error", function(e3) {
                                    n2 = [], r2(e3);
                                }).on("end", function() {
                                    try {
                                        var e3 = function(e4, t3, r3) {
                                            switch(e4){
                                                case "blob":
                                                    return h.newBlob(h.transformTo("arraybuffer", t3), r3);
                                                case "base64":
                                                    return u.encode(t3);
                                                default:
                                                    return h.transformTo(e4, t3);
                                            }
                                        }(s2, function(e4, t3) {
                                            var r3, n3 = 0, i3 = null, s3 = 0;
                                            for(r3 = 0; r3 < t3.length; r3++)s3 += t3[r3].length;
                                            switch(e4){
                                                case "string":
                                                    return t3.join("");
                                                case "array":
                                                    return Array.prototype.concat.apply([], t3);
                                                case "uint8array":
                                                    for(i3 = new Uint8Array(s3), r3 = 0; r3 < t3.length; r3++)i3.set(t3[r3], n3), n3 += t3[r3].length;
                                                    return i3;
                                                case "nodebuffer":
                                                    return $be59461d4a783f7b$var$Buffer.concat(t3);
                                                default:
                                                    throw new Error("concat : unsupported type '" + e4 + "'");
                                            }
                                        }(i2, n2), a2);
                                        t2(e3);
                                    } catch (e4) {
                                        r2(e4);
                                    }
                                    n2 = [];
                                }).resume();
                            });
                        }
                        function f(e2, t2, r2) {
                            var n2 = t2;
                            switch(t2){
                                case "blob":
                                case "arraybuffer":
                                    n2 = "uint8array";
                                    break;
                                case "base64":
                                    n2 = "string";
                            }
                            try {
                                this._internalType = n2, this._outputType = t2, this._mimeType = r2, h.checkSupport(n2), this._worker = e2.pipe(new i(n2)), e2.lock();
                            } catch (e3) {
                                this._worker = new s("error"), this._worker.error(e3);
                            }
                        }
                        f.prototype = {
                            accumulate: function(e2) {
                                return l(this, e2);
                            },
                            on: function(e2, t2) {
                                var r2 = this;
                                return "data" === e2 ? this._worker.on(e2, function(e3) {
                                    t2.call(r2, e3.data, e3.meta);
                                }) : this._worker.on(e2, function() {
                                    h.delay(t2, arguments, r2);
                                }), this;
                            },
                            resume: function() {
                                return h.delay(this._worker.resume, [], this._worker), this;
                            },
                            pause: function() {
                                return this._worker.pause(), this;
                            },
                            toNodejsStream: function(e2) {
                                if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                return new o(this, {
                                    objectMode: "nodebuffer" !== this._outputType
                                }, e2);
                            }
                        }, t.exports = f;
                    },
                    {
                        "../base64": 1,
                        "../external": 6,
                        "../nodejs/NodejsStreamOutputAdapter": 13,
                        "../support": 30,
                        "../utils": 32,
                        "./ConvertWorker": 24,
                        "./GenericWorker": 28
                    }
                ],
                30: [
                    function(e, t, r) {
                        if (r.base64 = true, r.array = true, r.string = true, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $be59461d4a783f7b$var$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = false;
                        else {
                            var n = new ArrayBuffer(0);
                            try {
                                r.blob = 0 === new Blob([
                                    n
                                ], {
                                    type: "application/zip"
                                }).size;
                            } catch (e2) {
                                try {
                                    var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                                    i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                                } catch (e3) {
                                    r.blob = false;
                                }
                            }
                        }
                        try {
                            r.nodestream = !!e("readable-stream").Readable;
                        } catch (e2) {
                            r.nodestream = false;
                        }
                    },
                    {
                        "readable-stream": 16
                    }
                ],
                31: [
                    function(e, t, s) {
                        for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                        u[254] = u[254] = 1;
                        function a() {
                            n.call(this, "utf-8 decode"), this.leftOver = null;
                        }
                        function l() {
                            n.call(this, "utf-8 encode");
                        }
                        s.utf8encode = function(e2) {
                            return h.nodebuffer ? r.newBufferFrom(e2, "utf-8") : function(e3) {
                                var t2, r2, n2, i2, s2, a2 = e3.length, o2 = 0;
                                for(i2 = 0; i2 < a2; i2++)55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o2 += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
                                for(t2 = h.uint8array ? new Uint8Array(o2) : new Array(o2), i2 = s2 = 0; s2 < o2; i2++)55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t2[s2++] = r2 : (r2 < 2048 ? t2[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t2[s2++] = 224 | r2 >>> 12 : (t2[s2++] = 240 | r2 >>> 18, t2[s2++] = 128 | r2 >>> 12 & 63), t2[s2++] = 128 | r2 >>> 6 & 63), t2[s2++] = 128 | 63 & r2);
                                return t2;
                            }(e2);
                        }, s.utf8decode = function(e2) {
                            return h.nodebuffer ? o.transformTo("nodebuffer", e2).toString("utf-8") : function(e3) {
                                var t2, r2, n2, i2, s2 = e3.length, a2 = new Array(2 * s2);
                                for(t2 = r2 = 0; t2 < s2;)if ((n2 = e3[t2++]) < 128) a2[r2++] = n2;
                                else if (4 < (i2 = u[n2])) a2[r2++] = 65533, t2 += i2 - 1;
                                else {
                                    for(n2 &= 2 === i2 ? 31 : 3 === i2 ? 15 : 7; 1 < i2 && t2 < s2;)n2 = n2 << 6 | 63 & e3[t2++], i2--;
                                    1 < i2 ? a2[r2++] = 65533 : n2 < 65536 ? a2[r2++] = n2 : (n2 -= 65536, a2[r2++] = 55296 | n2 >> 10 & 1023, a2[r2++] = 56320 | 1023 & n2);
                                }
                                return a2.length !== r2 && (a2.subarray ? a2 = a2.subarray(0, r2) : a2.length = r2), o.applyFromCharCode(a2);
                            }(e2 = o.transformTo(h.uint8array ? "uint8array" : "array", e2));
                        }, o.inherits(a, n), a.prototype.processChunk = function(e2) {
                            var t2 = o.transformTo(h.uint8array ? "uint8array" : "array", e2.data);
                            if (this.leftOver && this.leftOver.length) {
                                if (h.uint8array) {
                                    var r2 = t2;
                                    (t2 = new Uint8Array(r2.length + this.leftOver.length)).set(this.leftOver, 0), t2.set(r2, this.leftOver.length);
                                } else t2 = this.leftOver.concat(t2);
                                this.leftOver = null;
                            }
                            var n2 = function(e3, t3) {
                                var r3;
                                for((t3 = t3 || e3.length) > e3.length && (t3 = e3.length), r3 = t3 - 1; 0 <= r3 && 128 == (192 & e3[r3]);)r3--;
                                return r3 < 0 ? t3 : 0 === r3 ? t3 : r3 + u[e3[r3]] > t3 ? r3 : t3;
                            }(t2), i2 = t2;
                            n2 !== t2.length && (h.uint8array ? (i2 = t2.subarray(0, n2), this.leftOver = t2.subarray(n2, t2.length)) : (i2 = t2.slice(0, n2), this.leftOver = t2.slice(n2, t2.length))), this.push({
                                data: s.utf8decode(i2),
                                meta: e2.meta
                            });
                        }, a.prototype.flush = function() {
                            this.leftOver && this.leftOver.length && (this.push({
                                data: s.utf8decode(this.leftOver),
                                meta: {}
                            }), this.leftOver = null);
                        }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e2) {
                            this.push({
                                data: s.utf8encode(e2.data),
                                meta: e2.meta
                            });
                        }, s.Utf8EncodeWorker = l;
                    },
                    {
                        "./nodejsUtils": 14,
                        "./stream/GenericWorker": 28,
                        "./support": 30,
                        "./utils": 32
                    }
                ],
                32: [
                    function(e, t, a) {
                        var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                        function n(e2) {
                            return e2;
                        }
                        function l(e2, t2) {
                            for(var r2 = 0; r2 < e2.length; ++r2)t2[r2] = 255 & e2.charCodeAt(r2);
                            return t2;
                        }
                        e("setimmediate"), a.newBlob = function(t2, r2) {
                            a.checkSupport("blob");
                            try {
                                return new Blob([
                                    t2
                                ], {
                                    type: r2
                                });
                            } catch (e2) {
                                try {
                                    var n2 = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                                    return n2.append(t2), n2.getBlob(r2);
                                } catch (e3) {
                                    throw new Error("Bug : can't construct the Blob.");
                                }
                            }
                        };
                        var i = {
                            stringifyByChunk: function(e2, t2, r2) {
                                var n2 = [], i2 = 0, s2 = e2.length;
                                if (s2 <= r2) return String.fromCharCode.apply(null, e2);
                                for(; i2 < s2;)"array" === t2 || "nodebuffer" === t2 ? n2.push(String.fromCharCode.apply(null, e2.slice(i2, Math.min(i2 + r2, s2)))) : n2.push(String.fromCharCode.apply(null, e2.subarray(i2, Math.min(i2 + r2, s2)))), i2 += r2;
                                return n2.join("");
                            },
                            stringifyByChar: function(e2) {
                                for(var t2 = "", r2 = 0; r2 < e2.length; r2++)t2 += String.fromCharCode(e2[r2]);
                                return t2;
                            },
                            applyCanBeUsed: {
                                uint8array: function() {
                                    try {
                                        return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                    } catch (e2) {
                                        return false;
                                    }
                                }(),
                                nodebuffer: function() {
                                    try {
                                        return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                                    } catch (e2) {
                                        return false;
                                    }
                                }()
                            }
                        };
                        function s(e2) {
                            var t2 = 65536, r2 = a.getTypeOf(e2), n2 = true;
                            if ("uint8array" === r2 ? n2 = i.applyCanBeUsed.uint8array : "nodebuffer" === r2 && (n2 = i.applyCanBeUsed.nodebuffer), n2) for(; 1 < t2;)try {
                                return i.stringifyByChunk(e2, r2, t2);
                            } catch (e3) {
                                t2 = Math.floor(t2 / 2);
                            }
                            return i.stringifyByChar(e2);
                        }
                        function f(e2, t2) {
                            for(var r2 = 0; r2 < e2.length; r2++)t2[r2] = e2[r2];
                            return t2;
                        }
                        a.applyFromCharCode = s;
                        var c = {};
                        c.string = {
                            string: n,
                            array: function(e2) {
                                return l(e2, new Array(e2.length));
                            },
                            arraybuffer: function(e2) {
                                return c.string.uint8array(e2).buffer;
                            },
                            uint8array: function(e2) {
                                return l(e2, new Uint8Array(e2.length));
                            },
                            nodebuffer: function(e2) {
                                return l(e2, r.allocBuffer(e2.length));
                            }
                        }, c.array = {
                            string: s,
                            array: n,
                            arraybuffer: function(e2) {
                                return new Uint8Array(e2).buffer;
                            },
                            uint8array: function(e2) {
                                return new Uint8Array(e2);
                            },
                            nodebuffer: function(e2) {
                                return r.newBufferFrom(e2);
                            }
                        }, c.arraybuffer = {
                            string: function(e2) {
                                return s(new Uint8Array(e2));
                            },
                            array: function(e2) {
                                return f(new Uint8Array(e2), new Array(e2.byteLength));
                            },
                            arraybuffer: n,
                            uint8array: function(e2) {
                                return new Uint8Array(e2);
                            },
                            nodebuffer: function(e2) {
                                return r.newBufferFrom(new Uint8Array(e2));
                            }
                        }, c.uint8array = {
                            string: s,
                            array: function(e2) {
                                return f(e2, new Array(e2.length));
                            },
                            arraybuffer: function(e2) {
                                return e2.buffer;
                            },
                            uint8array: n,
                            nodebuffer: function(e2) {
                                return r.newBufferFrom(e2);
                            }
                        }, c.nodebuffer = {
                            string: s,
                            array: function(e2) {
                                return f(e2, new Array(e2.length));
                            },
                            arraybuffer: function(e2) {
                                return c.nodebuffer.uint8array(e2).buffer;
                            },
                            uint8array: function(e2) {
                                return f(e2, new Uint8Array(e2.length));
                            },
                            nodebuffer: n
                        }, a.transformTo = function(e2, t2) {
                            if (t2 = t2 || "", !e2) return t2;
                            a.checkSupport(e2);
                            var r2 = a.getTypeOf(t2);
                            return c[r2][e2](t2);
                        }, a.resolve = function(e2) {
                            for(var t2 = e2.split("/"), r2 = [], n2 = 0; n2 < t2.length; n2++){
                                var i2 = t2[n2];
                                "." === i2 || "" === i2 && 0 !== n2 && n2 !== t2.length - 1 || (".." === i2 ? r2.pop() : r2.push(i2));
                            }
                            return r2.join("/");
                        }, a.getTypeOf = function(e2) {
                            return "string" == typeof e2 ? "string" : "[object Array]" === Object.prototype.toString.call(e2) ? "array" : o.nodebuffer && r.isBuffer(e2) ? "nodebuffer" : o.uint8array && e2 instanceof Uint8Array ? "uint8array" : o.arraybuffer && e2 instanceof ArrayBuffer ? "arraybuffer" : void 0;
                        }, a.checkSupport = function(e2) {
                            if (!o[e2.toLowerCase()]) throw new Error(e2 + " is not supported by this platform");
                        }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e2) {
                            var t2, r2, n2 = "";
                            for(r2 = 0; r2 < (e2 || "").length; r2++)n2 += "\\x" + ((t2 = e2.charCodeAt(r2)) < 16 ? "0" : "") + t2.toString(16).toUpperCase();
                            return n2;
                        }, a.delay = function(e2, t2, r2) {
                            setImmediate(function() {
                                e2.apply(r2 || null, t2 || []);
                            });
                        }, a.inherits = function(e2, t2) {
                            function r2() {}
                            r2.prototype = t2.prototype, e2.prototype = new r2();
                        }, a.extend = function() {
                            var e2, t2, r2 = {};
                            for(e2 = 0; e2 < arguments.length; e2++)for(t2 in arguments[e2])Object.prototype.hasOwnProperty.call(arguments[e2], t2) && void 0 === r2[t2] && (r2[t2] = arguments[e2][t2]);
                            return r2;
                        }, a.prepareContent = function(r2, e2, n2, i2, s2) {
                            return u.Promise.resolve(e2).then(function(n3) {
                                return o.blob && (n3 instanceof Blob || -1 !== [
                                    "[object File]",
                                    "[object Blob]"
                                ].indexOf(Object.prototype.toString.call(n3))) && "undefined" != typeof FileReader ? new u.Promise(function(t2, r3) {
                                    var e3 = new FileReader();
                                    e3.onload = function(e4) {
                                        t2(e4.target.result);
                                    }, e3.onerror = function(e4) {
                                        r3(e4.target.error);
                                    }, e3.readAsArrayBuffer(n3);
                                }) : n3;
                            }).then(function(e3) {
                                var t2 = a.getTypeOf(e3);
                                return t2 ? ("arraybuffer" === t2 ? e3 = a.transformTo("uint8array", e3) : "string" === t2 && (s2 ? e3 = h.decode(e3) : n2 && true !== i2 && (e3 = function(e4) {
                                    return l(e4, o.uint8array ? new Uint8Array(e4.length) : new Array(e4.length));
                                }(e3))), e3) : u.Promise.reject(new Error("Can't read the data of '" + r2 + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                            });
                        };
                    },
                    {
                        "./base64": 1,
                        "./external": 6,
                        "./nodejsUtils": 14,
                        "./support": 30,
                        setimmediate: 54
                    }
                ],
                33: [
                    function(e, t, r) {
                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                        function h(e2) {
                            this.files = [], this.loadOptions = e2;
                        }
                        h.prototype = {
                            checkSignature: function(e2) {
                                if (!this.reader.readAndCheckSignature(e2)) {
                                    this.reader.index -= 4;
                                    var t2 = this.reader.readString(4);
                                    throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t2) + ", expected " + i.pretty(e2) + ")");
                                }
                            },
                            isSignature: function(e2, t2) {
                                var r2 = this.reader.index;
                                this.reader.setIndex(e2);
                                var n2 = this.reader.readString(4) === t2;
                                return this.reader.setIndex(r2), n2;
                            },
                            readBlockEndOfCentral: function() {
                                this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                var e2 = this.reader.readData(this.zipCommentLength), t2 = o.uint8array ? "uint8array" : "array", r2 = i.transformTo(t2, e2);
                                this.zipComment = this.loadOptions.decodeFileName(r2);
                            },
                            readBlockZip64EndOfCentral: function() {
                                this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                                for(var e2, t2, r2, n2 = this.zip64EndOfCentralSize - 44; 0 < n2;)e2 = this.reader.readInt(2), t2 = this.reader.readInt(4), r2 = this.reader.readData(t2), this.zip64ExtensibleData[e2] = {
                                    id: e2,
                                    length: t2,
                                    value: r2
                                };
                            },
                            readBlockZip64EndOfCentralLocator: function() {
                                if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                            },
                            readLocalFiles: function() {
                                var e2, t2;
                                for(e2 = 0; e2 < this.files.length; e2++)t2 = this.files[e2], this.reader.setIndex(t2.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t2.readLocalPart(this.reader), t2.handleUTF8(), t2.processAttributes();
                            },
                            readCentralDir: function() {
                                var e2;
                                for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e2 = new a({
                                    zip64: this.zip64
                                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e2);
                                if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                            },
                            readEndOfCentral: function() {
                                var e2 = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                                if (e2 < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                                this.reader.setIndex(e2);
                                var t2 = e2;
                                if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                    if (this.zip64 = true, (e2 = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                    if (this.reader.setIndex(e2), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                }
                                var r2 = this.centralDirOffset + this.centralDirSize;
                                this.zip64 && (r2 += 20, r2 += 12 + this.zip64EndOfCentralSize);
                                var n2 = t2 - r2;
                                if (0 < n2) this.isSignature(t2, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n2);
                                else if (n2 < 0) throw new Error("Corrupted zip: missing " + Math.abs(n2) + " bytes.");
                            },
                            prepareReader: function(e2) {
                                this.reader = n(e2);
                            },
                            load: function(e2) {
                                this.prepareReader(e2), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                            }
                        }, t.exports = h;
                    },
                    {
                        "./reader/readerFor": 22,
                        "./signature": 23,
                        "./support": 30,
                        "./utils": 32,
                        "./zipEntry": 34
                    }
                ],
                34: [
                    function(e, t, r) {
                        var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                        function l(e2, t2) {
                            this.options = e2, this.loadOptions = t2;
                        }
                        l.prototype = {
                            isEncrypted: function() {
                                return 1 == (1 & this.bitFlag);
                            },
                            useUTF8: function() {
                                return 2048 == (2048 & this.bitFlag);
                            },
                            readLocalPart: function(e2) {
                                var t2, r2;
                                if (e2.skip(22), this.fileNameLength = e2.readInt(2), r2 = e2.readInt(2), this.fileName = e2.readData(this.fileNameLength), e2.skip(r2), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                if (null === (t2 = function(e3) {
                                    for(var t3 in h)if (Object.prototype.hasOwnProperty.call(h, t3) && h[t3].magic === e3) return h[t3];
                                    return null;
                                }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                                this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t2, e2.readData(this.compressedSize));
                            },
                            readCentralPart: function(e2) {
                                this.versionMadeBy = e2.readInt(2), e2.skip(2), this.bitFlag = e2.readInt(2), this.compressionMethod = e2.readString(2), this.date = e2.readDate(), this.crc32 = e2.readInt(4), this.compressedSize = e2.readInt(4), this.uncompressedSize = e2.readInt(4);
                                var t2 = e2.readInt(2);
                                if (this.extraFieldsLength = e2.readInt(2), this.fileCommentLength = e2.readInt(2), this.diskNumberStart = e2.readInt(2), this.internalFileAttributes = e2.readInt(2), this.externalFileAttributes = e2.readInt(4), this.localHeaderOffset = e2.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                e2.skip(t2), this.readExtraFields(e2), this.parseZIP64ExtraField(e2), this.fileComment = e2.readData(this.fileCommentLength);
                            },
                            processAttributes: function() {
                                this.unixPermissions = null, this.dosPermissions = null;
                                var e2 = this.versionMadeBy >> 8;
                                this.dir = !!(16 & this.externalFileAttributes), 0 == e2 && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e2 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = true);
                            },
                            parseZIP64ExtraField: function() {
                                if (this.extraFields[1]) {
                                    var e2 = n(this.extraFields[1].value);
                                    this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e2.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e2.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e2.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e2.readInt(4));
                                }
                            },
                            readExtraFields: function(e2) {
                                var t2, r2, n2, i2 = e2.index + this.extraFieldsLength;
                                for(this.extraFields || (this.extraFields = {}); e2.index + 4 < i2;)t2 = e2.readInt(2), r2 = e2.readInt(2), n2 = e2.readData(r2), this.extraFields[t2] = {
                                    id: t2,
                                    length: r2,
                                    value: n2
                                };
                                e2.setIndex(i2);
                            },
                            handleUTF8: function() {
                                var e2 = u.uint8array ? "uint8array" : "array";
                                if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                                else {
                                    var t2 = this.findExtraFieldUnicodePath();
                                    if (null !== t2) this.fileNameStr = t2;
                                    else {
                                        var r2 = s.transformTo(e2, this.fileName);
                                        this.fileNameStr = this.loadOptions.decodeFileName(r2);
                                    }
                                    var n2 = this.findExtraFieldUnicodeComment();
                                    if (null !== n2) this.fileCommentStr = n2;
                                    else {
                                        var i2 = s.transformTo(e2, this.fileComment);
                                        this.fileCommentStr = this.loadOptions.decodeFileName(i2);
                                    }
                                }
                            },
                            findExtraFieldUnicodePath: function() {
                                var e2 = this.extraFields[28789];
                                if (e2) {
                                    var t2 = n(e2.value);
                                    return 1 !== t2.readInt(1) ? null : a(this.fileName) !== t2.readInt(4) ? null : o.utf8decode(t2.readData(e2.length - 5));
                                }
                                return null;
                            },
                            findExtraFieldUnicodeComment: function() {
                                var e2 = this.extraFields[25461];
                                if (e2) {
                                    var t2 = n(e2.value);
                                    return 1 !== t2.readInt(1) ? null : a(this.fileComment) !== t2.readInt(4) ? null : o.utf8decode(t2.readData(e2.length - 5));
                                }
                                return null;
                            }
                        }, t.exports = l;
                    },
                    {
                        "./compressedObject": 2,
                        "./compressions": 3,
                        "./crc32": 4,
                        "./reader/readerFor": 22,
                        "./support": 30,
                        "./utf8": 31,
                        "./utils": 32
                    }
                ],
                35: [
                    function(e, t, r) {
                        function n(e2, t2, r2) {
                            this.name = e2, this.dir = r2.dir, this.date = r2.date, this.comment = r2.comment, this.unixPermissions = r2.unixPermissions, this.dosPermissions = r2.dosPermissions, this._data = t2, this._dataBinary = r2.binary, this.options = {
                                compression: r2.compression,
                                compressionOptions: r2.compressionOptions
                            };
                        }
                        var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                        n.prototype = {
                            internalStream: function(e2) {
                                var t2 = null, r2 = "string";
                                try {
                                    if (!e2) throw new Error("No output type specified.");
                                    var n2 = "string" === (r2 = e2.toLowerCase()) || "text" === r2;
                                    "binarystring" !== r2 && "text" !== r2 || (r2 = "string"), t2 = this._decompressWorker();
                                    var i2 = !this._dataBinary;
                                    i2 && !n2 && (t2 = t2.pipe(new a.Utf8EncodeWorker())), !i2 && n2 && (t2 = t2.pipe(new a.Utf8DecodeWorker()));
                                } catch (e3) {
                                    (t2 = new h("error")).error(e3);
                                }
                                return new s(t2, r2, "");
                            },
                            async: function(e2, t2) {
                                return this.internalStream(e2).accumulate(t2);
                            },
                            nodeStream: function(e2, t2) {
                                return this.internalStream(e2 || "nodebuffer").toNodejsStream(t2);
                            },
                            _compressWorker: function(e2, t2) {
                                if (this._data instanceof o && this._data.compression.magic === e2.magic) return this._data.getCompressedWorker();
                                var r2 = this._decompressWorker();
                                return this._dataBinary || (r2 = r2.pipe(new a.Utf8EncodeWorker())), o.createWorkerFrom(r2, e2, t2);
                            },
                            _decompressWorker: function() {
                                return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                            }
                        };
                        for(var u = [
                            "asText",
                            "asBinary",
                            "asNodeBuffer",
                            "asUint8Array",
                            "asArrayBuffer"
                        ], l = function() {
                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                        }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                        t.exports = n;
                    },
                    {
                        "./compressedObject": 2,
                        "./stream/DataWorker": 27,
                        "./stream/GenericWorker": 28,
                        "./stream/StreamHelper": 29,
                        "./utf8": 31
                    }
                ],
                36: [
                    function(e, l, t) {
                        (function(t2) {
                            var r, n, e2 = t2.MutationObserver || t2.WebKitMutationObserver;
                            if (e2) {
                                var i = 0, s = new e2(u), a = t2.document.createTextNode("");
                                s.observe(a, {
                                    characterData: true
                                }), r = function() {
                                    a.data = i = ++i % 2;
                                };
                            } else if (t2.setImmediate || void 0 === t2.MessageChannel) r = "document" in t2 && "onreadystatechange" in t2.document.createElement("script") ? function() {
                                var e3 = t2.document.createElement("script");
                                e3.onreadystatechange = function() {
                                    u(), e3.onreadystatechange = null, e3.parentNode.removeChild(e3), e3 = null;
                                }, t2.document.documentElement.appendChild(e3);
                            } : function() {
                                setTimeout(u, 0);
                            };
                            else {
                                var o = new t2.MessageChannel();
                                o.port1.onmessage = u, r = function() {
                                    o.port2.postMessage(0);
                                };
                            }
                            var h = [];
                            function u() {
                                var e3, t3;
                                n = true;
                                for(var r2 = h.length; r2;){
                                    for(t3 = h, h = [], e3 = -1; ++e3 < r2;)t3[e3]();
                                    r2 = h.length;
                                }
                                n = false;
                            }
                            l.exports = function(e3) {
                                1 !== h.push(e3) || n || r();
                            };
                        }).call(this, "undefined" != typeof $be59461d4a783f7b$var$commonjsGlobal ? $be59461d4a783f7b$var$commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                    },
                    {}
                ],
                37: [
                    function(e, t, r) {
                        var i = e("immediate");
                        function u() {}
                        var l = {}, s = [
                            "REJECTED"
                        ], a = [
                            "FULFILLED"
                        ], n = [
                            "PENDING"
                        ];
                        function o(e2) {
                            if ("function" != typeof e2) throw new TypeError("resolver must be a function");
                            this.state = n, this.queue = [], this.outcome = void 0, e2 !== u && d(this, e2);
                        }
                        function h(e2, t2, r2) {
                            this.promise = e2, "function" == typeof t2 && (this.onFulfilled = t2, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r2 && (this.onRejected = r2, this.callRejected = this.otherCallRejected);
                        }
                        function f(t2, r2, n2) {
                            i(function() {
                                var e2;
                                try {
                                    e2 = r2(n2);
                                } catch (e3) {
                                    return l.reject(t2, e3);
                                }
                                e2 === t2 ? l.reject(t2, new TypeError("Cannot resolve promise with itself")) : l.resolve(t2, e2);
                            });
                        }
                        function c(e2) {
                            var t2 = e2 && e2.then;
                            if (e2 && ("object" == typeof e2 || "function" == typeof e2) && "function" == typeof t2) return function() {
                                t2.apply(e2, arguments);
                            };
                        }
                        function d(t2, e2) {
                            var r2 = false;
                            function n2(e3) {
                                r2 || (r2 = true, l.reject(t2, e3));
                            }
                            function i2(e3) {
                                r2 || (r2 = true, l.resolve(t2, e3));
                            }
                            var s2 = p(function() {
                                e2(i2, n2);
                            });
                            "error" === s2.status && n2(s2.value);
                        }
                        function p(e2, t2) {
                            var r2 = {};
                            try {
                                r2.value = e2(t2), r2.status = "success";
                            } catch (e3) {
                                r2.status = "error", r2.value = e3;
                            }
                            return r2;
                        }
                        (t.exports = o).prototype.finally = function(t2) {
                            if ("function" != typeof t2) return this;
                            var r2 = this.constructor;
                            return this.then(function(e2) {
                                return r2.resolve(t2()).then(function() {
                                    return e2;
                                });
                            }, function(e2) {
                                return r2.resolve(t2()).then(function() {
                                    throw e2;
                                });
                            });
                        }, o.prototype.catch = function(e2) {
                            return this.then(null, e2);
                        }, o.prototype.then = function(e2, t2) {
                            if ("function" != typeof e2 && this.state === a || "function" != typeof t2 && this.state === s) return this;
                            var r2 = new this.constructor(u);
                            this.state !== n ? f(r2, this.state === a ? e2 : t2, this.outcome) : this.queue.push(new h(r2, e2, t2));
                            return r2;
                        }, h.prototype.callFulfilled = function(e2) {
                            l.resolve(this.promise, e2);
                        }, h.prototype.otherCallFulfilled = function(e2) {
                            f(this.promise, this.onFulfilled, e2);
                        }, h.prototype.callRejected = function(e2) {
                            l.reject(this.promise, e2);
                        }, h.prototype.otherCallRejected = function(e2) {
                            f(this.promise, this.onRejected, e2);
                        }, l.resolve = function(e2, t2) {
                            var r2 = p(c, t2);
                            if ("error" === r2.status) return l.reject(e2, r2.value);
                            var n2 = r2.value;
                            if (n2) d(e2, n2);
                            else {
                                e2.state = a, e2.outcome = t2;
                                for(var i2 = -1, s2 = e2.queue.length; ++i2 < s2;)e2.queue[i2].callFulfilled(t2);
                            }
                            return e2;
                        }, l.reject = function(e2, t2) {
                            e2.state = s, e2.outcome = t2;
                            for(var r2 = -1, n2 = e2.queue.length; ++r2 < n2;)e2.queue[r2].callRejected(t2);
                            return e2;
                        }, o.resolve = function(e2) {
                            if (e2 instanceof this) return e2;
                            return l.resolve(new this(u), e2);
                        }, o.reject = function(e2) {
                            var t2 = new this(u);
                            return l.reject(t2, e2);
                        }, o.all = function(e2) {
                            var r2 = this;
                            if ("[object Array]" !== Object.prototype.toString.call(e2)) return this.reject(new TypeError("must be an array"));
                            var n2 = e2.length, i2 = false;
                            if (!n2) return this.resolve([]);
                            var s2 = new Array(n2), a2 = 0, t2 = -1, o2 = new this(u);
                            for(; ++t2 < n2;)h2(e2[t2], t2);
                            return o2;
                            function h2(e3, t3) {
                                r2.resolve(e3).then(function(e4) {
                                    s2[t3] = e4, ++a2 !== n2 || i2 || (i2 = true, l.resolve(o2, s2));
                                }, function(e4) {
                                    i2 || (i2 = true, l.reject(o2, e4));
                                });
                            }
                        }, o.race = function(e2) {
                            var t2 = this;
                            if ("[object Array]" !== Object.prototype.toString.call(e2)) return this.reject(new TypeError("must be an array"));
                            var r2 = e2.length, n2 = false;
                            if (!r2) return this.resolve([]);
                            var i2 = -1, s2 = new this(u);
                            for(; ++i2 < r2;)a2 = e2[i2], t2.resolve(a2).then(function(e3) {
                                n2 || (n2 = true, l.resolve(s2, e3));
                            }, function(e3) {
                                n2 || (n2 = true, l.reject(s2, e3));
                            });
                            var a2;
                            return s2;
                        };
                    },
                    {
                        immediate: 36
                    }
                ],
                38: [
                    function(e, t, r) {
                        var n = {};
                        (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
                    },
                    {
                        "./lib/deflate": 39,
                        "./lib/inflate": 40,
                        "./lib/utils/common": 41,
                        "./lib/zlib/constants": 44
                    }
                ],
                39: [
                    function(e, t, r) {
                        var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                        function p(e2) {
                            if (!(this instanceof p)) return new p(e2);
                            this.options = o.assign({
                                level: f,
                                method: d,
                                chunkSize: 16384,
                                windowBits: 15,
                                memLevel: 8,
                                strategy: c,
                                to: ""
                            }, e2 || {});
                            var t2 = this.options;
                            t2.raw && 0 < t2.windowBits ? t2.windowBits = -t2.windowBits : t2.gzip && 0 < t2.windowBits && t2.windowBits < 16 && (t2.windowBits += 16), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
                            var r2 = a.deflateInit2(this.strm, t2.level, t2.method, t2.windowBits, t2.memLevel, t2.strategy);
                            if (r2 !== l) throw new Error(i[r2]);
                            if (t2.header && a.deflateSetHeader(this.strm, t2.header), t2.dictionary) {
                                var n2;
                                if (n2 = "string" == typeof t2.dictionary ? h.string2buf(t2.dictionary) : "[object ArrayBuffer]" === u.call(t2.dictionary) ? new Uint8Array(t2.dictionary) : t2.dictionary, (r2 = a.deflateSetDictionary(this.strm, n2)) !== l) throw new Error(i[r2]);
                                this._dict_set = true;
                            }
                        }
                        function n(e2, t2) {
                            var r2 = new p(t2);
                            if (r2.push(e2, true), r2.err) throw r2.msg || i[r2.err];
                            return r2.result;
                        }
                        p.prototype.push = function(e2, t2) {
                            var r2, n2, i2 = this.strm, s2 = this.options.chunkSize;
                            if (this.ended) return false;
                            n2 = t2 === ~~t2 ? t2 : true === t2 ? 4 : 0, "string" == typeof e2 ? i2.input = h.string2buf(e2) : "[object ArrayBuffer]" === u.call(e2) ? i2.input = new Uint8Array(e2) : i2.input = e2, i2.next_in = 0, i2.avail_in = i2.input.length;
                            do {
                                if (0 === i2.avail_out && (i2.output = new o.Buf8(s2), i2.next_out = 0, i2.avail_out = s2), 1 !== (r2 = a.deflate(i2, n2)) && r2 !== l) return this.onEnd(r2), this.ended = true, false;
                                0 !== i2.avail_out && (0 !== i2.avail_in || 4 !== n2 && 2 !== n2) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i2.output, i2.next_out))) : this.onData(o.shrinkBuf(i2.output, i2.next_out)));
                            }while ((0 < i2.avail_in || 0 === i2.avail_out) && 1 !== r2);
                            return 4 === n2 ? (r2 = a.deflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === l) : 2 !== n2 || (this.onEnd(l), i2.avail_out = 0, true);
                        }, p.prototype.onData = function(e2) {
                            this.chunks.push(e2);
                        }, p.prototype.onEnd = function(e2) {
                            e2 === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
                        }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e2, t2) {
                            return (t2 = t2 || {}).raw = true, n(e2, t2);
                        }, r.gzip = function(e2, t2) {
                            return (t2 = t2 || {}).gzip = true, n(e2, t2);
                        };
                    },
                    {
                        "./utils/common": 41,
                        "./utils/strings": 42,
                        "./zlib/deflate": 46,
                        "./zlib/messages": 51,
                        "./zlib/zstream": 53
                    }
                ],
                40: [
                    function(e, t, r) {
                        var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                        function a(e2) {
                            if (!(this instanceof a)) return new a(e2);
                            this.options = d.assign({
                                chunkSize: 16384,
                                windowBits: 0,
                                to: ""
                            }, e2 || {});
                            var t2 = this.options;
                            t2.raw && 0 <= t2.windowBits && t2.windowBits < 16 && (t2.windowBits = -t2.windowBits, 0 === t2.windowBits && (t2.windowBits = -15)), !(0 <= t2.windowBits && t2.windowBits < 16) || e2 && e2.windowBits || (t2.windowBits += 32), 15 < t2.windowBits && t2.windowBits < 48 && 0 == (15 & t2.windowBits) && (t2.windowBits |= 15), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
                            var r2 = c.inflateInit2(this.strm, t2.windowBits);
                            if (r2 !== m.Z_OK) throw new Error(n[r2]);
                            this.header = new s(), c.inflateGetHeader(this.strm, this.header);
                        }
                        function o(e2, t2) {
                            var r2 = new a(t2);
                            if (r2.push(e2, true), r2.err) throw r2.msg || n[r2.err];
                            return r2.result;
                        }
                        a.prototype.push = function(e2, t2) {
                            var r2, n2, i2, s2, a2, o2, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = false;
                            if (this.ended) return false;
                            n2 = t2 === ~~t2 ? t2 : true === t2 ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e2 ? h.input = p.binstring2buf(e2) : "[object ArrayBuffer]" === _.call(e2) ? h.input = new Uint8Array(e2) : h.input = e2, h.next_in = 0, h.avail_in = h.input.length;
                            do {
                                if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r2 = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o2 = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r2 = c.inflateSetDictionary(this.strm, o2)), r2 === m.Z_BUF_ERROR && true === f && (r2 = m.Z_OK, f = false), r2 !== m.Z_STREAM_END && r2 !== m.Z_OK) return this.onEnd(r2), this.ended = true, false;
                                h.next_out && (0 !== h.avail_out && r2 !== m.Z_STREAM_END && (0 !== h.avail_in || n2 !== m.Z_FINISH && n2 !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i2 = p.utf8border(h.output, h.next_out), s2 = h.next_out - i2, a2 = p.buf2string(h.output, i2), h.next_out = s2, h.avail_out = u - s2, s2 && d.arraySet(h.output, h.output, i2, s2, 0), this.onData(a2)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = true);
                            }while ((0 < h.avail_in || 0 === h.avail_out) && r2 !== m.Z_STREAM_END);
                            return r2 === m.Z_STREAM_END && (n2 = m.Z_FINISH), n2 === m.Z_FINISH ? (r2 = c.inflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === m.Z_OK) : n2 !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                        }, a.prototype.onData = function(e2) {
                            this.chunks.push(e2);
                        }, a.prototype.onEnd = function(e2) {
                            e2 === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
                        }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e2, t2) {
                            return (t2 = t2 || {}).raw = true, o(e2, t2);
                        }, r.ungzip = o;
                    },
                    {
                        "./utils/common": 41,
                        "./utils/strings": 42,
                        "./zlib/constants": 44,
                        "./zlib/gzheader": 47,
                        "./zlib/inflate": 49,
                        "./zlib/messages": 51,
                        "./zlib/zstream": 53
                    }
                ],
                41: [
                    function(e, t, r) {
                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                        r.assign = function(e2) {
                            for(var t2 = Array.prototype.slice.call(arguments, 1); t2.length;){
                                var r2 = t2.shift();
                                if (r2) {
                                    if ("object" != typeof r2) throw new TypeError(r2 + "must be non-object");
                                    for(var n2 in r2)r2.hasOwnProperty(n2) && (e2[n2] = r2[n2]);
                                }
                            }
                            return e2;
                        }, r.shrinkBuf = function(e2, t2) {
                            return e2.length === t2 ? e2 : e2.subarray ? e2.subarray(0, t2) : (e2.length = t2, e2);
                        };
                        var i = {
                            arraySet: function(e2, t2, r2, n2, i2) {
                                if (t2.subarray && e2.subarray) e2.set(t2.subarray(r2, r2 + n2), i2);
                                else for(var s2 = 0; s2 < n2; s2++)e2[i2 + s2] = t2[r2 + s2];
                            },
                            flattenChunks: function(e2) {
                                var t2, r2, n2, i2, s2, a;
                                for(t2 = n2 = 0, r2 = e2.length; t2 < r2; t2++)n2 += e2[t2].length;
                                for(a = new Uint8Array(n2), t2 = i2 = 0, r2 = e2.length; t2 < r2; t2++)s2 = e2[t2], a.set(s2, i2), i2 += s2.length;
                                return a;
                            }
                        }, s = {
                            arraySet: function(e2, t2, r2, n2, i2) {
                                for(var s2 = 0; s2 < n2; s2++)e2[i2 + s2] = t2[r2 + s2];
                            },
                            flattenChunks: function(e2) {
                                return [].concat.apply([], e2);
                            }
                        };
                        r.setTyped = function(e2) {
                            e2 ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                        }, r.setTyped(n);
                    },
                    {}
                ],
                42: [
                    function(e, t, r) {
                        var h = e("./common"), i = true, s = true;
                        try {
                            String.fromCharCode.apply(null, [
                                0
                            ]);
                        } catch (e2) {
                            i = false;
                        }
                        try {
                            String.fromCharCode.apply(null, new Uint8Array(1));
                        } catch (e2) {
                            s = false;
                        }
                        for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                        function l(e2, t2) {
                            if (t2 < 65537 && (e2.subarray && s || !e2.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e2, t2));
                            for(var r2 = "", n2 = 0; n2 < t2; n2++)r2 += String.fromCharCode(e2[n2]);
                            return r2;
                        }
                        u[254] = u[254] = 1, r.string2buf = function(e2) {
                            var t2, r2, n2, i2, s2, a = e2.length, o = 0;
                            for(i2 = 0; i2 < a; i2++)55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
                            for(t2 = new h.Buf8(o), i2 = s2 = 0; s2 < o; i2++)55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t2[s2++] = r2 : (r2 < 2048 ? t2[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t2[s2++] = 224 | r2 >>> 12 : (t2[s2++] = 240 | r2 >>> 18, t2[s2++] = 128 | r2 >>> 12 & 63), t2[s2++] = 128 | r2 >>> 6 & 63), t2[s2++] = 128 | 63 & r2);
                            return t2;
                        }, r.buf2binstring = function(e2) {
                            return l(e2, e2.length);
                        }, r.binstring2buf = function(e2) {
                            for(var t2 = new h.Buf8(e2.length), r2 = 0, n2 = t2.length; r2 < n2; r2++)t2[r2] = e2.charCodeAt(r2);
                            return t2;
                        }, r.buf2string = function(e2, t2) {
                            var r2, n2, i2, s2, a = t2 || e2.length, o = new Array(2 * a);
                            for(r2 = n2 = 0; r2 < a;)if ((i2 = e2[r2++]) < 128) o[n2++] = i2;
                            else if (4 < (s2 = u[i2])) o[n2++] = 65533, r2 += s2 - 1;
                            else {
                                for(i2 &= 2 === s2 ? 31 : 3 === s2 ? 15 : 7; 1 < s2 && r2 < a;)i2 = i2 << 6 | 63 & e2[r2++], s2--;
                                1 < s2 ? o[n2++] = 65533 : i2 < 65536 ? o[n2++] = i2 : (i2 -= 65536, o[n2++] = 55296 | i2 >> 10 & 1023, o[n2++] = 56320 | 1023 & i2);
                            }
                            return l(o, n2);
                        }, r.utf8border = function(e2, t2) {
                            var r2;
                            for((t2 = t2 || e2.length) > e2.length && (t2 = e2.length), r2 = t2 - 1; 0 <= r2 && 128 == (192 & e2[r2]);)r2--;
                            return r2 < 0 ? t2 : 0 === r2 ? t2 : r2 + u[e2[r2]] > t2 ? r2 : t2;
                        };
                    },
                    {
                        "./common": 41
                    }
                ],
                43: [
                    function(e, t, r) {
                        t.exports = function(e2, t2, r2, n) {
                            for(var i = 65535 & e2 | 0, s = e2 >>> 16 & 65535 | 0, a = 0; 0 !== r2;){
                                for(r2 -= a = 2e3 < r2 ? 2e3 : r2; s = s + (i = i + t2[n++] | 0) | 0, --a;);
                                i %= 65521, s %= 65521;
                            }
                            return i | s << 16 | 0;
                        };
                    },
                    {}
                ],
                44: [
                    function(e, t, r) {
                        t.exports = {
                            Z_NO_FLUSH: 0,
                            Z_PARTIAL_FLUSH: 1,
                            Z_SYNC_FLUSH: 2,
                            Z_FULL_FLUSH: 3,
                            Z_FINISH: 4,
                            Z_BLOCK: 5,
                            Z_TREES: 6,
                            Z_OK: 0,
                            Z_STREAM_END: 1,
                            Z_NEED_DICT: 2,
                            Z_ERRNO: -1,
                            Z_STREAM_ERROR: -2,
                            Z_DATA_ERROR: -3,
                            Z_BUF_ERROR: -5,
                            Z_NO_COMPRESSION: 0,
                            Z_BEST_SPEED: 1,
                            Z_BEST_COMPRESSION: 9,
                            Z_DEFAULT_COMPRESSION: -1,
                            Z_FILTERED: 1,
                            Z_HUFFMAN_ONLY: 2,
                            Z_RLE: 3,
                            Z_FIXED: 4,
                            Z_DEFAULT_STRATEGY: 0,
                            Z_BINARY: 0,
                            Z_TEXT: 1,
                            Z_UNKNOWN: 2,
                            Z_DEFLATED: 8
                        };
                    },
                    {}
                ],
                45: [
                    function(e, t, r) {
                        var o = function() {
                            for(var e2, t2 = [], r2 = 0; r2 < 256; r2++){
                                e2 = r2;
                                for(var n = 0; n < 8; n++)e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
                                t2[r2] = e2;
                            }
                            return t2;
                        }();
                        t.exports = function(e2, t2, r2, n) {
                            var i = o, s = n + r2;
                            e2 ^= -1;
                            for(var a = n; a < s; a++)e2 = e2 >>> 8 ^ i[255 & (e2 ^ t2[a])];
                            return -1 ^ e2;
                        };
                    },
                    {}
                ],
                46: [
                    function(e, t, r) {
                        var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                        function R(e2, t2) {
                            return e2.msg = n[t2], t2;
                        }
                        function T(e2) {
                            return (e2 << 1) - (4 < e2 ? 9 : 0);
                        }
                        function D(e2) {
                            for(var t2 = e2.length; 0 <= --t2;)e2[t2] = 0;
                        }
                        function F(e2) {
                            var t2 = e2.state, r2 = t2.pending;
                            r2 > e2.avail_out && (r2 = e2.avail_out), 0 !== r2 && (c.arraySet(e2.output, t2.pending_buf, t2.pending_out, r2, e2.next_out), e2.next_out += r2, t2.pending_out += r2, e2.total_out += r2, e2.avail_out -= r2, t2.pending -= r2, 0 === t2.pending && (t2.pending_out = 0));
                        }
                        function N(e2, t2) {
                            u._tr_flush_block(e2, 0 <= e2.block_start ? e2.block_start : -1, e2.strstart - e2.block_start, t2), e2.block_start = e2.strstart, F(e2.strm);
                        }
                        function U(e2, t2) {
                            e2.pending_buf[e2.pending++] = t2;
                        }
                        function P(e2, t2) {
                            e2.pending_buf[e2.pending++] = t2 >>> 8 & 255, e2.pending_buf[e2.pending++] = 255 & t2;
                        }
                        function L(e2, t2) {
                            var r2, n2, i2 = e2.max_chain_length, s2 = e2.strstart, a2 = e2.prev_length, o2 = e2.nice_match, h2 = e2.strstart > e2.w_size - z ? e2.strstart - (e2.w_size - z) : 0, u2 = e2.window, l2 = e2.w_mask, f2 = e2.prev, c2 = e2.strstart + S, d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
                            e2.prev_length >= e2.good_match && (i2 >>= 2), o2 > e2.lookahead && (o2 = e2.lookahead);
                            do if (u2[(r2 = t2) + a2] === p2 && u2[r2 + a2 - 1] === d2 && u2[r2] === u2[s2] && u2[++r2] === u2[s2 + 1]) {
                                s2 += 2, r2++;
                                do ;
                                while (u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && s2 < c2);
                                if (n2 = S - (c2 - s2), s2 = c2 - S, a2 < n2) {
                                    if (e2.match_start = t2, o2 <= (a2 = n2)) break;
                                    d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
                                }
                            }
                            while ((t2 = f2[t2 & l2]) > h2 && 0 != --i2);
                            return a2 <= e2.lookahead ? a2 : e2.lookahead;
                        }
                        function j(e2) {
                            var t2, r2, n2, i2, s2, a2, o2, h2, u2, l2, f2 = e2.w_size;
                            do {
                                if (i2 = e2.window_size - e2.lookahead - e2.strstart, e2.strstart >= f2 + (f2 - z)) {
                                    for(c.arraySet(e2.window, e2.window, f2, f2, 0), e2.match_start -= f2, e2.strstart -= f2, e2.block_start -= f2, t2 = r2 = e2.hash_size; n2 = e2.head[--t2], e2.head[t2] = f2 <= n2 ? n2 - f2 : 0, --r2;);
                                    for(t2 = r2 = f2; n2 = e2.prev[--t2], e2.prev[t2] = f2 <= n2 ? n2 - f2 : 0, --r2;);
                                    i2 += f2;
                                }
                                if (0 === e2.strm.avail_in) break;
                                if (a2 = e2.strm, o2 = e2.window, h2 = e2.strstart + e2.lookahead, u2 = i2, l2 = void 0, l2 = a2.avail_in, u2 < l2 && (l2 = u2), r2 = 0 === l2 ? 0 : (a2.avail_in -= l2, c.arraySet(o2, a2.input, a2.next_in, l2, h2), 1 === a2.state.wrap ? a2.adler = d(a2.adler, o2, l2, h2) : 2 === a2.state.wrap && (a2.adler = p(a2.adler, o2, l2, h2)), a2.next_in += l2, a2.total_in += l2, l2), e2.lookahead += r2, e2.lookahead + e2.insert >= x) for(s2 = e2.strstart - e2.insert, e2.ins_h = e2.window[s2], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + 1]) & e2.hash_mask; e2.insert && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + x - 1]) & e2.hash_mask, e2.prev[s2 & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = s2, s2++, e2.insert--, !(e2.lookahead + e2.insert < x)););
                            }while (e2.lookahead < z && 0 !== e2.strm.avail_in);
                        }
                        function Z(e2, t2) {
                            for(var r2, n2;;){
                                if (e2.lookahead < z) {
                                    if (j(e2), e2.lookahead < z && t2 === l) return A;
                                    if (0 === e2.lookahead) break;
                                }
                                if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 !== r2 && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2)), e2.match_length >= x) {
                                    if (n2 = u._tr_tally(e2, e2.strstart - e2.match_start, e2.match_length - x), e2.lookahead -= e2.match_length, e2.match_length <= e2.max_lazy_match && e2.lookahead >= x) {
                                        for(e2.match_length--; e2.strstart++, e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart, 0 != --e2.match_length;);
                                        e2.strstart++;
                                    } else e2.strstart += e2.match_length, e2.match_length = 0, e2.ins_h = e2.window[e2.strstart], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 1]) & e2.hash_mask;
                                } else n2 = u._tr_tally(e2, 0, e2.window[e2.strstart]), e2.lookahead--, e2.strstart++;
                                if (n2 && (N(e2, false), 0 === e2.strm.avail_out)) return A;
                            }
                            return e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t2 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
                        }
                        function W(e2, t2) {
                            for(var r2, n2, i2;;){
                                if (e2.lookahead < z) {
                                    if (j(e2), e2.lookahead < z && t2 === l) return A;
                                    if (0 === e2.lookahead) break;
                                }
                                if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), e2.prev_length = e2.match_length, e2.prev_match = e2.match_start, e2.match_length = x - 1, 0 !== r2 && e2.prev_length < e2.max_lazy_match && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2), e2.match_length <= 5 && (1 === e2.strategy || e2.match_length === x && 4096 < e2.strstart - e2.match_start) && (e2.match_length = x - 1)), e2.prev_length >= x && e2.match_length <= e2.prev_length) {
                                    for(i2 = e2.strstart + e2.lookahead - x, n2 = u._tr_tally(e2, e2.strstart - 1 - e2.prev_match, e2.prev_length - x), e2.lookahead -= e2.prev_length - 1, e2.prev_length -= 2; ++e2.strstart <= i2 && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 != --e2.prev_length;);
                                    if (e2.match_available = 0, e2.match_length = x - 1, e2.strstart++, n2 && (N(e2, false), 0 === e2.strm.avail_out)) return A;
                                } else if (e2.match_available) {
                                    if ((n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1])) && N(e2, false), e2.strstart++, e2.lookahead--, 0 === e2.strm.avail_out) return A;
                                } else e2.match_available = 1, e2.strstart++, e2.lookahead--;
                            }
                            return e2.match_available && (n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1]), e2.match_available = 0), e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t2 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
                        }
                        function M(e2, t2, r2, n2, i2) {
                            this.good_length = e2, this.max_lazy = t2, this.nice_length = r2, this.max_chain = n2, this.func = i2;
                        }
                        function H() {
                            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                        }
                        function G(e2) {
                            var t2;
                            return e2 && e2.state ? (e2.total_in = e2.total_out = 0, e2.data_type = i, (t2 = e2.state).pending = 0, t2.pending_out = 0, t2.wrap < 0 && (t2.wrap = -t2.wrap), t2.status = t2.wrap ? C : E, e2.adler = 2 === t2.wrap ? 0 : 1, t2.last_flush = l, u._tr_init(t2), m) : R(e2, _);
                        }
                        function K(e2) {
                            var t2 = G(e2);
                            return t2 === m && function(e3) {
                                e3.window_size = 2 * e3.w_size, D(e3.head), e3.max_lazy_match = h[e3.level].max_lazy, e3.good_match = h[e3.level].good_length, e3.nice_match = h[e3.level].nice_length, e3.max_chain_length = h[e3.level].max_chain, e3.strstart = 0, e3.block_start = 0, e3.lookahead = 0, e3.insert = 0, e3.match_length = e3.prev_length = x - 1, e3.match_available = 0, e3.ins_h = 0;
                            }(e2.state), t2;
                        }
                        function Y(e2, t2, r2, n2, i2, s2) {
                            if (!e2) return _;
                            var a2 = 1;
                            if (t2 === g && (t2 = 6), n2 < 0 ? (a2 = 0, n2 = -n2) : 15 < n2 && (a2 = 2, n2 -= 16), i2 < 1 || y < i2 || r2 !== v || n2 < 8 || 15 < n2 || t2 < 0 || 9 < t2 || s2 < 0 || b < s2) return R(e2, _);
                            8 === n2 && (n2 = 9);
                            var o2 = new H();
                            return (e2.state = o2).strm = e2, o2.wrap = a2, o2.gzhead = null, o2.w_bits = n2, o2.w_size = 1 << o2.w_bits, o2.w_mask = o2.w_size - 1, o2.hash_bits = i2 + 7, o2.hash_size = 1 << o2.hash_bits, o2.hash_mask = o2.hash_size - 1, o2.hash_shift = ~~((o2.hash_bits + x - 1) / x), o2.window = new c.Buf8(2 * o2.w_size), o2.head = new c.Buf16(o2.hash_size), o2.prev = new c.Buf16(o2.w_size), o2.lit_bufsize = 1 << i2 + 6, o2.pending_buf_size = 4 * o2.lit_bufsize, o2.pending_buf = new c.Buf8(o2.pending_buf_size), o2.d_buf = 1 * o2.lit_bufsize, o2.l_buf = 3 * o2.lit_bufsize, o2.level = t2, o2.strategy = s2, o2.method = r2, K(e2);
                        }
                        h = [
                            new M(0, 0, 0, 0, function(e2, t2) {
                                var r2 = 65535;
                                for(r2 > e2.pending_buf_size - 5 && (r2 = e2.pending_buf_size - 5);;){
                                    if (e2.lookahead <= 1) {
                                        if (j(e2), 0 === e2.lookahead && t2 === l) return A;
                                        if (0 === e2.lookahead) break;
                                    }
                                    e2.strstart += e2.lookahead, e2.lookahead = 0;
                                    var n2 = e2.block_start + r2;
                                    if ((0 === e2.strstart || e2.strstart >= n2) && (e2.lookahead = e2.strstart - n2, e2.strstart = n2, N(e2, false), 0 === e2.strm.avail_out)) return A;
                                    if (e2.strstart - e2.block_start >= e2.w_size - z && (N(e2, false), 0 === e2.strm.avail_out)) return A;
                                }
                                return e2.insert = 0, t2 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : (e2.strstart > e2.block_start && (N(e2, false), e2.strm.avail_out), A);
                            }),
                            new M(4, 4, 8, 4, Z),
                            new M(4, 5, 16, 8, Z),
                            new M(4, 6, 32, 32, Z),
                            new M(4, 4, 16, 16, W),
                            new M(8, 16, 32, 32, W),
                            new M(8, 16, 128, 128, W),
                            new M(8, 32, 128, 256, W),
                            new M(32, 128, 258, 1024, W),
                            new M(32, 258, 258, 4096, W)
                        ], r.deflateInit = function(e2, t2) {
                            return Y(e2, t2, v, 15, 8, 0);
                        }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e2, t2) {
                            return e2 && e2.state ? 2 !== e2.state.wrap ? _ : (e2.state.gzhead = t2, m) : _;
                        }, r.deflate = function(e2, t2) {
                            var r2, n2, i2, s2;
                            if (!e2 || !e2.state || 5 < t2 || t2 < 0) return e2 ? R(e2, _) : _;
                            if (n2 = e2.state, !e2.output || !e2.input && 0 !== e2.avail_in || 666 === n2.status && t2 !== f) return R(e2, 0 === e2.avail_out ? -5 : _);
                            if (n2.strm = e2, r2 = n2.last_flush, n2.last_flush = t2, n2.status === C) {
                                if (2 === n2.wrap) e2.adler = 0, U(n2, 31), U(n2, 139), U(n2, 8), n2.gzhead ? (U(n2, (n2.gzhead.text ? 1 : 0) + (n2.gzhead.hcrc ? 2 : 0) + (n2.gzhead.extra ? 4 : 0) + (n2.gzhead.name ? 8 : 0) + (n2.gzhead.comment ? 16 : 0)), U(n2, 255 & n2.gzhead.time), U(n2, n2.gzhead.time >> 8 & 255), U(n2, n2.gzhead.time >> 16 & 255), U(n2, n2.gzhead.time >> 24 & 255), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 255 & n2.gzhead.os), n2.gzhead.extra && n2.gzhead.extra.length && (U(n2, 255 & n2.gzhead.extra.length), U(n2, n2.gzhead.extra.length >> 8 & 255)), n2.gzhead.hcrc && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending, 0)), n2.gzindex = 0, n2.status = 69) : (U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 3), n2.status = E);
                                else {
                                    var a2 = v + (n2.w_bits - 8 << 4) << 8;
                                    a2 |= (2 <= n2.strategy || n2.level < 2 ? 0 : n2.level < 6 ? 1 : 6 === n2.level ? 2 : 3) << 6, 0 !== n2.strstart && (a2 |= 32), a2 += 31 - a2 % 31, n2.status = E, P(n2, a2), 0 !== n2.strstart && (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), e2.adler = 1;
                                }
                            }
                            if (69 === n2.status) {
                                if (n2.gzhead.extra) {
                                    for(i2 = n2.pending; n2.gzindex < (65535 & n2.gzhead.extra.length) && (n2.pending !== n2.pending_buf_size || (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending !== n2.pending_buf_size));)U(n2, 255 & n2.gzhead.extra[n2.gzindex]), n2.gzindex++;
                                    n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), n2.gzindex === n2.gzhead.extra.length && (n2.gzindex = 0, n2.status = 73);
                                } else n2.status = 73;
                            }
                            if (73 === n2.status) {
                                if (n2.gzhead.name) {
                                    i2 = n2.pending;
                                    do {
                                        if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                                            s2 = 1;
                                            break;
                                        }
                                        s2 = n2.gzindex < n2.gzhead.name.length ? 255 & n2.gzhead.name.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                                    }while (0 !== s2);
                                    n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.gzindex = 0, n2.status = 91);
                                } else n2.status = 91;
                            }
                            if (91 === n2.status) {
                                if (n2.gzhead.comment) {
                                    i2 = n2.pending;
                                    do {
                                        if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                                            s2 = 1;
                                            break;
                                        }
                                        s2 = n2.gzindex < n2.gzhead.comment.length ? 255 & n2.gzhead.comment.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                                    }while (0 !== s2);
                                    n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.status = 103);
                                } else n2.status = 103;
                            }
                            if (103 === n2.status && (n2.gzhead.hcrc ? (n2.pending + 2 > n2.pending_buf_size && F(e2), n2.pending + 2 <= n2.pending_buf_size && (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), e2.adler = 0, n2.status = E)) : n2.status = E), 0 !== n2.pending) {
                                if (F(e2), 0 === e2.avail_out) return n2.last_flush = -1, m;
                            } else if (0 === e2.avail_in && T(t2) <= T(r2) && t2 !== f) return R(e2, -5);
                            if (666 === n2.status && 0 !== e2.avail_in) return R(e2, -5);
                            if (0 !== e2.avail_in || 0 !== n2.lookahead || t2 !== l && 666 !== n2.status) {
                                var o2 = 2 === n2.strategy ? function(e3, t3) {
                                    for(var r3;;){
                                        if (0 === e3.lookahead && (j(e3), 0 === e3.lookahead)) {
                                            if (t3 === l) return A;
                                            break;
                                        }
                                        if (e3.match_length = 0, r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++, r3 && (N(e3, false), 0 === e3.strm.avail_out)) return A;
                                    }
                                    return e3.insert = 0, t3 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
                                }(n2, t2) : 3 === n2.strategy ? function(e3, t3) {
                                    for(var r3, n3, i3, s3, a3 = e3.window;;){
                                        if (e3.lookahead <= S) {
                                            if (j(e3), e3.lookahead <= S && t3 === l) return A;
                                            if (0 === e3.lookahead) break;
                                        }
                                        if (e3.match_length = 0, e3.lookahead >= x && 0 < e3.strstart && (n3 = a3[i3 = e3.strstart - 1]) === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3]) {
                                            s3 = e3.strstart + S;
                                            do ;
                                            while (n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && i3 < s3);
                                            e3.match_length = S - (s3 - i3), e3.match_length > e3.lookahead && (e3.match_length = e3.lookahead);
                                        }
                                        if (e3.match_length >= x ? (r3 = u._tr_tally(e3, 1, e3.match_length - x), e3.lookahead -= e3.match_length, e3.strstart += e3.match_length, e3.match_length = 0) : (r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++), r3 && (N(e3, false), 0 === e3.strm.avail_out)) return A;
                                    }
                                    return e3.insert = 0, t3 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
                                }(n2, t2) : h[n2.level].func(n2, t2);
                                if (o2 !== O && o2 !== B || (n2.status = 666), o2 === A || o2 === O) return 0 === e2.avail_out && (n2.last_flush = -1), m;
                                if (o2 === I && (1 === t2 ? u._tr_align(n2) : 5 !== t2 && (u._tr_stored_block(n2, 0, 0, false), 3 === t2 && (D(n2.head), 0 === n2.lookahead && (n2.strstart = 0, n2.block_start = 0, n2.insert = 0))), F(e2), 0 === e2.avail_out)) return n2.last_flush = -1, m;
                            }
                            return t2 !== f ? m : n2.wrap <= 0 ? 1 : (2 === n2.wrap ? (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), U(n2, e2.adler >> 16 & 255), U(n2, e2.adler >> 24 & 255), U(n2, 255 & e2.total_in), U(n2, e2.total_in >> 8 & 255), U(n2, e2.total_in >> 16 & 255), U(n2, e2.total_in >> 24 & 255)) : (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), F(e2), 0 < n2.wrap && (n2.wrap = -n2.wrap), 0 !== n2.pending ? m : 1);
                        }, r.deflateEnd = function(e2) {
                            var t2;
                            return e2 && e2.state ? (t2 = e2.state.status) !== C && 69 !== t2 && 73 !== t2 && 91 !== t2 && 103 !== t2 && t2 !== E && 666 !== t2 ? R(e2, _) : (e2.state = null, t2 === E ? R(e2, -3) : m) : _;
                        }, r.deflateSetDictionary = function(e2, t2) {
                            var r2, n2, i2, s2, a2, o2, h2, u2, l2 = t2.length;
                            if (!e2 || !e2.state) return _;
                            if (2 === (s2 = (r2 = e2.state).wrap) || 1 === s2 && r2.status !== C || r2.lookahead) return _;
                            for(1 === s2 && (e2.adler = d(e2.adler, t2, l2, 0)), r2.wrap = 0, l2 >= r2.w_size && (0 === s2 && (D(r2.head), r2.strstart = 0, r2.block_start = 0, r2.insert = 0), u2 = new c.Buf8(r2.w_size), c.arraySet(u2, t2, l2 - r2.w_size, r2.w_size, 0), t2 = u2, l2 = r2.w_size), a2 = e2.avail_in, o2 = e2.next_in, h2 = e2.input, e2.avail_in = l2, e2.next_in = 0, e2.input = t2, j(r2); r2.lookahead >= x;){
                                for(n2 = r2.strstart, i2 = r2.lookahead - (x - 1); r2.ins_h = (r2.ins_h << r2.hash_shift ^ r2.window[n2 + x - 1]) & r2.hash_mask, r2.prev[n2 & r2.w_mask] = r2.head[r2.ins_h], r2.head[r2.ins_h] = n2, n2++, --i2;);
                                r2.strstart = n2, r2.lookahead = x - 1, j(r2);
                            }
                            return r2.strstart += r2.lookahead, r2.block_start = r2.strstart, r2.insert = r2.lookahead, r2.lookahead = 0, r2.match_length = r2.prev_length = x - 1, r2.match_available = 0, e2.next_in = o2, e2.input = h2, e2.avail_in = a2, r2.wrap = s2, m;
                        }, r.deflateInfo = "pako deflate (from Nodeca project)";
                    },
                    {
                        "../utils/common": 41,
                        "./adler32": 43,
                        "./crc32": 45,
                        "./messages": 51,
                        "./trees": 52
                    }
                ],
                47: [
                    function(e, t, r) {
                        t.exports = function() {
                            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = false;
                        };
                    },
                    {}
                ],
                48: [
                    function(e, t, r) {
                        t.exports = function(e2, t2) {
                            var r2, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                            r2 = e2.state, n = e2.next_in, z = e2.input, i = n + (e2.avail_in - 5), s = e2.next_out, C = e2.output, a = s - (t2 - e2.avail_out), o = s + (e2.avail_out - 257), h = r2.dmax, u = r2.wsize, l = r2.whave, f = r2.wnext, c = r2.window, d = r2.hold, p = r2.bits, m = r2.lencode, _ = r2.distcode, g = (1 << r2.lenbits) - 1, b = (1 << r2.distbits) - 1;
                            e: do {
                                p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                                t: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                                    else {
                                        if (!(16 & y)) {
                                            if (0 == (64 & y)) {
                                                v = m[(65535 & v) + (d & (1 << y) - 1)];
                                                continue t;
                                            }
                                            if (32 & y) {
                                                r2.mode = 12;
                                                break e;
                                            }
                                            e2.msg = "invalid literal/length code", r2.mode = 30;
                                            break e;
                                        }
                                        w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                        r: for(;;){
                                            if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                                if (0 == (64 & y)) {
                                                    v = _[(65535 & v) + (d & (1 << y) - 1)];
                                                    continue r;
                                                }
                                                e2.msg = "invalid distance code", r2.mode = 30;
                                                break e;
                                            }
                                            if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                                e2.msg = "invalid distance too far back", r2.mode = 30;
                                                break e;
                                            }
                                            if (d >>>= y, p -= y, (y = s - a) < k) {
                                                if (l < (y = k - y) && r2.sane) {
                                                    e2.msg = "invalid distance too far back", r2.mode = 30;
                                                    break e;
                                                }
                                                if (S = c, (x = 0) === f) {
                                                    if (x += u - y, y < w) {
                                                        for(w -= y; C[s++] = c[x++], --y;);
                                                        x = s - k, S = C;
                                                    }
                                                } else if (f < y) {
                                                    if (x += u + f - y, (y -= f) < w) {
                                                        for(w -= y; C[s++] = c[x++], --y;);
                                                        if (x = 0, f < w) {
                                                            for(w -= y = f; C[s++] = c[x++], --y;);
                                                            x = s - k, S = C;
                                                        }
                                                    }
                                                } else if (x += f - y, y < w) {
                                                    for(w -= y; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                                for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                                w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                            } else {
                                                for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                                w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                            }
                                            break;
                                        }
                                    }
                                    break;
                                }
                            }while (n < i && s < o);
                            n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e2.next_in = n, e2.next_out = s, e2.avail_in = n < i ? i - n + 5 : 5 - (n - i), e2.avail_out = s < o ? o - s + 257 : 257 - (s - o), r2.hold = d, r2.bits = p;
                        };
                    },
                    {}
                ],
                49: [
                    function(e, t, r) {
                        var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                        function L(e2) {
                            return (e2 >>> 24 & 255) + (e2 >>> 8 & 65280) + ((65280 & e2) << 8) + ((255 & e2) << 24);
                        }
                        function s() {
                            this.mode = 0, this.last = false, this.wrap = 0, this.havedict = false, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                        }
                        function a(e2) {
                            var t2;
                            return e2 && e2.state ? (t2 = e2.state, e2.total_in = e2.total_out = t2.total = 0, e2.msg = "", t2.wrap && (e2.adler = 1 & t2.wrap), t2.mode = P, t2.last = 0, t2.havedict = 0, t2.dmax = 32768, t2.head = null, t2.hold = 0, t2.bits = 0, t2.lencode = t2.lendyn = new I.Buf32(n), t2.distcode = t2.distdyn = new I.Buf32(i), t2.sane = 1, t2.back = -1, N) : U;
                        }
                        function o(e2) {
                            var t2;
                            return e2 && e2.state ? ((t2 = e2.state).wsize = 0, t2.whave = 0, t2.wnext = 0, a(e2)) : U;
                        }
                        function h(e2, t2) {
                            var r2, n2;
                            return e2 && e2.state ? (n2 = e2.state, t2 < 0 ? (r2 = 0, t2 = -t2) : (r2 = 1 + (t2 >> 4), t2 < 48 && (t2 &= 15)), t2 && (t2 < 8 || 15 < t2) ? U : (null !== n2.window && n2.wbits !== t2 && (n2.window = null), n2.wrap = r2, n2.wbits = t2, o(e2))) : U;
                        }
                        function u(e2, t2) {
                            var r2, n2;
                            return e2 ? (n2 = new s(), (e2.state = n2).window = null, (r2 = h(e2, t2)) !== N && (e2.state = null), r2) : U;
                        }
                        var l, f, c = true;
                        function j(e2) {
                            if (c) {
                                var t2;
                                for(l = new I.Buf32(512), f = new I.Buf32(32), t2 = 0; t2 < 144;)e2.lens[t2++] = 8;
                                for(; t2 < 256;)e2.lens[t2++] = 9;
                                for(; t2 < 280;)e2.lens[t2++] = 7;
                                for(; t2 < 288;)e2.lens[t2++] = 8;
                                for(T(D, e2.lens, 0, 288, l, 0, e2.work, {
                                    bits: 9
                                }), t2 = 0; t2 < 32;)e2.lens[t2++] = 5;
                                T(F, e2.lens, 0, 32, f, 0, e2.work, {
                                    bits: 5
                                }), c = false;
                            }
                            e2.lencode = l, e2.lenbits = 9, e2.distcode = f, e2.distbits = 5;
                        }
                        function Z(e2, t2, r2, n2) {
                            var i2, s2 = e2.state;
                            return null === s2.window && (s2.wsize = 1 << s2.wbits, s2.wnext = 0, s2.whave = 0, s2.window = new I.Buf8(s2.wsize)), n2 >= s2.wsize ? (I.arraySet(s2.window, t2, r2 - s2.wsize, s2.wsize, 0), s2.wnext = 0, s2.whave = s2.wsize) : (n2 < (i2 = s2.wsize - s2.wnext) && (i2 = n2), I.arraySet(s2.window, t2, r2 - n2, i2, s2.wnext), (n2 -= i2) ? (I.arraySet(s2.window, t2, r2 - n2, n2, 0), s2.wnext = n2, s2.whave = s2.wsize) : (s2.wnext += i2, s2.wnext === s2.wsize && (s2.wnext = 0), s2.whave < s2.wsize && (s2.whave += i2))), 0;
                        }
                        r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e2) {
                            return u(e2, 15);
                        }, r.inflateInit2 = u, r.inflate = function(e2, t2) {
                            var r2, n2, i2, s2, a2, o2, h2, u2, l2, f2, c2, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                                16,
                                17,
                                18,
                                0,
                                8,
                                7,
                                9,
                                6,
                                10,
                                5,
                                11,
                                4,
                                12,
                                3,
                                13,
                                2,
                                14,
                                1,
                                15
                            ];
                            if (!e2 || !e2.state || !e2.output || !e2.input && 0 !== e2.avail_in) return U;
                            12 === (r2 = e2.state).mode && (r2.mode = 13), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, f2 = o2, c2 = h2, x = N;
                            e: for(;;)switch(r2.mode){
                                case P:
                                    if (0 === r2.wrap) {
                                        r2.mode = 13;
                                        break;
                                    }
                                    for(; l2 < 16;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if (2 & r2.wrap && 35615 === u2) {
                                        E[r2.check = 0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0), l2 = u2 = 0, r2.mode = 2;
                                        break;
                                    }
                                    if (r2.flags = 0, r2.head && (r2.head.done = false), !(1 & r2.wrap) || (((255 & u2) << 8) + (u2 >> 8)) % 31) {
                                        e2.msg = "incorrect header check", r2.mode = 30;
                                        break;
                                    }
                                    if (8 != (15 & u2)) {
                                        e2.msg = "unknown compression method", r2.mode = 30;
                                        break;
                                    }
                                    if (l2 -= 4, k = 8 + (15 & (u2 >>>= 4)), 0 === r2.wbits) r2.wbits = k;
                                    else if (k > r2.wbits) {
                                        e2.msg = "invalid window size", r2.mode = 30;
                                        break;
                                    }
                                    r2.dmax = 1 << k, e2.adler = r2.check = 1, r2.mode = 512 & u2 ? 10 : 12, l2 = u2 = 0;
                                    break;
                                case 2:
                                    for(; l2 < 16;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if (r2.flags = u2, 8 != (255 & r2.flags)) {
                                        e2.msg = "unknown compression method", r2.mode = 30;
                                        break;
                                    }
                                    if (57344 & r2.flags) {
                                        e2.msg = "unknown header flags set", r2.mode = 30;
                                        break;
                                    }
                                    r2.head && (r2.head.text = u2 >> 8 & 1), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 3;
                                case 3:
                                    for(; l2 < 32;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    r2.head && (r2.head.time = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, E[2] = u2 >>> 16 & 255, E[3] = u2 >>> 24 & 255, r2.check = B(r2.check, E, 4, 0)), l2 = u2 = 0, r2.mode = 4;
                                case 4:
                                    for(; l2 < 16;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    r2.head && (r2.head.xflags = 255 & u2, r2.head.os = u2 >> 8), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 5;
                                case 5:
                                    if (1024 & r2.flags) {
                                        for(; l2 < 16;){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        r2.length = u2, r2.head && (r2.head.extra_len = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0;
                                    } else r2.head && (r2.head.extra = null);
                                    r2.mode = 6;
                                case 6:
                                    if (1024 & r2.flags && (o2 < (d = r2.length) && (d = o2), d && (r2.head && (k = r2.head.extra_len - r2.length, r2.head.extra || (r2.head.extra = new Array(r2.head.extra_len)), I.arraySet(r2.head.extra, n2, s2, d, k)), 512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, r2.length -= d), r2.length)) break e;
                                    r2.length = 0, r2.mode = 7;
                                case 7:
                                    if (2048 & r2.flags) {
                                        if (0 === o2) break e;
                                        for(d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.name += String.fromCharCode(k)), k && d < o2;);
                                        if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k) break e;
                                    } else r2.head && (r2.head.name = null);
                                    r2.length = 0, r2.mode = 8;
                                case 8:
                                    if (4096 & r2.flags) {
                                        if (0 === o2) break e;
                                        for(d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.comment += String.fromCharCode(k)), k && d < o2;);
                                        if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k) break e;
                                    } else r2.head && (r2.head.comment = null);
                                    r2.mode = 9;
                                case 9:
                                    if (512 & r2.flags) {
                                        for(; l2 < 16;){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        if (u2 !== (65535 & r2.check)) {
                                            e2.msg = "header crc mismatch", r2.mode = 30;
                                            break;
                                        }
                                        l2 = u2 = 0;
                                    }
                                    r2.head && (r2.head.hcrc = r2.flags >> 9 & 1, r2.head.done = true), e2.adler = r2.check = 0, r2.mode = 12;
                                    break;
                                case 10:
                                    for(; l2 < 32;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    e2.adler = r2.check = L(u2), l2 = u2 = 0, r2.mode = 11;
                                case 11:
                                    if (0 === r2.havedict) return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, 2;
                                    e2.adler = r2.check = 1, r2.mode = 12;
                                case 12:
                                    if (5 === t2 || 6 === t2) break e;
                                case 13:
                                    if (r2.last) {
                                        u2 >>>= 7 & l2, l2 -= 7 & l2, r2.mode = 27;
                                        break;
                                    }
                                    for(; l2 < 3;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    switch(r2.last = 1 & u2, l2 -= 1, 3 & (u2 >>>= 1)){
                                        case 0:
                                            r2.mode = 14;
                                            break;
                                        case 1:
                                            if (j(r2), r2.mode = 20, 6 !== t2) break;
                                            u2 >>>= 2, l2 -= 2;
                                            break e;
                                        case 2:
                                            r2.mode = 17;
                                            break;
                                        case 3:
                                            e2.msg = "invalid block type", r2.mode = 30;
                                    }
                                    u2 >>>= 2, l2 -= 2;
                                    break;
                                case 14:
                                    for(u2 >>>= 7 & l2, l2 -= 7 & l2; l2 < 32;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if ((65535 & u2) != (u2 >>> 16 ^ 65535)) {
                                        e2.msg = "invalid stored block lengths", r2.mode = 30;
                                        break;
                                    }
                                    if (r2.length = 65535 & u2, l2 = u2 = 0, r2.mode = 15, 6 === t2) break e;
                                case 15:
                                    r2.mode = 16;
                                case 16:
                                    if (d = r2.length) {
                                        if (o2 < d && (d = o2), h2 < d && (d = h2), 0 === d) break e;
                                        I.arraySet(i2, n2, s2, d, a2), o2 -= d, s2 += d, h2 -= d, a2 += d, r2.length -= d;
                                        break;
                                    }
                                    r2.mode = 12;
                                    break;
                                case 17:
                                    for(; l2 < 14;){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if (r2.nlen = 257 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ndist = 1 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ncode = 4 + (15 & u2), u2 >>>= 4, l2 -= 4, 286 < r2.nlen || 30 < r2.ndist) {
                                        e2.msg = "too many length or distance symbols", r2.mode = 30;
                                        break;
                                    }
                                    r2.have = 0, r2.mode = 18;
                                case 18:
                                    for(; r2.have < r2.ncode;){
                                        for(; l2 < 3;){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        r2.lens[A[r2.have++]] = 7 & u2, u2 >>>= 3, l2 -= 3;
                                    }
                                    for(; r2.have < 19;)r2.lens[A[r2.have++]] = 0;
                                    if (r2.lencode = r2.lendyn, r2.lenbits = 7, S = {
                                        bits: r2.lenbits
                                    }, x = T(0, r2.lens, 0, 19, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                                        e2.msg = "invalid code lengths set", r2.mode = 30;
                                        break;
                                    }
                                    r2.have = 0, r2.mode = 19;
                                case 19:
                                    for(; r2.have < r2.nlen + r2.ndist;){
                                        for(; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2);){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        if (b < 16) u2 >>>= _, l2 -= _, r2.lens[r2.have++] = b;
                                        else {
                                            if (16 === b) {
                                                for(z = _ + 2; l2 < z;){
                                                    if (0 === o2) break e;
                                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                                }
                                                if (u2 >>>= _, l2 -= _, 0 === r2.have) {
                                                    e2.msg = "invalid bit length repeat", r2.mode = 30;
                                                    break;
                                                }
                                                k = r2.lens[r2.have - 1], d = 3 + (3 & u2), u2 >>>= 2, l2 -= 2;
                                            } else if (17 === b) {
                                                for(z = _ + 3; l2 < z;){
                                                    if (0 === o2) break e;
                                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                                }
                                                l2 -= _, k = 0, d = 3 + (7 & (u2 >>>= _)), u2 >>>= 3, l2 -= 3;
                                            } else {
                                                for(z = _ + 7; l2 < z;){
                                                    if (0 === o2) break e;
                                                    o2--, u2 += n2[s2++] << l2, l2 += 8;
                                                }
                                                l2 -= _, k = 0, d = 11 + (127 & (u2 >>>= _)), u2 >>>= 7, l2 -= 7;
                                            }
                                            if (r2.have + d > r2.nlen + r2.ndist) {
                                                e2.msg = "invalid bit length repeat", r2.mode = 30;
                                                break;
                                            }
                                            for(; d--;)r2.lens[r2.have++] = k;
                                        }
                                    }
                                    if (30 === r2.mode) break;
                                    if (0 === r2.lens[256]) {
                                        e2.msg = "invalid code -- missing end-of-block", r2.mode = 30;
                                        break;
                                    }
                                    if (r2.lenbits = 9, S = {
                                        bits: r2.lenbits
                                    }, x = T(D, r2.lens, 0, r2.nlen, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                                        e2.msg = "invalid literal/lengths set", r2.mode = 30;
                                        break;
                                    }
                                    if (r2.distbits = 6, r2.distcode = r2.distdyn, S = {
                                        bits: r2.distbits
                                    }, x = T(F, r2.lens, r2.nlen, r2.ndist, r2.distcode, 0, r2.work, S), r2.distbits = S.bits, x) {
                                        e2.msg = "invalid distances set", r2.mode = 30;
                                        break;
                                    }
                                    if (r2.mode = 20, 6 === t2) break e;
                                case 20:
                                    r2.mode = 21;
                                case 21:
                                    if (6 <= o2 && 258 <= h2) {
                                        e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, R(e2, c2), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, 12 === r2.mode && (r2.back = -1);
                                        break;
                                    }
                                    for(r2.back = 0; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2);){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if (g && 0 == (240 & g)) {
                                        for(v = _, y = g, w = b; g = (C = r2.lencode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2);){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        u2 >>>= v, l2 -= v, r2.back += v;
                                    }
                                    if (u2 >>>= _, l2 -= _, r2.back += _, r2.length = b, 0 === g) {
                                        r2.mode = 26;
                                        break;
                                    }
                                    if (32 & g) {
                                        r2.back = -1, r2.mode = 12;
                                        break;
                                    }
                                    if (64 & g) {
                                        e2.msg = "invalid literal/length code", r2.mode = 30;
                                        break;
                                    }
                                    r2.extra = 15 & g, r2.mode = 22;
                                case 22:
                                    if (r2.extra) {
                                        for(z = r2.extra; l2 < z;){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        r2.length += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                                    }
                                    r2.was = r2.length, r2.mode = 23;
                                case 23:
                                    for(; g = (C = r2.distcode[u2 & (1 << r2.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2);){
                                        if (0 === o2) break e;
                                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                                    }
                                    if (0 == (240 & g)) {
                                        for(v = _, y = g, w = b; g = (C = r2.distcode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2);){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        u2 >>>= v, l2 -= v, r2.back += v;
                                    }
                                    if (u2 >>>= _, l2 -= _, r2.back += _, 64 & g) {
                                        e2.msg = "invalid distance code", r2.mode = 30;
                                        break;
                                    }
                                    r2.offset = b, r2.extra = 15 & g, r2.mode = 24;
                                case 24:
                                    if (r2.extra) {
                                        for(z = r2.extra; l2 < z;){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        r2.offset += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                                    }
                                    if (r2.offset > r2.dmax) {
                                        e2.msg = "invalid distance too far back", r2.mode = 30;
                                        break;
                                    }
                                    r2.mode = 25;
                                case 25:
                                    if (0 === h2) break e;
                                    if (d = c2 - h2, r2.offset > d) {
                                        if ((d = r2.offset - d) > r2.whave && r2.sane) {
                                            e2.msg = "invalid distance too far back", r2.mode = 30;
                                            break;
                                        }
                                        p = d > r2.wnext ? (d -= r2.wnext, r2.wsize - d) : r2.wnext - d, d > r2.length && (d = r2.length), m = r2.window;
                                    } else m = i2, p = a2 - r2.offset, d = r2.length;
                                    for(h2 < d && (d = h2), h2 -= d, r2.length -= d; i2[a2++] = m[p++], --d;);
                                    0 === r2.length && (r2.mode = 21);
                                    break;
                                case 26:
                                    if (0 === h2) break e;
                                    i2[a2++] = r2.length, h2--, r2.mode = 21;
                                    break;
                                case 27:
                                    if (r2.wrap) {
                                        for(; l2 < 32;){
                                            if (0 === o2) break e;
                                            o2--, u2 |= n2[s2++] << l2, l2 += 8;
                                        }
                                        if (c2 -= h2, e2.total_out += c2, r2.total += c2, c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, a2 - c2) : O(r2.check, i2, c2, a2 - c2)), c2 = h2, (r2.flags ? u2 : L(u2)) !== r2.check) {
                                            e2.msg = "incorrect data check", r2.mode = 30;
                                            break;
                                        }
                                        l2 = u2 = 0;
                                    }
                                    r2.mode = 28;
                                case 28:
                                    if (r2.wrap && r2.flags) {
                                        for(; l2 < 32;){
                                            if (0 === o2) break e;
                                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                                        }
                                        if (u2 !== (4294967295 & r2.total)) {
                                            e2.msg = "incorrect length check", r2.mode = 30;
                                            break;
                                        }
                                        l2 = u2 = 0;
                                    }
                                    r2.mode = 29;
                                case 29:
                                    x = 1;
                                    break e;
                                case 30:
                                    x = -3;
                                    break e;
                                case 31:
                                    return -4;
                                case 32:
                                default:
                                    return U;
                            }
                            return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, (r2.wsize || c2 !== e2.avail_out && r2.mode < 30 && (r2.mode < 27 || 4 !== t2)) && Z(e2, e2.output, e2.next_out, c2 - e2.avail_out) ? (r2.mode = 31, -4) : (f2 -= e2.avail_in, c2 -= e2.avail_out, e2.total_in += f2, e2.total_out += c2, r2.total += c2, r2.wrap && c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, e2.next_out - c2) : O(r2.check, i2, c2, e2.next_out - c2)), e2.data_type = r2.bits + (r2.last ? 64 : 0) + (12 === r2.mode ? 128 : 0) + (20 === r2.mode || 15 === r2.mode ? 256 : 0), (0 == f2 && 0 === c2 || 4 === t2) && x === N && (x = -5), x);
                        }, r.inflateEnd = function(e2) {
                            if (!e2 || !e2.state) return U;
                            var t2 = e2.state;
                            return t2.window && (t2.window = null), e2.state = null, N;
                        }, r.inflateGetHeader = function(e2, t2) {
                            var r2;
                            return e2 && e2.state ? 0 == (2 & (r2 = e2.state).wrap) ? U : ((r2.head = t2).done = false, N) : U;
                        }, r.inflateSetDictionary = function(e2, t2) {
                            var r2, n2 = t2.length;
                            return e2 && e2.state ? 0 !== (r2 = e2.state).wrap && 11 !== r2.mode ? U : 11 === r2.mode && O(1, t2, n2, 0) !== r2.check ? -3 : Z(e2, t2, n2, n2) ? (r2.mode = 31, -4) : (r2.havedict = 1, N) : U;
                        }, r.inflateInfo = "pako inflate (from Nodeca project)";
                    },
                    {
                        "../utils/common": 41,
                        "./adler32": 43,
                        "./crc32": 45,
                        "./inffast": 48,
                        "./inftrees": 50
                    }
                ],
                50: [
                    function(e, t, r) {
                        var D = e("../utils/common"), F = [
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            13,
                            15,
                            17,
                            19,
                            23,
                            27,
                            31,
                            35,
                            43,
                            51,
                            59,
                            67,
                            83,
                            99,
                            115,
                            131,
                            163,
                            195,
                            227,
                            258,
                            0,
                            0
                        ], N = [
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            17,
                            17,
                            17,
                            17,
                            18,
                            18,
                            18,
                            18,
                            19,
                            19,
                            19,
                            19,
                            20,
                            20,
                            20,
                            20,
                            21,
                            21,
                            21,
                            21,
                            16,
                            72,
                            78
                        ], U = [
                            1,
                            2,
                            3,
                            4,
                            5,
                            7,
                            9,
                            13,
                            17,
                            25,
                            33,
                            49,
                            65,
                            97,
                            129,
                            193,
                            257,
                            385,
                            513,
                            769,
                            1025,
                            1537,
                            2049,
                            3073,
                            4097,
                            6145,
                            8193,
                            12289,
                            16385,
                            24577,
                            0,
                            0
                        ], P = [
                            16,
                            16,
                            16,
                            16,
                            17,
                            17,
                            18,
                            18,
                            19,
                            19,
                            20,
                            20,
                            21,
                            21,
                            22,
                            22,
                            23,
                            23,
                            24,
                            24,
                            25,
                            25,
                            26,
                            26,
                            27,
                            27,
                            28,
                            28,
                            29,
                            29,
                            64,
                            64
                        ];
                        t.exports = function(e2, t2, r2, n, i, s, a, o) {
                            var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                            for(b = 0; b <= 15; b++)O[b] = 0;
                            for(v = 0; v < n; v++)O[t2[r2 + v]]++;
                            for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                            if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                            for(y = 1; y < w && 0 === O[y]; y++);
                            for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                            if (0 < z && (0 === e2 || 1 !== w)) return -1;
                            for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                            for(v = 0; v < n; v++)0 !== t2[r2 + v] && (a[B[t2[r2 + v]]++] = v);
                            if (d = 0 === e2 ? (A = R = a, 19) : 1 === e2 ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e2 && 852 < C || 2 === e2 && 592 < C) return 1;
                            for(;;){
                                for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                                for(h = 1 << b - 1; E & h;)h >>= 1;
                                if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                                    if (b === w) break;
                                    b = t2[r2 + a[v]];
                                }
                                if (k < b && (E & f) !== l) {
                                    for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                                    if (C += 1 << x, 1 === e2 && 852 < C || 2 === e2 && 592 < C) return 1;
                                    i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                                }
                            }
                            return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                        };
                    },
                    {
                        "../utils/common": 41
                    }
                ],
                51: [
                    function(e, t, r) {
                        t.exports = {
                            2: "need dictionary",
                            1: "stream end",
                            0: "",
                            "-1": "file error",
                            "-2": "stream error",
                            "-3": "data error",
                            "-4": "insufficient memory",
                            "-5": "buffer error",
                            "-6": "incompatible version"
                        };
                    },
                    {}
                ],
                52: [
                    function(e, t, r) {
                        var i = e("../utils/common"), o = 0, h = 1;
                        function n(e2) {
                            for(var t2 = e2.length; 0 <= --t2;)e2[t2] = 0;
                        }
                        var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            1,
                            1,
                            1,
                            2,
                            2,
                            2,
                            2,
                            3,
                            3,
                            3,
                            3,
                            4,
                            4,
                            4,
                            4,
                            5,
                            5,
                            5,
                            5,
                            0
                        ], k = [
                            0,
                            0,
                            0,
                            0,
                            1,
                            1,
                            2,
                            2,
                            3,
                            3,
                            4,
                            4,
                            5,
                            5,
                            6,
                            6,
                            7,
                            7,
                            8,
                            8,
                            9,
                            9,
                            10,
                            10,
                            11,
                            11,
                            12,
                            12,
                            13,
                            13
                        ], x = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            3,
                            7
                        ], S = [
                            16,
                            17,
                            18,
                            0,
                            8,
                            7,
                            9,
                            6,
                            10,
                            5,
                            11,
                            4,
                            12,
                            3,
                            13,
                            2,
                            14,
                            1,
                            15
                        ], z = new Array(2 * (l + 2));
                        n(z);
                        var C = new Array(2 * f);
                        n(C);
                        var E = new Array(512);
                        n(E);
                        var A = new Array(256);
                        n(A);
                        var I = new Array(a);
                        n(I);
                        var O, B, R, T = new Array(f);
                        function D(e2, t2, r2, n2, i2) {
                            this.static_tree = e2, this.extra_bits = t2, this.extra_base = r2, this.elems = n2, this.max_length = i2, this.has_stree = e2 && e2.length;
                        }
                        function F(e2, t2) {
                            this.dyn_tree = e2, this.max_code = 0, this.stat_desc = t2;
                        }
                        function N(e2) {
                            return e2 < 256 ? E[e2] : E[256 + (e2 >>> 7)];
                        }
                        function U(e2, t2) {
                            e2.pending_buf[e2.pending++] = 255 & t2, e2.pending_buf[e2.pending++] = t2 >>> 8 & 255;
                        }
                        function P(e2, t2, r2) {
                            e2.bi_valid > d - r2 ? (e2.bi_buf |= t2 << e2.bi_valid & 65535, U(e2, e2.bi_buf), e2.bi_buf = t2 >> d - e2.bi_valid, e2.bi_valid += r2 - d) : (e2.bi_buf |= t2 << e2.bi_valid & 65535, e2.bi_valid += r2);
                        }
                        function L(e2, t2, r2) {
                            P(e2, r2[2 * t2], r2[2 * t2 + 1]);
                        }
                        function j(e2, t2) {
                            for(var r2 = 0; r2 |= 1 & e2, e2 >>>= 1, r2 <<= 1, 0 < --t2;);
                            return r2 >>> 1;
                        }
                        function Z(e2, t2, r2) {
                            var n2, i2, s2 = new Array(g + 1), a2 = 0;
                            for(n2 = 1; n2 <= g; n2++)s2[n2] = a2 = a2 + r2[n2 - 1] << 1;
                            for(i2 = 0; i2 <= t2; i2++){
                                var o2 = e2[2 * i2 + 1];
                                0 !== o2 && (e2[2 * i2] = j(s2[o2]++, o2));
                            }
                        }
                        function W(e2) {
                            var t2;
                            for(t2 = 0; t2 < l; t2++)e2.dyn_ltree[2 * t2] = 0;
                            for(t2 = 0; t2 < f; t2++)e2.dyn_dtree[2 * t2] = 0;
                            for(t2 = 0; t2 < c; t2++)e2.bl_tree[2 * t2] = 0;
                            e2.dyn_ltree[2 * m] = 1, e2.opt_len = e2.static_len = 0, e2.last_lit = e2.matches = 0;
                        }
                        function M(e2) {
                            8 < e2.bi_valid ? U(e2, e2.bi_buf) : 0 < e2.bi_valid && (e2.pending_buf[e2.pending++] = e2.bi_buf), e2.bi_buf = 0, e2.bi_valid = 0;
                        }
                        function H(e2, t2, r2, n2) {
                            var i2 = 2 * t2, s2 = 2 * r2;
                            return e2[i2] < e2[s2] || e2[i2] === e2[s2] && n2[t2] <= n2[r2];
                        }
                        function G(e2, t2, r2) {
                            for(var n2 = e2.heap[r2], i2 = r2 << 1; i2 <= e2.heap_len && (i2 < e2.heap_len && H(t2, e2.heap[i2 + 1], e2.heap[i2], e2.depth) && i2++, !H(t2, n2, e2.heap[i2], e2.depth));)e2.heap[r2] = e2.heap[i2], r2 = i2, i2 <<= 1;
                            e2.heap[r2] = n2;
                        }
                        function K(e2, t2, r2) {
                            var n2, i2, s2, a2, o2 = 0;
                            if (0 !== e2.last_lit) for(; n2 = e2.pending_buf[e2.d_buf + 2 * o2] << 8 | e2.pending_buf[e2.d_buf + 2 * o2 + 1], i2 = e2.pending_buf[e2.l_buf + o2], o2++, 0 === n2 ? L(e2, i2, t2) : (L(e2, (s2 = A[i2]) + u + 1, t2), 0 !== (a2 = w[s2]) && P(e2, i2 -= I[s2], a2), L(e2, s2 = N(--n2), r2), 0 !== (a2 = k[s2]) && P(e2, n2 -= T[s2], a2)), o2 < e2.last_lit;);
                            L(e2, m, t2);
                        }
                        function Y(e2, t2) {
                            var r2, n2, i2, s2 = t2.dyn_tree, a2 = t2.stat_desc.static_tree, o2 = t2.stat_desc.has_stree, h2 = t2.stat_desc.elems, u2 = -1;
                            for(e2.heap_len = 0, e2.heap_max = _, r2 = 0; r2 < h2; r2++)0 !== s2[2 * r2] ? (e2.heap[++e2.heap_len] = u2 = r2, e2.depth[r2] = 0) : s2[2 * r2 + 1] = 0;
                            for(; e2.heap_len < 2;)s2[2 * (i2 = e2.heap[++e2.heap_len] = u2 < 2 ? ++u2 : 0)] = 1, e2.depth[i2] = 0, e2.opt_len--, o2 && (e2.static_len -= a2[2 * i2 + 1]);
                            for(t2.max_code = u2, r2 = e2.heap_len >> 1; 1 <= r2; r2--)G(e2, s2, r2);
                            for(i2 = h2; r2 = e2.heap[1], e2.heap[1] = e2.heap[e2.heap_len--], G(e2, s2, 1), n2 = e2.heap[1], e2.heap[--e2.heap_max] = r2, e2.heap[--e2.heap_max] = n2, s2[2 * i2] = s2[2 * r2] + s2[2 * n2], e2.depth[i2] = (e2.depth[r2] >= e2.depth[n2] ? e2.depth[r2] : e2.depth[n2]) + 1, s2[2 * r2 + 1] = s2[2 * n2 + 1] = i2, e2.heap[1] = i2++, G(e2, s2, 1), 2 <= e2.heap_len;);
                            e2.heap[--e2.heap_max] = e2.heap[1], function(e3, t3) {
                                var r3, n3, i3, s3, a3, o3, h3 = t3.dyn_tree, u3 = t3.max_code, l2 = t3.stat_desc.static_tree, f2 = t3.stat_desc.has_stree, c2 = t3.stat_desc.extra_bits, d2 = t3.stat_desc.extra_base, p2 = t3.stat_desc.max_length, m2 = 0;
                                for(s3 = 0; s3 <= g; s3++)e3.bl_count[s3] = 0;
                                for(h3[2 * e3.heap[e3.heap_max] + 1] = 0, r3 = e3.heap_max + 1; r3 < _; r3++)p2 < (s3 = h3[2 * h3[2 * (n3 = e3.heap[r3]) + 1] + 1] + 1) && (s3 = p2, m2++), h3[2 * n3 + 1] = s3, u3 < n3 || (e3.bl_count[s3]++, a3 = 0, d2 <= n3 && (a3 = c2[n3 - d2]), o3 = h3[2 * n3], e3.opt_len += o3 * (s3 + a3), f2 && (e3.static_len += o3 * (l2[2 * n3 + 1] + a3)));
                                if (0 !== m2) {
                                    do {
                                        for(s3 = p2 - 1; 0 === e3.bl_count[s3];)s3--;
                                        e3.bl_count[s3]--, e3.bl_count[s3 + 1] += 2, e3.bl_count[p2]--, m2 -= 2;
                                    }while (0 < m2);
                                    for(s3 = p2; 0 !== s3; s3--)for(n3 = e3.bl_count[s3]; 0 !== n3;)u3 < (i3 = e3.heap[--r3]) || (h3[2 * i3 + 1] !== s3 && (e3.opt_len += (s3 - h3[2 * i3 + 1]) * h3[2 * i3], h3[2 * i3 + 1] = s3), n3--);
                                }
                            }(e2, t2), Z(s2, u2, e2.bl_count);
                        }
                        function X(e2, t2, r2) {
                            var n2, i2, s2 = -1, a2 = t2[1], o2 = 0, h2 = 7, u2 = 4;
                            for(0 === a2 && (h2 = 138, u2 = 3), t2[2 * (r2 + 1) + 1] = 65535, n2 = 0; n2 <= r2; n2++)i2 = a2, a2 = t2[2 * (n2 + 1) + 1], ++o2 < h2 && i2 === a2 || (o2 < u2 ? e2.bl_tree[2 * i2] += o2 : 0 !== i2 ? (i2 !== s2 && e2.bl_tree[2 * i2]++, e2.bl_tree[2 * b]++) : o2 <= 10 ? e2.bl_tree[2 * v]++ : e2.bl_tree[2 * y]++, s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4));
                        }
                        function V(e2, t2, r2) {
                            var n2, i2, s2 = -1, a2 = t2[1], o2 = 0, h2 = 7, u2 = 4;
                            for(0 === a2 && (h2 = 138, u2 = 3), n2 = 0; n2 <= r2; n2++)if (i2 = a2, a2 = t2[2 * (n2 + 1) + 1], !(++o2 < h2 && i2 === a2)) {
                                if (o2 < u2) for(; L(e2, i2, e2.bl_tree), 0 != --o2;);
                                else 0 !== i2 ? (i2 !== s2 && (L(e2, i2, e2.bl_tree), o2--), L(e2, b, e2.bl_tree), P(e2, o2 - 3, 2)) : o2 <= 10 ? (L(e2, v, e2.bl_tree), P(e2, o2 - 3, 3)) : (L(e2, y, e2.bl_tree), P(e2, o2 - 11, 7));
                                s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4);
                            }
                        }
                        n(T);
                        var q = false;
                        function J(e2, t2, r2, n2) {
                            P(e2, (s << 1) + (n2 ? 1 : 0), 3), function(e3, t3, r3, n3) {
                                M(e3), U(e3, r3), U(e3, ~r3), i.arraySet(e3.pending_buf, e3.window, t3, r3, e3.pending), e3.pending += r3;
                            }(e2, t2, r2);
                        }
                        r._tr_init = function(e2) {
                            q || (function() {
                                var e3, t2, r2, n2, i2, s2 = new Array(g + 1);
                                for(n2 = r2 = 0; n2 < a - 1; n2++)for(I[n2] = r2, e3 = 0; e3 < 1 << w[n2]; e3++)A[r2++] = n2;
                                for(A[r2 - 1] = n2, n2 = i2 = 0; n2 < 16; n2++)for(T[n2] = i2, e3 = 0; e3 < 1 << k[n2]; e3++)E[i2++] = n2;
                                for(i2 >>= 7; n2 < f; n2++)for(T[n2] = i2 << 7, e3 = 0; e3 < 1 << k[n2] - 7; e3++)E[256 + i2++] = n2;
                                for(t2 = 0; t2 <= g; t2++)s2[t2] = 0;
                                for(e3 = 0; e3 <= 143;)z[2 * e3 + 1] = 8, e3++, s2[8]++;
                                for(; e3 <= 255;)z[2 * e3 + 1] = 9, e3++, s2[9]++;
                                for(; e3 <= 279;)z[2 * e3 + 1] = 7, e3++, s2[7]++;
                                for(; e3 <= 287;)z[2 * e3 + 1] = 8, e3++, s2[8]++;
                                for(Z(z, l + 1, s2), e3 = 0; e3 < f; e3++)C[2 * e3 + 1] = 5, C[2 * e3] = j(e3, 5);
                                O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                            }(), q = true), e2.l_desc = new F(e2.dyn_ltree, O), e2.d_desc = new F(e2.dyn_dtree, B), e2.bl_desc = new F(e2.bl_tree, R), e2.bi_buf = 0, e2.bi_valid = 0, W(e2);
                        }, r._tr_stored_block = J, r._tr_flush_block = function(e2, t2, r2, n2) {
                            var i2, s2, a2 = 0;
                            0 < e2.level ? (2 === e2.strm.data_type && (e2.strm.data_type = function(e3) {
                                var t3, r3 = 4093624447;
                                for(t3 = 0; t3 <= 31; t3++, r3 >>>= 1)if (1 & r3 && 0 !== e3.dyn_ltree[2 * t3]) return o;
                                if (0 !== e3.dyn_ltree[18] || 0 !== e3.dyn_ltree[20] || 0 !== e3.dyn_ltree[26]) return h;
                                for(t3 = 32; t3 < u; t3++)if (0 !== e3.dyn_ltree[2 * t3]) return h;
                                return o;
                            }(e2)), Y(e2, e2.l_desc), Y(e2, e2.d_desc), a2 = function(e3) {
                                var t3;
                                for(X(e3, e3.dyn_ltree, e3.l_desc.max_code), X(e3, e3.dyn_dtree, e3.d_desc.max_code), Y(e3, e3.bl_desc), t3 = c - 1; 3 <= t3 && 0 === e3.bl_tree[2 * S[t3] + 1]; t3--);
                                return e3.opt_len += 3 * (t3 + 1) + 5 + 5 + 4, t3;
                            }(e2), i2 = e2.opt_len + 3 + 7 >>> 3, (s2 = e2.static_len + 3 + 7 >>> 3) <= i2 && (i2 = s2)) : i2 = s2 = r2 + 5, r2 + 4 <= i2 && -1 !== t2 ? J(e2, t2, r2, n2) : 4 === e2.strategy || s2 === i2 ? (P(e2, 2 + (n2 ? 1 : 0), 3), K(e2, z, C)) : (P(e2, 4 + (n2 ? 1 : 0), 3), function(e3, t3, r3, n3) {
                                var i3;
                                for(P(e3, t3 - 257, 5), P(e3, r3 - 1, 5), P(e3, n3 - 4, 4), i3 = 0; i3 < n3; i3++)P(e3, e3.bl_tree[2 * S[i3] + 1], 3);
                                V(e3, e3.dyn_ltree, t3 - 1), V(e3, e3.dyn_dtree, r3 - 1);
                            }(e2, e2.l_desc.max_code + 1, e2.d_desc.max_code + 1, a2 + 1), K(e2, e2.dyn_ltree, e2.dyn_dtree)), W(e2), n2 && M(e2);
                        }, r._tr_tally = function(e2, t2, r2) {
                            return e2.pending_buf[e2.d_buf + 2 * e2.last_lit] = t2 >>> 8 & 255, e2.pending_buf[e2.d_buf + 2 * e2.last_lit + 1] = 255 & t2, e2.pending_buf[e2.l_buf + e2.last_lit] = 255 & r2, e2.last_lit++, 0 === t2 ? e2.dyn_ltree[2 * r2]++ : (e2.matches++, t2--, e2.dyn_ltree[2 * (A[r2] + u + 1)]++, e2.dyn_dtree[2 * N(t2)]++), e2.last_lit === e2.lit_bufsize - 1;
                        }, r._tr_align = function(e2) {
                            P(e2, 2, 3), L(e2, m, z), function(e3) {
                                16 === e3.bi_valid ? (U(e3, e3.bi_buf), e3.bi_buf = 0, e3.bi_valid = 0) : 8 <= e3.bi_valid && (e3.pending_buf[e3.pending++] = 255 & e3.bi_buf, e3.bi_buf >>= 8, e3.bi_valid -= 8);
                            }(e2);
                        };
                    },
                    {
                        "../utils/common": 41
                    }
                ],
                53: [
                    function(e, t, r) {
                        t.exports = function() {
                            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                        };
                    },
                    {}
                ],
                54: [
                    function(e, t, r) {
                        (function(e2) {
                            !function(r2, n) {
                                if (!r2.setImmediate) {
                                    var i, s, t2, a, o = 1, h = {}, u = false, l = r2.document, e3 = Object.getPrototypeOf && Object.getPrototypeOf(r2);
                                    e3 = e3 && e3.setTimeout ? e3 : r2, i = "[object process]" === ({}).toString.call(r2.process) ? function(e4) {
                                        $be59461d4a783f7b$var$process$1.nextTick(function() {
                                            c(e4);
                                        });
                                    } : function() {
                                        if (r2.postMessage && !r2.importScripts) {
                                            var e4 = true, t3 = r2.onmessage;
                                            return r2.onmessage = function() {
                                                e4 = false;
                                            }, r2.postMessage("", "*"), r2.onmessage = t3, e4;
                                        }
                                    }() ? (a = "setImmediate$" + Math.random() + "$", r2.addEventListener ? r2.addEventListener("message", d, false) : r2.attachEvent("onmessage", d), function(e4) {
                                        r2.postMessage(a + e4, "*");
                                    }) : r2.MessageChannel ? ((t2 = new MessageChannel()).port1.onmessage = function(e4) {
                                        c(e4.data);
                                    }, function(e4) {
                                        t2.port2.postMessage(e4);
                                    }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e4) {
                                        var t3 = l.createElement("script");
                                        t3.onreadystatechange = function() {
                                            c(e4), t3.onreadystatechange = null, s.removeChild(t3), t3 = null;
                                        }, s.appendChild(t3);
                                    }) : function(e4) {
                                        setTimeout(c, 0, e4);
                                    }, e3.setImmediate = function(e4) {
                                        "function" != typeof e4 && (e4 = new Function("" + e4));
                                        for(var t3 = new Array(arguments.length - 1), r3 = 0; r3 < t3.length; r3++)t3[r3] = arguments[r3 + 1];
                                        var n2 = {
                                            callback: e4,
                                            args: t3
                                        };
                                        return h[o] = n2, i(o), o++;
                                    }, e3.clearImmediate = f;
                                }
                                function f(e4) {
                                    delete h[e4];
                                }
                                function c(e4) {
                                    if (u) setTimeout(c, 0, e4);
                                    else {
                                        var t3 = h[e4];
                                        if (t3) {
                                            u = true;
                                            try {
                                                !function(e5) {
                                                    var t4 = e5.callback, r3 = e5.args;
                                                    switch(r3.length){
                                                        case 0:
                                                            t4();
                                                            break;
                                                        case 1:
                                                            t4(r3[0]);
                                                            break;
                                                        case 2:
                                                            t4(r3[0], r3[1]);
                                                            break;
                                                        case 3:
                                                            t4(r3[0], r3[1], r3[2]);
                                                            break;
                                                        default:
                                                            t4.apply(n, r3);
                                                    }
                                                }(t3);
                                            } finally{
                                                f(e4), u = false;
                                            }
                                        }
                                    }
                                }
                                function d(e4) {
                                    e4.source === r2 && "string" == typeof e4.data && 0 === e4.data.indexOf(a) && c(+e4.data.slice(a.length));
                                }
                            }("undefined" == typeof self ? void 0 === e2 ? this : e2 : self);
                        }).call(this, "undefined" != typeof $be59461d4a783f7b$var$commonjsGlobal ? $be59461d4a783f7b$var$commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                    },
                    {}
                ]
            }, {}, [
                10
            ])(10);
        });
    })($be59461d4a783f7b$var$jszip_min);
    return $be59461d4a783f7b$var$jszip_min.exports;
}
var $be59461d4a783f7b$var$jszip_minExports = $be59461d4a783f7b$var$requireJszip_min();
const $be59461d4a783f7b$var$JSZip = /* @__PURE__ */ $be59461d4a783f7b$var$getDefaultExportFromCjs$1($be59461d4a783f7b$var$jszip_minExports);
var $be59461d4a783f7b$var$xml$1 = {
    exports: {}
};
var $be59461d4a783f7b$var$escapeForXML_1;
var $be59461d4a783f7b$var$hasRequiredEscapeForXML;
function $be59461d4a783f7b$var$requireEscapeForXML() {
    if ($be59461d4a783f7b$var$hasRequiredEscapeForXML) return $be59461d4a783f7b$var$escapeForXML_1;
    $be59461d4a783f7b$var$hasRequiredEscapeForXML = 1;
    var XML_CHARACTER_MAP = {
        "&": "&amp;",
        '"': "&quot;",
        "'": "&apos;",
        "<": "&lt;",
        ">": "&gt;"
    };
    function escapeForXML(string) {
        return string && string.replace ? string.replace(/([&"<>'])/g, function(str, item) {
            return XML_CHARACTER_MAP[item];
        }) : string;
    }
    $be59461d4a783f7b$var$escapeForXML_1 = escapeForXML;
    return $be59461d4a783f7b$var$escapeForXML_1;
}
var $be59461d4a783f7b$var$hasRequiredXml;
function $be59461d4a783f7b$var$requireXml() {
    if ($be59461d4a783f7b$var$hasRequiredXml) return $be59461d4a783f7b$var$xml$1.exports;
    $be59461d4a783f7b$var$hasRequiredXml = 1;
    var escapeForXML = $be59461d4a783f7b$var$requireEscapeForXML();
    var Stream = $be59461d4a783f7b$var$requireStreamBrowserify().Stream;
    var DEFAULT_INDENT = "    ";
    function xml2(input, options) {
        if (typeof options !== "object") options = {
            indent: options
        };
        var stream = options.stream ? new Stream() : null, output = "", interrupted = false, indent = !options.indent ? "" : options.indent === true ? DEFAULT_INDENT : options.indent, instant = true;
        function delay(func) {
            if (!instant) func();
            else $be59461d4a783f7b$var$process$1.nextTick(func);
        }
        function append(interrupt, out) {
            if (out !== void 0) output += out;
            if (interrupt && !interrupted) {
                stream = stream || new Stream();
                interrupted = true;
            }
            if (interrupt && interrupted) {
                var data = output;
                delay(function() {
                    stream.emit("data", data);
                });
                output = "";
            }
        }
        function add(value, last) {
            format(append, resolve(value, indent, indent ? 1 : 0), last);
        }
        function end() {
            if (stream) {
                var data = output;
                delay(function() {
                    stream.emit("data", data);
                    stream.emit("end");
                    stream.readable = false;
                    stream.emit("close");
                });
            }
        }
        function addXmlDeclaration(declaration) {
            var encoding = declaration.encoding || "UTF-8", attr = {
                version: "1.0",
                encoding: encoding
            };
            if (declaration.standalone) attr.standalone = declaration.standalone;
            add({
                "?xml": {
                    _attr: attr
                }
            });
            output = output.replace("/>", "?>");
        }
        delay(function() {
            instant = false;
        });
        if (options.declaration) addXmlDeclaration(options.declaration);
        if (input && input.forEach) input.forEach(function(value, i) {
            var last;
            if (i + 1 === input.length) last = end;
            add(value, last);
        });
        else add(input, end);
        if (stream) {
            stream.readable = true;
            return stream;
        }
        return output;
    }
    function element() {
        var input = Array.prototype.slice.call(arguments), self2 = {
            _elem: resolve(input)
        };
        self2.push = function(input2) {
            if (!this.append) throw new Error("not assigned to a parent!");
            var that = this;
            var indent = this._elem.indent;
            format(this.append, resolve(input2, indent, this._elem.icount + (indent ? 1 : 0)), function() {
                that.append(true);
            });
        };
        self2.close = function(input2) {
            if (input2 !== void 0) this.push(input2);
            if (this.end) this.end();
        };
        return self2;
    }
    function create_indent(character, count) {
        return new Array(count || 0).join(character || "");
    }
    function resolve(data, indent, indent_count) {
        indent_count = indent_count || 0;
        var indent_spaces = create_indent(indent, indent_count);
        var name;
        var values = data;
        var interrupt = false;
        if (typeof data === "object") {
            var keys = Object.keys(data);
            name = keys[0];
            values = data[name];
            if (values && values._elem) {
                values._elem.name = name;
                values._elem.icount = indent_count;
                values._elem.indent = indent;
                values._elem.indents = indent_spaces;
                values._elem.interrupt = values;
                return values._elem;
            }
        }
        var attributes = [], content = [];
        var isStringContent;
        function get_attributes(obj) {
            var keys2 = Object.keys(obj);
            keys2.forEach(function(key) {
                attributes.push(attribute(key, obj[key]));
            });
        }
        switch(typeof values){
            case "object":
                if (values === null) break;
                if (values._attr) get_attributes(values._attr);
                if (values._cdata) content.push(("<![CDATA[" + values._cdata).replace(/\]\]>/g, "]]]]><![CDATA[>") + "]]>");
                if (values.forEach) {
                    isStringContent = false;
                    content.push("");
                    values.forEach(function(value) {
                        if (typeof value == "object") {
                            var _name = Object.keys(value)[0];
                            if (_name == "_attr") get_attributes(value._attr);
                            else content.push(resolve(value, indent, indent_count + 1));
                        } else {
                            content.pop();
                            isStringContent = true;
                            content.push(escapeForXML(value));
                        }
                    });
                    if (!isStringContent) content.push("");
                }
                break;
            default:
                content.push(escapeForXML(values));
        }
        return {
            name: name,
            interrupt: interrupt,
            attributes: attributes,
            content: content,
            icount: indent_count,
            indents: indent_spaces,
            indent: indent
        };
    }
    function format(append, elem, end) {
        if (typeof elem != "object") return append(false, elem);
        var len = elem.interrupt ? 1 : elem.content.length;
        function proceed() {
            while(elem.content.length){
                var value = elem.content.shift();
                if (value === void 0) continue;
                if (interrupt(value)) return;
                format(append, value);
            }
            append(false, (len > 1 ? elem.indents : "") + (elem.name ? "</" + elem.name + ">" : "") + (elem.indent && !end ? "\n" : ""));
            if (end) end();
        }
        function interrupt(value) {
            if (value.interrupt) {
                value.interrupt.append = append;
                value.interrupt.end = proceed;
                value.interrupt = false;
                append(true);
                return true;
            }
            return false;
        }
        append(false, elem.indents + (elem.name ? "<" + elem.name : "") + (elem.attributes.length ? " " + elem.attributes.join(" ") : "") + (len ? elem.name ? ">" : "" : elem.name ? "/>" : "") + (elem.indent && len > 1 ? "\n" : ""));
        if (!len) return append(false, elem.indent ? "\n" : "");
        if (!interrupt(elem)) proceed();
    }
    function attribute(key, value) {
        return key + '="' + escapeForXML(value) + '"';
    }
    $be59461d4a783f7b$var$xml$1.exports = xml2;
    $be59461d4a783f7b$var$xml$1.exports.element = $be59461d4a783f7b$var$xml$1.exports.Element = element;
    return $be59461d4a783f7b$var$xml$1.exports;
}
var $be59461d4a783f7b$var$xmlExports = $be59461d4a783f7b$var$requireXml();
const $be59461d4a783f7b$var$xml = /* @__PURE__ */ $be59461d4a783f7b$var$getDefaultExportFromCjs$1($be59461d4a783f7b$var$xmlExports);
const $be59461d4a783f7b$var$obfuscatedStartOffset = 0;
const $be59461d4a783f7b$var$obfuscatedEndOffset = 32;
const $be59461d4a783f7b$var$guidSize = 32;
const $be59461d4a783f7b$var$obfuscate = (buf, fontKey)=>{
    const guid = fontKey.replace(/-/g, "");
    if (guid.length !== $be59461d4a783f7b$var$guidSize) throw new Error(`Error: Cannot extract GUID from font filename: ${fontKey}`);
    const hexStrings = guid.replace(/(..)/g, "$1 ").trim().split(" ");
    const hexNumbers = hexStrings.map((hexString)=>parseInt(hexString, 16));
    hexNumbers.reverse();
    const bytesToObfuscate = buf.slice($be59461d4a783f7b$var$obfuscatedStartOffset, $be59461d4a783f7b$var$obfuscatedEndOffset);
    const obfuscatedBytes = bytesToObfuscate.map((byte, i)=>byte ^ hexNumbers[i % hexNumbers.length]);
    const out = new Uint8Array($be59461d4a783f7b$var$obfuscatedStartOffset + obfuscatedBytes.length + Math.max(0, buf.length - $be59461d4a783f7b$var$obfuscatedEndOffset));
    out.set(buf.slice(0, $be59461d4a783f7b$var$obfuscatedStartOffset));
    out.set(obfuscatedBytes, $be59461d4a783f7b$var$obfuscatedStartOffset);
    out.set(buf.slice($be59461d4a783f7b$var$obfuscatedEndOffset), $be59461d4a783f7b$var$obfuscatedStartOffset + obfuscatedBytes.length);
    return out;
};
class $be59461d4a783f7b$var$Formatter {
    format(input, context = {
        stack: []
    }) {
        const output = input.prepForXml(context);
        if (output) return output;
        else throw Error("XMLComponent did not format correctly");
    }
}
class $be59461d4a783f7b$var$ImageReplacer {
    replace(xmlData, mediaData, offset) {
        let currentXmlData = xmlData;
        mediaData.forEach((image, i)=>{
            currentXmlData = currentXmlData.replace(new RegExp(`{${image.fileName}}`, "g"), (offset + i).toString());
        });
        return currentXmlData;
    }
    getMediaData(xmlData, media) {
        return media.Array.filter((image)=>xmlData.search(`{${image.fileName}}`) > 0);
    }
}
class $be59461d4a783f7b$var$NumberingReplacer {
    replace(xmlData, concreteNumberings) {
        let currentXmlData = xmlData;
        for (const concreteNumbering of concreteNumberings)currentXmlData = currentXmlData.replace(new RegExp(`{${concreteNumbering.reference}-${concreteNumbering.instance}}`, "g"), concreteNumbering.numId.toString());
        return currentXmlData;
    }
}
class $be59461d4a783f7b$var$Compiler {
    constructor(){
        $be59461d4a783f7b$var$__publicField(this, "formatter");
        $be59461d4a783f7b$var$__publicField(this, "imageReplacer");
        $be59461d4a783f7b$var$__publicField(this, "numberingReplacer");
        this.formatter = new $be59461d4a783f7b$var$Formatter();
        this.imageReplacer = new $be59461d4a783f7b$var$ImageReplacer();
        this.numberingReplacer = new $be59461d4a783f7b$var$NumberingReplacer();
    }
    compile(file, prettifyXml, overrides = []) {
        const zip = new $be59461d4a783f7b$var$JSZip();
        const xmlifiedFileMapping = this.xmlifyFile(file, prettifyXml);
        const map = new Map(Object.entries(xmlifiedFileMapping));
        for (const [, obj] of map){
            if (Array.isArray(obj)) for (const subFile of obj)zip.file(subFile.path, subFile.data);
            else zip.file(obj.path, obj.data);
        }
        for (const subFile of overrides)zip.file(subFile.path, subFile.data);
        for (const data of file.Media.Array)if (data.type !== "svg") zip.file(`word/media/${data.fileName}`, data.data);
        else {
            zip.file(`word/media/${data.fileName}`, data.data);
            zip.file(`word/media/${data.fallback.fileName}`, data.fallback.data);
        }
        for (const { data: buffer2, name: name, fontKey: fontKey } of file.FontTable.fontOptionsWithKey){
            const [nameWithoutExtension] = name.split(".");
            zip.file(`word/fonts/${nameWithoutExtension}.odttf`, $be59461d4a783f7b$var$obfuscate(buffer2, fontKey));
        }
        return zip;
    }
    xmlifyFile(file, prettify) {
        const documentRelationshipCount = file.Document.Relationships.RelationshipCount + 1;
        const documentXmlData = $be59461d4a783f7b$var$xml(this.formatter.format(file.Document.View, {
            viewWrapper: file.Document,
            file: file,
            stack: []
        }), {
            indent: prettify,
            declaration: {
                standalone: "yes",
                encoding: "UTF-8"
            }
        });
        const commentRelationshipCount = file.Comments.Relationships.RelationshipCount + 1;
        const commentXmlData = $be59461d4a783f7b$var$xml(this.formatter.format(file.Comments, {
            viewWrapper: {
                View: file.Comments,
                Relationships: file.Comments.Relationships
            },
            file: file,
            stack: []
        }), {
            indent: prettify,
            declaration: {
                standalone: "yes",
                encoding: "UTF-8"
            }
        });
        const documentMediaDatas = this.imageReplacer.getMediaData(documentXmlData, file.Media);
        const commentMediaDatas = this.imageReplacer.getMediaData(commentXmlData, file.Media);
        return {
            Relationships: {
                data: (()=>{
                    documentMediaDatas.forEach((mediaData, i)=>{
                        file.Document.Relationships.createRelationship(documentRelationshipCount + i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${mediaData.fileName}`);
                    });
                    file.Document.Relationships.createRelationship(file.Document.Relationships.RelationshipCount + 1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable", "fontTable.xml");
                    return $be59461d4a783f7b$var$xml(this.formatter.format(file.Document.Relationships, {
                        viewWrapper: file.Document,
                        file: file,
                        stack: []
                    }), {
                        indent: prettify,
                        declaration: {
                            encoding: "UTF-8"
                        }
                    });
                })(),
                path: "word/_rels/document.xml.rels"
            },
            Document: {
                data: (()=>{
                    const xmlData = this.imageReplacer.replace(documentXmlData, documentMediaDatas, documentRelationshipCount);
                    const referenedXmlData = this.numberingReplacer.replace(xmlData, file.Numbering.ConcreteNumbering);
                    return referenedXmlData;
                })(),
                path: "word/document.xml"
            },
            Styles: {
                data: (()=>{
                    const xmlStyles = $be59461d4a783f7b$var$xml(this.formatter.format(file.Styles, {
                        viewWrapper: file.Document,
                        file: file,
                        stack: []
                    }), {
                        indent: prettify,
                        declaration: {
                            standalone: "yes",
                            encoding: "UTF-8"
                        }
                    });
                    const referencedXmlStyles = this.numberingReplacer.replace(xmlStyles, file.Numbering.ConcreteNumbering);
                    return referencedXmlStyles;
                })(),
                path: "word/styles.xml"
            },
            Properties: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.CoreProperties, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        standalone: "yes",
                        encoding: "UTF-8"
                    }
                }),
                path: "docProps/core.xml"
            },
            Numbering: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.Numbering, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        standalone: "yes",
                        encoding: "UTF-8"
                    }
                }),
                path: "word/numbering.xml"
            },
            FileRelationships: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.FileRelationships, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        encoding: "UTF-8"
                    }
                }),
                path: "_rels/.rels"
            },
            HeaderRelationships: file.Headers.map((headerWrapper, index)=>{
                const xmlData = $be59461d4a783f7b$var$xml(this.formatter.format(headerWrapper.View, {
                    viewWrapper: headerWrapper,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        encoding: "UTF-8"
                    }
                });
                const mediaDatas = this.imageReplacer.getMediaData(xmlData, file.Media);
                mediaDatas.forEach((mediaData, i)=>{
                    headerWrapper.Relationships.createRelationship(i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${mediaData.fileName}`);
                });
                return {
                    data: $be59461d4a783f7b$var$xml(this.formatter.format(headerWrapper.Relationships, {
                        viewWrapper: headerWrapper,
                        file: file,
                        stack: []
                    }), {
                        indent: prettify,
                        declaration: {
                            encoding: "UTF-8"
                        }
                    }),
                    path: `word/_rels/header${index + 1}.xml.rels`
                };
            }),
            FooterRelationships: file.Footers.map((footerWrapper, index)=>{
                const xmlData = $be59461d4a783f7b$var$xml(this.formatter.format(footerWrapper.View, {
                    viewWrapper: footerWrapper,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        encoding: "UTF-8"
                    }
                });
                const mediaDatas = this.imageReplacer.getMediaData(xmlData, file.Media);
                mediaDatas.forEach((mediaData, i)=>{
                    footerWrapper.Relationships.createRelationship(i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${mediaData.fileName}`);
                });
                return {
                    data: $be59461d4a783f7b$var$xml(this.formatter.format(footerWrapper.Relationships, {
                        viewWrapper: footerWrapper,
                        file: file,
                        stack: []
                    }), {
                        indent: prettify,
                        declaration: {
                            encoding: "UTF-8"
                        }
                    }),
                    path: `word/_rels/footer${index + 1}.xml.rels`
                };
            }),
            Headers: file.Headers.map((headerWrapper, index)=>{
                const tempXmlData = $be59461d4a783f7b$var$xml(this.formatter.format(headerWrapper.View, {
                    viewWrapper: headerWrapper,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        encoding: "UTF-8"
                    }
                });
                const mediaDatas = this.imageReplacer.getMediaData(tempXmlData, file.Media);
                const xmlData = this.imageReplacer.replace(tempXmlData, mediaDatas, 0);
                const referenedXmlData = this.numberingReplacer.replace(xmlData, file.Numbering.ConcreteNumbering);
                return {
                    data: referenedXmlData,
                    path: `word/header${index + 1}.xml`
                };
            }),
            Footers: file.Footers.map((footerWrapper, index)=>{
                const tempXmlData = $be59461d4a783f7b$var$xml(this.formatter.format(footerWrapper.View, {
                    viewWrapper: footerWrapper,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        encoding: "UTF-8"
                    }
                });
                const mediaDatas = this.imageReplacer.getMediaData(tempXmlData, file.Media);
                const xmlData = this.imageReplacer.replace(tempXmlData, mediaDatas, 0);
                const referenedXmlData = this.numberingReplacer.replace(xmlData, file.Numbering.ConcreteNumbering);
                return {
                    data: referenedXmlData,
                    path: `word/footer${index + 1}.xml`
                };
            }),
            ContentTypes: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.ContentTypes, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        encoding: "UTF-8"
                    }
                }),
                path: "[Content_Types].xml"
            },
            CustomProperties: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.CustomProperties, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        standalone: "yes",
                        encoding: "UTF-8"
                    }
                }),
                path: "docProps/custom.xml"
            },
            AppProperties: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.AppProperties, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        standalone: "yes",
                        encoding: "UTF-8"
                    }
                }),
                path: "docProps/app.xml"
            },
            FootNotes: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.FootNotes.View, {
                    viewWrapper: file.FootNotes,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        encoding: "UTF-8"
                    }
                }),
                path: "word/footnotes.xml"
            },
            FootNotesRelationships: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.FootNotes.Relationships, {
                    viewWrapper: file.FootNotes,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        encoding: "UTF-8"
                    }
                }),
                path: "word/_rels/footnotes.xml.rels"
            },
            Settings: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.Settings, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        standalone: "yes",
                        encoding: "UTF-8"
                    }
                }),
                path: "word/settings.xml"
            },
            Comments: {
                data: (()=>{
                    const xmlData = this.imageReplacer.replace(commentXmlData, commentMediaDatas, commentRelationshipCount);
                    const referenedXmlData = this.numberingReplacer.replace(xmlData, file.Numbering.ConcreteNumbering);
                    return referenedXmlData;
                })(),
                path: "word/comments.xml"
            },
            CommentsRelationships: {
                data: (()=>{
                    commentMediaDatas.forEach((mediaData, i)=>{
                        file.Comments.Relationships.createRelationship(commentRelationshipCount + i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${mediaData.fileName}`);
                    });
                    return $be59461d4a783f7b$var$xml(this.formatter.format(file.Comments.Relationships, {
                        viewWrapper: {
                            View: file.Comments,
                            Relationships: file.Comments.Relationships
                        },
                        file: file,
                        stack: []
                    }), {
                        indent: prettify,
                        declaration: {
                            encoding: "UTF-8"
                        }
                    });
                })(),
                path: "word/_rels/comments.xml.rels"
            },
            FontTable: {
                data: $be59461d4a783f7b$var$xml(this.formatter.format(file.FontTable.View, {
                    viewWrapper: file.Document,
                    file: file,
                    stack: []
                }), {
                    indent: prettify,
                    declaration: {
                        standalone: "yes",
                        encoding: "UTF-8"
                    }
                }),
                path: "word/fontTable.xml"
            },
            FontTableRelationships: {
                data: (()=>$be59461d4a783f7b$var$xml(this.formatter.format(file.FontTable.Relationships, {
                        viewWrapper: file.Document,
                        file: file,
                        stack: []
                    }), {
                        indent: prettify,
                        declaration: {
                            encoding: "UTF-8"
                        }
                    }))(),
                path: "word/_rels/fontTable.xml.rels"
            }
        };
    }
}
const $be59461d4a783f7b$export$846689ea131a0290 = {
    NONE: "",
    WITH_2_BLANKS: "  ",
    WITH_4_BLANKS: "    ",
    WITH_TAB: "	"
};
const $be59461d4a783f7b$var$convertPrettifyType = (prettify)=>prettify === true ? $be59461d4a783f7b$export$846689ea131a0290.WITH_2_BLANKS : prettify === false ? void 0 : prettify;
const $be59461d4a783f7b$var$_Packer = class _Packer {
    // eslint-disable-next-line require-await
    static pack(_0, _12, _2) {
        return $be59461d4a783f7b$var$__async(this, arguments, function*(file, type2, prettify, overrides = []) {
            const zip = this.compiler.compile(file, $be59461d4a783f7b$var$convertPrettifyType(prettify), overrides);
            return zip.generateAsync({
                type: type2,
                mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                compression: "DEFLATE"
            });
        });
    }
    static toString(file, prettify, overrides = []) {
        return _Packer.pack(file, "string", prettify, overrides);
    }
    static toBuffer(file, prettify, overrides = []) {
        return _Packer.pack(file, "nodebuffer", prettify, overrides);
    }
    static toBase64String(file, prettify, overrides = []) {
        return _Packer.pack(file, "base64", prettify, overrides);
    }
    static toBlob(file, prettify, overrides = []) {
        return _Packer.pack(file, "blob", prettify, overrides);
    }
    static toArrayBuffer(file, prettify, overrides = []) {
        return _Packer.pack(file, "arraybuffer", prettify, overrides);
    }
    static toStream(file, prettify, overrides = []) {
        const stream = new $be59461d4a783f7b$var$streamBrowserifyExports.Stream();
        const zip = this.compiler.compile(file, $be59461d4a783f7b$var$convertPrettifyType(prettify), overrides);
        zip.generateAsync({
            type: "nodebuffer",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            compression: "DEFLATE"
        }).then((z)=>{
            stream.emit("data", z);
            stream.emit("end");
        });
        return stream;
    }
};
$be59461d4a783f7b$var$__publicField($be59461d4a783f7b$var$_Packer, "compiler", new $be59461d4a783f7b$var$Compiler());
let $be59461d4a783f7b$export$b9ec4b114aa40074 = $be59461d4a783f7b$var$_Packer;
const $be59461d4a783f7b$var$formatter$1 = new $be59461d4a783f7b$var$Formatter();
const $be59461d4a783f7b$var$toJson = (xmlData)=>{
    const xmlObj = $be59461d4a783f7b$var$libExports.xml2js(xmlData, {
        compact: false,
        captureSpacesBetweenElements: true
    });
    return xmlObj;
};
const $be59461d4a783f7b$var$createTextElementContents = (text)=>{
    var _a;
    const textJson = $be59461d4a783f7b$var$toJson($be59461d4a783f7b$var$xml($be59461d4a783f7b$var$formatter$1.format(new $be59461d4a783f7b$var$Text({
        text: text
    }))));
    return (_a = textJson.elements[0].elements) != null ? _a : [];
};
const $be59461d4a783f7b$var$patchSpaceAttribute = (element)=>$be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, element), {
        attributes: {
            "xml:space": "preserve"
        }
    });
const $be59461d4a783f7b$var$getFirstLevelElements = (relationships, id)=>{
    var _a, _b;
    return (_b = (_a = relationships.elements) == null ? void 0 : _a.filter((e)=>e.name === id)[0].elements) != null ? _b : [];
};
const $be59461d4a783f7b$var$appendContentType = (element, contentType, extension)=>{
    const relationshipElements = $be59461d4a783f7b$var$getFirstLevelElements(element, "Types");
    const exist = relationshipElements.some((el)=>{
        var _a, _b;
        return el.type === "element" && el.name === "Default" && ((_a = el == null ? void 0 : el.attributes) == null ? void 0 : _a.ContentType) === contentType && ((_b = el == null ? void 0 : el.attributes) == null ? void 0 : _b.Extension) === extension;
    });
    if (exist) return;
    relationshipElements.push({
        attributes: {
            ContentType: contentType,
            Extension: extension
        },
        name: "Default",
        type: "element"
    });
};
const $be59461d4a783f7b$var$getIdFromRelationshipId = (relationshipId)=>{
    const output = parseInt(relationshipId.substring(3), 10);
    return isNaN(output) ? 0 : output;
};
const $be59461d4a783f7b$var$getNextRelationshipIndex = (relationships)=>{
    const relationshipElements = $be59461d4a783f7b$var$getFirstLevelElements(relationships, "Relationships");
    return relationshipElements.map((e)=>{
        var _a, _b, _c;
        return $be59461d4a783f7b$var$getIdFromRelationshipId((_c = (_b = (_a = e.attributes) == null ? void 0 : _a.Id) == null ? void 0 : _b.toString()) != null ? _c : "");
    }).reduce((acc, curr)=>Math.max(acc, curr), 0) + 1;
};
const $be59461d4a783f7b$var$appendRelationship = (relationships, id, type2, target, targetMode)=>{
    const relationshipElements = $be59461d4a783f7b$var$getFirstLevelElements(relationships, "Relationships");
    relationshipElements.push({
        attributes: {
            Id: `rId${id}`,
            Type: type2,
            Target: target,
            TargetMode: targetMode
        },
        name: "Relationship",
        type: "element"
    });
    return relationshipElements;
};
const $be59461d4a783f7b$var$findRunElementIndexWithToken = (paragraphElement, token)=>{
    var _a, _b, _c, _d;
    for(let i = 0; i < ((_a = paragraphElement.elements) != null ? _a : []).length; i++){
        const element = paragraphElement.elements[i];
        if (element.type === "element" && element.name === "w:r") {
            const textElement = ((_b = element.elements) != null ? _b : []).filter((e)=>e.type === "element" && e.name === "w:t");
            for (const text of textElement){
                if (!((_c = text.elements) == null ? void 0 : _c[0])) continue;
                if ((_d = text.elements[0].text) == null ? void 0 : _d.includes(token)) return i;
            }
        }
    }
    throw new Error("Token not found");
};
const $be59461d4a783f7b$var$splitRunElement = (runElement, token)=>{
    var _a, _b;
    let splitIndex = 0;
    const splitElements = (_b = (_a = runElement.elements) == null ? void 0 : _a.map((e, i)=>{
        var _a2, _b2, _c;
        if (e.type === "element" && e.name === "w:t") {
            const text = (_c = (_b2 = (_a2 = e.elements) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.text) != null ? _c : "";
            const splitText = text.split(token);
            const newElements = splitText.map((t)=>$be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues($be59461d4a783f7b$var$__spreadValues({}, e), $be59461d4a783f7b$var$patchSpaceAttribute(e)), {
                    elements: $be59461d4a783f7b$var$createTextElementContents(t)
                }));
            splitIndex = i;
            return newElements;
        } else return e;
    }).flat()) != null ? _b : [];
    const leftRunElement = $be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, JSON.parse(JSON.stringify(runElement))), {
        elements: splitElements.slice(0, splitIndex + 1)
    });
    const rightRunElement = $be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, JSON.parse(JSON.stringify(runElement))), {
        elements: splitElements.slice(splitIndex + 1)
    });
    return {
        left: leftRunElement,
        right: rightRunElement
    };
};
const $be59461d4a783f7b$var$ReplaceMode = {
    START: 0,
    MIDDLE: 1,
    END: 2
};
const $be59461d4a783f7b$var$replaceTokenInParagraphElement = ({ paragraphElement: paragraphElement, renderedParagraph: renderedParagraph, originalText: originalText, replacementText: replacementText })=>{
    const startIndex = renderedParagraph.text.indexOf(originalText);
    const endIndex = startIndex + originalText.length - 1;
    let replaceMode = $be59461d4a783f7b$var$ReplaceMode.START;
    for (const run of renderedParagraph.runs)for (const { text: text, index: index, start: start, end: end } of run.parts)switch(replaceMode){
        case $be59461d4a783f7b$var$ReplaceMode.START:
            if (startIndex >= start) {
                const offsetStartIndex = startIndex - start;
                const offsetEndIndex = Math.min(endIndex, end) - start;
                const partToReplace = run.text.substring(offsetStartIndex, offsetEndIndex + 1);
                if (partToReplace === "") continue;
                const firstPart = text.replace(partToReplace, replacementText);
                $be59461d4a783f7b$var$patchTextElement(paragraphElement.elements[run.index].elements[index], firstPart);
                replaceMode = $be59461d4a783f7b$var$ReplaceMode.MIDDLE;
                continue;
            }
            break;
        case $be59461d4a783f7b$var$ReplaceMode.MIDDLE:
            if (endIndex <= end) {
                const lastPart = text.substring(endIndex - start + 1);
                $be59461d4a783f7b$var$patchTextElement(paragraphElement.elements[run.index].elements[index], lastPart);
                const currentElement = paragraphElement.elements[run.index].elements[index];
                paragraphElement.elements[run.index].elements[index] = $be59461d4a783f7b$var$patchSpaceAttribute(currentElement);
                replaceMode = $be59461d4a783f7b$var$ReplaceMode.END;
            } else $be59461d4a783f7b$var$patchTextElement(paragraphElement.elements[run.index].elements[index], "");
            break;
    }
    return paragraphElement;
};
const $be59461d4a783f7b$var$patchTextElement = (element, text)=>{
    element.elements = $be59461d4a783f7b$var$createTextElementContents(text);
    return element;
};
const $be59461d4a783f7b$var$renderParagraphNode = (node)=>{
    if (node.element.name !== "w:p") throw new Error(`Invalid node type: ${node.element.name}`);
    if (!node.element.elements) return {
        text: "",
        runs: [],
        index: -1,
        pathToParagraph: []
    };
    let currentRunStringLength = 0;
    const runs = node.element.elements.map((element, i)=>({
            element: element,
            i: i
        })).filter(({ element: element })=>element.name === "w:r").map(({ element: element, i: i })=>{
        const renderedRunNode = $be59461d4a783f7b$var$renderRunNode(element, i, currentRunStringLength);
        currentRunStringLength += renderedRunNode.text.length;
        return renderedRunNode;
    }).filter((e)=>!!e);
    const text = runs.reduce((acc, curr)=>acc + curr.text, "");
    return {
        text: text,
        runs: runs,
        index: node.index,
        pathToParagraph: $be59461d4a783f7b$var$buildNodePath(node)
    };
};
const $be59461d4a783f7b$var$renderRunNode = (node, index, currentRunStringIndex)=>{
    if (!node.elements) return {
        text: "",
        parts: [],
        index: -1,
        start: currentRunStringIndex,
        end: currentRunStringIndex
    };
    let currentTextStringIndex = currentRunStringIndex;
    const parts = node.elements.map((element, i)=>{
        var _a, _b;
        return element.name === "w:t" && element.elements && element.elements.length > 0 ? {
            text: (_b = (_a = element.elements[0].text) == null ? void 0 : _a.toString()) != null ? _b : "",
            index: i,
            start: currentTextStringIndex,
            end: (()=>{
                var _a2, _b2;
                currentTextStringIndex += ((_b2 = (_a2 = element.elements[0].text) == null ? void 0 : _a2.toString()) != null ? _b2 : "").length - 1;
                return currentTextStringIndex;
            })()
        } : void 0;
    }).filter((e)=>!!e).map((e)=>e);
    const text = parts.reduce((acc, curr)=>acc + curr.text, "");
    return {
        text: text,
        parts: parts,
        index: index,
        start: currentRunStringIndex,
        end: currentTextStringIndex
    };
};
const $be59461d4a783f7b$var$buildNodePath = (node)=>node.parent ? [
        ...$be59461d4a783f7b$var$buildNodePath(node.parent),
        node.index
    ] : [
        node.index
    ];
const $be59461d4a783f7b$var$elementsToWrapper = (wrapper)=>{
    var _a, _b;
    return (_b = (_a = wrapper.element.elements) == null ? void 0 : _a.map((e, i)=>({
            element: e,
            index: i,
            parent: wrapper
        }))) != null ? _b : [];
};
const $be59461d4a783f7b$var$traverse = (node)=>{
    let renderedParagraphs = [];
    const queue2 = [
        ...$be59461d4a783f7b$var$elementsToWrapper({
            element: node,
            index: 0,
            parent: void 0
        })
    ];
    let currentNode;
    while(queue2.length > 0){
        currentNode = queue2.shift();
        if (currentNode.element.name === "w:p") renderedParagraphs = [
            ...renderedParagraphs,
            $be59461d4a783f7b$var$renderParagraphNode(currentNode)
        ];
        queue2.push(...$be59461d4a783f7b$var$elementsToWrapper(currentNode));
    }
    return renderedParagraphs;
};
const $be59461d4a783f7b$var$findLocationOfText = (node, text)=>$be59461d4a783f7b$var$traverse(node).filter((p)=>p.text.includes(text));
const $be59461d4a783f7b$var$formatter = new $be59461d4a783f7b$var$Formatter();
const $be59461d4a783f7b$var$SPLIT_TOKEN = "\u0275";
const $be59461d4a783f7b$var$replacer = ({ json: json, patch: patch, patchText: patchText, context: context, keepOriginalStyles: keepOriginalStyles = true })=>{
    const renderedParagraphs = $be59461d4a783f7b$var$findLocationOfText(json, patchText);
    if (renderedParagraphs.length === 0) return {
        element: json,
        didFindOccurrence: false
    };
    for (const renderedParagraph of renderedParagraphs){
        const textJson = patch.children.map((c)=>$be59461d4a783f7b$var$toJson($be59461d4a783f7b$var$xml($be59461d4a783f7b$var$formatter.format(c, context)))).map((c)=>c.elements[0]);
        switch(patch.type){
            case $be59461d4a783f7b$export$f2a72f9061335e5d.DOCUMENT:
                {
                    const parentElement = $be59461d4a783f7b$var$goToParentElementFromPath(json, renderedParagraph.pathToParagraph);
                    const elementIndex = $be59461d4a783f7b$var$getLastElementIndexFromPath(renderedParagraph.pathToParagraph);
                    parentElement.elements.splice(elementIndex, 1, ...textJson);
                    break;
                }
            case $be59461d4a783f7b$export$f2a72f9061335e5d.PARAGRAPH:
            default:
                {
                    const paragraphElement = $be59461d4a783f7b$var$goToElementFromPath(json, renderedParagraph.pathToParagraph);
                    $be59461d4a783f7b$var$replaceTokenInParagraphElement({
                        paragraphElement: paragraphElement,
                        renderedParagraph: renderedParagraph,
                        originalText: patchText,
                        replacementText: $be59461d4a783f7b$var$SPLIT_TOKEN
                    });
                    const index = $be59461d4a783f7b$var$findRunElementIndexWithToken(paragraphElement, $be59461d4a783f7b$var$SPLIT_TOKEN);
                    const runElementToBeReplaced = paragraphElement.elements[index];
                    const { left: left, right: right } = $be59461d4a783f7b$var$splitRunElement(runElementToBeReplaced, $be59461d4a783f7b$var$SPLIT_TOKEN);
                    let newRunElements = textJson;
                    let patchedRightElement = right;
                    if (keepOriginalStyles) {
                        const runElementNonTextualElements = runElementToBeReplaced.elements.filter((e)=>e.type === "element" && e.name === "w:rPr");
                        newRunElements = textJson.map((e)=>{
                            var _a;
                            return $be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, e), {
                                elements: [
                                    ...runElementNonTextualElements,
                                    ...(_a = e.elements) != null ? _a : []
                                ]
                            });
                        });
                        patchedRightElement = $be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, right), {
                            elements: [
                                ...runElementNonTextualElements,
                                ...right.elements
                            ]
                        });
                    }
                    paragraphElement.elements.splice(index, 1, left, ...newRunElements, patchedRightElement);
                    break;
                }
        }
    }
    return {
        element: json,
        didFindOccurrence: true
    };
};
const $be59461d4a783f7b$var$goToElementFromPath = (json, path)=>{
    let element = json;
    for(let i = 1; i < path.length; i++){
        const index = path[i];
        const nextElements = element.elements;
        element = nextElements[index];
    }
    return element;
};
const $be59461d4a783f7b$var$goToParentElementFromPath = (json, path)=>$be59461d4a783f7b$var$goToElementFromPath(json, path.slice(0, path.length - 1));
const $be59461d4a783f7b$var$getLastElementIndexFromPath = (path)=>path[path.length - 1];
const $be59461d4a783f7b$export$f2a72f9061335e5d = {
    DOCUMENT: "file",
    PARAGRAPH: "paragraph"
};
const $be59461d4a783f7b$var$imageReplacer = new $be59461d4a783f7b$var$ImageReplacer();
const $be59461d4a783f7b$var$UTF16LE = new Uint8Array([
    255,
    254
]);
const $be59461d4a783f7b$var$UTF16BE = new Uint8Array([
    254,
    255
]);
const $be59461d4a783f7b$var$compareByteArrays = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
};
const $be59461d4a783f7b$export$cbdefd6464a7f9df = (_0)=>$be59461d4a783f7b$var$__async(void 0, [
        _0
    ], function*({ outputType: outputType, data: data, patches: patches, keepOriginalStyles: keepOriginalStyles, placeholderDelimiters: placeholderDelimiters = {
        start: "{{",
        end: "}}"
    }, recursive: /**
   * Search for occurrences over patched document
   */ recursive = true }) {
        var _a, _b, _c;
        const zipContent = data instanceof $be59461d4a783f7b$var$JSZip ? data : yield $be59461d4a783f7b$var$JSZip.loadAsync(data);
        const contexts = /* @__PURE__ */ new Map();
        const file = {
            Media: new $be59461d4a783f7b$export$7fc53215244aec38()
        };
        const map = /* @__PURE__ */ new Map();
        const imageRelationshipAdditions = [];
        const hyperlinkRelationshipAdditions = [];
        let hasMedia = false;
        const binaryContentMap = /* @__PURE__ */ new Map();
        for (const [key, value] of Object.entries(zipContent.files)){
            const binaryValue = yield value.async("uint8array");
            const startBytes = binaryValue.slice(0, 2);
            if ($be59461d4a783f7b$var$compareByteArrays(startBytes, $be59461d4a783f7b$var$UTF16LE) || $be59461d4a783f7b$var$compareByteArrays(startBytes, $be59461d4a783f7b$var$UTF16BE)) {
                binaryContentMap.set(key, binaryValue);
                continue;
            }
            if (!key.endsWith(".xml") && !key.endsWith(".rels")) {
                binaryContentMap.set(key, binaryValue);
                continue;
            }
            const json = $be59461d4a783f7b$var$toJson((yield value.async("text")));
            if (key === "word/document.xml") {
                const document2 = (_a = json.elements) == null ? void 0 : _a.find((i)=>i.name === "w:document");
                if (document2 && document2.attributes) {
                    for (const ns of [
                        "mc",
                        "wp",
                        "r",
                        "w15",
                        "m"
                    ])document2.attributes[`xmlns:${ns}`] = $be59461d4a783f7b$export$7379524039920247[ns];
                    document2.attributes["mc:Ignorable"] = `${document2.attributes["mc:Ignorable"] || ""} w15`.trim();
                }
            }
            if (key.startsWith("word/") && !key.endsWith(".xml.rels")) {
                const context = {
                    file: file,
                    viewWrapper: {
                        Relationships: {
                            createRelationship: (linkId, _, target, __)=>{
                                hyperlinkRelationshipAdditions.push({
                                    key: key,
                                    hyperlink: {
                                        id: linkId,
                                        link: target
                                    }
                                });
                            }
                        }
                    },
                    stack: []
                };
                contexts.set(key, context);
                if (!(placeholderDelimiters == null ? void 0 : placeholderDelimiters.start.trim()) || !(placeholderDelimiters == null ? void 0 : placeholderDelimiters.end.trim())) throw new Error("Both start and end delimiters must be non-empty strings.");
                const { start: start, end: end } = placeholderDelimiters;
                for (const [patchKey, patchValue] of Object.entries(patches)){
                    const patchText = `${start}${patchKey}${end}`;
                    while(true){
                        const { didFindOccurrence: didFindOccurrence } = $be59461d4a783f7b$var$replacer({
                            json: json,
                            patch: $be59461d4a783f7b$var$__spreadProps($be59461d4a783f7b$var$__spreadValues({}, patchValue), {
                                children: patchValue.children.map((element)=>{
                                    if (element instanceof $be59461d4a783f7b$export$6ea6a3f0b2b263f3) {
                                        const concreteHyperlink = new $be59461d4a783f7b$export$6beda279b4a51476(element.options.children, $be59461d4a783f7b$export$8b15d37bc3f197d4());
                                        hyperlinkRelationshipAdditions.push({
                                            key: key,
                                            hyperlink: {
                                                id: concreteHyperlink.linkId,
                                                link: element.options.link
                                            }
                                        });
                                        return concreteHyperlink;
                                    } else return element;
                                })
                            }),
                            patchText: patchText,
                            context: context,
                            keepOriginalStyles: keepOriginalStyles
                        });
                        if (!recursive || !didFindOccurrence) break;
                    }
                }
                const mediaDatas = $be59461d4a783f7b$var$imageReplacer.getMediaData(JSON.stringify(json), context.file.Media);
                if (mediaDatas.length > 0) {
                    hasMedia = true;
                    imageRelationshipAdditions.push({
                        key: key,
                        mediaDatas: mediaDatas
                    });
                }
            }
            map.set(key, json);
        }
        for (const { key: key, mediaDatas: mediaDatas } of imageRelationshipAdditions){
            const relationshipKey = `word/_rels/${key.split("/").pop()}.rels`;
            const relationshipsJson = (_b = map.get(relationshipKey)) != null ? _b : $be59461d4a783f7b$var$createRelationshipFile();
            map.set(relationshipKey, relationshipsJson);
            const index = $be59461d4a783f7b$var$getNextRelationshipIndex(relationshipsJson);
            const newJson = $be59461d4a783f7b$var$imageReplacer.replace(JSON.stringify(map.get(key)), mediaDatas, index);
            map.set(key, JSON.parse(newJson));
            for(let i = 0; i < mediaDatas.length; i++){
                const { fileName: fileName } = mediaDatas[i];
                $be59461d4a783f7b$var$appendRelationship(relationshipsJson, index + i, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${fileName}`);
            }
        }
        for (const { key: key, hyperlink: hyperlink } of hyperlinkRelationshipAdditions){
            const relationshipKey = `word/_rels/${key.split("/").pop()}.rels`;
            const relationshipsJson = (_c = map.get(relationshipKey)) != null ? _c : $be59461d4a783f7b$var$createRelationshipFile();
            map.set(relationshipKey, relationshipsJson);
            $be59461d4a783f7b$var$appendRelationship(relationshipsJson, hyperlink.id, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", hyperlink.link, $be59461d4a783f7b$var$TargetModeType.EXTERNAL);
        }
        if (hasMedia) {
            const contentTypesJson = map.get("[Content_Types].xml");
            if (!contentTypesJson) throw new Error("Could not find content types file");
            $be59461d4a783f7b$var$appendContentType(contentTypesJson, "image/png", "png");
            $be59461d4a783f7b$var$appendContentType(contentTypesJson, "image/jpeg", "jpeg");
            $be59461d4a783f7b$var$appendContentType(contentTypesJson, "image/jpeg", "jpg");
            $be59461d4a783f7b$var$appendContentType(contentTypesJson, "image/bmp", "bmp");
            $be59461d4a783f7b$var$appendContentType(contentTypesJson, "image/gif", "gif");
            $be59461d4a783f7b$var$appendContentType(contentTypesJson, "image/svg+xml", "svg");
        }
        const zip = new $be59461d4a783f7b$var$JSZip();
        for (const [key, value] of map){
            const output = $be59461d4a783f7b$var$toXml(value);
            zip.file(key, output);
        }
        for (const [key, value] of binaryContentMap)zip.file(key, value);
        for (const { data: stream, fileName: fileName } of file.Media.Array)zip.file(`word/media/${fileName}`, stream);
        return zip.generateAsync({
            type: outputType,
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            compression: "DEFLATE"
        });
    });
const $be59461d4a783f7b$var$toXml = (jsonObj)=>{
    const output = $be59461d4a783f7b$var$libExports.js2xml(jsonObj, {
        attributeValueFn: (str)=>String(str).replace(/&(?!amp;|lt;|gt;|quot;|apos;)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;")
    });
    return output;
};
const $be59461d4a783f7b$var$createRelationshipFile = ()=>({
        declaration: {
            attributes: {
                version: "1.0",
                encoding: "UTF-8",
                standalone: "yes"
            }
        },
        elements: [
            {
                type: "element",
                name: "Relationships",
                attributes: {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                },
                elements: []
            }
        ]
    });
const $be59461d4a783f7b$export$806000e3d5887873 = (_0)=>$be59461d4a783f7b$var$__async(void 0, [
        _0
    ], function*({ data: data }) {
        const zipContent = data instanceof $be59461d4a783f7b$var$JSZip ? data : yield $be59461d4a783f7b$var$JSZip.loadAsync(data);
        const patches = /* @__PURE__ */ new Set();
        for (const [key, value] of Object.entries(zipContent.files)){
            if (!key.endsWith(".xml") && !key.endsWith(".rels")) continue;
            if (key.startsWith("word/") && !key.endsWith(".xml.rels")) {
                const json = $be59461d4a783f7b$var$toJson((yield value.async("text")));
                $be59461d4a783f7b$var$traverse(json).forEach((p)=>$be59461d4a783f7b$var$findPatchKeys(p.text).forEach((patch)=>patches.add(patch)));
            }
        }
        return Array.from(patches);
    });
const $be59461d4a783f7b$var$findPatchKeys = (text)=>{
    var _a;
    const pattern = new RegExp("(?<=\\{\\{).+?(?=\\}\\})", "gs");
    return (_a = text.match(pattern)) != null ? _a : [];
};


const $62f43bdea23689ae$export$6c01c7443ca2e3eb = async (superTitle, title, label)=>{
    const paragraphs = [];
    const convertChantToImages = async (liturgyItem)=>{
        const svgs = [];
        liturgyItem?.querySelectorAll("svg").forEach((svg)=>svgs.push(svg));
        for (const svg of svgs){
            const loadImage = async (url)=>{
                const img = document.createElement("img");
                img.src = url;
                return new Promise((resolve, reject)=>{
                    img.onload = ()=>resolve(img);
                    img.onerror = reject;
                });
            };
            const dataHeader = "data:image/svg+xml;charset=utf-8";
            const encodeAsUTF8 = (s)=>`${dataHeader},${encodeURIComponent(s)}`;
            const serializeAsXML = (e)=>new XMLSerializer().serializeToString(e);
            const svgData = encodeAsUTF8(serializeAsXML(svg));
            const img = await loadImage(svgData);
            const canvas = document.createElement("canvas");
            canvas.width = svg.clientWidth * 4;
            canvas.height = svg.clientHeight * 4;
            canvas.getContext("2d")?.drawImage(img, 0, 0, svg.clientWidth * 4, svg.clientHeight * 4);
            const dataUrl = canvas.toDataURL(`image/png`, 1.0);
            var data = (0, $6ZWSX.Buffer).from(dataUrl.split(",")[1], "base64");
            paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                children: [
                    new $be59461d4a783f7b$export$748e1095269a17e0({
                        type: "png",
                        data: data,
                        transformation: {
                            width: 448,
                            height: 448 * (svg.clientHeight / svg.clientWidth)
                        }
                    })
                ]
            }));
        }
    };
    const liturgyItems = [];
    paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
        children: [
            new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                text: superTitle,
                font: "Palatino Linotype",
                bold: true,
                size: 22
            })
        ],
        alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.CENTER
    }), new $be59461d4a783f7b$export$358a232cca1ab2ac({
        children: [
            new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                text: title,
                font: "Palatino Linotype",
                bold: true,
                size: 28
            })
        ],
        alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.CENTER
    }), new $be59461d4a783f7b$export$358a232cca1ab2ac({
        children: [
            new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                text: "",
                font: "Palatino Linotype",
                bold: true,
                size: 5
            })
        ]
    }));
    document.querySelectorAll(".liturgy-item").forEach((liturgyItem)=>{
        liturgyItems.push(liturgyItem);
    });
    for (const liturgyItem of liturgyItems){
        let foundAnything = false;
        // Extract rubrics
        liturgyItem.querySelectorAll(".rubric").forEach((rubricItem)=>{
            foundAnything = true;
            const rubricMarkdown = rubricItem.getAttribute("data-content") ?? "";
            let isBold = true;
            paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                alignment: $be59461d4a783f7b$export$97e681628fc5cdf4.CENTER,
                children: rubricMarkdown.replace(/_/g, " ").split("**").map((boldPart)=>{
                    isBold = !isBold;
                    return new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                        text: boldPart,
                        font: "Palatino Linotype",
                        bold: isBold,
                        color: "db281b",
                        size: 20
                    });
                })
            }));
        });
        // Extract svgs
        const svgChants = [];
        liturgyItem.querySelectorAll("div:not(.tone-diagram) > .svg-chant").forEach((svgChant)=>{
            svgChants.push(svgChant);
        });
        // Extract titles
        const titleElements = [];
        liturgyItem.querySelectorAll(".title").forEach((titleElement)=>{
            titleElements.push(titleElement);
        });
        for (const item of titleElements){
            foundAnything = true;
            const title = item.getAttribute("data-content") ?? "";
            paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                children: [
                    new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                        text: title,
                        font: "Palatino Linotype",
                        bold: true,
                        size: 22
                    })
                ]
            }));
            // If there are SVG chants, pop at least one per title, in order to hack supporting the multipart chants
            if (svgChants) {
                console.log("Number of SVG chants", svgChants.length);
                const current = svgChants.shift();
                await convertChantToImages(current);
            }
        }
        // Extract text blocks
        liturgyItem.querySelectorAll(".text-block").forEach((rubricItem)=>{
            foundAnything = true;
            const markdown = rubricItem.getAttribute("data-content") ?? "";
            const parts = markdown.replace(/ +/g, " ").split("**");
            if (parts[0].length <= 2) {
                parts[1] = parts[0] + parts[1];
                parts[0] = "";
            }
            let isBold = true;
            paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                children: parts.map((boldPart)=>{
                    isBold = !isBold;
                    return new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                        text: boldPart,
                        font: "Palatino Linotype",
                        bold: isBold,
                        size: 20
                    });
                })
            }));
        });
        // Extract legacy text blocks
        liturgyItem.querySelectorAll(".legacy-text-block").forEach((item)=>{
            if (foundAnything) // Hack that adds spacing after Here beginneth
            paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                children: [
                    new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                        text: " ",
                        font: "Palatino Linotype",
                        size: 10
                    })
                ]
            }));
            foundAnything = true;
            item.querySelectorAll(".markdown-text-line").forEach((line)=>{
                const markdown = line.getAttribute("data-content") ?? "";
                const indent = parseInt(line.getAttribute("data-indent") ?? "0");
                let tabs = "";
                if (indent !== 10) for(let i = 0; i < indent; i++)tabs += "\t";
                let isBold = true;
                paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                    alignment: indent === 10 ? $be59461d4a783f7b$export$97e681628fc5cdf4.RIGHT : $be59461d4a783f7b$export$97e681628fc5cdf4.JUSTIFIED,
                    children: [
                        new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                            text: tabs
                        })
                    ].concat(markdown.replace(/ +/g, " ").split("**").map((boldPart)=>{
                        isBold = !isBold;
                        return new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                            text: boldPart,
                            font: "Palatino Linotype",
                            bold: isBold,
                            size: 20
                        });
                    })),
                    tabStops: [
                        {
                            type: $be59461d4a783f7b$export$2effbc422db8f8ed.LEFT,
                            position: 300
                        },
                        {
                            type: $be59461d4a783f7b$export$2effbc422db8f8ed.LEFT,
                            position: 600
                        },
                        {
                            type: $be59461d4a783f7b$export$2effbc422db8f8ed.LEFT,
                            position: 900
                        }
                    ]
                }));
            });
        });
        // Extract small spacers
        liturgyItem.querySelectorAll(".spacer").forEach((item)=>{
            foundAnything = true;
            paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                children: [
                    new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                        text: " ",
                        font: "Palatino Linotype",
                        size: 20
                    })
                ]
            }));
        });
        // Extract big spacers
        liturgyItem.querySelectorAll(".big-spacer").forEach((item)=>{
            foundAnything = true;
            paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                children: [
                    new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                        text: " ",
                        font: "Palatino Linotype",
                        size: 20
                    })
                ]
            }));
            paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
                children: [
                    new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                        text: " ",
                        font: "Palatino Linotype",
                        size: 20
                    })
                ]
            }));
        });
        // Process remaining chants
        for (const svgChant of svgChants)await convertChantToImages(svgChant);
        // Add blank line for spacing
        if (foundAnything) paragraphs.push(new $be59461d4a783f7b$export$358a232cca1ab2ac({
            children: [
                new $be59461d4a783f7b$export$84d920a4f7ee9ae2({
                    text: " ",
                    font: "Palatino Linotype",
                    size: 10
                })
            ]
        }));
    }
    const doc = new $be59461d4a783f7b$export$b34a105447964f9f({
        sections: [
            {
                properties: {
                    page: {
                        margin: {
                            top: 852,
                            bottom: 852,
                            left: 852,
                            right: 852
                        },
                        size: {
                            height: 11930,
                            width: 8410
                        }
                    }
                },
                children: paragraphs
            }
        ]
    });
    const blob = await $be59461d4a783f7b$export$b9ec4b114aa40074.toBlob(doc);
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${label ?? "liturgy"}.docx`;
    link.click();
};


const $8e8eee601cb369fe$export$47dc637b8554585f = (props)=>{
    const { items: items, label: label, superTitle: superTitle, title: title, forceRender: forceRender } = props;
    const [modals, setModals] = (0, $acw62.useState)({});
    const addModal = (id, modal)=>{
        modals[id] = modal;
        setModals(modals);
    };
    const [loadingBookletState, setLoadingBookletState] = (0, $acw62.useState)("initial");
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    const topElement = (0, $acw62.useRef)(null);
    const bottomElement = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: topElement
            }),
            items.map((item)=>{
                switch(item.type){
                    case "heading":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55a5c2e1bacb63c1$export$a8a3e93435678ff9), {
                            day: item.day,
                            hour: item.hour
                        });
                    case "rubric":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                            content: item.content,
                            settingsPanelId: item.settingsPanelId
                        });
                    case "subheading":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cc292920dd8fd1f$export$5404b1d39162d870), {
                            content: item.content
                        });
                    case "text":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                            content: item.content,
                            dropCap: item.dropCap
                        });
                    case "spacer":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {
                            big: item.big
                        });
                    case "chant":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                            boldMode: item.boldMode,
                            pointedText: item.pointedText,
                            rubric: item.rubric,
                            dropCap: false,
                            tone: item.tone
                        });
                    case "tone chant":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2d213bd4c46a128$export$1246c4e68efb74f5), {
                                    id: item.title.replace(/ /g, "-").toLocaleLowerCase(),
                                    title: item.title,
                                    player: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d785bb9b161f2130$export$397fd5de0a6e6acd), {
                                        tones: [
                                            item.tone
                                        ],
                                        selectedTone: item.tone,
                                        id: item.title.replace(/ /g, "-").toLocaleLowerCase(),
                                        onSetModal: addModal
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                                    boldMode: item.boldMode,
                                    pointedText: item.pointedText,
                                    rubric: item.rubric,
                                    dropCap: true,
                                    tone: item.tone
                                })
                            ]
                        });
                    case "gabc chant":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2d213bd4c46a128$export$1246c4e68efb74f5), {
                                    id: item.title.replace(/ /g, "-").toLocaleLowerCase(),
                                    title: item.title,
                                    player: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: 4
                                        },
                                        children: item.playButtons.map((pb)=>{
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $074faffa041224b7$export$7b9f512f3db4233b), {
                                                gabc: pb.gabc,
                                                title: pb.title,
                                                onlyIntone: pb.intoneOnly,
                                                tone: item.tone,
                                                tweak: 0
                                            });
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                                    onlySides: true,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04cfb5a990424bdb$export$a512b99ae1e55604), {
                                        gabc: item.gabc,
                                        dropCap: item.dropCap,
                                        tone: item.tone
                                    })
                                })
                            ]
                        });
                    case "minimal gabc chant":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                            onlySides: true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04cfb5a990424bdb$export$a512b99ae1e55604), {
                                gabc: item.gabc,
                                dropCap: item.dropCap,
                                tone: item.tone
                            })
                        });
                    case "canticle":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2de76dc2a5b96b1f$export$4d2dd46eb8f9c829), {
                            id: item.id,
                            day: item.day,
                            tone: item.tone
                        });
                    case "office hymn":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $427fec415011985b$export$389138f633999d3), {
                            day: item.day,
                            hour: item.hour
                        });
                    case "new hymn":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2d213bd4c46a128$export$1246c4e68efb74f5), {
                                    id: item.hymn.title.replace(/ /g, "-").toLocaleLowerCase(),
                                    title: item.hymn.title,
                                    player: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $074faffa041224b7$export$7b9f512f3db4233b), {
                                                gabc: (0, $800a243c436a5a55$export$822ec9e4f0223433)(item.hymn.tune, item.hymn.text.split("\n\n")[0]),
                                                title: "Intone",
                                                onlyIntone: true,
                                                tone: "1",
                                                tweak: (0, $800a243c436a5a55$export$11a6a3eba8387011)(item.hymn.tune)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $074faffa041224b7$export$7b9f512f3db4233b), {
                                                gabc: (0, $800a243c436a5a55$export$822ec9e4f0223433)(item.hymn.tune, item.hymn.text.split("\n\n")[0]),
                                                title: "Play verse",
                                                tone: "1",
                                                tweak: (0, $800a243c436a5a55$export$11a6a3eba8387011)(item.hymn.tune)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                                    onlySides: true,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800a243c436a5a55$export$f3e61a719d75a165), {
                                        hymn: item.hymn
                                    })
                                })
                            ]
                        });
                    case "loading":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e6ae22ad468d2c6$export$e2b0760399e6dece), {});
                    case "psalm":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                            psalmRef: item.psalmRef
                        });
                    case "ord psalm":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77125283e747f314$export$bebb639124f81280), {
                            title: item.title,
                            sections: item.sections,
                            psalmNumber: item.psalmNumber
                        });
                    case "scripture":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fb31402637fa4d9$export$aaa271f2756a673f), {
                            title: item.title,
                            content: item.content,
                            hasBeginneth: item.hasBeginneth
                        });
                    case "litany rubric":
                        return item.day.label === "ash-wednesday" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $56b95cfdb7e54a07$export$35e63fe56e1d2b2a), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "ASH WEDNESDAY"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "It is appropriate to conclude with",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            style: {
                                                textDecoration: "underline"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                                to: "/pray/litany",
                                                children: "The\xa0Litany"
                                            })
                                        }),
                                        " ",
                                        "and",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            style: {
                                                textDecoration: "underline"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                                to: "/pray/commination",
                                                children: "The\xa0Commination"
                                            })
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {})
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $56b95cfdb7e54a07$export$35e63fe56e1d2b2a), {
                            children: [
                                "On Sundays, Wednesdays, and Fridays, it is appropriate to conclude Mattins with",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    style: {
                                        textDecoration: "underline"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                        to: "/pray/litany",
                                        children: "The\xa0Litany"
                                    })
                                }),
                                "."
                            ]
                        });
                    case "footer":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $130eca1cdc8dd34c$export$a06f1c675e846f6f), {
                            day: item.day,
                            hour: item.hour
                        });
                    case "picker":
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    backgroundColor: (0, $b5d1360628cd70a0$export$f688c137b5ee517a),
                                    display: "flex",
                                    flexDirection: "row",
                                    padding: 2,
                                    borderRadius: 4
                                },
                                children: item.options.map((option)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            padding: 4,
                                            paddingLeft: isSmallScreen ? 6 : 12,
                                            paddingRight: isSmallScreen ? 6 : 12,
                                            backgroundColor: item.selectedOption === option ? "white" : "transparent",
                                            borderRadius: 2,
                                            fontSize: "90%",
                                            fontWeight: "bold",
                                            color: "black",
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>{
                                            item.onChange(option);
                                        },
                                        children: option
                                    });
                                })
                            })
                        });
                }
            }).map((element, index)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "liturgy-item",
                    children: element
                }, `${index} - ${JSON.stringify(items[index])}`);
            }),
            Object.values(modals),
            superTitle && title && label ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    pointerEvents: loadingBookletState === "initial" ? "all" : "none",
                    opacity: loadingBookletState === "initial" ? 1 : 0.75
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    onClick: async ()=>{
                        if (loadingBookletState === "initial") {
                            setLoadingBookletState("loading");
                            console.log("Beginning");
                            const scrollArea = document.getElementsByClassName("app-scroll-area")[0];
                            if (!scrollArea) return;
                            let prevScrollTop = -100;
                            topElement.current.scrollIntoView();
                            const scrollThenGetBooklet = async ()=>{
                                if (scrollArea.scrollTop === prevScrollTop) {
                                    await (0, $62f43bdea23689ae$export$6c01c7443ca2e3eb)(superTitle, title, label);
                                    setLoadingBookletState("loaded");
                                } else {
                                    prevScrollTop = scrollArea.scrollTop;
                                    scrollArea.scrollTo({
                                        top: scrollArea.scrollTop + 100
                                    });
                                    setTimeout(()=>{
                                        scrollThenGetBooklet();
                                    }, 50);
                                }
                            };
                            scrollThenGetBooklet();
                        }
                    },
                    className: "new-button",
                    children: loadingBookletState === "loading" ? "Loading..." : loadingBookletState === "loaded" ? "Downloaded booklet" : "Download booklet"
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: bottomElement,
                style: {
                    paddingBottom: 32
                }
            })
        ]
    });
};




const $b7ff05a6482e42aa$export$15afb09fa9c9ed = ()=>{
    const year = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(new Date().getFullYear(), false, false, false);
    const today = year.find((day)=>day.date === new Date().getDate() && day.month === new Date().getMonth() + 1 && day.year === new Date().getFullYear());
    if (!today) throw new Error("Could not find today");
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const liturgy = [
        {
            type: "rubric",
            content: "The Litany may be said or sung, kneeling, standing, or in procession, according to the occasion or circumstance. It may be used at the accustomed times. The Litany may also be said separately; especially in Advent and Lent, and on Rogation Days."
        },
        {
            type: "rubric",
            content: "The Priest or Deacon (or cantor, if necessary) sings the Litany, with the People or Choir responding:"
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) O(h) God(h) the(h) Fa(h)ther,(h) Cre(h)a(h)tor(h) of(h) hea(h)ven(h) and(h) earth,(i) (::) *Have*(g) *mer*(g)*cy*(f) *u*(g)*pon*(h) *us.*(h) (::)",
            dropCap: true,
            tone: ""
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) O(h) God(h) the(h) Son,(h) Re(h)dee(h)mer(h) of(h) the(h) world,(i) (::) *Have*(g) *mer*(g)*cy*(f) *u*(g)*pon*(h) *us.*(h) (::)",
            dropCap: true,
            tone: ""
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) O(h) God(h) the(h) Ho(h)ly(h) Ghost,(h) Sanc(h)ti(h)fi(h)er(h) of(h) the(h) faith(i)ful,(g) (::) *Have*(g) *mer*(g)*cy*(f) *u*(g)*pon*(h) *us.*(h) (::)",
            dropCap: true,
            tone: ""
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) O(h) ho(h)ly,(h) bless(h)ed,(h) and(h) glo(h)rious(h) Tri(h)ni(h)ty,(h) three(h) Per(h)sons(h) and(h) one(h) God,(i) (::) *Have*(g) *mer*(g)*cy*(f) *u*(g)*pon*(h) *us.*(h) (::)",
            dropCap: true,
            tone: ""
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) Saint(h) Ma(h)ry,(h) Mo(h)ther(h) of(h) God(h) our(h) Lord(h) Je(h)sus(h) Christ,(i) (::) *Pray*(gf) *for*(g) *us.*(h) (::)",
            dropCap: true,
            tone: ""
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) All(h) ho(h)ly(h) An(h)gels(h) and(h) Arch(h)an(h)gels,(h) and(h) all(h) ho(h)ly(h) Or(h)ders(h) of(h) bless(h)ed(h) Spi(i)rits,(g) (::) *Pray*(gf) *for*(g) *us.*(h) (::)",
            dropCap: true,
            tone: ""
        },
        {
            type: "minimal gabc chant",
            gabc: "(c3) All(h) ho(h)ly(h) Pa(h)tri(h)archs(h) and(h) Pro(h)phets;(h) A(h)po(h)stles,(h) Mar(h)tyrs,(h) Con(h)fes(h)sors(h) and(h) Vir(h)gins;(h) and(h) the(h) bless(h)ed(h) Com(h)pa(h)ny(h) of(h) Hea(i)ven,(g) (::) *Pray*(gf) *for*(g) *us.*(h) (::)",
            dropCap: true,
            tone: ""
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
        initialState: {},
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    textAlign: "center",
                    padding: 24,
                    paddingTop: 64
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontSize: "150%",
                        fontWeight: "bold",
                        lineHeight: 1.2
                    },
                    children: "The Litany"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e8eee601cb369fe$export$47dc637b8554585f), {
                items: liturgy,
                label: "litany",
                superTitle: "",
                title: "The Litany"
            })
        ]
    });
};



parcelRequire("acw62");


const $19a968ddb8323925$var$Row = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            gap: 8,
            paddingLeft: 16
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    minWidth: 80,
                    fontWeight: "bold"
                },
                children: props.label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: "85%"
                },
                children: props.children === "MISSING" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        backgroundColor: "#F99"
                    },
                    children: "MISSING"
                }) : props.children
            })
        ]
    });
};
const $19a968ddb8323925$export$fd8619584ead7518 = ()=>{
    const isEpiphanyTransferred = false;
    const isAscensionTransferred = false;
    const isCorpusChristiTransferred = false;
    const regionLabels = localStorage.getItem("region-switches")?.split(";;;") ?? [];
    const year = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(new Date().getFullYear(), isEpiphanyTransferred, isAscensionTransferred, isCorpusChristiTransferred, regionLabels).slice(365);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: year.map((liturgicalDay, dayIndex)=>{
            const prevLiturgicalDay = year[dayIndex - 1];
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    liturgicalDay.date === 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontSize: "180%",
                            fontWeight: "bold",
                            padding: 12,
                            borderBottom: "1px solid silver",
                            textAlign: "center"
                        },
                        children: [
                            [
                                "",
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ][liturgicalDay.month],
                            " ",
                            liturgicalDay.year
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            borderBottom: "1px solid silver"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    width: 48,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    flexShrink: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            textTransform: "uppercase",
                                            fontSize: "80%",
                                            fontWeight: "bold",
                                            paddingTop: 8
                                        },
                                        children: liturgicalDay.day.slice(0, 3)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: "200%",
                                            lineHeight: 0.8,
                                            paddingBottom: 12
                                        },
                                        children: liturgicalDay.date
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    flexGrow: 1,
                                    padding: 8,
                                    paddingLeft: 12,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 16,
                                    paddingBottom: 16
                                },
                                children: liturgicalDay.morningOptions.map((option)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    fontSize: "110%"
                                                },
                                                children: [
                                                    option.regionNote ? option.regionNote + ": " : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            fontWeight: "bold"
                                                        },
                                                        children: option.rank <= 8 ? option.title.toLocaleUpperCase() : option.title
                                                    }),
                                                    " ",
                                                    "(",
                                                    option.optional ? "optional " : "",
                                                    option.type,
                                                    ")",
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: `/se/${prevLiturgicalDay?.year}/${prevLiturgicalDay?.month}/${prevLiturgicalDay?.date}/${option.label}/first-evensong`,
                                                        target: "_blank",
                                                        children: "EP1"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: `/se/${liturgicalDay.year}/${liturgicalDay.month}/${liturgicalDay.date}/${option.label}/mattins`,
                                                        target: "_blank",
                                                        children: "MP"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: `/se/${liturgicalDay.year}/${liturgicalDay.month}/${liturgicalDay.date}/${option.label}/second-evensong`,
                                                        target: "_blank",
                                                        children: "EP2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                label: "Collect",
                                                children: option.collect ?? "MISSING"
                                            }),
                                            option.commons ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                label: "Common",
                                                children: option.commons.map((common)=>(0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[common] ? common : "MISSING").join(" OR ")
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    option.type === "solemnity" || option.type === "sunday" || option.type === "feast" && option.feastHasFirstEvensong ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                                label: "EP1 Hymn",
                                                                children: option.ep1HymnId ?? "MISSING"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                                label: "EP1 V&R",
                                                                children: option.ep1VandR?.map((v)=>v.replace(/_/g, "")).join(" ") ?? "MISSING"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                                label: "EP1 Mag",
                                                                children: option.ep1MagId ?? "MISSING"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                        label: "Inv",
                                                        children: option.invId ?? "MISSING"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                        label: "MP Hymn",
                                                        children: option.mpHymnId ?? "MISSING"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                        label: "MP V&R",
                                                        children: option.mpVandR?.map((v)=>v.replace(/_/g, "")).join(" ") ?? "MISSING"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                        label: "Ben",
                                                        children: option.mpBenId ?? "MISSING"
                                                    }),
                                                    liturgicalDay.day === "sat" && (option.type === "feria" || option.type === "memorial") || liturgicalDay.date === 24 && liturgicalDay.month === 12 || liturgicalDay.morningOptions.find((opt)=>opt.title === "Rogation Wednesday") !== undefined || liturgicalDay.morningOptions.find((opt)=>opt.title === "Ember Saturday in Whitsun Week") !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                                label: "EP2 Hymn",
                                                                children: option.ep2HymnId ?? "MISSING"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                                label: "EP2 V&R",
                                                                children: option.ep2VandR?.map((v)=>v.replace(/_/g, "")).join(" ") ?? "MISSING"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19a968ddb8323925$var$Row, {
                                                                label: "EP2 Mag",
                                                                children: option.ep2MagId ?? "MISSING"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    })
                ]
            });
        })
    });
};



parcelRequire("acw62");

const $2ee31c3adb86234b$var$Row = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            gap: 8,
            paddingLeft: 16
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    minWidth: 80,
                    fontWeight: "bold"
                },
                children: props.label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: "85%"
                },
                children: props.children === "MISSING" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        backgroundColor: "#F99"
                    },
                    children: "MISSING"
                }) : props.children
            })
        ]
    });
};
const $2ee31c3adb86234b$export$20d973631fe67e1b = ()=>{
    const isEpiphanyTransferred = true;
    const isAscensionTransferred = false;
    const isCorpusChristiTransferred = true;
    const regionLabels = localStorage.getItem("region-switches")?.split(";;;") ?? [];
    const year = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(new Date().getFullYear(), isEpiphanyTransferred, isAscensionTransferred, isCorpusChristiTransferred, regionLabels).slice(365);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: year.map((liturgicalDay, dayIndex)=>{
            const prevLiturgicalDay = year[dayIndex - 1];
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        borderBottom: "1px solid silver"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                width: 60,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                flexShrink: 0
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontWeight: "bold",
                                    paddingTop: 8
                                },
                                children: [
                                    [
                                        "",
                                        "January",
                                        "February",
                                        "March",
                                        "April",
                                        "May",
                                        "June",
                                        "July",
                                        "August",
                                        "September",
                                        "October",
                                        "November",
                                        "December"
                                    ][liturgicalDay.month].slice(0, 3),
                                    " ",
                                    liturgicalDay.date
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                flexGrow: 1,
                                padding: 8,
                                display: "flex",
                                flexDirection: "column",
                                gap: 8
                            },
                            children: liturgicalDay.morningOptions.map((option)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        fontSize: "110%"
                                    },
                                    children: [
                                        option.regionNote ? option.regionNote + ": " : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                fontWeight: option.rank <= 8 ? "bold" : undefined,
                                                fontStyle: option.optional ? "italic" : undefined
                                            },
                                            children: option.rank <= 8 ? option.title.toLocaleUpperCase() : option.title
                                        }),
                                        " ",
                                        "(",
                                        option.optional ? "optional " : "",
                                        option.type,
                                        ")"
                                    ]
                                });
                            })
                        })
                    ]
                })
            });
        })
    });
};



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");






const $6e6f90ac2fa37e65$var$useOptionalInterval = (callback, period, enabled)=>{
    const enabledCallback = enabled ? callback : undefined;
    const intervalRef = (0, $acw62.useRef)(undefined);
    const savedCallback = (0, $acw62.useRef)(enabledCallback);
    (0, $acw62.useEffect)(()=>{
        savedCallback.current = enabledCallback;
    }, [
        enabledCallback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (enabled) {
            const tick = ()=>{
                if (savedCallback.current) savedCallback.current();
            };
            const intervalId = setInterval(tick, period);
            intervalRef.current = intervalId;
            return ()=>{
                clearInterval(intervalRef.current);
            };
        }
    }, [
        period,
        enabled
    ]);
    return intervalRef;
};
const $6e6f90ac2fa37e65$export$3c1f05d40f815626 = (neumes, index)=>{
    try {
        const neume = neumes[index[0]];
        let notesInNeume = 0;
        neume.elements.forEach((element)=>{
            notesInNeume += element.notes.length;
        });
        if (index[1] === notesInNeume - 1) {
            let newNeume = index[0] + 1;
            while(newNeume < neumes.length && neumes[newNeume].elements[0].notes.length === 0)newNeume += 1;
            if (newNeume === neumes.length) return undefined;
            else return [
                newNeume,
                0
            ];
        } else return [
            index[0],
            index[1] + 1
        ];
    } catch  {
        return undefined;
    }
};
const $6e6f90ac2fa37e65$export$aa2a939d159a1a02 = (neumes, index, baseDuration)=>{
    let pause = 0;
    const nextIndex = $6e6f90ac2fa37e65$export$3c1f05d40f815626(neumes, index);
    if (!nextIndex || nextIndex[1] !== 0) return 0;
    let newNeume = index[0] + 1;
    while(newNeume < neumes.length && neumes[newNeume].elements[0].notes.length === 0){
        console.log(neumes[newNeume]);
        if (neumes[newNeume].elements[0].type === "half bar") pause += baseDuration;
        if (neumes[newNeume].elements[0].type === "full bar") pause += baseDuration * 2;
        newNeume += 1;
    }
    return pause;
};
const $6e6f90ac2fa37e65$export$812e962987ae4379 = (neumes, index, baseDuration, tone, transposeBy)=>{
    const neume = neumes[index[0]];
    let noteCount = 0;
    let soundfontNote = undefined;
    for (const element of neume.elements)for (const note of element.notes){
        if (noteCount === index[1]) {
            const pitch = note.pitch;
            let label = (0, $02b52bdf6f82c33e$export$a77e5d8acb4fcf5d)[pitch];
            let duration = baseDuration;
            if (note.isNoteFlat) label = label.slice(0, 1) + "b" + label.slice(1, 2);
            label = (0, $02b52bdf6f82c33e$export$94966884eea635c4)(label, (0, $02b52bdf6f82c33e$export$17267529e6476353)(tone.slice(0, 1)) + transposeBy);
            if (note.hasMora) duration *= 2;
            soundfontNote = {
                label: label,
                duration: duration
            };
        } else if (noteCount === index[1] + 1 && note.isQuilisma && soundfontNote) soundfontNote.duration *= 1.25;
        noteCount += 1;
    }
    return soundfontNote;
};
const $6e6f90ac2fa37e65$var$NOTE_LENGTH = 500;
const $6e6f90ac2fa37e65$export$48122e7c0cf093bd = (props)=>{
    const { gabc: gabc, tone: tone } = props;
    const { neumes: neumes } = (0, $70c95f146be4c1d3$export$57f278225405371b)(gabc, false);
    const audioContextRef = (0, $acw62.useRef)(new AudioContext());
    const getCurrentTime = ()=>{
        return audioContextRef.current.currentTime;
    };
    const playNoteRef = (0, $acw62.useRef)(undefined);
    const [instrumentState, setInstrumentState] = (0, $acw62.useState)("initial");
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const transposeByKey = "1";
    const transposeBy = settings.transpositions["1"] + (0, $02b52bdf6f82c33e$export$17267529e6476353)(transposeByKey);
    const loadAndPlay = (0, $acw62.useCallback)((playerState)=>{
        if (instrumentState === "initial") {
            setInstrumentState("loading");
            // create empty buffer
            var buffer = audioContextRef.current.createBuffer(1, 1, 22050);
            var source = audioContextRef.current.createBufferSource();
            source.buffer = buffer;
            // connect to output (your speakers)
            source.connect(audioContextRef.current.destination);
            // play the file
            source.start(0);
            (0, $0d19688bebdb26f8$export$508265175ec7f40e).instrument(audioContextRef.current, "flute").then(()=>{
                playNoteRef.current = (note)=>{
                    (0, $0d19688bebdb26f8$export$508265175ec7f40e).instrument(audioContextRef.current, "flute").then((instrument)=>{
                        instrument.play(note.label, getCurrentTime(), {
                            duration: (note.duration + 150) / 1000
                        });
                    });
                };
                setInstrumentState("ready");
                setPlayerState(playerState);
            });
        } else setPlayerState(playerState);
    }, [
        instrumentState
    ]);
    const [playerState, setPlayerState] = (0, $acw62.useState)({
        playing: false
    });
    const playerStateRef = (0, $acw62.useRef)(playerState);
    (0, $acw62.useEffect)(()=>{
        playerStateRef.current = playerState;
    }, [
        playerState
    ]);
    const tickLength = $6e6f90ac2fa37e65$var$NOTE_LENGTH / 4;
    $6e6f90ac2fa37e65$var$useOptionalInterval((0, $acw62.useCallback)(()=>{
        if (playerStateRef.current.playing) {
            if (playerStateRef.current.timeUntilNextNote <= 0) {
                const nextHighlightedNote = $6e6f90ac2fa37e65$export$3c1f05d40f815626(neumes, playerStateRef.current.highlightedNote);
                if (nextHighlightedNote) {
                    const soundfontNote = $6e6f90ac2fa37e65$export$812e962987ae4379(neumes, nextHighlightedNote, $6e6f90ac2fa37e65$var$NOTE_LENGTH, tone, transposeBy);
                    console.log(soundfontNote);
                    if (playNoteRef.current && soundfontNote) {
                        playNoteRef.current(soundfontNote);
                        const pause = $6e6f90ac2fa37e65$export$aa2a939d159a1a02(neumes, nextHighlightedNote, $6e6f90ac2fa37e65$var$NOTE_LENGTH);
                        playerStateRef.current.highlightedNote = nextHighlightedNote;
                        playerStateRef.current.timeUntilNextNote = soundfontNote.duration + pause;
                    }
                } else {
                    setPlayerState({
                        playing: false
                    });
                    return;
                }
            }
            playerStateRef.current.timeUntilNextNote -= tickLength;
            setPlayerState({
                ...playerStateRef.current
            });
        }
    }, []), tickLength, playerState.playing && instrumentState === "ready");
    const click = (0, $cd93687958c8007e$export$bc451faac18251e7)() ? "Tap" : "Click";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            border: `1px solid black`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: playerState.playing ? `${click} anywhere to pause` : `${click} a neume to play from there`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                onClick: ()=>{
                    if (playerState.playing) setPlayerState({
                        playing: false
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04cfb5a990424bdb$export$a512b99ae1e55604), {
                    gabc: gabc,
                    dropCap: false,
                    tone: tone,
                    onClickNeume: (neumeIndex)=>{
                        if (!playerState.playing) loadAndPlay({
                            playing: true,
                            highlightedNote: [
                                neumeIndex,
                                -1
                            ],
                            timeUntilNextNote: 0
                        });
                    },
                    highlightedNote: playerState.playing ? playerState.highlightedNote : undefined
                })
            })
        ]
    });
};



const $fe1e439501581f64$export$a0abec500c76c448 = [
    {
        title: "part-a-000-0",
        gabc: "In(cg)  (fg) that(hf) day(hg) the(g) mountains(g)  (g) sha}l(g) drop(hi) down(g) new(hg) wine,(f)  and(f) the(g) hills(g) shall(h) flow(j) with(g) milk(h) and(g) ho(g) ney,(gfd)  al(ik)  (f) le(fg) lu(g) ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-000.png",
        nextFileName: "./pages/part-a-001.png"
    },
    {
        title: "part-a-000-1",
        gabc: "Be(fg) joy(gjkji) -(kj)ful,(kj) 0(j) daughter(ji)  (h) of(hj) Si-(hg)on,(g) and(g) ex-(g) ceeding(g)  (g) glad,(fe) O(f) daughter(d)  (e) of(fh) Je-(h)ru-(g)sa-(fg)lem,(gfd)  al(ef) -(fg)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-000.png",
        nextFileName: "./pages/part-a-001.png"
    },
    {
        title: "part-a-001-0",
        gabc: "e-(f)hold,(h) the(g) Lord(eg) cometh,(fe)  (d) and(e) all(e) his(e) Saints(df) with(hhi)  him;(h) and(h) there(h) shall(h) be(i) in(g) that(h) day(f) a(e) great(de) light,(fe)  al-(f)le-(e)lu-(d)ia.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-001.png",
        nextFileName: "./pages/part-a-002.png"
    },
    {
        title: "part-a-001-1",
        gabc: "o,(e) there(f) cometh(i)  (i) a(hi) mighty(j)  (h) TR(i) T(i) R(i) he(f) a-(i)lone(g)  reneweth(h)  (fe) -(f)&amp;(e) ru-(d)sa-(e)=(gfg) al(h) \u2014~le(h) \u2014lu(f) 1ia.(f) I(i)  (h)  (i)  (j) |(h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-001.png",
        nextFileName: "./pages/part-a-002.png"
    },
    {
        title: "part-a-001-2",
        gabc: "R(fdef) I(g) Thy(f) mer-(dc)cy,(df) O(fe) Lord.(e) &amp;(fdef) us.(g)  And(c) grant(df) us(f) thy(f) sal(fd) va(f) =(g) Thy(f) mer(dc) cy.(df) ",
        groupIndex: 2,
        filename: "./pages/part-a-001.png",
        nextFileName: "./pages/part-a-002.png"
    },
    {
        title: "part-a-002-0",
        gabc: "f.(c) Glory(g)  (g) be(g) to(g) the(g) Fa-(fh)ther,(h) and(h) to(g) the(h) Son,(f) and(f)  to(f) the(f) Ho(fd) ly(df) Ghost.(g) Shew(fd)  (ef) us.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-002.png",
        nextFileName: "./pages/part-a-003.png"
    },
    {
        title: "part-a-002-1",
        gabc: "a(e) a(c) a(e) a(g)  (h) .-(h) (f)  (g) L](g) &amp;(h)  (f) a(g) [(f) ](e)  (d) e(e)  2(g)  (f) a(d)  (e) ](f)  (e)  (d) (O(c)  (c) a(e)  (f) a(g) a(f)  (e) [(d)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-002.png",
        nextFileName: "./pages/part-a-003.png"
    },
    {
        title: "part-a-002-2",
        gabc: "h&#39;.\u2018F-(d) (d)  (f) Name(g) of(f) the(h) Lord(h) com(hjijkj) eth(hih) from(h)  a(gf) far:(ghihghg) and(g) his(eg) glo-(hg)-(fg)tilleth(fe) ul-(c)7(dgge) l-(fe) earth.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-002.png",
        nextFileName: "./pages/part-a-003.png"
    },
    {
        title: "part-a-003-0",
        gabc: ";(gi)  (f)  (f)  (fh)  (e) ~(fh)  (hg)  (fg)  (g)  (i)  (hg)  (f)  (g) .(hg)  (f)  (ef)  (f)  I(ig~)  (fi)  (f)  (fi)  (h) M(hg)  (fg)  (fe) u-(e)&amp;(e) =(f)  (g)  (hg)  (f)  (gf)  (ef)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-003.png",
        nextFileName: "./pages/part-a-004.png"
    },
    {
        title: "part-a-003-1",
        gabc: "s(e)  (c) N(e) 0(g)  (h) g(i)  (h) :(h)  (g)  (h)  (j) T(j)  (ig)  (h)  (i)  (h)  These(h) &quot;(h)  (i) [](g) Melodies(eg) 0(f)  (e) -(d)0(e) [(c) 0(e) 0(g)  (h) 0(i) the(h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-003.png",
        nextFileName: "./pages/part-a-004.png"
    },
    {
        title: "part-a-003-2",
        gabc: "Fear(j) [(hgf) Ma-(gh)ry,(gh) for(f) thou(g) hast(g) found(h) fa(ijkji) vour(gh) with(i)  the(h) Lord:(g) behold,(g)  (h) thou(ge) shalt(f) *(gh) it(fed) and(d) bring(def) forth(fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-003.png",
        nextFileName: "./pages/part-a-004.png"
    },
    {
        title: "part-a-004-0",
        gabc: "a(h) Son,(gfd) al-(ef)le-(fg)1lu-(g)1a.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-004.png",
        nextFileName: "./pages/part-a-005.png"
    },
    {
        title: "part-a-004-1",
        gabc: "L(c) ift(dhi) up(h) thine(hjj) evyes,(h) to(g) Je(ghg) ru-(fe)sa-(fg)lem,(gfed) and(d) see(fgh)  the(g) pow\u2014er(h)  (g) of(f) the(g) King:(gh) be-(d)hold(e) the(f) Sa(g) viour(ge) I(f)  com-(f)eth(fe) to(d) loose(fe) thee(dc) from(e) thy(fe) chain.(d) [(h) \xae(g) &amp;(f)  (gf) \xbb(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-004.png",
        nextFileName: "./pages/part-a-005.png"
    },
    {
        title: "part-a-005-0",
        gabc: "eck(f) ye(e) the(f) Lord(hi) Twhile(h) he(i) may(j) be(h) found:(i) cgl](fi) e(g) E(h)  on(ef) him(f) while(e) he(d) is(e) -(fg)al-(h)le-(h).(f) ia,(f) ol(i) :&quot;hl(h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-005.png",
        nextFileName: "./pages/part-a-006.png"
    },
    {
        title: "part-a-005-1",
        gabc: "A(h) ter(hg) T(hiih) cometh(h)  (hg) one(hiih) migh-(h)ti(h) er(g) than(fg) I,(e) the(e)  latchet(fg)  (f) of(f) whose(efede) shoes(ed) I(def) am(f) not(e) wor-(fe)thy(f) to(f)  =(fg) loose.(e) R(h)  (f) ](h) i(i) T(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-005.png",
        nextFileName: "./pages/part-a-006.png"
    },
    {
        title: "part-a-005-2",
        gabc: "I(h) will(hi) waittup(i)  (i) on(h) the(i) Lord(j) my(h) Saviour:(i)  (i) and(i)  I(gi) will(hg) look(f) for(e) him(f) while(e) he(d) 1is(e) near,(fg)  al(h) le(h) lu(f) ia.(f)  (i)  (h)  (hj)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-005.png",
        nextFileName: "./pages/part-a-006.png"
    },
    {
        title: "part-a-006-0",
        gabc: "ut(e) of(f) E-(hi)gypt!(i) have(i) I(i) call_ed(i)  (h) my(hj) Son:(i) e(gihg)  shall(f) come(f) to(e) o(de) his(fh) people.(f)  (f) [(i) S(h)  (i) \u2014-(j) (h) B(fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-006.png",
        nextFileName: "./pages/part-a-007.png"
    },
    {
        title: "part-a-006-1",
        gabc: "\u201C(c) 0(d) Lord,(f) in(fg) peace;(g) T(f) visit(g) us(h) .(i) thy(j) sal-(ih) (g)  vation,(g)  (g) that(fih) we(fg) a(i) e(h) rejoice(g) before(f)  (e) thee(d) with(c) a(d)  a(e) Perfect(d) heart.(c)  (h)  (g)  (f)  (ed) ",
        groupIndex: 1,
        filename: "./pages/part-a-006.png",
        nextFileName: "./pages/part-a-007.png"
    },
    {
        title: "part-a-007-0",
        gabc: "B(dd) ia,(c) e(d) o(ef) st(g) e(fe)  (ddc) Fin(f) e(g) o(h)  of(g) hea-(hg)ven,(f) with(f) pow-(f)er(e) and(f) great(fg) glo(fe) .,(dc)  al(d) \u2014le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-007.png",
        nextFileName: "./pages/part-a-008.png"
    },
    {
        title: "part-a-007-1",
        gabc: "i-(cg) (g) ontis(g) our(g) strong(ig) ci(fg) ty,(g) T(e) Saviour(g)  (f) will(g)  God(fe) ap-(de)point(f) with(ed) in(c) .(c) for(ghgfg) walls(g) and(gj) bul-(j) warks:(g) o-(g)pen(g) ye(h) the(f) gates,(geedef) for(f) God(fe) himsel(d)  (ef)  is(d) with(dc) al(cd) le-(d)lu(c) ia.(c)  (h)  (g)  (f)  (eg) ",
        groupIndex: 1,
        filename: "./pages/part-a-007.png",
        nextFileName: "./pages/part-a-008.png"
    },
    {
        title: "part-a-007-2",
        gabc: "a(c)  (e) in(e) a(e) time(g) ap(h) point-(ihj)ed,(i) the(i) Lord(jh) will(hi) come,(h) ",
        groupIndex: 2,
        filename: "./pages/part-a-007.png",
        nextFileName: "./pages/part-a-008.png"
    },
    {
        title: "part-a-008-0",
        gabc: "and(h) will(fh) not(fg) lie:(ef) though(d) he(f) tar-(hhi)ry,(i) wait(h) for(f) him:(fe)  [(e) he(e) a(e) -(ef)surely(dc) he(d) ,(f) not(f) -(e)ry,(ed)  (c)  al(cd) le(de) lu(e) a-(e)1ia.(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-008.png",
        nextFileName: "./pages/part-a-009.png"
    },
    {
        title: "part-a-008-1",
        gabc: "B(g) =(hj) our(j) Lord(j) shall(j) come(j) with(h) pow-(ih)er,(g) to(g) en-(h) lighten(j)  (i) the(g) eyes(gh) of(f) his(g) .(f) servants,(fd) al(f) le(fg) -(e)ia.(e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-008.png",
        nextFileName: "./pages/part-a-009.png"
    },
    {
        title: "part-a-008-2",
        gabc: "rt(fg) thou(g)  (h) should(g)  (j) come,(jih) or(j) do(ji) we(hg) look(fgh) for(i) ",
        groupIndex: 2,
        filename: "./pages/part-a-008.png",
        nextFileName: "./pages/part-a-009.png"
    },
    {
        title: "part-a-009-0",
        gabc: "an-(h)oth-(g)er?(g) Go(j) and(i) shew(j) John(h) those(gf) things(egh) whjgy,(hgf)  ye(h) do(ji) see:(g) the(hj) blind(j) receive(i)  (jk) their(h) sight,(hg) the(g)  dead(h) are(fg) rais-(gh)ed,(h) and(j) the(jk) poor(kjih) have(i) the(h) g0s-(ji)pe](g)  preached(hg)  (f) un-(g)to(gh) them,(h) al(j) -(hjhf)lu-(hh)ia,(g)  (j)  (i)  (j)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-009.png",
        nextFileName: "./pages/part-a-010.png"
    },
    {
        title: "part-a-009-1",
        gabc: "lessed(gj)  (h) art(g) thou,(h) [(gf) =(gh) -(gh)a(g) thou(gf) 0(g) be-(h)liey-(h) ed(j) the(k) Lord:(jkj) and(h) there(i) shall(j) be(h) a(h) per(g) formance(h)  (g)  in(fg) thee(g) of(gh) those(fe) things(d) which(e) were(f) told(gh) thee(h)  from(g) the(fg) AP(gfd) al(ef) L(fg) TN(g) ia.(g) I(j)  (i) g(j) e(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-009.png",
        nextFileName: "./pages/part-a-010.png"
    },
    {
        title: "part-a-010-0",
        gabc: "e-(f)hold(e) the(f) King(h) shall(ij)  (i) the(i) Lord(hi) of(j) the(h) earth,(i)  and(i) he(f) shall(i) take(g) a-(h)way(f) the(e) yoke(f) of(e) our(de) cap-(fh)ti-(f)vi-(f)ty.(f)   (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-010.png",
        nextFileName: "./pages/part-a-011.png"
    },
    {
        title: "part-a-010-1",
        gabc: "he(f) voice(f) of(f) one(e) T(f) W(e) the(d)  (f) g(hhi) wilderness,(h) ey(h) Prepare(i) T(hi)  ye(f) the(f) way(fe) of(f) the(e) Lord,(d) make(d) %(de) in(e) the(f)  des\u2014ert(de)  (e) a(f) highway(h)  (e) for(e) our(fe) God.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-010.png",
        nextFileName: "./pages/part-a-011.png"
    },
    {
        title: "part-a-010-2",
        gabc: "i-(hi)on,(i) thou(h) shalt(i) be(j) re-(h)new-(i)ed,(i) and(f) shalt(i) see(g) thy(h)  (f)  righteous(f) e(fe) One,(fe) he(d) that(e) cometh(f)  (g) un-(h)to(hg) thee.(f) ](i) ](h)  (hj)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-010.png",
        nextFileName: "./pages/part-a-011.png"
    },
    {
        title: "part-a-011-0",
        gabc: "[(e) that(f) cometh(h)  (h) af-(h)ter(ij) me(i) tis(h) preferred(i)  (j) =(i) be-(h);(i) .(i)  the(i) latchet(fi) a(g) of(h) whose(fe) shoes(f) I(e) am(d) L)(e) worthy(f)  (g) \xa2,(h)  -(h)-(f)n\u2014(i) =(h)  (i) &quot;~(j) =(h) 4(fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-011.png",
        nextFileName: "./pages/part-a-012.png"
    },
    {
        title: "part-a-011-1",
        gabc: "S(c) ing(g) un-(h)to(i) the(j) Lord(ij) Ta(hf) new(h) song;(g) and(i) his(hf) praise(h)  from(gi)  (g) the(h) end(hi) of(f) the(f) earth.(e)  (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-011.png",
        nextFileName: "./pages/part-a-012.png"
    },
    {
        title: "part-a-011-2",
        gabc: "B(c)  (c)  (d) e_fore(f) me(fg) there(g) was(g) no(g) God(gh) form-(h)ed,(hghihgg) neither(f) [](g) ",
        groupIndex: 2,
        filename: "./pages/part-a-011.png",
        nextFileName: "./pages/part-a-012.png"
    },
    {
        title: "part-a-012-0",
        gabc: "shall(gh) there(g) be(hg) af-(f)ter(ghg) me:(hih) un-(f)to(h) me(j) ev-(h)ery(g) knee(fe)  shall(def) bow,(fc) and(fe) me(g) shall(fe) ev-(dc)ery(df) tongue(g) confess.(fe)  (d)  a(h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-012.png",
        nextFileName: "./pages/part-a-013.png"
    },
    {
        title: "part-a-012-1",
        gabc: "T(ikc)  (c) he(f) Lord(h) will(g) surely(h)  (g) .(e) and(f) will(gh) not(ef) tarry:(d)  (d) and(d)  will(f) bring(g) to(g) light(g) the(g) hid-(h)den(fg) things(g) of(fgh) darkness,(f)  (f)  and(f) will(g) ma(h) ni(g) fest(h) him-(g)sel(e) to(f) all(fg) na-(fe)tionms,(cd)  al(d) le(efe) lu(d) ia.(d)  (h)  (g)  (f)  (g)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-012.png",
        nextFileName: "./pages/part-a-013.png"
    },
    {
        title: "part-a-013-0",
        gabc: "J(c)  (c)  (e) 1&#39;jow,&#39;(f)  (g)  (fe) with(f) great(d) rejoicing,(ef)  (fh)  (g) for(hj)  .(hi) Saviour(hg) :(h) cometh(g) un-(f)to(fe) thee,(d) al(e) le-(de)\u2014(c) ia.(c) 1(h) &quot;](g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-013.png",
        nextFileName: "./pages/part-a-014.png"
    },
    {
        title: "part-a-013-1",
        gabc: "I(ik)  (g) win(gfd) place(fe) sal-(fg)va-(fh)tion(g) Tin(fh) Si-(h)on,(g) and(h) in(j) Je-(g) ru-(ik) (hg) sa-(fg)lem(g) my(hg) glo-(fe)ry,(d) al(f) -(fg)1lu-(g)ia.(g) |(j) =(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-013.png",
        nextFileName: "./pages/part-a-014.png"
    },
    {
        title: "part-a-013-2",
        gabc: "et(gicd)  (ff) us(e) live(f)  (g) righteously(h) and(i)  (gh) godly,T(f)  (f) looking(e)  (f) for(h)  e(gi) that(fe) blessed(g) I(ig) hope,(hg) and(e) the(f) coming(h) s(g) of(e) the(g) Lord.(f)   (gi)  (h)  (g)  (e)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-013.png",
        nextFileName: "./pages/part-a-014.png"
    },
    {
        title: "part-a-014-0",
        gabc: "lessed(gj)  (h) art(g) thou,T(h) 0(gf) Ma-(gh)ry,(gh) for(g) thou(gf) hast(g) be-(h)liev-(h) ed(j) the(k) Lord:(jkj) and(h) there(i) shall(j) be(h) a(h) performance(g)  (h)  (g)  in(gf~) thee(g) of(hg) those(fe) things(d) which(e) were(f) told(gh) thee(h)  from(g) the(fg) Lord,(gfd) al-(ef)le-(fg)lu-(g)ia.(g)  (j)  (i) |(j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-014.png",
        nextFileName: "./pages/part-a-015.png"
    },
    {
        title: "part-a-014-1",
        gabc: "rt(fg) thou(g) he(h) Tthat(g) should(j) come,(jih) or(j) do(ji) we(hg) look(gh) for(i)  an\u2014oth\u2014er?(h)  (g)  (g) Go(j) and(i) shew(j) John(h) those(gf) things(gh) which(hgf)  ye(h) do(ji) see:(g) the(hj) blind(j) 1(i) receive(jk) their(h) sight,(hg) the(g)  poor(jih) have(i) the(h) gos-(ji)pel(g)  dead(h) are(gf) rais-(gh)ed,(h) and(j) the(jk)  \u2014(hg) preached(f) un-(g)to(gh) them,(h) al(j) v(hjhf) lu-(hh)ia.(g) -(j) (i)  (j) 0(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-014.png",
        nextFileName: "./pages/part-a-015.png"
    },
    {
        title: "part-a-015-0",
        gabc: "O(fhhg) 0(hfgfef) -(f)camest(f)  (f)  (f) out(g) of(f) the(f) mouth(gh) of(f)  the(ig)  (g) Most(ef) High,(e) and(f) reachest(cf)  (f) from(f) one(g) end(f) to(f) an-(f)oth-(g)er,(f)  mightily(gi)  (g)  (h) and(ijijkj)  (ij) sweetly(j) -(i)or-(h)der-(hg)ing(fh) all(h) things:(e)  v(gi) Come(ehhg) and(f) teach(gfef) us(fec) the(ef) way(hg) of(e) prudence.(gh)  (f) &quot;(h) pa(gf) e(hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-015.png",
        nextFileName: "./pages/part-a-016.png"
    },
    {
        title: "part-a-015-1",
        gabc: "O(hgi)  (fhhg) a-(hf) (gf)  (df) and(f)  (f) Leader(g)  (f) of(f) the(f) house(g) of(hf) Is-(g) ra-(gi) (f) el,(e) who(f)  (cf) appearedst(f)  (f) in(f) the(f) bush(g) to(f) Mo(g) ses(f) in(f)  a(i)  (f) flame(g) of(h) fire,(ijijkj) and(j) gavest(j)  (i) him(h) the(h) law(hg) in(fh)  Si-(hgi) (h) nai:(e) Come(ehhg) and(h) redeem(f)  (gfef) us(fec) with(e) an(f) n(hg)  (e)  ed(g) arm.(f) N(h)  (gf)  (hg) 62(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-015.png",
        nextFileName: "./pages/part-a-016.png"
    },
    {
        title: "part-a-016-0",
        gabc: "(O(ig~)  (fhhg) PBoot(hf) of(gf)  (ef) Jesse,(f) which(f) standest(g)  (f) for(f) an(f) ensign(g)  (f)  of(gh) the(fg) people,(f)  (e) at(f) whom(cf) kings(fg) shall(f) shut(g) their(h)  mouths,(g)  (jijijkj) un-(j)to(i) whom(j) the(i) Gentiles(h)  (fh) shall(fe) seek:(e) Come(ehhg)  and(gi)  (h) de-(f)liv-(gf)er(ef) us,(fe) and(ef) tarry(hg)  (eg) not.(f) -(h) (gf) \u2018I(hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-016.png",
        nextFileName: "./pages/part-a-017.png"
    },
    {
        title: "part-a-016-1",
        gabc: "()(fhhg) Key(hf) of(gf)  (ef) -(f)and(f) Sceptre(g)  (f) of(f) the(f) house(g) of(hf) Is-(g) ra-(gi) (f) el;(e) that(f) o-(cf) (f) penest(f) and(f) no(g) man(f) shutteth,(fh)  (ijijkj) and(j) shut-(j) test(gi)  (i) and(h) no(hg) man(fh) o-(h)&quot;e(fgfe) peneth:(e) Come,(eh) and(g) bring(h) the(f) pri-(g) soners(hig~)  (f)  (f) out(fe) of(f) the(h) prison-(h)CH(fgfe) house,(e) them(eh) that(g) sit(h) in(f)  v(ig~) darkness(gfef)  (fe) and(e) the(f) 0(hg) shadow(e) of(h) death.(f) m(h)  (gf) e(hg)  (e) ](f) ",
        groupIndex: 1,
        filename: "./pages/part-a-016.png",
        nextFileName: "./pages/part-a-017.png"
    },
    {
        title: "part-a-017-0",
        gabc: "()(ig~)  (fhhg) Day(hfgfef) -(f)of(g)  (f)  (f) the(f) Light(gh) ev_er.(f)  (g)  last-(f)ing,(e) and(f) Sun(cf) of(f)  (g) righteousness:(h)  (ijijkj) Come(ji) ang(gh)  en-(gi) (fh)  (h) a(e) them(eh) that(g) sit(h) in(f) darkness(gfef)  (fe) a(e) the(f)  N(gi) A(hg) dow(e) of(gh) death.(f) IS(h) A(gf) A(hg) S(e) Mol(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-017.png",
        nextFileName: "./pages/part-a-018.png"
    },
    {
        title: "part-a-017-1",
        gabc: "[(hig~) O(fhhg) King(hf) of(gf) N(ef) Nations,+and(f) -(fh)their(g) i(f) Desire;(e) the(f) Cor-(cf) v(gi) ner-(gh)stone,(ijijkj) who(ji) makest(hg) v(fh) both(hhg) e(e) Come(ehhg) and(f) save(gf)  .(gi) o(ef) e(fec) whom(e) thou(f) ;(hg) [(e) of(gh) clay.(f) 11(h)  (gf) O(hg) &quot;1(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-017.png",
        nextFileName: "./pages/part-a-018.png"
    },
    {
        title: "part-a-017-2",
        gabc: "~(fhhg) Em(hf) &quot;~(gf) u-(ef)-(f)our(f) King(g) and(fh) Lawgiver,(g)  (f)  (e) the(f) De-(cf)",
        groupIndex: 2,
        filename: "./pages/part-a-017.png",
        nextFileName: "./pages/part-a-018.png"
    },
    {
        title: "part-a-018-0",
        gabc: "-(g)sire(fg) of(f) all(gh) o(j) tions(jijkj) and(j) their(hg) [(fh) Salvation:(h) ](e) Come(ehhg)  |(ig~) and(f) save(gfef) us,(fe)  (c) O(ef) Lord(hg) our(eg) God.(f) e(h) i(gf) A(hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-018.png",
        nextFileName: "./pages/part-a-019.png"
    },
    {
        title: "part-a-018-1",
        gabc: "0(hg~)  (fhhg) Virgin(h)  (f) of(gf) virgins,T(ef)  (f) how(gh) shall(fg) this(f) be?(e)  for(f) neither(cf)  (f) be-(f)fore(g) thee(f) was(f) a~ny(g)  (f) seen(g) like(h)  [(ig~) thee,(kijijkj) nor(ji) shall(h) there(hg) be(fh) af-(h)ter.(e) Daughters(eh)  (g)  of(ig~)  (h) Je-(f)ru-(gf)sa-(ef)lem,(f) -(fe)mar-(f)vel(h) ye(h) at(fgfe) me?(e)  The(hg~)  (eh) thing(hg) which(f) ye(gf) be-(ef)hold(fec) is(f) a(e) di-(f)vine(hg)  mys(ig~)  (e) te(gh) ry.(f) 1.~(f)  (h) &amp;/(gf)  (hg) 5(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-018.png",
        nextFileName: "./pages/part-a-019.png"
    },
    {
        title: "part-a-019-0",
        gabc: "e-(f)hold(e) the(f) Lord(h) shall(ij) _\u2014\u2014_\u2014\u2014_\u2014_\uFB01(i) the(i) Prince(i) of(h) the(i)  kings(jk)  kings(j) of(i) the(h) earth:(i) bless-(gi)ed(hg) \u2014(fe) they(f) that(e) 4,(d)  a(e) -(fg)ed(h) to(h) meet(f) him.(f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-019.png",
        nextFileName: "./pages/part-a-020.png"
    },
    {
        title: "part-a-019-1",
        gabc: "hen(h) the(h) Son(h) of(hg) man(hiih)  (fghg) shall(e)  (hhg) he(f)  (fe) find(de)  faith(f) on(g) the(f) earth?(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-019.png",
        nextFileName: "./pages/part-a-020.png"
    },
    {
        title: "part-a-019-2",
        gabc: "0,(df) now(hf) com-(hi) (h) the(h) E(f) 0(e) of(f) the(e) :(d) wherein(d) a(e)  God(ig~)  (fe) N~(d) forth(ef) his(f) Son(h) in-(e)to(f) the(e) world.(d) |(h) I(i)  (g)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-019.png",
        nextFileName: "./pages/part-a-020.png"
    },
    {
        title: "part-a-020-0",
        gabc: "he(f) Lord(e) shall(f) go(hi) forthTout(i)  (i) of(h) his(i) ho(j) Iy(h) place:(i)  he(gihg) shall(ef) come(f) to(e) save(de) his(fh) people.(f)  (f) &#39;(i) 7(h)  (i)  (j) |(h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-020.png",
        nextFileName: "./pages/part-a-021.png"
    },
    {
        title: "part-a-020-1",
        gabc: "rop(f) down,(e) ye(f) heavens,(h)  (h) from(h) a-(ij)bove,(i) and(i) let(h) the(i)  skies(jh) pour(i) down(ij)  (h) righteousness:(g)  (f) let(f) the(i) earth(h) o(f) \u2014pen,(f)  a(e) let(d) 0(e) bring(fg) forth(h) [(h) salvation.(f) e(f) &amp;(i) v(h) &amp;(i) 1(j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-020.png",
        nextFileName: "./pages/part-a-021.png"
    },
    {
        title: "part-a-020-2",
        gabc: "end,(e) O(f) Lord,(h) the(hi) Lamb,T(i) the(i) Ruler(h)  (i) of(j) the(h) land,(i)  from(i) the(i) rock(fi) of(g) the(h) de-(fe)sert(f) un-(e)to(d) the(e) mount(f) of(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-020.png",
        nextFileName: "./pages/part-a-021.png"
    },
    {
        title: "part-a-021-0",
        gabc: "the(h) daughter(hg)  (hi) of(hg) Si-(f)on.(f) \u2014(i) -(h) (i) =(j)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-021.png",
        nextFileName: "./pages/part-a-022.png"
    },
    {
        title: "part-a-021-1",
        gabc: "That(c)  (c)  (e) thy(f) way,(h) O(ij) O(i) be(h)  (i) known(j) -(i)on(h) earth,(i)  thy(ig~)  (gihg) saving(f) \xbb(e) health(f) a(e) mong(de) all(fh) nations.(f)  (f) |(i) R(h)  (i)  (j)  (h) |(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-021.png",
        nextFileName: "./pages/part-a-022.png"
    },
    {
        title: "part-a-021-2",
        gabc: "he(dd) ](c) was(d) .(ef) en(g) by(fe) Moses,(d)  (d) but(fg) grace(hg) and(gf) truth(f)  came(f) by(g) a(e) sus(fe) Christ.(d) ~(h) i(g) _(f) A(gh) \xae(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-021.png",
        nextFileName: "./pages/part-a-022.png"
    },
    {
        title: "part-a-021-3",
        gabc: "T(c)  (c) he(d) prophets(dd) ](c) did(d) foretell(fe)  (ddc) that(f) a(g) Saviour(h)  (g) should(gf)  be(f) born(f) of(f) the(g) Virgin(e)  (ef) -(d)ry.(d) TR(h) e(g) -(f) (gh) :_H(g) ",
        groupIndex: 3,
        filename: "./pages/part-a-021.png",
        nextFileName: "./pages/part-a-022.png"
    },
    {
        title: "part-a-022-0",
        gabc: "T(ig~) he(f) Spi-(fgh)rit(f) Tof(f) the(f) Lord(fe) is(f) -(hg)on(e) me:(e) he(f) hath(g)  sent(g)  (f) me(e) to(g) preach(i) the(h) gospel(h)  (h) to(i) the(hg) poor.(f) Il(h) I(g) S|(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-022.png",
        nextFileName: "./pages/part-a-023.png"
    },
    {
        title: "part-a-022-1",
        gabc: "For(f) Si-(h)on\u2019s(hi) sake(i) TI(i) will(h) not(i) S(j) my(ih) peace,(i) B(i) until(f) the(i)  righteous-(g) (h) ness(f) thereof(e)  (f) go(e) forth(de) as(fh) brightness(f)  (f) s(i) T(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-022.png",
        nextFileName: "./pages/part-a-023.png"
    },
    {
        title: "part-a-022-2",
        gabc: "Tell(ig~)  (h) it(hi) out(i) -(i)mong(h) the(i) nations,(j)  (i) and(h) say:Be-(i) (i) hold,(fi)  \u2014(gi)  (gh) &quot;=(fe) 4(ef) Sa-(de)=(fh) @(f) 0@(f) 0w(i)  (h)  (hj)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-022.png",
        nextFileName: "./pages/part-a-023.png"
    },
    {
        title: "part-a-022-3",
        gabc: "ron(f) Si-(gh)on(h) draweth(h)  (g) nigh(h) the(ef) Lord(g) Al-(f)migh-(d)ty(d) to(d) ",
        groupIndex: 3,
        filename: "./pages/part-a-022.png",
        nextFileName: "./pages/part-a-023.png"
    },
    {
        title: "part-a-023-0",
        gabc: "bring(fe) salvation(fg)  (fe) [](c) un-(eg)to(e) o(fe) people.(d)  (d)  (h)  (g)  (f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-023.png",
        nextFileName: "./pages/part-a-024.png"
    },
    {
        title: "part-a-023-1",
        gabc: "urn(he) thee(f) &#39;a-(ed)gein,(efe) O(de)  (e) at(gh) the(if) last,(hg) and(i) do(i) pg(h)  de-(h)lay(ij) to(i) come(hghih) un-(ef)to(fh) thy(gf) servants.(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-023.png",
        nextFileName: "./pages/part-a-024.png"
    },
    {
        title: "part-a-023-2",
        gabc: "F(c)  (c) ron(f) |(gh)  (h) Si_on(h) cometh(g) he(h) that(g) is(e) to(f) reign(g) as(fe) Lord:(d)  Fn-(f) (gh) man\u2014u-(gf)el(f) is(fe) his(dc) migh-(d)ty(efe) Name.(d)  (h)  (g)  (f)  (g)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-023.png",
        nextFileName: "./pages/part-a-024.png"
    },
    {
        title: "part-a-023-3",
        gabc: "Lord(g)  (hj) is(j) our(h) Lawgiver,(j)  (i) t(i) the(g) Lord(hi) is(i) our(h) King,(g) he(i)  .(h) himself(j) will(i) come,(g) and(h) will(f) save(g) us.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 3,
        filename: "./pages/part-a-023.png",
        nextFileName: "./pages/part-a-024.png"
    },
    {
        title: "part-a-024-0",
        gabc: "B(gi) e(fi) ve(hg) steadfast,T(ef)  (f) and(f) see(f) the(h) sal-(g)va-(e)tion(e) of(g) 0(e)  \u2014(gi) Lord(f) with(gh) you.(f) I(h) a7(g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-024.png",
        nextFileName: "./pages/part-a-025.png"
    },
    {
        title: "part-a-024-1",
        gabc: "U(e) to(f) thee,(h) 0(hi) Lord,(i) Tdo(i) I(i) lift(i) up(h) my(ij) soul:(i)  =(fi) and(g) de-(h)liv\u2014-(f)I(e) me,(fe) for(d) I(e) flee(fg) S(h) to(hg) thee,(hi)  0(hg) Lord.(f)  (i)  (h)  (i)  (j)  (h) :(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-024.png",
        nextFileName: "./pages/part-a-025.png"
    },
    {
        title: "part-a-024-2",
        gabc: "C(gi) ome,(h) 0(hi) l..ord,T(i) and(i) do(hi) not(jh) tarry:(i)  (i) forgive(i)  (fi) the(g)  of(h) s(fe) ces(fe) of(d) thy(e) people(f)  (h) Is-(f)ra-(f)el.(f) W(i)  (h)  (hj)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-024.png",
        nextFileName: "./pages/part-a-025.png"
    },
    {
        title: "part-a-025-0",
        gabc: "Consi\u2014der(f)  (hi) T(i) how(i) great(h) and(i) glorious(j)  (i) is(h) he(i) who(fi) en-(g) (h) tereth(fe)  in(fe) for(d) the(e) salva-(fg) (h) tion(hg) of(hi) his(hg) people.(f)  (f) =(i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-025.png",
        nextFileName: "./pages/part-a-026.png"
    },
    {
        title: "part-a-025-1",
        gabc: "His(d) Kingdom(dd)  (c) shall(d) be(efg) 1n-(fe)creas(d) d,(dc) and(c) of(d) his(f) peace(ff)  there(f) shall(ef) be(g) no(fe) end.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-025.png",
        nextFileName: "./pages/part-a-026.png"
    },
    {
        title: "part-a-025-2",
        gabc: "I(g) the(hi) Lord(i) tbring(j) near(h) my(i) e(i) righteousness;(h)  (g) it(h) shall(i) not(h) be(i)  far(g) off,(e) and(g) my(g) salvation(h)  (g)  (f) shall(g) not(gf) tar-(e)ry.(e) e(j)  (h) 1(j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-025.png",
        nextFileName: "./pages/part-a-026.png"
    },
    {
        title: "part-a-025-3",
        gabc: "Prepare(f)  (f) thyself,(i)  (h) O(g) Is-(e)ra-(f)el,(f) to(f) meet(h) thy(g) (B(e) Saviour,(e) for(ge)  he(fh) cometh.(f)  (f) [(h) &amp;(g)  (e) =(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-025.png",
        nextFileName: "./pages/part-a-026.png"
    },
    {
        title: "part-a-026-0",
        gabc: "will(hi)  (i)  (i)  (h) look(ij) -(h)to(i) the(j) Lord,(i) and(i) 1(f)  (i)  will(i) -(gh)for(f) the(e) God(f) of(e) my(de) sal-(fh)va-(f)tion.(f) |\u2014I(i)  (h)  (hj)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-026.png",
        nextFileName: "./pages/part-a-027.png"
    },
    {
        title: "part-a-026-1",
        gabc: "Al(gj) ge-(h) (g)  (h) ne\u2014ra\u2014tions&#39;l&#39;(g) shall(fg) call(g) me(gh) blessed:(f)  (f) for(fg)  God(h) hath(g) re-(f)gard-(g)ed(h) the(h) low-(jk)1i-(j)ness(jijkj) of(h) his(h)  [(j) handmaiden.(g) a-(g)T(j) 00&quot;(i) I\u2014I(j)  (h) &amp;(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-026.png",
        nextFileName: "./pages/part-a-027.png"
    },
    {
        title: "part-a-026-2",
        gabc: "A(c)  (e) wake,(d) a(ef) ..(e) ta-(e)rise,(gh) O(i) Je(hf) ru-(h)sa-(h)lem:(g) loose(i)  thy-(i)self(i) from(h) the(h) bands(hj) of(i) thy(h) neck,(hghih) O(f) cap-(f).(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-026.png",
        nextFileName: "./pages/part-a-027.png"
    },
    {
        title: "part-a-027-0",
        gabc: "daughter(f)  (h) of(g) Si(ff) on.(e)  (h)  (g)  (h) .(f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-027.png",
        nextFileName: "./pages/part-a-028.png"
    },
    {
        title: "part-a-027-1",
        gabc: "B(j) hold(ji) the(hg) handmaid(ih~)  (h) of(gh) the(h) Lord;(g) -(ge)it(g) I\u2014\u2014\u2014\u2014(f) ](e)  me(f) ac-(d)a(e) ing(f) to(fgh) thy(h) word.(g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-027.png",
        nextFileName: "./pages/part-a-028.png"
    },
    {
        title: "part-a-027-2",
        gabc: "R(c)  (h) joice(hg) ye(f) Twith(f) Je-(e)ru-(f)sa-(h)em;(hiih) and(fh) be(hi) glad(j) with(ih)  her,(hif) all(fi) ye(h) that(gh) love(f) her,(ed) for-(ef)o(d) er.(d) e(h)  (i)  (g)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-027.png",
        nextFileName: "./pages/part-a-028.png"
    },
    {
        title: "part-a-027-3",
        gabc: "\u2014(c)  (dc) is(f) the(g)  (fh) witnessTwhich(h)  (h) John(hj) bare,(hg) saying:(fh)  (g) He(g) that(g)  i(g) 2(eg) af-(h)ter(g) e(fgh) is(e) =(c) preferred(eg) I(e) be-(fe)fore(d) me.(d) I(hg) IMMa_dp(f) \u2014\u2014(gh) Al(gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-027.png",
        nextFileName: "./pages/part-a-028.png"
    },
    {
        title: "part-a-028-0",
        gabc: "Blow(f) ye(c) the(d) trumpet(dhi)  (h) Tin(hgfg) Si(fghghi) on,(hgg) for(f) the(g) day(h) of(g) 3(f)  Lord(g) is(dg) nigh&#39;(gfed) \u2014\u2014\u2014(fed) at(cdfede) hand:(ed) behold,(f)  (fg) he(fe) cometh(c)  (d) to(f) say,(ed)  us,(def) al-(c)le-(d)lu-(fg)ia,(fe) al-(g)le(fe) lu-(d)ia.(d) &quot;(h) =(g) 3(f)  (fh) I(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-028.png",
        nextFileName: "./pages/part-a-029.png"
    },
    {
        title: "part-a-028-1",
        gabc: "TtheDesire(ik)  (d)  (dc)  (f)  (g) of(fh)  (h) all(h) nations(ih)  (g) shall(fh) come:(g) and(g) the(g) house(g)  ](e) the(g) Lord(h) shall(g) be(f)  (f) filledwith(g)  (f)  (fe) al-(dc) (d)  (efe) lu-(d)ia.(d)  .(h)  (g) Erunt(f) prava(gh)  (gf)  T(c) He(cd) crooked(dh) 1(hi) shall(h) be(g) made(h) straight,and(hg)  (f) the(g) rough(hgef) ple(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-028.png",
        nextFileName: "./pages/part-a-029.png"
    },
    {
        title: "part-a-029-0",
        gabc: "plain:(ki~)  (d) come,(fg) C(f) Lord,(d) and(fe) do(g) not(f) tarty,(fe)  (dc) al-(d)le-(efe)lu-(d)ia.(d)  4(h)  (g) Omnipotens(f)  (fh)  (g)  Thine(gi)  (h) Almighty(gh)  (f) |(fe) A(f) N(hg) Lord,(e) leapeth(g)  (h) down(i) from(hg) heaven(f)  (f)  out(h) of(g) thy(h) royal(i)  (h) throne,(ge) al-(f)le(ghg) lu-(f)ia.(f) IS(h) I(g) W(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-029.png",
        nextFileName: "./pages/part-a-030.png"
    },
    {
        title: "part-a-029-1",
        gabc: "0(g) Ju-(g)dah(gfd) and(e)  (f)  (gh) be(h)  (g)  (g) ye(g) mot(ih) dismayed:(g)  (ghgf)  (f)  to-(j) (ji) morrow(h) go(hk) ye(j) forth,(ihg) and(g) the(e) Lord(gh) himself(ef)  (d) will(ef) be(h)  (h)  with(h) you,(gfd) al-(f)le-(fg)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-029.png",
        nextFileName: "./pages/part-a-030.png"
    },
    {
        title: "part-a-030-0",
        gabc: "e(h) shall(fg) know(h) this(gf) T(e) that(e) the(e) Lord(f) will(de) come;(eef) and(h)  in(f) the(h) a(gf) morning(e) ye(f) shall(de) see(df) his(f) glory.(e)  (e) 1(h)  (f)  (h) 4(i)  (h)  -(ig~)To-(f) (e) morrothhe(f)  (h) i-(h)ni-(h)qui-(h)ty(h) of(h) the(ij) earth(i) shall(h) be(i)  blotted(g)  (j)  (h) out:(i) and(f) the(i) Saviour(g)  (h) of(f) the(e) world(fe) shall(de)  B/(g) reign(g) o(h) ver(hg) us.(f) +(i)  (h)  (i) &quot;(j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-030.png",
        nextFileName: "./pages/part-a-031.png"
    },
    {
        title: "part-a-030-1",
        gabc: "Tihe(c)  (dc) Lord(f) will(hg) come,(h) go(h) ye(hj) out(h) to(g) meet(hg) him,(e) saying:(ff)  (d)  Great(hihh) is(g) his(jh) do-(j)min-(jih)ion,(h) and(hgg) of(f) his(gh) kingdom(gf)  (g) there(h)  shall(g) be(f) no(gf) end:(d) the(g) migh-(ggg)ty(gd) God,(efd) the(e) Gov-(f)er-(de)mor,(dc)  (c)  the(cd) T(ffe) of(fg) peace,(g) al-(e)le-(fe)lu-(d)ia.(d) e(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-030.png",
        nextFileName: "./pages/part-a-031.png"
    },
    {
        title: "part-a-031-0",
        gabc: "T(c)  (h) o-(h)morrow(h) ye(h) shall(h) have(f) salvation,(h)  (gf)  (ef) saith(d) the(f) Lord(fh)  God(g) of(f) .-(e)hosts.(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-031.png",
        nextFileName: "./pages/part-a-032.png"
    },
    {
        title: "part-a-031-1",
        gabc: "_(fg) shall(f) know(g) this(gh) day(hg) That(f) the(gh) Lord(gfd) will(fg) 1~(gf)  Ye(fg) shall(f) know.(g) And(h) in(hi) the(h) morning(gh)  (g) ye(h) shall(g) see(g)  his(f) glory.(gh) I(hg) That(f) the(gh) Lord.(gfd) \xa5.Glory(h)  (h) be.(h) Ea(fg) shall(f) know.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-031.png",
        nextFileName: "./pages/part-a-032.png"
    },
    {
        title: "part-a-031-2",
        gabc: "The(ccgd) Saviour(fg)  (ghg) Tof(f) the(ghg) world(hih) shall(f) o(h) arise.(ji) as(gh) the(h) sun:(g) and(f)  shall(g) come(hg) down(f) in-(g)to(fe) the(d) Virgin\u2019s(f)  (f) womb,(df) ;s(c) the(d) show-(fg) ers(g) up-(f)on(h) the(ji) grass,(gfd) al(ef) le(fg) -(g)ia.(g) ITa(j)  (i) &quot;5(j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-031.png",
        nextFileName: "./pages/part-a-032.png"
    },
    {
        title: "part-a-032-0",
        gabc: "he(gd) King(fe) of(gf)  (g) highly(g)  (g)  (h) ex-(g)alt-(hg)ed,(f) for(gf) whose(gh)  counte-(i) (h) nance(g) all(gf) the(d) earth(fh) longeth.(g)  (g) I\u2014I(j)  (i)  (j)  (h)  (g)  counte-(j) (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-032.png",
        nextFileName: "./pages/part-a-033.png"
    },
    {
        title: "part-a-032-1",
        gabc: "he(e) King(g) of(h) peace(i) tis(h) highly(f)  (h) ex-(g)alt-(e)ed,(e) exceeding(f)  (h)  (h)  (h)  all(h) the(g) kings(fgh) of(h) the(f) whole(gf) earth.(e) A(j)  (i) e,(h) Aol(gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-032.png",
        nextFileName: "./pages/part-a-033.png"
    },
    {
        title: "part-a-032-2",
        gabc: "now(fg) ye(g) that(g) the(g) kingdom(h)  (g) of(f) God(g) .is(gh) nigh:(f) ve-(f)ri-(h)ly(j)  I(j) say(k) un-(i)to(j) you,(h) it(gf) will(e) not(fg) 2.(g) &amp;(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-032.png",
        nextFileName: "./pages/part-a-033.png"
    },
    {
        title: "part-a-033-0",
        gabc: "ift(ddc) up(d) your(fe) heads,(ddc) for(f) be-(h)hold,(gh) your(g) redemption(f)  (fg)  (g)  nigh.(dc)  (fe)  (d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-033.png",
        nextFileName: "./pages/part-a-034.png"
    },
    {
        title: "part-a-033-1",
        gabc: "Ye(fg) shall(f) know(fedc) this(fghi) day(h) That(h) the(ij) Lord(ihgfe) will(fhgf) come.(f) Ye(fg)  shall(f) know.(fedc) V.(c) And(f) in(g) the(f) morning(fh)  (f) ye(g) shall(f) see(fe) Mis(dc)  glory.(fghi)  (h) That(h) the(ij) Lord.(ihgfe) Glory(f)  (f) be(g) to(f) the(f) Father(gh)  (f) and(g)  and(ki~)  (fe)  (dc)  (c)  (c) to(df) the(f) Ho(gih) 1y(gf) Ghost.(f) Ye(fg) shall(f) know.(fedc) ",
        groupIndex: 1,
        filename: "./pages/part-a-033.png",
        nextFileName: "./pages/part-a-034.png"
    },
    {
        title: "part-a-033-2",
        gabc: "N(c)  (d) 0,(efg) o(gf) [(ed) 4(f) EaE(edc)  (d) 8(ce)  (g)  (gh)  (h)  0,(hg)  (gj)  (ihg) o(h) 4(hj) i(g)  (gf) e(e)  (dc)  (d)  (de)  (e)  4(c)  (d)  (eg)  (gf)  (ed)  (f)  (edc)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-a-033.png",
        nextFileName: "./pages/part-a-034.png"
    },
    {
        title: "part-a-034-0",
        gabc: "hen(g) the(gd) sun(fgh) hath(g) risen(gh) T(g) in(h) the(g) heavens,(h)  (h) ye(g) sha]](g)  see(h) the(gf) King(g) of(h) kings,(hijg) proceeding(gh)  (h) o,(ghgf) from(hgi) the(h) Father,(g)  (g)  A(ik)  (ge) a(g) =(f) bridegroom(d) out(def) of(fgh) his(h) chamber.(g)  (g) e(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-034.png",
        nextFileName: "./pages/part-a-035.png"
    },
    {
        title: "part-a-034-1",
        gabc: "PSALM(h)  (h)  (h)  (h)  (f)  (h)  (h)  (h)  (g)  (f) ANTIPHONS(h)  (h)  (de)  (h)  (h)  (h)  (h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-034.png",
        nextFileName: "./pages/part-a-035.png"
    },
    {
        title: "part-a-034-2",
        gabc: "P/(dhcgic) beheld(h)  (g)  (h) ye,(fhg) 0(ef) shepherds?(h)  (g) Tell(eg) usg;(f) D(f)  (e) to(f)  us(h) the(g) tidings,(eg)  (f) on(f) earth(ef) who(h) hath(g)  (e) appeared?(g)  (f)  We(ig~)  (f) saw(e) the(f) new-(hg)born(e) Infant,(g)  (f) and(e) the(f) choir(hg) .(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-034.png",
        nextFileName: "./pages/part-a-035.png"
    },
    {
        title: "part-a-035-0",
        gabc: "An-(gi) (hi) gels,(h) praising(h)  (h) the(i) Lord(g) together,(h)  (f)  (f) al-(f)[(e) lu-(f)ia,(h)  v(hgi) al-(g)le-(e)lu-(gfg)ia.(f) e(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-035.png",
        nextFileName: "./pages/part-a-036.png"
    },
    {
        title: "part-a-035-1",
        gabc: "She(gi)  (h) that(g) 0(h) travailed(g) T(f) hath(g) borne(f) the(e) Monarch(gg)  (f) whose(f)  Name(f) is(e) ev-(f)er-(h)b(fgfe) ing:(e) she(f) hath(cf) the(f) joy(g) of(f) a(f)  |(gi) mo(gh) ther,(kijijkj) with(j) the(i) -(h)honour(g) of(ih) vir-(g)gi-(hg)ni-(f)ty;(f) before(f)  (h)  her(gi)  (g) none(h) hath(g) been(f) seen(gf) like(ef) her,(fe)  (c) nor(ef) shall(h) there(e)  LI(gi) be(gh) af-(f)ter,(fec) al-(e)le-(ef)lu-(f)ia.(f) e(h)  (g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-035.png",
        nextFileName: "./pages/part-a-036.png"
    },
    {
        title: "part-a-035-2",
        gabc: "T(c) he(e) An-(e)gel(i) g(i) e(i) T(i) the(h) e(i)  (kji) o(i) e(hi) R(k) ",
        groupIndex: 2,
        filename: "./pages/part-a-035.png",
        nextFileName: "./pages/part-a-036.png"
    },
    {
        title: "part-a-036-0",
        gabc: "I(i) bring(j) you(i) joy-(jkj)ful(i) tidings:(j)  (i) for(ig) un-(ji)to(i) you(h) is(hi) bop,(h)  this(f) day(gh) the(f) world(gh) s(f) Redeemer,(fe)  (d) al-(ef)le-(f)lu-(e)ia.(e) |(j)  (i)  (h)  (gi) ",
        groupIndex: 0,
        filename: "./pages/part-a-036.png",
        nextFileName: "./pages/part-a-037.png"
    },
    {
        title: "part-a-036-1",
        gabc: "[](e) was(ei) Twith(i) the(i) An-(h)gel(g) a(i) mul-(k)ti-(i)tude(i) of(h) the(g)  heavenly(j)  (j)  (i) host,(h) praising(j)  (ih) God,(h) and(fgh) say-(iji)ing,(hf) Glo-(g)ry(f)  8(e) God(fg) in(fg) the(ef) highest,(f)  (f) and(f) on(gh) earth(ijji) peace(efeded) to(def) men(g)  of(h) good(fe) will,(d) al(ef) \xb0(f) 1lu-(e)ia.(e) [(j) &amp;(i)  (h)  (gi)  U(c)  (f) to(fg) us(gh) this(fg)  (g) Child(g)  (gh) is(e) born,(fg) a(e) Son(f) is(e) given:(d)  (d)  [](c) his(d) Name(f) shall(fg) the(gff)  (g) mighty(hij)  (ji) God,(ghiih) al-(h)le-(g)lu-(e)18(f)  al(gh) le-(h)lu-(g)ia.(g) =(j) 1(i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-036.png",
        nextFileName: "./pages/part-a-037.png"
    },
    {
        title: "part-a-037-0",
        gabc: "he(f) Word(f) was(e) made(g) flesh,(h) Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f)  The(f) Word.(f) And(f) dwelt(f) a-(e)mong(g) us.(h) Al-(h)le-(hg)lu-(g)ia.(f)  \xa5.(c) Glory(f) S(f) be(f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h)  to(h) the(g) Ho-(h)ly(g) Ghost.(gf) The(f) Word.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-037.png",
        nextFileName: "./pages/part-a-038.png"
    },
    {
        title: "part-a-037-1",
        gabc: " (d)  (e)  (f)  (gh)  (d)  (efg)  (fe)  (e)  (g)  (hj)  (j)  (ji)   (hg)  (hi)  (i)  (i)  (h)  (hjk)  (j)  (ji)  (hg)  (h)  (gf)   (edffgh)  (d)  (e)  (f)  (gh)  (gf)  (g)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-037.png",
        nextFileName: "./pages/part-a-038.png"
    },
    {
        title: "part-a-038-0",
        gabc: "lo-(fgh) (g) to(g) God(h) in(g) the(h) highest,(h)  (gh) and(f) on(f) earth(f)  (e)  peace(ik)  (g) to(h) men(hj) of(gh) good(fgh) will,(hgf) al-(fh) (fe) le_lu_ia&#39;(d)  (ef) a1(ggh)  le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-038.png",
        nextFileName: "./pages/part-a-039.png"
    },
    {
        title: "part-a-038-1",
        gabc: "n(d) the(d) day(f) .(c) thy(d) pow-(dhi)er(h) shall(h) the(h) peo\u2014ple(h)  (hghihgg) \xa3f(f)  (g)  thee(h) free-(h)will(gf) of-(fh) (fe) fer\u2014ings(d) with(f) an(fg) ho-(fe)ly(cd) worship:(d) LR(c)  the(d) dew(f) of(f) thy(f) birth(ffg) is(f) of(gh) the(fe) womb(dc) of(d) the(efe) morning(d) -(d) i(h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-038.png",
        nextFileName: "./pages/part-a-039.png"
    },
    {
        title: "part-a-039-0",
        gabc: "T(c) he(e) Lord(e) hath(g) sent(hi) T(fh) re-(fg)demption(e) un-(h)to(h) his(f) people:(h)  (g)  he(i) hath(i) com-(h) (iji) ed(hghih) his(h) co-(f)ve(e) nant(ffh) for(gf) ev-(e)er.(e)  a(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-039.png",
        nextFileName: "./pages/part-a-040.png"
    },
    {
        title: "part-a-039-1",
        gabc: "U(gi) n-(gi)to(i) the(j) ](i) ](i) a-(ij) (i) ri-(i)seth(hih) up(hg) light(hf) in(gh)  the(hg) darkness:(e) _-(e)the(f) Lord(h) is(f) mer-(h)ci-(h)ful,(gf) loving,(ef) O(g) and(f)  righteous.(gi)  (e)  (e)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-039.png",
        nextFileName: "./pages/part-a-040.png"
    },
    {
        title: "part-a-039-2",
        gabc: "a(e) the(f) Lord(hhi) %(hi) is(jh) mercy,(i)  (i) and(ig) with(hg) him(fe) 1is(fe)  plent(d) eous(e)  (f) redemption.(h)  (f)  (f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-039.png",
        nextFileName: "./pages/part-a-040.png"
    },
    {
        title: "part-a-040-0",
        gabc: "O(f) the(h) fruit(j) |(i) thy(ihjhg) bo-(hg)dy(fh) shall(j) I(ig) set(i) up-(j)on(hi)  thy(h) seat.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-040.png",
        nextFileName: "./pages/part-a-041.png"
    },
    {
        title: "part-a-040-1",
        gabc: "T(c) he(fg) Word(fe) was(dc) made(fg) flesh,(hii) Al-(hij)le(ihgfe) lu-(gh)ia,(f) al-(dc)le(ifgiihgfe)  lu-(gg)ia.(f) The(fg) Word.(fe) And(ffgh) dwelt(fe)  (dc) us.(fg)  (i) Al(hhj)  le(iihgfe) lu-(fgh)ia.(f) .(c) Glory(f)  (f) be.(g) The(fg)  (fe) ",
        groupIndex: 1,
        filename: "./pages/part-a-040.png",
        nextFileName: "./pages/part-a-041.png"
    },
    {
        title: "part-a-040-2",
        gabc: "T(c)  (d)  (dh) the(hg) Christ(i) is(hg) born;(fh) to-(f)day(fg) hath(g) a(g) Saviour(g)  (h)  (g)  L(g) pear-(hgf)ed:(f) to-(f)day(gh) on(h) earth(hhg) An-(i)e(h) are(g) -(fh)singing(h)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-040.png",
        nextFileName: "./pages/part-a-041.png"
    },
    {
        title: "part-a-041-0",
        gabc: "\u2014(hg) Archangels(i)  (h) rejoicing:(g)  (fh)  (h) to-(h)day(jkjih) the(h) righteous(hgi)  (h) exult(g) =(fh)  and(h) say,(fgh) Glory(fgh)  (fe) to(d) God(ef) in(gh) the(g) highest,(fe)  (dc) al(d) le-(efe)lu-(d)ia.(d)   (h)  (g)  (f)  (gf)  (fgh) ",
        groupIndex: 0,
        filename: "./pages/part-a-041.png",
        nextFileName: "./pages/part-a-042.png"
    },
    {
        title: "part-a-041-1",
        gabc: "And(c)  (j) St:ephen,T(ih)  (g) full(fgh) of(fe) faith(d) and(ef) power,(gh)  (h) did(j) great(kj)  wonders(hj)  (g) and(gh) mir-(g)a-(fe)cles(d) a-(ef)mong(gh) the(h) people.(g)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-041.png",
        nextFileName: "./pages/part-a-042.png"
    },
    {
        title: "part-a-042-0",
        gabc: "stoned(c)  (gg)  (f)  (h)  (j) calling(ig)  (j)  (h) up-(g)on(g) the(g) Lord(h) and(g) say-(hg) ing,(f) s(fh) lay(j) not(i) this(j) sin(hf) to(gh) their(h) charge.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-042.png",
        nextFileName: "./pages/part-a-043.png"
    },
    {
        title: "part-a-042-1",
        gabc: "a(e) a(e) of(g) the(h)  (i) e(g)  (h) sweet(ij) un-(h)to(f) Stephen:(h)  (g)  him(i) doth(h) every(f)  (h) soul(gf) of(d) the(f) =(hf) righteous(gf) follow.(e)  (e) B(j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-042.png",
        nextFileName: "./pages/part-a-043.png"
    },
    {
        title: "part-a-042-2",
        gabc: "a(e) -(h)T(f) ](e) -(h)un-(f)to(h) thee,(g) for-(i)as-(i)much(hf) as(h) my(h)  flesh(gh) hath(f) been(e) ston-(gh)ed(f) for(e) thee,(h) 0(f) my(f) God.(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-042.png",
        nextFileName: "./pages/part-a-043.png"
    },
    {
        title: "part-a-042-3",
        gabc: "tephen(fg)  (g) Tsaw(f) the(hj) heavens(jji)  (h) O-(j)pen-(hg)ed;(g) he(g) saw,(h) and(fg) ",
        groupIndex: 3,
        filename: "./pages/part-a-042.png",
        nextFileName: "./pages/part-a-043.png"
    },
    {
        title: "part-a-043-0",
        gabc: "en-(gh)ter\u2019d(h) in:(g) how(hj) blessed(j)  (i) is(j) the(k) man(hg) un-(h)[(g) whom(ef)  heav\u2019&#39;n(gh) stood(h) o-(g)pen.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-043.png",
        nextFileName: "./pages/part-a-044.png"
    },
    {
        title: "part-a-043-1",
        gabc: "e-(f)hold,(h) T(hi)  (i) _\u2014\\\u2014(hi)  (j)  (h) o-(i)pen-(i)ed;(i) and(fi) Jesus(g)  (h)  -(ef)=(fe) on(d) the(e) right(fg) hand(h) of(hg) God.(f) e(i) &amp;(h)  (i) \u2014\u2014\u2014\u2014(j)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-a-043.png",
        nextFileName: "./pages/part-a-044.png"
    },
    {
        title: "part-a-043-2",
        gabc: "T(c) hou(f) hast(f) crowned(g)  (h) him(hg) With(g) glory(f)  (g) and(fgh) s(g) honour,(fd) O(fg) Lord.(gf)  Thou(f) hast(f) crowned.(g)  (gh) And(h) madest(hi)  (h) him(h) to(h) have(h) do-(h)min-(gh) ion(g) of(g) the(h) works(g) of(f) thy(gh) hands.(hg) With(g) glory.(f)  (g)  Glory(h)  (h) be.(h) Thou(f) hast(f) crowned.(g)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-043.png",
        nextFileName: "./pages/part-a-044.png"
    },
    {
        title: "part-a-044-0",
        gabc: "R(g) )(g) D(f)  (e)  (d) (a8(fhg)  (fg) =(g) [T(hjji)  (h)  (hg)  &quot;(h)  (ig) [(h)  (g) =\u2014\u2014\u2014\u2014===(f) =(g) &amp;(g) @(f)  (g) @(h) 20(j)  (g) e(hih)  \xa5.(h) Devout(h) men(ghg) a(e)  (f) Stephen(hg) to(fg) his(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-044.png",
        nextFileName: "./pages/part-a-045.png"
    },
    {
        title: "part-a-044-1",
        gabc: "nd(j) Stephen,(ih)  (g) full(fgh) of(fe) faith(d) and(ef) power,(h)  (h) did(j) great(j)  wonders(hj)  (g) and(gh) mir-(g)a-(fe)cles(d) &amp;(f) mong(gh) the(h) e(g) people.(g) a1(j)  (h)  (j) 1(k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-044.png",
        nextFileName: "./pages/part-a-045.png"
    },
    {
        title: "part-a-045-0",
        gabc: "T(c) hou(f) hast(gh) set(hg) Up-(f)on(f) his(gh) head,(gf)  (d) O(fg) Lord.(gf) Thou(f)  hast(ik)  (fh) set.(hg) A(hi) crown(g) of(f) pure(gh) gold.(hg) Up-(f)on(f) his(gh) head.(gfd)  Glory(h)  (h) be.(h) Thou(f) hast(fh) set.(hg) ",
        groupIndex: 0,
        filename: "./pages/part-a-045.png",
        nextFileName: "./pages/part-a-046.png"
    },
    {
        title: "part-a-045-1",
        gabc: ".(g) a(g) a(f)  (e)  (d) fa(fhg) a(fg) o(g) T(hjji) =(h) Jao(hg) =(h) |(ig)  TR(h)  (g)  (f) e(g)  (g) N(f) R(g)  (h)  (j) R(g)  (hih)  5.(h) Stephen(h) a(ghg) the(e)  (f) heavens(hg) opened.(fg)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-045.png",
        nextFileName: "./pages/part-a-046.png"
    },
    {
        title: "part-a-045-2",
        gabc: "D(c)  (fh) e\u2014vout(j) menfcar-(ig)ri-(j)ed(h)  (g) e(g) Stephen(g) to(h) his(g) bu-(ghg)ri-(f)al,(f)  \u2014\u2014\u2014(f) made(hj) great(ji) la-(jk)men-(h)ta-(h)tion(gf) o(fh) ver(h) him.(g) |(j) B(i)  (j)  (h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-045.png",
        nextFileName: "./pages/part-a-046.png"
    },
    {
        title: "part-a-046-0",
        gabc: "T(c) his(f) i.s(c) the(d) same(dhi) John,T(hh) who(h) leaned(h)  (h) on(h) the(h) Lord\u2019&#39;s(h)  bo\u2014som(h)  (hghihgg) at(g) the(f) last(fh) sup-(fed)per:(d) the(f) blessed(f)  (fe) A\u2014POStl.e&#39;,(def)  (dc)  (c)  whom(c)  (d)  (f) were(f) revealed(f)  (fg)  (f) the(f) secret(f)  (ef) thingsof(g)  (fe) heaven,(d)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-a-046.png",
        nextFileName: "./pages/part-a-047.png"
    },
    {
        title: "part-a-046-1",
        gabc: "nght(ik)  (d) worthy(dc) ;(f) of(g) honourt(fh)  (h) is(h) blessed(h)  (g) Yo,(i) the(h) A-(g) (fh) postle,(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-046.png",
        nextFileName: "./pages/part-a-047.png"
    },
    {
        title: "part-a-047-0",
        gabc: "who(g) leaned(g)  (g) on(g) the(g) Lord\u2019s(eg) bo\u2014som(hg)  (f) at(fg) the(e) last(fe) R(d) supper.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-047.png",
        nextFileName: "./pages/part-a-048.png"
    },
    {
        title: "part-a-047-1",
        gabc: "This(c)  (g) is(h) that(j) dis\u2014ci-(h) (j) ple(i) Twhich(h) tes-(g)ti-(h)fi-(h)eth(h) of(h) these(hg)  things:(g) and(g) we(g) know(i) that(h) his(h) tes-(j)ti-(i)mo-(g)ny(h) is(gf) true.(e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-047.png",
        nextFileName: "./pages/part-a-048.png"
    },
    {
        title: "part-a-047-2",
        gabc: "T(c) his(g) ismy(h)  (j) dis-(h)ci-(j)ple,f(i) if(h) I(g) will(h) that(i) he(h) tarry(g)  (g)  till(hf) T(gg) T(e) I(j)  (h) I\u2014_I(j) N(ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-047.png",
        nextFileName: "./pages/part-a-048.png"
    },
    {
        title: "part-a-047-3",
        gabc: "T(c) here(d) be(dc) some(fg) standing(f)  (gh) here(h) which(h) shall(hi) not(g) taste(f)  (g) ",
        groupIndex: 3,
        filename: "./pages/part-a-047.png",
        nextFileName: "./pages/part-a-048.png"
    },
    {
        title: "part-a-048-0",
        gabc: "of(ki)  (h) death(g) till(g) they(eg) see(h) the(g) Son(fg) of(f) man(ef) -(g)hjg(fe)  kingdom.(d)  (d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-048.png",
        nextFileName: "./pages/part-a-049.png"
    },
    {
        title: "part-a-048-1",
        gabc: ".e-(ikc) (cdc)  (f) hold,my(g) servant,&#39;f&#39;(fh)  (h) mine(h) e-(g)lect,(i) whom(h) I(g) have(g)  chosen:(ik)  (fh)  (g) I(g) have(eg) put(hg) my(fg) spi-(ec)rit(eg) up-(fe)on(d) him.(d) &quot;=(h)  (g)  (f) dp(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-048.png",
        nextFileName: "./pages/part-a-049.png"
    },
    {
        title: "part-a-048-2",
        gabc: "heir(f) sound(g) is(f) gone(gh) out(hg) In-(g)to(fd) all(fg) lands.(gf) Their(f)  sound.(g) And(h) their(h) words(hi) in-(h)to(fh) the(g) ends(gf) of(g) the(gh) world.(hg)  In-(g)to.(fd) Glory(h)  (h) be.:(h) Their(f) sound.(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-048.png",
        nextFileName: "./pages/part-a-049.png"
    },
    {
        title: "part-a-049-0",
        gabc: ":(g)  (g) A(f)  (e)  (d) &amp;(fhg) &amp;(fg) &amp;(g) I(hjji) SN(h) &quot;(hg) ORI(h)  :(ig) &amp;(h)  (g) -(f)&amp;(g) &amp;(g) &amp;(f)  (g) &quot;(h)  (j) a(g) &quot;(ihih)  V.(h) This(h) is(ghg) a(e) disciple(f)  (hg) which(fg)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-049.png",
        nextFileName: "./pages/part-a-050.png"
    },
    {
        title: "part-a-049-1",
        gabc: "his(f) is(c) the(d) same(idhi) John,(hh) who(h) leaned(h)  (h) on(h) the(h) Lord\u2019s(h)  bo(h) som(hghihgg) at(g) the(f) last(gh) sup-(fed)per:(d) the(f) bless\u2014ed(f) |(fe)  A-(def)pos-(dc)((c) [](c) to(d) whom(f) were(f) revealed(f)  (fg)  (f) the(f) se-(f)cret(def)  things(g) \u2018of(fe) hea-(d)ven.(d) *(h) o(g) _(f) \xa2(gh) &amp;(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-049.png",
        nextFileName: "./pages/part-a-050.png"
    },
    {
        title: "part-a-050-0",
        gabc: "hou(f) shalt(f) .(g) them(f) princes(gh) :(hg) In(fd) all(fg) lands.(gf) Thou(f)  shalt(jk)  shalt(f) make.(g) They(hi) shall(h) re-(h)T(gh) R(g) thy(gf) ey(g)  (gh) OLord,(hg)  .(df) all(fg) lands.(gf) Glory(h)  (h) be.(h) Thou(f) shalt(f) make.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-050.png",
        nextFileName: "./pages/part-a-051.png"
    },
    {
        title: "part-a-050-1",
        gabc: "T(c) here(f) went(efddc) this(d) saying(fg)  (f) a-(f)broad(g) a-(h)mong(gh) the(h) s(fgf) brethren,(f)  that(f) that(fg) dis(f) ci(giih) ple(gh) should(f) not(ef) die:(f) yet(f) -(gh)sus(f)  said(g) not(f) un\u2014to(f) LR(e) him,(df) He(gh) shall(f) not(ef) die;(f) .(c) If(d) I(f)  will(fg) that(f) he(f) tar-(fhihg)ry(hg) till(fg)  (gf) I(h)  (hg) come.(fgf)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-050.png",
        nextFileName: "./pages/part-a-051.png"
    },
    {
        title: "part-a-051-0",
        gabc: "These(c)  (dh) are(hi) t(hghihgg) which(f) were(g) not(h) de_fil-(g) (h) ed(g) with(f) women;(f)  (d)  for(g) they(g) are(g) virgins:(hgf)  (f) and(e) they(f) follow(g)  (f) the(fe)  (ddc)  whither-(d)[](c) ev-(d)er(f)  (e) he(fgf) goeth.(d)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-a-051.png",
        nextFileName: "./pages/part-a-052.png"
    },
    {
        title: "part-a-051-1",
        gabc: "He-(d)rod(dc) was(f)  (g) exceeding(f)  (gh) wrot.h,&#39;f(h) and(h) slew(ih) ma-(g)ny(g) chil-(fh) dren(g) in(g) N(g) Bethlehem(e)  (g) Ju-(hg)dah,(fg) the(ec) =(e) ty(g) of(e) Da-(fe)vid.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-051.png",
        nextFileName: "./pages/part-a-052.png"
    },
    {
        title: "part-a-052-0",
        gabc: "F(c) rom(f) two(g) years(h) old(i) and(g) un-(gh)der,(f) did(f) He-(h)rod(g) slay(hi) a]j(f)  the(gi)  (h) male(gh) children,(ff)  (e) for(e) the(f) sake(hg) of(e) the(g) Lord.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-052.png",
        nextFileName: "./pages/part-a-053.png"
    },
    {
        title: "part-a-052-1",
        gabc: "T(ki~)  (c)  (c) heir(fh) AngelsTdo(g)  (gf)  (f) al-(hf~)ways(j) be-(i)hold(hj) the(i) face(g) of(h) my(h)  Fa(g) ther.(g) -(j) (i) &quot;(j)  (h) a7(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-052.png",
        nextFileName: "./pages/part-a-053.png"
    },
    {
        title: "part-a-052-2",
        gabc: "I(hcgi) n(ff) Ra-(e)ma(f) there(g) was(h) heard(i) a(hg) T(f) e(e) voice,(f) la\u2014men\u2014ta\u2014tion(h) Y(h) and(fh)  [(g) a(g) &quot;(f) &amp;(e) e(e) [(ge) chel(f) weeping(h)  (g) for(ef) her(hg) &amp;(f) children.(f)  &amp;(gi)  (h)  (g)  (e)  (g)  e(g) neath(ihij) the(i) al-(g) (g) tarTall(g) the(g) e(ghggh) do(fh) cry(jj) a-(j)loud:(jkjh) ",
        groupIndex: 2,
        filename: "./pages/part-a-052.png",
        nextFileName: "./pages/part-a-053.png"
    },
    {
        title: "part-a-053-0",
        gabc: "Shall(jj) not(j) our(jkjh) blood(j) be(h) a-(h)ven-(hg)ged,(f) O(gh) our(h) Cod.(g)  .(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-053.png",
        nextFileName: "./pages/part-a-054.png"
    },
    {
        title: "part-a-053-1",
        gabc: "Be(f) glad,(g) O(f) ye(f) L(gh) righteous,(hg) And(f) re-(gh)joice(gf)  (d) in(f) the(g) Lord.(gf)  Be(f) glad.(g) And(hi) be(h) joy-(h)ful,(g) all(g) ye(h) that(g) are(f) true(g)  of(gh) heart.(hg) And(f) T,(fgh) joice.(gfd) Glory(h) v(h) be.(h) N(f) glad.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-053.png",
        nextFileName: "./pages/part-a-054.png"
    },
    {
        title: "part-a-053-2",
        gabc: ".(c)  (d)  (eg)  (gf)  (ed)  (f)  (edc)  (d)  (ce)  (g)  (gh)  (h)  (hg)   (gj)  (ihg)  (h)  (hj)  (g)  (gf)  (e)  (dc)  (d)  (de)  (e)  (c)  x.(c)  (d)  (eg)  (gf)  (ed)  (f)  (edc)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-a-053.png",
        nextFileName: "./pages/part-a-054.png"
    },
    {
        title: "part-a-054-0",
        gabc: "hese(dh) are(hi) they(hghihgg) which(f) were(g) not(h) de-(g)fil-(h)ed(g) with(f) Wo-(g) (gf) nep,(d)  for(g) they(g) are(g) vir-(hgf)gins:(f) and(e) they(f) ](g) follow(f) the(fe) La;mb(ddc)  whither-(d)a(c) ev-(d)er(f)  (e) he(fgf) goeth.(d)  (d)  (h)  (g)  (f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-054.png",
        nextFileName: "./pages/part-a-055.png"
    },
    {
        title: "part-a-054-1",
        gabc: "et(f) the(f) \u201C(g) righteous(f) re-(gh)L(hg) \xa5(fd)  (fg) T(gf) Let(f) the(f)  (g)  .(g) righteous.(f) Let(hi) them(h) al-(fgh)so(g) be(g) merry(h) ,(g) and(f) joyful.(gh)  (hg)  Be-(fd)fore(fg) God.(gf) Glory(h)  (h) be.(h) Let(f) the(f) righteous:(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-054.png",
        nextFileName: "./pages/part-a-055.png"
    },
    {
        title: "part-a-055-0",
        gabc: "hen(e) were(f) in-(h)no-(i)cent(g) childrenT(h)  (f) slain(f)  (fe) in-(h)stead(f) of(eh)  Christ(gi)  (hiih) by(h) a(i) wick-(j)ed(h) ru-(ih)ler;(f) the(e) ve-(ef)ry(fe) [](hg) sucklings(hi)  were(gi)  (h) put(f) to(ef) death:(f) spotless,(f)  (fe) [(c) follow(fe~)  (f) a(hg) Lamb(f)  himsel(gi)  (eh)  (hiih) and(hihij) say(j) for(ih) ev-(ih)er:(f) Glory(f)  (f) be(hg) to(hih) thee,(f)  0(gi)  (ef) Lord.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-055.png",
        nextFileName: "./pages/part-a-056.png"
    },
    {
        title: "part-a-056-0",
        gabc: "hile(gd) all(fgh) thlngsTwere(g)  (gd) in(fg) qui-(h)et(fe) silence,(def)  (f) and(dg) that(fg)  night(h) e(g) in(h) the(g) midst(hj) =(hj) her(h) swift(gf) &quot;-(g)thine(g) A]_(g)  mighty(f)  (f) .(cd) O(fgh) Lord,(h) leaped(f)  (g) down(fgh) out(f) a(e) thy(d) royal(h)  (ij)  throne,(hgf) al-(gh)le-(h)lu-(g)1ia.(g) [(j) &quot;(i)  (j)  (h) a(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-056.png",
        nextFileName: "./pages/part-a-057.png"
    },
    {
        title: "part-a-056-1",
        gabc: "he(f) Child(cf) Je\u2014sus(df)  (ffg) Tincreased(df)  (fgh)  (h) in(h) wisdom(hj)  (h) and(fg) sta-(fghgf)ture(fggf)  in(f) the(f) sight(fg) of(df) God(d) and(cf) man.(f)  (h)  (f)  (h)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-056.png",
        nextFileName: "./pages/part-a-057.png"
    },
    {
        title: "part-a-057-0",
        gabc: "od,(gff) for(d) his(fg) great(hg) love(hghihgg) wherewith(fh)  (ji) he(hg) lov_ed(hi)  (hg) us,(g)  hath(hf) sent(h) his(f) own(g) Son(ffdefedc) in(d) the(f) T&quot;(hg) likeness(fg) of(g) sin-(ij)ful(h)  flesh,(hgf) al-(hg)le-(h)lu-(g)ia.(g) LAUDS(j) g(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-057.png",
        nextFileName: "./pages/part-a-058.png"
    },
    {
        title: "part-a-057-1",
        gabc: "wondrous(efddc)  (gf~)  (gf) in-(g)I(ghg) \u2014(f) The(f) Cre-(f)a-(g)tor(fe) of(g) man-(gh) kind,(f) taking(f)  (f) up-(f)on(fhihg) him(g) a(g) living(i)  (h) bo-(g)dy,(f) vouchsafed(f)  (g)  (f)  to(f) be(f) born(g) of(f) a(f) Vir-(fhihg)[(hg) and(g)  (g) proceeding(h)  (g) forth(fg) as(f)  Man,(fe) without(df)  (fe) seed,(cd) hath(cd) made(fg) us(f) partakers(f)  (gh)  (g) of(hj) bhis(hg)  Di_vi_ni_ty.(hg)  (f)  (f)  (f) 103(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-057.png",
        nextFileName: "./pages/part-a-058.png"
    },
    {
        title: "part-a-058-0",
        gabc: "W(c) hen(de) thou(g) wast(jh~) bornT_in\u2014ef-(j) (h) fa\u2014bly(j)  (i)  (h) of(gf) a(gh) Virgip,(hg)  (g)  then(gh) were(i) the(j) Scriptures(h) .(gf) =(gh) fulfilled:(e) &amp;(e) thou(h) camest(j)  (i) down(jjk)  like(j) the(i) rain(j) in-(h)to(h) a(g) fleece(i) of(j) wool,(h) to(h) bring(j) sa]_(i)  va-(ji)tion(gh) un-(h)to(gf) all(g) mankind:(gh)  (e) we(hi) praise(g) thee,(ef) 0(g) &amp;(ghg)  God.(e)  (ji)  (hi)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-058.png",
        nextFileName: "./pages/part-a-059.png"
    },
    {
        title: "part-a-058-1",
        gabc: "n(d) the(ef) bush(g) twhich(g) -(gfdefg)ses(fe) saw(e) un-(d)con-(fe~)sum-(g)ed,(g) we(g)  a(g) acknowl(g) edge(f) the(gh)  (h) preservation(gh)  (e)  (e) of(dh) thy(hg) glo-(hi)ri-(h)ous(h) vir-(fg) gi-(g)ni-(gf)ty:(e) ho-(h)ly(gf) Mother(g)  (e) of(ef) God,(d) intercede(f)  (g)  (h) for(g) thy(f)  an(gg) children.(e)  (h)  (g)  (h)  (ji)  (hg)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-058.png",
        nextFileName: "./pages/part-a-059.png"
    },
    {
        title: "part-a-059-0",
        gabc: "T(c) he(d) Root(e) of(f) Jes-(g)sel(e) hath(ghfe) bud-(d)ded:(dfddc) the(dc) Star(f) hath(g)  come(h) out(f) of(g) Ja\u2014cob:(g)  (f) a(g) Virgin(h)  (g) hath(f) borne(f) the(f) Sa-(fgfd) :(d) we(gh) praise(ffe) thee,(ce) 0(ge) our(fe) God.(d) &quot;(h) =(g) \xa5(f)  (fh) pll(gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-059.png",
        nextFileName: "./pages/part-a-060.png"
    },
    {
        title: "part-a-059-1",
        gabc: "L(gi) 0,(df)  (h)  (h) brought(h)  (hg) forth(f) to(ed) us(e) the(ef) Sa-(d)viour;(d)  whom(d) when(e) John(f) be-(e)held,(f) he(df) cri-(h)ed(fh) saying:(f)  (f) Fe-(f)hold(h)  the(g) Lamb(h) of(gf) God,(fe) which(d) &#39;:tmw(f) taketh(e) a-(d)way(f) theTsin(de)  (fee) of(d)  ](e) R(ed) al(def) i(ed) =(de) TP(d) |(h) \u2014\u2014a(i) I(g)  (h) -(fh) -(dcc)of(c) the(c)  fs1n(f) of(d) the(d) world,(d)  he(f) Lord(f) a(e) declared(g) *(h) Al(h) -(hg)lu-(g)ia,(f) al(d) -(fg)lu-(gf)ia.(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-059.png",
        nextFileName: "./pages/part-a-060.png"
    },
    {
        title: "part-a-060-0",
        gabc: "The(f) Lord.(f) His(f) sal-(e)va-(g)tion.(h) B.(h)  (hg) [(g)  (f)  \xa5(ik) Glory(f)  (f) be.(f) The(f) Lord.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-060.png",
        nextFileName: "./pages/part-a-061.png"
    },
    {
        title: "part-a-060-1",
        gabc: " (ki~)  (d)  (e)  (f)  (gh)  (d)  (eg)  (fe)  (e)  (g)  (hj)  (j)  (ji)  .(i)  (hg)  (hi)  (i)  (i)  (h)  (hjk)  (j)  (ji)  (hg)  (h)  (gf)  V.(ik)  (edfgh)  (d)  (e)  (f)  (gh)  (gf)  (g)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-060.png",
        nextFileName: "./pages/part-a-061.png"
    },
    {
        title: "part-a-060-2",
        gabc: "great(c)  (g)  (g) and(f) wondrous(f)  (d) my-(f)ste-(e)ry(df) Tis(f) made(g) known(h) to(g)  us(hj) this(gh) day;(h) L(g) new(g) thing(f) is(h) wrought(j) in(k) both(i)  na-(j)tures:(h) God(g) is(f) made(gh) man;(g) that(g) A(gf) was,(h) P(gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-060.png",
        nextFileName: "./pages/part-a-061.png"
    },
    {
        title: "part-a-061-0",
        gabc: ".(gg) mained,(d) and(d) .(c) which(d) was(ff) not,(f) he(fe) as-(d)sum-(f) (hg) ed;(h) suf-(j) fering(j)  (j) no(k) confusion,(i)  (j)  (h) nor(hf) yet(hj) di-(i)vi-(g)sion.(g)  (j) &quot;(i)  (j) a](h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-061.png",
        nextFileName: "./pages/part-a-062.png"
    },
    {
        title: "part-a-061-1",
        gabc: "T(fefhihgff) is(g) e(e) my-(f)ste-(h)](hg) of(f) the(e) in(f) he(fhihgfgf) ritance:(ef) .(f)  the(f) womb(h) of(i) her(j) that(i) knew(j) not(hg) man(f) is(h) be-(hg)come(f) the(e)  temple(f)  (g) of(h) the(g) Godhead:(f)  (f) by(f) taking(ef)  (f) flesh(fh) of(f) her,(f) he(ef)  was(f) no(fhg) 0(e) de-(eg)fil-(f)ed:(f) all(fefe) the(df) nations(hhi)  (h) shall(i) Ta(hg) gather,(fe)  H(fe) RO(d) Glory(f) PR(ed) be(e) to(f) thee,(fghihgfgf) O(ef) Lord.(f) O(h)  (g) T(e) ey(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-061.png",
        nextFileName: "./pages/part-a-062.png"
    },
    {
        title: "part-a-062-0",
        gabc: "ho-(g)so-(gd)ev-(fg)er(g) shall(hg) call(h) on(f) the(h) Name(ji) of(hi) the(h) Lord(g)  shall(gfd) be(fg) saved.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-062.png",
        nextFileName: "./pages/part-a-063.png"
    },
    {
        title: "part-a-062-1",
        gabc: "H(c)  (cffe) 1ly(f) and(df) rev-(hhi)er-(h)end(h) is(ikj) his(ih) Name:(ijih) the(i) fear(hi) of(f) the(e)  Lord(f) is(d) e(e) be-(f)=(fh) ning(fe) of(edf) wisdom.(d)  (d) I(h) =(i)  (g) &amp;(h) o(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-062.png",
        nextFileName: "./pages/part-a-063.png"
    },
    {
        title: "part-a-062-2",
        gabc: "et(ed) I(g)  (hj) in(ij)  (k)  (ij) the(hji) Lord,(hg) I(g) will(de) joy(ghg) .(hg)  God(hgf) my(gf) e(e) Jesus.(e) et(j)  (ji) \xb0(hi) &quot;-(h)w(gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-062.png",
        nextFileName: "./pages/part-a-063.png"
    },
    {
        title: "part-a-062-3",
        gabc: "From(c)  (c) .(c) the(d) rising(dhi)  (h) of(h) the(h) sun(hghihgg) even(f)  (g) unto(h)  (g) the(f) go1ng(e)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-a-062.png",
        nextFileName: "./pages/part-a-063.png"
    },
    {
        title: "part-a-063-0",
        gabc: "down(g) of(f) the(e) same,(ddc) the(ef) Lord\u2019s(g) Name(f) be(fe) prais-(d)ed.(d)  SHORT(h)  (g)  (f)  (h)  (g)  O(f) help(f) standeth(g)  (f) in(f) the(f) Name(f) of(e) the(g) lord,(h) Al-(h)le(hg)  lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) Our(f) help.(f) Who(f) hath(f) made(g) hea-(f) a(e) and(g) earth.(h) Al-(h)le-(hg)lu-(g)ia.(f) V.Glory(f)  (f) he.(f) RQur(f) help.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-063.png",
        nextFileName: "./pages/part-a-064.png"
    },
    {
        title: "part-a-063-1",
        gabc: "For(c)  (j) he(ji) that(hg) is(hi) mightyt(h)  (g) hath(g) mag-(g)ni-(eg)fi-(f)a(e) me,(f) and-(d) ](e) ly(f) is(gh) his(h) Name,(g) al(f) -(fg)lu-(g)ia.(g)  (j) .(h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-063.png",
        nextFileName: "./pages/part-a-064.png"
    },
    {
        title: "part-a-064-0",
        gabc: "Thy(c)  (d) Neme(dc) is(f) as(g) 01nmentTpour-(fh) (h) ed(hg)  (ih) forth,(g) there(h) ](g)  a(e) the(f) ](g) virgins(fe) love(d) thee.(d)  (h) ](g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-064.png",
        nextFileName: "./pages/part-a-065.png"
    },
    {
        title: "part-a-064-1",
        gabc: "ye(g)  (hj) that(j) the(h) LordThe(ji)  (h) is(hi) God:(g) his(ig) -(h)is(hi)  a(ik)  (g) er-(gf)last-(e)ing.(e) 1.(j) e(h) &amp;(j) R(ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-064.png",
        nextFileName: "./pages/part-a-065.png"
    },
    {
        title: "part-a-064-2",
        gabc: "My(i)  (cefg) soul(ddc) thirsteth(df)  (e) a(g) thy(h) ___l(h) ly(gf) Name,(g) O(ghg) Lord.(e)   (ik)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-064.png",
        nextFileName: "./pages/part-a-065.png"
    },
    {
        title: "part-a-064-3",
        gabc: ".(c) lessed(d) .(fg) the(g) Name(i)  (hi) Tof(h) thy(gf) glo-(gh)ry,(g) and(h) ho-(h).(g) and(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-064.png",
        nextFileName: "./pages/part-a-065.png"
    },
    {
        title: "part-a-065-0",
        gabc: "worthy(g)  (f) to(g) be(gh) praised,(f)  (d) and(fg) mag-(h)ni-(g)fi-(ef)ed(gh) for(h) ev-(g)er.(g)   (g)  (d)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-065.png",
        nextFileName: "./pages/part-a-066.png"
    },
    {
        title: "part-a-065-1",
        gabc: "Ym_mg(dh) men(h) and(j) maidens,T(hg)  (h) old(hge) men(fg) and(f) children,(d)  (d) praise(fg)  (g)  the(g) Neme(h) of(g) the(f) Lord,(fghghih) for(h) his(gh) Name(jj) on-(h) (hg) ly(hg) 1is(ef)  .(g) cel-(fe)lent.(d)  (h)  (g)  (f)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-065.png",
        nextFileName: "./pages/part-a-066.png"
    },
    {
        title: "part-a-065-2",
        gabc: "Blessed(g)  (f) be(f) o(f) Name(f) a(e) the(g) Lord,(h) Al-(h)le-(hg)lu-(g)ia,(f)  al(d) le(fg) _lu\u2014ia.(gf)  (f) Rlessed.(g)  (f) From(f) this(g) time(f) forth(f)  a(e) a(g) i(g) evermore.(h) &quot;(h) Alleluia.\xae.(hg)  (g)  (f) Glory(f)  (f) be.(f) Blessed.(g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-065.png",
        nextFileName: "./pages/part-a-066.png"
    },
    {
        title: "part-a-066-0",
        gabc: "[](ig~)  (c)  (f) a(h) :(g)  (f) L(g)  (fe)  (f)  (f)  (h)  (i)  (j)  a(h)  (i) a(i)  (j)  (h)  (j) a(i)  (ji)  (h)  (i) .(hg) .(f)  a(hgi)  (c)  (f)  (h)  (g)  (f)  (g)  (fe)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-066.png",
        nextFileName: "./pages/part-a-067.png"
    },
    {
        title: "part-a-066-1",
        gabc: "H(gi) e(e) gave(eh) himself(fe)  (f) that(e) he(e) might(f) de-(ed)liv-(e)er(f) his(f) people,(de)  (d)  (d)  and(ig~)  (d) get(fh) him(hi) a(g) per-(g)pe-(ij)tu-(h)[(h) &amp;(e) T(fgh) le-(fgf)e(e) wf(e)  a(ghi)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-066.png",
        nextFileName: "./pages/part-a-067.png"
    },
    {
        title: "part-a-067-0",
        gabc: "Thou(c) a(c) shalt(d) call(dhi) his(h) |(jh) Je-(h)sus,(hghihgg) for(g) he(f) shall(g) save(h)  (g)  bis(gf) peo-(g)ple(deef) from(g) their(fe) sins,(dc) al(d) le(efe) lu-(d)ia.(d) RO(h)  (g) LN(fghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-067.png",
        nextFileName: "./pages/part-a-068.png"
    },
    {
        title: "part-a-067-1",
        gabc: "e-(df) (h) the(f) An-(h)gel(g) of(e) the(g) Lord(fed) T(e) appeareth(f)  (de) in(e) a(d)  dream(e) to(f) Jo-(h)seph,(j) saying:(h)  (h) A-(f)rise,(hi) and(g) take(i) the(h)  young(gh) Child(ef) and(f) his(ef) Mother,(d)  (d) and(f) flee(hgf) in-(i)to(g) E(h) gypt,(f)  and(h) be(i) thou(j) there(k) un-(ij)til(hg) I(fg) bring(hi) thee(i) word;(h) for(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-067.png",
        nextFileName: "./pages/part-a-068.png"
    },
    {
        title: "part-a-068-0",
        gabc: "it(i) shall(h) come(fgh) to(fe) pass,(f) that(de) He-(fg)rod(f) wil](e) seek(feffge) A(e)  young(gf) Child,(eg) to(hg) destroy(e)  (d) him.(d)  (h) I\u2014h(i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-068.png",
        nextFileName: "./pages/part-a-069.png"
    },
    {
        title: "part-a-068-1",
        gabc: "ut(g) when(gj) Berod(h)  (g) was(hj) dead,T(j) -(j)bekold,(i) an(j) @(k) gel(ji) o(h) the(g)  (h)  B(jk)  Lord(h)  Lord(h) appeareth(g)  (h)  (i) in(j) a(h) dream(j) to(i) Jo-(ghig)sepk(h) in(ge) E-(fg)gynt,(gh)  say-(gfd)ing:(d) A-(g)rise,(gh) and(j) take(h) the(g) young(ij) Child(jk) and(ij) his(hg)  (h)  Mo-(hji)ther,(i) and(ji) zo(kj) in-(j)to(h) the(g) land(h) of(hi) Is-(ge)ra-(f)el;(ed) for(d)  (d)  t}Tey(dh) are(hj) dead(h) which(g) sought(g) the(d) young(ef) Child\u2019s(ghg) life.(e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-068.png",
        nextFileName: "./pages/part-a-069.png"
    },
    {
        title: "part-a-069-0",
        gabc: "hen(dg) Jo-(fe)seph(fg) heard(gh) Tthat(h) Ar-(g)che-(h)la-(g)us(g) did(g) reign(gh) in(ge)  Ju-(g)dae-(fed)a(defghhg) in(g) the(gh) room(hgf) of(g) his(h) fa-(ij)ther(h) Herod,(g)  (g)  he(g) was(gj) a-(j)fraid(ji) to(hj) go(ji) thither;(hg)  (g) and(h) be-(h)ing(h) warn-(gh)ed(g)  in(f) a(g) dream,(gh) he(f) turned(hj)  (j) a-(k)side(ji) in-(h)to(i) the(h) parts(g) of(hi)  Ga-(h)li-(g)lee:(g) and(i) he(j) came(h) and(g) dwelt(hg) in(d) a(ef) ci-(g)ty(h)  (g)  which(g) was(f) called(gh)  (g) Na-(f)za-(ff)reth;(defedc) that(c) it(d) might(fd) be(f) ful-(e) (f)  filled(gf)  (g) which(g) [(e) spoken(f)  (g) by(h) the(gf) prophets,(gh)  (h) He(g) shall(h)  be(ji) call-(hg)ed(ghg) a(f) Na(hg) -(fg)za-(g)E(j) I(i)  (j)  (h) ||(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-069.png",
        nextFileName: "./pages/part-a-070.png"
    },
    {
        title: "part-a-070-0",
        gabc: "All(f) they(gh) from(f) Sheba(fe)  (dc) shall(fg) come,(i) Al-(hij)1le(ihgfe) -(h)ia,(f) [\xa7]-(d) le(fgiihgfe) lu-(gg)ia.(f) All(f) they.(gh) \xa5.(c) They(fg) shall(f) bring(gh) gold(fe) {ng(cd)  incense.(fg)  (i) Al-(hij) (i) le(ihgfe) lu-(gh)ia.(f) Glory(f)  (f) be.(g) RZALL(f) they.(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-070.png",
        nextFileName: "./pages/part-a-071.png"
    },
    {
        title: "part-a-070-1",
        gabc: "An(c)  (f) they(g) from(f) Sheba(f) a2(e) shall(g) come,(h) Al(h) \u2014le-(hg)lu-(g)ia,(f) al-(d) le-(fg)lu-(gf)ia.(f) All(f) they.(g) \xa5.(c) They(f) shall(f) bring(g) gold(f) and(e)  (X(g) incense.(h) Al-(h)le-(hg)lu-(g)ia.(f) be.(f)  (f)  (f) B?&#39;All(f) \xa2(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-070.png",
        nextFileName: "./pages/part-a-071.png"
    },
    {
        title: "part-a-071-0",
        gabc: "a(d)  (e)  (f) -(gh) (d) |(eg)  (fe) A(e) ](g) (B(hj)  (j) -(ji) \xa2(hg) O(hi)  (i)  (i) e(h) S(hjk)  (j) S(ji) (B(hg)  (h) -(gf) (edfh)  O(d)  (e) This(f)  (fh) melody(gf) is(g) usad(f) at(e) ",
        groupIndex: 0,
        filename: "./pages/part-a-071.png",
        nextFileName: "./pages/part-a-072.png"
    },
    {
        title: "part-a-071-1",
        gabc: "The(gd) wise(ffh) ](g) men,(gh) beholding(hgf)  (fh) the(h) star,(g) said(hj) one(h) to(g) an-(f)o-(gh) (g)  This(jj) is(k) the(j) sign(j) of(i) a(h) mighty(ji)  (hg) King;(g) forth(d) fare(fgh) we,(g)  and(g) let(hi) us(gh) seek(g) him:(f) and(h) let(f) us(hj) of-(j)fer(i) him(h) gifts,(ghg) ](e)  gold,(ef) incense(hg)  (h) and(h) myrrh,(gfd) al-(ef)le-(fg)lu-(g)ia.(g) M-(j)1(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-071.png",
        nextFileName: "./pages/part-a-072.png"
    },
    {
        title: "part-a-072-0",
        gabc: "Before(gi)  (f) -(fg)a(e) morning(fij)  (h) star(g) a(e) begot.ten,T(gh)  (f) and(ef) Lord(h) frop(ij) .(ji)  erlasting,(h)  (hgf)  (gf) our(f) Saviour(h)  (g) is(h) made(f) ](g) ni-(ef)fedt(fgeec) Un-(fe)tg(h)  the(ig~)  (g) world(e) to-(h)day.(f) ](h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-072.png",
        nextFileName: "./pages/part-a-073.png"
    },
    {
        title: "part-a-072-1",
        gabc: "Ty(f) light(ghg) is(hg) come,(fgf) _I-(g)Je-(fe)ru-(d)sa-(defede)lem,(ed) and(d) the(d) glo(dgfh) r(gf)  of(gh) the(h) Lord(ghg) is(f) ri-(ghg)sen(hg) up-(ghge)on(f)  (hg) thee:(hg) and(g) the(f) Gen(g)  tiles(fe) shall(d) .(fgf) to(fe) thy(de) light,(ddc) al(def) le(fed) _\u2014I_I(de) ia.(d) T(h)  (g) adi](fg)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-072.png",
        nextFileName: "./pages/part-a-073.png"
    },
    {
        title: "part-a-072-2",
        gabc: "W(cc) hen(f) they(h) had(g) o-(h)L(g) @(g) @(f) @(g) e(d)  (hih) -(gh)men(jk)  presented(jkj)  (ij)  (g) un-(ji)to(i) the(i) Lord(h) gold,(h) frankincense,(g)  (h) [(e) and(f) ",
        groupIndex: 2,
        filename: "./pages/part-a-072.png",
        nextFileName: "./pages/part-a-073.png"
    },
    {
        title: "part-a-073-0",
        gabc: "myrrh,(ghg) al(h) le(gf)  (fe) lu-(d)ia.(d)  (h)  (g)  (f)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-073.png",
        nextFileName: "./pages/part-a-074.png"
    },
    {
        title: "part-a-073-1",
        gabc: "()(fd) ve(f) seas(g) and(f) floods,(efg)  (gf) bless(ef) ye(gh) the(h) Lord:(g) O(g) vye(g)  wells,(ij) sing(h) a(g) hymn(ge) un-(g)to(f) the(e) Lord,(d) al(f) \u2014le~-(fg)lu-(e)ia.(e)  -(h) (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-073.png",
        nextFileName: "./pages/part-a-074.png"
    },
    {
        title: "part-a-073-2",
        gabc: "Like(c)  (g) a(h) flame(i) of(j)  (i) that(i) star(i) glittereth(j)  (h)  (i) yonder,(h)  (g)  revealing(h)  (ij)  (i) God,(hg) the(ef) King(hf) of(gf) kings:(e) the(e) wise(ghji) men,(hihg)  when(f) they(h) beheld(g) a(e) it,(f) a(e) M(d) ](ef) presents(h) o(e) un-(f)to(e) the(d)  mighty(ef)  (f) Ruler.(e)  (e)  (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-073.png",
        nextFileName: "./pages/part-a-074.png"
    },
    {
        title: "part-a-074-0",
        gabc: "\u2014\u2014(f) kings(f) of(f) Tharsis(g)  (f) and(f) of(f) the(f) isles(f) shall(f) give(e) e(d)  presents,(g)  (h) Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ig,(f) The(f) kings,(f)  V.(c) The(f) kings(f) of(f) A-(f)ra-(g)bi-(f)a(f) and(f) Sa-(f)ba(f) shell(e) bring(g)  gifts.(h) Al-(h)le-(hg)lu-(g)ia.(f) i.Glory(c)  (f)  (f) be.(f) The(f) kings.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-074.png",
        nextFileName: "./pages/part-a-075.png"
    },
    {
        title: "part-a-074-1",
        gabc: "a4(g) s(g) a(f)  (e)  (d)  (fhg)  (fg)  (g)  (hjji)  (h)  (hg)  (h)  (@(ig) =(h) &amp;(g)  (f) e(g)  (g) g(f)  (g)  (h)  (j)  (g)  (hih)  \xa5.(h)  (h) 5(ghg)  (e)  (f)  (hg)  (fg) |(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-074.png",
        nextFileName: "./pages/part-a-075.png"
    },
    {
        title: "part-a-074-2",
        gabc: "o-(f) (fg) the(hij) Church(ji) is(hg) joined(h)  (g) to(i) her(j) heavenly(h)  (gf) Bride-(gh) (ggh) ",
        groupIndex: 2,
        filename: "./pages/part-a-074.png",
        nextFileName: "./pages/part-a-075.png"
    },
    {
        title: "part-a-075-0",
        gabc: "groom;(g) because(f)  (g) 1n(jg~) Jordan(jjk)  (j) Christ(j) hath(j) washed(k)  (j) a-(j)way(ji) her(hj)  of-(jk) (ji) fences:(g) the(h) wise(ji) men(g) with(h) their(i) offerings(j)  (h)  (j) hasten(ih)  (g)  \u2018to(g) the(g) roy-(h)al(ig) marriage;(hg)  (f) and(g) the(h) guests(g) are(f) re-(h)gal-(jj)ed(hih)  with(g) water(hj)  (g) made(ef) wine,(d) al-(ef)le-(fg)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-075.png",
        nextFileName: "./pages/part-a-076.png"
    },
    {
        title: "part-a-075-1",
        gabc: "Now(c)  (d) do(c) we(def) ce(fgfeded) le-(cd) (d) Tla(dc) ho-(f)ly(g) day(h) a-(g) (hg) dorned(f) by(gf) three(def)  mi(fgfeded) ra-(cd)cles:(d) to-(d)day(dh) a(h) star(hg) led(h) the(gf) wise(gh) men(fe)  (c) to(d) the(efe)  PV(d)  (d) I(d) day(dg) water(h) R(g) was(f) made(fe) wine(fg) at(e) the(fe) I(d) wedding(cd) feast;(d)  to-(d)day(dh) Christ(h) vouchsafed(g)  (h)  (f) to(f) be(g) baptized(gh)  (h) of(g)  (f) John(g) in(ef) Jor-(d) dan(dfddc) that(cd) he(fgfe) might(ghg) save(fe) us,(dc) al-(d)le-(efe)lu-(d)ia.(d) L(h)  (g)  (f)  (g) kY(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-075.png",
        nextFileName: "./pages/part-a-076.png"
    },
    {
        title: "part-a-076-0",
        gabc: "rom(d) the(de) FastT(efee) there(df) came(hfh) wise(hij) men(i) to(ij) Pethlehem,(h)  (gh)  (f) \xa2,(i)  worship(gi)  (h)  (gh) the(fe) Lord:(fgfe) and(d) when(e) they(f) had(e) o-(f) (e) pened(e) their(d)  treasures,(ef)  (f) they(f) a(i) presented(h)  (gh) un-(f)to(e) him(efe) precious(dc)  (de) &quot;N(e)  as(d) to(e) a(f) mighty(hf)  (gf) King,(e) incense(i)  (h) as(i) to(f)  (k) the(j) true(ih) God,(i)  \xa2(ig~) and(hi) myrrh(ihghf) to(f) -(i)foreshew(h) his(gh) bu-(f)ri-(e)al,(efe) .(d) le-(de)lu-(e)ia.(e) &quot;y(hghfefe) ",
        groupIndex: 0,
        filename: "./pages/part-a-076.png",
        nextFileName: "./pages/part-a-077.png"
    },
    {
        title: "part-a-076-1",
        gabc: "hen(c) I(c) wise(e) men(f) saw(gh) the(g) star&#39;(g) they(g) &quot;(f) rejoiced(hi)  (h) 3(h) \u2014\u2014(f)  ceeding(h)  (g) great(ih) joy:(g) and(g) when(h) they(g) were(g) come(hi) in-(j)to(j) the(i) house,(g)  they(g) presented(g)  (h) un-(g) (f) to(g) the(f) Lord(edd) gold,(c) frankincense(d)  (e)  (d) and(e)  .(cd)  (e) le-(d)lu-(c)ia.(c) 122(g)  (h) &#39;(g)  (f)  (ed) ",
        groupIndex: 1,
        filename: "./pages/part-a-076.png",
        nextFileName: "./pages/part-a-077.png"
    },
    {
        title: "part-a-077-0",
        gabc: "Three(c)  (fd) are(e) the(f)  (ge) giftsTwhich(f) the(d) wise(ef) men(g) s(g) presented(g) .(f) un\u2014(gh)  to(h) the(g) gold,(fg) frankincense,(d)  (e)  (f) and(h) myrrh,(gg) to(e) the(f) Son(gh) of(h)  God,(g) to(f) the(g) mighty(g)  (f) King,(fed) al-(f)le-(fg)lu-(e)ia.(e) ||(h) a1(g) 1(h)  (ih) [(gfe) a](e) ",
        groupIndex: 0,
        filename: "./pages/part-a-077.png",
        nextFileName: "./pages/part-a-078.png"
    },
    {
        title: "part-a-077-1",
        gabc: "|(c) ight(hg) of(fh) [(hge) &amp;4(d) C(ef) Christ,(hg) hast(f) a(e) appeared,(f) uw(e) un-(h)to(h)  whom(j) the(i) wise(j) men(i) present(h)  (i) their(hg) gifts,(f) al-(h)le-(e)lu-(f)ia,(e)  a(e) le-(ghi)lu-(h)ia,(f) al-(g)le-(f)lu-(e)ia.(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-077.png",
        nextFileName: "./pages/part-a-078.png"
    },
    {
        title: "part-a-077-2",
        gabc: "W&#39;e(fe) have(d) seen(e) his(f) star?(ghg) in(g) the(e) East,(fed) and(f) are(e) come(d) with(f)  gifts(ghg) to(g) worship(h)  (f) the(g) Lord.(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-077.png",
        nextFileName: "./pages/part-a-078.png"
    },
    {
        title: "part-a-078-0",
        gabc: "Y(gfd) rod(e) \u2014\u2014(f)  (gh) [(g) the(hgf)  (h) wise(ji) men,(g) What(jkji) .(h) haye(i) ve(j)  seen,(i)  (ih) concerning(j)  (ih)  (ghg) him(g) that(e) is(f) born(gh) King?(g) We(ji) have(h) .,(i)  a(j) star(ih) shining,(gi)  (h) the(g) brightness(gfd)  (ef) whereof(gh)  (g) enlighteng(hg~)  (hgf)  (h)  the(ji) world.(g) ](j)  (i)  (j) V.(h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-078.png",
        nextFileName: "./pages/part-a-079.png"
    },
    {
        title: "part-a-078-1",
        gabc: "L](g)  (h) nationsTsllall(ij)  (i)  (ijhg) :(fh) from(h) a-(gf)](ef) bearing(h)  (i) their(gh)  s(f) al-(f)le-(gf)lu-(e)1a.(e) RN(j)  (i) ;\u2014_I(h) BN(ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-078.png",
        nextFileName: "./pages/part-a-079.png"
    },
    {
        title: "part-a-078-2",
        gabc: "N(def) they(e) from(d) She(fhhgfe) batshall(ed)  (de) 5(e) they(eiji) shall(i) bring(hgf)  gold(hg) and(f)  (f) incense,(e) al-(f)le-(hg)lu-(f)ia,(ed) al-(ef)le-(f)lu-(e)T(e) |(h)  (g)  (h)  (f)  (efe) ",
        groupIndex: 2,
        filename: "./pages/part-a-078.png",
        nextFileName: "./pages/part-a-079.png"
    },
    {
        title: "part-a-079-0",
        gabc: "All(j) they(i) from(g) She-(j) (hg) ba(hg) come:(f) they(g) shall(g) bring(g)  gold(g) and(fh) incense,(j)  (i) al-(g)le-(j)lu-(h)ia,(h) al-(i)le-(h)lu-(g)ia.(g)  (j) 1(hj)  (k)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-a-079.png",
        nextFileName: "./pages/part-a-080.png"
    },
    {
        title: "part-a-079-1",
        gabc: "that(c)  (g)  (df) despised(e)  (f)  (fg) thee(g) tshall(g) come(hi) un-(ggh)to(g) thee,(f) and(f)  shall(jh) bow(j) themselves(jh)  (ih) at(h) the(f) soles(fh) of(h) thy(g) feet.(g)  a__.(ki~)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-079.png",
        nextFileName: "./pages/part-a-080.png"
    },
    {
        title: "part-a-079-2",
        gabc: "T(c) he(d) wise(d) men,(d) be-(f)ing(g) warned(fh)  (h) in(h) dreams(i) by(h) an(g) An-(fh) gel,(g) de-(g)part-(g)ed(e) in-(g)to(h) their(g) own(fg) country(ef) a(c) an-(d)oth-(dge)er(fe)  way,(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-079.png",
        nextFileName: "./pages/part-a-080.png"
    },
    {
        title: "part-a-080-0",
        gabc: "[(gi) he(e) Child(fg) Je-(h)sus(g) tar-(e)ri-(f)ed(f) a(e) behind(fg) in(h) Je-(hg)ru-(fg)sa-(fe)a(e)  and(ig~)  (h) Joseph(h)  (h) and(j) his(jk) mother(j)  (i) knew(h) not(hg) of(ef) it,(f) supposing(f)  (g)  (h)  B(ig~) him(i) to(i) have(ji) been(hgf) in(h) the(hg) compa-(fg)ny;(fe)  (e) [(c) they(ef) sought(hhi)  w(gi) him(h) -(h)among(h) their(h) -(h)e(gh) e(i) et(hg) acquaintance.(f) b(f) D(h)  (g) Th(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-080.png",
        nextFileName: "./pages/part-a-081.png"
    },
    {
        title: "part-a-081-0",
        gabc: "Son,(fg) why(h) hast(i) thou(h) thus(gf) dealt(gh) with(h) us?(g) behold(g)  (jh~) thy(ji)  father(h)  (g) and(h) I(g) have(g) sought(fed) thee(ef) sorrowing.(gh)  (h)  (g) How(jk) is(k) it(k)  that(k) ye(kj) sought(jk) me?(h) wist(hf) ye(hj) not(jkh) that(h) I(f) must(h) be(j) a-(i)bout(jk)  my(hg) Father\u2019s(fh)  (h) same(g) business?(g) o(j)  (i) et(j)  (h) .(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-081.png",
        nextFileName: "./pages/part-a-082.png"
    },
    {
        title: "part-a-082-0",
        gabc: "A(cd) when(f) they(g) wanted(f)  (h)  (h) bade(h)  (h)  (hj) them(h) to(g) fil](h)  the(g) w-(ef)a-(g)ter\u2014pot:s(f) with(fe) water;(d)  (d) and(hijihh) it(g) was(ef) turned(g)  (fe) in-(d) to(fe) wine,(dc) al-(d)le-(efe)lu-(d)ia.(d)  (h) THE(g)  (f) EPIPHANY(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-082.png",
        nextFileName: "./pages/part-a-083.png"
    },
    {
        title: "part-a-082-1",
        gabc: ".The(f) Ho-(fe)ly(d) Spirit(d) :(c) .(d) descended(f)  (gf) Tin(f)  (f) a(g) bo-(h)di-(g)ly(f) shape(f) like(f)  a(g) dove(h) up(gf) on(fgffg) him,(d) and(d) there(e) came(c) a(d) voice(f) from(g) hes-(fg) ven:(f) This(f) is(g) my(h) be-(e)lov-(f)ed(g) Son?\u2019(defedc) h\xe9ar(cd) ye(fg) him,(gf) al-(g)le-(ghg) lu-(f)1ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-082.png",
        nextFileName: "./pages/part-a-083.png"
    },
    {
        title: "part-a-083-0",
        gabc: "T(c) ord,(hh) if(g) thou(i) wilt,(ghge) thou(f) canst(g) make(e) me(fe) clean:(d) then(ff)  saith(ik)  (defec) Je-(f)sus,(ighghih) I(h) will;(gfe) be(fgf) thou(ef) clean.(d)  (h)  (h)  (g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-083.png",
        nextFileName: "./pages/part-a-084.png"
    },
    {
        title: "part-a-083-1",
        gabc: "us,(f)  (gh)  (h) we(gf) perish:(gf)  (d) re-(d)buke(d) the(e) winds(f) and(e) the(f)  (d)  sea,(de) IO(dc)  (c) and(cd) a(ef)  (g) great(fe) calm.(d)  (h)  (g)  (f)  (g)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-083.png",
        nextFileName: "./pages/part-a-084.png"
    },
    {
        title: "part-a-083-2",
        gabc: "ye(ik)  (f)  (dc~)  (d) to-(d)ge-(dhi)T(h) first(hj) the(h) tares,(hghihgg) and(f)  (gf) bind(h)  (hg~)  them(g) in(f) E==\u2014(def) a(g) to(fe) burn(d) them:(d) but(cd) gather(ffg)  (f) the(f) wheat(ghg)  in-(gf)to(f) my(dfe) bhrn,(dc) saith(d) the(efe) Lord.(d)  (ffh)  (h)  (g)  (f)  (fgh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-083.png",
        nextFileName: "./pages/part-a-084.png"
    },
    {
        title: "part-a-084-0",
        gabc: "he(d)  (f) of(c)  (d) hea-(dhi)ven(h) tis(h) like(hj) un-(h)to(h) lea-(h)ven,(hghihgg) Which}:(f)  a(g) wo-(h)man(g) took(fg) and(f) hid(f) in(f) three(ef) measures(g)  (fe) of(df) mea&#39;xl,(fc)  un-(cd)til(f) the(ef) whole(g) was(fe) leavened.(d)  (d)  (d) e(h)  (g) =](f) d(gh) e(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-084.png",
        nextFileName: "./pages/part-a-085.png"
    },
    {
        title: "part-a-084-1",
        gabc: "L](e)  (f) the(hi)  (i)  (i) bo-(hi)dy(jh) 1is,(i) there(fi) will(g) the(h) 0(fe) eacles(f)  be(e) gathered(d)  (e)  (f) together.(h)  (f)  (f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-084.png",
        nextFileName: "./pages/part-a-085.png"
    },
    {
        title: "part-a-084-2",
        gabc: "T(ki~)  (cc) he(d) Lord(fg) said(ghg) Tun-(g)to(fe) A-(fgf)dam,(g) Of(d) the(fg) tree(ghg) which(f) 1s(g)  in(hi) the(j) midst(ihij) of(h) the(gh) garden(i)  (j) thou(hg) shalt(f) not(fg)  in(j) the(jk) day(jih) that(j) thou(ji) ",
        groupIndex: 2,
        filename: "./pages/part-a-084.png",
        nextFileName: "./pages/part-a-085.png"
    },
    {
        title: "part-a-085-0",
        gabc: "sure-(h)ly(hih) die.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-085.png",
        nextFileName: "./pages/part-a-086.png"
    },
    {
        title: "part-a-085-1",
        gabc: "Let(g) us(g) bless(g) the(g) Lord,(h) al-(g)le-(f)lu-(hg)ia,(h) al-(h)le(gjihg) lu-(fgh)ia.(hg)  Thanks(g) be(g) to(g) God,(h) al-(g)le-(f)lu-(hg~)ia,(h) al-(h)le(gjihg) lu-(fgh)ia.(hg) ",
        groupIndex: 1,
        filename: "./pages/part-a-085.png",
        nextFileName: "./pages/part-a-086.png"
    },
    {
        title: "part-a-085-2",
        gabc: "And(cd) when(f) he(g) had(f)  (h) agreedfwith(hgg)  (f) the(g) labourers(h)  (g)  (f) for(f) a(f) pen-(fg) ny(fe) a(def) day,(fc) h\xe9(cd) sent(fg) them(f) into(ef)  (g) his(fe) vineyard.(d)  (d)  (h)  (g)  (f)  (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-085.png",
        nextFileName: "./pages/part-a-086.png"
    },
    {
        title: "part-a-085-3",
        gabc: "Goye(ji)  (hg) =](h) al-(gf)=(gh) to(i) the(h) vineyard,(g)  (g) and(g) what-(g)0(e) ev-(g)er(g)  18(fe) right(d) T(f) will(fh) give(g) you.(g) ](j)  (h)  (j)  (k)  (j) ",
        groupIndex: 3,
        filename: "./pages/part-a-085.png",
        nextFileName: "./pages/part-a-086.png"
    },
    {
        title: "part-a-086-0",
        gabc: "stand(cd)  (dh) ye(hi) herefall(hgg)  (h) the(gh) day(fe) 1i-(d)dle?(df) They(cd) answered(f)  (f)  (e)  him,(d) saying;(ffg)  (f) Because(f)  (ef) no(g) LR(e) hath(dfe) hired(d)  (d) us.(d)  (h) E\u2014\u2014(g)  (f)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-086.png",
        nextFileName: "./pages/part-a-087.png"
    },
    {
        title: "part-a-086-1",
        gabc: "C(ig) 211(eh) the(fed) la-(ef)bour-(fe)ers,(e) and(h) give(i) them(h) their(fhg) hire,(ef)  saith(gi)  (g) the(f) .-(e)Lord.(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-086.png",
        nextFileName: "./pages/part-a-087.png"
    },
    {
        title: "part-a-086-2",
        gabc: "Praise(h) be(h) to(h) thee,(h) O(h) Lord,(h) King(h) of(h) e-(h) (h) ternal(i) glory.(dhg)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-086.png",
        nextFileName: "./pages/part-a-087.png"
    },
    {
        title: "part-a-086-3",
        gabc: "\u2014(c) bouseholder(dc~fe)  (fg)  (g) saith(gf) un-(d)to(f) the(e) labourers,(d)  (c)  (c) Wby(cfe)  stand(fghi) ye(i) here(fhih) all(g) the(f) day(hih) ](g) dle?(g) They(fgh) say(gf) un-(fd)to(e) ",
        groupIndex: 3,
        filename: "./pages/part-a-086.png",
        nextFileName: "./pages/part-a-087.png"
    },
    {
        title: "part-a-087-0",
        gabc: ".(c) Becdlse(d)  (c) e(d) man(f) hath(e) hi-(d)red(c) us.(c) Go(hij) ye(jhjihg)  al-(hi)80(gf) in-(h)the(h) vineyard,(g)  (g) a(e) what-(g)so-(hg)ev-(f)er(e) is(d)  oy(ef) I(gf) .(d) a(c) (D(c) -(h) (g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-087.png",
        nextFileName: "./pages/part-a-088.png"
    },
    {
        title: "part-a-087-1",
        gabc: "Th:ase(ccc)  (dh) last(hj) have(hg)  (ef) but(g) one(fe) hour,(d) and(d) thou(fe) hast(d)  a(e) them(f) e\u2014qual(g)  (ge) un-(f)a(e) .(d) which(f) have(cd) borne(ed) the(d)  bur-(fh)den(ghg) and(f) heat(df) of(g) the(fe) day.(d) &quot;(h) e(g) .(f) d(gh) &amp;g(gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-087.png",
        nextFileName: "./pages/part-a-088.png"
    },
    {
        title: "part-a-087-2",
        gabc: "T(cc)  (c) he(e) householder(eh)  (f)  (e) an-(f)swer-(ed)ed(ef) and(ef) said,(e) Friend,(cfigij)  (c) 1(i)  (c)  do(ji) thee(hij) no(hg) wrong:(e) didst(hg) notthou(f)  (g) a-(h)gree(ihj) with(i) ",
        groupIndex: 2,
        filename: "./pages/part-a-087.png",
        nextFileName: "./pages/part-a-088.png"
    },
    {
        title: "part-a-088-0",
        gabc: "me(hf) for(g) a(f) penny?(e)  (e) Take(ec) that(e) thine(e) is,(dc) and(d) go(ef) thy(f) way.(e)  a(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-088.png",
        nextFileName: "./pages/part-a-089.png"
    },
    {
        title: "part-a-088-1",
        gabc: "Take(j) that(ji) thine(hg) ist(h) and(fg) go(gh) thy(h) way:(g) because(g)  (ge) I(g) am(fe)  (d)  good,(d) saith(f) the(h) Lord.(g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-088.png",
        nextFileName: "./pages/part-a-089.png"
    },
    {
        title: "part-a-088-2",
        gabc: "[s(e) it(eh) not(f) lawful(f)  (e) for(f) me(e) to(f) do(ed) what(ef) I(f) will?(e) Is(g)  thine(igj) eye(i) e-(hi)vil,(hghih) because(f)  (h) I(e) am(f) good,(ed) saith(ef) the(f)  Lord.(e)  (h)  (g)  (h)  (f) FRIDAY(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-088.png",
        nextFileName: "./pages/part-a-089.png"
    },
    {
        title: "part-a-088-3",
        gabc: "S(f) the(de) lastT(e) shall(f) be(d) -(ef)and(h) the(h) first(i) shall(f) be(h) ",
        groupIndex: 3,
        filename: "./pages/part-a-088.png",
        nextFileName: "./pages/part-a-089.png"
    },
    {
        title: "part-a-089-0",
        gabc: "last:(g) for(i) ma-(i)ny(g) are(h) call(iji) -(hghih)but(fe) few(fhf) are(gfj)  chosen.(e)  (e)  (h)  (g)  (h)  (f)  (ef) ",
        groupIndex: 0,
        filename: "./pages/part-a-089.png",
        nextFileName: "./pages/part-a-090.png"
    },
    {
        title: "part-a-089-1",
        gabc: "he(g) LordT(ghgf) said(hj) un-(h)to(gf) No-(ghg)ah:(g) The(gj) end(jj) of(h) all(ij) flesh(k)  is(ji) come(h) be-(ij)fore(hg) me:(g) Make(g) thee(j) an(k) ark(h) of(hgf) go-(h)pher(hi)  wood,(g) that(h) therein(hg)  (fgh) the(h) seed(j) of(ih) all(ghgf) flesh(gh) may(i) be(h)  [(g) saved.(g) 0(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-089.png",
        nextFileName: "./pages/part-a-090.png"
    },
    {
        title: "part-a-089-2",
        gabc: "I(h) seedT(g) .(e) a(g) good(i) _(h) and(g) N(e)  forth(f) fruit(h) with(g) a(e) ar(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-089.png",
        nextFileName: "./pages/part-a-090.png"
    },
    {
        title: "part-a-090-0",
        gabc: "T(c)  (c) hey(d) keep(dc)  (f) the(g) word(f) of(gh) God(h) with(h) an(g) honest(h)  (g) and(f)  =(h) perfect(fe) heart(d) bring(g) forth(ef) fruit(g) with(fe) patience.(d)  (d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-090.png",
        nextFileName: "./pages/part-a-091.png"
    },
    {
        title: "part-a-090-1",
        gabc: "ome(h) a(g) fell(e) on(g) good(i) ground,(h) and(f) broucht(ef) forth(gf) frujt;(e)  same(g) an(h)  (i) hundredfold,(h) ](g) and(f) some(hg) sixtyfold.(e)  (e)  (e) |(h) B(f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-090.png",
        nextFileName: "./pages/part-a-091.png"
    },
    {
        title: "part-a-090-2",
        gabc: "\xa3(ig) then,(j) brethren,Tye(i)  (i) n(i) would(i) be(gh) truly(ih)  (f) rich,(e) set(h) your(h)  af-(f)fec-(h)tion(gf) on(e) the(f) true(gf) riches.(e)  (e) \u2014(i) \xa2(j)  (i)  (h) |(gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-090.png",
        nextFileName: "./pages/part-a-091.png"
    },
    {
        title: "part-a-090-3",
        gabc: "Unr-(f)to(h) you(f) it(f) is(e) s(d) givenT(d) to(e) know(c) the(d) mys-(f)te-(f)ries(f) of(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-090.png",
        nextFileName: "./pages/part-a-091.png"
    },
    {
        title: "part-a-091-0",
        gabc: "the(e) kingdom(c)  (d) of(f) hea\u2014-(ffgf)ven:(f) but(fh) to(hg) o(hih) thers(gf) in(gghg)  parables,(f)  (ef)  (f) said(f) Je-(gh)sus(f) to(f) his(dc) disciples.(df)  (f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-091.png",
        nextFileName: "./pages/part-a-092.png"
    },
    {
        title: "part-a-091-1",
        gabc: "[f(cig) ye(hij) seek(i) the(i) summit(j)  (i) of(gh) true(ihf) [](e) honour,(e) hasten(h)  (h) to(h)  yon(h) heavenly(h)  (h)  (f) country(h)  (g) with(f) what(ef) speed(g) ye(f) may.(e)  (j)  (i)  (h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-091.png",
        nextFileName: "./pages/part-a-092.png"
    },
    {
        title: "part-a-091-2",
        gabc: "The(g) seed(hj) is(ji) the(hg) word(hiji) of(h) God,(g) but(g) Christ(hi) is(h) the(g)  Sow-(effg)er:(g) every(i)  (h) one(j) that(hg) hear-(h) (iji) eth(h) him(g) shall(h) a-(gf)bide(g)  for(gf) ev-(e)er.(e)  (j)  (h) ESDAY(j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-091.png",
        nextFileName: "./pages/part-a-092.png"
    },
    {
        title: "part-a-091-3",
        gabc: "thatT(idhi)  (h) which(h) fell(h) on(h) the(h) good(h) ground(ihghihgg) are(h)  (fg) they(h) ",
        groupIndex: 3,
        filename: "./pages/part-a-091.png",
        nextFileName: "./pages/part-a-092.png"
    },
    {
        title: "part-a-092-0",
        gabc: "which(g) in(h) an(g) honest(h)  (g) and(f) 4(ghfe) -(d)receive(g)  (h) the(g) word;(f)  and(f) bring(f) forth(ef) fruit(g) with(fe) U(d)  (d) E\u2014\u2014(h)  (g) {\u2018I(f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-092.png",
        nextFileName: "./pages/part-a-093.png"
    },
    {
        title: "part-a-092-1",
        gabc: "Some(h) a(g) 0(e) ](g) good(i) ground,(h) and(f) i(ef) forth(gf) fruit;(e)  some(gi)  (g) an(h) *(i) hundredfold,(h) :(g) and(f) some(hg) sixtyfold.(e)  (e) e(e) e(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-092.png",
        nextFileName: "./pages/part-a-093.png"
    },
    {
        title: "part-a-092-2",
        gabc: "T(c) hey(d) ;]Eo(dc) keep(f) the(g) word(f) of(gh) God(h) twith(h) an(g) honest(h)  (g) and(f) per-(h) fect(fe) heart(d) bring(g) forth(ef) fruit(g) with(fe) patience.(d)  (d) |(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-092.png",
        nextFileName: "./pages/part-a-093.png"
    },
    {
        title: "part-a-092-3",
        gabc: "-(ik) (c)  (cffddcf) ty(f) A-(gh)bra-(gf)ham,(f) the(hj) fa-(ih)ther(gf) of(g) our(gh) faith,(f)  of(ffdd) -(fcgh)fer-(gf)ed(f) a(g) burnt(ghg) offering(f)  (ef)  (f) up-(f)on(gh) the(ghg) al-(f)tar,(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-092.png",
        nextFileName: "./pages/part-a-093.png"
    },
    {
        title: "part-a-093-0",
        gabc: "in-(f)stead(fdd)  (fc) of(g) his(ghg) son.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-093.png",
        nextFileName: "./pages/part-a-094.png"
    },
    {
        title: "part-a-093-1",
        gabc: "As(cd)  (d) made(dc)  (d)  (fd) _\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014(ed)  (c) when(d) ia(dc) was(f) come(g) nigh(h)  un-(g)to(f) Je-(fe)ri-(fgf)cho,(g)  (g) la(dc) blind(f) man(g) cri-(h)ed(g) un\u2014to(f)  (gh) him,that(h)  (fg)  he(ihih) might(g) n(e) worthy(g) a(fe) to(d) -(c)receive(ef) light.(d) &quot;=(h) [(g)  (f) Te(g)  (gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-093.png",
        nextFileName: "./pages/part-a-094.png"
    },
    {
        title: "part-a-093-2",
        gabc: "As(d) the(dc) Lord(f) was(g) passing(f)  (gh) by,t(h) a(hg) blind(i) man(h) cri-(g)ed(g) un-(f) to(gh) him,(g) Have(g) mer-(e)cy(g) on(hg) me,(fg) thou(ec) Son(eg) of(f) Da-(d)vid.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-093.png",
        nextFileName: "./pages/part-a-094.png"
    },
    {
        title: "part-a-094-0",
        gabc: "a(e) they(g) which(h) went(ihj) before(hi)  (i) rebuked(i)  (i)  (i) him(i) that(h) he(ij)  should(i) hold(h) his(hg) peace:(e) but(h) he(h) cri-(hih)ed(hg) so(hf) much(gh) the(g) more,(e)  ave(dde) a(e) mercy(f) on(h) hong(gh) thou(f) Son(h) .(g) A(e) 8.(e) \u201C(i)  (j)  (i) \uFB02(h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-094.png",
        nextFileName: "./pages/part-a-095.png"
    },
    {
        title: "part-a-094-1",
        gabc: "he(d) bl;nd(ef) man(g)  (g) out(g)  (gh) more(ge) and(f) more,(d) that(fh) tle(h)  Lord(ghg) would(ef) give(g) him(fe) light.(d)  (f)  (h) I(g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-094.png",
        nextFileName: "./pages/part-a-095.png"
    },
    {
        title: "part-a-094-2",
        gabc: "And(c)  (c)  (cd)  (d) Tand(dfdcdc)  (f) ](g) commanded(hhi)  (h) him(h) [](g) be(f) ](g)  un-(fhi)to(gh) him,(h) and(hgh) asked(f)  (fe) him,(fgfe) saying:(d)  (d) What(ef)  (d) wilt(cd) thou(d)  that(d) I(d) shall(cd) do(f) un-(g)to(g) thee?(f)  (f) Lord,(fh) that(g) I(f) may(f) a(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-094.png",
        nextFileName: "./pages/part-a-095.png"
    },
    {
        title: "part-a-095-0",
        gabc: "ceive(fg) my(fe) sight.(d) And(c) Je-(df)sus(f) said(f) un-(f)to(de) him,(dc) Beceive(d)  (e)  e(i) thy(cd) sight,(d) thy(ccd) faith(f) hath(g) saved(g)  (f) thee.(f) And(f) straightway(fh)  (g)  he(f)  (fe) received(f)  (g) his(fe) sight,(d) and(c) followed(df)  (fe) him,(de)  (dc) glo-(cd)ri-(ef)fy-(fgh) ing(ik)  (fe) God.(d)  (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-095.png",
        nextFileName: "./pages/part-a-096.png"
    },
    {
        title: "part-a-095-1",
        gabc: "nd(e) they(g) which(h) went(ihj) before(hi)  (i) trebuked(i)  (i)  (i) him(i) that(h) he(ij)  should(i) hold(h) his(hg) peace:(e) but(h) he(h) cri-(hih)ed(h)  (hg) so(hf) much(gh) the(g) more,(e)  Have(g)  (de) .(e) mercy(f) on(h) -(gh)thou(f) Son(h) of(g) a.(e) David.(e) @-(j) (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-095.png",
        nextFileName: "./pages/part-a-096.png"
    },
    {
        title: "part-a-095-2",
        gabc: "Have(c)  (e) mercy(f)  (f) on(e) me,l(e) thou(f) Son(h) of(hg) Da-(fgfe)vid.(e) What(h) wilt(gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-095.png",
        nextFileName: "./pages/part-a-096.png"
    },
    {
        title: "part-a-096-0",
        gabc: "thou(f) that(g) I(f) shall(fi) do(i) un-(h)to(hg) thee?(hihgf) Lord,(de) that(f) I(hf)  may(g) receive(f) a(e) my(de) [(e) sight.(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-096.png",
        nextFileName: "./pages/part-a-097.png"
    },
    {
        title: "part-a-096-1",
        gabc: "Lay(f) up(h) for(h) yourselves(hj)  (i) t(h) treasures(i) .(hj) heaven,(i)  (i) where(fi)  neither(g)  (h) moth(f) nor(e) rust(fe) doth(de) corrupt.(fh)  (f) &amp;(i) v(h)  (i)  (j)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-a-096.png",
        nextFileName: "./pages/part-a-097.png"
    },
    {
        title: "part-a-096-2",
        gabc: "Lord,(f) T(gh) e(h) not(g) TR(h) e(ghg) TawT(e) thou(f) B(g) shouldest(f) e(g) ter(e)  un-(g)der(h) my(fe) roof:(d) but(d) speak(dgfgh) the(g) word(gf) on-(fg)1ly(f) and(f)  my(f)  my(f) -(f)servant(ef) shall(g) be(fe) healed.(d)  (d) e(h) %(g)  (f) &amp;(g) on(ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-096.png",
        nextFileName: "./pages/part-a-097.png"
    },
    {
        title: "part-a-096-3",
        gabc: "But(c)  (c)  (d) \xbb(dc) when(f) thou(g)  (fh) prayest,enter(h) t(i) -(h)a(g) to(h) -(fe)loset(d) ;(d) ",
        groupIndex: 3,
        filename: "./pages/part-a-096.png",
        nextFileName: "./pages/part-a-097.png"
    },
    {
        title: "part-a-097-0",
        gabc: "and(g) when(g) thou(e) hast(g) shut(h) thy(g) door,(f) pray(fg) to(e) thy(fe) Father.(d)  (d)  .(h)  (g)  (f) I(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-097.png",
        nextFileName: "./pages/part-a-098.png"
    },
    {
        title: "part-a-097-1",
        gabc: "He(c)  (cf) sball(f) de-(f)fend(gh) thee(hg) Un-(g)der(fd) his(fg) wings.(gf) He(f) shall.(f)  defend.(f)  (gh) And(h) thou(h)  (hi) shalt(h) be(gh) safe(g) un-(g)der(g) his(f) fea-(gh) thers.(hg) Un-(g)der(fd) his(fg) wings.(gf) Glory(h)  (h) be.(h) He(f) shall(f) defend.(f)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-097.png",
        nextFileName: "./pages/part-a-098.png"
    },
    {
        title: "part-a-097-2",
        gabc: "o(fe) |(f)  (hg) &quot;(h)  (fg) T(gf) W&amp;(ef) &quot;(f) &quot;(hg) R(hi) T(ihg) R(f) &quot;(hg)  (fg) P(fe) af(e)  .,(gi)  (e)  (f) a(g) o(dhg)  (f) fi(hg) R(hi) a.(i) &amp;(ef)  (hi)  (g) fa(hg) ](f) _a(gf) ](ef)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-097.png",
        nextFileName: "./pages/part-a-098.png"
    },
    {
        title: "part-a-098-0",
        gabc: "hen(e) shalt(g) thou(h) call,T(ihji) and(g) the(h) Lord(ih) shall(f) a(e) a(e)  thou(h) shalt(hhi) cry,(hggh) and(hi) he(h) shall(gh) say,(f) Here(gh) am(g) I.(e)  (ijihgf) ",
        groupIndex: 0,
        filename: "./pages/part-a-098.png",
        nextFileName: "./pages/part-a-099.png"
    },
    {
        title: "part-a-098-1",
        gabc: "J(g)  (g)  (dfe)  (f)  (g)  (h)  (f) [](f)  (f)  (f)  (h)  (g)  (e) !(f)  (h) |(g)  L(gi)  (h) J(i)  (h) T(g)  (f) I(h)  (f) SUNDAY(f) IN(g) LENT(g)  (fe) Y(f)  (g) T(h)  (f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-098.png",
        nextFileName: "./pages/part-a-099.png"
    },
    {
        title: "part-a-098-2",
        gabc: "o(gi) R(g)  (i) o(ij)  (j) P(ih)  (i) sG](i) |(j) s(i) GRS(g)  (h) -(i)IR(hg) N(f) e(eg) e(g)  [(g) .(i) N(ij)  (ji) A(gf)  (h) o(gf) L(fg) A(e) A(hg) A(hi) R(hg)  (e) B(gh) .(f)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-098.png",
        nextFileName: "./pages/part-a-099.png"
    },
    {
        title: "part-a-098-3",
        gabc: "nd(d) when(f)  (dc) had(f)  (g) fast-(fgh)ed(hgg)  (j)  (f) days(fg)  (h) and(g)  (h)  (fe)  .(d) he(e) was(f) &amp;(g) afterward(f)  (g) &#39;an(fe) hungred.(d)  (d) I(fh)  (h) *5\u2014\xa7(g)  (f)  (gh) |(gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-098.png",
        nextFileName: "./pages/part-a-099.png"
    },
    {
        title: "part-a-099-0",
        gabc: "the(h)  (h) devil(fg)  (f) T(f) a(e) him(f) up(h) in-(h)to(g) a(e) ho-(f)ly(efec) ci-(eg)ty,(f)  and(efh) setteth(h)  (hg) him(f) on(g) a(f) pinnacle(f)  (e)  (fh) of(hg) the(f) temple,(hi)  (h) and(h)  (ji)  saith(g)  (hg) un-(h)to(ih) him,(f) &#39;Tf(fe) thou(hi) be(j) the(ji) Son(h) of(i) God,(h) cast(hi) thy-(g) self(h) down.(f) I(f) =(h)  (g) I(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-099.png",
        nextFileName: "./pages/part-a-100.png"
    },
    {
        title: "part-a-099-1",
        gabc: "an(h) shall(df) not(hijh) live(hghih) 1(j) Tea(fe) bread(f) a-(e)lone,(d) but(d) by(f) \u2018every(fe)  (d)  word(ef) that(f)  (h) proceedeth(f)  (e) out(f) of(e) the(d) mouth(ef) of(e) God.(d) o(h) &amp;(i)  (g) _(h) 1(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-099.png",
        nextFileName: "./pages/part-a-100.png"
    },
    {
        title: "part-a-099-2",
        gabc: "hou(f) shalt(g)  (h)  (g) Lord(fgf)  (gfhg) thy(fg)  (gf) God,(fgfd) ahd(f)  (d) him(fg) on-(h)ly(defgf)  shalt(gh)  (fgf) serve,(f)  (dfgh)  (h)  (f)  (h)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-099.png",
        nextFileName: "./pages/part-a-100.png"
    },
    {
        title: "part-a-100-0",
        gabc: ".(c)  (de) \u2014o\u2014\u2014\u2014\u2014(eed) -(fh)the(g) ac-(h)2(f)  (de) =(efe) .3(d) behold,(de) S|(e)  (e)  5(e) day(ed) of(f)  (fgf) e(e)  (e) let(df) us(hj) therefore(hg)  (f) in(i) al](h) things(e)  approve(ig~)  (f)  (hf) ourselves(hi)  (f) as(d) the(fh) v(h) ministers(f)  (g) of(f) God,(e) in(fd~) much(hij)  |(gi)  (hg) 8(e) in(fg) T(hi) watchings,(h) in(f) e(fe) fastings,(d) e(e) by(fg) Y(gfghgfe)  unfeigned.(gi)  (fgf)  (e)  (e) a(j)  (i)  (j) L)(h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-100.png",
        nextFileName: "./pages/part-a-101.png"
    },
    {
        title: "part-a-100-1",
        gabc: "As(j) I(h) live,(ghjj) saith(j) the(j) Lord,(j)  (f) I(j) have(ih) no(gh) pleasure(j)  (i) 1n(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-100.png",
        nextFileName: "./pages/part-a-101.png"
    },
    {
        title: "part-a-101-0",
        gabc: "the(g) death(h) of(h) a(g) 4(df) &#39;.(ed) but(e) ra\u2014-(gi)ther(h) that(h) he(g) turn(h)  from(g) his(f) way(ef) and(fg) live.(e)  (j)  (h)  (j)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-101.png",
        nextFileName: "./pages/part-a-102.png"
    },
    {
        title: "part-a-101-1",
        gabc: "T(ik) he(g) days(g) of(h)  (h) a(g) a(g) come(hih) to(gf) us,(f) for(h) the(f) redemp-(h) (j)  tion(ik)  (k) of(i) our(j) sins,(hg) and(g) the(g) saving(e)  (f) of(gh) our(h) souls.(g) ||(j)  (i) &quot;](j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-101.png",
        nextFileName: "./pages/part-a-102.png"
    },
    {
        title: "part-a-101-2",
        gabc: "L(ig~) et(f) us(e) @(f) approve(h) ourselves(ij)  (i) Tin(ih~) much(jh) a(i) patience,(i) in(if) ma-(g)ny(h)  astings,(fe)  (fe) by(d) the(e) armour(gfg)  (h) of(h)  (f) righteousness.(f) v(f) |(i) e(h)  (i)  (j)  (h) |(f) ",
        groupIndex: 2,
        filename: "./pages/part-a-101.png",
        nextFileName: "./pages/part-a-102.png"
    },
    {
        title: "part-a-101-3",
        gabc: "By(d) the(f)  (d) of(dc)  (f) the(g)  (f) righteousness(gh) T(h) of(h) the(h) power(hj) of(h) God,(hghih)  let(h) us(g)  (fe) approve(g) ourselves(fe)  (def) in(fd~) much(gf) patience.(d)  (d) &quot;8(h)  (g) o(f) d(gh) p(gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-101.png",
        nextFileName: "./pages/part-a-102.png"
    },
    {
        title: "part-a-102-0",
        gabc: "hat(d) which(ef) ye(g) have(g) donet(gh) un-(g)to(g) one(g) of(g) the(e) least(f) of(e) mine,(d)  ye(f) have(gh) done(hg) un-(f)to(fg) me,(fe) saith(g) the(fe) Lord,(d) e(e)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-102.png",
        nextFileName: "./pages/part-a-103.png"
    },
    {
        title: "part-a-102-1",
        gabc: "it(c)  (c)  (fgh)  (g)  (g) is(g) written,(fef)  (df) Mine(f) house(h) shall(j) be(jih) call-(jk)eg(ji)  an(h) house(h) of(g) pray-(h)er(g) for(gh) all(ih) nations:(g)  (g) but(jk) ye(ji) have(h) made(h)  it(g) a(ef) den(g) of(f) -(edc)\u2019)bers.(c) 2(c) he(dcgfgh) Q(g) daily(gh)  (h) with(ghgfg) N(gf)  teach-(ghih) teach-(jk) (ghihij) ing(hg) in(f) e(gh) T(g) temple.(g) I(j) e(i)  (j) P(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-102.png",
        nextFileName: "./pages/part-a-103.png"
    },
    {
        title: "part-a-102-2",
        gabc: "For(c)  (c)  (e) as(f) Jo-(h) (h) was(h) three(ij) \\\u2014_T__(i) and(i) three(hi) nights(j) in(i) the(h)  whale\u2019s(ij) belly,(i)  (i) =(fi) shall(g) )(h) Son(f) ](e) man(fe) be(de) in(f) the(gg) ",
        groupIndex: 2,
        filename: "./pages/part-a-102.png",
        nextFileName: "./pages/part-a-103.png"
    },
    {
        title: "part-a-103-0",
        gabc: "heart(g)  (hg) of(hi) the(hg) earth.(f) \u2122(i)  (h)  (i) &quot;(j)  (h) 4(fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-103.png",
        nextFileName: "./pages/part-a-104.png"
    },
    {
        title: "part-a-103-1",
        gabc: "-(ef) (hi) woman,(i) is(h)  (i) thy(jh) faith:(i) be(gi) it(hg) un-(f)to(e) thee(fe) \u20AC-(d) ven(e) as(f) thou(fh) wilt.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-103.png",
        nextFileName: "./pages/part-a-104.png"
    },
    {
        title: "part-a-103-2",
        gabc: "e(d)  (dc) made(f) me(gh) whole,(hgg) the(fg) same(h) commanded(g)  (h)  (fe) me:(d) Take(g)  up(h) thy(g) bed,(f) and(def) walk(g) in(f) peace.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-103.png",
        nextFileName: "./pages/part-a-104.png"
    },
    {
        title: "part-a-103-3",
        gabc: "Tell(d) the(ef) vision(g)  (e) twhich(gh) ye(f) have(ed) &#39;seen(dfddc) to(fh) no(gf) man,(f) un-(df)til-(f) the(g) Son(h) of(g) Man(f) be(e) risen(fg)  (g) a-(f)gain(ef) from(g) the(fe) dead.(d)  (h)  (g)  (fgh)  (gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-103.png",
        nextFileName: "./pages/part-a-104.png"
    },
    {
        title: "part-a-104-0",
        gabc: "it(f)  (ghg)  (h) is(g) good(h) ](g) us(ef) [(g) Je(fe) here:(d) if(dgf) thoy(gh) -(g) let(f) us(g) make(hg) here(f) three(gfe) ta-(d)ber-(fe)a-(dc)[(c) one(c) for(d) thes,(f)  and(f) one(f) for(f) Mo-(fg)ses,(f) and(f) one(ef) a(g) a(fe) li-(d)\u2014as.(d)  (h)  (g)  (f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-104.png",
        nextFileName: "./pages/part-a-105.png"
    },
    {
        title: "part-a-104-1",
        gabc: "The(d)  (dc)  (f) of(g)  (f) Je-(gh)sus(hgg) came(fg) un-(h)to(g) him,(fgffd) beseeching(g)  (h)  (g)  him(jk)  him(fe) and(df)  (fe) Send(c)  (d) her(c) a-(d)way,(ffgf) for(h) she(g) ](e)  (f) af.(g)  ter(fe) us.(d)  (h) AT(g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-104.png",
        nextFileName: "./pages/part-a-105.png"
    },
    {
        title: "part-a-104-2",
        gabc: "I(e) am(gh) not(ij) sent?(i) but(i) un-(ih)e(ij) the(i) lost(hi) sheep(if) of(h) the(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-104.png",
        nextFileName: "./pages/part-a-105.png"
    },
    {
        title: "part-a-105-0",
        gabc: "house(i) of(i) Is-(h)ra-(f)el,(gh) saith(f) the(f) Lord.(e)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-105.png",
        nextFileName: "./pages/part-a-106.png"
    },
    {
        title: "part-a-105-1",
        gabc: "et(e) us(f) make(hi) 00O(i) three(hi) ta-(j)ber-(ih)na-(i)one(f) for(i) thee,(g)  and(h) one(f) for(f) Mo-(fe)ses,(f) and(e) one(de) for(f) E-(h)li-(f)as.(f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-105.png",
        nextFileName: "./pages/part-a-106.png"
    },
    {
        title: "part-a-105-2",
        gabc: "0(ef)  (hi) a(i) great(h) is(i) thy(jh) faith;(i) be(gi) it(hg) un-(f)to(e) thee(fe)  e(d) -(e)as(f) thou(fh) wilt.(f) NONE(i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-105.png",
        nextFileName: "./pages/part-a-106.png"
    },
    {
        title: "part-a-105-3",
        gabc: "Tell(c)  (d) the(ef) vision(g)  (e) Twhich(gh) ye(f) have(ed) se\xe9n(dfddc) to(fh) no(f) man,(f)  lin\u2014til(df)  (f) the(g) Son(h) of(g) Man(f) be(e) risen(fg)  (g) a-(f)gain(ef) from(g) the(fe) dead.(d)  .(h)  (g)  (f)  (h)  (gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-105.png",
        nextFileName: "./pages/part-a-106.png"
    },
    {
        title: "part-a-106-0",
        gabc: "(O(f) a(e) man,(f) go(h) thy(hij) way;(i) Talready(i)  (h)  (i) have(j) I(hih) told(i) thee(i)  If(i) thou(fi) wilt(g)  (h) believe,(fe) thou(f) shalt(e) see(de) mighty(f)  (h) wonders,(f)  (f)  AT(i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-106.png",
        nextFileName: "./pages/part-a-107.png"
    },
    {
        title: "part-a-106-1",
        gabc: "J(c) e-(d)sus(ef) said(g) Tun-(g)to(g) the(f) wo-(gh)man(h) of(h) Ca-(g)na-(fg)an,(g) It(cd) is(f) not(fd)  meet(f) to(ghg) take(h) the(g) 5(fe) 2(defgefe) .(d) and(c) to(d) cast(f) it(f)  to(gh) dogs.(g) Truth,(fg) Lord;(g) yet(g) the(g) dogs(hg) eat(f) of(h) the(g) crumbs(f)  which(fh) fall(jk) from(kji) their(hg) master&#39;s(f)  (fgh) table.(g)  (g) Then(j) Je-(j)sus(hg) en-(f) swer-(gh)ed,(g) O(df) [(fgh) man,(g) great(h) is.(dgf) thy(fgh) faith;(f) be(h) it(dgf) un-(g)to(fgh) ",
        groupIndex: 1,
        filename: "./pages/part-a-106.png",
        nextFileName: "./pages/part-a-107.png"
    },
    {
        title: "part-a-107-0",
        gabc: "thee(h)  (j) e-(hj)ven(h) as(i) thou(h) wilt,(g)  (h)  (j)  (i)  (j)  (h)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-107.png",
        nextFileName: "./pages/part-a-108.png"
    },
    {
        title: "part-a-107-1",
        gabc: "He(cd) that(ef) sent(g) meT(g) is(e) with(fe) me;(d) the(d) Fa-(d)ther(dc) hath(f) not(g)  left(h) me(g) a-(fg)lone;(f)  (f) I(fd)  (f) do(g) al-(ih)ways(g) those(fg) .(e)  please(dfe)  (d) him.(d)  (fh)  (h)  (g) I(f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-107.png",
        nextFileName: "./pages/part-a-108.png"
    },
    {
        title: "part-a-107-2",
        gabc: "ut(cdef) all(dfge) ye(f) are(d)  (e) 1&#39;a.nd(c)  (c) call(df) no(f) man(f) your(f)  (fe)  (d)  ther(d)  (c) on(df) earth;(de)  (h) for(g) one(hi) is(h) your(fg) Father,(g)  (e) which(g) is(fe)  in(de) heaven:(e)  (e)  (df)  (c) be(df)  (f) ye(f) call-(fe)ed(d) masters;(f)  (c) for(f)  (f) one(fed)  (fe~)  0(e) your(f) Master,(gh)  (g) e-(dghgf)ven(fgf) Christ.(e) I\u2014-(h)-(g) (h)  (fji) \u2014l(dhg)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-107.png",
        nextFileName: "./pages/part-a-108.png"
    },
    {
        title: "part-a-108-0",
        gabc: "For(d) he(d) all(dc) &#39;(f) a(g) liv-(f) (gh) \u2014T(h) Tun-(i)to(h) the(g) 4(fh)  (g) 0(g)  mock,(gg) and(e) .(g) \xae(hg) and(f) to(f) e(g)  (e) fy(fe) |(d)  (h)  (g)  (f) \u2014(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-108.png",
        nextFileName: "./pages/part-a-109.png"
    },
    {
        title: "part-a-108-1",
        gabc: "H\\\u2019\\.-(gh) (ij)  (i) .(j)  (k)  (j)  (i) \u2018(h)  (ij)  (j)  (i)  (g) vij(ij)  of(i) bread,(hg) de-(ef)sir-(g)ed(h) a(f) drop(g) M__(f) water,(e)  (e) [\u2014_:-(j) (i)  (h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-108.png",
        nextFileName: "./pages/part-a-109.png"
    },
    {
        title: "part-a-108-2",
        gabc: "m(g)  (h)  (j)  (j)  (h)  (j)  (i)  (i)  (g)  (h)  (h)  (h)  [(i) multitude,(hg)  (g) R(ih) because(ji) they(h) took(ghihg) him(ef) for(g) a(ghg) prophet.(e)  (e) |(j) I(h)  (j) ](ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-108.png",
        nextFileName: "./pages/part-a-109.png"
    },
    {
        title: "part-a-108-3",
        gabc: "ut(eh) the(f) fatherT(f)  (e) said(f) to(f) His(ed) servants,(ef)  (e) Bring(igij) forth(ij) ",
        groupIndex: 3,
        filename: "./pages/part-a-108.png",
        nextFileName: "./pages/part-a-109.png"
    },
    {
        title: "part-a-109-0",
        gabc: "the(i) best(hih) robe(he) and(f) put(h) it(gf) on(h) him;(e) and(hg) put(i) a(h) ring(g) on(f)  Lis(fh) hand,(gh) and(ih~) shoes(iie) on(fhf) his(gf) feet.(e) I(h)  (g)  (h) _l(f) N(e) ",
        groupIndex: 0,
        filename: "./pages/part-a-109.png",
        nextFileName: "./pages/part-a-110.png"
    },
    {
        title: "part-a-109-1",
        gabc: "A.nd(c) when(d) Je(idhi) sus(h) had(h) cast(h) out(h) the(h) de-(h)vil,(ihghihgg) the(gf) dumb(g)  (d)  spake,(def) and(e) the(f) [(g) people(fe) wondered.(d)  (d)  (d) a(h)  (g) 1~(f) d(gh) &amp;\xab(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-109.png",
        nextFileName: "./pages/part-a-110.png"
    },
    {
        title: "part-a-109-2",
        gabc: "If(g) I(gj) with(h) the(g) fin-(hjh)ger(i) of(j) God(k) cast(jh) out(ji) de-(hg)vils,(g) no(gh)  doubt(j) the(i) king-(ghig)dom(h) of(g) God(e) 1is(f) come(g) 3(gf) on(e) you.(e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-109.png",
        nextFileName: "./pages/part-a-110.png"
    },
    {
        title: "part-a-110-0",
        gabc: "He(cd) that(ef) gathereth(g)  (g)  (g) not(g) Twith(g) me(ge) scattereth:(f)  (e) o(d) ang(d) he(f)  that(g) is(h) not(g) with(ffg) me(f) -(fg)A(e) gainst(f) 8(d) me.(h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-110.png",
        nextFileName: "./pages/part-a-111.png"
    },
    {
        title: "part-a-110-1",
        gabc: "hen(d)  (dc) unclean(f)  (g) spiritT(fh)  (h) is(h)  (i) gone(ih) out(g) of(f) a(h) man,(g)  he(g) walketh(g) O(e) through(g) dry(hg) places,(fg) 0(fec) seeking(c)  (d) rest,(f) -(ef) findeth(g)  (fe) none.(d)  (h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-110.png",
        nextFileName: "./pages/part-a-111.png"
    },
    {
        title: "part-a-110-2",
        gabc: "A(e) certain(eh)  (f) woman(f)  (e) of(f)  (ed) company(ef)  (e)  (e) lifted(f)  (e) up(e) her(d) voice(f)  and(ffg) 2(e) a.(e) Blessed(ghi)  (i) is(j) the(i) womb(h) that(hf) bare(hi) thee,(g) and(g)  the(h) paps(i) which(fgh) thou(ih) hast(f) sucked.(e)  (e) But(d) Je-(fh)sus(hf) ansvered:(g)  (fg)  (e)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-110.png",
        nextFileName: "./pages/part-a-111.png"
    },
    {
        title: "part-a-111-0",
        gabc: ".(gi) Yea,(e) ra-(ghi)ther,(i)  (j) blessed(j)  (i) are(h) they(i) that(h) hear(h) the(gh) word(ih)  of(gi)  (f) God,(e) and(f)  (hg)  (gf) keep(e) it.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-111.png",
        nextFileName: "./pages/part-a-112.png"
    },
    {
        title: "part-a-111-1",
        gabc: "Blut(ik)  (dc) Je-(f)sus,(g)  (fh)  (h) M(h) the(g) midst(h) of(g) them,(ef) went(g)  his(ki~)  (fe) way.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-111.png",
        nextFileName: "./pages/part-a-112.png"
    },
    {
        title: "part-a-111-2",
        gabc: "Where(f) two(h) or(hj) three(i) Tare(i) gathered(h)  (i)  (j) together(h)  (i)  (i) in(gihg) a(fe)  Name,(fe) there(d) am(e) I(g)  (fg) in(h) the(hg) midst(hi) of(fghg) &#39;8(fg) them,saith(h) the(hg) Lord.(f)  Non(i)  (h) lotis(i)  (j) manibus(h)  (i)  (h)  5(e) eat(ehg) with(h)  (i) unwashen(hij)  (h) hands(fhh) Tdefileth(g)  (i) o(hg) not(fh) a(g) ](e) T\u2122e(ji)  (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-111.png",
        nextFileName: "./pages/part-a-112.png"
    },
    {
        title: "part-a-112-0",
        gabc: "so-(d)ev-(ef) (g) er(g) had(ge) a-(f)ny(e) .(d) they(dc) brought(f) them(g) up-(h) to(g) Je-(fg)sus;(f) and(gf) they(e) were(f) healed.(d)  (d) .(h)  (g) L(f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-112.png",
        nextFileName: "./pages/part-a-113.png"
    },
    {
        title: "part-a-112-1",
        gabc: "[(g) I(h)  (j) perceiveT(j) that(jk) thou(jh) art(i) a(h) prophet.(g)  (g) Our(gh) fathers(j)  (i)  worshipped(h)  (g)  (h) in(gf) this(ghg) &amp;(e) mountain.(e) [(j) I__I(h)  (j) T(ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-112.png",
        nextFileName: "./pages/part-a-113.png"
    },
    {
        title: "part-a-112-2",
        gabc: "a(e)  (fh) hath(h) no(h) man(hg) con-(f)dem-(fghg)ned(fg) thee?(ge) No(hg) man,(fg)  Lord.(g) Neither(i)  (j) do(i) I(h) condemn(fg)  (f)  (ghgf) thee;(gf) go(ghi) and(gh) sin(fe)  &quot;(gf) &amp;(e) [(h) &quot;(g)  (h)  (f) =(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-112.png",
        nextFileName: "./pages/part-a-113.png"
    },
    {
        title: "part-a-113-0",
        gabc: "Je-(d) (f) sus(g) took(f) the(fgh) loaves,and(hg)  (fg) when(h) he(g) had(f) given(f)  (fg) thanks,(f)  he(f)  (f) distributed(f)  (f) a(e) to(f) them(g) that(fe) were(d) set(cd) down.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-113.png",
        nextFileName: "./pages/part-a-114.png"
    },
    {
        title: "part-a-113-1",
        gabc: "W&#39;ith(ik)  (cd) five(fg) loaves(fgh) Tand(i) two(h) small(g) fishes,(fh)  (g) the(g) Lord(eg) sat-(h) is\u2014fi-(ik) (g) ed(f)  (g) five(ec) thousand(eg)  (f) men.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-113.png",
        nextFileName: "./pages/part-a-114.png"
    },
    {
        title: "part-a-113-2",
        gabc: "T(c) he(f) Lord(ef) sat-(h)is\u2014fi-(h)ed(hj)  (i) five(hi) thousand(j)  (hi) men(i) with(i) five(gihg)  loaves(fe) and(ef) two(de) small(fh) e(f) fishes.(f) S(i)  (h)  (i) R(j)  (h) )(f) ",
        groupIndex: 2,
        filename: "./pages/part-a-113.png",
        nextFileName: "./pages/part-a-114.png"
    },
    {
        title: "part-a-113-3",
        gabc: "hen(dh) those(hi) men,!(h) when(h) they(h) had(h) seen(h) the(h) mi-(h)ra-(h)cle(hghihgg) that(fg) ",
        groupIndex: 3,
        filename: "./pages/part-a-113.png",
        nextFileName: "./pages/part-a-114.png"
    },
    {
        title: "part-a-114-0",
        gabc: "Je-(h)sus(gf) did,(gfd) said(d) un\u2014to(d)  (c) each(d) o-(ffg)ther:(f) This(h) is(g) of(f) J(e)  truth(g) that(fe) pro-(defe)phet(ddc) that(c) should(d) come(f) in-(ef)to(gh) the(fe) worlq(d)  AT(h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-114.png",
        nextFileName: "./pages/part-a-115.png"
    },
    {
        title: "part-a-114-1",
        gabc: "A(ik) B(dc~) Je-(dhi)sus(h) Twent(h) up(hj) into(h)  (h) a(h)  (h) mountain,(hghihgg) and(f) there(gh) e(fe)  sat(ik)  (def) with(ef) his(g)  (fe) disciples.(d)  (d) &quot;=(h)  (g) \xa5(f)  (gh) &amp;(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-114.png",
        nextFileName: "./pages/part-a-115.png"
    },
    {
        title: "part-a-114-2",
        gabc: "e(f) estroy(d) this(f) el(hi)  (h) S(h) ey(ij) Lord,(jih) and(h) in(ij) three(jih)  days(h) I(hg) will(f) raise(hi) it(hi) up:(f) )(hf) he(hi) spake(h) of(f) the(f)  temple(d)  (f) of(h) his(e) bo-(f)dy.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-114.png",
        nextFileName: "./pages/part-a-115.png"
    },
    {
        title: "part-a-115-0",
        gabc: "But(ff) no(e) T(f) 1aid(gh) hands(i) on(hg) him,(fe) because(h)  (ij) his(j) hour(ji) was(gh)  not(gi)  (i) yet(hg) come.(f) A(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-115.png",
        nextFileName: "./pages/part-a-116.png"
    },
    {
        title: "part-a-115-1",
        gabc: "-(j)nanT(hj) that(i) is(g) called(h)  (i) Je-(h)sus(g) made(i) clay(i) out(h) of(i) spittle(g)  (e)  and(e) _n(f) anointed(gh)  (g) mine(g) =(gh) and(fg) now(g) I(f) see.(e) |(j)  (h)  (j)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-a-115.png",
        nextFileName: "./pages/part-a-116.png"
    },
    {
        title: "part-a-115-2",
        gabc: "A(f) great(f) prophet(hi)  (i) Tis(i) ri-(h)sen(i) up(j) among(h)  (i) us,(i) and(gihg) God(fe)  hath(fe) vis-(d)it-(e)ed(f) his(h) people.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-115.png",
        nextFileName: "./pages/part-a-116.png"
    },
    {
        title: "part-a-115-3",
        gabc: "s(f) if(gh) thou(h) hadst(g) been(h) &amp;(ghg) La-(e)za-(f)rus(g) would(e) not(gh) ",
        groupIndex: 3,
        filename: "./pages/part-a-115.png",
        nextFileName: "./pages/part-a-116.png"
    },
    {
        title: "part-a-116-0",
        gabc: "have(fe) di-(ded)ed:(d) lo,(g) by(e) this(fgh) time(f) he(e) stinketh;(def)  (fcd) for(d) He(dc) hath(f)  lain(gh) in(h) the(g) grave(ghg) four(ef) days(g) al-(fe)rea-(d)dy.(d)  (h)  (g)  (f)  (g)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-116.png",
        nextFileName: "./pages/part-a-117.png"
    },
    {
        title: "part-a-116-1",
        gabc: "Save(f) me,(f) O(fgh) Lord,(hg) From(f) the(gh) li-(gfd)on\u2019s(fg) mouth.(gf) Save(f) me.(f)  Thou(h) hast(h) heard(hi) me(h) al-(gh)so(g) from(g) among(g)  (g) the(g) horns(h) of(g)  the(f) u-(g)y(gh) ni~corns.(hg) From(f) the(gh) li-(gfd)on\u2019s(fg) mouth.(gf) Save(f) me,(f)  0(gh) Lord,*(hg) From(f) the(gh) li-(gfd)on\u2019s(fg) mouth.(gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-116.png",
        nextFileName: "./pages/part-a-117.png"
    },
    {
        title: "part-a-117-0",
        gabc: " (f)  (gi)  (i)  (hgf)  (g)  (ghg)  (f)  (ed)  (g)  (g)  (h)  (fed)  i.(f)  (edf)  (dc)  (cd)  (d)  (d)  (f)  (dc)  (f)  (fgh)  (g)  (gf)  ?.(f) Deliver(fhihg) me,(h) 0(fe) Lord,(d)  (f) from(f) i.(dc) evil(cd) ",
        groupIndex: 0,
        filename: "./pages/part-a-117.png",
        nextFileName: "./pages/part-a-118.png"
    },
    {
        title: "part-a-117-1",
        gabc: "I(e) am(hf~) one(h) that(h) bear(hgfg) witn\xe9ss(g)  (fe) of(ghih) myself,(ih)  (g) and(gh) the(h)  Father(ij)  (i) that(hf) sent(fg) me(e) beareth(e) PR(fh) witness(hgf) R(g) of(f) me.(e) el(hghf) |(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-117.png",
        nextFileName: "./pages/part-a-118.png"
    },
    {
        title: "part-a-117-2",
        gabc: "I(hg) have(f) not(g) a(gh) devil,f(fe)  (e) but(f) I(df) honour(h)  (g) my(f) Father,(hi)  (f) saith(fd)  the(f) .-(e) (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-117.png",
        nextFileName: "./pages/part-a-118.png"
    },
    {
        title: "part-a-118-0",
        gabc: "I(g) seek(hj) not(j) Tmine(h) own(j) htacue(ih)  (g) ahws(g) da(g) e(h) oy(g) TR(ef)  eth(g) and(gh) A(e) 8-(e)AT(j)  (h) SEXT(j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-118.png",
        nextFileName: "./pages/part-a-119.png"
    },
    {
        title: "part-a-118-1",
        gabc: "N(dc)  (f)  (g) ve-(f)ri-(gh)ly,T(h) I(h) say(j) un-(h)to(g) you,(h) If(h) a(g) man(fg) keep(ghi)  my(h) A(gf) saying,(f) he(gh) shall(g) never(fe)  (dc) taste(d) of(efe) death.(d) N(h)  (g)  (f) I(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-118.png",
        nextFileName: "./pages/part-a-119.png"
    },
    {
        title: "part-a-118-2",
        gabc: "T(c) he(d) Jews(cd) took(f) up(fe) stones(dc) Tto(ef) cast(g) at(fe) him:(d) but(ifghghih) Je(hg) sus(fe)  hid(gh) o(fe) himself,(d) and(fe) went(ge) out(gh) of(f) the(e) -(d)temple.(d) B(h)  (g)  (f) s(gh) |(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-118.png",
        nextFileName: "./pages/part-a-119.png"
    },
    {
        title: "part-a-118-3",
        gabc: "o(gi) Your(e) fa-(fgh)ther(h) A-(ij)bra-(hg)ham(fhffe) re(hiji) joic-(i)ed(g) to(i) see(ij) my(hg) day:(f)  and(f) he(ec) saw(e) it(f) and(h) was(g) glad.(f) Sl(h) i(g)  (e)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-a-118.png",
        nextFileName: "./pages/part-a-119.png"
    },
    {
        title: "part-a-119-0",
        gabc: "me,(d)  (dh)  (h)  (hj) O(hg)  (h) set(h)  (hg) me(ef) beside(g)  (fe) thee:(d) and(d) I(e)  care(fe) mot(d) who(ef) lifteth(gh)  (ghg) his(ef) hand(g) &#39;a-(fe)ginst(d) me.(d)  (h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-119.png",
        nextFileName: "./pages/part-a-120.png"
    },
    {
        title: "part-a-119-1",
        gabc: "O(f) Lord,(e) thou(f) hast(h)  (hj)  (i) -(i)causes(h)  (i) of(j) my(ih) soul:(i)  thou(i) hast(f) defended(i)  (g) my(h)  (fe) life,(f) O(e) Lord(de) my(fh) God.(f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-119.png",
        nextFileName: "./pages/part-a-120.png"
    },
    {
        title: "part-a-119-2",
        gabc: "O(f) my(h) people,1(hi)  (i) what(i) have(h) I(i) dome(j) unto(i)  (h) thee?(i) and(i) where-(f) in(i) have(g) I(h) wea-(f)ri-(f)ed(e) \xa2(fe) tes-(d).(e) fy(f) a-(h).(f) me.(f)  165(i)  (h)  (i)  (j)  (h)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-119.png",
        nextFileName: "./pages/part-a-120.png"
    },
    {
        title: "part-a-120-0",
        gabc: "e-(hi)vil(i) The(i) ](i) recompensed(h)  (j) for(h)  (hj) good?(i) for(f) a(g)  have(g) dig-(fe)ged(f) w(e) pit(ed~) for(f) &quot;(fh) soul.(f) \xa7|(i)  (h)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-120.png",
        nextFileName: "./pages/part-a-121.png"
    },
    {
        title: "part-a-120-1",
        gabc: "[f(f) a-(e)ny(f) man(h) thirst,(i) let(h) him(i) come(j) e(i) to(h) TR(ij) and(j) drink:(i)  and(i) out(fi) of(g) his(h) bel-(fe)ly(f) shall(e) flow(ed) living(f)  (g) wa-(h)ter,(gg) saith(hi)  the(hhg) Lord.(f) R(i)  (h)  (i) S(h) PR(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-120.png",
        nextFileName: "./pages/part-a-121.png"
    },
    {
        title: "part-a-120-2",
        gabc: "\u2014(c) (Govye(d) u(f) Tun-(f)to(e) this(gfe) -(d)&#39;I(ffdefec) go(f) not(f) up(hih) yet,(gg)  for(f) my(f) time(gf~) is(f) not(ef) yet(g) full(fe) come.(d) &amp;+(h)  (g) 5T(f)  (g)  (gfedf) ",
        groupIndex: 2,
        filename: "./pages/part-a-120.png",
        nextFileName: "./pages/part-a-121.png"
    },
    {
        title: "part-a-121-0",
        gabc: "ny(f) good(h) 5(i) have(h) I(i) wrought(j) among(h)  (i) you.(i) for(f) which(g)  (h)  of(h) those(f) works(fe) do(d) wish(f) to(h) kill(f) me?(f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-121.png",
        nextFileName: "./pages/part-a-122.png"
    },
    {
        title: "part-a-121-1",
        gabc: "ith(e) desire(f)  (hi) T(i) have(j) de-(ih)sir-(i)ed(i) to(fi) eat(g) this(h) Pass-(f)o-(fe)ver(f)  before(e)  (f) I(h)  with(e) you(c) before(f) I(h) suffer.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-121.png",
        nextFileName: "./pages/part-a-122.png"
    },
    {
        title: "part-a-121-2",
        gabc: "The(c)  (c) r(dc~)  (dfddc) o(d) onsulted(f)  (gh) how(hih) they(g) might(ig) take(hh)  Je-(g)sus(f) [](e) kill(c) 5(d) they(f) salid,(dfddc) Not(f) on(hh) the(g)  feast(ig) day,(h) lest(h) there(g) be(f) ](e) up-(f)roar(gh)  (hg) the(f)  (gf)  people.(d)  (d) ](h)  (g)  (f)  (g) =(gfed) ",
        groupIndex: 2,
        filename: "./pages/part-a-121.png",
        nextFileName: "./pages/part-a-122.png"
    },
    {
        title: "part-a-122-0",
        gabc: "R(f) N(ed)  (f) LS(fed) the(ef) w(ggf) hath(ggh) not(gf) T(e) T(e)  have(ki~)  (fg) known(hgf) thee,(eed) T(cd) because(df) thou(gh) m(fg) T(e) me.(e) }E&#39;ggl(h)  (g)  (h)  (ih) I(gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-122.png",
        nextFileName: "./pages/part-a-123.png"
    },
    {
        title: "part-a-122-1",
        gabc: "chil(ik)  (d)  (d) of(dc)  (f) the(g) Hebrews,t(fh)  (h) carrying(h)  (j)  (h) palms(h) and(g) o-(hg)live(f)  branches,(ki~)  (gh)  (h) went(f) forth(h) to(gf) meet(g) the(fe) Lord,(d) crying(f)  (fe) and(dc)  (df)  g(ik) i(ffg) saying;(f) Ho-(f)san-(hg)na(hge) in(f) the(e) highest.(d)  (d) |(h) N(g)  (f)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-122.png",
        nextFileName: "./pages/part-a-123.png"
    },
    {
        title: "part-a-122-2",
        gabc: "The(cc)  (d)  (d) of(dc)  (f) the(g) Hebrews(fh)  (h) spread(hj) their(h) garments(h)  (g) in(h) the(gf)  way,(fg) end(h) cri-(g)ed,(ef) e(ed) saying:(d) Hosanna(d)  (f) e(d) to(e) the(f) Son(g) of(ef) David;(f)  (g)  blessed(f) a(e) is(f) he(fgh) that(g) cometh(fg)  (f) the(f) Name(g) of(e) the(fe) Lord.(d) I(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-122.png",
        nextFileName: "./pages/part-a-123.png"
    },
    {
        title: "part-a-123-0",
        gabc: "[n-(e)to(f) thee,(h) O(hj) Lord,(i) have(i) I(h) 0(i) revealed(j) a(i) my(h) cause:(i) thou(i)  hast(f) defended(i)  (g)  (h) my(fe) life,(f) O(e) Lord(de) my(fh) God.(f)  (i) RS(h) &quot;(i)  (j)  (h) B(fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-123.png",
        nextFileName: "./pages/part-a-124.png"
    },
    {
        title: "part-a-123-1",
        gabc: "I(h) will(hi) call!(i) up-(i)on(h) thy(i) Name,(j) O(ih) Lord:(i) turn(fi) not(g) a-(h)way(f)  (e)  thy(e) face(fe) from(de) my(fh) calling.(f) T(f) T\u2014(i)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-a-123.png",
        nextFileName: "./pages/part-a-124.png"
    },
    {
        title: "part-a-123-2",
        gabc: "For(f) it(fg) is(g)  (fghihg) I(hg)  (gh) will(fg) smite(g) the(fgh) shepherd,(f)  (f) and(f)  (h)  the(h) sheep(j) shall(hi) \u2018&#39;be(jk) &quot;(h) scattered.(g) e(g) But(h) after(f)  (h) I(j) am(k) ri-(ji)sen(hj)  a-(j) (jjk) gain,(kj) I(k) will(k) go(j) be-(ij)fore(h) you(gf) in-(h)to(gh) Galilee:(f)  (f)  (f) there(g)  A(e) ye(g) LI(fe) me,(d) saith(fh) the(fg) Lord.(g) ST(j) TN(i)  (j) ST(h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-123.png",
        nextFileName: "./pages/part-a-124.png"
    },
    {
        title: "part-a-124-0",
        gabc: "\xbb(e) hid(hg)  (h) face(hi)  (g) from(ef) shame(g) and(fg) spitting.(e)  (e) INI(h)  (h)  (h) L(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-124.png",
        nextFileName: "./pages/part-a-125.png"
    },
    {
        title: "part-a-124-1",
        gabc: "wake,(h) O(hgf) sword,(fh) a(d) gainst(gf) them(fh) that(g) scatter(hi)  (g) my(ef)  flock.(g)  (f)  (h)  (g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-124.png",
        nextFileName: "./pages/part-a-125.png"
    },
    {
        title: "part-a-124-2",
        gabc: "S(ki~) o(d) they(df) weighed(g)  (e) for(gh) my(e) price(d) thirty(f)  (fe) pieces(d)  (e) of(f) sil-(g) ver,(d) the(f) price(fe) that(d) was(f) prised(g)  (f) at(gh) of(ff) them.(d)  (h) a(g)  (f) [(h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-124.png",
        nextFileName: "./pages/part-a-125.png"
    },
    {
        title: "part-a-124-3",
        gabc: "Be-(g)hold,(h) O(g) Lord,(f) the(f) lips(g) of(h) them(j) that(i) rise(hj) up(i) &amp;(g)  gainst(g) me,(h) and(h) their(i) devices.(h) &amp;R(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 3,
        filename: "./pages/part-a-124.png",
        nextFileName: "./pages/part-a-125.png"
    },
    {
        title: "part-a-125-0",
        gabc: "couldest(f)  (e)  (f) have(h) no(ij) power(i)  (i) at(h) all(j) a-(ih)gainst(i) me,(i) e\u20ACX-(i) =(fi) it(g) were(h) given(f)  (e) thee(fe) from(de) a-(fh)bove.(f)  (i)  (h) &quot;1(i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-125.png",
        nextFileName: "./pages/part-a-126.png"
    },
    {
        title: "part-a-125-1",
        gabc: "See,(g) O(h) Lord,T(i) and(j)  (i) consider,(hh)  (g) for(g) I(f) am(e) in(f) trouble:(h) O(f)  (e)  haste(e) thee(g) and(h) hear(f) me.(e) TERCE(j)  (i)  (h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-125.png",
        nextFileName: "./pages/part-a-126.png"
    },
    {
        title: "part-a-125-2",
        gabc: "[}(g) IE(iij) thou(i) my(j) cause,(k) O(j) Lord:(ij) O(i) de-(g)liv-(h) (h) er(fe) me(e) from(f) i(e)  a(jk)  a(e) .(f) deceitful(hhg)  (f) and(hihi) wicked(gg)  (hf)  (df) man.(ee) 1(j) &quot;(i)  (h) a(g)  (fhfh) ",
        groupIndex: 2,
        filename: "./pages/part-a-125.png",
        nextFileName: "./pages/part-a-126.png"
    },
    {
        title: "part-a-125-3",
        gabc: "&amp;(e) o(e) was(g) in(h) troublet(i) &quot;(hih) I(f) cried(h) 000000000(g) un-(f)to(e) Lord(e) out(f)  R(e) the(d) @(e) belly(e) of(fe) :(f) and(h) .(fe) A(fgf) me.(e) [(i) A(h)  (gf) ](i) ",
        groupIndex: 3,
        filename: "./pages/part-a-125.png",
        nextFileName: "./pages/part-a-126.png"
    },
    {
        title: "part-a-126-0",
        gabc: "T&#39;he(c)  (g) ungodly(g)  (g)  (fe) s\xe9id,?(dc) Let(g) us(f) oppress(g)  (h) the(gf) righteous(g)  (gh) man,(f)  a(g) because(f) he(g) is(h) clean(jk) :(i) contrary(ji) to(hg)  (fe) our(fg) doings.(g)  (g) |(j)  (i) )(j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-126.png",
        nextFileName: "./pages/part-a-127.png"
    },
    {
        title: "part-a-126-1",
        gabc: "&quot;(e) have(f) ~(hi) a(i) a(i) lay(hi) down(j) my(h) life,(i) and(i) T(gi) have(hg)  pow-(fe)er(f) to(e) take(de) it(f) a-(h)gain.(f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-126.png",
        nextFileName: "./pages/part-a-127.png"
    },
    {
        title: "part-a-126-2",
        gabc: "D(c)  (h) liv-(f)er(h) me(gf) tfrom(h) blood-(j)guiltiness,(jk)  (ji)  (j) O(j)  (jh) God(ij) my(i) God:(gh) and(f)  my(gh) tongue(i) shall(j) sing(h) of(g) =(gh) PR(i) righteousness.(hg) LI(g) 1(j) N(i)  (j) 1(h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-126.png",
        nextFileName: "./pages/part-a-127.png"
    },
    {
        title: "part-a-126-3",
        gabc: ",(h) eproaches(hg) O(e) Tand(f) R(hih) oY(hg) have(hg) I(f) suffered(g)  (h)  (f) a(e) them:(e) ",
        groupIndex: 3,
        filename: "./pages/part-a-126.png",
        nextFileName: "./pages/part-a-127.png"
    },
    {
        title: "part-a-127-0",
        gabc: "and(e) the(d) Lord(ef) is(hi) withme(hg)  (hih) as(h) a(h) mighty(hg)  (f) terrible(gh)  (f)  (gf) one.(e)  AT(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-127.png",
        nextFileName: "./pages/part-a-128.png"
    },
    {
        title: "part-a-127-1",
        gabc: "These(ef) al-(hi)so(i) Tthat(hi) seek(jk) the(i) hurt(hi) of(g) my(hg) soul,(f) they(e) shall(f)  go(ig~)  (hi) un-(gh)der(e) the(gh) earth.(f) 1w(h)  (g) a1(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-127.png",
        nextFileName: "./pages/part-a-128.png"
    },
    {
        title: "part-a-127-2",
        gabc: "ind(f) the(hi) nations(hg)  (h) Tof(g) the(ig) heathen(h)  (g) with(ef) chains,(g) O(fe) Lord;(d)  and(e) their(f) 8(ge) princes(f) with(e) fetters.(d)  (d) &amp;(h)  (g) _(f) a(g) am(ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-127.png",
        nextFileName: "./pages/part-a-128.png"
    },
    {
        title: "part-a-127-3",
        gabc: "&amp;(ig~) A(ff) nmaid(e) said(f) un-(h)e(g)  (f) -(fe)Surely(h)  (i) thou-(j)art(i) one(j) of(gh)  \u2018(gi) them,(fhffe) for(e) thy(f) speech(h) B(gh) bewrayeth(i) C(gh) thee.(f) o(h) ~(g) R(e)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-a-127.png",
        nextFileName: "./pages/part-a-128.png"
    },
    {
        title: "part-a-128-0",
        gabc: "A(f)  (g)  (h) al-(f) (gh) le-(g)lu-(f)ia,(dc) al-(f)le-(gh)lu-(dfg)ia.(f) |(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-128.png",
        nextFileName: "./pages/part-a-129.png"
    },
    {
        title: "part-a-128-1",
        gabc: "n(e) the(e) end(eh) &#39;of(fe) the(d) sabbath,T(ef)  (e) as(h) it(g) be-(h)gan(ij) to(i) dawn(i)  toward(i) the(j) 3(h) day(f) of(h) the(h) week,(g) came(h) Ma-(h)ry(h) Mag-(f)T(h)  le-(gf).-(e)a(e) a(e) o-(f)ther(g) Ma-(f)ry(f) to(f) see(h) the(f) se-(f)pul-(dfe)N(d)  al(fe~) -(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-128.png",
        nextFileName: "./pages/part-a-129.png"
    },
    {
        title: "part-a-128-2",
        gabc: "s(g) De(g) &quot;(g) .(g) peace,(h) a(g) le-(f):(hg)  (h) 2(gji) 0(g) .(f)  (gh) 1l(hg) ",
        groupIndex: 2,
        filename: "./pages/part-a-128.png",
        nextFileName: "./pages/part-a-129.png"
    },
    {
        title: "part-a-129-0",
        gabc: "a(c)  (e) An-(eh)gel(f) of(efe) the(de) Lord(e) T(g) descended(h)  (i) from(hf) heaven,(h)  (g) and(hih)  came(gh)  (hgfh) and(h) rolled(hg)  (f) back(g) the(gh) stone(fe) from(e) the(e) door,(f) and(e) sat(d)  up-(f)on(h) it,(g) al(f) -(gh)lu-(f)1a,(ed) al-(def)le-(f)lu-(e)ia.(e) ||(h)  (g) al](h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-129.png",
        nextFileName: "./pages/part-a-130.png"
    },
    {
        title: "part-a-129-1",
        gabc: "nd(gi) i(j) behold,(i) there(i) z(gh) a(i) great(hg) &amp;(e) earthquake:(e) for(h) the(h)  A(h) Angel(h) of(f) the(h) Lord(g) descended(f)  (e) .(f) from(f) heaven,(f)  (f) al(g) -(f) 175(e)  (e)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-129.png",
        nextFileName: "./pages/part-a-130.png"
    },
    {
        title: "part-a-130-0",
        gabc: "is(h) a(hihh)  (e) a(e) t(j) was(g) like(ih) lightning,(hih)  (h)  (hg) and(h) his(h) raimen(gf) ;(e)  white(g) as(e) snow,(f) al-(f)le-(e)lu-(c)ia,(d) al-(ef)le-(f)lu-(e)ia.(e)  (hf)  (h)  (i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-130.png",
        nextFileName: "./pages/part-a-131.png"
    },
    {
        title: "part-a-130-1",
        gabc: "nd(g) for(h) fear(i) of(gh) him(i) tthe(i) keepers(j)  (i) did(g) shake,(hi) and(f) ](e)  came(h) as(h) dead(fh) men,(gfe) al(fg) le(f) lu-(e)ia.(e) J(j) T(i)  (h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-130.png",
        nextFileName: "./pages/part-a-131.png"
    },
    {
        title: "part-a-130-2",
        gabc: "a(e) a(e) An-(eh)gel(f) an-(f)swer-(ed)ed(efe) and(de) a-(e)un-(gh)to(i) the(hf) women,(h)  (g)  Fear(h) not(gf) ye,(e) for(g) &#39;I(fe) know(fgf) that(g) ye(h) seek(ij) Je(ih) sus,(gh)  al(hgi)  (ih) le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-130.png",
        nextFileName: "./pages/part-a-131.png"
    },
    {
        title: "part-a-130-3",
        gabc: "T(jik)  (c) he(f) Lord(g) is(f) ri-(f)a(e) from(g) the(g) tomb,(h) Al-(h)le-(hg)lu-(g)is,(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-130.png",
        nextFileName: "./pages/part-a-131.png"
    },
    {
        title: "part-a-131-0",
        gabc: "al-(d)le-(fg)lu-(gf)ia.(f) The(f) Lord.(g) \xa5.(c) Who(f) for(f) our(g) sakes(f) hung(f)  up-(e)on(g) the(g) tree.(h) Al-(h)le-(hg)lu-(g)ia.(f) Glory(f)  (f) be(f) to(f) the(e)  Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g) Holy(h)  (g) Ghost.(cgf) The(cf) Lord.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-131.png",
        nextFileName: "./pages/part-a-132.png"
    },
    {
        title: "part-a-131-1",
        gabc: "[](e) a(e)  (f)  (g)  (h) a-(g) (f)  (e) i(h)  (h) [](h)  (g)  (e)  (f)  (h)  (hihg)  This(f)  (g) is(h) the(i) day(g)  (h) which(g) :(f) Lord(f)  (g) hath(h) made,(g)  (f) alleluia.(g)  (f) \u2122(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-131.png",
        nextFileName: "./pages/part-a-132.png"
    },
    {
        title: "part-a-131-2",
        gabc: "Ang(e) ve-(eh)ry(f) early(f)  (ed) in(ef) the(f) a(e) morningT(e) the(gh) first(i) day(f) of(fi)  the(h) week,(g) they(i) came(i) un-(h)to(h) the(h) sepulchre(ij)  (i)  (hghih) at(h) the(f) ris-(h) Ing(e) of(f) the(e) sun,(ed) al(ef) le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-131.png",
        nextFileName: "./pages/part-a-132.png"
    },
    {
        title: "part-a-132-0",
        gabc: "Lord(ik)  (f)  (gh) is(f)  (fe) in-(dc) (fg) deed,(ii) Al(hij) \u2014le(ihgfe) lu-(gh)ia,(f)  1(ik)  (cd) le(fgiihgfe) lu-(gg)ia.(f) The(f) Lord.(gh) And(f) hath(gh) ap(fe)  ear\u2014;d(ik)  (dc)  (c) to(f) Simon.(fg)  (i)  (i) Al(hihij) le(ihgfe) lu-(h)ia.(f) \xa5.(c) Glory(f)  (f)  be(ik)  (g) to(f) the(f) Father(gh)  (f) and(g) to(fe) he(dc) Son,(c) and(c) to(df) the(f) Ho-(ghih)ly(gf)  Ghost.(f) The(f) Lord.(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-132.png",
        nextFileName: "./pages/part-a-133.png"
    },
    {
        title: "part-a-132-1",
        gabc: "The(ik)  (cc)  (f) Lord(g) is(f) risen(f) a(e) indeed,*(g)  (h) Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f)  The(f) Lord.(g) \xa5.(c) And(f) hath(f) appeared(f)  (g)  (f) to(e) Simon.(g)  (h) Al-(h)le-(hg) lu-(g)ia.(f) Glory(f)  (f) be.(f) The(f) Lord.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-132.png",
        nextFileName: "./pages/part-a-133.png"
    },
    {
        title: "part-a-133-0",
        gabc: "[(g)  (j)  (hg)  (ji)  (jk) .(j)  (i)  (h)  (h)  (hg)  (ef) 5(g)  M(eg)  (f) a(e) -(d)[(e) 2(e) .(dc)  (g)  (gh)  (j)  (j)  (i)  \xa7.(jk) This(ji) the(hg) day(i) N(hij) O(h) L(g) Lord(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-133.png",
        nextFileName: "./pages/part-a-134.png"
    },
    {
        title: "part-a-133-1",
        gabc: "nd(e) when(eh) they(f) 0y(efhf) ed,(ghg) they(gh) saw(i) that(j) the(i) stone(h)  was(g) rolled(f)  (f) a-(g)way:(e) for(e) it(g) was(ef) ve(f) ry(e) gr\xe9at,(cd) al-(e)le-(ed) lu-(c)ia.(c)  (h)  (f)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-133.png",
        nextFileName: "./pages/part-a-134.png"
    },
    {
        title: "part-a-134-0",
        gabc: "-(ggfd) (f) himself(gh)  (g) drew(g) near(h) to(g) his(g) .(g) disciplesg(h)  (g) in(g)  way,(df) and(d) went(fe) with(gh) them:(g) but(gj) their(j) eyes(k) were(i)  (j)  (h)  that(gh)  (g) should(f) not(gijkjihih) know(g) him:(g) and(g) he(h) rebukeq(g)  (h)  (g)  them,(g) say-(fe)ing,(d) O(defg) fools(gh) and(hg) slow(j) of(i) heart(j) to(h) believe(gh)  (gf)  all(dfg) that(fg) the(g) \u2014(gh) .(g) have(gh) =(fe) spoken,(d) e(f) le-(gh)lu-(g)ia.(g) I(jijh) 1)(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-134.png",
        nextFileName: "./pages/part-a-135.png"
    },
    {
        title: "part-a-134-1",
        gabc: "menner(fg)  (gh)  (h) of(h) commu-(g) (f) e(gh) ni-(h) (g) are(g) these(g) that(h)  Ye(fg) have(hi) one(g) to(h) another?(g)  (hg)  (f) as(f) ye(hj) walk,(ji) and(j) are(h)  sad?(ghg) al-(f)le-(g)lu-(fe)ia,(d) al(f) -(fgh)lu-(g)ia.(g) |(j) T(i)  (j) e(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-134.png",
        nextFileName: "./pages/part-a-135.png"
    },
    {
        title: "part-a-135-0",
        gabc: "5(g) stood(h)  (gf~) :(h) the(j) =(ji) of(g) his(hj) .(hg) disciples(hg)  (f) and(g)  (g)  said(g) un-(f)to(g) them,(h) Peace(jj) be(h) un-(j)to(j) you,(i) al-(g)le-(ij)lu-(h)ia,(gf)  al(gfh) le-(h)lu-(g)ia.(g)  (j) I(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-135.png",
        nextFileName: "./pages/part-a-136.png"
    },
    {
        title: "part-a-135-1",
        gabc: "e-(g)hold(j) m);(ig) hands(hij) Tand(h) my(hg) feet,(f) that(g) it(f) is(h) I(j) |(j)  my-(j)self,(ig) al-(i)le-(j)lu-(h)ia,(gf) al(gh) le(h) lu-(g)1ia.(g) |(j) T(i)  (j)  (h) a(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-135.png",
        nextFileName: "./pages/part-a-136.png"
    },
    {
        title: "part-a-135-2",
        gabc: "C(ighij) the(i) net(i) Ton(ij) the(i) right(h) side(fhi) of(h) the(g) [N(e) and(f)  ve(hi) shall(ih) find,(gh) al-(hi)le-(f)lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-135.png",
        nextFileName: "./pages/part-a-136.png"
    },
    {
        title: "part-a-136-0",
        gabc: "a-(eh)sus(f) saith(f) a(e) to(d) his(ef)  (fgf) disciples,(e) a(e) Bring(igj) of(ji) the(i)  fish(ig~)  (hghih) which(h) ye(h) have(f) now(ghg) caught.(e) Si-(e)mon(fh) Pe-(h)ter(f) went(hg)  up,(e) and(g) drew(i) the(h) net(i) to(h) land,(fh) full(h) of(hg) great(fe) fis(f) es,(ed)  al-(ef)le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-136.png",
        nextFileName: "./pages/part-a-137.png"
    },
    {
        title: "part-a-136-1",
        gabc: "a(e) ry(h) stood(i) Tat(j) the(h) sepulchre(h)  (fh)  (gf) [(e) &amp;(e) and(e) seeth(d)  (f)  (h)  two(h) An-(h)gels(f) in(h) white,(gf) sitting,(hh)  (g) and(g) the(h) napkin(iji)  (h) that(f)  (h)  was(ig~)  (h) a-(ih)bout(f) the(ed) head(ef) of(h) Je-(f)sus,(gh) al-(ih)le-(f)lu-(e)ia.(e)  (j) I(i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-136.png",
        nextFileName: "./pages/part-a-137.png"
    },
    {
        title: "part-a-136-2",
        gabc: "hey(g) have(g) ta(igij) ken(i) &#39;(i) way(jk) A(ji) Lord,(ji) and(h) I(j) know(kj) not(ih) B(f) ",
        groupIndex: 2,
        filename: "./pages/part-a-136.png",
        nextFileName: "./pages/part-a-137.png"
    },
    {
        title: "part-a-137-0",
        gabc: "where(fi) they(h) ha:&#39;e(g) laid(e) him.(e) If(e) thou(g) have(h) borne(i) him(j)  hence,(ih) tell(jkji) me,(jh) al-(ij)le-(j)lu-(i)ia:(i) and(i) I(j) will(i) take(h)  him(f) a-(h)way,(gh) al(hi) -(f)lu-(e)ia.(e) a(i)  (j) [](i)  (h)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-137.png",
        nextFileName: "./pages/part-a-138.png"
    },
    {
        title: "part-a-137-1",
        gabc: "he(i) e(h) lev-(h)en(g) disciples,(h)  (ij)  (i) when(hg) they(hi) saw(ii) the(ef) Lord(i)  in(h) li-(f)lee,(e) M(e) worshipped(e) Fim,(dc) al(d) -(ef)lu-(e)ia.(e)   (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-137.png",
        nextFileName: "./pages/part-a-138.png"
    },
    {
        title: "part-a-137-2",
        gabc: "A1l(g) pow-(j)er!(i) is(g) giv-(ij)en(hg) un-(h)to(g) me(f) in(g) heaven(f)  (h) and(j) in(j)  earth,(ki~)  (ig) al(ij) le(h) -(g)lu~\u2014ia.(g) P(j)  (i) DI(j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-137.png",
        nextFileName: "./pages/part-a-138.png"
    },
    {
        title: "part-a-138-0",
        gabc: "hey(d) 2n(dc) both(f) to-(g) (fh) gether,(h) and(h) the(h) other(hj)  (h) isciple(gf)  (igih)  (gf)  did(gh) outrun(g)  (fe) Peter,(df)  (fc) and(cd) came(ffd) first(fhg) to(f) the(g)  (f) sepulclire,(fe)  (dc)  al(ik)  (d) le(efe) lu(d) 1ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-138.png",
        nextFileName: "./pages/part-a-139.png"
    },
    {
        title: "part-a-138-1",
        gabc: "A(f) 1-(g)le-(h)lu-(f)al(hg) \u2014le-(g)lu-(ef)ila,(dc) al-(f)le(gh) -(fg)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-138.png",
        nextFileName: "./pages/part-a-139.png"
    },
    {
        title: "part-a-138-2",
        gabc: "The(ik)  (c) sdne(cd) day(d) tat(d) S(f) evening,(d)  (dc) b\xe9-(c)ing(d) the(d)  (fdfgh) ay(fe) of(d)  the(cd) week,(d) when(cd) the(fg) doors(hg) were(fg) shut(gfed) wHere(dc) the(f) dis-(g) ci-(f)ples(gh) were(h) as-(g) (g)  (gf) sembled,(d) came(d) Je(dg) sus(g) and(gh) stood(g) in(h) ",
        groupIndex: 2,
        filename: "./pages/part-a-138.png",
        nextFileName: "./pages/part-a-139.png"
    },
    {
        title: "part-a-139-0",
        gabc: "the(g) midst,(fgf) and(f) saith(fg) un-(f)to(f) them,(ef) Peace(g) be(f) un-(fg)to(fe)  \u201975;_:1(dc) -(d) (efe) 1lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-139.png",
        nextFileName: "./pages/part-a-140.png"
    },
    {
        title: "part-a-139-1",
        gabc: "Al-(eh)le-(f)lu-(f)a(e) ia,Tal(d) en(efe) 1lu(ed) [(e) B(j) al(g) -(h)1lu-(i)ia;(f)  Al-(h)le-(h)1u-(hih)ia,(gh) al(f) le(gh) -(f)a.Ja(e) al(e) &amp;(e) &amp;(e) ](d)  Al-(d)le-(f)lu-(h)ia,(g) al-(e)le(gh) -(f)1ia,(ed) al(ef) -(f)&quot;(e) @(e) .(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-139.png",
        nextFileName: "./pages/part-a-140.png"
    },
    {
        title: "part-a-139-2",
        gabc: "is(f)  (g) ri-(h)sent(g) from(g) the(h) grave,(fgf) who(fh) de-(g)liv-(h)er-(g)ed(fgh)  the(hg) three(f) children(gf)  (def) from(c) the(d) burning(f)  (f) fiery(g)  (f) furnace,(fe)  (dc)  al(f) le(g) 1y(fg) ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-139.png",
        nextFileName: "./pages/part-a-140.png"
    },
    {
        title: "part-a-140-0",
        gabc: "A(f) 1le-(ghg)1lu-(h)ia,T(gf) al(gh) le-(g)lu(fe) ia,(d) al-(f)le-(g)lu-(g)ia,(f) \u20141(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-140.png",
        nextFileName: "./pages/part-a-141.png"
    },
    {
        title: "part-a-140-1",
        gabc: "-(g) (gj)  (h)  (hg)  (h)  (g) lu-(h)ia,(g) al-(g)le-(f)lu-(g)ia,(h)  al(i) -(hg)1lu-(h)ia.(g) ||(j) &quot;(i)  (j)  (h) =(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-140.png",
        nextFileName: "./pages/part-a-141.png"
    },
    {
        title: "part-a-140-2",
        gabc: "A(c) IR(f) l\u2014le\u2014lu\u2014ia,f(h)  (h) T,(g) al(f) -(g)lu-(h)ia,(f) al(f) -(e)lu-(f)ia,(f)  al(g) le(f) [(e) ia.(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-140.png",
        nextFileName: "./pages/part-a-141.png"
    },
    {
        title: "part-a-140-3",
        gabc: "Al-(h)le-(h)lu-(i)ia,(hg) Tal-(fh)le-(gf)lu-(e)ia,(e) al-(e)le-(e)lu-(f)ia(ed)  al-(ef)le-(f)1lu-(e)ia.(e) I(h)  (f) ](h)  (i)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-a-140.png",
        nextFileName: "./pages/part-a-141.png"
    },
    {
        title: "part-a-141-0",
        gabc: "AL-(hd)le-(hi)lu-(h)ie,(gh) Tal(f) -(h)11(fe) :(df)  (f) e(f)  (f)  (ef)  (g)  al(g) le(fe) -(d)1ia,(d)  (h)  (g)  (f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-141.png",
        nextFileName: "./pages/part-a-142.png"
    },
    {
        title: "part-a-141-1",
        gabc: "A(ig~) 1-(g) (h) lu-(i)ia,T(i) al(ih) -(fh)lu-(fg)ia,(e) al(f) le(fhg) lu-(e)a(e)   (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-141.png",
        nextFileName: "./pages/part-a-142.png"
    },
    {
        title: "part-a-141-2",
        gabc: "A(h) frer(h)  (hih) when(hg)  (h) the(g) doors(fh) were(gf) shut,(e) the(ef)  (d)  Lord(ig~)  (df) en-(h)ter-(g)and(e) said(ef) un-(d)to(f) them,(h) Peace(g) a(e) un-(g) (g)  to(g) you,(h) al(f) \u2014-(d)lu-(f)ia,(g) al-(f) (d)  (fe)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-141.png",
        nextFileName: "./pages/part-a-142.png"
    },
    {
        title: "part-a-142-0",
        gabc: "A(g) le-(h)lu-(ij)ia,(i) Tal(ih) le-(fh)lu-(fg)ia,(e) al-(f)le-(fhg)lu-(e)ia.(e)  (i)  (j) T(i)  (hih) ",
        groupIndex: 0,
        filename: "./pages/part-a-142.png",
        nextFileName: "./pages/part-a-143.png"
    },
    {
        title: "part-a-142-1",
        gabc: "A(f) le-(f)lu-(hg~)ia,(h) tal-(h)le-(g)lu-(gh)ia,(ef) al-(g)le(fe) lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-142.png",
        nextFileName: "./pages/part-a-143.png"
    },
    {
        title: "part-a-142-2",
        gabc: "Al-(h)le-(g)lu-(h)ia,(f) al-(e)le-(d)lu-(e)ia,(f) e(g) lu-(fe) (f) ia.(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-142.png",
        nextFileName: "./pages/part-a-143.png"
    },
    {
        title: "part-a-142-3",
        gabc: "A(ki~)  (c) I-(g)le-(h)lu-(hj)ia,T(j) al(ji) le(hg) lu-(h)ia,(g) al(gf) le-(gh)lu-(gfe)ia.(e)  (j)  (hji)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-a-142.png",
        nextFileName: "./pages/part-a-143.png"
    },
    {
        title: "part-a-143-0",
        gabc: "g(g)  (hj) al-(j) (g)  (h) le-(g)lu-(e)ia,(f) al-(hg)le-(gf)lu-(e)ia.(e)  (j) T(h)  (j) ](ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-143.png",
        nextFileName: "./pages/part-a-144.png"
    },
    {
        title: "part-a-143-1",
        gabc: "A(h) le-(gh)lu-(f) (e) al-(g)le-(f)lu-(g)ia,(h) al-(f)le-(e)lu-(f)ia.(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-143.png",
        nextFileName: "./pages/part-a-144.png"
    },
    {
        title: "part-a-143-2",
        gabc: "Al-(f)le-(g)lu-(h)ia,(f) al-(gh)le-(g)lu-(f)ia,(dc) al-(f)le-(gh)lu-(fg)ia.(f) 178.(h)  (f)  (gh) |(g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-143.png",
        nextFileName: "./pages/part-a-144.png"
    },
    {
        title: "part-a-143-3",
        gabc: "He(c)  (c)  (e) the(ef) ho-(f)ly(h) Cross(hg) endured,(fg)  (g) Burst(gi) the(g) gates(hg) of(f) hell(gf)  in(ef) twain:(f) Begirt(f)  (fe) might(c)  (e) and(hf~) ma-(hg)jes-(fg)ty,(g) On(i)  Eas-(iji)ter(g) morn(hg) he(f) rose(gf) a-(ef)gain,(f) al(eg) le(gfhhfgf) lu(ef) ia.(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-143.png",
        nextFileName: "./pages/part-a-144.png"
    },
    {
        title: "part-a-144-0",
        gabc: "\u2014(c) Peace(f) be(f) .(f) s(f) a(e) it(g) is(g) I,(h) a(e)  (f)  (d) o(c)  (fe)  not(g) afraid,(g)  (h) al(h) -(hg)le-(fg)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-144.png",
        nextFileName: "./pages/part-a-145.png"
    },
    {
        title: "part-a-144-1",
        gabc: "Reach(eg) \xab(g) _\u2014-(h)thy(g) finger,T(h)  (g) and(f) ex-(hj)am-(ji)\u2014\u2014\uFB01(g) the(g) a(g)  of(i)  (g) the(g) nails,(gh) al-(g)le-(f)lu-(gh)ia:(h) and(h) be(j) not(g) faithless(h)  (g)  but(g) believing,(fe)  (f)  (d) al-(g)le-(h)lu-(i)ia,(j) al-(h)le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-144.png",
        nextFileName: "./pages/part-a-145.png"
    },
    {
        title: "part-a-144-2",
        gabc: "B(g) cause(g) thou(f) hast(h) seen(j) me,T(i) a(g) Thomas,(i) thou(j) hast(h) be-(g) lieved:(hg)  (f) &quot;(g) s(g) are(g) they(g) that(f) have(h) not(j) seen,(i) and(g)  yet(ik)  (j) have(h) believed,(g)  (h)  (gf) al-(gh)le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-144.png",
        nextFileName: "./pages/part-a-145.png"
    },
    {
        title: "part-a-145-0",
        gabc: "[(fg) did(g) put(hj) my(i)  (j) finger(h) in-(g)to(g) the(hi) print(g) of(h) the(g) nails,(f)  (fe)  and(d) thrust(e) my(fg) hand(g) in-(jh)to(i) his(j) side,(h) and(hijg) said,(g) My(eg)  Lord(f)  (fe) and(d) my(ef) God,(gf) al-(gh)le-(h)lu-(g)ia.(g)  (j) I(i)  (j) 1(h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-145.png",
        nextFileName: "./pages/part-a-146.png"
    },
    {
        title: "part-a-145-1",
        gabc: "[(f) amTthe(ggf)  (h) Shepherd(j)  (ij) of(hg) the(fg) sheep:(g) I(ji) am(jkji) the(h) way,(ji)  the(hg) truth,(hi) and(h) the(g) life:(ghg) I(fg) am(g) the(f) Good(gh) Shepherd;(f)  (f)  and(f) I(hj) know(ji) my(hg) sheep,(g) -(e)am(f) known(g) of(f) (D(edc) .(c) le(d)  Q(e) ia,(f) al-(gh)le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-145.png",
        nextFileName: "./pages/part-a-146.png"
    },
    {
        title: "part-a-146-0",
        gabc: "\u2014(ik) I(g) am(hj) the(i) Good(hj) Shepherd,(ji)  (g) who(g) feed(hi) my(hg) sheep:(eg) and(g)  I(hj) lay(h) down(j) my(j) life(ihg) for(gh) my(g) sheep,(ef) al-(g)le-(gf)lu-(e)ia,(e)  &gt;(j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-146.png",
        nextFileName: "./pages/part-a-147.png"
    },
    {
        title: "part-a-146-1",
        gabc: ".(e) Good(fh) =(gh) Shepherd(h) Tlay(g)  (hiji) eth(h) down(fh) his(gf) life(e) for(f)  (hgf)  the(gi)  (gf) sheep,(ed) al(e) le(ed) lu-(c)1ia.(c)  (h)  (f)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-146.png",
        nextFileName: "./pages/part-a-147.png"
    },
    {
        title: "part-a-146-2",
        gabc: "St(j)  e(g) that(g) is(gj) an(h) hireling,(gi)  (i) whose(ij) own(k) the(kj) sheep(i) are(kj)  not,(k) se-(i)eth(k) the(j) wolf(ji) coming,(gh)  (g) and(hg) leaveth(j)  (i) the(h)  sheep,(ghihg) and(gh) fle-(f)kth:(ed) and(g) the(h) wolf(ji) catch-(gihg)eth(hg) them(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-146.png",
        nextFileName: "./pages/part-a-147.png"
    },
    {
        title: "part-a-147-0",
        gabc: "and(g) \u2014(e) scattereth(f)  (g) the(h) sheep,(gf) al-(g) (gf) lu-(e)ia.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-147.png",
        nextFileName: "./pages/part-a-148.png"
    },
    {
        title: "part-a-147-1",
        gabc: "A(c)  (d) the(fh) Fa-(hg)ther(fe) knoweth(h)  (ih) me,(h) e-(h)ven(i) so(j) know(kj) I(i) the(h)  (h)  Fa-(hi)ther:(f) and(f) I(gg) &lt;lay(hi) down(h) my(g) life(hh) for(d) the(e) sheep,(fg)  (h)  al(h) le(e) lu-(d)1ia.(d) M(h)  (i)  (g) ](h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-147.png",
        nextFileName: "./pages/part-a-148.png"
    },
    {
        title: "part-a-147-2",
        gabc: "OI(ffe)  (dc) I(c)  (d) have,(ffgf) which(gi) are(ih) not(g) of(ih)  (gf) fold:(gf)  them(hi) al-(j)so(hih) must(gf)  (dedcd)  (dc) and(f) they(f) shall(fg) hear(h) my(gf)  voice;(f) and(hjihgf) there(gh) ja]l(fg) be(f) one(df)  (edcd) and(fghgi) one(hg)  Shepherd,(f)  (fg) al(h) le(g) lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-147.png",
        nextFileName: "./pages/part-a-148.png"
    },
    {
        title: "part-a-148-0",
        gabc: "A(cf) little(f)  (ef)  (d) shall(de)  (c)  (d) not(fg) see(fg) me,(f) saith(f)  the(gh) Lord:(hgf) and(f) again,(fgh)  (h) a(h) lit-(h)tle(gfgf) while,(d) and(ed) ye(cd)  shall(fg) see(fg) me,(f) because(d)  (f) I(g) go(h) to(g) the(f) Fa-(g)ther?(dfedc)  *1-(c)le-(d)lu-(ffg)ia,(gf) al-(g)le-(gh)lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-148.png",
        nextFileName: "./pages/part-a-149.png"
    },
    {
        title: "part-a-148-1",
        gabc: "ly,(g)  (fgh)  (h) I(h) say(hg) un-(h)to(hi) S(g) that(f) ye(g) shall(g) weep(hf)  and(ik)  (g) lament,(h)  (f) the(g) world(fg) shall(g) rejoice:(h)  (jijkj) and(j) ye(jk)  shall(j) be(h) sorrowful,(ji)  (hg)  (g) but(g) your(eg) ](fe) sorrow(f) shall(d) be(e) turned(f)  (gh)  (g)  in-(g)to(fg) joy,(gfd) al-(ef)le-(fg)lu-(g)ia.(g) |(j) v(i)  (j)  (h) a(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-148.png",
        nextFileName: "./pages/part-a-149.png"
    },
    {
        title: "part-a-149-0",
        gabc: "be(g)  (gj)  (h)  (h)  (g) turned(hg)  (f) in-(hg)to(h) joy,(g) al(ij) -(kh) lu-(j)ia:(i) and(jk) your(k)  (k) joy(jijkj) no(h) man(j) taketh(g)  (hg) [(fe) -(dc) (j)  .(c) -(d)L(e) 1ia,(f) al-(fh)le-(h)lu-(g)ia.(g) I(j) 1(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-149.png",
        nextFileName: "./pages/part-a-150.png"
    },
    {
        title: "part-a-149-1",
        gabc: "Sorrowlhath(fg)  (g)  (hj) filled(j)  (ji) your(hg) heart:(hg) and(hjij) your(hg) joy(hig) [](e)  man(f) .(g) taketh(f) from(edc) you,(c) al(c) -(d)1lu-(e)ia,(f) al(gh) -(h)lu-(g)ia.(g)  an(j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-149.png",
        nextFileName: "./pages/part-a-150.png"
    },
    {
        title: "part-a-149-2",
        gabc: "Y&#39;our(fe)  (g) .(h)  (e) -(f)lu-(d)i;&#39;,(c) shall(f) be(f) turned(f) [(e) in-(g) to(g) joy,(h) al-(h)le-(hg)lu-(fg)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-149.png",
        nextFileName: "./pages/part-a-150.png"
    },
    {
        title: "part-a-150-0",
        gabc: "ve-(d) (d)  (f)  (d) ri-(d)lly,(dc) I(f) say(g) un-(f)to(gh) w,&#39;ou,&#39;r(h) I(hghih) will(gf) see(fgh)  you(ik)  (f) again,(e)  (d) and(cd) your(f) heart(fg) shall(h) re-(gf)joice:(f) and(f)  your(g) joy(hgf) no(g) man(f) taketh(g)  (f) from(fe) you,(dc) al(d) le(efe) lu-(d)ia,(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-150.png",
        nextFileName: "./pages/part-a-151.png"
    },
    {
        title: "part-a-150-1",
        gabc: "Now(dh) I(j) go(h) my(g) way!(h) to(f) him(gh) that(fe) sent(d) me;(d) and(fc) none(fe)  of(d) you(fg) ask\xe9th(f)  (ed) n(c) -(ifhi):(h) go-(h)est(g) thou?(ghg) al(f) -(f) lu-(e)ia,(f) al(g) le-(fe)lu-(d)ia.(d) &quot;(h) =(g) _dd(f)  (gh)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-150.png",
        nextFileName: "./pages/part-a-151.png"
    },
    {
        title: "part-a-150-2",
        gabc: "Now(c)  (ff) I(e) go(f) my(g) wayl(h) to(i) him(hg) that(fg) sent(f) me:(e) but(h) because(j)  (jji)  (kji) ",
        groupIndex: 2,
        filename: "./pages/part-a-150.png",
        nextFileName: "./pages/part-a-151.png"
    },
    {
        title: "part-a-151-0",
        gabc: "I(ig~)  (h) have(i) said(j) these(i) things(hi) un-(i)to(hg) you,(f) sorrow(ih)  (hg) hath(fe)  (f)  filled(gi)  (ff)  (e) your(f) heart,(hg) al-(i)le-(hg)1lu-(f)ia.(f) a1(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-151.png",
        nextFileName: "./pages/part-a-152.png"
    },
    {
        title: "part-a-151-1",
        gabc: "I(ec) tell(fh) you(g) the(hi) truth;(i) Tit(hg) is(g) ex-(fg)pe-(ef)di-(fe)ent(e) for(fgf) you(gfefhfgh)  that(i) I(h) go(j) a-(ih)way:(h) for(g) if(hi) I(hg) go(fe) =(fg) a-(f)..(e) the(f) Com-(f) orter(ed)  (d) s(c) not(d) ](e) a(e) to(f) you,(ed) al-(e)le-(ed)lu-(c)ia.(c)  (hg)  (fg)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-151.png",
        nextFileName: "./pages/part-a-152.png"
    },
    {
        title: "part-a-151-2",
        gabc: "1(e) A(e) you(g) the(h)  (i) it(i) is(hg) ex-(fg)pe-(e)di-(ef)ent(e) O(c) you(egh)  that(g) I(h) go(i) a(iji) a-(g)for(g) if(i) I(hg) go(f) L(gh) :(g) 5(e) the(f) Com-(f) a(e) forter(f) T(c) a(c) 0(e) [(e) to(f) -(ef)al-(g)le-(fg)lu-(e)ia.(e) af](i)  (ji) ](h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-151.png",
        nextFileName: "./pages/part-a-152.png"
    },
    {
        title: "part-a-152-0",
        gabc: "hen(fhh) the(f)  (fgf) T(ef)  (f) the(h) Spirit(j)  (i) of(j) truth,(ih) ig(ij) come,(jii)  he(ig~)  (j) will(i) g(h) convince(hih) the(f) world(i) of(hg) sin,(f) and(e) of(f) right(h)  I(gi)  (h) eousness,(gh) and(i) of(hg) judgment,(dfe)  (gh) al-(i)le-(hg)lu-(f)ia.(f) I-(h)-(g) (e) I(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-152.png",
        nextFileName: "./pages/part-a-153.png"
    },
    {
        title: "part-a-152-1",
        gabc: "-(d)have(f) yetT(hh) ma-(h)ny(h) things(ih) to(g) say(ij) un-(h)to(gh) you,(h) but(i) e(h)  bear(gh)  (fe)  (f) them(ef) now:(d) how-(f) (d) be(f) when(hf) he,(hi) the(h)  Spirit(i)  (h) of(fg) e(hi) is(i) come,(h) he(i) T(i) guide(h) you(h) in-(f) to(fe) all(ef) truth,(de) al-(f)le-(e)lu-(d)ia.(d) |(h) =(h) &amp;\xab(i)  (g) &quot;(h) 1(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-152.png",
        nextFileName: "./pages/part-a-153.png"
    },
    {
        title: "part-a-152-2",
        gabc: "F(gi)  (cf) he(e) shall(gfh) not(gh) speak(i) of(hg) himself;(fg)  (fe) T(c) but(f) what-(h)so-(i)",
        groupIndex: 2,
        filename: "./pages/part-a-152.png",
        nextFileName: "./pages/part-a-153.png"
    },
    {
        title: "part-a-153-0",
        gabc: "ev-(gi) (j) er(i) he(g) shall(h) hear,(i) That(h) shall(gh) he(f) speak:(gf) and(f) he(g)  will(gi)  (h) shew(ijijkj) you(hh) things(iji) to(hg) come,(fe) al-(f) (ghg) lu-(f)ia.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-153.png",
        nextFileName: "./pages/part-a-154.png"
    },
    {
        title: "part-a-153-1",
        gabc: "H(gi) ith-(f) (ef) er-(f)to(f) ye(gh) ask-(i)ed(i) nothing(j)  (i) in(g) my(hg) Name:(f) ask,(g)  and(ig~)  (ef) ye(f) shall(e) receive,(fh)  (gh) al-(i)le-(hg)lu-(f)ia.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-153.png",
        nextFileName: "./pages/part-a-154.png"
    },
    {
        title: "part-a-153-2",
        gabc: "sk,T(df) and(e) ye(e) shall(h) receive,(g)  (fge) that(d) your(f) joy(hiih) may(j) be(hg)  full:(f) for(h) the(g) Fa-(h)ther(f) himself(hg)  (f) loveth(fg)  (f) you,(e) because(e)  (e)  e(ec) e(e) lov-(d)ed(c) -(d)and(c) have(c)  (d) believed,(e) 3(d) al-(ef)le-(f)lu-(e)ia.(e)  al(gi)  (h)  (g)  (h)  (f)  (efe) ",
        groupIndex: 2,
        filename: "./pages/part-a-153.png",
        nextFileName: "./pages/part-a-154.png"
    },
    {
        title: "part-a-154-0",
        gabc: "or(def) the(e) Father(def)  (e) T(f) himself(de) loveth(f)  (gh) you,(e) because(df) you(hi) haye(j)  lov-(h)ed(hg) me,(f) and(f) have(h) believed,(e)  (fe)  (d) al-(ef)le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (efe) ",
        groupIndex: 0,
        filename: "./pages/part-a-154.png",
        nextFileName: "./pages/part-a-155.png"
    },
    {
        title: "part-a-154-1",
        gabc: "[(ki~)  (cg) came(gj) forth(hg) from(h) the(gf) Father,T(gh)  (g) and(g) am(g) come(hij) in-(j)to(h)  the(j) world:(j) again(j)  (j) I(h) leave(j) the(g) world,(ghg) and(fe) go(g) to(f)  the(e) Father,(f)  (efd) al-(f)le-(fgh)lu-(g)ia.(g) S(j)  (i)  (j) R(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-154.png",
        nextFileName: "./pages/part-a-155.png"
    },
    {
        title: "part-a-154-2",
        gabc: "When(f) Christ(gh) ascended(f)  (fe) LI(dc) up(f) on(fg) high,(i) Al-(hij)le(ihgfe) lu-(fh)i#(f)  (d)  al-(d)le(fgiihgfe) lu-(gg)ia.(f) When(f) Christ.(gh) He(f) led(gh) cap-(f)ti-(fe)",
        groupIndex: 2,
        filename: "./pages/part-a-154.png",
        nextFileName: "./pages/part-a-155.png"
    },
    {
        title: "part-a-155-0",
        gabc: "bi-(dc)=(c) captive.(fg)  (i) B(h) Al(hj) le(ihgfe) lu-(gh)ia.(f) Glory(f)  (f) be(g)  vo(f) the(f) Father(gh)  (f) and(g) to(fe) the(dc) Son,(c) and(c) to(df) the(f) Ho(ghih) ly(gf)  Ghost.(f) When(f) Christ.(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-155.png",
        nextFileName: "./pages/part-a-156.png"
    },
    {
        title: "part-a-155-1",
        gabc: "hen(f) Christ(g) ascended(f)  (f) a(e) up(g) on(g) high,*(h) Al-(h)le-(hg)lu-(g)ia,(f)  ol-(d)le-(fg)lu-(gf)ia.(f) When(f) Christ.(g) V.(c) He(f) led(g) capti-(f)vi-(f)ty(f)  (e)  captive.(g)  (h) Al(h) le(hg) -(g)ia.(f) Glory(f)  (f) be(f) to(f) the(e)  Father(g)  (h) and(h) to(ihi) the(h) Son,(h) and(h) to(h) the(g) Ho-(h)ly(g) Chost.(gf)  When(f) Christ.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-155.png",
        nextFileName: "./pages/part-a-156.png"
    },
    {
        title: "part-a-156-0",
        gabc: "Fa(ff)  (def) I(fd) have(gf~) ma-(hi)ni-(hi)fest-(g)ed(f) thy(ghg) Name(f) un-(gh)to(f)  the(e) men(ed~) which(d) thou(cd) ga-(f)vest(fgf) me:(f) and(hihgf) now(ghg) I(h) pray(jk)  for(ji) them,(hg) not(h) for(j) the(i) world,(hih) because(fh)  (gh) I(eg) come(hg) to(fe)  (dc)  al(f) le(gh) lu-(g)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-156.png",
        nextFileName: "./pages/part-a-157.png"
    },
    {
        title: "part-a-156-1",
        gabc: "Ye(e) men(g) of(h) Ga(ihji) li-(hi)lee,(i) why(i) stand(i) ye(g) gazing(ij)  (i) up(h)  in-(h)to(i) heaven?(hg)  (e) This(d) same(fh) Je-(hi)sus,(h) which(hg) is(f) ta-(g)ken(h)  up(f) from(e) you(f) in-(e)to(f) heaven,(e)  (d) shall(h) so(hgf) come,(gh) al(hi) -(f) lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-156.png",
        nextFileName: "./pages/part-a-157.png"
    },
    {
        title: "part-a-157-0",
        gabc: "nd(gf~) while(g) they(g) look-(g)ed(g) 1&#39;st&#39;.edfast:ly(g)  (h) toward(i)  (gh) heaven(g)  (f) as(hj)  he(i) went(jk) up,(h) they(g) said,(hg) al(f) -(gh)1lu-(g)ia.(g)  (j)  (i) 1(j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-157.png",
        nextFileName: "./pages/part-a-158.png"
    },
    {
        title: "part-a-157-1",
        gabc: "He(f) lifted(e)  (f) up(h) his(hij) hands(i) tand(ih~) blessed(j)  (ih) them,(i) and(f) was(i)  .(jk)  (jk)  carried(g)  (h) up(f) in-(f)to(e) heav\u2019n,(fe) al-(ed)le-(fh)lu-(f)ia.(f) 1(i)  (h)  (i) 1(j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-157.png",
        nextFileName: "./pages/part-a-158.png"
    },
    {
        title: "part-a-157-2",
        gabc: "x-(fg)alt(g) ye(gf) Tthe(h) King(j) of(jkj) kings,(hih) and(g) sing(hj) a(g) hymn(h) un-(g)to(g)  d,(fed) al-(f)le-(gh)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-157.png",
        nextFileName: "./pages/part-a-158.png"
    },
    {
        title: "part-a-157-3",
        gabc: "hile(h) they(g) a(e) -(gh)he(f) ](e) taken(f) a(e) B(d) and(d) a(e) cloud(e)  ](e) ](e)  (d) him(f) out(h) of(g) [(e) -(gh)al-(f)le-(f)lu-(e)ia.(e)  (h)  (fh)  (i)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-a-157.png",
        nextFileName: "./pages/part-a-158.png"
    },
    {
        title: "part-a-158-0",
        gabc: "God(f) is(f) gone(f) up(g) with(f) a(e) merry(g)  (g) noise,*(h) Al(h) le-(hg)lu-(g)j,(f)  al-(d)le-(fg)lu-(gf)ia.(f) God(f) is(f) gone(f) up.(g) And(f) the(f) Lord(g)  with(f) the(f) sound(f) a(e) the(g) trump.(h) Al(h) -(hg)lu-(g)ia,(f)  Glory(f)  (f) be.(f) God(f) is(f) gone(f) up.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-158.png",
        nextFileName: "./pages/part-a-159.png"
    },
    {
        title: "part-a-158-1",
        gabc: "Se\u2014m(ik)  (f)  (efgh)  (g)  (fd)  (f)  (efg) et(f)  (e)  (g)  (hj)  (h)  (gf)  (g)  .(g) \u2018(f)  (ed)  (cd) a(d)  (dc)  (d) (](fe) a(de)  (e) a.(e)  (g)   (ki~)  (gh)  (g)  (fd)  (f)  (efg)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-158.png",
        nextFileName: "./pages/part-a-159.png"
    },
    {
        title: "part-a-159-0",
        gabc: "I.(c) ascend(ef)  (g) Tun-(g)to(h) my(jg) Father,(h)  (gg) and(fe) your(gfd) Father:(c)  (c) and(ef)  to(d) my(fg) God,(g) and(g) your(hg) God,(fe) al-(dc~)le(ed) lu-(cd)1a.(c) l(ghgf)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-159.png",
        nextFileName: "./pages/part-a-160.png"
    },
    {
        title: "part-a-159-1",
        gabc: "0(gi)  (fhhg) King(hf) of(gf) o(ef) \u2014(f) thou(f) Lord(g) of(hf) Sa-(g)ba-(f).-(e)who(f)  triumphing(gi)  (cf)  (f)  (f) to-(f)day(g) hast(f) ascended(f)  (g)  (f) above(f)  (g) all(h) heav\u2019ns,(kijijkj)  leave(ji) us(hg) not(fh) comfortless;(h)  (fgfe)  (e) but(fe) send(he) on(h) us(h) the(g)  promise(h)  (g) of(f) the(g) Fa(gfef) ther,(fec) e-(f)ven(e) the(f) Spirit(h)  (g) of(e)  truth,(gi)  (fe) al(f) le(ghg) lu-(f)ia.(f) R(h)  (gf) o(hg)  (e) 1(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-159.png",
        nextFileName: "./pages/part-a-160.png"
    },
    {
        title: "part-a-160-0",
        gabc: "(O(fhhg) King(hf) of(gf) glory,(ef)  (f) thou(e) Lord(fh) of(hg) Sa-(fg)ba-(f)oth,(e) who(f)  triumphing(gi)  (cf)  (f)  (f) to-(f)day(gf) hast(e) ascended(fh)  (h)  (f) above(e)  (gh) all(f) hea(khjkji) veng(ji)  leave(ig~)  (ij) us(i) not(hf)  (g) comfortless;(ef)  (f) but(fe) send(f) on(f) us(f) the(f) pro-(hg) mise(gi)  (hih) of(h) the(e) Fa(fefe) ther,(c) e-(f)ven(e) the(f) Spirit(h)  (i) of(hg) truth,(fe)  =(hgi) al(f) le(ghg) -(f)ia.(f) 1&quot;(h) p(gf) 1(hg) s(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-160.png",
        nextFileName: "./pages/part-a-161.png"
    },
    {
        title: "part-a-160-1",
        gabc: "hen(c) the(d) Comforter(f)  (e) is(f)  (g) come,(g) whom(fh) I(hg) will(gf) send(gh) un-(j)to(i)  you(j) from(i) the(h) Father,(j)  (g) e-(g)ven(h) the(f) Spirit(g)  (f) of(ed) truth,(df) ",
        groupIndex: 1,
        filename: "./pages/part-a-160.png",
        nextFileName: "./pages/part-a-161.png"
    },
    {
        title: "part-a-161-0",
        gabc: "which(c) proceedeth(d)  (f)  (fe) from(d) the(f) Father,(fg)  (g) he(hj) shall(j) testify(ji)  (hg) .(hi)  of(ik)  (gh) me,(g) al(ef) le(fg) lu(g) -(g)0O(g)  (f)  (d)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-161.png",
        nextFileName: "./pages/part-a-162.png"
    },
    {
        title: "part-a-161-1",
        gabc: "hese(d)  (dc) have(f) I(g) told(fgh) e(h) that(f) when(h) the(j) time(h)  shall(fg) come,(ghg) ye(g) may(h) ](g) remember(gf~) E(f) that(e) I(f) told(g) you(f) of(fe)  them,(dc) al(d) le(efe) lu-(d)ia.(d) 8(h)  (g)  (f) &amp;(gh) p(gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-161.png",
        nextFileName: "./pages/part-a-162.png"
    },
    {
        title: "part-a-162-0",
        gabc: "he(f) Ho(fg) 1y(f) Ghost,(fe)  (dc) Comforter,*(f)  (fg)  (i) Al(hij) le(ihgfe) lu-(gh)ia,(f)  al(dc) le(ifgiihgfe) lu-(gg)ia.(f) The(f) Ho-(fg)ly(f) Ghost.(fe) \xa5.(c) Shall(fg)  teach(fe) you(dc) all(fg) things.(i) Al(hij) le(ihgfe) lu-(gh)ia.(f) \xa5.(c) Glory(f)  (f)  be(ijk)  (g) to(f) the(f) Father(gh)  (f) and(g) to(fe) e(dc)  (c) and(c) to(df) the(f) Ho-(ghih) Ghost.(gf)  (f) The(f) Ho(fg) 1y(f) Ghost.(fe) ",
        groupIndex: 0,
        filename: "./pages/part-a-162.png",
        nextFileName: "./pages/part-a-163.png"
    },
    {
        title: "part-a-162-1",
        gabc: "T(c) he(f) Ho-(g)1y(f) Ghost,(f) the(e)  (g) Comforter,*(g)  (h) Al-(h)le(hg) -(g)ia,(f)  al(d) -(fg)lu-(gf)ia.(f) The(f) Ho-(g)1ly(f) Ghost.(f) Shall(f) teach(f)  a(e) all(g) things.(h) R.Al(h) -(hg)lu-(g)ia.(f) \xa5.(c) Glory(f)  (f) be(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-162.png",
        nextFileName: "./pages/part-a-163.png"
    },
    {
        title: "part-a-163-0",
        gabc: "to(f) the(e) Father(g)  (h) and(h) to(ihi) the(h) Son,(h) and(h) to(h) the(g) Ho-(h)1ly(g) e(g)  Ghost.(gf) The(f) Ho(g) 1y(f) Ghost.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-163.png",
        nextFileName: "./pages/part-a-164.png"
    },
    {
        title: "part-a-163-1",
        gabc: " (e)  (f)  (ed)  (e)  (fe)  (h)  (ih)  (h)  (h)  (e)  (f)  (h)  [l(ih)  (ij)  (ih)  (i)  (h)  (ij)  (hg)  (fe) .(hi)  (e)  (f)  (h)  V.(gh) They(ffe~d) were(f) all(fgf) filled(e) with(d)  (e) the(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-163.png",
        nextFileName: "./pages/part-a-164.png"
    },
    {
        title: "part-a-163-2",
        gabc: "I(cd) will(d) not(d) leave(de)  (d)  (cd) al(df)  (fe)  (d)  (cd)  (de)  (dc)  (f)  I(fgh) go;(ghg) but(f) I(gh) will(f) come(ef) to(cd) you,(def) al-(f)le-(cd)lu=(de)  (dc)  and(cd) your(de) hdart(dc) shall(cd) rejoice,(f)  (ef) al-(g)le(fe) lu-(d)ia.(d) &quot;o(h)  (g) &quot;(f) en,(g) [(gfed) ",
        groupIndex: 2,
        filename: "./pages/part-a-163.png",
        nextFileName: "./pages/part-a-164.png"
    },
    {
        title: "part-a-164-0",
        gabc: "W(c) hen(e) t;le(ed) day(g) of(hj)  (ji) Pentecost(j)  (j) twas(h) fully(i)  (h) come,(g) they(g)  were(hi) all(h) with(g) one(e) !(fg) accord(g) in(g) one(h) place,(gf) al-(g)le(gf)  -(ki~) (e) ia.(e)  (ji)  (hi)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-164.png",
        nextFileName: "./pages/part-a-165.png"
    },
    {
        title: "part-a-164-1",
        gabc: "T(ki~) he(d) Spirit(fhg)  (gh) of(h) the(g) Lord(fe) Thath(d) filled(fg) Il(gd) the(fg) whole(hgf) world,(gh)  al(ik)  (gfd) -(ef)1lu-(gh)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-164.png",
        nextFileName: "./pages/part-a-165.png"
    },
    {
        title: "part-a-164-2",
        gabc: "hey(gj) were(h) all(fg) filledT(gh)  (g) with(h) the(gf) Ho-(g)ly(gh) Ghost,(h) and(ij) be-(h) gan(j) to(k) speak,(ghg) al-(f)le-(fg)lu-(hg~)1a,(gf) al-(hg~)le-(h)lu-(g)ia.(g)  (j)  (i)  (jh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-164.png",
        nextFileName: "./pages/part-a-165.png"
    },
    {
        title: "part-a-165-0",
        gabc: "(O~(dh) ve(hj) wells,Tand(h)  (g) all(h) that(g) move(ef) in(g) the(fe) waters,(d)  (d) sing(fd)  a(ef) hymn(ghg) un-(f) a(ef) hymn(gh) un-(f)to(fe) God,(dc) al(d) le-(efe)lu-(d)ia,(d) |(h) e,(g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-165.png",
        nextFileName: "./pages/part-a-166.png"
    },
    {
        title: "part-a-165-1",
        gabc: "he(hg)  (f) A-(hi) (i) did(ijhg) speak(fh) with(ef) o-(f) (ef) ther(ede) tongues(ed) the(fh)  wonderful(h)  (hg) LI(fe) works(f) of(gf) God,(e) al(h) le-(f)lu-(ih~)ia,(i) al-(fe)1le-(fed) W(fe) ia,(f) al-(h)1le(fhfd) lu-(ff)ia.(e) &amp;\xab(i) \u2122(j) \xae(i) &quot;m(h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-165.png",
        nextFileName: "./pages/part-a-166.png"
    },
    {
        title: "part-a-165-2",
        gabc: "he(f) Spirit(f)  (f) of(f) the(f) Lord(g) hath(f) L(f) e(f) the(e) T(g) .(h)  Al-(h)le-(hg)lu-(g)ia,(f) al(d) -(fg)lu-(gf)ia.(f) The(f) Spirit.(f)  (f)  %.(c) And(f) that(f) which(f) containeth(f)  (f)  (f) all(g) things(f) hath(f) knowledge(f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-165.png",
        nextFileName: "./pages/part-a-166.png"
    },
    {
        title: "part-a-166-0",
        gabc: "of(g) the(g) voice.(h) Al(h) -(hg)1lu-(g)ia.(f) \xa5.(c) Glory(f)  (f) be.(f)  The(f) Spirit.(f)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-166.png",
        nextFileName: "./pages/part-a-167.png"
    },
    {
        title: "part-a-166-1",
        gabc: "N(gi)  (ef) SEE==s\u2014s(fjk)  (j)  (j)  (ji) a(ij)  (i) -(ih) (j) ==(j)  (i)  (hg) .(f)  4(gh) .(fe)  (ef)  (c)  (ef)  (f)  (fh) -(hf) (g)  (f)  (e)  %.(ig~)  (i) They(i) were(h) all(iji) filled(gf) with(gh) the(fe)  (ef) ",
        groupIndex: 1,
        filename: "./pages/part-a-166.png",
        nextFileName: "./pages/part-a-167.png"
    },
    {
        title: "part-a-166-2",
        gabc: "R(c) e(c) ceive(cfefg) =1(defedcd) the(dc) Ho\u20141ly(fe)  (fg) Ghost:(g) whose-(g)so-(f)ev-(hj)er(j)  sins(ji) ye(h) re-(g)mit,(h) they(g) are(gg) a(e) mitted(gh)  (g) un-(f)to(fe) th\xe9m,(cd)  .(e) le-(d)1u-(c)ia.(c)  (g)  (h)  (g)  (f)  (ed) ",
        groupIndex: 2,
        filename: "./pages/part-a-166.png",
        nextFileName: "./pages/part-a-167.png"
    },
    {
        title: "part-a-167-0",
        gabc: "[(d)  (d)  (f)  (d)  (dc) ](f) D(g)  (h)  (hg)  (j)  (jk)  (j)  \u20144(ji)  (h)  (g)  (h)  (h)  (h)  (hjih)  (gf)  (ed)  (f)  (ed)  (de)  ](c)  (ed) ](g) a(ghg)  (fe) a(d)  (c)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-a-167.png",
        nextFileName: "./pages/part-a-168.png"
    },
    {
        title: "part-a-167-1",
        gabc: "T(c)  (cd) are(f)  (f) the(de)  (dc)  (fh) days(gh) of(fg)  (hg)  (fe) al(dc)  (d)  le(efe) lu-(d)ia:(d) to-(cd)day(dhi) the(h) Ho-(hhg)1ly(gf) Spi-(gig)rit(h) appeared(d)  (f)  (d) in(d)  fire(dg) to(f) the(fe) discipl(d) .(fe) 8,(dc) and(c) bestowed(d)  (d) [](e) up-(f)bn(cd) them(c) ||(e) ma-(g) ni-(ed)fold(f) graces:(d)  (d) sending(idhi)  (hg) them(gh) in-(h)to(g) all(h) the(iji) world,(h)  to(h) preach(h) the(g) gospel,(h)  (g) [](e) to(f) tes-(gh)ti-(fe)fy:(d) He(f) that(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-167.png",
        nextFileName: "./pages/part-a-168.png"
    },
    {
        title: "part-a-168-0",
        gabc: "believeth(d)  (ef)  (ghhg) and(fhh) is(ed)  (fe) baptizid&#39;(de) shall(dc)  (cd) be(gfe)  (gh)  (fe)  (gd)  lu-(d)ia.(d) WITHIN(h)  (g)  (f) THE(g) OCTAVE(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-168.png",
        nextFileName: "./pages/part-a-169.png"
    },
    {
        title: "part-a-168-1",
        gabc: "od(gfd) so(ef) loved(g)  (h) the(h) world,T(g) that(g) he(g) gave(fh) his(g) only-(h) (g) begot-(f) (g)  ten(gh) Son,(f) that(fh) who-(j)so-(i)ev-(j)er(i) believeth(h)  (j) in(g)  (gh) him(g) should(ge)  not(fgh) perish,(fed) 1(d) have(fgh) ev-(hg) (f) er-(gh)lasting(h) life,(gfd) al-(ef)le-(fg)lu-(g)ia.(g)  On(ik) this(j)  (i) Monday(j)  (h) ](g) ",
        groupIndex: 1,
        filename: "./pages/part-a-168.png",
        nextFileName: "./pages/part-a-169.png"
    },
    {
        title: "part-a-168-2",
        gabc: "If(cehg) a(h) man(ij) love(g)  (ih) me,(i) he(i) will(jk) keep(j) my(ij) saying,(ghi)  (i) and(ii)  my(ef) Fa-(hiji)ther(hg) will(f) love(fgf) him:(e) and(ef) we(g) will(h) come(i) un-(j)to(hi) ",
        groupIndex: 2,
        filename: "./pages/part-a-168.png",
        nextFileName: "./pages/part-a-169.png"
    },
    {
        title: "part-a-169-0",
        gabc: "him,(ihf) and(hj) make(i) our(h) a-(g)bode(f) with(gh) him,(fed) al(hf) le(hfefgf) lu-(e)ia.(e)  [(i)  (j) TUESDAY(i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-169.png",
        nextFileName: "./pages/part-a-170.png"
    },
    {
        title: "part-a-169-1",
        gabc: "[(eh) @am(fe) the(f) door,(ed) saith(efe) the(de) Lord:(e) by(e) me(e) if(e) a-(fh)ny(i)  man(i) enter(ji)  (i) in,(i) he(if) shall(h) be(i) sa-(g)ved,(g) and(g) shall(h) find(fe)  -(fe)pasture,(d) al-(ef)le-(f)lu-(e)ia.(e) &quot;(h) e\xab(g) \u2014(h)  (f) 1(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-169.png",
        nextFileName: "./pages/part-a-170.png"
    },
    {
        title: "part-a-169-2",
        gabc: "P(c)  (c)  (ff) TI(def)  (c) with(df) you,(fgf) my(f) peace(ggf~) I(g) give(h) un-(g)to(f)  you:(ghghih) not(fg) as(i) the(hg) world(fg) giveth,(fe)  (d) give(gf) I(gh) un-(g)to(fe) you,(dc)  al(g) le(gh) lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-169.png",
        nextFileName: "./pages/part-a-170.png"
    },
    {
        title: "part-a-170-0",
        gabc: "I(eh) am(f)  (ed) living(ef)  (f) bread,(e) saith(gh) the(if) Lord,(hhg) which(i) came(i) dow(h)  from(h) hea-(iji)ven,(hghih) al-(f)le-(e)lu-(f)ia,(f) al-(h)le-(g)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-170.png",
        nextFileName: "./pages/part-a-171.png"
    },
    {
        title: "part-a-170-1",
        gabc: "Il(dc) am(f) the(g) living(f)  (gh) bread(h) which(hg) came(def) down(g) from(fe) heaven:(d)  (d)  if(dhi) a-(h)ny(g) man(hg) eat(f) of(h) this(hj) bread,(h) he(hg) shall(ef) live(g) for(fe)  ev\u2014er:(d)  (d) and(ff) the(dedcd) bread(dc) that(d) Y(c) will(df) give(fgf) is(h) my(gf) flesh,(e)  which(c) I(e) will(d) give(f) for(d) the(d) life(fh) of(h) the(f) world,(ef) al(g) -(fe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-170.png",
        nextFileName: "./pages/part-a-171.png"
    },
    {
        title: "part-a-170-2",
        gabc: "](cf) sus(d) called(f) ](e) un-(d)to(d) a(e) him1his(fg) twelve(ghg) disciples,(fe)  (de)  (e) and(c) ",
        groupIndex: 2,
        filename: "./pages/part-a-170.png",
        nextFileName: "./pages/part-a-171.png"
    },
    {
        title: "part-a-171-0",
        gabc: "gave(dhi) them(h) pow-(g)er(h) and(gf) au-(g)thor-(ghg)i-(ef)ty(g) o-(g)ver(g) all(fe) devils,(de) ar(e)  and(efedd) to(cd) cure(ef) diseases:(gf)  (de)  (e) and(f) lle(dc) sent(de) them(e) to(ef) preach(gh)  the(g) .(f) a(e) of(de) God,(e) e(c) a(e) heal(fe) the(d) -(ef)al(gf) le(de)  lu(ik)  (e) ia.(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-171.png",
        nextFileName: "./pages/part-a-172.png"
    },
    {
        title: "part-a-171-1",
        gabc: "he(f) Spirit(de) ](e) twhich(e) ](e) proceedeth(e) .(d) from(f) the(e) Father,(eh)  (h) al-(g)le-(h) v(jk)  lu-(ij)ia:(i) he(j) shall(i) glo-(hg)ri-(fi)fy(hg) me,(e) al-(e)le(e) u-(dc):(d) le-(ef) lu-(e)ia.(e)  (h)  (g) EMBER(h)  (f)  (ef) ",
        groupIndex: 1,
        filename: "./pages/part-a-171.png",
        nextFileName: "./pages/part-a-172.png"
    },
    {
        title: "part-a-171-2",
        gabc: "J(cd) -(fgfe)said:(cd) But(f) that(g) ye(hg) may(if)  (ghi) know(h) that(hij) the(ihg) Son(fg) ",
        groupIndex: 2,
        filename: "./pages/part-a-171.png",
        nextFileName: "./pages/part-a-172.png"
    },
    {
        title: "part-a-172-0",
        gabc: "of(f) man(fe) hath(cd) power(ffe) on(c) earth(ffgf) to(f) forgive(f)  (defe) ji\uFB01s(dc)  (he(c) saith(d) un-(f)to(fg) the(f) sick(f) of(f) the(e) palsy)(cd)  (d) I(f) say(f) un-(f)t,(d)  thee,(dedc)  (c) take(d)  (d) thy(c)  (df) bed,(ffgf) and(fg) go(h)  (gf) way(fe) iin-(c)\xe9o(d)  thine(f) house,(ef) al(g) -(fe)lu-(d)ia.(d) i(h) e(g)  (f) \u2014\u2014(gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-a-172.png",
        nextFileName: "./pages/part-a-173.png"
    },
    {
        title: "part-a-172-1",
        gabc: "B&#39;ut(gd) the(fg) Comforter,(gh)  (g)  (g) which(g) is(h) the(gf) Ho-(g)ly(g) Ghost,(h) whom(i)  the(g) Father(h)  (g) will(hg~) send(hgf) in(g) my(hg) Name,(f) he(f) will(jh) teach(j) you(ij)  all(h) things,(h) and(g) bring(h) all(h) things(g) to(gd) your(hf) re-(h)mem-(g) brance,(g) what-(g)so-(g)ev-(h)er(g) I(h) have(g) said(g) un-(g)to(fe) you,(de) al-(f) le-(fgh)1lu-(g)ia.(g) T(j)  (i)  (j) Y(h) W(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-172.png",
        nextFileName: "./pages/part-a-173.png"
    },
    {
        title: "part-a-173-0",
        gabc: "T(c) %(dc) love(f) of(g) God(f) is(h) shed(h) Ta-(g)broad(f) in(g) our(fe) hearts(d) by(d)  his(f) Spirit(gf)  (d) which(fg) dwelleth(h)  (g) &#39;in(fe) ks,(dc) al(d) le(efe) lu-(d)ia.(d)  L](h)  (g)  (f) l(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-173.png",
        nextFileName: "./pages/part-a-174.png"
    },
    {
        title: "part-a-173-1",
        gabc: "Let(i)  (f) us(f) bless(f) the(f) Father,(g)  (f) and(f) the(gh) Son,(hg) And(f)  Ho-(g) (fd) =(fg) Ghost.(gf) Let(ff) \u2014(f) bless.(f) V.(c) Praise(hi) him,(h) and(h)  mag-(hg~)fy(g) him(g) for(f) ev(gh) er.(hg) And(f) the(gh) Bo-(gfd)ly(gf~) Ghost.(gf)  be(h) to(h) the(h) Father(hi)  (h) and(h) to(h) Son,(g) and(g) to(h) the(g) Fo-(f)ly(g)  Ghost,(gh) Let(f) us(f) bless.(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-173.png",
        nextFileName: "./pages/part-a-174.png"
    },
    {
        title: "part-a-174-0",
        gabc: " (gh)  (gfef)  (d)  (e)  (f)  (gh)  (hg)  (g)  (gh)  (gfef)  (d)  (e)  (f)  k(f)  (gh)  (hg)  (g) |(gh)  (j)  (j)  (h)  (gf)  (h) .(gfe)  (e)  B.(fg) (\xa2~(gfef) ,(d) &amp;(e) =(f) Lord,(fh) o(hg) T(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-174.png",
        nextFileName: "./pages/part-a-175.png"
    },
    {
        title: "part-a-174-1",
        gabc: "Th;nks,(c)  (cd) God,(dc) The(ed) &#39;un-(fe)to(cd) thee,(d) thanks(fgf) be(gh) un-(h)to(gf) thee(gh)  one(f) =(de) [(dgfghgfgfe) o(d) Tri(d) L(dcffd) o(cd) ty,(d) ](h) I(hgjji) and(h) supreme(f) o,(ghgf)  De(gfe) i-(d)ty,(d) ho(dgfedd) [(c) and(efgfg) one-(de)ly(efe) U-(d)ni-(cd)ty.(d)  For(h) O(g)  (f) n(g)  (gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-174.png",
        nextFileName: "./pages/part-a-175.png"
    },
    {
        title: "part-a-174-2",
        gabc: "\xa5.(dcef) Lo;E[d,(gfddc) for(ffhg) thy(fe) servant(fg)  (fe) heareth.(d)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-a-174.png",
        nextFileName: "./pages/part-a-175.png"
    },
    {
        title: "part-a-175-0",
        gabc: "G(df) to(d)  (d)  (dc) 0(fg) Tri-(f)ni-(gh)ty(h) co-(h)e(hj) -(h)onely(h)  (gf)  De-(g)i-(gh)ty,(h) ere(h) yet(hjkjhi) the(h) worlds(h) be-(hg)gan(h) to(gf) be,(gh) and(f)  now,(ghg) and(f) through(f) e(fgf) ter-(d)ni(cd) ty.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-175.png",
        nextFileName: "./pages/part-a-176.png"
    },
    {
        title: "part-a-175-1",
        gabc: "P(ig~) raise(ff) and(e) un-(f)end-(h)ing(hihg) gloryt(f)  (f) to(f) God(fg) the(f) Father,(fe)  (f) and(dh)  to(fg) the(fe) Son,(e) and(ef) to(f) Ho-(fe) (f) ly(h) Pa-(hi) (h) ra\u2014clete,(h) through(h)  a(gf) ges.(gh) ev-(i) (hg) er-(f)lasting.(f) &quot;(h) w7(g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-175.png",
        nextFileName: "./pages/part-a-176.png"
    },
    {
        title: "part-a-175-2",
        gabc: "L&#39;t(de) praise(g) and(jh) !(ij)  (j) glory(ji) resound(h) from(i) the(j) lips(k) of(ji) all(hihg)  men(g) to(g) the(g) ~(gh) &amp;(g) a(e) j(ed) Sole-(g)be-(hj)got-(ij)ten;(j) and(j) ",
        groupIndex: 2,
        filename: "./pages/part-a-175.png",
        nextFileName: "./pages/part-a-176.png"
    },
    {
        title: "part-a-176-0",
        gabc: "e(h) qual(hj) praise(k) be(ji) gi(hihg) ven(g) for(g) ev-(hi)er(h) to(g) the(gf)  Ho(g) 1y(ghg) e(e) A(e)  (ji)  (hi)  (h)  (gh)  &#39;et(ed) praise(df) to(d) God(dc) the(de) Father,(e)  (e) to(e) the(d) co-(c)equal(d)  (de) Son,(e)  [(ik)  (e) to(g) thee,(g) O(fh) Ho-(hi)ly(h) Spirit,(hg)  (h) resound(ih)  (gg) unceasingly(ef)  (gf)  (de) n.(e)  (c)  n(c) the(df) lips(fe) of(d) all(e) cre-(fg)a-(gh)tion,(g) for(g) ev-(gh)er(f) and(fg)  ev-(e)er.(e)  (h)  (g)  (h)  (ih)  (gfe)  (e)  \xa3(fee) whom(d) are(fh) all(h)  (ih)  (h) through(hik) whom(kj) are(ij) all(hi) things,(h)  in(ih) whom(ihg) are(hg) all(e) things:(fghgefeed) to(df) him(hi) T(hg) glo-(hg)4(eg) for(fhge)  ev(fe) \u2014er.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-176.png",
        nextFileName: "./pages/part-a-177.png"
    },
    {
        title: "part-a-177-0",
        gabc: "art(c)  (f)  (f)  (f) thou,(g) O(gh) Lord,(hg) In(g) the(f) fir-(fgh)ma-(g)mint(fd) of(fg)  heaven.(g)  (f) Blessed.(f)  (f) V.(c) And(h) to(h) be(h) praised,(hi)  (h) and(h) glo-(gh)ri-(g) fied,(g) and(g) mag-(h)ni-(g)fied(g) for(f) ev-(gh)er.(hg) In(g) the(f) fir-(gh) ma-(g)ment.(fd) Glory(h)  (h) be.(h) Blessed.(f)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-177.png",
        nextFileName: "./pages/part-a-178.png"
    },
    {
        title: "part-a-177-1",
        gabc: "Blessed(ff)  (g) be(fhih) Tthe(h) ho-(h)ly(h) Cre-(i)a-(ih)tor(g) and(h)  (g) Governor(gf)  (g) of(ghg)  all(f) things,(f)  (f) the(f) ho(fhi) ly(i) and(hi) un-(j)di-(jh)vid-(ij)ed(ihgf) Tri-(ghih)ni(gf)  ty,(f) both(fg) now(f) and(gi) ev-(hi)er,(i) and(hij) to(ih) endless(gf)  (f) a(gi) ges(hihg)  of(hg) a-(f)ges.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-177.png",
        nextFileName: "./pages/part-a-178.png"
    },
    {
        title: "part-a-178-0",
        gabc: "B(c) e(df) ye(d) therefore(de)  (d) Ther-(fe)ci-(de)ful,(dc) as(f) your(g) Father(h)  (gf) &quot;(g) Wl(d)  is(g) a(g) is(fe) King,(dc) saith(d) the(efe) Lord.(d) ",
        groupIndex: 0,
        filename: "./pages/part-a-178.png",
        nextFileName: "./pages/part-a-179.png"
    },
    {
        title: "part-a-178-1",
        gabc: "hee,(efgfe) 0(de) God,(e) the(e) -(g)Father(gh) un-(h)be-(hg)got-(fe)ten;(e) thee,(e) O(gh)  on-(gh)1ly-(hih)be-(gf)got-(ghg)ten(f) Son;(e) thee,(g) 0(hj) Ho-(ji)ly(hg) Spirit,(h)  (g) the(h)  Pa(ik)  (hiji) ra-(hg)clete;(g) ho(hih) ly(h) and(h) di(h) -(gf)-(fhgf)ded(ef) Tri-(gf)ni-(de)v(e)  with(ki~)  (fe) our(fg) whole(gfe) heart(fe) and(ffg)  (edd) confess(c)  (df)  (efee) thee,(d) we(dh) ",
        groupIndex: 1,
        filename: "./pages/part-a-178.png",
        nextFileName: "./pages/part-a-179.png"
    },
    {
        title: "part-a-179-0",
        gabc: "raise(fhgfg) thee(fe) and(idhi) bless(hgfgfe) thee:(e) to(f) thee(fe) be(de) glo-(edc)ry(c)  for(gf) ev-(gh)er(g) and(ffg) ev-(e)er.(e) Sunday(h) after(g)  (h) 1(ih) Pentecost(gfe) =(e) ",
        groupIndex: 0,
        filename: "./pages/part-a-179.png",
        nextFileName: "./pages/part-a-180.png"
    },
    {
        title: "part-a-179-1",
        gabc: "udge(ghj)  (hg) that(i) ye(j) be(k) not(h) judged:(j)  (j) for(k) with(k) what(i) judg-(kk) ment(jijkj) ye(hji) judge,(g) ye(ge) shall(g) be(g) judged,(fe)  (d) saith(f) the(gh) Lord.(g)  (f)  (ji)  (jhg) ",
        groupIndex: 1,
        filename: "./pages/part-a-179.png",
        nextFileName: "./pages/part-a-180.png"
    },
    {
        title: "part-a-179-2",
        gabc: "Christ(f) the(gh) Lord,(h) a(hj) Priest(h) for(gf) ev\u2014er(gh)  (h) af(hjkjhi) ter(h) the(h)  order(h)  (h) of(hg)  (h) Melchisedech,(g)  (f)  (gh) offered(f)  (gh)  (g) bread(fe) and(fgfe) wine.(d) 1(h) \u2014(g)  (ffghgf) ",
        groupIndex: 2,
        filename: "./pages/part-a-179.png",
        nextFileName: "./pages/part-a-180.png"
    },
    {
        title: "part-a-180-0",
        gabc: "he(c) mer\u2014ci-(e) (ef) ful(f) and(f) gra-(fghf)cious(ef) Lord(f) hath(fj) given(ih)  (gf) meat(g)  un-(h)to(i) them(g) that(h) 1](gf) fear(e) him,(f) in(j) re-(i)U](jjihii) brance(j) cf(fh)  I(gi) his(ge) T(c) mervellous(e) W(fg) do-(hf)ings.(f) B(h)  (g) W(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-180.png",
        nextFileName: "./pages/part-a-181.png"
    },
    {
        title: "part-a-180-1",
        gabc: "I(e) vin(e) receive(g)  (hj) the(j) cup(k) of(ji)  (jh) salvation,(ji)  (g) and(h) of-(efg)fer(g)  the(g) sacrifice(h)  (g)  (f) of(g) p(gf) thanksgiving.(e) @(e) &quot;(ji) _-(hi)](h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-180.png",
        nextFileName: "./pages/part-a-181.png"
    },
    {
        title: "part-a-180-2",
        gabc: "the(c)  (cfe)  (df) children(gh)  (gf) Tof(gh) the(gf) Church(e) be(e) like(ghi) the(h) o(h) -(gf) branches,(gh)  (gfe) o(fe) a-(de)7(e) TOCN(dc) ta(gf) ble(ghg) |(fe) the(de) Lord.(e)   (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-180.png",
        nextFileName: "./pages/part-a-181.png"
    },
    {
        title: "part-a-181-0",
        gabc: "e(d) that(fh) ma-(h)keth(fhiih) Peace(hik) in(j) the(i) Church\u2019s(i)  (hg) bor(hihh)  ders(f) )(f) the(g) Lord,(hge) who(fe) fill-(dfhhi)eth(h) us(h)  (hg) with(d) a(e)  flour(ef) of(e) wheat.(d)  (h)  (i)  (h)  (g)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-181.png",
        nextFileName: "./pages/part-a-182.png"
    },
    {
        title: "part-a-181-1",
        gabc: "He(f) fed(gh) them(f) with(g) the(f) fin-(fe)\xe9st(dc) wheat(fg) flour,(i) Al(hij) le(ihgfe)  lu-(fgh)ia,(f) &#39;al(dc) le(hifgiihgfe) lu-(gg)ia.(f) He(f) fed(gh) them.(f) And(f)  with(f) ho-(gh)ney(f) out(f) of(f) the(f) sto-(f)ny(f) rock(g) did(f) he(f) sa(fe) -(dc) fy(fg) them.(i)  (i) R.Al(hij) le(ihgfe) lu-(gh)ia.(f) 7.(c) Glory(f)  (f) be(g) to(f) the(f)  Father(gh)  (f) and(g) to(fe) the(dc) and(c)  (c) to(df) the(f) Ho(ighih) ly(gf) Ghost.(f)  He(f) fed(gh) them.(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-181.png",
        nextFileName: "./pages/part-a-182.png"
    },
    {
        title: "part-a-182-0",
        gabc: "He(f) fed(g) them(f) with(f) the(f) finest(f)  (e) wheat(g) flour,(h) A]-(h)1a.(hg)  lu-(g)ia,(f) a-(d)le-(fg)1lu-(gf)ia.(f) He(f) fed(g) them.(f) \xa5.(c) And(f) with(f)  ho-(g)ney(f) out(f) of(f) the(f) sto-(f)ny(f) rock(g) did(f) he(f) sa-(f) Al-(h)le-(hg)lu-(g)ia.(f) Glory(f)  (f) be.(f) He(f) fed(g) them.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-182.png",
        nextFileName: "./pages/part-a-183.png"
    },
    {
        title: "part-a-182-1",
        gabc: "[(d)  (d)  (d)  (c) ](f)  (f)  (gi)  (i) [(ij)  (i)  (i)  (i) )(g)  (i)  (hgf)  (f)  [(f)  (g) L(i) a(h)  (g)  (f) a(g) a(g) a(g)  (h) =(f)  (e)  (d) [](g) B(gc)  .(f) Thou(f)  (f) gavest(d)  (f) them(g) bread(g)  (f) from(g)  (h) heaven,(f)  (gf) LJ(e)  (c)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-a-182.png",
        nextFileName: "./pages/part-a-183.png"
    },
    {
        title: "part-a-182-2",
        gabc: "0(fghfggf) how(fe) sveet(dc) is(f) thy(gh) Spi(hjhhgf) rit,(gf) O(fhjij) Lord,(ih) who(jiih) ",
        groupIndex: 2,
        filename: "./pages/part-a-182.png",
        nextFileName: "./pages/part-a-183.png"
    },
    {
        title: "part-a-183-0",
        gabc: "that(g) thou(f) mightest(gh)  (f) shew(fe) thy(dc) kindness(fghi)  (h) un-(h)to(gf) thy(hj)  chil-(jhgj)dren,(j) giv-(jk)est(kji) them(j) that(ih) sweetest(jih)  (gf) bread(efddc)  fron(fghjhhgf) heaven,(gf)  (f) fillest(f)  (hj) the(j) hun(jhgj) gry(j) with(kj) good(kjij)  things,(ih) and(hgg) send-(fhjjk)est(j) the(j) rich&#39;(jkjhih) and(hg~) scornful(gf) &#39;(efddc)  emp(fghjh) ty(hg) a(f) \u2014way.(gf) e(h)  (f) |(h) s(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-183.png",
        nextFileName: "./pages/part-a-184.png"
    },
    {
        title: "part-a-183-1",
        gabc: "is-(dhi)dom(h) Thath(ghg) build-(fe)ed(fg) her(fe) house,(d) she(f) hath(e)  mingled(d) [](e) her(f) wine,(ghg) and(g) a(f)  (e)  (d) her(g) ta-(fe)ble,(dc)  al-(d)le(efe) lu-(d)1ia.(d)  (h)  (g)  (f)  (gf)  (fgh) ",
        groupIndex: 1,
        filename: "./pages/part-a-183.png",
        nextFileName: "./pages/part-a-184.png"
    },
    {
        title: "part-a-184-0",
        gabc: "T(gi) hou(fc) feddest(ef)  (f) thine(gf) own(ef) peo(hijk) ple(j) with(iji) an(hg) gels\u2019(fe) Foog(f)  N(jk)  and(c) didst(ef) send(f) them(fh) bread(hi) from(h) heaven,(hg)  (f) al-(e)le-(eg)lu-(f)ia,(f)  (h) I(ge)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-184.png",
        nextFileName: "./pages/part-a-185.png"
    },
    {
        title: "part-a-184-1",
        gabc: "Rich(ghjj) is(ijk) the(j) bread(ji) of(hi) Christ,t(hg) and(gh)  (ed) shall(ghj) yield(jj)  roy(i)  (j) al(k) dainties,(j)  (hg) al(ghij) le(hgf) lu(ghgg) ia.(e)  (j)  (h) &#39;(j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-184.png",
        nextFileName: "./pages/part-a-185.png"
    },
    {
        title: "part-a-184-2",
        gabc: "C(fede) -(d)se(dfe) crat\u2014ed(fg) priests(gff) Thf-(dc)fer(de) bread(efe) and(dhi) in-(hgfgfe)cense(e)  un(efgfe) to(de) God,(cd) al(dfgh) le(gfe) 8(de) e(e) e(h)  (g) T(h) T(ji) T(hg) w](e) ",
        groupIndex: 2,
        filename: "./pages/part-a-184.png",
        nextFileName: "./pages/part-a-185.png"
    },
    {
        title: "part-a-184-3",
        gabc: "o(f) him(d) that(fh) o(hg) ver-(fe)com-(hi)etht(h) will(h) I(ik) give(kj) the(ih) hidden(i)  (ij)  manna,(ih)  (h) and(d) a(e) new(efe)  (de) al-(f)le-(e)lu-(d)ia.(d)  (d)  (h)  (i)  (h)  (g)  (h)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-a-184.png",
        nextFileName: "./pages/part-a-185.png"
    },
    {
        title: "part-a-185-0",
        gabc: "He(f) gave(g) them(f) bread(f) from(e) heaven,(g)  (h) Al(h) le(hg) 1lu-(g)ia,(f)  (d)  al(d) -(fg)lu-(gf)ia.(f) He(f) gave(g) them.(f) So(f) man(g) did(f) a(e)  angels\u2019(g)  (g) food.(h) Al-(h)le-(hg)lu-(g)ia.(f) Glory(f)  (f) be(f) to(f)  the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g) Ho(h) 1y(g) Ghost.(gf)  Fe(f) gave(g) thenm.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-185.png",
        nextFileName: "./pages/part-a-186.png"
    },
    {
        title: "part-a-185-1",
        gabc: "[~(ik)  (g)  (ghijh) o(gf) Ja(hg) &quot;[e(hijihg) Jmu(hg) \xa7(fg) s(g) @(g)  (gji)  (jk)  (k)   (ik)  (ji)  (hg)  (hj)  (j)  (j)  (h)  (j)  (g)  (gh)  (hg)  (fg)  (g)  k.(f)  (hg)  (hj)  (ji)  (hg)  (hg)  (fg)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-185.png",
        nextFileName: "./pages/part-a-186.png"
    },
    {
        title: "part-a-186-0",
        gabc: "I(dh) &#39;am(g)  (gfhih) the(h) liv(hgf) ing(gf) bread,(dfgf) which(hgf) came(g)  (hf) down(h)  from(hdffdfggf)  (hhgf) hea-(gf)ven:(f) if(d) a(f) ny(g) nan(dc) eat(f) of(gh)  this(fh) bread,(h) he(hjigjjh) shall(jk) live(kh) for(kj) ..(igjhhhgfhg)  al(d) lle(dcdffghjihjijh) -(kjigjhhhgfhefgd)g(c) -(gge) (ghddcef) lu-(ed)i,,(d)  the(h)  (g) Hours(f)  (gh) the(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-186.png",
        nextFileName: "./pages/part-a-187.png"
    },
    {
        title: "part-a-186-1",
        gabc: "oy(fee) sa(dfhhih) cred(hj) ban(kjih) quet,T(h) where-(hh)in(f)  (fe) Christ(fh) 1(gfef)  re(f) [~(defgf) e(ed) the(f) me(hij) mo(ih) ry(h) of(f) his(gdfgh) Pas-(ihg) (gf) sim(h)  is(h) re(jk) new(kjijii) ed;(h) the(i) soul(ghi) s(h) grace(hgf) is(ef) fill-(ghgfed)",
        groupIndex: 1,
        filename: "./pages/part-a-186.png",
        nextFileName: "./pages/part-a-187.png"
    },
    {
        title: "part-a-187-0",
        gabc: "is(j)  ed,(ef) and(fg) a(def) pledge(hihfgh) of(gfe) fu(defe) ture(h) glo-(hij)ry(j) is(jk)  be(jjih) stow-(ijii)ed,(h) al-(k)le(kjih) [(ihggfhhfged) &quot;o(fgfe) i(hih) N(f)  (fe)  lu(g)  (defgfe) -(dde)ia.(d) e(h)  (i)  (g) ](h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-187.png",
        nextFileName: "./pages/part-a-188.png"
    },
    {
        title: "part-a-187-1",
        gabc: "cjild(cd)  (ef) Sa-(f) (fg)  (hg) mi-(f)nis-(g)ter-(h)ed(i) un-(j)to(k) the(j) Lord(i)  (j)  (i)  before(i)  (dhg) E-(fg)1i,(g) and(g) the(i) word(i) of(h) the(g) Lord(hihg) was(g)  precious(dfe) .(cd) .(e) his(d) ...(c) sight.(e)  (g)  (h)  (g)  (f)  (ed) ",
        groupIndex: 1,
        filename: "./pages/part-a-187.png",
        nextFileName: "./pages/part-a-188.png"
    },
    {
        title: "part-a-188-0",
        gabc: "A(g) certain(h)  (hi) T(i) made(j) a(hg) great(hi) wedwne(g) supper,(g) and(gh) bade(iih~) ma-(h)ny;(g)  and(g) sent(gij) his(i) servants(k)  (j) at(hj) supper(i)  (hg) time(g) to(g) say(h) to(ij)  them(h) that(h) were(i) bidden,(g)  (g) Come;(ghiji) for(hg) all(hhj) things(h) are(g)  now(hi) ready,(h) .(gf) al-(g)le-(gf)lu-(e)ia.(e) BENEDICTUS(j) T(ji) 1(hih) T\xa2(gfe) a](e) ",
        groupIndex: 0,
        filename: "./pages/part-a-188.png",
        nextFileName: "./pages/part-a-189.png"
    },
    {
        title: "part-a-188-1",
        gabc: "F(fg) ather(g) Abraham,(h)  (gf) e(g) have(g) mercy(hgf)  (g) on(gh) me,(f) and(g) send(hj) La-(jk)~za-(ji) rus,(j) that(j) he(j) may(j) dip(jig) the(j) tip(kj~) of(j) his(j) finger(ji)  (h) 11(ij) ",
        groupIndex: 1,
        filename: "./pages/part-a-188.png",
        nextFileName: "./pages/part-a-189.png"
    },
    {
        title: "part-a-189-0",
        gabc: "va(hh) ter,(g) and(dg) cool(f) my(gh) tongue.(g) am(j) the(i)  (j) living(h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-189.png",
        nextFileName: "./pages/part-a-190.png"
    },
    {
        title: "part-a-189-1",
        gabc: "Go(h) out(g) quicklyT(h)  (g) in-(ef)to(fg) the(ef) streets(d) and(c) lanes(ef) of(g) the(fe)  (d)  ci-(d)ty,(d) and(hihh) compel(hg)  (j) them(k) to(j) come(ih) in;(h) the(k) and(j) the(j)  naimed,(ji)  (g) the(h) halt(jk) and(i) the(ji) blind,(h) that(hgg) my(f) house(ghg) may(ef)  be(gf) filled,(df)  (ef) al-(g)le-(fe)lu-(d)ia.(d) &quot;(h) ml\u2014l(g)  (f) &amp;(g) =(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-189.png",
        nextFileName: "./pages/part-a-190.png"
    },
    {
        title: "part-a-190-0",
        gabc: "[(eh) re-(fd)e(e) ber(e) Tthat(e) thou(e) in(g) e(h) lifetime(i)  (i) re~Ceiv_(i) ](i)  edst(h) thy(f) good(h) things,(h) and(hg) likewise(hi)  (h) La-(f)za(h) ryg(g)  e(e) vil(de) things.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-190.png",
        nextFileName: "./pages/part-a-191.png"
    },
    {
        title: "part-a-190-1",
        gabc: "nd(d) all(ef) Is-(g)ra-(g)el(f) knew(d) Tfrom(fh) Dan(hghih) e-(h)ven(g) to(f) Beer-(f) she-(f)ba,(fgfefeded) that(cd) Sa(f) -(f)\u2014el(fd) was(f) es-(gh)tab-(g)lished(fg)  (g)  to(g) be(g) a(e) prophet(gh)  (fe) of(d) the(cd) Lord.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-190.png",
        nextFileName: "./pages/part-a-191.png"
    },
    {
        title: "part-a-191-0",
        gabc: "So(e) Da-(eh)vid(f) prevailedto-(e) (f) v(e) ver(f)  (e) the(d) )(ef) Philistine(f) e(e) with(g) a(h)  sling(i) and(h) a(f) stone,(h) in(g) the(e) Name(gh) of(f) the(f) Lord.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-191.png",
        nextFileName: "./pages/part-a-192.png"
    },
    {
        title: "part-a-191-1",
        gabc: "e(d) mbuntains(d) M(dfddc) of(fg) Gil(f) -(gh)a,(hfgfd) let(d) .(c) be(d) .(dg) neither(gh)  dew(f)  (ed) rain(f)  (ed) you;(cd)  (d) there(d)  (d)  (efd) the(dg) shield(fg) of(h)  the(g) mighty(f)  (fe) is(d) vilely(e)  (cd) cast(f) a-(gf)way,(f) the(f) shield(f)  (dc)  Saul,(efd) d5(dc) though(cd) he(d) had(f) not(g) been(f) a-(d) (fe) nointed(d) with(cd) oil.(d)  How(hghfefd) are(c) the(d) mighty(d)  (cd) fallen(fg)  (f) in(f) tEe(fe) ildst(cd) of(df) the(efe)  battle!(d)  (d) Jon-(fgf)a-(gh)than(hfgfd) was(cd) slain(f) up-(g)on(f) h.y(dc) high(ef) ",
        groupIndex: 1,
        filename: "./pages/part-a-191.png",
        nextFileName: "./pages/part-a-192.png"
    },
    {
        title: "part-a-192-0",
        gabc: "places!(d)  (d) Saul(hjih) and(hg) Jon-(j)a-(k)than(jih) were(h) love(jig) ly(h)  (fgfd)  .(c)  (d) exceeding(f)  (g) pleasant(f)  (d) &#39;in(de) their(cd) .(d) and(dde) in(c)  their(d) death(ffgf) they(fghg) were(fedc) not(d) di(efe) vided.(d)  (d)  (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-192.png",
        nextFileName: "./pages/part-a-193.png"
    },
    {
        title: "part-a-192-1",
        gabc: "0(d) ord,(dc) I(e) beseech(f)  (gff) thee,(dc) Tdo(f) a(gh) way(hghih) the(h) in-(g)i-(f) qui-(fg)ty(fe) of(g) thy(fe) ser-(df).(fc) for(d) a(c) have(d) done(ef) ve-(gh)ry(fe)  foolishly.(ik)  (d)  (d)  (d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-192.png",
        nextFileName: "./pages/part-a-193.png"
    },
    {
        title: "part-a-192-2",
        gabc: "a(ghggf) dok(gh) the(hji) priestf(g) and(g) Na(ghgf) than(g) the(h) prophet(jk)  (kj) anoin-(jk) (k)  ted(i) So-(j)lo-(ji)mon(hg) king(h) in(f) Gi-(hji)hon:(g) and(g) the(g) people(g)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-192.png",
        nextFileName: "./pages/part-a-193.png"
    },
    {
        title: "part-a-193-0",
        gabc: "came(gh) up(g) re-(g)joic-(ghgf)ing(gh) and(gf) said,(f) Let(fg) the(gh) king(ji) live(hg) for(hih)  ev-(g)er.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-193.png",
        nextFileName: "./pages/part-a-194.png"
    },
    {
        title: "part-a-193-1",
        gabc: "T(c) hou(ehg) hast(hi) heard,(iji) 0(hg) Lord,(hi) the(j) I(i) supplication(h)  (i) of(hg)  (f) thy(gf)  &quot;(e) servant,(e) that(e) I(f) might(ed) build(ef) a(f) temple(hi)  (hghih) to(f) thy(hg) Name.(e)  [(i)  (j) BEFORE(i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-193.png",
        nextFileName: "./pages/part-a-194.png"
    },
    {
        title: "part-a-193-2",
        gabc: "hen(g) the(g) Lord(gfd) took(e) up(f) E-(gh)li-(g)jaht(g) by(g) a(g) whirlwind(h)  (f) in-(h)to(ji)  CHN(g) heaven,(g) E-(f)li-(hj)sha(ji) cri-(jh)ed,(ih) saying:(g)  (g) My(fh) fa-(fe)ther,(d) the(d)  chariot(d) 5(c) of(d) Is-(fh)ra-(h)el(g) and(h) the(g) horses(hj)  (ih) thereof.(gh)  (g) S(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-193.png",
        nextFileName: "./pages/part-a-194.png"
    },
    {
        title: "part-a-194-0",
        gabc: "e(f) ho(gh) ash(g) Tdid(f) that(f) which(d) |f(dc) \xa5(c) W(c) the(d) sight(f) e(fg)  the(f) Lord(f) a1l(fd) his(ffh) days,(ghg) wherein(de)  (f) Je(e) ho(d) ia(dedc) da(c) the(fg)  priest(h) in-(g)struc-(hig)ted(gf) him.(f) I(h) B(f)  (gh)  (g) R(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-194.png",
        nextFileName: "./pages/part-a-195.png"
    },
    {
        title: "part-a-194-1",
        gabc: "\u2014(gi) I(d) beseech(d)  (fh) thee,(hhi) G(h)  (h) re-(h) (h) member(ik) now(jih) how(h) I(f) have(h)  walked(i)  (h) before(g)  (h) thee(fe) 1in(fe) truth(de) and(d) with(e) a(g) per-(gfe)fect(fe)  P(d) and(d) have(fg)  (ge) done(g) that(fe) which(fg) is(h) good(gf) in(fe~) thy(ed) sight(d)  a(h)  (i)  (g) BEFORE(h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-194.png",
        nextFileName: "./pages/part-a-195.png"
    },
    {
        title: "part-a-194-2",
        gabc: "W(gi) TR(e) isdom(f) hath(hi) N(i) builded(h) her(hj) RS,(i) she(i) hath(f) hewn(fi) out(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-194.png",
        nextFileName: "./pages/part-a-195.png"
    },
    {
        title: "part-a-195-0",
        gabc: "her(h) se-(f)ven(e) pil-(fgh)lars:(e) she(f) hath(e) sub-(f)du-(h)ed(h) the(h) nations,(hj)  (i)  and(h) in(i) her(j) own(jk) might(i) hath(g) she(i) trodden(j)  (ih) un(fh) der(e)  (j)  the(f) necks(g) of(ef) the(gh) proud(ihf) and(fg) lofty.(e)  (e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-195.png",
        nextFileName: "./pages/part-a-196.png"
    },
    {
        title: "part-a-195-1",
        gabc: "I(h) dwell(hghih) in(h) high(fh) places,(hg)  (e) and(e) my(g) throne(ef) is(f) in(f) a(i)  cloudy(jk)  cloudy(hg)  (e) pillar.(f)  (e) I\u201CI_I(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-195.png",
        nextFileName: "./pages/part-a-196.png"
    },
    {
        title: "part-a-195-2",
        gabc: "wis-(c) (dg)  (fh) dom(g)  (fe) from(d)  (f) the(fgh) Lord,(ihghih) and(f) is(h) with(j) him(g)  for(hg) ev(ffg) er;(fgfed) and(d) is(e) before(f)  (gh) the(h) ages.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-195.png",
        nextFileName: "./pages/part-a-196.png"
    },
    {
        title: "part-a-196-0",
        gabc: "W(ik) .(c) dom(d) .(fg) [(g) a(g) aloud(h) .(h) the(j) broad(hg~) places:(gf) N(f) Who-(f)so_(h)  -(jk)ev\u2014er(jih) lov-(kji)eth(hg) wisdom,(hi)  (hg) let(g) him(gh) turn(fe) in(df) &quot;(fe) -(dc) and(dc) he(e) shall(f) find(gh) her;(g) and(g) when(h) he(g) hath(fd) found(f) hel(efddc)  hap-(cd)|(e) is(d) he(c) if(d) he(f) hold(gh) her(h) fast.(g)  (g)  (f)  (d)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-196.png",
        nextFileName: "./pages/part-a-197.png"
    },
    {
        title: "part-a-196-1",
        gabc: "](efddc) son,(fg) .(g) thy(f) ](g) father\u2019s(gh) a(g) commandment,(f) .(f) for(f)  sake(fhihg) not(hg) the(i) law(ihf) of(g) thy(ghg) mother:(f)  (f) bind(g) them(f) contin-(f) (d)  up(de)  (c)  (j)  (gf) on(g) thine(ghg) heart.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-196.png",
        nextFileName: "./pages/part-a-197.png"
    },
    {
        title: "part-a-196-2",
        gabc: "ow(d) when(cd) Job(f) had(hg~) heard(h) the(h) words(hj) of(h) the(h) messengers:(h)  (g)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-196.png",
        nextFileName: "./pages/part-a-197.png"
    },
    {
        title: "part-a-197-0",
        gabc: "he(h) en-(g)dur-(h)ed(g) with(ef) patience,(g)  (fe) saying,(d)  (d) Shall(d) we(fg) re-(g) ceive(gh) good(g) at(g) the(gf) Lord&#39;s(gh) hand,(ffg) and(fh) shall(i) we(h) not(hi) re-(h) ceive(gf) e-(g)vil(ghg) al-(f)so?(f) In(d) all(gf) this(g) Job(g) sinned(h)  (g) not(g)  with(gf) his(ghg) lips,(f) nei(ifhi) ther(h) charged(h)  (g) God(ef) foolishly.(g)  (fe)  (d)  BEFORE(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-197.png",
        nextFileName: "./pages/part-a-198.png"
    },
    {
        title: "part-a-197-1",
        gabc: "I\u2122(cd) all(dhi) this(hhj) Job(hg) sinned(h)  (g) not(ef) with(g)  (fe) lips,(d) nei-(fed) ther(i)  (ef) charged(gh)  (ghg) God(ef) foolishly.(g)  (fe)  (d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-197.png",
        nextFileName: "./pages/part-a-198.png"
    },
    {
        title: "part-a-197-2",
        gabc: "Re\u2014mem-(d) (cdef) ber(f)  (f) Lord,(fe) dur(dc) of(ded) fences,(c)  (c) nor(c) the(d) of-(e)fen-(ef)",
        groupIndex: 2,
        filename: "./pages/part-a-197.png",
        nextFileName: "./pages/part-a-198.png"
    },
    {
        title: "part-a-198-0",
        gabc: "ces(ed) a(e) our(f) fore(ghgf) ](e) [(e) neither(e)  (gh) take(h) tho,(gf) Ve(fg)  geance(efggf) of(dc) our(de) sins.(e) l_-(h)o(g)  (h)  (ji) I(hg)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-198.png",
        nextFileName: "./pages/part-a-199.png"
    },
    {
        title: "part-a-198-1",
        gabc: "A(e) -(f)na-(g)1i,(gf) Lord(ed) God(g) Almighty,(jh)  (j)  (j) great(ijk) and(j) won~der-(hj) (hig)  ful,(g) who(g) hast(h) gi-(i)ven(j) salvation(hg)  (hi)  (i) by(e) the(f) hand(g) of(ge) %(fe)  woman;(d)  (d) we(de)  (g) beseech(ge)  (gi) thee,(h) the(g) pra_yers(ef) of(g) thy(ghg)  servants.(e)  (e)  (ji)  (hi)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-198.png",
        nextFileName: "./pages/part-a-199.png"
    },
    {
        title: "part-a-198-2",
        gabc: "A(cg) -(gj)na-(hg)i,(h) Lord(gf) Ged(g) =(h) Almighty,(hk)  (jkj) great(j) and(jk) won-(h)der-(fg) ven(j)  ful,(g) who(gji) hast(j) gi-(k)ven(k) salvation(k)  (ji)  (h) by(k) the(ji) hand(gh) of(hi) &amp;(h) ",
        groupIndex: 2,
        filename: "./pages/part-a-198.png",
        nextFileName: "./pages/part-a-199.png"
    },
    {
        title: "part-a-199-0",
        gabc: "woman;(g)  (g) hear,(g) we(h)  (g) beseech(eg) thee,(gfed) the(d) prayers(ef) of(gh) thy(h)  servants.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-199.png",
        nextFileName: "./pages/part-a-200.png"
    },
    {
        title: "part-a-199-1",
        gabc: "Lord,(dc)  (d) the(f) King(fg)  (d)  (ef)  (d) t\xe9e(d)  (dc) whole(fhg) world(fgf) 1is(ef)  in(g) thy(fe) power,(d)  (d) and(d) there(d) is(c) no(dgfgf) man(d) that(ef) can(hg)  gain-(fe)say(d) thee.(d)  (h) T(h)  (g)  (f) g(gf)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-a-199.png",
        nextFileName: "./pages/part-a-200.png"
    },
    {
        title: "part-a-199-2",
        gabc: "he(e) Lord:(eh)  (f) your(ed)  (f) hearts(e) Tin(e) his(e) law(f) and(e) com-(d) mandments;(ef)  (d) and(e) may(d) the(f) Lord(h) our(i) God(hghih) send(hf) you(g)  o(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-199.png",
        nextFileName: "./pages/part-a-200.png"
    },
    {
        title: "part-a-200-0",
        gabc: "he(gd) sun(fgh)  (g) the(g)  (hg)  (gd) shields(fgh) of(fe) gold,(def) and(f) the(h)  mountains(kj)  (j) glistered(ji)  (h)  (ji) therewith:(hg) ](g) and(ggh) yet(f) the(hij) forceg(j)  (ih)  of(jk) the(hg) heathen(fg)  (g) were(g) discom-(h)fi-(ji) (hg) ted.(g) \u2014I\u2014|(j)  (i)  (j) =(h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-200.png",
        nextFileName: "./pages/part-a-201.png"
    },
    {
        title: "part-a-200-1",
        gabc: "Bl:t(c)  (cd)  (d) mourned(cd)  (f)  (f) Ju\u2014d!g,(de)  (dc) and(f) made(gh) great(h) la-(i)men-(h) ta-(h)tion(gf) for(g) him,(ghg) saying:(f)  (f) How(f)  (hghi) art(h) thou(gf) fallen,(gf)  (d)  valiant(fg)  (h) in(dfg) battle,(ghi) e(h) that(d) didst(e) de(f) liv(gfghg) er(g) the(g)  peo-(fec)ple(d) of(c) the(ef) Lord.(d) s(h)  (g) e(f)  (g) &amp;(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-200.png",
        nextFileName: "./pages/part-a-201.png"
    },
    {
        title: "part-a-200-2",
        gabc: "God(d) .(dc) gracious(f) L](g) un-(f)to(gh) you,(ih~gg) T(j) and(ef) D(g) your(fe) prayers,(d) ",
        groupIndex: 2,
        filename: "./pages/part-a-200.png",
        nextFileName: "./pages/part-a-201.png"
    },
    {
        title: "part-a-201-0",
        gabc: "and(d)  (fe) at(de) one(d) a,(c) .(c) and(f) the(g) Lord(h) our(hi) God(h)  never(h)  (g) forsake(fg)  (gf) you(d) 1in(fe) time(g) of(fe) trouble.(d)  (d) R(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-201.png",
        nextFileName: "./pages/part-a-202.png"
    },
    {
        title: "part-a-201-1",
        gabc: "T(hig~) hine(fhghg) is(h) the(f) power,(gf) O(ef) Lord,T(f) and(ef) thine(gij) is(hg) the(f) king-(hg) dom;(hgi)  (e) thou(h) art(j) high(i) a-(ji)bove(i) all(ih) nations:(f)  (f) give(h) peace(hhg)  in(hig~)  (f) our(gfef) time,(fec) O(ef) Lord(hg) our(eg) God.(f) |(h)  (gf)  (hg) &amp;(e) =(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-201.png",
        nextFileName: "./pages/part-a-202.png"
    },
    {
        title: "part-a-201-2",
        gabc: "Hine(dc) is(f) the(g) power,(f) O(gh) Lord,(h) Tand(g) thine(fe) is(fg) the(f) king-(d) dom:(d) thou(hh) art(h) high(h) a-(g)bove(h) all(ji) nations:(hi)  (h) give(hgg) peace(ef)  in(g) our(fe) time,(dc) O(ef) s(g) our(fe) 9w(d) &quot;~(h) -(g)=(f) d(gh) 1(gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-201.png",
        nextFileName: "./pages/part-a-202.png"
    },
    {
        title: "part-a-202-0",
        gabc: "I(ch) saw(h) the(g) Lord(hj)  (hi)  (h) a(h)  (g) up(ef) on(g) .(fe) ;(d)  high(hihh) and(g) lifted(hj)  (ji) up,(hhg) and(hk) his(ji) train(hhg) filled(hk)  (i) the(ji)  temple:(h)  (h) the(hgg) whole(f)  (ghg) earth(ghg) was(ffe) full(d) of(e) the(f) ma(gi) jes-(hg) ty(hg) of(fe) his(fgf) .(d) e(d) W(h)  (g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-202.png",
        nextFileName: "./pages/part-a-203.png"
    },
    {
        title: "part-a-202-1",
        gabc: "Ble-(ik) (dc) hold,(defe) 0(de) L\xe9rd,(ddc) how(fhi) the(h) ci-(hg)ty(fg) 1is(g) a(hg) become(fef) de-(fe)so-(de) llte(dc) that(c) was(d) full(f) of(e) precious(fg)  (f) treasure;(d)  (d) s(cd) sit-(dhi) teth(hg) o(fe) T(fg) ful(g) that(hihgg)  (c) was(d) great(f) a-(e)mong(gf~) the(f) nations:(d) NS(d)  none(ff) can(dde) comfort(c)  (df) her(ffgf) but(f) on-(gh)ly(h) thou,(ghgffedc) 0(dg) our(fe)  God.(d)  (h)  (g)  (f)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-202.png",
        nextFileName: "./pages/part-a-203.png"
    },
    {
        title: "part-a-203-0",
        gabc: "us,TO(cd)  (dhi)  (h)  (h)  (h) Lord,(hghihgg) with(fg) thine(hg) im-(ef) (f) pregnable(g)  (fe)  wall:(d) and(f) with(c) the(d) arms(ffg) of(f) thy(fh) pow-(hg)er(f) de-(fh)fend(hg)  (f)  us(f) al-(f)way,(ef) O(g) our(fe) God.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-203.png",
        nextFileName: "./pages/part-a-204.png"
    },
    {
        title: "part-a-203-1",
        gabc: "hou(d) n(c)  (d)  (f)  (e) .:.\u2014F:J(dc) throne(d) of(e) the(f) heavens(d) :(dc) and(f)  beholdest(fgh)  (hi)  (h) the(gf) depths,(ghghih) O(hg)  (fedc) King(e) of(ef) kings;(d)  that(h) weighest(hg)  (hj) the(j) mountains(j)  (hg) and(h) holdest(hg)  (hj) the(ji) earth(hg)  in(g) the(h) hollow(jk)  (ih) of(i) thine(ij) hand:(h) ](hg) give(ef) 0(gh) Lord,(fe)  Un-(d)to(ffe) s,(dc) in(c) the(d) midst(ef) of(gh) our(fe) groanings.(d)  (d) \u2014(h)  (g) [(f)  (gf) 5(d) ",
        groupIndex: 1,
        filename: "./pages/part-a-203.png",
        nextFileName: "./pages/part-a-204.png"
    },
    {
        title: "part-a-204-0",
        gabc: "I.(c) have(d) set(fe)  (de)  (d) thy(dc)  (d)  (fe)  (dfddc) 0(fh) Je-(g)ry-(fe) sa(fgf) lem,(d) which(f) shall(gh) nev-(h)er(gf) hold(gh) their(fe) peace(dcec) e(c)  nor(ik)  (df) night,(ffgf) praising(f)  (f) the(fgh) Name(ed) of(e) the(efe) Lord.(d) LT(hgfg)  (gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-a-204.png",
        nextFileName: "./pages/part-a-205.png"
    },
    {
        title: "part-a-204-1",
        gabc: "hat(efdcd) wo(ffg) T(g) having(f) ten(g) pieces(gf)  (g) of(gh) silver,(f)  (f) if(f)  she(f) lose(fhihg) one(ih) piece,(gf) doth(f) not(f) light(g) a(f) can(fhihg) dle,(hg) and(hg~)  sweep(ff) the(df) house,(c)  sweep(k)  (ff) the(df) house,(c) and(d) seek(dc~) di(c) -(d)gent-(ffg)ly(f) un-(f)til(h)  she(gh) find(f) it.(f)  (h)  (f) &#39;(gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-204.png",
        nextFileName: "./pages/part-a-205.png"
    },
    {
        title: "part-a-205-0",
        gabc: "we(dhi)  (h)  (h) have(h) toiled(h)  (h) all(h) the(h) night,(hghihgg) and(fg) have(hf)  ta-(g)ken(fe) nothing:(d)  (d) nevertheless,(f)  (e)  (d)  (e) at(f) thy(gh) word(ghg) T(e) will(f)  let(ik)  (eg) down(gh) the(fe) net.(d) &quot;%(h)  (g) a4(f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-205.png",
        nextFileName: "./pages/part-a-206.png"
    },
    {
        title: "part-a-205-1",
        gabc: "\xa3(defe) thou(ed) bring(d) thy(df) gift(fe) to(d) the(f) al(defd) tar,(d) and(cd) there(f)  re-(g) (f) memberest(g)  (hih) that(h) thy(gf) brother(g)  (d) hath(gh) ought(f) a-(ef)gainst(dfgd)  thee;(d) leave(hij) there(ji) thy(hj) gift(ji) before(hg)  (h) the(j) al(hijh) tar,(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-205.png",
        nextFileName: "./pages/part-a-206.png"
    },
    {
        title: "part-a-206-0",
        gabc: "and(fhgg) go(fe) thy(fg) way;(g) first(hghg) be(ef) re-(g)con-(f)ci-(fe)led(d) to(f) thy(de)  .(dc)  (c) and(dc~) then(fdf) come(fhg) and(e) of-(g)fer(h) thy(fe) &quot;(dc) al(d)  le(efe) -(d)ia.(d) SUNDAY(h)  (g) AFTER(f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-206.png",
        nextFileName: "./pages/part-a-207.png"
    },
    {
        title: "part-a-206-1",
        gabc: "I(g) have(ig) compassion(ij)  (i)  (i) Ton(i) the(i) mul-(iji):(hi) tude,(i) because(i)  (i) they(i)  have(i) now(i) been(ij) with(i) me(i) three(ij) days,(i) and(h) have(fg) nothing(hi)  (h)  to(h) -(e)and(e) if(f) I(h) send(h) them(h) a-(h)way(gf) =(hi) a(i) they(j)  will(i) faint(h) by(h) the(g) way,(ef) a(g) le-(f)lu(e) 1ia.(e)  (i)  (j)  (i)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-206.png",
        nextFileName: "./pages/part-a-207.png"
    },
    {
        title: "part-a-206-2",
        gabc: "D(c) good(cd) tree(dfddc) T(f) cannot(g) bring(ed) forth(efe) e(d) \u2014vil(dc) -(d)",
        groupIndex: 2,
        filename: "./pages/part-a-206.png",
        nextFileName: "./pages/part-a-207.png"
    },
    {
        title: "part-a-207-0",
        gabc: "neither(f)  (g) can(h) a(g) corrupt(f)  (hg~) tree(gfe) bring(g) forth(fe) good(d) fruit:(d)  ev-(h)ery(j) tree(h) that(g) bringeth(e)  (f) not(h) forth(fe) good(d) fruit(d) is(f)  hewn(de) down,(c) and(e) cast(ge) in-(gh)to(f) the(e) fire,(def) al-(g)le-(fe)lu-(d)ia.(d)   (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-207.png",
        nextFileName: "./pages/part-a-208.png"
    },
    {
        title: "part-a-207-1",
        gabc: "W(c) hat(fcdf) shall(f) I(fg) do??(e) for(e) my(f) lord(gg) taketh(fed)  (d) &#39;a-(fd)way(f) from(g)  me(e) the(h) stew-(gf)ard-(ghgf)ship:(e) I(dhi) can-(hgf)not(ghgf) dig;(e) to(f) beg(g)  (gf)  s(e) v(fe) a-(d)shamed:(d) &#39;I(fd) -(f)re-(f)sol-(fg)ved(f) what(f) to(de) do,(e) that,(dhi)  \u2018when(h) I(h) am(gf) put(fghgf) out(e) of(e) the(dc)  (de) stewardship,(de) 8:(c) they(ffed) may(e)  receive(f) .(hg) me(g) in-(g)8(gf) their(ghgf) houses.(e)  (e) ol(h) el(g)  (h) R(ih) e(gfe) ](e) ",
        groupIndex: 1,
        filename: "./pages/part-a-207.png",
        nextFileName: "./pages/part-a-208.png"
    },
    {
        title: "part-a-208-0",
        gabc: "ut(eh) the(f)  (f) fatherTsaid(e)  (f) to(f) his(d) servants,(ef)  (e) Bring(igj) forg,(ji)  the(gi)  (i) best(hih) robe(he) and(f) put(h) it(gf) on(h) him;(e) and(hg~) put(i) g(h) Ting(g)  on(f) his(fh) hand,(gh) and(hi) shoes(iie) on(fhf) his(gf) feet,(e) al(fg) ](f)  lu-(e)1ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-208.png",
        nextFileName: "./pages/part-a-209.png"
    },
    {
        title: "part-a-208-1",
        gabc: "it(fgh)  (g) not(g) writ;ten,Th\u2018:ine(fef)  (def)  (dc) house(fg) shall(h) be(j) call-(jih)ed(h)  an(kj) house(ji) of(hg) T(h) prayer(g) for(gh) -(ih)S(g) A(g) but(jk) ye(ji) have(hg)  made(hg) it(gh) a(e) den(fg) of(f) roebbers.(edc)  (c) And(c) he(cgfgh) was(g) daily(gh)  (h)  with(ghgfg) )(gf) teach-(fhihj)ing(hg) in(h) the(hih) temple.(g)  (g) \u2014\u2014(j)  (i)  (j) 1(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-208.png",
        nextFileName: "./pages/part-a-209.png"
    },
    {
        title: "part-a-209-0",
        gabc: "his(gj) man(h) went(fg) down(g) Teo(h) his(j) house(jkjjg) jus-(k)ti-(j)fi-(ji)ed(hg)  rather(h)  (gf) than(h) the(h) other:(g)  (g) for(f) every(h)  (j) one(j)  (kj) that(h) ex-(j) -(ki~)alteth(ji)  (hg) himself(h)  (h) shall(e) be(f) a-(g)bas\xe9d;(ef)  (ed) and(hg) he(j) that(j)  humbleth(h)  (g) _(gh) himself(ghg) shall(e) be_(hg) ex-(fg) (g) alted.(g) 1(j)  (i)  (j)  (h) W](g) ",
        groupIndex: 0,
        filename: "./pages/part-a-209.png",
        nextFileName: "./pages/part-a-210.png"
    },
    {
        title: "part-a-209-1",
        gabc: "H(c) e(d) hath(fh) done(h) all(hg) things(fe) well:T(hih) he(h) maketh(ik)  (k) both(k) the(ih)  (i)  deaf(hij) to(ih) hear,(h) and(efgf) the(e) dumb(f) 4(ef) speak.(d) I(h)  (i)  (g)  (h)  (fh)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-209.png",
        nextFileName: "./pages/part-a-210.png"
    },
    {
        title: "part-a-209-2",
        gabc: "=(gd) certain(f)  (f) man(ghg) went(fgh) down(h) from(g) Je-(f)ru-(f)sa-(gh)lem(g) to(dfd)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-209.png",
        nextFileName: "./pages/part-a-210.png"
    },
    {
        title: "part-a-210-0",
        gabc: "Je-(f)e(e) cho,(defec) and(f) fell(g) a-(h)mong(ji) thieves,(hg) which(j) _(k) strippeg(i)  him(j) of(h) his(gh) raiment,(f)  (f) and(g) wounded(f)  (g) him,(h) and(j) departed,(ki)  (j)  (hg)  leaving(gf)  (d) him(ef) half(gh) dead.(g)  (j) [(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-210.png",
        nextFileName: "./pages/part-a-211.png"
    },
    {
        title: "part-a-210-1",
        gabc: "h&#39;(ik)  (cfd~)  (fe)  (dc) them,T(fgf) when(ef) he(fgh) saw(hg)  (hihgg) that(f) he(gh) was(fe)  healed,(ik)  (d)  (d) turned(gh)  (ef) back,(d) and(e) with(c) a(df) loud(ff) voice(f) glo(gh)  ri-(ik) (g) fi-(f)](e) -(dc)al(d) ..(efe) lu-(d)1ia.(d)  (h)  (g)  (f)  (g)  (gfedf) ",
        groupIndex: 1,
        filename: "./pages/part-a-210.png",
        nextFileName: "./pages/part-a-211.png"
    },
    {
        title: "part-a-210-2",
        gabc: "eek(dh) ye(hij) firstf(h) the(h) kingdom(h)  (h) of(h) God,(hg)  (ihgg) and(fg) his(hf) right-(gh) eousness;(fe)  (d) and(g) all(h) these(dgf) things(f) shall(e) be(f) added(g)  (fe) ",
        groupIndex: 2,
        filename: "./pages/part-a-210.png",
        nextFileName: "./pages/part-a-211.png"
    },
    {
        title: "part-a-211-0",
        gabc: "un-(d)to(fe) you,(dc) al-(d)le(efe) lu-(d)ia,(d) [(h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-211.png",
        nextFileName: "./pages/part-a-212.png"
    },
    {
        title: "part-a-211-1",
        gabc: "A(f) great(ef) prophet(hi)  (i) is(i) ri-(h)sen(i) up(j) a-(h)mong(i) us:(i)  (i) and(gihg)  (f)  God(fe) hath(fe) vi-(d)si-(e)ted(f) his(h) people.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-211.png",
        nextFileName: "./pages/part-a-212.png"
    },
    {
        title: "part-a-211-2",
        gabc: "[](e) thou(g) art(h) bidden(ij)  (i) to(g) a(h) wedding,(ij)  (i) sit(ji~) down(ji) in(h) the(f)  (g)  lowest(gh)  (f) place;(e) that(cef) he(d) that(f) bade(h) thee(h) maysay(h)  (gf) un-(h)to(hi)  (i)  thee,(i) Friend,(jij) go(h) up(f) higher;(hi)  (g) then(j) shalt(i) thou(hg) have(f)  \u2014(hihg) el(ef) in(e) the(f) presence(d) gV(f) of(h) them(h) that(g) sit(g) at(f) meat(h)  with(h) thee,(efh) al(ih) le(f) -(e)ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-211.png",
        nextFileName: "./pages/part-a-212.png"
    },
    {
        title: "part-a-212-0",
        gabc: "W(cc) hat(ff) think(cdf) ye(ffe) of(de) Ch(dc) whose(cdf) son(f) is(gh) he?(gfe)  say(hg) un-(h)to(gf) him,(ghg) The(gf) son(g) of(gh) Da-(gfe)vid.(e) Jesus(e)  (f) sait],(ggh)  n-(de)to(f) them,(d)  (ec) How(dhi) then(h) doth(h) Da-(gf)vid(g) in(gh) spirit(gfe)  (e) cail\\(ef)  him(hg) }(e)  (fd) -(d) (ec) ing,(efe) The(f) Lord(fedc) said(d) un-(ef)to(f) -(h)Lord,(g)  Sit(h) thou(gf) on(g) my(ghg) right(e) hand.(e) T(h) et(g)  (h)  (ih) 7(gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-212.png",
        nextFileName: "./pages/part-a-213.png"
    },
    {
        title: "part-a-212-1",
        gabc: "T(cc)  (c) he(cd) sick(d) 5(c) the(d) palsy&#39;r(ed)  (e) therefore(ef) a(e) took(d) ](e) his(d) bed(d)  whereon(cd) e(e) he(de) .-(c)glo-(cd)ri-(ef)fy-(gf)ing(de) God:(e) and(e) all(g) the(gh) peo-(hi) ple,(h) when(h) they(gf) saw(gf) bt(ef) gave(f) praise(gfd) [}(c) to(de) God.(e)  (h)  (g) =0(h)  (ji)  (hg)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-212.png",
        nextFileName: "./pages/part-a-213.png"
    },
    {
        title: "part-a-213-0",
        gabc: "nd(g) when(g) the(h) king(g) came(hjh) inTto(iji)  (ij) see(k) the(j) guests,(hg) he(gh)  saw(ji) there(g) a.(hi) man(h) which(e) had(gh) not(gf) on(h) &amp;(fg) wedding(g)  (gf) gar-(e) ment:(ik)  (e) and(d) he(d) said(ef) un-(gh)to(g) him,(g) Friend,(hjj) how(j) camest(h)  (g)  thou(ik)  (gh) in(g) hither(efg)  (g) not(g)  (fd) hav-(efg)ing(h) a(g) wedding(g)  (gf) garment?(e)  (e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-213.png",
        nextFileName: "./pages/part-a-214.png"
    },
    {
        title: "part-a-213-1",
        gabc: "D(g) the(g) fa-(ggj)ther(hg) knew(hj) tthat(j) it(i) was(j) at(k) the(ji) same(hg) hour(hg)  (f)  \u2018(ki~) in(f) the(h) which(ghji) Je(hg~hihg) sus(hg) said,(h) Thy(ef) son(ggh) &amp;(e) liveth:(e) and(h)  (g)  himself(h)  (j) be-(i)liev-(ghihg)ed,(hg) and(e) his(f) whole(ghg) house.(e)  (e) l(j)  (h)  (j) A(fi) ",
        groupIndex: 1,
        filename: "./pages/part-a-213.png",
        nextFileName: "./pages/part-a-214.png"
    },
    {
        title: "part-a-214-0",
        gabc: "bou(f) w1c\xa3.(ffddc) ed(dc) ser-(fghf)vant,(f) T&#39;1(f) forgave(f)  (gi) thee(ih) al}](fg) that(gh)  debt,(f) e(g) because(fd) thou(f) desiredst(ef)  (g) m(fg) me:(e) [(c) shouldest(ed~) not(e) th:)u(ef)  al-(e)so(e) have.had(e)  (e) -(e) (f)  (e) on(d) a(c) fellow-(d) (de) s.ervant,,(c)  (c) o(f)  ven(f) as(f) I(egi) had(hgi) pi-(h)ty(g) on(h) thee,(gf) al-(g)le-(gh)lu-(f)ia.(f)  (h) |(f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-214.png",
        nextFileName: "./pages/part-a-215.png"
    },
    {
        title: "part-a-214-1",
        gabc: ".(c) en\u2014der(d) thereforet(dhi)  (h) un-(h)to(g) Caesar(h)  (g) the(f) things(g) that(f) are(gh)  Cae-(fed)sar\u2019s:(ed) and(d) un-(ef)to(d) God(f) the(f) things(g) that-(f)are(fe) God\u2019(dc)  al(d) -(efe)lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-214.png",
        nextFileName: "./pages/part-a-215.png"
    },
    {
        title: "part-a-215-0",
        gabc: "ut(d) Je-(ef)sus(g) turned(g)  (e) him(f) about,t(e)  (d) dnd(d) when(f) he(g) saw(h) her,(g)  he(fg) said,(g) Daughter,(h)  (g) be(h) of(g) good(f) comfort;(hg)  (g) thy(cd) faith(f)  hath(ef) made(g) thee(fe) whole,(dc) al(d) le-(efe)lu-(d)ia.(d) |(h) T(g)  (f)  (gh) R(gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-215.png",
        nextFileName: "./pages/part-a-216.png"
    },
    {
        title: "part-a-215-1",
        gabc: "e-(d)ri-(d)ly(f) IT(dc) say(f) un-(g)to(fh) E%(hgg) ge(fg)  (h) -(gf)ra(gh) tion(h)  shall(cd) not(fe) pass,(cd) till(f) all(f) these(ef) things(gf) be(f)  (e) fulfilled.(d)  (d)  -(fh)ven(hghihgg) and(f) earth(ef) shall(g) pass(fe) a-(defe)wdy,(dc) but(c) my(df) words(ffgf)  shall(f) not(f) pass(f) .(g) way,(fe) saith(d)  (d) Lord.(d)  (h)  (g)  (f)  (fgh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-215.png",
        nextFileName: "./pages/part-a-216.png"
    },
    {
        title: "part-a-216-0",
        gabc: "Then(c)  (c)  (dh) those(hi)  (h) when(h) they(h) had(h) seen(h) the(h) mi-(h)ra\u2014cle(h)  (hghihgg) that(fg)  Je-(h)sus(gf) did,(gfd) said(d) un-(d).(c) each(de) o-(ffg)ther:(f) This(h) B(g) of(f) a(e) trutj(g)  that(fe) pro-(d) (efe) &quot;(ddc) n(c) should(d) come(f) P(ef) to(gh) the(f)  (e) world.(d)  (h) [(g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-216.png",
        nextFileName: "./pages/part-a-217.png"
    },
    {
        title: "part-a-216-1",
        gabc: "e(f) God,(gh) make(h) speed(gi) to(h) save(hg) me.(gh) R/.O(f) Lord,(gh) make(h) haste(ghi) to(h)  help(hg) me.(gh) Glory(f) be(gh)  (h) to(h) the(h) Father(h)  (h) and(h) to(h) the(h) Son,(h) and(h) to(ghi)  the(h) Ho-(h)ly(hg) Ghost;(gh) As(f) it(gh) was(h) in(h) the(h)  (h) beginning,(h)  (h) is(h) now(h) and(h)  a(gi) ev\u2014er(h) shall(hg) be,(gh) world(h) without(h)  (h) end.(hi) A-(h) (g) men.+Al(h) ~le-(i)lu-(h)ia(g)  A(ik) Praise(h) be(h) to(h) thee,0(h)  (h) Lord,(h) King(h) of(h) e-(h)ternal(h)  (i) glory:(hg)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-216.png",
        nextFileName: "./pages/part-a-217.png"
    },
    {
        title: "part-a-217-0",
        gabc: "e(dc) of(f) the(gh) two(hgg) which(fg) followed(h)  (gf)  (gh) the(fe) Lord(d) was(ffdfe~ec) An-(fg) (hh)  drew,(g) Simon(f)  (fe~) Peter\u2019s(g)  (f) broth(fe) &#39;r,(dc) al(d) -(efe)lu-(d)ia.(d)  (h)  (g)  (f)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-217.png",
        nextFileName: "./pages/part-a-218.png"
    },
    {
        title: "part-a-217-1",
        gabc: "Hoeil,(c)  (iig~) precious(i)  (j) Cross,(i) t(i) receive(j) the(i) disci-(i)ple(gh)  (ih) of(f) him(e)  who(h) hanged(h)  (f) on(h) thee,(gf)  (j) my(ef) Master(g)  (f) Christ.(e)  (d) ](i) [(j) ](i) g(h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-217.png",
        nextFileName: "./pages/part-a-218.png"
    },
    {
        title: "part-a-217-2",
        gabc: "lessed(eh)  (f)  (f)  (e) [(ef)  (f) ](e) &quot;-(e)O(hhigij) Lord,(i) King(ijji) of(ih)  \u20AC(g) ternal(hi)  (dfhg) glory,(e)  (e) sust;1n(g)  (fe) me,(f) as(f) I(hg) hang(ihih) up-(h)on(fh)  the(g) tree.(e)  (h)  (g)  (h)  (f)  (e)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-217.png",
        nextFileName: "./pages/part-a-218.png"
    },
    {
        title: "part-a-218-0",
        gabc: "A(c)  (gj) ndrew,(h) the(g) servant(h)  (g) of(f) Je-(gh)sus(h) Christ,Ta(g) worthy(g)  (i)  (j) A_(k)  postle(jh)  (j) of(j) God,(i) was(j) Peter&#39;s(j)  (j) brother,(ih)  (g) and(i) partaker(g)  (h)  (h)  of(j) his(i) passion.(g)  (g)  (j)  (i)  (j)  (h) viij(g)  ax-(g)i-(g)mil-(gj)la,(h) beloved(h)  (h)  (g) of(f) Je-(gh) (h) sus,Christ,T(g) took(g)  the(i) A-(j) (k) postle\u2019s(jh) bo-(j)dy:(i) and(j) in(j) a(j) place(j) of(j) honour(ih)  (g)  -(i)bu-(g)ri-(i)ed(g) it(h) with(h) sweet-(h)smelling(j)  (i) spices.(g)  (g) vij(j)  (i)  (j) !(h)  (g)  T(c) lLou(e) -(e)o-(g)verwhelmed(h)  (i) ](g) in(h) hell,(ij) 0(i) Lord,T(i) .(c) them(ij) that(h)  did(f) persecute(h)  (gh) =(ih) the(f) @5(e) righteous:(e) and(d) thou(fh) wast(hg) his(f) lead\u201D(hi)  er(i) on(i) the(hj) wood(dfhf) of(g) the(f) Cross.(e)  (h) __I__l(i)  (j)  (i)  (h)  (dgf) ",
        groupIndex: 0,
        filename: "./pages/part-a-218.png",
        nextFileName: "./pages/part-a-219.png"
    },
    {
        title: "part-a-219-0",
        gabc: "up(ef)  (hg) to(hi) usT(iji) a(h) man(j) so(i)  (k) righteous,(i) restore(k) us(j) a(h)  man(j) 8o(i) holy:(j) destroy(i)  (j) not(i) a(h) man(fg) so(h) dear(i) to(ih) God,(g)  righteous,(kj~)  (i) du-(h) (gh) ti-(ih)ful,and(f) gentle.(e)  (e) M(i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-219.png",
        nextFileName: "./pages/part-a-220.png"
    },
    {
        title: "part-a-219-1",
        gabc: "Wien(cd) blessed(d)  (fe) Andrew(de)  (d) cime(cd) to(f) the(fh) place(ihiih) where(h) the(g) Cross(hg)  had(ef) been(g) prepared,(cd)  (d)  (d) he(h) cried(h)  (hg) out(h) and(ij) said:(h) O(hhg) goodly(fe)  (fg)  Cross,(gi) so(dg) long(ffe) de-(de)sir-(dd)\u2014(c)  (f) and(cd) now(dc) made(fg) ready(h)  (g) a(e) my(f)  eager(g)  (cd) spirit;(d)  (d) fearless(hg)  (h) and(j) joyful(hi)  (h) do(h) I(g) come(ef) to(fg) thee:(g)  therefore(ik)  (dhi)  (h) do(g) thou(hij) al-(hi)so(h) receive(h) N(ihg) me(fe) gladly,(fg) A(g)  (f) as(dg) (R(fdfe) dis-(de) ci~ple,(dd) =(c) who(c) did(d) T(edefhhgf) %(cded) .(efe) thee.(d) I(defgh) I(h) w(g)  (f) ey(g) 151(dgfed) ](dfh) ",
        groupIndex: 1,
        filename: "./pages/part-a-219.png",
        nextFileName: "./pages/part-a-220.png"
    },
    {
        title: "part-a-220-0",
        gabc: "y(f) this(g) I(gh) know(hg) Thou(fgh) S(g) favourest(fd)  (fg) me.(f) By(f) this,(g) That(ih)  mine(h) e-(gh)ne(g) my(g) doth(g) not(g) triumph(h)  (g) against(f)  (hg~) me.(hg) They(fgh)  favourest.(g)  (fd)  (fg) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g) Son,(g)  and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) Rr.(h) By(f) this.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-220.png",
        nextFileName: "./pages/part-a-221.png"
    },
    {
        title: "part-a-220-1",
        gabc: "A1l(gj) ge-(h)ne-(g)ra-(h)tions(g) T(c) shall(ffg) call(g) me(gh) blessed:(f)  (f) for(f)  (f) he(hj)  that(j) is(i) mighty(ji)  (hg) |(dge) mag-(f)ni-(gh)fi-(f)ed(e) me,(d) al-(cdeef)le-(fg)lu-(g)ia.(g)  [(j)  (i)  (j)  (h) ](g)  (ef) ",
        groupIndex: 1,
        filename: "./pages/part-a-220.png",
        nextFileName: "./pages/part-a-221.png"
    },
    {
        title: "part-a-221-0",
        gabc: "hou(f) ert(f) all(hh) fair,(i) C(g) Me-(g)ry;(hf~) there(fhf) is(ghg) 1o(fe) spot(fg) in(ef)  thee.(ik)  (d)  (fh)  (h)  (g)  (f)  (h)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-221.png",
        nextFileName: "./pages/part-a-222.png"
    },
    {
        title: "part-a-221-1",
        gabc: "by(g) raiment(h)  (g) is(hhf) white(j) as(j) snow,(i) thy(g) countenance(h)  (g)  (cef)  like(h) the(h) sun.(g)  (feh)  (j)  (i)  (h)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-221.png",
        nextFileName: "./pages/part-a-222.png"
    },
    {
        title: "part-a-221-2",
        gabc: "hou(h) art(h) the(h) ex-(g)al-(f)ta-(gh)tion(f) of(f) e(ded) ru-(ef)sa-(f)lem,(e) thou(e)  glo-(f)a(e) Is-(e)ra-(e)el,(f)  (f) thou(f) art(d) the(f) great(h)  T(g)  (g) 1(ii)  (hghih) of(fh) our(g) N(e) T(e) |(f) P(h) S(f)  (h)  (i)  (h)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-221.png",
        nextFileName: "./pages/part-a-222.png"
    },
    {
        title: "part-a-222-0",
        gabc: "Blessed(ig~)  (c)  (cig)  (i) art(j)  (i) 0(gh) Virgin(ih)  (f) Ma-(e)ry,(e) of(f) the(h) Most(h) Higlh(fh)  God,(g) above(f)  (f) ](e) the(f) women(f)  (f) up-(f)on(h) the(g) a.(e) earth.(j)  (i)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-222.png",
        nextFileName: "./pages/part-a-223.png"
    },
    {
        title: "part-a-222-1",
        gabc: "-(ed)us,(g) O(hj) Maiden(i)  (j) 2(k) Ja(ji) 8(hi) .,(hg) we(g) will(h) run(ji) af-(ghhi) (g)  .(h) thee(h) in(g) a(e) goodly(fg) a(g) &#39;(h) fragrance(gf) of(g) thine(gf) n-(e)5(e)  ments.(ki)  (e)  (ji)  (hi)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-222.png",
        nextFileName: "./pages/part-a-223.png"
    },
    {
        title: "part-a-222-2",
        gabc: "he(f) Almighty(f)  (g)  (h) God(hg) Hath(f) girded(gh) 1=(g) &#39;me(fd) with(fg) strength.(gf)  The(ki~)  (f) Almighty(f)  (g) God.(gh)  (hg) \xa5.(c) And(h) made(hi) my(h) way(ig~) per(fgh) fect.(hg)  Hath(f) girded.(gh)  (g) \xa7.(c) Glory(h)  (h) be.(h) The(f) Almighty(f)  (g)  (gh) Cod-(hg)",
        groupIndex: 2,
        filename: "./pages/part-a-222.png",
        nextFileName: "./pages/part-a-223.png"
    },
    {
        title: "part-a-223-0",
        gabc: "he(g) Lord(hj) God(j) said(j) Tun\u2014to(ij)  (k) the(ji) serpent,(g)  (g) I(h) will(h) put(j) en-(ij) mi-(h)ty(h) between(g)  (ef) thee(g) and(h) the(j) woman,(j)  (j) and(j) between(i)  (gh) thy(i) seed(h)  and(gh) her(jk) seed;(j) it(jkj) shall(g) bruise(h) thy(gf) head,(gh) al-(jh)le-(gf)lu-(e)ia.(e)  As(j) at(h) I(j) Vespers(ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-223.png",
        nextFileName: "./pages/part-a-224.png"
    },
    {
        title: "part-a-223-1",
        gabc: "&#39;(c) [](c) us(d) ce-(fg)le-(fed)brate!(d) the(d) worshipful(e)  (d)  (d) Conception(efe)  (d)  (d) of(f)  the(g) blessed(h)  (f) and(g) glo-(f).(e) ous(dg) Virgin(e)  (fe) Ma-(dd)-(c)whose(cd) low-(fggf) li-(gh)ness(hgg) the(fg) Lord(hg) re-(f)gard-(ghgf)ed(d) when(gh) at(fe) the(dg) word(fe) of(d)  an(ik)  (fe) An-(dd)l(c) she(c)  (d) conceived(fg)  (f) the(f) world&#39;s(h)  (fe)  (d)  (dc)  al-(d)le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (gfedf) ",
        groupIndex: 1,
        filename: "./pages/part-a-223.png",
        nextFileName: "./pages/part-a-224.png"
    },
    {
        title: "part-a-224-0",
        gabc: "n(cd) thy(f) patience(gh)  (h) Tthou(c)  (h) didst(h) possess(h)  (hj) thy(h) soul,(h) a(g)  Lu(ik)  (hg) cy,(def) spouse(g) of(fe) Christ:(d) thou(c) didst(e) hate(g) the(g) things(g)  which(ik)  (g) are(f) in(g) the(fe) world,(d) and(f) thou(g) shinest(hi)  (h) among(j)  (hi) the(g)  An-(ik) (f) gels:(f) resisting(f)  (h)  (g) un-(h)a(fe) -(d)a(e) didst(f) van-(g) quish(ik)  (g) a(e) =(f) &#39;e-(ed)-(d) (f)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-224.png",
        nextFileName: "./pages/part-a-225.png"
    },
    {
        title: "part-a-224-1",
        gabc: "W(c)  (c) thile(g) ho(igij) Iy(i) Lu-(ij)cyT(i) prayed,(hih)  (hgh) there(gh)  (h) appeared(h)  (hg)  (f) un-(ffh)to(h)  her(gi)  (g) the(f) blessed(gh) O(f) A-(h)ga-(h)e(g) who(e) S(g) consoled(i) t(h) A(f) hand-(gfh) maid(g) of(f) Christ.(e)  (fh)  (i)  (j)  (i)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-224.png",
        nextFileName: "./pages/part-a-225.png"
    },
    {
        title: "part-a-225-0",
        gabc: "O_(gi)  (e) virgin(g)  (h) Lu-(ij)cy,(i) dost(i)  (i) thou(g) ask(i) of(hg) me(ef) that(f) which(ed)  thou(g)  (e) thyself(f)  (fi) canst(hg) presently(hi)  (h)  (h) bestow(h)  (h) up-(gf)on(fgh) thy(g)  mother?(i)  (e)  (e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-225.png",
        nextFileName: "./pages/part-a-226.png"
    },
    {
        title: "part-a-225-1",
        gabc: "hrough(g) thee,(gj) O(h) virgin(hg)  (f) Lu-(gh)cy,(g) the(g) Sy-(i)ra-(j)cu-(k)san(jh) ci-(j)ty(i)  -(ik)shall(j) be(j) glori-(jk)fi-(ji)ed(g)  (g) by(i) the(g) Lord(h) Je-(j)sus(i) Christ.(g) T(j)  (i)  (j)  (h) |(fg) ",
        groupIndex: 1,
        filename: "./pages/part-a-225.png",
        nextFileName: "./pages/part-a-226.png"
    },
    {
        title: "part-a-225-2",
        gabc: "I&#39;(gd) bless(fg) thee,!(g) O(g) a(g) &quot;(g) of(g) my(h) Lord(ij) Je-(h)sus(i) Christ:(g)  for(g) by(g) thy(h) Son(ji) the(hg) fire(ge) is(g) quenched(fe)  (f) round(d) a-(ef)bout(gh)  thine(h) handmaid.(g)  (g)  (j)  (i)  (j)  (h) _(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-225.png",
        nextFileName: "./pages/part-a-226.png"
    },
    {
        title: "part-a-226-0",
        gabc: "O(e) Y(dc) o(c) sister(d)  (ef) s(e) God\u2019(e) s(f) consecrated(e)  (f)  (fh) virgin,(hg)  (f) why(i)  (i)  dost(i) thou(i) ask(ijk) of(ji) me(ji) A(i) which(ig) thou(h) thyself(g)  (f) v(f)  (f)  presently(fi)  (h)  (h) bestow(h)  (g) up-(f)on(fh) thy(g) s(e) 8-(e)J|(h) oy(g)  (h) o=(f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-226.png",
        nextFileName: "./pages/part-a-227.png"
    },
    {
        title: "part-a-226-1",
        gabc: "A(d) pillar(df)  (e) art(f) thou(df) that(f) may(d) not(fh) be(gf) moved,(ghg)  (hih) O(h)  (gf)  (ef)  .(kj)  spouse(g) of(fe) Christ:(d) and(d) all(ffg) the(d) -(ef)people(e) are(d) waiting(cd) a.(c)  .(c) til(d) -(fg)re-(f)ceive(ighghih) -(ef)crown(g) of(fe) e(dc) al-(d)an(efe)  lu(d) .(d) ..(h) &amp;(g) \u2014\u2014(f) =(g) Te(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-226.png",
        nextFileName: "./pages/part-a-227.png"
    },
    {
        title: "part-a-226-2",
        gabc: "W(i) such(i) gravity(i)  (i) T(i) was(g) she(i) en-(j)du-(i)ed(i) by(j)  (g) the(h) Ho-(ih)ly(f) et(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-226.png",
        nextFileName: "./pages/part-a-227.png"
    },
    {
        title: "part-a-227-0",
        gabc: "a(e) Spirit,(e) that(h) the(h) virgin(h)  (h) of(f) the(h) Lord(g) remained(f)  (ef)  (g) un-(f) moved.(e)  (e)  (i)  (j) December(i)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-227.png",
        nextFileName: "./pages/part-a-228.png"
    },
    {
        title: "part-a-227-1",
        gabc: "B(c)  (g) ecause(g) thou(f) hast(h) seen(j) me,T(i) Thomas,(g)  (i) thou(j) hast(h) be(g)  lieved:(hg)  (f) blessed(g)  (g) are(g) they(g) that(f) have(h) not(j) seen,(i) and(g)  yet(ki~)  (j) have(h) 2(g) believed,(h) p(gf) al(fgh) le-(h)lu=-(g)ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-227.png",
        nextFileName: "./pages/part-a-228.png"
    },
    {
        title: "part-a-227-2",
        gabc: "[](d)  (e)  (f)  (g) i(h)  (gh) .(j)  (j)  (j) [](i)  (h)  (j)  (i)  (g)  0(h)  (g)  (h) [(d) ](e)  (f) i(g) R(h)  (gh) i(gf) _\u2014}(g)  (h) v(j)  (i)  (h)  )(j) 0(i) *(g)  (h) i(gh)  (ed) i(hj) R(g)  (f)  (ed) i(fgh)  (g) U(fe) S(d) T(e) |(efghi) ",
        groupIndex: 2,
        filename: "./pages/part-a-227.png",
        nextFileName: "./pages/part-a-228.png"
    },
    {
        title: "part-a-228-0",
        gabc: "0..(cc) most(f) blessed(g)  (f) of(gh)  (h) men!Twho,(f) .(h) rejecting(jj) ..(j) this(i)  (hi) world,(h)  bore(ik)  (jj) the(h) yoke(fg) of(f)  (fe) Bule(f)  (fg) from(fh)  (i) a(i) tender(hg) years(fghg) sio(fe)  loving-(ik) (f) 1ly;(fgf)  (f) and(h) be-(jjk)ing(j) made(j) o-(ih)be(gf) di-(g)ent(h) e-(ih) ven(ij)  (g) un-(h)a(fe) death,(fgf) he(h) de(j) -(jkj)ed(h) him-(ih)self,(gh) that(h)  he(i) might(ih) whol-(jjk)ly(j) cling(ih) to(g) Christ(hg) his(fe) Mas-(fgf)ter,(f)  al(f) le(fghfefihgh) lu-(cdfg)ia.(f) |(fh) =(h) O(f)  (gh) AT(g) I(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-228.png",
        nextFileName: "./pages/part-a-229.png"
    },
    {
        title: "part-a-228-1",
        gabc: "T(ik)  (c) he(cded) blessed(g)  (hi) Mau-(j)rus,(i) T(c) born(ijk) of(j) a(j) renowned(j)  (ji)  (h) and(h) noble(i)  (h)  house,(ki~)  (g) from(g) his(g) boyhood(hi)  (h) esteemed(h)  (hij)  (g) the(g) reproach(g)  (e) of(fg) ",
        groupIndex: 1,
        filename: "./pages/part-a-228.png",
        nextFileName: "./pages/part-a-229.png"
    },
    {
        title: "part-a-229-0",
        gabc: "Christ(g) greater(gf)  (e) .(ed) miches(d) than(h) the(ij) treasures(h)  (gf) of(e) the(de)  world.(e)  (j)  (ji)  (hi)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-229.png",
        nextFileName: "./pages/part-a-230.png"
    },
    {
        title: "part-a-229-1",
        gabc: "Up-(e)held(g) by(h) wings(ih) of(g) o-(h)be-(ij) (i) di-(i)he(h) walked(jk)  (ji) up-(i)on(gh)  (i)  the(i) waters;(hg)  (e) and(e) borne(g) by(g) the(g) Spirit(hf)  (h) of(h) God,(g) he(g) was(h)  (i)  saved(ij)  (i) from(h) sinking(hf)  (gf) in(e) the(de) flood.(e) [(i) R,(j)  (i) &quot;(h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-229.png",
        nextFileName: "./pages/part-a-230.png"
    },
    {
        title: "part-a-229-2",
        gabc: "a(e) blessed(c)  (d) Maurus,(idhi)  (h) a(h) disciple(h)  (g)  (f) of(gh) ho-(h)ly(h) Be-(hj)ne-(h)dict,(h)  from(gf) tender(fg)  (d) years,(d) stood(g) forth(g) as(g) a(g) zealous(h)  (g) follower(g)  (f)  (f)  ](e) his(f) .(g) master(dfe) &#39;s(d) excellence.(d) .(d)  (h)  (g)  (f)  (gh)  (g)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-229.png",
        nextFileName: "./pages/part-a-230.png"
    },
    {
        title: "part-a-230-0",
        gabc: "From(f) the(f) hotse(efddc) of(fg) prayer(g) he(g) passed(gf) a(g) o(ghf) ver(f) unto(f)  (f) the(f)  place(ki~)  (gf) of(f) the(f) -(fh)wondrous(ihg) ta-(i)ber-(h)na-(gf)cle,(f) e-(f)ven(f) un-(g)to(f) the(f)  house(fhihg) of(ih) God,(gf) with(efd) \u2018exceeding(dc)  (f)  (fg) love(g) of(gf) whom(g) he(ghg)  burned.(f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-230.png",
        nextFileName: "./pages/part-a-231.png"
    },
    {
        title: "part-a-230-1",
        gabc: "He(c)  (dh) [(hi) ](hg) chosen?(f) by(g) the(gh) Lord(h) to(h) be(hj) an(h) example(g)  (fg)  (d) to(c) the(d)  (f)  cloistered,(f)  (f)  (f) and(h) a(g) chief(fg) observer(f)  (fe) ,(cd) of(fg) the(e) o(f)  (ed) Rule.(d)  .(h)  (g)  (f)  (gf)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-230.png",
        nextFileName: "./pages/part-a-231.png"
    },
    {
        title: "part-a-231-0",
        gabc: "o-(c)day(cd) ho-(d)1y(c) Maurus,(efd)  (d) lying(f)  (h) up-(h)on(h) a(h) goat-(hi)skin,(h) died(fg)  hap-(h)pi-(fe)ly(d) before(dg)  (fe) the(d) altar;(cd)  (d) to-(d)day(dg) the(g) first-(h)begot-(g) (fg)  ten(f) dis-(f)ci-(fe)ple(d) of(df) blessed(f)  (f)  (f)  (fe)  (dc) the(c)  (d)  guiding(ffg)  (f) of(g) the(f) Ho-(g)ly(gh) Rule,(h) came(hjk) up(ji) to(hg) Christ,(ijh) rising(h)  (g)  untroubled,(hg)  (f)  (e) accompdnied(d)  (fe)  (dc) by(c)  (e) choirs(g) of(dfe) Angels;(cd)  (d)  to-(d)day(dh) the(h) o-(h)be-(h)di-(g)ent(h) man,(gf) telling(g)  (g) his(gh)  (h) victories,(d) N(d)  vas(cd) worthy(fg)  (fh) to(h) be(g) crowned(hg)  (f) by(g) the(fe) Lord,(dc) al-(dg)le-(efe)lu-(d)ia.(d)   (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-231.png",
        nextFileName: "./pages/part-a-232.png"
    },
    {
        title: "part-a-232-0",
        gabc: "lessed(h)  (fed)  (ef) in(e)  (e) the(g) midst(i) of(hg) the(fe) flames,(fe)  stretched(ig~)  (fi)  (h) out(hg) her(f) hands(h) and(g) prayed:(e)  (e) I(h) call(hg) on(fh)  thee,(hhe) O(gh) Father(i)  (hg) transcendent,(fh)  (h) -(h)august,(h)  (h) and(hiih~gih~hi) dread;(ih)  for(h) by(h) thy(i) ho-(j)ly(i) Son&#39;s(ij) pro-(h)tec(hghihi) tion(ih) I(i) have(e) es-(g) caped(i)  (h) the(h) threats(h) of(g) an(h) impious(f)  (e)  (f) tyrant,(de)  (e) and(f)  passed(de) a(e) unscathed(f)  (de) e\xab(e) through(e) the(i) foulness(hg)  (e) of(f) fleshly(hf)  (g)  \u2014(f) pollution:(e) _a:(e) #d(c) behold,(de)  (ffe) I(ef) cbfie(cd)  (c)  (c) to(df) thee,(gfefgf) whom(f) I(f) have(i)  Ioved,(hg)  (ef) whom(hf) I(g) have(f) jught,(ed) whom(f) T(f) have(i) alway(h)  (hg) de-(fgf) sired.(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-232.png",
        nextFileName: "./pages/part-a-233.png"
    },
    {
        title: "part-a-233-0",
        gabc: "Ag-(ig) (i) nes(j) en-(i)ter-(hi)ed(i) the(fh) place(ih) of(f) shame,(e) she(h) found(h)  the(h) An-(fh)gel(g) of(f) the(e) Lord(f) ready(f)  (h) beforehand.(g)  (e)  (e) A(i)  (j)  (i) N(h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-233.png",
        nextFileName: "./pages/part-a-234.png"
    },
    {
        title: "part-a-233-1",
        gabc: "or(i) I(g) have(ij) with(i) &quot;(i) of(h) the(g) A(e) the(h)  Guardi-(h)an(g)  (h) of(fh) my(g) bo-(e)dy.(e)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-233.png",
        nextFileName: "./pages/part-a-234.png"
    },
    {
        title: "part-a-233-2",
        gabc: "ith(ig) nis(ij)  (i) my(i)  (i) Lord(ij) Je-(i)sus(g) Christ(ih~) ](f)  (e) |(e)  me,(e) and(h) as(h) his(fh) bride(g) hath(f) he(e) crowned(fh)  (g) me.(e) |(i) R(j)  (i)  (h) |(gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-233.png",
        nextFileName: "./pages/part-a-234.png"
    },
    {
        title: "part-a-233-3",
        gabc: "[(gd) bless(fg) thee,T(g) 0(g) Father(g)  (g) of(g) my(h) Lord(j) Je-(h)sus(i) Christ:(g) ",
        groupIndex: 3,
        filename: "./pages/part-a-233.png",
        nextFileName: "./pages/part-a-234.png"
    },
    {
        title: "part-a-234-0",
        gabc: "for(g) by(g) thy(h) Son(ji) the(hg) fire(ge) is(g) quenched(fe)  (f) round(d) aboyt(f)  (h)  (h)  thine(h) handmaid.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-234.png",
        nextFileName: "./pages/part-a-235.png"
    },
    {
        title: "part-a-234-1",
        gabc: "R(gd) ejoice(f) with(fg) me(g) Tand(gi) be(k) exceeding(jh)  (j)  (j) glad,(i) because(k)  (k)  among(ik)  (j)  (j) all(k)  (k) these(jijkj) I(h) have(g) taken(h)  (h) a(h) throne(j) of(i) glory.(g)  (g) Y(jijh) ",
        groupIndex: 1,
        filename: "./pages/part-a-234.png",
        nextFileName: "./pages/part-a-235.png"
    },
    {
        title: "part-a-234-2",
        gabc: "o,(d) that(f) which(g) I(g) desired,T(g)  (gh)  (g) now(ge) I(fgh) see;(fed) that(c) for(d)  which(f) I(f) \u2018hoped,(g)  (f) L(fd) now(fh) =(fg) possess;(ghg) I(f) am(g) u-(hj)ni(jjh) ted(ih)  in(g) heaven(h)  (g) un-(f)to(e) him,(g) whom(h) on(fed) edrth(ed) I(f) loved(fe)  (d) with(e)  a(f) A(gf) perfect(gh) de-(gf)T(e) tion.(e) S(h)  (g) -(h)S(ih)  (gfe) _I(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-234.png",
        nextFileName: "./pages/part-a-235.png"
    },
    {
        title: "part-a-235-0",
        gabc: "While(d) the(f) blessed(d)  (dc) Ag(fgh) nes(h) Twas(fg) standing(h)  (h) in(h) the(h) midst(hj)  of(h) the(h) flames,(ihghihgg) she(fg) stretched(h)  (gf) out(h) her(fe) hands,(d)  (j) andpray-(cd) (fdfgh)  ed(ki~)  (ed) un-(e)to(fe) God:(d) Almighty(h)  (h)  (gf) Lord,(g) worthy(d)  (f) of(f) all(fe)  (dc)  (cd)  ra(ki~)  (fdfgh) tion,(ed) fear,(e) and(ef) worship:(d)  (d) I(h) bless(h) thy(gf) ho(g) ly(defedcd)  Neme,(dc) and(c) I(d) glorify(f)  (g)  (f) thee(gh) for(g) ev-(fe)\xe9r(dc) and(ef) ev-(d)er.(d) MTe(hg) de(fghgf) ",
        groupIndex: 0,
        filename: "./pages/part-a-235.png",
        nextFileName: "./pages/part-a-236.png"
    },
    {
        title: "part-a-235-1",
        gabc: "%\u2014\u2018\uFB01(ffe)  (dc)  (dfd)  (e)  (e)  (f)  (dc)  (fe) a(fgf)  (d)  (ce) |(e)  (f) &amp;(g) =(h) @200(j) &quot;8(h) ](gfe)  M(f)  (dc)  (fe) &quot;(fgf) o(d)  (ce) o(e) &amp;(dedd)  (d) JL(edfd) &amp;(e) o(e) \u2014(g)  (f) o(dc)  I(df)  (fe) i(de)  (e) -(ed)[(c) ](cd) -(de) (d)  (j) A(f)  (fh) |(fh) &amp;(fg) -(fe)T(de)  (e) |(dfg)  (efghi) ",
        groupIndex: 1,
        filename: "./pages/part-a-235.png",
        nextFileName: "./pages/part-a-236.png"
    },
    {
        title: "part-a-236-0",
        gabc: "a(e) a(e) An-(g)a-(h)ni(ihji) as,(i) and(i)  (j) enquire(ji) for(hih) Saul,(i) f,,(g)  behold,(gh)  (h)  (h) he(f) [(e) prayeth:(e) for(e) he(ei) is(i) a(i) chosen(i)  (i) vessel(h) -(gh)un-(ij) to(j) me,(i) to(j) bear(ih) my(fh) Name(hh) before(g)  (ij) the(i) Gentiles,(hg)  (fh) and(hih)  Kings,(fed) and(fh) the(h) -(h)children(g) of(h) Is-(ih)ra-(f)el.(e) -(i) (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-236.png",
        nextFileName: "./pages/part-a-237.png"
    },
    {
        title: "part-a-236-1",
        gabc: "T(c) hou(d) art(d) the(dc) shepherd(f)  (g) of(f) the(fh) sheep,(h) 0(hjkj) chief(hihhg) of(fe)  the(fg) &#39;A-(fe) (d) postles:(d) un-(g)to(g) thee(h) were(g) given(fe) .(c) the(d) keys(ffg)  of(f) the(f) kingdom(ef)  (g) of(fe) heaven.(d)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-a-236.png",
        nextFileName: "./pages/part-a-237.png"
    },
    {
        title: "part-a-237-0",
        gabc: "](c)  (eh) have(f) e(f)  (e)  (f) watered,(f)  (ed)  (ef)  (f)  (e) but(h) God(hf) gave(gh) the(f) fan-(ef) crease,(d) al-(ef)le-(f)lu-(e)ia.(e)  (g) e(e)  (e) w(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-237.png",
        nextFileName: "./pages/part-a-238.png"
    },
    {
        title: "part-a-237-1",
        gabc: "0(gh)  (e) gladly(eh)  (f) will(fe) I(d) glory(f) t(e) in(gh) my(i) in-(fh)firm-(h)i-(h)ties,(g) that(i)  the(gi)  (h) power(hj) of(i) Christ(hghih) may(f) rest(h) up-(g)on(e) me.(e) I(h)  (g)  (h) el(f) |(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-237.png",
        nextFileName: "./pages/part-a-238.png"
    },
    {
        title: "part-a-237-2",
        gabc: "T(c) he(f) grace(e) of(f) God(hi) Twhich(i) was(i) bestowed(i)  (i) )(h) up(i) on(j) me(i) was(h)  not(ij) in(j) vain:(i) but(f) his(i) grace(g) a-(h)bi(fe) deth(fe) with(de) me(fh)  always.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-237.png",
        nextFileName: "./pages/part-a-238.png"
    },
    {
        title: "part-a-238-0",
        gabc: "I(g) \xa7(gj) Damascus,(h) T(hg) the(f) governor(gh)  (h) e\xab(g) under(g)  (i) A-(j)re-(k)tas(jh) the(j)  king(i) would(j) have(j)  (i) apprehended(h)  (j) me:(i)  (g) but(g) I(ch) was(g) let(h) down(g)  the(g) wall(fghgf) by(f) the(f) brethren,(g)  (f) in(g) a(h) basket;(jk)  (jijkj) and(j) so(k) es-(i) caped(ik)  (j)  (h) out(j) of(g) his(h) hands(g) in(g) the(g) Name(df) of(h) the(h) Lord.(g)  (jijhg) ",
        groupIndex: 0,
        filename: "./pages/part-a-238.png",
        nextFileName: "./pages/part-a-239.png"
    },
    {
        title: "part-a-238-1",
        gabc: "T(c) hrice(eh) 0(f) I(e) beaten(f)  (de) with(f) e(e) rods,t(j) once(fh) was(i) I(hf) stoned,(h)  (g)  thrice(i) I(i) suffered(h)  (h)  (h) shipwreck,(iji)  (hghih) for(f) the(e) Name(fghf) of(fg) Christ.(e)  N.(h) Thou(g)  (h) a(f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-238.png",
        nextFileName: "./pages/part-a-239.png"
    },
    {
        title: "part-a-238-2",
        gabc: ".(dd) L)(c) have(df) followed(g)  (f) )(de)  (d) .(c) sit(d) up-(f)on(f) twelve(fgh) ",
        groupIndex: 2,
        filename: "./pages/part-a-238.png",
        nextFileName: "./pages/part-a-239.png"
    },
    {
        title: "part-a-239-0",
        gabc: "thrones,(g) judging(g)  (e) the(g)  (fe) tribes(ef) of(gf) Is-(d)ra-(c)el,(ef)  saith(ki~)  (g) the(fe) Lord.(d) &quot;(h) a(g) _(f) &quot;4(gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-239.png",
        nextFileName: "./pages/part-a-240.png"
    },
    {
        title: "part-a-239-1",
        gabc: "O(g) ho-(g)ly(f) A(fd) pos-(fh)tle(fg) Paul,(ghggf) thou(hj) preacher(j)  (i) of(j) the(g)  truth(h) and(h) Doctor(g)  (gh) of(h) the(g) Gen-(hgf)tiles,(f) &quot;(g) intercede(g)  (g) for(f)  us(h) un\u2014to(j)  (i) God,(j) who(h) hath(gf) chosen(gh)  (h) thee.(g) -(j) (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-239.png",
        nextFileName: "./pages/part-a-240.png"
    },
    {
        title: "part-a-239-2",
        gabc: "I(e) the(e) hea-(eh)ven-(f)\u2014(ed) kingdomT(ef)  (e) the(e) Blessed(g)  (h) have(i) their(hf)  dwelling-(h) (h) place,(g)  (f) and(ih) their(iji) rest(hghih) for(fe) ev-(fgh)er(f) and(gf) ev-(e)er.(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-239.png",
        nextFileName: "./pages/part-a-240.png"
    },
    {
        title: "part-a-240-0",
        gabc: "he(c)  (c)  (cd) an-(dedf)cient\xae(d) carri-(d)ed(c)  (d) the(fe)  (decf) but(c)  (f) the(f) In-(ihih)fant(ghg)  -(e)governed(f) a(g) the(d) O(d) ancient:(d) he(d) whom(f) a(e) Virgin(f)  (e) bare,(d) and(e)  _(ik) after(d)  (c) bearing,(de)  (d) remained(ef)  (g)  (cd) virgin,(d)  (d) the(f) same(ghghih) was(hg)  worshipped(i)  (h)  (g)  (fe) by(dc) her(d) who(efe) bare(d) him.(d) &amp;(h)  (g) _\u2014a(f)  (g) a,(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-240.png",
        nextFileName: "./pages/part-a-241.png"
    },
    {
        title: "part-a-240-1",
        gabc: "2(g) i-(h)me-(j)on,Ta(j) just(hj) and(i) a(g) \xa5(hi) man,(i) a-(g)waited(iij)  (h) the(h)  \u2014_\u2014(f) so(h) -(i)tion(h) .(g) I(gh) ra-(gf)A(e) and(g) M(h) Ho-(j)1ly(ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-240.png",
        nextFileName: "./pages/part-a-241.png"
    },
    {
        title: "part-a-241-0",
        gabc: "Ghost(h) was(g) up(ghg) a-(e)him.(e)  (j)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-241.png",
        nextFileName: "./pages/part-a-242.png"
    },
    {
        title: "part-a-241-1",
        gabc: "[(e) tvas(e) revealed(g)  (i)  (h) un-(h)to(f) Si-(h)me-(h)on(g) Thy(g) the(f) Ho-(h)ly(g) Ghost,(ghg)  that(h) he(i) should(h) not(f) see(hg) death,(g) a(e) hefore(gh) he(f) had(f) seen(g) the(f)  Lord.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-241.png",
        nextFileName: "./pages/part-a-242.png"
    },
    {
        title: "part-a-241-2",
        gabc: "S(g) me-(h)on(j) took(h) the(j) Child(i) Tup(h) in(h) his(ih) arms;(g) and(j)  giving(i) :(g) thanks,(hf) he(h) blessed(hi)  (g) the(g) Lord.(e)  (j) -(h)-(j)I(ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-241.png",
        nextFileName: "./pages/part-a-242.png"
    },
    {
        title: "part-a-241-3",
        gabc: "A(h) lightT(hg) [(e)  (gh) lighten(f) a(e) Gentiles,(f)  (d) and(d) the(f) glory(h)  (ge) of(g)  thy(h) people(f)  (f) Is-(g)ra-(f).-(e) (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-a-241.png",
        nextFileName: "./pages/part-a-242.png"
    },
    {
        title: "part-a-242-0",
        gabc: "A(c) nd(f) they(h) of-(j)fer-(i)ed(g) for(i) him(j) to(h) the(g) Lord(f) a(f) pair(f) of(h)  turtle(i) doves,(i) or(h) two(i) young(h) m-(g)pigeons.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-242.png",
        nextFileName: "./pages/part-a-243.png"
    },
    {
        title: "part-a-242-1",
        gabc: "A(c) hd(cd) when(f) the(gi) \u2122(ih) parentsTbrought(g) &amp;(fh) in(g) the(h) Child(ff) Je(dfe) dus,(dc)  (g)  then(igi) Si-(i)me-(hg)on(hi) took(ji) him(jkjh) up(h) in(f) his(gh) arms,(ghffd) and(gh) bless-(fe) d(dc) God,(df) say(defc) i:l&#39;g:(c) Lord,(gggfed) now(ef) lettest(gh)  (g) thou(fe) thy(defed)  ser(dc~fede) vant(ed) de-(ge)part(h) 1in(cdef) peace.(d) &quot;(h) a(g) _(f) d(gh) p,(dfgf) ",
        groupIndex: 1,
        filename: "./pages/part-a-242.png",
        nextFileName: "./pages/part-a-243.png"
    },
    {
        title: "part-a-242-2",
        gabc: "=(d) .(de) Tthe(ffh) blessed(h)  (fgf) Virgin(cdde)  (fgf) a(e) ry(e) a(dhg) presented(hi) the(i)  (i)  Child(ij) Je-(hg)@(fe) in(f) the(fgf) temple;(e) a(e) and(eef) _(d) me-(de)=(e) on,(j) fi\u201D&#39;ed(fgh)  (fgf) ",
        groupIndex: 2,
        filename: "./pages/part-a-242.png",
        nextFileName: "./pages/part-a-243.png"
    },
    {
        title: "part-a-243-0",
        gabc: "with(e) the(d) Ho-(f)ly(hg) Spirit,(e)  (e) received(i)  (h)  (f) him(hg) in-(hi)to(h) his(hg) arms,(f)  and(hg) blessed(iji)  (hg) God(ef) for(gf) ev-(e)er.(e) tat(h)  (g)  (h)  (f) ](efe) ",
        groupIndex: 0,
        filename: "./pages/part-a-243.png",
        nextFileName: "./pages/part-a-244.png"
    },
    {
        title: "part-a-243-1",
        gabc: "T\xa5e(ik)  (dc) blessed(d)  (f) A~ga-(de) (dc) tha,(c) standing(f)  (h) in(h) themidst(g)  (f) of(e) the(g) pri-(fed) son,(ki~)  (d) with(cd) out-(dhi)SN(h) stretched(gf) hands(ed) entreated(cd)  (fe)  (gh) the(fe) Lord:(d) OLord(h)  (gh)  Je-(ji)sus(jkj) Christ,my(h)  (hgf) gracious(ed)  (efe) Master,(d)  (d) I(c) give(df) thanks(fe) un-(de)to(d)  thee(c) who(c) hast(df) en-(fe)a-(gh)bled(h) me(h) to(h) o-(h)ver-(gh)come(h) the(ed) torments(fh)  (g)  of(e) the(d) ex-(ef)e-(e) (d) tion-(cd)er:(d) bid(c) me(df) now,(fe) O(de) Lord,(dc) joy(f)  (hi)  ful-(hg)ly(gh) i(gf)  (fg) |(fe) S(d) to(d) thine(f) un-(fe)fading(gh) B(fe) CRNTRCH(d) |(d) I(hg) Y(fg) Y(gfe) ",
        groupIndex: 1,
        filename: "./pages/part-a-243.png",
        nextFileName: "./pages/part-a-244.png"
    },
    {
        title: "part-a-244-0",
        gabc: "ho(i) art(i) thou(i) that(i) comest(i)  (g) un(i) to(j) me(i) to(h) heal(ih) my(f)  wounds?(e) I(h) am(h) the(h) A-(h) (h) postle(f) of(h) Christ;(g) be(f) not(e)  doubtful(f) g(f) of(f) me,(h) my(g) a-(e).-(e) (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-244.png",
        nextFileName: "./pages/part-a-245.png"
    },
    {
        title: "part-a-244-1",
        gabc: "N(d) ever(e) have(f) I(g) a(g)  (gh) a(g) a(g) my(g) bo-(gh)dy(g) an(gf) earthly(gh)  (fe)  re-(d)me-(cd)dy:(d) but(f) I(fg) have(fe) a(c) Lord(d) a(c) sus(de) Christ,(ffgf) who(f)  by(gh) his(g) word(f) a-(f)lone(fefgf) restoreth(ef)  (g) [(fe) .(d) e(d) things.(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-244.png",
        nextFileName: "./pages/part-a-245.png"
    },
    {
        title: "part-a-244-2",
        gabc: "I(i) give(i) thee(g) .(i) O(j) A(i) Je-(j)sus(kj) Christ:(i) s(i) because(j) ",
        groupIndex: 2,
        filename: "./pages/part-a-244.png",
        nextFileName: "./pages/part-a-245.png"
    },
    {
        title: "part-a-245-0",
        gabc: "thou(i) art(i) mindful(hg)  (i) of(hg) me,(e) and(h) hast(h) sent(h) thine(h) A-(h)pos-(h) tle(h) un-(f)to(h) me(g) to(f) heal(h) my(g) T(e) wounds.(i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-245.png",
        nextFileName: "./pages/part-a-246.png"
    },
    {
        title: "part-a-245-1",
        gabc: "I(gd) bless(fg) thee,TO(g)  (g) Father(g)  (g) of(g) my(h) Lord(ji) Je-(h)sus(i) Christ:(g)  because(g)  (g) by(h) thine(j) A-(i) (hg) postle(g) thou(g) hast(g) &quot;(g) restored(fe)  (d) my(ef)  breast(gf) to(gh) my(h) bosom.(g)  (g) [(j) g(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-245.png",
        nextFileName: "./pages/part-a-246.png"
    },
    {
        title: "part-a-245-2",
        gabc: "O(e) hin(e) who(g) hath(h) deigned(ij)  (i) Tto(i) heal(j) me(i) of(g) all(h) my(h)  wounds,(g) and(h) a(g) restore(h)  (ij) my(i) breast(hg) to(fe) my(fg) hosom;(g)  (g) on(hg~)  him,(i) the(h) living(hj)  (i) God,(hf) do(g) I(f) call.(e) l_II\u2014_I(i) &quot;(j)  (i)  (h) s(gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-245.png",
        nextFileName: "./pages/part-a-246.png"
    },
    {
        title: "part-a-246-0",
        gabc: "he(d) mul(f) titude(h)  (h) of(h) the(h) heathen,(h)  (g) fleeing(hg)  (fh) to(d) the(f) toph(hi)  of(h) the(h) vir-(i) (j) gin,(ih) took(f) thence(hj) her(i) veil(ij) to(i) defend(i)  (hi) they(h)  from(fh) the(hi) fire:(hif) that(d) the(f) Lord(h) might(g) shew(h) himself(g)  (f) a(d)  de~-(gi) (f) liv-(h) (g) er\u2014er(f) from(e) the(fg) Burning,(ed)  (d) for(d) the(f) me(fege) rits(e) of(g)  A(fe) ga-(fg)tha(g) his(fg) blessed(hg) e(e) o(d) Martyr.(d) J(h) 0(i)  (g) 0=(h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-246.png",
        nextFileName: "./pages/part-a-247.png"
    },
    {
        title: "part-a-246-1",
        gabc: "n(f) the(f) likeness(g)  (f) of(g) a(gh) dove(hg) *(h) The(g) soul(g) of(g) Scholasti(f)  (g) ice(g)  (g)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-246.png",
        nextFileName: "./pages/part-a-247.png"
    },
    {
        title: "part-a-247-0",
        gabc: "was(gh) seen(gfd) in(f) a(g) vision.(g)  (f) In(f) the(f) likeness.(g)  (f) The(c)  (ch) heart(hi)  of(h) her(h) brother(fh)  (g) rejoiced.(f)  (fh)  (hg) The(g) soul.(g) \xa5.(c) Glory(h) be(h)  (h)  co(h) the(h) Father(hi)  (h) and(h) to(fgh) the(g) Son,(g) and(g) to(h) the(g) Ho(f) ly(g)  Ghost.(ki~)  (gh) the(f)  (f) likeness.(g)  (f)  N(gi)  (e) .(ef) e(f)  (fe) a8,(h) -(g) (f)  (e) -(h)8(i) o(j) .(ih) -(i) (i) -(j) |1(h)  (i)  (j)  (i)  (hg)  (hihg)  (f)  (f) |(f)  (fi)  (h)  (hf) &amp;]](g)  (f)  (e)  a(c) is(ef) this(f)  (fe) that(h) flieth(i)  (i) as(h) cloud?(j)  (i)  (hg)  (hihg)  (f)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-247.png",
        nextFileName: "./pages/part-a-248.png"
    },
    {
        title: "part-a-247-1",
        gabc: "Let(d) ill(cd) the(d) [](f)  (e) -(dc)[(e) the(f) a(g) ex-(ed) (efe) ult(d) in(d) the(dh)  glory(hi)  (h) e(g) a(g) gracious(gh)  (h) 5(cd)  (d) Scholas-(fgf)ti-(d)l.(c) -(d) (efg) and(dhi) ",
        groupIndex: 1,
        filename: "./pages/part-a-247.png",
        nextFileName: "./pages/part-a-248.png"
    },
    {
        title: "part-a-248-0",
        gabc: "chiefly(h)  (gh) let(h) the(h) com-(hg)pa-(fe).(dc) of(cd) vir-(fgh).(fe) be(fgf) -(d) (d)  c:le\u2014brat.ing(h)  (j)  (ji) her(hg)  (fgh) So-(jk)lem-(jh)ni-(i)ty;(h) for(h) she(hg) besought(fe)  (fgh) the(h)  Lord,(hih) pouring(h)  (g) forth(fe) her(cd) tears,(d) and(c) of(df) him(ffg) received(f)  (gh)  (h)  greater(h) .(g) power,(fe) because(d)  (d) Her(dc) love(e) was(fe) greater.(d)  (d) |(h) )(gf) &amp;g(g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-248.png",
        nextFileName: "./pages/part-a-249.png"
    },
    {
        title: "part-a-248-1",
        gabc: "G(c) o(i) forth(ig) now,(hij) brother,T(i)  (i) go(i) forth(i) if(ghi) thou(hg) canst:(e) bid(h) me(h)  farewell,(fh)  (g) and(f) ](e) .(f) to(f) the(f) mo-(h)nas-(g)-(e)e(e)  (fghh) ||(i)  (j)  (i)  (h) ](gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-248.png",
        nextFileName: "./pages/part-a-249.png"
    },
    {
        title: "part-a-248-2",
        gabc: "A(defhf) Imighty(h)  (hij) God(i) T(e) forgive(fg) thee,(h) my(cdegf) sister:(e)  (ee) what(f) is(fi) this(h)  thou(h) hast(g) ae(ee) done?(hi)  (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-248.png",
        nextFileName: "./pages/part-a-249.png"
    },
    {
        title: "part-a-249-0",
        gabc: "o,(g) I(f)  (h) entreated(j)  (i) thee,T(i) and(h) thou(g) wouldest(i)  (i) not(j) hear(hg)  (f)  me:(ki~)  (f) I(g)  (g) entreated(g)  (f) my(hj) Lord,(i)  (j) and(ggij) he(hi) heard(h) me.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-249.png",
        nextFileName: "./pages/part-a-250.png"
    },
    {
        title: "part-a-249-1",
        gabc: "Nowspeak(ikc)  (j)  (ji) we(hi) Te-(i)ven(hg) until(h)  (i) morning(j)  (h) of(j) heavenly(h)  (i)  (h) things,(g) in(g)  _(ik)  (ij) ly(h) converse(h)  (g) a(g) regarding(hg)  (f) the(d) life(ef) of(gh) the(h) spirit.(g)  (g)  (j) e(hj)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-249.png",
        nextFileName: "./pages/part-a-250.png"
    },
    {
        title: "part-a-249-2",
        gabc: "[(c) fo-(cfe)ly(fg) :(h) Ben_edictT(g)  (g) had(f) ](g) withdrawn(i) himself(h) a(g) in(g) his(h) cell(g)  for(f) three(gh) days,(g) he(g) lifted(g)  (g) up(h) his(j) eyes,(j) and(j) the(j) soul(ih)  of(g) M(ih) o(f) s(fg) e(fh) departing(i) .(h) Ay(g) the(f) bo-(gh)dy(g) in(g) the(h) like-(g) Ness(f) of(f) :(ed) dove,(df) [(f) enter(e) the(f) wm(g) secret(f) o(f) places(fd) of(e) the(d) oo(c) heavens.(c)   (g)  (h)  (g)  (f)  (ed) ",
        groupIndex: 2,
        filename: "./pages/part-a-249.png",
        nextFileName: "./pages/part-a-250.png"
    },
    {
        title: "part-a-250-0",
        gabc: "O(dfgh) how(f)  (gi) illustrious(hg)  (g) Tare(f)  (hj) the(j) merits(j)  (j) of(j) blessed(kj)  (ih) Scho.(g)  lasti-(hf)ca!(ef)  (f) O(ghi)  (fgi) how(i) great(ih) the(gf) power(gh) of(g) her(g) tears!(f)  through(fc) which(f) the(g) \u2014renowned(h)  (h)  (gh) virgin,(ihi)  (h) out(fg) of(f) sunny(f)  (f)  clear(fhihgjj) ness,(j) drew(f) down(ef) from(d) i\xe9e\u2018(dc) air(fgh) a(g) mighty(fi)  (h)  flood(g) of(g) rain.(f) AT(h) IT(f)  (gh) VESPERS(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-250.png",
        nextFileName: "./pages/part-a-251.png"
    },
    {
        title: "part-a-250-1",
        gabc: "o-(f)day(fg) the(g) ho(hj) 1y(ji) virgin(j)  (hg) Scholastica,(f)  (fh)  (h) in(g)  (g) the(g) like-(f) ness(h) of(j) a(j) dove,(jkj) went(j) forth(kji) with(h) all(jj) gladness(j)  (j) to(j) the(j)  heavenly(jk)  (j)  (ji) places:(g)  (g) to-(g)day(gji) she(g) was(h) el(iig) \u201D(hg) worthy(f) *\xb0(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-250.png",
        nextFileName: "./pages/part-a-251.png"
    },
    {
        title: "part-a-251-0",
        gabc: "enjoy(g)  (h) for-(j)ev-(j)er(hih) the(gh) &#39;bliss(j) of(g)  (g) celestial(h)  (fe) life(d) be-(ef) gide(gh) her(h) brother.(g)  (g) ALTERNATE(j)  (i) OFFICE(j)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-251.png",
        nextFileName: "./pages/part-a-252.png"
    },
    {
        title: "part-a-251-1",
        gabc: "T(c) he(e) Lord(ehg) hath(h) giv-(i)en(gh) un-(ij)to(i) me(i) Twings(hkkj) like(i) a(hj) dove,(i)  that(i) I(i) might(h) flee(hj) a-(i)way,(hghih) and(f) be(fh) at(g) rest.(e) T(i)  (j) &quot;(i)  (h) T(gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-251.png",
        nextFileName: "./pages/part-a-252.png"
    },
    {
        title: "part-a-251-2",
        gabc: "A-(e)rise(ehg) quiddy,(hi)  (i) Tmy(i) love,(j) my(ih) fair(i) one,(i) my(i) r(j) that(i) -(h)in(h)  the(f) clefts(h) of(i) the(hg) rock:(e) come,(f) a(e) receive(d) ](e) the(ef) -(fihhj)which(j)  the(i) Lord(j) hath(h) ](i) m(hg)  (f) for(df) N(d) thee(hgih) for(f) ev-(e)er.(e) T(i) -(ji)a1(h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-251.png",
        nextFileName: "./pages/part-a-252.png"
    },
    {
        title: "part-a-252-0",
        gabc: "Th(cd) praise,T(defd) O(d) Virgin(e)  (d) M\xe9-(cd)ry,(d) shall(d) not(e) depart(f)  (gh) from(g) tp,(e)  heart(g) of(fe) men,(d) which(d) remember(dg)  (gh) S(g) the(h) power(hg) of(h) God(j) for(i) .y(h) ever(h)  because(dh)  (hi) thou(hg) hast(f) not(e) spared(fg)  (e) thy(fe) life.(d) ",
        groupIndex: 0,
        filename: "./pages/part-a-252.png",
        nextFileName: "./pages/part-a-253.png"
    },
    {
        title: "part-a-252-1",
        gabc: "Behold,(g)  (ih) how(i) good(g) and(g) joy(dfhgh) ful(f) a(h) thing(jj) it(j) is,(jkjh) breth-(h) ren,(h) to(g) dwell(hgf) together(d)  (eef) P(gh) in(h) u-(g)ni-(g)ty.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-252.png",
        nextFileName: "./pages/part-a-253.png"
    },
    {
        title: "part-a-253-0",
        gabc: " (d)  (f)  (d)  (dc)  (fg)  (f)  (gh)  (hg)  (fg)  (h)  -(g)to(h) thy(fe) servants(d)  (d) health(d) of(c) soul(d) and(f) bo(d) dy.(d) ",
        groupIndex: 0,
        filename: "./pages/part-a-253.png",
        nextFileName: "./pages/part-a-254.png"
    },
    {
        title: "part-a-253-1",
        gabc: "0(f)  (ffe) [(d)  (e) i(g)  (h) Lk(f)  (e)  (g)  (h) [(g)  (hjji)  (g)  i(g)  (f)  (gh)  (h)  (h)  (g)  (hjji)  (gf)  (h)  (h)  (dffe)  :(ed) g(c)  (eg) =(fghf~) 1(gf) Ta(g)  (fe) =(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-253.png",
        nextFileName: "./pages/part-a-254.png"
    },
    {
        title: "part-a-254-0",
        gabc: "e(dc) blessed(f)  (g) Gre-(f)go-(gh)ry,(h) T1ifted(h)  (g) up(h) to(ji) the(h) throne(jk) of(j) pe_(ihgh)  ter,(h) shewed(g)  (f) forth(g) i(h) deeds(g) .(fe) (](dc) of(d) the(e) Watchful\u2019,(fe)  (d)  a(h)  (g)  (f)  (gh)  (gf)  he(j) .(j) excellent(i) [(g) shepherd(ij)  (h) left(h) a(g) behind(h) him(g) an(fe) example(d)  (e)  (f)  and(g) L(fge) pattern(g) of(g) priestly(gh)  (g) life.(e) I(j)  (h)  (j)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-254.png",
        nextFileName: "./pages/part-a-255.png"
    },
    {
        title: "part-a-254-1",
        gabc: "](e) he(g) revealed(h)  (ij)  (i) fthe(h) mysteries(h)  (h) [](g) of(f) Ho~ly(i)  (h) Writ,(hg) there(h)  appeared(ig)  (ij) )(i) a(h) dove,(hg) whiter(f)  (fe) than(fgf) snow.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-254.png",
        nextFileName: "./pages/part-a-255.png"
    },
    {
        title: "part-a-254-2",
        gabc: "O(e) ye(g) servants(ef)  (f) of(g) the(h) Lord,(i) bless(gh) e(ij) the(j) Lord:(i) yoUr(i) ",
        groupIndex: 2,
        filename: "./pages/part-a-254.png",
        nextFileName: "./pages/part-a-255.png"
    },
    {
        title: "part-a-255-0",
        gabc: "gervant(g)  (i) Gre-(hg)go-(e)ry(ef) hath(df) \u2018risen(h)  (f) to(g) the(f) heavens.(e)  (e) I(i)  (j) [](i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-255.png",
        nextFileName: "./pages/part-a-256.png"
    },
    {
        title: "part-a-255-1",
        gabc: "re-(dhi) (h) go\u2014ry,T(h) mirror(h)  (g) of(h) the(gf) cloistered,(g)  (f)  (f) fathc;r(d)  (c) of(d) the(fg)  Ci(fe) ty,(e) .(g) beloved(gh)  (f) of(e) all(c) the(ef) world.(d) e(h)  (g) _(f) p(gf) d(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-255.png",
        nextFileName: "./pages/part-a-256.png"
    },
    {
        title: "part-a-255-2",
        gabc: "\u2014\u2014(f) go-(ff)ry,(def) when(c) he(d) looked(ffg)  (f) up-(f)on(g) the(h) youthful(ih)  (g) Angles,(f)  (e)  2(ik) said:(ghggf) They(f) have(h) the(i) countenance(j)  (ih)  (g) of(f) An-(ghg)gels,(f) &lt;(c)  such(d) as(f) these(f) should(g) a(fe) of(f) the(g) fellowship(f)  (gi)  (ih) of(g) the(g)  An-(gf)gels(g) in(ghg) heaven.(f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-255.png",
        nextFileName: "./pages/part-a-256.png"
    },
    {
        title: "part-a-256-0",
        gabc: ".(cd) Ja(dhi)  (h) i(h) Jo-(hj) (h) seph,(hghihgg) the(g) husband(f)  (g) of(h) Ma(fe) 1y,(d) of(eg)  whom(gh) was(g) born(fg) Je-(d)sus,(d)  (ef) who(e) is(f) a(g) calledfChriat.(fe)  (d) P.T.(f)  rist,(dc) al(d) le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-256.png",
        nextFileName: "./pages/part-a-257.png"
    },
    {
        title: "part-a-256-1",
        gabc: "The(gi)  (fc) An-(fe)gel(fh) Ga-(gf)bri-(e)el(f) 1\u2018was(fe) sent(h) from(ji) God(j) to(j) a(i) virgin(kjk)  (j)  O(ig~) .(i) espoused(hg) e(h) to(i) a(g) man(ij) whose(h) name(i) was(hg) Joseph,(f)  (fi) of(h) the(h)  house(hg~)  (hg) of(fg) De-(f)vid:(e) a(c) the(e) virgin\u2019s(f)  (ef) name(hg) e(e) 1y:(gg)  (f)  Y(gi)  (gg) ry,(f) al-(e)le-(ef)lu-(f)ia.(f) N(h) &amp;(g)  (e) =(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-256.png",
        nextFileName: "./pages/part-a-257.png"
    },
    {
        title: "part-a-257-0",
        gabc: "=(de) Ma-(ghj)ry(hg) the(h) mother(j)  (ji) of(j) Je-(k)was(k)  (j) espoused(ji) to(h)  (i)  Joseph,(h)  (g) before(g)  (g) they(i) came(g) together,(h)  (fe)  (d) she(g) was(h) found(j)  with(g)  (ig) child(hg) of(e) the(f) Ho(ghgf) IyTGhost.(gf)  (e) P.T.TGhost,(ef) al(g)  le-(gf)lu-(e)ia.(e) =(ji)  (hi) \u2014(h) &amp;(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-257.png",
        nextFileName: "./pages/part-a-258.png"
    },
    {
        title: "part-a-257-1",
        gabc: "Jo\u2014seph(f)  (def)  (dc) [(de) ](e) being(gh)  (h) a(g) just(hi) man,(h) and(g) not(gh) will-(g) ing(f) to(g) make(gh) her(g) &quot;(f) public(g)  (f) .(e) am-(ef)ple,(d) was(e) minded(f)  (d) to(dc)  put(f) her(e) a-(f)way(ghg) Tpri-(fe)vi\u2014ly.(de)  (e) vi\u2014(fe)  (de) -(ef)al(g) le-(gf) lu-(e)ia,(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-257.png",
        nextFileName: "./pages/part-a-258.png"
    },
    {
        title: "part-a-258-0",
        gabc: "I(f) called(g)  (f) up-(f)on(g) the(gh) Lord,*(hg) The(gh) Father(g)  (fd) of(fg) my(g) Lorg;(f)  I(f)  (g) X.(f)  (c) That(h) he(hi) would(h) not(h) leave(fh) me(g) in(g) the(g) days(h)  of(g) my(f) trouble.(h)  (hg) The(gh) Father.(g)  (fd) X.Glory(h) be(h)  (h) to(h) the(h) Fa(hi)  ther(h) and(h) to(gh) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)1y(g) fhost.(h) B}(.I(f) called,(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-258.png",
        nextFileName: "./pages/part-a-259.png"
    },
    {
        title: "part-a-258-1",
        gabc: "0(f) called(f)  (f) up-(f)on(f) =(f) Lord,(g) the(f) Father(f) 2(e) of(g) my(g) Lord,(h) Al(h) le-(hg) lu-(g)ia,(f) al(d) le-(fg)1u(gf) ia.(f) I(f) called.(f)  (f) That(f) he(f) would(f) not(f)  leave(ik)  (g) me(f) in(f) the(f) days(f) of(f) my(e) trouble.(g)  (h) Al(h) le-(hg)lu-(g)ia.(f)  V.(i) Glory(f)  (f) be(f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g)  Ho-(ik) (h) ly(g) Ghost.(gf) I(f) called.(f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-258.png",
        nextFileName: "./pages/part-a-259.png"
    },
    {
        title: "part-b-000-0",
        gabc: "a(e) parents(eh)  (f) Ef(ed) Je-(ef)(B(e) susj&#39;went(gh) to(i) Je-(f) (h) ru_Sa_]em(h)  (g) s(hi)  (h)  year(hghih) at(f) the(e) feast(f) of(h)  (g) theTPsssover.(e)  (e)  (e) m(ce) 1](e)  (ef)  al-(g)le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-000.png",
        nextFileName: "./pages/part-b-001.png"
    },
    {
        title: "part-b-000-1",
        gabc: "As(hig~)  (f) they(e) returned,f(c)  (ef)  (fe) the(f) Child(gh) Je-(i)sus(gf) tarri-(gh)ed(g)  (f) hehind(e)  (fh)  in(gi)  (i) Je-(h)ru-(ij)sa-(ih)lem;(h) and(hj) Jo-(h)seph(g) and(f) his(g) mother(ff)  (e) knev(gh)  ;(hgi) not(i) of(hg) fit.(f) it,(cfec) al-(e)le-(ef)lu-(f)ia.(f) |(h) m\u2014(g)  (e) |(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-000.png",
        nextFileName: "./pages/part-b-001.png"
    },
    {
        title: "part-b-000-2",
        gabc: "a8(j)  &#39;nd(dde) when(g) they(h) found(g) him(hj) not,(j) they(hj) turned(k)  (j) back(k) a8(k)  to(j) 7(jifdfd~hfh) sa-(gffd)lem,(hjdf)  (ff) seeking(kff) -(ji)him:(hg) and(g) after(h)  (g)  (hj) |(j) ",
        groupIndex: 2,
        filename: "./pages/part-b-000.png",
        nextFileName: "./pages/part-b-001.png"
    },
    {
        title: "part-b-001-0",
        gabc: "they(ki~)  (ij) found(k) him(ji) 1n(h) the(g) a(e) temple,(gf)  (g) sitting(hj)  (h) in(g) the(f) midst(ghg)  of(i)  (g) the(f) doctors,(de)  (e) both(ef) hearing(e)  (d) them,(gh) and(fg) asking(g)  (h) them(gf) |(e)  fquestions.(i)  (e)  (e) &#39;fquestions,(e)  (ef) al-(g)le(gf) lu-(e)ia.(e)  (ji)  (hi)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-b-001.png",
        nextFileName: "./pages/part-b-002.png"
    },
    {
        title: "part-b-001-1",
        gabc: "His(ik)  (c)  (c)  (e) mother(f)  (d) said(cd) un-(fe)to(de) him,(e)  (eh) why(h) hast(g) thou(hj) thus(hgf)  dealt(ik)  (gh) with(gf) us?(ef) behold,(dh)  (h) thy(g) ](g) and(dc)  (de) I(e) have(f) sought(edfd)  _(ki~) g(ef) thee&#39;fsorrowing.(fgh)  (g) w(e) P.T{-(gh)Tsorrowing,(g)  (ef) &quot;(g) le-(gf)lu-(e)is.(e) w1(h)  (g) e(h) st(ih) Tea](gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-001.png",
        nextFileName: "./pages/part-b-002.png"
    },
    {
        title: "part-b-001-2",
        gabc: "]e-(gf)sus(d)  (ef) down(gh) with(h) -(g).a\uFB01d(g) came(f) to(h)  (j)  (j)  (jijkj)  and(j) was(h) [(jh) i(ih) E\u2014\u2014\u2014(g)  (fg) e(gd) |(dfff)  (ef) T(fgfd) T(fe)  (fg) R(g)  (g)  .(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-001.png",
        nextFileName: "./pages/part-b-002.png"
    },
    {
        title: "part-b-002-0",
        gabc: "He(c)  (f) made(gh) im(hg) Lord(gfd) of(f) h1(g) house.(gf) H(f) made(gh)  ru-(hi)ler(h) of(g) all(g) his(f) substance.(gh)  (hg) Lord(gfd) of(f) hic(g)  Glory(h)  (h) be.(h) B.(h) e(f) made(gh) him.(hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-002.png",
        nextFileName: "./pages/part-b-003.png"
    },
    {
        title: "part-b-002-1",
        gabc: "He(f) nade(g) him(f) Lord(f) of(e) his(g) house,(h) *(h) le(hg) a(g) ia,(f) al-(d)fe.(fg)  lu-(gf)ia.(f) He(f) made(g) him.(f) And(f) ruler(g)  (f) of(f) all(f) :(e) sub-(g) stance.(h) TR(h) Al-(hg)lu-(g)ia.(f) |(c) A(f)  (f) be.(f) He(f) made(g) hin.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-002.png",
        nextFileName: "./pages/part-b-003.png"
    },
    {
        title: "part-b-002-2",
        gabc: "A(defd)  (dc) :(cd)  (d) o(f)  (e) s(d)  (e)  (e) p\u2014\u2014(d) 41\u2014(dfhi)  (h)  (h)  |(ik) ~(hg) I-(dgh) (f) 4(gh) _-(gd) (fg)  (d) 8(gfe) -(d) (dg) -(fe) (dc)  (dd) v(c)  e(f)  (fe)  (f)  (fddfg) :(dfefdffddcdfdhdhfhfdef)  (dd) L(dedf)  (dhdfdfddefdf) B(dcf) e(cd)  (d) \u2018(d) ",
        groupIndex: 2,
        filename: "./pages/part-b-002.png",
        nextFileName: "./pages/part-b-003.png"
    },
    {
        title: "part-b-003-0",
        gabc: "J\u2018;-(c) (ei) sus(gh) himself(ij)  (i) began(i)  (j) to(i) be(hi) a-(h)bout(hf) thirty(g)  (h) years(ij)  of(i) age,(i) being,(e)  (e) as(f) was(e) supposed,(d)  (ef)  (f) the(fi) son(h) ofT(fg)  (c) oseph.(fe)  (e)  Joseph,(fe)  (f) al-(g)le-(fg)lu-(e)I(i) e(j)  (i)  (h)  (gi) ",
        groupIndex: 0,
        filename: "./pages/part-b-003.png",
        nextFileName: "./pages/part-b-004.png"
    },
    {
        title: "part-b-003-1",
        gabc: "e(c)  (g) Behold(g) a(h) faithful(j)  (j) and(j) wise(hj) servant,(j)  (i) whom(g) his(h) Lord(h)  hath(h) made(h) ru-(ih)ler(g) o-(h)ver(f) e(gf)  (c) o(e) o(e) P.T.}(c) house-(e) =(ef) a1-(g)S(gf) i(e) v(e) e(ddj) i(dh)  (djd) U(dih) 50(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-003.png",
        nextFileName: "./pages/part-b-004.png"
    },
    {
        title: "part-b-004-0",
        gabc: "Ho-(c) (cf) ly(f) Father(g)  (f) Ben-(g)e-(gh)dict,(hg) *(f) Intercede(gh)  (gfd) for(fg)  Father(g)  (f) Ben\u2014e\u2014dict..(gh)  (hg) That(h) we(hi) may(h) be(h) made(h) worthy(gh)  of(g) the(g) promises(h)  (g)  (f) of(gh) Christ.(hg) \xa7.(f) Intercede(gh)  (gfd) for(fg) y,(gf)  R(c) Glory(h)  (h) be.(h) Ho-(f)ly(f) Father(g) e(f) Ben-(g)e-(gh)dict.(hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-004.png",
        nextFileName: "./pages/part-b-005.png"
    },
    {
        title: "part-b-004-1",
        gabc: "Hl\xb0&#39;1Y(c)  (cf)  (f) Father(f)  (f) Ben;eadict,(g)  (f)  (f) :(f)  (e) intercede(g) for(g) .(h) *Al-(h)e-(hg) lu-(g)ia,(f) al(d) le-(fg)lu-(fg)ja.(f) Ho-(f)ly(f) e(f) :(f) Ben-(g)e-(f)dict(f) cic(f)  \u2018We(ff) may(f) be(f) made(f) worthy(g)  (f) of(f) the(f) a(f)  (e)  (g) ot(g) \u2018ot(h) ",
        groupIndex: 1,
        filename: "./pages/part-b-004.png",
        nextFileName: "./pages/part-b-005.png"
    },
    {
        title: "part-b-005-0",
        gabc: "R(dc) S(cd)  (d) Mo(d) T(f)  (e) N(d) P(e)  (e) 1](d)  (idhi)  (h)  [(h)  (hg)  (gh)  (f)  (gh)  (g)  (fg)  (gfe)  (d)  (dg)  (fe)  (dc)  y(dd) =(c) loved(fe)  (fg) him(fe) and(dc) adorned(de)  (e) him.(defd) W(dc) o(cd)  (d) |(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-005.png",
        nextFileName: "./pages/part-b-006.png"
    },
    {
        title: "part-b-005-1",
        gabc: "T(c) et(d) hil(dc) the(d)  (f) multitdde(e)  (dc) of(e) the(f) faithful(g)  (ed) ex-(efe)ult(d) in(d) the(dh)  glory(hi)  (h) of(g) the(g) gracious(gh)  (h) Father(cd)  (d) Ben(fgf) le(dc) dict:(d) and(dhi) chief-(h) ly(gh) let(h) the(h)  (hg)  (fe) of(dc)  (cd) monks(fgh)  (fe) joyful,(fgf)  (d) ce-(h)le-(j) brating(ji)  (hg) his(gh) fes-(jk)ti-(ih)val(j) on(ij) earth,(h) in(h) whose(hg) goodly(fe)  (fg) fel-(e) a(efe) T(dc) the(cd) Saints(d) rejoice(fe)  (fgf) nTheaven.(ed)  (ef)  (d) p.T.T(c) L(e) &amp;(dc)  ol-(d)le-(efe)Ju-(d)jq.(d)  (h)  (g)  (f)  (g)  (dfgfed) ",
        groupIndex: 1,
        filename: "./pages/part-b-005.png",
        nextFileName: "./pages/part-b-006.png"
    },
    {
        title: "part-b-006-0",
        gabc: "Th\xe9re(g) was(h) a(g) man(ji) of(h) ve-(ij)ne-(h)ra-(g)ble(fg) life,&quot;l&#39;(g) Be-(jk)ne-(j)dict(ji)  grace(ik)  (hg) and(e) by(fg) name,(g) who,(h) from(f) his(h) younger(k)  (j) years,(j) car.(j)  ri-(i)ed(hg) T(h) always(g) the(h) mind(ji) of(h) an(g) old(fg) man;(g) o-(j) (i) verpassing(jk)  (k)  age(kj) by(jk) virtue,(ji)  (hj) he(ji) de-(g)ni-(hg)ed(f) himself(f)  (hg) all(gji) vainT(hg) de-(fg) lights.(g) P.T.fdelights,(fg)  (gh) al-(i)le-(h)lu-(g)ia.(g) E\u2014(j)  (i) ](j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-006.png",
        nextFileName: "./pages/part-b-007.png"
    },
    {
        title: "part-b-006-1",
        gabc: "he(e) b]egsed(f)  (e) man(d) Be-(g)ne-(hj)dict(j) de-(h)sir-(j)ed(i) rather(h)  (g) the(g) mi-(hi) \u2018se-(h)ries(dgh) :(dg)  (d) .(dffdffdfdghg) world(fd~)  be(df) weari-(dhd~fhfddffiffjf)with(hfchgdfcdhfddfhdfhdhghdfdfdffdfdfddf) .(f)  (f) a(de) sake,(ddd) .(cf) to(d) be(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-006.png",
        nextFileName: "./pages/part-b-007.png"
    },
    {
        title: "part-b-007-0",
        gabc: "ex-(fg)alt-(h)ed(g) with(g) tran-(ghj)si-(g) (gh) to-(gf) (e) ryffavour.(e) Tfavour,(e)  (def)  al\u2014]e-(g) (gf) ll.l-(e)ia.(e) i(j) \u2018(i)  (hi) i(h) i(fh) ",
        groupIndex: 0,
        filename: "./pages/part-b-007.png",
        nextFileName: "./pages/part-b-008.png"
    },
    {
        title: "part-b-007-1",
        gabc: "he(j) glorious(j)  (g) T(i) confessor(k)  (j) of(jk) the(j) Lord,(j) leading(ji)  (h) the(ij)  life(h) an-(g)ge-(h)lic(g) on(e) the(fg) earth,(g) was(g) made(g) a-(g) (h) mirror(g) of(h)  good(jk) works(ji) un-(g)to(hg) all(fd) the(f) world;(g) and(g) therefore(hj)  (j) with(j)  Christ(ji) he(h) rejoices(j)  (ih) R(g) |(fe) er-(d)more(ef) in(gh)  (h) theTheavens.(g) e(g)  a(g) Theavens,(gfd) -(fe)le-(fg)lu-(g)ia.(g)  (j)  (h)  (j)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-b-007.png",
        nextFileName: "./pages/part-b-008.png"
    },
    {
        title: "part-b-007-2",
        gabc: "B(c)  (d) e-(ef)dict(g) Tthe(g) man(gf) of(d) the(ef) Lord,(e) gentle(f)  (d) of(ef) a(g) a(g)  Nance,(g) was(g) 9(g) adorned(g) @(g) with(f) e(gh) angelic(h)  (gh) TN(e) wEETTE](d) so(dh) great(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-007.png",
        nextFileName: "./pages/part-b-008.png"
    },
    {
        title: "part-b-008-0",
        gabc: "a(h) brightness(i)  (h) shone(h) forth(h) round(g) a-(f)bout(gf) him,(e) that,(h)  although(ki~)  (h)  (g) yet(f) up-(g)on(fe) the(d) earth,(ed) he(d) might(e) be(f) -(h) :(g) among(g) =(f) celesti.al\uFB01I=(h)  (gf) beings.(e)  (e) beings,(c)  (e)  (f) dl-(g) (gf) lu-(e)ia,(e)   (h)  (g)  (h)  (ji)  (hg)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-008.png",
        nextFileName: "./pages/part-b-009.png"
    },
    {
        title: "part-b-008-1",
        gabc: "o(d)  (dc) de(f) the(g) man(f) ot(gh) God.(h) waa(h) filled(hj)  (h) with(h) the(h) apis(h)  rit(g) of(ef) all(g) the(fe) TS(d) righteous:(d) e(f) he(fe) SN(c) intercede(df)  (ffg) for(f) the(fe)  a(ik)  (cdc) L}(c) conventu-(eg) (e) alf(f)  (e) profession.(d)  (d) profession,(e)  (d)  (dc) al-(d) le-(efe)lu=-(d)1ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-008.png",
        nextFileName: "./pages/part-b-009.png"
    },
    {
        title: "part-b-009-0",
        gabc: "Be_ne\u2014dicc,(d) thou(e) father(g)  (gh) and(dfg) guide(g) o(f) monks,(e) thou(g) most(g)  Be_ne\u2014dicc,(f)  1y(h) Confessor(h)  (gg) of(g) the(ghg) Lord,(e) intercede(f)  (d)  (ggh) for(g) us(d) all(g)  hoe=-(ghj) and(g) for(gf) ourTsal-(g) (ghg) vation.(e)  (e) P.T.(eh) *salvation,(ghg)  (e) &quot;(ef) al-(g)le-(gf)ia.(e)  -(ik) (h)  (g)  (h)  (ih)  (gfe) AT(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-009.png",
        nextFileName: "./pages/part-b-010.png"
    },
    {
        title: "part-b-009-1",
        gabc: "To\u2014day(eh) il(hgf)  (g) ho-(ef)ly(f) Be-(fg)ne-(f)dict,(f) while(fg) his(f)  (e) disciples(f)  (h) beheld(fg)  (f)  N(hgi) it,(e) =(f) ascended(fc) ;(f)  (f) way(f) of(f) the(f) L(fg) on(f) a(f) straight(f) path-(fh)L(f)  %ay(hig~)  (f) to(f) hea-(gh)ven:(jkijijkj) to\u2014day(f)  (fj) with(j) hands(j) uplifted(j)  (ij)  (i) he(i) di-(ij)ed(i)  b(hgi)  (i) etween(i) the(i) r(i) of(h) his(f) =(h) supplica(h) -(fghgfef)(T(fe) T(e) e(ehg)  (hg)  |(gi) Y88(f)  (gf) received(ef) _:___l-(f)in-(e)to(f) -(h) (g) by(g) the(g) -(eg) (f)  (f) \u2014l(h)  (gf)  (hg)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-009.png",
        nextFileName: "./pages/part-b-010.png"
    },
    {
        title: "part-b-010-0",
        gabc: "while(hgi)  (eh)  (hg)  (fg)  (ef)  (f)  (fg) his(f) disciples(f)  (h) beheld(fg)  (f) it,(e) N(f)  ;:ende.cl(ig~)  (cf)  (f) by(f) way(f) of(f) the(f) Fast(fg) on(f) a-(f)straight(fh) pathway(f)  (f) 0(f) }E_(h)  ven:(hig~)  (ijijkj) and(jf~) with(j) hands(j) uplifted,(j)  (j)  (i) he(i) di-(ij)ed(i) between(i)  (i) the(i)  words(hgi)  (i) of(h) his(f) supplica(h)  (h) -(fhgfef)tion,(fe) and(ehg) was(f) received(gf)  (ef)  (f) ip-(e) to(hgi)  (f) glory(h)  (g) by(g) the(g) Angels,(eg)  (f) al-(g)le-(hg)lu-(f)ia.(f) E}(h) w1(gf)  (hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-010.png",
        nextFileName: "./pages/part-b-011.png"
    },
    {
        title: "part-b-010-1",
        gabc: "e(f) smoke(f) of(f) the(f) incense(g)  (f) ascended(f)  (g)  (gh) up(hg) before(fd)  (fg) God:(dgf)  The(f) \u2018smoke.(f)  (f) Out(c)  (i)  (hi) of(g) the(f) Angel&#39;s(g)  (gh) hand.(hg) Before(fd)  (fg) ",
        groupIndex: 1,
        filename: "./pages/part-b-010.png",
        nextFileName: "./pages/part-b-011.png"
    },
    {
        title: "part-b-011-0",
        gabc: "7.(c) Glory(fh)  (h) be.(h) The(f) smoke.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-011.png",
        nextFileName: "./pages/part-b-012.png"
    },
    {
        title: "part-b-011-1",
        gabc: "he(f) smoke(f) of(f) the(f) incense(g)  (f) ascended(f)  (f)  (f) up(f) before(e)  (g) God,*(h)  Al-(ik) (h) le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu(gf) ia.(f) The(f) smoke.(f) T(c) Out(f) of(f) the(e)  Angel\u2019(g)  (g) s(h) Al-(h)le(hg) lu-(g)ia.(f) Glory(f)  (f) be.(f) The(f)  smoke.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-011.png",
        nextFileName: "./pages/part-b-012.png"
    },
    {
        title: "part-b-011-2",
        gabc: "[(i)  (h) ](g)  (h) i;(dgfef) [(dc) \xbb(g) a(g) |(f) [(g) :(h) =(h) !(h)  (j)  (k)  :(jih) o~(h) b(i)  (g) =ty(f)  (g) s(h) |(h)  (h) [(h)  (g) e(h) I(dgfef) .(dc)  (g)  0(g) z(g) Angel(f) e(gh)  (hgf) Rl(f) (v(ef) (e(fghg) T(e) L)(fe) G(d)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-b-011.png",
        nextFileName: "./pages/part-b-012.png"
    },
    {
        title: "part-b-012-0",
        gabc: "he(e) Angel(ei)  (i) Ge-(hg)bri-(hi)el(i) Tcame(i) in(jk) un-(j)to(i) Ma(hgf) ry(g) and(fgf) gajq(e)  Hail,(ei) thou(i) that(h) full(h) of(hi) grace,(i) the(i) Lord(j) is(k) =(ij)  thee;(i) blessed(j)  (j) art(hi) thou(hh) @(fe) &quot;(fgf) s(e) 8-(e)g(e)  (e)  al-(fg)le(f) -(e)ia.(e)  (i)  (j)  (i)  (h)  (gi) ",
        groupIndex: 0,
        filename: "./pages/part-b-012.png",
        nextFileName: "./pages/part-b-013.png"
    },
    {
        title: "part-b-012-1",
        gabc: "hen(e) Za\u2014cha-(eh)ri-(f)as(f)  (e) twent(f) in-(ed)to(f) the(dhg) temple,(e)  (e) there(e) ap-(e) 0(ig~)  (jg~hi) peared(i) SR(j) to(ih) him(h) the(h) Angel(h)  (gf) Gabriel,(gh)  (g) T(e) o)(i) P(g) |(fe) T(fg) -(f) right(gh) side(hj) of(i) .(j) e(hf) =(hi) o(hg) offincense.(e) el(e) |(fhi) P.T.Tincense,(e) a5(ef)  al(g) -(f)&quot;(e) o(e) -(h) (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-012.png",
        nextFileName: "./pages/part-b-013.png"
    },
    {
        title: "part-b-013-0",
        gabc: "ut(d) the(f) L}(dc)  (f) said(g) un-(f)to(gh) him,(h) Fear(hj) not,(h) Za-(g)cha-(f) ri-(gh)as,(g) for(g) thy(ef) prayer(gh) isfheard.(fe)  (d) heard,(dc) al(d)  le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-013.png",
        nextFileName: "./pages/part-b-014.png"
    },
    {
        title: "part-b-013-1",
        gabc: "[(ff) dm(dc) the(f) An\u2014gel(g)  (fg) Ga-(h)bri-(gf)el,T(f) that(f) stand(gi) in(i) the(h)  |(ik) presence(g)  (i) of(h) God;(hgf) and(g) e(h) sent(f) L(dc) -(dg)S(gh)  (g) ||(f)  fthee,(fe) al(g) ~le(gh) -(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-013.png",
        nextFileName: "./pages/part-b-014.png"
    },
    {
        title: "part-b-013-2",
        gabc: "L](e) An-(ei)gel(i) Ge-(hg)bri-(hi)el(i) e(jk) un-(j)caenesseessesalice.(i) Ma(hgf) .(g) e(e) A(e)  a(e) Behold,(ei) thou(i) shalt(h) a(g) conceive(h) in(h) &quot;(hij) womb,(i) and(i) bring(jk) ",
        groupIndex: 2,
        filename: "./pages/part-b-013.png",
        nextFileName: "./pages/part-b-014.png"
    },
    {
        title: "part-b-014-0",
        gabc: "forth(ig~)  (j) a(ij) Son,(jih) an_d(h) shalt(f) call(hg) his(fe) Nape(fgf)  (e) =(e)  al(gi)  (e)  (e)  (fg) =le-(f)1lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gi) ",
        groupIndex: 0,
        filename: "./pages/part-b-014.png",
        nextFileName: "./pages/part-b-015.png"
    },
    {
        title: "part-b-014-1",
        gabc: "hen(j) said(hg) Ma-(hj)ry(j) Tun-(j)to(h) the(ih) An-(g)gel,(g) How(hg) shall(ef) this(gf) be,(df)  seeing(f) )(e) I(d) 8(ef) =(h) a(g) 53(e) And(d) the(d) An-(hd)gel(h) Ga-(h)bri-(g)el(h)  answered(ik)  (j)  (i) a(g) and(g) said(ij) un-(i)to(h) her,(h) The(h) Ho-(hk)ly(j) Ghost(j) shall(hf)  come(gh) up-(g)\uFB01(ec) thee,(de) a(e) &quot;(e) :(f) .(d) e(e) .(f) .(fh) -(g)e(h)  -(ik) (g)  (f) s(g) i(ghg) e(e) e(df) a0(g)  (gf) S(e)  (e) \u2014(j)  (h)  (j)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-b-014.png",
        nextFileName: "./pages/part-b-015.png"
    },
    {
        title: "part-b-014-2",
        gabc: "5(f) presence(fdfdgfdfdf) \u2014\u2014(fdf)  (cddcf)  (ddfgh) I(ddfdhg)  (dfdddcfg) P(f) .&quot;2:11:.1(fc) sing(g) p!(fgh) raise\xe9(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-014.png",
        nextFileName: "./pages/part-b-015.png"
    },
    {
        title: "part-b-015-0",
        gabc: "un(g) to(fd) thee,(fg) O(g) my(f) God.(f) 1In(f) the(f)  (g) presence.(f) I(c)  (h) will(h)  worship(hi)  (h) toward(h)  (h) thy(h) ho(h) 1ly(h) temple,(gh)  (g) and(g) praise(f) thy(gh) Name.(hg)  will(g)  (f) sing.(g) Glory(h)  (h) be.(h) In(f) the(f) presence.(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-015.png",
        nextFileName: "./pages/part-b-016.png"
    },
    {
        title: "part-b-015-1",
        gabc: "In(cf) e(f) presence(f)  (f) of(f) the(f) Angels(g)  (f) I(f) will(f) sing(f) preise(g)  un-(f)to(f) thee,(f) ](e) my(g) God,(h) Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f)  In(f) the(f)  (f) presence.(f) V.(c) I(f) will(f) worship(f)  (f) toward(f) thy(f) ho-(f)ly(f)  temple,(g)  (f) a(e) praise(g) thy(g) Name.(h) Al-(h)le(hg) lu-(g)ia.(f)  Glory(f)  (f) he,(f) In(f) the(f) presence.(f)  (f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-015.png",
        nextFileName: "./pages/part-b-016.png"
    },
    {
        title: "part-b-016-0",
        gabc: "g(d)  (fh)  (h)  (i) LI(dhg)  (h)  (i) g\uFB01-(jh) (k)  (i)  (j)  (h)  (ih)  %\u2014(gf)  (e)  (f)  (d)  (d)  (e) (](d)  (gf)  (e)  (f) |(h)  An(f)  (h) Angel(f) stood(g) at(fed) L(c) of(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-016.png",
        nextFileName: "./pages/part-b-017.png"
    },
    {
        title: "part-b-016-1",
        gabc: "T(c)  (c) he(e) An-(g)gel(h) Ga-(i)bri-(j)el(i) W(j) Y(hi) R(i) to(g) Za-(i)A(h) e(hh) as,(e) and(f)  said(hf) vmn(g) to(f) him:(e) Thy(f) wife(ed) shall(ef) bear(fi) thee(h) a(ij) son,(i) and(j)  thou(dhg) shalt(f) call(ghi) his(h) name(k) John;(ji) and(e) ma\u2014ny(ef)  (d) shall(f) re-(i) joice(hi) at(j) his(ih) birth;(ikjk)  (i) for(j) he(i) shall(h) ](g) before(h)  (i) the(h) face(ij)  of(fgji) the(hi) :(i) G(dfhgfi) &gt;(hgf) pare(g) his(fgf) Tways.(e) |-(e) al(fg) le(f) -(d)lu(e) ia.(e)  (hh)  (if)  (ddjd)  (di)  (d)  (dh)  (d)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-016.png",
        nextFileName: "./pages/part-b-017.png"
    },
    {
        title: "part-b-017-0",
        gabc: "The(c)  (cd)  (df)  (d) Gabriel(ed)  (c)  (d)  (f) Tsaid(g) un-(fe)to(c) Ma-(ef)ry:(d) With(fg) God(hgg)  nothing(ik)  (h)  (g) shall(f) be(g) impossi-(e) (gh) ble.(fe)  (d) And(dhh) Ma(hj) ry(h) said,(h) Be-(f) hold(ki~)  (h) the(gf) handmaid(g)  (fe) of(d) [(c) Lord:(df) be(f) it(de) un-(d)[](c) -(df)ac-(e) cording(ki~)  (f)  (g) to(h) thy(gf) word.(ffgf) And(fh) the(gf) Angel(g)  (d) c\uFB02aparted(ef)  (g)  (fe) from(d)  Ther.(de) \u2018Ther,(dc) al(d) le-(efe)lu-(d)ia.(d) SN(h) o(g) sl(f)  (g) el(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-017.png",
        nextFileName: "./pages/part-b-018.png"
    },
    {
        title: "part-b-018-0",
        gabc: "T(c) he(cgd) Ho-(f)1y(gh) Ghost(g) shall(g) come(g) up=-(h)on(g) thee,(f) Ma-(gh)ry.(h) S(f)  the(h) power(jji) of(h) the(hi) Highest(hg)  (g) shall(g) \u2014(gf) o\u2014ver-(d) (f) s}xa\u2014doth},ee_(fg)  (c)  (g)  al-(g) (ih) le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-018.png",
        nextFileName: "./pages/part-b-019.png"
    },
    {
        title: "part-b-018-1",
        gabc: "The(cc)  (ch) An\u2014gelT(fg)  (gh) Ga-(f)bri-(g)el(i)  (hi) was(hf) sent(h) to(j) Ma-(i)ry,(j) &amp;(h) Virgin(j) -(ij)es-(h) oo(gf) poused(fgh) to(i) =(h) Joseph.(g) Al(ef) -(fg)le-(g)lu~ia.(g) |(hf) e(j)  (i) e(j)  (h) )(gh)  Ma-(cd) (idhi) ry,(h) T(j) thou(h) that(g) art(f) full(g) of(gh) grace,(h) the(f) Lord(h)  is(gf) with(g) thee:(d)  (fh) blessed(g)  (h) art(g) thou(dfe) 7](f)  (dfgf) =(c)  (d)  (d)  women,(dc)  (ef) al-(g)|(defe) lu-(d)ia.(d) |(dfhfghi) .(h)  (g)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-018.png",
        nextFileName: "./pages/part-b-019.png"
    },
    {
        title: "part-b-019-0",
        gabc: "Fear(c)  (gj) not,(hgf) Me-(gh)ry,(gh) for+thou(f)  (g) hast(g) found(cdgh) fa(ijkji) vour(gh) with(i)  the(h) Lord:(g) behold,(g)  (h) thou(ge) shalt(f) conceive,(gh)  (fed) and(d) bring(ef)  forth(gh) afSon.(h)  (g) Wy(gfd) al-(f)le-(fg)lu-(g)ia.(g) e(j) e(i) e(j)  (h) o(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-019.png",
        nextFileName: "./pages/part-b-020.png"
    },
    {
        title: "part-b-019-1",
        gabc: "The(c)  (c)  (d) Lord(d)  (cd) give(fg) un-(f)to(gh) him(h) the(h) throne(ih) of(g) his(f) fa-(gh) ther(fe) We(dfe) vid,(dc) .(dc) he(f) shall(ef) reign(g) |(fe) orfev-(d)er.(d) phe\u2014\u2014(d)  Er,(cd) al(d) -(efe)lu-(d)ia.(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-019.png",
        nextFileName: "./pages/part-b-020.png"
    },
    {
        title: "part-b-019-2",
        gabc: "the(c)  (j)  (ji)  (hg) handmaid(hi)  (h) of(fgh) the(h)  (g) be(ge) it(g) un-(f)to(e) me(f)  8ccording(d)  (e)  (f) to(fgh) thy(h) word.(g) al-(hi)T(h) lu-(g)ia.(g) [(j)  (h) ](j)  (k)  (j) ",
        groupIndex: 2,
        filename: "./pages/part-b-019.png",
        nextFileName: "./pages/part-b-020.png"
    },
    {
        title: "part-b-020-0",
        gabc: "T(cc) he(f) Angel(g)  (f) of(g) the(gh) Lord(hg) *(f) Announced(h)  (g) un(fd) to(fg) Ma-(g)ry.(f) Tpe(f)  .(g) Angel.(f) And(h) she(hi) conceived(h)  (fh) by(g)  (h) the(g) Ho-(f)1ly(gh) Ghost,(hg)  R.(f) Announced(gh)  (g) un-(fd)to(fg) Ma-(g)ry.(f) \xa5.(c) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h)  and(h) to(gh) the(g) Son(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) The(f) Angel(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-020.png",
        nextFileName: "./pages/part-b-021.png"
    },
    {
        title: "part-b-020-1",
        gabc: "T(c)  (c) he(f) Angel(f)  (f) of(f) the(f) Lord(f)  (f) announced(g)  (f) un-(f)to(e) Ma-(g)ry,(h) Al(h) le-(hg) lu-(g)1a,(f) al-(d)le-(fg)lu-(gf)ia.(f) The(f) Angel.(f)  (f) And(c)  (f) she(f) conceiv-(f) (g)  ed(f) by(f) a(e) Ho-(g)ly(g) Ghost.(h) Iy(h) -(hg)lu-(g)ia.(f) Glory(f) be(f)  (f)  to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g) Ho-(h)1\xa5(g)  The(f) Angel:(f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-020.png",
        nextFileName: "./pages/part-b-021.png"
    },
    {
        title: "part-b-021-0",
        gabc: "a(c)  (c)  (e) shall(g) this(ih) be,TO(fh)  (h) Angel(h)  (g) of(f) God,(efhfghg) seeing(g)  (h) I(iji) know(hf) mot(g)  a(ig~)  (f) man?(e) Hearken,(iji)  (i) O(jjk)  (k) Virgin(jkj)  (ji) Ma-(j)ry:(ijig) The(h) Ho-(j)ly(i) Ghost(hih)  shall(hg) come(ij) up-(i)on(hg) thee,(fh) and(h) the(i) power(hg) of(f) the(gh) Highest(f)  (e)  shall(e) o-(e) (ef) vershadow(fe)  (de) TR(e) Al-(gf~)le-(f)lu-(e)ia.(e) [(j) I(i) e(h) e(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-021.png",
        nextFileName: "./pages/part-b-022.png"
    },
    {
        title: "part-b-021-1",
        gabc: "T(c) a(e) An-(e)gel(i) Ga-(hg)bri-(hi)el(i) spake(jk) un-(j)to(h) Ma-(g)ry,(fgf) B(e) B(e)  Bail,(ei) thou(ii) that(h) art(g) full(h) o(hi) grace,(i) the(i) Lord(j) is(k) with(j)  thee;(i) blessed(j)  (j) art(hi) thou(hh) a-(dfe)mong(fgf) @~(e) 8-(e)Al(gf~) Te-(f) lu-(e)ja,(e)  (i)  (j)  (i)  (h)  (gi) ",
        groupIndex: 1,
        filename: "./pages/part-b-021.png",
        nextFileName: "./pages/part-b-022.png"
    },
    {
        title: "part-b-022-0",
        gabc: "He(c)  (cf) hathmade(f)  (gh) me(hg) *(fd) so-(fg)late,(gf) He(f) hath(f) made.(gh) Apg(h)  (hi) =(g)  all(f) the(gh) day.(hg) -(fd)so-(fg)late.(gf) \xa5.Glory(c)  (h) f_l(h) be.(h) BiHe(f) l\u2014_l\u2014la{(f) magy,(gh)  =(f)  (g)  (h)  (g)  (h)  (j)  (i)  (h) i(h)  (g)  (f)  (e) S(d)  (e)  (d) 1(c)  ](g) [(f)  (g)  (h) a(g)  (f) -(f)a(f)  (g) a(h)  (g)  (h)  (j)  (i)  (h)  Pray(h)  (g) for(f) a(e) O(d) 2(e)  (d) .(c)  (g)  (f)  (g)  (h)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-022.png",
        nextFileName: "./pages/part-b-023.png"
    },
    {
        title: "part-b-022-1",
        gabc: "Si-(f)me-(gh)on(f) Tsaid(f) un-(dfe)to(dc) :(ifghghi) ry,(h) Yea,(hj) a(h) sword(h) shall(fg) pie(fe)  through(dg) thine(gf) own(gddd) soul(ghg) al-(ddfd)so.(fd) =(ddfddddh)  (f)  (fh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-022.png",
        nextFileName: "./pages/part-b-023.png"
    },
    {
        title: "part-b-023-0",
        gabc: "-(g) (g) O(f) a(e)  (f)  (hg) :(fg)  (g) a(gh)  (i)  (j) [](h)  (i) _.n(g)  (fg)  (g)  Hymn(j)  (h) Melody(i)  (g) at(hg)  (f) Prinma,(fh) :(h) Terce,(hg) Sext,(e)  (f) and(h) None(ih)  (g)  (fg)  (g)  U(ig~)  (e)  (f)  (gh)  (g)  (fe) N(f)  (g)  (f)  (f)  (g)  (h)  (ih)  (g)  (fh)  (hg)  (g)  e(gi)  (g) S(i)  (ij) e(ji) |(hg) B(fh) )(hg) B(g) T(e)  (f)  (gh) T(g)  (fe) I(fg)  (gf) |(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-023.png",
        nextFileName: "./pages/part-b-024.png"
    },
    {
        title: "part-b-023-1",
        gabc: "[(d) will(d) get(dh) me(h) to(h) the(h) mountain(j)  (k) of(ji) myrrh,(h) and(h) to(g) the(h)  hill(h) of(h) sl(efe) o(d) e(d) sk(h) RS(g) e(f) Sieboaat(gh) g(gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-023.png",
        nextFileName: "./pages/part-b-024.png"
    },
    {
        title: "part-b-023-2",
        gabc: "&#39;(cgi)  (cfe)  (c) Tis(ef)  (f)  (h) white(g) and(ef) ruddy:(fg)  (f) the(h) locks(j) of(ih) his(hj) head(j)  :(i) re(h) as(i) royal(ji)  (hg) purple,(fefh) _-(hg)bound(fe) in(c) _l-(ef)tresses.(f) [(h) \u2014l(g)  (e) =](f) _(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-023.png",
        nextFileName: "./pages/part-b-024.png"
    },
    {
        title: "part-b-024-0",
        gabc: "W(cc)  (ghj) hither(j) thy(j) be-(j)lov-(ji)ed(hi) gone,(i) O(ik) thou(j) fajreg,(ji) L(g) (](h)  (g)  women?(ef) ](g) whither(g) e(h) is(h) thy(j) be-(h)lov-(h)ed(gf) turned(gh)  (g) a-(gf)Wi(e) side?(ji) mh&#39;(hi)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-024.png",
        nextFileName: "./pages/part-b-025.png"
    },
    {
        title: "part-b-024-1",
        gabc: "A(ff) buncle(h)  (h) of(hj) myrrleis(i)  (i) my(i) well-(h)be-(i)lov-(j)ed(ih) un~to(ij)  (j) me;(i) he(f)  shall(i) lie(g) all(h) night(fe) betwixt(fe)  (de) my(fh) breasts.(f)  (i) Bl(h)  (i) 1(j)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-b-024.png",
        nextFileName: "./pages/part-b-025.png"
    },
    {
        title: "part-b-024-2",
        gabc: "Stay(de) me(f) with(ge) tlagons,(fe)  (d) T(f) comfort(g) me(h) with(ig) apples;(h)  (h) for(dhhg)  I(fe) pbm(dc) sick(e) of(ef) love.(d) a(h)  (g) gardinpiiE]l(f)  (gh) e(gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-024.png",
        nextFileName: "./pages/part-b-025.png"
    },
    {
        title: "part-b-024-3",
        gabc: "O(f) God,(g) my(gh) life(hg) I(f) have(g) declar-(h)ed(gfd)  (fg) un-(g)to(f) thee.(f) O(f)  (f) Go(g) ",
        groupIndex: 3,
        filename: "./pages/part-b-024.png",
        nextFileName: "./pages/part-b-025.png"
    },
    {
        title: "part-b-025-0",
        gabc: "\u2018z_(ki~) Thou(hi) hast(h) put(g) my(h) tears(g) in(f) thy(gh) sight.(hg) I(f) have(g)  declared.(ik)  (h)  (dgfd)  (fg) Clory(h)  (h) be.(h) G(f) God.(g)  \u2014(ik)  (f)  (e)  (fg) L](h)  (g)  (e) .-(f) (e)  (h) T(h)  (g)  (f) [(e) ](de) [(e)  [(ki~)  (g) ](c)  (f)  (d)  (e) =(e)  (e) a(c)  (d)  (e)  (e)  (e)  (e)  (f)  (e)  \xa5(ik)  (f) and(g) By(h) at(h)  (h) Vespers(h) above.(i)  (h)  (f)  (g)  (h)  (g)  (fd)  (d)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-025.png",
        nextFileName: "./pages/part-b-026.png"
    },
    {
        title: "part-b-025-1",
        gabc: "When(cc)  (gd) Je-(fg)sus(gh) therefore(h)  (hghih) Tsaw(f) his(gh) mother(j)  (g) standing(h)  (g) by(f)  the(fe) -(d)and(g) the(g) disciple(g)  (gh)  (g) 7(e) he(f) =(gh) loved,(g) he(g) saith(hj)  un-(ji)to(hg) T(fg) T(g) mother,(g) |(gi) S(ih) e(j) behold(hg) thy(hih) son!(g) Then(gd)  saith(fgh) he(g) to(h) the(g) disciple,(f)  (gh) -(h)Behold(j) -(hg)thy(fhih) [(g)  (g) ](fh)  (j) 1(ij)  (h) ](g) ",
        groupIndex: 1,
        filename: "./pages/part-b-025.png",
        nextFileName: "./pages/part-b-026.png"
    },
    {
        title: "part-b-026-0",
        gabc: ".(e) blessed(f)  (ed) Anselm(gh)  (g) Tinstructed(g)  (g)  (g) the(h) princes(j)  (ij) \u2014\u2014\u2014a(k) his(ji)  time,(hi) saying:(g)  (g) God(jj) O(hg) esteemeth(h)  (ge) nothing(f) a(e) more(f) highly(gh) i(g)  in(h) this(j) world,(ij) than(i) the(j) freedom(kj)  (hj) of(g)  (gf)  (c) |(e)  P.T.TChurch,(ef) al(g) =le-(gf)lu-(e)ia.(e) ](ji) _l_l(hi)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-026.png",
        nextFileName: "./pages/part-b-027.png"
    },
    {
        title: "part-b-026-1",
        gabc: "0O-(igij) (i) ans(hih) N(h)  (hg) full(d)  (hg) of(f) the(h) Ho-(hi)ly(hg) Spirit,(e)  (e) ](d) ve-(f)",
        groupIndex: 1,
        filename: "./pages/part-b-026.png",
        nextFileName: "./pages/part-b-027.png"
    },
    {
        title: "part-b-027-0",
        gabc: "newed(h)  (g) the(f) glory(hi)  (i) of(i) the(i) mo-(ij)nas-(hgf)tic(h) Order(f)  (ed) tlroughout(e)  (fh)  tle(hg) world,(ef) al-(g)le-(f)lu-(e)ia,(e) .(i)  (j)  (i)  (h) viij(h)  Ma(cfgh) jolus,(g)  (g) +(g) overflowing(g)  (h)  (g) with(h) love(g) and(f) favour,(gh)  (f) and(h)  striving(j)  (i) to(h) attain(j)  (jk) an-(hg)gel-(h)ic(g) loliness,(f)  (f)  (defeded) &quot;was(cd) lifted(fg)  (g)  high(f) n(g) above(h) mankind(gf)  (hj) in(i) virtue,(g) =(fgh) al-(i)le-(h)lu-(g)ia.(g) W(j)  (i) -(j) (h) 1(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-027.png",
        nextFileName: "./pages/part-b-028.png"
    },
    {
        title: "part-b-027-1",
        gabc: "-(cdf) (f) d1\u2014loTwonderfully(f)  (f)  (e)  (de) showed(edc)  (d)  (c) what(d) charity(f)  (fe) of(d)  (de) heart(ge)  he(fe) %(d) maintained;(cd)  (d) who,(dh) grieving(hi)  (h) for(h) the(g) \xe9(gh) sufferings(g) ](g) of(g)  the(g) -(gf)a(g) departed,(gh)  (fg)  (f) vearly(h)  (gf) decreased(g)  (fe) -(d)them(d) by(d) n(e)  e(f)  (gh) v(g) of(f) g(ef) &amp;(g)  (e) |(fe) refreshment,(d) =(dc) al-(d)le(efe) lu-(d)soga(d) =(h)  (g) 7(f)  (gf)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-027.png",
        nextFileName: "./pages/part-b-028.png"
    },
    {
        title: "part-b-028-0",
        gabc: "Ween(cc)  (ed) blessed(g)  (hj) Hu-(ij)go(j) fwas(i) about(j)  (k) to(j) die,(j) on(j) the(j) g3(ij)  (h)  the(g) rites(h) of(g) Ho-(f)ly(d) Sabbath,(ef)  (e) he(d) greeted(h)  (g) a(g) ney(hg) light(hj)  like(ik)  (h) e(gf) aPaschal(g)  (h) can-(gfe)dle,(e) earnestly(g)  (h)  (j) entreating(j)  (ji) (s(hg) witj(hg)  requent(fe)  (d) sighs(e) that(dh) it(g) might(f) reach(gh) the(h) earth(j) by(h) way(h)  of(ki~)  (gf) happy(g)  (h) promise,(gfe)  (ef) al-(g)le(gf) 1lu-(e)ia.(e)  (ji) -(hi) (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-028.png",
        nextFileName: "./pages/part-b-029.png"
    },
    {
        title: "part-b-028-1",
        gabc: "are(c)  (ddc)  (cf)  (fe) a(dc)  (c) vye(d) Saints(f) of(gh) God,(gfe) who(fe) have(d) [](c)  worthy(df)  (f) to(g) share(dc) in(f) heav\u2019&#39;n-(ffg)ly(fe) perfections,(de)  (dd) .(c) and(fg) to(f) [}(e)  -(ggh),.(c) the(d) honour(fg)  (f) of(f) high(f) rendwn,(fe)  (dc) al(d) le(efe) lu-(d)1a.(d)   (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 1,
        filename: "./pages/part-b-028.png",
        nextFileName: "./pages/part-b-029.png"
    },
    {
        title: "part-b-029-0",
        gabc: "hy(f)  (gg) 0(h) Lord,(h) shall(g) be(df) whiter(g)  (g) than(fe) show,(dc) al-(d) le-(efe)lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-b-029.png",
        nextFileName: "./pages/part-b-030.png"
    },
    {
        title: "part-b-029-1",
        gabc: "T(ki~) he(f) righteous(fg)  (g) shall(f) give(h) thanks(j) tun-(j)to(i) thy(hg) Name,(hg) and(g)  the(ik)  (g) just(fe) shall(f) continue(d)  (e) ST(f) in(gh) thy(h) sight,(gfd) al(fe) -(fg)1lu-(g)ia(g)  =(ik)  (j)  (i)  (j) a(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-b-029.png",
        nextFileName: "./pages/part-b-030.png"
    },
    {
        title: "part-b-029-2",
        gabc: "1(e) you,(gh) my(hji) Saints,(i) who(ih) in(i) this(j) world(kj) have(i) en-(hij)dur-(h)ed.(f)  the(ghi) struggle,(g)  (g) do(g) I(h) render(ij)  (i) the(h) reward(h)  (hih) of(f) your(f) la(fe)  bours,(d) a](ef) e-(f)1y~(e) ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-029.png",
        nextFileName: "./pages/part-b-030.png"
    },
    {
        title: "part-b-030-0",
        gabc: "0(dh) ye(hj) Spirits(hg)  (h) Tand(f) ho-(g)1ly(f) Souls(fgh) of(f) the(e) righteoys(d)  (d)  a(ef) hymn(g) un-(f)to(fe) God,(dc) al-(d)le~(efe) lu-(d)ia.(d) |(h)  (g) s(f)  (gh)  (gh)  \xa2(j) are(j) lo-(ih)ly,(h) G(gfe) the(fg) Lord;(g) end(g) :(f) Twill(g) muleg;.(h)  (j)  ply(j) your(jkj) number,(h)  (h) to(j) make(j)  (ih) supplication(gh)  (i) for(h)  (h) my(gf) people(gh)  (h)  in(ik)  (h) this(g) place,(gfd) al-(fe)le-(fg)lu-(g)ia.(g)  (j)  (h)  (j) |(k)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-b-030.png",
        nextFileName: "./pages/part-b-031.png"
    },
    {
        title: "part-b-030-1",
        gabc: "righteous(cccdc)  (cf)  (fe) shall(de) s(dc) and(c) run(df) to.(gf) and(d) fro(ed) like(d)  sparks(efedcdfe) among(fghg)  (ed) the(fe) stubble;(d)  (d) they(ef) shall(gh) judge(fe) the(de) na-(d) a-(c)[}(c) shall(d) reign(f) for(gh) ev-(fe)\xe9r,(dc) al-(d)le-(efe)lu-(d)1a.(d)  (hgfggfed) ",
        groupIndex: 1,
        filename: "./pages/part-b-030.png",
        nextFileName: "./pages/part-b-031.png"
    },
    {
        title: "part-b-031-0",
        gabc: "et(c)  (f) not(ef) your(de) hehrt(ddc) be(cd) troubled,(ffgf)  (f) neither(fe)  (g) let(gh) it(g) be(f)  a-(fgf)fraid;(f) ye(f) believe(gh)  (h) in(j) God,(ihgf) a(e) bhelieve(fg) al(gfe) s0(d) 1in(ef)  e:(dc) in(d) my(cd) Fa-(ffg)ther\u2019s(f) house(f) are(h) ma-(g)ny(h) mansions,(f)  (dg) al-(c) le-(d)lu-(fg)ia,(fe) al-(g)le-(gh)lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-031.png",
        nextFileName: "./pages/part-b-032.png"
    },
    {
        title: "part-b-031-1",
        gabc: "Lord,(c)  (hgih~) shew(ig) us(ij) the(i) Father,(hhi)  (h) and(h) it(h) suf-(f)fic-(hih)eth(g) us,(ef)  L](g) le-(f)&quot;(e) a.(e)  (i) .(j)  (i)  (hi)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-031.png",
        nextFileName: "./pages/part-b-032.png"
    },
    {
        title: "part-b-032-0",
        gabc: "Phi-(c) (hg) lip,(hi) The(ig) that(ij) hath(i) seen(h)  (ih) me(h) hath(h) seen(h) my(f)  a(e) so,(f) al-(g)le-(f)-(e)A-(e) (i)  (j)  (i)  (hi)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-b-032.png",
        nextFileName: "./pages/part-b-033.png"
    },
    {
        title: "part-b-032-1",
        gabc: "Have(c)  (c)  (g) I(hj) beentso(jji)  (h) long(ji) time(ji) with(h) you,(g) and(g) yet(hj) hest(j)  not(hi) known(i) me,(kj) Philip?(hi)  (i) he(i) that(j) hath(i) seen(hi) me(g) N(g)  seen(ih) my(hg) Father(h)  (g) dal-(fe)so,(d) al-(g)le-(gf)lu-(e)ia.(e) =(j)  (h) saaea](j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-b-032.png",
        nextFileName: "./pages/part-b-033.png"
    },
    {
        title: "part-b-032-2",
        gabc: "If(ce) ye(ehg) had(hi) known(hij) me,T(i) ye(i) should(h) have(j) known(k) my(ji) a(g) e(h)  al-(ij)so:(i) and(i) Pt(jih) henceforth(h) ye(i) know(hgf) him,(hg) and(i) have(i) seen(ji)  him,(hgf) al-(f)le-(e)lu-(fhg)ia,(f) al-(fgh)le-(i)=lu-(hg)ia,(f) S(g) le-(f)lu-(e)ia.(e)  (hdj) -(i) (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-032.png",
        nextFileName: "./pages/part-b-033.png"
    },
    {
        title: "part-b-033-0",
        gabc: "If(cgj) ye(h) love(g) me,T(i) keep(ij) my(k)  (ji) commandments,(h)  (hi) al(g) le-(ge)&#39;lu-(fe)ia,(d)  al(hg) le-(i)lu-(h)1ia,(gf) al(g) -(gf)lu-(e)1a.(e)  (j)  (h)  (j) 1(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-033.png",
        nextFileName: "./pages/part-b-034.png"
    },
    {
        title: "part-b-033-1",
        gabc: "T(h) an(h) the(h) way,T(gfe) the(i) truth,(ih) and(ij) the(j) life:(i) no(i) man(i)  cometh(ji)  (h) un-(h)to(h) the(i) Father,(hg)  (ef) but(hf) by(gf) &#39;me,(ed) al-(ef)le-(f)lu-(e)1ia.(e)   (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-033.png",
        nextFileName: "./pages/part-b-034.png"
    },
    {
        title: "part-b-033-2",
        gabc: "1fye(c)  (c) .(e) abide(f)  (g) in(h) [](g) [(g) my(fh) words(j) T(i) abide(hg) in(efg) you,(g) [](g)  shall(g) agk(hg) what(f) ye(d) will,(f) and(f) it(f) shall(e) |(g) a(g) un-(f)to(e)  =(d) al-(d)=(c) ly(efe) III-(dd)al-(ef)e-(gdfedd)3_____(de)  (dd) lu-(c)ia.(c)  (fg) [(hg)  (f)  (ed) ",
        groupIndex: 2,
        filename: "./pages/part-b-033.png",
        nextFileName: "./pages/part-b-034.png"
    },
    {
        title: "part-b-034-0",
        gabc: "We(cc)  (f) adore(f)  (g) thee,(f) 0(f) Christ,(f) and(f) 5(e) bless(g) thee,(h) A}(h)  lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) We(f) adore.(f)  (g) V.(c) Because(f)  (f) by(f) thy(f)  Cross(g) thou(f) lLast(f) redeemed(f)  (f) a(e) the(g) world.(h) Al-(h)le(hg) lu-(g)iq,(f)  y.(c) Glory(f)  (f) be(f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) R(h) the(g)  Ho-(h)ly(g) Ghost.(gf) We(f) adore.(f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-034.png",
        nextFileName: "./pages/part-b-035.png"
    },
    {
        title: "part-b-034-1",
        gabc: "0%(cd) Cross,(ff) t(cd) irpassing(f)  (gh) all(h) the(g) stars(fe) in(d) splendodr;(g)  (cd)  world(de) renowned,(d)  (cdf)  (f) exceeding(hfe)  (dfdd) d\xe9ar(dfedddc) un(ffh) to(gfegh) the(fe) heas(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-034.png",
        nextFileName: "./pages/part-b-035.png"
    },
    {
        title: "part-b-035-0",
        gabc: ",f(fe) men,(ddc) ho(eghg) li-(fe)er(fgf) than(ef) all(d) things:(d) thou(dh) on(h) ly(gfegh)  wert(fe) counted(d)  (fe) worthy(dd)  (c) to(c) uphold(d)  (ffg) the(ed) world\u2019s(eef) ransom.(d)  (d)  Gyeet(h) the(gf) wood,(ghghih) sweet(f) the(ed) i(dgf) ron,(g) [](c) bearing(d) so(fgf) sweet(ed)  a(efe) burden:(d)  (d) o(hg) bring(hih) aid(ghgfed) to(f) this(g) B(de) congregaktion,(fe) ,(dc) @-(c)L}(c)  are(d) here(fe) as-(f)sem-(gh)bled(g) to(cd) ce-(fg)le-(f)brate(ed) thy(efe) -(d)5(d)  il(cd) le(fgfe) .(gh) lu~ia,(fedc) al-(ddg)le-(efe)lu-(d)ia.(d) u(h)  (g) _(f) &amp;\xab(g) a,(gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-b-035.png",
        nextFileName: "./pages/part-b-036.png"
    },
    {
        title: "part-b-035-1",
        gabc: "0(igij) mighty(ij)  (i) Twork(ig) of(hg) mercy!(e) B(e) death(h) then(f) di-(h)ed,(g) when(h) life(hiji)  e(h) ed(f) up-(e)T(fh) the(g) o(ef) s(g) ](f)  (e) ia.(e) [(i) |(j)  (i) o(h) )(fgh) ",
        groupIndex: 1,
        filename: "./pages/part-b-035.png",
        nextFileName: "./pages/part-b-036.png"
    },
    {
        title: "part-b-036-0",
        gabc: "Save(g) us,TO(hj)  (j) Christ(j) our(h) Saviour,(j)  (i) by(g) the(h) virtue(h)  (h) of(i)  the(h) Cross:(g) thou(g) who(h) savedst(i)  (h) Peter(j)  (i) in(gi) the(hg) sea,(h) haye(g)  mercy(gf) i(gh) up-(gf)on(e) us,(ef) al~le(g)  (fg) lu-(e)1a.(e) |(j)  (h) \u20141(j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-036.png",
        nextFileName: "./pages/part-b-037.png"
    },
    {
        title: "part-b-036-1",
        gabc: "B(d) ](e) the(f) Cross(ge) of(f) the(e) e(d) Lord;Tflee(fh) a-(h)way,(hghihgg) Ye(ef) ad-(g) -(ki~)versaries:(fe)  (d)  (ded) the(c) [1-(cd)on(d) of(d) the(d) tribe(e) of(f) Ju-(gh)dah,(ghg) the(g) Root(ef)  of(i)  (g) Da\u2014vid(f) .(edc) hath(d) 3(f) prevailed,(d) .(dc) al-(d)le(efe) lu-(d)ia.(d)  (h) &quot;2(g) g(f)  (h) |(gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-036.png",
        nextFileName: "./pages/part-b-037.png"
    },
    {
        title: "part-b-036-2",
        gabc: "But(ig) as(j) for(i) us,T(i) it(i) behoveth(i)  (i)  (g) us(hi) to(hg) A(e) a-(e)in(h) the(h) Cro%(h)  of(f) our(h) Lord(gfe) Je-(fg)us(f) Christ,(ef) al-(g)le-(f)lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-036.png",
        nextFileName: "./pages/part-b-037.png"
    },
    {
        title: "part-b-037-0",
        gabc: "By(c)  (dd) n(c) -(df)of(fe) the(de) Cross,(dc) de-(fg)liv-(hi)er(g) us(hih) from(h) our(g)  e-(f)ne-(fe)mies,(dc) 0(d) our(efe) God,(dc) al-(d)le-(fe)lu-(d)ia.(d)  (h) &amp;(g) .(f) 9(h) &amp;l(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-037.png",
        nextFileName: "./pages/part-b-038.png"
    },
    {
        title: "part-b-037-1",
        gabc: "This(c)  (f) sign(f) of(f) the(f) Cross(g) shall(f) be(f) in(e) heaven,(g)  (h) Al(h) ~le(hg)  lu-(g)1ia,(f) al(d) le(fg) -(gf)1ia.(f) This(f) sign.(f) When(f) the(f) Lord(g)  shall(f) come(f) a(e) judgment.(g)  (h) B/&#39;.Al\u2014le-(h)lu-(hg)ia.(g)  (f) Y.(c) Glory(f)  (f) be.(f)  This(f) sign.(f)  |(j)  .(d)  (e) B(gh) |(hg) TR(h) ](j) [(ji) T(hg) e(i)  (j) |(j) L(hg) (](j) b(ih) (e(h)  5(h)  (hji)  (g) A(ge)  (f)  (dc) aw:__(de)  (efe) o(d) T(dh) [(fhg) #(ed) \u2014(f) 8(ed) |(d)  .(h)  (hji)  (g)  (ge)  (f)  (dc)  (de)  (f)  (edfe)  (d)  (d)  (dddhd)  (dhgd)  (ed)  (fd)  (ed)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-037.png",
        nextFileName: "./pages/part-b-038.png"
    },
    {
        title: "part-b-038-0",
        gabc: "alone(ccc)  (c)  (d)  (f) T(fe) excellest(d)  (ef) in(de) P(d) &gt;(c) all(f) the(g) cedars(hg)  (e) ._(fg) Tep(fe)  \u2014(ki~) a-(d)non:(d) for(f) on(fe) tiee(dc) the(df) Life(fh) of(g) the(f) world(fe) was(de) hang;[i(dd)  (c)  -(f)thee(fe) was(g) Christ(gh) vic-(ed)to-(fe) (d) ri\u2014ous,(d) and(dc) death(deed) -(degh)ver(g)  death(fgf) did(f) for(dfe) ev-(dc)er(d) triumph,(fe)  (f) -(g)le-(fe)lu-(d)ia.(d)  (f) I(h)  (g)  (f) v(gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-038.png",
        nextFileName: "./pages/part-b-039.png"
    },
    {
        title: "part-b-038-1",
        gabc: "\u2018He(c)  (ce) the(ef) ho-(f)ly(h) Cross(hg) S(fg) endured,(g) Burst(ghi) the(g) gates(hg) of(f) hell(gf)  in(ef) twain:(f) Begirt(f)  (fe)  (c) might(e) and(fh) ma-(hg)jes-(fg)ty,(g) On(i) Eas-(iji) ter(gi)  (g) morn(hg) he(f) rose(gf) a-(ef)gain,(f) al-(ge)le(cgfhdhfgf) lu-(fe)ia.(f)  (ff) %(h)  (g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-038.png",
        nextFileName: "./pages/part-b-039.png"
    },
    {
        title: "part-b-039-0",
        gabc: "Jolm(ff) the(d) A-(f)pos-(ef)tle,(f) Ee-(fe)ing(d) cast(ef) in-(gh)to(f) a(gf) caldron(e)  (e)  g(dc) boiling(d)  (de) 0il,(e) by(dhi) vir-(h)tue(gf) of(g) pro-(ghg)tect-(fe)ing(de)  a2(e) came(eg) forth(gf) un-(ghg)harm-(e)ed,(ef) al(fg) le(de) lu(e) 1ia.(e)  a(h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-039.png",
        nextFileName: "./pages/part-b-040.png"
    },
    {
        title: "part-b-040-0",
        gabc: "%hy(c)  (c)  (f) a(fg)  (g) hath(fh) broke_r\xe9_my(j)  (ih) .heart;(jk)  (h) I(h) am(h) full(e) of(f)  (gh) he\u201Ci_?(h)  some(j)  ness:(g) 1(j) looked(k)  (j) for(ik) some(k) to(k) have(j) pi-(ji)ty(hj) on(jj) me,(g) but(gf)  there(g) was(gh) no(f) man;(f) neither(f)  (g) found(f) I(gh) h-(fe)ny(d) to(ef) comfort(fh)  (h)  e(g)  (f)  (j)  (i) AT(j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-040.png",
        nextFileName: "./pages/part-b-041.png"
    },
    {
        title: "part-b-040-1",
        gabc: "=(c)  (gj) of(hghhj) me,(i) for(ij) I(k) am(ji) meek(g) andlowly(h)  (gf) in(g)  (fg) heart.(e) &#39;I(j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-b-040.png",
        nextFileName: "./pages/part-b-041.png"
    },
    {
        title: "part-b-040-2",
        gabc: "1(d) have(cd) sancti-(fg)L](e) ed(fe)  (d) this(cd) house,(d) that(dc) my(f) Name(g) may(fe) be(gh)  there(hihg) for(ef) ev-(gf)=(f) and(dh) mine(hi) eyes(hg) and(f) mine(gh)  (ij) heart(hjijkj) shal(h)  be(gf) there(ghi)  (hghg) T(ef) perpetually.(g)  (fe)  (d)  (h) 1(g)  (f)  (fgh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-040.png",
        nextFileName: "./pages/part-b-041.png"
    },
    {
        title: "part-b-041-0",
        gabc: "And(c)  (f) %(cdf) said:(f) TThen(ff) have(d) T(ef) cleansed(g)  (e) my(f) h\xe9art(dc) in(d) vain,(e)  and(gh) wash-(gfe)ed(e) my(ce) hands(g) in(g) in-(e)no-(fe)cen-(de)cy;(d) all(c) the(e) day(ge)  long(gh) have(hj) I(h) been(gf) punish-(g)ed.(ghg)  (e) e(h)  (g) T(h) e(ih) WO(gfe) el(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-041.png",
        nextFileName: "./pages/part-b-042.png"
    },
    {
        title: "part-b-041-1",
        gabc: "In(cf) the(g) multitude(gh)  (g) L](g) fof(f) tle(h) sorrows(j)  (i) that(h) I(ji) had(hg) in(h) my(h)  heart,(g) thy(j) comforts(j)  (i) have(h) A(g) refresked(h) =(e) my(fg) soul.(g) e(j) e(i)  (j)  (h) A(ghg) ",
        groupIndex: 1,
        filename: "./pages/part-b-041.png",
        nextFileName: "./pages/part-b-042.png"
    },
    {
        title: "part-b-041-2",
        gabc: "S\u2018et(hg) me(hih) as(f) a(f) seal(fi) up-(i)on(jih) thine(ih) heart,(f) as(i) a(hg) seal(f) up-(ed) on(fe) =(e) \u2014(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-041.png",
        nextFileName: "./pages/part-b-042.png"
    },
    {
        title: "part-b-041-3",
        gabc: "\u2014(cc)  (f) 0(f) a.(g) hast(f) broken(gh) R(hg) *(f) My(fgh) bonds(gfd) in(fg) T(g) sunder.(f) ",
        groupIndex: 3,
        filename: "./pages/part-b-041.png",
        nextFileName: "./pages/part-b-042.png"
    },
    {
        title: "part-b-042-0",
        gabc: "\u2018Thou,(f) O(f) Lord.(g) \xa5.(c) I(h) will(h) offer(hi)  (h) to(h) thee(h) the(h) )(h)  (g) :(g)  of(g)  (f) thanksgiving.(gh) .(hg) My(h)  (fgh) bonds.(gfd) Glory(h)  (h) be(h) to(h) o(h)  Father(hi)  (h) and(h) to(gh) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh)  Thou,(ik)  (f) C(f) Lord.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-042.png",
        nextFileName: "./pages/part-b-043.png"
    },
    {
        title: "part-b-042-1",
        gabc: "S(e)  (fed)  (e)  (f)  (e)  (f) WS(hg) S|(fe) a(e) [](g)  (iji) &quot;(h)  (gf)  o(e)  (f) [(d)  (e)  (g)  (i) a8(i) a(j)  (i) I(h)  (g)  (fge)  x.(e) Surely(cdefed) he(e) hath(f) borne(e) wa(f)  (hg) g(fe) ](e) ",
        groupIndex: 1,
        filename: "./pages/part-b-042.png",
        nextFileName: "./pages/part-b-043.png"
    },
    {
        title: "part-b-042-2",
        gabc: "e(c)  (hc~)  (f) was(edf) wounded(fhg~dedfgddfdfd) &#39;ffor_our(jfdffdfhdf)  (dfhi) transgressions;(fddfijdifhfdf)  (d)  (dhd) the.(f)  (df)  (di) wad(dfk) =(fdkj) ",
        groupIndex: 2,
        filename: "./pages/part-b-042.png",
        nextFileName: "./pages/part-b-043.png"
    },
    {
        title: "part-b-043-0",
        gabc: "ed(ih) for(h) our(f) i-(e) (f) ni-(ed)ties:(ef) the(gg)  (g) chastisement(dfgf)  (e) of(f) our(d)  peace(eg) was(f) up-(h)on(gh) him,(f) and(d) with(ef) his(fg) stripes(fed) we(ef) are(e)  healed.(d)  (d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-043.png",
        nextFileName: "./pages/part-b-044.png"
    },
    {
        title: "part-b-043-1",
        gabc: "He(f) ma-(gh)keth(hg) Peace(g) &#39;in(fd) thy(fg) e(g) borders.(f) He(f) ma-(gh)keth.(hg)  And(h) filleth(hi)  (g) thee(g) with(h) the(g) flour(f) of(fgh) wheat.(dhg)  (h)  (i) Peace.(c)  (g)  (f)  K.(c) Glory(h)  (h) be.(h) He(f) ma-(gh)keth.(hg)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-b-043.png",
        nextFileName: "./pages/part-b-044.png"
    },
    {
        title: "part-b-044-0",
        gabc: "But(c)  (d) when(d) .ey(dc) came(f) to(g) Je-(fh)sus,T(h) and(h) saw(hj) that(h) he(h) ygqq(gf)  dead(i)  (gh) already,(hi)  (h)  (h) they(g) brake(g) -(e)his(fe) le;g&#39;sz(cd) but(d) one(f)  (d)  .(e) soldiers(f)  (ghg) with(h) a(gh) spear(jkh) pierced(h)  (gf) his(hi) side,(h) ang(gh) forth.(fg)  with(f) came(f) there(f) out(ef) blood(g) and(fe) water.(d) i(d) B(h)  (g)  (f)  (gh) |(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-044.png",
        nextFileName: "./pages/part-b-045.png"
    },
    {
        title: "part-b-044-1",
        gabc: "He(e) shall(f) go(h) before(h)  (ij) him(i) Tin(h) the(i) spirit(k)  (j) and(i) pow-(i)er(g) of(ji~)  E-(i)1i-(hih)as,(gh) to(h) make(h) ready(h)  (g) a(f) people(gh) =(f) prepared(e)  (h) for(gh)  (fh)  E-(d) the(g) 5(e)  (i)  (j)  (i)  (h) .(cgf) ",
        groupIndex: 1,
        filename: "./pages/part-b-044.png",
        nextFileName: "./pages/part-b-045.png"
    },
    {
        title: "part-b-045-0",
        gabc: "shalt(f)  (fg) call(g) his(hg) name(j) John:(h) shall(g)  (g) drink(f) neither(g)  (h)  wine(ki~)  (j) nor(h) strong(ji) drink:(g) and(j) ma(kjji) ny(h) shall(ghih) rejoice(g)  (gf) [(e)  his(ki~)  (fg) birth.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-045.png",
        nextFileName: "./pages/part-b-046.png"
    },
    {
        title: "part-b-045-1",
        gabc: "Fron(c)  (d) the(d) womb(dc) of(f) the(g) ag-(fh) (h) edTand(h) barren(h)  (g) a(e) brought(fg)  forth(fe) John,(c) the(ef) .(g) Forerunner.(fe)  (d)  (d) =(h)  (g)  (f) dp(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-045.png",
        nextFileName: "./pages/part-b-046.png"
    },
    {
        title: "part-b-045-2",
        gabc: "E(cd) -(fg)a(g) a(g) great(h) L)(g) the(f) sight(gh) of(f) a(e) -(d) for(d) n(g) [(g) &quot;(g) the(f) Lord(gfed) is(c) with(edffd~) him.(fd~dd)  (d) |(h) &quot;o(h)  (g) _osa(f)  (g) _(gfedf) ",
        groupIndex: 2,
        filename: "./pages/part-b-045.png",
        nextFileName: "./pages/part-b-046.png"
    },
    {
        title: "part-b-046-0",
        gabc: "A(f) mong(f) them(f) that(f) are(f) born(g) of(f) wo-(gh)men(hg) There(f) O(g) |(h)  ri-(ki~) (g) sen(fd) a(fg) greater.(g)  (f) Among(f)  (f) them.(f) V.(c) Thap(h) John(hi)  (hi) the(h) Bp(gh)  tist.(ik)  (hg) There(f) hath(g) not(h) T(g) ri.sen.(fd) b.(c) Glory(h) E\u2014\u2014(h) be,(h) R.A-(f) mong(i)  (f) them,(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-046.png",
        nextFileName: "./pages/part-b-047.png"
    },
    {
        title: "part-b-046-1",
        gabc: ".(e) T(f) el(h) Be\u2014\u2014\u2014r(fg) T(f) R(f) a(f)  (e)  (f) TR(g)  (g) &quot;(ig) a(g)  (f)  a(ig~)  (fge)  (f)  (j) ;(h)  (i)  (j) -(i) (hf)  (f)  (iji) |(hg)  (h)  (i)  (f)  O(j) a(i) s,(j)  (hi) el(j)  (j) [(ih) |(gf) ](e) Lo(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-046.png",
        nextFileName: "./pages/part-b-047.png"
    },
    {
        title: "part-b-046-2",
        gabc: "hen(e) Za-(efh)cha-(f)ri-(f)as(e) Twentlin-(c) (f) to(de)  (f) the(dfhg) temple,(e)  (e) ther(e)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-b-046.png",
        nextFileName: "./pages/part-b-047.png"
    },
    {
        title: "part-b-047-0",
        gabc: "pear-(ghi)ed(i) un-(ij)to(ih) him(h) the(h) An-(h)gel(gf) Ga-(fgh)bri-(g)el,(e) standing(g)  (fe) on(fg)  (f)  the(f) right(gh) side(ij) of(i) the(j) al-(hf)tar(hi) of(hg) incense.(e)  (e) |(hfh) [(h) el(g)  (h)  (f) |(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-047.png",
        nextFileName: "./pages/part-b-048.png"
    },
    {
        title: "part-b-047-1",
        gabc: "](g) Eli\u2014sa-(g) (h) beth,T(j) the(j) wife(j) of(j) Za-(j)cha-(h)ri-(j)as,(i) brought(gh) forth(h)  a(jk)  a(h) mighty(i)  (h) son,(g) John(j) the(ig) Baptist,(h)  (hf) the(hj) Lord\u2019s(g) Fore-(gf) runner.(e)  (e)  (j)  (h)  (j)  (dih) ",
        groupIndex: 1,
        filename: "./pages/part-b-047.png",
        nextFileName: "./pages/part-b-048.png"
    },
    {
        title: "part-b-047-2",
        gabc: "made(d)  (ef) W(fge) s1gnsTto(gh) his(fe) father,(de)  (e) how(e) he(c) would(e) heve(fe~g) him(fe) call-(d) S(d)  (h) afid(ec) he(g) |(cdefge) e(gh) e(h)  (j) His(i) e(g) is(fg) T(e) |(h)  (f) e(h)  (g)  (h) o(ih)  (dgfe) W(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-047.png",
        nextFileName: "./pages/part-b-048.png"
    },
    {
        title: "part-b-048-0",
        gabc: "His(d) ](dc) shall(f) be(g) called(f)  (h) John:&#39;and(h)  (h) ma(ih) :(g) 0(e)  (f)  joice(g) at(e) his(fe) birth.(d)  (h)  (g)  (f)  (gh) -(gf) A(ch) mong(h) them(h) that(f) are(h) bornt(g) a(e) wo-(fgf)[B(e) there(h) hath(h) not(f)  risen(h) .(g) [](e) greater(f)  (fd) than(fh) John(e) the(d) Il_l(c) Raptist.(c) ateaats(h)  (f) |ERET(h)  (g)  =(fh) child,(hhg) shalt(f) be(h) called(hg) a(e) a(e) a(e) prophet(fg) of(f) 8(e) High(cde)  est;(e) for(e) thou(e) shalt(f) go(h) before(h)  (h) the(f) face(h) of(g) the(f) Lord,(e)  _to(f) prepare(ed)  (e) his(ed) :(c) o(h) od(f)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-048.png",
        nextFileName: "./pages/part-b-049.png"
    },
    {
        title: "part-b-048-1",
        gabc: "here(f) was(f) aman(gh) *(fddfhgfdfhfhfddfdhfd) Cod.(gdfcdfgfdffdfff) was(fddff)  (hf) @(fgh) man(hg) ",
        groupIndex: 1,
        filename: "./pages/part-b-048.png",
        nextFileName: "./pages/part-b-049.png"
    },
    {
        title: "part-b-049-0",
        gabc: "j.(c) Whose(hihi) name(g) was(gh) John.(hg) R(ef) Sent.(fd) F.(f)  (c) Glory(h)  (h) be.(h)  There(f) was(f) a(gh) man.(hg)  (fi) ",
        groupIndex: 0,
        filename: "./pages/part-b-049.png",
        nextFileName: "./pages/part-b-050.png"
    },
    {
        title: "part-b-049-1",
        gabc: "a(i)  (f)  (d)  (e) -(e)-(e)](e) ](e)  (g)  (h) __&#39;_&#39;__&#39;__&#39;_&#39;__t\u2014:::&quot;(h)  (g)  (f)  (h)  (i)  (h)  [(ki~)  (g)  (g)  (h)  (g)  (f)  (d)  (e) &quot;(e) -(f)-(d) (c)  (d) .(d)  X.(f) This(g) child(h)  (g) shall(g) be(f) great(h) in(g) the(f) -(e)-(e)",
        groupIndex: 1,
        filename: "./pages/part-b-049.png",
        nextFileName: "./pages/part-b-050.png"
    },
    {
        title: "part-b-049-2",
        gabc: "he(f) mouth(d) of(de) a(e) a(e) ri(fggh) as(hg) was(fe) o(f)  (e) o-(e)and(g) he(h)  Prophesi-(i) (h) ed,(f)  (h) saying:(h) =(g) Plessed(g)  (h) be(hij) the(i) God(dhghih) of(ih) Is(defe)  ra(def) e},(e)  (fhgh)  (h)  (g)  (h)  (f)  (ef)  (fgh) ",
        groupIndex: 2,
        filename: "./pages/part-b-049.png",
        nextFileName: "./pages/part-b-050.png"
    },
    {
        title: "part-b-050-0",
        gabc: "s(g)  (g)  (f)  (e)  (d)  (fhg)  (fg)  (g)  (hjji)  (h)  (hg)  (h)  (ig)  (h)  (g)  (f)  a(g) a(g) .(f)  (g)  (h) a(j)  (g) AT(ihih) VESPERS(h)  (h) ](ghg)  (e)  (f) =(hg)  (fg)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-050.png",
        nextFileName: "./pages/part-b-051.png"
    },
    {
        title: "part-b-050-1",
        gabc: "a(e) child(ei) Tthat(i) is(i) born(hg) un-(h)to(hi) us(i) 1s(ij) more(h) than(f) a(g)  ](gf) P(e) for(df) this(h) is(ij) he(i) of(j) whom(h) the(f) M(hf) &amp;(gf) saith:(e)  Among(d)  (f) them(h) that(h) are(h) born(g) of(f) -(hij)men,(i) there(i) hath(j) not(i)  risen(h)  (h) a(f) greater(h) .(g) ](e) =(gh) the(f) &quot;(e) a.(e)  (i)  (j) |(i)  (h)  (gi) ",
        groupIndex: 1,
        filename: "./pages/part-b-050.png",
        nextFileName: "./pages/part-b-051.png"
    },
    {
        title: "part-b-050-2",
        gabc: "ne(cd) 1(dhi) -(h)stood(h)  (d) before(fhfdh) the(f)  (f)  (hd) Lord,(ihghihgg) and(f) were(g) not(gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-050.png",
        nextFileName: "./pages/part-b-051.png"
    },
    {
        title: "part-b-051-0",
        gabc: "5(ki~) ge-(g) (f) pa\u2014ra\u2014ted(f)  (f) one(fe) from(gh) an-(fe)o~(de) ther:(d) they(d) drank(dgfgh) of(g)  the(f) cha(ghghi) lice(h) of(fghg) the(hgfg) Lord,(gf) and(f) were(f) called(f)  (f) the(ef)  friends(g) of(e) God.(d)  (h)  (g)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-051.png",
        nextFileName: "./pages/part-b-052.png"
    },
    {
        title: "part-b-051-1",
        gabc: "These(ik)  (f) are(dc) the(d) ho-(dhi)ly(h) ones,T(h) who(h) for(h) the(h) love(h) of(h) Christ(ehghihgg)  despised(fg)  (h)  (g) the(f) threats(gh) f(fe) men:(d) in(f) the(f) kingdom(f)  (d) of(c) heaven&#39;(dd)  (c)  \xbb(e) ho(g) 1y(f) =(fg) Martyrs(f) lexult(ed)  (dg) with(fe) e(d) Angels:(d) [(fgh) 1R(dhgfhjh) how(hg) precious(h) a(g)  ~(ik) 1is(h) the(gf) death(ef) of(gh) the(fe) Saints,(d) who(fed) stand(ef)  (fgh) unceasingly(g)  (f) be-(fe) (dc)  the(ki~)  (ddg)  (ef) Lord,(d) and(c) are(d) not(f) \u2014&#39;_I:_I(f) separhted(de)  (dc) \u2014_i(c) one(def) from(gh) an-(fe) (d) other.(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-051.png",
        nextFileName: "./pages/part-b-052.png"
    },
    {
        title: "part-b-052-0",
        gabc: "a(dhhi)  (g)  (hi)  (jihg)  (h)  (k)  (j)  (ih)  (g)  (j)  (ihg) =(h)  (h)  (hjih) Y(g)  (f)  :(fgf)  (ed) a(g)  (hi)  (j)  (ih)  (g)  (h)  (h)  (k) Y(ji)  (k)  (ji)  (h)  (i)  (j)  (h)  (i)  [(g)  (h) :(h) pastor(h) ANTIPHON(hjih)  (g)  (fgf) ON(ed) MAGNIFICAT(e)  (f)  (d)  (e) L(c)  (d)  (d)  T(c) hou(d) art(d) the(cdc) shepherd(f)  (g) of(f) the(fgh) sheep,(h) 1.0(hjfkj) chief(jihihhg) of(fe) the(fg)  A(fe) -(d)postles:(d) un-(g)to(g) thee(h) were(g)  (fe) the(c)  (d) keys(ffg) of(f) the(f)  kingdom(ef) a(g) of(fe) heaven.(d)  (d) e(h)  (g) LAUDS(f) o(gh) p(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-052.png",
        nextFileName: "./pages/part-b-053.png"
    },
    {
        title: "part-b-052-1",
        gabc: "e-(gj)ter(h) and(fg) S,(g) ;-(d) (d)  (dg)  (d) Raa(fdfdfidf)  (dd) \u201Ctogether(jdf)  (ffk)  (fddfj) in-(d) (d)  (j) to(j) the(hj) temple(j)  (i)  at(j) the(j) .(jkj) hour,(fhj)  (ji)  (d) &gt;(ffd) e(djdfddfhdfijfcfhf) \u2014\u2014(fdffjfdhfdffdddhifd~dd) prayer.(dg)  (g) I/(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-052.png",
        nextFileName: "./pages/part-b-053.png"
    },
    {
        title: "part-b-053-0",
        gabc: "S(ighj) il\u2014verT(i) and(i) gold(hj) have(i) I(hih) none;(h)  (hg) but(h) such(gf) as(fgh) I(g) hLave,(e)  give(hf) I(gf) thee.(e) reremie(i)  (j) e(i) e(h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-053.png",
        nextFileName: "./pages/part-b-054.png"
    },
    {
        title: "part-b-053-1",
        gabc: "The(h) Angel(h)  (f) said(h) un-(h)to(g) Peter,!(e) Cast(e) thy(h) [(ig) garment(ij) a-(i)bout(hg)  a-(e)and(f) follow(hf)  (gf) me.(e) e(h)  (f) il(h)  (i) e(h) ",
        groupIndex: 1,
        filename: "./pages/part-b-053.png",
        nextFileName: "./pages/part-b-054.png"
    },
    {
        title: "part-b-053-2",
        gabc: "he(e) Lord(g) hath(h) sent(i) his(hf) Angel,Tand(h)  (g)  (h) hath(g) de-(h)liv-(chj)er-(i)ed(h)  (c)  me(h) out(f) of(h) :(g) hand(f) s(e) Herod,(f) i(ed) al-(fgh)(&quot;(hgfefgf) lu-(e)ia.(e) |7(iji)  (hgf) ",
        groupIndex: 2,
        filename: "./pages/part-b-053.png",
        nextFileName: "./pages/part-b-054.png"
    },
    {
        title: "part-b-053-3",
        gabc: "3(ig) art(j) a(i) Peter,T(i) a(i) up-(g)g(h) this(g) rock(e) I(h) will(h) huild(fh) ](g)  Q.(e) Church,(j)  (j)  (i)  (h)  (gh) ",
        groupIndex: 3,
        filename: "./pages/part-b-053.png",
        nextFileName: "./pages/part-b-054.png"
    },
    {
        title: "part-b-054-0",
        gabc: "[(ffe)  (dc)  (dfd)  (e)  (e)  (f)  (dc) ](fe)  (fgf) 8.(d)  (ce)  (e)  (g)   (h)  (j)  (h)  (gfe)  (f)  (dc)  (fe)  (fgf)  (d)  (ce)  (e)  (edc)  (d)  [(dfd)  (e)  (e) ](g)  (f)  (dc) [(df)  (fe)  (de) B(e) -(ed)[}(c)  (cd)  ANTIPHON(de)  (d)  (f)  (gh)  (gh)  (fg) ON(fe)  (de) BENEDICTUS(e)  hat-(h)so-(fg) (g) ev-(g)thou(g) a(e) -(fg)on(ef) s(d) shall(f) be(g) N(hj)  er(j)  in(hi) hea-(g)ven:(g) and(j) what-(j)so-(jh)ev-(jk)er(k) thou(ji) shalt(g) loose(h) on(g)  earth(fh) shall(jjkg) be(g) loos-(h)ed(ge) in(fg) hea-(ef)ven:(d) \u2018saith(h) the(h) Lord(hj)  un-(h)to(h) Si-(hi)mon(h) Pe-(g)ter.(g) PrT(j)  (i) |(j) -(h)I(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-054.png",
        nextFileName: "./pages/part-b-055.png"
    },
    {
        title: "part-b-055-0",
        gabc: "&#39;T\u2018;_da\xa7TSi\u2014mon(c)  (cd)  (def) Pe-(fe) (de) ter(dc) ascended(f)  (gh)  (hih) the(fg) gibbet(hh)  (f) of(g) the(fe)  cHbss,(i)  (dc) al-(dg)le(fe) \u2014lu-(d)ia:(d) t8-(cd)day(dhi) the(h) Key-(h)bearer(h)  (g) of(g) the(f)  joyfully(gh)  (hih)  (de)  (d)  (d)  (f) to(f)  (fe)  (de)  (ddc) Paul(c)  (dcd)  (f) lie(fe)  A\u2014postle,(de)  (dc) -(c)the(d) light(f) of(g) the(e) whole(fe) world,(d) bowed(dhi)  (hg) down(h)  his(ji) head;(h) and(h) for(h) the(f) Name(g) of(fe) C(dc) received(cd)  (f)  (f) the(ef)  .(ik) crown(h) of(g)  (f) martyrdom,(fe) T(c) al-(d)le-(efe)lu-(d)ia.(d) e(h) =(g) |(f)  (g) B(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-055.png",
        nextFileName: "./pages/part-b-056.png"
    },
    {
        title: "part-b-056-0",
        gabc: "Who(e) is(gi) this?(hg) that(f) cometh(e)  (f) from(h) E-(f)dom,(g) with(e) dyeq(g) gar-(ih) ments(g)  (ij) from(ih) Bozrah(g)  (g) this(i) that(h) .(f) glorious(g) =(f)  (e) in(f) hijs(fh)  a:(gi)  (g)  (e) A(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-056.png",
        nextFileName: "./pages/part-b-057.png"
    },
    {
        title: "part-b-056-1",
        gabc: "I(jkkj) Tthat(j) speak(ji) in(h)  (ji) righteousness,(g)  (g) mighity(hijh) =(i) to(h) save.(g)   (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-b-056.png",
        nextFileName: "./pages/part-b-057.png"
    },
    {
        title: "part-b-056-2",
        gabc: "H(c)  (c) C(e) was(f) *(hi) clothed(i) with(h) a(i) vesture(ji)  (h) dipped(j) a(i) in(h) blood:(i) 3(f)  h1\xa7(i) Name(h) is(g) =(fe) CRlCPar(fe) the(fd) 1o,(cdedfdfhdfhhd~) o(dfdfh) of(f) o(hf) e(i)  (fh) D(i)  (d)  (j) |(h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-056.png",
        nextFileName: "./pages/part-b-057.png"
    },
    {
        title: "part-b-057-0",
        gabc: "-(c) (c)  (hg)  (e) tart(fh) thou(h) red(i) in(h) thine(ij) ap-(i)pa-(h)rel,(h) and(i) thy(h)  garments(ig~)  (gh)  (f) like(df) him(h) that(e) treadeth(fe)  (cd) in(ef) the(f) wine-(e)fat?(e)  SHORT(h)  (f)  (h)  (i)  (h)  hou(f) hast(f) redeemed(f)  (g)  (f) us,(f) O(fgh) Lord,*(hg) By(gfd) thy(fg) Blood.(gf)  (i) Thou(f)  hast(ki~)  (f) redeemed.(f)  (g)  (f) \xa5.(c) Out(h) of(h) ev-(h)ery(h) kindred,(hi)  (h) and(gh) tongue,(g)  and(g) people,(h)  (g) and(f) nation.(gh)  (fhg) By(gfd) thy(fg) Blood.(fgf) K.(c) Glory(h) v(h) be.(h)  Thou(f) hast(f) redeemed.(f)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-057.png",
        nextFileName: "./pages/part-b-058.png"
    },
    {
        title: "part-b-057-1",
        gabc: "a(g)  (e)  (f)  (d)  (g)  (g)  (j)  (gh)  (g)  (fedg)  (g)  (fg)  (g)  (g)  (dhg)  P(hiji) RS(h)  (gh)  (h) G(j)  (h) n(g) e(fe) &quot;(fg) m(g) .-(g)[(g) e(gji)  (jk) .(k) e(jk) e(k)  P(k) e(k)  (ji) RS(h) T(g) T(fg) [l(g) T(efgh)  (g) T(g) R(fe) e(d) =(g) B(g) o(fg) L(g) |(fh) ",
        groupIndex: 1,
        filename: "./pages/part-b-057.png",
        nextFileName: "./pages/part-b-058.png"
    },
    {
        title: "part-b-058-0",
        gabc: "But(c)  (g) ye(gj) are(hg) come(h) un-(h)to(g) mount(hi) Si-(ij)on(i) and(ji) un-(h)to(i) the(j)  ci-(k)ty(k) of(j) the(j) living(i)  (jk) God,(kh) the(h) heavenly(i)  (j) Je-(k) (j) ru-(hj)sa-(i)le,(i)  and(h) to(g) Je-(hi)sus,(fh) the(gh) me-(j)di-(ji)a-(h)tor(g) of(h) the(g) new(fe) CO-(fg)Ve-(g)nant,(g)  and(ki~)  (g) to(hi) the(g) Blood(g) of(h) a(fe) .(d) that(e) speaketh(f)  (d) a(e) better(f)  =(gh) than(gf) that(gh) of(gf) A-(e)bel.(e) e(j)  (h) R(j) |(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-058.png",
        nextFileName: "./pages/part-b-059.png"
    },
    {
        title: "part-b-058-1",
        gabc: "What(dd) are(c) f(d) which(f) are(fe) ar-(de)ray(d) ed(cd) in(fe) white(fgh) robes:(h)  (d)  ~and(efg) whence(dfe) came(dfd)  (dd) they?(dd)  (fd)  (f) :(fdhdfghdfddhfdgdddfd) -(hdfgh) (fdddg)  (dfd)  (fddff) ",
        groupIndex: 1,
        filename: "./pages/part-b-058.png",
        nextFileName: "./pages/part-b-059.png"
    },
    {
        title: "part-b-059-0",
        gabc: "T\u2019:[\u2018@lgsae(dh) are(hj) theyT(h) which(h) came(hg) out(fe) of(fg) great(g) tri-(f)bu-(e)la-(df)tion,(fc)  and(c) have(d) washed(ffg)  (f) their(ef) robes(gh) in(e) the(f) Blood(g) of(e) the(fe) Lamb.(d) |(de)   (h)  (g)  (f)  (gh)  (fgh) ",
        groupIndex: 0,
        filename: "./pages/part-b-059.png",
        nextFileName: "./pages/part-b-060.png"
    },
    {
        title: "part-b-059-1",
        gabc: "T(fg) [P(gf) tare(gh) they(f) before(e)  (f) the(gh) throne(hi) of(h) God,(h)  (gf) and(gh)  (f)  F,(jk)  serve(f) him(e) day(d) and(de) night(c) in(gf) his(gh) temple.(f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-059.png",
        nextFileName: "./pages/part-b-060.png"
    },
    {
        title: "part-b-059-2",
        gabc: "=(e) =(ei)  (i) e(hg) came(g) the(h) a(fihij) [E(i) Tby(h) the(j) Blood(kji) of(h) the(ij)  -(i)and(g) by(ij) the(i) word(h) of(f) their(h) tes(cdgfe) T(fgf) mo-(e)ny.(e)   (i)  (j)  (i)  (h)  (gi)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-b-059.png",
        nextFileName: "./pages/part-b-060.png"
    },
    {
        title: "part-b-060-0",
        gabc: "Blessed(h)  (fg) Tare(fh) they(hg) which(h) have(j) washed(ji)  (h) their(g) pope,(ghg) &amp;(h)  the(j) Plood(jih) of(i) the(hi) Lamb.(g)  (j)  (i)  (j)  (h) |(fgh) ",
        groupIndex: 0,
        filename: "./pages/part-b-060.png",
        nextFileName: "./pages/part-b-061.png"
    },
    {
        title: "part-b-060-1",
        gabc: "Christ(f) loved(g)  (f) us,(f) and(f) washed(g)  (gh) us(hg) In(fgh) his(gfd) own(gf~) Blood,(gf)  Christ(ki~)  (f) loved(g)  (f) us.(f) V.(c) And(h) hath(h) made(hi) us(h) kings(gh) and(g) priests(g)  un-(g)to(g) God(h) and(g) his(f) Father.(gh) |(hg) In(fgh) his(gfd) own(fg) Blood.(gf)  v(c) Glory(h)  (h) be.(h) Christ(f) loved(g)  (f) us.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-060.png",
        nextFileName: "./pages/part-b-061.png"
    },
    {
        title: "part-b-060-2",
        gabc: ";(ded)  (g)  (hj) e(jji)  (hg)  (hi) e(hg)  (g) S(g)  e(j) |(ji)  (hg)  &quot;(h)  (gf)  (e)  &quot;(h)  (gf)  (ded) [(dh)  (h) T(g) Wi(h) B(ji) R(hg) )(hi)  (hg)  (g)  O(h)  O(h)  (h)  (g) F(fe) o(d) &amp;(efg) fa(fe) e(e) ||(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-060.png",
        nextFileName: "./pages/part-b-061.png"
    },
    {
        title: "part-b-061-0",
        gabc: "he(gh) Blood(j) of(i) the(hg) Lamb(g) shall(f) be(g) to(h) you(g) for(h) a(j) token,(jg)  (g)  saith(g) the(fe) Lord;(e) and(j) when(j) I(k) see(ij) the(h) Blood,(ghg) I(g) will(g) pass(i)  o-(ik) (g) ver(h) you,(hg) and(fe) the(d) plague(e) shall(f) not(fh) be(h) up-(gf)on(fh) you(h) to(hig)  |(ik)  (gf) i(e) R(e) s(j) e(h) i(j) e(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-061.png",
        nextFileName: "./pages/part-b-062.png"
    },
    {
        title: "part-b-061-1",
        gabc: "nd(d) this(d)  (dc) shall(f) be(g) un-(f)to(h) you(h) for(h) a(gf) me-(eg)mo-(fe)ri-(d)al;(d)  (f)  and(hih) ye(g) shall(h) keep(jk) it(j) a(ih) feast(h) to(ih) the(fhji) Lord(fgh) throughout(h) a(g) your(f)  N(e) ne-(dg)3(gf) .(f) tions(j) by(d) an(e)  (fg) ordinance(dcd)  (e) for(fe) ever.(d)  (d) =~(h) &amp;(g) o(f)  (gh) \xbb(dfgf) ",
        groupIndex: 1,
        filename: "./pages/part-b-061.png",
        nextFileName: "./pages/part-b-062.png"
    },
    {
        title: "part-b-062-0",
        gabc: ".(ik) Blessed(c)  (gj)  (h) art(g) thou,T(h) 0(gf) Ma-(gh)ry,(gh) for(g) thou(gf) hast(g) .(h) believeg.(hj)  (jkj)  and(h) there(i) shall(j) be(h) a(h) a(g) performance(h) [(g) in(fg) R(g) of(gh) those(fe)  things(d) which(e) were(f) told(hg) thee(h) from(g) the(fg) Lord,(gfd) &amp;l(f) -(fg) lu-(ik) (g) ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-062.png",
        nextFileName: "./pages/part-b-063.png"
    },
    {
        title: "part-b-062-1",
        gabc: "a(e) ry(gg) arose,&#39;T(h)  (i) and(i) went(ij) in-(h)to(f) the(h) \u2014(gh) country(ihf)  (g) with(f)  -(e)in-(e)to(d) a(f) ci-(dhdd)ty.(f) of(gdf) Ju-(e)da.(e)  (h)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-062.png",
        nextFileName: "./pages/part-b-063.png"
    },
    {
        title: "part-b-063-0",
        gabc: "Ma-(hgi) (c)  (f)  (ef) ry(fe) en(fghf) ter-(ef)\u2014ed(f) in-(f)to(f) the(fgh) house(i) of(i) Zacha(i)  (h)  ri-(ij)as,(j) and(hj) sa-(hi)lu-(hg)ted(fec) E-(ef) (h) li-(g)sabeth.(f) S(h)  (g) mcie(e) e(f) ||(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-063.png",
        nextFileName: "./pages/part-b-064.png"
    },
    {
        title: "part-b-063-1",
        gabc: "hen(e)  (ed) E\u2018\u2014li\u2014sa\u2014beth(g)  (hj)  (ij) heard(j) Tthe(j) sa-(k)lu-(j)ta-(k)tion(ji) of(hi) Ma-(h)ry,(g)  the(g) babe(cdfe) leaped(f)  (gh) in(j) her(i) womb,(hg)  (g) and(h) she(ij) was(k) filled(ji)  (hg) with(h)  the(gf) Ho-(g)ly(f) Ghost,(ef) &quot;(g) al-(defgf)lu-(e)ia.(e) [l(h)  (ji) T(hi)  (h) s(gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-063.png",
        nextFileName: "./pages/part-b-064.png"
    },
    {
        title: "part-b-063-2",
        gabc: "Blessed(e)  (g) art(h) thou(i) T(gg) among(h) women,(j)  (i) and(j) blessed(defhg)  (ef) is(d) the(f)  fruit(h) of(dhf) N(gf) ToE(e) e(i)  (j) e(i)  (h) L(dfgf) ",
        groupIndex: 2,
        filename: "./pages/part-b-063.png",
        nextFileName: "./pages/part-b-064.png"
    },
    {
        title: "part-b-064-0",
        gabc: ".(d) lo,(f) as(fg) soon(g) |(g) \u2018agsthe(g) 3(g) of(g) thy(f) e(gh)  (h)  (g)  (g)  sounded(d)  (f) in(e) mine(df) ears,(df) the(cd) babe(ffd) leaped(fh)  (g) in(h) my(gf) yop}(ghg) i(fe)  ](dc) al-(d)le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh) |(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-064.png",
        nextFileName: "./pages/part-b-065.png"
    },
    {
        title: "part-b-064-1",
        gabc: "W(ikcc) hen(gd) E(fg) li-(gh)sa-(g)beth(g) Theard(h) the(g) a(g) sa~-(f)lu~ta-(gh)tion(h) of(hji) Ma-(g)ty,(g)  she(ij) spake(k) out(k) with(k) a(k) loud(jh) voice,(j) and(kj) said:(i) Whence(j) is(hg)  this(ik)  (h) to(i) me,(ihg) that(g) the(hj) mother(j)  (g) of(h) my(gf) Lord(g) should(gh) cor(f)  -(e)Y(d) al-(f)le-(fgh)lu-(g)ia,(g) m}__!(j) i(i) S|(j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-064.png",
        nextFileName: "./pages/part-b-065.png"
    },
    {
        title: "part-b-064-2",
        gabc: "Au(gj)  (h) generations(g)  (h) ;(g) Tshall(dfdfg)  (df) call(ffg) -(ff) (dfghdd)  (d) blessed:(f)  (f) for(fg) God(h) hath(g) r\xe9-(df)",
        groupIndex: 2,
        filename: "./pages/part-b-064.png",
        nextFileName: "./pages/part-b-065.png"
    },
    {
        title: "part-b-065-0",
        gabc: "garded(ik)  (g)  (h) the(h) lowliness(jk)  (j)  (jijkj) of(h) his(h) handmaiden,al-(j) (g) le-(gh)lu-(i) (h) ia.(g)  (g)  WITHIN(j)  (i)  (j)  (h) L)(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-065.png",
        nextFileName: "./pages/part-b-066.png"
    },
    {
        title: "part-b-065-1",
        gabc: "(G(f) lorious(g) princes(fgi)  (i) T(i) ver(h) all(g) the(h) earth,(hgf) as(f) in(i) life(i)  they(i) loved(i)  (i) one(i) an-(ih)o-(h)ther,(h) so(hjkj) e-(j)ven(ih) in(h) deat(hgefddc)  they(fhi) were(gf) not(h) S(gh) divided.(f) e(f) e(h)  (f) o(gh) T(g) i(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-065.png",
        nextFileName: "./pages/part-b-066.png"
    },
    {
        title: "part-b-065-2",
        gabc: "Pe-(eh)ter(f) L](e)  (d) Apostle(ef) a(e) a(e) ](g) the(h) a(i) Doctor(h) of(h) the(f) Gen-(h) =(g) these(i) ;(h) taught(iji) [(hghih) thy(fe) o(fhf) P,(gf) i(e) )(h) N(g) vl(h)  (f) |(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-065.png",
        nextFileName: "./pages/part-b-066.png"
    },
    {
        title: "part-b-066-0",
        gabc: "L(ki~) \xa2(d) a(dc) the(d) .(f)  (e) mltichie(dc) Tof(e) the(f) faichbul(g)  (ed) ss(efe) T(d) Tt(d)  \u2018the(dh) glory(hi)  (h) of(g) the(g) gracious(gh)  (h) Father(cd)  (d) Ben-(fgf)le-(dc)dict:(d) and(dhi)  chiefly(ik)  (h) =(fh) let(h) the(h)  (hg) a(fe)  (dc) of(cd) monks(fgh) be(fe) joyful,(fgf)  (d) ce-(h)le-(j) brating(i)  (ji)  (hg) his(g) So-(h)lem-(jk)ni-(ih)ty(j) on(ij) earth,(h) in(h) whose(hg) A(fe) oodly(fg)  fellowship(e)  (efe)  (dc) the(d) Saints(d) rejoice(fe)  (fgf) in(ced) heaven.(ef)  (d)  (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-066.png",
        nextFileName: "./pages/part-b-067.png"
    },
    {
        title: "part-b-066-1",
        gabc: "Be-(i) (d)  (dc) the(f)  (g) man(f) of(gh) God,t(h) made(igi) the(hgf) sign(fh) of(f) the(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-066.png",
        nextFileName: "./pages/part-b-067.png"
    },
    {
        title: "part-b-067-0",
        gabc: ":(d) and(gd) that(g) poison-(g) (f) laden(g)  (h) vessel(gf)  (f) was(h) so(gf) broken(h)  (hghih) as(h)  though(g) the(fe) sign(f) had(fg) been(g) a(f) stone(f) thrown(g) against(fe)  (d) it.(d)  (e)  (hg) BT(fhgf) ",
        groupIndex: 0,
        filename: "./pages/part-b-067.png",
        nextFileName: "./pages/part-b-068.png"
    },
    {
        title: "part-b-067-1",
        gabc: "his(c)  (d)  (de) prayer(e) was(fe) o-(fe)-(d)ve:r,T(j) he(d) took(e) three(fh) stones(hg) and(fe)  (f)  laid(f) in(fg) their(f) T(e) and(hg)  (h) Almighty(i)  (hg) God(hi) brought(i)  (i)  forth(ij) |(hg) ](efh) [(hg) the(e) top(fed) of(ef) that(f) ](e) (i(e) e(h)  (g) D(h)  (f) DN(efed) ",
        groupIndex: 1,
        filename: "./pages/part-b-067.png",
        nextFileName: "./pages/part-b-068.png"
    },
    {
        title: "part-b-067-2",
        gabc: "T(c)  (ed) glorious(g)  (hj)  (j) JfConfessor(j)  (i)  (j) of(k) the(j) after(j)  (h) some(i) praying,(i)  (hg)  e(fd) to(e)  (fg) stone(h) his(gf) SR(de) )(e) R~(ef) 2(ed) 5(g) where\u2014(hj)  on(j) Anos(k) Ncient(ji) foe(h) \u2014\u2014\u2014(g) sat,(hj) was(hg) \u2014\u2018_I\u2014l\u2014l=.l(f) e(ghg) WS(e) W(e) 3(efghiji)  (hi) e(h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-067.png",
        nextFileName: "./pages/part-b-068.png"
    },
    {
        title: "part-b-068-0",
        gabc: "A(c)  (d) the(f) soul&#39;s(g) re-(ge) (fe) turning,(d) the(fe) little(g)  (h) ho-(g)dy(g) of(g) the(g)  stripling(f)  (h) trembled:(h)  (g) and(g) beneath(h)  (j) the(hg) eyes(e) of(f) al](g) (](e)  were(f) present,(e)  (d) appeared(f)  (gh) [(g) living.(e)  (e)  (h)  (g)  (h)  (ih)  (gef)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-068.png",
        nextFileName: "./pages/part-b-069.png"
    },
    {
        title: "part-b-068-1",
        gabc: "When(f) Placidus(hj)  (i)  (i) 1\u2019was(j) drawn(hgf) from(hg) the(h) water,(hi)  (i) he(ik) saw(j) up-(ih)on(j)  his(j) head(i) the(h) garment(h)  (f) of(h) the(h) Ab-(h)bot,(hgh) who(f) rescu-(h)ed(g)  (ef) hin(ed)  from(ef) the(f) 0(e) @(e)  (i)  (j)  (i) f(h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-068.png",
        nextFileName: "./pages/part-b-069.png"
    },
    {
        title: "part-b-068-2",
        gabc: "B(f)  (fe)  (d) \xbb(e)  (g) father(gh) and(fg) guide(g) of(f) ..(e) monks,(f) thou(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-068.png",
        nextFileName: "./pages/part-b-069.png"
    },
    {
        title: "part-b-069-0",
        gabc: "most(g) ho(hjhgf) 1y(h) Confessor(h)  (g)  (g) of(g) the(ghg) Lord,(e) in-(fe) (d) tercede(ggh) for(g)  us(d) all(g) and(g) for(g) our(g) sal-(ghg)va-(e)tion.(e)  (h) ](g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-069.png",
        nextFileName: "./pages/part-b-070.png"
    },
    {
        title: "part-b-069-1",
        gabc: "0(dfddc) thou(f) pattern(gh)  (h) of(h) life(g)  (f) celestial(gh) ,T(h) our(h) Teacher(h)  (fgf) and(g)  Leader(h)  (fgf) Be-(d)ne-(cd)dict,(d) whose(dc) spirit(f)  (gh) now(h) rejoices(h)  (jkj)  (h) with(h)  Christ(ik)  (gf) in(gf) the(d) heavens:(cd)  (d) preserve(h)  (hij) thy(gf) flock,(gh) kindly(k)  (h)  (hg)  Shepherd:(fgefd) R(d) R(k) S(hg) them(h) by(g) thy(f) ho-(d)e(cd) e(d) o(d) and(c)  o0(d) a(f) way(ffg) made(f) clear(gh) by(h) thee(gf) their(fh) guide,(h) make(h) them(d)  .(e) =(c) B(fghgfe) N(cd)  (d) e(d) e(h)  (h) e(g)  (f) [(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-069.png",
        nextFileName: "./pages/part-b-070.png"
    },
    {
        title: "part-b-070-0",
        gabc: "O(efg) ho-(ddc)ly(de) Ma-(e)1y,(e) help(gh) thou(hhg) the(ed) suf(efgfe) -(de)fering,(e) strenp.(dfhhg)  then(gf) the(d) faint-(ef)hearted,(de)  (e) omfort(cdde)  (dc) the(c) sor(efgfe) rowful;(de)  (e) pray(dfhhg)  for(gf)  (dc) peopl\xe9,(df)  (efed) entreat(d)  (dh) for(hih) the(gh) c]erg}.&#39;,(gf)  (ed) intercede(d)  (fh)  (h)  for(g) all(gf) womankind(dc)  (df)  (efed) vow-(fhhgf)ed(g) un-(gfe)to(de) God:(e) may(c) all(df) ac-(fd) knowledge(ef)  (g) the(g) help(gh) of(gf) thy(de) prayer,(dd)  (c) who(cd) ce-(fe)le-(fg)brate(gh)  thy(g) solemn(gh)  (g) Commem-(gf)o-(g) (ghg) ra-(e)tion.(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-070.png",
        nextFileName: "./pages/part-b-071.png"
    },
    {
        title: "part-b-070-1",
        gabc: "hine(f) head(g) up-(f)on(fgi) thee(i) is(dhi) like(d)  (gf) Carmel:(gh)  (f) and(f) the(gi) heif(hi) ",
        groupIndex: 1,
        filename: "./pages/part-b-070.png",
        nextFileName: "./pages/part-b-071.png"
    },
    {
        title: "part-b-071-0",
        gabc: "thine(i) head(gh) is(jk) as(j) royal(ih)  (gh) purpl(gf)  (efddc) &quot;bound(f) in(gi) tresses,(hi)  (gfe)  \u2018(ge~) of(j)  al(g) le(gh) =lu-(f)ia.(f)  (h)  (f)  (h)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-071.png",
        nextFileName: "./pages/part-b-072.png"
    },
    {
        title: "part-b-071-1",
        gabc: "The(g) glory(gj)  (h) of(gf) Le-(gh)ba-(h)nonT(g) shall(h) be(g) given(f)  (h) un-(jjk)to(j) her,(j)  the(j)  (k) excellency(j)  (i) of(h)  (h) Carmel(j)  (i) and(g) Sharon,(h)  (gf) al-(gh)le-(h)lu-(g)ia.(g)  [(j)  (i)  (j)  (h) 8(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-071.png",
        nextFileName: "./pages/part-b-072.png"
    },
    {
        title: "part-b-071-2",
        gabc: "0(cd) mer-(idhih)ci-(gf);(gh) T(hgg) whose(fg)  (hg) righteousness(fg) [(gg)  (c) not(d) been(f)  geed(gf)  (d)  (d)  (dc)  (fg) standeth(f)  (gh) fast,(h) and(h) whose(gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-071.png",
        nextFileName: "./pages/part-b-072.png"
    },
    {
        title: "part-b-072-0",
        gabc: "children,(fh)  (h) for(h) their(jk) gakes,(jihg) shall(gf) remain(fh)  (h) with(h) glory(fhge)  ev-(ffed) (cd) er!(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-072.png",
        nextFileName: "./pages/part-b-073.png"
    },
    {
        title: "part-b-072-1",
        gabc: "o(g) e(hi) e(ih) e(j)  (ih) S(g) S(h) TS(i) a(g)  (i) (L(g)  (h)  (e)  o(f)  (e) 5(d) EE=\u2014\u2014\u2014\u2014(g)  (i)  (h)  (j) T(k)  (j)  (ih)  (g)  \xa5.(hj) Mary(g) hath(h) chosen(f) that(gh)  (g) good(fe) part.(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-072.png",
        nextFileName: "./pages/part-b-073.png"
    },
    {
        title: "part-b-072-2",
        gabc: "A&quot;(c) wo-(efg) (g) manTin(f) the(gi) ci-(h)ty(g) which(f) was(h) a(ih) sinner,(g)  (g) wher(hi)  she(ij) knew(jijig) that(h) Je-(i)sus(hg) sat(h) at(g) meat(fg) in(f) the(g) house(fe) f(dc) ",
        groupIndex: 2,
        filename: "./pages/part-b-072.png",
        nextFileName: "./pages/part-b-073.png"
    },
    {
        title: "part-b-073-0",
        gabc: "Gi-(f)mon(g) the(ih) leper,(g)  (g) brought(cddcdfedcd) an(d) I(c) _a&#39;~la-(df)bas-(fgf)ter(fed) box(e) of(ded)  :(c) .(c) and(ce)  (gf) stood(g) behind(fg)  (cg) &amp;t(c) the(d) feet(f) of(g) Je-(ih)sus,(g) and(hghhj)  began(g)  (h) to(g) wash(fe) his(d) feet(f) with(g) tears,(ihg) and(hi) did(ij) wipe(jijig) them(g)  with(i) the(hg) hairs(hg) of(e) her(gf) head,(g) and(dc) kiiss(dcfd~edcd) \u2014_._-(cdc)his(df) feet,(fgffed)  and(ge~)  (ef)  (fg) anointed(gh)  (f) them(ed) .(e) the(ded) ointment.(c)  (c)  (g) I(h)  (g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-b-073.png",
        nextFileName: "./pages/part-b-074.png"
    },
    {
        title: "part-b-073-1",
        gabc: "therefore(c)  (c)  (f)  (g)  (fh)  (h) T(h) anointed(i)  (gf) the(g) feet(g) of(gh) Je-(f)sus,(f) and(g)  wi-(hi)ped(h) them(hi) with(ji) her(gh) hair,(h) and(h) the(jk) house(jih) was(fgh) fil-(hgf) |(ffddc) with(ff) the(fh) T8(hih) S(g) of(h) ST(fgh) -(f)ointment.(f) e(h)  (f)  (gh) e(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-073.png",
        nextFileName: "./pages/part-b-074.png"
    },
    {
        title: "part-b-074-0",
        gabc: "A(f) wo-(de)man(efe) Tin(d) the(f) ci-(f)ty,(e) which(d) was(ffgh) a(fg) sinner,(f)  (e) brought(g) i(hi)  a-(j)la-(i)bas-(h)ter(g) box(f) of(i) 4&quot;(gh) ointment,(e) and(e) stoodat(ef)  (f) the(e) Lord&#39;(fe)  feet,(d) and(ef) be-(de)gan(e) to(e) wash(f) his(ed) feet(f) with(h) tears,(hghih) and(h)  did(h) wipe(i) them(g) with(h) the(fe) hairs(fe) of(c) her(de) head.(e) I(h) I(g)  (h)  (f)  (ef) ",
        groupIndex: 0,
        filename: "./pages/part-b-074.png",
        nextFileName: "./pages/part-b-075.png"
    },
    {
        title: "part-b-074-1",
        gabc: "The(cc) )(e) Lord(gh) gave(ij) them(i) Tthe(g) blessing(h)  (fe) of(f) all(gh) 7(fh) nations,(g) and(i)  es-(h)tab-(hij)lish-(i)ed(hghih) his(fe) co-(f)ve-(f)nant(g) -(h)on(g) their(f) heads.(e)  Be(i)  (j) glad,(i)  (h) O(gf) rightous,(fh) ",
        groupIndex: 1,
        filename: "./pages/part-b-074.png",
        nextFileName: "./pages/part-b-075.png"
    },
    {
        title: "part-b-075-0",
        gabc: "a(e)  (ef)  (fe)  (dc)  (de) a(e)  (f)  (h)  (hg)  (fe)  (de)  (e)  \xae.(h)  (ij)  (j)  (ih)  (i)  (i)  (hfe) 26(fh)  (f) n(fe)  (dc)  (de)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-075.png",
        nextFileName: "./pages/part-b-076.png"
    },
    {
        title: "part-b-075-1",
        gabc: "An(e) -(g)ev-(h)er-(i)lasting(j) name(i) Twill(j) I(i) give(h) my(fh) =(gh) saith(fg) the(f) ..(e)  they(g) shall(g) obtain(h)  (fh) joy(g) and(f) gladness(f)  (h) for(g) ev-(e)er.(e) I(i)  (j)  (i) bl(h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-075.png",
        nextFileName: "./pages/part-b-076.png"
    },
    {
        title: "part-b-075-2",
        gabc: "The(d) i,(dd) 0(c) al-(d)so(dfddc) shall(f) give(g) thanks(h) un-(g)to(g) thy(ffg) Name,(f)  and(f) the(f) just(fg) shall(f) continue(f)  (f) .(ef)  (g)  (fe) sight.(d)  (d)  (h)  (gddf)  (gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-075.png",
        nextFileName: "./pages/part-b-076.png"
    },
    {
        title: "part-b-076-0",
        gabc: "[(g) will(g) give(h) my(h) Saints(gf) s(h) place(ji) and(h) a(j) name(i) in(h) tle(g) king(h)  dom(h) of(h) my(h) Father,(i)  (h) saith(g) the(fg) Lord.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-076.png",
        nextFileName: "./pages/part-b-077.png"
    },
    {
        title: "part-b-076-1",
        gabc: "O(dh) ve(hj) (e(hg) Spirits(h) and(f) ho-(g)ly(f) Souls(h) of(f) the(e) TR(d) righteous,(d) sing(fd)  d(ef) hymn(g) un-(f)to(fe) God,(dc) al-(d)n(efe) lu-(d)ia.(d) TR(h)  (g)  (f) e(gh)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-076.png",
        nextFileName: "./pages/part-b-077.png"
    },
    {
        title: "part-b-076-2",
        gabc: "T(c) he(f) peo(g) leTwill(fe)  (hg) tell(gf) of(e) the(e) wis-(ddc)dom(df) of(fe) the(de) Saints,(e)  and(g) the(hj) I(ji) congregation(gh)  (gf) will(efddc)  (gfg) shew(ghg) forth(ef) their(de) praise:(e)  Short(h)  (g) Respond,(h)  (ih)  (gfe) \xa5(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-076.png",
        nextFileName: "./pages/part-b-077.png"
    },
    {
        title: "part-b-077-0",
        gabc: "I(g) am(hi) the(ij) God(k) Tof(j) your(hg) fathers,(hi)  (h) saith(gh) the(h) Lord:(g) I(g)  have(ij)  (g) seen(j) the(h)  (hg) affliction(h)  (g) of(f) my(h) &quot;(e) a-(e)and(g) have(h)  heard(ik)  (jkj) their(j) cry;(h) and(h) I(j) am(i) come(j) to(hg) de(hgf) liv-(g)er(gf) th-(ef) al(ik)  (g) le(gf) -(e)1ia.(e) [(j)  (h) I\u2014_I(j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-077.png",
        nextFileName: "./pages/part-b-078.png"
    },
    {
        title: "part-b-077-1",
        gabc: "he(c)  (c)  (c)  (c) no-(cd)ble(d) stock(df) of(d) J\xe9sse(cd)  (d) hath(f) brought(gh) forth(hg) a(f)  (g)  Pleasant(g)  (fe) stem,(d) from(h) which(dgf) doth(gh) spring(higih) [(hgf) flower(g)  (fe) of(ccd)  Wondrous(f)  (efe) fragrance.(d)  (d)  (h)  (h)  (g) ;(f)  (gh)  (gfed) ",
        groupIndex: 1,
        filename: "./pages/part-b-077.png",
        nextFileName: "./pages/part-b-078.png"
    },
    {
        title: "part-b-078-0",
        gabc: "a(f)  (e) 8(d)  (cdf)  (f)  (e) e(f)  (g) a(fe) a(d)  (c) .(d)  (f) |(h)  (h)  (T(h)  (d)  (f)  (gh)  (g)  (fe)  (d)  (e)  (e)  (g)  (h) 1(j)  (j)  (jh)  (hj)  (fh)  et(ij)  (g)  (gf)  (e)  (fg)  (g)  (g)  (hi)  (h)  (gh)  (h)  (h) i(hj)  (g)  (ge)  (f)  (ed)  (e)  a(i)  (c)  (d) art(f)  (ef) Peter.(d)  (e)  (f)  (gh)  (gf)  (d) |(e)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-078.png",
        nextFileName: "./pages/part-b-079.png"
    },
    {
        title: "part-b-078-1",
        gabc: "He-(gj)rod(h) the(g) king(h) t(g) proceeded(g)  (g) further(h)  (g) to(h) take(gf) Pe-(g)ter(gh)  al-(jk) (jk)  al-(f)so:(f) and(f) when(g) he(f) had(f)  (d) 384(dg) apprehended(h)  (dikj) him,(j)  (jijkj) B(hg)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-078.png",
        nextFileName: "./pages/part-b-079.png"
    },
    {
        title: "part-b-079-0",
        gabc: "him(j) in(i) prison,(g)  (g) a(g) intending(eg)  (g) after(e)  (g) Easter(fe)  (f) to(d) bring(e) him(fg)  forth(gf) to(h) the(ih) people.(g)  (g) [ees(j) Neats(i)  (j) e(h) s(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-079.png",
        nextFileName: "./pages/part-b-080.png"
    },
    {
        title: "part-b-079-1",
        gabc: "e-(f)ter(g) therefore(fgh)  (g) Twas(ef) kept(g) in(f) prison;(d)  (d) but(d) prayer(d)  was(ik)  (f) made(dc) without(f)  (g) ceasing(fh)  (h) of(h) the(g) Church(hg) to(f) God(g)  him.(fe)  (d)  (h)  (g)  (f)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-079.png",
        nextFileName: "./pages/part-b-080.png"
    },
    {
        title: "part-b-080-0",
        gabc: "L-(cdf)oo\u2014sen(f) these(f) earthly(fe)  (de) %\uFB01(edc) tat(c)  (d) the(c)  (d) command(e) of(f)  God,(gf) O(de) Peter;(e)  (e) and(dhi) let(h) the(gf) king-(g)dom(ghg) of(fe) heaven(df)  (f)  be(efgfe) o(de) pen-(dc)ed(c) un-(fg)to(gh) the(gf) blessed.(e)  (e) B(h)  (g)  (h)  (ji)  (hg) !(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-080.png",
        nextFileName: "./pages/part-b-081.png"
    },
    {
        title: "part-b-080-1",
        gabc: "=5(ikc) Thou(f) hast(f) crowned(g)  (f) him(f) with(f) glory(f)  (f) and(f) honour,(f) a(e) O(g) Lord,*(h)  Al-(ik) (h) le(hg) lu-(g)ia,(f) al-(d)le-(fg)lu-(dgf)ia.(f) Thou(f) hast(f) crowned.(g)  (f) \xa71.And(c)  (f)  madest(ki~)  (f)  (f) him(f) to(f) have(f) dominion(f)  (g)  (f) of(f) the(f) works(f) a(e) thy(g) bands(h)  B.(ik) Al-(h)le-(hg)lu-(g)ia.(f) \xa5,(h) Glory(f)  (f) be(f) to(f) the(e) Father(g)  (h) and(h) t0*(hi)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-080.png",
        nextFileName: "./pages/part-b-081.png"
    },
    {
        title: "part-b-081-0",
        gabc: "Son,(h) and(h) to(h) the(g) Ho-(h)ly(g) Ghost.(gf) Thou(f) hast(f) crowned.(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-081.png",
        nextFileName: "./pages/part-b-082.png"
    },
    {
        title: "part-b-081-1",
        gabc: "-(f) (egh)  (g)  (fd)  (f)  (efg)  (f) __.:_.&#39;-(e) (g)  (hj)  (h) :_(gf)  (g)  (g)  (f) i(ed)  V.(cd) n(d)  (dc)  (d) LI(fe)  (de) R(e) R(e) e(g) T(gh) ](g) P(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-081.png",
        nextFileName: "./pages/part-b-082.png"
    },
    {
        title: "part-b-081-2",
        gabc: "Christ(cd) a(cdf) sus,t(f) the(e) brightness(d)  (ef) of(g) the(gh) Fa-(gfe)-(e)and(d) a(c) ex-(d) Press(f) im-(fe)age(d) of(e) his(dc) person,(de) e(e) who(dg)  (g) upholdeth(h)  (gh) N(ij) allthings(gh) by(h)  the(g) word(g) of(gf) his(de) =(edc) w-(c)e.r.:,while(d) heRwes(c)  (d) by(f) himself(d)  (ef) purging(g) L(g)  (e)  Y@y(fe) our(de) sing,(e) vouchsafed(dh)  (hi) on(h)  (h) this(h) day(gf) shew(dc)  (df) himsel(f)  (e)  &#39;(ik)  (f) glo(gfgh) O(hg) up-(g)i(h) ey(ffg) y(ghg) oo(e) |(e)  (h) )(g)  (h) [(ji) |(hg) Pl(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-081.png",
        nextFileName: "./pages/part-b-082.png"
    },
    {
        title: "part-b-082-0",
        gabc: "Je\u2014sus(ki~)  (c)  (c)  (d) takethT(dh)  (ihi) Pe-(h)ter,(ghg) James,(f) and(e) John(fg) his(fe) brother,(d)  (d)  and(ik)  (dhi)  (h) I:\u2014&#39;-(h)them(g) up(h) in-(h)to(j) an(i) high(jk) mountain(k)  (ji) \xe9-(g)part,(ijh)  and(h) was(h) .(gf) transfigured(g)  (fe) before(dc)  (f)  (d) them.(d)  (h) S(g)  (f) S(gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-082.png",
        nextFileName: "./pages/part-b-083.png"
    },
    {
        title: "part-b-082-1",
        gabc: "His(c)  (g) face(gj) did(h) shineT(gf) as(g) the(h) sun,(f) and(f) his(h) raiment(jk)  (jijkj) Wes(i)  white(j) as(hg) the(hg) light,(ef) al-(hg)le-(h)lu-(g)ia.(g) _ld(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-082.png",
        nextFileName: "./pages/part-b-083.png"
    },
    {
        title: "part-b-082-2",
        gabc: "Wl(f) ,b.e\u2018}\u201C?.ld,t(fe) =iy(de) \u2018there(d) TRV(c) AL(de) BT(ed) 5(e) &amp;3(fed) them(e) Mo-(ghj)ses(h) &amp;(gh)  E-(dfe) (d) li-(dfg)as,(g)  (fddf) talking(f)  (fd)  (fd) with(fd) Je-(cde)sus.(dddedhd)  (dg)  (hd)  (dih)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-082.png",
        nextFileName: "./pages/part-b-083.png"
    },
    {
        title: "part-b-083-0",
        gabc: "answered(c)  (fh)  (i)  (i)  (gf)  (h) Pe-(f)t.er,T(f) and(f) said(f) u.n-(c)to(df) .&#39;Je\u2014sus,(ffg)  (f) Lord,(hfgi)  it(hi) is(hg) good(hj) for(ih) us(fe) to(gh) bhe(gf) here.(f) IS(h) et(f)  (h) arrei(g) e(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-083.png",
        nextFileName: "./pages/part-b-084.png"
    },
    {
        title: "part-b-083-1",
        gabc: ";(cc) While(e) he(ghg) yet(hj) |l(hghihgg) A(e) |(gh) a(fe) bright(df) clioud(dc) o-(d)ver-(ef) skadowed(g)  (f)  (ghg) them.(e)  (h)  (g)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-b-083.png",
        nextFileName: "./pages/part-b-084.png"
    },
    {
        title: "part-b-083-2",
        gabc: "lori-(f) (f) ous(f) didst(f) thou(f) appear(f) SR(g) in(f) the(f) sight(f) of(e) Lord,*(h)  Al-(h) (hg) ]u-(g)ia,(f) SRS(d) le-(fg)lu-(gf)ia.(f) Glori-(f)R(f) ous.(f) |(f) V.(c) Because(f)  (f)  the(f) Lord(f) hath(f) a(g) -(f)thee(f) with(e) ma-(g)jes-(g)ty.(h) Al-(h)le-(hg) lu-(g)ia,(f) A(c) Glory(f)  (f) be.(f) Glori-(f) (f) ous.(f) ",
        groupIndex: 2,
        filename: "./pages/part-b-083.png",
        nextFileName: "./pages/part-b-084.png"
    },
    {
        title: "part-b-084-0",
        gabc: "l;ehold(c)  (c)  (e) a(fg) voice(g) Tout(gh) of(f) the(h) cloud,(hih) which(gf) sajq(g)  This(gi) is(h) my(jg) lov-(hihg)ed(h) Son,(hg) in(gh) whom(h) I(fg) am(g) wel](fd)  pleased;(fe)  (e) hear(gfd) ye(f) =(ef) al-(gf)le-(d)8(c) &amp;(c) W(g)  (h) e(g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-b-084.png",
        nextFileName: "./pages/part-b-085.png"
    },
    {
        title: "part-b-084-1",
        gabc: "And(i)  (c)  (h) when(fg) the(g)  (g) disciples(g)  (fh) heard(jjk) it,T(j) they(ji) fell(jk)  (hg) on(f) their(fh)  face,(ik)  (g) and(h) were(gf) sore(g) afraid:(fgh)  (f) and(fg) Je-(hj)sus(jk) came(hjig) and(h)  touch-(hij)ed(gj) them,(g) and(hg~) said,(fed) A-(fhg)rise,(fg) and(g) be(fh) not(j) 2~(hij)  fraid,(ik)  (hgf) al-(gh)1le(h) lu-(g)ia.(g) e(jdd) of(i) gt(j)  (h) (6|(fgh) ",
        groupIndex: 1,
        filename: "./pages/part-b-084.png",
        nextFileName: "./pages/part-b-085.png"
    },
    {
        title: "part-b-085-0",
        gabc: "[(gj) aurence(h) the(gf) i(h) Deacon(g) hath(ij) wrought(k) a(jh) pious(j)  (j) work;(i) who(k) by(k)  the(k) sign(j) of(j) the(k)  (k) Cross(jijkj)  (h) enlightened(h)  (g) the(h)  (ji) blind:(g) and(g)  &quot;(g) distributed(g) a(e) T(g) to(fgh) the(fe) poor(d) the(ef) Church\u2019s(gh) s(h)  (g) treasures.(g) e(j)  (i)  (j) e(h) |(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-085.png",
        nextFileName: "./pages/part-b-086.png"
    },
    {
        title: "part-b-085-1",
        gabc: "I,(d) a(e) hath(f) =(eg) entered(fg)  (ef) in,T(d) jnd(cd) as(f) a(g) Martyr(h)  (g) hath(g)  (c)  |(jk)  confessed(f)  (g) \xe9(gh) [(g) Name(h) of(g) the(fe) Lord(cd) Je-(d)sus(efe) Christ.(c)  (d) \u201C(f)   (h)  (g)  (f)  (fgh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-085.png",
        nextFileName: "./pages/part-b-086.png"
    },
    {
        title: "part-b-086-0",
        gabc: "L(fg) aurence(g) hath(g) wrought(h) a(gf) pious(gh)  (h) work;(g) who(g) a(e) the(g) i(g)  of(f) .(e) Cross(f) .(d)  (e) enlightened(f) the(fh)  (h) blind.(g) ](j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-086.png",
        nextFileName: "./pages/part-b-087.png"
    },
    {
        title: "part-b-086-1",
        gabc: "M(c)  (c) y(e) =(gh) cleaveth(f) 0(e) -(gh)un-(f)to(h) thee,(g) for-(i)as-(i)much(hf) as(h) my(h)  flesh(fgh) hath(f) been(e) burned(gh)  (f) for(e) thee,(gh) O(f) my(f) God.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-086.png",
        nextFileName: "./pages/part-b-087.png"
    },
    {
        title: "part-b-086-2",
        gabc: "he(gh) Lord(j) hath(i) sent(dhf) his(h) An-(h)gel,(g) and(h) [(g) de-(h)liv-(ij)er-(i)ed(h)  ;(jk)  me(h) out(h) of(g) the(h) midst(gf) of(e) the(f) :(ed)  (fh) and(fgh) I(fe) am(fg) notbume(f)  (e) d.(e)   (i)  (j)  (i)  (h)  (ih)  B(c)  (c) lessed(efh)  (fe) Laurence(f)  (ed) a4(ef)  (f) [(e) (B(e) a(fh)  (de)  (fd) ren(dhfhigdhij) -(dddfd)der(id) ",
        groupIndex: 2,
        filename: "./pages/part-b-086.png",
        nextFileName: "./pages/part-b-087.png"
    },
    {
        title: "part-b-087-0",
        gabc: "un-(i)to(i) thee,(hi) O(hg) Lord,(ef) who(d) hast(f) counted(h)  (g) me(f) worthy(hi)  (i) to(fh)  en-(gi) (i) ter(g) within(h)  (fh) thy(gf) gates.(e) (N(h) s(g)  (h)  (f) W](e) ",
        groupIndex: 0,
        filename: "./pages/part-b-087.png",
        nextFileName: "./pages/part-b-088.png"
    },
    {
        title: "part-b-087-1",
        gabc: "O&#39;n(c) the(d) i-(f)ron(ed) grate,T(d) 0(fg) God,(g) I(g) de-(f)ni-(g)ed(h) thee(h) not;(h)  and(hi) when(hg) fire(gg) [(g) kindled(h)  (fe) me,(d)  (d) 0(f) Christ,(f) I(df)  confessed(ef)  (d)  (c) th:a.e:(c) thou(c) hast(d) proved(f)  (f) my(fh) heart(g) and(f) hast(gh)  Vi-(i)si-(h)ted(gf) me(e) in(df) the(f) night(hg) season;(fg)  (f) thou(f) hast(g) tri-(hg) ed(f) a(e) with(fg) &quot;-(g)and(d) hast(f) f%nd(ddc) no(ef) 4(g) wickedness(fe)  (d) in(d) me.(d)  |(h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-087.png",
        nextFileName: "./pages/part-b-088.png"
    },
    {
        title: "part-b-088-0",
        gabc: "Blessed(eh) D(fed) L(ef) Laurence,T(e) when(e) laid(g) and(h) burning(i)  (h) on(g) the(h) i-(ij)1op(j)  &gt;(i) grating,(i) spake(g) to(i) the(i) im-(ji)pious(h) [~(hf) [(g) s(e) saying:(e)  The(gi)  (e) feast(fg) is(fe) ready,(f)  (ed) turn(e) and(ef) eat;(d) but(hhf) the(hi) Church\u2019s(j)  (ih)  treasures,(ig~)  (iji)  (hg) which(i) thou(iji) claimest,(h)  (h) have(h) been(h) garner&#39;d(hi)  (hg)  up(f) in(h) heaven,(hg)  (e) by(f) the(efed) hands(dhf~) of(gf) the(g) poor(ih) and(f)  needy,(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-088.png",
        nextFileName: "./pages/part-b-089.png"
    },
    {
        title: "part-b-089-0",
        gabc: "Ma-(fg)ry(f) is(f) taken(gh)  (f) up(fe) 1n-(dc)to(f) hea-(fghi)ven:*(h) The(hij) An(ihgfe) gels(gh)  triumph.(gf)  (f) Ma-(fg)ry(f) is(f) taken(gh)  (f) up.(fe) V.(c) Ex-(f) (gh) alting(f) and(f) bless-(fe) x.1g(dc) the(fg) Lord.(i) The(hij) An(ihgfe) gels.(gh)  (c) Glory(f)  (f) be.(g)  Ma-(fg)ry(f) is(f) taken(h)  (f) up.(fe) ",
        groupIndex: 0,
        filename: "./pages/part-b-089.png",
        nextFileName: "./pages/part-b-090.png"
    },
    {
        title: "part-b-089-1",
        gabc: "O(d) most(f) prudeint.(d)  (d)  (fh)  (h) go-(j) (h)  (ge)  (gh) est(fe) thou,(d)  (fh) shi-(c) ning(d) re-(d)splen-(dhihg)dent(gh) like(h) the(ge) glowing(g)  (ef) Daughter(f)  (g)  of(e) Si-(f)on,(d) thou(dc) art(f) all(gh) comely(hi)  (h) and(h) beautiful(j)  (h) ,(gh) fair(fh)  38(ghf) the(g) moon,(ghfd) clear(fg) as(c) the(ef)  (f) sun.(d)  (hfhdf)  (dh)  (g)  (f)  (gh)  (gf)  (hi) ",
        groupIndex: 1,
        filename: "./pages/part-b-089.png",
        nextFileName: "./pages/part-b-090.png"
    },
    {
        title: "part-b-090-0",
        gabc: "T(c) Ma-(c) (e) ry(e) is(e) taken(g)  (h) upt(i) in-(j)to(h) heaven:(ii)  (g) the(h) Angels(gh)  (ef) triug,(h) [(g)  exalting(gi)  (h)  (ij) s(i) and(h) blessing(fh) .(h) the(g) Lord.(e) IR(i) I(j)  (i) 7%(h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-090.png",
        nextFileName: "./pages/part-b-091.png"
    },
    {
        title: "part-b-090-1",
        gabc: "T(ik) be(g) Virgin(g)  (g) Ma(gfd) ](e) ry.&#39;::_is(f) taken(fh)  (h) up(g) in-(f)to(h) heavenly(k)  (j) chan-(h) (j)  S(ik)  (i) wherein(k)  (i) e(j) King(k) C(k) BN(jijkj) ST(h) sitteth(h) ](g) on(hij) a(h)  starry(ik)  (i)  (h) throne.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-090.png",
        nextFileName: "./pages/part-b-091.png"
    },
    {
        title: "part-b-090-2",
        gabc: "We(e) will(f) Tun(h) af-(h)ter(ij)  (i)  (i) of(i)  (h) the(i) savour(j)  (i) of(h)  We(cdc)  thine(ij) oint(fgh) NHMeNts:(f) ex(gihg) ceedingly(f)  (e) :(fe) -(d)=(ed) virgins(f)  (h) 1(f)  thee.(f)  (i)  (h) \uFB01(i)  (j)  (h)  (fh)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-b-090.png",
        nextFileName: "./pages/part-b-091.png"
    },
    {
        title: "part-b-091-0",
        gabc: "Blessed(c)  (c)  (hg)  (h) art(ihij) thou,T0(i)  (ij) daughter,(ih)  (hg) from(fi) the(h) Lord:(ef) for(ed) by(ef)  thee(gi)  (f) we(ii) have(e) partaken(f)  (hf) of(g)  (f) the(ed) fruit(ef) of(f) life.(e) e(j)  (i) S(h) )(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-091.png",
        nextFileName: "./pages/part-b-092.png"
    },
    {
        title: "part-b-091-1",
        gabc: "Thou(f) art(f) fair(h) and(hhi) comely,(g)  (h) O(f) daughter(h)  (g) of(h) Je-(f)ru-(g) (fe) salem:(def)  (f)  &quot;(c) art(d) ter-(f)ri-(fg)ble(g) as(f) an(gh) ar-(fe)my(dg) with(efe) banners.(d) et(d) |(f) S(h)  (g) =(f)  (g) ||(h) ",
        groupIndex: 1,
        filename: "./pages/part-b-091.png",
        nextFileName: "./pages/part-b-092.png"
    },
    {
        title: "part-b-091-2",
        gabc: "he(ik)  (c)  (f) Virgin(f)  (f) Ma\u2014ry(g)  (f) is(f) taken(g)  (gh) up*(hg) In-(f)to(h) heaven-(g) (fd) ly(fg) cham-(g) bers.(ik)  (f) The(f) Virgin(f)  (f) Ma-(g)ry.(f) \xa5.(c) Wherein(h)  (hi) the(h) King(gh) of(g) kings(g)  Sitteth(g)  (g) up-(g)on(h) a(g) starry(f)  (gh) throne.(dhg) In-(f)to.(gh) V.(cef) Glory(h)  (h) be.(h)  The(f) Virgin(f)  (f) Ma-(g)ry.(f) ",
        groupIndex: 2,
        filename: "./pages/part-b-091.png",
        nextFileName: "./pages/part-b-092.png"
    },
    {
        title: "part-b-092-0",
        gabc: "is(c)  (d) she(dhi) Tthat(hg) riseth(h) ey(ghg) up(ef) as(gh) the(fe) morning,(d)  (d) fair(ff)  \u2019(ik) as(d) the(f) moon,(ffd) -(fedc)clear(fgh) as(gf) the(ghg) sun,(f) and(fghgf) ter-(g)-(fg)h]e(d) o(g)  an(h) ar-(fe)my(cd) with(fe) B(d) banners?(d) e(h)  (g)  (f) e(gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-092.png",
        nextFileName: "./pages/part-b-093.png"
    },
    {
        title: "part-b-092-1",
        gabc: "On(ik)  (f) this(fg) .(g) dayTthe(hj) Vir-(ji)gin(gh) Ma-(h)ry(g) went(j) up(ji) in-(h)to(g) heaven(h)  (ghgf)  i(ik) rejoice,(fg)  (g) because(fg)  (g) she(h) T(j) reigneth(i) with(j) Christ(h) for(fgh) ev-(g)er(f)  .(ik) and(fh) ev-(g)er.(g) TR(j) e(i)  (j) e(h) Sl(ghg) ",
        groupIndex: 1,
        filename: "./pages/part-b-092.png",
        nextFileName: "./pages/part-b-093.png"
    },
    {
        title: "part-b-093-0",
        gabc: "Let(e) us(e) praise(eh) a(f) man(d) famous(ef)  (e) in(g) his(hg) gen-(f)e-(h)ra(gfe) tion,(e)  with(gi)  (f) whom(d) the(fh) Lord(hihf) es-(i)tab-(g)lish-(h)ed(i) the(h) blessing(ij)  (hg) of(fe)  all(fh) nations,(hhi)  (h) and(h) the(gh) cov-(f)e-(e)nant,(d) |(de) made(ef) it(f) rest(h)  ](gf) on(gh) his(g) head.(e) e(h) s(g) e(h) e(f) ose(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-093.png",
        nextFileName: "./pages/part-b-094.png"
    },
    {
        title: "part-b-093-1",
        gabc: "He-(c)rod(d) sent(dh) Tan(h) ex\u2014e-(h) (gf) cu-(gh)tion-(h)er,(h) and(f) commanded(g)  (hg) him(fe)  (d)  to(f) behead(f)  (ef) Jbhn(dc) in(d) the(dfe) prison:(c) .-(c)and(cd) when(df) his(f) .(d) =(dc)  Ples(fg) heard(f) of(h) it,(h) they(hjj) came,(hih) and(f) took(g) up(h) his(dgf) bo-(g)dy,(def)  (j)  and(ik)  (f) laid(f) it(ef) in(g) a(cdfe) tomh.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-093.png",
        nextFileName: "./pages/part-b-094.png"
    },
    {
        title: "part-b-094-0",
        gabc: "He-(c) (cg) rod(g) himself(h) T(j) had(h) sent(j) forth(i) Tand(g) laid(h) e(j) o(h) S(j)  John,(ki~)  (i) and(h) bound(g) him(h) in(h) prison(ih)  (g) for(g) He-(g)ro-(h)di(hf) ag\u2019(fg) seke,(e)  |(j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-094.png",
        nextFileName: "./pages/part-b-095.png"
    },
    {
        title: "part-b-094-1",
        gabc: "My(j) lord(hij) the(ji) king,t(g) give(j) me(i) in(h) a(g) charger(hgh) ..(e) the(ef) head(g)  of(h) John(g) the(gf) Baptist.(e)  (e) LAl(j) \u2018(h) pongiivia(j) Casagg(i) ",
        groupIndex: 1,
        filename: "./pages/part-b-094.png",
        nextFileName: "./pages/part-b-095.png"
    },
    {
        title: "part-b-094-2",
        gabc: "hen(d) the(dc) damsel(f)  (g) danced,(fgh)  (hgg) her(fg) mother(h)  (gf) bade(ggf) her:(d) Ask(g)  for(g) nothing(h) a(g) else(fgf) a(e) the(f) head(g) of(fe) John.(d) \u2014E-(h) (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-094.png",
        nextFileName: "./pages/part-b-095.png"
    },
    {
        title: "part-b-094-3",
        gabc: "olin(d) reproved(d)  (d) dt(d) He-(ff)L2(defedc~) for(f) [(gd) sake(h) ](fdg) He-(g)di(fd) ",
        groupIndex: 3,
        filename: "./pages/part-b-094.png",
        nextFileName: "./pages/part-b-095.png"
    },
    {
        title: "part-b-095-0",
        gabc: "4hom(h) he(fe) took(df) for(cd) wife(ffgf) from(f) his(fg) brother(e)  (fe) Philip.(d)  (d)   (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-095.png",
        nextFileName: "./pages/part-b-096.png"
    },
    {
        title: "part-b-095-1",
        gabc: "ive(f) me(ef) in(h) a(h)  (hj)  (i) head(i)  (h) of(i) John(j) the(ih) Baptist:(i)  (i)  (i)  and(i) the(i) -(fgi)was(g)  (h) exceeding(f) ](e) sorry(f) a(e) for(de) his(fh) oath\u2019s(f) sake.(f)  (e)  Antiphon(ig~)  (i)  (h) on(i) Benedictus,(j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-095.png",
        nextFileName: "./pages/part-b-096.png"
    },
    {
        title: "part-b-095-2",
        gabc: "The(ccc) ](e) L](eh) the(f) un-(fe)be-(d)liev-(ef)a(e) sent(e) his(g) de-(h)test-(i)a-(h)ble(fh)  (h)  2(h) =(g)  (h) and(i) commanded(i)  (h)  (iji) them(hghih) to(f) behead(f)  (fe) John(fh) the(g)  (e)  Baptist.(e)  (e)  (f)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-b-095.png",
        nextFileName: "./pages/part-b-096.png"
    },
    {
        title: "part-b-096-0",
        gabc: "et(c) us(d) ce-(fg)le-(fed)brate(d) the(d) wors(e) 1pful(cd)  (d) Na-(efe)ti-(d)vi-(d)ty(d) of(f)  the(g) blessed(h)  (f) and(g) glorious(f)  (e)  (dg) Virgin(e)  (f) Ma-(dd)r;&quot;:(c) for(d) ihe(dc) hath(f)  ob-(ki~) (g) T(fgh) ed(hgg) the(fg) dig-(h)ni-(g)ty(g) of(f)  (gh) Motherhood,(fed) O(d) and(dgfe) yet(de) lost(dd)  not(ki~)  (c) her(ef) maiden(gh)  (fe) pu-(d)ri-(d)ty.(d)  (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-096.png",
        nextFileName: "./pages/part-b-097.png"
    },
    {
        title: "part-b-096-1",
        gabc: "et(g) us(h) ce-(ghij) (j) lebrate(j) fthe(j) W,(j) worshipful(hj)  (i) Na-(h)ti-(g)vi-(gh)ty(h) of(g) the(h)  blessed(j)  (ji) and(kj) glo-(k)ri-(k)ous(j) Virgin(kj)  (k) Ma-(j)ry:(j) for(ji) she(jk) hat(k) !(j)  -(ik) (ji) tained(h) the(j) r(h) ni-(hg)ty(f) of(hi)  (h) Motherhood,(gh)  (h) and(h) yet(jh) 1ost(ggf) nob(d)  her(ik)  (ef) maiden(fgf)  (ghf) pu-(g)ri-(e)ty.(e) e(ji) |(hi)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-096.png",
        nextFileName: "./pages/part-b-097.png"
    },
    {
        title: "part-b-097-0",
        gabc: "\u2019The(cc)  (g) Na-(g)ti-(g)vi-(g)ty(gd) Tof(f) the(gh) glorious(g)  (g) Virgin(hi)  (gh) Ma-(gf)ry,(f) of(f) the(g)  seed(h) of(h) A(hiji) bra-(hg)ham,(g) sprung(hg) from(g) the(g) tribe(g) of(fefgf) Ju-(dc)da,(c)  5f(c) the(d) no-(dfgh)ble(gf) stem(hg) of(hi) David.(h)  (g) G(j) N(i)  (j) Y(h) e(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-097.png",
        nextFileName: "./pages/part-b-098.png"
    },
    {
        title: "part-b-097-1",
        gabc: "T(c)  (c) o-(i)day(i) is(g) the(i) Na-(j)ti-(i)vi-(hi)A(i) Tof(i) the(i) ho-(i)ly(g) \u2014\u2014\u2014\u2014_\u2014(h) Virgin(g) Ma-(e)ry,(e)  whose(h) glorious(h)  (f)  (h) life(g) il-(f)lu-(f)0(e) mineth(f) all(h) the(g) &quot;(e) e(e)  (jihgh) ",
        groupIndex: 1,
        filename: "./pages/part-b-097.png",
        nextFileName: "./pages/part-b-098.png"
    },
    {
        title: "part-b-097-2",
        gabc: "from(f)  (g) a(f) royal(g)  (f) race;\u2019(g) lo,(ghg) Ma-(f)ry(f) shineth(jifhihg)  (g) resplen\u2014(i)  (hgf)  dent:(ki~)  (f) by(f) g(f) \u2014(g) we(f) ask(fhihg) L(g)  (h) 6(g)  (f) that(f) ==(ff) may(efd)  b(cd)  (fg) a1ded(f) both(g) RN(dffg)  (g) e(ggh) s(f) s(f) [(hhh) o(g)  (h)  (f) (o,(hhh) i(f)  (gh) i)(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-097.png",
        nextFileName: "./pages/part-b-098.png"
    },
    {
        title: "part-b-098-0",
        gabc: "With(c)  (gfd) all(e) our(f) heart(gh) and(h) soul(g) let(g) us(g) sing(g) glory(h)  (g)  Christ(d)  (ef) on(c) this(d) ho-(fg)ly(g) so-(g)lem-(h)ni-(fg)ty(g) of(h) Ma(hji) -(kjh)IV,(ih) the(g)  ex-(g)alt-(hi)ed(g) Mother(hg)  (fe) of(fg) God.(g) =(j)  (i) \u201Ca(j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-098.png",
        nextFileName: "./pages/part-b-099.png"
    },
    {
        title: "part-b-098-1",
        gabc: "With(c)  (i) joy(i) and(g) gladness(ij)  (i) let(i) us(i) ce-(ij)le-(i)brate(i) the(i) Na-(i)ti-(i) vi-(i)ty(i) of(g) blessed(hi)  (hg) a(e) ry:(e) that(f) she(h) may(h) intercede(h)  (h)  (h) =(fh)  us(g) un-(f)a(e) Jesus(f)  (f) Christ(h) our(g) Lord.(e) holy(h) Virgin(i)  (j) -(i) (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-098.png",
        nextFileName: "./pages/part-b-099.png"
    },
    {
        title: "part-b-098-2",
        gabc: "T\xb0&#39;d\uFB02Y(g)  (gh) let(h) us(fhghf) ce-(gh)s(h) T(g) Twith(g) due(hgjh) so-(gf)lem-(fgh)ni-(h)ty(g) the(ji)  Na-(j)ti-(jk)vi-(j)ty(ji) of(h) God\u2019s(fji) Mother,(fhg)  (g) the(g) ev-(g)er(g) Virgin(hi)  (fgh) Har\xa5:(g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-098.png",
        nextFileName: "./pages/part-b-099.png"
    },
    {
        title: "part-b-099-0",
        gabc: "from(g) whom(g) the(g) Son(gh) of(g) the(f) High-(h) (ij) est(jijkj) proceeded,(j)  (hg)  (f) al-(hg)le-(h) lu-(g)1ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-099.png",
        nextFileName: "./pages/part-b-100.png"
    },
    {
        title: "part-b-099-1",
        gabc: "Thy(d)  (dc) ia\xe9\u2014ti\u2014vi-(f)ty,(gh) t(h) 0(h) Virgin(h)  (g) Mother(fe~)  (g) God,(fe)  (d) hath(d) pro-(f) \u2014e(d) joyful(f) L(g) ti-(fh)dings(hgfed) un-(f)to(g) all(e) the(fe) world:(d) for(h) out(h)  of(h) thee(h) hath(g) a-(f) (gh) ris\u2014en(h) the(h) Sun(h) of(gi)  (h) righteousness,(gh) (9(hgfed)  e-(f)ven(g) [(e) M(fe) o(d) who,(df) taking(dc)  (f) a-(g)way(f) the(gh) curse,(h)  hath(h) \xab(g) Best;weda(ef) [](g)  (fe) L(d) a:ld(c)  (d) confounding(ef)  (c) death,(d) hath(fed)  g(e) en(f) a(g) =(fh) us(hgfed) life(fg) K_-(e)ev-(fe)er-(d)lasting.(d) C_I\u2014_I(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-099.png",
        nextFileName: "./pages/part-b-100.png"
    },
    {
        title: "part-b-100-0",
        gabc: "We(c)  (c)  (f) adore(f)  (g) thee,(f) .(h) Christ,*(hg) And(fd) we(fg) bless(g) thee,(f) We(f) \xa2(f)  dore.(g) \xa5.Pecause(h)  (hi) by(h) thy(h) Cross(g) thou(g) hast(g) redeemed(h)  (g)  (f)  the(fh) world.(hg) And(fd) we(fg) hless.(g) Glory(h)  (h) be(h) to(h) the(h) Fathe(hi)  (h)  and(h) to(h) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) We(f) a-(f)dore.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-100.png",
        nextFileName: "./pages/part-b-101.png"
    },
    {
        title: "part-b-100-1",
        gabc: "0&quot;(cd) Cross,(ff) T(cd) iurpassing(f) all(gh)  (h) the(g) stars(fe) in(d) splendour,(g)  (cd)  d(d) renowned,(d)  (cdf) o(f) exceeding(fe)  (d)  (fe) dear(ddc) -(fgh)to(gfefgh) the(fe) hearts(d)  of(fe) m\xe9n,(ddc) ho-(eghg)li-(fe)er(fgf) than(def) e(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-100.png",
        nextFileName: "./pages/part-b-101.png"
    },
    {
        title: "part-b-101-0",
        gabc: "wert(i)  (fe) counted(fe) worthy(dcd)  (c) to(c) uphold(d)  (ffg) the(ed) world\u2019s(e)  (ef) ransom.(d)  (d)  Sweet(h) the(gf) wood,(hghghih) sweet(f) the(ed) .(dgf) ron,(g) -(c).(d) so(fgf) sweet(ed)  e(ik)  (efe) ESPE(d) burden:(d) 2(hg) bring(hih) 5(hgfed) to(f) .(g) e(de) congrega&#39;tion,(fe) i(ddc) u-(c).(c)  are(d) here(fe) as-(f)sem-(gh)bled(g) to(cd) ce(fg) -(f)brate(d) thy(e)  (e) praises.(d)  (d)   (h)  (g)  (f)  (g)  (gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-b-101.png",
        nextFileName: "./pages/part-b-102.png"
    },
    {
        title: "part-b-101-1",
        gabc: "0(igj) mighty(j) G(i) Twork(ig) al(hg) s(e) b(e) death(h) then(f) di-(h)ed,(g) when(dgh)  life(hiji) di-(h)ed(f) .(e) -(fh)the(g) .(e) [(i) i(j) o(i)  (h) v(gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-101.png",
        nextFileName: "./pages/part-b-102.png"
    },
    {
        title: "part-b-102-0",
        gabc: "@.(g)  (hj)  (j)  (j)  (h)  (j) .-(i)o(g)  (h) 9(h)  (h)  (i) e(h)  Cross:(g) thou(g) who(h) savedst(i)  (h) Peter(j)  (i) in(gi) the(hg) =(h) [(g) e,(gf)  \xa2y(gh) up-(gf)on(e) us.(e) Y(j)  (h)  (j) &#39;(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-102.png",
        nextFileName: "./pages/part-b-103.png"
    },
    {
        title: "part-b-102-1",
        gabc: "B(d) n(e) the(f) Crass(ge) of(f) the(e) Lord;(d) [flee(fh) e(h) 1T(hghihgg) vye(ef) \u2018(g)  ver-(fe)sa-(d)ries:(ded) a(c) Li-(cd)-(d)of(d) the(d) a(e) of(f) Ju-(gh)dah,(ghg) the(g)  Root(ef) of(g) Da-(f)\u2014(edc) hath(d) prevaildd,(ef)  (d)  (dc) al-(d)le-(efe)lu-(d)ia.(d)  (hgf)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-102.png",
        nextFileName: "./pages/part-b-103.png"
    },
    {
        title: "part-b-102-2",
        gabc: "But(ig) s(ij) for(i) us,(i) it(i)  (i) behoveth(i)  (g) us(hi) to(hg) glory(e)  (e) in(h) the(h) Cross(h)  of(f) our(h) Lord(gfe) Je-(fg)sus(f) i(e) e(i) s(j) e(i)  (h) ;(fh) ",
        groupIndex: 2,
        filename: "./pages/part-b-102.png",
        nextFileName: "./pages/part-b-103.png"
    },
    {
        title: "part-b-103-0",
        gabc: "t,h-(dd)e(c) si;zn-(df)rof(fe) the(de)  (dc) de-(fg)liv-(hihi)er(g) us(hih) from(h) our(g)  e(f) ne-(fe)mies,(dc) O(d) our(efe) God.(d) =&quot;(h) w(g) &amp;(f) d(gh) aoW](g) ",
        groupIndex: 0,
        filename: "./pages/part-b-103.png",
        nextFileName: "./pages/part-b-104.png"
    },
    {
        title: "part-b-103-1",
        gabc: "This(f) sign(g) of(f) the(fhg) Cross(hg) Shall(fgh) be(gfd) in(fg) heaven.(g)  (f) This(f) sign(g)  V.(ki~) When(h) the(h) Lord(i) shall(h) come(g) to(f)  (gh) 17.(hg) Shall(fh) be.(cgfd)  X\u2019_,(i)  (c) Glory(h)  (h) be.(h) This(f) s&#39;ign.(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-103.png",
        nextFileName: "./pages/part-b-104.png"
    },
    {
        title: "part-b-103-2",
        gabc: "Ve(ij)  T(d)  (e)  (gh)  (hg)  (h) e(j) Lo(ji) |(hg) s(i) iy~(j) Ve(j) )(fhg) [y(j) N(ih) el(h)  (8(h)  (hji)  (g)  (ge) st(f)  (dc)  (de)  (efe) RS(d)  (dfh) s(hg)  (ed) e(f)  (ed)  (d)  We(h) \xab(hji)  (g) m(ge) i(f)  (dc) YR(de) and(efe)  (j) we(d) RS(dh) bless(hg) s(ed) thee.(f) e(ed) i\u2018:\u2014i(d) ",
        groupIndex: 2,
        filename: "./pages/part-b-103.png",
        nextFileName: "./pages/part-b-104.png"
    },
    {
        title: "part-b-104-0",
        gabc: "Thou(c) a-(d)lone(f) Texcellest(fe)  (d)  (ef) in(de) stature(d)  (c) all(f) the(g) cedarg(hg)  (e) of(fg)  Leb-(fe)a-(d)non:(d) for(f) on(fe) the(dc)  (df) Life(fh) of(g) the(f) world(fe) yag(de)  -(dd) (c) on(f) thee(fe) .(g) Christ(fh) vic-(ed)to-(fe)ri-(d)ous,(d) and(cd) deit)(deed)  o(defgh) ver(g) death(fgf) did(fe) for(dc) ev-(d)er(fe) triumph.(d)  (d) i(h)  (g) e(f)  (gf) \u2014(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-104.png",
        nextFileName: "./pages/part-b-105.png"
    },
    {
        title: "part-b-104-1",
        gabc: ":(ik)  (cdffghgefd) (e(d) ex\u2014ceed-(h) (gf) ing(gh) blessed,(defd)  (d) which(defe) a-(de).(ddc)  wast(ik)  (f) count\u2014ed(fghhg) W(edfe) e(d)  (dc) worthy(d) to(hg) R(hjighihgf) A(gh) the(cd) Ldrd,(ddc) the(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-104.png",
        nextFileName: "./pages/part-b-105.png"
    },
    {
        title: "part-b-104-2",
        gabc: "qm(dcdede) ia,(d) S(fg) st(dfdh) |(dfgdffhdfgffdgdfefdf) (|(hhfdf) ",
        groupIndex: 2,
        filename: "./pages/part-b-104.png",
        nextFileName: "./pages/part-b-105.png"
    },
    {
        title: "part-b-105-0",
        gabc: "bundle(cf)  (g)  (f) of(gh) myrrh(hg) Is(g) my(f) well-(g)be-(gh)lov-(gfd)ed(fg) un-(g)to(f) me.(f)  A(f) bundle(g)  (f) of(gh) myrrh.(hg) V.(c) He(hi) shall(h) lie(h) all(g) night(g) betwixt(gf)  (g)  my(gh) breasts.(hg) Is(g) my(f) well-(g)be-(gh)lov-(gfd)ed(fg) un-(g)to(f) me.(f)  Glory(h)  (h) be.(h) A(f) bundle(g)  (f) of(gh) myrrh.(hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-105.png",
        nextFileName: "./pages/part-b-106.png"
    },
    {
        title: "part-b-105-1",
        gabc: "a(d)  (e)  (f)  (g)  (h) \u2014_\u2014(h)  (h)  (g) [](e)  (f) -(gf) (e) a(d)  (e)  (f)  a(g)  (h)  (h)  (g)  (e)  (f)  (g)  (h)  (h)  (h)  (hi)  (ih)  (g)  (h)  (h)  D(h)  (g)  (e)  (f) :(ed) =(d)  (g) O(f)  (g)  (e) (S(fe) e(d) D(e) o(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-105.png",
        nextFileName: "./pages/part-b-106.png"
    },
    {
        title: "part-b-106-0",
        gabc: "ook(d) not(d) T(f) on(de) me,(dc) because(fg)  (fe) I(gh) am(h) black,(h) becauge(h)  (h) K(g)  sun(h) hath(g) =(fe) looked(f) up(fgf) on(d) me:(d) my(h)  (d) mother\u2019s(dg)  (ef) childrep(fh)  (fe) e(dc)  an(def) gry(d) with(cd) me.(d) a(h)  (g) [(f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-106.png",
        nextFileName: "./pages/part-b-107.png"
    },
    {
        title: "part-b-106-1",
        gabc: "Whi\u2014therris-(cffg)&lt;(f)  (f) thy(g) be-(h)lov-(ih)ed(fg) gone,(f) O(ff) @(c) fairest(f) [](g) -(f) (e)  women?(gh)  (h) whither(hi)  (h) is(fggh) thy(g) be-(f)lov-(e)ed(f) et(g) 0y(f) a-(ed)&amp;~(c) that(gf)  we(e) may(d) seek(cd) him(df) with(gf) thee.(f)  (h)  (f)  (gh) |(g)  (f)  Look(dh) a-(h)vay(hj) from(h) me;(h) T1(g) will(fgf) weep(e) bit-(def)ter-(d)ly,(d)  (f) labour(cd)  (dg)  not(ed) to(cdfe) comfort(d)  (ce) me.(d)  (h)  (g)  (f) |(gh)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-106.png",
        nextFileName: "./pages/part-b-107.png"
    },
    {
        title: "part-b-107-0",
        gabc: "H(c)  (c) e(e) hath(f) no(h) form(h) nor(h) comeliness;(j)  (i) and(i) when(hi) we(j) shall(ih)  see(i) him,(i) there(i) is(fi) no(hg) beauty(fe)  (fe) that(d) we(e) should(fh) de-(hg)sire(f)  him.(f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-107.png",
        nextFileName: "./pages/part-b-108.png"
    },
    {
        title: "part-b-107-1",
        gabc: "From(hghc)  (h) the(h) sole(hg) of(e) the(h) foot(f) T(e) ven(f) un\u2014-(hf)to(gf) the(e) head,(e)  (f)  there(fge) is(ec) no(def) soundness(h) e(g) in(g) him.(f) RIBD(h)  (g) e(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-107.png",
        nextFileName: "./pages/part-b-108.png"
    },
    {
        title: "part-b-107-2",
        gabc: "Stay(ik)  (de) me(f) with(ge) flagons,\u2018f(fe)  (d) comfort(f)  (g) me(h) with(ig) apples;(h)  (h) for(dhhg)  I(fe) (0w(dc) sick(e) W(ef) love.(d) [sreen(h)  (g) ey(f) el(fh)  (dgf) ",
        groupIndex: 2,
        filename: "./pages/part-b-107.png",
        nextFileName: "./pages/part-b-108.png"
    },
    {
        title: "part-b-107-3",
        gabc: "&gt;(ikc)  (c)  (f) :(g) T(h) fa-(hg)BEELEE(fgh) R(defdfg) e(g) T(f) |(h)  (fghi) e(f) B(g) |(hi) ",
        groupIndex: 3,
        filename: "./pages/part-b-107.png",
        nextFileName: "./pages/part-b-108.png"
    },
    {
        title: "part-b-108-0",
        gabc: "My(h) heart(hi) within(h)  (fgh) me(g) .(f) troubled.(fh)  (hg) s(fdfg) Veeping,(g)  (f)  Clory(h)  (h) be.(h) Mine(f) eyes.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-108.png",
        nextFileName: "./pages/part-b-109.png"
    },
    {
        title: "part-b-108-1",
        gabc: ".(gi)  (e) ;(f) :-(gh) (g) [(fe)  (f) &amp;(g) &amp;(f) |[=(f) ==_&quot;:-(g).(h)  (ih)  e(ig~) L-(g)e(fgh) |(hg) s(g) \u2018I.-(g)e(i) e(ij) i:-(ji)[(hg) wiases(fgh)  (hg) 0(g)  X.(gi) 0(e) o(f) e(gh) e(g) 110(fe) S(fg) )(gf) Rl(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-108.png",
        nextFileName: "./pages/part-b-109.png"
    },
    {
        title: "part-b-108-2",
        gabc: "ome(f) ye,(de) and(e) let(d) us(f) go(h) up(hg) to(f) the(g) mountain(hi)  (i) the(k)  Lord,(i) and(h) see(hh) if(e) there(f) be(hh) an-(hi)y(h) sorrow(hg)  (h) like(hg) un-(f)to(hf)  My(gf) T(e) SOrrow.(e) |(f) e(h)  (g) S\xab(h) M(f)  (ef) el(f) ",
        groupIndex: 2,
        filename: "./pages/part-b-108.png",
        nextFileName: "./pages/part-b-109.png"
    },
    {
        title: "part-b-109-0",
        gabc: "S(hg)  (ef) orrow(f) oppresseth(f)  (h)  (f) me,(fhffe) face(fh)  (hi) 1is(ih) swollen(gf)  (e) with(fg)  weeping,(gi)  (gh)  (g) and(ij) on(i) my(hi) eyelids(if)  (f) is(e) the(f) sha(fgh) dow(f) of(ef)  death.(f)  (hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-109.png",
        nextFileName: "./pages/part-b-110.png"
    },
    {
        title: "part-b-109-1",
        gabc: "smoke(f)  (f) of(f) the(f) incense(g)  (f) ascended(f)  (g)  (gh) up(hg) Before(fd)  (fg) God.(gf)  The(f) smoke.(f) [(f) A(hi) of(g) e(f) ](g) Angel\u2019s(gh) |(hg) |(fd) (&amp;(fg) ](gf)  Glory(h)  (h) be.(h) The(f) smoke.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-109.png",
        nextFileName: "./pages/part-b-110.png"
    },
    {
        title: "part-b-110-0",
        gabc: "a(ig~)  (e)  (ef)  (f) a(fe)  (h)  (g)  (f) .(e)  (h)  (i)  (j)  (ih) i(i)  (i)  (j)  a(hg)  (h)  (i) a(j)  (i)  (hg) TR(hihg)  (f)  (f)  (f)  (fi) b(h)  (hf)  (g)  (f)  (e)  -(hgi) (c)  (ef) Angel(f) stood(fe)  (h) TR(i) the(i) altar(h)  (j) of(i) the(hg) temple.(hihg)  (f) j(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-110.png",
        nextFileName: "./pages/part-b-111.png"
    },
    {
        title: "part-b-110-1",
        gabc: "While(cc)  (dg) John(ef) :(fg) beheld(g) Tthe(gh) sacred(h)  (gf) mys-(gh)ter-(g)y,(g) the(g) Archan-(hj) (jji)  gel(h) Mi\u2014cha-(ji)el(hg)  (g) sounded(eg) @(g) the(g) e(f) trumpet:(d) Forgive(g)  (h) us,(g) 0(f)  Lord(g) our(gh) Cod,(f) that(hj) o-(j)pen-(ji)est(hj) e(i) a(g) and(g) loosest(h)  (g)  the(g) seals(h) \xbb(g) G(fed) al-(f)le-(fg)lu-(g)ia.(g) I_-(j)P(i)  (j)  (h) I(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-110.png",
        nextFileName: "./pages/part-b-111.png"
    },
    {
        title: "part-b-111-0",
        gabc: "An(ef) An-(h)gel(hi) stood(i) Tat(i) the(i) altar(h)  (i) of(j) the(ih) temple,(i)  (i) having(f)  (i)  in(g) his.(h) hand(f) &quot;a(fe) golden(de)  (fh) censer.(f)  (f)  (i) [y(h)  (i) g(j)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-b-111.png",
        nextFileName: "./pages/part-b-112.png"
    },
    {
        title: "part-b-111-1",
        gabc: "While(cc)  (e) the(g) Arch-(h)an-(ihj)gel(i) Mi-(i)cha-(h)el(f) contended(i)  (gh)  (e) with(f) the(e)  dragon,(def)  (f) a(fi) voice(h) was(hg) heard(ee) of(df) them(h) that(i) said:(hghih) Sal-(h) va-(h)tion(f) to(h) our(ef) God,(ed) al-(fe~)le-(f)lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-111.png",
        nextFileName: "./pages/part-b-112.png"
    },
    {
        title: "part-b-111-2",
        gabc: "O(g) Arch-(h)an-(g)gel(f) Mi\u2014cha-(h) (j) el,(j) I(j) have(i) ap-(g)point-(j)ed(i) thee(g) )(g)  prince(g) o-(f)ver(h) all(j) the(j) souls(ig)  (j) about(g)  (h) to(hjh) be(i) received.(h)  (g)  (g)  .(j)  (i)  (j)  (h)  (g)  (f) &#39;(f) ",
        groupIndex: 2,
        filename: "./pages/part-b-111.png",
        nextFileName: "./pages/part-b-112.png"
    },
    {
        title: "part-b-112-0",
        gabc: "a(c) ye(d) Angels(f) 0(e) of(f) the(fg) Lord,T(g) bless(gh) &quot;(fe) the(d) Lord(f) o(gh)  ev-(g)er,(g)  (h)  (hi) e(h)  (hhh)  (g)  (f) ](ggg)  (d)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-b-112.png",
        nextFileName: "./pages/part-b-113.png"
    },
    {
        title: "part-b-112-1",
        gabc: "Angels(i)  (h) and(gh) Arch-(iji)an-(hi) (ie) Thrones(fi) ang(h) Do-(g)min-(e)ions,(e)  Prin-(iih)ci\u2014pa-(gh)li-(j) (i) ties(h) and(i) Pow(ijji) ers,(i) Virtues(jk)  (k) of(i) the(k)  hea(jkjh) vens,(ji) O(ij) praise(h) the(f) Lord(g) of(h) hea-(fe)ven,(d) al(fe) le-(f) lu-(e)1ia.(e)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-112.png",
        nextFileName: "./pages/part-b-113.png"
    },
    {
        title: "part-b-112-2",
        gabc: "In(f) the(f) presence(g)  (f) of(f) the(f) An-(gh)gels(hg) I(g) will(f) sing(g) praise(gh)  un-(i) (g) to(fd) thee,(fg) O(g) my(f) God.(f) In(f) the(f) e(g) presence.(f) P(h) 11(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-112.png",
        nextFileName: "./pages/part-b-113.png"
    },
    {
        title: "part-b-113-0",
        gabc: "worship(ik)  (hi)  (h) to-(h)ward(h) thy(h) ho-(h)ly(h) temple,(fgh)  (g) and(g) praise(f) thy(gh)  Name.(i)  (hg) I(g) will(f) sing.(g) X.(fg)  (fhc) Glory(h)  (h) be.(h) Fy(fhefh) In(f) the(f) presence.(g)  (f)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-113.png",
        nextFileName: "./pages/part-b-114.png"
    },
    {
        title: "part-b-113-1",
        gabc: "=(ki~) .(h)  (g)  (h) ...(gfef)  (dc) .(g) &amp;(g) CE(f)  (g)  (h)  (h)  (fgh)  (h)  (j)  (k)  (jih)  o(ik)  (h)  (i)  (i)  (g)  (f)  (g)  (h) Q)(h)  (h)  (g)  (h)  (gfef) a.(dc)  (g)  (g)  \xa5.(f) An(gh) Angel(hgf) [(f) S(hfghg) e(e) [(fe) altar(d) of(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-113.png",
        nextFileName: "./pages/part-b-114.png"
    },
    {
        title: "part-b-113-2",
        gabc: "There(cc)  (fg) was(g) si-(hhij)lence(i) in(jkj)  (dhg)  (g) the(cfh)  (dfe)  (f) dra-(de)gon(f) wa\u2014(gh)  ged(g) war:(g) and(jih) Mi\u2014cha-(jkk)el(k)  (k) fought(i) against(j)  (dhg) him,(higgf) and(f)  (f) had(g)  the(h) vic-(fji)to-(dfhg)ry,(g) al(dfe) le-(fg)lu(dg) ia.(dgd) \u2014;_I\u2014I(dfhif)  (j)  (i)  (j)  (h) _(ghg)  (fg) ",
        groupIndex: 2,
        filename: "./pages/part-b-113.png",
        nextFileName: "./pages/part-b-114.png"
    },
    {
        title: "part-b-114-0",
        gabc: "(&quot;(cd) Prince(fg) most(fe) glo-(d)ri-(fe)ouk,(ddc) Mi-(f)cha-(ghg)el(h) the(gf) Archan(gh)  (fed) ge](d)  keep(gf) us(ghg) in(ef) A(fgf) re-(d)membrance:(d) here(h) and(g) ev(hij) -(ji)where,(hg)  al-(ki~) (iji) ways,(h) en-(h)4(ghgfed) the(cd) Son(dg) of(gh) God(df) &quot;(dedc) 8-(c)al-(dc~)le-(fgfe) lu-(ik) (gh) 1a,(fedc) al-(gd)le-(efe)lu-(d)ia.(d) [(h) e(g)  (f) e(gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-114.png",
        nextFileName: "./pages/part-b-115.png"
    },
    {
        title: "part-b-115-0",
        gabc: "\u2014_(d)  (e) L(f)  (g)  (h)  (gh) 0(j)  (j)  (k)  (j)  (i)  (h) 0(j)  (i)  (g)  .(i)  (h) [(g) u(h) a(d)  (e) [(f) T(g)  (h) SR(gh) et(gf)  (g) R(h) S(j) ](i)  (h)  \xa5(j) u(i)  (g)  (h) II(gh) 5(ed) of(hj) St.(g) [0(fed) S(fgh) |(g) M(fe) ;(d) S(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-115.png",
        nextFileName: "./pages/part-b-116.png"
    },
    {
        title: "part-b-115-1",
        gabc: "They(c)  (gd) are(fg) all(g) t(h) ministering(g)  (h)  (gf) spirits,(gh)  (f) sent(fh) forth(j) to(ji)  mi-(hi)F=(hg) nis\u2014ter(g) to(eg) them(cdefef) who(d) shall(e) be(f) heirs(dgf) of(gh) U(ih) salvation.(g) e(g)  .(j)  (i)  (j)  (h)  (g) AT(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-115.png",
        nextFileName: "./pages/part-b-116.png"
    },
    {
        title: "part-b-115-2",
        gabc: "God(e) shall(f) e(h) his(h) oo(hj)  (i) o(hi) o-(j)ver(h) thee,(i) to(gihg)  keep(fe) thee(f) in(e) all(de) thy(fh) ways.(f)  (h) -(hid) (h)  (dfi)  (j)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-b-115.png",
        nextFileName: "./pages/part-b-116.png"
    },
    {
        title: "part-b-116-0",
        gabc: "Let(c)  (f) us(e) praise(fh) the(hgf) Lord(fgh) whom(f) the(e) An(fgh) gels(hgf)  to(gi)  (h) whom(fh) Che-(h)ru-(i)bim(j) and(i)  (hi)  (h) cry(h)  (hi) a-(h)loud,(hi)  Ho(hg) 1y,(fe) Ho-(f)1ly,(ghg) Ho-(f)ly.(f) S(h) |(g)  (e) R(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-116.png",
        nextFileName: "./pages/part-b-117.png"
    },
    {
        title: "part-b-116-1",
        gabc: "Their(d) An-(fg)gels(ghgg) Tdo(g) al(fghg) \u2014ways(h) behold(g)  (fg) the(f) face(f) of(e) my(f)  Father(g)  (f) which(fe) 1s(cddc) in(efe) heaven.(d)  (d) l__l(h) e(g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-116.png",
        nextFileName: "./pages/part-b-117.png"
    },
    {
        title: "part-b-116-2",
        gabc: "lessed(d)  (hf) be(hg) God,(fhiih) who(h) hath(i) sent(jk) his(ij) An-(hi)gel,(h) and(f) deliv-(f) (i)  er\u2014ed(h)  (gh) his(fed) servants(ef)  (f) who(fe) put(g) their(ded) trust(efe) in(d) him.(d)  (highf) ",
        groupIndex: 2,
        filename: "./pages/part-b-116.png",
        nextFileName: "./pages/part-b-117.png"
    },
    {
        title: "part-b-116-3",
        gabc: "-(ik) (ed) God,(gjjh) all(i) ye(j) Angels(k)  (j) of(hi) his:(hg) praise(hg) him,(efg) all(gh) ",
        groupIndex: 3,
        filename: "./pages/part-b-116.png",
        nextFileName: "./pages/part-b-117.png"
    },
    {
        title: "part-b-117-0",
        gabc: "his(gf) host.(e)  (ji) SHORT(hi)  (h)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-b-117.png",
        nextFileName: "./pages/part-b-118.png"
    },
    {
        title: "part-b-117-1",
        gabc: "An(f) Angel(g)  (h) stood(g) At(f) the(hg~) altar(g)  (fd) of(f) the(g) temple.(g)  (f)  Angel.(g)  (hg) Having(hi)  (g) in(g) his(g) hand(h) a(g) golden(g)  (f) censer.(gh)  (hg) At(f)  the(ik)  (gh) altar.(g)  (fd) \xa5.(c) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g) Son,(g)  and(ik)  (g) to(h) the(g) ly(g) Ghost.(gh) An(f) Angel.(g)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-117.png",
        nextFileName: "./pages/part-b-118.png"
    },
    {
        title: "part-b-117-2",
        gabc: "e(d)  (fh)  (h)  (i)  (hg)  (h)  (i) =(jh)  (k)  (i)  (j)  (h)  (ih)   (gf)  (e)  (f)  (d)  (d)  (e)  (d)  (gf)  (e)  (f)  (h)  *(gh) In(f) the(h) &#39;(f) .(g) of(fed) [](c) I(d)  &gt;(d) ",
        groupIndex: 2,
        filename: "./pages/part-b-117.png",
        nextFileName: "./pages/part-b-118.png"
    },
    {
        title: "part-b-118-0",
        gabc: "A(c) nd(c) the(d)  (dhi)  (h) talked(hg)  (f)  (e) with(fg) me(h) came(g) again(fe)  (d)  (d)  and(dg) wa-(gf)ked(gh) me,(h) as(f) a(ef) man(ghg) that(f) is(e) wa-(df)ken-(f)ed(f) out(ef) of(gf)  his(ed) sleep.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-118.png",
        nextFileName: "./pages/part-b-119.png"
    },
    {
        title: "part-b-118-1",
        gabc: "Ye(e) ho-(eh)ly(f) Angels,(f)  (ed) our(ef) Guardians,(e)  (e) defend(e)  (f) us(e) in(d) tine(e)  of(f) hattle,(de)  (d) lest(e) we(f) pe(hijih) rish(ih) in(f) the(hg) dreadful(e)  (d) dey(ef)  of(f) judgment.(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-118.png",
        nextFileName: "./pages/part-b-119.png"
    },
    {
        title: "part-b-119-0",
        gabc: "Who(fg) is(h) .(g) that(h) is(hgf) beautiful(f)  (hj) as(ji)  (hg) a(hi) dove,(g) like(jk) a(ji)  rose(hg) that(g) 1is(h) planted(ffd)  (d) by(e) the(f) rivers(gf)  (h) of(h) waters.(g)  (g)   (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-119.png",
        nextFileName: "./pages/part-b-120.png"
    },
    {
        title: "part-b-119-1",
        gabc: "Mighty(ic)  (c)  (fg) f(gf) Virgin,T(h)  (f) like(gi) the(h) tower(i)  (hg) of(f) Da-(g)vid,(h) whereon(f)  (f)  there(ik)  (d) a(c) a(e) thousand(ffgf)  (f) buck-(ifhihg)lers,(hg) all(gh) shields(fe) of(d)  wighty(ik)  (ghg)  (f) men.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-119.png",
        nextFileName: "./pages/part-b-120.png"
    },
    {
        title: "part-b-119-2",
        gabc: "Ma-(c) (c)  (d)  (dhi) ry,(h) thou(h) that(g) art(f) full(g) of(gh) grace;(h) the(f) Lord(h)  [(gf) L(g) thee:(d) R(g) e(h)  (g) e(fde)  (d) e(f) Vo(gf) women.(d) ypee(d) ety(hgfh) 1Y(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-119.png",
        nextFileName: "./pages/part-b-120.png"
    },
    {
        title: "part-b-120-0",
        gabc: "The(e) daughters(ed)  (g) of(hi) Si-(ij)on(i) tsaw(ik) her(j) a-(hi)dorn-(hg)ed(g) with(hj)  lands(hg) of(fe) ro-(fg)ses,(g) and(dg) proclaimed(h)  (gf) her(g)  (g) most(hg) blesseq,.(e)  (e)  SHORT(ji)  (hi)  (h)  (fh)  \u2018A(f) fter(f) Child-(g)bearing,(f)  (f) O(f) Virgin,(h)  (hg) Thou(g) didst(f) remain(gh)  (gfd)  in-(fg)vi-(g)o-(f)late.(f) After(f)  (f) Child-(g)bearing.(f)  (f) Intercede(hi)  (h)  (gh) for(g)  us,(g) O(h) .(g) Mother(f) of(fh) God.(hg) e(g) Glory(h)  (h) Be.(h) After(f)  (f)  Child-(g)bearing.(f)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-120.png",
        nextFileName: "./pages/part-b-121.png"
    },
    {
        title: "part-b-120-1",
        gabc: "Biess\xe9d(c)  (c)  (d)  (dc) art(d) thou,(f) fo(f)  (e) Ma-(c) (ef) ry,(d) Mother(fg)  (gf) of(fgh) God,(h) \xa3(h) ",
        groupIndex: 1,
        filename: "./pages/part-b-120.png",
        nextFileName: "./pages/part-b-121.png"
    },
    {
        title: "part-b-121-0",
        gabc: "thou(g) hast(hj)  (ji) believed(g) the(hj)  (iih) Lord:(g) for(h) those(hk) things(j) are(ji)  accomplished(hg)  (h)  (gf) in(eef)  (gh) thee,which(h)  (f) were(ed) told(de) thee:(e) a(c) inter(d)  cede(fgf) for(gh) us(h) un-(g)to-(h)the(ef) Lord(g) our(fe) God.(d) el(h)  (g) e(f)  (g) WO(dgfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-121.png",
        nextFileName: "./pages/part-b-122.png"
    },
    {
        title: "part-b-121-1",
        gabc: "Be(c)  (gh)  (ih) joyful,tVirgin(gh)  (ij)  (j) Mother;(i)  (i) Christ(iji) hath(hg) ri-(fh)sen(gh) from(fgih)  the(fe) me(e) [(i) |(j)  (i)  (h) el(gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-121.png",
        nextFileName: "./pages/part-b-122.png"
    },
    {
        title: "part-b-121-2",
        gabc: ")(e) is(f) .(hi) a(i) Twith(h) [(i) merry(j)  (ih) noise,(i) and(f) the(i) Lord(efghg)  1th(fe) the(fe) sound(de) of(f) the(h) trump.(f)  (h)  (dh)  (i)  (h)  (i) :(jd)  (h)  (f)  (ef) ",
        groupIndex: 2,
        filename: "./pages/part-b-121.png",
        nextFileName: "./pages/part-b-122.png"
    },
    {
        title: "part-b-122-0",
        gabc: "T(ik) he(d) Spi-(fhg)rit(gh) of(h) the(g) T(dfe) hath(d) filleld(fg)  (gd) the(ef)  world.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-122.png",
        nextFileName: "./pages/part-b-123.png"
    },
    {
        title: "part-b-122-1",
        gabc: "Ma-(g)a(e) a(e) taken(g)  (h) .(i) in-(j)to(h) a8(ii) heaven:(g) the(h) An-(hg)ge]s(ef) tris(h)  =(gi)  (g) ex-(h)alt-(ij)ing(i) and(hg) i(f) blessing(e) the(de) Lord,(ef) al-(g)e(f) ly-(e)ja,(e)   (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-122.png",
        nextFileName: "./pages/part-b-123.png"
    },
    {
        title: "part-b-122-2",
        gabc: "te(g) Virgin(gj)  (hgf) Ma-(gh)ry(gh) is(h) :(i) exalted(j)  (h) a-(g)hove(h) the(gf) choirs(g)  of(h) Angels:(hk)  (jkj) and(g) up-(fgh)on(fe) her(d) -(e)a(f) \xa3(gh) of(h) D(g)  stars.(g) i(j)  (i)  (j) )(h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-122.png",
        nextFileName: "./pages/part-b-123.png"
    },
    {
        title: "part-b-123-0",
        gabc: "hou(f) art(f) beautiful(g)  (gh) *(hg) And(fdfg) pleasant.(g)  (f) Thou(f) art(f) beauti-(g) (gh)  tal,(hg) V.(c) O(h) ho-(h)ly(h) Mother(hi)  (h) of(h) God,(g) in(g) thy(g) fe-(f)li-(g)ci-(fgh)ty.(hg)  And(fdfg) pleasant.(g)  (f) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh)  the(g) Son,(g) and(g) to(h) the(g) Holy(f)  (g) Ghost.(gh) Thou(f) art(f) beautiful(g)  (gh)  (hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-123.png",
        nextFileName: "./pages/part-b-124.png"
    },
    {
        title: "part-b-123-1",
        gabc: "T(ik)  (g) day(h) let(h) us(gf) cel-(fh)e-(h)brate(g)  (g) e(ij) the(h)  (h) So-(gf)lem-(fh) ni-(ik) (h) ty(g) of(gji) the(j) Ho-(k)ly(j) Ro-(ji)sa-(h)ry(h) of(j) Ma-(ihg)ry,(g) Mother(ghi)  (fh) of(gf)  :(ik)  (f) [(hgg) she(f) ](gh)  (hg) -(f) (g) for(hij) us(jijkj) un-(h)to(h) Je-(g)sus(f)  Christ(gh) the(g) Lord.(g) =i(j) we(i) bt(j) el(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-123.png",
        nextFileName: "./pages/part-b-124.png"
    },
    {
        title: "part-b-124-0",
        gabc: "O(e) blessed(eh)  (fed) Mother(df)  (e) fand(ei) spotlesis(hg)  (fh) Virgin,(gfe)  (e) thou(fh) 8lorigy,(eh)  (h)  Queen(ii) of(h) the(f) world,(hg) may(h) all(hihgijhih) acknowledge(hi)  (j)  (ih) the(g)  of(h) thy(i) prayer(ih) who(ie) cel-(fhi)e-(h)brate(hghih) the(f) so-(f)lem-(fi)ni-(hg)ty(e)  of(e) thy(ef) ho-(h)ly(fg) Bo-(f)sa-(e)ry.(e) 15(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-124.png",
        nextFileName: "./pages/part-b-125.png"
    },
    {
        title: "part-b-124-1",
        gabc: "He(ki~c)  (cg) shall(gf) be(d)  (fg) calledt(g) the(gh) Peaceful(gh)  (g) One,(f) and(g) his(f) thron(g)  ;(ki~) shall(h) be(j) IR(ji) established(h)  (g) for(h)  (hih) \u2018ev-(gf)er(d) and(fg) ev-(g)er.(gdfd~dfd) |(dfdj)  (i) |(j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-124.png",
        nextFileName: "./pages/part-b-125.png"
    },
    {
        title: "part-b-125-0",
        gabc: "is(c)  (h) kingdom(hih)  (hg) is(h) an(hg) ev-(f) (g) er-(hi)lasting(hg) kingdom,(e)  (e) and(f) all(d)  do-(f) (hg) nions(ef) shall(hig) serve(hf) and(f) o-(f)bey(gfe) him.(e) i(h)  (f)  (h) S|(i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-b-125.png",
        nextFileName: "./pages/part-b-126.png"
    },
    {
        title: "part-b-125-1",
        gabc: "_\u2014(gi) a(c)  (e) Behold(g) the(h) man&#39;(i) whose(i) name(ij) is(h) the(f) Branch;(hhih) he(h) shall(i)  sit(g) and(h) rule(f) a(e) i(f) a(e) .(d) a(e) L](e) a(d) speak(ef)  peace(g) un-(f)-(e)the(d) \u2014(e) heathen.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-125.png",
        nextFileName: "./pages/part-b-126.png"
    },
    {
        title: "part-b-125-2",
        gabc: "I(g) will(df) give(fg) thee(g) for(f) a(h) light(ji) to(j) the(k) Gentiles,(hg)  (g) that(g)  thou(gh) mayest(g)  (g) be(g) my(g) sal-(g)va-(fe)tion(d) un-(d)to(e) the(f) end(gf) of(gh)  the(h) earth.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-125.png",
        nextFileName: "./pages/part-b-126.png"
    },
    {
        title: "part-b-126-0",
        gabc: "A(f) scribe(g) un-(f)to(g) the(fgh) Lord,(defhg) O(f) ye(fgh) kindreds(g)  (fd) of(f) the(g)  (g)  Ascribe.(f)  (g) \xa5.(h) Ascribe(hi) un-(h)to(gh) the(g) Lord(g)  (j) glory(h)  (g) and(g) _\u2014(f)  (gh)  ion.(hg) 0(f) ye(fgh) kindreds.-(g) (fd) \xa5.(c) Glory(h)  (h) be.(h) K.(f) Ascribe,(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-126.png",
        nextFileName: "./pages/part-b-127.png"
    },
    {
        title: "part-b-126-1",
        gabc: "%(ef)  (jfjk) [Erare(j)  (j)  (ji) e(ij) 07(i) el(ih) e(j) e(j) N(i) SR(hg) SRR(f)  :(ig~) et(gh)  (fe) e(ef) s(c) e(ef) e(f) elinds(fh) (LS(hf) BT(g)  (f) e(e)  (i)  (i)  .(gi) ALl(h) power(iji) is(gf) given(fgh)  (fe) unto(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-126.png",
        nextFileName: "./pages/part-b-127.png"
    },
    {
        title: "part-b-126-2",
        gabc: "The(cc)  (df) Lord(de) God(d) shall(dc) give(f) un-(g)to(fh) himt(h) the(h) throne(ihgg) of(ef) his(g)  ](g) father(d) David:(d)  (c) and(d) he(c) shall(d) reign(f) o-(f)ver(fe) the(g) house(hg)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-126.png",
        nextFileName: "./pages/part-b-127.png"
    },
    {
        title: "part-b-127-0",
        gabc: "Ja-(ef)cob(g) for(fe) ev(df) er;(fc) and(c) of(d) his(f) kingdom(fg)  (f) there(e) shall(f)  be(g) no(fe) end,(dc) al-(d)le(efe) 1lu-(d)ia.(d) B(h) i(g)  (f)  (gh) [(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-127.png",
        nextFileName: "./pages/part-b-128.png"
    },
    {
        title: "part-b-127-1",
        gabc: "T(ig~) he(fg) God(e) of(f) hea(fij) ven(h) shall(h) set(ge) up(g) a(gh) kingdom(f)  (f) which(fe)  (h)  shall(hi) break(j) in(ih) pie(hgf) ces(gf) and(fh) consume(g)  (h) all(fg) kingdoms&#39;,(ef)  (fgeec)  (fe)  N(gi) it(h) shall(g) stand(hge) for(gh) ev-(f)er.(f) _I(h)  (g) ewesscqmmnin(e) oy(f)  he-(dc)Lord(f) hath(g) gi-(f)ven(fgh) him(h) T(h) dominion(hj) and(h)  (g) glory(h)  (g) and(g) a(g)  S(fh) kl\u201Cgdc)m,(g) that(gg) all(eg) people,(h)  (g) nations,(h)  (g) and(f) languages(f)  (fe) \u2014(c)  serve(d) him.(d) T(h)  (g) Rk(f) i(gh)  (gf) ]|(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-127.png",
        nextFileName: "./pages/part-b-128.png"
    },
    {
        title: "part-b-128-0",
        gabc: "\u2014p(ig~)  (e) iving(f) waters(h)  (h) shall(h) go(hj)  (i) =4(hi) g(jh)  (i) a(i) L(i) an\\d(g)  the(i) Lord(h) shall(g) be(fe) King(fe) c-(de)ver(fg) all(h) the(hg) earth.(f) e(i)  (h) Rt(i) |(jh)  (fh)  H(g) e(e) shall(g) be(h) great,T(i) e-(ij)ven(h) un-(f)to(h) the(fh) ends(ih) of(ge) the(f) eart}.(fg)  and(g)  (g) this(hf) man(gg) shallbe(f) Y(e) the(de) peace.(e) E\u2014(i) EE\u2014\u2014&quot;\u2014\u2014\u2014(j)  (i)  (h) b(gf)  T(ki~) he(f) na(fddcf) tion(f) and(f) kingdom(fg)  (f) that(f) will(gh) not(h) serve(hj) thee(h)  shall(jk)  shall(ik)  (gf) per-(ffgf)ish;(f) yea,(f) those(f) na(fdd) -(dfcfg)tions(f) shall(fg) be(gf)  ut-(ki~) (g) ter-(gh)ly(g) wasted.(f)  (f)  (h) :(f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-128.png",
        nextFileName: "./pages/part-b-129.png"
    },
    {
        title: "part-b-128-1",
        gabc: "There(f) is(f) given(g)  (f) un-(g)to(gh) me*All(hg) el(fdfg) power.(g)  (f) There(f) i(f) e(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-128.png",
        nextFileName: "./pages/part-b-129.png"
    },
    {
        title: "part-b-129-0",
        gabc: "heaven(g)  (f) and(gh) earth.(hg) All(fdfg) power.(g)  (f) V.(c) Glory(h)  (h) be.(h)  There(f) is(f) given.(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-129.png",
        nextFileName: "./pages/part-b-130.png"
    },
    {
        title: "part-b-129-1",
        gabc: "Un-(gic) (d) to(fh) God(hg) and(f) his(e) Father(hhi)  (h) hath(h) he(hi) made(h) us(h) to(g) be(i) a(ij)  \u2018(gi) kingdom,(h)  (h) who(h) is(i) the(j) first(j) be-(ih)got-(hg)ten(fi) of(hi) the(f) dead,(f)  and(ig~)  (h) the(f) Prince(ih) of(h) the(g) kings(h) of(fe) the(f) \u2014(e) al(e) le-(ef) lu-(gi) (d) ja.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-129.png",
        nextFileName: "./pages/part-b-130.png"
    },
    {
        title: "part-b-130-0",
        gabc: "He(e) hath(h) on(g) his(h) il(j) vesture(i) and(i) on(h) his(j) thigh(kj) o(ih) N(ij) wrig_(i)  .(jk)  (jk)  ten,(i) King(ij)  (k) of(k) kings,(i) and(i) Lord(kjhi) of(ijkijj) lords:(ji) \xa2,(ig) o(hij)  be(i) glory(h) 2(g) and(h) do-(hi)min-(hg)ion(ef) for(df) ev-(h)er(gh) and(ihf) ev-(e)er,(e)  a(i) a(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-130.png",
        nextFileName: "./pages/part-b-131.png"
    },
    {
        title: "part-b-130-1",
        gabc: "I(j) em(ih) Rapha-(ji) (h) el(g) the(h) Angel,(efg)  (g) that(h) stand(j) before(i)  (j) the(h) F(j)  ly(i) One:(g) wherefore(fgh)  (gfd) bless(g) ye(g) God(h) for(gf) ev-(gh)er,(h) and(gh) confe\xae(ji)  (hg)  ye(h) all(i) his(h) great(g) and(ef)  (g) wonderful(f) a(e) doings.(fg) [(e) 12(j)  (h)  (j)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-b-130.png",
        nextFileName: "./pages/part-b-131.png"
    },
    {
        title: "part-b-131-0",
        gabc: "The(f) An-(gf)gelT(gh) Ra-(f)pha-(g)el(hi) was(hg) sent(f) un-(h)to(j) To-(i)bit(j) and(h)  -(j)ra,(ij) that(h) he(f) might(gh) heal(g) them.(g) B(j) v(i)  (j) |(h) Gl(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-131.png",
        nextFileName: "./pages/part-b-132.png"
    },
    {
        title: "part-b-131-1",
        gabc: "a(e) An(ei) gel(i) :nt.(ij) N(h) un-(f)to(h) To-(gf)bit,(e) and(f) sa-(ed)lut-(ef)ed(f)  =(fi) say-(ihg)ing:(g) Joy(hhe~) be(fe) ev-(d)er(def) with(e) thee.(e) |(i) e(j)  (i)  (h) |(gi) ",
        groupIndex: 1,
        filename: "./pages/part-b-131.png",
        nextFileName: "./pages/part-b-132.png"
    },
    {
        title: "part-b-131-2",
        gabc: "Be(g) of(f) good(gf) EON(efgh) O(hg) O(fg) To(fe) bit;(e) for(e) the(f) [(g) is(f) nigh(dc)  at(de)  that(ef) God(gh) ,(fg) heal(g) n(e) @S(h)  (g) etas(h) i(ih) [0(gfe) @%(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-131.png",
        nextFileName: "./pages/part-b-132.png"
    },
    {
        title: "part-b-131-3",
        gabc: "Ble(f) 58(ge) Ye&quot;\u201Cthe(f) &#39;God(e) o(df) heaven,T(hhi)  (h) and(i) praise(hi) him(f) a(g) the(h) ",
        groupIndex: 3,
        filename: "./pages/part-b-131.png",
        nextFileName: "./pages/part-b-132.png"
    },
    {
        title: "part-b-132-0",
        gabc: "sight(gi)  (i) of(h) all(jk) that(ih) live;(h) mag-(f)-(f)fy(fi) him(h) apgq(g) Praiss(h) i(f)  for(f) the(fe) mer-(g)ci-(e)ful(d) things(ef) which(f) he(d) hath(f) done(he)  you.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-132.png",
        nextFileName: "./pages/part-b-133.png"
    },
    {
        title: "part-b-132-1",
        gabc: "eace(hh) be(gf) with(hg) you,(e) fear(ef) not:(d) bless(f) ye(d) the(f) Lord,(h) ](g)  sing(f) praises(i)  (hg) un-(fghf)to(g) el(f) him.(e) [t(h)  (f)  (h) s(i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-132.png",
        nextFileName: "./pages/part-b-133.png"
    },
    {
        title: "part-b-132-2",
        gabc: "0(cd) Prince(fg) most(fe) glo-(d)ri-(fe)ous,(ddc) Ra-(f)pha-(ghg)el(h) the(gf) Arc(gh) e(fed)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-b-132.png",
        nextFileName: "./pages/part-b-133.png"
    },
    {
        title: "part-b-133-0",
        gabc: "keep(gf) us(ghg) 10(f) re(fgf) -(d)membrance:(d) here(h) and(g) ev-(hij)ery-(ji)where,(hg)  ways,(h) entreat(h)  (ghgfed) the(cd) Son(dg) of(efe) God(d) for(cd) us.(d)  (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-133.png",
        nextFileName: "./pages/part-b-134.png"
    },
    {
        title: "part-b-133-1",
        gabc: "Let(f) the(f) righteous(gh)  (fedc) re(fghi) joice*(h) Be(hji~) fore(ihgfe) God.(ghggf) Let(f)  the(f) righteous.(gh)  (fedc) Let(f) them(f) al(g) so(f) be(f) merry(gh)  (fe) and(dc) joy-(hfghi) ,ful,(h) Be-(hj)fore(ihgfe) God.(ghggf) Glory(f)  (f) be(g) to(f) the(f) Father(gh)  (f) and(g)  0(fe) the(dc) o(c) et(c) to(df) the(f) Ho(hgih) ly(gf) Ghost.(f) Let(f) the(f)  rlghteous&#39;(gh)  (fedc) ",
        groupIndex: 1,
        filename: "./pages/part-b-133.png",
        nextFileName: "./pages/part-b-134.png"
    },
    {
        title: "part-b-134-0",
        gabc: "O(d) vye(cd) Angels(d)  (d)  (d) sndArchang\xe9ls,(df)  (d) ](dc) To(fghg) ye(fe) Thi.)nes(dc) and(d)  minions,(d)  (d)  minions,(d)  (d) Principa-(h) (h) li-(hg)ties(h)  (ji) and(jk) Powers,(jih)  (h) Virtyes(h)  (hg) of(fe) the(d)  he\xe9avens,(ik)  (cd) -(d)Che~ru-(h)bim(ji)  (hg) and(fgh) Se(j) ra(jih) phim,(h) O(h) a(g) Patri-(h) (f)  archs(ghg) and(f) Prophets,(d)  (d) ye(f) ho-(f)ly(e) Doctors(fe)  (d) of(f) the(e) 14w,(ddc)  all(cd)  (fghg) ye(ed) A(efe) postles,(d)  (d) ye(f) Martyrs(f)  (f) of(de) Christ,(dc) ye(cd)  ho-(fgh)ly(f)  (ef) Confessors,(d)  (d) ye(f) irgins(fe)  (d) bf(ed) the(cd) Lord,(d) &#39;(hgfedc)  ho-(d)ly(efe) Hermits,(d)  (d) and(cd) all(fed) Saints:(deddc) gffer(c)  (d) for(fge) [(hghg)  s(fedc) in.-(gd)ter-(efe)B(d) cessions.(d) i(h) 00(g) g(f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-134.png",
        nextFileName: "./pages/part-b-135.png"
    },
    {
        title: "part-b-135-0",
        gabc: "I(d) beheld(f)  (d) la(dc) great(fg) mul(f) titude(gh)  (h) Twhich(h) no(hj) man(h) could(g) s(fh) number,(g)  of(g) all(eg)  (hg) nations,(fg) standing(f)  (e) before(c)  (eg) the(fe) throne.(d)  (h) REO(g)  (f)  (fgh)  (gf)  Alnd(d) all(f) the(g) Angels(fh)  (h) stood(hg) round(hi) about(g)  (f) the(gh) throne,(g) and(g)  (e)  a(e) before(g)  (hg) the(f) throne(f) on(g) their(fe) face&#39;s,(d)  (ef)  (cdcf) and(ef)  (g) worshipp\u2019d(fe)  God.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-135.png",
        nextFileName: "./pages/part-b-136.png"
    },
    {
        title: "part-b-135-1",
        gabc: "Thou(ki~)  (c)  (g) hast(gd) redeemed(fg)  (gh)  (g) O(g)  (g) Lord(gh) our(g) God,by(hg)  (h) thy(ji) blood(g)  out(ik)  (f) of(h) ev-(jk) (k) ery(j) [(jih) kindred,(h) and(j) ~(hg) and(g) people,(g)  (e) and(g)  i(ki~) ~(fef) -(df)a(c) o(d) G(fg) p(gf) et(fh) to(j) e(i) God(hg) a(fg) e(g) 8(g)  :(j) 0(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-135.png",
        nextFileName: "./pages/part-b-136.png"
    },
    {
        title: "part-b-136-0",
        gabc: "()(e) bless(eh) the(fd) Lord,(efee) all(gh) his(hf) chosen;(h)  (g) keep(i) a(h) day(h) of(j)  rejoicing,(i)  (hg)  (ef) and(e) give(df) thanks(hf) un-(g)to(f) him.(e) -(h) (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-136.png",
        nextFileName: "./pages/part-b-137.png"
    },
    {
        title: "part-b-136-1",
        gabc: "A1l(eh) his(fed) SaintsT(e) skall(hg~) praise(iif) him,(hg) e-(i)ven(i) the(i) children(h)  (h)  of(h) Is-(ij)ra-(i)el,(hghih) e-(f)ven(e) the(f) people(f)  (f) that(f) serveth(h)  (g) him:(e)  (e)  such(ge) honour(fe)  (d) have(e) all(fh) his(h) Saints.(g) e(j)  (i)  (j) 1(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-136.png",
        nextFileName: "./pages/part-b-137.png"
    },
    {
        title: "part-b-136-2",
        gabc: "Tle(e) glorious(g)  (hi)  (ij) of(i)  (i)  (i) the(j) A-(hg)postles(hi) praise(i) thees(i)  the(i) goodly(j)  (i) fellowship(h)  (hg)  (ef) of(d) the(fh) Prophets(dhfd)  (dgf)  (d) praise(e) ghes?(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-136.png",
        nextFileName: "./pages/part-b-137.png"
    },
    {
        title: "part-b-137-0",
        gabc: "e(e) \u201Chi;e-(g)robed(h)  (i) army(jji)  (h) of(i) Martyrs(ijji)  (i) praise(ijjk)  (k) thee;(iki)  (kjkjiji) .(i)  one(ij) heart(h) and(h) voice(f) do(df) all(h) the(i) elect(h)  (hgfg) acknowledge(fgf)  (e)  (de)  thee:(e) O(eghi) blessed(i)  (ef) Tri-(h)ni-(h)ty,(gh) one(ih) on-(f)ly(f) God.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-137.png",
        nextFileName: "./pages/part-b-138.png"
    },
    {
        title: "part-b-137-1",
        gabc: "O(efdd) Hhbw(dc) glo-(f)ri-(fg)ous(gf) is(g) the(ghg) kingdom(f) z(f) wherein(fg)  (hg) all(hiih) the(gf)  Saints(g) rejoice(fg)  (h) with(gf) Christ;(f) ar-(dc)ray-(f)ed(g) in(hg) white(fh) robes,(hih)  tiey(dc) 8(g) |(ghg) tEe(fe)  (dc) a8(g) ](g) ther-(f)\u2014ev(g) \u2014er(g) he(ghg) go-(f)eth.(f)  November(ik)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-137.png",
        nextFileName: "./pages/part-b-138.png"
    },
    {
        title: "part-b-137-2",
        gabc: "o(ik)  (f)  (g)  (h) 4(hhh) )(g)  (g)  (hhh) (G(g)  (f)  (f) |(d)  (d)  (ddd) ISR(h)  (dh)  (h) [T(d)  (d) 0(f)  (g) -(g)",
        groupIndex: 2,
        filename: "./pages/part-b-137.png",
        nextFileName: "./pages/part-b-138.png"
    },
    {
        title: "part-b-138-0",
        gabc: "O(ig~)  (fhhg) blessed(h) -(f)Mart:in,T(g)  (f) whose(e) righteous(fgh)  (fgf) soul(e) m(fe) possessety(h)  (g)  Pa-(f) (ef) ra\u2014dise;(f) whereat(fe)  (h) the(i) Angels(j)  (i) _\u2014(ji) triumph,(h) the(h) Archan-(hhg) (ji)  (T(gi) gels(h) are(g) ju-(fgf)bi-(f)lant:(f) thee(hh) the(fgf) choir(f) of(e) Saints(f) pro-(f) claimeth,(g)  (hg)  (e) th.e(c) throng(ef) of(f) Virgins(fg)  (f) in-(f) (h) viteth,(h) saying,(hj)  (j)  i(ig~) A(i) bide(hg) with(fe) us(f) for-(hg)ev-(f)er.(f) ](h)  (gf) ety(hg)  (e) oo(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-138.png",
        nextFileName: "./pages/part-b-139.png"
    },
    {
        title: "part-b-138-1",
        gabc: "is(g) B(h) disciples(j) B(i) tsaid(iihg) un-(f)s(gh) |(ih) T(f) Martin:(e)  (e) Father,(ij)  (i)  why(h) dost(h) thou(j) a-(k) (j) bandon(hi) us?(i) or(g) to(h) whom(hj) wilt(i) thou(h) Jeave(hg)  thy(f) fatherless(gh)  (ih)  (f) children?(e)  (de) for(dfeed)  (d)  (hedhddefdd)  (dd)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-138.png",
        nextFileName: "./pages/part-b-139.png"
    },
    {
        title: "part-b-139-0",
        gabc: "on-(de)ter(ef) in(hi) a-(h)mong(hg) us,(hih) mot(fe) sparing(f)  (h) the(g) flock.(e)  a(ig~)  (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-139.png",
        nextFileName: "./pages/part-b-140.png"
    },
    {
        title: "part-b-139-1",
        gabc: "~\u2018O(gi)  (igij) Lord,(i) if(i) I(i) am(jji) yet(j) needful(i)  (i) un-(hg)to(i) thy(g) A(e) people,(e)  1(g)  (g) refuse(g)  (g) not-(h)to(f) la-(h)bour:(g) thy(f) will(h) be(g)   (ig~)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-139.png",
        nextFileName: "./pages/part-b-140.png"
    },
    {
        title: "part-b-139-2",
        gabc: "O(g) man(h) of(gf) worth(g) past(hih) telling,(g)  (g) whom(g) labour(h)  (gf) could(g) not(gh)  conquer,(f)  (f) ;(g) death(f) :(gh)  (jk)  (jijkj) who(k) neither(i)  (j) feared(h)  (h) to(g)  die,(h) nor(h) re-(g)fus-(ef)ed(gh) to(h) live.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-139.png",
        nextFileName: "./pages/part-b-140.png"
    },
    {
        title: "part-b-140-0",
        gabc: "](e) eyes(g) and(h) hands(iji) ev-(j)er(k) raised(j)  (ih) toward(j) heayen(ji)  (i)  his(ig~)  (j)  (i) undaunted(h)  (f) spirit(hh)  (g) ceased(i)  (h) not(g) from(h) sup-(f)pli-(e) p(ig~)  (f) =(h) le-(i)1lu-(hg),(f) S(g) PR(fg) VA(e)  (e) -(j) (i) i(h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-140.png",
        nextFileName: "./pages/part-b-141.png"
    },
    {
        title: "part-b-140-1",
        gabc: "Mar-(dg)tin(fg) is(g)  (g) received,T(gh)  (g) rejoicing,(g)  (h)  (g) in-(g)to(g) the(g) bo-(gh)sonm(g)  of(i)  (ge) A-(fg)bra-(ef)ham:(d) Mar-(gf)tin,(gf) poor(hj) and(h) low-(h)ly(gf) here(gh) on(h)  earth,(g) en-(jj)ter-(h)eth(hj) rich(ji) in-(h)to(g) heaven,(hg)  (f) and(f) is(g) sa-(h)lu-(j) ted(i)  (h) with(gf) heaven-(h)ly(h) songs.(g) [(j)  (i) -(j) (h) o(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-140.png",
        nextFileName: "./pages/part-b-141.png"
    },
    {
        title: "part-b-140-2",
        gabc: "a(cdf) blessed(fe)  (d)  (ed) who(d)  (f) with(hg) all(h) his(fgf) heart(ddfgd)  (fe)  (dc) ",
        groupIndex: 2,
        filename: "./pages/part-b-140.png",
        nextFileName: "./pages/part-b-141.png"
    },
    {
        title: "part-b-141-0",
        gabc: "he(d)  (fe) King,(d) and(d) fear-(gd~) (gf) ed(g) not(ghg) the(f) do-(fg)minion(fe)  (cd) of(f)  princes!(d)  (d) 0(dh) ho-(hj)ly(hg) soul,(h) which,(g)  (f) although(g) withheld(g)  (hg)  from(g) the(f) per-(fe)se-(fg)cu-(ef)tor\u2019s(def) sword,(fc) lacked(c)  (d) not(f) the(fe) palm(gh)  of(fe)  (d) martyrdom.(d)  (d) el(h) T(g) R(f) Y(g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-141.png",
        nextFileName: "./pages/part-b-142.png"
    },
    {
        title: "part-b-141-1",
        gabc: "Let(d) @11(dc) the(d) a(f)  (e)  (dc)  (c) a(e) the(f) :(g) faithful(ced) a(efe) 2(d) -(d)the(dh)  8lory(hi)  (h) of(g) the(g)  (gh)  (h)  (f)  (cd) and(d)  (dfdgf)  (dc)  (d)  (f) of(f) all(ef)  3(g) his(fe) fol(d)  (cd)  (d)  (d) {53@{:}\u2019&amp;(ef)  (ghgdfedd) ~(dc) in(d) his(efe) foot-(d)",
        groupIndex: 1,
        filename: "./pages/part-b-141.png",
        nextFileName: "./pages/part-b-142.png"
    },
    {
        title: "part-b-142-0",
        gabc: "steps:(d) and(dhi) chiefly(h) -(h)let(h) the(h)  (hg) pajy(fe) of(dc)  (cd) monks(fgh)  joyful,(fgf) S(d) ce-(h) (j) le-(ji)brating(hg) their(h) fes-(jk)ti-(ih)val(j)  in(ik)  (h) whose(hg) goodly(fe)  (fg) fel-(e)low-(efe)ship(dc) the(cd) Saints(d) rejoice(fe)  (fgf) iy(ed)  heaven.(i)  (ef)  (d) [forawwm(h) e(g)  (f)  (g) O(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-142.png",
        nextFileName: "./pages/part-b-143.png"
    },
    {
        title: "part-b-142-1",
        gabc: "T(gic) hen(f) shall(h) the(g) righteous(fg) L(fe) shine(hi) forth(ji) as(h) the(g) sun(fhih) [(e)  the(ig~)  (f) _-(hhi)kingdom(h) of(i) their(h) Father,(hg) I_I-(fe)saith(f) the(ghg) Lord.(f) o[(h) ||(g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-142.png",
        nextFileName: "./pages/part-b-143.png"
    },
    {
        title: "part-b-142-2",
        gabc: "Blessed(cdf)  (fe) are(de) ye,(ddc) when(gfhi) men(hgfe) shall(fgf) hate(d) you,(d) and(d)  they(d) shall(dg) se-(f)pa-(fe)fate(dc) you(cded) from(d) their(effd~) com-(d) (g) pa-(fde)ny:(e) &amp;&#39;(f)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-142.png",
        nextFileName: "./pages/part-b-143.png"
    },
    {
        title: "part-b-143-0",
        gabc: "shall(fe) reproach(de)  (d) you,(c) @nd(dc) cast(d) out(d) your(f) name(gfd) as(f) -(edc)vil(c)  (j)  for(ki~)  (e) the(cd) Son(dc) of(fe) man\u2019s(d) sake:(d) rejoice(fh)  (hgfe) and(fg) be(fe) exceeding(de)  (d) a(c)  gl;&#39;d;(ki~)  (c) for(f) i(ec) hold,(d) your(e) rewarJ(f)  (gfedc) is(egf) great(ed) in(cd) heaven.(d)  (d)   (ki~)  (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-143.png",
        nextFileName: "./pages/part-b-144.png"
    },
    {
        title: "part-b-143-1",
        gabc: "In(ij)  (cf) the(f) heavenly(f)  (f)  (gf) kingdom(e)  (fd)  (f) |(fg) rejoice(g) the(f) souls(gh) of(g) the(ghg)  Blessed,(f)  (f) who(f) fol-(df)lowed(f) the(gi)  (ih) footsteps(gh) of(hgf) Christ(g) their(ghg)  Master:(f) -(f)and(df) since(fg) for(f) love(hij) of(ih) him(gf) =(g) [(ii) scorned(h) this(gf)  vorld(ki~)  (g) of(ghg) e(f) \u2014vil,(f) therefore(f)  (gh) ot(h) Christ(ih) do(gf) they(gh) ex(hg)  ult(g) for(ghg) ev-(f)er,(f)  (h)  (f)  (h)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-143.png",
        nextFileName: "./pages/part-b-144.png"
    },
    {
        title: "part-b-144-0",
        gabc: "0(c) ve(d) Saints(f) of(f) 3(fg) Lord,(g) bless(hhg) ye(h) the(g) Lorq(f) 0(e)  ev-(d)er(f) and(gh) ev-(g)er,(g)  (g) S(g) O(d)  (f) U(ed) ",
        groupIndex: 0,
        filename: "./pages/part-b-144.png",
        nextFileName: "./pages/part-b-145.png"
    },
    {
        title: "part-b-144-1",
        gabc: "In(d) the(c) re-(d)ge-(f) (e) ne-(de)ra\u2014tion,(ddc) when(hf) the(fg) Son(gh) &amp;f(fe) man(dc) shall(d)  sit(fge) in(g) the(ghg) throne(fe) of(d) his(cd) glory,(d)  (d) ye(dhi) al-(hg)so(h) shall(j) sit(h)  up-(g)on(ef) twelve(gfe) thrones,(dfddc) judging(ffg)  (f) the(e) twelve(fhgf) tribes(ef) of(gf)  Is-(d)ra-(cd)el.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-144.png",
        nextFileName: "./pages/part-b-145.png"
    },
    {
        title: "part-b-145-0",
        gabc: "Go(cd) forth,(dhi) O(h) ve(h) daughters(hj)  (h) of(h)  (h) e(hghihg) and(f) behold(g)  (h) Ger-(hg) trude(g) with(fg) the(f) crown(f) wherewith(f)  (ef) Christ(gfe) crowned(def)  (fe) hen(ddc)  in(d) the(c) day(d) of(f) her(fg) es-(fe)pou-(gh)sals,(h) and(h) in(h) the(g) day(f) of(f)  the(g) gladness(f)  (ef) of(g) her(fe) heart.(d)  (h) e(g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-145.png",
        nextFileName: "./pages/part-b-146.png"
    },
    {
        title: "part-b-145-1",
        gabc: "0(eed) most(f) worthy(de) [(e) TBride(g) of(gh) a(g) whom(g) light(j) propEetic(h)  (gf) a(g)  :(gh) 11\u20141u\u2014mi-(g)ned,(fe)  (e) [(c) ;-(df)pos-(d)to&#39;\u2014lic(c) zeal(de) in-(fed)fla-(gh)med,(g) the(g) 3(hj)  rel(i)  garland(k)  (j) of(ji) virgins(h)  (hg) crowned,(hi) A(i) and(j) the(j) fire(hij) of(hg) love(def)  ;(ki~)  (gh) =(gfe) (\xa5(e)  (ji) [Tt(hih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-145.png",
        nextFileName: "./pages/part-b-146.png"
    },
    {
        title: "part-b-146-0",
        gabc: "C(e) les-(fe)tial(d) spirits(gh)  (g) e(e)  (g)  (f) descending(e)  (ghj)  (j) tq(ji) eart,(hg)  from(e) heaven;(fe)  (d) who(g) called(g)  (ef) Gertrude(f)  (e) to(d) the(g) Jjoys(gh) of(g) p,.(hj)  ra-(j)dise(j) with(k) me-(j)lo-(ji)di-(h)ous(ih) voices,(g)  (ef) saying:(gh)  (g) Come,(jj) 0(g)  come,(h) be-(g)lov-(fe)ed(d) one,(e) for(gh) heavenly(g)  (e) -(fe)delights(d)  (efgh) are(hg) a-(f) waiting(fe)  (d) thee,(e) al-(g)le~-(h)lu-(gjh~)ia,(j) al-(k)le-(ihgh)lu-(efgfe)ia.(e)  (ji) W,(hih) ",
        groupIndex: 0,
        filename: "./pages/part-b-146.png",
        nextFileName: "./pages/part-b-147.png"
    },
    {
        title: "part-b-146-1",
        gabc: "(0)(g) ev-(g)er(f) blessed(e)  (d) Mother(f)  (dddhg) of(dfgdd) God,\u2018r(dgd)  (cf) Ma-(j)ry(h) ev-(j)er(i) Virgil(g)  (g)  temple(j)  (k) of(j) the(djdfidf) S(ddfhdfhhhfhhhf~) B(jfd) )(ji)  (hdf) shrine(ghdfdfghfddf) of(fdg) the(dff) fis&#39;&quot;(dh) ",
        groupIndex: 1,
        filename: "./pages/part-b-146.png",
        nextFileName: "./pages/part-b-147.png"
    },
    {
        title: "part-b-147-0",
        gabc: "Spirit:(g)  (g) thou(gh) on(fg) ly,(f) a-(f)bove(f) all(hj) o(jk)  (kj) thers,(k) ac-(k) cep-(j)ta-(i)ble(hj) to(jk) our(ji) Lord(ghgf) Je(hijh) .sus(ih) Christ,(gh) al(i) le(h)  lu(g) 1ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-147.png",
        nextFileName: "./pages/part-b-148.png"
    },
    {
        title: "part-b-147-1",
        gabc: "D(ki~) a(e) a(e) O(e) [(e) B(e) Va-(g)le-(ff)ri-(f)an,(df) a(c) [)(efe) I(d)  \xa5ish(fh) to(gh) tell(egfe) thee:(e) I(e) have(g) an(fh) An-(h)gel(h) of(h) God(h) who(gf)  loves(ghge) a-(e))(e) guards(f) my(g) bo-(gh)dy(g) with(gf) ex-(d)ceed-(dg)ing(f)  Zea],(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-147.png",
        nextFileName: "./pages/part-b-148.png"
    },
    {
        title: "part-b-148-0",
        gabc: "organs(d)  (f)  (f) made(e) me(fg) lo(cfed) dy(def) Twhile(fd) Ce-(f)ci-(gh)lig(h) Sang(i) o(h)  gain(gg) to(e) the(f) Lord,(g) and(f) said:(d) Let(h) my(g) heart(j) be(h) soung(g)  thy(e) s(f) 5(d) that(d) I(f) be(g) not(ef) n(e) 2(d) shamed.(d) =(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-148.png",
        nextFileName: "./pages/part-b-149.png"
    },
    {
        title: "part-b-148-1",
        gabc: "Then(e) did(g) Va-(h)le-(hji)an(hi)  (i) L(j)  (h) findaCe=gi=)ia~insherschailies(i)  (h)  (g)  (h)  (ij)  (i)  with(h) an(f) An-(gfe)gel,(f) making(e)  (d) her(def) a(g) supplication.(f)  (e)  (e) ||(i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-148.png",
        nextFileName: "./pages/part-b-149.png"
    },
    {
        title: "part-b-148-2",
        gabc: "Ce-(g)ci-(hj)lia(j) Tthine(j) =(h) handmaid,(g) O(hiji) Lord,(hg) ev-(g)er(h) serveth(j)  (i)  \u2014}__I(h)  (j)  (ih)  thee(h) as(g) -(g)zealously(gf) as(d)  (fh) a(f) bu-(g)sy(f) bee.(e)  (j) \u2014}__I(h)  J&#39;(cgd) bless(fg) thee,(g) 10(f)  (fdg) Father(gfffgfgf) of(fddfdhffdfidfij) Lord(df) Je-(h)sus(i) Christ:(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-148.png",
        nextFileName: "./pages/part-b-149.png"
    },
    {
        title: "part-b-149-0",
        gabc: "for(g) by(g) thy(h) Son(ji) the(h)  (g) fire(ge) is(g) quenched(fe)  (f) round(d) a-(ef)bout(gh)  thine(h) handmaid.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-149.png",
        nextFileName: "./pages/part-b-150.png"
    },
    {
        title: "part-b-149-1",
        gabc: "I(ik)  (d) -(ef)de-(g)si-(g)rediof(g) the(g) Lord(gh) a(g) three(g) days\u2019(f) E(gf) respite,(e) \u2014(ef)  I(gf) micht(ef) hallow(gh) a(g) my(f) ](g) dwelling(ef) as(g) a(f) temple.(e)  (e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-149.png",
        nextFileName: "./pages/part-b-150.png"
    },
    {
        title: "part-b-149-2",
        gabc: "the(cc)  (d)  (f) dawn(d)  (cd) day(f) was(g) breaking,(fh)  (h) T(h) Ce~ci-(h)lia(g) the(g)  Martyr(ik)  (e)  (f) cri-(g)ed,(fe) saying:(d)  (d) %\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014f\u2014\u2014\u2014\u2014*(h) Forward,(g) soldiers(j)  (h) of(gf) Christ!(gh)  Cast(h) off(gh) tEe(fe) works(g) o|(def) darknEss,(df)  (fc) and(c) put(d) on(f) the(f) ar-(ef) mour(g) of(fe) 1jght.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-149.png",
        nextFileName: "./pages/part-b-150.png"
    },
    {
        title: "part-b-150-0",
        gabc: "T(ig~) his(h) no-(h)ble(fh) N(f) maiden(f) al(hh) +(fhge) bare(h) the(i) glo-(j)ri-(i)oyg(h) 0(i)  pel(gi)  (f) of(i) Christ(hg) in(e) her(gh) bosom:(f)  (f) I.:(e) without(f) -(hh) con-(gi) (i) ti-(ji)nu-(hi)ed(h) in(hi) prayer(j) and(i)  (j) supplication,(h)  (i) 10(h) and(gh) ce-(f)]es(f)  3(gi) tial(fi) con-(hi)verse,(f) night(hg) and(dgh) day.(f) el(h)  (g) e(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-150.png",
        nextFileName: "./pages/part-b-151.png"
    },
    {
        title: "part-b-150-1",
        gabc: "Let(ef) us(ed) all(ef) pray(e) Tto(f) our(h) Lord(ih) Je-(fh)sus(hg) Christ,(e) that(e) he(d)  would(f) o(hg) pen(ef) a(fgh) fountain(ij)  (h) for(f) his(h) Confessors.(g)  (e)  (ee) i(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-150.png",
        nextFileName: "./pages/part-b-151.png"
    },
    {
        title: "part-b-151-0",
        gabc: "While(g) ho(ighj) ly(i)  (ij) ClementTpray\u2014ed,(i)  (hih) Bl(hhg~) the(h) Lamb(hgf) of(gh) God(gf) ap-(e) peared(hf)  (gf) un-(e)to(de) him.(e)  (i) _I\u2014I(j)  (i)  (h) l(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-151.png",
        nextFileName: "./pages/part-b-152.png"
    },
    {
        title: "part-b-151-1",
        gabc: "Not(ii) for(g) my(ij) own(i) merits(hi)  (i) Tdid(i) the(i) Lord(i) send(g) me(h) un-(g)to(e)  you,(e) that(h) I(h) might(h) be(fh) made(g) partaker(f)  (e)  (f) of(h) your(g) crowns.(e)   (gi)  (i)  (j)  (i)  (h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-151.png",
        nextFileName: "./pages/part-b-152.png"
    },
    {
        title: "part-b-151-2",
        gabc: "Up-(gi) (i) on(i) the(g) mountain(ij)  (i) fI(i) .(i) a(g) Lemb(hg) K(e) [(e) from(h)  beneath(gi)  (h)  (h) whose(fh) foot(g) floweth(f)  (e) a(f) fount(f)  (gh) of(f) living(g)  (f) waters.(e)  (e)  [(ik)  (i)  (j) ](i)  (h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-151.png",
        nextFileName: "./pages/part-b-152.png"
    },
    {
        title: "part-b-152-0",
        gabc: "rom(i) [}(i) underneath(g)  (ij) his(i) foot(i) floweth(i)  (i) a(i) fount(ji) a(g) L](h)  (g)  waters:(e)  (e) a(h) river,(h)  (h) the(h) streams(h) whereof(fh)  (g) make(f) glad(e) the(f)  ci-(fh)ty(f) of(gf) God.(e) e(i) e(j) R(i)  (h) ST,(gh)  A(j) the(j) nations(jkj)  (ji) Troud(hj) about(j)  (i) believed(g)  (hf)  (fh) in(h) Christ(g)  Lord.(g)  (j) ANTIPHON(h)  (j)  (k)  (j)  W(ikcc) hen(d) he(d) had(f) start-(d):lta&#39;d(dc) going(f) O(g) to(f) the(h) sea,T(h) the(h) peo-(hjj)ple(hih)  cri-(h)ed(g) out(ef) with(g) loud(fe) voices,(d)  (d) O(f) Lord(fed) Je-(fg)sus(gf) Christ(ed)  save(fe) -(dc)a(c) Clement(cd)  (d) B(d) responded,(d) [(c) weeping,(ffg) =(f) Hee-(f) (fh) ven-(g)1(f)  a-(fe)ther,(c) receive(cd)  (f) my(gf) spirit.(d)  (d)  (h) :(g)  (df)  (gh)  (dgf)  (d) 456(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-152.png",
        nextFileName: "./pages/part-b-153.png"
    },
    {
        title: "part-b-153-0",
        gabc: "princes(h)  (hg) *(fgh) In(fd) all(fg) lands.(gf) Thou(f)  (f)  Thou(f) shalt(f) make(g) them(f)  shalt(i)  (f) make.\xa5.(g) They(hi) shall(h) remember(h)  (fh) cervenstmomnte|(g) thy(gf) Name,(g) O(gh) Lord.(hg)  H.&#39;In(fd) all(fg) lands.(gf) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(fgh) the(g)  Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) Thou(f) shalt(f) make.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-153.png",
        nextFileName: "./pages/part-b-154.png"
    },
    {
        title: "part-b-153-1",
        gabc: "hou(fg) shalt(f) make(fe)  (dc) \xa2(jifghi)  (h)  (efh) Tn(gfe) all(ghgf) lands.(f)  (efgh)  (f) Thou(fg) ",
        groupIndex: 1,
        filename: "./pages/part-b-153.png",
        nextFileName: "./pages/part-b-154.png"
    },
    {
        title: "part-b-154-0",
        gabc: "shalt(f) make.(fe)  (c) They(f) shall(f) remember(f)  (gh)  (f) tihy(fe) 0(dc)  (fghi)  (h)  R.(ik) In(gfe) all(hgf) lands.(f) V.(c) Glory(f)  (f) be.(g) Thou(fg) shalt(f) nghe,(fe) ",
        groupIndex: 0,
        filename: "./pages/part-b-154.png",
        nextFileName: "./pages/part-b-155.png"
    },
    {
        title: "part-b-154-1",
        gabc: "will(d)  (d) de-(dc)liv-(f)er(gh)  (hgg) up(f) to(gh) the(fe) councils,(d)  (d) and(g) they(g)  \u2014(g) scourge(h) you(fgf) in(e) their(f)  (g) WP(fe) synagogues;(d) and(d) ye(dc) shall(f) =(g)  brought(h) before(g)  (f) governors(gh)  (fe)  (d) and(fed) kings(ed) for(dfgf) my(fd) sake;(fgf) 1or(df)  a(fg) testimony(h)  (g)  (f)  (g) against(gh)  (g) them(dfedc) Tw(c) the(d) =(ffg) 7(d)  (hgfdgh)  (dgdf) ",
        groupIndex: 1,
        filename: "./pages/part-b-154.png",
        nextFileName: "./pages/part-b-155.png"
    },
    {
        title: "part-b-155-0",
        gabc: "is(j)  (ji) my(hg)  (hih) commandment,t(gh)  (g) el(h) that(g) ye(g) love(g) one(e) o(g) another,(fe)  (f)  as(jk)  as(d) I(e) have(f) loved(gh)  (h) you.(g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-b-155.png",
        nextFileName: "./pages/part-b-156.png"
    },
    {
        title: "part-b-155-1",
        gabc: "(Greater(dd) ](c) love(d) hath(fe) no(def) man(f) than(fghg) :,(ih) this,(ih)  (h) that(h) a(g) man(df)  =(fg) down(hf) his(g) life(fe) for(cd) his(fe) R(d) ||(h) S(f) @(e) 5(c)  (d) |(fg) ",
        groupIndex: 1,
        filename: "./pages/part-b-155.png",
        nextFileName: "./pages/part-b-156.png"
    },
    {
        title: "part-b-155-2",
        gabc: "-(dh)are(j) my(hg) frien&amp;,f(h) if(fe) ye(def) do(cfgc) [(e) so-(f)ev-(gh)er(g) 1(fg) com-(f) mand(ef) you,(dc) saith(d) the(efe) Lord.(d)  (h)  (g)  (f)  (gh) ;(gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-155.png",
        nextFileName: "./pages/part-b-156.png"
    },
    {
        title: "part-b-155-3",
        gabc: "BleSSEd(d)  (dc) are(f) the(g)  (f) peacemakers,T(gh)  (h) blessed(hi)  (h) are(g) the(g) pure(f)  \\\\;(gh) A(g) for(gg) they(ef) e(g) ](fe) God.(d) |(h) o(h) tiah(g)  (f) i)(gh) R(gf) ",
        groupIndex: 3,
        filename: "./pages/part-b-155.png",
        nextFileName: "./pages/part-b-156.png"
    },
    {
        title: "part-b-156-0",
        gabc: "In(dd) your(cd) LTSI(fe) patience(dc) e(f) possess(fg) ye(e) your(fe) souls,(d) I(f) ](e)  (c)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-156.png",
        nextFileName: "./pages/part-b-157.png"
    },
    {
        title: "part-b-156-1",
        gabc: "Their(c)  (c)  (f) sound(g) is(f) gone(gh) out(hg) In-(g)to(fd) all(fg) lands.(gf) Treir(f) so(g)  .(c) And(h) their(h) words(hi) %.(h)  (gh) ends(g)  (gf) of(g) the(gh) world,(hg)  In-(g)to.(fd) Glory(h)  (h) be.(h) Their(f) sound.(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-156.png",
        nextFileName: "./pages/part-b-157.png"
    },
    {
        title: "part-b-156-2",
        gabc: ".(ik) .(dc)  (cf) -(ed)e(dh)  (h) s(g) e(f) T(eghd) ](f)  (ed)  (ed) ](g)  \xae(ge) 2(f)  (e)  (ded)  (dh)  (g)  (h)  (g)  (f)  (h)  (g)  (hhgfed)  X,(dg) They(g) declared(f)  (ghg) the(gd) work(f) of(e) God.(defdcd) ",
        groupIndex: 2,
        filename: "./pages/part-b-156.png",
        nextFileName: "./pages/part-b-157.png"
    },
    {
        title: "part-b-157-0",
        gabc: "Y(dd) which(c) have(df) for-(fe)sa-(fg)ken(fed) all,T(df) and(cd) fol(ffd) low-(fh)ed(fgh) me,(g)  shall(hi) receive(g)  (f) an(f)  (g) hundredfold,(fe)  (df) and(efh)  (dc) shall(dd) in-(cd)her-(f)it(f)  [}(e) ev\u2014er-(f)lasting(g)  (fe) life.(d) Melody(h)  (g) is(f)  (gh) used(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-157.png",
        nextFileName: "./pages/part-b-158.png"
    },
    {
        title: "part-b-157-1",
        gabc: "he(gi) Lord(k) sware,(jkj) and(j) will(h) not(jh) re-(ih)pent:(g) Thou(g) art(fe) a(d)  Priest(ef) for(gh) .-(g)8-(g) (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-157.png",
        nextFileName: "./pages/part-b-158.png"
    },
    {
        title: "part-b-157-2",
        gabc: ":&#39;May(ji) the(hg) Lord(hih) set(fh) him(g) with(fge) the(g) princes(dfe)  (d) of(f) his(gh)  People.(g)  (g)  (f) =(j)  (h)  (j)  (k)  (j) ",
        groupIndex: 2,
        filename: "./pages/part-b-157.png",
        nextFileName: "./pages/part-b-158.png"
    },
    {
        title: "part-b-158-0",
        gabc: "Thou,(c)  (e) 0(f) Lord,(h) hast(h) broken(ij)  (i) 1&#39;my(ih) bonds(f) in(h) ..(fg)  (e) I(f) 2(e)  offer(gi)  (d) &quot;(e) to(f) thee(h) :(ge) sacrifice(gh)  (f)  (f) 3(g) of(f) thanksgiving,(e)  (e)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-158.png",
        nextFileName: "./pages/part-b-159.png"
    },
    {
        title: "part-b-158-1",
        gabc: "F(h) irmly(h) stab-(ihij)1ished(i)  (i) tis(ih) their(fh) prince-(ghffe)dom:(e) and(f) highly(e)  (d)  a(e) honoured(f)  (f) are(f) thy(i) e(fh) 0(gf) Vo(e) e(j)  (i) (|(h) )|(ih) ",
        groupIndex: 1,
        filename: "./pages/part-b-158.png",
        nextFileName: "./pages/part-b-159.png"
    },
    {
        title: "part-b-158-2",
        gabc: "Be(c)  (ch) ve(g) valiant(h)  (g) in(f) warfare,(g)  (d) and(hhi) contend(h)  (jk) ye(jkj) with(ji) the(g)  old(ij) ser-(hih)pent:(h) s(h) ve(ghg) shall(e) e(f) receivefan(gh) -(g)|(g) ter-(hf)nal(g)  .(i)  (fe) .(dc) W(d) al\u2014le\u2014lu-(efe)el(d) ia.(d) \u20AC(dg)  (e) ~ter(dg)  nal(ik)  (fe) kingdom.(d)  (d)  (h)  (g) .(f)  (gf)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-158.png",
        nextFileName: "./pages/part-b-159.png"
    },
    {
        title: "part-b-159-0",
        gabc: "Ligbt(f) per-(f)pe-(g)tu-(f)al(f) shall(f) shine(f) up-(f)on(f) thy(e) Saints,(g) O(g)  Lord,(h) *Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) Light(f) perpe-(f) (g) tual.(f)  (f)  And(f) an(f) ageless(f)  (f) e(e) ter-(g)ni-(g)ty.(h) Al-(h)le(hg) lu-(g)ia.(f)  Glory(f)  (f) be(f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g)  Ho-(h)ly(g) Ghost.(gf) Light(f) per-(f)pe~tu-(g) (f) al.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-159.png",
        nextFileName: "./pages/part-b-160.png"
    },
    {
        title: "part-b-159-1",
        gabc: "[(efg)  (fe)  (d)  (e)  (dc) p(d) e(fd)  (efe) e(edc) e(g) e(h)  (i)  |(j)  (ihg) [Tl(j)  (ihg)  (ih) s(g) [\xab(hg) 9(fed) e(efg) (78(f)  (e)  i(h)  (g)  (h)  (ihg) D(h)  (gfdefg) L(fe)  (e) |(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-159.png",
        nextFileName: "./pages/part-b-160.png"
    },
    {
        title: "part-b-160-0",
        gabc: "L(gi) ight(h) per-(h)pe-(h)tu-(f)al(g) x;ha.]l(h) shine(i) up-(g)on(hi) thy(gh) Saints,(f)  (ef) Lorg(f)  and(gi)  (h) an(i) ageless(j)  (i) e-(h)ter-(i)ni-(h)ty,(gh) al-(i)le-(ih)lu-(g)ia.(g)  (j) =(i)  (j)  (kj)  (ihg) ",
        groupIndex: 0,
        filename: "./pages/part-b-160.png",
        nextFileName: "./pages/part-b-161.png"
    },
    {
        title: "part-b-160-1",
        gabc: "hy(h)  (hih) Lord,(h)  (fh) shall(gf) blossom(e)  (e) as(i) a(hf) li-(h)ly,(gh) al-(hi)le-(f) lu-(e)A(e) L](e) as(g) the(h) o-(i)dour(h) of(i) balsam(ih)  (i) ahall(ii) they(ef) be(h)  be-(h)fore(gf) thee,(e) al-(gf~)le-(f)lu-(e)ia.(e) ___l_l(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-160.png",
        nextFileName: "./pages/part-b-161.png"
    },
    {
        title: "part-b-160-2",
        gabc: "In(e) the(e) heavenly(h)  (g)  (h) kingdom(hij)  (i) the(h) Blessed(j)  (k) have(j) their(i) dwell-(j) ing-(gi) (i) place,(h) al-(ji~)le-(j)lu-(i)ia:(i) and(ji~) their(i) rest(hd) -(f)ev-(hf)er(g) and(i) ",
        groupIndex: 2,
        filename: "./pages/part-b-160.png",
        nextFileName: "./pages/part-b-161.png"
    },
    {
        title: "part-b-161-0",
        gabc: "ev-(hg)er,(ef) al-(g)le-(f)lu-(e)ia.(e) S(j) e(i)  (h) e(gf)  :(gi)  (ff) blessed(e)  (fh) Saints,(hg) &#39;C(fe) Lord,(h) 1-(h)cri\u2014ed(i) out(j) within(ih)  (i) the(j)  7(gi) veil,(j) al(h) le(jhk) lu-(i)ia,(h) al-(i)le-(h)lu-(h)1a,(fe) al-(f)le-(ghg)lu-(f)ia.(f) |(f)  Spiritus(h)  (g)  (e) et(f)  O(h) ye(fg) spirits(g)  (g) and(g) souls(gf) tof(gh) the(fe) righteous,(d) L(d) sing(g) a(g) hymn(g)  un-(h)to(g) the(f) Lord(g) our(gh) God,(f) al-(fh)le(j) -(ihj)ia,(hgf) al-(gh)le-(h)lu-(g)ia.(g)  S(j) Fulgebunt(i)  (j)  (h) justi(gh)  :(f) shall(h) the(g) righteous(fg)  (fge) shine(ih) RN(ji) o(h) the(g) sun(fhih)  i(gi)  (e) the(f) 5(h) T(dhg)  (fe) s(f) 7(ghg) s(f) S(f) |(d) e(h)  (g) T(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-161.png",
        nextFileName: "./pages/part-b-162.png"
    },
    {
        title: "part-b-162-0",
        gabc: "O(ik)  (f) ye(f) ho-(f)ly(f) and(f) \xa5(g) righteous,(f) rejoice(f)  (f) a(e) the(g) Lorg,(h) Al(h)  le(ik)  (hg) lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) O(f) ye(f) ho-(f)ly.(f)  (d) \xa5.(c) God(f) haty(f)  chosen(f)  (f) you(f) to(f) him(g) to(f) be(f) his(f) a(e) he-(g) (g) ri-(h)Al(h)  le-(hg)lu-(g)ia.(f) X.(c) Glory(f)  (f) be.(f) O(f) ye(f) ho-(f)ly.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-162.png",
        nextFileName: "./pages/part-b-163.png"
    },
    {
        title: "part-b-162-1",
        gabc: "-(f) (ffe) a(d)  (e) a(g)  (h) -(f) (e)  (g)  (h)  (g)  (hjji)  L(g) i(g)  (f)  (fgh)  (h)  (h) 0(g)  (hjji)  (gf)  (h)  (h)  (dffe)  7.(ed) O(c) dear(eg) in(gfh) the(fgf) sight(g) of(fe) the(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-162.png",
        nextFileName: "./pages/part-b-163.png"
    },
    {
        title: "part-b-162-2",
        gabc: "D(c) \u2014_\u2014\u2014(c) aughters(d) of(f) Je-(gf)ru-(d)si-(cd) (d) t(h)  (cd) forth(ffgh) and(d)  (fh) behold(dffddfgddf) ",
        groupIndex: 2,
        filename: "./pages/part-b-162.png",
        nextFileName: "./pages/part-b-163.png"
    },
    {
        title: "part-b-163-0",
        gabc: "the(d) Martyrs\u2019(fe)  (dc) with(c) the(cg) di&#39;\u2014(g) a(fghg) dems(fed) wherewith(c)  (d) the(dg)  Lord(i)  (fe) hath(dc) crowned(d)  (efe) them(d) in(hiji) the(h) day(gfd) of(e) so-(f)lem-(gh)ni-(g) ty(gf) and(d)  (f) rejoicing,(de) =(dc) &amp;1(cd) le(fgfe) lu-(ghg)ia,(fedc) al-(dg)le-(efe)lu-(d)ia.(d)  Hymn(h) a(g)  (f) a(g) Melody(gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-b-163.png",
        nextFileName: "./pages/part-b-164.png"
    },
    {
        title: "part-b-163-1",
        gabc: "cO(g) ye(f) ho-(gf)ly(e) and(f)  (h) -(g)rejoice(g)  (h) in(ggh) the(f) Lord,(fh) al-(h) le-(fg)lu=jia:(gh)  (g) God(g) hath(g) chosen(h)  (fg) you(g) to(fh) him(f) to(h) be(f) his(g) in-(h) b(j) i(ih) tance,(hjk) al(h) le-(h)lu-(g)ia.(g) |(j) e(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-163.png",
        nextFileName: "./pages/part-b-164.png"
    },
    {
        title: "part-b-164-0",
        gabc: "hou(f) hast(gh) set(hg) Up-(f)on(f) his(gh) head,(gfd) O(fg) Lord,(gf) Thou(f) hast(gh) o(hg)  M.(jk)  M.(c) A(hi) crown(g) of(f) pure(gh) B(hg) Up-(f)on(f) his(gh) head.(gfd) Glory(h)  (h)  be(h) to(h) the(h) Father(hi)  (h) and(h) to(h) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)P(g)  Ghost.(gh) Thou(f) hast(gh) [(hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-164.png",
        nextFileName: "./pages/part-b-165.png"
    },
    {
        title: "part-b-164-1",
        gabc: "[(c) I(fe) e(fg) o(g) |(gh)  (hg)  (f)  (g)  (f)  (hg)  (hj)  (jk)  I(ji) W(g) e(gh) OO(hgf) s(fgh)  (h) w0(gf)  (g)  (fe)  (dc)  (de)  (edc)  L](g) ](g) hast(hj) crowned(j) :(hg)  (e) with(f) P(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-164.png",
        nextFileName: "./pages/part-b-165.png"
    },
    {
        title: "part-b-165-0",
        gabc: "This(f) is(e) 2(d) l\\\u2018!ar\u2019ter(ef)  (e) who(df) strove(h) for(h) his(h) Master\u2019s(hi)  (h) precepts,(hg)  (f)  e-(h)ven(f) un\u2014-(d)to(de) death:(e) and(df) feared(hhi)  (h) not(h) the(ih) words(i) of(iji) e-(h)vil(fh) men,(h)  forasmuch(h)  (h)  (i) as(g) he(h) was(f) stablished(h)  (e) an(efe) on(c) a(d) sure(ef) foundation.(f)  (e) -(e) AT(h)  (g)  (h)  (f)  (ef) ",
        groupIndex: 0,
        filename: "./pages/part-b-165.png",
        nextFileName: "./pages/part-b-166.png"
    },
    {
        title: "part-b-165-1",
        gabc: "bo:so-(d)ev-(f) (d) er(dc) shall(f) confess(g)  (fh) me(h) tbefore(gf)  (h) men,(g) him(gg) a(e) I(g)  confess(h)  (fg) al-(fe)so(c) before(e) g(ge) my(fe) Father.(d)  (d) RS(h) m(g) e(f) o(gh) 0(gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-165.png",
        nextFileName: "./pages/part-b-166.png"
    },
    {
        title: "part-b-165-2",
        gabc: "cHe(g) that(g) followeth(ghj)  (h)  (ghhj) me(j) Tshall(i) not(j) walk(k) in(hj)  (ji) darkness,but(hg)  (g)  shall(jk)  (jk)  shall(h) have(j) the(i) light(h) a(g) life,(hhj) a(g) the(gf) Lord.(e)  (j)  (h)  (j)  (fih) ",
        groupIndex: 2,
        filename: "./pages/part-b-165.png",
        nextFileName: "./pages/part-b-166.png"
    },
    {
        title: "part-b-166-0",
        gabc: "f(df) a-(d)ny(dc) man(fg) serve(fgh) me,(h) let(ih) him(g) follow(f)  (gh) me;(g) ang(g) wherg(eg)  I(hgf) am,(f) there(g) shall(f) al-(f)so(e) my(f) servant(g)  (f) be.(d)  (h)  (g)  (f)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-166.png",
        nextFileName: "./pages/part-b-167.png"
    },
    {
        title: "part-b-166-1",
        gabc: "If(d) a-(d)ny&#39;(dc) man(f) have(g) served(f)  (h) me,(h) he(f) shall(f) be(ih) honoured(g)  (f)  (gh) of(f)  my(ik)  (ef) Father(d)  (d) which(g) is(fh) in(f) heaven,(fe)  (dc) saith(d) the(efe) Lord.(d)  (h)  (g) 1(f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-166.png",
        nextFileName: "./pages/part-b-167.png"
    },
    {
        title: "part-b-166-2",
        gabc: "Fathe_r,T(fe) .(d) I(d) will(e) that(f) where(g) I(h) am,(g) there(h) may(g) al-(f)so(e)  my(f) [}(g) servant(f) be.(d) J(h)  (g)  (f)  (gf)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-b-166.png",
        nextFileName: "./pages/part-b-167.png"
    },
    {
        title: "part-b-166-3",
        gabc: "hou(f) hast(f) -(g)crowned(fh) him(hg) With(g) glory(fg)  (g) and(fhh) honour,(g)  (fd) 0(gf~)  Lord.(gf) Thou(f) hast(f) crowned.(g)  (gh) X.(c) And(h) madest(hi)  (h) him(h) to(h) have(h) ",
        groupIndex: 3,
        filename: "./pages/part-b-166.png",
        nextFileName: "./pages/part-b-167.png"
    },
    {
        title: "part-b-167-0",
        gabc: "dominion(h)  (h)  (g) of(g) the(h) works(g) of(f) thy(fh) hands.(hg) With(g) glory.(f)  (g)  X.(c) Glory(h)  (h) he.(h) Thou(f) hast(f) crowned.(g)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-167.png",
        nextFileName: "./pages/part-b-168.png"
    },
    {
        title: "part-b-167-1",
        gabc: "a(e) a(e) r.(ed) a(g) |(gh)  (j) a(j)  (ih) e(i) 0(j) a(i) a(h)  (g)  A(hiji)  (hg) e.(g) i(gh) 30(j)  (i) [suidimaDwsy(h) e(g) -(i)a(g) [,(hg)  The(hi) :(g) righteous(h) shall(fe)  (d) flourish(efg) like(fe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-167.png",
        nextFileName: "./pages/part-b-168.png"
    },
    {
        title: "part-b-167-2",
        gabc: "He(ghjj) that(j) ha-(j)teth(ji) his(hi) life(h) tin(g) this(hj) world(ij) shall(ij) keep(k)  it(i) un-(j)to(hg) life(hgf) e-(g)ter-(e)nal.(e) |(ji) \u2014l(hi)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-167.png",
        nextFileName: "./pages/part-b-168.png"
    },
    {
        title: "part-b-168-0",
        gabc: "W(cc) ho-(d)so-(f)ev-(d)er(dc) will(f) come(g) after(f)  (gh) me,(h) let(ih) him(g) de-(g)ny(f) hip.(hg~)  self,(g) and(g) take(ef) up(h) his(g) cross,(ff) and(f) EERGER(g) follow(fe) me.(d) I(h)  (g)  (fh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-168.png",
        nextFileName: "./pages/part-b-169.png"
    },
    {
        title: "part-b-168-1",
        gabc: "._L(ik) et(f) the(f) righteous(g)  (f) rejoice(gh)  (hg) Before(fd)  (fg) God.(gf) Let(f) the(f) right-(g) eous(i)  (f) rejoice.(gh)  (hg) Let(hi) them(h) al-(gh)so(g) be(g) merry(h)  (g) and(f) jOYfUI&#39;(h)  (hg)  Before(fd)  (fg) God.(gf) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g)  Son,(g) and(g) to(h) the(g) Mo-(f)ly(g) Ghost.(gh) Let(f) the(f) righteots:(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-168.png",
        nextFileName: "./pages/part-b-169.png"
    },
    {
        title: "part-b-169-0",
        gabc: "](e)  (g)  (h)  (ij)  (ih) e(i)  (e)  (fg)  (h) e(gfe)  (f)  (e)  [](e)  (g) &amp;(h)  (ij) a(ih) 3(i) \u2014(e)  (fg)  (h)  (gfe)  (f)  (e)  (ef)  g(ih)  (i)  (hj) \uFB01-(k) (k)  (ji) L(k)  (j) \u201C(j)  (i)  (ih)  (fgfg)  L(ghi)  (f)  (ed)  (e)  (f)  (g)  (hgf)  (fe) ",
        groupIndex: 0,
        filename: "./pages/part-b-169.png",
        nextFileName: "./pages/part-b-170.png"
    },
    {
        title: "part-b-169-1",
        gabc: "For(g) theirs(gj) is(h) the(g) kingdom(h)  (g) of(f)  (gh) heaven,(g) who(h)  (j) despised(j)  (g)  %g(h)  (j) =(ij) living:(j) who(i) have(j) won(k) the(j) rewards(i)  (j) of(h) &quot;(g) king-(h) dom,(ghihgg) .(e) have(f) washed(g)  (h) B(gf) dl(efd) in(g) the(h) blood(ghijh)  \u2018(i) the(ffh) MY(g) &amp;(j) =(i) e(ff)  (dj) e(h) o(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-169.png",
        nextFileName: "./pages/part-b-170.png"
    },
    {
        title: "part-b-170-0",
        gabc: "(O(g) how(gd) great(fh) torments(g)  (g) have(c)  (g) all(h) the(f) Saints(gh) en=(h)  ed,(dffedd) a(c) they(d) might(fg) surely(g)  (h) attain(g)  (ij) to(h) \u2018the(g) paln(h)  of(gf) martyrdom.(h)  (g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-170.png",
        nextFileName: "./pages/part-b-171.png"
    },
    {
        title: "part-b-170-1",
        gabc: "T(c) le(h) Plessed(fg) a-(g)Twith(g) their(h) palms(j) have(i) en(j) ter-(i)ed(h) in-(j)to(g)  the(h) king-(h)dom;(hghih) they(f) have(g) ear(hgfg) ned(gf) their(h) di(j) a-(i)dems(j)  of(ki~)  (h) glory(j) a(g) from(h) the(gf) hand(hg) of(h) God.(g)  (j) BT(i)  (j)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-170.png",
        nextFileName: "./pages/part-b-171.png"
    },
    {
        title: "part-b-170-2",
        gabc: "fe(dc) bodies(f)  (g) of(f) the(gh) Saints(h) Tare(h) bu-(h) (hg) ri-(f)ed(gh) 1n(ef) peace:(d) ",
        groupIndex: 2,
        filename: "./pages/part-b-170.png",
        nextFileName: "./pages/part-b-171.png"
    },
    {
        title: "part-b-171-0",
        gabc: "and(g) their(g) name(gh) liveth(fg)  (fe) for(dc) ev-(d)er(efe) \u2014more.(d)  (fgh) e(h) e(g)  (f) )(gh) P(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-171.png",
        nextFileName: "./pages/part-b-172.png"
    },
    {
        title: "part-b-171-1",
        gabc: "0(d) T(c) Martyrs(d)  (f) of(f) the(fg) Lord,T(g) bless(h) ye(g) the(f) Lord(e) for(d)  ev-(f)er(f) and(gh) ev-(g)er.:(g)  (g)  (d)  (f)  (ed) ",
        groupIndex: 1,
        filename: "./pages/part-b-171.png",
        nextFileName: "./pages/part-b-172.png"
    },
    {
        title: "part-b-171-2",
        gabc: "O(ki~)  (j) choir(i) of(j) L(hg) Martyrs,t(h) praise(gf) ye(g) the(h) Lord(j) of(h) heav\u2019n,(hj)  al-(h)le-(h)lu-(g)ia.(ef)  (j)  (h)  (j)  (k)  (j)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-171.png",
        nextFileName: "./pages/part-b-172.png"
    },
    {
        title: "part-b-171-3",
        gabc: ":(c) Be(c)  (f) glad,(g) O(f) ye(f) g(gh) [T(hg) TR(g) And(f) v(fh) i(gfd) e(f) e(g) )(gf) |(efg)  Be(f) glad.(g) X.(efghifhic) And(hi) be(h) joyful,(fh)  (g) all(j)  (g) ye(h) that(g) are(f) true(g) of(gh)  eart.(hg) |(hdefhi) .(f) And(df) rejoice.(ghf)  (gfd) o(fdd) .(ffc) Ay(h) Glory(d)  (h) be.(h) B.(efhij) Pe(f) glad.(g) |(efgh)  eart.(d)  (d) ",
        groupIndex: 3,
        filename: "./pages/part-b-171.png",
        nextFileName: "./pages/part-b-172.png"
    },
    {
        title: "part-b-172-0",
        gabc: "A(fgf) a(e) a(g) -(fgh) (hg) U(fe) s(d)  (e) :P\u2014Q(fe)  (d)  LT(fe) GO(d) Gape(c)  (d) TR(f) WRSSMs(d)  (c) i(e) 17(df)  (d)  (c)  (e)  V.(f) the(g) Saints(fgh) be(hg) joyful(ed)  (f) with(gf) glory.(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-172.png",
        nextFileName: "./pages/part-b-173.png"
    },
    {
        title: "part-b-172-1",
        gabc: "be(f) ve-(d)ry(f) hairs(h) of(hg) your(f) head(h) Tare(hi) all(kj) numbered:(i)  (h)  (i) fear(h)  Ye(f) not(fg) )(d) therefore,(d) ye(g) are(g) of(g) more(e) value(g) B(fe) than(d) ma-(eg)ny(f)  sparrows.(d)  (d)  (i)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-172.png",
        nextFileName: "./pages/part-b-173.png"
    },
    {
        title: "part-b-172-2",
        gabc: "These(gic)  (h) are(hg) the(e) ho-(gh)ly(f) ones(f) who,(ff) for(e) the(f) co-(h)ve-(fg)nant(f) 9%(f)  God,(e) have(e) de-(f)liv-(fij)B(hg) d(fe) up(f) their(hg) ho(f)  (gdhed) dies,(dhfded)  (fddfh) am(deffd) ",
        groupIndex: 2,
        filename: "./pages/part-b-172.png",
        nextFileName: "./pages/part-b-173.png"
    },
    {
        title: "part-b-173-0",
        gabc: "qashed(g)  (h)  (gf) their(hi) robes(i) in(e) the(f) blood(hg) of(e) the(fh) Lamb.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-173.png",
        nextFileName: "./pages/part-b-174.png"
    },
    {
        title: "part-b-173-1",
        gabc: "The(c)  (f) Saints(e) through(fh) faith(h)  (gf) Sub-(fe)du-(f)ed(hg) kingdoms,(gf)  (f) wrought(ff)  {(g) righteousness,(h)  (hj)  (i) ob~tain-(i) (jjki) =(ghg) the(ef) prom-(hgih)is-(f)es.(f)  (h)  (g)  (ef) ",
        groupIndex: 1,
        filename: "./pages/part-b-173.png",
        nextFileName: "./pages/part-b-174.png"
    },
    {
        title: "part-b-173-2",
        gabc: "The(g) youth(h) of(f) all(g) the(h) ho-(j)ly(j) Saints(i) Shall,(g) like(i) the(j)  eagle\u2019s,(h)  (g) be(h) re-(g)newed:(f) And(g) as(g) the(f) li-(g)ly(h) shall(j) they(j)  bloom(i) :(i) the(j) ci-(h)ty(h) of(i) the(h) Lord.(g)  (j)  (i)  (j) |(h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-173.png",
        nextFileName: "./pages/part-b-174.png"
    },
    {
        title: "part-b-173-3",
        gabc: "od(ehg) shall(h) wipe(i) a-(hg)way(fi) all(gh) t.e-(ef)from(f) the(f) of(ed)  (fghf)  he(gf) Saints:(e) L(e) there(ehg) e(d)  (d)  (ih) |(iji)  (hg) more(hi) sorrow,(i)  (i) ",
        groupIndex: 3,
        filename: "./pages/part-b-173.png",
        nextFileName: "./pages/part-b-174.png"
    },
    {
        title: "part-b-174-0",
        gabc: "neither(j)  (k) crying,(j)  (i) neither(j) shall(j) there(i) be(gf) a-(h)qv(ih)  (fg)  T(e) for(f) the(ed) former(e)  (fh) things(hgf) are(gh) pass-(ih)ed(f) a-(f)way(e)  a(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-174.png",
        nextFileName: "./pages/part-b-175.png"
    },
    {
        title: "part-b-174-1",
        gabc: "[(f) the(f) heavenly(f)  (f)  (gf) king\u2014-(edf) (f) domT&#39;rejoice(fg)  (g) the(f) souls(fh) of(g)  the(ghg) Blessed,(f)  (f) who(f) fol-(df)low\u2019d(f) the(gi) footsteps(ih)  (h) of(hgf) Christ(g)  their(ghg) Master:(f)  (f) and(df) since(fg) for(f) love(hij) of(ih) him(gf) they(g)  (i)  (h)  forth(fg) their(ghg) life-(f)blood,(f) therefore(f)  (gh) with(h) Christido(idih)  (ddd)  (gdf)  (d)  (dd)  they(h) ex-(hg)ult(g) for(ghg) ev-(f)er.(f) B(h)  (f) B(dgh) e(gddfddd) ",
        groupIndex: 1,
        filename: "./pages/part-b-174.png",
        nextFileName: "./pages/part-b-175.png"
    },
    {
        title: "part-b-175-0",
        gabc: "Lord(f)  (fg) chose(gh) him(hg) For(g) a(f) priest(fh) un-(g)to(fd) himself.(fg)  (gf) The(f)  Lord.(ik)  (fg) To(h) of-(hi)fer(h) un-(fh)to(g) him(g) the(g) sacrifice(h)  (g)  (f) of(fh) praise.(dhg)  For(g) a(f) priest.(gh) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g)  Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) The(f) Lord.(fg) ",
        groupIndex: 0,
        filename: "./pages/part-b-175.png",
        nextFileName: "./pages/part-b-176.png"
    },
    {
        title: "part-b-175-1",
        gabc: "The(f) Lord(f) chose(g) him(f) for(f) a(f) priest(f) a(e) unto(g) himself,(g) v(h) *Al-(h)le(hg)  lu-(g)ia,(f) al-(d)le-(fg)1(gf) ia.(f) The(f) Lord.(f) To(f) offer(g)  (f) e(f) untohim(f)  (f) the(f)  L(f)  (e)  (g) of(g) praise.(h) Al-(h)le-(hg)lu-(g)ia.(f) \xa5.(c) Glory(f)  (f) be(f) to(f) [(e)  Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g) Ho-(h)ly(g) Ghost.(gf) B.The(f) Lord.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-175.png",
        nextFileName: "./pages/part-b-176.png"
    },
    {
        title: "part-b-176-0",
        gabc: "\u2014\u2014(ghg)  (e)  (f) T(g)  (g)  (h)  (f)  (h) e(j)  (ih)  (g)  (j)  \xa3(h)  (j)  (ih)  (g)  (h)  (g)  (e) .(f)  (g)  (g) 0(g)  (e)  (g)  For(ki~)  (fe)  (dc)  (c)  (d)  (e) a(f) Doctor(fgh) \u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014ha(h)  (f)  (h)  (ijh) viij(i)  (h)  (g) &#39;(g)  A(ghg)  (e)  (f)  (ed) L}(de)  (c) .(e)  (g)  (h)  (h) [(g)  (ghg)  (e)  a(f)  (ed)  (de)  (c) [(e)  (g) .(h)  (h)  (g) i(jj)  (h)  (j) |(ih)  7(ik)  (gf)  (j)  (h) &quot;(j)  (i) a(h)  (g) .(hih) an.(gg) .(e) Tarwel(f)  (g) |(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-176.png",
        nextFileName: "./pages/part-b-177.png"
    },
    {
        title: "part-b-176-1",
        gabc: "()(dd) a(c) Priest(d) and(f) Bishop!(d) B(dfddc) Tthou(fg) worker(h)  (g) of(f) .(gh) mighty(gf)  (d)  works,(f) thou(h) good(g) shepherd(h)  (g) of(ef) the(f) people,(g)  (dddgdfeddd) pray(d)  (ffdgdddfdefddf) i(fdefdf)  Lord(ki~)  (d) for(cd) us.P.T.(d) Al-(e)le=(fe) lu-(dd) (dd) ia.(d) -(ddddd) (ddhddg) i(fd)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-176.png",
        nextFileName: "./pages/part-b-177.png"
    },
    {
        title: "part-b-177-0",
        gabc: "Teacher(h)  (g) right(fg) .(gf) ex\u2014cellent,(ef)  (f) 0(f) light(g) of(hf) Ho-(g)1y(f) Church,(e)  0(g)  (f) blessed(cf)  (f) N.,*(jghijijkj) lover(j)  (i) of(h) the(hg) divine(fh)  (hhg) law:(e) in-(ehh) tercede(f)  (gf) for(def) us(fec) un-(f)to(e) the(f) Son(hg) of(eg) God.(f) Al-(g)le(hg)  Jp-(f)ia.(f) Names(h) i(gf) of(hg) the(e) |(f)  [EEmaa(gi) An-(gh)brose(jijijkj) A-(g)tha(f) Ot(g) si-(h)s(ijijkj) Gre-(g)go-(h)el(ijijkj)  John(gi)  (gf) Chrysostom(g)  (h) e(kijijkj)  Al-(g) (f)  (c) phon-(cgh)sus(ijijkj)  (fg)  Bo-(g)na-(f)ven-(f)tu-(gh)ra(kjijijkj)  ](gh) \xa33(kijijkj) (T(gh) 0(kijijkj) 0(f) R(cf) AR(gh) Bede(kjijijkj) ",
        groupIndex: 0,
        filename: "./pages/part-b-177.png",
        nextFileName: "./pages/part-b-178.png"
    },
    {
        title: "part-b-178-0",
        gabc: "B(i) hold(i) a(g) great(hj) A(i) who(ig) in(h) his(g) n-(e)pleaseq(h)  (fh)  :(e) was(f) found(fg) righteous.(e)  (e) Al-(gf~)le-(f)lu-(e)ia.(e)  (j)  (i)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-b-178.png",
        nextFileName: "./pages/part-b-179.png"
    },
    {
        title: "part-b-178-1",
        gabc: "here(ig) was(j) none(i) Tlike(ig) un-(h)to(g) him,(e) who(h) kept(h) the(fh) law(gf) of(e)  the(f) Most(gf) High.(e) Al-(gf~)le-(f)lu-(e)ia.(e) |(j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-178.png",
        nextFileName: "./pages/part-b-179.png"
    },
    {
        title: "part-b-178-2",
        gabc: "The(fg) Lord,(g) therefore,(h)  (j) sur-(j)ed(h) him(h) by(i) an(h) oath(g) that(g)  he(i) would(j) bless(h) the(g) na-(fh)tions(fed) in(ef) hisTseed.(gh)  (g) p.(ef)  (d) fseed(gfd)  al(f) le-(fg)lu-(g)ia.(g) :(j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-b-178.png",
        nextFileName: "./pages/part-b-179.png"
    },
    {
        title: "part-b-179-0",
        gabc: "/O(i) ye(g) priests(i) of(j) God,\xa5(i) bless(ig) ye(h) the(g) Lord:(e) O(e) ye(f) ser-(h) ats(h) of(g) the(f) Lord,f(f) sing(hij) a(i) hymn(h) unto(h)  (hg) God,(f) al-(g)le-(fg)lu-(e)ia.(e)  sing(h)  (i) a(i) hymn(hg) un-(fg)to(fe) God.(e) |(i) e(j) i(i)  (h) 2(gh)  and(g)  (h) faithful(ghj)  (ji) servant,(hh)  (g) en-(h)ter(hj) thou(h) in-(g)to(h) the(g) joy(gf)  of(f) thyTLord.(gf)  (e) Lord,(eef) al-(g)le(gf) \u2014lu-(e)ia.(e) e(ji)  (hi) e(h) B(g) |(efghi) ",
        groupIndex: 0,
        filename: "./pages/part-b-179.png",
        nextFileName: "./pages/part-b-180.png"
    },
    {
        title: "part-b-179-1",
        gabc: "(Good(g) and(hj) faithful(j)  (hi) servant\u2018,T(h)  (g) en-(gi)ter(hg) a(e) in-(fg)to(g) the(g)  joy(hf) of(g) 3(gf) Lord.(e) p.T.T&quot;Lord,(ef) M(g) le(gf) lu-(e)ia.(e) il(h)  (f)  (h) @S(g)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-179.png",
        nextFileName: "./pages/part-b-180.png"
    },
    {
        title: "part-b-179-2",
        gabc: "T&#39;]~(ik)  (f) -(fg)\u2014(g) S(gh) Wt(hg) *(d) And(fd) T(d)  (fg)  (g) Tt(f)  (d) him.(f) e(f) Lord.(fg) |(fh) ",
        groupIndex: 2,
        filename: "./pages/part-b-179.png",
        nextFileName: "./pages/part-b-180.png"
    },
    {
        title: "part-b-180-0",
        gabc: "lle(h) clothed(hi) a_(g) him(g) with(h) a(g) robe(g) of(f) glory.(gh)  (hg) Apq(fd) 143(fg)  (g)  (f)  X.(c) Glory(h)  (h) be.(h) The(f) Lord.(fg) ",
        groupIndex: 0,
        filename: "./pages/part-b-180.png",
        nextFileName: "./pages/part-b-181.png"
    },
    {
        title: "part-b-180-1",
        gabc: "T(ik) he(f) Lord(f) lov-(g)ed(f) him(f) and(f) a-(e)dorned(g) him,(h) Al(h)  (hg)  (g)  (f)  al-(ki) (d) le-(fg)lu-(gf)ia.(f) The(f) Lord.(f) He(f) clothed(g)  (f) him(f) with(f) a(f)  robe(ki~)  (f) of(e) glory.(g)  (h) Al-(h)le(hg) lu-(g)ia.(f) Clory(f)  (f) be.(f) The(f)  Lord.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-180.png",
        nextFileName: "./pages/part-b-181.png"
    },
    {
        title: "part-b-180-2",
        gabc: "&quot;(f)  (ffe)  (d) [(e) L](g) se\u2014\u2014\u2014mmmee(h) R(f)  (e)  (g) 0(h)  (g)  (hjji)  a(g) a4(g)  (f)  (gh)  (h) \u2014(h)  (g)  (hjji)  (gf)  (h)  (dh)   (dffe)  (ed)  (c)  (eg)  (gf)  (gf)  (g)  (fe)  (d)  (dded) ",
        groupIndex: 2,
        filename: "./pages/part-b-180.png",
        nextFileName: "./pages/part-b-181.png"
    },
    {
        title: "part-b-181-0",
        gabc: ".(d)  a(e) .(e)  (e)  (efe)  (ec)  (d)  (e)  (f)  (hg)  (f)  (e)  ](f)  (e)  (ec) .-(d) (e) ](e)  (ehg)  (hi)  (i) -(iji) (h)  (g)  (fge)  &amp;(e) Lord(e) guided(e) the(efe)  (ec) righteous(d) in(e)  &amp;(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-181.png",
        nextFileName: "./pages/part-b-182.png"
    },
    {
        title: "part-b-181-1",
        gabc: "Well(ki~)  (defe) done,(d) good(d) al;ld(c) faithful(d)  (f) ser-(dfc)vant:(c) thou(fh) hast(gh)  |(i) =(fg) A(h) faithful(fgf) o(g) ver(dfg) a(f) (2(dedc) \xab-(c)a(c) will(d) make(f)  thee(f) ruler(f) ](e) o(d) ver(c) ma-(f)ny(f) things,(f) saith(g) the+(fe) Lord.(d)  (efh)  *Lord,(dc) al-(d)le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (dgfed)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-181.png",
        nextFileName: "./pages/part-b-182.png"
    },
    {
        title: "part-b-182-0",
        gabc: "T(c) &amp;(c) Lord(df) lov-(f)ed(fe) T(dc)  (f) tand(f) a-(gh) (hg) dorned(fg) him;(gfd) he(g)  (h)  (g)  him(f) 5(f) a(e) robe(d) of(f) (4(edc) LE(c) and(cd) at(f) a(fe) gates(d) iof(dc) pa?E(f)  :(fh) dise(hghihgg) he(f) __l_l_-(g)crowned(fe) him.(d) him,(dc) mi(d) al~le-(efe)]u..ia_(d)  (d)  ;(h) A(g)  (f)  (g)  (gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-b-182.png",
        nextFileName: "./pages/part-b-183.png"
    },
    {
        title: "part-b-182-1",
        gabc: "he(f) mouth(g) of(f) the(f) righteous(gh)  (hg) Is(fg) ex-(h)er-(g)ci-(fd)sed(f) in(g)  wisdom.(g)  (f) The(f) mouth.(g) And(h) his(h) tongue(hhi) will(h) be(h) talk-(gh) ing(g) of(f) judgment.(gh)  (hg) Is(fg) ex-(h)er-(g)cis(fd) ed.(f) Glory\u201Cbfff(dhddhd)  (h)  (d) I(d)  The(f) mouth.(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-182.png",
        nextFileName: "./pages/part-b-183.png"
    },
    {
        title: "part-b-183-0",
        gabc: "he(f) mouth(f) of(f) the(f) righteous(g)  (f) is\u2019(f) ex-(f)er-(f)cis-(f)ed(f) in(e) wisdom,\u201D(g)  (h)  (h)  al-(h) (hg)  (g)  (f)  (d) le-(fg)lu-(dgf)ia.(f)  (efhfgh) The(f) mouth.(f) \xa5.(efghih)  (c) And(f) his(f)  tongue(g) will(f) be(f) talking(f)  (f) of(e) judgment.(g)  (h) Al-(h)le-(hg)lu-(g)ia.(f)  (f)  Y.(c) Glory(f)  (f) be.(f) B/(fh) The(f) mouth.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-183.png",
        nextFileName: "./pages/part-b-184.png"
    },
    {
        title: "part-b-183-1",
        gabc: "-(f) (e)  (fh)  (hg)  (fg) e(f)  (f)  (e) e(f)  (h) L6(h) L(ih)  (i)  -(gi) (j)  (ih)  (i) \u2018(h)  (g)  (f)  (g)  (f)  (e)  (eh)  (hhg)  (f)  (e)  G(gi)  (h) =(h) ](i) r(j)  (i)  (h) \u201C__I(g)  (f)  (h)  (h)  (g)  (h) I(fe)  (f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-183.png",
        nextFileName: "./pages/part-b-184.png"
    },
    {
        title: "part-b-184-0",
        gabc: "I&#39;(c) will(c) liken(d)  (d)  (fdefec) a(f)  (h)  (g) wise(ig) man,(hih) whi(hg) .(ef)  house(fe) a(c) on(eg) a(fe) rock.(d) u(dc) al-(d)le(efe) Ju-(d)jq,(d)  (hgf)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-184.png",
        nextFileName: "./pages/part-b-185.png"
    },
    {
        title: "part-b-184-1",
        gabc: "ord,(f) thou(h) de-(h)liv-(h)er-(g)edst(hg) Tun-(e)to(f) me(g) five(fe) talents:(d)  (d)  behold,\u201D(f)  (ffdeefec) I(f) gained(h)  (g) beside(g)  (fggh) them(hg) five(ef) talents(g)  (ef)  T(d) e(dc) v(d) B(efe) lu-(d)ia.(d) |(h) v(g)  (f)  (h) ||(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-184.png",
        nextFileName: "./pages/part-b-185.png"
    },
    {
        title: "part-b-184-2",
        gabc: "ell(d) done,(dc) thou(f) good(g) \u20141\u2014\u2014E.\u2014\\____\u2014\u2014\u2014\u2014\u2014(fh) servant,t(h) in(g) little(i)  (h)  (d)  (gd) d(dg)  .(fh) faithful,(g) en-(gg)ter(e) thou(g) 4(h) to(g) the(f) v(f) of(dg)  (fd~) th(hdefddf) thy&#39;:\xa2%\u2122(fddd)  (dfd~dd) ia(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-184.png",
        nextFileName: "./pages/part-b-185.png"
    },
    {
        title: "part-b-185-0",
        gabc: "ord,(dc) al-(d)le-(efe)lu-(d)ia,(d)  (h)  (g)  (f) iij(gh)  (gf)  A(g) wise(g) and(h) faithful(j)  (h) servant,(j)  (i) whom(g) the(h) Lord(h) hath(h)  made(h) tu-(ih)ler(g) o-(g)ver(gh) all(hgf) o(gf) hisf&#39;household.(e)  (e) a(c)  (e)  )(ef)  (g) ML(gf) i(e)  (e) P(j)  (h)  (j) PR(ih)  lessed(e)  (e) is(f) that(ge)  (f) servant(e) whom(e) his(ei) Lord,(i) when(h) he(f)  cometh(h)  (g) and(h) knocketh(iji)  (hf) at(hi) the(g) door,(ef) shall(gh) find(ihf) watching..(e)  Al(f) -(f)1lu-(e)ia,(e)  (j)  (i)  (h)  (gf)  ood(g) and(h) faithful(ih) Bttt(f) Sk(h) servant,+(g)  (d) i,(i) alds(h) oo(f) e(h) to(h) the(h)  3%(gf) of(ef) :(gf) Lord.(dedd)  (dd) P.T.(d) I(d) Al-(gfdf)lu-(e)ia.(h)  (e) BV(j)  (di) WY(h) i(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-185.png",
        nextFileName: "./pages/part-b-186.png"
    },
    {
        title: "part-b-186-0",
        gabc: "a(g)  (g)  (f)  (e)  (d)  (fhg)  (fg)  (g)  (fg)  (hjji)  (h)  a(h)  [T(ig)  (h) et(g)  (f) e(g)  (g) b(f)  (g)  (h)  (j)  (g)  Hymn(h) Melody(h) wa(ghg) a(e) Doctor(f) as(hg) on(fg) page(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-186.png",
        nextFileName: "./pages/part-b-187.png"
    },
    {
        title: "part-b-186-1",
        gabc: "ale,(eefed) d(ed) good(g) and(f) faithful(gh)  (gf) R-(e)8-(e)thou(d) hast(e)  been(ffg) faithful(gh) 0(g) o-(def)ver(g) a(gf) few(e) things,(e) I(d) will(e) make(fgh) thee(fg)  ruler(g)  (g) o-(gh)ver(g) ma(hiji) ny(hg) things:(g) en(ggh) ter(hi) thou(ddgdd) t0(deffddfgddffg)  Jjoy(ik)  (fe) of(dg) .(gf) R(c)  (e) \u2019Tl,ord,\u2018(ef) Bl(fg) ia.(fgdffddeffffeffddfefhfg) .(hfih)  (geffef) ",
        groupIndex: 1,
        filename: "./pages/part-b-186.png",
        nextFileName: "./pages/part-b-187.png"
    },
    {
        title: "part-b-187-0",
        gabc: "E(e) world,(eh) and(f) all(f) things(ed) earthly,(def)  (e) t(fgh) this(e) man(g)  (h) despised,(i)  (h)  \xa2riumphant:(fh)  (h)  (d)  (g) he(i) laid(i) up(i) treasures(i)  (g) in(h) hea(iji) ven(dfhghih) by(dfe)  (f)  and(cdgf) deed.(e) i(efg)  (ef) Al-(gf)le-(f)lu-(e)ia.(e) |(f)  (fghi) T(h)  (g) e(h)  (f) T(e) |(efghi) ",
        groupIndex: 0,
        filename: "./pages/part-b-187.png",
        nextFileName: "./pages/part-b-188.png"
    },
    {
        title: "part-b-187-1",
        gabc: "od(fg) shall(f) help(gh) zer(hg) his(efd)  (fg)  (g) countenance.(f)  (f) God(efgde)  (fg) shall(f)  help.(fgh) W,(fggh) God(hi) is(h) in(h) the(h) midst(fgh) of(g) her,(g) therefore(h)  (g) shall(g)  she(g) &amp;(g) L(g) re-(f) (gh) ISR(fhg) |(fghi)  (dfghi) With(fd) BTNV(fg) e(g) TRV(f)  (f) |(fghief)  T,(c)  (f)  (h) ry(h) be.(h) B.(f)  (f) God(fg) shall(f) help.(gh)  (efg) ",
        groupIndex: 1,
        filename: "./pages/part-b-187.png",
        nextFileName: "./pages/part-b-188.png"
    },
    {
        title: "part-b-188-0",
        gabc: "(0d(f) shallhelp(f)  (g) her(f) with(f) L(e) L](g) &quot;(g) countenance,(h) .(h) Q(h) Wy(e)  al-(d)le-(fg)lu-(gf)ia.(f) God(f) shall(f) help.(g) \xa5,(h)  (c) Gogd(f) is(f) in(f) the(f) m\xa7&#39;d(g)  of(f) her,(f) therefore(f)  (f) shall(f) she(f) not(g) be(f) a(e) mo-(g)ved,(h) 4(h)  lu-(g)ia.(f) V.(c) Glory(f) be(f)  (f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h)  and(h) to(h) the(g) Ho(h) ly(g) Ghost.(gf) God(f) shall(f) help.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-188.png",
        nextFileName: "./pages/part-b-189.png"
    },
    {
        title: "part-b-188-1",
        gabc: "thou(i)  (g) Bride(i) of(j) e(i) ](g) receive(h) a(g) a.(e)  (f)  which(h) the(fh) Lord(g) hath(f) prepared(e)  (f)  (f) for(d)  (df)  (d)  (d) thee(ddh)  (d)  (g)  (chd~ed)  (dde)  (d)  =\u201Cev-(e)er,(ef) al-(g)le-(f)L(e) (](dded)  (d) ,(djdddi)  (d)  (h)  (dghd)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-188.png",
        nextFileName: "./pages/part-b-189.png"
    },
    {
        title: "part-b-189-0",
        gabc: "0(ig~)  (f) ve(f) wise(ef) O(ih) a(i)  (j)  (i) -(h)and(i) trim(j) your(fhi) lamps:(i)  (f)  for(i) behold(i)  (f) the(i) Bridegroom(g)  (h) cometh;(fe)  (fe) go(d) ye(e) out(f) to(h)  meet(f) him.(f) Al-(de)le-(fgh)lu-(f)ia.(f) |(ghi) T(ih) e(i)  (j)  (h) e(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-189.png",
        nextFileName: "./pages/part-b-190.png"
    },
    {
        title: "part-b-189-1",
        gabc: "This(c)  (c)  (d) is(d)  (dc) wise(fg) Virgin,(fh)  (hggf) and(fh) one(hgfg) of(d) the(f) number(f)  (g) L](e)  th*&#39;(fe)  (d) pPrudent.(ddh) N(d) e(c) isiiing(d) ooy(dc) =(d) o(efe) R(d)  (d) |(egh) N(hg)  (f)  (fgh)  (gf)  (efg) ",
        groupIndex: 1,
        filename: "./pages/part-b-189.png",
        nextFileName: "./pages/part-b-190.png"
    },
    {
        title: "part-b-190-0",
        gabc: "T(c) his(dd) is(c) &#39;a(d) wise(fe) Virgin,T(d) (](dc) whom(fh) the(g) Lord(hdfhghihgg) hath(e)  (fg)  fwatching.(d) \u2014(d) T(d) ing,(dc) al-(d) (efe) lu-(d)ia,(d) |(h) &quot;|(g)  (f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-190.png",
        nextFileName: "./pages/part-b-191.png"
    },
    {
        title: "part-b-190-1",
        gabc: "is(cc)  (ff)  (ef)  (dg) the(g) barren(jh)  (j) is(j)  (i) un-(h)de-(h)fi-(gi)led;(h) she(h)  shall(g) have(g) :(fg) in(g) i(e) vi-(gf)si-(e)ta-(fe)tion(d) of(ef) ho-(g) (gf) lylsoyls,(e)  p.7}souls,(c)  (ef) al-(g)le-(gf)lu-(e)ia.(e) |(ji) R(hi) T(h) S|(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-190.png",
        nextFileName: "./pages/part-b-191.png"
    },
    {
        title: "part-b-190-2",
        gabc: "Come,(d) D(cd) thou(f) my(g) chosen(f)  (fgh) one,(h) and(gh) Iwill(h)  (g) a(e) my(f)  throne(g) with-(fe)in(d) ee,(dc) al(d) ~le-(efe)=(d) ia.(d) 1(d) ;(d)  (d)  \u2018(d)  Fwithin(fe)  (dd) thee.(dddd) |(d)  (jfghdd)  (dddh) e(dgddfddghd) ",
        groupIndex: 2,
        filename: "./pages/part-b-190.png",
        nextFileName: "./pages/part-b-191.png"
    },
    {
        title: "part-b-191-0",
        gabc: "This(g) w_,mn\u2018l&#39;(hj)  (j) is(j) TR(h) beautiful(hji) a-(g) (g) mong(hj) the(j) e(j) i(j) B(h) e(c)  (hgf)  p.THe-(chgf)ru-(g)sa-(gf)l\xe9m,(ed) al(ef) -(fg)lu-(e)ia.(e)  (f)  (j) l(h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-191.png",
        nextFileName: "./pages/part-b-192.png"
    },
    {
        title: "part-b-191-1",
        gabc: "I(f) thy(fh) grace(hg) And(h) in(gfd) thy(fg) beauty.(g)  (f) In(f) thy(gh) grace.(hg)  f.(c) Go(h) forth,(hi) ride(h) prosp\u2019&#39;rously,(gh)  (g) and(f)  (fh) reign.(hg) And(h) 1in(gfd)  thy(i)  (fg) beauty.(g)  (f) Glory(h)  (h) be(h) to(h) the(h) Father(ihi)  (h) and(h) to(gh) the(g) Son,(g)  and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) B2(h) In(f) thy(gh) grace.(hg) ",
        groupIndex: 1,
        filename: "./pages/part-b-191.png",
        nextFileName: "./pages/part-b-192.png"
    },
    {
        title: "part-b-191-2",
        gabc: "In(f) thy(f) grace(g) and(f) in(f) -(e)beauty,(g)  (h) Al-(h)le(hg) ia,(f) al-(d)le-(fg) lu-(gf)ia.(f) 1In(f) thy(f) grace.(g) Go(f) =(g) ride(f) prosp\u2019(f) 0(e) rously,(g)  and(g) E(h) i(eh) iuern(h) Al-(f)le~(hg) lu-(g)ia.(f) .(c) |(f) e(f) |(f)  (f) In(f) thy(f) SRS(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-191.png",
        nextFileName: "./pages/part-b-192.png"
    },
    {
        title: "part-b-192-0",
        gabc: "\uFB01\u2014.\u2014&#39;\u2014&#39;\u2014\u2014\u2019\u2014\\(g)  (hi)  (j)  (ih)  (g)  (h)  (f)  (g)  (i)  (j)  \u2014\u2014__\u2014_\u2014__NQ](i)  (k)  (ih)  (f) |(g)  (h) [}(f)  (g)  (e)  (f)  Y.(ed) .(c) 8(g) are(hi) thy(j) lips.(ih)  (g)  (h)  (f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-192.png",
        nextFileName: "./pages/part-b-193.png"
    },
    {
        title: "part-b-192-1",
        gabc: "lLe(g) kingdom(g)  (k) of(k) heav\u2019n(hj) v(ih) e(g) e(g)  (g) un-(g)to(k) a(j) mer-(j) chantman(jh)  (i) [T(hg) seeking(h) 1(jh) i(ih) pearls;(g) who,(gd) when(g) he(f) had(h)  found(hj) one(ihj) pearl(j) of(j) great(jh) price,(g) went(g) and(g) sold(kjh) all(ij)  a(h) he(g) had,(h)  (ijh) and(hi) bought(g) it,(g) Al-(hi)le-(h)lu-(g)ia.(g)  n(j)  \xa5(k) *}Y.(k)  (j) The(ik) ",
        groupIndex: 1,
        filename: "./pages/part-b-192.png",
        nextFileName: "./pages/part-b-193.png"
    },
    {
        title: "part-b-193-0",
        gabc: "](g) theirs(gj) is(h) the(g) kingdom(h) ](g) of(f) heaven,T(gh)  (g) who(h) despised(j)  (j)  worldly(h)  (j) living:(ij)  (j) who(i) have(j) won(k) the(j) rewards(i)  (j) of(h) the(g) king-(h) d\xb0m,.(ghihgg) a(e) bave(f) washed(g)  (h) their(gf) B(efd) in(g) the(h) blood(gijh) of(i)  the(h) aL(g) =(ddghd) 5(i) le-(h)G|(g)  (g) |(j) SNt(i)  (j)  (h) |(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-193.png",
        nextFileName: "./pages/part-b-194.png"
    },
    {
        title: "part-b-194-0",
        gabc: "While(gj) the(hghj)  (j) tsitteth(i)  (j) at(k) his(ji) table,(h)  (g) my(gh)  (j) .(i)  [(g) sendeth(i) forth(hg) a(def) sweet-(gf) (gh) e(gf) smelllngTsavour.(e)  (e) y(e)  (ef)  al-(g)p(gf) lu-(e)ia.(e) R(j)  (h) )(j) el(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-194.png",
        nextFileName: "./pages/part-b-195.png"
    },
    {
        title: "part-b-194-1",
        gabc: "We(c)  (e) will(f) run(h) after(h)  (j) theel(i) because(i)  (i) of(h) the(i) savour(j)  (i) of(h) thine(hj)  ointments:(gi)  (gh)  (f) ex(gihg) O(f) ceedingly(e) L(fe) do(d) the(e) i(f) virgins(h) love(f) thee.(f)  Al-(de)le-(fh)1lu-(f)ia.(f) T(i)  (h)  (i) ;(j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-b-194.png",
        nextFileName: "./pages/part-b-195.png"
    },
    {
        title: "part-b-194-2",
        gabc: "-(gj)the(h) winter(h)  (fgf) is(gh) past,(g) the(g) rain(if) is(j) o-(dk)ver(j) and(hj) O\u2122(i)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-b-194.png",
        nextFileName: "./pages/part-b-195.png"
    },
    {
        title: "part-b-195-0",
        gabc: "UP(i) myFlovs(j) ,(hgf) and(f) comeT(hjh) a-(ih)way.(g) a-(ih)way,(gfd)   (ef)  (fg)  (g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-195.png",
        nextFileName: "./pages/part-b-196.png"
    },
    {
        title: "part-b-195-1",
        gabc: "C(ki~) one.,(d)  (dc) thou(f) my(g) chosen(f)  (fgh) one,T(h) and(h) I(h) will(g) set(e) my(f) throne(g)  tyithin(fe)  (d) thee,(dc) al-(d)le-(efe)lu-(d)a.(d) After(dfe)  \u201Cin(ik)  (d) thee.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-195.png",
        nextFileName: "./pages/part-b-196.png"
    },
    {
        title: "part-b-195-2",
        gabc: "This(c)  (g) wo-(ghj)man(j) ig(j)  (h) beautiful(hji)  (g) a-(g)mong(hj) the(j) daughters(j)  (hij) of(h)  &quot;Je(hgf) -(g)-(gf)lem.(e) P.T.TJe(hgf) ru-(g)sa-(gf)Yem,(ed) al(ef) le-(fg) lus(e) g,(e)  (dd)  (d)  (djd)  (dh)  (j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-b-195.png",
        nextFileName: "./pages/part-b-196.png"
    },
    {
        title: "part-b-196-0",
        gabc: "a(f)  (h)  (hg)  (i)  (hf) &quot;(g)  (i)  (h) %(h)  (f) \u2018(g)  [(ig~)  (h)  (h)  (f)  (g)  (f) %(f)  (h)  (hg)  (i)  \xa5.(hgi) Full(g) [(i) 5(h) are(h) thy(f) _\u2014_\u2014:MI(g) lips.(h)  (gh)  (f)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-196.png",
        nextFileName: "./pages/part-b-197.png"
    },
    {
        title: "part-b-196-1",
        gabc: "ive(hg) her(f) of(h) the(hi) fruit(ij) of(h) her(hf) hands;(g) and(i) let(hg) .(e)  (f)  works(ed) praise(f) her(f) S(hf~) the(g) e(e) le-(gf)Y|(f) ia.(e)  (j) \u2019(ihih) ",
        groupIndex: 1,
        filename: "./pages/part-b-196.png",
        nextFileName: "./pages/part-b-197.png"
    },
    {
        title: "part-b-196-2",
        gabc: "Sh::(c) stretcheth(cdf)  (f) outT(d)  (f) her(dfd) hand(dfg)  (dd) to(dfe) the(fde) poor;(e) Yea,(dhi) she(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-196.png",
        nextFileName: "./pages/part-b-197.png"
    },
    {
        title: "part-b-197-0",
        gabc: "forth(fg) her(dc) hands(c)  (fd) to(f) the(fe) needy;(de)  (e) she(f) eateth(efg)  (gd)  ot(d) the(dg) bread(gf) of(ghg) gt(e) g(e) st(e) |(e)  (e) al-(cef) (g) le-(gf) 1u\u2014ia.(e)  (e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-197.png",
        nextFileName: "./pages/part-b-198.png"
    },
    {
        title: "part-b-197-1",
        gabc: "This(fg) place(g) is(f) ho-(h)ly(hg) Wherein(fgh)  (g) the(fd) priest(fg) &quot;=(g) prayeth.This(f)  (fg)  place.(g) \xa5.(c) For(h) the(h) sins(hi) and(h) e(h) offences(gh)  (g) of(g) the(f) people.(gh)  (hg)  Wherein,(fgh)  (g) Glory(h) be(h)  (h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g) Son,(g)  *d(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) This(fg) place.(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-197.png",
        nextFileName: "./pages/part-b-198.png"
    },
    {
        title: "part-b-198-0",
        gabc: "This(c)  (f) place(f) is(f) ho-(g)ly,(f) wherein(f)  (f) -(e)a(g) pr&amp;\\)\u2019eth(g) i(h)  le(hg) lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) This(f) place,(f) Fok(f) f\\(f)  sins(f) and(f) of-(f)a(g) fences(f) of(f) a(e) a-(g)people.(h) Al-(h)le.(hg) ],(g) ;(f)  Glory(f)  (f) be(f) to(f) the(e) ](g) Father(h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g)  Ho-(h)ly(g) Ghost.(gf) This(f) place.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-198.png",
        nextFileName: "./pages/part-b-199.png"
    },
    {
        title: "part-b-198-1",
        gabc: ":\u2014_h(j)  (j)  (j)  (ih)  (i)  (j)  (j)  (f)  (h)  (i)  (g) }(h)  (f)  (e)  (f)  Tt(h)  (f)  (g)  (h)  (i)  (j)  (ihg)  (f)  (g) :(h)  (g)  (f)  (g)  (f) |(e)  L}(c)  (ef)  (f) R(fe)  (h) e(i)  (i) T(h) e(j)  (i) R(hg)  (hihg) T(f) ..(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-198.png",
        nextFileName: "./pages/part-b-199.png"
    },
    {
        title: "part-b-199-0",
        gabc: "Tord(e) path(cd) hal-(dhi)low-(h)ed(g) This(ef) ta-(g)ber-(fe)na-(d)cle:(d) for(d) this(df)  %(c) \u201C:3(dc) hoiuse(f) of(g) the(fh) Lord,(h) wherein(h)  (fgh) men(j) may(i) call(g) up-(h) on(j) his(i) Name;(h) whereof(hg)  (eef) it(g) is(fe) written,(d)  (d) My(dde) Name(c) shall(e)  pe(g) therein,(f)  (ef) saith(g) 5(fe) thelLord.(d) P.T.*Lord,(dc) al-(d)le(efe) -(d)ia.(d)  :(h)  (g)  (f) at(gh)  (g)  1(e) li-(f)ness(h) becometh(h)  (ij) t(i) thine(fi) house,(hg) O(ef) Lord,(f) for(hg) ev-(e)er.(e)  Al-(gf~)le-(f)lu-(e)ia.(e)  (j)  (i)  (h) -(gf) house(cf)  (c)  (cd)  (dfg) 1&#39;shall(gh) Ee(gf) call-(fghg)ed(f) the(ef) house-(g) (fe) of\u2019prayer.(d)  Prayer,(dfd~fddfhddhdffdefcffdfdfddf) al-(fddd)le(defefdd) lu-(d)ia.(d)  (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-199.png",
        nextFileName: "./pages/part-b-200.png"
    },
    {
        title: "part-b-200-0",
        gabc: "tis(dc) is(f) the(g) Lord\u2019s(fh) house,(h) firmly(h)  (gf) buildeq:(g)  (d) 1(c) i(d)  founded(hg)  (g) 5(e) the(f) sol-(g) (fe) idfrock.(c)  (d) al&lt;]e(dc)  (d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-200.png",
        nextFileName: "./pages/part-b-201.png"
    },
    {
        title: "part-b-200-1",
        gabc: "Well(ikc)  (c)  (ji) founded(hg)  (g) Tis(g) the(e) Lord\u2019s(f) house(d) on(e) the(f) solid*mck_(h)  (h)  (g)  rock,(ik)  (gfd) al-(ef)le-(fg)lu-(g)ia.(g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-b-200.png",
        nextFileName: "./pages/part-b-201.png"
    },
    {
        title: "part-b-200-2",
        gabc: "Al(f) thy(e)  (fh) shall(e) be(f) stones(h) e(g) S(fgh) W(he) and(e) the(f)  tow\u2019rs(hhi) of(h) Je-(h)ru-(i)sa-(hg)lem(fgh) shall(ef) be(h)  (g) upbuilded(ij)  (h) withtjends(g)  (f)  (f)  T(gi) Seter(f)  (fe) -(f)al-(ghg)lu-(f)ia.(f) s(h)  (g) e(e)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-200.png",
        nextFileName: "./pages/part-b-201.png"
    },
    {
        title: "part-b-201-0",
        gabc: "i-(f)ness(f) becometh(f)  (h)  (hg) Thine(fgh) house,(gfd) 0(fg) Lord.(gf) Ho-(fg)li-(f)ness.(f)  7,(jk) For(g) ev-(h)er:(hg) Thine(fgh) house.(gfd) Glory(h)  (h) be.(h) Ho-(fg)li-(f) (f)  ev-(g) ness.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-201.png",
        nextFileName: "./pages/part-b-202.png"
    },
    {
        title: "part-b-201-1",
        gabc: "[(g) 1i-(f)ness(f)  (f) becometh(f)  (f) thine(e) house,(g) 0(g) Lord,(h) Al-(h)le-(hg) lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) Ho-(g)li-(f)ness.(f) For(e) ev-(g)er.(h)  Al-(h)le-(hg)lu-(g)ia.(f) e(f) Glory(f) be.(f) Ho-(g)li-(f)ness.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-201.png",
        nextFileName: "./pages/part-b-202.png"
    },
    {
        title: "part-b-201-2",
        gabc: "i(e)  (ed)  (f)  (edc)  (d)  (dfd) T(e) o(e) 2T(ed) S(fgh) e(h) I(g) R(fe)  (de) |(e)  -(e) (h) \u2014=(h)  (g) oot(hj)  (h) Y(gfe) T(e) e(ed) Pl(fgh) ST(h)  (g) o(fe) A(de) 0(e)  0(e)  (ed)  (f)  (edc)  (d) e(dfd)  (e)  (e)  (ed) R(ffh) M(h)  (g) AR(fe)  (de) |(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-201.png",
        nextFileName: "./pages/part-b-202.png"
    },
    {
        title: "part-b-202-0",
        gabc: "_(gi)  (d)  (fe)  (e)  (f) q(hg)  (f)  (fe~) \u2014ap.(eed)  (d) 0(f)  (hiij)  I(i) must(hg) &#39;a-(fe)bide(f) at(de) thy(fh) house:(gfe) and(d) he(fe) made(f) haste,(hg)  and(f) came(fe) down,(eed) and(d) received(f)  (h)  (g) him(hfi) joyfully(f)  (e)  (d) in-(e)\xa2q(f) his(f)  house,(g)  (e) This(d) day(de)  (j) is(df) v(hij) va-(hf)tion(fi) come(hge) e(f) this(fe) house(fh)  from(f) [(e) Lord,(fe) lal(d) le-(de)lu-(e)ia.(e) 1:fmn(f)  the(de) Lord.(e)  (h)  (g)  (h)  (f)  (efe) ",
        groupIndex: 0,
        filename: "./pages/part-b-202.png",
        nextFileName: "./pages/part-b-203.png"
    },
    {
        title: "part-b-202-1",
        gabc: "O(efd) 1&amp;%(dc) dreadful(gf~)  (g) Tis(d)  (fgf)  (f) this(dffdghg)  (f) place!(ddfdf)  (f)  (dd) truly(df)  (dfdffhf) this(hdfgdfdfdhf) is(fdi)  (dd) no\uFB02e(hdf) ",
        groupIndex: 1,
        filename: "./pages/part-b-202.png",
        nextFileName: "./pages/part-b-203.png"
    },
    {
        title: "part-b-203-0",
        gabc: "ther(f) put(f) the(f) house(g) of(f) God,(fhihghg) and(edf) the(dc) gate(ffhig) of(hg)  heaven-(f) (f) Leaven,(f)  (fg) al-(h)le-(g)lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-203.png",
        nextFileName: "./pages/part-b-204.png"
    },
    {
        title: "part-b-203-1",
        gabc: "0(d)  (hi)  (g)  (hi) 0(k)  (jihgh)  (h)  (h) -(de) (gf)  B(e) =(d) S=\u2014\u2014\u2014(f) a(e)  (g)  (h) 5(h)  (defedc)  i(e) Vouchsafe(g) [(e)  (f) a(e) ;(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-203.png",
        nextFileName: "./pages/part-b-204.png"
    },
    {
        title: "part-b-204-0",
        gabc: "a(ik)  (eg)  (ddc) 1y(de) a(e) L](e) help(gh) thou(hhg) the(ed) suf(e)  (gfe) fero(de)  (e)  then(gf) the(d) faint-(ef)hearted,(de)  (e) comfort(de)  (dc) th.e(c)  SOT(fe)  pray(dfhhg) for(gf) the(dc) pe\xe9ople,(df)  (efed) entreat(d)  (dh) for(hih) the(gh) Clergy;(gf) ey(ed)  (d)  (f)  tercede(fh)  (h) for(g) all(gf) -(dc)man-(df)kind(efed) -(fhhgf)D-(g)un-(gfe)-(de)Codl(e)  ~(c) all(df) dc-(fd)L](ef) knowledge(g) a(g) help(gh) of(gf) thy(de) praye;;(dd) .(c)  who(d) ce(fe) le-(fg)a(gh) thy(gf) a(g) ly*(ghg) es~ti-(fe) (de) val.(e) P.T.Ffeq-(fe)|(d)  ti-(de)val,(ef) al-(g))(gf) lu-(e)ia.(e) e(h) l-(g)|(h) l_.&#39;_l(ih) _l(gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-204.png",
        nextFileName: "./pages/part-b-205.png"
    },
    {
        title: "part-b-204-1",
        gabc: "While(gj) the(hghj) King(j) Tsitteth(i)  (j) at(k) his(ji) table,(h)  (g) my(gh) spikenard(j) =(i)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-204.png",
        nextFileName: "./pages/part-b-205.png"
    },
    {
        title: "part-b-205-0",
        gabc: "\xa2h(i) forth(hg) a(ef) i(gf) i(gh) A(gf) smellingTsavour.(e)  (e) p.T.Fsavour,(e)  (def)  :i.a.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-205.png",
        nextFileName: "./pages/part-b-206.png"
    },
    {
        title: "part-b-205-1",
        gabc: "fis(f) left(ih) hand(i) Tis(hi) under(j)  (i) my(h) head,(i) and(ig) his(hg) right(fe) hand(ef)  doth(de) embrace(fh)  (f) me.(f) P.T..Al(ed) le(fh) -(f)ia.(f) ||(i) e(h)  (hj)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-b-205.png",
        nextFileName: "./pages/part-b-206.png"
    },
    {
        title: "part-b-205-2",
        gabc: "[(g) am(h) black,(j) but(h) comely,T(j)  (i) O(g) ye(h) daughters(h)  (h) of(h) Je-(h)ru-(i) sa-(h)lem;(g) therefore(g)  (h) the(i) King(i) delighteth(h)  (j)  (i) in(gh) me,(h) and(g)  T(e) brought(fe) me(d) in-(ef)e(g) W(fgf) hisTchambers.(e) T(e)  (h) 5(e)  (ef)  A-(dfgdf)le-(dfgdff) (d) 1y(de) e(e) ssruul(j)  (h)  (j) Ellrcin](ih) ",
        groupIndex: 2,
        filename: "./pages/part-b-205.png",
        nextFileName: "./pages/part-b-206.png"
    },
    {
        title: "part-c-000-0",
        gabc: "%(h) the(h) Father(ihi)  (h) and(h) to(gh) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh)  Hail(f)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-000.png",
        nextFileName: "./pages/part-c-001.png"
    },
    {
        title: "part-c-000-1",
        gabc: "Heail,(f) Ma-(f)ry,(f) full(f) of(f) grace,(g) the(f) Lord(f) is(e) with(g) thee,(h)  Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) Hail.(f) |(ghi) Blessed(f) e(f) art(f)  thou(f) a-(f)mong(f) R(g) men,(f) and(f) e(f) e(f) is(f) e(f) e(f) T(e) thy(g)  womb.(h) B,(h) Al-(hg)lu-(g)ia.(f) Glory(f)  (f) be(f) to(f) &quot;(e) Father(g)  (h) and(h)  to(hi) the(h) Son,(h) and(h) to(h) 5(g) Ho-(h)o(g) &lt;(gf) B(f) e(f) ",
        groupIndex: 1,
        filename: "./pages/part-c-000.png",
        nextFileName: "./pages/part-c-001.png"
    },
    {
        title: "part-c-001-0",
        gabc: "Hail(ik)  (c)  (c)  (f) Ma-(gh)ry,(f) full(fedc) of(fghi) erace,(h) The(hij) Lord(ihgfe) ig(gh)  (gf)  thee.(f) FHail.(f) Plessed(f)  (f) art(f) thou(g) a-(f)mong(f) Wo-(gh)nen(f)  (f)  blessed(g)  (f) is(f) the(f) fruit(fe) f(dc) thy(fghi) womb.(h) The(ihij) Lord,(i)  Glory(f) be(f)  (g) to(f) the(f) Father(gh)  (f) and(g) to(fe) jhe(dc) to(c)  (df) the(f)  Ho(ighhih) ly(gf) Ghost.(f) Mail.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-001.png",
        nextFileName: "./pages/part-c-002.png"
    },
    {
        title: "part-c-001-1",
        gabc: "a(g) 0(gfef) L}(dc)  (f) R(gi) -(ih) (g) :(h) i(j) o(jid)  (d)  (hdd)  (ihd)  (](g)  (hg)  (fg)  (g)  (gj)  (j)  (ji)  (j)  (jkj)  (idh)  (d)  (dgdfddhgfd)  V.(ih)  (ij) grace(h)  (ih)  (g) DR(hg)  (fg) |(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-001.png",
        nextFileName: "./pages/part-c-002.png"
    },
    {
        title: "part-c-002-0",
        gabc: ".(ki~) PBlessed(gj)  (h) art(g) thou,(h) 0(gf) Ma(gh) ry,(gh) for(g) thou(gf) hast(g) be(h) -(h) ljev-(h)ed:(jkj) and(h) there(i) shall(j) he(h) a(h) ](g) performance(h)  (g) in(fg) thee(g)  of(h) those(fe) things(d) which(e) were(f) told(gh) thee(h) from(g) the(fg) Lord,(gfd)  al-(ef)1le-(fg)lu-(g)1ia.(g) Tthee(h) from(h) the(fg)  Lord.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-002.png",
        nextFileName: "./pages/part-c-003.png"
    },
    {
        title: "part-c-002-1",
        gabc: "An(gj) ge-(h)ne-(g)-(h)ra-(g)shall(fg) call(g) me(gh) blessed:(f)  (f) for(fg) God(h)  \u201C(ik) hath(g) re-(f)gard-(g)ed(h) the(j) T(jk) li-(j)i(jijkj) of(h) et(h) hand(fhij)  Tnaig(g) T(g) i(g) =(gh) .(i)  (ddh) o(dd) 1lu-(g)ia.(gd) |(dd)  (d)  (d) e(j) e(di)  (j)  (h) |(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-002.png",
        nextFileName: "./pages/part-c-003.png"
    },
    {
        title: "part-c-003-0",
        gabc: "()(hig~)  (f) blessed(f)  (h) Mother(f)  (e) Tand(ef) spotless(f)  (h) Vir-(hg)gin,(e) thou(ef) glo.(h)  |(hgi) ri-(g)ous(h) Queen(i) of(hg) the(fe) world,(f) in-(e)ter-(f)cede(hih) for(hg) us(fe) to(g)  the(hgi)  (hg) Lord.(f) B(h) i(g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-003.png",
        nextFileName: "./pages/part-c-004.png"
    },
    {
        title: "part-c-003-1",
        gabc: ".M._ay(ig) all(hj) the(i) Saints(i)  (i) i_&#39;__|:__|(g) for(hg)  (f) us(f) to(g)  (fd)  (d)  (de) \u2018(d) ",
        groupIndex: 1,
        filename: "./pages/part-c-003.png",
        nextFileName: "./pages/part-c-004.png"
    },
    {
        title: "part-c-003-2",
        gabc: "ay(g) all(ef) the(fgh) Saints(g)  (j) Tin-(fhi)tercede(hj)  (i)  (hgdffgh) M\u2019&quot;(fedddfddf)  (ddfef) ",
        groupIndex: 2,
        filename: "./pages/part-c-003.png",
        nextFileName: "./pages/part-c-004.png"
    },
    {
        title: "part-c-004-0",
        gabc: "Queen(i)  (dc)  (f) of(fg) hea(gff) en,T(dc) be(f) joyful,(ed)  (f) al-(g)le(fe) 1lu-(d)ia;(d) Pe-(d) -(ik) (dedc) .(c) whom(fe) T(fg) ](gff) e(dc) thou(f) R(ed) barest,(f) al-(g)i(fe) lu-(d)Y(d)  Hath(ik)  (h) a-(g)ris-(h)en,(h) as(j) he(ig) promis\u2019d,(h)  (hih) al-(g)le-(gh)lu-(h)ia;(h) Pray(hgf)  :(ik) for(g) us(gh) to(fe) the(dc) \u2014(f) l_\u2014l_-(ef)al-(g)le(ef) lu-(d)ia.(d) l(fh)  (g) MY(f)  (gf) |(d) ",
        groupIndex: 0,
        filename: "./pages/part-c-004.png",
        nextFileName: "./pages/part-c-005.png"
    },
    {
        title: "part-c-005-0",
        gabc: "I(h) will(j) walkt(j) before(j)  (hi) the(h) Lord(g) ;(g) the(g) land(fg) of(gh)  living.(ki~)  (e)  (e) Psalm(j)  (h) 116(j)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-c-005.png",
        nextFileName: "./pages/part-c-006.png"
    },
    {
        title: "part-c-005-1",
        gabc: "Woe(ig~cc)  (h) is(hg) me(f) that(fe) T(f) am(h) constrained(fg)  (e)  (e) to(gihji) dwell(h) with(ge)  Mesech.(gh)  (f) Psalm(h)  (g) 120(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-005.png",
        nextFileName: "./pages/part-c-006.png"
    },
    {
        title: "part-c-005-2",
        gabc: "he(h) Lord(fg)  (g) preserve(g)  (h) thee(g) from(g) all(hg) evil:(f)  (f) yea,(h)  it(j) is(id) e-(jk)ven(h) he(h) that(g) shall(f) keep(gh) thy(h) soul.(g)  (h) Psals(j)  (ij) 121(h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-c-005.png",
        nextFileName: "./pages/part-c-006.png"
    },
    {
        title: "part-c-005-3",
        gabc: "\xa3(i) thou,(i) Lord,(i) wilt(h) w(g)  (h)  (i) Tto(i) mark(j) what(id) is(dd)  (dhddd) don\xae(hd)  (d) ",
        groupIndex: 3,
        filename: "./pages/part-c-005.png",
        nextFileName: "./pages/part-c-006.png"
    },
    {
        title: "part-c-006-0",
        gabc: "a-(g)miss,(h) O(h) Lord,(ih) who(dfhf) may(g) a-(f)bide(e) it?(e) Psalm(j)  (i) 130.(h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-006.png",
        nextFileName: "./pages/part-c-007.png"
    },
    {
        title: "part-c-006-1",
        gabc: "D(h) espise(h) not(h) then,(f) O(e) Lord,(f) the(h) works(hge) of(gfh) thine(i) own(hg)  hands.(f)  (i) Psalm(h)  (g) 138.(e)  (f)  I(h) heard(h) a(h) un-(i)to(h) \xbb(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-006.png",
        nextFileName: "./pages/part-c-007.png"
    },
    {
        title: "part-c-006-2",
        gabc: "11(ighij) that(i) the(i) i(ij) Father!(i) e(i) giveth(hih) me(defghgh) shall(ffh) come(ghi) to(hg) me;(e) |(fi)  and(e) him(fh) that(h) cometh(h)  (gf) to(h) me,(g) I(e) will(f) in(f) no(hf) wise(g)  cast(f) out.(e)  (j)  (i)  (h)  (fgh)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-c-006.png",
        nextFileName: "./pages/part-c-007.png"
    },
    {
        title: "part-c-007-0",
        gabc: "God,(c)  (f)  (h) make(h) speed(hi) to(h) save(gh) me.(h)   (f)  (h)  (h)  (h)  (h)  (gh)  (h)  Glory(h)  (h) be(h) to(h) the(h) Father(h)  (h) and(h) to(h) the(h) Son,and(h)  (h) to(h) the(h) Ho-(gh)ly(h)  Ghost;(h) As(h) it(h) was(h) in(h) the(h)  (h) beginning,(h)  (h) is(h) now(h) and(h) ev(h) \u2014er(h)  shall(h) be,(h) world(h) without(h)  (h) end.(gh) A\u2014men.(h)  (h) tAl-(h)le-(i)1lu-(h)1ia.(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-007.png",
        nextFileName: "./pages/part-c-008.png"
    },
    {
        title: "part-c-007-1",
        gabc: "Praise(h) be(h) to(h) thee,(h) O(h) Lord,(h) King(h) of(h) e(h) \u2014ternal(h)  (i) glory.(hg)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-007.png",
        nextFileName: "./pages/part-c-008.png"
    },
    {
        title: "part-c-007-2",
        gabc: " (h)  (h)  (h)  (g)  (f)  (h)  (h)  (h)  (h)  (h)  (h)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-c-007.png",
        nextFileName: "./pages/part-c-008.png"
    },
    {
        title: "part-c-008-0",
        gabc: "Al-(c) (f) le-(fdefe)M_ia,(d)  (c) al(f) -(g)1lu-(fg)ia.(f)  (h)  (f) Y(gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-008.png",
        nextFileName: "./pages/part-c-009.png"
    },
    {
        title: "part-c-008-1",
        gabc: "Al\u2014le-(c) (eh)  (f) a(f)  (e) \u2014lu-(d)a(efe) \u2014ia,Tal\u2014le\u2014lu\u2014ia,(de) -(e)&gt;(g) al&quot;le&quot;l\u201C~\\ia;(h) a(i)  (f)  Al(h) le(h) 1(hih) ia,(g) al(f) le(gh) lu(ef) ia,(e) al(e) -(e)le\u2018lu,fia;(e)  (e)  Al(d) le(f) lu(h) \u2014ia,(g) LI(e) Btk(gh) lu(f) 1a,(ed) al(ef) -(f)le\u2014lu_ia,(e) (N(e)  a(h)  (g)  (h)  (f)  (e)  At(g) the(gh) king\u2019s(hgf) [N(gh) commandment,(h)  (g) the(g) three(hi) [(ghgf) T(f) were(f)  (f) cast(dhj)  in-(j)to(i) the(h) furnace,(ji)  (hg) fearing(j) i(i) not(j) the(h) flame(j) of(g) the(h) fire&#39;(fgf) =i(d)  LS(fg) ing,(gf) Blessed(h) I(ji) be(hg) our(fg) L(g) \xa2(j) Em\u2014,(i)  (j) ;(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-008.png",
        nextFileName: "./pages/part-c-009.png"
    },
    {
        title: "part-c-009-0",
        gabc: "is(f)  (g) ri-(h)\u2014sent(g) from(g) the(gh) grave,(fgf) who(fgh) de-(g)liv\u2014er-(h) (g) ed(fgh) the(hg)  three(df) children(gf)  (df) from(c) the(d) burning(f) .(f) 2(g) ry(f) furndce,(fe)  (dc) al-(f) (c) le-(g)lu-(fg).(f)  -(h) (f) Alleluia(gh)  (g)  (f)  Al\u2014le\u2014lu-(h) (gf) \u2014ia,(gh)  (g) tal-(h)le-(j)lu-(h)ia,(f) al-(h)le~1lu-(h) (g) 1ia.(g)  (j)  (i)  (j)  (h)  (g)  Al-(ik) (cf) le-(ghg)lu-(h)1a,(gf) tal(gh) -(g)lu-(fe)ia,(d) al(f) \u2014le(g) \u2014lu\u20141ia.(g)  (f) S(h) s(f) g(fh) s(g) |(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-009.png",
        nextFileName: "./pages/part-c-010.png"
    },
    {
        title: "part-c-009-1",
        gabc: "B(c) lessing,(h)  (h) and(h) glory,(h)  (h) and(h) wisdom,(h)  (h) and(h) e(h) thanksgiving,{(h)  (f) and(h)  :(h) honour,(h) and(h) power,(h)  (h) and(h) might,(h) be(h) unto(h)  (g) our(f) God(h) for(h)  e(h) ev\u2014er(h) e(h) S(h) ev\u2014er.(h) A\u2014men.(f) .-(ef)Thanks(h) Il(f) to(e) God.(ef) ",
        groupIndex: 1,
        filename: "./pages/part-c-009.png",
        nextFileName: "./pages/part-c-010.png"
    },
    {
        title: "part-c-010-0",
        gabc: "n\u2014cline(h)  (gh) my(h) heart,(hj) O(hg) God,(gh) Un-(gf)to(g) thy(hj) m\u2018r-(i)tes\u2014tipg_(ih)  (gh) I(h)  Incline.(h)  (gh) \xa5.(c) Turn(ih) a-(gh)way(gf) mine(gi) eyes,(i) lest(h) they(gh) be-(g)N(g) L](i)  .1-(i) (hi) ty,(ih) and(gf) quicken(gh) e(h) thou(h) me(hj) in(h) thy(hg) way.(fh) Un-(gf)to(g) thy(hj)  tes(i) t1(ih) \u2014mo(h) \u2014nies.(h) V.(c) Glo-(ih)ry(fgh) be(gf) to(gi) the(h) Fa-(gh)ther,(g) and(g) to(g)  the(g) Son,(gh) and(g) to(gf) the(g) Ho-(i)1ly(hi) Ghost.(ih) Incline.(h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-010.png",
        nextFileName: "./pages/part-c-011.png"
    },
    {
        title: "part-c-010-1",
        gabc: "a(f)  (f)  (g)  (h) a(i) a(h)  (g) 2(h) [(h)  (g)  (j) a(j)  (g)  (h)  (i) |(hdg)  (d)  a(h)  (h)  (g)  (h)  (g)  (f)  (e)  (f)  (g) .(h)  (g)  (f)  (e)  (fg) |l(edddhdded)  (cdh)  The(h)  (h) Lord(h) aPPar&#39;;l&#39;(h)  (d)  (dh) ",
        groupIndex: 1,
        filename: "./pages/part-c-010.png",
        nextFileName: "./pages/part-c-011.png"
    },
    {
        title: "part-c-011-0",
        gabc: "Lord,(h)  (hh) ref(h) -(hhf)uge.(f) O(hgfef) ",
        groupIndex: 0,
        filename: "./pages/part-c-011.png",
        nextFileName: "./pages/part-c-012.png"
    },
    {
        title: "part-c-011-1",
        gabc: "O(e)  (f)  (e)  (d)  (e)  (e)  (d)  (c)  (d) a(e)  (e) T(e)  (c)  (e) a(gh)  (g)  a(g) .(f)  (e)  (f)  (h)  (g) ;(h)  (i)  (h)  (gh) -(f)[(e)  (f) a(g)  (d)  ..(ed)  (c)  (f) q(f)  (e) 3(d) -(e) (efe) glorious(de) ",
        groupIndex: 1,
        filename: "./pages/part-c-011.png",
        nextFileName: "./pages/part-c-012.png"
    },
    {
        title: "part-c-011-2",
        gabc: "L(c)  (h) have(h) mercy(h) a8(g) up-(f)on(g) us.(h) Christ,(h) have(h) mercy(h)  (g) up-(f) on(g) us.(h) Lord,(h) have(h) mercy(h)  (g) up-(f)on(g) us.(hd) ",
        groupIndex: 2,
        filename: "./pages/part-c-011.png",
        nextFileName: "./pages/part-c-012.png"
    },
    {
        title: "part-c-012-0",
        gabc: "Father,(f)  (g)  (h) who(h) art(h) in(h) heaven,(h)  (g) Hallow-(h)ed(g)  (f) be(h) thy(h) Nane(h)  Thy(f) kingdom(g)  (h) come.(h) Thy(f) will(g) be(h) done,(h) On(h) earth(h) ag(h) it(h) 5(g)  in(f) heaven.(h)  (h) Give(f) us(g) this(h) day(h) our(h) dai-(h)ly(f) bread,(g) And\xa7(f)  forgive(f)  (g) us(g) our(h) trespasses,(h)  (h) B(h) As(h) we(h) s(h) Wi(h) those(h) who(h)  trespass(h)  (g) a-(f) (h) us..(h) And(f) lead(f) us(g) not(g) in-(h)to(h) temp-(h) (h)  ta\u2014tion.(h)  (f) But(h) de-(h)liv-(h)er(h) us(h) from(h) e(h) vil.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-012.png",
        nextFileName: "./pages/part-c-013.png"
    },
    {
        title: "part-c-012-1",
        gabc: "The(f) Lord(h) be(gh) with(hg) you.(g) And(f) with(h) thy(gh)  (hg) spifitti(g)  Let(h) us(h) pray.(gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-012.png",
        nextFileName: "./pages/part-c-013.png"
    },
    {
        title: "part-c-013-0",
        gabc: "May(gi)  (e) the(df) blessed(h)  (hg) Mother(f)  (g) of(f) God,(e) the(fg) Virgin(f)  (e) Ma-(gh)ry,(f) and(hi)  all(gi)  (hg) the(i) Saints,(kjiji) intercede(e)  (f)  (hi) for(hg) us(fe) to(g) the(hg) Lord.(f)  .(chgi) The(h)  (h) Lord(h) up(h) won\u2014der\u2014ful.,(f) him.(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-013.png",
        nextFileName: "./pages/part-c-014.png"
    },
    {
        title: "part-c-013-1",
        gabc: "He(f) that(g) was(f) cru-(f)ci-(ghg)fi-(h)ed(gf) is(h) ri-(gf)sen(df) from(fef) the(dedcd) dead;(dc)  and(fd~) hath(f) re(fhg) \u2014deem-(h)ed(g) us,(f) al(fd) -(f) (fe) So(dedcd) 7a,(dc) al(f) -(fg)lu-(fg)ia.(f)  .(i) Tell(jj)  (j) 1lu-(j)1ia,(h) ",
        groupIndex: 1,
        filename: "./pages/part-c-013.png",
        nextFileName: "./pages/part-c-014.png"
    },
    {
        title: "part-c-014-0",
        gabc: "\xa5.(c) The(f) Lord(h) be(gh) with(hg) you.(g) And(f) with(h) thy(gh)  (hg)  (g)  V.(c) Let(i) us(i) bless(i) the(i) Lord.(ihg) Thanks(i) be(i) to(i) Gog,(ihg)  May(e)  (e) the(e) in(e) peace.(e) A(e) men,(e) ",
        groupIndex: 0,
        filename: "./pages/part-c-014.png",
        nextFileName: "./pages/part-c-015.png"
    },
    {
        title: "part-c-014-1",
        gabc: "ave(f) mer\u2014cy(h)  (g) tup\u2014on(f)  (gh) me,(g) C(g) God.(f) |(h) ;(f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-014.png",
        nextFileName: "./pages/part-c-015.png"
    },
    {
        title: "part-c-014-2",
        gabc: "Al-(f)le-(f)lu-(gh)ia,(h) tal-(h)le-(g)lu-(hg)ia,(f) al(g) le(h) lu-(f)1ia.(f) e(hf)  (fhdg)  (df) ",
        groupIndex: 2,
        filename: "./pages/part-c-014.png",
        nextFileName: "./pages/part-c-015.png"
    },
    {
        title: "part-c-014-3",
        gabc: "Con\u2014si\u2014der(h)  (fh) t(f) my(ed) 5(e) med\u2014i-(f)ta\u2014tion,(g)  (fd) O(fe) Lord.(e) |(h) A(f)  (h)  (i)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-c-014.png",
        nextFileName: "./pages/part-c-015.png"
    },
    {
        title: "part-c-015-0",
        gabc: "qercy,(g)  (h) 1O(g) Lord,(efg) reacheth(f)  (gh) un-(f)to(f) the(f) heavens.(fg)  (e)  (h)  (f)  (h)  (i)  (h)  Thy(h) qercy,(h)  an-(fe~)ger\u2019[is(g) turn-(h)ed(j) a-(j)way,(h) O(j) Lord,(ij) and(h) thou(hf)  Thi\uFB02e(c)  (h) an-(fg) (g)  com-(g)fort-(h)edst(hi) me.(g) P.T.Al(hi) \u2014le-(h)lu~ia.(g)  (g) AR(j)  (i) A(j)  (h) |(fh) ",
        groupIndex: 0,
        filename: "./pages/part-c-015.png",
        nextFileName: "./pages/part-c-016.png"
    },
    {
        title: "part-c-015-1",
        gabc: "Wala(dc) praise(f) thy(g) glo-(h)ri-(g)ous(f) Name,(fc) O(d) our(fe) God.(d)  God,(dc) al(d) \u2014le-(efe)lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-015.png",
        nextFileName: "./pages/part-c-016.png"
    },
    {
        title: "part-c-015-2",
        gabc: "O(dh) praise(hg) the(ef) Lord(g) of(fe) hea-(d)ven.(d) RN(h) e(g) e(f) m(gf) y(fgh) ",
        groupIndex: 2,
        filename: "./pages/part-c-015.png",
        nextFileName: "./pages/part-c-016.png"
    },
    {
        title: "part-c-015-3",
        gabc: "T(dh)  (hg) o(hi) v(h) al-(h)e(g) lu-(hg)ia,(ef) e(g) -(fe)e(d) lu.1a.(d) S(h)  (g) i(f) ||(gf)  (gh) ",
        groupIndex: 3,
        filename: "./pages/part-c-015.png",
        nextFileName: "./pages/part-c-016.png"
    },
    {
        title: "part-c-016-0",
        gabc: "Heal(c)  (cfe) my(f) soul,(gh) For(h) I(f) have(gh) sinned(g)  (fd) a-(fg)gainst(g) thee,(f)  Ryl(h) said,(ihi) Lord(h) be(h) mer-(gh)ci-(g)ful(g) un-(fe)to(f) me.(gh) For(h) I(f) Have(gh) g(g)  ned(fd) a-(gf~)gainst(g) thee.(f) Glory(h)  (h) be(h) to(h) the(h) Father,(ihi)  (h) and(h) to(gh) the(g)  Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) Heal(fe) my(f) soul,(gh) for(h) I(f) haye(h)  B(g) sinned(fd) a\u2014-(fg)gainst(g) thee.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-016.png",
        nextFileName: "./pages/part-c-017.png"
    },
    {
        title: "part-c-016-1",
        gabc: "[(f)  (f)  (g)  (h) L](i)  (h)  (g)  (h) a(h)  (g)  (j) [(j) ](g)  (h)  (i)  (hg)  (h)  on(h)  (h) Coeesceenss(g)  (h) s(g)  (f)  (e)  (f)  (g) 2(h)  (g)  (f)  (e)  (fg) [(e) .(d)  (ded)  (d)  .(e)  (c)  (d)  (f) O(ef)  (g)  (f)  (e) [(e)  (c)  (d)  (f) [](ef)  (g) .-(h) (g)  (h)  :(g)  (f)  (g)  (h) w(f)  (g)  (f)  (e) [](e)  (c)  (d)  (f) Lk(ef)  (g)  (hf)  (e) ;(ddefe)  (de)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-016.png",
        nextFileName: "./pages/part-c-017.png"
    },
    {
        title: "part-c-017-0",
        gabc: "B]ess\u2014ed(f)  (gh) be(h) the(f) Lord(g) God(fgfd) of(fg) Is-(h)ra-(g)el.(f)  (h)  (f)  (fgh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png"
    },
    {
        title: "part-c-017-1",
        gabc: "Do(e) a-(f)vay,(g) O(f) Lord,(df) mine(fd) of-(fg)T(e) fences.(e) e(h)  (g) |(h) |(ih) \xa2(gfe) S(e) ",
        groupIndex: 1,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png"
    },
    {
        title: "part-c-017-2",
        gabc: "Al-(i) (e) le_lu-(f) (g) ia,(g) fal-(gh)le\u2014lu-(g) (gf) da(d) sl(fd) e(fg) Sl(e) W(e) g(h)  (ghih) @(gfee) ",
        groupIndex: 2,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png"
    },
    {
        title: "part-c-017-3",
        gabc: "he(c)  (f) help(h) of(f) my(gh) coun-(g)R(fe) e(d) and(f) my(gh) lol(gf) ||(h) eineecal(f)  (gh)  (g) |(f) ",
        groupIndex: 3,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png"
    },
    {
        title: "part-c-017-4",
        gabc: "my(f)  (h) soul(ji) T(jk) trusteth(h) in(dfg) thee.(g)  (f) P(fffdjddiddj) o(hf)  (ghg) ",
        groupIndex: 4,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png"
    },
    {
        title: "part-c-018-0",
        gabc: "B(c)  (g) thou(g) rea-(hj)dy(j) to(h) save(j) us(i) all(g) the(h) days(h) of(h) gy,(gf)  Tife,(g) O}(gf) Lords.(e) Lotd;(f) sl(g) o(gf) el(e) on(e)  (j)  (h) g(j) ",
        groupIndex: 0,
        filename: "./pages/part-c-018.png",
        nextFileName: "./pages/part-c-019.png"
    },
    {
        title: "part-c-018-1",
        gabc: "x(c)  (ef) tol(hjh) the(i) ev-(g)er-(i)last-(hg)ing(f) King(f) in(f) all(hgf) your(gf) ings,(e)  Al-(fg)le-(f)lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-018.png",
        nextFileName: "./pages/part-c-019.png"
    },
    {
        title: "part-c-018-2",
        gabc: "L](e) ye(ef) An-(ff)gels(d) of(f) his,(hhih) O(i) praise(h) the(gh) Lord(c)  (f) of(ef) heaven.(d)  (d)   (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-018.png",
        nextFileName: "./pages/part-c-019.png"
    },
    {
        title: "part-c-018-3",
        gabc: "Al-(gi) (e) le-(f)lu-(ffe)ia,(d) al-(f)le-(h)lu-(hi)ia,(hg) al-(f)le(ef) ~lu-(d)ia.(d) .(h)  (digfh)  (f)  (d) ",
        groupIndex: 3,
        filename: "./pages/part-c-018.png",
        nextFileName: "./pages/part-c-019.png"
    },
    {
        title: "part-c-019-0",
        gabc: "The(e) Lord(g) hath(h) rais\u2014ed(i)  (hg) up(h) for(hi) us(i) an(i) horn(ji) of(j) sal-(k)va-(i)tion(i)  in(i) the(j) house(hf) of(h) his(gh) ser(ihf) \u2014vant(g) Da(e) vid.(e)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-019.png",
        nextFileName: "./pages/part-c-020.png"
    },
    {
        title: "part-c-019-1",
        gabc: "Wash(gg) me(fh) through-(j)ly,(ih) O(hj) Lord,(h) from(gf) my(h) wick\u2014ed-(i) (h) ness.(g)  [(j)  (i)  (j)  (h) ](g) ",
        groupIndex: 1,
        filename: "./pages/part-c-019.png",
        nextFileName: "./pages/part-c-020.png"
    },
    {
        title: "part-c-019-2",
        gabc: "Al-(g)le-(fh)lu-(j)ia,(ih) al-(hj)le(h) lu-(hg)ia,(f) al-(g)le-(h)lu-(ihg)1a.(g) |(j) e(i)  (j)  (h) |(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-019.png",
        nextFileName: "./pages/part-c-020.png"
    },
    {
        title: "part-c-019-3",
        gabc: "L(hg) P(h) serve(hg) %(f) life,(h) O(h) Lord,(hg) from(f) fear(fe) of(f) the(hg) e-(f)ne-(f)x|(f)   (gi)  (h)  (g)  (e)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-c-019.png",
        nextFileName: "./pages/part-c-020.png"
    },
    {
        title: "part-c-020-0",
        gabc: "0(gi)  (h)  (hih) -(e)art(fe) prais-(f)ed(d) 5(gf) Si(f) on,(e)  (h) |(f)  (h)  (i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png"
    },
    {
        title: "part-c-020-1",
        gabc: "T(c) he(f) Lord(fh) shall(g) judge(h) the(g) ends(ef) of(g) the(fe) earth.(d) 1(dc)  al(d) le(efe) lu(d) 1a.(d) ([(h) e(g) e(f)  (g) \\(ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png"
    },
    {
        title: "part-c-020-2",
        gabc: "()(hi) lord,(i) thou(h) art(i) great(ji) tand(h) glo-(i) (i) ri\u2014ous,(i) won-(fi)der\u2014ful(hg)  (fe) 1n(fe)  strength(de) and(f) in-(h)vin-(f)ci-(f)ble.(f) Al(de) le(fh) lu-(f)ia,(f)  (i) |(h) ",
        groupIndex: 2,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png"
    },
    {
        title: "part-c-020-3",
        gabc: "O(gi)  (h) all(h) ye(f) hea-(gh)vens,(g) [(fe) \u2019ye(f) the(ghg) Lord.(f) e(h) ;(gde)  (df) ",
        groupIndex: 3,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png"
    },
    {
        title: "part-c-020-4",
        gabc: "e(gi)  (h)  (f) Al&quot;le\u2014lu*ia,Tal\u2014le\u2014lu\u2014ia,(gh)  (g)  (f)  (e) IJ(f)  (g) al&#39;=(h) Te&#39;=(g) Tu&#39;\u2014(f)  (f)  (d) 18-(dh) (fg)  (e) S(f) ",
        groupIndex: 4,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png"
    },
    {
        title: "part-c-021-0",
        gabc: "Fron(h) the(g) hand(h) of(fg) all(g) that(d) hate(fe) us,(f) the(f) Lord(g) hath(e) de-(f) .(g) liv\u2014er\u2014ed(e)  (f) us.(d)  (h) THURSDAY(g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-021.png",
        nextFileName: "./pages/part-c-022.png"
    },
    {
        title: "part-c-021-1",
        gabc: "A(h) e(f) thee(fg) on(gh) ly(g) have(f) I(h) sin-(j)ned,(k) O(jh) Lord:(j)  have(h) mer(h) \u2014cy(i) up-(h)on(g) me.(g)  (j)  (i)  (j)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-021.png",
        nextFileName: "./pages/part-c-022.png"
    },
    {
        title: "part-c-021-2",
        gabc: "Al-(h)le\u2014l\uFB01-(fg)ia,(gh) O(g) al-(f)le-(h)lu-(jk)1ia,(jijkj) al-(hi)le-(h)lu-(g)ia.(g) EEE(j)  (i) e(j)  (h) |(fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-021.png",
        nextFileName: "./pages/part-c-022.png"
    },
    {
        title: "part-c-021-3",
        gabc: "LEt(gi)  (f) my(df) prayer,(h) O(gf) Lord,(fh) en-(h)ter(h) in(h) to(hi) thy(fe) pre-(fe)sence.(d)  L(h)  (i)  (g)  (h)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-c-021.png",
        nextFileName: "./pages/part-c-022.png"
    },
    {
        title: "part-c-022-0",
        gabc: "QO(f) [lord,(h) thou(f) hast(g) been(fd) our(fg) re\u2014fuge.(g)  (f) [T(h) o(f)  (gh) |(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-022.png",
        nextFileName: "./pages/part-c-023.png"
    },
    {
        title: "part-c-022-1",
        gabc: "I(e) will(f) sing(hi) un(hi) to(j) the(h) Lord,(i) for(gihfg) he(fe) hath(fe) tri-(d)A(e)  ed(fh) glo-(f)rious-(f)ly.(f) Al(cde) le(fh) lu-(f)ia.(f) e(i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-022.png",
        nextFileName: "./pages/part-c-023.png"
    },
    {
        title: "part-c-022-2",
        gabc: "M\u2019y(fd) peo-(e)ple(f) shall(g) be(g) sat-(g)1s\u2014fi-(ge) (f) ed(ed) with(d) my(dh) good-(h) ness,(gf) saith(g) the(gf) Lord.(e) Lord,(ef) al(gf) le(d) lu(e) ia.(e)  :(h)  (g)  (h)  (ih)  (gfe) i(e)  O(fg) praise(hgfg) God(fd) in(f) his(g) ho-(g)-(f)li(f) o(h) e(f)  (gh)  (g)  (f) |(d) ",
        groupIndex: 2,
        filename: "./pages/part-c-022.png",
        nextFileName: "./pages/part-c-023.png"
    },
    {
        title: "part-c-022-3",
        gabc: "Al(c)  (fg) le(hf) lu-(g)ia,(g) al-(gh)le-(g)lu-(f)ia,(d) al(f) -(g)lu-(g)ia.(f)  (dfh)  (fdfdfdghd)  (gff)  (df) ",
        groupIndex: 3,
        filename: "./pages/part-c-022.png",
        nextFileName: "./pages/part-c-023.png"
    },
    {
        title: "part-c-023-0",
        gabc: "Let(c)  (g) s(h) serve(i) the(i) Lord(j) in(h) ho-(i)1i(h) -(g)and(h) he(ij) will(i) de-(h) liv-(h)er(g) us(e) from(f) the(h) hand(hf) of(g) our(f) en-(e)e(e) -(e)ey(i)  (j)  (i) ]|(h)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-c-023.png",
        nextFileName: "./pages/part-c-024.png"
    },
    {
        title: "part-c-023-1",
        gabc: "1th(c)  (dc) thy(f) free(g) Spi(fh) rit(hgg) stab-(h)lish(g) my(ef) heart,(g) &#39;O(fe) God.(d)  .(h)  (g)  (f)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-023.png",
        nextFileName: "./pages/part-c-024.png"
    },
    {
        title: "part-c-023-2",
        gabc: "l-(d)le-(d)lu-(d)=(c) al(f) \u2014-(g)lu-(fh)ia,(hg) |(efg) L(fe) lu-(d)ia.(d) L(hg) e(fgh) |(gf) ",
        groupIndex: 2,
        filename: "./pages/part-c-023.png",
        nextFileName: "./pages/part-c-024.png"
    },
    {
        title: "part-c-023-3",
        gabc: ":(h) Nare(hg) lis(fe) great(f) in(ef) Is(g) ra(dfe) \u2014el.(fe) f_l_l(h)  (f) P(h) h(i) el(h) ",
        groupIndex: 3,
        filename: "./pages/part-c-023.png",
        nextFileName: "./pages/part-c-024.png"
    },
    {
        title: "part-c-024-0",
        gabc: "Jt(ch) is(h) a(h) good(hi) =(f) to(f) :(f) thanks(f) =(e) un\u2014to(f) the(f) Lo(e)   (h)  (f)  (h)  (i)  (h)  .(cfd) Lord,(f) I(e) have(f) heard(gh) thy(h) speech,(g) and(f) was(g) a(f) frajq(e)  Al(g) le(gf) lu(e) 1ia.(e) \u201CI_-(h) (g)  (h) I(ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-c-024.png",
        nextFileName: "./pages/part-c-025.png"
    },
    {
        title: "part-c-024-1",
        gabc: "In(cf) the(e) Lord(f) tshall(df) all(h) the(f) seed(g) of(h) Is-(i)ra-(hi)el(f) be(f)  (f)  jus\u2014ti(fi)  (h) fi(gh) ed,(fe) and(d) shall(e) glo-(fe)ry.(d) Al(e) \u2014le\u2014lp\u2014la-(edf) (d)  (d)   (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-024.png",
        nextFileName: "./pages/part-c-025.png"
    },
    {
        title: "part-c-024-2",
        gabc: "[(d) the(d) cym-(f)bals(e) and(d) dan-(d)es,(dc) lup(dc) on(ddfg) the(hgd)  (d) strings(dfg)  (dd)  (d) and(fd)  (dd) ",
        groupIndex: 2,
        filename: "./pages/part-c-024.png",
        nextFileName: "./pages/part-c-025.png"
    },
    {
        title: "part-c-025-0",
        gabc: "Lord.(h)  (g)  (f)  (gh)  (gf)  (fgh)  praise(e) the(fe) Lord.(d)  pipe,(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png"
    },
    {
        title: "part-c-025-1",
        gabc: "A]_]e_lu_.(d)  (fe)  (d) a,(dc) tal(fg) \u2014le(hg) lu-(fg)1a,(f) al(fgf) \u2014le(ef) lu-(d)1a.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png"
    },
    {
        title: "part-c-025-2",
        gabc: "Through(c)  (gj) the(hgf) ten\u2014der(g)  (h) mer\u2014cy(jk) t(jijkj) of(jh) our(ih) God:(g) whereby(g)  (g) the(g) day-(g) S(j) R(i)  (j) L(h) |(g)  spring(ge) from(fgh) on(fe) high(d) hath(ef) vi-(gh)sit-(h)ed(h) us.(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png"
    },
    {
        title: "part-c-025-3",
        gabc: "Be(f) [(g) M(f) e(e) ble,(d) O(ef) and(d) 7(gf) el(e) |(h) SESRERECS(g) &quot;(h) IS(ih) [(gfe) ](e) ",
        groupIndex: 3,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png"
    },
    {
        title: "part-c-025-4",
        gabc: "N(cd) S(f)  (gf)  (e) PNy(e) le-(f) (ghdd) lu\u2014ia,(d)  (g) P(dgd) \u2014le\u2014lu-(gdfdd)U(dde) ia.(e) |(f) e(hg)  (h) P(ih) a(gfe) e(e) ",
        groupIndex: 4,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png"
    },
    {
        title: "part-c-026-0",
        gabc: "Hear\u2014ken(c)  (h)  (f) un-(g)to(g) me,(h) O(g) Lord,(f) for(h) thy(hij) truth(ji) and(gh) Tight.(h)  eous-(i)ness\u2019(hg) sake.(g) R(j) R(i)  (j) SRR(h) AT(h) ",
        groupIndex: 0,
        filename: "./pages/part-c-026.png",
        nextFileName: "./pages/part-c-027.png"
    },
    {
        title: "part-c-026-1",
        gabc: ":(c) As\u2014cribe(f)  (fg) ye(hf) greatness(g)  (d) un-(f)to(g) our(g) God.(f) Al-(g)le-(gh)lu(f) i,(f)  .(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-026.png",
        nextFileName: "./pages/part-c-027.png"
    },
    {
        title: "part-c-026-2",
        gabc: "Shewus,t(hj)  (i) O(h) ,(hjg) the(gf) light(g) of(h) thy(gf) e(e) mer\u2014cy.(e) .(e)  cy,(ef) al(g) le(gf) lu(e) 1a.(e) [(j) T(h)  (j) \u2014\u2014(i) ",
        groupIndex: 2,
        filename: "./pages/part-c-026.png",
        nextFileName: "./pages/part-c-027.png"
    },
    {
        title: "part-c-026-3",
        gabc: "Up-(d)on(f) the(d) well(ef) ~tun-(g)ed(e) cym-(ef)bals(d) [0(dc) praise(df) God.(e)   (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 3,
        filename: "./pages/part-c-026.png",
        nextFileName: "./pages/part-c-027.png"
    },
    {
        title: "part-c-027-0",
        gabc: "2(d)  (e) [A(fe) _ia,(d) tal-(ef)le-(g)lu-(f)1ia,(d) [al(dc) le-(cdf)lu-(e)ia.(e) |(h) raenen(g)  (h) e(ih) |(dgfe) ||(e) ",
        groupIndex: 0,
        filename: "./pages/part-c-027.png",
        nextFileName: "./pages/part-c-028.png"
    },
    {
        title: "part-c-027-1",
        gabc: "Give(c)  (e) light,(h) &#39;O(fd) Lord,(e) to(e) them(g) that(h) sit(i) in(fh) darkness:(h)  (g) and(i)  guide(i) our(i) feet(i) in-(h)to(h) the(h) way(hij) of(i) peace,(hghih) thou(fe) God(fghf) of(gf)  Is-(e)ra-(e)el.(e)  (h) Suffrage(g)  (h)  (f) All(e) ",
        groupIndex: 1,
        filename: "./pages/part-c-027.png",
        nextFileName: "./pages/part-c-028.png"
    },
    {
        title: "part-c-027-2",
        gabc: "M(c) ay(ig) all(j) the(i) S(i) epa(i) i(g) |(hg) for(f) o(f) to(g) the(f) v(e) ||(f) ",
        groupIndex: 2,
        filename: "./pages/part-c-027.png",
        nextFileName: "./pages/part-c-028.png"
    },
    {
        title: "part-c-027-3",
        gabc: "May(g) \u2014(f) the(gh) Saints(g) f(hi) in-(ij)tercede(i) for(hgfgh) us(fe) to(d) the(ded) [(c) ",
        groupIndex: 3,
        filename: "./pages/part-c-027.png",
        nextFileName: "./pages/part-c-028.png"
    },
    {
        title: "part-c-028-0",
        gabc: "n(gg) that(fgh) day(hg) Tthe(g) mountains(g)  (g) shall(g) drop(hi) down(g) ney(hg) Wine,(f)  and(f) the(g) hills(g) shall(h) flow(j) with(g) milk(h) and(g) ho(g) ney,(gfd)  al(f) -(fg)lu(g) ia.(g)  (j) y(i)  (j)  (h)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-028.png",
        nextFileName: "./pages/part-c-029.png"
    },
    {
        title: "part-c-028-1",
        gabc: "Be(fg) ioy(gjkji) -(kj)ful,(kj) O(j) daughter(ji)  (h) of(j) Si-(hg)on,(g) and(g) ex-(g) ceeding(g)  (g) glad,(fe) O(f) daughter(d)  (e) of(fh) Je-(h)ru-(g)sa-(hfg)lem,(gfd)  al(ef) \u2014-(fg)lu-(g)1ia,(g)  (j)  (i)  (j) -(h) (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-028.png",
        nextFileName: "./pages/part-c-029.png"
    },
    {
        title: "part-c-029-0",
        gabc: "hold,(f)  (h) the(g) Lord(eg) cometh,(fe)  (d) and(e) all(e) his(e) Saints(df) with(hhi)  him;(h) and(h) there(h) shall(h) be(i) in(g) that(h) day(f) a(e) great(de) light,(fe)  al\u2014(f) le-(e)lu-(d)ia.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-029.png",
        nextFileName: "./pages/part-c-030.png"
    },
    {
        title: "part-c-029-1",
        gabc: "H(c)  (cgeh) ev\u2014ery(gh)  (g) one(g) that(e) thirsteth,(ghgg)  (f) come(f) ye(e) to(c) the(d)  waters:(d)  (c) seek(h)  (ji) ye(hihf) the(hi) Lord(hg) while(gg) he(ce) may(gf) be(df) found,(ec)  al(ed) -(d)..(c) -(c) (g)  (h) :(g)  (f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-029.png",
        nextFileName: "./pages/part-c-030.png"
    },
    {
        title: "part-c-029-2",
        gabc: "o,(e) there(f) cometh(hi)  (i) a(hi) mighty(j)  (h) Prophet:(i)  (i) and(i) he(f) a-(i)lone(g)  :(h) reneweth(fe)  (f) e(e) Je_ru-(d)sa-(e)lem,(fg) al(h) \u2014le-(h)lu-(f)ia.(f)  (d) e(i) \u2018(h)  (i) ||(j)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-029.png",
        nextFileName: "./pages/part-c-030.png"
    },
    {
        title: "part-c-030-0",
        gabc: "than(h) when(h) we(h) be(h) liev(f) \u2014ed.(ef) Thanks(h) be(f) \xa2,(e) Gog(def) ",
        groupIndex: 0,
        filename: "./pages/part-c-030.png",
        nextFileName: "./pages/part-c-031.png"
    },
    {
        title: "part-c-030-1",
        gabc: "and(c)  (f)  (fd) save(ef) us,(g) O(f) Lord(dc) God(df) of(fe) hosts.(e) Come(f) and(fd) save(ef) ys(g)  u(c) the(df) light(f) of(f) thy(f) countenance,(ef)  (f)  (f) and(f) we(fd) shall(e) be(f) a-(g) O(f) Lord(dc) God(df) of(fe) hosts.(e) \xa5.(c) Glory(g)  (g) be(g) to(g) the(g) Fa_ther,(fh)  (h) and(h)  to(g) the(h) L](e) and(f) to(f) the(f) Ho(fd) ly(ef) Ghost.(g) Come(f) and(fd) save(f)  us,(ik)  (g) O(f) Lord(dc) God(df) of(fe) hosts.(e) ",
        groupIndex: 1,
        filename: "./pages/part-c-030.png",
        nextFileName: "./pages/part-c-031.png"
    },
    {
        title: "part-c-030-2",
        gabc: "a(e) &quot;(c) [(e)  (g) \u2018a(h)  (i) -(h) (h)  (g) g(h)  (j)  (j) 0(ig) &amp;(h)  (i) )(h)  R(h)  (h) a(i) ](g)  (eg) &quot;(f)  (e)  (d) n(e) 3(c) \xab(e) [}(g) -(h) (i)  (h)  (h)  (hihd)  (dfgh) ",
        groupIndex: 2,
        filename: "./pages/part-c-030.png",
        nextFileName: "./pages/part-c-031.png"
    },
    {
        title: "part-c-031-0",
        gabc: "The\u2018fo\u2014ly(c)  (gd)  (cfe)  (fg) Ghost(g) shall(g) come(g) up-(g)\u2014on(gh) thee,(f) NMa(cgh) ry;(h) fear(hj)  not,(hg) thou(g) shalt(g) bear(g) in(h) thy(g) womb(fe) the(d) Son(f) of(h) God,(gfd)  al(ef) \u2014le(fg) lu\u20141a.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-031.png",
        nextFileName: "./pages/part-c-032.png"
    },
    {
        title: "part-c-031-1",
        gabc: "The(c)  (dc) [(e) gel(f) of(gf) the(d) L&#39;ord(dc) an(fg) &lt;nounc\u2019d(h) un-(g)to(f) Ma-(g)ry,(f) and(fg)  (e)  8(e) con-(f)ceiv\u2014ed(def) \u2014(fc) &amp;-(e)the(f) Ho-(g)ly(fe) ost,(dc) al(d) \u2014le\u2014lu\u2014(efe) :_I(d) ia.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-031.png",
        nextFileName: "./pages/part-c-032.png"
    },
    {
        title: "part-c-032-0",
        gabc: "B(c)  (c) e(d) fore(d) t\uFB02ey(dc) came(f) to-(g)geth-(fh)er(h) Ma-(i)ry(h) was(g) found(f) with(gh)  child(g) .(e) the(f) Ho-(g)ly(fe) Ghost,(dc) al(d) le-(efe)lu-(d)1ia,(d)  (hgfgh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-032.png",
        nextFileName: "./pages/part-c-033.png"
    },
    {
        title: "part-c-032-1",
        gabc: "Qut(ig~)  (f) of(f) Si-(i)on(h) shall(h) go(g) forth(e) the(f) law,(f) and(e) the(f) word(h)  of(gi)  (h) the(g) Lord(e) from(eg) Je\u2014ru-(fh) (g) \u2014sa-(h)\u2014lem.(f) e(h)  (g) |(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-032.png",
        nextFileName: "./pages/part-c-033.png"
    },
    {
        title: "part-c-032-2",
        gabc: "\u2014\u2014(gi) Bless\u2014ed(e)  (f) art(hi) thou(i) a-(hi)mong(jh) women,(i)  (i) and(gihg) bless\u2014ed(fe)  (fe) 1is(d)  the(e) fruit(fg) of(h) thy(hg) womb.(f) N(i) .(h) \u2014\u2014-(i) (j)  (h) ](fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-032.png",
        nextFileName: "./pages/part-c-033.png"
    },
    {
        title: "part-c-032-3",
        gabc: ".o,(idhi) there(h) cometh(hj)  (h) one(hghih) that(hg) is(f) both(ef) God(fg) and(efdf) Man,(d)  (d) of(f) ",
        groupIndex: 3,
        filename: "./pages/part-c-032.png",
        nextFileName: "./pages/part-c-033.png"
    },
    {
        title: "part-c-033-0",
        gabc: "4(ik) the(e) house(d) of(e) Da-(f)vid,(ghg) to(g) sit(f) up\u2014on(ed)  (dg) the(fe) th(dc)  al(d) \u2014le(efe) -(d)lu\u20141a.(d) /(h)  (g)  (f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-033.png",
        nextFileName: "./pages/part-c-034.png"
    },
    {
        title: "part-c-033-1",
        gabc: "Fear(c)  (hi) not,(i) O(hi) Si-(jh)on,(i) be-(i)hold(f) thy(i) God(gh) com\u2014eth,(fe)  (fe) al(d) \u2014le\u2014(fh)  lu-(f)1a(f)  (i)  (h)  (hj)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-c-033.png",
        nextFileName: "./pages/part-c-034.png"
    },
    {
        title: "part-c-033-2",
        gabc: "Be\u2014hold,(dd)  (c) the(d) Lord(ef) L](g) ap-(fe) of(ik)  (g) hea-(hg)-(f)with(f) e(f) er(e) s(f) [(fg) |(fe) P(dc)  al(ik)  (d) ~le(efe) lu\u2014ia.(d)  (d)  (f)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-033.png",
        nextFileName: "./pages/part-c-034.png"
    },
    {
        title: "part-c-034-0",
        gabc: "i-(ccdg)on(g) is(g) our(g) strong(ig) ci-(fg)~ty,(g) a(e) Saviour(g)  (f) wil](g) d(efe)  (de)  point(eg)  (f) with\u2014in(ed)  (c) her(c) for(ghgfg) walls(g) and(gj) bul-(j)warks:(g) 0(g) ~pen(g)  ye(eg)  (h) the(f) gates,(geedf) for(f) God(fe) him-(d)self(ef) is(d) with(dc) Us,(c) &amp;(cd) le_J(d)  lu(eg)  (c) ia.(c)  (h)  (g)  (f)  (eg) ",
        groupIndex: 0,
        filename: "./pages/part-c-034.png",
        nextFileName: "./pages/part-c-035.png"
    },
    {
        title: "part-c-034-1",
        gabc: "P(gi) Lo,(e) in(e) the(ee) time(g) ap,(h) I(ihj) -(i)the(i) Lord(ij) will(i) come,(h)  and(h) will(fh) not(fg) lie:(ef) though(d) he(f) tar-(hhi)ry,(i) wait(h) for(f) him;(fe)  for(e) he(e) will(e) sure-(ef)ly(dc) he(d) will(ef) not(f) tar(e) Y,(edc)  (f)  al(gi)  (cd) le(de) lu(e) 1a.(e) YT(j) e(i) ](h) |(gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-034.png",
        nextFileName: "./pages/part-c-035.png"
    },
    {
        title: "part-c-035-0",
        gabc: "T(c) \xae(dc) mountains(f)  (g) and(f) the(gh) hills(h) shall(h) break(hg) forth(h) be(g) fore(f)  God(ef) in-(g)to(fe) singing,(d)  (d) and(d) all(f) the(fg) trees(h) of(g) the(f) for(gh) \u2014est(h)  shall(hjj) clap(g) their(hj) hands:(h) for(f) be\u2014hold(gh)  (hgg) he(e) com-(fg)eth,(g) our(d)  Lord(ef) and(f) Rul(dd) .(c) to(d) reign(dd) for-(cde)ev-(ge)er,(fg) al-(e)0(c) lu-(e)ia,(g)  al(e) -(fe)lu-(d)1a.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-035.png",
        nextFileName: "./pages/part-c-036.png"
    },
    {
        title: "part-c-035-1",
        gabc: "B(g) hold,(hj) our(j) Lord(j) shall(j) come(j) with(h) pow-(ih)er,(g) to(g) en-(h) lighten(j)  lighten(j)  (i) the(g) eyes(gh) of(f) his(g) ser-(f)=(fd) -(f)le-(fg)lu-(e)ia.(e)  |(j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-035.png",
        nextFileName: "./pages/part-c-036.png"
    },
    {
        title: "part-c-036-0",
        gabc: "Now(c)  (d) when(cd) John(f) had(hg) heard(h) in(h) the(h) pri-(h)son(g) the(ef) works(g) of(fe)  7(d) he(d) sent(f) two(d) of(dc) .(f) .(g) -(fh)ples,(h) and(h) said(h) Unto(g)  (h)  (f)  him:(f) Art(f) thou(gh) he(h) that(gh) should(fe) come,(dfddc) or(cd) do(f) we(ef) look(g) 0(e)  an(fe) \u2014oth(d) \u2014er?(d) P.B.(h) ANTIPHON(g)  (f) ON(gh)  (gf)  He(c)  (g) shall(gd) sit(f) up-(fg)on(h) the(g) throne(h) of(g) Da(f) vid,(ghghih) and(f) of(g) his(h)  (j)  king\u2014dom(ik)  (hj)  (g) there(fe) shall(d) be(f) no(gh) end,(gfd) al-(f)le-(fg)lu-(g)ia.(g)  (j) |(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-036.png",
        nextFileName: "./pages/part-c-037.png"
    },
    {
        title: "part-c-036-1",
        gabc: "From(c)  (e) hea\u2014ven(e) a(g) there(h) com-(j)eth(i) the(i) Lord,(ih~) the(f) Rul(hg) er,(e) and(e)  (d)  in(i) his(h) hand(f) are(h) hon-(h)our(ih) and(f) do(f) ~min-(e)ion.(e)  (e) &#39;(j)  (i)  (dh) g(gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-036.png",
        nextFileName: "./pages/part-c-037.png"
    },
    {
        title: "part-c-037-0",
        gabc: "The(gi)  (f) Lord(e) shall(f) a\u2014rise(h)  (h) up\u2014on(h)  (j) thee,(i) O(h) Je-(i)ru-(j)sa-(ih)lenm,(i)  and(f) ;(h) glo\u2014ry(fe)  (fe) shall(d) be(e) seen(f) up(h) \u2014on(f) thee.(f) e(i)  (h) o(i)  (j) e(h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-037.png",
        nextFileName: "./pages/part-c-038.png"
    },
    {
        title: "part-c-037-1",
        gabc: "Be-(c) (ch) hold(j) I(jk) send(kji) my(hj) @(i) mes\u2014sen\u2014ger,(h)  (g) and(j) he(ij) shall(h) pre\u2014pare(g)  (g)  my(gh) way(fed) be_fore(ef)  (gh) thy(h) face.(g) THURSDAY(j)  (i)  (j)  (h) :(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-037.png",
        nextFileName: "./pages/part-c-038.png"
    },
    {
        title: "part-c-037-2",
        gabc: "T}iou,(c)  (ig) O(ij) Lord,t(i) art(i) he(i) that(g) is(h) to(g) come,(e) for(h) whom(h) we(fh) look,(g)  to(f) save(ef) thy(gf) peo-(e)ple.(e) FRIDAY.(j)  (i)  (h)  (gh)  (g)  Say(f) to(ghg) them:t(h) Ye(h) that(h) are(g) of(h) 4(g) fear\u2014ful(e)  (f) heart,(g) be(fe) strong:(ded)  for(g) (-(e)be_hold(f) the(g) Lord(f) our(fg) God(e) all(f)  (d) come.(d)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-c-037.png",
        nextFileName: "./pages/part-c-038.png"
    },
    {
        title: "part-c-038-0",
        gabc: "e(cd) Lord(c) shall(d) set(ef) up(g) an(fe) en-(d) (d) for(fh) the(g) na-(hg)tions,(f)  a(e) as-(g)sem-(h)ble(f) the(ef) out-(g)casts(e) of(fe) Is-(d)ra-(d)el.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-038.png",
        nextFileName: "./pages/part-c-039.png"
    },
    {
        title: "part-c-038-1",
        gabc: "The(ik)  (f) Lord(h) will(g) surely(h)  (g) [}(e) and(f) o(gh) not(ef) tarry:(d)  (d) and(d)  will(f) bring(g) to(g) light(g) the(g) hid-(h)den(fg) things(g) of(fgh) darkness,.(f)  (f)  and(f) will(g) ma-(h)ni-(g)fest(h) him-(g)a(e) to(f) all(fg) na-(fe)tions,(cd)  al(d) le(efe) lu-(d)1ia.(d)  (h)  (g)  (f)  (g)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-038.png",
        nextFileName: "./pages/part-c-039.png"
    },
    {
        title: "part-c-038-2",
        gabc: "%-(c)s(e) sa-(f)1lem,(g) Tjoy(fe) with(f) great(d) rejoicing,(ef)  (fh)  (g) for(ddhjdddjkidd) ",
        groupIndex: 2,
        filename: "./pages/part-c-038.png",
        nextFileName: "./pages/part-c-039.png"
    },
    {
        title: "part-c-039-0",
        gabc: "Zaviour(hi)  (hg) cometh(h)  (g) un-(f)to(fe) thee,(d) al(e) le-(de)lu-(c)1ia.(c)  (h)  (g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-c-039.png",
        nextFileName: "./pages/part-c-040.png"
    },
    {
        title: "part-c-039-1",
        gabc: ";(ik) will(g)  (gfd) place(fe) sal-(fg)va-(fh)tion(g) Tin(fh) Si-(h)on,(g) and(h) in(j) Je-(g) ri-(ik) (hg) sa-(fg)lem(g) my(hg) glo-(fe)ry,(d) al(f) ~le-(fg)lu-(g)ia.(g) ||(j) SNSRI(i)  (j)  (h) ||(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-039.png",
        nextFileName: "./pages/part-c-040.png"
    },
    {
        title: "part-c-039-2",
        gabc: "Mountains(cgi)  (c)  (f)  (d) and(f) all(hi) hills(h) {shall(hi) be(j) a-(ih) (hi) bas\u2014ed,(f) and(f) the(i)  crook\u2014ed(h)  (h) shall(f) be(e) made(ef) straight,(f) and(d) the(e) rough(fd) pla\u2014ces(e)  (ef)  plain,(d) Come,(hf) O(hih) Lord,(ggf) and(e) tar-(e)ry(e) not,(de) al(f) o(ef) lu-(d)ia.(d) B(ig)  (h) |(f) ",
        groupIndex: 2,
        filename: "./pages/part-c-039.png",
        nextFileName: "./pages/part-c-040.png"
    },
    {
        title: "part-c-039-3",
        gabc: "Let(ff) ](e) live(f)  (g) righteously(h)  (i) and(h) godly,(f)  (f) looking(e)  (f) for(h) L](fe)  A(gi) blessed(g)  (ig) R(hg) and(e) R(f) -(h) (g) of(e) U0(d)  (fgh) Lord.(f) o(d) Y(h)  (g)  (e) |(f) ",
        groupIndex: 3,
        filename: "./pages/part-c-039.png",
        nextFileName: "./pages/part-c-040.png"
    },
    {
        title: "part-c-040-0",
        gabc: "He(cg) shall(gd) sit(f) up-(f)on(gh) the(g) thronet(h) of(g) Da(f) vid,(ghghih) and(f) of(g) hig(h)  kingdom(hj)  (g) there(fe) shall(d) be(f) no(gh) end,(gfd) al-(ef)le-(fg)lu-(g)ia,(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-040.png",
        nextFileName: "./pages/part-c-041.png"
    },
    {
        title: "part-c-040-1",
        gabc: "Nev(d) when(cd) John(f) had(gh) heardt(h) in(h) the(h) prison(h)  (g) the(ef) works(g) of(fe) Christ,(d)  he(d) sent(f) two(d) lof(dc) his(f) dis\u2014ci-(g) (fh) ples,(h) and(h) said(h) un-(g)to(h) him:(f) Art(f)  (g)  thou(gh) he(h) that(gh) should(fe) come,(dfddc) or(cc) do(f) we(ef) look(g) for(e) an\u2014oth-(fe) (d) er?(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-040.png",
        nextFileName: "./pages/part-c-041.png"
    },
    {
        title: "part-c-040-2",
        gabc: "B(c)  (f) hold(e) the(f) Lord(h) shall(ij) come,(i) the(i) Prince(i) of(f)  (h) the(i) kings(dfjf) of(dhi) ",
        groupIndex: 2,
        filename: "./pages/part-c-040.png",
        nextFileName: "./pages/part-c-041.png"
    },
    {
        title: "part-c-041-0",
        gabc: "che(h) earth:(i) bless\u2014ed(gi)  (hg) are(fe) they(f) that(e) are(d) pre(e) \u2014par-(gf~)ed(h) to(h)  meet(f) him.(f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-041.png",
        nextFileName: "./pages/part-c-042.png"
    },
    {
        title: "part-c-041-1",
        gabc: "When(c)  (h) the(h) Son(h) of(hg) man(hiih) com(fhg) eth,(e) shall(hhg) he(fef) find(de) faith(ef)  on(ig~)  (g) the(f) earth?(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-041.png",
        nextFileName: "./pages/part-c-042.png"
    },
    {
        title: "part-c-041-2",
        gabc: "Lo,(df) now(hf) com\u2014eth(hi)  (h) the(h) fulness(f)  (e) of(f) the(e) time,(d) wherein(d)  (e) God(fe) sent(d)  &quot;(gi) forth(ef) his(f) Son(h) in-(e)to(f) the(e) world.(d)  (h)  (i)  (g)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-041.png",
        nextFileName: "./pages/part-c-042.png"
    },
    {
        title: "part-c-041-3",
        gabc: "ith(c)  (h) joy(hg) shall(fh) ye(h) draw(fe) wa(fe) \u2014ter(d) out(f) of(d) the(f) wells(h) of(e) sal-(fe) T(d) 3(d)  (h)  (i) ;(g)  (h)  (d)  (hfh) ",
        groupIndex: 3,
        filename: "./pages/part-c-041.png",
        nextFileName: "./pages/part-c-042.png"
    },
    {
        title: "part-c-042-0",
        gabc: "he(f) Lord(e) shall(f) go(hi) forthTout(i)  (i) of(h) his(i) ho(j) 1y(h) place:(i)  he(jk)  he(gihg) shall(ef) come(f) to(e) save(de) his(fh) people.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-042.png",
        nextFileName: "./pages/part-c-043.png"
    },
    {
        title: "part-c-042-1",
        gabc: "D(c) rop(f) down,(e) ye(f) heavens,(h)  (h) from(h) a-(ij)bove,(i) and(i) let(h) the(i)  skies(jh) pour(i) down(ij)  (h) righteousness:(g)  (f) let(f) the(i) earth(h) o(f) pen,(f)  [(e) let(d) them(e) bring(fg) forth(h) [(h) salvation.(f) o(f) e(i)  (h) |(i)  (j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-042.png",
        nextFileName: "./pages/part-c-043.png"
    },
    {
        title: "part-c-042-2",
        gabc: "end,(e) O(f) Lord;(h) the(hi) Lamb,(i) the(i) Ruler(h)  (i) of(j) the(h) land,(i)  from(i) the(i) rock(fi) of(g) the(h) de-(fe)sert(f) un-(e)to(d) the(e) mount(f) of(g)  the(h) daughter(hg)  (hi) of(hg) Si-(f)on.(f) e(i)  (h) ittt(i)  (j)  (h) |(fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-042.png",
        nextFileName: "./pages/part-c-043.png"
    },
    {
        title: "part-c-043-0",
        gabc: "That(e) thy(f) way,(h) O(ij) Lord,(i) may(h) be(i) known(j) up(i) \u2014on(h) earth,(i)  thy(jk)  thy(ig~)  (gihg) saving(f)  (e) health(f) a-(e)mong(de) all(fh) nations.(f)  (f) |(i) .(h)  (i)  (j) i(h) iv(fh)  Re.-(f)ward(e) thou(f) them,(h) O(ij) Lord,(i) that(hi) wait(j) for(h) thee,(i) and(f) let(g)  thy(h) =(fe) pro\u2014phets(fe) be(de) found(f) faith\u2014ful.(f)  (f)  (i)  (h)  (i) i1(j)  (h)  (f)  he(dd) &quot;(c) was(d) )(ef) en(g) by(fe) Moses,(d)  (d) but(fg) grace(hg) and(gf) truth(f)  5(jk)  came(f) by(g) n(e) Je\u2014sus(fe) Christ.(d) e(h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-043.png",
        nextFileName: "./pages/part-c-044.png"
    },
    {
        title: "part-c-043-1",
        gabc: "Te(c)  (d) prophets(dd)  (c) did(d) foret\xe9ll(fe)  (dc) fthat(f) 2(g) Saviour(h)  (g) should(fg) be(f) born(f)  of(f) the(g) T(e) gin(f) Ma(c)  (cd) \u2014ry.(d) e(h)  (g)  (f)  (d)  (fgh)  (g)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-043.png",
        nextFileName: "./pages/part-c-044.png"
    },
    {
        title: "part-c-044-0",
        gabc: "T(gi) he(f) Spi\u2014ritTof(fgh)  (f)  (f) the(f) Lord(fe) is(f) up-(hg)on(e) me:(e) he(f) hath(g)  T(g) sent(f) me(e) to(g) preach(i) the(h) Gospel(h)  (fh) to(i) the(hg) poor.(f)  (h) ](g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-044.png",
        nextFileName: "./pages/part-c-045.png"
    },
    {
        title: "part-c-044-1",
        gabc: "or(f) Si-(h)on\u2019s(hi) sake(i) TI(i) will(h) \u2014_\u2014\\.(i) hold(j) my(ih) peace;(i) until(i)  (f) the(i)  righteous-(g) (h) ness(f) L](e) thereof(f) ](e) forth(de) as(fh) brightness(f)  (f)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-044.png",
        nextFileName: "./pages/part-c-045.png"
    },
    {
        title: "part-c-044-2",
        gabc: "Be-(f)hold,(e) the(f) Lord(h) shall(hj) come,(i) that(i) he(h) \u2014Q\u2014\u2014\u2014\u2014\u2014\u2018(i) sit(j) a\u2014mong(i)  (h)  princes,(i)  (i) and(g) in-(h)he-(fe)rit(f) the(e) tkrone(de) of(fh) glo-(f)ry.(f) |(i) a0,(h)  (i)  (j) |(h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-044.png",
        nextFileName: "./pages/part-c-045.png"
    },
    {
        title: "part-c-044-3",
        gabc: "ell(h) it(hi) TR(i) R(i) mong(h) B(i)  (j) e(i) and(h) e(i) say:Be-(i)=(fi)  our(gh) God(fe) and(ef) Sa-(de)viour(fh) e(f) e(f) &#39;(i) \u2018(h)  (hj) )(i)  (d) ",
        groupIndex: 3,
        filename: "./pages/part-c-044.png",
        nextFileName: "./pages/part-c-045.png"
    },
    {
        title: "part-c-045-0",
        gabc: "rom(f) Si(gh) on(h) draweth(h)  (g) nigh(h) the(ef) Lord(g) Al-(f)migh-(d)ty(d) to(d)  Si(i)  bring(fe) salvation(fg)  (fe)  (c) un-(eg)to(e) his(fe) people.(d)  (d) \u2122(h) WIF(g)  (f) BT(g) Wi(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-045.png",
        nextFileName: "./pages/part-c-046.png"
    },
    {
        title: "part-c-045-1",
        gabc: "T;m&#39;(he) thee(f) &#39;a-(ed)gain,(efe) O(de)  (e) at(gh) the(if) last,(hg) and(i) do(i) not(h)  T;m&#39;(c)  de-(h)lay(ij) to(i) come(hghih) un-(ef)to(fh) thy(gf) e(e) servants.(e) |||(h) e(g)  (h)  (f) W(e)  From&#39;Si-(f) (gh)  (h) onTcomet.h(h) a(g) he(h) that(g) is(e) to(f) reign(g) as(fe) Lord:(d) e(f)  Fm-(f) (gh) man(gf) el(f) 1is(fe) his(dc) migh-(d)ty(efe) Name.(d) [(h) e\xab(g) e(f) e(g) ](ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-045.png",
        nextFileName: "./pages/part-c-046.png"
    },
    {
        title: "part-c-045-2",
        gabc: "ET(c)  (gd) o(f)  (g) my(h) God,(g) tand(g) I(g) will(g) give(hg) him(f) honour:(gh)  (h) my(hj) fa\u2014(g)  (f)  thers\u2019(fe) God,(f) and(d) I(df) will(fgh) ex-(h)alt(g) him.(g) &#39;(j)  (i) bial(j)  (h) O(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-045.png",
        nextFileName: "./pages/part-c-046.png"
    },
    {
        title: "part-c-046-0",
        gabc: "T(g) Lord(hj) is(j) O(h) B(j) SO(i) S(i) e(g) ey(hi) St(i) s(h) King,(g) he(i)  himself(h)  (j) will(i) 0(g) and(h) will(f) save(g) -(e)us.(j)  (h)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-c-046.png",
        nextFileName: "./pages/part-c-047.png"
    },
    {
        title: "part-c-046-1",
        gabc: "B(gi) |(fi) ye(hg) steadfast,T(ef)  (f) and(f) see(f) the(h) sal-(g)(T(e) va\u2014tion(e) of(g) 5(e)  [(gi) Lord(f) with(gh) you.(f) S(h) 7y(g) sy(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-046.png",
        nextFileName: "./pages/part-c-047.png"
    },
    {
        title: "part-c-046-2",
        gabc: "](e) to(f) thee,(h) 0(hi) Lord,(i) Tdo(i) I(i) lift(i) up(h) my(ij) soul:(i)  =(fi) and(g) de-(h)1liv-(f)I+(e) me,(fe) for(d) I(e) flee(fg) un-(h)to(hg) thee,(hi)  0(hg) Lord.(f) e(i) \u2014I\u2014=(h) e(i) ey(j) S(h) e(fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-046.png",
        nextFileName: "./pages/part-c-047.png"
    },
    {
        title: "part-c-046-3",
        gabc: "RGN(gi) Clome,(h) 0(hi) Lord,T(i) and(i) do(hi) S(jh) tarry:(i) (i(i) forgive(i)  (fi) the(g) ",
        groupIndex: 3,
        filename: "./pages/part-c-046.png",
        nextFileName: "./pages/part-c-047.png"
    },
    {
        title: "part-c-047-0",
        gabc: "of-(h)fen-(fe)ces.(fe) of(d) thy(e) people(f)  (h) Is-(f)ra-(f)el.(f)  (i) i(h)  (hj) 4(i)  God(dd) shall(c) come(d) \xa3rom(f) Le\u2014ba-(g) (fe) rion,(dc) and(f) his(g) bright-(h)ness(f)  shall(f) be(fg) as(e) the(fe) light.(d) N(h) e(g)  (f) e(gh) eE(g)  Therefore(hi)  (i) I(i) will(h) look(ij) un-(h)to(i) the(j) Lord,(i) and(i) I(f) will(i) T(g)  -(gh)for(f) the(e) God(f) of(e) my(ed) sal-(fh)va-(f)tion.(f) o(i) .(h)  (hj) s(i) ",
        groupIndex: 0,
        filename: "./pages/part-c-047.png",
        nextFileName: "./pages/part-c-048.png"
    },
    {
        title: "part-c-047-1",
        gabc: "The.word(gi)  (f)  (h) of(h) the(hj) t(i) shall(h) be(i) look\u2014ed(j)  (i) for(h) as(ij) the(j) rain,(i)  and(gihg) as(f) 0(e) dew(fe) L(d) N(e) God(f) e(g) down(h) [(fghg) B,(f) us.(f)   (i)  (h)  (i)  (j)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-c-047.png",
        nextFileName: "./pages/part-c-048.png"
    },
    {
        title: "part-c-048-0",
        gabc: "Be(eh) not(f) a-(de)fraid,(e) for(i) up-(g)on(j) the(i) fifth(hi) day(h) oyr(hgf) ot(hi)  shall(jk)  shall(gi)  (hf) come(g) to(f) you.(e) SEC(h) 8T(g) L(h)  (f) RayR(e) ",
        groupIndex: 0,
        filename: "./pages/part-c-048.png",
        nextFileName: "./pages/part-c-049.png"
    },
    {
        title: "part-c-048-1",
        gabc: "There(d) shall(dc) come(fg) fortht(ihi) a(h) rod(ihghihgg) out(f) of(e) the(f) stem(g) of(fe) Jes-(de)se,(d)  and(d) all(ff) the\xae(defedcd) ejr.th(dc) shall(ffg) be(ihi) fill-(hi)ed(h) with(h) the(ghg) glo-(hg)ry(fe) of(fg)  the(fe) Lord:(f) and(f) all(def) flesh(fe) shall(df) o(fc) the(e) sal-(f)va-(g)tion(e) of(fe) God.(d)  .(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-048.png",
        nextFileName: "./pages/part-c-049.png"
    },
    {
        title: "part-c-049-0",
        gabc: "Thou&#39;(c)  (g) Beth\u2014-(hj)le-(j)hem,(j) in(j) the(j) land(j) of(hj) Ju\u2014da,(ji)  (g) shalt(gi) not(hg) be(e)  the(fg) least:(g) for(g) out(g) of(h) thee(j) shall(j) come(j) a(h) Gov\u2014er-(j) (i) nor,(g)  that(g) shall(g) rule(fh) my(g) peo-(h)ple(gf) Is-(g) (gf) ra~el.(e) e(j)  (h) e(j) Ao(ih) ",
        groupIndex: 0,
        filename: "./pages/part-c-049.png",
        nextFileName: "./pages/part-c-050.png"
    },
    {
        title: "part-c-049-1",
        gabc: "The(h) An\u2014gel(fg)  (gh) t(f) Ga\u2014bri\u2014el(g) e(ihi) was(hf) sent(h) to(j) Ma\u2014ry,(i)  (j) a(h) Vir\u2014gin(j)  (ij)  es\u2014pous(h)  (gf) \u2014ed(gh) to(i) Jo-(h)\u2014seph.(g)  (ef)  (j)  (i)  (j) \u2018(h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-049.png",
        nextFileName: "./pages/part-c-050.png"
    },
    {
        title: "part-c-049-2",
        gabc: "~(e) Ye(f) =(g) watchful(f) 3(g) your(f) 3(efhhg) for(e) the(f) Lord(gf) e(df) (iod(fc)  1s(fd) nigh(f) at(fg) hand.(e) :(h) SR(h) R(g)  (h) ;(ih) T(gfe) P,(e) ;(fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-049.png",
        nextFileName: "./pages/part-c-050.png"
    },
    {
        title: "part-c-050-0",
        gabc: "For(c)  (d) lo,(f) as(fg) soon(g) as(g) the(g) voice(g) of(g) thy(f) sal(gh) \u2014u-(h)ta-(g)tjon(g)  sound-(dg)ed(f) in(e) mine(df) ears,(df) the(cd) babe(ffd) leap-(fh)ed(g) in(h) my(gf) womb(ghg) fo,(fe)  T(d)  T(dc) al(d) -(efe)lu-(d)1a.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-050.png",
        nextFileName: "./pages/part-c-051.png"
    },
    {
        title: "part-c-050-1",
        gabc: "H(c) n(c) shall(e) this(gf) be,(df) O(f) An-(f)gel(e) of(d) a(cdfdefe) see-(e)ing(f) I(ghg)  :(eg) know(fd) not(e) a(d) man?(c) Hearken,(ghg) e(g) O(hj) Vir-(ji)gin(hg) Ma(h) ry:(hge) the(f)  Ho(h) ly(g) Ghost(fgf) shall(ef) come(fh) up-(g)on(fe) thee,(df) and(f) the(g) pow&#39;r(ffe) of(d)  the(ge~)  (ef) Highest(d)  (c) shall(c) ov-(c) (cd) -(dc)er(c) thee.(c)  (h)  (g)  (f)  (ed)  er(d) ",
        groupIndex: 1,
        filename: "./pages/part-c-050.png",
        nextFileName: "./pages/part-c-051.png"
    },
    {
        title: "part-c-051-0",
        gabc: "?(c) Be-(cj)hold(ji) all(h) things(g) are(hi) fulfilled(h)  (g) t(g) which(gh) were(g) spo-(g)ken(e) by(g)  the(g)  (ef) An\u2014gel(f) of(d) the(ef) Vir-(gh)gin(h) Ma-(g)ry.(g) ADVENT(j)  (h)  (j)  (k)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-c-051.png",
        nextFileName: "./pages/part-c-052.png"
    },
    {
        title: "part-c-051-1",
        gabc: "\uFB01low(c)  (f) the(c)  (d)  (dhi)  (h) Si(hgfg)  (fghghi) on,(hgg) for(f) the(g) day(h) of(g) the(f)  Lord(g) is(dg) nigh&#39;(gfed) =(fed) at(cdfede) hand:(e) behold,(f)  (fg) he(fe) cometh(c)  (d) to(f) save(ed)  us,(def) al-(c)le-(d)lu-(fg)ia,(fe) al-(g)le(fe) lu-(d)ia.(d)  (h)  (g)  (f)  (h)  (g)  TtheDesire(ikc)  (d)  (dc)  (f)  (g)  (fh) of(h) all(h) nations(ih)  (g) shall(fh) come:(g) and(g) the(g) house(g)  a(e) the(g) Lord(h) shall(g) be(f)  (f) &lt;(g) filledwithglory,(f)  (fe) al-(dc) (d) le(efe) \u2014lu-(d)ia.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-051.png",
        nextFileName: "./pages/part-c-052.png"
    },
    {
        title: "part-c-052-0",
        gabc: "The(c)  (cd) crook\u2014ed(dh) f(hi) shall(h) be(g) made(h) straight,(h)  (fhg) and(f) the(g) rough(hgef) a(g) places(fe)  plain:(d) come,(fg) O(ef) Lord,(d) and(ef) do(g) not(f) tar-(fe)ry,(dc) al(d) \u2014le(efe) lu-(d)ia,(d)  Dominus(h) veniet(g)  (f) .(gh) .(g)  &#39;he(cdc) Lord(f) will(gh) come,(h) go(h) ye(hj) out(h) to(g) meet(hg) him,(e) say-(ff)ing:(d)  Great(hihh) is(g) his(hj)  (j) do\u2014min\u20141ion,(jih)  (h) and(hgg) of(f) his(gh) king-(gfg)dom(g) there(h) shall(g)  be(f) no(gf) end:(d) .the(g) migh-(ggg)ty(gd) God,(efd) the(e) Gov-(f) (de) er\u2014nor,(dc) the(cd)  Prince(ffe) of(fg) peace,(g) al(c) \u2014le-(d)lu-(f)1ia,(e) al(g) -(fe)le-(d)1ia.(d)  (h) ||(g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-052.png",
        nextFileName: "./pages/part-c-053.png"
    },
    {
        title: "part-c-052-1",
        gabc: "Thine(hg)  (h) Al-(gh)mighty(f)  (fe) Word,(f) O(hg) Lord,(e) leapeth(g)  (h) down(i) from(hg) heaven(f)  (f)  out(ig~)  (h) of(g) thy(h) roy-(i)al(h) throne,(ge) al(f) \u2014-(ghg)lu-(f)ia.(f) ;(h)  (ddg)  (edd)  (df)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-052.png",
        nextFileName: "./pages/part-c-053.png"
    },
    {
        title: "part-c-053-0",
        gabc: "H(c)  (c) ail,(cd) Ma\u2014ry,(dhi)  (h) thou(h) that(g) art(f) full(g) of(gh) grace,(h) the(f) Lord(h) is(gf)  with(g) thee:(d) blessed(g)  (h) art(g) thou(fe) e(f) a\u2014mong(gf) e(dc) =(ef) al-(g)le(fe) lu-(d).(d)  0(h)  (g)  (f) 3(gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-053.png",
        nextFileName: "./pages/part-c-054.png"
    },
    {
        title: "part-c-053-1",
        gabc: "Thus(g) saith(f) the(e) Lord(d) your(d) God:(fdfghhg) Re-(cd)pent(ffg) ye,(g) and(g) turn(h)  a(ghgfg) gain;(gf) for(f) the(gh) kingdom(j)  (g) of(h) hea\u2014ven(gd)  (f) 1s(gh) at(h) hand,(gfd)  (f)  al(ik)  (f) \u2014-(fg)le\u2014lu-(g)ia.(g)  (h) PR(j)  (i) .(j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-053.png",
        nextFileName: "./pages/part-c-054.png"
    },
    {
        title: "part-c-054-0",
        gabc: "Awake,(hgicf)  (fi) a-(hg)wake,(ef) put(f) on(h) strength,(e) O(e) arm(ge) of(f) the(fh) Lorq,(f)  |(h)  (g)  (e) WEDNESDAY(f)  I(f) will(g) place(h) sal-(g)va-(fg)tion(g) in(fh) Si-(h)on,(g) and(h) in(j) Je-(g)ru-(hg) (f)  sa\u2014lem(fg) W(g) my(hg) glo-(fe)ry,(d) al-(f)le-(fg)lu-(g)ia.(g) :(j)  (i) SRl(j)  (h) v(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-054.png",
        nextFileName: "./pages/part-c-055.png"
    },
    {
        title: "part-c-054-1",
        gabc: "Com\u2014fort(h) i~(hg) ye,(f) AN(f) ye(fh) my(hih) peo-(hg)ple,(fe) saith(f) your(ghg) God.(f)  A(gi) 3(h)  (g) a(e) .(f)  Be-(j)hold,(hji) all(h) things(g) are(hi) e(h) fulfilled(g) t(g) which(gh) were(g) spoken(g)  (e) by(g)  the(g) An\u2014gel(ef)  (f) of(d) the(ef) Vir-(h)gin(h) Ma(g) \u2014ry.(g) :(j)  (h) |(j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-c-054.png",
        nextFileName: "./pages/part-c-055.png"
    },
    {
        title: "part-c-055-0",
        gabc: "Mere(cdc) was(f) a(g) marriage(fh)  (h) tin(h) Ca\u2014na(h)  (hjj) of(h) Ga-(h)1i(gf) lee,(icgihghg) and(g)  Je(e) sus(g) was(hg) there(fgf) with(c) Ma(dg) \u2014ry(e) his(fe) Mo(d) \u2014ther.(d) [(h) i:_l__l(g)  (f)  (gh) =(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-055.png",
        nextFileName: "./pages/part-c-056.png"
    },
    {
        title: "part-c-055-1",
        gabc: "Je\u2014sus(g)  (h) saw(ghj) the(j) heavens(ji)  (h) o(hi) \u2014pen\u2014ed,(hg)  (g) and(g) the(hi) Spi-(h)rit(gf) like(e)  a(fg) dove(g) de-(gh)e(hgf) scend\u2014ing(g) up(gf) \u2014on(e) him.(e) e(ji) \xa2(hi) e(h) el(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-055.png",
        nextFileName: "./pages/part-c-056.png"
    },
    {
        title: "part-c-056-0",
        gabc: "\\M\\en(c)  (g) \u2014(h) sus(gf) was(g) come(hj) down(hj) from(i) the(h) mountain,(g)  (g) be-(f)hold(g)  there(hj) came(ji) alep(hg)  (hihg) er(g) and(fh) wor-(j)[t(ji) shipped(hg) him,(hih) say-(g)ing,(g) Lord,(gfd)  if(e) thou(fg) wilt,(ghgf) thou(h) canst(j) make(i) me(hih) clean.(g) And(g) Je(g) sus(g) put(h)  orth(eg) his(fg) hand(gfed) and(e) touch-(f)ed(g) him,(ghgf) =(h) ing:(h) =(hjjihg) will;(hi) be(i)  thou(hih) clean.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-056.png",
        nextFileName: "./pages/part-c-057.png"
    },
    {
        title: "part-c-056-1",
        gabc: ".(f) when(g) Je(if~hi) sus(i) was(ih) en-(g)ter\u2014ed(f)  (g) in-(ghg)to(f) aship,(ef)  (f) be-(f) (f)  hold,(fe) there(d) |a(dc) rose(ifghihg) a(g) great(gf) tem-(g)pest(iih) in(gh) the(gf) sea:(df) and(fghidhg) ",
        groupIndex: 1,
        filename: "./pages/part-c-056.png",
        nextFileName: "./pages/part-c-057.png"
    },
    {
        title: "part-c-057-0",
        gabc: "his(gf) dis\u2014ci-(fg) (fe) ples(d) |a(dc) woke(gf) him,(ghg) say-(f)ing:(f) Lord,(g) save(fi) us,(ih)  per\u2014ish.(f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-057.png",
        nextFileName: "./pages/part-c-058.png"
    },
    {
        title: "part-c-057-1",
        gabc: "Sir,\u2019[(dh) didst(h) not(g) thou(h) sow(gf) g\xe9od(fd) seed(fgh) \xe9n(f) t\xe9y(edfede) tglem,(ed) ;rom(gf)  whence(fghgfgh) then(g) hath(fe)  (dc) tares?(d) H\xe9(c) said(d)  (f)  (d) An(dc)  (cg)  en(fghgfgh) e-(g)my(fe) hath(dc) done(efe) this.(d) ey(h)  (g) oty(f) P(gf)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-057.png",
        nextFileName: "./pages/part-c-058.png"
    },
    {
        title: "part-c-057-2",
        gabc: "un\u2014to(i) a(h) grain(ih) of(f) mus\u2014(hi)  |-(hg)seed,(f) which(eh) is(h) the(h) least(hg) |(fe) all(gf~fe) 8(e) |(fhi) oW(e) when(hg~) it(ij)  :(k) grown,(ji) [(hg) is(h) S\u2014\u2014(i) e(ihij) e(i) ey(gh) e(ihfg) e(fe) e(j) e(i) dg(h) et(gi) ",
        groupIndex: 2,
        filename: "./pages/part-c-057.png",
        nextFileName: "./pages/part-c-058.png"
    },
    {
        title: "part-c-058-0",
        gabc: "A(g) the(h) lightning(ghj)  (j) com-(i)eth(j) out(k) of(ji) the(hi) east,(hg) and(hg) shineth(j)  (i)  e-(hi)ven(hg) un-(fe~)to(g) the(h) west;(gfd) so(dh) shall(h) al(hj) \u2014so(h) the(g) [(e) ing(f) of(g)  the(ik)  (f) Son(g) of(h) man(gfe) be.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-c-058.png",
        nextFileName: "./pages/part-c-059.png"
    },
    {
        title: "part-c-058-1",
        gabc: "Have(h) Sleol(h) -(h)O(e) God,(g) up-(i)R(h) me,(h) and(h) cleanse(h) me(j) from(i) my(j)  wick-(h)ed-(g)ness;(hg) for(e) a-(f)gainst(g) thee(g) on-(e)1ly(f) have&#39;l(gh) e(fe) sin-(d)ned.(d)   (h)  (g)  (f)  (g)  (h)  I(f) will(fg) thank(g) thee,(gf) for(h) thou(j) hast(i) heard(g) me.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-058.png",
        nextFileName: "./pages/part-c-059.png"
    },
    {
        title: "part-c-059-0",
        gabc: "0(d) God,(d) thou(f) art(e) my(d) God,(d) N(dc) ly(fg) :(jihi) I(h) seek(fg) theed,(fgfefedcdc) :(dc)  he\u2014cause(cd)  (fg) thou(f) hast(ef) been(g) my(fe) hel\u2014per.(d)  (d) R(h) s(g) e(f) e(gh) P(gf)  Bless\u2014ed(f) g(e) art(f) thou(d) in(d) the(dc) fir-(f)ma-(g)ment(hi) of(g) hea\u2014ven:(iig)  (h) and(h)  wor\u2014thy(h)  (g) to(f) be(e) prais\u2014ed(f)  (f) for(fg) ev-(fe)er,(c) Q(d) our(efe) God.(d)  (h) g(g)  (fh) i7(g)  ()(dh) praise(hg) the(ef) Lord(g) of(fe) heaven.(d)  (d) |(h) R(g)  (f) s(gf) s(gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-059.png",
        nextFileName: "./pages/part-c-060.png"
    },
    {
        title: "part-c-059-1",
        gabc: "T(cd) e(idhi) kingdom(h) of(h) heaaven(h)  (ihghih) 1s(h) like(h) un\u2014to(h)  (g) a(f) man(e) that(f) is(g) an(fe)  (d)  e(ki~) hOUSeholder,(d)  (cd)  (d) which(cd) went(idhi) out(h) ear\u2014ly(h)  (h) in(h) the(g) morning(hg)  (e) to(f) hire(ghfe) |(d)  labourers(d)  (cd) Sy(d) N(fd)  (e) his(f) S(h) =(ghg) U(ef) the(gf) Lord.(d) Y(h) e(g)  (ffgh) W(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-059.png",
        nextFileName: "./pages/part-c-060.png"
    },
    {
        title: "part-c-060-0",
        gabc: "Af\u2014ter(f) L](g) thy(h) great(gf) a(g) =(gh) have(f) mer-(f)7(e) up-(f)op(g) :(e)  0(fe) God.(d) S(h) s(g) iR(f)  (g) (e(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-060.png",
        nextFileName: "./pages/part-c-061.png"
    },
    {
        title: "part-c-060-1",
        gabc: "[(f) the(g) Lord(h) be(gf) on(g) my(fe) side,(d) I(f) will(gh) not(h) fear(ghg) what(f) man(gf) do-(f) eth(ef) R(g) I(fe) me.(d) SR(h)  (g) e(f) e(g) 1(ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-060.png",
        nextFileName: "./pages/part-c-061.png"
    },
    {
        title: "part-c-060-2",
        gabc: "With-(c) (ff) \xae(e) the(f) veil(h) thave(f) I(g) call-(fe)a(e) a(e) \u2014ry(f) ear-(h)ly(h) in(h) the(h)  morning:(hi)  (h) O(h) God,(ij) thou(ji) art(h) my(i) God,(iji) ear-(e)ly(f) will(h) I(g) seek(egdd)  thee.(gi)  (f) ,(h)  (g) ;(e)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-060.png",
        nextFileName: "./pages/part-c-061.png"
    },
    {
        title: "part-c-061-0",
        gabc: "Lot(g) us(g) sing(g) @(h) hymn(gf) un(hj) to(ji) the(hg) Lord(hi) our(h) God.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-061.png",
        nextFileName: "./pages/part-c-062.png"
    },
    {
        title: "part-c-061-1",
        gabc: "In(d) the(d) cym-(f)bals(e) and(d) danc-(d)\xe9s,(dc) 5\u2014on(dc)  (f) the(hg) .(fg) and(f)  pipe,(f) O(fgf) praise(e) the(fe) Lord.(d) e(h) i(g) Zos(f) T(gh) Py(gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-061.png",
        nextFileName: "./pages/part-c-062.png"
    },
    {
        title: "part-c-061-2",
        gabc: "When(c)  (g) much(gj) people(hg)  (h) were(g) gath-(gh)er-(g)ed(g) to-(g)geth-(hi)er(h) to(g) Je(fg) sus,(g)  and(j) to(kj) him(jkkj) out(h) of(gf) ev(gh) \u2014ery(ih) ci\u2014ty,(g) &amp;(g) he(g) g(gh)  by(g) a(fe) pa(de) \u2014(dc) A(c)  (g) sow\u2014er(hj)  (j) went(j) out(gh) to(gf) sow(gh) his(h) seed.(g)  a(j)  (i)  (j) .(h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-061.png",
        nextFileName: "./pages/part-c-062.png"
    },
    {
        title: "part-c-062-0",
        gabc: "Ac-(d)cord-(d)&#39;ng(dc) to(f) the(g) mul-(f)ti-(gh)tude(h) of(h) thy(h) mer\u2014cies,(hj)  (h) 0(gf) Lord,(ghg)  do(hg) a-(f)way(ef) mine(g) &#39;of(fe) fences.(d)  (d) SRR(h) N(g) e(f)  (gh) |(gf)  T}xou(c)  (h) art(h) my(hi) God,(hghih) and(h) I(f) will(hg) thank(e) thee:(e) thou(fe) art(df) my(hi)  God,(hghih) and(f) I(h) will(g) praise(e) thee.(e) [(h) e(f)  (h)  (i)  (h)  =(e) 1y(fh) will(i) I(i) seek(j) thee,(i) O(ih~) God,(g) that(h) I(iji) may(hghih) be-(f)hold(gh)  thy(gf) PO(e) o(e) [(j) Wy(i) o(h) e(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-062.png",
        nextFileName: "./pages/part-c-063.png"
    },
    {
        title: "part-c-062-1",
        gabc: "Sing(f) a(e) hym,(fed) and(cd) mag-(fg)ni-(h)fy(gf) him(fd) for(ef) ev(gfe) er.(e) -(h) (g) T(h) ,(ih)  (gfee) ",
        groupIndex: 1,
        filename: "./pages/part-c-062.png",
        nextFileName: "./pages/part-c-063.png"
    },
    {
        title: "part-c-063-0",
        gabc: "All(e) ye(ef) An(ff) gels(d) of(f) his,(hhih) O(i) praise(h) the(h) Lord(f) of(def) heaven.(d)  (d)  a(h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-063.png",
        nextFileName: "./pages/part-c-064.png"
    },
    {
        title: "part-c-063-1",
        gabc: "e-(f)hold,(fed) a(c) go(de) up(ed) to(e) Je\u2014ru-(f) (g) sa-(h)lem,(g) and(g) all(gh) things(i)  that(h) are(g) w.rit:\u2014ten(hg)  (g) con\u2014cern\u2014-(h) (fe) ing(d) the(ef) Son(gf) of(de) man(e) shall(gf)  be(ik)  (g) ac(ghg) com-(fe)plish(de) ed:(e) for(e) he(gh) shall(hg) be(f) de(gh) liv(g)  er(fe) ed(e) un-(ef)to(g) the(f) n-(edc)t:.i&#39;les,(c) and(dc) shall(ef) be(gh) mock-(g)ed,(f)  :(ik) and(gh) spit-(g)\u2014ted(fe) on;(e) and(e) they(gh) shall(hg) 0(hgf) =(f) and(h) put(gf) him(d)  to(ded) death;(c) and(c) the(d) third(ef) day(gh) he(g) .shall(f) rise(fh) a(gfe) gain.(e)   (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-c-063.png",
        nextFileName: "./pages/part-c-064.png"
    },
    {
        title: "part-c-064-0",
        gabc: "When(c)  (g) ye(h) fast,fbe(i)  (i) not(j) as(i) the(h) hy-(ih) (fg) po\u2014crites,(h) of(h) a(h) sad(if)  coun-(g)te-(f)nance.(e)  (j)  (i) THURSDAY(h)  (ih)  [ord,(c)  (f) my(gh) servant(h)  (g) li(h) \u2018eth(ghg) at(ef) home(g) sick(g) of&#39;(f) the(g) pal-(fe) grievous-(ef)ly(g)  (fe) tormented.(cd)  (d)  (d) V\xe9-(c)ri-(d)1ly(f) I(f) say(g) un-(e)to(f) thee,(d) I(f)  will(g) come(hg) and(fe~) heal(d) him.(d) i(h) g(g) ey(f) s(g)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-064.png",
        nextFileName: "./pages/part-c-065.png"
    },
    {
        title: "part-c-064-1",
        gabc: "When(c)  (d) thdu(dc) do-(f)est(g) thine(fh) alms,(h) let(i) not(h) thy(g) left(fgh) hand(f)  know(d) what(g) thy(fg) right(e) hand(ef) do-(d)eth.(d) -(h)2(hdffg)  (fhf) U(dfghddfdgdffdfhd~) ",
        groupIndex: 1,
        filename: "./pages/part-c-064.png",
        nextFileName: "./pages/part-c-065.png"
    },
    {
        title: "part-c-065-0",
        gabc: "et(ig~)  (f) they(fc) seek(eg) me(f) dai-(fg)ly,(fe) and(h) light(jki) to(gh) know(i) my(hg) ways(f)  .(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-065.png",
        nextFileName: "./pages/part-c-066.png"
    },
    {
        title: "part-c-065-1",
        gabc: "Make(cdh) me(hi) a(hg) clean(hf) heart,!0(gh)  (fe) God,(d) and(f) re(e) \u2014new(d) a(e) right(f)  spl-(g)rit(e)  (fe) me.(d)  (d)  (h)  (g)  (f)  (gf)  (gh)  Help(ig~)  (c)  (h) me(hgf) now,(fgh) O(fe) Lord:(fh) &#39;O(hf) Lord,(hij) send(iji) us(gh) now(i) i(ef) e(f) |(f)  SO(ig~) 1(f) ty.(f) A(h)  (g) e(e)  (f)  As(e) long(ehg) as\u2122(h) 1(i) 2(i) &#39;O(hg) g(g) will(f) I(f) mag-(g)ni\u2014fy(h)  (gf) thee(e) on(e)  P(h) 3(hgf) e(ghg) e(gh)  (iji) e(h) my(fgh) 1(fed)  (ef) e(gf) v(e) e(j)  (i)  (h) i(gf)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-065.png",
        nextFileName: "./pages/part-c-066.png"
    },
    {
        title: "part-c-066-0",
        gabc: "In(g)  (e) the(f) spirit(h)  (g) of(f) humil-(ef)i-(h) (f) ty(f) and(ef) with(h) a(f) contrite(h)  (ghf) heart,(fe) let(fe)  us(hgi)  (h) be(i)  (j) accepted(j)  (iji) by(gh) thee,(i) O(hg) Lord:(f) and(f) so(fi)  (ih) let(jh)  (ijijk) our(ji) sacri_(ih)  (i)  (j)  fice(gi)  (j) be(ih) of-(i)fered(f)  (f) as(f) to(i) be(h) ac-(fh)cepted(f)  (e) by(fe) thee(fgh) to-(e)day,(ec) e(e)  be(ef) pleasing(f)  (ef) in(f) =(fhj) sight,(hg) O(f) Lord(fi) 0o(gh) God.(f) e(h) e(g) e(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-066.png",
        nextFileName: "./pages/part-c-067.png"
    },
    {
        title: "part-c-066-1",
        gabc: "O&#39;praise(hhg)  (fggh) God,(f) all(h) ye(ji) R(j) &lt;R(h) end(ji) all(h) ye(h) waters.(g)  (g) ||(j) |(i)  (j)  (h) e(fh) ",
        groupIndex: 1,
        filename: "./pages/part-c-066.png",
        nextFileName: "./pages/part-c-067.png"
    },
    {
        title: "part-c-066-2",
        gabc: "e(cf) shall(f) de-(f) (g) liver(gh) thee(hg) From(f) the(gh) share(gfd) of(f) the(g) hunter.(g)  (f) He(f)  shall.(f) \xa5.(i) And(hi) from(h) the(h) [(h) noisome(g) e(f) pestilence.(gh) NN(hg) From(f) the(gh)  snare(gfd) .of(f) the(g) hunter.(g)  (f) \xa5.(c) Glory(h)  (h) be(h) to(h) the(h) Father,(hi)  (h) and(dh) to(fh) the(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-066.png",
        nextFileName: "./pages/part-c-067.png"
    },
    {
        title: "part-c-067-0",
        gabc: "Son,(g) end(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) He(f) shall.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-067.png",
        nextFileName: "./pages/part-c-068.png"
    },
    {
        title: "part-c-067-1",
        gabc: "|(hgi)  (fe)  (f)  (hg)  (h)  (fg)  (gf)  (ef)  (f) ()(hg)  (hi)  (ihg) R(f)  1(hi)  (hg) N(fg) W(fe) 1ot(e) T(e) P(f) R(g) [(hg) e(f) e(hg) el(hi) il(i)  e(ef) shall(hi) give(g) [(hg) his(f) Angels(gf) charge(ef) over(f) thee.(fgf) B(ef) ",
        groupIndex: 1,
        filename: "./pages/part-c-067.png",
        nextFileName: "./pages/part-c-068.png"
    },
    {
        title: "part-c-067-2",
        gabc: "hen(c) was(cd) Je-(d)TR(d) led(d) up(d) of(d) the(d) Spirit(f)  (cd) in-(d)to(c) the(d) wil-(fdfgh)der\u2014(fe)  ness(d) to(f) be(g) tempted(h) .(g) of(f) the(e) de-(fgfd)vil:(d) and(d) ](dc) he(f) had(g) fas-(fh)ted(hgg)  forty(f) &quot;(g) days(h) [(g) for-(h)ty(fe) nights,(d) he(e) was(f) af-(g) (f) terward(g) an(fe) PR(d) hungred.(d)   (h)  (g)  (f)  (g)  (gf)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-c-067.png",
        nextFileName: "./pages/part-c-068.png"
    },
    {
        title: "part-c-068-0",
        gabc: "ome,(hg) ye(hi) blessed(i)  (g) fof(ij) my(i)  (hhi) \xa3(h) Father,*in\u2014he\u2014rit(h) a(i) the(hg)  (f) kingdon(hh)  (e) b(f)  pared(gf)  (e) for(fg) you(f) from(h) the(g) foundation(h)  (i) o(if) of(g) the(f) world.(e) e(j)  (i)  (ih~)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-068.png",
        nextFileName: "./pages/part-c-069.png"
    },
    {
        title: "part-c-068-1",
        gabc: "A(c) nd(cd) -(dhi)sus(h) twent(h) in\u2014to(hj)  (h) the(h) tem\u2014ple(h)  (h) of(h) God,(hghihgg) and(g) cast(h)  out(g) all(fg) them(e) that(f) sold(g) and(f) bought:(d) and(d) o(dgfgh) ver-(g)threw(f)  the(g) ta-(h)bles(g) of(fg) the(d) mo-(fe) (de) ney\u2014changers,(dd)  (c) and(d) ;e(cd) seats(f) of(f) then(fghg)  &quot;that(ed) sold(efe) doves.(d) b(h)  (g) e(f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-068.png",
        nextFileName: "./pages/part-c-069.png"
    },
    {
        title: "part-c-068-2",
        gabc: "This.(g) crooked(gj) t(h) and(f) perverse(fg)  (gh) e(jk) e(j) ge\u2014ne\u2014raftlion(i) e(h) seeketh(j)  (dij) af-(d) (dhdd) ter(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-068.png",
        nextFileName: "./pages/part-c-069.png"
    },
    {
        title: "part-c-069-0",
        gabc: ".(gh) sign:(gf) and(g) there(g) shall(hi) no(ihihg) sign(g) be(ij) gi-(k)ven(j) it,(hj) but(j) the(j)  cign(jkj) of(i) the(h) prophet(j)  (i) Jo-(g)nas.(g) e(j) i(i)  (j) 0(h) e(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-069.png",
        nextFileName: "./pages/part-c-070.png"
    },
    {
        title: "part-c-069-1",
        gabc: "J(c) e(cd) sus(d) went(ef) thence,(d) and(d) d;\u2014part\u2014ed(c)  (fg)  (h) -(h)to(h) the(gf) coasts(gg)  of(d) T;re(dg) and(fe) S1(de) 0.1&#39;1:(dc) and(d) behold,(f)  (g) a(g) woman(h)  (g) of(g) Ca-(gf)na-(gf)an(d)  came(fhg~) out(h) of(fe) the(d) same(fg) coasts,(d) and(d) cri-(d)ed,(fe) Q-(c).(c) Have(d)  NN(f) mer\u2014cy(hg)  (ed) on(fe) me,(c) thou(d) Son(dg) of(fe) Da-(d)vad.(d) B(h) W(g) A(f)  (g) i(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-069.png",
        nextFileName: "./pages/part-c-070.png"
    },
    {
        title: "part-c-069-2",
        gabc: "An(f) -(e)gel(f) of(h) the(hi) Lord(i) went(hi) down(j) from(ih) hea-(i)ven,(i) and(i)  Toubled(fi)  (g) the(h) Lo(fe) S(f) e(e) N(de) S(fh)  (f) S(f) e(i)  (h) o(i)  (j)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-069.png",
        nextFileName: "./pages/part-c-070.png"
    },
    {
        title: "part-c-070-0",
        gabc: "nd(f) Je(h) \u2014sus(f) ta\u2014keth(h)  (hf) his(f) .(e) dis\u2014ci-(h)ples,(f) and(h) po(j) \u2014eth(jk) iy(i)  to(gi)  (g) a(i) mountain,(ij)  (h) and(h) was(h) trans-(hi)fi-(h)gu-(hg)red(e) be\u2014fore(gh)  (f) thep,(f)  :(ig~) :(h)  (g) II(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-070.png",
        nextFileName: "./pages/part-c-071.png"
    },
    {
        title: "part-c-070-1",
        gabc: "Thou(c)  (i) shalt(h) o(i) pen(h) my(g) lips,(ij) O(hi) lord,(f) and(h) my(g) mouth(h) shall(fd)  shew(ef) thy(f) praise.(e) -(j) (i) :(h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-070.png",
        nextFileName: "./pages/part-c-071.png"
    },
    {
        title: "part-c-070-2",
        gabc: "The(h) right(hg) hand(ef) of(fg) the(f) Lord(e) bringeth(e)  (e) migh(f) -(ed)things(e) to(ef)  pass:(f) the(h) right(hg) hand(ef) of(fg) the(f) Lord(e) hath(f)  (e) ~em=1-(d) (def)  (f)  BT(e) !(h) ;(f)  (h) B(i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-c-070.png",
        nextFileName: "./pages/part-c-071.png"
    },
    {
        title: "part-c-071-0",
        gabc: "Thou(c)  (f) hast(ghg) been1(h) my(f) help-(hg)er,(ef) O(g) my(fe) God.(d) e(h) e(g) e(f)  (g) e(ghg)  [et(c)  (g) us(g) sing(h) the(h) song(g) of(g) the(g) three(hg) chil-(fgh)dren,(h) which(f)  they(h) sang(j) as(k) they(i) bless-(j)ed(h) the(g) Lord(h) in(h) the(g) burning(g)  (f) fi\u2014ery(fgh) T(h)  furnace.(g)  (g)  (j)  (i)  (j)  (h)  (g)  He(ce) hath(f) made(h) them(j) fast(i) for(ij) ev\u2014er(j)  (i) and(fh) ev\u2014(gf) er:(e) he(f) hath(f)  giv-(de).(e) them(f) a(h) law(g) which(h) shall(df) not(f) be(f) broken.(e) et(e) |iesenseraleesl](j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-071.png",
        nextFileName: "./pages/part-c-072.png"
    },
    {
        title: "part-c-071-1",
        gabc: "A\u201Dd(f) Je-(h)sus(f) ;(h) taketh(hf) his(f) a(e) ci-(gh)ples,f(f) and(h) go\u2014eth(j) g(jk) up(i) in-(i)a(g) a(i)  Mountain,(ij) e(h) and(h) \u2018__l_-(h)transfi-(hi)gu-(h)red(hg)  (e) be-(fgh)fore(f) l(f) [(h) pe(g) e(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-071.png",
        nextFileName: "./pages/part-c-072.png"
    },
    {
        title: "part-c-072-0",
        gabc: "J(c) e(cd) sus(d) went(f) thence,(d) and(d) \xab(c) part-(fg)ed(h) in-(h)to(h) the(gf) coasts(gg) of(d)  Tyre(dg) and(fe) Si(de) don:(dc) and(d) i(f) behold,(g) a(g) woman(h) .\\(g) of(g) Ca-(gf)na-(gf)[(d) came(fgh)  (g)  out(h) of(fe) the(d) same(gf) coasts,(d) ahd(d) cri-(d)ed,(fe) ssyir.l&#39;g:(c)  (c) Have(d) mer\u2014cy(fhg)  (ed)  on(fe) T(c) thou(d) Son(dg) of(fe) Da-(d)vid.(d) e(h) a(g) e(f)  (g) ANGRA(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-c-072.png",
        nextFileName: "./pages/part-c-073.png"
    },
    {
        title: "part-c-072-1",
        gabc: "[(ig~)  (ch) am(h) the(h)  (h) Beginning,(h) [Fe(hghih) [V(hf) ven(gf) I(e) that(ef) speak(ed) e(ef) to(f) you.(e)  TUESDAY(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-072.png",
        nextFileName: "./pages/part-c-073.png"
    },
    {
        title: "part-c-072-2",
        gabc: "A(hg) o(h) is(hg) your(e) Mas-(gh)ter,(f) fwhich(fe) is(hi) in(hj) hea(jihg) -(ihi)ven,(ih) e-(i)ven(hg)  |(ig~) Christ(e) the(gh) Lord.(f) ey(h) T(g)  (e) el(f) ",
        groupIndex: 2,
        filename: "./pages/part-c-072.png",
        nextFileName: "./pages/part-c-073.png"
    },
    {
        title: "part-c-073-0",
        gabc: "a(ce) Be_hold.(gh) we(i) go(j) up(ji~) fto(hg) Je\u2014(f)  (h) ru\u2014sa\u2014lem:(i)  (g) and(h) the(h) Son(i) of(g)  man(h) shall(f) be(f) be-(ed) (ef) tray\u2014ed(f) to(i) be(j) cru-(hf) (gf) fi(e) \u2014ed.(e)  (j) e(i)  (h) ||(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-073.png",
        nextFileName: "./pages/part-c-074.png"
    },
    {
        title: "part-c-073-1",
        gabc: "So\u2019\uFB01,(eh) te(fd) \u2014mem-(ef)ber(e) that(e) thou(e) in(g) thy(h) lifetime(i)  (h) receivedst(h)  (i)  (h)  thy(gf) good(g) things,(h) and(h) likewise(hi)  (hghih) La-(f)za-(e)rus(f) e-(h)vil(g) things.(e)  E(h)  (g)  (h) [(f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-c-073.png",
        nextFileName: "./pages/part-c-074.png"
    },
    {
        title: "part-c-073-2",
        gabc: "He(g) will(h) mi(ghj) se(j) ra(j) \u2014bly(ji) des\u2014troy(hg)  (hg) those(g) wicked(gh)  (i) men:(h) and(i)  will(h) let(h) out(i) his(h) vineyird(h)  (ed) \u2014(g) to(h) o(j) ther(j) husbandmen,(h)  (hk) Mhich(k)  shal](j) ren-(ji)der(hg) him(h) o(g) =(ghjjg) e(h) their(h) R(e) W(e) o(dji) RS(hi)  (h) |(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-073.png",
        nextFileName: "./pages/part-c-074.png"
    },
    {
        title: "part-c-074-0",
        gabc: "will(cdh)  (h) gotto(j)  (h) my(g) father,(h)  (g) and(h) will(g) say(ge) un-(fgh)to(fe) him:(d) \u2018Fa-(ff) ther&#39;(c)  make(fhghi) me(h) as(g) one(fg) of(f) thy(ef) hir(g) &#39;ed(fe)  (d) servants.(d) B(h) |(g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-074.png",
        nextFileName: "./pages/part-c-075.png"
    },
    {
        title: "part-c-074-1",
        gabc: "O(g) be(h) d(gi) vour-(i)a-(i)ble(ik) and(j) gracious(ji)  (h) fun\u2014to(ij)  (i) Si-(g)\u2014on:(g) build(ge)  thou,(f) O(e) Lord,(d) the(d) walls(f) of(gh) Je(gf) \u2014ru-(e)sa-(de)lem.(e) I(ji)  (hi) &lt;(h)  (g)  The(c)  (h) Lord(fg) is(hg) on(fgh) my(fe) side:,(d) I(f) will(gh) not(h) fear(ghjijkj) what(hg) man(hg)  [(e) eth(f) -(hg~)to(h) me.(g)  (j)  (i)  (j)  (h)  (gh)  My(g) lips(f) shall(h) praise(j) thee(i) as(g) long(i) as(j) I(h) live,(i) O(h) my(gf) God-(dg) 3(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-074.png",
        nextFileName: "./pages/part-c-075.png"
    },
    {
        title: "part-c-075-0",
        gabc: "fire(c)  (d)  (dh) for-(h)gat(hj) his(h) pow\u2014er(h)  (hghihgg) and(f) vir-(g)tue,(df) that(d) thy(fe) chil-(fg) dren(g) might(gg) be(c) de-(d).(fe) liv\u2014er\u2014ed(f)  (g) un-(fe)harm-(d)g(d) ed.(h)  (g)  (f)  (gh)  (gh)  O(f) ve(gh) sun(h) and(gh) moon,(ef) praise(g) ve(fe) the(df) Lord:(cfc) f8r(c) his(d) Name(c)  (fg)  on\u2014ly(f) a(e) is(f) ex\u2014(g) cel(fe) lent.(d) [(h) [[EETrrawicannings(g)  (f) e(g) AR(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-075.png",
        nextFileName: "./pages/part-c-076.png"
    },
    {
        title: "part-c-075-1",
        gabc: "When(c)  (g) a(g) strong(jg) man(h) arm\u2014ed(ghjh) t(iji) keepeth(i)  (j) his(kj) palace,(h)  (g) all(g)  (ig) his(hg)  (e)  goods(f) are(g) in(f) peace.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-075.png",
        nextFileName: "./pages/part-c-076.png"
    },
    {
        title: "part-c-075-2",
        gabc: "V\u2018e~ri_1y(d)  (d)  (f) l.say(dc)  (f) un\u2014to(g)  (fh) you,(hgg) No(dfg) prophet(hg)  (f) is(f) ac(f) cep(fg) ~ted(f)  In(ki~)  (f) his(g) own(fe) country.(d)  (d) Lo(h)  (g)  (dfdghdgf) ",
        groupIndex: 2,
        filename: "./pages/part-c-075.png",
        nextFileName: "./pages/part-c-076.png"
    },
    {
        title: "part-c-076-0",
        gabc: "I(c)  (cd) two(dhi) of(h) f(h) shall(h) a-(h)gree(hj) on(h) earth(h) as(h) touching(h)  (h) an-(h)y_(h)  thing(hghihgg) that(f) they(h) sgall(fe) ask,(d) it(f) shall(fe) be(df) done(f) for(dedcd) of(dc)  (c)  my(ik)  (d) Fa(f) ther,(ef) saith(g) the(fe) Lord.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-076.png",
        nextFileName: "./pages/part-c-077.png"
    },
    {
        title: "part-c-076-1",
        gabc: "Hearken,(j)  (i) and(g) un-(i)der-(j)stand(hg) ye(f) the(f) tra\u2014di-(h) (j) tions(i) which(j) the(h)  Lord(i)  (i) hath(h) R(g) gi\u2014ven(fg) you.(g) a-(j) (h)  (j) -(k) (j) ",
        groupIndex: 1,
        filename: "./pages/part-c-076.png",
        nextFileName: "./pages/part-c-077.png"
    },
    {
        title: "part-c-076-2",
        gabc: "a(c)  (e) de-(eh)vils(f) al(f) a(e) F.(ed) a(e) of(fgf) /-(e)B(e) a(e) ing(h) out(i) and(ji) -(dd) (d)  saying:(gh)  (hh)  (g) Thou(gh) art(ih) Christ(fed) the(f) el(f) of(gf) God.(e) And(fijihfd) he(dj)  (d) rebuk-(dkdjddi) (d)  .(ij) them(i) suffered(i)  (g)  (i) them(ji) not(h) to(f) =(fgh) for(ih) they(fe) D(dcefeddd) that(he~ed~) ",
        groupIndex: 2,
        filename: "./pages/part-c-076.png",
        nextFileName: "./pages/part-c-077.png"
    },
    {
        title: "part-c-077-0",
        gabc: "Chrast.(e)  (h)  (g)  (h)  (f)  (e)  he(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-077.png",
        nextFileName: "./pages/part-c-078.png"
    },
    {
        title: "part-c-077-1",
        gabc: "who_so\u2014ev\u2014er(j)  (ji)  (hg) drinketh(hih)  (gh)  (g) of(g) the(g) wa-(g)ter(e) that(g) I(g) shall(g)  ive(fe) him(d) shall(ef) nev\u2014er(gh)  (h) thirst.(g)  (g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-c-077.png",
        nextFileName: "./pages/part-c-078.png"
    },
    {
        title: "part-c-077-2",
        gabc: "ut(d) Je(e)  (fg) sus(e) stooped(gh)  (fe) do(dfddc) and(f) wrote(h) on(g) the(f) =(gh) If(d)  (f)  a-(i) (fe) ny(d) is(e) without(f) \u2014\u2014(h) sin,(g) let(f) him(ef) cast(g) &#39;a(fe) stone(d) at(cd) her.(d) e(h)  (g)  (fgh) e(gf) ",
        groupIndex: 2,
        filename: "./pages/part-c-077.png",
        nextFileName: "./pages/part-c-078.png"
    },
    {
        title: "part-c-077-3",
        gabc: "Then(c) R(e) \xbb(e) A(g) be(h) pleas\u2014ed(ihji)  (i) fwith(i) the(i) L)(i) sacrifice(h)  (ij) of(i) \u2014(hi)  \u20ACousness,(hg)  (e) if(h) thou(hi) wilt(h) turn(h) thy(h) face(hghih) from(f) my(hg) sins.(e) IR(j)  (i) e(h)  (gf) ",
        groupIndex: 3,
        filename: "./pages/part-c-077.png",
        nextFileName: "./pages/part-c-078.png"
    },
    {
        title: "part-c-078-0",
        gabc: "J-(c) (f) is(fg) better(g)  (g) to(h) trust(ge) in(fgh) the(fe) Lord,(d) than(d) to(e) put(f) a-(g)ny(h)  con-(h)fi\u2014-(g)dence(ghjijkj) 1in(fh) princes.(hg) e(g) e(j)  (i) e(j)  (h) S(ghg)  I(c)  (h)  (g) not(hg) thought(f) up-(h)on(h) thee,(hg) O(hi) Lord,(i) when(ef) I(hig) was(hg)  .(hig~) [BasmaE(f) w(f) Rrir(h) o(g) e(e) AT(f)  Mj_ghty(f)  (fg) art(g) thou,(h) O(fg) Lord,(g) to(g) de-(h)liv\u2014er(j)  (i) us(j) from(h) the(g) hand(h)  of(g) the(h) strong:(ghg) save(f) and(g) de~liv(h)  (h) =(ghjijkj) us,(hgf) O(gh) our(h) God.(g)  5(i) Reges(j)  (i) terree(j) aa(h)  (ghg)  Klngs(f) of(e) the(d) =(d) and(d) all(ef) peo-(g)p]e,(ghg) praise(def) e(fddgd) ye(d) e(fdffddfd) t.he]..q,x(dfd)  (df)  .(h)  (g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-078.png",
        nextFileName: "./pages/part-c-079.png"
    },
    {
        title: "part-c-079-0",
        gabc: "When(c)  (df) Je\u2014sus(ff)  (ded) lift\u2014ed(cd)  (fg) up(ed) his(fe) eyes,(d) and(cd) saw(dhi) a(h) great(hgfe) com\u2014(h)  him,(fe)  (dc)  (dc)  (d)  (f)  (g) he(cd) saith(fe) un-(fgf)to(d) Philip:(cd)  (d) Whence(i)  (dh)  (i)  shall(h) we(hggf) buy(ghg) bread(hiih) that(fg) these(ed) may(efe) eat?(d)  (g) And(f) this(fe) he(d) said(fhgf)  o(ed) M(ec) him;(d)  (e) for(d) he(ffd) himself(ed)  (cd) knew(ffgf) what(fhg) he(ed) would(efe) do.(d) ||(h) e(g) |(f)  (fh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-079.png",
        nextFileName: "./pages/part-c-080.png"
    },
    {
        title: "part-c-079-1",
        gabc: "Take(gj) these(hg) things(hjh) M(ij) saith(k) the(ji) Lord,(hg) and(gh) make(ji) not(g)  my(ef) [(g) Father\u2019s(fgh) house(gfd) an(fed) house(f) of(gh) 500(g) merchandise.(ffg)  (e) (SR(j) \xa7(h) et(j) el(ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-079.png",
        nextFileName: "./pages/part-c-080.png"
    },
    {
        title: "part-c-079-2",
        gabc: "WIY(c)  (h) go(i) ye(j) a-(i)bout(h) fto(f) kill(hi) me,(h) a(h) man(fe) that(f) hath(ed) told(ef) you(g)  \u2018?he(f) truth?(e)  (j)  (i)  (h)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-c-079.png",
        nextFileName: "./pages/part-c-080.png"
    },
    {
        title: "part-c-080-0",
        gabc: "M(c)  (c) aster,(fg)  (g) vwherein(fh)  (j) hath(k) this(ji) man(hj) sinned,(ji)  (g) that(g) he(h) was(g)  blind?(ik)  (g) Jesus(j)  (j) 2(ji) answered(h) s(ij) and(ji) said:(g) Neither(ji)  (jk) hath(k) this(k) map(jk)  TV(ji) sinned,(h) nor(i) his(j) pa-(ji)rents;(g) e(h) that(g) the(f) works(g) of(h) God(jk)  should(ik)  (i) be(j) [(hg) ma\u2014ni\u2014fest(f) R(fh) in(h) him.(g) RO(j) R(i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-080.png",
        nextFileName: "./pages/part-c-081.png"
    },
    {
        title: "part-c-080-1",
        gabc: ".(c) sus(cd) went(d) .(ef) to(d) a(c) ci(d) .(ef) ty(fc) call-(fh)ed(fg) Na(gfd) i(d) and(g)  behold(fg)  (fh) there(g) was(g) a(f) dead(fg) man(f) car-(g)ri(fe) ed(d) out,(d) the(f) on-(f)ly(def)  v(i) son(g) of(f) his(fe) mother.(d)  (d) P(h) Jale(g)  (f) Sl(g) e(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-080.png",
        nextFileName: "./pages/part-c-081.png"
    },
    {
        title: "part-c-080-2",
        gabc: "Our(f) friend(ghg) La-(h)za-(g)rus(f) sleepeth:(gf)  (d) let(d) us(f) go,(f)  (fd)  (fdefc~f)  (d)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-080.png",
        nextFileName: "./pages/part-c-081.png"
    },
    {
        title: "part-c-081-0",
        gabc: "that(f) we(f) may(hi) a(g) \u2014wake(hg) him(ef) out(g) of(fe) =leep.(d) R(h) S(g)  (f) E(g) SRS(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-081.png",
        nextFileName: "./pages/part-c-082.png"
    },
    {
        title: "part-c-081-1",
        gabc: "He(cg) that(g) fol-(gj)low-(h)eth(hhj) me(j) shall(i) not(j) walk(k)  chall(h) have(j) the(i) light(h) of(g) life,(hhj) saith(g) the(gf) Lord.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-081.png",
        nextFileName: "./pages/part-c-082.png"
    },
    {
        title: "part-c-081-2",
        gabc: "O(h) Lord,(fg) be-(g)hold(h) my(g) af-(f)flic-(gh)tion:(f) for(g) mine(h) en-(jk)e(ij) \u2014my(hg)  hath(g) mag-(g) (gf) ni\u2014fi\u2014ed(d)  (f) him-(fg)self.(g)  (j)  (i)  (j)  (h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-c-081.png",
        nextFileName: "./pages/part-c-082.png"
    },
    {
        title: "part-c-081-3",
        gabc: "[(ig) calleq(ij)  (i) up\u2014-(i)on(j) the(h) Lord(i) in(gh) a(e) [(e) and(h) the(fh) Lord(gh)  heard.me(ih)  (f) at.(f) large.(e) (BT(fh)  (j) RG](i)  (h)  (gh) ",
        groupIndex: 3,
        filename: "./pages/part-c-081.png",
        nextFileName: "./pages/part-c-082.png"
    },
    {
        title: "part-c-082-0",
        gabc: "O(f) a(e) thou(f) hast(h) pleaded(hj)  (i) the(i) causes(h)  (i) of(j) my(ih) soul:(i) ol(i)  hast(f) de-(i)fend-(g)ed(h) my(fe) life,(f) O(e) Lord(de) my(fh) God.(f) &amp;(i)  (h) i(i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-082.png",
        nextFileName: "./pages/part-c-083.png"
    },
    {
        title: "part-c-082-1",
        gabc: "(O(f) my(h) e(hi)  (i) what(i) have(h) I(i) e(j) un-(i)to(h) thee?(i) and(i) wherein(f)  (i)  have(g) I(h) wea-(f)ri\u2014ed(f) .(e) thee?(fe) tes-(d)ti~fy(e)  (f) against(h)  (f) me.(f) I(i) &amp;(h)  (i)  (j) e(h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-c-082.png",
        nextFileName: "./pages/part-c-083.png"
    },
    {
        title: "part-c-082-2",
        gabc: "Shall(h) e-(hi)vil(i) be(i) re\u2014com-(i) (h) pensed(ij)  (h) for(ij) good?(i) for(fi) they(g) have(h)  dig-(fe)ged-(f)a(e) pit(d) for(f) my(fh) soul.(f) e(i) o(h) 1(i) ",
        groupIndex: 2,
        filename: "./pages/part-c-082.png",
        nextFileName: "./pages/part-c-083.png"
    },
    {
        title: "part-c-082-3",
        gabc: "D(f) li-(g)ver(f) my(f) soul,(g) O(fh) God,(hg) From(fd) the(fg) sword.(gf) De-(f)li-(gd)ver:(f)  My(h) darling(gh)  (g) from(g) the(g) pow\u2014er(h) 5(g) of(f) the(gh) dog.(hg) B.(i) From(fd) the(dfg)  (d) sword:(gf) ",
        groupIndex: 3,
        filename: "./pages/part-c-082.png",
        nextFileName: "./pages/part-c-083.png"
    },
    {
        title: "part-c-083-0",
        gabc: "De-(f)li-(g)ver(f) my(f) soul,(g) O(h) God,(hg) from(fd) the(fg) sword.(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-083.png",
        nextFileName: "./pages/part-c-084.png"
    },
    {
        title: "part-c-083-1",
        gabc: ".(j)  s(d)  (e) o(gh) St(hg) s(h)  (j) E-(ji)S(hg) e(i) o(j) .(k) gt(hg) (g(j) e(ih) ](h)  fa(h)  (hji) a(g) M(ge) [(f) [(dc) g(de) R(efe) e(d) e(dh) S(hg) R(ed) AT(f) R(ed) N1(d)  Deliver(h)  (hji) a(g) A(ge) from(f)  (dc) mine(de) enemies,(efe)  (d) O(dh) God.(hg) e(ed)  (f) e(ed) [(d)  (ded) I(d) ",
        groupIndex: 1,
        filename: "./pages/part-c-083.png",
        nextFileName: "./pages/part-c-084.png"
    },
    {
        title: "part-c-083-2",
        gabc: "Je-(ki~) (gj) sus(h) said(ghj) un-(j)to(i) the(h) mul-(i) (j) ti\u2014tude(k) of(ji) the(h) Jews,(hg) and(gh) to(j)  the(i)  (i) chief(hgf) y(fe) He(e) that(ed) is(g) of(hi) God(i) e(j) heareth(h) A(ik) words;(iji)  (g)  Ye(i)  (g) therefore(hi)  (hgf) hear(ghg) them(e) @(e) RS(f) RRRR(eff) ye(f) are(ghgf) not(g) of(gf) God.(e)   (ik)  (j)  (h)  (j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-c-083.png",
        nextFileName: "./pages/part-c-084.png"
    },
    {
        title: "part-c-084-0",
        gabc: "a(e) the(e) great(eh) day(fed) of(ef) the(f) feast,f(e) \u2014(igij) sus(i) stood(ijji) and(gi) Cri-(hi)ed(hg)  T(e) saying:(e) If(e) a\u2014ny(g) O(g) man(ef) thirst,(f) let(f) him(f) come(fi) un\u2014(h) to(hf) me(g) and(f)  drink.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-c-084.png",
        nextFileName: "./pages/part-c-085.png"
    },
    {
        title: "part-c-084-1",
        gabc: "MY(chi) time(i) 1is(i) not(hi) yet(jh) come,(i) but(gihg) Yyour(fe) time(f) is(e) al-(de)way(fh)  (f)  ready.(f)  (f)  (i)  (h) WEDNESDAY(i) ",
        groupIndex: 1,
        filename: "./pages/part-c-084.png",
        nextFileName: "./pages/part-c-085.png"
    },
    {
        title: "part-c-084-2",
        gabc: "My(chi) sheep(i) hear(hi) my(fjh) i(i) and(i) I(cf) the(i) Lord(g) both(c)  (hf) know(fdfdedf)  (fd~f) thef:(ddfefd)  and(de) they(fh) fol-(f)low(f) me.(f) =(i)  (h) &#39;(difdf)  (ff) ",
        groupIndex: 2,
        filename: "./pages/part-c-084.png",
        nextFileName: "./pages/part-c-085.png"
    },
    {
        title: "part-c-085-0",
        gabc: "The(c)  (f) Mas(h) ter(hj) saith,(i) My(i) time(hi) is(j) at(hi) hand;(i) I(f) will(i) keep(g)  the(h) Pass-(f)o-(fe)ver(f) at(e) thy(de) house(f) with(gg) my(h) dis\u2014ci-(h) (f) ples.(f) |(i) e(h)  (hj) |(i) ",
        groupIndex: 0,
        filename: "./pages/part-c-085.png",
        nextFileName: "./pages/part-c-086.png"
    },
    {
        title: "part-c-085-1",
        gabc: "N(gw(c) the(d) feast(dh) day(hi) of(h) the(g) Jews(hg) tdrew(h) nigh;(ghg) and(f) the(g) chief(ihg)  priests(hgfed) sought(dgfgh) how(g) they(hfgf) might(d) kill(fgg)  (gf) Je(ig) \u2014(h) but(e) they(f)  fear\u2014-(g)ed(e) the(fe) people.(d)  (d) [(h) mraeme(g)  (f) e(gh) W(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-085.png",
        nextFileName: "./pages/part-c-086.png"
    },
    {
        title: "part-c-085-2",
        gabc: "OFa\u2014t\uFB02gr,(ki~d)  (d)  (dc) glo-(f)ri\u2014fy(g)  (f) thou(gh) me(h) with(hi) thine(g) own(fh) self(g) with(g)  the(g) glo\u2014ry(g)  (g) (](e) I(g) had(h) with(gf) thee(fg) be\u2014fore(f)  (c) the(eg) world(e) be-(fe)gan.(d)  =](h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-c-085.png",
        nextFileName: "./pages/part-c-086.png"
    },
    {
        title: "part-c-086-0",
        gabc: "For(fh) the(f) Lord(fg) God(fe) will(f) help(hg) &quot;(e) and(h) therefore(i)  (h) shal]l(f) 0(g)  not(hi) be(g) con-(gh)e(f) founded.(f) o(h) e(g) el(e) e(f)  They(ik)  (d) compassed(f)  (f)  (f) me(f) a-(e)bout,(d) yea,(f) they(e) compassed(d)  (e) me(f)  (h) a-(h)hout:(g)  but(f) \xbb(e) the(f) Name(g) of(f) a(e) Lord(f) N(e) I(d) be(c) a-(c)\u2014#e%ged(c)  (de) on(d) :(d)  3(ik)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-086.png",
        nextFileName: "./pages/part-c-087.png"
    },
    {
        title: "part-c-086-1",
        gabc: "Judge(c)  (h) thou(f)  Judge(h) thou(fg) my(gh) cause:(g) de\u2014fend(fh)  (j) me,(jdijkj) for(h)  (gf) 0(ghd) Lord,(c)  (i) art(dh)  mighty.(g)  (g) \u2018(j)  (i)  (j)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-086.png",
        nextFileName: "./pages/part-c-087.png"
    },
    {
        title: "part-c-087-0",
        gabc: "May(e) the(g) faithful(i)  (h) to-(fh)day(ji) be(hi) found(i) a-(g)mong(ij) the(i) Angels(h)  (hg) and(f)  the(h) children,(hg)  (e) crying(e)  (e) un-(e)to(f) the(e) Conqueror(f)  (e) e(d) of(ef) death,(f) Ho-(cf) san-(hi)na(iihf) in(g) the(f) highest.(e)  (e)  (h)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-087.png",
        nextFileName: "./pages/part-c-088.png"
    },
    {
        title: "part-c-087-1",
        gabc: "Let(c)  (e) them(f) be(h)  (h) confounded(hj)  (i) that(i) persecute(h)  (i)  (jh) me,(i) but(i) let(f) not(i) me(g)  be(h)  (f) confounded,(ef) =&quot;(f) O(e) Lord(de) my(fh) God.(f) |(i)  (h) S(i) RO(j) e(h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-c-087.png",
        nextFileName: "./pages/part-c-088.png"
    },
    {
        title: "part-c-087-2",
        gabc: "he(c)  (g) =(fg) multitudes(f)  (f) a(e) came(f) together(g)  (g)  (g) for(g) the(f) feast(gh) day(ghg)  cried(e)  (f) P(g) un\u2014to(fe) the(de) Lord:(e) Blessed(e)  (f) is(g) he(fgh) that(g) cometh(f)  (g) in(f) the(e)  Name(df) of(e) the(de) Lord.(c) Ho-(f) (ef) san\u2014ha(dc) in(df) the(fg) highest.(e)  (e) |(h) e(g)  (h) e(ih)  (gfee) ",
        groupIndex: 2,
        filename: "./pages/part-c-087.png",
        nextFileName: "./pages/part-c-088.png"
    },
    {
        title: "part-c-088-0",
        gabc: ".(e) hid(gh) not(h) tmy(hi) face(g) from(f) shame(g) and(fg) v(e)  (e) |\xa7|(h)  (h) [(h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-088.png",
        nextFileName: "./pages/part-c-089.png"
    },
    {
        title: "part-c-088-1",
        gabc: "Awake,(g)  (ef)  (h) O(hgf) sword,(fh) t(f) against(hgf) them(fh) that(hg) scatter(hi)  (g) my(f) flock.(f)  3(gi) Appenderunt(h)  (g)  (e)  (f)  So(d) they(ef) L](g)  (e) for(gh) my(fe) price(d) thirty(f) [}(f) pieces(d) a(e) of(gf) silver,(g) -(d)the(f)  price(fe) that(d) I(e) was(f) prised(g)  (f) at(gh) of(f) them,(d) I(h) e(g)  (f) e(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-088.png",
        nextFileName: "./pages/part-c-089.png"
    },
    {
        title: "part-c-088-2",
        gabc: "Wa\u2014(c)  (g) ter(g) flow-(h)ed(h) o-(g)ver(f) tmine(h) head:(g) then(h) said,(g) I(h) am(hi)  cut(gf) off:(f) I(f) will(h) call(jk) up-(ij)on(h) thy(gh) Name,(gf) O(fh) Lord(hi) God.(g)  (j) e,(idj)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-088.png",
        nextFileName: "./pages/part-c-089.png"
    },
    {
        title: "part-c-089-0",
        gabc: "Be_hold,(c)  (g)  (h) O(g) Lord,(f) the(f) lips(g) of(h) them(j) that(i) rise(hj) up(i) a-(h)gainst(g)  me,(h) and(h) their(i) de-(h)vices.(g)  (g)  (h)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-089.png",
        nextFileName: "./pages/part-c-090.png"
    },
    {
        title: "part-c-089-1",
        gabc: "O(d)  (d)  (dc) glo-(f)ri\u2014fy(g)  (f) thou(gh) me(h) with(ihi) thine(g) own(fh) self,(g) with(g)  the(g) glo-(g)ry(g) which(e) I(g) had(h) with(gf) thee(fg) be-(f)](c) the(eg) world(e) be\u2014gan.(fe)  (d)   (h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-089.png",
        nextFileName: "./pages/part-c-090.png"
    },
    {
        title: "part-c-089-2",
        gabc: "See,(g) O(h) Lord,(i) and(j)  (i) consider,(h)  (g) for(g) I(f) 0(e) in(f) trouble:(h)  (g) O(f) haste(ef)  thee(g) and(h) hear(f) -(e) (j) ;(i)  (hd)  (dih) ",
        groupIndex: 2,
        filename: "./pages/part-c-089.png",
        nextFileName: "./pages/part-c-090.png"
    },
    {
        title: "part-c-090-0",
        gabc: "De-(c) (g) fend(igji~) thou(i) tmy(j) cause,(k) O(j) Lord:(iji) O(i) de-(g)li-(hih)ver(fe) me(e) from(f) the(e)  deceitful(f)  (hhg) T(f) and(hhi) wick(ghf) \u2014ed(ef) man.(e) W(j) (st(i)  (h) (](g) ",
        groupIndex: 0,
        filename: "./pages/part-c-090.png",
        nextFileName: "./pages/part-c-091.png"
    },
    {
        title: "part-c-090-1",
        gabc: "g(ig~) When(e) I(e) was(g) in(h) trouble(i)  (hih) I(f) cri-(h)ed(g) un\u2014to(f)  (e) the(f) Lord(e) out(f) of(e)  the(d) belly(e)  (e) of(ef) hell,(f) and(h) he(fe) heard(fgf) e(j)  (i)  (h) ](gf)  [ord,(g) I(h) am(j)  (j) oppressed,(hj)  (i) T(jk) un\u2014dertake(jh) for(i)  (h) me:(g) for(g) I(h) know(j)  not(ik)  (i) what(h) I(g) shall(hi) say(hg) to(f) mine(ghg) en-(e)e(e) mies.(e) e(j)  (h) ([(j) i(ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-090.png",
        nextFileName: "./pages/part-c-091.png"
    },
    {
        title: "part-c-090-2",
        gabc: "T}le(g) ungodly(g)  (g) [(fe)  (dc) Let(g) us(f) oppress(g)  (h) the(gf) righteous(g)  (h) man,(f) be-(g) cause(f) he(g) 1is(h) clean(j) con-(i)tra-(ji)-(hg)to\u2019our(fe) v(fg) doings.(g)  (g) e(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-090.png",
        nextFileName: "./pages/part-c-091.png"
    },
    {
        title: "part-c-091-0",
        gabc: "Now(d) pefore(cd)  (dhi) the(h) feast(h) of(gh) the(f) Pass\u2014o-(fh)ver,(h)  (ihghihgg) when(fg) Je\u2014sus(h)  (g) knew(f)  (f)  that(f) his(df) hour(g) was(fe) come,(d)  (fed) having(d) \xbb(c) loved(d) [(c) 3(d) own,(ffgf) he(f) loved(f)  (hg)  (hi)  them(hgg) un\u2014to(f)  (g) the(fe) end.(d) ST(h) A(g)  (f) e(gh) :(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-091.png",
        nextFileName: "./pages/part-c-092.png"
    },
    {
        title: "part-c-091-1",
        gabc: "ti-(jk) (ji) ness,(j) O(jh) God(hj) my(i) God:(gh) and(f)  De-(h)liver(f)  (h) me(gf) from(h)  T(h) tongue(i) shall(j) sing(h) of(g) thy(gh) righteousness.(hg)  (g) e(j) e(i)  (j) )(h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-091.png",
        nextFileName: "./pages/part-c-092.png"
    },
    {
        title: "part-c-091-2",
        gabc: "5(h) ReproaChesTand(hg)  (e)  (f) 5(hih) terrors(gh) have(hg) I(f) suffered(g)  (h)  (f) of(e) them:(e) and(e) the(d)  Lord(ef) =(hi) with(hg) me(ihih) as(h) a(h) mighty(hgf)  (f) terrible(gh)  (f)  (gf) one.(e) :(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-c-091.png",
        nextFileName: "./pages/part-c-092.png"
    },
    {
        title: "part-c-092-0",
        gabc: "These(ef) al(hi) ~so(i) that(hi) seek(jk) the(i) hurt(hi) of(g) my(hg) soul,(f) shal](f)  (h)  y(gi) go(hi) un-(h)der(e) GE(gh) earth.(f) |(h) y(g) PRyyees(e) Tae(f)  a(e) .(h) en-(i) (j) .(ih) have(jk) heard(j) of(h) my(jk) trouble,(j)  (ih) 0(j) Lord:(i)  they(i) are(hg) glad(e) that(i) thou(hf) hast(fg) done(e) it.(e) ](j) A(i)  (h)  (gf)  Bind(i)  (f) the(hi) nations(hg) t(h) of(g) the(ig) heathen(h)  (g) with(ef) chains,(g) O(fe) Lord;(d)  j(jk)  a(e) their(f) ](ge) princes(f) with(e) SO(d) fetters.(d) e(h) S(g) i(f)  (g) T(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-092.png",
        nextFileName: "./pages/part-c-093.png"
    },
    {
        title: "part-c-092-1",
        gabc: "i-(eh)mon,(fed) sleepest(ef)  (f) thou?(e) couldest(gh)  (i) not(hf) thou(hhg) watch(hih) with(hg)  (h)  me(hf) one(gf) hour?(e) e(h) e(g) _l__(h)  (f) |(e) ",
        groupIndex: 1,
        filename: "./pages/part-c-092.png",
        nextFileName: "./pages/part-c-093.png"
    },
    {
        title: "part-c-093-0",
        gabc: "E(c) zeal(h)  (h) of(h) thine(hih) house(gh) hath(h) e(h) ven(f) eat\u2014en(h)  (g) me;(e) and(e) the(d)  rebukes(f)  (h) of(g) them(ef) that(d) re-(f)buk-(hi)ed(g) thee(h) are(fe) fallen(fg)  (f) up-(f)on(e) me.(e)  9(h) Avertantur(f)  (h) retrorsum(i)  (h)  et(h) them(h) be(h) e(hi) turned(i) backward(ih)  (ih) and(h) put(h) to(hg) con\u2014fu-(fh) (hih) 1(e) that(hi)  (ih)  seek(f) to(df) do(hf) me(g) e-(e)\u2014vil.(e) cau(h) ok(f)  (h) caate(i) Saes(h) ",
        groupIndex: 0,
        filename: "./pages/part-c-093.png",
        nextFileName: "./pages/part-c-094.png"
    },
    {
        title: "part-c-093-1",
        gabc: "De~(h) 1itver(h)  (hg) me,(f) O(ghg) my(ef) -(e)out(hi) of(h) the(h) hand(h) of(hih) the(f)  N(gi) un(e) \u2014god(f) ly.(f) e(h) ee\u2014\u2014l|(g)  (e) Ao(f) ",
        groupIndex: 1,
        filename: "./pages/part-c-093.png",
        nextFileName: "./pages/part-c-094.png"
    },
    {
        title: "part-c-094-0",
        gabc: "was(g) of-(h) (hg) fer\u2014ed(f) .(fe) be\u2014cause(f) he(h) will-(h)ed(hiih) it:(h) and(h)  (ji) himself(i)  (hi)  was(gi)  (h)  hath(gi)  (h) borne(hg) our(e) 1(fh) -(f)ni-(f)qul-(f)l(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-094.png",
        nextFileName: "./pages/part-c-095.png"
    },
    {
        title: "part-c-094-1",
        gabc: "Mine(c)  (h) own(h) familiar(h)  (h)  (h) friend(h) whom(i) I(h) trusted.(g)  (g)  Who(h) did(h) also(h)  (h) eat(h) of(h) my(h) bread,(h) hath(h) laid(i) great(h) wait(g) for(g) me.(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-094.png",
        nextFileName: "./pages/part-c-095.png"
    },
    {
        title: "part-c-094-2",
        gabc: "NOW(d) he(f) t}l:it(c)  (d) be\u2014tray\u2014ed(dhi)  (h) f(h) gave(h) them(g) a(e) sign,(fgfe) say-(d)ing:(d)  Whom-(f) (d) so\u2014ev\u2014er(e)  (f) I(cgh) shall(fg) kiss,(f) that(fg) same(f) is(fe) he;(ce) hold(ge) him(f)  fast.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-094.png",
        nextFileName: "./pages/part-c-095.png"
    },
    {
        title: "part-c-095-0",
        gabc: "t(ffgf) for(f) our(ghfedgefg) sake,(f) be(f) came(hfghjjk)  (kj) 0(jij) be(hghj) di(jh) ent(f)  un(fihgh) to(f) death.(ffgf) ",
        groupIndex: 0,
        filename: "./pages/part-c-095.png",
        nextFileName: "./pages/part-c-096.png"
    },
    {
        title: "part-c-095-1",
        gabc: "\u2019Ihe(c)  (cgh) kings(h) of(h) the(h) earth(jj) stand(h) up,(h) and(g) the(h) ru\u2014lers(jj)  (i) take(hg)  coun-(ik) (h) sel(i) to-(j)P(ihg) o(g) a-(h)gainst(f) the(h) Lord,(jj) and(i) a\u2014-(g)gainst(j)  his(ik)  (h) A-(h)noint(g) \u2014ed.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-095.png",
        nextFileName: "./pages/part-c-096.png"
    },
    {
        title: "part-c-095-2",
        gabc: "&#39;I}ley(ikc)  (c)  (g) part(h) my(h) garmentst(g)  (g) a-(ih)\u2014mong(ji) them,(h) and(j) cast(jk) lots(h) up-(gf) (f) on(gh)  my(ik)  (h) -(g)vesture.(g) w-(j) (i)  (j)  (h) \u2014(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-095.png",
        nextFileName: "./pages/part-c-096.png"
    },
    {
        title: "part-c-096-0",
        gabc: "Re-(ik) (g) mem(h) be(gf) bernert(g) 0(h) Lord(j) my(i) God,(j) when(h) thoy(g) com-(i)est(ghg) in-(ef) to(gh) thy(hg) kingdom.(g)  (g)  (j)  (i)  (j)  (h) Psaln(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-096.png",
        nextFileName: "./pages/part-c-097.png"
    },
    {
        title: "part-c-096-1",
        gabc: ":(h) hath(h) laid(h) me(h) in(i) the(h) darkness.(g)  (g)  As(h) the(h) men(h) that(h) have(h) been(i) long(h) dead.(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-096.png",
        nextFileName: "./pages/part-c-097.png"
    },
    {
        title: "part-c-096-2",
        gabc: "T}ley(c)  (cd) set(idhi) up(h) o-(h)ver(h) his(h) head(ihghihgg) his(f) ac-(g)cu(h) \u2014sa-(g)tion(fe) writ\u2014(fg)  .(d) Je(d) sus(gd~gf) of(hg) Na-(f)za-(e)reth,(fgfd) the(ef) King(g) of(gh) the(fe) Jews.(d)   (ki~)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-096.png",
        nextFileName: "./pages/part-c-097.png"
    },
    {
        title: "part-c-097-0",
        gabc: "&quot;(ffgf) for(f) [(ghfedgefg) T(f) be(f) came(hfghjjjk) 0(jji) be(hghj) dj(jh) ent(f)  un(fihgh) to(f) death,(ffgf) e(fhhi) ven(g) the(gj) death(jhjig) 8(ihg) of(f) the(f) cross(ffffc) ",
        groupIndex: 0,
        filename: "./pages/part-c-097.png",
        nextFileName: "./pages/part-c-098.png"
    },
    {
        title: "part-c-097-1",
        gabc: "I(h) will(eg) lay(g) me(h) down(fe) r(f) peace,(df) and(fh) take(g) my(f) W(e) [(h) B(f) Psalm(h)  (i) 4(h) ",
        groupIndex: 1,
        filename: "./pages/part-c-097.png",
        nextFileName: "./pages/part-c-098.png"
    },
    {
        title: "part-c-097-2",
        gabc: "He(fe) shall(d) dwell(f) {in(e) thy(f) e(g) e(fe) cle:(fg) w-(g)he(g) shall(e) R(d) F(fe)  -(d)on(f) |(fd) ho-(f)1ly(fg) =(h) e(g)  (h) o(ih) 0(gfed) ](e) ",
        groupIndex: 2,
        filename: "./pages/part-c-097.png",
        nextFileName: "./pages/part-c-098.png"
    },
    {
        title: "part-c-098-0",
        gabc: ";(c) wo(cd) \u2014(dhi) men,(h) 1sitting(h)  (h) o-(h)ver(h) a(h) gainst(h)  =(fg) lam(h) en-(gf)ta-(g)tion,(d) weep\u2014ing(f)  (ef) for(g) the(fe) Lord.(d)  (h) Iy(g)  (fgh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-098.png",
        nextFileName: "./pages/part-c-099.png"
    },
    {
        title: "part-c-098-1",
        gabc: "Christ,(c)  (ffgf) for(f) our(fh) O(fedgefg) sake,(f) be.-(f)came(hfghjj) R(kj) o(jij) be(hghj) di(jh) ent(f)  un(ik)  (fihgh) to(f) death,(ffgf) e(fhhi) ven(g) the(gj) death(jh)  (jighihg) of(f) the(f) cross:(ffffc)  -(fghgf)8(eghfhghgegf) .(f)  (hgi) -(d)](d) God(fe) al-(eh)so(h) hath(h) high-(h)ly(h) ex-(h)",
        groupIndex: 1,
        filename: "./pages/part-c-098.png",
        nextFileName: "./pages/part-c-099.png"
    },
    {
        title: "part-c-098-2",
        gabc: "a(hf) -(hhhhfghihijhhiih)which(d) is(d) a-(d)bove(dfedef) ev(fhgf) ery(hhh) name.(hhf) -(ggfged)",
        groupIndex: 2,
        filename: "./pages/part-c-098.png",
        nextFileName: "./pages/part-c-099.png"
    },
    {
        title: "part-c-099-0",
        gabc: "day(j)  hen(g) Je-(gj)sus(h) was(gf) risen(gh)  (g) early(g)  (i) the(j) first(k) day(k) of(kj) the(i) week(i)  he(k)  (j) appeared(hj)  (h) first(h) to(fh) Ma-(ji)ry(g) Magda-(g)le(eg)  (ffg) G(gfed) M(gg)  (c)  whom(d) he(f) had(fg) cast(g) seven(gh)  (h) de-(gf)vils,al-(gh) (g) le-(ef)lu\u20141ia.(gh)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-099.png",
        nextFileName: "./pages/part-c-100.png"
    },
    {
        title: "part-c-099-1",
        gabc: "go(i)  (i) before(h)  (g) you(h) in-(j)to(j) Ga-(i)li-(i)lee:(i) there(ij) shall(h) ye(i) see(hg) me,(g)  as(hg) I(f) said(h) un-(i)to(h) you,(fh) al(ih) \u2014le-(f)i1a,(f) al-(fg)le-(fg)ia.(e)  (i) \u20141)(j)  (i)  (h)  (dgh) ",
        groupIndex: 1,
        filename: "./pages/part-c-099.png",
        nextFileName: "./pages/part-c-100.png"
    },
    {
        title: "part-c-099-2",
        gabc: "I(f) i(f) the.(e) true(g) B(h) al-(e)le-(f)lu-(d)(\xa5(c) and(f) ye(f) are(f) the(f)  (ff) true(ef)  (df)  [(g) branches,(h) al-(h) (hg) lu-(gf)1ia.(f)  (h)  (f) 5(ghf)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-099.png",
        nextFileName: "./pages/part-c-100.png"
    },
    {
        title: "part-c-100-0",
        gabc: "heart(cf)  (fg) a(ghggf) with\u2014in(hj)  (jih) me;(h) I(chi) desire(g)  (fe) to(d) be-(ef)hold(ghc) my(h)  Jord:(g) I(gj) seek,(jkjjih) and(h) find(ij) not(hg) where(h) they(g) have(f) laid(g) him,(h)  al\u2014-(i)le-(j)lu-(h)1a,(gf) al(gh) le(h) lu\u2014-(g)ia.(g)  (j) _(i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-100.png",
        nextFileName: "./pages/part-c-101.png"
    },
    {
        title: "part-c-100-1",
        gabc: "There(d) came(dc) un\u2014to(f) B(g) the(fh) tomb(h) {Ma(h) \u2014(jijkj) ry(hih) Magdale(h)  (gf) \u2014(ghihg) ne(hg) |(g)  the(e) o(g) ther(hg) Ma-(f)ry,(f)  (j) to(f) see(fg) the(f) sepu]chr.e,(f)  (ef)  (dc) al-(d)le(efe) lu-(d)ia.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-100.png",
        nextFileName: "./pages/part-c-101.png"
    },
    {
        title: "part-c-101-0",
        gabc: "](fg) t(ggf) the(h) Shepherd(j)  (ij) of(hg) the(fg) sheep:(g) T(ji) am(jkji) the(h) way,(ji) he(hg) i,(hi)  my(hg) sheep,(g)  and(h) the(g) life:(ghg) I(fg) am(g) the(f) Good(gh) Shepherd;(f)  (f) and(f) I(hj) know(j)  \u2018and(e) am(f) known(g) of(f) miNe,(edc) al-(c)le-(d)lu-(e)ia,(f) al-(h)le-(h)lu-(g)ia,(g)  (j)  (i)  (j) |(h) ",
        groupIndex: 0,
        filename: "./pages/part-c-101.png",
        nextFileName: "./pages/part-c-102.png"
    },
    {
        title: "part-c-101-1",
        gabc: "Go(f) ye(f) in-(f)a(e) the(g) world,f(h) al-(e)le-(f)P(d) a-(c)and(f) teach(f) e(e) allnations,(g)  (h)  al(h) le(hg) lu-(gf)1a.(f)  (h)  (f)  (fgh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-101.png",
        nextFileName: "./pages/part-c-102.png"
    },
    {
        title: "part-c-101-2",
        gabc: "Go(h) ye(fg) in-(g)to(g) the(h) world,(g) and(g) teach(h) all(gf) nations,(fh)  (f) baptizing(gf)  (dgh)  (djkd)  of(de)  them(jijkj) in(h) the(h) Name(h) of(h) the(h) Father,(j)  (ih) and(g) of(g) the(fg) Som,(d)  (g) and(dg)  the(f) Ho-(h)ly(h) Ghost,(gf)  (d) al(f) \u2014le(fg) \u2014Ju-(g)1ia.(g) |(j) :(i)  (j)  (fdh)  (dddfgh)  (d)  (dd) ",
        groupIndex: 2,
        filename: "./pages/part-c-101.png",
        nextFileName: "./pages/part-c-102.png"
    },
    {
        title: "part-c-102-0",
        gabc: "-(c) Go(f)  (ed) un\u2014-(d)to(e) my(fg) brethren{(gfgff) S(d) and(f) say(gh) un-(h)to(gf) them,(f) al-(g)le(gf) lu-(e)ia:(e)  [(j)  (d) =(fg) go(h) in-(hi)to(h) Ga-(g)li-(gf)lee,(e) al-(de)le-(fg)lu-(f)ia:(e) there(ef) shall(g) they(ef)  that(e) they(gh) go(h)  e(dc) me,(e) al_le-(c) (d) -(e)lu\u2014ia,(f) al(gf) \u2014le-(de)lu-(e)ia,(e) al-(eh)le(hghg) lu-(e)ia.(e)  (h)  (ghihgfee) ",
        groupIndex: 0,
        filename: "./pages/part-c-102.png",
        nextFileName: "./pages/part-c-103.png"
    },
    {
        title: "part-c-102-1",
        gabc: "A.rt,(c) thou(d) on(dhi) ly(h) .a(hg) stranger,(gh)  (f) and(g) hast(d) not(dg) heard(g) con\u2014(f)  cerning(f)  (d) Je(cf) ](ffggf) how(h)  (f) :(ifhi) de-(h)2(gih) ver\u2014ed(g) :(g) him(hg) to(d) be(d)  (](g) condemned(f) L](e) to(dc) death?(f) al(g) \u2014le\u2014(fe) lu-(d)ia.(d) B(h) ;(g) e(f) :(h) T(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-102.png",
        nextFileName: "./pages/part-c-103.png"
    },
    {
        title: "part-c-102-2",
        gabc: "ught(f) not(fg) Christ(g) to(h) have(j) e(ji) e(j)  (h) these(jg) things,(g) and(g) to(g)  \xaeh-(hi)ter(h) a(g) \u2018in-(h)C](g) glory?(fe)  (d) o(f) e(fh) Pa(g) o)(g) e(j)  (i) s(j) \xa2(h) 00(ghg) ",
        groupIndex: 2,
        filename: "./pages/part-c-102.png",
        nextFileName: "./pages/part-c-103.png"
    },
    {
        title: "part-c-103-0",
        gabc: "A(cf) little(f)  (ef) while,(d) and(de)  (c) shall(d) not(fg) see(fg) me,(f) saith(f) the(gh) Lorq:(hgf)  and(f)  and(f) again,(gh)  (h) a(h) little(h)  (gfgf) while,(d) and(de) ye(cd) shall(gf~) see(fg) nle;(f) because(d)  (f)  I(g) go(h) to(g) the(f) Father,\u2019a\uFB01-(g) (d) \u2014]e-(fedc) (c) \u2014]u-(d) (ffg) ia,(gf) al-(g)le-(fh)lu-(f)ia.(f)  (h) B(ffh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-103.png",
        nextFileName: "./pages/part-c-104.png"
    },
    {
        title: "part-c-103-1",
        gabc: "A.nd(c) be-(d)gin-(dhi)ning(h) at(h) Mo(hjh) ses(h) and(ih) all(gh) the(f) prophets,(fhge)  (e) he(e)  s(e) expounded(ce)  (g) un-(fgh)to(g) them(gf) the(d) e(ed) e(c)  (c) himself,(d)  (f)  (fe) -(h) al(f) le-(fe)lu-(d)ia.(d) -(h)e(g)  (f) &amp;gl(gh) e(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-103.png",
        nextFileName: "./pages/part-c-104.png"
    },
    {
        title: "part-c-103-2",
        gabc: "And(cgi)  (eh) they(h) constrained(g)  (h)  (f) him,(gf) saying,(ef)  (f) A(hf) bide(g) with(hi)  (d) us,(di) 0(d)  (hi)  Lord,(ghi)  (ffe) for(hj) it(ij) is(h) to-(i)ward(h) eve-(hg)ning,(fe) al-(f)le-(ghg)lu-(d) (fd) 1a.(f)  (h) |(g)  (e)  (df) ",
        groupIndex: 2,
        filename: "./pages/part-c-103.png",
        nextFileName: "./pages/part-c-104.png"
    },
    {
        title: "part-c-104-0",
        gabc: "bide(eg) with(fgh) us,(g) for(hi) it(h) is(f) to-(h)ward(g) eve-(ih)ning,(g) and(h) the(i) day(j)  !(ih) far(gh) spent,(gfd) al(e) -(d)lu-(c)ia.(c) a.(h)  (g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-c-104.png",
        nextFileName: "./pages/part-c-105.png"
    },
    {
        title: "part-c-104-1",
        gabc: "&#39;And(ki~)  (g) he(g) went(gj) in(h) to(g) tar-(h)ry(g) with(hhj) them:(iji) and(i) it(j) came(k) to(j) pass,(ji) T(h)  as(h) he(g) sat(h) at(ji) meat(hi) with(h) them,(g) he(gh) took(ji) bread,(ghighg) and(ef) blessed(g)  (gh)  (g)  D(gfd) and(d) brake,(gh) R(h) gave(hgf) L(g) them,(gfd) al(f) [](e) -(f).(e) al(f)  le(fg) lu-(e)ia.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-104.png",
        nextFileName: "./pages/part-c-105.png"
    },
    {
        title: "part-c-104-2",
        gabc: "\xbbThey(c)  (f) knew(g) the(f) Lord(e) Je-(g)sus,(h) al(e) -(f)lu-(d)ia,(c) in(f) breaking(f)  (e)  of(g) bread,(h) al(h) le(hg) lu-(fg)ia.(f) ;(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-104.png",
        nextFileName: "./pages/part-c-105.png"
    },
    {
        title: "part-c-105-0",
        gabc: "Now(dh) I(j) go(h) my(g) way(h) fto(f) him(gh) that(fe) sent(d)  (e) me;(d) and(df) none(fe) o(d)  (fg)  asketh(f)  (ed) T(c) Whi(ifhi) ther(h) goest(h) TR(g) thou?(ghg) al-(f) (f) .(e) le_ly_j,(f) :(g) allel(fe)  lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-105.png",
        nextFileName: "./pages/part-c-106.png"
    },
    {
        title: "part-c-105-1",
        gabc: "Did(c) not(cd) our(ddc) heart(ffd) tburn(f) within(g)  (h) us(i) concerning(h)  (g)  (hg) Je-(fe)sus;(d)  while(i)  (e) he(f) talk-(g)ed(gh) with(gf) us(d) by(f) the(f) way?(ed) al(c) le(cd) lu-(d)1ia.(d) IR(hgfggfd) ",
        groupIndex: 1,
        filename: "./pages/part-c-105.png",
        nextFileName: "./pages/part-c-106.png"
    },
    {
        title: "part-c-105-2",
        gabc: "eace(f) be(f) un-(f)to(f) you,(e) it(g) is(g) I,(h) al-(e)le-(f)lu-(d)ia:(c) be(fe) not(g) afraxt(g)  (h)  al(h) ~le-(hg)lu-(fg)ia.(f) B(h)  (f) Tn(h) v(g) e(f) ",
        groupIndex: 2,
        filename: "./pages/part-c-105.png",
        nextFileName: "./pages/part-c-106.png"
    },
    {
        title: "part-c-106-0",
        gabc: "spi-(cf) (fg) Tit(g) hath(hj) not(g) flesh(h) and(f) bones,(ghg) as(g) ye(g) see(hg) me(fe) haves:(d)  pelieve(g)  (gh) Y\u20AC(g) therefore,(fe)  (d) al(f) \u2014le-(gh)lu-(g)ia.(g) I(j)  (i) \u2014(j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-106.png",
        nextFileName: "./pages/part-c-107.png"
    },
    {
        title: "part-c-106-1",
        gabc: "e(c)  (c) dis\u2014ci-(d) (dhi) ples(h) of-(h) (g) fer\u2014ed(f) the(gh) Lord(hghih) a(g) piece(h) of(f) broil\u2014ed(igig) \u2014(hi)  fish,(h) and(hgg) of(f) an(gh) ho-(f)ney-(fe)b,(dfddc) al(e) \u2014le(ig)  (hih) \u2014lu\u2014ia,(g)  (fe) al(g) \u2014le\u2014(fe)  (d)  lu-(d)1ia.(d) .(h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-106.png",
        nextFileName: "./pages/part-c-107.png"
    },
    {
        title: "part-c-106-2",
        gabc: "hese(fg) are(ggf) the(gh) words(hg) twhich(g) I(gh) spake(hg) un\u2014to(fgh) 8(fg) you,(f) &lt;(fh) I(ji)  :(jk) yet(ji) with(h) you,(h) al-(f)le-(h)lu-(j)ia,(i) al-(h)le-(hi)lu-(g)ia.(g)  (j) o(i)  (j)  (h) D(ghg) ",
        groupIndex: 2,
        filename: "./pages/part-c-106.png",
        nextFileName: "./pages/part-c-107.png"
    },
    {
        title: "part-c-107-0",
        gabc: "H(hg)  (f) itherto(ef)  (f) have(f) ye(gh) asked(i)  (i) nothing(j)  (i) in(g) my(hg) Name:(f) L(g) and(dfe)  .(hg) ye(f) 0(e) receive,(fh) =(gh) al-(i)le(hg) lu-(f)ia.(f) PR(h) \u2014\u2014\u2014\u2014\u2014\u2014T(g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-107.png",
        nextFileName: "./pages/part-c-108.png"
    },
    {
        title: "part-c-107-1",
        gabc: "Ask,(fg) and(g) ye(h) shall(g) receive;(f)  (gh) seek,(ji) and(h) ye(h) shall(ih) find;(g)  (g)  knock,(g) and(fe) 1t(d) shall(e) be(f) o-(g)pen-(g)ed(f) un\u2014to(gh)  (h) you,(gfd) al(ef) le(fg) lu-(g)ia.(g)  e(j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-107.png",
        nextFileName: "./pages/part-c-108.png"
    },
    {
        title: "part-c-107-2",
        gabc: "It(f) be-(fg)hov\u2014ed(g)  (ghgf) Christ(h) to(j) suf-(ji)fer,(g) tand(g) to(g) rise(hi) a-(h)gain(dged) from(ddfg)  (d)  (d)  the(fe) dead,(d) al(f) -(gh)le-(g)1ia.(g) gl(j)  (i) e(fjdffddfh) e(ddghgd) A(dd) |(d) ",
        groupIndex: 2,
        filename: "./pages/part-c-107.png",
        nextFileName: "./pages/part-c-108.png"
    },
    {
        title: "part-c-108-0",
        gabc: "ther,(f) the(g) hour(f) is(gh) come:(h) glo-(h)ri~-(g)fy(i) thy(h) Son(g) with(g) the(g)  glo-(fh)ry(g) which(g) I(e) had(g) with(hg) thee(fg) be\u2014fore(ec)  (eg) the(e) world(fe) was,(dc) al(d) \u2014(e)  le(efe) lu(d) ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-108.png",
        nextFileName: "./pages/part-c-109.png"
    },
    {
        title: "part-c-108-1",
        gabc: "F(fg) u(g) A(h) [(gf) m-(g)a(g) |(hgf) \u2014cy(g) on(gh) me,(f) and(g) send(hj) ww(jk) La\u2014za\u2014(j)  TUs,(j) that(j) he(j) may(j) dip(jig) the(j) tip(jk) of(j) his(j) finger(ji)  (h) in(ij) wa\u2014ter,(hh)  (g) and(dfg)  my(ik)  (f)  (fh) tongue.(g)  (j)  (i)  (j) :(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-108.png",
        nextFileName: "./pages/part-c-109.png"
    },
    {
        title: "part-c-109-0",
        gabc: "A(g) certain(h)  (hi) man(i) made(ij) a(hg) great(hi) L(g) supper,(g) and(gh) bade(jihi) ma-(h)ny;(g)  and(ik)  (g) sent(ghij) his(i) servants(k)  (j) at(hj) supper:time(i)  (hg) a.F(g) to(g) say(h) to(ij) them(h)  that(h) were(i) [(g) bidden,(g) Come;(ghiji) for(hg) all(hij) things(h) a(g) now(hi) ready,(h)  (gf)  al(g) le(gf) lu-(e)1ia.(e) be(ji) cnn(hih) |(gfe) k@5(e) ",
        groupIndex: 0,
        filename: "./pages/part-c-109.png",
        nextFileName: "./pages/part-c-110.png"
    },
    {
        title: "part-c-109-1",
        gabc: "What(ed) man(g) of(hj) you,(j) hav-(ik)ing(j) an(i)  (h) sheep,(ji)  (g) 1f(g) he(hj) lose(jih)  one(gf) of(ghg) B(e) doth(de) not(g) leave(hj) the(hj) e(k) ninety(j) and(j) nine(hg) in(h) the(j)  wilderness,(j)  (ij)  (j) and(ij) go(kj) after(h)  (g) that(hi) which(g) is(f) lobst,(eed) un-(hi)til(h) he(hg)  un-(d) find(fg) it?(df) al-(g)le-(gf)lu-(e)ia.(e) ISR(ji)  (d)  (hi)  (h) [(gh) T(d) ",
        groupIndex: 1,
        filename: "./pages/part-c-109.png",
        nextFileName: "./pages/part-c-110.png"
    },
    {
        title: "part-c-110-0",
        gabc: "BB(df) ye(d) therefore(de)  (d)  (fe) Tmer\u2014ci\u2014iul,(de) as(dc)  (f) your(g) Father(h)  (gf) al-(g)so(d) 1is(g)  erci-(g) (fe) ful,(dc) saith(d) the(efe) Lord.(d)  (h) e(g)  (f) e(gh) T(g) e(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-110.png",
        nextFileName: "./pages/part-c-111.png"
    },
    {
        title: "part-c-110-1",
        gabc: "Ar:d(c) Je-(cd)sus(d) en\u2014ter\u2014ed(ef)  (d)  (d) in\u2014t.o(d)  (c) a(df) ship,(fc) and(f) sat(ghg) down,(hiih) and(fg)  (h)  taught(h) the(gf) -(g)people,(df) al-(g)le-(fe)lu-(d)1a.(d) |(h) e(g)  (f) 2(g) e(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-110.png",
        nextFileName: "./pages/part-c-111.png"
    },
    {
        title: "part-c-110-2",
        gabc: "Y(ig~) e(e) have(e) heard(eh) that(f) it(f) was(e) said(f) .;y(ed) them(ef) of(f) old(e) time,(e)  Thou(gi)  (hg) shalt(h) not(ij) kill;(i) and(i) whoso-(j)ev-(i)er(h)  (i) shall(hg) I\u2018(eef) shall(f)  be(e) e(d) )(c)  (d) of(ef) the(f) judgment.(e)  (e) .(h)  (g)  (h)  (f) \xa2(e) ",
        groupIndex: 2,
        filename: "./pages/part-c-110.png",
        nextFileName: "./pages/part-c-111.png"
    },
    {
        title: "part-c-111-0",
        gabc: "he(gd) mul-(f)ti-(fg)tude(gh) being(g)  (ge) ve-(f)ry(e) great,(df) and(cd) having(ffg)  (g) nothing(f)  (h)  to(fh)  to(gh) eat,(f) Je-(f)sus(hj) called(j)  (ji) his(h) T(g) disciples(h) T(g) un-(ji)to(hg) him,(ghg) and(f) -(gh) un-(h)to(g) them,(g) I(jj) have(k) oY(i) compassion(j) b(h) on(g) the(h) LR(i) multitude,(hg) (1.(g) because(fg)  (f)  they(g) have(h) now(gh) been(gf) with(f) me(h) three(jjk) days,(j) and(j) have(ik) nothing(j)  (h)  to(j) eat,(ghg) al(f) ~le-(fg)lu-(g)1ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-111.png",
        nextFileName: "./pages/part-c-112.png"
    },
    {
        title: "part-c-111-1",
        gabc: "B(fg) a-(g)of(hj) false(ji) Ta(hg) prophets,(hg) which(gh) come(f) to(fg) you(g) in(fg) sheep\u2019s(hj)  clothing,(jk)  (jijkj) but(j) in-(ki)wardly(ji)  (hhg) they(fg) are(fgh) ra(i) e(h) vening(di) ](g) Ye(gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-111.png",
        nextFileName: "./pages/part-c-112.png"
    },
    {
        title: "part-c-112-0",
        gabc: "know(d) them(ef) by(gh) their(h) fruits,(gfd) al(f) -(fg)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-112.png",
        nextFileName: "./pages/part-c-113.png"
    },
    {
        title: "part-c-112-1",
        gabc: "he(d) lc;rd(ef) said(ge) un-(gh)to(f) the(e) s(d) steward,(d) How(d) is(cd) it(d) that(f) I(g) hear(hg)  this(f) of(ghg) thee?(h) [}(c) an(d) account(f)  (ffgf) cf(f) thy(ef) ](g) a(fe) =(dc) al(d)  le(efe) lu\u2014-(d)1a.(d)  (h)  (g)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-112.png",
        nextFileName: "./pages/part-c-113.png"
    },
    {
        title: "part-c-112-2",
        gabc: "O(dh) will(h) go(j) to(h) my(g) father,(h) [(g) and(h) will(g) say(ge) un-(fgh)to(fe) e(d) him:Fa\u2014ther,(ff) e(dfec)  make(fhghi) me(h) O(g) one(fg) of(f) |(ef) [(g) [(fe) IR(d) servants.(d) |(h)  (g) ey(f)  (gh) i(gh) ",
        groupIndex: 2,
        filename: "./pages/part-c-112.png",
        nextFileName: "./pages/part-c-113.png"
    },
    {
        title: "part-c-113-0",
        gabc: "0(c) the(d) Lord(dhi) was(h) come(h) near(hg) to(e) Je~ru-(f) (g) 0(fe) 6(d) pe(d) 8(dc)  held(f) the(g) ci-(fh)ty,(h) and(h) wept(hjhih) o-(h)ver(ge) 1it,(fe) say-(d)ing:(d) If(de) th.ou(c)  hadst(ik)  (d) known,(fe) e(ghe) W(fe) T(d) For(hi) e(h) days(hij) shall(hg) come(gi) up-(ki)on(ji)  thee,(h) that(j) thine(i) e(j) ne-(i)T(h) shall(g) cast(h) a(g) trench(h) i(j) about(j)  thee,(g) and(h)  (j) compass(i) thee(ji) round,(h) and(i) keep(hg) thee(fh) in(jk) on(ji) a(hg) very(j)  side,(h) and(h) shall(i) a(e) e~(g) ven(i) with(i) the(ji) ground;(h) be(h)  cause(hkkj) thou(hg) knewest(j)  (ij) not(ih) the(fgh) z(e) of(f) thy(gh) vi-(g)gi-(fe)ta(d) -(dc) al(d) le(efe) lu-(d)ia(d) ,(h) ;(g)  (f)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-113.png",
        nextFileName: "./pages/part-c-114.png"
    },
    {
        title: "part-c-114-0",
        gabc: "A;d(c) the(df) \u2018publicen,(ed)  (cd)  (d) {standing(f) ;(d) a-(e)far(dc) off,(c) would(d) not(dc) 1ift(fh)  up(g) SO(hg) much(fe) as(f) his(g) eyes(gfed) un-(e)to(fe) heaven,(d)  (d) but(gf) smote(g) up\u2014(fe) on(d)  hys(ef) breast,(gfe) saying,(dc)  (c) God(cd) be(d) merci-(e)ful(f)  (ghghih) to(gf) me(ed) a(efe) sinner.(d)  (d)   (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-c-114.png",
        nextFileName: "./pages/part-c-115.png"
    },
    {
        title: "part-c-114-1",
        gabc: "When(gh)  (d) the(f) Lord(h) had(gg) pass(fh) \u2014ed(h) through(ih) the(i) coasts(ffh) of(gg) Tyre,\u2019(efed)  he(gi)  (d) made(e) the(f) deaf(e) to(d) hear(ff) and(f)  (gh) the(f) dumb(ef) to(d) speak.(d)  i(h) ](i)  (h)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-114.png",
        nextFileName: "./pages/part-c-115.png"
    },
    {
        title: "part-c-115-0",
        gabc: "Mascer,(fg) a(g) what(hij) shall(ji) I(hg) do(hg) to(ji) in-(hg)e(h) herit(g) e-(gf)ter(fh) \u2014na)(h) lifey(g)  He(hj) said(ji) un-(h)to(g) him,(hg) What(g) is(h) g(g) e(g) in(fh) the(fe) law?(d) hoy(ef) read.(gh)  est(ik)  (g) thou?(g) Thou(dfgh) shalt(g) love(g) the(gh) Lord(g) thy(hg) God(f) with(h) al](ij) thy(jh)  heart,(gh) al(i) le(hi) \u20141lu-(g)~1ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-115.png",
        nextFileName: "./pages/part-c-116.png"
    },
    {
        title: "part-c-115-1",
        gabc: "&quot;(c) Je-(cd)sus(d) passed(f)  (d) through(d) =(c) acertain(d)  (f) village,(d) [(dfddc) there(fg) met(hgf) him(dg)  ten(gf) men(f) that(d) were(fe) lepers,(de)  (c) which(f) stood(gghgf) a-(g)far(gh) off:(f) and(f)  they(f) lifted(fg)  (f) up(ef) their(g) voices,(fe)  (d) and(d) said,(dfddc) Je(f) sus,(fhghih) Master,(fe)  (c)  have(ef) mer-(g)B(e) Te(fe) on(d) s(d) |(h) D(g) (e(f)  (g) e(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-115.png",
        nextFileName: "./pages/part-c-116.png"
    },
    {
        title: "part-c-116-0",
        gabc: "g:(gj) not(h) therefore(h)  (g) anxious,}(h)  (gf) saying,(fgh)  (g) What(fgh)  (h) shall(g) we(h) eat?(gf) or(g)  (g)  What(fh) shall(f) we(fg) drink?(f) for(jk) your(i) heavenly(j)  (h) Father(j)  (g) knoweth(fe)  (f) that(d)  a(e) have(f) need(gh) of(h) all(g) these(fg) things,(gfd) al(eef) -(fg)\u2014le(g) ia.(g)  (j)  (i)  (jh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-116.png",
        nextFileName: "./pages/part-c-117.png"
    },
    {
        title: "part-c-116-1",
        gabc: "J;sus(c)  (cd) went(fd) in\u2014to(d)  (d) a(f) ci(def) ty(fc) called(fh)  (gf) Na(gfd) in;(d) and(d) behold,(g)  (g)  there(g) was(g) a(f) dead(gh) man(g) e(f)  (e)  (f) &lt;(fgf) the(f) on-(f)ly(ef) son(g) of(f) his(fe)  :(d) +(d) e(h) a(g) e(f) e(g) |(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-116.png",
        nextFileName: "./pages/part-c-117.png"
    },
    {
        title: "part-c-117-0",
        gabc: "A(e) Je-(gh)sus(ij) went(g) in-(h)to(i) the(i) house(hj) of(i) one(k) of(j) the(ij) chief(hf) -(hi) .(g)  (g) to(hg) eat(fg) bread(g) on(gf) the(g) sabbath(fg) o(e) day,(e) [(e) \u2014hold(ghij) there(i)  was(h) a(i) certain(i)  (jkj)  (h) man(i) before(k)  (k) him(j) which(ih) had(i) the(kj) dropsy;(hi)  (i) and(j)  he(i) took(jh) him,(h) and(hf) healed(hhi) him,(i) and(j)  (ji) let(hf) him(gf) go.(e) {(i) e(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-117.png",
        nextFileName: "./pages/part-c-118.png"
    },
    {
        title: "part-c-117-1",
        gabc: "M(fg) aster,(g) which(h) is(j) the(i) great(j) commandment(h)  (h) a(g) in(hi) the(h) law?(g)  Jesus(gj)  (i) said(jk) un-(hg)to(fg) him,(g) Thou(dfgh) shalt(g) love(gh) the(g) Lord(h) thy(gh) God(gf)  with(h) all(jh) thy(ih) heart,(gh) al(i) le-(h)lu-(g)ia.(g)  (j)  (i)  (j) L(h)  (dg) ",
        groupIndex: 1,
        filename: "./pages/part-c-117.png",
        nextFileName: "./pages/part-c-118.png"
    },
    {
        title: "part-c-118-0",
        gabc: "This(c)  (dd) kind(c) of(d) Fro(efg) vil(fe) han(d)  (dc) can(fh) come(gh) forth(g) by(f) nothing(fg)  (f)  put(cd) by(fe) prayer(g) and(fe) fasting.(d)  (d) |(h) o(g) o(f)  (gh) )(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-118.png",
        nextFileName: "./pages/part-c-119.png"
    },
    {
        title: "part-c-118-1",
        gabc: "A(ij)  (g) vonan(i)  (i) in(ij) the(h) ci-(h)ty,(g) which(h) was(gf) a(fh) sinner,(h)  (g) stood(gh) at(i) the(j)  A(g)  (h)  Lord&#39;s(ij) feet(k) e(jh) e(j) him,(i) e(h) o(g) began(h) to(d) wash(e) his(f) feet(gh) with(h)  tears,(g) and(h) 5(i) wipe(j) them(h) with(g) the(h) hairs(e) of(f) her(gh) head,(g) and(h)  kissed(ji)  (h) .(ij) feet,(k) and(j) a-(i) (hh) nointed(gh) them(ef) with(g) the(gf) ointment.(e)  (e)  %?(j)  (h)  (j)  (ih)  (d)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-118.png",
        nextFileName: "./pages/part-c-119.png"
    },
    {
        title: "part-c-119-0",
        gabc: "The(c)  (d) Lord(ef) said(gh) un-(g)to(g) the(e) sick(gh) L](fe) the(d) palsy,(cd) B(d) Son,(ffh) be(g) of(h)  good(ik)  (fg) =(gh) thy(cd) sins(ffg) be(f) S(ef) forgiven(g)  (fe) thee.(d) I(h)  (g) =T(f) N(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-119.png",
        nextFileName: "./pages/part-c-120.png"
    },
    {
        title: "part-c-119-1",
        gabc: "Te]](fg) them(ggf) which(h) are(h) bidden,t(g)  (g) Behold,(g)  (gh) I(g) have(g) prepared(g)  (gh)  (g) my(g)  e(ik)  (ghgf) dinner;(f) come(hj) un-(j)to(ji) the(h) o)(j) marriage,(hg)  (ghg) al(f) \u2014le-(fg)lu-(g)ia.(g)  (j)  (ijhghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-119.png",
        nextFileName: "./pages/part-c-120.png"
    },
    {
        title: "part-c-119-2",
        gabc: "There(dfd) was(d) &#39;a(dc) certain(f)  (g) nobleman,(f)  (gh)  (hggf) whose(fg) son(h) was.sick(g)  (fg) at(f)  Ca-(fe)per-(g) (fe) na\u2014um:(d) when(dfd) he(dc) heard(f) that(g) Je(fh) sus(h) was(h) come(hj)  out(h) of(g) Ju-(h)de-(g)a(f) in-(g)to(gh) Ga-(ffg)1li-(gf)lee,(f) he(g) besought(fe)  (ddf) him(fc) ",
        groupIndex: 2,
        filename: "./pages/part-c-119.png",
        nextFileName: "./pages/part-c-120.png"
    },
    {
        title: "part-c-120-0",
        gabc: "that(df) he(f) would(ef) heal(g) his(fe) son.(d)  (h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-120.png",
        nextFileName: "./pages/part-c-121.png"
    },
    {
        title: "part-c-120-1",
        gabc: "Then(ghj) said(h) the(h) lord(fg) un\u2014to(gh)  (i) the(hi) servant,(g)  (g) Pay(h) me(h) that(g) thou(f)  -(fgh)owest.(h) The(h) servant(j)  (i) therefore(j)  (h) fell(j) down(g) and(i) worshipped(k)  (j) him,(k)  (hij)  have(jh) patience(ij)  (i) =(gh) me,(g) =(gh) Iwill(ih)  (gf) pay(gh) thee(h)  saying,(jj)  (i) Lord,(ik)  all.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-120.png",
        nextFileName: "./pages/part-c-121.png"
    },
    {
        title: "part-c-120-2",
        gabc: "aster,(fg)  (g) we(h) know(jh) that(gf) thou(gh) art(h) true,(g) and(h) teachest(j)  (i) the(h)  Y2y(ik)  (jg) of(hi) God(h) in(gd) truth,(hgf) al(fdfghd) \u2014le-(h)e(g) e(g) A(j)  (i)  (j) SN(h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-120.png",
        nextFileName: "./pages/part-c-121.png"
    },
    {
        title: "part-c-121-0",
        gabc: "or(dd) u(c) said(d) within(f) .(g) herself,(fe)  (d) u(c)  (d) Imay(f) but(ed) touch(fg) the(f) hep(g)  of(ik)  (h) his(fg) garmc:nt,(fe)  (c) I(dc) shall(d) be(fe) whole.(d)  (h) |\xa7(g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-121.png",
        nextFileName: "./pages/part-c-122.png"
    },
    {
        title: "part-c-121-1",
        gabc: "When(c)  (dc~) ye,(d) \u2014\u2014_\u2014_\u2014__\u2014-(fe)therefore,(de) sial](dc) s;e(c) the(cd) a-(fe)bom\u2014i-(g) (fe) na-(d)jion(dc)  of(fg) de-(h)so-(gf)la-(fh)tion,(h) spoken(h)  (g) of(h) by(f) Da-(g)ni-(fe)el(d)  (fe) the(gfe) prophet,(de)  (dc)  stand(c) in(d) the(ffe~) ho-(g)1ly(fe) place;(dc) whoso(d)  (dc) readeth,(df)  (f) let(df) him(ef) un-(d)der(cd)  stand.(d)  (h) i(g)  (f)  (gf)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-121.png",
        nextFileName: "./pages/part-c-122.png"
    },
    {
        title: "part-c-121-2",
        gabc: "When(df) Je-(ff)sus(ded) lift-(cd)ed(fg) up(ed) his(fe) eyes,(d) and(cd) saw(dhi) a(h) great(hgfe) ",
        groupIndex: 2,
        filename: "./pages/part-c-121.png",
        nextFileName: "./pages/part-c-122.png"
    },
    {
        title: "part-c-122-0",
        gabc: "com\u2014(gh) Ppa\u20141y(fe)  (dc) come(dc) un\u2014to(d)  (fe) him,(fg) he(cd) saith(ffe) un(fgf) to(d) Philip:(cd)  (d)  Whence(dhi) shall(h) we(hggf) buy(ghg) bread(i)  (hiih) that(fg) these(ed) may(efe) eat?(d) And(f)  this(fe) he(d) said(fhgf) to(ed) prove(ec) him;(d) for(d) he(f)  (efd) himself(ed)  (cd) knew(ffgf) what(fhg)  e(ed) would(ef) do.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-122.png",
        nextFileName: "./pages/part-c-123.png"
    },
    {
        title: "part-c-123-0",
        gabc: "T(gi) hen(f) shall(h) the(g)  (fg) righteous(fe) shine(h) forth(ji) as(h) the(g) sun(fhih) ip(e) g,(f)  presence(gi)  (hi)  (g) of(hg) God.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-123.png",
        nextFileName: "./pages/part-c-124.png"
    },
    {
        title: "part-c-123-1",
        gabc: "Ve-(c) (d) ri(d) ~ly(f) IT(dc) say(f) un-(g)=(fh) you,(hgg) that(fg) -(h)S(fd~dgdddfd) dome(gdd)  (d)  -(k) (g) to(f) one(fe) of(f) the(d) L](c) -(df)T(fd) mine,(dddfd) :(fdddfgd) un=t(efddddfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-123.png",
        nextFileName: "./pages/part-c-124.png"
    },
    {
        title: "part-c-124-0",
        gabc: "comes(f) Y\u20AC(d) blessed(ef)  (ghg) of(fg) my(f) Fa-(df)ther,(fc) in-(d)he-(ffg)rit(f) the(f) kingdom(g)  (fe)  prepar-(g) (fe) ed(de) for(dc) you(c) from(e) the(f) be(ge) -(gh)ginning(fe) of(d) the(cd) world.(d) ",
        groupIndex: 0,
        filename: "./pages/part-c-124.png",
        nextFileName: "./pages/part-c-125.png"
    },
    {
        title: "part-c-124-1",
        gabc: "eek(dh) ye(hj) first(h) the(h) kingdom(h)  (h) of(h) God,(hghihgg) and(gf) his(hf) rightecus-(fgh) (fe)  -(d)and(g) all(h) these(gf) things(f) shall(e) be(f) add-(g)ed(fe) un-(d)\u2014to(fe) you:(d)  |(h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-124.png",
        nextFileName: "./pages/part-c-125.png"
    },
    {
        title: "part-c-125-0",
        gabc: "Be(gj) not(h) therefore(h)  (g) anxious,(h)  (gf) t(gh) saying,(g) What(h) shall(g) we(h) eat?(gf) 5(g)  What(gh) shall(f) we(fg) drink?(f) for(jk) your(i) heavenly(j)  (h) Father(j) 0(g) knoweth(fe) =(f)  that(d) ye(e) have(f) need(gh) of(h) all(g) these(fg) things.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-125.png",
        nextFileName: "./pages/part-c-126.png"
    },
    {
        title: "part-c-125-1",
        gabc: "O(g) ev-(g)er(f) 0(e) blessed(d) Mother(f)  (hg) of(fg) God,(g) Ma(j) \u2014.ry(h) ev(j) \u2014er(i)  (d) Virgin,(g)  (g)  temple(j)  (k) of(j) the(ji) Godhead,(h)  (h) hallowed(j)  (ji)  (gh) shrine(gh) of(g) the(f) Ho(h) 1y(hih) ",
        groupIndex: 1,
        filename: "./pages/part-c-125.png",
        nextFileName: "./pages/part-c-126.png"
    }
];


const $0327c0d0ab36de7b$export$46e97d99561dd31b = ()=>{
    const { index: index } = (0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)();
    const i = parseInt(index);
    const scanItem = (0, $fe1e439501581f64$export$a0abec500c76c448)[i];
    const [editValue, setEditValue] = (0, $fc466355347b8480$export$86e2cef2561044ac)(`antiphon-${scanItem.title}`, {
        gabc: scanItem.gabc,
        tone: "",
        isDone: false
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            width: "100%",
            height: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>{
                            window.location.href = `/antiphon-editor/${i - 1}`;
                        },
                        children: "Prev"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>{
                            window.location.href = `/antiphon-editor/${i + 1}`;
                        },
                        children: "Next"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: i
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "stretch",
                    flexGrow: 1,
                    flexShrink: 1,
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            overflow: "auto",
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `http://localhost:8080/${scanItem.filename}`,
                                style: {
                                    width: 600
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `http://localhost:8080/${scanItem.nextFileName}`,
                                style: {
                                    width: 600
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    paddingBottom: 1000
                                },
                                children: "npx http-server"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            padding: 8,
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "stretch",
                            maxWidth: 600
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e6f90ac2fa37e65$export$48122e7c0cf093bd), {
                                gabc: editValue.gabc,
                                tone: "8.1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                onChange: (event)=>{
                                    setEditValue({
                                        ...editValue,
                                        gabc: event.currentTarget.value
                                    });
                                },
                                style: {
                                    height: 300
                                },
                                children: editValue.gabc
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8094b590f6f28f06$export$f68cd553b87bbab1), {
                                toneId: editValue.tone,
                                highlightCount: 0
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                value: editValue.tone,
                                onChange: (event)=>{
                                    setEditValue({
                                        ...editValue,
                                        tone: event.currentTarget.value
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "done",
                                        name: "done",
                                        checked: editValue.isDone,
                                        onChange: ()=>{
                                            setEditValue({
                                                ...editValue,
                                                isDone: !editValue.isDone
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "done",
                                        children: "Done"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: JSON.stringify({
                                    gabc: editValue.gabc,
                                    tone: editValue.tone
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");



'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.9.0";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
const $51cabc77a6b85afb$var$NULL = null;
const $51cabc77a6b85afb$var$RemoteDataContext = /*#__PURE__*/ (0, $acw62.createContext)($51cabc77a6b85afb$var$NULL);
const $51cabc77a6b85afb$var$getDependencyId = (dependency)=>{
    return JSON.stringify(dependency);
};
function $51cabc77a6b85afb$export$492ad75cd9c03188(dependency) {
    const dependencyId = $51cabc77a6b85afb$var$getDependencyId(dependency);
    const context = (0, $acw62.useContext)($51cabc77a6b85afb$var$RemoteDataContext);
    console.log("use data dependency");
    if (context.results[dependencyId]) {
        console.log("already found");
        return context.results[dependencyId];
    } else {
        console.log("add dependency");
        context.addDependency(dependency);
        return {
            state: "loading"
        };
    }
}
const $51cabc77a6b85afb$export$c265e0ac02f3cef4 = (props)=>{
    const [results, setResults] = (0, $acw62.useState)({});
    const addDependency = (0, $acw62.useCallback)(async (dependency)=>{
        setResults((pr)=>{
            return {
                ...pr,
                [$51cabc77a6b85afb$var$getDependencyId(dependency)]: {
                    state: "loading"
                }
            };
        });
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post("/query", {
            dependency: dependency
        });
        console.log("RESPONSE FROM EXPRESS", response);
        setResults((pr)=>{
            return {
                ...pr,
                [$51cabc77a6b85afb$var$getDependencyId(dependency)]: {
                    state: "loaded",
                    value: response.data
                }
            };
        });
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($51cabc77a6b85afb$var$RemoteDataContext.Provider, {
        value: (0, $acw62.useMemo)(()=>{
            return {
                results: results,
                addDependency: addDependency
            };
        }, [
            results,
            addDependency
        ]),
        children: props.children
    });
};



parcelRequire("acw62");

parcelRequire("acw62");




const $7c33038c8be56082$export$1712d6253669b079 = (loadableTextList)=>{
    const getEasterId = (day, id, checkEaster)=>{
        const isEastertide = day.easterOctave;
        if (isEastertide && checkEaster) return `${id} [easter]`;
        else return id;
    };
    const loadableTextIsMissing = (day, celebration, key, checkEaster)=>{
        let missing = true;
        if (loadableTextList.state === "loaded") {
            const map = celebration;
            if (loadableTextList.value.includes(getEasterId(day, map[key] ?? "", checkEaster))) missing = false;
            if (celebration.commons && missing) {
                missing = false;
                celebration.commons.forEach((common)=>{
                    let map = (0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[common] ?? {};
                    if (day.easterOctave && map.easterOverrides) map = {
                        ...map,
                        ...map.easterOverrides
                    };
                    if (!loadableTextList.value.includes(getEasterId(day, map[key] ?? "", checkEaster))) missing = true;
                });
            }
        }
        return missing;
    };
    const valueIsMissing = (day, celebration, key)=>{
        let missing = true;
        if (loadableTextList.state === "loaded") {
            const map = celebration;
            if (map[key]) missing = false;
            if (celebration.commons && missing) {
                missing = false;
                celebration.commons.forEach((common)=>{
                    let map = (0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[common] ?? {};
                    if (day.easterOctave && map.easterOverrides) map = {
                        ...map,
                        ...map.easterOverrides
                    };
                    if (!map[key]) missing = true;
                });
            }
        }
        return missing;
    };
    const getCelebrationIssues = (day, celebration, hour)=>{
        const issues = [];
        if (celebration.propersOfTheFeria) return issues;
        if (!celebration.collect || celebration.collect.includes("TODO")) issues.push("No collect");
        if (hour === "first-evensong" && loadableTextIsMissing(day, celebration, "ep1HymnId", false)) issues.push("No EP1 Hymn");
        if (hour === "first-evensong" && valueIsMissing(day, celebration, "ep1VandR")) issues.push("No EP1 V&R");
        if (hour === "first-evensong" && loadableTextIsMissing(day, celebration, "ep1MagId", true)) issues.push("No EP1 Mag");
        if (hour === "mattins" && loadableTextIsMissing(day, celebration, "invId", true)) issues.push("No MP Inv");
        if (hour === "mattins" && loadableTextIsMissing(day, celebration, "mpHymnId", false)) issues.push("No MP Hymn");
        if (hour === "mattins" && valueIsMissing(day, celebration, "mpVandR")) issues.push("No MP V&R");
        if (hour === "mattins" && loadableTextIsMissing(day, celebration, "mpBenId", true)) issues.push("No MP Ben");
        if (hour === "second-evensong" && loadableTextIsMissing(day, celebration, "ep2HymnId", false)) issues.push("No EP2 Hymn");
        if (hour === "second-evensong" && valueIsMissing(day, celebration, "ep2VandR")) issues.push("No EP2 V&R");
        if (hour === "second-evensong" && loadableTextIsMissing(day, celebration, "ep2MagId", true)) issues.push("No EP2 Mag");
        return issues;
    };
    const getDaySectionIssues = (day, celebrations, outrankedCelebrations, isFirstEvensong, isMattins)=>{
        const celebrationIssues = [];
        celebrations.forEach((celebration)=>{
            const hour = isMattins ? "mattins" : isFirstEvensong.find((ife)=>ife === celebration.label) ? "first-evensong" : "second-evensong";
            const issues = getCelebrationIssues(day, celebration, hour);
            if (issues.length > 0) celebrationIssues.push({
                day: day,
                celebration: celebration,
                hour: hour,
                issues: issues,
                outranked: false
            });
        });
        outrankedCelebrations.forEach((celebration)=>{
            const hour = isMattins ? "mattins" : isFirstEvensong.find((ife)=>ife === celebration.label) ? "first-evensong" : "second-evensong";
            const issues = getCelebrationIssues(day, celebration, hour);
            if (issues.length > 0) {
                const issue = {
                    day: day,
                    celebration: celebration,
                    hour: hour,
                    issues: issues,
                    outranked: true
                };
                celebrationIssues.push(issue);
            }
        });
        return celebrationIssues;
    };
    const getNextDayWithIssues = ()=>{
        const year = new Date().getFullYear();
        const regionLabels = localStorage.getItem("region-switches")?.split(";;;");
        const days = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(year, false, false, false, regionLabels).concat((0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(year + 1, false, false, false, regionLabels));
        const todayIndex = days.findIndex((day)=>day.date === new Date().getDate() && day.month === new Date().getMonth() + 1 && day.year === new Date().getFullYear());
        let daysInFuture = 0;
        for (const day of days.slice(todayIndex)){
            const calendarDay = {
                year: year,
                month: day.month,
                date: day.date,
                dayOfTheWeek: "mon",
                label: "",
                collect: "",
                collectId: "",
                otherLabels: [],
                dayOfTheYear: 0,
                weekOfTheYear: 0,
                antiphonId: "",
                sentenceId: "",
                hymnId: "",
                // any eastertide day
                easterOctave: day.morningOptions.concat(day.morningOutranked).find((option)=>option.title.includes("Easter") || option.title.includes("Ascension") || option.title.includes("Whit") || option.title.includes("Pentecost")) !== undefined
            };
            const amIssues = getDaySectionIssues(calendarDay, day.morningOptions, day.morningOutranked, [], true);
            const pmIssues = getDaySectionIssues(calendarDay, day.eveningOptions, day.eveningOutranked, day.isFirstEvensong, false);
            if (amIssues.length > 0 || pmIssues.length > 0) return {
                daysInFuture: daysInFuture,
                amIssues: amIssues,
                pmIssues: pmIssues
            };
            daysInFuture++;
        }
    };
    return {
        loadableTextIsMissing: loadableTextIsMissing,
        valueIsMissing: valueIsMissing,
        getNextDayWithIssues: getNextDayWithIssues
    };
};


const $7585177e3d1bd2db$export$46e4cb079497c5a5 = (props)=>{
    const { day: day, celebration: celebration, hour: hour, loadableTextList: loadableTextList } = props;
    const { loadableTextIsMissing: loadableTextIsMissing, valueIsMissing: valueIsMissing } = (0, $7c33038c8be56082$export$1712d6253669b079)(loadableTextList);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            paddingBottom: 8,
            display: "flex",
            flexDirection: "row",
            gap: 16
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        children: [
                            celebration.regionNote ? `${celebration.regionNote}: ` : "",
                            celebration.title,
                            hour === "first-evensong" ? ` (Eve)` : ""
                        ]
                    }),
                    " ",
                    "\u2014 ",
                    celebration.type,
                    " ",
                    celebration.rank
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                to: `se/${day.year}/${day.month}/${day.date}/${celebration.label}/${hour}`,
                style: {
                    color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                },
                children: "Open"
            }),
            celebration.collect ? undefined : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: "\u274C No collect"
            }),
            loadableTextList.state === "loaded" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    hour === "first-evensong" && loadableTextIsMissing(day, celebration, "ep1HymnId", false) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No EP1 hymn"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "first-evensong" && valueIsMissing(day, celebration, "ep1VandR") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No EP1 V&R"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "first-evensong" && loadableTextIsMissing(day, celebration, "ep1MagId", true) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No EP1 Mag"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "mattins" && loadableTextIsMissing(day, celebration, "invId", true) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No Inv"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "mattins" && loadableTextIsMissing(day, celebration, "mpHymnId", false) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No MP hymn"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "mattins" && valueIsMissing(day, celebration, "mpVandR") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No MP V&R"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "mattins" && loadableTextIsMissing(day, celebration, "mpBenId", true) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No Ben"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "second-evensong" && loadableTextIsMissing(day, celebration, "ep2HymnId", false) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No EP2 hymn"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "second-evensong" && valueIsMissing(day, celebration, "ep2VandR") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No EP2 V&R"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    hour === "second-evensong" && loadableTextIsMissing(day, celebration, "ep2MagId", true) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "\u274C No EP2 Mag"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "\u231B"
            })
        ]
    });
};


const $efb6841452b6f304$export$87c04985f6f0023c = (props)=>{
    const { day: day, celebrations: celebrations, outrankedCelebrations: outrankedCelebrations, isFirstEvensong: isFirstEvensong, isMattins: isMattins, loadableTextList: loadableTextList } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            celebrations.map((celebration)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7585177e3d1bd2db$export$46e4cb079497c5a5), {
                    day: day,
                    celebration: celebration,
                    hour: isMattins ? "mattins" : isFirstEvensong.find((ife)=>ife === celebration.label) ? "first-evensong" : "second-evensong",
                    loadableTextList: loadableTextList
                });
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    opacity: 0.5
                },
                children: outrankedCelebrations.map((celebration)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7585177e3d1bd2db$export$46e4cb079497c5a5), {
                        day: day,
                        celebration: celebration,
                        hour: isMattins ? "mattins" : isFirstEvensong.find((ife)=>ife === celebration.label) ? "first-evensong" : "second-evensong",
                        loadableTextList: loadableTextList
                    });
                })
            })
        ]
    });
};


const $f202f3d143a741e6$export$f3eaedf2198b9b52 = `annunciation inv	Saint Mary on Saturday Inv	Hail, Mary, full of grace; * The Lord is with thee.
annunciation inv [easter]	Saint Mary on Saturday Inv with Alleluia	Hail, Mary, full of grace; * The Lord is with thee. Alleluia.
bvm o blessed mother	Saint Mary on Saturday Ben	How shall this be, *O Angel of God, seeing I know not a man? Hearken, O Virgin Mary: the Holy Ghost shall come upon thee, and the power of the highest shall overshadow thee.
ep we celebrate a holy day	The Epiphany of the Lord Mag at EP2	We celebrate a holy day * adorned with three wonders: today the star led the Sages to the crib; today did water become wine at the marriage feast; today Christ willed to be baptised by John in Jordan, for our salvation, alleluia.
inv sun ep	The Baptism of the Lord Inv	The Christ hath been manifested unto us: * O come, let us worship him.
baptism john the forerunner	The Baptism of the Lord Ben	John the Forerunner rejoiceth with the river Jordan; when the Lord was baptised, joy and gladness were come to the whole world: * through the hallowing of water there came to us remission of sins; let us all beseech him, Have mercy upon us.
inv thur	Thursday following The Baptism of the Lord Inv	The Christ hath been manifested unto us: * O come, let us worship him.
inv fri	Friday following The Baptism of the Lord Inv	The Christ hath been manifested unto us: * O come, let us worship him.
inv sat	Saturday following The Baptism of the Lord Inv	The Christ hath been manifested unto us: * O come, let us worship him.
ep sat ep1 god hath holpen	The Second Sunday after the Epiphany Mag at EP1	God hath holpen * his servant Israel: as he promised to Abraham, and his seed for ever.
ep2 there was a marriage	The Second Sunday after the Epiphany Ben	Now there was a marriage * in Cana of Galilee and Jesus himself was there, with Mary his Mother.
ep2 and when they	The Second Sunday after the Epiphany Mag at EP2	And when they wanted wine, * Jesus commanded them to fill the waterpots with water: and it was turned into wine, alleluia.
inv mon	Monday following Epiphany II Inv	O come, * let us sing unto the Lord.
inv tues	Tuesday following Epiphany II Inv	Let us heartily rejoice * in the strength of our salvation.
inv wed	Wednesday following Epiphany II Inv	The Lord is a great God: * O come, let us worship him.
ep3 and when jesus	The Third Sunday after the Epiphany Ben	And when Jesus was come down * from the mountain, behold ,there came a leper and worshipped him, saying: Lord, if thou wilt thou canst make me clean: and he put forth his hand and touched him, saying: I will, be thou clean.
ep3 lord if thou wilt	The Third Sunday after the Epiphany Mag at EP2	Lord, * if thou wilt, thou canst make me clean; and Jesus said: I will, be thou clean.
doctor francis de sales	Saint Francis de Sales Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Francis de Sales, lover of the divine law, intercede for us unto the Son of God.
doctor francis de sales [easter]	Saint Francis de Sales Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Francis de Sales, lover of the divine law, intercede for us unto the Son of God. Alleluia.
saint paul go forth	The Conversion of Saint Paul the Apostle Mag at EP1	Go forth, Ananias, * and seek out Saul; for behold, he prayeth: for he is a chosen vessel unto me, to carry my name before the Gentiles and kings and the children of Israel.
saint paul inv	The Conversion of Saint Paul the Apostle Inv	For the conversion of the Teacher of the Gentiles : Let us praise our God.
saint paul ye which have	The Conversion of Saint Paul the Apostle Ben	Ye which have followed me * shall sit upon twelve thrones, judging the twelve tribes of Israel, saith the Lord.
saint paul o holy apostle	The Conversion of Saint Paul the Apostle Mag at EP2	Holy Apostle Paul, * preacher of the truth and Teacher ofthe Gentiles, intercede for us unto God who chose thee.
doctor thomas aquinas	Saint Thomas Aquinas Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Thomas Aquinas, lover of the divine law, intercede for us unto the Son of God.
presentation the ancient	The Presentation of the Lord Mag at EP1	The elder * took up the Child in his arms; yet was the Child the elder's Lord: whom a Virgin bare, after childbirth remaining a Virgin; he was her Child, and him she worshipped.
presentation behold the lord	The Presentation of the Lord Inv	Behold, the Lord, the Ruler, cometh into his holy temple: * Rejoice and be glad, O Sion, and go forth to meet thy God.
presentation and when the parents	The Presentation of the Lord Ben	And when his parents * brought in the Child Jesus, then Simeon took him up in his arms, and blessed God, saying: Lord, now lettest thou thy servant depart in peace.
presentation today the blessed	The Presentation of the Lord Mag at EP2	Today * the blessed Virgin Mary presented the Child Jesus in the temple, and Simeon being full of the Holy Ghost took him up in his arms, and blessed God for ever.
septuagesima the lord said	The Third Sunday Before Lent Mag at EP1	The Lord said unto Adam: * Of the tree which is in the midst of the garden thou shalt not eat: in the day wherein thou eatest thereof, thou shalt surely die.
gesima let us come	The Third Sunday Before Lent Inv	Let us come before the presence of the Lord: * And show ourselves glad in him with Psalms.
septuagesima the kingdom of	The Third Sunday Before Lent Ben	The kingdom of heaven * is likened unto a man that is an householder, which went out early in the morning to hire labourers into his vineyard, saith the Lord.
septuagesima the householder said	The Third Sunday Before Lent Mag at EP2	The householder said * unto the labourers: Why stand ye here all the day idle? And they answering said: Because no man hath hired us. Go ye also into the vineyard; and whatsoever is right, that will I give you.
doctor peter damian	Saint Peter Damian Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Peter Damian, lover of the divine law, intercede for us unto the Son of God.
doctor peter damian [easter]	Saint Peter Damian Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Peter Damian, lover of the divine law, intercede for us unto the Son of God. Alleluia.
septuagesima these last	Monday following Septuagesima Mag at EP2	These last * have wrought but one hour, and thou hast made them equal unto us, which have borne the burden and heat of the day.
chair of st peter thou art	The Chair of Saint Peter Mag at EP1	Thou art shepherd * of the sheep, and prince of the Apostles; God hath given unto thee, O Peter, the keys of the kingdom of heaven.
chair of st peter inv	The Chair of Saint Peter Inv	Thou art the shepherd of the sheep, the prince of the Apostles; * To thee were given the keys of the kingdom of heaven.
chair of st peter whatsoever	The Chair of Saint Peter Ben	Whatsoever * thou shalt bind on earth shall be bound in heaven; and whatsoever thou shalt loose on earth shall be loosed in heaven: saith the Lord to Simon Peter.
chair of st peter being a high priest	The Chair of Saint Peter Mag at EP2	Being a high Priest, * he feared not the things of earth, but attained in glory unto the heavenly realms.
septuagesima but the householder	Tuesday following Septuagesima Mag at EP2	But the householder said: * Friend, I do thee no wrong; didst thou not agree with me for a penny? Take that thine is, and go thy way.
septuagesima take that	Wednesday following Septuagesima Mag at EP2	Take that thine is, * and go thy way: for I am righteous, saith the Lord.
septuagesima is it not	Thursday following Septuagesima Mag at EP2	Is it not lawful * for me to do what I will? Is thine eye evil? For I am righteous, saith the Lord.
septuagesima so the last	Friday following Septuagesima Mag at EP2	So the last shall be first, * and the first last: for many are called, but few are chosen.
sexagesima the lord spake unto noah	The Second Sunday Before Lent Mag at EP1	The Lord spake * unto Noah: The end of all flesh is come before me: make thee an ark of gopher wood: that the seed of all may be saved therein.
sexagesima when much people	The Second Sunday Before Lent Ben	When much people * were gathered together to Jesus, and were come to him out of every city, he spake by a parable: A sower went out to sow his seed.
sexagesima unto you it is given	The Second Sunday Before Lent Mag at EP2	Unto, you it is given * to know the mystery of the kingdom of God, but to others in parables, saith Jesus to his disciples.
doctor gregory	Saint Gregory of Narek Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Gregory of Narek, lover of the divine law, intercede for us unto the Son of God.
doctor gregory [easter]	Saint Gregory of Narek Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Gregory of Narek, lover of the divine law, intercede for us unto the Son of God. Alleluia.
sexagesima if ye seek	Monday following Sexagesima Mag at EP2	If ye seek * the summit of true honour, hasten to your heavenly country with what speed ye may.
sexagesima the seed	Tuesday following Sexagesima Mag at EP2	The seed is the word * of God, and Christ is the sower: every one that heareth him, abideth for ever.
sexagesima but that	Wednesday following Sexagesima Mag at EP2	But that which fell * on the good ground are they which in an honest and good heart receive the word, and bring forth fruit with patience.
sexagesima if then brethren	Thursday following Sexagesima Mag at EP2	If then, brethren, * ye would be truly rich, set your affection on the true riches.
sexagesima they which keep	Friday following Sexagesima Mag at EP2	They which keep the word of God * in an honest and good heart, bring forth fruit with patience.
quinquagesima mighty abraham	The Sunday Next Before Lent Mag at EP1	The great Abraham * is our father in the faith, who on the altar sacrificed a burnt-offering for his son.
quinquagesima behold we go up	The Sunday Next Before Lent Ben	Behold, we go up * to Jerusalem, and all things shall be accomplished which were written concerning the Son of man: for he shall be delivered unto the Gentiles, and shall be mocked and spitted upon: and after they have scourged him, they shall kill him; and the third day he shall rise again.
quinquagesima and jesus standing	The Sunday Next Before Lent Mag at EP2	And Jesus, standing, * commanded him to be brought unto him, and asked him, saying: What wilt thou that I should do unto thee? Lord, that I may receive my sight. And Jesus said unto him: Receive thy sight, thy faith hath saved thee. And straightway he received his sight, and followed, glorifying God.
quinquagesima and they which	Monday following Quinquagesima Mag at EP2	And they which went before * rebuked him, that he should hold his peace: but he cried so much the more: Have mercy on me, thou Son of David.
quinquagesima have mercy	Tuesday following Quinquagesima Mag at EP2	Have mercy upon me, * thou Son of David. What wilt thou that I should do unto thee? Lord, that I may receive my sight.
ash weds when ye fast	Ash Wednesday Ben	When ye fast, be not like the hypocrites, of a sad countenance.
ash weds lay up	Ash Wednesday Mag at EP2	Lay up for yourselves treasures in heaven, where neither moth nor rust doth corrupt.
frances of rome inv	Saint Frances of Rome Inv
ash weds lord my servant	Thursday following Ash Wednesday Ben	Lord, my servant * lieth at home, sick of the palsy, grievously tormented. Verily I say unto thee: I will come and heal him.
ash weds lord i am not worthy	Thursday following Ash Wednesday Mag at EP2	Lord, I am not worthy * that thou shouldest come under my roof: but speak the word only, and my servant shall be healed.
ash weds when thou doest thine alms	Friday following Ash Wednesday Ben	When thou doest thine alms, * let not thy left hand know what thy right hand doeth.
ash weds but thou when	Friday following Ash Wednesday Mag at EP2	But thou, when thou prayest, * enter into thy closet: and when thou hast shut thy door, pray to thy Father.
ash weds yet they seek	Saturday following Ash Wednesday Ben	From day to day * they seek me therefore, and would know my ways.
l1 then thou shalt	The First Sunday in Lent Mag at EP1	Then thou shalt call, * and the Lord shall hear thee: thou shalt cry out, and he shall say: Behold, here I am.
l1 inv	The First Sunday in Lent Inv	Think it not lost labour that ye haste to rise up early before the light: * For the Lord hath promised a crown unto them that watch.
l1 then was jesus led	The First Sunday in Lent Ben	Jesus was led up * of the Spirit into the wilderness, to be tempted of the devil: and when he had fasted forty days and forty nights, he was afterward an hungred.
l1 behold now is	The First Sunday in Lent Mag at EP2	Behold, now is the accepted time, * now is the day of salvation; let us therefore in these days approve ourselves, as the servants of God, in much patience, in watchings, in fastings, and by love unfeigned.
l1 come ye blessed	Monday following Lent I Ben	O come, ye blessed * children of my Father: inherit the kingdom prepared for you from the foundation of the world.
l1 inasmuch	Monday following Lent I Mag at EP2	Inasmuch * as ye have done it unto the least of these, ye have done it unto me, saith the Lord.
l1 and jesus went into	Tuesday following Lent I Ben	. And Jesus went * into the temple of God, and began to cast out all them that sold and bought in the temple: and overthrew the tables of the moneychangers, and the seats of them that sold doves.
l1 truly it is written	Tuesday following Lent I Mag at EP2	For it is written, * that my house is a house a prayer for all nations: but ye have made it a den of thieves: and he was teaching daily in the temple.
l1 this crooked and perverse	Ember Wednesday in Lent Ben	This generation * being perverse and crooked, seeketh a sign from me: and no sign shall be given to it, but the sign of Jonah the prophet.
l1 for as jonah	Ember Wednesday in Lent Mag at EP2	For as Jonah *was three days and three nights in the whale's belly, so shall the Son of man be in the heart of the earth.
l1 and jesus went thence	Thursday following Lent I Ben	And Jesus went thence * and departed into the coasts of Tyre and Sidon: and behold, a woman of Canaan came out of the same coasts, and cried unto him, saying: Have mercy on me, thou Son of David.
l1 o woman great is your faith	Thursday following Lent I Mag at EP2	O woman, * great is thy faith: be it unto thee, even as thou wilt.
l1 an angel of the lord	Ember Friday in Lent Ben	An Angel of the Lord * descended from heaven, and troubled the water: and one was made whole.
l1 he that made me	Ember Friday in Lent Mag at EP2	He that made me whole, * the same said unto me: Take up thy bed, and go in peace.
l1 and jesus taketh	Ember Saturday in Lent Ben	And Jesus taketh * his disciples, and goeth up into a mountain, and was transfigured before them.
doctor cyril	Saint Cyril of Jerusalem Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Cyril of Jerusalem, lover of the divine law, intercede for us unto the Son of God.
doctor cyril [easter]	Saint Cyril of Jerusalem Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Cyril of Jerusalem, lover of the divine law, intercede for us unto the Son of God. Alleluia.
l2 tell the vision	The Second Sunday in Lent Mag at EP1	Tell the vision which ye have seen * to no man, until the Son of man be risen from the dead.
l2 and jesus went thence	The Second Sunday in Lent Ben	And Jesus went thence * and departed into the coasts of Tyre and Sidon: and behold, a woman of Canaan came out of the same coasts and cried unto him, saying: Have mercy on me, thou Son of David.
l2 o woman great is	The Second Sunday in Lent Mag at EP2	O woman, * great is thy faith: be it unto thee, even as thou wilt.
joseph then joseph being raised	Saint Joseph Mag at EP1	Then Joseph * being raised from sleep, did as the Angel of the Lord had bidden him, and took unto him his wife.
joseph then joseph being raised [easter]	Saint Joseph Mag at EP1 with Alleluia	Then Joseph * being raised from sleep, did as the Angel of the Lord had bidden him, and took unto him his wife. Alleluia.
joseph inv	Saint Joseph Inv	Christ, the Son of God, deigned to be thought the son of Joseph: * O come, let us worship him.
joseph inv [easter]	Saint Joseph Inv with Alleluia	Christ, the Son of God, deigned to be thought the son of Joseph: * O come, let us worship him. Alleluia.
joseph jesus himself	Saint Joseph Ben	Jesus himself * began to be about thirty years of age, being, as was supposed, the son of Joseph.
joseph jesus himself [easter]	Saint Joseph Ben with Alleluia	Jesus himself * began to be about thirty years of age, being, as was supposed, the son of Joseph. Alleluia.
joseph behold a faithful	Saint Joseph Mag at EP2	Behold a faithful and wise steward, * whom his Lord hath made ruler over his household.
joseph behold a faithful [easter]	Saint Joseph Mag at EP2 with Alleluia	Behold a faithful and wise steward, * whom his Lord hath made ruler over his household. Alleluia.
l2 i am the beginning	Monday following Lent II Ben	I am the Beginning: * even I that speak unto you.
l2 he that sent me	Monday following Lent II Mag at EP2	He that sent me * is with me, and he hath not left me alone: for I do always those things that please him.
l2 one is your master	Tuesday following Lent II Ben	One is your Master, * which is in heaven, even Christ the Lord.
l2 all ye are brethren	Tuesday following Lent II Mag at EP2	All ye are brethren; * and call no man your father upon earth; for one is your Father, which is in heaven: neither be ye called masters, for one is your Master, even Christ.
l2 behold we go up	Wednesday following Lent II Ben	Behold we go up * to Jerusalem; and the Son of man shall be betrayed to be crucified.
l2 he shall be delivered	Wednesday following Lent II Mag at EP2	He shall be delivered * to the Gentiles, to mock, and to scourge, and to crucify him.
l2 son remember	Thursday following Lent II Ben	Son, remember * that thou in thy lifetime receivedst thy good things, and likewise Lazarus evil things.
l2 the same rich man	Thursday following Lent II Mag at EP2	The same rich man * begged a drop of water, who had denied crumbs of bread to Lazarus.
l2 he will miserably	Friday following Lent II Ben	He will miserably destroy * those miserable men; and will let out his vineyard unto other husbandmen, which shall render him the fruits in their seasons.
l2 when they sought to lay	Friday following Lent II Mag at EP2	When they sought to take him, * they feared the people; because they counted him as a prophet.
annunciation the holy ghost	The Annunciation of the Lord Mag at EP1	The Holy Ghost * shall come upon thee, and the power of the highest shall overshadow thee.
annunciation the holy ghost [easter]	The Annunciation of the Lord Mag at EP1 with Alleluia	The Holy Ghost * shall come upon thee, and the power of the highest shall overshadow thee. Alleluia.
annunciation how shall this be	The Annunciation of the Lord Ben	How shall this be, *O Angel of God, seeing I know not a man? Hearken, O Virgin Mary: the Holy Ghost shall come upon thee, and the power of the highest shall overshadow thee.
annunciation how shall this be [easter]	The Annunciation of the Lord Ben with Alleluia	How shall this be, *O Angel of God, seeing I know not a man? Hearken, O Virgin Mary: the Holy Ghost shall come upon thee, and the power of the highest shall overshadow thee. Alleluia.
annunciation the angel gabriel	The Annunciation of the Lord Mag at EP2	The Angel Gabriel * spake unto Mary, saying: Hail, full of grace; the Lord is with thee: blessed art thou among women.
annunciation the angel gabriel [easter]	The Annunciation of the Lord Mag at EP2 with Alleluia	The Angel Gabriel * spake unto Mary, saying: Hail, full of grace; the Lord is with thee: blessed art thou among women. Alleluia.
l2 i will go unto my father	Saturday following Lent II Ben	I will go unto my father, and will say unto him: Father, make me as one of thy hired servants.
l3 but the father	The Third Sunday in Lent Mag at EP1	But the father said * unto his servants: Bring forth quickly the best robe and put it on him, and put a ring on his finger, and shoes on his feet.
l3 when a strong man	The Third Sunday in Lent Ben	When a strong man armed * keepeth his palace, his goods are in peace.
l3 a certain woman	The Third Sunday in Lent Mag at EP2	A certain woman * of the company lifted up her voice, and cried: Blessed is the womb that bare thee, and the paps which thou hast sucked. But Jesus answered: Yea rather, blessed are they that hear the word of God, and keep it.
l3 verily i say unto you	Monday following Lent III Ben	Verily, I say unto you: * that no prophet is accepted in his own country.
l3 but jesus	Monday following Lent III Mag at EP2	But Jesus, passing * through the midst of them, went his way.
l3 if two of you	Tuesday following Lent III Ben	If two of you shall agree * on earth as touching aught for which they shall make request, it shall be done for them of my Father which is in heaven, saith the Lord.
l3 where two or three	Tuesday following Lent III Mag at EP2	Where two or three * are gathered together in my name, there am I in the midst of them, saith the Lord.
l3 hearken	Wednesday following Lent III Ben	Hearken and understand ye: * the traditions which the Lord hath given you.
l3 to eat with	Wednesday following Lent III Mag at EP2	To eat with unwashen hands * defileth not a man.
l3 and devils also	Thursday following Lent III Ben	And devils also came out, of many, * crying out and saying: Thou art Christ, the Son of God: and he rebuking them suffered them not to speak, for they knew that he was Christ.
l3 whosoever had any	Thursday following Lent III Mag at EP2	All they that had any sick * brought them to Jesus, and they were healed.
l3 whosoever drinketh	Friday following Lent III Ben	If any man drink * of the water that I shall give, he shall never thirst.
l3 sir i perceive	Friday following Lent III Mag at EP2	Sir, I perceive * that thou art a prophet: our fathers worshipped in this mountain.
l3 and jesus stooped down	Saturday following Lent III Ben	And Jesus stooped down, * and wrote upon the ground: he that is without sin, let him cast a stone at her.
l4 woman hath no	The Fourth Sunday in Lent Mag at EP1	Woman, hath no man condemned thee? * No man, Lord. Neither do I condemn thee: go and sin no more.
l4 when jesus lift up	The Fourth Sunday in Lent Ben	When Jesus lift up his eyes, * and saw a great company come unto him, he said unto Philip: Whence shall we buy bread, that these may eat? And this he said to prove him, for he himself knew what he would do.
l4 jesus went up	The Fourth Sunday in Lent Mag at EP2	Jesus went up * into a mountain, and there he sat with his disciples.
l4 take these things hence	Monday following Lent IV Ben	Take these things hence, * saith the Lord: and make not my Father's house a house of merchandise.
l4 destroy this temple	Monday following Lent IV Mag at EP2	Destroy this temple * saith the Lord: and in three days I will raise it up; but this he said of the temple of his body.
doctor isidore	Saint Isidore Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Isidore, lover of the divine law, intercede for us unto the Son of God.
doctor isidore [easter]	Saint Isidore Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Isidore, lover of the divine law, intercede for us unto the Son of God. Alleluia.
l4 wherefore do ye seek	Tuesday following Lent IV Ben	Wherefore do ye seek * to kill me, a man that hath told you the truth?
l4 no man laid hands	Tuesday following Lent IV Mag at EP2	No man laid hands on him, * because his hour was not yet come.
l4 master wherein hath	Wednesday following Lent IV Ben	Master, who hath sinned, * this man or his parents, that he was born blind? And Jesus answered, saying: Neither hath this man sinned, nor his parents: but that the works of God should be manifested in him.
l4 a man that is called	Wednesday following Lent IV Mag at EP2	A man that is called Jesus * made clay out of spittle, and anointed mine eyes, and now I see.
l4 jesus went into	Thursday following Lent IV Ben	Jesus went * into a city called Nain: and behold, there was a dead man carried out, the only son of his mother.
l4 a great prophet	Thursday following Lent IV Mag at EP2	A great prophet * is risen up amongst us, and God hath visited his people.
l4 our friend lazarus	Friday following Lent IV Ben	Our friend Lazarus * sleepeth: let us go, that we may awake him out of sleep.
l4 lord if thou hadst	Friday following Lent IV Mag at EP2	Lord, if thou hadst been here, * Lazarus would not have died: lo, by this time he stinketh, being in the sepulchre four days already.
l4 he that followeth me	Saturday following Lent IV Ben	He that followeth me * shall not walk in darkness: but shall have the light of life, saith the Lord.
l5 i am one	The Fifth Sunday in Lent Mag at EP1	I am one, * that bear witness of myself, and the Father that sent me beareth witness of me.
passiontide inv	The Fifth Sunday in Lent Inv	Today, if ye will hear the voice of the Lord, * Harden not your hearts.
l5 jesus said unto the	The Fifth Sunday in Lent Ben	Jesus said * unto the multitudes of the Jews, and to the chief priests: He that is of God, heareth my words; ye therefore hear them not, because ye are not of God.
l5 your father abraham	The Fifth Sunday in Lent Mag at EP2	Your father Abraham * rejoiced to see my day: he saw it, and was glad.
l5 in the last day of the feast	Monday following Passion Sunday Ben	In the last day * of the feast, Jesus stood and cried, saying: If any man thirst let him come unto me and drink.
l5 if any man thirst	Monday following Passion Sunday Mag at EP2	If any man thirst, * let him come and drink: and out of his belly shall flow rivers of living water, saith the Lord.
l5 my time is not yet come	Tuesday following Passion Sunday Ben	My time * is not yet come: but your time is always ready.
l5 go ye up	Tuesday following Passion Sunday Mag at EP2	Go ye up * unto this feast: I go not up yet, for my time is not yet fully come.
l5 my sheep hear	Wednesday following Passion Sunday Ben	My sheep * hear my voice: and I the Lord do know them.
l5 many good works	Wednesday following Passion Sunday Mag at EP2	Many. good works * have I wrought among you: for which of those works do ye seek to kill me?
l5 the master saith	Thursday following Passion Sunday Ben	The Master saith: * My time is at hand: I will keep the Passover at thy house with my disciples.
l5 with desire have i	Thursday following Passion Sunday Mag at EP2	With desire have I desired * to eat this Passover with you, before I suffer.
sorrows come ye	Saint Mary in Passiontide Ben	O come ye, * and let us go up to the hill of the Lord; and behold ye if there be any sorrow like unto my sorrow.
sorrows sorrow hath weighed	Saint Mary in Passiontide Mag at EP2	Sorrow hath weighted me down, * and my face is swollen with weeping, and on mine eyelids is the shadow of death.
l5 now the feast day	Friday following Passion Sunday Ben	Now the feast day * was nigh at hand, and the chief priests and elders sought for occasion to slay Jesus: but they feared the multitude.
l5 the chief priests	Friday following Passion Sunday Mag at EP2	The chief priests and elders * took counsel together how they might destroy him: but they spake and said: Not on the feast day, lest there be an uproar among the people.
l5 o father glorify	Saturday following Passion Sunday Ben	Glorify me, O Father, * with thine own self, with the glory which I had before the world was.
hw righteous father	Palm Sunday Mag at EP1	Righteous Father, * the world hath not known thee: but I have known that thou didst send me.
hw much people	Palm Sunday Ben	Much people, * which was come together on' the feast day, cried out and said: Blessed is he that cometh in the name of the Lord: Hosanna in the highest.
hw for it is written	Palm Sunday Mag at EP2	For it is written: * I will smite the shepherd, and the sheep of the flock shall be scattered: but after I am risen, I will go before you into Galilee: there shall ye see me, saith the Lord.
hw o father glorify	Monday in Holy Week Ben	Glorify me, O Father, * with thine own self, with the glory which I had before the world was.
hw thou couldest have	Monday in Holy Week Mag at EP2	Thou couldest have no power * at all against me, except it were given thee from above.
hw before the day	Tuesday in Holy Week Ben	Before the day of the feast * of the Passover, Jesus, knowing that his hour was come, when he loved his own, he loved them unto the end.
hw i have power	Tuesday in Holy Week Mag at EP2	I have power * to lay down my life, and I have power to take it up again.
hw simon sleepest thou	Wednesday in Holy Week Ben	Simon, sleepest thou? * Couldest thou not watch with me one hour?
hw a maid said	Wednesday in Holy Week Mag at EP2	A maid said * unto Peter: Verily thou art one of them; and thy speech betrayeth thee.
hw now he that betrayed	Thursday in Holy Week Ben	Now he that betrayed him * gave them a sign, saying: Whomsoever I shall kiss, that same is he; hold him fast.
hw and as they were eating	Thursday in Holy Week Mag at EP2	And as they were eating, * Jesus took bread, and blessed it, and brake it, and gave it to his disciples.
hw they set up	Good Friday Ben	And they set up * over his head his accusation written: Jesus of Nazareth, the King of the Jews.
hw when he had received	Good Friday Mag at EP2	When he had received the vinegar, * he said: It is finished; and he bowed his head, and gave up the ghost.
hw the women also sitting	Holy Saturday Ben	The women also, * sitting at the sepulchre, made lamentation, weeping for the Lord.
hw the chief priests	Holy Saturday Mag at EP2	The chief priests * and Pharisees guarded the sepulchre, sealing the stone, and setting a watch.
e1 and very early [easter]	Easter Day Ben with Alleluia	And very early in the morning, * the first day of the week, they came to the sepulchre at the rising of the sun, alleluia.
e1 and when they looked [easter]	Easter Day Mag at EP2 with Alleluia	And when they looked, * they saw that the stone was rolled away; for it was very great, alleluia.
st george the saints through faith	Saint George Mag at EP1	The Saints through faith * subdued kingdoms, wrought righteousness, obtained promises.
st george the saints through faith [easter]	Saint George Mag at EP1 with Alleluia	The Saints through faith * subdued kingdoms, wrought righteousness, obtained promises, alleluia.
e1 jesus joined himself [easter]	Monday in the Octave of Easter Ben with Alleluia	Jesus joined himself * to his disciples in the way, and went with them; but their eyes were holden that they knew him not; and he rebuked them, saying: O fools and slow of heart to believe all that the Prophets have spoken, alleluia.
e1 what manner [easter]	Monday in the Octave of Easter Mag at EP2 with Alleluia	What manner of communications * are these that ye have one to another, as ye walk, and are sad? alleluia.
e1 jesus stood in [easter]	Tuesday in the Octave of Easter Ben with Alleluia	Jesus stood * in the midst of his disciples, and said unto them: Peace be unto you, alleluia, alleluia.
e1 behold my hands [easter]	Tuesday in the Octave of Easter Mag at EP2 with Alleluia	Behold my hands * and my feet, that it is I myself, alleluia, alleluia.
e1 cast the net [easter]	Wednesday in the Octave of Easter Ben with Alleluia	Cast the net * on the right side of the ship, and ye shall find, alleluia.
e1 jesus said to [easter]	Wednesday in the Octave of Easter Mag at EP2 with Alleluia	Jesus said * to his disciples: Take of the fish which ye have now caught. But Simon Peter went up, and drew the net to land, full of great fishes, alleluia.
e1 many stood [easter]	Thursday in the Octave of Easter Ben with Alleluia	Mary stood * at the sepulchre weeping, and seeth two Angels in white sitting, and the napkin that was about the head of Jesus, alleluia.
e1 they have taken [easter]	Thursday in the Octave of Easter Mag at EP2 with Alleluia	They have taken away my Lord * and I know not where they have laid him; if thou have borne him hence, tell me, alleluia, and I will take him away, alleluia.
e1 the eleven [easter]	Friday in the Octave of Easter Ben with Alleluia	The eleven disciples * when they saw the Lord in Galilee, worshipped him, alleluia.
e1 all power [easter]	Friday in the Octave of Easter Mag at EP2 with Alleluia	All power is given * unto me in heaven and in earth, alleluia.
e1 they ran both [easter]	Saturday in the Octave of Easter Ben with Alleluia	They ran both together, * and the other disciple did outrun Peter, and came first to the sepulchre, alleluia.
doctor catherine	Saint Catherine of Siena Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Catherine of Siena, lover of the divine law, intercede for us unto the Son of God.
doctor catherine [easter]	Saint Catherine of Siena Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Catherine of Siena, lover of the divine law, intercede for us unto the Son of God. Alleluia.
bvm joy to thee [easter]	Saint Mary on Saturday Ben with Alleluia
e2 that same evening [easter]	The Second Sunday of Easter Mag at EP1 with Alleluia	The same day at evening, * being the first day of the week, when the doors were shut where the disciples were assembled, Jesus stood in the midst of them, and said unto them: Peace be unto you, alleluia.
easter inv [easter]	The Second Sunday of Easter Inv with Alleluia	The Lord is risen indeed, * alleluia.
e2 after eight days [easter]	The Second Sunday of Easter Mag at EP2 with Alleluia	After eight days, * when the doors were shut, the Lord entered, and said unto them: Peace be unto you; alleluia, alleluia.
e2 when jesus was risen [easter]	Monday following Easter II Ben with Alleluia	When Jesus was risen * early on the first day of the week, he appeared first to Mary Magdalene, out of whom he had cast seven devils, alleluia.
e2 peace be unto you [easter]	Monday following Easter II Mag at EP2 with Alleluia	Peace be unto you * it is I: be not afraid, alleluia.
doctor athanasius	Saint Athanasius Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Athanasius, lover of the divine law, intercede for us unto the Son of God.
doctor athanasius [easter]	Saint Athanasius Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Athanasius, lover of the divine law, intercede for us unto the Son of God. Alleluia.
e2 i go before you [easter]	Tuesday following Easter II Ben with Alleluia	I go before you * into Galilee: there shall ye see me, as I said unto you, alleluia, alleluia.
e2 reach hither [easter]	Tuesday following Easter II Mag at EP2 with Alleluia	Reach hither thy hand * and thrust it into my side, alleluia: and be not faithless but believing, alleluia.
e2 i am the true vine [easter]	Wednesday following Easter II Ben with Alleluia	I am the true vine, * and ye are the branches, alleluia.
e2 because thou hast [easter]	Wednesday following Easter II Mag at EP2 with Alleluia	Because thou hast seen me, * Thomas, thou hast believed: blessed are they that have not seen, and yet have believed, alleluia.
e2 my heart burns [easter]	Thursday following Easter II Ben with Alleluia	My heart burneth, *I long to behold my Lord: I seek him, and I find him not where they laid him, alleluia, alleluia.
e2 i did put [easter]	Thursday following Easter II Mag at EP2 with Alleluia	I put my finger * into the prints of the nails, and my hands into his side; and I said: My Lord and my God, alleluia.
e2 there came unto the tomb [easter]	Friday following Easter II Ben with Alleluia	There came unto the tomb * Mary Magdalene and the other Mary, to see the sepulchre, alleluia.
e2 after ... when the doors [easter]	Friday following Easter II Mag at EP2 with Alleluia	After eight days, * when the doors were shut, the Lord entered, and said unto them: Peace be unto you; alleluia, alleluia.
e3 i am the shepherd [easter]	The Third Sunday of Easter Mag at EP1 with Alleluia	I am the Shepherd of the sheep: * I am the way, the truth and the life; I am the good Shepherd, and know my sheep and am known of mine, alleluia, alleluia.
e3 i am the good shepherd [easter]	The Third Sunday of Easter Mag at EP2 with Alleluia	I am the good Shepherd, * and I feed my sheep; and I lay down my life for the sheep, alleluia.
e3 go ye into all [easter]	Monday following Easter III Ben with Alleluia	Go ye into all the world * and teach all nations, alleluia.
e3 the good shepherd lays [easter]	Monday following Easter III Mag at EP2 with Alleluia	The good Shepherd * layeth down his life for the sheep, alleluia.
e3 go ye into the world [easter]	Tuesday following Easter III Ben with Alleluia	Go ye into all the world, * and teach all nations, baptising them in the name of the Father, and of the Son, and of the Holy Ghost, alleluia.
e3 he that is an hireling [easter]	Tuesday following Easter III Mag at EP2 with Alleluia	He that is an hireling, * whose own the sheep are not, seeth the wolf coming, and leaveth the sheep, and fleeth: and the wolf catcheth them, and scattereth the sheep, alleluia.
doctor john	Saint John of Avila Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed John of Avila, lover of the divine law, intercede for us unto the Son of God.
doctor john [easter]	Saint John of Avila Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed John of Avila, lover of the divine law, intercede for us unto the Son of God. Alleluia.
e3 go unto my [easter]	Wednesday following Easter III Ben with Alleluia	Go unto my brethren * and say unto them, alleluia, that they go into Galilee, alleluia: there shall they see me, alleluia, alleluia, alleluia.
e3 as the father knows [easter]	Wednesday following Easter III Mag at EP2 with Alleluia	As the Father knoweth me, * even so know I the Father: and I lay down my life for the sheep, alleluia.
e3 art thou only [easter]	Thursday following Easter III Ben with Alleluia	Art thou only a stranger * and hast not heard concerning Jesus, how they delivered him to be condemned to death, alleluia.
e3 other sheep i have [easter]	Thursday following Easter III Mag at EP2 with Alleluia	Other sheep I have, * which are not of this fold: them also I must bring, and they shall hear my voice: and there shall be one fold and one Shepherd, alleluia.
e3 ought not christ [easter]	Friday following Easter III Ben with Alleluia	Ought not Christ to have suffered* these things, and to enter into his glory? alleluia.
e4 a little while [easter]	The Fourth Sunday of Easter Mag at EP1 with Alleluia	A little while * and ye shall not see me, saith the Lord: and again a little while, and ye shall see me, because I go to the Father, alleluia.
e4 verily i say [easter]	The Fourth Sunday of Easter Mag at EP2 with Alleluia	Verily I say unto you, * that ye shall weep and lament; and the world shall rejoice; and ye shall be sorrowful, but your sorrow shall be turned into joy, alleluia.
e4 and beginning [easter]	Monday following Easter IV Ben with Alleluia	And beginning at Moses * and all the Prophets, he expounded unto them the scriptures concerning himself, alleluia.
e4 your sorrow shall be [easter]	Monday following Easter IV Mag at EP2 with Alleluia	Your sorrow * shall be turned into joy, alleluia: and your joy no man taketh from you, alleluia, alleluia.
e4 and they constrained [easter]	Tuesday following Easter IV Ben with Alleluia	And they constrained him * saying: Abide with us, for it is toward evening, alleluia.
e4 sorrow hath filled [easter]	Tuesday following Easter IV Mag at EP2 with Alleluia	Sorrow hath filled * your heart: but your joy no man taketh from you, alleluia, alleluia.
e4 abide with us for [easter]	Wednesday following Easter IV Ben with Alleluia	Abide with us, * for it is toward evening, and the day is far spent, alleluia.
e4 your sorrow will be turned [easter]	Wednesday following Easter IV Mag at EP2 with Alleluia	Your sorrow, * alleluia, shall be turned into joy, alleluia.
e4 and he went in [easter]	Thursday following Easter IV Ben with Alleluia	And he went in * to tarry with them; and it came to pass, as he sat at meat with them, he took bread, and blessed it, and brake, and gave it to them, alleluia.
e4 verily verily i say [easter]	Thursday following Easter IV Mag at EP2 with Alleluia	Verily, verily, * I say unto you: I will see you again, and your heart shall rejoice, and your joy no man taketh from you, alleluia.
e4 they knew the lord [easter]	Friday following Easter IV Ben with Alleluia	They knew the Lord * Jesus, alleluia, in breaking of bread, alleluia.
e5 i go my way [easter]	The Fifth Sunday of Easter Mag at EP1 with Alleluia	I go my way to him * that sent me; and none of you asketh me: Whither goest thou? alleluia, alleluia.
e5 did not our heart [easter]	Monday following Easter V Ben with Alleluia	Did not our heart burn * within us concerning Jesus, while he talked with us in the way? alleluia.
e5 i tell you the truth [easter]	Monday following Easter V Mag at EP2 with Alleluia	I tell you the truth: * it is expedient for you that I go away; for if I go not away, the Comforter will not come unto you, alleluia.
e5 peace but unto you it is [easter]	Tuesday following Easter V Ben with Alleluia	Peace be unto you, * it is I, alleluia; be not afraid, alleluia.
e5 when the comforter [easter]	Tuesday following Easter V Mag at EP2 with Alleluia	When the Comforter shall come, * even the Spirit of truth, he shall reprove the world of sin, and of righteousness, and of judgement, alleluia.
olhoc behold mary	Our Lady, Help of Christians Mag at EP1	Behold, Mary * was our hope, to whom we fled for help, that she might deliver us, and she. came to our aid.
olhoc behold mary [easter]	Our Lady, Help of Christians Mag at EP1 with Alleluia	Behold, Mary * was our hope, to whom we fled for help, that she might deliver us, and she. came to our aid. Alleluia.
bvm inv	Our Lady, Help of Christians Inv	Holy Mary, Virgin Mother of God: * Intercede for us.
bvm inv [easter]	Our Lady, Help of Christians Inv with Alleluia	Holy Mary, Virgin Mother of God: * Intercede for us. Alleluia.
olhoc to thee we cried	Our Lady, Help of Christians Ben	To thee * we cried, O holy Mother of God, and through thee came the help of the Lord to us.
olhoc to thee we cried [easter]	Our Lady, Help of Christians Ben with Alleluia	To thee * we cried, O holy Mother of God, and through thee came the help of the Lord to us. Alleluia.
olhoc holy mary help	Our Lady, Help of Christians Mag at EP2	Holy Mary, * help those in misery, strengthen the fainthearted, comfort the sorrowful, pray for the people, intercede for clerics, plead for all women vowed to God; may all feel thy help, whosoever implore thine aid.
olhoc holy mary help [easter]	Our Lady, Help of Christians Mag at EP2 with Alleluia	Holy Mary, * help those in misery, strengthen the fainthearted, comfort the sorrowful, pray for the people, intercede for clerics, plead for all women vowed to God; may all feel thy help, whosoever implore thine aid. Alleluia.
e5 a spirit hath not [easter]	Wednesday following Easter V Ben with Alleluia	A spirit hath not flesh * and bones, as ye see me have; therefore believe, alleluia.
e5 i have yet many [easter]	Wednesday following Easter V Mag at EP2 with Alleluia	I have yet many things * to say into you, but ye cannot bear them now; howbeit, when he, the Spirit of truth, shall come, he will guide you into all truth, alleluia.
doctor bede	Saint Bede the Venerable Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Bede the Venerable, lover of the divine law, intercede for us unto the Son of God.
doctor bede [easter]	Saint Bede the Venerable Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Bede the Venerable, lover of the divine law, intercede for us unto the Son of God. Alleluia.
e5 the disciples offered [easter]	Thursday following Easter V Ben with Alleluia	The disciples * set before the Lord a piece of broiled fish, and of an honeycomb, alleluia, alleluia.
e5 for he shall not [easter]	Thursday following Easter V Mag at EP2 with Alleluia	He shall not speak * of himself, but whatsoever he shall hear, that shall he speak; and he will show you things to come, alleluia.
e5 these are the words [easter]	Friday following Easter V Ben with Alleluia	These are the words * which I spake unto you, while I was yet with you, alleluia, alleluia.
e5 now i go my way [easter]	Friday following Easter V Mag at EP2 with Alleluia	I go my way to him * that sent me; but because I have said these things unto you, sorrow hath filled your heart, alleluia.
e6 hitherto have ye [easter]	The Sixth Sunday of Easter Mag at EP1 with Alleluia	Hitherto * have ye asked nothing in my name; ask, and ye shall receive, alleluia.
e6 ask ye [easter]	The Sixth Sunday of Easter Mag at EP2 with Alleluia	Ask ye, * and ye shall receive, that your joy may be fulfilled; for the Father himself loveth you, because ye have loved me, and have believed, alleluia.
e6 ask and it shall [easter]	Rogation Monday Ben with Alleluia	Ask, and it shall be given you; * seek, and ye shall find; knock, and it shall be opened unto you, alleluia.
e6 for the father [easter]	Rogation Monday Mag at EP2 with Alleluia	The Father himself loveth * you, because ye have loved me, and have believed, alleluia.
e6 it behoved christ [easter]	Rogation Tuesday Ben with Alleluia	It beloved * Christ to suffer, and to rise again from the dead, alleluia.
e6 i came forth [easter]	Rogation Tuesday Mag at EP2 with Alleluia	I came forth * from the Father, and am come into the world; again, I leave the world, and go to the Father, alleluia.
visit blessed art thou	The Visitation of the Blessed Virgin Mary Mag at EP1	Blessed art thou, * O Mary, who hast believed: for there shall be a performance of those things which were told thee from the Lord, alleluia.
visit inv	The Visitation of the Blessed Virgin Mary Inv	Let us celebrate the Visitation of the Virgin Mary: * Let us worship her Son, Christ the Lord.
visit when elizabeth	The Visitation of the Blessed Virgin Mary Ben	When Elizabeth * heard the salutation of Mary, she cried with a loud voice, saying: Whence is this to me, that the Mother of my Lord should come to me? Alleluia.
visit all generations	The Visitation of the Blessed Virgin Mary Mag at EP2	All generations * shall call me blessed, for God hath regarded the lowliness of his handmaiden, alleluia.
e6 father the hour [easter]	Rogation Wednesday Ben with Alleluia	Father, the hour is come, * glorify thy Son with the glory which I had with thee before the world was, alleluia.
ascension father i have [easter]	The Ascension of the Lord Mag at EP1 with Alleluia	Father, * I have manifested thy name unto the men whom thou hast given me; and now I pray for them, not for the world, because I come to thee, alleluia.
ascension inv [easter]	The Ascension of the Lord Inv with Alleluia	Alleluia, Christ the Lord ascendeth into heaven: * O come, let us worship him, alleluia.
ascension i ascend [easter]	The Ascension of the Lord Ben with Alleluia	I ascend to my Father, * and your Father; and to my God, and your God, alleluia.
ascension o king of [easter]	The Ascension of the Lord Mag at EP2 with Alleluia	O King of glory, * Lord of Sabaoth, who on this day ascendest with exceeding triumph far above all heavens: we pray thee, leave us not comfortless, but send the promise of the Father on us, even the Spirit of truth, alleluia.
e7 when the [easter]	The Seventh Sunday of Easter Mag at EP1 with Alleluia	When the Comforter is come, * whom I will send unto you, even the Spirit of truth, which proceedeth from the Father, he shall testify of me, alleluia.
e7 these things [easter]	The Seventh Sunday of Easter Mag at EP2 with Alleluia	These things have I told you, * that when the hour cometh, ye may remember that I told you of them, alleluia.
doctor ephrem	Saint Ephrem Mag at EP2	O teacher most excellent, * O light of holy Church, O blessed Ephrem, lover of the divine law, intercede for us unto the Son of God.
doctor ephrem [easter]	Saint Ephrem Mag at EP2 with Alleluia	O teacher most excellent, * O light of holy Church, O blessed Ephrem, lover of the divine law, intercede for us unto the Son of God. Alleluia.
pen i will not [easter]	Pentecost Mag at EP1 with Alleluia	I will not leave you * comfortless, alleluia; I go away, and come again unto you, alleluia; and your heart shall rejoice, alleluia.
pen inv [easter]	Pentecost Inv with Alleluia	Alleluia, the Spirit of the Lord filleth the world:* \xa0O come, let us worship him, alleluia.
pen receive ye [easter]	Pentecost Ben with Alleluia	Receive ye * the Holy Ghost; whosesoever sins ye remit, they are remitted unto them, alleluia.
pen today are fulfilled [easter]	Pentecost Mag at EP2 with Alleluia	Today * are fulfilled the days of Pentecost, alleluia; today the Holy Spirit appeared in fire to the disciples, and bestowed upon them his manifold graces, sending them into all the world, to preach and to testify: He that believeth and is baptised shall be saved, alleluia.
pen god so loved [easter]	Monday in Whitsun Week Ben with Alleluia	God so loved the world * that he gave his only-begotten Son: that whosoever believeth in him should not perish, but have everlasting life, alleluia.
pen if a man love [easter]	Monday in Whitsun Week Mag at EP2 with Alleluia	If a man love me, * he will keep my word: and my Father will love him, and we will come unto him, and make our abode with him, alleluia.
pen i am the door [easter]	Tuesday in Whitsun Week Ben with Alleluia	I am the door, * saith the Lord: by me if any man enter in, he shall be saved, and shall find pasture, alleluia.
pen peace i leave [easter]	Tuesday in Whitsun Week Mag at EP2 with Alleluia	Peace I leave * with you, my peace I give unto you: not as the world giveth, give I unto you, alleluia.
pen i am the living [easter]	Ember Wednesday in Whitsun Week Ben with Alleluia	I am the living bread, * saith the Lord, which came down from heaven, alleluia.
pen i am the living which came [easter]	Ember Wednesday in Whitsun Week Mag at EP2 with Alleluia	I am the living bread, * which came down from heaven: if any man eat of this bread, he shall live for ever; and the bread that I will give is my flesh, for the life of the world, alleluia.
oljchp inv	Our Lord Jesus Christ, Eternal High Priest Inv	The Lord, the High Priest, * O come, let us worship him.
oljchp inv [easter]	Our Lord Jesus Christ, Eternal High Priest Inv with Alleluia	The Lord, the High Priest, * O come, let us worship him. Alleluia.
oljchp this is my body [easter]	Our Lord Jesus Christ, Eternal High Priest Ben with Alleluia	This is my body * which is given for you: this cup is the new testament in my blood, which is shed for you: this do in remembrance of me. Alleluia.
oljchp behold i will send [easter]	Our Lord Jesus Christ, Eternal High Priest Mag at EP2 with Alleluia	Behold, I will send my messenger, * and he shall prepare the way before me. He shall purify the sons of Levi; that they may offer unto the Lord an offering in righteousness: and the offering of Juda and Jerusalem shall be pleasant unto the Lord, as in former years. Alleluia.
pen jesus called unto [easter]	Thursday in Whitsun Week Ben with Alleluia	Jesus called the twelve * disciples together, and gave them power and authority over unclean spirits, and to cure diseases: and he sent them to preach the kingdom of God, and to heal the sick, alleluia.
pen the spirit which [easter]	Thursday in Whitsun Week Mag at EP2 with Alleluia	The Spirit, * which proceeded from the Father, alleluia: he shall glorify me, alleluia, alleluia.
pen jesus said [easter]	Ember Friday in Whitsun Week Ben with Alleluia	Jesus said: * But that ye know that the Son of man hath power on earth to forgive sins (he saith unto the sick of the palsy): I say unto thee: Arise, take up thy bed, and go thy way into thine house, alleluia.
pen but the comforter [easter]	Ember Friday in Whitsun Week Mag at EP2 with Alleluia	But the Comforter, * which is the Holy Ghost, whom the Father will send in my name, he shall teach you all things, and bring all things to your remembrance, whatsoever I have said unto you, alleluia.
pen the love of god [easter]	Ember Saturday in Whitsun Week Ben with Alleluia	The love of God * is shed abroad in our hearts by his Spirit which dwelleth in us, alleluia.
trin thanks o god	Trinity Sunday Mag at EP1	Thanks, O God, * be unto thee, thanks be unto thee: one and very Trinity, one and supreme Deity, holy and perfect Unity.
trin inv	Trinity Sunday Inv	The very God, one in Trinity, and Trinity in Unity: * O come, let us worship him.
trin blessed be	Trinity Sunday Ben	Blessed be the Creator * and Ruler of all things, the holy and undivided Trinity, both now and throughout all ages, world without end.
trin thee o god	Trinity Sunday Mag at EP2	Thee, O God, * the Father unbegotten; thee, the only-begotten Son; thee, O Holy Spirit, the Paraclete; holy and undivided Trinity, with our whole heart and voice we acknowledge thee, we praise thee, we bless thee; to thee be glory for ever and ever.
corpus o how sweet	The Most Holy Body and Blood of Christ Mag at EP1	O how sweet * O Lord is thy spirit, who, to show forth thy loving- kindness to thy children, feedest them with the most sweet Bread, which came from heaven; filling the hungry with good things, and sending the disdainful rich empty away.
corpus inv	The Most Holy Body and Blood of Christ Inv	Let us worship Christ the King, the Lord of all the world: * Who giveth health of spirit to them that feed on him.
corpus i am	The Most Holy Body and Blood of Christ Ben	"I am the living Bread * which came down from heaven;
if any man eat of this Bread, he shall live for ever, alleluia."
corpus o sacred	The Most Holy Body and Blood of Christ Mag at EP2	O sacred banquet, * in which Christ is received, the memory of his passion renewed, the mind filled with grace, and a pledge of future glory given unto us, alleluia.
t1 the child samuel	The First Sunday after Trinity Mag at EP1	The child Samuel * ministered before the Lord in the presence of Eli; and the word of the Lord was precious unto him.
inv sun trin	The First Sunday after Trinity Inv	Let us worship the Lord, * for he hath made us.
t1 father abraham	The First Sunday after Trinity Ben	Father Abraham, * have mercy upon me, and send Lazarus that he may dip the tip of his finger in water, and cool my tongue.
t1 son remember	The First Sunday after Trinity Mag at EP2	Son, remember * that thou in thy lifetime receivedst thy good things, and likewise Lazarus evil things.
sh i am come	The Most Sacred Heart of Jesus Mag at EP1	I am come * to send fire on the earth: and what will I if it be already kindled?
t5 master we have toiled	The Fifth Sunday after Trinity Mag at EP2	Master, * we have toiled all the night, and have taken nothing; nevertheless, at thy word I will let down the net.`;


const $a26e968dbd77cfe3$var$scanForAntiphons = (texts)=>{
    const rows = [
        "ID (DO NOT CHANGE)\tLABEL\tANTIPHON TEXT"
    ];
    const alreadyFound = {};
    const zebAnts = {};
    (0, $f202f3d143a741e6$export$f3eaedf2198b9b52).split("\n").forEach((row)=>{
        const parts = row.split("\t");
        zebAnts[parts[0]] = parts[2];
    });
    const maybeAddText = (id, label, isEastertide)=>{
        if (id === undefined) return;
        if (isEastertide) {
            const easterId = `${id} [easter]`;
            const existingValueWithAllelluia = zebAnts[easterId] ?? "MISSING";
            if (!alreadyFound[easterId]) {
                rows.push(`${easterId}\t${label} with Alleluia\t${existingValueWithAllelluia}`);
                alreadyFound[easterId] = true;
            }
        } else {
            const existingValue = zebAnts[id] ?? "MISSING";
            if (!alreadyFound[id]) {
                rows.push(`${id}\t${label}\t${existingValue}`);
                alreadyFound[id] = true;
            }
        }
    };
    const regionLabels = localStorage.getItem("region-switches")?.split(";;;") ?? [];
    for(let year = 2000; year < 2100; year++){
        const days = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(year, false, false, false, regionLabels).concat((0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(year, true, true, true, regionLabels));
        days.forEach((day)=>{
            const celebrationList = day.morningOptions.concat(day.morningOutranked);
            const isEastertide = celebrationList?.find((celebration)=>(celebration.title.includes("Easter") || celebration.title.includes("Ascension") || celebration.title === "Rogation Monday" || celebration.title === "Rogation Tuesday" || celebration.title === "Rogation Wednesday" || celebration.title === "Rogation Thursday" || celebration.title === "Rogation Friday" || celebration.title === "Rogation Saturday" || celebration.title.includes("Whit") || celebration.title.includes("Pentecost")) && celebration.title !== "Trinity Sunday") !== undefined;
            celebrationList.forEach((celebration)=>{
                maybeAddText(celebration.ep1MagId, `${celebration.title} Mag at EP1`, isEastertide);
                maybeAddText(celebration.invId, `${celebration.title} Inv`, isEastertide);
                maybeAddText(celebration.mpBenId, `${celebration.title} Ben`, isEastertide);
                maybeAddText(celebration.ep2MagId, `${celebration.title} Mag at EP2`, isEastertide);
                celebration.commons?.forEach((common)=>{
                    maybeAddText((0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[common].ep1MagId, `Common of ${common} Mag at EP1`, isEastertide);
                    maybeAddText((0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[common].invId, `Common of ${common} Inv`, isEastertide);
                    maybeAddText((0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[common].mpBenId, `Common of ${common} Ben`, isEastertide);
                    maybeAddText((0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[common].ep2MagId, `Common of ${common} Mag at EP2`, isEastertide);
                });
            });
        });
    }
    return rows.join("\n");
};
const $a26e968dbd77cfe3$export$cc0f45ef5b6d03fc = ()=>{
    const year = new Date().getFullYear();
    const regionLabels = localStorage.getItem("region-switches")?.split(";;;") ?? [];
    const days = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(year, false, false, false, regionLabels);
    const loadableTextList = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "ord text list"
    });
    console.log(loadableTextList);
    const todayIndex = days.findIndex((day)=>day.date === new Date().getDate() && day.month === new Date().getMonth() + 1 && day.year === new Date().getFullYear());
    if (loadableTextList.state === "loaded") console.log();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: "100%",
            overflow: "scroll",
            padding: 24
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                children: $a26e968dbd77cfe3$var$scanForAntiphons(loadableTextList.state === "loaded" ? loadableTextList.value : [])
            }),
            days.slice(todayIndex, todayIndex + 42).map((day)=>{
                const calendarDay = {
                    year: year,
                    month: day.month,
                    date: day.date,
                    dayOfTheWeek: "mon",
                    label: "",
                    collect: "",
                    collectId: "",
                    otherLabels: [],
                    dayOfTheYear: 0,
                    weekOfTheYear: 0,
                    antiphonId: "",
                    sentenceId: "",
                    hymnId: "",
                    // any eastertide day
                    easterOctave: day.morningOptions.concat(day.morningOutranked).find((option)=>option.title.includes("Easter") || option.title.includes("Ascension") || option.title.includes("Whit") || option.title.includes("Pentecost")) !== undefined
                };
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid #DDD",
                        paddingTop: 8,
                        paddingBottom: 8,
                        backgroundColor: day.day === "sun" ? "#F0F0F0" : undefined
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                width: 50
                            },
                            children: [
                                day.month,
                                "-",
                                day.date
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                flexGrow: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        borderBottom: "1px solid #DDD"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                width: 50
                                            },
                                            children: "AM"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efb6841452b6f304$export$87c04985f6f0023c), {
                                            day: calendarDay,
                                            celebrations: day.morningOptions,
                                            outrankedCelebrations: day.morningOutranked,
                                            isFirstEvensong: [],
                                            isMattins: true,
                                            loadableTextList: loadableTextList
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        paddingTop: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                width: 50
                                            },
                                            children: "PM"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efb6841452b6f304$export$87c04985f6f0023c), {
                                            day: calendarDay,
                                            celebrations: day.eveningOptions,
                                            outrankedCelebrations: day.eveningOutranked,
                                            isFirstEvensong: day.isFirstEvensong,
                                            isMattins: false,
                                            loadableTextList: loadableTextList
                                        })
                                    ]
                                }),
                                day.morningOptions.concat(day.morningOutranked).find((celebration)=>celebration.type === "feria" || celebration.type === "sunday") === undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "\u274C No feria"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                            ]
                        })
                    ]
                });
            })
        ]
    });
};



parcelRequire("acw62");


const $ff1d4b6eaad740ef$export$a8f9d2f019e4a929 = ()=>{
    const year = new Date().getFullYear();
    const regionLabels = localStorage.getItem("region-switches")?.split(";;;") ?? [];
    const days = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(year, false, false, false, regionLabels);
    const loadableTextList = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "special export"
    });
    console.log(loadableTextList);
    if (loadableTextList.state === "loaded") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Done"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
};


const $26972581ee59c8d3$export$cd9dd5b0786808e2 = [
    {
        lines: [
            [
                "BLESSED is the man that hath not walked in the counsel of the ungodly, nor stood in the way of sinners",
                "and hath not sat in the seat of the scornful."
            ],
            [
                "But his delight is in the law of the Lord",
                "and in his law will he exercise himself day and night."
            ],
            [
                "And he shall be like a tree planted by the waterside",
                "that will bring forth his fruit in due season."
            ],
            [
                "His leaf also shall not wither",
                "and look, whatsoever he doeth, it shall prosper."
            ],
            [
                "As for the ungodly, it is not so with them",
                "but they are like the chaff, which the wind scattereth away from the face of the earth."
            ],
            [
                "Therefore the ungodly shall not be able to stand in the judgement",
                "neither the sinners in the congregation of the righteous."
            ],
            [
                "But the Lord knoweth the way of the righteous",
                "and the way of the ungodly shall perish."
            ]
        ],
        id: "psalm1"
    },
    {
        lines: [
            [
                "WHY do the heathen so furiously rage together",
                "and why do the people imagine a vain thing?"
            ],
            [
                "The kings of the earth stand up, and the rulers take counsel together",
                "against the Lord, and against his Anointed."
            ],
            [
                "Let us break their bonds asunder",
                "and cast away their cords from us."
            ],
            [
                "He that dwelleth in heaven shall laugh them to scorn",
                "the Lord shall have them in derision."
            ],
            [
                "Then shall he speak unto them in his wrath",
                "and vex them in his sore displeasure."
            ],
            [
                "Yet have I set my King",
                "upon my holy hill of Sion."
            ],
            [
                "I will preach the law, whereof the Lord hath said unto me",
                "Thou art my Son, this day have I begotten thee."
            ],
            [
                "Desire of me, and I shall give thee the heathen for thine inheritance",
                "and the utmost parts of the earth for thy possession."
            ],
            [
                "Thou shalt bruise them with a rod of iron",
                "and break them in pieces like a potter's vessel."
            ],
            [
                "Be wise now therefore, O ye kings",
                "be learned, ye that are judges of the earth."
            ],
            [
                "Serve the Lord in fear",
                "and rejoice unto him with reverence."
            ],
            [
                "Kiss the Son, lest he be angry, and so ye perish from the right way",
                "if his wrath be kindled, (yea, but a little,) blessed are all they that put their trust in him."
            ]
        ],
        id: "psalm2"
    },
    {
        lines: [
            [
                "LORD, how are they increased that trouble me",
                "many are they that rise against me."
            ],
            [
                "Many one there be that say of my soul",
                "There is no help for him in his God."
            ],
            [
                "But thou, O Lord, art my defender",
                "thou art my worship, and the lifter up of my head."
            ],
            [
                "I did call upon the Lord with my voice",
                "and he heard me out of his holy hill."
            ],
            [
                "I laid me down and slept, and rose up again",
                "for the Lord sustained me."
            ],
            [
                "I will not be afraid for ten thousands of the people",
                "that have set themselves against me round about."
            ],
            [
                "Up, Lord, and help me, O my God",
                "for thou smitest all mine enemies upon the cheekbone; thou hast broken the teeth of the ungodly."
            ],
            [
                "Salvation belongeth unto the Lord",
                "and thy blessing is upon thy people."
            ]
        ],
        id: "psalm3"
    },
    {
        lines: [
            [
                "HEAR me when I call, O God of my righteousness",
                "thou hast set me at liberty when I was in trouble; have mercy upon me, and hearken unto my prayer."
            ],
            [
                "O ye sons of men, how long will ye blaspheme mine honour",
                "and have such pleasure in vanity, and seek after leasing?"
            ],
            [
                "Know this also, that the Lord hath chosen to himself the man that is godly",
                "when I call upon the Lord, he will hear me."
            ],
            [
                "Stand in awe, and sin not",
                "commune with your own heart, and in your chamber, and be still."
            ],
            [
                "Offer the sacrifice of righteousness",
                "and put your trust in the Lord."
            ],
            [
                "There be many that say",
                "Who will shew us any good?"
            ],
            [
                "Lord, lift thou up",
                "the light of thy countenance upon us."
            ],
            [
                "Thou hast put gladness in my heart",
                "since the time that their corn and wine and oil increased."
            ],
            [
                "I will lay me down in peace, and take my rest",
                "for it is thou, Lord, only, that makest me dwell in safety."
            ]
        ],
        id: "psalm4"
    },
    {
        lines: [
            [
                "PONDER my words, O Lord",
                "consider my meditation"
            ],
            [
                "O hearken thou unto the voice of my calling, my King, and my God",
                "for unto thee will I make my prayer."
            ],
            [
                "My voice shalt thou hear betimes, O Lord",
                "early in the morning will I direct my prayer unto thee, and will look up."
            ],
            [
                "For thou art the God that hast no pleasure in wickedness",
                "neither shall any evil dwell with thee."
            ],
            [
                "Such as be foolish shall not stand in thy sight",
                "for thou hatest all them that work vanity."
            ],
            [
                "Thou shalt destroy them that speak leasing",
                "the Lord will abhor both the blood thirsty and deceitful man."
            ],
            [
                "But as for me, I will come into thine house, even upon the multitude of thy mercy",
                "and in thy fear will I worship toward thy holy temple."
            ],
            [
                "Lead me, O Lord, in thy righteousness, because of mine enemies",
                "make thy way plain before my face."
            ],
            [
                "For there is no faithfulness in his mouth",
                "their inward parts are very wickedness."
            ],
            [
                "Their throat is an open sepulchre",
                "they flatter with their tongue."
            ],
            [
                "Destroy thou them, O God; let them perish through their own imaginations",
                "cast them out in the multitude of their ungodliness; for they have rebelled against thee."
            ],
            [
                "And let all them that put their trust in thee rejoice",
                "they shall ever be giving of thanks, because thou defendest them; they that love thy Name shall be joyful in thee;"
            ],
            [
                "For thou, Lord, wilt give thy blessing unto the righteous",
                "and with thy favourable kindness wilt thou defend him as with a shield."
            ]
        ],
        id: "psalm5"
    },
    {
        lines: [
            [
                "O LORD, rebuke me not in thine indignation",
                "neither chasten me in thy displeasure."
            ],
            [
                "Have mercy upon me, O Lord, for I am weak",
                "O Lord, heal me, for my bones are vexed."
            ],
            [
                "My soul also is sore troubled",
                "but, Lord, how long wilt thou punish me?"
            ],
            [
                "Turn thee, O Lord, and deliver my soul",
                "O save me for thy mercy's sake."
            ],
            [
                "For in death no man remembereth thee",
                "and who will give thee thanks in the pit?"
            ],
            [
                "I am weary of my groaning; every night wash I my bed",
                "and water my couch with my tears."
            ],
            [
                "My beauty is gone for very trouble",
                "and worn away because of all mine enemies."
            ],
            [
                "Away from me, all ye that work vanity",
                "for the Lord hath heard the voice of my weeping."
            ],
            [
                "The Lord hath heard my petition",
                "the Lord will receive my prayer."
            ],
            [
                "All mine enemies shall be confounded, and sore vexed",
                "they shall be turned back, and put to shame suddenly."
            ]
        ],
        id: "psalm6"
    },
    {
        lines: [
            [
                "O LORD my God, in thee have I put my trust",
                "save me from all them that persecute me, and deliver me;"
            ],
            [
                "Lest he devour my soul, like a lion, and tear it in pieces",
                "while there is none to help."
            ],
            [
                "O Lord my God, if I have done any such thing",
                "or if there be any wickedness in my hands;"
            ],
            [
                "If I have rewarded evil unto him that dealt friendly with me",
                "yea, I have delivered him that without any cause is mine enemy,"
            ],
            [
                "Then let mine enemy persecute my soul, and take me",
                "yea, let him tread my life down upon the earth, and lay mine honour in the dust."
            ],
            [
                "Stand up, O Lord, in thy wrath, and lift up thyself, because of the indignation of mine enemies",
                "arise up for me in the judgement that thou hast commanded."
            ],
            [
                "And so shall the congregation of the people come about thee",
                "for their sakes therefore lift up thyself again."
            ],
            [
                "The Lord shall judge the people; give sentence with me, O Lord",
                "according to my righteousness, and according to the innocency that is in me."
            ],
            [
                "O let the wickedness of the ungodly come to an end",
                "but guide thou the just."
            ],
            [
                "For the righteous God",
                "trieth the very hearts and reins."
            ],
            [
                "My help cometh of God",
                "who preserveth them that are true of heart."
            ],
            [
                "God is a righteous Judge, strong and patient",
                "and God is provoked ev'ry day."
            ],
            [
                "If a man will not turn, he will whet his sword",
                "he hath bent his bow, and made it ready."
            ],
            [
                "He hath prepared for him the instruments of death",
                "he ordaineth his arrows against the persecutors"
            ],
            [
                "Behold, he travaileth with mischief",
                "he hath conceived sorrow, and brought forth ungodliness."
            ],
            [
                "He hath graven and digged up a pit",
                "and is fallen on himself into the destruction that he made for other."
            ],
            [
                "For his travail shall come upon his own head",
                "and his wickedness shall fall on his own pate."
            ],
            [
                "I will give thanks unto the Lord, according to his righteousness",
                "and I will praise the Name of the Lord most High."
            ]
        ],
        id: "psalm7"
    },
    {
        lines: [
            [
                "O LORD our Governor, how excellent is thy Name in all the world",
                "thou that hast set thy glory above the heavens!"
            ],
            [
                "Out of the mouth of very babes and sucklings hast thou ordained strength, because of thine enemies",
                "that thou mightest still the enemy and the avenger."
            ],
            [
                "For I will consider thy heavens, even the works of thy fingers",
                "the moon and the stars, which thou hast ordained."
            ],
            [
                "What is man, that thou art mindful of him",
                "and the son of man, that thou visitest him?"
            ],
            [
                "Thou madest him lower than the angels",
                "to crown him with glory and worship."
            ],
            [
                "Thou makest him to have dominion of the works of thy hands",
                "and thou hast put all things in subjection under his feet;"
            ],
            [
                "All sheep and oxen",
                "yea, and the beasts of the field;"
            ],
            [
                "The fowls of the air, and the fishes of the sea",
                "and whatsoever walketh through the paths of the seas."
            ],
            [
                "O Lord our Governour",
                "how excellent is thy Name in all the world!"
            ]
        ],
        id: "psalm8"
    },
    {
        lines: [
            [
                "I WILL give thanks unto thee, O Lord, with my whole heart",
                "I will speak of all thy marvellous works."
            ],
            [
                "I will be glad and rejoice in thee",
                "yea, my songs will I make of thy Name, O thou most Highest."
            ],
            [
                "While mine enemies are driven back",
                "they shall fall and perish at thy presence."
            ],
            [
                "For thou hast maintained my right and my cause",
                "thou art set in the throne that judgest right."
            ],
            [
                "Thou hast rebuked the heathen, and destroyed the ungodly",
                "thou hast put out their name for ever and ever."
            ],
            [
                "O thou enemy, destructions are come to a perpetual end",
                "even as the cities which thou hast destroyed, their memorial is perished with them."
            ],
            [
                "But the Lord shall endure for ever",
                "he hath also prepared his seat for judgement."
            ],
            [
                "For he shall judge the world in righteousness",
                "and minister true judgement unto the people."
            ],
            [
                "The Lord also will be a defence for the oppressed",
                "even a refuge in due time of trouble."
            ],
            [
                "And they that know thy Name will put their trust in thee",
                "for thou, Lord, hast never failed them that seek thee."
            ],
            [
                "O praise the Lord which dwelleth in Sion",
                "shew the people of his doings."
            ],
            [
                "For when he maketh inquisition for blood, he remembereth them",
                "and forgetteth not the complaint of the poor."
            ],
            [
                "Have mercy upon me, O Lord; consider the trouble which I suffer of them that hate me",
                "thou that liftest me up from the gates of death."
            ],
            [
                "That I may shew all thy praises within the ports of the daughter of Sion",
                "I will rejoice in thy salvation."
            ],
            [
                "The heathen are sunk down in the pit that they made",
                "in the same net which they hid privily, is their foot taken."
            ],
            [
                "The Lord is known to execute judgement",
                "the ungodly is trapped in the work of his own hands."
            ],
            [
                "The wicked shall be turned into hell",
                "and all the people that forget God."
            ],
            [
                "For the poor shall not alway be forgotten",
                "the patient abiding of the meek shall not perish for ever."
            ],
            [
                "Up, Lord, and let not man have the upper hand",
                "let the heathen be judged in thy sight."
            ],
            [
                "Put them in fear, O Lord",
                "that the heathen may know themselves to be but men."
            ]
        ],
        id: "psalm9"
    },
    {
        lines: [
            [
                "WHY standest thou so far off, O Lord",
                "and hidest thy face in the needful time of trouble?"
            ],
            [
                "The ungodly for his own lust doth persecute the poor",
                "let them be taken in the crafty wiliness that they have imagined."
            ],
            [
                "For the ungodly hath made boast of his own heart's desire",
                "and speaketh good of the covetous, whom God abhorreth."
            ],
            [
                "The ungodly is so proud, that he careth not for God",
                "neither is God in all his thoughts."
            ],
            [
                "His ways are alway grievous",
                "thy judgements are far above out of his sight, and therefore defieth he all his enemies."
            ],
            [
                "For he hath said in his heart, Tush, I shall never be cast down",
                "there shall no harm happen unto me."
            ],
            [
                "His mouth is full of cursing, deceit, and fraud",
                "under his tongue is ungodliness and vanity."
            ],
            [
                "He sitteth lurking in the thievish corners of the streets",
                "and privily in his lurking dens doth he murder the innocent; his eyes are set against the poor."
            ],
            [
                "For he lieth waiting secretly, even as a lion lurketh he in his den",
                "that he may ravish the poor."
            ],
            [
                "He doth ravish the poor",
                "when he getteth him into his net."
            ],
            [
                "He falleth down, and humbleth himself",
                "that the congregation of the poor may fall into the hands of his captains."
            ],
            [
                "He hath said in his heart, Tush, God hath forgotten",
                "he hideth away his face, and he will never see it."
            ],
            [
                "Arise, O Lord God, and lift up thine hand",
                "forget not the poor."
            ],
            [
                "Wherefore should the wicked blaspheme God",
                "while he doth say in his heart, Tush, thou God carest not for it."
            ],
            [
                "Surely thou hast seen it",
                "for thou beholdest ungodliness and wrong."
            ],
            [
                "That thou mayest take the matter into thy hand",
                "the poor committeth himself unto thee; for thou art the helper of the friendless."
            ],
            [
                "Break thou the power of the ungodly and malicious",
                "take away his ungodliness, and thou shalt find none."
            ],
            [
                "The Lord is King for ever and ever",
                "and the heathen are perished out of the land."
            ],
            [
                "Lord, thou hast heard the desire of the poor",
                "thou preparest their heart, and thine ear hearkeneth thereto;"
            ],
            [
                "To help the fatherless and poor unto their right",
                "that the man of the earth be no more exalted against them."
            ]
        ],
        id: "psalm10"
    },
    {
        lines: [
            [
                "IN THE Lord put I my trust",
                "how say ye then to my soul, that she should flee as a bird unto the hill?"
            ],
            [
                "For lo, the ungodly bend their bow, and make ready their arrows within the quiver",
                "that they may privily shoot at them which are true of heart."
            ],
            [
                "For the foundations will be cast down",
                "and what hath the righteous done?"
            ],
            [
                "The Lord is in his holy temple",
                "the Lord's seat is in heaven."
            ],
            [
                "His eyes consider the poor",
                "and his eye lids try the children of men."
            ],
            [
                "The Lord alloweth the righteous",
                "but the ungodly, and him that delighteth in wickedness, doth his soul abhor."
            ],
            [
                "Upon the ungodly he shall rain snares, fire and brimstone, storm and tempest",
                "this shall be their portion to drink."
            ],
            [
                "For the righteous Lord loveth righteousness",
                "his countenance will behold the thing that is just."
            ]
        ],
        id: "psalm11"
    },
    {
        lines: [
            [
                "HELP me, Lord, for there is not one godly man left",
                "for the faithful are minished from among the children of men,"
            ],
            [
                "They talk of vanity every one with his neighbour",
                "they do but flatter with their lips, and dissemble in their double heart."
            ],
            [
                "The Lord shall root out all deceitful lips",
                "and the tongue that speaketh proud things;"
            ],
            [
                "Which have said, With our tongue will we prevail",
                "we are they that ought to speak, who is lord over us?"
            ],
            [
                "Now for the comfortless trouble's sake of the needy",
                "and because of the deep sighing of the poor,"
            ],
            [
                "I will up, saith the Lord",
                "and will help every one from him that swelleth against him, and will set him at rest."
            ],
            [
                "The words of the Lord are pure words",
                "even as the silver, which from the earth is tried, and purified seven times in the fire."
            ],
            [
                "Thou shalt keep them, O Lord",
                "thou shalt preserve him from this generation for ever."
            ],
            [
                "The ungodly walk on every side",
                "when they are exalted, the children of men are put to rebuke."
            ]
        ],
        id: "psalm12"
    },
    {
        lines: [
            [
                "HOW long wilt thou forget me, O Lord, for ever",
                "how long wilt thou hide thy face from me?"
            ],
            [
                "How long shall I seek counsel in my soul, and be so vexed in my heart",
                "how long shall mine enemies triumph over me?"
            ],
            [
                "Consider, and hear me, O Lord my God",
                "lighten mine eyes, that I sleep not in death."
            ],
            [
                "Lest mine enemy say, I have prevailed against him",
                "for if I be cast down, they that trouble me will rejoice at it."
            ],
            [
                "But my trust is in thy mercy",
                "and my heart is joyful in thy salvation."
            ],
            [
                "I will sing of the Lord, because he hath dealt so lovingly with me",
                "yea, I will praise the Name of the Lord most Highest."
            ]
        ],
        id: "psalm13"
    },
    {
        lines: [
            [
                "THE fool hath said in his heart",
                "There is no God."
            ],
            [
                "They are corrupt, and become abominable in their doings",
                "there is none that doeth good, no not one."
            ],
            [
                "The Lord looked down from heaven upon the children of men",
                "to see if there were any that would understand, and seek after God."
            ],
            [
                "But they are all gone out of the way, they are altogether become abominable",
                "there is none that doeth good, no not one."
            ],
            [
                "Their throat is an open sepulchre, with their tongues have they deceived",
                "the poison of asps is under their lips."
            ],
            [
                "Their mouth is full of cursing and bitterness",
                "their feet are swift to shed blood."
            ],
            [
                "Destruction and unhappiness is in their ways, and the way of peace have they not known",
                "there is no fear of God before their eyes."
            ],
            [
                "Have they no knowledge, that they are all such workers of mischief",
                "eating up my people as it were bread, and call not upon the Lord?"
            ],
            [
                "There were they brought in great fear, even where no fear was",
                "for God is in the generation of the righteous."
            ],
            [
                "As for you, ye have made a mock at the counsel of the poor",
                "because he putteth his trust in the Lord."
            ],
            [
                "Who shall give salvation unto Israel out of Sion? When the Lord turneth the captivity of his people",
                "then shall Jacob rejoice, and Israel shall be glad."
            ]
        ],
        id: "psalm14"
    },
    {
        lines: [
            [
                "LORD, who shall dwell in thy tabernacle",
                "or who shall rest upon thy holy hill?"
            ],
            [
                "Even he that leadeth an uncorrupt life",
                "and doeth the thing which is right, and speaketh the truth from his heart."
            ],
            [
                "He that hath used no deceit in his tongue, nor done evil to his neighbour",
                "and hath not slandered his neighbour."
            ],
            [
                "He that setteth not by himself, but is lowly in his own eyes",
                "and maketh much of them that fear the Lord."
            ],
            [
                "He that sweareth unto his neighbour, and disappointeth him not",
                "though it were to his own hindrance."
            ],
            [
                "He that hath not given his money upon usury",
                "nor taken reward against the innocent."
            ],
            [
                "Whoso doeth these things",
                "shall never fall."
            ]
        ],
        id: "psalm15"
    },
    {
        lines: [
            [
                "PRESERVE me, O God",
                "for in thee have I put my trust."
            ],
            [
                "O my soul, thou hast said unto the Lord",
                "Thou art my God, my goods are nothing unto thee."
            ],
            [
                "All my delight is upon the saints, that are in the earth",
                "and upon such as excel in virtue."
            ],
            [
                "But they that run after another god",
                "shall have great trouble."
            ],
            [
                "Their drink offerings of blood will I not offer",
                "neither make mention of their names within my lips."
            ],
            [
                "The Lord himself is the portion of mine inheritance, and of my cup",
                "thou shalt maintain my lot."
            ],
            [
                "The lot is fallen unto me in a fair ground",
                "yea, I have a goodly heritage."
            ],
            [
                "I will thank the Lord for giving me warning",
                "my reins also chasten me in the night season."
            ],
            [
                "I have set God always before me",
                "for he is on my right hand, therefore I shall not fall."
            ],
            [
                "Wherefore my heart was glad, and my glory rejoiced",
                "my flesh also shall rest in hope."
            ],
            [
                "For why? thou shalt not leave my soul in hell",
                "neither shalt thou suffer thy Holy One to see corruption."
            ],
            [
                "Thou shalt shew me the path of life; in thy presence is the fulness of joy",
                "and at thy right hand there is pleasure for evermore."
            ]
        ],
        id: "psalm16"
    },
    {
        lines: [
            [
                "HEAR the right, O Lord, consider my complaint",
                "and hearken unto my prayer, that goeth not out of feigned lips."
            ],
            [
                "Let my sentence come forth from thy presence",
                "and let thine eyes look upon the thing that is equal."
            ],
            [
                "Thou hast proved and visited mine heart in the night season; thou hast tried me, and shalt find no wickedness in me",
                "for I am utterly purposed that my mouth shall not offend."
            ],
            [
                "Because of men's works, that are done against the words of thy lips",
                "I have kept me from the ways of the destroyer."
            ],
            [
                "O hold thou up my goings in thy paths",
                "that my footsteps slip not."
            ],
            [
                "I have called upon thee, O God, for thou shalt hear me",
                "incline thine ear to me, and hearken unto my words."
            ],
            [
                "Shew thy marvellous loving kindness, thou that art the Saviour of them which put their trust in thee",
                "from such as resist thy right hand."
            ],
            [
                "Keep me as the apple of an eye",
                "hide me under the shadow of thy wings."
            ],
            [
                "From the ungodly that trouble me",
                "mine enemies compass me round about to take away my soul."
            ],
            [
                "They are inclosed in their own fat",
                "and their mouth speaketh proud things."
            ],
            [
                "They lie waiting in our way on every side",
                "turning their eyes down to the ground."
            ],
            [
                "Like as a lion that is greedy of his prey",
                "and as it were a lion's whelp, lurking in secret places."
            ],
            [
                "Up, Lord, disappoint him, and cast him down",
                "deliver my soul from the ungodly, which is a sword of thine;"
            ],
            [
                "From the men of thy hand, O Lord, from the men, I say, and from the evil world",
                "which have their portion in this life, whose bellies thou fillest with thy hid treasure."
            ],
            [
                "They have children at their desire",
                "and leave the rest of their substance for their babes."
            ],
            [
                "But as for me, I will behold thy presence in righteousness",
                "and when I awake up after thy likeness, I shall be satisfied with it."
            ]
        ],
        id: "psalm17"
    },
    {
        lines: [
            [
                "I WILL love thee, O Lord, my strength; the Lord is my stony rock, and my defence",
                "my saviour, my God, and my might, in whom I will trust, my buckler, the horn also of my salvation, and my refuge."
            ],
            [
                "I will call upon the Lord, which is worthy to be praised",
                "so shall I be safe from mine enemies."
            ],
            [
                "The sorrows of death compassed me",
                "and the overflowings of ungodliness made me afraid."
            ],
            [
                "The pains of hell came about me",
                "the snares of death overtook me."
            ],
            [
                "In my trouble I will call upon the Lord",
                "and complain unto my God."
            ],
            [
                "So shall he hear my voice out of his holy temple",
                "and my complaint shall come before him, it shall enter even into his ears."
            ],
            [
                "The earth trembled and quaked",
                "the very foundations also of the hills shook, and were removed, because he was wroth."
            ],
            [
                "There went a smoke out in his presence",
                "and a consuming fire out of his mouth, so that coals were kindled at it."
            ],
            [
                "He bowed the heavens also, and came down",
                "and it was dark under his feet."
            ],
            [
                "He rode upon the cherubins, and did fly",
                "he came flying upon the wings of the wind."
            ],
            [
                "He made darkness his secret place",
                "his pavilion round about him, with dark water and thick clouds to cover him."
            ],
            [
                "At the brightness of his presence his clouds removed",
                "hail stones, and coals of fire."
            ],
            [
                "The Lord also thundered out of heaven, and the Highest gave his thunder",
                "hail stones, and coals of fire."
            ],
            [
                "He sent out his arrows, and scattered them",
                "he cast forth lightnings, and destroyed them."
            ],
            [
                "The springs of water were seen, and the foundations of the round world were discovered, at thy chiding, O Lord",
                "at the blasting of the breath of thy displeasure."
            ],
            [
                "He shall send down from on high to fetch me",
                "and shall take me out of many waters."
            ],
            [
                "He shall deliver me from my strongest enemy, and from them which hate me",
                "for they are too mighty for me."
            ],
            [
                "They prevented me in the day of my trouble",
                "but the Lord was my upholder."
            ],
            [
                "He brought me forth also into a place of liberty",
                "he brought me forth, even because he had a favour unto me."
            ],
            [
                "The Lord shall reward me after my righteous dealing",
                "according to the cleanness of my hands shall he recompense me."
            ],
            [
                "Because I have kept the ways of the Lord",
                "and have not forsaken my God, as the wicked doth."
            ],
            [
                "For I have an eye unto all his laws",
                "and will not cast out his commandments from me."
            ],
            [
                "I was also uncorrupt before him",
                "and eschewed mine own wickedness."
            ],
            [
                "Therefore shall the Lord reward me after my righteous dealing",
                "and according unto the cleanness of my hands in his eye sight."
            ],
            [
                "With the holy thou shalt be holy",
                "and with a perfect man thou shalt be perfect."
            ],
            [
                "With the clean thou shalt be clean",
                "and with the froward thou shalt learn frowardness."
            ],
            [
                "For thou shalt save the people that are in adversity",
                "and shalt bring down the high looks of the proud."
            ],
            [
                "Thou also shalt light my candle",
                "the Lord my God shall make my darkness to be light."
            ],
            [
                "For in thee I shall discomfit an host of men",
                "and with the help of my God I shall leap over the wall."
            ],
            [
                "The way of God is an undefiled way",
                "the word of the Lord also is tried in the fire; he is the defender of all them that put their trust in him."
            ],
            [
                "For who is God, but the Lord",
                "or who hath any strength, except our God?"
            ],
            [
                "It is God, that girdeth me with strength of war",
                "and maketh my way perfect."
            ],
            [
                "He maketh my feet like harts' feet",
                "and setteth me up on high."
            ],
            [
                "He teacheth mine hands to fight",
                "and mine arms shall break even a bow of steel."
            ],
            [
                "Thou hast given me the defence of thy salvation",
                "thy right hand also shall hold me up, and thy loving correction shall make me great."
            ],
            [
                "Thou shalt make room enough under me for to go",
                "that my footsteps shall not slide."
            ],
            [
                "I will follow upon mine enemies, and overtake them",
                "neither will I turn again till I have destroyed them."
            ],
            [
                "I will smite them, that they shall not be able to stand",
                "but fall under my feet."
            ],
            [
                "Thou hast girded me with strength unto the battle",
                "thou shalt throw down mine enemies under me."
            ],
            [
                "Thou hast made mine enemies also to turn their backs upon me",
                "and I shall destroy them that hate me."
            ],
            [
                "They shall cry, but there shall be none to help them",
                "yea, even unto the Lord shall they cry, but he shall not hear them."
            ],
            [
                "I will beat them as small as the dust before the wind",
                "I will cast them out as the clay in the streets."
            ],
            [
                "Thou shalt deliver me from the strivings of the people",
                "and thou shalt make me the head of the heathen."
            ],
            [
                "A people whom I have not known",
                "shall serve me."
            ],
            [
                "As soon as they hear of me, they shall obey me",
                "but the strange children shall dissemble with me."
            ],
            [
                "The strange children shall fail",
                "and be afraid out of their prisons."
            ],
            [
                "The Lord liveth, and blessed be my strong helper",
                "and praised be the Lord of my salvation;"
            ],
            [
                "Even the God that seeth that I be avenged",
                "and subdueth the people unto me."
            ],
            [
                "It is he that delivereth me from my cruel enemies, and setteth me up above mine adversaries",
                "thou shalt rid me from the wicked man."
            ],
            [
                "For this cause will I give thanks unto thee, O Lord, among the Gentiles",
                "and sing praises unto thy Name."
            ],
            [
                "Great prosperity giveth he unto his King",
                "and sheweth loving kindness unto David his Anointed, and unto his seed for evermore."
            ]
        ],
        id: "psalm18"
    },
    {
        lines: [
            [
                "THE heavens declare the glory of God",
                "and the firmament sheweth his handywork."
            ],
            [
                "One day telleth another",
                "and one night certifieth another."
            ],
            [
                "There is neither speech nor language",
                "but their voices are heard among them."
            ],
            [
                "Their sound is gone out into all lands",
                "and their words into the ends of the world."
            ],
            [
                "In them hath he set a tabernacle for the sun",
                "which cometh forth as a bridegroom out of his chamber, and rejoiceth as a giant to run his course."
            ],
            [
                "It goeth forth from the uttermost part of the heaven, and runneth about unto the end of it again",
                "and there is nothing hid from the heat thereof."
            ],
            [
                "The law of the Lord is an undefiled law, converting the soul",
                "the testimony of the Lord is sure, and giveth wisdom unto the simple."
            ],
            [
                "The statutes of the Lord are right, and rejoice the heart",
                "the commandment of the Lord is pure, and giveth light unto the eyes."
            ],
            [
                "The fear of the Lord is clean, and endureth for ever",
                "the judgements of the Lord are true, and righteous altogether."
            ],
            [
                "More to be desired are they than gold, yea, than much fine gold",
                "sweeter also than honey, and the honey comb."
            ],
            [
                "Moreover, by them is thy servant taught",
                "and in keeping of them there is great reward."
            ],
            [
                "Who can tell how oft he offendeth",
                "O cleanse thou me from my secret faults."
            ],
            [
                "Keep thy servant also from presumptuous sins, lest they get the dominion over me",
                "so shall I be undefiled, and innocent from the great offence."
            ],
            [
                "Let the words of my mouth, and the meditation of my heart",
                "be alway acceptable in thy sight,"
            ],
            [
                "O Lord",
                "my strength, and my redeemer."
            ]
        ],
        id: "psalm19"
    },
    {
        lines: [
            [
                "THE Lord hear thee in the day of trouble",
                "the Name of the God of Jacob defend thee;"
            ],
            [
                "Send thee help from the sanctuary",
                "and strengthen thee out of Sion;"
            ],
            [
                "Remember all thy offerings",
                "and accept thy burnt sacrifice;"
            ],
            [
                "Grant thee thy heart's desire",
                "and fulfil all thy mind."
            ],
            [
                "We will rejoice in thy salvation, and triumph in the Name of the Lord our God",
                "the Lord perform all thy petitions."
            ],
            [
                "Now know I that the Lord helpeth his Anointed, and will hear him from his holy heaven",
                "even with the wholesome strength of his right hand."
            ],
            [
                "Some put their trust in chariots, and some in horses",
                "but we will remember the Name of the Lord our God."
            ],
            [
                "They are brought down, and fallen",
                "but we are risen, and stand upright."
            ],
            [
                "Save, Lord, and hear us, O King of heaven",
                "when we call upon thee."
            ]
        ],
        id: "psalm20"
    },
    {
        lines: [
            [
                "THE King shall rejoice in thy strength, O Lord",
                "exceeding glad shall he be of thy salvation."
            ],
            [
                "Thou hast given him his heart's desire",
                "and hast not denied him the request of his lips."
            ],
            [
                "For thou shalt prevent him with the blessings of goodness",
                "and shalt set a crown of pure gold upon his head."
            ],
            [
                "He asked life of thee, and thou gavest him a long life",
                "even for ever and ever."
            ],
            [
                "His honour is great in thy salvation",
                "glory and great worship shalt thou lay upon him."
            ],
            [
                "For thou shalt give him everlasting felicity",
                "and make him glad with the joy of thy countenance."
            ],
            [
                "And why? because the King putteth his trust in the Lord",
                "and in the mercy of the most Highest he shall not miscarry."
            ],
            [
                "All thine enemies shall feel thine hand",
                "thy right hand shall find out them that hate thee."
            ],
            [
                "Thou shalt make them like a fiery oven in time of thy wrath",
                "the Lord shall destroy them in his displeasure, and the fire shall consume them."
            ],
            [
                "Their fruit shalt thou root out of the earth",
                "and their seed from among the children of men."
            ],
            [
                "For they intended mischief against thee",
                "and imagined such a device as they are not able to perform."
            ],
            [
                "Therefore shalt thou put them to flight",
                "and the strings of thy bow shalt thou make ready against the face of them."
            ],
            [
                "Be thou exalted, Lord, in thine own strength",
                "so we will sing, and praise thy power."
            ]
        ],
        id: "psalm21"
    },
    {
        lines: [
            [
                "MY GOD, my God, look upon me; why hast thou forsaken me",
                "and art so far from my health, and from the words of my complaint?"
            ],
            [
                "O my God, I cry in the day time, but thou hearest not",
                "and in the night season also I take no rest."
            ],
            [
                "And thou continuest holy",
                "O thou worship of Israel."
            ],
            [
                "Our fathers hoped in thee",
                "they trusted in thee, and thou didst deliver them."
            ],
            [
                "They called upon thee, and were holpen",
                "they put their trust in thee, and were not confounded."
            ],
            [
                "But as for me, I am a worm, and no man",
                "a very scorn of men, and the outcast of the people."
            ],
            [
                "All they that see me laugh me to scorn",
                "they shoot our their lips, and shake their heads, saying,"
            ],
            [
                "He trusted in God, that he would deliver him",
                "let him deliver him, if he will have him."
            ],
            [
                "But thou art he that took me out of my mother's womb",
                "thou wast my hope, when I hanged yet upon my mother's breasts."
            ],
            [
                "I have been left unto thee ever since I was born",
                "thou art my God, even from my mother's womb."
            ],
            [
                "O go not from me, for trouble is hard at hand",
                "and there is none to help me."
            ],
            [
                "Many oxen are come about me",
                "fat bulls of Basan close me in on ev'ry side."
            ],
            [
                "They gape upon me with their mouths",
                "as it were a ramping and a roaring lion."
            ],
            [
                "I am poured out like water, and all my bones are out of joint",
                "my heart also in the midst of my body is even like melting wax."
            ],
            [
                "My strength is dried up like a potsherd, and my tongue cleaveth to my gums",
                "and thou shalt bring me into the dust of death."
            ],
            [
                "For many dogs are come about me",
                "and the council of the wicked layeth siege against me."
            ],
            [
                "They pierced my hands and my feet; I may tell all my bones",
                "they stand staring and looking upon me."
            ],
            [
                "They part my garments among them",
                "and casts lots upon my vesture."
            ],
            [
                "But be not thou far from me, O Lord",
                "thou art my succour, haste thee to help me."
            ],
            [
                "Deliver my soul from the sword",
                "my darling from the power of the dog."
            ],
            [
                "Save me from the lion's mouth",
                "thou hast heard me also from among the horns of the unicorns."
            ],
            [
                "I will declare thy Name unto my brethren",
                "in the midst of the congregation will I praise thee."
            ],
            [
                "O praise the Lord, ye that fear him",
                "magnify him, all ye of the seed of Jacob, and fear him, all ye seed of Israel."
            ],
            [
                "For he hath not despised, nor abhorred, the low estate of the poor",
                "he hath not hid his face from him, but when he called unto him he heard him."
            ],
            [
                "My praise is of thee in the great congregation",
                "my vows will I perform in the sight of them that fear him."
            ],
            [
                "The poor shall eat and be satisfied",
                "they that seek after the Lord shall praise him; your heart shall live for ever."
            ],
            [
                "All the ends of the world shall remember themselves, and be turned unto the Lord",
                "and all the kindreds of the nations shall worship before him."
            ],
            [
                "For the kingdom is the Lord's",
                "and he is the Governor among the people."
            ],
            [
                "All such as be fat upon earth",
                "have eaten and worshipped."
            ],
            [
                "All they that go down into the dust shall kneel before him",
                "and no man hath quickened his own soul."
            ],
            [
                "My seed shall serve him",
                "they shall be counted unto the Lord for a generation."
            ],
            [
                "They shall come, and the heavens shall declare his righteousness",
                "unto a people that shall be born, whom the Lord hath made."
            ]
        ],
        id: "psalm22"
    },
    {
        lines: [
            [
                "THE Lord is my shepherd",
                "therefore can I lack nothing."
            ],
            [
                "He shall feed me in a green pasture",
                "and lead me forth beside the waters of comfort."
            ],
            [
                "He shall convert my soul",
                "and bring me forth in the paths of righteousness, for his Name's sake."
            ],
            [
                "Yea, though I walk through the valley of the shadow of death, I will fear no evil",
                "for thou art with me; thy rod and thy staff comfort me."
            ],
            [
                "Thou shalt prepare a table before me against them that trouble me",
                "thou hast anointed my head with oil, and my cup shall be full."
            ],
            [
                "But thy loving kindness and mercy shall follow me all the days of my life",
                "and I will dwell in the house of the Lord for ever."
            ]
        ],
        id: "psalm23"
    },
    {
        lines: [
            [
                "THE earth is the Lord's, and all that therein is",
                "the compass of the world, and they that dwell therein."
            ],
            [
                "For he hath founded it upon the seas",
                "and prepared it upon the floods."
            ],
            [
                "Who shall ascend into the hill of the Lord",
                "or who shall rise up in his holy place?"
            ],
            [
                "Even he that hath clean hands, and a pure heart",
                "and that hath not lift up his mind unto vanity, nor sworn to deceive his neighbour."
            ],
            [
                "He shall receive the blessing from the Lord",
                "and righteousness from the God of his salvation."
            ],
            [
                "This is the generation of them that seek him",
                "even of them that seek thy face, O Jacob."
            ],
            [
                "Lift up your heads, O ye gates, and be ye lift up, ye everlasting doors",
                "and the King of glory shall come in."
            ],
            [
                "Who is the King of glory",
                "it is the Lord strong and mighty, even the Lord mighty in battle."
            ],
            [
                "Lift up your heads, O ye gates, and be ye lift up, ye everlasting doors",
                "and the King of glory shall come in."
            ],
            [
                "Who is the King of glory",
                "even the Lord of hosts, he is the King of glory."
            ]
        ],
        id: "psalm24"
    },
    {
        lines: [
            [
                "UNTO thee, O Lord, will I lift up my soul; my God, I have put my trust in thee",
                "O let me not be confounded, neither let mine enemies triumph over me."
            ],
            [
                "For all they that hope in thee shall not be ashamed",
                "but such as transgress without a cause shall be put to confusion."
            ],
            [
                "Shew me thy ways, O Lord",
                "and teach me thy paths."
            ],
            [
                "Lead me forth in thy truth, and learn me",
                "for thou art the God of my salvation; in thee hath been my hope all the day long."
            ],
            [
                "Call to remembrance, O Lord, thy tender mercies",
                "and thy loving kindnesses, which have been ever of old."
            ],
            [
                "O remember not the sins and offences of my youth",
                "but according to thy mercy think thou upon me, O Lord, for thy goodness."
            ],
            [
                "Gracious and righteous is the Lord",
                "therefore will he teach sinners in the way."
            ],
            [
                "Them that are meek shall he guide in judgement",
                "and such as are gentle, them shall he learn his way."
            ],
            [
                "All the paths of the Lord are mercy and truth",
                "unto such as keep his covenant and his testimonies."
            ],
            [
                "For thy Name's sake, O Lord",
                "be merciful unto my sin, for it is great."
            ],
            [
                "What man is he that feareth the Lord",
                "him shall he teach in the way that he shall choose."
            ],
            [
                "His soul shall dwell at ease",
                "and his seed shall inherit the land."
            ],
            [
                "The secret of the Lord is among them that fear him",
                "and he will shew them his covenant."
            ],
            [
                "Mine eyes are ever looking unto the Lord",
                "for he shall pluck my feet out of the net."
            ],
            [
                "Turn thee unto me, and have mercy upon me",
                "for I am desolate and in misery."
            ],
            [
                "The sorrows of my heart are enlarged",
                "O bring thou me out of my troubles."
            ],
            [
                "Look upon my adversity and misery",
                "and forgive me all my sin."
            ],
            [
                "Consider mine enemies, how many they are",
                "and they bear a tyrannous hate against me."
            ],
            [
                "O keep my soul, and deliver me",
                "let me not be confounded, for I have put my trust in thee."
            ],
            [
                "Let perfectness and righteous dealing wait upon me",
                "for my hope hath been in thee."
            ],
            [
                "Deliver Israel, O God",
                "out of all his troubles."
            ]
        ],
        id: "psalm25"
    },
    {
        lines: [
            [
                "BE THOU my judge, O Lord, for I have walked innocently",
                "my trust hath been also in the Lord, therefore shall I not fall."
            ],
            [
                "Examine me, O Lord, and prove me",
                "try out my reins and my heart."
            ],
            [
                "For thy loving kindness is ever before mine eyes",
                "and I will walk in thy truth."
            ],
            [
                "I have not dwelt with vain persons",
                "neither will I have fellowship with the deceitful."
            ],
            [
                "I have hated the congregation of the wicked",
                "and will not sit among the ungodly."
            ],
            [
                "I will wash my hands in innocency, O Lord",
                "and so will I go to thine altar."
            ],
            [
                "That I may shew the voice of thanksgiving",
                "and tell of all thy wondrous works."
            ],
            [
                "Lord, I have loved the habitation of thy house",
                "and the place where thine honour dwelleth."
            ],
            [
                "O shut not up my soul with the sinners",
                "nor my life with the blood thirsty."
            ],
            [
                "In whose hands is wickedness",
                "and their right hand is full of gifts."
            ],
            [
                "But as for me, I will walk innocently",
                "O deliver me, and be merciful unto me."
            ],
            [
                "My foot standeth right",
                "I will praise the Lord in the congregations."
            ]
        ],
        id: "psalm26"
    },
    {
        lines: [
            [
                "THE Lord is my light and my salvation ; whom then shall I fear",
                "the Lord is the strength of my life; of whom then shall I be afraid?"
            ],
            [
                "When the wicked, even mine enemies and my foes, came upon me to eat up my flesh",
                "they stumbled and fell."
            ],
            [
                "Though an host of men were laid against me, yet shall not my heart be afraid",
                "and though there rose up war against me, yet will I put my trust in him."
            ],
            [
                "One thing have I desired of the Lord, which I will require",
                "even that I may dwell in the house of the Lord all the days of my life, to behold the fair beauty of the Lord, and to visit his temple."
            ],
            [
                "For in the time of trouble he shall hide me in his tabernacle",
                "yea, in the secret place of his dwelling shall he hide me, and set me up upon a rock of stone."
            ],
            [
                "And now shall he lift up mine head",
                "above mine enemies round about me."
            ],
            [
                "Therefore will I offer in his dwelling an oblation with great gladness",
                "I will sing, and speak praises unto the Lord."
            ],
            [
                "Hearken unto my voice, O Lord, when I cry unto thee",
                "have mercy upon me, and hear me."
            ],
            [
                "My heart hath talked of thee, Seek ye my face",
                "Thy face, Lord, will I seek."
            ],
            [
                "O hide not thou thy face from me",
                "nor cast thy servant away in displeasure."
            ],
            [
                "Thou hast been my succour",
                "leave me not, neither forsake me, O God of my salvation."
            ],
            [
                "When my father and my mother forsake me",
                "the Lord taketh me up."
            ],
            [
                "Teach me thy way, O Lord",
                "and lead me in the right way, because of mine enemies."
            ],
            [
                "Deliver me not over into the will of mine adversaries",
                "for there are false witnesses risen up against me, and such as speak wrong."
            ],
            [
                "I should utterly have fainted",
                "but that I believe verily to see the goodness of the Lord in the land of the living."
            ],
            [
                "O tarry thou the Lord's leisure",
                "be strong, and he shall comfort thine heart ; and put thou thy trust in the Lord."
            ]
        ],
        id: "psalm27"
    },
    {
        lines: [
            [
                "UNTO thee will I cry, O Lord my strength",
                "think no scorn of me; lest, if thou make as though thou hearest not, I become like them that go down into the pit."
            ],
            [
                "Hear the voice of my humble petitions, when I cry unto thee",
                "when I hold up my hands towards the mercy seat of thy holy temple."
            ],
            [
                "O pluck me not away, neither destroy me, with the ungodly and wicked doers",
                "which speak friendly to their neighbours, but imagine mischief in their hearts."
            ],
            [
                "Reward them according to their deeds",
                "and according to the wickedness of their own inventions."
            ],
            [
                "Recompense them after the work of their hands",
                "pay them that they have deserved."
            ],
            [
                "For they regard not in their mind the works of the Lord, nor the operation of his hands",
                "therefore shall he break them down, and not build them up."
            ],
            [
                "Praised be the Lord",
                "for he hath heard the voice of my humble petitions."
            ],
            [
                "The Lord is my strength and my shield; my heart hath trusted in him, and I am helped",
                "therefore my heart danceth for joy, and in my song will I praise him."
            ],
            [
                "The Lord is my strength",
                "and he is the wholesome defence of his Anointed."
            ],
            [
                "O save thy people, and give thy blessing unto thine inheritance",
                "feed them, and set them up for ever."
            ]
        ],
        id: "psalm28"
    },
    {
        lines: [
            [
                "BRING unto the Lord, O ye mighty, bring young rams unto the Lord",
                "ascribe unto the Lord worship and strength."
            ],
            [
                "Give the Lord the honour due unto his Name",
                "worship the Lord with holy worship."
            ],
            [
                "It is the Lord that commandeth the waters",
                "it is the glorious God that maketh the thunder."
            ],
            [
                "It is the Lord that ruleth the sea; the voice of the Lord is mighty in operation",
                "the voice of the Lord is a glorious voice."
            ],
            [
                "The voice of the Lord breaketh the cedar trees",
                "yea, the Lord breaketh the cedars of Libanus."
            ],
            [
                "He maketh them also to skip like a calf",
                "Libanus also, and Sirion, like a young unicorn."
            ],
            [
                "The voice of the Lord divideth the flames of fire; the voice of the Lord shaketh the wilderness",
                "yea, the Lord shaketh the wilderness of Cades."
            ],
            [
                "The voice of the Lord maketh the hinds to bring forth young, and discovereth the thick bushes",
                "in his temple doth every man speak of his honour."
            ],
            [
                "The Lord sitteth above the water flood",
                "and the Lord remaineth a King for ever."
            ],
            [
                "The Lord shall give strength unto his people",
                "the Lord shall give his people the blessing of peace."
            ]
        ],
        id: "psalm29"
    },
    {
        lines: [
            [
                "I WILL magnify thee, O Lord, for thou hast set me up",
                "and not made my foes to triumph over me."
            ],
            [
                "O Lord my God, I cried unto thee",
                "and thou hast healed me."
            ],
            [
                "Thou, Lord, hast brought my soul out of hell",
                "thou hast kept my life from them that go down to the pit."
            ],
            [
                "Sing praises unto the Lord, O ye saints of his",
                "and give thanks unto him for a remembrance of his holiness."
            ],
            [
                "For his wrath endureth but the twinkling of an eye, and in his pleasure is life",
                "heaviness may endure for a night, but joy cometh in the morning."
            ],
            [
                "And in my prosperity I said, I shall never be removed",
                "thou, Lord, of thy goodness hast made my hill so strong."
            ],
            [
                "Thou didst turn thy face from me",
                "and I was troubled."
            ],
            [
                "Then cried I unto thee, O Lord",
                "and gat me to my Lord right humbly."
            ],
            [
                "What profit is there in my blood",
                "when I go down to the pit?"
            ],
            [
                "Shall the dust give thanks unto thee",
                "or shall it declare thy truth?"
            ],
            [
                "Hear, O Lord, and have mercy upon me",
                "Lord, be thou my helper."
            ],
            [
                "Thou hast turned my heaviness into joy",
                "thou hast put off my sackcloth, and girded me with gladness."
            ],
            [
                "Therefore shall every good man sing of thy praise without ceasing",
                "O my God, I will give thanks unto thee for ever."
            ]
        ],
        id: "psalm30"
    },
    {
        lines: [
            [
                "IN THEE, O Lord, have I put my trust",
                "let me never be put to confusion, deliver me in thy righteousness."
            ],
            [
                "Bow down thine ear to me",
                "make haste to deliver me."
            ],
            [
                "And be thou my strong rock, and house of defence",
                "that thou mayest save me."
            ],
            [
                "For thou art my strong rock, and my castle",
                "be thou also my guide, and lead me for thy Name's sake."
            ],
            [
                "Draw me out of the net that they have laid privily for me",
                "for thou art my strength."
            ],
            [
                "Into thy hands I commend my spirit",
                "for thou hast redeemed me, O Lord, thou God of truth."
            ],
            [
                "I have hated them that hold of superstitious vanities",
                "and my trust hath been in the Lord."
            ],
            [
                "I will be glad and rejoice in thy mercy",
                "for thou hast considered my trouble, and hast known my soul in adversities."
            ],
            [
                "Thou hast not shut me up into the hand of the enemy",
                "but hast set my feet in a large room."
            ],
            [
                "Have mercy upon me, O Lord , for I am in trouble",
                "and mine eye is consumed for very heaviness; yea, my soul and my body."
            ],
            [
                "For my life is waxen old with heaviness",
                "and my years with mourning."
            ],
            [
                "My strength faileth me, because of mine iniquity",
                "and my bones are consumed."
            ],
            [
                "I became a reproof among all mine enemies, but especially among my neighbours",
                "and they of mine acquaintance were afraid of me; and they that did see me without conveyed themselves from me."
            ],
            [
                "I am clean forgotten, as a dead man out of mind",
                "I am become like a broken vessel."
            ],
            [
                "For I have heard the blasphemy of the multitude",
                "and fear is on every side, while they conspire together against me, and take their counsel to take away my life."
            ],
            [
                "But my hope hath been in thee, O Lord",
                "I have said, Thou art my God."
            ],
            [
                "My time is in thy hand; deliver me from the hand of mine enemies",
                "and from them that persecute me."
            ],
            [
                "Shew thy servant the light of thy countenance",
                "and save me for thy mercy's sake."
            ],
            [
                "Let me not be confounded, O Lord, for I have called upon thee",
                "let the ungodly be put to confusion, and be put to silence in the grave."
            ],
            [
                "Let the lying lips be put to silence",
                "which cruelly, disdainfully, and despitefully, speak against the righteous."
            ],
            [
                "O how plentiful is thy goodness, which thou hast laid up for them that fear thee",
                "and that thou hast prepared for them that put their trust in thee, even before the sons of men!"
            ],
            [
                "Thou shalt hide them privily by thine own presence from the provoking of all men",
                "thou shalt keep them secretly in thy tabernacle from the strife of tongues."
            ],
            [
                "Thanks be to the Lord",
                "for he hath shewed me marvellous great kindness in a strong city."
            ],
            [
                "And when I made haste, I said",
                "I am cast out of the sight of thine eyes."
            ],
            [
                "Nevertheless, thou heardest the voice of my prayer",
                "when I cried unto thee."
            ],
            [
                "O love the Lord, all ye his saints",
                "for the Lord preserveth them that are faithful, and plenteously rewardeth the proud doer."
            ],
            [
                "Be strong, and he shall establish your heart",
                "all ye that put your trust in the Lord."
            ]
        ],
        id: "psalm31"
    },
    {
        lines: [
            [
                "BLESSED is he whose unrighteousness is forgiven",
                "and whose sin is covered."
            ],
            [
                "Blessed is the man unto whom the Lord imputeth no sin",
                "and in whose spirit there is no guile."
            ],
            [
                "For while I held my tongue",
                "my bones consumed away through my daily complaining."
            ],
            [
                "For thy hand is heavy upon me day and night",
                "and my moisture is like the drought in summer."
            ],
            [
                "I will acknowledge my sin unto thee",
                "and mine unrighteousness have I not hid."
            ],
            [
                "I said, I will confess my sins unto the Lord",
                "and so thou forgavest the wickedness of my sin."
            ],
            [
                "For this shall every one that is godly make his prayer unto thee, in a time when thou mayest be found",
                "but in the great water floods they shall not come nigh him."
            ],
            [
                "Thou art a place to hide me in, thou shalt preserve me from trouble",
                "thou shalt compass me about with songs of deliverance."
            ],
            [
                "I will inform thee, and teach thee in the way wherein thou shalt go",
                "and I will guide thee with mine eye."
            ],
            [
                "Be ye not like to horse and mule, which have no understanding",
                "whose mouths must be held with bit and bridle, lest they fall upon thee."
            ],
            [
                "Great plagues remain for the ungodly",
                "but whoso putteth his trust in the Lord, mercy embraceth him on ev'ry side."
            ],
            [
                "Be glad, O ye righteous, and rejoice in the Lord",
                "and be joyful, all ye that are true of heart."
            ]
        ],
        id: "psalm32"
    },
    {
        lines: [
            [
                "REJOICE in the Lord, O ye righteous",
                "for it becometh well the just to be thankful."
            ],
            [
                "Praise the Lord with harp",
                "sing praises unto him with the lute, and instrument of ten strings."
            ],
            [
                "Sing unto the Lord a new song",
                "sing praises lustily unto him with a good courage."
            ],
            [
                "For the word of the Lord is true",
                "and all his works are faithful."
            ],
            [
                "He loveth righteousness and judgement",
                "the earth is full of the goodness of the Lord."
            ],
            [
                "By the word of the Lord were the heavens made",
                "and all the hosts of them by the breath of his mouth."
            ],
            [
                "He gathereth the waters of the sea together, as it were upon an heap",
                "and layeth up the deep, as in a treasure house."
            ],
            [
                "Let all the earth fear the Lord",
                "stand in awe of him, all ye that dwell in the world."
            ],
            [
                "For he spake, and it was done",
                "he commanded, and it stood fast."
            ],
            [
                "The Lord bringeth the counsel of the heathen to nought",
                "and maketh the devices of the people to be of none effect, and casteth out the counsels of princes."
            ],
            [
                "The counsel of the Lord shall endure for ever",
                "and the thoughts of his heart from generation to generation."
            ],
            [
                "Blessed are the people, whose God is the Lord Jehovah",
                "and blessed are the folk, that he hath chosen to him to be his inheritance."
            ],
            [
                "The Lord looked down from heaven, and beheld all the children of men",
                "from the habitation of his dwelling he considereth all them that dwell on the earth."
            ],
            [
                "He fashioneth all the hearts of them",
                "and understandeth all their works."
            ],
            [
                "There is no king that can be saved by the multitude of an host",
                "neither is any mighty man delivered by much strength."
            ],
            [
                "A horse is counted but a vain thing to save a man",
                "neither shall he deliver any man by his great strength."
            ],
            [
                "Behold, the eye of the Lord is upon them that fear him",
                "and upon them that put their trust in his mercy;"
            ],
            [
                "To deliver their soul from death",
                "and to feed them in the time of dearth."
            ],
            [
                "Our soul hath patiently tarried for the Lord",
                "for he is our help and our shield."
            ],
            [
                "For our heart shall rejoice in him",
                "because we have hoped in his holy Name."
            ],
            [
                "Let thy merciful kindness, O Lord, be upon us",
                "like as we do put our trust in thee."
            ]
        ],
        id: "psalm33"
    },
    {
        lines: [
            [
                "I WILL alway give thanks unto the Lord",
                "his praise shall ever be in my mouth."
            ],
            [
                "My soul shall make her boast in the Lord",
                "the humble shall hear thereof, and be glad."
            ],
            [
                "O praise the Lord with me",
                "and let us magnify his Name together."
            ],
            [
                "I sought the Lord, and he heard me",
                "yea, he delivered me out of all my fear."
            ],
            [
                "They had an eye unto him, and were lightened",
                "and their faces were not ashamed."
            ],
            [
                "Lo, the poor crieth, and the Lord heareth him",
                "yea, and saveth him out of all his troubles."
            ],
            [
                "The angel of the Lord tarrieth round about them that fear him",
                "and delivereth them."
            ],
            [
                "O taste, and see, how gracious the Lord is",
                "blessed is the man that trusteth in him."
            ],
            [
                "O fear the Lord, ye that are his saints",
                "for they that fear him lack nothing."
            ],
            [
                "The lions do lack, and suffer hunger",
                "but they who seek the Lord shall want no manner of thing that is good."
            ],
            [
                "Come, ye children, and hearken unto me",
                "I will teach you the fear of the Lord."
            ],
            [
                "What man is he that lusteth to live",
                "and would fain see good days?"
            ],
            [
                "Keep thy tongue from evil",
                "and thy lips, that they speak no guile."
            ],
            [
                "Eschew evil, and do good",
                "seek peace, and ensue it."
            ],
            [
                "The eyes of the Lord are over the righteous",
                "and his ears are open unto their prayers."
            ],
            [
                "The countenance of the Lord is against them that do evil",
                "to root out the remembrance of them from the earth."
            ],
            [
                "The righteous cry, and the Lord heareth them",
                "and delivereth them out of all their troubles."
            ],
            [
                "The Lord is nigh unto them that are of a contrite heart",
                "and will save such as be of an humble spirit."
            ],
            [
                "Great are the troubles of the righteous",
                "but the Lord delivereth him out of all."
            ],
            [
                "He keepeth all his bones",
                "so that not one of them is broken."
            ],
            [
                "But misfortune shall slay the ungodly",
                "and they that hate the righteous shall be desolate."
            ],
            [
                "The Lord delivereth the souls of his servants",
                "and all they that put their trust in him shall not be destitute."
            ]
        ],
        id: "psalm34"
    },
    {
        lines: [
            [
                "PLEAD thou my cause, O Lord, with them that strive with me",
                "and fight thou against them that fight against me."
            ],
            [
                "Lay hand upon the shield and buckler",
                "and stand up to help me."
            ],
            [
                "Bring forth the spear, and stop the way against them that persecute me",
                "say unto my soul, I am thy salvation."
            ],
            [
                "Let them be confounded and put to shame, that seek after my soul",
                "let them be turned back and brought to confusion, that imagine mischief for me."
            ],
            [
                "Let them be as the dust before the wind",
                "and the angel of the Lord scattering them."
            ],
            [
                "Let their way be dark and slippery",
                "and let the angel of the Lord persecute them."
            ],
            [
                "For they have privily laid their net to destroy me without a cause",
                "yea, even without a cause have they made a pit for my soul."
            ],
            [
                "Let a sudden destruction come upon him unawares, and his net, that he hath laid privily, catch himself",
                "that he may fall into his own mischief."
            ],
            [
                "And, my soul, be joyful in the Lord",
                "it shall rejoice in his salvation."
            ],
            [
                "All my bones shall say, Lord, who is like unto thee, who deliverest the poor from him that is too strong for him",
                "yea, the poor, and him that is in misery, from him that spoileth him?"
            ],
            [
                "False witnesses did rise up",
                "they laid to my charge things that I knew not."
            ],
            [
                "They rewarded me evil for good",
                "to the great discomfort of my soul."
            ],
            [
                "Nevertheless, when they were sick, I put on sackcloth, and humbled my soul with fasting",
                "and my prayer shall turn into mine own bosom."
            ],
            [
                "I behaved myself as though it had been my friend or my brother",
                "I went heavily, as one that mourneth for his mother."
            ],
            [
                "But in mine adversity they rejoiced, and gathered themselves together",
                "yea, the very abjects came together against me unawares, making mouths at me, and ceased not."
            ],
            [
                "With the flatterers were busy mockers",
                "who gnashed upon me with their teeth."
            ],
            [
                "Lord, how long wilt thou look upon this",
                "O deliver my soul from the calamities which they bring on me, and my darling from the lions."
            ],
            [
                "So will I give thee thanks in the great congregation",
                "I will praise thee among much people."
            ],
            [
                "O let not them that are mine enemies triumph over me ungodly",
                "neither let them wink with their eyes that hate me without a cause."
            ],
            [
                "And why? their communing is not for peace",
                "but they imagine deceitful words against them that are quiet in the land."
            ],
            [
                "They gaped upon me with their mouths, and said",
                "Fie on thee, fie on thee, we saw it with our eyes."
            ],
            [
                "This thou hast seen, O Lord",
                "hold not thy tongue then, go not far from me, O Lord."
            ],
            [
                "Awake, and stand up to judge my quarrel",
                "avenge thou my cause, my God, and my Lord."
            ],
            [
                "Judge me, O Lord my God, according to thy righteousness",
                "and let them not triumph over me."
            ],
            [
                "Let them not say in their hearts, There, there, so would we have it",
                "neither let them say, We have devoured him."
            ],
            [
                "Let them be put to confusion and shame together, that rejoice at my trouble",
                "let them be clothed with rebuke and dishonour, that boast themselves against me."
            ],
            [
                "Let them be glad and rejoice, that favour my righteous dealing",
                "yea, let them say alway, Blessed be the Lord, who hath pleasure in the prosperity of his servant."
            ],
            [
                "And as for my tongue, it shall be talking of thy righteousness",
                "and of thy praise all the day long."
            ]
        ],
        id: "psalm35"
    },
    {
        lines: [
            [
                "MY HEART sheweth me the wickedness of the ungodly",
                "that there is no fear of God before his eyes."
            ],
            [
                "For he flattereth himself in his own sight",
                "until his abominable sin be found out."
            ],
            [
                "The words of his mouth are unrighteous, and full of deceit",
                "he hath left off to behave himself wisely, and to do good."
            ],
            [
                "He imagineth mischief upon his bed, and hath set himself in no good way",
                "neither doth he abhor any thing that is evil."
            ],
            [
                "Thy mercy, O Lord, reacheth unto the heavens",
                "and thy faithfulness unto the clouds."
            ],
            [
                "Thy righteousness standeth like the strong mountains",
                "thy judgements are like the great deep."
            ],
            [
                "Thou, Lord, shalt save both man and beast; How excellent is thy mercy, O God",
                "and the children of men shall put their trust under the shadow of thy wings."
            ],
            [
                "They shall be satisfied with the plenteousness of thy house",
                "and thou shalt give them drink of thy pleasures, as out of the river."
            ],
            [
                "For with thee is the well of life",
                "and in thy light shall we see light."
            ],
            [
                "O continue forth thy loving kindness unto them that know thee",
                "and thy righteousness unto them that are true of heart."
            ],
            [
                "O let not the foot of pride come against me",
                "and let not the hand of the ungodly cast me down."
            ],
            [
                "There are they fallen, all that work wickedness",
                "they are cast down, and shall not be able to stand."
            ]
        ],
        id: "psalm36"
    },
    {
        lines: [
            [
                "FRET not thyself because of the ungodly",
                "neither be thou envious against the evil doers."
            ],
            [
                "For they shall soon be cut down like the grass",
                "and be withered even as the green herb."
            ],
            [
                "Put thou thy trust in the Lord, and be doing good",
                "dwell in the land, and verily thou shalt be fed."
            ],
            [
                "Delight thou in the Lord",
                "and he shall give thee thy heart's desire."
            ],
            [
                "Commit thy way unto the Lord, and put thy trust in him",
                "and he shall bring it to pass."
            ],
            [
                "He shall make thy righteousness as clear as the light",
                "and thy just dealing as the noon day."
            ],
            [
                "Hold thee still in the Lord, and abide patiently upon him",
                "but grieve not thyself at him whose way doth prosper, against the man that doeth after evil counsels."
            ],
            [
                "Leave off from wrath, and let go displeasure",
                "fret not thyself, else shalt thou be moved to do evil."
            ],
            [
                "Wicked doers shall be rooted out",
                "and they that patiently abide the Lord, those shall inherit the land."
            ],
            [
                "Yet a little while, and the ungodly shall be clean gone",
                "thou shalt look after his place, and he shall be away."
            ],
            [
                "But the meek spirited shall possess the earth",
                "and shall be refreshed in the multitude of peace."
            ],
            [
                "The ungodly seeketh counsel against the just",
                "and gnasheth upon him with his teeth."
            ],
            [
                "The Lord shall laugh him to scorn",
                "for he hath seen that his day is coming."
            ],
            [
                "The ungodly have drawn out the sword, and have bent their bow",
                "to cast down the poor and needy, and to slay such as are of a right conversation."
            ],
            [
                "Their sword shall go through their own heart",
                "and their bow shall be broken."
            ],
            [
                "A small thing that the righteous hath",
                "is better than great riches of the ungodly."
            ],
            [
                "For the arms of the ungodly shall be broken",
                "and the Lord upholdeth the righteous."
            ],
            [
                "The Lord knoweth the days of the godly",
                "and their inheritance shall endure for ever."
            ],
            [
                "They shall not be confounded in the perilous time",
                "and in the days of dearth they shall have enough."
            ],
            [
                "As for the ungodly, they shall perish; and the enemies of the Lord shall consume as the fat of lambs",
                "yea, even as the smoke shall they consume away."
            ],
            [
                "The ungodly borroweth, and payeth not again",
                "but the righteous is merciful and liberal."
            ],
            [
                "Such as are blessed of God shall possess the land",
                "and they that are cursed of him shall be rooted out."
            ],
            [
                "The Lord ordereth a good man's going",
                "and maketh his way acceptable to himself."
            ],
            [
                "Though he fall, he shall not be cast away",
                "for the Lord upholdeth him with his hand."
            ],
            [
                "I have been young, and now am old",
                "and yet saw I never the righteous forsaken, nor his seed begging their bread."
            ],
            [
                "The righteous is ever merciful, and lendeth",
                "and his seed is blessed."
            ],
            [
                "Flee from evil, and do the thing that is good",
                "and dwell for evermore."
            ],
            [
                "For the Lord loveth the thing that is right",
                "he forsaketh not his that be godly, but they are preserved for ever."
            ],
            [
                "The unrighteous shall be punished",
                "as for the seed of the ungodly, it shall be rooted out."
            ],
            [
                "The righteous shall inherit the land",
                "and dwell therein for ever."
            ],
            [
                "The mouth of the righteous is exercised in wisdom",
                "and his tongue will be talking of judgement."
            ],
            [
                "The law of his God is in his heart",
                "and his goings shall not slide."
            ],
            [
                "The ungodly seeth the righteous",
                "and seeketh occasion to slay him."
            ],
            [
                "The Lord will not leave him in his hand",
                "nor condemn him when he is judged."
            ],
            [
                "Hope thou in the Lord, and keep his way, and he shall promote thee, that thou shalt possess the land",
                "when the ungodly shall perish, thou shalt see it."
            ],
            [
                "I myself have seen the ungodly in great power",
                "and flourishing like a green bay tree."
            ],
            [
                "I went by, and lo, he was gone",
                "I sought him, but his place could nowhere be found."
            ],
            [
                "Keep innocency, and take heed unto the thing that is right",
                "for that shall bring a man peace at the last."
            ],
            [
                "As for the transgressors, they shall perish together",
                "and the end of the ungodly is, they shall be rooted out at the last."
            ],
            [
                "But the salvation of the righteous cometh of the Lord",
                "who is also their strength in the time of trouble."
            ],
            [
                "And the Lord shall stand by them, and save them",
                "he shall deliver them from the ungodly, and shall save them, because they put their trust in him."
            ]
        ],
        id: "psalm37"
    },
    {
        lines: [
            [
                "PUT me not to rebuke, O Lord, in thine anger",
                "neither chasten me in thy heavy displeasure."
            ],
            [
                "For thine arrows stick fast in me",
                "and thy hand presseth me sore."
            ],
            [
                "There is no health in my flesh, because of thy displeasure",
                "neither is there any rest in my bones, by reason of my sin."
            ],
            [
                "For my wickednesses are gone over my head",
                "and are like a sore burden, too heavy for me to bear."
            ],
            [
                "My wounds stink, and are corrupt",
                "through my foolishness."
            ],
            [
                "I am brought into so great trouble and misery",
                "that I go mourning all the day long."
            ],
            [
                "For my loins are filled with a sore disease",
                "and there is no whole part in my body."
            ],
            [
                "I am feeble, and sore smitten",
                "I have roared for the very disquietness of my heart."
            ],
            [
                "Lord, thou knowest all my desire",
                "and my groaning is not hid from thee."
            ],
            [
                "My heart panteth, my strength hath failed me",
                "and the sight of mine eyes is gone from me."
            ],
            [
                "My lovers and my neighbours did stand looking upon my trouble",
                "and my kinsmen stood afar off."
            ],
            [
                "They also that sought after my life laid snares for me",
                "and they that went about to do me evil talked of wickedness, and imagined deceit all the day long."
            ],
            [
                "As for me, I was like a deaf man, and heard not",
                "and as one that is dumb, who doth not open his mouth."
            ],
            [
                "I became even as a man that heareth not",
                "and in whose mouth are no reproofs."
            ],
            [
                "For in thee, O Lord, have I put my trust",
                "thou shalt answer for me, O Lord my God."
            ],
            [
                "I have required that they, even mine enemies, should not triumph over me",
                "for when my foot slipped, they rejoiced greatly against me."
            ],
            [
                "And I, truly, am set in the plague",
                "and my heaviness is ever in my sight."
            ],
            [
                "For I will confess my wickedness",
                "and be sorry for my sin."
            ],
            [
                "But mine enemies live, and are mighty",
                "and they that hate me wrongfully are many in number."
            ],
            [
                "They also that reward evil for good are against me",
                "because I follow the thing that good is."
            ],
            [
                "Forsake me not, O Lord my God",
                "be not thou far from me."
            ],
            [
                "Haste thee to help me",
                "O Lord God of my salvation."
            ]
        ],
        id: "psalm38"
    },
    {
        lines: [
            [
                "I SAID, I will take heed to my ways",
                "that I offend not in my tongue."
            ],
            [
                "I will keep my mouth as it were with a bridle",
                "while the ungodly is in my sight."
            ],
            [
                "I held my tongue, and spake nothing",
                "I kept silence, yea, even from good words; but it was pain and grief to me."
            ],
            [
                "My heart was hot within me, and while I was thus musing the fire kindled",
                "and at the last I spake with my tongue;"
            ],
            [
                "Lord, let me know mine end, and the number of my days",
                "that I may be certified how long I have to live."
            ],
            [
                "Behold, thou hast made my days as it were a span long",
                "and mine age is even as nothing in respect of thee; and verily every man living is altogether vanity."
            ],
            [
                "For man walketh in a vain shadow, and disquieteth himself in vain",
                "he heapeth up riches, and cannot tell who shall gather them."
            ],
            [
                "And now, Lord, what is my hope",
                "truly my hope is even in thee."
            ],
            [
                "Deliver me from all mine offences",
                "and make me not a rebuke unto the foolish."
            ],
            [
                "I became dumb, and opened not my mouth",
                "for it was thy doing."
            ],
            [
                "Take thy plague away from me",
                "I am even consumed by the means of thy heavy hand."
            ],
            [
                "When thou with rebukes dost chasten man for sin, thou makest his beauty to consume away, like as it were a moth fretting a garment",
                "every man therefore is but vanity."
            ],
            [
                "Hear my prayer, O Lord, and with thine ears consider my calling",
                "hold not thy peace at my tears."
            ],
            [
                "For I am a stranger with thee",
                "and a sojourner, as all my fathers were."
            ],
            [
                "O spare me a little, that I may recover my strength",
                "before I go hence, and be no more seen."
            ]
        ],
        id: "psalm39"
    },
    {
        lines: [
            [
                "I WAITED patiently for the Lord",
                "and he inclined unto me, and heard my calling."
            ],
            [
                "He brought me also out of the horrible pit, out of the mire and clay",
                "and set my feet upon the rock, and ordered my goings."
            ],
            [
                "And he hath put a new song in my mouth",
                "even a thanksgiving unto our God."
            ],
            [
                "Many shall see it, and fear",
                "and shall put their trust in the Lord."
            ],
            [
                "Blessed is the man that hath set his hope in the Lord",
                "and turned not unto the proud, and to such as go about with lies."
            ],
            [
                "O Lord my God, great are the wondrous works which thou hast done, like as be also thy thoughts which are to us ward",
                "and yet there is no man that ordereth them unto thee."
            ],
            [
                "If I should declare them, and speak of them",
                "they should be more than I am able to express."
            ],
            [
                "Sacrifice and meat offering thou wouldest not",
                "but mine ears hast thou opened."
            ],
            [
                "Burnt offerings, and sacrifice for sin, hast thou not required",
                "then said I, Lo, I come,"
            ],
            [
                "In the volume of the book it is written of me, that I should fulfil thy will, O my God",
                "I am content to do it; yea, thy law is within my heart."
            ],
            [
                "I have declared thy righteousness in the great congregation",
                "lo, I will not refrain my lips, O Lord, and that thou knowest."
            ],
            [
                "I have not hid thy righteousness within my heart",
                "my talk hath been of thy truth and of thy salvation."
            ],
            [
                "I have not kept back thy loving mercy and truth",
                "from the great congregation."
            ],
            [
                "Withdraw not thou thy mercy from me, O Lord",
                "let thy loving kindness and thy truth alway preserve me."
            ],
            [
                "For innumerable troubles are come about me; my sins have taken such hold upon me that I am not able to look up",
                "yea, they are more in number than the hairs of my head, and my heart hath failed me."
            ],
            [
                "O Lord, let it be thy pleasure to deliver me",
                "make haste, O Lord, to help me."
            ],
            [
                "Let them be ashamed and confounded together, that seek after my soul to destroy it",
                "let them be driven backward and put to rebuke, that wish me evil."
            ],
            [
                "Let them be desolate, and rewarded with shame",
                "that say unto me, Fie upon thee, fie upon thee."
            ],
            [
                "Let all those that seek thee be joyful and glad in thee",
                "and let such as love thy salvation say alway, The Lord be praised."
            ],
            [
                "As for me, I am poor and needy",
                "but the Lord careth for me."
            ],
            [
                "Thou art my helper and redeemer",
                "make no long tarrying, O my God."
            ]
        ],
        id: "psalm40"
    },
    {
        lines: [
            [
                "BLESSED is he that considereth the poor and needy",
                "the Lord shall deliver him in the time of trou ble."
            ],
            [
                "The Lord preserve him, and keep him alive, that he may be blessed upon earth",
                "and deliver not thou him into the will of his enemies."
            ],
            [
                "The Lord comfort him, when he lieth sick upon his bed",
                "make thou all his bed in his sick ness."
            ],
            [
                "I said, Lord, be merciful unto me",
                "heal my soul, for I have sinned against thee."
            ],
            [
                "Mine enemies speak evil of me",
                "When shall he die, and his name per ish?"
            ],
            [
                "And if he come to see me, he speaketh vanity",
                "and his heart conceiveth falsehood within himself, and when he cometh forth he telleth it."
            ],
            [
                "All mine enemies whisper together against me",
                "even against me do they imagine this e vil."
            ],
            [
                "Let the sentence of guiltiness proceed against him",
                "and now that he lieth, let him rise up no more."
            ],
            [
                "Yea, even mine own familiar friend, whom I trusted",
                "who did also eat of my bread, hath laid great wait for me."
            ],
            [
                "But be thou merciful unto me, O Lord",
                "raise thou me up again, and I shall reward them."
            ],
            [
                "By this I know thou favourest me",
                "that mine enemy doth not triumph against me."
            ],
            [
                "And when I am in my health, thou upholdest me",
                "and shalt set me before thy face for ev er."
            ],
            [
                "Blessed be the Lord God of Israel",
                "world without end. A men."
            ]
        ],
        id: "psalm41"
    },
    {
        lines: [
            [
                "LIKE as the hart desireth the water brooks",
                "so longeth my soul after thee, O God."
            ],
            [
                "My soul is athirst for God, yea, even for the living God",
                "when shall I come to appear before the presence of God?"
            ],
            [
                "My tears have been my meat day and night",
                "while they daily say unto me, Where is now thy God?"
            ],
            [
                "Now when I think thereupon, I pour out my heart by myself",
                "for I went with the multitude, and brought them forth into the house of God;"
            ],
            [
                "In the voice of praise and thanksgiving",
                "among such as keep holy day."
            ],
            [
                "Why art thou so full of heaviness, O my soul",
                "and why art thou so disquieted within me?"
            ],
            [
                "Put thy trust in God",
                "for I will yet give him thanks for the help of his countenance."
            ],
            [
                "My God, my soul is vexed within me",
                "therefore will I remember thee concerning the land of Jordan, and the little hill of Hermon."
            ],
            [
                "One deep calleth another, because of the noise of the water pipes",
                "all thy waves and storms are gone over me."
            ],
            [
                "The Lord hath granted his loving kindness in the day time",
                "and in the night season did I sing of him, and made my prayer unto the God of my life."
            ],
            [
                "I will say unto the God of my strength, Why hast thou forgotten me",
                "why go I thus heavily, while the enemy oppresseth me?"
            ],
            [
                "My bones are smitten asunder as with a sword",
                "while mine enemies that trouble me cast me in the teeth;"
            ],
            [
                "Namely, while they say daily unto me",
                "Where is now thy God?"
            ],
            [
                "Why art thou so vexed, O my soul",
                "and why art thou so disquieted within me?"
            ],
            [
                "O put thy trust in God",
                "for I will yet thank him, which is the help of my countenance, and my God."
            ]
        ],
        id: "psalm42"
    },
    {
        lines: [
            [
                "GIVE sentence with me, O God, and defend my cause against the ungodly people",
                "O deliver me from the deceitful and wicked man."
            ],
            [
                "For thou art the God of my strength, why hast thou put me from thee",
                "and why go I so heavily, while the enemy oppresseth me?"
            ],
            [
                "O send out thy light and thy truth, that they may lead me",
                "and bring me unto thy holy hill, and to thy dwelling."
            ],
            [
                "And that I may go unto the altar of God, even unto the God of my joy and gladness",
                "and upon the harp will I give thanks unto thee, O God, my God."
            ],
            [
                "Why art thou so heavy, O my soul",
                "and why art thou so disquieted within me?"
            ],
            [
                "O put thy trust in God",
                "for I will yet give him thanks, which is the help of my countenance, and my God."
            ]
        ],
        id: "psalm43"
    },
    {
        lines: [
            [
                "WE HAVE heard with our ears, O God, our fathers have told us",
                "what thou hast done in their time of old;"
            ],
            [
                "How thou hast driven out the heathen with thy hand, and planted them in",
                "how thou hast destroyed the nations and cast them out."
            ],
            [
                "For they gat not the land in possession through their own sword",
                "neither was it their own arm that helped them;"
            ],
            [
                "But thy right hand, and thine arm, and the light of thy countenance",
                "because thou hadst a favour unto them."
            ],
            [
                "Thou art my King, O God",
                "send help unto Jacob."
            ],
            [
                "Through thee will we overthrow our enemies",
                "and in thy Name will we tread them under, that rise up against us."
            ],
            [
                "For I will not trust in my bow",
                "it is not my sword that shall help me;"
            ],
            [
                "But it is thou that savest us from our enemies",
                "and puttest them to confusion that hate us."
            ],
            [
                "We make our boast of God all day long",
                "and will praise thy Name for ever."
            ],
            [
                "But now thou art far off, and puttest us to confusion",
                "and goest not forth with our armies."
            ],
            [
                "Thou makest us to turn our backs upon our enemies",
                "so that they which hate us spoil our goods."
            ],
            [
                "Thou lettest us be eaten up like sheep",
                "and hast scattered us among the heathen."
            ],
            [
                "Thou sellest thy people for nought",
                "and takest no money for them."
            ],
            [
                "Thou makest us to be rebuked of our neighbours",
                "to be laughed to scorn, and had in derision of them that are round about us."
            ],
            [
                "Thou makest us to be a by word among the heathen",
                "and that the people shake their heads at us."
            ],
            [
                "My confusion is daily before me",
                "and the shame of my face hath covered me;"
            ],
            [
                "For the voice of the slanderer and blasphemer",
                "for the enemy and avenger."
            ],
            [
                "And though all this be come upon us, yet do we not forget thee",
                "nor behave ourselves frowardly in thy covenant."
            ],
            [
                "Our heart is not turned back",
                "neither our steps gone out of thy way;"
            ],
            [
                "No, not when thou hast smitten us into the place of dragons",
                "and covered us with the shadow of death."
            ],
            [
                "If we have forgotten the Name of our God, and holden up our hands to any strange god",
                "shall not God search it out? for he knoweth the very secrets of the heart."
            ],
            [
                "For thy sake also are we killed all the day long",
                "and are counted as sheep appointed to be slain."
            ],
            [
                "Up, Lord, why sleepest thou",
                "awake, and be not absent from us for ever."
            ],
            [
                "Wherefore hidest thou thy face",
                "and forgettest our misery and trouble?"
            ],
            [
                "For our soul is brought low, even unto the dust",
                "our belly cleaveth unto the ground."
            ],
            [
                "Arise, and help us",
                "and deliver us for thy mercy's sake."
            ]
        ],
        id: "psalm44"
    },
    {
        lines: [
            [
                "MY HEART is inditing of a good matter",
                "I speak of the things which I have made unto the King."
            ],
            [
                "My tongue is the pen",
                "of a ready writer."
            ],
            [
                "Thou art fairer than the children of men",
                "full of grace are thy lips, because God hath blessed thee for ever."
            ],
            [
                "Gird thee with thy sword upon thy thigh, O thou most Mighty",
                "according to thy worship and renown."
            ],
            [
                "Good luck have thou with thine honour",
                "ride on, because of the word of truth, of meekness, and righteousness; and thy right hand shall teach thee terrible things."
            ],
            [
                "Thy arrows are very sharp, and the people shall be subdued unto thee",
                "even in the midst among the King's enemies."
            ],
            [
                "Thy seat, O God, endureth for ever",
                "the sceptre of thy kingdom is a right sceptre."
            ],
            [
                "Thou hast loved righteousness, and hated iniquity",
                "wherefore God, even thy God, hath anointed thee with the oil of gladness above thy fellows."
            ],
            [
                "All thy garments smell of myrrh, aloes, and cassia",
                "out of the ivory palaces, whereby they have made thee glad."
            ],
            [
                "Kings' daughters were among thy honourable women",
                "upon thy right hand did stand the queen in a vesture of gold, wrought about with divers colours."
            ],
            [
                "Hearken, O daughter, and consider, incline thine ear",
                "forget also thine own people, and thy father's house."
            ],
            [
                "So shall the King have pleasure in thy beauty",
                "for he is thy Lord God, and worship thou him."
            ],
            [
                "And the daughter of Tyre shall be there with a gift",
                "like as the rich also among the people shall make their supplication before thee."
            ],
            [
                "The King's daughter is all glorious within",
                "her clothing is of wrought gold."
            ],
            [
                "She shall be brought unto the King in raiment of needle work",
                "the virgins that be her fellows shall bear her company, and shall be brought unto thee."
            ],
            [
                "With joy and gladness shall they be brought",
                "and shall enter into the King's palace."
            ],
            [
                "Instead of thy fathers thou shalt have children",
                "whom thou mayest make princes in all lands."
            ],
            [
                "I will remember thy Name from one generation to another",
                "therefore shall the people give thanks unto thee, world without end."
            ]
        ],
        id: "psalm45"
    },
    {
        lines: [
            [
                "GOD is our hope and strength",
                "a very present help in trouble."
            ],
            [
                "Therefore will we not fear, though the earth be moved",
                "and though the hills be carried into the midst of the sea;"
            ],
            [
                "Though the waters thereof rage and swell",
                "and though the mountains shake at the tempest of thesame."
            ],
            [
                "The rivers of the flood thereof shall make glad the city of God",
                "the holy place of the tabernacle of the most Highest."
            ],
            [
                "God is in the midst of her, therefore shall she not be removed",
                "God shall help her, and that right early."
            ],
            [
                "The heathen make much ado, and the kingdoms are moved",
                "but God hath shewed his voice, and the earth shall melt away."
            ],
            [
                "The Lord of hosts is with us",
                "the God of Jacob is our refuge."
            ],
            [
                "O come hither, and behold the works of the Lord",
                "what destruction he hath brought upon the earth."
            ],
            [
                "He maketh wars to cease in all the world",
                "he breaketh the bow, and knappeth the spear in sunder, and burneth the chariots in the fire."
            ],
            [
                "Be still then, and know that I am God",
                "I will be exalted among the heathen, and I will be exalted in the earth."
            ],
            [
                "The Lord of hosts is with us",
                "the God of Jacob is our refuge."
            ]
        ],
        id: "psalm46"
    },
    {
        lines: [
            [
                "O CLAP your hands together, all ye people",
                "O sing unto God with the voice of melody."
            ],
            [
                "For the Lord is high, and to be feared",
                "he is the great King upon all the earth."
            ],
            [
                "He shall subdue the people under us",
                "and the nations under our feet."
            ],
            [
                "He shall choose out an heritage for us",
                "even the worship of Jacob, whom he loved."
            ],
            [
                "God is gone up with a merry noise",
                "and the Lord with the sound of the trump."
            ],
            [
                "O sing praises, sing praises unto our God",
                "O sing praises, sing praises unto our King."
            ],
            [
                "For God is the King of all the earth",
                "sing ye praises with understanding."
            ],
            [
                "God reigneth over the heathen",
                "God sitteth upon his holy seat."
            ],
            [
                "The princes of the people are joined unto the people of the God of Abraham",
                "for God, which is very high exalted, doth defend the earth, as it were with a shield."
            ]
        ],
        id: "psalm47"
    },
    {
        lines: [
            [
                "GREAT is the Lord, and highly to be praised",
                "in the city of our God, even upon his holy hill."
            ],
            [
                "The hill of Sion is a fair place, and the joy of the whole earth",
                "upon the north side lieth the city of the great King; God is well known in her palaces as a sure refuge."
            ],
            [
                "For lo, the kings of the earth",
                "are gathered, and gone by together."
            ],
            [
                "They marvelled to see such things",
                "they were astonished, and suddenly cast down."
            ],
            [
                "Fear came there upon them, and sorrow",
                "as upon a woman in her travail."
            ],
            [
                "Thou shalt break the ships of the sea",
                "through the east wind."
            ],
            [
                "Like as we have heard, so have we seen in the city of the Lord of hosts, in the city of our God",
                "God upholdeth the same for ever."
            ],
            [
                "We wait for thy loving kindness, O God",
                "in the midst of thy temple."
            ],
            [
                "O God, according to thy Name, so is thy praise unto the world's end",
                "thy right hand is full of righteousness."
            ],
            [
                "Let the mount Sion rejoice, and the daughters of Judah be glad",
                "because of thy judgements."
            ],
            [
                "Walk about Sion, and go round about her",
                "and tell the towers thereof."
            ],
            [
                "Mark well her bulwarks, set up her houses",
                "that ye may tell them that come after."
            ],
            [
                "For this God is our God for ever and ever",
                "he shall be our guide unto death."
            ]
        ],
        id: "psalm48"
    },
    {
        lines: [
            [
                "O HEAR ye this, all ye people",
                "ponder it with your ears, all ye that dwell in the world;"
            ],
            [
                "High and low, rich and poor",
                "one with another."
            ],
            [
                "My mouth shall speak of wisdom",
                "and my heart shall muse of understanding."
            ],
            [
                "I will incline mine ear to the parable",
                "and shew my dark speech upon the harp."
            ],
            [
                "Wherefore should I fear in the days of wickedness",
                "and when the wickedness of my heels compasseth me round about?"
            ],
            [
                "There be some that put their trust in their goods",
                "and boast themselves in the multitude of their riches."
            ],
            [
                "But no man may deliver his brother",
                "nor make agreement unto God for him;"
            ],
            [
                "For it cost more to redeem their souls",
                "so that he must let that alone for ever;"
            ],
            [
                "Yea, though he live long",
                "and see not the grave."
            ],
            [
                "For he seeth that wise men also die, and perish together",
                "as well as the ignorant and foolish, and leave their riches for other."
            ],
            [
                "And yet they think that their houses shall continue for ever",
                "and that their dwelling places shall endure from one generation to another; and call the lands after their own names."
            ],
            [
                "Nevertheless, man will not abide in honour",
                "seeing he may be compared unto the beasts that perish; this is the way of them."
            ],
            [
                "This is their foolishness",
                "and their posterity praise their saying."
            ],
            [
                "They lie in the hell like sheep, death gnaweth upon them, and the righteous shall have domination over them in the morning",
                "their beauty shall consume in the sepulchre out of their dwelling."
            ],
            [
                "But God hath delivered my soul from the place of hell",
                "for he shall receive me."
            ],
            [
                "Be not thou afraid, though one be made rich",
                "or if the glory of his house be increased;"
            ],
            [
                "For he shall carry nothing away with him when he dieth",
                "neither shall his pomp follow him."
            ],
            [
                "For while he lived, he counted himself an happy man",
                "and so long as thou doest well unto thyself, men will speak good of thee."
            ],
            [
                "He shall follow the generation of his fathers",
                "and shall never see light."
            ],
            [
                "Man being in honour hath no understanding",
                "but is compared unto the beasts that perish."
            ]
        ],
        id: "psalm49"
    },
    {
        lines: [
            [
                "THE Lord, even the most mighty God, hath spoken",
                "and called the world, from the rising up of the sun unto the going down thereof."
            ],
            [
                "Out of Sion hath God appeared",
                "in perfect beauty."
            ],
            [
                "Our God shall come, and shall not keep silence",
                "there shall go before him a consuming fire, and a mighty tempest shall be stirred up round about him."
            ],
            [
                "He shall call the heaven from above",
                "and the earth, that he may judge his people."
            ],
            [
                "Gather my saints together unto me",
                "those that have made a covenant with me with sacrifice."
            ],
            [
                "And the heavens shall declare his righteousness",
                "for God is Judge himself."
            ],
            [
                "Hear, O my people, and I will speak",
                "I myself will testify against thee, O Israel; for I am God, even thy God."
            ],
            [
                "I will not reprove thee because of thy sacrifices, or for thy burnt offerings",
                "because they were not alway before me."
            ],
            [
                "I will take no bullock out of thine house",
                "nor he goat out of thy folds."
            ],
            [
                "For all the beasts of the forest are mine",
                "and so are the cattle upon a thousand hills."
            ],
            [
                "I know all the fowls upon the mountains",
                "and the wild beasts of the field are in my sight."
            ],
            [
                "If I be hungry, I will not tell thee",
                "for the whole world is mine, and all that is therein."
            ],
            [
                "Thinkest thou that I will eat bulls' flesh",
                "and drink the blood of goats?"
            ],
            [
                "Offer unto God thanksgiving",
                "and pay thy vows unto the most Highest."
            ],
            [
                "And call upon me in the time of trouble",
                "so will I hear thee, and thou shalt praise me."
            ],
            [
                "But unto the ungodly said God",
                "Why dost thou preach my laws, and takest my covenant in thy mouth;"
            ],
            [
                "Whereas thou hatest to be reformed",
                "and has cast my words behind thee?"
            ],
            [
                "When thou sawest a thief, thou consentedst unto him",
                "and hast been partaker with the adulterers."
            ],
            [
                "Thou hast let thy mouth speak wickedness",
                "and with thy tongue thou hast set forth deceit."
            ],
            [
                "Thou satest, and spakest against thy brother",
                "yea, and hast slandered thine own mother's son."
            ],
            [
                "These things hast thou done, and I held my tongue, and thou thoughtest wickedly, that I am even such a one as thyself",
                "but I will reprove thee, and set before thee the things that thou hast done."
            ],
            [
                "O consider this, ye that forget God",
                "lest I pluck you away, and there be none to deliver you."
            ],
            [
                "Whoso offereth me thanks and praise, he honoureth me",
                "and to him that ordereth his conversation right will I shew the salvation of God."
            ]
        ],
        id: "psalm50"
    },
    {
        lines: [
            [
                "HAVE mercy upon me, O God, after thy great goodness",
                "according to the multitude of thy mercies do away mine offences."
            ],
            [
                "Wash me throughly from my wickedness",
                "and cleanse me from my sin."
            ],
            [
                "For I acknowledge my faults",
                "and my sin is ever before me."
            ],
            [
                "Against thee only have I sinned, and done this evil in thy sight",
                "that thou mightest be justified in thy saying, and clear when thou art judged."
            ],
            [
                "Behold, I was shapen in wickedness",
                "and in sin hath my mother conceived me."
            ],
            [
                "But lo, thou requirest truth in the inward parts",
                "and shalt make me to understand wisdom secretly."
            ],
            [
                "Thou shalt purge me with hyssop, and I shall be clean",
                "thou shalt wash me, and I shall be whiter than snow."
            ],
            [
                "Thou shalt make me hear of joy and gladness",
                "that the bones which thou hast broken may rejoice."
            ],
            [
                "Turn thy face from my sins",
                "and put out all my misdeeds."
            ],
            [
                "Make me a clean heart, O God",
                "and renew a right spirit within me."
            ],
            [
                "Cast me not away from thy presence",
                "and take not thy holy Spirit from me."
            ],
            [
                "O give me the comfort of thy help again",
                "and stablish me with thy free Spirit."
            ],
            [
                "Then shall I teach thy ways unto the wicked",
                "and sinners shall be converted unto thee."
            ],
            [
                "Deliver me from blood guiltiness, O God, thou that art the God of my health",
                "and my tongue shall sing of thy righteousness."
            ],
            [
                "Thou shalt open my lips, O Lord",
                "and my mouth shall shew thy praise."
            ],
            [
                "For thou desirest no sacrifice, else would I give it thee",
                "but thou delightest not in burnt offerings."
            ],
            [
                "The sacrifice of God is a troubled spirit",
                "a broken and contrite heart, O God, shalt thou not despise."
            ],
            [
                "O be favourable and gracious unto Sion",
                "build thou the walls of Jerusalem."
            ],
            [
                "Then shalt thou be pleased with the sacrifice of righteousness, with the burnt offerings and oblations",
                "then shall they offer young bullocks upon thine altar."
            ]
        ],
        id: "psalm51"
    },
    {
        lines: [
            [
                "WHY boastest thou thyself, thou tyrant",
                "that thou canst do mischief;"
            ],
            [
                "Whereas the goodness of God",
                "endureth yet daily?"
            ],
            [
                "Thy tongue imagineth wickedness",
                "and with lies thou cuttest like a sharp rasor."
            ],
            [
                "Thou hast loved unrighteousness more then goodness",
                "and to talk of lies more than righteousness."
            ],
            [
                "Thou hast loved to speak all words that may do hurt",
                "O thou false tongue."
            ],
            [
                "Therefore shall God destroy thee for ever",
                "he shall take thee, and pluck thee out of thy dwelling, and root thee out of the land of the living."
            ],
            [
                "The righteous also shall see this, and fear",
                "and shall laugh him to scorn;"
            ],
            [
                "Lo, this is the man that took not God for his strength",
                "but trusted unto the multitude of his riches, and strengthened himself in his wickedness."
            ],
            [
                "As for me, I am like a green olive tree in the house of God",
                "my trust is in the tender mercy of God for ever and ever."
            ],
            [
                "I will always give thanks unto thee for that thou hast done",
                "and I will hope in thy Name, for thy saints like it well."
            ]
        ],
        id: "psalm52"
    },
    {
        lines: [
            [
                "THE foolish body hath said in his heart",
                "There is no God."
            ],
            [
                "Corrupt are they, and become abominable in their wickedness",
                "there is none that doeth good."
            ],
            [
                "God looked down from heaven upon the children of men",
                "to see if there were any that would understand, and seek after God."
            ],
            [
                "But they are all gone out of the way, they are altogether become abominable",
                "there is also none that doeth good, no not one."
            ],
            [
                "Are not they without understanding, that work wickedness",
                "eating up my people as if they would eat bread? they have not called upon God."
            ],
            [
                "They were afraid where no fear was",
                "for God hath broken the bones of him that besieged thee; thou hast put them to confusion, because God hath despised them."
            ],
            [
                "O that the salvation were given unto Israel out of Sion",
                "O that the Lord would deliver his people out of captivity!"
            ],
            [
                "Then should Jacob rejoice",
                "and Israel should be right glad."
            ]
        ],
        id: "psalm53"
    },
    {
        lines: [
            [
                "SAVE me, O God, for thy Name's sake",
                "and avenge me in thy strength."
            ],
            [
                "Hear my prayer, O God",
                "and hearken unto the words of my mouth."
            ],
            [
                "For strangers are risen up against me",
                "and tyrants, which have not God before their eyes, seek after my soul."
            ],
            [
                "Behold, God is my helper",
                "the Lord is with them that uphold my soul."
            ],
            [
                "He shall reward evil unto mine enemies",
                "destroy thou them in thy truth."
            ],
            [
                "An offering of a free heart will I give thee, and praise thy Name, O Lord",
                "because it is so comfortable."
            ],
            [
                "For he hath delivered me out of all my trouble",
                "and mine eye hath seen his desire upon mine enemies."
            ]
        ],
        id: "psalm54"
    },
    {
        lines: [
            [
                "HEAR my prayer, O God",
                "and hide not thyself from my petition."
            ],
            [
                "Take heed unto me, and hear me",
                "how I mourn in my prayer, and am vexed."
            ],
            [
                "The enemy crieth so, and the ungodly cometh on so fast",
                "for they are minded to do me some mischief; so maliciously are they set against me."
            ],
            [
                "My heart is disquieted within me",
                "and the fear of death is fallen upon me."
            ],
            [
                "Fearfulness and trembling are come upon me",
                "and an horrible dread hath overwhelmed me."
            ],
            [
                "And I said, O that I had wings like a dove",
                "for then would I flee away, and be at rest."
            ],
            [
                "Lo, then would I get me away far off",
                "and remain in the wilderness."
            ],
            [
                "I would make haste to escape",
                "because of the stormy wind and tempest."
            ],
            [
                "Destroy their tongues, O Lord, and divide them",
                "for I have spied unrighteousness and strife in the city."
            ],
            [
                "Day and night they go about within the walls thereof",
                "mischief also and sorrow are in the midst of it."
            ],
            [
                "Wickedness is therein",
                "deceit and guile go not out of their streets."
            ],
            [
                "For it is not an open enemy, that hath done me this dishonour",
                "for then I could have borne it."
            ],
            [
                "Neither was it mine adversary, that did magnify himself against me",
                "for then peradventure I would have hid myself from him."
            ],
            [
                "But it was even thou, my companion",
                "my guide, and mine own familiar friend."
            ],
            [
                "We took sweet counsel together",
                "and walked in the house of God as friends."
            ],
            [
                "Let death come hastily upon them, and let them go down quick into hell",
                "for wickedness is in their dwellings, and among them."
            ],
            [
                "As for me, I will call upon God",
                "and the Lord shall save me."
            ],
            [
                "In the evening, and morning, and at noonday will I pray, and that instantly",
                "and he shall hear my voice."
            ],
            [
                "It is he that hath delivered my soul in peace from the battle that was against me",
                "for there were many with me."
            ],
            [
                "Yea, even God, that endureth for ever, shall hear me, and bring them down",
                "for they will not turn, nor fear God."
            ],
            [
                "He laid his hands upon such as be at peace with him",
                "and he brake his covenant."
            ],
            [
                "The words of his mouth were softer than butter, having war in his heart",
                "his words were smoother than oil, and yet be they very swords."
            ],
            [
                "O cast thy burden upon the Lord, and he shall nourish thee",
                "and shall not suffer the righteous to fall for ever."
            ],
            [
                "And as for them",
                "thou, O God, shalt bring them into the pit of destruction."
            ],
            [
                "The blood thirsty and deceitful men shall not live out half their days",
                "nevertheless, my trust shall be in thee, O Lord."
            ]
        ],
        id: "psalm55"
    },
    {
        lines: [
            [
                "BE MERCIFUL unto me, O God, for man goeth about to devour me",
                "he is daily fighting, and troubling me."
            ],
            [
                "Mine enemies are daily in hand to swallow me up",
                "for they be many that fight against me, O thou most Highest."
            ],
            [
                "Nevertheless, though I am sometime afraid",
                "yet put I my trust in thee."
            ],
            [
                "I will praise God, because of his word",
                "I have put my trust in God, and will not fear what flesh can do unto me."
            ],
            [
                "They daily mistake my words",
                "all that they imagine is to do me evil."
            ],
            [
                "They hold all together, and keep themselves close",
                "and mark my steps, when they lay wait for my soul."
            ],
            [
                "Shall they escape for their wickedness",
                "thou, O God, in thy displeasure shalt cast them down."
            ],
            [
                "Thou tellest my flittings; put my tears into thy bottle",
                "are not these things noted in thy book?"
            ],
            [
                "Whensoever I call upon thee, then shall mine enemies be put to flight",
                "this I know; for God is on my side."
            ],
            [
                "In God's word I will rejoice",
                "in the Lord's word will I comfort me."
            ],
            [
                "Yea, in God have I put my trust",
                "I will not be afraid what man can do unto me."
            ],
            [
                "Unto thee, O God, will I pay my vows",
                "unto thee will I give thanks."
            ],
            [
                "For thou hast delivered my soul from death, and my feet from falling",
                "that I may walk before God in the light of the living."
            ]
        ],
        id: "psalm56"
    },
    {
        lines: [
            [
                "BE MERCIFUL unto me, O God, be merciful unto me, for my soul trusteth in thee",
                "and under the shadow of thy wings shall be my refuge, until this tyranny be over past."
            ],
            [
                "I will call unto the most high God",
                "even unto the God that shall perform the cause which I have in hand."
            ],
            [
                "He shall send from heaven",
                "and save me from the reproof of him that would eat me up."
            ],
            [
                "God shall send forth his mercy and truth",
                "my soul is among lions."
            ],
            [
                "And I lie even among the children of men, that are set on fire",
                "whose teeth are spears and arrows, and their tongue a sharp sword"
            ],
            [
                "Set up thyself, O God, above the heavens",
                "and thy glory above all the earth."
            ],
            [
                "They have laid a net for my feet, and pressed down my soul",
                "they have digged a pit before me, and are fallen into the midst of it themselves."
            ],
            [
                "My heart is fixed, O God, my heart is fixed",
                "I will sing, and give praise."
            ],
            [
                "Awake up, my glory; awake, lute and harp",
                "I myself will awake right early."
            ],
            [
                "I will give thanks unto thee, O Lord, among the people",
                "and I will sing unto thee among the nations."
            ],
            [
                "For the greatness of thy mercy reacheth unto the heavens",
                "and thy truth unto the clouds."
            ],
            [
                "Set up thyself, O God, above the heavens",
                "and thy glory above all the earth."
            ]
        ],
        id: "psalm57"
    },
    {
        lines: [
            [
                "ARE your minds set upon righteousness, O ye congregation",
                "and do ye judge the thing that is right, O ye sons of men?"
            ],
            [
                "Yea, ye imagine mischief in your heart upon the earth",
                "and your hands deal with wickedness."
            ],
            [
                "The ungodly are froward, even from their mother's womb",
                "as soon as they are born, they go astray, and speak lies."
            ],
            [
                "They are as venomous as the poison of a serpent",
                "even like the deaf adder that stoppeth her ears;"
            ],
            [
                "Which refuseth to hear the voice of the charmer",
                "charm he never so wisely."
            ],
            [
                "Break their teeth, O God, in their mouths; smite the jaw bones of the lions, O Lord",
                "let them fall away like water that runneth apace; and when they shoot their arrows let them be rooted out."
            ],
            [
                "Let them consume away like a snail, and be like the untimely fruit of a woman",
                "and let them not see the sun."
            ],
            [
                "Or ever your pots be made hot with thorns",
                "so let indignation vex him, even as a thing that is raw."
            ],
            [
                "The righteous shall rejoice when he seeth the vengeance",
                "he shall wash his footsteps in the blood of the ungodly."
            ],
            [
                "So that a man shall say, Verily there is a reward for the righteous",
                "doubtless there is a God that judgeth the earth."
            ]
        ],
        id: "psalm58"
    },
    {
        lines: [
            [
                "DELIVER me from mine enemies, O God",
                "defend me from them that rise up against me."
            ],
            [
                "O deliver me from the wicked doers",
                "and save me from the blood thirsty men."
            ],
            [
                "For lo, they lie waiting for my soul",
                "the mighty men are gathered against me, without any offence or fault of me, O Lord."
            ],
            [
                "They run and prepare themselves without my fault",
                "arise thou therefore to help me, and behold."
            ],
            [
                "Stand up, O Lord God of hosts, thou God of Israel, to visit all the heathen",
                "and be not merciful unto them that offend of malicious wickedness."
            ],
            [
                "They go to and fro in the evening",
                "they grin like a dog, and run about through the city."
            ],
            [
                "Behold, they speak with their mouth, and swords are in their lips",
                "for who doth hear?"
            ],
            [
                "But thou, O Lord, shalt have them in derision",
                "and thou shalt laugh all the heathen to scorn."
            ],
            [
                "My strength will I ascribe unto thee",
                "for thou art the God of my refuge."
            ],
            [
                "God sheweth me his goodness plenteously",
                "and God shall let me see my desire upon mine enemies."
            ],
            [
                "Slay them not, lest my people forget it",
                "but scatter them abroad among the people, and put them down, O Lord, our defence."
            ],
            [
                "For the sin of their mouth, and for the words of their lips, they shall be taken in their pride",
                "and why? their preaching is of cursing and lies."
            ],
            [
                "Consume them in thy wrath, consume them, that they may perish",
                "and know that it is God that ruleth in Jacob, and unto the ends of the world."
            ],
            [
                "And in the evening they will return",
                "grin like a dog, and will go about the city."
            ],
            [
                "They will run here and there for meat",
                "and grudge if they be not satisfied."
            ],
            [
                "As for me, I will sing of thy power, and will praise thy mercy betimes in the morning",
                "for thou hast been my defence and refuge in the day of my trouble."
            ],
            [
                "Unto thee, O my strength, will I sing",
                "for thou, O God, art my refuge, and my merciful God."
            ]
        ],
        id: "psalm59"
    },
    {
        lines: [
            [
                "O GOD, thou hast cast us out, and scattered us abroad",
                "thou hast also been displeased; O turn thee unto us again."
            ],
            [
                "Thou hast moved the land, and divided it",
                "heal the sores thereof, for it shaketh."
            ],
            [
                "Thou hast shewed thy people heavy things",
                "thou hast given us a drink of deadly wine."
            ],
            [
                "Thou hast given a token for such as fear thee",
                "that they may triumph because of the truth."
            ],
            [
                "Therefore were thy beloved delivered",
                "help me with thy right hand, and hear me."
            ],
            [
                "God hath spoken in his holiness, I will rejoice, and divide Sichem",
                "and mete out the valley of Succoth."
            ],
            [
                "Gilead is mine, and Manasses is mine",
                "Ephraim also is the strength of my head; Judah is my law giver;"
            ],
            [
                "Moab is my wash pot; over Edom will I cast out my shoe",
                "Philistia, be thou glad of me."
            ],
            [
                "Who will lead me into the strong city",
                "who will bring me into Edom?"
            ],
            [
                "Hast not thou cast us out, O God",
                "wilt not thou, O God, go out with our hosts?"
            ],
            [
                "O be thou our help in trouble",
                "for vain is the help of man."
            ],
            [
                "Through God will we do great acts",
                "for it is he that shall tread down our enemies."
            ]
        ],
        id: "psalm60"
    },
    {
        lines: [
            [
                "HEAR my crying, O God",
                "give ear unto my prayer."
            ],
            [
                "From the ends of the earth will I call upon thee",
                "when my heart is in heaviness."
            ],
            [
                "O set me up upon the rock that is higher than I",
                "for thou hast been my hope, and a strong tower for me against the enemy."
            ],
            [
                "I will dwell in thy tabernacle for ever",
                "and my trust shall be under the covering of thy wings."
            ],
            [
                "For thou, O Lord, hast heard my desires",
                "and hast given an heritage unto those that fear thy Name."
            ],
            [
                "Thou shalt grant the King a long life",
                "that his years may endure throughout all generations."
            ],
            [
                "He shall dwell before God for ever",
                "O prepare thy loving mercy and faithfulness, that they may preserve him."
            ],
            [
                "So will I always sing praise unto thy Name",
                "that I may daily perform my vows."
            ]
        ],
        id: "psalm61"
    },
    {
        lines: [
            [
                "MY SOUL truly waiteth still upon God",
                "for of him cometh my salvation."
            ],
            [
                "He verily is my strength and my salvation",
                "he is my defence, so that I shall not greatly fall."
            ],
            [
                "How long will ye imagine mischief against every man",
                "ye shall be slain all the sort of you; yea, as a tottering wall shall ye be, and like a broken hedge."
            ],
            [
                "Their device is only how to put him out whom God will exalt",
                "their delight is in lies; they give good words with their mouth, but curse with their heart."
            ],
            [
                "Nevertheless, my soul, wait thou still upon God",
                "for my hope is in him."
            ],
            [
                "He truly is my strength and my salvation",
                "he is my defence, so that I shall not fall."
            ],
            [
                "In God is my health, and my glory",
                "the rock of my might, and in God is my trust."
            ],
            [
                "O put your trust in him alway, ye people",
                "pour out your hearts before him, for God is our hope."
            ],
            [
                "As for the children of men, they are but vanity",
                "the children of men are deceitful upon the weights, they are altogether lighter than vanity itself."
            ],
            [
                "O trust not in wrong and robbery, give not yourselves unto vanity",
                "if riches increase, set not your heart upon them."
            ],
            [
                "God spake once, and twice I have also heard the same",
                "that power belongeth unto God;"
            ],
            [
                "And that thou, Lord, art merciful",
                "for thou rewardest every man according to his work."
            ]
        ],
        id: "psalm62"
    },
    {
        lines: [
            [
                "O GOD, thou art my God",
                "early will I seek thee."
            ],
            [
                "My soul thirsteth for thee, my flesh also longeth after thee",
                "in a barren and dry land where no water is."
            ],
            [
                "Thus have I looked for thee in holiness",
                "that I might behold thy power and glory."
            ],
            [
                "For thy loving kindness is better than the life itself",
                "my lips shall praise thee."
            ],
            [
                "As long as I live will I magnify thee on this manner",
                "and lift up my hands in thy Name."
            ],
            [
                "My soul shall be satisfied, even as it were with marrow and fatness",
                "when my mouth praiseth thee with joyful lips."
            ],
            [
                "Have I not remembered thee in my bed",
                "and thought upon thee when I was waking?"
            ],
            [
                "Because thou hast been my helper",
                "therefore under the shadow of thy wings will I rejoice."
            ],
            [
                "My soul hangeth upon thee",
                "thy right hand hath upholden me."
            ],
            [
                "These also that seek the hurt of my soul",
                "they shall go under the earth."
            ],
            [
                "Let them fall upon the edge of the sword",
                "that they may be a portion for foxes."
            ],
            [
                "But the King shall rejoice in God; all they also that swear by him shall be commended",
                "for the mouth of them that speak lies shall be stopped."
            ]
        ],
        id: "psalm63"
    },
    {
        lines: [
            [
                "HEAR my voice, O God, in my prayer",
                "preserve my life from fear of the enemy."
            ],
            [
                "Hide me from the gathering together of the froward",
                "and from the insurrection of wicked doers;"
            ],
            [
                "Who have whet their tongue like a sword",
                "and shoot out their arrows, even bitter words;"
            ],
            [
                "That they may privily shoot at him that is perfect",
                "suddenly do they hit him, and fear not."
            ],
            [
                "They encourage themselves in mischief",
                "and commune among themselves how they may lay snares, and say that no man shall see them."
            ],
            [
                "They imagine wickedness, and practise it",
                "that they keep secret among themselves, every man in the deep of his heart."
            ],
            [
                "But God shall suddenly shoot at them with a swift arrow",
                "that they shall be wounded."
            ],
            [
                "Yea, their own tongues shall make them fall",
                "insomuch that whoso seeth them shall laugh them to scorn."
            ],
            [
                "And all men that see it shall say, This hath God done",
                "for they shall perceive that it is his work."
            ],
            [
                "The righteous shall rejoice in the Lord, and put his trust in him",
                "and all they that are true of heart shall be glad."
            ]
        ],
        id: "psalm64"
    },
    {
        lines: [
            [
                "THOU, O God, art praised in Sion",
                "and unto thee shall the vow be performed in Jerusalem."
            ],
            [
                "Thou that hearest the prayer",
                "unto thee shall all flesh come."
            ],
            [
                "My misdeeds prevail against me",
                "O be thou merciful unto our sins."
            ],
            [
                "Blessed is the man whom thou choosest, and receivest unto thee",
                "he shall dwell in thy court, and shall be satisfied with the pleasures of thy house, even of thy holy temple."
            ],
            [
                "Thou shalt shew us wonderful things in thy righteousness, O God of our salvation",
                "thou that art the hope of all the ends of the earth, and of them that remain in the broad sea."
            ],
            [
                "Who in his strength setteth fast the mountains",
                "and is girded about with power."
            ],
            [
                "Who stilleth the raging of the sea",
                "and the noise of his waves, and the madness of the people."
            ],
            [
                "They also that dwell in the uttermost parts of the earth shall be afraid at thy tokens",
                "thou that makest the outgoings of the morning and evening to praise thee."
            ],
            [
                "Thou visitest the earth, and blessest it",
                "thou makest it very plenteous."
            ],
            [
                "The river of God is full of water",
                "thou preparest their corn, for so thou providest for the earth."
            ],
            [
                "Thou waterest her furrows, thou sendest rain into the little valleys thereof",
                "thou makest it soft with the drops of rain, and blessest the increase of it."
            ],
            [
                "Thou crownest the year with thy goodness",
                "and thy clouds drop fatness."
            ],
            [
                "They shall drop upon the dwellings of the wilderness",
                "and the little hills shall rejoice on ev'ry side."
            ],
            [
                "The folds shall be full of sheep",
                "the valleys also shall stand so thick with corn, that they shall laugh and sing."
            ]
        ],
        id: "psalm65"
    },
    {
        lines: [
            [
                "O BE joyful in God, all ye lands",
                "sing praises unto the honour of his Name, make his praise to be glorious."
            ],
            [
                "Say unto God, O how wonderful art thou in thy works",
                "through the greatness of thy power shall thine enemies be found liars unto thee."
            ],
            [
                "For all the world shall worship thee",
                "sing of thee, and praise thy Name."
            ],
            [
                "O come hither, and behold the works of God",
                "how wonderful he is in his doing toward the children of men."
            ],
            [
                "He turned the sea into dry land",
                "so that they went through the water on foot; there did we rejoice thereof."
            ],
            [
                "He ruleth with his power for ever; his eyes behold the people",
                "and such as will not believe shall not be able to exalt themselves."
            ],
            [
                "O praise our God, ye people",
                "and make the voice of his praise to be heard;"
            ],
            [
                "Who holdeth our soul in life",
                "and suffereth not our feet to slip."
            ],
            [
                "For thou, O God, hast proved us",
                "thou also hast tried us, like as silver is tried."
            ],
            [
                "Thou broughtest us into the snare",
                "and laidest trouble upon our loins."
            ],
            [
                "Thou sufferedst men to ride over our heads",
                "we went through fire and water, and thou broughtest us out into a wealthy place."
            ],
            [
                "I will go into thine house with burnt offerings",
                "and will pay thee my vows, which I promised with my lips, and spake with my mouth, when I was in trouble."
            ],
            [
                "I will offer unto thee fat burnt sacrifices, with the incense of rams",
                "I will offer bullocks and goats."
            ],
            [
                "O come hither, and hearken, all ye that fear God",
                "and I will tell you what he hath done for my soul."
            ],
            [
                "I called unto him with my mouth",
                "and gave him praises with my tongue."
            ],
            [
                "If I incline unto wickedness with mine heart",
                "the Lord will not hear me."
            ],
            [
                "But God hath heard me",
                "and considered the voice of my prayer."
            ],
            [
                "Praised be God, who hath not cast out my prayer",
                "nor turned his mercy from me."
            ]
        ],
        id: "psalm66"
    },
    {
        lines: [
            [
                "GOD be merciful unto us, and bless us",
                "and shew us the light of his countenance, and be merciful unto us;"
            ],
            [
                "That thy way may be known upon earth",
                "thy saving health among all nations."
            ],
            [
                "Let the people praise thee, O God",
                "yea, let all the people praise thee."
            ],
            [
                "O let the nations rejoice and be glad",
                "for thou shalt judge the folk righteously, and govern the nations upon earth."
            ],
            [
                "Let the people praise thee, O God",
                "let all the people praise thee."
            ],
            [
                "Then shall the earth bring forth her increase",
                "and God, even our own God, shall give us his blessing."
            ],
            [
                "God shall bless us",
                "and all the ends of the world shall fear him."
            ]
        ],
        id: "psalm67"
    },
    {
        lines: [
            [
                "LET God arise, and let his enemies be scattered",
                "let them also that hate him flee before him."
            ],
            [
                "Like as the smoke vanisheth, so shalt thou drive them away",
                "and like as wax melteth at the fire, so let the ungodly perish at the presence of God."
            ],
            [
                "But let the righteous be glad and rejoice before God",
                "let them also be merry and joyful."
            ],
            [
                "O sing unto God, and sing praises unto his Name",
                "magnify him that rideth upon the heavens, as it were upon an horse; praise him in his Name JAH, and rejoice before him."
            ],
            [
                "He is a father of the fatherless, and defendeth the cause of the widows",
                "even God in his holy habitation."
            ],
            [
                "He is the God that maketh men to be of one mind in an house, and bringeth the prisoners out of captivity",
                "but letteth the runagates continue in scarceness."
            ],
            [
                "O God, when thou wentest forth before the people",
                "when thou wentest through the wilderness;"
            ],
            [
                "The earth shook, and the heavens dropped at the presence of God",
                "even as Sinai also was moved at the presence of God, who is the God of Israel."
            ],
            [
                "Thou, O God, sentest a gracious rain upon thine inheritance",
                "and refreshedst it when it was weary."
            ],
            [
                "Thy congregation shall dwell therein",
                "for thou, O God, hast of thy goodness prepared for the poor."
            ],
            [
                "The Lord gave the word",
                "great was the company of the preachers."
            ],
            [
                "Kings with their armies did flee, and were discomfited",
                "and they of the household divided the spoil."
            ],
            [
                "Though ye have lien among the pots, yet shall ye be as the wings of a dove",
                "that is covered with silver wings, and her feathers like gold."
            ],
            [
                "When the Almighty scattered kings for their sake",
                "then were they as white as snow in Salmon."
            ],
            [
                "As the hill of Basan, so is God's hill",
                "even an high hill, as the hill of Basan."
            ],
            [
                "Why hop ye so, ye high hills? this is God's hill, in the which it pleaseth him to dwell",
                "yea, the Lord will abide in it for ever."
            ],
            [
                "The chariots of God are twenty thousand, even thousands of angels",
                "and the Lord is among them, as in the holy place of Sinai."
            ],
            [
                "Thou art gone up on high, thou hast led captivity captive, and received gifts for men",
                "yea, even for thine enemies, that the Lord God might dwell among them."
            ],
            [
                "Praised be the Lord daily",
                "even the God who helpeth us, and poureth his benefits upon us."
            ],
            [
                "He is our God, even the God of whom cometh salvation",
                "God is the Lord, by whom we escape death."
            ],
            [
                "God shall wound the head of his enemies",
                "and the hairy scalp of such a one as goeth on still in his wickedness."
            ],
            [
                "The Lord hath said, I will bring my people again, as I did from Basan",
                "mine own will I bring again, as I did sometime from the deep of the sea."
            ],
            [
                "That thy foot may be dipped in the blood of thine enemies",
                "and that the tongue of thy dogs may be red through the same."
            ],
            [
                "It is well seen, O God, how thou goest",
                "how thou, my God and King, goest in the sanctuary."
            ],
            [
                "The singers go before, the minstrels follow after",
                "in the midst are the damsels playing with the timbrels."
            ],
            [
                "Give thanks, O Israel, unto God the Lord in the congregations",
                "from the ground of the heart."
            ],
            [
                "There is little Benjamin their ruler, and the princes of Judah their counsel",
                "the princes of Zabulon, and the princes of Nephthali."
            ],
            [
                "Thy God hath sent forth strength for thee",
                "stablish the thing, O God, that thou hast wrought in us,"
            ],
            [
                "For thy temple's sake at Jerusalem",
                "so shall kings bring presents unto thee."
            ],
            [
                "When the company of the spear men, and multitude of the mighty are scattered abroad among the beasts of the people, so that they humbly bring pieces of silver",
                "and when he hath scattered the people that delight in war;"
            ],
            [
                "Then shall the princes come out of Eqypt",
                "the Morians' land shall soon stretch our her hands unto God."
            ],
            [
                "Sing unto God, O ye kingdoms of the earth",
                "O sing praises unto the Lord;"
            ],
            [
                "Who sitteth in the heavens over all from the beginning",
                "lo, he doth send out his voice, yea, and that a mighty voice."
            ],
            [
                "Ascribe ye the power to God over Israel",
                "his worship and strength is in the clouds."
            ],
            [
                "O God, wonderful art thou in thy holy places",
                "even the God of Israel, he will give strength and power unto his people; blessed be God."
            ]
        ],
        id: "psalm68"
    },
    {
        lines: [
            [
                "SAVE me, O God",
                "for the waters are come in, even unto my soul."
            ],
            [
                "I stick fast in the deep mire, where no ground is",
                "I am come into deep waters, so that the floods run over me."
            ],
            [
                "I am weary of crying; my throat is dry",
                "my sight faileth me for waiting so long upon my God."
            ],
            [
                "They that hate me without a cause are more than the hairs of my head",
                "they that are mine enemies, and would destroy me guiltless, are mighty."
            ],
            [
                "I paid them the things that I never took",
                "God, thou knowest my simpleness, and my faults are not hid from thee."
            ],
            [
                "Let not them that trust in thee, O Lord God of hosts, be ashamed for my cause",
                "let not those that seek thee be confounded through me, O Lord God of Israel."
            ],
            [
                "And why? for thy sake have I suffered reproof",
                "shame hath covered my face."
            ],
            [
                "I am become a stranger unto my brethren",
                "even an alien unto my mother's children."
            ],
            [
                "For the zeal of thine house hath even eaten me",
                "and the rebukes of them that rebuked thee are fallen upon me."
            ],
            [
                "I wept, and chastened myself with fasting",
                "and that was turned to my reproof."
            ],
            [
                "I put on sackcloth also",
                "and they jested upon me."
            ],
            [
                "They that sit in the gate speak against me",
                "and the drunkards make songs upon me."
            ],
            [
                "But, Lord, I make my prayer unto thee",
                "in an acceptable time."
            ],
            [
                "Hear me, O God, in the multitude of thy mercy",
                "even in the truth of thy salvation."
            ],
            [
                "Take me out of the mire, that I sink not",
                "O let me be delivered from them that hate me, and out of the deep waters."
            ],
            [
                "Let not the water flood drown me, neither let the deep swallow me up",
                "and let not the pit shut her mouth upon me."
            ],
            [
                "Hear me, O Lord, for thy loving kindness is comfortable",
                "turn thee unto me according to the multitude of thy mercies."
            ],
            [
                "And hide not thy face from thy servant, for I am in trouble",
                "O haste thee, and hear me."
            ],
            [
                "Draw nigh unto my soul, and save it",
                "O deliver me, because of mine enemies."
            ],
            [
                "Thou hast known my reproof, my shame, and my dishonour",
                "mine adversaries are all in thy sight."
            ],
            [
                "Thy rebuke hath broken my heart; I am full of heaviness",
                "I looked for some to have pity on me, but there was no man, neither found I any to comfort me."
            ],
            [
                "They gave me gall to eat",
                "and when I was thirsty they gave me vinegar to drink."
            ],
            [
                "Let their table be made a snare to take themselves withal",
                "and let the things that should have been for their wealth be unto them an occasion of falling."
            ],
            [
                "Let their eyes be blinded, that they see not",
                "and ever bow thou down their backs."
            ],
            [
                "Pour out thine indignation upon them",
                "and let thy wrathful displeasure take hold of them."
            ],
            [
                "Let their habitation be void",
                "and no man to dwell in their tents."
            ],
            [
                "For they persecute him whom thou hast smitten",
                "and they talk how they may vex them whom thou hast wounded."
            ],
            [
                "Let them fall from one wickedness to another",
                "and not come into thy righteousness."
            ],
            [
                "Let them be wiped out of the book of the living",
                "and not be written among the righteous."
            ],
            [
                "As for me, when I am poor and in heaviness",
                "thy help, O God, shall lift me up."
            ],
            [
                "I will praise the Name of God with a song",
                "and magnify it with thanksgiving."
            ],
            [
                "This also shall please the Lord",
                "better than a bullock that hath horns and hoofs."
            ],
            [
                "The humble shall consider this, and be glad",
                "seek ye after God, and your soul shall live."
            ],
            [
                "For the Lord heareth the poor",
                "and despiseth not his prisoners."
            ],
            [
                "Let heaven and earth praise him",
                "the sea, and all that moveth therein."
            ],
            [
                "For God will save Sion, and build the cities of Judah",
                "that men may dwell there, and have it in possession."
            ],
            [
                "The posterity also of his servants shall inherit it",
                "and they that love his Name shall dwell therein."
            ]
        ],
        id: "psalm69"
    },
    {
        lines: [
            [
                "HASTE thee, O God, to deliver me",
                "make haste to help me, O Lord."
            ],
            [
                "Let them be ashamed and confounded that seek after my soul",
                "let them be turned backward and put to confusion that wish me evil."
            ],
            [
                "Let them for their reward be soon brought to shame",
                "that cry over me, There, there."
            ],
            [
                "But let all those that seek thee be joyful and glad in thee",
                "and let all such as delight in thy salvation say alway, The Lord be praised."
            ],
            [
                "As for me, I am poor and in misery",
                "haste thee unto me, O God."
            ],
            [
                "Thou art my helper and my redeemer",
                "O Lord, make no long tarrying."
            ]
        ],
        id: "psalm70"
    },
    {
        lines: [
            [
                "IN THEE, O Lord, have I put my trust, let me never be put to confusion",
                "but rid me and deliver me in thy righteousness, incline thine ear unto me, and save me."
            ],
            [
                "Be thou my strong hold, whereunto I may alway resort",
                "thou hast promised to help me, for thou art my house of defence and my castle."
            ],
            [
                "Deliver me, O my God, out of the hand of the ungodly",
                "out of the hand of the unrighteous and cruel man."
            ],
            [
                "For thou, O Lord God, art the thing that I long for",
                "thou art my hope, even from my youth."
            ],
            [
                "Through thee have I been holden up ever since I was born",
                "thou art he that took me out of my mother's womb; my praise shall be always of thee."
            ],
            [
                "I am become as it were a monster unto many",
                "but my sure trust is in thee."
            ],
            [
                "O let my mouth be filled with thy praise",
                "that I may sing of thy glory and honour all the day long."
            ],
            [
                "Cast me not away in the time of age",
                "forsake me not when my strength faileth me."
            ],
            [
                "For mine enemies speak against me, and they that lay wait for my soul take their counsel together, saying",
                "God hath forsaken him; persecute him, and take him, for there is none to deliver him."
            ],
            [
                "Go not far from me, O God",
                "my God, haste thee to help me."
            ],
            [
                "Let them be confounded and perish that are against my soul",
                "let them be covered with shame and dishonour that seek to do me evil."
            ],
            [
                "As for me, I will patiently abide alway",
                "and will praise thee more and more."
            ],
            [
                "My mouth shall daily speak of thy righteousness and salvation",
                "for I know no end thereof."
            ],
            [
                "I will go forth in the strength of the Lord God",
                "and will make mention of thy righteousness only."
            ],
            [
                "Thou, O God, hast taught me from my youth up until now",
                "therefore will I tell of thy wondrous works."
            ],
            [
                "Forsake me not, O God, in mine old age, when I am gray headed",
                "until I have shewed thy strength unto this generation, and thy power to all them that are yet for to come."
            ],
            [
                "Thy righteousness, O God, is very high",
                "and great things are they that thou hast done; O God, who is like unto thee?"
            ],
            [
                "O what great troubles and adversities hast thou shewed me, and yet didst thou turn and refresh me",
                "yea, and broughtest me from the deep of the earth again."
            ],
            [
                "Thou hast brought me to great honour",
                "and comforted me on ev'ry side."
            ],
            [
                "Therefore will I praise thee and thy faithfulness, O God, playing upon an instrument of musick",
                "unto thee will I sing upon the harp, O thou Holy One of Israel."
            ],
            [
                "My lips will be fain when I sing unto thee",
                "and so will my soul whom thou hast delivered."
            ],
            [
                "My tongue also shall talk of thy righteousness all the day long",
                "for they are confounded and brought unto shame that seek to do me evil."
            ]
        ],
        id: "psalm71"
    },
    {
        lines: [
            [
                "GIVE the King thy judgements, O God",
                "and thy righteousness unto the King's son."
            ],
            [
                "Then shall he judge thy people according unto right",
                "and defend the poor."
            ],
            [
                "The mountains also shall bring peace",
                "and the little hills righteousness unto the people."
            ],
            [
                "He shall keep the simple folk by their right",
                "defend the children of the poor, and punish the wrong doer."
            ],
            [
                "They shall fear thee, as long as the sun and moon endureth",
                "from one generation to another."
            ],
            [
                "He shall come down like the rain into a fleece of wool",
                "even as the drops that water the earth."
            ],
            [
                "In his time shall the righteous flourish",
                "yea, and abundance of peace, so long as the moon endureth."
            ],
            [
                "His dominion shall be also from the one sea to the other",
                "and from the flood unto the world's end."
            ],
            [
                "They that dwell in the wilderness shall kneel before him",
                "his enemies shall lick the dust."
            ],
            [
                "The kings of Tharsis and of the isles shall give presents",
                "the kings of Arabia and Saba shall bring gifts."
            ],
            [
                "All kings shall fall down before him",
                "all nations shall do him service."
            ],
            [
                "For he shall deliver the poor when he crieth",
                "the needy also, and him that hath no helper."
            ],
            [
                "He shall be favourable to the simple and needy",
                "and shall preserve the souls of the poor."
            ],
            [
                "He shall deliver their souls from falsehood and wrong",
                "and dear shall their blood be in his sight."
            ],
            [
                "He shall live, and unto him shall be given of the gold of Arabia",
                "prayer shall be made ever unto him, and daily shall he be praised."
            ],
            [
                "There shall be an heap of corn in the earth, high upon the hills",
                "his fruit shall shake like Libanus, and shall be green in the city like grass upon the earth."
            ],
            [
                "His Name shall endure for ever; his Name shall remain under the sun among the posterities",
                "which shall be blessed through him; and all the heathen shall praise him."
            ],
            [
                "Blessed be the Lord God, even the God of Israel",
                "which only doeth wondrous things;"
            ],
            [
                "And blessed be the Name of his majesty for ever",
                "and all the earth shall be filled with his majesty. Amen, Amen."
            ]
        ],
        id: "psalm72"
    },
    {
        lines: [
            [
                "TRULY God is loving unto Israel",
                "even unto such as are of a clean heart."
            ],
            [
                "Nevertheless, my feet were almost gone",
                "my treadings had well nigh slipt."
            ],
            [
                "And why? I was grieved at the wicked",
                "I do also see the ungodly in such prosperity."
            ],
            [
                "For they are in no peril of death",
                "but are lusty and strong."
            ],
            [
                "They come in no misfortune like other folk",
                "neither are they plagued like other men."
            ],
            [
                "And this is the cause that they are so holden with pride",
                "and overwhelmed with cruelty."
            ],
            [
                "Their eyes swell with fatness",
                "and they do even what they lust."
            ],
            [
                "They corrupt other, and speak of wicked blasphemy",
                "their talking is against the most High."
            ],
            [
                "For they stretch forth their mouth unto the heaven",
                "and their tongue goeth through the world."
            ],
            [
                "Therefore fall the people unto them",
                "and thereout suck they no small advantage."
            ],
            [
                "Tush, say they, how should God perceive it",
                "is there knowledge in the most High?"
            ],
            [
                "Lo, these are the ungodly, these prosper in the world, and these have riches in possession",
                "and I said, Then have I cleansed my heart in vain, and washed mine hands in innocency."
            ],
            [
                "All the day long have I been punished",
                "and chastened every morning."
            ],
            [
                "Yea, and I had almost said even as they",
                "but lo, then I should have condemned the generation of thy children."
            ],
            [
                "Then thought I to understand this",
                "but it was too hard for me,"
            ],
            [
                "Until I went into the sanctuary of God",
                "then understood I the end of these men;"
            ],
            [
                "Namely, how thou dost set them in slippery places",
                "and castest them down, and destroyest them."
            ],
            [
                "O how suddenly do they consume",
                "perish, and come to a fearful end!"
            ],
            [
                "Yea, even like as a dream when one awaketh",
                "so shalt thou make their image to vanish out of the city."
            ],
            [
                "Thus my heart was grieved",
                "and it went even through my reins."
            ],
            [
                "So foolish was I, and ignorant",
                "even as it were a beast before thee."
            ],
            [
                "Nevertheless, I am alway by thee",
                "for thou hast holden me by my right hand."
            ],
            [
                "Thou shalt guide me with thy counsel",
                "and after that receive me with glory."
            ],
            [
                "Whom have I in heaven but thee",
                "and there is none upon earth that I desire in comparison of thee."
            ],
            [
                "My flesh and my heart faileth",
                "but God is the strength of my heart, and my portion for ever."
            ],
            [
                "For lo, they that forsake thee shall perish",
                "thou hast destroyed all them that commit fornication against thee."
            ],
            [
                "But it is good for me to hold me fast by God, to put my trust in the Lord God",
                "and to speak of all thy works in the gates of the daughter of Sion."
            ]
        ],
        id: "psalm73"
    },
    {
        lines: [
            [
                "O GOD, wherefore art thou absent from us so long",
                "why is thy wrath so hot against the sheep of thy pasture?"
            ],
            [
                "O think upon thy congregation",
                "whom thou hast purchased and redeemed of old."
            ],
            [
                "Think upon the tribe of thine inheritance",
                "and mount Sion, wherein thou hast dwelt."
            ],
            [
                "Lift up thy feet, that thou mayest utterly destroy every enemy",
                "which hath done evil in thy sanctuary."
            ],
            [
                "Thine adversaries roar in the midst of thy congregations",
                "and set up their banners for tokens."
            ],
            [
                "He that hewed timber afore out of the thick trees",
                "was known to bring it to an excellent work."
            ],
            [
                "But now they break down all the carved work thereof",
                "with axes and hammers."
            ],
            [
                "They have set fire upon thy holy places",
                "and have defiled the dwelling place of thy Name, even unto the ground."
            ],
            [
                "Yea, they said in their hearts, Let us make havock of them altogether",
                "thus have they burnt up all the houses of God in the land."
            ],
            [
                "We see not our tokens, there is not one prophet more",
                "no, not one is there among us, that understandeth any more."
            ],
            [
                "O God, how long shall the adversary do this dishonour",
                "how long shall the enemy blaspheme thy Name, for ever?"
            ],
            [
                "Why withdrawest thou thy hand",
                "why pluckest thou not thy right hand out of thy bosom to consume the enemy?"
            ],
            [
                "For God is my King of old",
                "the help that is done upon earth he doeth it himself."
            ],
            [
                "Thou didst divide the sea through thy power",
                "thou brakest the heads of the dragons in the waters."
            ],
            [
                "Thou smotest the heads of Leviathan in pieces",
                "and gavest him to be meat for the people in the wilderness."
            ],
            [
                "Thou broughtest out fountains and waters out of the hard rocks",
                "thou driedst up mighty waters."
            ],
            [
                "The day is thine, and the night is thine",
                "thou hast prepared the light and the sun."
            ],
            [
                "Thou hast set all the borders of the earth",
                "thou hast made summer and winter."
            ],
            [
                "Remember this, O Lord, how the enemy hath rebuked",
                "and how the foolish people hath blasphemed thy Name."
            ],
            [
                "O deliver not the soul of thy turtle dove unto the multitude of the enemies",
                "and forget not the congregation of the poor for ever."
            ],
            [
                "Look upon the covenant",
                "for all the earth is full of darkness and cruel habitations."
            ],
            [
                "O let not the simple go away ashamed",
                "but let the poor and needy give praise unto thy Name."
            ],
            [
                "Arise, O God, maintain thine own cause",
                "remember how the foolish man blasphemeth thee daily."
            ],
            [
                "Forget not the voice of thine enemies",
                "the presumption of them that hate thee increaseth ever more and more."
            ]
        ],
        id: "psalm74"
    },
    {
        lines: [
            [
                "UNTO thee, O God, do we give thanks",
                "yea, unto thee do we give thanks."
            ],
            [
                "Thy Name also is so nigh",
                "and that do thy wondrous works declare."
            ],
            [
                "When I receive the congregation",
                "I shall judge according unto right."
            ],
            [
                "The earth is weak, and all the inhabiters thereof",
                "I bear up the pillars of it."
            ],
            [
                "I said unto the fools, Deal not so madly",
                "and to the ungodly, Set not up your horn."
            ],
            [
                "Set not up your horn on high",
                "and speak not with a stiff neck."
            ],
            [
                "For promotion cometh neither from the east, nor from the west",
                "nor yet from the south."
            ],
            [
                "And why? God is the Judge",
                "he putteth down one, and setteth up another."
            ],
            [
                "For in the hand of the Lord there is a cup, and the wine is red",
                "it is full mixed, and he poureth out of the same."
            ],
            [
                "As for the dregs thereof",
                "all the ungodly of the earth shall drink them, and suck them out."
            ],
            [
                "But I will talk of the God of Jacob",
                "and praise him for ever."
            ],
            [
                "All the horns of the ungodly also will I break",
                "and the horns of the righteous shall be exalted."
            ]
        ],
        id: "psalm75"
    },
    {
        lines: [
            [
                "IN JEWRY is God known",
                "his Name is great in Israel."
            ],
            [
                "At Salem is his tabernacle",
                "and his dwelling in Sion."
            ],
            [
                "There brake he the arrows of the bow",
                "the shield, the sword, and the battle."
            ],
            [
                "Thou art of more honour and might",
                "than the hills of the robbers."
            ],
            [
                "The proud are robbed, they have slept their sleep",
                "and all the men whose hands were mighty have found nothing."
            ],
            [
                "At thy rebuke, O God of Jacob",
                "both the chariot and horse are fallen."
            ],
            [
                "Thou, even thou art to be feared",
                "and who may stand in thy sight when thou art angry?"
            ],
            [
                "Thou didst cause thy judgement to be heard from heaven",
                "the earth trembled, and was still;"
            ],
            [
                "When God arose to judgement",
                "and to help all the meek upon earth."
            ],
            [
                "The fierceness of man shall turn to thy praise",
                "and the fierceness of them shalt thou refrain."
            ],
            [
                "Promise unto the Lord your God, and keep it, all ye that are round about him",
                "bring presents unto him that ought to be feared."
            ],
            [
                "He shall refrain the spirit of princes",
                "and is wonderful among the kings of the earth."
            ]
        ],
        id: "psalm76"
    },
    {
        lines: [
            [
                "I WILL cry unto God with my voice",
                "even unto God will I cry with my voice, and he shall hearken unto me."
            ],
            [
                "In the time of my trouble I sought the Lord",
                "my sore ran and ceased not in the night season ; my soul refused comfort."
            ],
            [
                "When I am in heaviness, I will think upon God",
                "when my heart is vexed, I will complain."
            ],
            [
                "Thou holdest mine eyes waking",
                "I am so feeble, that I cannot speak."
            ],
            [
                "I have considered the days of old",
                "and the years that are past."
            ],
            [
                "I call to remembrance my song",
                "and in the night I commune with mine own heart, and search out my spirits."
            ],
            [
                "Will the Lord absent himself for ever",
                "and will he be no more intreated?"
            ],
            [
                "Is his mercy clean gone for ever",
                "and is his promise come utterly to an end for evermore?"
            ],
            [
                "Hath God forgotten to be gracious",
                "and will he shut up his loving kindness in displeasure?"
            ],
            [
                "And I said, It is mine own infirmity",
                "but I will remember the years of the right hand of the most Highest."
            ],
            [
                "I will remember the works of the Lord",
                "and call to mind thy wonders of old time."
            ],
            [
                "I will think also of all thy works",
                "and my talking shall be of thy doings."
            ],
            [
                "Thy way, O God, is holy",
                "who is so great a God as our God?"
            ],
            [
                "Thou art the God that doeth wonders",
                "and hast declared thy power among the people."
            ],
            [
                "Thou hast mightily delivered thy people",
                "even the sons of Jacob and Joseph."
            ],
            [
                "The waters saw thee, O God, the waters saw thee, and were afraid",
                "the depths also were troubled."
            ],
            [
                "The clouds poured out water, the air thundered",
                "and thine arrows went abroad."
            ],
            [
                "The voice of thy thunder was heard round about",
                "the lightnings shone upon the ground; the earth was moved, and shook withal."
            ],
            [
                "Thy way is in the sea, and thy paths in the great waters",
                "and thy footsteps are not known."
            ],
            [
                "Thou leddest thy people like sheep",
                "by the hand of Moses and Aaron."
            ]
        ],
        id: "psalm77"
    },
    {
        lines: [
            [
                "HEAR my law, O my people",
                "incline your ears unto the words of my mouth."
            ],
            [
                "I will open my mouth in a parable",
                "I will declare hard sentences of old;"
            ],
            [
                "Which we have heard and known",
                "and such as our fathers have told us;"
            ],
            [
                "That we should not hide them from the children of the generations to come",
                "but to shew the honour of the Lord, his mighty and wonderful works that he hath done."
            ],
            [
                "He made a covenant with Jacob, and gave Israel a law",
                "which he commanded our forefathers to teach their children;"
            ],
            [
                "That their posterity might know it",
                "and the children which were yet unborn;"
            ],
            [
                "To the intent that when they came up",
                "they might shew their children the same;"
            ],
            [
                "That they might put their trust in God",
                "and not to forget the works of God, but to keep his commandments;"
            ],
            [
                "And not to be as their forefathers, a faithless and stubborn generation",
                "a generation that set not their heart aright, and whose spirit cleaveth not stedfastly unto God;"
            ],
            [
                "Like as the children of Ephraim",
                "who being harnessed, and carrying bows, turned themselves back in the day of battle."
            ],
            [
                "They kept not the covenant of God",
                "and would not walk in his law;"
            ],
            [
                "But forgat what he had done",
                "and the wonderful works that he had shewed for them."
            ],
            [
                "Marvellous things did he in the sight of our forefathers, in the land of Egypt",
                "even in the field of Zoan."
            ],
            [
                "He divided the sea, and let them go through",
                "he made the waters to stand on an heap."
            ],
            [
                "In the day time also he led them with a cloud",
                "and all the night through with a light of fire."
            ],
            [
                "He clave the hard rocks in the wilderness",
                "and gave them drink thereof, as it had been out of the great depth."
            ],
            [
                "He brought waters out of the stony rock",
                "so that it gushed out like the rivers."
            ],
            [
                "Yet for all this they sinned more against him",
                "and provoked the most Highest in the wilderness."
            ],
            [
                "They tempted God in their hearts",
                "and required meat for their lust."
            ],
            [
                "They spake against God also, saying",
                "Shall God prepare a table in the wilderness?"
            ],
            [
                "He smote the stony rock indeed, that the waters gushed out, and the streams flowed withal",
                "but can he give bread also, or provide flesh for his people?"
            ],
            [
                "When the Lord heard this, he was wroth",
                "so the fire was kindled in Jacob, and there came up heavy displeasure against Israel;"
            ],
            [
                "Because they believed not in God",
                "and put not their trust in his help."
            ],
            [
                "So he commanded the clouds above",
                "and opened the doors of heaven."
            ],
            [
                "He rained down manna also upon them for to eat",
                "and gave them food from heaven."
            ],
            [
                "So man did eat angels' food",
                "for he sent them meat enough."
            ],
            [
                "He caused the east wind to blow under heaven",
                "and through his power he brought in the south west wind."
            ],
            [
                "He rained flesh upon them as thick as dust",
                "and feathered fowls like as the sand of the sea."
            ],
            [
                "He let it fall among their tents",
                "even round about their habitation."
            ],
            [
                "So they did eat and were well filled, for he gave them their own desire",
                "they were not disappointed of their lust."
            ],
            [
                "But while the meat was yet in their mouths, the heavy wrath of God came upon them, and slew the wealthiest of them",
                "yea, and smote down the chosen men that were in Israel."
            ],
            [
                "But for all this they sinned yet more",
                "and believed not his wondrous works."
            ],
            [
                "Therefore their days did he consume in vanity",
                "and their years in trouble."
            ],
            [
                "When he slew them, they sought him",
                "and turned them early, and inquired after God."
            ],
            [
                "And they remembered that God was their strength",
                "and that the high God was their redeemer."
            ],
            [
                "Nevertheless, they did but flatter him with their mouth",
                "and dissembled with him in their tongue."
            ],
            [
                "For their heart was not whole with him",
                "neither continued they stedfast in his covenant."
            ],
            [
                "But he was so merciful, that he forgave their misdeeds",
                "and destroyed them not."
            ],
            [
                "Yea, many a time turned he his wrath away",
                "and would not suffer his whole displeasure to arise."
            ],
            [
                "For he considered that they were but flesh",
                "and that they were even a wind that passeth away, and cometh not again."
            ],
            [
                "Many a time did they provoke him in the wilderness",
                "and grieved him in the desert."
            ],
            [
                "They turned back, and tempted God",
                "and moved the Holy One in Israel."
            ],
            [
                "They thought not of his hand",
                "and of the day when he delivered them from the hand of the enemy;"
            ],
            [
                "How he had wrought his miracles in Egypt",
                "and his wonders in the field of Zoan."
            ],
            [
                "He turned their waters into blood",
                "so that they might not drink of the rivers."
            ],
            [
                "He sent lice among them, and devoured them up",
                "and frogs to destroy them."
            ],
            [
                "He gave their fruit unto the caterpillar",
                "and their labour unto the grass hopper."
            ],
            [
                "He destroyed their vines with hail stones",
                "and their mulberry trees with the frost."
            ],
            [
                "He smote their cattle also with hail stones",
                "and their flocks with hot thunderbolts."
            ],
            [
                "He cast upon them the furiousness of his wrath, anger, displeasure and trouble",
                "and sent evil angels among them."
            ],
            [
                "He made a way to his indignation, and spared not their soul from death",
                "but gave their life over to the pestilence;"
            ],
            [
                "And smote all the first born in Egypt",
                "the most principal and mightiest in the dwellings of Ham."
            ],
            [
                "But as for his own people, he led them forth like sheep",
                "and carried them in the wilderness like a flock."
            ],
            [
                "He brought them out safely, that they should not fear",
                "and overwhelmed their enemies with the sea."
            ],
            [
                "And brought them within the borders of his sanctuary",
                "even to his mountain which he purchased with his right hand."
            ],
            [
                "He cast out the heathen also before them",
                "caused their land to be divided among them for an heritage, and made the tribes of Israel to dwell in their tents."
            ],
            [
                "So they tempted and displeased the most high God",
                "and kept not his testimonies;"
            ],
            [
                "But turned their backs, and fell away like their forefathers",
                "starting aside like a broken bow."
            ],
            [
                "For they grieved him with their hill altars",
                "and provoked him to displeasure with their images."
            ],
            [
                "When God heard this, he was wroth",
                "and took sore displeasure at Israel."
            ],
            [
                "So that he forsook the tabernacle in Silo",
                "even the tent that he had pitched among men."
            ],
            [
                "He delivered their power into captivity",
                "and their beauty into the enemy's hand."
            ],
            [
                "He gave his people over also unto the sword",
                "and was wroth with his inheritance."
            ],
            [
                "The fire consumed their young men",
                "and their maidens were not given to marriage."
            ],
            [
                "Their priests were slain with the sword",
                "and there were no widows to make lamentation."
            ],
            [
                "So the Lord awaked as one out of sleep",
                "and like a giant refreshed with wine."
            ],
            [
                "He smote his enemies in the hinder parts",
                "and put them to a perpetual shame."
            ],
            [
                "He refused the tabernacle of Joseph",
                "and chose not the tribe of Ephraim;"
            ],
            [
                "But chose the tribe of Judah",
                "even the hill of Sion which he loved."
            ],
            [
                "And there he built his temple on high",
                "and laid the foundation of it like the ground which he hath made continually."
            ],
            [
                "He chose David also his servant",
                "and took him away from the sheep folds."
            ],
            [
                "As he was following the ewes great with young ones he took him",
                "that he might feed Jacob his people, and Israel his inheritance."
            ],
            [
                "So he fed them with a faithful and true heart",
                "and ruled them prudently with all his power."
            ]
        ],
        id: "psalm78"
    },
    {
        lines: [
            [
                "O GOD, the heathen are come into thine inheritance",
                "thy holy temple have they defiled, and made Jerusalem an heap of stones."
            ],
            [
                "The dead bodies of thy servants have they given to be meat unto the fowls of the air",
                "and the flesh of thy saints unto the beasts of the land."
            ],
            [
                "Their blood have they shed like water on every side of Jerusalem",
                "and there was no man to bury them."
            ],
            [
                "We are become an open shame to our enemies",
                "a very scorn and derision unto them that are round about us."
            ],
            [
                "Lord, how long wilt thou be angry",
                "shall thy jealousy burn like fire for ever?"
            ],
            [
                "Pour out thine indignation upon the heathen that have not known thee",
                "and upon the kingdoms that have not called upon thy Name."
            ],
            [
                "For they have devoured Jacob",
                "and laid waste his dwelling place."
            ],
            [
                "O remember not our old sins, but have mercy upon us, and that soon",
                "for we are come to great misery."
            ],
            [
                "Help us, O God of our salvation, for the glory of thy Name",
                "O deliver us, and be merciful unto our sins, for thy Name's sake."
            ],
            [
                "Wherefore do the heathen say",
                "Where is now their God?"
            ],
            [
                "O let the vengeance of thy servants' blood that is shed",
                "be openly shewed upon the heathen in our sight."
            ],
            [
                "O let the sorrowful sighing of the prisoners come before thee",
                "according to the greatness of thy power, preserve thou those that are appointed to die."
            ],
            [
                "And for the blasphemy wherewith our neighbours have blasphemed thee",
                "reward thou them, O Lord, seven fold into their bosom."
            ],
            [
                "So we, that are thy people, and sheep of thy pasture, shall give thee thanks for ever",
                "and will alway be shewing forth thy praise from generation to generation."
            ]
        ],
        id: "psalm79"
    },
    {
        lines: [
            [
                "HEAR, O thou Shepherd of Israel, thou that leadest Joseph like a sheep",
                "shew thyself also, thou that sittest upon the cherubims."
            ],
            [
                "Before Ephraim, Benjamin, and Manasses",
                "stir up thy strength, and come, and help us."
            ],
            [
                "Turn us again, O God",
                "shew the light of thy countenance, and we shall be whole."
            ],
            [
                "O Lord God of hosts",
                "how long wilt thou be angry with thy people that prayeth?"
            ],
            [
                "Thou feedest them with the bread of tears",
                "and givest them plenteousness of tears to drink."
            ],
            [
                "Thou hast made us a very strife unto our neighbours",
                "and our enemies laugh us to scorn."
            ],
            [
                "Turn us again, thou God of hosts",
                "shew the light of thy countenance, and we shall be whole."
            ],
            [
                "Thou hast brought a vine out of Egypt",
                "thou hast cast out the heathen, and planted it."
            ],
            [
                "Thou madest room for it",
                "and when it had taken root it filled the land."
            ],
            [
                "The hills were covered with the shadow of it",
                "and the boughs thereof were like the goodly cedar trees."
            ],
            [
                "She stretched out her branches unto the sea",
                "and her boughs unto the river."
            ],
            [
                "Why hast thou then broken down her hedge",
                "that all they that go by pluck off her grapes?"
            ],
            [
                "The wild boar out of the wood doth root it up",
                "and the wild beasts of the field devour it."
            ],
            [
                "Turn thee again, thou God of hosts, look down from heaven",
                "behold, and visit this vine;"
            ],
            [
                "And the place of the vineyard that thy right hand hath planted",
                "and the branch that thou madest so strong for thyself."
            ],
            [
                "It is burnt with fire, and cut down",
                "and they shall perish at the rebuke of thy countenance."
            ],
            [
                "Let thy hand be upon the man of thy right hand",
                "and upon the son of man, whom thou madest so strong for thine own self."
            ],
            [
                "And so will not we go back from thee",
                "O let us live, and we shall call upon thy Name."
            ],
            [
                "Turn us again, O Lord God of hosts",
                "shew the light of thy countenance, and we shall be whole."
            ]
        ],
        id: "psalm80"
    },
    {
        lines: [
            [
                "SING we merrily unto God our strength",
                "make a cheerful noise unto the God of Jacob."
            ],
            [
                "Take the psalm, bring hither the tabret",
                "the merry harp with the lute."
            ],
            [
                "Blow up the trumpet in the new moon",
                "even in the time appointed, and upon our solemn feast day."
            ],
            [
                "For this was made a statute for Israel",
                "and a law of the God of Jacob."
            ],
            [
                "This he ordained in Joseph for a testimony",
                "when he came out of the land of Egypt, and had heard a strange language."
            ],
            [
                "I eased his shoulder from the burden",
                "and his hands were delivered from making the pots."
            ],
            [
                "Thou calledst upon me in troubles, and I delivered thee",
                "and heard thee what time as the storm fell upon thee."
            ],
            [
                "I proved thee also",
                "at the waters of strife."
            ],
            [
                "Hear, O my people, and I will assure thee, O Israel",
                "if thou wilt hearken unto me,"
            ],
            [
                "There shall no strange god be in thee",
                "neither shalt thou worship any other god."
            ],
            [
                "I am the Lord thy God, who brought thee out of the land of Egypt",
                "open thy mouth wide, and I shall fill it."
            ],
            [
                "But my people would not hear my voice",
                "and Israel would not obey me."
            ],
            [
                "So I gave them up unto their own hearts' lusts",
                "and let them follow their own imaginations."
            ],
            [
                "O that my people would have hearkened unto me",
                "for if Israel had walked in my ways,"
            ],
            [
                "I should soon have put down their enemies",
                "and turned my hand against their adversaries."
            ],
            [
                "The haters of the Lord should have been found liars",
                "but their time should have endured for ever."
            ],
            [
                "He should have fed them also with the finest wheat flour",
                "and with honey out of the stony rock should I have satisfied thee."
            ]
        ],
        id: "psalm81"
    },
    {
        lines: [
            [
                "GOD standeth in the congregation of princes",
                "he is a Judge among gods."
            ],
            [
                "How long will ye give wrong judgement",
                "and accept the persons of the ungodly?"
            ],
            [
                "Defend the poor and fatherless",
                "see that such as are in need and necessity have right."
            ],
            [
                "Deliver the outcast and poor",
                "save them from the hand of the ungodly."
            ],
            [
                "They will not be learned nor understand, but walk on still in darkness",
                "all the foundations of the earth are out of course."
            ],
            [
                "I have said, Ye are gods",
                "and ye are all the children of the most Highest."
            ],
            [
                "But ye shall die like men",
                "and fall like one of the princes."
            ],
            [
                "Arise, O God, and judge thou the earth",
                "for thou shalt take all heathen to thine inheritance."
            ]
        ],
        id: "psalm82"
    },
    {
        lines: [
            [
                "HOLD not thy tongue, O God, keep not still silence",
                "refrain not thyself, O God."
            ],
            [
                "For lo, thine enemies make a murmuring",
                "and they that hate thee have lift up their head."
            ],
            [
                "They have imagined craftily against thy people",
                "and taken counsel against thy secret ones."
            ],
            [
                "They have said, Come, and let us root them out, that they be no more a people",
                "and that the name of Israel may be no more in remembrance."
            ],
            [
                "For they have cast their heads together with one consent",
                "and are confederate against thee;"
            ],
            [
                "The tabernacles of the Edomites, and the Ismaelites",
                "the Moabites and Hagarens;"
            ],
            [
                "Gebal, and Ammon, and Amalek",
                "the Philistines, with them that dwell at Tyre."
            ],
            [
                "Assur also is joined with them",
                "and have holpen the children of Lot."
            ],
            [
                "But do thou to them as unto the Madianites",
                "unto Sisera, and unto Jabin at the brook of Kison;"
            ],
            [
                "Who perished at Endor",
                "and became as the dung of the earth."
            ],
            [
                "Make them and their princes like Oreb and Zeb",
                "yea, make all their princes like as Zeba and Salmana;"
            ],
            [
                "Who say, Let us take to ourselves",
                "the houses of God in possession."
            ],
            [
                "O my God, make them like unto a wheel",
                "and as the stubble before the wind;"
            ],
            [
                "Like as the fire that burneth up the wood",
                "and as the flame that consumeth the mountains."
            ],
            [
                "Persecute them even so with thy tempest",
                "and make them afraid with thy storm."
            ],
            [
                "Make their faces ashamed, O Lord",
                "that they may seek thy Name."
            ],
            [
                "Let them be confounded and vexed ever more and more",
                "let them be put to shame, and perish."
            ],
            [
                "And they shall know that thou, whose Name is Jehovah",
                "art only the most Highest over all the earth."
            ]
        ],
        id: "psalm83"
    },
    {
        lines: [
            [
                "O HOW amiable are thy dwellings",
                "thou Lord of hosts!"
            ],
            [
                "My soul hath a desire and longing to enter into the courts of the Lord",
                "my heart and my flesh rejoice in the living God."
            ],
            [
                "Yea, the sparrow hath found her an house, and the swallow a nest where she may lay her young",
                "even thy altars, O Lord of hosts, my King and my God."
            ],
            [
                "Blessed are they that dwell in thy house",
                "they will be alway praising thee."
            ],
            [
                "Blessed is the man whose strength is in thee",
                "in whose heart are thy ways."
            ],
            [
                "Who going through the vale of misery use it for a well",
                "and the pools are filled with water."
            ],
            [
                "They will go from strength to strength",
                "and unto the God of gods appeareth every one of them in Sion."
            ],
            [
                "O Lord God of hosts, hear my pray'r",
                "hearken, O God of Jacob."
            ],
            [
                "Behold, O God our defender",
                "and look upon the face of thine Anointed."
            ],
            [
                "For one day in thy courts",
                "is better than a thousand."
            ],
            [
                "I had rather be a door keeper in the house of my God",
                "than to dwell in the tents of ungodliness."
            ],
            [
                "For the Lord God is a light and defence",
                "the Lord will give grace and worship, and no good thing shall he withhold from them that live a godly life."
            ],
            [
                "O Lord God of hosts",
                "blessed is the man that putteth his trust in thee."
            ]
        ],
        id: "psalm84"
    },
    {
        lines: [
            [
                "LORD, thou art become gracious unto thy land",
                "thou hast turned away the captivity of Jacob."
            ],
            [
                "Thou hast forgiven the offence of thy people",
                "and covered all their sins."
            ],
            [
                "Thou hast taken away all thy displeasure",
                "and turned thyself from thy wrathful indignation."
            ],
            [
                "Turn us then, O God our Saviour",
                "and let thine anger cease from us."
            ],
            [
                "Wilt thou be displeased at us for ever",
                "and wilt thou stretch out thy wrath from one generation to another?"
            ],
            [
                "Wilt thou not turn again, and quicken us",
                "that thy people may rejoice in thee?"
            ],
            [
                "Shew us thy mercy, O Lord",
                "and grant us thy salvation."
            ],
            [
                "I will hearken what the Lord God will say concerning me",
                "for he shall speak peace unto his people, and to his saints, that they turn not again."
            ],
            [
                "For his salvation is nigh them that fear him",
                "that glory may dwell in our land."
            ],
            [
                "Mercy and truth are met together",
                "righteousness and peace have kissed each other."
            ],
            [
                "Truth shall flourish out of the earth",
                "and righteousness hath looked down from heaven."
            ],
            [
                "Yea, the Lord shall shew loving kindness",
                "and our land shall give her increase."
            ],
            [
                "Righteousness shall go before him",
                "and he shall direct his going in the way."
            ]
        ],
        id: "psalm85"
    },
    {
        lines: [
            [
                "BOW down thine ear, O Lord, and hear me",
                "for I am poor, and in misery."
            ],
            [
                "Preserve thou my soul, for I am holy",
                "my God, save thy servant that putteth his trust in thee."
            ],
            [
                "Be merciful unto me, O Lord",
                "for I will call daily upon thee."
            ],
            [
                "Comfort the soul of thy servant",
                "for unto thee, O Lord, do I lift up my soul."
            ],
            [
                "For thou, Lord, art good and gracious",
                "and of great mercy unto all them that call upon thee."
            ],
            [
                "Give ear, Lord, unto my prayer",
                "and ponder the voice of my humble desires."
            ],
            [
                "In the time of my trouble I will call upon thee",
                "for thou hearest me."
            ],
            [
                "Among the gods there is none like unto thee, O Lord",
                "there is not one that can do as thou doest."
            ],
            [
                "All nations whom thou hadst made shall come and worship thee, O Lord",
                "and shall glorify thy Name."
            ],
            [
                "For thou art great, and doest wondrous things",
                "thou art God alone."
            ],
            [
                "Teach me thy way, O Lord, and I will walk in thy truth",
                "O knit my heart unto thee, that I may fear thy Name."
            ],
            [
                "I will thank thee, O Lord my God, with all my heart",
                "and will praise thy Name for evermore."
            ],
            [
                "For great is thy mercy toward me",
                "and thou hast delivered my soul from the nethermost hell."
            ],
            [
                "O God, the proud are risen against me",
                "and the congregations of naughty men have sought after my soul, and have not set thee before their eyes."
            ],
            [
                "But thou, O Lord God, art full of compassion and mercy",
                "long suffering, plenteous in goodness and truth."
            ],
            [
                "O turn thee then unto me, and have mercy upon me",
                "give thy strength unto thy servant, and help the son of thine handmaid."
            ],
            [
                "Shew some token upon me for good, that they who hate me may see it and be ashamed",
                "because thou, Lord, hast holpen me and comforted me."
            ]
        ],
        id: "psalm86"
    },
    {
        lines: [
            [
                "HER foundations are upon the holy hills",
                "the Lord loveth the gates of Sion more than all the dwellings of Jacob."
            ],
            [
                "Very excellent things are spoken of thee",
                "thou city of God."
            ],
            [
                "I will think upon Rahab and Babylon",
                "with them that know me."
            ],
            [
                "Behold ye the Philistines also",
                "and they of Tyre, with the Morians; lo, there was he born."
            ],
            [
                "And of Sion it shall be reported that he was born in her",
                "and the most High shall stablish her."
            ],
            [
                "The Lord shall rehearse it when he writeth up the people",
                "that he was born there."
            ],
            [
                "The singers also and trumpeters shall he rehearse",
                "All my fresh springs shall be in thee."
            ]
        ],
        id: "psalm87"
    },
    {
        lines: [
            [
                "O LORD God of my salvation, I have cried day and night before thee",
                "O let my prayer enter into thy presence, incline thine ear unto my calling."
            ],
            [
                "For my soul is full of trouble",
                "and my life draweth nigh unto hell."
            ],
            [
                "I am counted as one of them that go down into the pit",
                "and I have been even as a man that hath no strength."
            ],
            [
                "Free among the dead, like unto them that are wounded, and lie in the grave",
                "who are out of remembrance, and are cut away from thy hand."
            ],
            [
                "Thou hast laid me in the lowest pit",
                "in a place of darkness, and in the deep."
            ],
            [
                "Thine indignation lieth hard upon me",
                "and thou hast vexed me with all thy storms."
            ],
            [
                "Thou hast put away mine acquaintance far from me",
                "and made me to be abhorred of them."
            ],
            [
                "I am so fast in prison",
                "that I cannot get forth."
            ],
            [
                "My sight faileth for very trouble",
                "Lord, I have called daily upon thee, I have stretched forth my hands unto thee."
            ],
            [
                "Dost thou shew wonders among the dead",
                "or shall the dead rise up again, and praise thee?"
            ],
            [
                "Shall thy loving kindness be shewed in the grave",
                "or thy faithfulness in destruction?"
            ],
            [
                "Shall thy wondrous works be known in the dark",
                "and thy righteousness in the land where all things are forgotten?"
            ],
            [
                "Unto thee have I cried, O Lord",
                "and early shall my prayer come before thee."
            ],
            [
                "Lord, why abhorrest thou my soul",
                "and hidest thou thy face from me?"
            ],
            [
                "I am in misery, and like unto him that is at the point to die",
                "even from my youth up thy terrors have I suffered with a troubled mind."
            ],
            [
                "Thy wrathful displeasure goeth over me",
                "and the fear of thee hath undone me."
            ],
            [
                "They came round about me daily like water",
                "and compassed me together on ev'ry side."
            ],
            [
                "My lovers and friends hast thou put away from me",
                "and hid mine acquaintance out of my sight."
            ]
        ],
        id: "psalm88"
    },
    {
        lines: [
            [
                "MY SONG shall be alway of the loving kindness of the Lord",
                "with my mouth will I ever be shewing thy truth from one generation to another."
            ],
            [
                "For I have said, Mercy shall be set up for ever",
                "thy truth shalt thou stablish in the heavens."
            ],
            [
                "I have made a covenant with my chosen",
                "I have sworn unto David my servant;"
            ],
            [
                "Thy seed will I stablish for ever",
                "and set up thy throne from one generation to another."
            ],
            [
                "O Lord, the very heavens shall praise thy wondrous works",
                "and thy truth in the congregation of the saints."
            ],
            [
                "For who is he among the clouds",
                "that shall be compared unto the Lord?"
            ],
            [
                "And what is he among the gods",
                "that shall be like unto the Lord?"
            ],
            [
                "God is very greatly to be feared in the council of the saints",
                "and to be had in reverence of all them that are round about him."
            ],
            [
                "O Lord God of hosts, who is like unto thee",
                "thy truth, most mighty Lord, is on ev'ry side."
            ],
            [
                "Thou rulest the raging of the sea",
                "thou stillest the waves thereof when they arise."
            ],
            [
                "Thou hast subdued Egypt, and destroyed it",
                "thou hast scattered thine enemies abroad with thy mighty arm."
            ],
            [
                "The heavens are thine, the earth also is thine",
                "thou hast laid the foundation of the round world, and all that therein is."
            ],
            [
                "Thou hast made the north and the south",
                "Tabor and Hermon shall rejoice in thy Name."
            ],
            [
                "Thou hast a mighty arm",
                "strong is thy hand, and high is thy right hand."
            ],
            [
                "Righteousness and equity are the habitation of thy seat",
                "mercy and truth shall go before thy face."
            ],
            [
                "Blessed is the people, O Lord, that can rejoice in thee",
                "they shall walk in the light of thy countenance."
            ],
            [
                "Their delight shall be daily in thy Name",
                "and in thy righteousness shall they make their boast."
            ],
            [
                "For thou art the glory of their strength",
                "and in thy loving kindness thou shalt lift up our horns."
            ],
            [
                "For the Lord is our defence",
                "the Holy One of Israel is our King."
            ],
            [
                "Thou spakest sometime in visions unto thy saints, and saidst",
                "I have laid help upon one that is mighty; I have exalted one chosen out of the people."
            ],
            [
                "I have found David my servant",
                "with my holy oil have I anointed him."
            ],
            [
                "My hand shall hold him fast",
                "and my arm shall strengthen him."
            ],
            [
                "The enemy shall not be able to do him violence",
                "the son of wickedness shall not hurt him."
            ],
            [
                "I will smite down his foes before his face",
                "and plague them that hate him."
            ],
            [
                "My truth also and my mercy shall be with him",
                "and in my Name shall his horn be exalted."
            ],
            [
                "I will set his dominion also in the sea",
                "and his right hand in the floods."
            ],
            [
                "He shall call me, Thou art my Father",
                "my God, and my strong salvation."
            ],
            [
                "And I will make him my first born",
                "higher than the kings of the earth."
            ],
            [
                "My mercy will I keep for him for evermore",
                "and my covenant shall stand fast with him."
            ],
            [
                "His seed also will I make to endure for ever",
                "and his throne as the days of heaven."
            ],
            [
                "But if his children forsake my law",
                "and walk not in my judgements;"
            ],
            [
                "If they break my statutes, and keep not my commandments",
                "I will visit their offences with the rod, and their sin with scourges."
            ],
            [
                "Nevertheless, my loving kindness will I not utterly take from him",
                "nor suffer my truth to fail."
            ],
            [
                "My covenant I will not break, nor alter the thing that is gone out of my lips",
                "I have sworn once by my holiness, that I will not fail David."
            ],
            [
                "His seed shall endure for ever",
                "and his seat is like as the sun before me."
            ],
            [
                "He shall stand fast for evermore as the moon",
                "and as the faithful witness in heaven."
            ],
            [
                "But thou hast abhorred and forsaken thine Anointed",
                "and art displeased at him."
            ],
            [
                "Thou hast broken the covenant of thy servant",
                "and cast his crown to the ground."
            ],
            [
                "Thou hast overthrown all his hedges",
                "and broken down his strong holds."
            ],
            [
                "All they that go by spoil him",
                "and he is become a reproach to his neighbours."
            ],
            [
                "Thou hast set up the right hand of his enemies",
                "and made all his adversaries to rejoice."
            ],
            [
                "Thou hast taken away the edge of his sword",
                "and givest him not victory in the battle."
            ],
            [
                "Thou hast put out his glory",
                "and cast his throne down to the ground."
            ],
            [
                "The days of his youth hast thou shortened",
                "and covered him with dishonour."
            ],
            [
                "Lord, how long wilt thou hide thyself, for ever",
                "and shall thy wrath burn like fire?"
            ],
            [
                "O remember how short my time is",
                "wherefore hast thou made all men for nought?"
            ],
            [
                "What man is he that liveth, and shall not see death",
                "and shall he deliver his soul from the hand of hell?"
            ],
            [
                "Lord, where are thy old loving kindnesses",
                "which thou swarest unto David in thy truth?"
            ],
            [
                "Remember, Lord, the rebuke that thy servants have",
                "and how I do bear in my bosom the rebukes of many people."
            ],
            [
                "Wherewith thine enemies have blasphemed thee, and slandered the footsteps of thine Anointed",
                "Praised be the Lord for evermore. Amen, and Amen."
            ]
        ],
        id: "psalm89"
    },
    {
        lines: [
            [
                "LORD, thou hast been our refuge",
                "from one generation to another."
            ],
            [
                "Before the mountains were brought forth, or ever the earth and the world were made",
                "thou art God from everlasting, and world without end."
            ],
            [
                "Thou turnest man to destruction",
                "again thou sayest, Come again, ye children of men."
            ],
            [
                "For a thousand years in thy sight are but as yesterday",
                "seeing that is past as a watch in the night."
            ],
            [
                "As soon as thou scatterest them they are even as a sleep",
                "and fade away suddenly like the grass."
            ],
            [
                "In the morning it is green, and groweth up",
                "but in the evening it is cut down, dried up, and withered."
            ],
            [
                "For we consume away in thy displeasure",
                "and are afraid at thy wrathful indignation."
            ],
            [
                "Thou hast set our misdeeds before thee",
                "and our secret sins in the light of thy countenance."
            ],
            [
                "For when thou art angry all our days are gone",
                "we bring our years to an end, as it were a tale that is told."
            ],
            [
                "The days of our age are threescore years and ten; and though men be so strong that they come to fourscore years",
                "yet is their strength then but labour and sorrow; so soon passeth it away, and we are gone."
            ],
            [
                "But who regardeth the power of thy wrath",
                "for even thereafter as a man feareth, so is thy displeasure."
            ],
            [
                "So teach us to number our days",
                "that we may apply our hearts unto wisdom."
            ],
            [
                "Turn thee again, O Lord, at the last",
                "and be gracious unto thy servants."
            ],
            [
                "O satisfy us with thy mercy, and that soon",
                "so shall we rejoice and be glad all the days of our life."
            ],
            [
                "Comfort us again now after the time that thou hast plagued us",
                "and for the years wherein we have suffered adversity."
            ],
            [
                "Shew thy servants thy work",
                "and their children thy glory."
            ],
            [
                "And the glorious majesty of the Lord our God be upon us",
                "prosper thou the work of our hands upon us, O prosper thou our handywork."
            ]
        ],
        id: "psalm90"
    },
    {
        lines: [
            [
                "WHOSO dwelleth under the defence of the most High",
                "shall abide under the shadow of the Almighty."
            ],
            [
                "I will say unto the Lord, Thou art my hope, and my strong hold",
                "my God, in him will I trust."
            ],
            [
                "For he shall deliver thee from the snare of the hunter",
                "and from the noisome pestilence."
            ],
            [
                "He shall defend thee under his wings, and thou shalt be safe under his feathers",
                "his faithfulness and truth shall be thy shield and buckler."
            ],
            [
                "Thou shalt not be afraid for any terror by night",
                "nor for the arrow that flieth by day;"
            ],
            [
                "For the pestilence that walketh in darkness",
                "nor for the sickness that destroyeth in the noon day."
            ],
            [
                "A thousand shall fall beside thee, and ten thousand at thy right hand",
                "but it shall not come nigh thee."
            ],
            [
                "Yea, with thine eyes shalt thou behold",
                "and see the reward of the ungodly."
            ],
            [
                "For thou, Lord, art my hope",
                "thou hast set thine house of defence very high."
            ],
            [
                "There shall no evil happen unto thee",
                "neither shall any plague come nigh thy dwelling."
            ],
            [
                "For he shall give his angels charge over thee",
                "to keep thee in all thy ways."
            ],
            [
                "They shall bear thee in their hands",
                "that thou hurt not thy foot against a stone."
            ],
            [
                "Thou shalt go upon the lion and adder",
                "the young lion and the dragon shalt thou tread under thy feet."
            ],
            [
                "Because he hath set his love upon me, therefore will I deliver him",
                "I will set him up, because he hath known my Name."
            ],
            [
                "He shall call upon me, and I will hear him",
                "yea, I am with him in trouble; I will deliver him, and bring him to honour."
            ],
            [
                "With long life will I satisfy him",
                "and shew him my salvation."
            ]
        ],
        id: "psalm91"
    },
    {
        lines: [
            [
                "IT IS a good thing to give thanks unto the Lord",
                "and to sing praises unto thy Name, O most Highest;"
            ],
            [
                "To tell of thy loving kindness early in the morning",
                "and of thy truth in the night season;"
            ],
            [
                "Upon an instrument of ten strings, and upon the lute",
                "upon a loud instrument, and upon the harp."
            ],
            [
                "For thou, Lord, hast made me glad through thy works",
                "and I will rejoice in giving praise for the operations of thy hands."
            ],
            [
                "O Lord, how glorious are thy works",
                "thy thoughts are very deep."
            ],
            [
                "An unwise man doth not well consider this",
                "and a fool doth not understand it."
            ],
            [
                "When the ungodly are green as the grass, and when all the workers of wickedness do flourish",
                "then shall they be destroyed for ever; but thou, Lord, art the most Highest for evermore."
            ],
            [
                "For lo, thine enemies, O Lord, lo, thine enemies shall perish",
                "and all the workers of wickedness shall be destroyed."
            ],
            [
                "But mine horn shall be exalted like the horn of an unicorn",
                "for I am anointed with fresh oil."
            ],
            [
                "Mine eye also shall see his lust of mine enemies",
                "and mine ear shall hear his desire of the wicked that arise up against me."
            ],
            [
                "The righteous shall flourish like a palm tree",
                "and shall spread abroad like a cedar in Libanus."
            ],
            [
                "Such as are planted in the house of the Lord",
                "shall flourish in the courts of the house of our God."
            ],
            [
                "They also shall bring forth more fruit in their age",
                "and shall be fat and well liking."
            ],
            [
                "That they may shew how true the Lord my strength is",
                "and that there is no unrighteousness in him."
            ]
        ],
        id: "psalm92"
    },
    {
        lines: [
            [
                "THE Lord is King, and hath put on glorious apparel",
                "the Lord hath put on his apparel, and girded himself with strength."
            ],
            [
                "He hath made the round world so sure",
                "that it cannot be moved."
            ],
            [
                "Ever since the world began hath thy seat been prepared",
                "thou art from everlasting."
            ],
            [
                "The floods are risen, O Lord, the floods have lift up their voice",
                "the floods lift up their waves."
            ],
            [
                "The waves of the sea are mighty, and rage horribly",
                "but yet the Lord, who dwelleth on high, is mightier."
            ],
            [
                "Thy testimonies, O Lord, are very sure",
                "holiness becometh thine house for ever."
            ]
        ],
        id: "psalm93"
    },
    {
        lines: [
            [
                "O LORD God, to whom vengeance belongeth",
                "thou God, to whom vengeance belongeth, shew thyself."
            ],
            [
                "Arise, thou Judge of the world",
                "and reward the proud after their deserving."
            ],
            [
                "Lord, how long shall the ungodly",
                "how long shall the ungodly triumph?"
            ],
            [
                "How long shall all wicked doers speak so disdainfully",
                "and make such proud boasting?"
            ],
            [
                "They smite down thy people, O Lord",
                "and trouble thine heritage."
            ],
            [
                "They murder the widow and the stranger",
                "and put the fatherless to death."
            ],
            [
                "And yet they say, Tush, the Lord shall not see",
                "neither shall the God of Jacob regard it."
            ],
            [
                "Take heed, ye unwise among the people",
                "O ye fools, when will ye understand?"
            ],
            [
                "He that planted the ear, shall he not hear",
                "or he that made the eye, shall he not see?"
            ],
            [
                "Or he that nurtureth the heathen",
                "it is he that teacheth man knowledge, shall not he punish?"
            ],
            [
                "The Lord knoweth the thoughts of man",
                "that they are but vain."
            ],
            [
                "Blessed is the man whom thou chastenest, O Lord",
                "and teachest him in thy law;"
            ],
            [
                "That thou mayest give him patience in time of adversity",
                "until the pit be digged up for the ungodly."
            ],
            [
                "For the Lord will not fail his people",
                "neither will he forsake his inheritance;"
            ],
            [
                "Until righteousness turn again unto judgement",
                "all such as are true in heart shall follow it."
            ],
            [
                "Who will rise up with me against the wicked",
                "or who will take my part against the evil doers?"
            ],
            [
                "If the Lord had not helped me",
                "it had not failed but my soul had been put to silence."
            ],
            [
                "But when I said, My foot hath slipt",
                "thy mercy, O Lord, held me up."
            ],
            [
                "In the multitude of the sorrows that I had in my heart",
                "thy comforts have refreshed my soul."
            ],
            [
                "Wilt thou have any thing to do with the stool of wickedness",
                "which imagineth mischief as a law?"
            ],
            [
                "They gather them together against the soul of the righteous",
                "and condemn the innocent blood."
            ],
            [
                "But the Lord is my refuge",
                "and my God is the strength of my confidence."
            ],
            [
                "He shall recompense them their wickedness, and destroy them in their own malice",
                "yea, the Lord our God shall destroy them."
            ]
        ],
        id: "psalm94"
    },
    {
        lines: [
            [
                "O COME, let us sing unto the Lord",
                "let us heartily rejoice in the strength of our salvation."
            ],
            [
                "Let us come before his presence with thanksgiving",
                "and shew ourselves glad in him with psalms."
            ],
            [
                "For the Lord is a great God",
                "and a great King above all gods."
            ],
            [
                "In his hand are all the corners of the earth",
                "and the strength of the hills is his also."
            ],
            [
                "The sea is his, and he made it",
                "and his hands prepared the dry land."
            ],
            [
                "O come, let us worship and fall down",
                "and kneel before the Lord our Maker."
            ],
            [
                "For he is the Lord our God",
                "and we are the people of his pasture, and the sheep of his hand."
            ],
            [
                "To day if ye will hear his voice, harden not your hearts",
                "as in the provocation, and as in the day of temptation in the wilderness."
            ],
            [
                "When your fathers tempted me",
                "proved me, and saw my works."
            ],
            [
                "Forty years long was I grieved with this generation, and said",
                "It is a people that do err in their hearts, for they have not known my ways;"
            ],
            [
                "Unto whom I sware in my wrath",
                "that they should not enter into my rest."
            ]
        ],
        id: "psalm95"
    },
    {
        lines: [
            [
                "O SING unto the Lord a new song",
                "sing unto the Lord, all the whole earth."
            ],
            [
                "Sing unto the Lord, and praise his Name",
                "be telling of his salvation from day to day."
            ],
            [
                "Declare his honour unto the heathen",
                "and his wonders unto all people."
            ],
            [
                "For the Lord is great, and cannot worthily be praised",
                "he is more to be feared than all gods."
            ],
            [
                "As for all the gods of the heathen, they are but idols",
                "but it is the Lord that made the heavens."
            ],
            [
                "Glory and worship are before him",
                "power and honour are in his sanctuary."
            ],
            [
                "Ascribe unto the Lord, O ye kindreds of the people",
                "ascribe unto the Lord worship and power."
            ],
            [
                "Ascribe unto the Lord the honour due unto his Name",
                "bring presents, and come into his courts."
            ],
            [
                "O worship the Lord in the beauty of holiness",
                "let the whole earth stand in awe of him."
            ],
            [
                "Tell it out among the heathen that the Lord is King",
                "and that it is he who hath made the round world so fast that it cannot be moved; and how that he shall judge the people righteously."
            ],
            [
                "Let the heavens rejoice, and let the earth be glad",
                "let the sea make a noise, and all that therein is."
            ],
            [
                "Let the field be joyful, and all that is in it",
                "then shall all the trees of the wood rejoice before the Lord."
            ],
            [
                "For he cometh, for he cometh to judge the earth",
                "and with righteousness to judge the world, and the people with his truth."
            ]
        ],
        id: "psalm96"
    },
    {
        lines: [
            [
                "THE Lord is King, the earth may be glad thereof",
                "yea, the multitude of the isles may be glad thereof."
            ],
            [
                "Clouds and darkness are round about him",
                "righteousness and judgement are the habitation of his seat."
            ],
            [
                "There shall go a fire before him",
                "and burn up his enemies on ev'ry side."
            ],
            [
                "His lightnings gave shine unto the world",
                "the earth saw it, and was afraid."
            ],
            [
                "The hills melted like wax at the presence of the Lord",
                "at the presence of the Lord of the whole earth."
            ],
            [
                "The heavens have declared his righteousness",
                "and all the people have seen his glory."
            ],
            [
                "Confounded be all they that worship carved images, and that delight in vain gods",
                "worship him, all ye gods."
            ],
            [
                "Sion heard of it, and rejoiced",
                "and the daughters of Judah were glad, because of thy judgements, O Lord."
            ],
            [
                "For thou, Lord, art higher than all that are in the earth",
                "thou art exalted far above all gods."
            ],
            [
                "O ye that love the Lord, see that ye hate the thing which is evil",
                "the Lord preserveth the souls of his saints; he shall deliver them from the hand of the ungodly."
            ],
            [
                "There is sprung up a light for the righteous",
                "and joyful gladness for such as are true hearted."
            ],
            [
                "Rejoice in the Lord, ye righteous",
                "and give thanks for a remembrance of his holiness."
            ]
        ],
        id: "psalm97"
    },
    {
        lines: [
            [
                "O SING unto the Lord a new song",
                "for he hath done marvellous things."
            ],
            [
                "With his own right hand, and with his holy arm",
                "hath he gotten himself the victory."
            ],
            [
                "The Lord declared his salvation",
                "his righteousness hath he openly shewed in the sight of the heathen."
            ],
            [
                "He hath remembered his mercy and truth toward the house of Israel",
                "and all the ends of the world have seen the salvation of our God."
            ],
            [
                "Shew yourselves joyful unto the Lord, all ye lands",
                "sing, rejoice, and give thanks."
            ],
            [
                "Praise the Lord upon the harp",
                "sing to the harp with a psalm of thanksgiving."
            ],
            [
                "With trumpets also and shawms",
                "O shew yourselves joyful before the Lord the King."
            ],
            [
                "Let the sea make a noise, and all that therein is",
                "the round world, and they that dwell therein."
            ],
            [
                "Let the floods clap their hands, and let the hills be joyful together before the Lord",
                "for he is come to judge the earth."
            ],
            [
                "With righteousness shall he judge the world",
                "and the people with equity."
            ]
        ],
        id: "psalm98"
    },
    {
        lines: [
            [
                "THE Lord is King, be the people never so unpatient",
                "he sitteth between the cherubims, be the earth never so unquiet."
            ],
            [
                "The Lord is great in Sion",
                "and high above all people."
            ],
            [
                "They shall give thanks unto thy Name",
                "which is great, wonderful, and holy."
            ],
            [
                "The King's power loveth judgement; thou hast prepared equity",
                "thou hast executed judgement and righteousness in Jacob."
            ],
            [
                "O magnify the Lord our God",
                "and fall down before his footstool, for he is holy."
            ],
            [
                "Moses and Aaron among his priests, and Samuel among such as call upon his Name",
                "these called upon the Lord, and he heard them."
            ],
            [
                "He spake unto them out of the cloudy pillar",
                "for they kept his testimonies, and the law that he gave them."
            ],
            [
                "Thou heardest them, O Lord our God",
                "thou forgavest them, O God, and punishedst their own inventions."
            ],
            [
                "O magnify the Lord our God, and worship him upon his holy hill",
                "for the Lord our God is holy."
            ]
        ],
        id: "psalm99"
    },
    {
        lines: [
            [
                "O BE joyful in the Lord, all ye lands",
                "serve the Lord with gladness, and come before his presence with a song."
            ],
            [
                "Be ye sure that the Lord he is God",
                "it is he that hath made us, and not we ourselves; we are his people, and the sheep of his pasture."
            ],
            [
                "O go your way into his gates with thanksgiving, and into his courts with praise",
                "be thankful unto him, and speak good of his Name."
            ],
            [
                "For the Lord is gracious, his mercy is everlasting",
                "and his truth endureth from generation to generation."
            ]
        ],
        id: "psalm100"
    },
    {
        lines: [
            [
                "MY SONG shall be of mercy and judgement",
                "unto thee, O Lord, will I sing."
            ],
            [
                "O let me have understanding",
                "in the way of godliness."
            ],
            [
                "When wilt thou come unto me",
                "I will walk in my house with a perfect heart."
            ],
            [
                "I will take no wicked thing in hand; I hate the sins of unfaithfulness",
                "there shall no such cleave unto me."
            ],
            [
                "A froward heart shall depart from me",
                "I will not know a wicked person."
            ],
            [
                "Whoso privily slandereth his neighbour",
                "him will I destroy."
            ],
            [
                "Whoso hath also a proud look and high stomach",
                "I will not suffer him."
            ],
            [
                "Mine eyes look upon such as are faithful in the land",
                "that they may dwell with me."
            ],
            [
                "Whoso leadeth a godly life",
                "he shall be my servant."
            ],
            [
                "There shall no deceitful person dwell in my house",
                "he that telleth lies shall not tarry in my sight."
            ],
            [
                "I shall soon destroy all the ungodly that are in the land",
                "that I may root out all wicked doers from the city of the Lord."
            ]
        ],
        id: "psalm101"
    },
    {
        lines: [
            [
                "HEAR my prayer, O Lord",
                "and let my crying come unto thee."
            ],
            [
                "Hide not thy face from me in the time of my trouble",
                "incline thine ear unto me when I call; O hear me, and that right soon."
            ],
            [
                "For my days are consumed away like smoke",
                "and my bones are burnt up as it were a firebrand."
            ],
            [
                "My heart is smitten down, and withered liked grass",
                "so that I forget to eat my bread."
            ],
            [
                "For the voice of my groaning",
                "my bones will scarce cleave to my flesh."
            ],
            [
                "I am become like a pelican in the wilderness",
                "and like an owl that is in the desert."
            ],
            [
                "I have watched, and am even as it were a sparrow",
                "that sitteth alone upon the house top."
            ],
            [
                "Mine enemies revile me all the day long",
                "and they that are mad upon me are sworn together against me."
            ],
            [
                "For I have eaten ashes as it were bread",
                "and mingled my drink with weeping;"
            ],
            [
                "And that because of thine indignation and wrath",
                "for thou hast taken me up, and cast me down."
            ],
            [
                "My days are gone like a shadow",
                "and I am withered like grass."
            ],
            [
                "But thou, O Lord, shalt endure for ever",
                "and thy remembrance throughout all generations."
            ],
            [
                "Thou shalt arise, and have mercy upon Sion",
                "for it is time that thou have mercy upon her, yea, the time is come."
            ],
            [
                "And why? thy servants think upon her stones",
                "and it pitieth them to see her in the dust."
            ],
            [
                "The heathen shall fear thy Name, O Lord",
                "and all the kings of the earth thy majesty;"
            ],
            [
                "When the Lord shall build up Sion",
                "and when his glory shall appear;"
            ],
            [
                "When he turneth him unto the prayer of the poor destitute",
                "and despiseth not their desire."
            ],
            [
                "This shall be written for those that come after",
                "and the people which shall be born shall praise the Lord."
            ],
            [
                "For he hath looked down from his sanctuary",
                "out of the heaven did the Lord behold the earth;"
            ],
            [
                "That he might hear the mournings of such as are in captivity",
                "and deliver the children appointed unto death;"
            ],
            [
                "That they may declare the Name of the Lord in Sion",
                "and his worship at Jerusalem;"
            ],
            [
                "When the people are gathered together",
                "and the kingdoms also, to serve the Lord."
            ],
            [
                "He brought down my strength in my journey",
                "and shortened my days."
            ],
            [
                "But I said, O my God, take me not away in the midst of mine age",
                "as for thy years, they endure throughout all generations."
            ],
            [
                "Thou, Lord, in the beginning hast laid the foundation of the earth",
                "and the heavens are the work of thy hands."
            ],
            [
                "They shall perish, but thou shalt endure",
                "they all shall wax old as doth a garment;"
            ],
            [
                "And as a vesture shalt thou change them, and they shall be changed",
                "but thou art the same, and thy years shall not fail."
            ],
            [
                "The children of thy servants shall continue",
                "and their seed shall stand fast in thy sight."
            ]
        ],
        id: "psalm102"
    },
    {
        lines: [
            [
                "PRAISE the Lord, O my soul",
                "and all that is within me praise his holy Name."
            ],
            [
                "Praise the Lord, O my soul",
                "and forget not all his benefits;"
            ],
            [
                "Who forgiveth all thy sin",
                "and healeth all thine infirmities;"
            ],
            [
                "Who saveth thy life from destruction",
                "and crowneth thee with mercy and loving kindness;"
            ],
            [
                "Who satisfieth thy mouth with good things",
                "making thee young and lusty as an eagle."
            ],
            [
                "The Lord executeth righteousness and judgement",
                "for all them that are oppressed with wrong."
            ],
            [
                "He shewed his ways unto Moses",
                "his works unto the children of Israel."
            ],
            [
                "The Lord is full of compassion and mercy",
                "long suffering, and of great goodness."
            ],
            [
                "He will not alway be chiding",
                "neither keepeth he his anger for ever."
            ],
            [
                "He hath not dealt with us after our sins",
                "nor rewarded us according to our wickednesses."
            ],
            [
                "For look how high the heaven is in comparison of the earth",
                "so great is his mercy also toward them that fear him."
            ],
            [
                "Look how wide also the east is from the west",
                "so far hath he set our sins from us."
            ],
            [
                "Yea, like as a father pitieth his own children",
                "even so is the Lord merciful unto them that fear him."
            ],
            [
                "For he knoweth whereof we are made",
                "he remembereth that we are but dust."
            ],
            [
                "The days of man are but as grass",
                "for he flourisheth as a flower of the field."
            ],
            [
                "For as soon as the wind goeth over it, it is gone",
                "and the place thereof shall know it no more."
            ],
            [
                "But the merciful goodness of the Lord endureth for ever and ever upon them that fear him",
                "and his righteousness upon children's children;"
            ],
            [
                "Even upon such as keep his covenant",
                "and think upon his commandments to do them."
            ],
            [
                "The Lord hath prepared his seat in heaven",
                "and his kingdom ruleth over all."
            ],
            [
                "O praise the Lord, ye angels of his, ye that excel in strength",
                "ye that fulfil his commandment, and hearken unto the voice of his words."
            ],
            [
                "O praise the Lord, all ye his hosts",
                "ye servants of his that do his pleasure."
            ],
            [
                "O speak good of the Lord, all ye works of his, in all places of his dominion",
                "praise thou the Lord, O my soul."
            ]
        ],
        id: "psalm103"
    },
    {
        lines: [
            [
                "PRAISE the Lord, O my soul",
                "O Lord my God, thou art become exceeding glorious; thou art clothed with majesty and honour."
            ],
            [
                "Thou deckest thyself with light as it were with a garment",
                "and spreadest out the heavens like a curtain."
            ],
            [
                "Who layeth the beams of his chambers in the waters",
                "and maketh the clouds his chariot, and walketh upon the wings of the wind."
            ],
            [
                "He maketh his angels spirits",
                "and his ministers a flaming fire."
            ],
            [
                "He laid the foundations of the earth",
                "that it never should move at any time."
            ],
            [
                "Thou coveredst it with the deep like as with a garment",
                "the waters stand in the hills."
            ],
            [
                "At thy rebuke they flee",
                "at the voice of thy thunder they are afraid."
            ],
            [
                "They go up as high as the hills, and down to the valleys beneath",
                "even unto the place which thou hast appointed for them."
            ],
            [
                "Thou hast set them their bounds which they shall not pass",
                "neither turn again to cover the earth."
            ],
            [
                "He sendeth the springs into the rivers",
                "which run among the hills."
            ],
            [
                "All beasts of the field drink thereof",
                "and the wild asses quench their thirst."
            ],
            [
                "Beside them shall the fowls of the air have their habitation",
                "and sing among the branches."
            ],
            [
                "He watereth the hills from above",
                "the earth is filled with the fruit of thy works."
            ],
            [
                "He bringeth forth grass for the cattle",
                "and green herb for the service of men;"
            ],
            [
                "That he may bring food out of the earth, and wine that maketh glad the heart of man",
                "and oil to make him a cheerful countenance, and bread to strengthen man's heart."
            ],
            [
                "The trees of the Lord also are full of sap",
                "even the cedars of Libanus which he hath planted;"
            ],
            [
                "Wherein the birds make their nests",
                "and the fir trees are a dwelling for the stork."
            ],
            [
                "The high hills are a refuge for the wild goats",
                "and so are the stony rocks for the conies."
            ],
            [
                "He appointed the moon for certain seasons",
                "and the sun knoweth his going down."
            ],
            [
                "Thou makest darkness that it may be night",
                "wherein all the beasts of the forest do move."
            ],
            [
                "The lions roaring after their prey",
                "do seek their meat from God."
            ],
            [
                "The sun ariseth, and they get them away together",
                "and lay them down in their dens."
            ],
            [
                "Man goeth forth to his work, and to his labour",
                "until the ev'ning."
            ],
            [
                "O Lord, how manifold are thy works",
                "in wisdom hast thou made them all; the earth is full of thy riches."
            ],
            [
                "So is the great and wide sea also",
                "wherein are things creeping innumerable, both small and great beasts."
            ],
            [
                "There go the ships, and there is that Leviathan",
                "whom thou hast made to take his pastime therein."
            ],
            [
                "These wait all upon thee",
                "that thou mayest give them meat in due season."
            ],
            [
                "When thou givest it them they gather it",
                "and when thou openest thy hand they are filled with good."
            ],
            [
                "When thou hidest thy face they are troubled",
                "when thou takest away their breath they die, and are turned again to their dust."
            ],
            [
                "When thou lettest thy breath go forth they shall be made",
                "and thou shalt renew the face of the earth."
            ],
            [
                "The glorious majesty of the Lord shall endure for ever",
                "the Lord shall rejoice in his works."
            ],
            [
                "The earth shall tremble at the look of him",
                "if he do but touch the hills, they shall smoke."
            ],
            [
                "I will sing unto the Lord as long as I live",
                "I will praise my God while I have my being."
            ],
            [
                "And so shall my words please him",
                "my joy shall be in the Lord."
            ],
            [
                "As for sinners, they shall be consumed out of the earth, and the ungodly shall come to an end",
                "praise thou the Lord, O my soul, praise the Lord."
            ]
        ],
        id: "psalm104"
    },
    {
        lines: [
            [
                "O GIVE thanks unto the Lord, and call upon his Name",
                "tell the people what things he hath done."
            ],
            [
                "O let your songs be of him, and praise him",
                "and let your talking be of all his wondrous works."
            ],
            [
                "Rejoice in his holy Name",
                "let the heart of them rejoice that seek the Lord."
            ],
            [
                "Seek the Lord and his strength",
                "seek his face evermore."
            ],
            [
                "Remember the marvellous works that he hath done",
                "his wonders, and the judgements of his mouth."
            ],
            [
                "O ye seed of Abraham his servant",
                "ye children of Jacob his chosen."
            ],
            [
                "He is the Lord our God",
                "his judgements are in all the world."
            ],
            [
                "He hath been alway mindful of his covenant and promise",
                "that he made to a thousand generations;"
            ],
            [
                "Even the covenant that he made with Abraham",
                "and the oath that he sware unto Isaac;"
            ],
            [
                "And appointed the same unto Jacob for a law",
                "and to Israel for an everlasting testament;"
            ],
            [
                "Saying, Unto thee will I give the land of Canaan",
                "the lot of your inheritance;"
            ],
            [
                "When there were yet but a few of them",
                "and they strangers in the land;"
            ],
            [
                "What time as they went from one nation to another",
                "from one kingdom to another people;"
            ],
            [
                "He suffered no man to do them wrong",
                "but reproved even kings for their sakes;"
            ],
            [
                "Touch not mine Anointed",
                "and do my prophets no harm."
            ],
            [
                "Moreover, he called for a dearth upon the land",
                "and destroyed all the provision of bread."
            ],
            [
                "But he had sent a man before them",
                "even Joseph, who was sold to be a bond servant;"
            ],
            [
                "Whose feet they hurt in the stocks",
                "the iron entered into his soul;"
            ],
            [
                "Until the time came that his cause was known",
                "the word of the Lord tried him."
            ],
            [
                "The king sent, and delivered him",
                "the prince of the people let him go free."
            ],
            [
                "He made him lord also of his house",
                "and ruler of all his substance;"
            ],
            [
                "That he might inform his princes after his will",
                "and teach his senators wisdom."
            ],
            [
                "Israel also came into Egypt",
                "and Jacob was a stranger in the land of Ham."
            ],
            [
                "And he increased his people exceedingly",
                "and made them stronger than their enemies;"
            ],
            [
                "Whose heart turned, so that they hated his people",
                "and dealt untruly with his servants."
            ],
            [
                "Then sent he Moses his servant",
                "and Aaron whom he had chosen."
            ],
            [
                "And these shewed his tokens among them",
                "and wonders in the land of Ham."
            ],
            [
                "He sent darkness, and it was dark",
                "and they were not obedient unto his word."
            ],
            [
                "He turned their waters into blood",
                "and slew their fish."
            ],
            [
                "Their land brought forth frogs",
                "yea, even in their kings' chambers."
            ],
            [
                "He spake the word, and there came all manner of flies",
                "and lice in all their quarters."
            ],
            [
                "He gave them hail stones for rain",
                "and flames of fire in their land."
            ],
            [
                "He smote their vines also and fig trees",
                "and destroyed the trees that were in their coasts."
            ],
            [
                "He spake the word, and the grasshoppers came, and caterpillars innumerable",
                "and did eat up all the grass in their land, and devoured the fruit of their ground."
            ],
            [
                "He smote all the first born in their land",
                "even the chief of all their strength."
            ],
            [
                "He brought them forth also with silver and gold",
                "there was not one feeble person among their tribes."
            ],
            [
                "Egypt was glad at their departing",
                "for they were afraid of them."
            ],
            [
                "He spread out a cloud to be a covering",
                "and fire to give light in the night season."
            ],
            [
                "At their desire he brought quails",
                "and he filled them with the bread of heaven."
            ],
            [
                "He opened the rock of stone, and the waters flowed out",
                "so that rivers ran in the dry places."
            ],
            [
                "For why? he remembered his holy promise",
                "and Abraham his servant."
            ],
            [
                "And he brought forth his people with joy",
                "and his chosen with gladness;"
            ],
            [
                "And gave them the lands of the heathen",
                "and they took the labours of the people in possession;"
            ],
            [
                "That they might keep his statutes",
                "and observe his laws."
            ]
        ],
        id: "psalm105"
    },
    {
        lines: [
            [
                "O GIVE thanks unto the Lord, for he is gracious",
                "and his mercy endureth for ever."
            ],
            [
                "Who can express the noble acts of the Lord",
                "or shew forth all his praise?"
            ],
            [
                "Blessed are they that alway keep judgement",
                "and do righteousness."
            ],
            [
                "Remember me, O Lord, according to the favour that thou bearest unto thy people",
                "O visit me with thy salvation;"
            ],
            [
                "That I may see the felicity of thy chosen",
                "and rejoice in the gladness of thy people, and give thanks with thine inheritance."
            ],
            [
                "We have sinned with our fathers",
                "we have done amiss, and dealt wickedly."
            ],
            [
                "Our fathers regarded not thy wonders in Egypt, neither kept they thy great goodness in remembrance",
                "but were disobedient at the sea, even at the Red sea."
            ],
            [
                "Nevertheless, he helped them for his Name's sake",
                "that he might make his power to be known."
            ],
            [
                "He rebuked the Red sea also, and it was dried up",
                "so he led them through the deep, as through a wilderness."
            ],
            [
                "And he saved them from the adversary's hand",
                "and delivered them from the hand of the enemy."
            ],
            [
                "As for those that troubled them, the waters overwhelmed them",
                "there was not one of them left."
            ],
            [
                "Then believed they his words",
                "and sang praise unto him."
            ],
            [
                "But within a while they forgat his works",
                "and would not abide his counsel."
            ],
            [
                "But lust came upon them in the wilderness",
                "and they tempted God in the desert."
            ],
            [
                "And he gave them their desire",
                "and sent leanness withal into their soul."
            ],
            [
                "They angered Moses also in the tents",
                "and Aaron the saint of the Lord."
            ],
            [
                "So the earth opened, and swallowed up Dathan",
                "and covered the congregation of Abiram."
            ],
            [
                "And the fire was kindled in their company",
                "the flame burnt up the ungodly."
            ],
            [
                "They made a calf in Horeb",
                "and worshipped the molten image."
            ],
            [
                "Thus they turned their glory",
                "into the similitude of a calf that eateth hay."
            ],
            [
                "And they forgat God their Saviour",
                "who had done so great things in Egypt;"
            ],
            [
                "Wondrous works in the land of Ham",
                "and fearful things by the Red sea."
            ],
            [
                "So he said, he would have destroyed them, had not Moses his chosen stood before him in the gap",
                "to turn away his wrathful indignation, lest he should destroy them."
            ],
            [
                "Yea, they thought scorn of that pleasant land",
                "and gave no credence unto his word;"
            ],
            [
                "But murmured in their tents",
                "and hearkened not unto the voice of the lord."
            ],
            [
                "Then lift he up his hand against them",
                "to overthrow them in the wilderness;"
            ],
            [
                "To cast out their seed among the nations",
                "and to scatter them in the lands."
            ],
            [
                "They joined themselves unto Baal peor",
                "and ate the offerings of the dead."
            ],
            [
                "Thus they provoked him to anger with their own inventions",
                "and the plague was great among them."
            ],
            [
                "Then stood up Phinees and prayed",
                "and so the plague ceased."
            ],
            [
                "And that was counted unto him for righteousness",
                "among all posterities for evermore."
            ],
            [
                "They angered him also at the waters of strife",
                "so that he punished Moses for their sakes;"
            ],
            [
                "Because they provoked his spirit",
                "so that he spake unadvisedly with his lips."
            ],
            [
                "Neither destroyed they the heathen",
                "as the Lord commanded them;"
            ],
            [
                "But were mingled among the heathen",
                "and learned their works."
            ],
            [
                "Insomuch that they worshipped their idols, which turned to their own decay",
                "yea, they offered their sons and their daughters unto devils;"
            ],
            [
                "And shed innocent blood, even the blood of their sons and of their daughters",
                "whom they had offered unto the idols of Canaan; and the land was defiled with blood."
            ],
            [
                "Thus were they stained with their own works",
                "and went a whoring with their own inventions."
            ],
            [
                "Therefore was the wrath of the Lord kindled against his people",
                "insomuch that he abhorred his own inheritance."
            ],
            [
                "And he gave them over into the hands of the heathen",
                "and they that hated them were lords over them."
            ],
            [
                "Their enemies oppressed them",
                "and had them in subjection."
            ],
            [
                "Many a time did he deliver them",
                "but they rebelled against him with their own inventions, and were brought down in their wickedness."
            ],
            [
                "Nevertheless, when he saw their adversity",
                "he heard their complaint."
            ],
            [
                "He thought upon his covenant, and pitied them according unto the multitude of his mercies",
                "yea, he made all those that led them away captive to pity them."
            ],
            [
                "Deliver us, O Lord our God, and gather us from among the heathen",
                "that we may give thanks unto thy holy Name, and make our boast of thy praise."
            ],
            [
                "Blessed be the Lord God of Israel from everlasting and world without end",
                "and let all the people say, Amen."
            ]
        ],
        id: "psalm106"
    },
    {
        lines: [
            [
                "O GIVE thanks unto the Lord, for he is gracious",
                "and his mercy endureth for ever."
            ],
            [
                "Let them give thanks whom the Lord hath redeemed",
                "and delivered from the hand of the enemy;"
            ],
            [
                "And gathered them out of the lands, from the east and from the west",
                "from the north and from the south."
            ],
            [
                "They went astray in the wilderness out of the way",
                "and found no city to dwell in;"
            ],
            [
                "Hungry and thirsty",
                "their soul fainted in them."
            ],
            [
                "So they cried unto the Lord in their trouble",
                "and he delivered them from their distress."
            ],
            [
                "He led them forth by the right way",
                "that they might go to the city where they dwelt."
            ],
            [
                "O that men would therefore praise the Lord for his goodness",
                "and declare the wonders that he doeth for the children of men!"
            ],
            [
                "For he satisfieth the empty soul",
                "and filleth the hungry soul with goodness."
            ],
            [
                "Such as sit in darkness, and in the shadow of death",
                "being fast bound in misery and iron;"
            ],
            [
                "Because they rebelled against the words of the Lord",
                "and lightly regarded the counsel of the most Highest;"
            ],
            [
                "He also brought down their heart through heaviness",
                "they fell down, and there was none to help them."
            ],
            [
                "So when they cried unto the Lord in their trouble",
                "he delivered them out of their distress."
            ],
            [
                "For he brought them out of darkness, and out of the shadow of death",
                "and brake their bonds in sunder."
            ],
            [
                "O that men would therefore praise the Lord for his goodness",
                "and declare the wonders that he doeth for the children of men!"
            ],
            [
                "For he hath broken the gates of brass",
                "and smitten the bars of iron in sunder."
            ],
            [
                "Foolish men are plagued for their offence",
                "and because of their wickedness."
            ],
            [
                "Their soul abhorred all manner of meat",
                "and they were even hard at death's door."
            ],
            [
                "So when they cried unto the Lord in their trouble",
                "he delivered them out of their distress."
            ],
            [
                "He sent his word, and healed them",
                "and they were saved from their destruction."
            ],
            [
                "O that men would therefore praise the Lord for his goodness",
                "and declare the wonders that he doeth for the children of men!"
            ],
            [
                "That they would offer unto him the sacrifice of thanksgiving",
                "and tell out his works with gladness!"
            ],
            [
                "They that go down to the sea in ships",
                "and occupy their business in great waters;"
            ],
            [
                "These men see the works of the Lord",
                "and his wonders in the deep."
            ],
            [
                "For at his word the stormy wind ariseth",
                "which lifteth up the waves thereof."
            ],
            [
                "They are carried up to the heaven, and down again to the deep",
                "their soul melteth away because of the trouble."
            ],
            [
                "They reel to and fro, and stagger like a drunken man",
                "and are at their wits' end."
            ],
            [
                "So when they cry unto the Lord in their trouble",
                "he delivereth them out of their distress."
            ],
            [
                "For he maketh the storm to cease",
                "so that the waves thereof are still."
            ],
            [
                "Then are they glad, because they are at rest",
                "and so he bringeth them unto the haven where they would be."
            ],
            [
                "O that men would therefore praise the Lord for his goodness",
                "and declare the wonders that he doeth for the children of men!"
            ],
            [
                "That they would exalt him also in the congregation of the people",
                "and praise him in the seat of the elders!"
            ],
            [
                "Who turneth the floods into a wilderness",
                "and drieth up the water springs."
            ],
            [
                "A fruitful land maketh he barren",
                "for the wickedness of them that dwell therein."
            ],
            [
                "Again, he maketh the wilderness a standing water",
                "and water springs of a dry ground."
            ],
            [
                "And there he setteth the hungry",
                "that they may build them a city to dwell in;"
            ],
            [
                "That they may sow their land, and plant vineyards",
                "to yield them fruits of increase."
            ],
            [
                "He blesseth them so that they multiply exceedingly",
                "and suffereth not their cattle to decrease."
            ],
            [
                "And again, when they are minished and brought low",
                "through oppression, through any plague or trouble;"
            ],
            [
                "Though he suffer them to be evil intreated through tyrants",
                "and let them wander out of the way in the wilderness;"
            ],
            [
                "Yet helpeth he the poor out of misery",
                "and maketh him households like a flock of sheep."
            ],
            [
                "The righteous will consider this, and rejoice",
                "and the mouth of all wickedness shall be stopped."
            ],
            [
                "Whoso is wise will ponder these things",
                "and they shall understand the loving kindness of the Lord."
            ]
        ],
        id: "psalm107"
    },
    {
        lines: [
            [
                "O GOD, my heart is ready, my heart is ready",
                "I will sing and give praise with the best member that I have."
            ],
            [
                "Awake, thou lute, and harp",
                "I myself will awake right early."
            ],
            [
                "I will give thanks unto thee, O Lord, among the people",
                "I will sing praises unto thee among the nations."
            ],
            [
                "For thy mercy is greater than the heavens",
                "and thy truth reacheth unto the clouds."
            ],
            [
                "Set up thyself, O God, above the heavens",
                "and thy glory above all the earth."
            ],
            [
                "That thy beloved may be delivered",
                "let thy right hand save them, and hear thou me."
            ],
            [
                "God hath spoken in his holiness",
                "I will rejoice therefore, and divide Sichem, and mete out the valley of Succoth."
            ],
            [
                "Gilead is mine, and Manasses is mine",
                "Ephraim also is the strength of my head."
            ],
            [
                "Judah is my law giver, Moab is my wash pot",
                "over Edom will I cast out my shoe, upon Philistia will I triumph."
            ],
            [
                "Who will lead me into the strong city",
                "and who will bring me into Edom?"
            ],
            [
                "Hast not thou forsaken us, O God",
                "and wilt not thou, O God, go forth with our hosts?"
            ],
            [
                "O help us against the enemy",
                "for vain is the help of man."
            ],
            [
                "Through God we shall do great acts",
                "and it is he that shall tread down our enemies."
            ]
        ],
        id: "psalm108"
    },
    {
        lines: [
            [
                "HOLD not thy tongue, O God of my praise",
                "for the mouth of the ungodly, yea, the mouth of the deceitful is opened upon me."
            ],
            [
                "And they have spoken against me with false tongues",
                "they compassed me about also with words of hatred, and fought against me without a cause."
            ],
            [
                "For the love that I had unto them, lo, they take now my contrary part",
                "but I give myself unto prayer."
            ],
            [
                "Thus have they rewarded me evil for good",
                "and hatred for my good will."
            ],
            [
                "Set thou an ungodly man to be ruler over him",
                "and let Satan stand at his right hand."
            ],
            [
                "When sentence is given upon him, let him be condemned",
                "and let his prayer be turned into sin."
            ],
            [
                "Let his days be few",
                "and let another take his office."
            ],
            [
                "Let his children be fatherless",
                "and his wife a widow."
            ],
            [
                "Let his children be vagabonds, and beg their bread",
                "let them seek it also out of desolate places."
            ],
            [
                "Let the extortioner consume all that he hath",
                "and let the stranger spoil his labour."
            ],
            [
                "Let there be no man to pity him",
                "nor to have compassion upon his fatherless children."
            ],
            [
                "Let his posterity be destroyed",
                "and in the next generation let his name be clean put out."
            ],
            [
                "Let the wickedness of his fathers be had in remembrance in the sight of the Lord",
                "and let not the sin of his mother be done away."
            ],
            [
                "Let them alway be before the Lord",
                "that he may root out the memorial of them from off the earth."
            ],
            [
                "And that, because his mind was not to do good",
                "but persecuted the poor helpless man, that he might slay him that was vexed at the heart."
            ],
            [
                "His delight was in cursing, and it shall happen unto him",
                "he loved not blessing, therefore shall it be far from him."
            ],
            [
                "He clothed himself with cursing, like as with a raiment",
                "and it shall come into his bowels like water, and like oil into his bones."
            ],
            [
                "Let it be unto him as the cloke that he hath upon him",
                "and as the girdle that he is alway girded withal."
            ],
            [
                "Let it thus happen from the Lord unto mine enemies",
                "and to those that speak evil against my soul."
            ],
            [
                "But deal thou with me, O Lord God, according unto thy Name",
                "for sweet is thy mercy."
            ],
            [
                "O deliver me, for I am helpless and poor",
                "and my heart is wounded within me."
            ],
            [
                "I go hence like the shadow that departeth",
                "and am driven away as the grass hopper."
            ],
            [
                "My knees are weak through fasting",
                "my flesh is dried up for want of fatness."
            ],
            [
                "I became also a reproach unto them",
                "they that looked upon me shaked their heads."
            ],
            [
                "Help me, O Lord my God",
                "O save me according to thy mercy."
            ],
            [
                "And they shall know, how that this is thy hand",
                "and that thou, Lord, hast done it."
            ],
            [
                "Though they curse, yet bless thou",
                "and let them be confounded that rise up against me; but let thy servant rejoice."
            ],
            [
                "Let mine adversaries be clothed with shame",
                "and let them cover themselves with their own confusion, as with a cloke."
            ],
            [
                "As for me, I will give great thanks unto the Lord with my mouth",
                "and praise him among the multitude."
            ],
            [
                "For he shall stand at the right hand of the poor",
                "to save his soul from the unrighteous judges."
            ]
        ],
        id: "psalm109"
    },
    {
        lines: [
            [
                "THE Lord said unto my Lord",
                "Sit thou on my right hand, until I make thine enemies thy footstool."
            ],
            [
                "The Lord shall send the rod of thy power out of Sion",
                "be thou ruler, even in the midst among thine enemies."
            ],
            [
                "In the day of thy power shall the people offer thee free will offerings with an holy worship",
                "the dew of thy birth is of the womb of the morning."
            ],
            [
                "The Lord sware, and will not repent",
                "Thou art a priest for ever after the order of Melchisedech."
            ],
            [
                "The Lord upon thy right hand",
                "shall wound even kings in the day of his wrath."
            ],
            [
                "He shall judge among the heathen; he shall fill the places with the dead bodies",
                "and smite in sunder the heads over divers countries."
            ],
            [
                "He shall drink of the brook in the way",
                "therefore shall he lift up hishead."
            ]
        ],
        id: "psalm110"
    },
    {
        lines: [
            [
                "I WILL give thanks unto the Lord with my whole heart",
                "secretly among the faithful, and in the congregation."
            ],
            [
                "The works of the Lord are great",
                "sought out of all them that have pleasure therein."
            ],
            [
                "His work is worthy to be praised and had in honour",
                "and his righteousness endureth for ever."
            ],
            [
                "The merciful and gracious Lord hath so done his marvellous works",
                "that they ought to be had in remembrance."
            ],
            [
                "He hath given meat unto them that fear him",
                "he shall ever be mindful of his covenant."
            ],
            [
                "He hath shewed his people the power of his works",
                "that he may give them the heritage of the heathen."
            ],
            [
                "The works of his hands are verity and judgement",
                "all his commandments are true."
            ],
            [
                "They stand fast for ever and ever",
                "and are done in truth and equity."
            ],
            [
                "He sent redemption unto his people",
                "he hath commanded his covenant for ever; holy and reverend is his Name."
            ],
            [
                "The fear of the Lord is the beginning of wisdom",
                "a good understanding have all they that do thereafter; the praise of it endureth for ever."
            ]
        ],
        id: "psalm111"
    },
    {
        lines: [
            [
                "BLESSED is the man that feareth the Lord",
                "he hath great delight in his commandments."
            ],
            [
                "His seed shall be mighty upon earth",
                "the generation of the faithful shall be blessed."
            ],
            [
                "Riches and plenteousness shall be in his house",
                "and his righteousness endureth for ever."
            ],
            [
                "Unto the godly there ariseth up light in the darkness",
                "he is merciful, loving, and righteous."
            ],
            [
                "A good man is merciful, and lendeth",
                "and will guide his words with discretion."
            ],
            [
                "For he shall never be moved",
                "and the righteous shall be had in everlasting remembrance."
            ],
            [
                "He will not be afraid of any evil tidings",
                "for his heart standeth fast, and believeth in the Lord."
            ],
            [
                "His heart is established, and will not shrink",
                "until he see his desire upon his enemies."
            ],
            [
                "He hath dispersed abroad, and given to the poor",
                "and his righteousness remaineth for ever; his horn shall be exalted with honour."
            ],
            [
                "The ungodly shall see it, and it shall grieve him",
                "he shall gnash with his teeth, and consume away; the desire of the ungodly shall perish."
            ]
        ],
        id: "psalm112"
    },
    {
        lines: [
            [
                "PRAISE the Lord, ye servants",
                "O praise the Name of the Lord."
            ],
            [
                "Blessed be the Name of the Lord",
                "from this time forth for evermore."
            ],
            [
                "The Lord's Name is praised",
                "from the rising up of the sun unto the going down of the same."
            ],
            [
                "The Lord is high above all heathen",
                "and his glory above the heavens."
            ],
            [
                "Who is like unto the Lord our God, that hath his dwelling so high",
                "and yet humbleth himself to behold the things that are in heaven and earth?"
            ],
            [
                "He taketh up the simple out of the dust",
                "and lifteth the poor out of the mire;"
            ],
            [
                "That he may set him with the princes",
                "even with the princes of his people."
            ],
            [
                "He maketh the barren woman to keep house",
                "and to be a joyful mother of children."
            ]
        ],
        id: "psalm113"
    },
    {
        lines: [
            [
                "WHEN Israel came out of Egypt",
                "and the |house of Jacob from among the strange people,"
            ],
            [
                "Judah was his sanctuary",
                "and |Israel his dominion."
            ],
            [
                "The sea saw that, and fled",
                "| Jordan was driven back."
            ],
            [
                "The mountains skipped like rams",
                "and the |lit tle hills like young sheep."
            ],
            [
                "What aileth thee, O thou sea, that thou fleddest",
                "and |thou Jordan, that thou wast driven back?"
            ],
            [
                "Ye mountains, that ye skipped like rams",
                "and ye |little hills, like young sheep?"
            ],
            [
                "Tremble, thou earth, at the presence of the Lord",
                "at the |presence of the God of Jacob;"
            ],
            [
                "Who turned the hard rock into a standing water",
                "and the |flint stone into a springing well."
            ]
        ],
        id: "psalm114"
    },
    {
        lines: [
            [
                "NOT unto us, O Lord, not unto us, but unto thy Name give the praise",
                "for thy |loving mercy and for thy truth's sake."
            ],
            [
                "Wherefore shall the heathen say",
                "| Where is now their God?"
            ],
            [
                "As for our God, he is in heaven",
                "|he hath done whatsoever pleased him."
            ],
            [
                "Their idols are silver and gold",
                "|even the work of men's hands."
            ],
            [
                "They have mouths, and speak not",
                "|eyes have they, and see not."
            ],
            [
                "They have ears, and hear not",
                "|noses have they, and smell not."
            ],
            [
                "They have hands, and handle not; feet have they, and walk not",
                "|neither speak they through their throat."
            ],
            [
                "They that make them are like unto them",
                "and |so are all such as put their trust in them."
            ],
            [
                "But thou, house of Israel, trust thou in the Lord",
                "|he is their succour and defence."
            ],
            [
                "Ye house of Aaron, put your trust in the Lord",
                "|he is their helper and defender."
            ],
            [
                "Ye that fear the Lord, put your trust in the Lord",
                "|he is their helper and defender."
            ],
            [
                "The Lord hath been mindful of us, and he shall bless us",
                "|even he shall bless the house of Israel, he shall bless the house of Aaron."
            ],
            [
                "He shall bless them that fear the Lord",
                "|  both small and great."
            ],
            [
                "The Lord shall increase you more and more",
                "| you and your children."
            ],
            [
                "Ye are the blessed of the Lord",
                "| who made heaven and earth."
            ],
            [
                "All the whole heavens are the Lord's",
                "the |earth hath he given to the children of men."
            ],
            [
                "The dead praise not thee, O Lord",
                "|neither all they that go down into silence."
            ],
            [
                "But we will praise the Lord",
                "from |this time forth for evermore. Praise the Lord."
            ]
        ],
        id: "psalm115"
    },
    {
        lines: [
            [
                "I AM well pleased",
                "that the Lord hath heard the voice of my prayer ..;"
            ],
            [
                "That he hath inclined his ear unto me",
                "therefore will I call upon him as long as I live."
            ],
            [
                "The snares of death compassed me round about",
                "and the pains of hell gat hold upon me."
            ],
            [
                "I shall find trouble and heaviness, and I will call upon the Name of the Lord",
                "O Lord, I beseech thee, deliver my soul."
            ],
            [
                "Gracious is the Lord, and righteous",
                "yea, our God is merciful."
            ],
            [
                "The Lord preserveth the simple",
                "I was in misery, and he helped me."
            ],
            [
                "Turn again then unto thy rest, O my soul",
                "for the Lord hath rewarded thee."
            ],
            [
                "And why? thou hast delivered my soul from death",
                "mine eyes from tears, and my feet from falling."
            ],
            [
                "I will walk before the Lord",
                "in the land of the living."
            ],
            [
                "I believed, and therefore will I speak; but I was sore troubled",
                "I said in my haste, All men are liars."
            ],
            [
                "What reward shall I give unto the Lord",
                "for all the benefits that he hath done unto me?"
            ],
            [
                "I will receive the cup of salvation",
                "and call upon the Name of the Lord."
            ],
            [
                "I will pay my vows now in the presence of all his people",
                "right dear in the sight of the Lord is the death of his saints."
            ],
            [
                "Behold, O Lord, how that I am thy servant",
                "I am thy servant, and the son of thine handmaid; thou hast broken my bonds in sunder."
            ],
            [
                "I will offer to thee the sacrifice of thanksgiving",
                "and will call upon the Name of the Lord."
            ],
            [
                "I will pay my vows unto the Lord, in the sight of all his people",
                "in the courts of the Lord's house, even in the midst of thee, O Jerusalem. Praise the Lord."
            ]
        ],
        id: "psalm116"
    },
    {
        lines: [
            [
                "O PRAISE the Lord, all ye heathen",
                "praise him, all ye nations."
            ],
            [
                "For his merciful kindness is ever more and more towards us",
                "and the truth of the Lord endureth for ever. Praise the Lord."
            ]
        ],
        id: "psalm117"
    },
    {
        lines: [
            [
                "O GIVE thanks unto the Lord, for he is gracious",
                "because his mercy endureth for ever."
            ],
            [
                "Let Israel now confess that he is gracious",
                "and that his mercy endureth for ever."
            ],
            [
                "Let the house of Aaron now confess",
                "that his mercy endureth for ever."
            ],
            [
                "Yea, let them now that fear the Lord confess",
                "that his mercy endureth for ever."
            ],
            [
                "I called upon the Lord in trouble",
                "and the Lord heard me at large."
            ],
            [
                "The Lord is on my side",
                "I will not fear what man doeth unto me."
            ],
            [
                "The Lord taketh my part with them that help me",
                "therefore shall I see my desire upon mine enemies."
            ],
            [
                "It is better to trust in the Lord",
                "than to put any confidence in man."
            ],
            [
                "It is better to trust in the Lord",
                "than to put any confidence in princes."
            ],
            [
                "All nations compassed me round about",
                "but in the Name of the Lord will I destroy them."
            ],
            [
                "They kept me in on every side, they kept me in, I say, on ev'ry side",
                "but in the Name of the Lord will I destroy them."
            ],
            [
                "They came about me like bees, and are extinct even as the fire among the thorns",
                "for in the Name of the Lord I will destroy them."
            ],
            [
                "Thou hast thrust sore at me, that I might fall",
                "but the Lord was my help."
            ],
            [
                "The Lord is my strength, and my song",
                "and is become my salvation."
            ],
            [
                "The voice of joy and health is in the dwellings of the righteous",
                "the right hand of the Lord bringeth mighty things to pass."
            ],
            [
                "The right hand of the Lord hath the pre eminence",
                "the right hand of the Lord bringeth mighty things to pass."
            ],
            [
                "I shall not die, but live",
                "and declare the works of the Lord."
            ],
            [
                "The Lord hath chastened and corrected me",
                "but he hath not given me over unto death."
            ],
            [
                "Open me the gates of righteousness",
                "that I may go into them, and give thanks unto the Lord."
            ],
            [
                "This is the gate of the Lord",
                "the righteous shall enter into it."
            ],
            [
                "I will thank thee, for thou hast heard me",
                "and art become my salvation."
            ],
            [
                "The same stone which the builders refused",
                "is become the head stone in the corner."
            ],
            [
                "This is the Lord's doing",
                "and it is marvellous in our eyes."
            ],
            [
                "This is the day which the Lord hath made",
                "we will rejoice and be glad in it."
            ],
            [
                "Help me now, O Lord",
                "O Lord, send us now prosperity."
            ],
            [
                "Blessed be he that cometh in the Name of the Lord",
                "we have wished you good luck, ye that are of the house of the Lord."
            ],
            [
                "God is the Lord who hath shewed us light",
                "bind the sacrifice with cords, yea, even unto the horns of the altar."
            ],
            [
                "Thou art my God, and I will thank thee",
                "thou art my God, and I will praise thee."
            ],
            [
                "O give thanks unto the Lord, for he is gracious",
                "and his mercy endureth for ever."
            ]
        ],
        id: "psalm118"
    },
    {
        lines: [
            [
                "WHEN I was in trouble I called upon the Lord",
                "and he heard me."
            ],
            [
                "Deliver my soul, O Lord, from lying lips",
                "and from a deceitful tongue."
            ],
            [
                "What reward shall be given or done unto thee, thou false tongue",
                "even mighty and sharp arrows, with hot burning coals."
            ],
            [
                "Woe is me, that I am constrained to dwell with Mesech",
                "and to have my habitation among the tents of Kedar."
            ],
            [
                "My soul hath long dwelt among them",
                "that are enemies unto peace."
            ],
            [
                "I labour for peace, but when I speak unto them thereof",
                "they make them ready to battle."
            ]
        ],
        id: "psalm120"
    },
    {
        lines: [
            [
                "I WILL lift up mine eyes unto the hills",
                "from whence cometh my help."
            ],
            [
                "My help cometh even from the Lord",
                "who hath made heaven and earth."
            ],
            [
                "He will not suffer thy foot to be moved",
                "and he that keepeth thee will not sleep."
            ],
            [
                "Behold, he that keepeth Israel",
                "shall neither slumber nor sleep."
            ],
            [
                "The Lord himself is thy keeper",
                "the Lord is thy defence upon thy right hand;"
            ],
            [
                "So that the sun shall not burn thee by day",
                "neither the moon by night."
            ],
            [
                "The Lord shall preserve thee from all evil",
                "yea, it is even he that shall keep thy soul."
            ],
            [
                "The Lord shall preserve thy going out, and thy coming in",
                "from this time forth for evermore."
            ]
        ],
        id: "psalm121"
    },
    {
        lines: [
            [
                "I WAS glad when they said unto me",
                "We will go into the house of the Lord."
            ],
            [
                "Our feet shall stand in thy gates",
                "O Jerusalem."
            ],
            [
                "Jerusalem is built as a city",
                "that is at unity in itself."
            ],
            [
                "For thither the tribes go up, even the tribes of the Lord",
                "to testify unto Israel, to give thanks unto the Name of the Lord."
            ],
            [
                "For there is the seat of judgement",
                "even the seat of the house of David."
            ],
            [
                "O pray for the peace of Jerusalem",
                "they shall prosper that love thee."
            ],
            [
                "Peace be within thy walls",
                "and plenteousness within thy palaces."
            ],
            [
                "For my brethren and companions' sakes",
                "I will wish thee prosperity."
            ],
            [
                "Yea, because of the house of the Lord our God",
                "I will seek to do thee good."
            ]
        ],
        id: "psalm122"
    },
    {
        lines: [
            [
                "UNTO thee lift I up mine eyes",
                "O thou that dwellest in the heavens."
            ],
            [
                "Behold, even as the eyes of servants look unto the hand of their masters, and as the eyes of a maiden unto the hand of her mistress",
                "even so our eyes wait upon the Lord our God, until he have mercy upon us."
            ],
            [
                "Have mercy upon us, O Lord, have mercy upon us",
                "for we are utterly despised."
            ],
            [
                "Our soul is filled with the scornful reproof of the wealthy",
                "and with the despitefulness of the proud."
            ]
        ],
        id: "psalm123"
    },
    {
        lines: [
            [
                "IF THE Lord himself had not been on our side, now may Israel say",
                "if the Lord himself had not been on our side, when men rose up against us;"
            ],
            [
                "They had swallowed us up quick",
                "when thy were so wrathfully displeased at us."
            ],
            [
                "Yea, the waters had drowned us",
                "and the stream had gone over our soul."
            ],
            [
                "The deep waters of the proud",
                "had gone even over our soul."
            ],
            [
                "But praised be the Lord",
                "who hath not given us over for a prey unto their teeth."
            ],
            [
                "Our soul is escaped even as a bird out of the snare of the fowler",
                "the snare is broken, and we are delivered."
            ],
            [
                "Our help standeth in the Name of the Lord",
                "who hath made heaven and earth."
            ]
        ],
        id: "psalm124"
    },
    {
        lines: [
            [
                "THEY that put their trust in the Lord shall be even as the mount Sion",
                "which may not be removed, but standeth fast for ever."
            ],
            [
                "The hills stand about Jerusalem",
                "even so standeth the Lord round about his people, from this time forth for evermore."
            ],
            [
                "For the rod of the ungodly cometh not into the lot of the righteous",
                "lest the righteous put their hand unto wickedness."
            ],
            [
                "Do well, O Lord",
                "unto those that are good and true of heart."
            ],
            [
                "As for such as turn back unto their own wickedness",
                "the Lord shall lead them forth with the evil doers; but peace shall be upon Israel."
            ]
        ],
        id: "psalm125"
    },
    {
        lines: [
            [
                "WHEN the Lord turned again the captivity of Sion",
                "then were we like unto them that dream."
            ],
            [
                "Then was our mouth filled with laughter",
                "and our tongue with joy."
            ],
            [
                "Then said they among the heathen",
                "The Lord hath done great things for them."
            ],
            [
                "Yea, the Lord hath done great things for us already",
                "whereof we rejoice."
            ],
            [
                "Turn our captivity, O Lord",
                "as the rivers in the south."
            ],
            [
                "They that sow in tears",
                "shall reap in joy."
            ],
            [
                "He that now goeth on his way weeping, and beareth forth good seed",
                "shall doubtless come again with joy, and bring his sheaves with him."
            ]
        ],
        id: "psalm126"
    },
    {
        lines: [
            [
                "EXCEPT the Lord build the house",
                "their labour is but lost that build it."
            ],
            [
                "Except the Lord keep the city",
                "the watchman waketh but in vain."
            ],
            [
                "It is but lost labour that ye haste to rise up early, and so late take rest, and eat the bread of carefulness",
                "for so he giveth his beloved sleep."
            ],
            [
                "Lo, children and the fruit of the womb",
                "are an heritage and gift that cometh of the Lord."
            ],
            [
                "Like as the arrows in the hand of the giant",
                "even so are the young children."
            ],
            [
                "Happy is the man that hath his quiver full of them",
                "they shall not be ashamed when they speak with their enemies in the gate."
            ]
        ],
        id: "psalm127"
    },
    {
        lines: [
            [
                "BLESSED are all they that fear the Lord",
                "and walk in his ways."
            ],
            [
                "For thou shalt eat the labours of thine hands",
                "O well is thee, and happy shalt thou be."
            ],
            [
                "Thy wife shall be as the fruitful vine",
                "upon the walls of thine house."
            ],
            [
                "Thy children like the olive branches",
                "round about thy table."
            ],
            [
                "Lo, thus shall the man be blessed",
                "that feareth the Lord."
            ],
            [
                "The Lord from out of Sion shall so bless thee",
                "that thou shalt see Jerusalem in prosperity all thy life long."
            ],
            [
                "Yea, that thou shalt see thy children's children",
                "and peace upon Israel."
            ]
        ],
        id: "psalm128"
    },
    {
        lines: [
            [
                "MANY a time have they fought against me from my youth up",
                "may Israel now say."
            ],
            [
                "Yea, many a time have they vexed me from my youth up",
                "but they have not prevailed against me."
            ],
            [
                "The plowers plowed upon my back",
                "and made long furrows."
            ],
            [
                "But the righteous Lord",
                "hath hewn the snares of the ungodly in pieces."
            ],
            [
                "Let them be confounded and turned backward",
                "as many as have evil will at Sion."
            ],
            [
                "Let them be even as the grass growing upon the house tops",
                "which withereth afore it be plucked up;"
            ],
            [
                "Whereof the mower filleth not his hand",
                "neither he that bindeth up the sheaves his bosom."
            ],
            [
                "So that they who go by say not so much as, The Lord prosper you",
                "we wish you good luck in the Name of the Lord."
            ]
        ],
        id: "psalm129"
    },
    {
        lines: [
            [
                "OUT of the deep have I called unto thee, O Lord",
                "Lord, hear my voice."
            ],
            [
                "O let thine ears consider well",
                "the voice of my complaint."
            ],
            [
                "If thou, Lord, wilt be extreme to mark what is done amiss",
                "O Lord, who may abide it?"
            ],
            [
                "For there is mercy with thee",
                "therefore shalt thou be feared."
            ],
            [
                "I look for the Lord; my soul doth wait for him",
                "in his word is my trust."
            ],
            [
                "My soul fleeth unto the Lord",
                "before the morning watch, I say, before the morning watch."
            ],
            [
                "O Israel, trust in the Lord, for with the Lord there is mercy",
                "and with him is plenteous redemption."
            ],
            [
                "And he shall redeem Israel",
                "from all his sins."
            ]
        ],
        id: "psalm130"
    },
    {
        lines: [
            [
                "LORD, I am not high minded",
                "I have no proud looks."
            ],
            [
                "I do not exercise myself in great matters",
                "which are too high for me."
            ],
            [
                "But I refrain my soul, and keep it low, like as a child that is weaned from his mother",
                "yea, my soul is even as a weaned child."
            ],
            [
                "O Israel, trust in the Lord",
                "from this time forth for evermore."
            ]
        ],
        id: "psalm131"
    },
    {
        lines: [
            [
                "LORD, remember David",
                "and all his trouble;"
            ],
            [
                "How he sware unto the Lord",
                "and vowed a vow unto the Almighty God of Jacob;"
            ],
            [
                "I will not come within the tabernacle of mine house",
                "nor climb up into my bed;"
            ],
            [
                "I will not suffer mine eyes to sleep, nor mine eye lids to slumber",
                "neither the temples of my head to take any rest;"
            ],
            [
                "Until I find out a place for the temple of the Lord",
                "an habitation for the mighty God of Jacob."
            ],
            [
                "Lo, we heard of the same at Ephrata",
                "and found it in the wood."
            ],
            [
                "We will go into his tabernacle",
                "and fall low on our knees before his footstool."
            ],
            [
                "Arise, O Lord, into thy resting place",
                "thou, and the ark of thy strength."
            ],
            [
                "Let thy priests be clothed with righteousness",
                "and let thy saints sing with joyfulness."
            ],
            [
                "For thy servant David's sake",
                "turn not away the presence of thine Anointed."
            ],
            [
                "The Lord hath made a faithful oath unto David",
                "and he shall not shrink from it;"
            ],
            [
                "Of the fruit of thy body",
                "shall I set upon thy seat."
            ],
            [
                "If thy children will keep my covenant, and my testimonies that I shall learn them",
                "their children also shall sit upon thy seat for evermore."
            ],
            [
                "For the Lord hath chosen Sion to be an habitation for himself",
                "he hath longed for her."
            ],
            [
                "This shall be my rest for ever",
                "here will I dwell, for I have a delight therein."
            ],
            [
                "I will bless her victuals with increase",
                "and will satisfy her poor with bread."
            ],
            [
                "I will deck her priests with health",
                "and her saints shall rejoice and sing."
            ],
            [
                "There shall I make the horn of David to flourish",
                "I have ordained a lantern for mine Anointed."
            ],
            [
                "As for his enemies, I shall clothe them with shame",
                "but upon himself shall his crown flourish."
            ]
        ],
        id: "psalm132"
    },
    {
        lines: [
            [
                "BEHOLD, how good and joyful a thing it is",
                "brethren, to dwell together in unity!"
            ],
            [
                "It is like the precious ointment upon the head, that ran down unto the beard",
                "even unto Aaron's beard, and went down to the skirts of his clothing."
            ],
            [
                "Like as the dew of Hermon",
                "which fell upon the hill of Sion."
            ],
            [
                "For there the Lord promised his blessing",
                "and life for evermore."
            ]
        ],
        id: "psalm133"
    },
    {
        lines: [
            [
                "BEHOLD now, praise the Lord",
                "all ye servants of the Lord;"
            ],
            [
                "Ye that by night stand in the house of the Lord",
                "even in the courts of the house of our God."
            ],
            [
                "Lift up your hands in the sanctuary",
                "and praise the Lord."
            ],
            [
                "The Lord that made heaven and earth",
                "give thee blessing out of Sion."
            ]
        ],
        id: "psalm134"
    },
    {
        lines: [
            [
                "O PRAISE the Lord, laud ye the Name of the Lord",
                "praise it, O ye servants of the Lord;"
            ],
            [
                "Ye that stand in the house of the Lord",
                "in the courts of the house of our God."
            ],
            [
                "O praise the Lord, for the Lord is gracious",
                "O sing praises unto his Name, for it is lovely."
            ],
            [
                "For why? the Lord hath chosen Jacob unto himself",
                "and Israel for his own possession."
            ],
            [
                "For I know that the Lord is great",
                "and that our Lord is above all gods."
            ],
            [
                "Whatsoever the Lord pleased, that did he in heaven and in earth",
                "and in the sea, and in all deep places."
            ],
            [
                "He bringeth forth the clouds from the ends of the world",
                "and sendeth forth lightnings with the rain, bringing the winds out of his treasures."
            ],
            [
                "He smote the first born of Egypt",
                "both of man and beast."
            ],
            [
                "He hath sent tokens and wonders into the midst of thee, O thou land of Egypt",
                "upon Pharaoh, and all his servants."
            ],
            [
                "He smote divers nations",
                "and slew mighty kings;"
            ],
            [
                "Sehon king of the Amorites, and Og the king of Basan",
                "and all the kingdoms of Canaan;"
            ],
            [
                "And gave their land to be an heritage",
                "even an heritage unto Israel his people."
            ],
            [
                "Thy Name, O Lord, endureth for ever",
                "so doth thy memorial, O Lord, from one generation to another."
            ],
            [
                "For the Lord will avenge his people",
                "and be gracious unto his servants."
            ],
            [
                "As for the images of the heathen, they are but silver and gold",
                "the work of men's hands."
            ],
            [
                "They have mouths, and speak not",
                "eyes have they, but they see not."
            ],
            [
                "They have ears, and yet they hear not",
                "neither is there any breath in their mouths."
            ],
            [
                "They that make them are like unto them",
                "and so are all they that put their trust in them."
            ],
            [
                "Praise the Lord, ye house of Israel",
                "praise the Lord, ye house of Aaron."
            ],
            [
                "Praise the Lord, ye house of Levi",
                "ye that fear the Lord, praise the Lord."
            ],
            [
                "Praised be the Lord out of Sion",
                "who dwelleth at Jerusalem."
            ]
        ],
        id: "psalm135"
    },
    {
        lines: [
            [
                "O GIVE thanks unto the LORD, for he is gracious",
                "and his mercy endureth for ever."
            ],
            [
                "O give thanks unto the God of all gods",
                "for his mercy endureth for ever."
            ],
            [
                "O thank the Lord of all lords",
                "for his mercy endureth for ever."
            ],
            [
                "Who only doeth great wonders",
                "for his mercy endureth for ever."
            ],
            [
                "Who by his excellent wisdom made the heavens",
                "for his mercy endureth for ever."
            ],
            [
                "Who laid out the earth above the waters",
                "for his mercy endureth for ever."
            ],
            [
                "Who hath made great lights",
                "for his mercy endureth for ever;"
            ],
            [
                "The sun to rule the day",
                "for his mercy endureth for ever;"
            ],
            [
                "The moon and the stars to govern the night",
                "for his mercy endureth for ever."
            ],
            [
                "Who smote Egypt with their first born",
                "for his mercy endureth for ever;"
            ],
            [
                "And brought out Israel from among them",
                "for his mercy endureth for ever;"
            ],
            [
                "With a mighty hand, and stretched out arm",
                "for his mercy endureth for ever."
            ],
            [
                "Who divided the Red sea in two parts",
                "for his mercy endureth for ever;"
            ],
            [
                "And made Israel to go through the midst of it",
                "for his mercy endureth for ever."
            ],
            [
                "But as for Pharaoh and his host, he overthrew them in the Red sea",
                "for his mercy endureth for ever."
            ],
            [
                "Who led his people through the wilderness",
                "for his mercy endureth for ever."
            ],
            [
                "Who smote great kings",
                "for his mercy endureth for ever;"
            ],
            [
                "Yea, and slew mighty kings",
                "for his mercy endureth for ever;"
            ],
            [
                "Sehon king of the Amorites",
                "for his mercy endureth for ever;"
            ],
            [
                "And Og the king of Basan",
                "for his mercy endureth for ever;"
            ],
            [
                "And gave away their land for an heritage",
                "for his mercy endureth for ever;"
            ],
            [
                "Even for an heritage unto Israel his servant",
                "for his mercy endureth for ever."
            ],
            [
                "Who remembered us when we were in trouble",
                "for his mercy endureth for ever;"
            ],
            [
                "And hath delivered us from our enemies",
                "for his mercy endureth for ever."
            ],
            [
                "Who giveth food to all flesh",
                "for his mercy endureth for ever."
            ],
            [
                "O give thanks unto the God of heaven",
                "for his mercy endureth for ever."
            ],
            [
                "O give thanks unto the Lord of lords",
                "for his mercy endureth for ever."
            ]
        ],
        id: "psalm136"
    },
    {
        lines: [
            [
                "BY THE waters of Babylon we sat down and wept",
                "when we remembered thee, O Sion."
            ],
            [
                "As for our harps, we hanged them up",
                "upon the trees that are therein."
            ],
            [
                "For they that led us away captive required of us then a song, and melody in our heaviness",
                "Sing us one of the songs of Sion."
            ],
            [
                "How shall we sing the Lord's song",
                "in a strange land?"
            ],
            [
                "If I forget thee, O Jerusalem",
                "let my right hand forget her cunning."
            ],
            [
                "If I do not remember thee, let my tongue cleave to the roof of my mouth",
                "yea, if I prefer not Jerusalem in my mirth."
            ],
            [
                "Remember the children of Edom, O Lord, in the day of Jerusalem",
                "how they said, Down with it, down with it, even to the ground."
            ],
            [
                "O daughter of Babylon, wasted with misery",
                "yea, happy shall he be that rewardeth thee, as thou hast served us."
            ],
            [
                "Blessed shall he be that taketh thy children",
                "and throweth them against the stones."
            ]
        ],
        id: "psalm137"
    },
    {
        lines: [
            [
                "I WILL give thanks unto thee, O Lord, with my whole heart",
                "even before the gods will I sing praise unto thee."
            ],
            [
                "I will worship toward thy holy temple, and praise thy Name, because of thy loving kindness and truth",
                "for thou hast magnified thy Name and thy word above all things."
            ],
            [
                "When I called upon thee, thou heardest me",
                "and enduedst my soul with much strength."
            ],
            [
                "All the kings of the earth shall praise thee, O Lord",
                "for they have heard the words of thy mouth."
            ],
            [
                "Yea, they shall sing in the ways of the Lord",
                "that great is the glory of the Lord."
            ],
            [
                "For though the Lord be high, yet hath he respect unto the lowly",
                "as for the proud, he beholdeth them afar off."
            ],
            [
                "Though I walk in the midst of trouble, yet shalt thou refresh me",
                "thou shalt stretch forth thy hand upon the furiousness of mine enemies, and thy right hand shall save me."
            ],
            [
                "The lord shall make good his loving kindness toward me",
                "yea, thy mercy, O Lord, endureth for ever; despise not then the works of thine own hands."
            ]
        ],
        id: "psalm138"
    },
    {
        lines: [
            [
                "O LORD, thou hast searched me out and known me",
                "thou knowest my down sitting and mine up rising, thou understandest my thoughts long before."
            ],
            [
                "Thou art about my path, and about my bed",
                "and spiest out all my ways."
            ],
            [
                "For lo, there is not a word in my tongue",
                "but thou, O Lord, knowest it altogether."
            ],
            [
                "Thou hast fashioned me behind and before",
                "and laid thine hand upon me."
            ],
            [
                "Such knowledge is too wonderful and excellent for me",
                "I cannot attain unto it."
            ],
            [
                "Whither shall I go then from thy Spirit",
                "or whither shall I go then from thy presence?"
            ],
            [
                "If I climb up into heaven, thou art there",
                "if I go down to hell, thou art there also."
            ],
            [
                "If I take the wings of the morning",
                "and remain in the uttermost parts of the sea;"
            ],
            [
                "Even there also shall thy hand lead me",
                "and thy right hand shall hold me."
            ],
            [
                "If I say, Peradventure the darkness shall cover me",
                "then shall my night be turned to day."
            ],
            [
                "Yea, the darkness is no darkness with thee, but the night is as clear as the day",
                "the darkness and light to thee are both alike."
            ],
            [
                "For my reins are thine",
                "thou hast covered me in my mother's womb."
            ],
            [
                "I will give thanks unto thee, for I am fearfully and wonderfully made",
                "marvellous are thy works, and that my soul knoweth right well."
            ],
            [
                "My bones are not hid from thee",
                "though I be made secretly, and fashioned beneath in the earth."
            ],
            [
                "Thine eyes did see my substance, yet being unperfect",
                "and in thy book were all my members written;"
            ],
            [
                "Which day by day were fashioned",
                "when as yet there was none of them."
            ],
            [
                "How dear are thy counsels unto me, O God",
                "O how great is the sum of them!"
            ],
            [
                "If I tell them, they are more in number than the sand",
                "when I wake up I am present with thee."
            ],
            [
                "Wilt thou not slay the wicked, O God",
                "depart from me, ye blood thirsty men."
            ],
            [
                "For they speak unrighteously against thee",
                "and thine enemies take thy Name in vain."
            ],
            [
                "Do not I hate them, O Lord, that hate thee",
                "and am not I grieved with those that rise up against thee?"
            ],
            [
                "Yea, I hate them right sore",
                "even as though they were mine enemies."
            ],
            [
                "Try me, O God, and seek the ground of my heart",
                "prove me, and examine my thoughts."
            ],
            [
                "Look well if there be any way of wickedness in me",
                "and lead me in the way everlasting."
            ]
        ],
        id: "psalm139"
    },
    {
        lines: [
            [
                "DELIVER me, O Lord, from the evil man",
                "and preserve me from the wicked man."
            ],
            [
                "Who imagine mischief in their hearts",
                "and stir up strife all the day long."
            ],
            [
                "They have sharpened their tongues like a serpent",
                "adders' poison is under their lips."
            ],
            [
                "Keep me, O Lord, from the hands of the ungodly",
                "preserve me from the wicked men, who are purposed to overthrow my goings."
            ],
            [
                "The proud have laid a snare for me, and spread a net abroad with cords",
                "yea, and set traps in my way."
            ],
            [
                "I said unto the Lord, Thou art my God",
                "hear the voice of my pray'rs, O Lord."
            ],
            [
                "O Lord God, thou strength of my health",
                "thou hast covered my head in the day of battle."
            ],
            [
                "Let not the ungodly have his desire, O Lord",
                "let not his mischievous imagination prosper, lest they be too proud."
            ],
            [
                "Let the mischief of their own lips fall upon the head of them",
                "that compass me about."
            ],
            [
                "Let hot burning coals fall upon them",
                "let them be cast into the fire and into the pit, that they never rise up again."
            ],
            [
                "A man full of words shall not prosper upon the earth",
                "evil shall hunt the wicked person to overthrow him."
            ],
            [
                "Sure I am that the Lord will avenge the poor",
                "and maintain the cause of the helpless."
            ],
            [
                "The righteous also shall give thanks unto thy Name",
                "and the just shall continue in thy sight."
            ]
        ],
        id: "psalm140"
    },
    {
        lines: [
            [
                "LORD, I call upon thee, haste thee unto me",
                "and consider my voice when I cry unto thee."
            ],
            [
                "Let my prayer be set forth in thy sight as the incense",
                "and let the lifting up of my hands be an evening sacrifice."
            ],
            [
                "Set a watch, O Lord, before my mouth",
                "and keep the door of my lips."
            ],
            [
                "O let not mine heart be inclined to any evil thing",
                "let me not be occupied in ungodly works with the men that work wickedness, lest I eat of such things as please them."
            ],
            [
                "Let the righteous rather smite me friendly",
                "and reprove me."
            ],
            [
                "But let not their precious balms break my head",
                "yea, I will pray yet against their wickedness."
            ],
            [
                "Let their judges be overthrown in stony places",
                "that they may hear my words, for they are sweet."
            ],
            [
                "Our bones lie scattered before the pit",
                "like as when one breaketh and heweth wood upon the earth."
            ],
            [
                "But mine eyes look unto thee, O Lord God",
                "in thee is my trust, O cast not out my soul."
            ],
            [
                "Keep me from the snare that they have laid for me",
                "and from the traps of the wicked doers."
            ],
            [
                "Let the ungodly fall into their own nets together",
                "and let me ever escape them."
            ]
        ],
        id: "psalm141"
    },
    {
        lines: [
            [
                "I CRIED unto the Lord with my voice",
                "yea, even unto the Lord did I make my supplication."
            ],
            [
                "I poured out my complaints before him",
                "and shewed him of my trouble."
            ],
            [
                "When my spirit was in heaviness thou knewest my path",
                "in the way wherein I walked have they privily laid a snare for me."
            ],
            [
                "I looked also upon my right hand",
                "and saw there was no man that would know me."
            ],
            [
                "I had no place to flee unto",
                "and no man cared for my soul."
            ],
            [
                "I cried unto thee, O Lord, and said",
                "Thou art my hope, and my portion in the land of the living."
            ],
            [
                "Consider my complaint",
                "for I am brought very low."
            ],
            [
                "O deliver me from my persecutors",
                "for they are too strong for me."
            ],
            [
                "Bring my soul out of prison, that I may give thanks unto thy Name",
                "which thing if thou wilt grant me, then shall the righteous resort unto my company."
            ]
        ],
        id: "psalm142"
    },
    {
        lines: [
            [
                "HEAR my prayer, O Lord, and consider my desire",
                "hearken unto me for thy truth and righteousness' sake."
            ],
            [
                "And enter not into judgement with thy servant",
                "for in thy sight shall no man living be justified."
            ],
            [
                "For the enemy hath persecuted my soul; he hath smitten my life down to the ground",
                "he hath laid me in the darkness, as the men that have been long dead."
            ],
            [
                "Therefore is my spirit vexed within me",
                "and my heart within me is desolate."
            ],
            [
                "Yet do I remember the time past; I muse upon all thy works",
                "yea, I exercise myself in the works of thy hands."
            ],
            [
                "I stretch forth my hands unto thee",
                "my soul gaspeth unto thee as a thirsty land."
            ],
            [
                "Hear me, O Lord, and that soon, for my spirit waxeth faint",
                "hide not thy face from me, lest I be like unto them that go down into the pit."
            ],
            [
                "O let me hear thy loving kindness betimes in the morning, for in thee is my trust",
                "shew thou me the way that I should walk in, for I lift up my soul unto thee."
            ],
            [
                "Deliver me, O Lord, from mine enemies",
                "for I flee unto thee to hide me."
            ],
            [
                "Teach me to do the thing that pleaseth thee, for thou art my God",
                "let thy loving Spirit lead me forth into the land of righteousness."
            ],
            [
                "Quicken me, O Lord, for thy Name's sake",
                "and for thy righteousness' sake bring my soul out of trouble."
            ],
            [
                "And of thy goodness slay mine enemies",
                "and destroy all them that vex my soul ; for I am thy servant."
            ]
        ],
        id: "psalm143"
    },
    {
        lines: [
            [
                "BLESSED be the Lord my strength",
                "who teacheth my hands to war, and my fingers to fight;"
            ],
            [
                "My hope and my fortress, my castle and deliverer, my defender in whom I trust",
                "who subdueth my people that is under me."
            ],
            [
                "Lord, what is man, that thou hast such respect unto him",
                "or the son of man, that thou so regardest him?"
            ],
            [
                "Man is like a thing of nought",
                "his time passeth away like a shadow."
            ],
            [
                "Bow thy heavens, O Lord, and come down",
                "touch the mountains, and they shall smoke."
            ],
            [
                "Cast forth thy lightning, and tear them",
                "shoot out thine arrows, and consume them."
            ],
            [
                "Send down thine hand from above",
                "deliver me, and take me out of the great waters, from the hand of strange children;"
            ],
            [
                "Whose mouth talketh of vanity",
                "and their right hand is a right hand of wickedness."
            ],
            [
                "I will sing a new song unto thee, O God",
                "and sing praises unto thee upon a ten stringed lute."
            ],
            [
                "Thou hast given victory unto kings",
                "and hast delivered David thy servant from the peril of the sword."
            ],
            [
                "Save me, and deliver me from the hand of strange children",
                "whose mouth talketh of vanity, and their right hand is a right hand of iniquity."
            ],
            [
                "That our sons may grow up as the young plants",
                "and that our daughters may be as the polished corners of the temple."
            ],
            [
                "That our garners may be full and plenteous with all manner of store",
                "that our sheep may bring forth thousands and ten thousands in our streets."
            ],
            [
                "That our oxen may be strong to labour, that there be no decay",
                "no leading into captivity, and no complaining in our streets."
            ],
            [
                "Happy are the people that are in such a case",
                "yea, blessed are the people who have the Lord for their God."
            ]
        ],
        id: "psalm144"
    },
    {
        lines: [
            [
                "I WILL magnify thee, O God, my King",
                "and I will praise thy Name for ever and ever."
            ],
            [
                "Every day will I give thanks unto thee",
                "and praise thy Name for ever and ever."
            ],
            [
                "Great is the Lord, and marvellous worthy to be praised",
                "there is no end of his greatness."
            ],
            [
                "One generation shall praise thy works unto another",
                "and declare thy pow'r."
            ],
            [
                "As for me, I will be talking of thy worship",
                "thy glory, thy praise, and wondrous works;"
            ],
            [
                "So that men shall speak of the might of thy marvellous acts",
                "and I will also tell of thy greatness."
            ],
            [
                "The memorial of thine abundant kindness shall be shewed",
                "and men shall sing of thy righteousness."
            ],
            [
                "The Lord is gracious and merciful",
                "long suffering and of great goodness."
            ],
            [
                "The Lord is loving unto ev' ry man",
                "and his mercy is over all his works."
            ],
            [
                "All thy works praise thee, O Lord",
                "and thy saints give thanks unto thee."
            ],
            [
                "They shew the glory of thy kingdom",
                "and talk of thy pow'r;"
            ],
            [
                "That thy power, thy glory, and mightiness of thy kingdom",
                "might be known unto men."
            ],
            [
                "Thy kingdom is an everlasting kingdom",
                "and thy dominion endureth throughout all ages."
            ],
            [
                "The Lord upholdeth all such as fall",
                "and lifteth up all those that are down."
            ],
            [
                "The eyes of all wait upon thee, O Lord",
                "and thou givest them their meat in due season."
            ],
            [
                "Thou openest thine hand",
                "and fillest all things living with plenteousness."
            ],
            [
                "The Lord is righteous in all his ways",
                "and holy in all his works."
            ],
            [
                "The Lord is nigh unto all them that call upon him",
                "yea, all such as call upon him faithfully."
            ],
            [
                "He will fulfil the desire of them that fear him",
                "he also will hear their cry, and will help them."
            ],
            [
                "The Lord preserveth all them that love him",
                "but scattereth abroad all the ungodly."
            ],
            [
                "My mouth shall speak the praise of the Lord",
                "and let all flesh give thanks unto his holy Name for ever and ever."
            ]
        ],
        id: "psalm145"
    },
    {
        lines: [
            [
                "PRAISE the Lord, O my soul; while I live will I praise the Lord",
                "yea, as long as I have any being, I will sing praises unto my God."
            ],
            [
                "O put not your trust in princes, nor in any child of man",
                "for there is no help in them."
            ],
            [
                "For when the breath of man goeth forth he shall turn again to his earth",
                "and then all his thoughts perish."
            ],
            [
                "Blessed is he that hath the God of Jacob for his help",
                "and whose hope is in the Lord his God;"
            ],
            [
                "Who made heaven and earth, the sea, and all that therein is",
                "who keepeth his promise for ever;"
            ],
            [
                "Who helpeth them to right that suffer wrong",
                "who feedeth the hungry."
            ],
            [
                "The Lord looseth men out of prison",
                "the Lord giveth sight to the blind."
            ],
            [
                "The Lord helpeth them that are fallen",
                "the Lord careth for the righteous."
            ],
            [
                "The Lord careth for the strangers, he defendeth the fatherless and widow",
                "as for the way of the ungodly, he turneth it upside down."
            ],
            [
                "The Lord thy God, O Sion, shall be King for evermore",
                "and throughout all generations."
            ]
        ],
        id: "psalm146"
    },
    {
        lines: [
            [
                "O PRAISE the Lord, for it is a good thing to sing praises unto our God",
                "yea, a joyful and pleasant thing it is to be thankful."
            ],
            [
                "The Lord doth build up Jerusalem",
                "and gather together the out casts of Israel."
            ],
            [
                "He healeth those that are broken in heart",
                "and giveth medicine to heal their sickness."
            ],
            [
                "He telleth the number of the stars",
                "and calleth them all by their names."
            ],
            [
                "Great is our Lord, and great is his power",
                "yea, and his wisdom is infinite."
            ],
            [
                "The Lord setteth up the meek",
                "and bringeth the ungodly down to the ground."
            ],
            [
                "O sing unto the Lord with thanksgiving",
                "sing praises upon the harp unto our God;"
            ],
            [
                "Who covereth the heaven with clouds, and prepareth rain for the earth",
                "and maketh the grass to grow upon the mountains, and herb for the use of men;"
            ],
            [
                "Who giveth fodder unto the cattle",
                "and feedeth the young ravens that call upon him."
            ],
            [
                "He hath no pleasure in the strength of an horse",
                "neither delighteth he in any man's legs."
            ],
            [
                "But the Lord's delight is in them that fear him",
                "and put their trust in his mercy."
            ],
            [
                "Praise the Lord, O Jerusalem",
                "praise thy God, O Sion."
            ],
            [
                "For he hath made fast the bars of thy gates",
                "and hath blessed thy children within thee."
            ],
            [
                "He maketh peace in thy borders",
                "and filleth thee with the flour of wheat."
            ],
            [
                "He sendeth forth his commandment upon earth",
                "and his word runneth very swiftly."
            ],
            [
                "He giveth snow like wool",
                "and scattereth the hoar frost like ashes."
            ],
            [
                "He casteth forth his ice like morsels",
                "who is able to abide his frost?"
            ],
            [
                "He sendeth out his word, and melteth them",
                "he bloweth with his wind, and the waters flow."
            ],
            [
                "He sheweth his word unto Jacob",
                "his statutes and ordinances unto Israel."
            ],
            [
                "He hath not dealt so with any nation",
                "neither have the heathen knowledge of his laws."
            ]
        ],
        id: "psalm147"
    },
    {
        lines: [
            [
                "O PRAISE the Lord of heaven",
                "praise him in the height."
            ],
            [
                "Praise him, all ye angels of his",
                "praise him, all his host."
            ],
            [
                "Praise him, sun and moon",
                "praise him, all ye stars and light."
            ],
            [
                "Praise him, all ye heavens",
                "and ye waters that are above the heavens."
            ],
            [
                "Let them praise the Name of the Lord",
                "for he spake the word, and they were made; he commanded, and they were created."
            ],
            [
                "He hath made them fast for ever and ever",
                "he hath given them a law which shall not be broken."
            ],
            [
                "Praise the Lord upon earth",
                "ye dragons, and all deeps;"
            ],
            [
                "Fire and hail, snow and vapours",
                "wind and storm, fulfilling his word;"
            ],
            [
                "Mountains and all hills",
                "fruitful trees and all cedars;"
            ],
            [
                "Beasts and all cattle",
                "worms and feathered fowls;"
            ],
            [
                "Kings of the earth and all people",
                "princes and all judges of the world;"
            ],
            [
                "Young men and maidens, old men and children, praise the Name of the Lord",
                "for his Name only is excellent, and his praise above heaven and earth."
            ],
            [
                "He shall exalt the horn of his people; all his saints shall praise him",
                "even the children of Israel, even the people that serveth him."
            ]
        ],
        id: "psalm148"
    },
    {
        lines: [
            [
                "O SING unto the Lord a new song",
                "let the congregation of saints praise him."
            ],
            [
                "Let Israel rejoice in him that made him",
                "and let the children of Sion be joyful in their King."
            ],
            [
                "Let them praise his Name in the dance",
                "let them sing praises unto him with tabret and harp."
            ],
            [
                "For the Lord hath pleasure in his people",
                "and helpeth the meek hearted."
            ],
            [
                "Let the saints be joyful with glory",
                "let them rejoice in their beds."
            ],
            [
                "Let the praises of God be in their mouth",
                "and a two edged sword in their hands;"
            ],
            [
                "To be avenged of the heathen",
                "and to rebuke the people;"
            ],
            [
                "To bind their kings in chains",
                "and their nobles with links of iron."
            ],
            [
                "That they may be avenged of them, as it is written",
                "Such honour have all his saints."
            ]
        ],
        id: "psalm149"
    },
    {
        lines: [
            [
                "O PRAISE God in his holiness",
                "praise him in the firmament of his power."
            ],
            [
                "Praise him in his noble acts",
                "praise him according to his excellent greatness."
            ],
            [
                "Praise him in the sound of the trumpet",
                "praise him upon the lute and harp."
            ],
            [
                "Praise him in the cymbals and dances",
                "praise him upon the strings and pipe."
            ],
            [
                "Praise him upon the well tuned cymbals",
                "praise him upon the loud cymbals."
            ],
            [
                "Let every thing that hath breath",
                "praise the Lord."
            ]
        ],
        id: "psalm150"
    },
    {
        lines: [
            [
                "BLESSED are those that are undefiled in the way",
                "and walk in the law of the Lord."
            ],
            [
                "Blessed are they that keep his testimonies",
                "and seek him with their whole heart."
            ],
            [
                "For they who do no wickedness",
                "walk in his ways."
            ],
            [
                "Thou hast charged",
                "that we shall diligently keep thy commandments."
            ],
            [
                "O that my ways were made so direct",
                "that I might keep thy statutes!"
            ],
            [
                "So shall I not be confounded",
                "while I have respect unto all thy commandments."
            ],
            [
                "I will thank thee with an unfeigned heart",
                "when I shall have learned the judgements of thy righteousness."
            ],
            [
                "I will keep thy ceremonies",
                "O forsake me not utterly."
            ],
            [
                "WHEREWITHAL shall a young man cleanse his way",
                "even by ruling himself after thy word."
            ],
            [
                "With my whole heart have I sought thee",
                "O let me not go wrong out of thy commandments."
            ],
            [
                "Thy words have I hid within my heart",
                "that I should not sin against thee."
            ],
            [
                "Blessed art thou, O Lord",
                "O teach me thy statutes."
            ],
            [
                "With my lips have I been telling",
                "of all the judgements of thy mouth."
            ],
            [
                "I have had as great delight in the way of thy testimonies",
                "as in all manner of riches."
            ],
            [
                "I will talk of thy commandments",
                "and have respect unto thy ways."
            ],
            [
                "My delight shall be in thy statutes",
                "and I will not forget thy word."
            ],
            [
                "O DO well unto thy servant",
                "that I may live, and keep thy word."
            ],
            [
                "Open thou mine eyes",
                "that I may see the wondrous things of thy law."
            ],
            [
                "I am a stranger upon earth",
                "O hide not thy commandments from me."
            ],
            [
                "My soul breaketh out for the very fervent desire",
                "that it hath alway unto thy judgements."
            ],
            [
                "Thou hast rebuked the proud",
                "and cursed are they that do err from thy commandments."
            ],
            [
                "O turn from me shame and rebuke",
                "for I have kept thy testimonies."
            ],
            [
                "Princes also did sit and speak against me",
                "but thy servant is occupied in thy statutes."
            ],
            [
                "For thy testimonies are my delight",
                "and my counsellors."
            ],
            [
                "MY SOUL cleaveth to the dust",
                "O quicken thou me, according to thy word."
            ],
            [
                "I have acknowledged my ways, and thou heardest me",
                "O teach me thy statutes."
            ],
            [
                "Make me to understand the way of thy commandments",
                "and so shall I talk of thy wondrous works."
            ],
            [
                "My soul melteth away for very heaviness",
                "comfort thou me according unto thy word."
            ],
            [
                "Take from me the way of lying",
                "and cause thou me to make much of thy law."
            ],
            [
                "I have chosen the way of truth",
                "and thy judgements have I laid before me."
            ],
            [
                "I have stuck unto thy testimonies",
                "O Lord, confound me not."
            ],
            [
                "I will run the way of thy commandments",
                "when thou hast set my heart at liberty."
            ],
            [
                "TEACH me, O Lord, the way of thy statutes",
                "and I shall keep it unto the end."
            ],
            [
                "Give me understanding, and I shall keep thy law",
                "yea, I shall keep it with my whole heart."
            ],
            [
                "Make me to go in the path of thy commandments",
                "for therein is my desire."
            ],
            [
                "Incline my heart unto thy testimonies",
                "and not to covetousness."
            ],
            [
                "O turn away mine eyes, lest they behold vanity",
                "and quicken thou me in thy way."
            ],
            [
                "O stablish thy word in thy servant",
                "that I may fear thee."
            ],
            [
                "Take away the rebuke that I am afraid of",
                "for thy judgements are good."
            ],
            [
                "Behold, my delight is in thy commandments",
                "O quicken me in thy righteousness."
            ],
            [
                "LET thy loving mercy come also unto me, O Lord",
                "even thy salvation, according unto thy word."
            ],
            [
                "So shall I make answer unto my blasphemers",
                "for my trust is in thy word."
            ],
            [
                "O take not the word of thy truth utterly out of my mouth",
                "for my hope is in thy judgements."
            ],
            [
                "So shall I alway keep thy law",
                "yea, for ever and ever."
            ],
            [
                "And I will walk at liberty",
                "for I seek thy commandments."
            ],
            [
                "I will speak of thy testimonies also, even before kings",
                "and will not be ashamed."
            ],
            [
                "And my delight shall be in thy commandments",
                "which I have loved."
            ],
            [
                "My hands also will I lift up unto thy commandments, which I have loved",
                "and my study shall be in thy statutes."
            ],
            [
                "O THINK upon thy servant, as concerning thy word",
                "wherein thou hast caused me to put my trust."
            ],
            [
                "The same is my comfort in my trouble",
                "for thy word hath quickened me."
            ],
            [
                "The proud have had me exceedingly in derision",
                "yet have I not shrinked from thy law."
            ],
            [
                "For I remembered thine everlasting judgements, O Lord",
                "and received comfort."
            ],
            [
                "I am horribly afraid",
                "for the ungodly that forsake thy law."
            ],
            [
                "Thy statutes have been my songs",
                "in the house of my pilgrimage."
            ],
            [
                "I have thought upon thy Name, O Lord, in the night season",
                "and have kept thy law."
            ],
            [
                "This I had",
                "because I kept thy commandments."
            ],
            [
                "THOU art my portion, O Lord",
                "I have promised to keep thy law."
            ],
            [
                "I made my humble petition in thy presence with my whole heart",
                "O be merciful unto me, according to thy word."
            ],
            [
                "I called mine own ways to remembrance",
                "and turned my feet unto thy testimonies."
            ],
            [
                "I made haste, and prolonged not the time",
                "to keep thy commandments."
            ],
            [
                "The congregations of the ungodly have robbed me",
                "but I have not forgotten thy law."
            ],
            [
                "At midnight I will rise to give thanks unto thee",
                "because of thy righteous judgements."
            ],
            [
                "I am a companion of all them that fear thee",
                "and keep thy commandments."
            ],
            [
                "The earth, O Lord, is full of thy mercy",
                "O teach me thy statutes."
            ],
            [
                "O LORD, thou hast dealt graciously with thy servant",
                "according unto thy word."
            ],
            [
                "O learn me true understanding and knowledge",
                "for I have believed thy commandments."
            ],
            [
                "Before I was troubled, I went wrong",
                "but now have I kept thy word."
            ],
            [
                "Thou art good and gracious",
                "O teach me thy statutes."
            ],
            [
                "The proud have imagined a lie against me",
                "but I will keep thy commandments with my whole heart."
            ],
            [
                "Their heart is as fat as brawn",
                "but my delight hath been in thy law."
            ],
            [
                "It is good for me that I have been in trouble",
                "that I may learn thy statutes."
            ],
            [
                "The law of thy mouth is dearer unto me",
                "than thousands of gold and silver."
            ],
            [
                "THY hands have made me and fashioned me",
                "O give me understanding, that I may learn thy commandments."
            ],
            [
                "They that fear thee will be glad when they see me",
                "because I have put my trust in thy word."
            ],
            [
                "I know, O Lord, that thy judgements are right",
                "and that thou of very faithfulness hast caused me to be troubled."
            ],
            [
                "O let thy merciful kindness be my comfort",
                "according to thy word unto thy servant."
            ],
            [
                "O let thy loving mercies come unto me, that I may live",
                "for thy law is my delight."
            ],
            [
                "Let the proud be confounded, for they go wickedly about to destroy me",
                "but I will be occupied in thy commandments."
            ],
            [
                "Let such as fear thee, and have known thy testimonies",
                "be turned unto me."
            ],
            [
                "O let my heart be sound in thy statutes",
                "that I be not ashamed."
            ],
            [
                "MY SOUL hath longed for thy salvation",
                "and I have a good hope because of thy word."
            ],
            [
                "Mine eyes long sore for thy word",
                "saying, O when wilt thou comfort me?"
            ],
            [
                "For I am become like a bottle in the smoke",
                "yet do I not forget thy statutes."
            ],
            [
                "How many are the days of thy servant",
                "when wilt thou be avenged of them that persecute me?"
            ],
            [
                "The proud have digged pits for me",
                "which are not after thy law."
            ],
            [
                "All thy commandments are true",
                "they persecute me falsely; O be thou my help."
            ],
            [
                "They had almost made an end of me upon earth",
                "but I forsook not thy commandments."
            ],
            [
                "O quicken me after thy loving kindness",
                "and so shall I keep the testimonies of thy mouth."
            ],
            [
                "O LORD, thy word",
                "endureth for ever in heaven."
            ],
            [
                "Thy truth also remaineth from one generation to another",
                "thou hast laid the foundation of the earth, and it abideth."
            ],
            [
                "They continue this day according to thine ordinance",
                "for all things serve thee."
            ],
            [
                "If my delight had not been in thy law",
                "I should have perished in my trouble."
            ],
            [
                "I will never forget thy commandments",
                "for with them thou hast quickened me."
            ],
            [
                "I am thine, O save me",
                "for I have sought thy commandments."
            ],
            [
                "The ungodly laid wait for me to destroy me",
                "but I will consider thy testimonies."
            ],
            [
                "I see that all things come to an end",
                "but thy commandment is exceeding broad."
            ],
            [
                "LORD, what love have I unto thy law",
                "all the day long is my study in it."
            ],
            [
                "Thou through thy commandments hast made me wiser than mine enemies",
                "for they are ever with me."
            ],
            [
                "I have more understanding than my teachers",
                "for thy testimonies are my study."
            ],
            [
                "I am wiser than the aged",
                "because I keep thy commandments."
            ],
            [
                "I have refrained my feet from every evil way",
                "that I may keep thy word."
            ],
            [
                "I have not shrunk from thy judgements",
                "for thou teachest me."
            ],
            [
                "O how sweet are thy words unto my throat",
                "yea, sweeter than honey unto my mouth."
            ],
            [
                "Through thy commandments I get understanding",
                "therefore I hate all evil ways."
            ],
            [
                "THY word is a lantern unto my feet",
                "and a light unto my paths."
            ],
            [
                "I have sworn, and am stedfastly purposed",
                "to keep thy righteous judgements."
            ],
            [
                "I am troubled above measure",
                "quicken me, O Lord, according to thy word."
            ],
            [
                "Let the free will offerings of my mouth please thee, O Lord",
                "and teach me thy judgements."
            ],
            [
                "My soul is alway in my hand",
                "yet do I not forget thy law."
            ],
            [
                "The ungodly have laid a snare for me",
                "but yet I swerved not from thy commandments."
            ],
            [
                "Thy testimonies have I claimed as mine heritage for ever",
                "and why? they are the very joy of my heart."
            ],
            [
                "I have applied my heart to fulfil thy statutes alway",
                "even unto the end."
            ],
            [
                "I HATE them that imagine evil things",
                "but thy law do I love."
            ],
            [
                "Thou art my defence and shield",
                "and my trust is in thy word."
            ],
            [
                "Away from me, ye wicked",
                "I will keep the commandments of my God."
            ],
            [
                "O stablish me according to thy word, that I may live",
                "and let me not be disappointed of my hope."
            ],
            [
                "Hold thou me up, and I shall be safe",
                "yea, my delight shall be ever in thy statutes."
            ],
            [
                "Thou hast trodden down all them that depart from thy statutes",
                "for they imagine but deceit."
            ],
            [
                "Thou puttest away all the ungodly of the earth like dross",
                "therefore I love thy testimonies."
            ],
            [
                "My flesh trembleth for fear of thee",
                "and I am afraid of thy judgements."
            ],
            [
                "I DEAL with the thing that is lawful and right",
                "O give me not over unto mine oppressors."
            ],
            [
                "Make thou thy servant to delight in that which is good",
                "that the proud do me no wrong."
            ],
            [
                "Mine eyes are wasted away with looking for thy health",
                "and for the word of thy righteousness."
            ],
            [
                "O deal with thy servant according unto thy loving mercy",
                "and teach me thy statutes."
            ],
            [
                "I am thy servant, O grant me understanding",
                "that I may know thy testimonies."
            ],
            [
                "It is time for thee, Lord, to lay to thine hand",
                "for they have destroyed thy law."
            ],
            [
                "For I love thy commandments",
                "above gold and precious stone."
            ],
            [
                "Therefore hold I straight all thy commandments",
                "and all false ways I utterly abhor."
            ],
            [
                "THY testimonies are wonderful",
                "therefore doth my soul keep them."
            ],
            [
                "When thy word goeth forth",
                "it giveth light and understanding unto the simple."
            ],
            [
                "I opened my mouth, and drew in my breath",
                "for my delight was in thy commandments."
            ],
            [
                "O look thou upon me, and be merciful unto me",
                "as thou usest to do unto those that love thy Name."
            ],
            [
                "Order my steps in thy word",
                "and so shall no wickedness have dominion over me."
            ],
            [
                "O deliver me from the wrongful dealings of men",
                "and so shall I keep thy commandments."
            ],
            [
                "Shew the light of thy countenance upon thy servant",
                "and teach me thy statutes."
            ],
            [
                "Mine eyes gush out with water",
                "because men keep not thy law."
            ],
            [
                "RIGHTEOUS art thou, O Lord",
                "and true is thy judgement."
            ],
            [
                "The testimonies that thou hast commanded",
                "are exceeding righteous and true."
            ],
            [
                "My zeal hath even consumed me",
                "because mine enemies have forgotten thy words."
            ],
            [
                "Thy word is tried to the uttermost",
                "and thy servant loveth it."
            ],
            [
                "I am small, and of no reputation",
                "yet do I not forget thy commandments."
            ],
            [
                "Thy righteousness is an everlasting righteousness",
                "and thy law is the truth."
            ],
            [
                "Trouble and heaviness have taken hold upon me",
                "yet is my delight in thy commandments."
            ],
            [
                "The righteousness of thy testimonies is everlasting",
                "O grant me understanding, and I shall live."
            ],
            [
                "I CALL with my whole heart",
                "hear me, O Lord, I will keep thy statutes."
            ],
            [
                "Yea, even unto thee do I call",
                "help me, and I shall keep thy testimonies."
            ],
            [
                "Early in the morning do I cry unto thee",
                "for in thy word is my trust."
            ],
            [
                "Mine eyes prevent the night watches",
                "that I might be occupied in thy words."
            ],
            [
                "Hear my voice, O Lord, according unto thy loving kindness",
                "quicken me, according as thou art wont."
            ],
            [
                "They draw nigh that of malice persecute me",
                "and are far from thy law."
            ],
            [
                "Be thou nigh at hand, O Lord",
                "for all thy commandments are true."
            ],
            [
                "As concerning thy testimonies, I have known long since",
                "that thou hast grounded them for ever."
            ],
            [
                "O CONSIDER mine adversity, and deliver me",
                "for I do not forget thy law."
            ],
            [
                "Avenge thou my cause, and deliver me",
                "quicken me, according to thy word."
            ],
            [
                "Health is far from the ungodly",
                "for they regard not thy statutes."
            ],
            [
                "Great is thy mercy, O Lord",
                "quicken me, as thou art wont."
            ],
            [
                "Many there are that trouble me, and persecute me",
                "yet do I not swerve from thy testimonies."
            ],
            [
                "It grieveth me when I see the transgressors",
                "because they keep not thy law."
            ],
            [
                "Consider, O Lord, how I love thy commandments",
                "O quicken me, according to thy loving kindness."
            ],
            [
                "Thy word is true from everlasting",
                "all the judgements of thy righteousness endure for evermore."
            ],
            [
                "PRINCES have persecuted me without a cause",
                "but my heart standeth in awe of thy word."
            ],
            [
                "I am as glad of thy word",
                "as one that findeth great spoils."
            ],
            [
                "As for lies, I hate and abhor them",
                "but thy law do I love."
            ],
            [
                "Seven times a day do I praise thee",
                "because of thy righteous judgements."
            ],
            [
                "Great is the peace that they have who love thy law",
                "and they are not offended at it."
            ],
            [
                "Lord, I have looked for thy saving health",
                "and done after thy commandments."
            ],
            [
                "My soul hath kept thy testimonies",
                "and loved them exceedingly."
            ],
            [
                "I have kept thy commandments and testimonies",
                "for all my ways are before thee."
            ],
            [
                "LET my complaint come before thee, O Lord",
                "give me understanding, according to thy word."
            ],
            [
                "Let my supplication come before thee",
                "deliver me, according to thy word."
            ],
            [
                "My lips shall speak of thy praise",
                "when thou hast taught me thy statutes."
            ],
            [
                "Yea, my tongue shall sing of thy word",
                "for all thy commandments are righteous."
            ],
            [
                "Let thine hand help me",
                "for I have chosen thy commandments."
            ],
            [
                "I have longed for thy saving health, O Lord",
                "and in thy law is my delight."
            ],
            [
                "O let my soul live, and it shall praise thee",
                "and thy judgements shall help me."
            ],
            [
                "I have gone astray like a sheep that is lost",
                "O seek thy servant, for I do not forget thy commandments."
            ]
        ],
        id: "psalm119"
    }
];






parcelRequire("acw62");





const $c1660c4b937221b9$export$556058c3d95d4cd7 = ()=>{
    const { id: id, tone: tone } = (0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)();
    const canticleId = id.replace(/-/g, " ");
    const dateTime = new Date();
    if (dateTime.getHours() < 3) dateTime.setDate(dateTime.getDate() - 1);
    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();
    const day = (0, $063afc2d5fcbb72a$export$229d3f939f129064)(year, month, date, true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
                initialState: {},
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        paddingTop: 32,
                        paddingBottom: 32
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2de76dc2a5b96b1f$export$4d2dd46eb8f9c829), {
                        id: canticleId,
                        day: day,
                        tone: tone === "tpa" ? "Tonus Peregrinus A" : tone
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {})
        ]
    });
};



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




const $3f96ea998b4cabec$export$3e6649f30f523144 = (props)=>{
    const { day: day, readings: readings } = props;
    const loadableLessons = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "mattins readings",
        day: day,
        mattinsReadings: readings,
        bibleTranslation: "ESV",
        refsOnly: false
    });
    const [isOpened, setIsOpened] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            borderTop: `1px dashed ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`
        },
        children: loadableLessons.state === "loaded" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        padding: 4,
                        fontSize: "90%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                width: 100
                            },
                            children: [
                                day.dayOfTheWeek.toLocaleUpperCase(),
                                " ",
                                day.month,
                                "/",
                                day.date,
                                " ",
                                day.label
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                width: 240
                            },
                            children: [
                                "(",
                                Math.round(loadableLessons.value.firstLesson.map((part)=>part.content.map((line)=>line.text.length).reduce((a, b)=>a + b, 0)).reduce((a, b)=>a + b, 0) / 100) / 10,
                                "k)",
                                " ",
                                loadableLessons.value.firstLesson.map((part)=>part.title).join("; ")
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                width: 240
                            },
                            children: [
                                "(",
                                Math.round(loadableLessons.value.secondLesson.map((part)=>part.content.map((line)=>line.text.length).reduce((a, b)=>a + b, 0)).reduce((a, b)=>a + b, 0) / 100) / 10,
                                "k)",
                                " ",
                                loadableLessons.value.secondLesson.map((part)=>part.title).join("; ")
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                textDecoration: "underline",
                                cursor: "pointer",
                                color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                            },
                            onClick: ()=>setIsOpened(!isOpened),
                            children: "Show/Hide"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        maxHeight: isOpened ? 10000 : 0,
                        overflow: "hidden",
                        opacity: isOpened ? 1 : 0,
                        transition: "all 0.3s",
                        paddingBottom: isOpened ? 48 : 0
                    },
                    children: [
                        loadableLessons.value.firstLesson.map((lessonPart)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fb31402637fa4d9$export$aaa271f2756a673f), {
                                title: lessonPart.title,
                                content: lessonPart.content,
                                hasBeginneth: false
                            }, lessonPart.title);
                        }),
                        loadableLessons.value.secondLesson.map((lessonPart)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fb31402637fa4d9$export$aaa271f2756a673f), {
                                title: lessonPart.title,
                                content: lessonPart.content,
                                hasBeginneth: false
                            }, lessonPart.title);
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e6ae22ad468d2c6$export$e2b0760399e6dece), {})
    });
};



parcelRequire("acw62");



const $92518e4b5be8b64d$export$99bbb45b94432a4e = (props)=>{
    const { day: day, cycle: cycle } = props;
    const loadableMorningPsalms = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "proper psalms",
        day: day,
        psalmCycle: cycle,
        time: "morning"
    });
    const loadableEveningPsalms = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "proper psalms",
        day: day,
        psalmCycle: cycle,
        time: "evening"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            borderTop: `1px dashed ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`
        },
        children: loadableMorningPsalms.state === "loaded" && loadableEveningPsalms.state === "loaded" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    padding: 4,
                    fontSize: "90%"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            width: 100
                        },
                        children: [
                            day.dayOfTheWeek.toLocaleUpperCase(),
                            " ",
                            day.month,
                            "/",
                            day.date
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            width: 240
                        },
                        children: loadableMorningPsalms.value.join("; ")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            width: 240
                        },
                        children: loadableEveningPsalms.value.join("; ")
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e6ae22ad468d2c6$export$e2b0760399e6dece), {})
    });
};


const $86f728f9e78ea0a6$var$psalmTableList = [
    "bcp",
    "acna",
    "cw"
];
const $86f728f9e78ea0a6$var$readingsTableList = [
    "1922-morning",
    "1922-evening",
    "1871-morning",
    "1871-evening",
    "cw-morning",
    "cw-evening",
    "acna-morning-short",
    "acna-evening-short"
];
const $86f728f9e78ea0a6$export$50512dd1088260c8 = ()=>{
    const dateTime = new Date();
    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();
    const psalmTables = $86f728f9e78ea0a6$var$psalmTableList.map((section)=>{
        let foundToday = false;
        let daysPrinted = 0;
        const rows = (0, $063afc2d5fcbb72a$export$6d7724e5c284a396)(year, true).days.concat((0, $063afc2d5fcbb72a$export$6d7724e5c284a396)(year + 1, true).days).map((day)=>{
            if (day.date === date && day.month === month && day.year === year) foundToday = true;
            if (foundToday && daysPrinted < 30) {
                daysPrinted++;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92518e4b5be8b64d$export$99bbb45b94432a4e), {
                        day: day,
                        cycle: section
                    })
                });
            } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                borderTop: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        fontSize: "120%",
                        fontWeight: "bold",
                        padding: 8
                    },
                    children: [
                        "Psalms: ",
                        section
                    ]
                }),
                rows
            ]
        });
    });
    const lessonTables = $86f728f9e78ea0a6$var$readingsTableList.map((section)=>{
        let foundToday = false;
        let daysPrinted = 0;
        const rows = (0, $063afc2d5fcbb72a$export$6d7724e5c284a396)(year, true).days.concat((0, $063afc2d5fcbb72a$export$6d7724e5c284a396)(year + 1, true).days).map((day)=>{
            if (day.date === date && day.month === month && day.year === year) foundToday = true;
            if (foundToday && daysPrinted < 30) {
                daysPrinted++;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f96ea998b4cabec$export$3e6649f30f523144), {
                        day: day,
                        readings: section
                    })
                });
            } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                borderTop: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontSize: "120%",
                        fontWeight: "bold",
                        padding: 8
                    },
                    children: section
                }),
                rows
            ]
        });
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            psalmTables,
            lessonTables
        ]
    });
};



parcelRequire("acw62");








parcelRequire("acw62");

const $dae5e57034279cf0$export$4377c71588c2474b = (props)=>{
    const { children: children, indent: indent } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingLeft: indent === 10 ? 0 : (indent ?? 0) * (isSmallScreen ? 16 : 24),
            paddingTop: (indent ?? 0) === 0 ? 6 : 0,
            paddingBottom: (indent ?? 0) === 0 ? 6 : 0,
            textAlign: indent === 10 ? "right" : (indent ?? 0) === 0 ? "justify" : "left"
        },
        children: children
    });
};


const $120d07281b4392b0$export$6be7e458d8b009af = ()=>{
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontWeight: "bold",
                        letterSpacing: 2,
                        textTransform: "uppercase",
                        fontSize: "140%",
                        paddingBottom: 4,
                        paddingTop: 32,
                        textAlign: "center"
                    },
                    children: "The Commination"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The Officiant shall say,"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "Brethren, in the Primitive Church there was a godly discipline, that, at the beginning of Lent, such persons as stood convicted of notorious sin were put to open penance, and punished in this world, that their souls might be saved in the day of the Lord; and that others, admonished by their example, might be the more afraid to offend.\\n\\nInstead whereof, until the said discipline may be restored again, (which is much to be wished,) it is thought good, that at this time (in the presence of you all) should be read the general sentences of God's cursing against impenitent sinners, gathered out of the seven and twentieth Chapter of Deuteronomy, and other places of Scripture; and that ye should answer to every Sentence, Amen: To the intent that, being admonished of the great indignation of God against sinners, ye may the rather be moved to earnest and true repentance; and may walk more warily in these dangerous days; fleeing from such vices, for which ye affirm with your own mouths the curse of God to be due."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The Officiant shall say, the_People_responding,"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "Cursed is the man that maketh any carved or molten image, to worship it.\\n **Amen.**\\n\\n Cursed is he that curseth his father or mother.\\n **Amen.**\\n\\n Cursed is he that removeth his neighbour's landmark.\\n **Amen.**\\n\\n Cursed is he that maketh the blind to go out of his way.\\n **Amen.**\\n\\n Cursed is he that perverteth the judgement of the stranger, the fatherless, and widow.\\n **Amen.**\\n\\n Cursed is he that smiteth his neighbour secretly.\\n **Amen.**\\n\\n Cursed is he that lieth with his neighbour's wife.\\n **Amen.**\\n\\n Cursed is he that taketh reward to slay the innocent.\\n **Amen.**\\n\\n Cursed is he that putteth his trust in man, and taketh man for his defence, and in his heart goeth from the Lord.\\n **Amen.**\\n\\n Cursed are the unmerciful, fornicators, and adulterers, covetous persons, idolaters, slanderers, drunkards, and extortioners.\\n **Amen.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The Officiant shall continue,"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "Now seeing that all they are accursed (as the prophet David beareth witness) who do err and go astray from the commandments of God; let us (remembering the dreadful judgement hanging over our heads, and always ready to fall upon us) return unto our Lord God, with all contrition and meekness of heart; bewailing and lamenting our sinful life, acknowledging and confessing our offences, and seeking to bring forth worthy fruits of penance. For now is the axe put unto the root of the trees, so that every tree that bringeth not forth good fruit is hewn down, and cast into the fire. It is a fearful thing to fall into the hands of the living God: he shall pour down rain upon the sinners, snares, fire and brimstone, storm and tempest; this shall be their portion to drink. For lo, the Lord is come out of his place to visit the wickedness of such as dwell upon the earth. But who may abide the day of his coming? Who shall be able to endure when he appeareth? His fan is in his hand, and he will purge his floor, and gather his wheat into the barn; but he will burn the chaff with unquenchable fire. The day of the Lord cometh as a thief in the night: and when men shall say, Peace, and all things are safe, then shall sudden destruction come upon them, as sorrow cometh upon a woman travailing with child, and they shall not escape. Then shall appear the wrath of God in the day of vengeance, which obstinate sinners, through the stubbornness of their heart, have heaped unto themselves; which despised the goodness, patience, and long-sufferance of God, when he calleth them continually to repentance. Then shall they call upon me, (saith the Lord,) but I will not hear; they shall seek me early, but they shall not find me; and that, because they hated knowledge, and received not the fear of the Lord, but abhorred my counsel, and despised my correction. Then shall it be too late to knock when the door shall be shut; and too late to cry for mercy when it is the time of justice. O terrible voice of most just judgement, which shall be pronounced upon them, when it shall be said unto them, Go, ye cursed, into the fire everlasting, which is prepared for the devil and his angels. Therefore, brethren, take we heed betime, while the day of salvation lasteth; for the night cometh, when none can work. But let us, while we have the light, believe in the light, and walk as children of the light; that we be not cast into utter darkness, where is weeping and gnashing of teeth. Let us not abuse the goodness of God, who calleth us mercifully to amendment, and of his endless pity promiseth us forgiveness of that which is past, if with a perfect and true heart we return unto him. For though our sins be as red as scarlet, they shall be made white as snow; and though they be like purple, yet they shall be made white as wool. Turn ye (saith the Lord) from all your wickedness, and your sin shall not be your destruction: Cast away from you all your ungodliness that ye have done: Make you new hearts, and a new spirit: Wherefore will ye die, O ye house of Israel, seeing that I have no pleasure in the death of him that dieth, saith the Lord God? Turn ye then, and ye shall live. Although we have sinned, yet have we an Advocate with the Father, Jesus Christ the righteous; and he is the propitiation for our sins. For he was wounded for our offences, and smitten for our wickedness. Let us therefore return unto him, who is the merciful receiver of all true penitent sinners; assuring ourselves that he is ready to receive us, and most willing to pardon us, if we come unto him with faithful repentance; if we submit ourselves unto him, and from henceforth walk in his ways; if we will take his easy yoke, and light burden upon us, to follow him in lowliness, patience, and charity, and be ordered by the governance of his Holy Spirit; seeking always his glory, and serving him duly in our vocation with thanksgiving: This if we do, Christ will deliver us from the curse of the law, and from the extreme malediction which shall light upon them that shall be set on the left hand; and he will set us on his right hand, and give us the gracious benediction of his Father, commanding us to take possession of his glorious kingdom: Unto which he vouchsafe to bring us all, for his infinite mercy. Amen."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "All kneeling, this **Penitential_Psalm** (Psalm_51) shall_be_said_without_note."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                onlySides: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        paddingBottom: 8,
                        paddingTop: 8,
                        paddingLeft: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                        paddingRight: isSmallScreen ? (0, $b5d1360628cd70a0$export$84c40e91fbd203e0) / 2 : (0, $b5d1360628cd70a0$export$84c40e91fbd203e0),
                        fontSize: isSmallScreen ? (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57) * 0.9 : (0, $b5d1360628cd70a0$export$edb31f1ce7b7be57),
                        textAlign: "justify",
                        color: (0, $b5d1360628cd70a0$export$516f68680b50dca1)
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            whiteSpace: "pre-wrap",
                            textAlign: "justify"
                        },
                        children: (0, $7f98b4308afe4768$export$adc377d3f4f7a592).find((psalm)=>psalm.id === "psalm51")?.lines.map((line)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dae5e57034279cf0$export$4377c71588c2474b), {
                                        children: line[0].replace(/_/g, "").replace(/\//g, "")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dae5e57034279cf0$export$4377c71588c2474b), {
                                        indent: 1,
                                        children: line[1].replace(/_/g, "").replace(/\//g, "")
                                    })
                                ]
                            });
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The Officiant shall pray, the_People_responding,"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "Lord, have mercy upon us.\\n**Christ, have mercy upon us.**\\n**Lord, have mercy upon us.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "Our Father, who art in heaven, Hallowed be thy Name. Thy kingdom come. Thy will be done on earth, as it is in heaven. Give us this day our daily bread, And forgive us our trespasses, As we forgive them that trespass against us. And lead us not into temptation; But deliver us from evil. For thine is the kingdom, the power, and the glory, for ever and ever.\\n**Amen.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "O Lord, save thy servants;\\n **That put their trust in thee.**\\n Send unto them help from above.\\n **And evermore mightily defend them.**\\n Help us, O God our Saviour.\\n **And for the glory of thy Name deliver us; be merciful to us sinners, for thy Name's sake.**\\n O Lord, hear our prayer.\\n **And let our cry come unto thee.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "Let us pray.\\n\\nO Lord, we beseech thee, mercifully hear our prayers, and spare all those who confess their sins unto thee; that they, whose consciences by sin are accused, by thy merciful pardon may be absolved; through Christ our Lord.\\n**Amen.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "O most mighty God, and merciful Father, who hast compassion upon all men, and hatest nothing that thou hast made; who wouldest not the death of a sinner, but that he should rather turn from his sin, and be saved: Mercifully forgive us our trespasses; receive and comfort us, who are grieved and wearied with the burden of our sins. Thy property is always to have mercy; to thee only it appertaineth to forgive sins. Spare us therefore, good Lord, spare thy people, whom thou hast redeemed; enter not into judgement with thy servants, who are vile earth, and miserable sinners; but so turn thine anger from us, who meekly acknowledge our vileness, and truly repent us of our faults, and so make haste to help us in this world, that we may ever live with thee in the world to come; through Jesus Christ our Lord.\\n**Amen.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The Officiant and People shall say together this prayer."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "**Turn thou us, O good Lord, and so shall we be turned. Be favourable, O Lord, Be favourable to thy people, Who turn to thee in weeping, fasting, and praying. For thou art a merciful God, Full of compassion. Longsuffering, and of great pity. Thou sparest when we deserve punishment, And in thy wrath thinkest upon mercy. Spare thy people, good Lord, spare them, And let not thine heritage be brought to confusion. Hear us, O Lord, for thy mercy is great, And after the multitude of thy mercies look upon us; Through the merits and mediation of thy blessed Son, Jesus Christ our Lord. Amen.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The Officiant shall pronounce this **Blessing.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "The Lord bless us, and keep us; the Lord lift up the light of his countenance upon us, and give us peace, now and for evermore.\\n**Amen.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {})
        ]
    });
};



parcelRequire("acw62");






const $55280dfc09a6d391$export$fcde770debb1d037 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontWeight: "bold",
                        letterSpacing: 2,
                        textTransform: "uppercase",
                        fontSize: "140%",
                        paddingBottom: 4,
                        paddingTop: 32,
                        textAlign: "center"
                    },
                    children: "INTRODUCTION"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {
                big: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            whiteSpace: "pre-wrap",
                            textAlign: "justify",
                            fontStyle: "italic"
                        },
                        children: [
                            [
                                "Praise the LORD, for it is a good thing to sing prais_es un_to our God;",
                                "yea, a joy_ful and plea_sant thing it is to be thank_ful."
                            ]
                        ].map((line)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dae5e57034279cf0$export$4377c71588c2474b), {
                                        children: line[0].replace(/_/g, "")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dae5e57034279cf0$export$4377c71588c2474b), {
                                        indent: 1,
                                        children: line[1].replace(/_/g, "")
                                    })
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            textAlign: "right"
                        },
                        children: "\u2014 Psalm 147:1"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            whiteSpace: "pre-wrap",
                            textAlign: "justify",
                            fontStyle: "italic"
                        },
                        children: [
                            [
                                "Show your_selves joy_ful un_to the LORD, all ye lands;",
                                "sing, re_joice, and give thanks."
                            ]
                        ].map((line)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dae5e57034279cf0$export$4377c71588c2474b), {
                                        children: line[0].replace(/_/g, "")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dae5e57034279cf0$export$4377c71588c2474b), {
                                        indent: 1,
                                        children: line[1].replace(/_/g, "")
                                    })
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            textAlign: "right"
                        },
                        children: "\u2014 Psalm 98:5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            whiteSpace: "pre-wrap",
                            textAlign: "justify",
                            fontStyle: "italic"
                        },
                        children: [
                            [
                                "Se_ven times a day do I praise thee;",
                                "be_cause of thy right_eous judg_ments."
                            ]
                        ].map((line)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dae5e57034279cf0$export$4377c71588c2474b), {
                                        children: line[0].replace(/_/g, "")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dae5e57034279cf0$export$4377c71588c2474b), {
                                        indent: 1,
                                        children: line[1].replace(/_/g, "")
                                    })
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            textAlign: "right"
                        },
                        children: "\u2014 Psalm 119:164"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: "For thousands of years, the People of God have sung the Psalms every day as an offering of thanks and praise to Almighty God, as an act of love, and as a response to his direct command and provision for us to do so."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: [
                    "As",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        style: {
                            textDecoration: "underline"
                        },
                        href: "https://theopolisinstitute.com/the-psalter-should-be-woven-into-the-fabric-of-worship/",
                        target: "_blank",
                        children: "James Jordan writes"
                    }),
                    ","
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        paddingLeft: 24,
                        paddingRight: 24
                    },
                    children: "God likes psalms. He wrote them, and He likes to hear them sung. If we love Him, we will make the effort to learn them, all of them, and sing them to Him before His throne on His day."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: "The exact implementation of this practice has varied with time and place. From early in the history of the Church, by the time of Saint Benedict in the 5th century, the practice of praying seven times during the day (Psalm 119:164) and once at night (Psalm 119:62) was observed. The whole Psalter could be sung every week within this framework."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: "Over the centuries, the participation of laypeople in this 'Liturgy of the Hours' has varied and has generally been less than that of monastics. By the time of the English Reformation, it was common for laypeople to attend Morning Prayer and Evening Prayer (and Mass) on feast days \u2014 services which were conducted in Latin \u2014 but otherwise to leave the Liturgy of the Hours to the monks. Thomas Cranmer, desiring that laypeople be exposed to the Scriptures in full and in English, condensed the eight Offices into two larger services with substantial readings in English covering most of the Bible every year and the whole Psalter every month."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: 'These Anglican Daily Offices have continued to this day, especially in the form of Choral Evensong, where the Psalms and Canticles are sung by a choir to beautiful settings, while the congregation listens in silence. Private recitation of the Offices among laypeople is somewhat common but is often said rather than sung, and so still falls short of the Scriptural command and provision to "sing to the Lord!" \u2014 rather like reading out the contents of a hymn book. No doubt there are many reasons for this, but one is the enormous difficulty of assembling and learning to use a suitable set of resources for singing the Daily Office, especially for those without a significant musical background. SingTheOffice.com is intended as a remedy to this difficulty.'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: "On SingTheOffice.com, the Psalms are provided set out in the 'square notation' commonly used by monks. This notation was designed with practicality in mind, and is generally considered easier than modern musical notation for people without a musical background. The settings provided here are plainsong, a form of music originating at least fifteen centuries ago and used to sing the Psalms ever since. With a bit of practice, anyone can learn to sing the Psalms in plainsong, and participate daily in this beautiful form of worship."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: [
                    "The best way to be introduced to plainsong is by example, so Psalm 1 is given below, and can be used alongside this",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        style: {
                            textDecoration: "underline"
                        },
                        href: "https://youtu.be/uakqB3is63E?t=48",
                        children: "recording of Psalm 1 being sung"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
                initialState: {},
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "full",
                        number: 1
                    },
                    excludeGloriaPatri: true
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: [
                    "More plainsong Psalm recordings (not all settings being identical to those on this site) can be found",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        style: {
                            textDecoration: "underline"
                        },
                        href: "https://canticasacra.org/?page_id=8623",
                        children: "here"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: [
                    "In plainsong, the text is sung smoothly at about the same pace that it would be said, without forcing the text into a particular rhythm. A good breath should be taken between each half-line (where there are vertical bars in the notation). The tone can be sung at any pitch that you find comfortable: when you come to a Psalm on this site, clicking",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "More..."
                    }),
                    " in the top right will allow you to play the notes of the tone in order to learn how to sing it, and the pitch can be changed with the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Higher"
                    }),
                    " and",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "Lower"
                    }),
                    " buttons."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: "On SingTheOffice.com, the whole liturgy for Mattins and Evensong (and for Compline, which has returned to common Anglican practice more recently) is given with all the musical settings right in the order of service. The instructions are given for how to celebrate the Daily Office as a service with multiple people in attendance, but if praying alone, one acts as both the Officiant and the 'People'."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: [
                    "The most important parts of the Daily Office to sing are the Psalms and Canticles, as they are expressly given as songs in the Bible; however, it is common practice to sing much more of the liturgy of the Daily Office. On SingTheOffice.com, just about everything that could be sung is given with a musical setting, but note that it is acceptable to say things that you are not confident to sing. Learning to sing the Daily Office is a marathon, not a sprint! It's also worth bearing in mind that it's more important here to sing ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        children: "joyfully"
                    }),
                    " than to sing",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        children: "accurately"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {
                big: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                children: "While not exactly identical to any of the following, this site is indebted to the Proctor and Frere Manual of Plainsong, the St Dunstan's Plainsong Psalter, the Palmer Sarum Psalter, the McMaster Sarum Psalter and Hymnal, the English Hymnal, the 1662, 1928, and 2019 Books of Common Prayer, to the ancestor works that fed into these, and ultimately to Almighty God for his loving provision of the Psalms and Canticles of Holy Scripture, and for his providence in guiding the development of plainsong and the Daily Offices throughout history. The work contained in this site is offered freely, to his glory, with the hope that it enables more individuals so inclined to sing his praises on a daily basis."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    paddingTop: 24,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    style: {
                        textDecoration: "underline"
                    },
                    href: "/",
                    children: "Return to Home"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {
                big: true
            })
        ]
    });
};



parcelRequire("acw62");






parcelRequire("acw62");



const $9657477ee54a4512$export$62dceb75706a409a = (props)=>{
    // DELETE
    const { settings: settings } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    if (props.said) {
        if (settings.lordsPrayer === "bcp") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
            content: "**Our Father, which art in heaven, Hallowed be thy Name, Thy kingdom come, Thy will be done, in earth as it is in heaven. Give us this day our daily bread; And forgive us our trespasses, As we forgive them that trespass against us; And lead us not into temptation, But deliver us from evil. Amen.**"
        });
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
            content: "**Our Father, who art in heaven, hallowed be thy Name. Thy kingdom come. Thy will be done, on earth as it is in heaven. Give us this day our daily bread. And forgive us our trespasses, as we forgive those who trespass against us. And lead us not into temptation, but deliver us from evil. For thine is the kingdom, the power, and the glory, for ever and ever. Amen.**"
        });
    } else {
        if (settings.lordsPrayer === "bcp") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
            boldMode: "all",
            dropCap: false,
            pointedText: {
                clef: "f5",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Our",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Fa",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ther,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "which",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "art",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hea",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ven,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Hal",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "lowed",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Name,",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "king",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "dom",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "come,",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "will",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "done,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "earth",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "as",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "it",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "is",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hea",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ven.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Give",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "this",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "day",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "dai",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ly",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "bread;",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "for",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "give",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "tres",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "pass",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "es,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "as",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "we",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "for",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "give",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "them",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "that",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "tres",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "pass",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "a",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "gainst",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us;",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "lead",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "not",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "to",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "temp",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ta",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "tion,",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "but",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "de",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "li",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ver",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "from",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "e",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "vil.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "A",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    },
                                    {
                                        text: "men.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        });
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
            boldMode: "all",
            dropCap: false,
            pointedText: {
                clef: "f5",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Our",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Fa",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ther,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "who",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "art",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hea",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ven,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hal",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "lowed",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Name.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "king",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "dom",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "come.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Thy",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "will",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "done,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "on",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "earth",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "as",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "it",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "is",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hea",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ven.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Give",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "this",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "day",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "dai",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ly",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "bread.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "for",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "give",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "tres",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "pass",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "es,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "as",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "we",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "for",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "give",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "those",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "who",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "tres",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "pass",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "a",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "gainst",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "lead",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "not",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "to",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "temp",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ta",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "tion,",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "but",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "de",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "li",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ver",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "from",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "e",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "vil.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "For",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thine",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "is",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "king",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "dom,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "pow",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "er,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "glo",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ry,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "for",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "ev",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "er",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "ev",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "er.",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "A",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    },
                                    {
                                        text: "men.",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        });
    }
};






parcelRequire("acw62");

const $754010e4eb809f2a$export$d279eb952b46bf38 = (props)=>{
    const { firstText: firstText, secondText: secondText, firstTone: firstTone, secondTone: secondTone } = props;
    const firstWords = [];
    const secondWords = [];
    let firstToneIndex = 0;
    const fw = firstText.split(" ");
    fw.forEach((word, wordIndex)=>{
        const pointedSyllables = [];
        const syllables = word.split("_");
        syllables.forEach((syllable, syllableIndex)=>{
            if (firstToneIndex > 0 && firstToneIndex < firstTone.length - 1) firstToneIndex++;
            if (syllable[0] === "|") {
                firstToneIndex++;
                syllable = syllable.slice(1);
            }
            pointedSyllables.push({
                text: syllable,
                notes: [
                    firstTone[firstToneIndex]
                ],
                long: wordIndex === fw.length - 1 && syllableIndex === syllables.length - 1,
                dotBefore: firstToneIndex === 1
            });
        });
        firstWords.push({
            syllables: pointedSyllables
        });
    });
    let secondToneIndex = 0;
    const sw = secondText.split(" ");
    sw.forEach((word, wordIndex)=>{
        const pointedSyllables = [];
        const syllables = word.split("_");
        syllables.forEach((syllable, syllableIndex)=>{
            if (secondToneIndex > 0 && secondToneIndex < secondTone.length - 1) secondToneIndex++;
            if (syllable[0] === "|") {
                secondToneIndex++;
                syllable = syllable.slice(1);
            }
            pointedSyllables.push({
                text: syllable,
                notes: [
                    secondTone[secondToneIndex]
                ],
                long: wordIndex === sw.length - 1 && syllableIndex === syllables.length - 1,
                dotBefore: secondToneIndex === 1
            });
        });
        secondWords.push({
            syllables: pointedSyllables
        });
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
        pointedText: {
            verses: [
                firstText.length > 0 ? {
                    firstHalf: firstWords,
                    secondHalf: secondWords
                } : {
                    secondHalf: secondWords
                }
            ],
            clef: "f5"
        },
        dropCap: false,
        boldMode: "alternate halves",
        tone: "2.1"
    });
};


const $f0fd8fc08fba9caf$export$f7380c386098e395 = ()=>{
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const date = new Date().getDate();
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    const day = (0, $063afc2d5fcbb72a$export$229d3f939f129064)(year, month, date, true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontWeight: "bold",
                        letterSpacing: 2,
                        textTransform: "uppercase",
                        fontSize: "140%",
                        paddingBottom: 4,
                        paddingTop: 32,
                        textAlign: "center"
                    },
                    children: "The Litany"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "These petitions shall be sung kneeling or standing."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "O God the Fa_ther, of |heav'n:",
                secondText: "have mer_cy up_on us mi_se_|ra_ble sin_ners.",
                firstTone: [
                    "5",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "O God the Son, Re_dee_mer of the |world:",
                secondText: "have mer_cy up_on us mi_se_|ra_ble sin_ners.",
                firstTone: [
                    "5",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "O God the Ho_ly Ghost, pro_ceed_ing from the Fa_ther and the |Son:",
                secondText: "have mer_cy up_on us mi_se_|ra_ble sin_ners.",
                firstTone: [
                    "5",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "O ho_ly, bless_ed, and glor_ious Tri_ni_ty, three Per_sons and one |God:",
                secondText: "have mer_cy up_on us mi_se_|ra_ble sin_ners.",
                firstTone: [
                    "5",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Re_mem_ber not, Lord, our of_fen_ces, nor the of_fen_ces of our fore_fa_thers; nei_ther take thou ven_geance of our sins: Spare us, good Lord, spare thy peo_ple, whom thou hast re_deemed with thy most precious blood, and be not an_gry with |us for ev_er.",
                secondText: "Spare |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "From all e_vil and mis_chief; from sin; from the crafts and ass_aults of the de_vil; from thy wrath, and from ev_er_last_|ing dam_na_tion,",
                secondText: "Good |Lord de_li_ver us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "From all blind_ness of heart; from pride, vain_glo_ry, and hy_po_cri_sy; from en_vy, hat_red, and ma_lice, and |all un_cha_ri_ta_ble_ness,",
                secondText: "Good |Lord de_li_ver us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "From for_ni_ca_tion, and all o_ther dead_ly sin; and from all the de_ceits of the world, the flesh, |and the de_vil,",
                secondText: "Good |Lord de_li_ver us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "From light_ning and tem_pest; from earth_quake, fire, and flood; from plague, pes_ti_lence, and fa_mine; from bat_tle and mur_der, and from |sud_den death,",
                secondText: "Good |Lord de_li_ver us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "From all se_di_tion, pri_vy con_spi_ra_cy, and re_bell_ion; from all false doc_trine, he_re_sy, and sch_ism; from hard_ness of heart, and con_tempt of thy Word |and Com_mand_ment,",
                secondText: "Good |Lord de_li_ver us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "By the my_ste_ry of thy ho_ly In_car_na_tion; by thy ho_ly Na_ti_vi_ty and Cir_cum_ci_sion; by thy Bap_tism, Fast_ing, |and Temp_ta_tion,",
                secondText: "Good |Lord de_li_ver us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "By thine A_go_ny and Bloo_dy Sweat; by thy Cross and Pass_ion; by thy pre_cious Death and Bu_ri_al; by thy glor_ious Re_sur_rec_tion and As_cen_sion, and by the Comi_ng of the |Ho_ly Ghost,",
                secondText: "Good |Lord de_li_ver us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "In all time of our tri_bu_la_tion; in all time of our wealth; in the hour of death, and in the |day of judg_ment,",
                secondText: "Good |Lord de_li_ver us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "We sin_ners do be_seech thee to hear us, O Lord God; and that it may please thee to rule and go_vern thy ho_ly Church u_ni_ver_sal in |the right way;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            settings.monarch === "yes" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                        firstText: "That it may please thee to keep and strength_en in the true wor_shipp_ing of thee, in right_eous_ness and ho_li_ness of life, thy Ser_vant Charles our most gra_cious |King and Go_ver_nor;",
                        secondText: "We be_seech thee to hear |us, good Lord.",
                        firstTone: [
                            "5",
                            "4",
                            "3",
                            "6"
                        ],
                        secondTone: [
                            "5",
                            "3",
                            "4",
                            "5"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                        firstText: "That it may please thee to rule his heart in thy faith, fear, and love, and that he may ev_er_more have af_fi_ance in thee, and ev_er seek thy hon_|our and glo_ry;",
                        secondText: "We be_seech thee to hear |us, good Lord.",
                        firstTone: [
                            "5",
                            "4",
                            "3",
                            "6"
                        ],
                        secondTone: [
                            "5",
                            "3",
                            "4",
                            "5"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                        firstText: "That it may please thee to be his de_fen_der and keep_er, giv_ing him the vic_to_ry o_ver |all his e_ne_mies;",
                        secondText: "We be_seech thee to hear |us, good Lord.",
                        firstTone: [
                            "5",
                            "4",
                            "3",
                            "6"
                        ],
                        secondTone: [
                            "5",
                            "3",
                            "4",
                            "5"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                        firstText: "That it may please thee to bless and pre_serve Wil_li_am Prince of Wales, and all the |Ro_yal Fa_mi_ly;",
                        secondText: "We be_seech thee to hear |us, good Lord.",
                        firstTone: [
                            "5",
                            "4",
                            "3",
                            "6"
                        ],
                        secondTone: [
                            "5",
                            "3",
                            "4",
                            "5"
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to il_lu_min_ate all Bish_ops, Priests, and Dea_cons, with true know_ledge and un_der_stand_ing of thy Word; and that both by their preach_ing and liv_ing they may set it forth, and show |it ac_cor_ding_ly;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to en_due the Lords of the Coun_cil, and all the No_bi_li_ty, with grace, wis_dom, and |un_der_stand_ing;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to bless and keep the Ma_gi_strates, giv_ing them grace to ex_e_cute just_ice, and to |main_tain truth;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to bless and keep |all thy peo_ple;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to give to all na_tions u_ni_ty, |peace, and con_cord;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to give us a heart to love and dread thee, and di_li_gent_ly to live af_ter |thy com_mand_ments;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to give to all thy peo_ple in_crease of grace to hear meek_ly thy Word, and to re_ceive it with pure af_fec_tion, and to bring forth the fruits |of the Spi_rit;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to bring in_to the way of truth all such as have erred, and |are de_ceived;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to strength_en such as do stand; and to com_fort and help the weak-_hearted; and to raise up those who fall; and fi_na_lly to beat down Sa_tan un_|der our feet;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to suc_cour, help, and com_fort, all who are in dan_ger, ne_ces_si_ty, and |tri_bu_la_tion;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to pre_serve all who tra_vel by land, by water, all wo_men la_bour_ing of child, all sick per_sons, and young child_ren; and to show thy pi_ty up_on all pri_so_|ners and cap_tives;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to de_fend, and pro_vide for, the fa_ther_less child_ren, and wi_dows, and all who are de_so_late |and op_pressed;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to have mer_cy up_|on all men;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to for_give our e_ne_mies, per_se_cu_tors, and slan_der_ers, and to |turn their hearts;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to give and pre_serve to our use the kindly fruits of the earth, so that in due time we |may en_joy them;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "That it may please thee to give us true re_pen_tance; to for_give us all our sins, neg_li_gen_ces, and ig_no_ran_ces; and to en_due us with the grace of thy Ho_ly Spi_rit to am_end our lives ac_cor_ding to thy |ho_ly Word;",
                secondText: "We be_seech thee to hear |us, good Lord.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Son of God: we be_seech |thee to hear us.",
                secondText: "Son of God: we be_seech |thee to hear us.",
                firstTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "O Lamb of God: that tak_est a_way the sins |of the world;",
                secondText: "Grant |us thy peace.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "O Lamb of God: that tak_est a_way the sins |of the world;",
                secondText: "Have mer_|cy up_on us.",
                firstTone: [
                    "5",
                    "4",
                    "3",
                    "6"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "|O Christ, hear us.",
                secondText: "|O Christ, hear us.",
                firstTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Lord, have mer_|cy up_on us.",
                secondText: "Lord, have mer_|cy up_on us.",
                firstTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Christ, have mer_|cy up_on us.",
                secondText: "Christ, have mer_|cy up_on us.",
                firstTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Lord, have mer_|cy up_on us.",
                secondText: "Lord, have mer_|cy up_on us.",
                firstTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "All shall sing together the **Lord's Prayer.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9657477ee54a4512$export$62dceb75706a409a), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "O Lord, deal not with us ac_cor_ding to |our sins.",
                secondText: "Nei_ther re_ward us ac_cord_ing to our i_ni_|qui_ties.",
                firstTone: [
                    "5",
                    "3",
                    "4"
                ],
                secondTone: [
                    "5",
                    "3"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The following prayers shall be sung by the Officiant on one note, ending as follows:"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "",
                secondText: "O God . . . through Je_sus Christ |our Lord",
                firstTone: [
                    "5",
                    "5"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "O God, merciful Father, that despisest not the sighing of a contrite heart, nor the desire of such as are sorrowful; Mercifully assist our prayers which we make before thee in all our troubles and adversities, whensoever they oppress us; and graciously hear us, that those evils which the craft and subtilty of the devil or man worketh be brought to nought; and by the providence of thy goodness they may be dispersed; that we thy servants, being hurt by no persecutions, may evermore give thanks unto thee in thy holy Church; through Jesus Christ our Lord."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "",
                secondText: "O Lord, a_rise, help us, and de_li_ver us for thy |Name's sake.",
                firstTone: [
                    "5"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "O God, we have heard with our ears, and our fathers have declared unto us, the noble works that thou didst in their days, and in the old time before them."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "",
                secondText: "O Lord, a_rise, help us, and de_li_ver us for thine hon_|our.",
                firstTone: [
                    "5"
                ],
                secondTone: [
                    "5",
                    "3"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Glo_ry be to the Fa_ther, and to the Son, and to the Ho_|ly Ghost;",
                secondText: "As it was in the be_ginn_ing, is now, and e_ver shall be, world with_|out end. A_men.",
                firstTone: [
                    "5",
                    "3",
                    "4"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4",
                    "4",
                    "5"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "From our e_ne_mies de_fend us, |O Christ.",
                secondText: "Gra_cious_ly look up_on our aff_lic_|tions.",
                firstTone: [
                    "5",
                    "3",
                    "4"
                ],
                secondTone: [
                    "5",
                    "3"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Pi_ti_ful_ly be_hold the sor_rows of |our hearts.",
                secondText: "Mer_ci_ful_ly for_give the sins of thy peo_|ple.",
                firstTone: [
                    "5",
                    "3",
                    "4"
                ],
                secondTone: [
                    "5",
                    "3"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Fa_vou_ra_bly with me_rcy hear our |pray'rs.",
                secondText: "O Son of Da_vid, have mer_cy up_|on us.",
                firstTone: [
                    "5",
                    "3"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "Both now and e_ver vouch_safe to hear us, |O Christ.",
                secondText: "Gra_cious_ly hear us, O Christ; gra_cious_ly hear us, O |Lord Christ.",
                firstTone: [
                    "5",
                    "3",
                    "4"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $754010e4eb809f2a$export$d279eb952b46bf38), {
                firstText: "O Lord, let thy mer_cy be showed up_|on us;",
                secondText: "As we do put our trust |in thee.",
                firstTone: [
                    "5",
                    "3",
                    "4"
                ],
                secondTone: [
                    "5",
                    "3",
                    "4"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "We humbly beseech thee, O Father, mercifully to look upon our infirmities; and, for the glory of thy Name, turn from us all those evils that we most justly have deserved; and grant, that in all our troubles we may put our whole trust and confidence in thy mercy, and evermore serve thee in holiness and pureness of living, to thy honour and glory; through our only Mediator and Advocate, Jesus Christ our Lord. **Amen.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The Officiant may say this **Prayer_of_Saint_John_Chrysostom.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "Almighty God, who hast given us grace at this time with one accord to make our common supplications unto thee; and dost promise, that when two or three are gathered together in thy Name thou wilt grant their requests: Fulfil now, O Lord, the desires and petitions of thy servants, as may be most expedient for them; granting us in this world knowledge of thy truth, and in the world to come life everlasting. **Amen.**"
            }),
            day.label === "ash-wednesday" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $56b95cfdb7e54a07$export$35e63fe56e1d2b2a), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "ASH WEDNESDAY"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "It is appropriate to conclude with",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                style: {
                                    textDecoration: "underline"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                    to: "/pray/commination",
                                    children: "The\xa0Commination"
                                })
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {})
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18d48c4e99474336$export$c95cd4f09a6c19a2), {
                content: "The Officiant shall say **The_Grace.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c45cd8ea291c1ba$export$2db84c782bfb16e2), {
                content: "The grace of our Lord Jesus Christ, and the love of God, and the fellowship of the Holy Ghost, be with us all evermore. **Amen.**"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {
                big: true
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");





const $75480ab0d41c8aaa$export$59079ee0c44d6fdd = ()=>{
    const loadableTextList = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "ord text list"
    });
    const { getNextDayWithIssues: getNextDayWithIssues } = (0, $7c33038c8be56082$export$1712d6253669b079)(loadableTextList);
    const nextDayWithIsssues = getNextDayWithIssues();
    const { settings: settings } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    if (settings.oneDayAheadPsalter !== "true") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    if (loadableTextList.state === "loaded" && nextDayWithIsssues) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingBottom: 24
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                padding: 8,
                border: "1px solid silver"
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        fontWeight: "bold"
                    },
                    children: [
                        "Next issue in",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            style: {
                                textDecoration: "underline"
                            },
                            children: [
                                nextDayWithIsssues.daysInFuture,
                                " days"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: "AM"
                }),
                nextDayWithIsssues.amIssues.map((issue)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                            opacity: issue.outranked ? 0.5 : 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: issue.celebration.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                to: `se/${issue.day.year}/${issue.day.month}/${issue.day.date}/${issue.celebration.label}/${issue.hour}`,
                                style: {
                                    color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                                },
                                children: "Open"
                            }),
                            issue.issues.map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: i
                                }))
                        ]
                    });
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: "PM"
                }),
                nextDayWithIsssues.pmIssues.map((issue)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                            opacity: issue.outranked ? 0.5 : 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: issue.celebration.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                                to: `se/${issue.day.year}/${issue.day.month}/${issue.day.date}/${issue.celebration.label}/${issue.hour}`,
                                style: {
                                    color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                                },
                                children: "Open"
                            }),
                            issue.issues.map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: i
                                }))
                        ]
                    });
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Checking for issues..."
    });
};







const $2a53768914375960$export$4e75a5f268c5373c = (gabc)=>{
    let isInsideNeume = false;
    let charsSoFar = 0;
    let wordsSoFar = 0;
    let result = "";
    for(let charIndex = 0; charIndex < gabc.length; charIndex++){
        const char = gabc[charIndex];
        if (char === ")") isInsideNeume = false;
        if (isInsideNeume) result += char;
        else {
            if (char === " " && charsSoFar > 1) wordsSoFar++;
            if ("abcdefghijklmnopqrstuvwxyz".includes(char.toLocaleLowerCase()) && wordsSoFar < 1) {
                charsSoFar++;
                result += char.toLocaleUpperCase();
            } else result += char;
        }
        if (char === "(") isInsideNeume = true;
    }
    return result;
};
const $2a53768914375960$export$73f5c5f9b6ebb3d8 = (line)=>{
    if (line.split(" ")[0].length === 1) return line.split(" ")[0].toLocaleUpperCase() + " " + line.split(" ")[1].toLocaleUpperCase() + " " + line.split(" ").slice(2).join(" ");
    else return line.split(" ")[0].toLocaleUpperCase() + " " + line.split(" ").slice(1).join(" ");
};
const $2a53768914375960$export$edab2bebf7e6cb2a = (day, hour, celebration, settings, loadableLessons, selectedOtCanticle, onSelectOtCanticle, officiantType, onSelectOfficiantType, antiphonOption, onSelectAntiphonOption, selectedCommon, onSelectCommon, selectedPsalms, onSelectPsalms, isLent, isEastertide, simplifiedHaecDies, onSelectSimplifiedHaecDies, includeIntroduction, onSelectIncludeIntroduction)=>{
    console.log("celebration", celebration);
    console.log(loadableLessons);
    const firstLesson = loadableLessons.state === "loaded" ? hour === "mattins" ? loadableLessons.value.lessons.morningFirstLesson : loadableLessons.value.lessons.eveningFirstLesson : undefined;
    const secondLesson = loadableLessons.state === "loaded" ? hour === "mattins" ? loadableLessons.value.lessons.morningSecondLesson : loadableLessons.value.lessons.eveningSecondLesson : undefined;
    const items = [];
    items.push({
        type: "rubric",
        content: "At the Office of the Dead the usual introductory responses are omitted."
    });
    items.push({
        type: "rubric",
        content: "The following Psalmody is said immediately."
    });
    if (hour === "mattins") {
        if (loadableLessons.state === "loaded") {
            const invAnt = loadableLessons.value.invAnts["ood inv"];
            if (loadableLessons.value.venite && invAnt) {
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: invAnt.gabc,
                    tone: invAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: invAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: invAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "gabc chant",
                    title: day.date === 19 ? "Jubliate Deo" : "Venite",
                    gabc: loadableLessons.value.venite,
                    tone: "VI",
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: loadableLessons.value.venite,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: loadableLessons.value.venite.split("(::)")[0] + "(::)",
                            title: "Play line",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: invAnt.gabc,
                    tone: invAnt.tone,
                    dropCap: true,
                    playButtons: []
                });
                items.push({
                    type: "spacer"
                });
            }
        }
    }
    const psalmTitles = {
        "ood make thy way": "Psalm 5",
        "ood turn thee o lord": "Psalm 6",
        "ood lest he devour": "Psalm 7",
        "ood from the gate": "Ego dixi",
        "ood i will walk": "Psalm 116",
        "ood woe is me": "Psalm 120",
        "ood the lord shall": "Psalm 121",
        "ood if thou lord": "Psalm 130",
        "ood despise not": "Psalm 138",
        "ood i am the": "Benedictus",
        "ood all that the": "Magnificat"
    };
    if (loadableLessons.state === "loaded") (hour === "mattins" ? [
        "ood make thy way",
        "ood turn thee o lord",
        "ood lest he devour"
    ] : [
        "ood i will walk",
        "ood woe is me",
        "ood the lord shall",
        "ood if thou lord",
        "ood despise not"
    ]).forEach((id)=>{
        if (loadableLessons.state === "loaded") {
            const psalm = loadableLessons.value.bens[id];
            if (psalm) {
                items.push({
                    type: "picker",
                    options: [
                        "Full",
                        "Simplified"
                    ],
                    onChange: onSelectAntiphonOption,
                    selectedOption: antiphonOption
                });
                const psalmAnt = antiphonOption === "Full" && !psalm.onlySimplified ? psalm.ant : psalm.simplifiedAnt;
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: psalmAnt.gabc,
                    tone: psalmAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: psalmAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: psalmAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "tone chant",
                    pointedText: (antiphonOption === "Simplified" || psalm.onlySimplified) && psalm.simplifiedBen ? psalm.simplifiedBen : psalm.ben,
                    tone: antiphonOption === "Full" ? psalm.ant.tone : psalm.ant.tone.replace("trans", ""),
                    boldMode: "alternate",
                    title: psalmTitles[id] ?? ""
                });
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: psalmAnt.gabc,
                    tone: psalmAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: psalmAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: psalmAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "spacer"
                });
            }
        }
    });
    else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "The **First_Lesson** is_read."
    });
    if (firstLesson !== undefined && Array.isArray(firstLesson)) {
        firstLesson.forEach((lessonPart, index)=>{
            items.push({
                type: "scripture",
                title: lessonPart.title,
                content: lessonPart.content,
                hasBeginneth: index === 0
            });
        });
        items.push({
            type: "text",
            content: "Here endeth the first lesson."
        });
    } else items.push({
        type: "loading"
    });
    if (hour !== "mattins") items.push({
        type: "gabc chant",
        title: "Versicle & Response",
        gabc: "(c4) I(h) heard(h) a(h) voice(h) from(h) hea(h)ven,(h) say(h)ing(h) un(i)to(h) me.(g) (::) *Bless*(h)*ed*(h) *are*(h) *the*(h) *dead*(h) *which*(h) *die*(i) *in*(h) *the*(h) *Lord.*(g) (::)",
        dropCap: true,
        tone: "",
        playButtons: [
            {
                gabc: "(c3) x(h) x(i) x(h) x(g)",
                title: "Play",
                intoneOnly: false
            }
        ]
    });
    items.push({
        type: "spacer"
    });
    if (loadableLessons.state === "loaded") (hour === "mattins" ? [
        "ood from the gate"
    ] : [
        "ood all that the"
    ]).forEach((id)=>{
        if (loadableLessons.state === "loaded") {
            const psalm = loadableLessons.value.bens[id];
            if (psalm) {
                items.push({
                    type: "picker",
                    options: [
                        "Full",
                        "Simplified"
                    ],
                    onChange: onSelectAntiphonOption,
                    selectedOption: antiphonOption
                });
                const psalmAnt = antiphonOption === "Full" && !psalm.onlySimplified ? psalm.ant : psalm.simplifiedAnt;
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: psalmAnt.gabc,
                    tone: psalmAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: psalmAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: psalmAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "tone chant",
                    pointedText: (antiphonOption === "Simplified" || psalm.onlySimplified) && psalm.simplifiedBen ? psalm.simplifiedBen : psalm.ben,
                    tone: antiphonOption === "Full" ? psalm.ant.tone : psalm.ant.tone.replace("trans", ""),
                    boldMode: "alternate",
                    title: psalmTitles[id] ?? ""
                });
                items.push({
                    type: "gabc chant",
                    title: "Antiphon",
                    gabc: psalmAnt.gabc,
                    tone: psalmAnt.tone,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: psalmAnt.gabc,
                            title: "Intone",
                            intoneOnly: true
                        },
                        {
                            gabc: psalmAnt.gabc,
                            title: "Play full",
                            intoneOnly: false
                        }
                    ]
                });
                items.push({
                    type: "spacer"
                });
            }
        }
    });
    else items.push({
        type: "loading"
    });
    items.push({
        type: "rubric",
        content: "The **Second_Lesson** is_read."
    });
    if (secondLesson !== undefined && Array.isArray(secondLesson)) {
        secondLesson.forEach((lessonPart, index)=>{
            items.push({
                type: "scripture",
                title: lessonPart.title,
                content: lessonPart.content,
                hasBeginneth: index === 0
            });
        });
        items.push({
            type: "text",
            content: "Here endeth the second lesson."
        });
    } else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    if (hour === "mattins") {
        // Mattins so add the hymn and benedictus
        items.push({
            type: "gabc chant",
            title: "Versicle & Response",
            gabc: "(c4) I(h) heard(h) a(h) voice(h) from(h) hea(h)ven,(h) say(h)ing(h) un(i)to(h) me.(g) (::) *Bless*(h)*ed*(h) *are*(h) *the*(h) *dead*(h) *which*(h) *die*(i) *in*(h) *the*(h) *Lord.*(g) (::)",
            dropCap: true,
            tone: "",
            playButtons: [
                {
                    gabc: "(c3) x(h) x(i) x(h) x(g)",
                    title: "Play",
                    intoneOnly: false
                }
            ]
        });
        items.push({
            type: "spacer"
        });
        items.push({
            type: "rubric",
            content: "The **Benedictus** is recited, and may be accompanied by the appointed Antiphon."
        });
        if (loadableLessons.state === "loaded") [
            "ood i am the"
        ].forEach((id)=>{
            if (loadableLessons.state === "loaded") {
                const psalm = loadableLessons.value.bens[id];
                if (psalm) {
                    items.push({
                        type: "picker",
                        options: [
                            "Full",
                            "Simplified"
                        ],
                        onChange: onSelectAntiphonOption,
                        selectedOption: antiphonOption
                    });
                    const psalmAnt = antiphonOption === "Full" && !psalm.onlySimplified ? psalm.ant : psalm.simplifiedAnt;
                    items.push({
                        type: "gabc chant",
                        title: "Antiphon",
                        gabc: psalmAnt.gabc,
                        tone: psalmAnt.tone,
                        dropCap: true,
                        playButtons: [
                            {
                                gabc: psalmAnt.gabc,
                                title: "Intone",
                                intoneOnly: true
                            },
                            {
                                gabc: psalmAnt.gabc,
                                title: "Play full",
                                intoneOnly: false
                            }
                        ]
                    });
                    items.push({
                        type: "tone chant",
                        pointedText: (antiphonOption === "Simplified" || psalm.onlySimplified) && psalm.simplifiedBen ? psalm.simplifiedBen : psalm.ben,
                        tone: antiphonOption === "Full" ? psalm.ant.tone : psalm.ant.tone.replace("trans", ""),
                        boldMode: "alternate",
                        title: psalmTitles[id] ?? ""
                    });
                    items.push({
                        type: "gabc chant",
                        title: "Antiphon",
                        gabc: psalmAnt.gabc,
                        tone: psalmAnt.tone,
                        dropCap: true,
                        playButtons: [
                            {
                                gabc: psalmAnt.gabc,
                                title: "Intone",
                                intoneOnly: true
                            },
                            {
                                gabc: psalmAnt.gabc,
                                title: "Play full",
                                intoneOnly: false
                            }
                        ]
                    });
                    items.push({
                        type: "spacer"
                    });
                }
            }
        });
        else items.push({
            type: "loading"
        });
    }
    if (hour !== "mattins") {
        // Evensong so add the nunc
        items.push({
            type: "rubric",
            content: "The **Nunc Dimittis** is recited."
        });
        if (loadableLessons.state === "loaded") {
            if (loadableLessons.value.otCanticleOptions) {
                const selectedCanticle = loadableLessons.value.otCanticleOptions[2];
                if (selectedCanticle) {
                    if (selectedCanticle.gabc) items.push({
                        type: "gabc chant",
                        title: selectedCanticle.title,
                        tone: selectedCanticle.tone,
                        gabc: selectedCanticle.gabc,
                        dropCap: true,
                        playButtons: [
                            {
                                gabc: selectedCanticle.gabc,
                                title: "Intone",
                                intoneOnly: true
                            }
                        ]
                    });
                    else if (selectedCanticle.pointedText) items.push({
                        type: "tone chant",
                        title: selectedCanticle.title,
                        pointedText: selectedCanticle.pointedText,
                        tone: selectedCanticle.tone,
                        boldMode: "alternate"
                    });
                }
                items.push({
                    type: "spacer"
                });
            }
        } else items.push({
            type: "loading"
        });
    }
    items.push({
        type: "rubric",
        content: "Then the Officiant and People shall say the **Lord's prayer,** all devoutly kneeling."
    });
    items.push({
        type: "text",
        content: "O**UR Father, who art in heaven, hallowed be thy Name, thy kingdom come, thy will be done, on earth as it is in heaven. Give us this day our daily bread. And forgive us our trespasses, as we forgive those who trespass against us. And lead us not into temptation, but deliver us from evil. Amen.**",
        dropCap: true
    });
    items.push({
        type: "rubric",
        content: "This Psalm is then said, except on the day of death or burial."
    });
    if (loadableLessons.state === "loaded") {
        if (loadableLessons.value.otCanticleOptions) {
            const selectedCanticle = loadableLessons.value.otCanticleOptions[hour === "mattins" ? 0 : 1];
            if (selectedCanticle) {
                if (selectedCanticle.gabc) items.push({
                    type: "gabc chant",
                    title: selectedCanticle.title,
                    tone: selectedCanticle.tone,
                    gabc: selectedCanticle.gabc,
                    dropCap: true,
                    playButtons: [
                        {
                            gabc: selectedCanticle.gabc,
                            title: "Intone",
                            intoneOnly: true
                        }
                    ]
                });
                else if (selectedCanticle.pointedText) items.push({
                    type: "tone chant",
                    title: selectedCanticle.title,
                    pointedText: selectedCanticle.pointedText,
                    tone: selectedCanticle.tone,
                    boldMode: "alternate"
                });
            }
            items.push({
                type: "spacer"
            });
        }
    } else items.push({
        type: "loading"
    });
    items.push({
        type: "rubric",
        content: "Then the Office continues as follows."
    });
    items.push({
        type: "picker",
        options: [
            "Lay officiant",
            "Priest officiant"
        ],
        selectedOption: officiantType,
        onChange: onSelectOfficiantType
    });
    if (officiantType === "Priest officiant") items.push({
        type: "minimal gabc chant",
        gabc: "(c3) From(h) the(h) gate(g) of(f) hell.(g) (::) *De*(h)*li*(h)*ver*(h) *{their*(h) *souls},*(h) *O*(f) *Lord.*(f) (::) May(h) {they}(h) rest(g) in(f) peace.(g) (::) *A*(h)*men.*(h) (::) The(h) Lord(g) be(f) with(g) you.(g) (::) *And*(h) *with*(h) *thy*(h) *spi*(h)*rit.*(f) (::) Let(h) us(h) pray.(h) (::)",
        dropCap: true,
        tone: ""
    });
    else items.push({
        type: "minimal gabc chant",
        gabc: "(c3) From(h) the(h) gate(g) of(f) hell.(g) (::) *De*(h)*li*(h)*ver*(h) *{their*(h) *souls}*(h) *O*(f) *Lord.*(f) (::) May(h) {they}(h) rest(g) in(f) peace.(g) (::) *A*(h)*men.*(h) (::) O(h) Lord(h) hear(g) our(f) prayer.(g) (::) *And*(h) *let*(h) *our*(h) *cry*(h) *come*(h) *un*(h)*to*(f) *thee.*(f) (::) Let(h) us(h) pray.(h) (::)",
        dropCap: true,
        tone: ""
    });
    items.push({
        type: "rubric",
        content: `This, or another appropriate **Collect** (DW:DO_pp._448-451) is_then_sung_recto_tono. **SEE BELOW.**`
    });
    items.push({
        type: "text",
        content: "O GOD, the Creator and Redeemer of all them that believe: grant unto the souls of thy servants and handmaids the remission of all their sins; that as they have ever desired thy merciful pardon, so by the supplications of their brethren they may receive the same; through Jesus Christ thy Son our Lord, who livest and reignest with thee, in the unity of the Holy Spirit, ever one God, world without end. **Amen.**",
        dropCap: true
    });
    items.push({
        type: "rubric",
        content: `**For a Pope.**`
    });
    items.push({
        type: "text",
        content: "O God, who of thy ineffable providence didst vouchsafe to number thy servant Pope Francis in the company of thy high Priests: grant, we beseech thee; that as he did fulfil on earth the office of thine Only Begotten Son, he may be numbered in the everlasting fellowship of thy holy Pontiffs; through the same Jesus Christ thy Son our Lord, who livest and reignest with thee, in the unity of the Holy Spirit, ever one God, world without end. **Amen.**",
        dropCap: true
    });
    if (officiantType === "Priest officiant") items.push({
        type: "minimal gabc chant",
        gabc: "(c3) The(h) Lord(g) be(f) with(g) you.(g) (::) *And*(h) *with*(h) *thy*(h) *spi*(h)*rit.*(f) (::) Rest(f) e(f)ter(f)nal(f) grant(f) un(f)to(f) them,(f) O(f) Lord.(f) (::) *And*(f) *let*(f) *light*(f) *per*(f)*pe*(f)*tual*(f) *shine*(f) *u*(f)*pon*(f) *them.*(f) (::) May(e) they(f) rest(f) in(e) peace.(fe) (::) *A*(e)*men.*(ef) (::)",
        dropCap: true,
        tone: ""
    });
    else items.push({
        type: "minimal gabc chant",
        gabc: "(c3) O(h) Lord(h) hear(g) our(f) prayer.(g) (::) *And*(h) *let*(h) *our*(h) *cry*(h) *come*(h) *un*(h)*to*(f) *thee.*(f) (::) Rest(f) e(f)ter(f)nal(f) grant(f) un(f)to(f) them,(f) O(f) Lord.(f) (::) *And*(f) *let*(f) *light*(f) *per*(f)*pe*(f)*tual*(f) *shine*(f) *u*(f)*pon*(f) *them.*(f) (::) May(e) they(f) rest(f) in(e) peace.(fe) (::) *A*(e)*men.*(ef) (::)",
        dropCap: true,
        tone: ""
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `Here ends the Order of ${hour === "mattins" ? "Morning" : "Evening"} Prayer.`
    });
    items.push({
        type: "spacer",
        big: true
    });
    return items;
};


const $67cbcc63a9947135$export$bc46037817f8ac12 = ()=>{
    const { hour: rawHour } = (0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)();
    const hour = rawHour === "evensong" ? "second-evensong" : rawHour;
    const regionLabels = localStorage.getItem("region-switches")?.split(";;;") ?? [];
    const year = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(new Date().getFullYear(), false, false, false, regionLabels);
    const today = year.find((day)=>day.date === new Date().getDate() && day.month === new Date().getMonth() + 1 && day.year === new Date().getFullYear());
    if (!today) throw new Error("Could not find today");
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const benAntIds = [
        "ood make thy way",
        "ood turn thee o lord",
        "ood lest he devour",
        "ood from the gate",
        "ood i am the",
        "ood i will walk",
        "ood woe is me",
        "ood the lord shall",
        "ood if thou lord",
        "ood despise not",
        "ood all that the"
    ];
    const magAntIds = [];
    const invAntIds = [
        "ood inv"
    ];
    const day = {
        date: 1,
        month: 1,
        year: 1,
        dayOfTheWeek: "sun",
        label: "office-of-the-dead",
        otherLabels: [],
        collectId: "office-of-the-dead",
        collect: "office-of-the-dead",
        weekOfTheYear: 1,
        antiphonId: "office-of-the-dead",
        dayOfTheYear: 1,
        sentenceId: "office-of-the-dead",
        hymnId: "office-of-the-dead",
        easterOctave: false
    };
    const celebration = {
        label: "office-of-the-dead",
        type: "misc",
        rank: 10,
        title: "Office of the Dead"
    };
    const loadableLessons = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "ord readings",
        day: day,
        hour: hour,
        celebration: celebration,
        hymnIds: [],
        benAntIds: benAntIds,
        magAntIds: magAntIds,
        invAntIds: invAntIds,
        oneDayAheadPsalter: settings.oneDayAheadPsalter === "true"
    });
    const [antiphonOption, setAntiphonOption] = (0, $acw62.useState)("Full");
    const [selectedPsalms, setSelectedPsalms] = (0, $acw62.useState)("");
    const [simplifiedHaecDies, onSetSimplifiedHaecDies] = (0, $acw62.useState)("Full");
    const [includeIntroduction, onSetIncludeIntroduction] = (0, $acw62.useState)("Omit");
    const liturgy = (0, $2a53768914375960$export$edab2bebf7e6cb2a)(day, hour, celebration, settings, loadableLessons, "", ()=>undefined, settings.salutation === "o lord hear our prayer" ? "Lay officiant" : "Priest officiant", (newType)=>{
        if (newType === "Lay officiant") setSetting("salutation", "o lord hear our prayer");
        if (newType === "Priest officiant") setSetting("salutation", "the lord be with you");
    }, antiphonOption, setAntiphonOption, "", ()=>undefined, selectedPsalms, setSelectedPsalms, false, false, simplifiedHaecDies, onSetSimplifiedHaecDies, includeIntroduction, onSetIncludeIntroduction);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
        initialState: {},
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    textAlign: "center",
                    padding: 24,
                    paddingTop: 64
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        fontSize: "150%",
                        fontWeight: "bold",
                        lineHeight: 1.2
                    },
                    children: [
                        hour === "mattins" ? "Mattins" : "Evensong",
                        " of the Dead"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e8eee601cb369fe$export$47dc637b8554585f), {
                items: liturgy,
                label: "office-of-the-dead",
                superTitle: hour === "mattins" ? "Mattins of" : "Evensong of",
                title: "Office of the Dead"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75480ab0d41c8aaa$export$59079ee0c44d6fdd), {})
        ]
    });
};




var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");

const $10afe2ece93b1c22$export$96bdf281383ed03d = (day)=>{
    if (day.month === 1 && day.date === 1) {
        const days = (0, $063afc2d5fcbb72a$export$6d7724e5c284a396)(day.year - 1, true).days;
        return days[days.length - 1];
    } else {
        const days = (0, $063afc2d5fcbb72a$export$6d7724e5c284a396)(day.year, true).days;
        let prevDay = days[0];
        let found = false;
        days.forEach((d)=>{
            if (!found) {
                if (d.month === day.month && d.date === day.date) found = true;
                else prevDay = d;
            }
        });
        return prevDay;
    }
};
const $10afe2ece93b1c22$export$2f65f19505bad047 = (day)=>{
    return `${day.year}-${day.month}-${day.date}`;
};



const $d9d511397f573593$export$606752b32846567e = (day, hour)=>{
    const { settings: settings } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const timeoutRef = (0, $acw62.useRef)(setTimeout(()=>{}, 0));
    const tracked = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        timeoutRef.current = setTimeout(()=>{
            if (!tracked.current) {
                window.localStorage.setItem(`last-${hour}`, (0, $10afe2ece93b1c22$export$2f65f19505bad047)(day));
                tracked.current = true;
                (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("pray", {
                    ...day,
                    hour: hour,
                    ...settings
                });
            }
        }, 300000);
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
};



const $fa147fa9bd45753a$export$c15082c4d1ac5d54 = ()=>{
    const { year: year, month: month, date: date, label: label, hour: rawHour } = (0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)();
    const hour = rawHour === "evensong" ? "second-evensong" : rawHour;
    const day = (0, $063afc2d5fcbb72a$export$229d3f939f129064)(year, month, date, false);
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    (0, $d9d511397f573593$export$606752b32846567e)(day, "mattins");
    const regionLabels = localStorage.getItem("region-switches")?.split(";;;") ?? [];
    const celebrationYear = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(day.year, settings.transferEpiphany === "yes", settings.transferAscension === "yes", settings.transferCorpusChristi === "yes", regionLabels);
    const celebrationDay = celebrationYear.find((d)=>d.date === day.date && d.month === day.month && day.year === d.year);
    const celebrationDayIndex = celebrationYear.findIndex((d)=>d.date === day.date && d.month === day.month && day.year === d.year);
    const easterDayIndex = celebrationYear.findIndex((d)=>d.morningOptions.find((cel)=>cel.title === "Easter Day") !== undefined && day.year === d.year);
    const isBeforeEaster = celebrationDayIndex < easterDayIndex;
    const celebrationList = hour === "mattins" ? celebrationDay?.morningOptions.concat(celebrationDay.morningOutranked) : celebrationDay?.eveningOptions.concat(celebrationDay.eveningOutranked);
    const backupYear = (0, $2d95fb1756754bc6$export$f64a227ad5260d8c)(day.year, settings.transferEpiphany !== "yes", settings.transferAscension !== "yes", settings.transferCorpusChristi !== "yes", regionLabels);
    const backupDay = backupYear.find((d)=>d.date === day.date && d.month === day.month && day.year === d.year);
    const backupList = hour === "mattins" ? backupDay?.morningOptions.concat(backupDay.morningOutranked) : backupDay?.eveningOptions.concat(backupDay.eveningOutranked);
    let celebration = celebrationList?.concat(backupList ?? []).find((c)=>c.label === label);
    if (celebration?.propersOfTheFeria) {
        const feriaToday = celebrationList?.find((c)=>c.type === "feria");
        celebration = {
            ...feriaToday,
            ...celebration
        };
    }
    const isLent = celebrationList?.find((c)=>(c.title.includes("Lent") || c.title.includes("Ash Wednesday") || c.title.includes("Passion Sunday") || c.title.includes("Palm Sunday") || c.title.includes("Holy Week") || c.title.includes("Good Friday") || c.title.includes("Holy Saturday")) && !c.title.includes("Before")) !== undefined;
    const isAdvent = celebrationList?.find((c)=>(c.title.includes("Advent") || c.title.includes("December")) && !c.title.includes("before")) !== undefined;
    const isChristmasOctave = celebrationList?.find((c)=>c.title.includes("Octave of Christmas") || c.title === "Mary, the Holy Mother of God") !== undefined;
    if (!celebration) {
        console.log(celebrationList?.concat(backupList ?? []));
        throw new Error("Could not find celebration");
    }
    const hymnIds = [];
    const benAntIds = [];
    const magAntIds = [];
    const invAntIds = [];
    const isEastertide = celebrationList?.find((celebration)=>celebration.title.includes("Easter") || celebration.title.includes("Ascension") || celebration.title === "Rogation Monday" || celebration.title === "Rogation Tuesday" || celebration.title === "Rogation Wednesday" || celebration.title === "Rogation Thursday" || celebration.title === "Rogation Friday" || celebration.title === "Rogation Saturday" || celebration.title.includes("Whit") || celebration.title.includes("Pentecost")) !== undefined && celebration.title !== "Trinity Sunday";
    const commonOptionsForRequest = [];
    celebration.commons?.forEach((commonId)=>{
        let common = (0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[commonId];
        if (isEastertide && common.easterOverrides) common = {
            ...common,
            ...common.easterOverrides
        };
        commonOptionsForRequest.push(common);
    });
    if (hour === "first-evensong") {
        if (celebration.ep1HymnId) hymnIds.push(celebration.ep1HymnId);
        commonOptionsForRequest.forEach((common)=>{
            const commonHymnId = common.ep1HymnId;
            if (commonHymnId) hymnIds.push(commonHymnId);
        });
        if (celebration.ep1MagId) magAntIds.push(celebration.ep1MagId);
        commonOptionsForRequest.forEach((common)=>{
            const commonAntId = common.ep1MagId;
            if (commonAntId) magAntIds.push(commonAntId);
        });
    }
    if (hour === "mattins") {
        if (celebration.mpHymnId) hymnIds.push(celebration.mpHymnId);
        commonOptionsForRequest.forEach((common)=>{
            const commonHymnId = common.mpHymnId;
            if (commonHymnId) hymnIds.push(commonHymnId);
        });
        if (celebration.mpBenId) benAntIds.push(celebration.mpBenId);
        commonOptionsForRequest.forEach((common)=>{
            const commonAntId = common.mpBenId;
            if (commonAntId) benAntIds.push(commonAntId);
        });
        if (celebration.invId) invAntIds.push(celebration.invId);
        commonOptionsForRequest.forEach((common)=>{
            const commonAntId = common.invId;
            if (commonAntId) invAntIds.push(commonAntId);
        });
    }
    if (hour === "second-evensong") {
        if (celebration.ep2HymnId) hymnIds.push(celebration.ep2HymnId);
        commonOptionsForRequest.forEach((common)=>{
            const commonHymnId = common.ep2HymnId;
            if (commonHymnId) hymnIds.push(commonHymnId);
        });
        if (celebration.ep2MagId) magAntIds.push(celebration.ep2MagId);
        commonOptionsForRequest.forEach((common)=>{
            const commonAntId = common.ep2MagId;
            if (commonAntId) magAntIds.push(commonAntId);
        });
    }
    const loadableLessons = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "ord readings",
        day: day,
        hour: hour,
        celebration: celebration,
        hymnIds: hymnIds,
        benAntIds: benAntIds,
        magAntIds: magAntIds,
        invAntIds: invAntIds,
        oneDayAheadPsalter: settings.oneDayAheadPsalter === "true"
    });
    console.log(loadableLessons);
    const [selectedOtCanticle, setSelectedOtCanticle] = (0, $acw62.useState)("");
    let officeLabel = "Mattins";
    if (hour !== "mattins") {
        if (celebration.type === "sunday" || celebration.type === "solemnity" || celebration.type === "feast" && celebration.feastHasFirstEvensong) {
            if (hour === "first-evensong") officeLabel = "First Evensong";
            else officeLabel = "Second Evensong";
        } else officeLabel = "Evensong";
    }
    const [antiphonOption, setAntiphonOption] = (0, $acw62.useState)("Full");
    const [selectedCommon, setSelectedCommon] = (0, $acw62.useState)(celebration.commons?.[0] ?? "");
    let celebrationWithCommonSelected = celebration;
    if (selectedCommon !== "" && !celebration.specialManner) celebrationWithCommonSelected = {
        ...(0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[selectedCommon],
        ...celebration
    };
    if (isEastertide && (0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[selectedCommon]?.easterOverrides) celebrationWithCommonSelected = {
        ...celebrationWithCommonSelected,
        ...(0, $e4d81acce6b1f0d2$export$68aaa04082781e33)[selectedCommon].easterOverrides
    };
    const [selectedPsalms, setSelectedPsalms] = (0, $acw62.useState)("");
    const [simplifiedHaecDies, onSetSimplifiedHaecDies] = (0, $acw62.useState)("Full");
    const [includeIntroduction, onSetIncludeIntroduction] = (0, $acw62.useState)("Omit");
    const [properVenite, onSetProperVenite] = (0, $acw62.useState)("Proper chant");
    const [resurrectionChant, onSetResurrectionChant] = (0, $acw62.useState)("Text");
    const liturgy = (0, $f946c5f928169e9d$export$5c8b9199836a83b3)(day, hour, celebrationWithCommonSelected, settings, loadableLessons, selectedOtCanticle, setSelectedOtCanticle, settings.salutation === "o lord hear our prayer" ? "Lay officiant" : "Priest officiant", (newType)=>{
        if (newType === "Lay officiant") setSetting("salutation", "o lord hear our prayer");
        if (newType === "Priest officiant") setSetting("salutation", "the lord be with you");
    }, antiphonOption, setAntiphonOption, selectedCommon, setSelectedCommon, selectedPsalms, setSelectedPsalms, isAdvent, isChristmasOctave, isLent, isEastertide, simplifiedHaecDies, onSetSimplifiedHaecDies, includeIntroduction, onSetIncludeIntroduction, properVenite, onSetProperVenite, isBeforeEaster, settings.marianAntiphonLanguage ?? "Latin", (newMarianAntiphonLanguage)=>{
        setSetting("marianAntiphonLanguage", newMarianAntiphonLanguage);
    }, resurrectionChant, onSetResurrectionChant);
    // useEffect(() => {
    //     const paragraphs =[];
    //     liturgy.forEach(item => {
    //         switch (item.type) {
    //             if (item.type === "heading")
    //         }
    //     })
    //     const doc = new Document({
    //         sections: [
    //             {
    //                 properties: {},
    //                 children: paragraphs, [
    //                     new Paragraph({
    //                         children: [
    //                             new TextRun("Hello World"),
    //                             new TextRun({
    //                                 text: "Foo Bar",
    //                                 bold: true,
    //                                 size: 40,
    //                             }),
    //                             new TextRun({
    //                                 children: [new Tab(), "Github is the best"],
    //                                 bold: true,
    //                             }),
    //                         ],
    //                     }),
    //                 ],
    //             },
    //         ],
    //     });
    //     Packer.toBlob(doc).then((blob) => {
    //         // saveAs from FileSaver will download the file
    //         //saveAs(blob, "example.docx");
    //         var blobUrl = URL.createObjectURL(blob);
    //         console.log(">>", blobUrl);
    //         var link = document.createElement("a"); // Or maybe get it from the current document
    //         link.href = blobUrl;
    //         link.download = "aDefaultFileName.txt";
    //         link.innerHTML = "Click here to download the file";
    //         document.body.appendChild(link);
    //         window.open(blobUrl);
    //     });
    // }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
        initialState: {},
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    textAlign: "center",
                    padding: 24,
                    paddingTop: 64
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                            fontWeight: "bold",
                            paddingBottom: 8
                        },
                        children: celebration.regionNote
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontSize: "120%",
                            fontWeight: "bold",
                            lineHeight: 1.2
                        },
                        children: [
                            officeLabel,
                            " of"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontSize: "150%",
                            fontWeight: "bold",
                            lineHeight: 1.2
                        },
                        children: [
                            celebration.title,
                            celebration.subtitle ? `, ${celebration.subtitle}` : ""
                        ]
                    }),
                    celebration.commonlyCalled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {},
                                children: "Commonly Called"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: "150%",
                                    fontWeight: "bold"
                                },
                                children: celebration.commonlyCalled
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            paddingTop: 4,
                            fontWeight: "bold",
                            color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9)
                        },
                        children: [
                            celebration.optional ? "Optional" : "",
                            " ",
                            {
                                "optional memorial": "",
                                memorial: "Memorial",
                                feast: "Feast",
                                solemnity: "Solemnity",
                                sunday: "",
                                misc: "",
                                feria: "Feria"
                            }[celebration.type],
                            celebration.optionalInLent ? " (optional in Lent)" : ""
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e8eee601cb369fe$export$47dc637b8554585f), {
                items: liturgy,
                label: `${celebration.label}-${officeLabel.toLocaleLowerCase()}`,
                superTitle: `${officeLabel} of`,
                title: celebration.title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75480ab0d41c8aaa$export$59079ee0c44d6fdd), {})
        ]
    });
};



parcelRequire("acw62");




parcelRequire("acw62");

const $61a8395a15b89ac7$export$d290fe58fcf464 = ()=>{
    return [
        {
            type: "chant",
            boldMode: "none",
            tone: "3a.4",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Pre",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "serve",
                                        notes: [
                                            "5",
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us,",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "7",
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "while",
                                        notes: [
                                            "5",
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "wak",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ing;",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "guard",
                                        notes: [
                                            "6",
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "8"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "while",
                                        notes: [
                                            "7",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "sleep",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ing:",
                                        notes: [
                                            "6"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "that",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "a",
                                        notes: [
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "wake",
                                        notes: [
                                            "8"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "we",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "may",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "watch",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "with",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Christ;",
                                        notes: [
                                            "6",
                                            "7"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "a",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "sleep",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "we",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "may",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "rest",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: [
                                            "4",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "peace.",
                                        notes: [
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];
};


const $8fdbc13022d41268$export$7e68c884ebc3ef52 = ()=>{
    return [
        {
            type: "chant",
            boldMode: "none",
            tone: "8.1",
            pointedText: {
                clef: "c5",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Have",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "mer",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "cy",
                                        notes: [
                                            "2",
                                            "1"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "up",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "on",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "me,",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "1",
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "God;",
                                        notes: [
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "3",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hear",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ken",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "un",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "to",
                                        notes: [
                                            "2",
                                            "1"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: [
                                            "2",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "prayer.",
                                        notes: [
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];
};


const $0ae3b4ecbd9d2011$export$b39c7348cda79d5 = ()=>{
    return [
        {
            type: "chant",
            boldMode: "none",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "In",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "to",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hands,",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "5",
                                            "4",
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "I",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "com",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "mend",
                                        notes: [
                                            "4",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "rit.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "In",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "to",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hands,",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "5",
                                            "4",
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "I",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "com",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "mend",
                                        notes: [
                                            "4",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "rit.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "none",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "For",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thou",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hast",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "re",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "deem",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ed",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "me,",
                                        notes: [
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thou",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "God",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "of",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "truth.",
                                        notes: [
                                            "5",
                                            "4",
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "I",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "com",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "mend",
                                        notes: [
                                            "4",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "rit.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "none",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Glo",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ry",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "to",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Fa",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ther,",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "to",
                                        notes: [
                                            "5",
                                            "6b"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Son,",
                                        notes: [
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "to",
                                        notes: [
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Ho",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ly",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Ghost.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "In",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "to",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "hands,",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "5",
                                            "4",
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "I",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "com",
                                        notes: [
                                            "4",
                                            "5"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "mend",
                                        notes: [
                                            "4",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "my",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: [
                                            "4"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "rit.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "none",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Keep",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "me,",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "as",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "app",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "le",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "of",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thine",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "eye.",
                                        notes: [
                                            "6",
                                            "7",
                                            "6",
                                            "5",
                                            "4",
                                            "5",
                                            "7",
                                            "6",
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "1b.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Hide",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "me",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "un",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "der",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "shad",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ow",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "of",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: [
                                            "7"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "wings.",
                                        notes: [
                                            "6",
                                            "7",
                                            "6",
                                            "5",
                                            "4",
                                            "5",
                                            "7",
                                            "6",
                                            "5"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];
};


const $4a7946aaaf242f88$export$77fe68ccb90ccc15 = ()=>{
    const result = [];
    result.push({
        type: "chant",
        boldMode: "none",
        rubric: "Officiant:",
        tone: "2.1",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Lord",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "have",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "mer",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "cy",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "up",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "on",
                                    notes: [
                                        "5",
                                        "4"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: [
                                        "5"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    result.push({
        type: "chant",
        boldMode: "all",
        tone: "2.1",
        rubric: "People:",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Christ",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "have",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "mer",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "cy",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "up",
                                    notes: [
                                        "5"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "on",
                                    notes: [
                                        "5",
                                        "4"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: [
                                        "5"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    result.push({
        type: "chant",
        boldMode: "all",
        tone: "2.1",
        rubric: "All:",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Lord",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "have",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "mer",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "cy",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "up",
                                    notes: [
                                        "3"
                                    ],
                                    long: false,
                                    dotBefore: false
                                },
                                {
                                    text: "on",
                                    notes: [
                                        "3",
                                        "2"
                                    ],
                                    long: false,
                                    dotBefore: false
                                }
                            ]
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: [
                                        "3"
                                    ],
                                    long: true,
                                    dotBefore: false
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    });
    return result;
};


const $025b4137d19c4e7f$export$fe883b921a9f683c = (day, hour)=>{
    const sentenceId = day.sentenceId;
    if (sentenceId === "easter" || sentenceId === "ascension" || day.hymnId === "apostle-or-evangelist-easter" || day.collectId === "whitsun" && day.dayOfTheWeek === "sun") return [
        {
            type: "chant",
            boldMode: "none",
            tone: "8.1",
            pointedText: {
                clef: "c5",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Let",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "bless",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Al",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "le",
                                        notes: [
                                            "1"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "lu",
                                        notes: [
                                            "2",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ia,",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Al ",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "  le  ",
                                        notes: [
                                            "2",
                                            "5",
                                            "4",
                                            "3",
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: " lu ",
                                        notes: [
                                            "1",
                                            "2",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: " ia.",
                                        notes: [
                                            "3",
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "all",
            tone: "8.1",
            pointedText: {
                clef: "c5",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Thanks",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "to",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "God.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Al",
                                        notes: [
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "le",
                                        notes: [
                                            "1"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "lu",
                                        notes: [
                                            "2",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ia,",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Al ",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "  le  ",
                                        notes: [
                                            "2",
                                            "5",
                                            "4",
                                            "3",
                                            "2"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: " lu ",
                                        notes: [
                                            "1",
                                            "2",
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: " ia.",
                                        notes: [
                                            "3",
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];
    else return [
        {
            type: "chant",
            boldMode: "alternate",
            tone: "2.1",
            pointedText: {
                clef: "f5",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Let",
                                        notes: [
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "bless",
                                        notes: [
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "the",
                                        notes: [
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord.",
                                        notes: [
                                            "6",
                                            "5",
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Thanks",
                                        notes: [
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: [
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "to",
                                        notes: [
                                            "6"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "God.",
                                        notes: [
                                            "6",
                                            "5",
                                            "4"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];
};


const $596e5f753ebbf674$export$18ee1b3164619030 = (said, settings)=>{
    if (said) {
        if (settings.lordsPrayer === "bcp") return [
            {
                type: "text",
                content: `**Our Father, which art in heaven, Hallowed be thy Name, Thy
                        kingdom come, Thy will be done, in earth as it is in heaven.
                        Give us this day our daily bread; And forgive us our
                        trespasses, As we forgive them that trespass against us; And
                        lead us not into temptation, But deliver us from evil. Amen.**`
            }
        ];
        else return [
            {
                type: "text",
                content: `**Our Father, who art in heaven, hallowed be thy Name. Thy
                        kingdom come. Thy will be done, on earth as it is in heaven.
                        Give us this day our daily bread. And forgive us our
                        trespasses, as we forgive those who trespass against us. And
                        lead us not into temptation, but deliver us from evil. For
                        thine is the kingdom, the power, and the glory, for ever and
                        ever. Amen.**`
            }
        ];
    } else {
        if (settings.lordsPrayer === "bcp") return [
            {
                type: "chant",
                boldMode: "all",
                tone: "2.1",
                pointedText: {
                    clef: "f5",
                    verses: [
                        {
                            firstHalf: [
                                {
                                    syllables: [
                                        {
                                            text: "Our",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Fa",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ther,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "which",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "art",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "in",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "hea",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ven,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Hal",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "lowed",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "be",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "thy",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Name,",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Thy",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "king",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "dom",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "come,",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Thy",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "will",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "be",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "done,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "in",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "earth",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "as",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "it",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "is",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "in",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "hea",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ven.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Give",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "this",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "day",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "our",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "dai",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ly",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "bread;",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "And",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "for",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "give",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "our",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "tres",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "pass",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "es,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "as",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "we",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "for",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "give",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "them",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "that",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "tres",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "pass",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "a",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "gainst",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us;",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "And",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "lead",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "not",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "in",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "to",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "temp",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ta",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "tion,",
                                            notes: [
                                                "3"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "but",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "de",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "li",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ver",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "from",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "e",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "vil.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                }
                            ],
                            secondHalf: [
                                {
                                    syllables: [
                                        {
                                            text: "A",
                                            notes: [
                                                "3"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        },
                                        {
                                            text: "men.",
                                            notes: [
                                                "4"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            }
        ];
        else return [
            {
                type: "chant",
                boldMode: "all",
                tone: "2.1",
                pointedText: {
                    clef: "f5",
                    verses: [
                        {
                            firstHalf: [
                                {
                                    syllables: [
                                        {
                                            text: "Our",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Fa",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ther,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "who",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "art",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "in",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "hea",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ven,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "hal",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "lowed",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "be",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "thy",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Name.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Thy",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "king",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "dom",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "come.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Thy",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "will",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "be",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "done,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "on",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "earth",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "as",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "it",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "is",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "in",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "hea",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ven.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Give",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "this",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "day",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "our",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "dai",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ly",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "bread.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "And",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "for",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "give",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "our",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "tres",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "pass",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "es,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "as",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "we",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "for",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "give",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "those",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "who",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "tres",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "pass",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "a",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "gainst",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "And",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "lead",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "not",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "in",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "to",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "temp",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ta",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "tion,",
                                            notes: [
                                                "3"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "but",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "de",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "li",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ver",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "from",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "e",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "vil.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "For",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "thine",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "is",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "the",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "king",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "dom,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "the",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "pow",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "er,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "and",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "the",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "glo",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "ry,",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "for",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "ev",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "er",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "and",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        }
                                    ]
                                },
                                {
                                    syllables: [
                                        {
                                            text: "ev",
                                            notes: [
                                                "5"
                                            ],
                                            long: false,
                                            dotBefore: false
                                        },
                                        {
                                            text: "er.",
                                            notes: [
                                                "5"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                }
                            ],
                            secondHalf: [
                                {
                                    syllables: [
                                        {
                                            text: "A",
                                            notes: [
                                                "3"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        },
                                        {
                                            text: "men.",
                                            notes: [
                                                "4"
                                            ],
                                            long: true,
                                            dotBefore: false
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            }
        ];
    }
};




const $b62f69636707813d$export$7b3e42473e668d2d = (day, hour, optional, settings)=>{
    const actualDay = day.eveOf && hour !== "mattins" ? day.eveOf : day;
    const result = [];
    if (!optional) result.push({
        type: "rubric",
        content: `The Officiant shall say or sing the\\n**Collect${day.collectId === "good-friday" ? "s" : ""} for ${day.label === "holy-saturday" && hour !== "mattins" ? "Easter Eve" : (0, $063afc2d5fcbb72a$export$fd51ed252694f070)(actualDay.collectId)},**`,
        settingsPanelId: "collect"
    });
    result.push({
        type: "text",
        content: `${day.label === "holy-saturday" && hour !== "mattins" ? "Grant, O Lord, that as we are baptized into the death of thy blessed Son our Saviour Jesus Christ, so by continual mortifying our corrupt affections we may be buried with him; and that, through the grave, and gate of death, we may pass to our joyful resurrection; for his merits, who died, and was buried, and rose again for us, thy Son Jesus Christ our Lord." : actualDay.collect} **Amen.**`
    });
    if (day.collectId === "good-friday") {
        result.push({
            type: "text",
            content: `Almighty and everlasting God, by whose Spirit the whole body of the Church is governed and sanctified: Receive our supplications and prayers, which we offer before thee for all estates of men in thy holy Church, that every member of the same, in his vocation and ministry, may truly and godly serve thee; through our Lord and Saviour Jesus Christ. **Amen.**`
        });
        result.push({
            type: "text",
            content: `O merciful God, who hast made all men, and hatest nothing that thou hast made, nor wouldest the death of a sinner, but rather that he should be converted and live: Have mercy upon all Jews, Turks, Infidels, and Hereticks, and take from them all ignorance, hardness of heart, and contempt of thy word; and so fetch them home, blessed Lord, to thy flock, that they may be saved among the remnant of the true Israelites, and be made one fold under one shepherd, Jesus Christ our Lord, who liveth and reigneth with thee and the Holy Spirit, one God, world without end. **Amen.**`
        });
    }
    if (settings.adventAndLentCollects === "repeat" && (day.collectId.includes("lent-") || day.collectId === "good-friday")) {
        if (!optional) result.push({
            type: "rubric",
            content: "The **Collect for Ash Wednesday** throughout_Lent,"
        });
        result.push({
            type: "text",
            content: `Almighty and everlasting God, who hatest nothing that
                thou hast made and dost forgive the sins of all them
                that are penitent: Create and make in us new and
                contrite hearts, that we, worthily lamenting our sins,
                and acknowledging our wretchedness, may obtain of thee,
                the God of all mercy, perfect remission and forgiveness;
                through Jesus Christ our Lord. **Amen.**`
        });
    }
    if (settings.adventAndLentCollects === "repeat" && day.collectId.includes("advent") && !day.collectId.includes("advent-1") && day.collectId !== "sunday-before-advent") {
        if (!optional) result.push({
            type: "rubric",
            content: "The **Collect for The First Sunday in Advent** throughout_Advent,"
        });
        result.push({
            type: "text",
            content: `Almighty God, give us grace that we may cast away the
                works of darkness, and put upon us the armour of light,
                now in the time of this mortal life in which thy Son
                Jesus Christ came to visit us in great humility; that in
                the last day, when he shall come again in his glorious
                majesty to judge both the quick and the dead, we may
                rise to the life immortal; through him who liveth and
                reigneth with thee and the Holy Ghost, one God, now and
                for ever. **Amen.**`
        });
    }
    return result;
};



const $9db686f04dd8dfc7$export$7d0e311343102fd6 = ()=>{
    return [
        {
            type: "chant",
            boldMode: "none",
            tone: "2.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Turn",
                                        notes: [
                                            "1"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "then",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "God",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "Sav",
                                        notes: [
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    },
                                    {
                                        text: "iour.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: "chant",
            boldMode: "all",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: [
                                            "1"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "let",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "thine",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "an",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    },
                                    {
                                        text: "ger",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "cease",
                                        notes: [
                                            "3"
                                        ],
                                        long: false,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "from",
                                        notes: [
                                            "2"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            },
                            {
                                syllables: [
                                    {
                                        text: "us.",
                                        notes: [
                                            "3"
                                        ],
                                        long: true,
                                        dotBefore: false
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ];
};


const $804b55676199e6be$export$6080bde622779e60 = (day, settings, loadablePsalms, loadableLessons)=>{
    const items = [];
    const psalmRefs = settings.psalmsAtCompline === "compline-short" ? [
        [
            "4",
            "134"
        ],
        [
            "31:1-16"
        ],
        [
            "91"
        ]
    ][day.dayOfTheYear % 3] : settings.psalmsAtCompline === "compline" ? [
        "4",
        "31:1-16",
        "91",
        "134"
    ] : loadablePsalms.state === "loaded" ? loadablePsalms.value : [];
    items.push({
        type: "heading",
        day: day,
        hour: "compline"
    });
    items.push({
        type: "rubric",
        content: `All standing, the Officiant shall begin with this prayer,
            **Short_Lesson**, and versicle, the People responding.`
    });
    items.push({
        type: "text",
        content: `The Lord almighty grant us a quiet night and a perfect end.\\n**Amen.**\\n\\nBrethren, be sober, be vigilant; because your adversary the devil, as a roaring lion, walketh about, seeking whom he may devour: whom resist, steadfast in the faith.\\n\\nBut thou, O Lord, have mercy upon us.\\n**Thanks be to God.**\\n\\nOur help is in the name of the Lord;\\n**Who hath made heaven and earth.**`
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `All shall kneel and say the **Confession.**`
    });
    items.push({
        type: "text",
        content: `**Almighty God and Father, we confess to thee, to one another, and
            to the whole host of heaven, that we have sinned against thee,
            through our own fault, in thought, and word, and deed, and in
            those things which we have left undone. For the sake of thy Son
            our Lord Jesus Christ, have mercy upon us, forgive us our sins,
            and by the power of the Holy Ghost raise us up to serve thee in
            newness of life, to the glory of thy holy Name. Amen.**`
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `The Officiant and People shall sing this **Versicle_and_Response.**`
    });
    items.push(...(0, $9db686f04dd8dfc7$export$7d0e311343102fd6)());
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `All standing, the Officiant and People shall sing these **Preces_and_Responses.**`
    });
    items.push(...(0, $4fae7b70f2712114$export$47fe3383e0215c92)(true));
    items.push({
        type: "spacer"
    });
    if (settings.hymnPosition === "before psalms") {
        items.push({
            type: "rubric",
            content: `The **Office Hymn** may be sung.`,
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "compline"
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: `All sitting, the **${psalmRefs.length === 1 ? "Psalm" : "Psalms"}** shall be sung.`,
        settingsPanelId: "compline psalms"
    });
    if (settings.psalmsAtCompline !== "same as evensong") items.push(...(0, $8fdbc13022d41268$export$7e68c884ebc3ef52)());
    if (psalmRefs.length > 0) psalmRefs.forEach((psalmRef)=>{
        items.push({
            type: "psalm",
            psalmRef: (0, $8da148c2c45b952c$export$f846b1f6e107a70c)(psalmRef)
        });
    });
    else items.push({
        type: "loading"
    });
    if (settings.psalmsAtCompline !== "same as evensong") items.push(...(0, $8fdbc13022d41268$export$7e68c884ebc3ef52)());
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `The **Lesson** shall_be_read.`,
        settingsPanelId: "compline lesson"
    });
    if (settings.secondReadingToCompline === "yes") {
        if (loadableLessons.state === "loaded" && Array.isArray(loadableLessons.value.secondLesson)) {
            loadableLessons.value.secondLesson.forEach((lessonPart, index)=>{
                items.push({
                    type: "scripture",
                    title: lessonPart.title,
                    content: lessonPart.content,
                    hasBeginneth: index === 0
                });
            });
            items.push({
                type: "text",
                content: `Here endeth the lesson.`
            });
        } else items.push({
            type: "loading"
        });
    } else items.push({
        type: "text",
        content: `Thou, O Lord, art in the midst of us, and we are called by
                thy name. Leave us not, O Lord our God.\\n\\n**Thanks be to God.**`
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `The Officiant and People shall sing this **Responsory.**`
    });
    items.push(...(0, $0ae3b4ecbd9d2011$export$b39c7348cda79d5)());
    items.push({
        type: "spacer"
    });
    if (settings.hymnPosition === "before canticle") {
        items.push({
            type: "rubric",
            content: `The **Office Hymn** may be sung.`,
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "compline"
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: `All standing, the **Gospel_Canticle** shall be sung.`,
        settingsPanelId: "gospel canticles"
    });
    items.push(...(0, $61a8395a15b89ac7$export$d290fe58fcf464)());
    items.push({
        type: "canticle",
        id: "nunc dimittis",
        tone: "3a.4",
        day: day
    });
    items.push(...(0, $61a8395a15b89ac7$export$d290fe58fcf464)());
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `The Officiant shall sing the **Salutation**, the_People_responding.`,
        settingsPanelId: "salutation"
    });
    items.push(...(0, $e5d4e422eab295c9$export$640f02cc93cb7a75)(settings));
    items.push({
        type: "rubric",
        content: `All kneeling, the **Prayers** shall be sung.`
    });
    items.push(...(0, $4a7946aaaf242f88$export$77fe68ccb90ccc15)());
    items.push(...(0, $596e5f753ebbf674$export$18ee1b3164619030)(false, settings));
    items.push({
        type: "rubric",
        content: `One or more of the following **Collects** shall be said or sung.`
    });
    items.push({
        type: "text",
        content: `Visit, we beseech thee, O Lord, this place, and drive far from
            it all snares of the enemy; Let thy holy Angels dwell herein to
            preserve us in peace, and may thy blessing be upon us evermore;
            through Jesus Christ our Lord.\n**Amen.**`
    });
    items.push(...(0, $b62f69636707813d$export$7b3e42473e668d2d)(day, "compline", true, settings));
    if (settings.hymnPosition === "anthem") {
        items.push({
            type: "rubric",
            content: `The **Office Hymn** may be sung.`,
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "compline"
        });
    }
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: `All standing, the Officiant shall sing, the_People_responding,`
    });
    items.push(...(0, $025b4137d19c4e7f$export$fe883b921a9f683c)(day, "compline"));
    items.push({
        type: "spacer"
    });
    items.push({
        type: "text",
        content: `The Almighty and Merciful Lord, Father, Son and Holy Ghost,
            bless us and keep us, this night and evermore. **Amen.**`
    });
    items.push({
        type: "spacer",
        big: true
    });
    items.push({
        type: "footer",
        day: day,
        hour: "compline"
    });
    return items;
};






const $31417567f1c17ca9$export$d760a004f53d03a2 = (props)=>{
    const { day: day } = props;
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    (0, $d9d511397f573593$export$606752b32846567e)(day, "compline");
    const loadablePsalms = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "proper psalms",
        day: day,
        psalmCycle: settings.psalmCycle,
        time: "evening"
    });
    const psalms = settings.psalmsAtCompline === "compline-short" ? [
        [
            "4",
            "134"
        ],
        [
            "31:1-16"
        ],
        [
            "91"
        ]
    ][day.dayOfTheYear % 3] : settings.psalmsAtCompline === "compline" ? [
        "4",
        "31:1-16",
        "91",
        "134"
    ] : loadablePsalms.state === "loaded" ? loadablePsalms.value : [];
    const loadableLessons = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "evensong readings",
        day: day,
        evensongReadings: (0, $e5274831a769feea$export$45057e54bc6685bf)(settings.mattinsReadings),
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e8eee601cb369fe$export$47dc637b8554585f), {
        items: (0, $804b55676199e6be$export$6080bde622779e60)(day, settings, loadablePsalms, loadableLessons)
    });
/*const psalmElements = useMemo(() => {
        return (
            <>
                {psalms.length > 0 ? (
                    psalms.map((psalm) => {
                        return (
                            <Psalm
                                psalmRef={getPsalmRefFromText(psalm)}
                                key={psalm}
                            />
                        );
                    })
                ) : (
                    <LoadingScreen />
                )}
            </>
        );
    }, [psalms, settings]);

    return (
        <>
            <Heading day={day} hour="compline" />
            <Rubric
                content="All standing, the Officiant shall begin with this prayer,
                **Short_Lesson**, and versicle, the People
                responding."
            />
            <TextBlock
                content="The Lord almighty grant us a quiet night and a perfect end.\n
                **Amen.**\n\n
                Brethren, be sober, be vigilant; because your adversary the
                devil, as a roaring lion, walketh about, seeking whom he may
                devour: whom resist, steadfast in the faith.\n\n
                But thou, O Lord, have mercy upon us.\n
                **Thanks be to God.**\n\n
                Our help is in the name of the Lord;\n
                **Who hath made heaven and earth.**"
            />
            <Spacer />
            <Rubric content="All shall kneel and say the **Confession.**" />
            <TextBlock
                content="**Almighty God and Father, we confess to thee, to one another, and
                to the whole host of heaven, that we have sinned against thee,
                through our own fault, in thought, and word, and deed, and in
                those things which we have left undone. For the sake of thy Son
                our Lord Jesus Christ, have mercy upon us, forgive us our sins,
                and by the power of the Holy Ghost raise us up to serve thee in
                newness of life, to the glory of thy holy Name. Amen.**"
            />
            <Spacer />
            <Rubric
                content="The Officiant and People shall sing this
                **Versicle_and_Response.**"
            />
            <TurnUsThen />
            <Spacer />
            <Rubric
                content="All standing, the Officiant and People shall sing these
                **Preces_and_Responses.**"
            />
            <OpeningResponses omitFirst />
            <Spacer />

            {settings.hymnPosition === "before psalms" ? (
                <>
                    <Rubric
                        content="The **Office Hymn** may be sung."
                        settingsPanelId="office hymn"
                    />
                    <OfficeHymn day={day} hour="compline" />
                    <Spacer />
                </>
            ) : (
                <></>
            )}
            <Rubric
                content={`All sitting, the **${
                    psalms.length === 1 ? "Psalm" : "Psalms"
                }**
                shall be sung.`}
                settingsPanelId="compline psalms"
            />
            <PsalmAntiphon />
            {psalmElements}
            <PsalmAntiphon />
            <Spacer />
            <Rubric
                content="The **Lesson** shall_be_read."
                settingsPanelId="compline lesson"
            />
            {settings.secondReadingToCompline === "yes" ? (
                <>
                    {loadableLessons.state === "loaded" &&
                    Array.isArray(loadableLessons.value.secondLesson) ? (
                        <>
                            {loadableLessons.value.secondLesson.map(
                                (lessonPart: {
                                    title: string;
                                    content: any;
                                }) => {
                                    return (
                                        <Scripture
                                            title={lessonPart.title}
                                            content={lessonPart.content}
                                            key={lessonPart.title}
                                        />
                                    );
                                }
                            )}
                            <TextBlock content="The Word of the Lord.\n**Thanks be to God.**" />
                        </>
                    ) : (
                        <LoadingScreen />
                    )}
                </>
            ) : (
                <TextBlock
                    content="Thou, O Lord, art in the midst of us, and we are called by
                thy name. Leave us not, O Lord our God.\n\n**Thanks be to God.**"
                />
            )}
            <Spacer />
            <Rubric content="The Officiant and People shall sing this **Responsory.**" />
            <Responsory />
            <Spacer />
            {settings.hymnPosition === "before canticle" ? (
                <>
                    <Rubric
                        content="The **Office Hymn** may be sung."
                        settingsPanelId="office hymn"
                    />
                    <OfficeHymn day={day} hour="compline" />
                    <Spacer />
                </>
            ) : (
                <></>
            )}
            <Rubric
                content="All standing, the **Gospel_Canticle** shall be sung."
                settingsPanelId="gospel canticles"
            />
            <CanticleAntiphon />
            <Canticle id="nunc dimittis" tone="3a.4" day={day} />
            <CanticleAntiphon />
            <Spacer />
            <Rubric
                content="The Officiant shall sing the **Salutation**, the_People_responding."
                settingsPanelId="salutation"
            />
            <Salutation />
            <Rubric content="All kneeling, the **Prayers** shall be sung." />
            <LesserLitany />
            <LordsPrayer />
            <Rubric content="One or more of the following **Collects** shall be said or sung." />
            <TextBlock
                content="Visit, we beseech thee, O Lord, this place, and drive far from
                it all snares of the enemy; Let thy holy Angels dwell herein to
                preserve us in peace, and may thy blessing be upon us evermore;
                through Jesus Christ our Lord.\n**Amen.**"
            />
            <ProperCollect day={day} hour="compline" optional />
            {settings.hymnPosition === "anthem" ? (
                <>
                    <Rubric
                        content="The **Office Hymn** may be sung."
                        settingsPanelId="office hymn"
                    />
                    <OfficeHymn day={day} hour="compline" />
                    <Spacer />
                </>
            ) : (
                <></>
            )}
            <Rubric content="All standing, the Officiant shall sing, the_People_responding," />
            <LetUsBlessTheLord />
            <TextBlock
                content="The Almighty and Merciful Lord, Father, Son and Holy Ghost,
                bless us and keep us, this night and evermore. **Amen.**"
            />
            <Spacer big />
            <Footer day={day} hour="compline" />
        </>
    );*/ };



parcelRequire("acw62");









const $1fd6f10be6a3817f$export$97f7b4aa9cc60d2d = (day, settings, loadablePsalms, loadableLessons)=>{
    const items = [];
    items.push({
        type: "heading",
        day: day,
        hour: "evensong"
    });
    items.push(...(0, $a1ab1a80faebded9$export$3e516573607ab6c4)(day, "evensong"));
    items.push({
        type: "rubric",
        content: "The Officiant may give this **Exhortation.**"
    });
    items.push({
        type: "text",
        content: `Dearly beloved brethren, the Scripture moveth us, in sundry
            places, to acknowledge and confess our manifold sins and
            wickedness; and that we should not dissemble nor cloak them
            before the face of Almighty God our heavenly Father; but confess
            them with an humble, lowly, penitent, and obedient heart; to the
            end that we may obtain forgiveness of the same, by his infinite
            goodness and mercy. And although we ought, at all times, humbly
            to acknowledge our sins before God; yet ought we most chiefly so
            to do, when we assemble and meet together to render thanks for
            the great benefits that we have received at his hands, to set
            forth his most worthy praise, to hear his most holy Word, and to
            ask those things which are requisite and necessary, as well for
            the body as the soul. Wherefore I pray and beseech you, as many
            as are here present, to accompany me with a pure heart, and
            humble voice, unto the throne of the heavenly grace, saying \u{2014}`
    });
    items.push({
        type: "rubric",
        content: "All shall kneel and say together the **Confession.**",
        settingsPanelId: "confession"
    });
    items.push({
        type: "text",
        content: `**Almighty and most merciful Father; We have erred, and strayed
            from thy ways like lost sheep. We have followed too much the
            devices and desires of our own hearts. We have offended against
            thy holy laws. We have left undone those things which we ought
            to have done; And we have done those things which we ought not
            to have done; And there is no health in us. But thou, O Lord,
            have mercy upon us, miserable offenders. Spare thou them, O God,
            who confess their faults. Restore thou those who are penitent;
            According to thy promises declared unto mankind in Christ Jesus
            our Lord. And grant, O most merciful Father, for his sake; That
            we may hereafter live a godly, righteous, and sober life, To the
            glory of thy holy Name. Amen.**`
    });
    if (settings.absolution === "bcp absolution") {
        items.push({
            type: "rubric",
            content: "The People still kneeling, the Officiant shall stand and pronounce the **Absolution**."
        });
        items.push({
            type: "text",
            content: `Almighty God, the Father of our Lord Jesus Christ, who
                desireth not the death of a sinner, but rather that he
                may turn from his wickedness, and live; and hath given
                power, and commandment, to his Ministers, to declare and
                pronounce to his people, being penitent, the Absolution
                and Remission of their sins: He pardoneth and absolveth
                all them that truly repent, and unfeignedly believe his
                holy Gospel. Wherefore let us beseech him to grant us
                true repentance, and his Holy Spirit, that those things
                may please him, which we do at this present; and that
                the rest of our life hereafter may be pure, and holy; so
                that at the last we may come to his eternal joy; through
                Jesus Christ our Lord. **Amen.**`
        });
    } else if (settings.absolution === "pardon and peace collect") {
        items.push({
            type: "rubric",
            content: "All still kneeling, the Officiant shall say this **Collect**."
        });
        items.push({
            type: "text",
            content: `Grant, we beseech thee, merciful Lord, to thy faithful
                people pardon and peace, that they may be cleansed from
                all their sins, and serve thee with a quiet mind;
                through Jesus Christ our Lord. **Amen.**`
        });
    }
    if (settings.lordsPrayerAfterConfession === "sung") {
        items.push({
            type: "rubric",
            content: "All kneeling, the **Lord's_Prayer** shall_be_sung."
        });
        items.push(...(0, $596e5f753ebbf674$export$18ee1b3164619030)(false, settings));
    } else if (settings.lordsPrayerAfterConfession === "said") {
        items.push({
            type: "rubric",
            content: "All kneeling, the **Lord's_Prayer** shall_be_said."
        });
        items.push(...(0, $596e5f753ebbf674$export$18ee1b3164619030)(true, settings));
    }
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "All standing, the Officiant and People shall sing in turn these **Preces_and_Responses.**"
    });
    items.push(...(0, $4fae7b70f2712114$export$47fe3383e0215c92)(false));
    if (settings.hymnPosition === "before psalms") {
        items.push({
            type: "rubric",
            content: "The **Office Hymn** may be sung.",
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "evensong"
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: `All sitting, the
    **Proper_Psalm${loadablePsalms.state === "loaded" && loadablePsalms.value.length === 1 ? "" : "s"}**
    shall be sung.`,
        settingsPanelId: "psalms"
    });
    if (loadablePsalms.state === "loaded") loadablePsalms.value.forEach((refText)=>{
        items.push({
            type: "psalm",
            psalmRef: (0, $8da148c2c45b952c$export$f846b1f6e107a70c)(refText)
        });
    });
    else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "The People sitting, the **First_Lesson** shall_be_read.",
        settingsPanelId: "evening lessons"
    });
    if (loadableLessons.state === "loaded" && Array.isArray(loadableLessons.value.firstLesson)) {
        loadableLessons.value.firstLesson.forEach((lessonPart, index)=>{
            items.push({
                type: "scripture",
                title: lessonPart.title,
                content: lessonPart.content,
                hasBeginneth: index === 0
            });
        });
        items.push({
            type: "text",
            content: "Here endeth the first lesson."
        });
    } else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    if (settings.hymnPosition === "before canticle") {
        items.push({
            type: "rubric",
            content: "The **Office Hymn** may be sung.",
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "evensong"
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: `All standing, the **${settings.secondReadingToCompline === "no" ? "First" : "Gospel"}_Canticle** shall_be_sung.`
    });
    items.push({
        type: "canticle",
        id: "magnificat",
        day: day
    });
    items.push({
        type: "spacer"
    });
    if (settings.secondReadingToCompline === "no") {
        if (loadableLessons.state === "loaded" && Array.isArray(loadableLessons.value.secondLesson)) {
            items.push({
                type: "rubric",
                content: "The People sitting, the **Second_Lesson** shall_be_read."
            });
            loadableLessons.value.secondLesson.forEach((lessonPart, index)=>{
                items.push({
                    type: "scripture",
                    title: lessonPart.title,
                    content: lessonPart.content,
                    hasBeginneth: index === 0
                });
            });
            items.push({
                type: "text",
                content: "Here endeth the second lesson."
            });
        } else items.push({
            type: "loading"
        });
        items.push({
            type: "spacer"
        });
        items.push({
            type: "rubric",
            content: "All standing, the second **Gospel_Canticle** shall_be_sung.",
            settingsPanelId: "gospel canticles"
        });
        items.push({
            type: "canticle",
            id: "nunc dimittis",
            day: day
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: "Remaining standing, all shall say together the **Apostles'_Creed.**"
    });
    items.push({
        type: "text",
        content: `**I believe in God, the Father Almighty, Maker of heaven and
            earth; and in Jesus Christ, his only Son our Lord; Who was
            conceived by the Holy Ghost; Born of the Virgin Mary; Suffered
            under Pontius Pilate; Was crucified, dead, and buried; He
            descended into hell; The third day he rose again from the dead;
            He ascended into heaven, And sitteth on the right hand of God
            the Father Almighty; From thence he shall come to judge the
            quick and the dead. I believe in the Holy Ghost; The holy
            Catholic Church; The Communion of Saints; The Forgiveness of
            sins; The Resurrection of the body; And the life everlasting.
            Amen.**`
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "The Officiant shall sing the **Salutation**, the_People_responding.",
        settingsPanelId: "salutation"
    });
    items.push(...(0, $e5d4e422eab295c9$export$640f02cc93cb7a75)(settings));
    items.push({
        type: "rubric",
        content: "All kneeling, the Officiant and People shall sing the **Lesser_Litany.**"
    });
    items.push(...(0, $4a7946aaaf242f88$export$77fe68ccb90ccc15)());
    items.push({
        type: "rubric",
        content: "All shall sing together the **Lord's_Prayer.**",
        settingsPanelId: "lords prayer"
    });
    items.push(...(0, $596e5f753ebbf674$export$18ee1b3164619030)(false, settings));
    items.push({
        type: "rubric",
        content: "The Officiant and People shall sing in turn the **Suffrages.**"
    });
    items.push(...(0, $59182a366e3671e1$export$128941c64a6df66a)(settings));
    items.push({
        type: "spacer"
    });
    items.push(...(0, $b62f69636707813d$export$7b3e42473e668d2d)(day, "evensong", false, settings));
    items.push({
        type: "rubric",
        content: "The **Collect_for_Peace,**"
    });
    items.push({
        type: "text",
        content: `O God, from whom all holy desires, all good counsels, and all
            just works do proceed; Give unto thy servants that peace which
            the world cannot give; that our hearts may be set to obey thy
            commandments, and also that by thee, we, being defended from the
            fear of our enemies, may pass our time in rest and quietness;
            through the merits of Jesus Christ our Saviour. **Amen.**`
    });
    items.push({
        type: "rubric",
        content: "And the **Collect_for_Aid_Against_all_Perils.**"
    });
    items.push({
        type: "text",
        content: `Lighten our darkness, we beseech thee, O Lord; and by thy great
            mercy defend us from all perils and dangers of this night; for
            the love of thy only Son, our Saviour, Jesus Christ. **Amen.**`
    });
    if (settings.letUsBlessMattinsAndEvensong === "after collects") {
        items.push({
            type: "spacer"
        });
        items.push({
            type: "rubric",
            content: "The Officiant shall sing, the_People_responding,",
            settingsPanelId: "let us bless"
        });
        items.push(...(0, $025b4137d19c4e7f$export$fe883b921a9f683c)(day, "evensong"));
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: "All may say together this **General_Thanksgiving.**"
    });
    items.push({
        type: "text",
        content: `**Almighty God, Father of all mercies, we thine unworthy servants
            do give thee most humble and hearty thanks for all thy goodness
            and loving-kindness to us, and to all men. We bless thee for our
            creation, preservation, and all the blessings of this life; but
            above all, for thine inestimable love in the redemption of the
            world by our Lord Jesus Christ; for the means of grace, and for
            the hope of glory. And, we beseech thee, give us that due sense
            of all thy mercies, that our hearts may be unfeignedly thankful,
            and that we may show forth thy praise, not only with our lips,
            but in our lives; by giving up ourselves to thy service, and by
            walking before thee in holiness and righteousness all our days;
            through Jesus Christ our Lord, to whom with thee and the Holy
            Ghost be all honour and glory, world without end. Amen.**`
    });
    items.push({
        type: "rubric",
        content: "The Officiant may say this **Prayer_of_Saint_John_Chrysostom.**"
    });
    items.push({
        type: "text",
        content: `Almighty God, who hast given us grace at this time with one
            accord to make our common supplications unto thee; and dost
            promise, that when two or three are gathered together in thy
            Name thou wilt grant their requests: Fulfil now, O Lord, the
            desires and petitions of thy servants, as may be most expedient
            for them; granting us in this world knowledge of thy truth, and
            in the world to come life everlasting. **Amen.**`
    });
    if (settings.hymnPosition === "anthem") {
        items.push({
            type: "rubric",
            content: "The **Office Hymn** may be sung.",
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "evensong"
        });
        items.push({
            type: "spacer"
        });
    }
    if (settings.letUsBlessMattinsAndEvensong === "before grace") {
        items.push({
            type: "spacer"
        });
        items.push({
            type: "rubric",
            content: "The Officiant shall sing, the_People_responding,",
            settingsPanelId: "let us bless"
        });
        items.push(...(0, $025b4137d19c4e7f$export$fe883b921a9f683c)(day, "evensong"));
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: "The Officiant shall say **The_Grace.**"
    });
    items.push({
        type: "text",
        content: `The grace of our Lord Jesus Christ, and the love of God, and the
            fellowship of the Holy Ghost, be with us all evermore. **Amen.**`
    });
    items.push({
        type: "spacer",
        big: true
    });
    items.push({
        type: "footer",
        day: day,
        hour: "evensong"
    });
    return items;
};






const $29cba15c31403d57$export$494cc934acf6d73c = (props)=>{
    const { day: day } = props;
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    (0, $d9d511397f573593$export$606752b32846567e)(day, "evensong");
    const loadablePsalms = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "proper psalms",
        day: day,
        psalmCycle: settings.psalmCycle,
        time: "evening"
    });
    const loadableLessons = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "evensong readings",
        day: day,
        evensongReadings: (0, $e5274831a769feea$export$45057e54bc6685bf)(settings.mattinsReadings),
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e8eee601cb369fe$export$47dc637b8554585f), {
            items: (0, $1fd6f10be6a3817f$export$97f7b4aa9cc60d2d)(day, settings, loadablePsalms, loadableLessons)
        })
    });
};



parcelRequire("acw62");










const $d2161558733c29d7$export$3e48560df517de33 = (day, settings, loadablePsalms, loadableLessons)=>{
    const items = [];
    items.push({
        type: "heading",
        day: day,
        hour: "mattins"
    });
    items.push(...(0, $a1ab1a80faebded9$export$3e516573607ab6c4)(day, "mattins"));
    items.push({
        type: "rubric",
        content: "The Officiant may give this **Exhortation.**"
    });
    items.push({
        type: "text",
        content: `Dearly beloved brethren, the Scripture moveth us, in sundry
            places, to acknowledge and confess our manifold sins and
            wickedness; and that we should not dissemble nor cloak them
            before the face of Almighty God our heavenly Father; but confess
            them with an humble, lowly, penitent, and obedient heart; to the
            end that we may obtain forgiveness of the same, by his infinite
            goodness and mercy. And although we ought, at all times, humbly
            to acknowledge our sins before God; yet ought we most chiefly so
            to do, when we assemble and meet together to render thanks for
            the great benefits that we have received at his hands, to set
            forth his most worthy praise, to hear his most holy Word, and to
            ask those things which are requisite and necessary, as well for
            the body as the soul. Wherefore I pray and beseech you, as many
            as are here present, to accompany me with a pure heart, and
            humble voice, unto the throne of the heavenly grace, saying \u{2014}`
    });
    items.push({
        type: "rubric",
        content: "All shall kneel and say together the **Confession.**",
        settingsPanelId: "confession"
    });
    items.push({
        type: "text",
        content: `**Almighty and most merciful Father; We have erred, and strayed
            from thy ways like lost sheep. We have followed too much the
            devices and desires of our own hearts. We have offended against
            thy holy laws. We have left undone those things which we ought
            to have done; And we have done those things which we ought not
            to have done; And there is no health in us. But thou, O Lord,
            have mercy upon us, miserable offenders. Spare thou them, O God,
            who confess their faults. Restore thou those who are penitent;
            According to thy promises declared unto mankind in Christ Jesus
            our Lord. And grant, O most merciful Father, for his sake; That
            we may hereafter live a godly, righteous, and sober life, To the
            glory of thy holy Name. Amen.**`
    });
    if (settings.absolution === "bcp absolution") {
        items.push({
            type: "rubric",
            content: "The People still kneeling, the Officiant shall stand and pronounce the **Absolution**."
        });
        items.push({
            type: "text",
            content: `Almighty God, the Father of our Lord Jesus Christ, who
                desireth not the death of a sinner, but rather that he
                may turn from his wickedness, and live; and hath given
                power, and commandment, to his Ministers, to declare and
                pronounce to his people, being penitent, the Absolution
                and Remission of their sins: He pardoneth and absolveth
                all them that truly repent, and unfeignedly believe his
                holy Gospel. Wherefore let us beseech him to grant us
                true repentance, and his Holy Spirit, that those things
                may please him, which we do at this present; and that
                the rest of our life hereafter may be pure, and holy; so
                that at the last we may come to his eternal joy; through
                Jesus Christ our Lord. **Amen.**`
        });
    } else if (settings.absolution === "pardon and peace collect") {
        items.push({
            type: "rubric",
            content: "All still kneeling, the Officiant shall say this **Collect**."
        });
        items.push({
            type: "text",
            content: `Grant, we beseech thee, merciful Lord, to thy faithful
                people pardon and peace, that they may be cleansed from
                all their sins, and serve thee with a quiet mind;
                through Jesus Christ our Lord. **Amen.**`
        });
    }
    if (settings.lordsPrayerAfterConfession === "sung") {
        items.push({
            type: "rubric",
            content: "All kneeling, the **Lord's_Prayer** shall_be_sung."
        });
        items.push(...(0, $596e5f753ebbf674$export$18ee1b3164619030)(false, settings));
    } else if (settings.lordsPrayerAfterConfession === "said") {
        items.push({
            type: "rubric",
            content: "All kneeling, the **Lord's_Prayer** shall_be_said."
        });
        items.push(...(0, $596e5f753ebbf674$export$18ee1b3164619030)(true, settings));
    }
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "All standing, the Officiant and People shall sing in turn these **Preces_and_Responses.**"
    });
    items.push(...(0, $4fae7b70f2712114$export$47fe3383e0215c92)(false));
    if (day.easterOctave && settings.paschaNostrum === "octave") {
        items.push({
            type: "rubric",
            content: "During the Octave of Easter, the **Pascha_Nostrum** shall_be_sung.",
            settingsPanelId: "invitatory"
        });
        items.push({
            type: "canticle",
            id: "pascha nostrum",
            day: day
        });
    } else if (day.label === "easter-day" && settings.paschaNostrum === "day") {
        items.push({
            type: "rubric",
            content: "On Easter Sunday, the **Pascha_Nostrum** shall_be_sung.",
            settingsPanelId: "invitatory"
        });
        items.push({
            type: "canticle",
            id: "pascha nostrum",
            day: day
        });
    } else {
        items.push({
            type: "rubric",
            content: "Then the **Invitatory_Psalm** shall be sung.",
            settingsPanelId: "invitatory"
        });
        items.push({
            type: "canticle",
            id: "venite",
            day: day
        });
    }
    items.push({
        type: "spacer"
    });
    if (settings.hymnPosition === "before psalms") {
        items.push({
            type: "rubric",
            content: "The **Office Hymn** may be sung.",
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "mattins"
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: `All sitting, the
    **Proper_Psalm${loadablePsalms.state === "loaded" && loadablePsalms.value.length === 1 ? "" : "s"}**
    shall be sung.`,
        settingsPanelId: "psalms"
    });
    if (loadablePsalms.state === "loaded") loadablePsalms.value.forEach((refText)=>{
        items.push({
            type: "psalm",
            psalmRef: (0, $8da148c2c45b952c$export$f846b1f6e107a70c)(refText)
        });
    });
    else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "The People sitting, the **First_Lesson** shall_be_read.",
        settingsPanelId: "morning lessons"
    });
    if (loadableLessons.state === "loaded" && Array.isArray(loadableLessons.value.firstLesson)) {
        loadableLessons.value.firstLesson.forEach((lessonPart, index)=>{
            items.push({
                type: "scripture",
                title: lessonPart.title,
                content: lessonPart.content,
                hasBeginneth: index === 0
            });
        });
        items.push({
            type: "text",
            content: "Here endeth the first lesson."
        });
    } else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    if (day.antiphonId === "lent") {
        items.push({
            type: "rubric",
            content: "All may stand and sing the **Benedictus_es,_Domine.**"
        });
        items.push({
            type: "canticle",
            id: "benedictus es",
            day: day
        });
        items.push({
            type: "spacer"
        });
    } else {
        items.push({
            type: "rubric",
            content: "All may stand and sing the **Te_Deum.**",
            settingsPanelId: "te deum"
        });
        if (settings.teDeum === "always" || settings.teDeum === "feasts" && day.label !== undefined) items.push({
            type: "canticle",
            id: "te deum",
            day: day
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: "The People sitting, the **Second_Lesson** shall_be_read."
    });
    if (loadableLessons.state === "loaded" && Array.isArray(loadableLessons.value.secondLesson)) {
        loadableLessons.value.secondLesson.forEach((lessonPart, index)=>{
            items.push({
                type: "scripture",
                title: lessonPart.title,
                content: lessonPart.content,
                hasBeginneth: index === 0
            });
        });
        items.push({
            type: "text",
            content: "Here endeth the second lesson."
        });
    } else items.push({
        type: "loading"
    });
    items.push({
        type: "spacer"
    });
    if (settings.hymnPosition === "before canticle") {
        items.push({
            type: "rubric",
            content: "The **Office Hymn** may be sung.",
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "mattins"
        });
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: "All standing, the **Gospel_Canticle** shall_be_sung.",
        settingsPanelId: "gospel canticles"
    });
    items.push({
        type: "canticle",
        id: "benedictus",
        day: day
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "Remaining standing, all shall say together the **Apostles'_Creed.**"
    });
    items.push({
        type: "text",
        content: `**I believe in God, the Father Almighty, Maker of heaven and
            earth; and in Jesus Christ, his only Son our Lord; Who was
            conceived by the Holy Ghost; Born of the Virgin Mary; Suffered
            under Pontius Pilate; Was crucified, dead, and buried; He
            descended into hell; The third day he rose again from the dead;
            He ascended into heaven, And sitteth on the right hand of God
            the Father Almighty; From thence he shall come to judge the
            quick and the dead. I believe in the Holy Ghost; The holy
            Catholic Church; The Communion of Saints; The Forgiveness of
            sins; The Resurrection of the body; And the life everlasting.
            Amen.**`
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "litany rubric",
        day: day
    });
    items.push({
        type: "spacer"
    });
    items.push({
        type: "rubric",
        content: "The Officiant shall sing the **Salutation**, the_People_responding.",
        settingsPanelId: "salutation"
    });
    items.push(...(0, $e5d4e422eab295c9$export$640f02cc93cb7a75)(settings));
    items.push({
        type: "rubric",
        content: "All kneeling, the Officiant and People shall sing the **Lesser_Litany.**"
    });
    items.push(...(0, $4a7946aaaf242f88$export$77fe68ccb90ccc15)());
    items.push({
        type: "rubric",
        content: "All shall sing together the **Lord's_Prayer.**",
        settingsPanelId: "lords prayer"
    });
    items.push(...(0, $596e5f753ebbf674$export$18ee1b3164619030)(false, settings));
    items.push({
        type: "rubric",
        content: "The Officiant and People shall sing in turn the **Suffrages.**"
    });
    items.push(...(0, $59182a366e3671e1$export$128941c64a6df66a)(settings));
    items.push({
        type: "spacer"
    });
    items.push(...(0, $b62f69636707813d$export$7b3e42473e668d2d)(day, "mattins", false, settings));
    items.push({
        type: "rubric",
        content: "The **Collect_for_Peace,**"
    });
    items.push({
        type: "text",
        content: `O God, who art the author of peace and lover of concord, in
            knowledge of whom standeth our eternal life, whose service is
            perfect freedom; Defend us thy humble servants in all assaults
            of our enemies; that we, surely trusting in thy defence, may not
            fear the power of any adversaries, through the might of Jesus
            Christ our Lord. **Amen.**`
    });
    items.push({
        type: "rubric",
        content: "And the **Collect_for_Grace.**"
    });
    items.push({
        type: "text",
        content: `O Lord, our heavenly Father, Almighty and everlasting God, who
            hast safely brought us to the beginning of this day; Defend us
            in the same with thy mighty power; and grant that this day we
            fall into no sin, neither run into any kind of danger; but that
            all our doings may be ordered by thy governance, to do always
            that which is righteous in thy sight; through Jesus Christ our
            Lord. **Amen.**`
    });
    if (settings.letUsBlessMattinsAndEvensong === "after collects") {
        items.push({
            type: "spacer"
        });
        items.push({
            type: "rubric",
            content: "The Officiant shall sing, the_People_responding,",
            settingsPanelId: "let us bless"
        });
        items.push(...(0, $025b4137d19c4e7f$export$fe883b921a9f683c)(day, "mattins"));
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: "All may say together this **General_Thanksgiving.**"
    });
    items.push({
        type: "text",
        content: `**Almighty God, Father of all mercies, we thine unworthy servants
            do give thee most humble and hearty thanks for all thy goodness
            and loving-kindness to us, and to all men. We bless thee for our
            creation, preservation, and all the blessings of this life; but
            above all, for thine inestimable love in the redemption of the
            world by our Lord Jesus Christ; for the means of grace, and for
            the hope of glory. And, we beseech thee, give us that due sense
            of all thy mercies, that our hearts may be unfeignedly thankful,
            and that we may show forth thy praise, not only with our lips,
            but in our lives; by giving up ourselves to thy service, and by
            walking before thee in holiness and righteousness all our days;
            through Jesus Christ our Lord, to whom with thee and the Holy
            Ghost be all honour and glory, world without end. Amen.**`
    });
    items.push({
        type: "rubric",
        content: "The Officiant may say this **Prayer_of_Saint_John_Chrysostom.**"
    });
    items.push({
        type: "text",
        content: `Almighty God, who hast given us grace at this time with one
            accord to make our common supplications unto thee; and dost
            promise, that when two or three are gathered together in thy
            Name thou wilt grant their requests: Fulfil now, O Lord, the
            desires and petitions of thy servants, as may be most expedient
            for them; granting us in this world knowledge of thy truth, and
            in the world to come life everlasting. **Amen.**`
    });
    if (settings.hymnPosition === "anthem") {
        items.push({
            type: "rubric",
            content: "The **Office Hymn** may be sung.",
            settingsPanelId: "office hymn"
        });
        items.push({
            type: "office hymn",
            day: day,
            hour: "mattins"
        });
        items.push({
            type: "spacer"
        });
    }
    if (settings.letUsBlessMattinsAndEvensong === "before grace") {
        items.push({
            type: "spacer"
        });
        items.push({
            type: "rubric",
            content: "The Officiant shall sing, the_People_responding,",
            settingsPanelId: "let us bless"
        });
        items.push(...(0, $025b4137d19c4e7f$export$fe883b921a9f683c)(day, "mattins"));
        items.push({
            type: "spacer"
        });
    }
    items.push({
        type: "rubric",
        content: "The Officiant shall say **The_Grace.**"
    });
    items.push({
        type: "text",
        content: `The grace of our Lord Jesus Christ, and the love of God, and the
            fellowship of the Holy Ghost, be with us all evermore. **Amen.**`
    });
    items.push({
        type: "spacer",
        big: true
    });
    items.push({
        type: "footer",
        day: day,
        hour: "mattins"
    });
    return items;
};






const $855e99114accba88$export$37d4b02dddb07f6a = (props)=>{
    const { day: day, isToday: isToday } = props;
    console.log(day);
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    (0, $d9d511397f573593$export$606752b32846567e)(day, "mattins");
    const loadablePsalms = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "proper psalms",
        day: day,
        psalmCycle: settings.psalmCycle,
        time: "morning"
    });
    const loadableLessons = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "mattins readings",
        day: day,
        mattinsReadings: settings.mattinsReadings,
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false
    });
    const loadablePreviousMattinsLessions = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "mattins readings",
        day: (0, $10afe2ece93b1c22$export$96bdf281383ed03d)(day),
        mattinsReadings: settings.mattinsReadings,
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false
    });
    const loadablePreviousEvensongLessions = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "evensong readings",
        day: (0, $10afe2ece93b1c22$export$96bdf281383ed03d)(day),
        evensongReadings: (0, $e5274831a769feea$export$45057e54bc6685bf)(settings.mattinsReadings),
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e8eee601cb369fe$export$47dc637b8554585f), {
            items: (0, $d2161558733c29d7$export$3e48560df517de33)(day, settings, loadablePsalms, loadableLessons)
        })
    });
};


const $1b5faf3a74c9a944$export$121d5e02794a18c5 = ()=>{
    const { year: year, month: month, date: date, hour: hour } = (0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)();
    const day = (0, $063afc2d5fcbb72a$export$229d3f939f129064)(year, month, date, true);
    switch(hour){
        case "mattins":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
                initialState: {},
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $855e99114accba88$export$37d4b02dddb07f6a), {
                    day: day,
                    isToday: false
                }, JSON.stringify(day))
            });
        case "evensong":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
                initialState: {},
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29cba15c31403d57$export$494cc934acf6d73c), {
                    day: day,
                    isToday: false
                }, JSON.stringify(day))
            });
        case "compline":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
                initialState: {},
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31417567f1c17ca9$export$d760a004f53d03a2), {
                    day: day
                }, JSON.stringify(day))
            });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            "Error: ",
            hour,
            " is not a valid hour."
        ]
    });
};



parcelRequire("acw62");



const $2c58651397710fc1$export$d23df640790b2fd6 = ()=>{
    const { psalm: psalm } = (0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
            initialState: {},
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    paddingTop: 32,
                    paddingBottom: 32
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "full",
                        number: parseInt(psalm)
                    }
                })
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");






const $c693eb8bb6a24bf5$export$b8cb238a79c4ebf1 = ()=>{
    const mailRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (mailRef.current) mailRef.current.href = "mailto:" + [
            "contact",
            "singtheoffice.com"
        ].join("@");
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
            initialState: {},
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontWeight: "bold",
                            letterSpacing: 2,
                            textTransform: "uppercase",
                            fontSize: "140%",
                            paddingBottom: 4,
                            paddingTop: 32,
                            textAlign: "center"
                        },
                        children: "Recording Project"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: "SingTheOffice is a website devoted to making it easier to sing traditional Anglican Daily Offices, in particular the plainsong chant of the Psalms and Canticles. It does this by providing an automatically generated order of service for Mattins, Evensong and Compline every day, with almost everything than can be sung set out fully in square notation. Alongside the main chants, options are provided where the site will intone the chant for the user, helping them to learn the pitches of the various chants."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: "This approach has been successful and well-received, with many people saying that it tipped the balance for them in making the chant of the office possible where they found it too difficult before. For many, however, this has not gone far enough, and they feel that they would need a recorded voice to sing along with."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: "To this end, at SingTheOffice we believe that the goal of more people singing the prayers of the church (especially the Psalms) will be advanced by comissioning, and making freely available on the site, a complete set of recordings of the Psalms, Canticles, and other sung parts of the Book of Common Prayer Daily Office."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: "We are therefore looking to hire a single tenor who is excited by this project and able to make the recordings over the summer of 2021."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: "We will need the following recordings:"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "All of the Psalms sung as they are set out on the site (one setting each)."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "All of the Canticles sung in ~4 settings per Canticle."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "All of the Office Hymns (approximately 20) sung."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "The other sung parts of the Office (preces and responses, etc) sung in one setting."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: "Details of the project are as follows:"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "We estimate that the total length of the recordings will be approximately 15 hours. Most of the settings are quite straightforward, with a few of the hymns being more ornate."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "We are offering \xa32000 for the complete set of recordings, paid upon completion."
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "The content to be sung will be finalised by June 2021."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "We can be flexible around how you wish to work. You could work on this project full time for two weeks, or complete it more slowly over the whole summer. All that we ask is that you commit firmly up front to a timetable that you agree with us."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "We are looking for someone who can work from home, or some other place arranged by them. We will cover the cost of any equipment hire, if this is necessary."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "We are still finalising the details, but we are expecting to use the Coverdale translations found in the 1662 Book of Common Prayer International Edition, which is a (very) slight modernisation of the text found in the original 1662 BCP."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "We are looking for someone who is excited about creating a quality end product, with a lasting legacy."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "We will, of course, publicly credit you for your work, and besides your monetary payment, you will have the satisfaction of helping many people learn to sing the prayers of the church over the coming years."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: [
                        "If you are interested in this work, please send a recording of the following texts (using something like a Dropbox link) to",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            type: "mailto",
                            ref: mailRef,
                            children: "our email address."
                        }),
                        " ",
                        "Guidelines for the recording are as follows:"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "Sing at whatever pitch you find comfortable, and you think others would generally find easiest to sing along to."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "Leave a decent pause between each verse, and at each half point of the verse."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "It doesn't matter whether these are all in one file, split across multiple files, or whatever."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "Record this using the best equipment you have easy access to. Sound quality is not perticularly important for this initial exercise."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82bb01a09dc6158e$export$b74815b6cb0f6d09), {
                    children: "Enjoy, and we are looking forward to hearing from you!"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 18,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 22,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 41,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 51,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 42,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 105,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 73,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 141,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f9a5c5a44aa3093$export$b4e679dc0df20af5), {
                    psalmRef: {
                        type: "section",
                        number: 114,
                        firstVerse: 1,
                        lastVerse: 5
                    },
                    excludeGloriaPatri: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $427fec415011985b$export$389138f633999d3), {
                    verseLimit: 4,
                    day: {
                        year: 2021,
                        date: 27,
                        dayOfTheWeek: "sat",
                        month: 3,
                        otherLabels: [],
                        collectId: "lent-5",
                        collect: "We beseech thee, Almighty God, mercifully to look upon thy people; that by thy great goodness they may be governed and preserved evermore, both in body and soul; through Jesus Christ our Lord.",
                        weekOfTheYear: 12,
                        antiphonId: "lent",
                        dayOfTheYear: 85,
                        sentenceId: "passiontide",
                        hymnId: "passiontide-1",
                        easterOctave: false,
                        eveOf: {
                            year: 2021,
                            date: 28,
                            dayOfTheWeek: "sun",
                            month: 3,
                            label: "lent-6",
                            otherLabels: [],
                            collectId: "lent-6",
                            collect: "Almighty and everlasting God, who, of thy tender love towards mankind, hast sent thy Son, our Savior Jesus Christ, to take upon him our flesh, and to suffer death upon the cross, that all mankind should follow the example of his great humility; Mercifully grant, that we may both follow the example of his patience, and also be made partakers of his resurrection; through the same Jesus Christ our Lord.",
                            weekOfTheYear: 13,
                            antiphonId: "lent",
                            dayOfTheYear: 86,
                            sentenceId: "passiontide",
                            hymnId: "passiontide-0",
                            easterOctave: false
                        },
                        label: "undefined"
                    },
                    hour: "evensong"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7fa6b19148d6ce$export$d7a54cba636a8cd6), {
                    big: true
                })
            ]
        })
    });
};



parcelRequire("acw62");




const $5298b88dda3758ff$export$8f6dcfe950367406 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontWeight: "bold",
                    letterSpacing: 2,
                    textTransform: "uppercase",
                    fontSize: "140%",
                    paddingBottom: 32,
                    paddingTop: 32,
                    textAlign: "center"
                },
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    backgroundColor: (0, $b5d1360628cd70a0$export$ee522376d3ee75f2),
                    border: `0.5px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`,
                    paddingTop: 6,
                    paddingBottom: 8,
                    paddingLeft: 12,
                    paddingRight: 12,
                    borderRadius: 4
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            color: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                            fontWeight: "bold",
                            fontSize: "90%"
                        },
                        children: "NOTE:"
                    }),
                    " ",
                    "It is easier to change the settings by pressing the",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2de9233531d2f09$export$ac4e8b8ca2b79f39), {}),
                    " button next to the relevant part of the liturgy."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "absolution"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "lordsPrayerAfterConfession"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "psalmCycle"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "lectionary"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "secondReadingToCompline"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "bibleTranslation"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "psalmsAtCompline"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "psalmsBold"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "invitatoryAntiphons"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "antiphonTones"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "teDeum"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "salutation"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "lordsPrayer"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "monarch"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "adventAndLentCollects"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "letUsBlessMattinsAndEvensong"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "hymnPosition"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "canticleAntiphonsExperimental"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "canticleTonesExperimental"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab540e91b6a0c911$export$805dc0bee9369f09), {
                setting: "experimentalChantRendering"
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");






const $9645b905b2410b01$var$getParts = (text)=>{
    const parts = [];
    Array.from(text).forEach((char)=>{
        if (char === "_") parts.push({
            type: "hyphen"
        });
        else if (char === " ") parts.push({
            type: "space"
        });
        else if (char === "/") parts.push({
            type: "syllable",
            text: "",
            stressed: true
        });
        else if (parts.length > 0) {
            const lastPart = parts[parts.length - 1];
            if (lastPart.type === "syllable") lastPart.text += char;
            else parts.push({
                type: "syllable",
                text: char,
                stressed: false
            });
        } else parts.push({
            type: "syllable",
            text: char,
            stressed: false
        });
    });
    return parts;
};
const $9645b905b2410b01$export$bddbd54033189e9c = ()=>{
    const { psalm: psalm } = (0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)();
    const [emphasisDb, setEmphasisDb] = (0, $fc466355347b8480$export$86e2cef2561044ac)("emphasis-db", undefined);
    const [parts, setParts] = (0, $acw62.useState)([]);
    const [remaining, setRemaining] = (0, $acw62.useState)(0);
    const [ending, setEnding] = (0, $acw62.useState)(undefined);
    const updatedText = parts.map((part)=>{
        switch(part.type){
            case "space":
                return " ";
            case "hyphen":
                return "_";
            case "syllable":
                return (part.stressed ? "/" : "") + part.text;
        }
    }).join("");
    const save = (0, $acw62.useCallback)(()=>{
        if (!ending) return;
        const newEmphasisDb = {
            ...emphasisDb,
            [ending.ending]: {
                tagged: updatedText,
                examples: []
            }
        };
        setEmphasisDb(newEmphasisDb);
        load(newEmphasisDb);
    }, [
        ending,
        emphasisDb,
        setEmphasisDb,
        updatedText
    ]);
    const [disabled, setDisabled] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)((eDb)=>{
        if (psalm === "load") return;
        const outstandingEndings = (0, $8da148c2c45b952c$export$67c5240321e9091f)(psalm, eDb ?? emphasisDb);
        if (outstandingEndings.length > 0) {
            const current = outstandingEndings[0];
            setParts($9645b905b2410b01$var$getParts(current.ending));
            setEnding(current);
            setRemaining(outstandingEndings.length);
            setDisabled(true);
            setTimeout(()=>{
                setDisabled(false);
            }, 2000);
        } else setRemaining(0);
    }, [
        emphasisDb,
        psalm
    ]);
    (0, $acw62.useEffect)(()=>{
        if (parts.length === 0) load();
    }, [
        parts,
        load
    ]);
    const tones = (0, $6610792c2b4ce802$export$28c156c102c4a912)[(0, $8da148c2c45b952c$export$f846b1f6e107a70c)(psalm).number];
    const preview = (0, $acw62.useMemo)(()=>{
        try {
            if (ending) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    paddingTop: 16
                },
                children: [
                    tones.map((t)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        "Actual tone (",
                                        t.tone,
                                        "):"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                                    pointedText: (0, $8da148c2c45b952c$export$30094a79c9c7227e)([
                                        [
                                            updatedText,
                                            updatedText
                                        ]
                                    ], t.tone, false, false, {
                                        [ending.ending]: {
                                            tagged: updatedText,
                                            examples: []
                                        }
                                    }),
                                    dropCap: false,
                                    boldMode: "all"
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Sanity check for other tones:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                        pointedText: (0, $8da148c2c45b952c$export$30094a79c9c7227e)([
                            [
                                updatedText,
                                updatedText
                            ]
                        ], "6b", false, false, {
                            [ending.ending]: {
                                tagged: updatedText,
                                examples: []
                            }
                        }),
                        dropCap: false,
                        boldMode: "all"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d4b9cf3f617ce8$export$90dad5714e071580), {
                        pointedText: (0, $8da148c2c45b952c$export$30094a79c9c7227e)([
                            [
                                updatedText,
                                updatedText
                            ]
                        ], "2.1", false, false, {
                            [ending.ending]: {
                                tagged: updatedText,
                                examples: []
                            }
                        }),
                        dropCap: false,
                        boldMode: "all"
                    })
                ]
            });
        } catch (error) {
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    paddingTop: 16
                },
                children: error.message
            });
        }
    }, [
        ending,
        updatedText,
        tones
    ]);
    if (remaining === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Done!"
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    textAlign: "center",
                    fontWeight: "bold"
                },
                children: [
                    remaining,
                    " remaining"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "200%",
                    padding: 32,
                    fontWeight: "bold"
                },
                children: parts.map((part, partIndex)=>{
                    switch(part.type){
                        case "space":
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "\xa0"
                            });
                        case "hyphen":
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "-"
                            });
                        case "syllable":
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: part.stressed ? {
                                    textDecoration: "underline",
                                    cursor: "pointer"
                                } : {
                                    cursor: "pointer"
                                },
                                onClick: ()=>{
                                    setParts(parts.map((p, pi)=>{
                                        if (pi === partIndex && p.type === "syllable") return {
                                            ...p,
                                            stressed: !p.stressed
                                        };
                                        else return p;
                                    }));
                                },
                                children: part.text
                            });
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    paddingBottom: 32
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    style: {
                        backgroundColor: (0, $b5d1360628cd70a0$export$f20e1008093b38b9),
                        color: (0, $b5d1360628cd70a0$export$1a6c4fc8d15a2dc7),
                        border: "none",
                        borderRadius: 4,
                        padding: 12,
                        fontFamily: (0, $b5d1360628cd70a0$export$95deb96ddfd043a9),
                        fontSize: "120%",
                        fontWeight: "bold",
                        opacity: disabled ? 0.5 : 1.0,
                        transition: "all 0.5s"
                    },
                    disabled: disabled,
                    onClick: ()=>{
                        save();
                    },
                    children: "Continue"
                })
            }),
            preview
        ]
    });
};



parcelRequire("acw62");



const $811ba1d4386fca12$export$e0c14ca60a78daaa = ()=>{
    const dateTime = new Date();
    if (dateTime.getHours() < 3) dateTime.setDate(dateTime.getDate() - 1);
    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();
    const day = (0, $063afc2d5fcbb72a$export$229d3f939f129064)(year, month, date, true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
        initialState: {},
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31417567f1c17ca9$export$d760a004f53d03a2), {
            day: day
        })
    });
};



parcelRequire("acw62");



const $9274aa06a0b765d3$export$65099c846075c939 = ()=>{
    const dateTime = new Date();
    if (dateTime.getHours() < 3) dateTime.setDate(dateTime.getDate() - 1);
    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();
    const day = (0, $063afc2d5fcbb72a$export$229d3f939f129064)(year, month, date, true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
        initialState: {},
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29cba15c31403d57$export$494cc934acf6d73c), {
            day: day,
            isToday: true
        })
    });
};



parcelRequire("acw62");



const $4f11594785de166d$export$7ada8c2f1f9e6e91 = ()=>{
    const dateTime = new Date();
    if (dateTime.getHours() < 3) dateTime.setDate(dateTime.getDate() - 1);
    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();
    const day = (0, $063afc2d5fcbb72a$export$229d3f939f129064)(year, month, date, true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
        initialState: {},
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $855e99114accba88$export$37d4b02dddb07f6a), {
            day: day,
            isToday: true
        })
    });
};



parcelRequire("acw62");





parcelRequire("acw62");




const $56a821df2a6e7752$export$5faecbd87eccfda1 = (props)=>{
    const { day: day, labelOverride: labelOverride } = props;
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            borderTop: labelOverride === "Yesterday" ? "" : `1px solid ${0, $b5d1360628cd70a0$export$6a1034a6524f1861}`,
            paddingBottom: 8,
            paddingTop: 8,
            display: "flex",
            alignItems: isSmallScreen ? "flex-start" : "center",
            flexDirection: isSmallScreen ? "column" : "row"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            width: 70,
                            flexShrink: 0,
                            fontWeight: labelOverride === "Today" ? "bold" : undefined
                        },
                        children: labelOverride ? labelOverride : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                day.dayOfTheWeek[0].toLocaleUpperCase() + day.dayOfTheWeek.substr(1),
                                " ",
                                day.date
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontWeight: day.label ? "bold" : "normal",
                            flexGrow: 1
                        },
                        children: day.label ? (0, $063afc2d5fcbb72a$export$fd51ed252694f070)(day.label) : day.blackLetterDay ? day.blackLetterDay.optional ? `(commonly: ${day.blackLetterDay.title})` : day.blackLetterDay.title : undefined
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    fontWeight: "bold"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                        to: `/pray/${day.year}/${day.month}/${day.date}/mattins`,
                        children: "Mattins"
                    }),
                    "\xa0\xa0",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                        to: `/pray/${day.year}/${day.month}/${day.date}/evensong`,
                        children: "Evensong"
                    }),
                    "\xa0\xa0",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$a6c7ac8248d6e38a), {
                        to: `/pray/${day.year}/${day.month}/${day.date}/compline`,
                        children: "Compline"
                    })
                ]
            })
        ]
    }, `${day.date} ${day.month}`);
};


const $a94d733270b5db4b$export$d6e2c116d12c5517 = ()=>{
    const year = parseInt((0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)().year);
    const isSmallScreen = (0, $cd93687958c8007e$export$bc451faac18251e7)();
    let prevMonth = 0;
    const rows = (0, $063afc2d5fcbb72a$export$6d7724e5c284a396)(year, true).days.map((day)=>{
        let monthDivider = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        if (prevMonth !== day.month) {
            prevMonth = day.month;
            monthDivider = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    paddingBottom: 8,
                    paddingTop: 48,
                    fontWeight: "bold"
                },
                children: (0, $063afc2d5fcbb72a$export$e7af3ee2c84591cc)(day.month)
            }, day.month);
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                monthDivider,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56a821df2a6e7752$export$5faecbd87eccfda1), {
                    day: day
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0bcfdc12ef99a56$export$8ee6ea94b5aedb49), {
        children: rows
    });
};



parcelRequire("acw62");




const $2dd8ddd2adab61fc$var$getPsalm = (ref, response)=>{
    const ant = {
        type: "gabc chant",
        gabc: response.psalms[ref].ant.gabc,
        dropCap: true,
        tone: response.psalms[ref].ant.tone,
        playButtons: [
            {
                gabc: response.psalms[ref].ant.gabc,
                title: "Intone",
                intoneOnly: true
            },
            {
                gabc: response.psalms[ref].ant.gabc,
                title: "Play full",
                intoneOnly: false
            }
        ],
        title: "Antiphon"
    };
    return [
        ant,
        {
            type: "tone chant",
            pointedText: response.psalms[ref].psalm,
            tone: response.psalms[ref].tone,
            boldMode: "alternate",
            title: `Psalm ${ref}`
        },
        ant
    ];
};
const $2dd8ddd2adab61fc$var$getRespond = (id, numeral, response)=>{
    return {
        type: "gabc chant",
        gabc: response.psalms[`${id}a`].ant.gabc + response.psalms[`${id}b`].ant.gabc.replace("(c4) ", "").replace("(c3) ", "").replace("(f3) ", ""),
        dropCap: true,
        tone: response.psalms[`${id}a`].ant.tone,
        playButtons: [
            {
                gabc: response.psalms[`${id}a`].ant.gabc,
                title: "Intone",
                intoneOnly: true
            },
            {
                gabc: response.psalms[`${id}a`].ant.gabc + response.psalms[`${id}b`].ant.gabc.replace("(c4) ", "").replace("(c3) ", "").replace("(f3) ", ""),
                title: "Play full",
                intoneOnly: false
            }
        ],
        title: `${numeral} Respond`
    };
};
const $2dd8ddd2adab61fc$export$1b58cfd8de96a8c = (day, response)=>{
    if (day === "thursday") return [
        {
            type: "rubric",
            content: "This page provides a number of the simpler proper chants for Tenebrae, but the antiphons and responsories have been set to solemn psalm tones for ease of singing without lengthy choir practice."
        },
        {
            type: "spacer"
        },
        {
            type: "subheading",
            content: "I Nocturn"
        },
        ...$2dd8ddd2adab61fc$var$getPsalm("69", response),
        ...$2dd8ddd2adab61fc$var$getPsalm("70", response),
        ...$2dd8ddd2adab61fc$var$getPsalm("71", response),
        {
            type: "spacer"
        },
        {
            type: "rubric",
            content: "All stand."
        },
        {
            type: "gabc chant",
            gabc: "(c4) A(j)rise,(j) O(i) Lord.(h) (::) *And*(f) *main*(f)*tain*(f) *my*(e) *cause.*(d) (::)",
            dropCap: false,
            tone: "1",
            title: "Versicle and Response",
            playButtons: [
                {
                    gabc: "(c4) A(j)rise,(j) O(i) Lord.(h) (::) *And*(f) *main*(f)*tain*(f) *my*(e) *cause.*(d) (::)",
                    title: "Play",
                    intoneOnly: false
                }
            ]
        },
        {
            type: "rubric",
            content: "**Our Father** and **Hail Mary** are said silently, then all sit for the lessons."
        },
        {
            type: "spacer"
        },
        {
            type: "gabc chant",
            gabc: "(c4) A(h)leph.(hvGFggf) (::) How(f) doth(g) the(h) ci(h)ty(h) sit(h) so(h)li(h)ta(h)ry,(h) (,) that(h) was(g) full(ixi) of(h) peo(g)ple:(h) (;) how(h) is(h) she(h) be(h)come(h) as(h) a(h) wi(h)dow,(h) (,) she(h) that(h) was(h) great(h) a(h)mong(h) the(h) na(h)tions,(h) (,) and(h) prin(h)cess(h) a(g)mong(ixi) the(h) pro(g)vin(h)ces,(h) (;) how(h) is(h) she(h) be(h)come(h) tri(g)bu(f)ta(g)ry!(f) (::) Beth.(hvGFggf) (::) She(f) wee(g)peth(h) sore(h) in(h) the(h) night,(h) (,) and(h) her(g) tears(ixi) are(h) on(g) her(h) cheeks:(h) (;) among(h) all(h) her(h) lo(h)vers(h) she(h) hath(h) none(g) to(f) com(g)fort(f) her.(f) (::) All(f) her(g) friends(h) have(h) dealt(g) trea(ixi)che(h)rous(h)ly(g) with(h) her:(h) (;) they(h) are(h) be(h)come(g) her(f) e(g)ne(f)mies.(f) (::) Je(f)ru(g)sa(h)lem,(g) Je(ixi)ru(h)sa(g)lem,(h) (,) re(h)turn(h) to(g) the(f) Lord(g) thy(g) God.(ghGFgvFEdf) (::)",
            dropCap: true,
            tone: "",
            playButtons: [
                {
                    gabc: "(c4) A(h)leph.(hvGFggf) (::)",
                    title: "Intone",
                    intoneOnly: true
                },
                {
                    gabc: "(c4) (h) to(g) the(f) Lord(g) God.(ghGFgvFEdf) (::)",
                    title: "Ending",
                    intoneOnly: false
                }
            ],
            title: "I Lesson"
        },
        $2dd8ddd2adab61fc$var$getRespond("r1", "I", response),
        {
            type: "gabc chant",
            gabc: "(c4) Ghi(h)mel.(hvGFggf) (::) Ju(f)dah(g) is(h) gone(h) in(h)to(h) cap(h)ti(h)vi(h)ty(h) be(h)cause(h) of(h) af(h)flic(h)tion,(h) (,) and(h) be(h)cause(h) of(g) great(ixi) ser(h)vi(g)tude:(h) (;) she(h) dwel(h)leth(h) a(h)mong(h) the(h) hea(h)then,(h) (,) she(h) fin(g)deth(f) no(g) rest.(f) (::) All(f) her(g) per(h)se(h)cu(h)tors(h) o(h)ver(h)took(h) her(g) be(f)tween(g) the(f) straits.(f) (::) Da(h)leth.(hvGFggf) (::) The(f) ways(g) of(h) Si(h)on(h) do(h) mourn,(h) (,) be(h)cause(h) none(h) come(g) to(ixi) the(h) so(g)lemn(h) feasts:(h) (;) all(h) her(h) gates(h) are(h) de(h)so(h)late;(h) (;) her(h) priests(h) sigh,(h) (,) her(h) vir(h)gins(g) are(ixi) af(h)flic(g)ted,(h) (;) and(h) she(h) is(g) in(f) bit(g)ter(f)ness.(f) (::) He.(hvGFggf) (::) Her(f) ad(g)ver(h)sa(h)ries(h) are(h) the(h) chief,(h) (,) her(g) e(ixi)ne(h)mies(h) pros(g)per;(h) (;) for(h) the(h) Lord(h) hath(h) af(h)flic(h)ted(h) her(h) (,) for(h) the(h) mul(h)ti(h)tude(h) of(h) her(g) trans(f)gres(g)sions.(f) (::) Her(f) chil(g)dren(h) are(h) gone(g) in(ixi)to(h) cap(h)ti(g)vi(h)ty(h) (;) be(h)fore(g) the(f) e(g)ne(f)my.(f) (::) Je(f)ru(g)sa(h)lem,(g) Je(ixi)ru(h)sa(g)lem,(h) (,) re(h)turn(h) to(g) the(f) Lord(g) thy(g) God.(ghGFgvFEdf) (::)",
            dropCap: true,
            tone: "",
            playButtons: [
                {
                    gabc: "(c4) A(h)leph.(hvGFggf) (::)",
                    title: "Intone",
                    intoneOnly: true
                },
                {
                    gabc: "(c4) (h) to(g) the(f) Lord(g) God.(ghGFgvFEdf) (::)",
                    title: "Ending",
                    intoneOnly: false
                }
            ],
            title: "II Lesson"
        },
        $2dd8ddd2adab61fc$var$getRespond("r2", "II", response),
        {
            type: "gabc chant",
            gabc: "(c4) Vaw.(hvGFggf) (::) From(f) the(g) daugh(h)ter(h) of(h) Zi(h)on(h) all(h) her(h) beau(h)ty(g) is(ixi) de(h)par(g)ted:(h) (;) her(h) prin(h)ces(h) are(h) be(h)come(h) like(h) harts(h) that(g) find(ixi) no(h) pas(g)ture,(h) (;) and(h) they(h) are(h) gone(h) wi(h)thout(h) strength(h) be(h)fore(h) the(g) pur(f)su(g)er.(f) (::) Za(h)yin.(hvGFggf) (::) Je(f)ru(g)sa(h)lem(h) re(h)mem(h)bered(h) in(h) the(h) days(h) of(h) her(h) af(h)flic(h)tion(h) and(g) of(ixi) her(h) mi(g)se(h)ries,(h) (;) all(h) her(h) plea(h)sant(h) things(h) that(h) she(g) had(ixi) in(h) the(h) days(g) of(h) old;(h) (;) when(h) her(h) peo(h)ple(h) fell(h) in(h)to(h) the(h) hand(h) of(h) the(h) e(h)ne(h)my,(h) (,) and(h) none(g) did(f) help(g) her.(f) (::) The(f) ad(g)ver(h)sa(h)ries(h) saw(h) her,(h) (,) and(h) did(h) mock(h) at(g) her(f) sab(g)baths.(f) (::) Heth.(hvGFggf) (::) Je(f)ru(g)sa(h)lem(h) hath(g) grie(ixi)vous(h)ly(g) sinned:(h) (;) there(h)fore(g) she(f) is(g) re(f)moved.(f) (::) All(f) that(g) ho(h)noured(g) her(ixi) des(h)pise(g) her,(h) (;) be(h)cause(h) they(h) have(h) seen(g) her(f) na(g)ked(f)ness:(f) (::) yea,(f) she(g) sigh(h)eth,(h) and(h) tur(g)neth(f) back(g)ward.(f) (::) Teth.(hvGFggf) (::) Her(f) fil(g)thi(h)ness(h) is(h) in(h) her(h) skirts;(h) (,) she(h) re(h)mem(h)ber(h)eth(g) not(ixi) her(h) last(g) end:(h) (;) there(h)fore(h) she(h) came(h) down(h) won(h)der(h)ful(h)ly;(h) (;) she(h) had(g) no(f) com(g)for(f)ter.(f) (::) O(f) Lord,(h) be(g)hold(ixi) my(h) af(h)flic(g)tion:(h) (;) for(h) the(h) e(h)ne(h)my(h) hath(h) mag(g)ni(f)fied(g) him(f)self.(f) (::) Je(f)ru(g)sa(h)lem,(g) Je(ixi)ru(h)sa(g)lem,(h) (,) re(h)turn(h) to(g) the(f) Lord(g) thy(g) God.(ghGFgvFEdf) (::)",
            dropCap: true,
            tone: "",
            playButtons: [
                {
                    gabc: "(c4) A(h)leph.(hvGFggf) (::)",
                    title: "Intone",
                    intoneOnly: true
                },
                {
                    gabc: "(c4) (h) to(g) the(f) Lord(g) God.(ghGFgvFEdf) (::)",
                    title: "Ending",
                    intoneOnly: false
                }
            ],
            title: "III Lesson"
        },
        $2dd8ddd2adab61fc$var$getRespond("r3", "III", response),
        {
            type: "spacer"
        },
        {
            type: "subheading",
            content: "II Nocturn"
        },
        ...$2dd8ddd2adab61fc$var$getPsalm("72", response),
        ...$2dd8ddd2adab61fc$var$getPsalm("73", response),
        ...$2dd8ddd2adab61fc$var$getPsalm("74", response),
        {
            type: "spacer"
        },
        {
            type: "rubric",
            content: "All stand."
        },
        {
            type: "gabc chant",
            gabc: "(c4) De(j)li(j)ver(j) my(j) soul(j),(j) O(i) Lord.(h) (::) *From*(f) *the*(f) *hand*(f) *of*(f) *the*(f) *un*(f)*god*(e)*ly.*(d) (::)",
            dropCap: false,
            tone: "1",
            title: "Versicle and Response",
            playButtons: [
                {
                    gabc: "(c4) De(j)li(j)ver(j) my(j) soul(j),(j) O(i) Lord.(h) (::) *From*(f) *the*(f) *hand*(f) *of*(f) *the*(f) *un*(f)*god*(e)*ly.*(d) (::)",
                    title: "Play",
                    intoneOnly: false
                }
            ]
        },
        {
            type: "rubric",
            content: "**Our Father** and **Hail Mary** are said silently, then all sit for the lessons."
        },
        {
            type: "spacer"
        },
        {
            type: "subheading",
            content: "IV Lesson"
        },
        {
            type: "rubric",
            content: "Exposition of Saint Augustine on Psalm 64"
        },
        {
            type: "text",
            content: "*Hear my voice, O God, in my prayer: preserve my life from fear of the enemy.* Ye know, holy and beloved brethren, that your Lord Jesus Christ is your Head, and that all they which cleave unto him are members of that Head. And it is his voice which ye hear, and that most plainly, inasmuch as it proceedeth not from the Head only, but from the whole Body. Wherefore let us also say: Hear my voice, O God, in my prayer: preserve my life from fear of the enemy. The enemy raged furiously against the martyrs. What said that voice of the Body of Christ? It pleaded that they might be delivered from their enemies; that the enemy might have no power to slay them."
        },
        $2dd8ddd2adab61fc$var$getRespond("r4", "IV", response),
        {
            type: "spacer"
        },
        {
            type: "subheading",
            content: "V Lesson"
        },
        {
            type: "rubric",
            content: "Exposition of Saint Augustine on Psalm 64"
        },
        {
            type: "text",
            content: "Suppose ye that because they were slain, therefore they were not heard? Hath the Lord ever forsaken his servants that be of a contrite heart? Or hath he ever despised them that put their trust in him? God forbid! Yea, they were heard, and yet they were slain: notwithstanding they were delivered from their enemies. This, then, is the martyr\u2019s prayer: *Preserve my life from the fear of the enemy;* not that the enemy should have no power to slay me, but that I should not fear the enemy that slayeth. Preserve me from fear of the enemy, and keep my in thy fear. Let me not fear him that killeth the body, but rather let me fear him which is able to destroy both body and soul in hell; yea, I say, let me fear him. For I desire not that I may be without fear, but that, being preserved from fear of the enemy, I may, with fear, become the servant of God."
        },
        $2dd8ddd2adab61fc$var$getRespond("r5", "V", response),
        {
            type: "spacer"
        },
        {
            type: "subheading",
            content: "VI Lesson"
        },
        {
            type: "rubric",
            content: "Exposition of Saint Augustine on Psalm 64"
        },
        {
            type: "text",
            content: "*Thou hast hidden me, O God, from the gathering together of the froward, and from the insurrection of wicked doers.* Now let us contemplate our Head himself. Many martyrs have suffered such things, but none shineth with such glory as the Head of the martyrs: in him we best perceive what they endured. He was hidden from the insurrection of the froward; for God hid himself. He, the Very Son made man, hid his own Flesh; for he is Son of man and Son of God; Son of God, being in the form of God; Son of man, being in the form of a servant, having power to lay down his life, and having power to take it again."
        },
        $2dd8ddd2adab61fc$var$getRespond("r6", "VI", response),
        {
            type: "spacer"
        }
    ];
    throw new Error("");
};


const $ec3c8899ba031dad$export$9476de778127e6b5 = ()=>{
    const { day: day } = (0, $fbd80a69cf576f05$export$99eaa27ddbbb95ef)();
    const response = (0, $51cabc77a6b85afb$export$492ad75cd9c03188)({
        type: "tenebrae",
        day: day
    });
    console.log(response);
    if (response.state === "loaded") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b0ef04497ab55347$export$875ca48977813ee8), {
        initialState: {},
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    textAlign: "center",
                    padding: 24,
                    paddingTop: 64
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: "120%",
                            fontWeight: "bold",
                            lineHeight: 1.2
                        },
                        children: "Tenebrae of"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: "150%",
                            fontWeight: "bold",
                            lineHeight: 1.2
                        },
                        children: day === "thursday" ? "Maundy Thursday" : day === "friday" ? "Good Friday" : "Holy Saturday"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e8eee601cb369fe$export$47dc637b8554585f), {
                items: (0, $2dd8ddd2adab61fc$export$1b58cfd8de96a8c)(day, response.value)
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
};





(0, $6fb9842575b03497$export$2e2bcd8739ae039).init("f5a4af976d34b678f65d2429cc9d3499");
(0, (/*@__PURE__*/$parcel$interopDefault($bedc752fb75fe228$exports))).init("4ptq78/singtheoffice");
const $cd93687958c8007e$var$SmallScreenContext = /*#__PURE__*/ (0, $acw62.createContext)(false);
const $cd93687958c8007e$export$bc451faac18251e7 = ()=>{
    return (0, $acw62.useContext)($cd93687958c8007e$var$SmallScreenContext);
};
const $cd93687958c8007e$var$NULL = null;
const $cd93687958c8007e$var$PopoverContext = /*#__PURE__*/ (0, $acw62.createContext)($cd93687958c8007e$var$NULL);
const $cd93687958c8007e$export$542a6fd13ac93354 = ()=>{
    return (0, $acw62.useContext)($cd93687958c8007e$var$PopoverContext);
};
const $cd93687958c8007e$var$ChantIndexContext = /*#__PURE__*/ (0, $acw62.createContext)($cd93687958c8007e$var$NULL);
const $cd93687958c8007e$export$f69bc4d89eecfba1 = ()=>{
    return (0, $acw62.useContext)($cd93687958c8007e$var$ChantIndexContext);
};
const $cd93687958c8007e$var$w = window;
const $cd93687958c8007e$var$startTuningAsync = async ()=>{
    console.log("starting tuner");
    const { start: start, subscribe: subscribe } = await (0, $67d312986a59f741$export$6446a2431c728cb0)();
    start();
    subscribe((tuningEvent)=>{
        $cd93687958c8007e$var$w.tuningEvent = tuningEvent;
    });
};
$cd93687958c8007e$var$w.startTuning = async ()=>{
    if ($cd93687958c8007e$var$w.isTuning) ;
    else try {
        $cd93687958c8007e$var$w.isTuning = true;
        await $cd93687958c8007e$var$startTuningAsync();
    } catch  {}
};
function $cd93687958c8007e$var$App() {
    if (!localStorage.getItem("region-switches")?.split(";;;")) localStorage.setItem("region-switches", "");
    const pageRef = (0, $acw62.useRef)(null);
    const isSmallScreen = window.innerWidth <= 700;
    (0, $acw62.useEffect)(()=>{
        document.querySelector(".app-scroll-area")?.scrollTo(0, 0);
        if (window.location.hostname !== "localhost") (0, $6fb9842575b03497$export$2e2bcd8739ae039).track("page-view", {
            path: window.location.href.split(".com")[1]
        });
    }, []);
    const [popoverId, setPopoverId] = (0, $acw62.useState)(undefined);
    if (window.location.hostname === "localhost") {
        const mappedTextData = (0, $7f98b4308afe4768$export$adc377d3f4f7a592).map((psalm)=>{
            return {
                ...psalm,
                lines: psalm.lines.map((line)=>{
                    return line.map((half)=>{
                        const emphasisPoints = (0, $8da148c2c45b952c$export$59b14e03afbf9ee8)(half);
                        const finalWords = [];
                        let syllableCount = 0;
                        half.split(" ").reverse().forEach((word)=>{
                            const finalSyllables = [];
                            word.split("_").reverse().forEach((syllable)=>{
                                syllableCount++;
                                if (emphasisPoints.includes(syllableCount)) finalSyllables.unshift("/" + syllable);
                                else finalSyllables.unshift(syllable);
                            });
                            finalWords.unshift(finalSyllables.join("_"));
                        });
                        return finalWords.join(" ");
                    });
                })
            };
        });
        let diffs = [];
        for(let i = 1; i <= 150; i++){
            const psalm1928 = (0, $7f98b4308afe4768$export$adc377d3f4f7a592).find((psalm)=>psalm.id === `psalm${i}`);
            const psalm1662 = (0, $26972581ee59c8d3$export$cd9dd5b0786808e2).find((psalm)=>psalm.id === `psalm${i}`);
            if (psalm1928 && psalm1662) for(let li = 0; li < Math.max(psalm1928.lines.length, psalm1662.lines.length); li++){
                const line1928A = (psalm1928.lines[li]?.[0] ?? "").toLocaleString().toLocaleLowerCase().replaceAll(/[\,\.\'\!\?\:\;\-\_]/g, "");
                const line1662A = (psalm1662.lines[li]?.[0] ?? "").toLocaleString().toLocaleLowerCase().replaceAll(/[\,\.\'\!\?\:\;\-\_]/g, "");
                if (line1928A !== line1662A) diffs.push({
                    psalm: i,
                    line: li,
                    line1928A: line1928A,
                    line1662A: line1662A
                });
                const line1928B = (psalm1928.lines[li]?.[1] ?? "").toLocaleString().toLocaleLowerCase().replaceAll(/[\,\.\'\!\?\:\;\-\_]/g, "");
                const line1662B = (psalm1662.lines[li]?.[1] ?? "").toLocaleString().toLocaleLowerCase().replaceAll(/[\,\.\'\!\?\:\;\-\_]/g, "");
                if (line1928B !== line1662B) diffs.push({
                    psalm: i,
                    line: li,
                    line1928B: line1928B,
                    line1662B: line1662B
                });
            }
        }
    }
    const { settings: settings, setSetting: setSetting } = (0, $e5274831a769feea$export$9115b42802a3e44f)();
    const transposeByKey = "1";
    const transposeBy = settings.transpositions["1"] + (0, $02b52bdf6f82c33e$export$17267529e6476353)(transposeByKey);
    const increaseTransposeBy = (0, $acw62.useCallback)(()=>{
        setSetting("transpositions", {
            ...settings.transpositions,
            ["1"]: transposeBy + 1
        });
    }, [
        settings,
        transposeBy
    ]);
    const decreaseTransposeBy = (0, $acw62.useCallback)(()=>{
        setSetting("transpositions", {
            ...settings.transpositions,
            ["1"]: transposeBy - 1
        });
    }, [
        settings,
        transposeBy
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51cabc77a6b85afb$export$c265e0ac02f3cef4), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$PopoverContext.Provider, {
            value: (0, $acw62.useMemo)(()=>{
                return {
                    popoverId: popoverId,
                    setPopoverId: setPopoverId
                };
            }, [
                popoverId,
                setPopoverId
            ]),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fbd80a69cf576f05$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                            path: "/antiphon-editor/:index",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0327c0d0ab36de7b$export$46e97d99561dd31b), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                            path: "/hymn-editor",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $425bbd180391c0d9$export$63738645d6c02a26), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                            path: "/calcheck",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a26e968dbd77cfe3$export$cc0f45ef5b6d03fc), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                            path: "/special-export",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff1d4b6eaad740ef$export$a8f9d2f019e4a929), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                            path: "/*",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$SmallScreenContext.Provider, {
                                value: isSmallScreen,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    ref: pageRef,
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "stretch",
                                        height: "100%",
                                        overflow: "hidden"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                borderBottom: `1px solid ${(0, $b5d1360628cd70a0$export$6a1034a6524f1861)}`,
                                                boxShadow: `0 4px 4px -4px rgba(0, 0, 0, 0.1)`,
                                                backgroundColor: (0, $b5d1360628cd70a0$export$1a6c4fc8d15a2dc7),
                                                zIndex: 999,
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    maxWidth: (0, $b5d1360628cd70a0$export$397f5285b920487e),
                                                    width: "100%",
                                                    boxSizing: "border-box",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    padding: isSmallScreen ? 4 : 8,
                                                    paddingLeft: isSmallScreen ? 4 : 0,
                                                    paddingRight: isSmallScreen ? 4 : 0,
                                                    fontSize: "120%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0e7871cd1858330$export$9c9ee2e156b54bfb), {}),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            flexGrow: 1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            border: `1px solid #d9d9d9`,
                                                            borderRadius: 2,
                                                            height: 32
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                style: {
                                                                    paddingLeft: 8,
                                                                    paddingTop: 1
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                                    width: "13",
                                                                    height: "14",
                                                                    viewBox: "0 0 13 14",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                                                                            cx: "10.5",
                                                                            cy: "10",
                                                                            rx: "2.5",
                                                                            ry: "2",
                                                                            fill: "black"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                                                                            cx: "2.5",
                                                                            cy: "12",
                                                                            rx: "2.5",
                                                                            ry: "2",
                                                                            fill: "black"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                                            x1: "12.5",
                                                                            y1: "10",
                                                                            x2: "12.5",
                                                                            y2: "2",
                                                                            stroke: "black"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                                                            x1: "4.5",
                                                                            y1: "12",
                                                                            x2: "4.5",
                                                                            y2: "4",
                                                                            stroke: "black"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                            d: "M4 2L13 0V3L4 5V2Z",
                                                                            fill: "black"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                style: {
                                                                    fontSize: "85%",
                                                                    paddingLeft: 4,
                                                                    paddingRight: 8,
                                                                    width: 24
                                                                },
                                                                children: [
                                                                    transposeBy >= 0 ? "+" : "",
                                                                    transposeBy
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    width: 32,
                                                                    borderLeft: `1px solid #d9d9d9`,
                                                                    alignSelf: "stretch",
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: decreaseTransposeBy,
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                    width: "8",
                                                                    height: "6",
                                                                    viewBox: "0 0 8 6",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M3.99999 6L8 0H0L3.99999 6Z",
                                                                        fill: "black"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    width: 32,
                                                                    borderLeft: `1px solid #d9d9d9`,
                                                                    alignSelf: "stretch",
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: increaseTransposeBy,
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                    width: "8",
                                                                    height: "6",
                                                                    viewBox: "0 0 8 6",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                        d: "M3.99999 0L8 6H0L3.99999 0Z",
                                                                        fill: "black"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "stretch",
                                                color: (0, $b5d1360628cd70a0$export$516f68680b50dca1),
                                                lineHeight: 1.5,
                                                overflow: "auto",
                                                flexGrow: 1,
                                                flexShrink: 1,
                                                backgroundColor: (0, $b5d1360628cd70a0$export$f688c137b5ee517a)
                                            },
                                            className: "app-scroll-area",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    paddingTop: isSmallScreen ? 0 : 48,
                                                    paddingBottom: isSmallScreen ? 0 : 64,
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        maxWidth: (0, $b5d1360628cd70a0$export$397f5285b920487e),
                                                        width: "100%",
                                                        boxSizing: "border-box",
                                                        backgroundColor: (0, $b5d1360628cd70a0$export$1a6c4fc8d15a2dc7),
                                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                                        borderRadius: isSmallScreen ? 0 : 4,
                                                        overflow: "hidden"
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fbd80a69cf576f05$export$3565eb3d00ca5a74), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/year/:year",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a94d733270b5db4b$export$d6e2c116d12c5517), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/pray/today/mattins",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f11594785de166d$export$7ada8c2f1f9e6e91), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/pray/today/evensong",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9274aa06a0b765d3$export$65099c846075c939), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/pray/today/compline",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $811ba1d4386fca12$export$e0c14ca60a78daaa), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/pray/litany",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0fd8fc08fba9caf$export$f7380c386098e395), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/pray/commination",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $120d07281b4392b0$export$6be7e458d8b009af), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/pray/:year/:month/:date/:hour",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b5faf3a74c9a944$export$121d5e02794a18c5), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/tag/:psalm",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9645b905b2410b01$export$bddbd54033189e9c), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/psalm/:psalm",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c58651397710fc1$export$d23df640790b2fd6), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/canticle/:id/:tone",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1660c4b937221b9$export$556058c3d95d4cd7), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/intro",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55280dfc09a6d391$export$fcde770debb1d037), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/settings",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5298b88dda3758ff$export$8f6dcfe950367406), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/check",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86f728f9e78ea0a6$export$50512dd1088260c8), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/recording-project",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c693eb8bb6a24bf5$export$b8cb238a79c4ebf1), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/se/litany",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7ff05a6482e42aa$export$15afb09fa9c9ed), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/se/:year/:month/:date/:label/:hour",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa147fa9bd45753a$export$c15082c4d1ac5d54), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/se/office-of-the-dead/:hour",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67cbcc63a9947135$export$bc46037817f8ac12), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/se/tenebrae/:day",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec3c8899ba031dad$export$9476de778127e6b5), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/secret-ordo",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19a968ddb8323925$export$fd8619584ead7518), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/ordo",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ee31c3adb86234b$export$20d973631fe67e1b), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/first-edition",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d572d9bbc08f1eb4$export$ae5419e1b4c8d902), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbd80a69cf576f05$export$e7b0ac011bb776c6), {
                                                                path: "/",
                                                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9afeba4689e197d7$export$def13b44aba10201), {})
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;



const $70fc9a727fa662ae$var$container = document.getElementById("app");
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=web.55cf74f8.js.map
